
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("4FYDR", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.40
   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.40', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HUAWEI = 'Huawei', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', OPERA = 'Opera', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /(?:honor)([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Honor'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Lenovo'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    'Nokia'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OnePlus'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});

parcelRegister("5nRL1", function(module, exports) {
// lightweight script to scan the SSR response and collect all elements with data-ssr-placeholder attribute
// and save their size/positions in a map __SSR_PLACEHOLDERS_DIMENSIONS__ on the Window object. Each placeholderId is
// unique and maps to its corresponding elements bounding client rectangle dimensions.
function $b8b2d306bbe1b8cb$export$aee7516e57289027(document, window, enablePageLayoutPlaceholder = false) {
    const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
    ssrPlaceholders.forEach((elem)=>{
        const placeholderId = elem.getAttribute('data-ssr-placeholder');
        if (placeholderId) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = $b8b2d306bbe1b8cb$var$getEffectiveBoundingRect(elem, window);
        }
    });
    if (enablePageLayoutPlaceholder) {
        const pageLayoutRoot = document?.getElementById('unsafe-design-system-page-layout-root');
        if (pageLayoutRoot) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__['page-layout.root'] = $b8b2d306bbe1b8cb$var$getEffectiveBoundingRect(pageLayoutRoot, window);
        }
    }
}
/**
 * Gets the effective bounding rectangle for an element, handling display: contents elements
 * by collecting dimensions from their children instead
 */ function $b8b2d306bbe1b8cb$var$getEffectiveBoundingRect(elem, window) {
    const computedStyle = window.getComputedStyle(elem);
    // If element has display: contents, collect bounding rect from children
    if (computedStyle.display === 'contents') {
        const children = Array.from(elem.children);
        if (children.length === 0) // No children, return zero rect
        return new DOMRect(0, 0, 0, 0);
        // Calculate union of all children's bounding rects
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        children.forEach((child)=>{
            const childRect = child.getBoundingClientRect();
            // Skip children with zero dimensions (likely also display: contents)
            if (childRect.width > 0 || childRect.height > 0) {
                minX = Math.min(minX, childRect.left);
                minY = Math.min(minY, childRect.top);
                maxX = Math.max(maxX, childRect.right);
                maxY = Math.max(maxY, childRect.bottom);
            }
        });
        // If no children with dimensions found, return zero rect
        if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
        return new DOMRect(minX, minY, maxX - minX, maxY - minY);
    }
    // Normal element, return its bounding rect
    return elem.getBoundingClientRect();
}
module.exports["collectSSRPlaceholderDimensions"] = $b8b2d306bbe1b8cb$export$aee7516e57289027;

});

parcelRegister("3ay3Q", function(module, exports) {

var $1DJUt = parcelRequire("1DJUt");


var $dh538 = parcelRequire("dh538");


var $baiQV = parcelRequire("baiQV");


var $53d5Q = parcelRequire("53d5Q");


var $28pAQ = parcelRequire("28pAQ");


var $jiBIT = parcelRequire("jiBIT");


var $jJ2Ec = parcelRequire("jJ2Ec");


var $4u5NT = parcelRequire("4u5NT");







const $7414ebe21cd8146c$var$nameCache = new WeakMap();
function $7414ebe21cd8146c$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $7414ebe21cd8146c$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $7414ebe21cd8146c$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $7414ebe21cd8146c$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $7414ebe21cd8146c$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $7414ebe21cd8146c$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $7414ebe21cd8146c$var$getAttributeSelector(currentElement, 'data-testid') || $7414ebe21cd8146c$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $7414ebe21cd8146c$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($7414ebe21cd8146c$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $7414ebe21cd8146c$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$7414ebe21cd8146c$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $7414ebe21cd8146c$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $7414ebe21cd8146c$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $7414ebe21cd8146c$var$getUniqueSelector(selectorConfig, element);
    $7414ebe21cd8146c$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $7414ebe21cd8146c$export$2e2bcd8739ae039 = $7414ebe21cd8146c$var$getElementName;


let $d5a6c732cffb1707$var$performanceEventObserver;
const $d5a6c732cffb1707$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
/**
 * Resolve the SelectorConfig for the performance-observer code path.
 *
 * In FedRAMP Moderate environments (when `getSelectorConfig()` returns the
 * forced all-`false` config) we honour that override; otherwise we fall back
 * to the historical default that enables every selector.
 */ function $d5a6c732cffb1707$var$resolveSelectorConfig() {
    return (0, $53d5Q.getSelectorConfig)() ?? $d5a6c732cffb1707$var$DEFAULT_SELECTOR_CONFIG;
}
function $d5a6c732cffb1707$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $d5a6c732cffb1707$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $d5a6c732cffb1707$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($d5a6c732cffb1707$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $d5a6c732cffb1707$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $d5a6c732cffb1707$export$17afbba0f16b4b19 = ()=>{
    $d5a6c732cffb1707$var$performanceEventObserver = $d5a6c732cffb1707$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $d5a6c732cffb1707$export$e6be05b411ce21a6(entry);
    });
    return $d5a6c732cffb1707$var$performanceEventObserver;
};
const $d5a6c732cffb1707$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction?.type === 'press') {
        if (!interaction.responsiveness?.experimentalInputToNextPaint) {
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
                inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    const componentHierarchy = $d5a6c732cffb1707$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $7414ebe21cd8146c$export$2e2bcd8739ae039)($d5a6c732cffb1707$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};



var $i328h = parcelRequire("i328h");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");





var $lMdlY = parcelRequire("lMdlY");


var $9x4nt = parcelRequire("9x4nt");





var $ic4nn = parcelRequire("ic4nn");

const $092052ee6bb73599$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const $092052ee6bb73599$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const $092052ee6bb73599$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const $092052ee6bb73599$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const $092052ee6bb73599$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const $092052ee6bb73599$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const $092052ee6bb73599$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const $092052ee6bb73599$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const $092052ee6bb73599$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $092052ee6bb73599$var$matchesCategory(error) {
    const name = error.name ?? '';
    const message = error.message ?? '';
    if ($092052ee6bb73599$var$ABORT_ERROR_NAMES.has(name) || $092052ee6bb73599$var$ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    $092052ee6bb73599$var$AUTH_ERROR_NAMES.has(name) && $092052ee6bb73599$var$AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if ($092052ee6bb73599$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($092052ee6bb73599$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $092052ee6bb73599$var$CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if ($092052ee6bb73599$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $092052ee6bb73599$var$NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if ($092052ee6bb73599$var$NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function $092052ee6bb73599$export$17e837b2daecf805(error) {
    const directMatch = $092052ee6bb73599$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = $092052ee6bb73599$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}


let $c0ae7dbc7abd2bb6$var$sinkHandlerFn = ()=>{};
function $c0ae7dbc7abd2bb6$export$e5fa3ac6dc44efff(fn) {
    $c0ae7dbc7abd2bb6$var$sinkHandlerFn = fn;
}
const $c0ae7dbc7abd2bb6$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $c0ae7dbc7abd2bb6$export$1a949ef92fd30eca = (error)=>error.name === $c0ae7dbc7abd2bb6$var$RELAY_NETWORK_ERRORS_NAME;
const $c0ae7dbc7abd2bb6$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $c0ae7dbc7abd2bb6$var$getErrorStatusCode = (error)=>{
    if (!$c0ae7dbc7abd2bb6$var$isErrorObject(error)) return undefined;
    if ($c0ae7dbc7abd2bb6$export$1a949ef92fd30eca(error)) return error.source?.errors?.[0]?.extensions?.statusCode;
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $c0ae7dbc7abd2bb6$var$getErrorTraceId = (error)=>$c0ae7dbc7abd2bb6$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $c0ae7dbc7abd2bb6$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    if (additionalAttributes?.isClientNetworkError && !(0, $dh538.fg)('platform_ufo_terminal_errors_track_client_errors')) // Exclude client network errors from being reported to UFO
    return;
    const activeInteraction = (0, $4u5NT.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: error.message?.slice(0, 100) || 'Unknown error',
        timestamp: currentTime,
        ...(0, $dh538.fg)('platform_ufo_terminal_errors_track_client_errors') ? {
            errorCategory: (0, $092052ee6bb73599$export$17e837b2daecf805)(error)
        } : {}
    };
    const errorData = {
        ...baseErrorData,
        statusCode: additionalAttributes?.statusCode ?? $c0ae7dbc7abd2bb6$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (0, $lMdlY.getActiveTrace)()?.traceId ?? $c0ae7dbc7abd2bb6$var$getErrorTraceId(error),
        teamName: additionalAttributes?.teamName,
        packageName: additionalAttributes?.packageName,
        errorBoundaryId: additionalAttributes?.errorBoundaryId,
        errorHash: additionalAttributes?.errorHash,
        fallbackType: additionalAttributes?.fallbackType
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $4u5NT.PreviousInteractionLog).timestamp != null ? currentTime - (0, $4u5NT.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: activeInteraction?.ufoName ?? null,
        activeInteractionId: activeInteraction?.id ?? null,
        activeInteractionType: activeInteraction?.type ?? null,
        previousInteractionId: (0, $4u5NT.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $4u5NT.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $4u5NT.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $ic4nn.default).current ?? null
    };
    $c0ae7dbc7abd2bb6$var$sinkHandlerFn(errorData, context);
}
const $c0ae7dbc7abd2bb6$export$79ee0f0d40355053 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useReportTerminalError(error, additionalAttributes) {
    const $ = (0, $frIzR.c)(8);
    const interactionContext = (0, $9x4nt.useInteractionContext)();
    const hasReportedRef = (0, $42omo.useRef)(false);
    let t0;
    if ($[0] !== additionalAttributes || $[1] !== error || $[2] !== interactionContext?.labelStack) {
        t0 = ()=>{
            if (error && !hasReportedRef.current) {
                hasReportedRef.current = true;
                $c0ae7dbc7abd2bb6$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
            }
        };
        $[0] = additionalAttributes;
        $[1] = error;
        $[2] = interactionContext?.labelStack;
        $[3] = t0;
    } else t0 = $[3];
    const t1 = interactionContext?.labelStack;
    let t2;
    if ($[4] !== additionalAttributes || $[5] !== error || $[6] !== t1) {
        t2 = [
            error,
            additionalAttributes,
            t1
        ];
        $[4] = additionalAttributes;
        $[5] = error;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    (0, $42omo.useEffect)(t0, t2);
} : function useReportTerminalError(error, additionalAttributes) {
    const interactionContext = (0, $9x4nt.useInteractionContext)();
    const hasReportedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $c0ae7dbc7abd2bb6$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext?.labelStack
    ]);
};



var $eggFB = parcelRequire("eggFB");




function $89fa2b1673704460$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $dh538.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $eggFB.unstable_scheduleCallback)((0, $eggFB.unstable_IdlePriority), work);
}
var $89fa2b1673704460$export$2e2bcd8739ae039 = $89fa2b1673704460$var$scheduleIdleCallback;


let $726cef1959388e45$var$initialized = false;
function $726cef1959388e45$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $89fa2b1673704460$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $4u5NT.sinkInteractionHandler)(sinkFn);
}
function $726cef1959388e45$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $4u5NT.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $89fa2b1673704460$export$2e2bcd8739ae039)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $726cef1959388e45$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $c0ae7dbc7abd2bb6$export$e5fa3ac6dc44efff)((errorData, context)=>{
        (0, $89fa2b1673704460$export$2e2bcd8739ae039)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $726cef1959388e45$var$sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, $4u5NT.interactionExtraMetrics).sinkHandler((interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult)=>{
        (0, $89fa2b1673704460$export$2e2bcd8739ae039)(async ()=>{
            const payload = await createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $726cef1959388e45$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $89fa2b1673704460$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $28pAQ.sinkExtraSearchPageInteractionHandler)(sinkFn);
}




function $726cef1959388e45$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($726cef1959388e45$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $53d5Q.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $53d5Q.isUFOEnabled)()) {
        $726cef1959388e45$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $i328h.initialisePressureObserver)();
    (0, $i328h.initialiseMemoryObserver)();
    if ((0, $dh538.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $jiBIT.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $jiBIT.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $1DJUt.context).setGlobalContextManager(contextManager);
    }
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $53d5Q.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $4u5NT.postInteractionLog).initializeVCObserver(vcOptions);
        if ((0, $53d5Q.isInteractionExtraMetricsEnabled)()) (0, $4u5NT.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, $jJ2Ec.setupHiddenTimingCapture)();
    (0, $baiQV.startLighthouseObserver)();
    (0, $jJ2Ec.setupThrottleDetection)();
    $726cef1959388e45$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $d5a6c732cffb1707$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    const extraInteractionMetricsPayloadPackagePromise = (0, $53d5Q.isInteractionExtraMetricsEnabled)() ? (parcelRequire("10huY")) : Promise.resolve(undefined);
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("d36Ll")),
        (parcelRequire("eGXpu")),
        extraInteractionMetricsPayloadPackagePromise,
        (parcelRequire("l1Nvz"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage, createInteractionExtraMetricsPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $726cef1959388e45$var$sinkInteraction(instance, payloadPackage);
            if (config?.terminalErrors?.enabled) $726cef1959388e45$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $726cef1959388e45$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if ((0, $53d5Q.isInteractionExtraMetricsEnabled)() && createInteractionExtraMetricsPayloadPackage) $726cef1959388e45$var$sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $726cef1959388e45$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            $726cef1959388e45$var$sinkInteraction(awc, payloadPackage);
            if (config?.terminalErrors?.enabled) $726cef1959388e45$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $726cef1959388e45$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if ((0, $53d5Q.isInteractionExtraMetricsEnabled)() && createInteractionExtraMetricsPayloadPackage) $726cef1959388e45$var$sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $726cef1959388e45$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}
module.exports["init"] = $726cef1959388e45$export$2cd8252107eb640b;

});

parcelRegister("baiQV", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $5ee5d57771f6c7fe$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $5ee5d57771f6c7fe$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        if ((0, $dh538.fg)('platform_ufo_filter_cls_logs_same_rects_positions')) {
            const allSourcesHaveSameRects = entry?.sources?.every(({ previousRect: previousRect, currentRect: currentRect })=>$5ee5d57771f6c7fe$var$isSameRects(previousRect, currentRect));
            return isWithinObservationWindow && !allSourcesHaveSameRects;
        }
        return isWithinObservationWindow;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}


const $f98053df596c1c19$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};


const $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $3d4a3152b88eeea8$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $3d4a3152b88eeea8$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}



class $3bf1fc6946af5f4a$export$2c6e86519c9e8188 {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    constructor(maxLength = 1000){
        this.buffer = [];
        this.maxLength = void 0;
        this.full = false;
        this.maxLength = maxLength;
    }
}
const $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe = {
    [(0, $f98053df596c1c19$export$a4def92db6fc8e17).LongTask]: new $3bf1fc6946af5f4a$export$2c6e86519c9e8188(),
    [(0, $f98053df596c1c19$export$a4def92db6fc8e17).LayoutShift]: new $3bf1fc6946af5f4a$export$2c6e86519c9e8188()
};




let $e20935e0f33fbf41$var$pe = null;
function $e20935e0f33fbf41$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($e20935e0f33fbf41$var$pe !== null) return $e20935e0f33fbf41$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $f98053df596c1c19$export$a4def92db6fc8e17).LayoutShift) (0, $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe)[(0, $f98053df596c1c19$export$a4def92db6fc8e17).LayoutShift].push(entry);
            if (entry.entryType === (0, $f98053df596c1c19$export$a4def92db6fc8e17).LongTask) (0, $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe)[(0, $f98053df596c1c19$export$a4def92db6fc8e17).LongTask].push(entry);
        });
    };
    $e20935e0f33fbf41$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $e20935e0f33fbf41$var$pe;
}
function $e20935e0f33fbf41$export$768ccc3ab7bac3ea() {
    $e20935e0f33fbf41$var$getObserver()?.observe({
        type: (0, $f98053df596c1c19$export$a4def92db6fc8e17).LayoutShift,
        buffered: true
    });
}
function $e20935e0f33fbf41$export$54fb8b6aaf70ec9c() {
    $e20935e0f33fbf41$var$getObserver()?.observe({
        type: (0, $f98053df596c1c19$export$a4def92db6fc8e17).LongTask,
        buffered: true
    });
}


function $507b4d71ea76a7a5$export$5ecf2aafafee3e0() {
    (0, $e20935e0f33fbf41$export$768ccc3ab7bac3ea)();
    (0, $e20935e0f33fbf41$export$54fb8b6aaf70ec9c)();
}
function $507b4d71ea76a7a5$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $3d4a3152b88eeea8$export$2d6e933b35bd3407)(start, stop, (0, $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe)[(0, $f98053df596c1c19$export$a4def92db6fc8e17).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $5ee5d57771f6c7fe$export$fc6227831ee7c7)(start, stop, (0, $3bf1fc6946af5f4a$export$f7dc16cbd16f7bbe)[(0, $f98053df596c1c19$export$a4def92db6fc8e17).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}
module.exports["startLighthouseObserver"] = $507b4d71ea76a7a5$export$5ecf2aafafee3e0;
module.exports["getLighthouseMetrics"] = $507b4d71ea76a7a5$export$b46cecdf698e4bb5;

});

parcelRegister("i328h", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $1b7ceb7dea9fa404$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $1b7ceb7dea9fa404$var$pressureRecordBuffer = [];
let $1b7ceb7dea9fa404$var$pressureObserver = null;
let $1b7ceb7dea9fa404$var$memoryRecordBuffer = [];
let $1b7ceb7dea9fa404$var$memoryInterval;
function $1b7ceb7dea9fa404$export$6c1060bed5fea050() {
    $1b7ceb7dea9fa404$var$pressureRecordBuffer.length = 0;
}
function $1b7ceb7dea9fa404$export$aa672c7221b183b0() {
    $1b7ceb7dea9fa404$var$memoryRecordBuffer.length = 0;
}
function $1b7ceb7dea9fa404$export$ec86686c1d2e65bc(filter) {
    $1b7ceb7dea9fa404$var$pressureRecordBuffer = $1b7ceb7dea9fa404$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $1b7ceb7dea9fa404$export$c0142ac82f5d0c28(filter) {
    $1b7ceb7dea9fa404$var$memoryRecordBuffer = $1b7ceb7dea9fa404$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $1b7ceb7dea9fa404$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $1b7ceb7dea9fa404$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $1b7ceb7dea9fa404$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $1b7ceb7dea9fa404$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $1b7ceb7dea9fa404$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $1b7ceb7dea9fa404$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $1b7ceb7dea9fa404$var$convertBytesToMegabytes($1b7ceb7dea9fa404$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $1b7ceb7dea9fa404$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $1b7ceb7dea9fa404$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $1b7ceb7dea9fa404$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $1b7ceb7dea9fa404$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $1b7ceb7dea9fa404$var$pressureObserver = new PressureObserver((records)=>{
                if ($1b7ceb7dea9fa404$var$pressureRecordBuffer.length + records.length <= $1b7ceb7dea9fa404$var$BUFFER_MAX_LENGTH) $1b7ceb7dea9fa404$var$pressureRecordBuffer.push(...records);
            });
            $1b7ceb7dea9fa404$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $1b7ceb7dea9fa404$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $1b7ceb7dea9fa404$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($1b7ceb7dea9fa404$var$memoryRecordBuffer.length <= $1b7ceb7dea9fa404$var$BUFFER_MAX_LENGTH) $1b7ceb7dea9fa404$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $1b7ceb7dea9fa404$export$10899ada382f2ae3() {
    clearInterval($1b7ceb7dea9fa404$var$memoryInterval);
}
function $1b7ceb7dea9fa404$export$b9fdd785f0fc1d40() {
    $1b7ceb7dea9fa404$var$pressureObserver?.disconnect();
}
module.exports["createPressureStateReport"] = $1b7ceb7dea9fa404$export$1f0ff35da084986e;
module.exports["createMemoryStateReport"] = $1b7ceb7dea9fa404$export$3b47ebb9832b4e24;
module.exports["initialisePressureObserver"] = $1b7ceb7dea9fa404$export$117ebc554c6e9f2f;
module.exports["initialiseMemoryObserver"] = $1b7ceb7dea9fa404$export$a3271f53e91faab7;

});

parcelRegister("10huY", function(module, exports) {

let $0bb35d667a864b37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bb35d667a864b37$var$load("gLWw8").then(()=>parcelRequire('jyLMo'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("d36Ll", function(module, exports) {

let $9800cd13931da468$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9800cd13931da468$var$load("813OY").then(()=>parcelRequire('kGADV'));

});

parcelRegister("eGXpu", function(module, exports) {

let $ab23128a70d930e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab23128a70d930e1$var$load("gQfqa").then(()=>parcelRequire('bprG4'));

});

parcelRegister("l1Nvz", function(module, exports) {

let $f4f018455756baa8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f4f018455756baa8$var$load("h0PDx").then(()=>parcelRequire('awGHE'));

});

parcelRegister("aanDq", function(module, exports) {

var $53d5Q = parcelRequire("53d5Q");

const $f9a9983405b992e1$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $f9a9983405b992e1$var$getAllowedParams() {
    const config = (0, $53d5Q.getConfig)();
    return config?.allowedResourcesParams || $f9a9983405b992e1$var$defaultAllowedParams;
}
function $f9a9983405b992e1$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $f9a9983405b992e1$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch  {
        return urlString;
    }
}
let $f9a9983405b992e1$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $f9a9983405b992e1$var$handleQueryParams(url);
    }
};
function $f9a9983405b992e1$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $f9a9983405b992e1$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $f9a9983405b992e1$var$config = newConfig;
}
function $f9a9983405b992e1$export$44487a86467333c3() {
    return $f9a9983405b992e1$var$config;
}
module.exports["configure"] = $f9a9983405b992e1$export$8d21e34596265fa2;
module.exports["getConfig"] = $f9a9983405b992e1$export$44487a86467333c3;

});

parcelRegister("hS38r", function(module, exports) {

var $8litl = parcelRequire("8litl");

const $3117d1f5648443d3$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $3117d1f5648443d3$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $3117d1f5648443d3$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $8litl.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $8litl.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $8litl.roundEpsilon)(entry.startTime),
            duration: (0, $8litl.roundEpsilon)(entry.duration),
            fetchStart: (0, $8litl.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $8litl.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $8litl.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $8litl.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $8litl.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $8litl.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $3117d1f5648443d3$var$getPerformanceObject();
        const PerformanceObserver = $3117d1f5648443d3$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($3117d1f5648443d3$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $3117d1f5648443d3$export$bea963256235a63e.timings = resources.map((resource)=>$3117d1f5648443d3$export$bea963256235a63e.transformResource(resource));
        $3117d1f5648443d3$export$bea963256235a63e.observer = new PerformanceObserver($3117d1f5648443d3$export$bea963256235a63e.addTimings);
        $3117d1f5648443d3$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($3117d1f5648443d3$export$bea963256235a63e.observer) {
            $3117d1f5648443d3$export$bea963256235a63e.observer.disconnect();
            $3117d1f5648443d3$export$bea963256235a63e.observer = null;
        }
        $3117d1f5648443d3$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$3117d1f5648443d3$export$bea963256235a63e.transformResource(entry));
        const overflow = $3117d1f5648443d3$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $3117d1f5648443d3$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $3117d1f5648443d3$export$bea963256235a63e.maxSize;
            $3117d1f5648443d3$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $3117d1f5648443d3$export$bea963256235a63e.timings.push(...entries);
    }
};
function $3117d1f5648443d3$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $3117d1f5648443d3$export$4138a729ef1db028(startTime, endTime) {
    const performance = $3117d1f5648443d3$var$getPerformanceObject();
    const PerformanceObserver = $3117d1f5648443d3$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$3117d1f5648443d3$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$3117d1f5648443d3$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $3117d1f5648443d3$export$bea963256235a63e.timings.filter((timing)=>$3117d1f5648443d3$var$isValidTiming(timing, startTime, endTime));
}
module.exports["resourceTimingBuffer"] = $3117d1f5648443d3$export$bea963256235a63e;
module.exports["filterResourceTimings"] = $3117d1f5648443d3$export$4138a729ef1db028;

});

parcelRegister("8litl", function(module, exports) {
function $1eb0154571433801$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}
module.exports["roundEpsilon"] = $1eb0154571433801$export$56014375de40214b;

});

parcelRegister("hPcrh", function(module, exports) {
const $9d50b67dcef9fae2$var$NESTED_METRIC_SEPARATOR = '/';
function $9d50b67dcef9fae2$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $9d50b67dcef9fae2$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $9d50b67dcef9fae2$var$SSR_PREFIX = 'ssr';
function $9d50b67dcef9fae2$var$mapKey(key) {
    if (key === 'total') return $9d50b67dcef9fae2$var$SSR_PREFIX;
    return `${$9d50b67dcef9fae2$var$SSR_PREFIX}${$9d50b67dcef9fae2$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $9d50b67dcef9fae2$var$config;
function $9d50b67dcef9fae2$export$8d21e34596265fa2(ssrConfig) {
    $9d50b67dcef9fae2$var$config = ssrConfig;
}
function $9d50b67dcef9fae2$var$getPerformanceNavigationTiming() {
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return performance.getEntriesByType('navigation')?.[0];
}
function $9d50b67dcef9fae2$var$getServerTimingsByName() {
    const serverTimingsByName = Object.fromEntries($9d50b67dcef9fae2$var$getPerformanceNavigationTiming()?.serverTiming?.map((timing)=>[
            timing.name,
            timing
        ]) ?? []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $9d50b67dcef9fae2$var$getEdgeOffset(edgeTtfb) {
    const clientTtfb = $9d50b67dcef9fae2$var$getPerformanceNavigationTiming()?.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $9d50b67dcef9fae2$export$5300d1b82e594615() {
    const serverTimingsByName = $9d50b67dcef9fae2$var$getServerTimingsByName();
    const edgeTotalDuration = serverTimingsByName['cdn-downstream-fbl']?.duration ?? serverTimingsByName['atl-edge']?.duration;
    if (!edgeTotalDuration) return null;
    const edgeOffset = $9d50b67dcef9fae2$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (serverTimingsByName['cdn-upstream-dns']?.duration || 0) + (serverTimingsByName['cdn-upstream-connect']?.duration || 0);
    const cfUpstreamDuration = (serverTimingsByName['cdn-upstream-fbl']?.duration || 0) - cfInternalDuration;
    const cfDownstreamDuration = (serverTimingsByName['cdn-downstream-fbl']?.duration || 0) - (serverTimingsByName['cdn-upstream-fbl']?.duration || 0);
    const atlEdgeDuration = serverTimingsByName['atl-edge']?.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: serverTimingsByName['cdn-downstream-fbl']?.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: serverTimingsByName['atl-edge-internal']?.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    edgeTimings?.edge && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $9d50b67dcef9fae2$export$bf7408e83532dcd0() {
    const defaultSSRTimings = $9d50b67dcef9fae2$export$5300d1b82e594615() || {};
    let configTimings = {};
    if (typeof $9d50b67dcef9fae2$var$config?.getTimings === 'function') configTimings = $9d50b67dcef9fae2$var$config.getTimings();
    const ssrTimings = Object.entries({
        ...configTimings,
        ...defaultSSRTimings
    }).reduce((acc, entry)=>{
        if ($9d50b67dcef9fae2$var$filterEntry(entry[1])) acc[$9d50b67dcef9fae2$var$mapKey(entry[0])] = $9d50b67dcef9fae2$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $9d50b67dcef9fae2$export$c7ad864055e75537() {
    return !!$9d50b67dcef9fae2$var$config?.getDoneMark();
}
function $9d50b67dcef9fae2$export$5eade9354185583d() {
    return $9d50b67dcef9fae2$var$config?.getSsrPhaseSuccess?.();
}
function $9d50b67dcef9fae2$export$3def7672244bab0c() {
    return $9d50b67dcef9fae2$var$config?.getDoneMark() ?? undefined;
}
function $9d50b67dcef9fae2$export$1c4a9b5e6e22393d() {
    if (!$9d50b67dcef9fae2$var$config?.getFeatureFlags) return undefined;
    try {
        return $9d50b67dcef9fae2$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}
function $9d50b67dcef9fae2$export$eb7c400973493903() {
    if (!$9d50b67dcef9fae2$var$config?.getSsrSuccessBreakdown) return undefined;
    try {
        return $9d50b67dcef9fae2$var$config.getSsrSuccessBreakdown() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}
module.exports["configure"] = $9d50b67dcef9fae2$export$8d21e34596265fa2;
module.exports["getSSRTimings"] = $9d50b67dcef9fae2$export$bf7408e83532dcd0;
module.exports["getSSRSuccess"] = $9d50b67dcef9fae2$export$c7ad864055e75537;
module.exports["getSSRPhaseSuccess"] = $9d50b67dcef9fae2$export$5eade9354185583d;
module.exports["getSSRDoneTime"] = $9d50b67dcef9fae2$export$3def7672244bab0c;
module.exports["getSSRFeatureFlags"] = $9d50b67dcef9fae2$export$1c4a9b5e6e22393d;
module.exports["getSSRSuccessBreakdown"] = $9d50b67dcef9fae2$export$eb7c400973493903;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("8Lf0D", function(module, exports) {
/**
 * Auto Incrementing ID
 *
 * Basic ID generation using a global integer
 */ class $35e1d987475b995b$export$1545ba9ccf1841ab {
    /**
   * ID
   *
   * Returns a stringified auto-incrementing ID
   */ ID() {
        return (++this.incrementor).toString();
    }
    /**
   * Reset
   *
   * Returns the incrementor to its original state
   */ reset() {
        this.incrementor = -1;
    }
    constructor(){
        this.incrementor = -1;
    }
}
module.exports["AutoIncrementingID"] = $35e1d987475b995b$export$1545ba9ccf1841ab;

});

parcelRegister("jy3Cx", function(module, exports) {
/**
 * Cache
 *
 * A generic cache designed to house just about anything. You can implement
 * your own type-safe LRU or just use it as a hash table
 */ class $f95e45deccc3ce2b$export$94affb487e701bf2 {
    /**
   * Data
   *
   * Returns the entirety of the cache
   */ get data() {
        return this._cache;
    }
    /**
   * Get
   *
   * Returns a cache value by key
   */ get(key) {
        return this._cache[key];
    }
    /**
   * Has
   *
   * Returns whether or not a given key exists in the cache
   */ has(key) {
        return this._cache.hasOwnProperty(key);
    }
    /**
   * Set
   *
   * Overrides the value of a given key with the specified value
   */ set(key, value) {
        this._cache[key] = value;
    }
    /**
   * Delete
   *
   * Deletes the specified cache key
   */ delete(key) {
        delete this._cache[key];
    }
    /**
   * Keys
   *
   * Returns all currently set cache keys
   */ get keys() {
        return Object.keys(this._cache);
    }
    /**
   * Values
   *
   * Returns all cached values
   */ get values() {
        return Object.values(this._cache);
    }
    /**
   * Clear
   *
   * Clears all cached values
   */ clear() {
        this._cache = {};
    }
    constructor(cache){
        this._cache = void 0;
        this._cache = cache || {};
    }
}
module.exports["Cache"] = $f95e45deccc3ce2b$export$94affb487e701bf2;

});

parcelRegister("5leFG", function(module, exports) {

var $jy3Cx = parcelRequire("jy3Cx");


var $bPw0L = parcelRequire("bPw0L");

class $e398c0accbc425cf$export$5087227eb54526 extends Map {
    /**
   * Stream
   *
   * Adds a stream of messages to the bus and invokes active
   * subscriptions to the corresponding message types
   */ async stream(events) {
        if (!events.length) return;
        const hash = {};
        for (const event of events){
            if (event.type in hash) hash[event.type].push(event);
            else hash[event.type] = [
                event
            ];
            this.cache(event.type, event);
        }
        await Promise.all(Object.keys(hash).map((key)=>{
            return this.dispatch(key, hash[key]);
        }));
    }
    /**
   * On
   *
   * Allows for registering listeners to incoming message types. Simply
   * pass the message type you wish to receive notifications for and
   * a callback to invoke
   */ on(event, callback) {
        const index = this.get(event) || new (0, $bPw0L.EventIndex)();
        const ID = index.subscribe(callback);
        this.set(event, index);
        return ID;
    }
    /**
   * Off
   *
   * Removes an event listener by event-name and ID
   */ off(event, ID) {
        const index = this.get(event);
        if (index) {
            index.unsubscribe(ID);
            if (index.size === 0) this.delete(event);
        }
    }
    /**
   * Dispatch
   *
   * Invokes all subscriptions for a given event type. Each listener
   * receives its corresponding messages as an argument
   */ async dispatch(event, ...params) {
        const index = this.get(event);
        if (index) await index.dispatch(params);
    }
    /**
   * Cache
   *
   * When caching is enabled, the Event Bus can act as a
   * database for historical message accumulation. To enable
   * this feature, pass `enableCache: true` to the constructor
   */ cache(key, value) {
        if (!this.enableCache) return;
        const values = this.Cache.get(key) || [];
        values.push(value);
        this.Cache.set(key, values);
    }
    constructor(cache){
        super();
        this.enableCache = false;
        this.Cache = new (0, $jy3Cx.Cache)();
        if (cache) this.enableCache = true;
    }
}
module.exports["EventBus"] = $e398c0accbc425cf$export$5087227eb54526;

});

parcelRegister("bPw0L", function(module, exports) {

var $8Lf0D = parcelRequire("8Lf0D");

class $93598c3fbf25b38d$export$8a9c48e07ede8c4b extends Map {
    /**
   * Subscribe
   *
   * Adds a subscription to the index and returns a unique
   * identifier
   */ subscribe(listener) {
        const ID = this.IDs.ID();
        this.set(ID, listener);
        return ID;
    }
    /**
   * Unsubscribe
   *
   * Removes a subscription from the index by ID
   */ unsubscribe(ID) {
        this.delete(ID);
    }
    /**
   * Dispatch
   *
   * Dispatches events to their registered listeners
   */ async dispatch(messages) {
        for (const [_, listener] of this)await Promise.resolve(listener(...messages));
    }
    constructor(...args){
        super(...args);
        this.IDs = new (0, $8Lf0D.AutoIncrementingID)();
    }
}
module.exports["EventIndex"] = $93598c3fbf25b38d$export$8a9c48e07ede8c4b;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("lXQLs", function(module, exports) {
const $feab3ea7dc0c8aa0$export$b471d97e795847e1 = (resourceTimings)=>{
    let hasScriptEntries = false;
    let hasNextHopProtocolProperty = false;
    for (const entry of resourceTimings){
        if (entry.initiatorType !== 'script') continue;
        hasScriptEntries = true;
        // Skip cache hits. Cached resources have transferSize === 0 and the browser reports
        // nextHopProtocol as "" since no network hop occurred.
        if (entry.transferSize === 0) continue;
        if ('nextHopProtocol' in entry) {
            hasNextHopProtocolProperty = true;
            if (entry.nextHopProtocol) return entry.nextHopProtocol;
        }
    }
    if (!hasScriptEntries || !hasNextHopProtocolProperty) return 'unsupported';
    return 'unknown';
};
module.exports["getHTTPProtocol"] = $feab3ea7dc0c8aa0$export$b471d97e795847e1;

});

parcelRegister("5j7rq", function(module, exports) {

let $3dd47fcb8b89f2bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3dd47fcb8b89f2bd$var$load("9SyhI"),
    $3dd47fcb8b89f2bd$var$load("76XJy")
]).then(()=>parcelRequire('a4qOe'));

});

parcelRegister("9PBjm", function(module, exports) {

var $eHj6r = parcelRequire("eHj6r");

function $ca1d37ec2e96c685$export$c25b3a02c2d5dc72() {
    return 0, $eHj6r.apolloCache;
}
module.exports["getApolloCache"] = $ca1d37ec2e96c685$export$c25b3a02c2d5dc72;

});

parcelRegister("gKr8t", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $5v4fk = parcelRequire("5v4fk");


var $guZe9 = parcelRequire("guZe9");


var $jxz2A = parcelRequire("jxz2A");


var $jWs8F = parcelRequire("jWs8F");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)({
    isForAggOnly: true
});
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $jWs8F.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $jxz2A.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $5v4fk.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $guZe9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $5v4fk.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $5v4fk.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9wEpK.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $5v4fk.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $5v4fk = parcelRequire("5v4fk");


var $lB1H3 = parcelRequire("lB1H3");


var $422HI = parcelRequire("422HI");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $5v4fk.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $5v4fk.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $lB1H3.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $422HI.ApolloErrorInterop)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $lB1H3.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $5v4fk = parcelRequire("5v4fk");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $5v4fk.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("bZGgW", function(module, exports) {

let $8bb62e98d3878706$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8bb62e98d3878706$var$load("gSXIX").then(()=>parcelRequire('kWFOs'));

});

parcelRegister("emNvf", function(module, exports) {
/**
 * @generated SignedSource<<6049717399a666092bcdc2991e7b1ca4>>
 * @relayHash d82ceab955fc558f582faba05877ecf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 765401ffb83f2e2a720c85a5da2a39f56c3a779bc1c3bf8b59c8eef803276a03
const $34dcc93d00ac09e9$var$node = function() {
    var v0 = [
        {
            "concreteType": "LookAndFeelSettings",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "custom",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HeaderLookAndFeel",
                            "kind": "LinkedField",
                            "name": "horizontalHeader",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundColor"
                                },
                                {
                                    "concreteType": "NavigationLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "primaryNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "highlightColor"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ThemeQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ThemeQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d82ceab955fc558f582faba05877ecf8",
            "id": "765401ffb83f2e2a720c85a5da2a39f56c3a779bc1c3bf8b59c8eef803276a03",
            "metadata": {},
            "name": "ThemeQuery",
            "operationKind": "query",
            "text": "query ThemeQuery{lookAndFeel{custom{horizontalHeader{backgroundColor,primaryNavigation{highlightColor}}}}}"
        }
    };
}();
$34dcc93d00ac09e9$var$node.hash = "1e70f0bab96233984a0d61d455b5303b";
var $34dcc93d00ac09e9$export$2e2bcd8739ae039 = $34dcc93d00ac09e9$var$node;
module.exports["default"] = $34dcc93d00ac09e9$export$2e2bcd8739ae039;

});

parcelRegister("lyWac", function(module, exports) {

var $3mugH = parcelRequire("3mugH");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') {
                const fulfilledValue = result.value;
                if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                else if (Array.isArray(fulfilledValue)) {
                    const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                    errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                }
            }
        }
        if (errors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return errors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("bPDOf", function(module, exports) {
const $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575 = {
    hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
    isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
    hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
    hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
    isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
    hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
    hasDismissedGettingStartedTour: 'aifc-onboarding:hasDismissedGettingStartedTour',
    hasSeenDeeplinkReturnSpotlight: 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight',
    hasSeenTwcAifcOnboarding: 'aifc-onboarding:hasSeenTwcAifcOnboarding'
};
const $4fc1e4c0ecd68c6d$export$6024bf9594f957fe = [
    ...Object.values($4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575)
];
module.exports["AIFC_ONBOARDING_STATE_KEYS"] = $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575;
module.exports["AIFCOnboardingKeys"] = $4fc1e4c0ecd68c6d$export$6024bf9594f957fe;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("hAiCi", function(module, exports) {
/**
 * @generated SignedSource<<bea9c781c186dacbb56d302fc1fdf3bc>>
 * @relayHash 03c88593e0a708b4a806a4bb00935330
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a40daa03e54d1598b3952a7a86fc5c6a154a8756d1cb79b58cc7bf3f2e125ee
const $1d80fc45612ce410$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "value"
    }, v1 = [
        {
            "concreteType": "SiteConfiguration",
            "kind": "LinkedField",
            "name": "siteConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "customSiteLogo"
                }
            ]
        },
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "siteTitle"
                },
                {
                    "kind": "ScalarField",
                    "name": "showApplicationTitle"
                }
            ]
        },
        {
            "concreteType": "SiteDescription",
            "kind": "LinkedField",
            "name": "siteDescription",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "logoUrl"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ 
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "TopNavigationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "TopNavigationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "03c88593e0a708b4a806a4bb00935330",
            "id": "2a40daa03e54d1598b3952a7a86fc5c6a154a8756d1cb79b58cc7bf3f2e125ee",
            "metadata": {},
            "name": "TopNavigationQuery",
            "operationKind": "query",
            "text": "query TopNavigationQuery{siteConfiguration{customSiteLogo},siteSettings{siteTitle,showApplicationTitle},siteDescription{logoUrl},user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary},photos{value}}}"
        }
    };
}();
$1d80fc45612ce410$var$node.hash = "58252cd5493d65d590f00c523b3d3ad8";
var $1d80fc45612ce410$export$2e2bcd8739ae039 = $1d80fc45612ce410$var$node;
module.exports["default"] = $1d80fc45612ce410$export$2e2bcd8739ae039;

});

parcelRegister("74VX5", function(module, exports) {
/**
 * @generated SignedSource<<ad4717b23996fc6dd876d64497a8db4e>>
 * @relayHash 13e9ccffd4783d3489f7fdc0bdb79076
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8
const $7964c46f2f85665b$var$node = function() {
    var v0 = [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "NotificationsButtonQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "NotificationsButtonQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "13e9ccffd4783d3489f7fdc0bdb79076",
            "id": "9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8",
            "metadata": {},
            "name": "NotificationsButtonQuery",
            "operationKind": "query",
            "text": "query NotificationsButtonQuery{notifications{unseenNotificationCount}}"
        }
    };
}();
$7964c46f2f85665b$var$node.hash = "942a544fd139c706378825d031824679";
var $7964c46f2f85665b$export$2e2bcd8739ae039 = $7964c46f2f85665b$var$node;
module.exports["default"] = $7964c46f2f85665b$export$2e2bcd8739ae039;

});

parcelRegister("9fLxI", function(module, exports) {
async function $2552b7855153149c$export$573ee875a39e7e73({ spaceKey: spaceKey } = {
    spaceKey: undefined
}) {
    if (spaceKey) {
        var _window;
        const extensionManifestSpaceaware = (_window = window).__EXTENSION_MANIFEST_SPACEAWARE__ || (_window.__EXTENSION_MANIFEST_SPACEAWARE__ = {});
        if (!extensionManifestSpaceaware[spaceKey]) extensionManifestSpaceaware[spaceKey] = $2552b7855153149c$var$fetchExtensionManifests(spaceKey);
        return extensionManifestSpaceaware[spaceKey];
    }
    if (!window.__EXTENSION_MANIFEST__) window.__EXTENSION_MANIFEST__ = $2552b7855153149c$var$fetchExtensionManifests();
    return window.__EXTENSION_MANIFEST__;
}
function $2552b7855153149c$var$fetchExtensionManifests(spaceKey) {
    // eslint-disable-next-line check-credentials-option/has-credentials-option,no-restricted-syntax
    return fetch(`/wiki/plugins/macrobrowser/browse-macros.action?detailed=true&origin=extension-provider${spaceKey ? `&spaceKey=${spaceKey}` : ''}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json());
}
module.exports["getExtensionManifest"] = $2552b7855153149c$export$573ee875a39e7e73;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetailsQuery", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetailsQuery);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("bgmQP")).ConfluenceSpaceType);

var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $bgmQP = parcelRequire("bgmQP");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await Promise.resolve((parcelRequire("bgmQP")))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("5SzHz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '', { includeSpaceTypeSettings: includeSpaceTypeSettings = false } = {})=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        },
        __callerPackage__: "@confluence/space-utils"
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '', options)=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey, options);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("jLyos", function(module, exports) {

var $a2WOL = parcelRequire("a2WOL");


var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $a2WOL.default);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b,
        __callerPackage__: "@confluence/space-utils"
    });
};
module.exports["preloadPersonalSpaceDetailsQuery"] = $51133d1487ddd8f7$export$945871a9cdda3d0b;
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("a2WOL", function(module, exports) {
/**
 * @generated SignedSource<<99c90ef1034a28215bdf926b84b02699>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;
module.exports["default"] = $fb9284d373020379$export$2e2bcd8739ae039;

});

parcelRegister("bgmQP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6T8v4 = parcelRequire("6T8v4");


var $3hOY6 = parcelRequire("3hOY6");


var $gdv5Z = parcelRequire("gdv5Z");


var $iXCQx = parcelRequire("iXCQx");


var $g5lKx = parcelRequire("g5lKx");

var $c8b68f6ea32b0094$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
const $c8b68f6ea32b0094$var$i18n = (0, $aXWIB.defineMessages)({
    ariaLabel: {
        id: "space-utils.permissions-export.form.space-target-select.aria-label",
        defaultMessage: "For which spaces"
    },
    all: {
        id: "space-utils.space-target-select.all",
        defaultMessage: "All"
    },
    allDescription: {
        id: "space-utils.space-target-select.allDescription",
        defaultMessage: "All spaces, regardless of type"
    },
    allExcludingPersonal: {
        id: "space-utils.space-target-select.allExcludingPersonal",
        defaultMessage: "All (excluding personal)"
    },
    allExcludingPersonalDescription: {
        id: "space-utils.space-target-select.allExcludingPersonalDescription",
        defaultMessage: "Don't include any personal spaces"
    },
    allExcludingSpecific: {
        id: "space-utils.space-target-select.allExcludingSpecific",
        defaultMessage: "All (excluding specific spaces)"
    },
    allExcludingSpecificDescription: {
        id: "space-utils.space-target-select.allExcludingSpecificDescription",
        defaultMessage: "Choose specific spaces to exclude"
    },
    personal: {
        id: "space-utils.space-target-select.personal",
        defaultMessage: "Only personal"
    },
    personalDescription: {
        id: "space-utils.space-target-select.personalDescription",
        defaultMessage: "All personal spaces"
    },
    specific: {
        id: "space-utils.space-target-select.specific",
        defaultMessage: "Only specific spaces"
    },
    specificDescription: {
        id: "space-utils.space-target-select.specificDescription",
        defaultMessage: "Choose specific spaces to include"
    }
});
const $c8b68f6ea32b0094$var$menuItemStyle = {
    style: "_zulp1b66 _1e0c1txw _2lx21bp4"
};
const $c8b68f6ea32b0094$var$CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] !== props.data.label) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, props.data.label);
        $[0] = props.data.label;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.data.description) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, props.data.description);
        $[2] = props.data.description;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c8b68f6ea32b0094$var$menuItemStyle.style
        }, t0, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== props || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, t2);
        $[7] = props;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
});
const $c8b68f6ea32b0094$var$SELECT_STYLE_PROPS = {
    isSearchable: false,
    styles: {
        menu: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0,
                zIndex: (0, $g5lKx.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, $g5lKx.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        control: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0
            })
    }
};
const $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS = [
    {
        label: 'all',
        value: "ALL",
        description: 'allDescription'
    },
    {
        label: 'allExcludingPersonal',
        value: "ALL_EXCEPT_PERSONAL",
        description: 'allExcludingPersonalDescription'
    },
    {
        label: 'allExcludingSpecific',
        value: "ALL_EXCEPT_SPECIFIC",
        description: 'allExcludingSpecificDescription'
    },
    {
        label: 'personal',
        value: "PERSONAL",
        description: 'personalDescription'
    },
    {
        label: 'specific',
        value: "SPECIFIC",
        description: 'specificDescription'
    }
];
const $c8b68f6ea32b0094$export$f10aab7c26f92d55 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { onChange: onChange, spaceTargetValue: spaceTargetValue, menuPortalTarget: menuPortalTarget } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== formatMessage || $[1] !== onChange || $[2] !== spaceTargetValue) {
        let t4;
        if ($[7] !== formatMessage) {
            t4 = (option)=>({
                    label: formatMessage($c8b68f6ea32b0094$var$i18n[option.label]),
                    value: option.value,
                    description: formatMessage($c8b68f6ea32b0094$var$i18n[option.description])
                });
            $[7] = formatMessage;
            $[8] = t4;
        } else t4 = $[8];
        const options = $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS.map(t4);
        T0 = (0, $6T8v4.default);
        t1 = options;
        if ($[9] !== onChange) {
            t2 = (newValue)=>onChange(newValue?.value);
            $[9] = onChange;
            $[10] = t2;
        } else t2 = $[10];
        let t5;
        if ($[11] !== spaceTargetValue) {
            t5 = (option_0)=>String(option_0.value) === String(spaceTargetValue);
            $[11] = spaceTargetValue;
            $[12] = t5;
        } else t5 = $[12];
        t3 = options.find(t5);
        $[0] = formatMessage;
        $[1] = onChange;
        $[2] = spaceTargetValue;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Option: $c8b68f6ea32b0094$var$CustomOption
        };
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage($c8b68f6ea32b0094$var$i18n.ariaLabel);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== T0 || $[17] !== menuPortalTarget || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            options: t1,
            onChange: t2,
            value: t3,
            components: t4,
            menuPosition: "fixed",
            menuPortalTarget: menuPortalTarget,
            "aria-label": t5,
            ...$c8b68f6ea32b0094$var$SELECT_STYLE_PROPS
        });
        $[16] = T0;
        $[17] = menuPortalTarget;
        $[18] = t1;
        $[19] = t2;
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
};
module.exports["ConfluenceSpaceType"] = $c8b68f6ea32b0094$export$2fabe69f8125d5a7;
module.exports["SpaceTargetSelect"] = $c8b68f6ea32b0094$export$f10aab7c26f92d55;

});

parcelRegister("hHhbz", function(module, exports) {

var $5O1YC = parcelRequire("5O1YC");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/workspace/manifest.ts
var $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5O1YC.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $5O1YC.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $ce23c8815c812c15$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $ce23c8815c812c15$export$d47d8a7e69df1865;

});

parcelRegister("5O1YC", function(module, exports) {
// src/confluence/workspace/types.ts
var $43a327cfc847ac6c$export$19f1a63686ec0369 = "confluence", $43a327cfc847ac6c$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $43a327cfc847ac6c$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $43a327cfc847ac6c$export$f1c423a93fbc71;

});

parcelRegister("gHaxX", function(module, exports) {

var $973aB = parcelRequire("973aB");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/user/manifest.ts
var $c278d7dccfa97a86$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $973aB.IdentityUserAriResourceOwner),
    resourceType: (0, $973aB.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $c278d7dccfa97a86$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3NXcb.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $c278d7dccfa97a86$export$1e9d09c2be53e55e;

});

parcelRegister("973aB", function(module, exports) {
// src/identity/user/types.ts
var $6a2739fa6e7a2528$export$b4c14c54282a779d = "identity", $6a2739fa6e7a2528$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $6a2739fa6e7a2528$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $6a2739fa6e7a2528$export$e9b50e20f4fbfb71;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$31a43870c77aad50 = {
    NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE: 'simplify-nav-new-user:nthUserD0SimplifiedNavEligible',
    NTH_USER_D0_SIMPLIFIED_NAV_START_AT: 'simplify-nav-new-user:nthUserD0SimplifiedNavStartAt'
};
const $3c94963df51c0e13$export$400b215814bf3fc0 = {
    CHECKED_ELIGIBLE: 'creation-focused-nav-xflow:creationFocusedNavXflowCheckedEligible',
    START_AT: 'creation-focused-nav-xflow:creationFocusedNavXflowStartAt'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_START_AT
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$31a43870c77aad50),
    ...Object.values($3c94963df51c0e13$export$400b215814bf3fc0),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["SIMPLIFY_NAV_NEW_USER"] = $3c94963df51c0e13$export$31a43870c77aad50;
module.exports["CFIND_5565_CREATION_FOCUSED_NAV_XFLOW"] = $3c94963df51c0e13$export$400b215814bf3fc0;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("1KHQh", function(module, exports) {
// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure

var $6mKj3 = parcelRequire("6mKj3");

/**
 * Reads the experimentStartDate param from the cfind_5565_creation_focused_nav_xflow
 * experiment config without firing an exposure. Falls back to 2026-05-07 (the gate
 * rollout date) if the param is missing. Returns null only if the value is not a valid date.
 */ // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
const $47ca1d22622dd352$var$XFLOW_EXPERIMENT_START_DATE_FALLBACK = '2026-05-07';
const $47ca1d22622dd352$export$9aeee5d7687bf679 = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind_5565_creation_focused_nav_xflow'); // Experiment exposure is fired elsewhere
    const rawValue = expConfig.get('experimentStartDate', $47ca1d22622dd352$var$XFLOW_EXPERIMENT_START_DATE_FALLBACK);
    const date = new Date(rawValue);
    return isNaN(date.getTime()) ? null : date;
};
module.exports["getXflowExperimentStartDate"] = $47ca1d22622dd352$export$9aeee5d7687bf679;

});

parcelRegister("6Dfc9", function(module, exports) {

var $8uR5k = parcelRequire("8uR5k");

var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");

function $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb(isoTimestamp) {
    if (!isoTimestamp) return false;
    const parsed = (0, $da71s.default)(isoTimestamp);
    return (0, $cFEpk.default)(parsed) && (0, $8uR5k.default)(new Date(), parsed) < 24;
}
function $e250b9cfd6dd2931$export$193a557a4d23c9aa(epochMs) {
    const date = new Date(epochMs);
    return (0, $cFEpk.default)(date) && (0, $8uR5k.default)(new Date(), date) < 24;
}
module.exports["isWithinD0Window"] = $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb;

});

parcelRegister("8uR5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $62fa4da7b1bddd96$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $62fa4da7b1bddd96$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInHour);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("aw3Ol", function(module, exports) {
/**
 * @generated SignedSource<<00d0e5d3a37f990b5c57e90cb9a4c167>>
 * @relayHash b6deec744f60682230923700997837b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 578d3e82faa4f8b41e9b4a045d22acfafcc5d643787b30aaeacc2c8d0b374b37
const $1195ff799ce1de07$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v2 = {
        "concreteType": "SpaceMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "totalCurrentBlogPosts"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadSpaceBlogCountQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadSpaceBlogCountQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b6deec744f60682230923700997837b2",
            "id": "578d3e82faa4f8b41e9b4a045d22acfafcc5d643787b30aaeacc2c8d0b374b37",
            "metadata": {},
            "name": "preloadSpaceBlogCountQuery",
            "operationKind": "query",
            "text": "query preloadSpaceBlogCountQuery($spaceKey:String!){space(key:$spaceKey){metadata{totalCurrentBlogPosts},id}}"
        }
    };
}();
$1195ff799ce1de07$var$node.hash = "050c888582515da2caf3f8b71a1e7a45";
var $1195ff799ce1de07$export$2e2bcd8739ae039 = $1195ff799ce1de07$var$node;
module.exports["default"] = $1195ff799ce1de07$export$2e2bcd8739ae039;

});

parcelRegister("iQzVo", function(module, exports) {
const $ac3059bce5b9a0ea$export$7bed14e1f2921c0a = {
    ENROLMENT_DATE: 'twcg-1489:enrolmentDate',
    SPOTLIGHT_SHOWN: 'twcg-1489:spotlightShown',
    PROMO_DISMISSED: 'twcg-1489:promoDismissed'
};
const $ac3059bce5b9a0ea$export$461c2b41206d7875 = [
    ...Object.values($ac3059bce5b9a0ea$export$7bed14e1f2921c0a)
];
module.exports["TWCG_1489_CONNECTOR_ONBOARDING"] = $ac3059bce5b9a0ea$export$7bed14e1f2921c0a;
module.exports["Twcg1489ConnectorOnboardingKeys"] = $ac3059bce5b9a0ea$export$461c2b41206d7875;

});

parcelRegister("gikGR", function(module, exports) {
/**
 * @generated SignedSource<<aecbb2a2fb7d4d0b370b72d42ff93673>>
 * @relayHash 7174e5f46f94e0340e2be57ace17cb1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c4fb068086036b0d8869003abab5519d1e65fc7c47b58a70ea5c07745b05c8f
const $878e3b8b3ab16eac$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": [
                                "twcg-1489:enrolmentDate",
                                "twcg-1489:spotlightShown",
                                "twcg-1489:promoDismissed"
                            ]
                        }
                    ],
                    "concreteType": "UserOnboardingState",
                    "kind": "LinkedField",
                    "name": "onboardingState",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ],
                    "storageKey": "onboardingState(key:[\"twcg-1489:enrolmentDate\",\"twcg-1489:spotlightShown\",\"twcg-1489:promoDismissed\"])"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useConnectorOnboardingStateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useConnectorOnboardingStateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7174e5f46f94e0340e2be57ace17cb1a",
            "id": "3c4fb068086036b0d8869003abab5519d1e65fc7c47b58a70ea5c07745b05c8f",
            "metadata": {},
            "name": "useConnectorOnboardingStateQuery",
            "operationKind": "query",
            "text": "query useConnectorOnboardingStateQuery{userPreferences{onboardingState(key:[\"twcg-1489:enrolmentDate\",\"twcg-1489:spotlightShown\",\"twcg-1489:promoDismissed\"]){key,value}}}"
        }
    };
}();
$878e3b8b3ab16eac$var$node.hash = "d9e97ff849d5b5284d9dd5284d3cab5d";
var $878e3b8b3ab16eac$export$2e2bcd8739ae039 = $878e3b8b3ab16eac$var$node;
module.exports["default"] = $878e3b8b3ab16eac$export$2e2bcd8739ae039;

});

parcelRegister("ljH80", function(module, exports) {
/**
 * @generated SignedSource<<def63672abb49c009b08c3310289a240>>
 * @relayHash 3645f14258aaf6df779f3874a7b10083
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 794380e9c61483adc5407aecc7ee4f9434dbddfd1b24827095cb41bca86c6bd6
const $761d928d522d0b4f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "userId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "teamType"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConnectorOnboardingTeamTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConnectorOnboardingTeamTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3645f14258aaf6df779f3874a7b10083",
            "id": "794380e9c61483adc5407aecc7ee4f9434dbddfd1b24827095cb41bca86c6bd6",
            "metadata": {},
            "name": "useConnectorOnboardingTeamTypeQuery",
            "operationKind": "query",
            "text": "query useConnectorOnboardingTeamTypeQuery($userId:ID!){user(accountId:$userId){__typename,...on AtlassianAccountUser{extendedProfile{teamType}},id}}"
        }
    };
}();
$761d928d522d0b4f$var$node.hash = "a2ab021a37664174ea5177e550544833";
var $761d928d522d0b4f$export$2e2bcd8739ae039 = $761d928d522d0b4f$var$node;
module.exports["default"] = $761d928d522d0b4f$export$2e2bcd8739ae039;

});

parcelRegister("iGpO4", function(module, exports) {
/**
 * @generated SignedSource<<583af0bf5d1397e9bb81877c0829a09c>>
 * @relayHash ed1c7ead1865251e45173593feb0b728
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b96b68ccc999039ea351e31941246e5bb0c0400a30e73f61b5c8a6ce57245ae1
const $dba60705293b2bec$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceId"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orgId",
                    "variableName": "orgId"
                },
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "concreteType": "AdminConnectorConnection",
            "kind": "LinkedField",
            "name": "admin_getAllDataSources",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AdminConnectorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "AdminConnector",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "concreteType": "AdminDataSource",
                                    "kind": "LinkedField",
                                    "name": "datasources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useConnectorStatesQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useConnectorStatesQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ed1c7ead1865251e45173593feb0b728",
            "id": "b96b68ccc999039ea351e31941246e5bb0c0400a30e73f61b5c8a6ce57245ae1",
            "metadata": {},
            "name": "useConnectorStatesQuery",
            "operationKind": "query",
            "text": "query useConnectorStatesQuery($orgId:ID!,$resourceId:ID!,$first:Int){admin_getAllDataSources(orgId:$orgId,resourceId:$resourceId,first:$first){edges{node{type,datasources{enabled}}}}}"
        }
    };
}();
$dba60705293b2bec$var$node.hash = "c1e906a9d592c8090d7d5864937f0dbe";
var $dba60705293b2bec$export$2e2bcd8739ae039 = $dba60705293b2bec$var$node;
module.exports["default"] = $dba60705293b2bec$export$2e2bcd8739ae039;

});

parcelRegister("7N8s0", function(module, exports) {
const $8757e52306056bac$var$MS_PER_DAY = 86400000;
const $8757e52306056bac$export$3ea4f037284b04bc = 30;
function $8757e52306056bac$export$be44dc7b069e47e9(enrolmentDateStr) {
    if (!enrolmentDateStr) return 0;
    return Math.floor((Date.now() - new Date(enrolmentDateStr).getTime()) / $8757e52306056bac$var$MS_PER_DAY);
}
function $8757e52306056bac$export$224893a904971d5d(enrolmentDateStr, windowDays = $8757e52306056bac$export$3ea4f037284b04bc) {
    if (!enrolmentDateStr) return false;
    return $8757e52306056bac$export$be44dc7b069e47e9(enrolmentDateStr) <= windowDays;
}
module.exports["getDaysSinceEnrolment"] = $8757e52306056bac$export$be44dc7b069e47e9;
module.exports["isWithinEnrolmentWindow"] = $8757e52306056bac$export$224893a904971d5d;

});

parcelRegister("4vyfK", function(module, exports) {

var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $iEfsZ = parcelRequire("iEfsZ");


var $eSLr0 = parcelRequire("eSLr0");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
const $2272f3d6a41ef128$var$isSystemBatchLocation = (location)=>location.length === 2 && location.includes((0, $eSLr0.SYSTEM_HEADER_LEFT)) && location.includes((0, $eSLr0.SYSTEM_USER));
// Keep this in sync with the editorToolbarLocations batched by
// load-edit-page/src/preload/preloadEditorData.ts.
const $2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS = [
    (0, $eSLr0.TOOLS_MENU_CONTAINER),
    (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS)
];
const $2272f3d6a41ef128$var$CONTENT_BATCH_ALLOWED_LOCATIONS = new Set([
    ...$2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS,
    (0, $eSLr0.PAGE_BUTTONS)
]);
const $2272f3d6a41ef128$var$isContentBatchLocation = (location)=>{
    const locationSet = new Set(location);
    return $2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS.every((requiredLocation)=>locationSet.has(requiredLocation)) && [
        ...locationSet
    ].every((candidateLocation)=>$2272f3d6a41ef128$var$CONTENT_BATCH_ALLOWED_LOCATIONS.has(candidateLocation));
};
const $2272f3d6a41ef128$var$filterSectionsByLocations = (webItemSections, locations)=>webItemSections.filter((section)=>locations.some((location)=>section?.id?.startsWith(`${location}/`)));
const $2272f3d6a41ef128$var$writeWebItemLocationCache = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $iEfsZ.default),
        variables: {
            location: null,
            locations: locations,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        data: {
            webItemSections: webItemSections
        },
        __callerPackage__: "@confluence/web-item-location"
    });
};
const $2272f3d6a41ef128$var$writeWebItemLocationEntries = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    locations.forEach((location)=>{
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: location,
                locations: [],
                contentId: contentId,
                spaceKey: spaceKey,
                version: version
            },
            data: {
                webItemSections: $2272f3d6a41ef128$var$filterSectionsByLocations(webItemSections, [
                    location
                ])
            },
            __callerPackage__: "@confluence/web-item-location"
        });
    });
};
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, context: context } = {}) {
    if (!contentId && spaceKey) return (0, $dYU3e.query)({
        query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
        variables: {
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            spaceKey: spaceKey,
            version: version
        },
        context: context,
        __callerPackage__: "@confluence/web-item-location"
    }).then(({ data: data })=>{
        if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                contentId: data?.space?.homepageId,
                spaceKey: null,
                version: version
            },
            data: {
                webItemSections: data?.space?.homepageWebSections || []
            },
            __callerPackage__: "@confluence/web-item-location"
        });
    });
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    const result = (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables,
        context: context,
        __callerPackage__: "@confluence/web-item-location"
    });
    if (Array.isArray(location)) {
        const shouldWriteSystemBatchEntries = (0, $6mKj3.expValEquals)('web_item_query_batch_system_call', 'isEnabled', true) && $2272f3d6a41ef128$var$isSystemBatchLocation(location);
        const shouldWriteContentBatchEntries = $2272f3d6a41ef128$var$isContentBatchLocation(location) && (0, $6mKj3.expValEquals)('web_item_query_batch_content_call', 'isEnabled', true);
        if (shouldWriteSystemBatchEntries || shouldWriteContentBatchEntries) result.then(({ data: data })=>{
            if (!data?.webItemSections) return;
            $2272f3d6a41ef128$var$writeWebItemLocationCache({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
            $2272f3d6a41ef128$var$writeWebItemLocationEntries({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
            if (shouldWriteContentBatchEntries && location.includes((0, $eSLr0.PAGE_BUTTONS))) {
                const liveEllipsisLocations = [
                    (0, $eSLr0.TOOLS_MENU_CONTAINER),
                    (0, $eSLr0.PAGE_BUTTONS)
                ];
                $2272f3d6a41ef128$var$writeWebItemLocationCache({
                    locations: liveEllipsisLocations,
                    contentId: contentId,
                    spaceKey: spaceKey,
                    version: version,
                    webItemSections: $2272f3d6a41ef128$var$filterSectionsByLocations(data.webItemSections, liveEllipsisLocations)
                });
            }
        });
    }
    return result;
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<723e491a15ec21972dd962ca0e8f8ba8>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<50efd21e0db5811e6867b792d80a2f0a>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("8dUjs", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");


var $eSLr0 = parcelRequire("eSLr0");


var $7Ndnw = parcelRequire("7Ndnw");


var $5tgcI = parcelRequire("5tgcI");

const $84cd59e06a85be4f$export$a9c446837cd59ef8 = [
    (0, $5tgcI.SPACES_KEY),
    (0, $5tgcI.PEOPLE_KEY),
    (0, $5tgcI.DISCOVER_KEY)
];
const $84cd59e06a85be4f$export$a56df56fab66279e = ({ edition: edition, accessStatus: accessStatus })=>{
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const hideAutomation = edition !== 'PREMIUM' || !isAdmin;
    const notAllowedWebItems = [
        ...$84cd59e06a85be4f$export$a9c446837cd59ef8,
        hideAutomation ? (0, $5tgcI.AUTOMATION_KEY) : ''
    ];
    return {
        webItemParams: {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            notAllowedWebItems: notAllowedWebItems
        },
        forgeExtensionParams: {
            moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
            spaceKey: ''
        }
    };
};
module.exports["getGlobalAppsParams"] = $84cd59e06a85be4f$export$a56df56fab66279e;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("5tgcI", function(module, exports) {
const $696759caf06ef68c$export$af39e4edc5e74 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $696759caf06ef68c$export$97c436ccc42cbac9 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $696759caf06ef68c$export$3a7ae658938afc39 = 'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.confluence.emcee__enduser-discover';
const $696759caf06ef68c$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link';
const $696759caf06ef68c$export$8a23ae6ca6b0c9ee = 'com.atlassian.confluence.extra.team-calendars:header-mycalendar-link';
const $696759caf06ef68c$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics__analytics-instance-settings-menu-item-adg3';
const $696759caf06ef68c$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics.moderate__analytics-instance-settings-menu-item-adg3';
module.exports["SPACES_KEY"] = $696759caf06ef68c$export$af39e4edc5e74;
module.exports["PEOPLE_KEY"] = $696759caf06ef68c$export$97c436ccc42cbac9;
module.exports["DISCOVER_KEY"] = $696759caf06ef68c$export$3a7ae658938afc39;
module.exports["AUTOMATION_KEY"] = $696759caf06ef68c$export$ee99bc1ad01a63ae;
module.exports["CALENDAR_KEY"] = $696759caf06ef68c$export$8a23ae6ca6b0c9ee;
module.exports["ANALYTICS_KEY"] = $696759caf06ef68c$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $696759caf06ef68c$export$6c3d789a4f56bea2;

});

parcelRegister("hPkGG", function(module, exports) {
/**
 * @generated SignedSource<<5efd4a44b24bb87c092d4fc494599337>>
 * @relayHash ee5a91706bc8d2c36266138f1556fa8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a
const $62aeb16db236e807$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SettingsMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "sidebar",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "menuId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "visible"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalNavigationComponentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalNavigationComponentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ee5a91706bc8d2c36266138f1556fa8e",
            "id": "7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a",
            "metadata": {},
            "name": "GlobalNavigationComponentQuery",
            "operationKind": "query",
            "text": "query GlobalNavigationComponentQuery($entityAri:ID!,$ownerAri:ID!){settings_navigationCustomisation(entityAri:$entityAri,ownerAri:$ownerAri){id,sidebar{nodes{menuId,visible}}}}"
        }
    };
}();
$62aeb16db236e807$var$node.hash = "0e74e77d53a00c9095e60ae7930a7cf3";
var $62aeb16db236e807$export$2e2bcd8739ae039 = $62aeb16db236e807$var$node;
module.exports["default"] = $62aeb16db236e807$export$2e2bcd8739ae039;

});

parcelRegister("aQN68", function(module, exports) {
/**
 * @generated SignedSource<<4397834310e821608aae72d6cd602b23>>
 * @relayHash efbccdac5bb753d6ce419c019fa1aaca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439
const $ede2af096215976f$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "efbccdac5bb753d6ce419c019fa1aaca",
            "id": "2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439",
            "metadata": {},
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "operationKind": "query",
            "text": "query useLicensedProductsQueryForGlobalAppShortcutsQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$ede2af096215976f$var$node.hash = "4173fb2f98b7988a84dc02df0399a348";
var $ede2af096215976f$export$2e2bcd8739ae039 = $ede2af096215976f$var$node;
module.exports["default"] = $ede2af096215976f$export$2e2bcd8739ae039;

});

parcelRegister("aT8im", function(module, exports) {

var $5wdey = parcelRequire("5wdey");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1o4fX = parcelRequire("1o4fX");


var $7Sm4c = parcelRequire("7Sm4c");





var $ivb8S = parcelRequire("ivb8S");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $318f5483656bcff4$export$cf07606bc08d56a7 = 'growth-luna-edition-awareness-standard-to-premium:treatmentPillDismissed';
const $318f5483656bcff4$var$UseConfluenceStandardToPremiumExperimentQuery = (0, $5wdey.default);
const $318f5483656bcff4$export$f2e766b4a1af4c38 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($318f5483656bcff4$var$UseConfluenceStandardToPremiumExperimentQuery, {
        variables: {
            key: [
                $318f5483656bcff4$export$cf07606bc08d56a7
            ]
        },
        fetchPolicy: 'cache-only',
        __callerPackage__: "@confluence/experiment-edition-awareness-for-standard-to-premium"
    });
    const { edition: confluenceEdition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: $318f5483656bcff4$export$cf07606bc08d56a7,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) {
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'failed',
                actionSubject: 'ea-standard-to-premium-query',
                source: 'useConfluenceStandardToPremiumExperiment',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    error: error.message
                }
            }
        }).fire();
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    // Exposure fired earlier in experiment when they see EA
    const enrolled = (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('edition_awareness_standard_upsell_confluence_ab', 'cohort', 'control') || (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('edition_awareness_standard_upsell_confluence_ab', 'cohort', 'treatment');
    const isSiteAdmin = data?.isSiteAdmin;
    const edition = confluenceEdition?.toLocaleLowerCase();
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(data?.license?.trialEndDate);
    const isInTrial = !data || loading || error ? undefined : trialDaysLeft ? trialDaysLeft > 0 : false;
    const firstPredunningEndTime = data?.license?.firstPredunningEndTime;
    const isInPreDunning = firstPredunningEndTime ? Date.now() < firstPredunningEndTime : false;
    const { treatmentPillDismissed: treatmentPillDismissed } = (0, $ivb8S.deserializeState)(data?.onboardingState ? {
        onboardingState: data?.onboardingState
    } : null);
    const isDismissed = loading || !!error || !!treatmentPillDismissed;
    const isEligibleForUpsellExperiment = enrolled && edition === 'standard' && isInTrial === false && !isInPreDunning && !!isSiteAdmin;
    return {
        isEligibleForUpsellExperiment: isEligibleForUpsellExperiment,
        cloudId: cloudId,
        product: 'confluence',
        edition: edition,
        userRoles: isSiteAdmin ? [
            'SITE_ADMIN'
        ] : [],
        hasDismissedButton: isDismissed,
        onDismissButton: handleDismiss
    };
};
module.exports["EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED"] = $318f5483656bcff4$export$cf07606bc08d56a7;
module.exports["useConfluenceStandardToPremiumExperiment"] = $318f5483656bcff4$export$f2e766b4a1af4c38;

});

parcelRegister("5wdey", function(module, exports) {
/**
 * @generated SignedSource<<239dd6a94e28f730c916b6e5c524ccf0>>
 * @relayHash 8dc51dcb846862aa9c8f8929ac2aebfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 53d89db9d85056eef82787d8d31a7893b60114ad98b36ee3758ba073330b2852
const $6015d94d40bd1aa0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        },
        {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "trialEndDate"
                },
                {
                    "kind": "ScalarField",
                    "name": "firstPredunningEndTime"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConfluenceStandardToPremiumExperimentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConfluenceStandardToPremiumExperimentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8dc51dcb846862aa9c8f8929ac2aebfd",
            "id": "53d89db9d85056eef82787d8d31a7893b60114ad98b36ee3758ba073330b2852",
            "metadata": {},
            "name": "useConfluenceStandardToPremiumExperimentQuery",
            "operationKind": "query",
            "text": "query useConfluenceStandardToPremiumExperimentQuery($key:[String]){isSiteAdmin,onboardingState(key:$key){key,value},license{trialEndDate,firstPredunningEndTime}}"
        }
    };
}();
$6015d94d40bd1aa0$var$node.hash = "3dcc62a6c345897ba2c1f5872f6a9096";
var $6015d94d40bd1aa0$export$2e2bcd8739ae039 = $6015d94d40bd1aa0$var$node;
module.exports["default"] = $6015d94d40bd1aa0$export$2e2bcd8739ae039;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $cbOce = parcelRequire("cbOce");


var $1cHqV = parcelRequire("1cHqV");


var $8Z78B = parcelRequire("8Z78B");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");

const $6fc4b7bb962289cc$var$isOnboardingStateEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return !a && !b;
    if (a.length !== b.length) return false;
    return a.every((item, i)=>item.key === b[i].key && item.value === b[i].value);
};
// Hook to check if we're on a view page route
const $6fc4b7bb962289cc$var$useIsViewPageRoute = ()=>(0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
// Get the combined onboarding state from cache, returns null if not cached
const $6fc4b7bb962289cc$var$getCombinedQueryFromCache = ()=>{
    try {
        return (0, $l1uFv.readQueryInterop)({
            query: (0, $8Z78B.default),
            variables: {
                key: []
            },
            __callerPackage__: "@confluence/onboarding-helpers"
        });
    } catch  {
        return null;
    }
};
// Updates the combined query cache with new onboarding state values.
// This ensures components using the centralized cache see updates on next mount/navigation.
const $6fc4b7bb962289cc$var$updateCombinedQueryCache = (updatedStates)=>{
    if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return;
    const currentData = $6fc4b7bb962289cc$var$getCombinedQueryFromCache();
    if (!currentData?.onboardingState) return;
    const updatedMap = new Map(updatedStates.map((s)=>[
            s.key,
            s.value
        ]));
    const newOnboardingState = currentData.onboardingState.map((item)=>updatedMap.has(item.key) ? {
            ...item,
            value: updatedMap.get(item.key) ?? item.value
        } : item);
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        data: {
            onboardingState: newOnboardingState
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "@confluence/onboarding-helpers"
                });
            });
            // Update the combined query cache for centralized onboarding state
            $6fc4b7bb962289cc$var$updateCombinedQueryCache(states ?? []);
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    const setOnboardingState = (0, $42omo.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false, reactive = true)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const isViewPageRoute = $6fc4b7bb962289cc$var$useIsViewPageRoute();
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    // Check if centralized cache should be used (experiment enabled + on view page route)
    const useCentralizedCache = isViewPageRoute && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false);
    // For non-reactive mode: read from cache once (no subscription)
    // This is a one-time synchronous read that doesn't trigger re-renders on cache changes
    const cachedCombinedData = !reactive && useCentralizedCache ? $6fc4b7bb962289cc$var$getCombinedQueryFromCache() : null;
    const hasCachedCombinedData = cachedCombinedData !== null;
    // For reactive mode: use useQueryInterop with cache-only to subscribe to cache changes
    // This subscribes to the centralized cache and re-renders when it changes (no network requests)
    const { data: reactiveCacheData, error: reactiveCacheError, loading: reactiveCacheLoading } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: []
        },
        skip: skipQuery || !reactive || !useCentralizedCache,
        fetchPolicy: 'cache-only',
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Memoize the filtered reactive cache result so filterOnboardingState is only called
    // when reactiveCacheData or key actually changes — not on every render.
    //
    // We must not skip the fallback just because reactiveCacheData is truthy — the centralized
    // cache may not contain the specific keys this consumer requested (e.g. the preload fetched
    // a different set of keys). We only skip the fallback when the filtered reactive cache data
    // actually has entries for the requested keys.
    const { reactiveFilteredData: reactiveFilteredData, reactiveFilteredHasData: reactiveFilteredHasData } = (0, $42omo.useMemo)(()=>{
        if (!(reactive && useCentralizedCache && reactiveCacheData)) return {
            reactiveFilteredData: null,
            reactiveFilteredHasData: false
        };
        const filtered = (0, $1cHqV.filterOnboardingState)(reactiveCacheData, key);
        return {
            reactiveFilteredData: filtered,
            reactiveFilteredHasData: (filtered?.onboardingState?.length ?? 0) > 0
        };
    }, [
        reactive,
        useCentralizedCache,
        reactiveCacheData,
        key
    ]);
    const { data: fallbackQueryData, error: fallbackError, loading: fallbackLoading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery || hasCachedCombinedData || reactiveFilteredHasData,
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Determine which data source to use:
    // 1. Non-reactive with cached data: use cachedCombinedData (filtered)
    // 2. Reactive with centralized cache and keys found: use reactiveFilteredData
    // 3. Fallback: use fallbackQueryData
    // For reactive path: skip re-render if filtered data for our keys hasn't changed
    const prevFilteredDataRef = (0, $42omo.useRef)(undefined);
    const data = (0, $42omo.useMemo)(()=>{
        if (hasCachedCombinedData) return (0, $1cHqV.filterOnboardingState)(cachedCombinedData, key);
        if (reactiveFilteredHasData && reactiveFilteredData) {
            if (prevFilteredDataRef.current && $6fc4b7bb962289cc$var$isOnboardingStateEqual(prevFilteredDataRef.current.onboardingState, reactiveFilteredData.onboardingState)) return prevFilteredDataRef.current;
            prevFilteredDataRef.current = reactiveFilteredData;
            return reactiveFilteredData;
        }
        return fallbackQueryData;
    }, [
        hasCachedCombinedData,
        cachedCombinedData,
        reactiveFilteredHasData,
        reactiveFilteredData,
        fallbackQueryData,
        key
    ]);
    // Combine error and loading states from both queries
    const error = reactiveCacheError || fallbackError;
    // When centralized cache is enabled in reactive mode but the preload hasn't populated
    // the cache yet, cache-only returns loading: false with data: undefined. Without this
    // guard, consumers interpret undefined data as "user never saw this onboarding" and
    // incorrectly show spotlights/changeboarding that was already dismissed.
    // We report loading: true until either the reactive cache or fallback has actual data.
    //
    // Also guard the case where the reactive cache is populated but doesn't contain the
    // specific keys this consumer requested (reactiveFilteredHasData is false). In that
    // scenario the fallback query has been allowed to run — keep loading: true until it
    // either returns data or an error, so consumers don't prematurely see empty state.
    const isCentralizedCacheWaitingForPreload = reactive && useCentralizedCache && (!reactiveCacheData || !reactiveFilteredHasData) && !fallbackQueryData && !skipQuery && !reactiveCacheError && !fallbackError;
    const loading = isCentralizedCacheWaitingForPreload || (reactive && useCentralizedCache ? reactiveCacheLoading : false) || fallbackLoading;
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("1cHqV", function(module, exports) {
// Cache for filtered onboarding state results.
// Uses WeakMap keyed by data object (auto-clears when data is garbage collected),
// with nested Map keyed by keys string for O(1) lookup.
const $e7b7b792910c4288$var$filteredStateCache = new WeakMap();
/**
 * Creates a cache key from the requested keys.
 */ const $e7b7b792910c4288$var$createCacheKey = (keys)=>{
    return Array.isArray(keys) ? keys.join(',') : keys;
};
/**
 * Performs the actual filtering of onboarding state data.
 */ const $e7b7b792910c4288$var$filterData = (data, requestedKeys)=>{
    const keysArray = Array.isArray(requestedKeys) ? requestedKeys : [
        requestedKeys
    ];
    const keySet = new Set(keysArray);
    return {
        ...data,
        onboardingState: data.onboardingState?.filter(({ key: key })=>{
            // Check both the full key and the parsed key (without prefix)
            // Keys come back as "{prefix}:{property}" format
            const parsedKey = key.split(':')[1] || key;
            return keySet.has(key) || keySet.has(parsedKey);
        })
    };
};
const $e7b7b792910c4288$export$c1dd389f39afa62f = (data, requestedKeys)=>{
    if (!data?.onboardingState) // Convert null to undefined to maintain backward compatibility with consumers
    // that expect `T | undefined` rather than `T | null | undefined`
    return data ?? undefined;
    const cacheKey = $e7b7b792910c4288$var$createCacheKey(requestedKeys);
    let dataCache = $e7b7b792910c4288$var$filteredStateCache.get(data);
    if (!dataCache) {
        dataCache = new Map();
        $e7b7b792910c4288$var$filteredStateCache.set(data, dataCache);
    }
    if (dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const filteredResult = $e7b7b792910c4288$var$filterData(data, requestedKeys);
    dataCache.set(cacheKey, filteredResult);
    return filteredResult;
};
module.exports["filterOnboardingState"] = $e7b7b792910c4288$export$c1dd389f39afa62f;

});

parcelRegister("cbHql", function(module, exports) {
/**
 * @generated SignedSource<<ca53475eaec9df41a732c9e6f52f225d>>
 * @relayHash c67b40e0841cbe3641e147b8f635e291
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5
const $40163854596f3729$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c67b40e0841cbe3641e147b8f635e291",
            "id": "8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5",
            "metadata": {},
            "name": "EditorPreferencesQuery",
            "operationKind": "query",
            "text": "query EditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$40163854596f3729$var$node.hash = "49dd5f6cf6c26477ad455a4c7f501e60";
var $40163854596f3729$export$2e2bcd8739ae039 = $40163854596f3729$var$node;
module.exports["default"] = $40163854596f3729$export$2e2bcd8739ae039;

});

parcelRegister("3y1ko", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
        if (res.ok) enabled = await res.text() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await $4c06255176f911bc$export$632d1cf1f5c6210f();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("wPrRK", function(module, exports) {


var $9WAeG = parcelRequire("9WAeG");


var $1xpoY = parcelRequire("1xpoY");



const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        const run = async ()=>{
            await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
            if (timer) clearTimeout(timer);
            return true;
        };
        return run();
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("b2p4s", function(module, exports) {
/**
 * @generated SignedSource<<4e480f3ff7d119a77ec41231b6b4ab42>>
 * @relayHash aa12b95dc97d2068b03de4a55dcec507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c
const $ac606d0e22e5c37c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "aa12b95dc97d2068b03de4a55dcec507",
            "id": "0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c",
            "metadata": {},
            "name": "NotFoundContainerQuery",
            "operationKind": "query",
            "text": "query NotFoundContainerQuery($contentId:ID!,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,links{webui},properties(key:\"editor\"){nodes{id,key,value}}}}}"
        }
    };
}();
$ac606d0e22e5c37c$var$node.hash = "df3b0c202e5cf0f97257fa8a583747bc";
var $ac606d0e22e5c37c$export$2e2bcd8739ae039 = $ac606d0e22e5c37c$var$node;
module.exports["default"] = $ac606d0e22e5c37c$export$2e2bcd8739ae039;

});

parcelRegister("cS4kb", function(module, exports) {
const $5b142abb1411e5f7$var$UNKNOWN = 'unknown';
function $5b142abb1411e5f7$var$sanitizeUrl(url) {
    try {
        const urlObject = new URL(url);
        const hostname = urlObject.hostname;
        const pathname = urlObject.pathname;
        const firstPathSegment = pathname.split('/')[1];
        return firstPathSegment ? `${hostname}/${firstPathSegment}` : hostname;
    } catch  {
        return '';
    }
}
function $5b142abb1411e5f7$export$8071740a02e53ce2(link) {
    if (link.includes('/jira/') || link.includes('/servicedesk/') || link.includes('/helpcenter/') || link.includes('/projects/')) return 'jira';
    else if (link.includes('/wiki/')) return 'confluence';
    else if (link.includes('bitbucket')) return 'bitbucket';
    else if (link.includes('atlassian') || link.includes('jira-dev')) {
        // eslint-disable-next-line no-console
        console.log(`Resolving other atlassian link type: ${$5b142abb1411e5f7$var$sanitizeUrl(link)}`);
        return 'otherAtlassian';
    }
    return 'thirdParty';
}
function $5b142abb1411e5f7$export$70b802114e3b3d52(smartLinks) {
    return Object.values(smartLinks.reduce((acc, smartLink)=>{
        try {
            var _acc, _hostname;
            const hostname = new URL(smartLink.resourceUrl).hostname;
            ((_acc = acc)[_hostname = hostname] || (_acc[_hostname] = [])).push(smartLink);
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
            var _acc1, _UNKNOWN;
            ((_acc1 = acc)[_UNKNOWN = $5b142abb1411e5f7$var$UNKNOWN] || (_acc1[_UNKNOWN] = [])).push(smartLink);
        }
        return acc;
    }, {}));
}
function $5b142abb1411e5f7$export$9f4b5e6e623e6720(smartLinksGroups, max) {
    const result = [];
    for (const smartLinks of smartLinksGroups){
        if (smartLinks.length <= max) result.push(smartLinks);
        else for(let i = 0; i < smartLinks.length; i += max)result.push(smartLinks.slice(i, i + max));
    }
    return result;
}
function $5b142abb1411e5f7$export$3e7fb54d0ef2df07(smartLinksGroups, min) {
    const result = [];
    const smallThirdPartyBatches = [];
    for (const smartLinks of smartLinksGroups)if (smartLinks.length >= min || $5b142abb1411e5f7$export$8071740a02e53ce2(smartLinks[0].resourceUrl) !== 'thirdParty') result.push(smartLinks);
    else smallThirdPartyBatches.push(...smartLinks);
    if (smallThirdPartyBatches.length > 0) result.push(smallThirdPartyBatches);
    return result;
}
function $5b142abb1411e5f7$export$8c4674ec524aaf2c(resourceUrl) {
    const type = $5b142abb1411e5f7$export$8071740a02e53ce2(resourceUrl);
    switch(type){
        case 'jira':
        case 'confluence':
        case 'bitbucket':
        case 'otherAtlassian':
            return true;
        default:
            return false;
    }
}
module.exports["getLinkType"] = $5b142abb1411e5f7$export$8071740a02e53ce2;
module.exports["groupSmartLinksByHostname"] = $5b142abb1411e5f7$export$70b802114e3b3d52;
module.exports["splitLinksIntoBatches"] = $5b142abb1411e5f7$export$9f4b5e6e623e6720;
module.exports["mergeSmallThirdPartyBatches"] = $5b142abb1411e5f7$export$3e7fb54d0ef2df07;
module.exports["isFirstPartyLink"] = $5b142abb1411e5f7$export$8c4674ec524aaf2c;

});

parcelRegister("fyUox", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (0, $dYU3e.query)({
        query: (0, $zalpJ.PreloadHomepageIdQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/content-topper"
    });
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "@confluence/content-topper"
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c93173dea6bc8ed379cb4b9b29fb2a88>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $1Y111 = parcelRequire("1Y111");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const { data: data, error: error, loading: loading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<27d66eab829e89ba017f17104702246d>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("7Ba23", function(module, exports) {
/**
 * @generated SignedSource<<3133240f1151076460fe7527c7d2ed07>>
 * @relayHash 20f962b7fded29f4112b167bd49676c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8346be568da1ca3d59b43656aaeecc1204136933a0c9edc5ee7a3bffd1720553
const $13f118fd299fdf03$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inputText"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraAssigneeAccountId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraReporterAccountId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceId"
    }, v5 = [
        {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "inputText",
                            "variableName": "inputText"
                        },
                        {
                            "kind": "Variable",
                            "name": "jiraAssigneeAccountId",
                            "variableName": "jiraAssigneeAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "jiraReporterAccountId",
                            "variableName": "jiraReporterAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "workspaceId",
                            "variableName": "workspaceId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "keyPhrases",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "keyPhrase"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        }
                                    ]
                                }
                            ],
                            "type": "KnowledgeDiscoveryKeyPhraseConnection"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "preloadAutohighlightsQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "preloadAutohighlightsQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "20f962b7fded29f4112b167bd49676c6",
            "id": "8346be568da1ca3d59b43656aaeecc1204136933a0c9edc5ee7a3bffd1720553",
            "metadata": {},
            "name": "preloadAutohighlightsQuery",
            "operationKind": "query",
            "text": "query preloadAutohighlightsQuery($entityAri:String!,$workspaceId:String!,$jiraReporterAccountId:String,$jiraAssigneeAccountId:String,$inputText:KnowledgeDiscoveryKeyPhraseInputText){knowledgeDiscovery{keyPhrases(entityAri:$entityAri,workspaceId:$workspaceId,jiraReporterAccountId:$jiraReporterAccountId,jiraAssigneeAccountId:$jiraAssigneeAccountId,inputText:$inputText)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}"
        }
    };
}();
$13f118fd299fdf03$var$node.hash = "2a72a5d970db2a37637d355335972efa";
var $13f118fd299fdf03$export$2e2bcd8739ae039 = $13f118fd299fdf03$var$node;
module.exports["default"] = $13f118fd299fdf03$export$2e2bcd8739ae039;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("e1KOF", function(module, exports) {
const $0be7e0c610d9cd49$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
module.exports["ADFStages"] = $0be7e0c610d9cd49$export$3b94ef2190b2d585;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references',
    NATIVE: 'com.atlassian.confluence.native'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    IFRAME: 'iframe',
    POPULAR_LABELS: 'popular-labels',
    TASKS_REPORT_MACRO: 'tasks-report-macro',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide',
    PAGE_TREE_SEARCH: 'pagetreesearch',
    WIDGET: 'widget',
    CONTENT_REPORT_TABLE: 'content-report-table',
    CHANGE_HISTORY: 'change-history',
    VIEWPDF: 'viewpdf',
    ATTACHMENTS: 'attachments',
    AGENT_MANAGED_BLOCK: 'agent-managed-block'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ATTACHMENTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.IFRAME,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.POPULAR_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.WIDGET,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_REPORT_TABLE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHANGE_HISTORY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWPDF,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TASKS_REPORT_MACRO
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("6mEZ3", function(module, exports) {

var $aMlgD = parcelRequire("aMlgD");


var $8pcS0 = parcelRequire("8pcS0");


var $juS6m = parcelRequire("juS6m");

function $b31b733ebe52245a$export$d80a64b0df71385c(params) {
    if (params.hasOwnProperty('')) return $b31b733ebe52245a$var$getParamValue(params['']) || '';
    return '';
}
function $b31b733ebe52245a$export$1d258479ae5735d7(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (value !== '') curr[key] = value;
        return curr;
    }, {});
}
function $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (key !== '' || value !== '') curr[key] = {
            value: value
        };
        return curr;
    }, {});
}
// does every key have a value key inside?
function $b31b733ebe52245a$var$getParamValue(macroParam) {
    if (macroParam?.hasOwnProperty('value')) return macroParam.value;
    return macroParam;
}
function $b31b733ebe52245a$export$a113856a79fa82ca(node) {
    const { type: type, content: content, attrs: attrs, fragmentLocalId: fragmentLocalId, ...rest } = node;
    // There is a discrepancy in docs and implementation of different parts of the code
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/30727/overview?commentId=4917242
    const fieldWithMacroParameters = attrs?.parameters ? attrs : rest;
    const { macroParams: macroParams } = fieldWithMacroParameters?.parameters || {};
    const adf = {
        attrs: fieldWithMacroParameters,
        type: type
    };
    if (fragmentLocalId) adf.marks = [
        {
            attrs: {
                localId: fragmentLocalId,
                name: null
            },
            type: 'fragment'
        }
    ];
    // confluence needs to be updated to get rid of bodyType as per
    // https://product-fabric.atlassian.net/wiki/spaces/E/pages/252351342/Splitting+Extension+node+into+three+nodes
    // but for now, the beackend requires it to be sent
    adf.attrs.bodyType = 'none';
    if (type === 'bodiedExtension') {
        adf.content = content && content.length > 0 ? content : [];
        adf.attrs.bodyType = 'rich';
    }
    const keys = Object.keys(adf.attrs);
    keys.forEach((key)=>{
        if (adf.attrs[key] === undefined || adf.attrs[key] === null) delete adf.attrs[key];
    });
    if (adf.attrs?.parameters) adf.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return adf;
}
function $b31b733ebe52245a$export$f700a29bb3cb52bb(node) {
    const { attrs: attrs, content: content, type: type } = node;
    const { macroParams: macroParams } = attrs.parameters;
    // MacroAttributes and ADNode are pretty much the same type, but
    // MacroAttributes requires either "extension", "bodiedExtension", "multiBodiedExtension" or
    // "inlineExtension". This check is so we can pass the ADNode as a
    // MacroAttributes, but will default to "extension" if given an unexpected
    // value.
    let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    if ([
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.INLINE_EXTENSION_TYPE)
    ].indexOf(type) >= 0) extensionType = type;
    const macroAttributes = {
        type: extensionType,
        attrs: attrs
    };
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    if (content) macroAttributes.content = content;
    macroAttributes.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return macroAttributes;
}
async function $b31b733ebe52245a$export$9ebfba63bbffe824(from, to, body, contentIdContext) {
    const queryData = await (0, $juS6m.experimentalContentBodyConvertQuery)(from, to, body, contentIdContext);
    return queryData.experimentalContentBodyConvert?.value;
}
async function $b31b733ebe52245a$export$4f223f6f161fb687(node, intl) {
    const legacyMacro = await $b31b733ebe52245a$export$dc6dc202968f1e29(node);
    legacyMacro.title = node.attrs?.parameters?.macroMetadata?.title;
    if (intl) {
        const description = (0, $aMlgD.getMacroDescriptionOverride)(node.attrs.extensionKey, intl);
        if (description) legacyMacro.description = description;
    }
    return legacyMacro;
}
async function $b31b733ebe52245a$export$dc6dc202968f1e29(node) {
    // just return the node if it's already in legacy format;
    if (node.hasOwnProperty('name') && !node.hasOwnProperty('attrs')) return Promise.resolve(node);
    const adNode = node;
    const { attrs: attrs } = adNode;
    const { extensionKey: extensionKey, parameters: parameters } = attrs || {
        extensionKey: null,
        parameters: {
            macroParams: {},
            macroMetadata: {
                schemaVersion: null
            }
        }
    };
    const { macroParams: macroParams, macroMetadata: macroMetadata } = parameters;
    const type = node.type;
    const name = extensionKey || '';
    const params = $b31b733ebe52245a$export$1d258479ae5735d7(macroParams || {});
    const defaultParameterValue = $b31b733ebe52245a$export$d80a64b0df71385c(macroParams || {});
    const schemaVersion = macroMetadata && macroMetadata.schemaVersion || '1';
    if (!adNode.content || adNode.content.length === 0) return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: ''
    };
    const responseBody = await $b31b733ebe52245a$export$9ebfba63bbffe824('atlas_doc_format', 'storage', JSON.stringify({
        type: 'doc',
        content: adNode.content,
        version: 1
    }));
    return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: responseBody || ''
    };
}
function $b31b733ebe52245a$export$9ca244251d53bbfc(node) {
    const parameters = {
        ...node?.parameters?.macroParams
    };
    if (parameters.__bodyContent) delete parameters.__bodyContent;
    // CEMS-300: To provide a consistent parameter to macro vendors for
    // both the Tiny and Fabric editors, we unwrap the parameter values
    return JSON.stringify($b31b733ebe52245a$export$1d258479ae5735d7(parameters));
}
module.exports["getDefaultParamValue"] = $b31b733ebe52245a$export$d80a64b0df71385c;
module.exports["unwrapMacroParams"] = $b31b733ebe52245a$export$1d258479ae5735d7;
module.exports["wrapMacroParams"] = $b31b733ebe52245a$export$80a8efbe6e0eac1d;
module.exports["extensionToADF"] = $b31b733ebe52245a$export$a113856a79fa82ca;
module.exports["formatAsMacroAttributes"] = $b31b733ebe52245a$export$f700a29bb3cb52bb;
module.exports["convertBody"] = $b31b733ebe52245a$export$9ebfba63bbffe824;
module.exports["formatAsLegacyMacroWithOverrides"] = $b31b733ebe52245a$export$4f223f6f161fb687;
module.exports["getParametersString"] = $b31b733ebe52245a$export$9ca244251d53bbfc;

});

parcelRegister("aMlgD", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $9wGTI = parcelRequire("9wGTI");


var $8pcS0 = parcelRequire("8pcS0");

const $123431e233f03ed6$var$i18n = (0, $aXWIB.defineMessages)({
    anchorMacroTitle: {
        id: "fabric-extension-lib.anchor.title",
        defaultMessage: "Anchor link"
    },
    anchorMacroDescription: {
        id: "fabric-extension-lib.anchor.description",
        defaultMessage: "Create a link to anywhere"
    },
    childrenMacroTitle: {
        id: "fabric-extension-lib.children.live-docs.title",
        defaultMessage: "Child items (Child pages)"
    },
    childrenMacroDescription: {
        id: "fabric-extension-lib.children.live-docs.description",
        defaultMessage: "Display a custom list of content nested under a page or live doc."
    },
    detailsMacroTitle: {
        id: "fabric-extension-lib.details.live-docs.title",
        defaultMessage: "Content properties (Page properties)"
    },
    detailsMacroDescription: {
        id: "fabric-extension-lib.details.live-docs.description",
        defaultMessage: "Enter a table of summary information in this macro and display it on another page or live doc using a content properties report macro. You will need to add a label to this content and specify it in the report macro."
    },
    pageTreeMacroTitle: {
        id: "fabric-extension-lib.pagetree.live-docs.title",
        defaultMessage: "Content tree (Page tree)"
    },
    pageTreeMacroDescription: {
        id: "fabric-extension-lib.pagetree.live-docs.description",
        defaultMessage: "Display a full or partial content tree."
    },
    includeMacroTitle: {
        id: "fabric-extension-lib.include.live-docs.title",
        defaultMessage: "Include content (Include page)"
    },
    includeMacroDescription: {
        id: "fabric-extension-lib.include.live-docs.description",
        defaultMessage: "Display the full contents of a page or live doc."
    },
    detailsSummaryMacroTitle: {
        id: "fabric-extension-lib.details-summary.live-docs.title",
        defaultMessage: "Content properties report (Page properties report)"
    },
    detailsSummaryMacroDescription: {
        id: "fabric-extension-lib.details-summary.live-docs.description",
        defaultMessage: "Display a table of pages and live docs that contain a content properties macro and a specific label. The table includes a link to each item and the summary from the macro on that page or doc."
    },
    jiraMacroTitle: {
        id: "fabric-extension-lib.jira.title",
        defaultMessage: "Jira Data Center"
    },
    jiraMacroDescription: {
        id: "fabric-extension-lib.jira.description",
        defaultMessage: "Insert Jira work items from Data Center via JQL"
    }
});
const $123431e233f03ed6$export$f37635a5fac054ef = (extensionKey, intl)=>{
    // Override new macro title for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroTitle);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroTitle);
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroTitle);
    }
    return null;
};
const $123431e233f03ed6$export$d82ae1b0fd434097 = (extensionKey, intl)=>{
    // Override new macro title and description for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroDescription);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroDescription);
    // PGXT-7617 Update macro strings referencing page content types to also include live docs content types
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroDescription);
    }
    return null;
};
module.exports["getMacroTitleOverride"] = $123431e233f03ed6$export$f37635a5fac054ef;
module.exports["getMacroDescriptionOverride"] = $123431e233f03ed6$export$d82ae1b0fd434097;

});

parcelRegister("juS6m", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");

const $3a3d352db800a7ae$export$4cf4dd4c5ab7075b = async (from, to, body, contentIdContext)=>{
    const variables = {
        from: from,
        to: to,
        body: body,
        contentIdContext: contentIdContext
    };
    const requestBody = {
        representation: from,
        value: body
    };
    const params = new URLSearchParams();
    if (contentIdContext) params.append('contentIdContext', contentIdContext);
    const queryString = params.toString();
    const queryParams = queryString ? `?${queryString}` : '';
    const url = `/wiki/rest/api/contentbody/convert/${to}${queryParams}`;
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: url,
        method: 'POST',
        body: JSON.stringify(requestBody),
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: async (response)=>{
            if (response.ok && response.status === 200) return response.json();
            throw response;
        },
        parseResponseOnError: (error)=>{
            throw new Error(`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`);
        },
        parseResult: (response)=>({
                experimentalContentBodyConvert: {
                    value: response.value
                }
            }),
        variables: variables
    });
    return result.data;
};
module.exports["experimentalContentBodyConvertQuery"] = $3a3d352db800a7ae$export$4cf4dd4c5ab7075b;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        error: undefined
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            error: undefined
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            error: apolloError
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $lMdlY = parcelRequire("lMdlY");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("7K6Nt", function(module, exports) {

var $lcuos = parcelRequire("lcuos");


var $ceVeI = parcelRequire("ceVeI");


var $1xpoY = parcelRequire("1xpoY");


var $3vv78 = parcelRequire("3vv78");


var $c4twg = parcelRequire("c4twg");


var $959F7 = parcelRequire("959F7");


var $lLjor = parcelRequire("lLjor");


var $6nf8t = parcelRequire("6nf8t");


var $eM1QC = parcelRequire("eM1QC");


var $9hg2I = parcelRequire("9hg2I");


var $gaqfB = parcelRequire("gaqfB");


var $2jr6j = parcelRequire("2jr6j");


var $j9Zer = parcelRequire("j9Zer");


var $eOfv4 = parcelRequire("eOfv4");


var $hwhSw = parcelRequire("hwhSw");


var $aEHCA = parcelRequire("aEHCA");


var $ivpnt = parcelRequire("ivpnt");

const $527158a32e078a3d$var$EXTENSION_TYPES = new Set([
    'extension',
    'bodiedExtension',
    'inlineExtension'
]);
/**
 * Returns a map of extensionKey → handler for all active macro preload
 * handlers based on current experiment gates and the current route.
 *
 * A handler is considered active when:
 *  - its underlying migration experiment is enabled
 *    (`isMigratedMacroImplEnabled`), AND
 *  - its `routes` configuration includes the current `route`.
 */ const $527158a32e078a3d$var$getActiveHandlers = (route)=>{
    const handlers = new Map();
    const register = (handler)=>{
        if (!handler.routes.includes(route)) return;
        if (!(0, $ceVeI.isMigratedMacroImplEnabled)(handler.extensionKey)) return;
        handlers.set(handler.extensionKey, handler);
    };
    register((0, $3vv78.blogPostsPreloadHandler));
    register((0, $c4twg.changeHistoryPreloadHandler));
    register((0, $959F7.contentByLabelPreloadHandler));
    register((0, $lLjor.contributorsPreloadHandler));
    register((0, $6nf8t.detailsSummaryPreloadHandler));
    register((0, $eM1QC.pageIncludePreloadHandler));
    register((0, $9hg2I.recentlyUpdatedPreloadHandler));
    register((0, $j9Zer.popularLabelsPreloadHandler));
    register((0, $gaqfB.pagetreePreloadHandler));
    register((0, $2jr6j.pagetreeSearchPreloadHandler));
    register((0, $eOfv4.profilePicturePreloadHandler));
    register((0, $hwhSw.userProfilePreloadHandler));
    register((0, $aEHCA.viewPdfPreloadHandler));
    register((0, $ivpnt.tasksReportPreloadHandler));
    return handlers;
};
/**
 * Resolves content nodes (which may be a promise), validates the body structure,
 * and parses the ADF JSON into a document object.
 *
 * Returns null if the content nodes are invalid, the representation is not
 * 'atlas_doc_format', or the ADF JSON cannot be parsed.
 */ const $527158a32e078a3d$var$resolveAndParseADF = async (contentNodes)=>{
    const resolvedNodes = contentNodes && typeof contentNodes.then === 'function' ? await contentNodes : contentNodes;
    if (!resolvedNodes?.[0]?.body?.dynamic?.value) return null;
    if (resolvedNodes[0].body.dynamic.representation !== 'atlas_doc_format') return null;
    try {
        return JSON.parse(resolvedNodes[0].body.dynamic.value);
    } catch  {
        return null;
    }
};
// Maximum number of JSON.parse iterations to apply to a stringified
// document. In practice the wire shape is at most double-encoded, so 3
// iterations gives us headroom while still bounding the loop.
const $527158a32e078a3d$var$MAX_DOCUMENT_DECODE_PASSES = 3;
const $527158a32e078a3d$export$c237b35d986a7858 = (document)=>{
    if (document == null) return null;
    let candidate = document;
    for(let pass = 0; pass < $527158a32e078a3d$var$MAX_DOCUMENT_DECODE_PASSES; pass++){
        if (typeof candidate !== 'string') break;
        try {
            candidate = JSON.parse(candidate);
        } catch  {
            return null;
        }
    }
    // Still a string after exhausting all decode passes, or resolved to a
    // non-object primitive (number, boolean, etc.) — give up.
    if (typeof candidate !== 'object') return null;
    return candidate;
};
/**
 * Resolves a `preloadCollabDraftContent` promise, extracts the document
 * field, and decodes it to an ADF object via {@link decodeCollabDraftDocument}.
 *
 * Returns `null` when the promise rejects, when the result has no
 * `data.collabDraft.document`, or when the document cannot be decoded.
 */ const $527158a32e078a3d$var$resolveCollabDraftToADF = async (collabDraftPromise)=>{
    let result;
    try {
        result = await collabDraftPromise;
    } catch  {
        return null;
    }
    return $527158a32e078a3d$export$c237b35d986a7858(result?.data?.collabDraft?.document);
};
/**
 * Parses the comma-separated blocklist string from Statsig into a list of
 * trimmed, non-empty regex pattern strings.
 */ const $527158a32e078a3d$var$getBlocklist = ()=>{
    const raw = (0, $1xpoY.default).getString('confluence-extensions-server-render-blocklist', '');
    const entries = raw.split(',');
    const result = [];
    for(let i = 0; i < entries.length; i++){
        const trimmed = entries[i].trim();
        if (trimmed) result.push(trimmed);
    }
    return result;
};
/**
 * Returns true when `extensionKey` is present in the blocklist.
 *
 * The blocklist is sourced from a single Statsig dynamic config
 * (`confluence-extensions-server-render-blocklist`) so it controls both SSR
 * macro query preloading and supplementary macro data preloading.
 */ const $527158a32e078a3d$var$isBlocklisted = (blocklist, extensionKey)=>{
    if (blocklist.length === 0) return false;
    return blocklist.includes(extensionKey);
};
/**
 * Default cap on the number of extensions preloaded per content node when
 * the `cc_ssr_max_extensions_to_preload` Statsig dynamic config is not set.
 */ const $527158a32e078a3d$var$DEFAULT_MAX_EXTENSIONS_TO_PRELOAD = 8;
/**
 * Default cap on the number of ADF nodes traversed when scanning the
 * document for preloadable extensions, used when the
 * `cc_ssr_macros_max_nodes_to_iterative_over` Statsig dynamic config is
 * not set.
 */ const $527158a32e078a3d$var$DEFAULT_MAX_NODES_TO_ITERATE_OVER = -1;
/**
 * Returns the maximum number of extensions to preload, sourced from the
 * `cc_ssr_max_extensions_to_preload` Statsig dynamic config.
 *
 * A non-positive or non-finite value is treated as "no limit" and is
 * returned as the sentinel `-1` so callers can opt out by configuring `0`
 * (or any negative value).
 */ const $527158a32e078a3d$var$getMaxExtensionsToPreload = ()=>{
    const value = (0, $1xpoY.default).getNumber('cc_ssr_max_extensions_to_preload', $527158a32e078a3d$var$DEFAULT_MAX_EXTENSIONS_TO_PRELOAD);
    if (!Number.isFinite(value) || value < 0) return -1;
    return Math.floor(value);
};
/**
 * Returns the maximum number of ADF nodes to iterate over when searching
 * for preloadable extension nodes, sourced from the
 * `cc_ssr_macros_max_nodes_to_iterative_over` Statsig dynamic config.
 *
 * A non-positive or non-finite value is treated as "no limit" and is
 * returned as the sentinel `-1` so callers can opt out by configuring `0`
 * (or any negative value).
 */ const $527158a32e078a3d$var$getMaxNodesToIterateOver = ()=>{
    const value = (0, $1xpoY.default).getNumber('cc_ssr_macros_max_nodes_to_iterative_over', $527158a32e078a3d$var$DEFAULT_MAX_NODES_TO_ITERATE_OVER);
    if (!Number.isFinite(value) || value < 0) return -1;
    return Math.floor(value);
};
/**
 * Filters extension nodes from the parsed ADF document that have a
 * registered preload handler and are not excluded by the SSR extension
 * blocklist.
 *
 * Two Statsig dynamic configs control the work done here:
 * - `cc_ssr_macros_max_nodes_to_iterative_over` caps the number of ADF
 *   nodes visited during traversal (default -1). A value of `-1` means
 *   no limit.
 * - `cc_ssr_max_extensions_to_preload` caps the number of matched
 *   extensions returned (default 8). A value of `-1` means no limit.
 */ const $527158a32e078a3d$var$getPreloadableMacroNodes = (documentADF, handlersByKey)=>{
    const blocklist = $527158a32e078a3d$var$getBlocklist();
    const maxNodesToIterateOver = $527158a32e078a3d$var$getMaxNodesToIterateOver();
    // Track how many ADF nodes the traversal has visited so we can short-
    // circuit once `cc_ssr_macros_max_nodes_to_iterative_over` is reached.
    // `filter` from @atlaskit/adf-utils/traverse walks the full document tree
    // (the document object itself is not an array), unlike `Array#filter`.
    let visited = 0;
    const matched = (0, $lcuos.filter)(documentADF, (node)=>{
        if (maxNodesToIterateOver !== -1 && visited >= maxNodesToIterateOver) return false;
        visited++;
        const extensionKey = node.attrs?.extensionKey;
        return $527158a32e078a3d$var$EXTENSION_TYPES.has(node.type) && typeof extensionKey === 'string' && handlersByKey.has(extensionKey) && !$527158a32e078a3d$var$isBlocklisted(blocklist, extensionKey);
    });
    const maxExtensionsToPreload = $527158a32e078a3d$var$getMaxExtensionsToPreload();
    if (maxExtensionsToPreload === -1 || matched.length <= maxExtensionsToPreload) return matched;
    return matched.slice(0, maxExtensionsToPreload);
};
/**
 * Shared execution core: walks the already-resolved ADF document through the
 * active handler pipeline for the given route.
 */ const $527158a32e078a3d$var$runPreloadHandlers = async (documentADF, handlersByKey, context)=>{
    const matchedNodes = $527158a32e078a3d$var$getPreloadableMacroNodes(documentADF, handlersByKey);
    if (matchedNodes.length === 0) return;
    // eslint-disable-next-line check-preloaders/no-promise-all
    await Promise.all(matchedNodes.map((node)=>{
        const handler = handlersByKey.get(node.attrs.extensionKey);
        return handler.preload(node, context);
    }));
};
const $527158a32e078a3d$export$dbda8fb8d4a3a2ff = async ({ contentNodes: contentNodes, context: context, route: route })=>{
    const handlersByKey = $527158a32e078a3d$var$getActiveHandlers(route);
    if (handlersByKey.size === 0) return;
    const documentADF = await $527158a32e078a3d$var$resolveAndParseADF(contentNodes);
    if (!documentADF) return;
    await $527158a32e078a3d$var$runPreloadHandlers(documentADF, handlersByKey, context);
};
const $527158a32e078a3d$export$50f56fb621d37e3a = async ({ collabDraftPromise: collabDraftPromise, context: context, route: route })=>{
    const handlersByKey = $527158a32e078a3d$var$getActiveHandlers(route);
    if (handlersByKey.size === 0) return;
    const documentADF = await $527158a32e078a3d$var$resolveCollabDraftToADF(collabDraftPromise);
    if (!documentADF) return;
    await $527158a32e078a3d$var$runPreloadHandlers(documentADF, handlersByKey, context);
};
module.exports["preloadMacroData"] = $527158a32e078a3d$export$dbda8fb8d4a3a2ff;
module.exports["preloadMacroDataFromCollabDraft"] = $527158a32e078a3d$export$50f56fb621d37e3a;

});

parcelRegister("ceVeI", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $c9f3102bc65ac225$var$getExperimentValue = (extensionKey)=>{
    switch(extensionKey){
        case 'blog-posts':
            return (0, $6mKj3.expValEquals)('cc_rewrite_blog_posts_legacy_macro', 'isEnabled', true);
        case 'content-report-table':
            return (0, $6mKj3.expValEquals)('cc_rewrite_content-report-table', 'isEnabled', true);
        case 'contentbylabel':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contentbylabel_legacy_macro', 'isEnabled', true);
        case 'contributors':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contributors_legacy_macro', 'isEnabled', true);
        case 'detailssummary':
        case 'profile':
        case 'profile-picture':
            return (0, $6mKj3.expValEquals)('cc_macro_full_ssr_support', 'isEnabled', true);
        case 'iframe':
            return (0, $6mKj3.expValEquals)('cc_rewrite_iframe_legacy_macro', 'isEnabled', true);
        case 'pagetree':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_legacy_macro', 'isEnabled', true);
        case 'pagetreesearch':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_search_legacy_macro', 'isEnabled', true);
        case 'popular-labels':
            return (0, $6mKj3.expValEquals)('cc_rewrite_popular_labels_legacy_macro', 'isEnabled', true);
        case 'recently-updated':
            return (0, $6mKj3.expValEquals)('cc_rewrite_recently_updated_legacy_macro', 'isEnabled', true);
        case 'viewpdf':
            return (0, $6mKj3.expValEquals)('cc_rewrite_viewpdf_macro', 'isEnabled', true);
        case 'widget':
            return (0, $6mKj3.expValEquals)('cc_rewrite_widget_legacy_macro', 'isEnabled', true);
        case 'attachments':
        case 'include':
        case 'tasks-report-macro':
        case 'change-history':
            return (0, $6mKj3.expValEquals)('cc_rewrite_legacy_macros_phase_2', 'isEnabled', true);
        default:
            return false;
    }
};
const $c9f3102bc65ac225$var$isMigratedMacroExtensionKey = (key)=>[
        'attachments',
        'blog-posts',
        'change-history',
        'content-report-table',
        'contributors',
        'detailssummary',
        'iframe',
        'include',
        'pagetree',
        'pagetreesearch',
        'recently-updated',
        'widget',
        'contentbylabel',
        'popular-labels',
        'profile',
        'profile-picture',
        'viewpdf',
        'tasks-report-macro'
    ].includes(key);
const $c9f3102bc65ac225$export$95a5e4cb1c9fae51 = (extensionKey)=>{
    const overrideList = (0, $1xpoY.default).getStringList('cc_macro_override_to_legacy_renderer', []);
    if (overrideList.includes(extensionKey)) return false;
    if (!$c9f3102bc65ac225$var$isMigratedMacroExtensionKey(extensionKey)) return false;
    return $c9f3102bc65ac225$var$getExperimentValue(extensionKey);
};
module.exports["isMigratedMacroImplEnabled"] = $c9f3102bc65ac225$export$95a5e4cb1c9fae51;

});

parcelRegister("3vv78", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $f9Oe5 = parcelRequire("f9Oe5");


var $gLc6G = parcelRequire("gLc6G");

const $fcca944fa3da51db$export$fcb441b1b4fb38e5 = {
    extensionKey: 'blog-posts',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const macroParams = node.attrs?.parameters?.macroParams ?? {};
            const variables = (0, $gLc6G.buildQueryVariables)(macroParams, context.spaceKey);
            await (0, $wPrRK.slowQueryGuard)('blogPostsPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $f9Oe5.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "@confluence/preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["blogPostsPreloadHandler"] = $fcca944fa3da51db$export$fcb441b1b4fb38e5;

});

parcelRegister("f9Oe5", function(module, exports) {
/**
 * @generated SignedSource<<e2eef557d077fd416e405ad8813adcf0>>
 * @relayHash fef787c2e6d812e72220d382c04bd44c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58d7df1bc883468554242bf1644d752239212384434b7e48ef0155e9af178cba
const $496608589e77ac6e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeAdfMediaToken"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeEntireBody"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeExcerpt"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "count"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "condition": "includeExcerpt",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "length",
                        "value": 500
                    }
                ],
                "kind": "ScalarField",
                "name": "excerpt",
                "storageKey": "excerpt(length:500)"
            },
            {
                "concreteType": "ConfluenceMacroExcerptBody",
                "kind": "LinkedField",
                "name": "macroExcerpt",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "fallbackToBody",
                                "value": false
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "atlasDocFormat",
                        "storageKey": "atlasDocFormat(fallbackToBody:false)"
                    }
                ]
            }
        ]
    }, v12 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "condition": "includeAdfMediaToken",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "atlas_doc_format",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "includeEntireBody",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaToken",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v13 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            },
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ],
        "type": "UnknownUser"
    }, v20 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v21 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "lastUpdated",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "when"
            }
        ]
    }, v22 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useBlogPostsQueryQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v6 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useBlogPostsQueryQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v6 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "fef787c2e6d812e72220d382c04bd44c",
            "id": "58d7df1bc883468554242bf1644d752239212384434b7e48ef0155e9af178cba",
            "metadata": {},
            "name": "useBlogPostsQueryQuery",
            "operationKind": "query",
            "text": "query useBlogPostsQueryQuery($after:String,$cql:String!,$first:Int,$includeEntireBody:Boolean!,$includeExcerpt:Boolean!,$includeAdfMediaToken:Boolean!){search:confluence_search(cql:$cql,first:$first,after:$after){count,nodes{content{id,title,type,excerpt(length:500)@include(if:$includeExcerpt)\n        macroExcerpt@include(if:$includeExcerpt){atlasDocFormat(fallbackToBody:false)},body{atlas_doc_format@include(if:$includeAdfMediaToken){value@include(if:$includeEntireBody),mediaToken{token}}},labels{nodes{name,id}},links{webui,base},space{id,key,name},history{createdBy{__typename,...on KnownUser{accountId,displayName,profilePicture{path}},...on UnknownUser{displayName,profilePicture{path}}},createdDate,lastUpdated{when}}}},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$496608589e77ac6e$var$node.hash = "be8af94549bdf95f1c5815a896900346";
var $496608589e77ac6e$export$2e2bcd8739ae039 = $496608589e77ac6e$var$node;
module.exports["default"] = $496608589e77ac6e$export$2e2bcd8739ae039;

});

parcelRegister("gLc6G", function(module, exports) {

var $eZ4zi = parcelRequire("eZ4zi");

const $90f568a5a6c2eff6$var$DAY = 86400000;
const $90f568a5a6c2eff6$var$DEFAULT_MAX = 100;
const $90f568a5a6c2eff6$var$MAX_LIMIT = 200;
const $90f568a5a6c2eff6$export$134cc4e90fdbc9cf = 5;
/**
 * Parses a relative time string like "7d", "14d", "1w", "2h" etc.
 * and returns milliseconds.
 */ const $90f568a5a6c2eff6$var$parseRelativeTime = (time)=>{
    const match = time.match(/^(\d+)([smhdwMy])$/);
    if (!match) return null;
    const value = parseInt(match[1], 10);
    const unit = match[2];
    const multipliers = {
        s: 1000,
        m: 60000,
        h: 3600000,
        d: 86400000,
        w: 604800000,
        M: 2592000000,
        y: 31536000000
    };
    return value * (multipliers[unit] ?? 0);
};
const $90f568a5a6c2eff6$export$fe3a78908f9d9349 = (params, currentSpaceKey)=>{
    const clauses = [
        "type = 'blogpost'"
    ];
    // Space filter
    const spacesValue = params.spaces?.value ?? params.space?.value;
    if (spacesValue) {
        const spaceKeys = spacesValue.split(',').flatMap((s)=>{
            const trimmed = s.trim();
            return trimmed ? [
                trimmed
            ] : [];
        });
        const includeSpaces = [];
        const excludeSpaces = [];
        for (const key of spaceKeys){
            if (key === '@all') {
                // No space filter needed
                includeSpaces.length = 0;
                excludeSpaces.length = 0;
                break;
            } else if (key === '@self' && currentSpaceKey) includeSpaces.push(currentSpaceKey);
            else if (key.startsWith('-')) excludeSpaces.push(key.slice(1));
            else includeSpaces.push(key);
        }
        if (includeSpaces.length > 0) {
            const spaceList = includeSpaces.map((s)=>`'${s}'`).join(',');
            clauses.push(`space IN (${spaceList})`);
        }
        for (const excludeSpace of excludeSpaces)clauses.push(`space != '${excludeSpace}'`);
    } else if (currentSpaceKey) // Default: current space
    clauses.push(`space = '${currentSpaceKey}'`);
    // Labels filter
    const labelsValue = params.labels?.value ?? params.label?.value;
    const matchLabels = params['match-labels']?.value ?? 'any';
    if (labelsValue) {
        const labels = labelsValue.split(',').flatMap((l)=>{
            const trimmed = l.trim();
            return trimmed ? [
                trimmed
            ] : [];
        });
        const requireLabels = [];
        const excludeLabels = [];
        const anyLabels = [];
        for (const label of labels){
            if (label.startsWith('+')) requireLabels.push(label.slice(1));
            else if (label.startsWith('-')) excludeLabels.push(label.slice(1));
            else anyLabels.push(label);
        }
        // Required labels (AND)
        for (const label of requireLabels)clauses.push(`label = '${label}'`);
        // Excluded labels
        for (const label of excludeLabels)clauses.push(`label != '${label}'`);
        // Any labels (OR) - or if match-labels is "all", treat as AND
        if (anyLabels.length > 0) {
            if (matchLabels === 'all') for (const label of anyLabels)clauses.push(`label = '${label}'`);
            else {
                const labelList = anyLabels.map((l)=>`'${l}'`).join(',');
                clauses.push(`label IN (${labelList})`);
            }
        }
    }
    // Time filter
    const timeValue = params.time?.value;
    if (timeValue) {
        const ms = $90f568a5a6c2eff6$var$parseRelativeTime(timeValue);
        if (ms) {
            // Ensures date calculation matches in SPA context, if SSR rendered,
            // such that resulting cql matches
            const currentTime = window['__SSR_CURRENT_DATE__'] || Date.now();
            const then = new Date(currentTime - ms);
            clauses.push(`lastModified >= '${then.toISOString().split('T')[0]}'`);
        }
    }
    // Author filter
    const authorValue = params.author?.value;
    if (authorValue) {
        const authors = authorValue.split(',').flatMap((a)=>{
            const trimmed = a.trim();
            return trimmed ? [
                trimmed
            ] : [];
        });
        if (authors.length === 1) clauses.push(`creator = '${authors[0]}'`);
        else if (authors.length > 1) {
            const authorList = authors.map((a)=>`'${a}'`).join(',');
            clauses.push(`creator IN (${authorList})`);
        }
    }
    // Sort
    const sortValue = params.sort?.value;
    const reverseValue = params.reverse?.value === 'true';
    let orderClause = 'ORDER BY created DESC'; // default
    if (sortValue === 'title') orderClause = `ORDER BY title ${reverseValue ? 'DESC' : 'ASC'}`;
    else if (sortValue === 'creation') orderClause = `ORDER BY created ${reverseValue ? 'DESC' : 'ASC'}`;
    else if (sortValue === 'modified') orderClause = `ORDER BY lastModified ${reverseValue ? 'DESC' : 'ASC'}`;
    return `${clauses.join(' AND ')} ${orderClause}`;
};
const $90f568a5a6c2eff6$export$9a3cee82e7cc08ff = (params, currentSpaceKey)=>{
    const contentMode = params.content?.value ?? 'entire';
    const max = $90f568a5a6c2eff6$export$152d338deb24dc62(params);
    const cql = $90f568a5a6c2eff6$export$fe3a78908f9d9349(params, currentSpaceKey);
    const includeEntireBody = contentMode === 'entire';
    const includeExcerpt = contentMode === 'excerpts';
    const includeAdfMediaToken = includeEntireBody || includeExcerpt;
    const first = includeEntireBody ? Math.min(max, $90f568a5a6c2eff6$export$134cc4e90fdbc9cf) : max;
    return {
        after: undefined,
        cql: cql,
        first: first,
        includeEntireBody: includeEntireBody,
        includeExcerpt: includeExcerpt,
        includeAdfMediaToken: includeAdfMediaToken
    };
};
const $90f568a5a6c2eff6$export$152d338deb24dc62 = (params)=>{
    const maxValue = params.max?.value ?? params.maxResults?.value ?? String($90f568a5a6c2eff6$var$DEFAULT_MAX);
    return Math.min(parseInt(maxValue, 10) || $90f568a5a6c2eff6$var$DEFAULT_MAX, $90f568a5a6c2eff6$var$MAX_LIMIT);
};
const $90f568a5a6c2eff6$export$c01426de3d995a88 = (node)=>node != null;
const $90f568a5a6c2eff6$export$701669137e89de62 = (node)=>{
    const links = node.content?.links;
    if (links?.webui) return `/wiki${links.webui}`;
    return '#';
};
const $90f568a5a6c2eff6$export$3b339b277f9d309a = (node)=>{
    const spaceKey = node.content?.space?.key;
    if (spaceKey) return `/wiki/spaces/${spaceKey}`;
    return '#';
};
const $90f568a5a6c2eff6$export$2c8f257f76f536e9 = (node)=>node.content?.history?.createdBy?.displayName ?? 'Unknown';
const $90f568a5a6c2eff6$export$5879f87d8125a540 = (node)=>{
    const createdBy = node.content?.history?.createdBy;
    if (createdBy && 'accountId' in createdBy) return createdBy.accountId ?? undefined;
    return undefined;
};
const $90f568a5a6c2eff6$export$6d333a56ff392766 = (node)=>{
    const accountId = $90f568a5a6c2eff6$export$5879f87d8125a540(node);
    if (accountId) return `/wiki/people/${accountId}?ref=confluence`;
    return '#';
};
const $90f568a5a6c2eff6$export$b6704bab7c727398 = (node)=>{
    const createdBy = node.content?.history?.createdBy;
    if (createdBy && 'profilePicture' in createdBy) return createdBy.profilePicture?.path ?? undefined;
    return undefined;
};
const $90f568a5a6c2eff6$export$1028703a6dee32c7 = (node)=>node.content?.history?.createdDate ?? '';
const $90f568a5a6c2eff6$export$f81a3ec2bfb3f287 = (node)=>{
    const result = [];
    const nodes = node.content?.labels?.nodes;
    if (!nodes) return result;
    for (const label of nodes)if (label?.name) result.push(label.name);
    return result;
};
const $90f568a5a6c2eff6$export$1187b1706349df3e = (label, spaceKey)=>{
    if (spaceKey) return `/wiki/label/${spaceKey}/${encodeURIComponent(label)}`;
    return `/wiki/label/${encodeURIComponent(label)}`;
};
const $90f568a5a6c2eff6$export$1e76b7005bbc55d6 = (dateString, intl)=>{
    const date = new Date(dateString);
    return intl.formatDate(date, {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};
const $90f568a5a6c2eff6$export$d1f5a2f86fcde3b5 = (dateString, intl)=>{
    const timestamp = new Date(dateString).getTime();
    const diff = Date.now() - timestamp;
    if (diff < $90f568a5a6c2eff6$var$DAY) return (0, $eZ4zi.getRelativeTime)(timestamp, intl);
    return $90f568a5a6c2eff6$export$1e76b7005bbc55d6(dateString, intl);
};
module.exports["ENTIRE_MODE_PAGE_SIZE"] = $90f568a5a6c2eff6$export$134cc4e90fdbc9cf;
module.exports["buildQueryVariables"] = $90f568a5a6c2eff6$export$9a3cee82e7cc08ff;
module.exports["getMaxResults"] = $90f568a5a6c2eff6$export$152d338deb24dc62;
module.exports["isBlogPostNode"] = $90f568a5a6c2eff6$export$c01426de3d995a88;
module.exports["getContentUrl"] = $90f568a5a6c2eff6$export$701669137e89de62;
module.exports["getSpaceUrl"] = $90f568a5a6c2eff6$export$3b339b277f9d309a;
module.exports["getAuthorName"] = $90f568a5a6c2eff6$export$2c8f257f76f536e9;
module.exports["getAuthorAccountId"] = $90f568a5a6c2eff6$export$5879f87d8125a540;
module.exports["getAuthorAvatarUrl"] = $90f568a5a6c2eff6$export$b6704bab7c727398;
module.exports["getCreatedDate"] = $90f568a5a6c2eff6$export$1028703a6dee32c7;
module.exports["getLabels"] = $90f568a5a6c2eff6$export$f81a3ec2bfb3f287;
module.exports["getLabelUrl"] = $90f568a5a6c2eff6$export$1187b1706349df3e;
module.exports["formatBlogDate"] = $90f568a5a6c2eff6$export$1e76b7005bbc55d6;
module.exports["formatSmartDate"] = $90f568a5a6c2eff6$export$d1f5a2f86fcde3b5;

});

parcelRegister("eZ4zi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $dce38ffecfe5cc1b$var$MINUTE = 60000;
const $dce38ffecfe5cc1b$var$HOUR = 3600000;
const $dce38ffecfe5cc1b$var$DAY = 86400000;
const $dce38ffecfe5cc1b$var$WEEK = 604800000;
const $dce38ffecfe5cc1b$var$MONTH = 2592000000;
const $dce38ffecfe5cc1b$var$YEAR = 31536000000;
const $dce38ffecfe5cc1b$export$5a00511f040384d7 = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit'
});
const $dce38ffecfe5cc1b$export$406508d2ca449bd = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
const $dce38ffecfe5cc1b$export$d2d0bf9c4d577e53 = (0, $aXWIB.defineMessages)({
    justNow: {
        id: "macro-utils.relative-time-just-now",
        defaultMessage: "just now"
    },
    minutesAgo: {
        id: "macro-utils.relative-time-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    hoursAgo: {
        id: "macro-utils.relative-time-hours-ago",
        defaultMessage: "{hourCount, plural, one {{hourCount} hour ago} other {{hourCount} hours ago}}"
    },
    daysAgo: {
        id: "macro-utils.relative-time-days-ago",
        defaultMessage: "{dayCount, plural, one {{dayCount} day ago} other {{dayCount} days ago}}"
    },
    weeksAgo: {
        id: "macro-utils.relative-time-weeks-ago",
        defaultMessage: "{weekCount, plural, one {{weekCount} week ago} other {{weekCount} weeks ago}}"
    },
    monthsAgo: {
        id: "macro-utils.relative-time-months-ago",
        defaultMessage: "{monthCount, plural, one {{monthCount} month ago} other {{monthCount} months ago}}"
    },
    yearsAgo: {
        id: "macro-utils.relative-time-years-ago",
        defaultMessage: "{yearCount, plural, one {{yearCount} year ago} other {{yearCount} years ago}}"
    },
    justAMomentAgo: {
        id: "macro-utils.relative-time-just-a-moment-ago",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "macro-utils.relative-time-less-than-a-minute-ago",
        defaultMessage: "less than a minute ago"
    },
    aMinuteAgo: {
        id: "macro-utils.relative-time-a-minute-ago",
        defaultMessage: "a minute ago"
    },
    contentReportMinutesAgo: {
        id: "macro-utils.content-report-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    aboutAnHourAgo: {
        id: "macro-utils.relative-time-about-an-hour-ago",
        defaultMessage: "about an hour ago"
    },
    contentReportHoursAgo: {
        id: "macro-utils.content-report-hours-ago",
        defaultMessage: "{hourCount, plural, one {about {hourCount} hour ago} other {about {hourCount} hours ago}}"
    },
    yesterdayAt: {
        id: "macro-utils.relative-time-yesterday-at",
        defaultMessage: "yesterday at {time}"
    }
});
const $dce38ffecfe5cc1b$var$formatBucketMessage = (bucket, diffMs, intl)=>{
    if (bucket.valueName && bucket.unitMs) {
        const count = bucket.countCalculator ? bucket.countCalculator(diffMs) : Math.floor(diffMs / bucket.unitMs);
        return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message], {
            [bucket.valueName]: count
        });
    }
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message]);
};
const $dce38ffecfe5cc1b$export$bfc1ce7d5853041b = {
    buckets: [
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'justNow'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$HOUR,
            message: 'minutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'hoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$WEEK,
            message: 'daysAgo',
            valueName: 'dayCount',
            unitMs: $dce38ffecfe5cc1b$var$DAY
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MONTH,
            message: 'weeksAgo',
            valueName: 'weekCount',
            unitMs: $dce38ffecfe5cc1b$var$WEEK
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$YEAR,
            message: 'monthsAgo',
            valueName: 'monthCount',
            unitMs: $dce38ffecfe5cc1b$var$MONTH
        },
        {
            maxDiffMs: Number.POSITIVE_INFINITY,
            message: 'yearsAgo',
            valueName: 'yearCount',
            unitMs: $dce38ffecfe5cc1b$var$YEAR
        }
    ]
};
const $dce38ffecfe5cc1b$export$409646d2c0c56892 = {
    buckets: [
        {
            maxDiffMs: 4000,
            message: 'justAMomentAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'lessThanAMinuteAgo'
        },
        {
            maxDiffMs: 2 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aMinuteAgo'
        },
        {
            maxDiffMs: 50 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'contentReportMinutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$MINUTE)
        },
        {
            maxDiffMs: 90 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aboutAnHourAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'contentReportHoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$HOUR)
        }
    ],
    specialCase: ({ timestampMs: timestampMs, nowMs: nowMs, diffMs: diffMs, intl: intl })=>{
        const savedTime = new Date(timestampMs);
        const now = new Date(nowMs);
        if ($dce38ffecfe5cc1b$export$221990270ebfe867(savedTime, now) && diffMs > 5 * $dce38ffecfe5cc1b$var$HOUR) return $dce38ffecfe5cc1b$export$fc16bfc40f160b09(savedTime, intl);
        return null;
    },
    fallback: ({ timestampMs: timestampMs })=>$dce38ffecfe5cc1b$export$359f3c271cd167e3(new Date(timestampMs))
};
const $dce38ffecfe5cc1b$export$e22324fe17cb0dfe = (timestamp, intl, config)=>{
    const nowMs = Date.now();
    const diffMs = nowMs - timestamp;
    if (config.specialCase) {
        const specialResult = config.specialCase({
            timestampMs: timestamp,
            nowMs: nowMs,
            diffMs: diffMs,
            intl: intl
        });
        if (specialResult !== null) return specialResult;
    }
    for (const bucket of config.buckets){
        if (diffMs < bucket.maxDiffMs) return $dce38ffecfe5cc1b$var$formatBucketMessage(bucket, diffMs, intl);
    }
    if (config.fallback) return config.fallback({
        timestampMs: timestamp,
        nowMs: nowMs,
        diffMs: diffMs,
        intl: intl
    });
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
};
const $dce38ffecfe5cc1b$export$493c11ff22f45a24 = (timestamp, intl)=>{
    const now = Date.now();
    const diff = now - timestamp;
    if (diff < $dce38ffecfe5cc1b$var$MINUTE) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
    else if (diff < $dce38ffecfe5cc1b$var$HOUR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.minutesAgo, {
        minuteCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MINUTE)
    });
    else if (diff < $dce38ffecfe5cc1b$var$DAY) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.hoursAgo, {
        hourCount: Math.floor(diff / $dce38ffecfe5cc1b$var$HOUR)
    });
    else if (diff < $dce38ffecfe5cc1b$var$WEEK) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.daysAgo, {
        dayCount: Math.floor(diff / $dce38ffecfe5cc1b$var$DAY)
    });
    else if (diff < $dce38ffecfe5cc1b$var$MONTH) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.weeksAgo, {
        weekCount: Math.floor(diff / $dce38ffecfe5cc1b$var$WEEK)
    });
    else if (diff < $dce38ffecfe5cc1b$var$YEAR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.monthsAgo, {
        monthCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MONTH)
    });
    else return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yearsAgo, {
        yearCount: Math.floor(diff / $dce38ffecfe5cc1b$var$YEAR)
    });
};
const $dce38ffecfe5cc1b$export$221990270ebfe867 = (date, now)=>{
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return yesterday.toLocaleDateString() === date.toLocaleDateString();
};
const $dce38ffecfe5cc1b$export$fc16bfc40f160b09 = (date, intl)=>{
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yesterdayAt, {
        time: $dce38ffecfe5cc1b$export$5a00511f040384d7.format(date)
    });
};
const $dce38ffecfe5cc1b$export$359f3c271cd167e3 = (date)=>{
    return $dce38ffecfe5cc1b$export$406508d2ca449bd.format(date);
};
const $dce38ffecfe5cc1b$export$505b35374c01d686 = (timestamp, intl)=>{
    return $dce38ffecfe5cc1b$export$e22324fe17cb0dfe(timestamp, intl, $dce38ffecfe5cc1b$export$409646d2c0c56892);
};
module.exports["getRelativeTime"] = $dce38ffecfe5cc1b$export$493c11ff22f45a24;
module.exports["formatContentReportEpochTime"] = $dce38ffecfe5cc1b$export$505b35374c01d686;

});

parcelRegister("c4twg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $k0BFU = parcelRequire("k0BFU");


var $eqmIR = parcelRequire("eqmIR");

const $3264be4c944b64e2$export$367ea2b94b2f04d6 = {
    extensionKey: 'change-history',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (_node, context)=>{
        try {
            const variables = (0, $eqmIR.buildChangeHistoryDataQueryVariables)(context.contentId);
            await (0, $wPrRK.slowQueryGuard)('changeHistoryPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $k0BFU.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "@confluence/preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["changeHistoryPreloadHandler"] = $3264be4c944b64e2$export$367ea2b94b2f04d6;

});

parcelRegister("k0BFU", function(module, exports) {
/**
 * @generated SignedSource<<6484e80b10b3e5b20ff1afdd3170a413>>
 * @relayHash d1f64712a6cd002694c18cfcfd5effc1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 78263e7aa84b79fc56acc881110e93ddfe4d32b8a74d09138dec9e6fa1f4af12
const $70dced0078029077$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v4 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "KnownUser"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "UnknownUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "when"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "number"
    }, v12 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v13 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "archived"
            ]
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v16 = {
        "kind": "ScalarField",
        "name": "key"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useChangeHistoryDataQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentHistoryList",
                    "kind": "LinkedField",
                    "name": "contentHistory",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentHistory",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "args": v13 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useChangeHistoryDataQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentHistoryList",
                    "kind": "LinkedField",
                    "name": "contentHistory",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentHistory",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "args": v13 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v17 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d1f64712a6cd002694c18cfcfd5effc1",
            "id": "78263e7aa84b79fc56acc881110e93ddfe4d32b8a74d09138dec9e6fa1f4af12",
            "metadata": {},
            "name": "useChangeHistoryDataQuery",
            "operationKind": "query",
            "text": "query useChangeHistoryDataQuery($contentId:ID!,$after:String,$first:Long){contentHistory(contentId:$contentId,after:$after,first:$first){nodes{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName},friendlyWhen,when,message,number},pageInfo{hasNextPage,endCursor}},singleContent(id:$contentId,status:[\"current\",\"archived\"]){type,subType,space{key,id},id}}"
        }
    };
}();
$70dced0078029077$var$node.hash = "c0c612fe849b83d73ce7d10f80a28adc";
var $70dced0078029077$export$2e2bcd8739ae039 = $70dced0078029077$var$node;
module.exports["default"] = $70dced0078029077$export$2e2bcd8739ae039;

});

parcelRegister("eqmIR", function(module, exports) {
const $5dff6ba48bb7564d$export$9266850431e06b56 = 100;
const $5dff6ba48bb7564d$export$70f9f93372f73c04 = (contentId)=>({
        contentId: contentId,
        after: null,
        first: $5dff6ba48bb7564d$export$9266850431e06b56
    });
module.exports["CHANGE_HISTORY_PAGE_SIZE"] = $5dff6ba48bb7564d$export$9266850431e06b56;
module.exports["buildChangeHistoryDataQueryVariables"] = $5dff6ba48bb7564d$export$70f9f93372f73c04;

});

parcelRegister("959F7", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $9wGTI = parcelRequire("9wGTI");


var $6T2gk = parcelRequire("6T2gk");


var $lTGWQ = parcelRequire("lTGWQ");

const $4f6b1e9f682bf5b0$export$8981cb49f72a0f44 = {
    extensionKey: 'contentbylabel',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const variables = (0, $lTGWQ.composeMacroParamsForQuery)(node.attrs?.parameters?.macroParams, context.spaceKey, context.contentId);
        if (!variables.cql) return;
        await (0, $wPrRK.slowQueryGuard)('contentByLabelPreload', ()=>(0, $dYU3e.query)({
                query: (0, $6T2gk.default),
                variables: {
                    ...variables,
                    skipSearchTitle: (0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title'),
                    skipContentTitle: !(0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title')
                },
                context: {
                    single: true
                },
                __callerPackage__: "@confluence/preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["contentByLabelPreloadHandler"] = $4f6b1e9f682bf5b0$export$8981cb49f72a0f44;

});

parcelRegister("6T2gk", function(module, exports) {
/**
 * @generated SignedSource<<c6f079812825f90983ab3e28cefb37be>>
 * @relayHash 713798aa2a70924b33d8b2ce9e20e7e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 49db14e7be0ff79b5205dba7ee8cb29bd08ed537962458b6eb5246b678fd1d9f
const $fed9f45d550b7e93$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fallbackToBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeExcerpt"
    }, v4 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "skipContentTitle"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "skipSearchTitle"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "condition": "skipSearchTitle",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": v6 /*: any*/ 
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastModified"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "condition": "skipContentTitle",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": v6 /*: any*/ 
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "condition": "includeExcerpt",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceMacroExcerptBody",
                                            "kind": "LinkedField",
                                            "name": "macroExcerpt",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "fallbackToBody",
                                                            "variableName": "fallbackToBody"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "maxBlocks",
                                                            "value": 3
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "atlasDocFormat"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "includeExcerpt",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentBody",
                                                    "kind": "LinkedField",
                                                    "name": "atlas_doc_format",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "EmbeddedMediaToken",
                                                            "kind": "LinkedField",
                                                            "name": "mediaToken",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "token"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentByLabelDataQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentByLabelDataQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "713798aa2a70924b33d8b2ce9e20e7e8",
            "id": "49db14e7be0ff79b5205dba7ee8cb29bd08ed537962458b6eb5246b678fd1d9f",
            "metadata": {},
            "name": "useContentByLabelDataQuery",
            "operationKind": "query",
            "text": "query useContentByLabelDataQuery($cql:String!,$first:Int,$includeExcerpt:Boolean!,$fallbackToBody:Boolean!,$skipSearchTitle:Boolean=false,$skipContentTitle:Boolean=true){search:confluence_search(cql:$cql,first:$first){nodes{title@skip(if:$skipSearchTitle),url,lastModified,content{id,title@skip(if:$skipContentTitle),type,subType,macroExcerpt@include(if:$includeExcerpt){atlasDocFormat(fallbackToBody:$fallbackToBody,maxBlocks:3)},body{atlas_doc_format@include(if:$includeExcerpt){mediaToken{token}}},space{id,key,name},labels{nodes{id,name}}}}}}"
        }
    };
}();
$fed9f45d550b7e93$var$node.hash = "967af5b0ba8e002af3b28af0d07ba29e";
var $fed9f45d550b7e93$export$2e2bcd8739ae039 = $fed9f45d550b7e93$var$node;
module.exports["default"] = $fed9f45d550b7e93$export$2e2bcd8739ae039;

});

parcelRegister("lTGWQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5fi0G = parcelRequire("5fi0G");

const $67a1e9c4dba455ef$var$MAX_RESULTS_CAP = 500;
const $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS = 15;
var $67a1e9c4dba455ef$export$b769d4fd9dd3feec = /*#__PURE__*/ function(ExcerptType) {
    ExcerptType["None"] = "none";
    ExcerptType["Simple"] = "simple";
    ExcerptType["RichContent"] = "rich content";
    return ExcerptType;
}({});
var $67a1e9c4dba455ef$export$9c8b9f8fac4b24ab = /*#__PURE__*/ function(SortOption) {
    SortOption["Creation"] = "created";
    SortOption["Title"] = "title";
    SortOption["Modified"] = "modified";
    return SortOption;
}({});
const $67a1e9c4dba455ef$var$SORT_PARAM_TO_CQL = {
    creation: "created",
    title: "title",
    modified: "modified"
};
function $67a1e9c4dba455ef$var$parseSortOption(value) {
    if (!value) return undefined;
    return $67a1e9c4dba455ef$var$SORT_PARAM_TO_CQL[value];
}
function $67a1e9c4dba455ef$var$parseBoolean(value, defaultValue) {
    if (value === undefined || value === '') return defaultValue;
    return value === 'true';
}
function $67a1e9c4dba455ef$var$parseMax(value, maxCheckbox) {
    if (maxCheckbox === 'true') return {
        max: $67a1e9c4dba455ef$var$MAX_RESULTS_CAP,
        maxParseError: false
    };
    if (value === undefined || value === '') return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: false
    };
    const parsed = parseInt(value, 10);
    if (isNaN(parsed)) return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: true
    };
    if (parsed <= 0) return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: false
    };
    return {
        max: Math.min(parsed, $67a1e9c4dba455ef$var$MAX_RESULTS_CAP),
        maxParseError: false
    };
}
function $67a1e9c4dba455ef$var$buildOrderByClause(sort, reverse) {
    if (!sort) return '';
    const direction = reverse ? 'desc' : 'asc';
    return ` order by ${sort} ${direction}`;
}
function $67a1e9c4dba455ef$var$parseExcerptType(value) {
    if (value === "simple") return "simple";
    if (value === "rich content") return "rich content";
    return "none";
}
function $67a1e9c4dba455ef$export$8f0d03faf499ec50(macroParams, currentSpaceKey, currentContentId) {
    const rawCql = macroParams?.cql?.value ?? '';
    const sort = $67a1e9c4dba455ef$var$parseSortOption(macroParams?.sort?.value);
    const reverse = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.reverse?.value, false);
    const { max: max } = $67a1e9c4dba455ef$var$parseMax(macroParams?.max?.value ?? macroParams?.maxResults?.value, macroParams?.maxCheckbox?.value);
    const resolvedCql = (0, $5fi0G.resolveQueryShorthands)(rawCql, {
        currentSpaceKey: currentSpaceKey,
        currentContentId: currentContentId
    });
    const orderByClause = $67a1e9c4dba455ef$var$buildOrderByClause(sort, reverse);
    const cql = resolvedCql + orderByClause;
    const excerptType = $67a1e9c4dba455ef$var$parseExcerptType(macroParams?.excerptType?.value);
    return {
        cql: cql,
        first: max,
        includeExcerpt: excerptType === "simple" || excerptType === "rich content",
        fallbackToBody: excerptType === "rich content"
    };
}
function $67a1e9c4dba455ef$export$2f9066b0466085e(macroParams, currentSpaceKey, currentContentId) {
    return (0, $42omo.useMemo)(()=>{
        const sort = $67a1e9c4dba455ef$var$parseSortOption(macroParams?.sort?.value);
        const reverse = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.reverse?.value, false);
        const { max: max, maxParseError: maxParseError } = $67a1e9c4dba455ef$var$parseMax(macroParams?.max?.value ?? macroParams?.maxResults?.value, macroParams?.maxCheckbox?.value);
        const title = macroParams?.title?.value ?? '';
        const showLabels = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.showLabels?.value, true);
        const showSpace = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.showSpace?.value, true);
        const excerptType = $67a1e9c4dba455ef$var$parseExcerptType(macroParams?.excerptType?.value);
        const macroParamsForQuery = $67a1e9c4dba455ef$export$8f0d03faf499ec50(macroParams, currentSpaceKey, currentContentId);
        const cql = macroParamsForQuery.cql;
        const limitLabelLinksToSpace = cql.includes('space = ');
        return {
            cql: cql,
            sort: sort,
            reverse: reverse,
            max: max,
            maxParseError: maxParseError,
            title: title,
            showLabels: showLabels,
            showSpace: showSpace,
            excerptType: excerptType,
            limitLabelLinksToSpace: limitLabelLinksToSpace,
            macroParamsForQuery: macroParamsForQuery
        };
    }, [
        macroParams,
        currentSpaceKey,
        currentContentId
    ]);
}
module.exports["ExcerptType"] = $67a1e9c4dba455ef$export$b769d4fd9dd3feec;
module.exports["composeMacroParamsForQuery"] = $67a1e9c4dba455ef$export$8f0d03faf499ec50;
module.exports["useParsedMacroParams"] = $67a1e9c4dba455ef$export$2f9066b0466085e;

});

parcelRegister("5fi0G", function(module, exports) {
// Matches both bare and quoted variants of the supported sentinels
// (`currentSpace()` / `currentContent()`), tolerating optional whitespace
// before and inside the parentheses (e.g. `currentSpace ( )`). Some macro
// authors / older clients persist `"currentSpace()"` as a string literal, so
// we accept both forms. The sentinel name is captured so the resolver can
// look up the corresponding substitution value.
const $bbef8c560cd45789$var$SHORTHAND_REGEX = /"?(currentSpace|currentContent)\s*\(\s*\)"?/g;
const $bbef8c560cd45789$export$61a94fb63540ef7c = (rawCql, { currentSpaceKey: currentSpaceKey, currentContentId: currentContentId })=>{
    if (!rawCql) return rawCql;
    return rawCql.replace($bbef8c560cd45789$var$SHORTHAND_REGEX, (match, sentinel)=>{
        switch(sentinel){
            case 'currentSpace':
                return currentSpaceKey == undefined ? match : `"${currentSpaceKey}"`;
            case 'currentContent':
                return currentContentId == undefined ? match : `"${currentContentId}"`;
            default:
                return match;
        }
    });
};
module.exports["resolveQueryShorthands"] = $bbef8c560cd45789$export$61a94fb63540ef7c;

});

parcelRegister("lLjor", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $i8KfB = parcelRequire("i8KfB");


var $f21pt = parcelRequire("f21pt");

const $36b2e12d8caeb47e$var$buildVariables = (node, contentId)=>{
    const macroParams = node.attrs?.parameters?.macroParams;
    return {
        contentId: contentId,
        contentStatus: [
            'current'
        ],
        contributorsMacroParameters: macroParams ? (0, $f21pt.composeMacroParamsForQuery)(macroParams) : undefined
    };
};
const $36b2e12d8caeb47e$export$8cfaa971235f65b5 = {
    extensionKey: 'contributors',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const variables = $36b2e12d8caeb47e$var$buildVariables(node, context.contentId);
        await (0, $wPrRK.slowQueryGuard)('contributorsPreload', ()=>(0, $dYU3e.query)({
                query: (0, $i8KfB.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "@confluence/preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["contributorsPreloadHandler"] = $36b2e12d8caeb47e$export$8cfaa971235f65b5;

});

parcelRegister("i8KfB", function(module, exports) {
/**
 * @generated SignedSource<<ec07190fb98e0f971c23bf5f1ea3300a>>
 * @relayHash ca950652c375632e8e3242fc2e8e313a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3
const $2e401621b9e1fde0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contributorsMacroParameters"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "contentStatus"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contributorsMacroParameters",
                            "variableName": "contributorsMacroParameters"
                        }
                    ],
                    "concreteType": "ConfluenceContributorsRankings",
                    "kind": "LinkedField",
                    "name": "contributorsMacro",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceAuthorRanking",
                            "kind": "LinkedField",
                            "name": "authorRankingList",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "idString"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "fullNameString"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "edits"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "comments"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "labels"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "watches"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastEditTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastCommentTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastLabelTime"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContributorsDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContributorsDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ca950652c375632e8e3242fc2e8e313a",
            "id": "d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3",
            "metadata": {},
            "name": "useContributorsDataQuery",
            "operationKind": "query",
            "text": "query useContributorsDataQuery($contentId:ID,$contentStatus:[String],$contributorsMacroParameters:ConfluenceContributorsMacroParametersModel){singleContent(id:$contentId,status:$contentStatus){id,contributorsMacro(contributorsMacroParameters:$contributorsMacroParameters){authorRankingList{idString,fullNameString,edits,comments,labels,watches,lastEditTime,lastCommentTime,lastLabelTime}}}}"
        }
    };
}();
$2e401621b9e1fde0$var$node.hash = "2b1ea1963eb971919228dd0de7168930";
var $2e401621b9e1fde0$export$2e2bcd8739ae039 = $2e401621b9e1fde0$var$node;
module.exports["default"] = $2e401621b9e1fde0$export$2e2bcd8739ae039;

});

parcelRegister("f21pt", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $66904c9443eb5472$export$8bf632d40c0a848b = (value)=>{
    if (!value) return [
        'authors'
    ];
    return value.split(',').map((s)=>s.trim());
};
const $66904c9443eb5472$export$4c17d9c0cb17e4cf = (value)=>{
    const validOrders = [
        'count',
        'name',
        'update',
        'edits',
        'editTime'
    ];
    if (value && validOrders.includes(value)) return value;
    return 'count';
};
const $66904c9443eb5472$export$3fb54149990fb5b5 = (value)=>{
    return value === 'true';
};
const $66904c9443eb5472$export$a122018e819bbb5 = (value)=>{
    if (!value) return -1;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? -1 : Math.max(parsed, -1);
};
const $66904c9443eb5472$export$8f0d03faf499ec50 = (macroParams)=>{
    const reverse = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.reverse?.value);
    const showAnonymous = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showAnonymous?.value);
    return {
        include: macroParams?.include?.value,
        order: macroParams?.order?.value,
        reverse: reverse,
        showAnonymous: showAnonymous,
        page: macroParams?.page?.value,
        labels: macroParams?.labels?.value,
        label: macroParams?.label?.value,
        spaces: macroParams?.spaces?.value,
        space: macroParams?.space?.value,
        contentType: macroParams?.contentType?.value,
        publishDate: macroParams?.publishDate?.value,
        scope: macroParams?.scope?.value
    };
};
const $66904c9443eb5472$export$2f9066b0466085e = (macroParams)=>{
    return (0, $42omo.useMemo)(()=>{
        const include = $66904c9443eb5472$export$8bf632d40c0a848b(macroParams?.include?.value);
        const order = $66904c9443eb5472$export$4c17d9c0cb17e4cf(macroParams?.order?.value);
        const reverse = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.reverse?.value);
        const limit = $66904c9443eb5472$export$a122018e819bbb5(macroParams?.limit?.value);
        const mode = macroParams?.mode?.value === 'list' ? 'list' : 'inline';
        const showAnonymous = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showAnonymous?.value);
        const showCount = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showCount?.value);
        const showTime = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showLastTime?.value);
        const noneFoundMessage = macroParams?.noneFoundMessage?.value;
        const macroParamsForQuery = $66904c9443eb5472$export$8f0d03faf499ec50(macroParams);
        return {
            include: include,
            order: order,
            reverse: reverse,
            limit: limit,
            mode: mode,
            showAnonymous: showAnonymous,
            showCount: showCount,
            showTime: showTime,
            noneFoundMessage: noneFoundMessage,
            macroParamsForQuery: macroParamsForQuery
        };
    }, [
        macroParams
    ]);
};
module.exports["composeMacroParamsForQuery"] = $66904c9443eb5472$export$8f0d03faf499ec50;
module.exports["useParsedMacroParams"] = $66904c9443eb5472$export$2f9066b0466085e;

});

parcelRegister("6nf8t", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $cXk0q = parcelRequire("cXk0q");


var $3WUt7 = parcelRequire("3WUt7");

const $467c80d7f40ed92f$var$buildVariables = (node, contentId, spaceKey)=>{
    const macroParams = node.attrs?.parameters?.macroParams;
    const macroId = node.attrs?.parameters?.macroMetadata?.macroId?.value || '';
    return (0, $3WUt7.buildDetailsSummaryVariables)({
        macroParams: macroParams,
        contentId: contentId,
        spaceKey: spaceKey,
        macroId: macroId
    });
};
const $467c80d7f40ed92f$export$69acddabbc0e6f95 = {
    extensionKey: 'detailssummary',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const variables = $467c80d7f40ed92f$var$buildVariables(node, context.contentId, context.spaceKey);
            await (0, $wPrRK.slowQueryGuard)('detailsSummaryPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $cXk0q.DetailsSummaryADFQuery),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "@confluence/preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["detailsSummaryPreloadHandler"] = $467c80d7f40ed92f$export$69acddabbc0e6f95;

});

parcelRegister("cXk0q", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6FBXU = parcelRequire("6FBXU");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $7zgzO = parcelRequire("7zgzO");


var $3WUt7 = parcelRequire("3WUt7");

const $8b4cd8637684b33c$export$4aa63971c7cdd461 = (0, $6FBXU.default);
const $8b4cd8637684b33c$export$3a7ba9dcd3d890e8 = (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { macroDefaultProps: macroDefaultProps, macroParams: macroParams } = t0;
    const [pageIndex, setPageIndex] = (0, $42omo.useState)(0);
    const { location: location } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setPageIndex(0);
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== macroParams) {
        t2 = [
            macroParams
        ];
        $[1] = macroParams;
        $[2] = t2;
    } else t2 = $[2];
    (0, $42omo.useEffect)(t1, t2);
    let isPDFExport;
    let t3;
    let t4;
    let t5;
    if ($[3] !== location?.pathname || $[4] !== macroDefaultProps.attributes?.macroId || $[5] !== macroDefaultProps.contentId || $[6] !== macroDefaultProps.spaceKey || $[7] !== macroParams || $[8] !== pageIndex) {
        isPDFExport = location?.pathname.startsWith("/wiki/pdf/");
        t4 = (0, $jMyy4.useQueryInterop);
        t5 = $8b4cd8637684b33c$export$4aa63971c7cdd461;
        t3 = (0, $3WUt7.buildDetailsSummaryVariables)({
            macroParams: macroParams,
            contentId: macroDefaultProps.contentId,
            spaceKey: macroDefaultProps.spaceKey,
            macroId: macroDefaultProps?.attributes?.macroId?.toString() || "",
            pageIndex: pageIndex,
            isPDFExport: isPDFExport
        });
        $[3] = location?.pathname;
        $[4] = macroDefaultProps.attributes?.macroId;
        $[5] = macroDefaultProps.contentId;
        $[6] = macroDefaultProps.spaceKey;
        $[7] = macroParams;
        $[8] = pageIndex;
        $[9] = isPDFExport;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else {
        isPDFExport = $[9];
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
    }
    let t6;
    if ($[13] !== t3) {
        t6 = {
            variables: t3
        };
        $[13] = t3;
        $[14] = t6;
    } else t6 = $[14];
    const { data: data, error: error, loading: loading } = t4(t5, t6);
    const isInitialLoad = loading && !data;
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (_, pageNumber)=>{
            setPageIndex(pageNumber - 1);
        };
        $[15] = t7;
    } else t7 = $[15];
    const paginateTable = t7;
    const t8 = data?.detailsLines?.totalPages || 0;
    let t9;
    if ($[16] !== data || $[17] !== error || $[18] !== isInitialLoad || $[19] !== isPDFExport || $[20] !== loading || $[21] !== pageIndex || $[22] !== t8) {
        t9 = {
            data: data,
            error: error,
            loading: loading,
            isInitialLoad: isInitialLoad,
            isPDFExport: isPDFExport,
            pageIndex: pageIndex,
            paginateTable: paginateTable,
            totalPages: t8
        };
        $[16] = data;
        $[17] = error;
        $[18] = isInitialLoad;
        $[19] = isPDFExport;
        $[20] = loading;
        $[21] = pageIndex;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
};
module.exports["DetailsSummaryADFQuery"] = $8b4cd8637684b33c$export$4aa63971c7cdd461;
module.exports["useDetailsSummaryADFQuery"] = $8b4cd8637684b33c$export$3a7ba9dcd3d890e8;

});

parcelRegister("6FBXU", function(module, exports) {
/**
 * @generated SignedSource<<61b269fc5c97af6ef6d28bc446a0eec0>>
 * @relayHash 81e0ec3084120c0be1f11ccafd133340
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d12d7ebbccf4878f0dfbd2b2e4f86b05fa695f03a27498a938b402a9f5529b9a
const $fa83278cc1200055$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": "atlas_doc_format",
        "kind": "LocalArgument",
        "name": "contentRepresentation"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countComments"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countLikes"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countUnresolvedComments"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "detailsId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "headings"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "macroId"
    }, v9 = {
        "defaultValue": 0,
        "kind": "LocalArgument",
        "name": "pageIndex"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageSize"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reverseSort"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showCreator"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showLastModified"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showPageLabels"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v17 = {
        "kind": "ScalarField",
        "name": "macroId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentRepresentation",
                    "variableName": "contentRepresentation"
                },
                {
                    "kind": "Variable",
                    "name": "countComments",
                    "variableName": "countComments"
                },
                {
                    "kind": "Variable",
                    "name": "countLikes",
                    "variableName": "countLikes"
                },
                {
                    "kind": "Variable",
                    "name": "countUnresolvedComments",
                    "variableName": "countUnresolvedComments"
                },
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "detailsId",
                    "variableName": "detailsId"
                },
                {
                    "kind": "Variable",
                    "name": "headings",
                    "variableName": "headings"
                },
                {
                    "kind": "Variable",
                    "name": "macroId",
                    "variableName": "macroId"
                },
                {
                    "kind": "Variable",
                    "name": "pageIndex",
                    "variableName": "pageIndex"
                },
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                },
                {
                    "kind": "Variable",
                    "name": "reverseSort",
                    "variableName": "reverseSort"
                },
                {
                    "kind": "Variable",
                    "name": "showCreator",
                    "variableName": "showCreator"
                },
                {
                    "kind": "Variable",
                    "name": "showLastModified",
                    "variableName": "showLastModified"
                },
                {
                    "kind": "Variable",
                    "name": "showPageLabels",
                    "variableName": "showPageLabels"
                },
                {
                    "kind": "Variable",
                    "name": "sortBy",
                    "variableName": "sortBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "DetailsSummaryLines",
            "kind": "LinkedField",
            "name": "detailsLines",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "currentPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalPages"
                },
                {
                    "kind": "ScalarField",
                    "name": "renderedHeadings"
                },
                v17 /*: any*/ ,
                {
                    "concreteType": "DetailLine",
                    "kind": "LinkedField",
                    "name": "detailLines",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relativeLink"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "details"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "commentsCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "rowId"
                        },
                        v17 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "unresolvedCommentsCount"
                        },
                        {
                            "concreteType": "DetailLabels",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": true,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "displayTitle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlPath"
                                }
                            ]
                        },
                        {
                            "concreteType": "DetailCreator",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                }
                            ]
                        },
                        {
                            "concreteType": "DetailLastModified",
                            "kind": "LinkedField",
                            "name": "lastModified",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyModificationDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "sortableDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useDetailsSummaryADFQueryQuery",
            "selections": v19 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v15 /*: any*/ ,
                v11 /*: any*/ ,
                v16 /*: any*/ ,
                v0 /*: any*/ ,
                v10 /*: any*/ ,
                v9 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v14 /*: any*/ ,
                v13 /*: any*/ ,
                v12 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useDetailsSummaryADFQueryQuery",
            "selections": v19 /*: any*/ 
        },
        "params": {
            "cacheID": "81e0ec3084120c0be1f11ccafd133340",
            "id": "d12d7ebbccf4878f0dfbd2b2e4f86b05fa695f03a27498a938b402a9f5529b9a",
            "metadata": {},
            "name": "useDetailsSummaryADFQueryQuery",
            "operationKind": "query",
            "text": "query useDetailsSummaryADFQueryQuery($cql:String,$detailsId:String,$sortBy:String,$reverseSort:Boolean,$spaceKey:String!,$contentId:ID!,$pageSize:Int,$pageIndex:Int=0,$countComments:Boolean,$countUnresolvedComments:Boolean,$countLikes:Boolean,$showPageLabels:Boolean,$showLastModified:Boolean,$showCreator:Boolean,$headings:String,$contentRepresentation:String=\"atlas_doc_format\",$macroId:String){detailsLines(cql:$cql,detailsId:$detailsId,sortBy:$sortBy,reverseSort:$reverseSort,spaceKey:$spaceKey,contentId:$contentId,pageSize:$pageSize,pageIndex:$pageIndex,countComments:$countComments,countUnresolvedComments:$countUnresolvedComments,countLikes:$countLikes,showPageLabels:$showPageLabels,showLastModified:$showLastModified,showCreator:$showCreator,headings:$headings,contentRepresentation:$contentRepresentation,macroId:$macroId){currentPage,totalPages,renderedHeadings,macroId,detailLines{id,title,relativeLink,details,reactionsCount,commentsCount,rowId,macroId,unresolvedCommentsCount,labels{name,displayTitle,urlPath},creator{name,accountId},lastModified{friendlyModificationDate,sortableDate}}}}"
        }
    };
}();
$fa83278cc1200055$var$node.hash = "e2f904ef103ed055ad0661a39595ea5b";
var $fa83278cc1200055$export$2e2bcd8739ae039 = $fa83278cc1200055$var$node;
module.exports["default"] = $fa83278cc1200055$export$2e2bcd8739ae039;

});

parcelRegister("3WUt7", function(module, exports) {

var $isgNA = parcelRequire("isgNA");

const $2969a01dbaf01c74$var$isTrue = (params, key)=>params?.[key]?.value === 'true';
/**
 * Resolve the effective `pageSize` query variable for the details-summary
 * macro.
 *
 * Rules (kept in one place so the runtime hook, the SSR preload-macros
 * handler, and the legacy SSR preload all behave identically):
 *
 * - When rendering inside a PDF export, always request the maximum page size
 *   (`MAX_PDF_PAGE_SIZE`) so the exported document contains every row.
 * - Otherwise, parse the user-supplied `pageSize` macro param as a base-10
 *   integer. Missing / unparseable values fall back to the default
 *   (`DEFAULT_MAX_PAGE_SIZE`).
 * - The parsed value is then clamped to `DEFAULT_MAX_PAGE_SIZE` so a macro
 *   author cannot accidentally request a larger page than the server is
 *   tuned for.
 */ const $2969a01dbaf01c74$var$resolvePageSize = (macroParams, isPDFExport)=>{
    if (isPDFExport) return 0, $isgNA.MAX_PDF_PAGE_SIZE;
    const rawValue = macroParams?.['pageSize']?.value;
    const parsed = parseInt(rawValue || `${0, $isgNA.DEFAULT_MAX_PAGE_SIZE}`, 10);
    if (Number.isNaN(parsed)) return 0, $isgNA.DEFAULT_MAX_PAGE_SIZE;
    return Math.min(parsed, (0, $isgNA.DEFAULT_MAX_PAGE_SIZE));
};
const $2969a01dbaf01c74$export$1b64d6545318c754 = ({ macroParams: macroParams, contentId: contentId, spaceKey: spaceKey, macroId: macroId, pageIndex: pageIndex = 0, isPDFExport: isPDFExport = false })=>({
        // `_parentId` is the source page where the macro was inserted; it is
        // present when nested inside of other macros and should be used instead of
        // the current page contentId.
        contentId: macroParams?.['_parentId']?.value || contentId,
        cql: macroParams?.['cql']?.value,
        detailsId: macroParams?.['id']?.value,
        headings: macroParams?.['headings']?.value,
        sortBy: macroParams?.['sortBy']?.value,
        spaceKey: spaceKey,
        countLikes: $2969a01dbaf01c74$var$isTrue(macroParams, 'showLikesCount'),
        reverseSort: $2969a01dbaf01c74$var$isTrue(macroParams, 'reverseSort'),
        countComments: $2969a01dbaf01c74$var$isTrue(macroParams, 'showCommentsCount'),
        countUnresolvedComments: $2969a01dbaf01c74$var$isTrue(macroParams, 'showUnresolvedCommentsCount'),
        showPageLabels: $2969a01dbaf01c74$var$isTrue(macroParams, 'showPageLabels'),
        showLastModified: $2969a01dbaf01c74$var$isTrue(macroParams, 'showLastModified'),
        showCreator: $2969a01dbaf01c74$var$isTrue(macroParams, 'showCreator'),
        pageIndex: pageIndex,
        macroId: macroId,
        pageSize: $2969a01dbaf01c74$var$resolvePageSize(macroParams, isPDFExport)
    });
module.exports["buildDetailsSummaryVariables"] = $2969a01dbaf01c74$export$1b64d6545318c754;

});

parcelRegister("isgNA", function(module, exports) {
const $38e46c834876fccf$export$38d4334417be6de4 = [
    'showCreator',
    'showLastModified',
    'showPageLabels',
    'showCommentsCount',
    'showUnresolvedCommentsCount',
    'showLikesCount'
];
const $38e46c834876fccf$export$89486cb0536270a1 = 30;
const $38e46c834876fccf$export$bcb403f7710dd1db = 500;
module.exports["optionalTableHeaderParams"] = $38e46c834876fccf$export$38d4334417be6de4;
module.exports["DEFAULT_MAX_PAGE_SIZE"] = $38e46c834876fccf$export$89486cb0536270a1;
module.exports["MAX_PDF_PAGE_SIZE"] = $38e46c834876fccf$export$bcb403f7710dd1db;

});

parcelRegister("eM1QC", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $oDAuM = parcelRequire("oDAuM");


var $7AKam = parcelRequire("7AKam");


var $6K7Y4 = parcelRequire("6K7Y4");

const $7a5f1a746a9c082d$var$preloadById = (variables)=>(0, $wPrRK.slowQueryGuard)('pageIncludeByIdPreload', ()=>(0, $dYU3e.query)({
            query: (0, $oDAuM.default),
            variables: variables,
            context: {
                single: true
            },
            __callerPackage__: "@confluence/preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
const $7a5f1a746a9c082d$var$preloadByTitle = (variables)=>(0, $wPrRK.slowQueryGuard)('pageIncludeByTitlePreload', ()=>(0, $dYU3e.query)({
            query: (0, $7AKam.default),
            variables: variables,
            context: {
                single: true
            },
            __callerPackage__: "@confluence/preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
const $7a5f1a746a9c082d$export$918221fb7aa02f2c = {
    extensionKey: 'include',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const parsedTarget = (0, $6K7Y4.parseMacroTarget)(node.attrs?.parameters?.macroParams);
        const queryTarget = (0, $6K7Y4.getPageIncludeQueryTarget)(parsedTarget, context.spaceKey);
        if (queryTarget.kind === 'by-id') {
            await $7a5f1a746a9c082d$var$preloadById(queryTarget.variables);
            return;
        }
        if (queryTarget.kind === 'by-title') await $7a5f1a746a9c082d$var$preloadByTitle(queryTarget.variables);
    }
};
module.exports["pageIncludePreloadHandler"] = $7a5f1a746a9c082d$export$918221fb7aa02f2c;

});

parcelRegister("oDAuM", function(module, exports) {
/**
 * @generated SignedSource<<1c0c89d79fe77d1b063869de36dc5dd5>>
 * @relayHash 29bcc67d3111f4f97c3c431cc81c9399
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53
const $8e0b9375d7694fe5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageIncludeMacroQueryByIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageIncludeMacroQueryByIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "29bcc67d3111f4f97c3c431cc81c9399",
            "id": "e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53",
            "metadata": {},
            "name": "usePageIncludeMacroQueryByIdQuery",
            "operationKind": "query",
            "text": "query usePageIncludeMacroQueryByIdQuery($contentId:ID!){singleContent(id:$contentId){id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}"
        }
    };
}();
$8e0b9375d7694fe5$var$node.hash = "983fd7d5b2c3bedd36acf332a4d2a21e";
var $8e0b9375d7694fe5$export$2e2bcd8739ae039 = $8e0b9375d7694fe5$var$node;
module.exports["default"] = $8e0b9375d7694fe5$export$2e2bcd8739ae039;

});

parcelRegister("7AKam", function(module, exports) {
/**
 * @generated SignedSource<<1bce5b35349cd4550da965c94478b555>>
 * @relayHash 8f72766dbc3288a69e1f166ec6dfe741
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0
const $74df5cfe1a2e5d0a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogSpaceKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogTitle"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeBlog"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeRaw"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSplit"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "postingDay"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawSpaceKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawTitle"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitSpaceKey"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitTitle"
    }, v10 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v11 = {
        "kind": "Literal",
        "name": "type",
        "value": "page"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v14 = [
        {
            "condition": "includeRaw",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "rawContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "rawSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "rawTitle"
                        },
                        v11 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        {
            "condition": "includeSplit",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "splitContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "splitSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "splitTitle"
                        },
                        v11 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        {
            "condition": "includeBlog",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "blogContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "postingDay",
                            "variableName": "postingDay"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "blogSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "blogTitle"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "blogpost"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "selections": v14 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "selections": v14 /*: any*/ 
        },
        "params": {
            "cacheID": "8f72766dbc3288a69e1f166ec6dfe741",
            "id": "4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0",
            "metadata": {},
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "operationKind": "query",
            "text": "query usePageIncludeMacroQueryByTitleQuery($rawSpaceKey:String!,$rawTitle:String!,$includeRaw:Boolean!,$splitSpaceKey:String!,$splitTitle:String!,$includeSplit:Boolean!,$blogSpaceKey:String!,$blogTitle:String!,$postingDay:String!,$includeBlog:Boolean!){rawContent:content(spaceKey:$rawSpaceKey,title:$rawTitle,type:\"page\",first:1)@include(if:$includeRaw){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},splitContent:content(spaceKey:$splitSpaceKey,title:$splitTitle,type:\"page\",first:1)@include(if:$includeSplit){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},blogContent:content(spaceKey:$blogSpaceKey,title:$blogTitle,type:\"blogpost\",postingDay:$postingDay,first:1)@include(if:$includeBlog){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}}"
        }
    };
}();
$74df5cfe1a2e5d0a$var$node.hash = "f95c0a76906580963b7866b01f678dd2";
var $74df5cfe1a2e5d0a$export$2e2bcd8739ae039 = $74df5cfe1a2e5d0a$var$node;
module.exports["default"] = $74df5cfe1a2e5d0a$export$2e2bcd8739ae039;

});

parcelRegister("6K7Y4", function(module, exports) {
const $397b91bd2abb6c3a$export$bcd93dab64989992 = (macroParams)=>{
    const referencedContentId = macroParams?.['_referencedContentId']?.value ?? null;
    const parentId = macroParams?.['_parentId']?.value ?? null;
    // 1. Modern typed parameter (key is "")
    const typedValue = macroParams?.['']?.value?.trim();
    if (typedValue) return {
        location: typedValue,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: null
    };
    // 2. Legacy pageTitle (takes precedence over "0")
    const pageTitle = macroParams?.['pageTitle']?.value?.trim();
    if (pageTitle) {
        const spaceKey = macroParams?.['spaceKey']?.value?.trim();
        const location = spaceKey ? `${spaceKey}:${pageTitle}` : pageTitle;
        return {
            location: location,
            referencedContentId: referencedContentId,
            parentId: parentId,
            error: null
        };
    }
    // 3. Legacy untyped default parameter "0"
    const legacyDefault = macroParams?.['0']?.value?.trim();
    if (legacyDefault) return {
        location: legacyDefault,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: null
    };
    // No target configured
    return {
        location: null,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: 'missing-target'
    };
};
const $397b91bd2abb6c3a$var$extractContentIdFromTypedValue = (value)=>{
    const match = value.match(/confluence-content:\/\/[^/]+\/(\d+)/);
    return match ? match[1] : null;
};
const $397b91bd2abb6c3a$var$BLOG_POST_LINK_REGEX = /^(?:([\w]+):)?\/(\d{4}\/\d{2}\/\d{2})\/(.+)$/;
const $397b91bd2abb6c3a$var$isValidSpaceKey = (spaceKey)=>{
    if (!spaceKey) return false;
    if (spaceKey.startsWith('~')) return true;
    return spaceKey.length <= 255 && /^[A-Za-z0-9]+$/.test(spaceKey);
};
const $397b91bd2abb6c3a$var$parseSplitPageCandidate = (location)=>{
    const colonIdx = location.indexOf(':');
    if (colonIdx < 0) return null;
    const spaceKey = location.slice(0, colonIdx);
    const title = location.slice(colonIdx + 1);
    if (!$397b91bd2abb6c3a$var$isValidSpaceKey(spaceKey) || title.startsWith(' ')) return null;
    return {
        spaceKey: spaceKey,
        title: title
    };
};
const $397b91bd2abb6c3a$var$parseBlogPostCandidate = (location, hostSpaceKey)=>{
    const match = location.match($397b91bd2abb6c3a$var$BLOG_POST_LINK_REGEX);
    if (!match) return null;
    const spaceKey = match[1] || hostSpaceKey;
    const postingDay = match[2].replace(/\//g, '-');
    const title = match[3];
    if (!spaceKey || !title) return null;
    return {
        spaceKey: spaceKey,
        title: title,
        postingDay: postingDay
    };
};
const $397b91bd2abb6c3a$export$fc5689613a273ab4 = (parsedTarget, hostSpaceKey)=>{
    if (!parsedTarget.location) return {
        kind: 'missing-target'
    };
    const idFromTyped = $397b91bd2abb6c3a$var$extractContentIdFromTypedValue(parsedTarget.location);
    if (idFromTyped) return {
        kind: 'by-id',
        variables: {
            contentId: idFromTyped
        }
    };
    if (parsedTarget.referencedContentId) return {
        kind: 'by-id',
        variables: {
            contentId: parsedTarget.referencedContentId
        }
    };
    const rawTitle = parsedTarget.location.trim();
    if (!rawTitle) return {
        kind: 'missing-target'
    };
    const splitPageCandidate = $397b91bd2abb6c3a$var$parseSplitPageCandidate(rawTitle);
    const blogPostCandidate = $397b91bd2abb6c3a$var$parseBlogPostCandidate(rawTitle, hostSpaceKey);
    const includeRaw = !!hostSpaceKey;
    if (!includeRaw && !splitPageCandidate && !blogPostCandidate) return {
        kind: 'missing-target'
    };
    return {
        kind: 'by-title',
        variables: {
            rawSpaceKey: hostSpaceKey ?? '',
            rawTitle: rawTitle,
            includeRaw: includeRaw,
            splitSpaceKey: splitPageCandidate?.spaceKey ?? '',
            splitTitle: splitPageCandidate?.title ?? '',
            includeSplit: !!splitPageCandidate,
            blogSpaceKey: blogPostCandidate?.spaceKey ?? '',
            blogTitle: blogPostCandidate?.title ?? '',
            postingDay: blogPostCandidate?.postingDay ?? '',
            includeBlog: !!blogPostCandidate
        }
    };
};
module.exports["parseMacroTarget"] = $397b91bd2abb6c3a$export$bcd93dab64989992;
module.exports["getPageIncludeQueryTarget"] = $397b91bd2abb6c3a$export$fc5689613a273ab4;

});

parcelRegister("9hg2I", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $3WQHM = parcelRequire("3WQHM");


var $8mra2 = parcelRequire("8mra2");

const $476f3d09a54732a7$var$buildVariables = (node, context)=>{
    const macroParams = node.attrs?.parameters?.macroParams ?? {};
    const params = {
        types: macroParams['types']?.value,
        spaces: macroParams['spaces']?.value,
        labels: macroParams['labels']?.value,
        author: macroParams['author']?.value,
        max: Number(macroParams['max']?.value) || undefined
    };
    const spaceKey = params.spaces ?? context.spaceKey ?? '';
    return (0, $8mra2.buildRecentlyUpdatedQueryVariables)(params, spaceKey);
};
const $476f3d09a54732a7$export$86adfac79e0861a1 = {
    extensionKey: 'recently-updated',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const variables = $476f3d09a54732a7$var$buildVariables(node, context);
        await (0, $wPrRK.slowQueryGuard)('recentlyUpdatedPreload', ()=>(0, $dYU3e.query)({
                query: (0, $3WQHM.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "@confluence/preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["recentlyUpdatedPreloadHandler"] = $476f3d09a54732a7$export$86adfac79e0861a1;

});

parcelRegister("3WQHM", function(module, exports) {
/**
 * @generated SignedSource<<d93dcd7c10f7020beaca89b6f3698114>>
 * @relayHash 727c301958baf0a557d685e96bfcc728
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70f8f49eb25e63b9c9a990b2097d7d2d64224f24bdfd36245da31052e0822ddd
const $0db13d9be330dd35$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "cqlcontext",
            "variableName": "cqlcontext"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "url"
    }, v6 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContributionStatusSummary",
                        "kind": "LinkedField",
                        "name": "lastcontributed",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "when"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "number"
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v19 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "727c301958baf0a557d685e96bfcc728",
            "id": "70f8f49eb25e63b9c9a990b2097d7d2d64224f24bdfd36245da31052e0822ddd",
            "metadata": {},
            "name": "RecentlyUpdatedMacroQuery",
            "operationKind": "query",
            "text": "query RecentlyUpdatedMacroQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{url,lastModified,content{id,type,title,status,space{key,name,id},links{webui},metadata{currentuser{lastcontributed{when}}},version{number,by{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$0db13d9be330dd35$var$node.hash = "7e6233c32402f853522988d79db44911";
var $0db13d9be330dd35$export$2e2bcd8739ae039 = $0db13d9be330dd35$var$node;
module.exports["default"] = $0db13d9be330dd35$export$2e2bcd8739ae039;

});

parcelRegister("8mra2", function(module, exports) {
const $9f74d735080597cb$export$e2092582db731ff4 = 15;
const $9f74d735080597cb$export$31a1864be1d33bad = [
    'page',
    'blogpost',
    'comment',
    'attachment',
    'whiteboard',
    'database',
    'embed',
    'folder'
];
const $9f74d735080597cb$var$TYPE_ALIASES = {
    news: 'blogpost',
    blog: 'blogpost',
    blogs: 'blogpost',
    'blog-post': 'blogpost',
    blogposts: 'blogpost',
    'blog-posts': 'blogpost',
    pages: 'page',
    comments: 'comment',
    attachments: 'attachment'
};
const $9f74d735080597cb$var$SUPPORTED_TYPES = new Set($9f74d735080597cb$export$31a1864be1d33bad);
function $9f74d735080597cb$var$isContentType(type) {
    return $9f74d735080597cb$var$SUPPORTED_TYPES.has(type);
}
function $9f74d735080597cb$var$normalizeType(rawType) {
    const normalized = $9f74d735080597cb$var$TYPE_ALIASES[rawType] ?? rawType;
    return $9f74d735080597cb$var$isContentType(normalized) ? normalized : undefined;
}
function $9f74d735080597cb$export$bbd572e80a63521b(max) {
    const parsed = Number(max);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : $9f74d735080597cb$export$e2092582db731ff4;
}
function $9f74d735080597cb$export$6a81e704675faae5(params, spaceKey) {
    const clauses = [];
    // Content types
    const collectedTypes = [];
    if (params.types) {
        const splitTypes = String(params.types).split(',');
        for (const t of splitTypes){
            const trimmed = t.trim();
            if (!trimmed) continue;
            const normalizedType = $9f74d735080597cb$var$normalizeType(trimmed.toLowerCase());
            if (normalizedType) collectedTypes.push(normalizedType);
        }
    } else collectedTypes.push(...$9f74d735080597cb$export$31a1864be1d33bad);
    const rawTypes = [
        ...new Set(collectedTypes)
    ];
    if (rawTypes.length > 0) clauses.push(`type in (${rawTypes.join(', ')})`);
    // Space key — defaults to current space
    if (spaceKey) clauses.push(`space = "${spaceKey}"`);
    // Labels
    if (params.labels) {
        const labelList = String(params.labels).split(',').map((l)=>`"${l.trim()}"`).join(', ');
        clauses.push(`label in (${labelList})`);
    }
    // Following users / contributors (author param — comma-separated account IDs)
    if (params.author) {
        const users = String(params.author).split(',').map((u)=>`"${u.trim()}"`).join(', ');
        clauses.push(`contributor in (${users})`);
    }
    return `${clauses.join(' AND ')} order by lastmodified desc`;
}
function $9f74d735080597cb$export$ae985ad2d8a37df8(params, spaceKey, after = '') {
    const maxItems = $9f74d735080597cb$export$bbd572e80a63521b(params.max);
    return {
        cql: $9f74d735080597cb$export$6a81e704675faae5(params, spaceKey),
        cqlcontext: '{"contentStatuses":["draft", "current"]}',
        first: maxItems,
        after: after
    };
}
module.exports["buildRecentlyUpdatedQueryVariables"] = $9f74d735080597cb$export$ae985ad2d8a37df8;

});

parcelRegister("gaqfB", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $eDO9L = parcelRequire("eDO9L");


var $6SH28 = parcelRequire("6SH28");


var $49vfa = parcelRequire("49vfa");


var $gzvFl = parcelRequire("gzvFl");


var $jvHsR = parcelRequire("jvHsR");


var $bEk7g = parcelRequire("bEk7g");

const $466aaf75a85fc8d1$export$6843d2ec6a82b03e = {
    extensionKey: 'pagetree',
    routes: [
        'view',
        'space-overview'
    ],
    preload: async (node, context)=>{
        const { rootParam: rootParam, spaceKey: spaceKey } = (0, $bEk7g.parseMacroParams)(node.attrs?.parameters?.macroParams, context.spaceKey);
        const rootType = (0, $bEk7g.parseRootType)(rootParam);
        if (!spaceKey) return;
        // Step 1: Resolve root via the appropriate query
        let homepageData;
        let ancestorData;
        let searchData;
        // All resolution queries are wrapped in slowQueryGuard so a slow
        // preload cannot hold SSR open past the configured timeout. On
        // timeout the captured `*Data` variable stays undefined, downstream
        // `resolveRootId` falls back to its safe defaults, and the renderer
        // fetches whatever it needs on the client.
        switch(rootType){
            case 'self':
                break;
            case 'title':
                if (rootParam) {
                    const pageTitle = (0, $bEk7g.parsePageTitle)(rootParam);
                    const cql = (0, $bEk7g.buildTitleSearchCql)(pageTitle, spaceKey);
                    searchData = await $466aaf75a85fc8d1$var$preloadSearchByTitle(cql);
                }
                break;
            case 'parent':
                ancestorData = await $466aaf75a85fc8d1$var$preloadAncestors(context.contentId);
                break;
            case 'home':
                homepageData = await $466aaf75a85fc8d1$var$preloadSpaceHomepage(spaceKey);
                break;
            case 'none':
                await $466aaf75a85fc8d1$var$preloadRootLevel(spaceKey);
                break;
        }
        // Derive rootId and preload its children
        const rootId = (0, $bEk7g.resolveRootId)({
            rootType: rootType,
            contentId: context.contentId,
            homepageData: homepageData,
            ancestorData: ancestorData,
            searchData: searchData
        });
        // Step 2: Fetch children + ancestors in parallel.
        // Children needs rootId, ancestors needs context.contentId — independent.
        const allTasks = [];
        if (rootId && (0, $bEk7g.needsRootChildren)(rootType)) allTasks.push($466aaf75a85fc8d1$var$preloadChildren(rootId));
        if ((0, $bEk7g.needsAncestorExpansion)(rootType)) allTasks.push($466aaf75a85fc8d1$var$preloadAncestors(context.contentId));
        if (allTasks.length > 0) await Promise.all(allTasks);
    }
};
/**
 * Preload search-by-title result for the title rootType. Returns the query data, or undefined on timeout.
 */ const $466aaf75a85fc8d1$var$preloadSearchByTitle = async (cql)=>{
    let result;
    await (0, $wPrRK.slowQueryGuard)('pageTreeSearchByTitlePreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $jvHsR.default),
            variables: {
                cql: cql
            },
            context: {
                single: true
            },
            __callerPackage__: "@confluence/preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data;
};
/**
 * Preload space homepage for the home rootType. Returns the query data, or undefined on timeout.
 */ const $466aaf75a85fc8d1$var$preloadSpaceHomepage = async (spaceKey)=>{
    let result;
    await (0, $wPrRK.slowQueryGuard)('pageTreeSpaceHomepagePreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $49vfa.default),
            variables: {
                spaceKey: spaceKey
            },
            context: {
                single: true
            },
            __callerPackage__: "@confluence/preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data;
};
/**
 * Preload root-level pages for the none rootType.
 */ const $466aaf75a85fc8d1$var$preloadRootLevel = (spaceKey)=>(0, $wPrRK.slowQueryGuard)('pageTreeRootLevelPreload', ()=>(0, $dYU3e.query)({
            query: (0, $gzvFl.default),
            variables: {
                spaceKey: spaceKey
            },
            context: {
                single: true
            },
            __callerPackage__: "@confluence/preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
/**
 * Preload children for a page.
 */ const $466aaf75a85fc8d1$var$preloadChildren = (contentId)=>(0, $wPrRK.slowQueryGuard)('pageTreeChildrenPreload', ()=>(0, $dYU3e.query)({
            query: (0, $eDO9L.default),
            variables: {
                contentId: contentId,
                first: (0, $bEk7g.CHILDREN_PAGE_SIZE),
                after: null
            },
            context: {
                single: true
            },
            __callerPackage__: "@confluence/preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
/**
 * Preload ancestor IDs for a page. Returns the query data, or undefined on timeout.
 */ const $466aaf75a85fc8d1$var$preloadAncestors = async (contentId)=>{
    let result;
    await (0, $wPrRK.slowQueryGuard)('pageTreeAncestorsPreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $6SH28.default),
            variables: {
                contentId: contentId
            },
            context: {
                single: true
            },
            __callerPackage__: "@confluence/preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data;
};
module.exports["pagetreePreloadHandler"] = $466aaf75a85fc8d1$export$6843d2ec6a82b03e;

});

parcelRegister("eDO9L", function(module, exports) {
/**
 * @generated SignedSource<<256d99ba3df4e54b3482ec39cb3f3867>>
 * @relayHash 9dca1a9ab56aa16ae0545254732c5266
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ebb04ab89b89574ca90d7d7a09945b7a18850fcd723f050470dc8298cd88e9c7
const $3b030073abdce2d6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = [
        {
            "kind": "Literal",
            "name": "format",
            "value": "MILLIS"
        }
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v11 = {
        "args": v9 /*: any*/ ,
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v12 = {
        "args": v9 /*: any*/ ,
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "lastUpdatedDate",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "lastUpdatedDate(format:\"MILLIS\")"
    }, v13 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "after",
                            "variableName": "after"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeMacroChildrenQuery",
            "selections": v14 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeMacroChildrenQuery",
            "selections": v14 /*: any*/ 
        },
        "params": {
            "cacheID": "9dca1a9ab56aa16ae0545254732c5266",
            "id": "ebb04ab89b89574ca90d7d7a09945b7a18850fcd723f050470dc8298cd88e9c7",
            "metadata": {},
            "name": "PageTreeMacroChildrenQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroChildrenQuery($contentId:ID!,$first:Int,$after:String){ptpage(id:$contentId){id,title,status,hasChildren,type,subType,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui},children(first:$first,after:$after){nodes{id,title,status,hasChildren,type,subType,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui}},pageInfo{hasNextPage,endCursor}}}}"
        }
    };
}();
$3b030073abdce2d6$var$node.hash = "05eb4aa8e3fbdce7af9f9598925a59b7";
var $3b030073abdce2d6$export$2e2bcd8739ae039 = $3b030073abdce2d6$var$node;
module.exports["default"] = $3b030073abdce2d6$export$2e2bcd8739ae039;

});

parcelRegister("6SH28", function(module, exports) {
/**
 * @generated SignedSource<<6ed9797be759e375a531e38a2af48352>>
 * @relayHash 1cb037b815e517bd7984595b20d124af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID acb8b4b0c8e9ce55d652b28f502d52dd391de7c55bdb32f248dbeb8199940cbc
const $7e0dd4f7164e5968$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroAncestorsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroAncestorsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "1cb037b815e517bd7984595b20d124af",
            "id": "acb8b4b0c8e9ce55d652b28f502d52dd391de7c55bdb32f248dbeb8199940cbc",
            "metadata": {},
            "name": "PageTreeMacroAncestorsQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroAncestorsQuery($contentId:ID!){ptpage(id:$contentId){id,nearestAncestors{nodes{id}}}}"
        }
    };
}();
$7e0dd4f7164e5968$var$node.hash = "87b0f0557adb9a0866c0ecd4aae73da8";
var $7e0dd4f7164e5968$export$2e2bcd8739ae039 = $7e0dd4f7164e5968$var$node;
module.exports["default"] = $7e0dd4f7164e5968$export$2e2bcd8739ae039;

});

parcelRegister("49vfa", function(module, exports) {
/**
 * @generated SignedSource<<c76673347537b0257d7eb27040ca82b3>>
 * @relayHash c61a430f42dfefbb095b2ca84bb4127d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a06f8ee0d26e27379e1824924505981b4e94348246f357fc7c17901ddf02d7f
const $21b326e4a95ad923$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c61a430f42dfefbb095b2ca84bb4127d",
            "id": "7a06f8ee0d26e27379e1824924505981b4e94348246f357fc7c17901ddf02d7f",
            "metadata": {},
            "name": "PageTreeMacroSpaceHomepageQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroSpaceHomepageQuery($spaceKey:String!){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$21b326e4a95ad923$var$node.hash = "97d54ae520df0edd2399fe104d2017bf";
var $21b326e4a95ad923$export$2e2bcd8739ae039 = $21b326e4a95ad923$var$node;
module.exports["default"] = $21b326e4a95ad923$export$2e2bcd8739ae039;

});

parcelRegister("gzvFl", function(module, exports) {
/**
 * @generated SignedSource<<5b9573791702755caa0b594b5e789206>>
 * @relayHash 4713f1182970b33f17d5b769e20b933a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 409e93ff2e04f08fded0e7d94a8a5514c3db5148f6459f540f1d1cdfadeb8ea7
const $bd17eac6cecb59ef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v7 = [
        {
            "kind": "Literal",
            "name": "format",
            "value": "MILLIS"
        }
    ], v8 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v9 = {
        "args": v7 /*: any*/ ,
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": v8 /*: any*/ ,
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v10 = {
        "args": v7 /*: any*/ ,
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "lastUpdatedDate",
        "plural": false,
        "selections": v8 /*: any*/ ,
        "storageKey": "lastUpdatedDate(format:\"MILLIS\")"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "followingSiblings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroRootLevelQuery",
            "selections": v12 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroRootLevelQuery",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "4713f1182970b33f17d5b769e20b933a",
            "id": "409e93ff2e04f08fded0e7d94a8a5514c3db5148f6459f540f1d1cdfadeb8ea7",
            "metadata": {},
            "name": "PageTreeMacroRootLevelQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroRootLevelQuery($spaceKey:String!){ptpage(spaceKey:$spaceKey){id,title,status,hasChildren,type,subType,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui},followingSiblings{nodes{id,title,status,hasChildren,type,subType,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui}},pageInfo{hasNextPage}}}}"
        }
    };
}();
$bd17eac6cecb59ef$var$node.hash = "aa699a91c79ad64021b680f9983cb88c";
var $bd17eac6cecb59ef$export$2e2bcd8739ae039 = $bd17eac6cecb59ef$var$node;
module.exports["default"] = $bd17eac6cecb59ef$export$2e2bcd8739ae039;

});

parcelRegister("jvHsR", function(module, exports) {
/**
 * @generated SignedSource<<7ce6cc193cc37b4484da707ada8e906b>>
 * @relayHash 2eb5932fe57eda221f60bf95729cc781
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d26dc563aec2070c8c92491642682e66884032b661b2c5862a9e3c2f83bcc352
const $6c3ffceca1ec4cfc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroSearchByTitleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroSearchByTitleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2eb5932fe57eda221f60bf95729cc781",
            "id": "d26dc563aec2070c8c92491642682e66884032b661b2c5862a9e3c2f83bcc352",
            "metadata": {},
            "name": "PageTreeMacroSearchByTitleQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroSearchByTitleQuery($cql:String!){confluence_search(cql:$cql,first:1){nodes{content{id}}}}"
        }
    };
}();
$6c3ffceca1ec4cfc$var$node.hash = "42441e185ca1b3e501257c64db0a4892";
var $6c3ffceca1ec4cfc$export$2e2bcd8739ae039 = $6c3ffceca1ec4cfc$var$node;
module.exports["default"] = $6c3ffceca1ec4cfc$export$2e2bcd8739ae039;

});

parcelRegister("bEk7g", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $26e80ddf91af379c$export$9921da6540a2b156 = (node)=>({
        id: node.id,
        title: node.title,
        hasChildren: node.hasChildren,
        url: node.links?.webui ? `${0, $jlIaF.CONTEXT_PATH}${node.links.webui}` : '',
        status: node.status,
        type: node.type,
        subType: node.subType,
        createdDate: node.createdDate?.value ? Number(node.createdDate.value) : undefined,
        lastModifiedDate: node.lastUpdatedDate?.value ? Number(node.lastUpdatedDate.value) : undefined
    });
// ---------------------------------------------------------------------------
// Client-side sorting
// ---------------------------------------------------------------------------
const $26e80ddf91af379c$var$naturalCompare = (a, b)=>{
    return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base'
    });
};
const $26e80ddf91af379c$export$96d07f33920abf3e = (nodes, sort, reverse)=>{
    const sorted = [
        ...nodes
    ];
    switch(sort){
        case 'bitwise':
            sorted.sort((a, b)=>a.title.localeCompare(b.title));
            break;
        case 'natural':
            sorted.sort((a, b)=>$26e80ddf91af379c$var$naturalCompare(a.title, b.title));
            break;
        case 'creation':
            sorted.sort((a, b)=>(a.createdDate || 0) - (b.createdDate || 0));
            break;
        case 'modified':
            sorted.sort((a, b)=>(a.lastModifiedDate || 0) - (b.lastModifiedDate || 0));
            break;
        case 'position':
        default:
            break;
    }
    if (reverse) sorted.reverse();
    return sorted;
};
const $26e80ddf91af379c$export$3cf9a7263d7d2d28 = 100;
const $26e80ddf91af379c$export$7db02a6ccf4cb65a = (data, sort, reverse)=>{
    const children = data?.ptpage?.children?.nodes;
    if (!children) return null;
    const nodes = [];
    for (const n of children)if (n != null) nodes.push($26e80ddf91af379c$export$9921da6540a2b156(n));
    return $26e80ddf91af379c$export$96d07f33920abf3e(nodes, sort, reverse);
};
const $26e80ddf91af379c$export$487d62996e3b3023 = async (refetchChildren, parentId, sort, reverse)=>{
    const batches = [];
    let after = null;
    let hasMore = true;
    let iteration = 0;
    while(hasMore && iteration < 100){
        const result = await refetchChildren({
            contentId: parentId,
            first: $26e80ddf91af379c$export$3cf9a7263d7d2d28,
            after: after
        });
        const children = result?.data?.ptpage?.children;
        if (!children?.nodes) break;
        batches.push(children.nodes);
        if (children.pageInfo?.hasNextPage && children.pageInfo?.endCursor !== after) after = children.pageInfo.endCursor ?? null;
        else hasMore = false;
        iteration++;
    }
    const rawNodes = batches.flat().filter((n)=>n != null);
    return $26e80ddf91af379c$export$96d07f33920abf3e(rawNodes.map($26e80ddf91af379c$export$9921da6540a2b156), sort, reverse);
};
const $26e80ddf91af379c$export$bdc9b163c4d0f3de = (value)=>{
    return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
};
const $26e80ddf91af379c$var$isValidSort = (value)=>[
        'natural',
        'bitwise',
        'position',
        'creation',
        'modified'
    ].includes(value);
const $26e80ddf91af379c$export$66770a7e7da42ecb = (macroParams, defaultSpaceKey)=>{
    const rootParam = macroParams?.root?.value ?? null;
    const spaceKey = macroParams?.spaces?.value ?? defaultSpaceKey;
    const showExcerpt = macroParams?.excerpt?.value === 'true';
    const sortValue = macroParams?.sort?.value ?? 'position';
    const sort = $26e80ddf91af379c$var$isValidSort(sortValue) ? sortValue : 'position';
    const reverse = macroParams?.reverse?.value === 'true';
    const showSearchBox = macroParams?.searchBox?.value === 'true';
    const showExpandCollapseAll = macroParams?.expandCollapseAll?.value === 'true';
    const startDepthStr = macroParams?.startDepth?.value ?? '0';
    const startDepth = /^\d+$/.test(startDepthStr) ? parseInt(startDepthStr, 10) : 0;
    return {
        rootParam: rootParam,
        spaceKey: spaceKey,
        showExcerpt: showExcerpt,
        sort: sort,
        reverse: reverse,
        showSearchBox: showSearchBox,
        showExpandCollapseAll: showExpandCollapseAll,
        startDepth: startDepth
    };
};
const $26e80ddf91af379c$export$b364eed1315822f9 = (params)=>JSON.stringify({
        root: params.rootParam,
        spaces: params.spaceKey,
        excerpt: String(params.showExcerpt),
        sort: params.sort,
        reverse: String(params.reverse),
        searchBox: String(params.showSearchBox),
        expandCollapseAll: String(params.showExpandCollapseAll),
        startDepth: String(params.startDepth)
    });
const $26e80ddf91af379c$export$b7bc6229bead1c21 = (rootParam)=>{
    if (!rootParam) return 'home';
    const lower = rootParam.toLowerCase();
    switch(lower){
        case '@self':
            return 'self';
        case '@parent':
            return 'parent';
        case '@home':
            return 'home';
        case '@none':
            return 'none';
        default:
            return 'title';
    }
};
const $26e80ddf91af379c$export$eca7683f8ecceb76 = (data)=>data?.content?.nodes?.[0]?.macroExcerpt?.atlasDocFormat ?? undefined;
const $26e80ddf91af379c$export$a8a6626948b501bd = (data)=>data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token ?? undefined;
const $26e80ddf91af379c$export$31e03f73732334a0 = (data)=>{
    const rawNodes = data?.content?.nodes;
    const nodes = [];
    if (rawNodes) for (const node of rawNodes){
        if (!node?.id) continue;
        nodes.push({
            id: node.id,
            adfString: node.macroExcerpt?.atlasDocFormat ?? undefined,
            mediaToken: node.body?.atlas_doc_format?.mediaToken?.token ?? undefined
        });
    }
    const rawPageInfo = data?.content?.pageInfo;
    const pageInfo = rawPageInfo ? {
        hasNextPage: rawPageInfo.hasNextPage,
        endCursor: rawPageInfo.endCursor ?? null
    } : null;
    return {
        nodes: nodes,
        pageInfo: pageInfo
    };
};
const $26e80ddf91af379c$export$2bcabf930da035c4 = (data)=>{
    const children = data?.ptpage?.children?.nodes;
    if (!children) return [];
    const ids = [];
    for (const child of children)if (child?.id) ids.push(child.id);
    return ids;
};
const $26e80ddf91af379c$export$27ca14a7672351ca = (data)=>data?.space?.homepage?.id ?? undefined;
const $26e80ddf91af379c$export$f0abfa7ade6f050b = (data)=>data?.ptpage?.nearestAncestors?.nodes?.[0]?.id ?? undefined;
const $26e80ddf91af379c$export$af332464b727c9e9 = (data)=>data?.confluence_search?.nodes?.[0]?.content?.id ?? undefined;
const $26e80ddf91af379c$export$25828e9857936ee8 = ({ rootType: rootType, contentId: contentId, homepageData: homepageData, ancestorData: ancestorData, searchData: searchData })=>{
    switch(rootType){
        case 'self':
            return contentId;
        case 'home':
            return $26e80ddf91af379c$export$27ca14a7672351ca(homepageData);
        case 'parent':
            return $26e80ddf91af379c$export$f0abfa7ade6f050b(ancestorData);
        case 'title':
            return $26e80ddf91af379c$export$af332464b727c9e9(searchData);
        case 'none':
            return undefined;
    }
};
const $26e80ddf91af379c$export$d0cbb0149dfad6ae = (rootType)=>rootType !== 'self' && rootType !== 'parent';
const $26e80ddf91af379c$export$b38ff668c727ce06 = (rootType)=>rootType !== 'none';
const $26e80ddf91af379c$export$a802709b8af34ca = (rootParam)=>{
    const colonIndex = rootParam.indexOf(':');
    return colonIndex >= 0 ? rootParam.substring(colonIndex + 1) : rootParam;
};
const $26e80ddf91af379c$export$87777831b2e51242 = (pageTitle, spaceKey)=>{
    return `title = "${$26e80ddf91af379c$export$bdc9b163c4d0f3de(pageTitle)}" and space = "${$26e80ddf91af379c$export$bdc9b163c4d0f3de(spaceKey)}" and type = "page"`;
};
module.exports["mapPtPageNode"] = $26e80ddf91af379c$export$9921da6540a2b156;
module.exports["sortNodes"] = $26e80ddf91af379c$export$96d07f33920abf3e;
module.exports["CHILDREN_PAGE_SIZE"] = $26e80ddf91af379c$export$3cf9a7263d7d2d28;
module.exports["extractChildNodes"] = $26e80ddf91af379c$export$7db02a6ccf4cb65a;
module.exports["extractChildren"] = $26e80ddf91af379c$export$487d62996e3b3023;
module.exports["parseMacroParams"] = $26e80ddf91af379c$export$66770a7e7da42ecb;
module.exports["serializeMacroParams"] = $26e80ddf91af379c$export$b364eed1315822f9;
module.exports["parseRootType"] = $26e80ddf91af379c$export$b7bc6229bead1c21;
module.exports["extractSingleNodeAdfString"] = $26e80ddf91af379c$export$eca7683f8ecceb76;
module.exports["extractSingleNodeMediaToken"] = $26e80ddf91af379c$export$a8a6626948b501bd;
module.exports["extractBatchPage"] = $26e80ddf91af379c$export$31e03f73732334a0;
module.exports["resolveRootId"] = $26e80ddf91af379c$export$25828e9857936ee8;
module.exports["needsAncestorExpansion"] = $26e80ddf91af379c$export$d0cbb0149dfad6ae;
module.exports["needsRootChildren"] = $26e80ddf91af379c$export$b38ff668c727ce06;
module.exports["parsePageTitle"] = $26e80ddf91af379c$export$a802709b8af34ca;
module.exports["buildTitleSearchCql"] = $26e80ddf91af379c$export$87777831b2e51242;

});

parcelRegister("2jr6j", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $kVsp1 = parcelRequire("kVsp1");


var $34TzN = parcelRequire("34TzN");


var $fV8ei = parcelRequire("fV8ei");

const $9e98ea7884d33a92$export$e06ba1e8026960ca = {
    extensionKey: 'pagetreesearch',
    routes: [
        'view',
        'space-overview'
    ],
    preload: async (node, context)=>{
        const macroParams = node.attrs?.parameters?.macroParams;
        const rootPageString = (0, $fV8ei.getRootPageParam)(macroParams);
        if (rootPageString == null) return;
        const { spaceKey: spaceKey, title: title, hasExplicitSpace: hasExplicitSpace } = (0, $fV8ei.parseRootPageString)(rootPageString, context.spaceKey);
        if (!spaceKey) return;
        if (title) {
            await (0, $wPrRK.slowQueryGuard)('pageTreeSearchPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $kVsp1.default),
                    variables: {
                        spaceKey: spaceKey,
                        title: title,
                        validateSpace: hasExplicitSpace
                    },
                    context: {
                        single: true
                    },
                    __callerPackage__: "@confluence/preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
            return;
        }
        // Space-only validation (e.g. "MYSPACE:")
        if (hasExplicitSpace) await (0, $wPrRK.slowQueryGuard)('pageTreeSearchSpaceValidationPreload', ()=>(0, $dYU3e.query)({
                query: (0, $34TzN.default),
                variables: {
                    spaceKey: spaceKey
                },
                context: {
                    single: true
                },
                __callerPackage__: "@confluence/preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["pagetreeSearchPreloadHandler"] = $9e98ea7884d33a92$export$e06ba1e8026960ca;

});

parcelRegister("kVsp1", function(module, exports) {
/**
 * @generated SignedSource<<ac24f7a863948accfbd6d59cbbee7264>>
 * @relayHash 4484fadd23c040a81eec65da02ab0cd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8333bcdd71159e20c0f7e8092762d02226d046fb6481936e04c0bb2aff61fca4
const $87e1172a98f7d3d7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "title"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "validateSpace"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v2 = [
        {
            "condition": "validateSpace",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "title"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageTreeSearchQueryQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageTreeSearchQueryQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "4484fadd23c040a81eec65da02ab0cd9",
            "id": "8333bcdd71159e20c0f7e8092762d02226d046fb6481936e04c0bb2aff61fca4",
            "metadata": {},
            "name": "usePageTreeSearchQueryQuery",
            "operationKind": "query",
            "text": "query usePageTreeSearchQueryQuery($spaceKey:String!,$title:String!,$validateSpace:Boolean!){space(key:$spaceKey)@include(if:$validateSpace){id},content(spaceKey:$spaceKey,title:$title,type:\"page\"){nodes{id}}}"
        }
    };
}();
$87e1172a98f7d3d7$var$node.hash = "1be6e27ce1b78f4f22a3ff6689bbf9e4";
var $87e1172a98f7d3d7$export$2e2bcd8739ae039 = $87e1172a98f7d3d7$var$node;
module.exports["default"] = $87e1172a98f7d3d7$export$2e2bcd8739ae039;

});

parcelRegister("34TzN", function(module, exports) {
/**
 * @generated SignedSource<<71bcfe57e49ffa98a90c029ce20a0c42>>
 * @relayHash a2a71f8c82ac5eef37dab68dd9909961
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1e18736f7c82cd2662cfe968df89a26d8a8dd52311595737ad8cf4818f4899dc
const $3a566bea7c41a78b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceValidationQueryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceValidationQueryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a2a71f8c82ac5eef37dab68dd9909961",
            "id": "1e18736f7c82cd2662cfe968df89a26d8a8dd52311595737ad8cf4818f4899dc",
            "metadata": {},
            "name": "useSpaceValidationQueryQuery",
            "operationKind": "query",
            "text": "query useSpaceValidationQueryQuery($spaceKey:String!){space(key:$spaceKey){id}}"
        }
    };
}();
$3a566bea7c41a78b$var$node.hash = "7638ca6f03f75527639ed0545762f27e";
var $3a566bea7c41a78b$export$2e2bcd8739ae039 = $3a566bea7c41a78b$var$node;
module.exports["default"] = $3a566bea7c41a78b$export$2e2bcd8739ae039;

});

parcelRegister("fV8ei", function(module, exports) {
/**
 * Extracts the raw `rootPage` macro parameter value, supporting all known
 * legacy parameter aliases (`rootPage`, `rootpage`, `'0'`).
 *
 * Returns `undefined` when no `rootPage` parameter is set.
 */ const $2efd9995ee26a8d7$export$7e7a804114e88dad = (macroParams)=>{
    if (!macroParams) return undefined;
    return macroParams.rootPage?.value ?? macroParams.rootpage?.value ?? macroParams['0']?.value;
};
const $2efd9995ee26a8d7$export$d0fe7d7e2f2da886 = (rootPageString, defaultSpaceKey)=>{
    const delimiterPos = rootPageString.indexOf(':');
    if (delimiterPos > -1) {
        const rawSpaceKey = rootPageString.substring(0, delimiterPos);
        const spaceKey = rawSpaceKey || defaultSpaceKey;
        const title = rootPageString.substring(delimiterPos + 1);
        return {
            spaceKey: spaceKey,
            title: title,
            hasExplicitSpace: Boolean(rawSpaceKey)
        };
    }
    return {
        spaceKey: defaultSpaceKey,
        title: rootPageString,
        hasExplicitSpace: false
    };
};
module.exports["getRootPageParam"] = $2efd9995ee26a8d7$export$7e7a804114e88dad;
module.exports["parseRootPageString"] = $2efd9995ee26a8d7$export$d0fe7d7e2f2da886;

});

parcelRegister("j9Zer", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $xwvlW = parcelRequire("xwvlW");


var $cBlwX = parcelRequire("cBlwX");


var $bWsrO = parcelRequire("bWsrO");


var $dAlan = parcelRequire("dAlan");

/**
 * Resolves a `spaceKey` to its `spaceId` by preloading the popular-labels
 * macro's own space-id query. This is the same query (`space(key:) { id }`)
 * that `usePopularLabelsDataForSpace` runs on the client, so the response
 * warms the same Apollo cache entry the renderer reads from.
 *
 * Returns `null` when the space cannot be resolved.
 */ const $c34d9e9634b09e90$var$preloadSpaceId = async (spaceKey)=>{
    // Wrap in slowQueryGuard so a slow preload cannot hold SSR open past
    // the configured timeout. We capture the underlying query result via a
    // closure: if the guard times out the closure variable stays undefined
    // and we return null, which causes the labels preload to be skipped —
    // the renderer will fetch on the client.
    let result;
    await (0, $wPrRK.slowQueryGuard)('popularLabelsSpaceIdPreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $dAlan.default),
            variables: {
                spaceKey: spaceKey
            },
            context: {
                single: true
            },
            __callerPackage__: "@confluence/preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data?.space?.id ?? null;
};
const $c34d9e9634b09e90$export$b9e25e62a1057304 = {
    extensionKey: 'popular-labels',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
            if (!cloudId) return;
            const macroParams = node.attrs?.parameters?.macroParams;
            // Resolve the legacy `'currentSpace()'` sentinel against the host
            // page's space key before issuing the space-id lookup, so the
            // preloaded space-id cache entry matches the renderer's lookup.
            const spaceKeyParam = (0, $cBlwX.resolveSpaceKey)(macroParams?.spaceKey?.value, context.spaceKey);
            let spaceId = null;
            if (spaceKeyParam) {
                spaceId = await $c34d9e9634b09e90$var$preloadSpaceId(spaceKeyParam);
                if (!spaceId) // SpaceKey didn't resolve — skip preloading the labels query rather
                // than warming the wrong (global) scope. The renderer will surface
                // the same error on the client.
                return;
            }
            const variables = {
                cloudId: cloudId,
                first: (0, $cBlwX.parseCount)(macroParams?.count?.value),
                style: (0, $cBlwX.toStyleEnum)((0, $cBlwX.parseStyle)(macroParams?.style?.value)),
                spaceId: spaceId
            };
            await (0, $wPrRK.slowQueryGuard)('popularLabelsPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $bWsrO.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "@confluence/preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            // Preloading is best-effort cache warming. Ignore failures here and
            // let the renderer perform the query in its normal error-handled path.
            return;
        }
    }
};
module.exports["popularLabelsPreloadHandler"] = $c34d9e9634b09e90$export$b9e25e62a1057304;

});

parcelRegister("cBlwX", function(module, exports) {
const $1f71c16b1032d2d5$export$72344c9fa45ae2c1 = 100;
const $1f71c16b1032d2d5$export$a3d4695a56a4eb21 = (value)=>{
    if (!value) return $1f71c16b1032d2d5$export$72344c9fa45ae2c1;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) || parsed <= 0 ? $1f71c16b1032d2d5$export$72344c9fa45ae2c1 : parsed;
};
const $1f71c16b1032d2d5$export$e13dc740254f53d7 = (value)=>{
    return value === 'heatmap' ? 'heatmap' : 'list';
};
const $1f71c16b1032d2d5$export$70583ee990b45c2f = (style)=>{
    return style === 'heatmap' ? 'HEATMAP' : 'LIST';
};
const $1f71c16b1032d2d5$export$f8e62856e51f4d9b = 'currentSpace()';
const $1f71c16b1032d2d5$export$95cd40c60becde49 = (rawSpaceKey, currentSpaceKey)=>{
    if (!rawSpaceKey) return undefined;
    if (rawSpaceKey === $1f71c16b1032d2d5$export$f8e62856e51f4d9b) return currentSpaceKey ?? rawSpaceKey;
    return rawSpaceKey;
};
module.exports["parseCount"] = $1f71c16b1032d2d5$export$a3d4695a56a4eb21;
module.exports["parseStyle"] = $1f71c16b1032d2d5$export$e13dc740254f53d7;
module.exports["toStyleEnum"] = $1f71c16b1032d2d5$export$70583ee990b45c2f;
module.exports["resolveSpaceKey"] = $1f71c16b1032d2d5$export$95cd40c60becde49;

});

parcelRegister("bWsrO", function(module, exports) {
/**
 * @generated SignedSource<<a5a6d0e82e428da960af0dc1a1abc4c4>>
 * @relayHash 273d979596298c8fcee11273951c160e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15aa4eecb798db8044ace93910ff132d0809c5a972721f5a601a3dc413a1716e
const $08d54037c47f542d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "style"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "spaceId",
                    "variableName": "spaceId"
                },
                {
                    "kind": "Variable",
                    "name": "style",
                    "variableName": "style"
                }
            ],
            "concreteType": "ConfluencePopularLabelEntryConnection",
            "kind": "LinkedField",
            "name": "confluence_popularLabelsMacro",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluencePopularLabelEntry",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "rank"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "count"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "labelId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePopularLabelsDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePopularLabelsDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "273d979596298c8fcee11273951c160e",
            "id": "15aa4eecb798db8044ace93910ff132d0809c5a972721f5a601a3dc413a1716e",
            "metadata": {},
            "name": "usePopularLabelsDataQuery",
            "operationKind": "query",
            "text": "query usePopularLabelsDataQuery($cloudId:ID!,$first:Int,$spaceId:ID,$style:ConfluencePopularLabelStyle){confluence_popularLabelsMacro(cloudId:$cloudId,first:$first,spaceId:$spaceId,style:$style){nodes{name,rank,count,labelId}}}"
        }
    };
}();
$08d54037c47f542d$var$node.hash = "5b8aebb08be483a2b2f2f54bf875f423";
var $08d54037c47f542d$export$2e2bcd8739ae039 = $08d54037c47f542d$var$node;
module.exports["default"] = $08d54037c47f542d$export$2e2bcd8739ae039;

});

parcelRegister("dAlan", function(module, exports) {
/**
 * @generated SignedSource<<ced0a6739432a230108889f4d0e09538>>
 * @relayHash 41fee47bcd447ee8e96835308a5a4f99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd95adfed4d8357af09a9ad201ca4d15932c64b4fa418a1b4a4c2e557e12c551
const $566340bccba941cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePopularLabelsDataSpaceIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePopularLabelsDataSpaceIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "41fee47bcd447ee8e96835308a5a4f99",
            "id": "cd95adfed4d8357af09a9ad201ca4d15932c64b4fa418a1b4a4c2e557e12c551",
            "metadata": {},
            "name": "usePopularLabelsDataSpaceIdQuery",
            "operationKind": "query",
            "text": "query usePopularLabelsDataSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}"
        }
    };
}();
$566340bccba941cc$var$node.hash = "d5968c7370aba3bd3a9089e4721bb508";
var $566340bccba941cc$export$2e2bcd8739ae039 = $566340bccba941cc$var$node;
module.exports["default"] = $566340bccba941cc$export$2e2bcd8739ae039;

});

parcelRegister("eOfv4", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $30F7c = parcelRequire("30F7c");

const $ab0a577528facf1f$export$a26d4f508ed8cd67 = {
    extensionKey: 'profile-picture',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, _context)=>{
        try {
            const userId = node.attrs?.parameters?.macroParams?.User?.value;
            if (!userId) return;
            const variables = {
                userId: userId
            };
            await (0, $wPrRK.slowQueryGuard)('profilePicturePreload', ()=>(0, $dYU3e.query)({
                    query: (0, $30F7c.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "@confluence/preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            // Preloading is best-effort cache warming. Ignore failures here and
            // let the renderer perform the query in its normal error-handled path.
            return;
        }
    }
};
module.exports["profilePicturePreloadHandler"] = $ab0a577528facf1f$export$a26d4f508ed8cd67;

});

parcelRegister("30F7c", function(module, exports) {
/**
 * @generated SignedSource<<20904bfa8cc8894f1f41fd4c23de4797>>
 * @relayHash 98854a5bccd4ea4b4cf3114c1778a63a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4c165001740b0572461dd93e231b3425c566a844e008bc410f5e0b3630c4f05
const $082db8f111d4d391$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v2 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "isActive"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useProfileInfoUserContextQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useProfileInfoUserContextQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "98854a5bccd4ea4b4cf3114c1778a63a",
            "id": "f4c165001740b0572461dd93e231b3425c566a844e008bc410f5e0b3630c4f05",
            "metadata": {},
            "name": "useProfileInfoUserContextQuery",
            "operationKind": "query",
            "text": "query useProfileInfoUserContextQuery($userId:ID){user:confluence_atlassianUser(id:$userId){id,photos{value,isPrimary},displayName,emails{value,isPrimary},title,isActive}}"
        }
    };
}();
$082db8f111d4d391$var$node.hash = "cd83aff11b55f855ecd3361dedc3552d";
var $082db8f111d4d391$export$2e2bcd8739ae039 = $082db8f111d4d391$var$node;
module.exports["default"] = $082db8f111d4d391$export$2e2bcd8739ae039;

});

parcelRegister("hwhSw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $30F7c = parcelRequire("30F7c");

const $f988674c040264f3$export$ba7f4f786ca1288f = {
    extensionKey: 'profile',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, _context)=>{
        try {
            const userId = node.attrs?.parameters?.macroParams?.user?.value;
            if (!userId) return;
            const variables = {
                userId: userId
            };
            await (0, $wPrRK.slowQueryGuard)('userProfilePreload', ()=>(0, $dYU3e.query)({
                    query: (0, $30F7c.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "@confluence/preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            // Preloading is best-effort cache warming. Ignore failures here and
            // let the renderer perform the query in its normal error-handled path.
            return;
        }
    }
};
module.exports["userProfilePreloadHandler"] = $f988674c040264f3$export$ba7f4f786ca1288f;

});

parcelRegister("aEHCA", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $15svH = parcelRequire("15svH");


var $jqlpB = parcelRequire("jqlpB");

const $07b632e1e0c660f3$var$buildVariables = (contentId, parsed)=>{
    return (0, $jqlpB.buildViewPdfQueryVariables)({
        contentId: contentId,
        pageName: parsed.pageName,
        spaceKey: parsed.spaceKey,
        date: parsed.date
    });
};
const $07b632e1e0c660f3$export$f9e67083aa63b898 = {
    extensionKey: 'viewpdf',
    routes: [
        'view',
        'space-overview',
        'edit'
    ],
    preload: async (node, context)=>{
        const macroParams = node.attrs?.parameters?.macroParams;
        const parsed = (0, $jqlpB.parseViewPdfMacroParams)(macroParams);
        if (!parsed.attachmentName) return;
        const variables = $07b632e1e0c660f3$var$buildVariables(context.contentId, parsed);
        await (0, $wPrRK.slowQueryGuard)('viewPdfPreload', ()=>(0, $dYU3e.query)({
                query: (0, $15svH.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "@confluence/preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["viewPdfPreloadHandler"] = $07b632e1e0c660f3$export$f9e67083aa63b898;

});

parcelRegister("15svH", function(module, exports) {
/**
 * @generated SignedSource<<c94c3f7a76f8371f5cb62396b720ee7a>>
 * @relayHash 814697115f3f596cbb9c38ce14be1f85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb4b2b513a3e28c226362fa46e7d11cc5508513505b03509f58942665c918c38
const $6ba83d52bb6ac0cf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "postingDay"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "postingDay",
            "variableName": "postingDay"
        },
        {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 250
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useViewPdfDataQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:250)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useViewPdfDataQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:250)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "814697115f3f596cbb9c38ce14be1f85",
            "id": "fb4b2b513a3e28c226362fa46e7d11cc5508513505b03509f58942665c918c38",
            "metadata": {},
            "name": "useViewPdfDataQuery",
            "operationKind": "query",
            "text": "query useViewPdfDataQuery($contentId:ID,$contentStatus:[String],$spaceKey:String,$title:String,$type:String,$postingDay:String){content(id:$contentId,status:$contentStatus,spaceKey:$spaceKey,title:$title,type:$type,postingDay:$postingDay){edges{node{id,attachments(first:250){nodes{title,extensions{key,value},id}}}}}}"
        }
    };
}();
$6ba83d52bb6ac0cf$var$node.hash = "20d975cc714dfdf1087101ddcb9c164b";
var $6ba83d52bb6ac0cf$export$2e2bcd8739ae039 = $6ba83d52bb6ac0cf$var$node;
module.exports["default"] = $6ba83d52bb6ac0cf$export$2e2bcd8739ae039;

});

parcelRegister("jqlpB", function(module, exports) {
const $3500f1c8d39c6386$export$ac4d1f313c318334 = '100%';
const $3500f1c8d39c6386$export$7ce912260e18e60d = '650px';
const $3500f1c8d39c6386$export$c3becee1470bf9a7 = (size)=>{
    const numericSize = size.replace(/[^\d.]+/g, '');
    if (size.endsWith('%')) return `${numericSize}%`;
    return `${numericSize}px`;
};
const $3500f1c8d39c6386$export$3082a5716eb987e9 = (rawWidth, rawHeight)=>({
        width: rawWidth ? $3500f1c8d39c6386$export$c3becee1470bf9a7(rawWidth) : $3500f1c8d39c6386$export$ac4d1f313c318334,
        height: rawHeight ? $3500f1c8d39c6386$export$c3becee1470bf9a7(rawHeight) : $3500f1c8d39c6386$export$7ce912260e18e60d
    });
const $3500f1c8d39c6386$export$c86b59de1acee041 = (rawPageParam)=>{
    if (!rawPageParam) return {
        pageName: null,
        spaceKey: null,
        date: null
    };
    const pageParam = rawPageParam.trim();
    if (!pageParam) return {
        pageName: null,
        spaceKey: null,
        date: null
    };
    const firstColon = pageParam.indexOf(':');
    const spacePart = firstColon !== -1 ? pageParam.slice(0, firstColon) || null : null;
    const titlePart = firstColon !== -1 ? pageParam.slice(firstColon + 1) : pageParam;
    let pageName = titlePart;
    let date = null;
    const blogMatch = titlePart.match(/^\/(\d{4})\/(\d{2})\/(\d{2})\/(.+)$/);
    if (blogMatch) {
        const [, year, month, day, title] = blogMatch;
        date = `${month}/${day}/${year}`;
        pageName = title;
    }
    return {
        pageName: pageName || null,
        spaceKey: spacePart || null,
        date: date
    };
};
const $3500f1c8d39c6386$export$6cc41227155528f2 = (macroParams)=>{
    const attachmentName = macroParams?.name?.value ?? macroParams?.['']?.value ?? macroParams?.defaultParameterValue?.value ?? null;
    const decodedPage = $3500f1c8d39c6386$export$c86b59de1acee041(macroParams?.page?.value ?? null);
    const { width: viewerWidth, height: viewerHeight } = $3500f1c8d39c6386$export$3082a5716eb987e9(macroParams?.width?.value, macroParams?.height?.value);
    return {
        attachmentName: attachmentName,
        pageName: decodedPage.pageName,
        spaceKey: macroParams?.space?.value ?? decodedPage.spaceKey,
        date: macroParams?.date?.value ?? decodedPage.date,
        viewerWidth: viewerWidth,
        viewerHeight: viewerHeight
    };
};
const $3500f1c8d39c6386$export$a35ba7e9630557a6 = (date)=>{
    const parts = date.split('/');
    if (parts.length !== 3) return undefined;
    const [month, day, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
const $3500f1c8d39c6386$export$3ac25d3edc0c1d36 = ({ contentId: contentId, pageName: pageName, spaceKey: spaceKey, date: date })=>{
    const normalizedPageName = pageName?.trim() || null;
    if (normalizedPageName) {
        const variables = {
            contentStatus: [
                'current'
            ],
            title: normalizedPageName,
            type: date ? 'blogpost' : 'page'
        };
        if (spaceKey) variables.spaceKey = spaceKey;
        if (date) variables.postingDay = $3500f1c8d39c6386$export$a35ba7e9630557a6(date);
        return variables;
    }
    return {
        contentId: contentId ?? undefined,
        contentStatus: [
            'current'
        ]
    };
};
module.exports["parseViewPdfMacroParams"] = $3500f1c8d39c6386$export$6cc41227155528f2;
module.exports["buildViewPdfQueryVariables"] = $3500f1c8d39c6386$export$3ac25d3edc0c1d36;

});

parcelRegister("ivpnt", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $xwvlW = parcelRequire("xwvlW");


var $ei8Ok = parcelRequire("ei8Ok");


var $rPmsQ = parcelRequire("rPmsQ");


var $fzKPX = parcelRequire("fzKPX");

/**
 * Splits the spaces macro param into two buckets at preload time, mirroring
 * the runtime hook's logic so the Apollo cache key matches exactly:
 *
 * - spaceIds: tokens (@self, currentSpace()) and numeric IDs resolved
 *   synchronously. At preload time there is no current-space context so tokens
 *   are dropped (toLongIds with undefined currentSpaceId skips them).
 * - spaceKeys: human-readable keys (e.g. "ENG") passed directly to the AGG
 *   query for server-side resolution (InlineTasksByMetadata.spaceKeys).
 *
 * Falls back to the context spaceKey when no explicit spaces are provided,
 * mirroring the "current page's space" default used at runtime.
 */ const $20c66e73a45f79d8$var$resolveSpaceFilter = (spacesParam, contextSpaceKey)=>{
    if (spacesParam) {
        const parts = (0, $fzKPX.parseCommaSeparatedValues)(spacesParam) ?? [];
        const spaceIds = (0, $fzKPX.toLongIds)(parts, undefined);
        const spaceKeys = parts.filter((value)=>value !== (0, $fzKPX.CURRENT_SPACE_TOKEN) && value !== (0, $fzKPX.SELF_SPACE_TOKEN) && !/^\d+$/.test(value.startsWith('~') ? value.slice(1) : value));
        if (spaceIds.length || spaceKeys.length) return {
            spaceIds: spaceIds,
            spaceKeys: spaceKeys
        };
    }
    // Fall back to the current space from context when no explicit spaces provided.
    const contextSpaceId = Number.parseInt(contextSpaceKey, 10);
    if (!Number.isNaN(contextSpaceId)) return {
        spaceIds: [
            contextSpaceId
        ],
        spaceKeys: []
    };
    return {
        spaceIds: [],
        spaceKeys: []
    };
};
const $20c66e73a45f79d8$export$536478985aace428 = {
    extensionKey: 'tasks-report-macro',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
            if (!cloudId) return;
            const macroParams = node.attrs?.parameters?.macroParams;
            const params = (0, $rPmsQ.parseMacroParams)(macroParams);
            const { spaceIds: spaceIds, spaceKeys: spaceKeys } = $20c66e73a45f79d8$var$resolveSpaceFilter(params.spaces, context.spaceKey);
            if (!spaceIds.length && !spaceKeys.length) return;
            // Keep preload variables identical to runtime so Apollo cache keys match.
            const taskQuery = (0, $fzKPX.buildTaskQueryMetadata)(params, spaceIds, spaceKeys);
            await (0, $wPrRK.slowQueryGuard)('tasksReportPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $ei8Ok.GetTasksReportQuery),
                    variables: {
                        taskQuery: taskQuery,
                        cloudId: cloudId
                    },
                    context: {
                        single: true
                    },
                    __callerPackage__: "@confluence/preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["tasksReportPreloadHandler"] = $20c66e73a45f79d8$export$536478985aace428;

});

parcelRegister("ei8Ok", function(module, exports) {

var $hJ6Qq = parcelRequire("hJ6Qq");

const $fad24ea7634a5491$export$19eb1cc447563b7 = (0, $hJ6Qq.default);
module.exports["GetTasksReportQuery"] = $fad24ea7634a5491$export$19eb1cc447563b7;

});

parcelRegister("hJ6Qq", function(module, exports) {
/**
 * @generated SignedSource<<a175a783c54a1bbb11115609f78cee71>>
 * @relayHash 4257b78a458e32e70bf16869db78cf05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e3aa6ff5332eca65f4d3f98919099fe7dc36425d0f211fc86efcd38e6128e4c
const $711aa99d4bd43f06$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "taskQuery"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "tasksQuery",
            "variableName": "taskQuery"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "taskId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "kind": "ScalarField",
        "name": "dueAt"
    }, v7 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v8 = {
        "kind": "ScalarField",
        "name": "completedAt"
    }, v9 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v11 = {
        "concreteType": "GraphQLUserInfo",
        "kind": "LinkedField",
        "name": "assignedTo",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "profilePicture",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "path"
                    }
                ]
            }
        ]
    }, v12 = {
        "concreteType": "GraphQLUserInfo",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v13 = {
        "concreteType": "ConfluenceContentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "adf"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "pageId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "title"
    }, v17 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v18 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v19 = {
        "kind": "ScalarField",
        "name": "label"
    }, v20 = {
        "kind": "ScalarField",
        "name": "prefix"
    }, v21 = {
        "concreteType": "ConfluenceLabel",
        "kind": "LinkedField",
        "name": "labels",
        "plural": true,
        "selections": [
            v19 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "spaceId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "ConfluenceSpaceLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v17 /*: any*/ 
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "blogPostId"
    }, v24 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v25 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v26 = {
        "concreteType": "ConfluenceLabel",
        "kind": "LinkedField",
        "name": "labels",
        "plural": true,
        "selections": [
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v3 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GetTasksReportQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "InlineTasksQueryResult",
                    "kind": "LinkedField",
                    "name": "inlineTasks",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLInlineTask",
                            "kind": "LinkedField",
                            "name": "inlineTasks",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluencePage"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluenceBlogPost"
                                        }
                                    ]
                                }
                            ]
                        },
                        v25 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GetTasksReportQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "InlineTasksQueryResult",
                    "kind": "LinkedField",
                    "name": "inlineTasks",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLInlineTask",
                            "kind": "LinkedField",
                            "name": "inlineTasks",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluencePage"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluenceBlogPost"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        },
                        v25 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4257b78a458e32e70bf16869db78cf05",
            "id": "9e3aa6ff5332eca65f4d3f98919099fe7dc36425d0f211fc86efcd38e6128e4c",
            "metadata": {},
            "name": "GetTasksReportQuery",
            "operationKind": "query",
            "text": "query GetTasksReportQuery($taskQuery:InlineTasksByMetadata!,$cloudId:ID){inlineTasks(tasksQuery:$taskQuery,cloudId:$cloudId){inlineTasks{id,taskId,status,dueAt,createdAt,completedAt,assignedTo{accountId,displayName,profilePicture{path}},createdBy{accountId,displayName},body{adf},container{__typename,...on ConfluencePage{id,pageId,title,links{base,webUi},labels{label,prefix,id},space{id,spaceId,name,links{base,webUi}}},...on ConfluenceBlogPost{id,blogPostId,title,links{base,webUi},labels{label,prefix,id},space{id,spaceId,name,links{base,webUi}}},...on Node{__isNode:__typename,id}}},endCursor}}"
        }
    };
}();
$711aa99d4bd43f06$var$node.hash = "2b6c33814689e4cbcbd78fd4ed149156";
var $711aa99d4bd43f06$export$2e2bcd8739ae039 = $711aa99d4bd43f06$var$node;
module.exports["default"] = $711aa99d4bd43f06$export$2e2bcd8739ae039;

});

parcelRegister("rPmsQ", function(module, exports) {

var $bdzG7 = parcelRequire("bdzG7");

const $3b01e085cfcfbcb8$var$DEFAULT_PAGE_SIZE = 20;
const $3b01e085cfcfbcb8$var$DEFAULT_COLUMNS = [
    'description',
    'duedate',
    'assignee',
    'location'
];
const $3b01e085cfcfbcb8$var$VALID_COLUMNS = [
    'description',
    'duedate',
    'assignee',
    'location',
    'completedate',
    'labels'
];
const $3b01e085cfcfbcb8$var$VALID_COLUMNS_SET = new Set($3b01e085cfcfbcb8$var$VALID_COLUMNS);
function $3b01e085cfcfbcb8$var$parseColumns(raw) {
    if (!raw || typeof raw !== 'string') return $3b01e085cfcfbcb8$var$DEFAULT_COLUMNS;
    const parsed = [];
    const seen = new Set();
    const parts = raw.split(',');
    for (const part of parts){
        const c = part.trim().toLowerCase();
        if ($3b01e085cfcfbcb8$var$VALID_COLUMNS_SET.has(c) && !seen.has(c)) {
            seen.add(c);
            parsed.push(c);
        }
    }
    // If no valid columns were found at all, use the documented default set.
    // This covers the case where the user supplied only invalid column names —
    // without this guard, description would be unshifted below and the user
    // would get a single-column table instead of the four-column default.
    if (!parsed.length) return $3b01e085cfcfbcb8$var$DEFAULT_COLUMNS;
    // description is always present as the first column.
    if (!parsed.includes('description')) parsed.unshift('description');
    return parsed;
}
function $3b01e085cfcfbcb8$export$66770a7e7da42ecb(macroParams) {
    const raw = macroParams ?? {};
    const columns = $3b01e085cfcfbcb8$var$parseColumns(raw.columns?.value);
    const pageSize = parseInt(raw.pageSize?.value ?? '', 10) || $3b01e085cfcfbcb8$var$DEFAULT_PAGE_SIZE;
    const reverseSort = raw.reverseSort?.value === 'true' || raw.reverseSort?.value === true;
    const status = (0, $bdzG7.normalizeTasksReportStatus)(raw.status?.value);
    return {
        columns: columns,
        spaces: raw.spaces?.value || undefined,
        pages: raw.pages?.value || undefined,
        assignees: raw.assignees?.value || undefined,
        creators: raw.creators?.value || undefined,
        labels: raw.labels?.value || undefined,
        status: status,
        duedateFrom: raw.duedateFrom?.value ?? undefined,
        duedateTo: raw.duedateTo?.value ?? undefined,
        createddateFrom: raw.createddateFrom?.value ?? undefined,
        createddateTo: raw.createddateTo?.value ?? undefined,
        pageSize: pageSize,
        sortBy: raw.sortBy?.value || undefined,
        reverseSort: reverseSort
    };
}
module.exports["parseMacroParams"] = $3b01e085cfcfbcb8$export$66770a7e7da42ecb;

});

parcelRegister("bdzG7", function(module, exports) {
const $4338c3d1d9e19bac$export$2344a301308c0556 = {
    complete: 'CHECKED',
    incomplete: 'UNCHECKED'
};
const $4338c3d1d9e19bac$var$DEFAULT_STATUS = 'incomplete';
const $4338c3d1d9e19bac$var$STATUS_ALIASES = {
    complete: 'complete',
    completed: 'complete',
    checked: 'complete',
    incomplete: 'incomplete',
    unchecked: 'incomplete'
};
const $4338c3d1d9e19bac$export$d7a098da087f5881 = (rawStatus)=>{
    const normalizedStatus = rawStatus?.trim().toLowerCase();
    if (!normalizedStatus) return $4338c3d1d9e19bac$var$DEFAULT_STATUS;
    return $4338c3d1d9e19bac$var$STATUS_ALIASES[normalizedStatus] ?? $4338c3d1d9e19bac$var$DEFAULT_STATUS;
};
module.exports["STATUS_MAP"] = $4338c3d1d9e19bac$export$2344a301308c0556;
module.exports["normalizeTasksReportStatus"] = $4338c3d1d9e19bac$export$d7a098da087f5881;

});

parcelRegister("fzKPX", function(module, exports) {

var $iDL64 = parcelRequire("iDL64");


var $bdzG7 = parcelRequire("bdzG7");

const $0eff6d7450e12c55$export$2344a301308c0556 = (0, $bdzG7.STATUS_MAP);
const $0eff6d7450e12c55$export$b589e8bb676eddda = {
    duedate: 'DUE_DATE',
    assignee: 'ASSIGNEE',
    location: 'PAGE_TITLE'
};
const $0eff6d7450e12c55$export$15d71cf2c82ff427 = (value)=>{
    if (!value) return undefined;
    const raw = value.split(',');
    const result = [];
    for (const rawValue of raw){
        const trimmed = rawValue.trim();
        if (trimmed) result.push(trimmed);
    }
    return result.length ? result : undefined;
};
const $0eff6d7450e12c55$export$c080dece27bf09b3 = 'currentSpace()';
const $0eff6d7450e12c55$export$ecbdafc24a12ca0b = '@self';
const $0eff6d7450e12c55$export$4399bda962ab122b = (value)=>{
    const normalizedValue = value.startsWith('~') ? value.slice(1) : value;
    if (!/^\d+$/.test(normalizedValue)) return undefined;
    const parsedId = Number.parseInt(normalizedValue, 10);
    return Number.isNaN(parsedId) ? undefined : parsedId;
};
const $0eff6d7450e12c55$export$3d46c7941b830c2b = (values, currentSpaceId)=>{
    if (!values?.length) return [];
    const parsedIds = [];
    for (const value of values){
        if (value === $0eff6d7450e12c55$export$c080dece27bf09b3 || value === $0eff6d7450e12c55$export$ecbdafc24a12ca0b) {
            if (currentSpaceId !== undefined) parsedIds.push(currentSpaceId);
            continue;
        }
        const parsedId = $0eff6d7450e12c55$export$4399bda962ab122b(value);
        if (parsedId !== undefined) parsedIds.push(parsedId);
    }
    return parsedIds;
};
function $0eff6d7450e12c55$export$6042c1e6bdce848e(params, spaceIds, spaceKeys, after = null) {
    const requestedStatus = params.status;
    const mappedStatus = $0eff6d7450e12c55$export$2344a301308c0556[requestedStatus] ?? $0eff6d7450e12c55$export$2344a301308c0556.incomplete;
    const pageIds = $0eff6d7450e12c55$export$3d46c7941b830c2b($0eff6d7450e12c55$export$15d71cf2c82ff427(params.pages));
    const assigneeAccountIds = $0eff6d7450e12c55$export$15d71cf2c82ff427(params.assignees);
    const creatorAccountIds = $0eff6d7450e12c55$export$15d71cf2c82ff427(params.creators);
    const hasDueDate = params.duedateFrom != null || params.duedateTo != null;
    const hasCreatedDate = params.createddateFrom != null || params.createddateTo != null;
    // Only pass sortParameters for columns the server can sort — labels has no
    // server-side equivalent and falls back to the server's default order.
    const sortColumn = params.sortBy ? $0eff6d7450e12c55$export$b589e8bb676eddda[params.sortBy] ?? null : null;
    const dueDate = hasDueDate ? {
        startDate: (0, $iDL64.toEpoch)(params.duedateFrom),
        endDate: (0, $iDL64.toEpoch)(params.duedateTo)
    } : null;
    const createdDateRange = hasCreatedDate ? {
        startDate: (0, $iDL64.toEpoch)(params.createddateFrom),
        endDate: (0, $iDL64.toEpoch)(params.createddateTo)
    } : null;
    return {
        first: params.pageSize,
        after: after,
        spaceIds: spaceIds.length ? spaceIds : null,
        spaceKeys: spaceKeys.length ? spaceKeys : null,
        pageIds: pageIds.length ? pageIds : null,
        status: mappedStatus,
        accountIds: assigneeAccountIds?.length || creatorAccountIds?.length ? {
            assigneeAccountIds: assigneeAccountIds,
            creatorAccountIds: creatorAccountIds
        } : null,
        dueDate: dueDate,
        createdDateRange: createdDateRange,
        sortParameters: sortColumn ? {
            sortColumn: sortColumn,
            // Legacy macro semantics: reverseSort=false keeps default descending order,
            // reverseSort=true flips to ascending.
            sortOrder: params.reverseSort ? 'ASCENDING' : 'DESCENDING'
        } : null
    };
}
module.exports["parseCommaSeparatedValues"] = $0eff6d7450e12c55$export$15d71cf2c82ff427;
module.exports["CURRENT_SPACE_TOKEN"] = $0eff6d7450e12c55$export$c080dece27bf09b3;
module.exports["SELF_SPACE_TOKEN"] = $0eff6d7450e12c55$export$ecbdafc24a12ca0b;
module.exports["toLongIds"] = $0eff6d7450e12c55$export$3d46c7941b830c2b;
module.exports["buildTaskQueryMetadata"] = $0eff6d7450e12c55$export$6042c1e6bdce848e;

});

parcelRegister("iDL64", function(module, exports) {
const $774a0d79f8a73639$var$DAY_FIRST_DATE_PATTERN = /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/;
const $774a0d79f8a73639$var$parseDayFirstDate = (input)=>{
    const dayFirstMatch = input.match($774a0d79f8a73639$var$DAY_FIRST_DATE_PATTERN);
    if (!dayFirstMatch) return undefined;
    const day = Number.parseInt(dayFirstMatch[1], 10);
    const month = Number.parseInt(dayFirstMatch[2], 10);
    const year = Number.parseInt(dayFirstMatch[3], 10);
    if (day < 1 || day > 31 || month < 1 || month > 12) return undefined;
    const asUtcMidnight = Date.UTC(year, month - 1, day);
    const parsedDate = new Date(asUtcMidnight);
    return parsedDate.getUTCFullYear() === year && parsedDate.getUTCMonth() === month - 1 && parsedDate.getUTCDate() === day ? asUtcMidnight : undefined;
};
const $774a0d79f8a73639$export$373c6eac988f94dd = (value)=>{
    if (value == null) return undefined;
    if (typeof value === 'number') return Number.isNaN(value) ? undefined : value;
    const trimmed = value.trim();
    if (!trimmed) return undefined;
    const numeric = Number(trimmed);
    if (!Number.isNaN(numeric)) return numeric;
    // Date picker values are day-first calendar dates; parse explicitly to avoid
    // locale-dependent Date.parse swaps (e.g. 09/04 interpreted as Sep 4).
    if ($774a0d79f8a73639$var$DAY_FIRST_DATE_PATTERN.test(trimmed)) return $774a0d79f8a73639$var$parseDayFirstDate(trimmed);
    const parsed = Date.parse(trimmed);
    return Number.isNaN(parsed) ? undefined : parsed;
};
module.exports["toEpoch"] = $774a0d79f8a73639$export$373c6eac988f94dd;

});

parcelRegister("1i2qc", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $dYU3e = parcelRequire("dYU3e");


var $iTcHJ = parcelRequire("iTcHJ");


var $6IsMq = parcelRequire("6IsMq");

const $ab4965c7462ff107$export$86e2470edfebdc54 = async (issueAri)=>{
    const response = await (0, $dYU3e.queryAgg)({
        query: (0, $6IsMq.default),
        variables: {
            issueAri: issueAri,
            maxTokenLength: 65536
        },
        __callerPackage__: "@confluence/fabric-media-support"
    });
    return response;
};
const $ab4965c7462ff107$export$2d12daceb0197048 = async (contentId)=>{
    const response = await (0, $dYU3e.query)({
        query: (0, $iTcHJ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        __callerPackage__: "@confluence/fabric-media-support"
    });
    return response;
};
module.exports["preloadJiraMediaToken"] = $ab4965c7462ff107$export$86e2470edfebdc54;
module.exports["preloadMediaToken"] = $ab4965c7462ff107$export$2d12daceb0197048;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<5e736080ce8c5ab015a5851e0537f7fa>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<d76d95039bbf9cae17d368276aebc792>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("bS81H", function(module, exports) {
/**
 * @generated SignedSource<<523aa3ee46c59d410bd7627eb0f987ce>>
 * @relayHash 611f36fd3ab140915814f503f8503110
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8
const $5a2ebb253ede159a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentVersion"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentVersion",
                            "variableName": "contentVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "611f36fd3ab140915814f503f8503110",
            "id": "97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8",
            "metadata": {},
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersDSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
        }
    };
}();
$5a2ebb253ede159a$var$node.hash = "c488c053b9896d7e6d5b6c4474dd396b";
var $5a2ebb253ede159a$export$2e2bcd8739ae039 = $5a2ebb253ede159a$var$node;
module.exports["default"] = $5a2ebb253ede159a$export$2e2bcd8739ae039;

});

parcelRegister("axutP", function(module, exports) {
/**
 * @generated SignedSource<<471bd2d51696f1de1dc7d46b066715f5>>
 * @relayHash fa5b50f9c89692d4dd86caf1df42c2d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a
const $972689412971ec2f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabledOnContentView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fa5b50f9c89692d4dd86caf1df42c2d1",
            "id": "60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a",
            "metadata": {},
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!,$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey){isEnabledOnContentView}}"
        }
    };
}();
$972689412971ec2f$var$node.hash = "d0f958354cdf65029012c243a64d4874";
var $972689412971ec2f$export$2e2bcd8739ae039 = $972689412971ec2f$var$node;
module.exports["default"] = $972689412971ec2f$export$2e2bcd8739ae039;

});

parcelRegister("8CHHT", function(module, exports) {

var $9WAeG = parcelRequire("9WAeG");


var $xwvlW = parcelRequire("xwvlW");


var $3mugH = parcelRequire("3mugH");


var $7Sm4c = parcelRequire("7Sm4c");


var $6fil2 = parcelRequire("6fil2");


var $8n0y0 = parcelRequire("8n0y0");

const $23196774779b9db8$var$setWindowExtensions = (moduleType, extensions, error)=>{
    window.__SSR_FORGE_EXTENSIONS__ = window.__SSR_FORGE_EXTENSIONS__ || {};
    window.__SSR_FORGE_EXTENSIONS__[moduleType] = {
        extensions: extensions,
        error: error
    };
};
async function $23196774779b9db8$export$afb6180712276ba1({ contentId: contentId, spaceKey: spaceKey, moduleType: moduleType, includeHidden: includeHidden = false }) {
    const { cloudId: cloudId, locale: locale } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:ForgeExtensionList', async ()=>{
        try {
            const extensions = await (0, $8n0y0.preloadForgeApps)({
                cloudId: cloudId,
                locale: locale,
                types: [
                    moduleType
                ],
                context: {
                    spaceKey: spaceKey,
                    contentId: contentId != null ? Number(contentId) : undefined
                },
                includeHidden: includeHidden
            });
            if (extensions) $23196774779b9db8$var$setWindowExtensions(moduleType, extensions, undefined);
        } catch (e) {
            // Want to handle network errors to not affect experience SLA
            if ((0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
            else (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Filed to get forge extension list: ${e.message}`));
        }
    });
}
module.exports["preloadUseExtensionList"] = $23196774779b9db8$export$afb6180712276ba1;

});

parcelRegister("8n0y0", function(module, exports) {

var $klHST = parcelRequire("klHST");


var $8VYSW = parcelRequire("8VYSW");


var $dYU3e = parcelRequire("dYU3e");

// Inlined from platform/packages/forge/forge-ui/src/utils/createAtlAttributionHeader.ts
// (not available as a public entry point of @atlassian/forge-ui)
const $0469ff9a24207ab9$var$createAtlAttributionHeader = (workspaceAri)=>JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: 'forge-ui'
    });
const $0469ff9a24207ab9$export$e95a50d7f0e263b5 = async ({ cloudId: cloudId, locale: locale, types: types, context: context, includeHidden: includeHidden })=>{
    const { data: data } = await (0, $dYU3e.queryAgg)({
        query: (0, $klHST.default),
        // copied from platform/packages/forge/forge-ui/src/web-client/hooks/usePrefilteredExtensionList.ts:createUsePrefilteredExtensionListQueryOptions()
        variables: {
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden ?? false,
            types: types,
            locale: locale
        },
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': $0469ff9a24207ab9$var$createAtlAttributionHeader(cloudId)
            },
            allowOnExternalPage: true
        },
        __callerPackage__: "@confluence/forge-ui"
    });
    // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
    // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
module.exports["preloadForgeApps"] = $0469ff9a24207ab9$export$e95a50d7f0e263b5;

});

parcelRegister("klHST", function(module, exports) {
/**
 * @generated SignedSource<<f9ea6c5dc173397e0deec2c9c61e408d>>
 * @relayHash ed5f81a23070bbd7a269663fafbee425
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 208bb10d6151e8c79ff890f81580ca160b8daad9625597cd7e7540aeac36d728
const $8dbf49233d9310af$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ed5f81a23070bbd7a269663fafbee425",
            "id": "208bb10d6151e8c79ff890f81580ca160b8daad9625597cd7e7540aeac36d728",
            "metadata": {},
            "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
            "operationKind": "query",
            "text": "query preloadForgeApps_FetchPreFilteredForgeAppsQuery($cloudId:ID!,$context:ConfluenceExtensionRenderingContextInput,$includeHidden:Boolean,$locale:String,$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId,context:$context,includeHidden:$includeHidden,locale:$locale,types:$types){id,appId,appVersion,appOwner,environmentId,environmentType,environmentKey,consentUrl,migrationKey,userAccess{enabled,hasAccess},key,properties{key,value},egress{addresses,category,type,inScopeEUD},scopes,license{active,capabilitySet,billingPeriod,ccpEntitlementId,ccpEntitlementSlug,isEvaluation,subscriptionEndDate,trialEndDate,type},type,installationId,hiddenBy}}"
        }
    };
}();
$8dbf49233d9310af$var$node.hash = "d99aeaa2aa86bf313f505de4d4d482e6";
var $8dbf49233d9310af$export$2e2bcd8739ae039 = $8dbf49233d9310af$var$node;
module.exports["default"] = $8dbf49233d9310af$export$2e2bcd8739ae039;

});

parcelRegister("8VYSW", function(module, exports) {
parcelRequire("1c598");
var $2JC3k = parcelRequire("2JC3k");


var $dh538 = parcelRequire("dh538");

const $2303076e1c638c7b$var$legacyCache = new Map();
const $2303076e1c638c7b$var$extensionCache = new WeakMap();
const $2303076e1c638c7b$export$9ff84ea1b2ab439c = (extensions)=>{
    const extensionsIds = (extensions || []).map((ext)=>ext.id).join(',');
    if ((0, $dh538.fg)('forge-ui-add-hidden-by-to-extension-cache')) {
        if (!extensions || extensions.length === 0) return [];
        if ($2303076e1c638c7b$var$extensionCache.has(extensions)) return $2303076e1c638c7b$var$extensionCache.get(extensions);
    } else if ($2303076e1c638c7b$var$legacyCache.has(extensionsIds)) return $2303076e1c638c7b$var$legacyCache.get(extensionsIds);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (_error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $2303076e1c638c7b$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) {
        if (extensions && extensions.length > 0 && (0, $dh538.fg)('forge-ui-add-hidden-by-to-extension-cache')) $2303076e1c638c7b$var$extensionCache.set(extensions, result);
        else $2303076e1c638c7b$var$legacyCache.set(extensionsIds, result);
    }
    return result;
};
const $2303076e1c638c7b$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $2303076e1c638c7b$export$9ff84ea1b2ab439c;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "BitbucketExtension", () => (parcelRequire("2JC3k")).BitbucketExtension);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
const $d977f97374f9d2c9$export$586232a3e4271798 = {
    CUSTOM_MERGE_CHECK: 'bitbucket:mergeCheck',
    DYNAMIC_PIPELINES_PROVIDER: 'bitbucket:dynamicPipelinesProvider',
    REPOSITORY_CODE_FILE_VIEWER: 'bitbucket:repoCodeFileViewer',
    REPOSITORY_CODE_OVERVIEW_CARD: 'bitbucket:repoCodeOverviewCard',
    REPOSITORY_CODE_OVERVIEW_ACTION: 'bitbucket:repoCodeOverviewAction',
    REPOSITORY_CODE_OVERVIEW_PANEL: 'bitbucket:repoCodeOverviewPanel',
    REPOSITORY_PULL_REQUEST_CARD: 'bitbucket:repoPullRequestCard',
    REPOSITORY_PULL_REQUEST_ACTION: 'bitbucket:repoPullRequestAction',
    REPOSITORY_PULL_REQUEST_OVERVIEW_PANEL: 'bitbucket:repoPullRequestOverviewPanel',
    REPOSITORY_MAIN_MENU_PAGE: 'bitbucket:repoMainMenuPage',
    REPOSITORY_SETTINGS_MENU_PAGE: 'bitbucket:repoSettingsMenuPage',
    PROJECT_SETTINGS_MENU_PAGE: 'bitbucket:projectSettingsMenuPage',
    WORKSPACE_GLOBAL_PAGE: 'bitbucket:workspaceGlobalPage',
    WORKSPACE_PERSONAL_SETTINGS_PAGE: 'bitbucket:workspacePersonalSettingsPage',
    WORKSPACE_SETTINGS_MENU_PAGE: 'bitbucket:workspaceSettingsMenuPage'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;
module.exports["BitbucketExtension"] = $d977f97374f9d2c9$export$586232a3e4271798;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("e5EnV", function(module, exports) {
/**
 * @generated SignedSource<<19f88e77d3cfba146c135d602dcd850a>>
 * @relayHash 6cd75834f128f4e69b90e03b31603fd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12b9ea0b2a8549a655e6db18139e709c6bf2e6d45eff5ec0488c52b8b8309362
const $e4798d13ae2c4a75$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canBeSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RestrictedPageWithCanViewQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RestrictedPageWithCanViewQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "6cd75834f128f4e69b90e03b31603fd0",
            "id": "12b9ea0b2a8549a655e6db18139e709c6bf2e6d45eff5ec0488c52b8b8309362",
            "metadata": {},
            "name": "RestrictedPageWithCanViewQuery",
            "operationKind": "query",
            "text": "query RestrictedPageWithCanViewQuery($id:ID!){singleContent(id:$id){id,status,links{webui}},user:confluence_atlassianUser(current:true){id,confluence{roles{canBeSuperAdmin}}}}"
        }
    };
}();
$e4798d13ae2c4a75$var$node.hash = "cac9cbea2e6f98b7e3ef1e383776a339";
var $e4798d13ae2c4a75$export$2e2bcd8739ae039 = $e4798d13ae2c4a75$var$node;
module.exports["default"] = $e4798d13ae2c4a75$export$2e2bcd8739ae039;

});

parcelRegister("eDV4X", function(module, exports) {
const $e24dc53dc88ae3e8$export$3211963609921415 = [
    'current',
    'draft'
];
const $e24dc53dc88ae3e8$export$d7a13677648fb230 = 'edit-label-dialog-heading';
var $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CLEAR"] = "clear";
    ActionTypes["CREATE_OPTION"] = "create-option";
    ActionTypes["REMOVE_VALUE"] = "remove-value";
    ActionTypes["POP_VALUE"] = "pop-value";
    ActionTypes["SELECT_OPTION"] = "select-option";
    return ActionTypes;
}({});
const $e24dc53dc88ae3e8$export$cac90560d1a4fb86 = /[:;,.•?&[\]()#^*@!<>]/;
var $e24dc53dc88ae3e8$export$b9e669a853ca2f38 = /*#__PURE__*/ function(ContentTypes) {
    ContentTypes["TEMPLATE"] = "template";
    return ContentTypes;
}({});
module.exports["ALLOWED_CONTENT_STATUSES"] = $e24dc53dc88ae3e8$export$3211963609921415;
module.exports["ActionTypes"] = $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4;
module.exports["INVALID_CHARACTERS"] = $e24dc53dc88ae3e8$export$cac90560d1a4fb86;
module.exports["ContentTypes"] = $e24dc53dc88ae3e8$export$b9e669a853ca2f38;

});

parcelRegister("fD4xZ", function(module, exports) {
/**
 * @generated SignedSource<<b8dc89479d7a3088a7f646f9d65fbbbf>>
 * @relayHash c16bdfa077971f51c800aa53740cee17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90985f9063fa73aeab5db37248e435f944e233be152dae66ff279d8a899b3988
const $d6621697d90b85f7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "refetchQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "refetchQuery",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "targetType"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orderBy",
                                    "value": {
                                        "direction": "ASCENDING",
                                        "sortField": "LABELLING_CREATIONDATE"
                                    }
                                }
                            ],
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "Label",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "prefix"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsSelectPropsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsSelectPropsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c16bdfa077971f51c800aa53740cee17",
            "id": "90985f9063fa73aeab5db37248e435f944e233be152dae66ff279d8a899b3988",
            "metadata": {},
            "name": "useLabelsSelectPropsQuery",
            "operationKind": "query",
            "text": "query useLabelsSelectPropsQuery($contentId:ID!,$refetchQuery:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations@skip(if:$refetchQuery){operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}}}"
        }
    };
}();
$d6621697d90b85f7$var$node.hash = "8cab44d2cb7a98dca8bf5c892a415540";
var $d6621697d90b85f7$export$2e2bcd8739ae039 = $d6621697d90b85f7$var$node;
module.exports["default"] = $d6621697d90b85f7$export$2e2bcd8739ae039;

});

parcelRegister("9xoMO", function(module, exports) {

var $dBcar = parcelRequire("dBcar");


var $gxTpP = parcelRequire("gxTpP");


var $5cryL = parcelRequire("5cryL");


var $lohHj = parcelRequire("lohHj");


var $b4VFP = parcelRequire("b4VFP");


var $d282Z = parcelRequire("d282Z");


var $d0hiC = parcelRequire("d0hiC");


var $9DBk6 = parcelRequire("9DBk6");


var $isKLx = parcelRequire("isKLx");


var $1gy7x = parcelRequire("1gy7x");


var $h86CY = parcelRequire("h86CY");


var $jbYIt = parcelRequire("jbYIt");


var $ccGoc = parcelRequire("ccGoc");


var $eoU1C = parcelRequire("eoU1C");


var $2wUAJ = parcelRequire("2wUAJ");


var $6eN5W = parcelRequire("6eN5W");


var $kNKrY = parcelRequire("kNKrY");


var $lIcXr = parcelRequire("lIcXr");


var $bPDOf = parcelRequire("bPDOf");


var $eyUJP = parcelRequire("eyUJP");


var $eC276 = parcelRequire("eC276");


var $fsF73 = parcelRequire("fsF73");


var $bEwOV = parcelRequire("bEwOV");


var $gGieN = parcelRequire("gGieN");


var $exrKs = parcelRequire("exrKs");


var $i1J1l = parcelRequire("i1J1l");


var $iTy0f = parcelRequire("iTy0f");


var $8l6NF = parcelRequire("8l6NF");


var $iQzVo = parcelRequire("iQzVo");


var $4UYoK = parcelRequire("4UYoK");

const $af0fb818e1350632$export$1c433575c0d65d05 = [
    ...(0, $2wUAJ.StorageEnforcementOnboardingKeys),
    ...(0, $dBcar.OnboardingKeys),
    ...(0, $gxTpP.ContextualInviteNudgeOnboardingKeys),
    ...(0, $5cryL.EditorOnboardingKeys),
    ...(0, $d282Z.InsightsOnboardingKeys),
    ...(0, $isKLx.SpaceMissionControlOnboardingKeys),
    ...(0, $h86CY.PresenceAdminFeedbackSurveyOnboardingKeys),
    ...(0, $jbYIt.RoleBasedAccessControlOnboardingKeys),
    ...(0, $ccGoc.RovoVideoPlayerStateOnboardingKeys),
    ...(0, $eoU1C.ShareAndRestrictDialogOnboardingKeys),
    ...(0, $6eN5W.TrialComponentsOnboardingKeys),
    ...(0, $1gy7x.PersonalizedTemplatesOnboardingKeys),
    ...(0, $9DBk6.LiveDocsOnboardingKeys),
    ...(0, $b4VFP.HomeTakeoverOnboardingKeys),
    ...(0, $lohHj.FeedOnboardingKeys),
    ...(0, $d0hiC.LandInSpampleSpaceOnboardingKeys),
    ...(0, $kNKrY.CreateIntroFirstStepOnboardingStateKeys),
    ...(0, $lIcXr.NewContentHistoryOnboardingStateKeys),
    ...(0, $bPDOf.AIFCOnboardingKeys),
    ...(0, $eyUJP.NthUserHomeOnboardingRevampKeys),
    ...(0, $eC276.ExportJiraContextToPageTourKeys),
    ...(0, $fsF73.ConfluenceRecapOnboardingKeys),
    ...(0, $gGieN.SuggestWhiteboardBasedOnPageTitleOnboardingKeys),
    ...(0, $exrKs.SuggestSkillBasedOnPageTitleOnboardingKeys),
    ...(0, $i1J1l.SuggestAgentBasedOnPageTitleOnboardingKeys),
    ...(0, $bEwOV.SnippetsOnboardingKeys),
    ...(0, $iTy0f.SmartLinkDraggableOnboardingKeys),
    ...(0, $8l6NF.ChangeboardingAdminNavTourOnboardingKeys),
    ...(0, $iQzVo.Twcg1489ConnectorOnboardingKeys),
    ...(0, $4UYoK.UniversalCreateCwRExperimentSpotlightOnboardingKeys)
];
module.exports["OnboardingKeysCombined"] = $af0fb818e1350632$export$1c433575c0d65d05;

});

parcelRegister("gxTpP", function(module, exports) {
const $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab = {
    EXPERIMENT_ELIGIBLE_TAG: 'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    WAS_CONFETTI_SEEN: 'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen'
};
const $62a1556a5bf2ef38$export$fdbc8dd83db637ed = [
    ...Object.values($62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab)
];
module.exports["CONTEXTUAL_INVITE_NUDGE"] = $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab;
module.exports["ContextualInviteNudgeOnboardingKeys"] = $62a1556a5bf2ef38$export$fdbc8dd83db637ed;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("lohHj", function(module, exports) {
const $3f26c87821b680a5$export$215d0f9cb557eff8 = 'onboarding-popular-feed-card:isDismissed';
const $3f26c87821b680a5$export$84bf53f359485dfc = [
    $3f26c87821b680a5$export$215d0f9cb557eff8
];
module.exports["FeedOnboardingKeys"] = $3f26c87821b680a5$export$84bf53f359485dfc;

});

parcelRegister("b4VFP", function(module, exports) {
const $390e454b1ae488b2$export$1d1c13df264a094 = {
    hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
    isHomeNudgeScheduledAt: 'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
    onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
    isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
    hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
    hasDismissedCarousel: 'home-onboarding-takeover-v2:hasDismissedCarousel',
    hasDismissedLearningResources: 'home-onboarding-takeover-v2:hasDismissedLearningResources',
    hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover'
};
const $390e454b1ae488b2$export$3392b5b28b589b00 = Object.values($390e454b1ae488b2$export$1d1c13df264a094);
module.exports["HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS"] = $390e454b1ae488b2$export$1d1c13df264a094;
module.exports["HomeTakeoverOnboardingKeys"] = $390e454b1ae488b2$export$3392b5b28b589b00;

});

parcelRegister("d282Z", function(module, exports) {
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen',
    AUDIO_V3_CHANGEBOARDING: 'onboarding-insights:hasAudioV3ChangeboardingBeenSeen'
};
const $a18eeb1d05dccc62$export$fac0a92023e58acd = [
    ...Object.values($a18eeb1d05dccc62$export$fc9b2402bb5adac2)
];
module.exports["ONBOARDING_INSIGHTS"] = $a18eeb1d05dccc62$export$fc9b2402bb5adac2;
module.exports["InsightsOnboardingKeys"] = $a18eeb1d05dccc62$export$fac0a92023e58acd;

});

parcelRegister("d0hiC", function(module, exports) {
const $fd31f36c9d251c72$export$3b7e7c8d78a4b783 = {
    hasDismissedBanner: 'land-in-sample-space:hasDismissedBanner',
    hasSeenSampleContentFlag: 'land-in-sample-space:hasSeenSampleContentFlag'
};
const $fd31f36c9d251c72$export$12692b0da4497e60 = [
    ...Object.values($fd31f36c9d251c72$export$3b7e7c8d78a4b783)
];
module.exports["LandInSpampleSpaceOnboardingKeys"] = $fd31f36c9d251c72$export$12692b0da4497e60;

});

parcelRegister("9DBk6", function(module, exports) {
const $d9e19a0d44ee3302$export$b02e3be205ee7739 = {
    LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN: 'live-page-nudge:wasLivePageNudgeSeen',
    // used to limit calls to the invite permissions API
    LIVE_PAGE_INVITE_INELIGIBLE: 'live-page-nudge:livePageNudgeInviteIneligible'
};
const $d9e19a0d44ee3302$export$b3d9533dbdf35d0 = [
    ...Object.values($d9e19a0d44ee3302$export$b02e3be205ee7739)
];
module.exports["LIVE_PAGE_NUDGE"] = $d9e19a0d44ee3302$export$b02e3be205ee7739;
module.exports["LiveDocsOnboardingKeys"] = $d9e19a0d44ee3302$export$b3d9533dbdf35d0;

});

parcelRegister("isKLx", function(module, exports) {
const $d14f8037089c8dc2$export$92d46364e5595a5a = {
    SPACE_SETTINGS_CHANGEBOARDING_FIRST_SEEN_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingFirstSeenAt',
    SPACE_SETTINGS_CHANGEBOARDING_DISMISSED_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingDismissedAt'
};
const $d14f8037089c8dc2$export$d9eb44525b9507f7 = [
    ...Object.values($d14f8037089c8dc2$export$92d46364e5595a5a)
];
module.exports["SpaceMissionControlOnboardingKeys"] = $d14f8037089c8dc2$export$d9eb44525b9507f7;

});

parcelRegister("1gy7x", function(module, exports) {
const $071869849092e495$export$d8593f7ef284bfd8 = {
    onboardingActionStates: 'personalized-templates-v2:onboardingActionStates',
    hasDismissedOnboardingActions: 'personalized-templates-v2:hasDismissedOnboardingActions',
    takeoverSeenAt: 'personalized-templates-v2:takeoverSeenAt',
    isTemplateListDismissed: 'personalized-templates-v2:isTemplateListDismissed',
    templateUsageValues: 'personalized-templates-v2:templateUsageValues'
};
const $071869849092e495$export$67c979693bf8551b = [
    ...Object.values($071869849092e495$export$d8593f7ef284bfd8)
];
module.exports["PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS"] = $071869849092e495$export$d8593f7ef284bfd8;
module.exports["PersonalizedTemplatesOnboardingKeys"] = $071869849092e495$export$67c979693bf8551b;

});

parcelRegister("h86CY", function(module, exports) {
const $1dd4a0157170f997$export$f8474b3e5d170456 = {
    PRESENCE_ADMIN_FEEDBACK_SEEN: 'presence-feedback-survey:hasAdminSeenFeedbackSurvey'
};
const $1dd4a0157170f997$export$dcc0ca03f6f8c68d = [
    ...Object.values($1dd4a0157170f997$export$f8474b3e5d170456)
];
module.exports["ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS"] = $1dd4a0157170f997$export$f8474b3e5d170456;
module.exports["PresenceAdminFeedbackSurveyOnboardingKeys"] = $1dd4a0157170f997$export$dcc0ca03f6f8c68d;

});

parcelRegister("jbYIt", function(module, exports) {
const $15e5f1cf9df2e13c$export$67837434b2dea54f = {
    USERS_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:usersTableSpotlightSeen',
    DEFAULTS_ROLE_TABLE_MODAL_SEEN: 'RoleBasedAccessControl:defaultsRoleTableModalSeen',
    PRODUCT_ADMIN_MODAL_SEEN: 'RoleBasedAccessControl:productAdminModalSeen',
    DEFAULT_ROLE_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:defaultRoleTableSpotlightSeen',
    CUSTOM_ROLE_PAGE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:customRolePageSpotlightSeen'
};
const $15e5f1cf9df2e13c$export$134f165f9f20f01c = [
    ...Object.values($15e5f1cf9df2e13c$export$67837434b2dea54f)
];
module.exports["ONBOARDING_ROLE_BASED_ACCESS_CONTROL"] = $15e5f1cf9df2e13c$export$67837434b2dea54f;
module.exports["RoleBasedAccessControlOnboardingKeys"] = $15e5f1cf9df2e13c$export$134f165f9f20f01c;

});

parcelRegister("ccGoc", function(module, exports) {
const $1acbcc6f3166a324$export$fa80c824b7402d9f = {
    ROVO_VIDEO_PLAYER_SEEN: 'onboarding-rovo-video-player:rovoVideoPlayerSeen'
};
const $1acbcc6f3166a324$export$d42bdf2f6333fafd = [
    ...Object.values($1acbcc6f3166a324$export$fa80c824b7402d9f)
];
module.exports["RovoVideoPlayerStateOnboardingKeys"] = $1acbcc6f3166a324$export$d42bdf2f6333fafd;

});

parcelRegister("eoU1C", function(module, exports) {
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};
const $b3332cb66ea1a913$export$e5c211f9c9c7792f = [
    ...Object.values($b3332cb66ea1a913$export$7f1c6b461c54348b)
];
module.exports["ONBOARDING_SHARE_AND_RESTRICT_DIALOG"] = $b3332cb66ea1a913$export$7f1c6b461c54348b;
module.exports["ShareAndRestrictDialogOnboardingKeys"] = $b3332cb66ea1a913$export$e5c211f9c9c7792f;

});

parcelRegister("2wUAJ", function(module, exports) {
const $70d55b678e14166c$export$13e578b1c1856d6f = {
    FLAGS_DISMISSED_FREE_THRESHOLD: 'storage-enforcement-state:flagsDismissedFreeThreshold'
};
const $70d55b678e14166c$export$abe3d9e5b5171ebf = [
    ...Object.values($70d55b678e14166c$export$13e578b1c1856d6f)
];
module.exports["STORAGE_ENFORCEMENT_STATE_KEYS"] = $70d55b678e14166c$export$13e578b1c1856d6f;
module.exports["StorageEnforcementOnboardingKeys"] = $70d55b678e14166c$export$abe3d9e5b5171ebf;

});

parcelRegister("6eN5W", function(module, exports) {
const $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f = {
    ACTION_MENU_OPENED: 'trial-components:actionMenuOpened',
    TRIAL_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial1DayFlag',
    TRIAL_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial3DayFlag',
    GRACE_PERIOD_0_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning0DayFlag',
    GRACE_PERIOD_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning1DayFlag',
    GRACE_PERIOD_2_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning2DayFlag',
    GRACE_PERIOD_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning3DayFlag',
    TRIAL_UNHANDLED_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrialUnhandledDayFlag'
};
const $e04ddb4a5df5bba6$export$8001dc7a7ed753e1 = [
    ...Object.values($e04ddb4a5df5bba6$export$840dd6f6c8ecd45f)
];
module.exports["TRIAL_COMPONENTS_EXPERIENCES"] = $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f;
module.exports["TrialComponentsOnboardingKeys"] = $e04ddb4a5df5bba6$export$8001dc7a7ed753e1;

});

parcelRegister("kNKrY", function(module, exports) {
const $9b3060c835515c41$export$ff14eab135fe9584 = {
    headerSeenAt: 'create-intro-first-step:headerSeenAt',
    headerCompleted: 'create-intro-first-step:headerCompleted',
    headerDismissed: 'create-intro-first-step:headerDismissed'
};
const $9b3060c835515c41$export$1c0fd29b58a87c97 = [
    ...Object.values($9b3060c835515c41$export$ff14eab135fe9584)
];
module.exports["CreateIntroFirstStepOnboardingStateKeys"] = $9b3060c835515c41$export$1c0fd29b58a87c97;

});

parcelRegister("lIcXr", function(module, exports) {
const $06a9ae8b05df4a8c$export$561442d092b808c6 = {
    HAS_SEEN_SPOTLIGHT: 'new-content-history-onboarding:hasSeenSpotlight1'
};
const $06a9ae8b05df4a8c$export$a8854c7bde991ac7 = [
    ...Object.values($06a9ae8b05df4a8c$export$561442d092b808c6)
];
module.exports["NEW_CONTENT_HISTORY_ONBOARDING_STATE_KEYS"] = $06a9ae8b05df4a8c$export$561442d092b808c6;
module.exports["NewContentHistoryOnboardingStateKeys"] = $06a9ae8b05df4a8c$export$a8854c7bde991ac7;

});

parcelRegister("eyUJP", function(module, exports) {
const $37b72543ace58c19$export$a266d7c13575e674 = {
    onboardingActionStates: 'nth-user-home-onboarding-revamp:onboardingActionStates',
    areAllActionsDismissed: 'nth-user-home-onboarding-revamp:areAllActionsDismissed',
    takeoverSeenAt: 'nth-user-home-onboarding-revamp:takeoverSeenAt',
    isTemplateListDismissed: 'nth-user-home-onboarding-revamp:isTemplateListDismissed',
    templateUsageValues: 'nth-user-home-onboarding-revamp:templateUsageValues'
};
const $37b72543ace58c19$export$f9348e90ce13bd50 = [
    ...Object.values($37b72543ace58c19$export$a266d7c13575e674)
];
module.exports["NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS"] = $37b72543ace58c19$export$a266d7c13575e674;
module.exports["NthUserHomeOnboardingRevampKeys"] = $37b72543ace58c19$export$f9348e90ce13bd50;

});

parcelRegister("eC276", function(module, exports) {
const $6acee6b0894846a1$export$fe11c6170169891b = {
    TOUR_COMPLETED: 'random:ExportJiraContextToPage:tourCompleted',
    TOUR_DISMISSED: 'random:ExportJiraContextToPage:tourDismissed'
};
const $6acee6b0894846a1$export$7eebc92289f9ff40 = [
    ...Object.values($6acee6b0894846a1$export$fe11c6170169891b)
];
module.exports["ExportJiraContextToPageTourKeys"] = $6acee6b0894846a1$export$7eebc92289f9ff40;

});

parcelRegister("fsF73", function(module, exports) {
const $29520d740d888926$export$84bb2ff8e52d4c63 = {
    HAS_SEEN_PUBLISH_SPOTLIGHT: 'confluence-recap:hasSeenPublishSpotlight'
};
const $29520d740d888926$export$42e96b8eba35eec9 = [
    ...Object.values($29520d740d888926$export$84bb2ff8e52d4c63)
];
module.exports["CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS"] = $29520d740d888926$export$84bb2ff8e52d4c63;
module.exports["ConfluenceRecapOnboardingKeys"] = $29520d740d888926$export$42e96b8eba35eec9;

});

parcelRegister("bEwOV", function(module, exports) {
const $91bce0a19c17c87b$export$608e762b0e8c3e5d = {
    HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL: 'snippets:hasSeenFirstSnippetCreatedModal',
    HAS_SEEN_SNIPPETS_TAB_SPOTLIGHT: 'snippets:hasSeenSnippetsTabSpotlight'
};
const $91bce0a19c17c87b$export$cf7ec9d4d7075704 = [
    ...Object.values($91bce0a19c17c87b$export$608e762b0e8c3e5d)
];
module.exports["SNIPPETS_ONBOARDING"] = $91bce0a19c17c87b$export$608e762b0e8c3e5d;
module.exports["SnippetsOnboardingKeys"] = $91bce0a19c17c87b$export$cf7ec9d4d7075704;

});

parcelRegister("gGieN", function(module, exports) {
const $24bab03e25b23f73$export$df82485048e605d4 = {
    hasDismissedFlowChart: 'suggest-whiteboard-based-on-page-title:hasDismissedFlowChart',
    hasDismissedBrainstorming: 'suggest-whiteboard-based-on-page-title:hasDismissedBrainstorming',
    hasDismissedRetro: 'suggest-whiteboard-based-on-page-title:hasDismissedRetro',
    hasDismissedProductRoadmap: 'suggest-whiteboard-based-on-page-title:hasDismissedProductRoadmap',
    hasDismissedPrioritizationMatrix: 'suggest-whiteboard-based-on-page-title:hasDismissedPrioritizationMatrix',
    hasDismissedOrgChart: 'suggest-whiteboard-based-on-page-title:hasDismissedOrgChart',
    hasDismissedStickyNotePack: 'suggest-whiteboard-based-on-page-title:hasDismissedStickyNotePack',
    hasDismissedAllTemplateSuggestions: 'suggest-whiteboard-based-on-page-title:hasDismissedAllTemplateSuggestions'
};
const $24bab03e25b23f73$export$70c9c230d84d75ef = [
    ...Object.values($24bab03e25b23f73$export$df82485048e605d4)
];
module.exports["SUGGEST_WHITEBOARD_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS"] = $24bab03e25b23f73$export$df82485048e605d4;
module.exports["SuggestWhiteboardBasedOnPageTitleOnboardingKeys"] = $24bab03e25b23f73$export$70c9c230d84d75ef;

});

parcelRegister("exrKs", function(module, exports) {
const $0be47723f71ecf5a$export$68726aa6479c32ea = {
    hasDismissedWritePrd: 'suggest-skill-based-on-page-title:hasDismissedWritePrd',
    hasDismissedWriteHowToArticle: 'suggest-skill-based-on-page-title:hasDismissedWriteHowToArticle',
    hasDismissedResearchInsights: 'suggest-skill-based-on-page-title:hasDismissedResearchInsights',
    hasDismissedCreateActionPlan: 'suggest-skill-based-on-page-title:hasDismissedCreateActionPlan',
    hasDismissedAllSkillSuggestions: 'suggest-skill-based-on-page-title:hasDismissedAllSkillSuggestions'
};
const $0be47723f71ecf5a$export$fde582fc9946f220 = [
    ...Object.values($0be47723f71ecf5a$export$68726aa6479c32ea)
];
module.exports["SUGGEST_SKILL_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS"] = $0be47723f71ecf5a$export$68726aa6479c32ea;
module.exports["SuggestSkillBasedOnPageTitleOnboardingKeys"] = $0be47723f71ecf5a$export$fde582fc9946f220;

});

parcelRegister("i1J1l", function(module, exports) {
const $2942cd38c2776ad9$export$589fce97fb79e61b = {
    // Planner
    hasDismissedPlannerOnce: 'suggest-agent-based-on-page-title:hasDismissedPlannerOnce',
    hasDismissedPlannerPermanently: 'suggest-agent-based-on-page-title:hasDismissedPlannerPermanently',
    hasDismissedDiscoveryAndFeedbackOnce: 'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackOnce',
    hasDismissedDiscoveryAndFeedbackPermanently: 'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackPermanently'
};
const $2942cd38c2776ad9$export$ecbd342637c16a8a = [
    ...Object.values($2942cd38c2776ad9$export$589fce97fb79e61b)
];
const $2942cd38c2776ad9$export$d3824c57be9dc0d6 = [
    $2942cd38c2776ad9$export$589fce97fb79e61b.hasDismissedPlannerPermanently,
    $2942cd38c2776ad9$export$589fce97fb79e61b.hasDismissedDiscoveryAndFeedbackPermanently
];
module.exports["SUGGEST_AGENT_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS"] = $2942cd38c2776ad9$export$589fce97fb79e61b;
module.exports["SuggestAgentBasedOnPageTitleOnboardingKeys"] = $2942cd38c2776ad9$export$ecbd342637c16a8a;

});

parcelRegister("iTy0f", function(module, exports) {
const $f4695f4ca31fd51c$export$a6cb5d34cb10fc27 = {
    CHANGEBOARD_VIEWED: 'smart-link-draggable:changeboardViewed'
};
const $f4695f4ca31fd51c$export$1a93287f12972b73 = Object.values($f4695f4ca31fd51c$export$a6cb5d34cb10fc27);
module.exports["SmartLinkDraggableOnboardingKeys"] = $f4695f4ca31fd51c$export$1a93287f12972b73;

});

parcelRegister("8l6NF", function(module, exports) {
/**
 * Onboarding-state keys for the admin-nav changeboarding tour. The tour is a
 * 3-step popover walkthrough shown to product admins the first time they
 * land on Confluence Admin after the RBAC admin modernization experiment
 * ships.
 */ const $aa5a5848fd75f53d$export$85befb6401d118b0 = {
    TOUR_SEEN: 'changeboarding-admin-nav-tour:tourSeen'
};
const $aa5a5848fd75f53d$export$d48b7123660bbab = [
    $aa5a5848fd75f53d$export$85befb6401d118b0.TOUR_SEEN
];
module.exports["CHANGEBOARDING_ADMIN_NAV_TOUR"] = $aa5a5848fd75f53d$export$85befb6401d118b0;
module.exports["ChangeboardingAdminNavTourOnboardingKeys"] = $aa5a5848fd75f53d$export$d48b7123660bbab;

});

parcelRegister("4UYoK", function(module, exports) {
/**
 * Onboarding-state keys for the spotlight that is anchored to the Universal
 * Create menu dropdown shown the first time a user in the Universal Create
 * (CwR) experiment cohort opens the create menu.
 */ const $88afb75838a9f8b5$export$134ea9981ab0c82e = {
    hasSeenUniversalCreateCwRExperimentSpotlight: 'universal-create-cwr-experiment-spotlight:hasSeenUniversalCreateCwRExperimentSpotlight'
};
const $88afb75838a9f8b5$export$5b55ba0fa31f0184 = [
    ...Object.values($88afb75838a9f8b5$export$134ea9981ab0c82e)
];
module.exports["UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS"] = $88afb75838a9f8b5$export$134ea9981ab0c82e;
module.exports["UniversalCreateCwRExperimentSpotlightOnboardingKeys"] = $88afb75838a9f8b5$export$5b55ba0fa31f0184;

});

parcelRegister("1k2r8", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $8Z78B = parcelRequire("8Z78B");

const $2daa64592339f2ce$export$ce5c629ae8376218 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
module.exports["preloadAllOnboardingState"] = $2daa64592339f2ce$export$ce5c629ae8376218;

});

parcelRegister("cRQNp", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $j25oo = parcelRequire("j25oo");

function $345f814d0887da7c$export$8301c585ee328ce0({ contentId: contentId, includeContentBody: includeContentBody = true, status: status, useCache: useCache }) {
    return (0, $dYU3e.query)({
        query: (0, $j25oo.default),
        variables: {
            contentId: contentId,
            includeContentBody: includeContentBody,
            status: status
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/read-time"
    });
}
module.exports["preloadReadTime"] = $345f814d0887da7c$export$8301c585ee328ce0;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<b0ed3f943392beb78acd9d9ea9b42788>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("80xNa", function(module, exports) {
const $5d488939c8bec967$export$21191b0c00ca25f4 = 4;
const $5d488939c8bec967$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $5d488939c8bec967$export$21191b0c00ca25f4;
module.exports["CONFLUENCE_EDITION"] = $5d488939c8bec967$export$4b915fb24c39b396;

});

parcelRegister("aqBZ0", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("ccWUN", function(module, exports) {
/**
 * @generated SignedSource<<e6d58d53d7d7da22616845f438faea90>>
 * @relayHash 3fac23e69ad72cef246c33b6b22b24bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 977d9e099882e8a74d82099a73a8a2401956aa3722a387c1dad0080809f1647f
const $462dea7d21a073f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "concreteType": "ArchivedContentMetadata",
        "kind": "LinkedField",
        "name": "archivedContentMetadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "archiveNote"
            }
        ]
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "KnownUser"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "UnknownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3fac23e69ad72cef246c33b6b22b24bc",
            "id": "977d9e099882e8a74d82099a73a8a2401956aa3722a387c1dad0080809f1647f",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}}"
        }
    };
}();
$462dea7d21a073f6$var$node.hash = "e569274206c06e3436e0c3de5c5fe595";
var $462dea7d21a073f6$export$2e2bcd8739ae039 = $462dea7d21a073f6$var$node;
module.exports["default"] = $462dea7d21a073f6$export$2e2bcd8739ae039;

});

parcelRegister("gFF2G", function(module, exports) {
/**
 * @generated SignedSource<<b09412736b8beecddca9546c0e2759d4>>
 * @relayHash 30a7ec0bd1bc84739eda7e4fe244b93f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d
const $385b63e5393fb4b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "30a7ec0bd1bc84739eda7e4fe244b93f",
            "id": "0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerContainerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$385b63e5393fb4b0$var$node.hash = "c639141edd782146ad296893dc79f146";
var $385b63e5393fb4b0$export$2e2bcd8739ae039 = $385b63e5393fb4b0$var$node;
module.exports["default"] = $385b63e5393fb4b0$export$2e2bcd8739ae039;

});

parcelRegister("4trRg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $flWvL = parcelRequire("flWvL");


var $joyRP = parcelRequire("joyRP");

const $b51af1b6a5dfb3b5$export$79f4fda3b987b044 = ({ contentId: contentId, isDraft: isDraft, useCache: useCache = false, isArchived: isArchived })=>{
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    return (0, $dYU3e.query)({
        query: (0, $joyRP.default),
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/editor-content-mode-button"
    });
};
module.exports["preloadContentMode"] = $b51af1b6a5dfb3b5$export$79f4fda3b987b044;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<11e8316517ac59e0b0326a7aa3a855c6>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("gad6U", function(module, exports) {
/**
 * @generated SignedSource<<c2d774a48c90fa70a24cdb1130a0d5d5>>
 * @relayHash 05121d91dabaeb1256fcb9012d73ba65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c83d09eb0de6a3bf710d7364431c8200591175f07d8ff8317f01a5255ea13554
const $ad449ae2ccc67b2c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    v5 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v10 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAudioContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                }
                            ]
                        },
                        v10 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAudioContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        },
                        v10 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "05121d91dabaeb1256fcb9012d73ba65",
            "id": "c83d09eb0de6a3bf710d7364431c8200591175f07d8ff8317f01a5255ea13554",
            "metadata": {},
            "name": "useAudioContentQuery",
            "operationKind": "query",
            "text": "query useAudioContentQuery($contentId:ID!){singleContent(id:$contentId){id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}}"
        }
    };
}();
$ad449ae2ccc67b2c$var$node.hash = "a697f593a36975591a0fa8257ca3e174";
var $ad449ae2ccc67b2c$export$2e2bcd8739ae039 = $ad449ae2ccc67b2c$var$node;
module.exports["default"] = $ad449ae2ccc67b2c$export$2e2bcd8739ae039;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<d41b8ab1bc70378bccaecb11f1842520>>
 * @relayHash c50470fc6bc0e84b4717fcf5627e7f88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe3af76fba4d01c8e3439953c8be2b197bbbc43b2a587eda294290284494d155
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalsBetaFeatures"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "success"
    }, v11 = {
        "kind": "ScalarField",
        "name": "message"
    }, v12 = {
        "kind": "ScalarField",
        "name": "principalType"
    }, v13 = {
        "kind": "ScalarField",
        "name": "principalId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v16 = {
        "kind": "ScalarField",
        "name": "value"
    }, v17 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v18 = [
        v7 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v17 /*: any*/ 
            ]
        }
    ], v19 = {
        "condition": "includeApprovalsBetaFeatures",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v9 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "filterSelf",
                        "value": false
                    },
                    {
                        "kind": "Variable",
                        "name": "spaceKey",
                        "variableName": "spaceKey"
                    }
                ],
                "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSpaceSettingConfig",
                "plural": false,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "concreteType": "MutationError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v11 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "disallowFirstPublish"
                            },
                            {
                                "concreteType": "ConfluenceApprovalReviewerConfig",
                                "kind": "LinkedField",
                                "name": "enforcedApprovalReviewerConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isEnabled"
                                    },
                                    {
                                        "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUser",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v18 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v20 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "status"
    }, v22 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v23 = {
        "args": [
            v9 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v24 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v25 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v26 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v27 = [
        v9 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v28 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v29 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v30 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v28 /*: any*/ ,
                    v29 /*: any*/ 
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v32 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v31 /*: any*/ 
        ]
    }, v33 = [
        v9 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v34 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v35 = [
        v16 /*: any*/ 
    ], v36 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v15 /*: any*/ ,
            v34 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v18 /*: any*/ 
            }
        ]
    }, v37 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            v31 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "condition": "includeApprovalsBetaFeatures",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": v35 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            v34 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v35 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v7 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    v16 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v38 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v28 /*: any*/ ,
                    v29 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v7 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v8 /*: any*/ ,
                v19 /*: any*/ ,
                {
                    "args": v20 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v27 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v30 /*: any*/ ,
                        v32 /*: any*/ 
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v30 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v8 /*: any*/ ,
                v19 /*: any*/ ,
                {
                    "args": v20 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v27 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v38 /*: any*/ ,
                        v32 /*: any*/ 
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v38 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c50470fc6bc0e84b4717fcf5627e7f88",
            "id": "fe3af76fba4d01c8e3439953c8be2b197bbbc43b2a587eda294290284494d155",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "3c810d34d21302717dacb9909603a7d3";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<217ed72306ad0003c83611da9b9dfec7>>
 * @relayHash 02343eb4ab11fc6471bc117cd9c349d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "02343eb4ab11fc6471bc117cd9c349d2",
            "id": "2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "e2a3c90b94181436fe0a32faafb92cf6";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("d3OVq", function(module, exports) {
/**
 * @generated SignedSource<<a13cd2a1d29aae2129c9a2a32580afb2>>
 * @relayHash 08655b5a07a80d6db6123fa2b954538c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a03e95f43b1257f84130aca2fcbdeff6cdf7b832e117cacf3d0b825870beb22
const $49f91628ee52d08c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "width"
    }, v5 = {
        "kind": "ScalarField",
        "name": "height"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "concreteType": "MapOfStringToString",
        "kind": "LinkedField",
        "name": "hoverOrFocus",
        "plural": true,
        "selections": v6 /*: any*/ 
    }, v8 = {
        "kind": "ScalarField",
        "name": "color"
    }, v9 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v10 = [
        v9 /*: any*/ ,
        v8 /*: any*/ 
    ], v11 = [
        v8 /*: any*/ ,
        v7 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "background"
    }, v13 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v14 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v15 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v16 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v18 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v19 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v20 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v21 = [
        v12 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "padding"
        },
        {
            "kind": "ScalarField",
            "name": "borderRadius"
        }
    ], v22 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                },
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isDefault"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "SpaceSettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "routeOverrideEnabled"
                                }
                            ]
                        },
                        {
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "theme",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "themeKey"
                                }
                            ]
                        },
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "headings",
                                    "plural": true,
                                    "selections": v6 /*: any*/ 
                                },
                                {
                                    "concreteType": "MenusLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "menus",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "HeaderLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "header",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "ButtonLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "button",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "NavigationLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "primaryNavigation",
                                            "plural": false,
                                            "selections": v11 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "NavigationLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "secondaryNavigation",
                                            "plural": false,
                                            "selections": v11 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "SearchFieldLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "search",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ScreenLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "screen",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "LayerScreenLookAndFeel",
                                                    "kind": "LinkedField",
                                                    "name": "layer",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterTop"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterRight"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterBottom"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterLeft"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "container",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "header",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "body",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "SpaceMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "prefix"
                                                },
                                                v3 /*: any*/ ,
                                                v1 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceBaseQueryBaseQuery",
            "selections": v22 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceBaseQueryBaseQuery",
            "selections": v22 /*: any*/ 
        },
        "params": {
            "cacheID": "08655b5a07a80d6db6123fa2b954538c",
            "id": "6a03e95f43b1257f84130aca2fcbdeff6cdf7b832e117cacf3d0b825870beb22",
            "metadata": {},
            "name": "useSpaceBaseQueryBaseQuery",
            "operationKind": "query",
            "text": "query useSpaceBaseQueryBaseQuery($spaceKey:String){spaces(spaceKey:$spaceKey){nodes{id,key,alias,name,homepage{id},icon{path,width,height,isDefault},type,settings{routeOverrideEnabled},theme{themeKey},lookAndFeel{headings{key,value},menus{hoverOrFocus{key,value},color},header{backgroundColor,button{backgroundColor,color},primaryNavigation{color,hoverOrFocus{key,value}},secondaryNavigation{color,hoverOrFocus{key,value}},search{backgroundColor,color}},content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius},header{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius},body{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},metadata{labels{nodes{prefix,name,id}}},operations{operation,targetType}}}}"
        }
    };
}();
$49f91628ee52d08c$var$node.hash = "e885d5c349d4cf19afe686a9f6747925";
var $49f91628ee52d08c$export$2e2bcd8739ae039 = $49f91628ee52d08c$var$node;
module.exports["default"] = $49f91628ee52d08c$export$2e2bcd8739ae039;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
const $4eb170397cdf11a9$export$5522fe3493552101 = [
    'current',
    'draft'
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("ixL26", function(module, exports) {
/**
 * @generated SignedSource<<fbb30a8834043aa8efe95e491818e212>>
 * @relayHash d6be154debcc9cc4834278390fc53126
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b
const $0d2a1fbf3179ce94$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeOperations"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "condition": "excludeOperations",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceOverviewQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceOverviewQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "d6be154debcc9cc4834278390fc53126",
            "id": "2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b",
            "metadata": {},
            "name": "SpaceOverviewQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewQuery($spaceKey:String!,$excludeOperations:Boolean!){space(key:$spaceKey){id,currentUser{isAdmin},name,type,theme{themeKey},icon{path},homepage{id,operations@skip(if:$excludeOperations){operation},properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}"
        }
    };
}();
$0d2a1fbf3179ce94$var$node.hash = "800c4a5e07b722b2b0e454947ac55f3c";
var $0d2a1fbf3179ce94$export$2e2bcd8739ae039 = $0d2a1fbf3179ce94$var$node;
module.exports["default"] = $0d2a1fbf3179ce94$export$2e2bcd8739ae039;

});

parcelRegister("3hHGU", function(module, exports) {
/**
 * @generated SignedSource<<97883e4f3341dc8eee867b0d2022b8b6>>
 * @relayHash 167c1a5fbdbb53604f3f562e570f1f91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030
const $02fb880a65c09e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "isPinned"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceSmartSpaceOverview",
            "kind": "LinkedField",
            "name": "confluence_smartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewSummary",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "body"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewFAQ",
                    "kind": "LinkedField",
                    "name": "faq",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewFAQEntry",
                            "kind": "LinkedField",
                            "name": "entries",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "question"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "answer"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "followUpQuestions"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewFAQSource",
                                    "kind": "LinkedField",
                                    "name": "sources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "excerpt"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "embeddedProduct"
                                                },
                                                {
                                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webui"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                    "kind": "LinkedField",
                    "name": "topLinks",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastRefreshed"
                        },
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "167c1a5fbdbb53604f3f562e570f1f91",
            "id": "9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030",
            "metadata": {},
            "name": "SpaceOverviewSwitcherQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewSwitcherQuery($cloudId:ID!,$spaceKey:String!){confluence_smartSpaceOverview(cloudId:$cloudId,spaceKey:$spaceKey){summary{body,isPinned},faq{entries{question,answer,followUpQuestions,sources{content{id,title,excerpt,embeddedProduct,links{webui}}}}},topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}"
        }
    };
}();
$02fb880a65c09e36$var$node.hash = "1b64f396256f01419c73a81884314905";
var $02fb880a65c09e36$export$2e2bcd8739ae039 = $02fb880a65c09e36$var$node;
module.exports["default"] = $02fb880a65c09e36$export$2e2bcd8739ae039;

});

parcelRegister("jpSPX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $cEgMD = parcelRequire("cEgMD");


var $8Psje = parcelRequire("8Psje");

const $d271b30f20f80b69$export$bb12d233342ab079 = ({ spaceKey: spaceKey, isRovoEnabled: isRovoEnabled, cloudId: cloudId })=>Boolean(cloudId) && !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && !(0, $8Psje.isRovoSystemSpaceKey)(spaceKey) && isRovoEnabled && (0, $6mKj3.expVal)('smart_space_overview', 'isEnabled', false);
module.exports["isSmartSpaceOverviewEnabled"] = $d271b30f20f80b69$export$bb12d233342ab079;

});

parcelRegister("8Psje", function(module, exports) {
const $5c0c9a15440579bc$export$fb74cd09fc20f0c3 = (spaceKey)=>{
    if (!spaceKey) return false;
    return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
module.exports["isRovoSystemSpaceKey"] = $5c0c9a15440579bc$export$fb74cd09fc20f0c3;

});

parcelRegister("d5h4f", function(module, exports) {
/**
 * @generated SignedSource<<c66496c25cb521f876dac5a42fd2fcd2>>
 * @relayHash 237b04f22d9b44361b6e9b7436f12aa7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 995bea55a94fd3b763d25f287ae43c4506bba32bd0abef2bf4de024e2ba46bf9
const $9de934dc3b27501e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentVersion"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "referenceId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "hasRestrictions"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
    }, v10 = {
        "kind": "ScalarField",
        "name": "hasInheritedRestrictions"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "kind": "ScalarField",
        "name": "type"
    }, v14 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v4 /*: any*/ ,
            v13 /*: any*/ ,
            v6 /*: any*/ ,
            v15 /*: any*/ 
        ]
    }, v17 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "value"
    }, v19 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "import-source",
                    "imported-page-modified-date"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v12 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"import-source\",\"imported-page-modified-date\"])"
    }, v20 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v21 = {
        "kind": "InlineFragment",
        "selections": v20 /*: any*/ ,
        "type": "KnownUser"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": v20 /*: any*/ ,
        "type": "UnknownUser"
    }, v23 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v24 = [
        v4 /*: any*/ 
    ], v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 10
            },
            v23 /*: any*/ 
        ],
        "concreteType": "PaginatedSpaceList",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": false,
        "selections": [
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    v11 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "homepage",
                        "plural": false,
                        "selections": v24 /*: any*/ 
                    }
                ]
            }
        ]
    }, v26 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": v24 /*: any*/ 
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v27 = {
        "args": v3 /*: any*/ ,
        "kind": "ScalarField",
        "name": "paywallStatus"
    }, v28 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v29 = [
        v28 /*: any*/ 
    ], v30 = {
        "args": v29 /*: any*/ ,
        "concreteType": "CanvasToken",
        "kind": "LinkedField",
        "name": "canvasToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "token"
            }
        ]
    }, v31 = [
        v18 /*: any*/ 
    ], v32 = {
        "args": v29 /*: any*/ ,
        "concreteType": "ContentMediaSession",
        "kind": "LinkedField",
        "name": "contentMediaSession",
        "plural": false,
        "selections": [
            {
                "concreteType": "MediaAccessTokens",
                "kind": "LinkedField",
                "name": "accessTokens",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MediaToken",
                        "kind": "LinkedField",
                        "name": "readOnlyToken",
                        "plural": false,
                        "selections": v31 /*: any*/ 
                    },
                    {
                        "concreteType": "MediaToken",
                        "kind": "LinkedField",
                        "name": "readWriteToken",
                        "plural": false,
                        "selections": v31 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "MediaConfiguration",
                "kind": "LinkedField",
                "name": "configuration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fileStoreUrl"
                    }
                ]
            }
        ]
    }, v33 = [
        {
            "kind": "ScalarField",
            "name": "isEntitled"
        }
    ], v34 = {
        "concreteType": "Entitlements",
        "kind": "LinkedField",
        "name": "entitlements",
        "plural": false,
        "selections": [
            {
                "concreteType": "WhiteboardFeatures",
                "kind": "LinkedField",
                "name": "whiteboardFeatures",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SmartConnectorsFeature",
                        "kind": "LinkedField",
                        "name": "smartConnectors",
                        "plural": false,
                        "selections": v33 /*: any*/ 
                    },
                    {
                        "concreteType": "SmartSectionsFeature",
                        "kind": "LinkedField",
                        "name": "smartSections",
                        "plural": false,
                        "selections": v33 /*: any*/ 
                    }
                ]
            }
        ]
    }, v35 = {
        "kind": "Literal",
        "name": "contentStatus",
        "value": "CURRENT"
    }, v36 = {
        "kind": "Variable",
        "name": "contentVersion",
        "variableName": "contentVersion"
    }, v37 = [
        {
            "kind": "ScalarField",
            "name": "allowed"
        }
    ], v38 = {
        "concreteType": "Confluence_dataSecurityPolicy",
        "kind": "LinkedField",
        "name": "dataSecurityPolicy",
        "plural": false,
        "selections": [
            {
                "alias": "isExportAllowed",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "action",
                        "value": "PAGE_EXPORT"
                    },
                    v28 /*: any*/ ,
                    v35 /*: any*/ ,
                    v36 /*: any*/ ,
                    v23 /*: any*/ 
                ],
                "concreteType": "DataSecurityPolicyDecision",
                "kind": "LinkedField",
                "name": "isActionEnabledForContent",
                "plural": false,
                "selections": v37 /*: any*/ 
            },
            {
                "alias": "isDownloadAllowed",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "action",
                        "value": "ATTACHMENT_DOWNLOAD"
                    },
                    v28 /*: any*/ ,
                    v35 /*: any*/ ,
                    v36 /*: any*/ ,
                    v23 /*: any*/ 
                ],
                "concreteType": "DataSecurityPolicyDecision",
                "kind": "LinkedField",
                "name": "isActionEnabledForContent",
                "plural": false,
                "selections": v37 /*: any*/ 
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WhiteboardUnifiedQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v14 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v30 /*: any*/ ,
                v32 /*: any*/ ,
                v34 /*: any*/ ,
                v38 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WhiteboardUnifiedQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v14 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v30 /*: any*/ ,
                v32 /*: any*/ ,
                v34 /*: any*/ ,
                v38 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "237b04f22d9b44361b6e9b7436f12aa7",
            "id": "995bea55a94fd3b763d25f287ae43c4506bba32bd0abef2bf4de024e2ba46bf9",
            "metadata": {},
            "name": "WhiteboardUnifiedQuery",
            "operationKind": "query",
            "text": "query WhiteboardUnifiedQuery($contentId:ID!,$spaceKey:String,$contentVersion:Int!){content(id:$contentId){nodes{id,referenceId,title,operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status},metadata{currentuser{favourited{isFavourite}},lastModifiedDate},properties(keys:[\"import-source\",\"imported-page-modified-date\"]){nodes{key,value}},history{createdBy{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,confluence{space{id}}},paywallStatus(id:$contentId),canvasToken(contentId:$contentId){token},contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl}},entitlements{whiteboardFeatures{smartConnectors{isEntitled},smartSections{isEntitled}}},dataSecurityPolicy{isExportAllowed:isActionEnabledForContent(action:PAGE_EXPORT,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed},isDownloadAllowed:isActionEnabledForContent(action:ATTACHMENT_DOWNLOAD,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed}}}"
        }
    };
}();
$9de934dc3b27501e$var$node.hash = "3a27147e54d7dc7fee56b195174180ed";
var $9de934dc3b27501e$export$2e2bcd8739ae039 = $9de934dc3b27501e$var$node;
module.exports["default"] = $9de934dc3b27501e$export$2e2bcd8739ae039;

});

parcelRegister("kwaj3", function(module, exports) {
/**
 * @generated SignedSource<<82a5121e796d7d88be54dc18b0c66612>>
 * @relayHash 7a46b279c61b3080707b64c6f2a92e47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f9ec01d56a841624c18f4cc3a1a96a06f53f806043d4f21f968b593c8ea5b1c7
const $80d237b89b6ac744$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7a46b279c61b3080707b64c6f2a92e47",
            "id": "f9ec01d56a841624c18f4cc3a1a96a06f53f806043d4f21f968b593c8ea5b1c7",
            "metadata": {},
            "name": "SpaceQuery",
            "operationKind": "query",
            "text": "query SpaceQuery($spaceKey:String){space(key:$spaceKey){id,name,icon{path},homepage{id}}}"
        }
    };
}();
$80d237b89b6ac744$var$node.hash = "6eceb4fc897c8a684e865776c35134e0";
var $80d237b89b6ac744$export$2e2bcd8739ae039 = $80d237b89b6ac744$var$node;
module.exports["default"] = $80d237b89b6ac744$export$2e2bcd8739ae039;

});

parcelRegister("bcVE2", function(module, exports) {
const $234cfa339ee54346$var$isQueryParamPresent = (value)=>Array.isArray(value) ? value.length > 0 : Boolean(value);
const $234cfa339ee54346$export$ca840bf5ed4ee034 = ({ parentProduct: parentProduct, presentationMode: presentationMode })=>$234cfa339ee54346$var$isQueryParamPresent(parentProduct) || $234cfa339ee54346$var$isQueryParamPresent(presentationMode);
module.exports["isEmbeddedWhiteboardMode"] = $234cfa339ee54346$export$ca840bf5ed4ee034;

});

parcelRegister("c7BJC", function(module, exports) {
/**
 * @generated SignedSource<<7480b5813e71e947657f66416e8eb77e>>
 * @relayHash 3d5107055d0ad5e5fed0e694feb80f1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5acb81487b5b5127dead4c25a310545e5437aad4717ee4c6f1d7a5a5a6c6614e
const $0040230a36fc338e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentVersion"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v9 = [
        v3 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v11 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v12 = {
        "kind": "Literal",
        "name": "contentStatus",
        "value": "CURRENT"
    }, v13 = {
        "kind": "Variable",
        "name": "contentVersion",
        "variableName": "contentVersion"
    }, v14 = [
        {
            "kind": "ScalarField",
            "name": "allowed"
        }
    ], v15 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "referenceId"
                        },
                        v4 /*: any*/ ,
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasViewRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasInheritedRestrictions"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v6 /*: any*/ ,
                                v4 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                },
                v8 /*: any*/ 
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": v9 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v10 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "locale"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": v9 /*: any*/ 
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "alias": "isExportAllowed",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "action",
                            "value": "PAGE_EXPORT"
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "isDownloadAllowed",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "action",
                            "value": "ATTACHMENT_DOWNLOAD"
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "DatabaseContainerQuery",
            "selections": v15 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "DatabaseContainerQuery",
            "selections": v15 /*: any*/ 
        },
        "params": {
            "cacheID": "3d5107055d0ad5e5fed0e694feb80f1c",
            "id": "5acb81487b5b5127dead4c25a310545e5437aad4717ee4c6f1d7a5a5a6c6614e",
            "metadata": {},
            "name": "DatabaseContainerQuery",
            "operationKind": "query",
            "text": "query DatabaseContainerQuery($contentId:ID!,$spaceKey:String,$contentVersion:Int!){content(id:$contentId){nodes{id,referenceId,title,operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status}}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},emails{value,isPrimary},locale,confluence{space{id}}},dataSecurityPolicy{isExportAllowed:isActionEnabledForContent(action:PAGE_EXPORT,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed},isDownloadAllowed:isActionEnabledForContent(action:ATTACHMENT_DOWNLOAD,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed}}}"
        }
    };
}();
$0040230a36fc338e$var$node.hash = "7a60e16be16d4c46e03e2f2d23d9dc89";
var $0040230a36fc338e$export$2e2bcd8739ae039 = $0040230a36fc338e$var$node;
module.exports["default"] = $0040230a36fc338e$export$2e2bcd8739ae039;

});

parcelRegister("1TElT", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $5DJsZ = parcelRequire("5DJsZ");

const $0272cf4ae0232c26$export$a9fe7043b42a1476 = (contentId, draftShareId, useCache)=>{
    return (0, $dYU3e.query)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/emoji-title"
    });
};
module.exports["preloadEmojiTitle"] = $0272cf4ae0232c26$export$a9fe7043b42a1476;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<8b96b7ca504d956e62c9a3c7888eb72c>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("65pdw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lC6Qd = parcelRequire("lC6Qd");

function $4e9d3c2f55d09139$export$cca2a63dd6cc6345(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $lC6Qd.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: draftShareId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/page-cover-picture"
    });
}
module.exports["preloadEditorPageCoverPicture"] = $4e9d3c2f55d09139$export$cca2a63dd6cc6345;

});

parcelRegister("lC6Qd", function(module, exports) {
/**
 * @generated SignedSource<<809e2044c3792f08e4a1f1fd3c386e1c>>
 * @relayHash eca6e9d325c97f4fd5880178ecc63561
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d
const $03de5ecc01e321ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "eca6e9d325c97f4fd5880178ecc63561",
            "id": "e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d",
            "metadata": {},
            "name": "CoverPictureQuery",
            "operationKind": "query",
            "text": "query CoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$03de5ecc01e321ee$var$node.hash = "cbe85309884dfe8220661d705f977e0f";
var $03de5ecc01e321ee$export$2e2bcd8739ae039 = $03de5ecc01e321ee$var$node;
module.exports["default"] = $03de5ecc01e321ee$export$2e2bcd8739ae039;

});

parcelRegister("4TRDb", function(module, exports) {
/**
 * @generated SignedSource<<08bbdfb732a0e903037634e82b2cebab>>
 * @relayHash c0a7532c77f00a6d3db89afbba6c2124
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e3afe4be4952ff1385de921ea89e96ad689b38bd27c628e4ceacc511c99519eb
const $027763ba95a6da42$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "atlas_doc_format",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreatePageEditorDataWrapperComponentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreatePageEditorDataWrapperComponentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c0a7532c77f00a6d3db89afbba6c2124",
            "id": "e3afe4be4952ff1385de921ea89e96ad689b38bd27c628e4ceacc511c99519eb",
            "metadata": {},
            "name": "SmartCreatePageEditorDataWrapperComponentQuery",
            "operationKind": "query",
            "text": "query SmartCreatePageEditorDataWrapperComponentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\"]){nodes{id,title,body{atlas_doc_format{value}},space{id,key,alias}}}}"
        }
    };
}();
$027763ba95a6da42$var$node.hash = "1aa5e1f3fdc665522f842f14ed2e0264";
var $027763ba95a6da42$export$2e2bcd8739ae039 = $027763ba95a6da42$var$node;
module.exports["default"] = $027763ba95a6da42$export$2e2bcd8739ae039;

});

parcelRegister("a2zQR", function(module, exports) {
/**
 * @generated SignedSource<<e77ba13c86de7ab0ec90d72e14a5eba1>>
 * @relayHash 3674404876fb671e57a7bc564c9498dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d9d6149ee0dc2a6f69d42a3b799534977c79ae87426c615721176aadbe34bd6
const $fbc22293d57aa8f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = [
        v1 /*: any*/ 
    ], v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedUrl"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasViewRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasInheritedRestrictions"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v4 /*: any*/ ,
                                v2 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "embeddedProduct"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EmbedContainerQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EmbedContainerQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "3674404876fb671e57a7bc564c9498dc",
            "id": "5d9d6149ee0dc2a6f69d42a3b799534977c79ae87426c615721176aadbe34bd6",
            "metadata": {},
            "name": "EmbedContainerQuery",
            "operationKind": "query",
            "text": "query EmbedContainerQuery($contentId:ID!,$spaceKey:String!){content(id:$contentId){nodes{id,title,metadata{frontend{embedUrl},currentuser{favourited{isFavourite}}},operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status},embeddedProduct}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,confluence{space{id}}}}"
        }
    };
}();
$fbc22293d57aa8f6$var$node.hash = "93be96607102ab4e689586d3195128e3";
var $fbc22293d57aa8f6$export$2e2bcd8739ae039 = $fbc22293d57aa8f6$var$node;
module.exports["default"] = $fbc22293d57aa8f6$export$2e2bcd8739ae039;

});

parcelRegister("cvj7x", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $65pdw = parcelRequire("65pdw");


var $1TElT = parcelRequire("1TElT");


var $3cpum = parcelRequire("3cpum");


var $7PLO8 = parcelRequire("7PLO8");


var $irrTO = parcelRequire("irrTO");


var $9sGCn = parcelRequire("9sGCn");


var $4trRg = parcelRequire("4trRg");

parcelRequire("kGDoD");
var $9nGwZ = parcelRequire("9nGwZ");


var $1c0dB = parcelRequire("1c0dB");


var $kDt9L = parcelRequire("kDt9L");


var $4vyfK = parcelRequire("4vyfK");


var $cRQNp = parcelRequire("cRQNp");


var $eSLr0 = parcelRequire("eSLr0");


var $8CHHT = parcelRequire("8CHHT");


var $7Ndnw = parcelRequire("7Ndnw");


var $lyWac = parcelRequire("lyWac");


var $fqIt3 = parcelRequire("fqIt3");


var $7K6Nt = parcelRequire("7K6Nt");


var $9OYfw = parcelRequire("9OYfw");


var $hr9NW = parcelRequire("hr9NW");

const $c13994d6914d469f$var$logger = (0, $7W8i8.getLogger)('load-edit-page');
async function $c13994d6914d469f$export$1149cf9041c3e7b8({ spaceKey: spaceKey, contentId: contentId, shouldPreloadMentionsProvider: shouldPreloadMentionsProvider = false, useCache: useCache = false, catchFn: // use cache for native editor data
catchFn, isBlog: isBlog, cloudId: cloudId, isLivePage: isLivePage = false }) {
    // note: explicitly casting to Promise<any> to avoid typescript incorrectly inferring tuple types; although we don't use the return value of this function regardless
    $c13994d6914d469f$var$logger.debug`Calling preloadEditorData ${performance.now() / 1000}`;
    const draftShareId = (0, $7PLO8.getDraftShareIdFromQueryParam)();
    // preload queries shared by Synchrony and Native Collab editors
    const immediateResultsPromises = [
        (0, $irrTO.preloadDraftContentAppearance)(contentId, useCache)
    ];
    // specific native collab editor queries
    if (!!contentId) {
        if ((0, $6mKj3.expValEquals)('web_item_query_batch_content_call', 'isEnabled', true)) {
            const editorToolbarLocations = isLivePage ? [
                (0, $eSLr0.TOOLS_MENU_CONTAINER),
                (0, $eSLr0.PAGE_BUTTONS),
                (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS)
            ] : [
                (0, $eSLr0.TOOLS_MENU_CONTAINER),
                (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS)
            ];
            immediateResultsPromises.push((0, $4vyfK.preloadWebItemLocation)({
                contentId: contentId,
                location: editorToolbarLocations
            }));
        }
        const collabDraftPromise = (0, $9OYfw.preloadCollabDraftContent)(contentId, draftShareId, (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? useCache || !(0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId) : useCache);
        immediateResultsPromises.push(collabDraftPromise);
        immediateResultsPromises.push((0, $7K6Nt.preloadMacroDataFromCollabDraft)({
            collabDraftPromise: collabDraftPromise,
            context: {
                contentId: contentId,
                spaceKey: spaceKey || ''
            },
            route: isLivePage ? 'live' : 'edit'
        }));
        immediateResultsPromises.push((0, $hr9NW.preloadEditorNodeDataProvidersData)(contentId, cloudId, isBlog));
        const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId ?? undefined);
        immediateResultsPromises.push((0, $4trRg.preloadContentMode)({
            contentId: contentId,
            isDraft: !isLivePage,
            useCache: useCache,
            isArchived: isArchived
        }));
        immediateResultsPromises.push((0, $1TElT.preloadEmojiTitle)(contentId, draftShareId, useCache), (0, $9OYfw.preloadNativeCollab)(contentId, draftShareId, useCache));
    }
    immediateResultsPromises.push((0, $65pdw.preloadEditorPageCoverPicture)(contentId, draftShareId, useCache), (0, $3cpum.preloadEditorContentState)({
        contentId: contentId,
        useCache: useCache,
        shouldGetDraftVersion: !isLivePage
    }));
    if (isLivePage) {
        // Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
        immediateResultsPromises.push((0, $4vyfK.preloadWebItemLocation)({
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        }), // For some reason the addition of the filter (uses new Forge query) is causing SSR to timeout - workaround by skipping the filter
        (0, $8CHHT.preloadUseExtensionList)({
            spaceKey: spaceKey || '',
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
        }));
        immediateResultsPromises.push((0, $9nGwZ.preloadLastUpdated)(contentId, useCache));
        immediateResultsPromises.push((0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            useCache: useCache
        }));
    }
    if (shouldPreloadMentionsProvider) immediateResultsPromises.push((0, $kDt9L.preloadMentionsProvider)());
    immediateResultsPromises.push((0, $1c0dB.preloadEditorPageTitleContentProperties)({
        contentId: contentId,
        draftShareId: draftShareId,
        useCache: useCache
    }));
    await (0, $lyWac.waitForAllReturnWhenError)(immediateResultsPromises.map((p)=>!!catchFn ? p?.catch(catchFn) : p));
    $c13994d6914d469f$var$logger.debug`preloadEditorData complete ${performance.now() / 1000}`;
}
module.exports["preloadEditorData"] = $c13994d6914d469f$export$1149cf9041c3e7b8;

});

parcelRegister("3cpum", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $3lWl0 = parcelRequire("3lWl0");

function $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0({ contentId: contentId, useCache: useCache, shouldGetDraftVersion: shouldGetDraftVersion }) {
    return (0, $dYU3e.query)({
        query: (0, $3lWl0.default),
        variables: {
            contentId: contentId,
            isDraft: shouldGetDraftVersion,
            shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? false : shouldGetDraftVersion,
            isApprovalsFgOn: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            format: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? 'MILLIS' : 'USER_FRIENDLY'
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/content-state"
    });
}
module.exports["preloadEditorContentState"] = $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<f94631fe88bfaea1f9346228f17314d1>>
 * @relayHash e78f45ef84b0309b46cad2982bdd129a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipAvailableContentStates"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipEditOnlyFields"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "color"
    }, v11 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "shouldSkipEditOnlyFields",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCallerPermitted"
                                }
                            ]
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "shouldSkipAvailableContentStates",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "AvailableContentStates",
                    "kind": "LinkedField",
                    "name": "availableContentStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "customContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "spaceContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e78f45ef84b0309b46cad2982bdd129a",
            "id": "d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!,$shouldSkipAvailableContentStates:Boolean=false,$shouldSkipEditOnlyFields:Boolean=false){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted@skip(if:$shouldSkipEditOnlyFields),lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId)@skip(if:$shouldSkipAvailableContentStates){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "f76426744ff28f16601d3ae4d51a17fb";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/content-appearance"
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("kGDoD", function(module, exports) {
$parcel$export(module.exports, "preloadLastUpdated", () => (parcelRequire("9nGwZ")).preloadLastUpdated);

var $9nGwZ = parcelRequire("9nGwZ");


var $9BupY = parcelRequire("9BupY");


});

parcelRegister("9nGwZ", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9BupY = parcelRequire("9BupY");

function $693a95aca15bff58$export$e7a15421d1327843(contentId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $9BupY.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/content-header"
    });
}
module.exports["preloadLastUpdated"] = $693a95aca15bff58$export$e7a15421d1327843;

});

parcelRegister("9BupY", function(module, exports) {
/**
 * @generated SignedSource<<6cd69bb600740f6a687eaabe82eab755>>
 * @relayHash 596c33f2627461693b923b812b6e225f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6f2f69ce739ced471a1cd1301a6cc419fb9a9219690e4c2e066d590fc835235
const $173882722a7c2e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "when"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LivePagesByLineLastUpdatedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LivePagesByLineLastUpdatedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "596c33f2627461693b923b812b6e225f",
            "id": "a6f2f69ce739ced471a1cd1301a6cc419fb9a9219690e4c2e066d590fc835235",
            "metadata": {},
            "name": "LivePagesByLineLastUpdatedQuery",
            "operationKind": "query",
            "text": "query LivePagesByLineLastUpdatedQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,version{friendlyWhen,when}}}}"
        }
    };
}();
$173882722a7c2e36$var$node.hash = "4e6df5756d13dcdcef29e05d538280a7";
var $173882722a7c2e36$export$2e2bcd8739ae039 = $173882722a7c2e36$var$node;
module.exports["default"] = $173882722a7c2e36$export$2e2bcd8739ae039;

});

parcelRegister("1c0dB", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $kae7O = parcelRequire("kae7O");

const $cb49cba09ddc32ea$export$2ea86854c75d3ec8 = async ({ contentId: contentId, draftShareId: draftShareId, useCache: useCache })=>{
    const variables = {
        contentId: contentId,
        status: [
            'current',
            'draft',
            'archived'
        ],
        draftShareId: draftShareId,
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    };
    return (0, $dYU3e.query)({
        query: (0, $kae7O.default),
        variables: variables,
        __callerPackage__: "@confluence/content-topper"
    });
};
module.exports["preloadEditorPageTitleContentProperties"] = $cb49cba09ddc32ea$export$2ea86854c75d3ec8;

});

parcelRegister("kae7O", function(module, exports) {
/**
 * @generated SignedSource<<235e2f4f1cae802c5b7683463fdf34f9>>
 * @relayHash 177df4e8b836b390b9636d650c93a7b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612
const $99e3ac9ccccf9f94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "177df4e8b836b390b9636d650c93a7b2",
            "id": "73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612",
            "metadata": {},
            "name": "useTitleContentPropertiesForEditorQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForEditorQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$99e3ac9ccccf9f94$var$node.hash = "cdd7743e3348e4dc97a35c6808323ae0";
var $99e3ac9ccccf9f94$export$2e2bcd8739ae039 = $99e3ac9ccccf9f94$var$node;
module.exports["default"] = $99e3ac9ccccf9f94$export$2e2bcd8739ae039;

});

parcelRegister("kDt9L", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $dYU3e = parcelRequire("dYU3e");


var $89CKS = parcelRequire("89CKS");

const $6bd71bdc26599ad9$export$45c648ba9bf4e12f = async ()=>(0, $dYU3e.query)({
        query: (0, $89CKS.default),
        __callerPackage__: "@confluence/fabric-media-support"
    });
module.exports["preloadMentionsProvider"] = $6bd71bdc26599ad9$export$45c648ba9bf4e12f;

});

parcelRegister("fqIt3", function(module, exports) {
const $3014a7cdda499b2d$var$collabDraftFetchTimestamps = new Map();
// TTL for CollabDraftQuery cached data
// This prevents stale data during SPA transitions while still allowing
// cache-first for SSR-rendered pages within the TTL window
const $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS = 15000;
/**
 * Creates a composite cache key that includes both contentId and draftShareId.
 * This aligns with how Apollo caches queries by their variables.
 */ const $3014a7cdda499b2d$var$getCacheKey = (contentId, draftShareId)=>{
    return `${contentId}:${draftShareId || ''}`;
};
function $3014a7cdda499b2d$export$76901333d647261(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    const lastFetchTime = $3014a7cdda499b2d$var$collabDraftFetchTimestamps.get(key);
    if (!lastFetchTime) return true;
    return Date.now() - lastFetchTime > $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS;
}
function $3014a7cdda499b2d$export$85437e97168f99bc(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.set(key, Date.now());
}
function $3014a7cdda499b2d$export$5f725cb33e7218ab(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.delete(key);
}
function $3014a7cdda499b2d$export$a379bfa68f31645e() {
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.clear();
}
module.exports["isCollabDraftCacheStale"] = $3014a7cdda499b2d$export$76901333d647261;
module.exports["markCollabDraftFetched"] = $3014a7cdda499b2d$export$85437e97168f99bc;
module.exports["clearCollabDraftTimestamp"] = $3014a7cdda499b2d$export$5f725cb33e7218ab;

});

parcelRegister("9OYfw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $l1kdf = parcelRequire("l1kdf");


var $nIvaQ = parcelRequire("nIvaQ");


var $8R0gj = parcelRequire("8R0gj");


var $hNtOj = parcelRequire("hNtOj");


var $27Dus = parcelRequire("27Dus");

function $cb117090d47a4a62$export$952cf09a216eb6d(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/load-edit-page"
    }).then(async (result)=>{
        // There is a bug in appolo client (https://github.com/apollographql/react-apollo/issues/3918)
        // that doesn't preserve the result in caches if there is an error in SSR
        // So we need to preserve the error, to be able to verify it later during render phase in SSR
        if (result?.errors?.some((err)=>(0, $8R0gj.isDraftSSRPreloadPermissionError)(err?.message))) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('edit');
        // There are two reasons to store smart card URLs on the window object:
        // 1. The OTP uses a document snapshot from Confluence that may be outdated and miss recently added or removed smart cards,
        //    so we must reconcile the list of smart cards with the draft content.
        // 2. The draft content stores links with slugs, but the Confluence snapshot does not,
        //    so we need to add slugs sourced from the draft content.
        // Therefore, we extract smart cards from the draft content here, save them on the window object,
        // and later use them to align the Confluence snapshot with the draft content.
        window['__SMART_CARDS_IN_DRAFT__'] = (0, $27Dus.findSmartCardNodes)(result?.data?.collabDraft?.document || '');
        return result;
    });
}
function $cb117090d47a4a62$export$7c1f00ae06ab82b8(contentId, draftShareId, useCache, status) {
    return (0, $dYU3e.query)({
        query: (0, $l1kdf.NativeCollabQuery),
        variables: {
            contentId: contentId,
            ...draftShareId && {
                draftShareId: draftShareId
            },
            status: status ?? [
                'draft',
                'current'
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        context: {
            single: 'true'
        },
        __callerPackage__: "@confluence/load-edit-page"
    });
}
module.exports["preloadCollabDraftContent"] = $cb117090d47a4a62$export$952cf09a216eb6d;
module.exports["preloadNativeCollab"] = $cb117090d47a4a62$export$7c1f00ae06ab82b8;

});

parcelRegister("l1kdf", function(module, exports) {

var $hrBIS = parcelRequire("hrBIS");

const $c2e596865d8e6fea$export$79b924d780de6f0d = (0, $hrBIS.default);
module.exports["NativeCollabQuery"] = $c2e596865d8e6fea$export$79b924d780de6f0d;

});

parcelRegister("hrBIS", function(module, exports) {
/**
 * @generated SignedSource<<4cf4db12dd73f2ac885d741a3d7c65ba>>
 * @relayHash 4e152ff0861f20bc69927f68972ccc1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc
const $83575f8369490c15$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "draftShareId",
            "variableName": "draftShareId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "number"
    }, v6 = {
        "kind": "ScalarField",
        "name": "ncsStepVersion"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v12 = {
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
            {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4e152ff0861f20bc69927f68972ccc1e",
            "id": "24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc",
            "metadata": {},
            "name": "NativeCollabQuery",
            "operationKind": "query",
            "text": "query NativeCollabQuery($contentId:ID,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,type,status,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},history{createdBy{__typename,displayName},createdDate},space{id,name,homepageId},labels{nodes{id,name}},subType}}}"
        }
    };
}();
$83575f8369490c15$var$node.hash = "182a5142c1846497c5e27245efe74033";
var $83575f8369490c15$export$2e2bcd8739ae039 = $83575f8369490c15$var$node;
module.exports["default"] = $83575f8369490c15$export$2e2bcd8739ae039;

});

parcelRegister("nIvaQ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fXb84 = parcelRequire("fXb84");


var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $6mKj3.expValEquals)('platform_editor_early_exit_return_draft', 'isEnabled', true) ? (0, $fXb84.CollabDraftWithRelevanceQuery) : (0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("fXb84", function(module, exports) {

var $kiLxw = parcelRequire("kiLxw");

const $abbff5e8c5475947$export$fb92c84fb9714700 = (0, $kiLxw.default);
module.exports["CollabDraftWithRelevanceQuery"] = $abbff5e8c5475947$export$fb92c84fb9714700;

});

parcelRegister("kiLxw", function(module, exports) {
/**
 * @generated SignedSource<<c2d68d945c3fe4452d03d6bdc8ddfd5c>>
 * @relayHash 5eb9ba691ed48d80122a8d87074eee9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1
const $ff1e82bf0b897703$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relevance"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5eb9ba691ed48d80122a8d87074eee9c",
            "id": "19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1",
            "metadata": {},
            "name": "CollabDraftWithRelevanceQuery",
            "operationKind": "query",
            "text": "query CollabDraftWithRelevanceQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title,relevance}}}"
        }
    };
}();
$ff1e82bf0b897703$var$node.hash = "c0bfcca7b64103265224238d7c18d9b1";
var $ff1e82bf0b897703$export$2e2bcd8739ae039 = $ff1e82bf0b897703$var$node;
module.exports["default"] = $ff1e82bf0b897703$export$2e2bcd8739ae039;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<81d932c04171cccd3ee1c517fa2180ce>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("8R0gj", function(module, exports) {

var $747ya = parcelRequire("747ya");

async function $65899b702fdd32b1$export$dfd3c4c0aa957792(contentId, draftShareId) {
    window.__PRELOAD_DRAFT__ = {
        contentId: contentId,
        draftFetchPromise: (0, $747ya.fetchDraft)(contentId, draftShareId),
        startTime: window?.performance?.now?.()
    };
}
const $65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR = '.PermissionException: User does not have permission';
function $65899b702fdd32b1$export$9d45b1b64b2cb8e1(message) {
    if (!message) return false;
    return message.indexOf($65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR) > -1 || false;
}
module.exports["preloadDraft"] = $65899b702fdd32b1$export$dfd3c4c0aa957792;
module.exports["isDraftSSRPreloadPermissionError"] = $65899b702fdd32b1$export$9d45b1b64b2cb8e1;

});

parcelRegister("747ya", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $6mKj3 = parcelRequire("6mKj3");


var $fqIt3 = parcelRequire("fqIt3");


var $nIvaQ = parcelRequire("nIvaQ");

async function $67d2826966f59cb2$export$af6160a01d539948(contentId, draftShareId) {
    // Use cache-first only if SSR rendered AND cache is not stale (within TTL)
    // This prevents stale data during SPA transitions while still benefiting from SSR cache
    const shouldUseCache = (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? window.__SSR_RENDERED__ || !(0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId) : window.__SSR_RENDERED__;
    const response = await (0, $c0rhi.queryInterop)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: shouldUseCache ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/fabric-providers"
    });
    const { data: data, error: error } = response;
    if (error || !data?.collabDraft) return {
        draft: null,
        response: response
    };
    const { document: document, version: version, metadata: metadata } = data.collabDraft;
    const draft = {
        version: version,
        metadata: $67d2826966f59cb2$var$excludeTypename(metadata),
        document: JSON.parse(document || '')
    };
    return {
        draft: draft,
        response: response
    };
}
function $67d2826966f59cb2$var$excludeTypename(metadata) {
    if (!metadata) return metadata;
    const { __typename: __typename, ...rest } = metadata;
    return rest;
}
module.exports["fetchDraft"] = $67d2826966f59cb2$export$af6160a01d539948;

});

parcelRegister("27Dus", function(module, exports) {

var $et4nk = parcelRequire("et4nk");


var $6GQtz = parcelRequire("6GQtz");


var $aN0qB = parcelRequire("aN0qB");

function $010c1dfc98319256$export$1970baffe86d32af(docJsonString) {
    if (!docJsonString) return [];
    const doc = JSON.parse(docJsonString);
    const cardProvider = new (0, $6GQtz.ConfluenceEditorCardProvider)('custom');
    return (0, $et4nk.findNodesToPrefetch)(doc, [
        {
            provider: cardProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        }
    ], (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT))[0].nodes;
}
module.exports["findSmartCardNodes"] = $010c1dfc98319256$export$1970baffe86d32af;

});

parcelRegister("et4nk", function(module, exports) {
function $7f5b74af20e3e05b$export$41263783ff0932a8(doc, providers, maxNodesToVisit) {
    // Counter for the total number of visited nodes to limit the traversal.
    let totalVisitedNodesCount = 0;
    // A map to store the results, with the provider name as the key.
    const resultMap = providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            provider: provider,
            nodes: []
        };
        return acc;
    }, {});
    // It doesn't use `filter` function from `@atlaskit/adf-utils/traverse` because it does not support early stopping.
    // We need to stop traversing when we reach the maximum number of nodes to visit to support large documents.
    // Create a list of providers for which we still need to find nodes.
    const providersToLookup = providers.filter(({ maxNodesToPrefetch: maxNodesToPrefetch })=>maxNodesToPrefetch > 0).map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            foundNodes: 0
        }));
    // Stack for the depth-first search (DFS), starting with the root document node.
    const nodesToVisit = [
        doc
    ];
    // The loop continues as long as there are nodes to visit, providers to look for,
    // and the visited nodes limit has not been reached.
    while(nodesToVisit.length > 0 && providersToLookup.length > 0 && totalVisitedNodesCount < maxNodesToVisit){
        totalVisitedNodesCount += 1;
        // Pop from the end to maintain DFS order (LIFO - Last In, First Out)
        const currentNode = nodesToVisit.pop();
        if (!currentNode) continue;
        // Using a reverse loop to avoid issues with array mutation (when removing elements).
        for(let i = providersToLookup.length - 1; i >= 0; i--){
            const providerToFind = providersToLookup[i];
            // Check if the current provider supports this node.
            if (providerToFind.provider.isNodeSupported(currentNode)) {
                // If provider supports the node, add it to the result map.
                resultMap[providerToFind.provider.name].nodes.push(currentNode);
                // Increment the count of found nodes for this provider.
                providerToFind.foundNodes += 1;
                // If the provider has found enough nodes, remove it from the lookup list.
                if (providerToFind.foundNodes >= providerToFind.maxNodesToPrefetch) providersToLookup.splice(i, 1);
            }
        }
        // If the current node has children, add them to the stack in reverse order
        // to maintain left-to-right traversal when popping from the stack,
        // because it's LIFO.
        if (currentNode.content) // Push children in reverse order to maintain correct DFS traversal order
        for(let i = currentNode.content.length - 1; i >= 0; i--){
            const node = currentNode.content[i];
            if (node) nodesToVisit.push(node);
        }
    }
    // Return an array of the found nodes, grouped by provider.
    return Object.values(resultMap);
}
module.exports["findNodesToPrefetch"] = $7f5b74af20e3e05b$export$41263783ff0932a8;

});

parcelRegister("6GQtz", function(module, exports) {

var $477dG = parcelRequire("477dG");


var $6mKj3 = parcelRequire("6mKj3");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $477dG.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if ((0, $6mKj3.isExperimentEnabled)('confluence_smartlink_default_display_types')) {
            if (this.shouldDisplayAsEmbed(url)) return 'embed';
            if (this.shouldDisplayAsCard(url)) return 'block';
        }
        return super.getHardCodedAppearance(url);
    }
    /**
   * Opt in to honouring an explicitly-requested embed appearance as the default
   * (validated, with a card fallback) for the quick-insert embed flow. Both active
   * cohorts of the quick-insert embeds experiment (`prioritizeLinkInQIM` and
   * `prioritizeEmbedInQIM`) enable this — they differ only in quick-insert menu
   * ordering, not in embedding behaviour. Only `control` and unenrolled users keep
   * the existing behaviour.
   *
   * The platform only calls this when a link is inserted with a requested embed
   * appearance and the user has no saved preference, so the exposure here is
   * scoped to the quick-insert embed insertion path.
   */ shouldHonorRequestedEmbedAsDefault() {
        return (0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control';
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("477dG", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $a1WXB = parcelRequire("a1WXB");


var $i0VEL = parcelRequire("i0VEL");


var $1oCLl = parcelRequire("1oCLl");


var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");


var $1bFdN = parcelRequire("1bFdN");


var $5nJCu = parcelRequire("5nJCu");


var $l1HSN = parcelRequire("l1HSN");


var $k00oi = parcelRequire("k00oi");


var $dh538 = parcelRequire("dh538");


var $lEzf1 = parcelRequire("lEzf1");


var $egwA4 = parcelRequire("egwA4");

const $807e27f9bf9a8610$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $807e27f9bf9a8610$var$JIRA_ROADMAP_OR_TIMELINE_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/;
const $807e27f9bf9a8610$var$POLARIS_VIEW_REGEX = /^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/;
const $807e27f9bf9a8610$var$JWM_VIEW_REGEX = /^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/;
const $807e27f9bf9a8610$var$JIRA_LIST_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/;
const $807e27f9bf9a8610$var$GIPHY_MEDIA_REGEX = /^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//;
const $807e27f9bf9a8610$var$PROFORMA_VIEW_REGEX = /^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?");
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$CONFLUENCE_WHITEBOARD_UUID_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?");
const $807e27f9bf9a8610$var$CONFLUENCE_DATABASE_REGEX = /\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/;
const $807e27f9bf9a8610$var$YOUTUBE_VIDEO_REGEX = /^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$LOOM_VIDEO_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$LOOM_SCREENSHOT_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?loom\\..*?\\/i\\/(?<id>[a-f0-9]{32})");
const $807e27f9bf9a8610$var$JIRA_DASHBOARD_REGEX = /^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/;
const $807e27f9bf9a8610$var$JIRA_BACKLOG_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/;
const $807e27f9bf9a8610$var$JIRA_BOARD_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/;
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$JIRA_PLAN_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)");
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$JIRA_PLAN_WITH_SCENARIO_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?");
const $807e27f9bf9a8610$var$JIRA_VERSION_REGEX = /https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/;
const $807e27f9bf9a8610$var$JIRA_FORM_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/;
const $807e27f9bf9a8610$var$JIRA_SUMMARY_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/;
const $807e27f9bf9a8610$var$ROVO_AGENT_PROFILE_PAGE_REGEX = /^https:\/\/.*?\/people\/agent\/.+$/;
const $807e27f9bf9a8610$var$CUSTOMER_360_LANDING_PAGE_REGEX = /^https:\/\/customer\.atlassian\.com\/.*$/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$CONFLUENCE_TEAM_CALENDARS_REGEX = RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)");
const $807e27f9bf9a8610$var$JIRA_ISSUE_NAVIGATOR_REGEX = /^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/;
const $807e27f9bf9a8610$var$AVP_VISUALIZATION_VIEW_REGEX = /^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/;
const $807e27f9bf9a8610$var$JIRA_WORK_ITEM_REGEX = /\/browse\/((?:\w+)-(?:\d+))/i;
const $807e27f9bf9a8610$var$DOES_URL_MATCH_PATH_START_REGEX = /^[a-zA-Z0-9]/;
const $807e27f9bf9a8610$var$DOES_URL_MATCH_PATH_END_REGEX = /[a-zA-Z0-9]$/;
const $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline = (url)=>url.match($807e27f9bf9a8610$var$JIRA_ROADMAP_OR_TIMELINE_REGEX);
const $807e27f9bf9a8610$var$isPolarisView = (url)=>url.match($807e27f9bf9a8610$var$POLARIS_VIEW_REGEX);
const $807e27f9bf9a8610$var$isJwmView = (url)=>url.match($807e27f9bf9a8610$var$JWM_VIEW_REGEX);
const $807e27f9bf9a8610$var$isJiraList = (url)=>url.match($807e27f9bf9a8610$var$JIRA_LIST_REGEX);
const $807e27f9bf9a8610$var$isGiphyMedia = (url)=>url.match($807e27f9bf9a8610$var$GIPHY_MEDIA_REGEX);
const $807e27f9bf9a8610$var$isProformaView = (url)=>url.match($807e27f9bf9a8610$var$PROFORMA_VIEW_REGEX);
const $807e27f9bf9a8610$var$isConfluenceWhiteboard = (url)=>url.match($807e27f9bf9a8610$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX) || url.match($807e27f9bf9a8610$var$CONFLUENCE_WHITEBOARD_UUID_REGEX);
const $807e27f9bf9a8610$var$isConfluenceDatabase = (url)=>url.match($807e27f9bf9a8610$var$CONFLUENCE_DATABASE_REGEX);
const $807e27f9bf9a8610$var$isYoutubeVideo = (url)=>url.match($807e27f9bf9a8610$var$YOUTUBE_VIDEO_REGEX);
const $807e27f9bf9a8610$var$isLoomVideoUrl = (url)=>{
    return url.match($807e27f9bf9a8610$var$LOOM_VIDEO_URL_REGEX);
};
const $807e27f9bf9a8610$var$isLoomScreenshotUrl = (url)=>{
    return url.match($807e27f9bf9a8610$var$LOOM_SCREENSHOT_URL_REGEX);
};
const $807e27f9bf9a8610$var$isJiraDashboard = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_DASHBOARD_REGEX);
};
const $807e27f9bf9a8610$var$isJiraBacklog = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_BACKLOG_REGEX);
};
const $807e27f9bf9a8610$var$isJiraBoard = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_BOARD_REGEX);
};
const $807e27f9bf9a8610$var$isJiraPlan = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_PLAN_REGEX) || url.match($807e27f9bf9a8610$var$JIRA_PLAN_WITH_SCENARIO_REGEX);
};
const $807e27f9bf9a8610$var$isJiraVersion = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_VERSION_REGEX);
};
const $807e27f9bf9a8610$var$isJiraForm = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_FORM_REGEX);
};
const $807e27f9bf9a8610$var$isJiraSummary = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_SUMMARY_REGEX);
};
const $807e27f9bf9a8610$var$isRovoAgentProfilePage = (url)=>{
    return url.match($807e27f9bf9a8610$var$ROVO_AGENT_PROFILE_PAGE_REGEX);
};
const $807e27f9bf9a8610$var$isCustomer360LandingPage = (url)=>url.match($807e27f9bf9a8610$var$CUSTOMER_360_LANDING_PAGE_REGEX);
const $807e27f9bf9a8610$var$isConfluenceTeamCalendars = (url)=>url.match($807e27f9bf9a8610$var$CONFLUENCE_TEAM_CALENDARS_REGEX);
const $807e27f9bf9a8610$var$isJiraIssueNavigator = (url)=>url.match($807e27f9bf9a8610$var$JIRA_ISSUE_NAVIGATOR_REGEX);
const $807e27f9bf9a8610$var$isAvpVisualizationView = (url)=>url.match($807e27f9bf9a8610$var$AVP_VISUALIZATION_VIEW_REGEX);
const $807e27f9bf9a8610$export$6a9668b99d8a1708 = (url)=>$807e27f9bf9a8610$var$JIRA_WORK_ITEM_REGEX.test(url);
// Local UrlChecker-compatible wrapper around the boolean-returning
// `isConfluenceSlideUrl` from `./url-checkers` (the single source of truth for
// slide URL matching). Wrapping (rather than aliasing the imported identifier
// directly inside the exported `internalUrlCheckers` object) avoids the
// @atlaskit/editor/no-re-export lint rule and gives the registry a uniform
// `(url) => RegExpMatchArray | null` signature. Consumers of
// `internalUrlCheckers` only check the truthiness of the result, so returning
// a synthetic single-element match array (or `null`) preserves behaviour.
const $807e27f9bf9a8610$var$isConfluenceSlide = (url)=>(0, $l1HSN.isConfluenceSlideUrl)(url) ? [
        url
    ] : null;
const $807e27f9bf9a8610$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline,
    isPolarisView: $807e27f9bf9a8610$var$isPolarisView,
    isJwmView: $807e27f9bf9a8610$var$isJwmView,
    isJiraList: $807e27f9bf9a8610$var$isJiraList,
    isConfluenceWhiteboard: $807e27f9bf9a8610$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $807e27f9bf9a8610$var$isConfluenceDatabase,
    isConfluenceSlide: $807e27f9bf9a8610$var$isConfluenceSlide,
    isJiraDashboard: $807e27f9bf9a8610$var$isJiraDashboard,
    isJiraBacklog: $807e27f9bf9a8610$var$isJiraBacklog,
    isJiraBoard: $807e27f9bf9a8610$var$isJiraBoard,
    isJiraPlan: $807e27f9bf9a8610$var$isJiraPlan,
    isJiraVersion: $807e27f9bf9a8610$var$isJiraVersion,
    isJiraForm: $807e27f9bf9a8610$var$isJiraForm,
    isJiraSummary: $807e27f9bf9a8610$var$isJiraSummary,
    isRovoAgentProfilePage: $807e27f9bf9a8610$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $807e27f9bf9a8610$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $807e27f9bf9a8610$var$isJiraIssueNavigator
};
function $807e27f9bf9a8610$export$4006295459a20a0(url) {
    return Object.values($807e27f9bf9a8610$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $807e27f9bf9a8610$export$78234eee43b97e81(url) {
    return !$807e27f9bf9a8610$export$4006295459a20a0(url);
}
function $807e27f9bf9a8610$var$getAppearanceForNode(node) {
    return node.type === 'blockCard' ? 'block' : node.type === 'embedCard' ? 'embed' : 'inline';
}
function $807e27f9bf9a8610$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $807e27f9bf9a8610$export$e4635c0135e1a519 extends (0, $i0VEL.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        if ((0, $1oCLl.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) === false) // if local cache feature flag is disabled, fall back to the base implementation
        return super.getData(node, callback);
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
        const isResolvedCachedResponse = details && details.meta && (0, $btw9C.getStatus)(details) === 'resolved';
        if (isResolvedCachedResponse) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the session storage cache
        if (isResolvedCachedResponse && this.getCacheStatusForNode(jsonNode) === 'network') return;
        // fetch the latest data async and update the session storage cache
        this.getDataAsync(node, (payload)=>{
            const response = payload.data;
            if (!payload.error && response?.meta) {
                const status = (0, $btw9C.getStatus)(response);
                if (status === 'resolved') this.smartCardLocalCacheClient.setItem(key, response);
            }
            callback(payload);
        });
    }
    nodeDataKey(node) {
        if (!(0, $dh538.fg)('platform_smartlink_inline_resolve_optimization')) return node.attrs.url;
        return `${node.attrs.url}|${$807e27f9bf9a8610$var$getAppearanceForNode(node)}`;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            const appearance = (0, $dh538.fg)('platform_smartlink_inline_resolve_optimization') ? $807e27f9bf9a8610$var$getAppearanceForNode(node) : undefined;
            return this.cardClient.fetchData(url, false, appearance);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$807e27f9bf9a8610$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $lEzf1.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = $807e27f9bf9a8610$var$DOES_URL_MATCH_PATH_START_REGEX.test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = $807e27f9bf9a8610$var$DOES_URL_MATCH_PATH_END_REGEX.test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $807e27f9bf9a8610$var$isJiraPlan(url);
        const isJiraFormEvaluated = $807e27f9bf9a8610$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $807e27f9bf9a8610$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $dh538.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $807e27f9bf9a8610$var$isConfluenceTeamCalendars(url);
        if ($807e27f9bf9a8610$var$isJiraRoadmapOrTimeline(url) || $807e27f9bf9a8610$var$isPolarisView(url) || $807e27f9bf9a8610$var$isJwmView(url) || $807e27f9bf9a8610$var$isJiraList(url) || $807e27f9bf9a8610$var$isGiphyMedia(url) || $807e27f9bf9a8610$var$isProformaView(url) || $807e27f9bf9a8610$var$isConfluenceWhiteboard(url) || $807e27f9bf9a8610$var$isConfluenceDatabase(url) || (0, $l1HSN.isConfluenceSlideUrl)(url) || $807e27f9bf9a8610$var$isYoutubeVideo(url) || $807e27f9bf9a8610$var$isLoomVideoUrl(url) || $807e27f9bf9a8610$var$isLoomScreenshotUrl(url) && (0, $dh538.fg)('loom-support-screenshot-sl-resolution') || $807e27f9bf9a8610$var$isJiraDashboard(url) || $807e27f9bf9a8610$var$isJiraBacklog(url) || $807e27f9bf9a8610$var$isJiraBoard(url) || $807e27f9bf9a8610$var$isRovoAgentProfilePage(url) || $807e27f9bf9a8610$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $807e27f9bf9a8610$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $807e27f9bf9a8610$var$isJiraIssueNavigator(url) || $807e27f9bf9a8610$var$isAvpVisualizationView(url) && (0, $dh538.fg)('avp_unfurl_shared_charts_embed_by_default_2')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $btw9C.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $a1WXB.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    /**
   * Opt-in hook: when a caller explicitly requests an `'embed'` appearance and the
   * user has no saved preference for the URL, honour that request as the default
   * (above any provider default), validating embeddability first and falling back
   * to a card (`'block'`) when the link cannot be embedded.
   *
   * Defaults to `false` so behaviour is unchanged for every existing consumer.
   * Subclasses (e.g. Confluence) can override this to opt in, typically behind an
   * experiment.
   */ shouldHonorRequestedEmbedAsDefault() {
        return false;
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $dh538.fg)('issue-link-suggestions-in-comments')) {
                if ($807e27f9bf9a8610$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                // When a caller explicitly requested an embed (e.g. Confluence's quick-insert
                // embed flow tags the inserted link) and the user has no saved preference for
                // this URL, honour embed-by-default above the provider default — but only in an
                // embed-friendly location (matching how hard-coded embeds are gated above) and
                // only when the link can actually be embedded, otherwise fall back to a card.
                // Gated behind a default-off opt-in hook so other consumers are unaffected.
                if (!userPreference && appearance === 'embed' && isEmbedFriendlyLocationEvaluated && this.shouldHonorRequestedEmbedAsDefault()) {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    preferredAppearance = canItBeEmbed ? 'embed' : 'block';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') return this.transformer.toSmartlinkAdf(url, 'block');
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $egwA4.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $5nJCu.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $807e27f9bf9a8610$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $k00oi.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $807e27f9bf9a8610$export$b7c3c9a99f7959f5 = new $807e27f9bf9a8610$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $807e27f9bf9a8610$export$4006295459a20a0;
module.exports["isExternalUrl"] = $807e27f9bf9a8610$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $807e27f9bf9a8610$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $807e27f9bf9a8610$export$b7c3c9a99f7959f5;

});

parcelRegister("a1WXB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8IyAG = parcelRequire("8IyAG");


var $4sZvs = parcelRequire("4sZvs");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $kbte2 = parcelRequire("kbte2");

function $ea05eb724aaf2d4b$export$ab527c45f467d3f7(options) {
    const { defaultExtractorFunction: defaultExtractorFunction, extractorPrioritiesByType: extractorPrioritiesByType, extractorFunctionsByType: extractorFunctionsByType, json: json } = options;
    if (json) {
        const type = json['@type'];
        if (type && Array.isArray(type)) {
            let highestPriority = 0;
            let highestPriorityExtractorFunction = defaultExtractorFunction;
            for (let t of type)if (extractorPrioritiesByType[t] > highestPriority) {
                highestPriority = extractorPrioritiesByType[t];
                highestPriorityExtractorFunction = extractorFunctionsByType[t];
            }
            return highestPriorityExtractorFunction(json);
        }
        if (type && extractorFunctionsByType[type]) return extractorFunctionsByType[type](json);
    }
    return defaultExtractorFunction(json);
}
const $ea05eb724aaf2d4b$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
const $ea05eb724aaf2d4b$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(icon);
    else {
        if (icon.url) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(icon.url);
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
const $ea05eb724aaf2d4b$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(url);
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = $ea05eb724aaf2d4b$export$efdbd45f3e77a161(jsonLd);
    const type = $ea05eb724aaf2d4b$export$2e9ae379995d99e3(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
const $ea05eb724aaf2d4b$export$3185b99040f72cfd = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $ea05eb724aaf2d4b$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && $ea05eb724aaf2d4b$export$67f3d92c824fd850(context.icon),
                type: $ea05eb724aaf2d4b$export$2e9ae379995d99e3(context)
            };
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $ea05eb724aaf2d4b$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $ea05eb724aaf2d4b$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $kbte2.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4sZvs.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $kbte2.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return $ea05eb724aaf2d4b$export$67f3d92c824fd850(icon);
    return undefined;
};
const $ea05eb724aaf2d4b$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$38df542ff03a4183 = (id)=>{
    return id === (0, $kbte2.CONFLUENCE_GENERATOR_ID);
};
const $ea05eb724aaf2d4b$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
const $ea05eb724aaf2d4b$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
const $ea05eb724aaf2d4b$export$601b23e9cf369aed = (jsonLd)=>{
    if (jsonLd['atlassian:dateViewed']) return jsonLd['atlassian:dateViewed'];
    return undefined;
};
const $ea05eb724aaf2d4b$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && $ea05eb724aaf2d4b$export$67f3d92c824fd850(person.icon)
        };
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>$ea05eb724aaf2d4b$export$c471ae5fddcf1392(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = $ea05eb724aaf2d4b$export$c471ae5fddcf1392(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return $ea05eb724aaf2d4b$export$c471ae5fddcf1392(assignedTo);
    return undefined;
};
const $ea05eb724aaf2d4b$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map($ea05eb724aaf2d4b$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $ea05eb724aaf2d4b$export$c471ae5fddcf1392(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map($ea05eb724aaf2d4b$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $ea05eb724aaf2d4b$export$c471ae5fddcf1392(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return $ea05eb724aaf2d4b$export$c471ae5fddcf1392(updatedBy);
    return undefined;
};
const $ea05eb724aaf2d4b$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
const $ea05eb724aaf2d4b$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = $ea05eb724aaf2d4b$export$3e8ad908070b68b2(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$8beff7405d020ddf = (response)=>response?.entityData;
const $ea05eb724aaf2d4b$export$c7168210b81d9383 = (response)=>Boolean($ea05eb724aaf2d4b$export$8beff7405d020ddf(response));
const $ea05eb724aaf2d4b$var$extractEntityEmbedUrl = (response)=>{
    const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $ea05eb724aaf2d4b$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    if ((0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entityIcon = $ea05eb724aaf2d4b$export$19346520e937a99f(response);
        if (entityIcon) return {
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        };
    }
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $kbte2.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4sZvs.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $kbte2.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    };
};
const $ea05eb724aaf2d4b$export$19346520e937a99f = (response)=>{
    if ((0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        if (!entity) return undefined;
        if (!(0, $8IyAG.isBaseEntity)(entity)) return undefined;
        if ((0, $8IyAG.isDesignEntity)(entity) && entity.iconUrl) return {
            url: entity.iconUrl,
            label: entity.type
        };
        if ((0, $8IyAG.isDocumentEntity)(entity) && entity.type.iconUrl) return {
            url: entity.type.iconUrl,
            label: entity.type.category
        };
        // When JSON-LD is deprecated, we can change this to returning entity provider icon.
        // For now code upstream will return better result when this method returns undefined.
        return undefined;
    } else {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        let url;
        if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
        return {
            url: url,
            label: entity?.displayName
        };
    }
};
const $ea05eb724aaf2d4b$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.displayName;
    return $ea05eb724aaf2d4b$export$b05803156e5015b6(response?.data, removeTextHighlightingFromTitle);
};
const $ea05eb724aaf2d4b$export$7ba9b12c6a1b73de = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.url;
    return $ea05eb724aaf2d4b$export$63f54cf4c5883620(response?.data);
};
const $ea05eb724aaf2d4b$export$16b02be3e2bb31ad = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.ari || $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.thirdPartyAri;
    const data = response?.data;
    return $ea05eb724aaf2d4b$export$be18a6294fd426ec(data);
};
const $ea05eb724aaf2d4b$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $ea05eb724aaf2d4b$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return $ea05eb724aaf2d4b$export$4b0d98b1b7f6d115(response?.data, 'web', iframeUrlType);
};
const $ea05eb724aaf2d4b$export$ff753ed519e96e9e = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$ad879f2c9d5100a0(response);
    return response?.data && $ea05eb724aaf2d4b$export$a832871718466647(response?.data);
};
const $ea05eb724aaf2d4b$export$7a685df468cbf38f = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.createdAt;
    return response?.data && $ea05eb724aaf2d4b$export$e1226a5e0bbbf862(response.data);
};
const $ea05eb724aaf2d4b$export$75047940e157fd1f = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.lastUpdatedAt;
    return response?.data && $ea05eb724aaf2d4b$export$7fc2f5e6f9d22ae7(response.data);
};
const $ea05eb724aaf2d4b$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.createdBy?.displayName;
    const persons = $ea05eb724aaf2d4b$export$a66235cba0c9d11a(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $ea05eb724aaf2d4b$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return $ea05eb724aaf2d4b$export$a66235cba0c9d11a(response.data);
};
const $ea05eb724aaf2d4b$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.lastUpdatedBy?.displayName;
    const person = $ea05eb724aaf2d4b$export$8a2d1ed7e6f336f0(response.data);
    return person ? person.name : undefined;
};
const $ea05eb724aaf2d4b$export$96ed4c1b14ac210a = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["genericExtractPropsFromJSONLD"] = $ea05eb724aaf2d4b$export$ab527c45f467d3f7;
module.exports["extractUrlFromLinkJsonLd"] = $ea05eb724aaf2d4b$export$396ba4ef2e37dc65;
module.exports["extractUrlFromIconJsonLd"] = $ea05eb724aaf2d4b$export$67f3d92c824fd850;
module.exports["extractType"] = $ea05eb724aaf2d4b$export$2e9ae379995d99e3;
module.exports["extractAri"] = $ea05eb724aaf2d4b$export$be18a6294fd426ec;
module.exports["extractLink"] = $ea05eb724aaf2d4b$export$63f54cf4c5883620;
module.exports["extractSummary"] = $ea05eb724aaf2d4b$export$db5a8500f6b6286e;
module.exports["extractTitle"] = $ea05eb724aaf2d4b$export$b05803156e5015b6;
module.exports["extractContext"] = $ea05eb724aaf2d4b$export$efdbd45f3e77a161;
module.exports["extractNameFromJsonLd"] = $ea05eb724aaf2d4b$export$3185b99040f72cfd;
module.exports["extractProvider"] = $ea05eb724aaf2d4b$export$a832871718466647;
module.exports["extractProviderIcon"] = $ea05eb724aaf2d4b$export$6fb636a2ac885215;
module.exports["isConfluenceGenerator"] = $ea05eb724aaf2d4b$export$38df542ff03a4183;
module.exports["extractDateCreated"] = $ea05eb724aaf2d4b$export$e1226a5e0bbbf862;
module.exports["extractDateUpdated"] = $ea05eb724aaf2d4b$export$7fc2f5e6f9d22ae7;
module.exports["extractDateViewed"] = $ea05eb724aaf2d4b$export$601b23e9cf369aed;
module.exports["extractPersonFromJsonLd"] = $ea05eb724aaf2d4b$export$c471ae5fddcf1392;
module.exports["extractMembers"] = $ea05eb724aaf2d4b$export$6281d080d62a0719;
module.exports["extractPersonAssignedTo"] = $ea05eb724aaf2d4b$export$38a0979ebf273662;
module.exports["extractPersonCreatedBy"] = $ea05eb724aaf2d4b$export$a66235cba0c9d11a;
module.exports["extractPersonOwnedBy"] = $ea05eb724aaf2d4b$export$19ee667f3f7a6ec3;
module.exports["extractPersonUpdatedBy"] = $ea05eb724aaf2d4b$export$8a2d1ed7e6f336f0;
module.exports["extractImage"] = $ea05eb724aaf2d4b$export$4c753a1297cb9805;
module.exports["extractPlatformIsSupported"] = $ea05eb724aaf2d4b$export$3e8ad908070b68b2;
module.exports["extractPreview"] = $ea05eb724aaf2d4b$export$4b0d98b1b7f6d115;
module.exports["extractEntity"] = $ea05eb724aaf2d4b$export$8beff7405d020ddf;
module.exports["isEntityPresent"] = $ea05eb724aaf2d4b$export$c7168210b81d9383;
module.exports["extractEntityProvider"] = $ea05eb724aaf2d4b$export$ad879f2c9d5100a0;
module.exports["extractEntityIcon"] = $ea05eb724aaf2d4b$export$19346520e937a99f;
module.exports["extractSmartLinkTitle"] = $ea05eb724aaf2d4b$export$3eda18658b66108;
module.exports["extractSmartLinkUrl"] = $ea05eb724aaf2d4b$export$7ba9b12c6a1b73de;
module.exports["extractSmartLinkAri"] = $ea05eb724aaf2d4b$export$16b02be3e2bb31ad;
module.exports["extractSmartLinkEmbed"] = $ea05eb724aaf2d4b$export$864b719baf5d744d;
module.exports["extractSmartLinkProvider"] = $ea05eb724aaf2d4b$export$ff753ed519e96e9e;
module.exports["extractSmartLinkCreatedOn"] = $ea05eb724aaf2d4b$export$7a685df468cbf38f;
module.exports["extractSmartLinkModifiedOn"] = $ea05eb724aaf2d4b$export$75047940e157fd1f;
module.exports["extractSmartLinkCreatedBy"] = $ea05eb724aaf2d4b$export$242875b46118beb2;
module.exports["extractSmartLinkAuthorGroup"] = $ea05eb724aaf2d4b$export$41fc716e1bc2dc90;
module.exports["extractSmartLinkModifiedBy"] = $ea05eb724aaf2d4b$export$7f099a839071a190;
module.exports["extractSmartLinkDownloadUrl"] = $ea05eb724aaf2d4b$export$96ed4c1b14ac210a;

});

parcelRegister("8IyAG", function(module, exports) {
const $1092512147c3e960$var$DESIGN_TYPES = [
    'FILE',
    'CANVAS',
    'GROUP',
    'NODE',
    'PROTOTYPE',
    'OTHER'
];
const $1092512147c3e960$var$DESIGN_STATUSES = [
    'READY_FOR_DEVELOPMENT',
    'UNKNOWN',
    'NONE'
];
const $1092512147c3e960$var$REMOTE_LINK_TYPES = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];
const $1092512147c3e960$var$APPEARANCES = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $1092512147c3e960$var$WORK_ITEM_SUB_TYPES = [
    'task',
    'bug',
    'story',
    'epic',
    'feature',
    'question',
    'other',
    'incident',
    'problem',
    'approval',
    'section',
    'milestone',
    'work_item',
    'default_task'
];
const $1092512147c3e960$var$DOCUMENT_CATEGORIES = [
    'folder',
    'document',
    'presentation',
    'spreadsheet',
    'image',
    'audio',
    'video',
    'pdf',
    'shortcut',
    'code',
    'archive',
    'form',
    'web-page',
    'other'
];
/**
 * Runtime membership check for string literal tuples.
 * Keeps guard logic aligned with tuple-derived union types.
 */ const $1092512147c3e960$var$isOneOf = (values, value)=>typeof value === 'string' && values.includes(value);
const $1092512147c3e960$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $1092512147c3e960$var$asRecord = (value)=>value;
const $1092512147c3e960$export$12af7c5462954d1e = (value)=>$1092512147c3e960$var$isObject(value) && typeof value.displayName === 'string' && typeof value.id === 'string' && typeof value.url === 'string';
const $1092512147c3e960$export$8dc9be81b5b6266b = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$DESIGN_STATUSES, $1092512147c3e960$var$asRecord(value).status) && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$DESIGN_TYPES, $1092512147c3e960$var$asRecord(value).type);
const $1092512147c3e960$export$f16c4076686c1f5b = (value)=>{
    if (!$1092512147c3e960$export$12af7c5462954d1e(value)) return false;
    const entity = $1092512147c3e960$var$asRecord(value);
    const remoteLink = entity['atlassian:remote-link'];
    return $1092512147c3e960$var$isObject(remoteLink) && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$REMOTE_LINK_TYPES, remoteLink.type);
};
const $1092512147c3e960$export$791f1b4852e2a184 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && $1092512147c3e960$var$isObject($1092512147c3e960$var$asRecord(value)['atlassian:project']);
const $1092512147c3e960$export$162dad7a1238d377 = (value)=>{
    if (!$1092512147c3e960$export$12af7c5462954d1e(value)) return false;
    const entity = $1092512147c3e960$var$asRecord(value);
    const workItem = entity['atlassian:work-item'];
    return $1092512147c3e960$var$isObject(workItem) && typeof workItem.status === 'string' && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$WORK_ITEM_SUB_TYPES, workItem.subtype) && typeof workItem.team === 'string';
};
const $1092512147c3e960$export$32c06ee7e0e9b79e = (value)=>{
    if (!$1092512147c3e960$export$12af7c5462954d1e(value)) return false;
    const entityType = $1092512147c3e960$var$asRecord(value).type;
    return $1092512147c3e960$var$isObject(entityType) && (entityType.category === undefined || $1092512147c3e960$var$isOneOf($1092512147c3e960$var$DOCUMENT_CATEGORIES, entityType.category)) && (entityType.iconUrl === undefined || typeof entityType.iconUrl === 'string') && ($1092512147c3e960$var$isOneOf($1092512147c3e960$var$DOCUMENT_CATEGORIES, entityType.category) || typeof entityType.iconUrl === 'string');
};
const $1092512147c3e960$export$33e8c1bbf9148b0e = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && ('attachments' in value || 'commentCount' in value || 'hidden' in value || 'isPinned' in value || 'lastActive' in value || 'reactions' in value);
const $1092512147c3e960$export$6c20afe8743cb761 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && ('isArchived' in value || 'lastActive' in value || 'memberCount' in value || 'members' in value || 'membershipType' in value || 'topic' in value || 'workspace' in value);
const $1092512147c3e960$export$fe785532d894f833 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && !$1092512147c3e960$export$8dc9be81b5b6266b(value) && !$1092512147c3e960$export$f16c4076686c1f5b(value) && !$1092512147c3e960$export$791f1b4852e2a184(value) && !$1092512147c3e960$export$162dad7a1238d377(value) && !$1092512147c3e960$export$32c06ee7e0e9b79e(value) && !$1092512147c3e960$export$33e8c1bbf9148b0e(value) && !$1092512147c3e960$export$6c20afe8743cb761(value);
const $1092512147c3e960$export$47565ffe58e56845 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && ($1092512147c3e960$export$8dc9be81b5b6266b(value) || $1092512147c3e960$export$f16c4076686c1f5b(value) || $1092512147c3e960$export$791f1b4852e2a184(value) || $1092512147c3e960$export$162dad7a1238d377(value) || $1092512147c3e960$export$32c06ee7e0e9b79e(value) || $1092512147c3e960$export$33e8c1bbf9148b0e(value) || $1092512147c3e960$export$6c20afe8743cb761(value) || $1092512147c3e960$export$fe785532d894f833(value));
module.exports["isBaseEntity"] = $1092512147c3e960$export$12af7c5462954d1e;
module.exports["isDesignEntity"] = $1092512147c3e960$export$8dc9be81b5b6266b;
module.exports["isDocumentEntity"] = $1092512147c3e960$export$32c06ee7e0e9b79e;

});

parcelRegister("4sZvs", function(module, exports) {

var $ldZvW = parcelRequire("ldZvW");


var $8akax = parcelRequire("8akax");


var $2i2Hp = parcelRequire("2i2Hp");

const $8bfb06df0501dc58$export$68f3db7f6af48bcb = (0, $8akax.createFeatureFlaggedComponent)((0, $2i2Hp.ConfluenceIcon), (0, $ldZvW.ConfluenceIcon));
module.exports["ConfluenceIcon"] = $8bfb06df0501dc58$export$68f3db7f6af48bcb;

});

parcelRegister("kbte2", function(module, exports) {
const $4827a4a6130f9557$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $4827a4a6130f9557$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $4827a4a6130f9557$export$84a73a0383f58180 = 'JiraTask';
const $4827a4a6130f9557$export$c6c83963a9378a67 = 'JiraSubTask';
const $4827a4a6130f9557$export$58af3c426c111a6d = 'JiraStory';
const $4827a4a6130f9557$export$ac9898a63417219e = 'JiraBug';
const $4827a4a6130f9557$export$54db5e3fb12e39cd = 'JiraEpic';
const $4827a4a6130f9557$export$2f54a5a217202c85 = 'JiraIncident';
const $4827a4a6130f9557$export$d097371052bfc411 = 'JiraServiceRequest';
const $4827a4a6130f9557$export$efd9452ad16c6676 = 'JiraChange';
const $4827a4a6130f9557$export$2e7e70abb5d81f67 = 'JiraProblem';
const $4827a4a6130f9557$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
var $4827a4a6130f9557$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $4827a4a6130f9557$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Video"] = "FileType:Video";
    return IconType;
}({});
module.exports["CONFLUENCE_GENERATOR_ID"] = $4827a4a6130f9557$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $4827a4a6130f9557$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $4827a4a6130f9557$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $4827a4a6130f9557$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $4827a4a6130f9557$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $4827a4a6130f9557$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $4827a4a6130f9557$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $4827a4a6130f9557$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $4827a4a6130f9557$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $4827a4a6130f9557$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $4827a4a6130f9557$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $4827a4a6130f9557$export$ce25cfc40b280dbc;
module.exports["SmartLinkSize"] = $4827a4a6130f9557$export$51f13ced115cbdae;
module.exports["IconType"] = $4827a4a6130f9557$export$13ff1290a9e22e77;

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $iu6m9 = parcelRequire("iu6m9");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("5nJCu", function(module, exports) {
class $b839f3682b6db3a9$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b839f3682b6db3a9$export$f993aef960936087;

});

parcelRegister("l1HSN", function(module, exports) {
/**
 * URL checker utilities for Confluence content types.
 *
 * Exported via the `@atlaskit/editor-card-provider/url-checkers` subpath
 * so consumers don't have to depend on the barrel file.
 */ /**
 * Matches Confluence Slides URLs.
 *
 * Examples:
 *   - /wiki/spaces/TEAM/slide/12345
 *   - /wiki/spaces/~uid/slide/8fb8c642-803d-59fe-8d1c-066610e860c6
 */ // eslint-disable-next-line require-unicode-regexp -- consistent with isConfluenceDatabase in provider.ts
const $57844766c894899d$var$CONFLUENCE_SLIDE_URL_PATTERN = /\/wiki\/spaces\/~?[\d\w]+\/slide\/[\d\w-]+(\?.*)?$/;
const $57844766c894899d$export$4091d55e0211d2e1 = (url)=>$57844766c894899d$var$CONFLUENCE_SLIDE_URL_PATTERN.test(url);
module.exports["isConfluenceSlideUrl"] = $57844766c894899d$export$4091d55e0211d2e1;

});

parcelRegister("lEzf1", function(module, exports) {
const $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $73e1dba18235f000$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $73e1dba18235f000$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $73e1dba18235f000$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $73e1dba18235f000$export$b5fe3f66a567bec0;

});

parcelRegister("egwA4", function(module, exports) {

var $kt8c2 = parcelRequire("kt8c2");

var $7a3952f20342cebe$var$_SmartCardLocalCacheClient;
const $7a3952f20342cebe$var$SMART_CARD_CACHE_CLIENT_KEY = 'smart-card-url-data';
const $7a3952f20342cebe$var$SMART_CARD_CACHE_KEY = 'response-cache';
const $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $7a3952f20342cebe$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache and prevents
   * race conditions when multiple instances write to the same storage key.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$7a3952f20342cebe$export$1987ad1ab31f2528.instance) $7a3952f20342cebe$export$1987ad1ab31f2528.instance = new $7a3952f20342cebe$export$1987ad1ab31f2528(maxItems);
        return $7a3952f20342cebe$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $7a3952f20342cebe$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.storageClient = new (0, $kt8c2.default)($7a3952f20342cebe$var$SMART_CARD_CACHE_CLIENT_KEY, {
            storageEngine: 'sessionStorage'
        });
        this.maxItems = void 0;
        this.memoryCache = void 0;
        this.pendingWrite = false;
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            return this.memoryCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url in storage
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached in storage
     */ this.setItem = (url, response)=>{
            // Add or update the item in the cache with current timestamp
            this.memoryCache[url] = {
                data: response,
                timestamp: Date.now()
            };
            // Apply FIFO behavior if cache exceeds maxItems
            const cacheKeys = Object.keys(this.memoryCache);
            if (cacheKeys.length > this.maxItems) {
                // Sort keys by timestamp (oldest first) and remove the oldest items
                const sortedKeys = cacheKeys.sort((a, b)=>this.memoryCache[a].timestamp - this.memoryCache[b].timestamp);
                const itemsToRemove = cacheKeys.length - this.maxItems;
                const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                keysToRemove.forEach((key)=>{
                    delete this.memoryCache[key];
                });
            }
            // Write through to storage asynchronously (non-blocking)
            // Debounced to batch multiple rapid calls into a single write
            if (!this.pendingWrite) {
                this.pendingWrite = true;
                queueMicrotask(()=>{
                    try {
                        this.storageClient.setItemWithExpiry($7a3952f20342cebe$var$SMART_CARD_CACHE_KEY, JSON.stringify(this.memoryCache));
                    } catch (_) {
                    // Ignore storage write errors (e.g. quota exceeded) to prevent blocking future writes
                    // Cache will still function in-memory for the session, but won't persist
                    } finally{
                        this.pendingWrite = false;
                    }
                });
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url from storage (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            const response = this.memoryCache?.[url]?.data;
            return response;
        };
        /**
     * Checks if a cached entry exists for the provided url in storage
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            return url in this.memoryCache;
        };
        this.maxItems = maxItems;
        // Load cache from storage into memory on instantiation
        const stored = this.storageClient.getItem($7a3952f20342cebe$var$SMART_CARD_CACHE_KEY, {
            useExpiredItem: true
        });
        this.memoryCache = stored ? JSON.parse(stored) : {};
    }
}
$7a3952f20342cebe$var$_SmartCardLocalCacheClient = $7a3952f20342cebe$export$1987ad1ab31f2528;
$7a3952f20342cebe$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $7a3952f20342cebe$export$1987ad1ab31f2528;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("aN0qB", function(module, exports) {
// Usually, one screen contains about 2_500 nodes, so 10_000 is more than enough.
const $e5ce665804adc727$export$d723a039341399fc = 10000;
const $e5ce665804adc727$export$109b6787e4cb0d4c = {
    smartCard: 10,
    emoji: 500
};
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT"] = $e5ce665804adc727$export$d723a039341399fc;
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH"] = $e5ce665804adc727$export$109b6787e4cb0d4c;

});

parcelRegister("hr9NW", function(module, exports) {

var $jC7Je = parcelRequire("jC7Je");


var $eTj7Y = parcelRequire("eTj7Y");


var $ibzAc = parcelRequire("ibzAc");


var $loQgl = parcelRequire("loQgl");


var $k00oi = parcelRequire("k00oi");


var $h9yJL = parcelRequire("h9yJL");


var $477dG = parcelRequire("477dG");


var $yuV6Z = parcelRequire("yuV6Z");


var $32x2E = parcelRequire("32x2E");


var $9WAeG = parcelRequire("9WAeG");


var $jQQYu = parcelRequire("jQQYu");


var $6GQtz = parcelRequire("6GQtz");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $xwvlW = parcelRequire("xwvlW");


var $60cDW = parcelRequire("60cDW");


var $aN0qB = parcelRequire("aN0qB");


var $kY8KV = parcelRequire("kY8KV");


var $6GukH = parcelRequire("6GukH");


var $985xA = parcelRequire("985xA");

const $8323d63e0ec880b7$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData';
const $8323d63e0ec880b7$var$DEFAULT_TIMEOUT = 300;
const $8323d63e0ec880b7$var$EDITOR_CARD_PROVIDER_NAME = 'editorCardProvider';
const $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME = 'externalEditorCardProvider';
const $8323d63e0ec880b7$var$preloadEditorNodeDataProvidersDataQuery = (0, $jC7Je.default);
async function $8323d63e0ec880b7$export$82c96ba69b54d1e5(contentId, cloudId, isBlog) {
    if (!contentId) return;
    if (!(0, $eTj7Y.isSSR)()) // If we are not in SSR, we don't need to preload node data providers data.
    return;
    await (0, $9WAeG.SSRMeasures).run($8323d63e0ec880b7$var$MEASURE_SEGMENT, async ()=>{
        const fetchAdfStart = performance.now();
        const docJsonString = await $8323d63e0ec880b7$var$fetchAdf(contentId);
        const fetchAdfDuration = performance.now() - fetchAdfStart;
        if (!docJsonString) return;
        const doc = JSON.parse(docJsonString);
        // Validate that the parsed document is a valid JSONDocNode
        if (!(0, $985xA.isValidJSONDocNode)(doc)) return;
        const providers = [];
        let syncedBlocksPromise;
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
            if ((0, $h9yJL.isJSONDocNode)(doc)) syncedBlocksPromise = (0, $6GukH.preloadEditorSyncedBlocksData)(contentId, cloudId, isBlog, doc);
        }
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) && (0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isSplittingEnabled', true)) {
            providers.push({
                provider: $8323d63e0ec880b7$export$ebf5846faf5beb2(),
                maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
            });
            providers.push({
                provider: $8323d63e0ec880b7$export$21425f1d7e912e7a(),
                maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
            });
        } else providers.push({
            provider: $8323d63e0ec880b7$var$ssrEditorCardProvider(),
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        });
        const emojiNodeDataProvider = await $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider();
        if (emojiNodeDataProvider) providers.push({
            provider: emojiNodeDataProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).emoji
        });
        providers.forEach(({ provider: provider })=>{
            (0, $9WAeG.SSRMeasures).markMeasureStart($8323d63e0ec880b7$var$measureProviderSegment(provider.name));
        });
        let editorNodeDataProvidersData = await (0, $loQgl.prefetchNodeDataProvidersData)({
            doc: doc,
            providers: providers,
            timeout: ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) ? // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
            (0, $6mKj3.expVal)('cc_editor_node_data_providers_preload_config', 'defaultTimeout', $8323d63e0ec880b7$var$DEFAULT_TIMEOUT) || $8323d63e0ec880b7$var$DEFAULT_TIMEOUT : $8323d63e0ec880b7$var$DEFAULT_TIMEOUT) - fetchAdfDuration,
            maxNodesToVisit: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT)
        });
        Object.entries(editorNodeDataProvidersData).forEach(([providerName, { duration: duration }])=>{
            (0, $9WAeG.SSRMeasures).setMeasureDuration($8323d63e0ec880b7$var$measureProviderSegment(providerName), duration);
        });
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) && (0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isSplittingEnabled', true)) editorNodeDataProvidersData = $8323d63e0ec880b7$export$45312dbe9e8537fb(editorNodeDataProvidersData);
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
            const nodeDataToStore = Object.fromEntries(Object.entries(editorNodeDataProvidersData).map(([providerName, { data: data }])=>[
                    providerName,
                    data
                ]));
            (0, $kY8KV.addToSSREditorNodeDataProvidersStore)(nodeDataToStore);
        } else window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = Object.fromEntries(Object.entries(editorNodeDataProvidersData).map(([providerName, { data: data }])=>[
                providerName,
                data
            ]));
        // Ensure synced blocks data is fully resolved before returning
        if (syncedBlocksPromise) await syncedBlocksPromise;
    });
}
function $8323d63e0ec880b7$export$45312dbe9e8537fb(nodeDataProvidersSsrData, // will merge to the first provider in the list, which is `editorCardProvider` in our case, so it should be listed first in the array
keysOfProviderDataToMerge = [
    $8323d63e0ec880b7$var$EDITOR_CARD_PROVIDER_NAME,
    $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME
]) {
    if (keysOfProviderDataToMerge.length < 2) return nodeDataProvidersSsrData;
    const [mainProviderName, ...sourceKeys] = keysOfProviderDataToMerge;
    const result = {
        ...nodeDataProvidersSsrData
    };
    const processedSourceKeys = new Set();
    for (const sourceKey of sourceKeys){
        if (sourceKey === mainProviderName || processedSourceKeys.has(sourceKey)) continue;
        processedSourceKeys.add(sourceKey);
        const sourceData = result[sourceKey];
        if (sourceData) {
            result[mainProviderName] = result[mainProviderName] || {
                data: {},
                duration: 0,
                success: false
            };
            result[mainProviderName] = {
                data: {
                    ...result[mainProviderName].data,
                    ...sourceData.data
                },
                duration: Math.max(result[mainProviderName].duration, sourceData.duration),
                success: result[mainProviderName].success || sourceData.success
            };
            delete result[sourceKey];
        }
    }
    return result;
}
function $8323d63e0ec880b7$var$fetchAdf(contentId) {
    return (0, $9WAeG.SSRMeasures).run(`${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/fetch:AdfDocQuery`, async ()=>{
        try {
            const result = await (0, $dYU3e.query)({
                query: $8323d63e0ec880b7$var$preloadEditorNodeDataProvidersDataQuery,
                variables: {
                    contentId: contentId,
                    status: [
                        'draft'
                    ]
                },
                fetchPolicy: 'network-only',
                __callerPackage__: "@confluence/load-edit-page"
            });
            if (result.hasErrors) return undefined;
            return result.data?.singleContent?.body?.atlas_doc_format?.value || undefined;
        } catch  {
            return undefined;
        }
    });
}
async function $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider() {
    const { userId: userId, cloudId: cloudId, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    // We need a special emoji parameters that supports SSR load optimization here.
    const emojiResourceParams = (0, $yuV6Z.createEmojiProviderParameters)({
        cloudId: cloudId,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn
    });
    return (0, $32x2E.getEmojiNodeDataProvider)((0, $ibzAc.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
}
function $8323d63e0ec880b7$var$ssrEditorCardProvider() {
    const { host: host, cloudId: cloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
    const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
    const ssrCardClient = new (0, $k00oi.default)('custom', objectResolverURL);
    ssrCardClient.setHeaders({
        Cookie: (0, $jQQYu.createCookie)(userContext),
        Origin: host.startsWith('http') ? host : `https://${host}`,
        CloudId: cloudId
    });
    // No URL filter: accepts both internal and external URLs
    return new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient);
}
function $8323d63e0ec880b7$var$createSSREditorCardProvider(urlFilter, nameOverride) {
    const { host: host, cloudId: cloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
    // This URL will be something like `https://object-resolver.staging.atl-paas.net/resolve/batch`.
    // We need only protocol and host to pass it to the EditorCardProvider,
    // because path will be added by `CardClient`.
    const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
    // We need to define a custom CardClient for SSR, because the default one works through public API gateway.
    const ssrCardClient = new (0, $k00oi.default)('custom', objectResolverURL);
    // Headers from `fetchORSForSSR` from confluence/next/packages/content-smartlinks/src/index.ts
    ssrCardClient.setHeaders({
        Cookie: (0, $jQQYu.createCookie)(userContext),
        Origin: host.startsWith('http') ? host : `https://${host}`,
        CloudId: cloudId
    });
    return new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient, urlFilter, nameOverride);
}
function $8323d63e0ec880b7$export$ebf5846faf5beb2() {
    return $8323d63e0ec880b7$var$createSSREditorCardProvider((0, $477dG.isInternalUrl));
}
function $8323d63e0ec880b7$export$21425f1d7e912e7a() {
    return $8323d63e0ec880b7$var$createSSREditorCardProvider((0, $477dG.isExternalUrl), $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME);
}
function $8323d63e0ec880b7$var$measureProviderSegment(providerName) {
    return `${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/${providerName}`;
}
module.exports["preloadEditorNodeDataProvidersData"] = $8323d63e0ec880b7$export$82c96ba69b54d1e5;

});

parcelRegister("jC7Je", function(module, exports) {
/**
 * @generated SignedSource<<a5c664904afb7aa720df5692f74ea8df>>
 * @relayHash 72f0e11f3a3324a5c8d9d9a03df96df2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6de5103060e3ef016dd939ce41c1ace25f1b934ec83c466b567b4f6ef2e2985
const $f23059387da63ee7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "72f0e11f3a3324a5c8d9d9a03df96df2",
            "id": "c6de5103060e3ef016dd939ce41c1ace25f1b934ec83c466b567b4f6ef2e2985",
            "metadata": {},
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "operationKind": "query",
            "text": "query preloadEditorNodeDataProvidersDataQuery($contentId:ID,$status:[String]){singleContent(id:$contentId,status:$status){id,body{atlas_doc_format{value}}}}"
        }
    };
}();
$f23059387da63ee7$var$node.hash = "b082e4555a8e2adb34e1cfb641ee98a0";
var $f23059387da63ee7$export$2e2bcd8739ae039 = $f23059387da63ee7$var$node;
module.exports["default"] = $f23059387da63ee7$export$2e2bcd8739ae039;

});

parcelRegister("loQgl", function(module, exports) {

var $et4nk = parcelRequire("et4nk");

async function $33eee30649b8eece$export$65217f7ac34c2278({ providers: providers, doc: doc, timeout: timeout, maxNodesToVisit: maxNodesToVisit = Infinity }) {
    if (timeout <= 0) // If the global timeout is 0 or negative, skip fetching entirely.
    return providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            data: {},
            success: false,
            duration: 0
        };
        return acc;
    }, {});
    const providersWithDefaults = providers.map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch = Infinity, timeout: providerTimeout = Infinity })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            // Use the minimum of the global timeout and the provider-specific timeout
            timeout: Math.min(providerTimeout, timeout)
        }));
    const providerTimeouts = providersWithDefaults.reduce((acc, { provider: provider, timeout: timeout })=>{
        acc[provider.name] = timeout;
        return acc;
    }, {});
    const nodesWithProviders = (0, $et4nk.findNodesToPrefetch)(doc, providersWithDefaults, maxNodesToVisit).map(({ provider: provider, nodes: nodes })=>({
            provider: provider,
            nodes: nodes,
            timeout: providerTimeouts[provider.name]
        }));
    const promises = nodesWithProviders.map(async ({ nodes: nodes, provider: provider, timeout: timeout })=>{
        if (timeout <= 0) return {
            provider: provider,
            success: false,
            duration: 0,
            nodes: nodes,
            data: []
        };
        const start = performance.now();
        function getDurationFromStart() {
            return Math.min(performance.now() - start, timeout);
        }
        try {
            const timeoutPromise = new Promise((_, reject)=>{
                setTimeout(()=>{
                    reject();
                }, timeout);
            });
            const data = await Promise.race([
                provider.fetchNodesData(nodes),
                timeoutPromise
            ]);
            return {
                provider: provider,
                success: true,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: data
            };
        } catch  {
            return {
                provider: provider,
                success: false,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: []
            };
        }
    });
    const results = await Promise.all(promises);
    return results.reduce((acc, { provider: provider, success: success, duration: duration, nodes: nodes, data: data })=>{
        const ssrData = data.reduce((providerSsrData, nodeData, nodeIndex)=>{
            const node = nodes[nodeIndex];
            const nodeDataKey = provider.nodeDataKey(node);
            providerSsrData[nodeDataKey] = nodeData;
            return providerSsrData;
        }, {});
        acc[provider.name] = {
            data: ssrData,
            success: success,
            duration: duration
        };
        return acc;
    }, {});
}
module.exports["prefetchNodeDataProvidersData"] = $33eee30649b8eece$export$65217f7ac34c2278;

});

parcelRegister("yuV6Z", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    const baseUrl = (0, $dh538.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $fJJ4V = parcelRequire("fJJ4V");


var $i0VEL = parcelRequire("i0VEL");


var $dZ8uq = parcelRequire("dZ8uq");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $dZ8uq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $fJJ4V.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $dZ8uq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                const unicodeEmoji = (0, $fJJ4V.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("jQQYu", function(module, exports) {
// Creates a cookie for object-resolver header
const $64671b371f568ec9$export$7892c26d6c7a7447 = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
module.exports["createCookie"] = $64671b371f568ec9$export$7892c26d6c7a7447;

});

parcelRegister("kY8KV", function(module, exports) {
/**
 * Adds data to the SSR editor node data providers store on the window object.
 * This allows multiple loaders to safely add data to the same object without
 * overwriting each other's data.
 *
 * @param data - The data to merge into the existing store
 */ function $5ae7655949a69969$export$a2bf498e230933ac(data) {
    const existingData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
    window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = {
        ...existingData,
        ...data
    };
}
module.exports["addToSSREditorNodeDataProvidersStore"] = $5ae7655949a69969$export$a2bf498e230933ac;

});

parcelRegister("6GukH", function(module, exports) {

var $45MGZ = parcelRequire("45MGZ");

const $86855d2f29349b22$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/syncedBlocksData';
async function $86855d2f29349b22$export$bd3ad760f826791(contentId, cloudId, isBlog, doc) {
    if (!contentId || !cloudId || typeof isBlog === 'undefined') return;
    return (0, $45MGZ.preloadSyncedBlocksData)({
        contentId: contentId,
        cloudId: cloudId,
        isBlog: isBlog,
        doc: doc,
        measureSegment: $86855d2f29349b22$var$MEASURE_SEGMENT
    });
}
module.exports["preloadEditorSyncedBlocksData"] = $86855d2f29349b22$export$bd3ad760f826791;

});

parcelRegister("45MGZ", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $l1vR8 = parcelRequire("l1vR8");


var $f8eu7 = parcelRequire("f8eu7");


var $47N43 = parcelRequire("47N43");


var $awHlv = parcelRequire("awHlv");


var $ghBq4 = parcelRequire("ghBq4");


var $9WAeG = parcelRequire("9WAeG");


var $1i2qc = parcelRequire("1i2qc");


var $6mKj3 = parcelRequire("6mKj3");


var $3mugH = parcelRequire("3mugH");


var $kY8KV = parcelRequire("kY8KV");


var $8AcAF = parcelRequire("8AcAF");


var $l9Wsf = parcelRequire("l9Wsf");

const $8435e015d85a0f69$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/syncedBlocksData';
// Timeout for fetching synced block references in milliseconds
// This is currently set to higher value to account for potential network latencys
// We will monitor performance and adjust this value as needed
const $8435e015d85a0f69$var$DEFAULT_TIMEOUT = 1500;
// New default timeout for batch fetch implementation, which includes more relistics value
const $8435e015d85a0f69$var$DEFAULT_TIMEOUT_NEXT = 500;
async function $8435e015d85a0f69$export$1de9b28b2fdef558(options) {
    const { contentId: contentId, cloudId: cloudId, isBlog: isBlog, doc: doc, measureSegment: measureSegment, timeout: timeout } = options;
    // Check feature flags before attempting to fetch synced block data
    if (!contentId || !cloudId || !doc || !(0, $eTj7Y.isSSR)() || typeof isBlog === 'undefined' || !(0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Skipped synced blocks preload: guard condition failed'), {
            isSsr: (0, $eTj7Y.isSSR)(),
            contentId: contentId,
            cloudId: cloudId,
            isBlog: isBlog
        });
        return;
    }
    const segmentName = measureSegment || $8435e015d85a0f69$var$MEASURE_SEGMENT;
    let blockNodeIdentifiers = [];
    // When FG is enabled, check for empty synced blocks BEFORE entering the measured run
    // so pages with no synced blocks don't record a metric for this segment
    blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
    if (blockNodeIdentifiers.length === 0) return;
    if (doc && (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) {
        blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
        // If no synced blocks found, return early
        if (blockNodeIdentifiers.length === 0) return;
    }
    await (0, $9WAeG.SSRMeasures).run(segmentName, async ()=>{
        // Use bulk load (batchFetchData) when doc is available
        if (doc) // Extract block identifiers from the ADF document
        {
            if (!(0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
        }
        const syncBlockReferences = await $8435e015d85a0f69$export$9523b76ee01ef6d(contentId, cloudId, isBlog, blockNodeIdentifiers, segmentName, timeout);
        if (!syncBlockReferences) {
            if (blockNodeIdentifiers.length > 0) (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Synced block fetch returned incomplete results: ${blockNodeIdentifiers.length} blocks missing`), {
                code: (0, $ghBq4.SyncedBlocksSSRErrorCodeMap).FETCH_INCOMPLETE,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                missingIdentifiers: blockNodeIdentifiers
            });
            return;
        }
        // check if results match the requested block identifiers, if not,
        // it means the fetch was likely incomplete/failed,
        if (syncBlockReferences.length !== blockNodeIdentifiers.length) {
            // Find which block identifiers are missing from the results
            const returnedIdentifiers = new Set(syncBlockReferences.map((ref)=>`${ref.resourceId}:${ref.data?.blockInstanceId ?? 'unknown'}`));
            const missingIdentifiers = blockNodeIdentifiers.filter((identifier)=>!returnedIdentifiers.has(`${identifier.resourceId}:${identifier.blockInstanceId}`));
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Synced block fetch returned incomplete results: ${missingIdentifiers.length} blocks missing`), {
                code: (0, $ghBq4.SyncedBlocksSSRErrorCodeMap).FETCH_INCOMPLETE,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                missingIdentifiers: missingIdentifiers
            });
        }
        (0, $kY8KV.addToSSREditorNodeDataProvidersStore)({
            syncBlocks: syncBlockReferences
        });
        const syncedBlocksWithMedia = syncBlockReferences.filter((syncBlock)=>{
            // Preload media data providers for synced blocks that contain media nodes
            const containedNodeTypes = (0, $8AcAF.syncBlockContainsNodes)(syncBlock, [
                'media'
            ]);
            return containedNodeTypes.length > 0 && containedNodeTypes.includes('media');
        });
        const tasks = [];
        syncedBlocksWithMedia.forEach((syncBlockInstance)=>{
            tasks.push($8435e015d85a0f69$export$6df3cdf918cdf771(syncBlockInstance));
        });
        await Promise.allSettled(tasks);
    });
}
async function $8435e015d85a0f69$export$6df3cdf918cdf771(syncBlock) {
    if (!syncBlock) return null;
    const { product: product, contentId: contentId } = (0, $47N43.parseResourceId)(syncBlock.resourceId) || {};
    if (!product) return {
        resourceId: syncBlock.resourceId,
        result: undefined
    };
    if (product === 'confluence-page') {
        if (!contentId) return {
            resourceId: syncBlock.resourceId,
            result: undefined
        };
        const result = await (0, $1i2qc.preloadMediaToken)(contentId);
        return {
            resourceId: syncBlock.resourceId,
            result: result
        };
    }
    if (product === 'jira-work-item') {
        const jiraIssueAri = syncBlock.data?.sourceAri;
        if (!jiraIssueAri) return {
            resourceId: syncBlock.resourceId,
            result: undefined
        };
        const result = await (0, $1i2qc.preloadJiraMediaToken)(jiraIssueAri);
        return {
            resourceId: syncBlock.resourceId,
            result: result
        };
    }
    return null;
}
function $8435e015d85a0f69$export$9523b76ee01ef6d(contentId, cloudId, isBlog, blockNodeIdentifiers, measureSegment = $8435e015d85a0f69$var$MEASURE_SEGMENT, timeout = (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false) ? $8435e015d85a0f69$var$DEFAULT_TIMEOUT_NEXT : $8435e015d85a0f69$var$DEFAULT_TIMEOUT) {
    return (0, $9WAeG.SSRMeasures).run(`${measureSegment}/fetch:SyncBlockReferences`, async ()=>{
        const pageAri = (0, $f8eu7.getConfluencePageAri)({
            cloudId: cloudId,
            pageId: contentId,
            pageType: isBlog ? 'blogpost' : 'page'
        });
        const timeoutError = new Error('timeout');
        let batchFetchDataConfig = undefined;
        if ((0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) batchFetchDataConfig = {
            timeoutMs: (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'timeout', null) ?? timeout,
            isSSR: (0, $eTj7Y.isSSR)(),
            maxBatchSize: (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'maxBatchSize', null) ?? undefined
        };
        try {
            let results;
            if ((0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) // We only passing the batchFetchDataConfig when the experiment is enabled,
            // however, batchFetchData is NOT gateed.
            results = await (0, $l1vR8.batchFetchData)(cloudId, pageAri, blockNodeIdentifiers, batchFetchDataConfig);
            else results = await Promise.race([
                (0, $l1vR8.batchFetchData)(cloudId, pageAri, blockNodeIdentifiers),
                new Promise((_resolve, reject)=>setTimeout(()=>{
                        reject(timeoutError);
                    }, timeout))
            ]);
            if (!results) {
                // No results returned - this could indicate a failure in the batch fetch operation
                // this would not be timeout, as it will throw a timeout error instead,
                // so we can attribute this to a fetch failure and log accordingly
                (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Synced blocks fetch returned no results'), {
                    code: (0, $ghBq4.SyncedBlocksSSRErrorCodeMap).BATCH_FETCH_FAILED,
                    contentId: contentId,
                    cloudId: cloudId,
                    isBlog: isBlog,
                    identifiers: blockNodeIdentifiers
                });
                return undefined;
            }
            // check if result is timeout error
            if (Array.isArray(results) && results.length > 0 && (0, $eTj7Y.isSSR)() && // we only want to apply this logic for SSR, as in client side we can allow for retries and better error handling.
            (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) {
                const isTimeout = results.some((result)=>(0, $awHlv.SyncBlockError).Aborted === result.error?.type);
                if (isTimeout) {
                    // This means the batch fetch operation timed out
                    (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Synced blocks fetch operation timed out'), {
                        code: (0, $ghBq4.SyncedBlocksSSRErrorCodeMap).FETCH_TIMEOUT,
                        contentId: contentId,
                        cloudId: cloudId,
                        isBlog: isBlog,
                        identifiers: blockNodeIdentifiers
                    });
                    // we don't want to return timeout results,
                    // as it might cause error on the initial page load.
                    return undefined;
                }
            }
            return results;
        } catch (error) {
            // Network or API error
            const errorMessage = error instanceof Error ? error.message : String(error);
            const errorName = error instanceof Error ? error.name : undefined;
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Batch fetch for synced blocks failed: unable to fetch ${blockNodeIdentifiers.length} blocks`), {
                code: (0, $ghBq4.SyncedBlocksSSRErrorCodeMap).BATCH_FETCH_FAILED,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                errorMessage: errorMessage,
                errorName: errorName
            });
            return undefined;
        }
    });
}
module.exports["preloadSyncedBlocksData"] = $8435e015d85a0f69$export$1de9b28b2fdef558;

});

parcelRegister("l1vR8", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ 
var $42omo = parcelRequire("42omo");


var $1oCLl = parcelRequire("1oCLl");


var $ejAeh = parcelRequire("ejAeh");


var $7SvKC = parcelRequire("7SvKC");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $47N43 = parcelRequire("47N43");


var $gtauf = parcelRequire("gtauf");

const $b01c0675c087bdaf$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX = /^ari:cloud:blocks:.*:synced-block\/(.+)$/;
const $b01c0675c087bdaf$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/(.+)$/;
const $b01c0675c087bdaf$var$mapBlockError = (error)=>{
    switch(error.status){
        case 400:
        case 401:
            return (0, $awHlv.SyncBlockError).InvalidRequest;
        case 403:
            return (0, $awHlv.SyncBlockError).Forbidden;
        case 404:
            return (0, $awHlv.SyncBlockError).NotFound;
        case 409:
            return (0, $awHlv.SyncBlockError).Conflict;
        case 429:
            return (0, $awHlv.SyncBlockError).RateLimited;
        case 500:
        case 503:
        case 504:
            return (0, $awHlv.SyncBlockError).ServerError;
    }
    return (0, $awHlv.SyncBlockError).Errored;
};
const $b01c0675c087bdaf$var$mapErrorResponseCode = (errorCode)=>{
    switch(errorCode){
        case 'FORBIDDEN':
            return (0, $awHlv.SyncBlockError).Forbidden;
        case 'RESOURCE_NOT_FOUND':
        case 'NOT_FOUND':
            return (0, $awHlv.SyncBlockError).NotFound;
        case 'EntityNotFound':
            return (0, $awHlv.SyncBlockError).EntityNotFound;
        case 'INVALID_REQUEST':
            return (0, $awHlv.SyncBlockError).InvalidRequest;
        case 'CONFLICT':
            return (0, $awHlv.SyncBlockError).Conflict;
        case 'RATE_LIMITED':
            return (0, $awHlv.SyncBlockError).RateLimited;
        case 'SERVER_ERROR':
            return (0, $awHlv.SyncBlockError).ServerError;
        case 'INVALID_CONTENT':
            return (0, $awHlv.SyncBlockError).InvalidContent;
        default:
            return (0, $awHlv.SyncBlockError).Errored;
    }
};
const $b01c0675c087bdaf$export$7a367d6c9621d11 = (blockAri)=>{
    // Validate ARI format and extract resourceId using regex
    // Format: ari:cloud:blocks:{uuid}:synced-block/{product}/{parentId}/{resourceId}
    // The regex captures the full path after synced-block/
    // e.g. ari:cloud:blocks:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:synced-block/confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    // should return confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    const match = blockAri.match($b01c0675c087bdaf$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX);
    return match?.[1] || null;
};
const $b01c0675c087bdaf$export$bba762cb095b2f42 = (data, resourceId)=>{
    let createdAt;
    if (data.createdAt !== undefined && data.createdAt !== null) try {
        createdAt = new Date(data.createdAt).toISOString();
    } catch  {
        // fallback to undefined
        // as we don't want to block the whole process due to invalid date
        createdAt = undefined;
    }
    return {
        blockInstanceId: data.blockInstanceId,
        content: JSON.parse(data.content),
        contentUpdatedAt: (0, $gtauf.convertContentUpdatedAt)(data.contentUpdatedAt),
        createdAt: createdAt,
        createdBy: data.createdBy,
        product: data.product,
        resourceId: resourceId,
        sourceAri: data.sourceAri,
        status: data.status
    };
};
const $b01c0675c087bdaf$export$17132bdfdc28611c = async (documentAri)=>{
    let response;
    try {
        response = await (0, $7SvKC.getReferenceSyncedBlocks)(documentAri);
    } catch (error) {
        if (error instanceof (0, $7SvKC.BlockError)) return $b01c0675c087bdaf$var$mapBlockError(error);
        return (0, $awHlv.SyncBlockError).Errored;
    }
    const { blocks: blocks, errors: errors } = response || {};
    const blocksInstances = (blocks || []).map((blockContentResponse)=>{
        try {
            const resourceId = $b01c0675c087bdaf$export$7a367d6c9621d11(blockContentResponse.blockAri);
            if (!resourceId) // could not extract resourceId from blockAri, return InvalidContent error
            return {
                error: {
                    type: (0, $awHlv.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
            return {
                data: $b01c0675c087bdaf$export$bba762cb095b2f42(blockContentResponse, resourceId),
                resourceId: resourceId
            };
        } catch  {
            // JSON parsing error, return InvalidContent error
            return {
                error: {
                    type: (0, $awHlv.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
        }
    });
    const errorInstances = (errors || []).map((errorBlock)=>({
            error: {
                type: (0, $awHlv.SyncBlockError).Errored
            },
            resourceId: errorBlock.blockAri
        }));
    return [
        ...blocksInstances,
        ...errorInstances
    ];
};
const $b01c0675c087bdaf$export$2837853885c81488 = (blockAri)=>{
    const match = blockAri.match($b01c0675c087bdaf$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX);
    return match?.[1];
};
const $b01c0675c087bdaf$export$abdcb5d4d6767e73 = async (cloudId, parentAri, blockNodeIdentifiers, config)=>{
    const blockIdentifiers = blockNodeIdentifiers.map((blockIdentifier)=>({
            blockAri: (0, $ejAeh.generateBlockAriFromReference)({
                cloudId: cloudId,
                resourceId: blockIdentifier.resourceId
            }),
            blockInstanceId: blockIdentifier.blockInstanceId
        }));
    // Create a set of valid resourceIds for validation
    const validResourceIds = new Set(blockNodeIdentifiers.map((blockNodeIdentifier)=>blockNodeIdentifier.resourceId));
    // Track which resourceIds have been processed
    const processedResourceIds = new Set();
    if (!parentAri) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
            error: {
                type: (0, $awHlv.SyncBlockError).Errored
            },
            resourceId: blockNodeIdentifier.resourceId
        }));
    try {
        const response = await (0, $7SvKC.batchRetrieveSyncedBlocks)({
            blockIdentifiers: blockIdentifiers,
            config: config
        });
        const results = [];
        // Process successful blocks
        if (response.success) for (const blockContentResponse of response.success){
            // Extract resourceId from the returned blockAri
            const resourceId = $b01c0675c087bdaf$export$2837853885c81488(blockContentResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            const { content: content, deletionReason: deletionReason, sourceAri: sourceAri, blockAri: blockAri, contentUpdatedAt: contentUpdatedAt, blockInstanceId: blockInstanceId, product: product, status: status } = blockContentResponse;
            if (!content) {
                results.push({
                    error: {
                        type: (0, $awHlv.SyncBlockError).NotFound,
                        reason: deletionReason,
                        sourceAri: sourceAri
                    },
                    resourceId: resourceId
                });
                continue;
            }
            try {
                const syncedBlockData = JSON.parse(content);
                results.push({
                    data: {
                        content: syncedBlockData,
                        resourceId: blockAri,
                        contentUpdatedAt: (0, $gtauf.convertContentUpdatedAt)(contentUpdatedAt),
                        blockInstanceId: blockInstanceId,
                        sourceAri: sourceAri,
                        product: product,
                        status: status,
                        deletionReason: deletionReason
                    },
                    resourceId: resourceId
                });
            } catch  {
                results.push({
                    error: {
                        type: (0, $awHlv.SyncBlockError).Errored,
                        reason: `parsing JSON content response failed for resourceId: ${resourceId} localId: ${blockAri}`
                    },
                    resourceId: resourceId
                });
            }
        }
        // Process errors
        if (response.error) for (const errorResponse of response.error){
            // Extract resourceId from the returned blockAri
            const resourceId = $b01c0675c087bdaf$export$2837853885c81488(errorResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            results.push({
                error: {
                    type: $b01c0675c087bdaf$var$mapErrorResponseCode(errorResponse.code),
                    reason: errorResponse.reason
                },
                resourceId: resourceId
            });
        }
        // Ensure all resourceIds have a result - return NotFound for any missing ones
        for (const blockNodeIdentifier of blockNodeIdentifiers)if (!processedResourceIds.has(blockNodeIdentifier.resourceId)) results.push({
            error: {
                type: (0, $awHlv.SyncBlockError).NotFound
            },
            resourceId: blockNodeIdentifier.resourceId
        });
        return results;
    } catch (error) {
        if (error instanceof (0, $7SvKC.BlockTimeoutError) && (0, $1oCLl.expValEquals)('platform_editor_sync_block_ssr_config', 'isEnabled', true)) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: (0, $awHlv.SyncBlockError).Aborted,
                    reason: error.message
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
        // If batch request fails, return error for all resourceIds. Capture the HTTP
        // status from `BlockError` so fetch analytics can break failures down by
        // statusCode (EDITOR-7862); undefined for non-HTTP failures.
        return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: error instanceof (0, $7SvKC.BlockError) ? $b01c0675c087bdaf$var$mapBlockError(error) : (0, $awHlv.SyncBlockError).Errored,
                    reason: error.message,
                    ...error instanceof (0, $7SvKC.BlockError) && {
                        statusCode: error.status
                    }
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
    }
};
const $b01c0675c087bdaf$export$13b682467148f88a = async (cloudId, parentAri, parentId, product, data, stepVersion)=>{
    if (!parentAri || !parentId) return data.map((block)=>({
            error: (0, $awHlv.SyncBlockError).Errored,
            resourceId: block.resourceId
        }));
    try {
        // Create a map from blockAri to original resourceId for matching responses
        const blockAriToResourceIdMap = new Map();
        const blocks = data.map((block)=>{
            const blockAri = (0, $ejAeh.generateBlockAri)({
                cloudId: cloudId,
                parentId: parentId,
                product: product,
                resourceId: block.resourceId
            });
            blockAriToResourceIdMap.set(blockAri, block.resourceId);
            return {
                blockAri: blockAri,
                content: JSON.stringify(block.content),
                status: block.status,
                stepVersion: stepVersion
            };
        });
        const response = await (0, $7SvKC.updateSyncedBlocks)({
            blocks: blocks
        });
        const results = [];
        // Process successful updates
        if (response.success) {
            const successResourceIds = new Set(response.success.map((block)=>blockAriToResourceIdMap.get(block.blockAri)));
            for (const block of data)if (successResourceIds.has(block.resourceId)) results.push({
                resourceId: block.resourceId
            });
        }
        if (response.error) {
            const errorResourceIds = new Map(response.error.map((err)=>[
                    // Use the map to get the original resourceId
                    blockAriToResourceIdMap.get(err.blockAri) || '',
                    $b01c0675c087bdaf$var$mapErrorResponseCode(err.code)
                ]));
            for (const block of data){
                const error = errorResourceIds.get(block.resourceId);
                if (error) results.push({
                    error: error,
                    resourceId: block.resourceId
                });
                else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                results.push({
                    error: (0, $awHlv.SyncBlockError).Errored,
                    resourceId: block.resourceId
                });
            }
        }
        return results;
    } catch (error) {
        if (error instanceof (0, $7SvKC.BlockError)) return data.map((block)=>({
                error: $b01c0675c087bdaf$var$mapBlockError(error),
                resourceId: block.resourceId,
                statusCode: error.status
            }));
        return data.map((block)=>({
                error: (0, $cFpEg.stringifyError)(error),
                resourceId: block.resourceId
            }));
    }
};

/**
 * ADFFetchProvider implementation that fetches synced block data from Block Service API
 */ class $b01c0675c087bdaf$var$BlockServiceADFFetchProvider {
    // resourceId of the reference synced block.
    // the ARI must be constructed to call the block service API
    async fetchData(resourceId) {
        const blockAri = (0, $ejAeh.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        try {
            const blockContentResponse = await (0, $7SvKC.getSyncedBlockContent)({
                blockAri: blockAri
            });
            const { content: content, sourceAri: sourceAri, deletionReason: deletionReason, blockInstanceId: blockInstanceId, contentUpdatedAt: contentUpdatedAt, product: product, status: status } = blockContentResponse;
            if (!content) return {
                error: {
                    type: (0, $awHlv.SyncBlockError).NotFound,
                    reason: deletionReason,
                    sourceAri: sourceAri
                },
                resourceId: resourceId
            };
            // Parse the synced block content from the response's content
            const syncedBlockData = JSON.parse(content);
            return {
                data: {
                    content: syncedBlockData,
                    resourceId: blockAri,
                    blockInstanceId: blockInstanceId,
                    // this was the node's localId, but has become the resourceId.
                    contentUpdatedAt: (0, $gtauf.convertContentUpdatedAt)(contentUpdatedAt),
                    sourceAri: sourceAri,
                    product: product,
                    status: status,
                    deletionReason: deletionReason
                },
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) // Capture the HTTP status so fetch analytics can break failures down by
            // statusCode (EDITOR-7862).
            return {
                error: {
                    type: $b01c0675c087bdaf$var$mapBlockError(error),
                    reason: error.message,
                    statusCode: error.status
                },
                resourceId: resourceId
            };
            return {
                error: {
                    type: (0, $awHlv.SyncBlockError).Errored,
                    reason: error.message
                },
                resourceId: resourceId
            };
        }
    }
    async fetchReferences(referenceResourceId) {
        try {
            const blockAri = (0, $ejAeh.generateBlockAriFromReference)({
                cloudId: this.cloudId,
                resourceId: referenceResourceId
            });
            const response = await (0, $7SvKC.getReferenceSyncedBlocksByBlockAri)({
                blockAri: blockAri
            });
            const references = [];
            response.references.forEach((reference)=>{
                references.push({
                    ...reference,
                    hasAccess: true,
                    onSameDocument: this.parentAri === reference.documentAri
                });
            });
            response.errors.forEach((reference)=>{
                if (reference.code === 'FORBIDDEN') references.push({
                    blockAri: reference.blockAri,
                    documentAri: reference.documentAri,
                    hasAccess: false,
                    onSameDocument: false
                });
            });
            return {
                references: references
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                error: $b01c0675c087bdaf$var$mapBlockError(error)
            };
            return {
                error: (0, $awHlv.SyncBlockError).Errored
            };
        }
    }
    /**
   * Batch fetches multiple synced blocks by their resource IDs.
   * @param blockNodeIdentifiers - Array of block node identifiers to fetch
   * @param config - Optional batch fetch configuration
   * @returns Array of SyncBlockInstance results
   */ async batchFetchData(blockNodeIdentifiers, config) {
        return await $b01c0675c087bdaf$export$abdcb5d4d6767e73(this.cloudId, this.parentAri, blockNodeIdentifiers, config);
    }
    /**
   * Subscribes to real-time updates for a specific block using GraphQL WebSocket subscriptions.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete) {
        const blockAri = (0, $ejAeh.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        // Track the real unsubscribe fn once the dynamic import resolves
        let unsubscribe;
        let cancelled = false;
        // Dynamically import blockSubscription so that graphql-ws is NOT pulled
        // into the SSR/preload bundle that imports this subpath.
        (parcelRequire("3fCEs")).then(({ subscribeToBlockUpdates: subscribeToBlockUpdatesWS })=>{
            if (cancelled) return;
            unsubscribe = subscribeToBlockUpdatesWS(blockAri, (parsedData)=>{
                // Convert ParsedBlockSubscriptionData to SyncBlockInstance
                const syncBlockInstance = {
                    data: {
                        content: parsedData.content,
                        resourceId: parsedData.blockAri,
                        blockInstanceId: parsedData.blockInstanceId,
                        sourceAri: parsedData.sourceAri,
                        product: parsedData.product,
                        createdAt: parsedData.createdAt,
                        contentUpdatedAt: parsedData.contentUpdatedAt,
                        createdBy: parsedData.createdBy,
                        status: parsedData.status
                    },
                    resourceId: parsedData.resourceId
                };
                onUpdate(syncBlockInstance);
            }, onError, onComplete);
        }).catch((err)=>{
            if (cancelled) return;
            onError?.(err instanceof Error ? err : new Error('Failed to load subscription module'));
        });
        // Return an unsubscribe fn that works whether the import has resolved or not
        return ()=>{
            cancelled = true;
            unsubscribe?.();
        };
    }
    constructor({ cloudId: cloudId, parentAri: parentAri }){
        this.cloudId = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
    }
}
/**
 * ADFWriteProvider implementation that writes synced block data to Block Service API
 */ class $b01c0675c087bdaf$var$BlockServiceADFWriteProvider {
    async writeData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $awHlv.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $ejAeh.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            const status = data.status;
            await (0, $7SvKC.updateSyncedBlock)({
                blockAri: blockAri,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                error: $b01c0675c087bdaf$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $cFpEg.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    async createData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $awHlv.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $ejAeh.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        const status = 'unpublished';
        try {
            await (0, $7SvKC.createSyncedBlock)({
                blockAri: blockAri,
                blockInstanceId: data.blockInstanceId,
                sourceAri: this.parentAri,
                product: this.product,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                error: $b01c0675c087bdaf$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $cFpEg.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    // soft deletes the source synced block
    async deleteData(resourceId, deleteReason) {
        if (!this.parentId) return {
            resourceId: resourceId,
            success: false,
            error: (0, $awHlv.SyncBlockError).Errored
        };
        const blockAri = (0, $ejAeh.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        try {
            await (0, $7SvKC.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockNotFoundError) && this.parentAri) return this.deleteOrphanBlock({
                blockAri: blockAri,
                resourceId: resourceId,
                parentAri: this.parentAri,
                deleteReason: deleteReason
            });
            if (error instanceof (0, $7SvKC.BlockError)) {
                if (error.status === 404) // User should not be blocked by not_found error when deleting,
                // hence returns successful result for 404 error
                return {
                    resourceId: resourceId,
                    success: true
                };
                return {
                    resourceId: resourceId,
                    success: false,
                    error: $b01c0675c087bdaf$var$mapBlockError(error),
                    statusCode: error.status
                };
            }
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $cFpEg.stringifyError)(error)
            };
        }
    }
    // The block is an orphan (e.g. from a copied page) — it doesn't exist in Block Service.
    // Block Service uses soft-deletes, so we must first create the block then delete it,
    // ensuring a deletion-reason record is stored (used to display errors in reference blocks).
    async deleteOrphanBlock({ blockAri: blockAri, resourceId: resourceId, parentAri: parentAri, deleteReason: deleteReason }) {
        try {
            const stepVersion = this.getVersion ? await this.getVersion() : undefined;
            try {
                await (0, $7SvKC.createSyncedBlock)({
                    blockAri: blockAri,
                    blockInstanceId: resourceId,
                    sourceAri: parentAri,
                    product: this.product,
                    content: '[]',
                    stepVersion: stepVersion
                });
            } catch (createError) {
                // "Conditional check failed" means the block already exists in Block Service.
                // This can happen when an orphan block is copied and pasted — a reference block repair
                // in the backend may have already created it. We can proceed directly to delete it.
                if (createError instanceof Error && createError.message.includes('Conditional check failed')) ;
                else if (createError instanceof (0, $7SvKC.BlockError)) return {
                    resourceId: resourceId,
                    success: false,
                    error: $b01c0675c087bdaf$var$mapBlockError(createError),
                    statusCode: createError.status
                };
                else return {
                    resourceId: resourceId,
                    success: false,
                    error: (0, $cFpEg.stringifyError)(createError)
                };
            }
            await (0, $7SvKC.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                resourceId: resourceId,
                success: false,
                error: $b01c0675c087bdaf$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $cFpEg.stringifyError)(error)
            };
        }
    }
    // the sourceId is the resourceId of the source synced block.
    generateResourceIdForReference(sourceId) {
        return (0, $47N43.createResourceIdForReference)(this.product, this.parentId || '', sourceId);
    }
    generateResourceId() {
        return crypto.randomUUID();
    }
    generateBlockAri(resourceId) {
        return (0, $ejAeh.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId || '',
            product: this.product,
            resourceId: resourceId
        });
    }
    async updateReferenceData(blocks, noContent) {
        if (!this.parentAri) return {
            success: false,
            error: (0, $awHlv.SyncBlockError).Errored
        };
        try {
            await (0, $7SvKC.updateReferenceSyncedBlockOnDocument)({
                documentAri: this.parentAri,
                blocks: blocks.map((block)=>({
                        blockAri: (0, $ejAeh.generateBlockAriFromReference)({
                            cloudId: this.cloudId,
                            resourceId: block.resourceId
                        }),
                        blockInstanceId: block.localId
                    })),
                noContent: noContent
            });
            return {
                success: true
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                success: false,
                error: $b01c0675c087bdaf$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                success: false,
                error: (0, $cFpEg.stringifyError)(error)
            };
        }
    }
    async writeDataBatch(data) {
        if (!this.parentAri || !this.parentId) return data.map((block)=>({
                error: (0, $awHlv.SyncBlockError).Errored,
                resourceId: block.resourceId
            }));
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            // Create a map from blockAri to original resourceId for matching responses
            const blockAriToResourceIdMap = new Map();
            const blocks = data.map((block)=>{
                const blockAri = this.generateBlockAri(block.resourceId);
                blockAriToResourceIdMap.set(blockAri, block.resourceId);
                return {
                    blockAri: blockAri,
                    content: JSON.stringify(block.content),
                    status: block.status,
                    stepVersion: stepVersion
                };
            });
            const response = await (0, $7SvKC.updateSyncedBlocks)({
                blocks: blocks
            });
            const results = [];
            // Process successful updates
            if (response.success) {
                const successBlocks = new Map(response.success.map((block)=>[
                        blockAriToResourceIdMap.get(block.blockAri),
                        block
                    ]));
                for (const block of data){
                    const successBlock = successBlocks.get(block.resourceId);
                    if (successBlock) results.push({
                        resourceId: block.resourceId,
                        status: successBlock.status
                    });
                }
            }
            if (response.error) {
                const errorResourceIds = new Map(response.error.map((err)=>[
                        // Use the map to get the original resourceId
                        blockAriToResourceIdMap.get(err.blockAri) || '',
                        $b01c0675c087bdaf$var$mapErrorResponseCode(err.code)
                    ]));
                for (const block of data){
                    const error = errorResourceIds.get(block.resourceId);
                    if (error) {
                        if (error !== (0, $awHlv.SyncBlockError).NotFound) results.push({
                            error: error,
                            resourceId: block.resourceId
                        });
                    } else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                    results.push({
                        error: (0, $awHlv.SyncBlockError).Errored,
                        resourceId: block.resourceId
                    });
                }
            }
            return results;
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return data.map((block)=>({
                    error: $b01c0675c087bdaf$var$mapBlockError(error),
                    resourceId: block.resourceId,
                    statusCode: error.status
                }));
            return data.map((block)=>({
                    error: (0, $cFpEg.stringifyError)(error),
                    resourceId: block.resourceId
                }));
        }
    }
    constructor({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion }){
        this.cloudId = void 0;
        this.parentId = void 0;
        this.getVersion = void 0;
        this.product = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
        this.parentId = parentId;
        this.product = product;
        this.getVersion = getVersion;
    }
}
const $b01c0675c087bdaf$var$createBlockServiceAPIProviders = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return {
        fetchProvider: new $b01c0675c087bdaf$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: new $b01c0675c087bdaf$var$BlockServiceADFWriteProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        })
    };
};
const $b01c0675c087bdaf$export$ec654f5ac7e6d976 = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return (0, $42omo.useMemo)(()=>{
        return $b01c0675c087bdaf$var$createBlockServiceAPIProviders({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        });
    }, [
        cloudId,
        parentAri,
        parentId,
        product,
        getVersion
    ]);
};
const $b01c0675c087bdaf$var$createBlockServiceFetchOnlyAPIProvider = ({ cloudId: cloudId, parentAri: parentAri })=>{
    return {
        fetchProvider: new $b01c0675c087bdaf$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: undefined
    };
};
const $b01c0675c087bdaf$export$1e67317f82b65067 = ({ cloudId: cloudId, parentAri: parentAri })=>(0, $42omo.useMemo)(()=>$b01c0675c087bdaf$var$createBlockServiceFetchOnlyAPIProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }), [
        cloudId,
        parentAri
    ]);
module.exports["batchFetchData"] = $b01c0675c087bdaf$export$abdcb5d4d6767e73;
module.exports["useMemoizedBlockServiceAPIProviders"] = $b01c0675c087bdaf$export$ec654f5ac7e6d976;

});

parcelRegister("ejAeh", function(module, exports) {
/* eslint-disable require-unicode-regexp */ const $111bb5a84f82538f$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $111bb5a84f82538f$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $111bb5a84f82538f$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $111bb5a84f82538f$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $111bb5a84f82538f$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $111bb5a84f82538f$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($111bb5a84f82538f$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $111bb5a84f82538f$export$c10656f449ea0fb5 = (ari)=>{
    const jiraMatch = ari?.search($111bb5a84f82538f$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search($111bb5a84f82538f$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $111bb5a84f82538f$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $111bb5a84f82538f$export$92a2331f8a9ed841;
module.exports["getProductFromSourceAri"] = $111bb5a84f82538f$export$c10656f449ea0fb5;

});

parcelRegister("7SvKC", function(module, exports) {

var $k2in1 = parcelRequire("k2in1");

const $619122aa51211846$export$f426a9918d7f49b3 = (response)=>{
    const content = response.content;
    return typeof content === 'string';
};
const $619122aa51211846$export$571f6abc3f4e5951 = async (documentAri)=>{
    const bodyData = {
        query: $619122aa51211846$var$buildGetDocumentReferenceBlocksQuery(documentAri),
        operationName: $619122aa51211846$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetDocumentReferenceBlocks`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getDocumentReferenceBlocks;
};
const $619122aa51211846$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $619122aa51211846$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $619122aa51211846$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_DOCUMENT_REFERENCE_BLOCKS';
const $619122aa51211846$var$UPDATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_BLOCK';
const $619122aa51211846$var$DELETE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_DELETE_BLOCK';
const $619122aa51211846$var$CREATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_CREATE_BLOCK';
const $619122aa51211846$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_DOCUMENT_REFERENCES';
const $619122aa51211846$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_RETRIEVE_BLOCKS';
const $619122aa51211846$var$GET_BLOCK_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_REFERENCES';
const $619122aa51211846$var$GET_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_BLOCK';
const $619122aa51211846$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_UPDATE_BLOCKS';
const $619122aa51211846$var$buildGetDocumentReferenceBlocksQuery = (documentAri)=>`query ${$619122aa51211846$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME} {
	blockService_getDocumentReferenceBlocks(documentAri: ${JSON.stringify(documentAri)}) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
const $619122aa51211846$var$buildGetBlockQuery = (blockAri)=>`query ${$619122aa51211846$var$GET_BLOCK_OPERATION_NAME} {
	blockService_getBlock(blockAri: ${JSON.stringify(blockAri)}) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
const $619122aa51211846$var$buildUpdateBlockMutation = (blockAri, content, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `content: ${JSON.stringify(content)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$619122aa51211846$var$UPDATE_BLOCK_OPERATION_NAME} {
	blockService_updateBlock(input: { ${inputArgs} }) {
		__typename
	}
}`;
};
const $619122aa51211846$var$buildDeleteBlockMutation = (blockAri, deletionReason)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`
    ];
    if (deletionReason !== undefined) inputParts.push(`deletionReason: ${JSON.stringify(deletionReason)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$619122aa51211846$var$DELETE_BLOCK_OPERATION_NAME} {
	blockService_deleteBlock(input: { ${inputArgs} }) {
		deleted
	}
}`;
};
/**
 * Converts product string to GraphQL enum format
 * 'confluence-page' -> 'CONFLUENCE_PAGE'
 * 'jira-work-item' -> 'JIRA_WORK_ITEM'
 */ const $619122aa51211846$var$convertProductToGraphQLEnum = (product)=>{
    switch(product){
        case 'confluence-page':
            return 'CONFLUENCE_PAGE';
        case 'jira-work-item':
            return 'JIRA_WORK_ITEM';
        default:
            {
                const exhaustiveCheck = product;
                throw new Error(`Unsupported product: ${exhaustiveCheck}`);
            }
    }
};
const $619122aa51211846$var$buildCreateBlockMutation = (blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `blockInstanceId: ${JSON.stringify(blockInstanceId)}`,
        `content: ${JSON.stringify(content)}`,
        `product: ${$619122aa51211846$var$convertProductToGraphQLEnum(product)}`,
        `sourceAri: ${JSON.stringify(sourceAri)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$619122aa51211846$var$CREATE_BLOCK_OPERATION_NAME} {
	blockService_createBlock(input: { ${inputArgs} }) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
};
const $619122aa51211846$var$buildUpdateDocumentReferencesMutation = (documentAri, blocks, noContent)=>{
    const blocksArray = blocks.map((block)=>`{ blockAri: ${JSON.stringify(block.blockAri)}, blockInstanceId: ${JSON.stringify(block.blockInstanceId)} }`).join(', ');
    const inputArgs = `documentAri: ${JSON.stringify(documentAri)}, blocks: [${blocksArray}], noContent: ${noContent}`;
    return `mutation ${$619122aa51211846$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME} {
	blockService_updateDocumentReferences(input: { ${inputArgs} }) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $619122aa51211846$var$buildBatchRetrieveBlocksQuery = (blockAris)=>{
    const blockArisArray = blockAris.map((ari)=>JSON.stringify(ari)).join(', ');
    const inputArgs = `blockAris: [${blockArisArray}]`;
    return `query ${$619122aa51211846$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME} {
	blockService_batchRetrieveBlocks(input: { ${inputArgs} }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
const $619122aa51211846$var$buildGetBlockReferencesQuery = (blockAri)=>{
    return `query ${$619122aa51211846$var$GET_BLOCK_REFERENCES_OPERATION_NAME} {
	blockService_getReferences(blockAri: ${JSON.stringify(blockAri)}) {
		references {
			blockAri
			blockInstanceId
			createdAt
			createdBy
			documentAri
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $619122aa51211846$var$buildBatchUpdateBlocksMutation = (blocks)=>{
    const blocksArray = blocks.map((block)=>{
        const inputParts = [
            `blockAri: ${JSON.stringify(block.blockAri)}`,
            `content: ${JSON.stringify(block.content)}`
        ];
        if (block.stepVersion !== undefined) inputParts.push(`stepVersion: ${block.stepVersion}`);
        if (block.status !== undefined) inputParts.push(`status: ${JSON.stringify(block.status)}`);
        return `{ ${inputParts.join(', ')} }`;
    }).join(', ');
    return `mutation ${$619122aa51211846$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME} {
	blockService_batchUpdateBlocks(input: { blocks: [${blocksArray}] }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
class $619122aa51211846$export$e47a0a94b0998697 extends Error {
    constructor(status){
        super(`Block error`), this.status = status;
    }
}
class $619122aa51211846$export$f5a00468af285e38 extends Error {
    constructor(){
        super('Block not found in Block Service');
        this.name = 'BlockNotFoundError';
    }
}
class $619122aa51211846$export$b5687000eb0902be extends Error {
    constructor(){
        super('Block request timed out');
        this.name = 'BlockTimeoutError';
    }
}
const $619122aa51211846$export$fab66d51cc0c1a7 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildGetBlockQuery(blockAri),
        operationName: $619122aa51211846$var$GET_BLOCK_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetBlock`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getBlock) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getBlock;
};
const $619122aa51211846$export$48a4f565308f4741 = async ({ blockIdentifiers: blockIdentifiers, config: config })=>{
    const blockAris = blockIdentifiers.map((blockIdentifier)=>blockIdentifier.blockAri);
    const bodyData = {
        query: $619122aa51211846$var$buildBatchRetrieveBlocksQuery(blockAris),
        operationName: $619122aa51211846$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchRetrieveBlocks`;
    // undefined or 0 or negative means no timeout,
    // We don't enforce a minimum timeout for simplicity
    const fetchPromise = (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    const timeoutMs = config?.timeoutMs ?? 0;
    const response = await (timeoutMs > 0 ? Promise.race([
        fetchPromise,
        new Promise((_, reject)=>setTimeout(()=>reject(new $619122aa51211846$export$b5687000eb0902be()), timeoutMs))
    ]) : fetchPromise);
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchRetrieveBlocks) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_batchRetrieveBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
const $619122aa51211846$export$cbbc86409cac3ee5 = async ({ blockAri: blockAri, deleteReason: deleteReason })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildDeleteBlockMutation(blockAri, deleteReason),
        operationName: $619122aa51211846$var$DELETE_BLOCK_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockDeleteBlock`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) {
        const allNotFound = result.errors.every((e)=>e.extensions?.errorType === 'RESOURCE_NOT_FOUND');
        if (allNotFound) // Throw BlockNotFoundError so the caller can create the block first then retry the delete.
        // Block Service uses soft-deletes: the entry must exist before deletion so a deletion-reason
        // is stored (used to display errors in reference blocks).
        throw new $619122aa51211846$export$f5a00468af285e38();
        throw new Error(result.errors.map((e)=>e.message).join(', '));
    }
    const isDeleted = result.data?.blockService_deleteBlock?.deleted;
    if (!isDeleted) throw new Error('Block deletion failed; deleted flag is false');
};
const $619122aa51211846$export$d5bf0c5618431e5e = async ({ blockAri: blockAri, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildUpdateBlockMutation(blockAri, content, stepVersion, status),
        operationName: $619122aa51211846$var$UPDATE_BLOCK_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateBlock`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
};
const $619122aa51211846$export$fbc30658d812c800 = async ({ blockAri: blockAri, blockInstanceId: blockInstanceId, sourceAri: sourceAri, product: product, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildCreateBlockMutation(blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status),
        operationName: $619122aa51211846$var$CREATE_BLOCK_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockCreateBlock`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_createBlock) throw new Error('No data returned from GraphQL mutation');
    return result.data.blockService_createBlock;
};
const $619122aa51211846$export$59c7369fa04bcba1 = async ({ documentAri: documentAri, blocks: blocks, noContent: noContent = true })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildUpdateDocumentReferencesMutation(documentAri, blocks, noContent),
        operationName: $619122aa51211846$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateDocumentReferences`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData),
        keepalive: true
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!noContent) {
        if (!result.data?.blockService_updateDocumentReferences) throw new Error('No data returned from GraphQL mutation');
        return result.data.blockService_updateDocumentReferences;
    }
};
const $619122aa51211846$export$75f5aeff9ce22a33 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildGetBlockReferencesQuery(blockAri),
        operationName: $619122aa51211846$var$GET_BLOCK_REFERENCES_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetReferences`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getReferences) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_getReferences;
    return {
        blockAri: blockAri,
        references: graphqlResponse.references || [],
        errors: graphqlResponse.errors || []
    };
};
const $619122aa51211846$export$a9e53fa4329b5ed2 = async ({ blocks: blocks })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildBatchUpdateBlocksMutation(blocks),
        operationName: $619122aa51211846$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchUpdateBlocks`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchUpdateBlocks) throw new Error('No data returned from GraphQL mutation');
    const graphqlResponse = result.data.blockService_batchUpdateBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
module.exports["getReferenceSyncedBlocks"] = $619122aa51211846$export$571f6abc3f4e5951;
module.exports["BlockError"] = $619122aa51211846$export$e47a0a94b0998697;
module.exports["BlockNotFoundError"] = $619122aa51211846$export$f5a00468af285e38;
module.exports["BlockTimeoutError"] = $619122aa51211846$export$b5687000eb0902be;
module.exports["getSyncedBlockContent"] = $619122aa51211846$export$fab66d51cc0c1a7;
module.exports["batchRetrieveSyncedBlocks"] = $619122aa51211846$export$48a4f565308f4741;
module.exports["deleteSyncedBlock"] = $619122aa51211846$export$cbbc86409cac3ee5;
module.exports["updateSyncedBlock"] = $619122aa51211846$export$d5bf0c5618431e5e;
module.exports["createSyncedBlock"] = $619122aa51211846$export$fbc30658d812c800;
module.exports["updateReferenceSyncedBlockOnDocument"] = $619122aa51211846$export$59c7369fa04bcba1;
module.exports["getReferenceSyncedBlocksByBlockAri"] = $619122aa51211846$export$75f5aeff9ce22a33;
module.exports["updateSyncedBlocks"] = $619122aa51211846$export$a9e53fa4329b5ed2;

});

parcelRegister("k2in1", function(module, exports) {
const $70107457754d8ab2$var$MAX_RETRY_DELAY = 30000;
const $70107457754d8ab2$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $70107457754d8ab2$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $70107457754d8ab2$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $70107457754d8ab2$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $70107457754d8ab2$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $70107457754d8ab2$export$cffaac380b94df26;

});

parcelRegister("awHlv", function(module, exports) {
var $14957aea32c8ee8e$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $14957aea32c8ee8e$export$7486a7adf8b0d591 = 'Data provider not set';
class $14957aea32c8ee8e$export$ca0858d4f5eeeac extends Error {
    constructor(message = $14957aea32c8ee8e$export$7486a7adf8b0d591){
        super(message);
        this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $14957aea32c8ee8e$export$ca0858d4f5eeeac.prototype);
    }
}
const $14957aea32c8ee8e$export$7ba508051f94701f = (error)=>{
    if (error instanceof $14957aea32c8ee8e$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $14957aea32c8ee8e$export$7486a7adf8b0d591;
};
module.exports["SyncBlockError"] = $14957aea32c8ee8e$export$686dd843fdf311d4;
module.exports["ProviderNotReadyError"] = $14957aea32c8ee8e$export$ca0858d4f5eeeac;
module.exports["isProviderNotReadyError"] = $14957aea32c8ee8e$export$7ba508051f94701f;

});

parcelRegister("cFpEg", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $awHlv = parcelRequire("awHlv");

const $22be2fac1f3375a4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $22be2fac1f3375a4$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $awHlv.SyncBlockError)));
const $22be2fac1f3375a4$export$3bf11deac13e0617 = (error)=>{
    if (error && $22be2fac1f3375a4$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $22be2fac1f3375a4$export$78792f4ddc3998e8 = (gateEnabled, error, statusCode)=>{
    if (!gateEnabled) return undefined;
    return {
        reason: $22be2fac1f3375a4$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $22be2fac1f3375a4$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $22be2fac1f3375a4$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $22be2fac1f3375a4$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $22be2fac1f3375a4$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $22be2fac1f3375a4$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $22be2fac1f3375a4$export$4ae89cef01c11c46 = (gateEnabled, error, statusCode)=>{
    if (!gateEnabled) return undefined;
    const reason = $22be2fac1f3375a4$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        benign: $22be2fac1f3375a4$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
function $22be2fac1f3375a4$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution) {
    return {
        action: (0, $d925B.ACTION).ERROR,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...attribution?.reason && {
                reason: attribution.reason
            },
            ...attribution?.statusCode !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            }
        }
    };
}
const $22be2fac1f3375a4$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it (gate OFF) it
    // hits the no-attribution overload. Both produce a fetch event regardless.
    attribution ? $22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $22be2fac1f3375a4$export$c5131f589148b9d3 = (error, resourceId, sourceProduct)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct);
const $22be2fac1f3375a4$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $22be2fac1f3375a4$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $22be2fac1f3375a4$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution);
const $22be2fac1f3375a4$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $22be2fac1f3375a4$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $22be2fac1f3375a4$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $d925B.ACTION).ERROR,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...context?.hasPendingDeletion !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...context?.hasSubscribers !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $22be2fac1f3375a4$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $d925B.ACTION).ERROR,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $22be2fac1f3375a4$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $22be2fac1f3375a4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $d925B.ACTION).FETCHED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $22be2fac1f3375a4$export$5b8e0915870366d0 = (resourceId, sourceProduct)=>{
    return {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    };
};
const $22be2fac1f3375a4$export$dd6ad6471c8fade8 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $22be2fac1f3375a4$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $d925B.ACTION).UPDATED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $22be2fac1f3375a4$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $d925B.ACTION).DELETED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.blockInstanceId && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...enrichment?.deletionReason && {
                deletionReason: enrichment.deletionReason
            },
            ...enrichment?.mechanism && {
                mechanism: enrichment.mechanism
            }
        }
    });
module.exports["stringifyError"] = $22be2fac1f3375a4$export$7fc2c997455452c8;
module.exports["buildErrorAttribution"] = $22be2fac1f3375a4$export$78792f4ddc3998e8;
module.exports["buildFetchErrorAttribution"] = $22be2fac1f3375a4$export$4ae89cef01c11c46;
module.exports["fetchErrorPayload"] = $22be2fac1f3375a4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $22be2fac1f3375a4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $22be2fac1f3375a4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $22be2fac1f3375a4$export$154595d209a77913;
module.exports["createErrorPayload"] = $22be2fac1f3375a4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $22be2fac1f3375a4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $22be2fac1f3375a4$export$e40ed1768baf5d1e;
module.exports["sourceInfoOrphanedPayload"] = $22be2fac1f3375a4$export$5665a31a69693485;
module.exports["cacheDeletionForcedPayload"] = $22be2fac1f3375a4$export$82f9608c8438ecb2;
module.exports["fetchReferencesErrorPayload"] = $22be2fac1f3375a4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $22be2fac1f3375a4$export$b20c56c32ea6ad76;
module.exports["createSuccessPayload"] = $22be2fac1f3375a4$export$5b8e0915870366d0;
module.exports["createSuccessPayloadNew"] = $22be2fac1f3375a4$export$dd6ad6471c8fade8;
module.exports["updateSuccessPayload"] = $22be2fac1f3375a4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $22be2fac1f3375a4$export$2283f5d682476cde;

});

parcelRegister("47N43", function(module, exports) {

var $6RJVA = parcelRequire("6RJVA");

const $f989ba18ccabbf74$var$isSyncBlockProduct = (product)=>{
    return (0, $6RJVA.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $f989ba18ccabbf74$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$f989ba18ccabbf74$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $f989ba18ccabbf74$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $f989ba18ccabbf74$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $f989ba18ccabbf74$export$cf5895b3b46faf63;

});

parcelRegister("6RJVA", function(module, exports) {
const $ccfe16213375d02d$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $ccfe16213375d02d$export$c05408ef703373ad;

});

parcelRegister("gtauf", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $5a9379de970b4a33$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $5a9379de970b4a33$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        if (!contentNode) {
            normalizedContent?.push(contentNode);
            return;
        }
        const hasAnnotationMark = contentNode.marks?.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $5a9379de970b4a33$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            normalizedContent?.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            const marks = contentNode.marks?.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $5a9379de970b4a33$export$19bb1d88f473b9c5 = (content)=>{
    return $5a9379de970b4a33$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $5a9379de970b4a33$export$b223a7607ed061dc = (content)=>{
    return $5a9379de970b4a33$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $5a9379de970b4a33$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $5a9379de970b4a33$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $5a9379de970b4a33$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $5a9379de970b4a33$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$5a9379de970b4a33$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $5a9379de970b4a33$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($5a9379de970b4a33$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $5a9379de970b4a33$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $5a9379de970b4a33$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $5a9379de970b4a33$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["normalizeSyncBlockJSONContent"] = $5a9379de970b4a33$export$b223a7607ed061dc;
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $5a9379de970b4a33$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $5a9379de970b4a33$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $5a9379de970b4a33$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $5a9379de970b4a33$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $5a9379de970b4a33$export$2cf4a74c3e18f31a;
module.exports["getSourceProductFromResourceIdSafe"] = $5a9379de970b4a33$export$31cbe0bed21e05b1;
module.exports["convertContentUpdatedAt"] = $5a9379de970b4a33$export$4c6687d128f55da5;

});

parcelRegister("3fCEs", function(module, exports) {

let $25e0c135115f4f52$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $25e0c135115f4f52$var$load("7j0mT"),
    $25e0c135115f4f52$var$load("69R9L"),
    $25e0c135115f4f52$var$load("doW60")
]).then(()=>parcelRequire('bXEbs'));

});

parcelRegister("f8eu7", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $ff6ec2d844d0271f$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $ff6ec2d844d0271f$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $ff6ec2d844d0271f$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($ff6ec2d844d0271f$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $ff6ec2d844d0271f$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $ff6ec2d844d0271f$export$2ee4e689bde04de2;

});

parcelRegister("ghBq4", function(module, exports) {
/**
 * Error codes for synced blocks preloading
 * Used for tracking and monitoring errors during SSR preload phase
 */ const $8eed5f2056f8fd6a$export$f10410d219e3ec29 = {
    /**
   * Occurs when the fetch operation returns fewer results than requested.
   * This indicates incomplete data retrieval or potential data loss.
   * Included in error: list of missing block identifiers
   */ FETCH_INCOMPLETE: 'SYNCED_BLOCKS_FETCH_INCOMPLETE',
    /**
   * Occurs when the batch fetch operation throws an error during execution.
   * This indicates a network error, timeout, or API failure.
   * Included in error: resource IDs that failed to fetch
   */ BATCH_FETCH_FAILED: 'SYNCED_BLOCKS_BATCH_FETCH_FAILED',
    /**
   * Occurs when the fetch operation times out without returning results.
   * This is specific to the bulk fetch operation with a configurable timeout.
   */ FETCH_TIMEOUT: 'SYNCED_BLOCKS_FETCH_TIMEOUT'
};
module.exports["SyncedBlocksSSRErrorCodeMap"] = $8eed5f2056f8fd6a$export$f10410d219e3ec29;

});

parcelRegister("8AcAF", function(module, exports) {
function $239408713401734d$export$25570414f819b6df(syncBlock, nodeTypes) {
    if (!syncBlock?.data?.content) return [];
    if (nodeTypes.length === 0) return [];
    const nodeTypesSet = new Set(nodeTypes);
    const foundTypes = new Set();
    const content = syncBlock.data.content;
    const checkNode = (node)=>{
        if (!node || typeof node !== 'object') return false;
        // Check if this node matches one of the requested types
        if (typeof node.type === 'string' && nodeTypesSet.has(node.type) && !foundTypes.has(node.type)) {
            // node type found, add to found set and remove from search set
            foundTypes.add(node.type);
            nodeTypesSet.delete(node.type);
            // If all types have been found, we can stop searching
            if (nodeTypesSet.size === 0) return true;
        }
        // Recursively check all child content
        if (Array.isArray(node.content)) // Return true to stop searching if all types have been found in children
        return node.content.some(checkNode);
        return false;
    };
    content.some(checkNode);
    return Array.from(foundTypes);
}
module.exports["syncBlockContainsNodes"] = $239408713401734d$export$25570414f819b6df;

});

parcelRegister("l9Wsf", function(module, exports) {
const $7267ec4c0ff40ba5$var$isSyncBlockNode = (node)=>{
    return node.type === 'syncBlock' && typeof node.attrs === 'object' && node.attrs !== null && 'resourceId' in node.attrs && 'localId' in node.attrs && typeof node.attrs.resourceId === 'string' && typeof node.attrs.localId === 'string';
};
function $7267ec4c0ff40ba5$export$7895de99cf1d8719(doc) {
    const content = doc.content || [];
    return content.reduce((acc, node)=>{
        if ($7267ec4c0ff40ba5$var$isSyncBlockNode(node)) acc.push({
            resourceId: node.attrs.resourceId,
            blockInstanceId: node.attrs.localId
        });
        return acc;
    }, []);
}
module.exports["extractSyncBlockIdentifiers"] = $7267ec4c0ff40ba5$export$7895de99cf1d8719;

});

parcelRegister("985xA", function(module, exports) {
function $4a85fd13a342ae42$export$e3ccb083fef98320(value) {
    if (!value || typeof value !== 'object') return false;
    const doc = value;
    // Check required properties
    if (doc.type !== 'doc') return false;
    if (!Array.isArray(doc.content)) return false;
    // Version is optional but if present should be a number
    if (doc.version !== undefined && typeof doc.version !== 'number') return false;
    return true;
}
module.exports["isValidJSONDocNode"] = $4a85fd13a342ae42$export$e3ccb083fef98320;

});

parcelRegister("fywGr", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $5cryL = parcelRequire("5cryL");


var $8Z78B = parcelRequire("8Z78B");


var $1k2r8 = parcelRequire("1k2r8");

const $7aae32df106d9977$export$864cb1c5b7b9b39 = ()=>{
    // When the centralized onboarding state experiment is enabled, use the centralized preloader
    // to ensure all onboarding state queries hit the cache.
    if ((0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return (0, $1k2r8.preloadAllOnboardingState)();
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS))
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
module.exports["preloadEditorOnboardingState"] = $7aae32df106d9977$export$864cb1c5b7b9b39;

});

parcelRegister("32Xjk", function(module, exports) {
/**
 * @generated SignedSource<<1411d3b38bfd3828f39e9de902613b71>>
 * @relayHash 3d166b53e496ae6a12171538cb6c6ca8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce
const $6ea889d48284c196$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-ever-set"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-ever-set\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "3d166b53e496ae6a12171538cb6c6ca8",
            "id": "47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce",
            "metadata": {},
            "name": "useEmojiEverSetPropertyQuery",
            "operationKind": "query",
            "text": "query useEmojiEverSetPropertyQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(key:\"emoji-ever-set\"){nodes{id,key,value}}}}}"
        }
    };
}();
$6ea889d48284c196$var$node.hash = "7922225ac99254e0526a345863d19578";
var $6ea889d48284c196$export$2e2bcd8739ae039 = $6ea889d48284c196$var$node;
module.exports["default"] = $6ea889d48284c196$export$2e2bcd8739ae039;

});

parcelRegister("fxLAA", function(module, exports) {
/**
 * @generated SignedSource<<c20b51993d2a42be5c40e4fb23513210>>
 * @relayHash 0e2ff3e32406276d823f5080dc7f9714
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54a10e60e2a0c15ce92471d6e08870349218fb356a74754f5961430a595b415b
const $d3bfdb752c338d80$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "embeddedContentRender"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isMarkdownModeEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v8 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "embeddedContentRender",
            "variableName": "embeddedContentRender"
        },
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v13 = {
        "kind": "ScalarField",
        "name": "title"
    }, v14 = {
        "kind": "ScalarField",
        "name": "status"
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "value"
    }, v17 = {
        "kind": "ScalarField",
        "name": "number"
    }, v18 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v10 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ 
                    ]
                }
            ]
        }
    ], v19 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v18 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v20 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v23 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v24 = [
        v11 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ 
    ], v25 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v18 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v26 = {
        "condition": "useNewContentTopper",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v18 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            }
        ]
    }, v27 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"editor\")"
    }, v28 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "message"
    }, v30 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v31 = {
        "kind": "ScalarField",
        "name": "when"
    }, v32 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v33 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    },
                    {
                        "condition": "isMarkdownModeEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isMarkdownMode"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v35 = [
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v36 = {
        "kind": "ScalarField",
        "name": "count"
    }, v37 = {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
    }, v38 = {
        "kind": "ScalarField",
        "name": "isOwnerContributor"
    }, v39 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MapOfStringToString",
                        "kind": "LinkedField",
                        "name": "headings",
                        "plural": true,
                        "selections": [
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "background"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundAttachment"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundBlendMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundClip"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundColor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundImage"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundOrigin"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundPosition"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundRepeat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundSize"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v40 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v11 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v24 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v24 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v24 /*: any*/ 
                                        }
                                    ]
                                },
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v24 /*: any*/ 
                                        },
                                        v30 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                },
                                v33 /*: any*/ ,
                                v34 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v35 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        v38 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v24 /*: any*/ 
                        }
                    ]
                },
                v39 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v40 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v40 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v40 /*: any*/ 
                                        }
                                    ]
                                },
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v40 /*: any*/ 
                                        },
                                        v30 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                },
                                v33 /*: any*/ ,
                                v34 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v35 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        v38 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v40 /*: any*/ 
                        }
                    ]
                },
                v39 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "0e2ff3e32406276d823f5080dc7f9714",
            "id": "54a10e60e2a0c15ce92471d6e08870349218fb356a74754f5961430a595b415b",
            "metadata": {},
            "name": "ContentHeaderUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$isMarkdownModeEnabled:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,type,subType,title,status,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy,isMarkdownMode@include(if:$isMarkdownModeEnabled)}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}"
        }
    };
}();
$d3bfdb752c338d80$var$node.hash = "bcaab4c549f5b087cf1d5719eca13fdc";
var $d3bfdb752c338d80$export$2e2bcd8739ae039 = $d3bfdb752c338d80$var$node;
module.exports["default"] = $d3bfdb752c338d80$export$2e2bcd8739ae039;

});

parcelRegister("3gyyc", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $kyRHQ = parcelRequire("kyRHQ");

const $59e4a4ba3e3599a7$export$7e063004a2621936 = ()=>{
    try {
        const isSSRRendered = // In most places there is no document when running on server-side
        typeof document === 'undefined' || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        typeof $kyRHQ !== 'undefined' && $kyRHQ.env?.REACT_SSR || typeof window !== 'undefined' && window.__SSR_RENDERED__ || globalThis.__SSR_RENDERED__;
        const isSSRReactStreaming = typeof window !== 'undefined' && window.__SSR_REACT_STREAMING__ || globalThis.__SSR_REACT_STREAMING__;
        return Boolean(isSSRRendered) && (0, $6mKj3.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) && Boolean(isSSRReactStreaming);
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};
module.exports["isSSRStreaming"] = $59e4a4ba3e3599a7$export$7e063004a2621936;

});

parcelRegister("tWJUB", function(module, exports) {

let $05a045fe11d6d226$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05a045fe11d6d226$var$load("lmyjp").then(()=>parcelRequire('g6sGq'));

});

parcelRegister("6ysPB", function(module, exports) {

let $4c5c4858a971c945$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c5c4858a971c945$var$load("7LQ6E").then(()=>parcelRequire('cofOy'));

});

parcelRegister("2XqLa", function(module, exports) {
/**
 * @generated SignedSource<<a63d6821b45767207607249abf9688dc>>
 * @relayHash 3d96e93646da973911628e43055a9f08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e401857f7c01e3a1e9f0925bc458239f573445ed8b7119ee7ef804a2ec848c88
const $24a18f673122a45e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PagesSpaceIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PagesSpaceIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3d96e93646da973911628e43055a9f08",
            "id": "e401857f7c01e3a1e9f0925bc458239f573445ed8b7119ee7ef804a2ec848c88",
            "metadata": {},
            "name": "PagesSpaceIdQuery",
            "operationKind": "query",
            "text": "query PagesSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}"
        }
    };
}();
$24a18f673122a45e$var$node.hash = "deb46e23288932c7ab718d7f71cc2103";
var $24a18f673122a45e$export$2e2bcd8739ae039 = $24a18f673122a45e$var$node;
module.exports["default"] = $24a18f673122a45e$export$2e2bcd8739ae039;

});

parcelRegister("jG2Es", function(module, exports) {
/**
 * @generated SignedSource<<308939eb97236fd7abf20adc7a4f957c>>
 * @relayHash 59320f1b8601c0164d05458b5671082b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7db8c3153986b4dbb13acf7de34310f81ac9a8e0ac042516b4ef9dcad70cc31e
const $2a2707667ff6d1a7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "globalPageCardAppearancePreference"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "PagesSortPersistenceOption",
                    "kind": "LinkedField",
                    "name": "spacePagesSortView",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "field"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "order"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpacePagesPersistenceQueriesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpacePagesPersistenceQueriesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "59320f1b8601c0164d05458b5671082b",
            "id": "7db8c3153986b4dbb13acf7de34310f81ac9a8e0ac042516b4ef9dcad70cc31e",
            "metadata": {},
            "name": "SpacePagesPersistenceQueriesQuery",
            "operationKind": "query",
            "text": "query SpacePagesPersistenceQueriesQuery($spaceKey:String!){userPreferences{globalPageCardAppearancePreference,spacePagesSortView(spaceKey:$spaceKey){field,order}}}"
        }
    };
}();
$2a2707667ff6d1a7$var$node.hash = "2a6df4b92cf1482402557b6fd5bb750a";
var $2a2707667ff6d1a7$export$2e2bcd8739ae039 = $2a2707667ff6d1a7$var$node;
module.exports["default"] = $2a2707667ff6d1a7$export$2e2bcd8739ae039;

});

parcelRegister("khheP", function(module, exports) {
/**
 * @generated SignedSource<<07d5f0710fdcbcefc26631e14b07539b>>
 * @relayHash 767409598881887aa79d216996b506d5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6841cfcc0970a95f1d151af08e5fdeee1588edf1ca9d6b1e88d51154f26c4932
const $fdbd89e429f2aa39$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRecommended"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceId"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v14 = {
        "kind": "Variable",
        "name": "experience",
        "variableName": "experience"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        v14 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "cloudIdARI"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "description"
    }, v20 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v21 = {
        "kind": "ScalarField",
        "name": "title"
    }, v22 = {
        "kind": "ScalarField",
        "name": "type"
    }, v23 = {
        "kind": "ScalarField",
        "name": "url"
    }, v24 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v25 = {
        "kind": "ScalarField",
        "name": "isVerified"
    }, v26 = {
        "kind": "ScalarField",
        "name": "name"
    }, v27 = {
        "concreteType": "SearchConfluenceResultSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v26 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "webUiLink"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "currentUserIsWatching"
    }, v29 = {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isWatched"
            },
            {
                "kind": "ScalarField",
                "name": "isWatchingBlogs"
            }
        ]
    }, v30 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v32 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v34 = {
        "alias": "pageStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v35 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v36 = {
        "kind": "ScalarField",
        "name": "editUi"
    }, v37 = [
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v38 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v37 /*: any*/ 
    }, v39 = {
        "kind": "ScalarField",
        "name": "key"
    }, v40 = {
        "kind": "ScalarField",
        "name": "value"
    }, v41 = [
        v18 /*: any*/ ,
        v17 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ 
    ], v42 = {
        "concreteType": "ConfluenceContentTitleEmoji",
        "kind": "LinkedField",
        "name": "titleEmojiPublished",
        "plural": false,
        "selections": v41 /*: any*/ 
    }, v43 = {
        "concreteType": "ConfluenceContentTitleEmoji",
        "kind": "LinkedField",
        "name": "titleEmojiDraft",
        "plural": false,
        "selections": v41 /*: any*/ 
    }, v44 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            v42 /*: any*/ ,
            v43 /*: any*/ 
        ]
    }, v45 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "editor"
            ]
        }
    ], v46 = [
        v18 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ 
    ], v47 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v46 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v48 = {
        "kind": "ScalarField",
        "name": "alias"
    }, v49 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v39 /*: any*/ ,
            v48 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v50 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v51 = [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v17 /*: any*/ ,
                v50 /*: any*/ ,
                v26 /*: any*/ 
            ]
        }
    ], v52 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": v51 /*: any*/ 
    }, v53 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": v51 /*: any*/ 
    }, v54 = [
        {
            "concreteType": "ConfluenceFavoritedSummary",
            "kind": "LinkedField",
            "name": "favoritedSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavorite"
                }
            ]
        }
    ], v55 = {
        "concreteType": "ConfluencePageViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v56 = {
        "concreteType": "ConfluenceCommentCountSummary",
        "kind": "LinkedField",
        "name": "commentCountSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "total"
            }
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "count"
    }, v58 = {
        "concreteType": "ConfluenceLikesSummary",
        "kind": "LinkedField",
        "name": "likesSummary",
        "plural": false,
        "selections": [
            v57 /*: any*/ 
        ]
    }, v59 = {
        "alias": "blogPostStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v60 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v37 /*: any*/ 
    }, v61 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v46 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v62 = {
        "concreteType": "ConfluenceBlogPostViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v63 = {
        "alias": "contentStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v64 = [
        v35 /*: any*/ 
    ], v65 = {
        "concreteType": "ConfluenceEmbedLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v66 = {
        "concreteType": "ConfluenceContentViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v67 = {
        "concreteType": "ConfluenceDatabaseLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v68 = {
        "concreteType": "ConfluenceWhiteboardLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v69 = {
        "concreteType": "ConfluenceFolderLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v70 = {
        "concreteType": "SearchProductCount",
        "kind": "LinkedField",
        "name": "totalCounts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "product"
            },
            v57 /*: any*/ 
        ]
    }, v71 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v72 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "spaceId"
                        },
                        {
                            "kind": "Literal",
                            "name": "product",
                            "value": "confluence"
                        },
                        {
                            "kind": "Variable",
                            "name": "tenantId",
                            "variableName": "tenantId"
                        },
                        {
                            "kind": "Literal",
                            "name": "userId",
                            "value": "context"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "context"
                },
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "caller",
                            "value": "confluence"
                        },
                        v14 /*: any*/ 
                    ],
                    "kind": "ObjectValue",
                    "name": "modelRequestParams"
                },
                {
                    "kind": "Literal",
                    "name": "requestingUserId",
                    "value": "context"
                }
            ],
            "kind": "ObjectValue",
            "name": "recommendationsQuery"
        }
    ], v73 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "length",
                        "value": 372
                    }
                ],
                "kind": "ScalarField",
                "name": "excerpt",
                "storageKey": "excerpt(length:372)"
            }
        ]
    }, v74 = [
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v18 /*: any*/ 
    ], v75 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v74 /*: any*/ 
    }, v76 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            v43 /*: any*/ ,
            v42 /*: any*/ 
        ]
    }, v77 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v39 /*: any*/ ,
            v48 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v78 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v50 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v79 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v78 /*: any*/ 
        ]
    }, v80 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v81 = [
        v79 /*: any*/ ,
        v80 /*: any*/ 
    ], v82 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v74 /*: any*/ 
    }, v83 = [
        v18 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v17 /*: any*/ 
    ], v84 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v83 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v85 = [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v18 /*: any*/ ,
                v17 /*: any*/ ,
                v50 /*: any*/ ,
                v26 /*: any*/ 
            ]
        },
        v17 /*: any*/ 
    ], v86 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": v85 /*: any*/ 
    }, v87 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": v85 /*: any*/ 
    }, v88 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v83 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v89 = {
        "kind": "InlineFragment",
        "selections": [
            v17 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v90 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v78 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v91 = [
        v90 /*: any*/ ,
        v80 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SearchResultsAGGSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "results",
                            "args": v15 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        {
                                                            "condition": "isLicensed",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "watchDialogContent",
                                                                    "concreteType": "Content",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "Space",
                                                                            "kind": "LinkedField",
                                                                            "name": "space",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v32 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v61 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceBlogPost"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceEmbed"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceDatabase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v68 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceWhiteboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v69 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceFolder"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v70 /*: any*/ ,
                                v71 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeRecommended",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SmartsQueryApi",
                            "kind": "LinkedField",
                            "name": "smarts",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v72 /*: any*/ ,
                                    "concreteType": "SmartsRecommendedObject",
                                    "kind": "LinkedField",
                                    "name": "recommendedObject",
                                    "plural": true,
                                    "selections": [
                                        v73 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "object",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v75 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v55 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v79 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluencePageVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v81 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluencePage"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v59 /*: any*/ ,
                                                        v82 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v62 /*: any*/ ,
                                                        v61 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v79 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluenceBlogPostVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v81 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluenceBlogPost"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v11 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SearchResultsAGGSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "results",
                            "args": v15 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v84 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v88 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceBlogPost"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceEmbed"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceDatabase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v68 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceWhiteboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v69 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceFolder"
                                                                },
                                                                v89 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isLicensed",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "watchDialogContent",
                                                                    "concreteType": "Content",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "Space",
                                                                            "kind": "LinkedField",
                                                                            "name": "space",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v70 /*: any*/ ,
                                v71 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeRecommended",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SmartsQueryApi",
                            "kind": "LinkedField",
                            "name": "smarts",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v72 /*: any*/ ,
                                    "concreteType": "SmartsRecommendedObject",
                                    "kind": "LinkedField",
                                    "name": "recommendedObject",
                                    "plural": true,
                                    "selections": [
                                        v73 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "object",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v75 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v55 /*: any*/ ,
                                                        v84 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v90 /*: any*/ ,
                                                        v87 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluencePageVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v91 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluencePage"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v59 /*: any*/ ,
                                                        v82 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v62 /*: any*/ ,
                                                        v88 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v90 /*: any*/ ,
                                                        v87 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluenceBlogPostVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v91 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluenceBlogPost"
                                                },
                                                v89 /*: any*/ 
                                            ]
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "767409598881887aa79d216996b506d5",
            "id": "6841cfcc0970a95f1d151af08e5fdeee1588edf1ca9d6b1e88d51154f26c4932",
            "metadata": {},
            "name": "SearchResultsAGGSearchQuery",
            "operationKind": "query",
            "text": "query SearchResultsAGGSearchQuery($query:String!,$cloudIdARI:[String!]!,$limit:Int!,$entities:[String!]!,$commonFilters:SearchCommonFilter,$confluenceFilters:SearchConfluenceFilter,$sort:[SearchSortInput],$after:String,$disableQueryReplacement:Boolean,$experience:String!,$isLicensed:Boolean!,$includeRecommended:Boolean=false,$spaceId:String!,$tenantId:String!){search{results:search(experience:$experience,query:$query,first:$limit,after:$after,sort:$sort,disableQueryReplacement:$disableQueryReplacement,filters:{entities:$entities,locations:$cloudIdARI,commonFilters:$commonFilters,confluenceFilters:$confluenceFilters}){totalCount,edges{node{id,__typename,description,iconUrl,title,type,url,...on SearchConfluencePageBlogAttachment{lastModified,isVerified,space{id,name,webUiLink},watchDialogContent:content@include(if:$isLicensed){id,__typename,currentUserIsWatching,space{currentUser{isWatched,isWatchingBlogs},operations{operation,targetType},id}},content{id,__typename,blank,excerpt},confluenceEntity{__typename,...on ConfluencePage{id,__typename,title,type,subtype,pageStatus:status,links{webUi,editUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},likesSummary{count}},...on ConfluenceBlogPost{id,__typename,title,type,blogPostStatus:status,links{webUi,editUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},likesSummary{count}},...on ConfluenceEmbed{id,__typename,title,type,contentStatus:status,links{webUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceDatabase{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceWhiteboard{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceFolder{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}}},...on Node{__isNode:__typename,id}}}}},totalCounts{product,count},pageInfo{endCursor}}},smarts@include(if:$includeRecommended){recommendedObject(recommendationsQuery:{context:{userId:\"context\",tenantId:$tenantId,product:\"confluence\",containerId:$spaceId},modelRequestParams:{experience:$experience,caller:\"confluence\"},requestingUserId:\"context\"}){content{id,__typename,blank,excerpt(length:372)},object{__typename,...on ConfluencePage{id,__typename,title,type,subtype,pageStatus:status,links{webUi,editUi,__typename},metadata{titleEmojiDraft{__typename,id,key,value},titleEmojiPublished{__typename,id,key,value}},viewer{favoritedSummary{isFavorite}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,__typename,key,alias,name},author{user{id,__typename,picture,name},id},owner{user{__typename,id,picture,name},id},latestVersion{author{user{id,__typename,picture,name},id},createdAt},commentCountSummary{total},likesSummary{count}},...on ConfluenceBlogPost{id,__typename,title,type,blogPostStatus:status,links{webUi,editUi,__typename},metadata{titleEmojiDraft{__typename,id,key,value},titleEmojiPublished{__typename,id,key,value}},viewer{favoritedSummary{isFavorite}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,__typename,key,alias,name},author{user{id,__typename,picture,name},id},owner{user{__typename,id,picture,name},id},latestVersion{author{user{id,__typename,picture,name},id},createdAt},commentCountSummary{total},likesSummary{count}},...on Node{__isNode:__typename,id}},id}}}"
        }
    };
}();
$fdbd89e429f2aa39$var$node.hash = "d1ed786c62b431549c6e881cb261091e";
var $fdbd89e429f2aa39$export$2e2bcd8739ae039 = $fdbd89e429f2aa39$var$node;
module.exports["default"] = $fdbd89e429f2aa39$export$2e2bcd8739ae039;

});

parcelRegister("dC2j7", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports, no-unneeded-ternary */ 
var $c3Qwv = parcelRequire("c3Qwv");

const $acb737f2b02900d4$var$CCSortOrder = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $acb737f2b02900d4$export$3e1423ba918b02c3 = 12;
const $acb737f2b02900d4$export$964ee2c26a2e8aba = {
    page: 'ati:cloud:confluence:page',
    blogpost: 'ati:cloud:confluence:blogpost',
    embed: 'ati:cloud:confluence:embed',
    folder: 'ati:cloud:confluence:folder',
    whiteboard: 'ati:cloud:confluence:whiteboard',
    database: 'ati:cloud:confluence:database'
};
const $acb737f2b02900d4$var$AGG_EXPERIENCE = 'ConfSpacePages';
const $acb737f2b02900d4$var$STARRED_PAGE_LABEL = 'my:favourite';
const $acb737f2b02900d4$export$f471e8a003a4fb0d = (sortBy)=>{
    if (!sortBy) return [];
    const order = sortBy.order === $acb737f2b02900d4$var$CCSortOrder.ASC ? 'ASC' : 'DESC';
    let field;
    switch(sortBy.field){
        case 'LAST_MODIFIED_DATE':
            field = 'latestModifiedDate';
            break;
        case 'TITLE':
            field = 'title';
            break;
        default:
            field = 'latestModifiedDate';
    }
    return [
        {
            field: field,
            order: order
        }
    ];
};
const $acb737f2b02900d4$export$832c8592ab821c21 = ({ cloudId: cloudId, spaceKey: spaceKey, userId: userId, isLicensed: isLicensed, spaceId: spaceId, isWhiteboardEnabled: isWhiteboardEnabled, isDatabaseEnabled: isDatabaseEnabled, searchText: searchText, pagesFilter: pagesFilter, sort: sort, after: after = '', includeRecommended: includeRecommended = false })=>{
    return {
        cloudIdARI: [
            `ari:cloud:confluence::site/${cloudId}`
        ],
        tenantId: cloudId,
        limit: $acb737f2b02900d4$export$3e1423ba918b02c3,
        after: after,
        query: searchText,
        commonFilters: {
            range: {}
        },
        confluenceFilters: {
            spacesFilter: [
                spaceKey
            ],
            ...pagesFilter === 'worked-on' && userId && isLicensed && {
                contributorsFilter: [
                    userId
                ]
            },
            ...pagesFilter === 'starred' && isLicensed && {
                labelsFilter: [
                    $acb737f2b02900d4$var$STARRED_PAGE_LABEL
                ]
            },
            titleMatchOnly: true,
            contentStatuses: [
                'CURRENT',
                'DRAFT'
            ],
            containerStatus: []
        },
        sort: sort ? sort : [],
        entities: [
            $acb737f2b02900d4$export$964ee2c26a2e8aba.page,
            $acb737f2b02900d4$export$964ee2c26a2e8aba.embed,
            $acb737f2b02900d4$export$964ee2c26a2e8aba.folder,
            ...isWhiteboardEnabled ? [
                $acb737f2b02900d4$export$964ee2c26a2e8aba.whiteboard
            ] : [],
            ...isDatabaseEnabled ? [
                $acb737f2b02900d4$export$964ee2c26a2e8aba.database
            ] : []
        ],
        experience: $acb737f2b02900d4$var$AGG_EXPERIENCE,
        spaceId: spaceId,
        isLicensed: Boolean(isLicensed),
        includeRecommended: includeRecommended
    };
};
const $acb737f2b02900d4$export$9afcdf80918a886b = (options)=>{
    const { cloudId: cloudId, spaceKey: spaceKey, queryParams: queryParams, userId: userId, isLicensed: isLicensed, spaceId: spaceId = '', isWhiteboardEnabled: isWhiteboardEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false } = options;
    const pagesFilter = (0, $c3Qwv.getSingleParam)(queryParams, 'pagesFilter');
    const searchText = (0, $c3Qwv.getSingleParam)(queryParams, 'text') || '';
    const sort = [
        {
            field: 'latestModifiedDate',
            order: 'DESC'
        }
    ];
    return $acb737f2b02900d4$export$832c8592ab821c21({
        cloudId: cloudId,
        spaceKey: spaceKey,
        userId: userId,
        isLicensed: isLicensed,
        spaceId: spaceId,
        isWhiteboardEnabled: isWhiteboardEnabled,
        isDatabaseEnabled: isDatabaseEnabled,
        searchText: searchText,
        pagesFilter: pagesFilter,
        sort: sort
    });
};
module.exports["convertCcSortToAggSort"] = $acb737f2b02900d4$export$f471e8a003a4fb0d;
module.exports["getAggSpacePagesQueryVariables"] = $acb737f2b02900d4$export$832c8592ab821c21;
module.exports["getPreloadAggSpacePagesQueryVariables"] = $acb737f2b02900d4$export$9afcdf80918a886b;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $5spQU.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $lzcvT.isFedRamp)() && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("aYbn7", function(module, exports) {
/**
 * @generated SignedSource<<3da907304922aa316c0cd54ed0c14713>>
 * @relayHash 7df592bb5fda30e06f43718e9defe250
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19a2cf3f1071fa87f2247c1bd2cea6e61fa75346876ceb3ad87e1ca8779b8e5d
const $ece8cda195425f0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "value"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confRev"
                        }
                    ]
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "number"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"content-appearance-published\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRendererExternalQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRendererExternalQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "7df592bb5fda30e06f43718e9defe250",
            "id": "19a2cf3f1071fa87f2247c1bd2cea6e61fa75346876ceb3ad87e1ca8779b8e5d",
            "metadata": {},
            "name": "ContentRendererExternalQuery",
            "operationKind": "query",
            "text": "query ContentRendererExternalQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{value}},type,version{confRev},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}}}}"
        }
    };
}();
$ece8cda195425f0d$var$node.hash = "8649e53c65ceb270b387846df51531ee";
var $ece8cda195425f0d$export$2e2bcd8739ae039 = $ece8cda195425f0d$var$node;
module.exports["default"] = $ece8cda195425f0d$export$2e2bcd8739ae039;

});

parcelRegister("eP7b6", function(module, exports) {
/**
 * @generated SignedSource<<293007c6777799aa33e10204d25d472b>>
 * @relayHash 002ee32db0695a9b63af69a407a07639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54
const $0ba271c76ca4c8d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"content-appearance-published\")"
                },
                {
                    "alias": "emojiTitlePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "emoji-title-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"emoji-title-published\")"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fabricEditorSupported"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "002ee32db0695a9b63af69a407a07639",
            "id": "5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54",
            "metadata": {},
            "name": "ContentTitleExternalQuery",
            "operationKind": "query",
            "text": "query ContentTitleExternalQuery($contentId:ID!){singleContent(id:$contentId){id,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}"
        }
    };
}();
$0ba271c76ca4c8d2$var$node.hash = "99403818c8d620c95107a7fed0ae3cd7";
var $0ba271c76ca4c8d2$export$2e2bcd8739ae039 = $0ba271c76ca4c8d2$var$node;
module.exports["default"] = $0ba271c76ca4c8d2$export$2e2bcd8739ae039;

});

parcelRegister("9HhEw", function(module, exports) {
/**
 * @generated SignedSource<<79c229d4f4ae3adcbe0b4f7f72920a16>>
 * @relayHash 80f146a83f48be7b9331f291c6222df0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962
const $cb80c8184222fcac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "number"
    }, v10 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v11 = {
        "kind": "ScalarField",
        "name": "syncRev"
    }, v12 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "80f146a83f48be7b9331f291c6222df0",
            "id": "441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962",
            "metadata": {},
            "name": "ExternalByLineQuery",
            "operationKind": "query",
            "text": "query ExternalByLineQuery($contentId:ID!){singleContent(id:$contentId){id,type,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId}},ownedBy{__typename,type,displayName,...on KnownUser{accountId}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,confRev,syncRev,contentTypeModified}}}"
        }
    };
}();
$cb80c8184222fcac$var$node.hash = "012bf9a7497572d73e22134c755e8758";
var $cb80c8184222fcac$export$2e2bcd8739ae039 = $cb80c8184222fcac$var$node;
module.exports["default"] = $cb80c8184222fcac$export$2e2bcd8739ae039;

});

parcelRegister("73cd2", function(module, exports) {
/**
 * @generated SignedSource<<9a2ed8ae8a2e7ca4b0ea0aeb30bd93d4>>
 * @relayHash 3d6684347765949569a6a0a937530a1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b7c9eefa2bf25c978941a86025d172525dda43e3d34b00c7ef169e0d42df0f72
const $6373d130d96f71f6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shareToken"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "referenceId"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                v4 /*: any*/ ,
                {
                    "concreteType": "ConfluenceAccessLinkInfo",
                    "kind": "LinkedField",
                    "name": "accessLinkInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        },
                        v4 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "lastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "when"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        }
                    ]
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "number"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"content-appearance-published\")"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SharedContentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SharedContentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "3d6684347765949569a6a0a937530a1b",
            "id": "b7c9eefa2bf25c978941a86025d172525dda43e3d34b00c7ef169e0d42df0f72",
            "metadata": {},
            "name": "SharedContentQuery",
            "operationKind": "query",
            "text": "query SharedContentQuery($shareToken:String!,$contentId:ID){singleContent(shareToken:$shareToken,id:$contentId){id,referenceId,space{id,key,alias,name},title,type,status,accessLinkInfo{accessType,status},history{createdDate,lastUpdated{when}},version{friendlyWhen},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}}}}"
        }
    };
}();
$6373d130d96f71f6$var$node.hash = "c5a5ac9ed500e0a6ec8cfd14a6151447";
var $6373d130d96f71f6$export$2e2bcd8739ae039 = $6373d130d96f71f6$var$node;
module.exports["default"] = $6373d130d96f71f6$export$2e2bcd8739ae039;

});

parcelRegister("5WLjq", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $5IsL6 = parcelRequire("5IsL6");


var $gW6rh = parcelRequire("gW6rh");


var $4H4Pj = parcelRequire("4H4Pj");


var $4eIcx = parcelRequire("4eIcx");


var $5t9S7 = parcelRequire("5t9S7");

const $0075b8fcac3e7fa4$export$19b525d696aff959 = ({ isLicensed: isLicensed, selectedSpaceKey: selectedSpaceKey })=>{
    const preloadQueries = [];
    if (isLicensed) {
        preloadQueries.push((0, $dYU3e.query)({
            query: (0, $gW6rh.default),
            variables: {},
            __callerPackage__: "@confluence/space-utils"
        }));
        if (selectedSpaceKey) preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4eIcx.default),
            variables: {
                selectedSpaceKey: selectedSpaceKey
            },
            __callerPackage__: "@confluence/space-utils"
        }));
        else preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4H4Pj.default),
            variables: {},
            __callerPackage__: "@confluence/space-utils"
        }));
    } else preloadQueries.push((0, $dYU3e.query)({
        query: (0, $5t9S7.default),
        variables: {},
        __callerPackage__: "@confluence/space-utils"
    }));
    preloadQueries.push((0, $5IsL6.preloadCreateSpace)({
        isLicensed: isLicensed
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(preloadQueries);
};
module.exports["preloadSpacesList"] = $0075b8fcac3e7fa4$export$19b525d696aff959;

});

parcelRegister("5IsL6", function(module, exports) {

var $fEhQK = parcelRequire("fEhQK");


var $dYU3e = parcelRequire("dYU3e");

/**
 * see next/packages/create-space/src/useCanCreateSpace.tsx for the query usage
 */ const $c4ac54148814de4b$var$PreloadCreateSpaceQuery = (0, $fEhQK.default);
const $c4ac54148814de4b$export$25bcc47d8ed557d4 = ({ isLicensed: isLicensed })=>{
    if (!isLicensed) return Promise.resolve({
        data: null
    });
    return (0, $dYU3e.query)({
        query: $c4ac54148814de4b$var$PreloadCreateSpaceQuery,
        __callerPackage__: "@confluence/create-space-preload"
    });
};
module.exports["preloadCreateSpace"] = $c4ac54148814de4b$export$25bcc47d8ed557d4;

});

parcelRegister("fEhQK", function(module, exports) {
/**
 * @generated SignedSource<<d09735fc2cd7a6020b32121ef039e936>>
 * @relayHash a615654a08ce3274fc54e07efd9211ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf
const $ba87c6a44dc20089$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a615654a08ce3274fc54e07efd9211ea",
            "id": "e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf",
            "metadata": {},
            "name": "preloadCreateSpaceQuery",
            "operationKind": "query",
            "text": "query preloadCreateSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation}}}}"
        }
    };
}();
$ba87c6a44dc20089$var$node.hash = "9a716c385cdfcba90204a7cf16292b9a";
var $ba87c6a44dc20089$export$2e2bcd8739ae039 = $ba87c6a44dc20089$var$node;
module.exports["default"] = $ba87c6a44dc20089$export$2e2bcd8739ae039;

});

parcelRegister("gW6rh", function(module, exports) {
/**
 * @generated SignedSource<<ae575abec3161777acd385178274168f>>
 * @relayHash 73d83e15c0dcd8f51610be1a44d77614
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e09890fd62940c18450f16c7b800d12192b6cf88b71dd44d4e5c2c55ff459796
const $af8a2f26164bd677$var$node = function() {
    var v0 = [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeUserGeneratedSpaces"
        }
    ], v1 = {
        "kind": "Literal",
        "name": "status",
        "value": "current"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "favourite",
                    "value": true
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                v1 /*: any*/ 
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(favourite:true,first:30,status:\"current\")"
        },
        {
            "condition": "includeUserGeneratedSpaces",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "userGeneratedSpaces",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "excludeTypes",
                            "value": "system,personal"
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        },
                        v1 /*: any*/ 
                    ],
                    "concreteType": "PaginatedSpaceList",
                    "kind": "LinkedField",
                    "name": "spaces",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "count"
                        }
                    ],
                    "storageKey": "spaces(excludeTypes:\"system,personal\",first:1,status:\"current\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "73d83e15c0dcd8f51610be1a44d77614",
            "id": "e09890fd62940c18450f16c7b800d12192b6cf88b71dd44d4e5c2c55ff459796",
            "metadata": {},
            "name": "useSpacesDataStarredSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataStarredSpacesQuery($includeUserGeneratedSpaces:Boolean=false){spaces(favourite:true,first:30,status:\"current\"){__typename,nodes{alias,id,name,key,status,icon{path}}},userGeneratedSpaces:spaces(first:1,status:\"current\",excludeTypes:\"system,personal\")@include(if:$includeUserGeneratedSpaces){count}}"
        }
    };
}();
$af8a2f26164bd677$var$node.hash = "a96bdb54596b720a5f4c2c48c7e6dd59";
var $af8a2f26164bd677$export$2e2bcd8739ae039 = $af8a2f26164bd677$var$node;
module.exports["default"] = $af8a2f26164bd677$export$2e2bcd8739ae039;

});

parcelRegister("4H4Pj", function(module, exports) {
/**
 * @generated SignedSource<<522284270ccae9ff37ff7a08efdc694a>>
 * @relayHash 0f8f1589411c8c2d9b98218fe1edd493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79
const $893f79462ca6be46$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f8f1589411c8c2d9b98218fe1edd493",
            "id": "68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$893f79462ca6be46$var$node.hash = "7082555a280d4e2eb838dda87a12b019";
var $893f79462ca6be46$export$2e2bcd8739ae039 = $893f79462ca6be46$var$node;
module.exports["default"] = $893f79462ca6be46$export$2e2bcd8739ae039;

});

parcelRegister("4eIcx", function(module, exports) {
/**
 * @generated SignedSource<<2801721cb0c85e92874b08f85a0ef8ee>>
 * @relayHash e0d0ca312e455dd89cba54cfb1984fbb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e
const $f0042d2ade0da40c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "selectedSpaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "alias"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "selectedSpaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "e0d0ca312e455dd89cba54cfb1984fbb",
            "id": "526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias,id,name,key,status,icon{path},currentUser{isFavourited}},myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$f0042d2ade0da40c$var$node.hash = "24da03b127211694c7ed862f0d6a1ac9";
var $f0042d2ade0da40c$export$2e2bcd8739ae039 = $f0042d2ade0da40c$var$node;
module.exports["default"] = $f0042d2ade0da40c$export$2e2bcd8739ae039;

});

parcelRegister("5t9S7", function(module, exports) {
/**
 * @generated SignedSource<<834023d7f0314fe8e5962f6e892c4636>>
 * @relayHash 6a42dba0e2f55d85a4e53a29287ca269
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476
const $410f901cf69fac5d$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(first:10)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "6a42dba0e2f55d85a4e53a29287ca269",
            "id": "5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476",
            "metadata": {},
            "name": "useSpacesDataAnonymousSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataAnonymousSpacesQuery{spaces(first:10){nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$410f901cf69fac5d$var$node.hash = "7f837e22c8d2b27a827944523b07b786";
var $410f901cf69fac5d$export$2e2bcd8739ae039 = $410f901cf69fac5d$var$node;
module.exports["default"] = $410f901cf69fac5d$export$2e2bcd8739ae039;

});

parcelRegister("gGK1T", function(module, exports) {
/**
 * @generated SignedSource<<e983bd00ea24afc042f5f11535352524>>
 * @relayHash b8208417e6c09fc98b947c6af794b0f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327
const $edbbfe37cbd0175f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 4,
            "kind": "LocalArgument",
            "name": "limit"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b8208417e6c09fc98b947c6af794b0f3",
            "id": "c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327",
            "metadata": {},
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "operationKind": "query",
            "text": "query useContentOwnershipContributorsContentOwnershipContributorsQuery($contentId:ID!,$limit:Int=4){content(id:$contentId){nodes{id,history{ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}},contentContributors(id:$contentId,limit:$limit){nodes{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}"
        }
    };
}();
$edbbfe37cbd0175f$var$node.hash = "e8dd42a19657acc23120ab54c46606ff";
var $edbbfe37cbd0175f$export$2e2bcd8739ae039 = $edbbfe37cbd0175f$var$node;
module.exports["default"] = $edbbfe37cbd0175f$export$2e2bcd8739ae039;

});

parcelRegister("2E1L5", function(module, exports) {
const $f1205e6da653ae62$export$16708f74bd486c8 = 'confluence_page_ownership_changeboarding';
const $f1205e6da653ae62$export$9ed1986df73b834a = 'change-page-ownership-link';
const $f1205e6da653ae62$export$21191b0c00ca25f4 = 10;
const $f1205e6da653ae62$export$83728ea2bd792f67 = {
    USER_IS_NULL: 'You cannot set an owner as an anonymous user.',
    USER_NOT_FOUND: 'Owner id is an invalid account id.',
    USER_MISSING_PAGE_PERMISSION: 'New owner must have view and edit permission on the content.',
    CONTENT_ID_INVALID: 'Content id is invalid.',
    INSUFFICIENT_PERMISSIONS: 'You must be the content creator, owner, or a space admin to set the owner.'
};
const $f1205e6da653ae62$export$f0b683cb64dc68b0 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $f1205e6da653ae62$export$b344b39e3835f655 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
const $f1205e6da653ae62$export$7ab4b084abc24ac8 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
module.exports["CONTENT_OWNERSHIP_WEB_ITEM_ID"] = $f1205e6da653ae62$export$9ed1986df73b834a;
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $f1205e6da653ae62$export$21191b0c00ca25f4;
module.exports["EXPECTED_ERROR_MESSAGES"] = $f1205e6da653ae62$export$83728ea2bd792f67;
module.exports["PARENT_PAGE_LEARN_MORE_URL"] = $f1205e6da653ae62$export$f0b683cb64dc68b0;
module.exports["CONFIRM_MODAL_LEARN_MORE_LINK"] = $f1205e6da653ae62$export$7ab4b084abc24ac8;

});

parcelRegister("5Sm9D", function(module, exports) {
/**
 * @generated SignedSource<<e68c8c2a0ac72dcf0482a562e22071ea>>
 * @relayHash 938cf04c38847de21bfb796dc9af87aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1d06804a4ae2ffabafc8e6b49780c37073c78ecce7f41615507292d3f46adfd
const $bcf2a116d61699fa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDevDocsSyncStatus"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "value"
    }, v10 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
            },
            {
                "kind": "Literal",
                "name": "status",
                "value": [
                    "CURRENT",
                    "DRAFT"
                ]
            }
        ],
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "ptpage",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "after",
                        "variableName": "after"
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 40
                    }
                ],
                "concreteType": "PTPaginatedPageList",
                "kind": "LinkedField",
                "name": "children",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PTPage",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v4 /*: any*/ ,
                            v5 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            v6 /*: any*/ ,
                            v7 /*: any*/ ,
                            {
                                "concreteType": "Map_LinkType_String",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "webui"
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "keys",
                                        "value": [
                                            "emoji-title-published",
                                            "emoji-title-draft",
                                            "editor"
                                        ]
                                    }
                                ],
                                "concreteType": "PaginatedJsonContentPropertyList",
                                "kind": "LinkedField",
                                "name": "properties",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JsonContentProperty",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v4 /*: any*/ ,
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ ,
                                            {
                                                "concreteType": "Version",
                                                "kind": "LinkedField",
                                                "name": "version",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "number"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                            }
                        ]
                    },
                    {
                        "concreteType": "PTPageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v11 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v12 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            }
        ]
    }, v13 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ]
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v15 = {
        "condition": "includeDevDocsSyncStatus",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "devDocsProperties",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "devdocsProperties"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v13 /*: any*/ ,
                "storageKey": "properties(keys:[\"devdocsProperties\"])"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FolderOverviewFirstPageQuery",
            "selections": [
                v10 /*: any*/ ,
                {
                    "args": v11 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FolderOverviewFirstPageQuery",
            "selections": [
                v10 /*: any*/ ,
                {
                    "args": v11 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "938cf04c38847de21bfb796dc9af87aa",
            "id": "f1d06804a4ae2ffabafc8e6b49780c37073c78ecce7f41615507292d3f46adfd",
            "metadata": {},
            "name": "FolderOverviewFirstPageQuery",
            "operationKind": "query",
            "text": "query FolderOverviewFirstPageQuery($id:ID!,$after:String,$contentId:ID!,$includeDevDocsSyncStatus:Boolean=false){ptpage(id:$id,status:[CURRENT,DRAFT]){id,title,type,subType,children(first:40,after:$after){nodes{id,title,status,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage,endCursor}}},singleContent(id:$contentId){operations{operation},properties(keys:[\"smartFolderProperties\"]){nodes{id,key,value}},devDocsProperties:properties(keys:[\"devdocsProperties\"])@include(if:$includeDevDocsSyncStatus){nodes{id,key,value}},id}}"
        }
    };
}();
$bcf2a116d61699fa$var$node.hash = "52018df6850c12446148663e546e2027";
var $bcf2a116d61699fa$export$2e2bcd8739ae039 = $bcf2a116d61699fa$var$node;
module.exports["default"] = $bcf2a116d61699fa$export$2e2bcd8739ae039;

});

parcelRegister("gAiOv", function(module, exports) {
/**
 * @generated SignedSource<<b5b48afb644b1c9ba2115e786ebc4620>>
 * @relayHash b0ec5645a9816290c20ca3f2be3c63ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b19a28811756f63c5661a06a4b602a408a80b7c8bf0a7bb74fe1ca80eb1c203e
const $9d045dbcaa31f409$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "CURRENT",
                        "DRAFT"
                    ]
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        }
                    ],
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "concreteType": "Map_LinkType_String",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webui"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "children(first:1)"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FolderRedirectFirstChildQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FolderRedirectFirstChildQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "b0ec5645a9816290c20ca3f2be3c63ff",
            "id": "b19a28811756f63c5661a06a4b602a408a80b7c8bf0a7bb74fe1ca80eb1c203e",
            "metadata": {},
            "name": "FolderRedirectFirstChildQuery",
            "operationKind": "query",
            "text": "query FolderRedirectFirstChildQuery($id:ID!){ptpage(id:$id,status:[CURRENT,DRAFT]){id,title,children(first:1){nodes{id,title,type,links{webui}}}}}"
        }
    };
}();
$9d045dbcaa31f409$var$node.hash = "fe1ad2671600d4e91a1ebc56f4fdea48";
var $9d045dbcaa31f409$export$2e2bcd8739ae039 = $9d045dbcaa31f409$var$node;
module.exports["default"] = $9d045dbcaa31f409$export$2e2bcd8739ae039;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<5557859264359e1b675fb8554d840b36>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("84kyw", function(module, exports) {
/**
 * @generated SignedSource<<3d2d56fdc053aa2d3639c1f34cea6843>>
 * @relayHash 701de8d25c0615cd65d074a2d0d26386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e4874aa6f1795a40140739a4ef2d22670502e0aa0add7ff9834458df2767c17
const $ee303482ff843c0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "CURRENT",
                        "DRAFT"
                    ]
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSmartFolderAncestorSyncQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSmartFolderAncestorSyncQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "701de8d25c0615cd65d074a2d0d26386",
            "id": "9e4874aa6f1795a40140739a4ef2d22670502e0aa0add7ff9834458df2767c17",
            "metadata": {},
            "name": "useSmartFolderAncestorSyncQuery",
            "operationKind": "query",
            "text": "query useSmartFolderAncestorSyncQuery($contentId:ID!){ptpage(id:$contentId,status:[CURRENT,DRAFT]){id,type,subType,nearestAncestors{nodes{id,type,subType}}}}"
        }
    };
}();
$ee303482ff843c0d$var$node.hash = "3feebc26cc696b75c6544fb3f45823b7";
var $ee303482ff843c0d$export$2e2bcd8739ae039 = $ee303482ff843c0d$var$node;
module.exports["default"] = $ee303482ff843c0d$export$2e2bcd8739ae039;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<77901a4d26c14ce3e165e61f1fbc7d81>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("MyxIQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bnKhH = parcelRequire("bnKhH");


var $5dPMD = parcelRequire("5dPMD");


var $301rJ = parcelRequire("301rJ");


var $6mKj3 = parcelRequire("6mKj3");


var $xwvlW = parcelRequire("xwvlW");


var $wPrRK = parcelRequire("wPrRK");


var $1xpoY = parcelRequire("1xpoY");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");



var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME = 'post-office';
const $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME = 'post-office-archetype';
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit)=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $5dPMD.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    // Mirror client-side guard in Placement.tsx (useInitialDataIfEnabled → isPostOfficePlacementsGloballyDisabled)
    // to prevent SSR/client mismatch when placements are globally disabled (e.g. stableUI=1).
    if (postOfficeContext.disableAllPlacements) return;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, isBifrostIcRequest: isBifrostIcRequest } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME,
                // Tells Tesseract to S2S with `post-office`
                ...isBifrostIcRequest === true && (0, $6mKj3.expVal)('confluence_ssr_bifrost_ic', 'isEnabled', false) ? {
                    'x-archetype-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME
                } : {},
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit);
    };
    const basePath = (0, $bnKhH.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $5dPMD.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $42omo.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $42omo.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $42omo.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, extraFetchOptions)=>{
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const postOfficeTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_postoffice_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return (0, $wPrRK.slowQueryGuard)(`preloadPostOfficePlacement:${placementId}`, ()=>$cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
            postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(sessionContext),
            environment: {
                currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(sessionContext.environment)
            }
        }, extraFetchOptions), postOfficeTimeout);
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("bnKhH", function(module, exports) {

var $7kqqb = parcelRequire("7kqqb");


var $c3xd8 = parcelRequire("c3xd8");

const $121828a65173ad3f$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $c3xd8.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $7kqqb.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};
module.exports["buildBasePath"] = $121828a65173ad3f$export$e8b30f9c4a80230f;

});

parcelRegister("5dPMD", function(module, exports) {
const $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $99c9a9fbdb7e3c13$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};
module.exports["defaultFetcher"] = $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3;
module.exports["requestInitialData"] = $99c9a9fbdb7e3c13$export$c4c39037cc4b06ab;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-\/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined,
        disableAllPlacements: (0, $i3jcY.isStableUIEnabledForTests)() ? true : undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("byPOx", function(module, exports) {
/**
 * @generated SignedSource<<b733e0a60fa7a2103af52ebf9c82676d>>
 * @relayHash 411aa56f960d21732fdea57d6645aefa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a480d9b1888fbb308b36f8f29f5b4576f84e4817c537652251e266c7ab98d45d
const $c11e5f03fd3a6c81$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "411aa56f960d21732fdea57d6645aefa",
            "id": "a480d9b1888fbb308b36f8f29f5b4576f84e4817c537652251e266c7ab98d45d",
            "metadata": {},
            "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
            "operationKind": "query",
            "text": "query useGetTeamAndSubanchorGetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$c11e5f03fd3a6c81$var$node.hash = "d084357d5b8c80b2a717087a9d5973e6";
var $c11e5f03fd3a6c81$export$2e2bcd8739ae039 = $c11e5f03fd3a6c81$var$node;
module.exports["default"] = $c11e5f03fd3a6c81$export$2e2bcd8739ae039;

});

parcelRegister("lWFZM", function(module, exports) {
/**
 * @generated SignedSource<<a28a6d4ece37010a1b3dc61b788601fc>>
 * @relayHash c4dbb1e53daef1b7c8f169a3f50616ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83251c724d7af2d6ea333c162ae5a4de26266110e4352c5b02f33510b840978f
const $f9637bad6b9857cf$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "usePersonalSpace",
                    "value": true
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "templateId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentBlueprintId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blueprintModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "itemModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ],
            "storageKey": "allTemplates(usePersonalSpace:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "PersonalizedTemplatesV2AllTemplatesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "PersonalizedTemplatesV2AllTemplatesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c4dbb1e53daef1b7c8f169a3f50616ce",
            "id": "83251c724d7af2d6ea333c162ae5a4de26266110e4352c5b02f33510b840978f",
            "metadata": {},
            "name": "PersonalizedTemplatesV2AllTemplatesQuery",
            "operationKind": "query",
            "text": "query PersonalizedTemplatesV2AllTemplatesQuery{allTemplates(usePersonalSpace:true){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,name}}}"
        }
    };
}();
$f9637bad6b9857cf$var$node.hash = "f89ae5ce759533fd2a0812719d0966df";
var $f9637bad6b9857cf$export$2e2bcd8739ae039 = $f9637bad6b9857cf$var$node;
module.exports["default"] = $f9637bad6b9857cf$export$2e2bcd8739ae039;

});

parcelRegister("l57Xv", function(module, exports) {
/**
 * @generated SignedSource<<23711dc6752a7094995d8efb756e1c1a>>
 * @relayHash 1dbbd240576b496aabf7631bbe5e8317
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad6fa59108f9429438bd30d3273091c7c3dbac7714e0489bd218aecdc02623cc
const $03e9502d9a3559f4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "GrowthUnifiedProfileResult",
            "kind": "LinkedField",
            "name": "growthUnifiedProfile_getUnifiedProfile",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GrowthUnifiedProfilePaidChannelContextByProduct",
                    "kind": "LinkedField",
                    "name": "paidChannelContext",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GrowthUnifiedProfilePaidChannelContext",
                            "kind": "LinkedField",
                            "name": "confluence",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "subAnchor"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1dbbd240576b496aabf7631bbe5e8317",
            "id": "ad6fa59108f9429438bd30d3273091c7c3dbac7714e0489bd218aecdc02623cc",
            "metadata": {},
            "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
            "operationKind": "query",
            "text": "query useGetTeamAndSubanchorGetSubanchorsAGGQuery($accountId:ID!){growthUnifiedProfile_getUnifiedProfile(accountId:$accountId){paidChannelContext{confluence{subAnchor}}}}"
        }
    };
}();
$03e9502d9a3559f4$var$node.hash = "41238e70a66e2ffbcfc5e10ca0de9d20";
var $03e9502d9a3559f4$export$2e2bcd8739ae039 = $03e9502d9a3559f4$var$node;
module.exports["default"] = $03e9502d9a3559f4$export$2e2bcd8739ae039;

});

parcelRegister("k2RxH", function(module, exports) {

var $d4Pk4 = parcelRequire("d4Pk4");


var $ctLrB = parcelRequire("ctLrB");


var $7Pigg = parcelRequire("7Pigg");


var $493fu = parcelRequire("493fu");

const $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3 = [
    (0, $ctLrB.ActivityEventType).EDITED,
    (0, $ctLrB.ActivityEventType).PUBLISHED,
    (0, $ctLrB.ActivityEventType).UPDATED,
    (0, $ctLrB.ActivityEventType).CREATED,
    (0, $ctLrB.ActivityEventType).STARTED,
    (0, $ctLrB.ActivityEventType).SNAPSHOTTED
];
const $355018d1e9284f84$var$COLLABORATED_ON_EVENT_TYPES = [
    (0, $ctLrB.ActivityEventType).COMMENTED,
    ...$355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3
];
const $355018d1e9284f84$var$OBJECT_TYPES = [
    (0, $ctLrB.ActivitiesObjectType).PAGE,
    (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
    (0, $ctLrB.ActivitiesObjectType).EMBED
];
const $355018d1e9284f84$var$PAGE_SIZE = 24;
const $355018d1e9284f84$export$c0883c47d72a59fc = ({ pill: pill, cloudId: cloudId, endCursor: endCursor, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled, isDatabaseEnabled: isDatabaseEnabled })=>{
    const createdDateFilter = 'and created >= startOfDay("-90d") ';
    const activityQuery = (0, $7Pigg.default);
    const activityCloudId = (0, $d4Pk4.PlatformSiteAri).create({
        siteId: cloudId
    }).toString();
    switch(pill){
        case 'created':
            return {
                query: (0, $493fu.default),
                variables: {
                    cql: `type in (page, blogpost, embed${isWhiteboardUpdatedEnabled ? ', whiteboard' : ''}${isDatabaseEnabled ? ', database' : ''}) and owner=currentUser() ${createdDateFilter}order by created desc`,
                    cqlcontext: `{"contentStatuses":["draft", "current"]}`,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor
                }
            };
        case 'worked-on':
            return {
                query: activityQuery,
                variables: {
                    cloudId: activityCloudId,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3,
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        (0, $ctLrB.ActivitiesObjectType).CONTENT,
                        ...isWhiteboardUpdatedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : []
                    ]
                }
            };
        case 'collaborated-on':
            return {
                query: activityQuery,
                variables: {
                    cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                        siteId: cloudId
                    }).toString(),
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: $355018d1e9284f84$var$COLLABORATED_ON_EVENT_TYPES,
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        ...isWhiteboardUpdatedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : [],
                        (0, $ctLrB.ActivitiesObjectType).CONTENT,
                        (0, $ctLrB.ActivitiesObjectType).COMMENT
                    ]
                }
            };
        case 'all':
        default:
            return {
                query: activityQuery,
                variables: {
                    cloudId: activityCloudId,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: [],
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        (0, $ctLrB.ActivitiesObjectType).CONTENT,
                        ...isWhiteboardViewedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : []
                    ]
                }
            };
    }
};
module.exports["getRecentQueryOptions"] = $355018d1e9284f84$export$c0883c47d72a59fc;

});

parcelRegister("d4Pk4", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $985375b928439e07$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $985375b928439e07$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $985375b928439e07$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $985375b928439e07$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $985375b928439e07$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $985375b928439e07$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $985375b928439e07$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("ctLrB", function(module, exports) {

var $5T18X = parcelRequire("5T18X");


var $aXWIB = parcelRequire("aXWIB");

var $61e4e33a86012bad$export$62aa48085237e36f = /*#__PURE__*/ function(LoadingState) {
    LoadingState[LoadingState["done"] = 0] = "done";
    LoadingState[LoadingState["initial"] = 1] = "initial";
    LoadingState[LoadingState["pagination"] = 2] = "pagination";
    return LoadingState;
}({});
var $61e4e33a86012bad$export$f5dd0176116f8854 = /*#__PURE__*/ function(HomeViewFilters) {
    HomeViewFilters["ALL"] = "ALL";
    HomeViewFilters["WORKED_ON"] = "WORKED_ON";
    HomeViewFilters["CREATED"] = "CREATED";
    HomeViewFilters["STARRED"] = "STARRED";
    HomeViewFilters["TASKS"] = "TASKS";
    HomeViewFilters["DRAFTS"] = "DRAFTS";
    return HomeViewFilters;
}({});
var $61e4e33a86012bad$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}({});
var $61e4e33a86012bad$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["SLIDE"] = "SLIDE";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivitiesObjectType["CONTENT"] = "CONTENT";
    ActivitiesObjectType["COMMENT"] = "COMMENT";
    return ActivitiesObjectType;
}({});
const $61e4e33a86012bad$var$i18n = (0, $aXWIB.defineMessages)({
    untitled: {
        id: "home.views.untitled",
        defaultMessage: "Untitled"
    }
});
const $61e4e33a86012bad$export$232e7dd3cd551a33 = $61e4e33a86012bad$var$i18n.untitled;
const $61e4e33a86012bad$export$2786ecc2e2951fe3 = (networkStatus)=>{
    if (networkStatus === (0, $5T18X.NetworkStatus).loading || networkStatus === (0, $5T18X.NetworkStatus).setVariables) return 1;
    if (networkStatus === (0, $5T18X.NetworkStatus).fetchMore) return 2;
    return 0;
};
function $61e4e33a86012bad$export$b29ea735dcfba3c1(value) {
    return value !== null && value !== undefined;
}
const $61e4e33a86012bad$export$4b0a6c95b9c45006 = (textFilter, title)=>{
    const trimmedTextFilter = textFilter.trim();
    if (trimmedTextFilter === '') return true;
    return (title || '').toUpperCase().indexOf(textFilter.toUpperCase()) > -1;
};
const $61e4e33a86012bad$export$c29c1699278467fe = (recent, isActivityV3HomeRecent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        recent.object.data = recent?.object?.data?.container;
    }
    const content = recent?.object?.data;
    if (isActivityV3HomeRecent) {
        if (content) {
            content.type = content.type?.toLowerCase();
            if (content.type === 'blog_post') content.type = 'blogpost';
            content.subtype = content.subtype?.toLowerCase();
            // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
            // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
            // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
            content.status = [
                content.status,
                content.pageStatus,
                content.blogStatus
            ].find((status)=>status)?.toLowerCase();
            // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
            if (content.status === 'draft' && content.createdAt) content.status = 'current';
        }
        recent.event.eventType = recent.event?.eventType.toUpperCase();
    }
    return recent;
};
const $61e4e33a86012bad$export$7105b33a95adadcf = (content)=>{
    return content?.status !== 'archived';
};
const $61e4e33a86012bad$export$d54a312242c6a930 = (content)=>{
    return content?.status !== 'trashed';
};
const $61e4e33a86012bad$export$78ba6bbd8fcbc43f = (userId, content)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    return userId === createdBy?.accountId;
};
module.exports["LoadingState"] = $61e4e33a86012bad$export$62aa48085237e36f;
module.exports["HomeViewFilters"] = $61e4e33a86012bad$export$f5dd0176116f8854;
module.exports["ActivityEventType"] = $61e4e33a86012bad$export$132f858337fea016;
module.exports["ActivitiesObjectType"] = $61e4e33a86012bad$export$4edf00fad4b97379;
module.exports["untitled"] = $61e4e33a86012bad$export$232e7dd3cd551a33;
module.exports["getLoadingState"] = $61e4e33a86012bad$export$2786ecc2e2951fe3;
module.exports["notEmpty"] = $61e4e33a86012bad$export$b29ea735dcfba3c1;
module.exports["byTitle"] = $61e4e33a86012bad$export$4b0a6c95b9c45006;
module.exports["transformActivityData"] = $61e4e33a86012bad$export$c29c1699278467fe;
module.exports["notArchived"] = $61e4e33a86012bad$export$7105b33a95adadcf;
module.exports["notDeleted"] = $61e4e33a86012bad$export$d54a312242c6a930;
module.exports["isCreatorCurrentUser"] = $61e4e33a86012bad$export$78ba6bbd8fcbc43f;

});

parcelRegister("7Pigg", function(module, exports) {
/**
 * @generated SignedSource<<482cb30e3ae284d8984fc9037a9cc5b4>>
 * @relayHash 3dad6697998a01d7a3ed7ebc02048dd1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c2ea6b5f911e55d36ef6b0b36d1ea8e472c62e46f062984bf199c0ae27820518
const $38dad1ddcca5450a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "eventTypes"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "objectTypes"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "eventTypes",
                            "variableName": "eventTypes"
                        },
                        {
                            "kind": "Variable",
                            "name": "objectTypes",
                            "variableName": "objectTypes"
                        },
                        {
                            "kind": "Literal",
                            "name": "products",
                            "value": [
                                "CONFLUENCE"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "arguments"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "rootContainerIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "rootContainerIds"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "AND"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v11 = {
        "alias": "pageStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v13 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v14 = [
        v13 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "editUi"
        }
    ], v15 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v14 /*: any*/ 
    }, v16 = {
        "concreteType": "ConfluenceBodies",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "excerpt"
            }
        ]
    }, v17 = [
        {
            "concreteType": "ConfluenceFavoritedSummary",
            "kind": "LinkedField",
            "name": "favoritedSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavorite"
                }
            ]
        }
    ], v18 = {
        "concreteType": "ConfluencePageViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v19 = {
        "concreteType": "ConfluenceCommentCountSummary",
        "kind": "LinkedField",
        "name": "commentCountSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "total"
            }
        ]
    }, v20 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v21 = {
        "concreteType": "ConfluenceLikesSummary",
        "kind": "LinkedField",
        "name": "likesSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v22 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "editor"
            ]
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "value"
    }, v24 = [
        v23 /*: any*/ 
    ], v25 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiDraft",
                "plural": false,
                "selections": v24 /*: any*/ 
            },
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiPublished",
                "plural": false,
                "selections": v24 /*: any*/ 
            }
        ]
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v21 /*: any*/ ,
            {
                "alias": "editorVersion",
                "args": v22 /*: any*/ ,
                "concreteType": "ConfluencePageProperty",
                "kind": "LinkedField",
                "name": "properties",
                "plural": true,
                "selections": v24 /*: any*/ ,
                "storageKey": "properties(keys:[\"editor\"])"
            },
            v25 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v27 = {
        "alias": "blogStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v28 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v14 /*: any*/ 
    }, v29 = {
        "concreteType": "ConfluenceBlogPostViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v30 = {
        "alias": "editorVersion",
        "args": v22 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v24 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v31 = {
        "kind": "ScalarField",
        "name": "status"
    }, v32 = [
        v13 /*: any*/ 
    ], v33 = {
        "concreteType": "ConfluenceContentViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v34 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v32 /*: any*/ 
            },
            v33 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ 
        ],
        "type": "ConfluenceWhiteboard"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v32 /*: any*/ 
            },
            v33 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ 
        ],
        "type": "ConfluenceDatabase"
    }, v36 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "concreteType": "ConfluenceEmbedLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v32 /*: any*/ 
            },
            v33 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v25 /*: any*/ 
        ],
        "type": "ConfluenceEmbed"
    }, v37 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v38 = [
        v7 /*: any*/ ,
        v37 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v26 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v27 /*: any*/ ,
                        v28 /*: any*/ ,
                        v16 /*: any*/ ,
                        v29 /*: any*/ ,
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        v30 /*: any*/ ,
                        v25 /*: any*/ 
                    ],
                    "type": "ConfluenceBlogPost"
                },
                v34 /*: any*/ 
            ]
        }
    ], v39 = {
        "concreteType": "ActivityEvent",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "ScalarField",
                "name": "eventType"
            }
        ]
    }, v40 = {
        "concreteType": "ActivityPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v41 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v42 = [
        v23 /*: any*/ ,
        v7 /*: any*/ 
    ], v43 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v21 /*: any*/ ,
            {
                "alias": "editorVersion",
                "args": v22 /*: any*/ ,
                "concreteType": "ConfluencePageProperty",
                "kind": "LinkedField",
                "name": "properties",
                "plural": true,
                "selections": v42 /*: any*/ ,
                "storageKey": "properties(keys:[\"editor\"])"
            },
            v25 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v44 = {
        "alias": "editorVersion",
        "args": v22 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v42 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v45 = [
        v7 /*: any*/ 
    ], v46 = {
        "kind": "InlineFragment",
        "selections": v45 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v47 = [
        v7 /*: any*/ ,
        v37 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v41 /*: any*/ ,
                v43 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v27 /*: any*/ ,
                        v28 /*: any*/ ,
                        v16 /*: any*/ ,
                        v29 /*: any*/ ,
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        v44 /*: any*/ ,
                        v25 /*: any*/ 
                    ],
                    "type": "ConfluenceBlogPost"
                },
                v34 /*: any*/ ,
                v46 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentActivityQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v25 /*: any*/ 
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        },
                                                                        v34 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v38 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v38 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v39 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v40 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentActivityQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v41 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v44 /*: any*/ ,
                                                                                v25 /*: any*/ 
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        },
                                                                        v34 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v47 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v47 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        },
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v45 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v45 /*: any*/ ,
                                                                            "type": "MercuryPortfolio"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v39 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v40 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3dad6697998a01d7a3ed7ebc02048dd1",
            "id": "c2ea6b5f911e55d36ef6b0b36d1ea8e472c62e46f062984bf199c0ae27820518",
            "metadata": {},
            "name": "HomeRecentActivityQuery",
            "operationKind": "query",
            "text": "query HomeRecentActivityQuery($cloudId:ID!,$first:Int,$after:String,$eventTypes:[String!],$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceInlineComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on ConfluenceFooterComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}},event{id,timestamp,eventType}}},pageInfo{hasNextPage,endCursor}}}}}"
        }
    };
}();
$38dad1ddcca5450a$var$node.hash = "52341ed87e0393b64ab0d4467f335784";
var $38dad1ddcca5450a$export$2e2bcd8739ae039 = $38dad1ddcca5450a$var$node;
module.exports["default"] = $38dad1ddcca5450a$export$2e2bcd8739ae039;

});

parcelRegister("493fu", function(module, exports) {
/**
 * @generated SignedSource<<450d62048a00a7671a0495c232f885c6>>
 * @relayHash f0145d2844cb31576b9be51e3b4df41d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2a7906eff37e0caa37a462044732c692e9ba5599a2b0e93eb2b126520f4761b
const $c756b2564f8020f1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "cqlcontext",
            "variableName": "cqlcontext"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 372
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:372)"
    }, v11 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "createdDate"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v5 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v14 = {
        "concreteType": "LikesResponse",
        "kind": "LinkedField",
        "name": "likes",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v17 = {
        "kind": "ScalarField",
        "name": "value"
    }, v18 = {
        "alias": "editorVersion",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v12 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"editor\")"
    }, v19 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v17 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\"])"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v21 = [
        v20 /*: any*/ 
    ], v22 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v23 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v20 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentCreatedQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentCreatedQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f0145d2844cb31576b9be51e3b4df41d",
            "id": "b2a7906eff37e0caa37a462044732c692e9ba5599a2b0e93eb2b126520f4761b",
            "metadata": {},
            "name": "HomeRecentCreatedQuery",
            "operationKind": "query",
            "text": "query HomeRecentCreatedQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{content{id,title,type,subType,links{webui,editui},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},createdDate},space{alias,id,key,name},likes{count},status,blank,editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\"]){nodes{id,value,key}},history{createdBy{__typename,...on KnownUser{accountId}}},version{by{__typename,...on KnownUser{accountId}}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$c756b2564f8020f1$var$node.hash = "85d080eebc369ed2623af7fb67441257";
var $c756b2564f8020f1$export$2e2bcd8739ae039 = $c756b2564f8020f1$var$node;
module.exports["default"] = $c756b2564f8020f1$export$2e2bcd8739ae039;

});

parcelRegister("5dcQK", function(module, exports) {
/**
 * @generated SignedSource<<ab148751716f98f00deddf45b6de3959>>
 * @relayHash 375208eee06e531e31912b7a419f44d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ead1382726b260e2d93f54b2da52d4042d91bc06acdee3a39ad5b4709186307
const $a2dc34d339146e99$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "recentFilter"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "375208eee06e531e31912b7a419f44d0",
            "id": "6ead1382726b260e2d93f54b2da52d4042d91bc06acdee3a39ad5b4709186307",
            "metadata": {},
            "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
            "operationKind": "query",
            "text": "query useRecentPreferencesHomeRecentUserPreferencesQuery{userPreferences{recentFilter}}"
        }
    };
}();
$a2dc34d339146e99$var$node.hash = "7467140cd6c953941675ec5eab0f0de2";
var $a2dc34d339146e99$export$2e2bcd8739ae039 = $a2dc34d339146e99$var$node;
module.exports["default"] = $a2dc34d339146e99$export$2e2bcd8739ae039;

});

parcelRegister("1abNy", function(module, exports) {
/**
 * @generated SignedSource<<45e1157e30330b381f1779e6a6b13578>>
 * @relayHash 62d0ae3cc424d28cdfd278c6ed4201e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 02857286577e787ccdd046602aa1cf2c1745318f4c88787491f6db95af2b6f9b
const $4ae0e3efa3fecc57$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "start"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "start",
                    "variableName": "start"
                }
            ],
            "concreteType": "PaginatedContentList",
            "kind": "LinkedField",
            "name": "favoriteContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "excerpt"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "lastUpdated",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "when"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "editorVersion",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v3 /*: any*/ ,
                            "storageKey": "properties(key:\"editor\")"
                        },
                        {
                            "alias": "emoji",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v3 /*: any*/ ,
                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "RecentlyViewedSummary",
                                            "kind": "LinkedField",
                                            "name": "viewed",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastSeen"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "LikesModelMetadataDto",
                                    "kind": "LinkedField",
                                    "name": "likes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                                    "kind": "LinkedField",
                                    "name": "comments",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "commentsCount"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                },
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useStarredDataHomeStarredPagesQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useStarredDataHomeStarredPagesQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "62d0ae3cc424d28cdfd278c6ed4201e3",
            "id": "02857286577e787ccdd046602aa1cf2c1745318f4c88787491f6db95af2b6f9b",
            "metadata": {},
            "name": "useStarredDataHomeStarredPagesQuery",
            "operationKind": "query",
            "text": "query useStarredDataHomeStarredPagesQuery($limit:Int,$start:Int)@allowHigherTimeout{favoriteContent(limit:$limit,start:$start){nodes{id,subType,type,title,excerpt,links{editui,webui},history{lastUpdated{when}},editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}},metadata{currentuser{favourited{isFavourite},viewed{lastSeen}},likes{count},comments{commentsCount}},space{alias,id,key,name}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$4ae0e3efa3fecc57$var$node.hash = "16905464af1968f88f238bc0c6585634";
var $4ae0e3efa3fecc57$export$2e2bcd8739ae039 = $4ae0e3efa3fecc57$var$node;
module.exports["default"] = $4ae0e3efa3fecc57$export$2e2bcd8739ae039;

});

parcelRegister("d64J2", function(module, exports) {
/**
 * @generated SignedSource<<2d62ef64b860026e339ca7c6a503eb4c>>
 * @relayHash b21205896b56de61c144ea7d0548f80d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d1b9f41b5612543ef58997db3b4d247971963f3a0117ac3fffe895483a45f2e
const $ed2416599a6e6a62$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v6 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Literal",
                    "name": "cql",
                    "value": "type in (page,blogpost) order by lastModified desc"
                },
                {
                    "kind": "Variable",
                    "name": "cqlcontext",
                    "variableName": "cqlcontext"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webui"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "editui"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "length",
                                            "value": 372
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "excerpt",
                                    "storageKey": "excerpt(length:372)"
                                },
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                            "kind": "LinkedField",
                                            "name": "currentuser",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "FavouritedSummary",
                                                    "kind": "LinkedField",
                                                    "name": "favourited",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isFavourite"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                                            "kind": "LinkedField",
                                            "name": "comments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "commentsCount"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastModifiedDate"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "LikesResponse",
                                    "kind": "LinkedField",
                                    "name": "likes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "blank"
                                },
                                {
                                    "alias": "editorVersion",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "editor"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"editor\")"
                                },
                                {
                                    "alias": "emoji",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "emoji-title-draft"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(keys:[\"emoji-title-draft\"])"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useDraftsDataHomeDraftsQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useDraftsDataHomeDraftsQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "b21205896b56de61c144ea7d0548f80d",
            "id": "1d1b9f41b5612543ef58997db3b4d247971963f3a0117ac3fffe895483a45f2e",
            "metadata": {},
            "name": "useDraftsDataHomeDraftsQuery",
            "operationKind": "query",
            "text": "query useDraftsDataHomeDraftsQuery($cqlcontext:String,$first:Int,$after:String){search:confluence_search(cql:\"type in (page,blogpost) order by lastModified desc\",cqlcontext:$cqlcontext,first:$first,after:$after){nodes{content{id,title,type,subType,links{webui,editui},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},lastModifiedDate},space{alias,id,key,name},likes{count},status,blank,editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-draft\"]){nodes{id,key,value}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$ed2416599a6e6a62$var$node.hash = "7618e5a200bb793a16a7e96fb74bdb29";
var $ed2416599a6e6a62$export$2e2bcd8739ae039 = $ed2416599a6e6a62$var$node;
module.exports["default"] = $ed2416599a6e6a62$export$2e2bcd8739ae039;

});

parcelRegister("kgC8N", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ const $8494f2a7cbb1632a$var$PAGE_SIZE = 24;
const $8494f2a7cbb1632a$export$57a6045b566b8b90 = {
    variables: {
        cqlcontext: `{"contentStatuses":["draft"]}`,
        first: $8494f2a7cbb1632a$var$PAGE_SIZE
    }
};
module.exports["DRAFTS_QUERY_OPTIONS"] = $8494f2a7cbb1632a$export$57a6045b566b8b90;

});

parcelRegister("01STT", function(module, exports) {
var $8357fd24c5d501e8$export$27a5bd065ad55220 = /*#__PURE__*/ function(View) {
    View["OVERVIEW"] = "overview";
    View["RECENT"] = "recent";
    View["STARRED"] = "starred";
    View["WATCHING"] = "watching";
    View["DRAFTS"] = "drafts";
    View["TASKS"] = "tasks";
    return View;
}({});
const $8357fd24c5d501e8$export$f183fe8f38c8cf4f = [
    "recent",
    "starred",
    "watching",
    "drafts",
    "tasks"
];
module.exports["View"] = $8357fd24c5d501e8$export$27a5bd065ad55220;
module.exports["SUPPORTED_ROUTES"] = $8357fd24c5d501e8$export$f183fe8f38c8cf4f;

});

parcelRegister("iwZYw", function(module, exports) {
/**
 * @generated SignedSource<<0f601e53264e4335e95f52245f9778c6>>
 * @relayHash 7354786c74bc87b4af0be7aa1c508959
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cabf46c80d68570a7536cd273538fd1d7a98ce651705dc29413ac4754b769dbc
const $3ac726b99ebc60d4$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceAdminAnnouncementBanner",
            "kind": "LinkedField",
            "name": "adminAnnouncementBanner",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "isDismissible"
                },
                {
                    "kind": "ScalarField",
                    "name": "content"
                },
                {
                    "kind": "ScalarField",
                    "name": "appearance"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "updatedAt"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7354786c74bc87b4af0be7aa1c508959",
            "id": "cabf46c80d68570a7536cd273538fd1d7a98ce651705dc29413ac4754b769dbc",
            "metadata": {},
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "operationKind": "query",
            "text": "query useRegisterAdminAnnouncementBannerQuery{adminAnnouncementBanner{id,isDismissible,content,appearance,title,updatedAt}}"
        }
    };
}();
$3ac726b99ebc60d4$var$node.hash = "240e64f11995d52e66311a69dc8032ab";
var $3ac726b99ebc60d4$export$2e2bcd8739ae039 = $3ac726b99ebc60d4$var$node;
module.exports["default"] = $3ac726b99ebc60d4$export$2e2bcd8739ae039;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<dc205b784e864c4042673f60370ebfb9>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("eI9QI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9NsQV = parcelRequire("9NsQV");


var $gGDxH = parcelRequire("gGDxH");


var $PAiZW = parcelRequire("PAiZW");


var $6yHRM = parcelRequire("6yHRM");


var $lgxIi = parcelRequire("lgxIi");

const $1f89a5665998c680$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $1f89a5665998c680$export$daf66a67c26dc848 = (config)=>{
    const currentScopeNames = $1f89a5665998c680$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $42omo.useCallback)((input)=>$1f89a5665998c680$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentScopeNames
    ]);
    const [state, setState] = (0, $42omo.useState)($1f89a5665998c680$var$initialState);
    const route = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    const nextScopeNames = $1f89a5665998c680$var$scopesNamesAsString(next);
    const updateKey = `${currentScopeNames}-${nextScopeNames}`;
    $1f89a5665998c680$var$usePostOfficeScopeSpy(state, config);
    (0, $42omo.useEffect)(()=>{
        if ($1f89a5665998c680$export$fcc046cb16c47539({
            next: next,
            state: state,
            treatIntersectionAsSame: config.treatIntersectionAsSame
        })) setState(({ current: current })=>({
                updateKey: (0, $gGDxH.simpleHash)(updateKey),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updateKey
    ]);
    return state;
};
const $1f89a5665998c680$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $1f89a5665998c680$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route ? 'pathname' in route ? {
            route: route,
            context: context
        } : route.current ? {
            route: $1f89a5665998c680$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $1f89a5665998c680$export$5c1cef6f5f213829({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $1f89a5665998c680$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname, search: search } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname,
        search: search
    };
};
const $1f89a5665998c680$export$5c1cef6f5f213829 = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($9NsQV)))(contextMatch, inputMatch, (contextValue, inputValue)=>$1f89a5665998c680$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $1f89a5665998c680$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $1f89a5665998c680$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $1f89a5665998c680$export$5c1cef6f5f213829({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $1f89a5665998c680$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $1f89a5665998c680$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($1f89a5665998c680$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $1f89a5665998c680$export$fcc046cb16c47539 = ({ next: next, state: state, treatIntersectionAsSame: treatIntersectionAsSame })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (treatIntersectionAsSame) {
        if (currentSet.length !== 0 && nextSet.length === 0) return true;
    } else {
        if (currentSet.length !== nextSet.length) return true;
    }
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $1f89a5665998c680$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $lgxIi.createSimplePubSub)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $42omo.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $1f89a5665998c680$var$scopesNamesAsString(state.current)
    ]);
};
module.exports["usePostOfficeContextScope"] = $1f89a5665998c680$export$daf66a67c26dc848;
module.exports["createMatchScopes"] = $1f89a5665998c680$export$ec890b48cae4cc1c;

});

parcelRegister("9NsQV", function(module, exports) {

var $6Ovzg = parcelRequire("6Ovzg");


var $bJedp = parcelRequire("bJedp");

/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $721f12379a69ffbe$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $6Ovzg(object, source, $bJedp(source), customizer);
}
module.exports = $721f12379a69ffbe$var$isMatchWith;

});

parcelRegister("gGDxH", function(module, exports) {
const $f93f74f184f2a2a2$export$b211ce59c0ea1cfb = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};
module.exports["simpleHash"] = $f93f74f184f2a2a2$export$b211ce59c0ea1cfb;

});

parcelRegister("6yHRM", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $hxT4C = parcelRequire("hxT4C");


var $4H1Ql = parcelRequire("4H1Ql");

const $d8346e8a2779e8cd$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $d8346e8a2779e8cd$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $d8346e8a2779e8cd$var$usePostOfficeRouteStore = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const { subscribe: subscribe, getSnapshot: getSnapshot } = t0;
    const route = (0, $hxT4C.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $4H1Ql.useStableObject)(route);
} : ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $hxT4C.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $4H1Ql.useStableObject)(route);
};
const $d8346e8a2779e8cd$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $d8346e8a2779e8cd$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$d8346e8a2779e8cd$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $d8346e8a2779e8cd$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $42omo.createContext)($d8346e8a2779e8cd$var$initialState);
const $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $42omo.useRef)();
    if (!ref.current) ref.current = $d8346e8a2779e8cd$export$98c77e1bd702ed15(props);
    const route = $d8346e8a2779e8cd$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8346e8a2779e8cd$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $d8346e8a2779e8cd$export$79301b66f7808cd8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($d8346e8a2779e8cd$export$f7f47a74e8b47b1f);
} : ()=>(0, $42omo.useContext)($d8346e8a2779e8cd$export$f7f47a74e8b47b1f); //Route listener
module.exports["PostOfficeRouteContext"] = $d8346e8a2779e8cd$export$f7f47a74e8b47b1f;
module.exports["PostOfficeRouteProvider"] = $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e;
module.exports["usePostOfficeRoute"] = $d8346e8a2779e8cd$export$79301b66f7808cd8;

});

parcelRegister("4H1Ql", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $6932c2b531d219ac$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $6932c2b531d219ac$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>obj, $6932c2b531d219ac$export$cdf98ded28406f69(obj));
}
module.exports["useStableObject"] = $6932c2b531d219ac$export$ed02d4adf2068b08;

});

parcelRegister("lgxIi", function(module, exports) {
const $f1742253be8873a8$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};
module.exports["createSimplePubSub"] = $f1742253be8873a8$export$92469b55607f005b;

});

parcelRegister("2mPpz", function(module, exports) {

var $byfJM = parcelRequire("byfJM");

const $479bf4f98cf9c8c7$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $byfJM.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $479bf4f98cf9c8c7$export$8a57effc6307f916;

});

parcelRegister("byfJM", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $T9xHm = parcelRequire("T9xHm");


var $1eSke = parcelRequire("1eSke");

var $4H1Ql = parcelRequire("4H1Ql");


var $kO3gu = parcelRequire("kO3gu");


var $a8wvv = parcelRequire("a8wvv");


var $9dOtv = parcelRequire("9dOtv");


var $eXPKf = parcelRequire("eXPKf");

var $MnX4h = parcelRequire("MnX4h");


var $2HRxT = parcelRequire("2HRxT");

const $573f4005c25c6dbc$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $2HRxT.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $T9xHm.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $1eSke.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $4H1Ql.useStableObject)(context);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kO3gu.MaybePlacementFetchingProvider), {
                fetch: fetch?.fetch,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $MnX4h.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $573f4005c25c6dbc$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $573f4005c25c6dbc$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $9dOtv.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $a8wvv.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
module.exports["createPlacementComponent"] = $573f4005c25c6dbc$export$8a57effc6307f916;

});

parcelRegister("9dOtv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $94fea169e2cb8de7$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $42omo.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};
module.exports["useComponentErrorHandling"] = $94fea169e2cb8de7$export$3d127465d22fe4e5;

});

parcelRegister("190tu", function(module, exports) {
module.exports = JSON.parse('{"adminhub.user.requests.count.message.spotlight.content.body":[{"type":0,"value":"See how many times a user has tried to access their requested app"}],"adminhub.user.requests.count.message.spotlight.content.done":[{"type":0,"value":"Done"}],"adminhub.user.requests.count.message.spotlight.content.headline":[{"type":0,"value":"View access attempts"}],"growth-groot.components.email.footer.message":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"growth-groot.et-group-product-assignment.message-template.email.analytics.description":[{"type":0,"value":"Visualize data across Atlassian products for actionable insights."}],"growth-groot.et-group-product-assignment.message-template.email.analytics.description-appify":[{"type":0,"value":"Visualize data across Atlassian apps for actionable insights."}],"growth-groot.et-group-product-assignment.message-template.email.avocado.description":[{"type":0,"value":"Question and answer."}],"growth-groot.et-group-product-assignment.message-template.email.beacon.description":[{"type":0,"value":"Security monitoring."}],"growth-groot.et-group-product-assignment.message-template.email.bitbucket.description":[{"type":0,"value":"Code management and collaboration."}],"growth-groot.et-group-product-assignment.message-template.email.body.footer":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"growth-groot.et-group-product-assignment.message-template.email.body.invite-button":[{"type":0,"value":"Accept Invite"}],"growth-groot.et-group-product-assignment.message-template.email.body.product-desc.learn-more":[{"type":0,"value":"Learn more"}],"growth-groot.et-group-product-assignment.message-template.email.body.product-desc.title":[{"type":0,"value":"What is "},{"type":1,"value":"productName"},{"type":0,"value":"? "}],"growth-groot.et-group-product-assignment.message-template.email.body.with-reinvite":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join "},{"type":1,"value":"productName"},{"type":0,"value":" 3 days ago. Start collaborating with your team."}],"growth-groot.et-group-product-assignment.message-template.email.body.without-product":[{"type":0,"value":"Start planning and tracking work with "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" and your team. You can share your work and view what your team is doing."}],"growth-groot.et-group-product-assignment.message-template.email.body.without-product-no-inviter":[{"type":0,"value":"Start planning and tracking work with your team. You can share your work and view what your team is doing."}],"growth-groot.et-group-product-assignment.message-template.email.compass.description":[{"type":0,"value":"Mission control for your distributed architecture."}],"growth-groot.et-group-product-assignment.message-template.email.confluence.description":[{"type":0,"value":"A team workspace where knowledge and collaboration meet. Create, collaborate, and organize all your work in one place."}],"growth-groot.et-group-product-assignment.message-template.email.jira-product-discovery.description":[{"type":0,"value":"Jira Product Discovery is a dedicated tool for product teams to capture and prioritize ideas, connect business and tech teams, and align everyone - all in Jira."}],"growth-groot.et-group-product-assignment.message-template.email.jira-servicedesk.description":[{"type":0,"value":"IT service desk and customer service."}],"growth-groot.et-group-product-assignment.message-template.email.jira.description":[{"type":0,"value":"A software tool for project and issue tracking across your team. Plan, track and manage your projects in Jira."}],"growth-groot.et-group-product-assignment.message-template.email.loom.description":[{"type":0,"value":"Record and share Loom videos to keep your team up to date on progress, feedback, ideas, and more."}],"growth-groot.et-group-product-assignment.message-template.email.mercury.bodyDescription":[{"type":0,"value":"Understand your company\u2019s strategic priorities and start mapping focus areas with your team. Connect goals, work, positions, and funds to maximize your enterprise strategy."}],"growth-groot.et-group-product-assignment.message-template.email.mercury.description":[{"type":0,"value":"Define and map strategic priorities and track progress with your team."}],"growth-groot.et-group-product-assignment.message-template.email.opsgenie.description":[{"type":0,"value":"A software tool for incident management. Track on-call alerts and notifications."}],"growth-groot.et-group-product-assignment.message-template.email.rovo.description":[{"type":0,"value":"Start using the same AI your team uses to find answers across your apps and work faster with chat, search, and agents."}],"growth-groot.et-group-product-assignment.message-template.email.statuspage.description":[{"type":0,"value":"What is Statuspage? A software tool for incident communication."}],"growth-groot.et-group-product-assignment.message-template.email.subject":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join them in "},{"type":1,"value":"subjectName"}],"growth-groot.et-group-product-assignment.message-template.email.subject.no-inviter":[{"type":0,"value":"You\'re invited to collaborate in "},{"type":1,"value":"subjectName"}],"growth-groot.et-group-product-assignment.message-template.email.subject.no-subject-name":[{"type":0,"value":"You\'ve been invited"}],"growth-groot.et-group-product-assignment.message-template.email.subject.with-reminder":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" is waiting for you to join "},{"type":1,"value":"subjectName"}],"growth-groot.et-group-product-assignment.message-template.email.townsquare.description":[{"type":0,"value":"A software tool to connect work across your company. Share work and get aligned across teams."}],"growth-groot.et-group-product-assignment.message-template.email.trello.description":[{"type":0,"value":"Tasks and project management."}],"growth-groot.pending-request-access-summary.message-template.in-app-notification.body":[{"type":0,"value":"Approve or deny your users\' requests for app access."}],"growth-groot.pending-request-access-summary.message-template.in-app-notification.heading":[{"type":1,"value":"totalRequests"},{"type":0,"value":" access requests are waiting for review"}],"user.access.settings.access.message.spotlight.content.body":[{"type":0,"value":"Create a message that users in your organization will see when they want to request access to an app."}],"user.access.settings.access.message.spotlight.content.got.it":[{"type":0,"value":"Got it"}],"user.access.settings.access.message.spotlight.content.headline":[{"type":0,"value":"Create an access message"}]}');

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("cZpTL", function(module, exports) {

let $974f456871e7d5ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $974f456871e7d5ba$var$load("b4iHn").then(()=>parcelRequire('3uWkR'));

});

parcelRegister("b5mhT", function(module, exports) {

let $81217335d72176a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $81217335d72176a4$var$load("19ttb").then(()=>parcelRequire('icsSU'));

});

parcelRegister("9Twow", function(module, exports) {

let $73426102477d2cf4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73426102477d2cf4$var$load("5NKrA").then(()=>parcelRequire('hnN7X'));

});

parcelRegister("iCk4Y", function(module, exports) {

let $d8db59ec341f2658$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d8db59ec341f2658$var$load("aetL8").then(()=>parcelRequire('5UVjp'));

});

parcelRegister("i0ur8", function(module, exports) {

let $d1bfd631771fde8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1bfd631771fde8b$var$load("coXup").then(()=>parcelRequire('33ZWD'));

});

parcelRegister("l7s9R", function(module, exports) {

let $f60018001123478a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f60018001123478a$var$load("6kVMK").then(()=>parcelRequire('ouvWk'));

});

parcelRegister("gnY8c", function(module, exports) {

let $bedd701fc0feb01d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bedd701fc0feb01d$var$load("5OaiG").then(()=>parcelRequire('9axUZ'));

});

parcelRegister("9LdEZ", function(module, exports) {

let $71b319715af04023$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71b319715af04023$var$load("i2Jso").then(()=>parcelRequire('h9L08'));

});

parcelRegister("fEHAt", function(module, exports) {

let $b65c66f216a4aca8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b65c66f216a4aca8$var$load("9B8Bd").then(()=>parcelRequire('MGf8Y'));

});

parcelRegister("47Um8", function(module, exports) {

let $301387fc609d3262$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $301387fc609d3262$var$load("jHepN").then(()=>parcelRequire('e44Fo'));

});

parcelRegister("fr5Eg", function(module, exports) {

let $b3cdc24fb862c41b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b3cdc24fb862c41b$var$load("d46Pi").then(()=>parcelRequire('gpThh'));

});

parcelRegister("6PuHy", function(module, exports) {

let $4f8f5229931f17c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f8f5229931f17c9$var$load("eeMOG").then(()=>parcelRequire('cBOO6'));

});

parcelRegister("34UIr", function(module, exports) {

let $23ddbd606004137a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23ddbd606004137a$var$load("lW8R4").then(()=>parcelRequire('jWkPs'));

});

parcelRegister("gAwaN", function(module, exports) {

let $c138f70a6c7a3cc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c138f70a6c7a3cc2$var$load("j9rax").then(()=>parcelRequire('h0r4N'));

});

parcelRegister("lVcnf", function(module, exports) {

let $ff5885112779d3bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff5885112779d3bc$var$load("cZuCl").then(()=>parcelRequire('gTx21'));

});

parcelRegister("hBROz", function(module, exports) {

let $cd1fa2d790cc0d81$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd1fa2d790cc0d81$var$load("gjBqp").then(()=>parcelRequire('8XWZn'));

});

parcelRegister("gVffl", function(module, exports) {

let $c51dcbd983c76c99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c51dcbd983c76c99$var$load("4CqYs").then(()=>parcelRequire('6Tw4t'));

});

parcelRegister("kJQNY", function(module, exports) {

let $f190f8950f48cf49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f190f8950f48cf49$var$load("i199v").then(()=>parcelRequire('c826G'));

});

parcelRegister("iVNUL", function(module, exports) {

let $dc8444db037a1cac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc8444db037a1cac$var$load("eaM7F").then(()=>parcelRequire('dthp3'));

});

parcelRegister("izM9A", function(module, exports) {

let $d860d93439d67bda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d860d93439d67bda$var$load("cpSee").then(()=>parcelRequire('d7yPV'));

});

parcelRegister("ciqSJ", function(module, exports) {

let $8f3c04a90959be60$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f3c04a90959be60$var$load("dCQ5d").then(()=>parcelRequire('3A9bn'));

});

parcelRegister("jjEwj", function(module, exports) {

let $03a1050cf8ecc644$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03a1050cf8ecc644$var$load("4QLQu").then(()=>parcelRequire('gZUAr'));

});

parcelRegister("dv3cd", function(module, exports) {

let $9d40a64a49826454$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9d40a64a49826454$var$load("a3k0s").then(()=>parcelRequire('8eUFi'));

});

parcelRegister("37kkP", function(module, exports) {

let $2451cca2453bf127$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2451cca2453bf127$var$load("kCWiJ").then(()=>parcelRequire('bIn0W'));

});

parcelRegister("3b4CG", function(module, exports) {

let $2505fc2fb34e4a00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2505fc2fb34e4a00$var$load("2rq8e").then(()=>parcelRequire('hhK5X'));

});

parcelRegister("6xgDq", function(module, exports) {

let $4c22ba8278b78b0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c22ba8278b78b0e$var$load("abKBD").then(()=>parcelRequire('6A0DB'));

});

parcelRegister("kN3Ki", function(module, exports) {

let $f22b4a11ccb407dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f22b4a11ccb407dc$var$load("lxVhC").then(()=>parcelRequire('hPB6S'));

});

parcelRegister("b6EFp", function(module, exports) {

let $815fccd2f3c73363$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $815fccd2f3c73363$var$load("hTobg").then(()=>parcelRequire('jvZAq'));

});

parcelRegister("c5Azu", function(module, exports) {

let $8cd251f98fc854b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cd251f98fc854b4$var$load("fjubE").then(()=>parcelRequire('bYctw'));

});

parcelRegister("6cSLG", function(module, exports) {

let $484e58d8afc58edc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $484e58d8afc58edc$var$load("lSU7I").then(()=>parcelRequire('gc8KT'));

});

parcelRegister("dcpcT", function(module, exports) {

let $99bff2ead6c32be0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99bff2ead6c32be0$var$load("7Ufta").then(()=>parcelRequire('5tPp4'));

});

parcelRegister("lITtB", function(module, exports) {

let $fd08bd7fc1066ea2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd08bd7fc1066ea2$var$load("bWrsN").then(()=>parcelRequire('aRrm7'));

});

parcelRegister("6Rfcd", function(module, exports) {

let $4fe37aead58ea8b7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4fe37aead58ea8b7$var$load("lqmFY").then(()=>parcelRequire('eWIaf'));

});

parcelRegister("ktVuZ", function(module, exports) {

let $ee931e2c91de30d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee931e2c91de30d7$var$load("jowz2").then(()=>parcelRequire('jHKJ6'));

});

parcelRegister("gNhq8", function(module, exports) {
module.exports = JSON.parse('{"admin-hub-notifications.dropdown-menu-button.aria-label":[{"type":0,"value":"More actions"}],"admin-hub-notifications.unread-notifications.aria-label":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" unread notification"}]},"other":{"value":[{"type":7},{"type":0,"value":" unread notifications"}]}},"pluralType":"cardinal","type":6,"value":"displayedCount"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-0":[{"type":0,"value":"Gain insight into your current period, past usage, and 30, 60, 90-day history."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-1":[{"type":0,"value":"Explore usage broken down by apps, features, and individual users."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-2":[{"type":0,"value":"Download usage data for in-depth analysis, custom reports, and easy sharing."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-0":[{"type":0,"value":"Track "},{"type":1,"value":"meterName"},{"type":0,"value":" credits across time"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-1":[{"type":0,"value":"Granular "},{"type":1,"value":"meterName"},{"type":0,"value":" insights"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-2":[{"type":0,"value":"Download usage reports"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-1":[{"type":0,"value":"Different reports now live in dedicated spaces so you can quickly find what you need."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-2":[{"type":0,"value":"Assess your Data Center instances and get them ready for cloud migration."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-3":[{"type":0,"value":"Monitor and improve the health and performance of your Data Center instances."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-4":[{"type":0,"value":"Discover Data Center instances you own based on existing connections."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-1":[{"type":0,"value":"What\'s new in Portfolio insights"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-2":[{"type":0,"value":"Cloud readiness"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-3":[{"type":0,"value":"Instance health"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-4":[{"type":0,"value":"Detected instances"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-rovo-chat-button-spotlight.body":[{"type":0,"value":"Troubleshoot common tasks with Rovo admin skills. Go to "},{"type":1,"value":"rovoSettings"},{"type":0,"value":" to turn on "},{"type":1,"value":"rovoChatInAdministration"},{"type":0,"value":"."}],"admin-hub.adminhub-rovo-chat-button-spotlight.button-open-rovo-chat":[{"type":0,"value":"Open Rovo Chat"}],"admin-hub.adminhub-rovo-chat-button-spotlight.heading":[{"type":0,"value":"Meet your new admin assistant"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-chat-in-administration":[{"type":0,"value":"Rovo Chat in Administration"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-settings-link":[{"type":0,"value":"Rovo settings"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-settings-link-text":[{"type":0,"value":"Rovo settings"}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.body":[{"type":0,"value":"Turn on Rovo Chat to enable it in Atlassian Administration."}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.button-try-it":[{"type":0,"value":"Turn on"}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.heading":[{"type":0,"value":"Turn on Rovo Chat"}],"admin-hub.adminhub-theme-darkmode.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-theme-darkmode.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-theme-darkmode.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-theme-darkmode.spotlight-body-1":[{"type":0,"value":"Reduce glare and boost focus with our sleek new dark theme."}],"admin-hub.adminhub-theme-darkmode.spotlight-body-2":[{"type":0,"value":"Go dark, stay light, or match your browser settings. Give it a try."}],"admin-hub.adminhub-theme-darkmode.spotlight-heading-1":[{"type":0,"value":"Experience dark mode"}],"admin-hub.adminhub-theme-darkmode.spotlight-heading-2":[{"type":0,"value":"Switch themes"}],"admin-hub.adminhub-theme-darkmode.step-count-1":[{"type":0,"value":"1 of 2"}],"admin-hub.adminhub-theme-darkmode.step-count-2":[{"type":0,"value":"2 of 2"}],"adminhub.inbox.recommendations.placement.header":[{"type":0,"value":"Recommendations"}],"ai-3p-connector-action-required.admin-hub-notifications.actionLink":[{"type":0,"value":"Go to connector settings"}],"ai-3p-connector-action-required.admin-hub-notifications.body":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector is still syncing, but a configuration issue needs your review. Some content may not be included as intended until it\'s resolved. Go to the connector setting and select the "},{"children":[{"type":0,"value":"Action required"}],"type":8,"value":"b"},{"type":0,"value":" status on your connector to see what needs attention and how to fix it."}],"ai-3p-connector-action-required.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector needs attention"}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.actionLink":[{"type":0,"value":"Go to connector settings"}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.body":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector"},{"options":{"other":{"value":[]},"true":{"value":[{"type":0,"value":" on "},{"type":1,"value":"cloudUrl"}]}},"type":5,"value":"hasCloudUrl"},{"type":0,"value":" is currently experiencing issues and cannot sync data from "},{"type":1,"value":"connectorType"},{"type":0,"value":"."}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.heading":[{"type":0,"value":"Action required: Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" Teamwork Graph connector needs attention"}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.actionLink":[{"type":0,"value":"View your connectors"}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.body":[{"type":0,"value":"Good news! Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector"},{"options":{"other":{"value":[]},"true":{"value":[{"type":0,"value":" on "},{"type":1,"value":"cloudUrl"}]}},"type":5,"value":"hasCloudUrl"},{"type":0,"value":" has recovered and is now syncing data normally. No further action is required."}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" Teamwork Graph connector is back online"}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.actionLink":[{"type":0,"value":"View your connectors"}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.body":[{"type":0,"value":"We\'ve finished the initial sync of your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector and ingested everything your connector configuration allows. Your data is now searchable in Rovo - try asking a question or running a search to see it in action."}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector\'s initial sync is complete"}],"brie-automated-restore-failed.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the automated restore test for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" run on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This may affect your ability to recover data if needed. Review restore test view more details."}],"brie-automated-restore-failed.admin-hub-notifications.heading":[{"type":0,"value":"Automated restore test did not complete"}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.action":[{"type":0,"value":"Check Backup"}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.body":[{"type":0,"value":"You can view details in the attached report or download the report for "},{"type":1,"value":"product"},{"type":0,"value":"."}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" backup "},{"type":1,"value":"status"},{"type":0,"value":" for "},{"type":1,"value":"cloudUrl"}],"brie-backup-failed.admin-hub-notifications.body":[{"type":0,"value":"The backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" failed on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This means your latest data may not be protected. Review backup job to view more details."}],"brie-backup-failed.admin-hub-notifications.heading":[{"type":0,"value":"Backup failed"}],"brie-backup-incomplete.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This means your latest data may not be protected. Review backup job to view more details."}],"brie-backup-incomplete.admin-hub-notifications.heading":[{"type":0,"value":"Backup did not complete"}],"brie-restore-completed-successfully.admin-hub-notifications.body":[{"type":0,"value":"The restore job for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" finished successfully. Review restore job to view more details."}],"brie-restore-completed-successfully.admin-hub-notifications.heading":[{"type":0,"value":"Restore complete"}],"brie-restore-failed.admin-hub-notifications.body":[{"type":0,"value":"The restore for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" that started at "},{"type":1,"value":"startTime"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":" has failed. Review restore job to view more details."}],"brie-restore-failed.admin-hub-notifications.heading":[{"type":0,"value":"Restore failed"}],"brie-restore-incomplete.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the restore for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" started at "},{"type":1,"value":"startTime"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". Review restore job to view more details."}],"brie-restore-incomplete.admin-hub-notifications.heading":[{"type":0,"value":"Restore did not complete"}],"brie-scheduler-halted-access-issue.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t run the scheduled backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":" due to a user access issue. This means your latest data may not be protected."}],"brie-scheduler-halted-access-issue.admin-hub-notifications.heading":[{"type":0,"value":"Scheduled backup could not run"}],"commerce.commerce-soft-limit-breach-ccp.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" is over the user limit"}],"commerce.commerce-soft-limit-breach-ccp.body-default.no-translate":[{"type":0,"value":"We recommend removing users as soon as possible if you don\'t want to automatically upgrade user tiers"}],"encryption.policy-page.spotlight.apps":[{"type":0,"value":"Your CMK encrypted apps will appear here."}],"encryption.policy-page.spotlight.back":[{"type":0,"value":"Back"}],"encryption.policy-page.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"encryption.policy-page.spotlight.done":[{"type":0,"value":"Done"}],"encryption.policy-page.spotlight.next":[{"type":0,"value":"Next"}],"encryption.policy-page.spotlight.tenantIdVpce":[{"type":0,"value":"Update your AWS KMS key policy with Encryption Tenant Identifier-tag pair and VPC endpoint(s) to enhance security."}],"growth-groot.pending-request-access-summary.admin-hub-notification.body":[{"type":0,"value":"Approve or deny your users\' requests for app access."}],"growth-groot.pending-request-access-summary.admin-hub-notification.heading":[{"type":1,"value":"totalRequests"},{"type":0,"value":" access requests are waiting for review"}],"placement.admin-hub-notifications.button.markAsRead":[{"type":0,"value":"Mark all as read"}],"placement.admin-hub-notifications.give-feedback":[{"type":0,"value":"Give feedback"}],"placement.admin-hub-notifications.learn-more.beta":[{"type":0,"value":"About this feature"}],"placement.admin-hub-notifications.main-heading":[{"type":0,"value":"Notifications"}],"placement.admin-hub-notifications.mark-as-read-tooltip":[{"type":0,"value":"Mark as read"}],"placement.admin-hub-notifications.mark-as-unread-tooltip":[{"type":0,"value":"Mark as unread"}],"post-office.access-invalid-payment.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid losing your Atlassian Access security settings, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.access-invalid-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.access-missing-payment.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid losing your Atlassian Access security settings, add your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.access-missing-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.actionLink":[{"type":0,"value":"Regenerate key"}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.body":[{"type":0,"value":"Regenerate key for "},{"type":1,"value":"directoryName"},{"type":0,"value":" to continue customer provisioning."}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.header":[{"type":0,"value":"Your SCIM API key will expire on "},{"type":1,"value":"expirationDate"},{"type":0,"value":"."}],"post-office.admin-hub-expiring-scim-tokens.notification.actionLink":[{"type":0,"value":"Regenerate key"}],"post-office.admin-hub-expiring-scim-tokens.notification.body":[{"type":0,"value":"Regenerate key for "},{"type":1,"value":"directoryName"},{"type":0,"value":" to continue user provisioning."}],"post-office.admin-hub-expiring-scim-tokens.notification.header":[{"type":0,"value":"Your SCIM API key will expire on "},{"type":1,"value":"expirationDate"},{"type":0,"value":"."}],"post-office.admin-hub-permissions-notification-shipit.admin-hub-notifications.body.non-final":[{"type":1,"value":"requesterName"},{"type":0,"value":" requested org admin permissions for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"post-office.admin-hub-permissions-notification-shipit.admin-hub-notifications.heading.non-final":[{"type":0,"value":"Org Admin Request"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.admin-hub-notifications.body":[{"type":0,"value":"We\'ve found "},{"children":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" Atlassian app"}]},"other":{"value":[{"type":7},{"type":0,"value":" Atlassian apps"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"type":8,"value":"strong"},{"type":0,"value":" that might belong to your portfolio. Review and connect them to get more insights. "}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.admin-hub-notifications.heading":[{"type":0,"value":"Detected "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" Atlassian app"}]},"other":{"value":[{"type":7},{"type":0,"value":" Atlassian apps"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.notification.buttonText":[{"type":0,"value":"Review detected apps"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.admin-hub-notifications.body":[{"type":0,"value":"We\'ve found "},{"children":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" product"}]},"other":{"value":[{"type":7},{"type":0,"value":" products"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"type":8,"value":"strong"},{"type":0,"value":" that might belong to your portfolio. Review and connect them to get more insights. "}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.admin-hub-notifications.heading":[{"type":0,"value":"Detected "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" product"}]},"other":{"value":[{"type":7},{"type":0,"value":" products"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.notification.buttonText":[{"type":0,"value":"Review detected products"}],"post-office.adminhub-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.adminhub-scope-alignment-reminder.admin-hub-notifications.body":[{"type":0,"value":"We\'re consolidating groups and teams visibility to support future improvements and features. Assign teams to a site to avoid losing team data."}],"post-office.adminhub-scope-alignment-reminder.admin-hub-notifications.heading":[{"type":0,"value":"Teams must be assigned to sites"}],"post-office.adminhub-scope-alignment-reminder.notification.buttonText":[{"type":0,"value":"Assign teams"}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.body":[{"type":0,"value":"As a result, some features will be restricted or unavailable until your allowance resets."}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.heading":[{"type":1,"value":"chargeElement"},{"type":0,"value":" limit reached"}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit has been used"}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.action":[{"type":0,"value":"Review new bill"}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.body":[{"type":0,"value":"You can now be billed for this app based on the number of Jira Service Management agents, instead of Jira users. If you don\'t switch to the new way of billing, we\'ll transition you automatically soon."}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Move to a new way of billing for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management"}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.action":[{"type":0,"value":"View subscription"}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.body":[{"type":0,"value":"The way you\'re billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management has been updated, which means you\'re now billed based on the number of JSM agents who have access to the app. Organization admins can view and manage user access in Atlassian Administration."}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Enjoy more control over billing for "},{"type":1,"value":"productName"},{"type":0,"value":" for JSM"}],"post-office.commerce-invoice-json-download-ppc.admin-hub-notifications.body":[{"type":0,"value":"You can start your download by clicking here"}],"post-office.commerce-invoice-json-download-ppc.admin-hub-notifications.heading":[{"type":0,"value":"JSON file for invoice ["},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"] is ready"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple-different-trial-lengths.admin-hub.notification.body":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlement"},{"type":0,"value":" purchase."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple-different-trial-lengths.admin-hub.notification.header":[{"type":0,"value":"Try "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" free"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple.admin-hub.notification.body":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlement"},{"type":0,"value":" purchase."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple.admin-hub.notification.header":[{"type":0,"value":"Try "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-confluence.admin-hub.notification.body":[{"type":0,"value":"Tired of hunting for the right doc? Build a single source of truth for your team\u2019s info with Confluence "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-confluence.admin-hub.notification.header":[{"type":0,"value":"Try Confluence"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jira.admin-hub.notification.body":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. Try the "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" plan free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jira.admin-hub.notification.header":[{"type":0,"value":"Try Jira"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jpd.admin-hub.notification.body":[{"type":0,"value":"Say goodbye to messy backlogs. Keep your brilliant ideas in one place with Jira Product Discovery "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jpd.admin-hub.notification.header":[{"type":0,"value":"Try Jira Product Discovery"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jsm.admin-hub.notification.body":[{"type":0,"value":"Bring developers, IT, and ops on the same tool and make work visible across teams with the "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" plan. Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jsm.admin-hub.notification.header":[{"type":0,"value":"Try Jira Service Management"}],"post-office.commerce-migration-opsgenie-ccp.admin-hub.notification.body":[{"type":0,"value":"We\u2019ll need a payment method before "},{"type":1,"value":"lastDate"},{"type":0,"value":" to start the migration, otherwise migration will be cancelled automatically"}],"post-office.commerce-migration-opsgenie-ccp.admin-hub.notification.header.heading":[{"type":0,"value":"Migrating Opsgenie to "},{"type":1,"value":"targetProductName"},{"type":0,"value":", bill approval pending"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\'re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount on your Atlassian Guard subscription for one year and the estimated bill may have changed. Review the bill estimate based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount-appify.admin-hub.notification.header.heading":[{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount applied on your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount.admin-hub.notification.body":[{"type":0,"value":"We\'re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount on your Atlassian Guard subscription for one year and the estimated bill may have changed. Review the bill estimate based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount.admin-hub.notification.header.heading":[{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount applied on your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.secondary-action":[{"type":0,"value":"Download Report"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\u2019re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount for one year on your Atlassian Guard subscription. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of the discounted Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount.admin-hub.notification.body":[{"type":0,"value":"We\u2019re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount for one year on your Atlassian Guard subscription. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of the discounted Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Review the subscription plan."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"A new Atlassian Guard subscription has been activated"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-review-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription for your Jira Service Management Premium account. Verify the domains and review the list of users who\u2019ll use Atlassian Guard."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-review-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Configure your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of your newly activated Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of your newly activated Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-review-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription for your Jira Service Management Premium account. Verify the domains and review the list of users who\u2019ll use Atlassian Guard."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-review-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Configure your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp.admin-hub.notification.body":[{"type":1,"value":"bodyContent"}],"post-office.commerce-migration-opsgenie-generic-ccp.admin-hub.notification.header.heading":[{"type":1,"value":"titleContent"}],"post-office.commerce-payment-failure-hams-atlassian-access-paid.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid losing your Atlassian Access security settings, update your payment details."}],"post-office.commerce-payment-failure-hams-atlassian-access-paid.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-atlassian-access-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid losing your Atlassian Access security settings, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-atlassian-access-trial.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-multi-product-paid.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions for this site ("},{"type":1,"value":"siteUrl"},{"type":0,"value":") due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-hams-multi-product-paid.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-hams-multi-product-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for subscriptions for this site ("},{"type":1,"value":"siteUrl"},{"type":0,"value":"). To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-multi-product-trial.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-hams-single-product-paid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-hams-single-product-paid.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-single-product-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-single-product-trial.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-trials-multi-product-invalid-payment.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions on your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-trials-multi-product-invalid-payment.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-trials-multi-product-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscriptions on your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"). To avoid your subscriptions being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-trials-multi-product-missing-payment.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-trials-single-product-invalid-payment.body":[{"type":0,"value":"We couldn\u2019t process payment for subscription due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-trials-single-product-invalid-payment.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-trials-single-product-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details."}],"post-office.commerce-payment-failure-trials-single-product-missing-payment.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-permission-request-add-payment-ccp.admin-hub-notifications.body.no-translate":[{"options":{"other":{"value":[{"type":0,"value":"Hi, I\u2019d like to request an upgrade and need payment details added to this subscription."}]},"true":{"value":[{"type":1,"value":"customMessage"}]}},"type":5,"value":"hasCustomMessage"}],"post-office.commerce-permission-request-add-payment-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Request to add payment from "},{"type":1,"value":"name"}],"post-office.commerce-permission-request-add-payment-response-ccp.admin-hub-notifications.body.no-translate":[{"type":0,"value":"Great news! Your request has been approved. Billing admin has added payment details to your subscription."}],"post-office.commerce-permission-request-add-payment-response-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Payment details added by billing admin"}],"post-office.commerce-permission-request-grant-ba-role-ccp.admin-hub-notifications.body.no-translate":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"children":[{"type":1,"value":"email"}],"type":8,"value":"b"},{"type":0,"value":") requested billing admin permission."}],"post-office.commerce-permission-request-grant-ba-role-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Billing admin access requested"}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-approved.admin-hub-notifications.body":[{"type":0,"value":"Your billing admin request was approved."}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-approved.admin-hub-notifications.heading":[{"type":0,"value":"You\'re now a billing admin"}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-declined.admin-hub-notifications.body":[{"type":0,"value":"Your billing admin request was declined. If needed, you can submit another request."}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-declined.admin-hub-notifications.heading":[{"type":0,"value":"Your request to be a billing admin was declined"}],"post-office.commerce-pre-dunning-ccp-multi-trial-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for some of your subscriptions. To avoid your subscriptions being deactivated, add payment details as soon as possible."}],"post-office.commerce-pre-dunning-ccp-multi-trial-missing-payment.heading":[{"type":0,"value":"Your trial expired for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-pre-dunning-ccp-single-trial-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-pre-dunning-ccp-single-trial-missing-payment.heading":[{"type":0,"value":"Your "},{"type":1,"value":"product"},{"type":0,"value":" trial expired"}],"post-office.commerce-quote-json-download-ppc.admin-hub-notifications.body":[{"type":0,"value":"You can start your download by clicking here"}],"post-office.commerce-quote-json-download-ppc.admin-hub-notifications.heading":[{"type":0,"value":"JSON file for quote ["},{"type":1,"value":"quoteNumber"},{"type":0,"value":"] is ready"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-breach.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-breach.admin-hub-notifications.heading":[{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance reached"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-milestone.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-milestone.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance used"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-view-usage.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.action":[{"type":0,"value":"Request upgrade"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.body":[{"type":0,"value":"Rovo Dev will be disabled for users who reach their limit. Allow more credits by requesting an upgrade to Rovo Dev Standard."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.heading":[{"type":0,"value":"Upgrade Rovo Dev users to avoid interruption"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds-mileStone-generic.admin-hub-notifications.body":[{"type":0,"value":"At least one user has reached "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of their Rovo Dev credit limit. If extra usage is enabled, extra charges will apply to use over the limit. Otherwise, Rovo Dev will be disabled for those users."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds-mileStone-generic.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of Rovo Dev credits used"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds.admin-hub-notifications.body":[{"type":0,"value":"If an extra usage limit has been set, Rovo Dev usage will be disabled for those users. Otherwise, charges will apply for extra usage."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds.admin-hub-notifications.heading":[{"type":0,"value":"Users have reached their Rovo Dev credit limit"}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.commerce-subscription-paid-trials-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.commerce-subscription-paid-trials-no-payment-method-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-no-payment-method-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.common.email.body.sent-by-atlassian-cloud.footer.org-id":[{"type":0,"value":" (ID: "},{"type":1,"value":"orgId"},{"type":0,"value":")"}],"post-office.common.email.body.sent-by-atlassian-cloud.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Administration. You are receiving this email because you are an admin for "},{"type":1,"value":"orgName"}],"post-office.et-domain-verification-missing-token.admin-hub.notification.body":[{"type":0,"value":"We\'re unable to verify that you own "},{"children":[{"type":1,"value":"domain"}],"type":8,"value":"strong"},{"type":0,"value":" due to missing tokens. Verify this domain to keep your managed accounts."}],"post-office.et-domain-verification-missing-token.admin-hub.notification.header":[{"type":0,"value":"Domain will be unverified in "},{"type":1,"value":"remainingDays"},{"type":0,"value":" days"}],"post-office.et-domain-verification-token-revoked.admin-hub.notification.body":[{"children":[{"type":1,"value":"domain"}],"type":8,"value":"strong"},{"type":0,"value":" is no longer verified. Accounts with this domain are now unmanaged. Verify the domain again to claim these accounts."}],"post-office.et-domain-verification-token-revoked.admin-hub.notification.header":[{"type":0,"value":"Domain has been unverified"}],"post-office.generic-invalid-payment.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription because of an issue with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.generic-invalid-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.generic-missing-payment.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have payment details for your subscription. To avoid your subscription being deactivated, add payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.generic-missing-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.multi-generic-invalid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions on this site "},{"type":1,"value":"siteUrl"},{"type":0,"value":" due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.multi-generic-invalid.admin-hub-notifications.heading":[{"type":0,"value":"Payment failed"}],"post-office.multi-generic-missing.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for subscriptions on this site "},{"type":1,"value":"siteUrl"},{"type":0,"value":". To avoid your subscription being deactivated, add payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.multi-generic-missing.admin-hub-notifications.heading":[{"type":0,"value":"Payment failed"}],"post-office.one-admin-left-notification.admin-hub.notification.body":[{"type":0,"value":"You\'re the only organization admin for this organization. Add another admin to avoid being locked out if you lose access."}],"post-office.one-admin-left-notification.admin-hub.notification.header":[{"type":0,"value":"Only one organization admin"}],"post-office.one-admin-left-notification.admin-hub.notification.how-to-add-admin-link":[{"type":0,"value":"How to add an admin"}],"post-office.one-admin-left-notification.notification.add-another-admin-link":[{"type":0,"value":"Add another organization admin"}],"post-office.partner-unified-xp-pvr-registrations.admin-hub-notifications.body":[{"type":0,"value":"You can view the PVR registration by clicking here"}],"post-office.partner-unified-xp-pvr-registrations.admin-hub-notifications.heading":[{"type":0,"value":"PVR registration "},{"type":1,"value":"pvrNumber"},{"type":0,"value":" submitted by "},{"type":1,"value":"submittedBy"}],"post-office.pure-dynamic-template.admin-hub.notification.body.no-translate":[{"type":1,"value":"bodyText"}],"post-office.pure-dynamic-template.admin-hub.notification.header.heading.no-translate":[{"type":1,"value":"headingText"}],"post-office.single-generic-invalid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to a problem with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.single-generic-invalid.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.single-generic-missing.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add a payment method by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.single-generic-missing.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.three-ds-payment-failure.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process your payment since we need your help to complete 3-D Secure (3DS) authentication."}],"post-office.three-ds-payment-failure.admin-hub-notifications.heading":[{"type":0,"value":"3DS payment failure"}],"post-office.townsquare-goals-request-trial.admin-hub-notifications.body":[{"type":0,"value":"Hi, I\u2019d like to try goals in the early access program. I think it can help the team save time and work better together. It\u2019s free to try if we\u2019re eligible."}],"post-office.townsquare-goals-request-trial.admin-hub-notifications.heading":[{"type":1,"value":"requesterName"},{"type":0,"value":" sent an approval request."}],"toggleLabel":[{"type":0,"value":"Only show unread"}]}');

});

parcelRegister("cvpCL", function(module, exports) {

let $91ac41b677b91249$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91ac41b677b91249$var$load("ByEi1").then(()=>parcelRequire('9ofFz'));

});

parcelRegister("3rDPF", function(module, exports) {

let $2822ca95be54516c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2822ca95be54516c$var$load("arO8g").then(()=>parcelRequire('cn7PX'));

});

parcelRegister("koyyF", function(module, exports) {

let $ed90db14bd3f2876$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ed90db14bd3f2876$var$load("krAu7").then(()=>parcelRequire('ds723'));

});

parcelRegister("fW7pK", function(module, exports) {

let $b9a20623ea3a7960$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b9a20623ea3a7960$var$load("896tF").then(()=>parcelRequire('kvf2u'));

});

parcelRegister("4SIDg", function(module, exports) {

let $38ded39af3ead857$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $38ded39af3ead857$var$load("ndT0Z").then(()=>parcelRequire('RBR5P'));

});

parcelRegister("6cdWq", function(module, exports) {

let $482ead829b36a8fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $482ead829b36a8fb$var$load("duvld").then(()=>parcelRequire('2ztIF'));

});

parcelRegister("k44G7", function(module, exports) {

let $e9b7cf6726fccd72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9b7cf6726fccd72$var$load("3LmE4").then(()=>parcelRequire('6dQkw'));

});

parcelRegister("hTIiZ", function(module, exports) {

let $d079f0d8e9683244$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d079f0d8e9683244$var$load("fULg8").then(()=>parcelRequire('erAQr'));

});

parcelRegister("7JvUo", function(module, exports) {

let $5a157cc50b12bd03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a157cc50b12bd03$var$load("7yaEe").then(()=>parcelRequire('bQo4N'));

});

parcelRegister("dRM9e", function(module, exports) {

let $a18592befb90286e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a18592befb90286e$var$load("iA0er").then(()=>parcelRequire('89du6'));

});

parcelRegister("eyA4r", function(module, exports) {

let $a990388dfc310f46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a990388dfc310f46$var$load("iuhKi").then(()=>parcelRequire('ORUsI'));

});

parcelRegister("hTjzH", function(module, exports) {

let $d066c1e2e7a94074$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d066c1e2e7a94074$var$load("5Xayi").then(()=>parcelRequire('4bLsc'));

});

parcelRegister("1JrzL", function(module, exports) {

let $142f626c5821f7c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $142f626c5821f7c2$var$load("1gOrJ").then(()=>parcelRequire('4FPWO'));

});

parcelRegister("lcJUc", function(module, exports) {

let $f6fe53d3ab199645$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f6fe53d3ab199645$var$load("geYDZ").then(()=>parcelRequire('hLHKy'));

});

parcelRegister("l1Qvs", function(module, exports) {

let $f4f26ba8114d82e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f4f26ba8114d82e6$var$load("7igYn").then(()=>parcelRequire('aMgqE'));

});

parcelRegister("97gxo", function(module, exports) {

let $6a3198808eaf8701$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a3198808eaf8701$var$load("5ylVb").then(()=>parcelRequire('2WAeu'));

});

parcelRegister("28KjQ", function(module, exports) {

let $18f042217ad09017$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18f042217ad09017$var$load("fBcZ8").then(()=>parcelRequire('1455p'));

});

parcelRegister("cPkVk", function(module, exports) {

let $956a7a78d692b12d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $956a7a78d692b12d$var$load("j5KzG").then(()=>parcelRequire('8ZA84'));

});

parcelRegister("87m4Y", function(module, exports) {

let $5e901aaa334d2d3e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e901aaa334d2d3e$var$load("3QWh9").then(()=>parcelRequire('lYD8P'));

});

parcelRegister("3LQss", function(module, exports) {

let $2bee73eef7d5603a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bee73eef7d5603a$var$load("7YxtR").then(()=>parcelRequire('OdxjC'));

});

parcelRegister("kADCg", function(module, exports) {

let $efd5e65f2a478c9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $efd5e65f2a478c9c$var$load("do3eA").then(()=>parcelRequire('cLRUX'));

});

parcelRegister("5riq8", function(module, exports) {

let $3f5dc34d22ba3f78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f5dc34d22ba3f78$var$load("2kSGK").then(()=>parcelRequire('9qZyo'));

});

parcelRegister("cagvh", function(module, exports) {

let $8db3387b70d2ecb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8db3387b70d2ecb0$var$load("7lkMO").then(()=>parcelRequire('TRyeW'));

});

parcelRegister("ksw7T", function(module, exports) {

let $ee4f57ca089dfb99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee4f57ca089dfb99$var$load("fNVfd").then(()=>parcelRequire('e6vjS'));

});

parcelRegister("ceSvC", function(module, exports) {

let $8e91132c68ddf7ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e91132c68ddf7ce$var$load("5kxTl").then(()=>parcelRequire('c4LpV'));

});

parcelRegister("apwlw", function(module, exports) {

let $7945546e34ed3aa6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7945546e34ed3aa6$var$load("irmGo").then(()=>parcelRequire('b7aco'));

});

parcelRegister("fSi2v", function(module, exports) {

let $b8e9e4669196d09a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8e9e4669196d09a$var$load("7EuV7").then(()=>parcelRequire('i9U7M'));

});

parcelRegister("F3Cke", function(module, exports) {

let $07b6a2bdb52ed5f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07b6a2bdb52ed5f6$var$load("5rAbq").then(()=>parcelRequire('jNHDp'));

});

parcelRegister("g1ihm", function(module, exports) {

let $ba9aeb24c50e6bf7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ba9aeb24c50e6bf7$var$load("idvo0").then(()=>parcelRequire('dzKqx'));

});

parcelRegister("gUFVV", function(module, exports) {

let $c502675ca41c17c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c502675ca41c17c4$var$load("9UauL").then(()=>parcelRequire('aMquS'));

});

parcelRegister("2yg4t", function(module, exports) {

let $1dbb3927948780cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1dbb3927948780cd$var$load("3Gwy9").then(()=>parcelRequire('dbCi9'));

});

parcelRegister("cOEa8", function(module, exports) {

let $95494ef9d03bc005$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95494ef9d03bc005$var$load("d9qUM").then(()=>parcelRequire('5w1DO'));

});

parcelRegister("47qkI", function(module, exports) {

let $2ffc3e17f0248d42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ffc3e17f0248d42$var$load("7m1EJ").then(()=>parcelRequire('cDCaa'));

});

parcelRegister("fjGpB", function(module, exports) {

let $b26987786bb652ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b26987786bb652ea$var$load("6UJe3").then(()=>parcelRequire('jnWwv'));

});

parcelRegister("aaA6n", function(module, exports) {
module.exports = JSON.parse('{"belugas.ax-admin-export-rovo-usage.message-template-template.email.header.logo.alt":[{"type":0,"value":"Atlassian"}],"belugas.ax-admin-export-rovo-usage.message-template.email.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Administration."}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.contact-support.button":[{"type":0,"value":"Contact support"}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.download.button":[{"type":0,"value":"Download CSV file"}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.download.intro":[{"type":0,"value":"A CSV of your organization\u2019s Rovo usage is ready to download."}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.download.intro.access":[{"type":0,"value":"Only organization admins can access this link and it expires in 24 hours."}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.download.intro.contact":[{"type":0,"value":"If you need access to more data, contact support to request a larger export."}],"belugas.ax-admin-export-rovo-usage.message-template.email.header.download.title":[{"type":0,"value":"Download usage data export"}],"belugas.ax-admin-export-rovo-usage.message-template.email.office-icon.alt":[{"type":0,"value":"Organization"}],"belugas.ax-admin-export-rovo-usage.message-template.email.subject":[{"type":0,"value":"Your user export is ready"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.cta-button":[{"type":0,"value":"Unlock all of Rovo\'s potential"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.heading":[{"type":0,"value":"You\'re almost there!"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.hero-image.description":[{"type":0,"value":"People collaborating with Rovo, showing various app integrations including Google Drive, Gmail, GitHub, Slack, and others"}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.supporting-text":[{"type":0,"value":"Rovo is nearly ready. Connect your apps to enable all the features for your organization."}],"belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.subject":[{"type":0,"value":"Reminder: Finish setting up Rovo by connecting your apps"}],"belugas.rovo-bookmarks-spotlight.action.back":[{"type":0,"value":"Back"}],"belugas.rovo-bookmarks-spotlight.action.done":[{"type":0,"value":"Done"}],"belugas.rovo-bookmarks-spotlight.action.learn-more":[{"type":0,"value":"Learn more"}],"belugas.rovo-bookmarks-spotlight.action.next":[{"type":0,"value":"Next"}],"belugas.rovo-bookmarks-spotlight.action.next-2":[{"type":0,"value":"Next"}],"belugas.rovo-bookmarks-spotlight.step-1.content":[{"type":0,"value":"Bookmarks allow you to make sure your teammates get the right result every time they search."}],"belugas.rovo-bookmarks-spotlight.step-1.heading":[{"type":0,"value":"Add bookmarks"}],"belugas.rovo-bookmarks-spotlight.step-1.page-count":[{"type":0,"value":"1 of 3"}],"belugas.rovo-bookmarks-spotlight.step-2.content":[{"type":0,"value":"Pick the terms and the result you want people to see the next time they use Rovo search."}],"belugas.rovo-bookmarks-spotlight.step-2.heading":[{"type":0,"value":"Add your first bookmark"}],"belugas.rovo-bookmarks-spotlight.step-2.page-count":[{"type":0,"value":"2 of 3"}],"belugas.rovo-bookmarks-spotlight.step-3.content":[{"type":0,"value":"Pick the terms and the result you want people to see the next time they use Rovo search."}],"belugas.rovo-bookmarks-spotlight.step-3.heading":[{"type":0,"value":"Bulk import"}],"belugas.rovo-bookmarks-spotlight.step-3.page-count":[{"type":0,"value":"3 of 3"}],"belugas.rovo-enablement-notification.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"belugas.rovo-enablement-notification.message-template.email.body.cta-button":[{"type":0,"value":"Connect my apps"}],"belugas.rovo-enablement-notification.message-template.email.body.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"belugas.rovo-enablement-notification.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"belugas.rovo-enablement-notification.message-template.email.body.heading":[{"type":0,"value":"Rovo is ready. Connect your apps today."}],"belugas.rovo-enablement-notification.message-template.email.body.hero-image.description":[{"type":0,"value":"People collaborating with Rovo, showing various app integrations including Google Drive, Gmail, GitHub, Slack, and others"}],"belugas.rovo-enablement-notification.message-template.email.body.supporting-text":[{"type":0,"value":"Power up your workspace. Set up and configure connectors to unlock all Rovo\'s potential."}],"belugas.rovo-enablement-notification.message-template.email.subject":[{"type":0,"value":"Rovo is ready for you to set up"}],"post-office.confluence-rovo-onboarding-banner.body":[{"type":0,"value":"Power up your workspace. Set up and configure connectors to unlock all Rovo\'s potential."}],"post-office.confluence-rovo-onboarding-banner.call.to.action":[{"type":0,"value":"Get started"}],"post-office.confluence-rovo-onboarding-banner.heading":[{"type":0,"value":"Rovo is ready for you"}],"post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.message":[{"type":0,"value":"We think setting up Rovo and connecting apps will improve your team\'s productivity. You\'re seeing this because Rovo is available to your team, and as an organizational admin you can extend Rovo\'s features by configuring connectors."}],"post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.reason":[{"type":0,"value":"Rovo is available to your team and you are an organizational admin"}]}');

});

parcelRegister("3BZ99", function(module, exports) {

let $2a14423b5b126632$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a14423b5b126632$var$load("gxxh0").then(()=>parcelRequire('aFaUd'));

});

parcelRegister("bWvna", function(module, exports) {

let $8b1d726cb7bfe0e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8b1d726cb7bfe0e0$var$load("Gqf1J").then(()=>parcelRequire('8MJQ1'));

});

parcelRegister("flGYB", function(module, exports) {

let $b2ca27666bf0bfad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2ca27666bf0bfad$var$load("cXezF").then(()=>parcelRequire('gBgUc'));

});

parcelRegister("5qBEv", function(module, exports) {

let $3f3c966fd021ad72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f3c966fd021ad72$var$load("eAb6e").then(()=>parcelRequire('cxr8p'));

});

parcelRegister("lIPCs", function(module, exports) {

let $fd05bf8de49857f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd05bf8de49857f6$var$load("cSx6o").then(()=>parcelRequire('4XqEl'));

});

parcelRegister("8zNf2", function(module, exports) {

let $63e7c9f3f879924a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $63e7c9f3f879924a$var$load("fYu96").then(()=>parcelRequire('1Lgsv'));

});

parcelRegister("1SRKH", function(module, exports) {

let $15f487a79349578a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $15f487a79349578a$var$load("4735t").then(()=>parcelRequire('4rrUY'));

});

parcelRegister("fFhpz", function(module, exports) {

let $b67830e4b052cd43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b67830e4b052cd43$var$load("a1SoE").then(()=>parcelRequire('ROTx3'));

});

parcelRegister("3XVjk", function(module, exports) {

let $2e3356835cbe4283$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2e3356835cbe4283$var$load("5lhOG").then(()=>parcelRequire('g89sb'));

});

parcelRegister("6p29z", function(module, exports) {

let $4a96bf7ef655e202$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a96bf7ef655e202$var$load("fmupm").then(()=>parcelRequire('8AS0l'));

});

parcelRegister("eNOc0", function(module, exports) {

let $ac6c93873752c1fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac6c93873752c1fc$var$load("rOHTq").then(()=>parcelRequire('cGINi'));

});

parcelRegister("9k5WG", function(module, exports) {

let $6c9a97f507f90987$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c9a97f507f90987$var$load("3ELnS").then(()=>parcelRequire('lkRSb'));

});

parcelRegister("7owSW", function(module, exports) {

let $562448988c7b555d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $562448988c7b555d$var$load("3xnav").then(()=>parcelRequire('foqjM'));

});

parcelRegister("l9B7C", function(module, exports) {

let $f6673bddca1713f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f6673bddca1713f6$var$load("53cJR").then(()=>parcelRequire('jKjPv'));

});

parcelRegister("iptbF", function(module, exports) {

let $d67133c63cc7cb7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d67133c63cc7cb7a$var$load("4f6tr").then(()=>parcelRequire('cy3jZ'));

});

parcelRegister("7zZbX", function(module, exports) {

let $584b44bd8443eb7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $584b44bd8443eb7d$var$load("fKSr1").then(()=>parcelRequire('1ZKWo'));

});

parcelRegister("bMnbg", function(module, exports) {

let $893628a044114544$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $893628a044114544$var$load("35Slm").then(()=>parcelRequire('2M0dT'));

});

parcelRegister("2hRtX", function(module, exports) {

let $1aa6a7bd5639702b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1aa6a7bd5639702b$var$load("aUv5J").then(()=>parcelRequire('fVQQZ'));

});

parcelRegister("6FkeT", function(module, exports) {

let $4da645841142f658$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4da645841142f658$var$load("4oWWD").then(()=>parcelRequire('4JvoA'));

});

parcelRegister("5LN1r", function(module, exports) {

let $43375e5092a71bbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $43375e5092a71bbe$var$load("g89Vi").then(()=>parcelRequire('f8Nby'));

});

parcelRegister("cFcSb", function(module, exports) {

let $93834cafba44bded$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93834cafba44bded$var$load("78Z5y").then(()=>parcelRequire('hE4ts'));

});

parcelRegister("aKNKv", function(module, exports) {

let $7d44ca60346be21b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d44ca60346be21b$var$load("kWPlg").then(()=>parcelRequire('czKHC'));

});

parcelRegister("yDHmi", function(module, exports) {

let $0681f85a3a459bde$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0681f85a3a459bde$var$load("FCrqA").then(()=>parcelRequire('fEnDd'));

});

parcelRegister("1djfm", function(module, exports) {

let $0e25ef54a4d96c8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e25ef54a4d96c8c$var$load("ekLru").then(()=>parcelRequire('52YLg'));

});

parcelRegister("eZUNS", function(module, exports) {

let $aeb2d32a67a97a56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aeb2d32a67a97a56$var$load("f11cT").then(()=>parcelRequire('bgnaX'));

});

parcelRegister("c3PIF", function(module, exports) {

let $8c7de244237de41d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8c7de244237de41d$var$load("jLw2u").then(()=>parcelRequire('4x580'));

});

parcelRegister("ihhCr", function(module, exports) {

let $d4e77b5067cc9eed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4e77b5067cc9eed$var$load("fL7z4").then(()=>parcelRequire('iNJF5'));

});

parcelRegister("aLzaO", function(module, exports) {

let $7d6993db703fc546$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d6993db703fc546$var$load("lpw0U").then(()=>parcelRequire('dkfq2'));

});

parcelRegister("5ZMR4", function(module, exports) {

let $45d88bdc66f173c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45d88bdc66f173c8$var$load("itcmL").then(()=>parcelRequire('fgyPK'));

});

parcelRegister("kI5EO", function(module, exports) {

let $f13c4e22eddb5e8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f13c4e22eddb5e8c$var$load("j09P8").then(()=>parcelRequire('a91qb'));

});

parcelRegister("4OPSI", function(module, exports) {

let $3824138688f812c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3824138688f812c6$var$load("lN71D").then(()=>parcelRequire('fZC84'));

});

parcelRegister("cFPHn", function(module, exports) {

let $93a16aa5b3c7356a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93a16aa5b3c7356a$var$load("lOM6i").then(()=>parcelRequire('f6O7L'));

});

parcelRegister("dULS7", function(module, exports) {

let $a215a3a9ed99b760$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a215a3a9ed99b760$var$load("4fr5J").then(()=>parcelRequire('84wh1'));

});

parcelRegister("g7y9j", function(module, exports) {

let $bbc7ca20058ed37d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bbc7ca20058ed37d$var$load("2sMVx").then(()=>parcelRequire('kkQnC'));

});

parcelRegister("4fHNz", function(module, exports) {
module.exports = JSON.parse("{\"aviator.service-health-dashboard.app-status-spotlight.action.back\":[{\"type\":0,\"value\":\"Back\"}],\"aviator.service-health-dashboard.app-status-spotlight.action.done\":[{\"type\":0,\"value\":\"Done\"}],\"aviator.service-health-dashboard.app-status-spotlight.action.next\":[{\"type\":0,\"value\":\"Next\"}],\"aviator.service-health-dashboard.app-status-spotlight.step-counter\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"aviator.service-health-dashboard.app-status-spotlight.step1.body\":[{\"type\":0,\"value\":\"View active incidents, maintenance events and their details.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step1.heading\":[{\"type\":0,\"value\":\"Track current events\"}],\"aviator.service-health-dashboard.app-status-spotlight.step2.body\":[{\"type\":0,\"value\":\"Search and filter past incidents and maintenance events.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step2.heading\":[{\"type\":0,\"value\":\"Browse event history\"}],\"aviator.service-health-dashboard.app-status-spotlight.step3.body\":[{\"type\":0,\"value\":\"View which app experiences across app instances are currently impacted.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step3.heading\":[{\"type\":0,\"value\":\"Check experience status\"}],\"aviator.service-health-dashboard.app-status-spotlight.step4.body\":[{\"type\":0,\"value\":\"Get an overview of how events affect your apps and their experiences.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step4.heading\":[{\"type\":0,\"value\":\"Review impact on apps\"}],\"aviator.service-health-dashboard.spotlight.action.back\":[{\"type\":0,\"value\":\"Back\"}],\"aviator.service-health-dashboard.spotlight.action.done\":[{\"type\":0,\"value\":\"Done\"}],\"aviator.service-health-dashboard.spotlight.action.next\":[{\"type\":0,\"value\":\"Next\"}],\"aviator.service-health-dashboard.spotlight.step-counter\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"aviator.service-health-dashboard.spotlight.step1.body\":[{\"type\":0,\"value\":\"View the current status and recent events for each app in your organization.\"}],\"aviator.service-health-dashboard.spotlight.step1.heading\":[{\"type\":0,\"value\":\"Dive into app status\"}],\"aviator.service-health-dashboard.spotlight.step2.body\":[{\"type\":0,\"value\":\"Stay informed about incidents and maintenance events in your organization\"}],\"aviator.service-health-dashboard.spotlight.step2.heading\":[{\"type\":0,\"value\":\"Subscribe to updates\"}]}");

});

parcelRegister("5xziy", function(module, exports) {

let $408b6a4b5407705b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $408b6a4b5407705b$var$load("3Fx8r").then(()=>parcelRequire('4Wicg'));

});

parcelRegister("18Hzf", function(module, exports) {

let $0d48556920172bad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d48556920172bad$var$load("30CDa").then(()=>parcelRequire('4qVoW'));

});

parcelRegister("9iBIA", function(module, exports) {

let $6c530d8ace69dd09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c530d8ace69dd09$var$load("b4JoO").then(()=>parcelRequire('s1fZp'));

});

parcelRegister("cfipm", function(module, exports) {

let $8ea52a3054f341c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ea52a3054f341c6$var$load("c4OQD").then(()=>parcelRequire('3C4zw'));

});

parcelRegister("fiu0J", function(module, exports) {

let $b22fd0f83eae294b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b22fd0f83eae294b$var$load("bmdh7").then(()=>parcelRequire('ar2dL'));

});

parcelRegister("dfqFh", function(module, exports) {

let $9a515c22d46f0e63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a515c22d46f0e63$var$load("hp1EB").then(()=>parcelRequire('9NSJF'));

});

parcelRegister("c2cWs", function(module, exports) {

let $8c2fb5e9c612de11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8c2fb5e9c612de11$var$load("5hHbC").then(()=>parcelRequire('9g28B'));

});

parcelRegister("d52Hd", function(module, exports) {

let $985dd5590c4687c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $985dd5590c4687c0$var$load("ll5SJ").then(()=>parcelRequire('5qx9l'));

});

parcelRegister("lgF96", function(module, exports) {

let $f7bb0249e2f5cf7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7bb0249e2f5cf7a$var$load("dill7").then(()=>parcelRequire('8y6vE'));

});

parcelRegister("jw1FE", function(module, exports) {

let $e3524d401e0fb6e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3524d401e0fb6e0$var$load("2lDIU").then(()=>parcelRequire('iOUYl'));

});

parcelRegister("4JELE", function(module, exports) {

let $372afcfdce213963$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $372afcfdce213963$var$load("dNtEl").then(()=>parcelRequire('7fmHm'));

});

parcelRegister("1kxJj", function(module, exports) {

let $0f81d2bba09b1743$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f81d2bba09b1743$var$load("89jFN").then(()=>parcelRequire('KXepW'));

});

parcelRegister("l6zVa", function(module, exports) {

let $f5d605b1fcfcbf6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5d605b1fcfcbf6a$var$load("9qV1K").then(()=>parcelRequire('i13hK'));

});

parcelRegister("dWyoI", function(module, exports) {

let $a26b5fcdd22fd1e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a26b5fcdd22fd1e2$var$load("kpegJ").then(()=>parcelRequire('ib8dg'));

});

parcelRegister("fvKND", function(module, exports) {

let $b4ae0dacc8474840$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b4ae0dacc8474840$var$load("7wmvv").then(()=>parcelRequire('emwl6'));

});

parcelRegister("dcjOX", function(module, exports) {

let $99bbc55fdd7c2c9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99bbc55fdd7c2c9a$var$load("6xzuO").then(()=>parcelRequire('22BDf'));

});

parcelRegister("aPCcp", function(module, exports) {

let $7e2c4c56f86f6641$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e2c4c56f86f6641$var$load("8jfca").then(()=>parcelRequire('fsyCB'));

});

parcelRegister("2uSwL", function(module, exports) {

let $1d18ae2188c0693f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d18ae2188c0693f$var$load("iNE7h").then(()=>parcelRequire('4KANE'));

});

parcelRegister("68cCD", function(module, exports) {

let $476d47e901aa3867$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $476d47e901aa3867$var$load("jaZmb").then(()=>parcelRequire('bgzaf'));

});

parcelRegister("jppvA", function(module, exports) {

let $e214238f5ca1685f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e214238f5ca1685f$var$load("j2uPS").then(()=>parcelRequire('25Eg8'));

});

parcelRegister("jybJb", function(module, exports) {

let $e3ba4a29b65a716c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3ba4a29b65a716c$var$load("4n27m").then(()=>parcelRequire('l00zl'));

});

parcelRegister("j64Xe", function(module, exports) {

let $de726bae3e751f8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de726bae3e751f8e$var$load("helCZ").then(()=>parcelRequire('e7ADb'));

});

parcelRegister("bxqIw", function(module, exports) {

let $866780387beb4e79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $866780387beb4e79$var$load("e7mQF").then(()=>parcelRequire('ipk6e'));

});

parcelRegister("hSedA", function(module, exports) {

let $d03282415f59293e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d03282415f59293e$var$load("i16FG").then(()=>parcelRequire('bDQKU'));

});

parcelRegister("9uHPr", function(module, exports) {

let $6e98e9dab09f10b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6e98e9dab09f10b3$var$load("WaqHy").then(()=>parcelRequire('b3TxH'));

});

parcelRegister("hSWH0", function(module, exports) {

let $d05501edd7d57db4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d05501edd7d57db4$var$load("huM5o").then(()=>parcelRequire('rgKsh'));

});

parcelRegister("1sSzi", function(module, exports) {

let $1112bc19cc690f99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1112bc19cc690f99$var$load("3YYKV").then(()=>parcelRequire('i7mfj'));

});

parcelRegister("8qXgQ", function(module, exports) {

let $623eba5a05ffe806$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $623eba5a05ffe806$var$load("F3IBz").then(()=>parcelRequire('13Yam'));

});

parcelRegister("4Lajz", function(module, exports) {

let $37738d79063b62e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $37738d79063b62e5$var$load("jcBW6").then(()=>parcelRequire('jeNOC'));

});

parcelRegister("eNPlV", function(module, exports) {

let $ac6d79d92c6f5ef3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac6d79d92c6f5ef3$var$load("1urgJ").then(()=>parcelRequire('aYP8e'));

});

parcelRegister("e9vFn", function(module, exports) {

let $a4da783c483e44e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4da783c483e44e5$var$load("fIp73").then(()=>parcelRequire('6Gnvm'));

});

parcelRegister("jq4oY", function(module, exports) {

let $e233dc233123e046$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e233dc233123e046$var$load("8CyYA").then(()=>parcelRequire('3IREa'));

});

parcelRegister("2awYG", function(module, exports) {

let $1946189d98305b04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1946189d98305b04$var$load("3Cg2d").then(()=>parcelRequire('eFxC0'));

});

parcelRegister("aaQMD", function(module, exports) {

let $7683c8406d8d1ddf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7683c8406d8d1ddf$var$load("cOLF5").then(()=>parcelRequire('9WSle'));

});

parcelRegister("hT7EH", function(module, exports) {
module.exports = JSON.parse('{"assets-deeplinking-modal.closeButton":[{"type":0,"value":"Close"}],"assets-deeplinking-modal.description1":[{"type":0,"value":"You can now click directly on data points in your charts to drill in and see the underlying records. For example, if you select a bar in the \u201CTicket volume\u201D chart, we\u2019ll open a detailed view showing the actual tickets that make up that data point."}],"assets-deeplinking-modal.description2":[{"type":0,"value":"This lets you move from high-level trends to the raw sources behind them in just one click."}],"assets-deeplinking-modal.doneButton":[{"type":0,"value":"Done"}],"assets-deeplinking-modal.heading":[{"type":0,"value":"See the data behind your charts"}]}');

});

parcelRegister("1jabv", function(module, exports) {

let $0f3f7738b6fa2622$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f3f7738b6fa2622$var$load("97CII").then(()=>parcelRequire('jTAPr'));

});

parcelRegister("7mov1", function(module, exports) {

let $55bd9787bfce0bfe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55bd9787bfce0bfe$var$load("2pjj2").then(()=>parcelRequire('bOit3'));

});

parcelRegister("8uoVC", function(module, exports) {

let $62e4764e95683fcd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $62e4764e95683fcd$var$load("iWDon").then(()=>parcelRequire('fHQcI'));

});

parcelRegister("gz6uF", function(module, exports) {

let $c0f4f3bfc7352d8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c0f4f3bfc7352d8f$var$load("3hUmR").then(()=>parcelRequire('1bBQ9'));

});

parcelRegister("1GoYT", function(module, exports) {

let $139d17688099325d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $139d17688099325d$var$load("5Ovgj").then(()=>parcelRequire('aYG6B'));

});

parcelRegister("eQ8Zl", function(module, exports) {

let $acdce4efed312140$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $acdce4efed312140$var$load("4EUZj").then(()=>parcelRequire('g5hXJ'));

});

parcelRegister("ikHh6", function(module, exports) {

let $d58ba9bae2ae0aaf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d58ba9bae2ae0aaf$var$load("k8c56").then(()=>parcelRequire('23Fr1'));

});

parcelRegister("2GiBV", function(module, exports) {

let $1f3df0b467fae1cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f3df0b467fae1cf$var$load("9Lp9b").then(()=>parcelRequire('4v2CC'));

});

parcelRegister("iyWwK", function(module, exports) {

let $d838cd43112a7497$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d838cd43112a7497$var$load("8AD3W").then(()=>parcelRequire('3lz93'));

});

parcelRegister("hDhdt", function(module, exports) {

let $cd636efdff534895$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd636efdff534895$var$load("9Ainn").then(()=>parcelRequire('cdOQH'));

});

parcelRegister("8aVea", function(module, exports) {

let $5f3ba61414705036$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f3ba61414705036$var$load("6iAvF").then(()=>parcelRequire('5pUgL'));

});

parcelRegister("kEfSb", function(module, exports) {

let $f083db1541c9fc22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f083db1541c9fc22$var$load("eGqqE").then(()=>parcelRequire('hV6ou'));

});

parcelRegister("gJAAM", function(module, exports) {

let $c2ed3bbd775d6f82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2ed3bbd775d6f82$var$load("bxgJo").then(()=>parcelRequire('i3Fbx'));

});

parcelRegister("5S4RM", function(module, exports) {

let $4465c53eb89edb1b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4465c53eb89edb1b$var$load("h2UMk").then(()=>parcelRequire('37xMu'));

});

parcelRegister("4p85t", function(module, exports) {

let $334fc52ad9b1fcc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $334fc52ad9b1fcc4$var$load("asgYr").then(()=>parcelRequire('1eMze'));

});

parcelRegister("1wmq7", function(module, exports) {

let $11ba2bcf4d02b7cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11ba2bcf4d02b7cc$var$load("dUa5b").then(()=>parcelRequire('em9d4'));

});

parcelRegister("bdz3k", function(module, exports) {

let $82ac195098707287$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82ac195098707287$var$load("eQhyd").then(()=>parcelRequire('8XOvQ'));

});

parcelRegister("cPixi", function(module, exports) {

let $9568a056449f1511$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9568a056449f1511$var$load("7Ofoo").then(()=>parcelRequire('cUbli'));

});

parcelRegister("cINh8", function(module, exports) {

let $942fd12d1e9935be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $942fd12d1e9935be$var$load("bE0lK").then(()=>parcelRequire('4uIIF'));

});

parcelRegister("hgFsW", function(module, exports) {

let $c9241884c7a8f1fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9241884c7a8f1fc$var$load("1G5Ox").then(()=>parcelRequire('fR5Aw'));

});

parcelRegister("9E73q", function(module, exports) {

let $705d525319c210da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $705d525319c210da$var$load("hla6z").then(()=>parcelRequire('avvnm'));

});

parcelRegister("krMf2", function(module, exports) {

let $ee2bc006d4b3a330$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee2bc006d4b3a330$var$load("7QfJH").then(()=>parcelRequire('3V1uD'));

});

parcelRegister("j7xZf", function(module, exports) {

let $deb908d97715d193$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $deb908d97715d193$var$load("ewRoj").then(()=>parcelRequire('hZanH'));

});

parcelRegister("jL6am", function(module, exports) {

let $e62730956fd3464c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e62730956fd3464c$var$load("dlFqv").then(()=>parcelRequire('8NPga'));

});

parcelRegister("738nS", function(module, exports) {

let $521f511fe71c4af8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $521f511fe71c4af8$var$load("4xSpq").then(()=>parcelRequire('e1x9K'));

});

parcelRegister("7EYyR", function(module, exports) {

let $593b3f0c83051638$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $593b3f0c83051638$var$load("biUaV").then(()=>parcelRequire('bIPEw'));

});

parcelRegister("9dQw1", function(module, exports) {

let $6b6e1072fd10f5ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b6e1072fd10f5ad$var$load("5cyUL").then(()=>parcelRequire('dusFT'));

});

parcelRegister("lvh45", function(module, exports) {

let $fa79baf94c64e2e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa79baf94c64e2e2$var$load("7L619").then(()=>parcelRequire('8e2C0'));

});

parcelRegister("31dUW", function(module, exports) {

let $232c42d352b4f2a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $232c42d352b4f2a9$var$load("3yJZR").then(()=>parcelRequire('dmJ3q'));

});

parcelRegister("bkyZM", function(module, exports) {

let $83fcb5504b9261cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83fcb5504b9261cb$var$load("232k1").then(()=>parcelRequire('32aTd'));

});

parcelRegister("aSroz", function(module, exports) {

let $7eb432af92083b66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7eb432af92083b66$var$load("bCuxk").then(()=>parcelRequire('dHBVr'));

});

parcelRegister("3JFOi", function(module, exports) {

let $2b8601af8ef577db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b8601af8ef577db$var$load("fB0nU").then(()=>parcelRequire('ky3bO'));

});

parcelRegister("k82YV", function(module, exports) {

let $ea76de176cd5decd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ea76de176cd5decd$var$load("1qiQ2").then(()=>parcelRequire('fjlif'));

});

parcelRegister("7MpBv", function(module, exports) {

let $5aa0e07be8561475$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5aa0e07be8561475$var$load("lj90c").then(()=>parcelRequire('gNhzV'));

});

parcelRegister("2Cirw", function(module, exports) {
module.exports = JSON.parse("{\"jsm-gs.cases.spotlight.step1.body.non-final\":[{\"type\":0,\"value\":\"Streamline how your team documents findings and outcomes with a dedicated \"},{\"children\":[{\"type\":0,\"value\":\"Case notes\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" section within work items.\"}],\"jsm-gs.cases.spotlight.step1.next.non-final\":[{\"type\":0,\"value\":\"Next\"}],\"jsm-gs.cases.spotlight.step1.step-count.non-final\":[{\"type\":0,\"value\":\"1 of 3\"}],\"jsm-gs.cases.spotlight.step1.title.non-final\":[{\"type\":0,\"value\":\"Better manage your case load\"}],\"jsm-gs.cases.spotlight.step2.back.non-final\":[{\"type\":0,\"value\":\"Back\"}],\"jsm-gs.cases.spotlight.step2.body.non-final\":[{\"type\":0,\"value\":\"To enable \"},{\"children\":[{\"type\":0,\"value\":\"Case notes\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" on work items, simply create or assign existing request types to this work category.\"}],\"jsm-gs.cases.spotlight.step2.next.non-final\":[{\"type\":0,\"value\":\"Next\"}],\"jsm-gs.cases.spotlight.step2.step-count.non-final\":[{\"type\":0,\"value\":\"2 of 3\"}],\"jsm-gs.cases.spotlight.step2.title.non-final\":[{\"type\":0,\"value\":\"Create or assign existing types\"}],\"jsm-gs.cases.spotlight.step3.back.non-final\":[{\"type\":0,\"value\":\"Back\"}],\"jsm-gs.cases.spotlight.step3.body.non-final\":[{\"type\":0,\"value\":\"Lock down sensitive \"},{\"children\":[{\"type\":0,\"value\":\"Cases\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" with work item security so only those with access can view case information.\"}],\"jsm-gs.cases.spotlight.step3.done.non-final\":[{\"type\":0,\"value\":\"Done\"}],\"jsm-gs.cases.spotlight.step3.step-count.non-final\":[{\"type\":0,\"value\":\"3 of 3\"}],\"jsm-gs.cases.spotlight.step3.title.non-final\":[{\"type\":0,\"value\":\"Restrict access to specific people\"}]}");

});

parcelRegister("eGMaw", function(module, exports) {

let $ab1a5a359f98419b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab1a5a359f98419b$var$load("9ATeW").then(()=>parcelRequire('40EkB'));

});

parcelRegister("kFAf3", function(module, exports) {

let $f0c3bfdb99b0ee62$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0c3bfdb99b0ee62$var$load("ds8tN").then(()=>parcelRequire('fpF4q'));

});

parcelRegister("5vL4N", function(module, exports) {

let $40345d6643f68b3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40345d6643f68b3c$var$load("lgBhD").then(()=>parcelRequire('1lRMq'));

});

parcelRegister("br3Zc", function(module, exports) {

let $85354edcc08f0f86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85354edcc08f0f86$var$load("4m7XX").then(()=>parcelRequire('acI4Y'));

});

parcelRegister("gvITV", function(module, exports) {

let $c0525efb55eee700$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c0525efb55eee700$var$load("2ZdsR").then(()=>parcelRequire('7gAo7'));

});

parcelRegister("glRb3", function(module, exports) {

let $be77db68557dff71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be77db68557dff71$var$load("k1wdL").then(()=>parcelRequire('jgT01'));

});

parcelRegister("6lsG6", function(module, exports) {

let $49eaf319e72bff89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49eaf319e72bff89$var$load("li5n8").then(()=>parcelRequire('7JUjn'));

});

parcelRegister("6hJXo", function(module, exports) {

let $4937faaffb7229ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4937faaffb7229ab$var$load("dHaLQ").then(()=>parcelRequire('dHxI5'));

});

parcelRegister("dj23V", function(module, exports) {

let $9afea637877b71d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9afea637877b71d9$var$load("8fmVM").then(()=>parcelRequire('Mu6ON'));

});

parcelRegister("1bBKq", function(module, exports) {

let $0dd41972eb3a3683$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0dd41972eb3a3683$var$load("5F8UF").then(()=>parcelRequire('9RVOd'));

});

parcelRegister("e4mSG", function(module, exports) {

let $a3e330148aaed3d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a3e330148aaed3d4$var$load("lJoax").then(()=>parcelRequire('eDP81'));

});

parcelRegister("36Mfu", function(module, exports) {

let $24375bd99078994f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24375bd99078994f$var$load("6J85j").then(()=>parcelRequire('dnXtl'));

});

parcelRegister("hcQ82", function(module, exports) {

let $c86bfe4dd2404883$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c86bfe4dd2404883$var$load("sgi41").then(()=>parcelRequire('a0uLK'));

});

parcelRegister("6iZLw", function(module, exports) {

let $497455d5a9661601$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $497455d5a9661601$var$load("3nrLy").then(()=>parcelRequire('jcxiT'));

});

parcelRegister("erHpn", function(module, exports) {

let $a84542451ed15d46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a84542451ed15d46$var$load("jSliW").then(()=>parcelRequire('2hJbF'));

});

parcelRegister("fdQsb", function(module, exports) {

let $b150c2145de57b07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b150c2145de57b07$var$load("auWqe").then(()=>parcelRequire('86IsJ'));

});

parcelRegister("8wptm", function(module, exports) {

let $6345123c071f9193$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6345123c071f9193$var$load("hxCWN").then(()=>parcelRequire('apuJ3'));

});

parcelRegister("gR2mu", function(module, exports) {

let $c4536d986b1c4a0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4536d986b1c4a0d$var$load("hqAiV").then(()=>parcelRequire('7a4LP'));

});

parcelRegister("QOrlE", function(module, exports) {

let $09ebfbcbe94ae7df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09ebfbcbe94ae7df$var$load("pMa2o").then(()=>parcelRequire('dvWGj'));

});

parcelRegister("69mtF", function(module, exports) {

let $47a504eb3935c53f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $47a504eb3935c53f$var$load("7ltQQ").then(()=>parcelRequire('e9J3d'));

});

parcelRegister("ttQQt", function(module, exports) {

let $0589dd6743c0da4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0589dd6743c0da4f$var$load("8Gltl").then(()=>parcelRequire('1ALHG'));

});

parcelRegister("1KReV", function(module, exports) {

let $14736299e0d8c900$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $14736299e0d8c900$var$load("aKpei").then(()=>parcelRequire('8owYA'));

});

parcelRegister("8XtxY", function(module, exports) {

let $685ac0d7e0f8c53c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $685ac0d7e0f8c53c$var$load("in0Z0").then(()=>parcelRequire('5LcK9'));

});

parcelRegister("clVOb", function(module, exports) {

let $8fe449c27a75e3cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8fe449c27a75e3cd$var$load("k84yj").then(()=>parcelRequire('crtQE'));

});

parcelRegister("h0bQ4", function(module, exports) {

let $c60b9eb4135a8f25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c60b9eb4135a8f25$var$load("15X9D").then(()=>parcelRequire('2K9np'));

});

parcelRegister("2QxUV", function(module, exports) {

let $212abf55f359e984$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $212abf55f359e984$var$load("aeMdg").then(()=>parcelRequire('9VeyM'));

});

parcelRegister("fw3gu", function(module, exports) {

let $b4bc608bd1fd872a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b4bc608bd1fd872a$var$load("9ouni").then(()=>parcelRequire('8n6KQ'));

});

parcelRegister("fEd1a", function(module, exports) {

let $b644b07caf0b3eba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b644b07caf0b3eba$var$load("dH34H").then(()=>parcelRequire('3p1jw'));

});

parcelRegister("aIa2C", function(module, exports) {

let $7cc5cd6f76264d58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7cc5cd6f76264d58$var$load("8VEtY").then(()=>parcelRequire('gSxiJ'));

});

parcelRegister("a1qBH", function(module, exports) {

let $74bea2f8de9d9ed1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74bea2f8de9d9ed1$var$load("hPqwY").then(()=>parcelRequire('eJst2'));

});

parcelRegister("lyaP6", function(module, exports) {

let $fb052b350d2080c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb052b350d2080c2$var$load("b7m0B").then(()=>parcelRequire('fnGxA'));

});

parcelRegister("6MzGD", function(module, exports) {

let $4f02e86a9909f9e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f02e86a9909f9e2$var$load("h1mKI").then(()=>parcelRequire('cgGw2'));

});

parcelRegister("iiltI", function(module, exports) {

let $d51a918f47e6caa8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d51a918f47e6caa8$var$load("DcwkM").then(()=>parcelRequire('i0Q7A'));

});

parcelRegister("bleeZ", function(module, exports) {

let $841cb3c5ec980ee7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $841cb3c5ec980ee7$var$load("1StPi").then(()=>parcelRequire('ixgLv'));

});

parcelRegister("kf5a8", function(module, exports) {
module.exports = JSON.parse("{\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-description\":[{\"type\":0,\"value\":\"Blocks of content can now be easily transformed, kept in sync, and saved as a template!\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-header\":[{\"type\":0,\"value\":\"Transform, sync & save blocks\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-image-alt\":[{\"type\":0,\"value\":\"Blocks feature illustration\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-description\":[{\"type\":0,\"value\":\"Blocks of content can now be easily transformed, kept in sync, and saved as a template!\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-header\":[{\"type\":0,\"value\":\"Transform, sync & save blocks\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-image-alt\":[{\"type\":0,\"value\":\"Blocks feature illustration\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-description\":[{\"type\":0,\"value\":\"Save any content as a block template for easy reuse across Confluence and Jira!\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-header\":[{\"type\":0,\"value\":\"Save content with block templates\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-image-alt\":[{\"type\":0,\"value\":\"Block templates feature illustration\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-description\":[{\"type\":0,\"value\":\"Easily change content blocks from one format to another!\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-header-new\":[{\"type\":0,\"value\":\"Quickly change format\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-image-alt-new\":[{\"type\":0,\"value\":\"Format feature illustration\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-description\":[{\"type\":0,\"value\":\"Synced blocks maintain source of truth across Confluence & Jira. Insert, copy, and paste!\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-header\":[{\"type\":0,\"value\":\"Keep content in sync\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-image-alt\":[{\"type\":0,\"value\":\"Synced blocks feature illustration\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-button\":[{\"type\":0,\"value\":\"Got it\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-description\":[{\"type\":0,\"value\":\"Controls to add or delete rows and columns have moved to their own menus. You can also align content vertically from the cell menu.\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-header\":[{\"type\":0,\"value\":\"Simple table controls\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-image-alt\":[{\"type\":0,\"value\":\"Table cell menu illustration\"}]}");

});

parcelRegister("k0hHz", function(module, exports) {

let $e90189e9833cc310$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e90189e9833cc310$var$load("lgp9T").then(()=>parcelRequire('016Ws'));

});

parcelRegister("iszcR", function(module, exports) {

let $d70626c686fe9746$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d70626c686fe9746$var$load("7pBer").then(()=>parcelRequire('zBeRG'));

});

parcelRegister("5Or4T", function(module, exports) {

let $43b6a05aa34ff1f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $43b6a05aa34ff1f8$var$load("iWLj2").then(()=>parcelRequire('jFgfB'));

});

parcelRegister("kgmEP", function(module, exports) {

let $ec06e090bd4a6c04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec06e090bd4a6c04$var$load("et8Wy").then(()=>parcelRequire('4CfaD'));

});

parcelRegister("enblM", function(module, exports) {

let $a76c049963b836de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a76c049963b836de$var$load("bS3Zu").then(()=>parcelRequire('2cqJv'));

});

parcelRegister("dOAsv", function(module, exports) {

let $a0ec39d17d392c51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0ec39d17d392c51$var$load("3QUQc").then(()=>parcelRequire('juWRh'));

});

parcelRegister("2DvGy", function(module, exports) {

let $1eb7cd5448213d2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1eb7cd5448213d2b$var$load("9dy4p").then(()=>parcelRequire('1WkGA'));

});

parcelRegister("7A6dp", function(module, exports) {

let $5850b771a8013868$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5850b771a8013868$var$load("3Thyr").then(()=>parcelRequire('4FPYx'));

});

parcelRegister("cI4O0", function(module, exports) {

let $940d525e2bbe0fec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $940d525e2bbe0fec$var$load("2Vl3i").then(()=>parcelRequire('iIJTv'));

});

parcelRegister("6QVjH", function(module, exports) {

let $4fd40f4cec37dad9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4fd40f4cec37dad9$var$load("cBpg6").then(()=>parcelRequire('efiKI'));

});

parcelRegister("1Z7QE", function(module, exports) {

let $172193764bb8d840$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $172193764bb8d840$var$load("5NfIb").then(()=>parcelRequire('8sUu2'));

});

parcelRegister("l8KD4", function(module, exports) {

let $f63e83edf5da292b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f63e83edf5da292b$var$load("dGVOm").then(()=>parcelRequire('cpVwe'));

});

parcelRegister("ddnGe", function(module, exports) {

let $99eedba391e92d95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99eedba391e92d95$var$load("fIyRy").then(()=>parcelRequire('g9bVp'));

});

parcelRegister("6U0oD", function(module, exports) {

let $506847ba548558a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $506847ba548558a3$var$load("dC7Un").then(()=>parcelRequire('keiHS'));

});

parcelRegister("6zdfY", function(module, exports) {

let $4c804b702801098b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c804b702801098b$var$load("dAhI4").then(()=>parcelRequire('7HLXm'));

});

parcelRegister("eZjit", function(module, exports) {

let $ae95bb30564a6ce5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae95bb30564a6ce5$var$load("0pP19").then(()=>parcelRequire('6eaz1'));

});

parcelRegister("lK1xg", function(module, exports) {

let $fd3f15cb50833600$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd3f15cb50833600$var$load("eZeN7").then(()=>parcelRequire('2lzAs'));

});

parcelRegister("iEkDX", function(module, exports) {

let $d93bf9ccb5cf23bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d93bf9ccb5cf23bc$var$load("bRh26").then(()=>parcelRequire('isKBI'));

});

parcelRegister("wZgFM", function(module, exports) {

let $063283ce4ea75508$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $063283ce4ea75508$var$load("gDikm").then(()=>parcelRequire('cmNhG'));

});

parcelRegister("dR7EO", function(module, exports) {

let $a1662a28ad65ba8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a1662a28ad65ba8b$var$load("gPkUo").then(()=>parcelRequire('f7azd'));

});

parcelRegister("1mq27", function(module, exports) {

let $0fdc0a2bb7b51848$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0fdc0a2bb7b51848$var$load("7yfD0").then(()=>parcelRequire('fp0R0'));

});

parcelRegister("k6ih1", function(module, exports) {

let $ea228aebebfded22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ea228aebebfded22$var$load("ho21c").then(()=>parcelRequire('dUPXz'));

});

parcelRegister("2nwWB", function(module, exports) {

let $1bb748c8a0f20df6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1bb748c8a0f20df6$var$load("7A1Y5").then(()=>parcelRequire('iaUkF'));

});

parcelRegister("2p5QR", function(module, exports) {

let $1c02748fa8c5049b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c02748fa8c5049b$var$load("bSAMT").then(()=>parcelRequire('8902j'));

});

parcelRegister("8HI7p", function(module, exports) {

let $65648fe8ce2ab638$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65648fe8ce2ab638$var$load("fwCMn").then(()=>parcelRequire('27Sjl'));

});

parcelRegister("v1VfJ", function(module, exports) {

let $05d4631e9a88fd04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05d4631e9a88fd04$var$load("1q7Jw").then(()=>parcelRequire('fcjMY'));

});

parcelRegister("eCARq", function(module, exports) {

let $aa51350efafdce47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa51350efafdce47$var$load("jXO7V").then(()=>parcelRequire('4YV2o'));

});

parcelRegister("j8LSv", function(module, exports) {

let $def3e741388a782f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $def3e741388a782f$var$load("bkEnH").then(()=>parcelRequire('dXl2n'));

});

parcelRegister("1bpCj", function(module, exports) {

let $0dcab07ec160f444$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0dcab07ec160f444$var$load("alhnD").then(()=>parcelRequire('6p9ae'));

});

parcelRegister("7fpPm", function(module, exports) {

let $546df7e9999252e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $546df7e9999252e9$var$load("lkuZf").then(()=>parcelRequire('70d4H'));

});

parcelRegister("dPdg3", function(module, exports) {

let $a10a528b38c91759$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a10a528b38c91759$var$load("5rYUl").then(()=>parcelRequire('7FLlj'));

});

parcelRegister("le2JO", function(module, exports) {

let $f73d077b47f90c22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f73d077b47f90c22$var$load("1Soc1").then(()=>parcelRequire('eSK6i'));

});

parcelRegister("7W1zC", function(module, exports) {

let $5c6f2ba91ebee1ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5c6f2ba91ebee1ab$var$load("9INRO").then(()=>parcelRequire('cQoRY'));

});

parcelRegister("7RgIB", function(module, exports) {

let $5b8a738f0d40bd14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5b8a738f0d40bd14$var$load("5cGtw").then(()=>parcelRequire('kNA0P'));

});

parcelRegister("e77Av", function(module, exports) {
module.exports = JSON.parse('{"ccommerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-dispute":[{"type":0,"value":"Action required: ACH Direct debit payment failed"}],"commerce-access-invalid-payment-ccp.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-access-invalid-payment-hams.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch":[{"type":0,"value":"To understand more on why we couldn\'t generate your invoice, please "},{"type":1,"value":"getInTouchLink"},{"type":0,"value":" with us."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch-link":[{"type":0,"value":"get in touch"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.no-invoice-generation":[{"type":0,"value":"We couldn\'t generate an invoice for your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") as we don\'t have\\n\\t\\t\\t\\tyour complete billing information. As a result, your subscription has been canceled."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-1":[{"type":0,"value":"Once you\u2019ve updated the billing details, reactivate your subscription by going to "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-5":[{"type":0,"value":". If you reactivate your subscription within 60 days of cancellation, your data and preferences will remain the same."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-partner-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.wrong-details":[{"type":0,"value":"It could be because you\u2019ve entered the wrong details, or that the information you\u2019ve provided us is\\n\\t\\t\\t\\tincomplete. Don\'t worry, you can reactivate your subscription after updating your billing information."}],"commerce-credit-account-deactivation-ccp.clear-unpaid-invoices":[{"type":0,"value":"Clear any unpaid invoices associated with your account."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.help-message":[{"type":0,"value":"We understand that managing payments can sometimes be challenging, and we\'re here to help."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.learn-reasons":[{"type":0,"value":"Learn about possible reasons"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.message":[{"type":0,"value":"You can no longer use Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms to place your orders as your billing account\u2019s eligibility has been suspended. "},{"type":1,"value":"learnReason"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.title":[{"type":0,"value":"You\u2019re no longer eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" terms"}],"commerce-credit-account-deactivation-ccp.reach-out":[{"type":0,"value":"Reach out to us so we can review your eligibility."}],"commerce-credit-account-deactivation-ccp.reconsider-eligibility":[{"type":0,"value":"If you\u2019d like us to reconsider your eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms, we suggest you to:"}],"commerce-credit-account-deactivation-ccp.view-unpaid-invoices-link":[{"type":0,"value":"View unpaid invoices"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.couldn\'t-approve-request":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your request because you\u2019ve reached the maximum credit limit that we can offer at this time. You can check back in a few months to see if your eligibility has changed."}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Unable to offer a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.rejected.title":[{"type":0,"value":"We\u2019re unable to offer you a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.thank-you.submitting":[{"type":0,"value":"Thank you for submitting your application for increasing your Atlassian Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit."}],"commerce-credit-account-limit-increase-request-rejection-ccp.move-forward":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce-credit-account-reactivation-ccp.message-template.good-news.restored.billing.account":[{"type":0,"value":"Good news! We\u2019ve restored your billing account\u2019s eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details:"}],"commerce-credit-account-reactivation-ccp.message-template.restored.title":[{"type":0,"value":"Your eligibility has been restored"}],"commerce-invoice-generated-ccp-g.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp-g.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-generated-ccp.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-terms-payment-pending-ccp.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-updated-ccp-g.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp-g.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-invoice-updated-ccp.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.message.entity.link.label":[{"type":0,"value":"Atlassian Administration"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.body.multiple":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlementProductName"},{"type":0,"value":" purchase."}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.title.different.trial.lengths.multiple":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" free"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.title.multiple":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"}],"commerce-marketing-multiple-product-upgrade-ccp-single.message.entity.link.label":[{"type":0,"value":"Atlassian Administration"}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.message.title.single":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.confluence.message.body.single":[{"type":0,"value":"Tired of hunting for the right doc? Build a single source of truth for your team\'s info with Confluence "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jira.message.body.single":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. Try the "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" plan free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jpd.message.body.single":[{"type":0,"value":"Say goodbye to messy backlogs. Keep your brilliant ideas in one place with Jira Product Discovery "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jsm.message.body.single":[{"type":0,"value":"Bring developers, IT, and ops on the same tool and make work visible across teams with the "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" plan. Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp.subtext":[{"type":0,"value":"Atlassian Administration"}],"commerce-on-account-approval-partner.email.attached-instructions":[{"type":0,"value":"We\'ve attached instructions outlining how to read your statement."}],"commerce-on-account-approval-partner.email.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Pay on account with terms of Net-\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from statement date."}],"commerce-on-account-approval-partner.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-approval-partner.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-approval-partner.email.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce-on-account-approval-partner.email.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the statement date"}],"commerce-on-account-approval-partner.email.statement-info":[{"type":0,"value":"As Pay on account Partner, you will now receive a statement twice a month (on the 1st and 16th) covering\\n\\t\\t\\t\\tinvoices for the periods 16th to last day and 1st to 15th respectively."}],"commerce-on-account-approval-partner.email.subject":[{"type":0,"value":"Your Pay on account request is approved"}],"commerce-on-account-approval-partner.email.title":[{"type":0,"value":"Your Pay on account request has been approved"}],"commerce-on-account-deactivation-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-deactivation-partner-ccp.email.apply-again":[{"type":0,"value":"You may apply again for Pay on account option after 6 months. Don\u2019t worry, you can still place new orders using a credit card. "}],"commerce-on-account-deactivation-partner-ccp.email.contact-us":[{"type":0,"value":"Should you have questions or wish to discuss ways to reactivate your pay on account option, please contact us at "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-deactivation-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-deactivation-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-deactivation-partner-ccp.email.on-account-being-deactivated":[{"type":0,"value":"Your Pay on account option with Atlassian is being deactivated effective immediately, due to overdue balances and failure to meet the agreed payment terms. "}],"commerce-on-account-deactivation-partner-ccp.email.reach-us":[{"type":0,"value":"You can reach out to us if you need further help in placing your order."}],"commerce-on-account-deactivation-partner-ccp.email.subject":[{"type":0,"value":"Pay on account deactivation notice"}],"commerce-on-account-deactivation-partner-ccp.email.title":[{"type":0,"value":"Pay on account is deactivated"}],"commerce-on-account-rejection-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.apply-again":[{"type":0,"value":"You can resubmit your application after 6 months to be considered again.  "}],"commerce-on-account-rejection-partner-ccp.email.contact-us":[{"type":0,"value":"You can still go ahead with your purchase. We suggest using a credit card to pay for your order. If you still need help placing an order contact us at  "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-rejection-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-rejection-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-rejection-partner-ccp.email.on-account-application-rejected":[{"type":0,"value":"Thank you for submitting your application for Pay on account. Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements. "}],"commerce-on-account-rejection-partner-ccp.email.sales-op-support.no-translate":[{"type":0,"value":"sales-ops-support@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.subject":[{"type":0,"value":"Pay on account application rejection notice"}],"commerce-on-account-rejection-partner-ccp.email.title":[{"type":0,"value":"We\u2019re unable to approve your Pay on account request"}],"commerce-payment-failure-ccp.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"FAQ"}],"commerce-payment-failure-hams.email.not-trial.without-cc.add-payment-details":[{"type":0,"value":"We noticed you haven\'t added payment details for "},{"type":1,"value":"allProductListString"},{"type":0,"value":". Add payment details today so your team can keep working without interruption."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.subject":[{"type":1,"value":"subject"}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or alternatively contact your bank.Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for Atlassian Cloud "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-1":[{"type":0,"value":"We\'re unable to process your payment for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":":"}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-2":[{"type":0,"value":"This is due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.not-processed":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"allProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.additional-actions":[{"type":0,"value":"If you\u2019re unable to make payments or you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details.submit":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request":[{"type":0,"value":"For more information about what happens when you\u2019re unsubscribed from Atlassian Access, "},{"type":1,"value":"submitRequestLink"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"see our FAQ"}],"commerce-payment-failure-hams.email.trial.without-cc.2-4.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-1":[{"type":0,"value":"It\u2019s okay, we all get busy! Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but you can still add your payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-1":[{"type":0,"value":"Your Standard plan trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-2":[{"type":0,"value":"But it\u2019s not too late! You can still add payment details and keep the work you\u2019ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested.cancel-subscription":[{"type":0,"value":"cancel your subscription"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-1":[{"type":0,"value":"Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but this could just be the beginning! Add payment details to keep working\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\twith your dream team."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more.support":[{"type":0,"value":"support.atlassian.com"}],"commerce-payment-failure-hams.email.trial.without-cc.org.2-4.expiration":[{"type":0,"value":"It\'s okay, we all get busy! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.org.4more.expiration.expiration":[{"type":0,"value":"It\'s not too late! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tdetails and keep the work you\'ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.org.less2.expiration":[{"type":0,"value":"Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but this could just be the beginning. Add payment details to keep working with your dream team"}],"commerce-payment-failure-hams.email.trial.without-cc.without-cc.org.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can unsubscribe at any time within the Manage Subscriptions area\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tof your organization administration."}],"commerce-payment-failure-hams.email.update-payment-details":[{"type":0,"value":"Update Payment Detail"}],"commerce-payment-failure-trials.add-payment":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.add-payment-without-access":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.billing-cycle-label.no-translate":[{"type":0,"value":" | "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.billing-cycle-text-label.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.card-details":[{"type":0,"value":"Card: "},{"type":1,"value":"cardBrand"},{"type":0,"value":" ending in "},{"type":1,"value":"lastFourDigits"}],"commerce-payment-failure-trials.contact-your-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue.\\n                        Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.contact_us":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation. We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access.contact_us_link":[{"type":0,"value":"Contact us"}],"commerce-payment-failure-trials.contact_us_access.data_storage_link":[{"type":0,"value":"Data Storage FAQs"}],"commerce-payment-failure-trials.contact_us_access.downgrade_link":[{"type":0,"value":"downgrade to a free plan"}],"commerce-payment-failure-trials.couldnt-charge-card":[{"type":0,"value":"We\'re reaching out as we couldn\'t charge your card for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.couldnt-charge-paypal":[{"type":0,"value":"We couldn\'t charge your PayPal account for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" because there was a problem with your account settings or the payment method selected from your PayPal wallet."}],"commerce-payment-failure-trials.ent-org-name-with-space-label.no-translate":[{"type":1,"value":"separator"},{"type":0,"value":" "},{"type":1,"value":"entOrgName"},{"type":0,"value":" "}],"commerce-payment-failure-trials.entitlement-number-label.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.entitlement-number-text.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.has_payment_method.add-payment-caption":[{"type":0,"value":"Add payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.caption":[{"type":0,"value":"Action required: Your payment was declined"}],"commerce-payment-failure-trials.has_payment_method.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment, based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.has_company_name.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"companyName"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.no_retries.partners.caption":[{"type":0,"value":"Action required: Update payment details by "},{"type":1,"value":"dueDate"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.payment-declined-title":[{"type":0,"value":"Action required: Payment declined for #"},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access":[{"type":0,"value":"Update your credit card details, or add a different credit card. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual":[{"type":0,"value":"Update your payment details or add a different payment method to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-monthly-subscriptions":[{"type":0,"value":"For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-payment-caption":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.update-paypal":[{"type":0,"value":"Log in to your PayPal account and go to your automatic payment settings. Select a different payment method for your Atlassian payment. You should also check that your account isn\'t restricted and allows international payments."}],"commerce-payment-failure-trials.has_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.invoice-number":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.invoice-number-label":[{"type":0,"value":"Invoice Number:"}],"commerce-payment-failure-trials.invoice_pdf_attachment":[{"type":0,"value":"For your records, the invoice with payment due is attached as a PDF."}],"commerce-payment-failure-trials.item-description-label.no-translate":[{"type":1,"value":"description"}],"commerce-payment-failure-trials.item-description.no-translate":[{"type":0,"value":" "},{"type":1,"value":"description"}],"commerce-payment-failure-trials.log-in-paypal":[{"type":0,"value":"Log in to PayPal"}],"commerce-payment-failure-trials.no_payment_method.partners.add_your_payment_details":[{"type":0,"value":"Add payment details today to avoid interruptions."}],"commerce-payment-failure-trials.no_payment_method.partners.caption":[{"type":0,"value":"Add payment details to avoid interruptions"}],"commerce-payment-failure-trials.no_payment_method.partners.title.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.partners.title.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.title":[{"type":0,"value":"Action required: Add your payment details"}],"commerce-payment-failure-trials.no_payment_method.unable_to_process_your_payment":[{"type":0,"value":"We were unable to process your payment since we haven\'t received your payment details for your subscription."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process your payment for Atlassian products as you haven\'t provided us with payment details yet."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process-access":[{"type":0,"value":"We\'re reaching out as we couldn\'t process your recent payment for invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" due to an issue with your account\'s payment details."}],"commerce-payment-failure-trials.payment":[{"type":0,"value":"This payment was for:"}],"commerce-payment-failure-trials.paypal-details":[{"type":0,"value":"PayPal account: "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.sold-to-details.address":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"address"}],"commerce-payment-failure-trials.sold-to-details.address-message":[{"type":0,"value":"Address:"}],"commerce-payment-failure-trials.sold-to-details.company":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"companyName"}],"commerce-payment-failure-trials.sold-to-details.company-label":[{"type":0,"value":"Company:"}],"commerce-payment-failure-trials.sold-to-details.customer-contact":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"customerContact"}],"commerce-payment-failure-trials.sold-to-details.customer-contact-label":[{"type":0,"value":"Customer contact:"}],"commerce-payment-failure-trials.total-bill":[{"type":0,"value":"Your total bill is "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce-payment-failure-trials.update-credit-card":[{"type":0,"value":"Update your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-without-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.we_will_try_to_process_again":[{"type":0,"value":"We\u2019ll try to process your payment again on "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-payment-failure-trials.what-to-do":[{"type":0,"value":"What you need to do:"}],"commerce-payment-failure-trials.without-payment-faq-product-access-lost":[{"type":0,"value":"Without this payment, product access will be lost, and product data will be permanently deleted soon after. See our "},{"type":1,"value":"element"}],"commerce-permission-request-add-payment-ccp.email.add-payment-request-text":[{"type":0,"value":"There is an add payment request from "},{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") for the subscription: "}],"commerce-permission-request-add-payment-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce-permission-request-add-payment-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce-permission-request-add-payment-ccp.email.personal-note.no-translate":[{"options":{"other":{"value":[{"type":0,"value":"Hi, I\u2019d like to request an upgrade and need payment details added to this subscription."}]},"true":{"value":[{"type":1,"value":"customMessage"}]}},"type":5,"value":"hasCustomMessage"}],"commerce-permission-request-add-payment-ccp.email.subtext-for-personal-note":[{"type":0,"value":"To help you with more details, here\u2019s a note from the requester: "}],"commerce-permission-request-add-payment-ccp.email.title":[{"type":0,"value":"Request from "},{"type":1,"value":"name"},{"type":0,"value":" to add payment details"}],"commerce-permission-request-add-payment-ccp.email.whats-next-subtext":[{"type":0,"value":"If you approve the request, continue with adding payment details for the subscription and we\u2019ll notify the requester. Ignore this email to deny. "}],"commerce-permission-request-add-payment-response-ccp.email.add-payment-request-text":[{"type":0,"value":"Great news! Your request has been approved. Billing admin has added payment details to your subscription."}],"commerce-permission-request-add-payment-response-ccp.email.benefits-text":[{"type":0,"value":"You can now enjoy the benefits of:"}],"commerce-permission-request-add-payment-response-ccp.email.go-to-site":[{"type":0,"value":"Go to site"}],"commerce-permission-request-add-payment-response-ccp.email.title":[{"type":0,"value":"Your request is complete"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-count":[{"type":0,"value":"Units: "},{"type":1,"value":"count"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-entitlement-number":[{"type":1,"value":"entitlementNumber"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.free-entitlement.no-action":[{"type":0,"value":"You don\u2019t need to do anything, and your monthly Statuspage payments will remain the same."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.merged-addon":[{"type":0,"value":"Over the next few days, we\u2019ll simplify things for you by merging these "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on subscriptions into one:"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.multiple-addons":[{"type":0,"value":"We noticed your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" for "},{"type":1,"value":"site"},{"type":0,"value":" has more than one "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on: "}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.merged-add-on":[{"type":0,"value":"You\u2019ll only see one Subscribers add-on listed on your next invoice."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-change":[{"type":0,"value":"There\u2019s no change to what you\u2019ll pay each month."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-setup":[{"type":0,"value":"You won\u2019t need to set up or configure anything."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.title":[{"type":0,"value":"We\u2019re merging your "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-ons for Statuspage"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.what-this-means":[{"type":0,"value":"What this means for you"}],"commerce-reactivation-order-to-paid-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-auto-servco-upgrade-notification.message.link.view.apps":[{"type":0,"value":"View apps"}],"commerce-subscription-auto-servco-upgrade-notification.message.link.what.is.service.collection":[{"type":0,"value":"What\'s Service Collection?"}],"commerce-subscription-auto-servco-upgrade-notification.message.text":[{"type":0,"value":"Jira Service Management has moved to Service Collection on your site. You can now use the new Customer Service Management app while your existing setup stays the same."}],"commerce-subscription-auto-servco-upgrade-notification.message.title":[{"type":0,"value":"Jira Service Management update"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.body.full.agent":[{"type":0,"value":"We upgraded you to a no-cost 14 day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard, because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":"-"},{"type":1,"value":"userType"},{"type":0,"value":" for the Free plan. Add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to avoid deactivation. Cancel anytime.\\nYou can switch back to a Free plan anytime by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count."}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.body.full.user":[{"type":0,"value":"We upgraded you to a no-cost 14 day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard, because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":"-"},{"type":1,"value":"userType"},{"type":0,"value":" for the Free plan. Add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to avoid deactivation. Cancel anytime.\\nYou can switch back to a Free plan anytime by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count."}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.path.manage.billing":[{"type":0,"value":"Manage billing"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.primary.action":[{"type":0,"value":"Add payment"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.secondary.action":[{"type":0,"value":"Manage subscriptions"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.title.agent":[{"type":0,"value":"Subscription upgraded: Add payment or remove "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" before your trial ends"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.title.user":[{"type":0,"value":"Subscription upgraded: Add payment or remove "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" before your trial ends"}],"commerce-subscription-cancellation-ecc.email.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" canceled"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-reactivation-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-reactivation-trial-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce-subscription-skip-trial-ccp.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.estimated-bill":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excluding tax)"},{"type":1,"value":"content"}],"commerce-subscription-skip-trial-ccp.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" subscription "}],"commerce-subscription-systematic-downgrade-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" subscription "}],"commerce.bill-estimate-common.key":[{"type":0,"value":"Estimated bill:"}],"commerce.bill-estimate-common.value":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excludes tax)"}],"commerce.billing-cycle-common.key":[{"type":0,"value":"Billing cycle:"}],"commerce.billing-cycle-common.value":[{"type":1,"value":"billingCycle"}],"commerce.commerce-approvals-received-author-notification.email.body":[{"type":0,"value":"Your initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") has been approved and is now ready for release."}],"commerce.commerce-approvals-received-author-notification.email.cta.link":[{"type":0,"value":"Click on the button below to release the initiative in Workbench."}],"commerce.commerce-approvals-received-author-notification.email.initiative.link":[{"type":0,"value":"Go to initiative"}],"commerce.commerce-approvals-received-author-notification.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-approvals-received-author-notification.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-approvals-received-author-notification.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-approvals-received-author-notification.message-template.email.subject.no-translate":[{"type":0,"value":"Your initiative is ready for release"}],"commerce.commerce-approvals-received-author-notification.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.cancellation-reason":[{"type":0,"value":"It could be because the information provided to us is incorrect or incomplete. Don\'t worry,\\n                            the subscription can be reactivated after you update your billing information."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.reactive-within":[{"type":1,"value":"content"},{"type":0,"value":" If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.subscription-cancellation-message":[{"type":0,"value":"We couldn\'t generate an invoice for the following subscription as we don\'t have your complete billing information.\\n                            As a result, the subscription has been canceled."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription canceled - update billing details"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.subject":[{"type":1,"value":"title"},{"type":0,"value":" canceled"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-adjust-limit":[{"type":0,"value":"Organization admins can adjust this limit anytime. For the amount of usage above the allowance, at the end of the current cycle, you\'ll receive a bill for extra usage incurred this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-body":[{"type":0,"value":"Your organization has reached the monthly "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit set by your admin. As a result, some features will be restricted or unavailable until your usage reset date. "},{"type":1,"value":"learnMoreLink"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-caption":[{"type":0,"value":"Your organization has hit its "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-body":[{"type":0,"value":"Your organization has used 80% of its "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit. This is a limit that was set by your admin, and is different to the allowance included with your subscriptions."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"80% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit has been used"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next":[{"type":0,"value":"Once your organization reaches the limit, some features will be restricted or unavailable until your usage resets. Organization admins can adjust this limit anytime. For the amount of usage above the allowance, at the end of the current cycle, you\'ll receive a bill for extra usage incurred this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.subject.breach":[{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.subject.milestone":[{"type":0,"value":"Your organization has used 80% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.more-about-usage-charges-and-billing":[{"type":0,"value":"More about usage charges and billing"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.whats-next":[{"type":0,"value":"What\'s next?"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-adjust-limit":[{"type":0,"value":"You can adjust this limit anytime. For the amount of usage above the allowance, at the end of the current cycle, the bill will include extra charges incurred for any extra usage this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-body":[{"type":0,"value":"Your customer has reached the monthly "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit you set. As a result, some features will be restricted or unavailable for your customer until their usage reset date. "},{"type":1,"value":"learnMoreLink"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-caption":[{"type":0,"value":"Your customer has hit their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-body":[{"type":0,"value":"Your customer has used 80% of their organization\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit. This is a limit that was set by your customer\'s admin, and is different to the allowance included with your customer\'s subscriptions."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"80% of your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit has been used"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-whats-next":[{"type":0,"value":"Once your customer reaches the limit, some features will be restricted or unavailable until their usage resets. You can adjust this limit anytime. For the amount of usage above the allowance, at the end of the current cycle, the bill will include extra charges incurred for any extra usage this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.breach":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.breach.without-company-name":[{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.milestone":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": 80% of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.milestone.without-company-name":[{"type":0,"value":"80% of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-credit-account-approval-ccp.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-approval-ccp.message-template.approved.title":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application has been approved"}],"commerce.commerce-credit-account-approval-ccp.message-template.email.subject":[{"type":0,"value":"Approved for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-approval-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details: "}],"commerce.commerce-credit-account-deactivation-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your account is now ineligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-limit-update-ccp.email.list.new-credit-limit":[{"type":0,"value":"New Credit limit: "},{"type":1,"value":"newCreditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-limit-update-ccp.email.possible-reasons":[{"type":0,"value":"Learn about possible reasons."}],"commerce.commerce-credit-account-limit-update-ccp.email.statement-info":[{"type":0,"value":"We\u2019ve decreased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". "},{"type":1,"value":"possibleReasons"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.decrease.title":[{"type":0,"value":"We\u2019ve decreased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.decrease.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been decreased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.increase.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been increased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve increased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". Here are the details: "}],"commerce.commerce-credit-account-limit-update-ccp.message-template.increase.title":[{"type":0,"value":"We\u2019ve increased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-reactivation-ccp.message-template.email.subject":[{"type":0,"value":"Your account is now re-eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.bad-news":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements."}],"commerce.commerce-credit-account-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Couldn\u2019t approve your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application"}],"commerce.commerce-credit-account-rejection-ccp.message-template.other-option":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce.commerce-credit-account-rejection-ccp.message-template.rejection.title":[{"type":0,"value":"We\u2019re unable to approve you for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.thanks":[{"type":0,"value":"Thank you for submitting your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Credit Application Result: Reject"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.how-to-move-forward":[{"type":0,"value":"Here\'s how to move forward:"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.all-fields":[{"children":[{"type":0,"value":"Double-check"}],"type":8,"value":"strong"},{"type":0,"value":" that every field is filled in \u2014 this helps us complete our review faster."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.return-form":[{"children":[{"type":0,"value":"Send them the form"}],"type":8,"value":"strong"},{"type":0,"value":" and ask them to return it directly to us."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.sign":[{"children":[{"type":0,"value":"Sign"}],"type":8,"value":"strong"},{"type":0,"value":" the top of the form."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.vendors":[{"children":[{"type":0,"value":"Choose two vendors"}],"type":8,"value":"strong"},{"type":0,"value":" you\'ve traded with for at least 12 months, whose trade volume with you exceeds the credit limit you\'re requesting. Please note: they can\'t be related entities."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.option.financial-statements":[{"children":[{"type":0,"value":"Latest audited financial statements"}],"type":8,"value":"strong"},{"type":0,"value":" (if you haven\'t already shared these), or"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.option.trade-references":[{"children":[{"type":0,"value":"A completed trade references form"}],"type":8,"value":"strong"},{"type":0,"value":" (attached)"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.reassessment":[{"type":0,"value":"The good news? This isn\'t final \u2014 we\'d be happy to reassess your account once we have a bit more information."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.reassessment-underway":[{"type":0,"value":"Once we receive everything, we\'ll get your reassessment underway."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.rejection":[{"type":0,"value":"Thank you for applying for payment terms with us. After carefully reviewing your application, we\'re unable to approve Net-30 terms at this time."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.resubmit-instructions":[{"type":0,"value":"Once you have the additional information ready, you can resubmit a new Net-30 application directly from your account (the application link is available there). Just include "},{"children":[{"type":0,"value":"one"}],"type":8,"value":"strong"},{"type":0,"value":" of the following with your resubmission:"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.trade-reference-intro":[{"type":0,"value":"Using the trade references form? Just follow these 4 steps:"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.card-expiry-warning-message":[{"type":0,"value":"Heads up \u2014 your credit card expires in "},{"type":1,"value":"expiryMonthAndYear"},{"type":0,"value":". To make sure your next payment is made on time so you can continue using your subscriptions without interruption, you\u2019ll need to update your payment details before "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action":[{"type":0,"value":"What happens if I don\u2019t update my details?"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action-warning":[{"type":0,"value":"Your next payment attempt will fail \u2013 this means your subscription could be deactivated and you could lose product access and data."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.select":[{"type":0,"value":"Select "}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your credit card expires soon"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.time-to-update-credit-card-details":[{"type":0,"value":"Time to update your credit card details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details":[{"type":0,"value":"Update payment details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details-note":[{"type":0,"value":" below to edit your saved card."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.email.subject":[{"type":0,"value":"Additional information needed for your Net-30 application"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.balance-sheet":[{"type":0,"value":"Balance Sheet"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.cash-flow":[{"type":0,"value":"Cash Flow Statement"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.income-statement":[{"type":0,"value":"Income Statement"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.all-fields":[{"type":0,"value":"Ensure all fields are completed so we can finalize the review without delays."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.return-form":[{"type":0,"value":"Send them the form and ask them to return it directly to us."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.sign":[{"type":0,"value":"Sign the top of the form."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.vendors":[{"type":0,"value":"Select two vendors you\'ve traded with for at least 12 months, whose trade volume with you exceeds the credit limit you\'re requesting. Please note that they can\'t be related entities."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.intro":[{"type":0,"value":"Thank you for your interest in setting up Net-30 payment terms with us. After reviewing your D&B credit profile, we\'re unable to approve the request at this time."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-accounting-team":[{"type":0,"value":"Your accounting team should be able to provide these. They\'ll give us a clearer view of your account and support our reassessment."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-heading":[{"type":0,"value":"Option 1: Provide your audited financial statements"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-intro":[{"type":0,"value":"If you haven\'t already shared these, please send your most recent:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option2-heading":[{"type":0,"value":"Option 2: Provide trade references"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option2-intro":[{"type":0,"value":"If you\'d prefer this option, please complete the attached trade reference form. Here\'s what we\'ll need:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.reconsider":[{"type":0,"value":"If you\'d like us to reconsider, we\'d be glad to take another look with some additional information from your end."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.thank-you":[{"type":0,"value":"Thank you again for being an Atlassian customer. We appreciate your business and look forward to hearing from you soon."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.two-options":[{"type":0,"value":"You have two options:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.whats-next-body":[{"type":0,"value":"Please let us know which option you\'d like to pursue, or feel free to reach out with any questions. We\'re here to support you and want to make this process as straightforward as possible."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.whats-next-heading":[{"type":0,"value":"What happens next?"}],"commerce.commerce-customer-contact-remove-digest.email.body.removed-contact":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":")"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.caption":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.contact-removed":[{"type":0,"value":"Contact removed: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.impacted-subscriptions":[{"type":0,"value":"Impacted subscriptions:"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.intro":[{"type":0,"value":"We\'ve removed a key customer contact from a billing profile."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.questions":[{"type":0,"value":"If you have any questions, please reach out to your Atlassian billing partner."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.removed-by":[{"type":0,"value":"Removed by: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes":[{"type":0,"value":"You can view the changes at "},{"type":1,"value":"url"},{"type":0,"value":" page."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes-link":[{"type":0,"value":"partner managed subscriptions"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" subscriptions."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.subject":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customers-deactivation-eve.email.body-p1":[{"type":0,"value":"U.S. law prohibits Atlassian, an Australian corporation with offices in the United States, from providing you with access to our products and services. After analyzing the applicable lists of restricted parties maintained by the U.S. Government, we were unable to confirm that your name was not affiliated with a restricted party."}],"commerce.commerce-customers-deactivation-eve.email.body-p2":[{"type":0,"value":"If this is a case of misidentification, please reply with two different copies of official documentation to verify your identity."}],"commerce.commerce-customers-deactivation-eve.email.body-p3":[{"type":0,"value":"Official documentation includes, but is not limited to, a government-issued driver\'s license or identification card, passport, utility bill, mortgage or bank statement, etc. Please make sure your full name and address are clearly visible."}],"commerce.commerce-customers-deactivation-eve.email.body-p4":[{"type":0,"value":"You may check out these resources for more information: U.S. export controls ("},{"type":1,"value":"exportControl"},{"type":0,"value":") | Consolidated Screening List ("},{"type":1,"value":"csl"},{"type":0,"value":")"}],"commerce.commerce-customers-deactivation-eve.email.body-p5":[{"type":0,"value":"Please reply directly via email with any further questions and the identification requested."}],"commerce.commerce-customers-deactivation-eve.email.body-p6":[{"type":0,"value":"We look forward to your reply."}],"commerce.commerce-customers-deactivation-eve.email.body.csl":[{"type":0,"value":"https://www.trade.gov/consolidated-screening-list"}],"commerce.commerce-customers-deactivation-eve.email.body.exportControl":[{"type":0,"value":"https://www.trade.gov/us-export-controls"}],"commerce.commerce-customers-deactivation-eve.email.caption":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-customers-deactivation-eve.email.salutation":[{"type":0,"value":"Dear Atlassian user,"}],"commerce.commerce-customers-deactivation-eve.email.subject":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.billed-based-on-the-users":[{"type":0,"value":"Until now, billing for this app has been linked to your total user count for Jira. The change will mean that you\'ll be billed based on the number of agents who use the Jira Service Management subscription instead."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.billing-flexibility-info-message":[{"type":0,"value":"Billing flexibility is now available for your "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management app."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.body.this-change-will-introduce-pricing-updates":[{"type":0,"value":"The change will introduce pricing updates that are set out by our Marketplace partners. These updates will come into effect with the new way of billing, even if your user count isn\'t updated."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.body.we-will-make-the-change":[{"type":0,"value":"We\'ll automatically make the change on "},{"type":1,"value":"nextBillingDate"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.caption":[{"type":0,"value":"Have more billing flexibility and only pay for what you need"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.if-you-dont-do-anything":[{"type":0,"value":"If you don\'t do anything"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.maximize-your-billing-efficiency":[{"type":0,"value":"Maximize your billing efficiency"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.need-more-info":[{"type":0,"value":"Need more info? See our guide on "},{"type":1,"value":"howMarketplaceAreBilled"},{"type":0,"value":"."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.billed-based-on-the-users":[{"type":0,"value":"Until now, billing for this app has been linked to your customer\'s total user count for Jira. The change will mean that your customer will be billed based on the number of agents who use the Jira Service Management subscription instead."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.billing-flexibility-info-message":[{"type":0,"value":"Billing flexibility is now available for your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management app."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.body.this-change-will-introduce-pricing-updates":[{"type":0,"value":"The change will introduce pricing updates that are set out by our Marketplace partners. These updates will come into effect with the new way of billing, even if your user count isn\'t updated."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.body.we-will-make-the-change":[{"type":0,"value":"We\'ll automatically make the change on "},{"type":1,"value":"nextBillingDate"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.caption":[{"type":0,"value":"Give your customer more billing flexibility"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.customer-label":[{"type":0,"value":"Customer: "},{"type":1,"value":"customerName"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.pay-for-what-you-need":[{"type":0,"value":"To only pay for what you need, your customer can update the number of JSM agents by heading to Atlassian Administration."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.pay-only-for-users-who-need-access":[{"type":0,"value":"This means they have the option to only pay for the users that really need access."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.review-your-bill":[{"type":0,"value":"Make the switch now so your customer can start making the most of billing flexibility for this app. Keep in mind that the bill may be impacted, and can be changed by the organization admin by managing JSM access as needed. We\'d recommend reviewing the bill as you make the change."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.pay-for-what-you-need":[{"type":0,"value":"To only pay for what you need, your organization admin can update the number of JSM agents by heading to Atlassian Administration."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.pay-only-for-users-who-need-access":[{"type":0,"value":"This means you have the option to only pay for the users that really need access."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.review-your-bill":[{"type":0,"value":"Make the switch now to start making the most of billing flexibility for this app. Keep in mind that your bill may be impacted, and can be changed by the organization admin by managing JSM access as needed. We\'d recommend reviewing your bill as you make the change."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Update billing for your Marketplace app"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.what-do-i-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.what-does-this-mean":[{"type":0,"value":"What does this mean?"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.direct.p1":[{"type":0,"value":"As requested, we\'ve updated the way you\'re billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management. You can now enjoy more control over who has access to and is charged for the app, and your bill will be based on the number of Jira Service Management agents, instead of the user count for Jira."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.direct.p2":[{"type":0,"value":"It\'s a good idea to review who you\'d like to have access to the app. Keep in mind that your bill may be impacted, and organization admins can change it by managing who has access to the app as needed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.partner.p1":[{"type":0,"value":"As requested, we\'ve updated the way your customer is billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management. They can now enjoy more control over who has access to and is charged for the app, and the bill will be linked to the number of JSM agents instead of the user count for Jira."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.partner.p2":[{"type":0,"value":"It\'s a good idea to remind your customer to review who they\'d like to have access to the app, and their bill may be impacted. Organization admins can adjust the bill by managing who has access to the app as needed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.button.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.help":[{"type":0,"value":"Have a question? We\'re here to help. "},{"type":1,"value":"getInTouch"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.link.get-in-touch":[{"type":0,"value":"Get in touch"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.link.how-billed":[{"type":0,"value":"Find out more about how Marketplace apps are billed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.signoff":[{"type":0,"value":"Thanks,"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.subject.direct":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" for JSM billing has been updated"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.subject.partner":[{"type":0,"value":"Update billing for your customer\'s Marketplace app"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.team":[{"type":0,"value":"The Atlassian team"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.title.direct":[{"type":0,"value":"Enjoy more control over your Marketplace app billing"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.title.partner":[{"type":0,"value":"Enjoy more control over your customer\'s app billing"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.custom":[{"type":1,"value":"greetingText"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.default":[{"type":0,"value":"Dear "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-dynamic-content-test-cns.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"message"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-generated-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"businessKey"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-generated-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.offer-message":[{"type":0,"value":"When you use the two together, you can centralize your docs, connect work across teams and more. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-congratulations-message":[{"type":0,"value":"Did you know that "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Confluence?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-product-caption":[{"type":0,"value":"Build a single source of truth for all your team\u2019s important info"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.cta.try-now":[{"type":0,"value":"Try now"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.offer-message":[{"type":0,"value":"Together, the products help you capture ideas and prioritize work, so you\u2019re always organized. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-congratulations-message":[{"type":0,"value":"Did you know "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Jira Product Discovery?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-product-caption":[{"type":0,"value":"Say goodbye to messy backlogs"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.offer-message":[{"type":0,"value":"With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-congratulations-message":[{"type":0,"value":"People who use Jira Service Management say that work is more visible for all teams involved, from request to resolution."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-product-caption":[{"type":0,"value":"Bring developers, IT, and operations onto the same platform"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.offer-message":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-congratulations-message":[{"type":0,"value":"Jira and "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" can help you visualize and deliver work, fast."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-product-caption":[{"type":0,"value":"Break down silos and connect the dots between teams"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-congratulations-message":[{"type":0,"value":"Congrats on purchasing "},{"type":1,"value":"purchasedProductTitle"},{"type":0,"value":"! Get free trials of these products and unlock these advanced features:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-product-caption":[{"type":0,"value":"Get free trials of "},{"type":1,"value":"productName1"},{"type":0,"value":" & "},{"type":1,"value":"productName2"},{"type":0,"value":" Standard with your "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" purchase"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.trial-length-message":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement-with-trial-length.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.single-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-space-permissions":[{"type":0,"value":"Advanced user & space permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.higher-automation-limit":[{"type":0,"value":"Higher automation limit"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.insights-into-page-views":[{"type":0,"value":"Get insights into page views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.on-call-management":[{"type":0,"value":"On-call management"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.published-views":[{"type":0,"value":"Published views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.trial-length":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents":[{"type":0,"value":"Unlimited agents"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents-storage":[{"type":0,"value":"Unlocked agent & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creator-storage":[{"type":0,"value":"Unlocked creator & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-user-storage":[{"type":0,"value":"Unlocked user & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-users":[{"type":0,"value":"Unlimited users"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-archive.alt-text":[{"type":0,"value":"Icon - Archive"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-graph.alt-text":[{"type":0,"value":"Icon - Graph"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-lightning.alt-text":[{"type":0,"value":"Icon - Lightning"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-link.alt-text":[{"type":0,"value":"Icon - Link"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-people.alt-text":[{"type":0,"value":"Icon - People"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-phone.alt-text":[{"type":0,"value":"Icon - Phone"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-unlock.alt-text":[{"type":0,"value":"Icon - Unlock"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.billing":[{"type":1,"value":"billingUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.faq":[{"type":0,"value":"FAQs"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.migrate":[{"type":0,"value":"You have been successfully migrated from Jira Work Management to Jira, within "},{"type":1,"value":"site"},{"type":0,"value":"."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.options":[{"type":0,"value":"To view pricing, auto-renewal, and cancellation options, go to "},{"type":1,"value":"billing"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.site":[{"type":1,"value":"siteUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.subsciption":[{"type":0,"value":"The current price of your subscription has not changed. However, pricing may vary if changes are made to your user tier, plan, and/or licensing. See "},{"type":1,"value":"faq"},{"type":0,"value":" for more details."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.caption":[{"type":0,"value":"You\u2019ve been successfully migrated to Jira"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.subject":[{"type":0,"value":"Your migration was successful"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.encryption-policy-info":[{"type":0,"value":"CMK policy enrollment is required for activation. "},{"type":1,"value":"supportInfo"},{"type":0,"value":" to self-enroll before provisioning Atlassian app instances. For step-by-step instructions, refer to the support "},{"type":1,"value":"CMKSupportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.manage-subscription":[{"type":0,"value":"Please click \u2018Manage Subscription\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.partner-managed-subscription":[{"type":0,"value":"Please visit your partner-managed subscriptions page"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.view-subscription":[{"type":0,"value":"Please click \u2018View all Subscriptions\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration. You can view a detailed breakdown of your team\u2019s usage in your billing account."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above your allowance may incur extra usage charges, which will be added to your bill each month. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.cbp-details":[{"type":0,"value":"Your plan includes:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"You can visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":" to learn more about how billing works."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"We\u2019ll send the final invoice within 24 hours, which will include all the details and payment options for your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" details from your "},{"type":1,"value":"hostingDetails"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.non-cloud.billing-info":[{"type":0,"value":"Go to your billing account to set up your new subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated-with-date.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription from its start date"}]},"other":{"value":[{"type":0,"value":"subscriptions from their start dates"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-reseller":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.give-admin-permission":[{"type":0,"value":"Setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian billing partner. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian reseller. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-reseller":[{"type":0,"value":"You can view or cancel your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time by going to "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" and following the steps."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"the subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.setup-your-site":[{"type":0,"value":"Get started straight away by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":":"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-url":[{"children":[{"type":1,"value":"siteURL"}],"type":8,"value":"a"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.ecc-reseller-managed-subscription.url":[{"type":0,"value":"your Subscription overview"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body-ecc.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.subject":[{"type":1,"value":"billToPartyName"},{"type":0,"value":": Atlassian product order confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer\u2019s bill each month. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.auto_prov_notification":[{"type":0,"value":"The products will be added to your customer\u2019s account shortly."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.cbp-details":[{"type":0,"value":"The plan also includes the following:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.customer_contact_info":[{"type":0,"value":"Your customer contact can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.get-started":[{"type":0,"value":"You can get started straight away by setting up the subscriptions. We\u2019ve also sent a notification to your customer with a setup link to get started. "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from our "},{"type":1,"value":"ppcHomePage"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_invoice_info":[{"type":0,"value":"We\u2019ll email the invoice with all the details within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_notification":[{"type":0,"value":"We\u2019ll also send a notification to your customer with a link to set up their new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and get started."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-details":[{"type":0,"value":"We\u2019ll send you an invoice with all the details within 24 hours. We\u2019ll also send an email to your customer with a link to set up and get started with their new subscription. You can get started straight away by setting up the subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order, and the products will be ready to use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\'ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscriptions from their start dates. We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.with.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscription/s on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"For more information on how to manage your subscriptions and billing, visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"Expect the final invoice within 24 hours, which will include all the necessary details and payment options for your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your cloud site for your new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your Atlassian order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-date.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-manage-subscriptions":[{"type":0,"value":"You can view the subscription from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.next_steps":[{"type":0,"value":"Get started by setting up your customer\u2019s cloud site for the new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.ppc_homepage":[{"type":0,"value":" You can also view and manage the subscription details from our Partner Purchasing Center. "},{"type":1,"value":"viewQuoteUrl"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.processing":[{"type":0,"value":"We\u2019re processing the payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-date.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.subject":[{"type":0,"value":"We\u2019ve received your order for "},{"type":1,"value":"customerCompanyName"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message-template.email.subject":[{"type":0,"value":"This template has been deprecated"}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message.email.body.no-translate":[{"type":0,"value":"This template has been deprecated as it has been merged along with \'commerce-quote-order-fulfilled-ccp\' template with dynamic content added to differentiate between pull/push payment method."}],"commerce.commerce-partner-cancellation-personal-data-deletion-link":[{"type":0,"value":"personal data deletion request form"}],"commerce.commerce-partner-personal-data-deletion":[{"type":0,"value":"If your customer would like to place a request for immediate deletion of personal data after cancellation, they can submit a "},{"type":1,"value":"formLink"},{"type":0,"value":". Otherwise, the data will be deleted in accordance with Atlassian\u2019s standard "},{"type":1,"value":"policyLink"},{"type":0,"value":"."}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.direct.caption":[{"type":0,"value":"Your payment has been processed"}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.direct.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\'ve received your payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The invoice is attached as a PDF for your records."}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.partner-or-reseller.caption":[{"type":0,"value":"Your payment has been processed"}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.partner-or-reseller.confirm":[{"type":0,"value":"This email is to confirm we have received payment for the following invoice:"}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your payment has been processed for the invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Payment processed"}],"commerce.commerce-payment-method-manage-ccp.account-ending-key":[{"type":0,"value":"Account ending: "}],"commerce.commerce-payment-method-manage-ccp.account-ending-value":[{"type":1,"value":"last4"}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-key":[{"type":0,"value":"Account holder name: "}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-value":[{"type":1,"value":"accountHolder"}],"commerce.commerce-payment-method-manage-ccp.authorization-date-key":[{"type":0,"value":"Authorization date: "}],"commerce.commerce-payment-method-manage-ccp.authorization-date-value":[{"type":1,"value":"authorizationDate"}],"commerce.commerce-payment-method-manage-ccp.authorization-details":[{"type":0,"value":"Authorization details"}],"commerce.commerce-payment-method-manage-ccp.bank-name-key":[{"type":0,"value":"Bank name: "}],"commerce.commerce-payment-method-manage-ccp.bank-name-value":[{"type":1,"value":"bankName"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-authorization":[{"type":0,"value":"Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-dispute":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce.commerce-payment-method-manage-ccp.could-not-process-payment":[{"type":0,"value":"We couldn\'t process your recent payment due to a dispute raised with your bank."}],"commerce.commerce-payment-method-manage-ccp.direct-debit-legal-terms":[{"type":0,"value":"You have authorized Atlassian to debit the bank account specified above for any amount owed for charges arising from your use of Atlassian\u2019 services and/or purchase of products from Atlassian, pursuant to Atlassian\u2019 website and terms, until this authorization is revoked. You have authorized Atlassian to debit your bank account periodically if and when you use Atlassian\u2019 services or purchase more than one of Atlassian\u2019 products periodically pursuant to Atlassian terms. Payments that fall outside the regular debits authorized above will only be debited after your authorization is obtained."}],"commerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-mandate":[{"type":0,"value":"Confirmation: Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.how-to-cancel-direct-debit":[{"type":0,"value":"You can cancel this direct debit at any time by deleting the linked bank account from your "},{"type":1,"value":"paymentMethods"},{"type":0,"value":" page"}],"commerce.commerce-payment-method-manage-ccp.payment-methods":[{"type":0,"value":"Payment methods"}],"commerce.commerce-payment-method-manage-ccp.received-authorization":[{"type":0,"value":"We\u2019ve received your authorization for direct debit."}],"commerce.commerce-payment-method-manage-ccp.routing-number-key":[{"type":0,"value":"Routing number: "}],"commerce.commerce-payment-method-manage-ccp.routing-number-value":[{"type":1,"value":"routingNumber"}],"commerce.commerce-payment-method-manage-ccp.update-bank-details":[{"type":0,"value":"Update your bank account details, or link a different bank account. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce.commerce-permission-request-add-payment-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: You have an add payment request"}],"commerce.commerce-permission-request-add-payment-response-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Request complete: Payment details added by billing admin "}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.cta.accept-billing-admin-request":[{"type":0,"value":"Review billing admin request"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.ba-request-text":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") is requesting billing admin permission for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.personal-note.no-translate":[{"type":1,"value":"customMessage"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.subtext-for-personal-note":[{"type":0,"value":"The request was sent with the following note: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.title":[{"type":1,"value":"name"},{"type":0,"value":" is requesting billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.what-they-can-do":[{"type":0,"value":"If you approve, they\'ll be able to:"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.whats-next-subtext":[{"type":0,"value":"If you accept the request, we\'ll notify the requester. If you don\'t want to grant billing admin access, you can decline the request."}],"commerce.commerce-permission-request-grant-ba-role-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: "},{"type":1,"value":"requesterName"},{"type":0,"value":" is requesting Billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.cta.manageSubscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails-for-changes":[{"type":0,"value":"Receive emails about any changes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.request-billing-admin":[{"type":0,"value":"Request billing admins to make changes to subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-site":[{"type":0,"value":"View, upgrade, downgrade and cancel subscriptions in your site"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-approved-text":[{"type":0,"value":"Great news - your billing admin request has been approved for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-declined-text":[{"type":0,"value":"Your request to become a billing admin on the following account has been declined."}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-approved":[{"type":0,"value":"You\'re now a billing admin"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get":[{"type":0,"value":"You\'ll now be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get-without-access":[{"type":0,"value":"You\'ll still be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.approved":[{"type":0,"value":"Your billing admin request has been approved"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-pre-comms-sp-add-on-merge-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Important information about your Statuspage add-ons"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.body-text":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" Standard "},{"children":[{"type":0,"value":"trial has ended."}],"type":8,"value":"strong"},{"type":0,"value":" You\'re currently over the 10-user limit for our Free plan. Add payment details now to keep your team active - otherwise, your team will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-pre-dunning-ccp.mpucup.email.heading":[{"type":0,"value":"Last chance to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" site and data"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.not-ready-heading":[{"type":0,"value":"Not ready to upgrade?"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.subject":[{"type":0,"value":"Last chance to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.switch-back-to-free-admin":[{"type":0,"value":"You can switch back to a Free plan by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"link"},{"type":0,"value":" to 10 or fewer."}],"commerce.commerce-pre-dunning-ccp.mpucup.email.switch-back-to-free-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan by reducing your user count to 10 or fewer."}],"commerce.commerce-pre-dunning-ccp.v2.email.contact-us":[{"type":0,"value":"Please "},{"type":1,"value":"contactUs"},{"type":0,"value":" with any questions, we\'re always happy to help."}],"commerce.commerce-pre-dunning-ccp.v2.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-pre-dunning-ccp.v2.email.total-bill":[{"type":0,"value":"Your total estimated bill is "},{"type":1,"value":"amount"},{"type":0,"value":" (excludes tax)"}],"commerce.commerce-quote-expired-ccp.email.caption":[{"type":0,"value":"Your quote has expired"}],"commerce.commerce-quote-expired-ccp.email.contact-us":[{"type":0,"value":"Contact us"}],"commerce.commerce-quote-expired-ccp.email.ready-to-order":[{"type":0,"value":"If you\u2019d like to try Atlassian products, opt for a free trial."}],"commerce.commerce-quote-expired-ccp.email.reminder-before-expiry":[{"type":0,"value":"Your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired. You\u2019ll no longer be able to pay for it."}],"commerce.commerce-quote-expired-ccp.email.view-quote":[{"type":0,"value":"You can always create a new quote by reaching out to us."}],"commerce.commerce-quote-expired-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"It\u2019s time to renew your subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.request-quote-to-avoid-losing-access":[{"type":0,"value":"To avoid losing access to your products, request a quote that is valid until the end of your billing cycle. When you are ready to pay, simply review the quote and place your order. "}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.list-subscriptions":[{"type":0,"value":"Subscriptions list:"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.caption":[{"type":0,"value":"It\u2019s time to renew"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.reach-out-to-create-quote":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.request-quote-to-avoid-customer-losing-access":[{"type":0,"value":"To avoid losing access to the products, request a quote valid until the end of your billing cycle. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring":[{"type":0,"value":"Just a heads up that you have subscriptions that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring-for-customer-company":[{"type":0,"value":"Just a heads up that you have subscriptions for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote billing period"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote billing period change"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.updated-quote-body":[{"type":0,"value":"We\'ve updated the quote billing period for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because there was a change to the subscription plan, user tier or billing cycle since the quote was created, which changed the start date for one or more items on the quote."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.estimates-changed":[{"type":0,"value":"Changing the billing period has changed how we calculate the quote total, which means that the quote total has now been updated."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote billing period and total change"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.updated-quote-body":[{"type":0,"value":"We\'ve updated the quote billing period and quote total for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because there was a change to the subscription plan, user tier or billing cycle since the quote was created, which changed the start date for one or more items on the quote."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote total"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote total change"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.updated-quote":[{"type":0,"value":"We\'ve updated the quote total for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because the billing address or sold-to address or subscription\'s user count linked to the quote was updated since the quote was created, which changes how we estimate the quote total."}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-estimate.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"commerce.commerce-quote-open-auto-fix-estimate.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.caption":[{"type":0,"value":"It\u2019s time to renew "}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.get-in-touch":[{"type":0,"value":"Get in touch with your Atlassian Billing Partner to get started on your renewal. They\u2019ll be able to help you with your quote and any next steps."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.let-you-know":[{"type":0,"value":"We hope you\u2019ve been enjoying your Atlassian products. We wanted to let you know that your subscription/s expire soon, so it\u2019s time to renew."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-quote-open-auto-renewal-ccp.message-template.email.ecc.subject":[{"type":0,"value":"Contact your Atlassian Billing Partner to renew "}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.caption":[{"type":0,"value":"Renew your subscription"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.caption":[{"type":0,"value":"It\'s time to renew your subscription"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.create-order":[{"type":0,"value":"When your customer is ready to convert the quote to an order, proceed to pay and confirm the order. You can also head to our Partner Purchasing Center to create an order. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"learnMoreLink"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.create-order-title":[{"type":0,"value":"To create an order"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.intro":[{"type":0,"value":"Hi, "},{"children":[],"type":8,"value":"br"},{"type":0,"value":"Just a heads up that the subscription for "},{"type":1,"value":"companyName"},{"type":0,"value":" expires soon and is ready to be renewed. To review the subscription details and the cost, we\'ve created a quote that\'s valid until the end of your customer\'s billing cycle."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.quote-created":[{"type":0,"value":"This is a friendly reminder that you have subscriptions up for renewal on "},{"children":[{"type":1,"value":"renewalDate"}],"type":8,"value":"b"},{"type":0,"value":". To review your subscription details and assess the cost, we\'ve created a quote("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") that\'s valid until the end of your current billing cycle. To view the details, download the attached quote PDF."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.ready-to-pay":[{"children":[{"type":0,"value":"Ready to pay?"}],"type":8,"value":"b"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.reseller.create-order":[{"type":0,"value":"When your customer is ready to convert the quote to an order, proceed to pay and confirm the order. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"learnMoreLink"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.view-details":[{"type":0,"value":"When you\'re ready to renew your subscription, access the quote from the "},{"children":[{"type":0,"value":"Quotes"}],"type":8,"value":"b"},{"type":0,"value":" page of your "},{"children":[{"type":0,"value":"billing account"}],"type":8,"value":"billingLink"},{"type":0,"value":" and place an order."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.what-happens-answer":[{"type":0,"value":"Your subscription will be canceled, unless you renew for the next billing cycle."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.what-happens-question":[{"children":[{"type":0,"value":"What happens after my current billing cycle ends?"}],"type":8,"value":"b"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.message-template.email.subject.direct":[{"type":0,"value":"Renew now: your subscription expires soon"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.message-template.email.subject.partner":[{"type":0,"value":"Quote created for "},{"type":1,"value":"companyName"},{"type":0,"value":" ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":")"}],"commerce.commerce-quote-open-auto-trial-ccp.email.caption":[{"type":0,"value":"Your quote is ready"}],"commerce.commerce-quote-open-auto-trial-ccp.email.place-order":[{"type":0,"value":"Ready to start your paid subscription? Simply review the quote and place your order."}],"commerce.commerce-quote-open-auto-trial-ccp.email.quote-created":[{"type":0,"value":"We\'ve created a quote for your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"edition"},{"type":0,"value":" trial ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"), to help you assess if it\'s the right plan for you. The quote is valid until your trial ends on "},{"children":[{"type":1,"value":"trialExpiry"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-quote-open-auto-trial-ccp.email.reminder":[{"type":0,"value":"Just a reminder \u2013 be sure to order before your trial ends to avoid losing access to your product."}],"commerce.commerce-quote-open-auto-trial-ccp.email.view-details":[{"type":0,"value":"To view the details, download the attached quote PDF or go to the "},{"children":[{"type":0,"value":"Quotes"}],"type":8,"value":"b"},{"type":0,"value":" page of your "},{"children":[{"type":0,"value":"billing account"}],"type":8,"value":"billingLink"},{"type":0,"value":"."}],"commerce.commerce-quote-open-auto-trial-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-trial-ccp.message-template.email.subject":[{"type":0,"value":"Quote created: "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"edition"},{"type":0,"value":" trial ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":")"}],"commerce.commerce-quote-open-ccp.email.contract-type-non-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, contact your customer advocate."}],"commerce.commerce-quote-open-ccp.email.contract-type-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, go to the quote in your billing account and proceed to create an order."}],"commerce.commerce-quote-open-ccp.email.direct-customer":[{"type":0,"value":"Your quote ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") is ready and will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details of the quote, download the attached PDF or go to your site\'s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":0,"value":"admin.atlassian.com/billing"}],"type":8,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-quote-open-ccp.email.direct-customer-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open":[{"type":0,"value":"Your quote ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") is ready and will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details of the quote, download the attached PDF or go to your site\'s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":1,"value":"billingUrlText"}],"type":8,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open-reminder":[{"type":0,"value":"Keep in mind, if you have product trials in the quote, we recommend placing your order before the trial ends. If you need more time, "},{"children":[{"type":0,"value":"reach out to us"}],"type":8,"value":"RawLink"},{"type":0,"value":" to extend your quote validity."}],"commerce.commerce-quote-open-ccp.email.manage-subscription":[{"type":0,"value":"You can view subscription and billing details on your "},{"children":[{"type":0,"value":"Manage Subscriptions"}],"type":8,"value":"RawLink"},{"type":0,"value":" page."}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open":[{"type":0,"value":"Good news \u2013 the quote you requested is now ready:"}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open-details":[{"type":0,"value":"The quote will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details, select \u2018View quote\u2019 and download the PDF."}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.email.partner-ppc-homepage":[{"type":0,"value":"You can also view quotes and manage these subscriptions from our Partner Purchasing Center. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.direct":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is here!"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.partner-or-reseller":[{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is ready"}],"commerce.commerce-quote-reminder-expiry-ccp.email.administration":[{"type":0,"value":"Administration"}],"commerce.commerce-quote-reminder-expiry-ccp.email.caption":[{"type":0,"value":"Your quote will expire soon"}],"commerce.commerce-quote-reminder-expiry-ccp.email.order-in-bac":[{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":" and create an order."}],"commerce.commerce-quote-reminder-expiry-ccp.email.ready-to-order":[{"type":0,"value":"When you\u2019re ready to convert your quote to an order, go to your site\'s "}],"commerce.commerce-quote-reminder-expiry-ccp.email.reminder-before-expiry":[{"type":0,"value":"This is a friendly reminder that your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire on "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". Once expired, the quote will be canceled and you have to create a new one."}],"commerce.commerce-quote-reminder-expiry-ccp.email.view-quote":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-reminder-expiry-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire soon"}],"commerce.commerce-quote-stale-ccp.email.body":[{"type":0,"value":"Just a heads up that your quote for "},{"type":1,"value":"companyName"},{"type":0,"value":" needs to be updated before it can be moved back to OPEN."}],"commerce.commerce-quote-stale-ccp.email.caption":[{"type":0,"value":"Your quote needs to be reviewed"}],"commerce.commerce-quote-stale-ccp.email.update-line-item":[{"type":0,"value":"Head to the effected line item/s on the quote and follow the prompts from the error to update it. If that doesn\'t work, you\'ll need to raise a GSAC ticket so that an Atlassian Customer Advocate can look into it."}],"commerce.commerce-quote-stale-ccp.message-template.email.subject":[{"type":0,"value":"Action required: "},{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" needs review"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.caption":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been successfully reactivated"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.we-will-charge":[{"type":0,"value":"We\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entNumber"},{"type":0,"value":")"}],"commerce.commerce-reactivation-order-to-paid-ccp.personal-information":[{"type":0,"value":"Since you reactivated your subscription within 60 days of cancellation, your data and preferences\\n                    are as you left them. You can jump right in and get started!"}],"commerce.commerce-refund-generic-email-ccp.email.direct.caption":[{"type":0,"value":"Your refund has been processed"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.caption":[{"type":0,"value":"Your refund has been processed"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.completed":[{"type":0,"value":"We have completed the refund related to the following invoice:"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.refund-amount":[{"type":0,"value":"The refund has been credited to the payment method used in the original purchase. Please allow 2-3 business days for the refunded amount to appear on your bank statement. Please note that any subscription changes based on your refund request will reflect on your account shortly."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.cash-refund":[{"type":0,"value":"If you would like to receive a cash refund instead, please reach out to "},{"children":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"type":8,"value":"a"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.completed":[{"type":0,"value":"We have completed the refund related to the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.credit-issued":[{"type":0,"value":"The credits issued on this credit note will be applied to any outstanding unpaid invoices you may have."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Refund processed for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-refund-generic-email-ccp.message-template.email.more-info":[{"type":0,"value":"For more information about invoices and subscriptions, go to your sites "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Refund processed"}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-amount":[{"type":0,"value":"The refunded amount should appear on your bank statement in 2-3 business days. Any subscription changes based on your refund request will reflect on your account soon."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-credited-to-cc":[{"type":0,"value":"A refund from the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been credited to your card "},{"children":[{"type":1,"value":"cardBrand"},{"type":0,"value":" ending in "},{"type":1,"value":"maskedNumber"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-credited-to-paypal":[{"type":0,"value":"A refund from the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been credited to your "},{"children":[{"type":0,"value":"PayPal account, "},{"type":1,"value":"paypalEmail"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.terms-completed":[{"type":0,"value":"We have completed the refund related to the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" and generated a credit note "},{"type":1,"value":"creditNoteNumber"},{"type":0,"value":" against it."}],"commerce.commerce-refund-internal-ccp.message-template.email.adc-refund.body":[{"type":0,"value":"Advocate Central REFUND LINK - "},{"type":1,"value":"advocateCentralUrl"},{"type":0,"value":"/refunds/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-bank-transfer.subject":[{"type":0,"value":"Bank Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-onAccount.subject":[{"type":0,"value":"Expert Account Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund.body":[{"type":0,"value":"CASSI REFUND LINK - "},{"type":1,"value":"cassiUrl"},{"type":0,"value":"/ui/refunds/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption-announcement":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption-announcement.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-rde-caption":[{"type":0,"value":"Upgrade to Rovo Dev Standard to get more Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption-allowance-announencement":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption-allowance-announencement.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"Rovo Dev credit allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached.pooled-meter":[{"type":1,"value":"productName"},{"type":0,"value":" allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone.pooled-meter":[{"type":1,"value":"productName"},{"type":0,"value":" allowance is running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-monitor":[{"type":0,"value":"You can monitor usage in your billing account to see which users have used their allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-ugrade-to-standard":[{"type":0,"value":"To increase Rovo Dev credits and allow extra usage, organization admins can upgrade to Rovo Dev Standard."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-user-cannot-use-extra":[{"type":0,"value":"Users who are at their credit limit won\'t be able to use any Rovo Dev features until the next billing cycle."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done anytime in Atlassian Administration to keep costs predictable. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-extra-usage-charges":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trialsneed-to-know-list-function-disabled":[{"type":0,"value":"Rovo Dev functionality is disabled for users who reach their allowance, and usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done at any time in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-will-be-disabled":[{"type":0,"value":"Once users use up their Rovo Dev credits, Rovo Dev functionality will be disabled until usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-details.ubp5":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message-announcement.ubp5":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-rde-info-message":[{"type":0,"value":"At least one of your users has used up their free Rovo Dev credit allowance in Jira."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-update-limits.ubp5":[{"type":0,"value":"Your org admin can update your usage limits anytime."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-what-next.ubp5":[{"type":0,"value":"If your org admin has enabled extra usage, you\u2019ll incur extra usage charges up to your extra usage limit. If extra usage is disabled, some features will be restricted or unavailable until your usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached.rovo-no-interruption":[{"type":0,"value":"Your org can still use "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" without interruption. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-announcement":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-announcement.ubp5":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-org-details.ubp5":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-what-next.ubp5":[{"type":0,"value":"If your org reaches 100% of their allowance, extra usage charges will be incurred if extra usage is enabled. Otherwise, some features will be restricted or unavailable until your usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone.rovo-no-interruption":[{"type":0,"value":"If the allowance limit is reached, your org can still use "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" without interruption. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-details.ubp5":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message-pooled-meter.ubp5":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-update-limits.ubp5":[{"type":0,"value":"You can update your customer\u2019s usage limits anytime."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-what-next.ubp5":[{"type":0,"value":"If you\'ve enabled extra usage for your customer, they\u2019ll incur extra usage charges up to the extra usage limit. If extra usage is disabled, some features will be restricted or unavailable until their usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached.rovo-no-interruption":[{"type":0,"value":"Your customer can still use "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" without interruption. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-details.ubp5":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-pooled-meter":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-pooled-meter.ubp5":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-vist-ppc-pooled-meter":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-what-next.ubp5":[{"type":0,"value":"If your customer reaches 100% of their allowance, extra usage charges will be incurred if extra usage is enabled. Otherwise, some features will be restricted or unavailable until their usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone.rovo-no-interruption":[{"type":0,"value":"If the allowance limit is reached, your customer can still use "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" without interruption. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.rc-io-usage-notice":[{"type":0,"value":"Extra usage is currently non-billable. "},{"type":1,"value":"moreAboutUsageUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.rc-io-usage-url":[{"type":0,"value":"More about usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.whats-next.ubp5":[{"type":0,"value":"What\u2019s next?"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption-pooled-meter":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption-pooled-meter.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption-pooled-meter.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.pooled-meter":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.pooled-meter":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" allowance is running low "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-ship-to-party-archival-ccp.body.initimation":[{"type":0,"value":"Please note that this sold-to address is no longer available for billing."}],"commerce.commerce-ship-to-party-archival-ccp.body.partner.p3":[{"type":0,"value":"To view the changes, head to "},{"type":1,"value":"ppcHomePageLink"},{"type":0,"value":"."}],"commerce.commerce-ship-to-party-archival-ccp.email.body.disclaimer":[{"type":0,"value":"We\'ve deactivated the below sold-to address:"}],"commerce.commerce-ship-to-party-archival-ccp.message-template.email.subject":[{"type":1,"value":"name"},{"type":0,"value":" Sold to address deactivated"}],"commerce.commerce-soft-limit-breach-ccp.email.automatic-upgrade":[{"type":0,"value":"Automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.email.manage-users":[{"type":0,"value":"Manage "},{"type":1,"value":"product"}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade":[{"type":0,"value":"Don\'t want to upgrade? "}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade-text":[{"type":0,"value":"We recommend removing "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users before your upgrade date. You can do this by selecting Manage users in your "},{"type":1,"value":"product"},{"type":0,"value":" subscription"}],"commerce.commerce-soft-limit-breach-ccp.email.note1":[{"type":0,"value":"If no changes are made, you\'ll be upgraded and we\'ll send you an invoice of prorated costs for the remainder of your billing period."}],"commerce.commerce-soft-limit-breach-ccp.email.note2":[{"type":0,"value":"You don\'t need to take any action. We\'ll automatically upgrade your account and the new charges will be applied."}],"commerce.commerce-soft-limit-breach-ccp.email.product-limit-exceeded":[{"type":0,"value":"Your "},{"type":1,"value":"product"},{"type":0,"value":" user limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" has exceeded by "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder":[{"type":0,"value":"In a few days you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder-caption":[{"type":0,"value":"You\u2019re about to be upgraded"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder":[{"type":0,"value":"Soon you\'ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder-caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder":[{"type":0,"value":"In the next week, you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count. "}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder-caption":[{"type":0,"value":"You\u2019ll be upgraded soon"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.final-reminder":[{"type":0,"value":"Last chance: manage users before automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.reminder":[{"type":0,"value":"Action required before automatic upgrade"}],"commerce.commerce-subscription-activation-ccp.message-template.ecc.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.setup-site":[{"type":0,"value":"Setting up the site means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.with-site":[{"type":0,"value":"Your products are ready for use "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.without-site":[{"type":0,"value":"Set up your subscription and get started"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian partner had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.site-info":[{"type":0,"value":"They\'ll be added to your site shortly."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian reseller had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage these subscriptions from our "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.subscriptions-active":[{"type":0,"value":"Great news \u2014 the subscriptions that you ordered for your customer on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are now active and ready to use. We\u2019ve also informed your customer that they can get started."}],"commerce.commerce-subscription-activation-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to your "},{"type":1,"value":"managedSubscriptionUrl"},{"type":0,"value":" page and following the steps."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.partner-managed-subscription.url":[{"type":0,"value":"Subscription overview"}],"commerce.commerce-subscription-activation-ccp.message-template.email.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.ecc":[{"type":0,"value":"It\u2019s time to set up your subscription"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.partner":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": it\u2019s time to set up subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.singular":[{"type":0,"value":"It\'s time to set up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subscriptions-active":[{"type":0,"value":"Great news \u2014 the "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" is"}]},"other":{"value":[{"type":0,"value":"subscriptions that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active."}],"commerce.commerce-subscription-activation-ccp.message-template.email.time-to-get-set-up":[{"type":0,"value":"It\'s time to get set up"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.add-on.cta":[{"type":0,"value":"Increase usage limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.add-on.cta":[{"type":0,"value":"Get quote for higher limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-auto-downgrade-ccp.email.partner.subject.with.company.name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":":"},{"type":1,"value":"productName"},{"type":0,"value":" now on Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.limted.features.info":[{"type":0,"value":"This way, your customer can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uncollectible":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uninvoiceable":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we don\u2019t have your customer\u2019s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.explore-plans":[{"type":0,"value":"Explore plans"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.how-to-get-back-to-original-plan":[{"type":0,"value":"If you\'d like to get back to your original plan, go to "},{"children":[{"type":0,"value":"Subscriptions"}],"type":8,"value":"b"},{"type":0,"value":" and select "},{"children":[{"type":0,"value":"Manage"}],"type":8,"value":"b"},{"type":0,"value":" for your product. In "},{"children":[{"type":0,"value":"Subscription details"}],"type":8,"value":"b"},{"type":0,"value":", select "},{"children":[{"type":0,"value":"Change plan"}],"type":8,"value":"b"},{"type":0,"value":" to upgrade."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.request-deletion-of-personal-data-link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.subscription-downgraded-message":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"). As a result, we\'ve moved your subscription to the Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.you-may-request-deletion-of-personal-data":[{"type":0,"value":"You may also place a "},{"type":1,"value":"requestForDeletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"You are now on the Free plan of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption-v2":[{"type":1,"value":"firstName"},{"type":0,"value":", you\u2019re now on the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.subject":[{"type":1,"value":"productName"},{"type":0,"value":" subscription downgraded to a Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.subject-v2":[{"type":0,"value":"We\u2019ve switched you to the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.summary-v2":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":", as of today, you\'ve been switched to the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.upgrade-your-subscription":[{"type":0,"value":"You can also choose to upgrade to go back to your original plan."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.go-back-original-plan":[{"type":0,"value":"Want to go back on the original plan?"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.review-and-manage-subscription":[{"type":0,"value":"Review the customer\u2019s billing details from our Partner Purchasing Center and change the subscription."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.subscription-downgraded-message":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for this subscription. As a result, we\'ve moved the subscription to the Free plan. This way, "},{"type":1,"value":"productName"},{"type":0,"value":" can still be used, but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.you-may-request-deletion-of-personal-data":[{"type":0,"value":"Your customer can also place a "},{"type":1,"value":"requestForDeletionOfPersonalDataLink"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" moved to Free plan due to payment issue"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":":"},{"type":1,"value":"productName"},{"type":0,"value":" now on Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.partner.email.body.personal-data-retention-summary.link":[{"type":0,"value":"request for deletion of their personal data."}],"commerce.commerce-subscription-auto-upgrade-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-ccp.legal-update-twcg-1465.downgrade":[{"type":0,"value":"downgrade"}],"commerce.commerce-subscription-auto-upgrade-ccp.legal-update-twcg-1465.reduce-your-user-count":[{"type":0,"value":"reduce your user count"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Your customer can now enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, with instructions."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.body.switch-to-back-free-plan":[{"type":0,"value":"To stay on the Standard plan, you don\'t need to do anything. We\'ll charge your saved payment method when your trial ends. To return to the Free plan, first "},{"type":1,"value":"reduceYourUserCount"},{"type":0,"value":" to meet the plan limit, then "},{"type":1,"value":"downgrade"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-date-label":[{"type":0,"value":"Next bill date"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-estimate-label":[{"type":0,"value":"Next bill estimate"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-estimate-value":[{"type":1,"value":"amount"},{"type":0,"value":" "},{"type":1,"value":"billingCycle"},{"type":0,"value":" (excluding taxes)"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.plan-label":[{"type":0,"value":"Plan"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.plan-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.explore-standard-cta":[{"type":0,"value":"Explore Standard"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.subscription-trial":[{"type":0,"value":"You\'ve reached the user limit for your Free plan, so "},{"children":[{"type":0,"value":"we\'ve upgraded you"}],"type":8,"value":"bold"},{"type":0,"value":" to our Standard plan. It\'s free for 14 days."},{"type":1,"value":"br"},{"type":0,"value":"You can now add unlimited users to your projects and help your team ship faster."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.subscription-trial-with-end-date":[{"type":0,"value":"You\'ve reached the user limit for your Free plan, so "},{"children":[{"type":0,"value":"we\'ve upgraded you"}],"type":8,"value":"bold"},{"type":0,"value":" to our Standard plan. It\'s free for 14 days."},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"You can now add unlimited users to your projects and help your team ship faster. Your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"bold"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.caption":[{"type":0,"value":"Your Standard trial has started"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.subscription-details-heading":[{"type":0,"value":"Subscription details"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.what-happens-next-heading":[{"type":0,"value":"What happens next?"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.confluence-logo-alt":[{"type":0,"value":"Confluence"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.jira-logo-alt":[{"type":0,"value":"Jira"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.jpd-logo-alt":[{"type":0,"value":"Jira Product Discovery"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.email.icon-warning.alt-text":[{"type":0,"value":"Icon - Warning"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Important things to know about "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you\u2019ll just need to make sure your Atlassian billing partner has the correct billing details. We\u2019ve also sent them an email with instructions."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been upgraded to the "},{"type":1,"value":"planName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.add-payment-details":[{"type":0,"value":"Add payment details before the trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", otherwise the subscription will be deactivated."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access":[{"type":0,"value":"You\u2019ll lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" if you don\u2019t take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.you-can-switch-back-to-free-plan-billing-admin":[{"type":0,"value":"You can switch back to a Free plan at any time by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"Link"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.you-can-switch-back-to-free-plan-mpucup-user":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan at any time by reducing your user count."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.body-intro":[{"type":0,"value":"Your team now has a "},{"children":[{"type":0,"value":"free 14-day trial"}],"type":8,"value":"b"},{"type":0,"value":" of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard because you reached the 10-user limit on the Free plan."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.invite-team":[{"children":[{"type":0,"value":"Invite your team."}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need to your spaces."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.page-insights":[{"children":[{"type":0,"value":"Measure impact."}],"type":8,"value":"b"},{"type":0,"value":" Track views and engagement with page insights."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.rovo-ai":[{"children":[{"type":0,"value":"Draft faster."}],"type":8,"value":"b"},{"type":0,"value":" Generate ideas and first drafts with Rovo AI."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.automation":[{"children":[{"type":0,"value":"Automate tedious tasks."}],"type":8,"value":"b"},{"type":0,"value":" Set rules for repetitive updates."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.invite-team":[{"children":[{"type":0,"value":"Invite your team."}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need to your spaces."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.rovo-agents":[{"children":[{"type":0,"value":"Put agents to work."}],"type":8,"value":"b"},{"type":0,"value":" Call on Rovo agents for specialized tasks."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.heading":[{"type":0,"value":"We\'ve upgraded you to "},{"type":1,"value":"productName"},{"type":0,"value":" Standard"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.payment-deadline":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\'t add payment details or reduce your user count to 10 or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019ve already added your payment details, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject3":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has changed to Standard"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-admin-partner.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or have your customer\u2019s admin remove users so you can switch back to Free in the "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.add-payment-or-remove-users":[{"type":0,"value":"To keep unlimited and users stay on Standard, ensure your Atlassian billing partner updates your billing details. We\u2019ve also sent them instructions. To switch back to Free, "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.take-action":[{"type":0,"value":"Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation. For help, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.direct-customer.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":" to switch back to the Free plan. Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.over-free-limit-moved-to-standard":[{"type":0,"value":"You\'re over the Free user limit, so we moved you to Standard, which includes unlimited users."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.partner-purchasing-center":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.remove-users":[{"type":0,"value":"remove users"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.caption":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.closing-line":[{"type":0,"value":"Your new bill date will be in effect from the next billing cycle. To transition you to the new\\n\\t\\t\\t\\t\\t  bill date, pro-rated adjustments will be applied to your next invoice."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.first-line":[{"type":0,"value":"We\'ve processed your request to change the bill date for your "},{"type":1,"value":"productName"},{"type":0,"value":"\\n\\t\\t\\t\\t\\t\\t("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription to "},{"type":1,"value":"requestedNextBillingDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.second-line":[{"type":0,"value":"If you have any other product and subscriptions on the same site that belong to the same product family,\\n            they need to be billed together. That means we\u2019ve changed the bill date for those subscriptions too."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template.email.subject":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-cancellation-ecc.email.body.billing-partner":[{"type":0,"value":"Atlassian billing partner"}],"commerce.commerce-subscription-cancellation-ecc.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" subscription is canceled"}],"commerce.commerce-subscription-cancellation-ecc.email.body.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-ecc.email.body.data-will-be-deleted":[{"type":0,"value":"Data will be deleted within 60 days from the date of cancellation. If you\u2019d like to request deletion of the data earlier, "}],"commerce.commerce-subscription-cancellation-ecc.email.body.reactivate":[{"type":0,"value":"Your Atlassian billing partner can ask us to reactivate the subscription if needed. If you weren\u2019t expecting this email, you can contact us."}],"commerce.commerce-subscription-cancellation-ecc.email.body.this-is-to-let-you-know":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your app\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.cta.reactivate-button":[{"type":0,"value":"Reactivate "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.exceeded-user-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.restore-within-15-days":[{"type":0,"value":"You can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.restore-within-15-days-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-direct-customer-non-cloud":[{"type":0,"value":"If you want to keep your subscription, "},{"type":1,"value":"reachOutLinkForNonCloud"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.direct-customer.jsm-requirement":[{"type":0,"value":"This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.direct-customer.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption.twc":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.body.sub-cancel-note.twc":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.manage-subscription-button":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-user.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.received-request":[{"type":0,"value":"We\'ve received your request to cancel your subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.sub-cancel-note":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.billing-partner-details.twc":[{"type":0,"value":"Your billing partner details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.data-deletion-note":[{"type":0,"value":"Product data will be deleted in 60 days from the date of cancellation. For trials, we retain data for 15 days. If you\u2019d like to request deletion of personal data, "},{"type":1,"value":"contactSupport"},{"type":0,"value":". Learn about "},{"type":1,"value":"privacyPolicy"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.contact-us":[{"type":0,"value":"contact us"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.data-deletion-note":[{"type":0,"value":"Product data will be deleted 60 days from cancellation. For trials, we retain data for 15 days. If you\'d like to request deletion of personal data, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.intro":[{"type":0,"value":"Your app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to contact your Atlassian billing partner to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request":[{"type":0,"value":"We\'ve received a request to cancel the following subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request.twc":[{"type":0,"value":"We\'ve received your request to cancel your subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject.twc":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-user.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.customer-details.twc":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.atlassian-privacy-policy":[{"type":0,"value":"Atlassian\u2019s Privacy Policy"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-billing-partner":[{"type":0,"value":"You can contact your Atlassian billing partner if you need help or want to reverse the cancellation request."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.intro":[{"type":0,"value":"Your customer\'s app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since your customer doesn\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription":[{"type":0,"value":"Keeping the subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription.twc":[{"type":0,"value":"Your customer contact can undo the cancellation at any time from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner-managed-subscriptions-link":[{"type":1,"value":"partnerManagedSubscriptionsLink"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner.billing-admin.undo-cancellation-link":[{"type":0,"value":"Learn how to undo a cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request":[{"type":0,"value":"We\u2019ve received a request to cancel the following subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request.twc":[{"type":0,"value":"We\u2019ve received your customer\u2019s request to cancel their subscription."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note.twc":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". Until then, the subscription can still be used. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.subscription-details.twc":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name.twc":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name.twc":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.body.could-not-process-payment":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription since we were unable to process your payment. "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.cta.reactivate-button":[{"type":0,"value":"Reactivate "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.exceeded-user-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.restore-within-15-days":[{"type":0,"value":"You can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.restore-within-15-days-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for the following subscription.As a result, the subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject.no-customer-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.cta-direct-customer.reactivate-subscription":[{"type":0,"value":"Don\u2019t worry, all\u2019s not lost! You can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days, we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription-button":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.product-list-item":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"},{"type":0,"value":")"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.update-payment-details":[{"type":0,"value":"We recommend updating your payment details to ensure this doesn\'t happen again."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.payment-details-up-to-date":[{"type":0,"value":"To avoid this in the future, ensure your payment details are up to date."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes canceled"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-view-cancel-subscription":[{"type":0,"value":"You can view or cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.managed-subscriptions-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-manage-subscription":[{"type":0,"value":"You can manage the subscription from the "},{"type":1,"value":"partnerPurchaseCentralUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, your customer\u2019s subscriptions are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-view-cancel-subscription":[{"type":0,"value":"Your customer contact can view and cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"Based on a quote that you\u2019ve already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-view-cancel-subscription":[{"type":0,"value":"You can view and manage your subscription from your billing account. "}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":" We\u2019ll charge your chosen payment details annually, and your subscription will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":"We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.auto-renewal":[{"type":0,"value":"As requested, your subscription has now been moved to the annual (auto-renewal) plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.termed":[{"type":0,"value":"As requested, your subscription has now been moved to the annual plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.caption":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":"We\u2019ll charge your chosen payment details annually for this subscription, and it will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":" We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.auto-renewal":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n\\t\\t\\t\\tAs requested, your subscription has been moved to an annual (auto-renewal) plan, which will start after\\n\\t\\t\\t\\tyour trial period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.termed":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n                As requested, your subscription has been moved to an annual plan, which will start after your trial\\n                period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.subject":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.charge-quantities-added-message":[{"type":0,"value":"You added new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to your subscription. Based on these changes, we\u2019ve adjusted your billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and prorated the cost for new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for the remaining time in your billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.estimated-bill":[{"type":0,"value":"Your estimated bill for the next billing cycle is "},{"children":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"type":8,"value":"b"},{"type":0,"value":" (excluding tax)."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.final-invoice-details":[{"type":0,"value":"Your final invoice will reflect all "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of your current billing period and the subsequent prorated charges."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.to-view-bill":[{"type":0,"value":"To view your bill breakdown and usage details, visit your "},{"children":[{"type":0,"value":"Subscription details"}],"type":8,"value":"b"},{"type":0,"value":" page."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.charge-quantities-added-message":[{"type":0,"value":"More "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been added to the following subscription:"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.final-invoice-details":[{"type":0,"value":"The final invoice will reflect the total number of "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of the current billing cycle."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.p2-billing-adjusted":[{"type":0,"value":"The billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been adjusted to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and the cost for the new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" has been prorated for the remaining time in the billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.ppc":[{"type":0,"value":"You can view the usage details from our "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your customer\u2019s team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.app-retiring":[{"type":0,"value":"We wanted to let you know that we\u2019re no longer offering "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". "}],"commerce.commerce-subscription-offering-cancellation-ccp.email.atlassian-suite":[{"type":0,"value":"Atlassian suite"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-at-end-of-billing-cycle":[{"type":0,"value":"This means your subscription will be canceled at the end of your last billing cycle."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-immediately":[{"type":0,"value":"This means your subscription will be canceled 30 days from the date of this email."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-on-offering-expiry-date":[{"type":0,"value":"This means your subscription will be canceled on "},{"type":1,"value":"expiryDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.caption":[{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is being retired"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.marketplace-apps":[{"type":0,"value":"Marketplace apps"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.other-plans-available":[{"type":0,"value":"There may still be other "},{"type":1,"value":"appName"},{"type":0,"value":" plans available \u2014 you can check out our "},{"type":1,"value":"atlassianSuite"},{"type":0,"value":" of products or "},{"type":1,"value":"marketplaceApps"},{"type":0,"value":"."}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription will be canceled"}],"commerce.commerce-subscription-offering-movement-ccp.email.app-getting-replaced":[{"type":0,"value":" The developers of "},{"type":1,"value":"appName"},{"type":0,"value":" are retiring this app and replacing it with a free version. Your paid\\n                subscription will transition to "},{"type":1,"value":"freeAppName"},{"type":0,"value":". From the end of your last billing cycle, you\u2019ll no \\n\\t\\t\\t\\tlonger be charged for this app."}],"commerce.commerce-subscription-offering-movement-ccp.email.caption":[{"type":0,"value":"Your paid subscription for this app will convert to a free subscription"}],"commerce.commerce-subscription-offering-movement-ccp.message-template.email.subject":[{"type":1,"value":"appName"},{"type":0,"value":" is being retired."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp-g.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-opt-out-ccp-grouped.email.direct.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember \u2014 if your organization admin has enabled extra usage, any usage above the allowance will incur extra usage charges. These will be reflected on your bill at the end of the cycle. Organization admins can adjust usage limits anytime. "}],"commerce.commerce-subscription-opt-out-ccp-grouped.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember \u2014 if you\u2019ve enabled extra usage, any usage above the allowance will incur extra usage charges. These will be reflected on your bill at the end of the cycle. You can adjust usage limits anytime."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.email.direct.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer\'s bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and billing details on your "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.manage-url":[{"type":0,"value":"Manage Subscriptions"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.ba-when-the-trial-ends":[{"type":0,"value":"Your subscription will be canceled, unless you place an order for the paid plan before the trial end date. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.bu-when-the-trial-ends":[{"type":0,"value":"When you\'re ready to start paid subscription, your billing admin will need to use the quote we send them to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-partner-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p2.partner":[{"type":0,"value":"When trial ends, the subscription will be deactivated. To extend the trial "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3":[{"type":0,"value":"We\'ve sent a quote to your billing admin. When you\'re ready to start your paid subscription, your billing admin will need to use the quote to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3-admin":[{"type":0,"value":"During your trial, we\'ll send you a quote. When you\'re ready to start your paid subscription, you can use the quote to place the order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.reach-out-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.ba.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to the included amount for each quota. If they want extra usage straight away you can contact us. Otherwise, they\u2019ll be able to use more than the included quantity once their paid plan starts, and extra usage charges will be added to the invoice as per their usage."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-details":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-cbp-details":[{"type":0,"value":"Your new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.dc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.dc.twc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.twc.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.upgraded-cbp-details":[{"type":0,"value":"The new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-cc.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allowance for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.caption-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.cbps-description":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":". You won\'t be charged if you switch before the trial ends."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.rovo-dev-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-on":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.twc-as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends"},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.twc-good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-description":[{"type":0,"value":", and you\u2019ll continue to be charged for your existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.dc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.dc.twc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.cta.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.docs":[{"children":[{"type":0,"value":"Create docs instantly."}],"type":8,"value":"b"},{"type":0,"value":" Generate plans, roadmaps, and more with AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.find":[{"children":[{"type":0,"value":"Find what you need."}],"type":8,"value":"b"},{"type":0,"value":" Search across all your connected apps in one place."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.automate":[{"children":[{"type":0,"value":"Automate tedious tasks."}],"type":8,"value":"b"},{"type":0,"value":" Set rules for repetitive updates."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.plans":[{"children":[{"type":0,"value":"Turn plans into work."}],"type":8,"value":"b"},{"type":0,"value":" Create work items from docs using AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.align":[{"children":[{"type":0,"value":"Align your team."}],"type":8,"value":"b"},{"type":0,"value":" Share plans with co-workers, no sign up required."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.prioritize":[{"children":[{"type":0,"value":"Prioritize ideas."}],"type":8,"value":"b"},{"type":0,"value":" Define and refine your opportunities in one place."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.edit":[{"children":[{"type":0,"value":"Edit your videos."}],"type":8,"value":"b"},{"type":0,"value":" Cut \u201Cums\u201D and more with trim and stitch tools."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.engagement":[{"children":[{"type":0,"value":"Understand engagement."}],"type":8,"value":"b"},{"type":0,"value":" See who watched and for how long."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.record":[{"children":[{"type":0,"value":"Record without limits."}],"type":8,"value":"b"},{"type":0,"value":" Create and share unlimited videos."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.confluence":[{"children":[{"type":0,"value":"Create docs instantly."}],"type":8,"value":"b"},{"type":0,"value":" Generate plans, roadmaps, and more with AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.jira":[{"children":[{"type":0,"value":"Turn plans into work."}],"type":8,"value":"b"},{"type":0,"value":" Create work items from docs using AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.loom":[{"children":[{"type":0,"value":"Align without meetings."}],"type":8,"value":"b"},{"type":0,"value":" Explain work or decisions with async video."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.rovo":[{"children":[{"type":0,"value":"Put agents to work."}],"type":8,"value":"b"},{"type":0,"value":" Create AI agents to handle specific tasks."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-full-access":[{"type":0,"value":"You get full access to all "},{"children":[{"type":1,"value":"planName"},{"type":0,"value":" features"}],"type":8,"value":"link"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-refund":[{"type":0,"value":"You can request a refund within 30 days if you forget to cancel."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-reminder":[{"type":0,"value":"We\'ll remind you 3 days before your trial ends. Cancel anytime."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.title":[{"type":0,"value":"How your trial works"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subject":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-date.label":[{"type":0,"value":"Next bill date"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-estimate.label":[{"type":0,"value":"Next bill estimate"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-estimate.value":[{"type":1,"value":"amount"},{"type":0,"value":" "},{"type":1,"value":"billingCycle"},{"type":0,"value":" (excluding taxes)"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.plan.label":[{"type":0,"value":"Plan"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.rovo-credits.label":[{"type":0,"value":"Rovo credits"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.rovo-credits.value":[{"type":1,"value":"quantity"},{"type":0,"value":" per user / month"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.title":[{"type":0,"value":"Subscription details"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subtitle":[{"type":0,"value":"Your free "},{"children":[{"type":1,"value":"trialLength"},{"type":0,"value":" trial"}],"type":8,"value":"b"},{"type":0,"value":" has started. "},{"type":1,"value":"offeringName"},{"type":0,"value":" gives you unlimited users and advanced features that help you:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.confluence":[{"type":0,"value":"Create and collaborate in one place"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.jira":[{"type":0,"value":"Start building better workflows"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.jpd":[{"type":0,"value":"Discover your next great product idea"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.loom":[{"type":0,"value":"Align your team without extra meetings"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.twc":[{"type":0,"value":"Sync work across teams, all in one place"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.partner.body.twc.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.partner.body.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new.partners":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-admin-button":[{"type":0,"value":"Add payment details"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-user":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.downgrade-to-free":[{"type":0,"value":"Add your payment details by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to continue using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" without any disruption. If you\u2019re under the user limit and don\u2019t add payment, you\u2019ll automatically switch to the Free plan at the end of your trial."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.twc.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption.grouped":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans.grouped":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences.grouped":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject.grouped":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details.grouped":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption.grouped":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans.grouped":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details.grouped":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-ccp-g.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you left them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.email.body.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you\\n\\t\\t\\t\\t\\t\\t\\t\\tleft them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information-next":[{"type":0,"value":"If you\u2019ve already settled the outstanding amount, you\u2019re all set. If not, settling it immediately will ensure uninterrupted service and prevent any future deactivations."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information.partner":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your customer\u2019s data and preferences will be as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.what\'s-next":[{"type":0,"value":"What\u2019s next"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription trial successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription trial."}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.subject.customerCompanyName":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.trial.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information":[{"type":0,"value":"When your trial ends, we\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information.partner":[{"type":0,"value":"When the trial ends, we\u2019ll charge the chosen payment method and send an invoice within 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.caption":[{"type":0,"value":"We\'ve reactivated your subscriptions"}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.details":[{"type":0,"value":"Your data and preferences are just as you left them, so your team can jump back in straight away."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.intro":[{"type":0,"value":"As requested, we\'ve reactivated "},{"type":1,"value":"numOfReactivatedSubscriptions"},{"type":0,"value":" subscriptions in the last 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.subject":[{"type":0,"value":"Your daily reactivations"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure your service continues smoothly, we\'ve moved you back on your previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription-change-plan":[{"type":0,"value":"Go to Manage subscription, then Change plan. "}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.payment-details-up-to-date":[{"type":0,"value":"Make sure your payment details are up to date."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users you have exceeds the user limit allowed on your updated plan. You can do this by heading to your Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure service continues smoothly, we\'ve changed the subscription back to its previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users exceeds the user limit allowed on the updated plan. You can do this from the Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.manage-subscription":[{"type":0,"value":"Ensure the payment details are up to date then manage the subscription in Partner Purchasing Center."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription changed"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-key":[{"type":0,"value":"Users:"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-value":[{"type":1,"value":"users"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.direct-customer-whats-next":[{"type":0,"value":"You can use your current plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.nonpause-billing-accepted-request":[{"type":0,"value":"We\'ve accepted your request to move your subscription from monthly to annual (auto-renewal) plan, which will start at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.nonpause-billing-caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-accepted-request":[{"type":0,"value":"You can use the current plan, but your partner would need to contact us for any modifications. "}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details":[{"children":[{"type":0,"value":"Subscription:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details-billing-partner":[{"children":[{"type":0,"value":"Atlassian billing partner:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"billingPartner"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.nonpause-billing-current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-accepted-request":[{"type":0,"value":"The customer can continue with the existing plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"The billing cycle for one of your customer\u2019s subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ve also informed your customer about the change."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-wont-billed":[{"type":0,"value":"Your customer won\'t be billed between the end of the current monthly billing cycle and the start of the annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.wont-billed.direct-customer-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.caption":[{"type":0,"value":"Your billing frequency will soon be changed"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.contact-us":[{"type":0,"value":"If you have any questions concerning this change, please contact us."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.request-to-change-bill-freq":[{"type":0,"value":"We received a request to change the billing frequency for your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.when-will-cycle-change":[{"type":0,"value":"We\u2019ll change your "},{"type":1,"value":"oldBillingCycleName"},{"type":0,"value":" subscription to "},{"type":1,"value":"newBillingCycleName"},{"type":0,"value":" subscription at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.message-template.email.subject":[{"type":0,"value":"Your request to change your billing frequency"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.email.dc.ubp-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.email.partner.ubp-enforcement":[{"type":0,"value":"Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.caption":[{"type":0,"value":"Welcome to the "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.charge-chosen-payment-method":[{"type":0,"value":"We\'ll charge your chosen payment method within 24 hours and send you a payment confirmation along with your invoice"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.caption":[{"type":0,"value":"Welcome to your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision":[{"type":0,"value":"If you decide that this isn\u2019t for you, "},{"type":1,"value":"content"},{"type":0,"value":" "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-multiple-offering":[{"type":0,"value":"you can change your plan from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-single-offering":[{"type":0,"value":"you can cancel anytime from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.great-news":[{"type":0,"value":"Great news \u2014 your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.how-addon-billed":[{"type":0,"value":"Find out more about "},{"type":1,"value":"manageAddonLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.manage-addon-link":[{"type":0,"value":"how add-ons are billed"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.on-pricing-plan":[{"type":0,"value":" on "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com/billing/partner-managed-subscriptions"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.caption":[{"type":0,"value":"Welcome to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision":[{"type":0,"value":"If your customer decides this isn\u2019t for them, they can "},{"type":1,"value":"content"},{"type":0,"value":" at any time from "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-multiple-offering":[{"type":0,"value":"change their plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-single-offering":[{"type":0,"value":"cancel the subscription"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.great-news":[{"type":0,"value":"Great news \u2014 "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription"},{"type":1,"value":"companyName"},{"type":0,"value":" is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.personal-information":[{"type":0,"value":"Remember - your invoice contains personal information such as your address and other billing admin details, so you should only share it with trusted sources."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan":[{"type":0,"value":"Change plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan-and-upgrade":[{"type":0,"value":" and upgrade your subscription. Don\u2019t forget to add your payment details so you can use "},{"type":1,"value":"productName"},{"type":0,"value":" without any interruptions."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.manage-subscription-button":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.no-payment-info":[{"type":0,"value":"Since we dont have your complete billing information, we moved you to the Free plan. You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" but with limited features."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.product-info":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is now on the Free plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.to-get-back-go-to":[{"type":0,"value":"Want to go back on the "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" plan? Select "}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.trial-has-ended":[{"type":0,"value":"Your "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" has ended. We hope you enjoyed it!"}],"commerce.commerce-subscription-transferred-ccp-g.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.can-now-manage":[{"type":0,"value":"You can now manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.uninterrupted-service":[{"type":0,"value":"To ensure uninterrupted access to your subscriptions, add your payment details before your bill end date."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can view and cancel the subscription by going to "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-from-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-to-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-from-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-to-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.can-not-manage":[{"type":0,"value":"You can no longer manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":". However, all the invoices up to the date of transfer are still available."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.caption":[{"type":0,"value":"Subscription removed from billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.product-transferred-info":[{"type":0,"value":"If you had any other product and subscriptions on the same site that belonged to the same product family,\\n\\t\\t\\tthey need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription from your Billing Account, "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.caption":[{"type":0,"value":"Subscription added to your billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.product-transferred-info":[{"type":0,"value":"If the billing account "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":" had any other product and subscriptions on the same site that belonged to the same product family, they need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\u2019ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-customer-billing-account.caption":[{"type":0,"value":"Subscription transferred to your billing account"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.trial-ended-message":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". Your paid plan has now started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.trial-ended-message":[{"type":0,"value":"The free "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended, and the paid period has started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge the chosen payment method and send you an invoice soon, along with the payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject.without-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.moved-back-old-plan":[{"type":0,"value":"The subscription will be moved back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan. You don\'t have to pay any additional charges for the trial period used as we continued your billing per your "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan while on trial. If you were initially on the Free plan, you won\'t be charged anything. "}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.subscription-opted-out-from-to":[{"type":0,"value":"As requested, we\'ve ended the no-cost "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial of the following product:"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"If needed, you can always restart the trial from our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial ended on request"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.trial-ended-message":[{"type":0,"value":"The no-cost "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.upgrade-offering-message":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" paid plan:"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"To view the subscription, visit our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.we-will-charge-message":[{"type":0,"value":"We\u2019ll charge you for a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with the payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan has started"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": No cost "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" trial period has ended"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.ba-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.bu-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.cancel":[{"type":0,"value":"If you decide this isn\u2019t for you, you can cancel your subscription before your trial ends by logging in to your account."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.on-trial":[{"type":0,"value":"Good news \u2014 you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.trial-auto-convert":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.subject":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.lets-make-it-official":[{"type":0,"value":"Let\u2019s make it official"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.time-flies":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is coming to an end"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.add-payment":[{"type":0,"value":"If you want to continue with the paid plan, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion":[{"type":0,"value":"If you want to continue, you don\u2019t need to do anything. When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off":[{"type":0,"value":"Your subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"You\u2019ll be moved back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.change-or-cancel-plan":[{"type":0,"value":"You can change or cancel your subscription before your trial ends by going to "},{"type":1,"value":"changePlanLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, we\u2019ll move you to the Free plan \u2014 as long as you meet the user limit requirements. If not, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.extend-trial":[{"type":0,"value":"If you\u2019d like to extend your trial, you\u2019ll need to contact us at "},{"type":1,"value":"salesOpsSupportEmail"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.scheduled-for-cancellation":[{"type":0,"value":"You can undo the cancellation by "},{"type":1,"value":"contactingUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end-twc":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial and your team\'s making the most of the increased collaboration."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.features.your-features-include":[{"children":[{"type":0,"value":"Your features include:"}],"type":8,"value":"b"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-body.end-of-trial-with-pde":[{"type":0,"value":"Your subscription begins on "},{"type":1,"value":"subscriptionStartDate"},{"type":0,"value":". Learn about your plan\u2019s features and see what they can do for you."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-caption.end-of-trial-with-pde":[{"type":0,"value":"Ready for your next chapter?"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off":[{"type":0,"value":"When the trial ends, the subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-upgrade-trial":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, the subscription will be moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and charged on the next bill date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.deactivate-if-payment-not-added":[{"type":0,"value":"To continue, add payment details (if you haven\u2019t already) before your trial ends to avoid deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"To continue with the paid plan, add payment details (if you haven\u2019t already) before your trial ends to avoid downgrading to the Free plan or deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.extend-trial":[{"type":0,"value":"To extend the trial, "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your customer\'s "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.scheduled-for-cancellation":[{"type":0,"value":"The trial is scheduled for cancellation. If your customer wants to undo the cancellation, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.intro":[{"type":0,"value":"Your trial will end in 3 days. Add your payment details now so you don\u2019t lose your features."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.refund-policy":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" Refund within 30 days of initial purchase if you change your mind."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.title":[{"type":0,"value":"Keep what\u2019s working for you"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.permissions":[{"type":0,"value":"You\u2019ll no longer be able to choose who can view, edit, or comment on pages."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat, or content help."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.whiteboards":[{"type":0,"value":"Whiteboards are great for planning and brainstorming, but Free only allows 3 per person."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.permissions":[{"type":0,"value":"You\u2019ll no longer be able to choose who can view, edit, or comment on pages."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat, or content help."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.users":[{"type":0,"value":"The user limit will drop from unlimited to 10 people."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.users.above-limit":[{"type":0,"value":"The user limit will drop to 10 people. You have "},{"type":1,"value":"userCount"},{"type":0,"value":" people, so your site may be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.permissions":[{"type":0,"value":"You won\u2019t be able to set rules on who can create, view, or comment on work items."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.plans":[{"type":0,"value":"Without cross-project plans, you won\u2019t be able to see status or problems across teams."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat or agents."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.permissions":[{"type":0,"value":"You won\u2019t be able to set rules on who can create, view, or comment on work items."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat or agents."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.users":[{"type":0,"value":"The user limit will drop from unlimited to 10 people."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.users.above-limit":[{"type":0,"value":"The user limit will drop to 10 people. You have "},{"type":1,"value":"userCount"},{"type":0,"value":" people, so your site may be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.roadmaps":[{"type":0,"value":"Cross-project roadmaps won\u2019t be available, so you can\u2019t see all ideas in one view."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat, or content help."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.view-restrictions":[{"type":0,"value":"You won\u2019t be able to control who can see, edit, or create views."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.published-view":[{"type":0,"value":"You won\u2019t be able to publish and share your plans with people unless they\u2019re signed in."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.storage":[{"type":0,"value":"Storage will drop from 250 GB to 2 GB, which will limit your ability to upload files."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.users":[{"type":0,"value":"The user limit will drop from unlimited to 3."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.users.above-limit":[{"type":0,"value":"The user limit will drop to 3 creators. You have "},{"type":1,"value":"userCount"},{"type":0,"value":" people, so your site may be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.add-payment":[{"type":0,"value":"Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.end-of-trial-with-pde":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.mpucup":[{"type":0,"value":"Payment required to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.mpucup.no-product-name":[{"type":0,"value":"Payment required to keep your subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.add-payment":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.trial-ends-soon":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.personalised-no-pde":[{"type":0,"value":"Don\u2019t lose your features - add payment details today"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.trial-ends-soon":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.add-payment-details-before-trial-ends":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\'t add payment details or reduce your user count to 10 or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.caption":[{"type":0,"value":"Add payment details to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.your-trial-ends-in-days":[{"type":0,"value":"Your free "},{"type":1,"value":"productName"},{"type":0,"value":" Standard trial ends in "},{"children":[{"type":0,"value":"3 days"}],"type":8,"value":"b"},{"type":0,"value":". Add payment details now to ensure your team has uninterrupted access."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.add-payment-details":[{"type":0,"value":"We noticed that we don\'t have your payment details on file. Add payment details before the renewal date to avoid any disruptions to your subscription."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.caption":[{"type":0,"value":"Your upcoming renewal"}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.payment-method-charged":[{"type":0,"value":"We\u2019ll charge your chosen payment method at this time. If you want to use a different payment method, update your details before the renewal date."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.renewal-reminder":[{"type":0,"value":"This is a friendly reminder that your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will renew on "},{"type":1,"value":"renewalDate"},{"type":0,"value":". Here are the details:"}],"commerce.commerce-subscription-upcoming-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription renews soon"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp.email.dc.ubp-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-ccp.email.partner.ubp-enforcement":[{"type":0,"value":"Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if you go over the included quantity or allowance for any of the usage types on your subscription, extra usage charges will be added to your next invoice. Organization admins can set and adjust usage limits anytime."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if your customer goes over the included quantity or allowance for any of the usage types on the subscription, extra usage charges will be added to their next invoice. You can set and adjust usage limits anytime."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-trial-extension-ad.created-date-bold.key":[{"type":0,"value":"Created date: "}],"commerce.commerce-trial-extension-ad.created-date-value":[{"type":1,"value":"createdDate"}],"commerce.commerce-trial-extension-ad.created-date.key":[{"type":1,"value":"createdDateKey"}],"commerce.commerce-trial-extension-ad.email.approved":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has approved the request."}],"commerce.commerce-trial-extension-ad.email.caption":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.email.declined":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has declined the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.default":[{"type":0,"value":"Your request for a trial extension has been received and is being processed."}],"commerce.commerce-trial-extension-ad.email.in-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" is the assignee of the approval request."}],"commerce.commerce-trial-extension-ad.email.reasons-provided":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has provided supporting reasons."}],"commerce.commerce-trial-extension-ad.email.reasons-requested":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has requested supporting reasons."}],"commerce.commerce-trial-extension-ad.email.request-cancelled":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has cancelled the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.waiting-for-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has submitted a new Trial Extension request."}],"commerce.commerce-trial-extension-ad.initiator-id-bold.key":[{"type":0,"value":"Initiator: "}],"commerce.commerce-trial-extension-ad.initiator-id-value":[{"type":1,"value":"initiator"}],"commerce.commerce-trial-extension-ad.initiator-id.key":[{"type":1,"value":"initiatorKey"}],"commerce.commerce-trial-extension-ad.message-template.email.subject":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id-bold.key":[{"type":0,"value":"Request ID: "}],"commerce.commerce-trial-extension-ad.request-id-value":[{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id.key":[{"type":1,"value":"requestIdKey"}],"commerce.commerce-trial-extension-ad.status-bold.key":[{"type":0,"value":"Status: "}],"commerce.commerce-trial-extension-ad.status-value":[{"type":1,"value":"status"}],"commerce.commerce-trial-extension-ad.status.key":[{"type":1,"value":"statusKey"}],"commerce.commerce-trial-extension-ad.subscription-bold.key":[{"type":0,"value":"Subscription: "}],"commerce.commerce-trial-extension-ad.subscription-value":[{"type":1,"value":"entitlementNumber"}],"commerce.commerce-trial-extension-ad.subscription.key":[{"type":1,"value":"subscriptionKey"}],"commerce.commerce-trial-extension-ad.support-ticket-id-bold.key":[{"type":0,"value":"Support Ticket: "}],"commerce.commerce-trial-extension-ad.support-ticket-id-value":[{"type":1,"value":"supportTicket"}],"commerce.commerce-trial-extension-ad.support-ticket-id.key":[{"type":1,"value":"supportTicketKey"}],"commerce.commerce-trial-extension-ad.total-trial-length-bold.key":[{"type":0,"value":"Total days on trial so far: "}],"commerce.commerce-trial-extension-ad.total-trial-length-value":[{"type":1,"value":"currentTotalTrialLength"}],"commerce.commerce-trial-extension-ad.total-trial-length.key":[{"type":1,"value":"totalTrialLengthKey"}],"commerce.commerce-trial-extension-ad.trial-length-bold.key":[{"type":0,"value":"Request: "}],"commerce.commerce-trial-extension-ad.trial-length-value":[{"type":0,"value":"Extend trial for "},{"type":1,"value":"netTrialDays"},{"type":0,"value":" days"}],"commerce.commerce-trial-extension-ad.trial-length.key":[{"type":1,"value":"requestKey"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.cta.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.disabled":[{"type":0,"value":"An admin has turned off extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on your organization."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.enabled":[{"type":0,"value":"An admin has turned on extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on your organization. If your organization goes over the extra usage limit, you\'ll receive a bill for extra usage incurred at the end of your bill cycle."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.limit-policy":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime. If your organization goes over the extra usage limit, you\'ll receive a bill for extra usage incurred at the end of your bill cycle."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.limit-set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your organization now allows monthly usage up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.subject.disabled":[{"type":0,"value":"Extra "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage has been turned off"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.subject.enabled":[{"type":0,"value":"Extra "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage has been turned on"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.policy":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime. If your organization allows extra usage above the allowance, at the end of the cycle, you\'ll receive a bill for extra usage incurred."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your organization now allows monthly usage up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.updated":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organisation. Your extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.updated.unlimited":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organisation. Your extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now unlimited."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.caption.set":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.caption.updated":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.subject.set":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.subject.updated":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.email.body.cta.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.policy":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime. If your customer\'s usage exceeds their allowance, at the end of the cycle, the bill will include extra charges incurred for any extra usage this cycle."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organization. They can now use up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.updated":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organisation. Your customer\'s extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.updated.unlimited":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organisation. Your customer\'s extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now unlimited."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.caption.set":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit has been set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.caption.updated":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit has been updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.set":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.set.without-company-name":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.updated":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.updated.without-company-name":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-write-off-email-ccp.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"commerce.commerce-write-off-email-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-write-off-email-ccp.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-write-off-email-ccp.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.commerce-write-off-email-ccp.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"commerce.commerce-write-off-email-ccp.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"commerce.commerce-write-off-email-ccp.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"commerce.commerce.commerce-ship-to-party-archival-ccp.email.body.caption":[{"type":1,"value":"name"},{"type":0,"value":": Sold to address deactivated"}],"commerce.common-ui.manage-subscription-from-ppc-homepage":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":"."}],"commerce.common-ui.ppc":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.common.atlassian-privacy-policy":[{"type":0,"value":"Atlassian Privacy Policy"}],"commerce.common.contact-us-to-talk-or-downgrade-to-free":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce.common.contact-your-bank-for-more-info":[{"type":0,"value":"Contact your bank if you need more information about the issue."}],"commerce.common.contacting-us":[{"type":0,"value":"contacting us"}],"commerce.common.data-retention-and-backup-policy":[{"type":0,"value":"data retention and backup policies"}],"commerce.common.data-storage-faqs":[{"type":0,"value":"Data Storage FAQs"}],"commerce.common.downgrade-to-a-free-plan":[{"type":0,"value":"downgrade to a free plan"}],"commerce.common.email.atl-logo.alt-text":[{"type":0,"value":"Atlassian logo"}],"commerce.common.email.billing-url":[{"type":1,"value":"url"}],"commerce.common.email.bitbucket-logo.alt-text":[{"type":0,"value":"Bitbucket logo"}],"commerce.common.email.compass-logo.alt-text":[{"type":0,"value":"Compass logo"}],"commerce.common.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.common.email.csm-logo.alt-text":[{"type":0,"value":"Customer Service Management logo"}],"commerce.common.email.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"commerce.common.email.guard-logo.alt-text":[{"type":0,"value":"Guard logo"}],"commerce.common.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.common.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.common.email.loom-logo.alt-text":[{"type":0,"value":"Loom logo"}],"commerce.common.email.rovo-dev-logo.alt-text":[{"type":0,"value":"Rovo Dev logo"}],"commerce.common.email.rovo-logo.alt-text":[{"type":0,"value":"Rovo logo"}],"commerce.common.email.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.common.email.talent-logo.alt-text":[{"type":0,"value":"Talent logo"}],"commerce.common.if-you-are-unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce.common.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.common.manage-subscription-document-link":[{"type":0,"value":"Manage your subscription for Standard and Premium plans"}],"commerce.common.subscriptiom-reactivation-link":[{"type":0,"value":"reactivate your subscription"}],"commerce.common.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.email.body.what-happens-if-your-customer-uses-extra":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.email.changed-your-mind":[{"type":0,"value":"Changed your mind?"}],"commerce.email.cms.learn-more":[{"type":0,"value":"Pay later by invoice."}],"commerce.email.dont-want-continue":[{"type":0,"value":"Don\'t want to continue with the subscription?"}],"commerce.email.dont-want-to-cancel":[{"type":0,"value":"Don\'t want to cancel?"}],"commerce.email.extra-usage-charge-for-metered-billing":[{"type":0,"value":"Remember, if the included quantity or allowance for any of the usage types on the subscription are exceeded each billing cycle, extra usage charges will be added to the next invoice. "},{"type":1,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.email.how-to":[{"type":0,"value":"How to pay your invoices"}],"commerce.email.included-products":[{"type":0,"value":"Included products:"}],"commerce.email.last-page":[{"type":0,"value":"The last page of your invoice includes Atlassian\u2019s account details and instructions on how to pay."}],"commerce.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"}],"commerce.email.list.payment-method":[{"type":0,"value":"Payment method: Pay later by invoice"}],"commerce.email.list.payment-terms":[{"type":0,"value":"Payment terms: "},{"type":1,"value":"netTermsDuration"}],"commerce.email.list.taxId":[{"type":1,"value":"identifierName"},{"type":0,"value":": "},{"type":1,"value":"id"}],"commerce.email.new-plan-includes":[{"type":0,"value":"Your new plan includes:"}],"commerce.email.payment-days":[{"type":0,"value":"You\u2019ll have "},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the order invoice date to send your payment to Atlassian. You can pay using bank transfer or ACH/check (U.S. banks). "}],"commerce.email.subscription-and-billing-support-url":[{"type":0,"value":"More about how billing works."}],"commerce.email.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.email.subscription-includes":[{"type":0,"value":"Your subscription includes:"}],"commerce.email.subscription-includes-quotes":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.email.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.email.teamwork-collection":[{"type":0,"value":"Teamwork Collection can make it easy for your whole organization to work more effectively together - "},{"type":1,"value":"findOut"},{"type":0,"value":"."}],"commerce.email.teamwork-collection.find-out":[{"type":0,"value":"find out more about Atlassian collections"}],"commerce.email.the.new-plan-includes":[{"type":0,"value":"The new plan includes:"}],"commerce.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.email.view-usage":[{"type":0,"value":"View usage"}],"commerce.email.want-to-keep your subscription":[{"type":0,"value":"Want to keep your subscription?"}],"commerce.email.what-do-i-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.email.what-do-you-need-to-do":[{"type":0,"value":"What you need to do:"}],"commerce.email.what-happens-when-trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.whats-next":[{"type":0,"value":"What\u2019s next?"}],"commerce.learn-more":[{"type":0,"value":"To learn more, see "},{"type":1,"value":"learnMore"}],"commerce.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce.message-template.email.explore-all-features-button.explore-all-features":[{"type":0,"value":"Explore all features"}],"commerce.message-template.email.features-list.confluence.premium.analytics":[{"children":[{"type":0,"value":"Analytics:"}],"type":8,"value":"b"},{"type":0,"value":" See who has viewed a page and when"}],"commerce.message-template.email.features-list.confluence.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.confluence.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.confluence.standard.page-insights":[{"children":[{"type":0,"value":"Page insights:"}],"type":8,"value":"b"},{"type":0,"value":" See engagement data, like page views"}],"commerce.message-template.email.features-list.confluence.standard.page-permissions":[{"children":[{"type":0,"value":"Page permissions:"}],"type":8,"value":"b"},{"type":0,"value":" Choose who can view, edit, and comment"}],"commerce.message-template.email.features-list.confluence.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jira.premium.cross-team-planning":[{"children":[{"type":0,"value":"Cross-team planning:"}],"type":8,"value":"b"},{"type":0,"value":" See all projects and timelines in one place"}],"commerce.message-template.email.features-list.jira.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your work and remove human error"}],"commerce.message-template.email.features-list.jira.standard.data-residency":[{"children":[{"type":0,"value":"Data residency:"}],"type":8,"value":"b"},{"type":0,"value":" Choose where your data is stored"}],"commerce.message-template.email.features-list.jira.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jpd.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jpd.premium.roadmaps":[{"children":[{"type":0,"value":"Roadmaps:"}],"type":8,"value":"b"},{"type":0,"value":" See multiple roadmaps in a single view"}],"commerce.message-template.email.features-list.jpd.premium.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jpd.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up work and reduce human error"}],"commerce.message-template.email.features-list.jpd.standard.published-views":[{"children":[{"type":0,"value":"Published views:"}],"type":8,"value":"b"},{"type":0,"value":" Share read-only views with anyone"}],"commerce.message-template.email.features-list.jpd.standard.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jsm.premium.ai-features":[{"children":[{"type":0,"value":"AI features:"}],"type":8,"value":"b"},{"type":0,"value":" AI-powered agents, search, and chat"}],"commerce.message-template.email.features-list.jsm.premium.change-automation":[{"children":[{"type":0,"value":"Change automation:"}],"type":8,"value":"b"},{"type":0,"value":" Gate deploys and automate record creation"}],"commerce.message-template.email.features-list.jsm.premium.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.jsm.standard.branded-help-center":[{"children":[{"type":0,"value":"Branded help center:"}],"type":8,"value":"b"},{"type":0,"value":" Use your company\'s branding and URLs"}],"commerce.message-template.email.features-list.jsm.standard.enhanced-support":[{"children":[{"type":0,"value":"Enhanced support:"}],"type":8,"value":"b"},{"type":0,"value":" Get business hour support from our experts"}],"commerce.message-template.email.features-list.jsm.standard.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.loom.business-ai.advanced-editing":[{"children":[{"type":0,"value":"Advanced editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim, stitch, remove silence and filler words"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.loom.business.editing":[{"children":[{"type":0,"value":"Editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim out mistakes or stitch multiple videos together"}],"commerce.message-template.email.features-list.loom.business.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.service-collection.premium.advanced-aiops":[{"children":[{"type":0,"value":"Advanced AIOps:"}],"type":8,"value":"b"},{"type":0,"value":" Fast alert grouping, incident creation, and more"}],"commerce.message-template.email.features-list.service-collection.premium.ai-agents":[{"children":[{"type":0,"value":"AI agents:"}],"type":8,"value":"b"},{"type":0,"value":" Save time and use AI for basic conversational support"}],"commerce.message-template.email.features-list.service-collection.premium.asset-management":[{"children":[{"type":0,"value":"Asset management:"}],"type":8,"value":"b"},{"type":0,"value":" Manage the lifecycle of assets and services"}],"commerce.message-template.email.features-list.service-collection.standard.ai-powered-agents":[{"children":[{"type":0,"value":"AI-powered agents:"}],"type":8,"value":"b"},{"type":0,"value":" Automate support, resolve requests faster"}],"commerce.message-template.email.features-list.service-collection.standard.custom-help-center":[{"children":[{"type":0,"value":"Custom help center:"}],"type":8,"value":"b"},{"type":0,"value":" Deliver a seamless support experience"}],"commerce.message-template.email.features-list.service-collection.standard.unlimited-emails":[{"children":[{"type":0,"value":"Unlimited emails:"}],"type":8,"value":"b"},{"type":0,"value":" Talk to customers as much as you need"}],"commerce.message-template.email.upgrade-benefits.compass.body.customizations":[{"type":0,"value":"More customizations"}],"commerce.message-template.email.upgrade-benefits.compass.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benefits.compass.body.reusable-templates":[{"type":0,"value":"20 reusable templates"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.agents-and-customers":[{"type":0,"value":"Up to 20,000 agents and unlimited customers"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.ai-powered-support":[{"type":0,"value":"AI-powered employee support, operations, and customer service"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.audit-logs-data-residency":[{"type":0,"value":"Audit logs and multi-region data residency"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.custom-help-center":[{"type":0,"value":"Custom-branded help center"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\'s team of experts"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.unlimited-email-notifications":[{"type":0,"value":"Unlimited email notifications"}],"commerce.message-template.email.upgrade-benifits.compass.body.storage":[{"type":0,"value":"One year of data retention"}],"commerce.message-template.email.upgrade-benifits.compass.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.confluence.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.confluence.body.page-analytics":[{"type":0,"value":"Page analytics"}],"commerce.message-template.email.upgrade-benifits.confluence.body.space-and-page-permissions":[{"type":0,"value":"Space and page permissions"}],"commerce.message-template.email.upgrade-benifits.confluence.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.confluence.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jira.body.create-issues":[{"type":0,"value":"Anonymous access to let external users view and create issues"}],"commerce.message-template.email.upgrade-benifits.jira.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jira.body.issue-permissions":[{"type":0,"value":"Advanced project and issue permissions"}],"commerce.message-template.email.upgrade-benifits.jira.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jira.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.message-template.email.upgrade-benifits.jpd.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jpd.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.message-template.email.upgrade-benifits.jsm.body.automation-rules-per-month":[{"type":0,"value":"500 project automation rules per month"}],"commerce.message-template.email.upgrade-benifits.jsm.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jsm.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jsm.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jsm.body.track-changes":[{"type":0,"value":"Audit logs to troubleshoot and track changes"}],"commerce.message-template.next-steps":[{"type":0,"value":"Next steps:"}],"commerce.message-template.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.next-bill-estimate-common.key":[{"type":0,"value":"Next estimated bill (prorated):"}],"commerce.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.partner-name.key":[{"type":0,"value":"Atlassian billing partner:"}],"commerce.partner-name.value":[{"type":1,"value":"partnerName"}],"commerce.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n    \\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days."}],"commerce.requested-by-common.key":[{"type":0,"value":"Requested by:"}],"commerce.requested-by-common.value":[{"type":1,"value":"orderPlacedBy"}],"commerce.requested-by-common.value-with-email":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"emailLink"},{"type":0,"value":")"}],"commerce.requested-by-common.value-without-email":[{"type":1,"value":"name"}],"commerce.reseller-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from the "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":" page."}],"commerce.reseller-manage-subscriptions-subscription-overview":[{"type":0,"value":"Subscription overview"}],"commerce.servco-post-auto-uplift-email-notification.email.banner-alt":[{"type":0,"value":"Service Collection"}],"commerce.servco-post-auto-uplift-email-notification.email.button-v2":[{"type":0,"value":"See details"}],"commerce.servco-post-auto-uplift-email-notification.email.csm-label":[{"type":0,"value":"Customer Service Management"}],"commerce.servco-post-auto-uplift-email-notification.email.heading":[{"type":0,"value":"Jira Service Management is now part of Service Collection"}],"commerce.servco-post-auto-uplift-email-notification.email.help-message":[{"type":0,"value":"If you have any questions or need assistance exploring the new features, please don\'t hesitate to reach out."}],"commerce.servco-post-auto-uplift-email-notification.email.intro":[{"type":0,"value":"We\'re excited to announce that as of "},{"type":1,"value":"month"},{"type":0,"value":" "},{"type":1,"value":"day"},{"type":0,"value":", "},{"type":1,"value":"year"},{"type":0,"value":", your Jira Service Management has become part of Service Collection. Try the new Customer Service Management app and enjoy extra features, with no changes to your Jira Service Management."}],"commerce.servco-post-auto-uplift-email-notification.email.jsm-label":[{"type":0,"value":"JSM"}],"commerce.servco-post-auto-uplift-email-notification.email.jsm-label.v2":[{"type":0,"value":"Jira Service Management"}],"commerce.servco-post-auto-uplift-email-notification.email.new-app-label":[{"type":0,"value":"New app"}],"commerce.servco-post-auto-uplift-email-notification.email.on-your-entitlement":[{"type":0,"value":"On your entitlement:"}],"commerce.servco-post-auto-uplift-email-notification.email.received-because":[{"type":0,"value":"You received this email because you\'re an admin for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"commerce.servco-post-auto-uplift-email-notification.email.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Administration."}],"commerce.servco-post-auto-uplift-email-notification.message-template.email.subject":[{"type":0,"value":"Jira Service Management has moved to Service Collection"}],"commerce.ship-to-information.address-key":[{"type":0,"value":"Address:"}],"commerce.ship-to-information.address-value":[{"type":1,"value":"soldToAddress"}],"commerce.ship-to-information.company-name-key":[{"type":0,"value":"Company:"}],"commerce.ship-to-information.company-name-key-alt-customer":[{"type":0,"value":"Customer:"}],"commerce.ship-to-information.company-name-value":[{"type":1,"value":"soldToCompanyName"}],"commerce.ship-to-information.end-customer-contact-key":[{"type":0,"value":"Customer contact:"}],"commerce.ship-to-information.end-customer-contact-value":[{"type":1,"value":"endCustomerContacts"}],"commerce.ship-to-information.invoice-number-key":[{"type":0,"value":"Invoice number:"}],"commerce.ship-to-information.invoice-number-value":[{"type":1,"value":"invoiceNumber"}],"commerce.subscription-common.entitlement-details":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-with-org-name":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") | "},{"type":1,"value":"orgName"}],"commerce.subscription-common.entitlement-details-with-site-url":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteURL"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-without-orgName":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.key":[{"type":0,"value":"Subscription:"}],"commerce.subscription-common.new-quote-total-key":[{"type":0,"value":"New quote total:"}],"commerce.subscription-common.old-quote-total-key":[{"type":0,"value":"Old quote total:"}],"commerce.subscription-common.quote-number-key":[{"type":0,"value":"Quote:"}],"commerce.subscription-common.quote-number-value":[{"type":1,"value":"quoteNumber"}],"commerce.subscription-common.quote-total-key":[{"type":0,"value":"Quote total:"}],"commerce.subscription-common.quote-total-value":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amount"}],"commerce.subscription-common.value-with-offering":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-offering-without-entitlement":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"commerce.subscription-common.value-with-pricing-plan":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"pricingPlanName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-product":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"commerce.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"common.cloud-payment-retry-actions.admin-hub-url":[{"type":0,"value":"admin.atlassian.com"}],"common.cloud-payment-retry-actions.atlassian-administration":[{"type":0,"value":"Atlassian administration"}],"common.cloud-payment-retry-actions.billing-console-url":[{"type":0,"value":"admin.atlassian.com/billing"}],"common.cloud-payment-retry-actions.billing-overview":[{"type":0,"value":"Billing overview"}],"common.cloud-payment-retry-actions.change-plan":[{"type":0,"value":"Change plan"}],"common.cloud-payment-retry-actions.contact-supportt":[{"type":0,"value":"If you need to speak to our team, you may "},{"type":1,"value":"element"},{"type":0,"value":" to the Atlassian Support Team."}],"common.cloud-payment-retry-actions.contact-us-heading":[{"type":0,"value":"Contact us:"}],"common.cloud-payment-retry-actions.data-storage-faq":[{"type":0,"value":"Data Storage FAQs"}],"common.cloud-payment-retry-actions.downgrade-heading":[{"type":0,"value":"Downgrade to a Free plan:"}],"common.cloud-payment-retry-actions.export-data":[{"type":0,"value":"We advise you to export your business data from your Atlassian instance. For more information, see our "},{"type":1,"value":"element"}],"common.cloud-payment-retry-actions.export-data-heading":[{"type":0,"value":"Export your data:"}],"common.cloud-payment-retry-actions.free":[{"type":0,"value":"Free"}],"common.cloud-payment-retry-actions.free-plan-change":[{"type":0,"value":"Change to the Free plan at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"billingOverview"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" in the "},{"type":1,"value":"subscriptions"},{"type":0,"value":" section. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" for your product. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"planChange"},{"type":0,"value":". Select the "},{"type":1,"value":"free"},{"type":0,"value":" plan and confirm"}],"common.cloud-payment-retry-actions.here-are-actions":[{"type":0,"value":"Here are some actions we suggest you take:"}],"common.cloud-payment-retry-actions.manage":[{"type":0,"value":"Manage"}],"common.cloud-payment-retry-actions.manage-users":[{"type":0,"value":"Manage users"}],"common.cloud-payment-retry-actions.reduce-users":[{"type":0,"value":"If applicable, you\'ll first need to reduce users to 10 or fewer (three agents or fewer for Jira Service Management). Go to your site\'s admin at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"admin"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":". Find users you want to remove, and select "},{"type":1,"value":"showDetails"},{"type":0,"value":"."}],"common.cloud-payment-retry-actions.show-details":[{"type":0,"value":"Show details &gt; Actions &gt; Remove user"}],"common.cloud-payment-retry-actions.submit-ticket":[{"type":0,"value":"Submit a ticket"}],"common.cloud-payment-retry-actions.subscription-details":[{"type":0,"value":"Subscription details"}],"common.cloud-payment-retry-actions.subscriptions":[{"type":0,"value":"Subscriptions"}],"common.cloud-payment-retry-actions.what-if-unable":[{"type":0,"value":"What if I\'m unable to make payments?"}],"common.invoice.manage-subscriptions.partner-info":[{"type":0,"value":"To manage subscriptions, visit our Partner Purchasing Center (PPC)."}],"common.invoice.manage-subscriptions.subscription-info":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"post-office.commerce-access-invalid-payment-hams.caption":[{"type":0,"value":"Action needed: Retry your payment with 3DS authentication"}],"post-office.commerce-access-invalid-payment-hams.error-message.access":[{"type":0,"value":"We couldn\u2019t process your payment for Atlassian Access since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.bitbucket":[{"type":0,"value":"We couldn\u2019t process your payment for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.cloud":[{"type":0,"value":"We couldn\'t process your payment for Atlassian Cloud since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.server":[{"type":0,"value":"We couldn\u2019t process your payment for "},{"type":1,"value":"productInfoString"},{"type":0,"value":" since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.retry-button":[{"type":0,"value":"Retry Payment"}],"post-office.commerce-access-invalid-payment-hams.retry-message":[{"type":0,"value":"Please retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or asked to authenticate in a different way."}],"post-office.commerce-common.Contact-us":[{"type":0,"value":"Contact us"}],"post-office.commerce-common.atlassian-support-team":[{"type":0,"value":"Atlassian Support Team"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.label":[{"type":0,"value":"Plan"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.value":[{"type":1,"value":"productName"},{"type":0,"value":" Standard ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" user"}]},"other":{"value":[{"type":7},{"type":0,"value":" users"}]}},"pluralType":"cardinal","type":6,"value":"userCount"},{"type":0,"value":")"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.value.no-user-count":[{"type":1,"value":"productName"},{"type":0,"value":" Standard"}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.heading":[{"type":0,"value":"Not ready to upgrade?"}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.switch-back-to-free-admin":[{"type":0,"value":"You can switch back to a Free plan by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"link"},{"type":0,"value":" to 10 or fewer."}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.switch-back-to-free-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan by reducing your user count to 10 or fewer."}],"post-office.commerce-common.blocks.regards":[{"type":0,"value":"Regards,"}],"post-office.commerce-common.blocks.thanks":[{"type":0,"value":"Thanks,"}],"post-office.commerce-common.cheers":[{"type":0,"value":"Cheers,"}],"post-office.commerce-common.cheers.from-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.cheers.from-atlassians":[{"type":0,"value":"The Atlassians"}],"post-office.commerce-common.choose-plan-link":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.choose-plan.billing-console":[{"type":0,"value":"Keep Premium plan"}],"post-office.commerce-common.choose-plan.choose-plan.billing-console":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.consumption.included-quantity-details":[{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"includedQuantityUnit"}],"post-office.commerce-common.consumption.summary-included-quantity":[{"type":0,"value":"Included quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity":[{"type":0,"value":"Consumed quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity-details":[{"type":1,"value":"consumedQuantity"},{"type":0,"value":" "},{"type":1,"value":"consumedQuantityUnit"}],"post-office.commerce-common.consumptionl.summary.consumption-percentage":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% consumed"}],"post-office.commerce-common.contact-support-button.partner":[{"type":0,"value":"Contact Support"}],"post-office.commerce-common.contact-us":[{"type":0,"value":"contact us"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian Jira"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-confluence":[{"type":0,"value":"Atlassian Confluence"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-product-discovery":[{"type":0,"value":"Atlassian Jira Product Discovery"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-service-management":[{"type":0,"value":"Atlassian Jira Service Management"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-loom":[{"type":0,"value":"Atlassian Loom"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-service-collection":[{"type":0,"value":"Atlassian Service Collection"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt":[{"type":0,"value":"Atlassian Jira"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-confluence":[{"type":0,"value":"Atlassian Confluence"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-jira-product-discovery":[{"type":0,"value":"Atlassian Jira Product Discovery"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-loom":[{"type":0,"value":"Atlassian Loom"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-teamwork-collection":[{"type":0,"value":"Atlassian Teamwork Collection"}],"post-office.commerce-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.email.plan-section.description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" 30-day money back guarantee if you forget to cancel."}],"post-office.commerce-common.email.plan-section.explore-plan.link-description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Explore all plans \u2192"}],"type":8,"value":"b"}],"post-office.commerce-common.email.subscription-details-section.billing-cycle-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Billing cycle"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-subtitle.end-of-trial-with-pde":[{"type":0,"value":"First bill estimate"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-suffix.end-of-trial-with-pde":[{"type":0,"value":" (Excludes taxes)"}],"post-office.commerce-common.email.subscription-details-section.plan-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Plan"}],"post-office.commerce-common.email.subscription-details-section.title.end-of-trial-with-pde":[{"type":0,"value":"Subscription details"}],"post-office.commerce-common.email.subscription-details-section.trial-ends-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Trial ends"}],"post-office.commerce-common.email.subscription.deactivate-consequence-section.deactivate-info":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\u2019t add payment details or reduce your user count to "},{"type":1,"value":"ceiling"},{"type":0,"value":" or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"post-office.commerce-common.email.subscription.deactivate-consequence-section.what-to-do-question":[{"type":0,"value":"What do I need to do?"}],"post-office.commerce-common.email.subscription.description.end-of-trial-with-pde":[{"type":0,"value":"When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"post-office.commerce-common.email.subscription.downgrade-consequence-section.downgrade-info":[{"type":0,"value":"If you don\u2019t add payment details you\u2019ll downgrade to the Free plan and lose access to your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan features."}],"post-office.commerce-common.email.subscription.downgrade-consequence-section.features-question":[{"type":0,"value":"Which other features will I lose access to?"}],"post-office.commerce-common.email.subscription.headline.end-of-trial-with-pde":[{"type":0,"value":"You don\'t need to do anything"}],"post-office.commerce-common.email.subscription.other-features-you-lose.confluence-premium":[{"type":0,"value":"Comparison between Premium and Free plans. Key differences are unlimited whiteboards, page insights, and access to Rovo on Premium."}],"post-office.commerce-common.email.subscription.other-features-you-lose.confluence-standard":[{"type":0,"value":"Comparison between Standard and Free plans. Key differences are unlimited users, page insights, and access to Rovo on Standard."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jira-premium":[{"type":0,"value":"Comparison between Premium and Free plans. Key differences are plans for multiple projects, ability to assign roles, and access to Rovo on Premium."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jira-standard":[{"type":0,"value":"Comparison between Standard and Free plans. Key differences are unlimited users, ability to assign roles, and access to Rovo on Standard."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jpd-premium":[{"type":0,"value":"Comparison between Premium and Free plans. Key differences are roadmaps for multiple spaces, ability to assign roles, and access to Rovo on Premium."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jpd-standard":[{"type":0,"value":"Comparison between Standard and Free plans. Key differences are unlimited users and ability to assign roles on Standard."}],"post-office.commerce-common.email.subscription.payment-details.keep-your-plan":[{"type":0,"value":"Keep "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"post-office.commerce-common.email.subscription.tick-circle-green-icon.end-of-trial-with-pde":[{"type":0,"value":"Green tick circle icon for the billing section"}],"post-office.commerce-common.features-image.confluence-premium":[{"type":0,"value":"Confluence Premium Features"}],"post-office.commerce-common.features-image.confluence-standard":[{"type":0,"value":"Confluence Standard Features"}],"post-office.commerce-common.features-image.jira-premium":[{"type":0,"value":"Jira Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-premium":[{"type":0,"value":"Jira Product Discovery Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-standard":[{"type":0,"value":"Jira Product Discovery Standard Features"}],"post-office.commerce-common.features-image.jira-service-management-premium":[{"type":0,"value":"Jira Service Management Premium Features"}],"post-office.commerce-common.features-image.jira-service-management-standard":[{"type":0,"value":"Jira Service Management Standard Features"}],"post-office.commerce-common.features-image.jira-standard":[{"type":0,"value":"Jira Standard Features"}],"post-office.commerce-common.features-image.loom-business":[{"type":0,"value":"Loom Business Features"}],"post-office.commerce-common.features-image.loom-business-ai":[{"type":0,"value":"Loom Business + AI Features"}],"post-office.commerce-common.features-image.service-collection-premium":[{"type":0,"value":"Service Collection Premium Features"}],"post-office.commerce-common.features-image.service-collection-standard":[{"type":0,"value":"Service Collection Standard Features"}],"post-office.commerce-common.footer-v2.ai-disclaimer":[{"type":0,"value":"Some content in this email has been generated by AI."}],"post-office.commerce-common.footer-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer-v2.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer-v2.dot-separator":[{"type":0,"value":"\u2022"}],"post-office.commerce-common.footer-v2.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer-v2.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer-v2.footer-links.read-our-blog":[{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer-v2.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer-v2.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer-v2.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"post-office.commerce-common.footer-v2.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer-v2.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"post-office.commerce-common.footer-v2.x-alt-text":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.x-title":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.youtube-alt-text":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer-v2.youtube-title":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer.contact-us":[{"type":0,"value":" Contact us \u2022 "}],"post-office.commerce-common.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer.footer-links.read-our-blog":[{"type":0,"value":" "},{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer.office-address.we-are-located-at":[{"type":0,"value":"We are located at "}],"post-office.commerce-common.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer.privacy-policy":[{"type":0,"value":"Privacy Policy \u2022 "}],"post-office.commerce-common.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer.twitter-alt-text":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.footer.twitter-title":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.formal-goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" with any questions, we\'re always happy to help."}],"post-office.commerce-common.formal-goodbye.contact-representative":[{"type":0,"value":"Contact your Atlassian representative if you have any questions."}],"post-office.commerce-common.formal-thank-you":[{"type":0,"value":"Thank you for taking action at your earliest convenience."}],"post-office.commerce-common.get-in-touch":[{"type":0,"value":"Have a question? We\'re here to help. "},{"type":1,"value":"getInTouchLink"}],"post-office.commerce-common.need-help-with-contact-us":[{"type":0,"value":"Need help with plans and billing? "},{"type":1,"value":"contactUs"}],"post-office.commerce-common.not-personal-greetings":[{"type":0,"value":"Hi,"}],"post-office.commerce-common.payment-details.add":[{"type":0,"value":"Add payment details"}],"post-office.commerce-common.payment-details.add.v2":[{"type":0,"value":"explore your plan options"}],"post-office.commerce-common.payment-details.update":[{"type":0,"value":"Update payment details"}],"post-office.commerce-common.personal-greetings":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"post-office.commerce-common.product.entitlement-number.billing-cycle":[{"type":0,"value":"Billing cycle: "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.product.entitlement-number.requested-by-email-id":[{"type":0,"value":"Requested by: "},{"type":1,"value":"requestedByEmailId"}],"post-office.commerce-common.product.entitlement-number.site-url.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"}]},"true":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"}]}},"type":5,"value":"hasSiteUrl"}],"post-office.commerce-common.product.entitlement-number.users-count":[{"type":1,"value":"chargeElement"},{"type":0,"value":"s: "},{"type":1,"value":"usersCount"}],"post-office.commerce-common.product.product-title.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"productName"}]},"true":{"value":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"offeringName"},{"type":0,"value":")"}]}},"type":5,"value":"hasOfferingName"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-asset-credits":[{"children":[{"type":0,"value":"Assets objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-asset-credits-with-unit":[{"children":[{"type":0,"value":"Assets objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-automation-credits":[{"children":[{"type":0,"value":"Automation steps:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-automation-credits-with-unit":[{"children":[{"type":0,"value":"Automation steps:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-build-time":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-build-time-with-unit":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-lfs-storage":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-lfs-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-network":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-network-with-unit":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-storage":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-csm-resolution":[{"children":[{"type":0,"value":"Customer Service Management AI agent resolutions:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-csm-resolution-with-unit":[{"children":[{"type":0,"value":"Customer Service Management AI agent resolutions:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-indexed-objects":[{"children":[{"type":0,"value":"Indexed objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-indexed-objects-with-unit":[{"children":[{"type":0,"value":"Indexed objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-rovo-dev-credits":[{"children":[{"type":0,"value":"Rovo credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-rovo-dev-credits-with-unit":[{"children":[{"type":0,"value":"Rovo credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-product-details.bill-estimate-and-currency":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"post-office.commerce-common.subscription-product-details.bill-estimate-title":[{"type":0,"value":"Total bill estimate"}],"post-office.commerce-common.subscription-product-details.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription-product-details.exclude-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscription-product-details.offering-name.user-size.billing-cycle.no-translate":[{"type":1,"value":"siteDetails"}],"post-office.commerce-common.subscription-product-details.product-name.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription-product-details.site-url.no-translate":[{"type":1,"value":"siteURL"}],"post-office.commerce-common.subscription.atlassian-guard-standard":[{"type":0,"value":"Atlassian Guard Standard"}],"post-office.commerce-common.subscription.atlassian-rovo":[{"type":0,"value":"Atlassian Rovo"}],"post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits":[{"type":0,"value":"Assets objects: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits-with-unit":[{"type":0,"value":"Assets objects: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits":[{"type":0,"value":"Automation steps: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits-with-unit":[{"type":0,"value":"Automation steps: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time-with-unit":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage-with-unit":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network-with-unit":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage-with-unit":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution":[{"type":0,"value":"Customer Service Management AI agent resolutions: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution-with-unit":[{"type":0,"value":"Customer Service Management AI agent resolutions: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects":[{"type":0,"value":"Indexed objects: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects-with-unit":[{"type":0,"value":"Indexed objects: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits":[{"type":0,"value":"Rovo credits: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits-with-unit":[{"type":0,"value":"Rovo credits: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-charge-element-package-network":[{"children":[{"type":0,"value":"Network traffic:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-package-storage":[{"children":[{"type":0,"value":"Package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-rovo-dev-credits":[{"children":[{"type":0,"value":"Rovo Dev credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" credits per user"}],"post-office.commerce-common.subscription.cbp-charge-element-runners":[{"children":[{"type":0,"value":"Pipeline runners:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage":[{"children":[{"type":0,"value":"Storage (Git LFS):"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage-minutes":[{"children":[{"type":0,"value":"Build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.free-access":[{"type":0,"value":"Free access to:"}],"post-office.commerce-common.subscription.included-apps":[{"type":0,"value":"Included apps:"}],"post-office.commerce-common.subscription.pooled-allocation.per-user-month":[{"type":1,"value":"credits"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" per user/month"}],"post-office.commerce-common.subscription.product-title.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.address.no-translate":[{"type":0,"value":"Address: "},{"type":1,"value":"address"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.company.no-translate":[{"type":0,"value":"Company: "},{"type":1,"value":"companyName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.customer-contact.no-translate":[{"type":0,"value":"Customer contact: "},{"type":1,"value":"customerContact"}],"post-office.commerce-common.subscription.product.billing-cycle.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.subscription.product.billing-user-partner-contextual-info.partner-name.no-translate":[{"type":0,"value":"Atlassian billing partner: "},{"type":1,"value":"billingPartner"}],"post-office.commerce-common.subscription.product.charge quantities.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"usageQuantity"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":"s "}],"post-office.commerce-common.subscription.product.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription.product.offering-name.no-translate":[{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"post-office.commerce-common.subscription.product.site-url.no-translate":[{"type":1,"value":"siteUrl"}],"post-office.commerce-common.subscription.rovo-dev-credit-allocation.per-user":[{"type":1,"value":"credits"},{"type":0,"value":" Rovo Dev credits per user"}],"post-office.commerce-common.subscriptions-change-plan":[{"type":0,"value":"Subscriptions"}],"post-office.commerce-common.subscriptions.excludes-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscriptions.this-payment-is-for":[{"type":0,"value":"This payment is for:"}],"post-office.commerce-common.subscriptions.total-bill-estimate":[{"type":0,"value":"Total bill estimate:"}],"post-office.commerce-common.subscriptions.total-bill-estimate-after-trial":[{"type":0,"value":"Total bill estimate after trial ends:"}],"post-office.commerce-common.subscriptions.your-estimated-bill-is":[{"type":0,"value":"Your estimated bill is:"}],"post-office.commerce-common.the-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.view-subscription.billing-console":[{"type":0,"value":"View subscription"}],"post-office.commerce-decoupled-offering-ccp.button.review-bill":[{"type":0,"value":"Review your new bill"}],"post-office.commerce-decoupled-offering-ccp.marketplace-details-guide":[{"type":0,"value":"how Marketplace apps are billed"}],"post-office.commerce-order-fulfilled-ccp.email.billing-account.other-host-type":[{"type":0,"value":"billing account"}],"post-office.commerce-order-fulfilled-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-ccp.email.cmk.support-url":[{"type":0,"value":"page"}],"post-office.commerce-order-fulfilled-ccp.email.direct-customer.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-ccp.email.siteAdmin.cloud":[{"type":0,"value":"site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"}],"post-office.commerce-order-fulfilled-ccp.email.support-url":[{"type":0,"value":"billing support"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.siteAdmin":[{"type":0,"value":"Administration"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.support-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.view-quote-url":[{"type":0,"value":"Learn more"}],"post-office.commerce-payment-failure-hams.email.support.additional_actions":[{"type":0,"value":"additional actions"}],"post-office.commerce-payment-failure-hams.email.title.check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.expiration":[{"type":0,"value":"This doesn\'t have to be a goodbye"}],"post-office.commerce-payment-failure-hams.email.title.expired":[{"type":0,"value":"Your Atlassian subscription has expired"}],"post-office.commerce-payment-failure-hams.email.title.make-it-official":[{"type":0,"value":"Let\'s make it official!"}],"post-office.commerce-payment-failure-hams.email.title.trial-check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.trial-end":[{"type":0,"value":"Your trial has ended. What\'s next?"}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.email.partner.set-up":[{"type":0,"value":"set up the collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.direct-customer.set-up":[{"type":0,"value":"set up your collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.partner.set-up":[{"type":0,"value":"sets up the collection"}],"post-office.commerce.star-email-template.body.agent-limit":[{"type":0,"value":"Get "},{"children":[{"type":0,"value":"unlimited agents"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"250 GB file storage"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.ai-triage":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"AI"}],"type":8,"value":"b"},{"type":0,"value":" to triage requests from portal, email, and chat"}],"post-office.commerce.star-email-template.body.ai-written-support":[{"type":0,"value":"Power your Rovo agent with "},{"children":[{"type":0,"value":"AI written support articles"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.assets":[{"type":0,"value":"Track business "},{"children":[{"type":0,"value":"assets"}],"type":8,"value":"b"},{"type":0,"value":" and link them to work items"}],"post-office.commerce.star-email-template.body.auto":[{"type":0,"value":"You\'ve reached the agent limit for your Free plan, so we\'ve upgraded you to our "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of the "},{"children":[{"type":0,"value":"Standard"}],"type":8,"value":"b"},{"type":0,"value":" plan."}],"post-office.commerce.star-email-template.body.auto.change-your-mind":[{"type":0,"value":"If you change your mind, get refunded in the first 30 days of your purchase. You can also "},{"children":[{"type":0,"value":"cancel or switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime by reducing your agent count."}],"post-office.commerce.star-email-template.body.auto.storage":[{"type":0,"value":"You\'ve reached the 2 GB storage limit for your Free plan, so we\'ve upgraded you to our "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of the "},{"children":[{"type":0,"value":"Standard"}],"type":8,"value":"b"},{"type":0,"value":" plan."}],"post-office.commerce.star-email-template.body.billing-date-with-pde":[{"type":0,"value":"You won\'t be charged until your next billing date on "},{"children":[{"type":1,"value":"nextBillTimestamp"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"post-office.commerce.star-email-template.body.billing-date-without-pde":[{"type":0,"value":"To continue with Standard, add payment details by "},{"children":[{"type":1,"value":"nextBillTimestamp"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"post-office.commerce.star-email-template.body.direct":[{"type":0,"value":"You\'re currently on a "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":". Dive in to manage requests, incidents, changes and assets. All in one place, with the power of AI."}],"post-office.commerce.star-email-template.body.manual":[{"type":0,"value":"Enjoy your "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":" with brand new benefits like AI, Assets, higher automation limits and unlimited agents."}],"post-office.commerce.star-email-template.body.manual-direct.change-your-mind":[{"type":0,"value":"If you change your mind, get refunded in the first 30 days of your purchase. You can also "},{"children":[{"type":0,"value":"cancel or switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime."}],"post-office.commerce.star-email-template.body.rovo-ai-agents":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"Rovo AI agents"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.rovo-ai-agents-direct":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"AI agents"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.button.explore-standard-direct":[{"type":0,"value":"Explore your new service space"}],"post-office.commerce.star-email-template.button.explore-standard-manual-auto":[{"type":0,"value":"Explore Standard"}],"post-office.commerce.star-email-template.caption.add-payment-details-button":[{"type":0,"value":"Add Payment Details"}],"post-office.commerce.star-email-template.caption.billing":[{"type":0,"value":"What happens to your billing?"}],"post-office.commerce.star-email-template.caption.heading.auto":[{"type":0,"value":"\uD83D\uDC4B Say hello to unlimited agents"}],"post-office.commerce.star-email-template.caption.heading.auto.storage":[{"type":0,"value":"\uD83D\uDC4B Say hello to more storage"}],"post-office.commerce.star-email-template.caption.heading.welcome.manual-direct":[{"type":0,"value":"\uD83C\uDF89 Welcome to Service Collection Standard"}],"post-office.commerce.star-email-template.link.explore-plans":[{"type":0,"value":"Explore all plans"}],"post-office.commerce.star-email-template.subject.auto-upgrade":[{"type":0,"value":"You\'ve been upgraded to our Standard plan - free for 14 days"}],"post-office.commerce.star-email-template.subject.direct-trial":[{"type":0,"value":"Welcome to your Service Collection "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan!"}],"post-office.commerce.star-email-template.subject.manual-trial":[{"type":0,"value":"Your "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialDaysLeft"},{"type":0,"value":" free trial of our "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has started"}],"post-office.commerce.star-email-template.subscription.excludes-taxes":[{"type":0,"value":"(Excludes Taxes)"}],"post-office.commerce.star-email-template.subscription.header":[{"type":0,"value":"Subscription Details"}],"post-office.commerce.star-email-template.subscription.header-no-payment":[{"type":0,"value":"Trial details"}],"post-office.commerce.star-email-template.subscription.included-apps":[{"type":0,"value":"Included apps:"}],"post-office.commerce.star-email-template.subscription.next-bill-date":[{"type":0,"value":"Next bill date"}],"post-office.commerce.star-email-template.subscription.next-bill-estimate":[{"type":0,"value":"Next bill estimate"}],"post-office.commerce.star-email-template.subscription.next-bill-estimate-no-payment":[{"type":0,"value":"Estimated first bill"}],"post-office.commerce.star-email-template.subscription.trial-end-date":[{"type":0,"value":"Trial ends"}],"post-office.commerce.star-email-template.subscription.users":[{"type":1,"value":"count"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"user"}]},"other":{"value":[{"type":0,"value":"users"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"post-office.star-email-template.email-header-alt":[{"type":0,"value":"Service Collection"}],"post-office.star-email-template.email-header-customer-service-management":[{"type":0,"value":"Customer Service Management"}],"post-office.star-email-template.email-header-jira-service-management":[{"type":0,"value":"Jira Service Management"}],"post-office.star-email-template.email-header-rovo":[{"type":0,"value":"Rovo"}],"post-office.star-email-template.email-header-subtitle":[{"type":0,"value":"Includes:"}],"post-office.star-email-template.footer.ai-disclaimer":[{"type":0,"value":"Some content in this email has been generated by AI."}],"post-office.star-email-template.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.star-email-template.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.star-email-template.footer.dot-separator":[{"type":0,"value":"\u2022"}],"post-office.star-email-template.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.star-email-template.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.star-email-template.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.star-email-template.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.star-email-template.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.star-email-template.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.star-email-template.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"post-office.star-email-template.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.star-email-template.footer.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"post-office.star-email-template.footer.x-alt-text":[{"type":0,"value":"X"}],"post-office.star-email-template.footer.x-title":[{"type":0,"value":"X"}],"post-office.star-email-template.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"post-office.star-email-template.footer.youtube-title":[{"type":0,"value":"Youtube"}]}');

});

parcelRegister("lnCdp", function(module, exports) {

let $f90963b6f59bf27f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f90963b6f59bf27f$var$load("fMM0W").then(()=>parcelRequire('2e3Ru'));

});

parcelRegister("eb1gR", function(module, exports) {

let $a52314250a699df4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a52314250a699df4$var$load("3Eh3Y").then(()=>parcelRequire('gkDnC'));

});

parcelRegister("5RIKb", function(module, exports) {

let $44549c2c5ec50afe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44549c2c5ec50afe$var$load("hUJ4u").then(()=>parcelRequire('fNRM8'));

});

parcelRegister("dovsn", function(module, exports) {

let $9c05eaebaa1526f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c05eaebaa1526f8$var$load("epSJY").then(()=>parcelRequire('2iK9l'));

});

parcelRegister("8ujMv", function(module, exports) {

let $62e0783f73bd716e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $62e0783f73bd716e$var$load("bLCoT").then(()=>parcelRequire('dIHua'));

});

parcelRegister("7uLNo", function(module, exports) {

let $575068fdd925a4c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $575068fdd925a4c3$var$load("9ChkX").then(()=>parcelRequire('dQRlT'));

});

parcelRegister("h5IDc", function(module, exports) {

let $c71586284ca5c822$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c71586284ca5c822$var$load("hU0gB").then(()=>parcelRequire('laEC1'));

});

parcelRegister("eqahM", function(module, exports) {

let $a7fb78eb831a98a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7fb78eb831a98a1$var$load("ibkLf").then(()=>parcelRequire('4Ti42'));

});

parcelRegister("gUfa2", function(module, exports) {

let $c4eda2f26b5cd8f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4eda2f26b5cd8f0$var$load("ilwVm").then(()=>parcelRequire('f9hOT'));

});

parcelRegister("fzoAJ", function(module, exports) {

let $b55d333c17e48c7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b55d333c17e48c7d$var$load("klVOv").then(()=>parcelRequire('2O82h'));

});

parcelRegister("bHHEy", function(module, exports) {

let $88559279cca4e865$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88559279cca4e865$var$load("iCSFT").then(()=>parcelRequire('elRIk'));

});

parcelRegister("1LZnU", function(module, exports) {

let $14a9cbeb14fe137c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $14a9cbeb14fe137c$var$load("fFwmN").then(()=>parcelRequire('bpioJ'));

});

parcelRegister("e5v3e", function(module, exports) {

let $a4199e6c3ef53710$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4199e6c3ef53710$var$load("lzYuB").then(()=>parcelRequire('18Lyj'));

});

parcelRegister("9nIBZ", function(module, exports) {

let $6d48de005396102e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d48de005396102e$var$load("4juqu").then(()=>parcelRequire('2iyEy'));

});

parcelRegister("26FpJ", function(module, exports) {

let $188c4444e4be4fbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $188c4444e4be4fbb$var$load("aH3js").then(()=>parcelRequire('2UazD'));

});

parcelRegister("4Gifa", function(module, exports) {

let $36893c791389fdbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $36893c791389fdbf$var$load("cWVaN").then(()=>parcelRequire('2tzo9'));

});

parcelRegister("gjCMe", function(module, exports) {

let $be0c7ff7f9cb33db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be0c7ff7f9cb33db$var$load("7ZMjf").then(()=>parcelRequire('gCfOe'));

});

parcelRegister("2uT7I", function(module, exports) {

let $1d19247ef646d984$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d19247ef646d984$var$load("cP5Vm").then(()=>parcelRequire('7z1Gc'));

});

parcelRegister("hvuuM", function(module, exports) {

let $034a04135217bf9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $034a04135217bf9c$var$load("jpsMP").then(()=>parcelRequire('cie0a'));

});

parcelRegister("hnBZg", function(module, exports) {

let $ca720d20820723d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca720d20820723d6$var$load("3Nesj").then(()=>parcelRequire('ipjdj'));

});

parcelRegister("7SJn9", function(module, exports) {

let $5bd0c58e6a37443d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bd0c58e6a37443d$var$load("jFE9F").then(()=>parcelRequire('f8XV3'));

});

parcelRegister("j05vz", function(module, exports) {

let $dd524a3c81b05553$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd524a3c81b05553$var$load("loRRx").then(()=>parcelRequire('d6uE7'));

});

parcelRegister("i0UGC", function(module, exports) {

let $d1d432cf25355ef9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1d432cf25355ef9$var$load("894iO").then(()=>parcelRequire('f5jiF'));

});

parcelRegister("7sBhv", function(module, exports) {

let $56e81137eb7b8dd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56e81137eb7b8dd9$var$load("8jC0S").then(()=>parcelRequire('j0e2J'));

});

parcelRegister("luKLP", function(module, exports) {

let $fa60adf38f6d04c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa60adf38f6d04c6$var$load("llNzy").then(()=>parcelRequire('9YxKt'));

});

parcelRegister("1eM5i", function(module, exports) {

let $0e6c65d4f95bca4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e6c65d4f95bca4d$var$load("3EOn7").then(()=>parcelRequire('53R9u'));

});

parcelRegister("5VqXr", function(module, exports) {

let $45072fd92e0a8f91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45072fd92e0a8f91$var$load("56IgT").then(()=>parcelRequire('7Mwv4'));

});

parcelRegister("aFL7V", function(module, exports) {

let $7c524a1e81ecec70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c524a1e81ecec70$var$load("iGnJK").then(()=>parcelRequire('414QG'));

});

parcelRegister("hADG6", function(module, exports) {

let $cce493b154339453$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cce493b154339453$var$load("2dTBo").then(()=>parcelRequire('56IBy'));

});

parcelRegister("h6zhf", function(module, exports) {

let $c73e5c7f9dfb532b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c73e5c7f9dfb532b$var$load("dJqBp").then(()=>parcelRequire('aBX1P'));

});

parcelRegister("gk800", function(module, exports) {

let $be24b8115ff66b7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be24b8115ff66b7b$var$load("4KjiR").then(()=>parcelRequire('5Wn3P'));

});

parcelRegister("8KsH5", function(module, exports) {

let $65e8e0a5fc18bebe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65e8e0a5fc18bebe$var$load("7o9PN").then(()=>parcelRequire('hzKad'));

});

parcelRegister("8gA9a", function(module, exports) {

let $604bdb5b98d25431$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $604bdb5b98d25431$var$load("9UQcb").then(()=>parcelRequire('c9I2t'));

});

parcelRegister("e3o5i", function(module, exports) {

let $a3b4072eb30c3a1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a3b4072eb30c3a1e$var$load("5sqYT").then(()=>parcelRequire('hmPR0'));

});

parcelRegister("2Zvud", function(module, exports) {

let $22d9b3cd6e322ced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $22d9b3cd6e322ced$var$load("jRTH1").then(()=>parcelRequire('ei2MK'));

});

parcelRegister("kMgxO", function(module, exports) {
module.exports = JSON.parse('{"Check out the support documentation for more details.":[{"type":0,"value":"Check out the support documentation for more details."}],"Dismiss":[{"type":0,"value":"Dismiss"}],"Looking to enhance the agent experience?":[{"type":0,"value":"Looking to enhance the agent experience?"}],"Not now":[{"type":0,"value":"Not now"}],"Show me":[{"type":0,"value":"Show me"}],"Show me the apps":[{"type":0,"value":"Show me the apps"}],"Upgrade options":[{"type":0,"value":"Upgrade options"}],"We\'ve curated a list for you of the best marketplace apps to boost agent productivity!":[{"type":0,"value":"We\'ve curated a list for you of the best marketplace apps to boost agent productivity!"}],"We\'ve made some changes to imports":[{"type":0,"value":"We\'ve made some changes to imports"}],"We\u2019re having trouble with your plan":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"We\u2019ve kept you on the Standard plan of Confluence for now.":[{"type":0,"value":"We\u2019ve kept you on the Standard plan of Confluence for now."}],"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users.":[{"type":0,"value":"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users."}],"confluence-3p-connector-nudge.action.connect":[{"type":0,"value":"Connect now"}],"confluence-3p-connector-nudge.action.learnMore":[{"type":0,"value":"Learn more"}],"confluence-3p-connector-nudge.description":[{"type":0,"value":"You\'ve been using "},{"type":1,"value":"providerName"},{"type":0,"value":". Connect it to get richer previews and better search."}],"confluence-3p-connector-nudge.error.generic.action.tryAgain":[{"type":0,"value":"Try again"}],"confluence-3p-connector-nudge.error.generic.description":[{"type":0,"value":"Try again or ask your admin for help."}],"confluence-3p-connector-nudge.error.generic.title":[{"type":0,"value":"We\'re having trouble connecting "},{"type":1,"value":"providerName"}],"confluence-3p-connector-nudge.error.unavailable.description":[{"type":0,"value":"Try using the "},{"type":1,"value":"providerName"},{"type":0,"value":" Smart Link to connect your account, or ask your admin for help."}],"confluence-3p-connector-nudge.error.unavailable.title":[{"type":0,"value":"We couldn\'t connect your app"}],"confluence-3p-connector-nudge.title":[{"type":0,"value":"Connect "},{"type":1,"value":"providerName"}],"feedback-collector.can-be-enrolled-label.text":[{"type":0,"value":"Atlassian can contact me about this feedback. See our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"feedback-collector.enroll-in-research-label.text":[{"type":0,"value":"I\'d like to help improve Atlassian products by joining the"},{"type":1,"value":"nbsp"},{"type":1,"value":"n"},{"type":1,"value":"t"},{"type":1,"value":"t"},{"children":[{"type":0,"value":"Atlassian Research Group"}],"type":8,"value":"enrollLink"}],"feedback-collector.feedback-title-details.component":[{"type":0,"value":"For help with billing or other issues, visit our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"documentation"}],"type":8,"value":"documentationLink"},{"type":1,"value":"nbsp"},{"type":0,"value":"or contact"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"support"}],"type":8,"value":"supportLink"}],"no-notifications-fallback.learn-more-link.text":[{"type":0,"value":"Learn more about this feature"}],"no-notifications-fallback.no-notifications.text":[{"type":0,"value":"Check back soon. No notifications yet."}],"notifications.error-fallback-error-reason.text":[{"type":0,"value":"We\'re unable to load notifications"}],"notifications.error-fallback-proposed-solution.text":[{"type":0,"value":"Refresh the page or try again later"}],"post-office-team.commerce-approvals-received-author-notification-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.commerce-approvals-received-author-notification-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office-team.confluence-recommended-following-feed.add-comment-button":[{"type":0,"value":"Comment"}],"post-office-team.confluence-recommended-following-feed.add-emoji-button-alt-text":[{"type":0,"value":"Add Emoji"}],"post-office-team.confluence-recommended-following-feed.ai-generated-content-icon-alt-text":[{"type":0,"value":"AI Generated Content"}],"post-office-team.confluence-recommended-following-feed.ai-use-disclaimer":[{"type":0,"value":"Uses AI. Verify results."}],"post-office-team.confluence-recommended-following-feed.ai-use-disclaimer-alt-text":[{"type":0,"value":"Information icon"}],"post-office-team.confluence-recommended-following-feed.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}],"post-office-team.confluence-recommended-following-feed.blog-icon":[{"type":0,"value":"Blog icon"}],"post-office-team.confluence-recommended-following-feed.clap-button-alt-text":[{"type":0,"value":"Clap"}],"post-office-team.confluence-recommended-following-feed.database-icon":[{"type":0,"value":"Database icon"}],"post-office-team.confluence-recommended-following-feed.email-unsubscribe-text":[{"children":[{"type":0,"value":"Update your email settings"}],"type":8,"value":"trackedLink"},{"type":0,"value":" to customize or stop receiving this email."}],"post-office-team.confluence-recommended-following-feed.email.body.hello":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.confluence-recommended-following-feed.email.body.summary":[{"type":0,"value":"Here are pages your team is reading, don\'t miss out on the conversation."}],"post-office-team.confluence-recommended-following-feed.email.ios-android-text":[{"type":0,"value":"Download the Confluence mobile app on "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"iosLink"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"androidLink"},{"type":0,"value":" to read notifications and comment on the go."}],"post-office-team.confluence-recommended-following-feed.email.privacy-policy-text":[{"type":0,"value":"This email was sent by Atlassian Confluence  \u2022  "},{"children":[{"type":0,"value":"Privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"post-office-team.confluence-recommended-following-feed.email.subject":[{"type":1,"value":"name"},{"type":0,"value":", your team is working on these pages -- join the conversation"}],"post-office-team.confluence-recommended-following-feed.email.subject.variant-a":[{"type":1,"value":"name"},{"type":0,"value":", "},{"type":1,"value":"pageTitle"},{"type":0,"value":" plus more pages your team is working on"}],"post-office-team.confluence-recommended-following-feed.header.confluence-icon.alt-text":[{"type":0,"value":"Confluence Icon"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted":[{"children":[{"type":1,"value":"firstUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"secondUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.no-comments":[{"type":0,"value":"Be the first to comment"}],"post-office-team.confluence-recommended-following-feed.no-reactions-text":[{"type":0,"value":"Be the first to react"}],"post-office-team.confluence-recommended-following-feed.number-of-comments":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comment"}]},"other":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comments"}]}},"pluralType":"cardinal","type":6,"value":"commentCount"}],"post-office-team.confluence-recommended-following-feed.number-of-users-reacted":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"reactionCount"}],"post-office-team.confluence-recommended-following-feed.owned-by":[{"type":0,"value":"Owned by "},{"type":1,"value":"ownerName"}],"post-office-team.confluence-recommended-following-feed.party-popper-button-alt-text":[{"type":0,"value":"Party Popper"}],"post-office-team.confluence-recommended-following-feed.read-more-link":[{"type":0,"value":"Read more"}],"post-office-team.confluence-recommended-following-feed.thumbs-up-button-alt-text":[{"type":0,"value":"Thumbs up"}],"post-office-team.confluence-recommended-following-feed.user-profile-picture-alt-text":[{"type":1,"value":"name"},{"type":0,"value":"\'s profile picture"}],"post-office-team.confluence-recommended-following-feed.whiteboard-icon":[{"type":0,"value":"Whiteboard icon"}],"post-office-team.email-with-tracking-links.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.email-with-tracking-links.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.email-with-tracking-links.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.email-with-tracking-links.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.email-with-tracking-links.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.email-with-tracking-links.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.email-with-tracking-links.test-message.email.confluence-link.text.no-translate":[{"type":0,"value":"Go to Confluence link"}],"post-office-team.email-with-tracking-links.test-message.email.jira-link.text.no-translate":[{"type":0,"value":"Go to Jira link"}],"post-office-team.email-with-tracking-links.test-message.email.trello-link.text.no-translate":[{"type":0,"value":"Go to Trello board"}],"post-office-team.push-msg-object-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.push-msg-object-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.push-msg-object-tracking.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office-team.push-msg-object-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.push-msg-object-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.push-msg-object-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.push-msg-object-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.push-msg-object-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office-team.test-audience-message-template.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.test-audience-message-template.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.test-audience-message-template.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.test-audience-message-template.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.test-audience-message-template.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.test-audience-message-template.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.test-audience-message-template.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office-team.test-message-groot.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.test-message-groot.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.test-message-groot.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.test-message-groot.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.test-message-groot.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.test-message-groot.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.test-message-groot.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.admin-hub.end-of-notifications.description":[{"type":0,"value":"That\'s all your notifications from the last 90 days"}],"post-office.live-nudge-demo.connecting.no-translate":[{"type":0,"value":"Connecting..."}],"post-office.live-nudge-demo.live-count.no-translate":[{"type":1,"value":"count"},{"type":0,"value":" live"}],"post-office.live-nudge-demo.main-heading.no-translate":[{"type":0,"value":"Live Nudge Demo Placement"}],"post-office.live-nudge-demo.subscription-error.no-translate":[{"type":0,"value":"Subscription Error!"}],"post-office.post-office-team-components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.post-office-team-components.email.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.post-office-team-components.email.footer.why-am-i-receiving-this-email":[{"type":0,"value":"You are receiving this email because this is an important message regarding your account and products you are using. You are not allowed to unsubscribe from this type of message."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.cta-link":[{"type":0,"value":"Get started"}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Help us improve messaging for Atlassian Admins! Answer a few short questions, and our\\n\\t\\t\\t\\t\\tResearch team will contact you for a 60-minute Zoom session if you qualify."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Share your experience for $120 USD"}],"post-office.post-office-team.push-msg-object-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.post-office-team.push-msg-object-tracking.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.post-office-team.test-message-dynamic-config-sets.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"test-messages.test-message-dynamic-config-sets.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-dynamic-config-sets.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"},{"type":0,"value":" for Dynamic Config Sets"}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"Click here to visit Atlassian"}],"test-messages.test-message-dynamic-config-sets.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("myuXu", function(module, exports) {

let $043cd0d6b068b9f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $043cd0d6b068b9f6$var$load("89k3K").then(()=>parcelRequire('Co4xy'));

});

parcelRegister("1Zl29", function(module, exports) {

let $172bcdd03699f684$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $172bcdd03699f684$var$load("i4TIz").then(()=>parcelRequire('iB0OS'));

});

parcelRegister("3ktao", function(module, exports) {

let $26c9dd3fa9151fea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26c9dd3fa9151fea$var$load("aJTUh").then(()=>parcelRequire('kVtQW'));

});

parcelRegister("aTDX5", function(module, exports) {

let $7eee080f84383ef6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7eee080f84383ef6$var$load("4UjsP").then(()=>parcelRequire('8SHH6'));

});

parcelRegister("gMxgr", function(module, exports) {

let $c37aeea100731088$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c37aeea100731088$var$load("eAMuS").then(()=>parcelRequire('4BKTu'));

});

parcelRegister("1Af9x", function(module, exports) {

let $1274e84305edc447$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1274e84305edc447$var$load("cgGsl").then(()=>parcelRequire('aA2px'));

});

parcelRegister("buXa0", function(module, exports) {

let $85f0630ff2417c67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85f0630ff2417c67$var$load("jCHho").then(()=>parcelRequire('j1D9P'));

});

parcelRegister("ccbpW", function(module, exports) {

let $8e0f7646ca409140$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e0f7646ca409140$var$load("V9B1k").then(()=>parcelRequire('8sTMU'));

});

parcelRegister("j434L", function(module, exports) {

let $de10c6d6aa84c266$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de10c6d6aa84c266$var$load("lHcdb").then(()=>parcelRequire('63U6R'));

});

parcelRegister("dMsU4", function(module, exports) {

let $a0862dacf79c82a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0862dacf79c82a2$var$load("8GdFF").then(()=>parcelRequire('usVdc'));

});

parcelRegister("jyRDE", function(module, exports) {

let $e3dacccf6d91b87b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3dacccf6d91b87b$var$load("1RIZj").then(()=>parcelRequire('79vH0'));

});

parcelRegister("9pglX", function(module, exports) {

let $6d932242d21b1165$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d932242d21b1165$var$load("6XajZ").then(()=>parcelRequire('5GSxA'));

});

parcelRegister("iozT6", function(module, exports) {

let $d6464e751b04691b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6464e751b04691b$var$load("h17IG").then(()=>parcelRequire('6fBb8'));

});

parcelRegister("dJrYt", function(module, exports) {

let $0294787994f85f03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0294787994f85f03$var$load("gr1Hg").then(()=>parcelRequire('2gvJk'));

});

parcelRegister("7B9fx", function(module, exports) {

let $588329e80ad5a2e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $588329e80ad5a2e6$var$load("ex9RG").then(()=>parcelRequire('aJCau'));

});

parcelRegister("7GCXU", function(module, exports) {

let $598aae54c1a009e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $598aae54c1a009e4$var$load("lpnZh").then(()=>parcelRequire('aWdCQ'));

});

parcelRegister("eDQJt", function(module, exports) {

let $aa8d9cc340d98eb8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa8d9cc340d98eb8$var$load("79K0y").then(()=>parcelRequire('lPJba'));

});

parcelRegister("h2jfy", function(module, exports) {

let $c6718e348de1e33f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c6718e348de1e33f$var$load("bi09N").then(()=>parcelRequire('7rjx9'));

});

parcelRegister("jFjcD", function(module, exports) {

let $e510bdeb2eda46ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e510bdeb2eda46ca$var$load("iwWXu").then(()=>parcelRequire('4Qx3O'));

});

parcelRegister("2pDy6", function(module, exports) {

let $1c1c982ff7628e88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c1c982ff7628e88$var$load("coHip").then(()=>parcelRequire('b85cr'));

});

parcelRegister("7ef6d", function(module, exports) {

let $54358d9f2fefdd1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54358d9f2fefdd1d$var$load("kiUGs").then(()=>parcelRequire('hEjEd'));

});

parcelRegister("na8Hk", function(module, exports) {

let $045a038c67b9402f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $045a038c67b9402f$var$load("aHmyu").then(()=>parcelRequire('kMiOr'));

});

parcelRegister("cgktE", function(module, exports) {

let $8ed6dd0957798f4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ed6dd0957798f4a$var$load("1vP6v").then(()=>parcelRequire('9znD6'));

});

parcelRegister("1I6NP", function(module, exports) {

let $13ef2d5ab0911d26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $13ef2d5ab0911d26$var$load("aO2Db").then(()=>parcelRequire('96Dop'));

});

parcelRegister("9BVla", function(module, exports) {

let $6ff40c6264893904$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ff40c6264893904$var$load("g49kY").then(()=>parcelRequire('dgI5j'));

});

parcelRegister("cZ5ja", function(module, exports) {

let $973f4ca1175d1217$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $973f4ca1175d1217$var$load("9Vcgl").then(()=>parcelRequire('28lMX'));

});

parcelRegister("im5oS", function(module, exports) {

let $d5ce78700f0202e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5ce78700f0202e8$var$load("jzyvw").then(()=>parcelRequire('ag8Mt'));

});

parcelRegister("e6ztg", function(module, exports) {

let $a44d2408cda76a96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a44d2408cda76a96$var$load("jE6NT").then(()=>parcelRequire('2yLDN'));

});

parcelRegister("lTjdd", function(module, exports) {

let $fefda3280fb6a5b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fefda3280fb6a5b4$var$load("jPFt3").then(()=>parcelRequire('3QGFD'));

});

parcelRegister("f1Q5v", function(module, exports) {

let $af0f5a9209bda4f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $af0f5a9209bda4f0$var$load("dchHI").then(()=>parcelRequire('7WQQ0'));

});

parcelRegister("gDyIy", function(module, exports) {

let $c1cb380d18d37cc7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1cb380d18d37cc7$var$load("7IGY8").then(()=>parcelRequire('htGib'));

});

parcelRegister("9JZXX", function(module, exports) {

let $7178622f45300f96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7178622f45300f96$var$load("jTear").then(()=>parcelRequire('2Eg1T'));

});

parcelRegister("e8Hp5", function(module, exports) {

let $a4b37b1a9bfa0d68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4b37b1a9bfa0d68$var$load("ilX2r").then(()=>parcelRequire('eAjlW'));

});

parcelRegister("2iQNZ", function(module, exports) {

let $1ad6394208fc1b58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ad6394208fc1b58$var$load("hbZkz").then(()=>parcelRequire('6ltFW'));

});

parcelRegister("fDWrG", function(module, exports) {
module.exports = JSON.parse('{"confluence-ai-audio.scenario-changeboarding.backButton":[{"type":0,"value":"Back"}],"confluence-ai-audio.scenario-changeboarding.doneButton":[{"type":0,"value":"Done"}],"confluence-ai-audio.scenario-changeboarding.nextButton":[{"type":0,"value":"Next"}],"confluence-ai-audio.scenario-changeboarding.step1Body":[{"type":0,"value":"Not ready to listen? Add it to your playlist for later or play it on the app."}],"confluence-ai-audio.scenario-changeboarding.step1Headline":[{"type":0,"value":"Save it"}],"confluence-ai-audio.scenario-changeboarding.step2Body":[{"type":0,"value":"See what\u2019s next, change the order, or start playing."}],"confluence-ai-audio.scenario-changeboarding.step2Headline":[{"type":0,"value":"Open playlist"}],"confluence-ai-audio.scenario-changeboarding.step3Body":[{"type":0,"value":"Copy and share a link so anyone with access can listen."}],"confluence-ai-audio.scenario-changeboarding.step3Headline":[{"type":0,"value":"Share it"}],"confluence-ai-audio.scenario-changeboarding.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"post-office.audio-button-spotlight.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2 hello there"}],"post-office.audio-player-spotlight-tour.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}]}');

});

parcelRegister("cGmZy", function(module, exports) {

let $93bb3df47275f2f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93bb3df47275f2f5$var$load("bnlyw").then(()=>parcelRequire('xGAhv'));

});

parcelRegister("aeM1b", function(module, exports) {

let $774075989ee47ba3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $774075989ee47ba3$var$load("jnDjd").then(()=>parcelRequire('e5JgA'));

});

parcelRegister("djdhG", function(module, exports) {

let $9b075ab0a2c8cea4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b075ab0a2c8cea4$var$load("gRrsm").then(()=>parcelRequire('9b9El'));

});

parcelRegister("aEsGF", function(module, exports) {

let $7c13e4800e42783a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c13e4800e42783a$var$load("hrY0o").then(()=>parcelRequire('l5joX'));

});

parcelRegister("4HhyS", function(module, exports) {

let $36b8ccee567fd8aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $36b8ccee567fd8aa$var$load("cwMI6").then(()=>parcelRequire('Ho2Z5'));

});

parcelRegister("uaYOe", function(module, exports) {

let $05ab51d0950a8b73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05ab51d0950a8b73$var$load("6zdm2").then(()=>parcelRequire('b9S5Y'));

});

parcelRegister("e4gwe", function(module, exports) {

let $a3de40b3488cdf76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a3de40b3488cdf76$var$load("fJTaB").then(()=>parcelRequire('bHqdW'));

});

parcelRegister("2lp9B", function(module, exports) {

let $1b510dfe70bd6084$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b510dfe70bd6084$var$load("gYz4r").then(()=>parcelRequire('hmJc5'));

});

parcelRegister("1CkmC", function(module, exports) {

let $12d922de97b2e96a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $12d922de97b2e96a$var$load("cxh24").then(()=>parcelRequire('2tP4Z'));

});

parcelRegister("7YcUs", function(module, exports) {

let $5cd826976bb1c072$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5cd826976bb1c072$var$load("gS4ZS").then(()=>parcelRequire('jfjAS'));

});

parcelRegister("fQLi3", function(module, exports) {

let $b8a065348e4cddac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8a065348e4cddac$var$load("149p8").then(()=>parcelRequire('38TVs'));

});

parcelRegister("1TBQM", function(module, exports) {

let $161849ca709322b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $161849ca709322b1$var$load("dL3g7").then(()=>parcelRequire('bM4wf'));

});

parcelRegister("hkcvm", function(module, exports) {

let $c9ce0124492ff880$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9ce0124492ff880$var$load("d9Wla").then(()=>parcelRequire('H9MXC'));

});

parcelRegister("gzkUO", function(module, exports) {

let $c1002394ce79a8b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1002394ce79a8b5$var$load("5MXQW").then(()=>parcelRequire('66mQd'));

});

parcelRegister("fPjSs", function(module, exports) {

let $b85b09ac9ec1e5a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b85b09ac9ec1e5a1$var$load("eLJz8").then(()=>parcelRequire('duEBj'));

});

parcelRegister("uiA6m", function(module, exports) {

let $05b1375011da6c2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05b1375011da6c2d$var$load("loMEq").then(()=>parcelRequire('8melM'));

});

parcelRegister("8rxkz", function(module, exports) {

let $625ab32a444e45d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $625ab32a444e45d8$var$load("kBCBX").then(()=>parcelRequire('3jVMx'));

});

parcelRegister("1MYlW", function(module, exports) {

let $14d916f82b037255$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $14d916f82b037255$var$load("6rmR6").then(()=>parcelRequire('bUzpR'));

});

parcelRegister("czdey", function(module, exports) {

let $926304d8aa9aca6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $926304d8aa9aca6e$var$load("aUGIm").then(()=>parcelRequire('l9TXs'));

});

parcelRegister("1yEI5", function(module, exports) {

let $12288b9709a1c159$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $12288b9709a1c159$var$load("3OavA").then(()=>parcelRequire('gggLq'));

});

parcelRegister("fTF6i", function(module, exports) {

let $b92bdfc88462a7a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b92bdfc88462a7a8$var$load("rgmlD").then(()=>parcelRequire('c3MAF'));

});

parcelRegister("5kcep", function(module, exports) {

let $3e084ee3ebe204b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e084ee3ebe204b0$var$load("4MG6R").then(()=>parcelRequire('gKLr2'));

});

parcelRegister("jCvFV", function(module, exports) {

let $e48a22f58ba61263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e48a22f58ba61263$var$load("8tZvr").then(()=>parcelRequire('lLZTe'));

});

parcelRegister("dcSyT", function(module, exports) {

let $99d6b82f2444f8a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99d6b82f2444f8a6$var$load("8xfQT").then(()=>parcelRequire('SFINg'));

});

parcelRegister("2FKmW", function(module, exports) {

let $1f23610d5daacbdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f23610d5daacbdb$var$load("cTyUa").then(()=>parcelRequire('47XX8'));

});

parcelRegister("dL1X2", function(module, exports) {

let $a0412d9e3a8ca307$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0412d9e3a8ca307$var$load("9orMt").then(()=>parcelRequire('74DEc'));

});

parcelRegister("5GLIP", function(module, exports) {

let $4245e49427f27809$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4245e49427f27809$var$load("l9AmV").then(()=>parcelRequire('kXynr'));

});

parcelRegister("8T3bi", function(module, exports) {

let $6785ed86a756a2a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6785ed86a756a2a4$var$load("3VVry").then(()=>parcelRequire('nyuUw'));

});

parcelRegister("bkDbV", function(module, exports) {

let $83fff68d5a4cfee5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83fff68d5a4cfee5$var$load("iMWlp").then(()=>parcelRequire('kIP10'));

});

parcelRegister("ec0Qz", function(module, exports) {

let $a552d7d6f57576ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a552d7d6f57576ea$var$load("eVPfQ").then(()=>parcelRequire('3mWqA'));

});

parcelRegister("err6c", function(module, exports) {

let $a8389b9ce1a4510e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8389b9ce1a4510e$var$load("hASqx").then(()=>parcelRequire('3xJcN'));

});

parcelRegister("cx45K", function(module, exports) {

let $91fbbd9c2e9859a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91fbbd9c2e9859a9$var$load("3ywZj").then(()=>parcelRequire('7E7Uv'));

});

parcelRegister("kJHYp", function(module, exports) {

let $f18a1ecee4bc6899$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f18a1ecee4bc6899$var$load("bSWkP").then(()=>parcelRequire('hbjBS'));

});

parcelRegister("ensmY", function(module, exports) {

let $a77938479e61ba73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a77938479e61ba73$var$load("9JsLN").then(()=>parcelRequire('3dkHM'));

});

parcelRegister("c0QiU", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aTXRA = parcelRequire("aTXRA");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $81b5ce4661044996$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $81b5ce4661044996$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("khGWi")));
        case 'da':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("jePlG")));
        case 'de':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("NEgCA")));
        case 'en-GB':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("3m4cl")));
        case 'en-US':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("9KM2L")));
        case 'en-XA':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("EXGAa")));
        case 'en-XB':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("emXpd")));
        case 'en-ZZ':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("UkJmz")));
        case 'en':
            return $81b5ce4661044996$var$importHelper(await Promise.resolve((parcelRequire("aTXRA"))));
        case 'es':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("eV6H5")));
        case 'et':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("7KL0A")));
        case 'fi':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("kda76")));
        case 'fr':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("h6ado")));
        case 'hr':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("ek2LX")));
        case 'hu':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("Vqlfy")));
        case 'it':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("5B2NC")));
        case 'ja':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("jSY2e")));
        case 'ko':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("hVrnG")));
        case 'nb':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("1281u")));
        case 'nl':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("5n47b")));
        case 'pl':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("eg80k")));
        case 'pt-BR':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("7jNKj")));
        case 'ro':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("43QWF")));
        case 'ru':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("6zd7I")));
        case 'sl':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("F68Ip")));
        case 'sr-RS':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("7uTYD")));
        case 'sr-YR':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("XPYo1")));
        case 'sr':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("akrsN")));
        case 'sv':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("5Nytl")));
        case 'th':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("4CejC")));
        case 'tr':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("7ZzCp")));
        case 'uk':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("a1wqN")));
        case 'vi':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("jDl0R")));
        case 'zh-CN':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("gBevv")));
        case 'zh-TW':
            return $81b5ce4661044996$var$importHelper(await (parcelRequire("gBZLb")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aTXRA));
    }
};
module.exports["messagesLoader"] = $81b5ce4661044996$export$720676d8cac8fbb;

});

parcelRegister("aTXRA", function(module, exports) {
module.exports = JSON.parse('{"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.primary.no-pde":[{"type":0,"value":"Try it free"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.primary.pde":[{"type":0,"value":"Try now"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.secondary":[{"type":0,"value":"No thanks"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.body.has-payment":[{"type":0,"value":"Billing starts after "},{"type":1,"value":"trialEndDate"},{"type":0,"value":". We\u2019ll remind you before your trial ends. Downgrade to Free or "},{"children":[{"type":0,"value":"switch plans"}],"type":8,"value":"Link"},{"type":0,"value":" anytime."}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.body.no-payment":[{"type":0,"value":"After your trial you can stay on your plan or downgrade to a free plan. "},{"children":[{"type":0,"value":"Explore plans"}],"type":8,"value":"Link"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.header":[{"type":0,"value":"Welcome to your "},{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":"-day"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":" free trial "},{"options":{"other":{"value":[]},"premium":{"value":[{"type":0,"value":"of Premium"}]},"standard":{"value":[{"type":0,"value":"of Standard"}]}},"type":5,"value":"edition"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature1":[{"type":0,"value":"See user data and insights in one place"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature2":[{"type":0,"value":"Control who can view, edit, and comment"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature3":[{"type":0,"value":"Create unlimited whiteboards"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature1":[{"type":0,"value":"Share read-only pages with external stakeholders"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature2":[{"type":0,"value":"Automate repetitive tasks"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature3":[{"type":0,"value":"Control who can edit and comment"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.admin-key":[{"children":[{"type":0,"value":"Admin key"}],"type":8,"value":"b"},{"type":0,"value":": Access restricted content so you can fix bugs, fast"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.automation":[{"children":[{"type":0,"value":"Automation"}],"type":8,"value":"b"},{"type":0,"value":": 10x more rule runs per month"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.page-insights":[{"children":[{"type":0,"value":"Page insights"}],"type":8,"value":"b"},{"type":0,"value":": See who viewed your page and when"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.page-permissions":[{"children":[{"type":0,"value":"Page permissions"}],"type":8,"value":"b"},{"type":0,"value":": Choose who can view, edit, and comment"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.rovo":[{"children":[{"type":0,"value":"Rovo"}],"type":8,"value":"b"},{"type":0,"value":": AI-powered search, chat, and agents"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.space-permissions":[{"children":[{"type":0,"value":"Space permissions"}],"type":8,"value":"b"},{"type":0,"value":": Choose who can access entire folders"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.admin-features-title":[{"type":0,"value":"You also get more admin features"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Archive\' feature on the Confluence Standard plan. This will make it easy to archive outdated content and keep things tidy."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Archive\' feature on the Confluence Standard plan. This will make it easy to archive outdated content and keep things tidy."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Archive\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.title":[{"type":0,"value":"Help your team keep Confluence work tidy and up-to-date"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Archive\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" keep Confluence work tidy and up-to-date"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Calendars\' feature on the Confluence Premium plan. This will make it easy to plan deadlines and time off across teams."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Calendars\' feature on the Confluence Premium plan. This will make it easy to plan deadlines and time off across teams."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Calendars\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.title":[{"type":0,"value":"Help your team balance downtime with deadlines"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Calendars\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" balance downtime with deadlines"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try features on the Confluence Standard plan."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.description":[{"type":0,"value":"Someone on your team has requested to try features on the Confluence Standard plan."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try new features"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for your team"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try new features"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for "},{"type":1,"value":"requesterFullName"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.explore-all-features":[{"type":0,"value":"Explore all features \u2192"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.get-started-button":[{"type":0,"value":"Get Started"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Confluence logo"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Pages insights and analytics\' feature on the Confluence Standard plan. This will make it easy to see user engagement and make more informed decisions"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Pages insights and analytics\' feature on the Confluence Standard plan. This will make it easy to see user engagement and make more informed decisions"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Page insights\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.title":[{"type":0,"value":"Unlock data and insights for your team"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Page insights\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.title":[{"type":0,"value":"Unlock data and insights for "},{"type":1,"value":"requesterFullName"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Page permissions\' feature on the Confluence Standard plan. This will makes it easy to decide who can edit, view, and comment on pages."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Page permissions\' feature on the Confluence Standard plan. This will makes it easy to decide who can edit, view, and comment on pages."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Page permissions\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.title":[{"type":0,"value":"Help your team share more and worry less"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Page permissions\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" share more and worry less"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try Rovo (AI) on the Confluence Standard plan. This will make it easy to summarize pages, get writing help, and generate ideas, fast."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.description":[{"type":0,"value":"Someone on your team has requested to try Rovo (AI) on the Confluence Standard plan. This will make it easy to summarize pages, get writing help, and generate ideas, fast."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try Rovo (AI)"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.title":[{"type":0,"value":"Unlock improved writing and more creativity for your team"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try Rovo (AI)"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.title":[{"type":0,"value":"Unlock improved writing and more creativity for "},{"type":1,"value":"requesterFullName"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.upgrade-trial-edition-info":[{"type":0,"value":"Grant access on a "},{"children":[{"type":0,"value":"free"}],"type":8,"value":"b"},{"type":0,"value":", "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."},{"type":1,"value":"br"},{"children":[{"type":0,"value":"Cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested access to more whiteboards on the Confluence Premium plan. This will unlock unlimited whiteboards."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.description":[{"type":0,"value":"Someone on your team has requested access to more whiteboards on the Confluence Premium plan. This will unlock unlimited whiteboards."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team needs more Confluence whiteboards"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.title":[{"type":0,"value":"Help your team turn ideas into action"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" needs more Confluence whiteboards"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" turn ideas into action"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.xflow-access-request-slack-notification.app-description.confluence":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Confluence, a collaboration app that lets your team create, share, and organize work in pages and spaces."}],"post-office.xflow-access-request-slack-notification.app-description.jira-product-discovery":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Jira Product Discovery, a roadmap and prioritization app that links to your Jira projects."}],"post-office.xflow-access-request-slack-notification.app-description.jira-service-management":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Jira Service Management, an app that helps your team unify and resolve requests faster."}],"post-office.xflow-access-request-slack-notification.app-description.loom":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Loom, an app that lets your team record and embed videos to Jira work items."}],"post-office.xflow-access-request-slack-notification.app-description.service-collection":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Service Collection, a suite of apps designed to help your team unify and resolve requests faster."}],"post-office.xflow-access-request-slack-notification.more-actions-placeholder":[{"type":0,"value":"More actions..."}],"post-office.xflow-access-request-slack-notification.mute-for-1-day":[{"type":0,"value":"Snooze for 1 day"}],"post-office.xflow-access-request-slack-notification.requestor-mention-fallback":[{"type":0,"value":"Someone"}],"post-office.xflow-access-request-slack-notification.review-request-button":[{"type":0,"value":"Review request"}],"post-office.xflow-access-request-slack-notification.turn-off-notifications":[{"type":0,"value":"Turn off these notifications"}]}');

});

parcelRegister("khGWi", function(module, exports) {

let $ec46b40637c5d23d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec46b40637c5d23d$var$load("a7O4E").then(()=>parcelRequire('hwALN'));

});

parcelRegister("jePlG", function(module, exports) {

let $e01727e8c592e25e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e01727e8c592e25e$var$load("kN8W3").then(()=>parcelRequire('fy7zW'));

});

parcelRegister("NEgCA", function(module, exports) {

let $0953cfec2e4c82f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0953cfec2e4c82f1$var$load("jsrqT").then(()=>parcelRequire('8Igfk'));

});

parcelRegister("3m4cl", function(module, exports) {

let $2716aed9afb7ecac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2716aed9afb7ecac$var$load("3VD9N").then(()=>parcelRequire('1G2OT'));

});

parcelRegister("9KM2L", function(module, exports) {

let $719dad693f219bcc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $719dad693f219bcc$var$load("6rxzi").then(()=>parcelRequire('jfzrD'));

});

parcelRegister("EXGAa", function(module, exports) {

let $07b208e6990645b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07b208e6990645b9$var$load("gXHED").then(()=>parcelRequire('dvmBw'));

});

parcelRegister("emXpd", function(module, exports) {

let $a7613379cf61fcdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7613379cf61fcdc$var$load("2Dxuh").then(()=>parcelRequire('bWkKT'));

});

parcelRegister("UkJmz", function(module, exports) {

let $0a954fc15c7190bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0a954fc15c7190bf$var$load("dPidX").then(()=>parcelRequire('4zayH'));

});

parcelRegister("eV6H5", function(module, exports) {

let $adcb94d18437f78e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $adcb94d18437f78e$var$load("dfcvH").then(()=>parcelRequire('1DPI5'));

});

parcelRegister("7KL0A", function(module, exports) {

let $5a514b2d1591faad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a514b2d1591faad$var$load("7Y59F").then(()=>parcelRequire('16TQL'));

});

parcelRegister("kda76", function(module, exports) {

let $eb6cdde32c102669$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb6cdde32c102669$var$load("50tPJ").then(()=>parcelRequire('hFmuY'));

});

parcelRegister("h6ado", function(module, exports) {

let $c72aebae98c48308$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c72aebae98c48308$var$load("9oubr").then(()=>parcelRequire('dHYg1'));

});

parcelRegister("ek2LX", function(module, exports) {

let $a6d51586927020cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a6d51586927020cf$var$load("djRvH").then(()=>parcelRequire('1w8Tu'));

});

parcelRegister("Vqlfy", function(module, exports) {

let $0ac9c1e8226ea819$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ac9c1e8226ea819$var$load("bO0hF").then(()=>parcelRequire('jUX9f'));

});

parcelRegister("5B2NC", function(module, exports) {

let $413294537842ea1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $413294537842ea1d$var$load("7URpa").then(()=>parcelRequire('jALuv'));

});

parcelRegister("jSY2e", function(module, exports) {

let $e7a1a128a5c07685$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7a1a128a5c07685$var$load("eDUok").then(()=>parcelRequire('k9hSk'));

});

parcelRegister("hVrnG", function(module, exports) {

let $d0ccffcf937c84f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d0ccffcf937c84f3$var$load("cvBaM").then(()=>parcelRequire('aNwfR'));

});

parcelRegister("1281u", function(module, exports) {

let $0c0c338edd408060$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c0c338edd408060$var$load("2wtqZ").then(()=>parcelRequire('iQG75'));

});

parcelRegister("5n47b", function(module, exports) {

let $3e924ad5431f6bf9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e924ad5431f6bf9$var$load("gXynX").then(()=>parcelRequire('4Zwlh'));

});

parcelRegister("eg80k", function(module, exports) {

let $a618c4c9b5f68586$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a618c4c9b5f68586$var$load("7bhv3").then(()=>parcelRequire('5KNEW'));

});

parcelRegister("7jNKj", function(module, exports) {

let $5540e5464345bedc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5540e5464345bedc$var$load("lfEaQ").then(()=>parcelRequire('g0aAJ'));

});

parcelRegister("43QWF", function(module, exports) {

let $2f50830a110183f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f50830a110183f1$var$load("k9PEt").then(()=>parcelRequire('gdphT'));

});

parcelRegister("6zd7I", function(module, exports) {

let $4c8030fb77d709f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c8030fb77d709f1$var$load("bQHVt").then(()=>parcelRequire('gr0Rd'));

});

parcelRegister("F68Ip", function(module, exports) {

let $07b897a400f239ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07b897a400f239ee$var$load("3Qge6").then(()=>parcelRequire('9SAV2'));

});

parcelRegister("7uTYD", function(module, exports) {

let $5756c19831675ca1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5756c19831675ca1$var$load("kRDD2").then(()=>parcelRequire('4GYl6'));

});

parcelRegister("XPYo1", function(module, exports) {

let $0b3dd38d8ab095e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b3dd38d8ab095e5$var$load("4yt96").then(()=>parcelRequire('fdEfE'));

});

parcelRegister("akrsN", function(module, exports) {

let $78511349a24c3325$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78511349a24c3325$var$load("klTnj").then(()=>parcelRequire('hTbmQ'));

});

parcelRegister("5Nytl", function(module, exports) {

let $438c44d42aa196fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $438c44d42aa196fb$var$load("1OMwg").then(()=>parcelRequire('kHFGa'));

});

parcelRegister("4CejC", function(module, exports) {

let $35c5d0c26a033f0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35c5d0c26a033f0e$var$load("5G5Ud").then(()=>parcelRequire('2sqs3'));

});

parcelRegister("7ZzCp", function(module, exports) {

let $5d19dbfc7aaeb720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d19dbfc7aaeb720$var$load("52niQ").then(()=>parcelRequire('lnFm2'));

});

parcelRegister("a1wqN", function(module, exports) {

let $74c3278616454a53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74c3278616454a53$var$load("5etrF").then(()=>parcelRequire('1vRLZ'));

});

parcelRegister("jDl0R", function(module, exports) {

let $e4b1f58ee95ebad6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4b1f58ee95ebad6$var$load("3T81s").then(()=>parcelRequire('hAve8'));

});

parcelRegister("gBevv", function(module, exports) {

let $c15b5ad81557defd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c15b5ad81557defd$var$load("b7qqi").then(()=>parcelRequire('92GIb'));

});

parcelRegister("gBZLb", function(module, exports) {

let $c180024bd54a155d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c180024bd54a155d$var$load("iSnvi").then(()=>parcelRequire('5tCOC'));

});

parcelRegister("8SCD0", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ineA9 = parcelRequire("ineA9");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6c9af975b930043$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $e6c9af975b930043$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("9DoTa")));
        case 'da':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4qglW")));
        case 'de':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("bfbM8")));
        case 'en-GB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("auur8")));
        case 'en-US':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hqlmj")));
        case 'en-XA':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4LGQD")));
        case 'en-XB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("iQahz")));
        case 'en-ZZ':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("1vN03")));
        case 'en':
            return $e6c9af975b930043$var$importHelper(await Promise.resolve((parcelRequire("ineA9"))));
        case 'es':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("l8F02")));
        case 'et':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4lx9v")));
        case 'fi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("7SJgz")));
        case 'fr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("2hAcG")));
        case 'hr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3KRsA")));
        case 'hu':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lorva")));
        case 'it':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("7z1yN")));
        case 'ja':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("6Lmbg")));
        case 'ko':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hDbAj")));
        case 'nb':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("ifA95")));
        case 'nl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("c8rti")));
        case 'pl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("kWAHY")));
        case 'pt-BR':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("8m74M")));
        case 'ro':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("cHbRQ")));
        case 'ru':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("iginQ")));
        case 'sl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("buteN")));
        case 'sr-RS':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("kXpFG")));
        case 'sr-YR':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("6DRMN")));
        case 'sr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("bytiP")));
        case 'sv':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("5eaPb")));
        case 'th':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("2JhNV")));
        case 'tr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lJjy6")));
        case 'uk':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hqddP")));
        case 'vi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lRJ6S")));
        case 'zh-CN':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("dNB4M")));
        case 'zh-TW':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("aazgg")));
        case 'zh':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("dNB4M")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ineA9));
    }
};
module.exports["messagesLoader"] = $e6c9af975b930043$export$720676d8cac8fbb;

});

parcelRegister("ineA9", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.atlassian-store":[{"type":0,"value":"Marketplace apps"}],"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"confluence.continue.reading.read-now":[{"type":0,"value":"Read now"}],"continue-reading.ai-footer.content-quality":[{"children":[{"type":0,"value":"Content quality may vary"}],"type":8,"value":"text"}],"continue-reading.ai-footer.powered-by-ai":[{"children":[{"type":0,"value":"Powered by AI"}],"type":8,"value":"text"}],"cross-flow-itsm-template.jsm.title":[{"type":0,"value":"Collect IT requests"}],"cross-flow-product-prioritization-template.jpd.title":[{"type":0,"value":"Prioritize ideas"}],"cross-flow-product-request-pending.jpd.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-request-pending.jsm.title":[{"type":0,"value":"Work requests"}],"cross-flow-product-roadmap-template.jpd.title":[{"type":0,"value":"Create a roadmap"}],"cross-flow-work-requests-template.jsm.title":[{"type":0,"value":"Collect requests"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluence-nudge-for-jira.action":[{"type":0,"value":"Accept invitation"}],"growth.confluence-nudge-for-jira.description":[{"type":0,"value":"Accept your invitation to make sure you\'re not missing any project updates."}],"growth.confluence-nudge-for-jira.title":[{"type":0,"value":"Your team invited you to Jira"}],"growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" commented on your page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you in a comment"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you on a page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text":[{"type":0,"value":"Reply sent to "},{"type":1,"value":"mentionerName"}],"growth.confluenceNudgeFlag.reply-cancel-button":[{"type":0,"value":"Cancel"}],"growth.confluenceNudgeFlag.reply-confirm-button":[{"type":0,"value":"Reply"}],"growth.confluenceNudgeFlag.reply-on-page-confirm-button.text":[{"children":[{"type":0,"value":"Reply on page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.replyFieldGenericError":[{"type":0,"value":"Failed to send comment. Please try again later."}],"growth.confluenceNudgeFlag.see-page-confirm-button":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.see-page-confirm-button.success.flag":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.placement-v2.atlas-side-nav-app-recommendation-menu-item.try-new-product":[{"type":0,"value":"TRY"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.admin-hub-recommendation-value-proposition":[{"type":0,"value":"Plan and deliver all on the same platform"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.admin-hub-recommendation-value-prop":[{"type":0,"value":"Bring your developers, IT, and operations onto the same platform."}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.recommendation-twc.twc-apps-lozenge":[{"type":0,"value":"New"}],"growth.recommendation-twc.twc-apps-product-benefits-description":[{"type":0,"value":"Run your whole project seamlessly"}],"growth.recommendation-twc.twc-apps-product-benefits-title":[{"type":0,"value":"1 collection, 4 tools"}],"growth.recommendation-twc.twc-image-alt-text":[{"type":0,"value":"Teamwork Collection"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message":[{"type":0,"value":"You\'re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis":[{"type":0,"value":"You\u2019re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag.suggestions":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.custom-dropdown-item.1.no-translate":[{"type":0,"value":"the first custom dropdown item"}],"post-office.ad-controls.custom-dropdown-item.2.no-translate":[{"type":0,"value":"the second custom dropdown item"}],"post-office.ad-controls.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate":[{"type":0,"value":"Done"}],"post-office.example-placement-quick-start.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.growth.jira-activation-project-recommendation.check-jira":[{"type":0,"value":"Check Jira"}],"post-office.growth.jira-activation-project-recommendation.hello-message":[{"type":0,"value":":wave: Hey "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"post-office.growth.jira-activation-project-recommendation.message-text":[{"type":0,"value":"Have you checked Jira lately? You may be missing out on important updates. Take a quick look to see if your team is using it to track any of your projects."}],"post-office.growth.jira-activation-project-recommendation.messages-exist":[{"type":0,"value":"Don\u2019t forget to get caught up on your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"project"}]},"other":{"value":[{"type":0,"value":"projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":" in Jira! Take a quick look to get up-to-date on your teammates\u2019 progress."}],"post-office.growth.jira-activation-project-recommendation.see-projects":[{"type":0,"value":"See all projects"}],"post-office.growth.jira-activation-project-recommendation.you-have-messages":[{"offset":0,"options":{"=0":{"value":[]},"=1":{"value":[]},"=2":{"value":[{"type":0,"value":"You have *two projects*:"}]},"=3":{"value":[{"type":0,"value":"You have *three projects*:"}]},"other":{"value":[{"type":0,"value":"You have *"},{"options":{"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects*. Here are three to get you started:"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-multiple-projects":[{"type":0,"value":":wave: Just a heads up \u2014 you have *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one project"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":"* assigned to you with new work items you haven\'t checked out yet."}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-one-project-work-items":[{"type":0,"value":":wave: Just a heads up \u2014 you were assigned "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"a work item in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]},"other":{"value":[{"type":0,"value":"some work items in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":" over three days ago."}],"post-office.growth.jira-assigned-nudge-digest.max-top-work-items-message":[{"type":0,"value":"You\'ve got *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one item"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfWorkItems"}]}},"type":5,"value":"numberOfWorkItems"},{"type":0,"value":" items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":"* to check on \u2014 here are three:"}],"post-office.growth.jira-assigned-nudge-digest.plural-cta-message":[{"type":0,"value":"See inactive "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"item"}]},"other":{"value":[{"type":0,"value":"items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"}],"post-office.growth.jira-assigned-nudge-digest.top-projects-message":[{"type":0,"value":"Here are three to get you started:"}],"post-office.growth.jira-board-catch-up-rovo-nudge.secondary-title":[{"type":0,"value":"Get a quick summary of new issues and important activity."}],"post-office.growth.jira-board-catch-up-rovo-nudge.static-prompt":[{"type":0,"value":"Summarize the most recent activity on this Jira board. Create an executive-ready update (max ~8 bullets total) using this structure:\\n\\n1. Sprint / timeline context\\n- Current sprint or time window, dates, and high-level status (e.g. \\"on track / at risk / off track\\").\\n\\n2. Key progress / wins (2-4 bullets)\\n- Focus on issues that moved into In Progress, In Review / Pending Review, or Done in the selected period.\\n- For each, include: issue key, short description (3-7 words), and current status only (no technical deep dive).\\n\\n3. Blockers / risks (1-3 bullets)\\n- Call out any flagged issues, long-running items stuck in In Progress or In Review, or dependencies that could impact delivery for this sprint / period.\\n\\n4. Scope & pipeline (1-3 bullets)\\n- Highlight important newly created or To Do issues that are not yet started but are significant for upcoming milestones.\\n- Note if work is skewed toward setup/foundations vs user-visible outcomes.\\n\\n5. Next-focus recommendation (1-2 bullets)\\n- Recommend the 1-2 highest-leverage next actions to keep the team\'s objectives on track, referencing specific issue keys.\\n\\nOutput the answer as concise markdown bullets, optimized for an executive audience (outcomes, risks, and next moves over implementation details)."}],"post-office.growth.jira-board-catch-up-rovo-nudge.title":[{"type":0,"value":"Catch up on recent changes"}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.nav-4-projects-recommendations.cta-button-lozenge-try":[{"type":0,"value":"Try"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-one-spork":[{"type":0,"value":"the tools you use (Jira)"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-two-appify":[{"type":0,"value":"the way you use your existing tools and apps"}],"post-office.nav-4-projects-recommendations.reasons-modal-explanation":[{"type":0,"value":"We think "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"post-office.nav-4-projects-recommendations.section-heading":[{"type":0,"value":"Recommended"}],"post-office.nav-4-requested-item.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-requested-item.cta-button-lozenge-pending":[{"type":0,"value":"Pending"}],"post-office.nav-4-requested-item.product-roadmap-icon-alt-text":[{"type":0,"value":"Icon for product roadmap"}],"post-office.nav-4-requested-item.work-requests-icon-alt-text":[{"type":0,"value":"Icon for work requests"}],"post-office.placement-v2-nav-4-section.requested-main-heading":[{"type":0,"value":"Requested"}],"post-office.test-placement.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.test-placement.test-message.learn-more-button.no-translate":[{"type":0,"value":"Learn more"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"rovo-3p-party-integration-admin-nudge.action.connect":[{"type":0,"value":"Connect now"}],"rovo-3p-party-integration-admin-nudge.action.learnMore":[{"type":0,"value":"Learn more"}],"rovo-3p-party-integration-admin-nudge.description.high-percentage-and-less-than-three-apps":[{"type":0,"value":"Over 90% of your team shares content on "},{"type":1,"value":"appName"},{"type":0,"value":", "},{"type":1,"value":"secondAppName"},{"type":0,"value":", and other apps. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.high-percentage-and-less-than-two-apps":[{"type":0,"value":"Over 90% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.low-percentage":[{"type":0,"value":"Most of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.more-than-two-apps":[{"type":1,"value":"percUsersConnected"},{"type":0,"value":"% of your team shares content on "},{"type":1,"value":"appName"},{"type":0,"value":", "},{"type":1,"value":"secondAppName"},{"type":0,"value":", and other apps. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.one-app":[{"type":1,"value":"percUsersConnected"},{"type":0,"value":"% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.more-apps-label":[{"type":0,"value":"More apps"}],"rovo-3p-party-integration-admin-nudge.title.more-than-two-apps":[{"type":0,"value":"Connect more apps"}],"rovo-3p-party-integration-admin-nudge.title.one-app":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"rovo-3p-party-integration-admin-nudge.title.two-apps":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" and "},{"type":1,"value":"secondAppName"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("9DoTa", function(module, exports) {

let $703b0ff5e45f39ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $703b0ff5e45f39ca$var$load("i5eMd").then(()=>parcelRequire('bvjlk'));

});

parcelRegister("4qglW", function(module, exports) {

let $33864678917c99b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33864678917c99b3$var$load("4UPfH").then(()=>parcelRequire('IzetR'));

});

parcelRegister("bfbM8", function(module, exports) {

let $82fa3abe0ee41d1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82fa3abe0ee41d1e$var$load("gd4qs").then(()=>parcelRequire('b60fG'));

});

parcelRegister("auur8", function(module, exports) {

let $7a3450d5cacf3802$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a3450d5cacf3802$var$load("fviv5").then(()=>parcelRequire('d1j2S'));

});

parcelRegister("hqlmj", function(module, exports) {

let $caf56ecfe84fe48c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf56ecfe84fe48c$var$load("hEkXc").then(()=>parcelRequire('dnFPq'));

});

parcelRegister("4LGQD", function(module, exports) {

let $378cc9e57c8473fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $378cc9e57c8473fa$var$load("6oOC9").then(()=>parcelRequire('4WIcD'));

});

parcelRegister("iQahz", function(module, exports) {

let $db750f2ad2fc95cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db750f2ad2fc95cb$var$load("le1sE").then(()=>parcelRequire('7DdDO'));

});

parcelRegister("1vN03", function(module, exports) {

let $119eb210e4162adb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $119eb210e4162adb$var$load("eBoC7").then(()=>parcelRequire('hWRzS'));

});

parcelRegister("l8F02", function(module, exports) {

let $f63a26007ba32907$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f63a26007ba32907$var$load("bNv64").then(()=>parcelRequire('c7q37'));

});

parcelRegister("4lx9v", function(module, exports) {

let $32a2d6f90f7dc6dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32a2d6f90f7dc6dd$var$load("bAoKR").then(()=>parcelRequire('6eH2E'));

});

parcelRegister("7SJgz", function(module, exports) {

let $5bd0b07a6c7362cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bd0b07a6c7362cc$var$load("4Afgd").then(()=>parcelRequire('Plo13'));

});

parcelRegister("2hAcG", function(module, exports) {

let $1a99408df5c40000$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a99408df5c40000$var$load("cMubu").then(()=>parcelRequire('iY0zC'));

});

parcelRegister("3KRsA", function(module, exports) {

let $2bbf230e3c7786a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bbf230e3c7786a6$var$load("oUCro").then(()=>parcelRequire('6luhh'));

});

parcelRegister("lorva", function(module, exports) {

let $f9312c1c621b494e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9312c1c621b494e$var$load("3fLE9").then(()=>parcelRequire('lqPAG'));

});

parcelRegister("7z1yN", function(module, exports) {

let $581d0323511a36f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $581d0323511a36f5$var$load("8hOn0").then(()=>parcelRequire('85Nk7'));

});

parcelRegister("6Lmbg", function(module, exports) {

let $4ec85677d908e5ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ec85677d908e5ea$var$load("h4OCL").then(()=>parcelRequire('gdGRk'));

});

parcelRegister("hDbAj", function(module, exports) {

let $cd5f10a6a7e39aac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd5f10a6a7e39aac$var$load("bcQs2").then(()=>parcelRequire('eVsDT'));

});

parcelRegister("ifA95", function(module, exports) {

let $d495aa769fbc0b39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d495aa769fbc0b39$var$load("aBa7j").then(()=>parcelRequire('76Zjl'));

});

parcelRegister("c8rti", function(module, exports) {

let $8d5b8aafb917ed74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d5b8aafb917ed74$var$load("b544F").then(()=>parcelRequire('8JOK1'));

});

parcelRegister("kWAHY", function(module, exports) {

let $f3f5b2f1a0e0f500$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3f5b2f1a0e0f500$var$load("K6fhx").then(()=>parcelRequire('5eTse'));

});

parcelRegister("8m74M", function(module, exports) {

let $6155ddfe74a250ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6155ddfe74a250ea$var$load("gZU54").then(()=>parcelRequire('1OKs8'));

});

parcelRegister("cHbRQ", function(module, exports) {

let $93e2b4d7e19c96a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93e2b4d7e19c96a8$var$load("hlJc4").then(()=>parcelRequire('Xa5VS'));

});

parcelRegister("iginQ", function(module, exports) {

let $d4b7fb3604fa2dd6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4b7fb3604fa2dd6$var$load("4Wdqb").then(()=>parcelRequire('7W27q'));

});

parcelRegister("buteN", function(module, exports) {

let $85d92d084d6748bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85d92d084d6748bf$var$load("bJMZS").then(()=>parcelRequire('hu9se'));

});

parcelRegister("kXpFG", function(module, exports) {

let $03eff490f7a06afd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03eff490f7a06afd$var$load("exiT6").then(()=>parcelRequire('llE8x'));

});

parcelRegister("6DRMN", function(module, exports) {

let $4d601b614fe17619$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d601b614fe17619$var$load("jLkRH").then(()=>parcelRequire('195GW'));

});

parcelRegister("bytiP", function(module, exports) {

let $8699999c641b845b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8699999c641b845b$var$load("dmrYq").then(()=>parcelRequire('inCkW'));

});

parcelRegister("5eaPb", function(module, exports) {

let $3ce6a816be8813ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ce6a816be8813ae$var$load("k10Cs").then(()=>parcelRequire('6CeqQ'));

});

parcelRegister("2JhNV", function(module, exports) {

let $1fcd9849f2e198be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fcd9849f2e198be$var$load("g5LV7").then(()=>parcelRequire('88szQ'));

});

parcelRegister("lJjy6", function(module, exports) {

let $fd1cf6ff1ab4b3c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd1cf6ff1ab4b3c6$var$load("1n8w9").then(()=>parcelRequire('8mq9f'));

});

parcelRegister("hqddP", function(module, exports) {

let $caef1efdd7b47752$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caef1efdd7b47752$var$load("2QtDQ").then(()=>parcelRequire('gOCry'));

});

parcelRegister("lRJ6S", function(module, exports) {

let $feb18a1e86664bd6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $feb18a1e86664bd6$var$load("i2vEA").then(()=>parcelRequire('8bOb4'));

});

parcelRegister("dNB4M", function(module, exports) {

let $a0bc9c843510574d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0bc9c843510574d$var$load("f1B4n").then(()=>parcelRequire('03O98'));

});

parcelRegister("aazgg", function(module, exports) {

let $767630bad9dc7d72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $767630bad9dc7d72$var$load("l079e").then(()=>parcelRequire('eLabs'));

});

parcelRegister("96o0f", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.context":[{"type":0,"value":"Context"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.meeting":[{"type":0,"value":"Meeting"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.pre-read":[{"type":0,"value":"Pre-read"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.agenda.time":[{"type":0,"value":"Time"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.cta.go-to-confluence":[{"type":0,"value":"Go to Confluence"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.feedback.body":[{"type":0,"value":"What\'s working, what\'s not, what do you wish it did?"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.feedback.cta":[{"type":0,"value":"Share your thoughts in "},{"children":[{"type":0,"value":"#cc-atlaspulse-feedback"}],"type":8,"value":"link"},{"type":0,"value":". We\'d love to hear from you!"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.feedback.heading":[{"type":0,"value":"Feedback: How can we improve your daily brief?"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.ai-disclaimer":[{"type":0,"value":"This briefing was generated by Rovo based on your recent work activity."}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.ai-disclaimer-note":[{"children":[{"type":0,"value":"Uses AI. Verify results."}],"type":8,"value":"link"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.manage-notifications":[{"type":0,"value":"Manage notification preferences"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.privacy-policy":[{"type":0,"value":"Privacy policy"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.footer.sent-by":[{"type":0,"value":"This email was sent by Atlassian"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.header.date":[{"type":0,"value":"Your briefing for "},{"type":1,"value":"briefingDate"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.header.greeting":[{"type":0,"value":"Good morning, "},{"type":1,"value":"userName"},{"type":0,"value":" \uD83D\uDC4B"}],"cc-flywheel-engagement.confluence-ai-daily-briefing.email.subject":[{"type":0,"value":"Atlas Pulse: Your daily briefing for "},{"type":1,"value":"briefingDate"}],"confluence-editor-smart-links-draggable-changeboard.description":[{"type":0,"value":"Organize your smart links and keep them in one place for quick access. Simply drag any smart link into your sidebar."}],"confluence-editor-smart-links-draggable-changeboard.dismissButton":[{"type":0,"value":"Got it"}],"confluence-editor-smart-links-draggable-changeboard.gifAlt":[{"type":0,"value":"Animation showing how to drag a smart link into the sidebar"}],"confluence-editor-smart-links-draggable-changeboard.headline":[{"type":0,"value":"Drag smart links to your sidebar"}],"confluence-inline-reactions-mcu-nudge.description.many-reactions":[{"type":1,"value":"user1"},{"type":0,"value":", "},{"type":1,"value":"user2"},{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" other"},{"offset":0,"options":{"one":{"value":[]},"other":{"value":[{"type":0,"value":"s"}]}},"pluralType":"cardinal","type":6,"value":"count"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-mcu-nudge.description.no-reactions":[{"type":0,"value":"Be the first one to react"}],"confluence-inline-reactions-mcu-nudge.description.one-reaction":[{"type":1,"value":"user"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-mcu-nudge.description.two-reactions":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-mcu-nudge.title":[{"type":0,"value":"Love this page? Let "},{"type":1,"value":"authorName"},{"type":0,"value":" know"}],"post-office.confluence-resurrected-user-welcome-back.body":[{"type":0,"value":"Catch up on the top discussions and highlights from your team."}],"post-office.confluence-resurrected-user-welcome-back.close":[{"type":0,"value":"Close"}],"post-office.confluence-resurrected-user-welcome-back.cta":[{"type":0,"value":"See what\'s popular"}],"post-office.confluence-resurrected-user-welcome-back.image-alt":[{"type":0,"value":"Two hearts overlapped with each other"}],"post-office.confluence-resurrected-user-welcome-back.next-best-action.header":[{"type":0,"value":"Welcome back"}]}');

});

parcelRegister("8pkfo", function(module, exports) {

let $61f05d3685a1f622$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61f05d3685a1f622$var$load("9lgXg").then(()=>parcelRequire('bj2br'));

});

parcelRegister("3xGoG", function(module, exports) {

let $2945575a62842ee4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2945575a62842ee4$var$load("cGVHa").then(()=>parcelRequire('7ApBu'));

});

parcelRegister("40eBS", function(module, exports) {

let $2ea27eb66f072cd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ea27eb66f072cd4$var$load("124it").then(()=>parcelRequire('3ntz2'));

});

parcelRegister("aPwCB", function(module, exports) {

let $7e27f8c145d8ea2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e27f8c145d8ea2a$var$load("gL84Y").then(()=>parcelRequire('OOVjL'));

});

parcelRegister("4ugRI", function(module, exports) {

let $34470be016111738$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34470be016111738$var$load("fpqFW").then(()=>parcelRequire('e5vLF'));

});

parcelRegister("lXmGM", function(module, exports) {

let $ffc0b53d188482a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffc0b53d188482a4$var$load("9LGea").then(()=>parcelRequire('9YAnZ'));

});

parcelRegister("f4AyR", function(module, exports) {

let $af9397080bd6c926$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $af9397080bd6c926$var$load("7uvFU").then(()=>parcelRequire('lMFWW'));

});

parcelRegister("kCR1F", function(module, exports) {

let $f0407d1cf9a6452b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0407d1cf9a6452b$var$load("lb58d").then(()=>parcelRequire('fZ956'));

});

parcelRegister("cmHVh", function(module, exports) {

let $90099c45518641f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $90099c45518641f6$var$load("53hWW").then(()=>parcelRequire('iPUlN'));

});

parcelRegister("4l2T3", function(module, exports) {

let $328b5ce1181d3fab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $328b5ce1181d3fab$var$load("ao95w").then(()=>parcelRequire('7PzL9'));

});

parcelRegister("dFQgI", function(module, exports) {

let $9f47a627672a1856$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9f47a627672a1856$var$load("2qn3g").then(()=>parcelRequire('37RXh'));

});

parcelRegister("2dfft", function(module, exports) {

let $19c89fbac79a025d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19c89fbac79a025d$var$load("3U2Yj").then(()=>parcelRequire('6mZms'));

});

parcelRegister("kvq2U", function(module, exports) {

let $eedae81428f24645$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eedae81428f24645$var$load("55GPM").then(()=>parcelRequire('5C4qU'));

});

parcelRegister("fuDUl", function(module, exports) {

let $b4789d3ab8eab63f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b4789d3ab8eab63f$var$load("bWZ2H").then(()=>parcelRequire('6yRTH'));

});

parcelRegister("CbMTN", function(module, exports) {

let $072cb183c6b8510a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $072cb183c6b8510a$var$load("c41dA").then(()=>parcelRequire('Zu92b'));

});

parcelRegister("95nBU", function(module, exports) {

let $69d6e53d4c9f3822$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69d6e53d4c9f3822$var$load("hP4MP").then(()=>parcelRequire('dGxBa'));

});

parcelRegister("5zIEY", function(module, exports) {

let $40f2dd281e5bedda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40f2dd281e5bedda$var$load("dB864").then(()=>parcelRequire('afv3s'));

});

parcelRegister("g3fl3", function(module, exports) {

let $baf8d3118ac881fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $baf8d3118ac881fb$var$load("373qZ").then(()=>parcelRequire('fObJH'));

});

parcelRegister("lY2P3", function(module, exports) {

let $ffe1640fe1cf897a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffe1640fe1cf897a$var$load("7GCHJ").then(()=>parcelRequire('7Ri80'));

});

parcelRegister("hSkuL", function(module, exports) {

let $d03760ba1e343de9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d03760ba1e343de9$var$load("kkWcG").then(()=>parcelRequire('9Wa6U'));

});

parcelRegister("2LCWr", function(module, exports) {

let $203e2d8822e56c9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $203e2d8822e56c9b$var$load("aa9mr").then(()=>parcelRequire('6LCpG'));

});

parcelRegister("l3u53", function(module, exports) {

let $f541362ce11da5b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f541362ce11da5b1$var$load("bz1s9").then(()=>parcelRequire('jGfPl'));

});

parcelRegister("iagzr", function(module, exports) {

let $d39603c2a0dd6744$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d39603c2a0dd6744$var$load("gUDkD").then(()=>parcelRequire('1fRy2'));

});

parcelRegister("a57cu", function(module, exports) {

let $756ff4debffe7db3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $756ff4debffe7db3$var$load("6O8uL").then(()=>parcelRequire('dJHTm'));

});

parcelRegister("hhSu4", function(module, exports) {

let $c95e49928dd60070$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c95e49928dd60070$var$load("RuRWN").then(()=>parcelRequire('kBSC8'));

});

parcelRegister("4j5zJ", function(module, exports) {

let $322d42f08775439f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $322d42f08775439f$var$load("7po8a").then(()=>parcelRequire('lIYnd'));

});

parcelRegister("gVJGC", function(module, exports) {

let $032e47e175e40287$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $032e47e175e40287$var$load("aSbz2").then(()=>parcelRequire('9t6IE'));

});

parcelRegister("frDwI", function(module, exports) {

let $b3e809ccc2e1d73d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b3e809ccc2e1d73d$var$load("b0Nov").then(()=>parcelRequire('5B42Z'));

});

parcelRegister("DmzaP", function(module, exports) {

let $076525d57706c0a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $076525d57706c0a0$var$load("cinaN").then(()=>parcelRequire('h35rw'));

});

parcelRegister("bi3sU", function(module, exports) {

let $83841041c52a5833$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83841041c52a5833$var$load("jV8xH").then(()=>parcelRequire('hBjVA'));

});

parcelRegister("8cyvu", function(module, exports) {

let $5f8a360bd574f58e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f8a360bd574f58e$var$load("aP9AA").then(()=>parcelRequire('6GPkr'));

});

parcelRegister("9qg2r", function(module, exports) {

let $6dc2fbabc78c5440$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dc2fbabc78c5440$var$load("1YvQ0").then(()=>parcelRequire('6CsZV'));

});

parcelRegister("e0XLq", function(module, exports) {

let $a33f6cab1825618d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a33f6cab1825618d$var$load("8SIrc").then(()=>parcelRequire('bVRXd'));

});

parcelRegister("4senR", function(module, exports) {

let $33e4ef4a40c99386$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33e4ef4a40c99386$var$load("2nTkk").then(()=>parcelRequire('dGCxL'));

});

parcelRegister("faKVU", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.body.long-read":[{"type":0,"value":"You\u2019ve been diving deep into Confluence pages lately to stay ahead of the game. To help you keep up without the information overload, "},{"children":[{"type":0,"value":"meet Rovo"}],"type":8,"value":"b"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.body.page-created":[{"type":0,"value":"Now that you created a page, "},{"children":[{"type":0,"value":"take it further with Rovo"}],"type":8,"value":"b"},{"type":0,"value":" \u2014 you\u2019ll get instant feedback on clarity, structure, and completeness."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.body.page-watched":[{"type":0,"value":"Watching pages is a great way to stay in the loop. But instead of sifting through every notification, let Rovo give you a quick AI-powered catch-up on what changed."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.cta.long-read":[{"type":0,"value":"Summarize a page with Rovo"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.cta.page-created":[{"type":0,"value":"Review my page with Rovo"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.cta.page-watched":[{"type":0,"value":"Try AI catch-up"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.footer.unsubscribe":[{"type":1,"value":"link"},{"type":0,"value":" to opt out of future emails like this."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.footer.unsubscribe.cta":[{"type":0,"value":"Unsubscribe"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.heading.long-read":[{"type":0,"value":"You\u2019re crushing your reading list \uD83D\uDCDA"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.heading.page-created":[{"type":0,"value":"Nice work on your new page! \uD83C\uDF89"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.heading.page-watched":[{"type":0,"value":"You\'re watching a page \u2014 nice!"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.preheader.long-read":[{"type":0,"value":"Review key points in seconds with AI summary"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.preheader.page-created":[{"type":0,"value":"Get instant feedback on clarity and structure from Rovo"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.preheader.page-watched":[{"type":0,"value":"Get AI-powered summaries instead of notification noise"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.rovo-prompt.long-read":[{"type":0,"value":"Summarize the key points of this page, \\""},{"type":1,"value":"pageTitle"},{"type":0,"value":"\\""}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.rovo-prompt.page-created":[{"type":0,"value":"Review this page, \\""},{"type":1,"value":"pageTitle"},{"type":0,"value":"\\", for clarity, tone, and structure"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.rovo-prompt.page-watched":[{"type":0,"value":"Notify me when this page, \\""},{"type":1,"value":"pageTitle"},{"type":0,"value":"\\", is updated"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.subject.long-read":[{"type":0,"value":"That was a long read \u2014 here\'s a shortcut for next time"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.subject.page-created":[{"type":0,"value":"You just published a page - want a second opinion?"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.subject.page-watched":[{"type":0,"value":"A smarter way to stay updated on pages you watch"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.body.long-read":[{"type":0,"value":"Next time, let Rovo scan the page\u2014you\'ll get a bulleted breakdown of "},{"children":[{"type":0,"value":"action items and insights"}],"type":8,"value":"b"},{"type":0,"value":" without the grind."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.body.page-created":[{"children":[{"type":0,"value":"Ask Rovo"}],"type":8,"value":"b"},{"type":0,"value":" to review your page for clarity, tone, and structure. It\'s like having an editor on standby."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.body.page-watched":[{"type":0,"value":"Rovo summarizes all recent changes across the pages you watch, so you can stay informed without the notification noise."}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.title.long-read":[{"type":0,"value":"Summarize long pages in seconds"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.title.page-created":[{"type":0,"value":"Get instant feedback from Rovo"}],"cc-flywheel-activation.confluence-companion-tip-email.message-template.email.tip-card.title.page-watched":[{"type":0,"value":"Get an AI catch-up"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta1.button.go-to-content-type.link-name":[{"type":0,"value":"Go to "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta1.button.view-more-insights.link-name":[{"type":0,"value":"View more insights"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta2-template-link-name":[{"type":0,"value":"Try template"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta2-template-name":[{"type":0,"value":"Meeting Notes"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.first-line-with-content-type":[{"type":0,"value":"Your "},{"type":1,"value":"contentType"},{"type":0,"value":" just got its first view"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.second-line.line1":[{"type":0,"value":"Your work is already helping your team stay on the same page."}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.second-line.line2":[{"type":0,"value":"To keep the collaboration momentum going, many teams use Confluence for meeting agendas and notes to make shared decisions easy to reference."}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.footer.line-1.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. 341 George Street, Sydney, NSW, 2000, Australia"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.footer.line-2.unsubscribe.cta":[{"type":0,"value":"Unsubscribe"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.email.footer.line-2.with-unsubscribe-cta":[{"type":1,"value":"link"},{"type":0,"value":" to opt out of future emails like this."}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Image depicting a "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.header.img.alt":[{"type":0,"value":"Confluence logo"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.meeting-notes-template.img.alt":[{"type":0,"value":"Meeting notes template preview"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.page-icon.img.alt":[{"type":0,"value":"Page icon"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.blog-post":[{"type":0,"value":"blog post"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.live-page":[{"type":0,"value":"live page"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.page":[{"type":0,"value":"page"}],"cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.subject":[{"type":0,"value":"You just got your first view ever!"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.blogpost":[{"type":0,"value":"blog post"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.database":[{"type":0,"value":"database"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.anonymous":[{"type":0,"value":"There\'s a new reaction to your "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.first-reaction":[{"type":1,"value":"reactor"},{"type":0,"value":" reacted to your "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.second-reaction":[{"type":1,"value":"reactor"},{"type":0,"value":" and "},{"type":1,"value":"secondReactor"},{"type":0,"value":" reacted to your "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.direct.third-reaction-or-more":[{"type":1,"value":"reactor"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other"}]},"other":{"value":[{"type":7},{"type":0,"value":" others"}]}},"pluralType":"cardinal","type":6,"value":"numberOfOtherReactors"},{"type":0,"value":" reacted to your "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.live-doc":[{"type":0,"value":"live doc"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.page":[{"type":0,"value":"page"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.anonymous":[{"type":0,"value":"There\'s a new reaction to a "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.first-reaction":[{"type":1,"value":"reactor"},{"type":0,"value":" reacted to a "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.second-reaction":[{"type":1,"value":"reactor"},{"type":0,"value":" and "},{"type":1,"value":"secondReactor"},{"type":0,"value":" reacted to a "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.watching.third-reaction-or-more":[{"type":1,"value":"reactor"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other"}]},"other":{"value":[{"type":7},{"type":0,"value":" others"}]}},"pluralType":"cardinal","type":6,"value":"numberOfOtherReactors"},{"type":0,"value":" reacted to a "},{"type":1,"value":"contentType"}],"cc-flywheel-activation.confluence-inline-reaction.message-template.notification-drawer.whiteboard":[{"type":0,"value":"whiteboard"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.button-text":[{"type":0,"value":"Create meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.description":[{"type":0,"value":"Share goals, set context, and save time with a meeting notes template."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header":[{"type":0,"value":"Keep meetings aligned and actionable"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header-image.alt-text":[{"type":0,"value":"Atlassian Confluence logo"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.main-image.alt-text":[{"type":0,"value":"Meeting notes illustration showing document with highlighted content"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-image.alt-text":[{"type":0,"value":"Meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-text":[{"type":0,"value":"Meeting notes"}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.email.unsubscribe-link-text":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or unsubscribe "},{"children":[{"type":0,"value":"here"}],"type":8,"value":"a"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-personalized-use-case-expansion.message-template.email.subject":[{"type":0,"value":"Save time with a Confluence meeting notes template"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part1":[{"type":0,"value":"Your teammates are using Confluence to share project context, capture decisions, and more in "},{"type":1,"value":"projectName"},{"type":0,"value":"."}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part2":[{"type":0,"value":"Here\'s what they\'ve recently linked to your Jira project:"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.email.subject":[{"type":0,"value":"Your team in "},{"type":1,"value":"projectName"},{"type":0,"value":" is using Confluence for project docs--see what they\u2019ve added"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.button-cta":[{"type":0,"value":"Open Confluence"}],"cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.signoff":[{"type":0,"value":"See what else is happening across your company:"}],"confluence-personalized-use-case-expansion.first.body":[{"type":0,"value":"Create your first page"}],"confluence-personalized-use-case-expansion.first.cta":[{"type":0,"value":"Create a page"}],"confluence-personalized-use-case-expansion.first.title":[{"type":0,"value":"Get started with Confluence"}],"confluence-reactivate-inactive-link-paste-in-jira-notif.action.text":[{"type":0,"value":"View in Confluence"}],"confluence-reactivate-inactive-link-paste-in-jira-notif.message.body":[{"type":0,"value":"A Confluence page was shared with you in Jira"}],"confluence-reminder.cta.button":[{"type":0,"value":"Accept invite"}],"confluence-reminder.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"confluence-reminder.email.subject":[{"type":0,"value":"Reminder: "},{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to collaborate in Confluence"}],"confluence-reminder.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"confluence-reminder.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"confluence-reminder.inviter.avatar.alt":[{"type":0,"value":"Profile photo of "},{"type":1,"value":"inviterName"}],"confluence-reminder.main.heading":[{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to join Confluence"}],"confluence-reminder.product.description":[{"type":0,"value":"Plan projects, run meetings, and brainstorm ideas with your team\u2014all in one place."}],"confluence-reminder.redacted.heading":[{"type":0,"value":"Reminder: Join your team in Confluence"}],"confluence-reminder.redacted.subject":[{"type":0,"value":"Reminder: Join your team in Confluence"}],"confluence-reminder.social-proof.text":[{"type":1,"value":"numberOfCustomers"},{"type":0,"value":" customers use "},{"type":1,"value":"productName"},{"type":0,"value":" to move work forward"}],"confluence.fastAndSnappy.survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"confluence.fastAndSnappy.survey.score-subtext.neutral":[{"type":0,"value":"Neutral"}],"confluence.fastAndSnappy.survey.score-subtext.strongly-agree":[{"type":0,"value":"Strongly agree"}],"confluence.fastAndSnappy.survey.score-subtext.strongly-disagree":[{"type":0,"value":"Strongly disagree"}],"confluence.fastAndSnappy.survey.statement":[{"type":0,"value":"Confluence feels fast and snappy."}],"confluence.lovability.survey.new-question":[{"type":0,"value":"How much do you love using Confluence?"}],"confluence.lovability.survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"confluence.lovability.survey.score-subtext.neutral":[{"type":0,"value":"Neutral"}],"confluence.lovability.survey.score-subtext.not-at-all":[{"type":0,"value":"Not at all"}],"confluence.lovability.survey.score-subtext.very-much":[{"type":0,"value":"Very much"}],"confluence.lovability.survey.statement":[{"type":0,"value":"Confluence is a product I love using."}],"post-office-team.confluence-reactivate-inactive-link-paste-in-jira-email.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}],"post-office.cc-flywheel-activation.ootb-rovo-button-spotlight.screen-space-flags.body":[{"type":0,"value":"We\'ve prioritized your agenda today so you don\'t have to."}],"post-office.cc-flywheel-activation.ootb-rovo-button-spotlight.screen-space-flags.cta":[{"type":0,"value":"Review brief"}],"post-office.cc-flywheel-activation.ootb-rovo-button-spotlight.screen-space-flags.headline":[{"type":0,"value":"Your Daily Brief - "},{"type":1,"value":"briefDate"}],"post-office.cc-flywheel-activation.ootb-rovo-button-spotlight.screen-space-flags.spotlight.prompt":[{"type":0,"value":"Give me my daily brief"}],"post-office.cc-flywheel-activation.ootb-rovo-button-spotlight.screen-space-flags.spotlight.title":[{"type":0,"value":"Daily brief for "},{"type":1,"value":"briefDate"}],"post-office.confluence-connect-3p-tools-nudge.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-connect-3p-tools-nudge.heading":[{"type":0,"value":"See more at a glance"}],"post-office.confluence-connect-3p-tools-nudge.modal.close":[{"type":0,"value":"Close"}],"post-office.confluence-connect-3p-tools-nudge.modal.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-connect-3p-tools-nudge.modal.subtitle":[{"children":[{"type":0,"value":"Bring your team\u2019s work"}],"type":8,"value":"strong"},{"type":0,"value":" into Confluence pages with rich, interactive previews \u2013 no tab-switching needed."}],"post-office.confluence-connect-3p-tools-nudge.modal.teammates.empty":[{"type":0,"value":"Teams stay in sync by seeing live updates directly in Confluence."}],"post-office.confluence-connect-3p-tools-nudge.modal.teammates.few":[{"type":0,"value":"Your team is already using "},{"type":1,"value":"appName"},{"type":0,"value":" to work smarter."}],"post-office.confluence-connect-3p-tools-nudge.modal.teammates.lots":[{"type":0,"value":"\uD83D\uDE4C "},{"children":[{"type":0,"value":"50+ teammates"}],"type":8,"value":"strong"},{"type":0,"value":" already connected "},{"type":1,"value":"appName"},{"type":0,"value":" to Confluence."}],"post-office.confluence-connect-3p-tools-nudge.modal.teammates.many":[{"type":0,"value":"\uD83D\uDE4C "},{"children":[{"type":1,"value":"numTeammates"},{"type":0,"value":" teammates"}],"type":8,"value":"strong"},{"type":0,"value":" already connected "},{"type":1,"value":"appName"},{"type":0,"value":" to Confluence."}],"post-office.confluence-connect-3p-tools-nudge.modal.title":[{"type":0,"value":"Connect your most-used apps"}],"post-office.confluence-connect-3p-tools-nudge.multi-app-body":[{"type":0,"value":"Connect your apps to embed rich links in this space."}],"post-office.confluence-connect-3p-tools-nudge.multi-app.call.to.action":[{"type":0,"value":"Connect apps"}],"post-office.confluence-connect-3p-tools-nudge.single-app-body":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" to embed rich links in this space."}],"post-office.confluence-connect-3p-tools-nudge.single-app.call.to.action":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}]}');

});

parcelRegister("2hVW4", function(module, exports) {

let $1aaa1c2151bdc005$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1aaa1c2151bdc005$var$load("4Pnig").then(()=>parcelRequire('6YKP0'));

});

parcelRegister("fAaEK", function(module, exports) {

let $b5827be4aed14d9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5827be4aed14d9b$var$load("TlLku").then(()=>parcelRequire('hRqbJ'));

});

parcelRegister("8GjgQ", function(module, exports) {

let $652131bf4f1dbd09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $652131bf4f1dbd09$var$load("5JIp5").then(()=>parcelRequire('gKnJd'));

});

parcelRegister("5a41J", function(module, exports) {

let $3c210293e9e613b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c210293e9e613b8$var$load("fC8IH").then(()=>parcelRequire('ba3HB'));

});

parcelRegister("fix6E", function(module, exports) {

let $b23237a66943085a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b23237a66943085a$var$load("104CE").then(()=>parcelRequire('01Oij'));

});

parcelRegister("bwCLU", function(module, exports) {

let $8640c21a29e9f6e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8640c21a29e9f6e3$var$load("4OdV1").then(()=>parcelRequire('lwLs9'));

});

parcelRegister("4bt64", function(module, exports) {

let $30bec28d7b61e5a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $30bec28d7b61e5a5$var$load("29P6Z").then(()=>parcelRequire('4awuM'));

});

parcelRegister("6MvOp", function(module, exports) {

let $4effe701f6dd6e68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4effe701f6dd6e68$var$load("3LT6Y").then(()=>parcelRequire('k85Dj'));

});

parcelRegister("60oCJ", function(module, exports) {

let $45f5d7e8b83f8f10$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45f5d7e8b83f8f10$var$load("aUk88").then(()=>parcelRequire('jJZSp'));

});

parcelRegister("hgfXf", function(module, exports) {

let $c9104e8b701d7952$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9104e8b701d7952$var$load("ilw9Q").then(()=>parcelRequire('fx9se'));

});

parcelRegister("bf7FY", function(module, exports) {

let $82f70cb80c571015$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82f70cb80c571015$var$load("4sHGL").then(()=>parcelRequire('k4nta'));

});

parcelRegister("8TUis", function(module, exports) {

let $67af2127738bcf45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $67af2127738bcf45$var$load("gqzPx").then(()=>parcelRequire('9EUOa'));

});

parcelRegister("goxB3", function(module, exports) {

let $bef8f2d6347758e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bef8f2d6347758e0$var$load("c2wP7").then(()=>parcelRequire('gD4xH'));

});

parcelRegister("atMnC", function(module, exports) {

let $7a1224118f78d7b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a1224118f78d7b5$var$load("5GFGF").then(()=>parcelRequire('hWxC2'));

});

parcelRegister("eDBpO", function(module, exports) {

let $aa81bb1c2acc1dca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa81bb1c2acc1dca$var$load("jfz2k").then(()=>parcelRequire('5QZzy'));

});

parcelRegister("fndj2", function(module, exports) {

let $b313534d3146fddf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b313534d3146fddf$var$load("5ejxC").then(()=>parcelRequire('b33bB'));

});

parcelRegister("1Fzpx", function(module, exports) {

let $137516a37654b52e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $137516a37654b52e$var$load("fjNLR").then(()=>parcelRequire('ep2qs'));

});

parcelRegister("4ZXgO", function(module, exports) {

let $3a3ad5c1768ea6cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a3ad5c1768ea6cd$var$load("cHkhr").then(()=>parcelRequire('7W04t'));

});

parcelRegister("7ArxX", function(module, exports) {

let $5861436913b35b65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5861436913b35b65$var$load("dzJ0w").then(()=>parcelRequire('9u8ii'));

});

parcelRegister("kHy3v", function(module, exports) {

let $f1223d8a762292bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f1223d8a762292bb$var$load("hvMMD").then(()=>parcelRequire('hV7Xw'));

});

parcelRegister("27vXu", function(module, exports) {

let $18b5067cf8e92ad3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18b5067cf8e92ad3$var$load("5Gah6").then(()=>parcelRequire('jq88S'));

});

parcelRegister("aGvLS", function(module, exports) {

let $7c7678bb7d8fb38b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c7678bb7d8fb38b$var$load("e3rNQ").then(()=>parcelRequire('g9737'));

});

parcelRegister("brfyh", function(module, exports) {

let $853e47a07dd07467$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $853e47a07dd07467$var$load("fZSN3").then(()=>parcelRequire('d6LkT'));

});

parcelRegister("9S126", function(module, exports) {

let $72f9f54acf42fc05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72f9f54acf42fc05$var$load("c0zXU").then(()=>parcelRequire('3eG9z'));

});

parcelRegister("7Hl4N", function(module, exports) {

let $59ace5dc3c52929c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $59ace5dc3c52929c$var$load("lA9u7").then(()=>parcelRequire('4i7fO'));

});

parcelRegister("18607", function(module, exports) {

let $0d2b31733891be89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d2b31733891be89$var$load("PjV2H").then(()=>parcelRequire('9Hpkr'));

});

parcelRegister("k3ViT", function(module, exports) {

let $e9b089c2bf88f8fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9b089c2bf88f8fa$var$load("2Leae").then(()=>parcelRequire('7Nbjk'));

});

parcelRegister("cISby", function(module, exports) {

let $9433a02d93c95687$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9433a02d93c95687$var$load("75IKC").then(()=>parcelRequire('9NWLE'));

});

parcelRegister("3JasV", function(module, exports) {

let $2b6db147cad9b95d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b6db147cad9b95d$var$load("j26Ur").then(()=>parcelRequire('6YaUi'));

});

parcelRegister("9euEq", function(module, exports) {

let $6b8d3289ba4eb2f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b8d3289ba4eb2f0$var$load("77kvn").then(()=>parcelRequire('6z1Qp'));

});

parcelRegister("bQrvq", function(module, exports) {

let $89f9e326bdd7d5ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89f9e326bdd7d5ae$var$load("ikviJ").then(()=>parcelRequire('75xzh'));

});

parcelRegister("5y8fx", function(module, exports) {

let $40a686eab9c6c982$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40a686eab9c6c982$var$load("9zjjt").then(()=>parcelRequire('eEtHi'));

});

parcelRegister("jUr6Q", function(module, exports) {

let $e7e846ab1cc53017$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7e846ab1cc53017$var$load("2PJpv").then(()=>parcelRequire('9s0Bd'));

});

parcelRegister("1PEi6", function(module, exports) {

let $1559ced11f925384$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1559ced11f925384$var$load("jysVQ").then(()=>parcelRequire('dDVJF'));

});

parcelRegister("g9B2Z", function(module, exports) {
module.exports = JSON.parse('{"growth-confluence-find.confluence-d1d6-back-to-product-email.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.header":[{"type":0,"value":"Confluence is better "},{"type":1,"value":"lineBreak"},{"type":0,"value":" when the team\u2019s all in"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Your team\u2019s waiting for your great ideas!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Jump back into Confluence and start collaborating today"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Click "},{"children":[{"type":0,"value":"Share"}],"type":8,"value":"b"},{"type":0,"value":" in Confluence to copy a link you can send in email, Slack or MS Teams"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Link content to teammates"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Give feedback on docs in progress, and @mention teammates to keep everyone in the loop"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Comment in pages"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Align on the best path forward by voting on ideas as a team in whiteboards"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Vote in whiteboards"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-header":[{"type":0,"value":"How to use Confluence "},{"type":1,"value":"lineBreak"},{"type":0,"value":" with your team:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.subtext":[{"type":0,"value":"You\u2019re creating awesome ideas in Confluence, "},{"type":1,"value":"firstName"},{"type":0,"value":". It\u2019s "},{"type":1,"value":"lineBreak"},{"type":0,"value":" time to share them with your team!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83D\uDC4F Your ideas deserve an audience, "},{"type":1,"value":"firstName"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.header":[{"type":0,"value":"Get your ideas"},{"type":1,"value":"lineBreak"},{"type":0,"value":"on \u201Cpaper\u201D, "},{"type":1,"value":"firstName"},{"type":0,"value":"!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Ready to jump back in?"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Go back to Confluence today to start doing your team\u2019s best work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Jot down & organize your ideas with sleek editor tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Start with a page"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"@mention someone to show them what you\u2019re working on"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Brainstorm with teammates"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Connect Slack, Microsoft, or Google to keep the whole team in sync"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Connect your tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Easy ways to get setup:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.subtext":[{"type":0,"value":"It only takes a minute to wrap up your Confluence setup. Jump back in now to start unleashing your team\u2019s knowledge."}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83D\uDC4B Almost there\u2014need help setting up Confluence?"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.header":[{"type":0,"value":"It\u2019s time to make your space, more spacious"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Create a space everyone will rave about!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Create, organize & share to get the team\u2019s ideas all out there"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Simply drag items around in the left-hand sidebar & click + to create something new to your space"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Drag, drop & create in context"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Add folders to create directories where everything\u2019s stored. You can even convert pages to folders in the ... menu."}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Pop it into a folder"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Create "},{"children":[{"type":0,"value":"smart links"}],"type":8,"value":"b"},{"type":0,"value":" to auto-pull content into Confluence from other tools your team already uses, like Google Docs or MS Excel"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Link from your favorite tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Tips for building out your team\u2019s space:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.subtext":[{"type":0,"value":"Your "},{"children":[{"type":0,"value":"space"}],"type":8,"value":"b"},{"type":0,"value":" is like a hub for your team\u2019s docs & resources. "},{"type":1,"value":"lineBreak"},{"type":0,"value":"Create more and organize it all in your space today!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83E\uDD29 Impressive work you\u2019ve got there, "},{"type":1,"value":"firstName"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.header":[{"type":0,"value":"Take your team\u2019s knowledge"},{"type":1,"value":"lineBreak"},{"type":0,"value":" to the next level"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Go ahead - unleash your team\u2019s knowledge!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Speed up teamwork by building out your knowledge hub today"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Organize work for specific teams, projects and workstreams in separate spaces to create specialized knowledge repos"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"More spaces = more knowledge sources"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Rovo Search helps any team instantly find the info they need in Confluence, Slack, MS Office, and more!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Search across spaces & tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Need to make a page or presentation with info from multiple sources? Ask Rovo Chat to pull in knowledge from anywhere and auto-create it for you in a snap!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Just ask Rovo"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Try out the knowledge hub basics:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.subtext":[{"type":0,"value":"Creating new spaces with even more Confluence content helps "},{"type":1,"value":"lineBreak"},{"type":0,"value":"unlock knowledge across every team!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83E\uDDD9 Did you know? A knowledge hub makes work easier"}],"growth-confluence-find.message-templates.confluence-notification-drawer-getting-started-nth-user.welcome-to-confluence":[{"type":0,"value":"Welcome to Confluence, "},{"type":1,"value":"name"},{"type":0,"value":"! Learn how to create your first doc."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.atlassian-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.capture-your-ideas":[{"type":0,"value":"Capture your ideas as a team in pages, whiteboards, and more today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.capture-your-thoughts":[{"type":0,"value":"Capture your thoughts and ideas on docs and whiteboards."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.collaborate-with-your-new-teammate":[{"type":0,"value":"Collaborate with your new teammate on your next big idea today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.confluence-is":[{"children":[{"type":0,"value":"Confluence is a collaborative workspace"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers create and organize knowledge with their team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.copy-shareable-link":[{"type":1,"value":"copyIcon"},{"type":0,"value":" Copy shareable link"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.create-with-a-template":[{"type":0,"value":"Create with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.get-started-at-lightning-speed":[{"type":0,"value":"\u26A1 Get started at lightning speed with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.get-your-ideas-on-paper":[{"type":0,"value":"Get your ideas on \\"paper\\" with pages, whiteboards, and more in Confluence today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-job-adding":[{"type":0,"value":"Great job adding your work to your Confluence space!"},{"children":[],"type":8,"value":"br"},{"type":0,"value":"Invite a teammate to get feedback on it today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-momentum":[{"type":0,"value":"Great momentum, "},{"type":1,"value":"name"},{"type":0,"value":"! Keep it going with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-work":[{"type":0,"value":"\uD83E\uDD29 Great work\u2014Your space deserves an audience"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.invite-teammates":[{"type":0,"value":"Invite teammates"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.invite-your-teammates":[{"type":0,"value":"Invite your teammates to collaborate and align on ideas quickly."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.jump-back-in":[{"type":0,"value":"Jump back in"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.kick-off-collaboration":[{"type":0,"value":"Kick off collaboration with your new teammate, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited":[{"type":0,"value":"Last edited "},{"type":1,"value":"relativeTime"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortJustNow":[{"type":0,"value":"just now"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXDaysAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"d ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXHoursAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"h ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXMinutesAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"m ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.lets-create-your-next":[{"type":0,"value":"Let\'s create your next big idea, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.nows-the-time":[{"type":0,"value":"\u23F0 Now\'s the time to create something great as a team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.one-new-teammate":[{"type":0,"value":"1 new teammate joined your Confluence space. Capture your next big idea with them in pages, whiteboards, and more today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.save-time-with":[{"type":0,"value":"Save time with these templates"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.share-your-work":[{"type":0,"value":"Share your work with the team, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.space":[{"type":1,"value":"spaceName"},{"type":0,"value":" space"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.start-creating-fast":[{"type":0,"value":"Start creating fast with templates recommended for your team."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.team":[{"type":0,"value":"Team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.90-day-plan":[{"type":0,"value":"90-day plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.all-hands-meeting":[{"type":0,"value":"All hands meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.annual-plan-one-pager":[{"type":0,"value":"Annual plan one-pager"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.aws-architecture-diagram":[{"type":0,"value":"AWS architecture diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.business-plan-one-pager":[{"type":0,"value":"Business plan one-pager"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.business-status-update":[{"type":0,"value":"Business status update"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.career-development-plan":[{"type":0,"value":"Career development plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.competitive-analysis":[{"type":0,"value":"Competitive analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.content-design-glossary":[{"type":0,"value":"Content design glossary"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.content-strategy":[{"type":0,"value":"Content strategy"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.customer-impact-assessment":[{"type":0,"value":"Customer impact assessment"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.customer-interview-report":[{"type":0,"value":"Customer interview report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.daci-decision-documentation":[{"type":0,"value":"DACI: decision documentation"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-decision":[{"type":0,"value":"Design decision"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-review":[{"type":0,"value":"Design review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-sprint":[{"type":0,"value":"Design sprint"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-systems":[{"type":0,"value":"Design systems"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.devops-runbook":[{"type":0,"value":"DevOps runbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.disruptive-brainstorming":[{"type":0,"value":"Disruptive brainstorming"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.employee-handbook":[{"type":0,"value":"Employee handbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.end-of-week-status-report":[{"type":0,"value":"End of week status report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.executive-business-review":[{"type":0,"value":"Executive business review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.hiring-process":[{"type":0,"value":"Hiring process"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.how-to-article":[{"type":0,"value":"How-to article"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.hr-knowledge-base-management":[{"type":0,"value":"HR knowledge base management"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.incident-communication":[{"type":0,"value":"Incident communication"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.incident-postmortem":[{"type":0,"value":"Incident postmortem"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-change-management":[{"type":0,"value":"ITSM change management"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-known-errors":[{"type":0,"value":"ITSM known errors"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-post-incident-reviews":[{"type":0,"value":"ITSM post incident reviews"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-runbook":[{"type":0,"value":"ITSM runbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-weekly-major-incident-report":[{"type":0,"value":"ITSM weekly major incident report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.job-description":[{"type":0,"value":"Job description"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.lennys-performance-review":[{"type":0,"value":"Lenny\'s performance review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.lennys-product-requirements":[{"type":0,"value":"Lenny\'s product requirements"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-blog-post":[{"type":0,"value":"Marketing blog post"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-campaign":[{"type":0,"value":"Marketing campaign"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-plan":[{"type":0,"value":"Marketing plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.meeting-notes":[{"type":0,"value":"Meeting notes"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.message-house":[{"type":0,"value":"Message house"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.mutual-action-plan":[{"type":0,"value":"Mutual action plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.okrs":[{"type":0,"value":"OKRs"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.persona":[{"type":0,"value":"Persona"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.presenter-mode":[{"type":0,"value":"Presenter mode"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.product-requirements":[{"type":0,"value":"Product requirements"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.product-roadmap":[{"type":0,"value":"Product roadmap"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-kickoff":[{"type":0,"value":"Project kickoff"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-plan":[{"type":0,"value":"Project plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-status":[{"type":0,"value":"Project status"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-timeline-template":[{"type":0,"value":"Project timeline"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.qtc-acquisition":[{"type":0,"value":"QTC acquisition"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.quarterly-check-in":[{"type":0,"value":"Quarterly check in"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.remote-team-meeting":[{"type":0,"value":"Remote team meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.risk-assessment-matrix":[{"type":0,"value":"Risk assessment matrix"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.roles-and-responsibilities-play":[{"type":0,"value":"Roles and responsibilities play"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sales-account-planning":[{"type":0,"value":"Sales account planning"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sales-portal":[{"type":0,"value":"Sales portal"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.service-team-health-monitor":[{"type":0,"value":"Service team health monitor"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.smart-goals":[{"type":0,"value":"SMART goals"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.software-architecture-review":[{"type":0,"value":"Software architecture review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sprint-planning-meeting":[{"type":0,"value":"Sprint planning meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.stakeholder-communications":[{"type":0,"value":"Stakeholder communications"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.standard-operating-procedure":[{"type":0,"value":"Standard operating procedure (SOP)"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.strategic-plan":[{"type":0,"value":"Strategic plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.swot-analysis":[{"type":0,"value":"SWOT analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.team-homepage":[{"type":0,"value":"Team homepage"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.team-poster":[{"type":0,"value":"Team poster"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.to-do-list":[{"type":0,"value":"To-do list"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.troubleshooting-article":[{"type":0,"value":"Troubleshooting article"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.vendor-agreement":[{"type":0,"value":"Vendor agreement"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.virtual-event":[{"type":0,"value":"Virtual event"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.vision-to-values":[{"type":0,"value":"Vision to values"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.weekly-meeting-notes":[{"type":0,"value":"Weekly meeting notes"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.work-trip-planner":[{"type":0,"value":"Work trip planner"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.workshop-planner":[{"type":0,"value":"Workshop planner"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.writing-guidelines":[{"type":0,"value":"Writing guidelines"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.use-template":[{"type":0,"value":"Use template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.we-recommend-starting":[{"type":0,"value":"We recommend starting with these templates for your team:"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.we-recommend-these-templates":[{"type":0,"value":"We recommend these templates for your team:"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.4ls-retro":[{"type":0,"value":"4 Ls Retro"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.action-plan":[{"type":0,"value":"Action plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.annual-calendar-2025-2026":[{"type":0,"value":"Annual Calendar"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.brainwriting":[{"type":0,"value":"Brainwriting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.concept-map":[{"type":0,"value":"Concept map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.crazy-8s":[{"type":0,"value":"Crazy 8s brainstorming"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.disruptive-brainstorm":[{"type":0,"value":"Disruptive brainstorm"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.elevator-pitch":[{"type":0,"value":"Elevator pitch"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.executive-summary":[{"type":0,"value":"Executive summary"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.fishbone-diagram":[{"type":0,"value":"Fishbone diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.flow-chart":[{"type":0,"value":"Flowchart"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.focus-area-diagram":[{"type":0,"value":"Focus area diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.gap-analysis":[{"type":0,"value":"Gap analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.health-monitor":[{"type":0,"value":"Team health monitor"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.ice-breakers":[{"type":0,"value":"Icebreakers"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.incident-postmortem":[{"type":0,"value":"Incident postmortem"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.network-of-teams":[{"type":0,"value":"Network of teams"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.org-chart":[{"type":0,"value":"Org chart"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.prioritization":[{"type":0,"value":"Prioritization matrix"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.product-roadmap":[{"type":0,"value":"Product roadmap"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.product-vision-board":[{"type":0,"value":"Product vision board"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.root-cause-analysis":[{"type":0,"value":"Root cause analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.service-blueprint":[{"type":0,"value":"Service blueprint"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.simple-retrospective":[{"type":0,"value":"Simple retrospective"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.stakeholder-mapping":[{"type":0,"value":"Stakeholder mapping"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.swimlanes":[{"type":0,"value":"Swimlanes process map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.swot-analysis":[{"type":0,"value":"SWOT Analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.team-formation-guide":[{"type":0,"value":"Team charter template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.timeline-workflow":[{"type":0,"value":"Timeline workflow"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.user-story-map":[{"type":0,"value":"User story map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.workflow":[{"type":0,"value":"Workflow"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.youre-off-to-a-great-start":[{"type":0,"value":"\uD83D\uDE80 You\'re off to a great start\u2014Let\'s start creating"}],"post-office.growth-confluence-find.connect-tools-spotlight.body":[{"type":0,"value":"Connect your team\'s most used apps to get better answers and more results across Search and Chat."}],"post-office.growth-confluence-find.connect-tools-spotlight.headline":[{"type":0,"value":"Search across tools"}],"post-office.growth-confluence-find.connect-tools-spotlight.primary-action":[{"type":0,"value":"Setup"}]}');

});

parcelRegister("fbEnR", function(module, exports) {

let $b0e7357e954627b7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b0e7357e954627b7$var$load("f0QQr").then(()=>parcelRequire('lHwK0'));

});

parcelRegister("lFFbj", function(module, exports) {

let $fc6d5f16da313b78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc6d5f16da313b78$var$load("7SCfe").then(()=>parcelRequire('5Dtz6'));

});

parcelRegister("lkpSJ", function(module, exports) {

let $f86f8acbea4e71c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f86f8acbea4e71c3$var$load("gBnSH").then(()=>parcelRequire('clTHT'));

});

parcelRegister("2q85D", function(module, exports) {

let $1c3448f967669c96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c3448f967669c96$var$load("4Gj2m").then(()=>parcelRequire('aupue'));

});

parcelRegister("e64qf", function(module, exports) {

let $a4350e6487e7a647$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4350e6487e7a647$var$load("erHmp").then(()=>parcelRequire('i9WUc'));

});

parcelRegister("2WvPQ", function(module, exports) {

let $2249b15737fc6718$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2249b15737fc6718$var$load("2TXvN").then(()=>parcelRequire('dzBCh'));

});

parcelRegister("2KXXN", function(module, exports) {

let $201e641f926de858$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $201e641f926de858$var$load("9PURL").then(()=>parcelRequire('aqtW5'));

});

parcelRegister("anZ9e", function(module, exports) {

let $78fb7c0f42bd1cf3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78fb7c0f42bd1cf3$var$load("k05Rq").then(()=>parcelRequire('26Yuo'));

});

parcelRegister("1O5Gg", function(module, exports) {

let $150ede0762f4badd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $150ede0762f4badd$var$load("dysrY").then(()=>parcelRequire('2PlgO'));

});

parcelRegister("hXxhz", function(module, exports) {

let $d131c38f39f31537$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d131c38f39f31537$var$load("jwdSG").then(()=>parcelRequire('9mo2t'));

});

parcelRegister("iy9Kq", function(module, exports) {

let $d812f6b2f0bc3432$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d812f6b2f0bc3432$var$load("iQQla").then(()=>parcelRequire('9dcGU'));

});

parcelRegister("3vBHP", function(module, exports) {

let $28e183f275aff3cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28e183f275aff3cb$var$load("3WXLb").then(()=>parcelRequire('3xoT0'));

});

parcelRegister("cfRRK", function(module, exports) {

let $8ec0ab5ffcee345f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ec0ab5ffcee345f$var$load("d2BXS").then(()=>parcelRequire('iBnbf'));

});

parcelRegister("hudxz", function(module, exports) {

let $cbafbdd7936ffbc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cbafbdd7936ffbc0$var$load("axiIZ").then(()=>parcelRequire('fKPXt'));

});

parcelRegister("hY4Xy", function(module, exports) {

let $d14be31e19a5f6ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d14be31e19a5f6ad$var$load("knku1").then(()=>parcelRequire('bW32m'));

});

parcelRegister("OMRr8", function(module, exports) {

let $098a926123ac1748$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $098a926123ac1748$var$load("k3HCv").then(()=>parcelRequire('eWaec'));

});

parcelRegister("7wXr9", function(module, exports) {

let $57b9a07b85190a73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57b9a07b85190a73$var$load("lLsnH").then(()=>parcelRequire('6XZb6'));

});

parcelRegister("eYyK6", function(module, exports) {

let $ae719e7376c26a16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae719e7376c26a16$var$load("5Kwum").then(()=>parcelRequire('9yPNI'));

});

parcelRegister("aM9uG", function(module, exports) {

let $7d85c05d9c6a5c5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d85c05d9c6a5c5a$var$load("2Aa0X").then(()=>parcelRequire('a5AVm'));

});

parcelRegister("mfQCG", function(module, exports) {

let $042e59390b56282f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $042e59390b56282f$var$load("jBvQv").then(()=>parcelRequire('b2fc1'));

});

parcelRegister("e8E84", function(module, exports) {

let $a4b0f0d94b2068e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4b0f0d94b2068e6$var$load("9ABSL").then(()=>parcelRequire('gPzLX'));

});

parcelRegister("7z0do", function(module, exports) {

let $581bf7fae5ee235b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $581bf7fae5ee235b$var$load("3sAXm").then(()=>parcelRequire('9jOtf'));

});

parcelRegister("dgSBX", function(module, exports) {

let $9a9721a60f09e94b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a9721a60f09e94b$var$load("1kBTa").then(()=>parcelRequire('5IGZc'));

});

parcelRegister("gkvnV", function(module, exports) {

let $be36dbfac96bd445$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be36dbfac96bd445$var$load("lIVFi").then(()=>parcelRequire('BbFys'));

});

parcelRegister("ihJB0", function(module, exports) {

let $d4fd2eecb685463b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4fd2eecb685463b$var$load("hRgnK").then(()=>parcelRequire('fXLj8'));

});

parcelRegister("hQoao", function(module, exports) {

let $cfda09fcc9640b57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfda09fcc9640b57$var$load("lgYpI").then(()=>parcelRequire('fTPst'));

});

parcelRegister("j3rsf", function(module, exports) {

let $ddf39811daf68d40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ddf39811daf68d40$var$load("1ZotR").then(()=>parcelRequire('gHfD8'));

});

parcelRegister("i6lZE", function(module, exports) {

let $d2d9d8f9a7d773b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2d9d8f9a7d773b9$var$load("5bVy9").then(()=>parcelRequire('aa7HV'));

});

parcelRegister("gemmb", function(module, exports) {

let $bd0f4bbd71506615$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd0f4bbd71506615$var$load("k9iOi").then(()=>parcelRequire('fkmkX'));

});

parcelRegister("81f9G", function(module, exports) {

let $5d6a2c3f7279c27e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d6a2c3f7279c27e$var$load("gcmT1").then(()=>parcelRequire('akWu9'));

});

parcelRegister("aPdB2", function(module, exports) {

let $7e1936bf1b52e5cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e1936bf1b52e5cb$var$load("8lkec").then(()=>parcelRequire('6bvDK'));

});

parcelRegister("c0bPU", function(module, exports) {

let $8bceaa93261e320e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8bceaa93261e320e$var$load("7lmf9").then(()=>parcelRequire('1Slf4'));

});

parcelRegister("1aud0", function(module, exports) {

let $0d9e286d3d4341f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d9e286d3d4341f8$var$load("lrpec").then(()=>parcelRequire('jAu2u'));

});

parcelRegister("lW8b5", function(module, exports) {

let $ff855bb912271cc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff855bb912271cc4$var$load("lt60c").then(()=>parcelRequire('38vel'));

});

parcelRegister("ayxoO", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-feature-discovery.rovo-awareness-survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"cc-flywheel-feature-discovery.rovo-awareness-survey.statement":[{"type":0,"value":"I\'m aware of Atlassian Rovo and its functionalities."}],"confluence-home-rovo-awareness.banner.ask-anything-cta":[{"type":0,"value":"Ask Rovo"}],"confluence-home-rovo-awareness.banner.description":[{"type":0,"value":"Let your AI teammate do the heavy lifting so you can focus on what matters. Just ask."}],"confluence-home-rovo-awareness.banner.dismiss-banner-cta":[{"type":0,"value":"Close banner"}],"confluence-home-rovo-awareness.banner.header":[{"type":0,"value":"Ask Rovo to get you up to speed, create automations, brainstorm ideas, and more."}],"confluence-home-rovo-awareness.banner.more-ideas-cta":[{"type":0,"value":"More ideas"}],"confluence-home-rovo-awareness.banner.search-bar-image-text":[{"type":0,"value":"If you Rovo, you know..."}],"confluence-home-rovo-awareness.carousel-modal.audio-description":[{"type":0,"value":"Rovo\u2032s audio briefings can fill you in on key information from your team.Just hit play and go for a walk."}],"confluence-home-rovo-awareness.carousel-modal.audio-title":[{"type":0,"value":"Get briefed on the go"}],"confluence-home-rovo-awareness.carousel-modal.carousel-image-alt":[{"type":0,"value":"New Feature"}],"confluence-home-rovo-awareness.carousel-modal.create-description":[{"type":0,"value":"You describe, Rovo creates. Pages, live docs, whiteboards, databases \u2014 Rovo does it all."}],"confluence-home-rovo-awareness.carousel-modal.create-title":[{"type":0,"value":"Bye-bye blank page"}],"confluence-home-rovo-awareness.carousel-modal.description":[{"type":0,"value":"Discover how you can use Rovo to make your life easier."}],"confluence-home-rovo-awareness.carousel-modal.diagram-description":[{"type":0,"value":"Rovo can draw the diagrams for you that clearly communicate your ideas."}],"confluence-home-rovo-awareness.carousel-modal.diagram-title":[{"type":0,"value":"Let flow charts flow"}],"confluence-home-rovo-awareness.carousel-modal.lozenge-coming-soon":[{"type":0,"value":"Coming soon"}],"confluence-home-rovo-awareness.carousel-modal.lozenge-new":[{"type":0,"value":"New"}],"confluence-home-rovo-awareness.carousel-modal.next-label":[{"type":0,"value":"Next"}],"confluence-home-rovo-awareness.carousel-modal.previous-label":[{"type":0,"value":"Previous"}],"confluence-home-rovo-awareness.carousel-modal.title":[{"type":0,"value":"More ways to Rovo"}],"post-office.confluence-create-with-rovo-side-nav-nudge.body":[{"type":0,"value":"With a simple prompt, Rovo can draft a page or whiteboard."}],"post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action":[{"type":0,"value":"Show me how"}],"post-office.confluence-create-with-rovo-side-nav-nudge.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-create-with-rovo-side-nav-nudge.heading":[{"type":0,"value":"You describe, Rovo creates"}],"post-office.confluence-maui-changeboarding.remix.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-changeboarding.remix.spotlight-header":[{"type":0,"value":"Transform your content"}],"post-office.confluence-maui-changeboarding.remix.spotlight-image-alt":[{"type":0,"value":"Remix content illustration"}],"post-office.confluence-maui-changeboarding.remix.spotlight-new-description":[{"type":0,"value":"Create charts, diagrams, and other content inspired by existing work."}],"post-office.confluence-maui-changeboarding.remix.spotlight-new-header":[{"type":0,"value":"Create custom visuals"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-done-button":[{"type":0,"value":"Done"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-next-button":[{"type":0,"value":"Next"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-1-description":[{"type":0,"value":"Ask Rovo to make adjustments to your remix."}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-1-header":[{"type":0,"value":"Refine with Rovo"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-copy-description":[{"type":0,"value":"Then paste it somewhere else in Confluence to view it later."}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-copy-header":[{"type":0,"value":"Copy this remix"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-insert-description":[{"type":0,"value":"Add your remix directly to this content, or copy and paste it somewhere else."}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-insert-header":[{"type":0,"value":"Insert this remix"}],"post-office.confluence-maui-slides-create-spotlight.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-slides-create-spotlight.spotlight-description":[{"type":0,"value":"Turn rough ideas and existing content into polished slides in seconds."}],"post-office.confluence-maui-slides-create-spotlight.spotlight-header":[{"type":0,"value":"Create stunning presentations"}],"post-office.confluence-maui-slides-create-spotlight.spotlight-image-alt":[{"type":0,"value":"Create slides illustration"}],"post-office.confluence-maui-slides-edit-spotlight.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-slides-edit-spotlight.spotlight-description":[{"type":0,"value":"Use Rovo to add or remove slides, edit sections, change the tone, and more."}],"post-office.confluence-maui-slides-edit-spotlight.spotlight-header":[{"type":0,"value":"Refine slides with Rovo"}],"post-office.confluence-maui-slides-modal.description":[{"type":0,"value":"Create polished presentations with Rovo."}],"post-office.confluence-maui-slides-modal.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-maui-slides-modal.feature-add-sources":[{"type":0,"value":"Add sources or links for context"}],"post-office.confluence-maui-slides-modal.feature-describe-presentation":[{"type":0,"value":"Start by describing your ideal presentation"}],"post-office.confluence-maui-slides-modal.feature-refine-slides":[{"type":0,"value":"Refine your slides with Rovo"}],"post-office.confluence-maui-slides-modal.got-it":[{"type":0,"value":"Got it"}],"post-office.confluence-maui-slides-modal.media-alt":[{"type":0,"value":"Slides feature illustration"}],"post-office.confluence-maui-slides-modal.title":[{"type":0,"value":"Welcome to Slides"}],"post-office.confluence-maui-slides-modal.try-it-out":[{"type":0,"value":"Create my own"}],"post-office.confluence-maui-slides-toolbar-spotlight.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-slides-toolbar-spotlight.spotlight-description":[{"type":0,"value":"Ask Rovo to rewrite, adjust tone, shorten or lengthen text, or apply other changes."}],"post-office.confluence-maui-slides-toolbar-spotlight.spotlight-header":[{"type":0,"value":"Make edits with Rovo"}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-description":[{"type":0,"value":"Transform content into slides, infographics, whiteboards, and more."}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-header":[{"type":0,"value":"Remix this content"}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-image-alt":[{"type":0,"value":"Remix content illustration"}]}');

});

parcelRegister("44VVw", function(module, exports) {

let $2f8478323d4c13d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f8478323d4c13d9$var$load("i9sd0").then(()=>parcelRequire('cNaUs'));

});

parcelRegister("lj8VP", function(module, exports) {

let $f8324cf91eef6216$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f8324cf91eef6216$var$load("aNg21").then(()=>parcelRequire('5PagH'));

});

parcelRegister("7b5JG", function(module, exports) {

let $539e027f2ee89c1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $539e027f2ee89c1e$var$load("YEGhv").then(()=>parcelRequire('5poWa'));

});

parcelRegister("fkiO8", function(module, exports) {

let $b287500f9315e7e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b287500f9315e7e7$var$load("d8WL7").then(()=>parcelRequire('bIxfG'));

});

parcelRegister("ctn5G", function(module, exports) {

let $914a1ac5f73c88a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $914a1ac5f73c88a0$var$load("g9jRX").then(()=>parcelRequire('3HEHB'));

});

parcelRegister("lEFIu", function(module, exports) {

let $fc3db16eda3725af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc3db16eda3725af$var$load("120fV").then(()=>parcelRequire('5CGAS'));

});

parcelRegister("6Vy8L", function(module, exports) {

let $50b28c8918e987db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $50b28c8918e987db$var$load("ekyg6").then(()=>parcelRequire('aqygr'));

});

parcelRegister("i9SUy", function(module, exports) {

let $d383a97e5a50810d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d383a97e5a50810d$var$load("j5F5K").then(()=>parcelRequire('3QoEw'));

});

parcelRegister("3D2oa", function(module, exports) {

let $2a46de015d91a00b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a46de015d91a00b$var$load("dXu4x").then(()=>parcelRequire('9e0h0'));

});

parcelRegister("aBfSC", function(module, exports) {

let $7b79ad85a00e11a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b79ad85a00e11a4$var$load("34YSq").then(()=>parcelRequire('gQOAT'));

});

parcelRegister("aXfLu", function(module, exports) {

let $7f9ba4ae6111fc3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f9ba4ae6111fc3f$var$load("18TX5").then(()=>parcelRequire('fhOxf'));

});

parcelRegister("hHbpn", function(module, exports) {

let $ce1f4d45b003d767$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce1f4d45b003d767$var$load("9Cdzw").then(()=>parcelRequire('hev8y'));

});

parcelRegister("3FQml", function(module, exports) {

let $2acdd0e8bc9a2ee8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2acdd0e8bc9a2ee8$var$load("gfsfz").then(()=>parcelRequire('3ZaVC'));

});

parcelRegister("epMeh", function(module, exports) {

let $a7e8cfd1cddae748$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7e8cfd1cddae748$var$load("guNAg").then(()=>parcelRequire('7Scqn'));

});

parcelRegister("M4CYG", function(module, exports) {

let $090812c4edc10c79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $090812c4edc10c79$var$load("cM3gY").then(()=>parcelRequire('fvvbN'));

});

parcelRegister("ax0T5", function(module, exports) {

let $7aadacaa18fff6dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7aadacaa18fff6dc$var$load("6yRq3").then(()=>parcelRequire('gXjXB'));

});

parcelRegister("h19CY", function(module, exports) {

let $c639ff86e9f73b05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c639ff86e9f73b05$var$load("cft22").then(()=>parcelRequire('8s2Tz'));

});

parcelRegister("jd0kM", function(module, exports) {

let $dfbf7d95e8ee8e7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dfbf7d95e8ee8e7c$var$load("gctEz").then(()=>parcelRequire('dLsgU'));

});

parcelRegister("cP3TX", function(module, exports) {

let $955d46369d6a6694$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $955d46369d6a6694$var$load("9PPH7").then(()=>parcelRequire('3OurB'));

});

parcelRegister("kkbnw", function(module, exports) {

let $ecbe806929203a1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ecbe806929203a1c$var$load("1y1eN").then(()=>parcelRequire('k5E3d'));

});

parcelRegister("jwK8C", function(module, exports) {

let $e374cb874d83eee2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e374cb874d83eee2$var$load("e8jpx").then(()=>parcelRequire('2wn0H'));

});

parcelRegister("h63LY", function(module, exports) {

let $c725ec6a0d7788ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c725ec6a0d7788ad$var$load("6tWAg").then(()=>parcelRequire('81BX8'));

});

parcelRegister("bZxBV", function(module, exports) {

let $8baf769f66212337$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8baf769f66212337$var$load("fjbzp").then(()=>parcelRequire('krc3E'));

});

parcelRegister("8dMdU", function(module, exports) {

let $5fc4f1ca32e0944c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5fc4f1ca32e0944c$var$load("kTsGE").then(()=>parcelRequire('dwA0d'));

});

parcelRegister("bb8gm", function(module, exports) {

let $8237219b8db303ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8237219b8db303ed$var$load("8JuRr").then(()=>parcelRequire('ild7S'));

});

parcelRegister("gEoeD", function(module, exports) {

let $c1f32e5da3fa24eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1f32e5da3fa24eb$var$load("aiOLS").then(()=>parcelRequire('g2xHn'));

});

parcelRegister("ax3oZ", function(module, exports) {

let $7aafa00a85ba7dfe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7aafa00a85ba7dfe$var$load("eleM6").then(()=>parcelRequire('eO2lu'));

});

parcelRegister("6qkex", function(module, exports) {

let $4ad4ddbde676a0ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ad4ddbde676a0ad$var$load("1pFHs").then(()=>parcelRequire('l7tGE'));

});

parcelRegister("cnFuw", function(module, exports) {

let $9037d15592e9cad6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9037d15592e9cad6$var$load("jEuPM").then(()=>parcelRequire('bbnmk'));

});

parcelRegister("32434", function(module, exports) {

let $2354b2ee7aa9e8b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2354b2ee7aa9e8b2$var$load("d0Fxy").then(()=>parcelRequire('7WiGm'));

});

parcelRegister("cnPZE", function(module, exports) {

let $903ff6d13dcf8a8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $903ff6d13dcf8a8a$var$load("deThS").then(()=>parcelRequire('d7TUP'));

});

parcelRegister("ceQUP", function(module, exports) {

let $8e8fd6c31a542c28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e8fd6c31a542c28$var$load("a7oQV").then(()=>parcelRequire('jxmii'));

});

parcelRegister("2Ee5k", function(module, exports) {

let $1eda3e30d24fea96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1eda3e30d24fea96$var$load("7sItg").then(()=>parcelRequire('kqsMW'));

});

parcelRegister("lYBDN", function(module, exports) {

let $fffc66453f53c7c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fffc66453f53c7c9$var$load("kKXTS").then(()=>parcelRequire('6pgwb'));

});

parcelRegister("cYsan", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("4P6Vl", function(module, exports) {

let $38314bc418b47d1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $38314bc418b47d1e$var$load("3Mvpe").then(()=>parcelRequire('70m7S'));

});

parcelRegister("27aNh", function(module, exports) {

let $18a49ba8fa6de244$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18a49ba8fa6de244$var$load("frKDr").then(()=>parcelRequire('hqEeD'));

});

parcelRegister("aSlsY", function(module, exports) {

let $7eaf99476a49e0ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7eaf99476a49e0ba$var$load("bjjck").then(()=>parcelRequire('a3QjM'));

});

parcelRegister("cOAck", function(module, exports) {

let $95463bac650a58f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95463bac650a58f1$var$load("iJz71").then(()=>parcelRequire('irzXr'));

});

parcelRegister("76gkg", function(module, exports) {

let $52b5c1e6747725bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $52b5c1e6747725bd$var$load("1ynXL").then(()=>parcelRequire('lPLnq'));

});

parcelRegister("2Bl1Y", function(module, exports) {

let $1e4f59c25a3a3683$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1e4f59c25a3a3683$var$load("9Tqjv").then(()=>parcelRequire('a2jXj'));

});

parcelRegister("grzFC", function(module, exports) {

let $bf8ad656fa93659a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf8ad656fa93659a$var$load("95GQ6").then(()=>parcelRequire('9prXl'));

});

parcelRegister("6JE8A", function(module, exports) {

let $4e7614872121963d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e7614872121963d$var$load("cOqwO").then(()=>parcelRequire('6U26G'));

});

parcelRegister("9S9M8", function(module, exports) {

let $7300bd6911e5c79d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7300bd6911e5c79d$var$load("lMCPq").then(()=>parcelRequire('ihIJC'));

});

parcelRegister("gkLcq", function(module, exports) {

let $be4320716f6f41e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be4320716f6f41e0$var$load("akfMh").then(()=>parcelRequire('ilzaM'));

});

parcelRegister("lLyBc", function(module, exports) {

let $fd88d36b34961fe5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd88d36b34961fe5$var$load("g4Ezq").then(()=>parcelRequire('8MEkZ'));

});

parcelRegister("4jCEx", function(module, exports) {

let $3246eb6e5b598b44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3246eb6e5b598b44$var$load("7oKyj").then(()=>parcelRequire('lWnug'));

});

parcelRegister("7OGyS", function(module, exports) {

let $5b0e37bb750cefc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5b0e37bb750cefc3$var$load("4WuEN").then(()=>parcelRequire('8z5Fd'));

});

parcelRegister("8clR5", function(module, exports) {

let $5f8065b59b285a42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f8065b59b285a42$var$load("7eb4c").then(()=>parcelRequire('dPsCl'));

});

parcelRegister("3MYuU", function(module, exports) {

let $2c24c857c76b6de3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c24c857c76b6de3$var$load("9gvzs").then(()=>parcelRequire('2gTzu'));

});

parcelRegister("aBCf4", function(module, exports) {

let $7b8b062d544f25df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b8b062d544f25df$var$load("2NHJm").then(()=>parcelRequire('iy8je'));

});

parcelRegister("5Bhq2", function(module, exports) {

let $413deb7e80b78a05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $413deb7e80b78a05$var$load("lzkjk").then(()=>parcelRequire('4Ykei'));

});

parcelRegister("3rRY7", function(module, exports) {

let $282dc1ca58969375$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $282dc1ca58969375$var$load("3Dg4n").then(()=>parcelRequire('lwBQR'));

});

parcelRegister("30lWk", function(module, exports) {

let $230263f88e4f1e8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $230263f88e4f1e8f$var$load("kgkaG").then(()=>parcelRequire('3pX63'));

});

parcelRegister("hA595", function(module, exports) {

let $ccc9ca46abe22024$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ccc9ca46abe22024$var$load("c9cT7").then(()=>parcelRequire('8j7Sz'));

});

parcelRegister("3RoXR", function(module, exports) {

let $2cf9afc82bb3e4cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2cf9afc82bb3e4cf$var$load("30Bx7").then(()=>parcelRequire('jFBzj'));

});

parcelRegister("2j9hJ", function(module, exports) {

let $1ae48ee9ce334678$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ae48ee9ce334678$var$load("8eAVU").then(()=>parcelRequire('dY0nX'));

});

parcelRegister("eRauK", function(module, exports) {

let $ad0e2803226cb0e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ad0e2803226cb0e9$var$load("aMdzs").then(()=>parcelRequire('joaA7'));

});

parcelRegister("krh33", function(module, exports) {

let $ee138dac9f451845$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee138dac9f451845$var$load("kRNym").then(()=>parcelRequire('28wDW'));

});

parcelRegister("eaNh3", function(module, exports) {

let $a51838ac0750cef3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a51838ac0750cef3$var$load("jwuG0").then(()=>parcelRequire('keiA6'));

});

parcelRegister("dbpza", function(module, exports) {

let $999022602688a0f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $999022602688a0f5$var$load("7In40").then(()=>parcelRequire('1g9AV'));

});

parcelRegister("gDeem", function(module, exports) {

let $c1bb53c9b9db92da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1bb53c9b9db92da$var$load("4rTb3").then(()=>parcelRequire('j2Qpo'));

});

parcelRegister("16hwG", function(module, exports) {

let $0cd3f2535cd35711$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cd3f2535cd35711$var$load("7zydV").then(()=>parcelRequire('5Ss5z'));

});

parcelRegister("hsd8R", function(module, exports) {

let $cb4f3ee4377f6801$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb4f3ee4377f6801$var$load("gBME1").then(()=>parcelRequire('dHZrs'));

});

parcelRegister("2JjwY", function(module, exports) {

let $1fceef26e364702d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fceef26e364702d$var$load("4jkxA").then(()=>parcelRequire('9HpHb'));

});

parcelRegister("epoZZ", function(module, exports) {

let $a7d6cab9f5f604fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7d6cab9f5f604fb$var$load("5xqxE").then(()=>parcelRequire('e8JXo'));

});

parcelRegister("2k0Bf", function(module, exports) {

let $1b0dea1f7626ee92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b0dea1f7626ee92$var$load("6n8TN").then(()=>parcelRequire('iqugp'));

});

parcelRegister("gGmMl", function(module, exports) {

let $c2523cf52d78d8e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2523cf52d78d8e0$var$load("4GzfW").then(()=>parcelRequire('6oUMz'));

});

parcelRegister("4Juzw", function(module, exports) {

let $3723145385ae5bca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3723145385ae5bca$var$load("8QvoP").then(()=>parcelRequire('ll8DE'));

});

parcelRegister("7BpGO", function(module, exports) {
module.exports = JSON.parse('{"jsm-cbp-grace-period-notification.message.link.extra.objects":[{"type":0,"value":"Get extra objects"}],"jsm-cbp-grace-period-notification.message.link.learn.more":[{"type":0,"value":"Learn more"}],"jsm-cbp-grace-period-notification.message.link.manage.usage":[{"type":0,"value":"Manage usage"}],"jsm-cbp-grace-period-notification.message.text.ninety.days":[{"type":0,"value":"Consumption-based pricing will come into effect after "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"jsm-cbp-grace-period-notification.message.text.thirty.days":[{"type":0,"value":"Extra usage of Assets and the virtual service agent in Jira Service Management will be billed."}],"jsm-cbp-grace-period-notification.message.title.ninety.days":[{"type":0,"value":"You are nearing the end of your Grace period"}],"jsm-cbp-grace-period-notification.message.title.thirty.days":[{"type":0,"value":"Consumption-based pricing starts in "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading":[{"type":0,"value":"Consumption-based pricing starts with your next renewal"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro":[{"type":0,"value":"We\u2019re letting you know that Assets and Virtual service agent will move to consumption-based pricing at your next renewal on "},{"type":1,"value":"cbpEffectiveDate"},{"type":0,"value":". Additional charges will only apply if your usage exceeds the included limit. Check your current usage and learn more below."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know":[{"type":0,"value":"Helpful things to know:"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text":[{"type":0,"value":"comment"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text":[{"type":0,"value":"lightbulb"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema":[{"children":[{"type":0,"value":"Contact support"}],"type":8,"value":"a"},{"type":0,"value":" if you have any questions"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit":[{"type":0,"value":"Consider "},{"children":[{"type":0,"value":"optimizing the structure of your schemas"}],"type":8,"value":"a"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.more-details-button":[{"type":0,"value":"More details"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject":[{"type":0,"value":"[Reminder] Upcoming pricing changes to Assets and Virtual Service Agent"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide":[{"type":0,"value":"For more information, read more about "},{"children":[{"type":0,"value":"how feature usage limits work"}],"type":8,"value":"a"},{"type":0,"value":"."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.view-and-manage-usage-button":[{"type":0,"value":"View and manage usage"}],"jsm-sequoia.nearing-storage-limit.body.agent-limit":[{"type":0,"value":"Get "},{"children":[{"type":0,"value":"unlimited agents"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"250 GB file storage"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.body.ai-written-support":[{"type":0,"value":"Power your Rovo agent with "},{"children":[{"type":0,"value":"AI written support articles"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.body.assets":[{"type":0,"value":"Track business "},{"children":[{"type":0,"value":"assets"}],"type":8,"value":"b"},{"type":0,"value":" and link them to work items"}],"jsm-sequoia.nearing-storage-limit.body.disclaimer":[{"type":0,"value":"We will automatically upgrade you to a "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":". You can "},{"children":[{"type":0,"value":"switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime by reducing your limits."}],"jsm-sequoia.nearing-storage-limit.body.rovo-ai-agents":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"Rovo AI agents"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.button.try-standard":[{"type":0,"value":"Try Standard for free"}],"jsm-sequoia.nearing-storage-limit.caption.body":[{"type":0,"value":"You\'ve used at least 1.8 GB of the 2 GB storage available on the Free plan. Once you reach 2 GB, you\'ll be upgraded to the 14-day free trial of our Standard plan."}],"jsm-sequoia.nearing-storage-limit.caption.disclaimer":[{"type":0,"value":"What happens once storage is full?"}],"jsm-sequoia.nearing-storage-limit.caption.heading":[{"type":0,"value":"You\'re almost out of storage"}],"jsm-sequoia.nearing-storage-limit.email-header-alt":[{"type":0,"value":"Service Collection"}],"jsm-sequoia.nearing-storage-limit.email-header-customer-service-management":[{"type":0,"value":"Customer Service Management"}],"jsm-sequoia.nearing-storage-limit.email-header-jira-service-management":[{"type":0,"value":"Jira Service Management"}],"jsm-sequoia.nearing-storage-limit.email-header-rovo":[{"type":0,"value":"Rovo"}],"jsm-sequoia.nearing-storage-limit.email-header-subtitle":[{"type":0,"value":"Includes:"}],"jsm-sequoia.nearing-storage-limit.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"jsm-sequoia.nearing-storage-limit.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"jsm-sequoia.nearing-storage-limit.footer.dot-separator":[{"type":0,"value":"\u2022"}],"jsm-sequoia.nearing-storage-limit.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"jsm-sequoia.nearing-storage-limit.footer.facebook-title":[{"type":0,"value":"Facebook"}],"jsm-sequoia.nearing-storage-limit.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"jsm-sequoia.nearing-storage-limit.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"jsm-sequoia.nearing-storage-limit.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"jsm-sequoia.nearing-storage-limit.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"jsm-sequoia.nearing-storage-limit.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"jsm-sequoia.nearing-storage-limit.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"jsm-sequoia.nearing-storage-limit.footer.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"jsm-sequoia.nearing-storage-limit.footer.x-alt-text":[{"type":0,"value":"X"}],"jsm-sequoia.nearing-storage-limit.footer.x-title":[{"type":0,"value":"X"}],"jsm-sequoia.nearing-storage-limit.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"jsm-sequoia.nearing-storage-limit.footer.youtube-title":[{"type":0,"value":"Youtube"}],"jsm-sequoia.nearing-storage-limit.link.explore-plans":[{"type":0,"value":"Explore all plans"}],"jsm-sequoia.service-collection-nearing-storage-limit-awareness.email.subject":[{"type":0,"value":"You are about to reach your limit"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.avatar.alt_text.user_avatar":[{"type":0,"value":"User Avatar"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.connection":[{"type":0,"value":"Connection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.csm":[{"type":0,"value":"Customer Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.id-badge":[{"type":0,"value":"ID Badge"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.jsm":[{"type":0,"value":"Jira Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.service-collection":[{"type":0,"value":"Service Collection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.description":[{"type":0,"value":"Deliver better customer support and quickly turn feedback into product improvements."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.title":[{"type":0,"value":"Delight external customers with purpose-built features"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.description":[{"type":0,"value":"Make internal support easier by enabling HR, IT, and other teams to resolve employee requests quickly."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.title":[{"type":0,"value":"Unite teams to deliver exceptional service experiences"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.alt_text.atlassian":[{"type":0,"value":"Atlassian"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.contact_us":[{"type":0,"value":"Contact us"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.privacy_policy":[{"type":0,"value":"Privacy Policy"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.read_our_blog":[{"type":0,"value":"Blog"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.twitter.no-translate":[{"type":0,"value":"Twitter"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.greeting":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":","}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.message":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" has requested a trial of Service Collection."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" requested your organization try Service Collection, Atlassian\u2019s solution for AI service management at high velocity."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.cta":[{"type":0,"value":"Try Service Collection for free"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.review-request-cta":[{"type":0,"value":"Review request"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.subject":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":", "},{"type":1,"value":"requestingUserName"},{"type":0,"value":" wants you to start a Service Collection trial"}],"jsm-servco-uplift-notification.message.button.servco.uplift":[{"type":0,"value":"Try it now"}],"jsm-servco-uplift-notification.message.link.learn.more.servco.uplift":[{"type":0,"value":"What\'s Service Collection"}],"jsm-servco-uplift-notification.message.text.servco.uplift":[{"type":0,"value":"Deliver great service experiences fast with a template designed to help your external customers."}],"jsm-servco-uplift-notification.message.title.servco.uplift":[{"type":0,"value":"Try Customer Service Management today with Service Collection"}],"post-office.ad-controls-sequoia.custom-dropdown-item.1.no-translate":[{"type":0,"value":"the first custom dropdown item"}],"post-office.ad-controls-sequoia.custom-dropdown-item.2.no-translate":[{"type":0,"value":"the second custom dropdown item"}],"post-office.ad-controls-sequoia.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls-sequoia.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls-sequoia.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls-sequoia.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls-sequoia.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls-sequoia.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls-sequoia.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls-sequoia.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls-sequoia.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls-sequoia.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls-sequoia.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls-sequoia.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls-sequoia.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls-sequoia.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls-sequoia.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-dashboard-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-dashboard-item.menu-item-label":[{"type":0,"value":"Dashboards"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-data-manager-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-data-manager-item.menu-item-label":[{"type":0,"value":"Data Manager"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-item.menu-item-label":[{"type":0,"value":"Assets"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-issue-view-details-section.description":[{"type":0,"value":"Update incidents from within Slack and summarize key events with AI."}],"post-office.jsm-issue-view-details-section.dismiss-button-one":[{"type":0,"value":"I don\'t use Slack"}],"post-office.jsm-issue-view-details-section.reasons-modal-bullet-one":[{"type":0,"value":"your usage of Jira Service Management\'s Alerts and Incidents features"}],"post-office.jsm-issue-view-details-section.reasons-modal-explanation":[{"type":0,"value":"We think Service Collection Premium will improve your team\'s workflow. The recommendation is based on:"}],"post-office.jsm-issue-view-details-section.title":[{"type":0,"value":"Resolve incidents on Slack with AI"}]}');

});

parcelRegister("6QBDZ", function(module, exports) {

let $4fc4ccb32bbf259c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4fc4ccb32bbf259c$var$load("buWQo").then(()=>parcelRequire('jwwdv'));

});

parcelRegister("hsbp6", function(module, exports) {

let $cb4de5c053c35e1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb4de5c053c35e1c$var$load("bxZKZ").then(()=>parcelRequire('dvpU1'));

});

parcelRegister("5XNq8", function(module, exports) {

let $4578cc570218199d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4578cc570218199d$var$load("4uuyw").then(()=>parcelRequire('fwZvg'));

});

parcelRegister("jaglo", function(module, exports) {

let $df3ba110688b00d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df3ba110688b00d6$var$load("2qXcV").then(()=>parcelRequire('4VUSU'));

});

parcelRegister("lln0M", function(module, exports) {

let $f89d68bcea0ff631$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f89d68bcea0ff631$var$load("elG2c").then(()=>parcelRequire('3iOYF'));

});

parcelRegister("4R0PP", function(module, exports) {

let $388cc2755fc72999$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $388cc2755fc72999$var$load("3V7D1").then(()=>parcelRequire('lnyUd'));

});

parcelRegister("zm9ce", function(module, exports) {

let $06a472ff32f96172$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $06a472ff32f96172$var$load("jO9JA").then(()=>parcelRequire('jI7oG'));

});

parcelRegister("2PCg8", function(module, exports) {

let $20fe05ae0034f4c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20fe05ae0034f4c7$var$load("fuwWn").then(()=>parcelRequire('cRloE'));

});

parcelRegister("cSEky", function(module, exports) {

let $9609cff92260751d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9609cff92260751d$var$load("eJOes").then(()=>parcelRequire('hp07f'));

});

parcelRegister("8jOSK", function(module, exports) {

let $60e79131d9723a40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $60e79131d9723a40$var$load("dSv74").then(()=>parcelRequire('12n7A'));

});

parcelRegister("lqJAb", function(module, exports) {

let $f99f62698e93e16b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f99f62698e93e16b$var$load("bVOQk").then(()=>parcelRequire('9uj17'));

});

parcelRegister("hLNRp", function(module, exports) {

let $cefd80b1afa8feb3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cefd80b1afa8feb3$var$load("aYLJl").then(()=>parcelRequire('b9FSQ'));

});

parcelRegister("hEaLO", function(module, exports) {

let $cd8e86d8d69763f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd8e86d8d69763f2$var$load("dkMGw").then(()=>parcelRequire('1eenD'));

});

parcelRegister("edyni", function(module, exports) {

let $a59cf1afdbc00623$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a59cf1afdbc00623$var$load("4e64W").then(()=>parcelRequire('3Zqas'));

});

parcelRegister("3v8Uk", function(module, exports) {

let $28cb2d2d7331e888$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28cb2d2d7331e888$var$load("2557e").then(()=>parcelRequire('fCSaL'));

});

parcelRegister("bUyhs", function(module, exports) {

let $8abf84134836bc28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8abf84134836bc28$var$load("jFAe5").then(()=>parcelRequire('j281j'));

});

parcelRegister("4DZSE", function(module, exports) {

let $361ace1f90fb7a4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $361ace1f90fb7a4e$var$load("iiWbr").then(()=>parcelRequire('hOaWN'));

});

parcelRegister("kZ3Vp", function(module, exports) {

let $f46c8c950b0ef0d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f46c8c950b0ef0d6$var$load("ky0u2").then(()=>parcelRequire('1l7RQ'));

});

parcelRegister("5L9Y0", function(module, exports) {

let $431912bc8d9ed7db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $431912bc8d9ed7db$var$load("8dO9q").then(()=>parcelRequire('1KwlE'));

});

parcelRegister("9VlSx", function(module, exports) {

let $739a689663d28d88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $739a689663d28d88$var$load("5JSTH").then(()=>parcelRequire('1cFLu'));

});

parcelRegister("2IZJt", function(module, exports) {

let $1fbf93997dadbafc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fbf93997dadbafc$var$load("25N5T").then(()=>parcelRequire('2jPVy'));

});

parcelRegister("2IzXu", function(module, exports) {

let $1fab957193d1d319$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fab957193d1d319$var$load("4muy4").then(()=>parcelRequire('af0Hy'));

});

parcelRegister("bholk", function(module, exports) {

let $83642a475909fb55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83642a475909fb55$var$load("eYatm").then(()=>parcelRequire('2Z71B'));

});

parcelRegister("8bDhu", function(module, exports) {

let $5f5dd23b7ce2a143$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f5dd23b7ce2a143$var$load("ipSCZ").then(()=>parcelRequire('cGxOa'));

});

parcelRegister("4wkUe", function(module, exports) {

let $34aa5e1515eb8c2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34aa5e1515eb8c2d$var$load("3WUT3").then(()=>parcelRequire('24yoB'));

});

parcelRegister("jKH7t", function(module, exports) {

let $e613c2dab77671fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e613c2dab77671fc$var$load("66fD9").then(()=>parcelRequire('oWc1A'));

});

parcelRegister("ax7Wv", function(module, exports) {

let $7ab325b009aae694$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ab325b009aae694$var$load("f4Itd").then(()=>parcelRequire('jz5XV'));

});

parcelRegister("iXAiR", function(module, exports) {

let $dcd9e5bea65a9fe4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dcd9e5bea65a9fe4$var$load("30JEs").then(()=>parcelRequire('5sSOO'));

});

parcelRegister("1kllb", function(module, exports) {

let $0f783681d79effd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f783681d79effd3$var$load("5t0DK").then(()=>parcelRequire('1JGHk'));

});

parcelRegister("bMeLJ", function(module, exports) {

let $892fa234e16d0ae9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $892fa234e16d0ae9$var$load("gNlLk").then(()=>parcelRequire('2525D'));

});

parcelRegister("cGxs1", function(module, exports) {

let $93c35aeda166b5bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93c35aeda166b5bc$var$load("c8iqx").then(()=>parcelRequire('33cWm'));

});

parcelRegister("bQE6x", function(module, exports) {

let $8a03a8f57dc4b450$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a03a8f57dc4b450$var$load("lQs6A").then(()=>parcelRequire('bmkcG'));

});

parcelRegister("5fPLI", function(module, exports) {

let $3d3682a4e3224c37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d3682a4e3224c37$var$load("fgTaG").then(()=>parcelRequire('7y2Wl'));

});

parcelRegister("2h5uo", function(module, exports) {

let $1a816d590986555b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a816d590986555b$var$load("jlFvm").then(()=>parcelRequire('cOflU'));

});

parcelRegister("jeVa2", function(module, exports) {
module.exports = JSON.parse('{"app.accept":[{"type":0,"value":"Accept"}],"app.reject":[{"type":0,"value":"Reject"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"ecosystem-forge-apps.ecosystem-forge-apps-in-app.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"jira.jira-project-pages-gdrive-deprecation.message-template.email.subject":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-1":[{"type":0,"value":"We\'re reaching out to notify you that from April 23rd 2024, syncing Google Drive shared drives will no longer be supported in Project Pages for the users in your site. Users will no longer be able to access their shared drives Jira as we are removing the feature, but they will still be able to sync Confluence spaces to Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-2":[{"type":0,"value":"Please note that we are not deleting any data within Google Drive itself. The change only affects the ability to sync, link, and access Google Shared Drives from Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-3":[{"type":0,"value":"This is part of our ongoing efforts to streamline our services and ensure the highest quality experience for our users."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-4":[{"type":0,"value":"Next steps:"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-5":[{"type":0,"value":"We are committed to providing you with the best possible experience, and appreciate your understanding as we make these necessary improvements. Thank you for your continued support."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-1":[{"type":0,"value":"No immediate action is required from your end regarding this deprecation. However, we understand that this change may impact your workflow, and we are here to support you through this transition."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-3":[{"type":0,"value":"For any feedback, or further questions and assistance with change management, please contact jnguyen2@atlassian.com"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.greeting":[{"type":0,"value":"Dear Admin,"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.title":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-weekly-digest.message-template.email.subject":[{"type":0,"value":"Your weekly digest for Jira project: "},{"type":1,"value":"projectName"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCompletion":[{"type":0,"value":"issues completed in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCreated":[{"type":0,"value":"issues created in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesUpdated":[{"type":0,"value":"issues updated in the past week"}],"jira.jira-weekly-digest.test-message.email.body.plusSign":[{"type":0,"value":"+"}],"jira.jira-weekly-digest.test-message.email.header":[{"type":0,"value":"Here\'s your weekly digest for Jira ("},{"type":1,"value":"projectName"},{"type":0,"value":") over the past week"}],"jira.jira-weekly-digest.test-message.email.headerDescription":[{"type":0,"value":"You\u2019re receiving this email because you have opted in to receive weekly updates for this project in Jira."}],"jira.jira-weekly-digest.test-message.email.playbookBodyText":[{"type":0,"value":"Atlassian Playbook"}],"jira.jira-weekly-digest.test-message.email.playbookHeader":[{"type":0,"value":"Has your team conducted a retrospective recently?"}],"jira.jira-weekly-digest.test-message.email.playbookSubheader":[{"type":0,"value":"A retrospective gives you an opportunity to review your latest project progress and make improvements for the future. Find out more at "},{"type":1,"value":"link"},{"type":0,"value":"."}],"jira.jira-weekly-digest.test-message.email.tableHeader":[{"type":0,"value":"Weekly Summary"}],"jira.suppression-email-notification-email.contact-us":[{"type":0,"value":"contact us"}],"jira.suppression-email-notification-email.email.body":[{"type":0,"value":"This is an automatated message to notify you that the jira "},{"type":1,"value":"emailType"},{"type":0,"value":" email \\n\\t\\t\\t\\t\\t\\tto "},{"type":1,"value":"affectedUserEmail"},{"type":0,"value":" has been suppressed. Please visit this "},{"type":1,"value":"unsuppressApiLink"},{"type":0,"value":" to unsuppress the user\'s email."}],"jira.suppression-email-notification-email.email.body.goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" if the issue persists, we\'re always happy to help."}],"jira.suppression-email-notification-email.email.body.regards":[{"type":0,"value":"Jira Notifications Team"}],"jira.suppression-email-notification-email.email.body.signoff":[{"type":0,"value":"Regards,"}],"jira.suppression-email-notification-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jira.suppression-email-notification-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira.suppression-email-notification-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.playground-local-execution-message.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.playground-local-execution-message.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hello, fellow child "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.playground-local-execution-message.test-message.email.body.no-translate":[{"type":0,"value":"We are currently trying to locally execute this message!"}],"playground.playground-local-execution-message.test-message.email.body.regards.no-translate":[{"type":0,"value":"Playground Team"}],"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"playground.post-office-auto-merge-config.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.post-office-auto-merge-config.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.post-office-auto-merge-config.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.post-office-auto-merge-config.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"playground.post-office-auto-merge-config.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"playground.post-office-auto-merge-config.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.post-office-auto-merge-config.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.commerce-common.unsuppress-email-link":[{"type":0,"value":"link"}],"post-office.jira-email.contact-us":[{"type":0,"value":"contact us"}],"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("8jtTq", function(module, exports) {

let $60d74934f3fc4f2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $60d74934f3fc4f2d$var$load("4naQb").then(()=>parcelRequire('7WEkG'));

});

parcelRegister("cv3GI", function(module, exports) {

let $919b3d9d355b965c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $919b3d9d355b965c$var$load("dqLxh").then(()=>parcelRequire('azhMm'));

});

parcelRegister("ZXTsi", function(module, exports) {

let $0ba42835c54e4fbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ba42835c54e4fbb$var$load("8WeOJ").then(()=>parcelRequire('78ZfA'));

});

parcelRegister("lY5PF", function(module, exports) {

let $ffe3b9c6d44a0d09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffe3b9c6d44a0d09$var$load("Ror2l").then(()=>parcelRequire('gdBO8'));

});

parcelRegister("9V8xD", function(module, exports) {

let $7390101d8126e1bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7390101d8126e1bd$var$load("drAPP").then(()=>parcelRequire('3DBMU'));

});

parcelRegister("7pWep", function(module, exports) {

let $566809c5586072e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $566809c5586072e0$var$load("esJrS").then(()=>parcelRequire('1Ja9P'));

});

parcelRegister("6rKzg", function(module, exports) {

let $4b19631981ab924d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4b19631981ab924d$var$load("lGAmz").then(()=>parcelRequire('biXgE'));

});

parcelRegister("2oKaF", function(module, exports) {

let $1bf1a33f953205dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1bf1a33f953205dc$var$load("khrIN").then(()=>parcelRequire('h4j8A'));

});

parcelRegister("41esF", function(module, exports) {

let $2ed27928cd788e44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ed27928cd788e44$var$load("jtHQR").then(()=>parcelRequire('cOAQ0'));

});

parcelRegister("dRD1P", function(module, exports) {

let $a17e7fdba862d49d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a17e7fdba862d49d$var$load("ixtOF").then(()=>parcelRequire('f8gcV'));

});

parcelRegister("fFTG6", function(module, exports) {

let $b695dfd516b154ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b695dfd516b154ac$var$load("fIHQM").then(()=>parcelRequire('l9n03'));

});

parcelRegister("bCI0M", function(module, exports) {

let $8765621c816a7691$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8765621c816a7691$var$load("kylxz").then(()=>parcelRequire('8k3Dp'));

});

parcelRegister("4l9p8", function(module, exports) {

let $32906b1e071934a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32906b1e071934a6$var$load("22CLQ").then(()=>parcelRequire('aDz18'));

});

parcelRegister("brtXp", function(module, exports) {

let $85497431c9caea5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85497431c9caea5b$var$load("dniwF").then(()=>parcelRequire('drxA7'));

});

parcelRegister("FE06j", function(module, exports) {

let $07d2dbbdad86cc63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07d2dbbdad86cc63$var$load("bxYVx").then(()=>parcelRequire('3usyN'));

});

parcelRegister("4QkHm", function(module, exports) {

let $386c12fec7a863d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $386c12fec7a863d3$var$load("9y5Sq").then(()=>parcelRequire('kssqx'));

});

parcelRegister("gbbp3", function(module, exports) {

let $bc7684d9967ffe8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bc7684d9967ffe8f$var$load("i2egy").then(()=>parcelRequire('6iScM'));

});

parcelRegister("e82Fu", function(module, exports) {

let $a493e1ea29534ab6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a493e1ea29534ab6$var$load("b55kW").then(()=>parcelRequire('eQ2gb'));

});

parcelRegister("e6FoT", function(module, exports) {

let $a451bd80e4cc8590$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a451bd80e4cc8590$var$load("hhVwh").then(()=>parcelRequire('jLy0N'));

});

parcelRegister("fhiWh", function(module, exports) {

let $b1f7226b5b50be9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1f7226b5b50be9d$var$load("h3C0X").then(()=>parcelRequire('3QxlH'));

});

parcelRegister("aWZX5", function(module, exports) {

let $7f8f6089c9f65a67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f8f6089c9f65a67$var$load("eo1Nf").then(()=>parcelRequire('1h2Il'));

});

parcelRegister("aV1kH", function(module, exports) {

let $7f3042f4c62cd8da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f3042f4c62cd8da$var$load("l7vp6").then(()=>parcelRequire('hJpAP'));

});

parcelRegister("6f7fJ", function(module, exports) {

let $48b9c506223d77b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48b9c506223d77b2$var$load("5dqQO").then(()=>parcelRequire('6sj97'));

});

parcelRegister("7y5pr", function(module, exports) {

let $57efe78feb2dff90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57efe78feb2dff90$var$load("cw6Fw").then(()=>parcelRequire('5g2dy'));

});

parcelRegister("jHNNf", function(module, exports) {

let $e588a866ca439639$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e588a866ca439639$var$load("f0uil").then(()=>parcelRequire('lQSZ5'));

});

parcelRegister("8Qs2q", function(module, exports) {

let $6708eddb17e5dda2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6708eddb17e5dda2$var$load("jtO9F").then(()=>parcelRequire('j1nNh'));

});

parcelRegister("kVBlv", function(module, exports) {

let $f3c619a7336e0990$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3c619a7336e0990$var$load("dXgKT").then(()=>parcelRequire('9SXle'));

});

parcelRegister("46N3z", function(module, exports) {

let $2fddc698f812fa93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2fddc698f812fa93$var$load("4xODr").then(()=>parcelRequire('iTbmt'));

});

parcelRegister("l5yjD", function(module, exports) {

let $f5a4aef63b1b252b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5a4aef63b1b252b$var$load("75XmY").then(()=>parcelRequire('iG3jk'));

});

parcelRegister("gM1Sd", function(module, exports) {

let $c362950c8cc8211d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c362950c8cc8211d$var$load("4qXPA").then(()=>parcelRequire('abn1m'));

});

parcelRegister("jcc6B", function(module, exports) {

let $df988734d8b113d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df988734d8b113d1$var$load("8yIqn").then(()=>parcelRequire('21Ujf'));

});

parcelRegister("eSb44", function(module, exports) {

let $ad3eb1063f20961e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ad3eb1063f20961e$var$load("e0f4q").then(()=>parcelRequire('lHABM'));

});

parcelRegister("ab3Wu", function(module, exports) {

let $01e9841611536c2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01e9841611536c2b$var$load("726Hx").then(()=>parcelRequire('fjIWF'));

});

parcelRegister("4KkWY", function(module, exports) {

let $374bb58e0478b75f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $374bb58e0478b75f$var$load("icq5C").then(()=>parcelRequire('9o7yY'));

});

parcelRegister("b2ONX", function(module, exports) {
module.exports = JSON.parse('{"INAPP-1736.spotlight.body":[{"type":0,"value":"We\'ve got the basic settings for your integration covered. Customize them to make sure you get the most out of the integration."}],"INAPP-1736.spotlight.primary":[{"type":0,"value":"OK"}],"INAPP-1736.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-1736.spotlight.title":[{"type":0,"value":"Set up your integration"}],"INAPP-1737.spotlight.body":[{"type":0,"value":"Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed"}],"INAPP-1737.spotlight.primary":[{"type":0,"value":"Learn more"}],"INAPP-1737.spotlight.secondary":[{"type":0,"value":"OK"}],"INAPP-1737.spotlight.title":[{"type":0,"value":"Create rich and informative alerts"}],"alert.status.acked":[{"type":0,"value":"Acknowledged"}],"alert.status.closed":[{"type":0,"value":"Closed"}],"alert.status.open":[{"type":0,"value":"Open"}],"alert.status.snoozed":[{"type":0,"value":"Snoozed"}],"alexstrasza.assess-risk-button-spotlight.description":[{"type":0,"value":"Evaluate the potential impact of this change before approving or scheduling."}],"alexstrasza.assess-risk-button-spotlight.heading":[{"type":0,"value":"Assess risk with Rovo Ops"}],"alexstrasza.assess-risk-button-spotlight.try-it-now":[{"type":0,"value":"Try it now"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Note added"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View alert in OpsGenie"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Note added to alert: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert acknowledged: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert assigned: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert closed: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-export.message-template.email.subject.no-translate":[{"type":0,"value":"Export Alert Result"}],"alexstrasza.jsm-operations-alert-export.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"alexstrasza.jsm-operations-alert-export.test-message.email.body.no-translate":[{"type":0,"value":"We\u2019ve exported your alerts and now you can download the zip file here:"}],"alexstrasza.jsm-operations-alert-export.test-message.email.continue-export-label.no-translate":[{"type":0,"value":"The results contain the latest 10k alerts. To continue exporting, you can click the link below:"}],"alexstrasza.jsm-operations-alert-export.test-message.email.expiry.no-translate":[{"type":0,"value":"Please note that the export link will expire in 14 days."}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-new.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" New alert: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.download-button.no-translate":[{"type":0,"value":"Download "},{"type":1,"value":"exportType"},{"type":0,"value":" log"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.download-icon.alt.no-translate":[{"type":0,"value":"Download icon"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-category.no-translate":[{"type":0,"value":"Category: "},{"type":1,"value":"filterCategories"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-label.no-translate":[{"type":0,"value":"Export Criteria:"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-log-level.no-translate":[{"type":0,"value":"Log level: "},{"type":1,"value":"filterLogLevels"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-search.no-translate":[{"type":0,"value":"Search: "},{"type":1,"value":"searchKeywords"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-time.no-translate":[{"type":0,"value":"Time: "},{"type":1,"value":"from"},{"type":0,"value":" to "},{"type":1,"value":"to"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.greeting.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"userFullName"},{"type":0,"value":","}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.heading.no-translate":[{"type":0,"value":"Download your "},{"type":1,"value":"exportType"},{"type":0,"value":" log"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.intro-message.no-translate":[{"type":0,"value":"The CSV file for "},{"type":1,"value":"siteName"},{"type":0,"value":"\'s "},{"type":1,"value":"exportType"},{"type":0,"value":" log is ready to download. The download link will expire in 24 hours."}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.limit-note.no-translate":[{"type":0,"value":"Up to 100,000 activities can be exported at once, activities over the limit would be skipped in the CSV file."}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.subject.no-translate":[{"type":0,"value":"Your "},{"type":1,"value":"exportType"},{"type":0,"value":" log is ready to download"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.affected-role-label.no-translate":[{"type":0,"value":"Affected member role"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.button-text.no-translate":[{"type":0,"value":"View your alert notifications"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.contact-methods.no-translate":[{"type":0,"value":"contact methods"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.description-text.no-translate":[{"type":0,"value":"The role-based notification "},{"type":1,"value":"roleBasedNotificationSettingName"},{"type":0,"value":" will trigger alert notifications based on the conditions set by the admin."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.note-label.no-translate":[{"type":0,"value":"Note"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.note-text.no-translate":[{"type":0,"value":"Review your "},{"type":1,"value":"contactMethods"},{"type":0,"value":" to confirm that this role-based notification works as expected."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.override-message.no-translate":[{"type":0,"value":"Role-based notifications override your personal notifications."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.title.no-translate":[{"type":0,"value":"Role-based notification turned on"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.subject.no-translate":[{"type":0,"value":"Role-based notification turned on"}],"alexstrasza.jsm-operations-rotation-ends.message-template.email.body.team.no-translate":[{"type":0,"value":"Team"}],"alexstrasza.jsm-operations-rotation-ends.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"productName"},{"type":0,"value":"] Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" ends"}],"alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-at.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is ending, at "},{"type":1,"value":"endTime"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-now.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is ending now."}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.app-store-logo.alt.no-translate":[{"type":0,"value":"Download on the App Store"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.link-text.no-translate":[{"type":0,"value":"update your notification settings"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.no-translate":[{"type":0,"value":"To customize the email or unsubscribe, "},{"type":1,"value":"link"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.mobile-app.no-translate":[{"type":0,"value":"Stay notified and comment on the go with Jira Service Management Mobile App"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.play-store-logo.alt.no-translate":[{"type":0,"value":"Download on the Play Store"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.team.no-translate":[{"type":0,"value":"Team"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer-logo.alt.no-translate":[{"type":0,"value":"Atlassian"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.privacy-policy.no-translate":[{"type":0,"value":"Privacy Policy"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.text.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"productName"},{"type":0,"value":"] Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" starts"}],"alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-at.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is starting, at "},{"type":1,"value":"startTime"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-now.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is starting now."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.alert-feature-image.alt.no-translate":[{"type":0,"value":"Alert management illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.chat-feature-image.alt.no-translate":[{"type":0,"value":"Chat integration illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.explore-subheading.no-translate":[{"type":0,"value":"Explore how operations can elevate your team\'s response"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-alert-description.no-translate":[{"type":0,"value":"Improve response efficiency and reduce the alert fatigue."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-alert-title.no-translate":[{"type":0,"value":"Manage all alerts in one place"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-chat-description.no-translate":[{"type":0,"value":"Handle alerts and on-call using your chat tools."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-chat-title.no-translate":[{"type":0,"value":"Respond to alerts via chat"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-integration-description.no-translate":[{"type":0,"value":"Connect your IT tools and apps to centralize alerts in one place."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-integration-title.no-translate":[{"type":0,"value":"Integrate with your apps"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-oncall-description.no-translate":[{"type":0,"value":"Set on-call schedules easily and never miss a critical alert."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-oncall-title.no-translate":[{"type":0,"value":"Become an on-call team"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.heading.no-translate":[{"children":[{"type":1,"value":"teamName"}],"type":8,"value":"strong"},{"type":0,"value":" has launched its operations and is ready to respond"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.integration-feature-image.alt.no-translate":[{"type":0,"value":"Integration illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.launch-message.no-translate":[{"children":[{"type":1,"value":"actorUserName"}],"type":8,"value":"strong"},{"type":0,"value":" has launched "},{"children":[{"type":1,"value":"teamName"},{"type":0,"value":"\'s"}],"type":8,"value":"strong"},{"type":0,"value":" operations and added you as a member to collaborate."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.learn-more-link.no-translate":[{"type":0,"value":"Learn more"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.oncall-feature-image.alt.no-translate":[{"type":0,"value":"On-call scheduling illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.start-collaborating-button.no-translate":[{"type":0,"value":"Start collaborating"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.team-image.alt.no-translate":[{"type":0,"value":"Team profile picture"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.what-are-operations.no-translate":[{"type":0,"value":"What are operations?"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.subject.no-translate":[{"type":0,"value":"You\'re invited to collaborate on your team\'s operations"}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-allowlist.no-translate":[{"type":0,"value":"Your email server might be rejecting emails from Jira Service Management. Request your email administrator to allowlist jsm-notifications.atlassian.net."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-deactivated.no-translate":[{"type":0,"value":"The email address "},{"type":1,"value":"displayName"},{"type":0,"value":" you had added for alert notifications is deactivated."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-reactivate.no-translate":[{"type":0,"value":"If the email address is correct, go to the Alert notifications page in your personal settings and reactivate it."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.greeting.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"fullName"},{"type":0,"value":","}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.mobile-deactivated.no-translate":[{"type":0,"value":"The mobile device "},{"type":1,"value":"displayName"},{"type":0,"value":" added to your contact methods for mobile push notifications is currently deactivated because it\'s invalid or your app instance was unregistered. To continue receiving push notifications, re-install the application and verify the status from the Alert notifications page in your Jira personal settings."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.phone-deactivated.no-translate":[{"type":0,"value":"The phone number "},{"type":1,"value":"displayName"},{"type":0,"value":" added to your contact methods for voice/SMS is currently deactivated because it\'s invalid or it\'s blocklisted by your service provider. If the phone number is correct, go to the Alert notifications page in your Jira personal settings and reactivate it."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"product"},{"type":0,"value":"] Contact method for notifications deactivated"}],"alexstrasza.jsm-ops-enablement-notification-drawer.message-template.notification-drawer.message":[{"type":1,"value":"actorName"},{"type":0,"value":" launched "},{"type":1,"value":"teamName"},{"type":0,"value":"\'s operations"}],"alexstrasza.operations-overview-discoverability-spotlights.high-bug.description":[{"type":0,"value":"Your team\'s been logging a lot of bugs. Set up operations to get ahead of the next one \u2014 with on-call, alerting, and incident response built right in."}],"alexstrasza.operations-overview-discoverability-spotlights.high-bug.tour.step1-description":[{"type":0,"value":"Your team\'s been logging a lot of bugs. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and get ahead of the next one \u2014 with on-call, alerting, and incident response built right in."}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.description":[{"type":0,"value":"It\'s been a while since you started setting up operations. Turn on alerts and on-call schedules to unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.heading":[{"type":0,"value":"You\'re almost there"}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.primary-action":[{"type":0,"value":"Go to Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.tour.step1-description":[{"type":0,"value":"It\'s been a while since you started setting up operations. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.description":[{"type":0,"value":"You\'re getting notified through third-party integrations today. Instead, set up operations to receive real-time alerts and stay on top of issues as soon as they happen."}],"alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.tour.step1-description":[{"type":0,"value":"You\'re getting notified through third-party integrations today. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.heading":[{"type":0,"value":"Explore Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.primary-action":[{"type":0,"value":"Explore"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.next-button":[{"type":0,"value":"Next"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.primary-action":[{"type":0,"value":"Go to Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step-count":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step1-heading":[{"type":0,"value":"Complete your Operations setup"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step2-description":[{"type":0,"value":"Click on "},{"children":[{"type":0,"value":"Operations"}],"type":8,"value":"b"},{"type":0,"value":" to set up alerts and on-call schedules to make sure your team stay on top of issues as soon as they happen."}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step2-heading":[{"type":0,"value":"You\'re almost there"}],"alexstrasza.risk-assessment-spotlight.explore-categories.description":[{"type":0,"value":"Rovo Ops breaks down risk into categories. Select any category to see risk details, contributing factors, and why it was flagged."}],"alexstrasza.risk-assessment-spotlight.explore-categories.heading":[{"type":0,"value":"Explore risk by category"}],"alexstrasza.risk-assessment-spotlight.mitigate-risk.description":[{"type":0,"value":"Get actionable mitigation steps tailored to each risk category, so you can address issues before the change goes live."}],"alexstrasza.risk-assessment-spotlight.mitigate-risk.heading":[{"type":0,"value":"Mitigate risk"}],"alexstrasza.risk-assessment-spotlight.navigation.done":[{"type":0,"value":"Done"}],"alexstrasza.risk-assessment-spotlight.navigation.next":[{"type":0,"value":"Next"}],"alexstrasza.risk-assessment-spotlight.navigation.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"eoc-heartbeats.message-id.spotlight.body":[{"type":0,"value":"Copy heartbeat\u2019s name, edit, duplicate, and manage more heartbeat actions."}],"eoc-heartbeats.message-id.spotlight.dismiss":[{"type":0,"value":"OK"}],"eoc-heartbeats.message-id.spotlight.title":[{"type":0,"value":"Easy access to heartbeat actions"}],"eoc-heartbeats.tour.learn-more.no-translate":[{"type":0,"value":"Learn More"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-body.no-translate":[{"type":1,"value":"description"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-subtitle.no-translate":[{"type":0,"value":"Status: "},{"type":1,"value":"status"},{"type":0,"value":" | Source: "},{"type":1,"value":"source"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-title.no-translate":[{"type":0,"value":"["},{"type":1,"value":"priority"},{"type":0,"value":"] "},{"type":1,"value":"message"}]}');

});

parcelRegister("8gKl9", function(module, exports) {

let $6053c38877b29ee9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6053c38877b29ee9$var$load("0l0tL").then(()=>parcelRequire('gsb8W'));

});

parcelRegister("jpSOO", function(module, exports) {

let $e22adff0b36f5f5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e22adff0b36f5f5b$var$load("kS4Lw").then(()=>parcelRequire('fPIB7'));

});

parcelRegister("6AecT", function(module, exports) {

let $4cb12012ea66b4c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4cb12012ea66b4c5$var$load("5gGJt").then(()=>parcelRequire('96DZB'));

});

parcelRegister("hlWDs", function(module, exports) {

let $ca21e19bd87545fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca21e19bd87545fc$var$load("7g6eW").then(()=>parcelRequire('fXmH2'));

});

parcelRegister("l6nXd", function(module, exports) {

let $f5ccbd4e90c5a3e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5ccbd4e90c5a3e7$var$load("1Vhlr").then(()=>parcelRequire('jMeMF'));

});

parcelRegister("iEmwp", function(module, exports) {

let $d93d6ec487addf17$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d93d6ec487addf17$var$load("63Pb3").then(()=>parcelRequire('3W12e'));

});

parcelRegister("2gNE9", function(module, exports) {

let $1a7396303d37eb39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a7396303d37eb39$var$load("lEX61").then(()=>parcelRequire('bHmzJ'));

});

parcelRegister("aTgWD", function(module, exports) {

let $7edc2f4866763f6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7edc2f4866763f6e$var$load("fqkMC").then(()=>parcelRequire('bA5Ka'));

});

parcelRegister("iiAsS", function(module, exports) {

let $d5263194561155ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5263194561155ca$var$load("99PJi").then(()=>parcelRequire('1hFWg'));

});

parcelRegister("2tWdS", function(module, exports) {

let $1ceb740818ca6ac0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ceb740818ca6ac0$var$load("6D08s").then(()=>parcelRequire('l6rHB'));

});

parcelRegister("iiOFt", function(module, exports) {

let $d5313608989c4ead$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5313608989c4ead$var$load("ijPpX").then(()=>parcelRequire('bEmjJ'));

});

parcelRegister("aeHTQ", function(module, exports) {

let $773d43be7a4872c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $773d43be7a4872c4$var$load("dfhwS").then(()=>parcelRequire('lwhLg'));

});

parcelRegister("5GK6s", function(module, exports) {

let $4244a318eef3e4a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4244a318eef3e4a5$var$load("4rU0s").then(()=>parcelRequire('dPuzR'));

});

parcelRegister("eEw0a", function(module, exports) {

let $aaad9fff1cf3629f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aaad9fff1cf3629f$var$load("2rRxY").then(()=>parcelRequire('bZN2t'));

});

parcelRegister("jthau", function(module, exports) {

let $e2ce0b02ea63610a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e2ce0b02ea63610a$var$load("claFy").then(()=>parcelRequire('3sSbK'));

});

parcelRegister("84Cxf", function(module, exports) {

let $5e0c96b9d5dc34cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e0c96b9d5dc34cd$var$load("5Kn8Z").then(()=>parcelRequire('7VfNr'));

});

parcelRegister("iW3kM", function(module, exports) {

let $dc903ad91b69b5bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc903ad91b69b5bf$var$load("jLj2M").then(()=>parcelRequire('7WvbB'));

});

parcelRegister("9nNUV", function(module, exports) {

let $6d4cfb89288098d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d4cfb89288098d3$var$load("l4bde").then(()=>parcelRequire('kz3Lh'));

});

parcelRegister("81GdU", function(module, exports) {

let $5d7f2b68a04d6302$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d7f2b68a04d6302$var$load("2aiDg").then(()=>parcelRequire('ieaKJ'));

});

parcelRegister("92qiC", function(module, exports) {

let $6948b375c36d309d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6948b375c36d309d$var$load("9NdQS").then(()=>parcelRequire('9DuFq'));

});

parcelRegister("9bHyb", function(module, exports) {

let $6b06ec5a3045285a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b06ec5a3045285a$var$load("1BHqK").then(()=>parcelRequire('aKkQw'));

});

parcelRegister("gvcyQ", function(module, exports) {

let $c03948f5fa5dc9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c03948f5fa5dc9d7$var$load("fuAjW").then(()=>parcelRequire('7cokY'));

});

parcelRegister("jRfhy", function(module, exports) {

let $e74ed246ba47b870$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e74ed246ba47b870$var$load("l8hOj").then(()=>parcelRequire('jCu14'));

});

parcelRegister("irGVY", function(module, exports) {

let $d6dc0d666f47ed9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6dc0d666f47ed9c$var$load("kCJuv").then(()=>parcelRequire('KcT4F'));

});

parcelRegister("7O4me", function(module, exports) {

let $5af0953e181c4611$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5af0953e181c4611$var$load("56AJD").then(()=>parcelRequire('b1TUx'));

});

parcelRegister("4s7jC", function(module, exports) {

let $33df73a81e07998e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33df73a81e07998e$var$load("4pLuY").then(()=>parcelRequire('7NfSm'));

});

parcelRegister("dA2nN", function(module, exports) {

let $9e307c50a4ba392f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e307c50a4ba392f$var$load("kFWZh").then(()=>parcelRequire('8Gg0l'));

});

parcelRegister("9IUYg", function(module, exports) {

let $71446a59d7380bf9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71446a59d7380bf9$var$load("ap3Co").then(()=>parcelRequire('96cpV'));

});

parcelRegister("bCUq0", function(module, exports) {

let $876f01daf945e216$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $876f01daf945e216$var$load("51qYO").then(()=>parcelRequire('6Ru1J'));

});

parcelRegister("ew9Iy", function(module, exports) {

let $a91b978f79d29a11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a91b978f79d29a11$var$load("80DaC").then(()=>parcelRequire('877gu'));

});

parcelRegister("h6IDB", function(module, exports) {

let $c7459f5618d2558f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7459f5618d2558f$var$load("CxhW1").then(()=>parcelRequire('32UbK'));

});

parcelRegister("hKi96", function(module, exports) {

let $ceb4ceed4e80294e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ceb4ceed4e80294e$var$load("5D9Of").then(()=>parcelRequire('4EO5i'));

});

parcelRegister("4Dsjr", function(module, exports) {

let $3600c435b6e9d62d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3600c435b6e9d62d$var$load("IN5iq").then(()=>parcelRequire('2LOlb'));

});

parcelRegister("laflr", function(module, exports) {

let $f6866f4a4ba2691e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f6866f4a4ba2691e$var$load("akVf8").then(()=>parcelRequire('iUU9u'));

});

parcelRegister("k3ebb", function(module, exports) {
module.exports = JSON.parse("{\"INAPP-2055.spotlight.body\":[{\"type\":0,\"value\":\"Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed\"}],\"INAPP-2055.spotlight.primary\":[{\"type\":0,\"value\":\"Learn more\"}],\"INAPP-2055.spotlight.secondary\":[{\"type\":0,\"value\":\"OK\"}],\"INAPP-2055.spotlight.title\":[{\"type\":0,\"value\":\"Create rich and informative alerts\"}],\"INAPP-3273.spotlight.body\":[{\"type\":0,\"value\":\"Triage and resolve alerts faster by using Atlassian Intelligence to access similar alerts.\"}],\"INAPP-3273.spotlight.primary\":[{\"type\":0,\"value\":\"OK\"}],\"INAPP-3273.spotlight.title\":[{\"type\":0,\"value\":\"Drive faster alert resolution with Atlassian Intelligence\"}],\"jira-ops-group-customisation.spotlight.body\":[{\"type\":0,\"value\":\"Your team's alerts are grouped based on the similarity of alert titles, descriptions, tags and so on within a specific time window. If you want more control, you can fine-tune how alerts are grouped. Only team admins, Ops admins, or Jira admins can change these settings.\"}],\"jira-ops-group-customisation.spotlight.primary\":[{\"type\":0,\"value\":\"OK\"}],\"jira-ops-group-customisation.spotlight.title\":[{\"type\":0,\"value\":\"Configure alert groups\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.body\":[{\"type\":0,\"value\":\"Expand to quickly view all alerts in the group.\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.title\":[{\"type\":0,\"value\":\"View grouped alerts\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.body\":[{\"type\":0,\"value\":\"Rovo helps you classify your alerts as signal or noise so you can focus on what matters most.\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.title\":[{\"type\":0,\"value\":\"Triage alerts faster\"}],\"jira-ops-unified-view-revamp.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-ops-unified-view-revamp.spotlight.go-back\":[{\"type\":0,\"value\":\"Go back\"}],\"jira-ops-unified-view-revamp.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-ops-unified-view-revamp.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}]}");

});

parcelRegister("ktaGw", function(module, exports) {

let $ee6ecdd9e62a6018$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee6ecdd9e62a6018$var$load("izosY").then(()=>parcelRequire('697Tr'));

});

parcelRegister("1nAmB", function(module, exports) {

let $1014257bc41fe578$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1014257bc41fe578$var$load("3AtlW").then(()=>parcelRequire('bxLKl'));

});

parcelRegister("kADfk", function(module, exports) {

let $efd59cf13251bde5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $efd59cf13251bde5$var$load("49R0z").then(()=>parcelRequire('2D505'));

});

parcelRegister("39Kqy", function(module, exports) {

let $24c639d62efdcbb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24c639d62efdcbb7$var$load("awYAY").then(()=>parcelRequire('9lbX1'));

});

parcelRegister("lspmN", function(module, exports) {

let $f9efe3c9f712c8ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9efe3c9f712c8ba$var$load("d4kiK").then(()=>parcelRequire('cb2XJ'));

});

parcelRegister("OUGQx", function(module, exports) {

let $0990a51807c89fdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0990a51807c89fdb$var$load("30jIn").then(()=>parcelRequire('2zrZa'));

});

parcelRegister("aXzEj", function(module, exports) {

let $7fab1141442428c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7fab1141442428c2$var$load("8e9HE").then(()=>parcelRequire('e9jSz'));

});

parcelRegister("eeT8z", function(module, exports) {

let $a5dd2497131cfec6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5dd2497131cfec6$var$load("5PqJ2").then(()=>parcelRequire('c05fi'));

});

parcelRegister("gWIaz", function(module, exports) {

let $c564534987e61082$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c564534987e61082$var$load("eqI14").then(()=>parcelRequire('8FtQT'));

});

parcelRegister("7edTv", function(module, exports) {

let $54349e56bc0722ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54349e56bc0722ef$var$load("3sl1f").then(()=>parcelRequire('4QaSh'));

});

parcelRegister("4OGmS", function(module, exports) {

let $381cb258235fad51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $381cb258235fad51$var$load("3pZNx").then(()=>parcelRequire('aYpuU'));

});

parcelRegister("7BE2v", function(module, exports) {

let $589b0c1f4473ac7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $589b0c1f4473ac7c$var$load("axOzI").then(()=>parcelRequire('fkUiE'));

});

parcelRegister("56MyO", function(module, exports) {

let $3b832e68c0f16f11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b832e68c0f16f11$var$load("3KSkB").then(()=>parcelRequire('1muii'));

});

parcelRegister("qLVGx", function(module, exports) {

let $05079b9abc3461d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05079b9abc3461d4$var$load("39iSL").then(()=>parcelRequire('5H9GZ'));

});

parcelRegister("48zwW", function(module, exports) {

let $30337859cc2d7ead$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $30337859cc2d7ead$var$load("dNXsf").then(()=>parcelRequire('9mVBJ'));

});

parcelRegister("cQeIN", function(module, exports) {

let $9595c2ba18306dbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9595c2ba18306dbe$var$load("7Vq2p").then(()=>parcelRequire('80Id3'));

});

parcelRegister("1Dxz8", function(module, exports) {

let $1313786c25f0b69a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1313786c25f0b69a$var$load("b7Crx").then(()=>parcelRequire('41zJe'));

});

parcelRegister("d4Hmo", function(module, exports) {

let $984d488628fea574$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $984d488628fea574$var$load("ef4Ev").then(()=>parcelRequire('ez8W0'));

});

parcelRegister("gjyaO", function(module, exports) {

let $be08edd46504f822$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be08edd46504f822$var$load("dam1i").then(()=>parcelRequire('d9lvP'));

});

parcelRegister("cAhBk", function(module, exports) {

let $9296800d174d5338$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9296800d174d5338$var$load("edH9A").then(()=>parcelRequire('8auZY'));

});

parcelRegister("8YHHO", function(module, exports) {

let $6895d46172f6ca48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6895d46172f6ca48$var$load("aYhwp").then(()=>parcelRequire('bhisA'));

});

parcelRegister("759f8", function(module, exports) {

let $52802b7f628937a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $52802b7f628937a3$var$load("g5eT1").then(()=>parcelRequire('e9W1F'));

});

parcelRegister("7Y4Mm", function(module, exports) {

let $5cd1d808ebe21561$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5cd1d808ebe21561$var$load("a0epF").then(()=>parcelRequire('fNV4p'));

});

parcelRegister("fBb1L", function(module, exports) {

let $b5b2dd8cd186752a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5b2dd8cd186752a$var$load("cS8nd").then(()=>parcelRequire('c83ZD'));

});

parcelRegister("fO9qZ", function(module, exports) {

let $b822d7f98d409fb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b822d7f98d409fb9$var$load("gcjwP").then(()=>parcelRequire('jnt25'));

});

parcelRegister("kYiGN", function(module, exports) {

let $f447e88dcdfd7d56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f447e88dcdfd7d56$var$load("6wQZW").then(()=>parcelRequire('gX6ZO'));

});

parcelRegister("25Upz", function(module, exports) {

let $1867ce871f32473a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1867ce871f32473a$var$load("6s9LC").then(()=>parcelRequire('k4e6D'));

});

parcelRegister("2KPG0", function(module, exports) {

let $2017f680e599f00e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2017f680e599f00e$var$load("buj9L").then(()=>parcelRequire('2EuJ7'));

});

parcelRegister("8uKnv", function(module, exports) {

let $62f519c72ec35a3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $62f519c72ec35a3d$var$load("gnYru").then(()=>parcelRequire('8oIJl'));

});

parcelRegister("hHp3F", function(module, exports) {

let $ce29e3dbd59c233e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce29e3dbd59c233e$var$load("gujd3").then(()=>parcelRequire('joDGC'));

});

parcelRegister("ex8X1", function(module, exports) {

let $a94b173bb39e871e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a94b173bb39e871e$var$load("hyz8a").then(()=>parcelRequire('4XEzj'));

});

parcelRegister("6SbWl", function(module, exports) {

let $50110c42dbc0fb20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $50110c42dbc0fb20$var$load("d6dBt").then(()=>parcelRequire('4HH5G'));

});

parcelRegister("6wqja", function(module, exports) {

let $4bfa2380898257dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4bfa2380898257dd$var$load("jg4bP").then(()=>parcelRequire('8DdeG'));

});

parcelRegister("5VpDs", function(module, exports) {

let $45062941f9bb99f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45062941f9bb99f9$var$load("hMfET").then(()=>parcelRequire('es9Pj'));

});

parcelRegister("cGs9w", function(module, exports) {
module.exports = JSON.parse('{"INAPP-2270.spotlight.body":[{"type":0,"value":"Collaborate on requirements, meetings notes, retros, and more."}],"INAPP-2270.spotlight.primary":[{"type":0,"value":"Ok"}],"INAPP-2270.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-2270.spotlight.title":[{"type":0,"value":"Create docs without leaving Jira"}],"INAPP-2271.spotlight.body":[{"type":0,"value":"Create a single source of truth for your project docs. It\'s free to try."}],"INAPP-2271.spotlight.bodyV2":[{"type":0,"value":"Use it to create a single source of truth for all of your project docs."}],"INAPP-2271.spotlight.primary":[{"type":0,"value":"Ok"}],"INAPP-2271.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-2271.spotlight.title":[{"type":0,"value":"You have Confluence!"}],"growth-starburst.chloe-test-po-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"growth-starburst.chloe-test-po-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"growth-starburst.chloe-test-po-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"growth-starburst.chloe-test-po-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"growth-starburst.chloe-test-po-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"growth-starburst.chloe-test-po-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"growth-starburst.chloe-test-po-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"growth-starburst.common.arrow-right.alt-text":[{"type":0,"value":"Arrow right"}],"growth-starburst.common.bundled-existing-apps.header":[{"type":0,"value":"Bundled with your existing apps"}],"growth-starburst.common.icon-check-circle-blue.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-starburst.common.icon-confluence.alt-text":[{"type":0,"value":"Icon - Confluence"}],"growth-starburst.common.icon-jira.alt-text":[{"type":0,"value":"Icon - Jira"}],"growth-starburst.common.icon-loom.alt-text":[{"type":0,"value":"Icon - Loom"}],"growth-starburst.common.icon-rovo.alt-text":[{"type":0,"value":"Icon - Rovo"}],"growth-starburst.common.percentage.alt-text":[{"type":0,"value":"Percentage "},{"type":1,"value":"percentage"}],"growth-starburst.common.pro-tip.alt-text":[{"type":0,"value":"Pro tip"}],"growth-starburst.common.twc-email-summary.confluence":[{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"b"},{"type":0,"value":" - Idea & knowledge sharing"}],"growth-starburst.common.twc-email-summary.header":[{"type":0,"value":"Your Teamwork Collection gives you access to:"}],"growth-starburst.common.twc-email-summary.jira":[{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"b"},{"type":0,"value":" - Work planning & tracking"}],"growth-starburst.common.twc-email-summary.loom":[{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"b"},{"type":0,"value":" - Async video communication"}],"growth-starburst.common.twc-email-summary.rovo":[{"children":[{"type":0,"value":"Rovo"}],"type":8,"value":"b"},{"type":0,"value":" - AI Chat, Search & a team of specialized Agents"}],"growth-starburst.ep-migration-inapp-3280.description":[{"type":0,"value":"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users."}],"growth-starburst.ep-migration-inapp-3280.primary-button":[{"type":0,"value":"Upgrade options"}],"growth-starburst.ep-migration-inapp-3280.secondary-button":[{"type":0,"value":"Dismiss"}],"growth-starburst.ep-migration-inapp-3280.title":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"growth-starburst.ep-migration-inapp-3282.description":[{"type":0,"value":"We\u2019ve kept you on the Standard plan of Confluence for now."}],"growth-starburst.ep-migration-inapp-3282.primary-button":[{"type":0,"value":"Upgrade options"}],"growth-starburst.ep-migration-inapp-3282.secondary-button":[{"type":0,"value":"Dismiss"}],"growth-starburst.ep-migration-inapp-3282.title":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.description":[{"type":0,"value":"Try summarizing or generating more content with AI. You can always come back to this panel."}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content-with-ai.title":[{"type":0,"value":"Now it\'s your turn!"}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content.description":[{"type":0,"value":"Try Keep adding content to your page. You can type /ai to prompt AI."}],"growth-starburst.jira-issue-view-twc-spotlight-card.create-content.title":[{"type":0,"value":"Now it\'s your turn!"}],"growth-starburst.jira-issue-view-twc-spotlight-card.documentation.description":[{"type":0,"value":"Create docs directly in Jira to capture work, strategy, and more \u2014 with AI doing the heavy lifting."}],"growth-starburst.jira-issue-view-twc-spotlight-card.documentation.title":[{"type":0,"value":"Turn ideas into docs instantly with AI"}],"growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.description":[{"type":0,"value":"Create video messages using Loom to talk through updates, feedback, or upcoming work."}],"growth-starburst.jira-issue-view-twc-spotlight-card.interactive-video.title":[{"type":0,"value":"Record & share videos"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.explore":[{"type":0,"value":"Explore"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.next":[{"type":0,"value":"Next"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"growth-starburst.jira-issue-view-twc-spotlight-card.navigation.skip":[{"type":0,"value":"Dismiss"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-enabled":[{"type":0,"value":"enabled"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.auto-advance-label":[{"type":0,"value":"Auto advance:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.dismiss-button":[{"type":0,"value":"Dismiss Tour"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.start-from-step-label":[{"type":0,"value":"Start from step:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.steps-label":[{"type":0,"value":"Steps:"}],"growth-starburst.jira-issue-view-twc-spotlight-tour.test-message.title":[{"type":0,"value":"TWC Spotlight Tour Test"}],"growth-starburst.twc-conf-sample-page-tour.back":[{"type":0,"value":"Back"}],"growth-starburst.twc-conf-sample-page-tour.dismiss":[{"type":0,"value":"Dismiss"}],"growth-starburst.twc-conf-sample-page-tour.done":[{"type":0,"value":"Done"}],"growth-starburst.twc-conf-sample-page-tour.next":[{"type":0,"value":"Next"}],"growth-starburst.twc-conf-sample-page-tour.step1.description":[{"type":0,"value":"Create, update and manage Jira work directly in Confluence docs."}],"growth-starburst.twc-conf-sample-page-tour.step1.header":[{"type":0,"value":"Create and update tasks in Jira"}],"growth-starburst.twc-conf-sample-page-tour.step1.progressIndicator":[{"type":0,"value":"1 of 3"}],"growth-starburst.twc-conf-sample-page-tour.step2.description":[{"type":0,"value":"Generate content easily and quickly with our AI-powered writing assistant. Type /rovo to try it now."}],"growth-starburst.twc-conf-sample-page-tour.step2.header":[{"type":0,"value":"Let AI do the writing for you"}],"growth-starburst.twc-conf-sample-page-tour.step2.progressIndicator":[{"type":0,"value":"2 of 3"}],"growth-starburst.twc-conf-sample-page-tour.step3.description":[{"type":0,"value":"Loom can create a script from your page content. Record a quick video and add it to your doc to explain updates."}],"growth-starburst.twc-conf-sample-page-tour.step3.header":[{"type":0,"value":"Share updates with video"}],"growth-starburst.twc-conf-sample-page-tour.step3.progressIndicator":[{"type":0,"value":"3 of 3"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-confluence":[{"type":0,"value":"Create documents in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"b"},{"type":0,"value":" to share knowledge"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-jira":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"b"},{"type":0,"value":" to organize and plan projects"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-loom.premium":[{"type":0,"value":"Save time with "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"b"},{"type":0,"value":" and get AI-generated meeting recaps"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-loom.standard":[{"type":0,"value":"Save time with "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"b"},{"type":0,"value":" and record async video updates"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.benefit-rovo":[{"type":0,"value":"Get AI-powered help and keep work moving with "},{"children":[{"type":0,"value":"Rovo"}],"type":8,"value":"b"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.description":[{"type":0,"value":"Teamwork Collection brings together Jira, Confluence, Loom, and Rovo so you can plan, document, and collaborate across teams\u2014all in one place."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.explore-features-link":[{"type":0,"value":"Explore all features \u2192"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.features-title":[{"type":0,"value":"Finish work 3x faster with Teamwork Collection"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.get-started-button":[{"type":0,"value":"Get started"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.heading":[{"type":1,"value":"requesterName"},{"type":0,"value":" requested to try Teamwork Collection"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.logo.alt":[{"type":0,"value":"Teamwork Collection Atlassian"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.trial-info.premium":[{"type":0,"value":"Grant access on a "},{"children":[{"type":0,"value":"free"}],"type":8,"value":"b"},{"type":0,"value":", 30-day trial of Premium."},{"type":1,"value":"br"},{"children":[{"type":0,"value":"Cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":", we\'ll remind you 3 days before your trial ends."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.trial-info.standard":[{"type":0,"value":"Grant access on a "},{"children":[{"type":0,"value":"free"}],"type":8,"value":"b"},{"type":0,"value":", 14-day trial of Standard."},{"type":1,"value":"br"},{"children":[{"type":0,"value":"Cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":", we\'ll remind you 3 days before your trial ends."}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.body.visual.alt":[{"type":0,"value":"Teamwork Collection visual showing Jira, Confluence, Loom, and Rovo"}],"growth-starburst.twc-end-user-request-admin-email.message-template.email.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterName"},{"type":0,"value":" wants to try Teamwork Collection"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.buttonText.jiraAndConfAndRovo":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingDescription.jiraAndConfAndRovo":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingTitle.jiraAndConfAndRovo":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.emailSubject.jiraAndConfAndRovo":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.header.jiraAndConfAndRovo":[{"type":0,"value":"Accelerate teamwork 3x faster with video and AI, at "},{"children":[{"type":0,"value":"no added cost"}],"type":8,"value":"blue"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.header.jiraConf":[{"type":0,"value":"Accelerate teamwork 3x faster with video and AI, at "},{"children":[{"type":0,"value":"no added cost"}],"type":8,"value":"blue"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Description.jiraAndConfAndRovo":[{"type":0,"value":"Save time with AI-generated meeting notes and async video"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Title.jiraAndConfAndRovo":[{"type":0,"value":"faster project completion with"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step1Title.jiraConf":[{"type":0,"value":"faster project completion with"}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email-no-price-increase.message-template.email.step2Title.jiraConf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email-v2.article1Copy1.confluenceArticle":[{"type":0,"value":"Start with a simple prompt like \\"plan a Q3 launch\\" and let Rovo draft a structured project plan."}],"growth-starburst.twc-marketing-email-v2.article1Copy1.jiraArticle":[{"type":0,"value":"Start with a simple prompt like \\"plan a Q3 launch\\" and let Rovo draft a structured project plan."}],"growth-starburst.twc-marketing-email-v2.article1Copy1.jiraConfArticle":[{"type":0,"value":"Start with a simple prompt like \\"plan a Q3 launch\\" and let Rovo draft a structured project plan. Turn key milestones into Jira work items, with fields, assignees, and due dates pre\u2011filled and linked back to a plan in Confluence."}],"growth-starburst.twc-marketing-email-v2.article1Copy2.confluenceArticle":[{"type":0,"value":"Turn key milestones into Jira issues, with fields, assignees, and due dates pre\u2011filled and linked back to your plan in Confluence."}],"growth-starburst.twc-marketing-email-v2.article1Copy2.jiraArticle":[{"type":0,"value":"Turn key milestones into Jira work items, with fields, assignees, and due dates pre\u2011filled and linked back to a plan in Confluence."}],"growth-starburst.twc-marketing-email-v2.article1Copy2.jiraConfArticle":[{"type":0,"value":"Add a Loom recording to your pages & tickets to keep your teams up to date!"}],"growth-starburst.twc-marketing-email-v2.article1Subhead.confluenceArticle":[{"type":0,"value":"From project idea \u2192 structured plan"}],"growth-starburst.twc-marketing-email-v2.article1Subhead.jiraArticle":[{"type":0,"value":"From project idea \u2192 structured plan"}],"growth-starburst.twc-marketing-email-v2.article1Subhead.jiraConfArticle":[{"type":0,"value":"From project idea \u2192 structured plan"}],"growth-starburst.twc-marketing-email-v2.article2Copy1.confluenceArticle":[{"type":0,"value":"Write specs in Confluence, create linked Jira work items with tasks, owners, and due dates."}],"growth-starburst.twc-marketing-email-v2.article2Copy1.jiraArticle":[{"type":0,"value":"Confluence captures your project plans, notes, and decision logs as organized knowledge that stays connected to your Jira work."}],"growth-starburst.twc-marketing-email-v2.article2Copy1.jiraConfArticle":[{"type":0,"value":"Confluence captures your project plans, notes, and decision logs as organized knowledge that stays connected to your Jira work."}],"growth-starburst.twc-marketing-email-v2.article2Copy2.confluenceArticle":[{"type":0,"value":"No more \\"Who picked this?\\" or \\"Who\'s on point?\\" weeks later."}],"growth-starburst.twc-marketing-email-v2.article2Copy2.jiraArticle":[{"type":0,"value":"See the \\"why\\" and \\"how\\" behind any work item \u2013 no digging required."}],"growth-starburst.twc-marketing-email-v2.article2Copy2.jiraConfArticle":[{"type":0,"value":"See the \\"why\\" and \\"how\\" behind any work item \u2013 no digging required."}],"growth-starburst.twc-marketing-email-v2.article2Subhead.confluenceArticle":[{"type":0,"value":"Product requirements \u2192 Development tickets"}],"growth-starburst.twc-marketing-email-v2.article2Subhead.jiraArticle":[{"type":0,"value":"Docs and decisions that stay in sync with issues"}],"growth-starburst.twc-marketing-email-v2.article2Subhead.jiraConfArticle":[{"type":0,"value":"Docs and decisions that stay in sync with issues"}],"growth-starburst.twc-marketing-email-v2.article3Copy1.confluenceArticle":[{"type":0,"value":"Drop Loom videos straight into Confluence pages and Jira work items to add instant visual context and reduce confusion."}],"growth-starburst.twc-marketing-email-v2.article3Copy1.jiraArticle":[{"type":0,"value":"Drop Loom videos straight into Jira work items and Confluence pages to add instant visual context and reduce confusion."}],"growth-starburst.twc-marketing-email-v2.article3Copy1.jiraConfArticle":[{"type":0,"value":"Add Instant Visual Context: Embed Loom videos directly into your Jira issues and Confluence pages to clearly explain complex ideas and reduce confusion. Automate Next Steps: Let AI automatically summarize your recordings, extract key feedback, and link action items directly to your work."}],"growth-starburst.twc-marketing-email-v2.article3Copy2.confluenceArticle":[{"type":0,"value":"Then let Loom AI auto\u2011capture feedback, summarize meetings, and turn recordings into action items so work keeps moving forward without more meetings."}],"growth-starburst.twc-marketing-email-v2.article3Copy2.jiraArticle":[{"type":0,"value":"Then let Loom AI auto\u2011capture feedback, summarize meetings, and turn recordings into action items so work keeps moving forward without more meetings."}],"growth-starburst.twc-marketing-email-v2.article3Copy2.jiraConfArticle":[{"type":0,"value":"Eliminate Additional Meetings: Keep your team perfectly aligned and work moving forward asynchronously"}],"growth-starburst.twc-marketing-email-v2.article3Subhead.confluenceArticle":[{"type":0,"value":"Async updates without more meetings"}],"growth-starburst.twc-marketing-email-v2.article3Subhead.jiraArticle":[{"type":0,"value":"Async updates without more meetings"}],"growth-starburst.twc-marketing-email-v2.article3Subhead.jiraConfArticle":[{"type":0,"value":"Async updates without more meetings"}],"growth-starburst.twc-marketing-email-v2.articleHeader.confluenceArticle":[{"type":0,"value":"Here\'s how teams use Teamwork Collection:"}],"growth-starburst.twc-marketing-email-v2.articleHeader.jiraArticle":[{"type":0,"value":"Here\'s how teams use Teamwork Collection:"}],"growth-starburst.twc-marketing-email-v2.articleHeader.jiraConfArticle":[{"type":0,"value":"Here\'s how teams use Teamwork Collection:"}],"growth-starburst.twc-marketing-email-v2.bodyCopy.confluenceArticle":[{"type":0,"value":"Your best work already starts in Confluence. "},{"children":[{"type":0,"value":"Teamwork Collection"}],"type":8,"value":"link"},{"type":0,"value":" helps you get to results faster."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.confluenceData":[{"type":0,"value":"Teams that use Teamwork Collection see one consistent pattern: less chaos and faster progress on the work."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.confluencePlatform":[{"type":0,"value":"Confluence is where your team thinks: project plans, decision logs, documentation, meeting notes, etc.\\n\\nBut after you agree on what to do, work frequently scatters into different tools and channels. Tasks get lost, updates go stale, and stakeholders aren\'t sure where to look for the latest.\\n\\n"},{"children":[{"type":0,"value":"Teamwork Collection"}],"type":8,"value":"link"},{"type":0,"value":" closes that gap. \\n\\nTeamwork Collection combines "},{"children":[{"type":0,"value":"Jira + Confluence + Loom + Rovo AI"}],"type":8,"value":"bold"},{"type":0,"value":" into one connected workspace."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraArticle":[{"type":0,"value":"With Teamwork Collection, Jira remains the structured backbone of your work, but your teams also get shared context, knowledge, and AI to help them go further, faster."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfArticle":[{"type":0,"value":"With Teamwork Collection, Jira & Confluence remain the structured backbones of your work, but your teams also get shared context, knowledge, and AI to help them go further, faster."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfData":[{"type":0,"value":"You already have a head start with Jira and Confluence. Upgrading to Teamwork Collection adds Loom and Rovo AI, bringing one consistent pattern to your workflows: less chaos and faster progress on the work."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfDataHasRovo":[{"type":0,"value":"You already have a head start with Jira and Confluence. Upgrading to Teamwork Collection adds Loom, bringing one consistent pattern to your workflows: less chaos and faster progress on the work."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfPlatform":[{"type":0,"value":"Confluence and Jira already help you plan and track your work. Adding Loom and Rovo to your tools brings greater clarity, faster progress, and improved teamwork."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraConfPlatformHasRovo":[{"type":0,"value":"Confluence and Jira already help you plan and track your work. Adding Loom to your tools brings greater clarity, faster progress, and improved teamwork."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraData":[{"type":0,"value":"Teams that use Teamwork Collection see one consistent pattern: less chaos and faster progress on the work."}],"growth-starburst.twc-marketing-email-v2.bodyCopy.jiraPlatform":[{"type":0,"value":"Teamwork Collection brings Jira, Confluence, Loom, and Rovo AI together, augmenting your work already in Jira with clearer plans, shared context, and fewer status meetings."}],"growth-starburst.twc-marketing-email-v2.bullet1.confluenceData":[{"children":[{"type":0,"value":"3x faster delivery"}],"type":8,"value":"bold"},{"type":0,"value":": Less app switching and manual copy\u2011pasting across tools"}],"growth-starburst.twc-marketing-email-v2.bullet1.confluencePlatform":[{"type":0,"value":"Plan and document in Confluence"}],"growth-starburst.twc-marketing-email-v2.bullet1.jiraConfData":[{"children":[{"type":0,"value":"3x faster delivery"}],"type":8,"value":"bold"},{"type":0,"value":": Less app switching and manual copy-pasting across tools"}],"growth-starburst.twc-marketing-email-v2.bullet1.jiraConfPlatform":[{"type":0,"value":"Plan and track work in Jira, with Rovo AI agents as teammates"}],"growth-starburst.twc-marketing-email-v2.bullet1.jiraData":[{"children":[{"type":0,"value":"3x faster delivery"}],"type":8,"value":"bold"},{"type":0,"value":": Less app switching and manual copy-pasting across tools"}],"growth-starburst.twc-marketing-email-v2.bullet1.jiraPlatform":[{"type":0,"value":"Plan and track work in Jira, with Rovo AI agents as teammates"}],"growth-starburst.twc-marketing-email-v2.bullet2.confluenceData":[{"children":[{"type":0,"value":"50% less time searching for info"}],"type":8,"value":"bold"},{"type":0,"value":": Teams align faster with everyone seeing the same source of truth"}],"growth-starburst.twc-marketing-email-v2.bullet2.confluencePlatform":[{"type":0,"value":"Track and execute in Jira"}],"growth-starburst.twc-marketing-email-v2.bullet2.jiraConfData":[{"children":[{"type":0,"value":"50% less time searching for info"}],"type":8,"value":"bold"},{"type":0,"value":": Teams align faster with everyone seeing the same source of truth"}],"growth-starburst.twc-marketing-email-v2.bullet2.jiraConfPlatform":[{"type":0,"value":"Capture project plans, notes, and decision logs in Confluence and keep them tied to the right work items"}],"growth-starburst.twc-marketing-email-v2.bullet2.jiraData":[{"children":[{"type":0,"value":"50% less time searching for info"}],"type":8,"value":"bold"},{"type":0,"value":": Teams align faster with everyone seeing the same source of truth"}],"growth-starburst.twc-marketing-email-v2.bullet2.jiraPlatform":[{"type":0,"value":"Capture project plans, notes, and decision logs in Confluence and keep them tied to the right work items"}],"growth-starburst.twc-marketing-email-v2.bullet3.confluenceData":[{"children":[{"type":0,"value":"31% increase in project success"}],"type":8,"value":"bold"},{"type":0,"value":": Rovo AI helps teams unlock the knowledge buried in projects"}],"growth-starburst.twc-marketing-email-v2.bullet3.confluencePlatform":[{"type":0,"value":"Share updates asynchronously with Loom"}],"growth-starburst.twc-marketing-email-v2.bullet3.jiraConfData":[{"children":[{"type":0,"value":"31% increase in project success"}],"type":8,"value":"bold"},{"type":0,"value":": Rovo AI helps teams unlock the knowledge buried in projects"}],"growth-starburst.twc-marketing-email-v2.bullet3.jiraConfPlatform":[{"type":0,"value":"Share quick Loom updates instead of scheduling another live meeting"}],"growth-starburst.twc-marketing-email-v2.bullet3.jiraData":[{"children":[{"type":0,"value":"31% increase in project success"}],"type":8,"value":"bold"},{"type":0,"value":": Rovo AI helps teams unlock the knowledge buried in projects"}],"growth-starburst.twc-marketing-email-v2.bullet3.jiraPlatform":[{"type":0,"value":"Share quick Loom updates instead of scheduling another live meeting"}],"growth-starburst.twc-marketing-email-v2.bullet4.confluencePlatform":[{"type":0,"value":"Use Rovo AI to augment your work"}],"growth-starburst.twc-marketing-email-v2.bullet4.jiraConfPlatform":[{"type":0,"value":"Use Rovo to help draft plans, summarize changes, and surface what matters from across your tools"}],"growth-starburst.twc-marketing-email-v2.bullet4.jiraPlatform":[{"type":0,"value":"Use Rovo to help draft plans, summarize changes, and surface what matters from across your tools"}],"growth-starburst.twc-marketing-email-v2.bulletHeader.confluenceData":[{"type":0,"value":"With Teamwork Collection, teams report:"}],"growth-starburst.twc-marketing-email-v2.bulletHeader.confluencePlatform":[{"type":0,"value":"With Teamwork Collection, your team can:"}],"growth-starburst.twc-marketing-email-v2.bulletHeader.jiraConfData":[{"type":0,"value":"With Teamwork Collection, teams report:"}],"growth-starburst.twc-marketing-email-v2.bulletHeader.jiraConfPlatform":[{"type":0,"value":"Teamwork Collection upgrades your workspace by adding Loom for quick, asynchronous video updates and Rovo to connect the dots. Now, your team can see the plan, track the status, and watch the context\u2014all in one place."}],"growth-starburst.twc-marketing-email-v2.bulletHeader.jiraData":[{"type":0,"value":"With Teamwork Collection, teams report:"}],"growth-starburst.twc-marketing-email-v2.bulletHeader.jiraPlatform":[{"type":0,"value":"With Teamwork Collection, your team can:"}],"growth-starburst.twc-marketing-email-v2.closingLine.confluenceData":[{"type":0,"value":"Teamwork Collection brings the power of connected Atlassian tools to your Confluence docs."}],"growth-starburst.twc-marketing-email-v2.closingLine.confluencePlatform":[{"type":0,"value":"The result: one platform to run the whole project."}],"growth-starburst.twc-marketing-email-v2.closingLine.jiraConfData":[{"type":0,"value":"Teamwork Collection brings the power of connected Atlassian tools to your Jira and Confluence workspace."}],"growth-starburst.twc-marketing-email-v2.closingLine.jiraConfPlatform":[{"type":0,"value":"The result: one intelligent platform to run the whole project."}],"growth-starburst.twc-marketing-email-v2.closingLine.jiraData":[{"type":0,"value":"Teamwork Collection brings the power of connected Atlassian tools to your Jira projects."}],"growth-starburst.twc-marketing-email-v2.closingLine.jiraPlatform":[{"type":0,"value":"The result: one intelligent platform to run the whole project."}],"growth-starburst.twc-marketing-email-v2.ctaText.confluenceArticle":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.confluenceData":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.confluencePlatform":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraArticle":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraConfArticle":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraConfData":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraConfPlatform":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraData":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.ctaText.jiraPlatform":[{"type":0,"value":"Try it free"}],"growth-starburst.twc-marketing-email-v2.emailSubject.confluenceArticle":[{"type":0,"value":"Extend Confluence with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.confluenceData":[{"type":0,"value":"Get 3x faster delivery with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.confluencePlatform":[{"type":0,"value":"Your plans live in Confluence. Where is the work?"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraArticle":[{"type":0,"value":"Elevate Jira with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraConfArticle":[{"type":0,"value":"Elevate Jira and Confluence workflows with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraConfData":[{"type":0,"value":"3 ways to speed up your Jira & Confluence workflows"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraConfPlatform":[{"type":0,"value":"Add context to your workflows with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraData":[{"type":0,"value":"Elevate Jira with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.emailSubject.jiraPlatform":[{"type":0,"value":"Elevate Jira with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.headline.confluenceArticle":[{"type":0,"value":"Take Confluence further with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.headline.confluenceData":[{"type":0,"value":"Get the most out of Confluence with Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.headline.confluencePlatform":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraArticle":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraConfArticle":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraConfData":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraConfPlatform":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraData":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.headline.jiraPlatform":[{"type":0,"value":"One intelligent platform to run the whole project"}],"growth-starburst.twc-marketing-email-v2.heroAlt.confluenceArticle":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.confluenceData":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.confluencePlatform":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraArticle":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraConfArticle":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraConfData":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraConfPlatform":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraData":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.heroAlt.jiraPlatform":[{"type":0,"value":"Teamwork Collection"}],"growth-starburst.twc-marketing-email-v2.outroText.confluenceArticle":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.confluenceData":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.confluencePlatform":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraArticle":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraConfArticle":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraConfData":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraConfPlatform":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraData":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroText.jiraPlatform":[{"type":0,"value":"Try Teamwork Collection free"}],"growth-starburst.twc-marketing-email-v2.outroTitle.confluenceArticle":[{"type":0,"value":"Ready to try Teamwork Collection for free?"}],"growth-starburst.twc-marketing-email-v2.outroTitle.jiraArticle":[{"type":0,"value":"Ready to try Teamwork Collection for free?"}],"growth-starburst.twc-marketing-email-v2.outroTitle.jiraConfArticle":[{"type":0,"value":"Ready to try Teamwork Collection for free?"}],"growth-starburst.twc-marketing-email-v2.preheader.confluenceArticle":[{"type":0,"value":"Pages -> projects, decisions -> action, updates -> insight"}],"growth-starburst.twc-marketing-email-v2.preheader.confluenceData":[{"type":0,"value":"Add plans, context, video, and AI to your work"}],"growth-starburst.twc-marketing-email-v2.preheader.confluencePlatform":[{"type":0,"value":"Connect planning, documentation, and delivery"}],"growth-starburst.twc-marketing-email-v2.preheader.jiraArticle":[{"type":0,"value":"Connect work, knowledge, and updates in one place"}],"growth-starburst.twc-marketing-email-v2.preheader.jiraConfArticle":[{"type":0,"value":"Add video, summaries and data-driven context to your updates in one place"}],"growth-starburst.twc-marketing-email-v2.preheader.jiraConfData":[{"type":0,"value":"Connect work, knowledge, and updates in one place with Video and AI context."}],"growth-starburst.twc-marketing-email-v2.preheader.jiraConfPlatform":[{"type":0,"value":"Bridge the gap between planning and execution with clarity."}],"growth-starburst.twc-marketing-email-v2.preheader.jiraData":[{"type":0,"value":"Connect work, knowledge, and updates in one place"}],"growth-starburst.twc-marketing-email-v2.preheader.jiraPlatform":[{"type":0,"value":"Connect work, knowledge, and updates in one place"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.conf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.confAndLoom":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jira":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraAndConfAndRovo":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraAndLoom":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Try free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.conf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.confAndLoom":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jira":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraAndConfAndRovo":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraAndLoom":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Jump into Teamwork Collection now!"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.confAndLoom":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraAndConfAndRovo":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraAndLoom":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.conf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.confAndLoom":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jira":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraAndConfAndRovo":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraAndLoom":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"Try Teamwork Collection - Free for 30 days"}],"growth-starburst.twc-marketing-email.message-template.email.header.conf":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.confAndLoom":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jira":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraAndConfAndRovo":[{"type":0,"value":"Accelerate teamwork "},{"children":[{"type":0,"value":"3x faster"}],"type":8,"value":"blue"},{"type":0,"value":" with video and AI"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraAndLoom":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.header.jiraConf":[{"type":0,"value":"Boost your team\'s productivity with connected tools built to work together"}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.conf":[{"type":0,"value":"The #1 tool for agile teams. Plan, track, and deliver your biggest ideas together."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.confAndLoom":[{"type":0,"value":"The #1 tool for agile teams. Plan, track, and deliver your biggest ideas together."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jira":[{"type":0,"value":"Create strategy docs, flowcharts, project plans, and more \u2014 without leaving Jira."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraAndConfAndRovo":[{"type":0,"value":"Reduce repetitive syncs and follow-ups \u2014 Loom videos and automated recaps keep everyone aligned."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraAndLoom":[{"type":0,"value":"Create strategy docs, flowcharts, project plans, and more \u2014 without leaving Jira."}],"growth-starburst.twc-marketing-email.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.conf":[{"type":0,"value":"increase speed in decision making"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.confAndLoom":[{"type":0,"value":"increase speed in decision making"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jira":[{"type":0,"value":"boost in project completion with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraAndConfAndRovo":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraAndLoom":[{"type":0,"value":"boost in project completion with"}],"growth-starburst.twc-marketing-email.message-template.email.step1Title.jiraConf":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.conf":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.confAndLoom":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jira":[{"type":0,"value":"Record and share videos to stay in sync without extra meetings."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jiraAndLoom":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.conf":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.confAndLoom":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jira":[{"type":0,"value":"fewer meetings with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jiraAndLoom":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step2Title.jiraConf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step3Description.conf":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step3Description.jira":[{"type":0,"value":"Use AI to search through all docs and channels to find the right info."}],"growth-starburst.twc-marketing-email.message-template.email.step3Title.conf":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-marketing-email.message-template.email.step3Title.jira":[{"type":0,"value":"less time searching for work with"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.conf":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.jira":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-1.message-template.email.buttonText.land":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.conf":[{"type":0,"value":"Try Jira today to make getting work done a snap!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.jira":[{"type":0,"value":"Try Confluence today to start connecting org-wide knowledge to your work."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingDescription.land":[{"type":0,"value":"Try out Confluence today to add context to your work in Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-1.message-template.email.closingTitle.land":[{"type":0,"value":"Bring your next big idea to life"}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.conf":[{"type":0,"value":"Use Jira to visualize your tasks and workflows. Plus, use AI-powered automations to get the whole team get moving fast."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.jira":[{"type":0,"value":"Use Confluence to capture notes, draft plans, share project insights. Plus, keep it all organized alongside Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.jiraConf":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-1.message-template.email.content.land":[{"type":0,"value":"Hit \u201CCreate\u201D in Confluence to jot down notes, draft plans, or share learnings. Pick a ready-made template to start fast."}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83C\uDFCE\uFE0F Kickstart collaboration with Jira & Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83C\uDFCE\uFE0F Kickstart collaboration with Confluence & Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-1.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83D\uDDBC\uFE0F See the full picture for your projects"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.conf":[{"type":0,"value":"Plan it, track it, get it done"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.jira":[{"type":0,"value":"Go from cluttered docs to organized knowledge"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.jiraConf":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-1.message-template.email.header.land":[{"type":0,"value":"Say \u201Cgoodbye\u201D to boring project docs"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-1.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Confluence"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.conf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.jira":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipButtonText.jiraConf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.conf":[{"type":0,"value":"Add Jira views as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Confluence to help keep everyone in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.jira":[{"type":0,"value":"Add Confluence docs as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira to help keep everyone in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipContent.jiraConf":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.conf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.jira":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.proTipHeader.jiraConf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.conf":[{"type":0,"value":"Use a "},{"children":[{"type":0,"value":"board"}],"type":8,"value":"b"},{"type":0,"value":" to arrange issues in columns, or plot work out on a "},{"children":[{"type":0,"value":"timeline"}],"type":8,"value":"b"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"calendar"}],"type":8,"value":"b"},{"type":0,"value":" over months or quarters."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.jira":[{"type":0,"value":"Add Jira boards, Google forms, Figma designs, Excel spreadsheets & more\u2014right into Confluence. It\'s your team\'s new single source of truth!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Description.land":[{"type":0,"value":"Embed Jira views, reports, and forms directly into Confluence pages with Smart Links."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.conf":[{"type":0,"value":"View it your way"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.jira":[{"type":0,"value":"Connect your work from anywhere"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step1Title.land":[{"type":0,"value":"Keep it all in sync"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.conf":[{"type":0,"value":"Let AI automatically transform Confluence notes into trackable work in Jira\u2014no copy-pasting or re-typing needed."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.jira":[{"type":0,"value":"Let AI automatically transform Confluence notes into trackable work in Jira\u2014no copy-pasting or re-typing needed."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Description.land":[{"type":0,"value":"Let AI automatically turn Confluence pages and whiteboards into trackable work in Jira."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.conf":[{"type":0,"value":"Auto-capture action items"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.jira":[{"type":0,"value":"Auto-capture action items"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step2Title.land":[{"type":0,"value":"Transform ideas into action"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.conf":[{"type":0,"value":"Create and edit Confluence docs and whiteboards right inside Jira to help your team stay connected all in one tool."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.jira":[{"type":0,"value":"Create and edit docs, whiteboards (anything, really!) right inside Confluence to help your team stay connected all in one tool."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.jiraConf":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Description.land":[{"type":0,"value":"View, edit, and create Confluence pages and whiteboards right from Jira, without losing context."}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.conf":[{"type":0,"value":"Never switch context again!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.jira":[{"type":0,"value":"Never switch context again!"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.jiraConf":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-1.message-template.email.step3Title.land":[{"type":0,"value":"View work across teams"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.conf":[{"type":0,"value":"Our top tips for planning and tracking work:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.jira":[{"type":0,"value":"Our top tips for connecting team knowledge:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.jiraConf":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-1.message-template.email.subheader.land":[{"type":0,"value":"How to plan, track, and doc with Confluence and Jira:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.conf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.jira":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.buttonText.land":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.conf":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.jira":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Chat with Rovo AI today to get on the fast-track to productivity."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingDescription.land":[{"type":0,"value":"Record your first Loom video today to show (not tell) what you\'re working on."}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to try out Rovo AI?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.closingTitle.land":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.conf":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.jira":[{"type":0,"value":"Record a Loom video to add visual context and clarity to project updates, presentations, and training materials."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.jiraConf":[{"type":0,"value":"Summarize, search, and streamline any task. No context-switching, no searching\u2014just better results."}],"growth-starburst.twc-onboarding-email-2.message-template.email.content.land":[{"type":0,"value":"Record a Loom video to add visual context to project updates, presentations, and training materials in Jira and Confluence."}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83E\uDD2B Your secret to better, faster teamwork"}],"growth-starburst.twc-onboarding-email-2.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83C\uDFAC Start your first Loom recording today"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.conf":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.jira":[{"type":0,"value":"Capture context in a single click"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.jiraConf":[{"type":0,"value":"Get to \u201Cdone\u201D faster with Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.header.land":[{"type":0,"value":"Bring work to life with video"}],"growth-starburst.twc-onboarding-email-2.message-template.email.item1.jiraConf":[{"children":[{"type":0,"value":"Take action in a flash"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Chat with Rovo AI to summarize updates, create tasks, and draft content in seconds."}],"growth-starburst.twc-onboarding-email-2.message-template.email.item2.jiraConf":[{"children":[{"type":0,"value":"Find, don\'t search"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Rovo AI Search provides rich, contextual answers grounded in your org\'s knowledge, history, and context."}],"growth-starburst.twc-onboarding-email-2.message-template.email.item3.jiraConf":[{"children":[{"type":0,"value":"Say \u201Chey\u201D to your AI teammate"}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":0,"value":"Call on Rovo to tackle any task and act on insights across all your apps and integrations."}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-2.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Loom"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.conf":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.jira":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipButtonText.land":[{"type":0,"value":"Try it out"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.conf":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.jira":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipContent.land":[{"type":0,"value":"Add Loom videos as "},{"children":[{"type":0,"value":"Smart Links"}],"type":8,"value":"b"},{"type":0,"value":" in Jira and Confluence to keep the team in sync"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.conf":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.jira":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.proTipHeader.land":[{"type":0,"value":"Pro tip!"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.conf":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.jira":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Description.land":[{"type":0,"value":"Drop Loom videos into Jira work items and Confluence docs for visual context that cuts through confusion."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.conf":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.jira":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step1Title.land":[{"type":0,"value":"Add clarity instantly"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.conf":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.jira":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Description.land":[{"type":0,"value":"Get automated meeting recaps\u2014with summaries and action items, so nothing slips through the cracks."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.conf":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.jira":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step2Title.land":[{"type":0,"value":"Take notes, without writing a single word"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.conf":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.jira":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Description.land":[{"type":0,"value":"Loom AI auto-captures feedback, triages bugs, and keeps your work in Jira moving along faster than ever."}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.conf":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.jira":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.step3Title.land":[{"type":0,"value":"Turn recordings into action"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.conf":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.jira":[{"type":0,"value":"How to work with AI-powered videos:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.jiraConf":[{"type":0,"value":"Top tips for working smarter & speedier with Rovo AI:"}],"growth-starburst.twc-onboarding-email-2.message-template.email.subheader.land":[{"type":0,"value":"How to work with AI-powered videos in Loom:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.conf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.jira":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.buttonText.land":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.conf":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.jira":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"Try out your Teamwork Collection apps today to transform how your team gets it all done."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingDescription.land":[{"type":0,"value":"Use Rovo AI to turn deliver big ideas faster and collaborate as a human-AI team. Try out Rovo AI with your collection of apps today."}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.conf":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.jira":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"There\'s no limit to what your team can do!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.closingTitle.land":[{"type":0,"value":"Discover a whole new way to teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.conf":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.jira":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.jiraConf":[{"type":0,"value":"Discover how your collection of apps helps boost productivity, save you valuable time, and transform how your team works."}],"growth-starburst.twc-onboarding-email-3.message-template.email.content.land":[{"type":0,"value":"Supercharge how you work with AI-powered Search, Chat, and Agents\u2014all integrated directly into Jira, Confluence, and Loom."}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83E\uDD29 Everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83E\uDD29 Here\'s everything you need to plan, sync, and launch\u2014together"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.conf":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.jira":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.jiraConf":[{"type":0,"value":"Go further with the power of teamwork"}],"growth-starburst.twc-onboarding-email-3.message-template.email.header.land":[{"type":0,"value":"Get to \u201Cdone\u201D faster with your apps + Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Explore now"}],"growth-starburst.twc-onboarding-email-3.message-template.email.mainImageAltText.land":[{"type":0,"value":"Explore Rovo AI"}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipButtonText.land":[{"type":0,"value":"Read more"}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipContent.land":[{"type":0,"value":"The Rovo guide introduces the basics of working with AI Search, Chat and agents."}],"growth-starburst.twc-onboarding-email-3.message-template.email.proTipHeader.land":[{"type":0,"value":"Pro tip:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.conf":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.jira":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Link Confluence pages to Jira tasks, and add in a Loom video for extra context. Then, Rovo AI unites it all into clear, actionable team summaries."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Description.land":[{"type":0,"value":"Need help dreaming up your next big idea? Brainstorm project docs and tasks with Rovo Chat to create everything you need in the blink of an eye."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.conf":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.jira":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Share powerful, contextual updates"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step1Title.land":[{"type":0,"value":"Create anything in seconds!"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.conf":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.jira":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Brainstorm in Confluence, and instantly turn your notes into Jira tasks. Then, perfect your project plan with Rovo AI, sharing Loom video updates at every step."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Description.land":[{"type":0,"value":"Use Rovo AI to automatically scan Confluence pages for action items and turn them into Jira tasks with just a few clicks."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.conf":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.jira":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Smash projects, as a team"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step2Title.land":[{"type":0,"value":"Transform pages into action"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.conf":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.jira":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.jiraConf":[{"type":0,"value":"Automate meeting notes with Loom, summarize & assign action items with AI, and co-create docs and resources on the fly in Confluence."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Description.land":[{"type":0,"value":"Use Rovo AI to break your Jira work items into easily-achievable sub-tasks. Automatically surface related Confluence pages, and use them to create descriptions."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.conf":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.jira":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.jiraConf":[{"type":0,"value":"Redefine how you collaborate"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step3Title.land":[{"type":0,"value":"Instantly enhance your work"}],"growth-starburst.twc-onboarding-email-3.message-template.email.step4Description.land":[{"type":0,"value":"Create and embed a Loom right from your Confluence page (along with AI-generated notes or action items!) and keep everyone in-the-know."}],"growth-starburst.twc-onboarding-email-3.message-template.email.step4Title.land":[{"type":0,"value":"Auto-summarize with video"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.conf":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.jira":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.jiraConf":[{"type":0,"value":"3 easy ways to speed up your workflows:"}],"growth-starburst.twc-onboarding-email-3.message-template.email.subheader.land":[{"type":0,"value":"Try this workflow for using Jira, Confluence, Loom, and Rovo together:"}],"growth-starburst.twc-onboarding-widget.onboarding-card.dismiss-tooltip":[{"type":0,"value":"Dismiss"}],"growth-starburst.twc-onboarding-widget.onboarding-card.status":[{"type":0,"value":"Completed"}],"growth-starburst.twc-project-pages-confluence-tour.back":[{"type":0,"value":"Back"}],"growth-starburst.twc-project-pages-confluence-tour.dismiss":[{"type":0,"value":"Dismiss"}],"growth-starburst.twc-project-pages-confluence-tour.done":[{"type":0,"value":"Done"}],"growth-starburst.twc-project-pages-confluence-tour.next":[{"type":0,"value":"Next"}],"growth-starburst.twc-project-pages-confluence-tour.step1.description":[{"type":0,"value":"Create, update and manage Jira work directly in Pages."}],"growth-starburst.twc-project-pages-confluence-tour.step1.header":[{"type":0,"value":"Create Jira tasks directly in Pages"}],"growth-starburst.twc-project-pages-confluence-tour.step1.progressIndicator":[{"type":0,"value":"1 of 3"}],"growth-starburst.twc-project-pages-confluence-tour.step2.description":[{"type":0,"value":"Generate content easily and quickly with our AI-powered writing assistant. Type /rovo to try it now."}],"growth-starburst.twc-project-pages-confluence-tour.step2.header":[{"type":0,"value":"Let AI do the writing for you"}],"growth-starburst.twc-project-pages-confluence-tour.step2.progressIndicator":[{"type":0,"value":"2 of 3"}],"growth-starburst.twc-project-pages-confluence-tour.step3.description":[{"type":0,"value":"Loom can create a script from your page content. Record a quick video and add it to your doc to explain updates."}],"growth-starburst.twc-project-pages-confluence-tour.step3.header":[{"type":0,"value":"Share updates with video"}],"growth-starburst.twc-project-pages-confluence-tour.step3.progressIndicator":[{"type":0,"value":"3 of 3"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.conf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.jira":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.jiraConf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.buttonText.land":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.conf":[{"type":0,"value":"See how Jira, Loom, and Rovo plug into your Confluence workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.jira":[{"type":0,"value":"See how Confluence, Loom, and Rovo plug into your Jira workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.jiraConf":[{"type":0,"value":"See how Loom and Rovo plug into your Jira and Confluence workflows today."}],"growth-starburst.twc-welcome-email.message-template.email.closingDescription.land":[{"type":0,"value":"Jump into Jira to create your first task"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.conf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.jira":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.jiraConf":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.closingTitle.land":[{"type":0,"value":"Ready to get started?"}],"growth-starburst.twc-welcome-email.message-template.email.content.conf":[{"type":0,"value":"Your new collection of apps supercharges productivity with work tracking across teams, async video, and AI-powered insights\u2014all alongside Confluence."}],"growth-starburst.twc-welcome-email.message-template.email.content.jira":[{"type":0,"value":"Your new collection of apps supercharges productivity with org-wide knowledge sharing, async video, and AI-powered insights\u2014all alongside Jira."}],"growth-starburst.twc-welcome-email.message-template.email.content.jiraConf":[{"type":0,"value":"Your new collection of apps supercharges productivity with async video and AI-powered insights\u2014all alongside Jira & Confluence."}],"growth-starburst.twc-welcome-email.message-template.email.content.land":[{"type":0,"value":"Collaborate and achieve more\u2014right from day one. We\'ll guide you step-by-step over the next few days."}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.conf":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.jira":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.jiraConf":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.emailSubject.land":[{"type":0,"value":"\uD83D\uDE4C You\'re in\u2014welcome to Teamwork Collection!"}],"growth-starburst.twc-welcome-email.message-template.email.header.conf":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.jira":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.jiraConf":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.header.land":[{"type":0,"value":"Meet your team\'s new superpower"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.conf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.jira":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.jiraConf":[{"type":0,"value":"Start exploring"}],"growth-starburst.twc-welcome-email.message-template.email.mainImageAltText.land":[{"type":0,"value":"Start with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.conf":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.jira":[{"type":0,"value":"Create and share information effortlessly\u2014plan better, stay aligned, and keep everything you need right at your fingertips."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.jiraConf":[{"type":0,"value":"Send quick video messages that add context, save time, reduce meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step1Description.land":[{"type":0,"value":"Create "},{"children":[{"type":0,"value":"work items"}],"type":8,"value":"b"},{"type":0,"value":", which are chunks of work (just like to-dos) that you can break down into smaller, more achievable tasks."}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.conf":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.jira":[{"type":0,"value":"Organize knowledge with Confluence"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.jiraConf":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step1Title.land":[{"type":0,"value":"Break down your work"}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.conf":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.jira":[{"type":0,"value":"Send quick video messages that add context, save time, cut out meetings, and keep everyone in sync across time zones."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.jiraConf":[{"type":0,"value":"Automatically get answers to anything your team needs with Rovo Chat, automate tasks with AI agents, and find exactly what you need with AI Search."}],"growth-starburst.twc-welcome-email.message-template.email.step2Description.land":[{"type":0,"value":"Add "},{"children":[{"type":0,"value":"fields"}],"type":8,"value":"b"},{"type":0,"value":" to include all the important details to your work items, like due dates, assignees, priority, and more."}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.conf":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.jira":[{"type":0,"value":"Share updates instantly with Loom"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.jiraConf":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step2Title.land":[{"type":0,"value":"Add important details"}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.conf":[{"type":0,"value":"Plan and manage anything\u2014from big projects to daily tasks\u2014with seamless workflows, real-time tracking, and clear alignment to goals."}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.jira":[{"type":0,"value":"Automatically get answers to anything your team needs with Rovo Chat, automate tasks with AI agents, and find exactly what you need with AI Search."}],"growth-starburst.twc-welcome-email.message-template.email.step3Description.land":[{"type":0,"value":"Use a "},{"children":[{"type":0,"value":"board"}],"type":8,"value":"b"},{"type":0,"value":" to arrange work items in columns and by status, or plot work out on a "},{"children":[{"type":0,"value":"timeline"}],"type":8,"value":"b"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"calendar"}],"type":8,"value":"b"},{"type":0,"value":" view over months or quarters."}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.conf":[{"type":0,"value":"Get it done with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.jira":[{"type":0,"value":"Work smarter with Rovo AI"}],"growth-starburst.twc-welcome-email.message-template.email.step3Title.land":[{"type":0,"value":"View it your way"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.conf":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.jira":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.jiraConf":[{"type":0,"value":"Our expert tips for using your new apps:"}],"growth-starburst.twc-welcome-email.message-template.email.subheader.land":[{"type":0,"value":"We recommend starting with Jira"}],"growth-starburst.twc-welcome-email.message-template.email.subheaderDescription.land":[{"type":0,"value":"Managing your projects starts with Jira. Start by setting things up to manage your work more efficiently:"}],"growth-starburst.wac-product-activation-checklist.add-comment.cta":[{"type":0,"value":"Add comment"}],"growth-starburst.wac-product-activation-checklist.add-comment.description":[{"type":0,"value":"Jump back into a recent work item and leave a comment for your team."}],"growth-starburst.wac-product-activation-checklist.add-comment.title":[{"type":0,"value":"Add a comment to a work item"}],"growth-starburst.wac-product-activation-checklist.create-work-item.cta":[{"type":0,"value":"Create work item"}],"growth-starburst.wac-product-activation-checklist.create-work-item.description":[{"type":0,"value":"Use AI to draft a work item in your most recent Jira Software project."}],"growth-starburst.wac-product-activation-checklist.create-work-item.title":[{"type":0,"value":"Create your first Jira work item"}],"growth-starburst.wac-product-activation-checklist.dismiss-checklist":[{"type":0,"value":"Dismiss checklist"}],"growth-starburst.wac-product-activation-checklist.invite-team.cta":[{"type":0,"value":"Invite team"}],"growth-starburst.wac-product-activation-checklist.invite-team.description":[{"type":0,"value":"Bring teammates into Jira so everyone can collaborate in one place."}],"growth-starburst.wac-product-activation-checklist.invite-team.title":[{"type":0,"value":"Invite your team"}],"growth-starburst.wac-product-activation-checklist.item-completed":[{"type":0,"value":"Completed"}],"growth-starburst.wac-product-activation-checklist.update-work-item.cta":[{"type":0,"value":"Update work item"}],"growth-starburst.wac-product-activation-checklist.update-work-item.description":[{"type":0,"value":"Open a recent work item and update one of its fields."}],"growth-starburst.wac-product-activation-checklist.update-work-item.title":[{"type":0,"value":"Update a work item"}],"jira-project-space-connected.message-templates.spotlight-description-couse":[{"type":0,"value":"Create pages for your project without leaving Jira."}],"jira-project-space-connected.message-templates.spotlight-description-xflow":[{"type":0,"value":"Create Confluence pages within Jira. Free for 10 users."}],"jira-project-space-connected.message-templates.spotlight-header-couse":[{"type":0,"value":"Your project has Confluence pages"}],"jira-project-space-connected.message-templates.spotlight-header-xflow":[{"type":0,"value":"Add pages to your project"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.body":[{"type":0,"value":"Instead of manually typing meeting notes, why not try Loom to record meetings?"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.close":[{"type":0,"value":"Close"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.cta":[{"type":0,"value":"Try now"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.header":[{"type":0,"value":"Automate meeting notes"}],"post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.image-alt":[{"type":0,"value":"Notepad with sparkling background"}],"post-office.project-assets-ai-suggestions.empty-state":[{"type":0,"value":"No suggestions available right now."}],"post-office.project-assets-ai-suggestions.header.loaded":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" suggested action"}]},"other":{"value":[{"type":7},{"type":0,"value":" suggested actions"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"post-office.project-assets-ai-suggestions.header.loading":[{"type":0,"value":"Rovo is analyzing\u2026"}],"post-office.project-assets-ai-suggestions.loom-meeting-notes.cta":[{"type":0,"value":"Set up Loom"}],"post-office.project-assets-ai-suggestions.loom-meeting-notes.description":[{"type":0,"value":"Use Loom to record meetings and auto-create notes, so you never forget next steps."}],"post-office.project-assets-ai-suggestions.loom-meeting-notes.title":[{"type":0,"value":"Set up meeting notes"}],"post-office.project-assets-ai-suggestions.project-plan.cta":[{"type":0,"value":"Create summary"}],"post-office.project-assets-ai-suggestions.project-plan.description":[{"type":0,"value":"Create a project plan for your newly added epic "},{"type":1,"value":"epicKey"},{"type":0,"value":" to share with your team."}],"post-office.project-assets-ai-suggestions.project-plan.title":[{"type":0,"value":"Create a project plan"}],"post-office.project-assets-ai-suggestions.toggle.hide":[{"type":0,"value":"Hide"}],"post-office.project-assets-ai-suggestions.toggle.show":[{"type":0,"value":"Show"}],"post-office.project-assets-ai-suggestions.weekly-summary.additional-count":[{"type":0,"value":" +"},{"type":1,"value":"count"}],"post-office.project-assets-ai-suggestions.weekly-summary.cta":[{"type":0,"value":"Create summary"}],"post-office.project-assets-ai-suggestions.weekly-summary.description":[{"type":0,"value":"Create a summary for completed tasks "},{"type":1,"value":"issueKey"},{"type":1,"value":"additionalCount"},{"type":0,"value":" to share with leadership."}],"post-office.project-assets-ai-suggestions.weekly-summary.title":[{"type":0,"value":"Create a weekly summary"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.for-you-spotlight-text":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.rovo-chat-spotlight-text":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-screen-space-flags.twc-spotlight-test.switcher-spotlight-text":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-modal.progress":[{"type":1,"value":"currentSpotlightNumber"},{"type":0,"value":"/"},{"type":1,"value":"numTotalSpotlights"}],"townsquare.townsquare-twc-modal.twc-modal-story.for-you-spotlight-text.no-translate":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-twc-modal.twc-modal-story.rovo-chat-spotlight-text.no-translate":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-twc-modal.twc-modal-story.switcher-spotlight-text.no-translate":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.for-you-spotlight-text.no-translate":[{"type":0,"value":"for you spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.rovo-chat-spotlight-text.no-translate":[{"type":0,"value":"rovo chat spotlight"}],"townsquare.townsquare-twc-modal.twc-spotlight-test.switcher-spotlight-text.no-translate":[{"type":0,"value":"switcher spotlight"}],"townsquare.townsquare-twc-spotlight.progress":[{"type":1,"value":"currentSpotlightNumber"},{"type":0,"value":"/"},{"type":1,"value":"numTotalSpotlights"}],"townsquare.twc-onboarding-modal.app-switcher.body":[{"type":0,"value":"Use this menu to easily switch between other Atlassian apps."}],"townsquare.twc-onboarding-modal.app-switcher.heading":[{"type":0,"value":"Find all your apps here"}],"townsquare.twc-onboarding-modal.apps-icon-label":[{"type":0,"value":"Apps"}],"townsquare.twc-onboarding-modal.atlassian-home":[{"type":0,"value":"Access all your "},{"children":[{"type":0,"value":"work"}],"type":8,"value":"bold"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"spaces"}],"type":8,"value":"bold"},{"type":0,"value":" in Atlassian Home"}],"townsquare.twc-onboarding-modal.atlassian-logo-label":[{"type":0,"value":"Atlassian"}],"townsquare.twc-onboarding-modal.back-button":[{"type":0,"value":"Back"}],"townsquare.twc-onboarding-modal.close-button-label":[{"type":0,"value":"Close onboarding modal"}],"townsquare.twc-onboarding-modal.confluence-feature":[{"type":0,"value":"Document notes and knowledge in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.confluence-icon-label":[{"type":0,"value":"Confluence"}],"townsquare.twc-onboarding-modal.connect-integrations":[{"type":0,"value":"Connect work with "},{"children":[{"type":0,"value":"teams, AI,"}],"type":8,"value":"bold"},{"type":0,"value":" and more"}],"townsquare.twc-onboarding-modal.connect-work-title":[{"type":0,"value":"Connect work across Atlassian"}],"townsquare.twc-onboarding-modal.description":[{"type":0,"value":"Collaborating is easier than ever with new apps and features, including AI-powered Search and Chat."}],"townsquare.twc-onboarding-modal.explore-atlassian-home":[{"type":0,"value":"Explore Atlassian Home"}],"townsquare.twc-onboarding-modal.explore-loom":[{"type":0,"value":"Explore Loom"}],"townsquare.twc-onboarding-modal.for-you.body":[{"type":0,"value":"Home connects work from across Atlassian, giving you an overview of what\'s happening across teams, goals, and projects."}],"townsquare.twc-onboarding-modal.for-you.generic-heading":[{"type":0,"value":"Welcome Home!"}],"townsquare.twc-onboarding-modal.for-you.heading":[{"type":0,"value":"Welcome Home, "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"townsquare.twc-onboarding-modal.got-it-button":[{"type":0,"value":"Got it"}],"townsquare.twc-onboarding-modal.home-icon-label":[{"type":0,"value":"Home"}],"townsquare.twc-onboarding-modal.illustration-alt":[{"type":0,"value":"Illustration showing collaborative teamwork with connected apps and AI-powered features"}],"townsquare.twc-onboarding-modal.integration-feature":[{"type":0,"value":"Bring it all together with "},{"children":[{"type":0,"value":"teams, AI,"}],"type":8,"value":"bold"},{"type":0,"value":" and more"}],"townsquare.twc-onboarding-modal.integration-icon-label":[{"type":0,"value":"Integration"}],"townsquare.twc-onboarding-modal.jira-confluence-features":[{"type":0,"value":"Add context in "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"bold"},{"type":0,"value":" with detailed docs in "},{"children":[{"type":0,"value":"Confluence"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.jira-feature":[{"type":0,"value":"Map out your team\'s work and tasks in "},{"children":[{"type":0,"value":"Jira"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.jira-icon-label":[{"type":0,"value":"Jira"}],"townsquare.twc-onboarding-modal.left-align-icon-label":[{"type":0,"value":"Align Text Left"}],"townsquare.twc-onboarding-modal.loom-add-demos":[{"type":0,"value":"Add "},{"children":[{"type":0,"value":"demos"}],"type":8,"value":"bold"},{"type":0,"value":" and walkthroughs of your work in Jira"}],"townsquare.twc-onboarding-modal.loom-bring-together":[{"type":0,"value":"Bring it all together with "},{"children":[{"type":0,"value":"teams, goals, AI"}],"type":8,"value":"bold"},{"type":0,"value":", and more"}],"townsquare.twc-onboarding-modal.loom-description":[{"type":0,"value":"Loom makes it easy to record videos and streamline communication in the apps you already use:"}],"townsquare.twc-onboarding-modal.loom-feature":[{"type":0,"value":"Share and embed async video updates with "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.loom-icon-label":[{"type":0,"value":"Loom"}],"townsquare.twc-onboarding-modal.loom-share-updates":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"Loom"}],"type":8,"value":"bold"},{"type":0,"value":" to easily share updates and knowledge"}],"townsquare.twc-onboarding-modal.loom-title":[{"type":0,"value":"Create better shareouts with Loom"}],"townsquare.twc-onboarding-modal.loom-use-videos":[{"type":0,"value":"Use videos to give "},{"children":[{"type":0,"value":"context"}],"type":8,"value":"bold"},{"type":0,"value":" to Confluence pages"}],"townsquare.twc-onboarding-modal.new-apps-one":[{"type":0,"value":"Streamline work with "},{"children":[{"type":1,"value":"appOneName"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.new-apps-title":[{"type":0,"value":"New apps and features are here"}],"townsquare.twc-onboarding-modal.new-apps-two":[{"type":0,"value":"Streamline work with "},{"children":[{"type":1,"value":"appOneName"}],"type":8,"value":"bold"},{"type":0,"value":" and "},{"children":[{"type":1,"value":"appTwoName"}],"type":8,"value":"bold"}],"townsquare.twc-onboarding-modal.next-button":[{"type":0,"value":"Next"}],"townsquare.twc-onboarding-modal.ok-button":[{"type":0,"value":"Ok"}],"townsquare.twc-onboarding-modal.rovo-chat.body":[{"type":0,"value":"You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things."}],"townsquare.twc-onboarding-modal.rovo-chat.heading":[{"type":0,"value":"Chat with AI"}],"townsquare.twc-onboarding-modal.spotlight.close-button-label":[{"type":0,"value":"Close onboarding spotlight tour"}],"townsquare.twc-onboarding-modal.take-a-tour-button":[{"type":0,"value":"Take a tour"}],"townsquare.twc-onboarding-modal.teams-icon-label":[{"type":0,"value":"Integration"}],"townsquare.twc-onboarding-modal.title":[{"type":0,"value":"Transform teamwork, together"}],"townsquare.twc-onboarding-modal.try-now-button":[{"type":0,"value":"Try now"}],"townsquare.twc-onboarding-spotlight.app-switcher.body":[{"type":0,"value":"Use this menu to easily switch between other Atlassian apps."}],"townsquare.twc-onboarding-spotlight.app-switcher.heading":[{"type":0,"value":"Find all your apps here"}],"townsquare.twc-onboarding-spotlight.back-button":[{"type":0,"value":"Back"}],"townsquare.twc-onboarding-spotlight.close-button-label":[{"type":0,"value":"Close"}],"townsquare.twc-onboarding-spotlight.for-you.body":[{"type":0,"value":"Home connects work from across Atlassian, giving you an overview of what\'s happening across teams, goals, and projects."}],"townsquare.twc-onboarding-spotlight.for-you.generic-heading":[{"type":0,"value":"Welcome Home!"}],"townsquare.twc-onboarding-spotlight.for-you.heading":[{"type":0,"value":"Welcome Home, "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"townsquare.twc-onboarding-spotlight.next-button":[{"type":0,"value":"Next"}],"townsquare.twc-onboarding-spotlight.ok-button":[{"type":0,"value":"Ok"}],"townsquare.twc-onboarding-spotlight.rovo-chat.body":[{"type":0,"value":"You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things."}],"townsquare.twc-onboarding-spotlight.rovo-chat.heading":[{"type":0,"value":"Chat with AI"}],"townsquare.twc-onboarding-spotlight.try-now-button":[{"type":0,"value":"Try now"}],"townsquare.twc-onboarding-widget.chat-card.cta":[{"type":0,"value":"Try Chat"}],"townsquare.twc-onboarding-widget.chat-card.description":[{"type":0,"value":"Get helpful answers to your questions and collaborate with AI on your work."}],"townsquare.twc-onboarding-widget.chat-card.heading":[{"type":0,"value":"Chat with Rovo"}],"townsquare.twc-onboarding-widget.confluence-card.cta":[{"type":0,"value":"Try Confluence"}],"townsquare.twc-onboarding-widget.confluence-card.description":[{"type":0,"value":"Create a knowledge bank available to everyone in your team."}],"townsquare.twc-onboarding-widget.confluence-card.heading":[{"type":0,"value":"Write docs with Confluence"}],"townsquare.twc-onboarding-widget.goals-card.cta":[{"type":0,"value":"Try Goals"}],"townsquare.twc-onboarding-widget.goals-card.description":[{"type":0,"value":"Align your work with goals to make sure you are on track."}],"townsquare.twc-onboarding-widget.goals-card.heading":[{"type":0,"value":"Track progress with goals"}],"townsquare.twc-onboarding-widget.jira-card.cta":[{"type":0,"value":"Try Jira"}],"townsquare.twc-onboarding-widget.jira-card.description":[{"type":0,"value":"Create project tasks to begin managing your project."}],"townsquare.twc-onboarding-widget.jira-card.heading":[{"type":0,"value":"Plan out tasks with Jira"}],"townsquare.twc-onboarding-widget.loom-card.cta":[{"type":0,"value":"Try Loom"}],"townsquare.twc-onboarding-widget.loom-card.description":[{"type":0,"value":"Share async video updates and reduce meetings for all."}],"townsquare.twc-onboarding-widget.loom-card.heading":[{"type":0,"value":"Share updates with Loom"}],"townsquare.twc-onboarding-widget.search-card.cta":[{"type":0,"value":"Try Search"}],"townsquare.twc-onboarding-widget.search-card.description":[{"type":0,"value":"Power up your searches with AI and find what you\'re looking for faster."}],"townsquare.twc-onboarding-widget.search-card.heading":[{"type":0,"value":"Find more with Search"}],"townsquare.twc-onboarding-widget.studio-card.cta":[{"type":0,"value":"Try Studio"}],"townsquare.twc-onboarding-widget.studio-card.description":[{"type":0,"value":"Build custom AI agents, automations, and more without needing to code."}],"townsquare.twc-onboarding-widget.studio-card.heading":[{"type":0,"value":"Automate work with Studio"}],"townsquare.twc-onboarding-widget.teams-card.cta":[{"type":0,"value":"Try Teams"}],"townsquare.twc-onboarding-widget.teams-card.description":[{"type":0,"value":"Collaborate more with teams and unlock the power of your teammates."}],"townsquare.twc-onboarding-widget.teams-card.heading":[{"type":0,"value":"Collaborate with teams"}],"townsquare.twc-onboarding-widget.twc-card.cta":[{"type":0,"value":"Watch video"}],"townsquare.twc-onboarding-widget.twc-card.description":[{"type":0,"value":"Not sure where to start? Find out how your apps can streamline your work."}],"townsquare.twc-onboarding-widget.twc-card.heading":[{"type":0,"value":"See how it all works together"}],"townsquare.twc-onboarding-widget.twc-card.modal-close":[{"type":0,"value":"Close"}],"townsquare.twc-onboarding-widget.twc-card.modal-external-link":[{"type":0,"value":"Open link"}],"townsquare.twc-onboarding-widget.twc-card.modal-title":[{"type":0,"value":"Welcome to Atlassian"}],"twc-jira.email.header.alt":[{"type":0,"value":"Jira"}],"twc.email.header.alt":[{"type":0,"value":"Teamwork Collection Atlassian"}],"twc.sidenav.banner.generic.app.tiles.alt":[{"type":0,"value":"App tiles illustration"}],"twc.sidenav.banner.generic.close":[{"type":0,"value":"Close"}],"twc.sidenav.banner.generic.cta":[{"type":0,"value":"Try now"}],"twc.sidenav.banner.generic.heading":[{"type":0,"value":"Explore Teamwork Collection"}],"twc.sidenav.banner.generic.subheading.confluence":[{"type":0,"value":"Discover how the other apps can accelerate your workflows in Confluence."}],"twc.sidenav.banner.generic.subheading.jira":[{"type":0,"value":"Discover how the other apps can accelerate your workflows in Jira."}],"twc.sidenav.banner.personalized.app.tiles.alt":[{"type":0,"value":"App tiles illustration"}],"twc.sidenav.banner.personalized.close":[{"type":0,"value":"Close"}],"twc.sidenav.banner.personalized.cta":[{"type":0,"value":"Get started"}],"twc.sidenav.banner.personalized.heading":[{"type":0,"value":"Explore Teamwork Collection"}],"twc.sidenav.banner.personalized.subheading.confluence":[{"type":0,"value":"Create with Rovo in Confluence"}],"twc.sidenav.banner.personalized.subheading.jira":[{"type":0,"value":"Plan your next team project in Jira"}],"twc.sidenav.banner.personalized.subheading.loom":[{"type":0,"value":"Setup video meetings with Loom AI"}],"twc.solo.admin.invite.body.comment_created_v2":[{"type":0,"value":"Invite your team so they can see your comments, reply, and stay in the loop!"}],"twc.solo.admin.invite.body.issue_completed_v2":[{"type":0,"value":"Invite your team so they can review your completed Jira ticket, leave comments, and create a new one!"}],"twc.solo.admin.invite.body.issue_created_only_v2":[{"type":0,"value":"Invite your team so they can review your new Jira ticket, leave comments, and help you finish it!"}],"twc.solo.admin.invite.body.loom_active_v2":[{"type":0,"value":"Invite your team so they can watch your Loom, leave comments, and record their own videos!"}],"twc.solo.admin.invite.body.no_actions":[{"type":0,"value":"Teamwork Collection is better together. Invite your team and try creating a page together, assigning a task, or recording a quick Loom!"}],"twc.solo.admin.invite.body.page_edited_v2":[{"type":0,"value":"Invite your team so they can review your edited doc, leave comments, and add their own ideas!"}],"twc.solo.admin.invite.body.template_used_v2":[{"type":0,"value":"Invite your team so they can use your template, leave comments, and add their own ideas!"}],"twc.solo.admin.invite.cta":[{"type":0,"value":"Invite teammates"}],"twc.solo.admin.invite.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"twc.solo.admin.invite.headline.no_actions":[{"type":0,"value":"Now that you have Teamwork Collection, bring in your team!"}],"twc.solo.admin.invite.headline.shared_v2":[{"type":0,"value":"Teams that share are "},{"children":[{"type":0,"value":"4x"}],"type":8,"value":"em"},{"type":0,"value":" more likely to stay on track"}],"twc.solo.admin.invite.hero.alt.comment_created":[{"type":0,"value":"Illustration of a comment being shared with teammates"}],"twc.solo.admin.invite.hero.alt.issue_completed":[{"type":0,"value":"Illustration of a completed Jira issue being shared with teammates"}],"twc.solo.admin.invite.hero.alt.issue_created_only":[{"type":0,"value":"Illustration of a new Jira issue being shared with teammates"}],"twc.solo.admin.invite.hero.alt.loom_active":[{"type":0,"value":"Illustration of a Loom recording being shared with teammates"}],"twc.solo.admin.invite.hero.alt.no_actions":[{"type":0,"value":"Illustration of Jira, Confluence, Loom and Rovo working together"}],"twc.solo.admin.invite.hero.alt.page_edited":[{"type":0,"value":"Illustration of an edited document being shared with teammates"}],"twc.solo.admin.invite.hero.alt.template_used":[{"type":0,"value":"Illustration of a template being shared with teammates"}],"twc.solo.admin.invite.preheader.comment_created":[{"type":0,"value":"You\'ve started a conversation\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.preheader.issue_completed":[{"type":0,"value":"You\'ve completed a Jira ticket\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.preheader.issue_created_only":[{"type":0,"value":"You\'ve created a Jira ticket\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.preheader.loom_active":[{"type":0,"value":"You\'ve recorded a Loom\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.preheader.no_actions":[{"type":0,"value":"Bring in your team to collaborate across your apps"}],"twc.solo.admin.invite.preheader.page_edited":[{"type":0,"value":"You\'ve edited a doc\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.preheader.template_used":[{"type":0,"value":"You\'ve set up a template\u2014now bring in your team to keep the momentum going."}],"twc.solo.admin.invite.secondary.body":[{"type":0,"value":"Invite your teammates to open up the conversation."}],"twc.solo.admin.invite.secondary.heading":[{"type":0,"value":"Teamwork Collection\u2019s better together"}],"twc.solo.admin.invite.signoff":[{"type":0,"value":"The Atlassian Team"}],"twc.solo.admin.invite.subject.comment_created":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}],"twc.solo.admin.invite.subject.issue_completed":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}],"twc.solo.admin.invite.subject.issue_created_only":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}],"twc.solo.admin.invite.subject.loom_active":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}],"twc.solo.admin.invite.subject.no_actions":[{"type":0,"value":"\uD83D\uDC65 Teamwork Collection is better together"}],"twc.solo.admin.invite.subject.page_edited":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}],"twc.solo.admin.invite.subject.template_used":[{"type":0,"value":"\uD83D\uDC65 Keep your team in the loop"}]}');

});

parcelRegister("dhNNU", function(module, exports) {

let $9ac37ef3cce02440$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ac37ef3cce02440$var$load("aqnFU").then(()=>parcelRequire('jYKHD'));

});

parcelRegister("jeBuB", function(module, exports) {

let $e00c6860b85e4658$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e00c6860b85e4658$var$load("8IMxm").then(()=>parcelRequire('hNpkf'));

});

parcelRegister("j6f4O", function(module, exports) {

let $de7a45c5df1f7d9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de7a45c5df1f7d9b$var$load("5XnIl").then(()=>parcelRequire('a1RiA'));

});

parcelRegister("kD2zY", function(module, exports) {

let $f0497354db2fd90f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0497354db2fd90f$var$load("5Axcp").then(()=>parcelRequire('kdROr'));

});

parcelRegister("92Bya", function(module, exports) {

let $69516d9e1a6e32ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69516d9e1a6e32ef$var$load("8IMve").then(()=>parcelRequire('1Ek80'));

});

parcelRegister("aOWdw", function(module, exports) {

let $7e0bbb9b78325536$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e0bbb9b78325536$var$load("3Suyp").then(()=>parcelRequire('ei8yv'));

});

parcelRegister("7t4bC", function(module, exports) {

let $56fe7d2ca6661ff6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56fe7d2ca6661ff6$var$load("7QQXz").then(()=>parcelRequire('2PgcG'));

});

parcelRegister("7Sa8a", function(module, exports) {

let $5bb56f4d5ad59576$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bb56f4d5ad59576$var$load("9wHYa").then(()=>parcelRequire('1HGZy'));

});

parcelRegister("lXA5l", function(module, exports) {

let $ffcb1970202a00ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffcb1970202a00ac$var$load("amUuO").then(()=>parcelRequire('64R0b'));

});

parcelRegister("5aTpK", function(module, exports) {

let $3c48df106ec5adb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c48df106ec5adb9$var$load("hQmwz").then(()=>parcelRequire('hRXdX'));

});

parcelRegister("7fLFn", function(module, exports) {

let $547ee8ad6758eca1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $547ee8ad6758eca1$var$load("8u6e4").then(()=>parcelRequire('8kSz9'));

});

parcelRegister("lhgAS", function(module, exports) {

let $f7d80eb4c0ac4ee3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7d80eb4c0ac4ee3$var$load("d1pZ3").then(()=>parcelRequire('4vpaT'));

});

parcelRegister("lNiHq", function(module, exports) {

let $fddcade5dff993bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fddcade5dff993bf$var$load("sXDfU").then(()=>parcelRequire('9PwX5'));

});

parcelRegister("h1f53", function(module, exports) {

let $c63e3a5cec821530$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c63e3a5cec821530$var$load("5ktje").then(()=>parcelRequire('5j0tp'));

});

parcelRegister("9euo9", function(module, exports) {

let $6b8cfe60d53b77ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b8cfe60d53b77ed$var$load("6zSFk").then(()=>parcelRequire('8Q41L'));

});

parcelRegister("aQeTx", function(module, exports) {

let $7e4a50808c076bb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e4a50808c076bb7$var$load("5u7RJ").then(()=>parcelRequire('74Awr'));

});

parcelRegister("jKCUu", function(module, exports) {

let $e6107ef57df48fef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6107ef57df48fef$var$load("9igas").then(()=>parcelRequire('21oBo'));

});

parcelRegister("1u5LJ", function(module, exports) {

let $114d115e867eb5f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $114d115e867eb5f5$var$load("5VCId").then(()=>parcelRequire('1BVGI'));

});

parcelRegister("d2bnS", function(module, exports) {

let $97d44aeda7a6b877$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97d44aeda7a6b877$var$load("5U9Bf").then(()=>parcelRequire('dOoDk'));

});

parcelRegister("bd2Zq", function(module, exports) {

let $82933a480f2fd7de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82933a480f2fd7de$var$load("cJRtC").then(()=>parcelRequire('hJlwC'));

});

parcelRegister("1wPMw", function(module, exports) {

let $11d0f25b26cbc41f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11d0f25b26cbc41f$var$load("9CnFE").then(()=>parcelRequire('aLq5r'));

});

parcelRegister("gF5rz", function(module, exports) {

let $c214b2b320eec5d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c214b2b320eec5d6$var$load("kOzld").then(()=>parcelRequire('3mpWH'));

});

parcelRegister("elclF", function(module, exports) {

let $a70c9b059ae1b002$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a70c9b059ae1b002$var$load("72WHu").then(()=>parcelRequire('glQOK'));

});

parcelRegister("kbgzR", function(module, exports) {

let $eb11b1a98b3708c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb11b1a98b3708c0$var$load("8lLIr").then(()=>parcelRequire('gbPzc'));

});

parcelRegister("v1pT0", function(module, exports) {

let $05d3fea7fa91b50f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05d3fea7fa91b50f$var$load("8swF7").then(()=>parcelRequire('kf6KA'));

});

parcelRegister("l0Crr", function(module, exports) {

let $f4b76ac404019fb4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f4b76ac404019fb4$var$load("aM9Tn").then(()=>parcelRequire('jACzc'));

});

parcelRegister("9PZYW", function(module, exports) {

let $7298f4d07fde2f8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7298f4d07fde2f8e$var$load("dO5k0").then(()=>parcelRequire('27czT'));

});

parcelRegister("injBd", function(module, exports) {

let $d60993fd2ff869e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d60993fd2ff869e0$var$load("lGEzi").then(()=>parcelRequire('KrNgY'));

});

parcelRegister("hzgJF", function(module, exports) {

let $cca2afe71ba85f7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cca2afe71ba85f7e$var$load("dho0e").then(()=>parcelRequire('lxrg6'));

});

parcelRegister("2aS0a", function(module, exports) {

let $1956678aa30362a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1956678aa30362a8$var$load("blgK2").then(()=>parcelRequire('g4x51'));

});

parcelRegister("5cu4s", function(module, exports) {

let $3c95662b351ec287$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c95662b351ec287$var$load("vIWKw").then(()=>parcelRequire('5FvHz'));

});

parcelRegister("lplb2", function(module, exports) {

let $f95c5c15577a5f65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f95c5c15577a5f65$var$load("30rzZ").then(()=>parcelRequire('kFAfQ'));

});

parcelRegister("8nYPU", function(module, exports) {

let $61afa98769f6470c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61afa98769f6470c$var$load("bAque").then(()=>parcelRequire('aeOOR'));

});

parcelRegister("50zN1", function(module, exports) {

let $3a58b6ee5047b80c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a58b6ee5047b80c$var$load("80chk").then(()=>parcelRequire('58v4x'));

});

parcelRegister("foa2l", function(module, exports) {
module.exports = JSON.parse('{"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.admin-key":[{"children":[{"type":0,"value":"Admin key"}],"type":8,"value":"b"},{"type":0,"value":": Access restricted content so you can fix issues"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.advanced-insights":[{"children":[{"type":0,"value":"Advanced insights"}],"type":8,"value":"b"},{"type":0,"value":": Audit and track all admin activity"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.support":[{"children":[{"type":0,"value":"24/7 support"}],"type":8,"value":"b"},{"type":0,"value":": Dedicated support team for critical issues"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Mission Control\' feature on the Premium plan. This will give them a dashboard to easily see activity across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Mission Control\' feature on the Confluence Premium plan. This will give them a dashboard to easily see activity across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Mission Control\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.title":[{"type":0,"value":"Help your team do more and worry less"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Mission Control\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" stay across team activity"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-features-title":[{"type":0,"value":"You also get more admin features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.description":[{"type":0,"value":"Someone on your team wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced page elements"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.title":[{"type":0,"value":"Help your team create engaging content"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced page elements"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" create engaging content"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.description":[{"type":0,"value":"Someone on your team wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced permissions features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.title":[{"type":0,"value":"Help your team manage access better"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced permissions features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" manage access better"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Company Hub\' feature on the Premium plan. This will let them create a central place for updates and key resources."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.description":[{"type":0,"value":"Someone on your team wants to try the \u2018Company Hub\u2019 feature on the Premium plan. This will let them create a central place for updates and key resources."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Company Hub\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.title":[{"type":0,"value":"Give your team one place to share updates"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Company Hub\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.title":[{"type":0,"value":"Give "},{"type":1,"value":"firstName"},{"type":0,"value":" one place to share updates"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Content manager\' feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.description":[{"type":0,"value":"Someone on your team wants to try the \u2018Content Manager\u2019 feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Content manager\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.title":[{"type":0,"value":"Help your team keep spaces organised"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Content manager\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" keep spaces organised"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.body-description":[{"children":[{"type":0,"value":"Let "},{"type":1,"value":"firstName"},{"type":0,"value":" try on a free, "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Cancel anytime. We\'ll remind you "},{"type":1,"value":"reminderDays"},{"type":0,"value":" days before your trial ends."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.description":[{"type":1,"value":"firstName"},{"type":0,"value":" has requested to try features on the Confluence Premium plan."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.body-description":[{"children":[{"type":0,"value":"Let your team member try on a free, "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Cancel anytime. We\'ll remind you "},{"type":1,"value":"reminderDays"},{"type":0,"value":" days before your trial ends."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.description":[{"type":0,"value":"Someone on your team has requested to try features on the Confluence Premium plan."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try new features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for your team"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try new features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for "},{"type":1,"value":"firstName"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.explore-all-features":[{"type":0,"value":"Explore all features \u2192"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.get-started-button":[{"type":0,"value":"Get Started"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.img.alt":[{"type":0,"value":"Confluence logo"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.learn-more":[{"type":0,"value":"Learn more"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.description":[{"type":0,"value":"Someone on your team wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced whiteboard features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.title":[{"type":0,"value":"Boost your team\'s collaboration"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced whiteboard features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.title":[{"type":0,"value":"Boost "},{"type":1,"value":"firstName"},{"type":0,"value":"\'s team collaboration"}],"growth-luna.jira-automation-limit-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"growth-luna.jira-automation-limit-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"growth-luna.jira-automation-limit-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"growth-luna.jira-automation-limit-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"growth-luna.jira-automation-limit-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"growth-luna.jira-automation-limit-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"growth-luna.jira-automation-limit-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"growth-luna.jira-recommend-retrial.banner.cta.permissions":[{"type":0,"value":"Set up permissions"}],"growth-luna.jira-recommend-retrial.banner.cta.plans":[{"type":0,"value":"Create a plan"}],"growth-luna.jira-recommend-retrial.banner.title.permissions":[{"type":0,"value":"Keep work secure"}],"growth-luna.jira-recommend-retrial.banner.title.plans":[{"type":0,"value":"See all your timelines in one plan"}],"growth-luna.jira-recommend-retrial.permissions.allow-customer-submissions":[{"type":0,"value":"Allow customers to submit bugs and requests"}],"growth-luna.jira-recommend-retrial.permissions.assign-roles":[{"type":0,"value":"Assign roles for groups, teams, or individuals"}],"growth-luna.jira-recommend-retrial.permissions.set-custom-permissions":[{"type":0,"value":"Set custom permissions for each role"}],"growth-luna.jira-recommend-retrial.placement.cancel-anytime":[{"type":0,"value":"Cancel anytime"}],"growth-luna.jira-recommend-retrial.placement.customer-agreement":[{"type":0,"value":"Atlassian Customer Agreement"}],"growth-luna.jira-recommend-retrial.placement.dismiss":[{"type":0,"value":"Dismiss"}],"growth-luna.jira-recommend-retrial.placement.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"growth-luna.jira-recommend-retrial.placement.progress-bar-label":[{"type":0,"value":"Upgrading your workspace, less than a minute remaining..."}],"growth-luna.jira-recommend-retrial.placement.suggested-feature.permissions":[{"type":0,"value":"Keep work secure and organized"}],"growth-luna.jira-recommend-retrial.placement.suggested-feature.plans":[{"type":0,"value":"See all your timelines in one plan"}],"growth-luna.jira-recommend-retrial.placement.terms":[{"type":0,"value":"By continuing, you agree to the "},{"type":1,"value":"customerAgreement"},{"type":0,"value":" and acknowledge the "},{"type":1,"value":"privacyPolicy"},{"type":0,"value":". "},{"type":1,"value":"cancelAnytime"},{"type":0,"value":"."}],"growth-luna.jira-recommend-retrial.placement.try-it-free":[{"type":0,"value":"Try it free"}],"growth-luna.jira-recommend-retrial.placement.upgrading-message":[{"type":0,"value":"Upgrading in a new tab, come back here when you\'re done..."}],"growth-luna.jira-recommend-retrial.plans.break-into-steps":[{"type":0,"value":"Break plans into achievable steps with AI"}],"growth-luna.jira-recommend-retrial.plans.customize-view":[{"type":0,"value":"Customize your view to suit you"}],"growth-luna.jira-recommend-retrial.plans.team-progress":[{"type":0,"value":"See every team\'s progress in one place"}],"growth-luna.jira-twcg-810-upgrade-free.action.primary.pde":[{"type":0,"value":"Try it free"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.body":[{"type":0,"value":"Your team has already used half your free automation runs. Try a higher limit free for "},{"type":1,"value":"trialLength"},{"type":0,"value":" days with "},{"options":{"other":{"value":[{"type":0,"value":"Standard"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.limit":[{"type":0,"value":"Increase your limit to 1,700 monthly runs"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.rovo":[{"type":0,"value":"Create new automations fast with Rovo AI"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.workflows":[{"type":0,"value":"Keep workflows moving and avoid interruptions"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.heading":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" rules running"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.body":[{"type":0,"value":"See progress across your team\'s work in one view. Try Plans free for "},{"type":1,"value":"trialLength"},{"type":0,"value":" days with "},{"options":{"other":{"value":[{"type":0,"value":"Standard"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.blockers":[{"type":0,"value":"Spot blockers early and keep things moving"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.goals":[{"type":0,"value":"Help your team hit goals together"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.timelines":[{"type":0,"value":"Create one view of all your team\'s timelines"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.heading":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" projects on track"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.body":[{"type":0,"value":"Help your team move work in progress faster. Try Rovo AI free for "},{"type":1,"value":"trialLength"},{"type":0,"value":" days with "},{"options":{"other":{"value":[{"type":0,"value":"Standard"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.connect":[{"type":0,"value":"Connect related and duplicate tasks automatically"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.next-steps":[{"type":0,"value":"Turn big work into clearer next steps"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.summaries":[{"type":0,"value":"Get instant summaries of what\'s happening"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.heading":[{"offset":0,"options":{"=0":{"value":[{"type":0,"value":"Stay across your team\'s tasks"}]},"one":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" task"}]},"other":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" tasks"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.automations.cta":[{"type":0,"value":"Get more runs"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.automations.title":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" rules running"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.plans.cta":[{"type":0,"value":"Try Plans"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.plans.title":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" projects on track"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.rovo.cta":[{"type":0,"value":"Try Rovo"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.rovo.title":[{"offset":0,"options":{"=0":{"value":[{"type":0,"value":"Stay across your team\'s tasks"}]},"one":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" task"}]},"other":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" tasks"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira-recommend-retrial.placement.body.has-payment":[{"type":0,"value":"Enjoy "},{"type":1,"value":"trialLength"},{"type":0,"value":" days to try "},{"type":1,"value":"suggestedFeature"},{"type":0,"value":" with another free trial of "},{"options":{"other":{"value":[{"type":0,"value":"Premium"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"post-office.ep-migration-inapp-715.body":[{"type":0,"value":"Get Confluence Premium to ship projects faster with advanced admin controls and analytics."}],"post-office.ep-migration-inapp-715.change-plans-button":[{"type":0,"value":"Change plans"}],"post-office.ep-migration-inapp-715.image-alt":[{"type":0,"value":"Confluence Premium illustration"}],"post-office.ep-migration-inapp-715.not-now-button":[{"type":0,"value":"Not now"}],"post-office.ep-migration-inapp-715.title":[{"type":0,"value":"Grow more agile"}],"post-office.jira-exp-banner.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.jira-standard-automation-limit-awareness-banner.close":[{"type":0,"value":"Close"}],"post-office.jira-standard-automation-limit-awareness-banner.message":[{"type":0,"value":"You\'re nearing or at your monthly automation run limit. Automations will fail to run this month if you hit the limit."}]}');

});

parcelRegister("qRlBF", function(module, exports) {

let $050bcf8615a03d8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $050bcf8615a03d8d$var$load("bDI57").then(()=>parcelRequire('hvHzV'));

});

parcelRegister("eICgf", function(module, exports) {

let $ab72da9f4cacc5e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab72da9f4cacc5e9$var$load("33fwI").then(()=>parcelRequire('iNCoH'));

});

parcelRegister("fSFtG", function(module, exports) {

let $b8fc12c27549df5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8fc12c27549df5b$var$load("7koLR").then(()=>parcelRequire('k6684'));

});

parcelRegister("9B4Ca", function(module, exports) {

let $6fcb261c95c238d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6fcb261c95c238d0$var$load("a4Pfb").then(()=>parcelRequire('gzPdT'));

});

parcelRegister("5aMRH", function(module, exports) {

let $3c43ca822e21aae4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c43ca822e21aae4$var$load("hJH9b").then(()=>parcelRequire('rnaQY'));

});

parcelRegister("5fuln", function(module, exports) {

let $3d25e41dfa9bfacb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d25e41dfa9bfacb$var$load("jVZVT").then(()=>parcelRequire('5bdUZ'));

});

parcelRegister("1mHIH", function(module, exports) {

let $0fe9c26459157035$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0fe9c26459157035$var$load("kEWnj").then(()=>parcelRequire('j8q0P'));

});

parcelRegister("1uSoo", function(module, exports) {

let $1172c8fe9b5be5ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1172c8fe9b5be5ae$var$load("hgVRH").then(()=>parcelRequire('cJ3vp'));

});

parcelRegister("jtzSo", function(module, exports) {

let $e2dc8e0684144dea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e2dc8e0684144dea$var$load("8zrOK").then(()=>parcelRequire('lp9iY'));

});

parcelRegister("53ueL", function(module, exports) {

let $3ae4b00061715ff0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ae4b00061715ff0$var$load("eqQsS").then(()=>parcelRequire('cpLQS'));

});

parcelRegister("fKytd", function(module, exports) {

let $b775e3fc6cb42c45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b775e3fc6cb42c45$var$load("a1BZ9").then(()=>parcelRequire('fS4PD'));

});

parcelRegister("63vCc", function(module, exports) {

let $468b8c00f27ffea8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $468b8c00f27ffea8$var$load("fgAR7").then(()=>parcelRequire('eU4jz'));

});

parcelRegister("4MvCs", function(module, exports) {

let $37b42c06c49209fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $37b42c06c49209fd$var$load("75NrO").then(()=>parcelRequire('7aebp'));

});

parcelRegister("aoP1S", function(module, exports) {

let $7923ba9a1715daba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7923ba9a1715daba$var$load("bSW0m").then(()=>parcelRequire('lRjGz'));

});

parcelRegister("3sAgr", function(module, exports) {

let $28501decdac73bb8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28501decdac73bb8$var$load("Mruw4").then(()=>parcelRequire('6kjbV'));

});

parcelRegister("1n5YT", function(module, exports) {

let $0ffc9422ee270c85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ffc9422ee270c85$var$load("cOHcg").then(()=>parcelRequire('d0NM0'));

});

parcelRegister("h9xHo", function(module, exports) {

let $c7cd6ad929cf67be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7cd6ad929cf67be$var$load("gO2Ws").then(()=>parcelRequire('9ncGU'));

});

parcelRegister("8KAdZ", function(module, exports) {

let $65eeb8106a90bc1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65eeb8106a90bc1d$var$load("8mkTm").then(()=>parcelRequire('2slRW'));

});

parcelRegister("bgeKH", function(module, exports) {

let $832ca1d56170968b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $832ca1d56170968b$var$load("7LzOz").then(()=>parcelRequire('jDQ4X'));

});

parcelRegister("4B2Nz", function(module, exports) {

let $358cc9deb456e8fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $358cc9deb456e8fd$var$load("jAS45").then(()=>parcelRequire('97Kac'));

});

parcelRegister("tRe5z", function(module, exports) {

let $059bff2b95947be8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $059bff2b95947be8$var$load("6k2Y0").then(()=>parcelRequire('87h4V'));

});

parcelRegister("bK3WI", function(module, exports) {

let $88c70d34ff0195ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88c70d34ff0195ca$var$load("6ZsM2").then(()=>parcelRequire('boO6G'));

});

parcelRegister("7irz8", function(module, exports) {

let $54ff98ce2ecc50a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54ff98ce2ecc50a5$var$load("h0zBk").then(()=>parcelRequire('apd3M'));

});

parcelRegister("cJiFs", function(module, exports) {

let $94482b0754eb1c8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94482b0754eb1c8f$var$load("22k4A").then(()=>parcelRequire('lO2PB'));

});

parcelRegister("j6HYL", function(module, exports) {

let $de90b12915f03a89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de90b12915f03a89$var$load("4jXQD").then(()=>parcelRequire('8QRyJ'));

});

parcelRegister("5zjR4", function(module, exports) {

let $40df9f6a260249ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40df9f6a260249ac$var$load("k71Fj").then(()=>parcelRequire('729bR'));

});

parcelRegister("jjCqb", function(module, exports) {

let $e0fd9854c53ba46e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0fd9854c53ba46e$var$load("ilXRX").then(()=>parcelRequire('8YOns'));

});

parcelRegister("3KZyc", function(module, exports) {

let $2bc569a7d2ae7c49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bc569a7d2ae7c49$var$load("6CMIH").then(()=>parcelRequire('9UaMe'));

});

parcelRegister("crTHB", function(module, exports) {

let $910336f8b7345070$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $910336f8b7345070$var$load("7rvD3").then(()=>parcelRequire('91UgQ'));

});

parcelRegister("1Ka3U", function(module, exports) {

let $1451e4740bc08f36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1451e4740bc08f36$var$load("dGDjs").then(()=>parcelRequire('gun65'));

});

parcelRegister("7E4Qy", function(module, exports) {

let $5910074bf2f67b13$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5910074bf2f67b13$var$load("2qYp0").then(()=>parcelRequire('dqAEN'));

});

parcelRegister("hYUvO", function(module, exports) {

let $d173e0662f3b45d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d173e0662f3b45d0$var$load("b9sUh").then(()=>parcelRequire('7OlYu'));

});

parcelRegister("ghsss", function(module, exports) {

let $bda44f0ecb823f92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bda44f0ecb823f92$var$load("23UL7").then(()=>parcelRequire('60PaG'));

});

parcelRegister("93OYL", function(module, exports) {

let $698bf03d9b9c6a8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $698bf03d9b9c6a8b$var$load("aMybP").then(()=>parcelRequire('8c0qm'));

});

parcelRegister("1Vfmh", function(module, exports) {
module.exports = JSON.parse("{\"post-office.aurum.jira-assets-schemas-display-name.body\":[{\"type\":0,\"value\":\"Clarify and localise entities without breaking AQL or integrations.\"}],\"post-office.aurum.jira-assets-schemas-display-name.headline\":[{\"type\":0,\"value\":\"Display names are here\"}],\"post-office.aurum.jira-assets-schemas-display-name.primary-action\":[{\"type\":0,\"value\":\"Learn more\"}]}");

});

parcelRegister("hClXY", function(module, exports) {

let $cd370659aa179eb8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd370659aa179eb8$var$load("6N2hg").then(()=>parcelRequire('kYbPk'));

});

parcelRegister("hRm4F", function(module, exports) {

let $d008826b367fdf82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d008826b367fdf82$var$load("heueK").then(()=>parcelRequire('5G7Fn'));

});

parcelRegister("faXH8", function(module, exports) {

let $b0c61851cb75ad10$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b0c61851cb75ad10$var$load("dkWse").then(()=>parcelRequire('jlwja'));

});

parcelRegister("hJ6r1", function(module, exports) {

let $ce7ba173dde334eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce7ba173dde334eb$var$load("kC1xg").then(()=>parcelRequire('520nu'));

});

parcelRegister("g5neE", function(module, exports) {

let $bb5f2306bcd40a8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb5f2306bcd40a8b$var$load("HYkx2").then(()=>parcelRequire('4Rq4f'));

});

parcelRegister("lpioP", function(module, exports) {

let $f95a348b3de6b753$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f95a348b3de6b753$var$load("1qR7k").then(()=>parcelRequire('am69E'));

});

parcelRegister("hkqrg", function(module, exports) {

let $c9d8d02198a4753b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9d8d02198a4753b$var$load("svxod").then(()=>parcelRequire('63wYH'));

});

parcelRegister("179Md", function(module, exports) {

let $0cfe075214c91dbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cfe075214c91dbf$var$load("818wW").then(()=>parcelRequire('c8pet'));

});

parcelRegister("cKQDj", function(module, exports) {

let $94929bbce738b4ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94929bbce738b4ed$var$load("34XXI").then(()=>parcelRequire('lulV5'));

});

parcelRegister("5ihX5", function(module, exports) {

let $3dac8f149bcf26e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3dac8f149bcf26e4$var$load("aA0u0").then(()=>parcelRequire('irT9M'));

});

parcelRegister("5abYe", function(module, exports) {

let $3c272c001a903db5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c272c001a903db5$var$load("blJaU").then(()=>parcelRequire('4d1jZ'));

});

parcelRegister("3fVB6", function(module, exports) {

let $25ef73743f91f930$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $25ef73743f91f930$var$load("9AFPC").then(()=>parcelRequire('dGOuU'));

});

parcelRegister("cuF7f", function(module, exports) {

let $91882e1dece043aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91882e1dece043aa$var$load("8GupR").then(()=>parcelRequire('f4Y61'));

});

parcelRegister("jzbcB", function(module, exports) {

let $e3e9f9bfb8f50765$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3e9f9bfb8f50765$var$load("eJLYG").then(()=>parcelRequire('b5uTC'));

});

parcelRegister("jUV4j", function(module, exports) {

let $e7ff83ec908d2552$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7ff83ec908d2552$var$load("kYOls").then(()=>parcelRequire('bWkL7'));

});

parcelRegister("dC4lh", function(module, exports) {

let $9e92313a2587196d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e92313a2587196d$var$load("hVXBK").then(()=>parcelRequire('iFZls'));

});

parcelRegister("dReF7", function(module, exports) {

let $a16b992fca3da0bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a16b992fca3da0bb$var$load("j6Sl2").then(()=>parcelRequire('h3ATr'));

});

parcelRegister("le3nC", function(module, exports) {

let $f73d86f36d18dc34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f73d86f36d18dc34$var$load("jbo0o").then(()=>parcelRequire('i1pAw'));

});

parcelRegister("dyjca", function(module, exports) {

let $9ddd571b126be18c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ddd571b126be18c$var$load("kON6o").then(()=>parcelRequire('jq34p'));

});

parcelRegister("kxSoh", function(module, exports) {

let $ef5114901101133d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ef5114901101133d$var$load("eVkhL").then(()=>parcelRequire('fm9js'));

});

parcelRegister("5PZVa", function(module, exports) {

let $4401bf6d06bf0d4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4401bf6d06bf0d4d$var$load("1tBxH").then(()=>parcelRequire('5Bv3z'));

});

parcelRegister("9jewc", function(module, exports) {

let $6c71267345b47655$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c71267345b47655$var$load("bl5fq").then(()=>parcelRequire('eoPTU'));

});

parcelRegister("4JIEf", function(module, exports) {

let $372dff969d245b5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $372dff969d245b5c$var$load("aZ7ZS").then(()=>parcelRequire('aUZ01'));

});

parcelRegister("lBugK", function(module, exports) {

let $fba4887e710e9daa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fba4887e710e9daa$var$load("d3k5c").then(()=>parcelRequire('6Tq9v'));

});

parcelRegister("elWfu", function(module, exports) {

let $a73035dc440b8330$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a73035dc440b8330$var$load("h9xm5").then(()=>parcelRequire('fa3h4'));

});

parcelRegister("dqXgH", function(module, exports) {

let $9c7bad8d4491c5b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c7bad8d4491c5b2$var$load("11TRy").then(()=>parcelRequire('ls5Kt'));

});

parcelRegister("bUpxm", function(module, exports) {

let $8ab8bbcf953e6193$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ab8bbcf953e6193$var$load("6m91y").then(()=>parcelRequire('gYwcA'));

});

parcelRegister("ay5EV", function(module, exports) {

let $7ae178210910afd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ae178210910afd9$var$load("8duKA").then(()=>parcelRequire('ciCR3'));

});

parcelRegister("gbFWz", function(module, exports) {

let $bc8e358cedff7a5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bc8e358cedff7a5e$var$load("5458j").then(()=>parcelRequire('3mjzi'));

});

parcelRegister("eBJcN", function(module, exports) {

let $aa2796378c0784ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa2796378c0784ec$var$load("60H4I").then(()=>parcelRequire('5VS4D'));

});

parcelRegister("jxHHN", function(module, exports) {

let $e3a300595693b44e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3a300595693b44e$var$load("cu7A4").then(()=>parcelRequire('f8nDZ'));

});

parcelRegister("aEvb3", function(module, exports) {

let $7c15d2f831eb604f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c15d2f831eb604f$var$load("btIKk").then(()=>parcelRequire('9OLo8'));

});

parcelRegister("aMU9j", function(module, exports) {

let $7da9f1280388760f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7da9f1280388760f$var$load("6Ihdr").then(()=>parcelRequire('389G1'));

});

parcelRegister("1dSty", function(module, exports) {

let $0e4143105d02fca6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e4143105d02fca6$var$load("k1mbv").then(()=>parcelRequire('4NlN6'));

});

parcelRegister("5U1zM", function(module, exports) {
module.exports = JSON.parse("{\"jira-board-inline-editing-onboarding.message-templates.ok-button\":[{\"type\":0,\"value\":\"OK\"}],\"jira-board-inline-editing-onboarding.message-templates.spotlight-body\":[{\"type\":0,\"value\":\"You can now edit fields like the summary, assignee, parent and estimate. Select the fields to edit them.\"}],\"jira-board-inline-editing-onboarding.message-templates.spotlight-header\":[{\"type\":0,\"value\":\"Edit details of the work item directly in the board\"}]}");

});

parcelRegister("kCxZ5", function(module, exports) {

let $f031b7d3c404d102$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f031b7d3c404d102$var$load("hLQnq").then(()=>parcelRequire('dHAUx'));

});

parcelRegister("alWoE", function(module, exports) {

let $789929e71d5d2b4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $789929e71d5d2b4a$var$load("bfeTU").then(()=>parcelRequire('dyPRF'));

});

parcelRegister("2k0yx", function(module, exports) {

let $1b0de17754e5ac3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b0de17754e5ac3c$var$load("j5WDM").then(()=>parcelRequire('2wY3J'));

});

parcelRegister("iFxq4", function(module, exports) {

let $d975fac433438bd1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d975fac433438bd1$var$load("aqPSc").then(()=>parcelRequire('5KA11'));

});

parcelRegister("3Xjc2", function(module, exports) {

let $2e15c522b2aa714b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2e15c522b2aa714b$var$load("3fp4P").then(()=>parcelRequire('emAAV'));

});

parcelRegister("51O5A", function(module, exports) {

let $3a93e666a4241d84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a93e666a4241d84$var$load("himgz").then(()=>parcelRequire('6glWt'));

});

parcelRegister("dnjzB", function(module, exports) {

let $9bcc9b300b42e015$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9bcc9b300b42e015$var$load("geKrL").then(()=>parcelRequire('erYks'));

});

parcelRegister("ahSoT", function(module, exports) {

let $77d5b0b72510c876$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77d5b0b72510c876$var$load("lO9sq").then(()=>parcelRequire('hckSd'));

});

parcelRegister("cJXik", function(module, exports) {

let $9467aeafd1ba55e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9467aeafd1ba55e4$var$load("9AR7a").then(()=>parcelRequire('5uJ2G'));

});

parcelRegister("3f0Fr", function(module, exports) {

let $25c34a52bb42cbd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $25c34a52bb42cbd9$var$load("qq3t5").then(()=>parcelRequire('fh3pW'));

});

parcelRegister("iWQO6", function(module, exports) {

let $dcb69b2b850efa93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dcb69b2b850efa93$var$load("b6ipk").then(()=>parcelRequire('ent0H'));

});

parcelRegister("c6nXU", function(module, exports) {

let $8cf8a295bc6d1166$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cf8a295bc6d1166$var$load("aXBcV").then(()=>parcelRequire('kWwKq'));

});

parcelRegister("7M0f6", function(module, exports) {

let $5a8d344a04c3a384$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a8d344a04c3a384$var$load("7lkW2").then(()=>parcelRequire('dhhKL'));

});

parcelRegister("15WTx", function(module, exports) {

let $0cc3f15d30a33c53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cc3f15d30a33c53$var$load("fsTi2").then(()=>parcelRequire('bMgPR'));

});

parcelRegister("lAzjh", function(module, exports) {

let $fb785991d6fe2f8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb785991d6fe2f8d$var$load("jTqsp").then(()=>parcelRequire('lhJ8i'));

});

parcelRegister("beV3E", function(module, exports) {

let $82ed430c171f0a06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82ed430c171f0a06$var$load("jZRfO").then(()=>parcelRequire('eerah'));

});

parcelRegister("8Kz2Z", function(module, exports) {

let $65edce416b792a5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65edce416b792a5d$var$load("5fOvo").then(()=>parcelRequire('cCvPR'));

});

parcelRegister("aFbGF", function(module, exports) {

let $7c36cc8d34c45179$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c36cc8d34c45179$var$load("jw6Fw").then(()=>parcelRequire('6BnaY'));

});

parcelRegister("a24Sy", function(module, exports) {

let $74dde01ea109e0b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74dde01ea109e0b2$var$load("hWm6t").then(()=>parcelRequire('6B1xj'));

});

parcelRegister("6tcP1", function(module, exports) {

let $4b5f65aaa89b05d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4b5f65aaa89b05d9$var$load("ccP4M").then(()=>parcelRequire('2SgQR'));

});

parcelRegister("7kDLD", function(module, exports) {

let $55693f9c65f39d06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55693f9c65f39d06$var$load("d8SO1").then(()=>parcelRequire('awnz4'));

});

parcelRegister("9JcU7", function(module, exports) {

let $715253835f51dcd5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $715253835f51dcd5$var$load("eL5Xf").then(()=>parcelRequire('hD5rJ'));

});

parcelRegister("1eIXL", function(module, exports) {

let $0e69f9f9875dc783$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e69f9f9875dc783$var$load("GcGD5").then(()=>parcelRequire('i692O'));

});

parcelRegister("ik5VI", function(module, exports) {

let $d56eb1d2e65d0188$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d56eb1d2e65d0188$var$load("1Tmeq").then(()=>parcelRequire('c9IZL'));

});

parcelRegister("1wmX4", function(module, exports) {

let $11ba955453896f1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11ba955453896f1f$var$load("aDUXT").then(()=>parcelRequire('5YVNj'));

});

parcelRegister("gJj4D", function(module, exports) {

let $c2dfa4f0bb3b13de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2dfa4f0bb3b13de$var$load("32RHR").then(()=>parcelRequire('bXJLo'));

});

parcelRegister("kGFwa", function(module, exports) {

let $f0f7ef7c0e47b464$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0f7ef7c0e47b464$var$load("fLRnq").then(()=>parcelRequire('1NLDX'));

});

parcelRegister("6XJTT", function(module, exports) {

let $511bdb9f7bc5dbdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $511bdb9f7bc5dbdd$var$load("6w1yT").then(()=>parcelRequire('3nNhz'));

});

parcelRegister("cDsqP", function(module, exports) {

let $932f2e7a3b909c04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $932f2e7a3b909c04$var$load("4UKLt").then(()=>parcelRequire('5Lgid'));

});

parcelRegister("1sfji", function(module, exports) {

let $10f448495e6b0db7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $10f448495e6b0db7$var$load("4ryKW").then(()=>parcelRequire('4o595'));

});

parcelRegister("hwmk8", function(module, exports) {

let $cc16bdde0ed03975$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc16bdde0ed03975$var$load("bQxQQ").then(()=>parcelRequire('avO0W'));

});

parcelRegister("8aXh4", function(module, exports) {

let $5f3d3c924666bf8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f3d3c924666bf8a$var$load("lQN2i").then(()=>parcelRequire('juvgQ'));

});

parcelRegister("gAZxn", function(module, exports) {

let $c14fbe282a1fa120$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c14fbe282a1fa120$var$load("8x856").then(()=>parcelRequire('Jxc1c'));

});

parcelRegister("2LLiX", function(module, exports) {

let $2044aa470f0e84f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2044aa470f0e84f3$var$load("hOgqE").then(()=>parcelRequire('gnTSm'));

});

parcelRegister("57xWx", function(module, exports) {
module.exports = JSON.parse('{"jira-business-saved-views.admin.changeboarding.spotlight.body":[{"type":0,"value":"Saved views are now in timeline view.\\n\\nSave your view for everyone in the project or reset it back to your previous saved view."}],"jira-business-saved-views.admin.changeboarding.spotlight.headline":[{"type":0,"value":"Save and reset your timeline view"}],"jira-business-saved-views.admin.changeboarding.spotlight.primary-action":[{"type":0,"value":"OK"}],"jira-business-saved-views.admin.changeboarding.spotlight.secondary-action":[{"type":0,"value":"More about saved views"}],"jira-business-saved-views.changeboarding.spotlight.body":[{"type":0,"value":"Saved views are now in timeline view. Your admin set up a view to help make collaboration easier.\\n\\nYou can make changes to your view or reset to the admin\'s view anytime."}],"jira-business-saved-views.changeboarding.spotlight.headline":[{"type":0,"value":"Reset your view"}],"jira-business-saved-views.changeboarding.spotlight.primary-action":[{"type":0,"value":"OK"}],"jira-business-saved-views.changeboarding.spotlight.secondary-action":[{"type":0,"value":"More about saved views"}],"jira-software-timeline-m3.descriptionContentBulkOperations":[{"type":0,"value":"Edit, move, transition, watch or delete multiple work items simultaneously."}],"jira-software-timeline-m3.descriptionContentCustomizeBar":[{"type":0,"value":"Make specific work items easier to scan or highlight as a priority."}],"jira-software-timeline-m3.descriptionContentFindWork":[{"type":0,"value":"Search, filter and group work items."}],"jira-software-timeline-m3.descriptionContentSeeSubtasks":[{"type":0,"value":"They now appear under epics."}],"jira-software-timeline-m3.headingContentBulkOperations":[{"type":0,"value":"Reduce repetitive work"}],"jira-software-timeline-m3.headingContentCustomizeBar":[{"type":0,"value":"Customize bars using colors"}],"jira-software-timeline-m3.headingContentFindWork":[{"type":0,"value":"Quickly find work items"}],"jira-software-timeline-m3.headingContentSeeSubtasks":[{"type":0,"value":"See subtasks at a glance"}],"jira-software-timeline-m3.modal.closeButton":[{"type":0,"value":"Close"}],"jira-software-timeline-m3.modal.doneButton":[{"type":0,"value":"Done"}],"jira-software-timeline-m3.modal.nextButton":[{"type":0,"value":"Next"}],"jira-software-timeline-m3.timelineImprovmentsLink":[{"type":0,"value":"Read about Timeline improvements."}],"post-office.software-timeline-example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.software-timeline-testing.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.software-timeline-testing.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.software-timeline-testing.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"timeline-10k-issues-flag.actions":[{"type":0,"value":"Learn more about the 10k limit"}],"timeline-10k-issues-flag.description":[{"type":0,"value":"Parent rollup bars in timeline have been disabled to give you a smoother performance and experience."}],"timeline-10k-issues-flag.title":[{"type":0,"value":"This space has more than 10k work items."}],"timeline-feedback-collector.spotlight.body":[{"type":0,"value":"In doing this we are keen to hear feedback from users about the timeline, what else you may want, and importantly, what you don\u2019t want."}],"timeline-feedback-collector.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"timeline-feedback-collector.spotlight.give-feedback":[{"type":0,"value":"Give feedback"}],"timeline-feedback-collector.spotlight.heading":[{"type":0,"value":"We\u2019re updating Jira timelines"}]}');

});

parcelRegister("gAEGB", function(module, exports) {

let $c13f9191f818bc78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c13f9191f818bc78$var$load("20Ni3").then(()=>parcelRequire('buXT4'));

});

parcelRegister("dMJF5", function(module, exports) {

let $a0932d89b84b54d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0932d89b84b54d7$var$load("dlCxV").then(()=>parcelRequire('lJRLk'));

});

parcelRegister("6pKIv", function(module, exports) {

let $4ab950da08866ff4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ab950da08866ff4$var$load("9XJxM").then(()=>parcelRequire('kQbbV'));

});

parcelRegister("jqwrY", function(module, exports) {

let $e2499def421773d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e2499def421773d5$var$load("4BhtJ").then(()=>parcelRequire('36kNt'));

});

parcelRegister("3W8CE", function(module, exports) {

let $2ddd7a1762381e04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ddd7a1762381e04$var$load("g6ZYs").then(()=>parcelRequire('76r0N'));

});

parcelRegister("h214p", function(module, exports) {

let $c66374109b055a38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c66374109b055a38$var$load("fjhyt").then(()=>parcelRequire('lPj6I'));

});

parcelRegister("kLlQM", function(module, exports) {

let $f1d925787820e3a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f1d925787820e3a2$var$load("ku4in").then(()=>parcelRequire('dd3Zm'));

});

parcelRegister("iCeA1", function(module, exports) {

let $d8d715e26ccf3de7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d8d715e26ccf3de7$var$load("fbCyW").then(()=>parcelRequire('1DwoI'));

});

parcelRegister("5rCoM", function(module, exports) {

let $3f6d428ecf8ab1ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f6d428ecf8ab1ed$var$load("hgIdF").then(()=>parcelRequire('d6Jww'));

});

parcelRegister("aw1rm", function(module, exports) {

let $7a7e028e9cd6cfb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a7e028e9cd6cfb9$var$load("iDpf4").then(()=>parcelRequire('jw9xM'));

});

parcelRegister("8ITYw", function(module, exports) {

let $659dda4ba48e2c83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $659dda4ba48e2c83$var$load("dZkdz").then(()=>parcelRequire('S4YmJ'));

});

parcelRegister("c0Gtc", function(module, exports) {

let $8be66dc03421917b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8be66dc03421917b$var$load("jK7IB").then(()=>parcelRequire('75ppW'));

});

parcelRegister("leZEY", function(module, exports) {

let $f76abc255da813f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f76abc255da813f7$var$load("5knon").then(()=>parcelRequire('fxWOL'));

});

parcelRegister("7tJBP", function(module, exports) {

let $571e9ee1faa82189$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $571e9ee1faa82189$var$load("7DvZK").then(()=>parcelRequire('lG56O'));

});

parcelRegister("5yLqW", function(module, exports) {

let $40c4ec0da2988eab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40c4ec0da2988eab$var$load("1bjPC").then(()=>parcelRequire('b6pCU'));

});

parcelRegister("6yV4D", function(module, exports) {

let $4c7230bb068e1aa3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c7230bb068e1aa3$var$load("1cB2I").then(()=>parcelRequire('hsQNE'));

});

parcelRegister("ezNqT", function(module, exports) {

let $a9caade4c4d08682$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9caade4c4d08682$var$load("i2nFm").then(()=>parcelRequire('cU1zD'));

});

parcelRegister("8tM0n", function(module, exports) {

let $62c644f5f5fe4f54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $62c644f5f5fe4f54$var$load("4SJX4").then(()=>parcelRequire('i784l'));

});

parcelRegister("hr9h0", function(module, exports) {

let $cb1c26be017b4703$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb1c26be017b4703$var$load("19Dzb").then(()=>parcelRequire('i57eq'));

});

parcelRegister("lTIc2", function(module, exports) {

let $ff1103dba2bffb14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff1103dba2bffb14$var$load("jd0MW").then(()=>parcelRequire('hy1lX'));

});

parcelRegister("ghpeV", function(module, exports) {

let $bda1cff801acf7cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bda1cff801acf7cf$var$load("eXELD").then(()=>parcelRequire('1sXoi'));

});

parcelRegister("cZ8Qj", function(module, exports) {

let $97420a81774fb395$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97420a81774fb395$var$load("jY5sI").then(()=>parcelRequire('215xL'));

});

parcelRegister("kEyaV", function(module, exports) {

let $f0920d89daf8356b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0920d89daf8356b$var$load("jT9wv").then(()=>parcelRequire('aj53f'));

});

parcelRegister("8InNC", function(module, exports) {

let $6584e4da87702524$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6584e4da87702524$var$load("jQdF8").then(()=>parcelRequire('btQ2m'));

});

parcelRegister("hfnTn", function(module, exports) {

let $c8e65edf2b34db63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8e65edf2b34db63$var$load("dmBXV").then(()=>parcelRequire('gNW5W'));

});

parcelRegister("67PcB", function(module, exports) {

let $475b1d33b43312a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $475b1d33b43312a0$var$load("7wWfx").then(()=>parcelRequire('iWmRT'));

});

parcelRegister("22vVN", function(module, exports) {

let $17c4898821ea5200$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17c4898821ea5200$var$load("d82zB").then(()=>parcelRequire('cSyHG'));

});

parcelRegister("aA24d", function(module, exports) {

let $7b3ede9e2c34ae3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b3ede9e2c34ae3c$var$load("boM6T").then(()=>parcelRequire('1oEhO'));

});

parcelRegister("fFh2C", function(module, exports) {

let $b677e76045e28235$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b677e76045e28235$var$load("hGyPr").then(()=>parcelRequire('938pC'));

});

parcelRegister("8x8Qx", function(module, exports) {

let $636844879e8cdf42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $636844879e8cdf42$var$load("7B7s8").then(()=>parcelRequire('dxRY0'));

});

parcelRegister("kOrUi", function(module, exports) {

let $f26e1fee821e50bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f26e1fee821e50bf$var$load("dVnnv").then(()=>parcelRequire('3t9pO'));

});

parcelRegister("c5TSF", function(module, exports) {

let $8ce14c65afdc6811$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ce14c65afdc6811$var$load("4QMLW").then(()=>parcelRequire('1e9Mm'));

});

parcelRegister("dlwhB", function(module, exports) {

let $9b76473bc67ece99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b76473bc67ece99$var$load("bTeYa").then(()=>parcelRequire('hHceS'));

});

parcelRegister("bzFAS", function(module, exports) {

let $86d33a4444a6a134$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86d33a4444a6a134$var$load("jZ99Z").then(()=>parcelRequire('baqzM'));

});

parcelRegister("4DVgS", function(module, exports) {
module.exports = JSON.parse('{"export-issues-flyout-spotlight-tour.spotlight.body":[{"type":0,"value":"Export your work items in the format you need, right from the more actions menu."}],"export-issues-flyout-spotlight-tour.spotlight.heading":[{"type":0,"value":"Export options have moved"}],"export-issues-flyout-spotlight-tour.spotlight.okButton":[{"type":0,"value":"OK"}],"jira-filter-refinement-board-and-backlog.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement-board-and-backlog.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement-board-and-backlog.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement-board-and-backlog.tour.step1Body":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement-board-and-backlog.tour.step1Headline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement-board-and-backlog.tour.step2Body":[{"type":0,"value":"Reorder and pin fields to\xa0prioritize\xa0what matters\xa0most to you."}],"jira-filter-refinement-board-and-backlog.tour.step2Headline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement-board-and-backlog.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-filter-refinement.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement.tour.step1Body":[{"type":0,"value":"Save any filter combination to reuse later."}],"jira-filter-refinement.tour.step1Headline":[{"type":0,"value":"Save your filter"}],"jira-filter-refinement.tour.step2Body":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement.tour.step2Headline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement.tour.step3Body":[{"type":0,"value":"Reorder and pin fields to\xa0prioritize\xa0what matters\xa0most to you."}],"jira-filter-refinement.tour.step3Headline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-nin-issue-preview-panel.body":[{"type":0,"value":"View and edit work items in the new preview panel, while staying on the List."}],"jira-nin-issue-preview-panel.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-issue-preview-panel.heading":[{"type":0,"value":"Access work items instantly"}],"jira-nin-issue-preview-panel.more":[{"type":0,"value":"More about preview panels"}],"jira-nin-issue-preview-panel.new-window":[{"type":0,"value":"(opens in a new window)"}],"jira-nin-list-merge-modal-onboarding-v2.closeButton":[{"type":0,"value":"Close"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsDescription":[{"type":0,"value":"Want us to apply your current filter and group settings to this new List view?"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsNo":[{"type":0,"value":"No"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsYes":[{"type":0,"value":"Yes"}],"jira-nin-list-merge-modal-onboarding-v2.description":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience. A new List view."}],"jira-nin-list-merge-modal-onboarding-v2.filtersAndGroupsDescription":[{"type":0,"value":"Any existing filters and groups will be applied."}],"jira-nin-list-merge-modal-onboarding-v2.heading":[{"type":0,"value":"We\'ve merged List and All Work"}],"jira-nin-list-merge-modal-onboarding-v2.learnMoreLink":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.body":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience. A new List view."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.explore-list-view-button-label":[{"type":0,"value":"Explore List view"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.filter":[{"type":0,"value":"One place to search work and filter results to find what you need."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.heading":[{"type":0,"value":"We\'ve merged List and All Work views"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.more-actions":[{"type":0,"value":"Dive deeper - view work items as a chart, use format rules to highlight key work, and more."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.next":[{"type":0,"value":"Next"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.ok":[{"type":0,"value":"OK"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.tell-me-more-aria-label":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.body":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience."}],"jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.heading":[{"type":0,"value":"We\'ve merged List and All Work views"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more":[{"type":0,"value":"Tell me more"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira.filter.refinement.filter-popup.changeboarding.description.filter":[{"type":0,"value":"You can now filter work items by status and priority, making it easier to find work."}],"jira.filter.refinement.filter-popup.changeboarding.description.improvements":[{"type":0,"value":"More improvements to come."}],"jira.filter.refinement.filter-popup.changeboarding.description.parent":[{"type":0,"value":"Use the parent filter to search for epics, as well as any other work items with child work items."}],"jira.filter.refinement.filter-popup.changeboarding.dismiss":[{"type":0,"value":"Dismiss"}],"jira.filter.refinement.filter-popup.changeboarding.next":[{"type":0,"value":"Next"}],"jira.filter.refinement.filter-popup.changeboarding.ok":[{"type":0,"value":"OK"}],"jira.filter.refinement.filter-popup.changeboarding.page2.title":[{"type":0,"value":"We\'ve updated epic to parent"}],"jira.filter.refinement.filter-popup.changeboarding.title":[{"type":0,"value":"Introducing a new home for filters"}]}');

});

parcelRegister("18J8c", function(module, exports) {

let $0d498be71abcd75d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d498be71abcd75d$var$load("35F0C").then(()=>parcelRequire('ewgiR'));

});

parcelRegister("ktFNM", function(module, exports) {

let $ee86f110962116fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee86f110962116fd$var$load("iHDy5").then(()=>parcelRequire('awz8h'));

});

parcelRegister("9TP7r", function(module, exports) {

let $7350e74d20078dbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7350e74d20078dbe$var$load("kx0jD").then(()=>parcelRequire('jUtMb'));

});

parcelRegister("2MOnI", function(module, exports) {

let $2077252fcbbf616f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2077252fcbbf616f$var$load("kZX9q").then(()=>parcelRequire('lNykc'));

});

parcelRegister("62ALx", function(module, exports) {

let $465f72ea6729a96b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $465f72ea6729a96b$var$load("kDRm3").then(()=>parcelRequire('4NZbM'));

});

parcelRegister("3TOwu", function(module, exports) {

let $2d6db2f47619e748$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d6db2f47619e748$var$load("g3vHE").then(()=>parcelRequire('iJIlA'));

});

parcelRegister("bMiNH", function(module, exports) {

let $8932c2d6739058ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8932c2d6739058ca$var$load("cPktR").then(()=>parcelRequire('7TMin'));

});

parcelRegister("jNFAH", function(module, exports) {

let $e6a2db06571cd953$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6a2db06571cd953$var$load("9vLJ1").then(()=>parcelRequire('Az0YW'));

});

parcelRegister("ljkw3", function(module, exports) {

let $f83b49629781b8b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f83b49629781b8b2$var$load("04gFb").then(()=>parcelRequire('3EntX'));

});

parcelRegister("i0P5c", function(module, exports) {

let $d1cfda12b3be160e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1cfda12b3be160e$var$load("bpf5v").then(()=>parcelRequire('iTSS8'));

});

parcelRegister("6ODIz", function(module, exports) {

let $4f6638b7eee47896$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f6638b7eee47896$var$load("5jqkn").then(()=>parcelRequire('4fSTs'));

});

parcelRegister("kGimx", function(module, exports) {

let $f0e5f94fb3631657$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0e5f94fb3631657$var$load("aAQC5").then(()=>parcelRequire('dgmaH'));

});

parcelRegister("lHPqi", function(module, exports) {

let $fcd580b5a7f54c77$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fcd580b5a7f54c77$var$load("4KEVk").then(()=>parcelRequire('fXDSt'));

});

parcelRegister("iXipl", function(module, exports) {

let $dccc04175e1d2015$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dccc04175e1d2015$var$load("lNdmL").then(()=>parcelRequire('9ziRU'));

});

parcelRegister("33CvA", function(module, exports) {

let $239f85e7cc45d9f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $239f85e7cc45d9f6$var$load("e5tvx").then(()=>parcelRequire('4w4mn'));

});

parcelRegister("3PU8V", function(module, exports) {

let $2cb1af5bd40bf39b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2cb1af5bd40bf39b$var$load("ddYPk").then(()=>parcelRequire('Ghqa4'));

});

parcelRegister("6xWQm", function(module, exports) {

let $4c43784114040d0c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c43784114040d0c$var$load("5Pmwl").then(()=>parcelRequire('6eoXh'));

});

parcelRegister("2YfsB", function(module, exports) {

let $229d2d71387fce11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $229d2d71387fce11$var$load("9u2y4").then(()=>parcelRequire('hEut2'));

});

parcelRegister("7uCTo", function(module, exports) {

let $574980f42e6f3c4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $574980f42e6f3c4c$var$load("9dydl").then(()=>parcelRequire('cUaI2'));

});

parcelRegister("e5UZq", function(module, exports) {

let $a42dbd4c9265b30b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a42dbd4c9265b30b$var$load("l9cNp").then(()=>parcelRequire('cggiB'));

});

parcelRegister("3nzC9", function(module, exports) {

let $275f2555a52bf827$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $275f2555a52bf827$var$load("akbSW").then(()=>parcelRequire('46Gi2'));

});

parcelRegister("qp9S6", function(module, exports) {

let $04f5f1b8a703c9c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $04f5f1b8a703c9c1$var$load("ljfO7").then(()=>parcelRequire('8RUvv'));

});

parcelRegister("evrj3", function(module, exports) {

let $a8f9246ba3bdd011$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8f9246ba3bdd011$var$load("kPrmI").then(()=>parcelRequire('2VdJi'));

});

parcelRegister("iAREi", function(module, exports) {

let $d895345ab3c252e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d895345ab3c252e3$var$load("ig7YW").then(()=>parcelRequire('2Dpnh'));

});

parcelRegister("4JqHt", function(module, exports) {

let $372013849dcc0b0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $372013849dcc0b0f$var$load("haC3H").then(()=>parcelRequire('gE5ib'));

});

parcelRegister("eryyQ", function(module, exports) {

let $a83e656aef6428f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a83e656aef6428f5$var$load("15olF").then(()=>parcelRequire('o92fW'));

});

parcelRegister("3D6Ix", function(module, exports) {

let $2a4a39857069d2fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a4a39857069d2fe$var$load("cY7P3").then(()=>parcelRequire('dpMx7'));

});

parcelRegister("9zGMZ", function(module, exports) {

let $6f8892fe454e78e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6f8892fe454e78e5$var$load("5892S").then(()=>parcelRequire('lRRGB'));

});

parcelRegister("39Rei", function(module, exports) {

let $24cb80a9bccd4e76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24cb80a9bccd4e76$var$load("cZny7").then(()=>parcelRequire('co42b'));

});

parcelRegister("l6rvQ", function(module, exports) {

let $f5cf7ff5feab8f91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5cf7ff5feab8f91$var$load("fC5SH").then(()=>parcelRequire('b8PJy'));

});

parcelRegister("lGagy", function(module, exports) {

let $fc857bdb4018fa95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc857bdb4018fa95$var$load("cCQto").then(()=>parcelRequire('3DdkG'));

});

parcelRegister("9zunr", function(module, exports) {

let $6f7ef22ecaff5b6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6f7ef22ecaff5b6e$var$load("d0Knu").then(()=>parcelRequire('5H2ph'));

});

parcelRegister("g92qV", function(module, exports) {

let $bc0f5fcf03df0396$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bc0f5fcf03df0396$var$load("eaJc3").then(()=>parcelRequire('iFLhI'));

});

parcelRegister("ft73v", function(module, exports) {

let $b42f098e94ea376d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b42f098e94ea376d$var$load("lFdLx").then(()=>parcelRequire('fRj5u'));

});

parcelRegister("8tEET", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("iitm0", function(module, exports) {

let $d520ad83b7b11e6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d520ad83b7b11e6a$var$load("12mie").then(()=>parcelRequire('gHN26'));

});

parcelRegister("9a0Kb", function(module, exports) {

let $6ab59fefeba7ef7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ab59fefeba7ef7d$var$load("lX3hU").then(()=>parcelRequire('dP4uk'));

});

parcelRegister("9X8kp", function(module, exports) {

let $73f0158b88479145$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73f0158b88479145$var$load("glVF0").then(()=>parcelRequire('gJP5f'));

});

parcelRegister("d4wxz", function(module, exports) {

let $9844e3eedb2f7a55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9844e3eedb2f7a55$var$load("lTvyt").then(()=>parcelRequire('aYYK8'));

});

parcelRegister("8N0XQ", function(module, exports) {

let $6663a5cfdfad2fca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6663a5cfdfad2fca$var$load("2hH31").then(()=>parcelRequire('iDdMo'));

});

parcelRegister("qvwys", function(module, exports) {

let $04fae1d90c8a64cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $04fae1d90c8a64cb$var$load("cmMrn").then(()=>parcelRequire('2Q4q0'));

});

parcelRegister("jJAhj", function(module, exports) {

let $e5de5c5e0f99983f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5de5c5e0f99983f$var$load("2DWrJ").then(()=>parcelRequire('ahzrV'));

});

parcelRegister("aC7Do", function(module, exports) {

let $7ba36009f4f73020$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ba36009f4f73020$var$load("Ddbkb").then(()=>parcelRequire('bPVDt'));

});

parcelRegister("a2hH9", function(module, exports) {

let $74e7d1228ec68f99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74e7d1228ec68f99$var$load("h7KVv").then(()=>parcelRequire('3mjdz'));

});

parcelRegister("aGNXV", function(module, exports) {

let $7c8495c0a88befdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c8495c0a88befdb$var$load("9d1Ui").then(()=>parcelRequire('8QGBH'));

});

parcelRegister("3ygJs", function(module, exports) {

let $296186b8a4536d31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $296186b8a4536d31$var$load("6QOF8").then(()=>parcelRequire('mD7UB'));

});

parcelRegister("lEm5y", function(module, exports) {

let $fc2e77b791abda48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc2e77b791abda48$var$load("hELm2").then(()=>parcelRequire('evxEr'));

});

parcelRegister("8yWzv", function(module, exports) {

let $63beeecc625673fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $63beeecc625673fe$var$load("fTjh6").then(()=>parcelRequire('b2gKV'));

});

parcelRegister("byGSA", function(module, exports) {

let $86a421aa88c13b84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86a421aa88c13b84$var$load("jtL6y").then(()=>parcelRequire('7lu1B'));

});

parcelRegister("71g5k", function(module, exports) {

let $51c51a83c3509dc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $51c51a83c3509dc0$var$load("4kFYm").then(()=>parcelRequire('85PqM'));

});

parcelRegister("6HenW", function(module, exports) {

let $4e01ead27732e99f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e01ead27732e99f$var$load("etT7C").then(()=>parcelRequire('3NE6B'));

});

parcelRegister("5HXUg", function(module, exports) {

let $427f700f4d98e278$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $427f700f4d98e278$var$load("6zH8Y").then(()=>parcelRequire('iikGX'));

});

parcelRegister("eODHb", function(module, exports) {

let $ac9486e807833e5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac9486e807833e5d$var$load("ciUip").then(()=>parcelRequire('eEUNg'));

});

parcelRegister("dLADO", function(module, exports) {

let $a05c164e4ba3361c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a05c164e4ba3361c$var$load("4SS6F").then(()=>parcelRequire('f9lx5'));

});

parcelRegister("24VEe", function(module, exports) {

let $1838ac24c98c1436$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1838ac24c98c1436$var$load("khomJ").then(()=>parcelRequire('9XVn7'));

});

parcelRegister("40iY1", function(module, exports) {

let $2ea5dffa156d7c7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ea5dffa156d7c7c$var$load("l3PYj").then(()=>parcelRequire('3FpGZ'));

});

parcelRegister("egl1q", function(module, exports) {

let $a622ddd6c34ada21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a622ddd6c34ada21$var$load("hLcol").then(()=>parcelRequire('eU6sn'));

});

parcelRegister("9mMGO", function(module, exports) {

let $6d1befde1abc0d82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d1befde1abc0d82$var$load("jZro9").then(()=>parcelRequire('ikdCz'));

});

parcelRegister("3qFE0", function(module, exports) {

let $27f41a7fb3ff5913$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27f41a7fb3ff5913$var$load("aVX51").then(()=>parcelRequire('5fONF'));

});

parcelRegister("3wQcD", function(module, exports) {

let $291cdaa3ecdf9a99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $291cdaa3ecdf9a99$var$load("5JIp8").then(()=>parcelRequire('ff6WO'));

});

parcelRegister("fDOxt", function(module, exports) {

let $b631b37b31632e21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b631b37b31632e21$var$load("8Lmyh").then(()=>parcelRequire('fTVkt'));

});

parcelRegister("9Eqsz", function(module, exports) {

let $706c5fd4a58e9b85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $706c5fd4a58e9b85$var$load("fz3OS").then(()=>parcelRequire('dWu3Q'));

});

parcelRegister("gyn2A", function(module, exports) {

let $c0d1b1beb57b374a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c0d1b1beb57b374a$var$load("cfJp1").then(()=>parcelRequire('4yDJ1'));

});

parcelRegister("hhf8Q", function(module, exports) {

let $c93fc50380f4199b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c93fc50380f4199b$var$load("d5QGH").then(()=>parcelRequire('CVmAv'));

});

parcelRegister("9prlg", function(module, exports) {

let $6d9ba86cb606cc46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d9ba86cb606cc46$var$load("9oxHW").then(()=>parcelRequire('DFtL7'));

});

parcelRegister("bGNnN", function(module, exports) {

let $8829ec5f6734cd9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8829ec5f6734cd9d$var$load("emJGv").then(()=>parcelRequire('2l8UK'));

});

parcelRegister("glZwc", function(module, exports) {

let $be7e53ca38a41728$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be7e53ca38a41728$var$load("8ToNm").then(()=>parcelRequire('ibM2P'));

});

parcelRegister("29rck", function(module, exports) {

let $191184f606c7ce8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $191184f606c7ce8d$var$load("bs8sn").then(()=>parcelRequire('47EfI'));

});

parcelRegister("3upPm", function(module, exports) {

let $28a8353813d420f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28a8353813d420f2$var$load("a2brZ").then(()=>parcelRequire('evTqT'));

});

parcelRegister("b6i2n", function(module, exports) {
module.exports = JSON.parse("{\"gnin.fps-redirect.changeboarding.description\":[{\"type\":0,\"value\":\"Looking for more? Switch to find results and answers from all your Atlassian and connected apps.\"}],\"gnin.fps-redirect.changeboarding.primary-button\":[{\"type\":0,\"value\":\"Got it\"}],\"gnin.fps-redirect.changeboarding.title\":[{\"type\":0,\"value\":\"Switch to search beyond Jira\"}],\"post-office.quick-find-spotlight.spotlight-body-1\":[{\"type\":0,\"value\":\"Apply a mix of filters to narrow down results.\"}],\"post-office.quick-find-spotlight.spotlight-body-2\":[{\"type\":0,\"value\":\"Search only Jira, or expand across all your Atlassian and connected apps.\"}],\"post-office.quick-find-spotlight.spotlight-button-done\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.quick-find-spotlight.spotlight-button-next\":[{\"type\":0,\"value\":\"Next\"}],\"post-office.quick-find-spotlight.spotlight-heading-1\":[{\"type\":0,\"value\":\"Filter for what you need\"}],\"post-office.quick-find-spotlight.spotlight-heading-2\":[{\"type\":0,\"value\":\"Choose where to search\"}],\"search-page.gnin-redirect.changeboarding.back-button\":[{\"type\":0,\"value\":\"Back\"}],\"search-page.gnin-redirect.changeboarding.next-button\":[{\"type\":0,\"value\":\"Next\"}],\"search-page.gnin-redirect.changeboarding.primary-button\":[{\"type\":0,\"value\":\"Got it\"}],\"search-page.gnin-redirect.changeboarding.step-label\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"search-page.gnin-redirect.changeboarding.step1.description\":[{\"type\":0,\"value\":\"Your results may come from all your apps or just Jira, depending on your search terms.\"}],\"search-page.gnin-redirect.changeboarding.step1.image-alt\":[{\"type\":0,\"value\":\"Rovo full page search smart AI answer illustration\"}],\"search-page.gnin-redirect.changeboarding.step1.title\":[{\"type\":0,\"value\":\"Search that adapts to you\"}],\"search-page.gnin-redirect.changeboarding.step2.description\":[{\"type\":0,\"value\":\"You can switch anytime to search Jira work items (including JQL).\"}],\"search-page.gnin-redirect.changeboarding.step2.image-alt\":[{\"type\":0,\"value\":\"Rovo full page search illustration\"}],\"search-page.gnin-redirect.changeboarding.step2.title\":[{\"type\":0,\"value\":\"Switch your view anytime\"}]}");

});

parcelRegister("cDdaq", function(module, exports) {

let $932357487f6e3d95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $932357487f6e3d95$var$load("23b63").then(()=>parcelRequire('78lXq'));

});

parcelRegister("auOfl", function(module, exports) {

let $7a43ae9c1e22fc8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a43ae9c1e22fc8d$var$load("feh3p").then(()=>parcelRequire('5w41a'));

});

parcelRegister("5wIYr", function(module, exports) {

let $4062d3cd052c98ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4062d3cd052c98ae$var$load("g8Zyl").then(()=>parcelRequire('1n93x'));

});

parcelRegister("7VZz0", function(module, exports) {

let $5c6d9c860f93043e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5c6d9c860f93043e$var$load("4xc8n").then(()=>parcelRequire('hgnjq'));

});

parcelRegister("k47Zk", function(module, exports) {

let $e9ba60a605b9a4ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9ba60a605b9a4ac$var$load("95OWE").then(()=>parcelRequire('395Km'));

});

parcelRegister("6oMpr", function(module, exports) {

let $4a8a890caafbd0cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a8a890caafbd0cd$var$load("1TZJr").then(()=>parcelRequire('585Ua'));

});

parcelRegister("buNhf", function(module, exports) {

let $85e8b87dcc9707fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85e8b87dcc9707fe$var$load("47hEV").then(()=>parcelRequire('cuJfy'));

});

parcelRegister("hzXmp", function(module, exports) {

let $ccc3c04cc4c176e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ccc3c04cc4c176e4$var$load("901sU").then(()=>parcelRequire('1akYw'));

});

parcelRegister("dh44h", function(module, exports) {

let $9aa004be3d955c59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9aa004be3d955c59$var$load("612wZ").then(()=>parcelRequire('77CgS'));

});

parcelRegister("7WzwU", function(module, exports) {

let $5c8982a6919c38e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5c8982a6919c38e0$var$load("8NqIM").then(()=>parcelRequire('1xn05'));

});

parcelRegister("3k8AG", function(module, exports) {

let $26b9e74c0551c94b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26b9e74c0551c94b$var$load("5blxS").then(()=>parcelRequire('lSBQw'));

});

parcelRegister("geY98", function(module, exports) {

let $bd2c9bf79893ce5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd2c9bf79893ce5e$var$load("8RbOe").then(()=>parcelRequire('lDVa9'));

});

parcelRegister("7qHjX", function(module, exports) {

let $568c90c1b0db3f9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $568c90c1b0db3f9d$var$load("5u2UK").then(()=>parcelRequire('kC4dL'));

});

parcelRegister("3s44g", function(module, exports) {

let $28372462a633d5a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28372462a633d5a3$var$load("2ydJq").then(()=>parcelRequire('1Tkfo'));

});

parcelRegister("1Xkv4", function(module, exports) {

let $16cb340b0637ae17$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $16cb340b0637ae17$var$load("5t5Y1").then(()=>parcelRequire('4R81F'));

});

parcelRegister("as4oX", function(module, exports) {

let $79bfeef18a87e321$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79bfeef18a87e321$var$load("6P70W").then(()=>parcelRequire('h83dN'));

});

parcelRegister("e5dzS", function(module, exports) {

let $a40c10900f4804ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a40c10900f4804ec$var$load("joo0f").then(()=>parcelRequire('gesJm'));

});

parcelRegister("dGpOG", function(module, exports) {

let $9f633936c46fa34d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9f633936c46fa34d$var$load("lyRdw").then(()=>parcelRequire('9AyKA'));

});

parcelRegister("80uT5", function(module, exports) {

let $5d46486bb248dcae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d46486bb248dcae$var$load("hGWxW").then(()=>parcelRequire('9p6Os'));

});

parcelRegister("6Nmfs", function(module, exports) {

let $4f2893be18cfcdfc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f2893be18cfcdfc$var$load("bn0Od").then(()=>parcelRequire('bcIbh'));

});

parcelRegister("i1dhj", function(module, exports) {

let $d1e29ec0fc27340a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1e29ec0fc27340a$var$load("jMzyY").then(()=>parcelRequire('8T5qI'));

});

parcelRegister("3sHvi", function(module, exports) {

let $2855bb941c33387f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2855bb941c33387f$var$load("3juT3").then(()=>parcelRequire('jHlCl'));

});

parcelRegister("66aeI", function(module, exports) {

let $470b3e5192fdc627$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $470b3e5192fdc627$var$load("a6WPO").then(()=>parcelRequire('lb303'));

});

parcelRegister("akPKe", function(module, exports) {

let $7863e9097c65dc53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7863e9097c65dc53$var$load("af8dS").then(()=>parcelRequire('57Cm7'));

});

parcelRegister("62fTj", function(module, exports) {

let $464f41a12aca11db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $464f41a12aca11db$var$load("i5BJw").then(()=>parcelRequire('adDSw'));

});

parcelRegister("lPC4H", function(module, exports) {

let $fe4be53f92fb4c4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fe4be53f92fb4c4e$var$load("7FP3a").then(()=>parcelRequire('e85JH'));

});

parcelRegister("2ZduP", function(module, exports) {

let $22cbbf551bf7e352$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $22cbbf551bf7e352$var$load("5zsBq").then(()=>parcelRequire('adn7y'));

});

parcelRegister("i4OQL", function(module, exports) {

let $d2900b7cf1b01ccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2900b7cf1b01ccf$var$load("bxWG7").then(()=>parcelRequire('4ENOm'));

});

parcelRegister("gwnv5", function(module, exports) {

let $c071dd2fe6e83eca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c071dd2fe6e83eca$var$load("8yEvW").then(()=>parcelRequire('hDer7'));

});

parcelRegister("5Jjdv", function(module, exports) {

let $42c00fc76a16025d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $42c00fc76a16025d$var$load("6VqyS").then(()=>parcelRequire('3YlGL'));

});

parcelRegister("aJnC5", function(module, exports) {

let $7d006c70b06d1754$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d006c70b06d1754$var$load("daVsY").then(()=>parcelRequire('5zgpF'));

});

parcelRegister("jUDUz", function(module, exports) {

let $e7f234de12ce781a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7f234de12ce781a$var$load("bBFYq").then(()=>parcelRequire('hn16I'));

});

parcelRegister("17MhK", function(module, exports) {

let $0d1be65b8ce52b4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d1be65b8ce52b4a$var$load("7dUZS").then(()=>parcelRequire('gN0nG'));

});

parcelRegister("5iIKM", function(module, exports) {

let $3dc1594df59490a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3dc1594df59490a4$var$load("cnY4I").then(()=>parcelRequire('4mDoG'));

});

parcelRegister("hYdie", function(module, exports) {
module.exports = JSON.parse("{\"jira-glance-panel-navigation-arrows.spotlight.body\":[{\"type\":0,\"value\":\"View your work in a side panel or modal, and navigate both contextually.\"}],\"jira-glance-panel-navigation-arrows.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-glance-panel-navigation-arrows.spotlight.headline\":[{\"type\":0,\"value\":\"Control how you view work\"}],\"jira-glance-panel-navigation-arrows.spotlight.image-alt\":[{\"type\":0,\"value\":\"Navigation arrows on the glance panel\"}],\"jira-glance-panel-navigation-arrows.spotlight.primary-action\":[{\"type\":0,\"value\":\"OK\"}],\"jira-work-item-view-native-projects-field.body\":[{\"type\":0,\"value\":\"Your existing project connections have moved to the new field. Nothing to set up.\"}],\"jira-work-item-view-native-projects-field.button.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-work-item-view-native-projects-field.button.done\":[{\"type\":0,\"value\":\"Got it\"}],\"jira-work-item-view-native-projects-field.headline\":[{\"type\":0,\"value\":\"Projects are now part of Jira\"}],\"jira-work-item-view-native-projects-field.image-alt\":[{\"type\":0,\"value\":\"Illustration showing a native Atlas project smart card pointing to the project interface\"}],\"jira-work-item-view-native-projects-field.tp.body\":[{\"type\":0,\"value\":\"Connect your work to a project, track progress, and easily share updates.\"}],\"jira-work-item-view-native-projects-field.tp.button.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-work-item-view-native-projects-field.tp.button.done\":[{\"type\":0,\"value\":\"Try Projects\"}],\"jira-work-item-view-native-projects-field.tp.headline\":[{\"type\":0,\"value\":\"Share updates with Projects\"}],\"jira-work-item-view-native-projects-field.tp.image-alt\":[{\"type\":0,\"value\":\"Illustration showing the new Projects field in the Jira work item view, ready to connect work to a project\"}]}");

});

parcelRegister("8nmw0", function(module, exports) {

let $6191efc6945a69b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6191efc6945a69b5$var$load("deKd8").then(()=>parcelRequire('8Cl9V'));

});

parcelRegister("3doji", function(module, exports) {

let $25757181f352a748$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $25757181f352a748$var$load("kUhHO").then(()=>parcelRequire('7IjFM'));

});

parcelRegister("1Oqzy", function(module, exports) {

let $151f12b7271020ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $151f12b7271020ac$var$load("7IcvY").then(()=>parcelRequire('f06qa'));

});

parcelRegister("bVAOn", function(module, exports) {

let $8af19290eb251002$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8af19290eb251002$var$load("XfEP6").then(()=>parcelRequire('1EyWG'));

});

parcelRegister("7AlJL", function(module, exports) {

let $585cc1b7d83cfc6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $585cc1b7d83cfc6d$var$load("kvKHy").then(()=>parcelRequire('9MVrK'));

});

parcelRegister("41ilg", function(module, exports) {

let $2ed57bbb00a17893$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ed57bbb00a17893$var$load("1ZjtK").then(()=>parcelRequire('1VMpg'));

});

parcelRegister("b4dkn", function(module, exports) {

let $80ea680b9edfe973$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80ea680b9edfe973$var$load("agUw3").then(()=>parcelRequire('aNGom'));

});

parcelRegister("96hZt", function(module, exports) {

let $6a02a12489cfe16b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a02a12489cfe16b$var$load("gt8AI").then(()=>parcelRequire('8RWSe'));

});

parcelRegister("2lwQK", function(module, exports) {

let $1b57063184b29006$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b57063184b29006$var$load("f6ZPj").then(()=>parcelRequire('cPakK'));

});

parcelRegister("5nyCO", function(module, exports) {

let $3ea9f58ab0edc15b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ea9f58ab0edc15b$var$load("3bDom").then(()=>parcelRequire('EK5NN'));

});

parcelRegister("9EUXj", function(module, exports) {

let $708407b045408ab0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $708407b045408ab0$var$load("2CW2m").then(()=>parcelRequire('gGQ2h'));

});

parcelRegister("jPBlT", function(module, exports) {

let $e6ffc1144ab17424$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6ffc1144ab17424$var$load("gyces").then(()=>parcelRequire('cKwTh'));

});

parcelRegister("c1QEb", function(module, exports) {

let $8c1e6aa9b781c484$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8c1e6aa9b781c484$var$load("iA47s").then(()=>parcelRequire('978M8'));

});

parcelRegister("67ObA", function(module, exports) {

let $475a53676269d921$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $475a53676269d921$var$load("i3SYW").then(()=>parcelRequire('85Ypp'));

});

parcelRegister("kpo0h", function(module, exports) {

let $edb8c30d988fb244$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $edb8c30d988fb244$var$load("ljWoZ").then(()=>parcelRequire('7wMfF'));

});

parcelRegister("dIXkk", function(module, exports) {

let $9fdd677f1507b36d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9fdd677f1507b36d$var$load("el6dg").then(()=>parcelRequire('eK3tl'));

});

parcelRegister("StmFr", function(module, exports) {

let $0a3bd275902789f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0a3bd275902789f9$var$load("6LftV").then(()=>parcelRequire('eim0G'));

});

parcelRegister("8HRam", function(module, exports) {

let $656b94956e79b3a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $656b94956e79b3a8$var$load("43gQl").then(()=>parcelRequire('9w2X9'));

});

parcelRegister("kIvbW", function(module, exports) {

let $f1501cbc4e561fa6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f1501cbc4e561fa6$var$load("eEXB4").then(()=>parcelRequire('gtzWX'));

});

parcelRegister("kb2WL", function(module, exports) {

let $eb071eed25583ca6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb071eed25583ca6$var$load("6hYpH").then(()=>parcelRequire('hhngr'));

});

parcelRegister("jJGiG", function(module, exports) {

let $e5e30842d259641b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5e30842d259641b$var$load("cUYHM").then(()=>parcelRequire('bKA2v'));

});

parcelRegister("gjtft", function(module, exports) {

let $be051bd95a8f10b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be051bd95a8f10b8$var$load("5XwQJ").then(()=>parcelRequire('5CvyC'));

});

parcelRegister("2O8Ud", function(module, exports) {

let $20b728c0a959fc12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20b728c0a959fc12$var$load("cht3A").then(()=>parcelRequire('I2v7P'));

});

parcelRegister("iupCL", function(module, exports) {

let $d75ee7c8b6aea938$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d75ee7c8b6aea938$var$load("htefS").then(()=>parcelRequire('12CFw'));

});

parcelRegister("8MjEO", function(module, exports) {

let $66420df3829b11c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66420df3829b11c6$var$load("aM5HQ").then(()=>parcelRequire('h0WVp'));

});

parcelRegister("h7rjs", function(module, exports) {

let $c76846e39a101b5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c76846e39a101b5b$var$load("e5PzQ").then(()=>parcelRequire('7v7e1'));

});

parcelRegister("5OzKu", function(module, exports) {

let $43bd5a3df6fd9e0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $43bd5a3df6fd9e0b$var$load("lkiRi").then(()=>parcelRequire('fKD9L'));

});

parcelRegister("8putr", function(module, exports) {

let $61f84bfd2a732f0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61f84bfd2a732f0a$var$load("haAfc").then(()=>parcelRequire('dSrZ5'));

});

parcelRegister("jC72S", function(module, exports) {

let $e47708057bea6951$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e47708057bea6951$var$load("kdObH").then(()=>parcelRequire('1vgtJ'));

});

parcelRegister("8dJob", function(module, exports) {

let $5fc2bef53c356d8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5fc2bef53c356d8f$var$load("eHXTv").then(()=>parcelRequire('brbX3'));

});

parcelRegister("lSGkj", function(module, exports) {

let $fedf794c5a99d353$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fedf794c5a99d353$var$load("4JFvO").then(()=>parcelRequire('5xjAm'));

});

parcelRegister("2pXqz", function(module, exports) {

let $1c2c03a597c6ae38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c2c03a597c6ae38$var$load("dwAjs").then(()=>parcelRequire('114j5'));

});

parcelRegister("iLuja", function(module, exports) {

let $da94205ca06abf64$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da94205ca06abf64$var$load("6UpXG").then(()=>parcelRequire('i6MDs'));

});

parcelRegister("c8RHS", function(module, exports) {

let $8d6fe471af790597$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d6fe471af790597$var$load("bT2gX").then(()=>parcelRequire('1RMoN'));

});

parcelRegister("f65x9", function(module, exports) {
module.exports = JSON.parse('{"growth-jira-onboarding.Contact-us":[{"type":0,"value":"Contact us"}],"growth-jira-onboarding.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"growth-jira-onboarding.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"growth-jira-onboarding.footer.dot-separator":[{"type":0,"value":"\u2022"}],"growth-jira-onboarding.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"growth-jira-onboarding.footer.facebook-title":[{"type":0,"value":"Facebook"}],"growth-jira-onboarding.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"growth-jira-onboarding.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"growth-jira-onboarding.footer.footer-links.read-our-blog":[{"type":1,"value":"thirdText"}],"growth-jira-onboarding.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"growth-jira-onboarding.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"growth-jira-onboarding.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-jira-onboarding.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"growth-jira-onboarding.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"growth-jira-onboarding.footer.x-alt-text":[{"type":0,"value":"X"}],"growth-jira-onboarding.footer.x-title":[{"type":0,"value":"X"}],"growth-jira-onboarding.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"growth-jira-onboarding.footer.youtube-title":[{"type":0,"value":"Youtube"}],"growth-jira-onboarding.invite-reminder-with-board-activity.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.board-heading":[{"type":0,"value":"Join in on your team\u2019s recent work"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.board-heading-text":[{"type":0,"value":"Here\u2019s what everyone\u2019s been up to in Jira:"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-text":[{"type":0,"value":"Start collaborating"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-text.join-now":[{"type":0,"value":"Join now"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-view-all":[{"type":0,"value":"View all work"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.assignee":[{"type":0,"value":"Assignee"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.due-date":[{"type":0,"value":"Due date"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.status":[{"type":0,"value":"Status"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.summary":[{"type":0,"value":"Summary"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.created-by":[{"type":0,"value":"Created by "},{"type":1,"value":"projectAdmin"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.header-admin-only":[{"type":1,"value":"projectAdmin"},{"type":0,"value":" is waiting for you to join \'"},{"type":1,"value":"projectName"},{"type":0,"value":"\'"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.header-many-user":[{"type":1,"value":"projectAdmin"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other"}]},"other":{"value":[{"type":7},{"type":0,"value":" others"}]}},"pluralType":"cardinal","type":6,"value":"otherUsers"},{"type":0,"value":" are waiting for you to join \'"},{"type":1,"value":"projectName"},{"type":0,"value":"\'"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.in-body-header":[{"type":0,"value":"Your team is waiting for you to join them in Jira"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.subject.no-translate":[{"type":0,"value":"Reminder: You\u2019ve been invited to plan and track work in Jira"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.done":[{"type":0,"value":"Done"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.inProgress":[{"type":0,"value":"In Progress"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.todo":[{"type":0,"value":"To Do"}],"growth-jira-onboarding.invite-reminder-with-board-activity.social-proof.text":[{"children":[{"type":0,"value":"Jira is the #1 project management tool"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers plan and track work across every team."}],"growth-jira-onboarding.invite-reminder-with-board-activitye.message-template.email.project-launch":[{"type":1,"value":"projectName"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.body-text":[{"children":[{"type":0,"value":"Jira is the #1 project management tool"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers plan and track work across every team."}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.button-text":[{"type":0,"value":"Join now"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.created-by":[{"type":0,"value":"Created by "},{"type":1,"value":"projectAdmin"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.header":[{"type":0,"value":"Start collaborating with your team in Jira"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.invite-nudge.banner":[{"type":0,"value":"\uD83D\uDC4B "},{"children":[{"type":0,"value":"Forward this email"}],"type":8,"value":"b"},{"type":0,"value":" to easily invite more teammates"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.project-launch":[{"type":1,"value":"filteredProjectName"},{"type":0,"value":" Launch"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.subject.start-collaborating":[{"type":0,"value":"Start collaborating with your team on "},{"type":1,"value":"filteredProjectName"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.unsubscribe-link-text":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"jira-sidebar-nav-day-x-notification.body-text":[{"type":0,"value":"We\u2019ve added features to boost your productivity. "},{"children":[{"type":0,"value":"Customize your sidebar"}],"type":8,"value":"strong"},{"type":0,"value":" to change what shows up."}],"jira-sidebar-nav-day-x-notification.button-text":[{"type":0,"value":"Got it"}],"post-office.components.email.default-project-name":[{"type":0,"value":"Big Campaign"}],"post-office.components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.components.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.growth-jira-onboarding-common.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.growth-jira-onboarding-common.footer.contact-us":[{"type":0,"value":" Contact us \u2022 "}],"post-office.growth-jira-onboarding-common.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.growth-jira-onboarding-common.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.growth-jira-onboarding-common.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.growth-jira-onboarding-common.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.growth-jira-onboarding-common.footer.footer-links.join-atlassian-community":[{"type":1,"value":"joinAtlassianCommunity"}],"post-office.growth-jira-onboarding-common.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.growth-jira-onboarding-common.footer.footer-links.read-in-browser":[{"type":1,"value":"readInBrowser"}],"post-office.growth-jira-onboarding-common.footer.footer-links.read-our-blog":[{"type":0,"value":" "},{"type":1,"value":"thirdText"}],"post-office.growth-jira-onboarding-common.footer.join-atlassian-community":[{"type":0,"value":"Join Atlassian Community"}],"post-office.growth-jira-onboarding-common.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.growth-jira-onboarding-common.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.growth-jira-onboarding-common.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.growth-jira-onboarding-common.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.growth-jira-onboarding-common.footer.privacy-policy":[{"type":0,"value":"Privacy Policy \u2022 "}],"post-office.growth-jira-onboarding-common.footer.read-in-browser":[{"type":0,"value":"Read in browser \u2022 "}],"post-office.growth-jira-onboarding-common.footer.read-our-blog":[{"type":0,"value":"Read our blog \u2022 "}],"post-office.growth-jira-onboarding-common.footer.twitter-alt-text":[{"type":0,"value":"Twitter"}],"post-office.growth-jira-onboarding-common.footer.twitter-title":[{"type":0,"value":"Twitter"}],"post-office.growth-jira-onboarding-common.footer.unsubscribe":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or "},{"type":1,"value":"unsubscribe"},{"type":0,"value":" here."}],"post-office.growth-jira-onboarding-common.footer.unsubscribeText":[{"type":0,"value":"unsubscribe"}],"post-office.growth-jira-onboarding-common.jira-email-header.atlassian-text":[{"type":0,"value":"Atlassian"}],"post-office.growth-jira-onboarding-common.jira-email-header.jira-logo-alt-text":[{"type":0,"value":"Jira"}],"post-office.growth-jira-onboarding-common.jira-email-header.jira-text":[{"type":0,"value":"Jira"}],"post-office.growth-jira-onboarding.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Tell us about your setup experience and we\u2019ll send you a $100 gift card as a thank you."}],"post-office.growth-jira-onboarding.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Join our paid research study \uD83D\uDCB8"}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.body":[{"type":0,"value":"Use Rovo to create structured tasks, connect agents, and organize work."}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.cta":[{"type":0,"value":"Try now"}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.headline":[{"type":0,"value":"Try a suggested action"}],"post-office.growth-jira-onboarding.jira-setup-user-interviews-signup.screen-space-flags.cta-link":[{"type":0,"value":"Join now"}],"post-office.test-placement.jonboarding-jira-side-nav-projects.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}]}');

});

parcelRegister("1eQXd", function(module, exports) {

let $0e702cd58b93e094$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e702cd58b93e094$var$load("asnh4").then(()=>parcelRequire('eacJu'));

});

parcelRegister("4BuSr", function(module, exports) {

let $35a291a974cac526$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35a291a974cac526$var$load("8LnkK").then(()=>parcelRequire('6ihZP'));

});

parcelRegister("fYBx8", function(module, exports) {

let $ba1992f2e25c8c91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ba1992f2e25c8c91$var$load("dUyup").then(()=>parcelRequire('a31vg'));

});

parcelRegister("dBvjV", function(module, exports) {

let $9e7706a36731ec7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e7706a36731ec7d$var$load("lxWnP").then(()=>parcelRequire('6KgGb'));

});

parcelRegister("d1ASM", function(module, exports) {

let $97b7fa748cb5ea18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97b7fa748cb5ea18$var$load("ctpV1").then(()=>parcelRequire('h0tVz'));

});

parcelRegister("2Gx92", function(module, exports) {

let $1f4936e53f65cbc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f4936e53f65cbc4$var$load("9NhfJ").then(()=>parcelRequire('9e9qH'));

});

parcelRegister("87OwI", function(module, exports) {

let $5ea62bbc4edb6eea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ea62bbc4edb6eea$var$load("18n3D").then(()=>parcelRequire('dyjz6'));

});

parcelRegister("3mt22", function(module, exports) {

let $2729f24c1c16e8d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2729f24c1c16e8d8$var$load("7J2Tj").then(()=>parcelRequire('6hsA7'));

});

parcelRegister("iT8gj", function(module, exports) {

let $dc03c5ba7121cd40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc03c5ba7121cd40$var$load("fpBjx").then(()=>parcelRequire('2duGV'));

});

parcelRegister("a5wxd", function(module, exports) {

let $75839bb9fde4ce1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $75839bb9fde4ce1e$var$load("dbP9C").then(()=>parcelRequire('4KtKe'));

});

parcelRegister("g2Te9", function(module, exports) {

let $bae7ac389e504c3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bae7ac389e504c3a$var$load("dJ6CU").then(()=>parcelRequire('lIieJ'));

});

parcelRegister("dCauw", function(module, exports) {

let $9e96f64e87cd0f12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e96f64e87cd0f12$var$load("7xWuQ").then(()=>parcelRequire('avij5'));

});

parcelRegister("92iRe", function(module, exports) {

let $6942edad3f810000$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6942edad3f810000$var$load("iXAaE").then(()=>parcelRequire('jqozH'));

});

parcelRegister("37njW", function(module, exports) {

let $24541d8761e83884$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24541d8761e83884$var$load("1p26G").then(()=>parcelRequire('gagNu'));

});

parcelRegister("7clBf", function(module, exports) {

let $53da68ad8e4bddf1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $53da68ad8e4bddf1$var$load("8ye0y").then(()=>parcelRequire('26NO9'));

});

parcelRegister("aMcgl", function(module, exports) {

let $7d87e63285668a33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d87e63285668a33$var$load("9iLk6").then(()=>parcelRequire('98AaJ'));

});

parcelRegister("4OlwQ", function(module, exports) {

let $380c881295a4de4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $380c881295a4de4e$var$load("4dnxF").then(()=>parcelRequire('1zUbf'));

});

parcelRegister("NAgHO", function(module, exports) {

let $0950b5e032113724$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0950b5e032113724$var$load("d7luX").then(()=>parcelRequire('Zm8Fe'));

});

parcelRegister("lMTw5", function(module, exports) {

let $fdc925184d8b5bfa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fdc925184d8b5bfa$var$load("jF5rR").then(()=>parcelRequire('gOeee'));

});

parcelRegister("Zfmgg", function(module, exports) {

let $0b819c68ce83e38d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b819c68ce83e38d$var$load("dX8AQ").then(()=>parcelRequire('eMNUr'));

});

parcelRegister("2H8xi", function(module, exports) {

let $1f6638070c48b720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f6638070c48b720$var$load("f0AfY").then(()=>parcelRequire('auYFA'));

});

parcelRegister("hu4gj", function(module, exports) {

let $cba88b5e0f9cb7b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cba88b5e0f9cb7b5$var$load("6Eqdq").then(()=>parcelRequire('4KxsF'));

});

parcelRegister("cvaUd", function(module, exports) {

let $91a0d6f04acd6ab6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91a0d6f04acd6ab6$var$load("jhtRT").then(()=>parcelRequire('beJkR'));

});

parcelRegister("iXWdg", function(module, exports) {

let $dceae48e598b2175$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dceae48e598b2175$var$load("cdI8S").then(()=>parcelRequire('4Ae3H'));

});

parcelRegister("ccYKF", function(module, exports) {

let $8e35bb0c5b800576$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e35bb0c5b800576$var$load("c6vGH").then(()=>parcelRequire('6brmz'));

});

parcelRegister("hD3yW", function(module, exports) {

let $cd58d7a514192a73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd58d7a514192a73$var$load("g0hK0").then(()=>parcelRequire('hKCg0'));

});

parcelRegister("5TvTU", function(module, exports) {

let $44aad59c5ad35577$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44aad59c5ad35577$var$load("bHjk7").then(()=>parcelRequire('iiA1g'));

});

parcelRegister("lqj2a", function(module, exports) {

let $f98aca6b08d3175f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f98aca6b08d3175f$var$load("f056k").then(()=>parcelRequire('5R6Sb'));

});

parcelRegister("lgygW", function(module, exports) {

let $03fecd1e626bf7d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03fecd1e626bf7d7$var$load("2AAcu").then(()=>parcelRequire('jxauH'));

});

parcelRegister("eOamb", function(module, exports) {

let $ac7dc4d8302790a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac7dc4d8302790a6$var$load("6maU8").then(()=>parcelRequire('d1Dwn'));

});

parcelRegister("8sIM1", function(module, exports) {

let $6293ab58f7acdf1b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6293ab58f7acdf1b$var$load("cBmmw").then(()=>parcelRequire('1rStK'));

});

parcelRegister("8sxCA", function(module, exports) {

let $628b04c30ce3e5fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $628b04c30ce3e5fd$var$load("kjWSq").then(()=>parcelRequire('lO6S4'));

});

parcelRegister("5Mtnd", function(module, exports) {

let $4358386282b06db6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4358386282b06db6$var$load("hvak0").then(()=>parcelRequire('6iB89'));

});

parcelRegister("79Jsn", function(module, exports) {

let $535ca269f7d7a9a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $535ca269f7d7a9a7$var$load("5rFOl").then(()=>parcelRequire('3ZGIg'));

});

parcelRegister("6rGkx", function(module, exports) {
module.exports = JSON.parse("{\"dismissButton\":[{\"type\":0,\"value\":\"OK\"}],\"jira-issueview-status.issue-view-resolution-changeboarding-body\":[{\"type\":0,\"value\":\"To keep key information in one spot, we've moved the status and resolution field to the left\"}],\"jira-issueview-status.issue-view-resolution-changeboarding-heading\":[{\"type\":0,\"value\":\"Status is now on the left\"}],\"jira-issueview-status.issue-view-status-changeboarding-body\":[{\"type\":0,\"value\":\"To keep key information in one spot, we've moved status to the left\"}],\"jira-issueview-status.issue-view-status-changeboarding-heading\":[{\"type\":0,\"value\":\"Status is now on the left\"}],\"post-office.jira-issueview-status.main-heading.no-translate\":[{\"type\":0,\"value\":\"Welcome to Jira Issue View Status\"}]}");

});

parcelRegister("btONi", function(module, exports) {

let $85b9cdcf25dd52f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85b9cdcf25dd52f7$var$load("afHt5").then(()=>parcelRequire('1FuKj'));

});

parcelRegister("cVlbZ", function(module, exports) {

let $968b3f442ff2a2dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $968b3f442ff2a2dd$var$load("aiHku").then(()=>parcelRequire('8nmXG'));

});

parcelRegister("kBSwR", function(module, exports) {

let $f0118fa6fcb53653$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0118fa6fcb53653$var$load("iRgSc").then(()=>parcelRequire('cMVtX'));

});

parcelRegister("iq2Ha", function(module, exports) {

let $d68cbee664c2fecd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d68cbee664c2fecd$var$load("hASKq").then(()=>parcelRequire('aApJ5'));

});

parcelRegister("5Za3J", function(module, exports) {

let $45ba73cc64f2355e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45ba73cc64f2355e$var$load("lRPUn").then(()=>parcelRequire('h7M99'));

});

parcelRegister("7qdcA", function(module, exports) {

let $567533c2e9d06dd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $567533c2e9d06dd9$var$load("1Io1M").then(()=>parcelRequire('jnFeZ'));

});

parcelRegister("fVPDF", function(module, exports) {

let $b9943c4ba9e7a1e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b9943c4ba9e7a1e9$var$load("kEVX0").then(()=>parcelRequire('2r6Al'));

});

parcelRegister("18JTz", function(module, exports) {

let $0d4a23a70c0e9c3e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d4a23a70c0e9c3e$var$load("goPCF").then(()=>parcelRequire('ekjQz'));

});

parcelRegister("dO75E", function(module, exports) {

let $a0d571ce7a7b8f51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0d571ce7a7b8f51$var$load("hdQ3n").then(()=>parcelRequire('gZWG2'));

});

parcelRegister("6nyeE", function(module, exports) {

let $4a4f7278b21f97fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a4f7278b21f97fd$var$load("54HVR").then(()=>parcelRequire('96u8o'));

});

parcelRegister("lyfNH", function(module, exports) {

let $fb09079ab5fea915$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb09079ab5fea915$var$load("kiXKy").then(()=>parcelRequire('lnh2Q'));

});

parcelRegister("3EeAE", function(module, exports) {

let $2a806cd81043989b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a806cd81043989b$var$load("8GmfZ").then(()=>parcelRequire('fTiqQ'));

});

parcelRegister("hqdIj", function(module, exports) {

let $caef80a8ec22893d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caef80a8ec22893d$var$load("cMMJw").then(()=>parcelRequire('iFazd'));

});

parcelRegister("dW9f5", function(module, exports) {

let $a257dc7802e257e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a257dc7802e257e7$var$load("aJNOs").then(()=>parcelRequire('Zqh0A'));

});

parcelRegister("9wfQB", function(module, exports) {

let $6ee36532f62a0c6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ee36532f62a0c6b$var$load("6MZNE").then(()=>parcelRequire('cseSs'));

});

parcelRegister("hRkFc", function(module, exports) {

let $d0076a416b9bbb5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d0076a416b9bbb5d$var$load("iJpVF").then(()=>parcelRequire('f5Tod'));

});

parcelRegister("ddJov", function(module, exports) {

let $99ffb39bf3a1fbe9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99ffb39bf3a1fbe9$var$load("7PL9E").then(()=>parcelRequire('dNRCe'));

});

parcelRegister("jigr4", function(module, exports) {

let $039ff154b6372d4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $039ff154b6372d4a$var$load("eSmn9").then(()=>parcelRequire('88yes'));

});

parcelRegister("54TR9", function(module, exports) {

let $3b28a75741e2bc3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b28a75741e2bc3d$var$load("h5vux").then(()=>parcelRequire('kyT0s'));

});

parcelRegister("ecgqg", function(module, exports) {

let $a55eece13787ff2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a55eece13787ff2b$var$load("dzp9v").then(()=>parcelRequire('u4lEZ'));

});

parcelRegister("kNY9t", function(module, exports) {

let $f2570b2033c2bb21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2570b2033c2bb21$var$load("lfV4b").then(()=>parcelRequire('c88aq'));

});

parcelRegister("6R1Tz", function(module, exports) {

let $4fd929ac5fa476f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4fd929ac5fa476f5$var$load("hnzJi").then(()=>parcelRequire('3mVC3'));

});

parcelRegister("1OM09", function(module, exports) {

let $152fb20e6f7df686$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $152fb20e6f7df686$var$load("1VEoh").then(()=>parcelRequire('2e4bZ'));

});

parcelRegister("2VfZD", function(module, exports) {

let $220d4f8f4f192e70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $220d4f8f4f192e70$var$load("3C3qD").then(()=>parcelRequire('aTlUh'));

});

parcelRegister("bzCDp", function(module, exports) {

let $86d0ee9ea90e9c75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86d0ee9ea90e9c75$var$load("Ju5La").then(()=>parcelRequire('c7rEO'));

});

parcelRegister("aMyR0", function(module, exports) {

let $7d996c5c38523de8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d996c5c38523de8$var$load("2fDar").then(()=>parcelRequire('lXziF'));

});

parcelRegister("7AUrQ", function(module, exports) {

let $5877ae99e288e5b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5877ae99e288e5b3$var$load("hBNuK").then(()=>parcelRequire('6021Z'));

});

parcelRegister("2PyPc", function(module, exports) {

let $20fb5bad14e1f439$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20fb5bad14e1f439$var$load("5O05U").then(()=>parcelRequire('lyys6'));

});

parcelRegister("YyzdC", function(module, exports) {

let $0b606b018b993099$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b606b018b993099$var$load("3XRbj").then(()=>parcelRequire('c3Tsk'));

});

parcelRegister("iURxI", function(module, exports) {

let $dc56fd7317ef715e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc56fd7317ef715e$var$load("4315y").then(()=>parcelRequire('4GuUb'));

});

parcelRegister("hTDKi", function(module, exports) {

let $d07667694c778e94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d07667694c778e94$var$load("j315U").then(()=>parcelRequire('liO2D'));

});

parcelRegister("a1UKY", function(module, exports) {

let $74d60616fa9488aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74d60616fa9488aa$var$load("9yiBg").then(()=>parcelRequire('h1ytc'));

});

parcelRegister("i0vtB", function(module, exports) {

let $d1c0a4a3c6816817$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1c0a4a3c6816817$var$load("i4Skc").then(()=>parcelRequire('6I2GO'));

});

parcelRegister("6xqzX", function(module, exports) {

let $4c2a713064ae1684$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c2a713064ae1684$var$load("gE1SW").then(()=>parcelRequire('g0ggp'));

});

parcelRegister("kKV5X", function(module, exports) {
module.exports = JSON.parse("{\"jira-nin-grouping-with-hierarchy-spotlight.spotlightDismissButton\":[{\"type\":0,\"value\":\"Done\"}],\"jira-nin-grouping-with-hierarchy-spotlight.spotlightHeading\":[{\"type\":0,\"value\":\"Show hierarchy when grouping\"}],\"jira-nin-grouping-with-hierarchy-spotlight.spotlightImageAltText\":[{\"type\":0,\"value\":\"Illustration of the hierarchy toggle enabled when grouping is applied in the List View.\"}],\"jira-nin-grouping-with-hierarchy-spotlight.spotlightManageHierarchyDescription\":[{\"type\":0,\"value\":\"To manage hierarchy, select \"},{\"children\":[{\"type\":0,\"value\":\"More actions (...)\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" at the top-right of your list.\"}],\"jira-nin-grouping-with-hierarchy-spotlight.spotlightSeeRelationshipsDescription\":[{\"type\":0,\"value\":\"See relationships between work items when you group the list view.\"}],\"jira-nin-paid-list-merge-modal-onboarding.closeButton\":[{\"type\":0,\"value\":\"Close\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsDescriptionContentRefresh\":[{\"type\":0,\"value\":\"Want to use the same settings that you're currently using in List? This includes filters, groups and columns you've set.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltText\":[{\"type\":0,\"value\":\"Illustration of multiple spaces stacked to show everything will migrate together.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextCurrentSpace\":[{\"type\":0,\"value\":\"Illustration of a single space showing the list settings will migrate to the new view.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextNo\":[{\"type\":0,\"value\":\"Illustration of a cursor selecting the More actions menu to choose migrate later.\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoContentRefresh\":[{\"type\":0,\"value\":\"Don't apply current settings\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoDescriptionContentRefresh\":[{\"type\":0,\"value\":\"Update settings later in More actions (...)\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesAllSpacesContentRefresh\":[{\"type\":0,\"value\":\"Apply current settings for all spaces I use\"}],\"jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesSingleSpaceContentRefresh\":[{\"type\":0,\"value\":\"Apply current settings for \"},{\"type\":1,\"value\":\"spaceName\"},{\"type\":0,\"value\":\" space only\"}],\"jira-nin-paid-list-merge-modal-onboarding.descriptionContentRefresh\":[{\"type\":0,\"value\":\"We've combined the best of List and All work into \"},{\"children\":[{\"type\":0,\"value\":\"one powerful, unified view for managing work items.\"}],\"type\":8,\"value\":\"link\"}],\"jira-nin-paid-list-merge-modal-onboarding.headingContentRefresh\":[{\"type\":0,\"value\":\"A single, more powerful List view\"}],\"jira-nin-paid-list-merge-modal-onboarding.spaceNameFallback\":[{\"type\":0,\"value\":\"current\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.apply-settings-button-label\":[{\"type\":0,\"value\":\"Apply settings\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.explore-list-view-button-label\":[{\"type\":0,\"value\":\"Explore List view\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.filter\":[{\"type\":0,\"value\":\"Search, filter, and group work items to quickly find what you need.\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.more-actions\":[{\"type\":0,\"value\":\"Adjust how you visualise the work with charts and format rules. You can also apply your old list settings.\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-nin-paid-list-merge-modal-onboarding.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.ok\":[{\"type\":0,\"value\":\"OK\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.text\":[{\"type\":0,\"value\":\"Find work faster using filters.\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.text.advanced.jql\":[{\"type\":0,\"value\":\"Select advanced or JQL mode to filter by more fields.\"}],\"jira.nin.filter.refinement.filter-popup.changeboarding.title\":[{\"type\":0,\"value\":\"A new home for filters\"}]}");

});

parcelRegister("1NYRC", function(module, exports) {

let $1509945a515c47ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1509945a515c47ab$var$load("iVXva").then(()=>parcelRequire('b9HNL'));

});

parcelRegister("dYrYA", function(module, exports) {

let $a2c6947330d56774$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a2c6947330d56774$var$load("irtvq").then(()=>parcelRequire('6XNbh'));

});

parcelRegister("kEZZO", function(module, exports) {

let $f0a7a2302a401ef1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0a7a2302a401ef1$var$load("fBFci").then(()=>parcelRequire('kkxvM'));

});

parcelRegister("if7BP", function(module, exports) {

let $d47f87b6b95d47f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d47f87b6b95d47f4$var$load("l6dWA").then(()=>parcelRequire('h7n9s'));

});

parcelRegister("gkAL1", function(module, exports) {

let $be3b06da2deb4d49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be3b06da2deb4d49$var$load("5gsdi").then(()=>parcelRequire('lTUxC'));

});

parcelRegister("galxv", function(module, exports) {

let $bc4e49c79daa0be0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bc4e49c79daa0be0$var$load("f5JIU").then(()=>parcelRequire('i1B53'));

});

parcelRegister("1KbcF", function(module, exports) {

let $1452c7138e146f03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1452c7138e146f03$var$load("c8CAi").then(()=>parcelRequire('g9ImX'));

});

parcelRegister("5R3U2", function(module, exports) {

let $4434ee088297eb9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4434ee088297eb9e$var$load("1aYtX").then(()=>parcelRequire('e6Toy'));

});

parcelRegister("gbJYL", function(module, exports) {

let $bc9156ea5e5a72ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bc9156ea5e5a72ec$var$load("gSKQp").then(()=>parcelRequire('5mgu9'));

});

parcelRegister("cdHiZ", function(module, exports) {

let $8e584a758ca19dab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e584a758ca19dab$var$load("32AUX").then(()=>parcelRequire('039Sx'));

});

parcelRegister("ULOdL", function(module, exports) {

let $0aaa50f3cf9e69e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0aaa50f3cf9e69e2$var$load("dovy2").then(()=>parcelRequire('9WKzB'));

});

parcelRegister("iJaMK", function(module, exports) {

let $da24cbb27379bdfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da24cbb27379bdfd$var$load("7j92c").then(()=>parcelRequire('lFVl2'));

});

parcelRegister("2Tui6", function(module, exports) {

let $21b837021e579aa1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21b837021e579aa1$var$load("9fqkh").then(()=>parcelRequire('688Nc'));

});

parcelRegister("dCK44", function(module, exports) {

let $9eb28e6e6554f28b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9eb28e6e6554f28b$var$load("gjImt").then(()=>parcelRequire('gJavF'));

});

parcelRegister("1aPXW", function(module, exports) {

let $0daf08f037851ae5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0daf08f037851ae5$var$load("dtXUg").then(()=>parcelRequire('gLzQ7'));

});

parcelRegister("bs5bi", function(module, exports) {

let $8566541fa57a82f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8566541fa57a82f1$var$load("9eMDo").then(()=>parcelRequire('kxY57'));

});

parcelRegister("f9TiZ", function(module, exports) {

let $b09298bb402a25fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b09298bb402a25fc$var$load("8LOW4").then(()=>parcelRequire('86c8j'));

});

parcelRegister("cS71P", function(module, exports) {

let $95effaea00b8df72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95effaea00b8df72$var$load("khT8i").then(()=>parcelRequire('hxhBB'));

});

parcelRegister("bHpBu", function(module, exports) {

let $88479239f9e1047a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88479239f9e1047a$var$load("9uQpw").then(()=>parcelRequire('7z7s1'));

});

parcelRegister("gc3W0", function(module, exports) {

let $bca0d1a3f0289a1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bca0d1a3f0289a1e$var$load("iLKT4").then(()=>parcelRequire('aZcUb'));

});

parcelRegister("cW099", function(module, exports) {

let $96ab03f03010a99d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96ab03f03010a99d$var$load("dyn4Q").then(()=>parcelRequire('L00gy'));

});

parcelRegister("1iQtT", function(module, exports) {

let $0f302e8c78e90feb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f302e8c78e90feb$var$load("6guFg").then(()=>parcelRequire('BAU7q'));

});

parcelRegister("dQkcb", function(module, exports) {

let $a13fcc19e26c235d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a13fcc19e26c235d$var$load("gOLRZ").then(()=>parcelRequire('6CFYe'));

});

parcelRegister("eCQlI", function(module, exports) {

let $aa5d38cb876fac08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa5d38cb876fac08$var$load("65ciN").then(()=>parcelRequire('eML1P'));

});

parcelRegister("8erZp", function(module, exports) {

let $5fe557aa05bffc40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5fe557aa05bffc40$var$load("f8r36").then(()=>parcelRequire('7LA0I'));

});

parcelRegister("4nl4V", function(module, exports) {

let $32f9a92ab8a3ade9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32f9a92ab8a3ade9$var$load("4kLmh").then(()=>parcelRequire('aowbr'));

});

parcelRegister("abr61", function(module, exports) {

let $769ff32a8bde94d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $769ff32a8bde94d0$var$load("3vCNW").then(()=>parcelRequire('5OEnJ'));

});

parcelRegister("aJo6X", function(module, exports) {

let $7d00cf53cffb71af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d00cf53cffb71af$var$load("iQ3Co").then(()=>parcelRequire('7AjxY'));

});

parcelRegister("gqVEY", function(module, exports) {

let $bf6bcd1ef8e65af4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf6bcd1ef8e65af4$var$load("lHDFC").then(()=>parcelRequire('2Qcwu'));

});

parcelRegister("85Yqg", function(module, exports) {

let $5e4da906838252a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e4da906838252a2$var$load("76GMf").then(()=>parcelRequire('ggbRv'));

});

parcelRegister("3AeHJ", function(module, exports) {

let $29c023db4f990c65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29c023db4f990c65$var$load("liQTV").then(()=>parcelRequire('3faZa'));

});

parcelRegister("55eKA", function(module, exports) {

let $3b38dc7be41904b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b38dc7be41904b3$var$load("fwU2z").then(()=>parcelRequire('hLvCO'));

});

parcelRegister("1iVmS", function(module, exports) {

let $0f33f8f54472a1fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f33f8f54472a1fc$var$load("fgDVq").then(()=>parcelRequire('B1a5R'));

});

parcelRegister("ed1DR", function(module, exports) {

let $a5838da50538774f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5838da50538774f$var$load("8RZLP").then(()=>parcelRequire('5nggI'));

});

parcelRegister("8eaIp", function(module, exports) {
module.exports = JSON.parse("{\"jira-pandora.common.footer.address.no-translate\":[{\"type\":0,\"value\":\"341 George Street, Sydney, NSW, 2000, Australia\"}],\"jira-pandora.common.footer.copyright.no-translate\":[{\"type\":0,\"value\":\"Copyright 2025 Atlassian Pty Ltd. All rights reserved.\"}],\"jira-pandora.common.project-access-email.banner.alt\":[{\"type\":0,\"value\":\"Jira banner image\"}],\"jira-pandora.jira-project-access-granted.email.body.content\":[{\"type\":0,\"value\":\"You can now access \"},{\"children\":[{\"type\":1,\"value\":\"projectName\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-granted.email.body.redacted.content\":[{\"children\":[{\"type\":0,\"value\":\"You can now access your Jira project\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-granted.email.button.redacted.text\":[{\"type\":0,\"value\":\"View project\"}],\"jira-pandora.jira-project-access-granted.email.button.text\":[{\"type\":0,\"value\":\"View project\"}],\"jira-pandora.jira-project-access-granted.message-template.email.redacted.subject\":[{\"type\":0,\"value\":\"You've been granted access to your project\"}],\"jira-pandora.jira-project-access-granted.message-template.email.subject\":[{\"type\":0,\"value\":\"You've been granted access to \"},{\"type\":1,\"value\":\"projectName\"}],\"jira-pandora.jira-project-access-request-reminder.email.body.content\":[{\"type\":0,\"value\":\"Users have requested to join \"},{\"children\":[{\"type\":1,\"value\":\"projectName\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" project\"}],\"jira-pandora.jira-project-access-request-reminder.email.body.redacted.content\":[{\"children\":[{\"type\":0,\"value\":\"Users have requested to join your Jira project\"}],\"type\":8,\"value\":\"b\"}],\"jira-pandora.jira-project-access-request-reminder.email.button.redacted.text\":[{\"type\":0,\"value\":\"View access requests\"}],\"jira-pandora.jira-project-access-request-reminder.email.button.text\":[{\"type\":0,\"value\":\"View access requests\"}],\"jira-pandora.jira-project-access-request-reminder.message-template.email.redacted.subject\":[{\"type\":0,\"value\":\"Access request for your project\"}],\"jira-pandora.jira-project-access-request-reminder.message-template.email.subject\":[{\"type\":0,\"value\":\"Access request for \"},{\"type\":1,\"value\":\"projectName\"}],\"jira-sprints-auto-managed-feature-discovery.spotlight-content\":[{\"type\":0,\"value\":\"Sprints can now start and complete automatically based on their scheduled dates.\"}],\"jira-sprints-auto-managed-feature-discovery.spotlight-cta-button-label\":[{\"type\":0,\"value\":\"See how\"}],\"jira-sprints-auto-managed-feature-discovery.spotlight-headline\":[{\"type\":0,\"value\":\"Automate your sprint transitions\"}]}");

});

parcelRegister("8soQH", function(module, exports) {

let $628436b8e8e8eaf8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $628436b8e8e8eaf8$var$load("ks76h").then(()=>parcelRequire('45V88'));

});

parcelRegister("AcmB1", function(module, exports) {

let $06ccf4081353d32a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $06ccf4081353d32a$var$load("fzTL1").then(()=>parcelRequire('7akKj'));

});

parcelRegister("eBZC4", function(module, exports) {

let $aa345078086aa5b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa345078086aa5b6$var$load("42exk").then(()=>parcelRequire('lKCMg'));

});

parcelRegister("aQguK", function(module, exports) {

let $7e4b8e44f8036bdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e4b8e44f8036bdc$var$load("dkLpW").then(()=>parcelRequire('ijhOv'));

});

parcelRegister("34B0a", function(module, exports) {

let $23ce729a58c03ca4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23ce729a58c03ca4$var$load("eWmKu").then(()=>parcelRequire('cBAaP'));

});

parcelRegister("cxnmS", function(module, exports) {

let $920ab18013b0f7f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $920ab18013b0f7f8$var$load("jt6Nc").then(()=>parcelRequire('1nEI6'));

});

parcelRegister("4EYTl", function(module, exports) {

let $364a21ad792f719a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $364a21ad792f719a$var$load("lqf4p").then(()=>parcelRequire('2DoLm'));

});

parcelRegister("bJtGs", function(module, exports) {

let $88aaec3e6f4d3912$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88aaec3e6f4d3912$var$load("c45pb").then(()=>parcelRequire('y1Wnl'));

});

parcelRegister("j11u3", function(module, exports) {

let $dd7f42f8d84f45ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd7f42f8d84f45ee$var$load("7eyPa").then(()=>parcelRequire('bvpLA'));

});

parcelRegister("4Iu9a", function(module, exports) {

let $36f2a803ed4a3c32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $36f2a803ed4a3c32$var$load("O2IGv").then(()=>parcelRequire('9lbqx'));

});

parcelRegister("2Nl1L", function(module, exports) {

let $209077fe3f5a3c5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $209077fe3f5a3c5c$var$load("62Ypr").then(()=>parcelRequire('cifrM'));

});

parcelRegister("iFn6p", function(module, exports) {

let $d96df9f5e0fa655f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d96df9f5e0fa655f$var$load("csjms").then(()=>parcelRequire('21RiV'));

});

parcelRegister("b3s7K", function(module, exports) {

let $80c5ca5ceb491d87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80c5ca5ceb491d87$var$load("gbVrg").then(()=>parcelRequire('7sMrv'));

});

parcelRegister("1TvLV", function(module, exports) {

let $161392c6bbc05a47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $161392c6bbc05a47$var$load("1sYxz").then(()=>parcelRequire('ebWgz'));

});

parcelRegister("f2hYx", function(module, exports) {

let $af24fc72b5ddd3d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $af24fc72b5ddd3d5$var$load("fzXBH").then(()=>parcelRequire('bK0aF'));

});

parcelRegister("4CBdR", function(module, exports) {

let $35d795a27addcd23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35d795a27addcd23$var$load("5wMyt").then(()=>parcelRequire('hh8kS'));

});

parcelRegister("1RKr2", function(module, exports) {

let $15bec2b593e79cc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $15bec2b593e79cc8$var$load("cHRYh").then(()=>parcelRequire('cpvvm'));

});

parcelRegister("bhjSn", function(module, exports) {

let $8360b32f307ad8d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8360b32f307ad8d8$var$load("1GUTB").then(()=>parcelRequire('8lmTs'));

});

parcelRegister("9bBvZ", function(module, exports) {

let $6b023dcd7b78e012$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b023dcd7b78e012$var$load("02nNU").then(()=>parcelRequire('ez1g9'));

});

parcelRegister("lHU96", function(module, exports) {

let $fcd92a84b6f9ea7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fcd92a84b6f9ea7a$var$load("1mlos").then(()=>parcelRequire('jaOZS'));

});

parcelRegister("7uvFj", function(module, exports) {

let $5743e5d6930650cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5743e5d6930650cf$var$load("6d23n").then(()=>parcelRequire('f9TVv'));

});

parcelRegister("845sW", function(module, exports) {

let $5df2efd6bd97e0ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5df2efd6bd97e0ad$var$load("he9IT").then(()=>parcelRequire('6ALbD'));

});

parcelRegister("gu9bW", function(module, exports) {

let $c00693f1a5aed643$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c00693f1a5aed643$var$load("bs9oy").then(()=>parcelRequire('iHbmF'));

});

parcelRegister("2jE4Q", function(module, exports) {

let $1afc7199fc8a1221$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1afc7199fc8a1221$var$load("l9cUJ").then(()=>parcelRequire('l8TDJ'));

});

parcelRegister("fXcft", function(module, exports) {

let $b9d5de07414b1cc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b9d5de07414b1cc2$var$load("4Mr42").then(()=>parcelRequire('0UymV'));

});

parcelRegister("iQ2Vw", function(module, exports) {

let $db6f5a8b38850674$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db6f5a8b38850674$var$load("3TuC7").then(()=>parcelRequire('6lyud'));

});

parcelRegister("gtYuO", function(module, exports) {

let $bffe4800c3d63df7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bffe4800c3d63df7$var$load("5B1VR").then(()=>parcelRequire('jdBzR'));

});

parcelRegister("asYPk", function(module, exports) {

let $79ebb3dfc5515bc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79ebb3dfc5515bc1$var$load("i3DnP").then(()=>parcelRequire('3vVaC'));

});

parcelRegister("3jL6F", function(module, exports) {

let $26a7afd84de512ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26a7afd84de512ac$var$load("6M7E7").then(()=>parcelRequire('DaM6a'));

});

parcelRegister("dt5Ek", function(module, exports) {

let $9ce25dad1436faff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ce25dad1436faff$var$load("aJZ5d").then(()=>parcelRequire('ezVkX'));

});

parcelRegister("8CrAA", function(module, exports) {

let $646745fa2207cf38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $646745fa2207cf38$var$load("jkveD").then(()=>parcelRequire('lLkdp'));

});

parcelRegister("5Xak2", function(module, exports) {

let $455a7830a7586ba0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $455a7830a7586ba0$var$load("ib8vr").then(()=>parcelRequire('5L5lX'));

});

parcelRegister("2x03E", function(module, exports) {

let $1d7eb55452c561f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d7eb55452c561f4$var$load("llprT").then(()=>parcelRequire('58Kxq'));

});

parcelRegister("4a5zq", function(module, exports) {

let $307c6ac0f5b5f612$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $307c6ac0f5b5f612$var$load("ftS0S").then(()=>parcelRequire('3XMWt'));

});

parcelRegister("8Wdqe", function(module, exports) {
module.exports = JSON.parse('{"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.cta-button":[{"type":0,"value":"View your plan"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.header-title":[{"type":0,"value":"Your plan is waiting for you!"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.intro-paragraph-1":[{"type":0,"value":"Getting started is the hardest step, and you\'ve already done that! Your plan "},{"type":1,"value":"planTitle"},{"type":0,"value":" is waiting for you to unlock its full potential!"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.intro-paragraph-2":[{"type":0,"value":"Whether you\'re managing a product launch or tracking bugs, Jira Plans offers powerful planning tools to help your and your team stay organized, track progress, and keep everyone aligned. It can help you:"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.see-big-picture-description":[{"type":0,"value":"View work from all your teams teams, spaces, and releases in one easy-to-read Timeline view. "}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.see-big-picture-link":[{"type":0,"value":"Open the Timeline view."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.see-big-picture-title":[{"type":0,"value":"See the big picture"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.take-it-day-by-day-description":[{"type":0,"value":"Share important dates from your plan with stakeholders using the Calendar view."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.take-it-day-by-day-link":[{"type":0,"value":"Open the Calendar view."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.take-it-day-by-day-title":[{"type":0,"value":"Take it day-by-day"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.transparency-for-all-description":[{"type":0,"value":"Track work that\'s blocked by other work using the Dependencies view, and resolve conflicts before they become problems."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.transparency-for-all-link":[{"type":0,"value":"Open the Dependencies view."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.transparency-for-all-title":[{"type":0,"value":"Transparency for all"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.visualize-your-progress-description":[{"type":0,"value":"Keep your finger on the pulse with the Summary view to avoid surprises and keep delivery on track."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.visualize-your-progress-link":[{"type":0,"value":"Open your Summary view."}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.visualize-your-progress-title":[{"type":0,"value":"Visualize your progress"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.blog":[{"type":0,"value":"Read our blog"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.contact-us":[{"type":0,"value":"Contact Us"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"currentYear"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.join-atlassian-community":[{"type":0,"value":"Join Atlassian Community"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.footer.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"jira-chronos.jira-plan-created-reminder-experiment-deep-links.message-template.email.subject":[{"type":0,"value":"Plan and track complex work confidently in "},{"type":1,"value":"planTitle"},{"type":0,"value":" in a few easy steps"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.cta-button":[{"type":0,"value":"View your plan"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.header-title":[{"type":0,"value":"Your plan is waiting for you!"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.intro-paragraph-1":[{"type":0,"value":"Getting started is the hardest step, and you\'ve already done that! Your plan "},{"type":1,"value":"planTitle"},{"type":0,"value":" is waiting for you to unlock its full potential!"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.intro-paragraph-2":[{"type":0,"value":"Whether you\'re managing a product launch or tracking bugs, Jira Plans offers powerful planning tools to help your and your team stay organized, track progress, and keep everyone aligned. It can help you:"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.see-big-picture-description":[{"type":0,"value":"View work from all your teams teams, spaces, and releases in one easy-to-read Timeline view. "}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.see-big-picture-read-more":[{"type":0,"value":"Read more."}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.see-big-picture-title":[{"type":0,"value":"See the big picture"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.spread-the-load-description":[{"type":0,"value":"Balance the workload among your teams to create an achievable yet realistic delivery plan. "}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.spread-the-load-read-more":[{"type":0,"value":"Read more."}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.spread-the-load-title":[{"type":0,"value":"Spread the load"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.transparency-for-all-description":[{"type":0,"value":"Track work that\'s blocked by other work using the Dependencies view, and resolve conflicts before they become problems. "}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.transparency-for-all-read-more":[{"type":0,"value":"Read more."}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.transparency-for-all-title":[{"type":0,"value":"Transparency for all"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.visualize-your-progress-description":[{"type":0,"value":"Keep your finger on the pulse with the Summary view to avoid surprises and keep delivery on track. "}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.visualize-your-progress-read-more":[{"type":0,"value":"Read more."}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.visualize-your-progress-title":[{"type":0,"value":"Visualize your progress"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.blog":[{"type":0,"value":"Read our blog"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.contact-us":[{"type":0,"value":"Contact Us"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"currentYear"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.join-atlassian-community":[{"type":0,"value":"Join Atlassian Community"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.footer.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"jira-chronos.jira-plan-created-reminder-experiment-doc-links.message-template.email.subject":[{"type":0,"value":"Plan and track complex work confidently in "},{"type":1,"value":"planTitle"},{"type":0,"value":" in a few easy steps"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.cta-button":[{"type":0,"value":"View your plan"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.header-title":[{"type":0,"value":"Your plan is waiting for you!"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.intro-paragraph-1":[{"type":0,"value":"Getting started is the hardest step, and you\'ve already done that! Your plan "},{"type":1,"value":"planTitle"},{"type":0,"value":" is waiting for you to unlock its full potential!"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.intro-paragraph-2":[{"type":0,"value":"Whether you\'re managing a product launch or tracking bugs, Jira Plans offers powerful planning tools to help your and your team stay organized, track progress, and keep everyone aligned. It can help you:"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.see-big-picture-description":[{"type":0,"value":"View work from all your teams teams, spaces, and releases in one easy-to-read Timeline view."}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.see-big-picture-title":[{"type":0,"value":"See the big picture"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.stay-realistic-description":[{"type":0,"value":"Balance the workload among your teams to create an achievable yet realistic delivery plan."}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.stay-realistic-title":[{"type":0,"value":"Spread the load"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.take-it-day-by-day-description":[{"type":0,"value":"Share important dates from your plan with stakeholders using the Calendar view."}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.take-it-day-by-day-title":[{"type":0,"value":"Take it day-by-day"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.transparency-for-all-description":[{"type":0,"value":"Track work that\'s blocked by other work using the Dependencies view, and resolve conflicts before they become problems."}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.transparency-for-all-title":[{"type":0,"value":"Transparency for all"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.visualize-your-progress-description":[{"type":0,"value":"Keep your finger on the pulse with the Summary view to avoid surprises and keep delivery on track."}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.visualize-your-progress-title":[{"type":0,"value":"Visualize your progress"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.blog":[{"type":0,"value":"Read our blog"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.contact-us":[{"type":0,"value":"Contact Us"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"currentYear"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.join-atlassian-community":[{"type":0,"value":"Join Atlassian Community"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.footer.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"jira-chronos.jira-plan-created-reminder-experiment-single-cta.message-template.email.subject":[{"type":0,"value":"Plan and track complex work confidently in "},{"type":1,"value":"planTitle"},{"type":0,"value":" in a few easy steps"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.avatar.no-translate":[{"type":0,"value":"avatar"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.globe.no-translate":[{"type":0,"value":"globeLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"planTitle"},{"type":0,"value":" "}],"type":8,"value":"b"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.join.link":[{"type":0,"value":"Join the Plan"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.learn.more.message":[{"type":0,"value":"Learn more about Jira"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.logo.no-translate":[{"type":0,"value":"logo"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template.dot":[{"type":0,"value":"."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"jira-chronos.jira-plans-user-invited.message-template.email.body.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"jira-chronos.jira-plans-user-invited.message-template.email.body.write.no-translate":[{"type":0,"value":"writeLogo"}],"jira-chronos.jira-plans-user-invited.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"planTitle"},{"type":0,"value":")"}],"jira-chronos.plan-calendar-create-item-spotlight.body":[{"type":0,"value":"Use + to create a work item without leaving the Calendar."}],"jira-chronos.plan-calendar-create-item-spotlight.done":[{"type":0,"value":"Done"}],"jira-chronos.plan-calendar-create-item-spotlight.header":[{"type":0,"value":"Add here, view here"}],"jira-plan-created-reminder-experiment.action":[{"type":0,"value":"View plan"}],"jira-plan-created-reminder-experiment.body":[{"type":0,"value":"View your plan from end-to-end and get insights to help you move forward. Your plan can do it all!"}],"jira-plan-created-reminder-experiment.title":[{"type":1,"value":"planTitle"},{"type":0,"value":" is waiting for you in Jira"}],"jira-plans-efa-change-boarding.message-templates.flag.description":[{"type":0,"value":"Fields that aren\u2019t part of a space\u2019s configuration can no longer be used in your plan. Add those fields to your space to use them again."}],"jira-plans-efa-change-boarding.message-templates.flag.goToSettings":[{"type":0,"value":"Go to settings"}],"jira-plans-efa-change-boarding.message-templates.flag.read-more":[{"type":0,"value":"Read more"}],"jira-plans-efa-change-boarding.message-templates.flag.title":[{"type":0,"value":"Some fields in your plan may be deactivated."}]}');

});

parcelRegister("9VKWU", function(module, exports) {

let $73addb0820ce0cdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73addb0820ce0cdd$var$load("bFOLQ").then(()=>parcelRequire('jz6EW'));

});

parcelRegister("eEiCw", function(module, exports) {

let $aaa33ebe332c61ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aaa33ebe332c61ca$var$load("gZdcf").then(()=>parcelRequire('kJZys'));

});

parcelRegister("9JB41", function(module, exports) {

let $716511294ed5e6ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $716511294ed5e6ff$var$load("5XZYg").then(()=>parcelRequire('kELyd'));

});

parcelRegister("hV07a", function(module, exports) {

let $d0b7d94b8fb36f2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d0b7d94b8fb36f2b$var$load("8606Q").then(()=>parcelRequire('ccqVV'));

});

parcelRegister("gDq2e", function(module, exports) {

let $c1c47bdcdec51882$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c1c47bdcdec51882$var$load("iXY8o").then(()=>parcelRequire('2yT3X'));

});

parcelRegister("6bPds", function(module, exports) {

let $481b7f9e207b260c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $481b7f9e207b260c$var$load("aZgVL").then(()=>parcelRequire('JpnY2'));

});

parcelRegister("ecgTI", function(module, exports) {

let $02aad3cb334bf3af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $02aad3cb334bf3af$var$load("Opl2l").then(()=>parcelRequire('ixj8r'));

});

parcelRegister("6o8ua", function(module, exports) {

let $4a6b910c98f1dd38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a6b910c98f1dd38$var$load("6riHk").then(()=>parcelRequire('jXtba'));

});

parcelRegister("9QeTC", function(module, exports) {

let $72a486760866dc0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72a486760866dc0f$var$load("9YQYw").then(()=>parcelRequire('8HhNv'));

});

parcelRegister("8bUPH", function(module, exports) {

let $5f6b6f9d6980b45e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f6b6f9d6980b45e$var$load("ejbGK").then(()=>parcelRequire('4WZyG'));

});

parcelRegister("jydp9", function(module, exports) {

let $e3bb97287526de48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3bb97287526de48$var$load("6mjPT").then(()=>parcelRequire('3sE2m'));

});

parcelRegister("iloKM", function(module, exports) {

let $d5ad63b3d02b364a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5ad63b3d02b364a$var$load("epOmi").then(()=>parcelRequire('calXt'));

});

parcelRegister("dfyFv", function(module, exports) {

let $9a579187f46248ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a579187f46248ef$var$load("4WDAC").then(()=>parcelRequire('aDy4u'));

});

parcelRegister("kENzV", function(module, exports) {

let $f09e004da05b6026$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f09e004da05b6026$var$load("4qLQo").then(()=>parcelRequire('fKdvz'));

});

parcelRegister("6eell", function(module, exports) {

let $488f2d28f5fa2101$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $488f2d28f5fa2101$var$load("kX7CO").then(()=>parcelRequire('gbuK8'));

});

parcelRegister("1YD3M", function(module, exports) {

let $1709b18b46093cf4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1709b18b46093cf4$var$load("kVmkh").then(()=>parcelRequire('iiIWy'));

});

parcelRegister("4kGYK", function(module, exports) {

let $327a5e60fc471d5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $327a5e60fc471d5f$var$load("dta3s").then(()=>parcelRequire('6EtFI'));

});

parcelRegister("4Hq5s", function(module, exports) {

let $36bf69e7ec920a2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $36bf69e7ec920a2a$var$load("cU1bg").then(()=>parcelRequire('31Mvf'));

});

parcelRegister("6Fddj", function(module, exports) {

let $4da0d26483d99cb6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4da0d26483d99cb6$var$load("jixIn").then(()=>parcelRequire('b8C5r'));

});

parcelRegister("6BShP", function(module, exports) {

let $4d004ef65d82b7b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d004ef65d82b7b8$var$load("dnADU").then(()=>parcelRequire('lMHbT'));

});

parcelRegister("67yyE", function(module, exports) {

let $474e33f9eacecc73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $474e33f9eacecc73$var$load("lGjdm").then(()=>parcelRequire('2aBLw'));

});

parcelRegister("El8YA", function(module, exports) {

let $07942341592f7cea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07942341592f7cea$var$load("lln6F").then(()=>parcelRequire('i6sCI'));

});

parcelRegister("eYNBw", function(module, exports) {

let $ae7d25a50307b6fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae7d25a50307b6fe$var$load("hQkGr").then(()=>parcelRequire('aQ86W'));

});

parcelRegister("dEblD", function(module, exports) {

let $9ef7d0457ffc7b29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ef7d0457ffc7b29$var$load("aWeYx").then(()=>parcelRequire('5kIN6'));

});

parcelRegister("jh6sZ", function(module, exports) {

let $e0849eff528e9b9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0849eff528e9b9b$var$load("fyJlv").then(()=>parcelRequire('kwNO6'));

});

parcelRegister("eAgqe", function(module, exports) {

let $a9e12a9079550183$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9e12a9079550183$var$load("6RpIk").then(()=>parcelRequire('1QaNg'));

});

parcelRegister("7LJh0", function(module, exports) {

let $5a800a8570381111$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a800a8570381111$var$load("bV9I0").then(()=>parcelRequire('fROot'));

});

parcelRegister("aqwUD", function(module, exports) {

let $7975dcd4c42a666f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7975dcd4c42a666f$var$load("9Eycr").then(()=>parcelRequire('jb76V'));

});

parcelRegister("2JiTe", function(module, exports) {

let $1fce6fd8b2d94118$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fce6fd8b2d94118$var$load("5wUQd").then(()=>parcelRequire('4s9GW'));

});

parcelRegister("4gyuP", function(module, exports) {

let $31b36a4d0f3d182b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31b36a4d0f3d182b$var$load("akLPz").then(()=>parcelRequire('8N9fs'));

});

parcelRegister("2cyZP", function(module, exports) {

let $19a7d945ea0dea26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19a7d945ea0dea26$var$load("6yBZZ").then(()=>parcelRequire('huhfR'));

});

parcelRegister("hhfGW", function(module, exports) {

let $c94032366bea9084$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c94032366bea9084$var$load("jKEvE").then(()=>parcelRequire('3RgGT'));

});

parcelRegister("gvgJi", function(module, exports) {

let $c03c84c37c5f8f3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c03c84c37c5f8f3d$var$load("jqOKH").then(()=>parcelRequire('acqAM'));

});

parcelRegister("btEIp", function(module, exports) {

let $85b1fc5592c7c3aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85b1fc5592c7c3aa$var$load("98LiC").then(()=>parcelRequire('1dTgQ'));

});

parcelRegister("6Ey85", function(module, exports) {
module.exports = JSON.parse('{"ai-rovo.actions-software-backlog.nudge-description.nonfinal":[{"type":0,"value":"We have identified "},{"type":1,"value":"numberOfSuggestions"},{"type":0,"value":" work item "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"update"}]},"other":{"value":[{"type":0,"value":"updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfSuggestions"}],"ai-rovo.actions-software-backlog.nudge-icon-label.nonfinal":[{"type":0,"value":"Work items icon"}],"ai-rovo.actions-software-backlog.nudge-title.nonfinal":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfSuggestions"},{"type":0,"value":" work item "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"update"}]},"other":{"value":[{"type":0,"value":"updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfSuggestions"}],"jira-issueview-quickactions.src.ui.index.recommended-for-you":[{"type":0,"value":"Recommended for you"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.now":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.soon":[{"type":0,"value":"Jira \'projects\' will soon be renamed \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.learn-more":[{"type":0,"value":"Read more about this change"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.now":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.soon":[{"type":0,"value":"Coming soon"}],"jira-pulsar.common.components.cross-flow.add":[{"type":0,"value":"Add"}],"jira-pulsar.common.components.cross-flow.dismiss":[{"type":0,"value":"Dismiss"}],"jira-pulsar.common.components.issue-view-description-ad.close":[{"type":0,"value":"Close"}],"jira-pulsar.jira-comment-mention.message-template.notification-drawer.message":[{"type":1,"value":"user1"},{"type":0,"value":" mentioned you in a comment"}],"jira-pulsar.jira-comment-mention.message-template.notification-drawer.message.anonymous":[{"type":0,"value":"You\'ve been mentioned in a comment"}],"jira-pulsar.jira-common.celebration-icon.body_image_alt":[{"type":0,"value":"Celebration icon"}],"jira-pulsar.jira-common.exclamation-icon.body_image_alt":[{"type":0,"value":"Exclamation icon"}],"jira-pulsar.jira-common.jira-logo.alt_text":[{"type":0,"value":"Jira logo"}],"jira-pulsar.jira-common.message-template.text.body.display.old.field.value":[{"type":0,"value":"was: "},{"type":1,"value":"oldFieldValue"}],"jira-pulsar.jira-common.redesign.footer.atlassian-logo.no-translate":[{"type":0,"value":"Atlassian logo"}],"jira-pulsar.jira-common.right-arrow-icon.no-translate":[{"type":0,"value":"&#x2192;"}],"jira-pulsar.jira-contact-admin.message-template.email.body.from.contact.admin":[{"type":0,"value":"From:"}],"jira-pulsar.jira-contact-admin.message-template.email.body.new.message.from.contact.admin":[{"type":0,"value":"New message from Contact Administrators page"}],"jira-pulsar.jira-contact-admin.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"}],"jira-pulsar.jira-issue-approval-decided.right.arrow.image.alt.no-translate":[{"type":0,"value":"->"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers.plus.no-translate":[{"type":0,"value":"+"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.subject":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.declined.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required":[{"type":1,"value":"issueLink"},{"type":0,"value":" requires your approval"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira-pulsar.jira-issue-approval.message-template.email.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-archived.message-template.redacted.email.subject":[{"type":0,"value":"("},{"type":1,"value":"issueKey"},{"type":0,"value":") work item was archived"}],"jira-pulsar.jira-issue-assign.message-template-template.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"assigned"}],"type":8,"value":"b"},{"type":0,"value":" this work item to you"}],"jira-pulsar.jira-issue-assign.message-template.email.html.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.assigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been assigned to "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.assigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.unassigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been unassigned from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.unassigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.anonymous":[{"type":0,"value":"There\'s a new assignee on an issue"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new assignee on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" to "},{"type":1,"value":"newAssignee"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assignee.change.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" to "},{"type":1,"value":"newAssignee"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.unassigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"The "},{"options":{"Bug":{"value":[{"type":0,"value":"bug\'s"}]},"Epic":{"value":[{"type":0,"value":"epic\'s"}]},"Generalrequest":{"value":[{"type":0,"value":"request\'s"}]},"Idea":{"value":[{"type":0,"value":"idea\'s"}]},"Story":{"value":[{"type":0,"value":"story\'s"}]},"Subtask":{"value":[{"type":0,"value":"subtask\'s"}]},"Task":{"value":[{"type":0,"value":"task\'s"}]},"other":{"value":[{"type":0,"value":"work item\'s"}]}},"type":5,"value":"issueType"},{"type":0,"value":" assignee has been removed"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.unassigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assigned.email.body.assignee":[{"type":0,"value":"Assignee"}],"jira-pulsar.jira-issue-assigned.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-comment-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-delete.message-template.hipppa.view.update":[{"type":0,"value":"Comment: "},{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-comment-delete.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment-update.email.body.added":[{"type":0,"value":"Added"}],"jira-pulsar.jira-issue-comment-update.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-comment-update.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira-pulsar.jira-issue-comment-update.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new update in a comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment-update.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" updated the comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment-update.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment.body_image_alt":[{"type":0,"value":"Icon for comment on a Jira issue"}],"jira-pulsar.jira-issue-comment.email.body.add-comment":[{"type":0,"value":"Add comment"}],"jira-pulsar.jira-issue-comment.email.body.view-comment":[{"type":0,"value":"View comment"}],"jira-pulsar.jira-issue-comment.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-comment.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-create.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-create.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" created "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-delete.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-mention.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been mentioned on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-mention.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user1"},{"type":0,"value":" mentioned you on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-moved.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-moved.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" Work item was updated"}],"jira-pulsar.jira-issue-reopen.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-pulsar.jira-issue-reopen.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"jira-pulsar.jira-issue-reopened.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-transitioned.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"options":{"Bug":{"value":[{"type":0,"value":"A bug"}]},"Epic":{"value":[{"type":0,"value":"An epic"}]},"Generalrequest":{"value":[{"type":0,"value":"A request"}]},"Idea":{"value":[{"type":0,"value":"An idea"}]},"Story":{"value":[{"type":0,"value":"A story"}]},"Subtask":{"value":[{"type":0,"value":"A subtask"}]},"Task":{"value":[{"type":0,"value":"A task"}]},"other":{"value":[{"type":0,"value":"A work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" has been transitioned from "},{"type":1,"value":"fromStatus"},{"type":0,"value":" to "},{"type":1,"value":"toStatus"}],"jira-pulsar.jira-issue-transitioned.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" changed "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"fromStatus"},{"type":0,"value":" to "},{"type":1,"value":"toStatus"}],"jira-pulsar.jira-issue-update.email.body.slash.no-translate":[{"type":0,"value":" \u2192 "}],"jira-pulsar.jira-issue-update.message-template.changeby":[{"type":0,"value":"Change by: "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.hipppa.view.update":[{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-work-started.message-template.email.body.started":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"started work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-started.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.body.stopped":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"stopped work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-worklog-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-delete.email.body.work.log.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.add.worklog.title":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a worklog"}],"type":8,"value":"strong"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"issueKey"}],"type":8,"value":"b"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.change.by":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.add.comment":[{"children":[{"type":0,"value":"Add Comment"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.description":[{"children":[{"type":0,"value":"View work description"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.entry.logged.by":[{"type":1,"value":"entry"},{"type":0,"value":" logged by "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklogged.body_image_alt":[{"type":0,"value":"Product logo"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.titleForIssueComment":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.page":[{"type":0,"value":"Page"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.idea":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Record a comment"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.descriptionForIssueDescription":[{"type":0,"value":"Use video to explain the work"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.titleForIssueDescription":[{"type":0,"value":"Record your screen"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.video":[{"type":0,"value":"Video"}],"jira.default.subject":[{"type":0,"value":"[JIRA] Project Update: "},{"type":1,"value":"projectName"},{"type":0,"value":" ("},{"type":1,"value":"projectKey"},{"type":0,"value":")"}],"jira.jira-bulk.message-template.email.header":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"sent you"}],"type":8,"value":"strong"},{"type":0,"value":" a message."}],"jira.jira-bulk.message-template.email.subject.user.provided.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"subject"}],"jira.jira-bulk.message-template.text.message":[{"type":1,"value":"user"},{"type":0,"value":" sent you a message"}],"jira.jira-common.email.addon-banner.gmail":[{"type":0,"value":"Gmail"}],"jira.jira-common.email.addon-banner.install-text":[{"type":0,"value":"Install the Atlassian email extension for "},{"type":1,"value":"gmailLink"},{"type":0,"value":" or "},{"type":1,"value":"outlookLink"},{"type":0,"value":"."}],"jira.jira-common.email.addon-banner.main-text":[{"type":0,"value":"Update work items without leaving your inbox."}],"jira.jira-common.email.addon-banner.opt-out":[{"type":0,"value":"Don\'t show again"}],"jira.jira-common.email.addon-banner.outlook":[{"type":0,"value":"Outlook"}],"jira.jira-common.email.addon-banner.tip":[{"type":0,"value":"Tip:"}],"jira.jira-common.email.dot-separator.no-translate":[{"type":0,"value":" \u2022 "}],"jira.jira-common.email.footer.custom.message":[{"type":1,"value":"footerText"}],"jira.jira-common.email.footer.download.app-store.no-translate":[{"type":0,"value":"Download on the App Store"}],"jira.jira-common.email.footer.get-on.google-play.no-translate":[{"type":0,"value":"Get it on Google Play"}],"jira.jira-common.email.footer.get.apps":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "}],"jira.jira-common.email.footer.get.apps.new":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"a1"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"a2"},{"type":0,"value":"."}],"jira.jira-common.email.footer.give.feedback":[{"type":0,"value":"Give feedback"}],"jira.jira-common.email.footer.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.email.footer.open.attachment":[{"type":0,"value":"Open the work item to view attachments over 100 KB"}],"jira.jira-common.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-common.email.footer.sent-by-atlassian-jira":[{"type":0,"value":"This email was sent by Atlassian Jira"}],"jira.jira-common.email.footer.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.email.footer.unsubscribe-message":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or unsubscribe "},{"children":[{"type":0,"value":"here"}],"type":8,"value":"link"},{"type":0,"value":"."}],"jira.jira-common.email.slash.no-translate":[{"type":0,"value":"/"}],"jira.jira-common.message-template.text.body.assignee.label":[{"type":0,"value":"Assignee:"}],"jira.jira-common.message-template.text.body.attachments.label":[{"type":0,"value":"Attachments:"}],"jira.jira-common.message-template.text.body.key.label":[{"type":0,"value":"Key:"}],"jira.jira-common.message-template.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.message-template.text.body.priority.label":[{"type":0,"value":"Priority:"}],"jira.jira-common.message-template.text.body.project.label":[{"type":0,"value":"Project:"}],"jira.jira-common.message-template.text.body.reporter.heading":[{"type":0,"value":"Reporter: "}],"jira.jira-common.message-template.text.body.reporter.label":[{"type":0,"value":"Reporter:"}],"jira.jira-common.message-template.text.body.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.message-template.text.body.work.type.label":[{"type":0,"value":"Work type:"}],"jira.jira-filter-subscription.message-template.email.table.filter-label":[{"type":0,"value":"Filter: "}],"jira.jira-filter-subscription.message-template.email.table.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-filter-subscription.message-template.email.table.subscriber-label":[{"type":0,"value":"Subscriber:"}],"jira.jira-issue-approval-decided.message-template.approval.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval-decided.message-template.approval.event.allapproved.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.plural":[{"type":1,"value":"remainingApprovals"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.singular":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.declined.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.declined.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval.message-template.approval.required.title":[{"type":1,"value":"issueLabel"},{"type":0,"value":" requires your approval"}],"jira.jira-issue-approval.message-template.approval.title.all-approved":[{"type":1,"value":"issueLink"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.approval.approved":[{"type":0,"value":"Approved"}],"jira.jira-issue-approval.message-template.email.approval.approvers.remaining":[{"type":1,"value":"remainingApprovers"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira.jira-issue-approval.message-template.email.approval.declined":[{"type":0,"value":"Declined"}],"jira.jira-issue-approval.message-template.email.approval.declined.transition":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"declinedStatus"}],"jira.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira.jira-issue-approval.message-template.email.approval.one.approver.remaining":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.view.work.item":[{"type":0,"value":"View "},{"type":1,"value":"issueType"}],"jira.jira-issue-approval.message-template.email.approved.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.declined.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.footer.contact.us":[{"type":0,"value":"Contact Us"}],"jira.jira-issue-approval.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira.jira-issue-approval.message-template.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-issue-approval.message-template.email.issue.approved":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.issue.has.moved.from":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-archived.message-template.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.redacted.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.text.archived.work.item":[{"type":1,"value":"user"},{"type":0,"value":" archived "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-assign.text.body.assigned":[{"type":0,"value":" "},{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"type":1,"value":"issueKey"}],"jira.jira-issue-assign.text.body.assignee.update":[{"type":0,"value":"Assignee: "},{"type":1,"value":"assigneeName"},{"type":0,"value":" was: ("},{"type":1,"value":"oldAssigneeName"},{"type":0,"value":")"}],"jira.jira-issue-assign.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-batch.email.body.issue.comments.heading":[{"type":0,"value":"Comments"}],"jira.jira-issue-batch.email.body.issue.created.heading":[{"type":0,"value":"Work item created"}],"jira.jira-issue-batch.email.body.issue.updates.heading":[{"type":0,"value":"Updates"}],"jira.jira-issue-batch.email.body.issue.worklog.heading":[{"type":0,"value":"Work log"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a new comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.created.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a work item"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work items"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.dot":[{"type":0,"value":". "}],"jira.jira-issue-batch.email.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.separator.comma":[{"type":0,"value":", "}],"jira.jira-issue-batch.email.body.summary.issue.updates.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"type":1,"value":"count"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.updates.multiple.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other person"}]},"other":{"value":[{"type":7},{"type":0,"value":" other people"}]}},"pluralType":"cardinal","type":6,"value":"userCount"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"an update"}]},"other":{"value":[{"type":1,"value":"count"},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.updates.two.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"user1"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"an update"}]},"other":{"value":[{"type":1,"value":"count"},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" started a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueId"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-batch.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] Updates for "},{"type":1,"value":"issueId"}],"jira.jira-issue-closed.message-template.email.body.closed":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.email.body.closed.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" closed "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment-delete.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-delete.message-template.text.comment.was.deleted":[{"type":0,"value":"Comment: was deleted"}],"jira.jira-issue-comment-delete.message-template.text.updated.work.item":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-comment-update.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"edited a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-update.message-template.text.body.comment.was":[{"type":0,"value":"was (Author: "},{"type":1,"value":"authorName"},{"type":0,"value":"):"}],"jira.jira-issue-comment-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" edited a comment on "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-common.message-template.text.body.common.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-common.message-template.text.body.common.issue.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-create.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-create.email.body.view.attachments":[{"type":0,"value":"View Attachments"}],"jira.jira-issue-create.email.body.view.components":[{"type":0,"value":"View Components"}],"jira.jira-issue-create.email.body.view.description":[{"type":0,"value":"View description"}],"jira.jira-issue-create.email.body.view.environment":[{"type":0,"value":"View environment"}],"jira.jira-issue-create.email.body.view.labels":[{"type":0,"value":"View labels"}],"jira.jira-issue-create.email.body.view.work.type":[{"type":0,"value":"View Work Type"}],"jira.jira-issue-create.message-template.email.original.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueKey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-create.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" created "},{"type":1,"value":"issueKey"}],"jira.jira-issue-create.message-template.text.body.common.issue.key":[{"type":0,"value":"Key"}],"jira.jira-issue-create.message-template.text.body.common.summary":[{"type":0,"value":"Summary"}],"jira.jira-issue-create.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"jira.jira-issue-create.text.body.common.assignee":[{"type":0,"value":"Assignee"}],"jira.jira-issue-create.text.body.common.attachments":[{"type":0,"value":"Attachments"}],"jira.jira-issue-create.text.body.common.created":[{"type":0,"value":"Created"}],"jira.jira-issue-create.text.body.common.description":[{"type":0,"value":"Description"}],"jira.jira-issue-create.text.body.common.priority":[{"type":0,"value":"Priority"}],"jira.jira-issue-create.text.body.common.reporter":[{"type":0,"value":"Reporter"}],"jira.jira-issue-create.text.body.common.status":[{"type":0,"value":"Status"}],"jira.jira-issue-create.text.body.common.work.type":[{"type":0,"value":"Work type"}],"jira.jira-issue-delete.message-template.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" deleted this work item at "},{"type":1,"value":"timestamp"}],"jira.jira-issue-delete.message-template.redacted.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted"}],"type":8,"value":"strong"},{"type":0,"value":" a work item"}],"jira.jira-issue-delete.message-template.text.deleted.work.item":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-filter-subscription.message-template.email.subject":[{"type":0,"value":"[JIRA] Subscription: "},{"type":1,"value":"filterName"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.filter-name":[{"type":0,"value":"Filter: "},{"type":1,"value":"filterName"},{"type":1,"value":"count"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.subscriber-info":[{"type":0,"value":"Subscriber: "},{"type":1,"value":"subscriberName"}],"jira.jira-issue-mention.email.body.colon.no-translate":[{"type":0,"value":": "}],"jira.jira-issue-mention.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"mentioned you"}],"type":8,"value":"strong"},{"type":0,"value":" on a work item"}],"jira.jira-issue-mention.email.body.mentioned.you":[{"type":0,"value":" mentioned you "}],"jira.jira-issue-mention.email.body.onWorkItem.you":[{"type":0,"value":" on a work item "}],"jira.jira-issue-mention.email.body.spaces.no-translate":[{"type":0,"value":"&nbsp;&nbsp;"}],"jira.jira-issue-mention.email.body.view.work.item":[{"type":0,"value":" View work item "}],"jira.jira-issue-mention.email.subject.mention":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-mention.push.mentioned.you":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"jira.jira-issue-mention.push.mentioned.you.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on this work item"}],"jira.jira-issue-mention.text.body.addComment":[{"type":0,"value":" Add Comment: "}],"jira.jira-issue-mention.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-issue-mention.text.body.mention.hint":[{"type":0,"value":" Hint: You can mention someone in a work item description or comment by typing  \\"@\\" in front of their username."}],"jira.jira-issue-mention.text.body.mentioned":[{"type":0,"value":" mentioned you on "}],"jira.jira-issue-mention.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-mention.text.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira.jira-issue-mention.text.body.viewOnline":[{"type":0,"value":" View Online: "}],"jira.jira-issue-moved.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"moved a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-moved.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-notify.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.body.heading.redesigned":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.subject.notify":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared \\""},{"type":1,"value":"issueKey"},{"type":0,"value":" "},{"type":1,"value":"summary"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-reopened.message-template.email.body.reopened":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"reopened a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-reopened.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" reopened "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-resolved.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-search.message-template.email.subject.filter.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared the filter \\""},{"type":1,"value":"filterName"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-search.message-template.email.subject.search.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.email.header.filter":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a filter with you."}],"jira.jira-issue-share.message-template.email.header.results":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a search result with you."}],"jira.jira-issue-share.message-template.email.shared-with":[{"type":0,"value":" Also shared with "}],"jira.jira-issue-share.message-template.email.view.results":[{"type":0,"value":"View search results"}],"jira.jira-issue-share.message-template.text.shared.filter.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a filter with you"}],"jira.jira-issue-share.message-template.text.shared.results.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.text.shared.with.others":[{"type":0,"value":"Also shared with"}],"jira.jira-issue-test.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] test template "},{"type":1,"value":"issueKey"}],"jira.jira-issue-update.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.created.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-work-started.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.email.body.created.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" started by "},{"type":1,"value":"user"}],"jira.jira-issue-work-stopped.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" stopped by "},{"type":1,"value":"user"}],"jira.jira-issue-worklog-delete.message-template.email.body.title.redesigned":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-delete.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-deleted.message-template.text.email.body.deleted.worklog":[{"type":0,"value":"The following worklog was deleted:"}],"jira.jira-issue-worklog-update.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.body.title.redesigned":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-updated.message-template.email.body.description":[{"type":0,"value":"Description"}],"jira.jira-issue-worklog-updated.message-template.email.body.timeLogged":[{"type":0,"value":"Time logged"}],"jira.jira-issue-worklogged.message-template.email.body.description":[{"type":0,"value":"Description: "}],"jira.jira-issue-worklogged.message-template.email.body.logTitle":[{"type":0,"value":"Work log"}],"jira.jira-issue-worklogged.message-template.email.body.timelogged":[{"type":0,"value":"Time logged: "}],"jira.jira-issue-worklogged.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"added 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklogged.message-template.email.body.updateTitle":[{"type":0,"value":"Updates"}],"jira.jira-issue-worklogged.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-worklogged.message-template.email.body.worklog.entry":[{"type":0,"value":"Worklog entry:"}],"jira.jira-issue-worklogged.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.body.common.change.by":[{"type":0,"value":"Change by"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.created.on":[{"type":0,"value":"Created on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.by":[{"type":0,"value":"Edited by:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.on":[{"type":0,"value":"Edited on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.key":[{"type":0,"value":"Key:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.worklog.entry.label":[{"type":0,"value":"Worklog entry"}],"jira.jira-issue-worklogged.message-template.text.body.common.project":[{"type":0,"value":"Project:"}],"jira.jira-issue-worklogged.message-template.text.body.common.start.date":[{"type":0,"value":"Start Date:"}],"jira.jira-issue-worklogged.message-template.text.body.common.time.spent":[{"type":0,"value":"Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.common.url":[{"type":0,"value":"URL:"}],"jira.jira-issue-worklogged.message-template.text.body.common.view.work.description":[{"type":0,"value":"View work description"}],"jira.jira-issue-worklogged.message-template.text.body.common.work.type":[{"type":0,"value":"Work type:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.body":[{"type":0,"value":"Work Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description":[{"type":0,"value":"Worklog Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description.was":[{"type":0,"value":"Worklog Description was:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.id":[{"type":0,"value":"Worklog Id:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.estimated":[{"type":0,"value":"Remaining Estimate:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.spent":[{"type":0,"value":"Worklog Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.redacted.logged.by":[{"type":1,"value":"worklogEntry"},{"type":0,"value":" logged by "},{"type":1,"value":"actioner"}],"jira.jira-issue-worklogged.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.email.body.tracking":[{"type":0,"value":"Issue time Tracking"}],"jira.jira-project-deletion-reminder.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"},{"type":0,"value":" "}],"jira.jira-project-event-archived-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from archive "}],"jira.jira-project-event-archived.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Space archived"}],"jira.jira-project-event-delete-failed.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Could not permanently delete the project "}],"jira.jira-project-event-deleted-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from trash"}],"jira.jira-project-event-deleted.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project moved to trash"}],"jira.jira-project-event-user-invited-new-user.message-template.email.subject":[{"type":0,"value":"Action requested: "},{"type":1,"value":"userName"},{"type":0,"value":" invited you to join your team in "},{"type":1,"value":"projectName"},{"type":0,"value":", Jira"}],"jira.jira-project-event-user-invited-new-user.message-template.email.subject.redacted":[{"type":0,"value":"Action requested: You\'ve been invited to join your team in Jira"}],"jira.jira-project-event-user-invited.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"projectName"},{"type":0,"value":")  "}],"jira.user.premium-plan.requested.email.explaination":[{"type":0,"value":"You can try Jira Premium for free with no commitment. This trial period includes access\\n\\t\\t\\t\\tto our advanced planning features plus other great functionalities that unlock new ways\\n\\t\\t\\t\\tof working for your teams."}],"jira.user.premium-plan.requested.email.greeting":[{"type":0,"value":"Hi,"}],"jira.user.premium-plan.requested.email.learn-more":[{"type":0,"value":"Learn more about Jira Premium."}],"jira.user.premium-plan.requested.email.start-trial":[{"type":0,"value":"Start your Jira Premium trial"}],"jira.user.premium-plan.requested.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium"}],"jira.user.premium-plan.requested.email.text":[{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium."}],"note.added.by.user":[{"type":1,"value":"userName"},{"type":0,"value":" added this note"}],"post-office.jira-pulsar.jira-issue-approval.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-archived.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-closed.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-generic.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-moved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-resolved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.placement.jira-top-banner.primary-message":[{"type":0,"value":"As we roll out \'work\' as the new term for items tracked in Jira, you may still see \'issue\' in some areas."}],"postoffice.jira.issue.common.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.common.reply-button":[{"type":0,"value":"Reply"}],"postoffice.jira.issue.common.visibility-level":[{"type":0,"value":"Restricted to "},{"children":[{"type":1,"value":"name"}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"type"}],"postoffice.jira.issue.metioned.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.share-search.shared-with.no-translate":[{"type":0,"value":"sharedWithUser"}],"postoffice.jira.issue.work.started.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.work.stopped.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.worklogged.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.project.event.avatar.no-translate":[{"type":0,"value":"avatar"}],"postoffice.jira.project.event.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"postoffice.jira.project.event.globe.no-translate":[{"type":0,"value":"globeLogo"}],"postoffice.jira.project.event.logo.no-translate":[{"type":0,"value":"logo"}],"postoffice.jira.project.event.write.no-translate":[{"type":0,"value":"writeLogo"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.body":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.learn-more":[{"type":0,"value":"Learn more"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.title":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"push.mobile.issue.approval.requested.description":[{"type":0,"value":"on "},{"type":1,"value":"summary"}],"push.mobile.issue.approval.requested.title":[{"type":0,"value":"Approval requested"}],"push.mobile.issue.assignment.description.assigned.others":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"assignee"}],"push.mobile.issue.assignment.description.assigned.you":[{"type":1,"value":"user"},{"type":0,"value":" assigned you to "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.others":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.you":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment to "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment"}],"push.mobile.issue.comment.added.android.description":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.added.ios.body.redacted":[{"type":0,"value":"commented on this work item"}],"push.mobile.issue.comment.added.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on this work item"}],"push.mobile.issue.create.android.description":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.create.android.title":[{"type":0,"value":"Work item Created"}],"push.mobile.issue.create.ios.body.redacted":[{"type":0,"value":"Open to view work item details"}],"push.mobile.issue.create.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.transition.description.resolved":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"summary"}],"push.mobile.issue.transition.description.resolved.redacted":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved this work item"}],"push.mobile.issue.transition.ios.description":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"push.mobile.issue.transition.ios.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"st-office.placement.jira-top-banner.primary-cta-text":[{"type":0,"value":"Read about this terminology change"}],"template..project-deletion-reminder.restore-link.multiple-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.restore-link.single-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.trash-link.multiple-project":[{"type":0,"value":" Trash"}],"template.project-deletion-reminder.generic-message.mutiple-projects":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" project"}]},"other":{"value":[{"type":7},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"projectCount"},{"type":0,"value":" will be permanently deleted in 7 days "}],"template.project-deletion-reminder.generic-message.single-project":[{"type":0,"value":"The project will be permanently deleted in 7 days "}],"template.project-deletion-reminder.view-more-projects-message":[{"type":0,"value":"+ "},{"type":1,"value":"remainingProjectCount"},{"type":0,"value":" other projects currently in "}],"template.project-event-user-invited-new.custom-message-heading":[{"type":0,"value":"A note from "},{"type":1,"value":"inviterName"}],"template.project-event-user-invited-new.custom-message-heading-no-inviter":[{"type":0,"value":"A note from the admin"}],"template.project-event-user-invited-new.footer.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"template.project-event-user-invited-new.join-space":[{"type":0,"value":"Join the space"}],"template.project-event-user-invited-new.logo-alt-text":[{"type":0,"value":"Jira logo"}],"template.project-event-user-invited-new.product-description":[{"children":[{"type":0,"value":"What is Jira?"}],"type":8,"value":"strong"},{"type":0,"value":" A software tool for project and work item tracking with your team"}],"template.project-event-user-invited-new.social-proof-text":[{"type":1,"value":"numberOfCustomers"},{"type":0,"value":"+ customers use Jira to move work forward"}],"template.project-event-user-invited-new.title-generic":[{"type":0,"value":"You\'ve been invited to join your team in Jira"}],"template.project-event-user-invited-new.title-inviter":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join your team in Jira"}],"template.project-event-user-invited-new.welcome-message":[{"type":1,"value":"waveEmoji"},{"type":0,"value":" G\'day, "},{"type":1,"value":"recipientFirstName"}],"template.project-event-user-invited.invited-custom-message":[{"type":1,"value":"customMessage"}],"template.project-event-user-invited.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"projectName"},{"type":0,"value":" "}],"type":8,"value":"b"}],"template.project.archived.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the space."}],"template.project.deleted.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.event.project.archive.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from archive on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" archived this space on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template.generic.message":[{"type":0,"value":"This space and its work items, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" archive "}],"type":8,"value":"a"},{"type":0,"value":" forever"}],"template.project.event.project.deleted.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" moved this project to trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deleted.body.template.generic.message":[{"type":0,"value":"The project, including all its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" trash "}],"type":8,"value":"a"},{"type":0,"value":" for 60 days after which it will be permanently deleted."}],"template.project.event.project.deleted.failure.body.template.generic.message":[{"type":0,"value":"It\'s probably a temporary problem. "},{"children":[{"type":0,"value":" Go to trash "}],"type":8,"value":"a"},{"type":0,"value":" and try again. If it persists, please contact support."}],"template.project.event.project.deleted.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deletion.failure.body.template":[{"type":0,"value":"We couldn\'t delete this project"}],"template.project.event.project.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"template.project.event.project.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"template.project.event.project.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"template.project.event.project.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"template.project.event.project.privacy.policy.template.dot":[{"type":0,"value":"."}],"template.project.event.project.user.invited.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.join.link":[{"type":0,"value":"Join the Project"}],"template.project.event.project.user.invited.learn.more.message":[{"type":0,"value":"Learn more about Jira "}],"template.project.event.project.user.invited.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"template.project.event.project.user.invited.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"template.subscription.filter.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.html.subset.issue-term-refresh":[{"type":0,"value":"Displaying "},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" matched work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" matched work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":". "}],"template.subscription.filter.html.view.filter.work-items":[{"type":0,"value":"View all of them"}],"template.subscription.filter.redacted.html.edit":[{"type":0,"value":"You may edit this subscription "},{"children":[{"type":0,"value":" here "}],"type":8,"value":"a"},{"type":0,"value":" "}],"template.subscription.filter.redacted.html.view.filter":[{"type":0,"value":"Details are hidden to protect sensitive data. "},{"children":[{"type":0,"value":" View the filter "}],"type":8,"value":"a"},{"type":0,"value":" in Jira"}],"template.subscription.filter.subcount.issue-term-refresh":[{"type":0,"value":"  ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"template.subscription.filter.text.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.text.subcount.issue-term-refresh":[{"type":0,"value":" ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"user.avatar.alt":[{"type":0,"value":"User avatar"}]}');

});

parcelRegister("ls6Zj", function(module, exports) {

let $f9e1a22b103f8367$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9e1a22b103f8367$var$load("7Yj9o").then(()=>parcelRequire('6jwGQ'));

});

parcelRegister("15mZm", function(module, exports) {

let $0ca8172ba9f4d4b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ca8172ba9f4d4b6$var$load("dBwdi").then(()=>parcelRequire('74s8I'));

});

parcelRegister("doZ7S", function(module, exports) {

let $9c1cee9c5d7f522b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c1cee9c5d7f522b$var$load("j9yw3").then(()=>parcelRequire('02V19'));

});

parcelRegister("diQmT", function(module, exports) {

let $9af594070c140dee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9af594070c140dee$var$load("l8iFi").then(()=>parcelRequire('hCGRQ'));

});

parcelRegister("7hpmi", function(module, exports) {

let $54cdca9fba214c9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54cdca9fba214c9d$var$load("lBZIH").then(()=>parcelRequire('6ZxwT'));

});

parcelRegister("8Fw4S", function(module, exports) {

let $64fb09005b66f024$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64fb09005b66f024$var$load("joixz").then(()=>parcelRequire('cwpN3'));

});

parcelRegister("l1He6", function(module, exports) {

let $f4eb38db34656c46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f4eb38db34656c46$var$load("4i4Kt").then(()=>parcelRequire('beOaf'));

});

parcelRegister("ilTZL", function(module, exports) {

let $d5c59fa5122463ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5c59fa5122463ac$var$load("2lJZz").then(()=>parcelRequire('6LaWj'));

});

parcelRegister("3BLr5", function(module, exports) {

let $2a099f9729b89de1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a099f9729b89de1$var$load("7U9F6").then(()=>parcelRequire('fqRiS'));

});

parcelRegister("cAkqT", function(module, exports) {

let $9298b255c5d5d45b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9298b255c5d5d45b$var$load("kdo3S").then(()=>parcelRequire('bUxcb'));

});

parcelRegister("2pYQB", function(module, exports) {

let $1c2d1d9555fc3222$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c2d1d9555fc3222$var$load("csrC6").then(()=>parcelRequire('95hjm'));

});

parcelRegister("hQ4xx", function(module, exports) {

let $cfcad08e62c6ce6c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfcad08e62c6ce6c$var$load("iMP7C").then(()=>parcelRequire('2la6R'));

});

parcelRegister("1gNZX", function(module, exports) {

let $0ece11b5b15f85ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ece11b5b15f85ff$var$load("q3l0L").then(()=>parcelRequire('dlQ8N'));

});

parcelRegister("54YVY", function(module, exports) {

let $3b2c97b25c184454$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b2c97b25c184454$var$load("5Z3qI").then(()=>parcelRequire('dLZfG'));

});

parcelRegister("9IWwn", function(module, exports) {

let $71459e3b2608d195$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71459e3b2608d195$var$load("1x1kI").then(()=>parcelRequire('7dLLD'));

});

parcelRegister("5MqOz", function(module, exports) {

let $43563c468b0b8307$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $43563c468b0b8307$var$load("7m2nY").then(()=>parcelRequire('E24ro'));

});

parcelRegister("6O41U", function(module, exports) {

let $4f4a89cdc9f0e5b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f4a89cdc9f0e5b4$var$load("3VEav").then(()=>parcelRequire('80TMP'));

});

parcelRegister("dMSCA", function(module, exports) {

let $a09a20bb9a0ef81d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a09a20bb9a0ef81d$var$load("CYzZ6").then(()=>parcelRequire('6eaHY'));

});

parcelRegister("w1ZQX", function(module, exports) {

let $060489c36e3809cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $060489c36e3809cf$var$load("avS1q").then(()=>parcelRequire('bvbVP'));

});

parcelRegister("47Edk", function(module, exports) {

let $30070285efb6dded$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $30070285efb6dded$var$load("kqxDJ").then(()=>parcelRequire('huU6a'));

});

parcelRegister("i7S8e", function(module, exports) {

let $d322dedbd2af4a74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d322dedbd2af4a74$var$load("dziTX").then(()=>parcelRequire('iLn5v'));

});

parcelRegister("eM3rX", function(module, exports) {

let $ac18397cf0817cc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac18397cf0817cc4$var$load("e365F").then(()=>parcelRequire('l5bNB'));

});

parcelRegister("gsuf5", function(module, exports) {

let $bfb6b85fb473ed25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bfb6b85fb473ed25$var$load("e3Wja").then(()=>parcelRequire('4qQ9E'));

});

parcelRegister("3GLTX", function(module, exports) {

let $2afa739990e90400$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2afa739990e90400$var$load("hgEfL").then(()=>parcelRequire('kwyOm'));

});

parcelRegister("ghIyH", function(module, exports) {

let $bdb0cc4b17b196d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bdb0cc4b17b196d6$var$load("5nPJL").then(()=>parcelRequire('jNvDS'));

});

parcelRegister("kTdQD", function(module, exports) {

let $f353af9974f3ac57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f353af9974f3ac57$var$load("6bLCw").then(()=>parcelRequire('6q8dO'));

});

parcelRegister("ao0pU", function(module, exports) {

let $78fc780b78fe826e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78fc780b78fe826e$var$load("5eF31").then(()=>parcelRequire('7fyIe'));

});

parcelRegister("d5zS6", function(module, exports) {

let $98779157fbcdbd32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98779157fbcdbd32$var$load("hSDas").then(()=>parcelRequire('dk9zU'));

});

parcelRegister("kU9Bh", function(module, exports) {

let $f3807c05689a862a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3807c05689a862a$var$load("jyp3O").then(()=>parcelRequire('fDMQY'));

});

parcelRegister("6gc2r", function(module, exports) {

let $48ed9345137a7fd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48ed9345137a7fd3$var$load("cZgN3").then(()=>parcelRequire('1soyt'));

});

parcelRegister("6q3fz", function(module, exports) {

let $4ac7b12d877cf259$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ac7b12d877cf259$var$load("l0VRX").then(()=>parcelRequire('l0MAd'));

});

parcelRegister("l9eWx", function(module, exports) {

let $f65607a6d5011585$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f65607a6d5011585$var$load("1QYgR").then(()=>parcelRequire('cffGX'));

});

parcelRegister("5qgOk", function(module, exports) {

let $3f2c6bb30b0c2927$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f2c6bb30b0c2927$var$load("9VcQN").then(()=>parcelRequire('3RLpu'));

});

parcelRegister("37UgO", function(module, exports) {

let $246dac9ac88a6789$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $246dac9ac88a6789$var$load("k7It5").then(()=>parcelRequire('5ozG8'));

});

parcelRegister("3d9WN", function(module, exports) {
module.exports = JSON.parse("{\"acrabats.rovo-dev-spotlight.explore-rovo-dev.description\":[{\"type\":0,\"value\":\"Get started on this work item using Rovo Dev to generate code. It's work is only visible to you.\"}],\"acrabats.rovo-dev-spotlight.explore-rovo-dev.heading\":[{\"type\":0,\"value\":\"Start coding with Rovo Dev in Jira\"}],\"acrabats.rovo-dev-spotlight.navigation.back\":[{\"type\":0,\"value\":\"Back\"}],\"acrabats.rovo-dev-spotlight.navigation.next\":[{\"type\":0,\"value\":\"Next\"}],\"acrabats.rovo-dev-spotlight.navigation.progress\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}],\"acrabats.rovo-dev-spotlight.navigation.read-more\":[{\"type\":0,\"value\":\"Read more\"}],\"acrabats.rovo-dev-spotlight.understand-rovo-dev.description\":[{\"type\":0,\"value\":\"Once the agent has finished, you're in control of approving the work and sharing with your team.\"}],\"acrabats.rovo-dev-spotlight.understand-rovo-dev.heading\":[{\"type\":0,\"value\":\"You review and approve\"}],\"devai-acrabats.ai-planner-plan-created.message-template.notification-drawer.message.no-translate\":[{\"type\":1,\"value\":\"actorName\"},{\"type\":0,\"value\":\" updated your page\"}],\"devai-acrabats.blocks.header.alt_text.atlassian\":[{\"type\":0,\"value\":\"Atlassian\"}],\"devai-acrabats.components.email..footer.img.alt\":[{\"type\":0,\"value\":\"Atlassian Logo\"}],\"devai-acrabats.components.email..footer.text\":[{\"type\":0,\"value\":\"This message was sent to you by Atlassian Cloud\"}],\"devai-acrabats.components.email.footer.note.no-org-name\":[{\"type\":0,\"value\":\"You received this because you're an organization admin\"}],\"devai-acrabats.components.email.footer.note.org-name\":[{\"type\":0,\"value\":\"You received this because you're an organization admin for \"},{\"type\":1,\"value\":\"orgName\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message-template.email.subject\":[{\"type\":0,\"value\":\"Rovo Dev is coming to the terminal\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fifth-paragraph\":[{\"type\":0,\"value\":\"Learn more about how RovoDev CLI capabilities and its data use and controls \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fifth-paragraph.link\":[{\"type\":0,\"value\":\"here\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.first-paragraph\":[{\"type\":0,\"value\":\"Rovo Dev CLI brings powerful Rovo Dev capabilities, along with your team's Jira and Confluence\\n\\t\\t\\t\\t\\tknowledge, to your terminal.\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fourth-paragraph\":[{\"type\":0,\"value\":\"Rovo Dev users will receive instructions soon for how to install Rovo Dev CLI and use it in your team's workflow.\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.heading\":[{\"type\":0,\"value\":\"Rovo Dev CLI has been enabled for your site\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.second-paragraph\":[{\"type\":0,\"value\":\"Developers can collaborate with AI to generate and ship code, turn work items into features,\\n\\t\\t\\t\\t\\task questions in natural language, and more. And all without switching contexts.\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.third-paragraph\":[{\"type\":0,\"value\":\"Rovo Dev CLI enables users to connect to third-party data sources via \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.third-paragraph.link\":[{\"type\":0,\"value\":\"Model Context Protocol\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Rovo Dev is now ready to use in your terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-1\":[{\"type\":0,\"value\":\"Natural language insights into repositories, files, and features.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-2\":[{\"type\":0,\"value\":\"AI-powered code generation and shipping.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-3\":[{\"type\":0,\"value\":\"Collaboration with AI to turn work items into features.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-4\":[{\"type\":0,\"value\":\"Connecting to third-party data sources via Model Context Protocol.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.first-paragraph\":[{\"type\":0,\"value\":\"We've enabled access to Rovo Dev CLI for your site (\"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\") as part of the Rovo Dev Agents beta.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.first-paragraph.link\":[{\"type\":1,\"value\":\"siteName\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.heading\":[{\"type\":0,\"value\":\"Your team can now use Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.second-paragraph\":[{\"type\":0,\"value\":\"Once your team \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\", they can access Rovo Dev features like:\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.second-paragraph.link\":[{\"type\":0,\"value\":\"installs the agent in their terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.third-paragraph.link\":[{\"type\":0,\"value\":\"manage access for your site\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.read-more-button\":[{\"type\":0,\"value\":\"Read more about Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.test-message.email.body.third-paragraph\":[{\"type\":0,\"value\":\"If you don't want your team to be able to access Rovo Dev CLI, \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Rovo Dev is now ready to use in your terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-1\":[{\"type\":0,\"value\":\"Natural language insights into repositories, files, and features.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-2\":[{\"type\":0,\"value\":\"AI-powered code generation and implementation.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-3\":[{\"type\":0,\"value\":\"Automated test creation to improve coverage metrics.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-4\":[{\"type\":0,\"value\":\"Dynamic documentation writing reflecting repository features and changes.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.first-paragraph\":[{\"type\":0,\"value\":\"We've enabled access to Rovo Dev CLI as part of the Rovo Dev Agents beta.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.heading\":[{\"type\":0,\"value\":\"You can now use Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.img.alt\":[{\"type\":0,\"value\":\"Rovo Dev CLI Screenshot\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1\":[{\"type\":0,\"value\":\"Install ACLI (or update to the latest version if you already have ACLI installed) using instructions for your OS:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-1\":[{\"type\":0,\"value\":\"macOS\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-2\":[{\"type\":0,\"value\":\"Linux\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-3\":[{\"type\":0,\"value\":\"Windows\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-2\":[{\"type\":0,\"value\":\"Generate an unscoped API token from your  \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-2.link\":[{\"type\":0,\"value\":\"Atlassian profile\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-3\":[{\"type\":0,\"value\":\"In your terminal, run:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-3.code\":[{\"type\":0,\"value\":\"acli rovodev auth login\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-4\":[{\"type\":0,\"value\":\"Run this command to open Rovo Dev in interactive mode:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-4.code\":[{\"type\":0,\"value\":\"acli rovodev run\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.second-paragraph\":[{\"type\":0,\"value\":\"Once you \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\", you can access Rovo Dev features like:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.second-paragraph.link\":[{\"type\":0,\"value\":\"install the agent in your terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.read-more-button\":[{\"type\":0,\"value\":\"Read more about Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.test-message.email.body.sub-header\":[{\"type\":0,\"value\":\"How do I get started?\"}],\"jiraRovoDev.survey.question\":[{\"type\":0,\"value\":\"Rovo Dev in Jira is valuable to my work.\"}],\"jiraRovoDev.survey.score.neutral\":[{\"type\":0,\"value\":\"Neutral\"}],\"jiraRovoDev.survey.score.stronglyAgree\":[{\"type\":0,\"value\":\"Strongly agree\"}],\"jiraRovoDev.survey.score.stronglyDisagree\":[{\"type\":0,\"value\":\"Strongly disagree\"}],\"jiraRovoDev.survey.statement\":[{\"type\":0,\"value\":\"To what extent do you agree or disagree with the statement?\"}]}");

});

parcelRegister("45b9z", function(module, exports) {

let $2f9047e5e7bc4aa7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f9047e5e7bc4aa7$var$load("b5Yhq").then(()=>parcelRequire('ieTlg'));

});

parcelRegister("1sDYK", function(module, exports) {

let $11076aeeea39631a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11076aeeea39631a$var$load("gRJEH").then(()=>parcelRequire('k3yE6'));

});

parcelRegister("4CsHf", function(module, exports) {

let $35d0f8987f5c8f7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35d0f8987f5c8f7e$var$load("hLNHr").then(()=>parcelRequire('11ktS'));

});

parcelRegister("4wTm9", function(module, exports) {

let $34c517336433f22d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34c517336433f22d$var$load("gautO").then(()=>parcelRequire('6MchO'));

});

parcelRegister("4h72G", function(module, exports) {

let $31ce3668449f5080$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31ce3668449f5080$var$load("3rITJ").then(()=>parcelRequire('6FtSF'));

});

parcelRegister("5ohrQ", function(module, exports) {

let $3eccba78a98009be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3eccba78a98009be$var$load("dwpIu").then(()=>parcelRequire('hnVof'));

});

parcelRegister("dzxc3", function(module, exports) {

let $9e184ac30d64cd59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e184ac30d64cd59$var$load("cxeN7").then(()=>parcelRequire('7qJPE'));

});

parcelRegister("j7JQa", function(module, exports) {

let $dec23ab7036bec78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dec23ab7036bec78$var$load("g5HqX").then(()=>parcelRequire('23A2a'));

});

parcelRegister("jGcku", function(module, exports) {

let $e53b80edcafc0ef7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e53b80edcafc0ef7$var$load("6bQYo").then(()=>parcelRequire('gWN94'));

});

parcelRegister("bIsWt", function(module, exports) {

let $887a4114746583ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $887a4114746583ef$var$load("bLRIR").then(()=>parcelRequire('7XA80'));

});

parcelRegister("alyXB", function(module, exports) {

let $7886fbf10d9a89fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7886fbf10d9a89fb$var$load("7bk4A").then(()=>parcelRequire('eXQfP'));

});

parcelRegister("hoxc6", function(module, exports) {

let $ca9e6d36b1e70d92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca9e6d36b1e70d92$var$load("1Cadl").then(()=>parcelRequire('c5yjs'));

});

parcelRegister("b4qlQ", function(module, exports) {

let $80f4823eca034cb8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80f4823eca034cb8$var$load("hiJWy").then(()=>parcelRequire('6qTzS'));

});

parcelRegister("1Uurj", function(module, exports) {

let $1642a20e8733a838$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1642a20e8733a838$var$load("9urBX").then(()=>parcelRequire('ltjeo'));

});

parcelRegister("6BUtM", function(module, exports) {

let $4d02026241071897$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d02026241071897$var$load("hA2xr").then(()=>parcelRequire('aOh9Z'));

});

parcelRegister("cYXx7", function(module, exports) {

let $973944aa12ec531a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $973944aa12ec531a$var$load("9NIUU").then(()=>parcelRequire('8O0PS'));

});

parcelRegister("idcgG", function(module, exports) {

let $d422f512490350a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d422f512490350a0$var$load("3847A").then(()=>parcelRequire('a62vs'));

});

parcelRegister("59inb", function(module, exports) {

let $3bfc0b85165d252a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3bfc0b85165d252a$var$load("lAlBm").then(()=>parcelRequire('kyNlP'));

});

parcelRegister("4m2Sb", function(module, exports) {

let $32bb72066bd2ffe7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32bb72066bd2ffe7$var$load("1Mdwi").then(()=>parcelRequire('g98td'));

});

parcelRegister("5MoII", function(module, exports) {

let $43549c632ab5e522$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $43549c632ab5e522$var$load("fAlR6").then(()=>parcelRequire('ck7xl'));

});

parcelRegister("8zydd", function(module, exports) {

let $63dc216ef86a795a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $63dc216ef86a795a$var$load("9gi28").then(()=>parcelRequire('kNsb2'));

});

parcelRegister("5H4eB", function(module, exports) {

let $425440d06ce1ca56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $425440d06ce1ca56$var$load("cPixV").then(()=>parcelRequire('8GU6S'));

});

parcelRegister("3vPJc", function(module, exports) {

let $28ec6479c02ade0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28ec6479c02ade0a$var$load("dVGar").then(()=>parcelRequire('kisxe'));

});

parcelRegister("gA2xU", function(module, exports) {

let $c121fbafdf43de89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c121fbafdf43de89$var$load("bSe8I").then(()=>parcelRequire('1ajsj'));

});

parcelRegister("60Lwd", function(module, exports) {

let $46079a61e9892c97$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46079a61e9892c97$var$load("39h4P").then(()=>parcelRequire('hrHLU'));

});

parcelRegister("aNHSu", function(module, exports) {

let $7dd0843943ee766b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7dd0843943ee766b$var$load("aHCVC").then(()=>parcelRequire('joICV'));

});

parcelRegister("fpzDy", function(module, exports) {

let $b384d58d56dd1ef3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b384d58d56dd1ef3$var$load("cXpKE").then(()=>parcelRequire('jLNQW'));

});

parcelRegister("6SAbG", function(module, exports) {

let $5023db47e9ac72e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5023db47e9ac72e2$var$load("cdBH8").then(()=>parcelRequire('lQquy'));

});

parcelRegister("hDKnD", function(module, exports) {

let $cd7a0e50a2126bb8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd7a0e50a2126bb8$var$load("bXAV9").then(()=>parcelRequire('aDsTB'));

});

parcelRegister("dblAN", function(module, exports) {

let $998d0d458774cc95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $998d0d458774cc95$var$load("3gr7A").then(()=>parcelRequire('586mV'));

});

parcelRegister("3gjtx", function(module, exports) {

let $2601f91f1e315800$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2601f91f1e315800$var$load("eLF9M").then(()=>parcelRequire('1A0Hh'));

});

parcelRegister("9mwGO", function(module, exports) {

let $6d0f86958b38b4e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d0f86958b38b4e3$var$load("j30EA").then(()=>parcelRequire('eE9kd'));

});

parcelRegister("8x59G", function(module, exports) {

let $6365677cee463bd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6365677cee463bd3$var$load("6BTbY").then(()=>parcelRequire('hjK0F'));

});

parcelRegister("bzFQm", function(module, exports) {

let $86d36bd52c5fc8b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86d36bd52c5fc8b4$var$load("5iIlm").then(()=>parcelRequire('ft2zv'));

});

parcelRegister("6bHt8", function(module, exports) {
module.exports = JSON.parse("{\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.closing\":[{\"type\":0,\"value\":\"Launch your space today to give your team a single, self-service entry point for HR help.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.contact\":[{\"type\":0,\"value\":\"Please \"},{\"type\":1,\"value\":\"contactUsLink\"},{\"type\":0,\"value\":\" with any questions, we're always happy to help.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.contact-us-link\":[{\"type\":0,\"value\":\"contact us\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.cta\":[{\"type\":0,\"value\":\"Go to your space\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.greeting\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.heading\":[{\"type\":0,\"value\":\"Bring your HR team together in Jira Service Management\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.intro\":[{\"type\":0,\"value\":\"You recently started an HR service space, but it looks like your team hasn't moved in yet. When you're ready, Jira Service Management can help you centralize requests and track onboarding in one place.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.signoff\":[{\"type\":0,\"value\":\"Cheers,\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-1\":[{\"children\":[{\"type\":0,\"value\":\"Add team members\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" as agents to handle requests\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-2\":[{\"children\":[{\"type\":0,\"value\":\"Set up request types\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" like \\\"New hire onboarding\\\"\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-3\":[{\"children\":[{\"type\":0,\"value\":\"Publish your portal\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" so employees can find help\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.steps-heading\":[{\"type\":0,\"value\":\"Get started in three steps:\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.team-name\":[{\"type\":0,\"value\":\"The Atlassians\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.subject\":[{\"type\":0,\"value\":\"Quick check-in on your HR service space\"}]}");

});

parcelRegister("jIdVZ", function(module, exports) {

let $e59cef78a3398b1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e59cef78a3398b1d$var$load("3Szyh").then(()=>parcelRequire('5rCQB'));

});

parcelRegister("4xhSQ", function(module, exports) {

let $34d81dc668c0bcf7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34d81dc668c0bcf7$var$load("54wKa").then(()=>parcelRequire('dpa2u'));

});

parcelRegister("7EwnF", function(module, exports) {

let $592562faebedda52$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $592562faebedda52$var$load("keTiL").then(()=>parcelRequire('lUUqa'));

});

parcelRegister("k3E0o", function(module, exports) {

let $e9a31eb494e4d91c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9a31eb494e4d91c$var$load("goYKM").then(()=>parcelRequire('7LFZd'));

});

parcelRegister("80RZJ", function(module, exports) {

let $5d58350a57095feb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d58350a57095feb$var$load("6kDcM").then(()=>parcelRequire('rZAK6'));

});

parcelRegister("8CsTa", function(module, exports) {

let $64684809a7602e9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64684809a7602e9a$var$load("fvKkA").then(()=>parcelRequire('iZ8dc'));

});

parcelRegister("loIZs", function(module, exports) {

let $f93ebcfab5c52c5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f93ebcfab5c52c5d$var$load("kbQZE").then(()=>parcelRequire('16jdm'));

});

parcelRegister("hJhrs", function(module, exports) {

let $ce842b39e722cf2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce842b39e722cf2f$var$load("cdrsx").then(()=>parcelRequire('jCcG9'));

});

parcelRegister("ePqOe", function(module, exports) {

let $acba9fd7d60d3d91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $acba9fd7d60d3d91$var$load("fYvEM").then(()=>parcelRequire('3WBiu'));

});

parcelRegister("jINk5", function(module, exports) {

let $e5b862e21be2b574$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5b862e21be2b574$var$load("iRm1T").then(()=>parcelRequire('jl9FW'));

});

parcelRegister("gqpBw", function(module, exports) {

let $bf52ef887931ab12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf52ef887931ab12$var$load("4mH2Z").then(()=>parcelRequire('ef3N0'));

});

parcelRegister("1roHb", function(module, exports) {

let $10cb7811b7fb0f3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $10cb7811b7fb0f3a$var$load("jfnhY").then(()=>parcelRequire('eIOep'));

});

parcelRegister("fGIZ4", function(module, exports) {

let $b6bdac1f57892e4b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6bdac1f57892e4b$var$load("5QDEn").then(()=>parcelRequire('i7m4s'));

});

parcelRegister("jIMau", function(module, exports) {

let $e5b77d9424366f56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5b77d9424366f56$var$load("k2BAN").then(()=>parcelRequire('lkKDU'));

});

parcelRegister("lzQvT", function(module, exports) {

let $fb5599ee87c9c101$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb5599ee87c9c101$var$load("jAlIu").then(()=>parcelRequire('6SZfM'));

});

parcelRegister("3K32N", function(module, exports) {

let $2b980775f216bf07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b980775f216bf07$var$load("7Mb75").then(()=>parcelRequire('7sXYG'));

});

parcelRegister("cWXqX", function(module, exports) {

let $96d90121412101a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96d90121412101a1$var$load("cJwl1").then(()=>parcelRequire('e1BI1'));

});

parcelRegister("4FH7p", function(module, exports) {

let $366c703542cdbade$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $366c703542cdbade$var$load("bgNfq").then(()=>parcelRequire('4TUqZ'));

});

parcelRegister("aeVv6", function(module, exports) {

let $7747d0992da641ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7747d0992da641ba$var$load("59MRZ").then(()=>parcelRequire('eZJFk'));

});

parcelRegister("2UrBG", function(module, exports) {

let $21e639d9b8d51dd5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21e639d9b8d51dd5$var$load("kQ34m").then(()=>parcelRequire('byPxV'));

});

parcelRegister("aOw3v", function(module, exports) {

let $7df77071fda6f5c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7df77071fda6f5c6$var$load("a7nBF").then(()=>parcelRequire('8HZrG'));

});

parcelRegister("1vAxq", function(module, exports) {

let $11950765ef99ae6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11950765ef99ae6a$var$load("6LjTk").then(()=>parcelRequire('0n9eq'));

});

parcelRegister("hiGCK", function(module, exports) {

let $c9852e56d44893f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9852e56d44893f1$var$load("elktR").then(()=>parcelRequire('82Pdl'));

});

parcelRegister("kLaPk", function(module, exports) {

let $f1d0986b5427ce7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f1d0986b5427ce7d$var$load("9nZ7e").then(()=>parcelRequire('hNahA'));

});

parcelRegister("iJtWO", function(module, exports) {

let $da33a8eaaf6802e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da33a8eaaf6802e4$var$load("2qOzy").then(()=>parcelRequire('74f1v'));

});

parcelRegister("l7gVc", function(module, exports) {

let $f5f760ab8231c680$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5f760ab8231c680$var$load("cGDG6").then(()=>parcelRequire('fRuOt'));

});

parcelRegister("jxN0u", function(module, exports) {

let $03abfc573737a2a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03abfc573737a2a8$var$load("58AUw").then(()=>parcelRequire('pQt4w'));

});

parcelRegister("g691M", function(module, exports) {

let $bb8435949b45c54c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb8435949b45c54c$var$load("1ddjU").then(()=>parcelRequire('dVhJE'));

});

parcelRegister("kixZ4", function(module, exports) {

let $ec6fd99df19d19b7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec6fd99df19d19b7$var$load("lRE1N").then(()=>parcelRequire('1j76i'));

});

parcelRegister("LQLNC", function(module, exports) {

let $08fd52ea48f09954$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $08fd52ea48f09954$var$load("dmfYo").then(()=>parcelRequire('duqno'));

});

parcelRegister("1yVN1", function(module, exports) {

let $1235cb3d2a9735b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1235cb3d2a9735b3$var$load("56sIW").then(()=>parcelRequire('5gsmY'));

});

parcelRegister("at24j", function(module, exports) {

let $79ee379832c4a38b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79ee379832c4a38b$var$load("k4FnS").then(()=>parcelRequire('j2cGn'));

});

parcelRegister("96qjp", function(module, exports) {

let $6a0915a072a78f11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a0915a072a78f11$var$load("6k4jr").then(()=>parcelRequire('7wQf3'));

});

parcelRegister("6YqLJ", function(module, exports) {

let $513d1c66b75dd6ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $513d1c66b75dd6ca$var$load("jNs8M").then(()=>parcelRequire('gKbo5'));

});

parcelRegister("7vWY6", function(module, exports) {
module.exports = JSON.parse('{"post-office.jsm-phantom.issue-view.playbook.spotlight-close-button":[{"type":0,"value":"Close"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-first-line":[{"type":0,"value":"Follow step-by-step guidance and run automate actions to resolve work faster."}],"post-office.jsm-phantom.issue-view.playbook.spotlight-heading":[{"type":0,"value":"Resolve work items faster with playbooks"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-learn-more":[{"type":0,"value":"Learn more about playbooks"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-second-line":[{"type":0,"value":"No playbook yet? Share your runbooks with project admin to turn them into actionable playbooks."}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-close-button":[{"type":0,"value":"Close"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-first-line":[{"type":0,"value":"Create reusable playbooks from runbooks, SOPs, and how-tos to give your team step-by-step guidance and automated actions to resolve work items faster, right in context."}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-heading":[{"type":0,"value":"Turn your team\u2019s knowledge into playbooks"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-learn-more":[{"type":0,"value":"Learn more about playbooks"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight.create-playbook":[{"type":0,"value":"Create playbook"}]}');

});

parcelRegister("1LpSr", function(module, exports) {

let $148e40df1a0827cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $148e40df1a0827cf$var$load("8HCzh").then(()=>parcelRequire('41pzY'));

});

parcelRegister("bvrkp", function(module, exports) {

let $8607c9c6b38f6954$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8607c9c6b38f6954$var$load("7Upnc").then(()=>parcelRequire('eHKIg'));

});

parcelRegister("02Yd6", function(module, exports) {

let $008ee4905b4bef63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $008ee4905b4bef63$var$load("jTgn4").then(()=>parcelRequire('lM0hw'));

});

parcelRegister("dLK1A", function(module, exports) {

let $a0635daf2feb169e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0635daf2feb169e$var$load("kKFf5").then(()=>parcelRequire('3sA6B'));

});

parcelRegister("4SLw9", function(module, exports) {

let $38e11093c7252a65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $38e11093c7252a65$var$load("rYHSR").then(()=>parcelRequire('hNAgI'));

});

parcelRegister("1VVmJ", function(module, exports) {

let $16879cf60d284a0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $16879cf60d284a0d$var$load("EPmgP").then(()=>parcelRequire('6ymfp'));

});

parcelRegister("goMeW", function(module, exports) {

let $bf044eb6a590f20e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf044eb6a590f20e$var$load("ihGQl").then(()=>parcelRequire('9Dgrt'));

});

parcelRegister("9dyCN", function(module, exports) {

let $6b602fae7ead3506$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b602fae7ead3506$var$load("fpt29").then(()=>parcelRequire('l1dl7'));

});

parcelRegister("cTzry", function(module, exports) {

let $96361d6f66cc7798$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96361d6f66cc7798$var$load("9jN4B").then(()=>parcelRequire('4TcT5'));

});

parcelRegister("dIoHy", function(module, exports) {

let $9fc28ba23fe69d5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9fc28ba23fe69d5a$var$load("jkwNK").then(()=>parcelRequire('ij7tb'));

});

parcelRegister("3RJ21", function(module, exports) {

let $2d0940ac4500d3d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d0940ac4500d3d9$var$load("SgT4s").then(()=>parcelRequire('fffUh'));

});

parcelRegister("9sHg7", function(module, exports) {

let $6e3848e823953308$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6e3848e823953308$var$load("gfHi5").then(()=>parcelRequire('3JCgx'));

});

parcelRegister("7tSBx", function(module, exports) {

let $572599294da31cac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $572599294da31cac$var$load("6XWPj").then(()=>parcelRequire('crgic'));

});

parcelRegister("40C0A", function(module, exports) {

let $2eb4a533c5f6ff4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2eb4a533c5f6ff4f$var$load("lIo1e").then(()=>parcelRequire('32vcX'));

});

parcelRegister("8ixib", function(module, exports) {

let $60a9d4553c4645b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $60a9d4553c4645b9$var$load("5pKA1").then(()=>parcelRequire('c7mPU'));

});

parcelRegister("1JuBT", function(module, exports) {

let $1431bcf081a9275d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1431bcf081a9275d$var$load("fkmvi").then(()=>parcelRequire('fpPX2'));

});

parcelRegister("3dZ9f", function(module, exports) {

let $259204c3a7b90f6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $259204c3a7b90f6a$var$load("7cYYT").then(()=>parcelRequire('2L7jL'));

});

parcelRegister("lGNLQ", function(module, exports) {

let $fca420a9668e979a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fca420a9668e979a$var$load("7idbH").then(()=>parcelRequire('02Vne'));

});

parcelRegister("dqfCk", function(module, exports) {

let $9c59d14ea96b2a37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c59d14ea96b2a37$var$load("1LQ5d").then(()=>parcelRequire('8y4qA'));

});

parcelRegister("ck4nk", function(module, exports) {

let $8f8abf25c2c92b70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f8abf25c2c92b70$var$load("cYGwl").then(()=>parcelRequire('8ird4'));

});

parcelRegister("cw5Ee", function(module, exports) {

let $91ccdabad4cc6c7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91ccdabad4cc6c7b$var$load("ivhSc").then(()=>parcelRequire('9AcwF'));

});

parcelRegister("c6T8f", function(module, exports) {

let $8d10cfa0ce3e2c19$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d10cfa0ce3e2c19$var$load("gxxjy").then(()=>parcelRequire('3UOMI'));

});

parcelRegister("gREVX", function(module, exports) {

let $c4715929c6fa9e05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4715929c6fa9e05$var$load("lRS8b").then(()=>parcelRequire('7P9qa'));

});

parcelRegister("a3qnR", function(module, exports) {

let $751ea676c52c0c12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $751ea676c52c0c12$var$load("4iPBG").then(()=>parcelRequire('eRD8y'));

});

parcelRegister("30FqW", function(module, exports) {

let $23118308ffa8e367$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23118308ffa8e367$var$load("28sR2").then(()=>parcelRequire('9WmTt'));

});

parcelRegister("gxTOv", function(module, exports) {

let $c0bb05dac795d2b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c0bb05dac795d2b5$var$load("hUGrX").then(()=>parcelRequire('26xbY'));

});

parcelRegister("PV8Yp", function(module, exports) {

let $09c11716e5464526$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09c11716e5464526$var$load("eIA8Y").then(()=>parcelRequire('bmHUw'));

});

parcelRegister("87P91", function(module, exports) {

let $5ea6a667819176a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ea6a667819176a8$var$load("hRyML").then(()=>parcelRequire('1CZPg'));

});

parcelRegister("dlQX1", function(module, exports) {

let $9b864f7a656d7042$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b864f7a656d7042$var$load("9yHcq").then(()=>parcelRequire('eB35u'));

});

parcelRegister("hfAFd", function(module, exports) {

let $c8f04704f13df7c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8f04704f13df7c5$var$load("7ApdI").then(()=>parcelRequire('iDmF9'));

});

parcelRegister("bj4ZW", function(module, exports) {

let $83b5588fbb11bb53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83b5588fbb11bb53$var$load("iMkSI").then(()=>parcelRequire('i2HfB'));

});

parcelRegister("9FUEQ", function(module, exports) {

let $70b3e476672cc3ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70b3e476672cc3ec$var$load("eMzq0").then(()=>parcelRequire('jWTfa'));

});

parcelRegister("5cNzU", function(module, exports) {

let $3ca487ead5981aca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ca487ead5981aca$var$load("5O73Z").then(()=>parcelRequire('aIdJu'));

});

parcelRegister("kL4GF", function(module, exports) {

let $f1cbd53171454f96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f1cbd53171454f96$var$load("8WMYT").then(()=>parcelRequire('5VWa3'));

});

parcelRegister("5j4Cn", function(module, exports) {
module.exports = JSON.parse('{"jsm-project-summary-onboarding.changeLayout":[{"type":0,"value":"Change the layout and order of charts"}],"jsm-project-summary-onboarding.closeButton":[{"type":0,"value":"Close"}],"jsm-project-summary-onboarding.description":[{"type":0,"value":"You can now edit the summary page to keep your team up to date. Tailor your space overview by customizing the layout, filters, and charts."}],"jsm-project-summary-onboarding.editFilters":[{"type":0,"value":"Edit filters"}],"jsm-project-summary-onboarding.heading":[{"type":0,"value":"Edit your space summary"}],"jsm-project-summary-onboarding.hideAddCharts":[{"type":0,"value":"Hide or add charts"}],"jsm-project-summary-onboarding.moreAboutFeature":[{"type":0,"value":"More about space summary"}],"jsm-project-summary-onboarding.okButton":[{"type":0,"value":"Got it"}],"jsm-project-summary-onboarding.whatsNewTitle":[{"type":0,"value":"What\u2019s new?"}]}');

});

parcelRegister("dBqKf", function(module, exports) {

let $9e737a12c4bbb83a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e737a12c4bbb83a$var$load("71ZfD").then(()=>parcelRequire('2T0sT'));

});

parcelRegister("3Qq1K", function(module, exports) {

let $2cca6ae084e3b2b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2cca6ae084e3b2b5$var$load("kYEsp").then(()=>parcelRequire('fr2U1'));

});

parcelRegister("dV1W3", function(module, exports) {

let $a222198c71a5346f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a222198c71a5346f$var$load("4tvhv").then(()=>parcelRequire('hx9ka'));

});

parcelRegister("90jP0", function(module, exports) {

let $68e37d55f2d87ebf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $68e37d55f2d87ebf$var$load("5eop4").then(()=>parcelRequire('bEGgx'));

});

parcelRegister("iC5L5", function(module, exports) {

let $d8d03e1cceb55cb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d8d03e1cceb55cb0$var$load("5YEPv").then(()=>parcelRequire('3Z1ar'));

});

parcelRegister("hsrB8", function(module, exports) {

let $cb5a759163bc4a5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb5a759163bc4a5e$var$load("1Bn96").then(()=>parcelRequire('bxLpT'));

});

parcelRegister("iJkX5", function(module, exports) {

let $da2cae959d9fe512$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da2cae959d9fe512$var$load("7Pg2p").then(()=>parcelRequire('qmn3S'));

});

parcelRegister("dcLFo", function(module, exports) {

let $99d15ef9a45aedc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99d15ef9a45aedc4$var$load("5BZYq").then(()=>parcelRequire('7EHde'));

});

parcelRegister("9l0bw", function(module, exports) {

let $6cc637f23f505b6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cc637f23f505b6e$var$load("gzVLb").then(()=>parcelRequire('8LbUN'));

});

parcelRegister("ilvnY", function(module, exports) {

let $d5b288b16021bb00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5b288b16021bb00$var$load("fjNHB").then(()=>parcelRequire('34tgh'));

});

parcelRegister("jCs0C", function(module, exports) {

let $e4874af0fcf407ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4874af0fcf407ee$var$load("8wgTR").then(()=>parcelRequire('2YF6k'));

});

parcelRegister("5SsPO", function(module, exports) {

let $44785cda0d6f1977$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44785cda0d6f1977$var$load("lLpfP").then(()=>parcelRequire('crvL4'));

});

parcelRegister("d9xvN", function(module, exports) {

let $99361c5fe3fba7fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99361c5fe3fba7fa$var$load("6j79B").then(()=>parcelRequire('Ep8H8'));

});

parcelRegister("frfnt", function(module, exports) {

let $b3d54e4929f6deed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b3d54e4929f6deed$var$load("dpeU1").then(()=>parcelRequire('7NPrx'));

});

parcelRegister("inUxe", function(module, exports) {

let $d6263aa9aaf97319$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6263aa9aaf97319$var$load("4A3f7").then(()=>parcelRequire('i2p5v'));

});

parcelRegister("flQhK", function(module, exports) {

let $b2d15ff40d112e1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2d15ff40d112e1a$var$load("1BVEq").then(()=>parcelRequire('2AtWd'));

});

parcelRegister("1OMhC", function(module, exports) {

let $152fe9fdf836feb6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $152fe9fdf836feb6$var$load("jUMMO").then(()=>parcelRequire('9jC9P'));

});

parcelRegister("81qiI", function(module, exports) {

let $5d72d1878359424d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d72d1878359424d$var$load("bQCV5").then(()=>parcelRequire('7b1u7'));

});

parcelRegister("3BqL6", function(module, exports) {

let $29f99587fdb562da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29f99587fdb562da$var$load("7dDmH").then(()=>parcelRequire('lPInm'));

});

parcelRegister("jGcQ3", function(module, exports) {

let $e53be605e2a21597$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e53be605e2a21597$var$load("jBsSN").then(()=>parcelRequire('3DVt4'));

});

parcelRegister("1uDtI", function(module, exports) {

let $1167375c057b5bc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1167375c057b5bc2$var$load("4Av21").then(()=>parcelRequire('jtGep'));

});

parcelRegister("lduSs", function(module, exports) {

let $f722c376c99fdc71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f722c376c99fdc71$var$load("9P1aS").then(()=>parcelRequire('c8Q2n'));

});

parcelRegister("7rL6x", function(module, exports) {

let $56bf97f6c3a53761$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56bf97f6c3a53761$var$load("ME74m").then(()=>parcelRequire('4vFQJ'));

});

parcelRegister("13N5z", function(module, exports) {

let $0c5c264e28184ba9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c5c264e28184ba9$var$load("16muz").then(()=>parcelRequire('8S2d5'));

});

parcelRegister("6p4u1", function(module, exports) {

let $4a988e211cfb73b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a988e211cfb73b3$var$load("44AF2").then(()=>parcelRequire('MeKSQ'));

});

parcelRegister("hmV0j", function(module, exports) {

let $ca50b58dabdae38c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca50b58dabdae38c$var$load("4dVgm").then(()=>parcelRequire('hBhq3'));

});

parcelRegister("82CEB", function(module, exports) {

let $5dac7e788e55864b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5dac7e788e55864b$var$load("2IyJP").then(()=>parcelRequire('hv1Az'));

});

parcelRegister("cqbvt", function(module, exports) {

let $90b0d6b52ebaa0f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $90b0d6b52ebaa0f4$var$load("hdZjB").then(()=>parcelRequire('aoRVr'));

});

parcelRegister("4OMwv", function(module, exports) {

let $382178a0864d5cfe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $382178a0864d5cfe$var$load("bSySW").then(()=>parcelRequire('Cam0x'));

});

parcelRegister("aTMcN", function(module, exports) {

let $7ef46f0c79a2ac2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ef46f0c79a2ac2d$var$load("jFPli").then(()=>parcelRequire('hjEHA'));

});

parcelRegister("cSl8T", function(module, exports) {

let $95faeda1d3929df8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95faeda1d3929df8$var$load("tpYwC").then(()=>parcelRequire('cn7RC'));

});

parcelRegister("grGrh", function(module, exports) {

let $bf901678f6ad1f5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf901678f6ad1f5a$var$load("ijyQj").then(()=>parcelRequire('9E78Q'));

});

parcelRegister("4fT85", function(module, exports) {

let $319353b56d137ead$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $319353b56d137ead$var$load("8eCH0").then(()=>parcelRequire('io0Lo'));

});

parcelRegister("hsL5e", function(module, exports) {

let $cb6992f8a1f9faac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb6992f8a1f9faac$var$load("LclDr").then(()=>parcelRequire('d2zPy'));

});

parcelRegister("8nApX", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("dkP8f", function(module, exports) {

let $9b54ce59ed110425$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b54ce59ed110425$var$load("gk64V").then(()=>parcelRequire('5IIdf'));

});

parcelRegister("9K0ut", function(module, exports) {

let $7178ca59f16d3321$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7178ca59f16d3321$var$load("fsnzn").then(()=>parcelRequire('4vVNg'));

});

parcelRegister("erGSk", function(module, exports) {

let $a844d86a68519c66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a844d86a68519c66$var$load("8JWF2").then(()=>parcelRequire('9LjTG'));

});

parcelRegister("xzGgN", function(module, exports) {

let $064ec2a40134f30e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $064ec2a40134f30e$var$load("czxXO").then(()=>parcelRequire('04Nh9'));

});

parcelRegister("afhQo", function(module, exports) {

let $7759258c9f1a7b40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7759258c9f1a7b40$var$load("2SHBN").then(()=>parcelRequire('6isq3'));

});

parcelRegister("418JS", function(module, exports) {

let $2ece08ca9ce0fd9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ece08ca9ce0fd9f$var$load("8Vsnm").then(()=>parcelRequire('jHZA4'));

});

parcelRegister("2bn0B", function(module, exports) {

let $196e74ec3e2071d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $196e74ec3e2071d4$var$load("ll2xm").then(()=>parcelRequire('CHhGe'));

});

parcelRegister("4bOOa", function(module, exports) {

let $30cf99f6bd7943b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $30cf99f6bd7943b0$var$load("30zeN").then(()=>parcelRequire('bLNg4'));

});

parcelRegister("euHFi", function(module, exports) {

let $a8d5bd05841ae516$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8d5bd05841ae516$var$load("asSvh").then(()=>parcelRequire('24p1b'));

});

parcelRegister("9FYQQ", function(module, exports) {

let $70b72535ff06630a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70b72535ff06630a$var$load("ko3ZY").then(()=>parcelRequire('felsP'));

});

parcelRegister("9PYIr", function(module, exports) {

let $7297f964468a3efa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7297f964468a3efa$var$load("8hhkt").then(()=>parcelRequire('l8yVa'));

});

parcelRegister("aOs9j", function(module, exports) {

let $7df468bccc4a7c9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7df468bccc4a7c9e$var$load("3hBeC").then(()=>parcelRequire('lVZTS'));

});

parcelRegister("apYGp", function(module, exports) {

let $795b4f8a55492cc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $795b4f8a55492cc8$var$load("5yF0J").then(()=>parcelRequire('c8PQm'));

});

parcelRegister("bQEQ9", function(module, exports) {

let $8a043b0777e302a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a043b0777e302a3$var$load("a6jC4").then(()=>parcelRequire('7GItp'));

});

parcelRegister("9gMNA", function(module, exports) {

let $6bfb761abb00b843$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6bfb761abb00b843$var$load("aFMAu").then(()=>parcelRequire('10yxD'));

});

parcelRegister("bUcVf", function(module, exports) {

let $8aaef2c627fae52c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8aaef2c627fae52c$var$load("8oLhH").then(()=>parcelRequire('kQgQ4'));

});

parcelRegister("bE0oF", function(module, exports) {

let $87a3bcf80800cec9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $87a3bcf80800cec9$var$load("8cxcS").then(()=>parcelRequire('kzpl0'));

});

parcelRegister("dcBMI", function(module, exports) {

let $99c9b49a3c631fc6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99c9b49a3c631fc6$var$load("20mGg").then(()=>parcelRequire('bQEeI'));

});

parcelRegister("eayvQ", function(module, exports) {

let $a50cc552e900f8a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a50cc552e900f8a3$var$load("d4idW").then(()=>parcelRequire('3arua'));

});

parcelRegister("ktNCp", function(module, exports) {

let $ee8d014708fcfbe2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee8d014708fcfbe2$var$load("9pe2W").then(()=>parcelRequire('iWqAW'));

});

parcelRegister("iF5CO", function(module, exports) {

let $d9606b597a3b6709$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9606b597a3b6709$var$load("f9Y88").then(()=>parcelRequire('38lNl'));

});

parcelRegister("7ynNQ", function(module, exports) {

let $57fe2c29da44e0c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57fe2c29da44e0c3$var$load("h5YWz").then(()=>parcelRequire('jUTzs'));

});

parcelRegister("cRdXf", function(module, exports) {

let $95c542623c2f474c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95c542623c2f474c$var$load("6zoXD").then(()=>parcelRequire('3FJdS'));

});

parcelRegister("431S1", function(module, exports) {

let $2f28e4a35ee4728e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f28e4a35ee4728e$var$load("e1zG7").then(()=>parcelRequire('bbMoQ'));

});

parcelRegister("cLOXU", function(module, exports) {

let $94c16874f8ca58e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94c16874f8ca58e4$var$load("gOG0m").then(()=>parcelRequire('k6JMo'));

});

parcelRegister("9k4WX", function(module, exports) {

let $6c99d2476fa77929$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c99d2476fa77929$var$load("jnwxR").then(()=>parcelRequire('fvdnX'));

});

parcelRegister("kuR5A", function(module, exports) {

let $eebfca5cd355b1f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eebfca5cd355b1f0$var$load("kdhLI").then(()=>parcelRequire('ghdUi'));

});

parcelRegister("8mOnM", function(module, exports) {

let $617775c07208347b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $617775c07208347b$var$load("jLmcr").then(()=>parcelRequire('dnrkl'));

});

parcelRegister("aSGVv", function(module, exports) {

let $7ec03ed340617d62$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ec03ed340617d62$var$load("14wFt").then(()=>parcelRequire('3cCIn'));

});

parcelRegister("akt5W", function(module, exports) {

let $785257423d4cf3dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $785257423d4cf3dd$var$load("88BSo").then(()=>parcelRequire('4RFM5'));

});

parcelRegister("6Mt5i", function(module, exports) {

let $4efdc95a52796118$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4efdc95a52796118$var$load("i8jRD").then(()=>parcelRequire('k1d4Y'));

});

parcelRegister("fSpz2", function(module, exports) {

let $b8efbaacc4227d0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8efbaacc4227d0f$var$load("bdOCZ").then(()=>parcelRequire('1JGyY'));

});

parcelRegister("10c2u", function(module, exports) {

let $0baf213eb796a2b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0baf213eb796a2b3$var$load("e5Kbr").then(()=>parcelRequire('l9pzx'));

});

parcelRegister("fzjVn", function(module, exports) {

let $b55994800bef8bad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b55994800bef8bad$var$load("Ck85q").then(()=>parcelRequire('lnuY1'));

});

parcelRegister("kHXyL", function(module, exports) {
module.exports = JSON.parse('{"mercury.mercury-default-mentioned-in-comment.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"article"},{"type":0,"value":" "},{"type":1,"value":"typeName"}],"mercury.mercury-groups-configure-permissions.message-template.email.configurePermissions":[{"type":0,"value":"Manage permissions"}],"mercury.mercury-groups-configure-permissions.message-template.email.footerText":[{"type":0,"value":"You received this email because you\u2019re a Focus app admin for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"mercury.mercury-groups-configure-permissions.message-template.email.footerTextRedacted":[{"type":0,"value":"You received this email because you\u2019re a Focus app admin for your organization."}],"mercury.mercury-groups-configure-permissions.message-template.email.heading":[{"type":0,"value":"Review permissions for Focus user groups"}],"mercury.mercury-groups-configure-permissions.message-template.email.introduction":[{"type":0,"value":"Some user groups in your organization require your attention. This happens when:"}],"mercury.mercury-groups-configure-permissions.message-template.email.introductionItem1":[{"type":0,"value":"1. A new group has been added to Focus, or"}],"mercury.mercury-groups-configure-permissions.message-template.email.introductionItem2":[{"type":0,"value":"2. An existing group\'s role for the Focus app has changed in Atlassian Administration."}],"mercury.mercury-groups-configure-permissions.message-template.email.learnMore":[{"type":0,"value":"Learn more about group permissions"}],"mercury.mercury-groups-configure-permissions.message-template.email.subject.no-translate":[{"type":0,"value":"Action needed: review permissions in the Focus app"}],"mercury.mercury-groups-configure-permissions.message-template.email.whatToDoNext":[{"type":0,"value":"Please review and enable permissions for these groups so impacted users can start using Focus."}],"mercury.mercury-monthly-digest.email.arrow-icon.alt":[{"type":0,"value":"arrow-icon"}],"mercury.mercury-monthly-digest.email.arrow-right-icon.alt":[{"type":0,"value":"arrow-right-icon"}],"mercury.mercury-monthly-digest.email.calendar-icon.alt":[{"type":0,"value":"calendar-icon"}],"mercury.mercury-monthly-digest.email.catch.up.link":[{"type":0,"value":"Jump into Atlassian Focus"}],"mercury.mercury-monthly-digest.email.catch.up.text":[{"type":0,"value":"Want to catch up on previous updates? "},{"type":1,"value":"link"}],"mercury.mercury-monthly-digest.email.date-changed":[{"type":0,"value":"Date Changed"}],"mercury.mercury-monthly-digest.email.focus-area-icon.alt":[{"type":0,"value":"Focus area icon"}],"mercury.mercury-monthly-digest.email.footer.atlassian-logo.alt":[{"type":0,"value":"Atlassian footer"}],"mercury.mercury-monthly-digest.email.footer.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Focus"}],"mercury.mercury-monthly-digest.email.footer.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"mercury.mercury-monthly-digest.email.for":[{"type":0,"value":"for"}],"mercury.mercury-monthly-digest.email.header.logoAltText":[{"type":0,"value":"Focus Logo"}],"mercury.mercury-monthly-digest.email.no-target-date.alt":[{"type":0,"value":"No target date set"}],"mercury.mercury-monthly-digest.email.status-changed":[{"type":0,"value":"Status changed"}],"mercury.mercury-monthly-digest.email.total-following.sub-header":[{"type":0,"value":"You\'re following "},{"type":1,"value":"total"},{"type":0,"value":" active focus areas, here\'s the breakdown."}],"mercury.mercury-monthly-digest.email.view-update":[{"type":0,"value":"View Update"}],"mercury.mercury-monthly-digest.message-template.email.subject.no-translate":[{"type":1,"value":"name"},{"type":0,"value":", here are your monthly focus area updates"}],"mercury.mercury-re-engage-empty-focus-area.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.body.multiple.no-translate":[{"type":0,"value":"Your focus areas are off to a great start, but they\'re missing a few key pieces to unlock their full value. Complete setup in just a few minutes:"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.body.single.no-translate":[{"type":0,"value":"Your focus area is off to a great start, but it\'s missing a few key pieces to unlock its full value. Complete setup in just a few minutes:"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.cta.multiple.no-translate":[{"type":0,"value":"View Your Focus Areas"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.cta.single.no-translate":[{"type":0,"value":"View Focus Area"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.add-context.description.no-translate":[{"type":0,"value":"Use the About section to describe what success looks like and why "},{"type":1,"value":"focusAreaName"},{"type":0,"value":" matters to your team."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.add-context.title.no-translate":[{"type":0,"value":"Add more context"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.bring-in-team.description.no-translate":[{"type":0,"value":"Invite teammates as followers so they\'re automatically notified of important updates and milestones."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.bring-in-team.title.no-translate":[{"type":0,"value":"Bring in your team"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.connect-work-goals.description.no-translate":[{"type":0,"value":"Link your Goals and work from Jira Align, Jira Software, and Atlassian Projects to get strategic insights on execution."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.connect-work-goals.title.no-translate":[{"type":0,"value":"Connect work & goals"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.focus-area-icon.alt.no-translate":[{"type":0,"value":"Focus area icon"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.address.no-translate":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.atlassian-logo-alt.no-translate":[{"type":0,"value":"Atlassian"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.copyright.no-translate":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.sent-by.no-translate":[{"type":0,"value":"This email was sent to you by Atlassian Focus"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.unsubscribe.no-translate":[{"type":0,"value":"unsubscribe"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.greeting.no-translate":[{"type":0,"value":"\uD83D\uDC4B Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.more-link.no-translate":[{"type":0,"value":"+ "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.pre-header.no-translate":[{"type":0,"value":"Connect work, add context, and bring your team in."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.second-cta.body.no-translate":[{"type":0,"value":"Complete setup to help your team stay aligned on strategy."}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.second-cta.button.no-translate":[{"type":0,"value":"Go to Focus"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.second-cta.heading.no-translate":[{"type":0,"value":"Ready to jump back into Focus?"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.multiple.no-translate":[{"type":1,"value":"focusAreaName"},{"type":0,"value":" and others are empty \u2014 let\'s get started"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.redacted.multiple.no-translate":[{"type":0,"value":"Your focus areas are empty \u2014 let\'s get started"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.redacted.single.no-translate":[{"type":0,"value":"Your focus area is empty \u2014 let\'s get started"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.single.no-translate":[{"type":1,"value":"focusAreaName"},{"type":0,"value":" is empty \u2014 let\'s get started"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.three-ways-heading.multiple.no-translate":[{"type":0,"value":"3 ways to bring your focus areas to life:"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.three-ways-heading.no-translate":[{"type":0,"value":"3 ways to bring your focus area to life:"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.title.multiple.no-translate":[{"type":0,"value":"Let\'s get your focus areas set up for success"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.title.single.no-translate":[{"type":0,"value":"Let\'s get your focus area set up for success"}],"mercury.mercury-re-engage-empty-focus-area.message-template.email.view-focus-area-button.no-translate":[{"type":0,"value":"View Focus Area"}],"mercury.mercury-re-engage-pending-status-update.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.body.multiple.no-translate":[{"type":0,"value":"It\'s been a while since your focus areas were updated. Sharing regular updates keeps everyone aligned and helps your team understand progress."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.body.single.no-translate":[{"type":0,"value":"It\'s been a while since your focus area was updated. Sharing regular updates keeps everyone aligned and helps your team understand progress."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature-highlights.heading.no-translate":[{"type":0,"value":"Now it\'s even easier to write updates"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature-icon.alt.no-translate":[{"type":0,"value":"Feature icon"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.ai-summary.description.no-translate":[{"type":0,"value":"Need help drafting an update? Use Rovo to **summarize** focus areas and quickly surface key risks, highlights, challenges, and more."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.ai-summary.title.no-translate":[{"type":0,"value":"AI Summary"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.inline-looms.description.no-translate":[{"type":0,"value":"Record a **Loom** directly in the update composer to walk teammates through key details and add a personal touch."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.inline-looms.title.no-translate":[{"type":0,"value":"In-line Looms"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.update-notifications.description.no-translate":[{"type":0,"value":"Set up **automations** to send a notification via Slack, Microsoft Teams, or email whenever you post an update."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.feature.update-notifications.title.no-translate":[{"type":0,"value":"Update Notifications"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.focus-area-icon.alt.no-translate":[{"type":0,"value":"Focus area icon"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.focus-area-illustration.alt.no-translate":[{"type":0,"value":"Focus area update workflow illustration"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.footer.address.no-translate":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.footer.atlassian-logo-alt.no-translate":[{"type":0,"value":"Atlassian"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.footer.copyright.no-translate":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.footer.sent-by.no-translate":[{"type":0,"value":"This email was sent to you by Atlassian Focus"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.footer.unsubscribe.no-translate":[{"type":0,"value":"unsubscribe"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.greeting.no-translate":[{"type":0,"value":"\uD83D\uDC4B Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"mercury.mercury-re-engage-pending-status-update.message-template.email.last-update-text.no-translate":[{"type":0,"value":"Last updated "},{"type":1,"value":"relativeDate"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.more-link.no-translate":[{"type":0,"value":"+ "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.post-update-button.no-translate":[{"type":0,"value":"Post Update"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.pre-header.no-translate":[{"type":0,"value":"Keep your team aligned with your latest progress."}],"mercury.mercury-re-engage-pending-status-update.message-template.email.second-cta.body.no-translate":[{"type":0,"value":"Update your team and keep momentum going"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.second-cta.button.no-translate":[{"type":0,"value":"Go to Focus"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.second-cta.heading.no-translate":[{"type":0,"value":"Ready to jump back into Focus?"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.subject.multiple.no-translate":[{"type":1,"value":"focusAreaName"},{"type":0,"value":" and others are waiting for an update"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.subject.redacted.multiple.no-translate":[{"type":0,"value":"Your focus areas are waiting for an update"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.subject.redacted.single.no-translate":[{"type":0,"value":"Your focus area is waiting for an update"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.subject.single.no-translate":[{"type":1,"value":"focusAreaName"},{"type":0,"value":" is waiting for an update"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.title.multiple.no-translate":[{"type":0,"value":"Share what\'s new with your focus areas"}],"mercury.mercury-re-engage-pending-status-update.message-template.email.title.single.no-translate":[{"type":0,"value":"Share what\'s new with your focus area"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.custom-fields.description.no-translate":[{"type":0,"value":"Create custom fields (text, number, and select) for Focus areas to capture the data that matters most."}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.custom-fields.title.no-translate":[{"type":0,"value":"Custom Fields"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.focus-area-permissions.description.no-translate":[{"type":0,"value":"Control who can edit each Focus area to maintain clear ownership and precise access."}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.focus-area-permissions.title.no-translate":[{"type":0,"value":"Focus Area Permissions"}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.work-linking-automations.description.no-translate":[{"type":0,"value":"Automatically keep Jira work linked to the right Focus area based on custom field values in work items."}],"mercury.mercury-re-engage-whats-new.feature-highlights.default.work-linking-automations.title.no-translate":[{"type":0,"value":"Work Linking Automations"}],"mercury.mercury-re-engage-whats-new.feature-highlights.heading.no-translate":[{"type":0,"value":"Feature highlights"}],"mercury.mercury-re-engage-whats-new.feature-highlights.icon.alt.no-translate":[{"type":0,"value":"Feature icon"}],"mercury.mercury-re-engage-whats-new.feature-highlights.learn-more":[{"type":0,"value":"Learn more"}],"mercury.mercury-re-engage-whats-new.feature-highlights.subheading.no-translate":[{"type":0,"value":"See what\'s new and improved in Focus."}],"mercury.mercury-re-engage-whats-new.focus-area-summary.heading.no-translate":[{"type":0,"value":"Your team has created "},{"type":1,"value":"noOfFocusAreas"},{"type":0,"value":" new focus areas \u2014 follow to get notified of progress."}],"mercury.mercury-re-engage-whats-new.focus-area-summary.more-link.no-translate":[{"type":0,"value":"+ "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"mercury.mercury-re-engage-whats-new.focus-area-summary.owned-heading.no-translate":[{"type":0,"value":"Focus areas you own"}],"mercury.mercury-re-engage-whats-new.focus-area-summary.recently-created-heading.no-translate":[{"type":0,"value":"Focus areas your team has created"}],"mercury.mercury-re-engage-whats-new.focus-area-summary.view-all.no-translate":[{"type":0,"value":"View all Focus Areas"}],"mercury.mercury-re-engage-whats-new.focus-area-summary.watched-heading.no-translate":[{"type":0,"value":"Focus areas you follow"}],"mercury.mercury-re-engage-whats-new.focus-area.created-by.no-translate":[{"type":1,"value":"relativeDate"},{"type":0,"value":" \xb7 created by "},{"type":1,"value":"userName"}],"mercury.mercury-re-engage-whats-new.focus-area.created-date.no-translate":[{"type":1,"value":"relativeDate"}],"mercury.mercury-re-engage-whats-new.focus-area.created.days-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" day ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" days ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.hours-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" hour ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" hours ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.minutes-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" minute ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" minutes ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.months-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" month ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" months ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.seconds-ago.no-translate":[{"offset":0,"options":{"=0":{"value":[{"type":0,"value":"just now"}]},"=1":{"value":[{"type":7},{"type":0,"value":" second ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" seconds ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.created.weeks-ago.no-translate":[{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":" week ago"}]},"other":{"value":[{"type":7},{"type":0,"value":" weeks ago"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"mercury.mercury-re-engage-whats-new.focus-area.icon.alt-text":[{"type":0,"value":"Focus area icon"}],"mercury.mercury-re-engage-whats-new.focus-area.status-date.no-translate":[{"type":1,"value":"status"},{"type":0,"value":" \u2022 "},{"type":1,"value":"date"}],"mercury.mercury-re-engage-whats-new.focus-area.status.at-risk.no-translate":[{"type":0,"value":"At Risk"}],"mercury.mercury-re-engage-whats-new.focus-area.status.completed.no-translate":[{"type":0,"value":"Completed"}],"mercury.mercury-re-engage-whats-new.focus-area.status.off-track.no-translate":[{"type":0,"value":"Off Track"}],"mercury.mercury-re-engage-whats-new.focus-area.status.on-track.no-translate":[{"type":0,"value":"On Track"}],"mercury.mercury-re-engage-whats-new.focus-area.status.paused.no-translate":[{"type":0,"value":"Paused"}],"mercury.mercury-re-engage-whats-new.focus-area.status.pending.no-translate":[{"type":0,"value":"Pending"}],"mercury.mercury-re-engage-whats-new.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"mercury.mercury-re-engage-whats-new.follow-button.no-translate":[{"type":0,"value":"Follow"}],"mercury.mercury-re-engage-whats-new.innovation-spotlight.cta-text.no-translate":[{"type":0,"value":"Read the Blog"}],"mercury.mercury-re-engage-whats-new.innovation-spotlight.description.no-translate":[{"type":0,"value":"Want to learn more? Check out everything that\'s shipped in Strategy Collection since Team \'25 Europe."}],"mercury.mercury-re-engage-whats-new.innovation-spotlight.heading.no-translate":[{"type":0,"value":"See the full Innovation Spotlight"}],"mercury.mercury-re-engage-whats-new.message-template.email.banner.alt.no-translate":[{"type":0,"value":"Strategy Collection"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.address.no-translate":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.atlassian-logo-alt.no-translate":[{"type":0,"value":"Atlassian"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.copyright.no-translate":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.sent-by.no-translate":[{"type":0,"value":"This email was sent to you by Atlassian Focus"}],"mercury.mercury-re-engage-whats-new.message-template.email.footer.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"mercury.mercury-re-engage-whats-new.message-template.email.header.greeting.no-translate":[{"type":0,"value":"\uD83D\uDC4B Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"mercury.mercury-re-engage-whats-new.message-template.email.header.no-translate":[{"type":0,"value":"Welcome to your Focus snapshot"}],"mercury.mercury-re-engage-whats-new.message-template.email.pre-header.no-translate":[{"type":0,"value":"Catch up on your Focus areas and explore what\'s new."}],"mercury.mercury-re-engage-whats-new.message-template.email.subject.no-translate":[{"type":0,"value":"Your Focus Snapshot"}],"mercury.mercury-re-engage-whats-new.test-message.email.header.sub-text.no-translate":[{"type":0,"value":"Your bi-monthly update on the Focus areas you care about \u2014 plus what\'s new."}],"mercury.mercury-re-engage-whats-new.view-focus-area-button.no-translate":[{"type":0,"value":"View Focus Area"}],"mercury.mercury-risk-assigned-organization.notification-drawer.message.title.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" assigned "},{"type":1,"value":"organizationName"},{"type":0,"value":" to a risk"}],"mercury.mercury-risk-assigned-organization.notification-drawer.path.status.no-translate":[{"type":0,"value":"Risk \u2022 "},{"type":1,"value":"status"}],"mercury.mercury-risk-assigned-owner.notification-drawer.message.title.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" made you the owner of a risk"}],"mercury.mercury-risk-assigned-owner.notification-drawer.path.status.no-translate":[{"type":0,"value":"Risk \u2022 "},{"type":1,"value":"status"}],"mercury.mercury-risk-assigned-submitter.notification-drawer.message.title.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" made you the submitter of a risk"}],"mercury.mercury-risk-assigned-submitter.notification-drawer.path.status.no-translate":[{"type":0,"value":"Risk \u2022 "},{"type":1,"value":"status"}],"mercury.mercury-risk-ownership-updated.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" updated your page"}],"mercury.mercury-risk-updated-date.notification-drawer.message.title.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" updated the target date"}],"mercury.mercury-risk-updated-date.notification-drawer.path.status.no-translate":[{"type":0,"value":"Risk \u2022 "},{"type":1,"value":"status"}]}');

});

parcelRegister("1d7Xm", function(module, exports) {

let $0e1d2d50638aa04a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e1d2d50638aa04a$var$load("233DY").then(()=>parcelRequire('fKwU8'));

});

parcelRegister("fhIlA", function(module, exports) {

let $b20ad7fe56e41be9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b20ad7fe56e41be9$var$load("fPDWC").then(()=>parcelRequire('35reh'));

});

parcelRegister("97nLs", function(module, exports) {

let $6a3733a367b8118e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a3733a367b8118e$var$load("1nNbp").then(()=>parcelRequire('jvqSD'));

});

parcelRegister("hnGKA", function(module, exports) {

let $ca75befe454ca2c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca75befe454ca2c7$var$load("kVG1M").then(()=>parcelRequire('kNDd8'));

});

parcelRegister("3Lnvg", function(module, exports) {

let $2bd7fe26a209d908$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bd7fe26a209d908$var$load("2dw9h").then(()=>parcelRequire('i7wi3'));

});

parcelRegister("2uM3C", function(module, exports) {

let $1d13a94d7213469a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d13a94d7213469a$var$load("eHGzF").then(()=>parcelRequire('dqYiy'));

});

parcelRegister("8yElw", function(module, exports) {

let $63b0cb9cfcd9150e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $63b0cb9cfcd9150e$var$load("7ogxc").then(()=>parcelRequire('8OCzv'));

});

parcelRegister("auCC2", function(module, exports) {

let $7a3aa859523330fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a3aa859523330fc$var$load("fDdMl").then(()=>parcelRequire('2Iidu'));

});

parcelRegister("3WFy2", function(module, exports) {

let $2df70474e112b4db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2df70474e112b4db$var$load("aV0w9").then(()=>parcelRequire('eVkih'));

});

parcelRegister("4vHmF", function(module, exports) {

let $348bb1f66c5233d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $348bb1f66c5233d5$var$load("j1eUL").then(()=>parcelRequire('5KSuP'));

});

parcelRegister("lYcKE", function(module, exports) {

let $ffe917c3a7be8151$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ffe917c3a7be8151$var$load("cc1H3").then(()=>parcelRequire('bDSsV'));

});

parcelRegister("9G9oT", function(module, exports) {

let $70bf540ac3fcefc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70bf540ac3fcefc5$var$load("iBJl3").then(()=>parcelRequire('iwR1g'));

});

parcelRegister("8iP56", function(module, exports) {

let $60b7a0d982553695$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $60b7a0d982553695$var$load("lYlZW").then(()=>parcelRequire('51pqL'));

});

parcelRegister("iDdYL", function(module, exports) {

let $d906b67297d20a1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d906b67297d20a1d$var$load("deZDr").then(()=>parcelRequire('mkvWp'));

});

parcelRegister("7sVxF", function(module, exports) {

let $56f7c8961670fdce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56f7c8961670fdce$var$load("iZvLM").then(()=>parcelRequire('3LR6X'));

});

parcelRegister("1NRP3", function(module, exports) {

let $15041e0e94c94573$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $15041e0e94c94573$var$load("ejFfH").then(()=>parcelRequire('7299x'));

});

parcelRegister("eSyFb", function(module, exports) {

let $ad50ff3a0c162144$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ad50ff3a0c162144$var$load("9XWAe").then(()=>parcelRequire('ckkq8'));

});

parcelRegister("jiKDf", function(module, exports) {

let $e0d3dee97e37f57a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0d3dee97e37f57a$var$load("cjEpc").then(()=>parcelRequire('4wXd5'));

});

parcelRegister("lOf4U", function(module, exports) {

let $fe09f6b4561f70d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fe09f6b4561f70d6$var$load("fKD9g").then(()=>parcelRequire('1WAgc'));

});

parcelRegister("14cLa", function(module, exports) {

let $0c700ff866d40d95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c700ff866d40d95$var$load("4p1M4").then(()=>parcelRequire('7vChv'));

});

parcelRegister("7gvhr", function(module, exports) {

let $54a24aa51b90be98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54a24aa51b90be98$var$load("6F9Q6").then(()=>parcelRequire('68T1m'));

});

parcelRegister("isYx2", function(module, exports) {

let $d719cbe6ef09f58d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d719cbe6ef09f58d$var$load("eAqp7").then(()=>parcelRequire('8zEpB'));

});

parcelRegister("2ivap", function(module, exports) {

let $1ac57049a24f3731$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ac57049a24f3731$var$load("eLnWW").then(()=>parcelRequire('hIbcI'));

});

parcelRegister("bspFP", function(module, exports) {

let $857639795340119b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $857639795340119b$var$load("3oq4x").then(()=>parcelRequire('inFdk'));

});

parcelRegister("iT7Bj", function(module, exports) {

let $dc034268eb8c7529$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc034268eb8c7529$var$load("hrbca").then(()=>parcelRequire('iUZjn'));

});

parcelRegister("1ufvN", function(module, exports) {

let $1154a01f93764fe8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1154a01f93764fe8$var$load("hjKX1").then(()=>parcelRequire('a3ED6'));

});

parcelRegister("gummO", function(module, exports) {

let $c010cc4771b297b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c010cc4771b297b1$var$load("aOoSy").then(()=>parcelRequire('7jnAA'));

});

parcelRegister("4kqhJ", function(module, exports) {

let $326d6b4fd96be8d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $326d6b4fd96be8d7$var$load("gDItP").then(()=>parcelRequire('SCLJM'));

});

parcelRegister("gip1e", function(module, exports) {

let $bdd1bc03597b82e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bdd1bc03597b82e1$var$load("p1FD0").then(()=>parcelRequire('8vZ67'));

});

parcelRegister("lRss2", function(module, exports) {

let $fea49e0a4b3da52b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fea49e0a4b3da52b$var$load("4cWYg").then(()=>parcelRequire('cC6lI'));

});

parcelRegister("kSxqn", function(module, exports) {

let $f332c7356b9f6e94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f332c7356b9f6e94$var$load("afWwx").then(()=>parcelRequire('dfKtg'));

});

parcelRegister("452Wi", function(module, exports) {

let $2f89e8b6d831d8ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f89e8b6d831d8ec$var$load("1rCyU").then(()=>parcelRequire('6aXrQ'));

});

parcelRegister("jJkiB", function(module, exports) {

let $e5d1f73e913b63b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5d1f73e913b63b4$var$load("9iSQB").then(()=>parcelRequire('c3n3p'));

});

parcelRegister("fVcfA", function(module, exports) {

let $b975ae8fb90b3bdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b975ae8fb90b3bdd$var$load("anqUS").then(()=>parcelRequire('rAGPp'));

});

parcelRegister("3nDO6", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6YvRD = parcelRequire("6YvRD");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8393a846181017db$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8393a846181017db$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8393a846181017db$var$importHelper(await (parcelRequire("3MpkQ")));
        case 'da':
            return $8393a846181017db$var$importHelper(await (parcelRequire("byKYQ")));
        case 'de':
            return $8393a846181017db$var$importHelper(await (parcelRequire("Ny4Dt")));
        case 'en-GB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("lwrPN")));
        case 'en-US':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cfGkc")));
        case 'en-XA':
            return $8393a846181017db$var$importHelper(await (parcelRequire("eBjVi")));
        case 'en-XB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("b9V4D")));
        case 'en-ZZ':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cjS15")));
        case 'en':
            return $8393a846181017db$var$importHelper(await Promise.resolve((parcelRequire("6YvRD"))));
        case 'es':
            return $8393a846181017db$var$importHelper(await (parcelRequire("fUiux")));
        case 'et':
            return $8393a846181017db$var$importHelper(await (parcelRequire("6DVur")));
        case 'fi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8FDQ0")));
        case 'fr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("7zYd1")));
        case 'hr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kUL2N")));
        case 'hu':
            return $8393a846181017db$var$importHelper(await (parcelRequire("6eZER")));
        case 'it':
            return $8393a846181017db$var$importHelper(await (parcelRequire("eUqg6")));
        case 'ja':
            return $8393a846181017db$var$importHelper(await (parcelRequire("at2wl")));
        case 'ko':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ihALB")));
        case 'nb':
            return $8393a846181017db$var$importHelper(await (parcelRequire("1ZGET")));
        case 'nl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("jIxnh")));
        case 'pl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("9WZ2j")));
        case 'pt-BR':
            return $8393a846181017db$var$importHelper(await (parcelRequire("bhB5c")));
        case 'ro':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ckNRb")));
        case 'ru':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ir1xn")));
        case 'sl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("di9OC")));
        case 'sr-RS':
            return $8393a846181017db$var$importHelper(await (parcelRequire("jIjgo")));
        case 'sr-YR':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8E5tZ")));
        case 'sr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("75Frc")));
        case 'sv':
            return $8393a846181017db$var$importHelper(await (parcelRequire("aCqVE")));
        case 'th':
            return $8393a846181017db$var$importHelper(await (parcelRequire("2q19p")));
        case 'tr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kP7UO")));
        case 'uk':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cJoPm")));
        case 'vi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("h62OK")));
        case 'zh-CN':
            return $8393a846181017db$var$importHelper(await (parcelRequire("95Xcn")));
        case 'zh-TW':
            return $8393a846181017db$var$importHelper(await (parcelRequire("dzsOs")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6YvRD));
    }
};
module.exports["messagesLoader"] = $8393a846181017db$export$720676d8cac8fbb;

});

parcelRegister("6YvRD", function(module, exports) {
module.exports = JSON.parse("{\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.titleForIssueComment\":[{\"type\":0,\"value\":\"Record your screen\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.titleForIssueDescription\":[{\"type\":0,\"value\":\"Record your screen\"}],\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.message-template.microsoft-teams.hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office-template.message-template.notification-drawer.message.no-translate\":[{\"type\":1,\"value\":\"actorName\"},{\"type\":0,\"value\":\" updated your page\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.browser-push-body.no-translate\":[{\"type\":0,\"value\":\"You are a lovely\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("3MpkQ", function(module, exports) {

let $2c0981d7c54f4e53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c0981d7c54f4e53$var$load("bv8GZ").then(()=>parcelRequire('74xff'));

});

parcelRegister("byKYQ", function(module, exports) {

let $022bfd294816e214$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $022bfd294816e214$var$load("cdeuH").then(()=>parcelRequire('hQIGt'));

});

parcelRegister("Ny4Dt", function(module, exports) {

let $094f020f0aa3b5f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $094f020f0aa3b5f7$var$load("7gF8f").then(()=>parcelRequire('j9sSr'));

});

parcelRegister("lwrPN", function(module, exports) {

let $fab22d73b102392e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fab22d73b102392e$var$load("djb49").then(()=>parcelRequire('4tVXT'));

});

parcelRegister("cfGkc", function(module, exports) {

let $8eb7b7970922d5fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8eb7b7970922d5fc$var$load("koawN").then(()=>parcelRequire('k7TQm'));

});

parcelRegister("eBjVi", function(module, exports) {

let $aa13f9b6f0cd2936$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa13f9b6f0cd2936$var$load("6htQT").then(()=>parcelRequire('lIWyQ'));

});

parcelRegister("b9V4D", function(module, exports) {

let $81fccea2c7692076$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $81fccea2c7692076$var$load("fi75i").then(()=>parcelRequire('5QCdA'));

});

parcelRegister("cjS15", function(module, exports) {

let $8f8128f149f291d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f8128f149f291d2$var$load("ksTQ6").then(()=>parcelRequire('4EAWY'));

});

parcelRegister("fUiux", function(module, exports) {

let $b94a6e00f1130c23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b94a6e00f1130c23$var$load("5CGnz").then(()=>parcelRequire('1PSNt'));

});

parcelRegister("6DVur", function(module, exports) {

let $4d62fae3367e8fba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d62fae3367e8fba$var$load("X0Jic").then(()=>parcelRequire('cNrRQ'));

});

parcelRegister("8FDQ0", function(module, exports) {

let $65010e043670e359$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65010e043670e359$var$load("9Oxgj").then(()=>parcelRequire('5L1ix'));

});

parcelRegister("7zYd1", function(module, exports) {

let $584a81908bcf6b02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $584a81908bcf6b02$var$load("kAg8V").then(()=>parcelRequire('f4vYC'));

});

parcelRegister("kUL2N", function(module, exports) {

let $f39d8798e3aacd6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f39d8798e3aacd6e$var$load("36XYg").then(()=>parcelRequire('jRDUE'));

});

parcelRegister("6eZER", function(module, exports) {

let $48b3e0de1ed42ace$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48b3e0de1ed42ace$var$load("fM2oh").then(()=>parcelRequire('lmfGu'));

});

parcelRegister("eUqg6", function(module, exports) {

let $adaaaa1542ad404d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $adaaaa1542ad404d$var$load("xnqy2").then(()=>parcelRequire('J7CId'));

});

parcelRegister("at2wl", function(module, exports) {

let $79ee915b8a5cfa5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79ee915b8a5cfa5f$var$load("awkVi").then(()=>parcelRequire('iEu8X'));

});

parcelRegister("ihALB", function(module, exports) {

let $d4f655a3a30906cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4f655a3a30906cd$var$load("11DLa").then(()=>parcelRequire('lklBt'));

});

parcelRegister("1ZGET", function(module, exports) {

let $173c9412aa2d6ea2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $173c9412aa2d6ea2$var$load("barSq").then(()=>parcelRequire('edhkG'));

});

parcelRegister("jIxnh", function(module, exports) {

let $e5ac03dff8d9aeff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5ac03dff8d9aeff$var$load("a8heY").then(()=>parcelRequire('aFb9z'));

});

parcelRegister("9WZ2j", function(module, exports) {

let $73e8e060a723dc38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73e8e060a723dc38$var$load("6hlNE").then(()=>parcelRequire('bAPfw'));

});

parcelRegister("bhB5c", function(module, exports) {

let $836e0c1dd75645f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $836e0c1dd75645f5$var$load("2bqSD").then(()=>parcelRequire('c1E8Q'));

});

parcelRegister("ckNRb", function(module, exports) {

let $8fae06d114550a7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8fae06d114550a7b$var$load("j6IGj").then(()=>parcelRequire('88y6K'));

});

parcelRegister("ir1xn", function(module, exports) {

let $d6bbf0de65f9bce4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6bbf0de65f9bce4$var$load("bJykp").then(()=>parcelRequire('8Rjw5'));

});

parcelRegister("di9OC", function(module, exports) {

let $9ad491ee252155d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ad491ee252155d7$var$load("7Rbde").then(()=>parcelRequire('awMdX'));

});

parcelRegister("jIjgo", function(module, exports) {

let $e5a111b573c22c47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5a111b573c22c47$var$load("l8auu").then(()=>parcelRequire('eNbID'));

});

parcelRegister("8E5tZ", function(module, exports) {

let $64b64febd9024da4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64b64febd9024da4$var$load("3ColL").then(()=>parcelRequire('YVOUf'));

});

parcelRegister("75Frc", function(module, exports) {

let $529924b6cea297fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $529924b6cea297fd$var$load("2VSOH").then(()=>parcelRequire('fEcqf'));

});

parcelRegister("aCqVE", function(module, exports) {

let $7bb257853d40c532$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7bb257853d40c532$var$load("dh2Er").then(()=>parcelRequire('6TlJn'));

});

parcelRegister("2q19p", function(module, exports) {

let $1c2ee6fb468abb06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c2ee6fb468abb06$var$load("kyBJI").then(()=>parcelRequire('7Nysq'));

});

parcelRegister("kP7UO", function(module, exports) {

let $f28eb5e89a23de79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f28eb5e89a23de79$var$load("eBLgB").then(()=>parcelRequire('1gaUd'));

});

parcelRegister("cJoPm", function(module, exports) {

let $944cf23be3b0d1a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $944cf23be3b0d1a4$var$load("ahhGv").then(()=>parcelRequire('bcwM6'));

});

parcelRegister("h62OK", function(module, exports) {

let $c7252eb9922192b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7252eb9922192b6$var$load("1Zesg").then(()=>parcelRequire('7fZ9R'));

});

parcelRegister("95Xcn", function(module, exports) {

let $69f280464f678177$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69f280464f678177$var$load("eLlpV").then(()=>parcelRequire('15VSW'));

});

parcelRegister("dzsOs", function(module, exports) {

let $9e14e4de0de5cb5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e14e4de0de5cb5f$var$load("bV8sS").then(()=>parcelRequire('dU88R'));

});

parcelRegister("6e6y3", function(module, exports) {
module.exports = JSON.parse('{"navx-smartlink-full-picture-auth-nudge.connect-button":[{"type":0,"value":"Connect"}],"navx-smartlink-full-picture-auth-nudge.connect-error-button":[{"type":0,"value":"Try again"}],"navx-smartlink-full-picture-auth-nudge.connect-permanent-error-label":[{"type":0,"value":"Failed to connect"}],"navx-smartlink-full-picture-auth-nudge.connected-button":[{"type":0,"value":"Connected"}],"navx-smartlink-full-picture-auth-nudge.connecting-label":[{"type":0,"value":"Connecting"}],"navx-smartlink-full-picture-auth-nudge.description":[{"type":0,"value":"Connect to preview what\'s inside. Your teammates have connected this app."}],"navx-smartlink-full-picture-auth-nudge.description-success":[{"type":0,"value":"Links now display as synced previews"}],"navx-smartlink-full-picture-auth-nudge.description-with-org-stat":[{"type":0,"value":"Connect to preview what\'s inside. "},{"children":[{"type":1,"value":"percent"},{"type":0,"value":"%"}],"type":8,"value":"b"},{"type":0,"value":" of your organization has connected this app."}],"navx-smartlink-full-picture-auth-nudge.dismiss-button":[{"type":0,"value":"Dismiss"}],"navx-smartlink-full-picture-auth-nudge.dont-show-again-button":[{"type":0,"value":"Don\'t show this again"}],"navx-smartlink-full-picture-auth-nudge.reload-to-see-previews":[{"type":0,"value":"Reload to see previews"}],"navx-smartlink-full-picture-auth-nudge.title":[{"type":0,"value":"See what\'s behind these "},{"type":1,"value":"providerName"},{"type":0,"value":" links"}],"navx-smartlink-full-picture-auth-nudge.title-success":[{"type":1,"value":"providerName"},{"type":0,"value":" connected"}],"post-office.rovo-extension-install-cta-rovo-chat-input.banner-cta-button":[{"type":0,"value":"Get extension"}],"post-office.rovo-extension-install-cta-rovo-chat-input.banner-description-compact":[{"type":0,"value":"Install the Chrome extension for instant, trusted answers anywhere you browse."}],"post-office.rovo-extension-install-cta-rovo-chat-input.banner-description-wide":[{"type":0,"value":"Download the Chrome extension to use Rovo in your browser. Get instant answers from trusted sources"}],"post-office.rovo-extension-install-cta-rovo-chat-input.banner-dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-extension-install-cta-rovo-chat-input.banner-title":[{"type":0,"value":"Use Rovo everywhere"}],"post-office.rovo-insights-full-page-chat-spotlight.body":[{"type":0,"value":"See weekly follow-ups just for you, team trends, company news, and more."}],"post-office.rovo-insights-full-page-chat-spotlight.got-it-button":[{"type":0,"value":"Got it"}],"post-office.rovo-insights-full-page-chat-spotlight.headline":[{"type":0,"value":"Start your week with insights"}],"post-office.rovo-insights-full-page-chat-spotlight.image-alt":[{"type":0,"value":"Insights spotlight banner"}],"rovo-button-onboarding-spotlight.copy-version-a.bodyText":[{"type":0,"value":"Connect the dots, simplify writing, and move projects forward."}],"rovo-button-onboarding-spotlight.copy-version-a.headlineText":[{"type":0,"value":"Your AI teammate is here"}],"rovo-button-onboarding-spotlight.getStartedButtonLabel":[{"type":0,"value":"Get started"}],"rovo-expansion-onboarding-checklist.ask-rovo-find":[{"type":0,"value":"Search for related work across your tools"}],"rovo-expansion-onboarding-checklist.ask-rovo-find-description":[{"type":0,"value":"Rovo searches across Jira, Confluence, and connected tools to find the work that unblocks you."}],"rovo-expansion-onboarding-checklist.automate-work":[{"type":0,"value":"Automate repetitive work with Rovo-powered flows"}],"rovo-expansion-onboarding-checklist.automate-work-description":[{"type":0,"value":"Get Rovo to automatically update key work item details like fields and labels, so you don\'t have to."}],"rovo-expansion-onboarding-checklist.browse-agents":[{"type":0,"value":"Browse agents to handle specialized work"}],"rovo-expansion-onboarding-checklist.browse-agents-description":[{"type":0,"value":"Build or use Rovo agents that know your team\'s context, can answer questions, write content, or take action."}],"rovo-expansion-onboarding-checklist.connect-work-tools":[{"type":0,"value":"Connect Rovo to "},{"type":1,"value":"appName"}],"rovo-expansion-onboarding-checklist.connect-work-tools-description":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" so Rovo can search and summarize work across your tools."}],"rovo-expansion-onboarding-checklist.deep-research":[{"type":0,"value":"Use deep research for complex work"}],"rovo-expansion-onboarding-checklist.deep-research-description":[{"type":0,"value":"Run deep research with Rovo to explore a complex issue and get a research-backed plan to move forward."}],"rovo-expansion-onboarding-checklist.deep-research-prompt":[{"type":0,"value":"Gather and synthesize customer feedback on my site from various channels (emails, calls, surveys, support tickets) to identify common pain points and areas for product enhancement over the past year."}],"rovo-expansion-onboarding-checklist.dismiss-button":[{"type":0,"value":"Dismiss"}],"rovo-expansion-onboarding-checklist.heading":[{"type":0,"value":"Get started working with your AI teammate"}],"rovo-expansion-onboarding-checklist.install-extension":[{"type":0,"value":"Install the Chrome Extension"}],"rovo-expansion-onboarding-checklist.install-extension-description":[{"type":0,"value":"Access Rovo from everywhere you work on the web."}],"rovo-expansion-onboarding-checklist.next-card":[{"type":0,"value":"Next tip"}],"rovo-expansion-onboarding-checklist.oauth-error-cancelled":[{"type":0,"value":"You cancelled the connection to "},{"type":1,"value":"appName"},{"type":0,"value":". Please try again."}],"rovo-expansion-onboarding-checklist.oauth-error-generic":[{"type":0,"value":"Something went wrong connecting "},{"type":1,"value":"appName"},{"type":0,"value":". Please try again."}],"rovo-expansion-onboarding-checklist.oauth-error-message-title":[{"type":0,"value":"Error connecting "},{"type":1,"value":"appName"},{"type":0,"value":". Please try again."}],"rovo-expansion-onboarding-checklist.options-menu-title":[{"type":0,"value":"Options"}],"rovo-expansion-onboarding-checklist.previous-card":[{"type":0,"value":"Previous tip"}],"rovo-expansion-onboarding-checklist.prompt-gallery":[{"type":0,"value":"Explore the prompt gallery"}],"rovo-expansion-onboarding-checklist.prompt-gallery-description":[{"type":0,"value":"See a gallery of tested Rovo prompts and use cases you can reuse instead of starting from scratch."}],"rovo-expansion-onboarding-checklist.subheading":[{"type":1,"value":"totalSteps"},{"type":0,"value":" easy steps to become a Rovo Pro"}],"rovo-expansion-onboarding-checklist.title.updated":[{"type":1,"value":"totalSteps"},{"type":0,"value":" Quick tips to power up your work with AI"}],"rovo-expansion-onboarding-checklist.try-it":[{"type":0,"value":"Try it"}],"rovo-expansion-onboarding-checklist.write-status-update":[{"type":0,"value":"Use Rovo to write your status update"}],"rovo-expansion-onboarding-checklist.write-status-update-description":[{"type":0,"value":"Convert your latest Jira activity into one clear, shareable status update"}],"rovo-expansion-onboarding-checklist.write-status-update-prompt":[{"type":0,"value":"Write an update about my week"}],"rovo-expansion.base-3p-rovo-email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo branded header"}],"rovo-expansion.base-3p-rovo-email.title":[{"type":0,"value":"Atlassian Rovo"}],"rovo-expansion.email.body.app-connect-card.add-connectors-button":[{"type":0,"value":"Add connectors"}],"rovo-expansion.email.body.app-connect-card.adobe.alt":[{"type":0,"value":"Adobe Sign logo"}],"rovo-expansion.email.body.app-connect-card.adobe.body":[{"type":0,"value":"Find the Adobe Sign agreements your team needs with ease"}],"rovo-expansion.email.body.app-connect-card.adobe.heading":[{"type":0,"value":"Adobe Sign"}],"rovo-expansion.email.body.app-connect-card.aha.alt":[{"type":0,"value":"Aha! logo"}],"rovo-expansion.email.body.app-connect-card.aha.body":[{"type":0,"value":"Quickly locate Aha! features you need"}],"rovo-expansion.email.body.app-connect-card.aha.heading":[{"type":0,"value":"Aha"}],"rovo-expansion.email.body.app-connect-card.airtable.alt":[{"type":0,"value":"Airtable logo"}],"rovo-expansion.email.body.app-connect-card.airtable.body":[{"type":0,"value":"Bring your data and records and make them searchable alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.airtable.heading":[{"type":0,"value":"Airtable"}],"rovo-expansion.email.body.app-connect-card.asana.alt":[{"type":0,"value":"Asana logo"}],"rovo-expansion.email.body.app-connect-card.asana.body":[{"type":0,"value":"Locate your team\'s work by searching Asana\'s tasks and subtasks"}],"rovo-expansion.email.body.app-connect-card.asana.heading":[{"type":0,"value":"Asana"}],"rovo-expansion.email.body.app-connect-card.azure.alt":[{"type":0,"value":"Azure DevOps logo"}],"rovo-expansion.email.body.app-connect-card.azure.body":[{"type":0,"value":"Quickly retrieve your Azure DevOps repositories"}],"rovo-expansion.email.body.app-connect-card.azure.heading":[{"type":0,"value":"Azure DevOps"}],"rovo-expansion.email.body.app-connect-card.box.alt":[{"type":0,"value":"Box logo"}],"rovo-expansion.email.body.app-connect-card.box.body":[{"type":0,"value":"Search all your documents, spreadsheets, and presentations alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.box.heading":[{"type":0,"value":"Box"}],"rovo-expansion.email.body.app-connect-card.connect-button":[{"type":0,"value":"Connect"}],"rovo-expansion.email.body.app-connect-card.docusign.alt":[{"type":0,"value":"DocuSign logo"}],"rovo-expansion.email.body.app-connect-card.docusign.body":[{"type":0,"value":"Make your important envelopes findable alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.docusign.heading":[{"type":0,"value":"DocuSign"}],"rovo-expansion.email.body.app-connect-card.dropbox.alt":[{"type":0,"value":"Dropbox logo"}],"rovo-expansion.email.body.app-connect-card.dropbox.body":[{"type":0,"value":"Bring in your documents, spreadsheets, and presentations "}],"rovo-expansion.email.body.app-connect-card.dropbox.heading":[{"type":0,"value":"Dropbox"}],"rovo-expansion.email.body.app-connect-card.gear.alt":[{"type":0,"value":"Add connectors icon"}],"rovo-expansion.email.body.app-connect-card.gear.body":[{"type":0,"value":"Add or remove your connected apps at anytime."}],"rovo-expansion.email.body.app-connect-card.gear.heading":[{"type":0,"value":"You\u2019re always in control"}],"rovo-expansion.email.body.app-connect-card.github.alt":[{"type":0,"value":"GitHub logo"}],"rovo-expansion.email.body.app-connect-card.github.body":[{"type":0,"value":"Integrate your development workflow and search across your PRs, issues, commits, and repos"}],"rovo-expansion.email.body.app-connect-card.github.heading":[{"type":0,"value":"GitHub"}],"rovo-expansion.email.body.app-connect-card.gitlab.alt":[{"type":0,"value":"GitLab logo"}],"rovo-expansion.email.body.app-connect-card.gitlab.body":[{"type":0,"value":"Find your Gitlab repositories easily"}],"rovo-expansion.email.body.app-connect-card.gitlab.heading":[{"type":0,"value":"GitLab"}],"rovo-expansion.email.body.app-connect-card.google-drive.alt":[{"type":0,"value":"Google Drive logo"}],"rovo-expansion.email.body.app-connect-card.google-drive.body":[{"type":0,"value":"Get insights and answers from docs and integrate your files into a unified search"}],"rovo-expansion.email.body.app-connect-card.google-drive.heading":[{"type":0,"value":"Google Drive"}],"rovo-expansion.email.body.app-connect-card.lucid.alt":[{"type":0,"value":"Lucid logo"}],"rovo-expansion.email.body.app-connect-card.lucid.body":[{"type":0,"value":"Make your documents and visual collaboration searchable alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.lucid.heading":[{"type":0,"value":"Lucid"}],"rovo-expansion.email.body.app-connect-card.miro.alt":[{"type":0,"value":"Miro logo"}],"rovo-expansion.email.body.app-connect-card.miro.body":[{"type":0,"value":"Make all your brainstorming and planning boards searchable alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.miro.heading":[{"type":0,"value":"Miro"}],"rovo-expansion.email.body.app-connect-card.ms-teams.alt":[{"type":0,"value":"Microsoft Teams"}],"rovo-expansion.email.body.app-connect-card.ms-teams.body":[{"type":0,"value":"Make all your messages part of your company knowledge"}],"rovo-expansion.email.body.app-connect-card.ms-teams.heading":[{"type":0,"value":"Microsoft Teams"}],"rovo-expansion.email.body.app-connect-card.notion.alt":[{"type":0,"value":"Notion logo"}],"rovo-expansion.email.body.app-connect-card.notion.body":[{"type":0,"value":"Add your pages and make them searchable alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.notion.heading":[{"type":0,"value":"Notion"}],"rovo-expansion.email.body.app-connect-card.onedrive.alt":[{"type":0,"value":"OneDrive logo"}],"rovo-expansion.email.body.app-connect-card.onedrive.body":[{"type":0,"value":"Search across documents, spreadsheets, and presentations"}],"rovo-expansion.email.body.app-connect-card.onedrive.heading":[{"type":0,"value":"OneDrive"}],"rovo-expansion.email.body.app-connect-card.sharepoint.alt":[{"type":0,"value":"Sharepoint logo"}],"rovo-expansion.email.body.app-connect-card.sharepoint.body":[{"type":0,"value":"Get answers from your SharePoint documents and bring your files alongside your company knowledge"}],"rovo-expansion.email.body.app-connect-card.sharepoint.heading":[{"type":0,"value":"Sharepoint"}],"rovo-expansion.email.body.app-connect-card.slack.alt":[{"type":0,"value":"Slack logo"}],"rovo-expansion.email.body.app-connect-card.slack.body":[{"type":0,"value":"Make every thread and channel part of your company knowledge"}],"rovo-expansion.email.body.app-connect-card.slack.heading":[{"type":0,"value":"Slack"}],"rovo-expansion.email.body.app-connect-card.smartsheet.alt":[{"type":0,"value":"Smartsheet logo"}],"rovo-expansion.email.body.app-connect-card.smartsheet.body":[{"type":0,"value":"Access your Smartsheet sheets"}],"rovo-expansion.email.body.app-connect-card.smartsheet.heading":[{"type":0,"value":"Smartsheet"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.default.introduction":[{"type":0,"value":"Now that you\u2019ve connected "},{"type":1,"value":"connected3PApp"},{"type":0,"value":", you\u2019ll find answers that include your team\u2019s content and more. Try using these prompts to get started:"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.default.prompt-1":[{"type":0,"value":"What content is in my "},{"type":1,"value":"connected3PApp"},{"type":0,"value":" account?"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.default.prompt-2":[{"type":0,"value":"Show me the latest updates from "},{"type":1,"value":"connected3PApp"},{"type":0,"value":"."}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.default.prompt-3":[{"type":0,"value":"Find my "},{"type":1,"value":"connected3PApp"},{"type":0,"value":" contributions."}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.github.introduction":[{"type":0,"value":"Now that you\u2019ve connected "},{"type":1,"value":"connected3PApp"},{"type":0,"value":", you\u2019ll find answers that include your PRs, commits, and more. Try using these prompts to get started:"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.github.prompt-1":[{"type":0,"value":"Find GitHub PRs I created or was tagged in over the past 30 days"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.github.prompt-2":[{"type":0,"value":"Show all PRs that mention me in GitHub"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.github.prompt-3":[{"type":0,"value":"Find the most recent PRs and commits I\u2019ve worked on in GitHub"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.google-drive.full-connector-prompt-1":[{"type":0,"value":"Find all Google Docs I\'ve seen from Jira and Confluence"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.google-drive.full-connector-prompt-2":[{"type":0,"value":"Summarize my latest project from Google Drive in a couple of sentences"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.google-drive.full-connector-prompt-3":[{"type":0,"value":"Find all Google Drive content I\u2019ve worked on from the last 30 days"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.google-drive.introduction":[{"type":0,"value":"Now that you\u2019ve connected your app, you\u2019ll find answers that include Docs, Sheets, and more. Try using these prompts to get started:"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.header-link-prompt":[{"type":0,"value":"In a few words, what is Rovo and how can I use it?"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.heading-1":[{"type":0,"value":"Your Chat just got more powerful"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.prompt.link":[{"type":0,"value":"Try prompt"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.slack.introduction":[{"type":0,"value":"Now that you\u2019ve connected "},{"type":1,"value":"connected3PApp"},{"type":0,"value":", you\u2019ll find answers that are grounded in the conversations of your messages and channels. Try using these prompts to get started:"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.slack.prompt-1":[{"type":0,"value":"Find the latest conversations from Slack"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.slack.prompt-2":[{"type":0,"value":"Summarize the latest activity from all Slack channels in a couple of sentences"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.body.slack.prompt-3":[{"type":0,"value":"Show all messages that mention me in Slack"}],"rovo-expansion.rovo-3p-celebrate-full-connector.message-template.email.title":[{"type":0,"value":"Try 3 prompts to instantly improve your search with "},{"type":1,"value":"connected3PApp"}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.github-description":[{"type":0,"value":"Your Search just got more powerful. Find your code from one place."}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.github-link":[{"type":0,"value":"Find related commits"}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.github-search-query":[{"type":0,"value":"PRs and commits related to "},{"type":1,"value":"pageId"}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.google-drive-description":[{"type":0,"value":"Your Search just got more powerful. Find your recent documents, spreadsheets, and slides from one place."}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.google-drive-link":[{"type":0,"value":"Find related Docs"}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.google-drive-search-query":[{"type":0,"value":"Docs related to "},{"type":1,"value":"pageId"}],"rovo-expansion.rovo-3p-celebrate-nudge.flag.title":[{"type":1,"value":"connected3PApp"},{"type":0,"value":" is now connected"}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.know-more.heading":[{"type":0,"value":"Want to know more?"}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.know-more.subheading":[{"type":0,"value":"Learn about managing connectors, your data, and permissions."}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.recommended-for-you.heading":[{"type":0,"value":"Recommended for you"}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.recommended-for-you.subheading":[{"type":0,"value":"Connect the apps your team is already using."}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.rovo.heading":[{"type":0,"value":"Get better results by connecting your apps with Rovo"}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.rovo.subheading.gear-variant":[{"type":0,"value":"Smarter search and chat starts with connected apps. App permissions are always respected."}],"rovo-expansion.rovo-3p-connector-admin-activation.email.body.rovo.subheading.text-variant":[{"type":0,"value":"Smarter search and chat starts with connected apps. Rovo respects existing app permissions, and "},{"children":[{"type":0,"value":"you can add or remove connectors at any time."}],"type":8,"value":"a"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.add-connectors-button":[{"type":0,"value":"Add connectors"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.adobe.alt":[{"type":0,"value":"Adobe Sign logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.adobe.body":[{"type":0,"value":"Find the Adobe Sign agreements your team needs with ease"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.adobe.heading":[{"type":0,"value":"Adobe Sign"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.aha.alt":[{"type":0,"value":"Aha! logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.aha.body":[{"type":0,"value":"Quickly locate Aha! features you need"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.aha.heading":[{"type":0,"value":"Aha"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.airtable.alt":[{"type":0,"value":"Airtable logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.airtable.body":[{"type":0,"value":"Bring your data and records and make them searchable alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.airtable.heading":[{"type":0,"value":"Airtable"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.asana.alt":[{"type":0,"value":"Asana logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.asana.body":[{"type":0,"value":"Locate your team\'s work by searching Asana\'s tasks and subtasks"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.asana.heading":[{"type":0,"value":"Asana"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.azure.alt":[{"type":0,"value":"Azure DevOps logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.azure.body":[{"type":0,"value":"Quickly retrieve your Azure DevOps repositories"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.azure.heading":[{"type":0,"value":"Azure DevOps"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.box.alt":[{"type":0,"value":"Box logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.box.body":[{"type":0,"value":"Search all your documents, spreadsheets, and presentations alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.box.heading":[{"type":0,"value":"Box"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.connect-banner.description":[{"type":0,"value":"Banner image showing Rovo app connectors"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.connect-button":[{"type":0,"value":"Connect"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.docusign.alt":[{"type":0,"value":"DocuSign logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.docusign.body":[{"type":0,"value":"Make your important envelopes findable alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.docusign.heading":[{"type":0,"value":"DocuSign"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.dropbox.alt":[{"type":0,"value":"Dropbox logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.dropbox.body":[{"type":0,"value":"Bring in your documents, spreadsheets, and presentations "}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.dropbox.heading":[{"type":0,"value":"Dropbox"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.contact-us":[{"type":0,"value":"Contact us"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.facebook-title":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.separator":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.footer.x-title":[{"type":0,"value":"X"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gear.alt":[{"type":0,"value":"Add connectors icon"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gear.body":[{"type":0,"value":"Add or remove your connected apps at anytime."}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gear.heading":[{"type":0,"value":"You\u2019re always in control"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.github.alt":[{"type":0,"value":"GitHub logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.github.body":[{"type":0,"value":"Integrate your development workflow and search across your PRs, issues, commits, and repos"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.github.heading":[{"type":0,"value":"GitHub"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gitlab.alt":[{"type":0,"value":"GitLab logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gitlab.body":[{"type":0,"value":"Find your Gitlab repositories easily"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.gitlab.heading":[{"type":0,"value":"GitLab"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.google-drive.alt":[{"type":0,"value":"Google Drive logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.google-drive.body":[{"type":0,"value":"Get insights and answers from docs and integrate your files into a unified search"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.google-drive.heading":[{"type":0,"value":"Google Drive"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.lucid.alt":[{"type":0,"value":"Lucid logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.lucid.body":[{"type":0,"value":"Make your documents and visual collaboration searchable alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.lucid.heading":[{"type":0,"value":"Lucid"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.miro.alt":[{"type":0,"value":"Miro logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.miro.body":[{"type":0,"value":"Make all your brainstorming and planning boards searchable alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.miro.heading":[{"type":0,"value":"Miro"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.monday.alt":[{"type":0,"value":"Monday logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.monday.body":[{"type":0,"value":"Centralize your Monday boards seamlessly"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.monday.heading":[{"type":0,"value":"Monday"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.ms-teams.alt":[{"type":0,"value":"Microsoft Teams"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.ms-teams.body":[{"type":0,"value":"Make all your messages part of your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.ms-teams.heading":[{"type":0,"value":"Microsoft Teams"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.notion.alt":[{"type":0,"value":"Notion logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.notion.body":[{"type":0,"value":"Add your pages and make them searchable alongside your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.notion.heading":[{"type":0,"value":"Notion"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.onedrive.alt":[{"type":0,"value":"OneDrive logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.onedrive.body":[{"type":0,"value":"Search across documents, spreadsheets, and presentations"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.onedrive.heading":[{"type":0,"value":"OneDrive"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.slack.alt":[{"type":0,"value":"Slack logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.slack.body":[{"type":0,"value":"Make every thread and channel part of your company knowledge"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.slack.heading":[{"type":0,"value":"Slack"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.smartsheet.alt":[{"type":0,"value":"Smartsheet logo"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.smartsheet.body":[{"type":0,"value":"Access your Smartsheet sheets"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.body.smartsheet.heading":[{"type":0,"value":"Smartsheet"}],"rovo-expansion.rovo-3p-connector-admin-activation.message-template.email.subject":[{"type":0,"value":"Connect the apps your team depends on"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.banner.description":[{"type":0,"value":"Decorative banner image"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.flow-state.description":[{"type":0,"value":"Turn scattered files into accessible knowledge, without compromising on security and permissions"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.flow-state.headline":[{"type":0,"value":"Expand organizational knowledge"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.flow-state.icon.description":[{"type":0,"value":"Flow state icon"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.heading":[{"type":0,"value":"Finish connecting "},{"type":1,"value":"appName"},{"type":0,"value":" to give your team a more intuitive way to search"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.heading-subtext":[{"type":0,"value":"Centralize the search for your team\u2019s files so they\u2019ll always have the knowledge and context they need."}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.page-search.description":[{"type":0,"value":"Getting rich, contextual results in search and chat"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.page-search.headline":[{"type":0,"value":"Find better answers instantly"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.page-search.icon.description":[{"type":0,"value":"Page search icon"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.platform.description":[{"type":0,"value":"Reducing context switching to focus on the work that matters"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.platform.headline":[{"type":0,"value":"Stay concentrated in their workflow"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.platform.icon.description":[{"type":0,"value":"Platform icon"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.body.rovo.heading-after-connecting":[{"type":0,"value":"With your help, they\u2019ll be able to:"}],"rovo-expansion.rovo-3p-connector-admin-follow-up.email.subject":[{"type":0,"value":"Unblock your team\u2019s work: finish connecting "},{"type":1,"value":"appName"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.banner.description":[{"type":0,"value":"Banner image showing Rovo app connectors"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.flow-state.description":[{"type":0,"value":"Connect related work across tools, teams, and projects so knowledge never stays siloed"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.flow-state.icon.description":[{"type":0,"value":"Flow state icon"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.page-search.description":[{"type":0,"value":"Get richer answers in Search and Chat, not just links"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.page-search.icon.description":[{"type":0,"value":"Page search icon"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.platform.description":[{"type":0,"value":"Find content across your entire workspace from a single search"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.platform.icon.description":[{"type":0,"value":"Platform icon"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.body.rovo.heading-after-connecting":[{"type":0,"value":"After connecting your app, you\u2019ll be able to:"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading-subtext.more-than-one-app":[{"type":0,"value":"Your admin just added the following apps. Finish connecting your account to find contextual results that include all your work in a single search."}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading-subtext.one-app":[{"type":0,"value":"Your admin just added "},{"type":1,"value":"appName"},{"type":0,"value":". Finish connecting your account to find contextual results that include all your work in a single search."}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading.one-app":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" to get more in-depth answers"}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading.three-or-more-apps":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" and other apps to get more in-depth answers "}],"rovo-expansion.rovo-3p-enduser-auth-post-admin.email.heading.two-apps":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" and "},{"type":1,"value":"appName2"},{"type":0,"value":" to get more in-depth answers"}],"rovo-expansion.rovo-expansion-prompt-of-day-email.message-template.email.body.header.v4":[{"type":1,"value":"userName"},{"type":0,"value":", stay on top of work with instant context and speed"}],"rovo-expansion.rovo-expansion-prompt-of-day-email.message-template.email.body.intro.v3":[{"type":0,"value":"Spend less time on busywork and more time on what matters. Try these "},{"type":1,"value":"count"},{"type":0,"value":" prompts designed with your week in mind."}],"rovo-expansion.rovo-expansion-prompt-of-day-email.message-template.email.body.prompt.link.v2":[{"type":0,"value":"Try prompt"}],"rovo-expansion.rovo-expansion-prompt-of-day-email.message-template.email.subject.variant-one.v2":[{"type":1,"value":"userName"},{"type":0,"value":", "},{"type":1,"value":"promptCount"},{"type":0,"value":" prompts to simplify your weekly to-dos"}],"rovo-expansion.rovo-expansion-prompt-of-day-email.message-template.email.subject.variant-two.v2":[{"type":1,"value":"userName"},{"type":0,"value":", these "},{"type":1,"value":"promptCount"},{"type":0,"value":" prompts were made just for you"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.01-body":[{"type":0,"value":"Less background activity. Tighter behavior on third-party pages. Updated documentation that explains what runs, when, and why \u2014 ready to hand to reviewers. Privacy review doesn\u2019t have to be the slowest part of your rollout anymore."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.01-heading":[{"type":0,"value":"Privacy features your security team will love"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.02-body":[{"type":0,"value":"Enable, disable, or lock individual capabilities \u2014 site by site, feature by feature. Manage in-page reading features with one consistent policy surface. No more all-or-nothing deployments."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.02-heading":[{"type":0,"value":"Granular deployment you can tailor site by site"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.03-body":[{"type":0,"value":"Publish company-wide updates, links, and important news directly to the Rovo new tab page \u2014 seen the moment anyone opens a tab. Perfect for town halls, policy updates, and launches."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.03-heading":[{"type":0,"value":"Company-wide broadcasts on every new tab"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.04-body":[{"type":0,"value":"Set your brand colors and background imagery so every new tab your team opens looks like it belongs to your company."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.04-heading":[{"type":0,"value":"Custom branding to make every new tab feel like home"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.actions-heading":[{"type":0,"value":"Get started"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.greeting-introduction":[{"type":0,"value":"You\u2019ve been telling us what the Rovo browser extension needs before it\u2019s ready for broad rollout. We\u2019ve shipped a wave of upgrades to make it safer, more controllable, and easier to deploy on your terms."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.improvements-heading":[{"type":0,"value":"Here\'s what you get"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.install-button":[{"type":0,"value":"Download the extension"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.instructions-link":[{"type":0,"value":"Or learn how to roll out the Rovo extension across your org"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.personal-greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.sign-off":[{"type":0,"value":"Have questions about the Rovo browser extension or just keen to learn more? Reach out to us at "},{"type":1,"value":"rovoExtEmail"},{"type":0,"value":" \u2013 we\u2019re happy to help!"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.subject":[{"type":0,"value":"Rovo browser extension: new admin upgrades, ready to roll out"}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.summary-1":[{"type":0,"value":"Less risk, more choice. A direct line to every user. A new tab that finally looks like it belongs to your company."}],"rovo-expansion.rovo-extension-admin-improvements-email.message-template.email.summary-2":[{"type":0,"value":"If you\u2019ve been waiting for the right moment to roll out the Rovo browser extension across your org, this is it."}],"rovo-expansion.rovo-extension-download-end-users-i18n.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"rovo-expansion.rovo-extension-download-end-users-i18n.email.body.hello.subtext":[{"type":0,"value":"Love using Rovo? Take it to the next level with the Rovo browser extension."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.chat-that-knows-your-context-section.description":[{"type":0,"value":"Chat that knows your context. Ask questions about what\u2019s open. Get context, fast."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.chat-that-knows-your-context-section.heading":[{"type":0,"value":"Chat that knows your context"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.chat-that-knows-your-context-section.subtext":[{"type":0,"value":"Ask questions about whatever tab is open. Get context, fast."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.create-what-you-need-fast-section.description":[{"type":0,"value":"Create what you need, fast. Instant work items across Jira, Confluence, Loom, and Agents. Make teamwork easy."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.create-what-you-need-fast-section.heading":[{"type":0,"value":"Create what you need, fast"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.create-what-you-need-fast-section.subtext":[{"type":0,"value":"Instant work items across Jira, Confluence, Loom, and Agents. Make teamwork easy."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.download-extension":[{"type":0,"value":"Download the extension"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.extension-screenshot.description":[{"type":0,"value":"Demo of the extension in action"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.contact-us":[{"type":0,"value":"Contact us"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.facebook-aria":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.facebook-title":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.linkedin-aria":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.separator-1":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.separator-2":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.unsubscribe.full":[{"type":0,"value":"to opt out of future emails like this"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.unsubscribe.short":[{"type":0,"value":"Unsubscribe"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.x-aria":[{"type":0,"value":"X"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.footer.x-title":[{"type":0,"value":"X"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.four-icon.description":[{"type":0,"value":"Four icon"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.instant-answers-section.description":[{"type":0,"value":"Instant answers. Chat with your company\u2019s knowledge base, right from any browser tab."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.instant-answers-section.heading":[{"type":0,"value":"Instant answers"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.instant-answers-section.subtext":[{"type":0,"value":"Chat with your "},{"children":[{"type":0,"value":"company\u2019s knowledge"}],"type":8,"value":"strong"},{"type":0,"value":" base, right from any browser tab."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.one-icon.description":[{"type":0,"value":"One icon"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.three-icon.description":[{"type":0,"value":"Three icon"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.try-it-today":[{"type":0,"value":"Try it today."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.two-icon.description":[{"type":0,"value":"Two icon"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.your-work-in-one-click-section.description":[{"type":0,"value":"Your work in one click. Pick up where you left off. Rovo\'s new tab page keeps your recent work ready after that last unexpected interruption."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.your-work-in-one-click-section.heading":[{"type":0,"value":"Your work in one click"}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.body.your-work-in-one-click-section.subtext":[{"type":0,"value":"Pick up where you left off. Rovo\'s new tab page keeps your recent work ready after that last unexpected interruption."}],"rovo-expansion.rovo-extension-download-end-users-i18n.message-template.email.subject":[{"type":0,"value":"\uD83D\uDE80 Try out the Rovo browser extension \u2013 Available now"}],"rovo-expansion.rovo-extension-download-end-users.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"rovo-expansion.rovo-extension-download-end-users.email.body.hello.subtext":[{"type":0,"value":"Love using Rovo? Take it to the next level with the Rovo browser extension."}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.download-extension":[{"type":0,"value":"Download the extension"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.extension-screenshot.description":[{"type":0,"value":"Demo of the extension in action"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.make-rovo-your-own":[{"type":0,"value":"Here\u2019s what you get"}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.rovo-extension-features.description":[{"type":0,"value":"Rovo extension features: Chat with your company\u2019s knowledge base, right from any browser tab. Ask questions about what\u2019s open. Get context that connects back to your projects. Pick up where you left off. Rovo\u2019s new tab page keeps your recent work ready after that last unexpected interruption. Create what you need, fast. Instantly create work items across Jira, Confluence, and Loom. Make teamwork easy."}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.body.try-it-today":[{"type":0,"value":"Try it today."}],"rovo-expansion.rovo-extension-download-end-users.message-template.email.subject":[{"type":0,"value":"\uD83D\uDE80 Try out the Rovo browser extension \u2013 Available now"}],"rovo-expansion.rovo-extension-download-org-admins-usage.email.body.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"rovo-expansion.rovo-extension-download-org-admins-usage.email.body.hello.subtext":[{"type":0,"value":"Companies are using "},{"children":[{"type":0,"value":"AI 400% as often"}],"type":8,"value":"span"},{"type":0,"value":" with the Rovo browser extension. Scale your org\u2019s AI adoption fast."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.branded-header.description":[{"type":0,"value":"Atlassian Rovo logo"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.download-extension":[{"type":0,"value":"Install the extension across your company"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.extension-screenshot.description":[{"type":0,"value":"Demo of the extension in action"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.contact-us":[{"type":0,"value":"Contact us"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.facebook-aria":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.facebook-title":[{"type":0,"value":"Facebook"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.linkedin-aria":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.separator-1":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.separator-2":[{"type":0,"value":" \u2022 "}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.unsubscribe.full":[{"type":0,"value":"to opt out of future emails like this"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.unsubscribe.short":[{"type":0,"value":"Unsubscribe"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.x-aria":[{"type":0,"value":"X"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.footer.x-title":[{"type":0,"value":"X"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.make-rovo-your-own":[{"type":0,"value":"Make Rovo your own"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.ready-to-roll-out":[{"type":0,"value":"Ready to roll out?"}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.rovo-features.description":[{"type":0,"value":"Customize the experience: add your company\u2019s logo, colors, and background to the new tab page. Push your announcements: Company-wide updates and news to every user\u2019s new tab. Users stay in control of their browsing experience by customizing or opting out in their extension settings."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.vitafleet-spotlight.description":[{"type":0,"value":"Rovo extension with company branding and annoucements."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.why-rovo.description":[{"type":0,"value":"Rovo is Atlassian\u2019s AI. It is designed for teamwork, connecting knowledge, people, and action to move work forward. Today Rovo includes Enterprise Search, Chat, Studio, Agents, and Skills and can be connected to 50+ 3rd party tools."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.body.your-team-will-thank-you":[{"type":0,"value":"Your team will thank you."}],"rovo-expansion.rovo-extension-download-org-admins-usage.message-template.email.subject":[{"type":0,"value":"\uD83D\uDE80 Get the Rovo extension ready for your whole team"}],"rovo-expansion.rovo-growth-insights-notification.message-template.notification-drawer.body-base.no-translate":[{"type":0,"value":"Rovo has generated new insights based on your recent activity"}],"rovo-expansion.rovo-growth-insights-notification.message-template.notification-drawer.body-categories.no-translate":[{"type":1,"value":"formattedCategories"},{"type":0,"value":" you need to see"}],"rovo-expansion.rovo-growth-insights-notification.message-template.notification-drawer.message-fallback.no-translate":[{"type":0,"value":"Your Rovo insights are ready"}],"rovo-expansion.rovo-growth-insights-notification.message-template.notification-drawer.message-plural.no-translate":[{"type":1,"value":"insightCount"},{"type":0,"value":" Rovo insights for you"}],"rovo-expansion.rovo-growth-insights-notification.message-template.notification-drawer.message-singular.no-translate":[{"type":1,"value":"insightCount"},{"type":0,"value":" Rovo insight for you"}],"rovo-extension-gdocs-definitions-install-cta-flag.flag-description":[{"type":0,"value":"Define company jargon in Google Docs, with the Rovo browser extension."}],"rovo-extension-gdocs-definitions-install-cta-flag.flag-dismiss-button-label":[{"type":0,"value":"Dismiss"}],"rovo-extension-gdocs-definitions-install-cta-flag.flag-download":[{"type":0,"value":"Download extension"}],"rovo-extension-gdocs-definitions-install-cta-flag.flag-title":[{"type":0,"value":"Get definitions in your Gdocs"}],"rovo-extension-install-cta-left-nav.chrome-icon-alt":[{"type":0,"value":"Google Chrome Icon"}],"rovo-extension-install-cta-left-nav.description.copy-version-b":[{"type":0,"value":"Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab."}],"rovo-extension-install-cta-left-nav.description.copy-version-c":[{"type":0,"value":"50K+ workers use it to chat with AI that understands their company."}],"rovo-extension-install-cta-left-nav.description.jira-rovo":[{"type":0,"value":"Manage work items, get instant insights, and act on Jira from any tab in your browser."}],"rovo-extension-install-cta-left-nav.description.jira-take-anywhere":[{"type":0,"value":"Manage work items, get instant insights, and act on Jira from any tab in your browser."}],"rovo-extension-install-cta-left-nav.dismiss-label":[{"type":0,"value":"Dismiss message"}],"rovo-extension-install-cta-left-nav.heading.copy-version-b":[{"type":0,"value":"Get answers for work, anywhere"}],"rovo-extension-install-cta-left-nav.heading.copy-version-c":[{"type":0,"value":"Unlock Rovo in every tab"}],"rovo-extension-install-cta-left-nav.heading.jira-rovo":[{"type":0,"value":"Jira. Anywhere."}],"rovo-extension-install-cta-left-nav.heading.jira-take-anywhere":[{"type":0,"value":"Jira. Anywhere."}],"rovo-extension-install-cta-left-nav.jira-icon-alt":[{"type":0,"value":"Jira Icon"}],"rovo-extension-install-cta-left-nav.jira-link":[{"type":0,"value":"Get the browser extension"}],"rovo-extension-install-cta-left-nav.jira-rovo-link":[{"type":0,"value":"Get the Rovo extension"}],"rovo-extension-install-cta-left-nav.link":[{"type":0,"value":"Get the browser extension"}],"rovo-extension-install-cta-left-nav.rovo-icon-alt":[{"type":0,"value":"Rovo Icon"}],"rovo-growth-3p-end-user-cta-flag.common.error.action":[{"type":0,"value":"Try again"}],"rovo-growth-3p-end-user-cta-flag.common.first-error.description":[{"type":0,"value":"Try again or ask your admin for help."}],"rovo-growth-3p-end-user-cta-flag.common.first-error.title":[{"type":0,"value":"We\'re having trouble connecting "},{"type":1,"value":"product"}],"rovo-growth-3p-end-user-cta-flag.common.second-error.description":[{"type":0,"value":"Try using the "},{"type":1,"value":"product"},{"type":0,"value":" Smart Link to connect your account, or ask your admin for help."}],"rovo-growth-3p-end-user-cta-flag.common.second-error.title":[{"type":0,"value":"We couldn\'t connect your app"}],"rovo-growth-3p-end-user-cta-flag.common.success.title":[{"type":0,"value":"Successfully connected to "},{"type":1,"value":"product"},{"type":0,"value":"."}],"rovo-growth-3p-smartlink-admin-paste-nudge.action.connect":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"rovo-growth-3p-smartlink-admin-paste-nudge.action.learn-more":[{"type":0,"value":"Learn more"}],"rovo-growth-3p-smartlink-admin-paste-nudge.description.generic":[{"type":0,"value":"Help your team find better answers with shared "},{"type":1,"value":"appName"},{"type":0,"value":" content from across your organization."}],"rovo-growth-3p-smartlink-admin-paste-nudge.description.github":[{"type":0,"value":"Help your team find answers faster. Connect GitHub to see PR previews, repository details, and GitHub content across Rovo."}],"rovo-growth-3p-smartlink-admin-paste-nudge.description.gitlab":[{"type":0,"value":"Help your team find answers faster. Connect GitLab to see PR previews, repository details, and GitLab content across Rovo."}],"rovo-growth-3p-smartlink-admin-paste-nudge.title":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"},{"type":0,"value":" for your team"}],"rovo-growth-3p-smartlink-paste-nudge.connect-button-text":[{"type":0,"value":"Connect "},{"type":1,"value":"product"}],"rovo-growth-3p-smartlink-paste-nudge.description":[{"type":0,"value":"Make this Smart Link and other files searchable by connecting your account."}],"rovo-growth-3p-smartlink-paste-nudge.flag-title.high-percentage":[{"type":0,"value":"90% of your team shares content from "},{"type":1,"value":"product"}],"rovo-growth-3p-smartlink-paste-nudge.flag-title.low-percentage":[{"type":0,"value":"Your team shares content from "},{"type":1,"value":"product"}],"rovo-growth-3p-smartlink-paste-nudge.flag-title.medium-percentage":[{"type":1,"value":"percent"},{"type":0,"value":"% of your team shares content from "},{"type":1,"value":"product"}],"rovo-growth-3p-smartlink-paste-nudge.success.description":[{"type":0,"value":"Shared links now display rich previews."}],"rovo-growth-3p-smartlink-paste-nudge.success.title":[{"type":1,"value":"product"},{"type":0,"value":" is connected"}],"rovo-growth-nudge-end-user-highly-connected-apps.action.connect":[{"type":0,"value":"Connect "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.action.connect.variant2":[{"type":0,"value":"Connect now"}],"rovo-growth-nudge-end-user-highly-connected-apps.action.dont-show-again":[{"type":0,"value":"Don\'t show "},{"type":1,"value":"app"},{"type":0,"value":" again"}],"rovo-growth-nudge-end-user-highly-connected-apps.description.high-percentage.variant2":[{"type":0,"value":"90% of your team works with shared content. Connect for a smarter Search and Chat that includes work you\u2019ve seen. "}],"rovo-growth-nudge-end-user-highly-connected-apps.description.medium-high-percentage.variant1":[{"type":0,"value":"Connect your account to search smarter and get more in-depth summaries in Chat."}],"rovo-growth-nudge-end-user-highly-connected-apps.description.medium-high-percentage.variant2":[{"type":1,"value":"percent"},{"type":0,"value":"% of your team works with shared content. Connect for a smarter Search and Chat that includes work you\u2019ve seen. "}],"rovo-growth-nudge-end-user-highly-connected-apps.description.variant1":[{"type":0,"value":"Get better summaries in Search and Chat from work that was shared with you."}],"rovo-growth-nudge-end-user-highly-connected-apps.description.variant2":[{"type":0,"value":"Get better summaries in Search and Chat that includes files from work you\u2019ve seen. "}],"rovo-growth-nudge-end-user-highly-connected-apps.error.action":[{"type":0,"value":"Try again"}],"rovo-growth-nudge-end-user-highly-connected-apps.first-error.description":[{"type":0,"value":"Try again or ask your admin for help."}],"rovo-growth-nudge-end-user-highly-connected-apps.first-error.title":[{"type":0,"value":"We\'re having trouble connecting "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.second-error.description":[{"type":0,"value":"Try using the "},{"type":1,"value":"product"},{"type":0,"value":" Smart Link to connect your account, or ask your admin for help."}],"rovo-growth-nudge-end-user-highly-connected-apps.second-error.title":[{"type":0,"value":"We couldn\'t connect your app"}],"rovo-growth-nudge-end-user-highly-connected-apps.title.high-percentage.variant1":[{"type":0,"value":"90% of your team has connected apps like "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.title.low-percentage.variant1":[{"type":0,"value":"Your team connected "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.title.low-percentage.variant2":[{"type":0,"value":"Your team is using "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.title.medium-percentage.variant1":[{"type":1,"value":"percent"},{"type":0,"value":"% of your team has connected apps like "},{"type":1,"value":"product"}],"rovo-growth-nudge-end-user-highly-connected-apps.title.medium-percentage.variant2":[{"type":0,"value":"Connect "},{"type":1,"value":"product"}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.chat-prompt":[{"type":0,"value":"Hi Rovo, list three things you can do right now for me based on my recent work"}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.cta-link-text":[{"type":0,"value":"Try Rovo now"}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.description.v1":[{"type":0,"value":"Rovo connects your tools and knowledge so work gets done for you."}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.heading.v1":[{"type":0,"value":"Unlock your AI teammate"}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.why-am-i-seeing-this.reason-1":[{"type":0,"value":"your existing Atlassian products"}],"rovo-non-mau-chat-cta-jira-confluence-left-nav.why-am-i-seeing-this.reason-2":[{"type":0,"value":"your organization having AI enabled"}],"rovo-non-mau-chat-cta-left-nav.chat-prompt":[{"type":0,"value":"Hi Rovo, list three things you can do right now for me based on my recent work"}],"rovo-non-mau-chat-cta-left-nav.cta-link-text":[{"type":0,"value":"Try Rovo now"}],"rovo-non-mau-chat-cta-left-nav.description.v1":[{"type":0,"value":"Rovo connects your tools and knowledge so work gets done for you."}],"rovo-non-mau-chat-cta-left-nav.description.v2":[{"type":0,"value":"Rovo uses your Teamwork Graph to surface the right answers from your team\u2019s work and tools."}],"rovo-non-mau-chat-cta-left-nav.description.v3":[{"type":0,"value":"Rovo unifies your tools and knowledge so your AI teammate handles the busywork."}],"rovo-non-mau-chat-cta-left-nav.heading.v1":[{"type":0,"value":"Unlock your AI teammate"}],"rovo-non-mau-chat-cta-left-nav.heading.v2":[{"type":0,"value":"Knowledge that knows you"}],"rovo-non-mau-chat-cta-left-nav.heading.v3":[{"type":0,"value":"Your work. On autopilot."}],"rovo-non-mau-chat-cta-left-nav.why-am-i-seeing-this.reason-1":[{"type":0,"value":"your existing Atlassian products"}],"rovo-non-mau-chat-cta-left-nav.why-am-i-seeing-this.reason-2":[{"type":0,"value":"your organization having AI enabled"}],"rovo.search.inline-3p.banner-image-alt":[{"type":0,"value":"Illustration showing "},{"type":1,"value":"connectorName"},{"type":0,"value":" integration with Atlassian search"}],"rovo.search.inline-3p.connect":[{"type":0,"value":"Connect "},{"type":1,"value":"connectorName"}],"rovo.search.inline-3p.connect-later":[{"type":0,"value":"Connect later"}],"rovo.search.inline-3p.dismiss":[{"type":0,"value":"Dismiss"}],"rovo.search.inline-3p.full-connector.admin-blessed.body":[{"type":0,"value":"Finish connecting your account to unlock search results with context from all your files."}],"rovo.search.inline-3p.full-connector.admin-blessed.heading":[{"type":0,"value":"Your admin added "},{"type":1,"value":"connectorName"}],"rovo.search.inline-3p.full-connector.fomo.body-v2":[{"type":0,"value":"Join your team in a smarter search. Connect your account to find answers hidden in your team\'s work."}],"rovo.search.inline-3p.full-connector.fomo.heading":[{"type":0,"value":"Your team is getting results you might be missing"}],"rovo.search.inline-3p.full-connector.search-in-one-place.body":[{"type":0,"value":"Connect your account to see missing results, including files and docs you already have access to."}],"rovo.search.inline-3p.full-connector.search-in-one-place.heading":[{"type":0,"value":"See richer search results in every search"}],"rovo.search.inline-3p.smart-link-connector.fomo.body-v2":[{"type":0,"value":"Most of your team\'s Smart Links don\'t appear in search. Connect "},{"type":1,"value":"connectorName"},{"type":0,"value":" to expand your search."}],"rovo.search.inline-3p.smart-link-connector.fomo.heading":[{"type":0,"value":"Your team is getting results you might be missing"}],"rovo.search.inline-3p.smart-link-connector.recency-1.body-v2":[{"type":0,"value":"Connect your account to find work you\'ve seen and its related content."}],"rovo.search.inline-3p.smart-link-connector.recency-1.heading":[{"type":0,"value":"Missing that recent "},{"type":1,"value":"connectorName"},{"type":0,"value":" result?"}],"rovo.search.inline-3p.smart-link-connector.recency-2.body":[{"type":0,"value":"Connect your account to find "},{"type":1,"value":"connectorName"},{"type":0,"value":" links you\'ve seen before."}],"rovo.search.inline-3p.smart-link-connector.recency-2.heading":[{"type":0,"value":"See richer results in every search"}],"rovo.search.inline-3p.smart-link-connector.social-proof-high.body":[{"type":1,"value":"teamUsagePercentage"},{"type":0,"value":"% of your team works with shared content. Connect your account so work shared via Smart Links shows up in Search."}],"rovo.search.inline-3p.smart-link-connector.social-proof-high.heading-v2":[{"type":0,"value":"Find missing results from your team\'s content"}],"rovo.search.inline-3p.smart-link-connector.social-proof-low.body":[{"type":0,"value":"Connect your account to search across "},{"type":1,"value":"connectorName"},{"type":0,"value":" files shared by your team via Smart Links."}],"rovo.search.inline-3p.smart-link-connector.social-proof-low.heading":[{"type":0,"value":"Find what\'s hidden in your team\'s shared links"}],"rovo.search.inline-authorization-fail":[{"type":0,"value":"Failed to connect to "},{"type":1,"value":"product"},{"type":0,"value":"."}],"rovo.search.inline.authorization-success":[{"type":0,"value":"Account connected to "},{"type":1,"value":"product"},{"type":0,"value":"."}],"rovo.search.quick-find-3p.connect":[{"type":0,"value":"Connect "},{"type":1,"value":"connectorName"}],"rovo.search.quick-find-3p.connect-later":[{"type":0,"value":"Connect later"}],"rovo.search.quick-find-3p.dismiss":[{"type":0,"value":"Dismiss"}],"rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.body":[{"type":0,"value":"Connect to see missing results"}],"rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.heading-v2":[{"type":0,"value":"Your admin added "},{"type":1,"value":"connectorName"},{"type":0,"value":". "}],"rovo.search.quick-find-3p.full-connector.social-proof-high.heading-v2":[{"type":1,"value":"teamConnectAppPercentage"},{"type":0,"value":"% of your team have connected apps"}],"rovo.search.quick-find-3p.smart-link-connector.social-proof-high.heading-v3":[{"type":1,"value":"teamConnectAppPercentage"},{"type":0,"value":"% of your team have connected apps"}],"rovo.search.quick-find-3p.smart-link-connector.social-proof-low.body":[{"type":0,"value":"Connect your account to see missing results"}],"rovo.search.quick-find-3p.smart-link-connector.social-proof-low.heading-v2":[{"type":1,"value":"connectorName"},{"type":0,"value":" is now available!"}],"rovo.search.quick-find-authorization-fail":[{"type":0,"value":"Failed to connect to "},{"type":1,"value":"product"},{"type":0,"value":"."}],"rovo.search.quick-find.authorization-success":[{"type":0,"value":"Account connected to "},{"type":1,"value":"product"},{"type":0,"value":"."}]}');

});

parcelRegister("idRZz", function(module, exports) {

let $d4435296cfb68c94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4435296cfb68c94$var$load("kpSc4").then(()=>parcelRequire('89xPm'));

});

parcelRegister("7d8jN", function(module, exports) {

let $540033236f439308$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $540033236f439308$var$load("i3cfl").then(()=>parcelRequire('8kBPZ'));

});

parcelRegister("eJosu", function(module, exports) {

let $ab983d9efd1861d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab983d9efd1861d3$var$load("jy3XW").then(()=>parcelRequire('79Dsu'));

});

parcelRegister("fSR9p", function(module, exports) {

let $b90520d038b00bcb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b90520d038b00bcb$var$load("cJhLC").then(()=>parcelRequire('4m2RD'));

});

parcelRegister("2aOul", function(module, exports) {

let $1953ade984590544$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1953ade984590544$var$load("k6B8h").then(()=>parcelRequire('CQmJI'));

});

parcelRegister("8KWRB", function(module, exports) {

let $660047b4f0e1301c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $660047b4f0e1301c$var$load("klnez").then(()=>parcelRequire('4es1M'));

});

parcelRegister("aD6lN", function(module, exports) {

let $01ff44040e0ccbd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01ff44040e0ccbd8$var$load("cYDv1").then(()=>parcelRequire('97IsN'));

});

parcelRegister("ht1nW", function(module, exports) {

let $cb76382a9f576507$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb76382a9f576507$var$load("g3r6l").then(()=>parcelRequire('hTfdg'));

});

parcelRegister("6TdpN", function(module, exports) {

let $5042491214156eec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5042491214156eec$var$load("dfrnV").then(()=>parcelRequire('cHyox'));

});

parcelRegister("3dPbj", function(module, exports) {

let $258a498c8b1866aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $258a498c8b1866aa$var$load("jYSNZ").then(()=>parcelRequire('fzVcR'));

});

parcelRegister("bNrrT", function(module, exports) {

let $8969901238b990aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8969901238b990aa$var$load("rzYAC").then(()=>parcelRequire('2zbZb'));

});

parcelRegister("fzWvN", function(module, exports) {

let $b5778323c097400b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5778323c097400b$var$load("b1RNi").then(()=>parcelRequire('g1IzC'));

});

parcelRegister("k9LUw", function(module, exports) {

let $eac9cff7e134e983$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eac9cff7e134e983$var$load("fcU7k").then(()=>parcelRequire('2dQJG'));

});

parcelRegister("7NEGR", function(module, exports) {

let $5adcac43c901bc7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5adcac43c901bc7f$var$load("lYtN4").then(()=>parcelRequire('ek20L'));

});

parcelRegister("fHFaz", function(module, exports) {

let $b6eace8e0f75ab54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6eace8e0f75ab54$var$load("hvz65").then(()=>parcelRequire('4f0Oq'));

});

parcelRegister("lB4Ue", function(module, exports) {

let $fb90dbea861114d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb90dbea861114d2$var$load("6aWEg").then(()=>parcelRequire('bkHdf'));

});

parcelRegister("hcpTt", function(module, exports) {

let $c857a49c0ce50a62$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c857a49c0ce50a62$var$load("3AkwZ").then(()=>parcelRequire('aZ2hi'));

});

parcelRegister("lLSQO", function(module, exports) {

let $fd988902d5e753ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd988902d5e753ad$var$load("cbHUA").then(()=>parcelRequire('91Xd7'));

});

parcelRegister("04L3J", function(module, exports) {

let $00e4e0ccb0bc5769$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $00e4e0ccb0bc5769$var$load("5485f").then(()=>parcelRequire('24N9u'));

});

parcelRegister("7Gmd2", function(module, exports) {

let $597daeef7021c298$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $597daeef7021c298$var$load("d4ETO").then(()=>parcelRequire('9Rcfo'));

});

parcelRegister("eCPZn", function(module, exports) {

let $aa5cf1394f619b2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa5cf1394f619b2f$var$load("2sU7M").then(()=>parcelRequire('8kSvx'));

});

parcelRegister("2siS3", function(module, exports) {

let $1c9cd5a4bc1b7808$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c9cd5a4bc1b7808$var$load("zXFQE").then(()=>parcelRequire('7sEYG'));

});

parcelRegister("jYxQj", function(module, exports) {

let $e8addf61dfaa7a86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8addf61dfaa7a86$var$load("8pLiY").then(()=>parcelRequire('bcdVB'));

});

parcelRegister("i2pRS", function(module, exports) {

let $03638e5dda7132b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03638e5dda7132b1$var$load("3J4FI").then(()=>parcelRequire('1nusn'));

});

parcelRegister("6851R", function(module, exports) {

let $4767641929e2988c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4767641929e2988c$var$load("h8FRl").then(()=>parcelRequire('fiOEz'));

});

parcelRegister("79owM", function(module, exports) {

let $534c665f69ebe5d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $534c665f69ebe5d4$var$load("8Ptvx").then(()=>parcelRequire('4bbsk'));

});

parcelRegister("fOIhl", function(module, exports) {

let $b83ddf63e2660e2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b83ddf63e2660e2a$var$load("9NEAK").then(()=>parcelRequire('cXQvP'));

});

parcelRegister("dgcZd", function(module, exports) {

let $9a76d7d0f5070274$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a76d7d0f5070274$var$load("2l1wL").then(()=>parcelRequire('1JovN'));

});

parcelRegister("hR3zt", function(module, exports) {

let $cffa281416d999f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cffa281416d999f7$var$load("d5Ft0").then(()=>parcelRequire('6aOOn'));

});

parcelRegister("kHeB2", function(module, exports) {

let $f113255d2b14abdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f113255d2b14abdc$var$load("1zTvG").then(()=>parcelRequire('g9bZA'));

});

parcelRegister("jX25P", function(module, exports) {

let $e86526a3ec5da4f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e86526a3ec5da4f9$var$load("cxb60").then(()=>parcelRequire('eUtmf'));

});

parcelRegister("inesZ", function(module, exports) {

let $d60598c181cbb709$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d60598c181cbb709$var$load("a3cvU").then(()=>parcelRequire('8XP6i'));

});

parcelRegister("4hAqw", function(module, exports) {

let $31e50188543ae68c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31e50188543ae68c$var$load("2p07R").then(()=>parcelRequire('greUY'));

});

parcelRegister("62O4L", function(module, exports) {

let $4669c6009e0642a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4669c6009e0642a9$var$load("hTwNV").then(()=>parcelRequire('jLR9K'));

});

parcelRegister("kdvUL", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8Mosz = parcelRequire("8Mosz");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a5b98d263d96b9ca$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a5b98d263d96b9ca$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5kzWa")));
        case 'da':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("i4vm8")));
        case 'de':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("2criv")));
        case 'en-GB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7leZF")));
        case 'en-US':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("lIduW")));
        case 'en-XA':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6Ga8j")));
        case 'en-XB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("9SvDD")));
        case 'en-ZZ':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("ilsDR")));
        case 'en':
            return $a5b98d263d96b9ca$var$importHelper(await Promise.resolve((parcelRequire("8Mosz"))));
        case 'es':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("eA1bq")));
        case 'et':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("20oYo")));
        case 'fi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5uv0c")));
        case 'fr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aT1Cx")));
        case 'hr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("loDZu")));
        case 'hu':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("j3kFT")));
        case 'it':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("ks52q")));
        case 'ja':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aTDBw")));
        case 'ko':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("bTqNO")));
        case 'nb':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("10NvT")));
        case 'nl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("4Yta3")));
        case 'pl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7T2DO")));
        case 'pt-BR':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("86KYZ")));
        case 'ro':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("9ZXMc")));
        case 'ru':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("bP7Hx")));
        case 'sl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("3iSMg")));
        case 'sr-RS':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("gjRTJ")));
        case 'sr-YR':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("dDE21")));
        case 'sr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7Se25")));
        case 'sv':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("giWmH")));
        case 'th':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("2rtZr")));
        case 'tr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("az1hp")));
        case 'uk':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("hW673")));
        case 'vi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("34J1c")));
        case 'zh-CN':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("cMfEi")));
        case 'zh-TW':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("iVQsE")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8Mosz));
    }
};
module.exports["messagesLoader"] = $a5b98d263d96b9ca$export$720676d8cac8fbb;

});

parcelRegister("8Mosz", function(module, exports) {
module.exports = JSON.parse('{"admin-hub.ci-test.message-template-template-hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"ci-generation.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ci-generation.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ci-generation.email.body.img.alt":[{"type":0,"value":"This is the alt text for the image"}],"ci-generation.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ci-generation.email.body.signoff":[{"type":0,"value":"Regards,"}],"ci-generation.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ci-generation.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"post-office.test-message-digest-email-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-email-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-digest-local-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-local-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-microsoft-teams.sample-hello-message":[{"type":0,"value":"Hello, this is test message from Post Office: "},{"type":1,"value":"text"}],"post-office.test-message.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"},{"type":0,"value":"."}],"post-office.test-messages.test-message-config-sets.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-lifecycle-email-recipients.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-lifecycle.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a redacted test mobile push notification from post office."}],"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push.greeting.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate":[{"type":0,"value":"Hello, this is a redacted mobile push notification test from post office."}],"post-office.test-messages.test-message-no-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-slack-experiment-exposure.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-slack-notification.sample-hello-message":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"product-store-personal-use-case.hello-world":[{"type":0,"value":"Hello. Is is a lovely"}],"test-message.test-message-email-onboarding-test.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-message.test-message-email-onboarding-test.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-message.test-message-email-onboarding-test.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-message.test-message-email-onboarding-test.test-message.email.body.no-translate":[{"type":0,"value":"This is an test onboarding message for "},{"type":1,"value":"team"},{"type":0,"value":" team from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-message.test-message-email-onboarding-test.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-message.test-message-email-onboarding-test.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-message.test-message-email-onboarding-test.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.app-switcher-discovery-section.dismiss":[{"type":0,"value":"Dismiss"}],"test-messages.app-switcher-discovery-section.test-content":[{"type":0,"value":"This is a test message."}],"test-messages.app-switcher-upgrade-section.dismiss":[{"type":0,"value":"Dismiss"}],"test-messages.app-switcher-upgrade-section.test-content":[{"type":0,"value":"This is a test message."}],"test-messages.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.in-app-example.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"test-messages.in-app-notification-comment-rollup.second-comment":[{"type":1,"value":"actor"},{"type":0,"value":" commented on a page"}],"test-messages.in-app-notification-mention-rollup.first-comment":[{"type":1,"value":"reactor"},{"type":0,"value":" mentioned you in a comment"}],"test-messages.in-app-notification-reaction-rollup.many-actors":[{"type":1,"value":"actor1Name"},{"type":0,"value":" and "},{"type":1,"value":"otherActorsCount"},{"type":0,"value":" others reacted to your page"}],"test-messages.in-app-notification-reaction-rollup.one-actor":[{"type":1,"value":"actor1Name"},{"type":0,"value":" reacted to your page"}],"test-messages.in-app-notification-reaction-rollup.two-actors":[{"type":1,"value":"actor1Name"},{"type":0,"value":" and "},{"type":1,"value":"actor2Name"},{"type":0,"value":" reacted to your page"}],"test-messages.in-app-notification.email-onboarding.body":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":", This is an onboarding test message for "},{"type":1,"value":"team"},{"type":0,"value":" team."}],"test-messages.in-app-notification.email-onboarding.title":[{"type":0,"value":"Welcome!"}],"test-messages.in-app-notification.title":[{"type":0,"value":"Test Notification "},{"type":1,"value":"title"}],"test-messages.jira-navigation-topbar-edition-awareness.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"test-messages.redacted-email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate":[{"type":0,"value":"Post Office Redacted Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-client-generation.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-client-generation.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-client-generation.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-client-generation.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-client-generation.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-client-generation.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-client-generation.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-config-sets.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-config-sets.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-config-sets.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-config-sets.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-config-sets.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-config-sets.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-config-sets.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"Click here to visit Atlassian"}],"test-messages.test-message-config-sets.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-content-diffing.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-content-diffing.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-content-diffing.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-content-diffing.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-content-diffing.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-content-diffing.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-content-diffing.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-delivery-control.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-delivery-control.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-delivery-control.message-template.in-app-notification.body.no-translate":[{"type":1,"value":"body"}],"test-messages.test-message-delivery-control.message-template.in-app-notification.title.no-translate":[{"type":0,"value":"Template Notification "},{"type":1,"value":"title"}],"test-messages.test-message-delivery-control.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-delivery-control.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-delivery-control.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-delivery-control.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-delivery-control.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-local.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-local.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-local.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-local.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-local.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-local.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-local.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-cdn.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-cdn.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-cdn.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-cdn.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-cdn.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-experiment-exposure.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-experiment-exposure.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.button.no-translate":[{"type":0,"value":"Click me!"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-experiment-exposure.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-high-priority.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-high-priority.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-high-priority.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-high-priority.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-high-priority.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-high-priority.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-high-priority.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-log-dropping.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-log-dropping.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-log-dropping.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-log-dropping.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-log-dropping.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-log-dropping.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-log-dropping.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-low-priority.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-low-priority.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-low-priority.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-low-priority.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-low-priority.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-low-priority.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-low-priority.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-mfc.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-mfc.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-ugc.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-ugc.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate":[{"type":0,"value":"This is a redacted test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-grouped-recipients.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-grouped-recipients.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-grouped-recipients.test-message.email.body.hello":[{"type":0,"value":"Hello"}],"test-messages.test-message-grouped-recipients.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-grouped-recipients.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-comment-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-comment-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-comment-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-mention-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-mention-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-mention-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-reaction-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-reaction-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-reaction-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-lifecycle-email-recipients.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-lifecycle-email-recipients.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-lifecycle.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-lifecycle.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-lifecycle.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-lifecycle.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-lifecycle.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-lifecycle.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Kind Regards,"}],"test-messages.test-message-lifecycle.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-link-tracking.email.heading.no-translate":[{"type":0,"value":"Origin Tracing \u2014 Tracked Link Test ("},{"type":1,"value":"env"},{"type":0,"value":")"}],"test-messages.test-message-link-tracking.email.intro.no-translate":[{"type":0,"value":"This email tests Post Office tracked links. Tracked links go through the Post Office redirect service; plain links do not. Click each link and inspect the redirect URL to verify origin tracing."}],"test-messages.test-message-link-tracking.email.tracked-link-atl-origin.no-translate":[{"type":0,"value":"TrackedLink with atlOrigin param"}],"test-messages.test-message-link-tracking.email.tracked-link-atlassian.no-translate":[{"type":0,"value":"TrackedLink to https://atlassian.com"}],"test-messages.test-message-link-tracking.email.tracked-link-external.no-translate":[{"type":0,"value":"TrackedLink to https://www.example.com (non-Atlassian)"}],"test-messages.test-message-link-tracking.email.tracked-link-pdf.no-translate":[{"type":0,"value":"TrackedLink to PDF"}],"test-messages.test-message-link-tracking.email.tracked-link-tenanted.no-translate":[{"type":0,"value":"TrackedLink to https://hello.atlassian.net/wiki/home (tenanted)"}],"test-messages.test-message-link-tracking.email.tracked-section.no-translate":[{"type":0,"value":"Tracked links"}],"test-messages.test-message-link-tracking.email.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-link-tracking.email.untracked-link-atl-origin.no-translate":[{"type":0,"value":"Plain link with atlOrigin param"}],"test-messages.test-message-link-tracking.email.untracked-link-atlassian.no-translate":[{"type":0,"value":"Plain link to https://atlassian.com"}],"test-messages.test-message-link-tracking.email.untracked-link-external.no-translate":[{"type":0,"value":"Plain link to https://www.example.com (non-Atlassian)"}],"test-messages.test-message-link-tracking.email.untracked-link-pdf.no-translate":[{"type":0,"value":"Plain link to PDF"}],"test-messages.test-message-link-tracking.email.untracked-link-tenanted.no-translate":[{"type":0,"value":"Plain link to https://hello.atlassian.net/wiki/home (tenanted)"}],"test-messages.test-message-link-tracking.email.untracked-section.no-translate":[{"type":0,"value":"Plain (untracked) links"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-marketing.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-marketing.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-marketing.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-marketing.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-message-failures.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-message-failures.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-nd-ni-influents-mapper.influents.message-main.no-translate":[{"type":0,"value":"Main line ("},{"type":1,"value":"text"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.action.no-translate":[{"type":0,"value":"Open ("},{"type":1,"value":"emoji"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.entity.no-translate":[{"type":0,"value":"Entity for "},{"type":1,"value":"team"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.path.no-translate":[{"type":0,"value":"Path ("},{"type":1,"value":"team"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.title.no-translate":[{"type":0,"value":"Team "},{"type":1,"value":"teamName"},{"type":0,"value":" update"}],"test-messages.test-message-no-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-no-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-no-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-no-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-no-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-no-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-no-tracking.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"This is a TrackedLink that isn\'t being tracked!"}],"test-messages.test-message-no-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-notifications-platform.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" updated your page"}],"test-messages.test-message-persona-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-persona-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-persona-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-persona-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-persona-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-persona-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate":[{"type":1,"value":"greeting"}],"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi,"}],"test-messages.test-message-raw-recipients.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-transform-metadata.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message.app.img.alt.large":[{"type":0,"value":"test image 2"}],"test-messages.test-message.app.img.alt.plant":[{"type":0,"value":"test image 1"}],"test-messages.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. "},{"type":1,"value":"additionalBody"}],"test-messages.test-message.email.body.hello":[{"type":0,"value":"Hi Atlassian,"}],"test-messages.test-message.email.body.img.alt":[{"type":0,"value":"this is the alt for the test-message-email message template"}],"test-messages.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message.redacted-email.body":[{"type":0,"value":"This is the redacted version of the test email message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. "},{"type":1,"value":"additionalBody"}],"test-messages.test-message.redacted-email.body.hello":[{"type":0,"value":"Hi Atlassian,"}],"test-messages.test-message.redacted-email.body.img.alt":[{"type":0,"value":"this is the alt for the test-message-email message template"}],"test-messages.test-message.redacted-email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message.redacted-email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"wac-global-nav-product-recommendation.hello-world":[{"type":0,"value":"Hello. Is is a lovely"}]}');

});

parcelRegister("5kzWa", function(module, exports) {

let $3e1ab25bd080ef18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e1ab25bd080ef18$var$load("1jsQH").then(()=>parcelRequire('fa8lP'));

});

parcelRegister("i4vm8", function(module, exports) {

let $d280ec5dc220c64f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d280ec5dc220c64f$var$load("deyvi").then(()=>parcelRequire('e3sAb'));

});

parcelRegister("2criv", function(module, exports) {

let $19a1e074f016a288$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19a1e074f016a288$var$load("6dERU").then(()=>parcelRequire('gch8x'));

});

parcelRegister("7leZF", function(module, exports) {

let $558620019a9af14d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $558620019a9af14d$var$load("kTurq").then(()=>parcelRequire('8ptsW'));

});

parcelRegister("lIduW", function(module, exports) {

let $fce82d783e15c0ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fce82d783e15c0ae$var$load("fbIIm").then(()=>parcelRequire('a6GY6'));

});

parcelRegister("6Ga8j", function(module, exports) {

let $4dce8689974dee0c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4dce8689974dee0c$var$load("7l3it").then(()=>parcelRequire('8fxxk'));

});

parcelRegister("9SvDD", function(module, exports) {

let $7311b2ec66131e05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7311b2ec66131e05$var$load("i64HJ").then(()=>parcelRequire('efBlj'));

});

parcelRegister("ilsDR", function(module, exports) {

let $d5b067deab340511$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5b067deab340511$var$load("j0PWv").then(()=>parcelRequire('ks6TI'));

});

parcelRegister("eA1bq", function(module, exports) {

let $a9d558780c2a5d28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9d558780c2a5d28$var$load("dlmud").then(()=>parcelRequire('imT4f'));

});

parcelRegister("20oYo", function(module, exports) {

let $175ef3f7b5281c9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $175ef3f7b5281c9e$var$load("7snhF").then(()=>parcelRequire('cQTYN'));

});

parcelRegister("5uv0c", function(module, exports) {

let $3ff7cd8091ce22a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ff7cd8091ce22a4$var$load("cbkj0").then(()=>parcelRequire('j8AG8'));

});

parcelRegister("aT1Cx", function(module, exports) {

let $7ed04c3d213b805a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ed04c3d213b805a$var$load("17m16").then(()=>parcelRequire('cdNFz'));

});

parcelRegister("loDZu", function(module, exports) {

let $f93adc2ef4ae79f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f93adc2ef4ae79f5$var$load("eQZk8").then(()=>parcelRequire('8akbo'));

});

parcelRegister("j3kFT", function(module, exports) {

let $ddee55b7ab979037$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ddee55b7ab979037$var$load("b4NO6").then(()=>parcelRequire('gPFiy'));

});

parcelRegister("ks52q", function(module, exports) {

let $ee3a549cc562cf0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee3a549cc562cf0d$var$load("1K1Fj").then(()=>parcelRequire('dIMMS'));

});

parcelRegister("aTDBw", function(module, exports) {

let $7eedc2fbe15b315c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7eedc2fbe15b315c$var$load("38sfA").then(()=>parcelRequire('css4w'));

});

parcelRegister("bTqNO", function(module, exports) {

let $8a899f28c59c2af5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a899f28c59c2af5$var$load("bjmre").then(()=>parcelRequire('9R9u0'));

});

parcelRegister("10NvT", function(module, exports) {

let $0bcc32df5e9c1b1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bcc32df5e9c1b1f$var$load("asvK9").then(()=>parcelRequire('6DTdr'));

});

parcelRegister("4Yta3", function(module, exports) {

let $39f362cd04b24307$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $39f362cd04b24307$var$load("7v6wU").then(()=>parcelRequire('ceZMk'));

});

parcelRegister("7T2DO", function(module, exports) {

let $5bdfb7f14449e2c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bdfb7f14449e2c0$var$load("aEpRh").then(()=>parcelRequire('jtjwW'));

});

parcelRegister("86KYZ", function(module, exports) {

let $5e73541143b39bdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e73541143b39bdc$var$load("3fuR9").then(()=>parcelRequire('l8CqS'));

});

parcelRegister("9ZXMc", function(module, exports) {

let $74782de4a4745e6c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74782de4a4745e6c$var$load("bSjyK").then(()=>parcelRequire('fFbIU'));

});

parcelRegister("bP7Hx", function(module, exports) {

let $89ba6e7402c93988$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89ba6e7402c93988$var$load("fMrUo").then(()=>parcelRequire('hHfxK'));

});

parcelRegister("3iSMg", function(module, exports) {

let $267d8b2ea98c2197$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $267d8b2ea98c2197$var$load("glLvq").then(()=>parcelRequire('lr9gd'));

});

parcelRegister("gjRTJ", function(module, exports) {

let $be183aac679ffec9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be183aac679ffec9$var$load("fFGjZ").then(()=>parcelRequire('ilsFV'));

});

parcelRegister("dDE21", function(module, exports) {

let $9eddf85990b84494$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9eddf85990b84494$var$load("fEAqG").then(()=>parcelRequire('8xJoA'));

});

parcelRegister("7Se25", function(module, exports) {

let $5bb876238d07b83c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bb876238d07b83c$var$load("e9tHh").then(()=>parcelRequire('b1h3K'));

});

parcelRegister("giWmH", function(module, exports) {

let $bdeb99e2433e700b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bdeb99e2433e700b$var$load("9eNkX").then(()=>parcelRequire('2OLbL'));

});

parcelRegister("2rtZr", function(module, exports) {

let $1c755dc3df24f4b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c755dc3df24f4b3$var$load("fTPgj").then(()=>parcelRequire('lSTN4'));

});

parcelRegister("az1hp", function(module, exports) {

let $7b0e2a6644cdd48f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b0e2a6644cdd48f$var$load("h0uBE").then(()=>parcelRequire('74ATO'));

});

parcelRegister("hW673", function(module, exports) {

let $d0ec98572b185326$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d0ec98572b185326$var$load("lKa7i").then(()=>parcelRequire('3fixv'));

});

parcelRegister("34J1c", function(module, exports) {

let $23d4aa8a0a9f8628$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23d4aa8a0a9f8628$var$load("9aufD").then(()=>parcelRequire('kafqC'));

});

parcelRegister("cMfEi", function(module, exports) {

let $94d61b4e9741d415$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94d61b4e9741d415$var$load("gDiIK").then(()=>parcelRequire('19yAM'));

});

parcelRegister("iVQsE", function(module, exports) {

let $dc863e8c0dddf9f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc863e8c0dddf9f8$var$load("j9OUx").then(()=>parcelRequire('jSsWA'));

});

parcelRegister("etB1f", function(module, exports) {
module.exports = JSON.parse("{\"confluence-integrations.project-pages-revamp-onboarding-spotlight.body\":[{\"type\":0,\"value\":\"Pages is now Docs. Access pages, live docs, and more, all from your space.\"}],\"confluence-integrations.project-pages-revamp-onboarding-spotlight.done-button\":[{\"type\":0,\"value\":\"Done\"}],\"confluence-integrations.project-pages-revamp-onboarding-spotlight.heading\":[{\"type\":0,\"value\":\"One place for all your project docs\"}]}");

});

parcelRegister("5LldV", function(module, exports) {

let $4321ce1bae4f3142$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4321ce1bae4f3142$var$load("gSKZ7").then(()=>parcelRequire('g7x15'));

});

parcelRegister("bfGP4", function(module, exports) {

let $831250218e4b907c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $831250218e4b907c$var$load("241y2").then(()=>parcelRequire('cVzWp'));

});

parcelRegister("jGodn", function(module, exports) {

let $03b2a8259b34c7cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03b2a8259b34c7cd$var$load("fiUrV").then(()=>parcelRequire('dYVUd'));

});

parcelRegister("l2Upn", function(module, exports) {

let $f5258a60859ce6a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5258a60859ce6a7$var$load("b6KRV").then(()=>parcelRequire('97MUg'));

});

parcelRegister("2VfwF", function(module, exports) {

let $220cf2c81235c21d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $220cf2c81235c21d$var$load("laRs8").then(()=>parcelRequire('jKikj'));

});

parcelRegister("eLOF2", function(module, exports) {

let $ac0cc0aa12b68703$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac0cc0aa12b68703$var$load("ihLvQ").then(()=>parcelRequire('duV3v'));

});

parcelRegister("ipE39", function(module, exports) {

let $d679a0de1bfa73c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d679a0de1bfa73c3$var$load("kpte5").then(()=>parcelRequire('iDdTS'));

});

parcelRegister("F2Hw0", function(module, exports) {

let $07b5ecc8c47f18e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07b5ecc8c47f18e8$var$load("5rJME").then(()=>parcelRequire('3LFel'));

});

parcelRegister("b6ZoS", function(module, exports) {

let $816fe211df0a558b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $816fe211df0a558b$var$load("5nGh3").then(()=>parcelRequire('3Ytmw'));

});

parcelRegister("hWHhW", function(module, exports) {

let $d1096e9a03cf4173$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1096e9a03cf4173$var$load("bFVOW").then(()=>parcelRequire('dXe5q'));

});

parcelRegister("jWBzC", function(module, exports) {

let $e8509469ba61b591$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8509469ba61b591$var$load("3WqAM").then(()=>parcelRequire('eceNZ'));

});

parcelRegister("lloRn", function(module, exports) {

let $f89ed7c86e16ad91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f89ed7c86e16ad91$var$load("cklES").then(()=>parcelRequire('bn0QF'));

});

parcelRegister("7lhoK", function(module, exports) {

let $5587fd7a436f7f61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5587fd7a436f7f61$var$load("21Ws5").then(()=>parcelRequire('7Kg1P'));

});

parcelRegister("fTfQH", function(module, exports) {

let $b918495e3d30e511$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b918495e3d30e511$var$load("2102R").then(()=>parcelRequire('eYUiC'));

});

parcelRegister("3CPUN", function(module, exports) {

let $2a3d30fb214b5b90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a3d30fb214b5b90$var$load("in9Wy").then(()=>parcelRequire('66KFX'));

});

parcelRegister("8Z1zR", function(module, exports) {

let $68a53e751d64999f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $68a53e751d64999f$var$load("dS5n6").then(()=>parcelRequire('hv1GQ'));

});

parcelRegister("gMfEV", function(module, exports) {

let $c36d4699c00c74fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c36d4699c00c74fa$var$load("1o5cw").then(()=>parcelRequire('a4wat'));

});

parcelRegister("01pCV", function(module, exports) {

let $0043f90b32cbf85d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0043f90b32cbf85d$var$load("5CSYa").then(()=>parcelRequire('k4Lv9'));

});

parcelRegister("bOKuE", function(module, exports) {

let $89a86dd502c623bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89a86dd502c623bd$var$load("f6Zr3").then(()=>parcelRequire('hUDfT'));

});

parcelRegister("5S7fV", function(module, exports) {

let $44679fc6b4cc1216$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44679fc6b4cc1216$var$load("anuaM").then(()=>parcelRequire('3Vj8I'));

});

parcelRegister("aWR85", function(module, exports) {

let $7f888895da0c4719$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f888895da0c4719$var$load("8XAKk").then(()=>parcelRequire('lrt4O'));

});

parcelRegister("gbdXE", function(module, exports) {

let $bc7880d51bfcee0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bc7880d51bfcee0d$var$load("f9fXX").then(()=>parcelRequire('231NI'));

});

parcelRegister("fRIvY", function(module, exports) {

let $b8ce55ef9f483845$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8ce55ef9f483845$var$load("duCyw").then(()=>parcelRequire('kO2e8'));

});

parcelRegister("4O2NT", function(module, exports) {

let $37fe01b7f1e6a7cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $37fe01b7f1e6a7cf$var$load("gEx9H").then(()=>parcelRequire('exwqm'));

});

parcelRegister("6NgG6", function(module, exports) {

let $4f24419c09872f86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f24419c09872f86$var$load("1hTgl").then(()=>parcelRequire('2chuy'));

});

parcelRegister("6GSTs", function(module, exports) {

let $4df13f070ae98ab8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4df13f070ae98ab8$var$load("88xAH").then(()=>parcelRequire('bSpsf'));

});

parcelRegister("jTf4w", function(module, exports) {

let $e7aed858862d2366$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7aed858862d2366$var$load("7dP7b").then(()=>parcelRequire('lSQST'));

});

parcelRegister("ia0mz", function(module, exports) {

let $d389713fce30cc13$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d389713fce30cc13$var$load("hUyOV").then(()=>parcelRequire('XFdXx'));

});

parcelRegister("HzhjT", function(module, exports) {

let $082f61d034fc2e68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $082f61d034fc2e68$var$load("8aW6m").then(()=>parcelRequire('7WRaW'));

});

parcelRegister("jzLQb", function(module, exports) {

let $e4066556e7bcfc40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4066556e7bcfc40$var$load("hFlaj").then(()=>parcelRequire('6B00v'));

});

parcelRegister("j8CoH", function(module, exports) {

let $deec8c9242198d8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $deec8c9242198d8d$var$load("iz678").then(()=>parcelRequire('2i4wj'));

});

parcelRegister("4UqBV", function(module, exports) {

let $393108b5bbff051e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $393108b5bbff051e$var$load("5b4lI").then(()=>parcelRequire('1AsOa'));

});

parcelRegister("fMWzH", function(module, exports) {

let $b7e8c66d571e848e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7e8c66d571e848e$var$load("bM81N").then(()=>parcelRequire('6yFEc'));

});

parcelRegister("4rXW5", function(module, exports) {

let $33d82d12b9b5b676$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33d82d12b9b5b676$var$load("2I5ju").then(()=>parcelRequire('c9fAq'));

});

parcelRegister("l7nJS", function(module, exports) {
module.exports = JSON.parse("{\"rovo-agents.scenario-onboarding.backButton\":[{\"type\":0,\"value\":\"Back\"}],\"rovo-agents.scenario-onboarding.doneButton\":[{\"type\":0,\"value\":\"Done\"}],\"rovo-agents.scenario-onboarding.gettingStarted\":[{\"type\":0,\"value\":\"Getting started with your agent\"}],\"rovo-agents.scenario-onboarding.nextButton\":[{\"type\":0,\"value\":\"Next\"}],\"rovo-agents.scenario-onboarding.startTour\":[{\"type\":0,\"value\":\"Start Tour\"}],\"rovo-agents.scenario-onboarding.step1Body\":[{\"type\":0,\"value\":\"Scenarios allow you to instruct your agent to do things differently depending on the situation.\"}],\"rovo-agents.scenario-onboarding.step1Headline\":[{\"type\":0,\"value\":\"Tune your agent to each situation\"}],\"rovo-agents.scenario-onboarding.step2Body\":[{\"type\":0,\"value\":\"Unlike scenarios, behavior is the instructions your agent always follows, no matter the situation.\"}],\"rovo-agents.scenario-onboarding.step2Headline\":[{\"type\":0,\"value\":\"Set your agent's traits and goals\"}],\"rovo-agents.scenario-onboarding.step3Body\":[{\"type\":0,\"value\":\"You can add knowledge to your agent's scenarios so it has the right information to answer prompts in each situation.\"}],\"rovo-agents.scenario-onboarding.step3Headline\":[{\"type\":0,\"value\":\"See what your agent knows\"}],\"rovo-agents.scenario-onboarding.step4Body\":[{\"type\":0,\"value\":\"You can add skills to your agent's scenarios so it can connect and take action across apps.\"}],\"rovo-agents.scenario-onboarding.step4Headline\":[{\"type\":0,\"value\":\"See what your agent can do\"}],\"rovo-agents.scenario-onboarding.stepIndicator\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}]}");

});

parcelRegister("7F3wY", function(module, exports) {

let $593f19e2a1825cdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $593f19e2a1825cdb$var$load("1eIRF").then(()=>parcelRequire('jDatA'));

});

parcelRegister("5ThXX", function(module, exports) {

let $44a00681c75483f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44a00681c75483f2$var$load("3aKJV").then(()=>parcelRequire('gYv7J'));

});

parcelRegister("ifLF0", function(module, exports) {

let $d49e9915e2025685$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d49e9915e2025685$var$load("bvL9U").then(()=>parcelRequire('3ncrE'));

});

parcelRegister("hQpPC", function(module, exports) {

let $cfdb549eb2c97eba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfdb549eb2c97eba$var$load("1HNuh").then(()=>parcelRequire('1OT7K'));

});

parcelRegister("grX31", function(module, exports) {

let $bf9cf89b15f74ffb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf9cf89b15f74ffb$var$load("5nM89").then(()=>parcelRequire('j1jR0'));

});

parcelRegister("56m6k", function(module, exports) {

let $3b6ea81b2753230a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b6ea81b2753230a$var$load("gfA6x").then(()=>parcelRequire('xrZKp'));

});

parcelRegister("j2jty", function(module, exports) {

let $ddbd4faeff81facd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ddbd4faeff81facd$var$load("2ncxe").then(()=>parcelRequire('dD9uY'));

});

parcelRegister("aUTQd", function(module, exports) {

let $7f2a733d739e2607$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f2a733d739e2607$var$load("gQpFC").then(()=>parcelRequire('1YxvO'));

});

parcelRegister("2lc7b", function(module, exports) {

let $1b46f0b2e881056b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b46f0b2e881056b$var$load("aQi3k").then(()=>parcelRequire('d22qs'));

});

parcelRegister("9De0h", function(module, exports) {

let $70329e6402aff8c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70329e6402aff8c8$var$load("7r4Mk").then(()=>parcelRequire('4JJyB'));

});

parcelRegister("dPQCn", function(module, exports) {

let $a128da9da0a9c917$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a128da9da0a9c917$var$load("ezmrI").then(()=>parcelRequire('scPYT'));

});

parcelRegister("a3wwm", function(module, exports) {

let $752369317e754c2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $752369317e754c2d$var$load("8u2dK").then(()=>parcelRequire('8i35h'));

});

parcelRegister("N8n34", function(module, exports) {

let $093b11f971f19873$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $093b11f971f19873$var$load("iQKsR").then(()=>parcelRequire('eEEbH'));

});

parcelRegister("f73Ab", function(module, exports) {

let $b00a49e19326fcca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b00a49e19326fcca$var$load("l6Qbn").then(()=>parcelRequire('4Ko8J'));

});

parcelRegister("d1TD1", function(module, exports) {

let $97c684fc2512469b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97c684fc2512469b$var$load("cmxTT").then(()=>parcelRequire('lTx3E'));

});

parcelRegister("hqk7Y", function(module, exports) {

let $caf47a5202978575$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf47a5202978575$var$load("kOuFW").then(()=>parcelRequire('eQlp1'));

});

parcelRegister("6JSr6", function(module, exports) {

let $4e812be8e303a1d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e812be8e303a1d8$var$load("7S12o").then(()=>parcelRequire('1Z5O1'));

});

parcelRegister("PTBOV", function(module, exports) {

let $09bfe65332700b28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09bfe65332700b28$var$load("hOtIt").then(()=>parcelRequire('lx8ik'));

});

parcelRegister("BDhK6", function(module, exports) {

let $0711ee08417bc018$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0711ee08417bc018$var$load("hsogV").then(()=>parcelRequire('1IIuQ'));

});

parcelRegister("az4lL", function(module, exports) {

let $7b108c147c097a0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b108c147c097a0b$var$load("a7pdV").then(()=>parcelRequire('bga69'));

});

parcelRegister("kjp2o", function(module, exports) {

let $ec9900f43d05714d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec9900f43d05714d$var$load("ectHA").then(()=>parcelRequire('6CrhD'));

});

parcelRegister("3G2oA", function(module, exports) {

let $2ad7270acf9716fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2ad7270acf9716fd$var$load("iHRZw").then(()=>parcelRequire('cQrPH'));

});

parcelRegister("eDz89", function(module, exports) {

let $aa7ff56684fe27a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa7ff56684fe27a0$var$load("3oWaU").then(()=>parcelRequire('7R82u'));

});

parcelRegister("j0FpS", function(module, exports) {

let $dd6e24d4b9141fff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd6e24d4b9141fff$var$load("bjotz").then(()=>parcelRequire('cqziN'));

});

parcelRegister("3VhJA", function(module, exports) {

let $2db473a318f885fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2db473a318f885fc$var$load("iOoAK").then(()=>parcelRequire('6Hmfz'));

});

parcelRegister("gsLZE", function(module, exports) {

let $bfc47d56c5f3041b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bfc47d56c5f3041b$var$load("kDGaT").then(()=>parcelRequire('9NKdT'));

});

parcelRegister("ebIbe", function(module, exports) {

let $a5445d033110b74d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5445d033110b74d$var$load("jCVeU").then(()=>parcelRequire('eZmdV'));

});

parcelRegister("eJp0O", function(module, exports) {

let $ab98ab87180bb9b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab98ab87180bb9b5$var$load("e8CAg").then(()=>parcelRequire('i7S3K'));

});

parcelRegister("hXakN", function(module, exports) {

let $d11ff691de3a4123$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d11ff691de3a4123$var$load("iALKs").then(()=>parcelRequire('4MIWH'));

});

parcelRegister("dn1vt", function(module, exports) {

let $9bbe978df6b46361$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9bbe978df6b46361$var$load("kiuvA").then(()=>parcelRequire('jVS84'));

});

parcelRegister("3kGQX", function(module, exports) {

let $26d47b161d2812bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26d47b161d2812bd$var$load("9d6gK").then(()=>parcelRequire('8G8gO'));

});

parcelRegister("fcA9B", function(module, exports) {

let $b114056685c3b293$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b114056685c3b293$var$load("alRHJ").then(()=>parcelRequire('6g6AR'));

});

parcelRegister("ayJEf", function(module, exports) {

let $7b007d2471ef62e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b007d2471ef62e7$var$load("5n9Ut").then(()=>parcelRequire('1zo8U'));

});

parcelRegister("eWB3S", function(module, exports) {

let $ae133b1a448e9365$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae133b1a448e9365$var$load("hPmxZ").then(()=>parcelRequire('f7OYW'));

});

parcelRegister("kuHXA", function(module, exports) {
module.exports = JSON.parse('{"post-office.rovo-chat-button.main-heading.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat-button.onboarding-heading":[{"type":0,"value":"Chat with Rovo AI"}],"post-office.rovo-chat-button.onboarding-input-placeholder-1":[{"type":0,"value":"Pick a conversation starter or ask Rovo anything"}],"post-office.rovo-chat-button.onboarding-input-placeholder-2":[{"type":0,"value":"Write a prompt"}],"post-office.rovo-chat-button.send-prompt":[{"type":0,"value":"Send prompt"}],"post-office.rovo-chat-recommended-spaces-spotlight.main-heading.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat-spaces-spotlight.main-heading.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.3p-connector-nudge.connect-button":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"post-office.rovo-chat.3p-connector-nudge.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.3p-connector-nudge.heading":[{"type":0,"value":"Your admin has added "},{"type":1,"value":"appName"}],"post-office.rovo-chat.3p-connector-nudge.logo-alt":[{"type":1,"value":"appName"},{"type":0,"value":" logo"}],"post-office.rovo-chat.3p-connector-nudge.subtitle":[{"type":0,"value":"Connect your account to see more results"}],"post-office.rovo-chat.browse-prompt-gallery-spotlight.body":[{"type":0,"value":"Explore a library of Rovo prompts you can plug into your everyday work, or create your own."}],"post-office.rovo-chat.browse-prompt-gallery-spotlight.headline":[{"type":0,"value":"Browse prompt library"}],"post-office.rovo-chat.long-running-task-fullpage-banner.body":[{"type":0,"value":"Max takes on complex, multi-step work and comes back with a finished result."}],"post-office.rovo-chat.long-running-task-fullpage-banner.cta-button":[{"type":0,"value":"Get a team summary"}],"post-office.rovo-chat.long-running-task-fullpage-banner.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.long-running-task-fullpage-banner.headline":[{"type":0,"value":"Meet Max. It handles everything."}],"post-office.rovo-chat.long-running-task-fullpage-banner.max-label":[{"type":0,"value":"Max"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta":[{"type":0,"value":"Awaiting user response"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta-timestamp":[{"type":0,"value":"1 minute ago"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-title":[{"type":0,"value":"Implement new authentication system"}],"post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-meta":[{"type":0,"value":"Just now"}],"post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-title":[{"type":0,"value":"New Policy Presentation"}],"post-office.rovo-chat.long-running-task-spotlight.body":[{"type":0,"value":"Max takes on complex, multi-step work and comes back with a finished result."}],"post-office.rovo-chat.long-running-task-spotlight.headline":[{"type":0,"value":"Say hi to Max"}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.body":[{"type":0,"value":"Max takes on complex, multi-step work and comes back with a finished result."}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.headline":[{"type":0,"value":"Meet Max. It handles everything."}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.try-max-button":[{"type":0,"value":"Try Max"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.action":[{"type":0,"value":"See how"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.body":[{"type":0,"value":"Rovo now remembers facts and details from your chats to make responses more personalized and helpful"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.headline":[{"type":0,"value":"A more personalized Rovo"}],"post-office.rovo-chat.think-deeper-spotlight.body":[{"type":0,"value":"Turn on Think Deeper for deeper, more nuanced answers to complex questions."}],"post-office.rovo-chat.think-deeper-spotlight.dismiss":[{"type":0,"value":"Turn on Think Deeper"}],"post-office.rovo-chat.think-deeper-spotlight.headline":[{"type":0,"value":"Let Rovo think it through"}],"post-office.rovo-chat.web-search-spotlight.body":[{"type":0,"value":"We\'re running an experiment to improve Rovo. For some users, web search is now on by default\u2014you can turn it off any time."}],"post-office.rovo-chat.web-search-spotlight.dismiss":[{"type":0,"value":"Turn off default web search"}],"post-office.rovo-chat.web-search-spotlight.headline":[{"type":0,"value":"Web search is now on by default"}],"rovo-chat.rovo-chat-scheduled-chat-recurring-chat-complete.message-template.notification-drawer.message":[{"type":0,"value":"Rovo has completed your scheduled query"}],"rovo-chat.rovo-chat-task-awaiting-user.message-template.notification-drawer.message.no-translate":[{"type":0,"value":"Rovo is awaiting your response"}],"rovo-chat.rovo-chat-task-complete.message-template.notification-drawer.message":[{"type":0,"value":"Rovo has completed your task"}],"rovo-chat.rovo-chat-task-plan-generated.message-template.notification-drawer.message.no-translate":[{"type":0,"value":"Rovo has generated your plan"}]}');

});

parcelRegister("6kkJ4", function(module, exports) {

let $49b4b015fd07d712$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49b4b015fd07d712$var$load("4tExh").then(()=>parcelRequire('kIEcR'));

});

parcelRegister("duAZa", function(module, exports) {

let $9d2ac449c04d2fae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9d2ac449c04d2fae$var$load("arcNG").then(()=>parcelRequire('lLLXL'));

});

parcelRegister("1ZERr", function(module, exports) {

let $173b2f118382c0df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $173b2f118382c0df$var$load("grj4p").then(()=>parcelRequire('jeUrc'));

});

parcelRegister("5W4OK", function(module, exports) {

let $45261b30a545c3ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45261b30a545c3ee$var$load("aEKW8").then(()=>parcelRequire('8iZNL'));

});

parcelRegister("1Xy1X", function(module, exports) {

let $16d5b2dfb19b860b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $16d5b2dfb19b860b$var$load("cZ0VC").then(()=>parcelRequire('lKvvi'));

});

parcelRegister("36pnH", function(module, exports) {

let $24259ecd70cc5cb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24259ecd70cc5cb2$var$load("g4FsN").then(()=>parcelRequire('c2ii0'));

});

parcelRegister("9wZAE", function(module, exports) {

let $6f06e0bb2ab680ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6f06e0bb2ab680ed$var$load("k9pVx").then(()=>parcelRequire('b9Hqi'));

});

parcelRegister("aVJvU", function(module, exports) {

let $7f52885251c8de6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f52885251c8de6d$var$load("1wbGe").then(()=>parcelRequire('1KyCW'));

});

parcelRegister("e6Xxe", function(module, exports) {

let $a45fcea7a681458c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a45fcea7a681458c$var$load("cHHbz").then(()=>parcelRequire('l4WVo'));

});

parcelRegister("hqm7k", function(module, exports) {

let $caf6056383f9ccfc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf6056383f9ccfc$var$load("chm8u").then(()=>parcelRequire('cxwZE'));

});

parcelRegister("6cIp2", function(module, exports) {

let $48464e8e7393813e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48464e8e7393813e$var$load("hoc45").then(()=>parcelRequire('gsO3E'));

});

parcelRegister("giM71", function(module, exports) {

let $bde3a5e1d88229e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bde3a5e1d88229e7$var$load("gIp42").then(()=>parcelRequire('2PGTn'));

});

parcelRegister("cBYmo", function(module, exports) {

let $92e7c3060e7e0755$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $92e7c3060e7e0755$var$load("5Twst").then(()=>parcelRequire('enXPa'));

});

parcelRegister("aYwnN", function(module, exports) {

let $7fd8a0870d8c6177$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7fd8a0870d8c6177$var$load("9tpAl").then(()=>parcelRequire('aaFrW'));

});

parcelRegister("lkaJU", function(module, exports) {

let $f863cbd8e34ad951$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f863cbd8e34ad951$var$load("7Pcu0").then(()=>parcelRequire('dajwh'));

});

parcelRegister("56Qpv", function(module, exports) {

let $3b862ae21fe04aad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b862ae21fe04aad$var$load("hdODW").then(()=>parcelRequire('tTm9X'));

});

parcelRegister("iBBMG", function(module, exports) {

let $d8b8fddac712b785$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d8b8fddac712b785$var$load("aypl2").then(()=>parcelRequire('5o2m8'));

});

parcelRegister("kmCuo", function(module, exports) {

let $ed33b7e325cb0d2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ed33b7e325cb0d2b$var$load("dO3RR").then(()=>parcelRequire('jOEcZ'));

});

parcelRegister("hM9fu", function(module, exports) {

let $cf0e17fab34f6002$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cf0e17fab34f6002$var$load("3mD5c").then(()=>parcelRequire('kE4vM'));

});

parcelRegister("40CVR", function(module, exports) {

let $2eb55ca13cdd7241$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2eb55ca13cdd7241$var$load("2y2Ch").then(()=>parcelRequire('7k8BW'));

});

parcelRegister("gcYDt", function(module, exports) {

let $bccccd498ac5ba45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bccccd498ac5ba45$var$load("d12N7").then(()=>parcelRequire('dwo4T'));

});

parcelRegister("avcWa", function(module, exports) {

let $7a56d5ae07b95ef3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a56d5ae07b95ef3$var$load("lESGm").then(()=>parcelRequire('47GVV'));

});

parcelRegister("jzQPI", function(module, exports) {

let $e40a44c4e280bb87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e40a44c4e280bb87$var$load("9F6HY").then(()=>parcelRequire('3z7uV'));

});

parcelRegister("hrbZ6", function(module, exports) {

let $cb1e412738742fb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb1e412738742fb2$var$load("ahU0x").then(()=>parcelRequire('3H2WD'));

});

parcelRegister("10Bed", function(module, exports) {

let $0bc2ab4da0277bc6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bc2ab4da0277bc6$var$load("adiNc").then(()=>parcelRequire('c6bba'));

});

parcelRegister("9FuFO", function(module, exports) {

let $709fbc7cba1dc37a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $709fbc7cba1dc37a$var$load("ffHru").then(()=>parcelRequire('gystd'));

});

parcelRegister("daLb5", function(module, exports) {

let $9970ce0dc32e8e7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9970ce0dc32e8e7a$var$load("a0L9Q").then(()=>parcelRequire('5qvWM'));

});

parcelRegister("gzlIo", function(module, exports) {

let $c100c25e29a49e30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c100c25e29a49e30$var$load("8XqZ4").then(()=>parcelRequire('4Uz2V'));

});

parcelRegister("jpRHl", function(module, exports) {

let $e22a01776f4ffd2c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e22a01776f4ffd2c$var$load("jjCcH").then(()=>parcelRequire('aU7Yz'));

});

parcelRegister("eAst9", function(module, exports) {

let $a9ea82e1fae8fd7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9ea82e1fae8fd7c$var$load("fsg70").then(()=>parcelRequire('5eXRf'));

});

parcelRegister("cIr6G", function(module, exports) {

let $941e9eeef9808254$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $941e9eeef9808254$var$load("2EHdz").then(()=>parcelRequire('fTfTD'));

});

parcelRegister("1N7Ew", function(module, exports) {

let $14e04daa63961c9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $14e04daa63961c9b$var$load("7j1G4").then(()=>parcelRequire('fYv9k'));

});

parcelRegister("5UxGo", function(module, exports) {

let $44dc4f6d428d5ac0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44dc4f6d428d5ac0$var$load("htu7u").then(()=>parcelRequire('jtjxn'));

});

parcelRegister("hMvPE", function(module, exports) {

let $cf1f9c90b97fc9a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cf1f9c90b97fc9a5$var$load("aHfja").then(()=>parcelRequire('3cebw'));

});

parcelRegister("4ArCP", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("2PLrc", function(module, exports) {

let $2105245213baab05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2105245213baab05$var$load("6IgnP").then(()=>parcelRequire('cXffM'));

});

parcelRegister("5U1ma", function(module, exports) {

let $44c33c15b9a33b99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44c33c15b9a33b99$var$load("etfae").then(()=>parcelRequire('2VnH9'));

});

parcelRegister("kK4P8", function(module, exports) {

let $f19bd865db8443da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f19bd865db8443da$var$load("8ZHVT").then(()=>parcelRequire('7DgJW'));

});

parcelRegister("hoIUd", function(module, exports) {

let $caa782eb0833f228$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caa782eb0833f228$var$load("gq0Tc").then(()=>parcelRequire('5snGR'));

});

parcelRegister("e2nxm", function(module, exports) {

let $a383828d6382e132$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a383828d6382e132$var$load("izM4O").then(()=>parcelRequire('epG02'));

});

parcelRegister("1mdVo", function(module, exports) {

let $0fd2a5ad9f52febd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0fd2a5ad9f52febd$var$load("8XgJT").then(()=>parcelRequire('9NdS3'));

});

parcelRegister("8JFse", function(module, exports) {

let $65c2aeb198fcc75c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65c2aeb198fcc75c$var$load("8tckG").then(()=>parcelRequire('7v2P1'));

});

parcelRegister("eU2Qu", function(module, exports) {

let $ad9880b94c6a49d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ad9880b94c6a49d2$var$load("i48Ka").then(()=>parcelRequire('1CO2p'));

});

parcelRegister("d6i2l", function(module, exports) {

let $9899d3a0f207b95e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9899d3a0f207b95e$var$load("aEWBo").then(()=>parcelRequire('ccBfT'));

});

parcelRegister("70pqn", function(module, exports) {

let $519c41435df3f5e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $519c41435df3f5e7$var$load("d3l9I").then(()=>parcelRequire('vmCbT'));

});

parcelRegister("1Qgy2", function(module, exports) {

let $15777be1e774b2c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $15777be1e774b2c2$var$load("fgtWV").then(()=>parcelRequire('3tY7g'));

});

parcelRegister("eczpc", function(module, exports) {

let $a56da67a14c054c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a56da67a14c054c3$var$load("igoEE").then(()=>parcelRequire('3vye7'));

});

parcelRegister("4959m", function(module, exports) {

let $304bff5cb3b9aacf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $304bff5cb3b9aacf$var$load("djqJR").then(()=>parcelRequire('3JM3D'));

});

parcelRegister("9iaw4", function(module, exports) {

let $6c3df3cf6129178b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c3df3cf6129178b$var$load("fABj2").then(()=>parcelRequire('hXfnC'));

});

parcelRegister("j0x3U", function(module, exports) {

let $dd67a9d3b8db233f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd67a9d3b8db233f$var$load("7sFkq").then(()=>parcelRequire('dgCZE'));

});

parcelRegister("9qlD0", function(module, exports) {

let $6dc751a4f44b4143$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dc751a4f44b4143$var$load("7qHX3").then(()=>parcelRequire('1UZnP'));

});

parcelRegister("fdW6i", function(module, exports) {

let $b155237ef71ac220$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b155237ef71ac220$var$load("1XNQi").then(()=>parcelRequire('6wuUu'));

});

parcelRegister("kU4F2", function(module, exports) {

let $f37ca724f60adddd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f37ca724f60adddd$var$load("fGmqG").then(()=>parcelRequire('hVbjH'));

});

parcelRegister("2f1JX", function(module, exports) {

let $1a1e550f768aafc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a1e550f768aafc9$var$load("k8Mg5").then(()=>parcelRequire('7vY7X'));

});

parcelRegister("4xaRW", function(module, exports) {

let $34d2acd6fe62ce11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34d2acd6fe62ce11$var$load("2fube").then(()=>parcelRequire('dXpP9'));

});

parcelRegister("18Vsq", function(module, exports) {

let $0d531baa8ea95e96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d531baa8ea95e96$var$load("6e2m5").then(()=>parcelRequire('cJjia'));

});

parcelRegister("h4ZRi", function(module, exports) {

let $c6f2cb36fcf26313$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c6f2cb36fcf26313$var$load("aFXzM").then(()=>parcelRequire('dlYg3'));

});

parcelRegister("5U8NJ", function(module, exports) {

let $44c902752bb94956$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44c902752bb94956$var$load("b6b20").then(()=>parcelRequire('8H1Dr'));

});

parcelRegister("4nFVq", function(module, exports) {

let $3309d4de5be7f7c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3309d4de5be7f7c0$var$load("bkJkR").then(()=>parcelRequire('ejkS0'));

});

parcelRegister("cuDz2", function(module, exports) {

let $9186f9fb1d673ae1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9186f9fb1d673ae1$var$load("7lqdJ").then(()=>parcelRequire('2OFMK'));

});

parcelRegister("jCQrS", function(module, exports) {

let $e49a401ec3325b56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e49a401ec3325b56$var$load("bkWAs").then(()=>parcelRequire('1L1ql'));

});

parcelRegister("4uQwK", function(module, exports) {

let $3462b591b91acbc6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3462b591b91acbc6$var$load("koc96").then(()=>parcelRequire('kjC8p'));

});

parcelRegister("aWUzU", function(module, exports) {

let $7f8b3569fa2a4e3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f8b3569fa2a4e3f$var$load("7JQmg").then(()=>parcelRequire('bSOOF'));

});

parcelRegister("I7xZy", function(module, exports) {

let $0849f6e745928d71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0849f6e745928d71$var$load("aSU4a").then(()=>parcelRequire('agkOc'));

});

parcelRegister("iKabz", function(module, exports) {

let $03857d9f0aa06539$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03857d9f0aa06539$var$load("7Fau3").then(()=>parcelRequire('j1Kax'));

});

parcelRegister("bMJBQ", function(module, exports) {

let $89478e796e220b5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89478e796e220b5e$var$load("3oYho").then(()=>parcelRequire('3jyyQ'));

});

parcelRegister("29KnO", function(module, exports) {

let $192066bdaa36e4b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $192066bdaa36e4b0$var$load("c9uTg").then(()=>parcelRequire('l0LPi'));

});

parcelRegister("hiOCh", function(module, exports) {

let $03402efde8f45203$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03402efde8f45203$var$load("1djg4").then(()=>parcelRequire('9ODUU'));

});

parcelRegister("6qUXY", function(module, exports) {

let $4af15c21f83e8c6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4af15c21f83e8c6e$var$load("kECXn").then(()=>parcelRequire('kcAVH'));

});

parcelRegister("hutRG", function(module, exports) {
module.exports = JSON.parse("{\"shared-user-preferences-onboarding.modal.alternative-text\":[{\"type\":0,\"value\":\"Alternatively, you can choose light or dark mode from the \"},{\"children\":[{\"type\":0,\"value\":\"Appearance\"}],\"type\":8,\"value\":\"appearanceSettings\"},{\"type\":0,\"value\":\" settings in your profile menu.\"}],\"shared-user-preferences-onboarding.modal.button.accept\":[{\"type\":0,\"value\":\"Okay\"}],\"shared-user-preferences-onboarding.modal.button.choose-theme\":[{\"type\":0,\"value\":\"Choose mode\"}],\"shared-user-preferences-onboarding.modal.button.close\":[{\"type\":0,\"value\":\"Close modal\"}],\"shared-user-preferences-onboarding.modal.description\":[{\"type\":0,\"value\":\"All supported apps will now match your system's display mode by default.\"}],\"shared-user-preferences-onboarding.modal.feature.consistent\":[{\"type\":0,\"value\":\"Consistent look and feel\"}],\"shared-user-preferences-onboarding.modal.feature.override\":[{\"type\":0,\"value\":\"Choose display mode for individual apps\"}],\"shared-user-preferences-onboarding.modal.feature.set-once\":[{\"type\":0,\"value\":\"Only set your display mode once\"}],\"shared-user-preferences-onboarding.modal.title\":[{\"type\":0,\"value\":\"Your display mode is now synced\"}]}");

});

parcelRegister("erlv3", function(module, exports) {

let $a83443b93675ce31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a83443b93675ce31$var$load("kHJL1").then(()=>parcelRequire('klL0c'));

});

parcelRegister("hyrCI", function(module, exports) {

let $cc7b0a16f6921e71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc7b0a16f6921e71$var$load("5zhBR").then(()=>parcelRequire('5ICPG'));

});

parcelRegister("lRpEo", function(module, exports) {

let $fea271e388992377$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fea271e388992377$var$load("7HsFX").then(()=>parcelRequire('hsdoS'));

});

parcelRegister("ggw2O", function(module, exports) {

let $bd76ff498b0c2692$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd76ff498b0c2692$var$load("eezIh").then(()=>parcelRequire('eAim8'));

});

parcelRegister("hPTao", function(module, exports) {

let $cfc1fe04b4fe2cc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfc1fe04b4fe2cc5$var$load("7nZOc").then(()=>parcelRequire('7n1Yj'));

});

parcelRegister("lcBLN", function(module, exports) {

let $f6f80448ec180cb6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f6f80448ec180cb6$var$load("16ctX").then(()=>parcelRequire('ewuzo'));

});

parcelRegister("dBkh6", function(module, exports) {

let $9e6e7534dbc220e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e6e7534dbc220e0$var$load("lRsSW").then(()=>parcelRequire('6tp8x'));

});

parcelRegister("dFJoB", function(module, exports) {

let $9f42516015e35160$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9f42516015e35160$var$load("33w3O").then(()=>parcelRequire('h4r0z'));

});

parcelRegister("4Dzz2", function(module, exports) {

let $3606643c6b9ee668$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3606643c6b9ee668$var$load("3V9JV").then(()=>parcelRequire('agzbM'));

});

parcelRegister("9oSEu", function(module, exports) {

let $6d80bfbb2af7906e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d80bfbb2af7906e$var$load("lR2iC").then(()=>parcelRequire('WTx7Y'));

});

parcelRegister("2LYdk", function(module, exports) {

let $204eadd0e8fafcee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $204eadd0e8fafcee$var$load("3KeA9").then(()=>parcelRequire('9QQr7'));

});

parcelRegister("4BCOh", function(module, exports) {

let $35a8b8f9b156d7b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35a8b8f9b156d7b3$var$load("7VauH").then(()=>parcelRequire('lh3Xp'));

});

parcelRegister("j1vKh", function(module, exports) {

let $dd96bc5344d365e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd96bc5344d365e1$var$load("6gxg1").then(()=>parcelRequire('8IvqN'));

});

parcelRegister("6bsbz", function(module, exports) {

let $4809a23c9cfcbbff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4809a23c9cfcbbff$var$load("fC53x").then(()=>parcelRequire('aVpbD'));

});

parcelRegister("alXGr", function(module, exports) {

let $789a297517fe617c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $789a297517fe617c$var$load("03q9Y").then(()=>parcelRequire('bxkXp'));

});

parcelRegister("2zxWZ", function(module, exports) {

let $1df92f7c22ec43d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1df92f7c22ec43d2$var$load("lzICY").then(()=>parcelRequire('84yl1'));

});

parcelRegister("5ucB7", function(module, exports) {

let $3fe986b556f080fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fe986b556f080fd$var$load("kL6EC").then(()=>parcelRequire('gOpw9'));

});

parcelRegister("h6Pun", function(module, exports) {

let $c74aefd5dc5cb8d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c74aefd5dc5cb8d1$var$load("ls6yt").then(()=>parcelRequire('aXBLi'));

});

parcelRegister("9AvLk", function(module, exports) {

let $6fb01d3683097f98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6fb01d3683097f98$var$load("3b3AF").then(()=>parcelRequire('eio5I'));

});

parcelRegister("3ABqE", function(module, exports) {

let $29d1c47e51ad505c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29d1c47e51ad505c$var$load("fqluR").then(()=>parcelRequire('eabsn'));

});

parcelRegister("lW5ia", function(module, exports) {

let $ff831ea98928c073$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff831ea98928c073$var$load("i4oFC").then(()=>parcelRequire('hjOit'));

});

parcelRegister("biIex", function(module, exports) {

let $83a3affe43753d35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83a3affe43753d35$var$load("dlXMJ").then(()=>parcelRequire('GkLoD'));

});

parcelRegister("4Xmpo", function(module, exports) {

let $39be0dfa20f55fa4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $39be0dfa20f55fa4$var$load("3Wz8w").then(()=>parcelRequire('j1M7k'));

});

parcelRegister("8105H", function(module, exports) {

let $5d5e7cc4f0e8ea0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d5e7cc4f0e8ea0d$var$load("eJuYi").then(()=>parcelRequire('9VUhq'));

});

parcelRegister("6GstT", function(module, exports) {

let $4ddcc21a2fd98dbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ddcc21a2fd98dbb$var$load("gLWOP").then(()=>parcelRequire('bupB5'));

});

parcelRegister("b825f", function(module, exports) {

let $81a20ed37a1f163b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $81a20ed37a1f163b$var$load("xYuTp").then(()=>parcelRequire('Dw2OB'));

});

parcelRegister("7HCuW", function(module, exports) {

let $59ba697e18561da2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $59ba697e18561da2$var$load("lbYf0").then(()=>parcelRequire('17Zy6'));

});

parcelRegister("9Uxty", function(module, exports) {

let $73734f9b01b99814$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73734f9b01b99814$var$load("5RCMm").then(()=>parcelRequire('e6LBR'));

});

parcelRegister("fwEkh", function(module, exports) {

let $b4d9201388e548c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b4d9201388e548c1$var$load("CMPTw").then(()=>parcelRequire('irg4k'));

});

parcelRegister("4QDVl", function(module, exports) {

let $387afcd36034ffd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $387afcd36034ffd4$var$load("3K3Qm").then(()=>parcelRequire('cRU8U'));

});

parcelRegister("k26Lv", function(module, exports) {

let $e9593dfd95311e9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9593dfd95311e9f$var$load("5RzGS").then(()=>parcelRequire('EmpfH'));

});

parcelRegister("7jx5e", function(module, exports) {

let $5533f86dc733431c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5533f86dc733431c$var$load("iIXZI").then(()=>parcelRequire('emiD2'));

});

parcelRegister("c0uLU", function(module, exports) {

let $8bdd5abf3eaac397$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8bdd5abf3eaac397$var$load("iii8A").then(()=>parcelRequire('lxO7G'));

});

parcelRegister("gqxhP", function(module, exports) {

let $bf58e514c67c4a8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf58e514c67c4a8d$var$load("M926c").then(()=>parcelRequire('54Fog'));

});

parcelRegister("8tFY2", function(module, exports) {
module.exports = JSON.parse('{"jsm-nebula-kb-suggested-topic.multiple.button.primary":[{"type":0,"value":"View suggestions"}],"jsm-nebula-kb-suggested-topic.notification.subtitle":[{"type":0,"value":"These suggestions are for "},{"type":1,"value":"projectName"}],"jsm-nebula-kb-suggested-topic.notification.title":[{"offset":0,"options":{"one":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new article suggestion for your knowledge base"}]},"other":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new article suggestions for your knowledge base"}]}},"pluralType":"cardinal","type":6,"value":"numSuggestions"}],"jsm-nebula-kb-suggested-topic.notification.title.legacy":[{"type":0,"value":"You have "},{"type":1,"value":"numSuggestions"},{"type":0,"value":" new article suggestions for your knowledge base"}],"jsm-nebula-kb-suggested-topic.single.button.primary":[{"type":0,"value":"View suggestion"}],"jsm-nebula-kb-suggested-topic.singletopic.notification.subtitle":[{"type":0,"value":"This suggestion is for "},{"type":1,"value":"projectName"}],"jsm-nebula-kb-suggested-topic.singletopic.notification.title":[{"type":0,"value":"You have a new article suggestion for your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.add-knowledge-from-third-party-apps":[{"type":0,"value":"Add knowledge from third-party apps"}],"jsm-nebula.jsm-kb-activation-reminder.boost-agent-productivity":[{"type":0,"value":"Boost agent productivity"}],"jsm-nebula.jsm-kb-activation-reminder.create-or-link-articles":[{"type":0,"value":"Create or link articles."}],"jsm-nebula.jsm-kb-activation-reminder.empower-customers-with-instant-access":[{"type":0,"value":"Empower customers with instant access to helpful articles"}],"jsm-nebula.jsm-kb-activation-reminder.get-started-button-label":[{"type":0,"value":"Get started"}],"jsm-nebula.jsm-kb-activation-reminder.getting-started-is-easy":[{"type":0,"value":"Getting started is easy"}],"jsm-nebula.jsm-kb-activation-reminder.greeting-message":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-nebula.jsm-kb-activation-reminder.header.text":[{"type":0,"value":"Say goodbye to knowledge silos"}],"jsm-nebula.jsm-kb-activation-reminder.how-to-set-up-your-knowledge-base":[{"type":0,"value":"How to set up your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.illustration.alt":[{"type":0,"value":"KnowledgeBase Illustration"}],"jsm-nebula.jsm-kb-activation-reminder.improve-ai-powered-suggestions":[{"type":0,"value":"Improve AI-powered suggestions"}],"jsm-nebula.jsm-kb-activation-reminder.improve-knowledge-base-health-by-closing-knowledge-gaps":[{"type":0,"value":"Improve knowledge base health by closing knowledge gaps."}],"jsm-nebula.jsm-kb-activation-reminder.knowledge-base-benefit":[{"type":0,"value":"By setting up a knowledge base, you can provide instant answers to your customers, reduce repetitive requests, and help your team resolve requests faster."}],"jsm-nebula.jsm-kb-activation-reminder.knowledge-base-help":[{"type":0,"value":"Adding knowledge to your Jira Service Management project helps:"}],"jsm-nebula.jsm-kb-activation-reminder.message-template.email.subject":[{"type":0,"value":"[Jira Service Management] Set up your knowledge base today"}],"jsm-nebula.jsm-kb-activation-reminder.need-help-explore-these-resources":[{"type":0,"value":"Need help? Explore these resources"}],"jsm-nebula.jsm-kb-activation-reminder.privacy-policy":[{"type":0,"value":"Privacy policy"}],"jsm-nebula.jsm-kb-activation-reminder.project-notice":[{"type":0,"value":"We noticed your Jira Service Management project, "},{"children":[{"type":1,"value":"project"}],"type":8,"value":"b"},{"type":0,"value":", doesn\'t have a knowledge base yet."}],"jsm-nebula.jsm-kb-activation-reminder.sent-to-you-by-atlassian-jira-service-management":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management  \u2022"}],"jsm-nebula.jsm-kb-activation-reminder.share-them-with-your-team-and-customers":[{"type":0,"value":"Share them with your team and customers."}],"jsm-nebula.jsm-kb-activation-reminder.start-building-your-knowledge-base":[{"type":0,"value":"Start building your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.stay-notified-and-comment-on-the-go-with-jira-mobile-app":[{"type":0,"value":"Stay notified and comment on the go with Jira Mobile App"}],"jsm-nebula.jsm-kb-activation-reminder.subheading":[{"type":0,"value":"Set up knowledge base to keep requests and knowledge within Jira Service Management."}],"jsm-nebula.jsm-kb-activation-reminder.surface-instant-answers-deflect-requests-and-keep-everything-in-one-place":[{"type":0,"value":"Surface instant answers, deflect requests, and keep everything in one place"}],"jsm-nebula.jsm-kb-activation-reminder.tips-for-writing-effective-knowledge-articles":[{"type":0,"value":"Tips for writing effective knowledge articles"}],"jsm-nebula.jsm-kb-activation-reminder.to-build-your-knowledge-base":[{"type":0,"value":"To build your knowledge base, all you need to do is:"}],"jsm-nebula.jsm-kb-activation-reminder.to-customize-email-or-unsubscribe":[{"type":0,"value":"To customize the email or unsubscribe, "}],"jsm-nebula.jsm-kb-activation-reminder.update-your-notification-settings":[{"type":0,"value":"update your notification settings."}],"jsm-nebula.jsm-kb-activation-reminder.why-set-up-knowledge-base":[{"type":0,"value":"Why set up a knowledge base?"}],"jsm-nebula.solcom-create-space-spotlight.action":[{"type":0,"value":"Get started"}],"jsm-nebula.solcom-create-space-spotlight.body":[{"type":0,"value":"Tell Rovo what you need in plain language and it\'ll build the space for you."}],"jsm-nebula.solcom-create-space-spotlight.headline":[{"type":0,"value":"Support teams faster with Rovo"}]}');

});

parcelRegister("3nXKv", function(module, exports) {

let $2771de058a60e06c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2771de058a60e06c$var$load("iqROb").then(()=>parcelRequire('im0eH'));

});

parcelRegister("leIEI", function(module, exports) {

let $f75d8b7f749e6fca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f75d8b7f749e6fca$var$load("4sP9z").then(()=>parcelRequire('LqrQi'));

});

parcelRegister("1dYwG", function(module, exports) {

let $0e45f49689f57d83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e45f49689f57d83$var$load("gvLDE").then(()=>parcelRequire('I06uX'));

});

parcelRegister("e9ZOX", function(module, exports) {

let $a4f1dc4695cb4e27$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4f1dc4695cb4e27$var$load("6QK6r").then(()=>parcelRequire('9Ow2u'));

});

parcelRegister("bEeHl", function(module, exports) {

let $87aed4dd0a991c4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $87aed4dd0a991c4e$var$load("k4Jlv").then(()=>parcelRequire('ccTJi'));

});

parcelRegister("aZ8JL", function(module, exports) {

let $7ff660e53f1c6f29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ff660e53f1c6f29$var$load("d5Jzq").then(()=>parcelRequire('77rut'));

});

parcelRegister("he4rO", function(module, exports) {

let $c8a731acad5a80e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8a731acad5a80e9$var$load("gHf5y").then(()=>parcelRequire('5uURY'));

});

parcelRegister("64o15", function(module, exports) {

let $46b5bef684736d93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46b5bef684736d93$var$load("1zqYk").then(()=>parcelRequire('dlf7I'));

});

parcelRegister("bO7Bp", function(module, exports) {

let $898a42e225070173$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $898a42e225070173$var$load("7tELK").then(()=>parcelRequire('gDvsM'));

});

parcelRegister("1hanH", function(module, exports) {

let $0edf6e754bfceb5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0edf6e754bfceb5c$var$load("6ESNh").then(()=>parcelRequire('iOhKU'));

});

parcelRegister("lumMh", function(module, exports) {

let $fa4e1183a1e8c30f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa4e1183a1e8c30f$var$load("gamVO").then(()=>parcelRequire('i3Yp6'));

});

parcelRegister("7qzx6", function(module, exports) {

let $5686863b19966002$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5686863b19966002$var$load("lICxg").then(()=>parcelRequire('h3a9U'));

});

parcelRegister("2oSLc", function(module, exports) {

let $1bf84ce43e66be61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1bf84ce43e66be61$var$load("cHh4M").then(()=>parcelRequire('i80JU'));

});

parcelRegister("1Opka", function(module, exports) {

let $151e1ad5e79376c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $151e1ad5e79376c9$var$load("b71cA").then(()=>parcelRequire('cWOCq'));

});

parcelRegister("hgOdp", function(module, exports) {

let $c92ae20406eb33e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c92ae20406eb33e1$var$load("2BuEU").then(()=>parcelRequire('cbTn5'));

});

parcelRegister("557jE", function(module, exports) {

let $3b331828a7115375$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b331828a7115375$var$load("9687j").then(()=>parcelRequire('5EGkB'));

});

parcelRegister("iTAbm", function(module, exports) {

let $dc196e1ac637807b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc196e1ac637807b$var$load("22G8P").then(()=>parcelRequire('8DyEP'));

});

parcelRegister("e2qxW", function(module, exports) {

let $a385d82615df5172$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a385d82615df5172$var$load("kxJyW").then(()=>parcelRequire('eGIuW'));

});

parcelRegister("2aaTR", function(module, exports) {

let $1934f871c8e81c23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1934f871c8e81c23$var$load("cEXVS").then(()=>parcelRequire('8GQeh'));

});

parcelRegister("ast8h", function(module, exports) {

let $79d31e0530a5b3fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79d31e0530a5b3fd$var$load("8utf1").then(()=>parcelRequire('hlHze'));

});

parcelRegister("99Xkk", function(module, exports) {

let $6ab2f967bf420110$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ab2f967bf420110$var$load("5bmMW").then(()=>parcelRequire('lkORs'));

});

parcelRegister("aCCUe", function(module, exports) {

let $7bbba1e21c39b5a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7bbba1e21c39b5a7$var$load("clzcd").then(()=>parcelRequire('jJhAb'));

});

parcelRegister("hSNGq", function(module, exports) {

let $d04e04e3baaba62f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d04e04e3baaba62f$var$load("lUMhq").then(()=>parcelRequire('32PR5'));

});

parcelRegister("7aGbT", function(module, exports) {

let $538a31cb5b0a47b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $538a31cb5b0a47b4$var$load("jjtzM").then(()=>parcelRequire('gM3e8'));

});

parcelRegister("2bbS0", function(module, exports) {

let $1965d1065ab74074$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1965d1065ab74074$var$load("v48e5").then(()=>parcelRequire('5V9FB'));

});

parcelRegister("gBZsU", function(module, exports) {

let $c17fc7c3dadbcfc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c17fc7c3dadbcfc1$var$load("a9FFX").then(()=>parcelRequire('fhz2a'));

});

parcelRegister("3OW7P", function(module, exports) {

let $2c83211165fcc52e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c83211165fcc52e$var$load("3wj8u").then(()=>parcelRequire('aVjQ5'));

});

parcelRegister("lUjFE", function(module, exports) {

let $ff2e162408e0e6a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff2e162408e0e6a2$var$load("c7JWN").then(()=>parcelRequire('5eSQl'));

});

parcelRegister("2LYh8", function(module, exports) {

let $204eb9faa3c9c049$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $204eb9faa3c9c049$var$load("az3fm").then(()=>parcelRequire('3pmXR'));

});

parcelRegister("mONzw", function(module, exports) {

let $044975b8cf3960ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $044975b8cf3960ec$var$load("7TdaH").then(()=>parcelRequire('9kPRv'));

});

parcelRegister("gvgRQ", function(module, exports) {

let $c03ca021c8a0e864$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c03ca021c8a0e864$var$load("lswl3").then(()=>parcelRequire('aN8kL'));

});

parcelRegister("8oRHf", function(module, exports) {

let $61da37a0f28cc1be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61da37a0f28cc1be$var$load("jyBZF").then(()=>parcelRequire('bQjCq'));

});

parcelRegister("hz2Kg", function(module, exports) {

let $cc97d5b03afa0356$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc97d5b03afa0356$var$load("i7bu9").then(()=>parcelRequire('4H9V3'));

});

parcelRegister("jN80O", function(module, exports) {

let $e688cef55af462ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e688cef55af462ad$var$load("3RtDH").then(()=>parcelRequire('96oa3'));

});

parcelRegister("7ppsX", function(module, exports) {
module.exports = JSON.parse('{"post-office.stakeholder-comms-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"stakeholder-comms-confirm-add-subscriber-email.email-events-list.no-translate":[{"type":0,"value":"You will now receive emails whenever:"}],"stakeholder-comms-confirm-add-subscriber-email.endpoint-info.no-translate":[{"type":0,"value":"View Status page"}],"stakeholder-comms-confirm-add-subscriber-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-confirm-add-subscriber-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-confirm-add-subscriber-email.list-item.incident-resolved.no-translate":[{"type":0,"value":"An incident is resolved"}],"stakeholder-comms-confirm-add-subscriber-email.list-item.service-outage.no-translate":[{"type":0,"value":"A service outage or degradation occurs"}],"stakeholder-comms-confirm-add-subscriber-email.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Added as subscriber to status page updates"}],"stakeholder-comms-confirm-add-subscriber-email.message-template.email.subject-with-page-name.no-translate":[{"type":0,"value":"Added as subscriber to "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status updates"}],"stakeholder-comms-confirm-add-subscriber-email.title-message.email.title.no-translate":[{"type":0,"value":"You have been added as a subscriber"}],"stakeholder-comms-confirm-add-subscriber-email.webhook-added.no-translate":[{"type":0,"value":"The admin has successfully added you as a subscriber to "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page."}],"stakeholder-comms-webhook-notification-confirmation-email.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-notification-confirmation-email.endpoint-info.no-translate":[{"type":0,"value":"The endpoint "},{"type":1,"value":"webhookEndpointUrl"},{"type":0,"value":" is now set to receive updates. "}],"stakeholder-comms-webhook-notification-confirmation-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-notification-confirmation-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-notification-confirmation-email.greeting.no-translate":[{"type":0,"value":"Hi there,"}],"stakeholder-comms-webhook-notification-confirmation-email.title-message.email.title.no-translate":[{"type":0,"value":"Webhook subscription activated"}],"stakeholder-comms-webhook-notification-confirmation-email.webhook-added.no-translate":[{"type":0,"value":"We\'ve added your webhook subscription for "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page."}],"stakeholder-comms-webhook-notification-delivery-failure.deactivation-reason.no-translate":[{"type":0,"value":" has been deactivated because we couldn\'t deliver notifications to it. This endpoint was previously reachable, but it\'s now returning errors or is unreachable."}],"stakeholder-comms-webhook-notification-delivery-failure.endpoint-deactivated.no-translate":[{"type":0,"value":"Your endpoint "},{"type":1,"value":"webhookEndpointUrl"}],"stakeholder-comms-webhook-notification-delivery-failure.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-notification-delivery-failure.footer-message-url.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-notification-delivery-failure.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-notification-delivery-failure.resubscribe-message.no-translate":[{"type":0,"value":"To continue receiving updates, resubscribe to your endpoint."}],"stakeholder-comms-webhook-notification-delivery-failure.title-message.email.title.no-translate":[{"type":0,"value":"Webhook subscription deactivated"}],"stakeholder-comms-webhook-validation-failure.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-validation-failure.endpoint-unreachable.no-translate":[{"type":0,"value":"The endpoint "},{"type":1,"value":"webhookEndpointUrl"},{"type":0,"value":" could not be reached or did not respond."}],"stakeholder-comms-webhook-validation-failure.footer-message-url.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-validation-failure.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-validation-failure.title-message.email.title.no-translate":[{"type":0,"value":"Endpoint validation failed"}],"stakeholder-comms-webhook-validation-failure.webhook-validation-error.no-translate":[{"type":0,"value":"We couldn\'t notify your webhook for "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page updates."}],"status-page.create-component-details.spotlight.got-it":[{"type":0,"value":"Ok, got it"}],"status-page.create-component.spotlight.action":[{"type":0,"value":"Dismiss"}],"status-page.create-component.spotlight.primary-action":[{"type":0,"value":"Next"}],"status-page.create-component.spotlight.step1.body":[{"type":0,"value":"Customize each component and link it to a service"}],"status-page.create-component.spotlight.step1.heading":[{"type":0,"value":"Add component"}],"status-page.create-component.spotlight.step2.body":[{"type":0,"value":"Organize your components by adding them to specific groups."}],"status-page.create-component.spotlight.step2.heading":[{"type":0,"value":"Group components"}],"status-page.create-component.spotlight.step3.body":[{"type":0,"value":"Add multiple components and groups for better structure and clarity."}],"status-page.create-component.spotlight.step3.heading":[{"type":0,"value":"Manage and organize"}],"status-page.details.actions.spotlight.body":[{"type":0,"value":"Easily manage your status page, edit details and post updates to keep your audience informed."}],"status-page.details.actions.spotlight.got-it":[{"type":0,"value":"Ok, got it"}],"status-page.details.actions.spotlight.heading":[{"type":0,"value":"Update and manage"}],"status-page.details.tabs.spotlight.action":[{"type":0,"value":"Dismiss"}],"status-page.details.tabs.spotlight.body":[{"type":0,"value":"Review your status page, target audience, and post real-time incident updates, all from a single place."}],"status-page.details.tabs.spotlight.body.line1":[{"type":0,"value":"Review your status page, target"}],"status-page.details.tabs.spotlight.body.line2":[{"type":0,"value":"audience, and post real-time incident"}],"status-page.details.tabs.spotlight.body.line3":[{"type":0,"value":"updates, all from a single place."}],"status-page.details.tabs.spotlight.heading":[{"type":0,"value":"All at a glance"}],"status-page.details.tabs.spotlight.primary-action":[{"type":0,"value":"Next"}],"statuspage.actions-spotlight.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"statuspage.appearance-spotlight.action":[{"type":0,"value":"Ok, got it"}],"statuspage.appearance-spotlight.body":[{"type":0,"value":"Customize with additional flexibility and advanced styling."}],"statuspage.appearance-spotlight.heading":[{"type":0,"value":"Switch to CSS view"}],"statuspage.confirm-incident-notifications.button.verify-email.no-translate":[{"type":0,"value":"Confirm subscription"}],"statuspage.confirm-incident-notifications.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.confirm-incident-notifications.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.confirm-incident-notifications.list-item.incident-resolved.no-translate":[{"type":0,"value":"An incident is resolved"}],"statuspage.confirm-incident-notifications.list-item.scheduled-maintenance.no-translate":[{"type":0,"value":"Scheduled maintenance is announced"}],"statuspage.confirm-incident-notifications.list-item.service-outage.no-translate":[{"type":0,"value":"A service outage or degradation occurs"}],"statuspage.confirm-incident-notifications.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Confirm your email to subscribe to status page updates"}],"statuspage.confirm-incident-notifications.message-template.email.subject-with-page-name.no-translate":[{"type":0,"value":"Confirm your email to subscribe to "},{"type":1,"value":"pageName"},{"type":0,"value":" status updates"}],"statuspage.confirm-incident-notifications.test-message.email.body-hello.no-translate":[{"type":0,"value":"Hi there,"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Please confirm your email address to start receiving incident and maintenance notifications."},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Once confirmed, you\u2019ll receive emails whenever:"}],"statuspage.confirm-incident-notifications.title-message.email.title.no-translate":[{"type":0,"value":"Confirm your subscription"}],"statuspage.create-component-spotlight.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"statuspage.edit-spotlight.action":[{"type":0,"value":"Done"}],"statuspage.edit-spotlight.body":[{"type":0,"value":"Customize your status page to match your brand. Add the components you need and personalize the look and feel with brand new colours and themes."}],"statuspage.edit-spotlight.heading":[{"type":0,"value":"Status page created! Set it up in a few simple steps."}],"statuspage.navigation-spotlight.action":[{"type":0,"value":"About status pages"}],"statuspage.navigation-spotlight.body":[{"type":0,"value":"Post real-time updates and customize your status pages directly from here, without switching platforms."}],"statuspage.navigation-spotlight.heading":[{"type":0,"value":"Create and manage status pages"}],"statuspage.stakeholder-comms-archive-email.title.no-translate":[{"type":0,"value":"Your status page is archived and will be deleted in 60 days."}],"statuspage.stakeholder-comms-archive-page-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-archive-page-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-archive-page-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Details of the status page"}],"statuspage.stakeholder-comms-archive-page-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Atlassian Logo"}],"statuspage.stakeholder-comms-archive-page-email.message-template.email.subject.no-translate":[{"type":0,"value":"Status page archived"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Archived on"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"archivedOn"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"URL"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"pageUrl"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-time-title.no-translate":[{"type":0,"value":"Permanent deletion date"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-time.no-translate":[{"type":1,"value":"deletionDate"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'ve received your request to archive the status page. This status page will be automatically deleted in 60 days"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"If you wish to restore it, you can do so within the next 60 days"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"statuspage.stakeholder-comms-page-restored-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-page-restored-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-page-restored-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Details of the status page"}],"statuspage.stakeholder-comms-page-restored-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Atlassian Logo"}],"statuspage.stakeholder-comms-page-restored-email.message-template.email.subject.no-translate":[{"type":0,"value":"Status page restored"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Archived on"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"archivedOn"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"URL"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"pageUrl"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'ve received your request to restore the status page. You can now edit the page and post any updates as needed."}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"You can publish the page when you\'re ready to make it accessible to all subscribers."}],"statuspage.stakeholder-comms-page-restored-email.title.no-translate":[{"type":0,"value":"Your status page has been restored"}],"statuspage.stakeholder-comms-sender-test.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-sender-test.footer-message.email.body":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-sender-test.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-sender-test.test-message.email.body.no-translate":[{"type":0,"value":"Thanks for subscribing to pageName status updates. You\'re almost done - we just need to confirm your subscription."}],"statuspage.stakeholder-comms-sender-test.test-message.email.link-body.no-translate":[{"type":0,"value":"In order to activate your subscription, please click the following link:"}],"statuspage.stakeholder-comms-sender-test.title-message.email.title":[{"type":0,"value":"Confirm your subscription."}],"statuspage.stakeholder-comms-subscriber-incident-status-email.affected-components.and-more.no-translate":[{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.button.view-status-page.no-translate":[{"type":0,"value":"View Status page"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-unsubscribe-url.email.email.no-translate":[{"type":0,"value":"Unsubscribe"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Incident details"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Status page Incident: "},{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.message-template.email.subject-with-page-name.no-translate":[{"type":1,"value":"pageName"},{"type":0,"value":" Incident: "},{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-affected-components-title.no-translate":[{"type":0,"value":"Affected components"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-affected-components.no-translate":[{"type":1,"value":"affectedComponentsString"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Details"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"incidentDescription"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"Status"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"incidentStatus"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-time-title.no-translate":[{"type":0,"value":"Time posted"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-time.no-translate":[{"type":1,"value":"timePosted"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'re investigating issues reported on the "},{"type":1,"value":"pageNameText"},{"type":0,"value":"status page. Here are the details:"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"You received this email because you subscribed to incident updates for "},{"type":1,"value":"pageNameText"},{"type":0,"value":"."}],"statuspage.stakeholder-comms-subscriber-incident-status-email.title-message.email.title.no-translate":[{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-user-added-verify-email.button.verify-email":[{"type":0,"value":"Verify your email"}],"statuspage.stakeholder-comms-user-added-verify-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-user-added-verify-email.footer-message.email.body":[{"type":0,"value":"This email was sent by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-user-added-verify-email.message-template.email.subject.no-translate":[{"type":0,"value":"[Action required] Verify your email to join "},{"type":1,"value":"siteName"},{"type":0,"value":"\'s site as a stakeholder on "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message1.email.body":[{"type":0,"value":"Know about disruptions that affect operations"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message2.email.body":[{"type":0,"value":"Make better decisions as you\u2019re always informed"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message3.email.body":[{"type":0,"value":"Get notified about the health and status of key services"}],"statuspage.stakeholder-comms-user-added-verify-email.table-title-message.email.title":[{"type":0,"value":"Stay in the loop always"}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body1.no-translate":[{"type":1,"value":"adminName"},{"type":0,"value":" has invited you to join their Jira Service Management site, "},{"type":1,"value":"siteName"},{"type":0,"value":", as a stakeholder."}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body2.no-translate":[{"type":0,"value":"Once you verify your email, you\'ll start receiving important notifications about incidents and changes directly to your inbox."}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body3.no-translate":[{"type":0,"value":"To receive updates on incidents communications, verify your email now!"}],"statuspage.stakeholder-comms-user-added-verify-email.title-message.email.title":[{"type":0,"value":"You\u2019ve been invited to join "},{"type":1,"value":"siteName"},{"type":0,"value":" as a stakeholder"}],"statuspage.stakeholder-comms-webhook-notification-confirmation-email.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription is active"}],"statuspage.stakeholder-comms-webhook-notification-delivery-failure.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription is deactivated"}],"statuspage.stakeholder-comms-webhook-validation-failure.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription could not be activated"}]}');

});

parcelRegister("7gF24", function(module, exports) {

let $54a9db345a9338c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54a9db345a9338c8$var$load("5ArYB").then(()=>parcelRequire('hXq9g'));

});

parcelRegister("72nxx", function(module, exports) {

let $51fafadeb0d7436c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $51fafadeb0d7436c$var$load("1dgv8").then(()=>parcelRequire('dYE6f'));

});

parcelRegister("iF71G", function(module, exports) {

let $d96181978ed56d8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d96181978ed56d8d$var$load("f2KX0").then(()=>parcelRequire('hIIYo'));

});

parcelRegister("iE53B", function(module, exports) {

let $d92fe2ae1e00883e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d92fe2ae1e00883e$var$load("9coRL").then(()=>parcelRequire('4EyIg'));

});

parcelRegister("8aWgE", function(module, exports) {

let $5f3c74a3cd5d6960$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f3c74a3cd5d6960$var$load("jzddh").then(()=>parcelRequire('2gfWF'));

});

parcelRegister("jLeAR", function(module, exports) {

let $e62dba0f61b2777e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e62dba0f61b2777e$var$load("iIEbI").then(()=>parcelRequire('be6hZ'));

});

parcelRegister("lKDeX", function(module, exports) {

let $fd5c551f9a7a1cdf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd5c551f9a7a1cdf$var$load("2XqIN").then(()=>parcelRequire('fb7hK'));

});

parcelRegister("izdO1", function(module, exports) {

let $d846346710e39c96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d846346710e39c96$var$load("dQ2l3").then(()=>parcelRequire('epqic'));

});

parcelRegister("9OmuJ", function(module, exports) {

let $724a3b88421b6346$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $724a3b88421b6346$var$load("ajm0e").then(()=>parcelRequire('2vZro'));

});

parcelRegister("364YA", function(module, exports) {

let $2415cac9c1f42806$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2415cac9c1f42806$var$load("iIB4f").then(()=>parcelRequire('ibWr4'));

});

parcelRegister("6czQz", function(module, exports) {

let $483fab7e40ddcbc6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $483fab7e40ddcbc6$var$load("iN15I").then(()=>parcelRequire('6NsIl'));

});

parcelRegister("csIQU", function(module, exports) {

let $912ae44f06b80f31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $912ae44f06b80f31$var$load("fWAV9").then(()=>parcelRequire('bn3QY'));

});

parcelRegister("270mj", function(module, exports) {

let $189c8376cee1ee77$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $189c8376cee1ee77$var$load("6JKCJ").then(()=>parcelRequire('jG4TR'));

});

parcelRegister("8jLpN", function(module, exports) {

let $60e4e0b761e23396$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $60e4e0b761e23396$var$load("39tTx").then(()=>parcelRequire('8Wi2p'));

});

parcelRegister("eah6n", function(module, exports) {

let $a4ff43f279d4f071$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4ff43f279d4f071$var$load("joEt1").then(()=>parcelRequire('hHUbQ'));

});

parcelRegister("2RSnl", function(module, exports) {

let $216ab5db5df2a0f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $216ab5db5df2a0f6$var$load("3kSEN").then(()=>parcelRequire('hJc2S'));

});

parcelRegister("dfdvc", function(module, exports) {

let $9a472654d7e7dce1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a472654d7e7dce1$var$load("cN2wG").then(()=>parcelRequire('dgIXa'));

});

parcelRegister("8W4t8", function(module, exports) {

let $681734f2e50adc70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $681734f2e50adc70$var$load("cGJDi").then(()=>parcelRequire('mYXr5'));

});

parcelRegister("51u8p", function(module, exports) {

let $3a846bdf61040a72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a846bdf61040a72$var$load("8RFSK").then(()=>parcelRequire('jatQQ'));

});

parcelRegister("38ld7", function(module, exports) {

let $2482926d01f8ef2e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2482926d01f8ef2e$var$load("cCgst").then(()=>parcelRequire('bHDno'));

});

parcelRegister("bFgv5", function(module, exports) {

let $87e052b04e7e8254$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $87e052b04e7e8254$var$load("LGLcC").then(()=>parcelRequire('dKG9e'));

});

parcelRegister("l8jMH", function(module, exports) {

let $f629b1180644f0e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f629b1180644f0e2$var$load("5Wiva").then(()=>parcelRequire('3lIis'));

});

parcelRegister("9qE70", function(module, exports) {

let $6dd5a82a37b5cb6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dd5a82a37b5cb6f$var$load("7ML06").then(()=>parcelRequire('fPUdC'));

});

parcelRegister("VOBXZ", function(module, exports) {

let $0adc95592173a8dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0adc95592173a8dd$var$load("lrlwB").then(()=>parcelRequire('6YNbT'));

});

parcelRegister("bxlxO", function(module, exports) {

let $86637d05ee4bd6a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86637d05ee4bd6a4$var$load("6U9a5").then(()=>parcelRequire('6BEYv'));

});

parcelRegister("fGImP", function(module, exports) {

let $b6bd31add68d182c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6bd31add68d182c$var$load("ckRX4").then(()=>parcelRequire('gTkYl'));

});

parcelRegister("fzJq9", function(module, exports) {

let $b56d5b8bd5ba8dd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b56d5b8bd5ba8dd0$var$load("kbNEA").then(()=>parcelRequire('l6iCj'));

});

parcelRegister("abZe5", function(module, exports) {

let $01ea3b8f57ef2e3e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01ea3b8f57ef2e3e$var$load("5X1g8").then(()=>parcelRequire('9D9Zn'));

});

parcelRegister("gK0xx", function(module, exports) {

let $c3015c7187f2d2a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3015c7187f2d2a8$var$load("k73hK").then(()=>parcelRequire('69IQt'));

});

parcelRegister("5RiXl", function(module, exports) {

let $44409b4c4335dc1b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44409b4c4335dc1b$var$load("di038").then(()=>parcelRequire('at4N2'));

});

parcelRegister("9x7Pe", function(module, exports) {

let $6f0d440e4fe48eed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6f0d440e4fe48eed$var$load("apFA4").then(()=>parcelRequire('8Uafx'));

});

parcelRegister("c4e4Z", function(module, exports) {

let $8c90c7a29415fa00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8c90c7a29415fa00$var$load("5U2BC").then(()=>parcelRequire('dRHXF'));

});

parcelRegister("fpfLj", function(module, exports) {

let $b3756adbe6bad487$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b3756adbe6bad487$var$load("1yBOv").then(()=>parcelRequire('ifoB1'));

});

parcelRegister("dW3ES", function(module, exports) {

let $a253879be9f5463e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a253879be9f5463e$var$load("kKbSg").then(()=>parcelRequire('1KVXU'));

});

parcelRegister("bPfg5", function(module, exports) {
module.exports = JSON.parse("{\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.cta-link\":[{\"type\":0,\"value\":\"Go to space\"}],\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.description\":[{\"type\":0,\"value\":\"Your work has been imported and your new space is set up.\"}],\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.header\":[{\"type\":0,\"value\":\"Your space is ready\"}]}");

});

parcelRegister("ezpFa", function(module, exports) {

let $a9b83db75ebdfa78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9b83db75ebdfa78$var$load("2qOCh").then(()=>parcelRequire('7JKgU'));

});

parcelRegister("6iXcm", function(module, exports) {

let $49725813ca63d55b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49725813ca63d55b$var$load("03WMB").then(()=>parcelRequire('dAEo8'));

});

parcelRegister("j8hPt", function(module, exports) {

let $dedc982ff2eaa678$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dedc982ff2eaa678$var$load("h5VNS").then(()=>parcelRequire('lQn4R'));

});

parcelRegister("c6ypt", function(module, exports) {

let $8d00bca18b827604$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d00bca18b827604$var$load("lxr0E").then(()=>parcelRequire('abbF5'));

});

parcelRegister("9A6MN", function(module, exports) {

let $6f9cbd64c1a64e1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6f9cbd64c1a64e1c$var$load("6l2hr").then(()=>parcelRequire('aNYjC'));

});

parcelRegister("kl8Zu", function(module, exports) {

let $ececbe37726dad14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ececbe37726dad14$var$load("9CWyj").then(()=>parcelRequire('fFPOJ'));

});

parcelRegister("10ck8", function(module, exports) {

let $0baf59cb178fa5a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0baf59cb178fa5a6$var$load("4B9n7").then(()=>parcelRequire('agWh9'));

});

parcelRegister("emoOI", function(module, exports) {

let $a7465ee90cbdfab2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7465ee90cbdfab2$var$load("anisN").then(()=>parcelRequire('cD2NX'));

});

parcelRegister("b029V", function(module, exports) {

let $80215e8f2ae8ab10$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80215e8f2ae8ab10$var$load("36O9w").then(()=>parcelRequire('bSViP'));

});

parcelRegister("dPDLv", function(module, exports) {

let $a11ee25685ccef58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a11ee25685ccef58$var$load("9qEz1").then(()=>parcelRequire('bFptX'));

});

parcelRegister("bmPng", function(module, exports) {

let $846999a017a21b87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $846999a017a21b87$var$load("cCbWj").then(()=>parcelRequire('l1llD'));

});

parcelRegister("1xaPk", function(module, exports) {

let $11e1457d4d702906$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11e1457d4d702906$var$load("3kXIu").then(()=>parcelRequire('5iVcV'));

});

parcelRegister("h89gC", function(module, exports) {

let $c78a5f3eec2dabae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c78a5f3eec2dabae$var$load("kyiBf").then(()=>parcelRequire('cVYDx'));

});

parcelRegister("iwOVL", function(module, exports) {

let $d7d2b8ee6b7fb89a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d7d2b8ee6b7fb89a$var$load("7eq0t").then(()=>parcelRequire('5OplD'));

});

parcelRegister("582EA", function(module, exports) {

let $3bbfc211672dfce4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3bbfc211672dfce4$var$load("jIzEI").then(()=>parcelRequire('ldTTG'));

});

parcelRegister("15jtm", function(module, exports) {

let $0ca55cea4dbeb4e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ca55cea4dbeb4e0$var$load("3WxEy").then(()=>parcelRequire('kXiet'));

});

parcelRegister("1ylzx", function(module, exports) {

let $1219b33518bb4566$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1219b33518bb4566$var$load("6YHoC").then(()=>parcelRequire('gthKH'));

});

parcelRegister("aVqqC", function(module, exports) {

let $7f43ba5ea74ed6de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f43ba5ea74ed6de$var$load("gJtR0").then(()=>parcelRequire('lSfIJ'));

});

parcelRegister("irnoA", function(module, exports) {

let $d6cce58116c2533f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6cce58116c2533f$var$load("fJ7q0").then(()=>parcelRequire('5QXEz'));

});

parcelRegister("a703N", function(module, exports) {

let $75ca9ac96602639f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $75ca9ac96602639f$var$load("4d16d").then(()=>parcelRequire('7K3fk'));

});

parcelRegister("1Vjjh", function(module, exports) {

let $166a17de206a4de3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $166a17de206a4de3$var$load("bYDIT").then(()=>parcelRequire('6hrDD'));

});

parcelRegister("b7TOB", function(module, exports) {

let $819ba4e59ad80b06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $819ba4e59ad80b06$var$load("gFJt8").then(()=>parcelRequire('g80pJ'));

});

parcelRegister("3xF69", function(module, exports) {

let $2944556c31557f59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2944556c31557f59$var$load("dh4Wb").then(()=>parcelRequire('5EyDB'));

});

parcelRegister("g7M1d", function(module, exports) {

let $bbd28c47371534d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bbd28c47371534d3$var$load("fVFxc").then(()=>parcelRequire('kNpoD'));

});

parcelRegister("adblt", function(module, exports) {

let $76f3eb390344c8b7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $76f3eb390344c8b7$var$load("6o7ls").then(()=>parcelRequire('fh2Ml'));

});

parcelRegister("bjieh", function(module, exports) {

let $83bf9c065dd6dcca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83bf9c065dd6dcca$var$load("aOAzu").then(()=>parcelRequire('3OWN0'));

});

parcelRegister("iIpDn", function(module, exports) {

let $da00387ad9b5b2ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da00387ad9b5b2ea$var$load("k2wwM").then(()=>parcelRequire('fbqEA'));

});

parcelRegister("iaV4U", function(module, exports) {

let $d3b56fb298db0816$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d3b56fb298db0816$var$load("esWeu").then(()=>parcelRequire('6PgoT'));

});

parcelRegister("38VFR", function(module, exports) {

let $249edb54231dbd75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $249edb54231dbd75$var$load("dpc6a").then(()=>parcelRequire('7kaW9'));

});

parcelRegister("6pvxQ", function(module, exports) {

let $4aad8c0467fe6195$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4aad8c0467fe6195$var$load("52GZF").then(()=>parcelRequire('9bpvb'));

});

parcelRegister("6eJ39", function(module, exports) {

let $48a6fed0a9446fc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48a6fed0a9446fc1$var$load("8qdgi").then(()=>parcelRequire('kcXTr'));

});

parcelRegister("guWtA", function(module, exports) {

let $c02cced8a10bcd24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c02cced8a10bcd24$var$load("fW1wG").then(()=>parcelRequire('9mlRX'));

});

parcelRegister("amBL2", function(module, exports) {

let $78b93f564d391b51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78b93f564d391b51$var$load("9KGbC").then(()=>parcelRequire('iL0ro'));

});

parcelRegister("OtK4y", function(module, exports) {

let $097bbdc9f0f62ff6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $097bbdc9f0f62ff6$var$load("1Ns7e").then(()=>parcelRequire('82dJs'));

});

parcelRegister("cyz5M", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $3NyPa = parcelRequire("3NyPa");

var $h6POP = parcelRequire("h6POP");


var $hOVIX = parcelRequire("hOVIX");


var $4oTqF = parcelRequire("4oTqF");


var $eNels = parcelRequire("eNels");


var $aEUWC = parcelRequire("aEUWC");


var $2amyA = parcelRequire("2amyA");


var $cTbOk = parcelRequire("cTbOk");


var $cqOSB = parcelRequire("cqOSB");


var $4S89c = parcelRequire("4S89c");


var $9iUWG = parcelRequire("9iUWG");


var $fUB5z = parcelRequire("fUB5z");


var $2HRxT = parcelRequire("2HRxT");


var $5pgAV = parcelRequire("5pgAV");


var $42omo = parcelRequire("42omo");


var $lVEBn = parcelRequire("lVEBn");


var $2GePd = parcelRequire("2GePd");

const $765afc5340447923$var$STABLE_EMPTY_OBJECT = {};
const $765afc5340447923$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        ...props,
        children: children
    });
};
const $765afc5340447923$export$7b7e5a348ef9a7c1 = (messageComponents, placementId, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $42omo.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, SuspenseBoundary: SuspenseBoundary = (0, $42omo.Suspense), ...data })=>{
            const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
            /// https://switcheroo.atlassian.com/ui/gates/e8049c84-32d5-4452-a52f-5b92940a1b55/key/post-office_enable-i18n-migration-pull
            const isI18nMigrationInAppEnabled = (0, $c6GJD.default).checkGate('post-office_enable-i18n-migration-pull');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $42omo.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $3NyPa.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const isChunkLoadError = (error)=>{
                    return error?.name === 'ChunkLoadError';
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        if (!isChunkLoadError(error)) messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $hOVIX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $hOVIX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $42omo.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                        name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = (0, $9iUWG.isClientTriggeredMessage)(triggerType);
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $cqOSB.useWaitForTrigger)({
                    hasTrigger: hasTrigger,
                    messageSuccessComponent: messageSuccessComponent,
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                const messageContextValue = (0, $42omo.useMemo)(()=>({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        triggerId: triggerId,
                        messageCreationType: messageCreationType,
                        transactionAccountId: componentProps.transactionAccountId,
                        analyticsDetails: postOffice?.analyticsDetails,
                        journeyId: journeyId,
                        journeyTriggerId: journeyTriggerId,
                        configSetId: configSetId
                    }), [
                    componentProps.transactionAccountId
                ]);
                // MaybeChoreographerWrapper sits at the top so it can claim its slot while the
                // lazy chunk is loading; it no-ops for client-triggered messages, which handle
                // their own choreography via MaybeTriggeredMessageValidator below.
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GePd.MaybeChoreographerWrapper), {
                    ChoreographerWrapper: (0, $lVEBn.ChoreographerWrapper),
                    enabled: !waitForTrigger,
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4oTqF.MessageContextProvider), {
                            value: messageContextValue,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5pgAV.RecommendationProvider), {
                                value: recommendationSession ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT,
                                children: /*#__PURE__*/ (0, $l998X.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cTbOk.MaybeTriggeredMessageValidator), {
                                        waitForTrigger: waitForTrigger,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aEUWC.MessageAnalyticsContextProvider), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eNels.MaybeI18nProvider), {
                                                messageTemplateId: messageTemplateId,
                                                placementId: placementId,
                                                isI18nMigrationInAppEnabled: isI18nMigrationInAppEnabled,
                                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4S89c.MaybeManualMessageViewedEvent), {
                                                    isManual: !!waitForTrigger,
                                                    children: [
                                                        !waitForTrigger && messageSuccessComponent,
                                                        /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                                            onError: onError,
                                                            messageInstanceId: messageInstanceId,
                                                            ...componentProps,
                                                            waitForTrigger: waitForTrigger
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $2HRxT.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $765afc5340447923$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $765afc5340447923$export$7b7e5a348ef9a7c1;

});

parcelRegister("3NyPa", function(module, exports) {

var $jTlSd = parcelRequire("jTlSd");


var $koKWt = parcelRequire("koKWt");

const $959aa8656bf0972c$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jTlSd.MessagePerformanceTracker,
    PlacementPerformanceTracker: $koKWt.PlacementPerformanceTracker
};
module.exports["UFOv1"] = $959aa8656bf0972c$export$96236906ebaa7f87;

});

parcelRegister("jTlSd", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");


var $haNjI = parcelRequire("haNjI");

class $71d7f78b2ff13923$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}
module.exports["MessagePerformanceTracker"] = $71d7f78b2ff13923$export$ae5c73c7c4f454e6;

});

parcelRegister("haNjI", function(module, exports) {
const $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $ac68ec5e99dfa5a8$export$6d482cfa20c9d220 = 'post-office';
module.exports["UFOExperienceNames"] = $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1;
module.exports["POST_OFFICE_PLATFORM_NAME"] = $ac68ec5e99dfa5a8$export$6d482cfa20c9d220;

});

parcelRegister("koKWt", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");


var $haNjI = parcelRequire("haNjI");

const $f3e04d171a04c0ba$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $9NDUe.ExperienceTypes).Load,
    platform: {
        component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $f3e04d171a04c0ba$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).PLACEMENT, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).PLACEMENT}.${placementId}`, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}
module.exports["PlacementPerformanceTracker"] = $f3e04d171a04c0ba$export$8b48c2105ba0b35a;

});

parcelRegister("lVEBn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $7XIdu = parcelRequire("7XIdu");


var $iX6G3 = parcelRequire("iX6G3");


var $42omo = parcelRequire("42omo");

const $5d2b57d7f45b3b6a$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
};
const $5d2b57d7f45b3b6a$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $iX6G3.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $c6GJD.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $l998X.jsx)($5d2b57d7f45b3b6a$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $5d2b57d7f45b3b6a$export$8db7ba034addcd65;

});

parcelRegister("6Ht9d", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $876859b1b10b173e$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $42omo.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $gAOec.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};
module.exports["useInitialData"] = $876859b1b10b173e$export$5523c5f3222291d0;

});

parcelRegister("hTU1a", function(module, exports) {

let $d08306ae8bff4fa5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d08306ae8bff4fa5$var$load("h4yKa").then(()=>parcelRequire('bjivg'));

});

parcelRegister("bb6sB", function(module, exports) {

let $8235bbab86deaaa4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8235bbab86deaaa4$var$load("93D7z").then(()=>parcelRequire('fIb2d'));

});

parcelRegister("jf6d3", function(module, exports) {

let $e0243c229ad6fc52$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0243c229ad6fc52$var$load("93RXD").then(()=>parcelRequire('6os8i'));

});

parcelRegister("g0non", function(module, exports) {

let $ba6eca9d62eacbb8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ba6eca9d62eacbb8$var$load("bc1BA").then(()=>parcelRequire('5Zjce'));

});

parcelRegister("900Tl", function(module, exports) {

let $68d4ce2eb5ab2d90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $68d4ce2eb5ab2d90$var$load("dKAaX").then(()=>parcelRequire('294kL'));

});

parcelRegister("bVJjp", function(module, exports) {

let $8af82a9c0ece1581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8af82a9c0ece1581$var$load("4dpWD").then(()=>parcelRequire('7SHFw'));

});

parcelRegister("iQHra", function(module, exports) {

let $db8ec709e01760d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db8ec709e01760d7$var$load("7ls3M").then(()=>parcelRequire('irXKC'));

});

parcelRegister("8U3Nd", function(module, exports) {

let $67b67edf18287ae3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $67b67edf18287ae3$var$load("12uC0").then(()=>parcelRequire('9pA9M'));

});

parcelRegister("bTY1R", function(module, exports) {

let $8aa3654344ce03cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8aa3654344ce03cf$var$load("exQVH").then(()=>parcelRequire('iOHLg'));

});

parcelRegister("4fb4L", function(module, exports) {

let $3171278f11ef4417$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3171278f11ef4417$var$load("8rWck").then(()=>parcelRequire('1r6du'));

});

parcelRegister("f9guR", function(module, exports) {

let $b0747e2c06952289$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b0747e2c06952289$var$load("5ENiY").then(()=>parcelRequire('8lCJL'));

});

parcelRegister("lQwjw", function(module, exports) {

let $fe77852e92c886a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fe77852e92c886a8$var$load("9dJhQ").then(()=>parcelRequire('g8iJD'));

});

parcelRegister("5U9Yl", function(module, exports) {

let $44c9eafdbd28a60a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44c9eafdbd28a60a$var$load("2wttk").then(()=>parcelRequire('3oOnx'));

});

parcelRegister("gXIev", function(module, exports) {

let $c59477ca8c3a8a55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c59477ca8c3a8a55$var$load("5qOLN").then(()=>parcelRequire('ldyM5'));

});

parcelRegister("gwAtY", function(module, exports) {

let $c07bef2cddcb73d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c07bef2cddcb73d1$var$load("1D9vJ").then(()=>parcelRequire('juVkd'));

});

parcelRegister("5BuKr", function(module, exports) {

let $4148425e85d6f15e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4148425e85d6f15e$var$load("boFd7").then(()=>parcelRequire('grycR'));

});

parcelRegister("eauZQ", function(module, exports) {

let $a50a0b1c5e96b610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a50a0b1c5e96b610$var$load("h7r0P").then(()=>parcelRequire('fb7nO'));

});

parcelRegister("8XR9v", function(module, exports) {

let $686d105ea6a075e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $686d105ea6a075e0$var$load("8VzF2").then(()=>parcelRequire('gfK9i'));

});

parcelRegister("bslzO", function(module, exports) {

let $85730be23691ebd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85730be23691ebd0$var$load("9vzi2").then(()=>parcelRequire('8CypG'));

});

parcelRegister("1d288", function(module, exports) {

let $0e18a85f5dbc5617$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e18a85f5dbc5617$var$load("dIyZu").then(()=>parcelRequire('g0Wiv'));

});

parcelRegister("96AVN", function(module, exports) {

let $6a11525bf35a54cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a11525bf35a54cb$var$load("5UqSO").then(()=>parcelRequire('ipFcd'));

});

parcelRegister("2BGsK", function(module, exports) {

let $1e5ff9aac99e40ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1e5ff9aac99e40ec$var$load("j2ACX").then(()=>parcelRequire('7EXUe'));

});

parcelRegister("1kO9S", function(module, exports) {

let $0f8e9117d973ab95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0f8e9117d973ab95$var$load("fjOTL"),
    $0f8e9117d973ab95$var$load("c8a0g")
]).then(()=>parcelRequire('kInVV'));

});

parcelRegister("b1asB", function(module, exports) {

let $8057e6e51e4964e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8057e6e51e4964e5$var$load("ebZF2").then(()=>parcelRequire('ihYsf'));

});

parcelRegister("brkAz", function(module, exports) {

let $85422fd3b55d9ddf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85422fd3b55d9ddf$var$load("jh0xO").then(()=>parcelRequire('6vWxb'));

});

parcelRegister("9AH4j", function(module, exports) {

let $6fb8e2605623658a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6fb8e2605623658a$var$load("8d1Ke").then(()=>parcelRequire('gdOxp'));

});

parcelRegister("d75wG", function(module, exports) {

let $98c03729e6d79948$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $98c03729e6d79948$var$load("aBROj"),
    $98c03729e6d79948$var$load("6wr18"),
    $98c03729e6d79948$var$load("lRtGG"),
    $98c03729e6d79948$var$load("ffEVr"),
    $98c03729e6d79948$var$load("46epn")
]).then(()=>parcelRequire('5xYPR'));

});

parcelRegister("dnOiB", function(module, exports) {

let $9be470ad19e76e8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9be470ad19e76e8b$var$load("lPDuX"),
    $9be470ad19e76e8b$var$load("aBROj"),
    $9be470ad19e76e8b$var$load("3EXzu"),
    $9be470ad19e76e8b$var$load("7EorR"),
    $9be470ad19e76e8b$var$load("kM6re")
]).then(()=>parcelRequire('bTu8V'));

});

parcelRegister("6JAdj", function(module, exports) {

let $4e7309541c056fdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e7309541c056fdc$var$load("aBROj"),
    $4e7309541c056fdc$var$load("fRrg0")
]).then(()=>parcelRequire('7aApD'));

});

parcelRegister("g3tI0", function(module, exports) {

let $bb03f8ac8e4a5cb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb03f8ac8e4a5cb2$var$load("hIrqC").then(()=>parcelRequire('3R9Ru'));

});

parcelRegister("4RySe", function(module, exports) {

let $38a729dd5eb2038e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $38a729dd5eb2038e$var$load("FzfPQ"),
    $38a729dd5eb2038e$var$load("fiBFO"),
    $38a729dd5eb2038e$var$load("c5gFe")
]).then(()=>parcelRequire('6KYBJ'));

});

parcelRegister("jSc4X", function(module, exports) {

let $e77c6e1ea58cd4da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e77c6e1ea58cd4da$var$load("iVcX9").then(()=>parcelRequire('dPlvK'));

});

parcelRegister("xpCDf", function(module, exports) {

let $0646f5324dac52e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0646f5324dac52e5$var$load("6wr18"),
    $0646f5324dac52e5$var$load("aBROj"),
    $0646f5324dac52e5$var$load("3EXzu"),
    $0646f5324dac52e5$var$load("ffEVr"),
    $0646f5324dac52e5$var$load("7EorR"),
    $0646f5324dac52e5$var$load("4eilt"),
    $0646f5324dac52e5$var$load("d23vF")
]).then(()=>parcelRequire('egpSh'));

});

parcelRegister("4GwkX", function(module, exports) {

let $36942b25c7f0adbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $36942b25c7f0adbe$var$load("6wr18"),
    $36942b25c7f0adbe$var$load("aBROj"),
    $36942b25c7f0adbe$var$load("3EXzu"),
    $36942b25c7f0adbe$var$load("ffEVr"),
    $36942b25c7f0adbe$var$load("7EorR"),
    $36942b25c7f0adbe$var$load("4eilt")
]).then(()=>parcelRequire('6tq3k'));

});

parcelRegister("5u7cq", function(module, exports) {

let $3fe556c4830dec85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3fe556c4830dec85$var$load("6wr18"),
    $3fe556c4830dec85$var$load("aBROj"),
    $3fe556c4830dec85$var$load("3EXzu"),
    $3fe556c4830dec85$var$load("ffEVr"),
    $3fe556c4830dec85$var$load("7EorR"),
    $3fe556c4830dec85$var$load("iqdt6")
]).then(()=>parcelRequire('gu1SQ'));

});

parcelRegister("jtUHm", function(module, exports) {

let $e2ecb4df1a43b756$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e2ecb4df1a43b756$var$load("FzfPQ"),
    $e2ecb4df1a43b756$var$load("fiBFO"),
    $e2ecb4df1a43b756$var$load("j1DDh")
]).then(()=>parcelRequire('d6NMQ'));

});

parcelRegister("at41i", function(module, exports) {

let $79efbb17c427a8c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79efbb17c427a8c2$var$load("hf3XM").then(()=>parcelRequire('dr2b4'));

});

parcelRegister("3dm00", function(module, exports) {

let $2573a691bcbac548$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2573a691bcbac548$var$load("3sCrn").then(()=>parcelRequire('2ydpK'));

});

parcelRegister("jbib7", function(module, exports) {

let $df6d254068fd899e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df6d254068fd899e$var$load("hPZ3K").then(()=>parcelRequire('7jH0G'));

});

parcelRegister("aW9IB", function(module, exports) {

let $7f66dc05a7f2fc7f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f66dc05a7f2fc7f$var$load("97bNj").then(()=>parcelRequire('8Iqyb'));

});

parcelRegister("kdxw4", function(module, exports) {

let $eb7f052f3ce7cdea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb7f052f3ce7cdea$var$load("huMm6").then(()=>parcelRequire('4XtLB'));

});

parcelRegister("9htqv", function(module, exports) {

let $6c1c8719debb9147$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c1c8719debb9147$var$load("erKaD").then(()=>parcelRequire('hTBTI'));

});

parcelRegister("74iQN", function(module, exports) {

let $52578770dbf18e77$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $52578770dbf18e77$var$load("lPDuX"),
    $52578770dbf18e77$var$load("aBROj"),
    $52578770dbf18e77$var$load("3EXzu"),
    $52578770dbf18e77$var$load("7EorR"),
    $52578770dbf18e77$var$load("34wRu")
]).then(()=>parcelRequire('hja8R'));

});

parcelRegister("5Ew3s", function(module, exports) {

let $41d98d9a93c93f63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $41d98d9a93c93f63$var$load("lPDuX"),
    $41d98d9a93c93f63$var$load("aBROj"),
    $41d98d9a93c93f63$var$load("3EXzu"),
    $41d98d9a93c93f63$var$load("7EorR"),
    $41d98d9a93c93f63$var$load("eL8EA")
]).then(()=>parcelRequire('2QxAP'));

});

parcelRegister("e3KlB", function(module, exports) {

let $a3c54c25ed6d20ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a3c54c25ed6d20ea$var$load("8otE8").then(()=>parcelRequire('bOshH'));

});

parcelRegister("desqE", function(module, exports) {

let $9a22a28de06616ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a22a28de06616ce$var$load("3ZqxH").then(()=>parcelRequire('kIA2G'));

});

parcelRegister("Y8oCe", function(module, exports) {

let $0b4c1dfcbc76e900$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b4c1dfcbc76e900$var$load("exk8r").then(()=>parcelRequire('boMNP'));

});

parcelRegister("4BuLh", function(module, exports) {

let $35a27abe4c3775b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35a27abe4c3775b6$var$load("fiBFO"),
    $35a27abe4c3775b6$var$load("5Qmut")
]).then(()=>parcelRequire('aIf1e'));

});

parcelRegister("1Thq7", function(module, exports) {

let $160870cd2afcf06c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $160870cd2afcf06c$var$load("8TN4y"),
    $160870cd2afcf06c$var$load("cv1Ay")
]).then(()=>parcelRequire('hKsAh'));

});

parcelRegister("l9jc8", function(module, exports) {

let $f65953e7bd7ee0ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f65953e7bd7ee0ba$var$load("8V7ms").then(()=>parcelRequire('9DGMu'));

});

parcelRegister("gg5UE", function(module, exports) {

let $bd62ba1e49d87c89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd62ba1e49d87c89$var$load("2oglp").then(()=>parcelRequire('84C2y'));

});

parcelRegister("goKWQ", function(module, exports) {

let $bf034e2a70454555$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf034e2a70454555$var$load("5xRpV").then(()=>parcelRequire('aSwMH'));

});

parcelRegister("65CjO", function(module, exports) {

let $46f0eefc31262c97$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46f0eefc31262c97$var$load("gaUC1").then(()=>parcelRequire('k8aVR'));

});

parcelRegister("dDm9g", function(module, exports) {

let $9ed01917b2488134$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ed01917b2488134$var$load("ikrRd").then(()=>parcelRequire('cRKQU'));

});

parcelRegister("8E2z4", function(module, exports) {

let $64b40c71124461de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64b40c71124461de$var$load("3G5wx").then(()=>parcelRequire('fwAQ0'));

});

parcelRegister("lyKqX", function(module, exports) {

let $fb20cac298a0e97d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fb20cac298a0e97d$var$load("4p4bD").then(()=>parcelRequire('ebxMi'));

});

parcelRegister("cMkRx", function(module, exports) {

let $94da2697eca13e72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94da2697eca13e72$var$load("6CK1s").then(()=>parcelRequire('a43ur'));

});

parcelRegister("rjKoE", function(module, exports) {

let $0521d723e88be2a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0521d723e88be2a7$var$load("20iLk").then(()=>parcelRequire('hYgtC'));

});

parcelRegister("dFvPJ", function(module, exports) {

let $9f37cc1eaee640ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9f37cc1eaee640ca$var$load("bPoc6").then(()=>parcelRequire('l1cwM'));

});

parcelRegister("24wf9", function(module, exports) {

let $1824f760dd5ac3b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1824f760dd5ac3b9$var$load("6ZSIb").then(()=>parcelRequire('jAPEN'));

});

parcelRegister("kgs2Y", function(module, exports) {

let $ec0b0ed3b6ec9643$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec0b0ed3b6ec9643$var$load("1npYA").then(()=>parcelRequire('35P9D'));

});

parcelRegister("g4zqA", function(module, exports) {

let $bb388044271af3bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb388044271af3bc$var$load("9I3Em").then(()=>parcelRequire('5IOvx'));

});

parcelRegister("dMUgb", function(module, exports) {

let $a09b6621f6da2119$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a09b6621f6da2119$var$load("7vRg5").then(()=>parcelRequire('lVbkE'));

});

parcelRegister("03acy", function(module, exports) {

let $009831b91d91f422$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $009831b91d91f422$var$load("iYPek").then(()=>parcelRequire('j1Wqs'));

});

parcelRegister("4ImLl", function(module, exports) {

let $36eceda780ae6a46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $36eceda780ae6a46$var$load("4tuq5").then(()=>parcelRequire('b2Ry1'));

});

parcelRegister("hNYGB", function(module, exports) {

let $cf661641c8417ef7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cf661641c8417ef7$var$load("gyva2").then(()=>parcelRequire('2QAiP'));

});

parcelRegister("2mRvB", function(module, exports) {

let $1b9724963056563b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b9724963056563b$var$load("8WNrC").then(()=>parcelRequire('a23Fb'));

});

parcelRegister("a4VVI", function(module, exports) {

let $756736c480fdf3f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $756736c480fdf3f7$var$load("hczM1").then(()=>parcelRequire('aFt5p'));

});

parcelRegister("9YH9O", function(module, exports) {

let $743b31ccb40794e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $743b31ccb40794e9$var$load("1QuSH").then(()=>parcelRequire('goHEt'));

});

parcelRegister("c6gD1", function(module, exports) {

let $8cf2f19aba8abe15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cf2f19aba8abe15$var$load("1llHF").then(()=>parcelRequire('hRgVC'));

});

parcelRegister("gUPfp", function(module, exports) {

let $c509a1044c062b0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c509a1044c062b0d$var$load("53uoN").then(()=>parcelRequire('1XcBd'));

});

parcelRegister("gH4Ot", function(module, exports) {

let $c27465423d200909$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c27465423d200909$var$load("deMui").then(()=>parcelRequire('59bfh'));

});

parcelRegister("jrYzB", function(module, exports) {

let $e28f86870e73c161$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e28f86870e73c161$var$load("gaiTQ").then(()=>parcelRequire('cZGXJ'));

});

parcelRegister("fAjAo", function(module, exports) {

let $b589692d13892081$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b589692d13892081$var$load("4wkIO").then(()=>parcelRequire('k0o7T'));

});

parcelRegister("1glQs", function(module, exports) {

let $0eb83b06fd19ab1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0eb83b06fd19ab1c$var$load("fmozR").then(()=>parcelRequire('cbsIf'));

});

parcelRegister("jF00y", function(module, exports) {

let $e501da3677b46538$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e501da3677b46538$var$load("S8fB3").then(()=>parcelRequire('bNgTk'));

});

parcelRegister("kb2TK", function(module, exports) {

let $eb07153bb4afe625$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb07153bb4afe625$var$load("5zlmP").then(()=>parcelRequire('9ZJkB'));

});

parcelRegister("74jEK", function(module, exports) {

let $52582772199b31df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $52582772199b31df$var$load("d6flF").then(()=>parcelRequire('4Wdl0'));

});

parcelRegister("afy8z", function(module, exports) {

let $7765c9059accb5d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7765c9059accb5d1$var$load("fOy1c").then(()=>parcelRequire('71rIN'));

});

parcelRegister("2hmq4", function(module, exports) {

let $1a8e8f57156882ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a8e8f57156882ea$var$load("10oey").then(()=>parcelRequire('j6mc5'));

});

parcelRegister("1m9L7", function(module, exports) {

let $0fcf6a6c902e7280$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0fcf6a6c902e7280$var$load("gQwgB").then(()=>parcelRequire('1MfEz'));

});

parcelRegister("3SMxY", function(module, exports) {

let $2d3c12adcab1dd26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d3c12adcab1dd26$var$load("dodbW").then(()=>parcelRequire('gDcgd'));

});

parcelRegister("eCJ4O", function(module, exports) {

let $aa5794924fcfa5fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa5794924fcfa5fd$var$load("d864Y").then(()=>parcelRequire('8rWqo'));

});

parcelRegister("5VGt6", function(module, exports) {

let $451337f7d8a3cfcf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $451337f7d8a3cfcf$var$load("9fPPq").then(()=>parcelRequire('1a3na'));

});

parcelRegister("cGuso", function(module, exports) {

let $93c10865f2f86d2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93c10865f2f86d2b$var$load("926ek").then(()=>parcelRequire('gNkpT'));

});

parcelRegister("fIBDg", function(module, exports) {

let $b7182811a1f3453c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7182811a1f3453c$var$load("5oL16").then(()=>parcelRequire('aVGO8'));

});

parcelRegister("jzkrd", function(module, exports) {

let $e3f123c2e1375d6a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3f123c2e1375d6a$var$load("6hlj7").then(()=>parcelRequire('3huTA'));

});

parcelRegister("03cg3", function(module, exports) {

let $0099ca1fc3bc865a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0099ca1fc3bc865a$var$load("hgwjT").then(()=>parcelRequire('hUlaJ'));

});

parcelRegister("784KA", function(module, exports) {

let $530cf711c93a624a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $530cf711c93a624a$var$load("fiBFO"),
    $530cf711c93a624a$var$load("FzfPQ"),
    $530cf711c93a624a$var$load("kxlMs")
]).then(()=>parcelRequire('kjCoc'));

});

parcelRegister("6YLik", function(module, exports) {

let $514d08698aec540b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $514d08698aec540b$var$load("1I3KI").then(()=>parcelRequire('dq3jd'));

});

parcelRegister("kGns1", function(module, exports) {

let $f0e9ebc241f09935$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0e9ebc241f09935$var$load("155CX").then(()=>parcelRequire('mBDMf'));

});

parcelRegister("dPlq7", function(module, exports) {

let $a110a76617ccca15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a110a76617ccca15$var$load("cW8qz").then(()=>parcelRequire('ck1ow'));

});

parcelRegister("dTFwU", function(module, exports) {

let $a1e0a0603445ceb1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a1e0a0603445ceb1$var$load("6h7Dg").then(()=>parcelRequire('dQkDP'));

});

parcelRegister("ci6eu", function(module, exports) {

let $8f2c002f239dfefb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f2c002f239dfefb$var$load("4gpLy").then(()=>parcelRequire('6UP22'));

});

parcelRegister("hLbyA", function(module, exports) {

let $cedfca6d92755e84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cedfca6d92755e84$var$load("736Db").then(()=>parcelRequire('dWTrq'));

});

parcelRegister("l6eYL", function(module, exports) {

let $03f6cd88694518ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03f6cd88694518ff$var$load("agMxe").then(()=>parcelRequire('lVVzR'));

});

parcelRegister("aZcJG", function(module, exports) {

let $7ff97af68d9dd80d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ff97af68d9dd80d$var$load("lfhXC").then(()=>parcelRequire('gLPpx'));

});

parcelRegister("5nybb", function(module, exports) {

let $3ea99d068d70d7a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ea99d068d70d7a7$var$load("9Qhhe").then(()=>parcelRequire('88Bjk'));

});

parcelRegister("5Ctct", function(module, exports) {

let $417726e7e4b7895d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $417726e7e4b7895d$var$load("emi2C").then(()=>parcelRequire('fnP3P'));

});

parcelRegister("bpSbS", function(module, exports) {

let $84fc10a63ed23969$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $84fc10a63ed23969$var$load("9Y9iM").then(()=>parcelRequire('9lpql'));

});

parcelRegister("kctk3", function(module, exports) {

let $eb4bac7953570ae6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eb4bac7953570ae6$var$load("kXvCT"),
    $eb4bac7953570ae6$var$load("7RIp3")
]).then(()=>parcelRequire('aPPv4'));

});

parcelRegister("a5SgP", function(module, exports) {

let $759477ffefef3dca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $759477ffefef3dca$var$load("6wr18"),
    $759477ffefef3dca$var$load("3Bbwl"),
    $759477ffefef3dca$var$load("ffEVr"),
    $759477ffefef3dca$var$load("jUe3X")
]).then(()=>parcelRequire('jvsYc'));

});

parcelRegister("8KCLJ", function(module, exports) {

let $65f0b147b0e37b9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65f0b147b0e37b9a$var$load("6jNWq").then(()=>parcelRequire('5n8d3'));

});

parcelRegister("8jPAy", function(module, exports) {

let $60e81d84db92fa5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $60e81d84db92fa5a$var$load("3m9re").then(()=>parcelRequire('hHfH9'));

});

parcelRegister("jQsf1", function(module, exports) {

let $e728c7c2d23dfa69$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e728c7c2d23dfa69$var$load("7tbBL").then(()=>parcelRequire('ihnIJ'));

});

parcelRegister("fjl4m", function(module, exports) {

let $02e0671e0db95b34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $02e0671e0db95b34$var$load("lJPCo").then(()=>parcelRequire('ke5ij'));

});

parcelRegister("4hqZj", function(module, exports) {

let $31ddaf346ef5c5c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31ddaf346ef5c5c1$var$load("ii2Wd").then(()=>parcelRequire('hHVBf'));

});

parcelRegister("kLxqa", function(module, exports) {

let $f1e21f23604d8652$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f1e21f23604d8652$var$load("4Prt0").then(()=>parcelRequire('kt6eN'));

});

parcelRegister("1GI2N", function(module, exports) {

let $13abe0e7d14f5dd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $13abe0e7d14f5dd3$var$load("6QkbA").then(()=>parcelRequire('ctI4X'));

});

parcelRegister("hJ8Of", function(module, exports) {

let $ce7d7908dd10889a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce7d7908dd10889a$var$load("6JwQH").then(()=>parcelRequire('hbs7o'));

});

parcelRegister("4CxN9", function(module, exports) {

let $35d4ec5b1eabc8c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35d4ec5b1eabc8c3$var$load("b10B7").then(()=>parcelRequire('8HTYi'));

});

parcelRegister("jGphw", function(module, exports) {

let $e5458cfba4c65ac9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5458cfba4c65ac9$var$load("k6Mgt").then(()=>parcelRequire('6GeD6'));

});

parcelRegister("5VKYq", function(module, exports) {

let $4516b69db175142b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4516b69db175142b$var$load("19xe3").then(()=>parcelRequire('VtCYO'));

});

parcelRegister("d0tJU", function(module, exports) {

let $978258157c3ccbb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $978258157c3ccbb9$var$load("gex3C").then(()=>parcelRequire('fbBtU'));

});

parcelRegister("15VmW", function(module, exports) {

let $0cc2c2594abf6469$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cc2c2594abf6469$var$load("ct6TX").then(()=>parcelRequire('gjADW'));

});

parcelRegister("kSf38", function(module, exports) {

let $f324865071f67fcd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f324865071f67fcd$var$load("24ezh").then(()=>parcelRequire('5EUjv'));

});

parcelRegister("4ofl9", function(module, exports) {

let $33254d86d7329c03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33254d86d7329c03$var$load("cdpNa").then(()=>parcelRequire('fnPeI'));

});

parcelRegister("1AIyT", function(module, exports) {

let $128bb8421ef0600d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $128bb8421ef0600d$var$load("4IqoW").then(()=>parcelRequire('9MFI2'));

});

parcelRegister("4Udyh", function(module, exports) {

let $3926e77ebe10a403$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3926e77ebe10a403$var$load("4J3Jj").then(()=>parcelRequire('4kFqh'));

});

parcelRegister("3MyU8", function(module, exports) {

let $2c10ee187ec42483$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c10ee187ec42483$var$load("3oXss").then(()=>parcelRequire('iQte8'));

});

parcelRegister("61npX", function(module, exports) {

let $46250056c949eba0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46250056c949eba0$var$load("hzaTn").then(()=>parcelRequire('eChjc'));

});

parcelRegister("8TKKA", function(module, exports) {

let $67a7b96a0b51df46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $67a7b96a0b51df46$var$load("aGJ4a").then(()=>parcelRequire('gp1NP'));

});

parcelRegister("3AgQf", function(module, exports) {

let $29c1cc518bdaefae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29c1cc518bdaefae$var$load("b1Kbr").then(()=>parcelRequire('5cT1i'));

});

parcelRegister("ca9BQ", function(module, exports) {

let $8daddf6d18007a46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8daddf6d18007a46$var$load("cs6LB"),
    $8daddf6d18007a46$var$load("9anPW"),
    $8daddf6d18007a46$var$load("50ame"),
    $8daddf6d18007a46$var$load("1N732")
]).then(()=>parcelRequire('bAtET'));

});

parcelRegister("8nGSq", function(module, exports) {

let $61a1bb2956db4bd1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61a1bb2956db4bd1$var$load("1L1aL").then(()=>parcelRequire('eeTD0'));

});

parcelRegister("7Gwv2", function(module, exports) {

let $5985aa6aa1cde555$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5985aa6aa1cde555$var$load("fFJCh"),
    $5985aa6aa1cde555$var$load("e7iKc")
]).then(()=>parcelRequire('jTxsP'));

});

parcelRegister("bbxjT", function(module, exports) {

let $824a916ad0e535f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $824a916ad0e535f2$var$load("dVK77").then(()=>parcelRequire('coICk'));

});

parcelRegister("h2YRW", function(module, exports) {

let $c691d6e7a4c309d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c691d6e7a4c309d9$var$load("iZIdc").then(()=>parcelRequire('6eooX'));

});

parcelRegister("eFGJr", function(module, exports) {

let $aae60ab8248b77d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aae60ab8248b77d9$var$load("2VVfz").then(()=>parcelRequire('1phEn'));

});

parcelRegister("eATWS", function(module, exports) {

let $a9ffd3b9918d5398$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9ffd3b9918d5398$var$load("adyb9").then(()=>parcelRequire('iPB5v'));

});

parcelRegister("fpuJu", function(module, exports) {

let $b38107aeb3d357bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b38107aeb3d357bb$var$load("cuewJ").then(()=>parcelRequire('71Pdv'));

});

parcelRegister("hWIYP", function(module, exports) {

let $d10abe901d2defc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d10abe901d2defc4$var$load("5NFhD").then(()=>parcelRequire('011Nq'));

});

parcelRegister("9AN3p", function(module, exports) {

let $6fbd86f7a9f4543c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6fbd86f7a9f4543c$var$load("9USAR").then(()=>parcelRequire('adC7x'));

});

parcelRegister("iENKQ", function(module, exports) {

let $d9528ea2c35efad4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9528ea2c35efad4$var$load("jk1pK").then(()=>parcelRequire('d63bs'));

});

parcelRegister("7gIM8", function(module, exports) {

let $54acc2810421afaf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54acc2810421afaf$var$load("1LBwE").then(()=>parcelRequire('8KQQq'));

});

parcelRegister("16is3", function(module, exports) {

let $0cd4aa0da212dd4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cd4aa0da212dd4a$var$load("YwKAY").then(()=>parcelRequire('73NdU'));

});

parcelRegister("7xmBT", function(module, exports) {

let $57cd275d14d207d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57cd275d14d207d0$var$load("cs6LB"),
    $57cd275d14d207d0$var$load("gufL1"),
    $57cd275d14d207d0$var$load("9anPW"),
    $57cd275d14d207d0$var$load("50ame"),
    $57cd275d14d207d0$var$load("9tDpQ")
]).then(()=>parcelRequire('8joER'));

});

parcelRegister("5vi32", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    return (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("9QvUi", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4H1Ql = parcelRequire("4H1Ql");


var $NT2w1 = parcelRequire("NT2w1");


var $2mPpz = parcelRequire("2mPpz");


var $eXPKf = parcelRequire("eXPKf");


var $42omo = parcelRequire("42omo");


var $2xYsH = parcelRequire("2xYsH");


var $hnA4H = parcelRequire("hnA4H");

const $13bb23ac78effffb$var$STABLE_OBJECT = {};
const $13bb23ac78effffb$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $42omo.useMemo)(()=>(0, $2mPpz.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $4H1Ql.useStableObject)(placementProps ?? $13bb23ac78effffb$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $NT2w1.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2xYsH.default), {
                    analyticsChannel: (0, $hnA4H.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
const $13bb23ac78effffb$var$PlacementMemoized = /*#__PURE__*/ (0, $42omo.memo)($13bb23ac78effffb$var$Placement);
var $13bb23ac78effffb$export$2e2bcd8739ae039 = $13bb23ac78effffb$var$PlacementMemoized;
module.exports["default"] = $13bb23ac78effffb$export$2e2bcd8739ae039;

});

parcelRegister("NT2w1", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $ffCOo = parcelRequire("ffCOo");


var $1eSke = parcelRequire("1eSke");

var $PAiZW = parcelRequire("PAiZW");

var $6yHRM = parcelRequire("6yHRM");

var $4H1Ql = parcelRequire("4H1Ql");


var $3NyPa = parcelRequire("3NyPa");


var $kO3gu = parcelRequire("kO3gu");


var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $dE7qQ = parcelRequire("dE7qQ");


var $5dPMD = parcelRequire("5dPMD");


var $dug7n = parcelRequire("dug7n");


var $feexy = parcelRequire("feexy");


var $9x4nt = parcelRequire("9x4nt");


var $dh538 = parcelRequire("dh538");

const $80ab3a0c2f45d583$var$useInitialDataIfEnabled = (0, $4pOgL.isReactCompilerActivePlatform)() ? (placementId, context, baseUrl, path, disableInitialData)=>{
    const $ = (0, $frIzR.c)(10);
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    let t0;
    if ($[0] !== context) {
        t0 = (0, $1eSke.isPostOfficePlacementsGloballyDisabled)(context);
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const arePlacementsGloballyDisabled = t0;
    let t1;
    if ($[2] !== arePlacementsGloballyDisabled || $[3] !== baseUrl || $[4] !== context || $[5] !== disableInitialData || $[6] !== fetcher.fetch || $[7] !== path || $[8] !== placementId) {
        t1 = arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $5dPMD.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        });
        $[2] = arePlacementsGloballyDisabled;
        $[3] = baseUrl;
        $[4] = context;
        $[5] = disableInitialData;
        $[6] = fetcher.fetch;
        $[7] = path;
        $[8] = placementId;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    const arePlacementsGloballyDisabled = (0, $1eSke.isPostOfficePlacementsGloballyDisabled)(context);
    return (0, $42omo.useMemo)(()=>arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $5dPMD.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        arePlacementsGloballyDisabled,
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $80ab3a0c2f45d583$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $80ab3a0c2f45d583$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $80ab3a0c2f45d583$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $4u5NT.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $4u5NT.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $80ab3a0c2f45d583$var$Placement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: t1, children: children } = t0;
    const disableInitialData = t1 === undefined ? false : t1;
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $dug7n.useBuildBasePath)();
    let t2;
    if ($[0] !== context || $[1] !== postOfficeRoute) {
        t2 = {
            ...context,
            postOfficeRoute: postOfficeRoute
        };
        $[0] = context;
        $[1] = postOfficeRoute;
        $[2] = t2;
    } else t2 = $[2];
    const stableContextWithRoute = (0, $4H1Ql.useStableObject)(t2);
    let t3;
    if ($[3] !== consumptionType || $[4] !== placementId) {
        t3 = new (0, $3NyPa.UFOv1).PlacementPerformanceTracker(placementId, consumptionType);
        $[3] = consumptionType;
        $[4] = placementId;
        $[5] = t3;
    } else t3 = $[5];
    const ufoV1PlacementTracker = t3;
    const ufoV2InteractionId = (0, $42omo.useContext)((0, $feexy.default));
    const ufoV2InteractionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const t4 = ufoV2InteractionContext?.labelStack;
    let t5;
    if ($[6] !== t4 || $[7] !== ufoV2InteractionId.current) {
        t5 = {
            interactionId: ufoV2InteractionId.current,
            labelStack: t4
        };
        $[6] = t4;
        $[7] = ufoV2InteractionId.current;
        $[8] = t5;
    } else t5 = $[8];
    const stableUfoV2Interaction = (0, $4H1Ql.useStableObject)(t5);
    let t6;
    if ($[9] !== consumptionType || $[10] !== placementId || $[11] !== placementOnEvent || $[12] !== stableUfoV2Interaction || $[13] !== ufoV1PlacementTracker) {
        t6 = (t7)=>{
            const { type: type, error: error } = t7;
            if (consumptionType === "local") {
                switch(type){
                    case "fetch-error":
                    case "component-error":
                    case "render-error":
                        if ((0, $dh538.fg)("post-office_enable_ufo-v2-add-error")) $80ab3a0c2f45d583$var$handleUfoV2Error({
                            ufoV2Interaction: stableUfoV2Interaction,
                            placementId: placementId,
                            error: error,
                            errorEventType: type
                        });
                }
                return;
            }
            if (consumptionType === "remote") {
                placementOnEvent?.({
                    type: type,
                    error: error
                });
                bb31: switch(type){
                    case "fetch-complete":
                        ufoV1PlacementTracker?.markFetchComplete();
                        break bb31;
                    case "fetch-error":
                        ufoV1PlacementTracker?.markFetchFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                        break bb31;
                    case "render-complete":
                        ufoV1PlacementTracker?.markRenderComplete();
                        break bb31;
                    case "render-error":
                        ufoV1PlacementTracker?.markRenderFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                        break bb31;
                    case "initial-data-complete":
                        ufoV1PlacementTracker?.markInitialDataComplete();
                        break bb31;
                    case "initial-data-error":
                        ufoV1PlacementTracker?.markInitialDataFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                        break bb31;
                    case "component-error":
                        ufoV1PlacementTracker?.markComponentFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                        break bb31;
                    case "component-ready":
                        ufoV1PlacementTracker?.markComponentReady();
                        break bb31;
                    case "unmount":
                        ufoV1PlacementTracker?.markComponentAborted();
                }
            }
        };
        $[9] = consumptionType;
        $[10] = placementId;
        $[11] = placementOnEvent;
        $[12] = stableUfoV2Interaction;
        $[13] = ufoV1PlacementTracker;
        $[14] = t6;
    } else t6 = $[14];
    const componentOnEvent = t6;
    const initialData = $80ab3a0c2f45d583$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    let t7;
    if ($[15] !== placementId) {
        t7 = {
            source: (0, $dE7qQ.ANALYTICS_SOURCE),
            componentName: "Placement",
            attributes: {
                placementId: placementId,
                channel: "in-app"
            }
        };
        $[15] = placementId;
        $[16] = t7;
    } else t7 = $[16];
    const placementAnalyticsContext = t7;
    let t8;
    if ($[17] !== children || $[18] !== componentOnEvent || $[19] !== initialData || $[20] !== stableContextWithRoute) {
        t8 = children({
            initialData: initialData,
            context: stableContextWithRoute,
            onEvent: componentOnEvent
        });
        $[17] = children;
        $[18] = componentOnEvent;
        $[19] = initialData;
        $[20] = stableContextWithRoute;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== placementAnalyticsContext || $[23] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext
        }, t8);
        $[22] = placementAnalyticsContext;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $dug7n.useBuildBasePath)();
    const stableContextWithRoute = (0, $4H1Ql.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $42omo.useMemo)(()=>isUFOEnabled ? new (0, $3NyPa.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $42omo.useContext)((0, $feexy.default));
    const ufoV2InteractionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const stableUfoV2Interaction = (0, $4H1Ql.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $42omo.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    if ((0, $dh538.fg)('post-office_enable_ufo-v2-add-error')) $80ab3a0c2f45d583$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $80ab3a0c2f45d583$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $42omo.useMemo)(()=>({
            source: (0, $dE7qQ.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext
    }, children({
        initialData: initialData,
        context: stableContextWithRoute,
        onEvent: componentOnEvent
    }));
};
var $80ab3a0c2f45d583$export$2e2bcd8739ae039 = $80ab3a0c2f45d583$var$Placement;
module.exports["default"] = $80ab3a0c2f45d583$export$2e2bcd8739ae039;

});

parcelRegister("dE7qQ", function(module, exports) {
const $2d2adb07a8ea6d4a$export$85183a312807388d = 'postOffice';
const $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6 = 'post-office-frontend';
module.exports["ANALYTICS_SOURCE"] = $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6;

});

parcelRegister("dug7n", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $bnKhH = parcelRequire("bnKhH");

var $c3xd8 = parcelRequire("c3xd8");


var $42omo = parcelRequire("42omo");

const $f2f503b4228c54ff$export$83d6c58b7ab7ae67 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const postOfficeEnvironment = (0, $c3xd8.usePostOfficeEnvironment)();
    let t0;
    if ($[0] !== postOfficeEnvironment.currentEnv || $[1] !== postOfficeEnvironment.envConfigs) {
        t0 = (0, $bnKhH.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs);
        $[0] = postOfficeEnvironment.currentEnv;
        $[1] = postOfficeEnvironment.envConfigs;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const postOfficeEnvironment = (0, $c3xd8.usePostOfficeEnvironment)();
    return (0, $42omo.useMemo)(()=>(0, $bnKhH.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};
module.exports["useBuildBasePath"] = $f2f503b4228c54ff$export$83d6c58b7ab7ae67;

});

parcelRegister("2xYsH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $1DWH0 = parcelRequire("1DWH0");


var $42omo = parcelRequire("42omo");

class $1916333c8b5a116e$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $1916333c8b5a116e$var$ErrorBoundaryWithAnalytics = (0, $1DWH0.default)()($1916333c8b5a116e$var$ErrorBoundary);
var $1916333c8b5a116e$export$2e2bcd8739ae039 = $1916333c8b5a116e$var$ErrorBoundaryWithAnalytics;
module.exports["default"] = $1916333c8b5a116e$export$2e2bcd8739ae039;

});

parcelRegister("hnA4H", function(module, exports) {
const $f3b0e253e752d4df$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $f3b0e253e752d4df$export$85183a312807388d;

});

parcelRegister("9oJIg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kO3gu = parcelRequire("kO3gu");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO3gu.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("8MKuN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $b1Jpy = parcelRequire("b1Jpy");

const $88668855474bc367$export$27cee8d00af73bce = [
    'edit-page.page_load',
    'edit-page.transition',
    'space-overview-edit-page.page_load',
    'space-overview-edit-page.transition',
    'live-edit.page_load',
    'live-edit.transition'
];
function $88668855474bc367$export$2510d15b8c74a469({ children: children, excludedInteractions: excludedInteractions = $88668855474bc367$export$27cee8d00af73bce }) {
    // Capture the interaction once at mount time to ensure stable behavior for the
    // component's lifetime. getActiveInteraction() can return null mid-render cycle
    // if the UFO interaction ends, which would cause the ignore prop to toggle
    // between renders and effectively un-ignore the hold on a subsequent re-render.
    const ignoreHoldsRef = (0, $42omo.useRef)(null);
    if (ignoreHoldsRef.current === null) {
        const interaction = (0, $4u5NT.getActiveInteraction)();
        if (interaction) {
            const { type: type, ufoName: ufoName } = interaction;
            ignoreHoldsRef.current = excludedInteractions.includes(`${ufoName}.${type}`);
        } else ignoreHoldsRef.current = false;
    }
    const ignoreHolds = ignoreHoldsRef.current ?? false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1Jpy.default), {
        ignore: ignoreHolds
    }, children);
}
module.exports["ConditionalUfoHoldIgnore"] = $88668855474bc367$export$2510d15b8c74a469;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<f026ee318392a45fe95d1de0923dc1ed>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("dA1Sn", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoFullCycleOutput = (0, $6mKj3.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) ? fullCycleOutput === undefined : !fullCycleOutput;
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $42omo.useState)(isNoSSR || isNoFullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $42omo.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- the saveFullCycleOutput() only runs in the browser
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { style: style, name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)("cc_fix_hydration_ttvc", "isEnabled", true)) {
        if (!enabled) return children;
        if (hydrated) {
            let t3;
            if ($[0] !== name || $[1] !== ssrPlaceholder) {
                t3 = ssrPlaceholder ? {
                    "data-ssr-placeholder": name,
                    "data-ssr-placeholder-replace": name
                } : {};
                $[0] = name;
                $[1] = ssrPlaceholder;
                $[2] = t3;
            } else t3 = $[2];
            let t4;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t4 = {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                };
                $[3] = t4;
            } else t4 = $[3];
            let t5;
            if ($[4] !== children || $[5] !== name || $[6] !== t3) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    "data-testid": "two-stage-hydration",
                    "data-fullcycle-name": name,
                    ...t3,
                    style: t4
                }, children);
                $[4] = children;
                $[5] = name;
                $[6] = t3;
                $[7] = t5;
            } else t5 = $[7];
            return t5;
        }
        const innerHTML = fullCycleOutput;
        let t3;
        if ($[8] !== name || $[9] !== ssrPlaceholder) {
            t3 = ssrPlaceholder ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[8] = name;
            $[9] = ssrPlaceholder;
            $[10] = t3;
        } else t3 = $[10];
        let t4;
        if ($[11] !== innerHTML) {
            t4 = {
                __html: innerHTML
            };
            $[11] = innerHTML;
            $[12] = t4;
        } else t4 = $[12];
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[13] = t5;
        } else t5 = $[13];
        let t6;
        if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                dangerouslySetInnerHTML: t4,
                style: t5
            });
            $[14] = name;
            $[15] = t3;
            $[16] = t4;
            $[17] = t6;
        } else t6 = $[17];
        return t6;
    }
    if (!enabled || hydrated) return children;
    const innerHTML_0 = fullCycleOutput;
    let t3;
    if ($[22] !== innerHTML_0) {
        t3 = {
            __html: innerHTML_0
        };
        $[22] = innerHTML_0;
        $[23] = t3;
    } else t3 = $[23];
    let t4;
    if ($[24] !== name || $[25] !== style || $[26] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            dangerouslySetInnerHTML: t3
        });
        $[24] = name;
        $[25] = style;
        $[26] = t3;
        $[27] = t4;
    } else t4 = $[27];
    return t4;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { name: name, style: style, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder || $[4] !== style) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            style: style,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = style;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("gWfvV", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fCcUZ = parcelRequire("fCcUZ");


var $kDuN4 = parcelRequire("kDuN4");


var $dh538 = parcelRequire("dh538");


var $PAiZW = parcelRequire("PAiZW");


var $c3xd8 = parcelRequire("c3xd8");


var $dP3ac = parcelRequire("dP3ac");


var $6vAdz = parcelRequire("6vAdz");


var $3Bn1T = parcelRequire("3Bn1T");


var $aXjWU = parcelRequire("aXjWU");


var $4H1Ql = parcelRequire("4H1Ql");


var $e1zWV = parcelRequire("e1zWV");


var $cpPWT = parcelRequire("cpPWT");


var $iUetH = parcelRequire("iUetH");


var $iV9tb = parcelRequire("iV9tb");

const $7282dd84f12498d5$export$fb465b6e855c1e85 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { environment: envWithOverrides, context: context, children: children, analyticsClientInstance: analyticsClientInstance } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $dh538.fg)("post-office-rml-fedramp-compliant-urls");
        $[0] = t1;
    } else t1 = $[0];
    const isFedRampCompliantUrlsEnabled = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $c3xd8.buildDefaultEnvironmentValues)(isFedRampCompliantUrlsEnabled);
        $[1] = t2;
    } else t2 = $[1];
    const environmentValues = t2;
    let t3;
    if ($[2] !== envWithOverrides) {
        t3 = (0, $iUetH.generateEnvironmentConfigWithOverrides)(environmentValues, envWithOverrides);
        $[2] = envWithOverrides;
        $[3] = t3;
    } else t3 = $[3];
    const stableEnvironment = (0, $4H1Ql.useStableObject)(t3);
    let t4;
    if ($[4] !== context.current) {
        t4 = $7282dd84f12498d5$var$composeConfig((0, $PAiZW.defaultPostOfficeContextValue), context.current);
        $[4] = context.current;
        $[5] = t4;
    } else t4 = $[5];
    const stableContext = (0, $4H1Ql.useStableObject)(t4);
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $cpPWT.createMessagePlacementValues)();
        $[6] = t5;
    } else t5 = $[6];
    const memoizedMessagePlacementValues = t5;
    let t6;
    if ($[7] !== analyticsClientInstance || $[8] !== children) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Bn1T.PostOfficeScreenContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cpPWT.MessagePlacementProvider), {
            value: memoizedMessagePlacementValues
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6vAdz.RouteListenerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXjWU.TriggerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7282dd84f12498d5$var$MaybeAnalyticsListener, {
            analyticsClientInstance: analyticsClientInstance
        }, children)))));
        $[7] = analyticsClientInstance;
        $[8] = children;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== stableContext || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $PAiZW.InternalPostOfficeContextProvider), {
            value: stableContext
        }, t6);
        $[10] = stableContext;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== stableEnvironment || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7282dd84f12498d5$var$MaybePostOfficeCacheProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3xd8.PostOfficeEnvironmentProvider), {
            value: stableEnvironment
        }, t7));
        $[13] = stableEnvironment;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ({ environment: envWithOverrides, context: context, children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isFedRampCompliantUrlsEnabled = (0, $dh538.fg)('post-office-rml-fedramp-compliant-urls');
    const environmentValues = (0, $42omo.useMemo)(()=>(0, $c3xd8.buildDefaultEnvironmentValues)(isFedRampCompliantUrlsEnabled), [
        isFedRampCompliantUrlsEnabled
    ]);
    const stableEnvironment = (0, $4H1Ql.useStableObject)((0, $iUetH.generateEnvironmentConfigWithOverrides)(environmentValues, envWithOverrides));
    const stableContext = (0, $4H1Ql.useStableObject)($7282dd84f12498d5$var$composeConfig((0, $PAiZW.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $42omo.useMemo)(()=>(0, $cpPWT.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7282dd84f12498d5$var$MaybePostOfficeCacheProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3xd8.PostOfficeEnvironmentProvider), {
        value: stableEnvironment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $PAiZW.InternalPostOfficeContextProvider), {
        value: stableContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Bn1T.PostOfficeScreenContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cpPWT.MessagePlacementProvider), {
        value: memoizedMessagePlacementValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6vAdz.RouteListenerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXjWU.TriggerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7282dd84f12498d5$var$MaybeAnalyticsListener, {
        analyticsClientInstance: analyticsClientInstance
    }, children))))))));
};
const $7282dd84f12498d5$var$swrConfig = {
    provider: (0, $iV9tb.localStorageCacheProvider),
    use: [
        (0, $iV9tb.postOfficeCacheMiddleware)
    ]
};
const $7282dd84f12498d5$var$MaybePostOfficeCacheProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children } = t0;
    if ((0, $dh538.fg)("post-office-use-placement-with-client")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fCcUZ.SWRConfig), {
                value: $7282dd84f12498d5$var$swrConfig
            }, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $dh538.fg)('post-office-use-placement-with-client')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fCcUZ.SWRConfig), {
        value: $7282dd84f12498d5$var$swrConfig
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $7282dd84f12498d5$var$MaybeAnalyticsListener = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children, analyticsClientInstance: analyticsClientInstance } = t0;
    const isEPExposuresListenerEnabled = (0, $dh538.fg)("post-office_ep_exposures_enabled");
    const isAnalyticsListenerEnabled = (0, $dh538.fg)("post-office-analytics-listener-enabled");
    let content = children;
    if (isEPExposuresListenerEnabled) {
        let t1;
        if ($[0] !== analyticsClientInstance || $[1] !== content) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1zWV.EPExposuresListener), {
                analyticsClientInstance: analyticsClientInstance
            }, content);
            $[0] = analyticsClientInstance;
            $[1] = content;
            $[2] = t1;
        } else t1 = $[2];
        content = t1;
    }
    if (isAnalyticsListenerEnabled) {
        const { handleEvent: handleEvent } = (0, $dP3ac.postOfficeGasv3ListenerStore);
        let t1;
        if ($[3] !== content) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
                channel: "*",
                onEvent: handleEvent
            }, content);
            $[3] = content;
            $[4] = t1;
        } else t1 = $[4];
        content = t1;
    }
    let t1;
    if ($[5] !== content) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, content);
        $[5] = content;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isEPExposuresListenerEnabled = (0, $dh538.fg)('post-office_ep_exposures_enabled');
    const isAnalyticsListenerEnabled = (0, $dh538.fg)('post-office-analytics-listener-enabled');
    let content = children;
    if (isEPExposuresListenerEnabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1zWV.EPExposuresListener), {
        analyticsClientInstance: analyticsClientInstance
    }, content);
    if (isAnalyticsListenerEnabled) {
        const { handleEvent: handleEvent } = (0, $dP3ac.postOfficeGasv3ListenerStore);
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
            channel: "*",
            onEvent: handleEvent
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, content);
};
const $7282dd84f12498d5$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });
module.exports["PostOfficeProvider"] = $7282dd84f12498d5$export$fb465b6e855c1e85;

});

parcelRegister("dP3ac", function(module, exports) {

var $hs90m = parcelRequire("hs90m");

function $6bb999f896c7d6ae$var$getSubscribers() {
    if (typeof window !== 'undefined' && window.postOffice?.gasv3Listener?.subscribers) return window.postOffice.gasv3Listener.subscribers;
    if (typeof window !== 'undefined') {
        window.postOffice = {
            ...window.postOffice,
            gasv3Listener: {
                ...window.postOffice?.gasv3Listener,
                subscribers: new Map()
            }
        };
        return window.postOffice.gasv3Listener.subscribers;
    }
    return new Map();
}
const $6bb999f896c7d6ae$var$createPostOfficeGasv3ListenerStore = ()=>{
    const subscribers = $6bb999f896c7d6ae$var$getSubscribers();
    const handleEvent = (event)=>{
        subscribers.forEach((callback, matcher)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hs90m)))(event.payload, matcher)) callback();
        });
    };
    const subscribe = (matcher, callback)=>{
        subscribers.set(matcher, callback);
        return ()=>{
            subscribers.delete(matcher);
        };
    };
    return {
        subscribe: subscribe,
        handleEvent: handleEvent
    };
};
const $6bb999f896c7d6ae$export$19b95495a42be187 = $6bb999f896c7d6ae$var$createPostOfficeGasv3ListenerStore();
module.exports["postOfficeGasv3ListenerStore"] = $6bb999f896c7d6ae$export$19b95495a42be187;

});

parcelRegister("6vAdz", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lgxIi = parcelRequire("lgxIi");


var $6yHRM = parcelRequire("6yHRM");

const $89c4065b6c91d839$var$noop = ()=>{};
const $89c4065b6c91d839$var$RouteListenerContext = /*#__PURE__*/ (0, $42omo.createContext)({
    update: $89c4065b6c91d839$var$noop
});
const $89c4065b6c91d839$export$7a2084f4baac29a7 = ()=>(0, $lgxIi.createSimplePubSub)();
const $89c4065b6c91d839$export$72fd8977abf03d60 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($89c4065b6c91d839$var$RouteListenerContext);
} : ()=>(0, $42omo.useContext)($89c4065b6c91d839$var$RouteListenerContext);
const $89c4065b6c91d839$export$755edb1665399d41 = ()=>{
    const ref = (0, $42omo.useRef)();
    if (!ref.current) ref.current = $89c4065b6c91d839$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $42omo.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $42omo.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $89c4065b6c91d839$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $89c4065b6c91d839$export$72fd8977abf03d60();
    (0, $42omo.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $89c4065b6c91d839$export$31986273b686f5ea = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children } = t0;
    const [route, routeUpdater] = $89c4065b6c91d839$export$755edb1665399d41();
    let t1;
    if ($[0] !== children || $[1] !== route) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6yHRM.PostOfficeRouteProvider), route, children);
        $[0] = children;
        $[1] = route;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== routeUpdater || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($89c4065b6c91d839$var$RouteListenerContext.Provider, {
            value: routeUpdater
        }, t1);
        $[3] = routeUpdater;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children })=>{
    const [route, routeUpdater] = $89c4065b6c91d839$export$755edb1665399d41();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($89c4065b6c91d839$var$RouteListenerContext.Provider, {
        value: routeUpdater
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6yHRM.PostOfficeRouteProvider), route, children));
};
module.exports["usePostOfficeRouteUpdate"] = $89c4065b6c91d839$export$bb606326acdd1a64;
module.exports["RouteListenerProvider"] = $89c4065b6c91d839$export$31986273b686f5ea;

});

parcelRegister("aXjWU", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $42omo.useState)({});
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
} : ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
} : ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $frIzR.c)(3);
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $frIzR.c)(17);
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("e1zWV", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5DUgU = parcelRequire("5DUgU");


var $kDuN4 = parcelRequire("kDuN4");

const $5238aa3ac06c99b9$var$ENGAGEMENT_PLATFORM_CHANNEL = 'engagementPlatform';
const $5238aa3ac06c99b9$var$isPromise = (value)=>{
    return value && typeof value.then === 'function';
};
const $5238aa3ac06c99b9$export$3476bc3bd0845b44 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, analyticsClientInstance: analyticsClientInstance } = t0;
    let t1;
    if ($[0] !== analyticsClientInstance) {
        t1 = (event)=>{
            if (!analyticsClientInstance) return;
            const { eventType: eventType, attributes: attributes, ...restPayload } = event.payload || {};
            const userId = restPayload?.userId || attributes?.userId;
            const tenantId = restPayload?.tenantId || attributes?.tenantId;
            if (eventType !== "track" && eventType !== "operational") return;
            if (!userId || !tenantId) return;
            const processEvent = (client)=>{
                try {
                    if (tenantId) client.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, tenantId);
                    if (userId) client.setUserInfo((0, $5DUgU.userType).ATLASSIAN_ACCOUNT, userId);
                } catch (t2) {
                    return;
                }
                const gasPayload = {
                    ...restPayload,
                    tenantId: tenantId,
                    ...attributes ? {
                        attributes: attributes
                    } : {}
                };
                if (eventType === "track") client.sendTrackEvent(gasPayload);
                else if (eventType === "operational") client.sendOperationalEvent(gasPayload);
            };
            if ($5238aa3ac06c99b9$var$isPromise(analyticsClientInstance)) analyticsClientInstance.then(processEvent);
            else processEvent(analyticsClientInstance);
        };
        $[0] = analyticsClientInstance;
        $[1] = t1;
    } else t1 = $[1];
    const handleEvent = t1;
    let t2;
    if ($[2] !== children || $[3] !== handleEvent) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
            channel: $5238aa3ac06c99b9$var$ENGAGEMENT_PLATFORM_CHANNEL,
            onEvent: handleEvent
        }, children);
        $[2] = children;
        $[3] = handleEvent;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        if (!analyticsClientInstance) return;
        const { eventType: eventType, attributes: attributes, ...restPayload } = event.payload || {};
        const userId = restPayload?.userId || attributes?.userId;
        const tenantId = restPayload?.tenantId || attributes?.tenantId;
        if (eventType !== 'track' && eventType !== 'operational') return;
        if (!userId || !tenantId) return;
        // Handle Promise if analyticsClientInstance is a Promise
        const processEvent = (client)=>{
            // Update client with user and tenant info
            try {
                if (tenantId) client.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, tenantId);
                if (userId) client.setUserInfo((0, $5DUgU.userType).ATLASSIAN_ACCOUNT, userId);
            } catch (error) {
                return;
            }
            // Build payload with tenantId at top level (userId is automatically included via setUserInfo)
            const gasPayload = {
                ...restPayload,
                tenantId: tenantId,
                ...attributes ? {
                    attributes: attributes
                } : {}
            };
            if (eventType === 'track') client.sendTrackEvent(gasPayload);
            else if (eventType === 'operational') client.sendOperationalEvent(gasPayload);
        };
        if ($5238aa3ac06c99b9$var$isPromise(analyticsClientInstance)) analyticsClientInstance.then(processEvent);
        else processEvent(analyticsClientInstance);
    }, [
        analyticsClientInstance
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: $5238aa3ac06c99b9$var$ENGAGEMENT_PLATFORM_CHANNEL,
        onEvent: handleEvent
    }, children);
};
module.exports["EPExposuresListener"] = $5238aa3ac06c99b9$export$3476bc3bd0845b44;

});

parcelRegister("iUetH", function(module, exports) {
const $3e0678b32258dc83$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};
module.exports["generateEnvironmentConfigWithOverrides"] = $3e0678b32258dc83$export$ae3dab16eb1fc2cc;

});

parcelRegister("iV9tb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ltrno = parcelRequire("ltrno");


var $kt8c2 = parcelRequire("kt8c2");

const $9a4b8c66470cb7c0$var$STORAGE_KEY = 'POST_OFFICE__CLIENT_CACHE';
const $9a4b8c66470cb7c0$var$CACHE_KEY = 'placement-api';
const $9a4b8c66470cb7c0$var$CACHE_EXPIRY = 120000; // 2 minutes
const $9a4b8c66470cb7c0$var$storageClient = new (0, $kt8c2.default)($9a4b8c66470cb7c0$var$STORAGE_KEY);
const $9a4b8c66470cb7c0$export$3c979fbaa76beaf9 = (cache)=>{
    if (cache instanceof Map && cache.size > 0) {
        const existingCache = $9a4b8c66470cb7c0$export$54eb3e634424b746();
        const mergedCache = new Map([
            ...existingCache,
            ...cache
        ]);
        const appCache = Array.from(mergedCache.entries());
        // localStorage.getItem("POST_OFFICE__CLIENT_CACHE_placement-api")
        $9a4b8c66470cb7c0$var$storageClient.setItemWithExpiry($9a4b8c66470cb7c0$var$CACHE_KEY, appCache, $9a4b8c66470cb7c0$var$CACHE_EXPIRY);
    }
};
const $9a4b8c66470cb7c0$export$54eb3e634424b746 = ()=>{
    if (typeof window === 'undefined') // Return a dummy storage for server-side rendering
    return new Map();
    // When initializing, we restore the data from `localStorage` into a map.
    const cache = $9a4b8c66470cb7c0$var$storageClient.getItem($9a4b8c66470cb7c0$var$CACHE_KEY) || [];
    return new Map(cache);
};
const $9a4b8c66470cb7c0$export$711c5bb855c82238 = (useSWRNext)=>{
    return (key, fetcher, config)=>{
        const { cache: cache } = (0, $ltrno.useSWRConfig)();
        const swr = useSWRNext(key, fetcher, config);
        /**
     * This will execute even when data is pulled from the local storage cache.
     * This means that the cache will be updated and the CACHE_EXPIRY reset to be a rolling window.
     *
     * We may want to change this behaviour in the future to only update the cache when the data is NOT pulled from the local storage cache.
     */ (0, $42omo.useEffect)(()=>{
            if (swr.data !== undefined) $9a4b8c66470cb7c0$export$3c979fbaa76beaf9(cache);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            swr.data
        ]);
        return swr;
    };
};
module.exports["localStorageCacheProvider"] = $9a4b8c66470cb7c0$export$54eb3e634424b746;
module.exports["postOfficeCacheMiddleware"] = $9a4b8c66470cb7c0$export$711c5bb855c82238;

});

parcelRegister("djMdn", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $ee867efa4e0f51e3$export$e5c6d63c1f3f867f = (0, $42omo.createContext)({
    usePageRecommendationData: ()=>({
            data: undefined,
            loading: false,
            hoverPageError: undefined,
            recPageError: undefined
        }),
    useInlineReactionsData: (_numberOfReactedUsers, _skip)=>({
            data: {
                authorName: undefined,
                authorAvatar: undefined,
                reactionsCount: undefined,
                reactionsSummary: undefined,
                reactedUsers: undefined,
                userId: undefined,
                activationId: undefined
            },
            loading: false,
            error: undefined
        }),
    getPageDataFromUrl: ()=>({
            contentId: undefined,
            contentType: undefined,
            spaceKey: undefined
        }),
    emojiProvider: undefined
});
module.exports["ConfluenceExperimentsContext"] = $ee867efa4e0f51e3$export$e5c6d63c1f3f867f;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const contentId = rec?.content?.id;
        if (!contentId) return;
        const el = transformedRecs.find((card)=>card?.id === contentId);
        if (el) pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $dh538.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, hasReplacedAIFCEmoji: hasReplacedAIFCEmoji, setHasReplacedAIFCEmoji: setHasReplacedAIFCEmoji, aiEmojiSuggestionSource: aiEmojiSuggestionSource }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    // Snapshot before overwrite to detect if the AIFC-suggested emoji was replaced.
    const previouslySelectedEmoji = emojiTitleState.state.selectedEmoji;
    const previouslySelectedEmojiId = typeof previouslySelectedEmoji === 'string' ? previouslySelectedEmoji : previouslySelectedEmoji?.id;
    const replacedAIFCSuggestedEmoji = !hasReplacedAIFCEmoji && !!isSmartCreate && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedAIFCSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedBlankPageAutoSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'pasteAutoTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedBlankPageAutoSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedSuggestTitleSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'suggestTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedSuggestTitleSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    // Snapshot the shared flag at fire time so the value reflects the latest
    // state regardless of when/where the picker JSX was created.
    const justRestoredEmoji = !!emojiTitleState.justRestoredEmoji;
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage,
            replacedAIFCSuggestedEmoji: replacedAIFCSuggestedEmoji,
            replacedBlankPageAutoSuggestedEmoji: replacedBlankPageAutoSuggestedEmoji,
            replacedSuggestTitleSuggestedEmoji: replacedSuggestTitleSuggestedEmoji,
            aiEmojiSuggestionSource: aiEmojiSuggestionSource,
            isRestoreLatestEmojiEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji'),
            replacedRestoredEmoji: justRestoredEmoji
        }
    });
    // Reset after firing so the next selection correctly reports
    // replacedRestoredEmoji=false.
    emojiTitleState.justRestoredEmoji = false;
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "@confluence/emoji-title"
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "@confluence/emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "@confluence/emoji-title"
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "@confluence/emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("3shHM", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        __callerPackage__: "@confluence/emoji-title"
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $iH7AG = parcelRequire("iH7AG");

var $dM0Qh = parcelRequire("dM0Qh");

var $lb1Mg = parcelRequire("lb1Mg");

var $a2xFu = parcelRequire("a2xFu");

var $1LZHF = parcelRequire("1LZHF");

var $a5Dk4 = parcelRequire("a5Dk4");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $a2xFu.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $eB56w.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $a5Dk4.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iH7AG.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $dM0Qh.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lb1Mg.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $1LZHF.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("iH7AG", function(module, exports) {

var $hIjpx = parcelRequire("hIjpx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/database/manifest.ts
var $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hIjpx.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $hIjpx.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $d9c22183dba005c8$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $d9c22183dba005c8$export$317cd32472deea7e;

});

parcelRegister("hIjpx", function(module, exports) {
// src/confluence/database/types.ts
var $ce559a57d4ba003b$export$e83bc7b627335f1d = "confluence", $ce559a57d4ba003b$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $ce559a57d4ba003b$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $ce559a57d4ba003b$export$d26db9a1a0b750aa;

});

parcelRegister("dM0Qh", function(module, exports) {

var $dPsPU = parcelRequire("dPsPU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/embed/manifest.ts
var $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $dPsPU.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $dPsPU.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $a070694ffdc5cb3b$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $a070694ffdc5cb3b$export$47d4b4205d0ac61a;

});

parcelRegister("dPsPU", function(module, exports) {
// src/confluence/embed/types.ts
var $a116681263506e39$export$7a02af293cacddd2 = "confluence", $a116681263506e39$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $a116681263506e39$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $a116681263506e39$export$f817d48842ea0d4a;

});

parcelRegister("lb1Mg", function(module, exports) {

var $bYbE5 = parcelRequire("bYbE5");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/folder/manifest.ts
var $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bYbE5.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $bYbE5.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $f6ac010730fe9d5d$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $f6ac010730fe9d5d$export$501a782385a3f485;

});

parcelRegister("bYbE5", function(module, exports) {
// src/confluence/folder/types.ts
var $8b6e54dbbb0b2632$export$77cf4e1b17902bfa = "confluence", $8b6e54dbbb0b2632$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $8b6e54dbbb0b2632$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $8b6e54dbbb0b2632$export$6256ff329bc25a9c;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("1LZHF", function(module, exports) {

var $gFQkO = parcelRequire("gFQkO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/slide/manifest.ts
var $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $gFQkO.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $gFQkO.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $14aa0b35cfffabf8$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $14aa0b35cfffabf8$export$86048ac46024146a;

});

parcelRegister("gFQkO", function(module, exports) {
// src/confluence/slide/types.ts
var $c23912470bd9b644$export$204fa7edd529d4b3 = "confluence", $c23912470bd9b644$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $c23912470bd9b644$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $c23912470bd9b644$export$3de52c55a164daa4;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("2HQyh", function(module, exports) {
/**
 * @generated SignedSource<<e56ee58f550eae496b45df46a24c2dad>>
 * @relayHash feae64578b0a3fba44f22230201969bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272
const $5b8dbd4fd00aa380$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "exp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyString"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "exp"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "creatorId"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v16 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "strategy"
    }, v18 = {
        "concreteType": "RecommendedPagesStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "userCanToggle"
            },
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            }
        ]
    }, v19 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "feae64578b0a3fba44f22230201969bb",
            "id": "5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272",
            "metadata": {},
            "name": "EndOfPageRecommendationQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy},status{userCanToggle,isEnabled}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
        }
    };
}();
$5b8dbd4fd00aa380$var$node.hash = "89dc64ac31ebaadc798791741477c5f3";
var $5b8dbd4fd00aa380$export$2e2bcd8739ae039 = $5b8dbd4fd00aa380$var$node;
module.exports["default"] = $5b8dbd4fd00aa380$export$2e2bcd8739ae039;

});

parcelRegister("1AapX", function(module, exports) {
/**
 * @generated SignedSource<<49f29fe4cce6e5914fc9f51ae5a226c1>>
 * @relayHash bde3b931406ea3b1108284cc13c5d3a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2af0384892c40194e0e0a528388473adfd17c11fe5e5c3ae99fd5096a1349d29
const $43fd533a637b8d46$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v10 = {
        "alias": "editorVersion",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "properties(key:\"editor\")"
    }, v11 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 372
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:372)"
    }, v13 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v17 = [
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v19 = {
        "concreteType": "LikesResponse",
        "kind": "LinkedField",
        "name": "likes",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v20 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceHoverPageCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceHoverPageCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "bde3b931406ea3b1108284cc13c5d3a4",
            "id": "2af0384892c40194e0e0a528388473adfd17c11fe5e5c3ae99fd5096a1349d29",
            "metadata": {},
            "name": "SpaceHoverPageCardQuery",
            "operationKind": "query",
            "text": "query SpaceHoverPageCardQuery($id:ID!){singleContent(id:$id){id,title,type,subType,status,links{webui,editui},editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},lastModifiedDate},history{createdBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}},ownedBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}},space{id,key,alias,name},likes{count},version{by{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}}}}"
        }
    };
}();
$43fd533a637b8d46$var$node.hash = "43d0bff36706ae93bf29ac12a5604ee3";
var $43fd533a637b8d46$export$2e2bcd8739ae039 = $43fd533a637b8d46$var$node;
module.exports["default"] = $43fd533a637b8d46$export$2e2bcd8739ae039;

});

parcelRegister("3V1KT", function(module, exports) {

var $71jDq = parcelRequire("71jDq");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $71jDq.default);
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("71jDq", function(module, exports) {
/**
 * @generated SignedSource<<24da7f14ba8749c8630d2573f19b3159>>
 * @relayHash f5d80e75401b9c7d3d224f964fef6438
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4
const $380a75471f8fd0e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f5d80e75401b9c7d3d224f964fef6438",
            "id": "1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4",
            "metadata": {},
            "name": "ReactionsContentQuery",
            "operationKind": "query",
            "text": "query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$380a75471f8fd0e5$var$node.hash = "b632c435e4326f4f3245476cffd31162";
var $380a75471f8fd0e5$export$2e2bcd8739ae039 = $380a75471f8fd0e5$var$node;
module.exports["default"] = $380a75471f8fd0e5$export$2e2bcd8739ae039;

});

parcelRegister("2OQgp", function(module, exports) {

var $6snPf = parcelRequire("6snPf");

const $b0d4ef9b24ddbdc3$export$e27c33fe32c2fd7b = (0, $6snPf.default);
module.exports["ReactedUsersQuery"] = $b0d4ef9b24ddbdc3$export$e27c33fe32c2fd7b;

});

parcelRegister("6snPf", function(module, exports) {
/**
 * @generated SignedSource<<c7c013e439bad88b330cd4d9c70935f1>>
 * @relayHash a2be411b1772244feef74a2765f2ac57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8df3009a9d79522bd8efe037cb70fe5c72987241726fa1580e2f0eb97ceb9c96
const $d0a610df0853dabe$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerType"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emojiId"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "containerId",
                    "variableName": "containerId"
                },
                {
                    "kind": "Variable",
                    "name": "containerType",
                    "variableName": "containerType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                },
                {
                    "kind": "Variable",
                    "name": "emojiId",
                    "variableName": "emojiId"
                }
            ],
            "concreteType": "ReactedUsersResponse",
            "kind": "LinkedField",
            "name": "reactedUsers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                },
                {
                    "concreteType": "ConfluencePerson",
                    "kind": "LinkedField",
                    "name": "confluencePerson",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactedUsersQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactedUsersQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "a2be411b1772244feef74a2765f2ac57",
            "id": "8df3009a9d79522bd8efe037cb70fe5c72987241726fa1580e2f0eb97ceb9c96",
            "metadata": {},
            "name": "ReactedUsersQuery",
            "operationKind": "query",
            "text": "query ReactedUsersQuery($contentId:String!,$containerId:String!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){reactedUsers(contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId){count,emojiId,reacted,confluencePerson{accountId,displayName,profilePicture{path}}}}"
        }
    };
}();
$d0a610df0853dabe$var$node.hash = "c015b4e131a157a2b697f6c2a7cdf8e3";
var $d0a610df0853dabe$export$2e2bcd8739ae039 = $d0a610df0853dabe$var$node;
module.exports["default"] = $d0a610df0853dabe$export$2e2bcd8739ae039;

});

parcelRegister("bcvT8", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");




parcelRequire("2YerA");
var $jCM2u = parcelRequire("jCM2u");
var $fqrVl = parcelRequire("fqrVl");


var $8z9j5 = parcelRequire("8z9j5");


var $7TH2w = parcelRequire("7TH2w");

const $f63d596471d12742$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $7TH2w.UI_EVENT_TYPE:
                    client.sendUIEvent(event);
                    break;
                case 0, $7TH2w.TRACK_EVENT_TYPE:
                    client.sendTrackEvent(event);
                    break;
                case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $7TH2w.SCREEN_EVENT_TYPE:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};


// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.



const $7ddb7856a75b7fbe$var$GROWTH_TAG = 'growth';
const $7ddb7856a75b7fbe$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $7ddb7856a75b7fbe$var$getSources = (context)=>$7ddb7856a75b7fbe$var$extractFromEventContext([
        'source'
    ], context);
const $7ddb7856a75b7fbe$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $7ddb7856a75b7fbe$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $7ddb7856a75b7fbe$var$last = (values)=>values[values.length - 1];
const $7ddb7856a75b7fbe$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $7ddb7856a75b7fbe$var$getSources(context);
    const source = $7ddb7856a75b7fbe$var$last(sources) || (0, $7TH2w.DEFAULT_SOURCE);
    const extraAttributes = $7ddb7856a75b7fbe$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $7ddb7856a75b7fbe$var$last($7ddb7856a75b7fbe$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $7TH2w.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($7ddb7856a75b7fbe$var$GROWTH_TAG);
    switch(eventType){
        case 0, $7TH2w.UI_EVENT_TYPE:
        case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
        case 0, $7TH2w.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $7TH2w.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};


parcelRequire("49sr4");
var $82BVR = parcelRequire("82BVR");

const $82f75673d6758a24$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $82f75673d6758a24$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $82f75673d6758a24$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $82f75673d6758a24$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $82f75673d6758a24$export$2a45a00073911255 = '/software';


var $1d705bbdb490746b$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});


const $38a222a070b75a8d$var$utmCampaignMap = {
    'atlassian-switcher': (0, $1d705bbdb490746b$export$fc604aa353a97e10)['atlassian-switcher']
};
const $38a222a070b75a8d$var$isBundledProduct = (productKey)=>{
    return [
        (0, $82BVR.Targets).JIRA_SOFTWARE,
        (0, $82BVR.Targets).JIRA_SERVICE_DESK,
        (0, $82BVR.Targets).JIRA_CORE,
        (0, $82BVR.Targets).CONFLUENCE
    ].includes(productKey);
};
const $38a222a070b75a8d$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $82BVR.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $82BVR.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $82BVR.Targets).JIRA_CORE]: 'jira-core',
        [(0, $82BVR.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $38a222a070b75a8d$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $82BVR.Targets).OPSGENIE
    ].includes(productKey);
};
const $38a222a070b75a8d$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $82BVR.Targets).OPSGENIE]: (0, $82f75673d6758a24$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $38a222a070b75a8d$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($38a222a070b75a8d$var$utmCampaignMap[sourceComponent]);
};
const $38a222a070b75a8d$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $38a222a070b75a8d$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$38a222a070b75a8d$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $38a222a070b75a8d$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $82f75673d6758a24$export$c37558e5c67d2b01) : (0, $82f75673d6758a24$export$f199baf8dfc7621e);
    const utmParams = $38a222a070b75a8d$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $82f75673d6758a24$export$2a45a00073911255);
    if ($38a222a070b75a8d$var$isBundledProduct(productKey)) {
        path = (0, $82f75673d6758a24$export$e6c04a1dd86d1c14);
        bundleParams = $38a222a070b75a8d$var$getBundleSignUpParams(productKey);
    } else if ($38a222a070b75a8d$var$isProductWithCustomSignUpPath(productKey)) path = $38a222a070b75a8d$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $38a222a070b75a8d$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $38a222a070b75a8d$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};








const $ab8bd02760c6d61c$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $ab8bd02760c6d61c$export$9d8252a268f4fa72 = 'errorCaught';
const $ab8bd02760c6d61c$export$1045419caf49b395 = 'errorBoundary';
const $ab8bd02760c6d61c$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $ab8bd02760c6d61c$export$e5c2c058fa8068a6 = 'uiInitialized';
const $ab8bd02760c6d61c$export$e67cdcb8867a3bd0 = 'openInvoked';




const $fbfb52c7bf4616fb$var$name = "platform-pkg";
const $fbfb52c7bf4616fb$var$version = "0.0.0-use.local";
const $fbfb52c7bf4616fb$var$payload = {
    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
    action: (0, $ab8bd02760c6d61c$export$9d8252a268f4fa72),
    actionSubject: (0, $ab8bd02760c6d61c$export$1045419caf49b395)
};
const $fbfb52c7bf4616fb$var$context = [
    {
        source: $ab8bd02760c6d61c$export$b4d5da5f34fb77ad
    },
    {
        packageName: $fbfb52c7bf4616fb$var$name,
        packageVersion: $fbfb52c7bf4616fb$var$version
    }
];
class $fbfb52c7bf4616fb$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $fbfb52c7bf4616fb$var$payload,
            context: $fbfb52c7bf4616fb$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}


const $2990596a720578f3$var$version = "0.0.0-use.local";
const $2990596a720578f3$export$84f9cf7ef89d4c26 = {
    version: $2990596a720578f3$var$version
};
const $2990596a720578f3$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $2990596a720578f3$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};


const $c3f4a60925dc07c0$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};






const $2e3c136e31b0a37a$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("byixj")));
const $2e3c136e31b0a37a$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        const onCloseResolver = (0, $42omo.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $42omo.useState)(false);
        const fireEvent = (0, $42omo.useMemo)(()=>(0, $f63d596471d12742$export$91b4dd3bfc301325)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $42omo.useState)();
        const onAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
            const gasV3Event = (0, $7ddb7856a75b7fbe$export$3f40e8c44448be30)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $c3f4a60925dc07c0$export$a5a156dc5df42f0)((0, $2990596a720578f3$export$59518efab336a8b5)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $42omo.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                        action: (0, $ab8bd02760c6d61c$export$e5c2c058fa8068a6),
                        actionSubject: (0, $ab8bd02760c6d61c$export$d54c183f56e39aa5),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $ab8bd02760c6d61c$export$b4d5da5f34fb77ad
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $42omo.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $c3f4a60925dc07c0$export$a5a156dc5df42f0)({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    action: (0, $ab8bd02760c6d61c$export$e67cdcb8867a3bd0),
                    actionSubject: (0, $ab8bd02760c6d61c$export$d54c183f56e39aa5)
                }, options),
                context: [
                    {
                        source: $ab8bd02760c6d61c$export$b4d5da5f34fb77ad
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $fqrVl.Journeys).GET_STARTED && redirectToWac) {
                (0, $38a222a070b75a8d$export$2827e2473cb9a346)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $42omo.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $8z9j5.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jCM2u.BaseCrossFlowApiProvider), {
            onOpen: onOpen
        }, children, requestOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fbfb52c7bf4616fb$export$e926676385687eaf), {
            onAnalyticsEvent: onAnalyticsEvent,
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IntegrationView, {
            ...baseProviderProps,
            ...requestOptions,
            onAnalyticsEvent: onAnalyticsEvent,
            originProduct: originProduct,
            theme: colorMode,
            onClose: onClose,
            onHandShake: onHandShake,
            plugins: plugins,
            env: env,
            redirectToWac: redirectToWac,
            zIndex: requestOptions.zIndex ?? 1000
        }))));
    };
const $2e3c136e31b0a37a$export$d900e4062895cd7c = $2e3c136e31b0a37a$export$79d79d8dd8574306($2e3c136e31b0a37a$var$IntegrationView);



const $3ca71cfad0801800$var$ConfluenceProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2e3c136e31b0a37a$export$d900e4062895cd7c), {
            ...props,
            originProduct: "confluence"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2e3c136e31b0a37a$export$d900e4062895cd7c), {
        ...props,
        originProduct: "confluence"
    });
};
var $3ca71cfad0801800$export$2e2bcd8739ae039 = $3ca71cfad0801800$var$ConfluenceProvider;
module.exports["default"] = $3ca71cfad0801800$export$2e2bcd8739ae039;

});

parcelRegister("2YerA", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("jCM2u")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("jCM2u")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("jCM2u")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("fqrVl")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("fqrVl")).Reasons);

var $jCM2u = parcelRequire("jCM2u");


var $fqrVl = parcelRequire("fqrVl");


});

parcelRegister("jCM2u", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5xIym = parcelRequire("5xIym");


var $5B9n6 = parcelRequire("5B9n6");


var $fqrVl = parcelRequire("fqrVl");

const $32c19fce160b377b$var$LATEST_VERSION = (0, $5B9n6.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $32c19fce160b377b$var$CrossFlowContext = /*#__PURE__*/ (0, $42omo.createContext)(()=>({
        isEnabled: false,
        reason: (0, $fqrVl.Reasons).NO_PROVIDER
    }));
const $32c19fce160b377b$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $5B9n6.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $5xIym.createAPIv0)(onOpen),
                    apiV1: (0, $5B9n6.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $fqrVl.Reasons).NO_API_SUPPORT
                };
        }
    };
const $32c19fce160b377b$export$c0ddec072762f62a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { onOpen: onOpen, children: children } = t0;
    let t1;
    if ($[0] !== onOpen) {
        t1 = $32c19fce160b377b$export$59ce2d27e6cd8c9(onOpen);
        $[0] = onOpen;
        $[1] = t1;
    } else t1 = $[1];
    const negotiateApi = t1;
    let t2;
    if ($[2] !== children || $[3] !== negotiateApi) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32c19fce160b377b$var$CrossFlowContext.Provider, {
            value: negotiateApi
        }, children);
        $[2] = children;
        $[3] = negotiateApi;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $42omo.useMemo)(()=>$32c19fce160b377b$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32c19fce160b377b$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $32c19fce160b377b$export$6e7a10fe635a0dfc = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const negotiateApi = (0, $42omo.useContext)($32c19fce160b377b$var$CrossFlowContext);
    let t0;
    if ($[0] !== negotiateApi) {
        t0 = negotiateApi($32c19fce160b377b$var$LATEST_VERSION);
        $[0] = negotiateApi;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const negotiateApi = (0, $42omo.useContext)($32c19fce160b377b$var$CrossFlowContext);
    return (0, $42omo.useMemo)(()=>negotiateApi($32c19fce160b377b$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $32c19fce160b377b$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $frIzR.c)(3);
        const crossFlow = $32c19fce160b377b$export$6e7a10fe635a0dfc();
        let t0;
        if ($[0] !== crossFlow || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...props,
                crossFlow: crossFlow
            });
            $[0] = crossFlow;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const crossFlow = $32c19fce160b377b$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $32c19fce160b377b$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $32c19fce160b377b$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $32c19fce160b377b$export$655b6c19a0daddb8;

});

parcelRegister("5xIym", function(module, exports) {
const $1eb0c594c750199f$export$a4ad2735b021c132 = 0;
const $1eb0c594c750199f$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $1eb0c594c750199f$export$9ff7368ac93fcf2d;

});

parcelRegister("5B9n6", function(module, exports) {
const $12de2f6721823415$export$a4ad2735b021c132 = 1;
const $12de2f6721823415$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $12de2f6721823415$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $12de2f6721823415$export$8fd5792fc468459f;

});

parcelRegister("fqrVl", function(module, exports) {
const $4db9b154d66dd01a$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $4db9b154d66dd01a$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $4db9b154d66dd01a$export$3411873bfd520bb6;
module.exports["Reasons"] = $4db9b154d66dd01a$export$da2d4f2f250d6f84;

});

parcelRegister("49sr4", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("ctMWd")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("82BVR")).Targets);

var $ctMWd = parcelRequire("ctMWd");


var $82BVR = parcelRequire("82BVR");


});

parcelRegister("ctMWd", function(module, exports) {
class $0081b4f618dff6fe$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}
module.exports["CrossFlowExtensions"] = $0081b4f618dff6fe$export$a5e53d1dcbd6eb61;

});

parcelRegister("82BVR", function(module, exports) {
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $49d7ae8ec7eae7d8$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};
module.exports["Targets"] = $49d7ae8ec7eae7d8$export$59a8eb9cff113544;

});

parcelRegister("byixj", function(module, exports) {

let $86913f9a634a8760$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86913f9a634a8760$var$load("lRa6k"),
    $86913f9a634a8760$var$load("3tgAP"),
    $86913f9a634a8760$var$load("1or3R")
]).then(()=>parcelRequire('3Subp'));

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("hSHWm", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("9hxmQ", function(module, exports) {

let $6c1f95ad23940a76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c1f95ad23940a76$var$load("gufL1"),
    $6c1f95ad23940a76$var$load("khj8U"),
    $6c1f95ad23940a76$var$load("5uN9h"),
    $6c1f95ad23940a76$var$load("g29Xd"),
    $6c1f95ad23940a76$var$load("cjGZs"),
    $6c1f95ad23940a76$var$load("7zPi7")
]).then(()=>parcelRequire('MVtCj'));

});

parcelRegister("koZ31", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $6a2b9fa9e63188b2$export$1ba03842b7d3a654 = /*#__PURE__*/ function(CoreInvitesSource) {
    CoreInvitesSource["UNKNOWN"] = "unknown";
    CoreInvitesSource["MENTION"] = "mention";
    CoreInvitesSource["PEOPLE_MENU"] = "peopleMenu";
    CoreInvitesSource["ONBOARDING_INVITE_FLAG"] = "onboarding-invite-flag";
    CoreInvitesSource["PERSISTENT_INVITE_PAGETREE"] = "pageTree";
    CoreInvitesSource["PERSISTENT_INVITE_HOMESCREEN"] = "homeScreen";
    CoreInvitesSource["CONTEXTUAL_INVITE_NUDGE"] = "onboarding-contextual-invite-nudge";
    CoreInvitesSource["LIVE_PAGES_NUDGE"] = "onboarding-contextual-invite-live-pages-nudge";
    CoreInvitesSource["SHARE_DIALOG"] = "share-dialog";
    CoreInvitesSource["SHARE_AND_RESTRICT_DIALOG"] = "share-and-restrict-dialog";
    CoreInvitesSource["IBO_TAKEOVER_INVITE"] = "onboarding-takeover-invite-people";
    CoreInvitesSource["EA_DROPDOWN"] = "ea-dropdown";
    CoreInvitesSource["HOME_ONBOARDING_TAKEOVER_V2"] = "home-onboarding-takeover-v2";
    CoreInvitesSource["CROSS_JOIN"] = "virality-cross-join";
    CoreInvitesSource["OPEN_MODAL_QUERY_PARAM"] = "open-modal-query-param";
    return CoreInvitesSource;
}({});
module.exports["CoreInvitesSource"] = $6a2b9fa9e63188b2$export$1ba03842b7d3a654;

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $i3jcY = parcelRequire("i3jcY");


var $6mKj3 = parcelRequire("6mKj3");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $T1bCI.Container) {
    constructor(props = {}){
        super();
        // Nav4 is fully rolled out; top nav height is always 48px unless FHS is enabled
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        let navHeight = 48;
        if (// The increased height change is only applied when FHS is enabled.
        // Ideally we could check `useIsFhsEnabled()` but we can't use hooks here.
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false)) navHeight = 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $T1bCI.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        // Guards optimistic, mutation-owned fields (applied status + option list) from being
        // clobbered by stale refetches while an operation is pending. Kept off `state` so it
        // survives the refetch-driven `setInitialValues` calls.
        this.isOptimisticOperationPending = false;
        this.setIsOptimisticOperationPending = (isOptimisticOperationPending)=>{
            this.isOptimisticOperationPending = isOptimisticOperationPending;
        };
        // The contentId for which the empty add-status trigger should be kept visible after a
        // view-mode delete. Stored as an id (not a boolean) so render can scope it to the current page
        // without a navigation listener — it's only honored while this matches the active contentId,
        // so it naturally clears on navigation. Kept off `state` so a fresh container (refresh) resets it.
        this.keepEmptyTriggerForContentId = null;
        this.setKeepEmptyTriggerForContentId = (contentId)=>{
            this.keepEmptyTriggerForContentId = contentId;
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $6mKj3 = parcelRequire("6mKj3");


var $8rneB = parcelRequire("8rneB");


var $bKZz0 = parcelRequire("bKZz0");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $T1bCI.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        // Analytics-only flag: intentionally bypasses Container state so mutations
        // never trigger subscriber re-renders.
        this.justRestoredEmoji = false;
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false,
            previousEmojiIdByContentId: {}
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        this.getPreviousEmojiId = (contentId)=>this.state.previousEmojiIdByContentId[contentId] ?? null;
        // Pass `null` to clear just that entry.
        this.setPreviousEmojiId = (contentId, previousEmojiId)=>{
            const next = {
                ...this.state.previousEmojiIdByContentId
            };
            if (previousEmojiId === null) delete next[contentId];
            else next[contentId] = previousEmojiId;
            if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) (0, $bKZz0.writeSessionStoragePreviousEmojiCache)(next);
            return this.setState({
                previousEmojiIdByContentId: next
            });
        };
        if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) {
            const hydrated = (0, $bKZz0.readSessionStoragePreviousEmojiCache)();
            if (Object.keys(hydrated).length > 0) this.state = {
                ...this.state,
                previousEmojiIdByContentId: hydrated
            };
        }
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("bKZz0", function(module, exports) {
/**
 * sessionStorage mirror for the per-contentId `previousEmojiId` cache used by
 * the Live Docs "Restore emoji" affordance. Survives same-tab refresh; not a
 * source of truth — the in-memory unstated state is. Failures degrade silently.
 */ 
var $17wUi = parcelRequire("17wUi");


var $ivEX1 = parcelRequire("ivEX1");

const $dabf2e5c28263f4b$var$STORAGE_KEY = (0, $ivEX1.sessionKeys).EMOJI_TITLE_PREVIOUS_EMOJI;
const $dabf2e5c28263f4b$export$6adb2744b497be8f = ()=>{
    try {
        const raw = (0, $17wUi.confluenceSessionStorageInstance)?.getItem($dabf2e5c28263f4b$var$STORAGE_KEY);
        if (!raw || typeof raw !== 'string') return {};
        const parsed = JSON.parse(raw);
        if (!parsed || parsed.v !== 1 || typeof parsed.entries !== 'object' || !parsed.entries) return {};
        // Defensive: filter to non-empty string values in case the slot was
        // mutated by something else on the same origin.
        const out = {};
        for (const [contentId, emojiId] of Object.entries(parsed.entries))if (typeof emojiId === 'string' && emojiId.length > 0) out[contentId] = emojiId;
        return out;
    } catch  {
        return {};
    }
};
const $dabf2e5c28263f4b$export$3ef572a2467e08f4 = (map)=>{
    try {
        const entries = {};
        for (const [contentId, emojiId] of Object.entries(map))if (typeof emojiId === 'string' && emojiId.length > 0) entries[contentId] = emojiId;
        // Drop the key entirely when empty to keep storage clean.
        if (Object.keys(entries).length === 0) {
            (0, $17wUi.confluenceSessionStorageInstance)?.removeItem($dabf2e5c28263f4b$var$STORAGE_KEY);
            return;
        }
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem($dabf2e5c28263f4b$var$STORAGE_KEY, JSON.stringify({
            v: 1,
            entries: entries
        }));
    } catch  {
    // Quota / consent / disabled storage — swallow; in-memory cache is unaffected.
    }
};
const $dabf2e5c28263f4b$export$fc4e54f3757eb471 = $dabf2e5c28263f4b$var$STORAGE_KEY;
module.exports["readSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$6adb2744b497be8f;
module.exports["writeSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$3ef572a2467e08f4;

});

parcelRegister("ivEX1", function(module, exports) {
/**
 * Registry of keys used with `confluenceSessionStorageInstance` (session storage).
 *
 * Keys here are intentionally NOT persisted across browser sessions.
 * Do NOT add keys here that should survive a tab close — use `LocalStorageKeys.ts` instead.
 */ const $ebcfca89ee3399cd$export$43572ca00746d574 = {
    /**
	 * The layout ('grid' | 'list') selected by the user for the folder contents view.
	 * Persisted for the duration of the browser session only.
	 */ FOLDER_VIEW_LAYOUT: 'folder.view.layout',
    /**
	 * Overrides the release track to 'dev'. Useful for running end-to-end tests
	 * from a dev machine against a production instance.
	 * Used by @confluence/build-info.
	 */ TELEMETRY_DEV_TRACK_OVERRIDE: 'confluence.telemetry-dev-track-override',
    /**
	 * Enables Confluence frontend logging when set to 'true'.
	 * Used by @confluence/logger.
	 */ ENABLE_LOGGING: 'confluence.enable-logging',
    /**
	 * Controls the minimum log level (1–5) for Confluence frontend logging.
	 * Used by @confluence/logger.
	 */ LOG_LEVEL: 'confluence.log-level',
    /**
	 * Tracks when the page-watch nudge was last shown to the user.
	 * Used by @confluence/third-party-nudge.
	 */ PAGE_VIEW_NUDGE_DATE: 'page-view-nudge-date',
    /**
	 * Tracks the state of the notification section nudge.
	 * Used by @confluence/third-party-nudge.
	 */ NOTIFICATION_NUDGE_STATE: 'notification-nudge-state',
    /**
	 * Per-contentId cache of the most recent custom emoji observed on a Live
	 * Doc, used to drive the "Restore emoji" affordance.
	 * Used by @confluence/emoji-title.
	 */ EMOJI_TITLE_PREVIOUS_EMOJI: 'confluence.emoji-title.previousEmojiId.v1',
    /**
	 * Set to `true` once the Planner title-based agent suggestion banner has been
	 * dismissed (via the close button or by clicking the CTA) during the current
	 * browser session, so it is not re-shown again until the next session.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_PLANNER_DISMISSED_SESSION: 'confluence.title-agent-nudge.planner-dismissed-session',
    /**
	 * Set to `true` once the Discovery & Feedback title-based agent suggestion
	 * banner has been dismissed (via the close button or by clicking the CTA)
	 * during the current browser session, so it is not re-shown again until the
	 * next session.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_DISCOVERY_AND_FEEDBACK_DISMISSED_SESSION: 'confluence.title-agent-nudge.discovery-and-feedback-dismissed-session'
};
module.exports["sessionKeys"] = $ebcfca89ee3399cd$export$43572ca00746d574;

});

parcelRegister("brNvA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2c05d1bead0fe3b6$export$fb4e7a383f5cb089 = /*#__PURE__*/ (0, $42omo.createContext)({
    commentToReattach: null,
    reattachHighlight: null,
    isInReattachMode: ()=>false
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentContext';
const $2c05d1bead0fe3b6$export$29a077948aa018ea = /*#__PURE__*/ (0, $42omo.createContext)({
    setCommentToReattach: ()=>{},
    setReattachHighlight: ()=>{},
    clearReattachMode: ()=>{}
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentDispatchContext';
const $2c05d1bead0fe3b6$export$eeb6c3345224df9d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    const [commentToReattach, setCommentToReattach] = (0, $42omo.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] !== commentToReattach) {
        t1 = ()=>Boolean(commentToReattach);
        $[0] = commentToReattach;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== commentToReattach || $[3] !== reattachHighlight || $[4] !== t1) {
        t2 = {
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: t1
        };
        $[2] = commentToReattach;
        $[3] = reattachHighlight;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const providerValue = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        };
        $[6] = t3;
    } else t3 = $[6];
    const dispatchProviderValue = t3;
    let t4;
    if ($[7] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
            value: dispatchProviderValue
        }, children);
        $[7] = children;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== providerValue || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
            value: providerValue
        }, t4);
        $[9] = providerValue;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children })=>{
    const [commentToReattach, setCommentToReattach] = (0, $42omo.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $42omo.useState)(null);
    const providerValue = (0, $42omo.useMemo)(()=>({
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: ()=>Boolean(commentToReattach)
        }), [
        commentToReattach,
        reattachHighlight
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        }), [
        setCommentToReattach,
        setReattachHighlight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $2c05d1bead0fe3b6$export$d801c7a3a205f98e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
} : ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
};
const $2c05d1bead0fe3b6$export$344893016ba0bdd4 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
} : ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
};
module.exports["ReattachCommentContext"] = $2c05d1bead0fe3b6$export$fb4e7a383f5cb089;
module.exports["ReattachCommentProvider"] = $2c05d1bead0fe3b6$export$eeb6c3345224df9d;
module.exports["useReattachComment"] = $2c05d1bead0fe3b6$export$d801c7a3a205f98e;
module.exports["useReattachCommentDispatch"] = $2c05d1bead0fe3b6$export$344893016ba0bdd4;

});

parcelRegister("fN9wG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $iXCQx = parcelRequire("iXCQx");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $17wUi = parcelRequire("17wUi");


var $b5SMr = parcelRequire("b5SMr");


var $elPdM = parcelRequire("elPdM");


var $c0rhi = parcelRequire("c0rhi");

const $bd929afc952baa40$var$INVITE_CAPABILITIES_URL = '/gateway/api/v3/invitations/capabilities';
const $bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY = 'confluence_invite_capabilities_direct_invite_mode';
const $bd929afc952baa40$var$i18n = (0, $aXWIB.defineMessages)({
    inviteSuccessTitle: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.title",
        defaultMessage: "Successfully added"
    },
    inviteSuccessDescription: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.description",
        defaultMessage: "We sent an email to <b>{name}</b> confirming you added them to Confluence."
    }
});
const $bd929afc952baa40$export$3bdfaf8c811be72d = /*#__PURE__*/ (0, $42omo.createContext)({});
const $bd929afc952baa40$var$hasDirectInviteCapabilities = async (cloudId, createAnalyticsEvent)=>{
    try {
        const canUserAccessJira = await $bd929afc952baa40$var$hasJiraSoftwareAccess(cloudId) ?? false;
        let directInviteMode;
        let invitePendingApprovalMode;
        if (canUserAccessJira) {
            //Call invite capabilities endpoint only if directInviteMode value is not available from local storage
            directInviteMode = (0, $17wUi.confluenceLocalStorageInstance).getItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY);
            if (!directInviteMode) {
                const response = await (0, $f7B1p.cfetch)(`${$bd929afc952baa40$var$INVITE_CAPABILITIES_URL}?resource=ari:cloud:platform::site/${cloudId}`, {
                    method: 'GET',
                    headers: {
                        ACCEPT: 'application/json'
                    }
                });
                if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
                const data = await response.json();
                for (const item of data)if (item?.resourceARI?.includes('confluence')) {
                    directInviteMode = item?.directInvite?.mode;
                    invitePendingApprovalMode = item?.invitePendingApproval?.mode;
                    break;
                }
                createAnalyticsEvent && createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: 'editor',
                        action: 'fetched',
                        actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                        attributes: {
                            directInviteMode: directInviteMode,
                            invitePendingApprovalMode: invitePendingApprovalMode
                        }
                    }
                }).fire();
                if (!!directInviteMode) (0, $17wUi.confluenceLocalStorageInstance).setItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY, directInviteMode, 86400);
            }
        }
        return directInviteMode === 'ANYONE';
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        createAnalyticsEvent && createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'editor',
                action: 'errored',
                actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                attributes: {
                    errorMessage: errorMessage
                }
            }
        }).fire();
        return false;
    }
};
const $bd929afc952baa40$var$hasJiraSoftwareAccess = async (cloudId)=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $b5SMr.default),
        variables: {
            resourceId: `ari:cloud:jira::site/${cloudId}`,
            permissionId: 'write'
        },
        __callerPackage__: "@confluence/fabric-media-support"
    }).then(({ data: data })=>{
        const hasJira = data?.confluence_tenantContext?.licensedProducts.some((product)=>product?.productKey?.toLowerCase().includes('jira-software') && product?.licenseStatus === (0, $elPdM.LicenseStatus).ACTIVE);
        return !!hasJira && data?.permitted;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return false;
    });
};
const $bd929afc952baa40$export$266d732058715003 = ({ children: children, flags: flags })=>{
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const promiseRef = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleXProductUserInvite = (0, $42omo.useCallback)(()=>{
        //check the eligibility criteria only once per SPA
        if (promiseRef.current) return promiseRef.current;
        promiseRef.current = (async ()=>{
            try {
                if (!(0, $9wGTI.fg)('cc_virality_x_product_user_invite_kill_switch') || !(accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS)) return false;
                return await $bd929afc952baa40$var$hasDirectInviteCapabilities(cloudId, createAnalyticsEvent);
            } catch  {
                return false;
            }
        })();
        return promiseRef.current;
    }, [
        accessStatus,
        cloudId,
        createAnalyticsEvent
    ]);
    const showSuccessFlag = (0, $42omo.useCallback)((name, isSuccess)=>{
        if (isSuccess) flags.showFlag({
            id: `x-product-user-invite-success`,
            title: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessTitle),
            description: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessDescription, {
                name: name,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        weight: "bold"
                    }, chunks)
            }),
            type: 'success-circle'
        });
    }, [
        flags,
        formatMessage
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            isEligibleXProductUserInvite: isEligibleXProductUserInvite,
            onXProductUserInviteClick: (name, isSuccess)=>{
                showSuccessFlag(name, isSuccess);
            }
        }), [
        isEligibleXProductUserInvite,
        showSuccessFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd929afc952baa40$export$3bdfaf8c811be72d.Provider, {
        value: value
    }, children);
};
const $bd929afc952baa40$export$363c701b8b10381c = (0, $7aRa9.withFlags)($bd929afc952baa40$export$266d732058715003);
module.exports["XProductUserInviteContext"] = $bd929afc952baa40$export$3bdfaf8c811be72d;
module.exports["XProductUserInviteProvider"] = $bd929afc952baa40$export$363c701b8b10381c;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("b5SMr", function(module, exports) {
/**
 * @generated SignedSource<<6d920e0b0bb587b6b159e40c1bffaa50>>
 * @relayHash 0799e7283121eb71f27f154269c35d2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f082ceabb2a22dad1af827fe35d8b92c3abbe18d26f157a4497a988561a8d8ff
const $0dd0647641a6eb7a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permissionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceId"
    }, v2 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "permissionId",
                    "variableName": "permissionId"
                },
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "kind": "ScalarField",
            "name": "permitted"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GetUserAccessQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GetUserAccessQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0799e7283121eb71f27f154269c35d2f",
            "id": "f082ceabb2a22dad1af827fe35d8b92c3abbe18d26f157a4497a988561a8d8ff",
            "metadata": {},
            "name": "GetUserAccessQuery",
            "operationKind": "query",
            "text": "query GetUserAccessQuery($resourceId:String!,$permissionId:String!){confluence_tenantContext{licensedProducts{licenseStatus,productKey}},permitted(resourceId:$resourceId,permissionId:$permissionId)}"
        }
    };
}();
$0dd0647641a6eb7a$var$node.hash = "32bb5d7171ecf6d04700c4e127e76256";
var $0dd0647641a6eb7a$export$2e2bcd8739ae039 = $0dd0647641a6eb7a$var$node;
module.exports["default"] = $0dd0647641a6eb7a$export$2e2bcd8739ae039;

});

parcelRegister("elPdM", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ad8e722f7df5268a$export$902181cb056f3d0b = /*#__PURE__*/ function(LicenseStatus) {
    LicenseStatus["ACTIVE"] = "ACTIVE";
    LicenseStatus["SUSPENDED"] = "SUSPENDED";
    LicenseStatus["UNLICENSED"] = "UNLICENSED";
    return LicenseStatus;
}({});
module.exports["LicenseStatus"] = $ad8e722f7df5268a$export$902181cb056f3d0b;

});

parcelRegister("kCeSx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f022e5db44f52121$export$2e2bcd8739ae039);

var $kFqI2 = parcelRequire("kFqI2");


var $64Cib = parcelRequire("64Cib");


var $eYRlV = parcelRequire("eYRlV");


var $iyEDi = parcelRequire("iyEDi");


var $eYNcX = parcelRequire("eYNcX");


var $g4VeD = parcelRequire("g4VeD");

const $f022e5db44f52121$var$selectContentsFromIds = (0, $eYRlV.createContentsFromIdsSelector)();
const $f022e5db44f52121$export$c31df4bd766f9c35 = (state)=>{
    let spaceKey;
    let contentId;
    let contentType;
    let createpageProps = {};
    // CreatePage passes draftId as contentId. Use it instead of the one coming from
    if (state.editor.get('draftId') && state.editor.get('statusCode') === (0, $eYNcX.OK)) {
        contentId = state.editor.get('draftId');
        const createdPage = state.editor.get('result');
        let ancestors;
        let parentPage;
        if (typeof createdPage?.get === 'function') {
            contentType = createdPage.get('type', null);
            ancestors = createdPage.get('ancestors', []);
            parentPage = ancestors.last();
        } else {
            contentType = createdPage.type;
            ancestors = createdPage.ancestors || [];
            parentPage = ancestors[ancestors.length - 1];
        }
        createpageProps = {
            parentPageId: `${// So the page can either be a plain object or a record depending on timing...
            // TODO: Get rid of all the redux here.
            parentPage ? typeof parentPage.get === 'function' ? parentPage.get('id') : parentPage.id : 0}`,
            // cast to string
            pageVersion: 0 // enforce version 0, otherwise saving will fail with 409 Conflict
        };
    }
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    const location = (0, $iyEDi.getLocation)(state);
    if (!spaceKey) spaceKey = routeParams.spaceKey;
    if (!contentId) // on old viewPage we need `contentId` for request permissions component
    // we can get it as `pageId` from location query;
    contentId = routeParams.contentId || (location.query || {}).pageId;
    if (!contentId && spaceKey) // Fallback to space homepage if no content id found
    contentId = `${state.entities.getIn([
        'spaces',
        spaceKey,
        'homepageId'
    ])}`; // string
    const currentPage = state.entities.getIn([
        'contents',
        `${contentId}`
    ]);
    if (contentId && currentPage) contentType = currentPage.type;
    const editorForCommentsIsEnabled = state.views.viewPage.editor.contentId;
    if (editorForCommentsIsEnabled) contentType = 'comment';
    if ([
        'CREATE_TEMPLATE_SPACE',
        'EDIT_TEMPLATE_SPACE',
        'EDIT_TEMPLATE',
        'CREATE_TEMPLATE'
    ].includes(location.routeName)) contentType = 'template';
    let viewpageProps = {};
    const currentPageVersion = state.entities.getIn([
        'versions',
        `${contentId}`
    ], {});
    if (currentPage) {
        const parentPage = currentPage.ancestors && currentPage.ancestors.size ? $f022e5db44f52121$var$selectContentsFromIds((0, $64Cib.fromJS)([
            currentPage.ancestors.last()
        ]), state).first() : null;
        viewpageProps = {
            pageTitle: currentPage.title,
            pageVersion: currentPageVersion.number,
            parentPageTitle: parentPage ? parentPage.title : '',
            parentPageId: parentPage ? parentPage.id : '0',
            canRemovePage: currentPage.currentUserPermissions && currentPage.currentUserPermissions.includes('delete')
        };
    }
    const experimentProps = {
        experimentFeatures: state.views.dashboard.get('experimentFeatures')
    };
    // TODO: there is no simple way to select the parent yet so this code will be commented out till we solve it
    // matches /spaces/{spaceKey}/pages or /spaces/{spaceKey}/pages/ only
    //const isPageTree = /\/spaces\/([~0-9A-z]*)\/pages(\/)?$/.test(location.pathname);
    //const contextualMenuOpenForPageId = state.views.spaceHome.pageTreeContextualMenu;
    //
    //if (isPageTree && !!contextualMenuOpenForPageId) {
    //    const selectedPage = state.entities.getIn(['contents', contextualMenuOpenForPageId]);
    //    if (selectedPage) {
    //        const parentPage = selectedPage.ancestors.size ? selectContentsFromIds(fromJS([selectedPage.ancestors.last()]), state).first() : null;
    //        viewpageProps = {
    //            contentId: selectedPage.id,
    //            pageTitle: selectedPage.title,
    //            parentPageTitle: parentPage ? parentPage.title : null,
    //            parentPageId: parentPage ? parentPage.id : '0',
    //            canRemovePage: selectedPage.currentUserPermissions.includes('delete')
    //        };
    //    }
    //}
    return {
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        spaceName: state.entities.getIn([
            'spaces',
            spaceKey,
            'name'
        ]),
        spaceType: state.entities.getIn([
            'spaces',
            spaceKey,
            'type'
        ]),
        ...viewpageProps,
        ...createpageProps,
        ...experimentProps
    };
};
var $f022e5db44f52121$export$2e2bcd8739ae039 = (0, $kFqI2.connect)($f022e5db44f52121$export$c31df4bd766f9c35)((0, $g4VeD.default));

});

parcelRegister("eYRlV", function(module, exports) {

var $b4Wym = parcelRequire("b4Wym");


var $64Cib = parcelRequire("64Cib");


var $ePeSL = parcelRequire("ePeSL");

const $ae800dfdeadf4eac$var$PREDEFINED_BLUEPRINT_TYPES = {
    'meeting-notes': true,
    decisions: true,
    'kb-how-to-article': true,
    'file-list': true,
    retrospective: true,
    requirements: true,
    'shared-links': true,
    'kb-troubleshooting-article': true,
    'task-report': true,
    jirareport: true
};
function $ae800dfdeadf4eac$var$isEmpty(data) {
    if (!data) return true;
    return !$ae800dfdeadf4eac$var$size(data);
}
function $ae800dfdeadf4eac$var$size(data) {
    if (!data) return 0;
    return data.hasOwnProperty('size') ? data.size : data.length;
}
const $ae800dfdeadf4eac$export$1ada442d7b78f25 = (0, $ePeSL.default)((item)=>item, (item, users)=>users, // 'containers' may be a space or a content, right now it's only ever content on file records
(item, users, containers)=>containers, (item, users, containers, versions)=>versions, (item, users, containers, versions)=>{
    let version = versions.get(`${item.version}`);
    if (version) version = version.set('by', users.get(version.by));
    const container = item.container ? containers.get(`${item.container}`) : null;
    let result = item.set('createdBy', users.get(item.createdBy)).set('version', version);
    if (item.contributors) result = result.set('contributors', item.contributors.map((accountId)=>users.get(accountId)));
    if (item.viewers) result = result.set('viewers', item.viewers.map((accountId)=>users.get(accountId)));
    if (container) {
        result = result.set('container', container);
        const containerVersion = container.get('version');
        if (containerVersion) result = result.setIn([
            'container',
            'version'
        ], versions.get(`${containerVersion}`));
    }
    return result;
});
const $ae800dfdeadf4eac$export$5c63e7dafa621e16 = (contentId, state)=>{
    const entities = state.entities;
    const content = entities.get('contents').get(`${contentId}`);
    if (content && (content.createdBy || content.version)) return $ae800dfdeadf4eac$export$1ada442d7b78f25(content, entities.get('users'), entities.get('contents'), entities.get('versions'));
    return content;
};
const $ae800dfdeadf4eac$export$fe6dd8e2950283cb = (state, contentId, permissionType)=>{
    const content = state.entities.getIn([
        'contents',
        contentId
    ]);
    return content.currentUserPermissions.contains(permissionType);
};
const $ae800dfdeadf4eac$export$84b461ed686ebfb9 = (state, contentId)=>$ae800dfdeadf4eac$export$fe6dd8e2950283cb(state, contentId, 'update');
const $ae800dfdeadf4eac$var$buildContentCreatedBy = (0, $ePeSL.default)((item)=>item, (item, users)=>users, (item, users)=>item.set('createdBy', users.get(item.createdBy)));
const $ae800dfdeadf4eac$export$5c767ea021dac201 = ()=>(0, $b4Wym.createSelector)((ids)=>ids, (ids, state, contents)=>contents || state.entities.get('contents'), (ids, state)=>state.entities.get('contents'), (ids, state)=>state.entities.get('versions'), (ids, state)=>state.entities.get('users'), // 'containers' may be a space or a content, right now it's only ever content on file records
    (ids, contents, containers, versions, users)=>{
        if (!ids) return null;
        if (typeof ids === 'number' || typeof ids === 'string') ids = (0, $64Cib.List)([
            `${ids}`
        ]);
        if (ids.length && !(0, $64Cib.List).isList(ids)) ids = (0, $64Cib.List)(ids);
        if (!ids.size) return (0, $64Cib.List)([]);
        ids = ids.filter((id)=>!!contents.get(`${id}`));
        return ids.map((id)=>{
            const content = contents.get(`${id}`);
            if (content.createdBy || content.version) return $ae800dfdeadf4eac$export$1ada442d7b78f25(content, users, containers, versions);
            return content;
        });
    });
const $ae800dfdeadf4eac$export$7203590478a6c254 = ()=>(0, $b4Wym.createSelector)((ids)=>ids, (ids, state)=>state.entities.get('contents'), (ids, contents)=>{
        if ($ae800dfdeadf4eac$var$isEmpty(ids)) return (0, $64Cib.List)([]);
        return ids.map((id)=>contents.get(`${id}`));
    });
const $ae800dfdeadf4eac$export$167cb14480de4389 = ()=>(0, $b4Wym.createSelector)((ids)=>ids, (ids, state)=>state.entities.get('contents'), (ids, state)=>state.entities.get('users'), (ids, contents, users)=>{
        if ($ae800dfdeadf4eac$var$isEmpty(ids)) return (0, $64Cib.List)([]);
        return ids.map((id)=>{
            const content = contents.get(`${id}`);
            if (content && content.createdBy) return $ae800dfdeadf4eac$var$buildContentCreatedBy(content, users);
            return content;
        });
    });
const $ae800dfdeadf4eac$var$getContent = (contentId, state)=>state.entities.getIn([
        'contents',
        contentId
    ]);
const $ae800dfdeadf4eac$var$getLabels = (contentId, state)=>state.entities.get('labels');
const $ae800dfdeadf4eac$export$e23bbeb6c3d185f2 = (0, $b4Wym.createSelector)($ae800dfdeadf4eac$var$getContent, $ae800dfdeadf4eac$var$getLabels, (content, labels)=>{
    if (!content || !labels) return '';
    const contentLabels = content.get('labels');
    if (!contentLabels || contentLabels.size === 0) return '';
    const contentBlueprintId = contentLabels.find((labelId)=>{
        const labelData = labels.get(labelId);
        return !labelData ? false : $ae800dfdeadf4eac$var$PREDEFINED_BLUEPRINT_TYPES[labelData.get('name')];
    });
    return contentBlueprintId ? labels.get(contentBlueprintId).get('name') : '';
});
module.exports["buildContentItem"] = $ae800dfdeadf4eac$export$5c63e7dafa621e16;
module.exports["createContentsFromIdsSelector"] = $ae800dfdeadf4eac$export$5c767ea021dac201;

});

parcelRegister("ePeSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $acb15f65db8e2947$export$2e2bcd8739ae039);

var $b4Wym = parcelRequire("b4Wym");

/**
 * WeakMapMemoizer allows memoisation of lists
 */ class $acb15f65db8e2947$var$WeakMapMemoizer {
    memoize(...weakArgs) {
        return this._memoizeImpl(this.map, weakArgs, 0);
    }
    _memoizeImpl(map, args, i) {
        let value = map.get(args[i]);
        if (i === args.length - 1) {
            if (!value) {
                value = this.func(...args);
                map.set(args[i], value);
            }
            return value;
        }
        if (!value) {
            value = new WeakMap();
            map.set(args[i], value);
        }
        return this._memoizeImpl(value, args, i + 1);
    }
    constructor(func){
        this.map = new WeakMap();
        this.func = func;
    }
}
var /**
 * createSelectorCreator - drop in replacement for reselect.createSelector
 * which offers better performance when dealing with lists that should
 * be recreated very often
 */ $acb15f65db8e2947$export$2e2bcd8739ae039 = (0, $b4Wym.createSelectorCreator)((func)=>{
    const memoizer = new $acb15f65db8e2947$var$WeakMapMemoizer(func);
    return memoizer.memoize.bind(memoizer);
});

});

parcelRegister("g4VeD", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $6g1oe = parcelRequire("6g1oe");


var $cSdzn = parcelRequire("cSdzn");

class $bb496ac4c35df382$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    componentDidMount() {
        this._setLegacyProps(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this._setLegacyProps(nextProps);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.props, nextProps);
    }
    componentWillUnmount() {
        this._setAJSValues({});
        this._cancelWaitForGlobalInProgress();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this._waitForGlobalInProgress = null;
        this._setLegacyProps = (props)=>{
            this._cancelWaitForGlobalInProgress();
            this._waitForGlobalInProgress = (0, $cSdzn.default)({
                listener: 'LegacyBridge.js',
                globalProperty: 'AJS.params'
            }, ()=>this._setAJSValues(props));
        };
        this._cancelWaitForGlobalInProgress = ()=>{
            if (this._waitForGlobalInProgress) // This prevents waitForGlobal to updates this component in random order in case of multiple calls.
            this._waitForGlobalInProgress.cancel();
        };
        this._setAJSValues = (props)=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS || !(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.params) return;
            const { spaceKey: spaceKey, spaceName: spaceName, spaceType: spaceType, contentId: contentId, contentType: contentType, pageTitle: pageTitle, pageVersion: pageVersion, parentPageId: parentPageId, parentPageTitle: parentPageTitle, canRemovePage: canRemovePage, experimentFeatures: experimentFeatures } = props;
            const createPage = pageVersion === 0;
            const pageId = createPage ? '0' : contentId;
            // page/content info
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.params.pageId = pageId;
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.params.spaceKey = spaceKey;
            const metaParams = {
                // page/content info
                'content-id': contentId,
                'content-type': contentType,
                'page-id': pageId,
                'page-title': pageTitle,
                'page-version': pageVersion,
                'parent-page-id': parentPageId,
                'parent-page-title': parentPageTitle,
                'latest-page-id': contentId,
                'can-remove-page': canRemovePage,
                'new-page': createPage,
                // space info
                'space-key': spaceKey,
                'space-name': spaceName,
                'space-type': spaceType,
                // experiments
                'experiment-features': experimentFeatures
            };
            // Do not set if legacy bridge in next has already handled
            // See: next/packages/view-page/src/LegacyBridgeNext.js
            if ((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.Meta && !(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.Meta.get('has-next-legacy-bridge')) Object.keys(metaParams).forEach((key)=>{
                // standalone mode doesn't have AJS
                (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).AJS.Meta.set(key, metaParams[key]);
            });
        };
    }
}
$bb496ac4c35df382$export$2e2bcd8739ae039.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaceName: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    spaceType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    pageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    pageVersion: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
    parentPageId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    parentPageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    canRemovePage: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    experimentFeatures: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["default"] = $bb496ac4c35df382$export$2e2bcd8739ae039;

});

parcelRegister("cSdzn", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f50dcfd27e28ce$export$2e2bcd8739ae039);
function $95f50dcfd27e28ce$var$isDefined(path) {
    const pathParts = path.split('.');
    let obj = window[pathParts.shift()];
    while(typeof obj !== 'undefined' && pathParts.length)obj = obj[pathParts.shift()];
    return obj;
}
const $95f50dcfd27e28ce$var$lines = {};
function $95f50dcfd27e28ce$var$logOnce(message) {}
function $95f50dcfd27e28ce$export$d2adf65b87e47523() {
    for(const key in $95f50dcfd27e28ce$var$lines)delete $95f50dcfd27e28ce$var$lines[key];
}
function $95f50dcfd27e28ce$export$2e2bcd8739ae039({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($95f50dcfd27e28ce$var$isDefined(globalProperty)) {
        $95f50dcfd27e28ce$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $95f50dcfd27e28ce$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($95f50dcfd27e28ce$var$isDefined(globalProperty)) {
            $95f50dcfd27e28ce$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
    return {
        cancel () {
            if (waitForGlobalInterval) clearInterval(waitForGlobalInterval);
        }
    };
}

});

parcelRegister("aXWtB", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $jmjWc = parcelRequire("jmjWc");

const $35c87ab817b10787$var$createLoadingComponent = ()=>{
    return (0, $fwDOR.default)({
        name: 'LoadingConfluenceConversationAssistantBundle'
    });
};

const $35c87ab817b10787$export$3ca68d91b1a1bca2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HQN7e",
    name: "ConfluenceConversationAssistant",
    loader: async ()=>(await (parcelRequire("elV4M"))).ConfluenceConversationAssistant,
    loading: $35c87ab817b10787$var$createLoadingComponent
});
module.exports["ConfluenceConversationAssistant"] = $35c87ab817b10787$export$3ca68d91b1a1bca2;

});

parcelRegister("elV4M", function(module, exports) {

let $a72f4cfffc6ab0f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a72f4cfffc6ab0f8$var$load("9nwFZ"),
    $a72f4cfffc6ab0f8$var$load("7j0mT"),
    $a72f4cfffc6ab0f8$var$load("69R9L"),
    $a72f4cfffc6ab0f8$var$load("aoJPa")
]).then(()=>parcelRequire('kaQDe'));

});

parcelRegister("gLUd5", function(module, exports) {
$parcel$export(module.exports, "exitBranchFn", () => (parcelRequire("5Z4kM")).exitBranchFn);
$parcel$export(module.exports, "isBranchDeployFn", () => (parcelRequire("5Z4kM")).isBranchDeployFn);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $5Z4kM = parcelRequire("5Z4kM");


//Plain div to display while chunk loads, avoids help menu resizing after loading
// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
const $9708b4b4a3dbcb64$var$loadingDiv = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            width: '100%',
            height: 29
        }
    });

const $9708b4b4a3dbcb64$export$b39479f42d974760 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RVoYJ",
    name: "FeedbackCollectorButton",
    loader: async ()=>(await (parcelRequire("jBmCK"))).FeedbackCollectorButton,
    loading: $9708b4b4a3dbcb64$var$loadingDiv
});

});

parcelRegister("jBmCK", function(module, exports) {

let $e45305a9815fea20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e45305a9815fea20$var$load("6wr18"),
    $e45305a9815fea20$var$load("ffEVr"),
    $e45305a9815fea20$var$load("3aT4s")
]).then(()=>parcelRequire('3ZEEP'));

});

parcelRegister("5Z4kM", function(module, exports) {
/* eslint no-restricted-syntax: 0 */ 
var $jiJCD = parcelRequire("jiJCD");


var $68uaC = parcelRequire("68uaC");

const $45b602e848c81a5d$export$28445d8a8237c240 = 'useFrontendBranch';
const $45b602e848c81a5d$export$2db401a6b81eceee = 'useFrontendBuildVersion';
const $45b602e848c81a5d$var$BIFROST_OVERRIDE = 'bifrost-override';
const $45b602e848c81a5d$export$399982ccb22744fa = ()=>{
    const urlComponents = (0, $jiJCD.parse)(window.location.href, true);
    (0, $68uaC.Cookies).remove($45b602e848c81a5d$var$BIFROST_OVERRIDE);
    (0, $68uaC.Cookies).remove($45b602e848c81a5d$export$28445d8a8237c240);
    (0, $68uaC.Cookies).remove($45b602e848c81a5d$export$2db401a6b81eceee);
    window.location.assign((0, $jiJCD.format)({
        path: urlComponents.path,
        query: {
            ...urlComponents.query,
            [$45b602e848c81a5d$export$28445d8a8237c240]: 'off',
            [$45b602e848c81a5d$export$2db401a6b81eceee]: 'off'
        },
        hash: urlComponents.hash
    }));
};
const $45b602e848c81a5d$export$6b1dc8f4a2350eb5 = ()=>{
    let cookieBasedBranchVersion;
    const isBifrost = window.__IS_BIFROST__;
    let bifrostOverrideVersion;
    try {
        cookieBasedBranchVersion = (0, $68uaC.Cookies).get($45b602e848c81a5d$export$28445d8a8237c240);
        if (isBifrost) bifrostOverrideVersion = (0, $68uaC.Cookies).get('bifrost-override');
    } catch (err) {
        // Likely a firefox edge-case: "Error: can't access dead object"
        // Occasionally, document.cookie is cleaned up despite living
        // references -- including js-cookie's
        cookieBasedBranchVersion = 'off';
        if (isBifrost) bifrostOverrideVersion = 'off';
    }
    if (isBifrost) return !!(bifrostOverrideVersion && !bifrostOverrideVersion.includes('CLASSIC-off-off'));
    return !!(cookieBasedBranchVersion && cookieBasedBranchVersion !== 'off');
};
module.exports["exitBranchFn"] = $45b602e848c81a5d$export$399982ccb22744fa;
module.exports["isBranchDeployFn"] = $45b602e848c81a5d$export$6b1dc8f4a2350eb5;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("2Nwuj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(21);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)("platform-dst-shape-theme-default") && $0412590977f134ac$var$styles.baseT26Shape, appearance === "default" && $0412590977f134ac$var$styles.defaultAppearance, appearance === "subtle" && $0412590977f134ac$var$styles.subtleAppearance, appearance === "inverse" && $0412590977f134ac$var$styles.inverseAppearance, appearance !== "inverse" && $0412590977f134ac$var$styles.visitedLink);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== target || $[10] !== testId) {
        t3 = target === "_blank" && /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: $0412590977f134ac$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", /*#__PURE__*/ $42omo.createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            className: (0, $gMc0m.default)([
                "_1bsbgm0b _4t3igm0b _ahbqzjw7"
            ])
        }, /*#__PURE__*/ $42omo.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })));
        $[9] = target;
        $[10] = testId;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children || $[13] !== htmlAttributes || $[14] !== newWindowLabel || $[15] !== ref || $[16] !== t2 || $[17] !== t3 || $[18] !== target || $[19] !== testId) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, $auNCB.default), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t2,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, t3);
        $[12] = children;
        $[13] = htmlAttributes;
        $[14] = newWindowLabel;
        $[15] = ref;
        $[16] = t2;
        $[17] = t3;
        $[18] = target;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $42omo.createElement((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $0412590977f134ac$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $42omo.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $gMc0m.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("4o1RV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iV5Ic = parcelRequire("iV5Ic");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $frIzR.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $42omo.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $42omo.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2XqLN = parcelRequire("2XqLN");


var $7CLBv = parcelRequire("7CLBv");


var $dDZcC = parcelRequire("dDZcC");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $frIzR.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $2XqLN.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $2XqLN.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $dDZcC.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("ipwYn", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $hLryH = parcelRequire("hLryH");


var $jykdj = parcelRequire("jykdj");


var $3g4Fn = parcelRequire("3g4Fn");


var $juOMD = parcelRequire("juOMD");


var $dYI4C = parcelRequire("dYI4C");


var $irmBX = parcelRequire("irmBX");


var $3qHtb = parcelRequire("3qHtb");


var $80RNM = parcelRequire("80RNM");


var $d5B92 = parcelRequire("d5B92");


var $jHiyU = parcelRequire("jHiyU");


var $1WABR = parcelRequire("1WABR");


var $1Z3rm = parcelRequire("1Z3rm");


var $ka5vO = parcelRequire("ka5vO");


var $8LtzT = parcelRequire("8LtzT");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $83PD5 = parcelRequire("83PD5");


var $lc9ud = parcelRequire("lc9ud");


var $6b9OI = parcelRequire("6b9OI");


var $d6TaN = parcelRequire("d6TaN");


var $jVTxf = parcelRequire("jVTxf");

/** Used to compose bitmasks for cloning. */ var $d674238523d4f2bb$var$CLONE_DEEP_FLAG = 1, $d674238523d4f2bb$var$CLONE_FLAT_FLAG = 2, $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d674238523d4f2bb$var$argsTag = '[object Arguments]', $d674238523d4f2bb$var$arrayTag = '[object Array]', $d674238523d4f2bb$var$boolTag = '[object Boolean]', $d674238523d4f2bb$var$dateTag = '[object Date]', $d674238523d4f2bb$var$errorTag = '[object Error]', $d674238523d4f2bb$var$funcTag = '[object Function]', $d674238523d4f2bb$var$genTag = '[object GeneratorFunction]', $d674238523d4f2bb$var$mapTag = '[object Map]', $d674238523d4f2bb$var$numberTag = '[object Number]', $d674238523d4f2bb$var$objectTag = '[object Object]', $d674238523d4f2bb$var$regexpTag = '[object RegExp]', $d674238523d4f2bb$var$setTag = '[object Set]', $d674238523d4f2bb$var$stringTag = '[object String]', $d674238523d4f2bb$var$symbolTag = '[object Symbol]', $d674238523d4f2bb$var$weakMapTag = '[object WeakMap]';
var $d674238523d4f2bb$var$arrayBufferTag = '[object ArrayBuffer]', $d674238523d4f2bb$var$dataViewTag = '[object DataView]', $d674238523d4f2bb$var$float32Tag = '[object Float32Array]', $d674238523d4f2bb$var$float64Tag = '[object Float64Array]', $d674238523d4f2bb$var$int8Tag = '[object Int8Array]', $d674238523d4f2bb$var$int16Tag = '[object Int16Array]', $d674238523d4f2bb$var$int32Tag = '[object Int32Array]', $d674238523d4f2bb$var$uint8Tag = '[object Uint8Array]', $d674238523d4f2bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d674238523d4f2bb$var$uint16Tag = '[object Uint16Array]', $d674238523d4f2bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d674238523d4f2bb$var$cloneableTags = {};
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$argsTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayBufferTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dataViewTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$boolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dateTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float64Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$mapTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$numberTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$objectTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$regexpTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$setTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$stringTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$symbolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8ClampedTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint32Tag] = true;
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$errorTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$funcTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d674238523d4f2bb$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d674238523d4f2bb$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d674238523d4f2bb$var$CLONE_FLAT_FLAG, isFull = bitmask & $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lc9ud(value)) return value;
    var isArr = $fZxmY(value);
    if (isArr) {
        result = $1Z3rm(value);
        if (!isDeep) return $irmBX(value, result);
    } else {
        var tag = $1WABR(value), isFunc = tag == $d674238523d4f2bb$var$funcTag || tag == $d674238523d4f2bb$var$genTag;
        if ($cSA01(value)) return $dYI4C(value, isDeep);
        if (tag == $d674238523d4f2bb$var$objectTag || tag == $d674238523d4f2bb$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $8LtzT(value);
            if (!isDeep) return isFlat ? $80RNM(value, $juOMD(result, value)) : $3qHtb(value, $3g4Fn(result, value));
        } else {
            if (!$d674238523d4f2bb$var$cloneableTags[tag]) return object ? value : {};
            result = $ka5vO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $en5bh);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6b9OI(value)) value.forEach(function(subValue) {
        result.add($d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($83PD5(value)) value.forEach(function(subValue, key) {
        result.set(key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $jHiyU : $d5B92 : isFlat ? $jVTxf : $d6TaN;
    var props = isArr ? undefined : keysFunc(value);
    $hLryH(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $jykdj(result, key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d674238523d4f2bb$var$baseClone;

});

parcelRegister("hLryH", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ceec3402dc147ea9$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ceec3402dc147ea9$var$arrayEach;

});

parcelRegister("3g4Fn", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25f67c63e240b594$var$baseAssign(object, source) {
    return object && $gR42R(source, $d6TaN(source), object);
}
module.exports = $25f67c63e240b594$var$baseAssign;

});

parcelRegister("juOMD", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e318362ea5151771$var$baseAssignIn(object, source) {
    return object && $gR42R(source, $jVTxf(source), object);
}
module.exports = $e318362ea5151771$var$baseAssignIn;

});

parcelRegister("3qHtb", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jcne3 = parcelRequire("jcne3");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $27f584f8141687cb$var$copySymbols(source, object) {
    return $gR42R(source, $jcne3(source), object);
}
module.exports = $27f584f8141687cb$var$copySymbols;

});

parcelRegister("80RNM", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $75Obx = parcelRequire("75Obx");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d580ec319704467$var$copySymbolsIn(source, object) {
    return $gR42R(source, $75Obx(source), object);
}
module.exports = $5d580ec319704467$var$copySymbolsIn;

});

parcelRegister("1Z3rm", function(module, exports) {
/** Used for built-in method references. */ var $171e28212cd49be3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $171e28212cd49be3$var$hasOwnProperty = $171e28212cd49be3$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $171e28212cd49be3$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $171e28212cd49be3$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $171e28212cd49be3$var$initCloneArray;

});

parcelRegister("ka5vO", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");


var $43GUE = parcelRequire("43GUE");


var $62nGv = parcelRequire("62nGv");


var $eBmVy = parcelRequire("eBmVy");


var $jDkcM = parcelRequire("jDkcM");

/** `Object#toString` result references. */ var $ead9046a77579327$var$boolTag = '[object Boolean]', $ead9046a77579327$var$dateTag = '[object Date]', $ead9046a77579327$var$mapTag = '[object Map]', $ead9046a77579327$var$numberTag = '[object Number]', $ead9046a77579327$var$regexpTag = '[object RegExp]', $ead9046a77579327$var$setTag = '[object Set]', $ead9046a77579327$var$stringTag = '[object String]', $ead9046a77579327$var$symbolTag = '[object Symbol]';
var $ead9046a77579327$var$arrayBufferTag = '[object ArrayBuffer]', $ead9046a77579327$var$dataViewTag = '[object DataView]', $ead9046a77579327$var$float32Tag = '[object Float32Array]', $ead9046a77579327$var$float64Tag = '[object Float64Array]', $ead9046a77579327$var$int8Tag = '[object Int8Array]', $ead9046a77579327$var$int16Tag = '[object Int16Array]', $ead9046a77579327$var$int32Tag = '[object Int32Array]', $ead9046a77579327$var$uint8Tag = '[object Uint8Array]', $ead9046a77579327$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ead9046a77579327$var$uint16Tag = '[object Uint16Array]', $ead9046a77579327$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ead9046a77579327$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ead9046a77579327$var$arrayBufferTag:
            return $jZrbP(object);
        case $ead9046a77579327$var$boolTag:
        case $ead9046a77579327$var$dateTag:
            return new Ctor(+object);
        case $ead9046a77579327$var$dataViewTag:
            return $43GUE(object, isDeep);
        case $ead9046a77579327$var$float32Tag:
        case $ead9046a77579327$var$float64Tag:
        case $ead9046a77579327$var$int8Tag:
        case $ead9046a77579327$var$int16Tag:
        case $ead9046a77579327$var$int32Tag:
        case $ead9046a77579327$var$uint8Tag:
        case $ead9046a77579327$var$uint8ClampedTag:
        case $ead9046a77579327$var$uint16Tag:
        case $ead9046a77579327$var$uint32Tag:
            return $jDkcM(object, isDeep);
        case $ead9046a77579327$var$mapTag:
            return new Ctor;
        case $ead9046a77579327$var$numberTag:
        case $ead9046a77579327$var$stringTag:
            return new Ctor(object);
        case $ead9046a77579327$var$regexpTag:
            return $62nGv(object);
        case $ead9046a77579327$var$setTag:
            return new Ctor;
        case $ead9046a77579327$var$symbolTag:
            return $eBmVy(object);
    }
}
module.exports = $ead9046a77579327$var$initCloneByTag;

});

parcelRegister("43GUE", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2f48bad00268e015$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jZrbP(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2f48bad00268e015$var$cloneDataView;

});

parcelRegister("62nGv", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $46554d38b2abfa6c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $46554d38b2abfa6c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $46554d38b2abfa6c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $46554d38b2abfa6c$var$cloneRegExp;

});

parcelRegister("eBmVy", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

/** Used to convert symbols to primitives and strings. */ var $aa164e47d9e5bdc6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $aa164e47d9e5bdc6$var$symbolValueOf = $aa164e47d9e5bdc6$var$symbolProto ? $aa164e47d9e5bdc6$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $aa164e47d9e5bdc6$var$cloneSymbol(symbol) {
    return $aa164e47d9e5bdc6$var$symbolValueOf ? Object($aa164e47d9e5bdc6$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $aa164e47d9e5bdc6$var$cloneSymbol;

});

parcelRegister("83PD5", function(module, exports) {

var $3Ap6k = parcelRequire("3Ap6k");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $5de6a718766ecdb3$var$nodeIsMap = $cl53l && $cl53l.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5de6a718766ecdb3$var$isMap = $5de6a718766ecdb3$var$nodeIsMap ? $dFnBO($5de6a718766ecdb3$var$nodeIsMap) : $3Ap6k;
module.exports = $5de6a718766ecdb3$var$isMap;

});

parcelRegister("3Ap6k", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $29c8346be35e214d$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $29c8346be35e214d$var$baseIsMap(value) {
    return $6eZU2(value) && $1WABR(value) == $29c8346be35e214d$var$mapTag;
}
module.exports = $29c8346be35e214d$var$baseIsMap;

});

parcelRegister("6b9OI", function(module, exports) {

var $sQE8x = parcelRequire("sQE8x");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $47fb629c5fa31bac$var$nodeIsSet = $cl53l && $cl53l.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $47fb629c5fa31bac$var$isSet = $47fb629c5fa31bac$var$nodeIsSet ? $dFnBO($47fb629c5fa31bac$var$nodeIsSet) : $sQE8x;
module.exports = $47fb629c5fa31bac$var$isSet;

});

parcelRegister("sQE8x", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $056b741c66fd28fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $056b741c66fd28fb$var$baseIsSet(value) {
    return $6eZU2(value) && $1WABR(value) == $056b741c66fd28fb$var$setTag;
}
module.exports = $056b741c66fd28fb$var$baseIsSet;

});

parcelRegister("aFbGo", function(module, exports) {
const $3fe527a88453b695$export$5dd7a635c52544a = ()=>window?.location?.search?.indexOf('lite=1') >= 0;
module.exports["isViewPageLite"] = $3fe527a88453b695$export$5dd7a635c52544a;

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $kyiqo = parcelRequire("kyiqo");


var $3kTfj = parcelRequire("3kTfj");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $kyiqo.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $kyiqo.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $kyiqo.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $kyiqo.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $cbc8g.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $kyiqo = parcelRequire("kyiqo");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $kyiqo.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("aYxMO", function(module, exports) {

let $7fd9b73c6522cc05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7fd9b73c6522cc05$var$load("aWPe2").then(()=>parcelRequire('bDxwy'));

});

parcelRegister("hzVuz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");





var $bQm3c = parcelRequire("bQm3c");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $k3pHv = parcelRequire("k3pHv");

const $b7aff31f4e633d8f$var$checkDomainApproval = async (cloudId, userId, onError)=>{
    let OrgMemberCapabilityType = /*#__PURE__*/ function(OrgMemberCapabilityType) {
        OrgMemberCapabilityType["DIRECT_ACCESS"] = "DIRECT_ACCESS";
        OrgMemberCapabilityType["REQUEST_ACCESS"] = "REQUEST_ACCESS";
        OrgMemberCapabilityType["PENDING_REQUEST_EXISTS"] = "PENDING_REQUEST_EXISTS";
        return OrgMemberCapabilityType;
    }({});
    const params = new URLSearchParams({
        resource: `ari:cloud:confluence::site/${cloudId}`
    });
    let hasCapabilities = false;
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                resource: `ari:cloud:confluence::site/${cloudId}`,
                ACCEPT: 'application/json',
                'Account-Id': userId
            }
        });
        const data = await response.json();
        if (Object.values(data.results)[0] in OrgMemberCapabilityType) hasCapabilities = true;
    } catch (e) {
        const response = (0, $hBkCm.BadStatusError).isBadStatusError(e) ? e.response : undefined;
        const error = new Error(`Error in getting approved domains, status = ${response?.status}, message = "${response?.statusText}"`);
        onError(error);
    }
    return hasCapabilities;
};
const $b7aff31f4e633d8f$export$435bbe3b3c44f9d8 = (isExternalShareRequest = false)=>{
    const { isLicensed: isLicensed, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isApprovedOrgMember, setIsApprovedOrgMember] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const validateDomain = async ()=>{
            if (userId && !isLicensed && isExternalShareRequest) {
                const isApproved = await $b7aff31f4e633d8f$var$checkDomainApproval(cloudId, userId, (error)=>{
                    experienceTracker.fail({
                        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
                        error: error
                    });
                });
                isApproved && setIsApprovedOrgMember(isApproved);
            }
        };
        validateDomain();
    }, [
        userId,
        isLicensed,
        cloudId,
        experienceTracker,
        isExternalShareRequest
    ]);
    if (!userId) return {
        userType: (0, $k3pHv.UserTypes).ANONYMOUS
    };
    if (isLicensed) return {
        userType: (0, $k3pHv.UserTypes).CONFLUENCE_USER
    };
    return {
        userType: isApprovedOrgMember ? (0, $k3pHv.UserTypes).ORG_MEMBER : (0, $k3pHv.UserTypes).ATLASSIAN_USER
    };
};



var $gXrHX = parcelRequire("gXrHX");

const $a5952995c9c756c1$export$355d4724e049b0df = ({ children: children, path: path, shareToken: shareToken })=>{
    const isExternalShareRequest = !!(0, $1NBp8.EXTERNAL_SHARE).match(path);
    const isAccessLinkRequest = !!(0, $1NBp8.ACCESS_LINK).match(path) && (0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false);
    const { userType: userType } = (0, $b7aff31f4e633d8f$export$435bbe3b3c44f9d8)(isExternalShareRequest || isAccessLinkRequest);
    // Extract shareToken from path if it's an external share request
    const extractedShareToken = (0, $42omo.useMemo)(()=>{
        if (isExternalShareRequest) {
            const match = (0, $1NBp8.EXTERNAL_SHARE).match(path);
            return match?.params?.externalToken || undefined;
        } else if (isAccessLinkRequest) {
            const match = (0, $1NBp8.ACCESS_LINK).match(path);
            return match?.params?.shareToken || undefined;
        }
        return undefined;
    }, [
        isExternalShareRequest,
        path,
        isAccessLinkRequest
    ]);
    // Use provided shareToken if available, otherwise use extracted one
    const resolvedShareToken = shareToken || extractedShareToken;
    const externalShareContextValue = (0, $42omo.useMemo)(()=>({
            isExternalShareRequest: isExternalShareRequest || isAccessLinkRequest,
            userType: userType,
            shareToken: resolvedShareToken,
            isAccessLinkRequest: isAccessLinkRequest
        }), [
        isExternalShareRequest,
        userType,
        resolvedShareToken,
        isAccessLinkRequest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gXrHX.ExternalShareContext).Provider, {
        value: externalShareContextValue
    }, children);
};
module.exports["ExternalShareContextProvider"] = $a5952995c9c756c1$export$355d4724e049b0df;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("dTt0t", function(module, exports) {

let $a1d6e98377bd5bbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a1d6e98377bd5bbe$var$load("8k5W1").then(()=>parcelRequire('42H7Z'));

});

parcelRegister("6UYek", function(module, exports) {

var $fbcPJ = parcelRequire("fbcPJ");


var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $fD0Uz = parcelRequire("fD0Uz");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $1xpoY = parcelRequire("1xpoY");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$var$getLegacyApolloError = (error)=>{
    if (!('errors' in error) || !Array.isArray(error.errors)) return undefined;
    const firstError = error.errors[0];
    return firstError && typeof firstError === 'object' ? firstError : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorMessage = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('message' in firstError)) return undefined;
    return typeof firstError.message === 'string' ? firstError.message : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('extensions' in firstError)) return undefined;
    const { extensions: extensions } = firstError;
    if (!extensions || typeof extensions !== 'object' || !('statusCode' in extensions)) return undefined;
    return typeof extensions.statusCode === 'number' ? extensions.statusCode : undefined;
};
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = (subscribers[delta] ?? []).filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            const subscribersForDelta = subscribers[delta];
            if (subscribersForDelta) subscribersForDelta.forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $fbcPJ.default), {
        variables: {
            id: id,
            __extensions: extensions
        },
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(data ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/graphql"
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || $da160e8fa3112de6$var$getLegacyApolloErrorMessage(error) || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode(error);
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            //
            // When graphql-subscriptions rate-limits us it returns an HTML page (eg a 429),
            // which graphql-ws feeds into JSON.parse and throws a SyntaxError. In V8 the
            // thrown message embeds the offending token, eg:
            //   Unexpected token '<', "<!DOCTYPE "... is not valid JSON
            // We match on the HTML markers rather than the generic "Unexpected token" so we
            // only suppress HTML payloads and not unrelated malformed-JSON bugs.
            const isHtmlRateLimitError = (0, $1xpoY.default).getBoolean('confluence_html_error_catching', false) && Boolean(errorMessage && /Unexpected token '<'|<!DOCTYPE|<html/.test(errorMessage));
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage || isHtmlRateLimitError;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("fbcPJ", function(module, exports) {
/**
 * @generated SignedSource<<c3d204b8cdf61b7b48be93a59878a242>>
 * @relayHash ea2b205ca41661c4d9e75a2c80bfd1c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1544e91e1f726342c809416076aa298d38dd5af242cabac4b6c9a623bc409d20
const $31174e902ea6e4b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "version"
    }, v6 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v7 = [
        v4 /*: any*/ ,
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v10 = [
        v9 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "confVersion"
    }, v12 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "inlineCommentType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "adfBodyContent"
    }, v15 = {
        "kind": "ScalarField",
        "name": "markerRef"
    }, v16 = {
        "kind": "ScalarField",
        "name": "publishVersionNumber"
    }, v17 = {
        "kind": "ScalarField",
        "name": "from"
    }, v18 = {
        "kind": "ScalarField",
        "name": "to"
    }, v19 = {
        "kind": "ScalarField",
        "name": "pos"
    }, v20 = {
        "kind": "ScalarField",
        "name": "annotationType"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v3 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "replies"
    }, v23 = {
        "kind": "ScalarField",
        "name": "pageCommentType"
    }, v24 = [
        v3 /*: any*/ ,
        v12 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "emojiId"
    }, v26 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceContentModified",
            "kind": "LinkedField",
            "name": "confluence_onContentModified",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "_deltas"
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "contentStateUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "emojiTitleUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "pageTitlePropertyUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "coverPictureDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "emojiTitleDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "contentStateDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCoverPictureWidthUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureWidthUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "coverPictureWidth"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageBlogified",
                    "kind": "LinkedField",
                    "name": "pageBlogified",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "spaceName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blogTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "converterDisplayName"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceEmbedUpdated",
                    "kind": "LinkedField",
                    "name": "embedUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isBlankStateUpdate"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageMigrated",
                    "kind": "LinkedField",
                    "name": "pageMigrated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fabricEligibility"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentRestrictionUpdated",
                    "kind": "LinkedField",
                    "name": "contentRestrictionUpdated",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluencePageMoved",
                    "kind": "LinkedField",
                    "name": "pageMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldParentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldPosition"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceAlias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceAlias"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageUpdated",
                    "kind": "LinkedField",
                    "name": "pageUpdated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "trigger"
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceWorkflowApplicationChanged",
                    "kind": "LinkedField",
                    "name": "workflowApplicationChanged",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "changeType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newWorkflowStatusId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        v5 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceMarkdownModeUpdated",
                    "kind": "LinkedField",
                    "name": "markdownModeUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isMarkdownMode"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentUpdatedWithTemplate",
                    "kind": "LinkedField",
                    "name": "contentUpdatedWithTemplate",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "inlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceRendererInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "rendererInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "editorInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUpdated",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentDeleted",
                    "kind": "LinkedField",
                    "name": "inlineCommentDeleted",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentResolved",
                    "kind": "LinkedField",
                    "name": "inlineCommentResolved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentResolveProperties",
                            "kind": "LinkedField",
                            "name": "inlineResolveProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolved"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedByDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedFriendlyDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedUser"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "inlineText"
                        },
                        v15 /*: any*/ ,
                        v22 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUnresolved",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentReattached",
                    "kind": "LinkedField",
                    "name": "inlineCommentReattached",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentUpdated",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentResolved",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentReopened",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceSchedulePublished",
                    "kind": "LinkedField",
                    "name": "schedulePublished",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "publishTime"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventType"
                        },
                        v11 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentAccessRequested",
                    "kind": "LinkedField",
                    "name": "contentAccessRequested",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentAccessDecisionMade",
                    "kind": "LinkedField",
                    "name": "contentAccessDecisionMade",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "decision"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionAdded",
                    "kind": "LinkedField",
                    "name": "inlineReactionAdded",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "newHighlight"
                        },
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "stepType"
                                }
                            ]
                        },
                        v16 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionRemoved",
                    "kind": "LinkedField",
                    "name": "inlineReactionRemoved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionHighlightDeleted",
                    "kind": "LinkedField",
                    "name": "inlineReactionHighlightDeleted",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ 
        },
        "params": {
            "cacheID": "ea2b205ca41661c4d9e75a2c80bfd1c5",
            "id": "1544e91e1f726342c809416076aa298d38dd5af242cabac4b6c9a623bc409d20",
            "metadata": {},
            "name": "SubscriptionsContextProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},markdownModeUpdated{isMarkdownMode,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename},inlineReactionAdded{commentId,markerRef,emojiId,newHighlight,step{from,to,pos,mark{attrs{annotationType,id},type},stepType},publishVersionNumber,__typename},inlineReactionRemoved{commentId,markerRef,emojiId,__typename},inlineReactionHighlightDeleted{commentId,markerRef,__typename}}}"
        }
    };
}();
$31174e902ea6e4b2$var$node.hash = "efc034f232cec513c997752add52e641";
var $31174e902ea6e4b2$export$2e2bcd8739ae039 = $31174e902ea6e4b2$var$node;
module.exports["default"] = $31174e902ea6e4b2$export$2e2bcd8739ae039;

});

parcelRegister("fD0Uz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7hXu9 = parcelRequire("7hXu9");


var $irOoi = parcelRequire("irOoi");


var $3e6Uc = parcelRequire("3e6Uc");


var $iffSy = parcelRequire("iffSy");


var $422HI = parcelRequire("422HI");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

const $c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode = (subscription)=>typeof subscription === 'function' || subscription.kind !== 'Document';
const $c7f06d7e4ea271ae$var$isFormattedExecutionResult = (response)=>Boolean(response && typeof response === 'object' && ('data' in response || 'errors' in response));
const $c7f06d7e4ea271ae$var$isSubscriptionData = (response)=>!$c7f06d7e4ea271ae$var$isFormattedExecutionResult(response);
const $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions = (response)=>{
    if (response == null) return {
        data: undefined,
        extensions: undefined
    };
    if ($c7f06d7e4ea271ae$var$isSubscriptionData(response)) return {
        data: response,
        extensions: undefined
    };
    return {
        data: response.data ?? undefined,
        extensions: response.extensions
    };
};
const $c7f06d7e4ea271ae$export$4966ff7f324f6363 = (response)=>{
    const { data: data, extensions: extensions } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
    return {
        ...extensions ? {
            extensions: extensions
        } : {},
        subscriptionData: {
            data: data,
            loading: false,
            ...extensions ? {
                extensions: extensions
            } : {}
        }
    };
};
const $c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment = ()=>{
    const isProduction = true;
    const isCloudProduction = true;
    const isCloudStaging = false;
    if (isProduction || isCloudProduction || isCloudStaging) return false;
    const isTest = false;
    const isDevelopment = false;
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    return isTest || isDevelopment || isLocalhost;
};
const $c7f06d7e4ea271ae$export$1bed67b955596e29 = (forceRelay)=>{
    if (!$c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment()) return false;
    window.__TEST_ONLY_FORCE_RELAY_MODE__ = forceRelay;
    return true;
};
function $c7f06d7e4ea271ae$export$275462b87cef6610(subscription, options) {
    const forceRelayMode = window.__TEST_ONLY_FORCE_RELAY_MODE__;
    const shouldUseRelay = forceRelayMode || (0, $iffSy.isRelayEnabled)(options?.__callerPackage__);
    if (shouldUseRelay) {
        if (!$c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode(subscription)) throw new Error('[Relay migration] useSubscriptionInterop Relay mode requires graphql tag');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options);
    } else {
        const { interopApolloAggClient: interopApolloAggClient, extensions: extensions, ...apolloOptions } = options ?? {};
        // Apollo v2's `useSubscription` does not forward a per-call `context` option down
        // to the WebSocket link, so we smuggle `extensions` through `variables.__extensions`.
        // `AttachExtensionsLink` strips it back out and re-attaches it to the operation
        // context, which `GraphQLWSLink.request` then sets on the wire payload.
        const variables = extensions !== undefined ? {
            ...apolloOptions.variables,
            __extensions: extensions
        } : apolloOptions.variables;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $7hXu9.useSubscription)((0, $86okN.toDocumentNode)(subscription), {
            ...apolloOptions,
            variables: variables,
            ...interopApolloAggClient ? {
                client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
            } : {}
        });
    }
}
const $c7f06d7e4ea271ae$var$toApolloErrorInterop = (error)=>new (0, $422HI.ApolloErrorInterop)({
        networkError: error instanceof Error ? error : new Error(String(error))
    });
function $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options) {
    const environment = (0, $irOoi.useRelayEnvironment)();
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [loading, setLoading] = (0, $42omo.useState)(!options?.skip);
    const disposableRef = (0, $42omo.useRef)(null);
    const callbacksRef = (0, $42omo.useRef)(options);
    callbacksRef.current = options;
    const skip = options?.skip;
    const variables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__);
    const extensions = (0, $iF5wn.useMemoObj)(options?.extensions, options?.__callerPackage__);
    (0, $42omo.useEffect)(()=>{
        if (skip) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(undefined);
        setData(undefined);
        try {
            disposableRef.current = (0, $3e6Uc.requestSubscription)(environment, {
                subscription: subscription,
                variables: variables,
                // `RelayWebSocketSubscriptionHandler` reads `cacheConfig.metadata.extensions`
                // and attaches them to the WS payload's `extensions` field.
                // cacheConfig is always set because useMemoObj coerces undefined → {}, so any
                // guard on `extensions` would always evaluate the same way. The consumer
                // (RelayWebSocketSubscriptionHandler) ignores an empty extensions object.
                cacheConfig: {
                    metadata: {
                        extensions: extensions
                    }
                },
                onNext: (response)=>{
                    const { data: responseData } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
                    setData(responseData);
                    setError(undefined);
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionData?.($c7f06d7e4ea271ae$export$4966ff7f324f6363(response));
                },
                onError: (err_0)=>{
                    setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err_0));
                    setLoading(false);
                },
                onCompleted: ()=>{
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionComplete?.();
                }
            });
        } catch (err) {
            setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err));
            setLoading(false);
        }
        return ()=>{
            if (!disposableRef.current) return;
            disposableRef.current.dispose();
            disposableRef.current = null;
        };
    }, [
        environment,
        subscription,
        variables,
        extensions,
        skip
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSubscriptionInterop"] = $c7f06d7e4ea271ae$export$275462b87cef6610;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("1BZTM", function(module, exports) {

let $12c942f289404064$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $12c942f289404064$var$load("kY5BF").then(()=>parcelRequire('fUwgh'));

});

parcelRegister("kE2cJ", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");



parcelRequire("gSgn8");


var $9wGTI = parcelRequire("9wGTI");


var $7zgzO = parcelRequire("7zgzO");

const $14c2681824cc07d8$export$7b9b5b70059a466b = ({ href: href = null, name: name, params: params, to: to = null, usePush: usePush = false, forceReload: forceReload = false, reason: reason, skipRouteChange: skipRouteChange = false, excludedQueryParams: excludedQueryParams })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams, getHref: getHref, matchRoute: matchRoute } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const getUrl = ()=>{
        const customPath = href || to;
        let parsedUrl = {};
        if (customPath) parsedUrl = (0, $jiJCD.parse)(customPath, true);
        const currentQuery = getQueryParams();
        if (excludedQueryParams && (0, $9wGTI.fg)('confluence_frontend_excluded_query_params_redirect')) excludedQueryParams.forEach((param)=>{
            delete currentQuery[param];
        });
        return toUrl(name, {
            hash: getHash(),
            query: currentQuery,
            ...params,
            ...parsedUrl
        });
    };
    (0, $42omo.useEffect)(()=>{
        const oldRoute = matchRoute(getHref());
        const oldRouteName = oldRoute?.name || null;
        const getAnalyticsAttributes = ({ newRouteName: newRouteName })=>({
                oldRouteName: oldRouteName,
                newRouteName: newRouteName,
                // It is safe to fire an event with the names of the route params because they are not UGC.
                // They are part of our route definitions. In contrast, the values of the route params are UGC.
                // Additionally, both the names and values of the route query params are UGC because they are
                // read directly from the URL without matching against our route definitions.
                oldRouteParamNames: Object.keys(oldRoute?.params || {}),
                newRouteParamNames: Object.keys(params || {}),
                // Space key related attributes.
                isOldRouteSpaceKeyDefined: !!oldRoute?.params?.spaceKey,
                isNewRouteSpaceKeyDefined: !!params?.spaceKey,
                areSpaceKeysEqual: oldRoute?.params?.spaceKey === params?.spaceKey,
                areSpaceKeysEqualLowercase: oldRoute?.params?.spaceKey?.toLowerCase() === params?.spaceKey?.toLowerCase()
            });
        const doRedirect = ()=>{
            // Reset the delayed content redirection object to avoid unnecessary redirects
            window['__DELAYED_CONTENT_REDIRECTION__'] = {};
            const gottenUrl = getUrl();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'redirect',
                    actionSubject: oldRouteName,
                    actionSubjectId: name || matchRoute(gottenUrl)?.name,
                    source: oldRouteName
                }
            }).fire();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirect',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: getAnalyticsAttributes({
                        newRouteName: name || matchRoute(gottenUrl)?.name
                    })
                }
            }).fire();
            // Skip route change by only rewrite URL
            if (skipRouteChange) try {
                window.history.replaceState({}, '', gottenUrl);
                return;
            } catch  {
            // If replaceState failed, then run the redirect normally
            }
            (usePush ? push : replace)(gottenUrl, forceReload);
        };
        try {
            doRedirect();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirectFailed',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: {
                        ...getAnalyticsAttributes({
                            newRouteName: name
                        }),
                        errorMessage: error?.message
                    }
                }
            }).fire();
            throw error;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["Redirection"] = $14c2681824cc07d8$export$7b9b5b70059a466b;

});

parcelRegister("3JgB7", function(module, exports) {

let $2b7273002326465f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b7273002326465f$var$load("5zLU3").then(()=>parcelRequire('6nGVD'));

});

parcelRegister("9RxHT", function(module, exports) {

let $72e335c8ec12e3d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72e335c8ec12e3d2$var$load("9dZCH").then(()=>parcelRequire('ghOyy'));

});

parcelRegister("5gmpn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f6b55c9cc88888b7$export$93af822566053b3e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "GCw5R",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'MainLayout',
    loader: async ()=>(await (parcelRequire("lPNUo"))).MainLayout
});
module.exports["MainLayout"] = $f6b55c9cc88888b7$export$93af822566053b3e;

});

parcelRegister("lPNUo", function(module, exports) {

let $fe55133684e6c4e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fe55133684e6c4e5$var$load("4GE9S").then(()=>parcelRequire('cmkWO'));

});

parcelRegister("6pwLK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5vi32 = parcelRequire("5vi32");


var $lJlG6 = parcelRequire("lJlG6");


var $jxpvN = parcelRequire("jxpvN");

const $f91eb48475fb1f4e$export$fce08d0d9d687787 = ({ includeTopNav: includeTopNav, children: children })=>{
    const { includeTopNav: inheritedOrDefaultValue } = (0, $42omo.useContext)((0, $jxpvN.BannerContext));
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    if (typeof includeTopNav !== 'boolean') includeTopNav = isEmbeddedConfluence || isMobileApp ? false : inheritedOrDefaultValue;
    const bannerContextValue = (0, $42omo.useMemo)(()=>({
            includeTopNav: includeTopNav
        }), [
        includeTopNav
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jxpvN.BannerContext).Provider, {
        value: bannerContextValue
    }, children);
};
module.exports["BannerContextProvider"] = $f91eb48475fb1f4e$export$fce08d0d9d687787;

});

parcelRegister("jxpvN", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $42omo.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("djZz9", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $38a3bf8a14810337$export$de3a38bd9f6fbd0c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JEntR",
    name: "SpaceOverviewLoader",
    loader: async ()=>(await (parcelRequire("aGtBg"))).SpaceOverview
});

const $38a3bf8a14810337$export$5c3607a122f4ef5a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "AGreW",
    name: "SpaceOverviewSwitcherLoader",
    loader: async ()=>(await (parcelRequire("1KH6t"))).SpaceOverviewSwitcher
});
module.exports["SpaceOverviewLoader"] = $38a3bf8a14810337$export$de3a38bd9f6fbd0c;
module.exports["SpaceOverviewSwitcherLoader"] = $38a3bf8a14810337$export$5c3607a122f4ef5a;

});

parcelRegister("aGtBg", function(module, exports) {

let $7c74c9986c244e47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7c74c9986c244e47$var$load("h3ABO"),
    $7c74c9986c244e47$var$load("i6s2m"),
    $7c74c9986c244e47$var$load("bNW8r"),
    $7c74c9986c244e47$var$load("jDHDy"),
    $7c74c9986c244e47$var$load("4oONP"),
    $7c74c9986c244e47$var$load("evm5a"),
    $7c74c9986c244e47$var$load("35X59"),
    $7c74c9986c244e47$var$load("2F69B"),
    $7c74c9986c244e47$var$load("72caV"),
    $7c74c9986c244e47$var$load("fAtWn"),
    $7c74c9986c244e47$var$load("iPYAE"),
    $7c74c9986c244e47$var$load("5lTVp"),
    $7c74c9986c244e47$var$load("lWNY8"),
    $7c74c9986c244e47$var$load("5dkX4"),
    $7c74c9986c244e47$var$load("e2WH6"),
    $7c74c9986c244e47$var$load("hxmLu"),
    $7c74c9986c244e47$var$load("1oUEV"),
    $7c74c9986c244e47$var$load("a0cZb"),
    $7c74c9986c244e47$var$load("RXMWr"),
    $7c74c9986c244e47$var$load("jLwPS"),
    $7c74c9986c244e47$var$load("9IMTL"),
    $7c74c9986c244e47$var$load("b9CA3"),
    $7c74c9986c244e47$var$load("g0OKa"),
    $7c74c9986c244e47$var$load("c6DIp"),
    $7c74c9986c244e47$var$load("dgH7p"),
    $7c74c9986c244e47$var$load("coUzl"),
    $7c74c9986c244e47$var$load("5nMTY"),
    $7c74c9986c244e47$var$load("7j0mT"),
    $7c74c9986c244e47$var$load("69R9L"),
    $7c74c9986c244e47$var$load("hXbzh"),
    $7c74c9986c244e47$var$load("6wr18"),
    $7c74c9986c244e47$var$load("dwSiO"),
    $7c74c9986c244e47$var$load("evP3v"),
    $7c74c9986c244e47$var$load("HaNwW"),
    $7c74c9986c244e47$var$load("cmqxT"),
    $7c74c9986c244e47$var$load("ZBVfs"),
    $7c74c9986c244e47$var$load("4oXMS"),
    $7c74c9986c244e47$var$load("67Alm"),
    $7c74c9986c244e47$var$load("2B2rM"),
    $7c74c9986c244e47$var$load("9anPW"),
    $7c74c9986c244e47$var$load("cyGuT"),
    $7c74c9986c244e47$var$load("9DBoM"),
    $7c74c9986c244e47$var$load("jPuvo"),
    $7c74c9986c244e47$var$load("ffEVr"),
    $7c74c9986c244e47$var$load("zSp86"),
    $7c74c9986c244e47$var$load("Wowvf"),
    $7c74c9986c244e47$var$load("1F7LX"),
    $7c74c9986c244e47$var$load("foAs3"),
    $7c74c9986c244e47$var$load("hhss7"),
    $7c74c9986c244e47$var$load("7EorR"),
    $7c74c9986c244e47$var$load("1gUNx"),
    $7c74c9986c244e47$var$load("eiF7i"),
    $7c74c9986c244e47$var$load("h94bv"),
    $7c74c9986c244e47$var$load("e66P8")
]).then(()=>parcelRequire('eiWUW'));

});

parcelRegister("1KH6t", function(module, exports) {

let $146b85c4b091efb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $146b85c4b091efb0$var$load("2YffH"),
    $146b85c4b091efb0$var$load("gufL1"),
    $146b85c4b091efb0$var$load("kQSfw"),
    $146b85c4b091efb0$var$load("8PzH3"),
    $146b85c4b091efb0$var$load("h3ABO"),
    $146b85c4b091efb0$var$load("i6s2m"),
    $146b85c4b091efb0$var$load("bNW8r"),
    $146b85c4b091efb0$var$load("jDHDy"),
    $146b85c4b091efb0$var$load("4oONP"),
    $146b85c4b091efb0$var$load("evm5a"),
    $146b85c4b091efb0$var$load("35X59"),
    $146b85c4b091efb0$var$load("2F69B"),
    $146b85c4b091efb0$var$load("72caV"),
    $146b85c4b091efb0$var$load("fAtWn"),
    $146b85c4b091efb0$var$load("iPYAE"),
    $146b85c4b091efb0$var$load("5lTVp"),
    $146b85c4b091efb0$var$load("lWNY8"),
    $146b85c4b091efb0$var$load("5dkX4"),
    $146b85c4b091efb0$var$load("e2WH6"),
    $146b85c4b091efb0$var$load("hxmLu"),
    $146b85c4b091efb0$var$load("1oUEV"),
    $146b85c4b091efb0$var$load("a0cZb"),
    $146b85c4b091efb0$var$load("RXMWr"),
    $146b85c4b091efb0$var$load("jLwPS"),
    $146b85c4b091efb0$var$load("9IMTL"),
    $146b85c4b091efb0$var$load("b9CA3"),
    $146b85c4b091efb0$var$load("g0OKa"),
    $146b85c4b091efb0$var$load("c6DIp"),
    $146b85c4b091efb0$var$load("dgH7p"),
    $146b85c4b091efb0$var$load("coUzl"),
    $146b85c4b091efb0$var$load("5nMTY"),
    $146b85c4b091efb0$var$load("7j0mT"),
    $146b85c4b091efb0$var$load("69R9L"),
    $146b85c4b091efb0$var$load("hXbzh"),
    $146b85c4b091efb0$var$load("6wr18"),
    $146b85c4b091efb0$var$load("dwSiO"),
    $146b85c4b091efb0$var$load("evP3v"),
    $146b85c4b091efb0$var$load("HaNwW"),
    $146b85c4b091efb0$var$load("cmqxT"),
    $146b85c4b091efb0$var$load("ZBVfs"),
    $146b85c4b091efb0$var$load("4oXMS"),
    $146b85c4b091efb0$var$load("67Alm"),
    $146b85c4b091efb0$var$load("2B2rM"),
    $146b85c4b091efb0$var$load("9anPW"),
    $146b85c4b091efb0$var$load("cyGuT"),
    $146b85c4b091efb0$var$load("9DBoM"),
    $146b85c4b091efb0$var$load("jPuvo"),
    $146b85c4b091efb0$var$load("ffEVr"),
    $146b85c4b091efb0$var$load("zSp86"),
    $146b85c4b091efb0$var$load("Wowvf"),
    $146b85c4b091efb0$var$load("1F7LX"),
    $146b85c4b091efb0$var$load("foAs3"),
    $146b85c4b091efb0$var$load("hhss7"),
    $146b85c4b091efb0$var$load("7EorR"),
    $146b85c4b091efb0$var$load("1gUNx"),
    $146b85c4b091efb0$var$load("eiF7i"),
    $146b85c4b091efb0$var$load("h94bv"),
    $146b85c4b091efb0$var$load("e66P8"),
    $146b85c4b091efb0$var$load("7J0Jt")
]).then(()=>parcelRequire('2m4WS'));

});

parcelRegister("iqPBi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $2daQU = parcelRequire("2daQU");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $dPJCf = parcelRequire("dPJCf");


var $1ytiN = parcelRequire("1ytiN");


var $fM6x5 = parcelRequire("fM6x5");


var $cEgMD = parcelRequire("cEgMD");


var $8oCjN = parcelRequire("8oCjN");


var $4b4iP = parcelRequire("4b4iP");


var $j9XVO = parcelRequire("j9XVO");

const $023f02fd9a9aead0$var$DISPLAY_ROOT = 'display';
const $023f02fd9a9aead0$var$SPACE_ROOT = 'spaces';
const $023f02fd9a9aead0$var$getUrlRoot = (pathname)=>{
    if (!pathname) return undefined;
    if (pathname.includes(`/${$023f02fd9a9aead0$var$SPACE_ROOT}/`)) return $023f02fd9a9aead0$var$SPACE_ROOT;
    else if (pathname.includes(`/${$023f02fd9a9aead0$var$DISPLAY_ROOT}/`)) return $023f02fd9a9aead0$var$DISPLAY_ROOT;
    else return undefined;
};
const $023f02fd9a9aead0$var$useContentSlug = (0, $dPJCf.createRouteParamHook)('contentSlug');
const $023f02fd9a9aead0$var$useContentId = (0, $dPJCf.createRouteParamHook)('contentId');
const $023f02fd9a9aead0$var$LegacySpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAnonymous: isAnonymous } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const history = (0, $dPJCf.useHistory)();
    const isFirstRoute = history?.length === 1;
    const location = (0, $QU6QS.useLocation)();
    const fixSpaceEncodingInSpaceKey = ()=>{
        const pathname = location?.pathname || '';
        const decodedPathname = decodeURIComponent(pathname);
        if (// excludes the cases where there are no + symbols to replace at all
        // eg: /spaces/perfectly-fine-space-key
        pathname.indexOf('+') !== -1 && // excludes the cases where there is a + that follows the space key portion of the path
        // eg: /spaces/DS/other+stuff+that+contains+plus
        spaceKey.indexOf('+') !== -1 && // excludes the cases where the decoded path name still contains a + (from %2B)
        // , but the replacement to strip the + from the space key has already happened in previous SPA transition
        // eg: pathname = '/spaces/space%2Bkey', decodedPathname = '/spaces/space+key', spaceKey = 'space+key'
        decodedPathname.indexOf(`spaces/${spaceKey}`) !== -1) history?.replace?.({
            ...location,
            // Ensure we are replacing the "+" in the space key not other funny stuff
            pathname: decodedPathname.replace(`spaces/${spaceKey}`, `spaces/${spaceKey}`.replace(/\+/g, ' '))
        });
    };
    const removeEmailQueryParameters = ()=>{
        if (!location?.search?.includes('src=mail') && !location?.search?.includes('src.mail.')) return;
        let search = location?.search?.substring(1);
        const params = search.split('&').filter((param)=>!param.includes('src=mail') && !param.startsWith('src.mail.'));
        search = `?${params.join('&')}`;
        history?.replace?.({
            ...location,
            search: search
        });
    };
    (0, $42omo.useEffect)(()=>{
        fixSpaceEncodingInSpaceKey();
        removeEmailQueryParameters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isSpaceLoading) return;
        if (space && space.alias && space.alias !== spaceKey) {
            const pathnameRoot = $023f02fd9a9aead0$var$getUrlRoot(location?.pathname);
            if (pathnameRoot) {
                const routeName = routeDataRef.current?.routeName || null;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'redirect',
                        actionSubject: 'route',
                        source: 'SpaceBase',
                        attributes: {
                            routeName: routeName,
                            // Space key related attributes.
                            areSpaceKeysEqualLowercase: space?.alias?.toLowerCase() === spaceKey?.toLowerCase()
                        }
                    }
                }).fire();
                history?.replace?.({
                    ...location,
                    pathname: location?.pathname?.replace(`/${pathnameRoot}/${spaceKey}`, `/${pathnameRoot}/${space.alias}`)
                });
            }
            return;
        }
    }, [
        createAnalyticsEvent,
        history,
        location,
        space,
        spaceKey,
        routeDataRef,
        isSpaceLoading
    ]);
    /*
   * Removing SpaceBaseThemedComponent for the Company Hub app-like experience
   *
   * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
   * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
   */ const SpaceBaseWrapper = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) ? (0, $42omo.Fragment) : (0, $8oCjN.SpaceBaseThemedComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        isAnonymous: isAnonymous,
        contentId: contentId,
        isFirstRoute: isFirstRoute,
        goBackPreviousPage: history?.goBack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpaceBaseWrapper, null, children)));
};
const $023f02fd9a9aead0$var$SpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const { isAnonymous: isAnonymous } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    // We cannot use useRenderServerPlaceholder() here
    // because SpaceBaseComponent is invoked through withDocumentTitle's inline
    // function pattern, which breaks hooks during renderToString.
    // The !isTransition check ensures SPA navigations always take the SPA branch,
    // matching the pattern in useRenderServerPlaceholder.
    const isTransition = window.__SSR_RENDERED__ === false;
    const isSSROrHydrating = (0, $6mKj3.expVal)('confluence_hydration_with_document_title_fix', 'isEnabled', false) ? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined) || Boolean(window.__HYDRATABLE__) && !isTransition : // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined);
    if (isSSROrHydrating && (0, $6mKj3.expVal)('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        isAnonymous: isAnonymous,
        contentId: contentId,
        goBackPreviousPage: ()=>{}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, children));
    else if (isSSROrHydrating) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($023f02fd9a9aead0$var$LegacySpaceBaseComponent, {
        spaceKey: spaceKey,
        space: space,
        isSpaceLoading: isSpaceLoading
    }, children);
};
const $023f02fd9a9aead0$var$useSpaceKey = (0, $dPJCf.createRouteParamHook)('spaceKey');
const $023f02fd9a9aead0$export$adbf61121b32bd9b = ({ children: children, spaceKey: spaceKey })=>{
    const resolvedSpaceKey = $023f02fd9a9aead0$var$useSpaceKey() || spaceKey || '';
    const { space: space, loading: loading } = (0, $j9XVO.useSpaceBaseQuery)({
        resolvedSpaceKey: resolvedSpaceKey
    });
    return (0, $fM6x5.default)(()=>space?.name)($023f02fd9a9aead0$var$SpaceBaseComponent)({
        spaceKey: resolvedSpaceKey,
        space: space,
        children: children,
        isSpaceLoading: loading
    });
};
module.exports["SpaceBase"] = $023f02fd9a9aead0$export$adbf61121b32bd9b;

});

parcelRegister("fM6x5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6436abe84fc91b7d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $8EsbU = parcelRequire("8EsbU");


var $d5RCH = parcelRequire("d5RCH");

function $6436abe84fc91b7d$export$2e2bcd8739ae039(getTitle, wrapperStyle) {
    if (typeof wrapperStyle === 'undefined') wrapperStyle = {};
    return (BaseComponent)=>(props)=>{
            const title = getTitle(props);
            const siteTitle = (0, $8EsbU.getOverride)('site-title') || '';
            const titleDefinedOnWindow = window['__DOCUMENT_TITLE_TAG__'] || '';
            let titleProp;
            if (titleDefinedOnWindow) titleProp = titleDefinedOnWindow;
            else if (title && siteTitle) titleProp = `${title} - ${siteTitle}`;
            else titleProp = title || siteTitle;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                style: wrapperStyle,
                "data-testid": "with-document-title"
            }, !window['__SSR_RENDERED__'] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
                title: titleProp
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, props)));
        };
}

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("8oCjN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $lKNXy = parcelRequire("lKNXy");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $3Klda = parcelRequire("3Klda");


var $5ZqQS = parcelRequire("5ZqQS");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $fyPYm = parcelRequire("fyPYm");


var $eSlm6 = parcelRequire("eSlm6");

const $7bbee5da9ba28ec8$var$connectAddonContainerStyle = {
    position: 'relative'
};
const $7bbee5da9ba28ec8$var$connectAddonProps = {
    contentStyle: {
        width: '100%',
        textAlign: 'center',
        display: 'inline-block'
    },
    width: '100%',
    height: '100%'
};
const $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX = /^ac:(.*)__(.*)-remote-theme$/;
const $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7 = (themeKey)=>{
    const regexResult = $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX.exec(themeKey);
    return regexResult ? [
        regexResult[1],
        regexResult[2]
    ] : [
        null,
        null
    ];
};
const $7bbee5da9ba28ec8$export$7f576b861c4a75d4 = ({ children: children })=>{
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isBlogpost = contentType === 'blogpost';
    const isSpaceOverview = match?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
    const skipContentQuery = !contentId || !spaceKey || !isSpaceOverview || contentIdLoading;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const pageContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        context: {
            single: true
        },
        variables: {
            contentId: contentId ?? '',
            spaceKey: spaceKey,
            versionOverride: null,
            isSSR: isSSR,
            useNewContentTopper: true
        },
        skip: skipContentQuery || isBlogpost,
        __callerPackage__: "@confluence/space-base"
    });
    const blogContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        context: {
            single: true
        },
        variables: {
            contentId: contentId ?? '',
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: null,
            useNewContentTopper: true
        },
        skip: skipContentQuery || !isBlogpost,
        __callerPackage__: "@confluence/space-base"
    });
    const contentQueryResult = isBlogpost ? blogContentQueryResult : pageContentQueryResult;
    const themeKey = contentQueryResult?.data?.space?.theme?.themeKey;
    const routeOverrideEnabled = contentQueryResult?.data?.space?.settings?.routeOverrideEnabled;
    const [themeAddonKey, themeModuleKey] = $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7(themeKey ?? '');
    const skipOverrideQuery = !themeAddonKey || !themeModuleKey || !routeOverrideEnabled;
    const overrideQueryResult = (0, $eSlm6.useExperimentalThemeSpaceHomeOverrideQuery)({
        variables: {
            themeAddonKey: themeAddonKey,
            themeModuleKey: themeModuleKey,
            spaceKey: spaceKey || '',
            spaceHomePageId: contentId || ''
        },
        skip: skipOverrideQuery
    });
    const productCtx = overrideQueryResult.data?.experimentalThemeSpaceHomeOverride?.spaceHomeOverrideDescriptor?.productCtx;
    const productContext = (0, $42omo.useMemo)(()=>productCtx ? JSON.parse(productCtx) : undefined, [
        productCtx
    ]);
    if (contentQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(contentQueryResult.error, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(contentQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    }
    if (overrideQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(overrideQueryResult.error, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(overrideQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    }
    if (contentIdLoading) return null;
    if (skipContentQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    if (contentQueryResult.loading || !skipOverrideQuery && overrideQueryResult.loading) return null;
    if (skipOverrideQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    if (!contentQueryResult.data || !overrideQueryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    const { hasSpaceHomeOverride: hasSpaceHomeOverride, spaceHomeOverrideDescriptor: spaceHomeOverrideDescriptor } = overrideQueryResult.data.experimentalThemeSpaceHomeOverride;
    if (!hasSpaceHomeOverride || !spaceHomeOverrideDescriptor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    // Ensure required fields are present for ConnectAddonDescriptor
    if (!spaceHomeOverrideDescriptor.addon_key || !spaceHomeOverrideDescriptor.key || !spaceHomeOverrideDescriptor.url || !spaceHomeOverrideDescriptor.contextJwt || !spaceHomeOverrideDescriptor.structuredContext || !spaceHomeOverrideDescriptor.productCtx) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
    const descriptor = {
        addon_key: spaceHomeOverrideDescriptor.addon_key,
        key: spaceHomeOverrideDescriptor.key,
        url: spaceHomeOverrideDescriptor.url,
        contextJwt: spaceHomeOverrideDescriptor.contextJwt,
        structuredContext: spaceHomeOverrideDescriptor.structuredContext,
        productContext: productContext
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
        lookAndFeel: contentQueryResult?.data?.space?.lookAndFeel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lKNXy.ConnectAddon), {
        containerStyle: $7bbee5da9ba28ec8$var$connectAddonContainerStyle,
        descriptor: descriptor,
        ...$7bbee5da9ba28ec8$var$connectAddonProps
    }), isSpaceOverview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fyPYm.ContentViewedEvent), {
        contentId: contentId
    }));
};
module.exports["SpaceBaseThemedComponent"] = $7bbee5da9ba28ec8$export$7f576b861c4a75d4;

});

parcelRegister("lKNXy", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


const $d2cf06290ddd4b8d$export$1679e39403bb0c0c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rJ3Sr",
    loader: async ()=>(await (parcelRequire("9g7C6"))).ConnectAddon,
    name: 'ConnectAddonNext'
});
module.exports["ConnectAddon"] = $d2cf06290ddd4b8d$export$1679e39403bb0c0c;

});

parcelRegister("9g7C6", function(module, exports) {

let $6bdb8397d6d8ced9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6bdb8397d6d8ced9$var$load("Wowvf"),
    $6bdb8397d6d8ced9$var$load("6d83I")
]).then(()=>parcelRequire('2uezU'));

});

parcelRegister("3Klda", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");

const $2ba61f17a8768eba$var$screenLayerStyles = {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    height: 250
};
class $2ba61f17a8768eba$export$e0e5b47f08900b58 extends (0, $42omo.Component) {
    render() {
        const { lookAndFeel: lookAndFeel } = this.props;
        if (!lookAndFeel || !lookAndFeel.content) return null;
        const customScreenLayerStyles = lookAndFeel?.content?.screen?.layer || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "content-screen-background-layer",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...$2ba61f17a8768eba$var$screenLayerStyles,
                ...customScreenLayerStyles
            }
        });
    }
}
$2ba61f17a8768eba$export$e0e5b47f08900b58.propTypes = {
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
module.exports["ContentScreenBackgroundLayer"] = $2ba61f17a8768eba$export$e0e5b47f08900b58;

});

parcelRegister("fyPYm", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bavCP = parcelRequire("bavCP");


var $eyzLS = parcelRequire("eyzLS");

let $701bdc3764047e40$var$lastContentId;
const $701bdc3764047e40$export$cc2fc38458ee98cc = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId) {
        t1 = ()=>{
            $701bdc3764047e40$var$lastContentId = contentId;
        };
        t2 = [
            contentId
        ];
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[3] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = $701bdc3764047e40$var$lastContentId === contentId;
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: (0, $eyzLS.default),
            variables: t3,
            fetchPolicy: "network-only",
            skip: t4,
            __callerPackage__: "@confluence/content-body"
        }, $701bdc3764047e40$var$_temp);
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
function $701bdc3764047e40$var$_temp() {
    return null;
}
module.exports["ContentViewedEvent"] = $701bdc3764047e40$export$cc2fc38458ee98cc;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("eyzLS", function(module, exports) {
/**
 * @generated SignedSource<<b170f4062a7b22df5c789ae2263ec5d9>>
 * @relayHash 6b82c836e177933e272ade59efcd5b5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6442e1d626bb37ef4897bdc166747bc6f6f93f7d888574ea37d7d5521fde4b42
const $ac80f5dc8fd0c04e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "trigger",
                    "value": "viewed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentViewedEventQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentViewedEventQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "6b82c836e177933e272ade59efcd5b5c",
            "id": "6442e1d626bb37ef4897bdc166747bc6f6f93f7d888574ea37d7d5521fde4b42",
            "metadata": {},
            "name": "ContentViewedEventQuery",
            "operationKind": "query",
            "text": "query ContentViewedEventQuery($contentId:ID){content(id:$contentId,trigger:\"viewed\"){nodes{id}}}"
        }
    };
}();
$ac80f5dc8fd0c04e$var$node.hash = "d8b1d8e3bca16082db7c9284db04b505";
var $ac80f5dc8fd0c04e$export$2e2bcd8739ae039 = $ac80f5dc8fd0c04e$var$node;
module.exports["default"] = $ac80f5dc8fd0c04e$export$2e2bcd8739ae039;

});

parcelRegister("eSlm6", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $d5f5bff41df6d94f$export$aa603d43549e91b7 = ({ skip: skip, variables: variables })=>{
    const { themeAddonKey: themeAddonKey, themeModuleKey: themeModuleKey, spaceKey: spaceKey, spaceHomePageId: spaceHomePageId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: ()=>{
            if (!themeAddonKey || !themeModuleKey) // This will be handled by parseResponseOnError to return expected data when these keys are missing
            throw new Error('themeAddonKey and themeModuleKey are missing');
            return `/wiki/plugins/servlet/ac/${themeAddonKey}/${themeModuleKey}/?classifier=json&space.key=${spaceKey}&content.id=${spaceHomePageId}&content.type=page`;
        },
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnError: ()=>null,
        parseResult: (data)=>({
                experimentalThemeSpaceHomeOverride: {
                    hasSpaceHomeOverride: data !== null,
                    spaceHomeOverrideDescriptor: data
                }
            }),
        skip: skip,
        variables: variables
    });
};
module.exports["useExperimentalThemeSpaceHomeOverrideQuery"] = $d5f5bff41df6d94f$export$aa603d43549e91b7;

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $42omo.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("4b4iP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $67Foi = parcelRequire("67Foi");


var $eAduJ = parcelRequire("eAduJ");


var $fG32j = parcelRequire("fG32j");


var $aZfd8 = parcelRequire("aZfd8");

const $343989ced147f5e6$export$20a459334853e190 = ({ children: children, spaceKey: spaceKey, isAnonymous: isAnonymous = false, contentId: contentId, isFirstRoute: isFirstRoute = false, goBackPreviousPage: goBackPreviousPage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        spaceKey: spaceKey,
        contentId: contentId
    }, ({ isSpaceRestricted: isSpaceRestricted, isSpaceNotFound: isSpaceNotFound })=>{
        if (isSpaceRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eAduJ.RestrictedSpace), {
            goToPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute,
            contentId: contentId
        });
        if (isSpaceNotFound && !isAnonymous && !contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZfd8.Space404), {
            goBackPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            name: "spaceNotFoundScreen",
            id: spaceKey
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    });
};
module.exports["SpaceRestrictionHandler"] = $343989ced147f5e6$export$20a459334853e190;

});

parcelRegister("eAduJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0e8fee473144754c$export$5ef003f00c9525a1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wviAQ",
    name: "RestrictedSpace",
    loader: async ()=>(await (parcelRequire("5mqfa"))).RestrictedSpace
});
module.exports["RestrictedSpace"] = $0e8fee473144754c$export$5ef003f00c9525a1;

});

parcelRegister("5mqfa", function(module, exports) {

let $3e735d42f48956ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3e735d42f48956ec$var$load("daX4F"),
    $3e735d42f48956ec$var$load("7EorR"),
    $3e735d42f48956ec$var$load("hhss7"),
    $3e735d42f48956ec$var$load("2OcM6")
]).then(()=>parcelRequire('9at9H'));

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $frIzR.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "@confluence/restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "@confluence/restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("aZfd8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $wtSEP = parcelRequire("wtSEP");

const $c70a78199cd90f84$export$a506b89ee82dfeb8 = (props)=>{
    const { isFirstRoute: isFirstRoute, goBackPreviousPage: goBackPreviousPage } = props;
    const onClickGoPreviousLink = (e)=>{
        e.preventDefault();
        if (goBackPreviousPage) goBackPreviousPage();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), {
        secondaryButtonProps: {
            children: !isFirstRoute && goBackPreviousPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "space-404.text.go.back.previous.page",
                defaultMessage: "Go to previous page"
            }),
            onClick: onClickGoPreviousLink
        }
    });
};
$c70a78199cd90f84$export$a506b89ee82dfeb8.displayName = 'Space404';
module.exports["Space404"] = $c70a78199cd90f84$export$a506b89ee82dfeb8;

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("4uKhv"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("4uKhv", function(module, exports) {

let $345ddd434f7501d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $345ddd434f7501d9$var$load("9a2oY"),
    $345ddd434f7501d9$var$load("iMSgb"),
    $345ddd434f7501d9$var$load("7EorR"),
    $345ddd434f7501d9$var$load("hhss7"),
    $345ddd434f7501d9$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("j9XVO", function(module, exports) {

var $kiJuS = parcelRequire("kiJuS");


var $d3OVq = parcelRequire("d3OVq");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");

const $2278a3c3763ebfe6$export$f1cfc3b574a4d714 = (0, $d3OVq.default);
const $2278a3c3763ebfe6$export$9d574d064e4f4f51 = (0, $kiJuS.default);
const $2278a3c3763ebfe6$export$8eab19bcc4a0311d = ({ resolvedSpaceKey: resolvedSpaceKey })=>{
    const { data: spaceBaseQueryData, loading: spaceBaseQueryLoading, error: spaceBaseQueryError } = (0, $jMyy4.useQueryInterop)($2278a3c3763ebfe6$export$f1cfc3b574a4d714, {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        },
        __callerPackage__: "@confluence/space-base"
    });
    const { data: singleSpaceQueryData, loading: singleSpaceQueryLoading, error: singleSpaceQueryError } = (0, $jMyy4.useQueryInterop)($2278a3c3763ebfe6$export$9d574d064e4f4f51, {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || !(0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        },
        __callerPackage__: "@confluence/space-base"
    });
    let space, loading;
    if ((0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
        loading = singleSpaceQueryLoading;
        space = singleSpaceQueryError && !singleSpaceQueryLoading ? null : singleSpaceQueryData?.space;
    } else {
        loading = spaceBaseQueryLoading;
        space = spaceBaseQueryError && !spaceBaseQueryLoading ? null : spaceBaseQueryData?.spaces?.nodes?.[0];
    }
    return {
        space: space,
        loading: loading
    };
};
module.exports["useSpaceBaseQuery"] = $2278a3c3763ebfe6$export$8eab19bcc4a0311d;

});

parcelRegister("kiJuS", function(module, exports) {
/**
 * @generated SignedSource<<3ce11fe803ce3ee1884a6393aee1a87e>>
 * @relayHash c65404aa4339865deb33b960b63ac1fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e03d29f1801373ff6e80b3bfcf7c8bfe26a96bb6370f9f8c083d9d51a7a1a366
const $667a49a7f0668b30$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c65404aa4339865deb33b960b63ac1fb",
            "id": "e03d29f1801373ff6e80b3bfcf7c8bfe26a96bb6370f9f8c083d9d51a7a1a366",
            "metadata": {},
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "operationKind": "query",
            "text": "query useSpaceBaseQuerySingleSpaceQuery($spaceKey:String){space(key:$spaceKey){id,key,name,alias}}"
        }
    };
}();
$667a49a7f0668b30$var$node.hash = "0994a40a61365970e08e840dbdb433df";
var $667a49a7f0668b30$export$2e2bcd8739ae039 = $667a49a7f0668b30$var$node;
module.exports["default"] = $667a49a7f0668b30$export$2e2bcd8739ae039;

});

parcelRegister("hz81G", function(module, exports) {

let $cc9bee5fb7c73b84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc9bee5fb7c73b84$var$load("fp9cm").then(()=>parcelRequire('9ehFI'));

});

parcelRegister("eeExv", function(module, exports) {

let $a5d1d1c1090bbe7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a5d1d1c1090bbe7b$var$load("hOaAV"),
    $a5d1d1c1090bbe7b$var$load("lFAez"),
    $a5d1d1c1090bbe7b$var$load("1qlDN"),
    $a5d1d1c1090bbe7b$var$load("1yVM6"),
    $a5d1d1c1090bbe7b$var$load("cEqm7"),
    $a5d1d1c1090bbe7b$var$load("6XCf4"),
    $a5d1d1c1090bbe7b$var$load("22Xly")
]).then(()=>parcelRequire('kQJNb'));

});

parcelRegister("8NC5Z", function(module, exports) {

var $896gY = parcelRequire("896gY");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $896gY.default), {
        skip: shouldSkip,
        __callerPackage__: "@confluence/company-hub-utils"
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements?.companyHub?.isEntitled;
};
module.exports["useCompanyHubPremiumGate"] = $1de3a5511529eed3$export$f032b5e8b485da1d;

});

parcelRegister("896gY", function(module, exports) {
/**
 * @generated SignedSource<<0bf45832ece12ce1024ca4a87950d3ec>>
 * @relayHash c31aa70a9a01e2207eb48c0b9be8b493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6
const $983e77d68212dc57$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CompanyHubFeature",
                    "kind": "LinkedField",
                    "name": "companyHub",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c31aa70a9a01e2207eb48c0b9be8b493",
            "id": "46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6",
            "metadata": {},
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "operationKind": "query",
            "text": "query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}"
        }
    };
}();
$983e77d68212dc57$var$node.hash = "a5508e7e7123c5675909c4f9214a5be2";
var $983e77d68212dc57$export$2e2bcd8739ae039 = $983e77d68212dc57$var$node;
module.exports["default"] = $983e77d68212dc57$export$2e2bcd8739ae039;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("7CeAz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $8NC5Z = parcelRequire("8NC5Z");

const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled
    };
};
module.exports["useIsCompanyHubEnabled"] = $16ea73778f65e8da$export$1d4394ae12760637;

});

parcelRegister("eqNP8", function(module, exports) {
/* FullPageLoadingScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $94835ea6111c7010$var$zIndexBlanket = 500; // layers.blanket()
const $94835ea6111c7010$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _154i1ssb _1ltv1ssb _t9ec1ooe _1pby1ap8",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v5641p41 _1pbybfng _4t3i1osq _1bsb1osq _kqsw1n9t _1ltvidpf _154iidpf _bfhkvuon _tzy47u59 _1lww1yx9",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$fe2b6579564feee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($94835ea6111c7010$export$7c6e2c02157bb7d2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: "full-page-loading-screen",
        size: 26
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($94835ea6111c7010$export$5b927fc1ef8c468b, null));
module.exports["FullPageLoadingScreen"] = $94835ea6111c7010$export$fe2b6579564feee;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("gi8UL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $422HI = parcelRequire("422HI");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $43e2h = parcelRequire("43e2h");


var $bZB1l = parcelRequire("bZB1l");


var $fg6th = parcelRequire("fg6th");


var $fbF8y = parcelRequire("fbF8y");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");

const $acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR = 'A space already exists';
const $acd2ea8b6650161b$export$66010d469140e6a6 = (error)=>{
    return !!error?.graphQLErrors?.some((error)=>{
        const isStatusCode400 = error.extensions?.statusCode === 400;
        const hasSimpleErrorMessage = error.message.includes($acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR);
        const hasNestedErrorMessage = error.extensions?.data?.errors?.every((err)=>err?.message?.translation?.includes($acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR));
        return isStatusCode400 && (hasSimpleErrorMessage || hasNestedErrorMessage);
    });
};
const $acd2ea8b6650161b$export$167bd8b1ca11153c = "User doesn't have permission to create system space";
const $acd2ea8b6650161b$export$ed3e7d674501852d = (error)=>$acd2ea8b6650161b$var$hasNestedApolloErrorMessage(error, $acd2ea8b6650161b$export$167bd8b1ca11153c);
const $acd2ea8b6650161b$var$hasNestedApolloErrorMessage = (error, errorMessage)=>{
    return error?.graphQLErrors?.[0]?.extensions?.data?.errors?.some((err)=>err?.message?.translation?.includes(errorMessage));
};
const $acd2ea8b6650161b$var$getErrorFlagConfig = (title, description, actions = [], id)=>({
        id: id,
        title: title,
        description: description,
        actions: actions
    });
const $acd2ea8b6650161b$var$showStalePermissionsErrorFlag = (flags)=>{
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagDescription,
        values: {
            a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                    target: "_blank"
                }, chunks)
        }
    });
    const actions = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagButton),
            onClick: ()=>window.location.reload()
        }
    ];
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, actions));
};
const $acd2ea8b6650161b$var$showUnauthorizedErrorFlag = (flags)=>{
    const id = 'create-system-space-permissions-failure';
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagDescription,
        values: {
            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }
    });
    const actions = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagButton),
            href: (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()
        }
    ];
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, actions, id));
};
const $acd2ea8b6650161b$var$showGenericErrorFlag = (flags)=>{
    const id = 'create-system-space-failure';
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceErrorFlagDescription);
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, [], id));
};
const $acd2ea8b6650161b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    createCompanyHubSpaceErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-error-flag-title",
        defaultMessage: "Something went wrong"
    },
    createCompanyHubSpaceErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-error-flag-description",
        defaultMessage: "Try again to continue setting up your landing page."
    },
    createCompanyHubSpacePermissionsErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-title",
        defaultMessage: "You need permission"
    },
    createCompanyHubSpacePermissionsErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-description",
        defaultMessage: "You need <b>Create space</b> permissions to create this hub."
    },
    createCompanyHubSpacePermissionsErrorFlagButton: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-button",
        defaultMessage: "Go to permissions"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-title",
        defaultMessage: "We couldn\u2019t create your hub"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-description",
        defaultMessage: "Only product admins can create and activate a <a>Company hub</a>"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagButton: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-button",
        defaultMessage: "Got it"
    }
});
async function $acd2ea8b6650161b$export$cb27704aaa7dfff2(flags) {
    const client = (0, $hp2SH.getApolloClient)();
    try {
        const hasHubSpace = await (0, $43e2h.checkIfCompanyHubSpaceExists)();
        if (!hasHubSpace) {
            const { data: data, errors: errors } = await (0, $6s78L.mutateInterop)({
                mutation: (0, $fg6th.default),
                variables: {
                    input: {
                        systemSpaceHomepageTemplate: (0, $bZB1l.SystemSpaceHomepageTemplate).EAP
                    }
                },
                update: (cache, { data: data })=>{
                    const companyHubName = data?.createSystemSpace?.name;
                    if (!companyHubName) return;
                    $acd2ea8b6650161b$var$updateSiteConfigurationCache(cache, companyHubName);
                },
                __callerPackage__: "@confluence/company-hub-utils"
            });
            if (errors?.length) throw new (0, $422HI.ApolloErrorInterop)({
                graphQLErrors: errors
            });
            if (data?.createSystemSpace?.id != null) $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
            return {
                didCreateSpace: true,
                homepageId: data?.createSystemSpace?.homepageId
            };
        }
        $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
        return {
            didCreateSpace: false,
            homepageId: undefined
        };
    } catch (error) {
        if ($acd2ea8b6650161b$export$66010d469140e6a6(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
            return {
                didCreateSpace: false,
                homepageId: undefined
            };
        }
        if (flags) {
            if ($acd2ea8b6650161b$export$ed3e7d674501852d(error)) $acd2ea8b6650161b$var$showStalePermissionsErrorFlag(flags);
            else if ((0, $1uFM6.isUnauthorizedError)(error)) $acd2ea8b6650161b$var$showUnauthorizedErrorFlag(flags);
            else $acd2ea8b6650161b$var$showGenericErrorFlag(flags);
        }
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        throw error;
    }
}
function $acd2ea8b6650161b$var$updateFrontCoverStateCache(cache) {
    $acd2ea8b6650161b$var$updateSiteConfigurationCache(cache, null, (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY);
}
function $acd2ea8b6650161b$var$updateSiteConfigurationCache(_cache, companyHubName, frontCoverState) {
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $fbF8y.default),
        data: {
            siteSettings: {
                // Codegen is specifically configured to not add __typename when generating the types file,
                // so unfortunately ts-ignore is required here.
                // @ts-ignore
                __typename: 'SiteSettings',
                ...companyHubName ? {
                    companyHubName: companyHubName
                } : {},
                ...frontCoverState ? {
                    frontCover: {
                        frontCoverState: frontCoverState,
                        // Codegen is specifically configured to not add __typename when generating the types file,
                        // so unfortunately ts-ignore is required here.
                        // @ts-ignore
                        __typename: 'FrontCover'
                    }
                } : {}
            }
        },
        __callerPackage__: "@confluence/company-hub-utils"
    });
}
module.exports["hasStalePermissionsErrorMessage"] = $acd2ea8b6650161b$export$ed3e7d674501852d;
module.exports["i18n"] = $acd2ea8b6650161b$export$a7357cdd1f0b0168;
module.exports["createCompanyHubSpace"] = $acd2ea8b6650161b$export$cb27704aaa7dfff2;

});

parcelRegister("43e2h", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $cEgMD = parcelRequire("cEgMD");


var $dSvuc = parcelRequire("dSvuc");


var $c0rhi = parcelRequire("c0rhi");

async function $efb8b6f89ca41072$export$bd1440de1c6279ff() {
    const key = (0, $cEgMD.getCompanyHubSpaceKey)();
    if (!key) throw new Error('Failed to get company hub space key');
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $dSvuc.CompanyHubSpaceQuery),
            variables: {
                key: key
            },
            __callerPackage__: "@confluence/company-hub-utils"
        });
        return !!data?.space?.id;
    } catch (error) {
        if (error?.message.includes('NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return false;
        } else throw error;
    }
}
module.exports["checkIfCompanyHubSpaceExists"] = $efb8b6f89ca41072$export$bd1440de1c6279ff;

});

parcelRegister("dSvuc", function(module, exports) {

var $8m8tN = parcelRequire("8m8tN");

const $d89c04ce1104682e$export$64834e9fe6776d12 = (0, $8m8tN.default);
module.exports["CompanyHubSpaceQuery"] = $d89c04ce1104682e$export$64834e9fe6776d12;

});

parcelRegister("8m8tN", function(module, exports) {
/**
 * @generated SignedSource<<22025a05bd4c5824adfd3b7c2aa87820>>
 * @relayHash f54737bfd2a13d4b0794f55692abc45f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5dadc9e02b20435a2eb281b9e0526d9c30d7939933ec6809776a6a63a0bfbfb0
const $a46838f64d9d3dd2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CompanyHubSpaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CompanyHubSpaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f54737bfd2a13d4b0794f55692abc45f",
            "id": "5dadc9e02b20435a2eb281b9e0526d9c30d7939933ec6809776a6a63a0bfbfb0",
            "metadata": {},
            "name": "CompanyHubSpaceQuery",
            "operationKind": "query",
            "text": "query CompanyHubSpaceQuery($key:String!){space(key:$key){id,homepageId}}"
        }
    };
}();
$a46838f64d9d3dd2$var$node.hash = "27e0b4cea0d06588f669e5b18022e172";
var $a46838f64d9d3dd2$export$2e2bcd8739ae039 = $a46838f64d9d3dd2$var$node;
module.exports["default"] = $a46838f64d9d3dd2$export$2e2bcd8739ae039;

});

parcelRegister("bZB1l", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $f8cc4d70fe32131d$export$7347d1c116cc1a56 = /*#__PURE__*/ function(SystemSpaceHomepageTemplate) {
    SystemSpaceHomepageTemplate["EAP"] = "EAP";
    SystemSpaceHomepageTemplate["MINIMAL"] = "MINIMAL";
    SystemSpaceHomepageTemplate["VISUAL"] = "VISUAL";
    return SystemSpaceHomepageTemplate;
}({});
module.exports["SystemSpaceHomepageTemplate"] = $f8cc4d70fe32131d$export$7347d1c116cc1a56;

});

parcelRegister("fg6th", function(module, exports) {
/**
 * @generated SignedSource<<0846e0fadbf09c50aad36a858dc422d6>>
 * @relayHash fe06e2f4a69f3231f81c25802441a1dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 694ca0efa967ba191320a5158bb8c5493f3d9fad08441a81d4bd1701967c7fc1
const $50fdf9c304115b8b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "createSystemSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CreateCompanyHubSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CreateCompanyHubSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fe06e2f4a69f3231f81c25802441a1dc",
            "id": "694ca0efa967ba191320a5158bb8c5493f3d9fad08441a81d4bd1701967c7fc1",
            "metadata": {},
            "name": "CreateCompanyHubSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation CreateCompanyHubSpaceMutation($input:SystemSpaceHomepageInput!){createSystemSpace(input:$input){homepageId,id,name,type}}"
        }
    };
}();
$50fdf9c304115b8b$var$node.hash = "6d874a2575f518173ffd31619b161569";
var $50fdf9c304115b8b$export$2e2bcd8739ae039 = $50fdf9c304115b8b$var$node;
module.exports["default"] = $50fdf9c304115b8b$export$2e2bcd8739ae039;

});

parcelRegister("fbF8y", function(module, exports) {
/**
 * @generated SignedSource<<671cda1bccf0a3f50223a0090b44579c>>
 * @relayHash 4811a5c342533b21d8dd3e696c5fe3f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b172e9d092e820e54ac35b21158bc7ef6a5fb96801347d822b558b506f90cf8
const $dd16027bddebb268$var$node = function() {
    var v0 = [
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "companyHubName"
                },
                {
                    "concreteType": "FrontCover",
                    "kind": "LinkedField",
                    "name": "frontCover",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "frontCoverState"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "SiteConfigurationQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "SiteConfigurationQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "4811a5c342533b21d8dd3e696c5fe3f8",
            "id": "4b172e9d092e820e54ac35b21158bc7ef6a5fb96801347d822b558b506f90cf8",
            "metadata": {},
            "name": "SiteConfigurationQuery",
            "operationKind": "query",
            "text": "query SiteConfigurationQuery{siteSettings{companyHubName,frontCover{frontCoverState}}}"
        }
    };
}();
$dd16027bddebb268$var$node.hash = "b4b2ce4fdc75a41f2f68ef6d954513ab";
var $dd16027bddebb268$export$2e2bcd8739ae039 = $dd16027bddebb268$var$node;
module.exports["default"] = $dd16027bddebb268$export$2e2bcd8739ae039;

});

parcelRegister("iBtOw", function(module, exports) {

let $d8b2cf1d37ff514e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d8b2cf1d37ff514e$var$load("bLm2D"),
    $d8b2cf1d37ff514e$var$load("6wr18"),
    $d8b2cf1d37ff514e$var$load("jCTl8"),
    $d8b2cf1d37ff514e$var$load("jtqzu"),
    $d8b2cf1d37ff514e$var$load("3w49v"),
    $d8b2cf1d37ff514e$var$load("4CfTY"),
    $d8b2cf1d37ff514e$var$load("kTnVa"),
    $d8b2cf1d37ff514e$var$load("gufL1"),
    $d8b2cf1d37ff514e$var$load("ffEVr"),
    $d8b2cf1d37ff514e$var$load("iMSgb"),
    $d8b2cf1d37ff514e$var$load("hLjS5"),
    $d8b2cf1d37ff514e$var$load("7bkye"),
    $d8b2cf1d37ff514e$var$load("48rvp"),
    $d8b2cf1d37ff514e$var$load("bAAhx"),
    $d8b2cf1d37ff514e$var$load("cYP30")
]).then(()=>parcelRequire('35RMv'));

});

parcelRegister("ak57N", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $2w2Hu = parcelRequire("2w2Hu");


const $a0c4fc2f529fa1f8$export$99fa8db8497fb663 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fAvbz",
    name: 'EditPageLoaderServer',
    loader: async ()=>(await (parcelRequire("6vGTt"))).EditPageLoaderServer,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicEditorContextProviderLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).NativeCollabLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).FullPageEditorLoader
    ]
});
module.exports["EditPageLoaderServer"] = $a0c4fc2f529fa1f8$export$99fa8db8497fb663;

});

parcelRegister("2w2Hu", function(module, exports) {
/**
 * These are loadable names that cross reference by multiple places.
 * They were kept as constants here instead of automatically generated for consistency.
 * ONLY put names here if they are going to be used in _mustPreloadWhenRenderingSPA.
 */ const $8cf96aaaf31dfd76$export$75ebf2388340a0ba = {
    ClassicRendererLoader: 'ClassicRendererLoader',
    ClassicEditorContextProviderLoader: 'ClassicEditorContextProviderLoader',
    NativeCollabLoader: 'NativeCollabLoader',
    FullPageEditorLoader: 'FullPageEditorLoader',
    ViewPageRouteComponentLoader: 'ViewPageRouteComponentLoader',
    LivePageComponentLoader: 'LivePageComponentLoader',
    EditorByLineArea: 'EditorByLineArea'
};
module.exports["MustPreloadLoadableNames"] = $8cf96aaaf31dfd76$export$75ebf2388340a0ba;

});

parcelRegister("6vGTt", function(module, exports) {

let $4bd6e91c814aeb4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4bd6e91c814aeb4d$var$load("cgtG8").then(()=>parcelRequire('g3qL5'));

});

parcelRegister("5AtW0", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jZrBc = parcelRequire("jZrBc");

class $8777d177426e798b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8777d177426e798b$var$WithEditorActionsNew, this.props);
    }
    constructor(props){
        super(props);
    }
}
const $8777d177426e798b$var$WithEditorActionsNew = (0, $4pOgL.isReactCompilerActivePlatform)() ? function WithEditorActionsNew(props) {
    const $ = (0, $frIzR.c)(3);
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $jZrBc.EditorContext));
    const t0 = context?.editorActions;
    let t1;
    if ($[0] !== render || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8777d177426e798b$var$WithEditorActionsInner, {
            render: render,
            editorActions: t0
        });
        $[0] = render;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $jZrBc.EditorContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8777d177426e798b$var$WithEditorActionsInner, {
        render: render,
        editorActions: context?.editorActions
    });
}; // Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $8777d177426e798b$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}
module.exports["default"] = $8777d177426e798b$export$2e2bcd8739ae039;

});

parcelRegister("g3LxX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $753deba3fe656290$var$initialState = {
    isInViewMode: true,
    isInAutoFocusMode: true,
    selectedExtensionLocalId: null,
    selectedToEditCardId: null,
    selectedToRemoveCardId: null
};
// Actions for managing the Custom Site Extensions state that is shared between the extension and the config panel
const $753deba3fe656290$var$actions = {
    setIsInViewMode: (isInViewMode)=>({ setState: setState })=>{
            setState({
                isInViewMode: isInViewMode
            });
        },
    setIsInAutoFocusMode: (isInAutoFocusMode)=>({ setState: setState })=>{
            setState({
                isInAutoFocusMode: isInAutoFocusMode
            });
        },
    setSelectedExtensionLocalId: (extensionLocalId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedExtensionLocalId: extensionLocalId
            });
        },
    setSelectedToEditCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToEditCardId: cardId
            });
        },
    setSelectedToRemoveCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToRemoveCardId: cardId
            });
        }
};
const $753deba3fe656290$var$ExtensionsStateStore = (0, $1P1Tu.createStore)({
    initialState: $753deba3fe656290$var$initialState,
    actions: $753deba3fe656290$var$actions,
    name: 'ExtensionsStateStore'
});
const $753deba3fe656290$export$732cb2f7b629a11e = (0, $9zUhf.createHook)($753deba3fe656290$var$ExtensionsStateStore);
const $753deba3fe656290$export$d50cb813b9099554 = (0, $9zUhf.createActionsHook)($753deba3fe656290$var$ExtensionsStateStore);
module.exports["useExtensionsState"] = $753deba3fe656290$export$732cb2f7b629a11e;
module.exports["useExtensionsActions"] = $753deba3fe656290$export$d50cb813b9099554;

});

parcelRegister("cCWcB", function(module, exports) {

let $93162e6a9acac415$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $93162e6a9acac415$var$load("jDjSj"),
    $93162e6a9acac415$var$load("ggmrd"),
    $93162e6a9acac415$var$load("2TuJp"),
    $93162e6a9acac415$var$load("cgmWe"),
    $93162e6a9acac415$var$load("2rU1T"),
    $93162e6a9acac415$var$load("9GOJf"),
    $93162e6a9acac415$var$load("3L4o4"),
    $93162e6a9acac415$var$load("4JAC8"),
    $93162e6a9acac415$var$load("cmqxT"),
    $93162e6a9acac415$var$load("c6fuq"),
    $93162e6a9acac415$var$load("coUzl"),
    $93162e6a9acac415$var$load("5nMTY"),
    $93162e6a9acac415$var$load("ciAVN"),
    $93162e6a9acac415$var$load("2YffH"),
    $93162e6a9acac415$var$load("3RdRc"),
    $93162e6a9acac415$var$load("j1hcz"),
    $93162e6a9acac415$var$load("6Hrp4"),
    $93162e6a9acac415$var$load("fxcvO"),
    $93162e6a9acac415$var$load("jeALs"),
    $93162e6a9acac415$var$load("4rv8V"),
    $93162e6a9acac415$var$load("eBRUf"),
    $93162e6a9acac415$var$load("gufL1"),
    $93162e6a9acac415$var$load("7U84Z"),
    $93162e6a9acac415$var$load("7EorR"),
    $93162e6a9acac415$var$load("gknbb"),
    $93162e6a9acac415$var$load("6iz6l"),
    $93162e6a9acac415$var$load("4SCW2"),
    $93162e6a9acac415$var$load("kQSfw"),
    $93162e6a9acac415$var$load("8PzH3"),
    $93162e6a9acac415$var$load("2jJ1i"),
    $93162e6a9acac415$var$load("bd77Q"),
    $93162e6a9acac415$var$load("hnGEQ"),
    $93162e6a9acac415$var$load("Wowvf"),
    $93162e6a9acac415$var$load("6wr18"),
    $93162e6a9acac415$var$load("1MWOL"),
    $93162e6a9acac415$var$load("hhss7"),
    $93162e6a9acac415$var$load("f35QR"),
    $93162e6a9acac415$var$load("eVYW1"),
    $93162e6a9acac415$var$load("ls0Um"),
    $93162e6a9acac415$var$load("020xd"),
    $93162e6a9acac415$var$load("eTBsW"),
    $93162e6a9acac415$var$load("bYxCZ"),
    $93162e6a9acac415$var$load("6HBYC"),
    $93162e6a9acac415$var$load("eDqo1"),
    $93162e6a9acac415$var$load("lxiFd"),
    $93162e6a9acac415$var$load("1oiJ6"),
    $93162e6a9acac415$var$load("huUvS"),
    $93162e6a9acac415$var$load("bTmOC"),
    $93162e6a9acac415$var$load("8j9XC"),
    $93162e6a9acac415$var$load("lFZaH"),
    $93162e6a9acac415$var$load("llxGi"),
    $93162e6a9acac415$var$load("ffEVr"),
    $93162e6a9acac415$var$load("6vhrJ"),
    $93162e6a9acac415$var$load("fxC6e"),
    $93162e6a9acac415$var$load("2YDZN")
]).then(()=>parcelRequire('le2hP'));

});

parcelRegister("ab2CU", function(module, exports) {
const $8ad93972529e0d13$export$62b7ac1cc8a8f8d7 = 'com.atlassian.hub.jsm-help';
const $8ad93972529e0d13$export$b5a30704f903627a = 'jsm-help';
const $8ad93972529e0d13$export$727d928d273126f1 = 'jsmHelpExtension';
const $8ad93972529e0d13$export$5eecea5c34e4d0ec = 'jsmHelpExtensionConfig';
const $8ad93972529e0d13$export$42fa33c628980eca = '1.0.0';
const $8ad93972529e0d13$export$8ec3d08588d2eeda = 9;
const $8ad93972529e0d13$export$93c0382b74e40ff9 = {
    SMALL: 'small',
    LARGE: 'large'
};
const $8ad93972529e0d13$export$d95e7684b6658cc2 = {
    COMMON_REQUESTS: 'common-requests',
    KB_ARTICLES: 'kb-articles',
    MANUAL: 'manual',
    PORTAL_CARDS: 'portal-cards',
    PORTAL_GROUPS: 'portal-groups'
};
module.exports["JSM_HELP_EXTENSION_TYPE"] = $8ad93972529e0d13$export$62b7ac1cc8a8f8d7;
module.exports["JSM_HELP_EXTENSION_CONFIG_ANALYTIC_SOURCE"] = $8ad93972529e0d13$export$5eecea5c34e4d0ec;
module.exports["PAGE_SIZE"] = $8ad93972529e0d13$export$8ec3d08588d2eeda;
module.exports["SourceType"] = $8ad93972529e0d13$export$d95e7684b6658cc2;

});

parcelRegister("3cMhk", function(module, exports) {
// Constants are renamed from PAGE_TOPPER prefix to CALLOUT_BANNER in anticipation of the extension rename to callout banner.
// Leaving the extension and type strings as page-topper, however, as the extension has already been added to a few instances
const $4a783e799621232b$export$5eb13835d9fc35c6 = 'page-topper';
const $4a783e799621232b$export$1e0076557b3776e7 = 'com.atlassian.confluence.page-topper';
const $4a783e799621232b$export$bbe74ef6b7213123 = 'calloutBannerExtension';
module.exports["CALLOUT_BANNER_EXTENSION_TYPE"] = $4a783e799621232b$export$1e0076557b3776e7;
module.exports["CALLOUT_BANNER_EXTENSION_ANALYTIC_SOURCE"] = $4a783e799621232b$export$bbe74ef6b7213123;

});

parcelRegister("cKAxI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $cUcZ5 = parcelRequire("cUcZ5");


var $bre0g = parcelRequire("bre0g");


var $fwDOR = parcelRequire("fwDOR");


var $lhvsH = parcelRequire("lhvsH");


var $4cOi8 = parcelRequire("4cOi8");

var $fcAaV = parcelRequire("fcAaV");


var $kcoxM = parcelRequire("kcoxM");


var $5un3P = parcelRequire("5un3P");


var $51FJF = parcelRequire("51FJF");


const $e60576104e03cc2c$var$CardsExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "JDp8H",
    name: "CardsExtension",
    loader: async ()=>(await (parcelRequire("9FKsX"))).CardsExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "cards-extension-loader"
        })
});
const $e60576104e03cc2c$export$b7316deff43c35f7 = (imageSrc, imageAltText)=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        link: '',
        isLinkUserEdited: false,
        title: '',
        isTitleUserEdited: false,
        description: '',
        isDescriptionUserEdited: false,
        imageSrc: imageSrc,
        imagePosition: (0, $5un3P.ImagePosition).MIDDLE,
        imageAltText: imageAltText
    });
let $e60576104e03cc2c$var$cards = null;
const $e60576104e03cc2c$export$adc082ec96ce9cca = ()=>{
    if ($e60576104e03cc2c$var$cards) return $e60576104e03cc2c$var$cards;
    return $e60576104e03cc2c$var$cards = (0, $kcoxM.CARDS_IMAGES_V5).map(({ src: src, alt: alt })=>$e60576104e03cc2c$export$b7316deff43c35f7(src, alt));
};
const $e60576104e03cc2c$export$611063def302f5f2 = ({ extensionTitle: extensionTitle, defaultParameters: defaultParameters })=>{
    const parameters = {
        size: (0, $4cOi8.Height).MEDIUM,
        cards: $e60576104e03cc2c$export$adc082ec96ce9cca(),
        isAvatarShown: false,
        isPublishDateShown: false,
        extensionTitle: extensionTitle,
        version: (0, $kcoxM.CARDS_EXTENSION_VERSION_5),
        renderVariant: (0, $4cOi8.RenderVariant).MANUAL,
        isSegmentationShown: false,
        orientation: (0, $5un3P.Orientation).STACKED,
        alignment: (0, $5un3P.Alignment).CENTER,
        isAutoscrollEnabled: false,
        backgroundColor: defaultParameters?.backgroundColor ?? "var(--ds-surface-overlay, #FFFFFF)",
        textColor: defaultParameters?.textColor ?? "var(--ds-text, #292A2E)",
        cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
        isSocialStatsShown: false,
        isIconShown: true,
        layout: (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT,
        isPaddingEnabled: true,
        isLabelShown: true,
        borderColor: (0, $lhvsH.DEFAULT_GRAY_COLOR),
        isDescriptionShown: true
    };
    return parameters;
};

const $e60576104e03cc2c$export$c0798477a3103ad2 = ({ contentId: contentId, propsProvider: propsProvider, mode: mode, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl, setUpsellModalSource: setUpsellModalSource })=>{
        const parameters = $e60576104e03cc2c$export$611063def302f5f2({
            extensionTitle: intl.formatMessage((0, $51FJF.messages).linkCardsMacroTitle),
            defaultParameters: defaultParameters
        });
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                title: intl.formatMessage((0, $51FJF.messages).linkCardsMacroTitle),
                type: (0, $kcoxM.CARDS_EXTENSION_TYPE),
                key: (0, $kcoxM.CARDS_EXTENSION_KEY),
                description: intl.formatMessage((0, $51FJF.messages).linkCardsMacroDescription),
                icons: {
                    '48': ()=>(parcelRequire("9AEfc")).then((mod)=>mod.CardsExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e60576104e03cc2c$var$CardsExtension, {
                            extensionNode: node,
                            contentId: contentId,
                            propsProvider: propsProvider,
                            mode: mode
                        });
                    },
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'extension',
                        key: (0, $kcoxM.CARDS_EXTENSION_KEY),
                        attrs: {
                            extensionType: (0, $kcoxM.CARDS_EXTENSION_TYPE),
                            extensionKey: (0, $kcoxM.CARDS_EXTENSION_KEY),
                            layout: 'default',
                            parameters: parameters
                        }
                    }),
                source: 'premiumCardsInsert',
                setUpsellModalSource: setUpsellModalSource
            })
        ]);
    };
};
module.exports["getDefaultCards"] = $e60576104e03cc2c$export$adc082ec96ce9cca;
module.exports["getCardsExtensionParameters"] = $e60576104e03cc2c$export$611063def302f5f2;
module.exports["cardsExtensionProvider"] = $e60576104e03cc2c$export$c0798477a3103ad2;

});

parcelRegister("bre0g", function(module, exports) {

var $i5qfp = parcelRequire("i5qfp");

class $1d9210071da756d7$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $i5qfp.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $1d9210071da756d7$export$2e2bcd8739ae039;

});

parcelRegister("i5qfp", function(module, exports) {
async function $953ad04814dc1360$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
module.exports["getAutoConvertPatternsFromModule"] = $953ad04814dc1360$export$60407594ea5edd1c;

});

parcelRegister("lhvsH", function(module, exports) {

var $1u5CA = parcelRequire("1u5CA");

const $c7b070100499a556$export$47962e37d9fd03c7 = (0, $1u5CA.knownBackgroundColors)[10];
module.exports["DEFAULT_GRAY_COLOR"] = $c7b070100499a556$export$47962e37d9fd03c7;

});

parcelRegister("4cOi8", function(module, exports) {
var $c7f67cb608b5916f$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $c7f67cb608b5916f$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $c7f67cb608b5916f$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $c7f67cb608b5916f$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $c7f67cb608b5916f$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $c7f67cb608b5916f$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $c7f67cb608b5916f$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $c7f67cb608b5916f$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $c7f67cb608b5916f$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $c7f67cb608b5916f$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $c7f67cb608b5916f$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $c7f67cb608b5916f$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $c7f67cb608b5916f$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $c7f67cb608b5916f$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $c7f67cb608b5916f$export$a6e645fda5339bf8;
module.exports["Height"] = $c7f67cb608b5916f$export$8954cfac7c08d16a;
module.exports["Alignment"] = $c7f67cb608b5916f$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $c7f67cb608b5916f$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $c7f67cb608b5916f$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $c7f67cb608b5916f$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $c7f67cb608b5916f$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $c7f67cb608b5916f$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $c7f67cb608b5916f$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $c7f67cb608b5916f$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $c7f67cb608b5916f$export$bf7ebf7fed6e7189;

});

parcelRegister("5un3P", function(module, exports) {

var $4cOi8 = parcelRequire("4cOi8");

const $a247ba2e22f9ecac$export$12c9c8946ce83b13 = 3;
var $a247ba2e22f9ecac$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $a247ba2e22f9ecac$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["CENTER"] = "center";
    Alignment["RIGHT"] = "right";
    return Alignment;
}({});
var $a247ba2e22f9ecac$export$a1ccd8e6c4b447b2 = /*#__PURE__*/ function(ImagePosition) {
    ImagePosition["TOP"] = "top";
    ImagePosition["MIDDLE"] = "middle";
    ImagePosition["BOTTOM"] = "bottom";
    return ImagePosition;
}({});
var $a247ba2e22f9ecac$export$9eefe1d63a5bbb7e = /*#__PURE__*/ function(CardsLayout) {
    CardsLayout["FIXED_IMAGE_HEIGHT"] = "fixed-image-height";
    CardsLayout["FLEXIBLE_IMAGE_HEIGHT"] = "flexible-image-height";
    return CardsLayout;
}({});
module.exports["DEFAULT_DYNAMIC_CARDS_COUNT"] = $a247ba2e22f9ecac$export$12c9c8946ce83b13;
module.exports["Orientation"] = $a247ba2e22f9ecac$export$df54d73aa0ec5e82;
module.exports["Alignment"] = $a247ba2e22f9ecac$export$9d7927214ed7d2cf;
module.exports["ImagePosition"] = $a247ba2e22f9ecac$export$a1ccd8e6c4b447b2;
module.exports["CardsLayout"] = $a247ba2e22f9ecac$export$9eefe1d63a5bbb7e;

});

parcelRegister("51FJF", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d14ef5a1094a027d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    linkCardsMacroTitle: {
        id: "company-hub.cards-extension.manifest.macro-title",
        defaultMessage: "Cards"
    },
    linkCardsMacroDescription: {
        id: "company-hub.cards-extension.manifest.macro-description",
        defaultMessage: "Display links as cards"
    }
});
module.exports["messages"] = $d14ef5a1094a027d$export$defe85febe8b728c;

});

parcelRegister("9FKsX", function(module, exports) {

let $70abfc93a4e188af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $70abfc93a4e188af$var$load("f35QR"),
    $70abfc93a4e188af$var$load("eVYW1"),
    $70abfc93a4e188af$var$load("ls0Um"),
    $70abfc93a4e188af$var$load("020xd"),
    $70abfc93a4e188af$var$load("eTBsW"),
    $70abfc93a4e188af$var$load("bYxCZ"),
    $70abfc93a4e188af$var$load("6HBYC"),
    $70abfc93a4e188af$var$load("eDqo1"),
    $70abfc93a4e188af$var$load("lxiFd"),
    $70abfc93a4e188af$var$load("1oiJ6"),
    $70abfc93a4e188af$var$load("huUvS"),
    $70abfc93a4e188af$var$load("9GOJf"),
    $70abfc93a4e188af$var$load("bTmOC"),
    $70abfc93a4e188af$var$load("3L4o4"),
    $70abfc93a4e188af$var$load("gvp1r"),
    $70abfc93a4e188af$var$load("8j9XC"),
    $70abfc93a4e188af$var$load("gknbb"),
    $70abfc93a4e188af$var$load("6iz6l"),
    $70abfc93a4e188af$var$load("4SCW2"),
    $70abfc93a4e188af$var$load("kQSfw"),
    $70abfc93a4e188af$var$load("8PzH3"),
    $70abfc93a4e188af$var$load("2jJ1i"),
    $70abfc93a4e188af$var$load("bd77Q"),
    $70abfc93a4e188af$var$load("hnGEQ"),
    $70abfc93a4e188af$var$load("6wr18"),
    $70abfc93a4e188af$var$load("1MWOL"),
    $70abfc93a4e188af$var$load("6vhrJ"),
    $70abfc93a4e188af$var$load("fxC6e"),
    $70abfc93a4e188af$var$load("ffEVr"),
    $70abfc93a4e188af$var$load("3gJkK")
]).then(()=>parcelRequire('gnpMO'));

});

parcelRegister("9AEfc", function(module, exports) {

let $6fb6b18034134dd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6fb6b18034134dd2$var$load("gKYwM").then(()=>parcelRequire('4LKV2'));

});

parcelRegister("g6QUH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $bre0g = parcelRequire("bre0g");


var $fwDOR = parcelRequire("fwDOR");


var $4cOi8 = parcelRequire("4cOi8");

var $fcAaV = parcelRequire("fcAaV");


var $5Ac5G = parcelRequire("5Ac5G");


var $eIwIu = parcelRequire("eIwIu");


var $9XEGe = parcelRequire("9XEGe");


const $4059117d6b06825c$var$CarouselExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "g5PGT",
    name: "CarouselExtension",
    loader: async ()=>(await (parcelRequire("2IMnE"))).CarouselExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "carousel-extension-loader"
        })
});
const $4059117d6b06825c$var$carouselFrames = [
    {
        imageSrc: (0, $eIwIu.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        imageSrc: (0, $eIwIu.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE
    },
    {
        imageSrc: (0, $eIwIu.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT
    }
];
const $4059117d6b06825c$var$getV2Frames = ({ intl: intl, defaultParameters: defaultParameters })=>{
    return $4059117d6b06825c$var$carouselFrames.map(({ imageSrc: imageSrc, layout: layout })=>(0, $eIwIu.createNewFrameWithDefaultParameters)({
            intl: intl,
            defaultParameters: defaultParameters,
            defaultField: {
                imageSrc: imageSrc,
                layout: layout
            }
        }));
};
const $4059117d6b06825c$export$3339a462074fecc3 = ({ extensionTitle: extensionTitle, intl: intl, defaultParameters: defaultParameters })=>({
        cards: $4059117d6b06825c$var$getV2Frames({
            intl: intl,
            defaultParameters: defaultParameters
        }),
        extensionTitle: extensionTitle,
        version: (0, $5Ac5G.CAROUSEL_VERSION_2),
        ...(0, $eIwIu.carouselNewParametersV2)
    });

const $4059117d6b06825c$export$e807a589fe0f4d24 = ({ contentId: contentId, propsProvider: propsProvider, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, intl: intl, openConfigPanel: openConfigPanel, setUpsellModalSource: setUpsellModalSource })=>{
        const parameters = $4059117d6b06825c$export$3339a462074fecc3({
            extensionTitle: intl.formatMessage((0, $9XEGe.messages).carouselMacroTitle),
            intl: intl,
            defaultParameters: defaultParameters
        });
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                title: intl.formatMessage((0, $9XEGe.messages).carouselMacroTitle),
                type: (0, $5Ac5G.carouselExtensionType),
                key: (0, $5Ac5G.carouselExtensionKey),
                description: intl.formatMessage((0, $9XEGe.messages).carouselMacroDescription),
                icons: {
                    '48': ()=>(parcelRequire("a5YHa")).then((mod)=>mod.CarouselExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4059117d6b06825c$var$CarouselExtension, {
                            propsProvider: propsProvider,
                            extensionNode: node,
                            contentId: contentId
                        });
                    },
                setUpsellModalSource: setUpsellModalSource,
                source: 'premiumCarouselInsert'
            })
        ]);
    };
};
module.exports["carouselParameters"] = $4059117d6b06825c$export$3339a462074fecc3;
module.exports["carouselExtensionProvider"] = $4059117d6b06825c$export$e807a589fe0f4d24;

});

parcelRegister("eIwIu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qzNs = parcelRequire("5qzNs");


var $aXWIB = parcelRequire("aXWIB");


var $cUcZ5 = parcelRequire("cUcZ5");


var $1VNax = parcelRequire("1VNax");

var $7q60U = parcelRequire("7q60U");

var $g3LxX = parcelRequire("g3LxX");

var $fOKpq = parcelRequire("fOKpq");


var $5Ac5G = parcelRequire("5Ac5G");


var $4cOi8 = parcelRequire("4cOi8");

var $9Uxg8 = parcelRequire("9Uxg8");


var $1JVKE = parcelRequire("1JVKE");

const $2417a3de58eaf173$export$3882df2b635374e2 = {
    cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
    isAutoplayEnabled: false,
    navigationStyle: (0, $9Uxg8.NavigationStyle).THUMBNAILS
};
const $2417a3de58eaf173$export$b713c3bc8c446d60 = 'https://images.unsplash.com/photo-1488470015861-8bb1317353ef?auto=format&fit=crop&q=80&w=1080';
const $2417a3de58eaf173$export$27643bf44cc02178 = {
    [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: "var(--ds-text, #292A2E)",
    [(0, $4cOi8.ITEM_FIELDS).LAYOUT]: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
    [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: $2417a3de58eaf173$export$b713c3bc8c446d60,
    [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: "Close-up of a vibrant green palm leaf\u2019s patterns.",
    buttonText: '',
    buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT
};
const $2417a3de58eaf173$export$4f94ab8184143ae6 = {
    imageSrc: 'https://images.unsplash.com/photo-1579547621706-1a9c79d5c9f1?auto=format&fit=crop&q=80&w=1080',
    imageAltText: 'purple and pink light illustration'
};
const $2417a3de58eaf173$export$5d30fc17e786110 = ({ intl: intl, defaultField: defaultField, randomLayout: randomLayout, defaultParameters: defaultParameters })=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        link: '',
        isLinkUserEdited: false,
        title: intl.formatMessage((0, $1JVKE.messages).placeholderTitle),
        isTitleUserEdited: false,
        description: intl.formatMessage((0, $1JVKE.messages).placeholderDescription),
        isDescriptionUserEdited: false,
        ...$2417a3de58eaf173$export$4f94ab8184143ae6,
        ...$2417a3de58eaf173$export$27643bf44cc02178,
        ...defaultParameters?.backgroundColor ? {
            [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: defaultParameters.backgroundColor
        } : {},
        ...defaultParameters?.textColor ? {
            [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: defaultParameters.textColor
        } : {},
        ...randomLayout && {
            [(0, $4cOi8.ITEM_FIELDS).LAYOUT]: randomLayout
        },
        ...defaultField
    });
const $2417a3de58eaf173$export$721510bd2cdb9b4f = (link, confluencePageId, isLinkUserEdited)=>{
    return {
        [(0, $4cOi8.ITEM_FIELDS).LINK]: link,
        [(0, $4cOi8.ITEM_FIELDS).CONFLUENCE_PAGE_ID]: confluencePageId || '',
        [(0, $4cOi8.ITEM_FIELDS).IS_LINK_USER_EDITED]: isLinkUserEdited || false
    };
};
const $2417a3de58eaf173$var$fetchLocalIdMacroParameters = ({ editorActions: editorActions, localId: localId })=>{
    var _params, _params1, _params2;
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    // If the extension was created prior to removal of type field, remove it from object here
    // This update is/was not done in combination with a feature gate
    delete params['type'];
    params.version = (0, $5Ac5G.CAROUSEL_VERSION_2);
    const { cornerStyle: cornerStyle, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle } = $2417a3de58eaf173$export$3882df2b635374e2;
    (_params = params).cornerStyle ?? (_params.cornerStyle = cornerStyle);
    (_params1 = params).isAutoplayEnabled ?? (_params1.isAutoplayEnabled = isAutoplayEnabled);
    (_params2 = params).navigationStyle ?? (_params2.navigationStyle = navigationStyle);
    /* construct frames array with intercepted params */ params.cards = params.cards?.map((frame)=>{
        return {
            ...$2417a3de58eaf173$export$27643bf44cc02178,
            // override BG color back to white for v1 carousels to maintain parity...
            [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-input, #FFFFFF)",
            // ... but let frame BG color (if already set, eg to default color) override again
            ...(0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(frame, [
                'imagePosition'
            ])
        };
    }) || params.cards;
    /* there were card fields added to carousel params that were nonfunctional.
   * reconstructing params to those with them omitted
   */ params = (0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(params, [
        'size',
        'isPublishDateShown',
        'isAvatarShown'
    ]);
    return params;
};
const $2417a3de58eaf173$var$updateFrameInList = (frames, cardId, updatedField)=>frames.map((frame)=>{
        if (frame.cardId === cardId) return {
            ...frame,
            ...updatedField
        };
        return frame;
    });
const $2417a3de58eaf173$export$3cf295eeccc933e1 = ({ localId: localId, editorActions: editorActions })=>{
    const { branding: branding } = (0, $fOKpq.useProductDependencies)();
    const defaultParameters = branding?.defaultParameters;
    const [carouselParameters, setCarouselParameters] = (0, $42omo.useState)($2417a3de58eaf173$var$fetchLocalIdMacroParameters({
        editorActions: editorActions,
        localId: localId
    }));
    const usedLayoutsRef = (0, $42omo.useRef)(new Set());
    const lastUsedLayoutRef = (0, $42omo.useRef)(null);
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = (0, $g3LxX.useExtensionsActions)();
    const { cards: frames } = carouselParameters ?? {};
    const intl = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        const extensionNodeParams = $2417a3de58eaf173$var$fetchLocalIdMacroParameters({
            editorActions: editorActions,
            localId: localId
        });
        setCarouselParameters(extensionNodeParams);
    // we don't want to re-fetch the parameters when the default parameters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorActions,
        localId
    ]);
    const getRandomLayout = (0, $42omo.useCallback)(()=>{
        const allLayouts = Object.values((0, $4cOi8.CommonLayout));
        if (usedLayoutsRef.current.size >= allLayouts.length - 1) usedLayoutsRef.current = new Set();
        const availableLayouts = allLayouts.filter((layout)=>!usedLayoutsRef.current.has(layout) && layout !== lastUsedLayoutRef.current);
        const randomIndex = Math.floor(Math.random() * availableLayouts.length);
        const randomLayout = availableLayouts[randomIndex];
        usedLayoutsRef.current.add(randomLayout);
        lastUsedLayoutRef.current = randomLayout;
        return randomLayout;
    }, []);
    const updateExtensionParams = (0, $42omo.useCallback)((newExtensionParameters)=>{
        setCarouselParameters((prevParams)=>{
            const updatedParams = {
                ...prevParams,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            (0, $7q60U.updateNodeParameters)(editorActions, updatedParams);
            return updatedParams;
        });
    }, [
        editorActions
    ]);
    const addFrame = (0, $42omo.useCallback)(()=>{
        const newFrame = $2417a3de58eaf173$export$5d30fc17e786110({
            intl: intl,
            defaultParameters: defaultParameters,
            defaultField: undefined,
            randomLayout: getRandomLayout()
        });
        updateExtensionParams({
            cards: [
                ...(0, $1VNax.checkItems)(frames) || [],
                newFrame
            ]
        });
        setIsInAutoFocusMode(true);
        setSelectedToEditCardId(newFrame.cardId);
    // no need to re-run when default parameters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        frames,
        updateExtensionParams,
        setSelectedToEditCardId,
        setIsInAutoFocusMode,
        intl,
        getRandomLayout
    ]);
    const removeFrame = (0, $42omo.useCallback)((cardId)=>updateExtensionParams({
            cards: frames.filter((frame)=>frame.cardId !== cardId)
        }), [
        frames,
        updateExtensionParams
    ]);
    const updateMainFormField = (0, $42omo.useCallback)((updatedFields)=>updateExtensionParams(updatedFields), [
        updateExtensionParams
    ]);
    const updateFrameFormField = (0, $42omo.useCallback)((cardId, updatedField)=>{
        const updatedFrames = $2417a3de58eaf173$var$updateFrameInList(frames, cardId, updatedField);
        updateExtensionParams({
            cards: updatedFrames
        });
    }, [
        frames,
        updateExtensionParams
    ]);
    const carouselActions = (0, $42omo.useMemo)(()=>({
            addFrame: addFrame,
            removeFrame: removeFrame,
            updateMainFormField: updateMainFormField,
            updateFrameFormField: updateFrameFormField
        }), [
        addFrame,
        removeFrame,
        updateMainFormField,
        updateFrameFormField
    ]);
    return {
        carouselParameters: carouselParameters,
        carouselActions: carouselActions
    };
};
module.exports["carouselNewParametersV2"] = $2417a3de58eaf173$export$3882df2b635374e2;
module.exports["FRAME_V2_DEFAULT_IMAGE_SRC"] = $2417a3de58eaf173$export$b713c3bc8c446d60;
module.exports["frameNewParametersV2"] = $2417a3de58eaf173$export$27643bf44cc02178;
module.exports["createNewFrameWithDefaultParameters"] = $2417a3de58eaf173$export$5d30fc17e786110;
module.exports["updateLinkAndConfluencePageId"] = $2417a3de58eaf173$export$721510bd2cdb9b4f;
module.exports["useCarouselExtensionParametersAndActions"] = $2417a3de58eaf173$export$3cf295eeccc933e1;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/** Used for built-in method references. */ var $3e1566926de40aab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e1566926de40aab$var$hasOwnProperty = $3e1566926de40aab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $w287Y(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$3e1566926de40aab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $9rfkh(object, path);
    return obj == null || delete obj[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("1VNax", function(module, exports) {
const $c0bf087c1d0f2640$var$validateItemsUrls = (items)=>{
    items.forEach((item)=>{
        if (!!item?.link && !item?.link.startsWith('http')) item.link = '';
    });
};
const $c0bf087c1d0f2640$export$3831ccf0db7ad748 = (items)=>{
    if (!items || items?.length === 0) return null;
    else if (Array.isArray(items)) {
        $c0bf087c1d0f2640$var$validateItemsUrls(items);
        return items;
    }
};
module.exports["checkItems"] = $c0bf087c1d0f2640$export$3831ccf0db7ad748;

});

parcelRegister("fOKpq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $7c1587c4cdf698a9$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $42omo.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $7c1587c4cdf698a9$export$774887fcc3922763 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const defaultValue = (0, $42omo.useContext)($7c1587c4cdf698a9$export$49e1053dfc41d188);
    let t1;
    if ($[3] !== defaultValue || $[4] !== props) {
        t1 = {
            ...defaultValue,
            ...props
        };
        $[3] = defaultValue;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const value = t1;
    let t2;
    if ($[6] !== children || $[7] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c1587c4cdf698a9$export$49e1053dfc41d188.Provider, {
            value: value
        }, children);
        $[6] = children;
        $[7] = value;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, ...props })=>{
    const defaultValue = (0, $42omo.useContext)($7c1587c4cdf698a9$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c1587c4cdf698a9$export$49e1053dfc41d188.Provider, {
        value: value
    }, children);
};
const $7c1587c4cdf698a9$export$8dcbb40932065737 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useProductDependencies() {
    const ctx = (0, $42omo.useContext)($7c1587c4cdf698a9$export$49e1053dfc41d188);
    if (!ctx) throw new Error("useProductDependencies must be used within ProductDependenciesProvider");
    return ctx;
} : function useProductDependencies() {
    const ctx = (0, $42omo.useContext)($7c1587c4cdf698a9$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
};
module.exports["ProductDependenciesContext"] = $7c1587c4cdf698a9$export$49e1053dfc41d188;
module.exports["useProductDependencies"] = $7c1587c4cdf698a9$export$8dcbb40932065737;

});

parcelRegister("9Uxg8", function(module, exports) {

var $4cOi8 = parcelRequire("4cOi8");

var $4c5172dc3da882ee$export$f8af16d8231e3b4e = /*#__PURE__*/ function(NavigationStyle) {
    NavigationStyle["PROGRESS_CIRCLES"] = "progress-circles";
    NavigationStyle["THUMBNAILS"] = "thumbnails";
    return NavigationStyle;
}({});
var $4c5172dc3da882ee$export$f34582f4a07dd8dd = /*#__PURE__*/ function(FrameSizes) {
    FrameSizes["NAVIGATION_THUMBNAIL"] = "navigationThumbnail";
    FrameSizes["NAVIGATION_THUMBNAIL_V2"] = "navigationThumbnailV2";
    return FrameSizes;
}({});
const $4c5172dc3da882ee$export$288376e91ac51845 = {
    ["navigationThumbnailV2"]: {
        minWidth: 200,
        maxWidth: 200,
        height: 40
    },
    ["navigationThumbnail"]: {
        minWidth: 244,
        maxWidth: 250,
        height: 72
    }
};
module.exports["NavigationStyle"] = $4c5172dc3da882ee$export$f8af16d8231e3b4e;
module.exports["FrameSizes"] = $4c5172dc3da882ee$export$f34582f4a07dd8dd;
module.exports["framesDimensions"] = $4c5172dc3da882ee$export$288376e91ac51845;

});

parcelRegister("1JVKE", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $512cd77b50dddf7a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    placeholderTitle: {
        id: "company-hub.carousel-extension.placeholder.title",
        defaultMessage: "Give your frame a title"
    },
    placeholderDescription: {
        id: "company-hub.carousel-extension.placeholder.description",
        defaultMessage: "Customize this frame to create a rotating carousel."
    }
});
module.exports["messages"] = $512cd77b50dddf7a$export$defe85febe8b728c;

});

parcelRegister("9XEGe", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $93d5a0345fe228e3$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    carouselMacroTitle: {
        id: "company-hub.carousel-extension.manifest.macro-title",
        defaultMessage: "Carousel"
    },
    carouselMacroDescription: {
        id: "company-hub.carousel-extension.manifest.macro-description",
        defaultMessage: "Create a rotating trio of dynamic frames."
    }
});
module.exports["messages"] = $93d5a0345fe228e3$export$defe85febe8b728c;

});

parcelRegister("2IMnE", function(module, exports) {

let $1fb538351557ada4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1fb538351557ada4$var$load("3L4o4"),
    $1fb538351557ada4$var$load("f35QR"),
    $1fb538351557ada4$var$load("eVYW1"),
    $1fb538351557ada4$var$load("ls0Um"),
    $1fb538351557ada4$var$load("020xd"),
    $1fb538351557ada4$var$load("eTBsW"),
    $1fb538351557ada4$var$load("bYxCZ"),
    $1fb538351557ada4$var$load("6HBYC"),
    $1fb538351557ada4$var$load("eDqo1"),
    $1fb538351557ada4$var$load("lxiFd"),
    $1fb538351557ada4$var$load("1oiJ6"),
    $1fb538351557ada4$var$load("huUvS"),
    $1fb538351557ada4$var$load("iEdZP"),
    $1fb538351557ada4$var$load("g2A8O"),
    $1fb538351557ada4$var$load("bTmOC"),
    $1fb538351557ada4$var$load("gvp1r"),
    $1fb538351557ada4$var$load("6aY84"),
    $1fb538351557ada4$var$load("8j9XC"),
    $1fb538351557ada4$var$load("gknbb"),
    $1fb538351557ada4$var$load("6iz6l"),
    $1fb538351557ada4$var$load("4SCW2"),
    $1fb538351557ada4$var$load("kQSfw"),
    $1fb538351557ada4$var$load("8PzH3"),
    $1fb538351557ada4$var$load("2jJ1i"),
    $1fb538351557ada4$var$load("bd77Q"),
    $1fb538351557ada4$var$load("hnGEQ"),
    $1fb538351557ada4$var$load("9aQIt"),
    $1fb538351557ada4$var$load("XZauT"),
    $1fb538351557ada4$var$load("4S1SF"),
    $1fb538351557ada4$var$load("jiFtb"),
    $1fb538351557ada4$var$load("lm9Lt"),
    $1fb538351557ada4$var$load("9wPDc"),
    $1fb538351557ada4$var$load("1MWOL"),
    $1fb538351557ada4$var$load("6fQco"),
    $1fb538351557ada4$var$load("aOY32"),
    $1fb538351557ada4$var$load("6vhrJ"),
    $1fb538351557ada4$var$load("fxC6e"),
    $1fb538351557ada4$var$load("7jSfd"),
    $1fb538351557ada4$var$load("4HZlX"),
    $1fb538351557ada4$var$load("6wr18"),
    $1fb538351557ada4$var$load("kDqHr"),
    $1fb538351557ada4$var$load("ffEVr"),
    $1fb538351557ada4$var$load("bap37")
]).then(()=>parcelRequire('9deYz'));

});

parcelRegister("a5YHa", function(module, exports) {

let $759973d0146159f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $759973d0146159f3$var$load("8nWJU").then(()=>parcelRequire('ayHRb'));

});

parcelRegister("aYtOO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $cUcZ5 = parcelRequire("cUcZ5");


var $bre0g = parcelRequire("bre0g");


var $fwDOR = parcelRequire("fwDOR");


var $fcAaV = parcelRequire("fcAaV");


var $cVaAA = parcelRequire("cVaAA");


var $dEsCs = parcelRequire("dEsCs");


var $ktHpM = parcelRequire("ktHpM");

const $bff4494b16ff252f$var$LINKS_MENU_VERSION_1 = '1';

const $bff4494b16ff252f$var$LinksMenuExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "l5-_n",
    name: "LinksMenuExtension",
    loader: async ()=>(await (parcelRequire("accAV"))).LinksMenuExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "links-menu-extension-loader"
        })
});
const $bff4494b16ff252f$export$e0faacd43528e300 = {
    alignment: (0, $dEsCs.ALIGNMENT).CENTER,
    fillColor: "var(--ds-surface-overlay, #FFFFFF)",
    borderColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    border: (0, $dEsCs.BORDER).NONE,
    cornerStyle: (0, $dEsCs.CORNERS).SHARP,
    textColor: "var(--ds-text, #292A2E)",
    highlightColor: "var(--ds-text, #292A2E)"
};
const $bff4494b16ff252f$var$getParameters = ({ formatMessage: formatMessage, defaultParameters: defaultParameters })=>({
        extensionTitle: formatMessage((0, $ktHpM.messages).linksMenuTitle),
        version: $bff4494b16ff252f$var$LINKS_MENU_VERSION_1,
        styles: {
            ...$bff4494b16ff252f$export$e0faacd43528e300,
            // Pre-v2 behaviour (preserved verbatim from master): when help-center
            // passes `defaultParameters` (legacy `var(--hub-primary-color, ...)`
            // shape), both `fillColor` AND `borderColor` mirror the brand-tinted
            // bg so the menu chip blends visually with the rest of the page chrome.
            ...defaultParameters?.backgroundColor ? {
                fillColor: defaultParameters.backgroundColor,
                borderColor: defaultParameters.backgroundColor
            } : {},
            // Advanced-theming (v2) override: spec says the day-0 border for new
            // links-menu inserts should be the neutral `color.border` hex, not the
            // bg-mirroring shade above. Fires *after* the legacy block so it wins.
            // Gated explicitly on the v2 flag — legacy help-center, Confluence,
            // and CSM all see `isAdvancedThemingEnabled !== true` and skip this.
            ...defaultParameters?.isAdvancedThemingEnabled ? {
                borderColor: '#DCDFE4'
            } : {},
            ...defaultParameters?.textColor ? {
                textColor: defaultParameters.textColor,
                highlightColor: defaultParameters.textColor
            } : {}
        },
        items: [
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                type: (0, $dEsCs.ITEM).LINK,
                title: formatMessage((0, $ktHpM.messages).firstDefaultItem),
                link: ''
            },
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                type: (0, $dEsCs.ITEM).LINK,
                title: formatMessage((0, $ktHpM.messages).secondDefaultItem),
                link: ''
            },
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                type: (0, $dEsCs.ITEM).MENU,
                title: formatMessage((0, $ktHpM.messages).thirdDefaultItem),
                childItems: [
                    {
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        itemId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                        type: (0, $dEsCs.ITEM).LINK,
                        title: formatMessage((0, $ktHpM.messages).nestedDefaultItem),
                        link: ''
                    }
                ]
            }
        ]
    });

const $bff4494b16ff252f$export$7c3934f2ad869115 = async ({ contentId: contentId, propsProvider: propsProvider, mode: mode, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const parameters = $bff4494b16ff252f$var$getParameters({
            formatMessage: intl.formatMessage,
            defaultParameters: defaultParameters
        });
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                title: intl.formatMessage((0, $ktHpM.messages).linksMenuTitle),
                type: (0, $cVaAA.LINKS_MENU_EXTENSION_TYPE),
                key: 'links-menu',
                description: intl.formatMessage((0, $ktHpM.messages).linksMenuDescription),
                icons: {
                    '48': ()=>(parcelRequire("2YLKr")).then((mod)=>mod.LinksMenuExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bff4494b16ff252f$var$LinksMenuExtension, {
                            extensionNode: node,
                            contentId: contentId,
                            propsProvider: propsProvider,
                            mode: mode
                        });
                    },
                // @TODO add links menu upsell in COMPHUB-2408
                setUpsellModalSource: undefined,
                source: 'premiumCarouselInsert'
            })
        ]);
    };
};
module.exports["DEFAULT_STYLES"] = $bff4494b16ff252f$export$e0faacd43528e300;
module.exports["linksMenuExtensionProvider"] = $bff4494b16ff252f$export$7c3934f2ad869115;

});

parcelRegister("dEsCs", function(module, exports) {
var $a31b1dbcb326eba3$export$25d99ac3e552cf7a = /*#__PURE__*/ function(ITEM) {
    ITEM["LINK"] = "link";
    ITEM["MENU"] = "menu";
    return ITEM;
}({});
var $a31b1dbcb326eba3$export$470d0905851e47a1 = /*#__PURE__*/ function(ALIGNMENT) {
    ALIGNMENT["LEFT"] = "left";
    ALIGNMENT["CENTER"] = "center";
    ALIGNMENT["RIGHT"] = "right";
    return ALIGNMENT;
}({});
var $a31b1dbcb326eba3$export$8a9179e387c60c17 = /*#__PURE__*/ function(BORDER) {
    BORDER["NONE"] = "none";
    BORDER["ALL_SIDES"] = "all_sides";
    BORDER["BOTTOM"] = "bottom";
    return BORDER;
}({});
var $a31b1dbcb326eba3$export$87780c3e8dee494d = /*#__PURE__*/ function(CORNERS) {
    CORNERS["ROUND"] = "round";
    CORNERS["SHARP"] = "sharp";
    return CORNERS;
}({});
module.exports["ITEM"] = $a31b1dbcb326eba3$export$25d99ac3e552cf7a;
module.exports["ALIGNMENT"] = $a31b1dbcb326eba3$export$470d0905851e47a1;
module.exports["BORDER"] = $a31b1dbcb326eba3$export$8a9179e387c60c17;
module.exports["CORNERS"] = $a31b1dbcb326eba3$export$87780c3e8dee494d;

});

parcelRegister("ktHpM", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $bc353a1ca4476d36$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    linksMenuTitle: {
        id: "company-hub.links-menu-extension.manifest.extension-title",
        defaultMessage: "Links menu"
    },
    linksMenuDescription: {
        id: "company-hub.links-menu-extension.manifest.extension-description",
        defaultMessage: "Add multiple links and sub-menus to Company Hub"
    },
    firstDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.first-default-item",
        defaultMessage: "About us"
    },
    secondDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.second-default-item",
        defaultMessage: "Benefits"
    },
    thirdDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.third-default-item",
        defaultMessage: "Teams"
    },
    nestedDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.nested-default-item",
        defaultMessage: "Team 1"
    }
});
module.exports["messages"] = $bc353a1ca4476d36$export$defe85febe8b728c;

});

parcelRegister("accAV", function(module, exports) {

let $76c4cb6886609d68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $76c4cb6886609d68$var$load("igTEs").then(()=>parcelRequire('eMrjW'));

});

parcelRegister("2YLKr", function(module, exports) {

let $22b63923736fc1f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $22b63923736fc1f0$var$load("7soIx").then(()=>parcelRequire('4YKKp'));

});

parcelRegister("2QkXB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $bre0g = parcelRequire("bre0g");


var $fwDOR = parcelRequire("fwDOR");


var $fcAaV = parcelRequire("fcAaV");

var $cNwLI = parcelRequire("cNwLI");


var $6HKgG = parcelRequire("6HKgG");


var $6DWJW = parcelRequire("6DWJW");


const $1438c18bb2760da6$var$SectionExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "r-pUQ",
    name: "SectionExtension",
    loader: async ()=>(await (parcelRequire("fC20J"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "section-extension-loader"
        })
});
const $1438c18bb2760da6$var$sectionParameters = (intl, defaultBackgroundColor)=>({
        extensionTitle: intl.formatMessage((0, $6DWJW.messages).title),
        backgroundColor: defaultBackgroundColor,
        contentWidth: (0, $6HKgG.DEFAULT_CONTENT_WIDTH)
    });

const $1438c18bb2760da6$export$6775abcfdb3b0453 = ({ getSectionExtensionContents: getSectionExtensionContents, mode: mode, propsProvider: propsProvider, defaultParameters: defaultParameters })=>async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const title = intl.formatMessage((0, $6DWJW.messages).title);
        const description = intl.formatMessage((0, $6DWJW.messages).description);
        // Only honour the v2 seed when advanced theming is on. Falls back to the
        // legacy `DEFAULT_BACKGROUND_COLOR` for Confluence/CSM/gate-OFF help-center.
        const defaultBackgroundColor = defaultParameters?.isAdvancedThemingEnabled && defaultParameters.backgroundColor ? defaultParameters.backgroundColor : (0, $6HKgG.DEFAULT_BACKGROUND_COLOR);
        const parameters = $1438c18bb2760da6$var$sectionParameters(intl, defaultBackgroundColor);
        const type = (0, $cNwLI.SECTION_EXTENSION_TYPE);
        const key = (0, $6HKgG.SECTION_EXTENSION_KEY);
        const initialContentText = {
            header: intl.formatMessage((0, $6DWJW.messages).contentHeader),
            subHeader: intl.formatMessage((0, $6DWJW.messages).contentSubHeader),
            placeholderTitle: intl.formatMessage((0, $6DWJW.messages).placeHolderTitle)
        };
        const icons = {
            '48': ()=>(parcelRequire("lkdwc")).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const update = async ()=>{
            const selectedNode = editorActions?.getSelectedNode()?.toJSON();
            const selectedLocalId = selectedNode?.attrs?.localId;
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        const render = async ()=>({ node: node, actions: actions })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1438c18bb2760da6$var$SectionExtension, {
                    contentId: contentId,
                    extensionNode: node,
                    editorActions: editorActions,
                    mbeActions: actions,
                    mode: mode,
                    propsProvider: propsProvider
                });
            };
        const additionalModuleNodeProps = {
            __allowBodiedOverride: true
        };
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                key: key,
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                source: 'premiumSectionInsert',
                nodeType: 'multiBodiedExtension',
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'multiBodiedExtension',
                        key: 'hub-section',
                        attrs: {
                            extensionType: type,
                            extensionKey: 'hub-section',
                            layout: 'full-width',
                            parameters: parameters
                        },
                        content: getSectionExtensionContents(initialContentText)
                    }),
                additionalModuleNodeProps: additionalModuleNodeProps
            })
        ]);
    };
module.exports["sectionExtensionProvider"] = $1438c18bb2760da6$export$6775abcfdb3b0453;

});

parcelRegister("6HKgG", function(module, exports) {
const $c274b9d16f8d5323$export$bc69bf23ec1f99d5 = 'hub-section';
const $c274b9d16f8d5323$export$7a75cc6a69e05549 = 'hub-sectionExtensionConfig';
var $c274b9d16f8d5323$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $c274b9d16f8d5323$export$6cccba5fae1d609d = "wide";
const $c274b9d16f8d5323$export$617cdcc6afaae4f7 = "var(--ds-surface-overlay, #FFFFFF)";
module.exports["SECTION_EXTENSION_KEY"] = $c274b9d16f8d5323$export$bc69bf23ec1f99d5;
module.exports["SECTION_EXTENSION_ANALYTICS_SOURCE"] = $c274b9d16f8d5323$export$7a75cc6a69e05549;
module.exports["CONTENT_WIDTH"] = $c274b9d16f8d5323$export$3130b484681bf8bc;
module.exports["DEFAULT_CONTENT_WIDTH"] = $c274b9d16f8d5323$export$6cccba5fae1d609d;
module.exports["DEFAULT_BACKGROUND_COLOR"] = $c274b9d16f8d5323$export$617cdcc6afaae4f7;

});

parcelRegister("6DWJW", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $687c08afff3e5712$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    title: {
        id: "company-hub.section-extension.manifest.extension-title",
        defaultMessage: "Section"
    },
    description: {
        id: "company-hub.section-extension.manifest.macro-description",
        defaultMessage: "Group elements together with a background"
    },
    contentHeader: {
        id: "company-hub.section-extension.manifest.content.header",
        defaultMessage: "Give your section a title"
    },
    contentSubHeader: {
        id: "company-hub.section-extension.manifest.content.sub-header",
        defaultMessage: "Organize elements into sections with customizable backgrounds."
    },
    placeHolderTitle: {
        id: "company-hub.section-extension.manifest.content.placeholder-title",
        defaultMessage: "Placeholder"
    }
});
module.exports["messages"] = $687c08afff3e5712$export$defe85febe8b728c;

});

parcelRegister("fC20J", function(module, exports) {

let $b5dbf6ea707bc215$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5dbf6ea707bc215$var$load("grbhN").then(()=>parcelRequire('5cloc'));

});

parcelRegister("lkdwc", function(module, exports) {

let $f865f3b2f1da87a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f865f3b2f1da87a2$var$load("jle6Z").then(()=>parcelRequire('iNP4c'));

});

parcelRegister("2baLD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $bre0g = parcelRequire("bre0g");


var $fwDOR = parcelRequire("fwDOR");


var $4cOi8 = parcelRequire("4cOi8");

var $fcAaV = parcelRequire("fcAaV");

var $cNwLI = parcelRequire("cNwLI");


var $iC0lV = parcelRequire("iC0lV");


var $95CeO = parcelRequire("95CeO");


const $07a2866bda8a4248$var$SpotlightExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "p5n9G",
    name: "SpotlightExtension",
    loader: async ()=>(await (parcelRequire("hp0Ot"))).Spotlight,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "spotlight-extension-loader"
        })
});
const $07a2866bda8a4248$export$bc4319ada86b358d = ({ intl: intl, defaultParameters: defaultParameters })=>({
        extensionTitle: intl.formatMessage((0, $95CeO.i18n).title),
        height: (0, $4cOi8.Height).MEDIUM,
        backgroundColor: defaultParameters?.backgroundColor ?? "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
        cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
        content: {
            text: {
                title: intl.formatMessage((0, $95CeO.i18n).initialTitleParameter),
                description: intl.formatMessage((0, $95CeO.i18n).initialDescriptionParameter),
                textColor: defaultParameters?.textColor ?? "var(--ds-text, #292A2E)"
            },
            button: {
                isButtonShown: false,
                text: '',
                link: '',
                style: (0, $4cOi8.ButtonStyle).DEFAULT
            },
            image: {
                imageSrc: 'https://images.unsplash.com/photo-1527519135413-1e146b552e10?q=80&w=2940&auto=format',
                altText: intl.formatMessage((0, $95CeO.i18n).initialImageAltTextParameter)
            }
        }
    });

const $07a2866bda8a4248$export$10b21ce9d2029ff1 = async ({ contentId: contentId, propsProvider: propsProvider, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, setUpsellModalSource: setUpsellModalSource, intl: intl })=>{
        const title = intl.formatMessage((0, $95CeO.i18n).title);
        const description = intl.formatMessage((0, $95CeO.i18n).description);
        const type = (0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE);
        const render = async ()=>({ node: node })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07a2866bda8a4248$var$SpotlightExtension, {
                    isInEditor: true,
                    contentId: contentId,
                    extensionNode: node,
                    PropsProvider: propsProvider
                });
        const icons = {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>(parcelRequire("lkdwc")).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const parameters = $07a2866bda8a4248$export$bc4319ada86b358d({
            intl: intl,
            defaultParameters: defaultParameters
        });
        const update = async ()=>{
            const selectedNode = editorActions?.getSelectedNode()?.toJSON();
            const selectedLocalId = selectedNode?.attrs?.localId;
            // missing openConfigPanel and editorActions
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        return new (0, $bre0g.default)([
            (0, $fcAaV.getExtensionManifest)({
                key: (0, $iC0lV.SPOTLIGHT_EXTENSION_KEY),
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                setUpsellModalSource: setUpsellModalSource,
                source: 'premiumSpotlightInsert'
            })
        ]);
    };
};
module.exports["spotlightParameters"] = $07a2866bda8a4248$export$bc4319ada86b358d;
module.exports["spotlightExtensionProvider"] = $07a2866bda8a4248$export$10b21ce9d2029ff1;

});

parcelRegister("iC0lV", function(module, exports) {

var $4cOi8 = parcelRequire("4cOi8");


var $afjCM = parcelRequire("afjCM");

const $dadf278331e20e03$export$8434ce10552078fe = 'spotlight';
const $dadf278331e20e03$export$af1b061943ec63f0 = [
    {
        label: (0, $afjCM.i18n).splitDesignContentFirstLabel,
        description: (0, $afjCM.i18n).splitDesignContentFirstDescription,
        value: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT
    },
    {
        label: (0, $afjCM.i18n).splitDesignImageFirstLabel,
        description: (0, $afjCM.i18n).splitDesignImageFirstDescription,
        value: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        label: (0, $afjCM.i18n).solidColorBackgroundLabel,
        description: (0, $afjCM.i18n).solidColorBackgroundDescription,
        value: (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND
    },
    {
        label: (0, $afjCM.i18n).frameAboveImageLabel,
        description: (0, $afjCM.i18n).frameAboveImageDescription,
        value: (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE
    }
];
module.exports["SPOTLIGHT_EXTENSION_KEY"] = $dadf278331e20e03$export$8434ce10552078fe;
module.exports["layoutOptions"] = $dadf278331e20e03$export$af1b061943ec63f0;

});

parcelRegister("afjCM", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b0bda2c986a36858$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    splitDesignContentFirstLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label",
        defaultMessage: "Split design (content first)"
    },
    splitDesignContentFirstDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description",
        defaultMessage: "Large image on the right with lots of room for content"
    },
    splitDesignImageFirstLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label",
        defaultMessage: "Split design (image first)"
    },
    splitDesignImageFirstDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description",
        defaultMessage: "Large image on the left with lots of room for content"
    },
    solidColorBackgroundLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label",
        defaultMessage: "Solid color background"
    },
    solidColorBackgroundDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description",
        defaultMessage: "Content in front of a full-width color"
    },
    frameAboveImageLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label",
        defaultMessage: "Content frame inside image"
    },
    frameAboveImageDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description",
        defaultMessage: "Text box overlay on a large image"
    },
    // We will eventually use these translations when full background layout is properly introduced
    imageBackgroundLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label",
        defaultMessage: "Image background"
    },
    imageBackgroundDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description",
        defaultMessage: "Full-size image behind your content"
    }
});
module.exports["i18n"] = $b0bda2c986a36858$export$a7357cdd1f0b0168;

});

parcelRegister("95CeO", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $819f7046fed5f31d$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    title: {
        id: "company-hub.spotlight-extension.manifest.macro-title",
        defaultMessage: "Spotlight"
    },
    description: {
        id: "company-hub.spotlight-extension.manifest.macro-description",
        defaultMessage: "Highlight important messages with a visual spotlight."
    },
    initialTitleParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.text-title",
        defaultMessage: "Give your spotlight a title"
    },
    initialDescriptionParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.text-description",
        defaultMessage: "Design a spotlight to highlight your most vital information. Bring the most important messages to life with custom colors, a powerful image, and flexible layouts."
    },
    initialImageAltTextParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.alt-image-text",
        defaultMessage: "Landscape photography of desert"
    }
});
module.exports["i18n"] = $819f7046fed5f31d$export$a7357cdd1f0b0168;

});

parcelRegister("hp0Ot", function(module, exports) {

let $cab566ee558316f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cab566ee558316f9$var$load("c6fuq"),
    $cab566ee558316f9$var$load("coUzl"),
    $cab566ee558316f9$var$load("5nMTY"),
    $cab566ee558316f9$var$load("ciAVN"),
    $cab566ee558316f9$var$load("2YffH"),
    $cab566ee558316f9$var$load("3RdRc"),
    $cab566ee558316f9$var$load("j1hcz"),
    $cab566ee558316f9$var$load("6Hrp4"),
    $cab566ee558316f9$var$load("fxcvO"),
    $cab566ee558316f9$var$load("jeALs"),
    $cab566ee558316f9$var$load("4rv8V"),
    $cab566ee558316f9$var$load("eBRUf"),
    $cab566ee558316f9$var$load("gufL1"),
    $cab566ee558316f9$var$load("7U84Z"),
    $cab566ee558316f9$var$load("7EorR"),
    $cab566ee558316f9$var$load("gknbb"),
    $cab566ee558316f9$var$load("6iz6l"),
    $cab566ee558316f9$var$load("4SCW2"),
    $cab566ee558316f9$var$load("kQSfw"),
    $cab566ee558316f9$var$load("8PzH3"),
    $cab566ee558316f9$var$load("2jJ1i"),
    $cab566ee558316f9$var$load("bd77Q"),
    $cab566ee558316f9$var$load("hnGEQ"),
    $cab566ee558316f9$var$load("Wowvf"),
    $cab566ee558316f9$var$load("6wr18"),
    $cab566ee558316f9$var$load("1MWOL"),
    $cab566ee558316f9$var$load("ffEVr"),
    $cab566ee558316f9$var$load("hhss7"),
    $cab566ee558316f9$var$load("f35QR"),
    $cab566ee558316f9$var$load("eVYW1"),
    $cab566ee558316f9$var$load("ls0Um"),
    $cab566ee558316f9$var$load("020xd"),
    $cab566ee558316f9$var$load("eTBsW"),
    $cab566ee558316f9$var$load("bYxCZ"),
    $cab566ee558316f9$var$load("6HBYC"),
    $cab566ee558316f9$var$load("eDqo1"),
    $cab566ee558316f9$var$load("lxiFd"),
    $cab566ee558316f9$var$load("1oiJ6"),
    $cab566ee558316f9$var$load("huUvS"),
    $cab566ee558316f9$var$load("bTmOC"),
    $cab566ee558316f9$var$load("8j9XC"),
    $cab566ee558316f9$var$load("6vhrJ"),
    $cab566ee558316f9$var$load("fxC6e"),
    $cab566ee558316f9$var$load("lFZaH")
]).then(()=>parcelRequire('27Ekc'));

});

parcelRegister("jgFdO", function(module, exports) {

var $aMfes = parcelRequire("aMfes");


var $aBpO5 = parcelRequire("aBpO5");

const $ee26c792ae0f4629$export$a69eee655819c5bd = ({ api: api, config: config })=>{
    return {
        name: 'codeBlockAdvanced',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $aMfes.codeBlockNodeWithFixedToDOM)({
                        allowCodeFolding: config?.allowCodeFolding ?? false
                    })
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlockAdvancedPlugin',
                    plugin: ({ getIntl: getIntl })=>(0, $aBpO5.createPlugin)({
                            api: api,
                            extensions: config?.extensions ?? [],
                            allowCodeFolding: config?.allowCodeFolding ?? false,
                            getIntl: getIntl
                        })
                }
            ];
        }
    };
};
module.exports["codeBlockAdvancedPlugin"] = $ee26c792ae0f4629$export$a69eee655819c5bd;

});

parcelRegister("aMfes", function(module, exports) {

var $4HD7y = parcelRequire("4HD7y");


var $dNXVc = parcelRequire("dNXVc");


var $24P9d = parcelRequire("24P9d");


var $5MaNT = parcelRequire("5MaNT");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");

const $0b09362160fbf83a$var$codeBlockClassNames = {
    container: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    contentWrapped: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED,
    content: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
};
const $0b09362160fbf83a$var$MATCH_NEWLINES = new RegExp('\n', 'gu');
const $0b09362160fbf83a$var$getGutterBaseStyle = ()=>({
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        position: 'relative',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        boxSizing: 'content-box'
    });
const $0b09362160fbf83a$var$getGutterPadding = (allowCodeFolding)=>allowCodeFolding ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-100, 8px)";
const $0b09362160fbf83a$var$getGuttersWithLineNumbers = (content, config)=>[
        'div',
        {
            // Based on packages/editor/editor-common/src/styles/shared/code-block.ts
            // But we can't reuse that class as it adds a ::before that intefers with this approach
            style: (0, $24P9d.convertToInlineCss)({
                ...$0b09362160fbf83a$var$getGutterBaseStyle(),
                width: 'var(--lineNumberGutterWidth, 2rem)',
                /* top and bottom | left and right */ padding: $0b09362160fbf83a$var$getGutterPadding(config.allowCodeFolding)
            }),
            contenteditable: 'false'
        },
        [
            'div',
            {
                class: 'code-block-gutter-pseudo-element',
                style: (0, $24P9d.convertToInlineCss)({
                    textAlign: 'right',
                    color: "var(--ds-text-subtlest, #6B6E76)",
                    fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
                    whiteSpace: 'pre-wrap'
                }),
                'data-label': content
            }
        ]
    ];
const $0b09362160fbf83a$var$getFoldOnlyGutter = ()=>[
        'div',
        {
            style: (0, $24P9d.convertToInlineCss)({
                ...$0b09362160fbf83a$var$getGutterBaseStyle(),
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
            }),
            contenteditable: 'false'
        }
    ];
const $0b09362160fbf83a$var$getGutters = (content, config, hideLineNumbers)=>{
    if (!hideLineNumbers) return [
        $0b09362160fbf83a$var$getGuttersWithLineNumbers(content, config)
    ];
    if (config.allowCodeFolding) return [
        $0b09362160fbf83a$var$getFoldOnlyGutter()
    ];
    return [];
};
// Based on: `packages/editor/editor-plugin-code-block/src/nodeviews/code-block.ts`
const $0b09362160fbf83a$var$toDOM = (node, formattedAriaLabel, config)=>{
    let totalLineCount = 1;
    node.forEach((node)=>{
        const text = node.text;
        if (text) totalLineCount += (node.text.match($0b09362160fbf83a$var$MATCH_NEWLINES) || []).length;
    });
    const hideLineNumbers = (0, $dNXVc.areCodeBlockLineNumbersHidden)(node);
    const maxDigits = totalLineCount.toString().length;
    const content = node.textContent.split('\n').map((_, i)=>i + 1).join('\n');
    const gutters = $0b09362160fbf83a$var$getGutters(content, config, hideLineNumbers);
    const isCodeBlockWrapped = (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && node.attrs.wrap === true;
    const className = [
        $0b09362160fbf83a$var$codeBlockClassNames.container,
        isCodeBlockWrapped ? $0b09362160fbf83a$var$codeBlockClassNames.contentWrapped : undefined
    ].filter(Boolean).join(' ');
    return [
        'pre',
        {
            class: className,
            style: `--lineNumberGutterWidth:${maxDigits}ch;`,
            'data-language': node.attrs.language || '',
            ...(0, $dZ8uq.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && {
                'data-wrap': node.attrs.wrap ? 'true' : 'false',
                ...hideLineNumbers && {
                    'data-hide-line-numbers': 'true'
                }
            }
        },
        [
            'div',
            {
                class: $0b09362160fbf83a$var$codeBlockClassNames.start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: $0b09362160fbf83a$var$codeBlockClassNames.contentWrapper
            },
            ...gutters,
            [
                'div',
                {
                    class: $0b09362160fbf83a$var$codeBlockClassNames.content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel,
                        ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                            'data-local-id': node.attrs.localId
                        }
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: $0b09362160fbf83a$var$codeBlockClassNames.end,
                contenteditable: 'false'
            }
        ]
    ];
};
const $0b09362160fbf83a$export$3cf83e71c577e77b = (config)=>{
    return {
        ...(0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? (0, $4HD7y.codeBlock) : (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $4HD7y.codeBlockWithLocalId) : (0, $4HD7y.codeBlock),
        toDOM: (node)=>$0b09362160fbf83a$var$toDOM(node, '', config)
    };
};
module.exports["codeBlockNodeWithFixedToDOM"] = $0b09362160fbf83a$export$3cf83e71c577e77b;

});

parcelRegister("aBpO5", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $76ISC = parcelRequire("76ISC");


var $iNmBw = parcelRequire("iNmBw");

const $c622eb7762717460$export$ae829ec7b2625219 = (props)=>{
    return new (0, $1S4f7.SafePlugin)({
        props: {
            nodeViews: {
                codeBlock: (0, $76ISC.lazyCodeBlockView)(props)
            },
            // Custom selection behaviour to fix issues with codeblocks with Shift + Arrow{Up || Down}
            // These issues are also present in the prosemirror codemirror example and @marijnh suggests to
            // use custom event handlers: https://github.com/ProseMirror/website/issues/83
            handleKeyDown (view, event) {
                if (!(event instanceof KeyboardEvent)) return false;
                if (event.key === 'ArrowUp' && event.shiftKey) return (0, $iNmBw.shiftArrowUpWorkaround)(view, event);
                else if (event.key === 'ArrowDown' && event.shiftKey) return (0, $iNmBw.shiftArrowDownWorkaround)(view, event);
            }
        }
    });
};
module.exports["createPlugin"] = $c622eb7762717460$export$ae829ec7b2625219;

});

parcelRegister("76ISC", function(module, exports) {

var $ftpVl = parcelRequire("ftpVl");


const $ac8e0ae822b535d4$export$28da8fbeb01202c6 = (props)=>{
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'codeBlock',
        getNodeViewOptions: ()=>{},
        loader: async ()=>{
            const { getCodeBlockAdvancedNodeView: getCodeBlockAdvancedNodeView } = await (parcelRequire("ds8Ls"));
            return (node, view, getPos, _decs, _nodeViewOptions, innerDecorations)=>getCodeBlockAdvancedNodeView(props)(node, view, getPos, innerDecorations);
        }
    });
};
module.exports["lazyCodeBlockView"] = $ac8e0ae822b535d4$export$28da8fbeb01202c6;

});

parcelRegister("ds8Ls", function(module, exports) {

let $9cb4b054e295e36d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9cb4b054e295e36d$var$load("FOgP0"),
    $9cb4b054e295e36d$var$load("abd2b"),
    $9cb4b054e295e36d$var$load("6XNSn")
]).then(()=>parcelRequire('2SLpl'));

});

parcelRegister("iNmBw", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $1f2f0f9c198ac88d$export$d4559115ffe0b372 = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = Math.max($head.pos - 1, 1);
    const isNodeBefore = doc.resolve(pos).nodeBefore?.type === codeBlock;
    const maybeProblematicNode = isNodeBefore ? doc.resolve(pos).nodeBefore : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeBefore ? pos : $head.pos;
        tr.setSelection((0, $ks2lK.TextSelection).create(doc, $anchor.pos, Math.max(startPos - nodeSize, 0)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
const $1f2f0f9c198ac88d$export$ba335e235e59f4ed = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = $head.pos + 1;
    const isNodeAfter = doc.resolve(pos).nodeAfter?.type === codeBlock;
    const maybeProblematicNode = isNodeAfter ? doc.resolve(pos).nodeAfter : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeAfter ? pos : $head.pos;
        tr.setSelection((0, $ks2lK.TextSelection).create(doc, $anchor.pos, Math.min(startPos + nodeSize, doc.content.size)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
module.exports["shiftArrowUpWorkaround"] = $1f2f0f9c198ac88d$export$d4559115ffe0b372;
module.exports["shiftArrowDownWorkaround"] = $1f2f0f9c198ac88d$export$ba335e235e59f4ed;

});

parcelRegister("hcboS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $ahUGI = parcelRequire("ahUGI");

var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $1S4f7 = parcelRequire("1S4f7");


var $lOELb = parcelRequire("lOELb");


var $lNDSG = parcelRequire("lNDSG");


var $ks2lK = parcelRequire("ks2lK");


var $kVNt7 = parcelRequire("kVNt7");

var $lGf1F = parcelRequire("lGf1F");

var $injKz = parcelRequire("injKz");

var $aGYoD = parcelRequire("aGYoD");


var $1yB28 = parcelRequire("1yB28");


var $iu6m9 = parcelRequire("iu6m9");


var $kQc80 = parcelRequire("kQc80");


var $j0XxS = parcelRequire("j0XxS");


var $lhIns = parcelRequire("lhIns");


var $cKEEj = parcelRequire("cKEEj");


var $cTFYB = parcelRequire("cTFYB");


var $aFWfo = parcelRequire("aFWfo");

const $8d1c5078b4947753$export$144d1b98bacb98cc = (emoji, emojiProvider)=>({
        title: emoji.shortName || '',
        key: emoji.id || emoji.shortName,
        render ({ isSelected: isSelected, onClick: onClick, onHover: onHover }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kVNt7.default), {
                emoji: emoji,
                selected: isSelected,
                onMouseMove: onHover,
                onSelection: onClick,
                emojiProvider: emojiProvider
            });
        },
        emoji: emoji
    });
function $8d1c5078b4947753$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(emoji, emojiProvider) {
        // Check cache for hits
        const hit = seen.get(emoji.id || emoji.shortName);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(emoji, emojiProvider);
        seen.set(emoji.id || emoji.shortName, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $8d1c5078b4947753$var$memoizedToItem = $8d1c5078b4947753$export$fc10aeed3a532e2a($8d1c5078b4947753$export$144d1b98bacb98cc);
const $8d1c5078b4947753$var$defaultListLimit = 50;
const $8d1c5078b4947753$var$isFullShortName = (query)=>query && query.length > 1 && query.charAt(0) === ':' && query.charAt(query.length - 1) === ':';
const $8d1c5078b4947753$var$TRIGGER = ':';
function $8d1c5078b4947753$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $8d1c5078b4947753$export$d1221bd3f80501e0 = ({ config: options, api: api })=>{
    let previousEmojiProvider;
    const typeAhead = {
        id: (0, $lOELb.TypeAheadAvailableNodes).EMOJI,
        trigger: $8d1c5078b4947753$var$TRIGGER,
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(:)',
        headless: options ? options.headless : undefined,
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = $8d1c5078b4947753$var$getEmojiPluginState(editorState);
            const emojiProvider = pluginState.emojiProvider;
            if (!emojiProvider) return Promise.resolve([]);
            return new Promise((resolve)=>{
                const emojiProviderChangeHandler = {
                    result (emojiResult) {
                        if (!emojiResult || !emojiResult.emojis) resolve([]);
                        else {
                            const emojiItems = emojiResult.emojis.map((emoji)=>$8d1c5078b4947753$var$memoizedToItem.call(emoji, emojiProvider));
                            resolve(emojiItems);
                        }
                        emojiProvider.unsubscribe(emojiProviderChangeHandler);
                    }
                };
                emojiProvider.subscribe(emojiProviderChangeHandler);
                emojiProvider.filter($8d1c5078b4947753$var$TRIGGER.concat(query), {
                    limit: $8d1c5078b4947753$var$defaultListLimit,
                    skinTone: emojiProvider.getSelectedTone(),
                    sort: !query.length ? (0, $aGYoD.SearchSort).UsageFrequency : (0, $aGYoD.SearchSort).Default
                });
            });
        },
        forceSelect ({ query: query, items: items, editorState: editorState }) {
            const { asciiMap: asciiMap } = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(editorState) || {};
            const normalizedQuery = $8d1c5078b4947753$var$TRIGGER.concat(query);
            // if the query has space at the end
            // check the ascii map for emojis
            if (!options?.disableAutoformat && asciiMap && normalizedQuery.length >= 3 && normalizedQuery.endsWith(' ') && asciiMap.has(normalizedQuery.trim())) {
                const emoji = asciiMap.get(normalizedQuery.trim());
                return {
                    title: emoji?.name || '',
                    emoji: emoji
                };
            }
            const matchedItem = $8d1c5078b4947753$var$isFullShortName(normalizedQuery) ? items.find((item)=>item.title.toLowerCase() === normalizedQuery) : undefined;
            return matchedItem;
        },
        selectItem (state, item, insert, { mode: mode }) {
            const emojiPluginState = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(state);
            if (emojiPluginState.emojiProvider && emojiPluginState.emojiProvider.recordSelection && item.emoji) emojiPluginState.emojiProvider.recordSelection(item.emoji).then((0, $injKz.recordSelectionSucceededSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            })).catch((0, $injKz.recordSelectionFailedSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            }));
            const fragment = (0, $kQc80.createEmojiFragment)(state.doc, state.selection.$head, item.emoji);
            const tr = insert(fragment);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).TYPEAHEAD
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    };
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { emoji: emojiNodeType } = schema.nodes;
        if (node.type === emojiNodeType) {
            const newText = node.attrs.text;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'emoji',
        nodes () {
            return [
                {
                    name: 'emoji',
                    node: (0, $j0XxS.emojiNodeSpec)()
                }
            ];
        },
        usePluginHook () {
            (0, $42omo.useEffect)(()=>{
                $8d1c5078b4947753$var$delayUntilIdle(()=>{
                    (0, $lGf1F.preloadEmojiPicker)();
                });
            }, []);
        },
        pmPlugins () {
            return [
                {
                    name: 'emoji',
                    plugin: (pmPluginFactoryParams)=>{
                        return $8d1c5078b4947753$var$createEmojiPlugin(pmPluginFactoryParams, options, api);
                    }
                },
                {
                    name: 'emojiAsciiInputRule',
                    plugin: ({ schema: schema })=>(0, $cTFYB.inputRulePlugin)(schema, api?.analytics?.actions, api, options?.disableAutoformat)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { emojiResourceConfig: emojiResourceConfig, asciiMap: asciiMap, emojiProvider: emojiProvider, inlineEmojiPopupOpen: inlineEmojiPopupOpen, emojiProviderPromise: emojiProviderPromise } = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(editorState) ?? {};
            return {
                emojiResourceConfig: emojiResourceConfig,
                asciiMap: asciiMap,
                typeAheadHandler: typeAhead,
                emojiProvider: emojiProvider,
                emojiProviderPromise: emojiProviderPromise,
                inlineEmojiPopupOpen: inlineEmojiPopupOpen
            };
        },
        actions: {
            openTypeAhead: (0, $cKEEj.openTypeAhead)(typeAhead, api),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousEmojiProvider === provider || options?.emojiProvider === providerPromise) return false;
                previousEmojiProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$8d1c5078b4947753$var$setProviderTr(provider)(tr)) ?? false;
            }
        },
        commands: {
            insertEmoji: (0, $kQc80.insertEmoji)(api?.analytics?.actions)
        },
        contentComponent ({ editorView: editorView, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
            if (!api || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') || !editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aFWfo.InlineEmojiPopup), {
                api: api,
                editorView: editorView,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'emoji',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emoji),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emojiDescription),
                        priority: 500,
                        keyshortcut: ':',
                        isDisabledOffline: false,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pLGZ.IconEmoji), null),
                        action (insert) {
                            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                                exposure: true
                            })) {
                                // Clear slash
                                let tr = insert('');
                                tr = (0, $cKEEj.setInlineEmojiPopupOpen)(true)(tr);
                                return tr;
                            }
                            const tr = insert(undefined);
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead,
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).CLICKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $d925B.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'emoji'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $d925B.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Emoji floating toolbar',
                    nodeType: [
                        state.schema.nodes.emoji
                    ],
                    onPositionCalculated: (0, $lNDSG.calculateToolbarPositionAboveSelection)('Emoji floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark && isViewMode();
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-emoji-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                                title: intl.formatMessage((0, $ahUGI.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hgeg8.ToolTipContent), {
                                    description: intl.formatMessage((0, $ahUGI.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
/**
 * Actions
 */ const $8d1c5078b4947753$var$setAsciiMap = (asciiMap)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $cKEEj.setAsciiMap)(asciiMap)(state.tr);
            dispatch(tr);
        }
        return true;
    };
function $8d1c5078b4947753$export$ae9fa76f15c1e295(fn, limitTime, limitCount, onLimitReached) {
    let lastCallTime = 0;
    let callCount = 0;
    return function wrappedFn(...args) {
        const now = Date.now();
        if (now - lastCallTime < limitTime) {
            if (++callCount > limitCount) onLimitReached?.();
        } else {
            lastCallTime = now;
            callCount = 1;
        }
        return fn(...args);
    };
}
// At this stage console.error only
const $8d1c5078b4947753$var$logRateWarning = ()=>{};
const $8d1c5078b4947753$var$setProviderTr = $8d1c5078b4947753$export$ae9fa76f15c1e295((provider)=>(tr)=>(0, $cKEEj.setProvider)(provider)(tr), // If we change the emoji provider more than three times every 5 seconds we should warn.
// This seems like a really long time but the performance can be that laggy that we don't
// even get 3 events in 3 seconds and miss this indicator.
5000, 3, $8d1c5078b4947753$var$logRateWarning);
const $8d1c5078b4947753$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = $8d1c5078b4947753$var$setProviderTr(provider)(state.tr);
            dispatch(tr);
        }
        return true;
    };
const $8d1c5078b4947753$export$e3ef5170578bd8ba = new (0, $ks2lK.PluginKey)('emojiPlugin');
function $8d1c5078b4947753$var$getEmojiPluginState(state) {
    return $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(state) || {};
}
function $8d1c5078b4947753$var$createEmojiPlugin(pmPluginFactoryParams, options, api) {
    return new (0, $1S4f7.SafePlugin)({
        key: $8d1c5078b4947753$export$e3ef5170578bd8ba,
        state: {
            init () {
                if (options?.emojiProvider && (0, $iu6m9.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) return {
                    emojiProviderPromise: options.emojiProvider
                };
                return {};
            },
            apply (tr, pluginState) {
                const { action: action, params: params } = tr.getMeta($8d1c5078b4947753$export$e3ef5170578bd8ba) || {
                    action: null,
                    params: null
                };
                let newPluginState = pluginState;
                switch(action){
                    case (0, $cKEEj.ACTIONS).SET_PROVIDER:
                        newPluginState = {
                            ...pluginState,
                            emojiProvider: params.provider,
                            emojiProviderPromise: (0, $iu6m9.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true) ? Promise.resolve(params.provider) : undefined
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $cKEEj.ACTIONS).SET_ASCII_MAP:
                        newPluginState = {
                            ...pluginState,
                            asciiMap: params.asciiMap
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $cKEEj.ACTIONS).SET_INLINE_POPUP:
                        newPluginState = {
                            ...pluginState,
                            inlineEmojiPopupOpen: params.open
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                emoji: (node)=>{
                    return new (0, $lhIns.EmojiNodeView)(node, {
                        intl: pmPluginFactoryParams.getIntl(),
                        api: api,
                        emojiNodeDataProvider: options?.emojiNodeDataProvider
                    });
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'emojiProvider':
                        if (!providerPromise) return $8d1c5078b4947753$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch);
                        providerPromise.then((provider)=>{
                            $8d1c5078b4947753$var$setProvider?.(provider)?.(editorView.state, editorView.dispatch);
                            provider.getAsciiMap().then((asciiMap)=>{
                                $8d1c5078b4947753$var$setAsciiMap(asciiMap)(editorView.state, editorView.dispatch);
                            });
                        }).catch(()=>$8d1c5078b4947753$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch));
                        break;
                }
                return;
            };
            if (options?.emojiProvider) providerHandler('emojiProvider', options.emojiProvider);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('emojiProvider', providerHandler);
                }
            };
        }
    });
}
module.exports["emojiPlugin"] = $8d1c5078b4947753$export$d1221bd3f80501e0;
module.exports["emojiPluginKey"] = $8d1c5078b4947753$export$e3ef5170578bd8ba;

});

parcelRegister("kQc80", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $bYZ53 = parcelRequire("bYZ53");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

const $86388d1937acfc41$export$c62c7770bca4be17 = (doc, pos, emoji)=>{
    const { id: id = '', fallback: fallback, shortName: shortName } = emoji;
    const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)(pos);
    const emojiNode = doc.type.schema.nodes.emoji.createChecked({
        shortName: shortName,
        id: id,
        text: fallback || shortName
    }, null, annotationMarksForPos);
    const space = doc.type.schema.text(' ', annotationMarksForPos);
    return (0, $5SAOw.Fragment).fromArray([
        emojiNode,
        space
    ]);
};
const $86388d1937acfc41$export$8d5c072327044b6f = (editorAnalyticsAPI)=>(emojiId, inputMethod)=>{
        return ({ tr: tr })=>{
            const { doc: doc, selection: selection } = tr;
            const { emoji: emoji } = tr.doc.type.schema.nodes;
            if (emoji && emojiId) {
                const fragment = $86388d1937acfc41$export$c62c7770bca4be17(doc, selection.$head, emojiId);
                const newTr = (0, $8m4tT.safeInsert)(fragment)(tr);
                if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(newTr);
                newTr.setSelection((0, $ks2lK.Selection).near(newTr.doc.resolve(selection.$from.pos + fragment.size)));
                return newTr;
            }
            return null;
        };
    };
module.exports["createEmojiFragment"] = $86388d1937acfc41$export$c62c7770bca4be17;
module.exports["insertEmoji"] = $86388d1937acfc41$export$8d5c072327044b6f;

});

parcelRegister("j0XxS", function(module, exports) {

var $bIZRt = parcelRequire("bIZRt");


var $24P9d = parcelRequire("24P9d");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");

const $ef49a6b5d9cf65a1$var$isSSR = Boolean(undefined);
const $ef49a6b5d9cf65a1$export$d122e24cc43292f6 = ()=>{
    const emojiNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $bIZRt.emojiWithLocalId) : (0, $bIZRt.emoji);
    if ($ef49a6b5d9cf65a1$var$isSSR) return emojiNode;
    return {
        ...emojiNode,
        toDOM: (node)=>$ef49a6b5d9cf65a1$export$9edeb07c311f4561(node)
    };
};
function $ef49a6b5d9cf65a1$export$9edeb07c311f4561(node) {
    // From packages/elements/emoji/src/components/common/EmojiPlaceholder.tsx
    const { shortName: shortName, id: id, text: text } = node.attrs;
    const isEmojiScalingEnabled = (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true);
    const attrs = {
        'data-emoji-short-name': shortName,
        'data-emoji-id': id,
        'data-emoji-text': text,
        contenteditable: 'false',
        style: (0, $24P9d.convertToInlineCss)({
            content: "''",
            fill: "var(--ds-background-neutral, #0515240F)",
            ...isEmojiScalingEnabled ? {
                minWidth: '16.25px',
                minHeight: '16.25px'
            } : {
                minWidth: `20px`,
                width: `20px`,
                height: `20px`
            },
            position: 'relative',
            margin: '-1px 0',
            display: 'inline-block',
            background: "var(--ds-background-neutral, #0515240F)",
            borderRadius: "var(--ds-radius-small, 3px)",
            overflow: 'hidden',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            textAlign: 'center'
        }),
        'aria-busy': 'true',
        'aria-label': shortName,
        class: 'emoji-common-placeholder'
    };
    if ((0, $dh538.fg)('platform_editor_adf_with_localid')) attrs['data-local-id'] = node.attrs.localId;
    return [
        'span',
        attrs
    ];
}
module.exports["emojiNodeSpec"] = $ef49a6b5d9cf65a1$export$d122e24cc43292f6;
module.exports["emojiToDom"] = $ef49a6b5d9cf65a1$export$9edeb07c311f4561;

});

parcelRegister("lhIns", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $fjRlK = parcelRequire("fjRlK");


var $hTKp4 = parcelRequire("hTKp4");


var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");

var $98HrB = parcelRequire("98HrB");

var $ig7BH = parcelRequire("ig7BH");


var $hWRJP = parcelRequire("hWRJP");


var $jIvPx = parcelRequire("jIvPx");


var $91bcx = parcelRequire("91bcx");


var $5SAOw = parcelRequire("5SAOw");


var $fJJ4V = parcelRequire("fJJ4V");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");


var $j0XxS = parcelRequire("j0XxS");

const $14dc3fa642295a9f$var$SINGLE_EMOJI_REGEX = // Regular expression to match a single emoji character
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
RegExp("^(\\p{Emoji_Presentation}(?:[\\u{1F3FB}-\\u{1F3FF}])?|\\p{Extended_Pictographic}\\u{FE0F}(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)*|\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
function $14dc3fa642295a9f$export$1d677781db73ff20(fallbackText) {
    return $14dc3fa642295a9f$var$SINGLE_EMOJI_REGEX.test(fallbackText);
}
/**
 * Emoji node view for renderering emoji nodes
 */ const $14dc3fa642295a9f$var$EMOJI_TOOLTIP_CLASS = 'emoji-tooltip-editor';
class $14dc3fa642295a9f$export$cadc6675ce598ba8 {
    destroyTooltip() {
        this.tooltipInstance?.destroy();
        this.tooltipTarget?.removeAttribute('popovertarget');
        this.tooltipTarget?.removeAttribute('aria-describedby');
        this.tooltipInstance = undefined;
        this.tooltipTarget = undefined;
    }
    static logError(error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-emoji/EmojiNodeView'
        });
    }
    /** Type guard to check if a Node is an HTMLElement in a safe way. */ isHTMLElement(element) {
        if (element === null) return false;
        // In SSR `HTMLElement` is not defined, so we need to use duck typing here
        return 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    async updateDom(emojiProvider) {
        try {
            const { shortName: shortName, id: id, text: fallback } = this.node.attrs;
            const emojiDescription = await emojiProvider?.fetchByEmojiId({
                id: id,
                shortName: shortName,
                fallback: fallback
            }, true);
            if (!emojiDescription) {
                $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(new Error('Emoji description is not loaded'));
                this.renderFallback();
                return;
            }
            const unicodeEmoji = id && (0, $dZ8uq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true) ? (0, $fJJ4V.emojiIdToEmoji)(id) : undefined;
            const emojiRepresentation = unicodeEmoji ? {
                unicodeEmoji: unicodeEmoji
            } : emojiDescription?.representation;
            if (!$14dc3fa642295a9f$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(new Error('Emoji representation is not supported'));
                this.renderFallback();
                return;
            }
            this.renderEmoji(emojiDescription, emojiRepresentation);
        } catch (error) {
            $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error('Unknown error on EmojiNodeView updateDom'));
            this.renderFallback();
        }
    }
    static isEmojiRepresentationSupported(representation) {
        return !!representation && ('sprite' in representation || 'imagePath' in representation || 'mediaPath' in representation || 'unicodeEmoji' in representation);
    }
    static shouldRecordUnicodeEmojiExposure(description, representation) {
        return description.type === 'STANDARD' || 'unicodeEmoji' in representation;
    }
    // Pay attention, this method should be called only when the emoji provider returns
    // emoji data to prevent rendering empty emoji during loading.
    cleanUpAndRenderCommonAttributes() {
        this.destroyTooltip();
        // Clean up the DOM before rendering the new emoji
        if (this.domElement) {
            this.domElement.innerHTML = '';
            this.domElement.style.cssText = '';
            this.domElement.classList.remove((0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER);
            this.domElement.removeAttribute('aria-label'); // The label is set in the renderEmoji method
            this.domElement.removeAttribute('aria-busy');
        }
    }
    /**
   * Creates a VanillaTooltip on the given element showing the emoji shortName.
   * Gated behind the platform_editor_emoji_hover_show_tooltip experiment.
   * When the tooltip is active, the native `title` attribute is removed to avoid
   * showing both the browser tooltip and the custom tooltip.
   */ createTooltip(element, shortName) {
        if (!(0, $1oCLl.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true)) return;
        const tooltipId = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `emoji-tooltip-${crypto.randomUUID()}` : (0, (/*@__PURE__*/$parcel$interopDefault($fjRlK)))('emoji-tooltip-');
        try {
            const tooltipInstance = new (0, $jIvPx.VanillaTooltip)(// VanillaTooltip types expect HTMLButtonElement but works with any HTMLElement
            element, shortName, tooltipId, $14dc3fa642295a9f$var$EMOJI_TOOLTIP_CLASS, // default timeout
            300, // Inline styles are required because the Popover API promotes the tooltip
            // to the browser's top layer, where ancestor CSS selectors cannot reach it.
            {
                boxSizing: 'border-box',
                maxWidth: '240px',
                backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
                border: 'none',
                borderRadius: "var(--ds-radius-small, 3px)",
                color: "var(--ds-text-inverse, #FFFFFF)",
                font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                insetBlockStart: "var(--ds-space-0, 0px)",
                insetInlineStart: "var(--ds-space-0, 0px)",
                overflowWrap: 'break-word',
                paddingBlockStart: "var(--ds-space-050, 4px)",
                paddingBlockEnd: "var(--ds-space-050, 4px)",
                paddingInlineEnd: "var(--ds-space-075, 6px)",
                paddingInlineStart: "var(--ds-space-075, 6px)",
                whiteSpace: 'normal'
            });
            this.tooltipInstance = tooltipInstance;
            this.tooltipTarget = element;
            element.removeAttribute('title');
        } catch (error) {
            element.removeAttribute('popovertarget');
            element.removeAttribute('aria-describedby');
            $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error(String(error)));
        }
    }
    renderFallback() {
        this.renderingFallback = true;
        this.cleanUpAndRenderCommonAttributes();
        let doc = (0, $hTKp4.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const fallbackElement = doc.createElement('span');
        const { text: text, shortName: shortName } = this.node.attrs;
        // When the gate is enabled and the emoji is "custom" (i.e. its fallback
        // text is not a single standard Unicode emoji), render the Unicode
        // Replacement Character (U+FFFD) instead of the shortName text. Standard
        // emojis continue to fall back to their Unicode text representation.
        const fallbackText = text || shortName;
        const useReplacementChar = (0, $dh538.fg)('platform_editor_custom_emoji_unicode_fallback') && !$14dc3fa642295a9f$export$1d677781db73ff20(fallbackText);
        const renderedFallbackText = useReplacementChar ? '\uFFFD' : fallbackText;
        fallbackElement.innerText = renderedFallbackText;
        fallbackElement.setAttribute('role', 'img');
        fallbackElement.setAttribute('title', shortName);
        fallbackElement.setAttribute('aria-label', shortName);
        fallbackElement.setAttribute('data-testid', `fallback-emoji-${shortName}`);
        fallbackElement.setAttribute('data-emoji-type', 'fallback');
        this.dom.appendChild(fallbackElement);
        this.createTooltip(fallbackElement, shortName);
    }
    renderEmoji(description, representation) {
        this.renderingFallback = false;
        this.cleanUpAndRenderCommonAttributes();
        const emojiType = 'unicodeEmoji' in representation ? 'unicode' : 'sprite' in representation ? 'sprite' : 'image';
        let doc = (0, $hTKp4.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        // Add wrapper for the emoji
        const containerElement = doc.createElement('span');
        containerElement.setAttribute('role', 'img');
        containerElement.setAttribute('title', description.shortName);
        containerElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER);
        containerElement.setAttribute('data-testid', `${emojiType}-emoji-${description.shortName}`);
        containerElement.setAttribute('data-emoji-type', emojiType);
        containerElement.setAttribute('aria-label', `${this.intl.formatMessage((0, $ig7BH.messages).emojiNodeLabel)} ${description.shortName}`);
        const emojiElement = 'unicodeEmoji' in representation ? this.createUnicodeEmojiElement(representation.unicodeEmoji) : 'sprite' in representation ? this.createSpriteEmojiElement(representation) : this.createImageEmojiElement(description, representation);
        containerElement.appendChild(emojiElement);
        this.dom.appendChild(containerElement);
        if ($14dc3fa642295a9f$export$cadc6675ce598ba8.shouldRecordUnicodeEmojiExposure(description, representation)) (0, $1oCLl.expValEquals)('platform_use_unicode_emojis', 'isEnabled', true);
        this.createTooltip(containerElement, description.shortName);
    }
    createUnicodeEmojiElement(emoji) {
        let doc = (0, $hTKp4.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const spanElement = doc.createElement('span');
        spanElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_UNICODE);
        spanElement.textContent = emoji;
        spanElement.style.display = 'inline-flex';
        spanElement.style.fontSize = `var(--emoji-common-unicode-size, ${0, $fhsiz.defaultEmojiHeight}px)`;
        spanElement.style.alignItems = 'center';
        spanElement.style.aspectRatio = '1/1';
        spanElement.style.lineHeight = '1em';
        spanElement.style.margin = '-1px 0';
        spanElement.style.verticalAlign = 'middle'; // to keep vertical alignment consistent with images
        return spanElement;
    }
    createSpriteEmojiElement(representation) {
        let doc = (0, $hTKp4.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const spriteElement = doc.createElement('span');
        spriteElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE);
        const sprite = representation.sprite;
        const xPositionInPercent = 100 / (sprite.column - 1) * representation.xIndex;
        const yPositionInPercent = 100 / (sprite.row - 1) * representation.yIndex;
        spriteElement.style.backgroundImage = `url(${sprite.url})`;
        spriteElement.style.backgroundPosition = `${xPositionInPercent}% ${yPositionInPercent}%`;
        spriteElement.style.backgroundSize = `${sprite.column * 100}% ${sprite.row * 100}%`;
        spriteElement.style.minWidth = `${0, $fhsiz.defaultEmojiHeight}px`;
        spriteElement.style.minHeight = `${0, $fhsiz.defaultEmojiHeight}px`;
        if (!(0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) {
            spriteElement.style.width = `${0, $fhsiz.defaultEmojiHeight}px`;
            spriteElement.style.height = `${0, $fhsiz.defaultEmojiHeight}px`;
        }
        return spriteElement;
    }
    createImageEmojiElement(emojiDescription, representation) {
        let doc = (0, $hTKp4.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const imageElement = doc.createElement('img');
        imageElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE);
        imageElement.src = 'imagePath' in representation ? representation.imagePath : representation.mediaPath;
        imageElement.loading = 'lazy';
        imageElement.alt = emojiDescription.name || emojiDescription.shortName;
        imageElement.style.minWidth = `${0, $fhsiz.defaultEmojiHeight}px`;
        imageElement.style.objectFit = 'contain';
        imageElement.height = (0, $fhsiz.defaultEmojiHeight);
        imageElement.onerror = ()=>{
            if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
                // If there's an error (ie. offline) render the ascii fallback if possible, otherwise
                // mark the node to refresh when returning online.
                // Create a check that confirms if this.node.attrs.text if an ascii emoji
                if ($14dc3fa642295a9f$export$1d677781db73ff20(this.node.attrs.text)) this.renderFallback();
                else this.renderingFallback = true;
            } else this.renderFallback();
        };
        return imageElement;
    }
    /**
   * Prosemirror node view for rendering emoji nodes. This class is responsible for
   * rendering emoji nodes in the editor, handling updates, and managing fallback rendering.
   *
   * @param node - The ProseMirror node representing the emoji.
   * @param extraProps - An object containing additional parameters.
   * @param extraProps.intl - The internationalization object for formatting messages.
   * @param extraProps.api - The editor API for accessing shared state and connectivity features.
   * @param extraProps.emojiNodeDataProvider - (Optional) A provider for fetching emoji data.
   *
   * @example
   * const emojiNodeView = new EmojiNodeView(node, { intl, api, emojiNodeDataProvider });
   */ constructor(node, { intl: intl, api: api, emojiNodeDataProvider: emojiNodeDataProvider }){
        this.dom = void 0;
        this.domElement = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.renderingFallback = false;
        this.tooltipInstance = void 0;
        this.tooltipTarget = void 0;
        this.destroy = ()=>{
            if ((this.tooltipInstance || this.tooltipTarget) && (0, $1oCLl.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true)) this.destroyTooltip();
        };
        this.node = node;
        this.intl = intl;
        const { dom: dom } = (0, $5SAOw.DOMSerializer).renderSpec(document, (0, $j0XxS.emojiToDom)(this.node));
        this.dom = dom;
        this.domElement = this.isHTMLElement(dom) ? dom : undefined;
        if (emojiNodeDataProvider) {
            let previousEmojiDescription;
            emojiNodeDataProvider.getData(node, (payload)=>{
                if (payload.error) {
                    $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(payload.error);
                    this.renderFallback();
                    return;
                }
                const optionalEmojiDescription = payload.data;
                if (!optionalEmojiDescription) {
                    this.renderFallback();
                    return;
                }
                const emojiRepresentation = optionalEmojiDescription?.representation;
                if (!$14dc3fa642295a9f$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                    this.renderFallback();
                    return;
                }
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(previousEmojiDescription, optionalEmojiDescription)) // Do not re-render if the emoji description is the same as before
                return;
                previousEmojiDescription = optionalEmojiDescription;
                this.renderEmoji(optionalEmojiDescription, emojiRepresentation);
            });
        } else {
            if ((0, $eTj7Y.isSSR)()) // The provider doesn't work in SSR, and we don't want to render fallback in SSR,
            // that's why we don't need to continue node rendering.
            // In SSR we want to show a placeholder, that `emojiToDom()` returns.
            return;
            // We use the `emojiProvider` from the shared state
            // because it supports the `emojiProvider` prop in the `ComposableEditor` options
            // as well as the `emojiProvider` in the `EmojiPlugin` options.
            const sharedState = api?.emoji?.sharedState;
            if (!sharedState) return;
            let emojiProvider = sharedState.currentState()?.emojiProvider;
            if (emojiProvider) this.updateDom(emojiProvider);
            const unsubscribe = sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (emojiProvider === nextSharedState?.emojiProvider) // Do not update if the provider is the same
                return;
                emojiProvider = nextSharedState?.emojiProvider;
                this.updateDom(emojiProvider);
            });
            // Refresh emojis if we go back online
            const subscribeToConnection = api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
                if ((0, $91bcx.isOfflineMode)(prevSharedState?.mode) && nextSharedState?.mode === 'online' && this.renderingFallback && (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) this.updateDom(sharedState.currentState()?.emojiProvider);
            });
            this.destroy = ()=>{
                unsubscribe();
                subscribeToConnection?.();
                this.destroyTooltip();
            };
        }
    }
}
module.exports["EmojiNodeView"] = $14dc3fa642295a9f$export$cadc6675ce598ba8;

});

parcelRegister("fjRlK", function(module, exports) {

var $fPVB6 = parcelRequire("fPVB6");

/** Used to generate unique IDs. */ var $b272038ac29335d7$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $b272038ac29335d7$var$uniqueId(prefix) {
    var id = ++$b272038ac29335d7$var$idCounter;
    return $fPVB6(prefix) + id;
}
module.exports = $b272038ac29335d7$var$uniqueId;

});

parcelRegister("ig7BH", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $2faac4f2f00836b4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});
module.exports["messages"] = $2faac4f2f00836b4$export$defe85febe8b728c;

});

parcelRegister("jIvPx", function(module, exports) {

var $i4Myo = parcelRequire("i4Myo");


var $fFa3V = parcelRequire("fFa3V");

const $6f35ce5a454a5878$var$startingOffset = {
    name: 'offset',
    options: {
        offset: [
            0,
            4
        ]
    }
};
const $6f35ce5a454a5878$var$endingOffset = {
    name: 'offset',
    options: {
        offset: [
            0,
            8
        ]
    }
};
class $6f35ce5a454a5878$export$47a232ed95817c75 {
    createPopperInstance() {
        this.popperInstance = (0, $i4Myo.createPopper)(this.button, this.tooltip, {
            placement: 'top',
            modifiers: [
                $6f35ce5a454a5878$var$startingOffset
            ]
        });
    }
    destroy() {
        this.popperInstance?.destroy();
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    hide(immediate = false) {
        clearTimeout(this.currentTimeoutId);
        this.shouldHidePopover = true;
        // Disable the event listeners
        this.currentTimeoutId = setTimeout(()=>{
            this.popperInstance?.setOptions((options)=>({
                    ...options,
                    modifiers: [
                        $6f35ce5a454a5878$var$startingOffset,
                        {
                            name: 'eventListeners',
                            enabled: false
                        }
                    ]
                }));
            this.tooltip.style.opacity = '0';
            this.isDisplayed = false;
            // If transition animations are disabled immediately hide the popover
            if (this.tooltip.style.transition === 'none') this.tooltip.hidePopover();
        }, immediate ? 0 : this.timeout);
    }
    show() {
        if (this.isDisplayed) return;
        clearTimeout(this.currentTimeoutId);
        this.shouldHidePopover = false;
        // Make the tooltip visible - but hide until
        this.tooltip.style.visibility = 'hidden';
        this.tooltip.showPopover();
        // Update its position
        if (!this.popperInstance) this.createPopperInstance();
        else this.popperInstance.update();
        // Enable the event listeners
        this.currentTimeoutId = setTimeout(()=>{
            this.tooltip.style.opacity = '1';
            this.tooltip.style.visibility = 'visible';
            this.popperInstance?.setOptions((options)=>({
                    ...options,
                    modifiers: [
                        $6f35ce5a454a5878$var$endingOffset,
                        {
                            name: 'eventListeners',
                            enabled: true
                        }
                    ]
                }));
            this.isDisplayed = true;
        }, this.timeout);
    }
    constructor(button, content, /**
   * Id associated to the tooltip - must be unique.
   */ id, /**
   * Class Name – used for styling.
   */ className, timeout = 300, /**
   * Optional inline styles to apply directly to the tooltip element.
   * Useful when the tooltip is rendered in the browser's top layer (via Popover API),
   * where ancestor CSS selectors cannot reach it.
   */ styles){
        this.button = button;
        this.timeout = timeout;
        this.popperInstance = void 0;
        this.listeners = [];
        this.currentTimeoutId = void 0;
        this.shouldHidePopover = false;
        this.tooltip = void 0;
        this.isDisplayed = false;
        const tooltip = document.createElement('span');
        tooltip.role = 'tooltip';
        tooltip.popover = 'hint';
        tooltip.className = className;
        tooltip.id = id;
        tooltip.textContent = content;
        if (styles) Object.assign(tooltip.style, styles);
        this.tooltip = tooltip;
        // Button preparation
        button.appendChild(tooltip);
        // Prepare the button to have the popover target and accessibility properties
        button.setAttribute('popovertarget', tooltip.id);
        button.setAttribute('aria-describedby', tooltip.id);
        const showEvents = [
            'mouseenter',
            'focus'
        ];
        const hideEvents = [
            'mouseleave',
            'blur'
        ];
        showEvents.forEach((event)=>{
            this.listeners.push((0, $fFa3V.bind)(button, {
                type: event,
                listener: ()=>this.show()
            }));
        });
        hideEvents.forEach((event)=>{
            this.listeners.push((0, $fFa3V.bind)(button, {
                type: event,
                listener: ()=>this.hide()
            }));
        });
        this.listeners.push((0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') this.hide(true);
            }
        }));
        // Hide the tooltip if the hide transition has completed
        this.tooltip.ontransitionend = ()=>{
            if (this.shouldHidePopover) this.tooltip.hidePopover();
        };
    }
}
module.exports["VanillaTooltip"] = $6f35ce5a454a5878$export$47a232ed95817c75;

});

parcelRegister("cKEEj", function(module, exports) {

var $hcboS = parcelRequire("hcboS");

const $38eca9ebbfac95ba$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_ASCII_MAP: 'SET_ASCII_MAP',
    SET_INLINE_POPUP: 'SET_INLINE_POPUP'
};
const $38eca9ebbfac95ba$export$5e8f481ab8296997 = (asciiMap)=>(tr)=>{
        return tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_ASCII_MAP,
            params: {
                asciiMap: asciiMap
            }
        });
    };
const $38eca9ebbfac95ba$export$adbec20dbbf15a6b = (typeaheadHandler, api)=>(inputMethod)=>{
        return Boolean(api?.typeAhead?.actions.open({
            triggerHandler: typeaheadHandler,
            inputMethod: inputMethod
        }));
    };
const $38eca9ebbfac95ba$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        });
    };
const $38eca9ebbfac95ba$export$f53f9c9a74ec859b = (open)=>(tr)=>tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_INLINE_POPUP,
            params: {
                open: open
            }
        });
module.exports["ACTIONS"] = $38eca9ebbfac95ba$export$92a1a3b7554e9387;
module.exports["setAsciiMap"] = $38eca9ebbfac95ba$export$5e8f481ab8296997;
module.exports["openTypeAhead"] = $38eca9ebbfac95ba$export$adbec20dbbf15a6b;
module.exports["setProvider"] = $38eca9ebbfac95ba$export$1572b3eade6662f9;
module.exports["setInlineEmojiPopupOpen"] = $38eca9ebbfac95ba$export$f53f9c9a74ec859b;

});

parcelRegister("cTFYB", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $4VXMf = parcelRequire("4VXMf");


var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");

let $4f54215972d22941$var$matcher;
function $4f54215972d22941$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi, disableAutoformat) {
    if (disableAutoformat) return;
    if (schema.nodes.emoji) {
        $4f54215972d22941$var$initMatcher(pluginInjectionApi);
        const asciiEmojiRule = (0, $4VXMf.createRule)($4f54215972d22941$var$AsciiEmojiMatcher.REGEX, $4f54215972d22941$var$inputRuleHandler(editorAnalyticsAPI));
        return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('emoji', [
            asciiEmojiRule
        ]));
    }
    return;
}
function $4f54215972d22941$var$initMatcher(pluginInjectionApi) {
    pluginInjectionApi?.emoji.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        const emojiProvider = nextSharedState?.emojiProvider;
        if (emojiProvider) emojiProvider.getAsciiMap().then((map)=>{
            $4f54215972d22941$var$matcher = new $4f54215972d22941$var$RecordingAsciiEmojiMatcher(emojiProvider, map);
        });
    });
}
const $4f54215972d22941$var$inputRuleHandler = (editorAnalyticsAPI)=>(state, matchParts, start, end)=>{
        if (!$4f54215972d22941$var$matcher) return null;
        const match = $4f54215972d22941$var$matcher.match(matchParts);
        if (match) {
            const transactionCreator = new $4f54215972d22941$var$AsciiEmojiTransactionCreator(state, match, start, end, editorAnalyticsAPI);
            return transactionCreator.create();
        }
        return null;
    };
const $4f54215972d22941$var$REGEX_LEADING_CAPTURE_INDEX = 1;
const $4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES = 2;
const $4f54215972d22941$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
const $4f54215972d22941$var$REGEX_TRAILING_CAPTURE_INDEX = 4;
const $4f54215972d22941$var$getLeadingString = (match, withParenthesis = true)=>match[$4f54215972d22941$var$REGEX_LEADING_CAPTURE_INDEX] + (withParenthesis ? match[$4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES] : '');
const $4f54215972d22941$var$getLeadingStringWithoutParentheses = (match)=>$4f54215972d22941$var$getLeadingString(match, false);
const $4f54215972d22941$var$getAscii = (match, withParentheses = false)=>(withParentheses ? match[$4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES] : '') + match[$4f54215972d22941$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
const $4f54215972d22941$var$getAsciiWithParentheses = (matchParts)=>$4f54215972d22941$var$getAscii(matchParts, true);
const $4f54215972d22941$var$getTrailingString = (match)=>match[$4f54215972d22941$var$REGEX_TRAILING_CAPTURE_INDEX] || '';
class $4f54215972d22941$var$AsciiEmojiMatcher {
    match(matchParts) {
        return this.getAsciiEmojiMatch($4f54215972d22941$var$getLeadingStringWithoutParentheses(matchParts), $4f54215972d22941$var$getAsciiWithParentheses(matchParts), $4f54215972d22941$var$getTrailingString(matchParts)) || this.getAsciiEmojiMatch($4f54215972d22941$var$getLeadingString(matchParts), $4f54215972d22941$var$getAscii(matchParts), $4f54215972d22941$var$getTrailingString(matchParts));
    }
    getAsciiEmojiMatch(leading, ascii, trailing) {
        const emoji = this.asciiToEmojiMap.get(ascii);
        return emoji ? {
            emoji: emoji,
            leadingString: leading,
            trailingString: trailing
        } : undefined;
    }
    constructor(asciiToEmojiMap){
        this.asciiToEmojiMap = void 0;
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
}
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */ /**
 * This regex matches 2 scenarios:
 * 1. an emoticon starting with a colon character (e.g. :D => 😃)
 * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
 *
 * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
 *
 *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
 *    Non-capturing group (?:^|[\s\ufffc])
 *      1st Alternative ^
 *        ^ asserts position at start of the string
 *      2nd Alternative [\s\ufffc]
 *        matches a single character present in [\s\ufffc]
 *    Non-capturing group (?:\(*?)
 *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
 *  2nd Capturing Group (\(?)
 *    matches a single ( if present
 *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
 *    1st Alternative [^:\s\ufffc\(]\S{1,3}
 *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *    2nd Alternative :\S{1,3}( )
 *      : matches the character : literally
 *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *  4th Capturing Group ( )
 *
 * See https://regex101.com/r/HRS9O2/4
 */ // New behavior: All emoticons require whitespace after them
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
$4f54215972d22941$var$AsciiEmojiMatcher.REGEX = new RegExp(`((?:^|[\\s${(0, $14sLv.leafNodeReplacementCharacter)}])(?:\\(*?))(\\(?)([^:\\s${(0, $14sLv.leafNodeReplacementCharacter)}\\(]\\S{1,3}|:\\S{1,3})([\\s\\t\\n])$`);
class $4f54215972d22941$var$RecordingAsciiEmojiMatcher extends $4f54215972d22941$var$AsciiEmojiMatcher {
    match(matchParts) {
        const match = super.match(matchParts);
        if (match && this.emojiProvider.recordSelection) this.emojiProvider.recordSelection(match.emoji);
        return match;
    }
    constructor(emojiProvider, asciiToEmojiMap){
        super(asciiToEmojiMap);
        this.emojiProvider = void 0;
        this.emojiProvider = emojiProvider;
    }
}
class $4f54215972d22941$var$AsciiEmojiTransactionCreator {
    create() {
        const tr = this.state.tr.replaceWith(this.from, this.to, this.createNodes());
        this.editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).ASCII
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    get from() {
        return this.start + this.match.leadingString.length;
    }
    get to() {
        return this.end;
    }
    createNodes() {
        const nodes = [
            this.createEmojiNode()
        ];
        if (this.trailingTextNodeRequired()) nodes.push(this.createTrailingTextNode());
        return nodes;
    }
    createEmojiNode() {
        const { emoji: emojiTypeNode } = this.state.schema.nodes;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    }
    getEmojiNodeAttrs() {
        const emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName
        };
    }
    trailingTextNodeRequired() {
        return this.match.trailingString.length > 0;
    }
    createTrailingTextNode() {
        return this.state.schema.text(this.match.trailingString);
    }
    constructor(state, match, start, end, editorAnalyticsAPI){
        this.state = void 0;
        this.match = void 0;
        this.start = void 0;
        this.end = void 0;
        this.editorAnalyticsAPI = void 0;
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
    }
}
const $4f54215972d22941$var$plugins = (schema, providerFactory, featureFlags, editorAnalyticsAPI, pluginInjectionApi)=>{
    return [
        $4f54215972d22941$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi)
    ].filter((plugin)=>!!plugin);
};
var $4f54215972d22941$export$2e2bcd8739ae039 = $4f54215972d22941$var$plugins;
module.exports["inputRulePlugin"] = $4f54215972d22941$export$568a7ed6897c4817;

});

parcelRegister("aFWfo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $d925B = parcelRequire("d925B");


var $kuh1P = parcelRequire("kuh1P");


var $1Oo9w = parcelRequire("1Oo9w");


var $jwWgu = parcelRequire("jwWgu");


var $wJ8xb = parcelRequire("wJ8xb");

var $efG2U = parcelRequire("efG2U");


var $b3YrF = parcelRequire("b3YrF");


var $aFUXX = parcelRequire("aFUXX");


var $fnia6 = parcelRequire("fnia6");


var $dh538 = parcelRequire("dh538");


var $cKEEj = parcelRequire("cKEEj");

const $5da86e14354f1f0f$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
const $5da86e14354f1f0f$var$emojiPopupMessages = {
    emojiPickerAriaLabel: {
        id: 'fabric.emoji.picker.aria.label',
        defaultMessage: 'Emoji picker',
        description: 'Accessible label for the emoji picker popup'
    }
};
const $5da86e14354f1f0f$export$b7ec9ebb3bbf8534 = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, onClose: onClose })=>{
    const { emojiProvider: emojiProvider, inlineEmojiPopupOpen: isOpen } = (0, $1Oo9w.useSharedPluginState)(api, [
        'emoji'
    ])?.emojiState ?? {};
    const intl = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        if (isOpen && (0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        isOpen,
        api
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        onClose?.();
    }, [
        onClose,
        api
    ]);
    const focusEditor = (0, $42omo.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $42omo.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $d925B.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    if (!isOpen || !emojiProvider) return null;
    const domRef = (0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5da86e14354f1f0f$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($5da86e14354f1f0f$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wJ8xb.OutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fnia6.EmojiPicker), {
            emojiProvider: Promise.resolve(emojiProvider),
            onPickerRef: setOutsideClickTargetRef,
            onSelection: handleSelection
        })));
};
const $5da86e14354f1f0f$var$InlineEmojiPopupContent = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const emojiProvider = (0, $b3YrF.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const intl = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        api?.core.actions,
        api?.metrics?.commands
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        editorView.dispatch((0, $cKEEj.setInlineEmojiPopupOpen)(false)(editorView.state.tr));
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
    }, [
        editorView,
        api.core.actions,
        api.metrics?.commands
    ]);
    const focusEditor = (0, $42omo.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $42omo.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $d925B.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    const domRef = (0, $42omo.useMemo)(()=>(0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions), [
        editorView,
        api?.analytics?.actions
    ]);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5da86e14354f1f0f$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($5da86e14354f1f0f$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wJ8xb.OutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fnia6.EmojiPicker), {
            emojiProvider: Promise.resolve(emojiProvider),
            onPickerRef: setOutsideClickTargetRef,
            onSelection: handleSelection
        })));
};
const $5da86e14354f1f0f$export$295b54f3ba0abfa5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const isOpen = (0, $b3YrF.useSharedPluginStateSelector)(api, 'emoji.inlineEmojiPopupOpen');
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5da86e14354f1f0f$var$InlineEmojiPopupContent, {
        api: api,
        editorView: editorView,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement
    });
});
module.exports["InlineEmojiPopup"] = $5da86e14354f1f0f$export$295b54f3ba0abfa5;

});

parcelRegister("kuh1P", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $d925B = parcelRequire("d925B");

const $7e8a46109aa777b7$export$49d74ed2464a12b9 = (view, actionSubjectId, editorAnalyticsAPI)=>{
    try {
        const domRef = (0, $8m4tT.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (editorAnalyticsAPI) {
            const payload = {
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                actionSubjectId: actionSubjectId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            editorAnalyticsAPI.fireAnalyticsEvent(payload);
        }
    }
};
module.exports["getDomRefFromSelection"] = $7e8a46109aa777b7$export$49d74ed2464a12b9;

});

parcelRegister("cu2RD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jvymJ = parcelRequire("jvymJ");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $lYyGb = parcelRequire("lYyGb");


var $dzypS = parcelRequire("dzypS");


var $31vtz = parcelRequire("31vtz");


var $dLPJI = parcelRequire("dLPJI");


var $hpaOT = parcelRequire("hpaOT");


var $cdbrp = parcelRequire("cdbrp");


var $hCfMV = parcelRequire("hCfMV");

const $7ff11d0606ef5fb6$export$8751de4ba1d9a8f9 = ({ api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdbrp.PrimaryToolbarHighlightColorWithIntl), {
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            pluginInjectionApi: api,
            editorView: editorView
        });
    };
    if (!isToolbarAIFCEnabled) api?.primaryToolbar?.actions.registerComponent({
        name: 'highlight',
        component: primaryToolbarComponent
    });
    else api?.toolbar?.actions.registerComponents((0, $hCfMV.getToolbarComponent)(api));
    return {
        name: 'highlight',
        marks () {
            if ((0, $1oCLl.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) || (0, $1oCLl.expValEquals)('platform_editor_lovability_color_schema_change', 'isEnabled', true)) return [
                {
                    name: 'backgroundColor',
                    mark: (0, $jvymJ.backgroundColor)
                }
            ];
            // color is defined in platform/packages/editor/adf-schema/src/next-schema/marks/color.ts
            return [
                {
                    name: 'backgroundColor',
                    mark: {
                        ...(0, $jvymJ.backgroundColor),
                        excludes: 'color'
                    }
                }
            ];
        },
        commands: {
            changeColor: (0, $lYyGb.changeColor)(editorAnalyticsAPI)
        },
        pmPlugins: ()=>{
            const plugins = [
                {
                    name: 'highlight',
                    plugin: ()=>(0, $dLPJI.createPlugin)({
                            api: api
                        })
                },
                {
                    name: 'highlightKeymap',
                    plugin: ()=>(0, $31vtz.keymapPlugin)({
                            api: api
                        })
                },
                {
                    name: 'highlightPadding',
                    plugin: ()=>(0, $dzypS.createHighlightPaddingPlugin)()
                }
            ];
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $dLPJI.highlightPluginKey).getState(editorState);
        },
        pluginsOptions: !isToolbarAIFCEnabled ? {
            selectionToolbar () {
                const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, dispatchAnalyticsEvent)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpaOT.FloatingToolbarHighlightColorWithIntl), {
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                pluginInjectionApi: api,
                                editorView: view
                            }),
                        fallback: []
                    };
                    const rank = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 5 : -9;
                    return {
                        rank: rank,
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        pluginName: 'highlight'
                    };
                } else return undefined;
            }
        } : {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["highlightPlugin"] = $7ff11d0606ef5fb6$export$8751de4ba1d9a8f9;

});

parcelRegister("lYyGb", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $eD3dl = parcelRequire("eD3dl");

var $b167b = parcelRequire("b167b");


var $kjBYH = parcelRequire("kjBYH");


var $5qdhe = parcelRequire("5qdhe");

var $fEGA1 = parcelRequire("fEGA1");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $dLPJI = parcelRequire("dLPJI");


var $kRdr9 = parcelRequire("kRdr9");

const $443070aebdee33c1$var$maybeSyncSelectionAfterFormat = (tr)=>{
    if (tr.docChanged && (0, $1oCLl.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true)) tr.setMeta((0, $kjBYH.FORMAT_SELECTION_SYNC_META), true);
};
const $443070aebdee33c1$export$917538e4f4eb20f9 = (editorAnalyticsAPI)=>({ color: color, inputMethod: inputMethod })=>({ tr: tr })=>{
            const { marks: marks } = tr.doc.type.schema;
            const { backgroundColor: backgroundColor } = tr.doc.type.schema.marks;
            if (!backgroundColor) return null;
            editorAnalyticsAPI?.attachAnalyticsEvent($443070aebdee33c1$var$createAnalyticsEvent(color, inputMethod, tr))(tr);
            tr.scrollIntoView();
            if (color === (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR)) (0, $eD3dl.removeMark)(backgroundColor)({
                tr: tr
            });
            else {
                if ((0, $1oCLl.expValEquals)('platform_editor_lovability_color_schema_change', 'isEnabled', true) && !(0, $1oCLl.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) {
                    const overrideMarks = [
                        'textColor'
                    ];
                    overrideMarks.forEach((mark)=>{
                        if (marks[mark]) (0, $eD3dl.removeMark)(marks[mark])({
                            tr: tr
                        });
                    });
                }
                tr.setMeta((0, $dLPJI.highlightPluginKey), {
                    type: (0, $dLPJI.HighlightPluginAction).CHANGE_COLOR,
                    color: color
                });
                (0, $b167b.toggleMark)(backgroundColor, {
                    color: color
                })({
                    tr: tr
                });
            }
            $443070aebdee33c1$var$maybeSyncSelectionAfterFormat(tr);
            return tr;
        };
const $443070aebdee33c1$var$createAnalyticsEvent = (color, inputMethod, tr)=>{
    const previousColor = (0, $kRdr9.getActiveColor)(tr) ?? (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR);
    const highlightPalette = (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? (0, $fEGA1.highlightColorPaletteNew) : (0, $5qdhe.highlightColorPalette);
    // get color names from palette
    const newColorFromPalette = highlightPalette.find(({ value: value })=>value === color);
    const previousColorFromPalette = highlightPalette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : color;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor;
    return {
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel ? previousColorLabel.toLowerCase() : '',
            inputMethod: inputMethod
        }
    };
};
module.exports["changeColor"] = $443070aebdee33c1$export$917538e4f4eb20f9;

});

parcelRegister("fEGA1", function(module, exports) {

var $jvymJ = parcelRequire("jvymJ");


var $hMewq = parcelRequire("hMewq");


var $5qdhe = parcelRequire("5qdhe");


var $kUgQN = parcelRequire("kUgQN");


var $fWSjz = parcelRequire("fWSjz");

const $7a76bb43b44d4ee9$export$7dee00034afd0ce = [
    {
        value: (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR),
        label: 'No color',
        // Mostly informative, only used for analytics
        border: "var(--ds-border, #0B120E24)",
        message: (0, $hMewq.default)((0, $fWSjz.default), 'no-color')
    }
];
(0, $jvymJ.backgroundColorPaletteNew).forEach((label, color)=>{
    $7a76bb43b44d4ee9$export$7dee00034afd0ce.push((0, $kUgQN.mapPaletteColor)(label, color));
});
module.exports["highlightColorPaletteNew"] = $7a76bb43b44d4ee9$export$7dee00034afd0ce;

});

parcelRegister("dLPJI", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $kRdr9 = parcelRequire("kRdr9");


var $2gsYp = parcelRequire("2gsYp");

const $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0 = new (0, $ks2lK.PluginKey)('highlight');
var $4d4a1e94f0e796d8$export$2dfab9d4f3f51423 = /*#__PURE__*/ function(HighlightPluginAction) {
    HighlightPluginAction[HighlightPluginAction["CHANGE_COLOR"] = 0] = "CHANGE_COLOR";
    HighlightPluginAction[HighlightPluginAction["SET_PALETTE"] = 1] = "SET_PALETTE";
    return HighlightPluginAction;
}({});
const $4d4a1e94f0e796d8$export$ae829ec7b2625219 = ({ api: api })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0,
        state: {
            init: (_, editorState)=>({
                    activeColor: null,
                    disabled: (0, $2gsYp.getDisabledState)(editorState),
                    isPaletteOpen: false
                }),
            apply: (tr, pluginState, _oldState, newState)=>{
                const action = tr.getMeta($4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0)?.type;
                switch(action){
                    case 0:
                        const { color: color } = tr.getMeta($4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            activeColor: color
                        };
                    case 1:
                        const { isPaletteOpen: isPaletteOpen } = tr.getMeta($4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            isPaletteOpen: isPaletteOpen
                        };
                    default:
                        return {
                            ...pluginState,
                            activeColor: (0, $kRdr9.getActiveColor)(tr),
                            disabled: (0, $2gsYp.getDisabledState)(newState)
                        };
                }
            }
        }
    });
};
module.exports["highlightPluginKey"] = $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0;
module.exports["HighlightPluginAction"] = $4d4a1e94f0e796d8$export$2dfab9d4f3f51423;
module.exports["createPlugin"] = $4d4a1e94f0e796d8$export$ae829ec7b2625219;

});

parcelRegister("kRdr9", function(module, exports) {

var $b6bhi = parcelRequire("b6bhi");


var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");

const $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInRange = (from, to, tr)=>{
    const { doc: doc } = tr;
    const { backgroundColor: backgroundColor } = doc.type.schema.marks;
    const colorMarks = [];
    const colorSet = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (node.isLeaf) {
            const mark = backgroundColor.isInSet(node.marks);
            if (mark && !colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        }
    });
    return colorMarks;
};
const $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInCellSelection = (selection, tr)=>{
    const colorMarks = [];
    const colorSet = new Set();
    selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        const marks = $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
        marks.forEach((mark)=>{
            if (!colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        });
    });
    return colorMarks;
};
// For Cell Selections - find first instance of a backgroundColor mark
// if all cells entirely contain this mark, set the color.
// If the selection contains multiple colors, return null
const $3d2494da195881ae$var$getColorFromCellSelection = (selection, tr)=>{
    const marks = $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInCellSelection(selection, tr);
    if (marks.length > 1) return 'multiple';
    const firstColorMark = marks.at(0);
    if (!firstColorMark) return null;
    let foundUncolouredNode = false;
    selection.forEachCell((cell, cellPos)=>{
        if (foundUncolouredNode) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!(0, $b6bhi.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) foundUncolouredNode = true;
    });
    return foundUncolouredNode ? null : firstColorMark.attrs.color;
};
// All other selections - find the first instance of a backgroundColor mark
// if selection entirely contains this mark, set the color.
// If the selection contains multiple colors, return null
const $3d2494da195881ae$var$getColorFromRange = (from, to, tr)=>{
    const marks = $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
    if (marks.length > 1) return 'multiple';
    const firstColorMark = marks.at(0);
    if (firstColorMark && (0, $b6bhi.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) return firstColorMark.attrs.color;
    return null;
};
// For Cursor selections - set color if it is found in the storedMarks or $cursor.marks
const $3d2494da195881ae$var$getColorFromCursor = (selection, tr)=>{
    if (!selection.$cursor) return null;
    const mark = tr.doc.type.schema.marks.backgroundColor.isInSet([
        ...tr.storedMarks ? tr.storedMarks : [],
        ...selection.$cursor.marks()
    ]);
    return mark?.attrs.color ?? null;
};
const $3d2494da195881ae$export$1c6fa8f53a5fb47f = (tr)=>{
    const { selection: selection } = tr;
    let color = null;
    if (selection instanceof (0, $7XFGZ.CellSelection)) color = $3d2494da195881ae$var$getColorFromCellSelection(selection, tr);
    else if (selection instanceof (0, $ks2lK.TextSelection) && selection.$cursor) color = $3d2494da195881ae$var$getColorFromCursor(selection, tr);
    else color = $3d2494da195881ae$var$getColorFromRange(selection.from, selection.to, tr);
    return color;
};
module.exports["getActiveColor"] = $3d2494da195881ae$export$1c6fa8f53a5fb47f;

});

parcelRegister("2gsYp", function(module, exports) {

var $3x31R = parcelRequire("3x31R");

var $lrJCy = parcelRequire("lrJCy");


var $adhil = parcelRequire("adhil");


var $ks2lK = parcelRequire("ks2lK");

const $7d78cd00df36c4c6$export$4af1020a67b5ec91 = (state)=>{
    const { backgroundColor: backgroundColor } = state.schema.marks;
    const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
    if (!backgroundColor) return true;
    if (state.selection instanceof (0, $ks2lK.NodeSelection) || state.selection instanceof (0, $adhil.GapCursorSelection)) return true;
    if (empty && !$cursor || (0, $3x31R.isMarkAllowedInRange)(state.doc, ranges, backgroundColor) === false) return true;
    if ((0, $lrJCy.isMarkExcluded)(backgroundColor, state.storedMarks || $cursor && $cursor.marks())) return true;
    return false;
};
module.exports["getDisabledState"] = $7d78cd00df36c4c6$export$4af1020a67b5ec91;

});

parcelRegister("dzypS", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $lHd5I = parcelRequire("lHd5I");


var $g9iqE = parcelRequire("g9iqE");

const $9cdc59158e6be17c$export$64079c8b271eeba4 = new (0, $ks2lK.PluginKey)('highlightPaddingPluginKey');
const $9cdc59158e6be17c$export$8d5a971433249768 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $9cdc59158e6be17c$export$64079c8b271eeba4,
        state: {
            init: (_, state)=>{
                // Initially scan the entire doc to create all highlight padding decorations
                // after which updates will only apply to changed ranges
                const initialDecorationSet = (0, $ftzrq.DecorationSet).empty;
                const decorationSet = (0, $lHd5I.addPaddingDecorations)({
                    decorationSet: initialDecorationSet,
                    state: state,
                    from: 0,
                    to: state.doc.content.size
                });
                return {
                    decorationSet: decorationSet
                };
            },
            apply: (tr, pluginState, _oldState, state)=>{
                if (!tr.docChanged) return pluginState;
                let decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
                tr.mapping.maps.forEach((stepMap)=>{
                    stepMap.forEach((_oldStart, _oldEnd, start, end)=>{
                        decorationSet = (0, $g9iqE.updatePaddingDecorations)({
                            decorationSet: decorationSet,
                            state: state,
                            start: start,
                            end: end
                        });
                    });
                });
                return {
                    decorationSet: decorationSet
                };
            }
        },
        props: {
            decorations: (state)=>{
                return $9cdc59158e6be17c$export$64079c8b271eeba4.getState(state).decorationSet;
            }
        }
    });
};
module.exports["createHighlightPaddingPlugin"] = $9cdc59158e6be17c$export$8d5a971433249768;

});

parcelRegister("lHd5I", function(module, exports) {

var $ftzrq = parcelRequire("ftzrq");


var $27aZU = parcelRequire("27aZU");

const $75d65e7fd63930f1$var$createPaddingDecoration = ({ pos: pos, node: node, padLeft: padLeft, padRight: padRight })=>{
    const classes = [];
    const baseClass = 'background-color';
    const padLeftClass = `${baseClass}-padding-left`;
    const padRightClass = `${baseClass}-padding-right`;
    if (padLeft) classes.push(padLeftClass);
    if (padRight) classes.push(padRightClass);
    return (0, $ftzrq.Decoration).inline(pos, pos + node.nodeSize, {
        class: classes.join(' ')
    });
};
const $75d65e7fd63930f1$export$e955b6e659e59713 = ({ decorationSet: decorationSet, state: state, from: from, to: to })=>{
    let newDecorationSet = decorationSet;
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!(0, $27aZU.isHighlightedTextNode)(node)) return;
        const nodeStart = pos;
        const nodeEnd = pos + node.nodeSize;
        const padLeft = (0, $27aZU.shouldPadLeft)({
            state: state,
            nodeStart: nodeStart
        });
        const padRight = (0, $27aZU.shouldPadRight)({
            state: state,
            nodeEnd: nodeEnd
        });
        if (padLeft && padRight) {
            const newDecoration = $75d65e7fd63930f1$var$createPaddingDecoration({
                pos: nodeStart,
                node: node,
                padLeft: padLeft,
                padRight: padRight
            });
            newDecorationSet = newDecorationSet.add(state.doc, [
                newDecoration
            ]);
        }
    });
    return newDecorationSet;
};
module.exports["addPaddingDecorations"] = $75d65e7fd63930f1$export$e955b6e659e59713;

});

parcelRegister("27aZU", function(module, exports) {
const $8bd38b773d7252d2$export$d6f914f85b7b868b = (node)=>{
    return node.isText && node.marks.some((mark)=>mark.type.name === 'backgroundColor');
};
const $8bd38b773d7252d2$export$48e6e6ce50a6fb39 = ({ state: state, nodeStart: nodeStart })=>{
    const $pos = state.doc.resolve(nodeStart);
    const isAtBlockStart = $pos.parentOffset === 0;
    if (isAtBlockStart) return true;
    const isAtDocStart = nodeStart === 0;
    if (isAtDocStart) return true;
    const isPrevCharSpace = state.doc.textBetween(nodeStart - 1, nodeStart) === ' ';
    if (isPrevCharSpace) return true;
    return false;
};
const $8bd38b773d7252d2$export$b44b3045e621df46 = ({ state: state, nodeEnd: nodeEnd })=>{
    const $pos = state.doc.resolve(nodeEnd);
    const isAtBlockEnd = $pos.parentOffset === $pos.parent.content.size;
    if (isAtBlockEnd) return true;
    const isAtDocEnd = nodeEnd === state.doc.content.size;
    if (isAtDocEnd) return true;
    const isNextCharSpace = state.doc.textBetween(nodeEnd, nodeEnd + 1) === ' ';
    if (isNextCharSpace) return true;
    return false;
};
module.exports["isHighlightedTextNode"] = $8bd38b773d7252d2$export$d6f914f85b7b868b;
module.exports["shouldPadLeft"] = $8bd38b773d7252d2$export$48e6e6ce50a6fb39;
module.exports["shouldPadRight"] = $8bd38b773d7252d2$export$b44b3045e621df46;

});

parcelRegister("g9iqE", function(module, exports) {

var $lHd5I = parcelRequire("lHd5I");

const $8934f79a1793d309$export$d9003f1f8089aa99 = ({ decorationSet: prevDecorationSet, state: state, start: start, end: end })=>{
    // First remove any decorations within the range
    // Note that it finds all decorations in the set which touch the given range (including decorations that start or end directly at the boundaries)
    const toRemove = prevDecorationSet.find(start, end);
    const decorationSet = prevDecorationSet.remove(toRemove);
    // Expand the range by 1 on each side to catch adjacent text nodes
    // that may need padding decorations added/removed
    const from = Math.max(0, start - 1);
    const to = Math.min(state.doc.content.size, end + 1);
    return (0, $lHd5I.addPaddingDecorations)({
        decorationSet: decorationSet,
        state: state,
        from: from,
        to: to
    });
};
module.exports["updatePaddingDecorations"] = $8934f79a1793d309$export$d9003f1f8089aa99;

});

parcelRegister("31vtz", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");

var $60bKU = parcelRequire("60bKU");


var $gmyMu = parcelRequire("gmyMu");


var $5qdhe = parcelRequire("5qdhe");

var $fEGA1 = parcelRequire("fEGA1");


var $dZ8uq = parcelRequire("dZ8uq");


var $lYyGb = parcelRequire("lYyGb");


var $3VmVg = parcelRequire("3VmVg");

function $37cb423ae71dbe77$export$e832373cff8dec22({ api: api }) {
    const list = {};
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (!isToolbarAIFCEnabled) (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleHighlightPalette).common, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $3VmVg.togglePalette)(api)({
        inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
    }), list);
    const analyticsApi = api?.analytics?.actions;
    const highlightPalette = (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? (0, $fEGA1.highlightColorPaletteNew) : (0, $5qdhe.highlightColorPalette);
    const color = highlightPalette.find(({ label: label })=>label === 'Yellow');
    if (color) (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.applyYellowHighlight).common, (0, $gmyMu.editorCommandToPMCommand)((0, $lYyGb.changeColor)(analyticsApi)({
        color: color.value,
        inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
    })), list);
    return (0, $60bKU.keymap)(list);
}
module.exports["keymapPlugin"] = $37cb423ae71dbe77$export$e832373cff8dec22;

});

parcelRegister("3VmVg", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $dLPJI = parcelRequire("dLPJI");

const $0fd746eb53b3bb5e$export$7c9cf3bdfeac3246 = (api)=>({ inputMethod: inputMethod })=>(state, dispatch)=>{
            const isPaletteOpen = (0, $dLPJI.highlightPluginKey).getState(state)?.isPaletteOpen;
            return $0fd746eb53b3bb5e$export$9567774ece486a9(api)({
                isPaletteOpen: !isPaletteOpen,
                inputMethod: inputMethod
            })(state, dispatch);
        };
const $0fd746eb53b3bb5e$export$9567774ece486a9 = (api)=>({ isPaletteOpen: isPaletteOpen, inputMethod: inputMethod })=>(state, dispatch)=>{
            const isDisabled = (0, $dLPJI.highlightPluginKey).getState(state)?.disabled;
            if (!isDisabled) {
                const tr = state.tr;
                tr.setMeta((0, $dLPJI.highlightPluginKey), {
                    type: (0, $dLPJI.HighlightPluginAction).SET_PALETTE,
                    isPaletteOpen: isPaletteOpen
                });
                api.analytics?.actions.attachAnalyticsEvent($0fd746eb53b3bb5e$var$createAnalyticsEvent(isPaletteOpen, inputMethod))(tr);
                tr.setMeta('addToHistory', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
const $0fd746eb53b3bb5e$var$createAnalyticsEvent = (isPaletteOpen, inputMethod)=>{
    return {
        action: isPaletteOpen ? (0, $d925B.ACTION).OPENED : (0, $d925B.ACTION).CLOSED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLBAR,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod
        }
    };
};
module.exports["togglePalette"] = $0fd746eb53b3bb5e$export$7c9cf3bdfeac3246;
module.exports["setPalette"] = $0fd746eb53b3bb5e$export$9567774ece486a9;

});

parcelRegister("hpaOT", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");


var $cQMhV = parcelRequire("cQMhV");


var $hgeg8 = parcelRequire("hgeg8");


var $e0nFU = parcelRequire("e0nFU");


var $cORDs = parcelRequire("cORDs");

var $iMS6j = parcelRequire("iMS6j");


var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");


var $bWiTS = parcelRequire("bWiTS");


var $ghftu = parcelRequire("ghftu");


var $74Ajl = parcelRequire("74Ajl");


var $iu6m9 = parcelRequire("iu6m9");


var $3VmVg = parcelRequire("3VmVg");


var $3hEpM = parcelRequire("3hEpM");


var $4je8H = parcelRequire("4je8H");

const $5945e95d36a07c01$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        activeColor: states.highlightState?.activeColor,
        disabled: states.highlightState?.disabled
    };
};
const $5945e95d36a07c01$var$FloatingToolbarHighlightColor = ({ pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $42omo.useRef)(null);
    const { activeColor: activeColor, disabled: disabled, isPaletteOpen: isPaletteOpen } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $5945e95d36a07c01$var$selector);
    const setDropdownOpen = (isOpen)=>{
        if (!disabled && editorView && pluginInjectionApi) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $3VmVg.setPalette)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            })(state, dispatch);
        }
        pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent({
            action: isOpen ? (0, $d925B.ACTION).OPENED : (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            }
        });
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $4je8H.useDropdownEvents)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || disabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $e0nFU.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)(activeColor);
    const title = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $hgeg8.tooltip)((0, $hgeg8.toggleHighlightPalette), toolbarButtonLabel) : toolbarButtonLabel;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3hEpM.PaletteDropdown), {
        isOpen: isDropdownOpen && !disabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $cORDs.disableBlueBorderStyles),
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
            disabled: disabled,
            selected: isDropdownOpen,
            "aria-label": title,
            "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: title,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $cORDs.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cQMhV.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: disabled,
                icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($74Ajl))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: (0, $iMS6j.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                color: "currentColor",
                size: "small"
            })))
        }, (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') && formatMessage((0, $e0nFU.highlightMessages).highlightFloatingToolbar)),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    });
};
const $5945e95d36a07c01$export$5d201a8e1b725031 = (0, $aXWIB.injectIntl)($5945e95d36a07c01$var$FloatingToolbarHighlightColor);
module.exports["FloatingToolbarHighlightColorWithIntl"] = $5945e95d36a07c01$export$5d201a8e1b725031;

});

parcelRegister("3hEpM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxEux = parcelRequire("hxEux");

var $ahQKW = parcelRequire("ahQKW");

var $5qdhe = parcelRequire("5qdhe");

var $fEGA1 = parcelRequire("fEGA1");


var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");


var $bWiTS = parcelRequire("bWiTS");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");

const $c17a292014f8c899$var$HIGHLIGHT_COLOR_PICKER_COLUMNS = 8;
const $c17a292014f8c899$var$HIGHLIGHT_COLOR_PICKER_COLUMNS_NEW = 10;
const $c17a292014f8c899$export$780f86860853be18 = (props)=>{
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isOpen: isOpen, activeColor: activeColor, trigger: trigger, onColorChange: onColorChange, isOpenedByKeyboard: isOpenedByKeyboard, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown } = props;
    const isNewColorPaletteEnabled = (0, $1oCLl.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const highlightPalette = isNewColorPaletteEnabled ? (0, $fEGA1.highlightColorPaletteNew) : (0, $5qdhe.highlightColorPalette);
    const colorPickerColumns = isNewColorPaletteEnabled ? $c17a292014f8c899$var$HIGHLIGHT_COLOR_PICKER_COLUMNS_NEW : $c17a292014f8c899$var$HIGHLIGHT_COLOR_PICKER_COLUMNS;
    // pixels, used to determine where to horizontally position the dropdown when space is limited
    // this should reflect the width of the dropdown when fully populated with colors, including translations due to layering
    const fitWidth = isNewColorPaletteEnabled ? 338 : 274;
    // 8 cols: 272 = (32 * 8) + (8 + 8)
    // 10 cols: 336 = (32 * 10) + (8 + 8)
    // Not sure where the extra 2px comes from
    const selectedColor = activeColor || (isNewColorPaletteEnabled ? (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR) : null);
    const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $ahQKW.getSelectedRowAndColumnFromPalette)(highlightPalette, selectedColor, colorPickerColumns);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2dkHo.DropdownContainer), {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        isOpen: isOpen,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown,
        zIndex: (0, $aFUXX.akEditorMenuZIndex),
        fitWidth: fitWidth,
        closeOnTab: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $5v8Ta.ArrowKeyNavigationType).COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: true
        },
        trigger: trigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "highlight-color-palette"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hxEux.default), {
        cols: colorPickerColumns,
        onClick: onColorChange,
        selectedColor: selectedColor,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        paletteOptions: {
            palette: highlightPalette,
            hexToPaletteColor: (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)
        }
    })));
};
module.exports["PaletteDropdown"] = $c17a292014f8c899$export$780f86860853be18;

});

parcelRegister("4je8H", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lYyGb = parcelRequire("lYyGb");

const $86014c52cbaafb4d$export$98f4eb06acf89919 = (args)=>{
    const { toolbarItemRef: toolbarItemRef, setIsDropdownOpen: setIsDropdownOpen, isDropdownOpen: isDropdownOpen, pluginInjectionApi: pluginInjectionApi } = args;
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $42omo.useState)(false);
    return {
        handleClick: ()=>{
            setIsOpenedByKeyboard(false);
            setIsDropdownOpen(!isDropdownOpen);
        },
        handleKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setIsOpenedByKeyboard(true);
                setIsDropdownOpen(!isDropdownOpen);
            }
        },
        handleClickOutside: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
            }
        },
        handleEscapeKeydown: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
                toolbarItemRef?.current?.focus();
            }
        },
        handleColorChange: ({ color: color, inputMethod: inputMethod })=>{
            pluginInjectionApi?.core?.actions.execute((0, $lYyGb.changeColor)(pluginInjectionApi?.analytics?.actions)({
                color: color,
                inputMethod: inputMethod
            }));
            setIsDropdownOpen(false);
        },
        isOpenedByKeyboard: isOpenedByKeyboard
    };
};
module.exports["useDropdownEvents"] = $86014c52cbaafb4d$export$98f4eb06acf89919;

});

parcelRegister("cdbrp", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");


var $cQMhV = parcelRequire("cQMhV");


var $hgeg8 = parcelRequire("hgeg8");


var $e0nFU = parcelRequire("e0nFU");


var $cORDs = parcelRequire("cORDs");

var $iMS6j = parcelRequire("iMS6j");


var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");


var $bWiTS = parcelRequire("bWiTS");


var $ghftu = parcelRequire("ghftu");


var $74Ajl = parcelRequire("74Ajl");


var $1s5hv = parcelRequire("1s5hv");


var $3VmVg = parcelRequire("3VmVg");


var $3hEpM = parcelRequire("3hEpM");


var $4je8H = parcelRequire("4je8H");

const $9f842e0a01a1e3bc$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        highlightDisabled: states.highlightState?.disabled,
        activeColor: states.highlightState?.activeColor
    };
};
const $9f842e0a01a1e3bc$var$PrimaryToolbarHighlightColor = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, disabled: disabled, pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $42omo.useRef)(null);
    const { isPaletteOpen: isPaletteOpen, highlightDisabled: highlightDisabled, activeColor: activeColor } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $9f842e0a01a1e3bc$var$selector);
    const setIsDropdownOpen = (isOpen)=>{
        if (!highlightDisabled) {
            const { state: state, dispatch: dispatch } = editorView;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $3VmVg.setPalette)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
            })(state, dispatch);
        }
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $4je8H.useDropdownEvents)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setIsDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || highlightDisabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $e0nFU.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)(activeColor);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3hEpM.PaletteDropdown), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isOpen: isDropdownOpen && !highlightDisabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $cORDs.disableBlueBorderStyles),
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: isToolbarReducedSpacing ? 'none' : 'default',
            disabled: disabled || highlightDisabled,
            selected: isDropdownOpen,
            "aria-label": (0, $hgeg8.tooltip)((0, $hgeg8.toggleHighlightPalette), toolbarButtonLabel),
            "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: (0, $hgeg8.tooltip)((0, $hgeg8.toggleHighlightPalette), toolbarButtonLabel),
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $cORDs.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cQMhV.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: highlightDisabled,
                icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($74Ajl))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: (0, $iMS6j.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                color: "currentColor",
                size: "small"
            })))
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    }));
};
const $9f842e0a01a1e3bc$export$124ac7b23aa1ea6a = (0, $aXWIB.injectIntl)($9f842e0a01a1e3bc$var$PrimaryToolbarHighlightColor);
module.exports["PrimaryToolbarHighlightColorWithIntl"] = $9f842e0a01a1e3bc$export$124ac7b23aa1ea6a;

});

parcelRegister("hCfMV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $kRJ3B = parcelRequire("kRJ3B");

const $a5b7313ece327a81$export$6cd8b101843de8d2 = (api)=>{
    return [
        {
            ...(0, $cPCP8.HIGHLIGHT_MENU_ITEM),
            parents: [
                {
                    ...(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $4Chin.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $cPCP8.HIGHLIGHT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kRJ3B.HighlightColorMenuItem), {
                    api: api,
                    parents: parents
                })
        }
    ];
};
module.exports["getToolbarComponent"] = $a5b7313ece327a81$export$6cd8b101843de8d2;

});

parcelRegister("kRJ3B", function(module, exports) {
/* HighlightColorMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e0nFU = parcelRequire("e0nFU");


var $fIFhP = parcelRequire("fIFhP");


var $5qdhe = parcelRequire("5qdhe");

var $fEGA1 = parcelRequire("fEGA1");

var $fcJdJ = parcelRequire("fcJdJ");


var $b3YrF = parcelRequire("b3YrF");


var $bWiTS = parcelRequire("bWiTS");

var $iS6Uy = parcelRequire("iS6Uy");


var $g66hv = parcelRequire("g66hv");

var $5v3PK = parcelRequire("5v3PK");


var $cO1el = parcelRequire("cO1el");


var $cvXh8 = parcelRequire("cvXh8");


var $5gydP = parcelRequire("5gydP");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $1oCLl = parcelRequire("1oCLl");

const $c3912d4eed8d6b1c$var$HIGHLIGHT_COLOR_PICKER_COLUMNS = 10;
const $c3912d4eed8d6b1c$var$styles = {
    container: "_zulp12x7 _19pkpxbi",
    icon: "_1e0c1o8l _18u01n1a"
};
const $c3912d4eed8d6b1c$var$getTextColorIconColor = (defaultColor, textColor, isNewColorPaletteEnabled)=>{
    if (!isNewColorPaletteEnabled) return "var(--ds-icon, #292A2E)";
    if (!textColor || defaultColor && textColor === defaultColor) return "var(--ds-icon, #292A2E)";
    return (0, $iS6Uy.hexToEditorTextPaletteColor)(textColor) || "var(--ds-icon, #292A2E)";
};
const $c3912d4eed8d6b1c$var$TextColorIconDecorator = ({ label: label, isSelected: isSelected, iconColor: iconColor })=>{
    return isSelected ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        color: "var(--ds-icon, #292A2E)",
        label: label
    }) : /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $c3912d4eed8d6b1c$var$styles.icon
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5gydP))), {
        label: label,
        color: iconColor,
        shouldRecommendSmallIcon: true,
        spacing: "spacious",
        size: "small"
    }));
};
const $c3912d4eed8d6b1c$var$NoColorIconDecorator = ({ isSelected: isSelected, iconColor: iconColor })=>/*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "translate(-1 -1)"
    }, /*#__PURE__*/ $42omo.createElement("rect", {
        x: "1.70703",
        y: "1.35383",
        width: "29.8003",
        height: "0.5",
        transform: "rotate(45 1.70703 1.35383)",
        stroke: "var(--ds-border, #0B120E24)",
        strokeWidth: "0.5"
    }), isSelected ? /*#__PURE__*/ $42omo.createElement("path", {
        d: "M17.959 7.9707L10.709 16.9707C10.5675 17.1462 10.3544 17.2488 10.1289 17.25C9.90343 17.2512 9.68924 17.1506 9.5459 16.9766L6.0459 12.7266L7.2041 11.7734L10.1182 15.3115L16.791 7.0293L17.959 7.9707Z",
        fill: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ $42omo.createElement("path", {
        d: "M7.80469 16L10.9746 7.26953H12.2637L15.4746 16H14.3027L12.4512 10.8203C12.3379 10.5 12.2051 10.1016 12.0527 9.625C11.9043 9.14453 11.7227 8.5332 11.5078 7.79102H11.7188C11.5078 8.54102 11.3242 9.16016 11.168 9.64844C11.0156 10.1328 10.8887 10.5234 10.7871 10.8203L8.98828 16H7.80469ZM9.39844 13.5625V12.5898H13.8809V13.5625H9.39844Z",
        fill: iconColor
    })));
function $c3912d4eed8d6b1c$export$5b2f3a4c271f0961({ api: api, parents: parents }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const activeColor = (0, $b3YrF.useSharedPluginStateSelector)(api, 'highlight.activeColor');
    const context = (0, $5v3PK.useToolbarDropdownMenu)();
    const { textColor: textColor, defaultColor: defaultColor } = (0, $fcJdJ.useSelectedTextColor)();
    const closeMenu = context?.closeMenu;
    const isNewColorPaletteEnabled = (0, $1oCLl.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const selectedColor = activeColor || (isNewColorPaletteEnabled ? (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR) : null);
    const handleHighlightColorChange = (0, $42omo.useCallback)((color, event)=>{
        if (api?.highlight?.commands?.changeColor) {
            api.core.actions.execute(api.highlight.commands.changeColor({
                color: color,
                inputMethod: (0, $fIFhP.getInputMethodFromParentKeys)(parents)
            }));
            if (!isNewColorPaletteEnabled) closeMenu?.(event);
        }
    }, [
        api,
        closeMenu,
        isNewColorPaletteEnabled,
        parents
    ]);
    const colorPalette = (0, $42omo.useMemo)(()=>{
        const isSelected = (color)=>color.value === selectedColor;
        const iconColor = $c3912d4eed8d6b1c$var$getTextColorIconColor(defaultColor, textColor, isNewColorPaletteEnabled);
        const highlightPalette = isNewColorPaletteEnabled ? (0, $fEGA1.highlightColorPaletteNew) : (0, $5qdhe.highlightColorPalette);
        return highlightPalette.filter((color)=>isNewColorPaletteEnabled || color.value !== (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR)).map((color)=>({
                ...color,
                decorator: isNewColorPaletteEnabled && color.value === (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR) ? /*#__PURE__*/ $42omo.createElement($c3912d4eed8d6b1c$var$NoColorIconDecorator, {
                    isSelected: isSelected(color),
                    iconColor: iconColor
                }) : /*#__PURE__*/ $42omo.createElement($c3912d4eed8d6b1c$var$TextColorIconDecorator, {
                    label: color.label,
                    isSelected: isSelected(color),
                    iconColor: iconColor
                })
            }));
    }, [
        defaultColor,
        textColor,
        isNewColorPaletteEnabled,
        selectedColor
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        xcss: $c3912d4eed8d6b1c$var$styles.container,
        testId: "highlight-color-menu-item"
    }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "xxsmall"
    }, formatMessage((0, $e0nFU.highlightMessages).highlight)), /*#__PURE__*/ $42omo.createElement((0, $g66hv.default), {
        cols: isNewColorPaletteEnabled ? $c3912d4eed8d6b1c$var$HIGHLIGHT_COLOR_PICKER_COLUMNS : undefined,
        onClick: (color, _, event)=>{
            handleHighlightColorChange(color, event);
        },
        selectedColor: selectedColor,
        paletteOptions: {
            palette: colorPalette || [],
            hexToPaletteColor: (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)
        }
    }));
}
module.exports["HighlightColorMenuItem"] = $c3912d4eed8d6b1c$export$5b2f3a4c271f0961;

});

parcelRegister("fcJdJ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $6vK9x = parcelRequire("6vK9x");

const $ab4a72300e2c3f98$export$dbd605ef953212b2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)((0, $6vK9x.SelectedTextColorContext));
} : ()=>(0, $42omo.useContext)((0, $6vK9x.SelectedTextColorContext));
module.exports["useSelectedTextColor"] = $ab4a72300e2c3f98$export$dbd605ef953212b2;

});

parcelRegister("aUwPP", function(module, exports) {

var $9LRzA = parcelRequire("9LRzA");


var $5abq6 = parcelRequire("5abq6");


var $b9lC3 = parcelRequire("b9lC3");


var $87fJd = parcelRequire("87fJd");

const $8f944f557ac62b40$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $9LRzA.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $b9lC3.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $b9lC3.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $b9lC3.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $87fJd.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $8f944f557ac62b40$export$171e576bb7c729fa;

});

parcelRegister("b9lC3", function(module, exports) {

var $aU3dp = parcelRequire("aU3dp");

var $d925B = parcelRequire("d925B");


var $dhoHU = parcelRequire("dhoHU");


var $5abq6 = parcelRequire("5abq6");


var $kecXX = parcelRequire("kecXX");


var $by9bj = parcelRequire("by9bj");

const $a4290f7701cf1730$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $a4290f7701cf1730$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $dhoHU.toggleBlockMark)(indentation, getNewIndentationAttrs, $a4290f7701cf1730$export$54db194d337db321)(state, dispatch);
    };
}
function $a4290f7701cf1730$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $kecXX.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $a4290f7701cf1730$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $by9bj.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $a4290f7701cf1730$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getIndentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $a4290f7701cf1730$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getOutdentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $a4290f7701cf1730$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $dhoHU.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $a4290f7701cf1730$export$54db194d337db321;
module.exports["getIndentCommand"] = $a4290f7701cf1730$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $a4290f7701cf1730$export$620b2a1f10eb3a5f;

});

parcelRegister("kecXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d4de3432317ffe3$export$2e2bcd8739ae039);
function $2d4de3432317ffe3$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("by9bj", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $aU3dp = parcelRequire("aU3dp");

const $a44445544afb543f$var$indentTypes = {
    paragraph: (0, $aU3dp.INDENT_TYPE).PARAGRAPH,
    heading: (0, $aU3dp.INDENT_TYPE).HEADING
};
function $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $a44445544afb543f$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $a44445544afb543f$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $a44445544afb543f$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $a44445544afb543f$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $a44445544afb543f$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $a44445544afb543f$export$4f15b45384b61427;

});

parcelRegister("87fJd", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $1XMEN = parcelRequire("1XMEN");


var $dus6D = parcelRequire("dus6D");


var $8m4tT = parcelRequire("8m4tT");


var $b9lC3 = parcelRequire("b9lC3");

function $e60d68c782a1a955$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $b9lC3.getIndentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.outdent)), (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $1XMEN.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $8m4tT.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}
var $e60d68c782a1a955$export$2e2bcd8739ae039 = $e60d68c782a1a955$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $e60d68c782a1a955$export$e832373cff8dec22;

});

parcelRegister("80JwR", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $bdlPz = parcelRequire("bdlPz");


var $1Tagp = parcelRequire("1Tagp");


var $1Elsv = parcelRequire("1Elsv");


var $hB6ux = parcelRequire("hB6ux");


var $8PlH8 = parcelRequire("8PlH8");

const $574aa43e6bff8140$export$c1375d8d7bd75982 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isNewToolbarEnabled = Boolean(api?.toolbar);
    // Workaround since we want to insert a loom via the `hyperlink` plugin for now.
    // The hyperlink plugin (and the card plugin) are deeply tied into using the Prosemirror Command
    // Ideally one day we refactor those and we can remove this.
    const editorViewRef = {
        current: null
    };
    const primaryToolbarComponent = (0, $1Elsv.loomPrimaryToolbarComponent)(config, api);
    if (isNewToolbarEnabled) api?.toolbar?.actions.registerComponents((0, $8PlH8.getToolbarComponents)(config, api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'loom',
        component: primaryToolbarComponent
    });
    return {
        name: 'loom',
        actions: {
            recordVideo: $bdlPz.recordVideo,
            insertLoom: (video, positionType)=>(0, $bdlPz.insertLoom)(editorViewRef.current, api, video, positionType),
            initLoom: ({ loomProvider: loomProvider })=>{
                return (0, $bdlPz.setupLoom)(loomProvider, api, editorViewRef.current, true);
            }
        },
        pmPlugins: ()=>[
                {
                    name: 'loom',
                    plugin: ()=>(0, $1Tagp.createPlugin)({
                            config: config,
                            api: api
                        })
                },
                {
                    name: 'loomViewRefWorkaround',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $1Tagp.loomPluginKey).getState(editorState);
        },
        pluginsOptions: {
            // Enable inserting Loom recordings through the slash command
            quickInsert: (intl)=>{
                if (config.loomProvider) return (0, $hB6ux.getQuickInsertItem)(editorAnalyticsAPI)(intl);
                return [];
            }
        },
        // Enable inserting Loom recordings through main toolbar
        primaryToolbarComponent: !api?.primaryToolbar && !isNewToolbarEnabled ? primaryToolbarComponent : undefined
    };
};
module.exports["loomPlugin"] = $574aa43e6bff8140$export$c1375d8d7bd75982;

});

parcelRegister("bdlPz", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hWRJP = parcelRequire("hWRJP");


var $hB6ux = parcelRequire("hB6ux");


var $1Tagp = parcelRequire("1Tagp");

const $a212a932479b4271$export$b5c7c74886310ae0 = ({ loomButton: loomButton })=>({ tr: tr })=>{
        tr.setMeta((0, $1Tagp.loomPluginKey), {
            type: (0, $1Tagp.LoomPluginAction).ENABLE,
            loomButton: loomButton
        });
        return tr;
    };
const $a212a932479b4271$export$6f61f49dd8b64c45 = ({ error: error })=>({ tr: tr })=>{
        tr.setMeta((0, $1Tagp.loomPluginKey), {
            type: (0, $1Tagp.LoomPluginAction).DISABLE,
            error: error
        });
        return tr;
    };
const $a212a932479b4271$export$2d56b03ca3f4ead9 = ({ inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        tr.setMeta((0, $1Tagp.loomPluginKey), {
            type: (0, $1Tagp.LoomPluginAction).RECORD_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).RECORD_VIDEO,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $a212a932479b4271$export$3b5a9e613ed2ae87 = ({ inputMethod: inputMethod, error: error, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).RECORD_VIDEO_FAILED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod,
                error: error
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $a212a932479b4271$export$73a289ac38fc1ec = ({ editorAnalyticsAPI: editorAnalyticsAPI, video: video })=>({ tr: tr })=>{
        tr.setMeta((0, $1Tagp.loomPluginKey), {
            type: (0, $1Tagp.LoomPluginAction).INSERT_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERT_VIDEO,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                duration: video.duration
            }
        })(tr);
        return tr;
    };
const $a212a932479b4271$var$getPositions = (tr, posType)=>{
    const selection = tr.selection;
    switch(posType){
        case 'current':
            return {
                from: selection.from,
                to: selection.from
            };
        case 'start':
            return {
                from: 0,
                to: 0
            };
        case 'end':
            return {
                from: tr.doc.content.size,
                to: tr.doc.content.size
            };
    }
};
const $a212a932479b4271$export$e61f2d2bdaa7ecf4 = (editorView, api, video, positionType)=>{
    if (!editorView) return false;
    const { state: state, dispatch: dispatch } = editorView;
    const { from: from, to: to } = $a212a932479b4271$var$getPositions(state.tr, positionType);
    return api?.hyperlink?.actions.insertLink((0, $d925B.INPUT_METHOD).TYPEAHEAD, from, to, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch) ?? false;
};
const $a212a932479b4271$export$92a5ff9a4d5c2287 = (api)=>{
    api?.core?.actions.execute($a212a932479b4271$export$2d56b03ca3f4ead9({
        inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
        editorAnalyticsAPI: api?.analytics?.actions
    }));
};
const $a212a932479b4271$export$a39487b0b81d2404 = async (loomProvider, api, editorView, /**
	 * Whether loom initialisation is evoked via `initLoom` command.
	 */ initViaCommand)=>{
    const clientResult = await loomProvider.getClient();
    if (clientResult.status === 'error') {
        api?.core?.actions.execute($a212a932479b4271$export$6f61f49dd8b64c45({
            error: clientResult.message
        }));
        (0, $hWRJP.logException)(new Error(clientResult.message), {
            location: 'editor-plugin-loom/sdk-initialisation'
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).ERRORED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: clientResult.message
            }
        });
        return {
            error: clientResult.message
        };
    }
    const { attachToButton: attachToButton } = clientResult.client;
    // Hidden element to work around the SDK API
    const loomButton = document.createElement('button');
    attachToButton({
        button: loomButton,
        onInsert: (video)=>{
            if (!editorView) return;
            const { state: state, dispatch: dispatch } = editorView;
            const pos = state.selection.from;
            api?.hyperlink?.actions.insertLink((0, $d925B.INPUT_METHOD).TYPEAHEAD, pos, pos, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch);
            api?.core?.actions.execute($a212a932479b4271$export$73a289ac38fc1ec({
                editorAnalyticsAPI: api?.analytics?.actions,
                video: video
            }));
        }
    });
    api?.core?.actions.execute(({ tr: tr })=>{
        $a212a932479b4271$export$b5c7c74886310ae0({
            loomButton: loomButton
        })({
            tr: tr
        });
        if (initViaCommand) api?.quickInsert?.commands.addQuickInsertItem((0, $hB6ux.getQuickInsertItem)(api?.analytics?.actions))({
            tr: tr
        });
        return tr;
    });
    // We're not combining the analytics steps into the enable / disable commands because the collab-edit plugin
    // filters out any transactions with steps (even analytics) when it's initialising.
    // Even if `initViaCommand` is true, collab-edit might not be ready depending on when `initLoom` is called,
    // hence the analytics step is added separately in both cases
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).INITIALISED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    });
    return {};
};
module.exports["recordVideo"] = $a212a932479b4271$export$2d56b03ca3f4ead9;
module.exports["recordVideoFailed"] = $a212a932479b4271$export$3b5a9e613ed2ae87;
module.exports["insertLoom"] = $a212a932479b4271$export$e61f2d2bdaa7ecf4;
module.exports["executeRecordVideo"] = $a212a932479b4271$export$92a5ff9a4d5c2287;
module.exports["setupLoom"] = $a212a932479b4271$export$a39487b0b81d2404;

});

parcelRegister("hB6ux", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $4HWgE = parcelRequire("4HWgE");


var $hWRJP = parcelRequire("hWRJP");


var $2Yaht = parcelRequire("2Yaht");


var $bdlPz = parcelRequire("bdlPz");


var $1Tagp = parcelRequire("1Tagp");

const $ad333a3a37885863$export$3432d7b65cad662d = (editorAnalyticsAPI)=>({ formatMessage: formatMessage })=>[
            {
                id: 'loom',
                title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).recordVideo),
                description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).recordVideoDescription),
                keywords: [
                    'loom',
                    'record',
                    'video'
                ],
                priority: 800,
                isDisabledOffline: true,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        spacing: "spacious"
                    }),
                action (insert, editorState) {
                    const tr = insert(undefined);
                    const loomState = (0, $1Tagp.loomPluginKey).getState(editorState);
                    if (!loomState?.isEnabled) {
                        const errorMessage = loomState?.error;
                        (0, $hWRJP.logException)(new Error(errorMessage), {
                            location: 'editor-plugin-loom/quick-insert-record-video'
                        });
                        return (0, $bdlPz.recordVideoFailed)({
                            inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                            error: errorMessage,
                            editorAnalyticsAPI: editorAnalyticsAPI
                        })({
                            tr: tr
                        }) ?? false;
                    }
                    return (0, $bdlPz.recordVideo)({
                        inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                        editorAnalyticsAPI: editorAnalyticsAPI
                    })({
                        tr: tr
                    }) ?? false;
                }
            }
        ];
module.exports["getQuickInsertItem"] = $ad333a3a37885863$export$3432d7b65cad662d;

});

parcelRegister("1Tagp", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $bdlPz = parcelRequire("bdlPz");

var $ae8edf494757bf0e$export$5f9dbfce88541fe5 = /*#__PURE__*/ function(LoomPluginAction) {
    LoomPluginAction[LoomPluginAction["ENABLE"] = 0] = "ENABLE";
    LoomPluginAction[LoomPluginAction["DISABLE"] = 1] = "DISABLE";
    LoomPluginAction[LoomPluginAction["RECORD_VIDEO"] = 2] = "RECORD_VIDEO";
    LoomPluginAction[LoomPluginAction["INSERT_VIDEO"] = 3] = "INSERT_VIDEO";
    return LoomPluginAction;
}({});
const $ae8edf494757bf0e$export$db6b5ebe5a8c279 = new (0, $ks2lK.PluginKey)('loom');
const $ae8edf494757bf0e$export$ae829ec7b2625219 = ({ config: config, api: api })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $ae8edf494757bf0e$export$db6b5ebe5a8c279,
        state: {
            init: ()=>({
                    isEnabled: false,
                    loomButton: null,
                    isRecordingVideo: false,
                    error: undefined
                }),
            apply: (tr, pluginState)=>{
                const action = tr.getMeta($ae8edf494757bf0e$export$db6b5ebe5a8c279)?.type;
                switch(action){
                    case 0:
                        const { loomButton: loomButton } = tr.getMeta($ae8edf494757bf0e$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: true,
                            loomButton: loomButton
                        };
                    case 1:
                        const { error: error } = tr.getMeta($ae8edf494757bf0e$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: false,
                            loomButton: null,
                            error: error
                        };
                    case 2:
                        // Click the unmounted button in state that has the Loom SDK attached
                        pluginState?.loomButton?.click();
                        return {
                            ...pluginState,
                            isRecordingVideo: true
                        };
                    case 3:
                        return {
                            ...pluginState,
                            isRecordingVideo: false
                        };
                    default:
                        return pluginState;
                }
            }
        },
        view (editorView) {
            if (config.loomProvider) (0, $bdlPz.setupLoom)(config.loomProvider, api, editorView);
            return {};
        }
    });
};
module.exports["LoomPluginAction"] = $ae8edf494757bf0e$export$5f9dbfce88541fe5;
module.exports["loomPluginKey"] = $ae8edf494757bf0e$export$db6b5ebe5a8c279;
module.exports["createPlugin"] = $ae8edf494757bf0e$export$ae829ec7b2625219;

});

parcelRegister("1Elsv", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $eiA8Z = parcelRequire("eiA8Z");


var $91bcx = parcelRequire("91bcx");


var $bdlPz = parcelRequire("bdlPz");


var $aOf65 = parcelRequire("aOf65");

const $e04bd784ac086222$var$selector = (states)=>{
    return {
        loomEnabled: states.loomState?.isEnabled,
        connectivityMode: states.connectivityState?.mode
    };
};
const $e04bd784ac086222$var$CustomisableLoomToolbarButton = (disabled, appearance, api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
        const { onClickBeforeInit: onClickBeforeInit, isDisabled: isDisabled = false, href: href, ...restProps } = props;
        const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
            'loom',
            'connectivity'
        ], $e04bd784ac086222$var$selector);
        const isLoomEnabled = !!loomEnabled;
        const handleOnClick = (0, $42omo.useCallback)((e)=>{
            if (isLoomEnabled) (0, $bdlPz.executeRecordVideo)(api);
            else onClickBeforeInit && onClickBeforeInit(e);
        }, [
            isLoomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aOf65.default), {
            ref: ref,
            hideTooltip: !!(restProps.onMouseEnter || restProps.onMouseLeave),
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: isLoomEnabled ? undefined : href,
            disabled: disabled || isDisabled || (0, $91bcx.isOfflineMode)(connectivityMode),
            api: api,
            appearance: appearance,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (e)=>handleOnClick(e),
            ...restProps
        });
    });
const $e04bd784ac086222$var$LoomToolbarButtonWrapper = ({ disabled: disabled, api: api, appearance: appearance })=>{
    const handleOnClick = (0, $42omo.useCallback)(()=>(0, $bdlPz.executeRecordVideo)(api), [
        api
    ]);
    const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'loom',
        'connectivity'
    ], $e04bd784ac086222$var$selector);
    if (loomEnabled === undefined) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aOf65.default), {
        // Disable the icon while the SDK isn't initialised
        disabled: disabled || !loomEnabled || (0, $91bcx.isOfflineMode)(connectivityMode),
        api: api,
        appearance: appearance,
        onClick: handleOnClick
    });
};
const $e04bd784ac086222$export$b7aa095334bc8677 = (config, api)=>({ disabled: disabled, appearance: appearance })=>{
        if (config.shouldShowToolbarButton === false) return null;
        if (config.renderButton) return config.renderButton($e04bd784ac086222$var$CustomisableLoomToolbarButton(disabled, appearance, api));
        if (config.shouldShowToolbarButton) return /*#__PURE__*/ (0, $9K4OG.jsx)($e04bd784ac086222$var$LoomToolbarButtonWrapper, {
            // Disable the icon while the SDK isn't initialised
            disabled: disabled,
            api: api,
            appearance: appearance
        });
        return null;
    };
module.exports["loomPrimaryToolbarComponent"] = $e04bd784ac086222$export$b7aa095334bc8677;

});

parcelRegister("aOf65", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $eiA8Z = parcelRequire("eiA8Z");


var $4HWgE = parcelRequire("4HWgE");


var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");


var $2Yaht = parcelRequire("2Yaht");

function $e0f54c4226daf504$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
// Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
const $e0f54c4226daf504$var$LOOM_BUTTON_WIDTH_BREAKPOINT = 1076;
const $e0f54c4226daf504$var$iconMinWidthStyle = {
    name: "9bmev",
    styles: "min-width:24px"
};
const $e0f54c4226daf504$var$selector = (states)=>{
    return {
        width: states.widthState?.width
    };
};
const $e0f54c4226daf504$var$LoomToolbarButtonInternal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ disabled: disabled, api: api, appearance: appearance, intl: { formatMessage: formatMessage }, selected: selected, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'data-ds--level': dataDsLevel, onClick: onClick, href: href, target: target, hideTooltip: hideTooltip, rel: rel }, ref)=>{
    const { width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'width'
    ], $e0f54c4226daf504$var$selector);
    const label = formatMessage(appearance === 'comment' ? (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideoComment : (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideo);
    const shouldShowRecordText = (width || 0) > $e0f54c4226daf504$var$LOOM_BUTTON_WIDTH_BREAKPOINT;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        hideTooltip: hideTooltip,
        ref: ref,
        href: href,
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
        disabled: disabled,
        title: label,
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: $e0f54c4226daf504$var$iconMinWidthStyle
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
            label: label,
            color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)",
            spacing: "spacious"
        })),
        selected: selected,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        target: target,
        rel: rel
    }, shouldShowRecordText && formatMessage((0, $4HWgE.toolbarInsertBlockMessages).recordLoomShortTitle));
});
const $e0f54c4226daf504$var$_default_1 = (0, $aXWIB.injectIntl)($e0f54c4226daf504$var$LoomToolbarButtonInternal, {
    forwardRef: true
});
var $e0f54c4226daf504$export$2e2bcd8739ae039 = $e0f54c4226daf504$var$_default_1;
module.exports["default"] = $e0f54c4226daf504$export$2e2bcd8739ae039;

});

parcelRegister("8PlH8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $7gIIX = parcelRequire("7gIIX");


var $3Y62F = parcelRequire("3Y62F");

const $cc270d98483e6586$export$a758406ca53b86a5 = (config, api)=>{
    return [
        {
            type: (0, $cPCP8.LOOM_MENU_SECTION).type,
            key: (0, $cPCP8.LOOM_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.OVERFLOW_MENU_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.OVERFLOW_MENU_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.OVERFLOW_MENU_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.LOOM_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Y62F.MenuSection), {
                    api: api
                }, children);
            }
        },
        {
            type: (0, $cPCP8.LOOM_MENU_ITEM).type,
            key: (0, $cPCP8.LOOM_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.LOOM_MENU_SECTION).type,
                    key: (0, $cPCP8.LOOM_MENU_SECTION).key,
                    rank: (0, $4Chin.LOOM_MENU_SECTION_RANK)[(0, $cPCP8.LOOM_MENU_ITEM).key]
                },
                {
                    type: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                    key: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                    rank: (0, $4Chin.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $cPCP8.LOOM_MENU_ITEM).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gIIX.LoomMenuItem), {
                    api: api,
                    renderButton: config.renderButton
                });
            },
            isHidden: ()=>{
                const loomState = api?.loom?.sharedState.currentState();
                const editorViewMode = api?.editorViewMode?.sharedState.currentState() ?? 'edit';
                // if shouldRenderButton is not provided, default to true
                const shouldRenderButton = config?.shouldRenderButton?.() ?? true;
                return 'renderButton' in config && shouldRenderButton === false || loomState?.isEnabled === undefined || editorViewMode !== 'edit';
            }
        }
    ];
};
module.exports["getToolbarComponents"] = $cc270d98483e6586$export$a758406ca53b86a5;

});

parcelRegister("7gIIX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eiA8Z = parcelRequire("eiA8Z");


var $4HWgE = parcelRequire("4HWgE");


var $gzUv9 = parcelRequire("gzUv9");


var $2Yaht = parcelRequire("2Yaht");

var $2GVu1 = parcelRequire("2GVu1");


var $bdlPz = parcelRequire("bdlPz");

const $6934ba2fbea4b39b$var$useLoomEnabled = (api)=>{
    const { loomEnabled: loomEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'loom'
    ], (states)=>{
        return {
            loomEnabled: states.loomState?.isEnabled
        };
    });
    return loomEnabled;
};
const $6934ba2fbea4b39b$export$cfd738d449e0a4ef = ({ api: api, renderButton: renderButton })=>{
    const loomEnabled = $6934ba2fbea4b39b$var$useLoomEnabled(api);
    const { editorViewMode: editorViewMode } = (0, $gzUv9.useEditorToolbar)();
    if (editorViewMode !== 'edit') return null;
    if (renderButton) return renderButton($6934ba2fbea4b39b$export$a209d77fd6c75051(api));
    else if (loomEnabled !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6934ba2fbea4b39b$var$DefaultLoomMenuItem, {
        api: api
    });
};
const $6934ba2fbea4b39b$export$a209d77fd6c75051 = (api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ isDisabled: isDisabled = false, onClickBeforeInit: onClickBeforeInit, href: href, target: target, rel: rel }, ref)=>{
        const loomEnabled = !!$6934ba2fbea4b39b$var$useLoomEnabled(api);
        const handleOnClick = (0, $42omo.useCallback)((e)=>{
            if (loomEnabled) (0, $bdlPz.executeRecordVideo)(api);
            else if (onClickBeforeInit && e.type === 'click' && e.target instanceof HTMLElement) onClickBeforeInit(e);
        }, [
            loomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6934ba2fbea4b39b$var$MenuItemComponent, {
            ref: ref,
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: loomEnabled ? undefined : href,
            disabled: isDisabled,
            onClick: handleOnClick,
            target: target,
            rel: rel
        });
    });
const $6934ba2fbea4b39b$var$DefaultLoomMenuItem = ({ api: api })=>{
    const loomEnabled = $6934ba2fbea4b39b$var$useLoomEnabled(api);
    const handleOnClick = (0, $42omo.useCallback)(()=>(0, $bdlPz.executeRecordVideo)(api), [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6934ba2fbea4b39b$var$MenuItemComponent, {
        disabled: !loomEnabled,
        onClick: handleOnClick
    });
};
const $6934ba2fbea4b39b$var$MenuItemComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(// eslint-disable-next-line no-unused-vars
({ disabled: disabled, onClick: onClick, href: href, target: target, rel: rel }, ref)=>{
    const { editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
            size: "small",
            label: ""
        }),
        isDisabled: disabled,
        href: href,
        target: target,
        rel: rel,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>onClick(e)
    }, formatMessage(editorAppearance === 'comment' ? (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideoComment : (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideo));
});
module.exports["LoomMenuItem"] = $6934ba2fbea4b39b$export$cfd738d449e0a4ef;

});

parcelRegister("3Y62F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gzUv9 = parcelRequire("gzUv9");


var $6UWPx = parcelRequire("6UWPx");

const $0e0411cca8afc5ea$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
};
const $0e0411cca8afc5ea$export$4b1545b4f2016d26 = ({ children: children, api: api })=>{
    const { editorViewMode: editorViewMode } = $0e0411cca8afc5ea$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit';
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UWPx.ToolbarDropdownItemSection), {
        hasSeparator: isEdit
    }, children);
};
module.exports["MenuSection"] = $0e0411cca8afc5ea$export$4b1545b4f2016d26;

});

parcelRegister("2n8po", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");

parcelRequire("42omo");


var $31bj1 = parcelRequire("31bj1");


var $9JSVA = parcelRequire("9JSVA");

const $f0c37d2844a91b76$export$62ed72bc21f6b8a6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $frIzR.c)(6);
    const { appearance: t1, edge: edge, gap: gap, indent: indent, type: type } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $9JSVA.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== edge || $[1] !== gap || $[2] !== indent || $[3] !== t2 || $[4] !== type) {
        t3 = /*#__PURE__*/ (0, $l998X.jsx)((0, $31bj1.Line), {
            edge: edge,
            gap: gap,
            strokeColor: t2,
            type: type,
            indent: indent
        });
        $[0] = edge;
        $[1] = gap;
        $[2] = indent;
        $[3] = t2;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $31bj1.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
};
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f0c37d2844a91b76$export$2e2bcd8739ae039 = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["default"] = $f0c37d2844a91b76$export$2e2bcd8739ae039;

});

parcelRegister("31bj1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $1707735fc36ab082$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $1707735fc36ab082$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $1707735fc36ab082$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $1707735fc36ab082$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $1707735fc36ab082$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
const $1707735fc36ab082$export$17d680238e50603e = (0, $4pOgL.isReactCompilerActivePlatform)() ? function Line(t0) {
    const $ = (0, $frIzR.c)(15);
    const { edge: edge, gap: t1, indent: t2, strokeColor: t3, strokeWidth: t4, type: t5 } = t0;
    const gap = t1 === undefined ? "0px" : t1;
    const indent = t2 === undefined ? "0px" : t2;
    const strokeColor = t3 === undefined ? (0, $9JSVA.presetStrokeColors).default : t3;
    const strokeWidth = t4 === undefined ? (0, $9JSVA.presetStrokeWidth) : t4;
    const type = t5 === undefined ? "terminal" : t5;
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    const t6 = `calc(-0.5 * (${gap} + var(--stroke-width)))`;
    let t7;
    if ($[0] !== indent || $[1] !== type) {
        t7 = $1707735fc36ab082$var$lineStartFrom[type]({
            indent: indent
        });
        $[0] = indent;
        $[1] = type;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = type === "no-terminal" ? "none" : "block";
    let t9;
    if ($[3] !== strokeColor || $[4] !== strokeWidth || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
        t9 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--main-axis-offset": t6,
            "--line-main-axis-start": t7,
            "--terminal-display": t8,
            "--terminal-diameter": "calc(var(--stroke-width) * 4)",
            "--terminal-radius": "calc(var(--terminal-diameter) / 2)",
            "--terminal-main-axis-start": "calc(-1 * var(--terminal-diameter))",
            "--terminal-cross-axis-offset": "calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)"
        };
        $[3] = strokeColor;
        $[4] = strokeWidth;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = t9;
    const t11 = $1707735fc36ab082$var$orientationStyles[orientation];
    const t12 = $1707735fc36ab082$var$edgeStyles[edge];
    let t13;
    if ($[9] !== t11 || $[10] !== t12) {
        t13 = (0, $gMc0m.default)([
            $1707735fc36ab082$var$baseStyles.root,
            t11,
            t12
        ]);
        $[9] = t11;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] !== t10 || $[13] !== t13) {
        t14 = /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: t10,
            className: t13
        });
        $[12] = t10;
        $[13] = t13;
        $[14] = t14;
    } else t14 = $[14];
    return t14;
} : function Line({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $1707735fc36ab082$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $gMc0m.default)([
            $1707735fc36ab082$var$baseStyles.root,
            $1707735fc36ab082$var$orientationStyles[orientation],
            $1707735fc36ab082$var$edgeStyles[edge]
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$1707735fc36ab082$export$2e2bcd8739ae039 = $1707735fc36ab082$export$17d680238e50603e;
module.exports["Line"] = $1707735fc36ab082$export$17d680238e50603e;

});

parcelRegister("9JSVA", function(module, exports) {
const $795a0d6001dc944e$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $795a0d6001dc944e$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $795a0d6001dc944e$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $795a0d6001dc944e$export$45db03aa04b685e3;

});

parcelRegister("cILXD", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("bLeKY")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("6SYln")).useRouterActions);
$parcel$export(module.exports, "Link", () => (parcelRequire("iNLdL")).default);
$parcel$export(module.exports, "RouterStore", () => (parcelRequire("fvDxY")).RouterStore);
$parcel$export(module.exports, "useRouterStoreActions", () => (parcelRequire("fvDxY")).useRouterStoreActions);

parcelRequire("fekRU");
var $bLeKY = parcelRequire("bLeKY");
var $6SYln = parcelRequire("6SYln");

parcelRequire("2yKZA");
var $iNLdL = parcelRequire("iNLdL");

parcelRequire("fJGSb");
var $7cg8h = parcelRequire("7cg8h");
var $eNEWi = parcelRequire("eNEWi");
var $kgdzf = parcelRequire("kgdzf");
var $fJGSb = parcelRequire("fJGSb");


var $2OiMz = parcelRequire("2OiMz");


var $fvDxY = parcelRequire("fvDxY");


var $eknCg = parcelRequire("eknCg");

parcelRequire("2BZYg");
var $dAheB = parcelRequire("dAheB");
var $dCvbe = parcelRequire("dCvbe");
var $7dOkC = parcelRequire("7dOkC");


});

parcelRegister("9ML05", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");











var $4KS7f = parcelRequire("4KS7f");


var $3gadb = parcelRequire("3gadb");


var $4qrTW = parcelRequire("4qrTW");

const $d9f8522a95eafbc1$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };


const $15fa71be19d9664f$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(48);
    let component;
    let href;
    let icon;
    let id;
    let isDisabled;
    let isSelected;
    let label;
    let onBlur;
    let onClick;
    let onFocus;
    let onMouseDown;
    let onMouseEnter;
    let onMouseLeave;
    let onMouseUp;
    let rest;
    let t0;
    let target;
    let testId;
    let theme;
    let tooltip;
    if ($[0] !== props) {
        ({ icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: t0, ...rest } = props);
        $[0] = props;
        $[1] = component;
        $[2] = href;
        $[3] = icon;
        $[4] = id;
        $[5] = isDisabled;
        $[6] = isSelected;
        $[7] = label;
        $[8] = onBlur;
        $[9] = onClick;
        $[10] = onFocus;
        $[11] = onMouseDown;
        $[12] = onMouseEnter;
        $[13] = onMouseLeave;
        $[14] = onMouseUp;
        $[15] = rest;
        $[16] = t0;
        $[17] = target;
        $[18] = testId;
        $[19] = theme;
        $[20] = tooltip;
    } else {
        component = $[1];
        href = $[2];
        icon = $[3];
        id = $[4];
        isDisabled = $[5];
        isSelected = $[6];
        label = $[7];
        onBlur = $[8];
        onClick = $[9];
        onFocus = $[10];
        onMouseDown = $[11];
        onMouseEnter = $[12];
        onMouseLeave = $[13];
        onMouseUp = $[14];
        rest = $[15];
        t0 = $[16];
        target = $[17];
        testId = $[18];
        theme = $[19];
        tooltip = $[20];
    }
    const isTooltipAnnouncementDisabled = t0 === undefined ? false : t0;
    const themeFromContext = (0, $4qrTW.useTheme)();
    let t1;
    if ($[21] !== theme || $[22] !== themeFromContext) {
        t1 = theme || (0, $d9f8522a95eafbc1$export$f32bddcb857301f3)(themeFromContext);
        $[21] = theme;
        $[22] = themeFromContext;
        $[23] = t1;
    } else t1 = $[23];
    let t2;
    if ($[24] !== component || $[25] !== href || $[26] !== icon || $[27] !== id || $[28] !== isDisabled || $[29] !== isSelected || $[30] !== label || $[31] !== onBlur || $[32] !== onClick || $[33] !== onFocus || $[34] !== onMouseDown || $[35] !== onMouseEnter || $[36] !== onMouseLeave || $[37] !== onMouseUp || $[38] !== ref || $[39] !== rest || $[40] !== t1 || $[41] !== target || $[42] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            appearance: "primary",
            "aria-label": label,
            component: component,
            href: href,
            iconBefore: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            theme: t1,
            ...rest
        });
        $[24] = component;
        $[25] = href;
        $[26] = icon;
        $[27] = id;
        $[28] = isDisabled;
        $[29] = isSelected;
        $[30] = label;
        $[31] = onBlur;
        $[32] = onClick;
        $[33] = onFocus;
        $[34] = onMouseDown;
        $[35] = onMouseEnter;
        $[36] = onMouseLeave;
        $[37] = onMouseUp;
        $[38] = ref;
        $[39] = rest;
        $[40] = t1;
        $[41] = target;
        $[42] = testId;
        $[43] = t2;
    } else t2 = $[43];
    const button = t2;
    if (tooltip) {
        let t3;
        if ($[44] !== button || $[45] !== isTooltipAnnouncementDisabled || $[46] !== tooltip) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: tooltip,
                hideTooltipOnClick: true,
                isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled
            }, button);
            $[44] = button;
            $[45] = isTooltipAnnouncementDisabled;
            $[46] = tooltip;
            $[47] = t3;
        } else t3 = $[47];
        return t3;
    }
    return button;
} : (props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $4qrTW.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $d9f8522a95eafbc1$export$f32bddcb857301f3)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled
    }, button);
    return button;
});


const $0be61804ed286c81$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(41);
    let component;
    let href;
    let icon;
    let id;
    let isDisabled;
    let isSelected;
    let labelProp;
    let onBlur;
    let onClick;
    let onFocus;
    let onMouseDown;
    let onMouseEnter;
    let onMouseLeave;
    let onMouseUp;
    let rest;
    let target;
    let testId;
    let theme;
    let tooltip;
    if ($[0] !== props) {
        ({ component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props);
        $[0] = props;
        $[1] = component;
        $[2] = href;
        $[3] = icon;
        $[4] = id;
        $[5] = isDisabled;
        $[6] = isSelected;
        $[7] = labelProp;
        $[8] = onBlur;
        $[9] = onClick;
        $[10] = onFocus;
        $[11] = onMouseDown;
        $[12] = onMouseEnter;
        $[13] = onMouseLeave;
        $[14] = onMouseUp;
        $[15] = rest;
        $[16] = target;
        $[17] = testId;
        $[18] = theme;
        $[19] = tooltip;
    } else {
        component = $[1];
        href = $[2];
        icon = $[3];
        id = $[4];
        isDisabled = $[5];
        isSelected = $[6];
        labelProp = $[7];
        onBlur = $[8];
        onClick = $[9];
        onFocus = $[10];
        onMouseDown = $[11];
        onMouseEnter = $[12];
        onMouseLeave = $[13];
        onMouseUp = $[14];
        rest = $[15];
        target = $[16];
        testId = $[17];
        theme = $[18];
        tooltip = $[19];
    }
    const label = labelProp || (typeof tooltip === "string" ? tooltip : "Your profile and settings");
    let t0;
    if ($[20] !== component || $[21] !== href || $[22] !== icon || $[23] !== id || $[24] !== isDisabled || $[25] !== isSelected || $[26] !== label || $[27] !== onBlur || $[28] !== onClick || $[29] !== onFocus || $[30] !== onMouseDown || $[31] !== onMouseEnter || $[32] !== onMouseLeave || $[33] !== onMouseUp || $[34] !== ref || $[35] !== rest || $[36] !== target || $[37] !== testId || $[38] !== theme || $[39] !== tooltip) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $15fa71be19d9664f$export$c25acd513dcc8062), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        }));
        $[20] = component;
        $[21] = href;
        $[22] = icon;
        $[23] = id;
        $[24] = isDisabled;
        $[25] = isSelected;
        $[26] = label;
        $[27] = onBlur;
        $[28] = onClick;
        $[29] = onFocus;
        $[30] = onMouseDown;
        $[31] = onMouseEnter;
        $[32] = onMouseLeave;
        $[33] = onMouseUp;
        $[34] = ref;
        $[35] = rest;
        $[36] = target;
        $[37] = testId;
        $[38] = theme;
        $[39] = tooltip;
        $[40] = t0;
    } else t0 = $[40];
    return t0;
} : (props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $15fa71be19d9664f$export$c25acd513dcc8062), {
        component: component,
        href: href,
        icon: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    }));
});
module.exports["Profile"] = $0be61804ed286c81$export$5120f2d0b8d4cab8;

});

parcelRegister("4qrTW", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $2DnkX = parcelRequire("2DnkX");

const $14a2b16d436ce3a5$export$93d4e7f90805808f = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)((0, $2DnkX.ThemeContext));
} : ()=>(0, $42omo.useContext)((0, $2DnkX.ThemeContext));
module.exports["useTheme"] = $14a2b16d436ce3a5$export$93d4e7f90805808f;

});

parcelRegister("2DnkX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ahT8g = parcelRequire("ahT8g");

const $4e884b8efc8f269f$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ahT8g.defaultTheme));
module.exports["ThemeContext"] = $4e884b8efc8f269f$export$2c657da244d00bd6;

});

parcelRegister("ahT8g", function(module, exports) {

var $a0ZVg = parcelRequire("a0ZVg");

const $245571a50d5c46d4$export$164de7ab8df77ef0 = (0, $a0ZVg.atlassianTheme);
module.exports["defaultTheme"] = $245571a50d5c46d4$export$164de7ab8df77ef0;

});

parcelRegister("a0ZVg", function(module, exports) {

var $lCH0w = parcelRequire("lCH0w");


var $jeF0t = parcelRequire("jeF0t");

const $03958183e124dca2$export$eeee8619e1b91cb0 = (0, $jeF0t.generateTheme)({
    name: (0, $lCH0w.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});
module.exports["atlassianTheme"] = $03958183e124dca2$export$eeee8619e1b91cb0;

});

parcelRegister("lCH0w", function(module, exports) {
const $08762123b36e773e$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $08762123b36e773e$var$defaultThemeCopy = JSON.parse(JSON.stringify($08762123b36e773e$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$08762123b36e773e$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$08762123b36e773e$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $08762123b36e773e$export$2491e13b198e597d = 'atlassian';
var $08762123b36e773e$export$2e2bcd8739ae039 = $08762123b36e773e$var$defaultTheme;
module.exports["DEFAULT_THEME_NAME"] = $08762123b36e773e$export$2491e13b198e597d;
module.exports["default"] = $08762123b36e773e$export$2e2bcd8739ae039;

});

parcelRegister("jeF0t", function(module, exports) {

var $lCH0w = parcelRequire("lCH0w");


var $fPQM7 = parcelRequire("fPQM7");


var $78UIl = parcelRequire("78UIl");


var $2z33P = parcelRequire("2z33P");


var $WGIbD = parcelRequire("WGIbD");


var $9x0PE = parcelRequire("9x0PE");

const $1ebbdfb973eaad0e$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $1ebbdfb973eaad0e$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $1ebbdfb973eaad0e$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $9x0PE.hexToRGBA)(backgroundColor, 0.65) : (0, $WGIbD.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $2z33P.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $2z33P.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $9x0PE.hexToRGBA)(backgroundColor, 0.8) : (0, $WGIbD.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $2z33P.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $WGIbD.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $2z33P.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $WGIbD.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $2z33P.getBoxShadow)('transparent')
        }
    };
};
const $1ebbdfb973eaad0e$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $78UIl.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $1ebbdfb973eaad0e$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $78UIl.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $lCH0w.DEFAULT_THEME_NAME)) return 0, $fPQM7.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $1ebbdfb973eaad0e$var$generateButtonCSSStates($1ebbdfb973eaad0e$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $1ebbdfb973eaad0e$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $1ebbdfb973eaad0e$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $9x0PE.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $9x0PE.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $9x0PE.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $2z33P.getBoxShadow)((0, $9x0PE.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $WGIbD.getContrastColor)(0.1, $1ebbdfb973eaad0e$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
module.exports["generateTheme"] = $1ebbdfb973eaad0e$export$2e4ecffaca289a18;

});

parcelRegister("fPQM7", function(module, exports) {

var $lCH0w = parcelRequire("lCH0w");

const $d21c66f3717d746b$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $lCH0w.default)));
const $d21c66f3717d746b$export$77823bc9863eaa03 = $d21c66f3717d746b$var$defaultThemeCopy;
module.exports["defaultThemeBrandRefresh"] = $d21c66f3717d746b$export$77823bc9863eaa03;

});

parcelRegister("78UIl", function(module, exports) {

var $lcPXp = parcelRequire("lcPXp");


var $dqCO0 = parcelRequire("dqCO0");

const $f0a990ddad2b144b$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $dqCO0.convertHexShorthand)(color);
    return (0, $lcPXp.default).contrastRatio(converted).hex;
};
module.exports["generateTextColor"] = $f0a990ddad2b144b$export$10a10e7cd1193377;

});

parcelRegister("dqCO0", function(module, exports) {
const $0b5ea9a632ade2be$var$hex = '[a-z0-9]';
const $0b5ea9a632ade2be$var$shortHandHexColorPattern = new RegExp(`#(${$0b5ea9a632ade2be$var$hex})(${$0b5ea9a632ade2be$var$hex})(${$0b5ea9a632ade2be$var$hex})`, 'i');
const $0b5ea9a632ade2be$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $0b5ea9a632ade2be$var$isShortHexColor = (color)=>color && color.length === 4;
const $0b5ea9a632ade2be$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$0b5ea9a632ade2be$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $0b5ea9a632ade2be$var$completeTriplet = (colors)=>`#${$0b5ea9a632ade2be$var$repeat(colors[1], 6)}`;
const $0b5ea9a632ade2be$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $0b5ea9a632ade2be$export$db8d2130677f868c = (color)=>{
    if ($0b5ea9a632ade2be$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($0b5ea9a632ade2be$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($0b5ea9a632ade2be$var$isTriplet(colors)) return $0b5ea9a632ade2be$var$completeTriplet(colors);
            else return $0b5ea9a632ade2be$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
module.exports["convertHexShorthand"] = $0b5ea9a632ade2be$export$db8d2130677f868c;

});

parcelRegister("2z33P", function(module, exports) {
const $0cc90bf2b0f7cfc2$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
module.exports["getBoxShadow"] = $0cc90bf2b0f7cfc2$export$bba5a971afe05444;

});

parcelRegister("WGIbD", function(module, exports) {

var $lcPXp = parcelRequire("lcPXp");


var $9x0PE = parcelRequire("9x0PE");

const $1dbd2704b89a1348$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $9x0PE.hexToRGBA)((0, $lcPXp.default).contrast(contrastValue, color).hex, opacityValue);
module.exports["getContrastColor"] = $1dbd2704b89a1348$export$77a1051494882576;

});

parcelRegister("9x0PE", function(module, exports) {

var $lcPXp = parcelRequire("lcPXp");

const $8d435839a182b9d3$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $lcPXp.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
module.exports["hexToRGBA"] = $8d435839a182b9d3$export$7229be6d7219ee6a;

});

parcelRegister("fJM5Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd36682bcf7d93c8d6a4f8218f4f4e2d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7505d4a6629268d$var$_react = $b7505d4a6629268d$var$_interopRequireDefault((parcelRequire("42omo")));

var $b7505d4a6629268d$var$_baseNew = $b7505d4a6629268d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b7505d4a6629268d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Home".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7505d4a6629268d$var$HomeIcon = (props)=>/*#__PURE__*/ $b7505d4a6629268d$var$_react.default.createElement($b7505d4a6629268d$var$_baseNew.default, Object.assign({
        name: "HomeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.646.727a2 2 0 0 1 2.708 0l5 4.6A2 2 0 0 1 15 6.799V13a2 2 0 0 1-2 2H9.75a.75.75 0 0 1-.75-.75V9.5H7v4.75a.75.75 0 0 1-.75.75H3a2 2 0 0 1-2-2V6.799a2 2 0 0 1 .646-1.472zM8.339 1.83a.5.5 0 0 0-.678 0l-5 4.6a.5.5 0 0 0-.161.368V13a.5.5 0 0 0 .5.5h2.5V8.75A.75.75 0 0 1 6.25 8h3.5a.75.75 0 0 1 .75.75v4.75H13a.5.5 0 0 0 .5-.5V6.799a.5.5 0 0 0-.162-.368z" clip-rule="evenodd"/>`
    }, props));
$b7505d4a6629268d$var$HomeIcon.displayName = 'HomeIcon';
var $b7505d4a6629268d$var$_default = module.exports.default = $b7505d4a6629268d$var$HomeIcon;

});

parcelRegister("6S3N0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e354977285efce08ec10c33c7aa547f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $500ab9b98f2dde41$var$_react = $500ab9b98f2dde41$var$_interopRequireDefault((parcelRequire("42omo")));

var $500ab9b98f2dde41$var$_baseNew = $500ab9b98f2dde41$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $500ab9b98f2dde41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $500ab9b98f2dde41$var$InboxIcon = (props)=>/*#__PURE__*/ $500ab9b98f2dde41$var$_react.default.createElement($500ab9b98f2dde41$var$_baseNew.default, Object.assign({
        name: "InboxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$500ab9b98f2dde41$var$InboxIcon.displayName = 'InboxIcon';
var $500ab9b98f2dde41$var$_default = module.exports.default = $500ab9b98f2dde41$var$InboxIcon;

});

parcelRegister("aaEXZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba900c72212c64dae6bc7b16bbe38cce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $767a9dabdc94c6ea$var$_react = $767a9dabdc94c6ea$var$_interopRequireDefault((parcelRequire("42omo")));

var $767a9dabdc94c6ea$var$_baseNew = $767a9dabdc94c6ea$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $767a9dabdc94c6ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $767a9dabdc94c6ea$var$MenuIcon = (props)=>/*#__PURE__*/ $767a9dabdc94c6ea$var$_react.default.createElement($767a9dabdc94c6ea$var$_baseNew.default, Object.assign({
        name: "MenuIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15 12.5V14H1v-1.5zm0-5.25v1.5H1v-1.5zM15 2v1.5H1V2z"/>`
    }, props));
$767a9dabdc94c6ea$var$MenuIcon.displayName = 'MenuIcon';
var $767a9dabdc94c6ea$var$_default = module.exports.default = $767a9dabdc94c6ea$var$MenuIcon;

});

parcelRegister("8PMrR", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");

const $b14a95969404228e$var$noop = ()=>{};
const $b14a95969404228e$export$2c6067e95d1be081 = (0, $42omo.createContext)({
    options: null,
    setOptions: $b14a95969404228e$var$noop
});
const $b14a95969404228e$export$ce205152a61c4e11 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($b14a95969404228e$export$2c6067e95d1be081);
} : ()=>(0, $42omo.useContext)($b14a95969404228e$export$2c6067e95d1be081);
module.exports["useNavigationStyle"] = $b14a95969404228e$export$ce205152a61c4e11;

});

parcelRegister("wcTgs", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $67bcf6e29384be22$var$_default_1 = (0, $aXWIB.defineMessages)({
    editSite: {
        id: "hub-app-shell.avatar-menu.edit-site",
        defaultMessage: "Edit site"
    },
    profile: {
        id: "hub-app-shell.avatar-menu.profile",
        defaultMessage: "Profile"
    },
    logout: {
        id: "hub-app-shell.avatar-menu.logout",
        defaultMessage: "Logout"
    }
});
var $67bcf6e29384be22$export$2e2bcd8739ae039 = $67bcf6e29384be22$var$_default_1;
module.exports["default"] = $67bcf6e29384be22$export$2e2bcd8739ae039;

});

parcelRegister("b44o4", function(module, exports) {
const $6e83c683dfe7ee01$var$MODELS_API_URL = '/rest/servicedesk/1/customer/models';
const $6e83c683dfe7ee01$export$9aabeb09177df765 = async (cloudUrl, helpCenterAri)=>{
    const response = await fetch(`${cloudUrl}${$6e83c683dfe7ee01$var$MODELS_API_URL}`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                clientBasePath: cloudUrl,
                helpCenterAri: helpCenterAri
            },
            models: [
                'userRequestsCounts'
            ]
        })
    });
    return response.json();
};
module.exports["getRequestCount"] = $6e83c683dfe7ee01$export$9aabeb09177df765;

});

parcelRegister("ahcSt", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<0b420321b8f0e6761b0f1e413d38c4e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $56f09d887b3a4cf8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moreDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "customPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "CUSTOM"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
        }
    ],
    "type": "HelpCenter"
};
$56f09d887b3a4cf8$var$node.hash = "bdf2ee4c0e7d81a58ea6f6250d6f062a";
var $56f09d887b3a4cf8$export$2e2bcd8739ae039 = $56f09d887b3a4cf8$var$node;



var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $irOoi = parcelRequire("irOoi");

parcelRequire("cILXD");
var $6SYln = parcelRequire("6SYln");


var $eEA8O = parcelRequire("eEA8O");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $8jHAi = parcelRequire("8jHAi");


var $56M4r = parcelRequire("56M4r");

var $7rvPL = parcelRequire("7rvPL");


var $g9Srd = parcelRequire("g9Srd");

var $htJyp = parcelRequire("htJyp");


var $5dK2X = parcelRequire("5dK2X");


var $3uOfZ = parcelRequire("3uOfZ");




const $3e3a2e75e316724e$var$messages = (0, $aXWIB.defineMessages)({
    more: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more",
        defaultMessage: "More"
    },
    moreDownIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more.chevron-down",
        defaultMessage: "Open more dropdown"
    },
    moreUpIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more.chevron-up",
        defaultMessage: "Close more dropdown"
    },
    pageIconLabel: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more.page-icon-label",
        defaultMessage: "Page icon"
    }
});
var $3e3a2e75e316724e$export$2e2bcd8739ae039 = $3e3a2e75e316724e$var$messages;


const $962843d891b711b3$var$styles = {
    overflowHidden: "_1reo15vq _18m915vq",
    dropdownItems: "_19bvu2gc"
};
const $962843d891b711b3$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq15r3 _5sagi9qs _1pgl1lbj"
};
const $962843d891b711b3$export$6d7fd1d1521d3638 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(40);
    const { queryRef: queryRef, textColor: textColor, isMobile: isMobile } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { push: push } = (0, $6SYln.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const data = (0, $irOoi.useFragment)((0, $56f09d887b3a4cf8$export$2e2bcd8739ae039), queryRef);
    const customPages = data?.customPages;
    if (!customPages || customPages.length === 0) return null;
    if (isMobile) {
        let t1;
        if ($[0] !== formatMessage || $[1] !== isExpanded) {
            t1 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                label: formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).moreUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).moreDownIcon)
            });
            $[0] = formatMessage;
            $[1] = isExpanded;
            $[2] = t1;
        } else t1 = $[2];
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = ()=>setIsExpanded($962843d891b711b3$var$_temp);
            $[3] = t2;
        } else t2 = $[3];
        let t3;
        if ($[4] !== formatMessage) {
            t3 = formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).more);
            $[4] = formatMessage;
            $[5] = t3;
        } else t3 = $[5];
        let t4;
        if ($[6] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "medium"
            }, t3);
            $[6] = t3;
            $[7] = t4;
        } else t4 = $[7];
        let t5;
        if ($[8] !== isExpanded || $[9] !== t1 || $[10] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                iconAfter: t1,
                onClick: t2,
                "aria-expanded": isExpanded
            }, t4);
            $[8] = isExpanded;
            $[9] = t1;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $gMc0m.default)([
                $962843d891b711b3$var$styles.overflowHidden
            ]);
            $[12] = t6;
        } else t6 = $[12];
        let t7;
        if ($[13] !== customPages || $[14] !== isExpanded || $[15] !== push) {
            t7 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
                enteringAnimationXcss: $962843d891b711b3$var$motionStyles.slideEntering,
                exitingAnimationXcss: $962843d891b711b3$var$motionStyles.slideExiting
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "more-dropdown-items",
                className: (0, $gMc0m.default)([
                    $962843d891b711b3$var$styles.dropdownItems
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, customPages.map((page)=>{
                const pageId = page?.id ? (0, $3uOfZ.HelpPageAri).parse(page.id).pageId : "";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                    key: pageId,
                    testId: `nav-custom-page-${pageId}`,
                    onClick: ()=>{
                        push(`/page/${pageId}`);
                    }
                }, page?.name?.default);
            }))));
            $[13] = customPages;
            $[14] = isExpanded;
            $[15] = push;
            $[16] = t7;
        } else t7 = $[16];
        let t8;
        if ($[17] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
                appear: true
            }, t7);
            $[17] = t7;
            $[18] = t8;
        } else t8 = $[18];
        let t9;
        if ($[19] !== t6 || $[20] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: t6
            }, t8);
            $[19] = t6;
            $[20] = t8;
            $[21] = t9;
        } else t9 = $[21];
        let t10;
        if ($[22] !== t5 || $[23] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, t9);
            $[22] = t5;
            $[23] = t9;
            $[24] = t10;
        } else t10 = $[24];
        return t10;
    }
    let t1;
    if ($[25] !== formatMessage || $[26] !== textColor) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...props } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).moreDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).more));
        };
        $[25] = formatMessage;
        $[26] = textColor;
        $[27] = t1;
    } else t1 = $[27];
    let t2;
    if ($[28] !== customPages || $[29] !== formatMessage || $[30] !== push) {
        let t3;
        if ($[32] !== formatMessage || $[33] !== push) {
            t3 = (page_0)=>{
                const pageId_0 = page_0?.id ? (0, $3uOfZ.HelpPageAri).parse(page_0.id).pageId : "";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                    key: pageId_0,
                    testId: `nav-custom-page-${pageId_0}`,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                        label: formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).pageIconLabel)
                    }),
                    onClick: ()=>{
                        push(`/page/${pageId_0}`);
                    }
                }, page_0?.name?.default);
            };
            $[32] = formatMessage;
            $[33] = push;
            $[34] = t3;
        } else t3 = $[34];
        t2 = customPages.map(t3);
        $[28] = customPages;
        $[29] = formatMessage;
        $[30] = push;
        $[31] = t2;
    } else t2 = $[31];
    let t3;
    if ($[35] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, t2);
        $[35] = t2;
        $[36] = t3;
    } else t3 = $[36];
    let t4;
    if ($[37] !== t1 || $[38] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            trigger: t1,
            shouldRenderToParent: true
        }, t3);
        $[37] = t1;
        $[38] = t3;
        $[39] = t4;
    } else t4 = $[39];
    return t4;
} : ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { push: push } = (0, $6SYln.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const data = (0, $irOoi.useFragment)((0, $56f09d887b3a4cf8$export$2e2bcd8739ae039), queryRef);
    const customPages = data?.customPages;
    if (!customPages || customPages.length === 0) return null;
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).moreUpIcon)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).moreDownIcon)
        }),
        onClick: ()=>setIsExpanded((prev)=>!prev),
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "medium"
    }, formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).more))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $962843d891b711b3$var$styles.overflowHidden
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
        enteringAnimationXcss: $962843d891b711b3$var$motionStyles.slideEntering,
        exitingAnimationXcss: $962843d891b711b3$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "more-dropdown-items",
        className: (0, $gMc0m.default)([
            $962843d891b711b3$var$styles.dropdownItems
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, customPages.map((page)=>{
        const pageId = page?.id ? (0, $3uOfZ.HelpPageAri).parse(page.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            key: pageId,
            testId: `nav-custom-page-${pageId}`,
            onClick: ()=>{
                push(`/page/${pageId}`);
            }
        }, page?.name?.default);
    })))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).moreDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).more)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, customPages.map((page_0)=>{
        const pageId_0 = page_0?.id ? (0, $3uOfZ.HelpPageAri).parse(page_0.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: pageId_0,
            testId: `nav-custom-page-${pageId_0}`,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                label: formatMessage((0, $3e3a2e75e316724e$export$2e2bcd8739ae039).pageIconLabel)
            }),
            onClick: ()=>{
                push(`/page/${pageId_0}`);
            }
        }, page_0?.name?.default);
    })));
};
function $962843d891b711b3$var$_temp(prev) {
    return !prev;
}
module.exports["MoreDropdown"] = $962843d891b711b3$export$6d7fd1d1521d3638;

});

parcelRegister("52EPl", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $ghftu = parcelRequire("ghftu");


var $kIK5c = parcelRequire("kIK5c");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $g5lKx = parcelRequire("g5lKx");


var $cmqV4 = parcelRequire("cmqV4");


var $4hF42 = parcelRequire("4hF42");


var $rTIrg = parcelRequire("rTIrg");


var $nVQ0B = parcelRequire("nVQ0B");


var $dhBFe = parcelRequire("dhBFe");


var $6XsRH = parcelRequire("6XsRH");

const $58fceacc21a186da$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $58fceacc21a186da$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $58fceacc21a186da$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${crossAxis}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-start`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $58fceacc21a186da$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ const $58fceacc21a186da$var$DropdownMenuLegacy = (0, $4pOgL.isReactCompilerActivePlatform)() ? function DropdownMenuLegacy(t0) {
    const $ = (0, $frIzR.c)(63);
    const { autoFocus: t1, children: children, defaultOpen: t2, isLoading: t3, isOpen: isOpen, onOpenChange: t4, placement: t5, shouldFitContainer: t6, shouldFlip: t7, shouldRenderToParent: t8, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: t9, label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: t10, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent } = t0;
    const autoFocus = t1 === undefined ? false : t1;
    const defaultOpen = t2 === undefined ? false : t2;
    const isLoading = t3 === undefined ? false : t3;
    const onOpenChange = t4 === undefined ? (0, $ee7An.default) : t4;
    const placement = t5 === undefined ? "bottom-start" : t5;
    const shouldFitContainer = t6 === undefined ? false : t6;
    const shouldFlip = t7 === undefined ? true : t7;
    const shouldRenderToParent = t8 === undefined ? false : t8;
    let t11;
    if ($[0] !== t9) {
        t11 = t9 === undefined ? (0, $g5lKx.layers).modal() : t9;
        $[0] = t9;
        $[1] = t11;
    } else t11 = $[1];
    const zIndex = t11;
    const shouldPreventEscapePropagation = t10 === undefined ? false : t10;
    let t12;
    if ($[2] !== defaultOpen) {
        t12 = ()=>defaultOpen;
        $[2] = defaultOpen;
        $[3] = t12;
    } else t12 = $[3];
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, t12);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $kIK5c.useLayering)();
    let t13;
    if ($[4] !== placement) {
        t13 = $58fceacc21a186da$var$getFallbackPlacements(placement);
        $[4] = placement;
        $[5] = t13;
    } else t13 = $[5];
    const fallbackPlacements = t13;
    let t14;
    if ($[6] !== isLocalOpen || $[7] !== itemRef || $[8] !== onOpenChange || $[9] !== setLocalIsOpen) {
        t14 = (event)=>{
            const newValue = !isLocalOpen;
            const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
            if (type === "keydown") setTriggeredUsingKeyboard(true);
            else {
                if (clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
                else if (detail === 0) setTriggeredUsingKeyboard(true);
                else {
                    itemRef?.current?.focus();
                    setTriggeredUsingKeyboard(false);
                }
            }
            setLocalIsOpen(newValue);
            onOpenChange({
                isOpen: newValue,
                event: event
            });
        };
        $[6] = isLocalOpen;
        $[7] = itemRef;
        $[8] = onOpenChange;
        $[9] = setLocalIsOpen;
        $[10] = t14;
    } else t14 = $[10];
    const handleTriggerClicked = t14;
    let t15;
    if ($[11] !== itemRef || $[12] !== onOpenChange || $[13] !== returnFocusRef || $[14] !== setLocalIsOpen || $[15] !== shouldPreventEscapePropagation) {
        t15 = (event_0, currentLevel_0)=>{
            const isTabLeftOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" || event_0.key === "Escape" || event_0.key === (0, $4JWgN.KEY_LEFT));
            if (shouldPreventEscapePropagation && $58fceacc21a186da$var$isKeyboardEvent(event_0) && (event_0.key === "Escape" || event_0.key === (0, $4JWgN.KEY_LEFT))) event_0.stopPropagation();
            if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
                if (!currentLevel_0) return;
                const toCloseLevel = itemRef.current?.dataset["ds-Level"];
                if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
            }
            if (returnFocusRef) requestAnimationFrame(()=>{
                returnFocusRef.current?.focus();
            });
            else {
                if ($58fceacc21a186da$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" && event_0.shiftKey || event_0.key === "Escape" || event_0.key === (0, $4JWgN.KEY_LEFT))) requestAnimationFrame(()=>{
                    itemRef.current?.focus();
                });
                else if (triggerRef.current) {
                    const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.("[role=\"menu\"]") === null;
                    const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body;
                    if (!shouldPreventFocus) requestAnimationFrame(()=>{
                        triggerRef.current?.focus();
                    });
                }
            }
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: event_0
            });
        };
        $[11] = itemRef;
        $[12] = onOpenChange;
        $[13] = returnFocusRef;
        $[14] = setLocalIsOpen;
        $[15] = shouldPreventEscapePropagation;
        $[16] = t15;
    } else t15 = $[16];
    const handleOnClose = t15;
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    let t16;
    let t17;
    if ($[17] !== handleOnClose || $[18] !== handleTriggerClicked || $[19] !== isFocused || $[20] !== isLocalOpen) {
        t16 = ()=>{
            if (!isFocused) return 0, $ee7An.default;
            if (isLocalOpen) return 0, $ee7An.default;
            return (0, $fFa3V.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    let isNestedTriggerButton;
                    if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                    if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    } else {
                        if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
                        else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) handleOnClose(e);
                    }
                }
            });
        };
        t17 = [
            isFocused,
            isLocalOpen,
            handleTriggerClicked,
            handleOnClose
        ];
        $[17] = handleOnClose;
        $[18] = handleTriggerClicked;
        $[19] = isFocused;
        $[20] = isLocalOpen;
        $[21] = t16;
        $[22] = t17;
    } else {
        t16 = $[21];
        t17 = $[22];
    }
    (0, $42omo.useEffect)(t16, t17);
    let t18;
    if ($[23] !== shouldFitContainer || $[24] !== shouldRenderToParent || $[25] !== strategy) {
        t18 = shouldFitContainer ? {
            shouldFitContainer: shouldFitContainer,
            strategy: strategy !== "fixed" ? strategy : undefined
        } : {
            shouldRenderToParent: shouldRenderToParent,
            strategy: strategy
        };
        $[23] = shouldFitContainer;
        $[24] = shouldRenderToParent;
        $[25] = strategy;
        $[26] = t18;
    } else t18 = $[26];
    const conditionalProps = t18;
    const t19 = isLocalOpen ? id : undefined;
    const t20 = returnFocusRef === undefined;
    const t21 = shouldRenderToParent && currentLevel > 0 ? "group" : undefined;
    const t22 = testId && `${testId}--content`;
    let t23;
    if ($[27] !== bindFocus || $[28] !== handleTriggerClicked || $[29] !== interactionName || $[30] !== isLocalOpen || $[31] !== itemRef || $[32] !== label || $[33] !== testId || $[34] !== trigger) {
        t23 = (t24)=>{
            const { ref: ref, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, ...rest } = t24;
            if (typeof trigger === "function") return trigger({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $3654r.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...bindFocus,
                ref: (0, $3654r.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: $58fceacc21a186da$var$_temp,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label,
                interactionName: interactionName
            }, trigger);
        };
        $[27] = bindFocus;
        $[28] = handleTriggerClicked;
        $[29] = interactionName;
        $[30] = isLocalOpen;
        $[31] = itemRef;
        $[32] = label;
        $[33] = testId;
        $[34] = trigger;
        $[35] = t23;
    } else t23 = $[35];
    let t24;
    if ($[36] !== autoFocus || $[37] !== children || $[38] !== handleOnClose || $[39] !== isLoading || $[40] !== isTriggeredUsingKeyboard || $[41] !== menuLabel || $[42] !== shouldFitContainer || $[43] !== shouldRenderToParent || $[44] !== spacing || $[45] !== statusLabel || $[46] !== testId) {
        t24 = (t25)=>{
            const { setInitialFocusRef: setInitialFocusRef, update: update } = t25;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4hF42.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $rTIrg.default), {
                spacing: spacing,
                maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`,
                menuLabel: menuLabel
            }, children));
        };
        $[36] = autoFocus;
        $[37] = children;
        $[38] = handleOnClose;
        $[39] = isLoading;
        $[40] = isTriggeredUsingKeyboard;
        $[41] = menuLabel;
        $[42] = shouldFitContainer;
        $[43] = shouldRenderToParent;
        $[44] = spacing;
        $[45] = statusLabel;
        $[46] = testId;
        $[47] = t24;
    } else t24 = $[47];
    let t25;
    if ($[48] !== conditionalProps || $[49] !== fallbackPlacements || $[50] !== handleOnClose || $[51] !== isLocalOpen || $[52] !== placement || $[53] !== shouldFlip || $[54] !== shouldIgnoreCloseEvent || $[55] !== t19 || $[56] !== t20 || $[57] !== t21 || $[58] !== t22 || $[59] !== t23 || $[60] !== t24 || $[61] !== zIndex) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $nVQ0B.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            id: t19,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: t20,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: t21,
            fallbackPlacements: fallbackPlacements,
            testId: t22,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: t23,
            content: t24
        }));
        $[48] = conditionalProps;
        $[49] = fallbackPlacements;
        $[50] = handleOnClose;
        $[51] = isLocalOpen;
        $[52] = placement;
        $[53] = shouldFlip;
        $[54] = shouldIgnoreCloseEvent;
        $[55] = t19;
        $[56] = t20;
        $[57] = t21;
        $[58] = t22;
        $[59] = t23;
        $[60] = t24;
        $[61] = zIndex;
        $[62] = t25;
    } else t25 = $[62];
    return t25;
} : function DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $g5lKx.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $kIK5c.useLayering)();
    const fallbackPlacements = (0, $42omo.useMemo)(()=>$58fceacc21a186da$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $42omo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $42omo.useCallback)((event_0, currentLevel_0)=>{
        const isTabLeftOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' || event_0.key === 'Escape' || event_0.key === (0, $4JWgN.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $58fceacc21a186da$var$isKeyboardEvent(event_0) && (event_0.key === 'Escape' || event_0.key === (0, $4JWgN.KEY_LEFT))) event_0.stopPropagation();
        if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel_0) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($58fceacc21a186da$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' && event_0.shiftKey || event_0.key === 'Escape' || event_0.key === (0, $4JWgN.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue_0 = false;
        setLocalIsOpen(newValue_0);
        onOpenChange({
            isOpen: newValue_0,
            event: event_0
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $nVQ0B.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $3654r.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...bindFocus,
                ref: (0, $3654r.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label,
                interactionName: interactionName
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4hF42.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $rTIrg.default), {
                spacing: spacing,
                maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`,
                menuLabel: menuLabel
            }, children))
    }));
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ function $58fceacc21a186da$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        ...iconProps,
        size: "small"
    });
}
const $58fceacc21a186da$var$DropdownMenu = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(19);
    const { autoFocus: t0, children: children, defaultOpen: t1, isLoading: t2, isOpen: isOpen, onOpenChange: t3, placement: t4, shouldFitContainer: t5, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    const autoFocus = t0 === undefined ? false : t0;
    const defaultOpen = t1 === undefined ? false : t1;
    const isLoading = t2 === undefined ? false : t2;
    const onOpenChange = t3 === undefined ? (0, $ee7An.default) : t3;
    const placement = t4 === undefined ? "bottom-start" : t4;
    const shouldFitContainer = t5 === undefined ? false : t5;
    if ((0, $dh538.fg)("platform-dst-top-layer")) {
        let t6;
        if ($[0] !== autoFocus || $[1] !== children || $[2] !== defaultOpen || $[3] !== interactionName || $[4] !== isLoading || $[5] !== isOpen || $[6] !== label || $[7] !== menuLabel || $[8] !== onOpenChange || $[9] !== placement || $[10] !== returnFocusRef || $[11] !== shouldFitContainer || $[12] !== spacing || $[13] !== statusLabel || $[14] !== testId || $[15] !== trigger) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cmqV4.default), {
                autoFocus: autoFocus,
                children: children,
                defaultOpen: defaultOpen,
                isLoading: isLoading,
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                placement: placement,
                shouldFitContainer: shouldFitContainer,
                returnFocusRef: returnFocusRef,
                spacing: spacing,
                statusLabel: statusLabel,
                testId: testId,
                trigger: trigger,
                label: label,
                interactionName: interactionName,
                menuLabel: menuLabel
            });
            $[0] = autoFocus;
            $[1] = children;
            $[2] = defaultOpen;
            $[3] = interactionName;
            $[4] = isLoading;
            $[5] = isOpen;
            $[6] = label;
            $[7] = menuLabel;
            $[8] = onOpenChange;
            $[9] = placement;
            $[10] = returnFocusRef;
            $[11] = shouldFitContainer;
            $[12] = spacing;
            $[13] = statusLabel;
            $[14] = testId;
            $[15] = trigger;
            $[16] = t6;
        } else t6 = $[16];
        return t6;
    }
    let t6;
    if ($[17] !== props) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($58fceacc21a186da$var$DropdownMenuLegacy, props);
        $[17] = props;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $dh538.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cmqV4.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($58fceacc21a186da$var$DropdownMenuLegacy, props);
};
var $58fceacc21a186da$export$2e2bcd8739ae039 = $58fceacc21a186da$var$DropdownMenu;
module.exports["default"] = $58fceacc21a186da$export$2e2bcd8739ae039;

});

parcelRegister("6mkwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f7534b8d0112$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $b752f7534b8d0112$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $42omo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $42omo.useRef)(isControlled);
    (0, $42omo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $42omo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("cmqV4", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $ghftu = parcelRequire("ghftu");


var $2SlZp = parcelRequire("2SlZp");


var $9hlns = parcelRequire("9hlns");


var $hFC20 = parcelRequire("hFC20");


var $3rEYI = parcelRequire("3rEYI");


var $bgEkj = parcelRequire("bgEkj");


var $4Mlap = parcelRequire("4Mlap");


var $itGS3 = parcelRequire("itGS3");


var $fjSIv = parcelRequire("fjSIv");


var $hewu1 = parcelRequire("hewu1");


var $nVQ0B = parcelRequire("nVQ0B");


var $cvNpe = parcelRequire("cvNpe");

var $k2dA5 = parcelRequire("k2dA5");

var $JW5lP = parcelRequire("JW5lP");

const $1e16cab33633f070$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $1e16cab33633f070$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k",
    menuContent: "_2rkofajl _bfhk1bhr _16qs130s"
};
const $1e16cab33633f070$var$animation = (0, $hFC20.slideAndFade)(); /**
                                   * Event types produced by trigger interactions.
                                   *
                                   * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
                                   * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
                                   * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
                                   */ 
function $1e16cab33633f070$var$isKeyboardTriggered(event) {
    if (event.type === 'keydown') return true;
    if ('clientX' in event && (event.clientX === 0 || event.clientY === 0)) return true;
    if (event.detail === 0) return true;
    return false;
} /**
   * Loading indicator for the dropdown menu.
   */ 
const $1e16cab33633f070$var$LoadingIndicator = (0, $4pOgL.isReactCompilerActivePlatform)() ? function LoadingIndicator(t0) {
    const $ = (0, $frIzR.c)(4);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            $1e16cab33633f070$var$styles.spinnerContainer
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== statusLabel || $[2] !== testId) {
        t3 = /*#__PURE__*/ $42omo.createElement("div", {
            role: "menuitem",
            className: t2
        }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        }));
        $[1] = statusLabel;
        $[2] = testId;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : function LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ $42omo.createElement("div", {
        role: "menuitem",
        className: (0, $gMc0m.default)([
            $1e16cab33633f070$var$styles.spinnerContainer
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $1e16cab33633f070$var$DropdownMenuTopLayer({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const popoverRef = (0, $42omo.useRef)(null);
    const menuRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const popoverId = (0, $fjSIv.usePopoverId)();
    const topLayerPlacement = (0, $42omo.useMemo)(()=>(0, $bgEkj.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]);
    (0, $itGS3.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen
    });
    (0, $hewu1.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'min-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: triggerRef,
        isOpen: isLocalOpen
    }); // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $42omo.useCallback)(({ reason: _reason })=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]); // Trigger click handling.
    const handleTriggerClicked = (0, $42omo.useCallback)((event)=>{
        const newValue = !isLocalOpen;
        setTriggeredUsingKeyboard($1e16cab33633f070$var$isKeyboardTriggered(event));
        setLocalIsOpen(newValue); // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: newValue,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)(); // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $42omo.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return 0, $ee7An.default;
         // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = triggerRef.current?.closest('[role="menu"]') != null;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]); // Arrow navigation.
    // useArrowNavigation handles ArrowUp/Down, Home/End, and Tab-to-close
    // by querying focusable elements in the menu DOM container.
    const handleArrowClose = (0, $42omo.useCallback)(()=>{
        handleOnClose({
            reason: 'escape'
        });
    }, [
        handleOnClose
    ]);
    const handleNestedOpen = (0, $42omo.useCallback)(({ trigger: trigger_0 })=>{
        trigger_0.click();
    }, []);
    const handleNestedClose = (0, $42omo.useCallback)(()=>{
        handleOnClose({
            reason: 'escape'
        });
    }, [
        handleOnClose
    ]);
    (0, $JW5lP.useArrowNavigation)({
        containerRef: menuRef,
        onClose: handleArrowClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleNestedClose,
        isEnabled: isLocalOpen,
        filter: (0, $k2dA5.isAtCurrentMenuLevel)
    }); // Auto-focus first item on open.
    (0, $42omo.useEffect)(()=>{
        if (!isLocalOpen || !isTriggeredUsingKeyboard && !autoFocus) return;
        requestAnimationFrame(()=>{
            const menu = menuRef.current;
            if (!menu) return;
            const firstItem = (0, $cvNpe.getFirstFocusable)({
                container: menu
            });
            firstItem?.focus();
        });
    }, [
        isLocalOpen,
        isTriggeredUsingKeyboard,
        autoFocus
    ]); // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    const handleMenuClick = (0, $42omo.useCallback)((e_0)=>{
        const target = e_0.target;
        const menuItem = target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio'; // Do not close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger_0 = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger_0) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e_0.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $3rEYI.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    }); // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    const narrowAriaAttributes = ariaAttributes;
    const renderTrigger = ()=>{
        const setRef = (node)=>{
            triggerRef.current = node;
        };
        const combinedRef = (0, $3654r.default)([
            setRef
        ]);
        if (typeof trigger === 'function') return trigger({
            ...narrowAriaAttributes,
            ...bindFocus,
            triggerRef: combinedRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            ...bindFocus,
            ref: combinedRef,
            ...narrowAriaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName
        }, trigger);
    };
    return /*#__PURE__*/ $42omo.createElement((0, $nVQ0B.default), null, renderTrigger(), /*#__PURE__*/ $42omo.createElement((0, $4Mlap.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        animate: $1e16cab33633f070$var$animation,
        placement: topLayerPlacement,
        testId: testId && `${testId}--content`
    }, /*#__PURE__*/ $42omo.createElement("div", {
        ref: menuRef,
        className: (0, $gMc0m.default)([
            $1e16cab33633f070$var$styles.menuContent
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: $1e16cab33633f070$var$MAX_HEIGHT,
        maxWidth: shouldFitContainer ? undefined : 800,
        onClick: handleMenuClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-wrapper--menu-group`,
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $42omo.createElement($1e16cab33633f070$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--menu-wrapper--loading-indicator`
    }) : children))));
}
var $1e16cab33633f070$export$2e2bcd8739ae039 = $1e16cab33633f070$var$DropdownMenuTopLayer;
module.exports["default"] = $1e16cab33633f070$export$2e2bcd8739ae039;

});

parcelRegister("nVQ0B", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5g4rt = parcelRequire("5g4rt");

/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $02b3fc6de2f24ae9$var$SelectionStore = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children } = props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    const store = (0, $42omo.useRef)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>store.current[group_2] || {}
        };
        $[1] = t1;
    } else t1 = $[1];
    const context = t1;
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5g4rt.SelectionStoreContext).Provider, {
            value: context
        }, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>{
    const { children: children } = props;
    const store = (0, $42omo.useRef)({});
    const context = (0, $42omo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return undefined;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>{
                return store.current[group_2] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5g4rt.SelectionStoreContext).Provider, {
        value: context
    }, children);
};
var $02b3fc6de2f24ae9$export$2e2bcd8739ae039 = $02b3fc6de2f24ae9$var$SelectionStore;
module.exports["default"] = $02b3fc6de2f24ae9$export$2e2bcd8739ae039;

});

parcelRegister("5g4rt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $19b5453b5db39d0b$export$756f795847463ebd = /*#__PURE__*/ (0, $42omo.createContext)({
    setItemState: (0, $ee7An.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ee7An.default),
    getGroupState: ()=>({})
});
module.exports["SelectionStoreContext"] = $19b5453b5db39d0b$export$756f795847463ebd;

});

parcelRegister("k2dA5", function(module, exports) {
const $5fb584a7e7507fb4$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $5fb584a7e7507fb4$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $5fb584a7e7507fb4$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $5fb584a7e7507fb4$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($5fb584a7e7507fb4$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $5fb584a7e7507fb4$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}
module.exports["isAtCurrentMenuLevel"] = $5fb584a7e7507fb4$export$f1bba0ef464d60af;

});

parcelRegister("JW5lP", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $hTKp4 = parcelRequire("hTKp4");


var $4JWgN = parcelRequire("4JWgN");


var $cvNpe = parcelRequire("cvNpe");


var $47mYJ = parcelRequire("47mYJ");


var $c3nfT = parcelRequire("c3nfT");

const $fe7e868f8d553302$var$menuScope = '[role="menu"]';
const $fe7e868f8d553302$export$23dfbae28e0cc453 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useArrowNavigation(t0) {
    const $ = (0, $frIzR.c)(11);
    const { containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: t1, filter: filter } = t0;
    const isEnabled = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== containerRef || $[1] !== filter || $[2] !== onClose || $[3] !== onNestedClose || $[4] !== onNestedOpen) {
        t2 = (event)=>{
            const container = containerRef.current;
            if (!container) return;
            const focused = (0, $hTKp4.getDocument)()?.activeElement;
            if (focused instanceof HTMLElement) {
                if (filter) {
                    if (!filter(focused, container)) return;
                }
                if (!filter && container.getAttribute("role") === "menu" && focused.closest($fe7e868f8d553302$var$menuScope) !== container) return;
            }
            if (event.key === (0, $4JWgN.KEY_DOWN)) {
                event.preventDefault();
                (0, $c3nfT.getNextFocusable)({
                    container: container,
                    direction: "forwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $4JWgN.KEY_UP)) {
                event.preventDefault();
                (0, $c3nfT.getNextFocusable)({
                    container: container,
                    direction: "backwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $4JWgN.KEY_HOME)) {
                event.preventDefault();
                (0, $cvNpe.getFirstFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $4JWgN.KEY_END)) {
                event.preventDefault();
                (0, $47mYJ.getLastFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $4JWgN.KEY_TAB)) {
                onClose();
                return;
            }
            if (event.key === "ArrowRight") {
                if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute("aria-haspopup")) {
                    event.preventDefault();
                    onNestedOpen({
                        trigger: focused
                    });
                }
                return;
            }
            if (event.key === "ArrowLeft") {
                if (onNestedClose) {
                    const isNested = container.parentElement?.closest($fe7e868f8d553302$var$menuScope) !== null;
                    if (isNested) {
                        event.preventDefault();
                        onNestedClose();
                    }
                }
                return;
            }
        };
        $[0] = containerRef;
        $[1] = filter;
        $[2] = onClose;
        $[3] = onNestedClose;
        $[4] = onNestedOpen;
        $[5] = t2;
    } else t2 = $[5];
    const handleKeyDown = t2;
    let t3;
    let t4;
    if ($[6] !== containerRef || $[7] !== handleKeyDown || $[8] !== isEnabled) {
        t3 = ()=>{
            const container_0 = containerRef.current;
            if (!container_0 || !isEnabled) return;
            return (0, $fFa3V.bind)(container_0, {
                type: "keydown",
                listener: handleKeyDown
            });
        };
        t4 = [
            containerRef,
            handleKeyDown,
            isEnabled
        ];
        $[6] = containerRef;
        $[7] = handleKeyDown;
        $[8] = isEnabled;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $42omo.useEffect)(t3, t4);
} : function useArrowNavigation({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = (0, $hTKp4.getDocument)()?.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($fe7e868f8d553302$var$menuScope) !== container) return;
        }
        if (event.key === (0, $4JWgN.KEY_DOWN)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $c3nfT.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_UP)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $c3nfT.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_HOME)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $cvNpe.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_END)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $47mYJ.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = container.parentElement?.closest($fe7e868f8d553302$var$menuScope) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $42omo.useEffect)(()=>{
        const container_0 = containerRef.current;
        if (!container_0 || !isEnabled) return;
        return (0, $fFa3V.bind)(container_0, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
};
module.exports["useArrowNavigation"] = $fe7e868f8d553302$export$23dfbae28e0cc453;

});

parcelRegister("4hF42", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $kIK5c = parcelRequire("kIK5c");


var $ijhQY = parcelRequire("ijhQY");


var $6wMCT = parcelRequire("6wMCT");

/**
 * Focus manager logic.
 */ const $72bf3d2a48c5b2ec$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $42omo.useState)(0);
    const registerMode = (0, $42omo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $kIK5c.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $42omo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $42omo.useEffect)(()=>(0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $ijhQY.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wMCT.FocusManagerContext).Provider, {
        value: contextValue
    }, children);
};
var $72bf3d2a48c5b2ec$export$2e2bcd8739ae039 = $72bf3d2a48c5b2ec$var$FocusManager;
module.exports["default"] = $72bf3d2a48c5b2ec$export$2e2bcd8739ae039;

});

parcelRegister("ijhQY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb43cdb6098a100$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");


var $dh538 = parcelRequire("dh538");


var $6XsRH = parcelRequire("6XsRH");

const $8cb43cdb6098a100$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8cb43cdb6098a100$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $6XsRH.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $4JWgN.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $4JWgN.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $8cb43cdb6098a100$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("6XsRH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $c0qxy = parcelRequire("c0qxy");

const $6ec4c4b23458ff7f$export$8a682ae47622dbb9 = 'ds--dropdown--';
/**
 * useGeneratedId generates a random string which remains constant across
 * renders when called without any parameter.
 */ const $6ec4c4b23458ff7f$var$useGeneratedId = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useGeneratedId() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
} : function useGeneratedId() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
};
var $6ec4c4b23458ff7f$export$2e2bcd8739ae039 = $6ec4c4b23458ff7f$var$useGeneratedId;
module.exports["PREFIX"] = $6ec4c4b23458ff7f$export$8a682ae47622dbb9;
module.exports["default"] = $6ec4c4b23458ff7f$export$2e2bcd8739ae039;

});

parcelRegister("6wMCT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $ad89860a791bab0b$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
module.exports["FocusManagerContext"] = $ad89860a791bab0b$export$f18c1d4fc7326096;

});

parcelRegister("rTIrg", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $51SOF = parcelRequire("51SOF");


var $4AsMp = parcelRequire("4AsMp");


var $6wMCT = parcelRequire("6wMCT");

const $b799d0b248957a2a$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $b799d0b248957a2a$var$LoadingIndicator = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] !== statusLabel || $[1] !== testId) {
        t2 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
            role: "menuitem"
        }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        }));
        $[0] = statusLabel;
        $[1] = testId;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    })); /**
          *
          * MenuWrapper wraps all the menu items.
          * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
          * if a CheckboxItem or RadioItem is clicked.
          * It also sets focus to the first menu item when opened.
          */ 
const $b799d0b248957a2a$var$MenuWrapper = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel } = t0;
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $6wMCT.FocusManagerContext));
    let t1;
    if ($[0] !== menuItemRefs || $[1] !== onClose) {
        t1 = (e)=>{
            const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
                const { current: menuItem } = menuItemRef;
                if (!menuItem) return false;
                const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
                return menuItem.contains(e.target) && !isCheckboxOrRadio;
            });
            if (isTargetMenuItemOrDescendant && onClose) onClose(e);
        };
        $[0] = menuItemRefs;
        $[1] = onClose;
        $[2] = t1;
    } else t1 = $[2];
    const closeOnMenuItemClick = t1;
    let t2;
    if ($[3] !== onUpdate) {
        t2 = ()=>{
            onUpdate();
        };
        $[3] = onUpdate;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isLoading || $[6] !== onUpdate) {
        t3 = [
            isLoading,
            onUpdate
        ];
        $[5] = isLoading;
        $[6] = onUpdate;
        $[7] = t3;
    } else t3 = $[7];
    (0, $42omo.useLayoutEffect)(t2, t3);
    let t4;
    let t5;
    if ($[8] !== autoFocus || $[9] !== isTriggeredUsingKeyboard || $[10] !== menuItemRefs || $[11] !== setInitialFocusRef || $[12] !== shouldRenderToParent) {
        t4 = ()=>{
            const firstFocusableRef = menuItemRefs.map($b799d0b248957a2a$var$_temp).find($b799d0b248957a2a$var$_temp2) ?? null;
            if (((0, $dh538.fg)("platform_dst_menu_item_focus") || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
            setInitialFocusRef?.(firstFocusableRef);
        };
        t5 = [
            menuItemRefs,
            setInitialFocusRef,
            autoFocus,
            shouldRenderToParent,
            isTriggeredUsingKeyboard
        ];
        $[8] = autoFocus;
        $[9] = isTriggeredUsingKeyboard;
        $[10] = menuItemRefs;
        $[11] = setInitialFocusRef;
        $[12] = shouldRenderToParent;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $42omo.useEffect)(t4, t5);
    const t6 = testId && `${testId}--menu-group`;
    let t7;
    if ($[15] !== children || $[16] !== isLoading || $[17] !== statusLabel || $[18] !== testId) {
        t7 = isLoading ? /*#__PURE__*/ $42omo.createElement($b799d0b248957a2a$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children;
        $[15] = children;
        $[16] = isLoading;
        $[17] = statusLabel;
        $[18] = testId;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== closeOnMenuItemClick || $[21] !== isLoading || $[22] !== maxHeight || $[23] !== maxWidth || $[24] !== menuLabel || $[25] !== spacing || $[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ $42omo.createElement((0, $2SlZp.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            onClick: closeOnMenuItemClick,
            role: "menu",
            spacing: spacing,
            testId: t6,
            menuLabel: menuLabel
        }, t7);
        $[20] = closeOnMenuItemClick;
        $[21] = isLoading;
        $[22] = maxHeight;
        $[23] = maxWidth;
        $[24] = menuLabel;
        $[25] = spacing;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $6wMCT.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        }); // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $42omo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $dh538.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $42omo.createElement($b799d0b248957a2a$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $b799d0b248957a2a$export$2e2bcd8739ae039 = $b799d0b248957a2a$var$MenuWrapper;
function $b799d0b248957a2a$var$_temp(t0) {
    const { current: current } = t0;
    return current;
}
function $b799d0b248957a2a$var$_temp2(el) {
    return !!el && !el.hasAttribute("disabled");
}
module.exports["default"] = $b799d0b248957a2a$export$2e2bcd8739ae039;

});

parcelRegister("51SOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e12d4b588eba9c45$export$2e2bcd8739ae039);
function $e12d4b588eba9c45$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4AsMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1db4379970383b$export$2e2bcd8739ae039);
function $9b1db4379970383b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("dhBFe", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $6wMCT = parcelRequire("6wMCT");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
const $167560b2a39794c6$var$useRegisterItemWithFocusManager = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useRegisterItemWithFocusManager(t0) {
    const $ = (0, $frIzR.c)(4);
    const hasPopup = t0 === undefined ? false : t0;
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $6wMCT.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== hasPopup || $[1] !== registerRef) {
        t1 = ()=>{
            if (hasPopup && (0, $dh538.fg)("select-avoid-duplicated-registered-ref")) return;
            registerRef(itemRef);
        };
        t2 = [
            registerRef,
            hasPopup
        ];
        $[0] = hasPopup;
        $[1] = registerRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    return itemRef;
} : function useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $6wMCT.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (hasPopup && (0, $dh538.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
};
var $167560b2a39794c6$export$2e2bcd8739ae039 = $167560b2a39794c6$var$useRegisterItemWithFocusManager;
module.exports["default"] = $167560b2a39794c6$export$2e2bcd8739ae039;

});

parcelRegister("dAYOx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");


var $d77M1 = parcelRequire("d77M1");


var $cGtPE = parcelRequire("cGtPE");


var $dhBFe = parcelRequire("dhBFe");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $cdf608dda9733d23$var$DropdownMenuItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $dhBFe.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $42omo.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d77M1.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest
    }, children);
});
var $cdf608dda9733d23$export$2e2bcd8739ae039 = $cdf608dda9733d23$var$DropdownMenuItem;
module.exports["default"] = $cdf608dda9733d23$export$2e2bcd8739ae039;

});

parcelRegister("ahaN7", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $88990be4c91574c4$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(23);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UQGL.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== ref || $[18] !== rest || $[19] !== t1 || $[20] !== t2 || $[21] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: t1,
            ...rest
        }, t2, children);
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = ref;
        $[18] = rest;
        $[19] = t1;
        $[20] = t2;
        $[21] = testId;
        $[22] = t3;
    } else t3 = $[22];
    return t3;
} : ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UQGL.default), {
        id: titleId,
        title: title
    }), children);
});
var $88990be4c91574c4$export$2e2bcd8739ae039 = $88990be4c91574c4$var$DropdownMenuItemGroup;
module.exports["default"] = $88990be4c91574c4$export$2e2bcd8739ae039;

});

parcelRegister("2UQGL", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $19018ee1ec1e6aca$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $19018ee1ec1e6aca$var$GroupTitle = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { id: id, title: title } = t0;
    let t1;
    if ($[0] !== id || $[1] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            "data-ds--menu--heading-item": true,
            role: "menuitem",
            id: id,
            "aria-hidden": "true",
            xcss: $19018ee1ec1e6aca$var$styles.heading
        }, title);
        $[0] = id;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ id: id, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $19018ee1ec1e6aca$var$styles.heading
    }, title);
var $19018ee1ec1e6aca$export$2e2bcd8739ae039 = $19018ee1ec1e6aca$var$GroupTitle;
module.exports["default"] = $19018ee1ec1e6aca$export$2e2bcd8739ae039;

});

parcelRegister("lxESh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<5f1bffc73ab190c3ed149645d865f273>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f99d8a493f598455$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portalDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "concreteType": "HelpCenterPortals",
            "kind": "LinkedField",
            "name": "portals",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HelpCenterPortal",
                    "kind": "LinkedField",
                    "name": "portalsList",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$f99d8a493f598455$var$node.hash = "9321e563780af8e8cdc6d16d81e1564c";
var $f99d8a493f598455$export$2e2bcd8739ae039 = $f99d8a493f598455$var$node;



var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $irOoi = parcelRequire("irOoi");

parcelRequire("cILXD");
var $6SYln = parcelRequire("6SYln");


var $eEA8O = parcelRequire("eEA8O");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $8jHAi = parcelRequire("8jHAi");


var $56M4r = parcelRequire("56M4r");

var $7rvPL = parcelRequire("7rvPL");


var $g9Srd = parcelRequire("g9Srd");

var $htJyp = parcelRequire("htJyp");


var $5dK2X = parcelRequire("5dK2X");




const $c5a8de29e837fbb6$var$messages = (0, $aXWIB.defineMessages)({
    pageIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.page-icon.non-final",
        defaultMessage: "Page icon"
    },
    portalDownIcon: {
        defaultMessage: "Open portals dropdown",
        id: "company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-down.non-final"
    },
    portalUpIcon: {
        defaultMessage: "Close portals dropdown",
        id: "company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-up.non-final"
    },
    portals: {
        id: "company-hub.hub-app-shell.navbar.nav-links.portals",
        defaultMessage: "Portals"
    }
});
var $c5a8de29e837fbb6$export$2e2bcd8739ae039 = $c5a8de29e837fbb6$var$messages;


const $2d0ed755221bd2cd$var$styles = {
    overflowHidden: "_1reo15vq _18m915vq",
    dropdownItems: "_19bvu2gc"
};
const $2d0ed755221bd2cd$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq15r3 _5sagi9qs _1pgl1lbj"
};
const $2d0ed755221bd2cd$export$32e0c0d1c2f88773 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(52);
    const { queryRef: queryRef, textColor: textColor, isMobile: isMobile } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { push: push } = (0, $6SYln.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const data = (0, $irOoi.useFragment)((0, $f99d8a493f598455$export$2e2bcd8739ae039), queryRef);
    const portalPages = data?.portals?.portalsList;
    if (!portalPages || portalPages.length === 0) return null;
    const hasSinglePortal = portalPages.length === 1;
    if (isMobile) {
        if (hasSinglePortal) {
            let t1;
            if ($[0] !== portalPages[0]?.id || $[1] !== push) {
                t1 = ()=>{
                    push(`/portal/${portalPages[0]?.id}`);
                };
                $[0] = portalPages[0]?.id;
                $[1] = push;
                $[2] = t1;
            } else t1 = $[2];
            const t2 = portalPages[0]?.name;
            let t3;
            if ($[3] !== t1 || $[4] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                    onClick: t1
                }, t2);
                $[3] = t1;
                $[4] = t2;
                $[5] = t3;
            } else t3 = $[5];
            return t3;
        }
        let t1;
        if ($[6] !== formatMessage || $[7] !== isExpanded) {
            t1 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                label: formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).portalUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).portalDownIcon)
            });
            $[6] = formatMessage;
            $[7] = isExpanded;
            $[8] = t1;
        } else t1 = $[8];
        let t2;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = ()=>setIsExpanded($2d0ed755221bd2cd$var$_temp);
            $[9] = t2;
        } else t2 = $[9];
        let t3;
        if ($[10] !== formatMessage) {
            t3 = formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).portals);
            $[10] = formatMessage;
            $[11] = t3;
        } else t3 = $[11];
        let t4;
        if ($[12] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "medium"
            }, t3);
            $[12] = t3;
            $[13] = t4;
        } else t4 = $[13];
        let t5;
        if ($[14] !== isExpanded || $[15] !== t1 || $[16] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                iconAfter: t1,
                onClick: t2,
                "aria-expanded": isExpanded
            }, t4);
            $[14] = isExpanded;
            $[15] = t1;
            $[16] = t4;
            $[17] = t5;
        } else t5 = $[17];
        let t6;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $gMc0m.default)([
                $2d0ed755221bd2cd$var$styles.overflowHidden
            ]);
            $[18] = t6;
        } else t6 = $[18];
        let t7;
        if ($[19] !== isExpanded || $[20] !== portalPages || $[21] !== push) {
            t7 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
                enteringAnimationXcss: $2d0ed755221bd2cd$var$motionStyles.slideEntering,
                exitingAnimationXcss: $2d0ed755221bd2cd$var$motionStyles.slideExiting
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "portal-dropdown-items",
                className: (0, $gMc0m.default)([
                    $2d0ed755221bd2cd$var$styles.dropdownItems
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, portalPages?.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                    key: portal?.id,
                    onClick: ()=>{
                        push(`/portal/${portal?.id}`);
                    }
                }, portal?.name)))));
            $[19] = isExpanded;
            $[20] = portalPages;
            $[21] = push;
            $[22] = t7;
        } else t7 = $[22];
        let t8;
        if ($[23] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
                appear: true
            }, t7);
            $[23] = t7;
            $[24] = t8;
        } else t8 = $[24];
        let t9;
        if ($[25] !== t6 || $[26] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: t6
            }, t8);
            $[25] = t6;
            $[26] = t8;
            $[27] = t9;
        } else t9 = $[27];
        let t10;
        if ($[28] !== t5 || $[29] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, t9);
            $[28] = t5;
            $[29] = t9;
            $[30] = t10;
        } else t10 = $[30];
        return t10;
    }
    if (hasSinglePortal) {
        let t1;
        if ($[31] !== portalPages[0]?.id || $[32] !== push) {
            t1 = ()=>{
                push(`/portal/${portalPages[0]?.id}`);
            };
            $[31] = portalPages[0]?.id;
            $[32] = push;
            $[33] = t1;
        } else t1 = $[33];
        let t2;
        if ($[34] !== textColor) {
            t2 = {
                color: textColor
            };
            $[34] = textColor;
            $[35] = t2;
        } else t2 = $[35];
        const t3 = portalPages[0]?.name;
        let t4;
        if ($[36] !== t1 || $[37] !== t2 || $[38] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "subtle",
                onClick: t1,
                style: t2
            }, t3);
            $[36] = t1;
            $[37] = t2;
            $[38] = t3;
            $[39] = t4;
        } else t4 = $[39];
        return t4;
    }
    let t1;
    if ($[40] !== formatMessage || $[41] !== textColor) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...props } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).portalDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).portals));
        };
        $[40] = formatMessage;
        $[41] = textColor;
        $[42] = t1;
    } else t1 = $[42];
    let t2;
    if ($[43] !== formatMessage || $[44] !== portalPages || $[45] !== push) {
        t2 = portalPages?.map((portal_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: portal_0?.id,
                onClick: ()=>{
                    push(`/portal/${portal_0?.id}`);
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                    label: formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).pageIcon)
                })
            }, portal_0?.name));
        $[43] = formatMessage;
        $[44] = portalPages;
        $[45] = push;
        $[46] = t2;
    } else t2 = $[46];
    let t3;
    if ($[47] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, t2);
        $[47] = t2;
        $[48] = t3;
    } else t3 = $[48];
    let t4;
    if ($[49] !== t1 || $[50] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            trigger: t1,
            shouldRenderToParent: true
        }, t3);
        $[49] = t1;
        $[50] = t3;
        $[51] = t4;
    } else t4 = $[51];
    return t4;
} : ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { push: push } = (0, $6SYln.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const data = (0, $irOoi.useFragment)((0, $f99d8a493f598455$export$2e2bcd8739ae039), queryRef);
    const portalPages = data?.portals?.portalsList;
    if (!portalPages || portalPages.length === 0) return null;
    const hasSinglePortal = portalPages.length === 1;
    if (isMobile) {
        if (hasSinglePortal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            onClick: ()=>{
                push(`/portal/${portalPages[0]?.id}`);
            }
        }, portalPages[0]?.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                label: formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).portalUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).portalDownIcon)
            }),
            onClick: ()=>setIsExpanded((prev)=>!prev),
            "aria-expanded": isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            weight: "medium"
        }, formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $2d0ed755221bd2cd$var$styles.overflowHidden
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: true
        }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
            enteringAnimationXcss: $2d0ed755221bd2cd$var$motionStyles.slideEntering,
            exitingAnimationXcss: $2d0ed755221bd2cd$var$motionStyles.slideExiting
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "portal-dropdown-items",
            className: (0, $gMc0m.default)([
                $2d0ed755221bd2cd$var$styles.dropdownItems
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, portalPages?.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                key: portal?.id,
                onClick: ()=>{
                    push(`/portal/${portal?.id}`);
                }
            }, portal?.name))))))));
    }
    if (hasSinglePortal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: ()=>{
            push(`/portal/${portalPages[0]?.id}`);
        },
        style: {
            color: textColor
        }
    }, portalPages[0]?.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).portalDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).portals)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, portalPages?.map((portal_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: portal_0?.id,
            onClick: ()=>{
                push(`/portal/${portal_0?.id}`);
            },
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                label: formatMessage((0, $c5a8de29e837fbb6$export$2e2bcd8739ae039).pageIcon)
            })
        }, portal_0?.name))));
};
function $2d0ed755221bd2cd$var$_temp(prev) {
    return !prev;
}
module.exports["PortalDropdown"] = $2d0ed755221bd2cd$export$32e0c0d1c2f88773;

});

parcelRegister("6rp67", function(module, exports) {

let $4b08bb938eaa42c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4b08bb938eaa42c3$var$load("1EEPI").then(()=>parcelRequire('49hYL'));

});

parcelRegister("drIIO", function(module, exports) {

let $9ca07cc70b385afb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ca07cc70b385afb$var$load("d62hC"),
    $9ca07cc70b385afb$var$load("7HPPR"),
    $9ca07cc70b385afb$var$load("lnk1B"),
    $9ca07cc70b385afb$var$load("fBVt2"),
    $9ca07cc70b385afb$var$load("9yJxD"),
    $9ca07cc70b385afb$var$load("eM4bT"),
    $9ca07cc70b385afb$var$load("5gRHV"),
    $9ca07cc70b385afb$var$load("jPzkK"),
    $9ca07cc70b385afb$var$load("dy59R"),
    $9ca07cc70b385afb$var$load("FHgFh"),
    $9ca07cc70b385afb$var$load("cIKpa"),
    $9ca07cc70b385afb$var$load("kNNS3"),
    $9ca07cc70b385afb$var$load("bGqrb"),
    $9ca07cc70b385afb$var$load("6tsCm"),
    $9ca07cc70b385afb$var$load("6kcCF"),
    $9ca07cc70b385afb$var$load("9V1vV"),
    $9ca07cc70b385afb$var$load("i6s2m"),
    $9ca07cc70b385afb$var$load("dwSiO"),
    $9ca07cc70b385afb$var$load("bNW8r"),
    $9ca07cc70b385afb$var$load("4dNRa"),
    $9ca07cc70b385afb$var$load("5ra3E"),
    $9ca07cc70b385afb$var$load("coUzl"),
    $9ca07cc70b385afb$var$load("5nMTY"),
    $9ca07cc70b385afb$var$load("zSp86"),
    $9ca07cc70b385afb$var$load("k0WnS"),
    $9ca07cc70b385afb$var$load("dlm6q"),
    $9ca07cc70b385afb$var$load("4oONP"),
    $9ca07cc70b385afb$var$load("cmqxT"),
    $9ca07cc70b385afb$var$load("l5It5"),
    $9ca07cc70b385afb$var$load("Wowvf"),
    $9ca07cc70b385afb$var$load("67Alm"),
    $9ca07cc70b385afb$var$load("2B2rM"),
    $9ca07cc70b385afb$var$load("7bkye"),
    $9ca07cc70b385afb$var$load("dtpmo"),
    $9ca07cc70b385afb$var$load("35X59"),
    $9ca07cc70b385afb$var$load("2F69B"),
    $9ca07cc70b385afb$var$load("1GCFv"),
    $9ca07cc70b385afb$var$load("9anPW"),
    $9ca07cc70b385afb$var$load("lFAez"),
    $9ca07cc70b385afb$var$load("1qlDN"),
    $9ca07cc70b385afb$var$load("1yVM6"),
    $9ca07cc70b385afb$var$load("9DBoM"),
    $9ca07cc70b385afb$var$load("6wr18"),
    $9ca07cc70b385afb$var$load("7EorR"),
    $9ca07cc70b385afb$var$load("5dkX4"),
    $9ca07cc70b385afb$var$load("9lUu8"),
    $9ca07cc70b385afb$var$load("hhss7"),
    $9ca07cc70b385afb$var$load("ffEVr"),
    $9ca07cc70b385afb$var$load("e2WH6"),
    $9ca07cc70b385afb$var$load("5vzT0"),
    $9ca07cc70b385afb$var$load("h94bv"),
    $9ca07cc70b385afb$var$load("hy9kW")
]).then(()=>parcelRequire('88o1o'));

});

parcelRegister("aVKfT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "93O33",
    name: "ForgeGlobalSettingsExtensionPoint",
    loader: async ()=>(await (parcelRequire("hPrIc"))).GlobalSettings
});
module.exports["ForgeGlobalSettingsExtensionPoint"] = $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4;

});

parcelRegister("hPrIc", function(module, exports) {

let $cfacb2164df6b0af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cfacb2164df6b0af$var$load("4JAC8"),
    $cfacb2164df6b0af$var$load("c6fAG")
]).then(()=>parcelRequire('jOztW'));

});

parcelRegister("jOXb3", function(module, exports) {

let $e6e09734dc28cb91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6e09734dc28cb91$var$load("iVLHX").then(()=>parcelRequire('7DYe9'));

});

parcelRegister("aF1vZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47940fef216e9562$export$2709da4acd7d0aec = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Q3Ruy",
    name: "AdvancedSearch",
    loader: async ()=>(await (parcelRequire("dbnAT"))).AdvancedSearch
});
module.exports["AdvancedSearch"] = $47940fef216e9562$export$2709da4acd7d0aec;

});

parcelRegister("dbnAT", function(module, exports) {

let $998e9abf12cbb510$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $998e9abf12cbb510$var$load("h3ABO"),
    $998e9abf12cbb510$var$load("67Alm"),
    $998e9abf12cbb510$var$load("bzyKp"),
    $998e9abf12cbb510$var$load("k3yUD"),
    $998e9abf12cbb510$var$load("esOWw"),
    $998e9abf12cbb510$var$load("fAtWn"),
    $998e9abf12cbb510$var$load("iPYAE"),
    $998e9abf12cbb510$var$load("b9CA3"),
    $998e9abf12cbb510$var$load("jZLnv"),
    $998e9abf12cbb510$var$load("6edij"),
    $998e9abf12cbb510$var$load("2YffH"),
    $998e9abf12cbb510$var$load("jmKRS"),
    $998e9abf12cbb510$var$load("9TQyl"),
    $998e9abf12cbb510$var$load("4JAC8"),
    $998e9abf12cbb510$var$load("ijNBa"),
    $998e9abf12cbb510$var$load("hGJ7X"),
    $998e9abf12cbb510$var$load("c6VA1"),
    $998e9abf12cbb510$var$load("2MTmD"),
    $998e9abf12cbb510$var$load("9skky"),
    $998e9abf12cbb510$var$load("j9Q0e"),
    $998e9abf12cbb510$var$load("71gca"),
    $998e9abf12cbb510$var$load("jlCbV"),
    $998e9abf12cbb510$var$load("1D1pC"),
    $998e9abf12cbb510$var$load("eBRUf"),
    $998e9abf12cbb510$var$load("gufL1"),
    $998e9abf12cbb510$var$load("2B2rM"),
    $998e9abf12cbb510$var$load("1GCFv"),
    $998e9abf12cbb510$var$load("72caV"),
    $998e9abf12cbb510$var$load("bo7iw"),
    $998e9abf12cbb510$var$load("9anPW"),
    $998e9abf12cbb510$var$load("6iz6l"),
    $998e9abf12cbb510$var$load("4SCW2"),
    $998e9abf12cbb510$var$load("kQSfw"),
    $998e9abf12cbb510$var$load("8PzH3"),
    $998e9abf12cbb510$var$load("2jJ1i"),
    $998e9abf12cbb510$var$load("bd77Q"),
    $998e9abf12cbb510$var$load("3KVI3"),
    $998e9abf12cbb510$var$load("9DBoM"),
    $998e9abf12cbb510$var$load("5lTVp"),
    $998e9abf12cbb510$var$load("lWNY8"),
    $998e9abf12cbb510$var$load("aSL4q"),
    $998e9abf12cbb510$var$load("6wr18"),
    $998e9abf12cbb510$var$load("h9S8v"),
    $998e9abf12cbb510$var$load("jPuvo"),
    $998e9abf12cbb510$var$load("3GuOt"),
    $998e9abf12cbb510$var$load("37ldp"),
    $998e9abf12cbb510$var$load("ffEVr"),
    $998e9abf12cbb510$var$load("1SyLT"),
    $998e9abf12cbb510$var$load("a0cZb"),
    $998e9abf12cbb510$var$load("RXMWr"),
    $998e9abf12cbb510$var$load("coUzl"),
    $998e9abf12cbb510$var$load("5nMTY"),
    $998e9abf12cbb510$var$load("bLm2D"),
    $998e9abf12cbb510$var$load("7j0mT"),
    $998e9abf12cbb510$var$load("69R9L"),
    $998e9abf12cbb510$var$load("zSp86"),
    $998e9abf12cbb510$var$load("Wowvf"),
    $998e9abf12cbb510$var$load("1F7LX"),
    $998e9abf12cbb510$var$load("hXbzh"),
    $998e9abf12cbb510$var$load("hhss7"),
    $998e9abf12cbb510$var$load("7EorR"),
    $998e9abf12cbb510$var$load("mK22p")
]).then(()=>parcelRequire('luNAU'));

});

parcelRegister("fS0ja", function(module, exports) {

let $b8dc235593b42c16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8dc235593b42c16$var$load("6wr18"),
    $b8dc235593b42c16$var$load("ffEVr"),
    $b8dc235593b42c16$var$load("hDfPU")
]).then(()=>parcelRequire('2mD8T'));

});

parcelRegister("kb9X9", function(module, exports) {

var $7i418 = parcelRequire("7i418");


var $AoYlq = parcelRequire("AoYlq");


var $d6TaN = parcelRequire("d6TaN");


var $6g1oe = parcelRequire("6g1oe");

const $eb0c8e33e0268c1c$export$d17bd3fb4432c2eb = (a, b)=>{
    // lodash reduce can reduce over objects, not just arrays
    /* istanbul ignore next */ const results = (0, (/*@__PURE__*/$parcel$interopDefault($7i418)))(a, (result, value, key)=>value === b[key] ? result : result.concat([
            `Prop name: '${key}'`,
            '1:',
            value,
            '2:',
            b[key]
        ], '=========='), []);
    /* istanbul ignore next */ if (!results || results.length === 0) return 'No change!';
    return results;
};
const $eb0c8e33e0268c1c$export$2225b4c39d37f8b3 = (obj1, obj2, omitProps = [])=>{
    if (obj1 === obj2) return true;
    const allKeys = (0, (/*@__PURE__*/$parcel$interopDefault($AoYlq)))((0, (/*@__PURE__*/$parcel$interopDefault($d6TaN)))(obj1), (0, (/*@__PURE__*/$parcel$interopDefault($d6TaN)))(obj2));
    for (const key of allKeys){
        if (omitProps.indexOf(key) >= 0) continue;
        if (obj1[key] !== obj2[key]) return false;
    }
    return true;
};
const $eb0c8e33e0268c1c$export$e3a9c512dde3781c = (name)=>{};
const $eb0c8e33e0268c1c$export$1b1e26e4583cf9d2 = (names)=>{};
const $eb0c8e33e0268c1c$export$948fe58907adae7d = (markA, markB)=>{
    return 'N/A';
};
const $eb0c8e33e0268c1c$export$76909ea6fcdbea03 = (name, markA, markB)=>{};
const $eb0c8e33e0268c1c$export$34e34130f1d9d12c = (mark)=>{
    return 'N/A';
};
const $eb0c8e33e0268c1c$export$a1e5925b5910cb4 = (mark)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).performance) return;
    (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).performance.mark(mark);
};
module.exports["performanceMarkInProd"] = $eb0c8e33e0268c1c$export$a1e5925b5910cb4;

});

parcelRegister("7i418", function(module, exports) {

var $52wl7 = parcelRequire("52wl7");


var $iawSg = parcelRequire("iawSg");


var $hWvFC = parcelRequire("hWvFC");


var $8ehsp = parcelRequire("8ehsp");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $54ed5492bda67974$var$reduce(collection, iteratee, accumulator) {
    var func = $fZxmY(collection) ? $52wl7 : $8ehsp, initAccum = arguments.length < 3;
    return func(collection, $hWvFC(iteratee, 4), accumulator, initAccum, $iawSg);
}
module.exports = $54ed5492bda67974$var$reduce;

});

parcelRegister("iawSg", function(module, exports) {

var $fh4WQ = parcelRequire("fh4WQ");


var $fKRi0 = parcelRequire("fKRi0");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d3a2a94fdae59b54$var$baseEach = $fKRi0($fh4WQ);
module.exports = $d3a2a94fdae59b54$var$baseEach;

});

parcelRegister("fh4WQ", function(module, exports) {

var $9d5GH = parcelRequire("9d5GH");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b1ec481d92afa1cf$var$baseForOwn(object, iteratee) {
    return object && $9d5GH(object, iteratee, $d6TaN);
}
module.exports = $b1ec481d92afa1cf$var$baseForOwn;

});

parcelRegister("fKRi0", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7847d143ef17a3d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bRRFB(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7847d143ef17a3d$var$createBaseEach;

});

parcelRegister("8ehsp", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $5fdd2c2f38667b48$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $5fdd2c2f38667b48$var$baseReduce;

});

parcelRegister("AoYlq", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");


var $9JSQw = parcelRequire("9JSQw");


var $ghltV = parcelRequire("ghltV");


var $bVtKl = parcelRequire("bVtKl");

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $06d6bbe2d946d3b0$var$union = $9JSQw(function(arrays) {
    return $ghltV($8jC8i(arrays, 1, $bVtKl, true));
});
module.exports = $06d6bbe2d946d3b0$var$union;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("fJtJD", function(module, exports) {

let $b7421fbfbe751b64$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7421fbfbe751b64$var$load("dMWJp").then(()=>parcelRequire('eTW2b'));

});

parcelRegister("7lrfj", function(module, exports) {

let $558fa1074ff5f10f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $558fa1074ff5f10f$var$load("amygy").then(()=>parcelRequire('iMfxO'));

});

parcelRegister("9dIvj", function(module, exports) {

let $6b67d98c43ffb4bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b67d98c43ffb4bc$var$load("erzsl"),
    $6b67d98c43ffb4bc$var$load("4Scjl"),
    $6b67d98c43ffb4bc$var$load("arG0U"),
    $6b67d98c43ffb4bc$var$load("jnr1d"),
    $6b67d98c43ffb4bc$var$load("1inbB"),
    $6b67d98c43ffb4bc$var$load("6xN9r"),
    $6b67d98c43ffb4bc$var$load("3Bbwl"),
    $6b67d98c43ffb4bc$var$load("jle6Z"),
    $6b67d98c43ffb4bc$var$load("24OMS"),
    $6b67d98c43ffb4bc$var$load("bRqDI"),
    $6b67d98c43ffb4bc$var$load("dVLeP"),
    $6b67d98c43ffb4bc$var$load("lFAez"),
    $6b67d98c43ffb4bc$var$load("1qlDN"),
    $6b67d98c43ffb4bc$var$load("1yVM6"),
    $6b67d98c43ffb4bc$var$load("cEqm7"),
    $6b67d98c43ffb4bc$var$load("6XCf4"),
    $6b67d98c43ffb4bc$var$load("gNfuQ"),
    $6b67d98c43ffb4bc$var$load("8SLfD"),
    $6b67d98c43ffb4bc$var$load("9YlTA"),
    $6b67d98c43ffb4bc$var$load("l0dd5"),
    $6b67d98c43ffb4bc$var$load("j104l"),
    $6b67d98c43ffb4bc$var$load("7CYB9"),
    $6b67d98c43ffb4bc$var$load("5uN9h"),
    $6b67d98c43ffb4bc$var$load("1GCFv"),
    $6b67d98c43ffb4bc$var$load("4fYzp"),
    $6b67d98c43ffb4bc$var$load("h4Nf7"),
    $6b67d98c43ffb4bc$var$load("dek7I"),
    $6b67d98c43ffb4bc$var$load("dYtBN"),
    $6b67d98c43ffb4bc$var$load("kNV5Y"),
    $6b67d98c43ffb4bc$var$load("5lTVp"),
    $6b67d98c43ffb4bc$var$load("lWNY8"),
    $6b67d98c43ffb4bc$var$load("hhss7"),
    $6b67d98c43ffb4bc$var$load("6wr18"),
    $6b67d98c43ffb4bc$var$load("h9S8v"),
    $6b67d98c43ffb4bc$var$load("dZsGY"),
    $6b67d98c43ffb4bc$var$load("jPuvo"),
    $6b67d98c43ffb4bc$var$load("3GuOt"),
    $6b67d98c43ffb4bc$var$load("ffEVr"),
    $6b67d98c43ffb4bc$var$load("lbsQO"),
    $6b67d98c43ffb4bc$var$load("7j0mT"),
    $6b67d98c43ffb4bc$var$load("69R9L"),
    $6b67d98c43ffb4bc$var$load("zSp86"),
    $6b67d98c43ffb4bc$var$load("kuFG2"),
    $6b67d98c43ffb4bc$var$load("Wowvf"),
    $6b67d98c43ffb4bc$var$load("1F7LX"),
    $6b67d98c43ffb4bc$var$load("9ftJe"),
    $6b67d98c43ffb4bc$var$load("7EorR"),
    $6b67d98c43ffb4bc$var$load("hA2SB"),
    $6b67d98c43ffb4bc$var$load("6ExNy")
]).then(()=>parcelRequire('iIJIO'));

});

parcelRegister("agglT", function(module, exports) {
var $585d52ec7db54bb4$export$e0a694ad492b37fe = /*#__PURE__*/ function(CompanyHubSettingsPageTabsType) {
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["GENERAL"] = 0] = "GENERAL";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["ANALYTICS"] = 1] = "ANALYTICS";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["USERS"] = 2] = "USERS";
    return CompanyHubSettingsPageTabsType;
}({});
module.exports["CompanyHubSettingsPageTabsType"] = $585d52ec7db54bb4$export$e0a694ad492b37fe;

});

parcelRegister("bUPA7", function(module, exports) {

let $8accefb3f9ff6de5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8accefb3f9ff6de5$var$load("dRtRF"),
    $8accefb3f9ff6de5$var$load("6wr18"),
    $8accefb3f9ff6de5$var$load("lGXsx"),
    $8accefb3f9ff6de5$var$load("kwgtb"),
    $8accefb3f9ff6de5$var$load("j8ma3"),
    $8accefb3f9ff6de5$var$load("7Ya0F"),
    $8accefb3f9ff6de5$var$load("eNZNF"),
    $8accefb3f9ff6de5$var$load("5uN9h"),
    $8accefb3f9ff6de5$var$load("jfGTp"),
    $8accefb3f9ff6de5$var$load("ffEVr"),
    $8accefb3f9ff6de5$var$load("7EorR"),
    $8accefb3f9ff6de5$var$load("4fYzp"),
    $8accefb3f9ff6de5$var$load("1fLz7")
]).then(()=>parcelRequire('eBAks'));

});

parcelRegister("iquRY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $frIzR.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t0,
        __callerPackage__: "@confluence/space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<2ff02ee1cce578f61d9a435abf2def2c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("K4Itq", function(module, exports) {

let $08a7f48df3cc40e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $08a7f48df3cc40e4$var$load("6wr18"),
    $08a7f48df3cc40e4$var$load("jGTjO"),
    $08a7f48df3cc40e4$var$load("68wXf"),
    $08a7f48df3cc40e4$var$load("6CBhM"),
    $08a7f48df3cc40e4$var$load("2yk7f"),
    $08a7f48df3cc40e4$var$load("dRtRF"),
    $08a7f48df3cc40e4$var$load("4CfTY"),
    $08a7f48df3cc40e4$var$load("j104l"),
    $08a7f48df3cc40e4$var$load("7CYB9"),
    $08a7f48df3cc40e4$var$load("gctwz"),
    $08a7f48df3cc40e4$var$load("4drdS"),
    $08a7f48df3cc40e4$var$load("1GCFv"),
    $08a7f48df3cc40e4$var$load("5DjNv"),
    $08a7f48df3cc40e4$var$load("bo7iw"),
    $08a7f48df3cc40e4$var$load("ffEVr"),
    $08a7f48df3cc40e4$var$load("6xN9r"),
    $08a7f48df3cc40e4$var$load("3Bbwl"),
    $08a7f48df3cc40e4$var$load("jle6Z"),
    $08a7f48df3cc40e4$var$load("24OMS"),
    $08a7f48df3cc40e4$var$load("7EorR"),
    $08a7f48df3cc40e4$var$load("bRqDI"),
    $08a7f48df3cc40e4$var$load("4fYzp"),
    $08a7f48df3cc40e4$var$load("dVLeP"),
    $08a7f48df3cc40e4$var$load("lFAez"),
    $08a7f48df3cc40e4$var$load("1qlDN"),
    $08a7f48df3cc40e4$var$load("1yVM6"),
    $08a7f48df3cc40e4$var$load("cEqm7"),
    $08a7f48df3cc40e4$var$load("6XCf4"),
    $08a7f48df3cc40e4$var$load("gNfuQ"),
    $08a7f48df3cc40e4$var$load("8SLfD"),
    $08a7f48df3cc40e4$var$load("7DSUW")
]).then(()=>parcelRequire('54mQG'));

});

parcelRegister("5TJmA", function(module, exports) {

let $44b547017209bffe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $44b547017209bffe$var$load("dRtRF"),
    $44b547017209bffe$var$load("aGTsr"),
    $44b547017209bffe$var$load("jGTjO"),
    $44b547017209bffe$var$load("2gKO4"),
    $44b547017209bffe$var$load("lUFbG"),
    $44b547017209bffe$var$load("fjOTL"),
    $44b547017209bffe$var$load("e1z0Z"),
    $44b547017209bffe$var$load("1GCFv"),
    $44b547017209bffe$var$load("YlVRj"),
    $44b547017209bffe$var$load("5DjNv"),
    $44b547017209bffe$var$load("bo7iw"),
    $44b547017209bffe$var$load("4fYzp"),
    $44b547017209bffe$var$load("hOaAV"),
    $44b547017209bffe$var$load("lFAez"),
    $44b547017209bffe$var$load("1qlDN"),
    $44b547017209bffe$var$load("1yVM6"),
    $44b547017209bffe$var$load("cEqm7"),
    $44b547017209bffe$var$load("6XCf4"),
    $44b547017209bffe$var$load("amPsT"),
    $44b547017209bffe$var$load("hhss7"),
    $44b547017209bffe$var$load("bU3dV"),
    $44b547017209bffe$var$load("96X3r")
]).then(()=>parcelRequire('9FcLT'));

});

parcelRegister("fUGDw", function(module, exports) {

let $b95d28b0da8ed60b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b95d28b0da8ed60b$var$load("f35QR"),
    $b95d28b0da8ed60b$var$load("eVYW1"),
    $b95d28b0da8ed60b$var$load("ls0Um"),
    $b95d28b0da8ed60b$var$load("020xd"),
    $b95d28b0da8ed60b$var$load("eTBsW"),
    $b95d28b0da8ed60b$var$load("bYxCZ"),
    $b95d28b0da8ed60b$var$load("6HBYC"),
    $b95d28b0da8ed60b$var$load("eDqo1"),
    $b95d28b0da8ed60b$var$load("lxiFd"),
    $b95d28b0da8ed60b$var$load("1oiJ6"),
    $b95d28b0da8ed60b$var$load("huUvS"),
    $b95d28b0da8ed60b$var$load("6wr18"),
    $b95d28b0da8ed60b$var$load("j104l"),
    $b95d28b0da8ed60b$var$load("7CYB9"),
    $b95d28b0da8ed60b$var$load("ffEVr"),
    $b95d28b0da8ed60b$var$load("8j9XC"),
    $b95d28b0da8ed60b$var$load("7EorR"),
    $b95d28b0da8ed60b$var$load("6vhrJ"),
    $b95d28b0da8ed60b$var$load("fxC6e"),
    $b95d28b0da8ed60b$var$load("5ZaO3")
]).then(()=>parcelRequire('dpLKi'));

});

parcelRegister("6V55f", function(module, exports) {

let $509c0271e6072601$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $509c0271e6072601$var$load("iIfud").then(()=>parcelRequire('fi3dY'));

});

parcelRegister("769vU", function(module, exports) {

let $52b0792ebd60c093$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $52b0792ebd60c093$var$load("l0dd5"),
    $52b0792ebd60c093$var$load("5uN9h"),
    $52b0792ebd60c093$var$load("7EorR"),
    $52b0792ebd60c093$var$load("4uUio")
]).then(()=>parcelRequire('ayZRr'));

});

parcelRegister("b1pD4", function(module, exports) {
$parcel$export(module.exports, "CommentsSectionLoader", () => (parcelRequire("3ACqI")).CommentsSectionLoader);

var $3ACqI = parcelRequire("3ACqI");


});

parcelRegister("3ACqI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $hnvzE = parcelRequire("hnvzE");


var $7boqA = parcelRequire("7boqA");


var $c04Yn = parcelRequire("c04Yn");


var $jmjWc = parcelRequire("jmjWc");


var $deTj5 = parcelRequire("deTj5");


var $6Hogt = parcelRequire("6Hogt");


var $2YUV8 = parcelRequire("2YUV8");


var $dDqLo = parcelRequire("dDqLo");


var $3Am3T = parcelRequire("3Am3T");


var $bQm3c = parcelRequire("bQm3c");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


const $bab3bd054370fc67$export$a378d01c696bd81e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SZ3wU",
    name: "CommentsSectionFabric",
    // eslint-disable-next-line react/prop-types
    //@ts-ignore
    loading: ({ handlePageCommentsRender: handlePageCommentsRender })=>{
        return !handlePageCommentsRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), null) : null;
    },
    loader: ()=>//@ts-ignore
        (parcelRequire("gV8Ob"))
});

const $bab3bd054370fc67$export$4740f0dffd11e693 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y3qpe",
    name: "CommentsSectionFabricPaint",
    loader: ()=>//@ts-ignore
        (parcelRequire("gV8Ob"))
});
const $bab3bd054370fc67$export$2fa3aacacd7711f1 = ({ contentId: contentId, ...props })=>{
    // This information is available in the CommentsCountContext, but it also needs to be available to the legacy class
    // component so passing in directly from the hook as well
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $dDqLo.useCommentCounts)(contentId);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const allowNestedComments = (0, $2YUV8.useAllowNestedComments)();
    const commentsDataActions = (0, $8i27m.useCommentsDataActions)();
    const { refetch: refetchActiveComments } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId
    });
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "page-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: props.contentId,
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC),
        isCustomStart: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c04Yn.PageSegmentLoadMark), {
        markName: "pageCommentsRenderStart",
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC)
    }), (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bab3bd054370fc67$export$4740f0dffd11e693, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: refetchActiveComments
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bab3bd054370fc67$export$a378d01c696bd81e, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: refetchActiveComments
    }))));
};
$bab3bd054370fc67$export$2fa3aacacd7711f1.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired
};
module.exports["CommentsSectionLoader"] = $bab3bd054370fc67$export$2fa3aacacd7711f1;

});

parcelRegister("7boqA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("18R9N", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $42omo.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("c04Yn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");


var $N1nBh = parcelRequire("N1nBh");

const $31e8db7744b54631$var$noop = ()=>{};
/**
 * Records a UFO custom mark via `addUFOCustomMark` at the configured timing
 * for a page-segment-load.
 */ const $31e8db7744b54631$export$83817ed93c2e1e7f = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { markName: markName, timing: timing, onComplete: onComplete = $31e8db7744b54631$var$noop, timestamp: timestamp } = props;
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const handleMark = (0, $42omo.useCallback)(()=>{
        (0, $kGwvc.addUFOCustomMark)(markName, timestamp);
        onComplete();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `timestamp`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        resolvedKey,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handleMark, timing);
    return null;
});
module.exports["PageSegmentLoadMark"] = $31e8db7744b54631$export$83817ed93c2e1e7f;

});

parcelRegister("deTj5", function(module, exports) {
/* CommentPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$FlexComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _i0dl1osq _otyru2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _bfhkizff _1bsbzwfg _4t3izwfg _19pk1b66 _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$BeforeStylesContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlia51 _1sb2f705 _1e0c1ule _otyrpxbi _ca0qutpp _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$commentWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.250',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$CommentAddPromptContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _1bsb1osq _4t3i1ylp _syaz1rpy _ca0qze3t _1e0c1o8l _s7n4jp4b _18u0u2gc _16jlkb7n _bfhkizff",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$GridContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c11p5 _yv0ehpgh _727q19bv _bfhk1j28 _1bsbdgin _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Author = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lzmlf _1yt45uws _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$InnerComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lbahz _1yt41h4g _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$export$46096a93b7c122b2 = ({ showPlaceholder: showPlaceholder = false })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (window.__SSR_RENDERED__ || showPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c27f350b69a05b43$var$commentWrapperStyles,
        "data-vc": "comment-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$GridContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Author, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$InnerComment, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$BeforeStylesContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$FlexComment, {
        "data-testid": "comment-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentAddPromptContainer, null))));
    else return null;
};
module.exports["CommentPlaceholder"] = $c27f350b69a05b43$export$46096a93b7c122b2;

});

parcelRegister("6Hogt", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_COMMENTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'pageCommentsRender',
            startMark: 'pageCommentsRenderStart',
            endMark: 'pageCommentsRenderEnd'
        }
    ]
});
module.exports["PAGE_COMMENTS_METRIC"] = $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("2YUV8", function(module, exports) {

var $4UfTc = parcelRequire("4UfTc");


var $ep3mz = parcelRequire("ep3mz");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $jMyy4 = parcelRequire("jMyy4");

const $d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery = (0, $4UfTc.default);
const $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE = new Date(Date.UTC(2025, 2, 6)); // 6th March 2025. Only month is 0 indexed.
const $d2978a0663607f28$export$3044701888c6e050 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { data: createdDateData, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery, {
        variables: {
            contentId: contentId ?? '',
            status: 'current'
        },
        skip: !contentId,
        __callerPackage__: "@confluence/comments-hooks"
    });
    const pageCreatedDate = createdDateData?.content?.nodes?.[0]?.metadata?.createdDate;
    const isLivePage = pageMode === (0, $cD1qu.PageMode).LIVE;
    if (loading || error || !pageCreatedDate) return false;
    const pageCreateDateObject = new Date(pageCreatedDate);
    const isBeforeLaunchDate = pageCreateDateObject < $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE;
    return isBeforeLaunchDate && !isLivePage;
};
module.exports["useAllowNestedComments"] = $d2978a0663607f28$export$3044701888c6e050;

});

parcelRegister("4UfTc", function(module, exports) {
/**
 * @generated SignedSource<<d74116ddf84c22c868c27826499d1987>>
 * @relayHash 1b34c24939127448f5c00dae3686d441
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c221363cc883efefab5cfa0e3ab169a67cfbd5e0421720c08604343009f0248
const $59a2e4a8bcae6006$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "status.0",
                            "variableName": "status"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAllowNestedCommentsDetailsPanelContentCreatedDateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAllowNestedCommentsDetailsPanelContentCreatedDateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b34c24939127448f5c00dae3686d441",
            "id": "4c221363cc883efefab5cfa0e3ab169a67cfbd5e0421720c08604343009f0248",
            "metadata": {},
            "name": "useAllowNestedCommentsDetailsPanelContentCreatedDateQuery",
            "operationKind": "query",
            "text": "query useAllowNestedCommentsDetailsPanelContentCreatedDateQuery($contentId:ID!,$status:String!){content(id:$contentId,status:[$status]){nodes{id,metadata{createdDate}}}}"
        }
    };
}();
$59a2e4a8bcae6006$var$node.hash = "654d747af6c04558b92d70397d0023f0";
var $59a2e4a8bcae6006$export$2e2bcd8739ae039 = $59a2e4a8bcae6006$var$node;
module.exports["default"] = $59a2e4a8bcae6006$export$2e2bcd8739ae039;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $dkkKv = parcelRequire("dkkKv");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $aPT9H = parcelRequire("aPT9H");

const $c085ac79a8833850$export$453b7c79178856e5 = (contentId)=>{
    // Always call both hooks to follow React rules, but skip the queries conditionally
    // Legacy implementation using CommentsSectionQuery
    const legacyResult = (0, $aPT9H.useCommentCountsLegacy)(contentId);
    // New comments data manager - get processed data from the store
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // ActiveCommentsQuery implementation - used when cc_comments_new_comments_data_manager is disabled
    // Call without type filter to get both inline and footer comments, then filter by location.type
    const { data: allCommentsData } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        // Don't pass type to get all comment types (both CommentType.INLINE and CommentType.FOOTER)
        skip: !contentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    return (0, $42omo.useMemo)(()=>{
        // Priority 1: Use new comments data manager when enabled
        if (processedCommentsData.isDataProcessed && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            const unresolvedInlineCommentsCount = processedCommentsData.openInlineComments.length;
            const footerCommentsCount = processedCommentsData.openFooterComments.length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 2: Use ActiveCommentsQuery when cc_comments_new_comments_data_manager is disabled
        if (allCommentsData?.comments?.nodes && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // New implementation using ActiveCommentsQuery
            // ActiveCommentsQuery already filters by commentState: UNRESOLVED, so all comments are unresolved
            // Filter comments by location.type to count inline vs footer separately
            const unresolvedInlineCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'INLINE').length;
            const footerCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'FOOTER').length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 3: Legacy implementation using CommentsSectionQuery
        // Return legacy result if available, otherwise return default values
        if (legacyResult && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return legacyResult;
        // Fallback when experiment is enabled but data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        processedCommentsData.isDataProcessed,
        processedCommentsData.openInlineComments.length,
        processedCommentsData.openFooterComments.length,
        allCommentsData?.comments?.nodes,
        legacyResult
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});

parcelRegister("dkkKv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $7c240d799ee287c0$export$1369688a638bab5e = ({ pageId: pageId, skip: skip = false, type: type, onCompletedFn: onCompletedFn, returnNativeLoading: returnNativeLoading = false, useStableCommentsDataUpdates: // Doing this in the useEffect has slightly different behavior than the native graphQL query, this lets us choose which behavior we want
useStableCommentsDataUpdates = false, fetchPolicy: fetchPolicy, isPreload: isPreload = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap, setFooterCommentsLoadingState: setFooterCommentsLoadingState }] = (0, $8i27m.useCommentsData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0 || Object.keys(commentsDataMap.general).length > 0;
    // Check if the page is archived
    const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Using preload variables isn't 100% necessary since we write to the full cache,
    // but should be more stable in the event the full cache update fails
    const queryVariables = isPreload ? (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(pageId, isArchived) : (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
        pageId: pageId,
        type: type,
        isArchived: isArchived
    });
    const cacheUpdateFailedFetchPolicy = cacheUpdateFailed ? 'network-only' : undefined;
    const defaultFetchPolicy = skipQuery || isPreload ? 'cache-only' : 'cache-and-network'; // TODO: Cache and network probably not perfect, used to ensure consistency on the panel
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $b1hSc.default), {
        variables: queryVariables,
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: fetchPolicy || cacheUpdateFailedFetchPolicy || defaultFetchPolicy,
        skip: skipQuery,
        onCompleted: (result)=>{
            // onCompleted doesn't fire as expected after multiple cache reads
            if (!useStableCommentsDataUpdates && result) {
                (0, $3ZsvI.updateCommentsDataState)({
                    data: result,
                    updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                    pageMode: pageMode,
                    currentUserId: currentUserId ?? '',
                    isOpen: true
                });
                if (!skipQuery) // Don't update loading state if the query is skipped
                // onCompleted will still get called in some circumstances with skip = true
                (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
            }
            setLoading(false);
            if (result) onCompletedFn && onCompletedFn();
        },
        onError: undefined,
        errorPolicy: 'all',
        __callerPackage__: "@confluence/comments-data"
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
            setLoading(false);
        }
    }, [
        error
    ]);
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    let returnLoading = queryLoading;
    // If we're not returning the native loading out of apollo, update returnLoading to our tracked version
    if (!returnNativeLoading) returnLoading = !skipQuery ? loading : false;
    // We set totalCount to ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG when preload is loading
    // We should respect this regardless of context, since the query really is loading behind the scenes
    const isPreloadLoading = data?.comments?.totalCount === (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG);
    returnLoading = isPreloadLoading || returnLoading;
    (0, $42omo.useEffect)(()=>{
        // onCompleted gets fired on the first cache-read only, which as you can imagine causes a lot of race conditions during transition
        // This is the recommended way to deal with complex scenarios involving cache + network reads
        // onCompleted will also fire incorrectly for concurrent calls on the same page, since it has an outdated copy of hasAlreadyFetchedInitialData telescoped in before some calls complete
        if (!skipQuery && isPreloadLoading) // Mark this as preloading to prevent race conditions where loading is not yet set in caller
        setFooterCommentsLoadingState((0, $8i27m.FooterCommentsLoadingStateType).PRELOADING);
        if (useStableCommentsDataUpdates && !isPreloadLoading && !skipQuery && data) {
            // Preload updates data, which we don't want
            (0, $3ZsvI.updateCommentsDataState)({
                data: data,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            // Don't update loading state if the query is skipped
            (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
        }
    }, [
        data,
        useStableCommentsDataUpdates,
        hasAlreadyFetchedInitialData,
        addNewCommentThreads,
        setCommentsDataMap,
        pageMode,
        currentUserId,
        skipQuery,
        type,
        setFooterCommentsLoadingState,
        isPreloadLoading
    ]);
    return {
        loading: returnLoading,
        data: // If we skip the query make sure loading is false
        data,
        error: error,
        refetch: refetch
    };
};
module.exports["useActiveCommentsQuery"] = $7c240d799ee287c0$export$1369688a638bab5e;

});

parcelRegister("htsj6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2PDpU = parcelRequire("2PDpU");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");

const $feac3235d890b171$export$50af12b79850199d = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const props = t1;
    return $feac3235d890b171$export$689c7050603c5c14(props, false);
};
const $feac3235d890b171$export$689c7050603c5c14 = ({ skip: skip = false } = {}, returnRefreshFunction = true)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const query = (0, $2PDpU.default);
    const options = {
        skip: skip || !contentId,
        variables: {
            contentId: contentId ?? ''
        }
    };
    let result;
    if (returnRefreshFunction) // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jMyy4.useQueryInterop)(query, {
        ...options,
        __callerPackage__: "@confluence/page-utils"
    });
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(query, options);
    const { data: data, loading: loading, error: error } = result;
    const contentNode = data?.content?.nodes?.[0];
    return {
        contentStatus: contentNode?.status,
        loading: loading,
        error: error,
        refetch: result.refetch,
        type: contentNode?.type
    };
};
module.exports["useContentStatus"] = $feac3235d890b171$export$50af12b79850199d;
module.exports["useContentStatusWithRefetch"] = $feac3235d890b171$export$689c7050603c5c14;

});

parcelRegister("2PDpU", function(module, exports) {
/**
 * @generated SignedSource<<46aaf98c7fe5f9fcbf890b27644f6f9d>>
 * @relayHash 11ef6cf70fe5a26f89cf732fe25cb27f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5
const $ac2eaa9e4c9bbbba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft",
                        "archived"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "11ef6cf70fe5a26f89cf732fe25cb27f",
            "id": "3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5",
            "metadata": {},
            "name": "useContentStatusContentStatusQuery",
            "operationKind": "query",
            "text": "query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status,type}}}"
        }
    };
}();
$ac2eaa9e4c9bbbba$var$node.hash = "42fd7c46b2fddcc220c48467ae805b6e";
var $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039 = $ac2eaa9e4c9bbbba$var$node;
module.exports["default"] = $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039;

});

parcelRegister("9rE3H", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $5b808dc3cc2fdcb5$export$3816ffab97d6707 = 3;
const $5b808dc3cc2fdcb5$export$c2458e66b06ab105 = -1; // We can't do cache.evict based on apollo version, so use -1 as a flag
const $5b808dc3cc2fdcb5$export$ed108990552755bd = 2000;
const $5b808dc3cc2fdcb5$export$37f798be419840d9 = (contentId, isArchived)=>{
    return {
        pageId: contentId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        type: [
            'FOOTER'
        ],
        first: $5b808dc3cc2fdcb5$export$3816ffab97d6707
    };
};
const $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef = ({ pageId: pageId, type: type, isArchived: isArchived = false })=>{
    return {
        pageId: pageId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        first: $5b808dc3cc2fdcb5$export$ed108990552755bd,
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        ...(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && type && {
            type: [
                type
            ]
        }
    };
};
module.exports["ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG"] = $5b808dc3cc2fdcb5$export$c2458e66b06ab105;
module.exports["buildConsistentActiveCommentsQueryPreloadVariables"] = $5b808dc3cc2fdcb5$export$37f798be419840d9;
module.exports["buildConsistentActiveCommentsQueryVariables"] = $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef;

});

parcelRegister("b1hSc", function(module, exports) {
/**
 * @generated SignedSource<<df78531541631ab4c7caa75da707783f>>
 * @relayHash 51e15b77790c5d8cdaef4df99503fbf3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ec4e8503cac8503ab97b9d5696225ef01a65c63685ff47bcda76917fd8a9386
const $4bf9442691f65266$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "commentState",
                    "value": "UNRESOLVED"
                },
                {
                    "kind": "Variable",
                    "name": "commentType",
                    "variableName": "type"
                }
            ],
            "kind": "ObjectValue",
            "name": "confluenceCommentFilter"
        },
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "singleThreaded",
            "value": true
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v6 /*: any*/ ,
                    v11 /*: any*/ 
                ],
                "type": "KnownUser"
            }
        ]
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v15 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v16 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v17 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v18 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "type"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v20 /*: any*/ ,
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v21 /*: any*/ ,
                    v20 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v26 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v28 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "when"
    }, v30 = {
        "kind": "ScalarField",
        "name": "number"
    }, v31 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v8 /*: any*/ 
                ]
            },
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v32 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v11 /*: any*/ 
                ],
                "type": "KnownUser"
            }
        ]
    }, v35 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    v8 /*: any*/ 
                ]
            },
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActiveCommentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ActiveCommentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v34 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v35 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v36 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v35 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "51e15b77790c5d8cdaef4df99503fbf3",
            "id": "3ec4e8503cac8503ab97b9d5696225ef01a65c63685ff47bcda76917fd8a9386",
            "metadata": {},
            "name": "ActiveCommentsQuery",
            "operationKind": "query",
            "text": "query ActiveCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$type:[CommentType],$first:Long)@allowHigherTimeout{comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:$type},singleThreaded:true,type:$type,first:$first){__typename,nodes{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{__typename,accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},replies{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{__typename,accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}},totalCount}}"
        }
    };
}();
$4bf9442691f65266$var$node.hash = "37d97577cf19b12ed92bf7d36576353c";
var $4bf9442691f65266$export$2e2bcd8739ae039 = $4bf9442691f65266$var$node;
module.exports["default"] = $4bf9442691f65266$export$2e2bcd8739ae039;

});

parcelRegister("4L9ve", function(module, exports) {
/**
 * Sweet state store for processed comments data.
 * This store should ONLY be updated by CommentsDataBackgroundLoader.
 * All other consumers should use the state/actions hooks to read data.
 */ 
var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");


var $kgNLQ = parcelRequire("kgNLQ");

const $20eb19f7ec5706e8$export$53ac33307b5acee9 = ()=>({
        lastProcessedData: null,
        allComments: [],
        allFilteredComments: [],
        openInlineComments: [],
        openFooterComments: [],
        resolvedComments: [],
        openComments: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        flatCommentsMap: {},
        flatMarkerRefMap: {},
        hasNestedComments: false,
        isDataProcessed: false,
        commentCount: 0,
        hasAnyComments: false,
        error: undefined,
        refetch: undefined
    });
const $20eb19f7ec5706e8$export$e324594224ef24da = {
    /**
	 * Updates all processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 * Note: refetch is set separately via setRefetch, so it's not included here.
	 */ setProcessedData: (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...data,
                error: undefined,
                // Keep existing refetch if it exists, don't overwrite it
                refetch: currentState.refetch
            });
        },
    /**
	 * Sets an error state for processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setError: (error)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                error: error,
                isDataProcessed: true
            });
        },
    /**
	 * Clears error and resets isDataProcessed to initial values.
	 * Skips setState when already at initial values to avoid unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearErrorAndResetIsDataProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const initialState = $20eb19f7ec5706e8$export$53ac33307b5acee9();
            if (currentState.error === initialState.error && currentState.isDataProcessed === initialState.isDataProcessed) return;
            setState({
                ...currentState,
                error: initialState.error,
                isDataProcessed: initialState.isDataProcessed
            });
        },
    /**
	 * Sets isDataProcessed to true without changing other state.
	 * Only updates if isDataProcessed is currently false to prevent unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setDataToProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isDataProcessed) return;
            setState({
                ...currentState,
                isDataProcessed: true
            });
        },
    /**
	 * Sets the refetch function from useAllCommentsData.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setRefetch: (refetch)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                refetch: refetch
            });
        },
    /**
	 * Clears all processed comments data and resets to initial state.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearProcessedData: ()=>({ setState: setState })=>{
            setState($20eb19f7ec5706e8$export$53ac33307b5acee9());
        },
    /**
	 * Processes the raw comments data if it hasn't already been processed and updates the store with
	 * categorized comments. Can be used with output from useAllCommentsData() hook (that is, the full
	 * comments data query result) or the full comments data cache (for when we need to synchronously
	 * process updated cache data).
	 *
	 * Note that for Apollo GQL, if the data hasn't changed then readQuery() will return the same
	 * data reference as the full comment query does. So it is safe to compare data references from
	 * real queries and cache reads to avoid unnecessary reprocessing.
	 *
	 */ // TODO: Verify the data reference behavior for Relay GQL when we start enabling Relay support.
    processCommentsData: ({ data: data, pageMode: pageMode })=>({ setState: setState, getState: getState })=>{
            // Nothing to process if data is null
            if (!data) return;
            // Don't process the same data twice - if the data reference is the same as the last processed
            const currentState = getState();
            if (currentState.isDataProcessed && currentState.lastProcessedData === data) return;
            // Filter out null nodes and create array (empty array if no data)
            const allComments = (data?.comments?.nodes || []).filter((node)=>node !== null);
            // Categorize comments using default contentStatus filters
            const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
            const categorizedData = (0, $kgNLQ.categorizeComments)(allComments, contentStatusFilters);
            // Update the store with categorized comments
            setState({
                ...currentState,
                ...categorizedData,
                allComments: allComments,
                lastProcessedData: data,
                error: undefined,
                isDataProcessed: true
            });
        }
};
const $20eb19f7ec5706e8$export$4be6ac988c62a591 = (0, $1P1Tu.createStore)({
    initialState: $20eb19f7ec5706e8$export$53ac33307b5acee9(),
    actions: $20eb19f7ec5706e8$export$e324594224ef24da,
    name: 'ProcessedCommentsDataStore'
});
const $20eb19f7ec5706e8$export$421cff7071854c91 = (0, $9zUhf.createHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$2919c8d01260d4fe = (0, $9zUhf.createActionsHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$93d43ef0fc9d136b = (0, $9zUhf.createStateHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
// Non-React utility for accessing store outside of React components
const $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance = (0, $4HDYO.defaultRegistry).getStore($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$db6951977b558d4d = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.storeState.getState();
};
const $20eb19f7ec5706e8$export$ae4b56ccf0bbe776 = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.actions;
};
module.exports["useProcessedCommentsData"] = $20eb19f7ec5706e8$export$421cff7071854c91;
module.exports["useProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$2919c8d01260d4fe;
module.exports["useProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$93d43ef0fc9d136b;
module.exports["getProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$db6951977b558d4d;
module.exports["getProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$ae4b56ccf0bbe776;

});

parcelRegister("aPT9H", function(module, exports) {

var $k8e76 = parcelRequire("k8e76");


var $ftXPY = parcelRequire("ftXPY");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $l5y3Y = parcelRequire("l5y3Y");


var $jMyy4 = parcelRequire("jMyy4");

const $a2300d29b43bb5dd$export$e32e67cfb7516912 = (contentId)=>{
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    // Instead of requesting 0 comments with the 'first' param here I am reusing the query that is preloaded and fetched
    // for page comments themselves. This allows me to take advantage of the caching and updates that occur in the
    // legacy classes. I've also just marked all errors as handled as we don't particularly care about the results here
    // and the page comments component has much more robust error handling than we'd want to add here.
    const { data: footerCommentsData, error: error } = (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- This is not preloaded but there is a name collision with a preloaded query
    isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), {
        variables: {
            contentId: contentId,
            offset: '',
            first: 100
        },
        fetchPolicy: window.__SSR_RENDERED__ && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? 'cache-first' : undefined,
        skip: (0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || !contentId,
        __callerPackage__: "@confluence/comments-hooks"
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    // Return undefined when feature gate or experiment is enabled
    if ((0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return undefined;
    return {
        unresolvedInlineCommentsCount: (unresolvedInlineComments && unresolvedInlineComments.length) ?? 0,
        footerCommentsCount: (footerCommentsData && footerCommentsData.comments?.totalCount) ?? 0
    };
};
module.exports["useCommentCountsLegacy"] = $a2300d29b43bb5dd$export$e32e67cfb7516912;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("ftXPY", function(module, exports) {

var $Tbcfi = parcelRequire("Tbcfi");


var $f4AIb = parcelRequire("f4AIb");

const $75943abbc80ed84d$export$fd7e2403f7d3fed9 = (0, $f4AIb.default);
const $75943abbc80ed84d$export$274156b7c7eb3601 = (0, $Tbcfi.default);
module.exports["CommentsSectionQuery"] = $75943abbc80ed84d$export$fd7e2403f7d3fed9;
module.exports["CommentsSectionWithoutReactionsQuery"] = $75943abbc80ed84d$export$274156b7c7eb3601;

});

parcelRegister("Tbcfi", function(module, exports) {
/**
 * @generated SignedSource<<0aa4bde3ab258fb665e89212828a925f>>
 * @relayHash 4e66a1ed92ecc98e74128ce3557c84b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d7c6c79929eb2196d98aff2b51eba75c385f34e79e699de05c60f756a38000c
const $c6cf5a908bbe58bf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offset"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "offset"
        },
        {
            "kind": "Literal",
            "name": "confluenceCommentFilter",
            "value": {
                "commentState": "UNRESOLVED",
                "commentType": "FOOTER"
            }
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "FOOTER"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v5 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v11 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v13 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v14 = {
        "kind": "ScalarField",
        "name": "value"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v15 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v18 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v15 /*: any*/ 
    }, v19 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v20 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v24 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v27 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v28 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v30 = {
        "kind": "ScalarField",
        "name": "number"
    }, v31 = {
        "kind": "ScalarField",
        "name": "when"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v33 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v35 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v36 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v37 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    },
                    v14 /*: any*/ 
                ]
            },
            v7 /*: any*/ 
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v38 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentsSectionQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v34 /*: any*/ ,
                                v7 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v37 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentsSectionQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v34 /*: any*/ ,
                                v7 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v37 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "4e66a1ed92ecc98e74128ce3557c84b1",
            "id": "8d7c6c79929eb2196d98aff2b51eba75c385f34e79e699de05c60f756a38000c",
            "metadata": {},
            "name": "CommentsSectionQueryWithoutReactionsQuery",
            "operationKind": "query",
            "text": "query CommentsSectionQueryWithoutReactionsQuery($offset:String,$first:Long,$contentId:ID!){comments(pageId:$contentId,type:FOOTER,depth:ALL,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER},first:$first,after:$offset){totalCount,pageInfo{hasNextPage,endCursor},edges{cursor,node{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}}}}},content(id:$contentId){nodes{subType,id,operations{operation,targetType},space{id,homepageId},type,history{createdBy{__typename,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){displayName,photos{isPrimary,value},id}}"
        }
    };
}();
$c6cf5a908bbe58bf$var$node.hash = "c124efaee0103dd309c2e510586b845f";
var $c6cf5a908bbe58bf$export$2e2bcd8739ae039 = $c6cf5a908bbe58bf$var$node;
module.exports["default"] = $c6cf5a908bbe58bf$export$2e2bcd8739ae039;

});

parcelRegister("f4AIb", function(module, exports) {
/**
 * @generated SignedSource<<3569a19fadd937f8324f2cd7a1ed6c9e>>
 * @relayHash ddb1eba379ed1544bae77ce8070be56f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e8e74d715fec5fddbd3512bf92f9a13ef034b327df28b13fd1a6534cdc3677e0
const $55379995f0cb8cff$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offset"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "contentId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "offset"
        },
        {
            "kind": "Literal",
            "name": "confluenceCommentFilter",
            "value": {
                "commentState": "UNRESOLVED",
                "commentType": "FOOTER"
            }
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "FOOTER"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v8 /*: any*/ 
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v12 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v15 = {
        "kind": "ScalarField",
        "name": "value"
    }, v16 = [
        v15 /*: any*/ 
    ], v17 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v16 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v18 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v19 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v16 /*: any*/ 
    }, v20 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v21 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v24 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v25 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v28 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v29 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v31 = {
        "kind": "ScalarField",
        "name": "number"
    }, v32 = {
        "kind": "ScalarField",
        "name": "when"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v34 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v35 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v36 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v37 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v38 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v39 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    },
                    v15 /*: any*/ 
                ]
            },
            v8 /*: any*/ 
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v40 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentsSectionQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v34 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v35 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v36 /*: any*/ ,
                                v8 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v33 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v39 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentsSectionQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v40 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v40 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v40 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v34 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v35 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v36 /*: any*/ ,
                                v8 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v40 /*: any*/ ,
                                                v33 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v39 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "ddb1eba379ed1544bae77ce8070be56f",
            "id": "e8e74d715fec5fddbd3512bf92f9a13ef034b327df28b13fd1a6534cdc3677e0",
            "metadata": {},
            "name": "CommentsSectionQuery",
            "operationKind": "query",
            "text": "query CommentsSectionQuery($offset:String,$first:Long,$contentId:ID!)@allowHigherTimeout{comments(pageId:$contentId,type:FOOTER,depth:ALL,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER},first:$first,after:$offset){totalCount,pageInfo{hasNextPage,endCursor},edges{cursor,node{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}},content(id:$contentId){nodes{subType,id,operations{operation,targetType},space{id,homepageId},type,history{createdBy{__typename,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){displayName,photos{isPrimary,value},id}}"
        }
    };
}();
$55379995f0cb8cff$var$node.hash = "2dc784a3ffdaa1784c202cee08d95c7c";
var $55379995f0cb8cff$export$2e2bcd8739ae039 = $55379995f0cb8cff$var$node;
module.exports["default"] = $55379995f0cb8cff$export$2e2bcd8739ae039;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/comments-hooks"
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("9Z1sw", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $eq95w = parcelRequire("eq95w");


var $42omo = parcelRequire("42omo");


var $iRRvH = parcelRequire("iRRvH");


var $bavCP = parcelRequire("bavCP");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $frIzR.c)(3);
    const batchContext = (0, $42omo.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $frIzR.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    if (!panelHasContent) return children;
    const t1 = `web-panel-${locationName}`;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: t1
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "@confluence/web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $42omo.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $42omo.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $42omo.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, loading: loading, error: error })=>{
        // For transitions, loading and data is true
        if (loading && data) return null;
        if (!renderWhenLoading) {
            if (loading || error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "@confluence/web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("1eaCJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");


var $gEtAQ = parcelRequire("gEtAQ");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $frIzR.c)(18);
    const { html: html, panelId: panelId } = t0;
    const containerRef = (0, $42omo.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $42omo.useState)(true);
    let t1;
    if ($[0] !== html) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /"moduleLocation"\s*:\s*"atl\.general"/;
            $[2] = t2;
        } else t2 = $[2];
        t1 = html.match(t2);
        $[0] = html;
        $[1] = t1;
    } else t1 = $[1];
    const moduleLocationMatch = t1;
    let t2;
    if ($[3] !== moduleLocationMatch) {
        t2 = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
        $[3] = moduleLocationMatch;
        $[4] = t2;
    } else t2 = $[4];
    const isMatchForActivatable = t2;
    let t3;
    if ($[5] !== isMatchForActivatable || $[6] !== ssrSuccess) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            if (isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false)) {
                if (window?.__HYDRATABLE__) {
                    const scriptElement = container.querySelector("script.ap-iframe-body-script");
                    if (scriptElement) {
                        const scriptContent = scriptElement.textContent || "";
                        const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                        if (match) {
                            const uniqueKey = match[1];
                            const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                            if (iframe) return;
                        }
                    }
                }
                if (ssrSuccess) setSsrSuccess(false);
            }
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false));
        };
        $[5] = isMatchForActivatable;
        $[6] = ssrSuccess;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== html || $[9] !== isMatchForActivatable || $[10] !== panelId || $[11] !== ssrSuccess) {
        t4 = [
            html,
            panelId,
            ssrSuccess,
            isMatchForActivatable
        ];
        $[8] = html;
        $[9] = isMatchForActivatable;
        $[10] = panelId;
        $[11] = ssrSuccess;
        $[12] = t4;
    } else t4 = $[12];
    (0, $42omo.useLayoutEffect)(t3, t4);
    let t5;
    if ($[13] !== html || $[14] !== isMatchForActivatable || $[15] !== panelId || $[16] !== ssrSuccess) {
        t5 = isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UM2Q.ActivatableComponent), {
            id: panelId ?? "WebPanel",
            triggers: [
                {
                    type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
                }
            ],
            ssrSuccess: ssrSuccess,
            analyticsName: "WebPanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: containerRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
        $[13] = html;
        $[14] = isMatchForActivatable;
        $[15] = panelId;
        $[16] = ssrSuccess;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("6UM2Q", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

const $68e0b10beef6f399$export$1db2f2faaee8467f = (0, $3u0dr.isReactCompilerActiveV2)() ? function ActivatableComponent(t0) {
    const $ = (0, $frIzR.c)(26);
    const { children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9s45p.makeGate)();
        $[0] = t1;
    } else t1 = $[0];
    const gate = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[1] !== children) {
        t2 = ()=>children;
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    const renderChildren = t2;
    let t3;
    if ($[3] !== analyticsName || $[4] !== createAnalyticsEvent || $[5] !== id || $[6] !== onActivate || $[7] !== triggers) {
        t3 = (reason)=>{
            if (gate?.getStatus() === "suspended") {
                onActivate?.(reason);
                if (analyticsName) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "activatableComponent",
                        action: "activated",
                        actionSubject: "activatableComponent",
                        attributes: {
                            analyticsName: analyticsName,
                            triggers: triggers,
                            boundaryId: id,
                            activationReason: reason
                        }
                    }
                }).fire();
                gate.resolve();
            }
        };
        $[3] = analyticsName;
        $[4] = createAnalyticsEvent;
        $[5] = id;
        $[6] = onActivate;
        $[7] = triggers;
        $[8] = t3;
    } else t3 = $[8];
    const activateComponent = t3;
    let t4;
    if ($[9] !== activateComponent || $[10] !== analyticsName || $[11] !== id || $[12] !== triggers) {
        t4 = {
            triggers: triggers,
            gate: gate,
            activateComponent: activateComponent,
            boundaryId: id,
            analyticsName: analyticsName
        };
        $[9] = activateComponent;
        $[10] = analyticsName;
        $[11] = id;
        $[12] = triggers;
        $[13] = t4;
    } else t4 = $[13];
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)(t4);
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = gate?.getStatus?.();
        $[14] = t5;
    } else t5 = $[14];
    const t6 = analyticsName || id;
    let t7;
    if ($[15] !== activateComponent || $[16] !== id || $[17] !== renderChildren || $[18] !== ssrSuccess || $[19] !== t6 || $[20] !== triggers) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75bK2.Boundary), {
            gate: gate,
            id: id,
            render: renderChildren,
            ssrSuccess: ssrSuccess,
            activateComponent: activateComponent,
            resolved: t5 === "resolved",
            boundaryName: t6,
            triggers: triggers
        });
        $[15] = activateComponent;
        $[16] = id;
        $[17] = renderChildren;
        $[18] = ssrSuccess;
        $[19] = t6;
        $[20] = triggers;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== hostRefWithActivation || $[23] !== id || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: hostRefWithActivation,
            "data-hydration-shield": id
        }, t7);
        $[22] = hostRefWithActivation;
        $[23] = id;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function ActivatableComponent({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $42omo.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const renderChildren = (0, $42omo.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $42omo.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
};
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("3Am3T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $42omo.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { contentId: contentId, children: children } = t0;
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    let t1;
    if ($[0] !== children || $[1] !== commentCounts) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
            value: commentCounts
        }, children);
        $[0] = children;
        $[1] = commentCounts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("gV8Ob", function(module, exports) {

let $c518cd5ba1e3a6d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c518cd5ba1e3a6d1$var$load("1OPxx"),
    $c518cd5ba1e3a6d1$var$load("byAMe"),
    $c518cd5ba1e3a6d1$var$load("cmqxT"),
    $c518cd5ba1e3a6d1$var$load("35X59"),
    $c518cd5ba1e3a6d1$var$load("5iZqi"),
    $c518cd5ba1e3a6d1$var$load("6wr18"),
    $c518cd5ba1e3a6d1$var$load("kNNS3"),
    $c518cd5ba1e3a6d1$var$load("cf5vC"),
    $c518cd5ba1e3a6d1$var$load("eik0U"),
    $c518cd5ba1e3a6d1$var$load("cJsay"),
    $c518cd5ba1e3a6d1$var$load("4W6oq"),
    $c518cd5ba1e3a6d1$var$load("7EorR"),
    $c518cd5ba1e3a6d1$var$load("1GCFv"),
    $c518cd5ba1e3a6d1$var$load("ffEVr"),
    $c518cd5ba1e3a6d1$var$load("hhss7"),
    $c518cd5ba1e3a6d1$var$load("bLm2D"),
    $c518cd5ba1e3a6d1$var$load("2zqtv")
]).then(()=>parcelRequire('kXPQu'));

});

parcelRegister("iWp4Q", function(module, exports) {

let $dca1188d50346d5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dca1188d50346d5b$var$load("3EXzu"),
    $dca1188d50346d5b$var$load("lHi37"),
    $dca1188d50346d5b$var$load("fBVt2"),
    $dca1188d50346d5b$var$load("5gRHV"),
    $dca1188d50346d5b$var$load("d62hC"),
    $dca1188d50346d5b$var$load("jPzkK"),
    $dca1188d50346d5b$var$load("aCwOt"),
    $dca1188d50346d5b$var$load("cIKpa"),
    $dca1188d50346d5b$var$load("bNW8r"),
    $dca1188d50346d5b$var$load("94gN4"),
    $dca1188d50346d5b$var$load("jDHDy"),
    $dca1188d50346d5b$var$load("cJsay"),
    $dca1188d50346d5b$var$load("8LtYa"),
    $dca1188d50346d5b$var$load("dlm6q"),
    $dca1188d50346d5b$var$load("4oONP"),
    $dca1188d50346d5b$var$load("dtpmo"),
    $dca1188d50346d5b$var$load("2F69B"),
    $dca1188d50346d5b$var$load("1GCFv"),
    $dca1188d50346d5b$var$load("5dkX4"),
    $dca1188d50346d5b$var$load("coUzl"),
    $dca1188d50346d5b$var$load("5nMTY"),
    $dca1188d50346d5b$var$load("7j0mT"),
    $dca1188d50346d5b$var$load("69R9L"),
    $dca1188d50346d5b$var$load("hXbzh"),
    $dca1188d50346d5b$var$load("6wr18"),
    $dca1188d50346d5b$var$load("dwSiO"),
    $dca1188d50346d5b$var$load("evP3v"),
    $dca1188d50346d5b$var$load("HaNwW"),
    $dca1188d50346d5b$var$load("cmqxT"),
    $dca1188d50346d5b$var$load("ZBVfs"),
    $dca1188d50346d5b$var$load("4oXMS"),
    $dca1188d50346d5b$var$load("67Alm"),
    $dca1188d50346d5b$var$load("2B2rM"),
    $dca1188d50346d5b$var$load("9anPW"),
    $dca1188d50346d5b$var$load("cyGuT"),
    $dca1188d50346d5b$var$load("9DBoM"),
    $dca1188d50346d5b$var$load("jPuvo"),
    $dca1188d50346d5b$var$load("zSp86"),
    $dca1188d50346d5b$var$load("Wowvf"),
    $dca1188d50346d5b$var$load("1F7LX"),
    $dca1188d50346d5b$var$load("foAs3"),
    $dca1188d50346d5b$var$load("7EorR"),
    $dca1188d50346d5b$var$load("eiF7i"),
    $dca1188d50346d5b$var$load("1gUNx"),
    $dca1188d50346d5b$var$load("9lUu8"),
    $dca1188d50346d5b$var$load("hhss7"),
    $dca1188d50346d5b$var$load("ffEVr"),
    $dca1188d50346d5b$var$load("e2WH6"),
    $dca1188d50346d5b$var$load("5vzT0"),
    $dca1188d50346d5b$var$load("h94bv"),
    $dca1188d50346d5b$var$load("27cgC")
]).then(()=>parcelRequire('fp8N8'));

});

parcelRegister("4Yv1J", function(module, exports) {
$parcel$export(module.exports, "ContentExtensionsProvider", () => (parcelRequire("f5aR2")).ContentExtensionsProvider);

var $f5aR2 = parcelRequire("f5aR2");


});

parcelRegister("f5aR2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k77lQ = parcelRequire("k77lQ");


var $69aHU = parcelRequire("69aHU");


var $hFueH = parcelRequire("hFueH");


var $hMRhJ = parcelRequire("hMRhJ");


const $cc34c55db5a1bcbb$var$getLegacyContentExtensions = ()=>({
        loadSortableTable: ()=>(parcelRequire("gY2se"))
    });
const $cc34c55db5a1bcbb$var$providers = {
    getExtensionHandlers: $k77lQ.getExtensionHandlers,
    getLegacyContentExtensions: $cc34c55db5a1bcbb$var$getLegacyContentExtensions,
    populateExtensionProviders: $69aHU.populateExtensionProviders,
    EditorLoaderLoader: $hFueH.default
};
const $cc34c55db5a1bcbb$export$2a88d3b468decd4a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
        value: $cc34c55db5a1bcbb$var$providers
    }, children);
module.exports["ContentExtensionsProvider"] = $cc34c55db5a1bcbb$export$2a88d3b468decd4a;

});

parcelRegister("gY2se", function(module, exports) {

let $c5a42755014c640b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c5a42755014c640b$var$load("kuPgl").then(()=>parcelRequire('5byen'));

});

parcelRegister("crTA1", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("iqZzD")).default);

var $iqZzD = parcelRequire("iqZzD");


});

parcelRegister("iqZzD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6ba6afbc5717c4a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $iqPBi = parcelRequire("iqPBi");

var $d6ba6afbc5717c4a$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPBi.SpaceBase), props);
};

});

parcelRegister("3BNlM", function(module, exports) {

let $2a0b1bc312f04833$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2a0b1bc312f04833$var$load("aiC0W"),
    $2a0b1bc312f04833$var$load("2wyaQ"),
    $2a0b1bc312f04833$var$load("7HPPR"),
    $2a0b1bc312f04833$var$load("6wr18"),
    $2a0b1bc312f04833$var$load("8rBWe"),
    $2a0b1bc312f04833$var$load("8EEwj"),
    $2a0b1bc312f04833$var$load("jvHRs"),
    $2a0b1bc312f04833$var$load("gufL1"),
    $2a0b1bc312f04833$var$load("ffEVr"),
    $2a0b1bc312f04833$var$load("72caV"),
    $2a0b1bc312f04833$var$load("bo7iw"),
    $2a0b1bc312f04833$var$load("9DBoM"),
    $2a0b1bc312f04833$var$load("7EorR"),
    $2a0b1bc312f04833$var$load("5yCzB"),
    $2a0b1bc312f04833$var$load("9s2yE"),
    $2a0b1bc312f04833$var$load("1PT2m"),
    $2a0b1bc312f04833$var$load("fZYxu"),
    $2a0b1bc312f04833$var$load("glsIE"),
    $2a0b1bc312f04833$var$load("6J5UB"),
    $2a0b1bc312f04833$var$load("ak4AP"),
    $2a0b1bc312f04833$var$load("l8Dig"),
    $2a0b1bc312f04833$var$load("c5u8A"),
    $2a0b1bc312f04833$var$load("8Tfc6"),
    $2a0b1bc312f04833$var$load("lwcwb"),
    $2a0b1bc312f04833$var$load("boWf5"),
    $2a0b1bc312f04833$var$load("i8qZz"),
    $2a0b1bc312f04833$var$load("4M3vA"),
    $2a0b1bc312f04833$var$load("inj26"),
    $2a0b1bc312f04833$var$load("cIyFe"),
    $2a0b1bc312f04833$var$load("lkuRr"),
    $2a0b1bc312f04833$var$load("ha0dM"),
    $2a0b1bc312f04833$var$load("bR8yE"),
    $2a0b1bc312f04833$var$load("bTTil"),
    $2a0b1bc312f04833$var$load("4Wx4n"),
    $2a0b1bc312f04833$var$load("1gcQ5"),
    $2a0b1bc312f04833$var$load("gPTId"),
    $2a0b1bc312f04833$var$load("cAutP"),
    $2a0b1bc312f04833$var$load("4DMbb"),
    $2a0b1bc312f04833$var$load("dQ5wp"),
    $2a0b1bc312f04833$var$load("bbk8L"),
    $2a0b1bc312f04833$var$load("8DCw4"),
    $2a0b1bc312f04833$var$load("gsf1a"),
    $2a0b1bc312f04833$var$load("4qZ9f"),
    $2a0b1bc312f04833$var$load("iJ7i2"),
    $2a0b1bc312f04833$var$load("4jTYI"),
    $2a0b1bc312f04833$var$load("bNNeh"),
    $2a0b1bc312f04833$var$load("gBTOA"),
    $2a0b1bc312f04833$var$load("9joh8"),
    $2a0b1bc312f04833$var$load("1SyLT"),
    $2a0b1bc312f04833$var$load("ik9rg")
]).then(()=>parcelRequire('dg3UC'));

});

parcelRegister("QVJaI", function(module, exports) {

let $09f1a2f01e5f74a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $09f1a2f01e5f74a8$var$load("d62hC"),
    $09f1a2f01e5f74a8$var$load("7Ya0F"),
    $09f1a2f01e5f74a8$var$load("eNZNF"),
    $09f1a2f01e5f74a8$var$load("9OQNK"),
    $09f1a2f01e5f74a8$var$load("4oONP"),
    $09f1a2f01e5f74a8$var$load("xu7ej"),
    $09f1a2f01e5f74a8$var$load("7bkye"),
    $09f1a2f01e5f74a8$var$load("lFAez"),
    $09f1a2f01e5f74a8$var$load("6wr18"),
    $09f1a2f01e5f74a8$var$load("4JHZy"),
    $09f1a2f01e5f74a8$var$load("h9Ycm"),
    $09f1a2f01e5f74a8$var$load("j104l"),
    $09f1a2f01e5f74a8$var$load("4JAC8"),
    $09f1a2f01e5f74a8$var$load("3Bbwl"),
    $09f1a2f01e5f74a8$var$load("3xuDK"),
    $09f1a2f01e5f74a8$var$load("fGvqc"),
    $09f1a2f01e5f74a8$var$load("1Qnbg"),
    $09f1a2f01e5f74a8$var$load("5uN9h"),
    $09f1a2f01e5f74a8$var$load("ffEVr"),
    $09f1a2f01e5f74a8$var$load("7EorR"),
    $09f1a2f01e5f74a8$var$load("fFJCh"),
    $09f1a2f01e5f74a8$var$load("2bs4C"),
    $09f1a2f01e5f74a8$var$load("3tgAP"),
    $09f1a2f01e5f74a8$var$load("3GBzS"),
    $09f1a2f01e5f74a8$var$load("1pxHe"),
    $09f1a2f01e5f74a8$var$load("eVJyV")
]).then(()=>parcelRequire('9yrtR'));

});

parcelRegister("628tr", function(module, exports) {

let $464980b7aa25be98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $464980b7aa25be98$var$load("dRtRF"),
    $464980b7aa25be98$var$load("6unZM")
]).then(()=>parcelRequire('c0oNl'));

});

parcelRegister("kjKSX", function(module, exports) {

let $eca9f3733c3dcfa7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eca9f3733c3dcfa7$var$load("7UdVV").then(()=>parcelRequire('kCK7c'));

});

parcelRegister("hTO1G", function(module, exports) {

let $d07e60d9c890bb3e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d07e60d9c890bb3e$var$load("ge3AN").then(()=>parcelRequire('iiG61'));

});

parcelRegister("WJkgK", function(module, exports) {

let $0b0893ad96ab6d7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b0893ad96ab6d7e$var$load("4Yemz").then(()=>parcelRequire('3R3rh'));

});

parcelRegister("gObvh", function(module, exports) {

let $c3ca3d2fd4a434ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3ca3d2fd4a434ff$var$load("8prF9").then(()=>parcelRequire('aJ0Cr'));

});

parcelRegister("afKSR", function(module, exports) {

let $01ed27f09ff00d29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $01ed27f09ff00d29$var$load("dRtRF"),
    $01ed27f09ff00d29$var$load("4CfTY"),
    $01ed27f09ff00d29$var$load("gctwz"),
    $01ed27f09ff00d29$var$load("4drdS"),
    $01ed27f09ff00d29$var$load("4fYzp"),
    $01ed27f09ff00d29$var$load("aIuOE")
]).then(()=>parcelRequire('56n4X'));

});

parcelRegister("kSHES", function(module, exports) {

let $f33ab76f69730595$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f33ab76f69730595$var$load("fV7Cf").then(()=>parcelRequire('gkSJt'));

});

parcelRegister("j5opD", function(module, exports) {

let $de516bbdf9e75693$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $de516bbdf9e75693$var$load("dRtRF"),
    $de516bbdf9e75693$var$load("6wr18"),
    $de516bbdf9e75693$var$load("hwUDh"),
    $de516bbdf9e75693$var$load("cCHYW"),
    $de516bbdf9e75693$var$load("ecwNN"),
    $de516bbdf9e75693$var$load("4xgpM"),
    $de516bbdf9e75693$var$load("iK6Gk"),
    $de516bbdf9e75693$var$load("gskl6"),
    $de516bbdf9e75693$var$load("bIAIU"),
    $de516bbdf9e75693$var$load("eF24J"),
    $de516bbdf9e75693$var$load("kaAxH"),
    $de516bbdf9e75693$var$load("fm6Nu"),
    $de516bbdf9e75693$var$load("g5HUX"),
    $de516bbdf9e75693$var$load("c39Xf"),
    $de516bbdf9e75693$var$load("czd3n"),
    $de516bbdf9e75693$var$load("7P36N"),
    $de516bbdf9e75693$var$load("jlCbV"),
    $de516bbdf9e75693$var$load("ct54r"),
    $de516bbdf9e75693$var$load("9f5Sw"),
    $de516bbdf9e75693$var$load("2ap9J"),
    $de516bbdf9e75693$var$load("4oXMS"),
    $de516bbdf9e75693$var$load("9CydI"),
    $de516bbdf9e75693$var$load("3CazT"),
    $de516bbdf9e75693$var$load("gp06T"),
    $de516bbdf9e75693$var$load("9ifQI"),
    $de516bbdf9e75693$var$load("abd2b"),
    $de516bbdf9e75693$var$load("67Alm"),
    $de516bbdf9e75693$var$load("9nwFZ"),
    $de516bbdf9e75693$var$load("2B2rM"),
    $de516bbdf9e75693$var$load("b11Cj"),
    $de516bbdf9e75693$var$load("7HPPR"),
    $de516bbdf9e75693$var$load("4TzHH"),
    $de516bbdf9e75693$var$load("1okAQ"),
    $de516bbdf9e75693$var$load("35X59"),
    $de516bbdf9e75693$var$load("hOaAV"),
    $de516bbdf9e75693$var$load("9anPW"),
    $de516bbdf9e75693$var$load("lFAez"),
    $de516bbdf9e75693$var$load("1qlDN"),
    $de516bbdf9e75693$var$load("1yVM6"),
    $de516bbdf9e75693$var$load("cEqm7"),
    $de516bbdf9e75693$var$load("6XCf4"),
    $de516bbdf9e75693$var$load("ffEVr"),
    $de516bbdf9e75693$var$load("9DBoM"),
    $de516bbdf9e75693$var$load("7gkvG"),
    $de516bbdf9e75693$var$load("7EorR"),
    $de516bbdf9e75693$var$load("aSL4q"),
    $de516bbdf9e75693$var$load("7UvpM")
]).then(()=>parcelRequire('hQDgX'));

});

parcelRegister("l1Dg4", function(module, exports) {

let $f4e824d965915a9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f4e824d965915a9e$var$load("dRtRF"),
    $f4e824d965915a9e$var$load("4CfTY"),
    $f4e824d965915a9e$var$load("gctwz"),
    $f4e824d965915a9e$var$load("4drdS"),
    $f4e824d965915a9e$var$load("4fYzp"),
    $f4e824d965915a9e$var$load("dezv5")
]).then(()=>parcelRequire('hD4yV'));

});

parcelRegister("bxUCq", function(module, exports) {

let $867eb2117b57cde7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $867eb2117b57cde7$var$load("eNXrl"),
    $867eb2117b57cde7$var$load("gNfuQ"),
    $867eb2117b57cde7$var$load("h94bv"),
    $867eb2117b57cde7$var$load("6wr18"),
    $867eb2117b57cde7$var$load("8eNS3"),
    $867eb2117b57cde7$var$load("5p0Bu"),
    $867eb2117b57cde7$var$load("ffEVr"),
    $867eb2117b57cde7$var$load("2eiOk")
]).then(()=>parcelRequire('do0K0'));

});

parcelRegister("kPml2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f767605c1291541e11ee398674a3c525>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f299e6000fe75318$var$_react = $f299e6000fe75318$var$_interopRequireDefault((parcelRequire("42omo")));

var $f299e6000fe75318$var$_baseNew = $f299e6000fe75318$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f299e6000fe75318$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f299e6000fe75318$var$LocationIcon = (props)=>/*#__PURE__*/ $f299e6000fe75318$var$_react.default.createElement($f299e6000fe75318$var$_baseNew.default, Object.assign({
        name: "LocationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$f299e6000fe75318$var$LocationIcon.displayName = 'LocationIcon';
var $f299e6000fe75318$var$_default = module.exports.default = $f299e6000fe75318$var$LocationIcon;

});

parcelRegister("a6t12", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $8j9VY = parcelRequire("8j9VY");


var $2TEGg = parcelRequire("2TEGg");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");

parcelRequire("5XsiK");
var $lfSOe = parcelRequire("lfSOe");


var $6OL2O = parcelRequire("6OL2O");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $aXWIB.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $6OL2O.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = (0, $lfSOe.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $42omo.useMemo)(()=>(0, $lfSOe.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        }), [
        push,
        userId,
        userProfile
    ]);
    const followUserAction = (0, $42omo.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $42omo.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $42omo.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        if ((0, $lfSOe.isTeamsAppEnabled)()) {
            getReportingLinesUserProfile(clickedUserId_0).onNavigate();
            return false;
        }
        if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, '', (0, $jlIaF.CONTEXT_PATH)), '_blank', 'noreferrer');
        else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, ()=>{});
    };
    if ((0, $9wGTI.fg)('people-teams_migrate-user-profile-card')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2TEGg.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        trigger: trigger,
        actions: [
            followUserActionNext
        ],
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("5XsiK", function(module, exports) {
$parcel$export(module.exports, "isTeamsAppEnabled", () => (parcelRequire("lfSOe")).isTeamsAppEnabled);

var $lfSOe = parcelRequire("lfSOe");


});

parcelRegister("lfSOe", function(module, exports) {

var $hbEOA = parcelRequire("hbEOA");

const $6739d59719e0930b$export$5921b2a93a401547 = ()=>{
    return (0, $hbEOA.isTeamsAppEnabled)({
        userHasNav4Enabled: true,
        hostProduct: 'confluence'
    });
};
module.exports["isTeamsAppEnabled"] = $6739d59719e0930b$export$5921b2a93a401547;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("bedVD", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3gadb = parcelRequire("3gadb");

const $e4e11ee9fe4a88c9$var$i18n = (0, $aXWIB.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("l7wqU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("4GlQ9", function(module, exports) {

var $k7Nop = parcelRequire("k7Nop");


var $hOSkW = parcelRequire("hOSkW");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $hOSkW.default);
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $k7Nop.default);
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $jMyy4.useQueryInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error),
        __callerPackage__: "@confluence/profile"
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $308Wd.useMutationInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            }
        ],
        __callerPackage__: "@confluence/profile"
    });
    const followedUsersRaw = data?.getFeedUserConfig?.accountIds;
    const followedUsers = followedUsersRaw ? followedUsersRaw.map((id)=>id ?? null) : undefined;
    const getToggleFollowUser = (0, $42omo.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch  {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    return (0, $42omo.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers ?? []
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("k7Nop", function(module, exports) {
/**
 * @generated SignedSource<<faabaa80182918f5d00c229b25800acb>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c
const $2274f77c1a29b092$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "follow"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "unfollow"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "follow"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollow"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
            "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
            "metadata": {},
            "name": "useFeedFollowFeedFollowMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
        }
    };
}();
$2274f77c1a29b092$var$node.hash = "7ecf9b28db7400fffab67e3a3c52027c";
var $2274f77c1a29b092$export$2e2bcd8739ae039 = $2274f77c1a29b092$var$node;
module.exports["default"] = $2274f77c1a29b092$export$2e2bcd8739ae039;

});

parcelRegister("hOSkW", function(module, exports) {
/**
 * @generated SignedSource<<597a7b2d7b3333c8532a887f4cdcbd48>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b
const $eeb53afb4cc8b670$var$node = function() {
    var v0 = [
        {
            "concreteType": "FollowingFeedGetUserConfig",
            "kind": "LinkedField",
            "name": "getFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
            "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
            "metadata": {},
            "name": "useFeedFollowFeedFollowQuery",
            "operationKind": "query",
            "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
        }
    };
}();
$eeb53afb4cc8b670$var$node.hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";
var $eeb53afb4cc8b670$export$2e2bcd8739ae039 = $eeb53afb4cc8b670$var$node;
module.exports["default"] = $eeb53afb4cc8b670$export$2e2bcd8739ae039;

});

parcelRegister("bumSD", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $7c52C = parcelRequire("7c52C");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $2XqLN.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $7c52C.default)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $8zKPT = parcelRequire("8zKPT");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");


var $c0rhi = parcelRequire("c0rhi");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $8zKPT.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        const UserProfileClientForConfluencePromise = (0, $c0rhi.queryInterop)({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            },
            __callerPackage__: "@confluence/profile"
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $aXWIB.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("ldOrZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {

var $ay9Uu = parcelRequire("ay9Uu");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $ay9Uu.default);
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("ay9Uu", function(module, exports) {
/**
 * @generated SignedSource<<c8072e566be2615c9f169051b183f1d7>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d
const $bb661b120eec94ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
            "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
            "metadata": {},
            "name": "UserProfileClientForConfluenceQuery",
            "operationKind": "query",
            "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$bb661b120eec94ae$var$node.hash = "f636f7ede64e4c0d1757767b061d53b5";
var $bb661b120eec94ae$export$2e2bcd8739ae039 = $bb661b120eec94ae$var$node;
module.exports["default"] = $bb661b120eec94ae$export$2e2bcd8739ae039;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("gj42z", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $aXWIB = parcelRequire("aXWIB");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        defaultMessage: "We\u2019re having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("kcIQr", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $inPa6 = parcelRequire("inPa6");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $frIzR.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("4BDAe", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bbe4d3361c67916e$var$noop,
                close: $bbe4d3361c67916e$var$noop,
                setPanelWidth: $bbe4d3361c67916e$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("fN3iy", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = ()=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $dh538.fg)("nin_glance_panel_initial_width_ssr") ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel && (0, $dh538.fg)("preview_panel_initial_state") ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$1ec08acbc7c3653d$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)((0, $dh538.fg)('nin_glance_panel_initial_width_ssr') ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        ...initialPanel && (0, $dh538.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
} : ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$MINIMUM_WIDTH = 1800;
const $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $9ee4137247832c84$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("1YXTQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $clUfR = parcelRequire("clUfR");


var $7GLtr = parcelRequire("7GLtr");


var $awd1Q = parcelRequire("awd1Q");


var $bQm3c = parcelRequire("bQm3c");

'use no memo';
const $6f4eb0725770e50a$var$i18n = (0, $aXWIB.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
                    // Validate the timezone, use UTC as fallback for invalid values
                    return (0, $7GLtr.isValidTimeZone)(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $awd1Q.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    const localeLanguage = new Intl.Locale(locale).language;
    const formatter = new Intl.RelativeTimeFormat(localeLanguage, {
        style: 'long',
        numeric: 'auto'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    const value = -Math.round(seconds / factor / granularity) * granularity;
    const unit = $6f4eb0725770e50a$var$gradation[i].unit || 'second';
    return formatter.format(value, unit);
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $42omo.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $42omo.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};
module.exports["formatTimeAgo"] = $6f4eb0725770e50a$export$78ae3e68d8c394bc;
module.exports["StaticTimeAgo"] = $6f4eb0725770e50a$export$fc791eb9f9c39e49;
module.exports["TimeAgo"] = $6f4eb0725770e50a$export$9e4a631e7281406a;

});

parcelRegister("clUfR", function(module, exports) {
const $dad8374cf8f904e8$export$c333b33f2586074c = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return 'Etc/UTC';
    }
};
module.exports["guessTimeZone"] = $dad8374cf8f904e8$export$c333b33f2586074c;

});

parcelRegister("7GLtr", function(module, exports) {
const $0e3ee782c26ab488$export$c793e14020d7c7b = (timeZone)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
module.exports["isValidTimeZone"] = $0e3ee782c26ab488$export$c793e14020d7c7b;

});

parcelRegister("cbtR4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e145ebbd6eaf2e0b8e4930467ce4a33d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8dedabaf09e709a0$var$_react = $8dedabaf09e709a0$var$_interopRequireDefault((parcelRequire("42omo")));

var $8dedabaf09e709a0$var$_baseNew = $8dedabaf09e709a0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8dedabaf09e709a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeCleanup".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for automated cleanup and tidy functionality
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8dedabaf09e709a0$var$AiGenerativeCleanupIcon = (props)=>/*#__PURE__*/ $8dedabaf09e709a0$var$_react.default.createElement($8dedabaf09e709a0$var$_baseNew.default, Object.assign({
        name: "AiGenerativeCleanupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.23.44 12.22 8h1.58a2 2 0 0 1 1.91 2.59l-1.23 4a2 2 0 0 1-1.9 1.41H4.75a.75.75 0 0 1-.28-1.45h-.01l.02-.01q.03-.01.1-.06c.09-.06.23-.16.39-.32.31-.32.71-.88.93-1.84l.03-.09L7 9.3A2 2 0 0 1 8.87 8h1.8L12.78.06zM8.87 9.5a.5.5 0 0 0-.47.33l-1.06 2.89a5.7 5.7 0 0 1-.73 1.78h5.97a.5.5 0 0 0 .48-.35l1.23-4a.5.5 0 0 0-.48-.65zM4.62 1.01a.75.75 0 0 1 .54.38l.05.11.54 1.47.05.1a.5.5 0 0 0 .25.2l1.47.54.11.05a.75.75 0 0 1 0 1.31l-.11.05-1.47.54a.5.5 0 0 0-.3.3l-.54 1.47a.75.75 0 0 1-1.36.11l-.05-.1-.54-1.47a.5.5 0 0 0-.2-.25l-.1-.05-1.47-.53a.75.75 0 0 1-.48-.59L1 4.5l.01-.12a.75.75 0 0 1 .48-.59l1.47-.54.1-.05a.5.5 0 0 0 .2-.25l.54-1.47.05-.11A.75.75 0 0 1 4.5 1z"/>`
    }, props));
$8dedabaf09e709a0$var$AiGenerativeCleanupIcon.displayName = 'AiGenerativeCleanupIcon';
var $8dedabaf09e709a0$var$_default = module.exports.default = $8dedabaf09e709a0$var$AiGenerativeCleanupIcon;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["AgentReceiptPanel"] = "agentReceiptPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    PanelName["SpaceSuggestionReviewPanel"] = "space-suggestion-review-panel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    "agentReceiptPanel",
    "space-suggestion-review-panel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("kmWRd", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");


var $g9Srd = parcelRequire("g9Srd");


var $h3cbw = parcelRequire("h3cbw");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $ecnYn.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3, width: t4 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    const width = t4 === undefined ? 320 : t4;
    let t5;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop || $[6] !== width) {
        t5 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: `${width}px`,
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = width;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: true
        }, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("3hnrC", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");

const $6f3a2c1a9f6e5048$var$bodyWrapperStyles = (0, $ecnYn.xcss)({
    flexGrow: '1'
});
const $6f3a2c1a9f6e5048$export$b32ca013fcba8075 = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150",
            xcss: $6f3a2c1a9f6e5048$var$bodyWrapperStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelBody"] = $6f3a2c1a9f6e5048$export$b32ca013fcba8075;

});

parcelRegister("cHiEk", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");

const $50364c7681d2ff9d$var$footerBaseStyles = (0, $ecnYn.xcss)({
    borderTopColor: 'color.border',
    borderTopStyle: 'solid',
    borderTopWidth: 'border.width'
});
const $50364c7681d2ff9d$export$87589ca4d6050188 = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlock: "space.200",
            paddingInline: "space.300",
            xcss: $50364c7681d2ff9d$var$footerBaseStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelFooter"] = $50364c7681d2ff9d$export$87589ca4d6050188;

});

parcelRegister("4WZFP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $72d7920b18bf3596$export$70e0922268f2e08b = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("lBvGi", function(module, exports) {
$parcel$export(module.exports, "default", () => $56c2dc0faf44f7eb$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $kZ5GD = parcelRequire("kZ5GD");

const $56c2dc0faf44f7eb$var$noOptions = [];
function $56c2dc0faf44f7eb$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $56c2dc0faf44f7eb$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $ee7An.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $c0qxy.useId)();
    const [selectedValue, setSelectedValue] = (0, $42omo.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid
    }, options.map(({ ...optionProps }, index)=>{
        if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
        const isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
            ...optionProps,
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            testId: optionProps.testId || testId,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        });
    }));
}

});

parcelRegister("kZ5GD", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");

const $56d63ff022409480$var$packageName = "platform-pkg";
const $56d63ff022409480$var$packageVersion = "0.0.0-use.local";
const $56d63ff022409480$var$noop = (0, $ee7An.default);
const $56d63ff022409480$var$labelPaddingStyles = null;
const $56d63ff022409480$var$labelStyles = null;
const $56d63ff022409480$var$labelDisabledStyles = null;
const $56d63ff022409480$var$radioBaseStyles = null;
const $56d63ff022409480$var$radioInteractiveStyles = null;
const $56d63ff022409480$var$radioDisabledStyles = null;
const $56d63ff022409480$var$radioDisabledCheckedStyles = null;
const $56d63ff022409480$var$radioInvalidStyles = null;
const $56d63ff022409480$var$InnerRadio = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function Radio(props, ref) {
    const $ = (0, $frIzR.c)(47);
    let analyticsContext;
    let ariaLabel;
    let ariaLabelledBy;
    let isRequired;
    let label;
    let labelId;
    let name;
    let rest;
    let t0;
    let t1;
    let t2;
    let t3;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ ariaLabel: ariaLabel, "aria-labelledby": ariaLabelledBy, isDisabled: t0, isRequired: isRequired, isInvalid: t1, isChecked: t2, label: label, labelId: labelId, name: name, onChange: t3, value: value, testId: testId, analyticsContext: analyticsContext, ...rest } = props);
        $[0] = props;
        $[1] = analyticsContext;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = isRequired;
        $[5] = label;
        $[6] = labelId;
        $[7] = name;
        $[8] = rest;
        $[9] = t0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = testId;
        $[14] = value;
    } else {
        analyticsContext = $[1];
        ariaLabel = $[2];
        ariaLabelledBy = $[3];
        isRequired = $[4];
        label = $[5];
        labelId = $[6];
        name = $[7];
        rest = $[8];
        t0 = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        testId = $[13];
        value = $[14];
    }
    const isDisabled = t0 === undefined ? false : t0;
    const isInvalid = t1 === undefined ? false : t1;
    const isChecked = t2 === undefined ? false : t2;
    const onChange = t3 === undefined ? $56d63ff022409480$var$noop : t3;
    let t4;
    if ($[15] !== analyticsContext || $[16] !== onChange) {
        t4 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "radio",
            packageName: $56d63ff022409480$var$packageName,
            packageVersion: $56d63ff022409480$var$packageVersion
        };
        $[15] = analyticsContext;
        $[16] = onChange;
        $[17] = t4;
    } else t4 = $[17];
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)(t4);
    const t5 = testId && `${testId}--radio-label`;
    const t6 = isDisabled ? "true" : undefined;
    const t7 = isDisabled && "_syaz1gmx _80om13gf";
    let t8;
    if ($[18] !== t7) {
        t8 = (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo",
            t7
        ]);
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    const t9 = labelId || ariaLabelledBy;
    const t10 = testId && `${testId}--radio-input`;
    const t11 = isInvalid ? "true" : undefined;
    const t12 = !isDisabled && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r";
    const t13 = isDisabled && "_80om13gf _1q6q187o _1151bk0g _1s6w2sac";
    const t14 = isDisabled && isChecked && "_tqbwt94y";
    const t15 = isInvalid && !isDisabled && "_1151s4qr _11jys4qr";
    let t16;
    if ($[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t15) {
        t16 = (0, $gMc0m.default)([
            "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd",
            t12,
            t13,
            t14,
            t15
        ]);
        $[20] = t12;
        $[21] = t13;
        $[22] = t14;
        $[23] = t15;
        $[24] = t16;
    } else t16 = $[24];
    let t17;
    if ($[25] !== ariaLabel || $[26] !== isChecked || $[27] !== isDisabled || $[28] !== isRequired || $[29] !== name || $[30] !== onChangeAnalytics || $[31] !== ref || $[32] !== rest || $[33] !== t10 || $[34] !== t11 || $[35] !== t16 || $[36] !== t9 || $[37] !== value) {
        t17 = /*#__PURE__*/ $42omo.createElement("input", {
            ...rest,
            tabIndex: 0,
            "aria-label": ariaLabel,
            "aria-labelledby": t9,
            checked: isChecked,
            disabled: isDisabled,
            name: name,
            onChange: onChangeAnalytics,
            required: isRequired,
            type: "radio",
            value: value,
            "data-testid": t10,
            "data-invalid": t11,
            ref: ref,
            className: t16
        });
        $[25] = ariaLabel;
        $[26] = isChecked;
        $[27] = isDisabled;
        $[28] = isRequired;
        $[29] = name;
        $[30] = onChangeAnalytics;
        $[31] = ref;
        $[32] = rest;
        $[33] = t10;
        $[34] = t11;
        $[35] = t16;
        $[36] = t9;
        $[37] = value;
        $[38] = t17;
    } else t17 = $[38];
    let t18;
    if ($[39] !== label) {
        t18 = label ? /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
            ])
        }, label) : null;
        $[39] = label;
        $[40] = t18;
    } else t18 = $[40];
    let t19;
    if ($[41] !== t17 || $[42] !== t18 || $[43] !== t5 || $[44] !== t6 || $[45] !== t8) {
        t19 = /*#__PURE__*/ $42omo.createElement("label", {
            "data-testid": t5,
            "data-disabled": t6,
            className: t8
        }, t17, t18);
        $[41] = t17;
        $[42] = t18;
        $[43] = t5;
        $[44] = t6;
        $[45] = t8;
        $[46] = t19;
    } else t19 = $[46];
    return t19;
} : function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $56d63ff022409480$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $56d63ff022409480$var$packageName,
        packageVersion: $56d63ff022409480$var$packageVersion
    });
    return /*#__PURE__*/ $42omo.createElement("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo",
            isDisabled && "_syaz1gmx _80om13gf"
        ])
    }, /*#__PURE__*/ $42omo.createElement("input", {
        ...rest,
        tabIndex: 0,
        "aria-label": ariaLabel,
        "aria-labelledby": labelId || ariaLabelledBy,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd",
            !isDisabled && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
            isDisabled && "_80om13gf _1q6q187o _1151bk0g _1s6w2sac",
            isDisabled && isChecked && "_tqbwt94y",
            isInvalid && !isDisabled && "_1151s4qr _11jys4qr"
        ])
    }), label ? /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
        ])
    }, label) : null);
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $56d63ff022409480$var$Radio = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function Radio(props, ref) {
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ $42omo.createElement($56d63ff022409480$var$InnerRadio, {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function Radio(props, ref) {
    return /*#__PURE__*/ $42omo.createElement($56d63ff022409480$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $56d63ff022409480$export$2e2bcd8739ae039 = $56d63ff022409480$var$Radio;
module.exports["default"] = $56d63ff022409480$export$2e2bcd8739ae039;

});

parcelRegister("7gpC4", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");


var $9wgn8 = parcelRequire("9wgn8");


var $cVrnQ = parcelRequire("cVrnQ");


var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $frIzR.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $42omo.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $gMc0m.default)([
            $1f9fb6b4b3bc4020$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ $42omo.createElement("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ $42omo.createElement((0, $6MlG5.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ $42omo.createElement((0, $cVrnQ.default), null, label, isRequired && /*#__PURE__*/ $42omo.createElement((0, $hcDON.default), null));
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ $42omo.createElement((0, $9wgn8.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss
        }, t16, t17, t18);
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ $42omo.createElement("input" // It is necessary only for Safari. It allows to render focus styles.
    , {
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        className: (0, $gMc0m.default)([
            $1f9fb6b4b3bc4020$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ $42omo.createElement((0, $6MlG5.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $42omo.createElement((0, $cVrnQ.default), null, label, isRequired && /*#__PURE__*/ $42omo.createElement((0, $hcDON.default), null)));
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = t0;
    let t1;
    if ($[0] !== isChecked || $[1] !== isIndeterminate) {
        t1 = $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked);
        $[0] = isChecked;
        $[1] = isIndeterminate;
        $[2] = t1;
    } else t1 = $[2];
    const icon = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $42omo.createElement("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            className: (0, $gMc0m.default)([
                $71feb0a29953fded$var$svgStyles.rect
            ])
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== icon) {
        t4 = /*#__PURE__*/ $42omo.createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            role: "presentation",
            className: t2
        }, /*#__PURE__*/ $42omo.createElement("g", {
            fillRule: "evenodd"
        }, t3, icon));
        $[5] = icon;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $42omo.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $42omo.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.rect
        ])
    }), icon));
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null;
const $edf27753e59bf881$var$Label = (0, $4pOgL.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $frIzR.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_zulp1nu5 _yv0ey09t";
    const t2 = (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz";
    const t3 = isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2";
    const t4 = isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ $42omo.createElement("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id
        }, children);
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ $42omo.createElement("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
};
var $edf27753e59bf881$export$2e2bcd8739ae039 = $edf27753e59bf881$var$Label;
module.exports["default"] = $edf27753e59bf881$export$2e2bcd8739ae039;

});

parcelRegister("cVrnQ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
const $f0c2060f65a94bd0$var$LabelText = (0, $4pOgL.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $42omo.createElement("span", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
};
var $f0c2060f65a94bd0$export$2e2bcd8739ae039 = $f0c2060f65a94bd0$var$LabelText;
module.exports["default"] = $f0c2060f65a94bd0$export$2e2bcd8739ae039;

});

parcelRegister("hcDON", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
const $a14852587cdb2524$var$RequiredIndicator = (0, $4pOgL.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("span", {
            "aria-hidden": true,
            className: (0, $gMc0m.default)([
                "_syaz1tmw _bozgv77o"
            ])
        }, "*");
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ $42omo.createElement("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
};
var $a14852587cdb2524$export$2e2bcd8739ae039 = $a14852587cdb2524$var$RequiredIndicator;
module.exports["default"] = $a14852587cdb2524$export$2e2bcd8739ae039;

});

parcelRegister("jOUeC", function(module, exports) {

let $e6de4ee6d721d073$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6de4ee6d721d073$var$load("EEHCI").then(()=>parcelRequire('dtJ3H'));

});

parcelRegister("amnPv", function(module, exports) {

let $78ae718ee14a8eb0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78ae718ee14a8eb0$var$load("gABRh").then(()=>parcelRequire('3JgtQ'));

});

parcelRegister("iAxzI", function(module, exports) {

let $d885a21a603d1a46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d885a21a603d1a46$var$load("fAUr9").then(()=>parcelRequire('7EJ9w'));

});

parcelRegister("fFNVl", function(module, exports) {

let $b69169312bf01236$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b69169312bf01236$var$load("h94bv"),
    $b69169312bf01236$var$load("6wr18"),
    $b69169312bf01236$var$load("7QQL7"),
    $b69169312bf01236$var$load("ffEVr"),
    $b69169312bf01236$var$load("4pYLw")
]).then(()=>parcelRequire('i9E8j'));

});

parcelRegister("l40Ef", function(module, exports) {

let $f55a796a6d69688b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f55a796a6d69688b$var$load("evWu5").then(()=>parcelRequire('8foBH'));

});

parcelRegister("6O2BV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f497007dae01ffa$export$25fb473e92ff8332 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PT7yD",
    name: "ClassicEditorContextProviderLoader",
    loader: ()=>(parcelRequire("dJ04D"))
});
module.exports["ClassicEditorContextProviderLoader"] = $4f497007dae01ffa$export$25fb473e92ff8332;

});

parcelRegister("dJ04D", function(module, exports) {

let $9fdf89005fb5ebe2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9fdf89005fb5ebe2$var$load("h3ABO"),
    $9fdf89005fb5ebe2$var$load("2YffH"),
    $9fdf89005fb5ebe2$var$load("2LxnN"),
    $9fdf89005fb5ebe2$var$load("e2ahM"),
    $9fdf89005fb5ebe2$var$load("5Wqrg"),
    $9fdf89005fb5ebe2$var$load("HaNwW"),
    $9fdf89005fb5ebe2$var$load("evm5a"),
    $9fdf89005fb5ebe2$var$load("c6VA1"),
    $9fdf89005fb5ebe2$var$load("2MTmD"),
    $9fdf89005fb5ebe2$var$load("eBRUf"),
    $9fdf89005fb5ebe2$var$load("hOBst"),
    $9fdf89005fb5ebe2$var$load("9ijrN"),
    $9fdf89005fb5ebe2$var$load("bzyKp"),
    $9fdf89005fb5ebe2$var$load("k3yUD"),
    $9fdf89005fb5ebe2$var$load("2RWyc"),
    $9fdf89005fb5ebe2$var$load("8YSo7"),
    $9fdf89005fb5ebe2$var$load("fAtWn"),
    $9fdf89005fb5ebe2$var$load("iPYAE"),
    $9fdf89005fb5ebe2$var$load("36QeB"),
    $9fdf89005fb5ebe2$var$load("cyGuT"),
    $9fdf89005fb5ebe2$var$load("3KVI3"),
    $9fdf89005fb5ebe2$var$load("5lTVp"),
    $9fdf89005fb5ebe2$var$load("lWNY8"),
    $9fdf89005fb5ebe2$var$load("6wr18"),
    $9fdf89005fb5ebe2$var$load("h9S8v"),
    $9fdf89005fb5ebe2$var$load("dZsGY"),
    $9fdf89005fb5ebe2$var$load("jPuvo"),
    $9fdf89005fb5ebe2$var$load("3GuOt"),
    $9fdf89005fb5ebe2$var$load("ffEVr"),
    $9fdf89005fb5ebe2$var$load("hxmLu"),
    $9fdf89005fb5ebe2$var$load("1oUEV"),
    $9fdf89005fb5ebe2$var$load("eIWkK"),
    $9fdf89005fb5ebe2$var$load("a0cZb"),
    $9fdf89005fb5ebe2$var$load("RXMWr"),
    $9fdf89005fb5ebe2$var$load("jLwPS"),
    $9fdf89005fb5ebe2$var$load("9IMTL"),
    $9fdf89005fb5ebe2$var$load("5dBst"),
    $9fdf89005fb5ebe2$var$load("ghNAx"),
    $9fdf89005fb5ebe2$var$load("6GIKD"),
    $9fdf89005fb5ebe2$var$load("2Ws5B"),
    $9fdf89005fb5ebe2$var$load("coUzl"),
    $9fdf89005fb5ebe2$var$load("5nMTY"),
    $9fdf89005fb5ebe2$var$load("7j0mT"),
    $9fdf89005fb5ebe2$var$load("69R9L"),
    $9fdf89005fb5ebe2$var$load("zSp86"),
    $9fdf89005fb5ebe2$var$load("7tgvK"),
    $9fdf89005fb5ebe2$var$load("fRtVQ"),
    $9fdf89005fb5ebe2$var$load("b9CA3"),
    $9fdf89005fb5ebe2$var$load("g0OKa"),
    $9fdf89005fb5ebe2$var$load("Wowvf"),
    $9fdf89005fb5ebe2$var$load("1F7LX"),
    $9fdf89005fb5ebe2$var$load("c6DIp"),
    $9fdf89005fb5ebe2$var$load("dgH7p"),
    $9fdf89005fb5ebe2$var$load("hH53H"),
    $9fdf89005fb5ebe2$var$load("jZLnv"),
    $9fdf89005fb5ebe2$var$load("6edij"),
    $9fdf89005fb5ebe2$var$load("hXbzh"),
    $9fdf89005fb5ebe2$var$load("foAs3"),
    $9fdf89005fb5ebe2$var$load("hhss7"),
    $9fdf89005fb5ebe2$var$load("f2Ovh"),
    $9fdf89005fb5ebe2$var$load("lAHER"),
    $9fdf89005fb5ebe2$var$load("7EorR"),
    $9fdf89005fb5ebe2$var$load("lsb09")
]).then(()=>parcelRequire('gnN3I'));

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("7EX8o", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $2w2Hu = parcelRequire("2w2Hu");


const $1c44eab82f88f298$export$3717da370a5be6bc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NLJVG",
    name: "EmbeddedViewPageLoader",
    loader: async ()=>(await (parcelRequire("9NcAx"))).EmbeddedViewPage,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ViewPageRouteComponentLoader
    ]
});
module.exports["EmbeddedViewPageLoader"] = $1c44eab82f88f298$export$3717da370a5be6bc;

});

parcelRegister("9NcAx", function(module, exports) {

let $7212746df4bda375$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7212746df4bda375$var$load("3EXzu"),
    $7212746df4bda375$var$load("3g3jg"),
    $7212746df4bda375$var$load("lHi37"),
    $7212746df4bda375$var$load("fBVt2"),
    $7212746df4bda375$var$load("5gRHV"),
    $7212746df4bda375$var$load("d62hC"),
    $7212746df4bda375$var$load("jPzkK"),
    $7212746df4bda375$var$load("cIKpa"),
    $7212746df4bda375$var$load("bNW8r"),
    $7212746df4bda375$var$load("94gN4"),
    $7212746df4bda375$var$load("jDHDy"),
    $7212746df4bda375$var$load("cJsay"),
    $7212746df4bda375$var$load("8LtYa"),
    $7212746df4bda375$var$load("dlm6q"),
    $7212746df4bda375$var$load("4oONP"),
    $7212746df4bda375$var$load("dtpmo"),
    $7212746df4bda375$var$load("2F69B"),
    $7212746df4bda375$var$load("1GCFv"),
    $7212746df4bda375$var$load("5dkX4"),
    $7212746df4bda375$var$load("el56J"),
    $7212746df4bda375$var$load("9lUu8"),
    $7212746df4bda375$var$load("e2WH6"),
    $7212746df4bda375$var$load("5vzT0"),
    $7212746df4bda375$var$load("coUzl"),
    $7212746df4bda375$var$load("5nMTY"),
    $7212746df4bda375$var$load("7j0mT"),
    $7212746df4bda375$var$load("69R9L"),
    $7212746df4bda375$var$load("hXbzh"),
    $7212746df4bda375$var$load("6wr18"),
    $7212746df4bda375$var$load("dwSiO"),
    $7212746df4bda375$var$load("evP3v"),
    $7212746df4bda375$var$load("HaNwW"),
    $7212746df4bda375$var$load("cmqxT"),
    $7212746df4bda375$var$load("ZBVfs"),
    $7212746df4bda375$var$load("4oXMS"),
    $7212746df4bda375$var$load("67Alm"),
    $7212746df4bda375$var$load("2B2rM"),
    $7212746df4bda375$var$load("9anPW"),
    $7212746df4bda375$var$load("cyGuT"),
    $7212746df4bda375$var$load("9DBoM"),
    $7212746df4bda375$var$load("jPuvo"),
    $7212746df4bda375$var$load("ffEVr"),
    $7212746df4bda375$var$load("zSp86"),
    $7212746df4bda375$var$load("Wowvf"),
    $7212746df4bda375$var$load("1F7LX"),
    $7212746df4bda375$var$load("foAs3"),
    $7212746df4bda375$var$load("hhss7"),
    $7212746df4bda375$var$load("7EorR"),
    $7212746df4bda375$var$load("1gUNx"),
    $7212746df4bda375$var$load("eiF7i"),
    $7212746df4bda375$var$load("h94bv"),
    $7212746df4bda375$var$load("WXYxI")
]).then(()=>parcelRequire('6N2H2'));

});

parcelRegister("4H46k", function(module, exports) {
// These exports are using the .default prop of the module because we're mixing ES6 and ES5. This is required for
// webpack to be able to correctly split bundles.

var $jmjWc = parcelRequire("jmjWc");


const $36ae5bfcf92491af$export$2f32c75fff716fcc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b7m6n",
    name: "LazySpaceBlogRedirect",
    loader: async ()=>(await (parcelRequire("c29Ia"))).SpaceBlogRedirect
});

const $36ae5bfcf92491af$export$5590c410e7d0a293 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LfHUf",
    name: "LazySpaceCreatePage",
    loader: ()=>(parcelRequire("eVmUs"))
});

const $36ae5bfcf92491af$export$e650af616d3a92cf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Z1eTA",
    name: "LazyMobileWebContainer",
    loader: ()=>(parcelRequire("a57MR"))
});

const $36ae5bfcf92491af$export$dcf40c4d983a3b1f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TnNDX",
    name: "LazyDwellTime",
    loader: ()=>(parcelRequire("djVjJ"))
});

const $36ae5bfcf92491af$export$a804be9097757ef8 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "GCYkT",
    name: "LazyConsumptionViewedAndCompletedEventTracker",
    loader: async ()=>(await (parcelRequire("ipPBg"))).ConsumptionViewedAndCompletedEventTracker
});

const $36ae5bfcf92491af$export$33256e23669f7955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AaHry",
    name: "LazyConfluenceNotFound",
    loader: ()=>(parcelRequire("eQZPX"))
});
module.exports["LazySpaceBlogRedirect"] = $36ae5bfcf92491af$export$2f32c75fff716fcc;
module.exports["LazySpaceCreatePage"] = $36ae5bfcf92491af$export$5590c410e7d0a293;
module.exports["LazyMobileWebContainer"] = $36ae5bfcf92491af$export$e650af616d3a92cf;
module.exports["LazyDwellTime"] = $36ae5bfcf92491af$export$dcf40c4d983a3b1f;
module.exports["LazyConsumptionViewedAndCompletedEventTracker"] = $36ae5bfcf92491af$export$a804be9097757ef8;
module.exports["LazyConfluenceNotFound"] = $36ae5bfcf92491af$export$33256e23669f7955;

});

parcelRegister("c29Ia", function(module, exports) {

let $8c2d346fe517694f$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("kzRPH"), 5)),
    $8c2d346fe517694f$var$load("gaXhw")
]).then(()=>parcelRequire('4bW1i'));

});

parcelRegister("alui6", function(module, exports) {
"use strict";

var $h4lNe = parcelRequire("h4lNe");

module.exports = $h4lNe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("h4lNe", function(module, exports) {
"use strict";
let $c6d3b70899d3a8aa$var$cachedBundles = {};
let $c6d3b70899d3a8aa$var$cachedPreloads = {};
let $c6d3b70899d3a8aa$var$cachedPrefetches = {};
function $c6d3b70899d3a8aa$var$getCache(type) {
    switch(type){
        case 'preload':
            return $c6d3b70899d3a8aa$var$cachedPreloads;
        case 'prefetch':
            return $c6d3b70899d3a8aa$var$cachedPrefetches;
        default:
            return $c6d3b70899d3a8aa$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $c6d3b70899d3a8aa$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("eVmUs", function(module, exports) {

let $add828ed1181df33$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $add828ed1181df33$var$load("h94bv"),
    $add828ed1181df33$var$load("a0cZb"),
    $add828ed1181df33$var$load("RXMWr"),
    $add828ed1181df33$var$load("2YffH"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("meCbt"), 5)),
    $add828ed1181df33$var$load("ddsSQ"),
    $add828ed1181df33$var$load("2LxnN"),
    $add828ed1181df33$var$load("e2ahM"),
    $add828ed1181df33$var$load("e1cuZ"),
    $add828ed1181df33$var$load("5Wqrg"),
    $add828ed1181df33$var$load("4JAC8"),
    $add828ed1181df33$var$load("evm5a"),
    $add828ed1181df33$var$load("c6VA1"),
    $add828ed1181df33$var$load("2MTmD"),
    $add828ed1181df33$var$load("eBRUf"),
    $add828ed1181df33$var$load("hOBst"),
    $add828ed1181df33$var$load("4xzkC"),
    $add828ed1181df33$var$load("7EorR"),
    $add828ed1181df33$var$load("bzyKp"),
    $add828ed1181df33$var$load("k3yUD"),
    $add828ed1181df33$var$load("2RWyc"),
    $add828ed1181df33$var$load("2F69B"),
    $add828ed1181df33$var$load("1GCFv"),
    $add828ed1181df33$var$load("hUmZG"),
    $add828ed1181df33$var$load("kHDuB"),
    $add828ed1181df33$var$load("hhss7"),
    $add828ed1181df33$var$load("6SWFK"),
    $add828ed1181df33$var$load("5zapo"),
    $add828ed1181df33$var$load("3MYQs"),
    $add828ed1181df33$var$load("6wr18"),
    $add828ed1181df33$var$load("9atVd"),
    $add828ed1181df33$var$load("ffEVr"),
    $add828ed1181df33$var$load("el56J"),
    $add828ed1181df33$var$load("kOWvR"),
    $add828ed1181df33$var$load("Wowvf"),
    $add828ed1181df33$var$load("hxmLu"),
    $add828ed1181df33$var$load("1oUEV"),
    $add828ed1181df33$var$load("eIWkK"),
    $add828ed1181df33$var$load("jLwPS"),
    $add828ed1181df33$var$load("9IMTL"),
    $add828ed1181df33$var$load("6GIKD"),
    $add828ed1181df33$var$load("2Ws5B"),
    $add828ed1181df33$var$load("coUzl"),
    $add828ed1181df33$var$load("5nMTY"),
    $add828ed1181df33$var$load("7tgvK"),
    $add828ed1181df33$var$load("fRtVQ"),
    $add828ed1181df33$var$load("b9CA3"),
    $add828ed1181df33$var$load("hH53H"),
    $add828ed1181df33$var$load("f2Ovh"),
    $add828ed1181df33$var$load("lAHER"),
    $add828ed1181df33$var$load("6UKHF")
]).then(()=>parcelRequire('lJvEZ'));

});

parcelRegister("a57MR", function(module, exports) {

let $7570695a0f125b86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7570695a0f125b86$var$load("kOWvR"),
    $7570695a0f125b86$var$load("4D7T2")
]).then(()=>parcelRequire('1x5LM'));

});

parcelRegister("djVjJ", function(module, exports) {

let $9b2982b618f8cf76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9b2982b618f8cf76$var$load("9HjYv").then(()=>parcelRequire('7SYCP'));

});

parcelRegister("ipPBg", function(module, exports) {

let $d682967ebe3fde01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d682967ebe3fde01$var$load("f2uDI").then(()=>parcelRequire('3deqg'));

});

parcelRegister("eQZPX", function(module, exports) {

let $ad05e39509ec3e59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ad05e39509ec3e59$var$load("kOWvR").then(()=>parcelRequire('4uiGD'));

});

parcelRegister("9pOEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9jl6v = parcelRequire("9jl6v");

const $1adfb96e71037064$export$1d04f0e8aa57d594 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9jl6v.InlineCommentsProvider), null, children);
};
module.exports["CommentContextWrapper"] = $1adfb96e71037064$export$1d04f0e8aa57d594;

});

parcelRegister("9jl6v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $42omo = parcelRequire("42omo");


var $ag6aQ = parcelRequire("ag6aQ");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $9wGTI = parcelRequire("9wGTI");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $42omo.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $42omo.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $42omo.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $42omo.useState)('userHighlight');
    /**
   * We eventually want this value to be the official state for loading/displaying
   * the UI for inline comments. InlineCommentSidebar and some child components have created
   * stateful logic (active highlight, isSidebarShown, etc) that assumes
   * the code is always loaded which we will eventually adjust.
   */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $42omo.useState)(false);
    const firstHighlightClicked = (0, $42omo.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $42omo.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $42omo.useState)(null);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $42omo.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
       * Creating a comment is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
       * Clicking on a highlight is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, getCommentIndex: getCommentIndex, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (isNavigateToNextUnread) {
                        // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                        const nextIndex = currentCommentIndex + 1;
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = document.getElementById(nextThreadKey) || ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? document.getElementById(`footer-comment-thread-${nextThreadKey}-container`) : null);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                const enableOnArrowNavigation = !triggeredByKeyboardShortcut;
                // Handle scrolling navigation
                if (enableOnArrowNavigation) (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                    previousMarkerRef: currentThreadKey,
                    nextMarkerRef: nextThreadKey,
                    context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER,
                    action: action,
                    nextCommentIndex: nextCommentIndex,
                    totalComments: unresolvedInlineComments.length
                });
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $ag6aQ.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
} : ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
} : ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("aHcFH", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $cD1qu = parcelRequire("cD1qu");


var $i49vP = parcelRequire("i49vP");

const $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7 = 'inline-create-comment-selection';
const $a78c261c3211f7d6$export$b803c692fbaaa5a4 = 'inline-highlight';
const $a78c261c3211f7d6$export$fb3d0eebfe85522a = 'active-highlight';
const $a78c261c3211f7d6$export$b899b07e3f725968 = ()=>{
    const commentData = {
        commentIndex: undefined,
        totalComments: undefined
    };
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) {
        commentData['commentIndex'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position']);
        commentData['totalComments'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments']);
    }
    return commentData;
};
const $a78c261c3211f7d6$export$1f7acceb752add79 = (pageMode)=>{
    const marks = Array.from(document.querySelectorAll($a78c261c3211f7d6$export$8c7b048437c01388(pageMode))).map((node)=>{
        if (pageMode === 'edit') return node.id;
        else return $a78c261c3211f7d6$export$8f4213b45c05ab5d(node);
    });
    /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
  duplicates in that case so we can navigate between comments correctly */ return new Set(marks);
};
const $a78c261c3211f7d6$export$9b48c18cc387f791 = (markerRefList, pageMode = 'view')=>{
    const distinctMarks = [
        ...$a78c261c3211f7d6$export$1f7acceb752add79(pageMode)
    ];
    return distinctMarks.filter((mark)=>mark && markerRefList.includes(mark));
};
const $a78c261c3211f7d6$export$8c7b048437c01388 = (pageMode = 'view')=>{
    if (pageMode === 'edit') return "[annotationtype='inlineComment']";
    else return '[data-mark-annotation-type="inlineComment"], .inline-comment-marker';
};
const $a78c261c3211f7d6$export$f7ceeb7ba8156450 = ()=>{
    const activeHighlights = document.querySelectorAll(`.${$a78c261c3211f7d6$export$fb3d0eebfe85522a}`);
    activeHighlights.forEach((activeHighlight)=>{
        activeHighlight.classList.remove($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    });
};
const $a78c261c3211f7d6$var$getNextTextNodeOld = (node, boundingParentNode)=>{
    let currentNode = node;
    let nextTextNode = currentNode?.nextSibling;
    // If the node has no next sibling, grab it's parent's next sibling until we find a node
    while(!nextTextNode){
        nextTextNode = currentNode?.parentElement?.nextSibling;
        if (nextTextNode) {
            // WS-2551 - If the bounding parent exists and we're out of bounds of it, we're done looking
            if (boundingParentNode && !boundingParentNode.contains(nextTextNode)) {
                nextTextNode = null;
                break;
            }
            // If we've landed on a text node, then break out
            if (nextTextNode.nodeType === Node.TEXT_NODE) break;
            // If the node exists and it's a hard break (<br />), we do one of two things:
            //   1. If it has a bounding parent, break out because the <br /> signifies the end of the selection
            //   2. If not, then move to the next sibling because we don't count hard breaks in selections
            if (nextTextNode?.tagName === 'BR') {
                if (boundingParentNode) break;
                else nextTextNode = nextTextNode.nextSibling;
            }
        } else // If the text node we tried to access is null, we need to jump up a generation
        currentNode = currentNode?.parentNode;
    }
    // Search for the first text node in the next node
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE)nextTextNode = nextTextNode.firstChild;
    return nextTextNode;
};
const $a78c261c3211f7d6$export$3e98291f1f032a77 = (currentNode, boundingNode, isInlineMark)=>{
    let nextTextNode = isInlineMark ? currentNode : currentNode?.nextSibling;
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE){
        // If the text node is the bounding node, return that node
        if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return nextTextNode;
        // Check if the node is a hard break (<br />) or an element with role="presentation" we do one of two things:
        if (nextTextNode?.tagName === 'BR') {
            // If it has a bounding parent, break out because the <br /> signifies the end of the selection
            if (boundingNode) return nextTextNode;
            // If not, then move to the next sibling because we don't count hard breaks in selections
            nextTextNode = nextTextNode.nextSibling;
        } else if (nextTextNode?.attributes?.getNamedItem('role')?.value === 'presentation') // If the element has role="presentation", move to the parent element's sibling because this current node does not contain a text node
        nextTextNode = nextTextNode.parentNode?.nextSibling;
        else if ($a78c261c3211f7d6$var$isEmojiNode(nextTextNode)) {
            // If we encounter an emoji and it's also the bounding node, return nothing
            if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return null;
            // Otherwise, just return the node after it and keep going
            nextTextNode = nextTextNode.nextSibling;
        } else // Otherwise, search for the first text node in the next node
        nextTextNode = nextTextNode.firstChild;
    }
    // If we've found the text node, return that node
    if (nextTextNode?.nodeType === Node.TEXT_NODE) return nextTextNode;
    // If the text node we tried to access is null, we need to jump up a generation
    if (!nextTextNode) return $a78c261c3211f7d6$export$3e98291f1f032a77(currentNode?.parentNode, boundingNode);
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // WS-2551 - Triple clicks are the only thing that can cause the endContainer to be a non-text node
    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    if (!startContainer.isSameNode(endContainer)) {
        let boundingParentNode;
        // Push the starting node into a range
        const startingRange = new Range();
        startingRange.setStart(startContainer, startOffset);
        startingRange.setEnd(startContainer, startContainer.length);
        rangesToHighlight.push(startingRange);
        // WS-2551 - In the case of a triple click, we only want to contain our selection to the
        // first non-comment parent wrapping the starting container to ensure we don't over select
        if (isTripleClick) {
            boundingParentNode = startContainer.parentNode;
            while(!boundingParentNode || boundingParentNode.nodeType === Node.TEXT_NODE || $a78c261c3211f7d6$export$8f4213b45c05ab5d(boundingParentNode) !== null)boundingParentNode = boundingParentNode?.parentNode;
        } else {
            // Push the ending node into a range only if it's not a triple click
            const endingRange = new Range();
            endingRange.setStart(endContainer, 0);
            endingRange.setEnd(endContainer, endOffset);
            rangesToHighlight.push(endingRange);
        }
        // Iterate through all the inner nodes and extract the text ranges
        let node = $a78c261c3211f7d6$var$getNextTextNodeOld(startContainer, boundingParentNode);
        while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
            if (node.length) {
                const range = new Range();
                range.selectNodeContents(node);
                rangesToHighlight.push(range);
            }
            node = $a78c261c3211f7d6$var$getNextTextNodeOld(node, boundingParentNode);
        }
    } else // If they are the same container it's much simpler and we can just use the range
    rangesToHighlight.push(selectedRange);
    return rangesToHighlight;
};
const $a78c261c3211f7d6$var$isEmojiNode = (node)=>{
    if (!node) return false;
    const attributes = node?.attributes;
    const classList = node?.classList;
    return attributes && attributes.getNamedItem('data-emoji-id') || classList && classList.contains('emoji-common-node');
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRanges = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // The endContainer is a non-text node when the user either:
    // 1. Triple clicks a node
    // 2. Highlights a header
    // 3. The highlight goes to the next node but does not actually highlight anything (offset === 0)
    const isNonTextNodeEndContainer = endContainer.nodeType !== Node.TEXT_NODE;
    // If highlight is just one node (i.e. same containers), it's much simpler and we can just use the range
    if (startContainer.isSameNode(endContainer)) {
        rangesToHighlight.push(selectedRange);
        return rangesToHighlight;
    }
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    let boundingNode;
    // Push the starting node into a range
    const startingRange = new Range();
    startingRange.setStart(startContainer, startOffset);
    startingRange.setEnd(startContainer, startContainer.length);
    rangesToHighlight.push(startingRange);
    // In the case of a non-text node endContainer, we want to set a bounding node to the endContainer so we know
    // to stop traversing the DOM when hidding that bounding node
    if (isNonTextNodeEndContainer) {
        // If the end container is non-text and an emoji, we need to jump up a level or else it is
        // going to be bound to a node that we will never be able to check and thus never exit
        if ($a78c261c3211f7d6$var$isEmojiNode(endContainer)) boundingNode = endContainer.parentNode;
        else boundingNode = endContainer;
    } else {
        // Push the ending node into a range
        const endingRange = new Range();
        endingRange.setStart(endContainer, 0);
        endingRange.setEnd(endContainer, endOffset);
        rangesToHighlight.push(endingRange);
    }
    // Get the first "inner" node between the start and end containers
    let node = $a78c261c3211f7d6$export$3e98291f1f032a77(startContainer, boundingNode);
    // Iterate through all the inner nodes and extract the text ranges
    while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
        if (node.length) {
            const range = new Range();
            range.selectNodeContents(node);
            rangesToHighlight.push(range);
        }
        node = $a78c261c3211f7d6$export$3e98291f1f032a77(node, boundingNode);
    }
    return rangesToHighlight;
};
const $a78c261c3211f7d6$export$739c145b6a07c076 = (isFabricPage, isCreateDialogOpen = false, markerRef = '')=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    let markOffsetTop = 0;
    // Measure the offset of the highlight from the renderer wrapper
    // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    if (markerRef) {
        const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(highlight);
    } else {
        const selection = window.getSelection();
        // If there is a user selection, we need to create a new temp "highlight" for this
        // new selection as it is removed when the temp "highlight" is created
        const isNewSelection = selection && selection.type == 'Range' && !isCreateDialogOpen;
        if (isNewSelection) {
            // Reset any existing DOM selections
            $a78c261c3211f7d6$export$743373b19993e2b0();
            // Mark the selection in the DOM temporarily
            $a78c261c3211f7d6$export$4147ba71ff179432(false);
        }
        const createCommentHighlight = document.querySelector(`.${highlightClass}`);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(createCommentHighlight);
    }
    // On a fabric page, the highlight is positioned relative to the renderer
    // wrapper. To correctly position the sidebar we need to measure the offset
    // of the renderer wrapper and the offset of the highlight from the wrapper
    if (isFabricPage) {
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper');
        if (rendererWrapper) markOffsetTop += rendererWrapper.offsetTop;
    } else {
        // In tiny, we need to remove the title and author info offset to position it correctly
        const pageMetadata = document.querySelector('#content-body .page-metadata-modification-info');
        if (pageMetadata) markOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
    }
    return markOffsetTop;
};
const $a78c261c3211f7d6$export$4147ba71ff179432 = (useNewHighlightLogic)=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    const selection = window.getSelection();
    if (!selection || selection.type !== 'Range') // Throw error?
    return;
    // Extract the range
    const selectedRange = selection.getRangeAt(0);
    // Get an array of the ranges to make highlights
    const rangesToHighlight = useNewHighlightLogic ? $a78c261c3211f7d6$var$extractTextNodesIntoRanges(selectedRange) : $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld(selectedRange);
    rangesToHighlight.forEach((range)=>{
        // Create a new wrapper element with the correct class
        const highlightWrapper = document.createElement('span');
        highlightWrapper.classList.add(highlightClass);
        // Extract the contents of the range and add it to the new wrapper
        highlightWrapper.appendChild(range.extractContents());
        // Re-insert the wrapper back into the range
        range.insertNode(highlightWrapper);
    });
    // Clear the selection
    selection.removeAllRanges();
};
const $a78c261c3211f7d6$var$unwrapTextNodes = (wrappedNodes)=>{
    while(wrappedNodes.length){
        const node = wrappedNodes.shift();
        if (!node) return;
        const { parentNode: parentNode } = node;
        // Extract the text contents of the selection node out of the temp wrapper
        while(node.firstChild)parentNode?.insertBefore(node.firstChild, node);
        // After the text has been extracted, delete the wrapper
        parentNode?.removeChild(node);
        // Normalize the parent to fix any text node fragmentation
        parentNode?.normalize();
    }
};
const $a78c261c3211f7d6$export$743373b19993e2b0 = ()=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    // Grab all the newly created selection nodes
    const tempSelectionNodes = Array.from(document.querySelectorAll(`.${highlightClass}`));
    $a78c261c3211f7d6$var$unwrapTextNodes(tempSelectionNodes);
};
const $a78c261c3211f7d6$export$a160a5110cbadcb8 = (isFabricPage, markerRef, isActive = true)=>{
    const createCommentSelectionNodes = document.querySelectorAll(`.${$a78c261c3211f7d6$export$d2bdbdaa2c26e7f7}`);
    const ref = markerRef || '';
    // If we find selection nodes in the DOM, we need to add some attributes to them,
    // based on the page type, so they behave correctly when the user clicks a highlight
    if (createCommentSelectionNodes.length) createCommentSelectionNodes.forEach((selectionNode)=>{
        if (isFabricPage) {
            selectionNode.setAttribute($a78c261c3211f7d6$export$98471574bfa5228e, ref);
            selectionNode.setAttribute('data-mark-annotation-type', 'inlineComment');
        } else {
            selectionNode.setAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832, ref);
            selectionNode.classList.add('inline-comment-marker');
        }
        const classesToAdd = [
            $a78c261c3211f7d6$export$b803c692fbaaa5a4
        ];
        if (isActive) classesToAdd.push($a78c261c3211f7d6$export$fb3d0eebfe85522a);
        // Add the classes needed
        selectionNode.classList.add(...classesToAdd);
        // Finally, remove the selection class to make it a full mark
        selectionNode.classList.remove($a78c261c3211f7d6$export$d2bdbdaa2c26e7f7);
    });
};
const $a78c261c3211f7d6$var$setHighlightsAsActive = (highlightElement, skipClassCheck = false)=>{
    if (skipClassCheck || highlightElement.classList.contains($a78c261c3211f7d6$export$b803c692fbaaa5a4)) highlightElement.classList.add($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    // We need to set all the children of this highlight to active as well
    const { children: children } = highlightElement;
    for(let i = 0; i < children.length; ++i)$a78c261c3211f7d6$var$setHighlightsAsActive(children[i], skipClassCheck);
};
const $a78c261c3211f7d6$export$fd55463aeed84830 = (markerRef, skipClassCheck = false)=>{
    const highlightMarks = $a78c261c3211f7d6$export$6dfccc77fe608546(markerRef) || [];
    highlightMarks.forEach((highlight)=>$a78c261c3211f7d6$var$setHighlightsAsActive(highlight, skipClassCheck));
};
const $a78c261c3211f7d6$export$280edc47a64130be = (markerRef)=>{
    const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef || '');
    return Boolean(highlight && highlight.classList.contains($a78c261c3211f7d6$export$fb3d0eebfe85522a));
};
const $a78c261c3211f7d6$export$a26c4eafef12029f = (markerRef)=>{
    const highlightMarksToRemove = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    $a78c261c3211f7d6$var$unwrapTextNodes(highlightMarksToRemove);
    $a78c261c3211f7d6$export$f7ceeb7ba8156450();
};
const $a78c261c3211f7d6$export$a0939f064b367798 = ()=>{
    const highlightedAnnotations = Array.from(document.querySelectorAll('.ak-editor-annotation-blur, .ak-editor-annotation-focus'));
    const highlightedAnnotationIds = highlightedAnnotations.map((annotation)=>annotation?.closest('.annotationView-content-wrap')?.id).filter((id)=>Boolean(id));
    return new Set(highlightedAnnotationIds);
};
const $a78c261c3211f7d6$export$98471574bfa5228e = 'data-id';
const $a78c261c3211f7d6$export$90ee95b6cd79c832 = 'data-ref';
const $a78c261c3211f7d6$var$hasAdfContent = (input)=>{
    const content = input && input.content;
    return content && content.some($a78c261c3211f7d6$var$validateContent);
};
// Check to make sure if we have item.type as paragraph content is not empty (user did not type anything)
// or user has put in blank spaces(empty string) and clicked save
// Any type other than paragraph is valid (e.g:- when user inserts divider, status etc without content)
const $a78c261c3211f7d6$var$validateContent = (item)=>item.type !== 'paragraph' || $a78c261c3211f7d6$var$validateParagraph(item);
const $a78c261c3211f7d6$var$validateParagraph = (item)=>{
    if (item.content) return item.content.some($a78c261c3211f7d6$var$isParagraphNotEmpty);
    return false;
};
const $a78c261c3211f7d6$var$isParagraphNotEmpty = (item)=>item.type !== 'text' || item.text.trim() !== '';
const $a78c261c3211f7d6$export$915f03d46d87bfd4 = (adf)=>!adf || !$a78c261c3211f7d6$var$hasAdfContent(adf);
const $a78c261c3211f7d6$export$d204c0ea9b3f0d7d = (isFabricPage)=>isFabricPage ? $a78c261c3211f7d6$export$98471574bfa5228e : $a78c261c3211f7d6$export$90ee95b6cd79c832;
const $a78c261c3211f7d6$export$8f4213b45c05ab5d = (element)=>{
    let markerRef = null;
    if (element) {
        markerRef = element.getAttribute($a78c261c3211f7d6$export$98471574bfa5228e);
        if (!markerRef) markerRef = element.getAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832);
    }
    return markerRef;
};
const $a78c261c3211f7d6$export$21445ab787d3b446 = (markerRef, additionalQueryScope = '')=>{
    if (!markerRef) return null;
    // We need to allow for additional query scope to be added to specify particular markerRef comments
    return document.querySelector(`${additionalQueryScope} [${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], ${additionalQueryScope} [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6dfccc77fe608546 = (markerRef)=>{
    return document.querySelectorAll(`[${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$var$isHighlightCandidateVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(element);
    return element.isConnected && computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden' && element.getAttribute('aria-hidden') !== 'true' && (rect.width > 0 || rect.height > 0);
};
const $a78c261c3211f7d6$export$c36aa9f15eddb765 = (markerRef)=>{
    if (!markerRef) return null;
    const allHighlights = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    const visibleHighlight = allHighlights.find((element)=>$a78c261c3211f7d6$var$isHighlightCandidateVisible(element));
    return visibleHighlight || $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
};
const $a78c261c3211f7d6$export$6d23af9d8c2844b1 = [
    'enter',
    'escape'
];
const $a78c261c3211f7d6$var$getDimensions = ()=>{
    try {
        const nav4ScrollParent = document.getElementById('AkMainContent');
        const currentPageOffset = !!nav4ScrollParent ? nav4ScrollParent.scrollTop : window.scrollY || (window.top?.scrollY ?? 0);
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: currentPageOffset
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET = 350;
const $a78c261c3211f7d6$export$858fd2398afb28e4 = (commentElement, useInstantScroll = false, isAbove = false)=>{
    if (!commentElement) return;
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = $a78c261c3211f7d6$var$getDimensions();
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    // If the position of the comment box is more than halfway down the screen, reposition it to the center
    if (offset <= currentPageOffset || offset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = currentWindowHeight / 5;
        window.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$b451b837f5309ae9 = ({ commentId: commentId, targetCommentId: targetCommentId, isEditor: isEditor, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (commentId !== targetCommentId) return;
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (isEditor && commentElement) (0, $i49vP.scrollToElementInEditor)({
        targetElement: commentElement,
        viewingRoomOffset: viewingRoomOffset
    });
    else $a78c261c3211f7d6$export$fc9b5eebad60b835({
        element: commentElement,
        viewingRoomOffset: viewingRoomOffset,
        useInstantScroll: useInstantScroll
    });
};
const $a78c261c3211f7d6$export$e5d4e097ce63febc = ({ commentElement: commentElement, scrollRootElement: scrollRootElement, currentPageOffset: currentPageOffset, currentWindowHeight: currentWindowHeight, isAbove: isAbove, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll })=>{
    if (!commentElement) return;
    // We may be in an iframe so use window.top
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    const rendererOffset = document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
    // If the position of the highlight is more than halfway down the screen, reposition it to the center
    if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
        scrollRootElement.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$82eb6662255613e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, commentThreadContainerId: commentThreadContainerId, isCommentsPanel: isCommentsPanel })=>{
    if (!commentElement) return;
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext();
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    const behavior = useInstantScroll ? 'instant' : 'smooth';
    if (isCommentsPanel) {
        const element = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
        const commentThreadParentElement = element.getBoundingClientRect().top;
        const commentThreadSelector = document.querySelector(`[data-testid='comments-panel-list-container']`);
        const inlineCommentPosition = element?.getBoundingClientRect();
        const documentContent = document.getElementById('content');
        const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
        const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && Math.floor(inlineCommentPosition.top) < Math.floor(documentContentTopPosition);
        const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        /**
     * Determine which panel or section needs to be scrolled:
     * the content area or the comments panel.
     * We need to find out if the highlight or panel is above or below the viewport.
     * This will help us decide which one to scroll.
     */ if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) // if the comment highlight is above or below viewport use content area to scroll;
        scrollRootElement.scrollBy({
            top: window.innerHeight - commentThreadParentElement - (window.innerHeight - targetCommentHighlight.top),
            behavior: behavior
        });
        else if (commentThreadSelector && (commentAboveViewport || commentBelowViewport || window.innerHeight - commentThreadParentElement - (window.innerHeight - targetCommentHighlight.top) < 0)) // if the comment thread is above or below viewport or
        // there is difference in top of comment thread and highlight if completely visible in the viewport
        //  use commentThreadSelector as an element to scroll ;
        commentThreadSelector.scrollBy({
            top: window.innerHeight - targetCommentHighlight.top - (window.innerHeight - commentThreadParentElement),
            behavior: behavior
        });
        else scrollRootElement.scrollBy({
            top: targetCommentHighlight.top - commentThreadParentElement,
            behavior: behavior
        });
    } else {
        // We may be in an iframe so use window.top
        const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
        const rendererOffset = document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
        // If the position of the highlight is more than halfway down the screen, reposition it to the center
        if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
            const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
            scrollRootElement.scrollTo({
                top: offset - windowOffset,
                behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
            });
        }
    //If comment is in expand, open respective expand
    }
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$c7436bd0a15f3e7e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, commentThreadAnnotationId: commentThreadAnnotationId, isCommentsPanel: isCommentsPanel })=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        const commentThreadContainerId = `comment-thread-${commentThreadAnnotationId}-container`;
        $a78c261c3211f7d6$export$82eb6662255613e({
            commentElement: commentElement,
            isFabricPage: isFabricPage,
            useInstantScroll: useInstantScroll,
            isAbove: isAbove,
            commentThreadContainerId: commentThreadContainerId,
            isCommentsPanel: isCommentsPanel
        });
        return;
    }
    if (!commentElement) return;
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext();
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    if (isCommentsPanel) {
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        // Scroll the highlight into view in the main content body
        if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) $a78c261c3211f7d6$export$e5d4e097ce63febc({
            commentElement: commentElement,
            scrollRootElement: scrollRootElement,
            currentPageOffset: currentPageOffset,
            currentWindowHeight: currentWindowHeight,
            isAbove: isAbove,
            isFabricPage: !!isFabricPage,
            useInstantScroll: useInstantScroll
        });
    } else $a78c261c3211f7d6$export$e5d4e097ce63febc({
        commentElement: commentElement,
        scrollRootElement: scrollRootElement,
        currentPageOffset: currentPageOffset,
        currentWindowHeight: currentWindowHeight,
        isAbove: isAbove,
        isFabricPage: !!isFabricPage,
        useInstantScroll: useInstantScroll
    });
    //If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$66b4d1e3b6633573 = (target, scrollContainer)=>{
    const rect = target.getBoundingClientRect();
    const parentRect = scrollContainer.getBoundingClientRect();
    let moveY = 0;
    // The distance (in pixels) between the target and the end of the visible viewport at which point,
    // when scrolling the target into view, scrolling takes place.
    const SCROLL_THRESHOLD = 60;
    // The extra space (in pixels) that is left above or below the target when it is scrolled into view.
    const SCROLL_MARGIN = 120;
    // Note: visible area of the container refers to parentRect.top/bottom +/- SCROLL_THRESHOLD
    if (rect.top < parentRect.top + SCROLL_THRESHOLD) // If the target is above the top of the visible area of the container, moveY should be negative to bring target down into view
    moveY = -(parentRect.top - rect.top + SCROLL_MARGIN);
    else if (rect.bottom > parentRect.bottom - SCROLL_THRESHOLD) // If the target's bottom is below the bottom of the visible area of the container, move Y should be positive to bring target up into view
    moveY = rect.bottom - parentRect.bottom + SCROLL_MARGIN;
    if (moveY) scrollContainer.scrollTop += moveY;
};
const $a78c261c3211f7d6$export$fb40c5e75b82df8 = (isEditor, isViewCommentMode)=>{
    if (isEditor && isViewCommentMode) return 'editor-comments-sidebar';
    else if (isEditor && !isViewCommentMode) return 'editor-create-sidebar';
    else if (!isEditor && isViewCommentMode) return 'renderer-comments-sidebar';
    else return 'renderer-create-sidebar';
};
const $a78c261c3211f7d6$export$59a770a0e59b0dd2 = (container)=>{
    const selector = [
        'button:not([disabled])',
        'a[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[contenteditable="true"]',
        '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    return Array.from(container.querySelectorAll(selector)).filter((element)=>!element.hasAttribute('disabled') && element.getAttribute('aria-hidden') !== 'true');
};
const $a78c261c3211f7d6$export$642e21ba866d02df = (container, element)=>{
    if (!element) return false;
    return $a78c261c3211f7d6$export$59a770a0e59b0dd2(container)[0] === element;
};
const $a78c261c3211f7d6$export$876aeb5dffd449af = (container, element)=>{
    if (!element) return false;
    const tabbableElements = $a78c261c3211f7d6$export$59a770a0e59b0dd2(container);
    return tabbableElements[tabbableElements.length - 1] === element;
};
const $a78c261c3211f7d6$export$cfa8eefe354167cd = (element, focusOptions)=>{
    element.setAttribute('tabIndex', '-1');
    element.focus(focusOptions);
};
const $a78c261c3211f7d6$export$db9eae89818590a4 = (commentElement, previousCommentElement, isFabricPage, isEditor)=>{
    if (!commentElement) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    // if current open comment is out of viewport, we need to scroll so that the next comment is in viewport
    const sidebarId = $a78c261c3211f7d6$export$fb40c5e75b82df8(isEditor, true); // Hard-coding isViewCommentMode to true because navigation only exists in the view scenario
    const inlineCommentSidebar = document.getElementById(sidebarId);
    const inlineCommentPosition = inlineCommentSidebar?.getBoundingClientRect();
    const documentContent = document.getElementById('content');
    const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
    const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && inlineCommentPosition.top < documentContentTopPosition + scrollRootOffset;
    const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
    if (commentAboveViewport || commentBelowViewport) {
        $a78c261c3211f7d6$export$c7436bd0a15f3e7e({
            commentElement: commentElement,
            isFabricPage: isFabricPage
        });
        return;
    }
    const previousOffset = previousCommentElement ? $a78c261c3211f7d6$export$331805bfbe18b1c0(previousCommentElement) : 0;
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement);
    const differenceOffset = offset - previousOffset;
    scrollRootElement.scrollBy({
        top: differenceOffset,
        behavior: 'smooth' // navigation uses a smooth scroll
    });
    // If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$var$adjustNodeForStickyHeader = (stickyHeaderElement)=>{
    let adjustedElement = stickyHeaderElement;
    const markerRef = $a78c261c3211f7d6$export$8f4213b45c05ab5d(adjustedElement);
    // If this is exists it's a commited comment, look for its counterpart in the real table
    // TODO: Support new highlights when we allow it
    if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    adjustedElement = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef, '.pm-table-wrapper');
    return adjustedElement;
};
const $a78c261c3211f7d6$export$ee0755cb593feed6 = (element)=>{
    let nodeToReturn = element;
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToReturn && nodeToReturn.closest && nodeToReturn.closest('.pm-table-sticky-wrapper')) nodeToReturn = $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToReturn);
    if (nodeToReturn) {
        // WS-2718 - If a comment is in an extension macro
        const extensionParent = nodeToReturn.closest('.ak-renderer-extension');
        if (extensionParent) nodeToReturn = extensionParent;
    }
    return nodeToReturn;
};
const $a78c261c3211f7d6$export$331805bfbe18b1c0 = (element, relativeToElement, isRendererAnnotationProviderEnabled)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    // new sticky header implementation
    if ((0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
        if (relativeToElement && nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('tr.pm-table-row-native-sticky-active')) {
            const elementRect = nodeToMeasure.getBoundingClientRect();
            const containerRect = relativeToElement.getBoundingClientRect();
            return elementRect.top - containerRect.top;
        }
    }
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) // The RAP annotation draft mark is applied to the both pm-table-sticky-wrapper as well as the pm-table-wrapper.
    // Need to check only pm-table-wrapper annotation draft mark for the RAP enabled
    nodeToMeasure = isRendererAnnotationProviderEnabled ? document.querySelector(`.pm-table-wrapper [data-annotation-draft-mark="true"]`) : $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToMeasure);
    // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
    // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
    // pages do not have anything like that, but will return null when we get to <body>
    while(nodeToMeasure && !nodeToMeasure.classList.contains('ak-renderer-wrapper') && nodeToMeasure !== relativeToElement){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    // WS-2718 - If a comment is in an extension macro, we need to add its container offset as well
    if (nodeToMeasure) {
        const extensionParent = nodeToMeasure.closest('.ak-renderer-extension');
        if (extensionParent) elementOffsetTop += extensionParent.offsetTop;
    }
    return elementOffsetTop;
};
const $a78c261c3211f7d6$export$d0d02dc9adb82d62 = (element, isFabricPage)=>{
    //get the child of element passed in
    const expandElement = element?.hasChildNodes() ? element?.firstChild : element;
    //check if element is expand button and return element if so
    if (isFabricPage) {
        if (expandElement?.tagName?.toLowerCase() === 'button') return expandElement;
    } else if (expandElement?.classList?.contains('expand-control')) return expandElement?.firstChild; //it's one child down for tiny pages
    return null;
};
const $a78c261c3211f7d6$export$1a2319f5c2109ee1 = (element, options)=>{
    const { expandSelectors: expandSelectors, getExpandButton: getExpandButton, isExpanded: isExpanded, onExpand: onExpand } = options;
    const nodeToCheck = element;
    // Check if comment is in any expand
    const isInExpand = expandSelectors.some((selector)=>nodeToCheck?.closest?.(selector));
    if (!isInExpand) return;
    // Find all expand buttons that need to be opened, starting from the innermost
    const expandButtonsToOpen = [];
    let currentNode = nodeToCheck;
    while(currentNode){
        // Check if current node has an expand button
        const expandButton = getExpandButton(currentNode);
        if (expandButton) // Check if this expand is already opened
        {
            if (!isExpanded(expandButton)) expandButtonsToOpen.push(expandButton);
        }
        currentNode = currentNode?.parentElement;
    }
    // Open all expand buttons from innermost to outermost
    const buttonsToClick = [
        ...expandButtonsToOpen
    ].reverse();
    buttonsToClick.forEach((expandButton)=>{
        if (onExpand) onExpand(expandButton);
        expandButton.click();
    });
};
const $a78c261c3211f7d6$export$d2685a53bf6957f4 = (element, isFabricPage)=>{
    const expandElementClassname = isFabricPage ? '.expand-content-wrapper' : '.expand-content';
    const nestedExpandElementClassname = '.nestedExpand-content-wrapper';
    const expandSelectors = [
        expandElementClassname,
        nestedExpandElementClassname
    ];
    const getExpandButton = (node)=>$a78c261c3211f7d6$export$d0d02dc9adb82d62(node, isFabricPage);
    const isExpanded = (button)=>{
        return isFabricPage ? button.getAttribute('aria-expanded') === 'true' : button.className.includes('expanded');
    };
    $a78c261c3211f7d6$export$1a2319f5c2109ee1(element, {
        isFabricPage: isFabricPage,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded
    });
};
const $a78c261c3211f7d6$export$876171b9c9b54aab = (element, isFabricPage)=>{
    $a78c261c3211f7d6$export$d2685a53bf6957f4(element, isFabricPage);
};
const $a78c261c3211f7d6$export$187f977414e8342c = (action, index, markerRefList)=>{
    if (markerRefList.length === 0 || index === undefined || index === -1) return;
    let commentIndex = -1;
    //Navigate to first inline comment if we're on the last comment and the user clicks next,
    // or to the last comment if we're on the first comment and the user clicks previous
    if (action === 'next') commentIndex = index === markerRefList.length - 1 ? 0 : index + 1;
    else if (action === 'previous') commentIndex = index === 0 ? markerRefList.length - 1 : index - 1;
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$883ebc059dd86e88 = (index, markerRefList, unreadMarkerRefList)=>{
    if (index === undefined || markerRefList.length === 0 || index === -1 || !unreadMarkerRefList || unreadMarkerRefList.length === 0) return;
    let commentIndex = index % markerRefList.length; // Handle case where index is beyond array length
    const refListLength = markerRefList.length;
    let iterations = 0;
    while(markerRefList[commentIndex] !== undefined && !unreadMarkerRefList.includes(markerRefList[commentIndex]) && iterations < refListLength){
        commentIndex = (commentIndex + 1) % markerRefList.length;
        iterations++;
    }
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$b401b3c3a0774fd7 = ()=>navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $a78c261c3211f7d6$export$2cdf1b96a9f86d16 = async (text)=>{
    if ($a78c261c3211f7d6$export$b401b3c3a0774fd7()) await navigator.clipboard.writeText(text);
};
const $a78c261c3211f7d6$export$ab567600730c0b3b = (annotationElement, scrollParentSelector)=>{
    const scrollParent = document.querySelector(scrollParentSelector);
    return $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement, scrollParent);
};
const $a78c261c3211f7d6$export$3cdeee3ea1732782 = (annotationElement, scrollParentSelector, isView)=>{
    let offset = 0;
    if (annotationElement) {
        // If the annotation is the wrapperDOM, we actually need #content to be the scrollParent
        const scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
        if (scrollParent) {
            let annotationOffset;
            if (isView) annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement);
            else {
                // If the annotation is the wrapperDOM, we need to find the actual highlight instead
                const actualHiglightElement = scrollParent.querySelector(scrollParentSelector);
                annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(actualHiglightElement, undefined, true);
            }
            offset = annotationOffset + scrollParent.offsetTop;
        }
    }
    return offset;
};
const $a78c261c3211f7d6$export$9f8164812b21bc7a = (entries)=>{
    const windowHeight = window.innerHeight;
    if ((0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true) || (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
        if (!(0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
            // When fg is ON, we would have verified that there's no
            // endOfPageRecommendations before adding this ResizeObserver.
            // So no need to check it here.
            const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
            if (endOfPageRecommendations) return 0;
        }
        const editorTextArea = document.getElementById('ak-editor-textarea');
        const editorBottom = editorTextArea?.getBoundingClientRect().bottom;
        if (editorBottom && windowHeight) {
            // The minimum spacing between bottom of editor content and top of footer is 120px
            const minimumSpacing = 120;
            // - There's an existing fixed 24px margin below editor content.
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px to make it visually distinct
            //   when a short LiveDoc has some vs zero existing footer comment.
            const editorBottomMargin = 24;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
            const currentScroll = editorScrollParent?.scrollTop ?? 0;
            const editorBottomUnscrolled = editorBottom + currentScroll;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - editorBottomUnscrolled;
            return Math.max(verticalDistanceFromWindowBottomUnscrolled - editorBottomMargin - addFooterCommentHeight - extraFooterCommentHeightToShow, minimumSpacing);
        }
    } else {
        // The calculation is
        // 15px of marginTop on the comment container
        // 2px full-page-editor-style bottom which above the viewport
        // 1px border which is cumulates to 120px
        const thresholdTop = 102;
        const editorEntry = entries.find((entry)=>entry.target.id === 'ak-editor-textarea');
        const editorBottom = editorEntry?.target.getBoundingClientRect().bottom;
        const editorContentHeight = document.querySelector(`.ak-editor-content-area .ProseMirror`)?.getBoundingClientRect().height;
        const documentContentBottom = document.querySelector(`[data-testid='full-page-editor-style']`)?.getBoundingClientRect().bottom;
        if (editorContentHeight) {
            // If the document content is larger than the window height, just set it to a static 120 to keep the proper spacing
            if (editorContentHeight > windowHeight) return 120;
            if (documentContentBottom && editorBottom) {
                const verticalDistance = documentContentBottom - editorBottom;
                if (verticalDistance >= thresholdTop && editorContentHeight <= windowHeight) return verticalDistance - thresholdTop;
                else if (verticalDistance <= thresholdTop) return thresholdTop;
            }
        }
    }
};
const $a78c261c3211f7d6$export$e3a17b46d43aa5f6 = ()=>{
    // This is deprecated, and will be replaced by a new approach that works in SSR.
    let newTop = 0;
    const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
    const legacyLabels = document.querySelector('[data-vc="view-page-labels-container"]');
    // no extra spacing if the page shows end-of-page recommendations or legacy labels
    if (!endOfPageRecommendations && !legacyLabels) {
        const rendererContent = document.getElementById('main-content');
        const rendererContentBottom = rendererContent?.getBoundingClientRect()?.bottom ?? 0;
        if (rendererContentBottom) {
            // - There's an existing fixed 80px margin below Page content (See
            //   next/packages/view-page-common/src/ViewPageContent.tsx).
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px (matching Editor version ^)
            //   to make it visually distinct when a short Page has some vs zero
            //   existing footer comment.
            const contentBottomMargin = 80;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // Find the current scroll offset on the Page.
            // This is similar to implementation in getDimensionsForNav4(),
            // but when the window is very narrow, nav4ScrollParent.scrollTop
            // can be 0 (nav4ScrollParent element itself exists on page) while
            // window.scrollY is positive.
            // So this is a more robust implementation. Will explore whether
            // getDimensionsForNav4() can be updated to use this implementation
            // in a separate PR.
            const nav4ScrollParent = document.getElementById('AkMainContent');
            const currentPageOffset = (nav4ScrollParent?.scrollTop ?? 0) + (window.scrollY ?? window.top?.scrollY ?? 0);
            const rendererContentBottomUnscrolled = rendererContentBottom + currentPageOffset;
            const windowHeight = window.innerHeight;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - rendererContentBottomUnscrolled - contentBottomMargin;
            newTop = Math.max(verticalDistanceFromWindowBottomUnscrolled - addFooterCommentHeight - extraFooterCommentHeightToShow, 0);
        }
    }
    return newTop;
};
const $a78c261c3211f7d6$export$fc9b5eebad60b835 = ({ element: element, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (!element) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    const elementRect = element.getBoundingClientRect();
    const elementTopViewport = elementRect.top;
    const scrollRootTopViewport = scrollRootElement instanceof Window ? 0 // Window doesn't have a bounding rect; its top is always 0
     : scrollRootElement.getBoundingClientRect().top;
    const elementTopFromScrollRoot = elementTopViewport - scrollRootTopViewport;
    const targetScrollPosition = elementTopFromScrollRoot + scrollRootOffset + viewingRoomOffset;
    scrollRootElement.scrollTo({
        top: targetScrollPosition,
        behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
    });
    // open expand if the element is inside an expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(element, true);
};
const $a78c261c3211f7d6$export$b3ba907d5759e257 = (commentId, annotationId)=>{
    let isDisconnected = false;
    let commentFound = false;
    // Find the most specific container to observe
    const commentsPanelListContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const targetContainer = commentsPanelListContainer || document.body;
    const observer = new MutationObserver(()=>{
        if (isDisconnected || commentFound) return;
        const commentElement = targetContainer.querySelector(`[data-comment-id="${commentId}"]`) || (annotationId ? targetContainer.querySelector(`[data-testid="comment-thread-${annotationId}-container"]`) : null);
        if (commentElement) {
            commentFound = true;
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            isDisconnected = true;
            observer.disconnect();
        }
    });
    // Start observing only the specific container
    observer.observe(targetContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: annotationId ? [
            'data-comment-id',
            'data-testid'
        ] : [
            'data-comment-id'
        ]
    });
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
        }
    };
};
const $a78c261c3211f7d6$export$b1b7c9bcc75c855d = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId })=>{
    if ((0, $6mKj3.expValEquals)('confluence_comments_use_new_observer', 'isEnabled', true)) return $a78c261c3211f7d6$export$4d09fb2a10e54800({
        targetCommentId: targetCommentId,
        onScrollReady: onScrollReady,
        onFallback: onFallback,
        timeoutMs: timeoutMs,
        markElement: markElement,
        containerId: containerId
    });
    let commentFound = false;
    let isDisconnected = false;
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                for (const addedNode of Array.from(mutation.addedNodes))if (addedNode.nodeType === Node.ELEMENT_NODE) {
                    const element = addedNode;
                    // Check if this element or any of its descendants has the specific data-comment-id
                    const containerElement = containerId ? document.getElementById(containerId) : null;
                    const commentElement = containerElement || element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
                    if (commentElement) {
                        commentFound = true;
                        // Early return if the comment is in the container element
                        if (containerElement) {
                            onScrollReady(containerElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        }
                        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                        // Check the initial state of the show more button
                        const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                        if (!showMoreButton) {
                            onScrollReady(commentElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        } else // Trigger click on the show more button to expand all replies
                        showMoreButton.click();
                        break;
                    }
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
            const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Find the comment element by ID or data-comment-id attribute
 */ const $a78c261c3211f7d6$var$findCommentElement = (targetCommentId, containerId, isFooterCommentInPanel)=>{
    // If isFooterCommentInPanel is true, use comment-thread-${targetCommentId}-container
    if (isFooterCommentInPanel) {
        const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
        if (panelContainer) return panelContainer;
    }
    // Try container element first if containerId is provided
    if (containerId) {
        const container = document.getElementById(containerId);
        if (container) return container;
    }
    // Fall back to finding by data-comment-id
    return document.querySelector(`[data-comment-id="${targetCommentId}"]`);
};
const $a78c261c3211f7d6$export$5eaef9e6a0975768 = (commentElement, targetCommentId)=>{
    if (!commentElement) return null;
    // 1. Check within commentElement (descendants)
    const buttonInComment = commentElement.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInComment) return buttonInComment;
    // 2. Check in parent element (siblings)
    const parentElement = commentElement.parentElement;
    const buttonInParent = parentElement?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInParent) return buttonInParent;
    // 3. Check in replies container (specific to this comment thread)
    const repliesContainer = document.querySelector(`[data-testid="comment-thread-${targetCommentId}-replies"]`);
    const buttonInReplies = repliesContainer?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInReplies) return buttonInReplies;
    return null;
};
/**
 * Handle the comment element being found
 * Checks for show more button and either scrolls immediately or clicks to expand
 */ const $a78c261c3211f7d6$var$handleCommentFound = (commentElement, targetCommentId, containerId, markElement, onScrollReady)=>{
    // If container element exists and we're using it, scroll immediately
    if (containerId && commentElement.id === containerId) {
        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    }
    // Expand mark element if needed
    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
    // Check for show more button
    const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
    if (!showMoreButton) {
        // No show more button, scroll immediately
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    } else {
        // Show more button exists, click it to expand replies
        showMoreButton.click();
        return false; // Keep watching for button to disappear
    }
};
/**
 * Check if comment element exists in newly added nodes
 */ const $a78c261c3211f7d6$var$checkAddedNodes = (addedNodes, targetCommentId, containerId, isFooterCommentInPanel, onCommentFound)=>{
    for (const addedNode of Array.from(addedNodes)){
        if (addedNode.nodeType !== Node.ELEMENT_NODE) continue;
        const element = addedNode;
        // Check if this element or its descendants contains the comment
        let commentElement = null;
        // First check for container element
        if (containerId) {
            const container = document.getElementById(containerId);
            if (container) commentElement = container;
        }
        // If not found, check for comment by data-comment-id
        if (!commentElement) commentElement = element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
        // If isFooterCommentInPanel, also check for panel container
        if (!commentElement && isFooterCommentInPanel) {
            const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
            if (panelContainer) commentElement = panelContainer;
        }
        if (commentElement) {
            const shouldDisconnect = onCommentFound(commentElement);
            if (shouldDisconnect) return true; // Indicates we should stop processing
        }
    }
    return false;
};
const $a78c261c3211f7d6$export$4d09fb2a10e54800 = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId, isFooterCommentInPanel: isFooterCommentInPanel = false })=>{
    let commentFound = false;
    let isDisconnected = false;
    const handleCommentFoundWrapper = (commentElement)=>{
        commentFound = true;
        return $a78c261c3211f7d6$var$handleCommentFound(commentElement, targetCommentId, containerId, markElement, onScrollReady);
    };
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const shouldStop = $a78c261c3211f7d6$var$checkAddedNodes(mutation.addedNodes, targetCommentId, containerId, isFooterCommentInPanel, handleCommentFoundWrapper);
                if (shouldStop) {
                    isDisconnected = true;
                    observer.disconnect();
                    return;
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
            const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
            // If comment exists and show more button is gone, we're ready to scroll
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Returns the HTMLElement or window that should be used as the scroll root. By default,
 *  this is the div with id=AkMainContent, if the id exists in the DOM
 */ function $a78c261c3211f7d6$var$getScrollRootContext() {
    const nav4ScrollRootElement = document.getElementById('AkMainContent');
    const scrollRootElement = nav4ScrollRootElement || window;
    const scrollRootOffset = nav4ScrollRootElement ? nav4ScrollRootElement.scrollTop : window.scrollY;
    return {
        scrollRootElement: scrollRootElement,
        scrollRootOffset: scrollRootOffset,
        getDimensions: $a78c261c3211f7d6$var$getDimensions
    };
}
// Constants for comment thread visibility
const $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $a78c261c3211f7d6$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $a78c261c3211f7d6$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
const $a78c261c3211f7d6$export$e3c287b6d80b16ce = ({ pageMode: pageMode, pageWidthType: pageWidthType, hasEndOfPageRecommendations: hasEndOfPageRecommendations })=>{
    const endOfPageRecommendationsMaxWidth = '1000px';
    if (pageMode === (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) {
        // pageWidthType is a string like '"default"' / '"full-width"' in renderer mode, and is undefined in live doc mode
        const isDefaultWidth = pageWidthType && JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT;
        if (hasEndOfPageRecommendations) // when end-of-page recommendations is present, always match its width (see EndOfPageRecContainer.tsx)
        return {
            width: isDefaultWidth ? '87.5%' : '100%',
            maxWidth: endOfPageRecommendationsMaxWidth
        };
        else return {
            width: '100%',
            maxWidth: isDefaultWidth ? '760px' : '1800px' // if not defaultWidth, use full page width
        };
    }
    if (pageMode !== (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width_ld') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) return {
        width: '100%',
        maxWidth: hasEndOfPageRecommendations && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) ? endOfPageRecommendationsMaxWidth : '100%'
    };
    // Base case: when the fg for the current pageMode isn't ON, i.e. either of:
    // - pageMode === PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // - pageMode !== PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width_ld') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // This block can be removed entirely once both fgs are rolled out.
    let maxWidth = '100%';
    if (pageWidthType) maxWidth = JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? '1000px' : 'unset';
    return {
        width: '100%',
        maxWidth: maxWidth
    };
};
module.exports["CREATE_COMMENT_SELECTION_CLASS"] = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
module.exports["HIGHLIGHT_CLASS"] = $a78c261c3211f7d6$export$b803c692fbaaa5a4;
module.exports["ACTIVE_CLASS"] = $a78c261c3211f7d6$export$fb3d0eebfe85522a;
module.exports["getCommentIndexAndCount"] = $a78c261c3211f7d6$export$b899b07e3f725968;
module.exports["getInlineMarkSelector"] = $a78c261c3211f7d6$export$8c7b048437c01388;
module.exports["getMarkerRef"] = $a78c261c3211f7d6$export$8f4213b45c05ab5d;
module.exports["getSortedMarkerRefs"] = $a78c261c3211f7d6$export$9b48c18cc387f791;
module.exports["clearActiveHighlight"] = $a78c261c3211f7d6$export$f7ceeb7ba8156450;
module.exports["getNextTextNode"] = $a78c261c3211f7d6$export$3e98291f1f032a77;
module.exports["getHighlightOffset"] = $a78c261c3211f7d6$export$739c145b6a07c076;
module.exports["getHighlightFromMarkerRef"] = $a78c261c3211f7d6$export$21445ab787d3b446;
module.exports["calculateElementOffset"] = $a78c261c3211f7d6$export$331805bfbe18b1c0;
module.exports["resetTemporaryDOMHighlight"] = $a78c261c3211f7d6$export$743373b19993e2b0;
module.exports["convertDOMHighlightToMark"] = $a78c261c3211f7d6$export$a160a5110cbadcb8;
module.exports["setCommentAsActive"] = $a78c261c3211f7d6$export$fd55463aeed84830;
module.exports["removeMarkInDOM"] = $a78c261c3211f7d6$export$a26c4eafef12029f;
module.exports["isEmptyAdf"] = $a78c261c3211f7d6$export$915f03d46d87bfd4;
module.exports["getFocusableElementFromMarkerRef"] = $a78c261c3211f7d6$export$c36aa9f15eddb765;
module.exports["keyPropagationList"] = $a78c261c3211f7d6$export$6d23af9d8c2844b1;
module.exports["scrollToElementWithViewingRoom"] = $a78c261c3211f7d6$export$fc9b5eebad60b835;
module.exports["getNodeForTableORMacro"] = $a78c261c3211f7d6$export$ee0755cb593feed6;
module.exports["checkElementExpand"] = $a78c261c3211f7d6$export$876171b9c9b54aab;
module.exports["scrollCommentIntoView"] = $a78c261c3211f7d6$export$c7436bd0a15f3e7e;
module.exports["getSidebarId"] = $a78c261c3211f7d6$export$fb40c5e75b82df8;
module.exports["isFirstTabbableElement"] = $a78c261c3211f7d6$export$642e21ba866d02df;
module.exports["isLastTabbableElement"] = $a78c261c3211f7d6$export$876aeb5dffd449af;
module.exports["focusElementAndUpdateTabIndex"] = $a78c261c3211f7d6$export$cfa8eefe354167cd;
module.exports["scrollToComment"] = $a78c261c3211f7d6$export$db9eae89818590a4;
module.exports["checkElementExpandMultiLevelCommon"] = $a78c261c3211f7d6$export$1a2319f5c2109ee1;
module.exports["getNextMarkerRef"] = $a78c261c3211f7d6$export$187f977414e8342c;
module.exports["getNextUnreadThreadKey"] = $a78c261c3211f7d6$export$883ebc059dd86e88;
module.exports["copyToClipboard"] = $a78c261c3211f7d6$export$2cdf1b96a9f86d16;
module.exports["calculateEditorOffsetFromParent"] = $a78c261c3211f7d6$export$ab567600730c0b3b;
module.exports["calculateRendererOffsetFromParent"] = $a78c261c3211f7d6$export$3cdeee3ea1732782;
module.exports["getCommentPositionTopOfSectionEditor"] = $a78c261c3211f7d6$export$9f8164812b21bc7a;
module.exports["getCommentPositionTopOfSectionRenderer"] = $a78c261c3211f7d6$export$e3a17b46d43aa5f6;
module.exports["watchForCommentContainerAndScroll"] = $a78c261c3211f7d6$export$b3ba907d5759e257;
module.exports["watchForCommentRepliesAndScroll"] = $a78c261c3211f7d6$export$b1b7c9bcc75c855d;
module.exports["shouldScrollCommentThreadToTop"] = $a78c261c3211f7d6$export$4d211f4974dcf196;
module.exports["isCommentThreadReplyOutOfView"] = $a78c261c3211f7d6$export$9c5b7a3c864ae31b;
module.exports["getWidthAndMaxWidth"] = $a78c261c3211f7d6$export$e3c287b6d80b16ce;

});

parcelRegister("i49vP", function(module, exports) {

var $gfqXk = parcelRequire("gfqXk");


var $4EKKB = parcelRequire("4EKKB");


var $aHcFH = parcelRequire("aHcFH");

const $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage = (element)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    while(nodeToMeasure && !nodeToMeasure.classList.contains('fabric-editor-popup-scroll-parent')){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    return elementOffsetTop;
};
const $36cd0189b09a46b6$export$cc3d34287540b287 = (element)=>{
    const expandSelectors = [
        '.ak-editor-expand'
    ];
    const getExpandButton = (node)=>{
        if (node.classList.contains('ak-editor-expand')) {
            const button = node.querySelector('.ak-editor-expand__icon-container');
            return button;
        }
        return null;
    };
    const isExpanded = (button)=>{
        const expandContainer = button.closest('.ak-editor-expand');
        return expandContainer?.classList.contains('ak-editor-expand__expanded') || false;
    };
    const onExpand = ()=>{
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            isInExpand: true
        });
    };
    (0, $aHcFH.checkElementExpandMultiLevelCommon)(element, {
        isEditor: true,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded,
        onExpand: onExpand
    });
};
const $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8 = (element)=>{
    $36cd0189b09a46b6$export$cc3d34287540b287(element);
};
const $36cd0189b09a46b6$export$2163ce5a75e4a465 = ({ targetElement: targetElement, targetElementID: targetElementID, shouldScroll: shouldScroll = true })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8(targetElement);
    emitter.emit('setselectedannotation', targetElementID);
    window.getSelection()?.setPosition(targetElement);
    shouldScroll && $36cd0189b09a46b6$export$4ee22c4fac4681d8({
        targetElement: targetElement,
        viewingRoomOffset: -100
    });
};
const $36cd0189b09a46b6$export$4ee22c4fac4681d8 = ({ targetElement: targetElement, viewingRoomOffset: viewingRoomOffset = 0 })=>{
    const editorScrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollableContainer) editorScrollableContainer.scrollTo(0, $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage(targetElement) + viewingRoomOffset // add viewing room
    );
};
const $36cd0189b09a46b6$export$443ba0c8d1b21569 = ({ data: data, previousAnnotations: previousAnnotations })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const topLevelCommentMarkerRefs = data?.comments?.nodes?.map((node)=>(node?.location).inlineMarkerRef);
    if (topLevelCommentMarkerRefs && topLevelCommentMarkerRefs.length > 0) {
        const newAnnotationsSet = new Set(topLevelCommentMarkerRefs);
        const removedMarkerRefs = [];
        previousAnnotations.forEach((item)=>{
            if (!newAnnotationsSet.has(item)) removedMarkerRefs.push(item);
        });
        let updatedAnnotations = [
            ...previousAnnotations
        ];
        const addedMarkerRefs = [];
        newAnnotationsSet.forEach((item)=>{
            if (!previousAnnotations.includes(item)) addedMarkerRefs.push(item);
        });
        for (const markerRef of addedMarkerRefs){
            emitter.emit('create', markerRef);
            updatedAnnotations.push(markerRef);
        }
        for (const markerRef of removedMarkerRefs){
            emitter.emit('resolve', markerRef);
            updatedAnnotations = updatedAnnotations.filter((annotation)=>annotation !== markerRef);
        }
        return updatedAnnotations;
    }
    return [];
};
module.exports["checkElementExpandInEditor"] = $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8;
module.exports["openInlineCommentInEditor"] = $36cd0189b09a46b6$export$2163ce5a75e4a465;
module.exports["scrollToElementInEditor"] = $36cd0189b09a46b6$export$4ee22c4fac4681d8;

});

parcelRegister("9FoVw", function(module, exports) {
/**
 * @fileoverview Unified comment navigation utilities for scrolling to different comment types
 * and handling various navigation scenarios across editor and renderer contexts.
 */ 
var $21K7m = parcelRequire("21K7m");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6mKj3 = parcelRequire("6mKj3");


var $4L9ve = parcelRequire("4L9ve");


var $kgNLQ = parcelRequire("kgNLQ");


var $i49vP = parcelRequire("i49vP");


var $aHcFH = parcelRequire("aHcFH");

var $0343eaf78527fd4c$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["NEXT"] = "next";
    ShortcutType["PREVIOUS"] = "previous";
    ShortcutType["UNREAD"] = "unread";
    return ShortcutType;
}({});
var $0343eaf78527fd4c$var$CommentType = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}($0343eaf78527fd4c$var$CommentType || {});
var $0343eaf78527fd4c$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
// Navigation types based on comment scrolling architecture
var $0343eaf78527fd4c$var$NavigationType = /*#__PURE__*/ function(NavigationType) {
    NavigationType["INLINE_ANNOTATION"] = "inline_annotation";
    NavigationType["COMMENTS_PANEL"] = "comments_panel";
    NavigationType["FOOTER_COMMENTS"] = "footer_comments";
    NavigationType["DEEP_LINK"] = "deep_link";
    NavigationType["KEYBOARD_SHORTCUT"] = "keyboard_shortcut";
    NavigationType["INLINE_HEADER_ARROWS"] = "inline_header_arrows";
    return NavigationType;
}($0343eaf78527fd4c$var$NavigationType || {});
var $0343eaf78527fd4c$export$e6e360ac7d345e5 = /*#__PURE__*/ function(ScrollBehavior) {
    ScrollBehavior["INSTANT"] = "instant";
    ScrollBehavior["SMOOTH"] = "smooth";
    return ScrollBehavior;
}({});
var $0343eaf78527fd4c$export$3044ab7fdabeaee6 = /*#__PURE__*/ function(NavigationContext) {
    NavigationContext["EDITOR"] = "editor";
    NavigationContext["RENDERER"] = "renderer";
    NavigationContext["PANEL"] = "panel";
    NavigationContext["REPLY"] = "reply";
    return NavigationContext;
}({});
var $0343eaf78527fd4c$export$368ed1d84e0ae668 = /*#__PURE__*/ function(CommentNavigationStatus) {
    CommentNavigationStatus["FOUND_IN_DOM"] = "FOUND_IN_DOM";
    CommentNavigationStatus["DELETED_CONTENT"] = "DELETED_CONTENT";
    CommentNavigationStatus["RESOLVED"] = "RESOLVED";
    CommentNavigationStatus["UNKNOWN"] = "UNKNOWN";
    CommentNavigationStatus["REMOVED_BY_ANOTHER_USER"] = "REMOVED_BY_ANOTHER_USER";
    return CommentNavigationStatus;
}({});
const $0343eaf78527fd4c$export$9f32f1ed184088e0 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, inline: inline, markElement: markElement, annotationId: annotationId } = options;
    if (!markElement) return false;
    // Handle different contexts
    switch(context){
        case "editor":
            // Check if element needs to be expanded in editor
            (0, $i49vP.checkElementExpandInEditor)(markElement);
            // Emit the setselectedannotation event
            const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
            editorEmitter.emit('setselectedannotation', markElement.id);
            // Scroll to the element in editor
            (0, $i49vP.scrollToElementInEditor)({
                targetElement: markElement,
                viewingRoomOffset: -100
            });
            return true;
        case "renderer":
            // Renderer-specific logic with improved focus management
            const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
            if (focusedMarkerRef?.id !== markElement.id) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: markElement.id
                });
                // Check if element needs to be expanded
                (0, $aHcFH.checkElementExpand)(markElement, true);
            }
            // Scroll to the annotation mark
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        case "panel":
            // For panel context, ensure annotation is visible and highlighted
            if (annotationId) {
                // Emit events to ensure the annotation is properly focused
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: annotationId
                });
            }
            // Scroll the annotation into view
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        default:
            return false;
    }
};
/**
 * Wait for the comments panel to be rendered in the DOM
 * Returns a Promise that resolves when the panel is available or times out after 5 seconds
 */ const $0343eaf78527fd4c$var$waitForCommentsPanel = ()=>{
    const commentsPanelListContainerId = 'comments-panel-list-container';
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            const panel = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
            if (panel) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Start observing the document body for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 5000); // 5 second timeout
    });
};
/**
 * Wait for the comments panel view/filter to change to the specified view
 * Returns a Promise that resolves when the view change is complete or times out after 3 seconds
 */ const $0343eaf78527fd4c$var$waitForViewChange = (expectedView)=>{
    return new Promise((resolve)=>{
        // Check if the view has already changed by checking the data-current-view attribute on the container
        const checkView = ()=>{
            const container = document.querySelector('[data-testid="comments-panel-list-container"]');
            if (container && container.getAttribute('data-current-view') === expectedView) return true;
        };
        if (checkView()) {
            resolve(true);
            return;
        }
        // Observe document body for both container creation and attribute changes
        // This handles cases where the container gets unmounted/remounted
        const observer = new MutationObserver(()=>{
            if (checkView()) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Observe the entire document body to catch:
        // 1. Container being created/removed
        // 2. Attribute changes on the container when it exists
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'data-current-view'
            ]
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 3000); // 3 second timeout
    });
};
/**
 * Check if the top edge of an element is visible in the viewport
 * Used to determine if scrolling is needed based on element visibility
 */ const $0343eaf78527fd4c$var$isElementTopVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    return rect.top >= 0;
};
/**
 * Wait for an element to finish scrolling into view
 * Returns a Promise that resolves when the element is reasonably visible or times out
 */ const $0343eaf78527fd4c$var$waitForScrollCompletion = (element, timeout = 3000)=>{
    return new Promise((resolve)=>{
        const startTime = Date.now();
        const check = ()=>{
            if ($0343eaf78527fd4c$var$isElementTopVisible(element)) // Add a small delay after element becomes visible to let scrolling settle
            setTimeout(()=>resolve(true), 150);
            else if (Date.now() - startTime > timeout) resolve(false);
            else requestAnimationFrame(check);
        };
        // Small delay to let scroll animation start
        setTimeout(check, 16);
    });
};
/**
 * Helper function for viewport checking - returns true if should skip scrolling due to viewport visibility
 */ const $0343eaf78527fd4c$var$checkAndHandleViewportVisibility = (element, shouldScrollIfCommentIsInViewport)=>{
    if (!shouldScrollIfCommentIsInViewport) {
        const commentIsInViewport = $0343eaf78527fd4c$var$isElementTopVisible(element);
        if (commentIsInViewport) return true;
    }
    return false;
};
/**
 * Handle scroll completion based on awaitScrollCompletion flag and scroll behavior
 */ const $0343eaf78527fd4c$var$handleScrollCompletion = (awaitScrollCompletion, scrollBehavior, element)=>{
    if (awaitScrollCompletion) return scrollBehavior === "smooth" ? $0343eaf78527fd4c$var$waitForScrollCompletion(element) : Promise.resolve(true);
    return true;
};
/**
 * Check if an element is already fully visible within the panel
 * Avoids unnecessary scrolling if the element is already in view
 */ const $0343eaf78527fd4c$var$isElementFullyVisible = (element)=>{
    const elementRect = element.getBoundingClientRect();
    const panelContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const panelRect = panelContainer?.getBoundingClientRect();
    if (!panelRect) return false;
    return elementRect.top >= panelRect.top && elementRect.bottom <= panelRect.bottom;
};
/**
 * Determine the optimal scroll position based on context and comment type
 * Considers whether to scroll to start, center, or end based on various factors
 */ const $0343eaf78527fd4c$var$determineScrollPosition = (element, block, scrollToEnd, commentType)=>{
    let scrollBlock = block;
    if (scrollToEnd) {
        // Check if the comment thread reply is out of view
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? "inline" : "general";
        const isOutOfView = (0, $aHcFH.isCommentThreadReplyOutOfView)(element, commentTypeEnum);
        if (isOutOfView) scrollBlock = 'end';
    } else {
        // Check if we should scroll to top
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? "inline" : "general";
        const shouldScrollToTop = (0, $aHcFH.shouldScrollCommentThreadToTop)(element, commentTypeEnum);
        if (shouldScrollToTop) scrollBlock = 'start';
    }
    return scrollBlock;
};
/**
 * Perform the actual scrolling operation with optimized behavior
 * Handles different scroll scenarios based on user interaction context
 */ const $0343eaf78527fd4c$var$performScrollToElement = (element, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType)=>{
    // Skip scrolling if element is already fully visible
    if ($0343eaf78527fd4c$var$isElementFullyVisible(element)) return;
    // Determine scroll behavior based on trigger type
    if (hasKeyPressed || annotationClicked || scrollOnLoad) {
        const scrollBlock = $0343eaf78527fd4c$var$determineScrollPosition(element, block, scrollToEnd, commentType);
        element.scrollIntoView({
            behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
            block: scrollBlock
        });
    } else // Default scroll behavior
    element.scrollIntoView({
        behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
        block: block
    });
};
const $0343eaf78527fd4c$export$390f6df30bfcd812 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, commentId: commentId, annotationId: annotationId, commentType: commentType, scrollToEnd: scrollToEnd = false, hasKeyPressed: hasKeyPressed = false, annotationClicked: annotationClicked = false, scrollOnLoad: scrollOnLoad = false, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    // Only handle panel context navigation
    if (context !== "panel") return false;
    // Define panel container and thread selectors
    const commentsPanelListContainerId = 'comments-panel-list-container';
    // annotationId is used for DOM selectors, commentId is the actual comment identifier
    const commentThreadContainerId = `comment-thread-${annotationId}-container`;
    // Check if panel is available, wait if not
    const panelContainer = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
    if (!panelContainer) // Panel is not rendered yet, wait for it to appear
    return $0343eaf78527fd4c$var$waitForCommentsPanel().then((panelAvailable)=>{
        if (panelAvailable) // Recursively call the function now that panel is available
        return $0343eaf78527fd4c$export$390f6df30bfcd812(options);
        return false;
    });
    // Look for the specific comment thread container
    const commentThreadElement = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
    // If comment thread exists, scroll immediately
    if (commentThreadElement) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(commentThreadElement, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        $0343eaf78527fd4c$var$performScrollToElement(commentThreadElement, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType);
        // For panel navigation, always return Promise when awaitScrollCompletion is true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, commentThreadElement);
    }
    // Use optimized observer to watch for comment thread container creation
    if (commentId) (0, $aHcFH.watchForCommentContainerAndScroll)(commentId);
    else if (annotationId) (0, $aHcFH.watchForCommentContainerAndScroll)('', annotationId);
    return true;
};
const $0343eaf78527fd4c$export$dcd3c0d6a66d0412 = async (options)=>{
    const { expectedView: expectedView, commentId: commentId, annotationId: annotationId, ...navigationOptions } = options;
    // Only wait for view change for panel context
    if (navigationOptions.context === "panel" && expectedView) await $0343eaf78527fd4c$var$waitForViewChange(expectedView);
    // Then perform the navigation - pass both commentId and annotationId
    return $0343eaf78527fd4c$export$390f6df30bfcd812({
        ...navigationOptions,
        commentId: commentId,
        annotationId: annotationId
    });
};
const $0343eaf78527fd4c$export$34fd7e98d0739b5c = (options)=>{
    const { block: block, inline: inline, commentId: commentId, scrollBehavior: scrollBehavior, navigationContext: navigationContext, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    let containerId;
    if (!commentId) return false;
    // Check if comment already exists in DOM
    // Determine container ID based on navigation context:
    // - PANEL: uses comment-thread container
    // - REPLY: uses data-comment-id attribute selector
    // - Default (footer): uses footer-comment-thread container
    if (navigationContext === "panel") containerId = `comment-thread-${commentId}-container`;
    else if (navigationContext === "reply") containerId = `[data-comment-id="${commentId}"]`;
    else containerId = `footer-comment-thread-${commentId}-container`;
    // Use querySelector for REPLY context (attribute selector), getElementById for others (ID)
    const existingComment = navigationContext === "reply" ? document.querySelector(containerId) : document.getElementById(containerId);
    if (existingComment) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(existingComment, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        // Wait for scroll completion when awaitScrollCompletion is true, otherwise return true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, existingComment);
    } else {
        // Comment not yet rendered, use DOM resolver to watch for it
        (0, $aHcFH.watchForCommentRepliesAndScroll)({
            targetCommentId: commentId,
            onScrollReady: (commentElement)=>{
                // Find the container element by ID or selector based on navigation context
                const containerElement = navigationContext === "reply" ? document.querySelector(containerId) : document.getElementById(containerId);
                const elementToScroll = containerElement || commentElement;
                elementToScroll.scrollIntoView({
                    behavior: scrollBehavior,
                    block: block,
                    inline: inline
                });
            },
            containerId: containerId
        });
        return true;
    }
};
const $0343eaf78527fd4c$export$ea1c337d9000e2 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, commentId: commentId, markElement: markElement, context: context } = options;
    if (!commentId || !markElement) return false;
    // Check if comment already exists in DOM
    const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (existingComment) {
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        return true;
    }
    // we need to click on the annotation in the editor if the comment is not yet rendered
    if (context === "editor" && markElement) (0, $i49vP.openInlineCommentInEditor)({
        targetElement: markElement,
        targetElementID: markElement.id,
        shouldScroll: false
    });
    // Comment not yet rendered, use DOM resolver to watch for it
    (0, $aHcFH.watchForCommentRepliesAndScroll)({
        targetCommentId: commentId,
        onScrollReady: (commentElement)=>{
            commentElement.scrollIntoView({
                behavior: scrollBehavior,
                block: block,
                inline: inline
            });
        },
        markElement: markElement
    });
    return true;
};
const $0343eaf78527fd4c$export$807107038899c351 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, annotationId: annotationId, commentId: commentId, commentType: commentType, isCommentsPanelOpen: isCommentsPanelOpen, hasKeyPressed: hasKeyPressed = true, scrollToEnd: scrollToEnd = false, context: context, shortcutType: shortcutType, isResolved: isResolved, previousAnnotationId: previousAnnotationId } = options;
    // Get the mark element for both inline navigation and annotation events
    let markElement = document.getElementById(annotationId);
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    // Get the previous comment element for difference-based scrolling
    const previousCommentElement = previousAnnotationId ? document.getElementById(previousAnnotationId) : null;
    // Check if the mark element is in a sticky table header and adjust if needed
    const isInStickyTableHeader = markElement?.closest && markElement.closest('.pm-table-sticky-wrapper');
    if (isInStickyTableHeader && markElement && (0, $6mKj3.expValEquals)('confluence_comment_enable_table_header_navigation', 'isEnabled', true)) // Get the real element from the non-sticky table using getNodeForTableORMacro
    markElement = (0, $aHcFH.getNodeForTableORMacro)(markElement) || markElement;
    if (commentType === 'FOOTER') $0343eaf78527fd4c$export$34fd7e98d0739b5c({
        scrollBehavior: scrollBehavior,
        block: block,
        inline: inline || 'center',
        commentId: annotationId
    });
    // If comments panel is open, use panel navigation
    if (isCommentsPanelOpen) {
        // For inline comments, also call handleInlineAnnotationNavigation to ensure proper inline comment behavior
        if (commentType === 'INLINE' && !isResolved) $0343eaf78527fd4c$export$9f32f1ed184088e0({
            scrollBehavior: scrollBehavior,
            context: context || "panel",
            block: block,
            inline: inline || 'center',
            markElement: markElement,
            annotationId: annotationId
        });
        // This ensure the ViewComponent useEffect is not triggered
        if (markElement && !isResolved) {
            // Emit annotation events for panel navigation
            if (context === "editor") {
                const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                editorEmitter.emit('setselectedannotation', annotationId);
            } else if (context === "renderer") {
                const rendererEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                rendererEmitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: null
                });
            }
        }
        // Use the existing panel navigation logic
        const result = $0343eaf78527fd4c$export$390f6df30bfcd812({
            scrollBehavior: scrollBehavior,
            context: "panel",
            block: block,
            inline: inline,
            annotationId: annotationId,
            commentType: commentType,
            hasKeyPressed: hasKeyPressed,
            scrollToEnd: scrollToEnd
        });
        if (result instanceof Promise) // For async panel navigation, return true immediately
        // The actual navigation will happen asynchronously
        return true;
        return result;
    }
    if (!markElement) return false;
    // For standalone navigation (comments panel closed), expand the element if needed
    if (commentType === 'INLINE' && context === "renderer") (0, $aHcFH.checkElementExpand)(markElement, true);
    // Use difference-based scrolling if we have both previous and next elements
    if (previousCommentElement && markElement && previousCommentElement !== markElement && (0, $6mKj3.expValEquals)('confluence_comment_use_kbs_exp', 'isEnabled', true)) {
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between next and previous comment positions
                const nextRect = markElement.getBoundingClientRect();
                const previousRect = previousCommentElement.getBoundingClientRect();
                const differenceOffset = nextRect.top - previousRect.top;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment with difference-based scrolling
        (0, $aHcFH.scrollToComment)(markElement, previousCommentElement, true, false);
        return true;
    }
    // For unread navigation, scroll to the comment element with data-comment-id instead of markElement
    if (shortcutType === "unread" && commentElement) commentElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    else // For standalone navigation, we don't emit events - just scroll to the element
    markElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    return true;
};
/**
 * Calculate the height of media comment placeholder to adjust scroll offset.
 * When the media comment placeholder is visible, it pushes the contents of the page down,
 * so we need to scroll a bit less to keep the cursor over the navigation arrow icon.
 */ const $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight = (options)=>{
    const { previousCommentElement: previousCommentElement, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    const isCurrentCommentContentMediaComment = previousCommentElement?.closest('.media-single-node');
    const isNavigatingToLastCommentFromPreviousAction = action === 'previous' && nextCommentIndex === totalComments - 1;
    const isNavigatingToFirstCommentFromNextAction = action === 'next' && nextCommentIndex === 0;
    if (isCurrentCommentContentMediaComment && (action === 'next' || isNavigatingToLastCommentFromPreviousAction || isNavigatingToFirstCommentFromNextAction)) {
        const mediaCommentSelectedPlaceholder = document.querySelector('[data-id="caption-placeholder"]');
        return mediaCommentSelectedPlaceholder ? mediaCommentSelectedPlaceholder.offsetHeight : 0;
    }
    return 0;
};
const $0343eaf78527fd4c$export$36dad1a923539611 = (options)=>{
    const { previousMarkerRef: previousMarkerRef, nextMarkerRef: nextMarkerRef, context: context, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    // Get the next comment element
    const nextMarkElement = document.getElementById(nextMarkerRef);
    if (!nextMarkElement) return false;
    // Get the previous and next comment elements
    const previousCommentElement = document.getElementById(previousMarkerRef);
    const nextCommentElement = document.getElementById(nextMarkerRef);
    if (previousCommentElement && nextCommentElement) {
        const heightOfMediaCommentSelectedPlaceholder = $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight({
            previousCommentElement: previousCommentElement,
            action: action,
            nextCommentIndex: nextCommentIndex,
            totalComments: totalComments
        });
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between current and previous comment positions using calculateElementOffset
                // This handles special cases like sticky table headers
                const previousOffset = (0, $aHcFH.calculateElementOffset)(previousCommentElement);
                const nextOffset = (0, $aHcFH.calculateElementOffset)(nextCommentElement);
                const differenceOffset = nextOffset - previousOffset - heightOfMediaCommentSelectedPlaceholder;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment
        (0, $aHcFH.scrollToComment)(nextCommentElement, previousCommentElement, true, false);
    }
    return true;
};
/**
 * Wait for a comment marker element to appear in the DOM.
 * Resolves immediately if the element already exists, otherwise waits via MutationObserver until timeout.
 */ const $0343eaf78527fd4c$var$waitForCommentElement = ({ markerRef: markerRef, timeoutMs: timeoutMs })=>{
    const existingElement = document.getElementById(markerRef);
    if (existingElement) return Promise.resolve(existingElement);
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            const element = document.getElementById(markerRef);
            if (!element) return;
            observer.disconnect();
            resolve(element);
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        setTimeout(()=>{
            observer.disconnect();
            const fallbackElement = document.getElementById(markerRef);
            resolve(fallbackElement);
        }, timeoutMs);
    });
};
const $0343eaf78527fd4c$export$6591627df1eb1f44 = async ({ markerRef: markerRef, commentId: commentId, timeoutMs: timeoutMs = 3000, getCommentThreadsRemovedByOtherUsers: getCommentThreadsRemovedByOtherUsers })=>{
    let element = null;
    if (markerRef) element = await $0343eaf78527fd4c$var$waitForCommentElement({
        markerRef: markerRef,
        timeoutMs: timeoutMs
    });
    // Check if comment was removed by another user BEFORE checking processed state
    // This check happens early because it's a specific known state
    // NOTE - we can't import the official type here due to circular dep concerns
    if (commentId) {
        const commentThreadsRemovedByOtherUsers = getCommentThreadsRemovedByOtherUsers?.();
        if (commentThreadsRemovedByOtherUsers?.[commentId] === 'deleted') return {
            status: "REMOVED_BY_ANOTHER_USER",
            element: undefined
        };
    }
    // Read processed state after DOM wait to avoid stale classification.
    const state = (0, $4L9ve.getProcessedCommentsDataState)();
    const rootComment = state.isDataProcessed && markerRef ? state.flatMarkerRefMap[markerRef] : undefined;
    if (element) {
        if (rootComment && (0, $kgNLQ.isCommentResolved)(rootComment)) return {
            status: "RESOLVED",
            element: undefined
        };
        return {
            status: "FOUND_IN_DOM",
            element: element
        };
    }
    // Comment marker is missing from the DOM — classify as DELETED_CONTENT or UNKNOWN.
    // Note: classification depends on cc_comments_new_comments_data_manager being enabled.
    // When disabled, state isn't populated so are forced into FOUND_IN_DOM or UNKNOWN
    if (!state.isDataProcessed) return {
        status: "UNKNOWN",
        element: undefined
    };
    const existsInData = rootComment || commentId && state.flatCommentsMap[commentId];
    return existsInData ? {
        status: "DELETED_CONTENT",
        element: undefined
    } : {
        status: "UNKNOWN",
        element: undefined
    };
};
module.exports["ShortcutType"] = $0343eaf78527fd4c$export$99058db374262376;
module.exports["ScrollBehavior"] = $0343eaf78527fd4c$export$e6e360ac7d345e5;
module.exports["NavigationContext"] = $0343eaf78527fd4c$export$3044ab7fdabeaee6;
module.exports["CommentNavigationStatus"] = $0343eaf78527fd4c$export$368ed1d84e0ae668;
module.exports["handleInlineAnnotationNavigation"] = $0343eaf78527fd4c$export$9f32f1ed184088e0;
module.exports["handleCommentsPanelNavigation"] = $0343eaf78527fd4c$export$390f6df30bfcd812;
module.exports["handleCommentsPanelNavigationWithViewChange"] = $0343eaf78527fd4c$export$dcd3c0d6a66d0412;
module.exports["handleFooterCommentsNavigation"] = $0343eaf78527fd4c$export$34fd7e98d0739b5c;
module.exports["handleDeepLinkNavigation"] = $0343eaf78527fd4c$export$ea1c337d9000e2;
module.exports["handleKeyboardShortcutNavigation"] = $0343eaf78527fd4c$export$807107038899c351;
module.exports["handleInlineHeaderArrowsNavigation"] = $0343eaf78527fd4c$export$36dad1a923539611;
module.exports["waitForCommentStatus"] = $0343eaf78527fd4c$export$6591627df1eb1f44;

});

parcelRegister("f6jYE", function(module, exports) {

let $afe6e99dc8e0d20c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $afe6e99dc8e0d20c$var$load("5J2Yz").then(()=>parcelRequire('gJcNU'));

});

parcelRegister("2VZOl", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $FOT9i.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $1P1Tu.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $9zUhf.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("8KbKw", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $04e9M = parcelRequire("04e9M");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $c0rhi = parcelRequire("c0rhi");


var $lR7wI = parcelRequire("lR7wI");


var $1sAC2 = parcelRequire("1sAC2");

const $6f395e426fb151a0$var$isContentNotFoundError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.message.includes('Invalid content id'));
    return false;
};
const $6f395e426fb151a0$export$e344958ab47793df = (0, $2XqLN.default)((contentId, draftShareId)=>async ()=>{
        const permissionsTokenState = (0, $1sAC2.nativeCollabPermissionsTokenState).getPermissionsTokenState(contentId);
        if (permissionsTokenState) {
            const { getToken: getToken, isUsedForDraftFetch: isUsedForDraftFetch, isUsedForWSInitialization: isUsedForWSInitialization } = permissionsTokenState;
            // fetchCollabPermissionToken should only return the token if it is valid and has successfully been passed to the getDraft call
            if (isUsedForDraftFetch && !isUsedForWSInitialization) {
                const token = await getToken;
                if (token) {
                    (0, $1sAC2.nativeCollabPermissionsTokenState).setIsUsedForWSInitialization(contentId, true);
                    return token;
                }
            }
        }
        try {
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            const result = await (0, $c0rhi.queryInterop)({
                query: (0, $lR7wI.default),
                variables: {
                    contentId: contentId,
                    ...draftShareId && {
                        draftShareId: draftShareId
                    }
                },
                fetchPolicy: 'network-only',
                context: {
                    fetchOptions: {
                        // If we have a "no network error" this will never resolve and subsequent calls will
                        // be in limbo. This means we are unable to ever connect to NCS again (requiring a page reset)
                        ignoreNoNetworkError: true
                    }
                },
                __callerPackage__: "@confluence/native-collab"
            });
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            const token = result.data?.collabToken?.token ?? null; // if token is null, collab service will fall back to permissions service check
            if (token === null && (0, $6mKj3.expVal)('platform_editor_emit_null_token_event', 'isEnabled', false)) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    action: 'nullTokenReturned',
                    actionSubject: 'collabPermissionToken',
                    source: 'fetchCollabPermissionToken',
                    attributes: {
                        reason: 'emptyResponse'
                    }
                });
            });
            return token;
        } catch (e) {
            (0, $7Sm4c.markErrorAsHandled)(e);
            if ($6f395e426fb151a0$var$isContentNotFoundError(e)) // nasty fragile hack, mimic 404 exception which goes through collab-provider, then gets wrapped and emitted and handled in `useError`.
            // collab provider simply emits errors thrown in permissionTokenRefresh directly on its internal channel, so we have to conform to their error type
            // prettier-ignore
            throw {
                message: "Content not found",
                data: {
                    status: 404,
                    code: "INSUFFICIENT_EDITING_PERMISSION",
                    meta: {
                        description: "RESOURCE_DELETED",
                        reason: "RESOURCE_DELETED"
                    }
                }
            };
            else if (e?.networkError?.response?.status === 503) // prettier-ignore
            throw {
                message: "Service unavailable",
                data: {
                    meta: {
                        reason: "RESOURCE_DELETED"
                    }
                }
            }; // temporary hack to ensure draft cannot be edited during tenant migration, but we should throw TENANT_INSTANCE_MAINTENANCE once supported by collab-provider
            if ((0, $6mKj3.expVal)('platform_editor_emit_null_token_event', 'isEnabled', false)) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    action: 'nullTokenReturned',
                    actionSubject: 'collabPermissionToken',
                    source: 'fetchCollabPermissionToken',
                    attributes: {
                        reason: 'fetchError'
                    }
                });
            });
            return null;
        }
    });
module.exports["fetchCollabPermissionToken"] = $6f395e426fb151a0$export$e344958ab47793df;

});

parcelRegister("9137z", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $e77725a58fc80757$export$d93492bf620814be = new (0, $kGrzq.BaseMeasures)();
module.exports["CollabEditProviderMeasures"] = $e77725a58fc80757$export$d93492bf620814be;

});

parcelRegister("j8hiR", function(module, exports) {
var $fbca710eb28c4147$export$d0a57beabaefb993 = /*#__PURE__*/ function(COLLAB_EDIT_PROVIDER_MEASURES) {
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH"] = "collabEditProviderAnalyticsFetch";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CREATED"] = "collabEditProviderCreated";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_DISABLED"] = "collabEditProviderDisabled";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT"] = "collabEditProviderInitialized";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRE_CONNECTED"] = "collabEditProviderPreconnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CONNECTED"] = "collabEditProviderConnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT_DOC"] = "collabEditProviderInitDoc";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT"] = "collabEditProviderFetchNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT"] = "collabEditProviderPreloadNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT"] = "collabEditProviderPreloadNCSDraftTimeout";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_PERMS_TOKEN_FETCH"] = "collabEditProviderPermsTokenFetch";
    return COLLAB_EDIT_PROVIDER_MEASURES;
}({});
module.exports["COLLAB_EDIT_PROVIDER_MEASURES"] = $fbca710eb28c4147$export$d0a57beabaefb993;

});

parcelRegister("lR7wI", function(module, exports) {
/**
 * @generated SignedSource<<a61063136e57f7cd39e5b8a983d46e87>>
 * @relayHash bd2d61cdca16378a4f1f566700b1fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69
const $4abe7e20c4ebe0be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "CollabTokenResponse",
            "kind": "LinkedField",
            "name": "collabToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "bd2d61cdca16378a4f1f566700b1fb56",
            "id": "5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69",
            "metadata": {},
            "name": "CollabPermissionTokenQuery",
            "operationKind": "query",
            "text": "query CollabPermissionTokenQuery($contentId:ID!,$draftShareId:String){collabToken(id:$contentId,draftShareId:$draftShareId){token}}"
        }
    };
}();
$4abe7e20c4ebe0be$var$node.hash = "f88c8dd0f4e61065305cc9c5b9a3253b";
var $4abe7e20c4ebe0be$export$2e2bcd8739ae039 = $4abe7e20c4ebe0be$var$node;
module.exports["default"] = $4abe7e20c4ebe0be$export$2e2bcd8739ae039;

});

parcelRegister("1sAC2", function(module, exports) {
class $3f756fb591e8330c$export$88b5d10ee0ed72d9 {
    getPermissionsTokenState(contentId) {
        return this.tokenState[contentId];
    }
    setToken(contentId, tokenPromise = Promise.resolve(null)) {
        // clear any existing tokens/bools in state
        this.tokenState[contentId] = {
            getToken: tokenPromise,
            isUsedForDraftFetch: false,
            isUsedForWSInitialization: false
        };
    }
    setIsUsedForDraftFetch(contentId, isUsedForDraftFetch) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForDraftFetch = isUsedForDraftFetch;
    }
    setIsUsedForWSInitialization(contentId, isUsedForWSInitialization) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForWSInitialization = isUsedForWSInitialization;
    }
    setTimestamp(contentId) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].timestamp = performance.now();
    }
    clearPermissionsTokenState(contentId) {
        if (this.tokenState[contentId]) delete this.tokenState[contentId];
    }
    constructor(){
        this.tokenState = {};
    }
}
const $3f756fb591e8330c$export$8e63d30e585828b3 = new $3f756fb591e8330c$export$88b5d10ee0ed72d9();
module.exports["nativeCollabPermissionsTokenState"] = $3f756fb591e8330c$export$8e63d30e585828b3;

});

parcelRegister("hQm1C", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a8b418da1bc27466$export$871388fb833dfa56 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "2M0Zq",
    name: "NativeCollabLoader",
    loader: async ()=>{
        const { NativeCollabComponent: NativeCollabComponent } = await (parcelRequire("9hbYF"));
        return NativeCollabComponent;
    }
});
module.exports["NativeCollabLoader"] = $a8b418da1bc27466$export$871388fb833dfa56;

});

parcelRegister("9hbYF", function(module, exports) {

let $6c0efe0c67fc83ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c0efe0c67fc83ba$var$load("h94bv"),
    $6c0efe0c67fc83ba$var$load("coUzl"),
    $6c0efe0c67fc83ba$var$load("5nMTY"),
    $6c0efe0c67fc83ba$var$load("kFiBp"),
    $6c0efe0c67fc83ba$var$load("daX4F"),
    $6c0efe0c67fc83ba$var$load("jZLnv"),
    $6c0efe0c67fc83ba$var$load("6edij"),
    $6c0efe0c67fc83ba$var$load("hXbzh"),
    $6c0efe0c67fc83ba$var$load("exa5h"),
    $6c0efe0c67fc83ba$var$load("8Iv0f"),
    $6c0efe0c67fc83ba$var$load("bGqrb"),
    $6c0efe0c67fc83ba$var$load("9StSe"),
    $6c0efe0c67fc83ba$var$load("ecwNN"),
    $6c0efe0c67fc83ba$var$load("gLFJS"),
    $6c0efe0c67fc83ba$var$load("el56J"),
    $6c0efe0c67fc83ba$var$load("lbsQO"),
    $6c0efe0c67fc83ba$var$load("hhss7"),
    $6c0efe0c67fc83ba$var$load("btqFK")
]).then(()=>parcelRequire('03pNx'));

});

parcelRegister("8Hqv7", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $9WAeG = parcelRequire("9WAeG");


var $7koGn = parcelRequire("7koGn");

const $6f5a0d3cf76b2edb$export$c4004a2b66cea884 = 'ssr-app/render/render-full-cycle';
function $6f5a0d3cf76b2edb$var$createFullCycleRenderRegistry() {
    const registry = new Set();
    function register(callback) {
        registry.add(callback);
    }
    function unregister(callback) {
        registry.delete(callback);
    }
    function notifyRenderComplete() {
        registry.forEach((callback)=>callback());
    }
    return {
        register: register,
        unregister: unregister,
        notifyRenderComplete: notifyRenderComplete
    };
}
const $6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac = $6f5a0d3cf76b2edb$var$createFullCycleRenderRegistry();
const $6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0 = ({ name: name, children: children })=>{
    const fullCycleSSRState = window.__FULLCYCLE_SSR__;
    const containerRef = (0, $42omo.useRef)(null);
    const onFullCycleRenderComplete = (0, $42omo.useCallback)(()=>{
        if (containerRef.current && fullCycleSSRState) {
            const html = (0, $7koGn.sanitizeInputLoadablesForSSR)(containerRef.current.innerHTML);
            fullCycleSSRState.htmlOutput[name] = html;
        }
    }, [
        name,
        fullCycleSSRState
    ]);
    (0, $42omo.useEffect)(()=>{
        $6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac.register(onFullCycleRenderComplete);
        return ()=>$6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac.unregister(onFullCycleRenderComplete);
    }, [
        onFullCycleRenderComplete
    ]);
    return null;
};
const $6f5a0d3cf76b2edb$export$f81c4bd5356d97f8 = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-test-id": "fullCycleOutput"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $6f5a0d3cf76b2edb$export$8f3a9d27aa76c470 = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { name: name, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const renders = (0, $42omo.useRef)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id, phase, actualDuration)=>{
            const updateName = `${id}/${phase}`;
            renders.current[updateName] = (renders.current[updateName] || 0) + 1;
            (0, $9WAeG.SSRMeasures).addMeasure(`${$6f5a0d3cf76b2edb$export$c4004a2b66cea884}/${updateName}/${renders.current[updateName]}`, actualDuration, true);
        };
        $[1] = t2;
    } else t2 = $[1];
    const onRender = t2;
    if (!(0, $9wGTI.fg)("confluence_profile_fullcycle")) {
        let t3;
        if ($[2] !== children || $[3] !== name) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0, {
                name: name
            }, children);
            $[2] = children;
            $[3] = name;
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    let t3;
    if ($[5] !== children || $[6] !== name) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0, {
            name: name
        }, children);
        $[5] = children;
        $[6] = name;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== name || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Profiler), {
            id: name,
            onRender: onRender
        }, t3);
        $[8] = name;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FullCycleRenderWrapper"] = $6f5a0d3cf76b2edb$export$f81c4bd5356d97f8;
module.exports["FullCycleRenderWithProfiler"] = $6f5a0d3cf76b2edb$export$8f3a9d27aa76c470;

});

parcelRegister("7koGn", function(module, exports) {
const $a4af1bafcd952bf9$var$MARKER_REGEX = /<input(?:\s?type="hidden")? data-loadable-(begin|end)="([^"]*)"(?:\sdata-ssr-placeholder-id="([^"]*)")?(?:\sdata-debug-name="([^"]*)")?\s*?(?:\s?type="hidden")?\s*>(?!\s*<\/input>)/g;
function $a4af1bafcd952bf9$export$7400f7b8afb970c2(html) {
    return html.replace($a4af1bafcd952bf9$var$MARKER_REGEX, (inputTag)=>{
        return `${inputTag.slice(0, -1)} />`;
    });
}
module.exports["sanitizeInputLoadablesForSSR"] = $a4af1bafcd952bf9$export$7400f7b8afb970c2;

});

parcelRegister("6gETM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");

const $5ed14ae7f856df1d$export$204c1449657d49fd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
const $5ed14ae7f856df1d$export$ae764d691d5f37c6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3loHF",
    name: "TreeRootForServerPlaceholder",
    loader: async ()=>$5ed14ae7f856df1d$export$204c1449657d49fd,
    _reactTreeRootForServerPlaceholderId: true
});
const $5ed14ae7f856df1d$export$4279728e9b12d235 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ed14ae7f856df1d$export$ae764d691d5f37c6, null, children);
};
module.exports["TreeRootForServerPlaceholderWrapper"] = $5ed14ae7f856df1d$export$4279728e9b12d235;

});

parcelRegister("8jRXE", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ba942ead23497767$export$d49c8c8cf1b10f7e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ynpC3",
    name: "FullPageEditorLoader",
    loader: async ()=>{
        const { FullPageEditorComponent: FullPageEditorComponent } = await (parcelRequire("jNi1z"));
        return FullPageEditorComponent;
    }
});
module.exports["FullPageEditorLoader"] = $ba942ead23497767$export$d49c8c8cf1b10f7e;

});

parcelRegister("jNi1z", function(module, exports) {

let $e69093289b2e7598$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e69093289b2e7598$var$load("1OPxx"),
    $e69093289b2e7598$var$load("h3ABO"),
    $e69093289b2e7598$var$load("2YffH"),
    $e69093289b2e7598$var$load("6wr18"),
    $e69093289b2e7598$var$load("hwUDh"),
    $e69093289b2e7598$var$load("i6s2m"),
    $e69093289b2e7598$var$load("dwSiO"),
    $e69093289b2e7598$var$load("7JaVh"),
    $e69093289b2e7598$var$load("4PgR7"),
    $e69093289b2e7598$var$load("1V37g"),
    $e69093289b2e7598$var$load("2LxnN"),
    $e69093289b2e7598$var$load("e2ahM"),
    $e69093289b2e7598$var$load("8GSpT"),
    $e69093289b2e7598$var$load("4xgpM"),
    $e69093289b2e7598$var$load("bIAIU"),
    $e69093289b2e7598$var$load("cmqxT"),
    $e69093289b2e7598$var$load("kaAxH"),
    $e69093289b2e7598$var$load("blwYk"),
    $e69093289b2e7598$var$load("c6VA1"),
    $e69093289b2e7598$var$load("2MTmD"),
    $e69093289b2e7598$var$load("2wRqX"),
    $e69093289b2e7598$var$load("50D4z"),
    $e69093289b2e7598$var$load("j9Q0e"),
    $e69093289b2e7598$var$load("4oXMS"),
    $e69093289b2e7598$var$load("abd2b"),
    $e69093289b2e7598$var$load("bzyKp"),
    $e69093289b2e7598$var$load("k3yUD"),
    $e69093289b2e7598$var$load("67Alm"),
    $e69093289b2e7598$var$load("b11Cj"),
    $e69093289b2e7598$var$load("2F69B"),
    $e69093289b2e7598$var$load("9anPW"),
    $e69093289b2e7598$var$load("6iz6l"),
    $e69093289b2e7598$var$load("4SCW2"),
    $e69093289b2e7598$var$load("2jJ1i"),
    $e69093289b2e7598$var$load("bd77Q"),
    $e69093289b2e7598$var$load("5lTVp"),
    $e69093289b2e7598$var$load("lWNY8"),
    $e69093289b2e7598$var$load("e2WH6"),
    $e69093289b2e7598$var$load("ffEVr"),
    $e69093289b2e7598$var$load("hxmLu"),
    $e69093289b2e7598$var$load("1oUEV"),
    $e69093289b2e7598$var$load("a0cZb"),
    $e69093289b2e7598$var$load("RXMWr"),
    $e69093289b2e7598$var$load("jLwPS"),
    $e69093289b2e7598$var$load("9IMTL"),
    $e69093289b2e7598$var$load("coUzl"),
    $e69093289b2e7598$var$load("5nMTY"),
    $e69093289b2e7598$var$load("7j0mT"),
    $e69093289b2e7598$var$load("69R9L"),
    $e69093289b2e7598$var$load("zSp86"),
    $e69093289b2e7598$var$load("Wowvf"),
    $e69093289b2e7598$var$load("1F7LX"),
    $e69093289b2e7598$var$load("c6DIp"),
    $e69093289b2e7598$var$load("dgH7p"),
    $e69093289b2e7598$var$load("3Llsl"),
    $e69093289b2e7598$var$load("jZLnv"),
    $e69093289b2e7598$var$load("6edij"),
    $e69093289b2e7598$var$load("hXbzh"),
    $e69093289b2e7598$var$load("hhss7"),
    $e69093289b2e7598$var$load("f2Ovh"),
    $e69093289b2e7598$var$load("lAHER"),
    $e69093289b2e7598$var$load("7EorR"),
    $e69093289b2e7598$var$load("eiF7i"),
    $e69093289b2e7598$var$load("h94bv"),
    $e69093289b2e7598$var$load("7x00I")
]).then(()=>parcelRequire('h1Y8a'));

});

parcelRegister("34NZw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d52b69b4dbbb4bb4$export$e6747c633274762a = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "UL-jW",
    name: "PageShownPublicLinksEventLoader",
    loader: async ()=>{
        const { PageShownPublicLinksEvent: PageShownPublicLinksEvent } = await (parcelRequire("hyyt3"));
        return PageShownPublicLinksEvent;
    }
});
module.exports["PageShownPublicLinksEventLoader"] = $d52b69b4dbbb4bb4$export$e6747c633274762a;

});

parcelRegister("hyyt3", function(module, exports) {

let $cc805933f0615777$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc805933f0615777$var$load("bRqDI"),
    $cc805933f0615777$var$load("63zHi")
]).then(()=>parcelRequire('jvel0'));

});

parcelRegister("cZa7r", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $42omo = parcelRequire("42omo");


var $cVw8q = parcelRequire("cVw8q");


var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $afGoD = parcelRequire("afGoD");


var $9QIM2 = parcelRequire("9QIM2");


var $gczDe = parcelRequire("gczDe");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $8WQTF = parcelRequire("8WQTF");

const $d99a6317060f344e$export$4162754b616020bc = 2000;
const $d99a6317060f344e$export$39085f26fb4d6afa = /*#__PURE__*/ (0, $42omo.createContext)({
    selectionProps: null,
    hoverProps: null,
    viewProps: null,
    editorCreateProps: null,
    editorViewProps: null,
    showCreateComponent: false,
    showHighlightActions: false,
    selectionOptions: undefined,
    stepGenerationError: false,
    newlyCreatedAnnotationId: undefined,
    commentSidebarContext: null,
    isOffline: false,
    storedCommentData: null
});
$d99a6317060f344e$export$39085f26fb4d6afa.displayName = 'AnnotationsContext';
const $d99a6317060f344e$export$57d1b2fe9544d93c = /*#__PURE__*/ (0, $42omo.createContext)(false);
$d99a6317060f344e$export$57d1b2fe9544d93c.displayName = 'AnnotationsOfflineContext';
const $d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider = ({ children: children, value: value })=>{
    if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$57d1b2fe9544d93c.Provider, {
        value: value
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $d99a6317060f344e$export$6e641cb791644965 = /*#__PURE__*/ (0, $42omo.createContext)({
    setSelectionProps: ()=>{},
    setHoverProps: ()=>{},
    setViewProps: ()=>{},
    setEditorCreateProps: ()=>{},
    setEditorViewProps: ()=>{},
    setShowCreateComponent: ()=>{},
    setShowHighlightActions: ()=>{},
    setSelectionOptions: ()=>{},
    setStepGenerationError: ()=>{},
    setSelectionOptionsForCreateEditor: ()=>{},
    setNewlyCreatedAnnotationId: ()=>{},
    setCommentSidebarContext: ()=>{},
    handleSaveSuccess: ()=>{},
    handleClose: ()=>{},
    setIsOffline: ()=>{},
    setStoredCommentData: ()=>{},
    clearStoredCommentData: ()=>{},
    waitForAnnotationElementAndEmit: ()=>{}
});
$d99a6317060f344e$export$6e641cb791644965.displayName = 'AnnotationDispatchContext';
const $d99a6317060f344e$export$567c82ef93e7d5a1 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
$d99a6317060f344e$export$567c82ef93e7d5a1.displayName = 'AnnotationManagerContext';
const $d99a6317060f344e$export$22e6290b4a8e41d3 = ({ children: children })=>{
    const [selectionProps, setSelectionProps] = (0, $42omo.useState)(null);
    const [hoverProps, setHoverProps] = (0, $42omo.useState)(null);
    const [viewProps, setViewProps] = (0, $42omo.useState)(null);
    const [editorCreateProps, setEditorCreateProps] = (0, $42omo.useState)(null);
    const [editorViewProps, setEditorViewProps] = (0, $42omo.useState)(null);
    const [showCreateComponent, setShowCreateComponent] = (0, $42omo.useState)(false);
    const [showHighlightActions, setShowHighlightActions] = (0, $42omo.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $42omo.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $42omo.useState)(false);
    const [newlyCreatedAnnotationId, setNewlyCreatedAnnotationId] = (0, $42omo.useState)();
    const [commentSidebarContext, setCommentSidebarContext] = (0, $42omo.useState)(null);
    const [prevContentId, setPrevContentId] = (0, $42omo.useState)(null);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const annotationManager = (0, $42omo.useMemo)(()=>(0, $9wGTI.fg)('platform_editor_comments_api_manager') ? (0, $cVw8q.createAnnotationManager)() : undefined, []);
    // This is effectively used with editorCreateProps and editorViewProps but we're tracking it independently as it doesn't really tie into the same lifecycle events
    const [isOffline, setIsOffline] = (0, $42omo.useState)(false);
    // Stored comment data for direct data flow
    const [storedCommentData, setStoredCommentData] = (0, $42omo.useState)(null);
    // Track active MutationObserver and timeout for cleanup on unmount
    const activeObserverRef = (0, $42omo.useRef)(null);
    const activeTimeoutRef = (0, $42omo.useRef)(null);
    /**
   * Waits for an annotation element to appear in the DOM using MutationObserver,
   * then emits annotation selection events. If element doesn't appear within 2 seconds,
   * fails the VIEW_INLINE_COMMENT_EXPERIENCE.
   */ const waitForAnnotationElementAndEmit = (0, $42omo.useCallback)((annotationId, emitter)=>{
        // Clean up any existing observer/timeout before creating new ones
        if (activeObserverRef.current) activeObserverRef.current.disconnect();
        if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
        // Use MutationObserver to wait for element to appear in DOM
        activeObserverRef.current = new MutationObserver(()=>{
            const element = document.getElementById(annotationId);
            if (element) {
                if (activeObserverRef.current) activeObserverRef.current.disconnect();
                if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
                activeObserverRef.current = null;
                activeTimeoutRef.current = null;
                // Emit annotation events and check if listeners exist
                if (emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: element
                })) {
                    emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: annotationId
                    });
                    setNewlyCreatedAnnotationId(annotationId);
                } else // No listeners registered - fail the experience
                experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Failed to emit annotation click')
                });
            }
        });
        // Observe the renderer wrapper for child additions (fallback to document.body for safety)
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper') || document.body;
        activeObserverRef.current.observe(rendererWrapper, {
            childList: true,
            subtree: true
        });
        // Fallback: If element doesn't appear within timeout, fail the experience
        // This almost always happens due to super slow re-renders (slow client on large page)
        activeTimeoutRef.current = setTimeout(()=>{
            if (activeObserverRef.current) activeObserverRef.current.disconnect();
            activeObserverRef.current = null;
            activeTimeoutRef.current = null;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`Annotation element not found in DOM after ${$d99a6317060f344e$export$4162754b616020bc}ms`)
            });
        }, $d99a6317060f344e$export$4162754b616020bc);
    }, [
        experienceTracker,
        setNewlyCreatedAnnotationId
    ]);
    // Cleanup observer and timeout on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (activeObserverRef.current) {
                activeObserverRef.current.disconnect();
                activeObserverRef.current = null;
            }
            if (activeTimeoutRef.current) {
                clearTimeout(activeTimeoutRef.current);
                activeTimeoutRef.current = null;
            }
        };
    }, []);
    // Get rendererActions for renderer mode (always call hook, but only use when feature gate is enabled)
    const rendererActionsHook = (0, $8WQTF.useRendererActions)();
    const rendererActions = rendererActionsHook?.rendererActions;
    (0, $42omo.useEffect)(()=>{
        const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
        function handleAnnotationFocus({ annotationId: annotationId }) {
            // The fact annotations is an array here is meaningless at this time - Confluence
            // always picks the top annotation
            const focusedAnnotation = annotationId;
            if (!focusedAnnotation) {
                // If there is no running experience -- then this is a noop.
                (0, $4EKKB.selectInlineComment).debug('Renderer emitted event indicating no focused annotation.');
                return;
            }
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.complete({
                pageClass: pageClass,
                entryPoint: 'unknown:RendererFocus',
                annotationId: focusedAnnotation
            });
        }
        // Fired when an annotation is focused (ie. comment navigation, comment click)
        emitter.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        return ()=>{
            emitter.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        };
    }, [
        pageClass
    ]);
    const resetProviderState = (0, $42omo.useCallback)(()=>{
        setSelectionProps(null);
        setHoverProps(null);
        setViewProps(null);
        setEditorCreateProps(null);
        setEditorViewProps(null);
        setShowCreateComponent(false);
        setShowHighlightActions(false);
        setSelectionOptions(undefined);
        setStepGenerationError(false);
        setNewlyCreatedAnnotationId(undefined);
        setCommentSidebarContext(null);
        setStoredCommentData(null);
    }, []);
    // When the content ID changes, reset the provider state
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        if (prevContentId && contentId !== prevContentId) {
            resetProviderState();
            // Deselect any currently selected annotations
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
        }
        setPrevContentId(contentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        setSelectionOptions(undefined);
        if (annotationManager) annotationManager.clearDraft();
        else selectionProps && selectionProps.onClose();
        setSelectionProps(null);
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        selectionProps,
        annotationManager
    ]);
    /*
   * NOTE: This function will not be calling setShowCreateComponent because it's
   *       consumers will not be refreshing themselves with new selectionOptions.
   *       It will now be the responsibility of the consumers of this function to call
   *       setShowCreateComponent(true). See SelectionComponent.tsx (~line 132)
   */ const setSelectionOptionsForCreateEditor = (0, $42omo.useCallback)(({ experienceAttributes: experienceAttributes } = {})=>{
        setShowCreateComponent(false); // Hide an existing create component if it exists
        const annotationId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        // Narrow pageClass to 'renderer' | 'editor' for the experience attributes
        const pageClassAttr = pageClass === 'renderer' ? 'renderer' : 'editor';
        (0, $3YBks.createInlineCommentCompoundExperience).start({
            attributes: {
                pageClass: pageClassAttr,
                commentType: 'inline',
                annotationId: annotationId,
                ...experienceAttributes
            }
        });
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        let result = undefined;
        if (annotationManager) {
            const startDraftResult = annotationManager.startDraft();
            if (startDraftResult.success) result = startDraftResult.actionResult;
        } else {
            if (!selectionProps) {
                // selectionProps is not defined. This may occur if a comment sidebar box was just closed, which
                // unsets selectionProps. In this case, we treat this as no-op, and unselect any annotation.
                (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                // We soft-fail create-inline-comment/init experience here to track how often this occurs.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Attempted to create inline comment when no selection was present'));
                return;
            }
            result = selectionProps.applyDraftMode({
                annotationId: annotationId,
                keepNativeSelection: false
            });
        }
        const ancestorNodeTypes = result?.ancestorNodeTypes ?? [];
        const alphabeticalAncestorNodeTypes = [
            ...ancestorNodeTypes
        ].sort();
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: result?.inlineNodeTypes ?? [],
            ancestorNodeTypes: ancestorNodeTypes,
            alphabeticalAncestorNodeTypes: alphabeticalAncestorNodeTypes,
            // @ts-ignore
            initialPosition: [
                result?.step?.from,
                result?.step?.to
            ]
        });
        if (result) {
            setSelectionOptions({
                step: result.step,
                inlineNodeTypes: result.inlineNodeTypes,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                pos: result.pos,
                targetNodeType: result.targetNodeType
            });
            // Tell the renderer to close any currently-open comments
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            setShowHighlightActions(false);
        } else {
            setStepGenerationError(true);
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Failed to generate step'));
        }
    }, [
        selectionProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setStepGenerationError,
        annotationManager,
        pageClass
    ]);
    const handleSaveSuccess = (0, $42omo.useCallback)((annotationId, commentData)=>{
        setStepGenerationError(false);
        setCommentSidebarContext('create');
        // Set stored comment data for direct data flow when experiment is enabled
        if (commentData) setStoredCommentData(commentData);
        let result = false;
        if (annotationManager) {
            const result = annotationManager.applyDraft(annotationId);
            if (result.success && !!result.actionResult?.doc) {
                selectionProps.updateDocument && selectionProps.updateDocument(result.actionResult.doc);
                setNewlyCreatedAnnotationId(annotationId);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else // Renderer mode: Try using rendererActions.applyAnnotation() first (similar to editor's annotationManager.applyDraft())
        // This provides more reliable annotation application, matching the editor implementation
        if (rendererActions && selectionOptions?.step) {
            const step = selectionOptions.step;
            // Extract position from step - use pos if available, otherwise use from/to
            const position = selectionOptions.pos ? {
                to: selectionOptions.pos,
                from: selectionOptions.pos
            } : {
                to: step.to,
                from: step.from
            };
            const annotationResult = rendererActions.applyAnnotation(position, {
                annotationId: annotationId,
                annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
            });
            if (annotationResult && annotationResult.doc) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(annotationResult.doc);
                waitForAnnotationElementAndEmit(annotationId, emitter);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else {
            // Fallback to original onCreate method
            // Since we generated the uuid ourselves, we need to replace the document generated with
            // the annotationId that we received from the backend so things line up correctly
            result = selectionProps.onCreate(annotationId);
            if (result) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(result.doc);
                waitForAnnotationElementAndEmit(annotationId, emitter);
            } else throw new Error('Error ocurred when applying the step to the active document');
        }
    }, [
        annotationManager,
        setStepGenerationError,
        setNewlyCreatedAnnotationId,
        selectionProps,
        setStoredCommentData,
        storedCommentData,
        rendererActions,
        selectionOptions,
        waitForAnnotationElementAndEmit
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>({
            selectionProps: selectionProps,
            hoverProps: hoverProps,
            viewProps: viewProps,
            editorCreateProps: editorCreateProps,
            editorViewProps: editorViewProps,
            showCreateComponent: showCreateComponent,
            showHighlightActions: showHighlightActions,
            selectionOptions: selectionOptions,
            stepGenerationError: stepGenerationError,
            newlyCreatedAnnotationId: newlyCreatedAnnotationId,
            commentSidebarContext: commentSidebarContext,
            isOffline: isOffline,
            storedCommentData: storedCommentData
        }), [
        selectionProps,
        hoverProps,
        viewProps,
        editorCreateProps,
        editorViewProps,
        showCreateComponent,
        showHighlightActions,
        selectionOptions,
        stepGenerationError,
        newlyCreatedAnnotationId,
        commentSidebarContext,
        isOffline,
        storedCommentData
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setSelectionProps: setSelectionProps,
            setHoverProps: setHoverProps,
            setViewProps: setViewProps,
            setEditorCreateProps: setEditorCreateProps,
            setEditorViewProps: setEditorViewProps,
            setShowCreateComponent: setShowCreateComponent,
            setShowHighlightActions: setShowHighlightActions,
            setSelectionOptions: setSelectionOptions,
            setStepGenerationError: setStepGenerationError,
            setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor,
            setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId,
            setCommentSidebarContext: setCommentSidebarContext,
            handleSaveSuccess: handleSaveSuccess,
            handleClose: handleClose,
            setIsOffline: setIsOffline,
            // Stored comment data management functions
            setStoredCommentData: (commentData)=>setStoredCommentData(commentData ?? null),
            clearStoredCommentData: ()=>setStoredCommentData(null),
            waitForAnnotationElementAndEmit: waitForAnnotationElementAndEmit
        }), [
        setSelectionProps,
        setHoverProps,
        setViewProps,
        setEditorCreateProps,
        setEditorViewProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setSelectionOptions,
        setStepGenerationError,
        setSelectionOptionsForCreateEditor,
        setNewlyCreatedAnnotationId,
        setCommentSidebarContext,
        handleSaveSuccess,
        handleClose,
        setIsOffline,
        // Stored comment data management functions
        setStoredCommentData,
        waitForAnnotationElementAndEmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$567c82ef93e7d5a1.Provider, {
        value: annotationManager
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$39085f26fb4d6afa.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$6e641cb791644965.Provider, {
        value: dispatchProviderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider, {
        value: isOffline
    }, children))));
};
const $d99a6317060f344e$export$ede9be424e8ef89a = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$39085f26fb4d6afa);
};
const $d99a6317060f344e$export$3be336e5c3e78567 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$6e641cb791644965);
};
const $d99a6317060f344e$export$3998d49469d13f97 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$567c82ef93e7d5a1);
};
const $d99a6317060f344e$export$3757730e05e42ee2 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$57d1b2fe9544d93c);
};
module.exports["AnnotationsProvider"] = $d99a6317060f344e$export$22e6290b4a8e41d3;
module.exports["useAnnotations"] = $d99a6317060f344e$export$ede9be424e8ef89a;
module.exports["useAnnotationsDispatch"] = $d99a6317060f344e$export$3be336e5c3e78567;
module.exports["useAnnotationManager"] = $d99a6317060f344e$export$3998d49469d13f97;
module.exports["useAnnotationsIsOffline"] = $d99a6317060f344e$export$3757730e05e42ee2;

});

parcelRegister("afGoD", function(module, exports) {
/**
 * @generated SignedSource<<71be4194137313c8ff0872a3df259dda>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f8b43d46712cd783$export$cdccd0683766be81 = /*#__PURE__*/ function(CommentCreationLocation) {
    CommentCreationLocation["DATABASE"] = "DATABASE";
    CommentCreationLocation["EDITOR"] = "EDITOR";
    CommentCreationLocation["LIVE"] = "LIVE";
    CommentCreationLocation["RENDERER"] = "RENDERER";
    CommentCreationLocation["WHITEBOARD"] = "WHITEBOARD";
    return CommentCreationLocation;
}({});
var $f8b43d46712cd783$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $f8b43d46712cd783$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $f8b43d46712cd783$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentCreationLocation"] = $f8b43d46712cd783$export$cdccd0683766be81;

});

parcelRegister("9QIM2", function(module, exports) {

var $de2j9 = parcelRequire("de2j9");


var $3jwuS = parcelRequire("3jwuS");


var $dPJCf = parcelRequire("dPJCf");


var $gEtAQ = parcelRequire("gEtAQ");

function $06d23c10422abe2f$export$d9ae12e82c9f2aba() {
    // Note -- this hook does not inform the consumer if they are on a live doc page which
    // is using the editor.
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    // useRouteName use RoutesContext which is more reliable than reading window.location.pathname directly.
    const routeName = (0, $dPJCf.useRouteName)({
        selector: (name)=>name
    });
    if (isEditorPage) return 'editor';
    if (isCurrentPageLive) return 'editor';
    const isTinyMCEPage = $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage();
    if (isTinyMCEPage) // TinyMCE pages are not considered editor pages or docs in the context of this hook
    return 'tinyMCE';
    // Pass routeName to isDatabase/isWhiteboard - they will use it to avoid race conditions during SPA transitions
    if ((0, $gEtAQ.isDatabase)(routeName)) return 'database';
    if ((0, $gEtAQ.isWhiteboard)(routeName)) return 'whiteboard';
    if ((0, $gEtAQ.isSlides)(routeName)) return 'slide';
    return 'renderer';
}
function $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage() {
    const possibleTinyMCESelectors = [
        `[data-testid="TinyMCERendererTestId"]`,
        '.tinymce-editor'
    ];
    // This check is only relevant in the context of comment experiences
    // and so if we are in an environment without a document -- we
    // can safely treat it as not a tinymce page.
    if (typeof document === 'undefined') return false;
    const isTinyMCEPage = possibleTinyMCESelectors.some((selector)=>document.querySelector(selector) !== null);
    return isTinyMCEPage;
}
module.exports["usePageClass"] = $06d23c10422abe2f$export$d9ae12e82c9f2aba;

});

parcelRegister("3YBks", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $gtj7V = parcelRequire("gtj7V");

let $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
let $3ac00da98b683ca3$var$runningExperiences = [];
// Note: The soft failure is set on the first soft failure not updated following
let $3ac00da98b683ca3$var$softFailure = undefined;
let $3ac00da98b683ca3$var$publishFailed = false;
let $3ac00da98b683ca3$var$publishSuccessCount = 0;
function $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug(experienceName) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceAttributes = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
                source: experienceName,
                attributes: {
                    ...experienceAttributes,
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
                    ...extraAttributes,
                    error: error.message || String(error),
                    stack: error.stack
                }
            }
        }).fire();
    }
    return createInlineCommentExperienceDebug;
}
const $3ac00da98b683ca3$export$90894e50be2305e9 = {
    start: function createInlineCommentCompoundExperience({ attributes: attributes }) {
        // reset common experience state when starting a new parent experience
        $3ac00da98b683ca3$var$runningExperiences = [
            (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)
        ];
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
        $3ac00da98b683ca3$var$softFailure = undefined;
        $3ac00da98b683ca3$var$publishFailed = false;
        $3ac00da98b683ca3$var$publishSuccessCount = 0;
        const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.start({
            name: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
            id: compoundTaskId,
            attributes: {
                ...attributes,
                compoundTaskId: compoundTaskId,
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
            },
            collect: (events, experience)=>{
                (0, $1A7bE.collectAll)([
                    (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ])(events, experience);
            }
        });
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            compoundTaskId: compoundTaskId,
            annotationId: attributes.annotationId,
            pageClass: attributes.pageClass,
            entryPoint: attributes.entryPoint,
            edition: attributes.edition,
            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
        };
    },
    debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)),
    addCommonAttributes: (commonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
            ...commonAttributes
        };
        for (const runningExperience of $3ac00da98b683ca3$var$runningExperiences)experienceTracker.updateAttributes({
            name: runningExperience,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    attachCommonAttributes: (experienceName)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.updateAttributes({
            name: experienceName,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    initExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                timeout: 5000,
                attributes: {
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
                }
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
        },
        fail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                error: error
            });
        },
        softFail: (error)=>{
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'init'
            };
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        /**
     * This completes the init experience and starts the draft to publish experience.
     */ complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    draftToPublishExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
        },
        publishFailed: (error)=>{
            $3ac00da98b683ca3$var$publishFailed = true;
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'publish-failed'
            };
        },
        publishSucceeded: ()=>{
            $3ac00da98b683ca3$var$publishSuccessCount += 1;
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        stopOnError: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.stopOnError({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        dismissed: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$publishSuccessCount > 0) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish success')
            });
            else if ($3ac00da98b683ca3$var$publishFailed) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish attempt')
            });
            else experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: 'Draft comment dismissed'
            });
        },
        softFail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'multiple-saves-without-error'
            };
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    attachCommentExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                // If the view comment does not load in 6 seconds, it's
                // an indicator something has gone wrong.
                timeout: 6000,
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    }
};
module.exports["createInlineCommentCompoundExperience"] = $3ac00da98b683ca3$export$90894e50be2305e9;

});

parcelRegister("lNzoy", function(module, exports) {

let $fde9a14c531f21a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fde9a14c531f21a6$var$load("9lUu8"),
    $fde9a14c531f21a6$var$load("4aHyS"),
    $fde9a14c531f21a6$var$load("6Naxm"),
    $fde9a14c531f21a6$var$load("6wr18"),
    $fde9a14c531f21a6$var$load("4dNRa"),
    $fde9a14c531f21a6$var$load("cYfEG"),
    $fde9a14c531f21a6$var$load("4Ig4q"),
    $fde9a14c531f21a6$var$load("k2R9e"),
    $fde9a14c531f21a6$var$load("7kkP6"),
    $fde9a14c531f21a6$var$load("19uFC"),
    $fde9a14c531f21a6$var$load("3g3jg"),
    $fde9a14c531f21a6$var$load("1GCFv"),
    $fde9a14c531f21a6$var$load("ffEVr"),
    $fde9a14c531f21a6$var$load("aDjtG")
]).then(()=>parcelRequire('fJXL7'));

});

parcelRegister("kvrFT", function(module, exports) {

let $eedc2b8a70ca482f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eedc2b8a70ca482f$var$load("6wr18"),
    $eedc2b8a70ca482f$var$load("9Q8Ik"),
    $eedc2b8a70ca482f$var$load("3FG3M"),
    $eedc2b8a70ca482f$var$load("8eNS3"),
    $eedc2b8a70ca482f$var$load("iLTLW"),
    $eedc2b8a70ca482f$var$load("5p0Bu"),
    $eedc2b8a70ca482f$var$load("lUFbG"),
    $eedc2b8a70ca482f$var$load("e6e7M"),
    $eedc2b8a70ca482f$var$load("llxGi"),
    $eedc2b8a70ca482f$var$load("ffEVr"),
    $eedc2b8a70ca482f$var$load("hOaAV"),
    $eedc2b8a70ca482f$var$load("lFAez"),
    $eedc2b8a70ca482f$var$load("1qlDN"),
    $eedc2b8a70ca482f$var$load("1yVM6"),
    $eedc2b8a70ca482f$var$load("cEqm7"),
    $eedc2b8a70ca482f$var$load("6XCf4"),
    $eedc2b8a70ca482f$var$load("651dU")
]).then(()=>parcelRequire('gDZU2'));

});

parcelRegister("lt6Lx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $aXWIB.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { siteTitle: siteTitle } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title — but only when this render has no
    // meaningful content to contribute. If contentTitle, titlePrefix, notFound,
    // isHomePage, or siteTitleOnly are set, we must still update the title
    // (e.g. relay race: new page renders before old cleanup effect runs).
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence").
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    // A title is considered "specific" if it provides either a contentTitle or a titlePrefix.
    // Pages like the advanced search page pass a titlePrefix (e.g. "Search") without a
    // contentTitle, and we must still allow that title to replace the previous page's title
    // during client-side navigation. notFound, isHomePage, and siteTitleOnly are also
    // meaningful signals that must always be allowed to update the title.
    if (typeof document !== 'undefined' && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) {
        // If contentTitle, titlePrefix, notFound, isHomePage, and siteTitleOnly are all empty/false,
        // we're likely setting a generic title (just siteTitle or siteTitle with space).
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip.
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("9bk2S", function(module, exports) {

let $6af4b0c184f38816$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6af4b0c184f38816$var$load("7HPPR"),
    $6af4b0c184f38816$var$load("6kXh6"),
    $6af4b0c184f38816$var$load("4JAC8"),
    $6af4b0c184f38816$var$load("kKNsN")
]).then(()=>parcelRequire('1vSpd'));

});

parcelRegister("eDS9F", function(module, exports) {

let $aa8eb741adc5bd53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa8eb741adc5bd53$var$load("czd3n"),
    $aa8eb741adc5bd53$var$load("jlCbV"),
    $aa8eb741adc5bd53$var$load("7gkvG"),
    $aa8eb741adc5bd53$var$load("h94bv"),
    $aa8eb741adc5bd53$var$load("6wr18"),
    $aa8eb741adc5bd53$var$load("cCHYW"),
    $aa8eb741adc5bd53$var$load("iZnOu"),
    $aa8eb741adc5bd53$var$load("hgiUY"),
    $aa8eb741adc5bd53$var$load("9StSe"),
    $aa8eb741adc5bd53$var$load("4PgR7"),
    $aa8eb741adc5bd53$var$load("cwwTu"),
    $aa8eb741adc5bd53$var$load("5Raqr"),
    $aa8eb741adc5bd53$var$load("iOaZJ"),
    $aa8eb741adc5bd53$var$load("iK6Gk"),
    $aa8eb741adc5bd53$var$load("gskl6"),
    $aa8eb741adc5bd53$var$load("brdE2"),
    $aa8eb741adc5bd53$var$load("g5HUX"),
    $aa8eb741adc5bd53$var$load("c39Xf"),
    $aa8eb741adc5bd53$var$load("5ra3E"),
    $aa8eb741adc5bd53$var$load("gufL1"),
    $aa8eb741adc5bd53$var$load("24OMS"),
    $aa8eb741adc5bd53$var$load("gLFJS"),
    $aa8eb741adc5bd53$var$load("35X59"),
    $aa8eb741adc5bd53$var$load("jrCdz"),
    $aa8eb741adc5bd53$var$load("hOaAV"),
    $aa8eb741adc5bd53$var$load("lFAez"),
    $aa8eb741adc5bd53$var$load("1qlDN"),
    $aa8eb741adc5bd53$var$load("1yVM6"),
    $aa8eb741adc5bd53$var$load("cEqm7"),
    $aa8eb741adc5bd53$var$load("6XCf4"),
    $aa8eb741adc5bd53$var$load("ffEVr"),
    $aa8eb741adc5bd53$var$load("9DBoM"),
    $aa8eb741adc5bd53$var$load("lmyjp"),
    $aa8eb741adc5bd53$var$load("j6RYV")
]).then(()=>parcelRequire('5y7xd'));

});

parcelRegister("7WjJq", function(module, exports) {

let $5c7d41786288b00b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5c7d41786288b00b$var$load("czd3n"),
    $5c7d41786288b00b$var$load("4oXMS"),
    $5c7d41786288b00b$var$load("h94bv"),
    $5c7d41786288b00b$var$load("bLm2D"),
    $5c7d41786288b00b$var$load("6wr18"),
    $5c7d41786288b00b$var$load("9eStK"),
    $5c7d41786288b00b$var$load("khj8U"),
    $5c7d41786288b00b$var$load("3w49v"),
    $5c7d41786288b00b$var$load("jfplD"),
    $5c7d41786288b00b$var$load("xu7ej"),
    $5c7d41786288b00b$var$load("c39Xf"),
    $5c7d41786288b00b$var$load("jlCbV"),
    $5c7d41786288b00b$var$load("5HYGH"),
    $5c7d41786288b00b$var$load("gufL1"),
    $5c7d41786288b00b$var$load("67Alm"),
    $5c7d41786288b00b$var$load("2wyaQ"),
    $5c7d41786288b00b$var$load("2B2rM"),
    $5c7d41786288b00b$var$load("b11Cj"),
    $5c7d41786288b00b$var$load("7HPPR"),
    $5c7d41786288b00b$var$load("7PNQN"),
    $5c7d41786288b00b$var$load("7bkye"),
    $5c7d41786288b00b$var$load("9anPW"),
    $5c7d41786288b00b$var$load("lFAez"),
    $5c7d41786288b00b$var$load("1qlDN"),
    $5c7d41786288b00b$var$load("1yVM6"),
    $5c7d41786288b00b$var$load("9DBoM"),
    $5c7d41786288b00b$var$load("7EorR"),
    $5c7d41786288b00b$var$load("hhss7"),
    $5c7d41786288b00b$var$load("ffEVr"),
    $5c7d41786288b00b$var$load("9s2yE"),
    $5c7d41786288b00b$var$load("1PT2m"),
    $5c7d41786288b00b$var$load("fZYxu"),
    $5c7d41786288b00b$var$load("c5u8A"),
    $5c7d41786288b00b$var$load("8Tfc6"),
    $5c7d41786288b00b$var$load("lwcwb"),
    $5c7d41786288b00b$var$load("boWf5"),
    $5c7d41786288b00b$var$load("i8qZz"),
    $5c7d41786288b00b$var$load("4M3vA"),
    $5c7d41786288b00b$var$load("inj26"),
    $5c7d41786288b00b$var$load("cIyFe"),
    $5c7d41786288b00b$var$load("lkuRr"),
    $5c7d41786288b00b$var$load("ha0dM"),
    $5c7d41786288b00b$var$load("bR8yE"),
    $5c7d41786288b00b$var$load("bTTil"),
    $5c7d41786288b00b$var$load("4Wx4n"),
    $5c7d41786288b00b$var$load("1gcQ5"),
    $5c7d41786288b00b$var$load("4qZ9f"),
    $5c7d41786288b00b$var$load("gBTOA"),
    $5c7d41786288b00b$var$load("9joh8"),
    $5c7d41786288b00b$var$load("1SyLT"),
    $5c7d41786288b00b$var$load("dkIUD")
]).then(()=>parcelRequire('l2J3i'));

});

parcelRegister("eBhNl", function(module, exports) {

let $aa1253139e15f97c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa1253139e15f97c$var$load("kpjEU"),
    $aa1253139e15f97c$var$load("d62hC"),
    $aa1253139e15f97c$var$load("fT5Tk"),
    $aa1253139e15f97c$var$load("jPzkK"),
    $aa1253139e15f97c$var$load("dEZTU"),
    $aa1253139e15f97c$var$load("hVgF8"),
    $aa1253139e15f97c$var$load("bGqrb"),
    $aa1253139e15f97c$var$load("6tsCm"),
    $aa1253139e15f97c$var$load("6kcCF"),
    $aa1253139e15f97c$var$load("9V1vV"),
    $aa1253139e15f97c$var$load("i6s2m"),
    $aa1253139e15f97c$var$load("bNW8r"),
    $aa1253139e15f97c$var$load("1ZFzv"),
    $aa1253139e15f97c$var$load("diyjB"),
    $aa1253139e15f97c$var$load("4oONP"),
    $aa1253139e15f97c$var$load("lUFbG"),
    $aa1253139e15f97c$var$load("Wowvf"),
    $aa1253139e15f97c$var$load("gy5DL"),
    $aa1253139e15f97c$var$load("dtpmo"),
    $aa1253139e15f97c$var$load("35X59"),
    $aa1253139e15f97c$var$load("2F69B"),
    $aa1253139e15f97c$var$load("3g3jg"),
    $aa1253139e15f97c$var$load("1GCFv"),
    $aa1253139e15f97c$var$load("bRqDI"),
    $aa1253139e15f97c$var$load("4fYzp"),
    $aa1253139e15f97c$var$load("kNNS3"),
    $aa1253139e15f97c$var$load("hOBst"),
    $aa1253139e15f97c$var$load("cmqxT"),
    $aa1253139e15f97c$var$load("9DBoM"),
    $aa1253139e15f97c$var$load("eN6nL"),
    $aa1253139e15f97c$var$load("6wr18"),
    $aa1253139e15f97c$var$load("7EorR"),
    $aa1253139e15f97c$var$load("5dkX4"),
    $aa1253139e15f97c$var$load("9lUu8"),
    $aa1253139e15f97c$var$load("hhss7"),
    $aa1253139e15f97c$var$load("ffEVr"),
    $aa1253139e15f97c$var$load("e2WH6"),
    $aa1253139e15f97c$var$load("5vzT0"),
    $aa1253139e15f97c$var$load("h94bv"),
    $aa1253139e15f97c$var$load("fNffa")
]).then(()=>parcelRequire('7MAGI'));

});

parcelRegister("lEtIM", function(module, exports) {

let $fc34637023e8c235$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fc34637023e8c235$var$load("4oONP"),
    $fc34637023e8c235$var$load("6wr18"),
    $fc34637023e8c235$var$load("d62hC"),
    $fc34637023e8c235$var$load("fT5Tk"),
    $fc34637023e8c235$var$load("ffEVr"),
    $fc34637023e8c235$var$load("1GCFv"),
    $fc34637023e8c235$var$load("4fYzp"),
    $fc34637023e8c235$var$load("h94bv"),
    $fc34637023e8c235$var$load("aRnD4")
]).then(()=>parcelRequire('fgp6d'));

});

parcelRegister("bLcV9", function(module, exports) {

let $88fe1b49ab818267$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $88fe1b49ab818267$var$load("6wr18"),
    $88fe1b49ab818267$var$load("gWan9"),
    $88fe1b49ab818267$var$load("cwwTu"),
    $88fe1b49ab818267$var$load("bpPDZ"),
    $88fe1b49ab818267$var$load("5Raqr"),
    $88fe1b49ab818267$var$load("4WTdS"),
    $88fe1b49ab818267$var$load("ecwNN"),
    $88fe1b49ab818267$var$load("26hDP"),
    $88fe1b49ab818267$var$load("4xgpM"),
    $88fe1b49ab818267$var$load("iK6Gk"),
    $88fe1b49ab818267$var$load("gskl6"),
    $88fe1b49ab818267$var$load("eF24J"),
    $88fe1b49ab818267$var$load("kaAxH"),
    $88fe1b49ab818267$var$load("g5HUX"),
    $88fe1b49ab818267$var$load("c39Xf"),
    $88fe1b49ab818267$var$load("czd3n"),
    $88fe1b49ab818267$var$load("jlCbV"),
    $88fe1b49ab818267$var$load("9f5Sw"),
    $88fe1b49ab818267$var$load("2ap9J"),
    $88fe1b49ab818267$var$load("4oXMS"),
    $88fe1b49ab818267$var$load("gufL1"),
    $88fe1b49ab818267$var$load("hhss7"),
    $88fe1b49ab818267$var$load("9nwFZ"),
    $88fe1b49ab818267$var$load("2B2rM"),
    $88fe1b49ab818267$var$load("b11Cj"),
    $88fe1b49ab818267$var$load("7HPPR"),
    $88fe1b49ab818267$var$load("4TzHH"),
    $88fe1b49ab818267$var$load("1okAQ"),
    $88fe1b49ab818267$var$load("hOaAV"),
    $88fe1b49ab818267$var$load("9anPW"),
    $88fe1b49ab818267$var$load("lFAez"),
    $88fe1b49ab818267$var$load("1qlDN"),
    $88fe1b49ab818267$var$load("1yVM6"),
    $88fe1b49ab818267$var$load("cEqm7"),
    $88fe1b49ab818267$var$load("6XCf4"),
    $88fe1b49ab818267$var$load("ffEVr"),
    $88fe1b49ab818267$var$load("9DBoM"),
    $88fe1b49ab818267$var$load("7gkvG"),
    $88fe1b49ab818267$var$load("7EorR"),
    $88fe1b49ab818267$var$load("aSL4q"),
    $88fe1b49ab818267$var$load("cS7dz")
]).then(()=>parcelRequire('ec8HN'));

});

parcelRegister("iEUAa", function(module, exports) {

let $d957da7a44e77950$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d957da7a44e77950$var$load("IyjLX").then(()=>parcelRequire('esu8h'));

});

parcelRegister("ipfH1", function(module, exports) {

let $d666bc0d98260477$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d666bc0d98260477$var$load("7S9EX").then(()=>parcelRequire('3VmKy'));

});

parcelRegister("hwzJf", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a0c1672298304318$export$c34c105fee6e8977 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JsB5i",
    name: "GoToHomeLoader",
    loader: async ()=>(await (parcelRequire("dsUTi"))).GoToHome
});
module.exports["GoToHomeLoader"] = $a0c1672298304318$export$c34c105fee6e8977;

});

parcelRegister("dsUTi", function(module, exports) {

let $9cda053f51048b8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9cda053f51048b8c$var$load("c0lrw").then(()=>parcelRequire('7QGXJ'));

});

parcelRegister("idSff", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d4a3e046810f681f$export$1fe963e8f052ccbb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VM3qQ",
    name: "SiteHomepageRedirectLoader",
    loader: async ()=>(await (parcelRequire("azb28"))).SiteHomepageRedirect
});
module.exports["SiteHomepageRedirectLoader"] = $d4a3e046810f681f$export$1fe963e8f052ccbb;

});

parcelRegister("azb28", function(module, exports) {

let $7b15bb4474603b49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b15bb4474603b49$var$load("cgZOp").then(()=>parcelRequire('kkwpp'));

});

parcelRegister("8MiHL", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $664150cfb8454085$export$325f108b642b51d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EdgKX",
    name: "LazyRouteToRightEditor",
    loader: ()=>(parcelRequire("dpKI3"))
});
module.exports["LazyRouteToRightEditor"] = $664150cfb8454085$export$325f108b642b51d;

});

parcelRegister("dpKI3", function(module, exports) {

let $9c41d7aedabd089d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c41d7aedabd089d$var$load("4NoAV").then(()=>parcelRequire('kZVh7'));

});

parcelRegister("cJC2l", function(module, exports) {

let $94573158fd319d9d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $94573158fd319d9d$var$load("lVfKJ"),
    $94573158fd319d9d$var$load("67Alm"),
    $94573158fd319d9d$var$load("h94bv"),
    $94573158fd319d9d$var$load("gWan9"),
    $94573158fd319d9d$var$load("4X1QD"),
    $94573158fd319d9d$var$load("iZnOu"),
    $94573158fd319d9d$var$load("9StSe"),
    $94573158fd319d9d$var$load("4PgR7"),
    $94573158fd319d9d$var$load("1V37g"),
    $94573158fd319d9d$var$load("cwwTu"),
    $94573158fd319d9d$var$load("bpPDZ"),
    $94573158fd319d9d$var$load("5Raqr"),
    $94573158fd319d9d$var$load("iOaZJ"),
    $94573158fd319d9d$var$load("ecwNN"),
    $94573158fd319d9d$var$load("4xgpM"),
    $94573158fd319d9d$var$load("iK6Gk"),
    $94573158fd319d9d$var$load("gskl6"),
    $94573158fd319d9d$var$load("bIAIU"),
    $94573158fd319d9d$var$load("brdE2"),
    $94573158fd319d9d$var$load("8LtYa"),
    $94573158fd319d9d$var$load("kaAxH"),
    $94573158fd319d9d$var$load("c39Xf"),
    $94573158fd319d9d$var$load("czd3n"),
    $94573158fd319d9d$var$load("7P36N"),
    $94573158fd319d9d$var$load("jlCbV"),
    $94573158fd319d9d$var$load("5ra3E"),
    $94573158fd319d9d$var$load("4oXMS"),
    $94573158fd319d9d$var$load("gufL1"),
    $94573158fd319d9d$var$load("hhss7"),
    $94573158fd319d9d$var$load("2B2rM"),
    $94573158fd319d9d$var$load("b11Cj"),
    $94573158fd319d9d$var$load("7HPPR"),
    $94573158fd319d9d$var$load("24OMS"),
    $94573158fd319d9d$var$load("gLFJS"),
    $94573158fd319d9d$var$load("35X59"),
    $94573158fd319d9d$var$load("2F69B"),
    $94573158fd319d9d$var$load("9anPW"),
    $94573158fd319d9d$var$load("lFAez"),
    $94573158fd319d9d$var$load("1qlDN"),
    $94573158fd319d9d$var$load("1yVM6"),
    $94573158fd319d9d$var$load("3Kg3S"),
    $94573158fd319d9d$var$load("9DBoM"),
    $94573158fd319d9d$var$load("aSL4q"),
    $94573158fd319d9d$var$load("1jVx9"),
    $94573158fd319d9d$var$load("lmyjp"),
    $94573158fd319d9d$var$load("6wr18"),
    $94573158fd319d9d$var$load("1OPxx"),
    $94573158fd319d9d$var$load("7EorR"),
    $94573158fd319d9d$var$load("ffEVr"),
    $94573158fd319d9d$var$load("aHCaB"),
    $94573158fd319d9d$var$load("lwNze")
]).then(()=>parcelRequire('dJsyi'));

});

parcelRegister("iY7Hl", function(module, exports) {

let $dcf3cd40e00af8b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dcf3cd40e00af8b1$var$load("bpPDZ"),
    $dcf3cd40e00af8b1$var$load("gskl6"),
    $dcf3cd40e00af8b1$var$load("67Alm"),
    $dcf3cd40e00af8b1$var$load("d62hC"),
    $dcf3cd40e00af8b1$var$load("cCHYW"),
    $dcf3cd40e00af8b1$var$load("iZnOu"),
    $dcf3cd40e00af8b1$var$load("cwwTu"),
    $dcf3cd40e00af8b1$var$load("5Raqr"),
    $dcf3cd40e00af8b1$var$load("ecwNN"),
    $dcf3cd40e00af8b1$var$load("26hDP"),
    $dcf3cd40e00af8b1$var$load("4xgpM"),
    $dcf3cd40e00af8b1$var$load("bIAIU"),
    $dcf3cd40e00af8b1$var$load("brdE2"),
    $dcf3cd40e00af8b1$var$load("kaAxH"),
    $dcf3cd40e00af8b1$var$load("g5HUX"),
    $dcf3cd40e00af8b1$var$load("c39Xf"),
    $dcf3cd40e00af8b1$var$load("czd3n"),
    $dcf3cd40e00af8b1$var$load("jlCbV"),
    $dcf3cd40e00af8b1$var$load("4oXMS"),
    $dcf3cd40e00af8b1$var$load("gufL1"),
    $dcf3cd40e00af8b1$var$load("9nwFZ"),
    $dcf3cd40e00af8b1$var$load("2B2rM"),
    $dcf3cd40e00af8b1$var$load("b11Cj"),
    $dcf3cd40e00af8b1$var$load("7HPPR"),
    $dcf3cd40e00af8b1$var$load("4TzHH"),
    $dcf3cd40e00af8b1$var$load("1GCFv"),
    $dcf3cd40e00af8b1$var$load("9anPW"),
    $dcf3cd40e00af8b1$var$load("9DBoM"),
    $dcf3cd40e00af8b1$var$load("7gkvG"),
    $dcf3cd40e00af8b1$var$load("aSL4q"),
    $dcf3cd40e00af8b1$var$load("lmyjp"),
    $dcf3cd40e00af8b1$var$load("g0OKa"),
    $dcf3cd40e00af8b1$var$load("jZLnv"),
    $dcf3cd40e00af8b1$var$load("6edij"),
    $dcf3cd40e00af8b1$var$load("6wr18"),
    $dcf3cd40e00af8b1$var$load("3qoxm"),
    $dcf3cd40e00af8b1$var$load("dlm6q"),
    $dcf3cd40e00af8b1$var$load("ffEVr"),
    $dcf3cd40e00af8b1$var$load("gLFJS"),
    $dcf3cd40e00af8b1$var$load("35X59"),
    $dcf3cd40e00af8b1$var$load("4NdV5"),
    $dcf3cd40e00af8b1$var$load("3KVI3"),
    $dcf3cd40e00af8b1$var$load("7EorR"),
    $dcf3cd40e00af8b1$var$load("jPuvo"),
    $dcf3cd40e00af8b1$var$load("el56J"),
    $dcf3cd40e00af8b1$var$load("5dBst"),
    $dcf3cd40e00af8b1$var$load("zSp86"),
    $dcf3cd40e00af8b1$var$load("hhss7"),
    $dcf3cd40e00af8b1$var$load("h94bv"),
    $dcf3cd40e00af8b1$var$load("dUTj8"),
    $dcf3cd40e00af8b1$var$load("5MpJT")
]).then(()=>parcelRequire('7cCRg'));

});

parcelRegister("gpq9c", function(module, exports) {

let $bf23437dc6cfbbfe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf23437dc6cfbbfe$var$load("7bkye"),
    $bf23437dc6cfbbfe$var$load("03fWQ")
]).then(()=>parcelRequire('ePNbS'));

});

parcelRegister("8xWdd", function(module, exports) {

let $638e8f87e436975b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $638e8f87e436975b$var$load("lFAez"),
    $638e8f87e436975b$var$load("1qlDN"),
    $638e8f87e436975b$var$load("1yVM6"),
    $638e8f87e436975b$var$load("cEqm7"),
    $638e8f87e436975b$var$load("6XCf4"),
    $638e8f87e436975b$var$load("iO7VA")
]).then(()=>parcelRequire('4CchY'));

});

parcelRegister("iXUzT", function(module, exports) {

let $dce99fdec626f024$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dce99fdec626f024$var$load("3cI3U").then(()=>parcelRequire('5CzWQ'));

});

parcelRegister("eSHjN", function(module, exports) {

let $ad57b5f72cf5b708$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ad57b5f72cf5b708$var$load("eNXrl"),
    $ad57b5f72cf5b708$var$load("7EorR"),
    $ad57b5f72cf5b708$var$load("fRtVQ"),
    $ad57b5f72cf5b708$var$load("lnKog"),
    $ad57b5f72cf5b708$var$load("gNfuQ"),
    $ad57b5f72cf5b708$var$load("5n2uM")
]).then(()=>parcelRequire('bexnX'));

});

parcelRegister("8R4tZ", function(module, exports) {

let $6726c0218d17ed6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6726c0218d17ed6d$var$load("lHNSl").then(()=>parcelRequire('8fbPW'));

});

parcelRegister("4pErf", function(module, exports) {

let $3368dd75d2c90463$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3368dd75d2c90463$var$load("vlZ5n").then(()=>parcelRequire('i5MLu'));

});

parcelRegister("9KOnT", function(module, exports) {

let $719f7e32bb58b634$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $719f7e32bb58b634$var$load("ejYwx").then(()=>parcelRequire('2X92e'));

});

parcelRegister("6ODB7", function(module, exports) {

let $4f6620daf36616a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f6620daf36616a5$var$load("6nNce").then(()=>parcelRequire('iPlli'));

});

parcelRegister("7sQ6z", function(module, exports) {

let $56f390e44978dd2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56f390e44978dd2a$var$load("gI35P").then(()=>parcelRequire('grc8F'));

});

parcelRegister("j31oX", function(module, exports) {

let $dddf6279cbd59b8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dddf6279cbd59b8c$var$load("hMGc2").then(()=>parcelRequire('fOnOH'));

});

parcelRegister("alRCK", function(module, exports) {

let $7895762480137a0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7895762480137a0f$var$load("l0dd5"),
    $7895762480137a0f$var$load("j104l"),
    $7895762480137a0f$var$load("7CYB9"),
    $7895762480137a0f$var$load("5uN9h"),
    $7895762480137a0f$var$load("1GCFv"),
    $7895762480137a0f$var$load("4fYzp"),
    $7895762480137a0f$var$load("h4Nf7"),
    $7895762480137a0f$var$load("dek7I"),
    $7895762480137a0f$var$load("dYtBN"),
    $7895762480137a0f$var$load("kNV5Y"),
    $7895762480137a0f$var$load("5lTVp"),
    $7895762480137a0f$var$load("lWNY8"),
    $7895762480137a0f$var$load("hhss7"),
    $7895762480137a0f$var$load("6wr18"),
    $7895762480137a0f$var$load("h9S8v"),
    $7895762480137a0f$var$load("dZsGY"),
    $7895762480137a0f$var$load("jPuvo"),
    $7895762480137a0f$var$load("3GuOt"),
    $7895762480137a0f$var$load("ffEVr"),
    $7895762480137a0f$var$load("lbsQO"),
    $7895762480137a0f$var$load("7j0mT"),
    $7895762480137a0f$var$load("69R9L"),
    $7895762480137a0f$var$load("zSp86"),
    $7895762480137a0f$var$load("kuFG2"),
    $7895762480137a0f$var$load("Wowvf"),
    $7895762480137a0f$var$load("1F7LX"),
    $7895762480137a0f$var$load("9ftJe"),
    $7895762480137a0f$var$load("7EorR"),
    $7895762480137a0f$var$load("hA2SB"),
    $7895762480137a0f$var$load("8Dgzr")
]).then(()=>parcelRequire('bhsbE'));

});

parcelRegister("kz8pQ", function(module, exports) {

let $ef8d9ac17e8ee49c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ef8d9ac17e8ee49c$var$load("eT0Md").then(()=>parcelRequire('y0ZZq'));

});

parcelRegister("bb7pf", function(module, exports) {

let $82367788fe5c1a54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82367788fe5c1a54$var$load("1PNUT").then(()=>parcelRequire('8qhuK'));

});

parcelRegister("ivrRE", function(module, exports) {

let $d790bc8358610985$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d790bc8358610985$var$load("h2HOa").then(()=>parcelRequire('3C4B7'));

});

parcelRegister("dqpQq", function(module, exports) {

let $9c61c046eed2863a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c61c046eed2863a$var$load("hsAS2").then(()=>parcelRequire('6PsK0'));

});

parcelRegister("fFYfK", function(module, exports) {

let $b6996c5661b1fc74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b6996c5661b1fc74$var$load("6wr18"),
    $b6996c5661b1fc74$var$load("hHrTM"),
    $b6996c5661b1fc74$var$load("4rKYa"),
    $b6996c5661b1fc74$var$load("ffEVr"),
    $b6996c5661b1fc74$var$load("2NgQt")
]).then(()=>parcelRequire('cPinp'));

});

parcelRegister("941FH", function(module, exports) {

let $6995c8b56ddde032$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6995c8b56ddde032$var$load("jlCbV"),
    $6995c8b56ddde032$var$load("6wr18"),
    $6995c8b56ddde032$var$load("9cgaG"),
    $6995c8b56ddde032$var$load("3Q80N"),
    $6995c8b56ddde032$var$load("4JAC8"),
    $6995c8b56ddde032$var$load("g5HUX"),
    $6995c8b56ddde032$var$load("c39Xf"),
    $6995c8b56ddde032$var$load("czd3n"),
    $6995c8b56ddde032$var$load("7P36N"),
    $6995c8b56ddde032$var$load("lVfKJ"),
    $6995c8b56ddde032$var$load("ffEVr"),
    $6995c8b56ddde032$var$load("1tzsM"),
    $6995c8b56ddde032$var$load("llxGi"),
    $6995c8b56ddde032$var$load("lFAez"),
    $6995c8b56ddde032$var$load("1qlDN"),
    $6995c8b56ddde032$var$load("1yVM6"),
    $6995c8b56ddde032$var$load("cEqm7"),
    $6995c8b56ddde032$var$load("6XCf4"),
    $6995c8b56ddde032$var$load("faxwR")
]).then(()=>parcelRequire('eHKVU'));

});

parcelRegister("fpeTv", function(module, exports) {

let $b374be7f86530728$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b374be7f86530728$var$load("6wr18"),
    $b374be7f86530728$var$load("lGXsx"),
    $b374be7f86530728$var$load("jtqzu"),
    $b374be7f86530728$var$load("kwgtb"),
    $b374be7f86530728$var$load("i84Fm"),
    $b374be7f86530728$var$load("j8ma3"),
    $b374be7f86530728$var$load("7Ya0F"),
    $b374be7f86530728$var$load("eNZNF"),
    $b374be7f86530728$var$load("4EFsN"),
    $b374be7f86530728$var$load("hHrTM"),
    $b374be7f86530728$var$load("5uN9h"),
    $b374be7f86530728$var$load("jfGTp"),
    $b374be7f86530728$var$load("fjOTL"),
    $b374be7f86530728$var$load("hOaAV"),
    $b374be7f86530728$var$load("lFAez"),
    $b374be7f86530728$var$load("1qlDN"),
    $b374be7f86530728$var$load("1yVM6"),
    $b374be7f86530728$var$load("cEqm7"),
    $b374be7f86530728$var$load("6XCf4"),
    $b374be7f86530728$var$load("ffEVr"),
    $b374be7f86530728$var$load("gYbv6")
]).then(()=>parcelRequire('9qsRH'));

});

parcelRegister("fVdPo", function(module, exports) {

let $b976e7d28125bbd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b976e7d28125bbd8$var$load("83Dnz").then(()=>parcelRequire('1e8Au'));

});

parcelRegister("9TVBV", function(module, exports) {
/**
 * @generated SignedSource<<585ff00e08b16fb246b11138f7d89006>>
 * @relayHash 6e460ac038e243dbc74984a7e17a7720
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6d8a1c1432dd78a309529a8426e9f0e759b0e202139621c928d8dab8a2de74c7
const $d5416dce4c756c64$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spacePermissions"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceTypes"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "subjectId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "subjectType"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "spacePermissions",
                    "variableName": "spacePermissions"
                },
                {
                    "kind": "Variable",
                    "name": "spaceTypes",
                    "variableName": "spaceTypes"
                },
                {
                    "kind": "Variable",
                    "name": "subjectId",
                    "variableName": "subjectId"
                },
                {
                    "kind": "Variable",
                    "name": "subjectType",
                    "variableName": "subjectType"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "taskId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BulkSetSpacePermissionAsyncPayload",
                    "kind": "LinkedField",
                    "name": "bulkSetSpacePermissionAsync",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BulkSetSpacePermissionAsyncPayload",
                    "kind": "LinkedField",
                    "name": "bulkSetSpacePermissionAsync",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "6e460ac038e243dbc74984a7e17a7720",
            "id": "6d8a1c1432dd78a309529a8426e9f0e759b0e202139621c928d8dab8a2de74c7",
            "metadata": {},
            "name": "BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation",
            "operationKind": "mutation",
            "text": "mutation BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation($spacePermissions:[SpacePermissionType]!,$spaceTypes:[BulkSetSpacePermissionSpaceType]!,$subjectId:ID!,$subjectType:BulkSetSpacePermissionSubjectType!){bulkSetSpacePermissionAsync(input:{spacePermissions:$spacePermissions,spaceTypes:$spaceTypes,subjectId:$subjectId,subjectType:$subjectType}){success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}},taskId}}"
        }
    };
}();
$d5416dce4c756c64$var$node.hash = "3a45909974779c48b1ef1a6ec89f783e";
var $d5416dce4c756c64$export$2e2bcd8739ae039 = $d5416dce4c756c64$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $laHi9 = parcelRequire("laHi9");


var $ccHMk = parcelRequire("ccHMk");


var $7p4As = parcelRequire("7p4As");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");


var $dcJ7R = parcelRequire("dcJ7R");


var $ecnYn = parcelRequire("ecnYn");


var $1BYn9 = parcelRequire("1BYn9");


var $hpRYU = parcelRequire("hpRYU");


var $euL71 = parcelRequire("euL71");


var $1NBp8 = parcelRequire("1NBp8");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7aRa9 = parcelRequire("7aRa9");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $iquRY = parcelRequire("iquRY");

parcelRequire("cp4jg");
var $9phVF = parcelRequire("9phVF");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $70228f3077c41fe6$export$e57870671ec2468e = /*#__PURE__*/ function(BulkSetSpacePermissionSpaceType) {
    BulkSetSpacePermissionSpaceType["COLLABORATION"] = "COLLABORATION";
    BulkSetSpacePermissionSpaceType["GLOBAL"] = "GLOBAL";
    BulkSetSpacePermissionSpaceType["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    BulkSetSpacePermissionSpaceType["PERSONAL"] = "PERSONAL";
    return BulkSetSpacePermissionSpaceType;
}({});
var $70228f3077c41fe6$export$8b2051573ac4b3d5 = /*#__PURE__*/ function(BulkSetSpacePermissionSubjectType) {
    BulkSetSpacePermissionSubjectType["GROUP"] = "GROUP";
    BulkSetSpacePermissionSubjectType["USER"] = "USER";
    return BulkSetSpacePermissionSubjectType;
}({});
var $70228f3077c41fe6$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});









var $aoVih = parcelRequire("aoVih");


var $gdv5Z = parcelRequire("gdv5Z");

const $0d65445224ec1da1$export$ebaaa2fd42680a02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: 'bulk-permissions.space.removal-warning.non-final',
        defaultMessage: '<b>Permission to view is not selected. This will remove the user or group from all spaces.</b>',
        description: 'Warning text telling the user that they are removing permissions for a user or group.',
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }
    })));



var $ilq3G = parcelRequire("ilq3G");


var $8A6YM = parcelRequire("8A6YM");














var $9wGTI = parcelRequire("9wGTI");

/* BulkSpacePermissionsTable.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $gEpEw = parcelRequire("gEpEw");


var $7gpC4 = parcelRequire("7gpC4");





var $eicAg = parcelRequire("eicAg");


var $yuLaV = parcelRequire("yuLaV");


var $jhwJP = parcelRequire("jhwJP");



var $9TVBV = parcelRequire("9TVBV");

const $7a1206d786c0ab1b$var$groupI18nBase = (0, $aXWIB.defineMessages)({
    selectAll: {
        id: "bulk-permissions.space.table.header.group.select-all",
        defaultMessage: "Select all"
    },
    all: {
        id: "bulk-permissions.space.table.header.group.all",
        defaultMessage: "All"
    },
    pages: {
        id: "bulk-permissions.space.table.header.group.pages",
        defaultMessage: "Pages"
    },
    pagesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-embeds",
        defaultMessage: "Pages and Smart Links"
    },
    pagesWhiteboardsDatabases: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases",
        defaultMessage: "Pages, whiteboards, and databases"
    },
    pagesWhiteboardsEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-embeds",
        defaultMessage: "Pages, whiteboards, and Smart Links"
    },
    pagesDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-databases-embeds",
        defaultMessage: "Pages, databases, and Smart Links"
    },
    pagesWhiteboardsDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds",
        defaultMessage: "Pages, whiteboards, databases, and Smart Links"
    },
    blogs: {
        id: "bulk-permissions.space.table.header.group.blogs",
        defaultMessage: "Blogs"
    },
    comments: {
        id: "bulk-permissions.space.table.header.group.comments",
        defaultMessage: "Comments"
    },
    attachments: {
        id: "bulk-permissions.space.table.header.group.attachments",
        defaultMessage: "Attachments"
    },
    restrictions: {
        id: "bulk-permissions.space.table.header.group.restrictions",
        defaultMessage: "Restrictions"
    },
    mail: {
        id: "bulk-permissions.space.table.header.group.mail",
        defaultMessage: "Mail"
    },
    space: {
        id: "bulk-permissions.space.table.header.group.space",
        defaultMessage: "Space"
    }
});
const $7a1206d786c0ab1b$var$groupI18nLiveDocs = (0, $aXWIB.defineMessages)({
    pages: {
        id: "bulk-permissions.space.table.header.group.pages.livedocs",
        defaultMessage: "Pages and live docs"
    },
    pagesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-embeds.livedocs",
        defaultMessage: "Pages, live docs, and Smart Links"
    },
    pagesWhiteboardsDatabases: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, and databases"
    },
    pagesWhiteboardsEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-embeds.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, databases, and Smart Links"
    },
    pagesDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-databases-embeds.livedocs",
        defaultMessage: "Pages, live docs, databases, and Smart Links"
    },
    pagesWhiteboardsDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, databases, and Smart Links"
    }
});
const $7a1206d786c0ab1b$var$groupI18n = (0, $jhwJP.mergeLiveDocI18n)($7a1206d786c0ab1b$var$groupI18nBase, $7a1206d786c0ab1b$var$groupI18nLiveDocs);
const $7a1206d786c0ab1b$var$columnI18n = (0, $aXWIB.defineMessages)({
    view: {
        id: "bulk-permissions.space.table.header.column.view",
        defaultMessage: "View"
    },
    deleteOwn: {
        id: "bulk-permissions.space.table.header.column.delete-own",
        defaultMessage: "Delete own"
    },
    add: {
        id: "bulk-permissions.space.table.header.column.Add",
        defaultMessage: "Add"
    },
    delete: {
        id: "bulk-permissions.space.table.header.column.delete",
        defaultMessage: "Delete"
    },
    archive: {
        id: "bulk-permissions.space.table.header.column.archive",
        defaultMessage: "Archive"
    },
    addDelete: {
        id: "bulk-permissions.space.table.header.column.add-delete",
        defaultMessage: "Add/Delete"
    },
    export: {
        id: "bulk-permissions.space.table.header.column.export",
        defaultMessage: "Export"
    },
    admin: {
        id: "bulk-permissions.space.table.header.column.admin",
        defaultMessage: "Admin"
    }
});
const $7a1206d786c0ab1b$var$i18n = (0, $aXWIB.defineMessages)({
    allViewTooltipContent: {
        id: "bulk-permissions.space.table.header.allViewTooltipContent",
        defaultMessage: "View permission determines who has access to the space."
    },
    allViewTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.allViewTooltipIconLabel",
        defaultMessage: "Learn more about view permissions"
    },
    deleteOwnTooltipContent: {
        id: "bulk-permissions.space.table.header.deleteOwnTooltipContent",
        defaultMessage: "Lets users delete their own content and attachments. (For comments, the \u201CAdd\u201D permission includes \u201CDelete Own\u201D)"
    },
    deleteOwnTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.deleteOwnTooltipIconLabel",
        defaultMessage: "Learn more about delete own"
    },
    restrictionsTooltipContent: {
        id: "bulk-permissions.space.table.header.restrictionsTooltipContent",
        defaultMessage: "Lets users add and remove restrictions directly on content. Does not affect inherited restrictions."
    },
    restrictionsTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.restrictionsTooltipIconLabel",
        defaultMessage: "Restrictions Add/Delete tooltip"
    }
});
const $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL = 'SELECT_ALL';
const $7a1206d786c0ab1b$var$CELL_BORDER = {
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1206d786c0ab1b$var$TableWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo1wug _19pkv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1206d786c0ab1b$var$CheckboxWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $7a1206d786c0ab1b$export$92f022c5db01744 = {
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE]: false
};
const $7a1206d786c0ab1b$export$2f227e4ea23eeffd = ({ spacePermissions: spacePermissions, setSpacePermissions: setSpacePermissions, isDisabled: isTableDisabled = false })=>{
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isSelectAllCheckbox, setSelectAllCheckbox] = (0, $42omo.useState)(false);
    spacePermissions.forEach((val)=>{
        $7a1206d786c0ab1b$export$92f022c5db01744[val] = true;
    });
    const [checkboxValues, setCheckboxValues] = (0, $42omo.useState)($7a1206d786c0ab1b$export$92f022c5db01744);
    (0, $42omo.useEffect)(()=>{
        Object.keys(checkboxValues).forEach((val)=>{
            checkboxValues[val] = false;
        });
        spacePermissions.forEach((val)=>{
            checkboxValues[val] = true;
        });
        setCheckboxValues(checkboxValues);
        checkSelectAllCheckbox(checkboxValues);
    }, [
        spacePermissions,
        checkboxValues
    ]);
    const getContentGroupName = (_isWhiteboardsEnabled, _isDatabasesEnabled)=>{
        if (!_isWhiteboardsEnabled && !_isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesEmbeds);
        else if (_isWhiteboardsEnabled && !_isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesWhiteboardsEmbeds);
        else if (!_isWhiteboardsEnabled && _isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesDatabasesEmbeds);
        else return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesWhiteboardsDatabasesEmbeds);
    };
    const groupNames = {
        SELECT_ALL: formatMessage($7a1206d786c0ab1b$var$groupI18n.selectAll),
        ALL: formatMessage($7a1206d786c0ab1b$var$groupI18n.all),
        CONTENT: getContentGroupName(isWhiteboardsEnabled, isDatabasesEnabled),
        BLOGS: formatMessage($7a1206d786c0ab1b$var$groupI18n.blogs),
        COMMENTS: formatMessage($7a1206d786c0ab1b$var$groupI18n.comments),
        ATTACHMENTS: formatMessage($7a1206d786c0ab1b$var$groupI18n.attachments),
        RESTRICTIONS: formatMessage($7a1206d786c0ab1b$var$groupI18n.restrictions),
        MAIL: formatMessage($7a1206d786c0ab1b$var$groupI18n.mail),
        SPACE: formatMessage($7a1206d786c0ab1b$var$groupI18n.space)
    };
    const columnNames = {
        VIEW: formatMessage($7a1206d786c0ab1b$var$columnI18n.view),
        DELETE_OWN: formatMessage($7a1206d786c0ab1b$var$columnI18n.deleteOwn),
        ADD: formatMessage($7a1206d786c0ab1b$var$columnI18n.add),
        DELETE: formatMessage($7a1206d786c0ab1b$var$columnI18n.delete),
        ARCHIVE: formatMessage($7a1206d786c0ab1b$var$columnI18n.archive),
        ADD_DELETE: formatMessage($7a1206d786c0ab1b$var$columnI18n.addDelete),
        EXPORT: formatMessage($7a1206d786c0ab1b$var$columnI18n.export),
        ADMIN: formatMessage($7a1206d786c0ab1b$var$columnI18n.admin)
    };
    const permissionsTableHeaders = [
        {
            key: $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: "",
                columnName: groupNames.SELECT_ALL
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ALL,
                columnName: columnNames.VIEW,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.allViewTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.allViewTooltipIconLabel,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ALL,
                columnName: columnNames.DELETE_OWN,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.deleteOwnTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.deleteOwnTooltipIconLabel
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.CONTENT,
                columnName: columnNames.ADD
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                showGroupName: true,
                groupName: groupNames.CONTENT,
                columnName: columnNames.ARCHIVE,
                centerGroupName: true,
                setWidth: true
            }),
            inlineStyles: {
                maxWidth: "var(--ds-space-1000, 80px)"
            }
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.CONTENT,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.BLOGS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.BLOGS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.COMMENTS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.COMMENTS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ATTACHMENTS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ATTACHMENTS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.RESTRICTIONS,
                columnName: columnNames.ADD_DELETE,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.restrictionsTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.restrictionsTooltipIconLabel,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.SPACE,
                columnName: columnNames.EXPORT,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.SPACE,
                columnName: columnNames.ADMIN
            })
        }
    ];
    const updateSpacePermissions = (checkboxValues)=>{
        setSpacePermissions(Object.keys(checkboxValues).filter((val)=>checkboxValues[val]));
    };
    const checkSelectAllCheckbox = (valuesObject)=>{
        if (Object.values(valuesObject).every((v)=>{
            return v;
        })) setSelectAllCheckbox(true);
        else setSelectAllCheckbox(false);
    };
    const getAriaLabel = (checkBox)=>{
        switch(checkBox){
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE:
                return `${columnNames.VIEW} ${groupNames.ALL}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT:
                return `${columnNames.DELETE_OWN} ${groupNames.ALL}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE:
                return `${columnNames.ADD} ${groupNames.CONTENT}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE:
                return `${columnNames.ARCHIVE} ${groupNames.CONTENT}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE:
                return `${columnNames.DELETE} ${groupNames.CONTENT}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG:
                return `${columnNames.ADD} ${groupNames.BLOGS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG:
                return `${columnNames.DELETE} ${groupNames.BLOGS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT:
                return `${columnNames.ADD} ${groupNames.COMMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT:
                return `${columnNames.DELETE} ${groupNames.COMMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT:
                return `${columnNames.ADD} ${groupNames.ATTACHMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT:
                return `${columnNames.DELETE} ${groupNames.ATTACHMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS:
                return `${columnNames.ADD_DELETE} ${groupNames.RESTRICTIONS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE:
                return `${columnNames.EXPORT} ${groupNames.SPACE}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE:
                return `${columnNames.ADMIN} ${groupNames.SPACE}`;
        }
    };
    const PermissionsTableCheckBox = ({ spacePermission: spacePermission })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7a1206d786c0ab1b$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
            testId: `bulk-space-permissions-table-checkbox-${spacePermission}`,
            "aria-label": getAriaLabel(spacePermission),
            isChecked: getCheckedValue(spacePermission),
            isDisabled: isTableDisabled || (spacePermission === (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE ? false : isViewSpaceDisabled()),
            onChange: ()=>{
                checkboxValues[spacePermission] = !checkboxValues[spacePermission];
                setCheckboxValues(checkboxValues);
                checkSelectAllCheckbox(checkboxValues);
                updateSpacePermissions(checkboxValues);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        actionSubject: 'checkbox',
                        action: 'clicked',
                        actionSubjectId: spacePermission,
                        source: (0, $9TVBV.ANALYTICS_SOURCE),
                        attributes: {
                            value: checkboxValues[spacePermission]
                        }
                    }
                }).fire();
            }
        }));
    };
    const handleSelectAllChange = ()=>{
        setSelectAllCheckbox(!isSelectAllCheckbox);
        Object.keys(checkboxValues).map((val)=>{
            checkboxValues[val] = !isSelectAllCheckbox;
        });
        setCheckboxValues(checkboxValues);
        updateSpacePermissions(checkboxValues);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'checkbox',
                action: 'clicked',
                actionSubjectId: 'COLUMN_KEY_SELECT_ALL',
                source: (0, $9TVBV.ANALYTICS_SOURCE),
                attributes: {
                    value: isSelectAllCheckbox
                }
            }
        }).fire();
    };
    const isViewSpaceDisabled = ()=>{
        return !checkboxValues[(0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE];
    };
    const getCheckedValue = (itemId)=>{
        return checkboxValues[itemId];
    };
    const checkboxes = [
        {
            key: $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7a1206d786c0ab1b$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
                testId: "bulk-space-permissions-table-checkbox-SELECT_ALL",
                "aria-label": groupNames.SELECT_ALL,
                isChecked: isSelectAllCheckbox,
                isDisabled: isTableDisabled,
                onChange: handleSelectAllChange
            }))
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE
            })
        }
    ];
    const rowData = [
        checkboxValues
    ].map(()=>({
            key: `checkboxes`,
            cells: checkboxes
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7a1206d786c0ab1b$var$TableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gEpEw.default), {
        head: {
            cells: permissionsTableHeaders
        },
        rows: rowData,
        testId: "bulk-space-permissions-table"
    }));
};


const $ac9ac80a1cd63f38$var$i18n = (0, $aXWIB.defineMessages)({
    permissionsSelectionHeader: {
        id: "bulk-permissions.space.permissions-selection-header",
        defaultMessage: "Choose space permissions"
    },
    permissionsSelectionSubtext: {
        id: "bulk-permissions.space.permissions-selection-subtext",
        defaultMessage: "Select which permissions the user or group should have in all spaces. This will overwrite any existing permissions they have. <b>This can\u2019t be undone</b> so make sure to double check who you\u2019re adding and what permissions they should have."
    },
    permissionsWithTeamsSelectionSubtext: {
        id: "bulk-permissions.space.permissions-selection-subtext-with-teams",
        defaultMessage: "Select which permissions the user, team or group should have in all spaces. This will overwrite any existing permissions they have. <b>This can\u2019t be undone</b> so make sure to double check who you\u2019re adding and what permissions they should have."
    },
    permissionsSelectionSubtextAdditional: {
        id: "bulk-permissions.space.permissions-selection-subtext-additional",
        defaultMessage: "To remove permissions from all spaces, uncheck the view permission."
    }
});
const $ac9ac80a1cd63f38$var$permissionSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $ac9ac80a1cd63f38$var$subtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $ac9ac80a1cd63f38$export$15775f46ef52c627 = ({ spacePermissions: spacePermissions, setSpacePermissions: setSpacePermissions, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ac9ac80a1cd63f38$var$permissionSelectionHeaderStyle
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ac9ac80a1cd63f38$var$subtextStyle
    }, formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $ac9ac80a1cd63f38$var$i18n.permissionsWithTeamsSelectionSubtext : $ac9ac80a1cd63f38$var$i18n.permissionsSelectionSubtext, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlockStart: "space.200"
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionSubtextAdditional))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7a1206d786c0ab1b$export$2f227e4ea23eeffd), {
        spacePermissions: spacePermissions,
        setSpacePermissions: setSpacePermissions,
        isDisabled: isDisabled
    }));
};



var $eIwUX = parcelRequire("eIwUX");





var $6xdDU = parcelRequire("6xdDU");


var $lsxnT = parcelRequire("lsxnT");


var $67Foi = parcelRequire("67Foi");


var $lM2MU = parcelRequire("lM2MU");








var $eEA8O = parcelRequire("eEA8O");


var $1DHa6 = parcelRequire("1DHa6");


var $8o1lj = parcelRequire("8o1lj");


var $9ot3w = parcelRequire("9ot3w");


var $d8eRd = parcelRequire("d8eRd");





var $1GzhS = parcelRequire("1GzhS");







const $e9f437038d263d04$var$i18n = (0, $aXWIB.defineMessages)({
    addConfirmationDialogTitle: {
        id: "bulk-permissions.space.add.confirmation-dialog",
        defaultMessage: "Add {principalName} to selected spaces?"
    },
    addAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> (excluding personal) on your site with the selected permissions."
    },
    addAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-all.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> on your site with the selected permissions."
    },
    addAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all personal spaces</b>  on your site with the selected permissions."
    },
    confirmationDialogWarning: {
        id: "bulk-permissions.space.confirmation-dialog-warning",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    removeConfirmationDialogTitle: {
        id: "bulk-permissions.space.remove.confirmation-dialog",
        defaultMessage: "Remove {principalName} from selected spaces?"
    },
    removeAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> (excluding personal) on your site."
    },
    removeAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-all.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> on your site."
    },
    removeAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all personal spaces</b> on your site."
    },
    cancelButtonText: {
        id: "bulk-permissions.space.cancel-button-text",
        defaultMessage: "Cancel"
    },
    addButtonText: {
        id: "bulk-permissions.space.add-button-text",
        defaultMessage: "Add to all"
    },
    removeButtonText: {
        id: "bulk-permissions.space.remove-button-text",
        defaultMessage: "Remove from all"
    }
});
const $e9f437038d263d04$var$ConfirmatonSubSection = (0, $ecnYn.xcss)({
    paddingTop: 'space.300'
});
const $e9f437038d263d04$var$boldString = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks);
const $e9f437038d263d04$export$b8704437d11c7fe7 = ({ principalName: principalName, isRemoval: isRemoval, spaceSelection: spaceSelection, onConfirm: onConfirm, onCancel: onCancel })=>{
    const getConfirmationDialogDescription = ()=>{
        if (isRemoval) switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $e9f437038d263d04$var$i18n.removeAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $e9f437038d263d04$var$i18n.removeAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $e9f437038d263d04$var$i18n.removeAllPersonalConfirmationDialogDescription;
        }
        else switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $e9f437038d263d04$var$i18n.addAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $e9f437038d263d04$var$i18n.addAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $e9f437038d263d04$var$i18n.addAllPersonalConfirmationDialogDescription;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: isRemoval ? 'warning' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...isRemoval ? $e9f437038d263d04$var$i18n.removeConfirmationDialogTitle : $e9f437038d263d04$var$i18n.addConfirmationDialogTitle,
        values: {
            principalName: principalName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...getConfirmationDialogDescription(),
        values: {
            b: $e9f437038d263d04$var$boldString
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $e9f437038d263d04$var$ConfirmatonSubSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$e9f437038d263d04$var$i18n.confirmationDialogWarning,
        values: {
            b: $e9f437038d263d04$var$boldString
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e9f437038d263d04$var$i18n.cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "confirmation-dialog-confirm-button",
        appearance: isRemoval ? 'warning' : 'primary',
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), isRemoval ? $e9f437038d263d04$var$i18n.removeButtonText : $e9f437038d263d04$var$i18n.addButtonText))));
};


const $0e3e25b83ca7a775$export$a9b83e32db9bc573 = ({ principalName: principalName, isLoading: isLoading, isRemoval: isRemoval, spaceSelection: spaceSelection, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
        name: "bulk-space-permissions-dialog",
        id: "bulk-space-permissions-dialog",
        attributes: isRemoval ? {
            action: 'remove'
        } : {
            action: 'add'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        testId: "bulk-space-permissions-confirmation",
        onClose: // Don't allow the dialog to close while mutation is loading
        isLoading ? undefined : onCancel
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lM2MU.LoadingDialog), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e9f437038d263d04$export$b8704437d11c7fe7), {
        principalName: principalName,
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        onCancel: onCancel,
        onConfirm: onConfirm
    })));
};



var $kAGh9 = parcelRequire("kAGh9");

const $eb8c51b94819be10$var$BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation = (0, $d5416dce4c756c64$export$2e2bcd8739ae039);
const $eb8c51b94819be10$export$f7109619a5e9e0d6 = 'bulkSpacePermissionsScreen';
const $eb8c51b94819be10$export$c4b5d6610bc5fc6e = (0, $aXWIB.defineMessages)({
    backToSpacePermissions: {
        id: "bulk-permissions.space-permissions-link",
        defaultMessage: "Space permissions"
    },
    bulkAddHeader: {
        id: "bulk-permissions.space.header",
        defaultMessage: "Add people to all spaces"
    },
    titleSubtext: {
        id: "bulk-permissions.space.title-subtext",
        defaultMessage: "Quickly add (or remove) an individual user or group to all spaces on your Confluence site. This will overwrite any existing access they have, which means it can also be a good way to change access for a user or group in all spaces."
    },
    titleSubtextWithTeams: {
        id: "bulk-permissions.space.title-subtext-teams",
        defaultMessage: "Quickly add (or remove) an individual user, team or group to all spaces on your Confluence site. This will overwrite any existing access they have, which means it can also be a good way to change access for a user or group in all spaces."
    },
    userPickerHeader: {
        id: "bulk-permissions.space.user-picker-header",
        defaultMessage: "Choose who to add or remove<asterisk>*</asterisk>"
    },
    userPickerSubtext: {
        id: "bulk-permissions.space.user-picker-subtext",
        defaultMessage: "You may only select one for this action."
    },
    asyncSuccessFlagTitle: {
        id: "bulk-permissions.space.async.update.success-flag-title",
        defaultMessage: "Bulk permissions change processing"
    },
    asyncSuccessFlagDescription: {
        id: "bulk-permissions.space.async.update.success-flag-description",
        defaultMessage: "These changes can take a while. We\u2019ll notify you when it\u2019s finished."
    },
    errorFlagTitle: {
        id: "bulk-permissions.space.error-flag-title",
        defaultMessage: "Bulk permissions change failed"
    },
    errorFlagDescription: {
        id: "bulk-permissions.space.error-flag-description",
        defaultMessage: "We ran into a problem completing your bulk permissions change. Try again."
    },
    userPickerPlaceholder: {
        id: "bulk-permissions.space.user-picker-placeholder",
        defaultMessage: "Enter a person or group"
    },
    userPickerWithTeamsPlaceholder: {
        id: "bulk-permissions.space.user-picker-with-teams-placeholder",
        defaultMessage: "Enter a person, team or group"
    },
    requirementMessage: {
        id: "bulk-permissions.space.requirement-message",
        defaultMessage: "<asterisk>* </asterisk> Required to perform action"
    },
    applyButtonTextAdd: {
        id: "bulk-permissions.space.apply-button-text-add",
        defaultMessage: "Add to all"
    },
    applyButtonTextRemove: {
        id: "bulk-permissions.space.apply-button-text-remove",
        defaultMessage: "Remove from all"
    }
});
const $eb8c51b94819be10$var$bulkAddHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$bulkSubtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $eb8c51b94819be10$var$userPickerHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $eb8c51b94819be10$var$asteriskStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.red'
});
const $eb8c51b94819be10$var$userPickerFineTextStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.gray',
    marginTop: 'space.050',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $eb8c51b94819be10$var$contentStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.1000',
    marginRight: 'space.1000'
});
const $eb8c51b94819be10$var$backButtonStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.200',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$userPickerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $eb8c51b94819be10$var$requirementMessageStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$getPrincipalId = (principal)=>{
    if (!principal || Array.isArray(principal)) return '';
    const principalData = principal;
    return principalData.id || '';
};
const $eb8c51b94819be10$export$405a6cc8f1c994c8 = (0, $7aRa9.withFlags)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})(({ flags: flags })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const { pickerProps: teamPickerProps } = (0, $9phVF.useTeamPicker)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const [spacePermissions, setSpacePermissions] = (0, $42omo.useState)([
        (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE
    ]);
    const [stagedPrincipal, setStagedPrincipal] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(undefined);
    const [spaceSelection, setSpaceSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [showDialog, setShowDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const isRemoval = !spacePermissions.includes((0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE);
    const closeDialog = (0, $42omo.useCallback)(()=>{
        setShowDialog(false);
    }, [
        setShowDialog
    ]);
    const setInitState = (0, $42omo.useCallback)(()=>{
        setStagedPrincipal(undefined);
        setSpaceSelection((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
        setSpacePermissions([
            (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE
        ]);
    }, []);
    const onMutationErrored = (0, $42omo.useCallback)((error)=>{
        closeDialog();
        flags.showErrorFlag({
            id: 'bulk-space-permissions.add.error',
            title: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.errorFlagTitle),
            description: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.errorFlagDescription),
            isAutoDismiss: true
        });
        experienceTracker.stopOnError({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            error: error
        });
    }, [
        closeDialog,
        flags,
        intl,
        experienceTracker
    ]);
    const onAsyncMutationSubmitted = (0, $42omo.useCallback)((data)=>{
        closeDialog();
        /**
     * The backend is counting the mutation as a success for some exceptions
     * but returning an error in the mutation response.  We need to check for
     * these here.
     */ if (data?.bulkSetSpacePermissionAsync?.errors?.length > 0) onMutationErrored(new Error('Bulk space permissions mutation failed', data?.bulkSetSpacePermissionAsync?.errors));
        else {
            flags.showSuccessFlag({
                id: 'bulk-space-permissions.async.update.success',
                title: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.asyncSuccessFlagTitle),
                description: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.asyncSuccessFlagDescription),
                isAutoDismiss: true
            });
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        }
        setInitState();
    }, [
        closeDialog,
        setInitState,
        onMutationErrored,
        flags,
        intl,
        experienceTracker
    ]);
    const getBulkSpacePermissionSubjectType = (0, $42omo.useCallback)(()=>{
        if (!stagedPrincipal || Array.isArray(stagedPrincipal)) return (0, $70228f3077c41fe6$export$8b2051573ac4b3d5).USER;
        const principalData = stagedPrincipal;
        return principalData.type === 'user' ? (0, $70228f3077c41fe6$export$8b2051573ac4b3d5).USER : (0, $70228f3077c41fe6$export$8b2051573ac4b3d5).GROUP;
    }, [
        stagedPrincipal
    ]);
    const getBulkSpacePermissionSpaceType = (0, $42omo.useCallback)(()=>{
        switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return [
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).GLOBAL,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).COLLABORATION,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).KNOWLEDGE_BASE
                ];
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return [
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).PERSONAL,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).GLOBAL,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).COLLABORATION,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).KNOWLEDGE_BASE
                ];
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return [
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).PERSONAL
                ];
            default:
                return [
                    null
                ];
        }
    }, [
        spaceSelection
    ]);
    const [bulkUpdateAsync, { loading: asyncLoading, error: asyncError }] = (0, $308Wd.useMutationInterop)($eb8c51b94819be10$var$BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: (err)=>{
            closeDialog();
            onMutationErrored(err);
        },
        variables: {
            spacePermissions: spacePermissions,
            subjectType: getBulkSpacePermissionSubjectType(),
            subjectId: $eb8c51b94819be10$var$getPrincipalId(stagedPrincipal),
            spaceTypes: getBulkSpacePermissionSpaceType()
        },
        __callerPackage__: "@confluence/bulk-permissions"
    });
    const openDialog = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
        });
        setShowDialog(true);
    }, [
        setShowDialog,
        experienceTracker
    ]);
    const handleBackClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'defaultspaceperms',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceRadioChange = (0, $42omo.useCallback)((e)=>{
        setSpaceSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkSpacePermissionsType',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                attributes: {
                    spaceSelection: e.target.value
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onPrincipalChange = (0, $42omo.useCallback)((received)=>{
        // Only send an analytic event if a principal isn't deselected
        if (received && !Array.isArray(received)) {
            const principalData = received;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    actionSubject: 'principal',
                    action: 'selected',
                    actionSubjectId: 'bulkSpacePermissionsPrincipal',
                    source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                    attributes: {
                        principal: principalData.type,
                        verified: principalData.type === 'team' ? principalData.verified : 'N/A'
                    }
                }
            }).fire();
        }
        setStagedPrincipal(received);
    }, [
        createAnalyticsEvent
    ]);
    const onDialogConfirm = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulkSpacePermissionsConfirm',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                attributes: {
                    verified: stagedPrincipal?.type === 'team' ? stagedPrincipal?.verified : 'N/A',
                    principalType: stagedPrincipal?.type || 'N/A',
                    principal: stagedPrincipal?.type,
                    action: isRemoval ? 'remove' : 'add'
                }
            }
        }).fire();
        bulkUpdateAsync();
    }, [
        createAnalyticsEvent,
        bulkUpdateAsync,
        isRemoval,
        stagedPrincipal
    ]);
    const onDialogCancel = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulkSpacePermissionsCancel',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
        closeDialog();
        experienceTracker.abort({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            reason: 'User closed the dialog'
        });
    }, [
        createAnalyticsEvent,
        experienceTracker,
        closeDialog
    ]);
    // Don't render the page until we know if the user is a product admin
    // to avoid a flicker of the restricted view.
    if (isAdminCheckLoading) return null;
    if (!isProductAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIwUX.RestrictedView), null);
    const pickerResultsFilter = (options)=>{
        // TEMPORARY WORKAROUND:
        // Smart User Picker does not currently expose a reliable field to identify guest users.
        // We're using the presence of the "GUEST" lozenge as a proxy to filter out guest users.
        // This should be revisited once the platform team adds a proper field
        // to accurately indicate guest status.
        return options.filter((option)=>{
            const { lozenge: lozenge } = option;
            const isGuest = typeof lozenge === 'object' && lozenge !== null && 'text' in lozenge && lozenge.text === 'GUEST';
            return !isGuest;
        });
    };
    const placeholderText = intl.formatMessage(teamPickerProps.includeTeamsUpdates ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerWithTeamsPlaceholder : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerPlaceholder);
    return isRbacEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kAGh9.BulkAccessManagementPage), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, asyncError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: asyncError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? undefined : $eb8c51b94819be10$var$contentStyle
    }, !(0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$backButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        onClick: handleBackClick,
        href: (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'allspaces'
        }),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            })
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.backToSpacePermissions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$bulkAddHeaderStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.bulkAddHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$bulkSubtextStyle
    }, intl.formatMessage(teamPickerProps.includeTeamsUpdates ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.titleSubtextWithTeams : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.titleSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerHeaderStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $eb8c51b94819be10$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        ariaLabel: placeholderText,
        "data-test-id": "user-and-group-search",
        fieldId: "bulk-permissions-user-picker",
        includeGroup: true,
        withUsers: true,
        isMulti: false,
        smart: true,
        placeholder: placeholderText,
        noOptionsMessage: null,
        onChange: onPrincipalChange,
        value: stagedPrincipal || [],
        smartFilterOptions: pickerResultsFilter,
        isDisabled: isFreeEdition,
        includeTeams: teamPickerProps.includeTeams,
        includeTeamsUpdates: teamPickerProps.includeTeamsUpdates,
        verifiedTeams: teamPickerProps.verifiedTeams
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ilq3G.AgentAccessWarning), {
        stagedPrincipals: stagedPrincipal && !Array.isArray(stagedPrincipal) ? [
            stagedPrincipal
        ] : []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerFineTextStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8A6YM.SpaceSelectionRadioButtons), {
        spaceSelection: spaceSelection,
        onRadioChange: onSpaceRadioChange,
        isDisabled: isFreeEdition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac9ac80a1cd63f38$export$15775f46ef52c627), {
        spacePermissions: spacePermissions,
        setSpacePermissions: setSpacePermissions,
        isDisabled: isFreeEdition
    }), isRemoval && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0d65445224ec1da1$export$ebaaa2fd42680a02), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: openDialog,
        isDisabled: isFreeEdition || stagedPrincipal === undefined
    }, intl.formatMessage(isRemoval ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.applyButtonTextRemove : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.applyButtonTextAdd)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $eb8c51b94819be10$var$requirementMessageStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.requirementMessage, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $eb8c51b94819be10$var$asteriskStyle
            }, chunks)
    }))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0e3e25b83ca7a775$export$a9b83e32db9bc573), {
        principalName: !stagedPrincipal || Array.isArray(stagedPrincipal) ? '' : stagedPrincipal.name || '',
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        isLoading: asyncLoading,
        onConfirm: onDialogConfirm,
        onCancel: onDialogCancel
    }));
}));
module.exports["ANALYTICS_SOURCE"] = $eb8c51b94819be10$export$f7109619a5e9e0d6;
module.exports["i18nBulk"] = $eb8c51b94819be10$export$c4b5d6610bc5fc6e;
module.exports["BulkSpacePermissionsPage"] = $eb8c51b94819be10$export$405a6cc8f1c994c8;

});

parcelRegister("1BYn9", function(module, exports) {

var $3TDto = parcelRequire("3TDto");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $fWkVZ = parcelRequire("fWkVZ");


var $jMyy4 = parcelRequire("jMyy4");

const $141bd073c52fec74$export$44f5b9746e66da9 = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $jMyy4.useQueryInterop)((0, $3TDto.default), {
        __callerPackage__: "@confluence/current-user"
    });
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(data);
    return {
        isProductAdmin: isProductAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsProductAdmin"] = $141bd073c52fec74$export$44f5b9746e66da9;

});

parcelRegister("3TDto", function(module, exports) {
/**
 * @generated SignedSource<<5ad29dfea09a4ca6925d754e625f4e3a>>
 * @relayHash d40e79986defbb74ee71a42460f4e593
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622
const $7c2c3a08c3ad61f2$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "kind": "ScalarField",
            "name": "hasUserAccessAdminRole"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d40e79986defbb74ee71a42460f4e593",
            "id": "fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622",
            "metadata": {},
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "operationKind": "query",
            "text": "query useIsProductAdminUseIsProductAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
        }
    };
}();
$7c2c3a08c3ad61f2$var$node.hash = "179058bf05f0f539ac360b7a899d6923";
var $7c2c3a08c3ad61f2$export$2e2bcd8739ae039 = $7c2c3a08c3ad61f2$var$node;
module.exports["default"] = $7c2c3a08c3ad61f2$export$2e2bcd8739ae039;

});

parcelRegister("fWkVZ", function(module, exports) {
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));
module.exports["getIsProductAdminFromQuery"] = $b7fc105cb96f63fd$export$7ed4faccc7e85b7f;

});

parcelRegister("hpRYU", function(module, exports) {

var $1dUJk = parcelRequire("1dUJk");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $kSKAi = parcelRequire("kSKAi");


var $3hOY6 = parcelRequire("3hOY6");


var $7rus4 = parcelRequire("7rus4");


var $bQm3c = parcelRequire("bQm3c");


var $gdv5Z = parcelRequire("gdv5Z");


var $9wGTI = parcelRequire("9wGTI");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $jjoF2 = parcelRequire("jjoF2");


var $VQdE0 = parcelRequire("VQdE0");


var $g3p2i = parcelRequire("g3p2i");


var $jMyy4 = parcelRequire("jMyy4");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
const $4cbf051190fe8573$var$withoutAriaLabelledBy = (props)=>{
    const { 'aria-labelledby': _ariaLabelledBy, ...inputProps } = props;
    return inputProps;
};
const $4cbf051190fe8573$var$LabelledInput = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Input, $4cbf051190fe8573$var$withoutAriaLabelledBy(props));
const $4cbf051190fe8573$var$wrapWithLabelledInput = (InputComponent)=>{
    const WrappedLabelledInput = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InputComponent, $4cbf051190fe8573$var$withoutAriaLabelledBy(props));
    return WrappedLabelledInput;
};
const $4cbf051190fe8573$var$getLabelledComponents = (components)=>{
    return {
        ...components,
        Input: components?.Input ? $4cbf051190fe8573$var$wrapWithLabelledInput(components.Input) : $4cbf051190fe8573$var$LabelledInput
    };
};
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, verifiedTeams: verifiedTeams, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, 'aria-labelledby': ariaLabelledByFromField, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components, isHeaderFocused: isHeaderFocused, setIsHeaderFocused: setIsHeaderFocused })=>{
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $VQdE0.default));
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $jMyy4.useQueryInterop)((0, $1dUJk.default), {
        __callerPackage__: "@confluence/user-and-group-search"
    });
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const pickerAriaLabelledBy = ariaLabel ? undefined : ariaLabelledBy || ariaLabelledByFromField || `react-select-${fieldId}-placeholder`;
    const pickerComponents = (0, $42omo.useMemo)(()=>ariaLabel ? $4cbf051190fe8573$var$getLabelledComponents(components) : components, [
        ariaLabel,
        components
    ]);
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: pickerComponents,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        ariaLabel: ariaLabel,
        ariaLabelledBy: pickerAriaLabelledBy,
        'aria-describedby': userpickerDescribedbyId,
        isHeaderFocused: isHeaderFocused,
        setIsHeaderFocused: setIsHeaderFocused
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context",
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        verifiedTeams: verifiedTeams,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: true,
        enableEmailSearch: true,
        allowEmailSelectionWhenEmailMatched: false,
        isTeamSyncedToGroupDirectoryFilter: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("1dUJk", function(module, exports) {
/**
 * @generated SignedSource<<b63c5c1bb2388ba01c0f335df08966f1>>
 * @relayHash 55f887ce338962f3d231967eb05baaf5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a
const $a7eff2b640cdd5ac$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "55f887ce338962f3d231967eb05baaf5",
            "id": "f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a",
            "metadata": {},
            "name": "UserAndGroupSearchPickerQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$a7eff2b640cdd5ac$var$node.hash = "6fe67cddff8056d8e38840c5214712ee";
var $a7eff2b640cdd5ac$export$2e2bcd8739ae039 = $a7eff2b640cdd5ac$var$node;
module.exports["default"] = $a7eff2b640cdd5ac$export$2e2bcd8739ae039;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

const $b847dc1d37d68706$export$dcf9d4e77de27956 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInterop(query, options) {
    const $ = (0, $frIzR.c)(11);
    const resolversRef = (0, $42omo.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options || $[3] !== t0) {
        t1 = [
            t0,
            options
        ];
        $[2] = options;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const [doQuery, t2] = (0, $jxs8y.useLazyQuery)(...t1);
    const { data: data, error: error } = t2;
    let t3;
    let t4;
    if ($[5] !== data || $[6] !== error) {
        t3 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t4 = [
            data,
            error
        ];
        $[5] = data;
        $[6] = error;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== doQuery) {
        t5 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[9] = doQuery;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : function useLazyQueryPromiseInterop(query, options) {
    const resolversRef = (0, $42omo.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ const [doQuery, { data: data, error: error }] = (0, $jxs8y.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $42omo.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("11dKl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $f9006b515271a00f$var$i18n = (0, $aXWIB.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("VQdE0", function(module, exports) {
/**
 * @generated SignedSource<<d8c13f003578e6757b54483ce7e2bebb>>
 * @relayHash 8824351f0529abac5573900b2bee2db5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751
const $3fbecf5b2b9bf0ac$var$node = function() {
    var v0 = {
        "defaultValue": 50,
        "kind": "LocalArgument",
        "name": "maxResults"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchTerm"
    }, v2 = {
        "defaultValue": "NONE",
        "kind": "LocalArgument",
        "name": "sitePermissionTypeFilter"
    }, v3 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withGroups"
    }, v4 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withUsers"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "maxResults",
            "variableName": "maxResults"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "searchTerm"
        },
        {
            "kind": "Variable",
            "name": "sitePermissionTypeFilter",
            "variableName": "sitePermissionTypeFilter"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "condition": "withGroups",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    v8 /*: any*/ 
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "8824351f0529abac5573900b2bee2db5",
            "id": "2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751",
            "metadata": {},
            "name": "UserAndGroupSearchQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchQuery($searchTerm:String!,$maxResults:Int=50,$withGroups:Boolean=true,$withUsers:Boolean=true,$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm,maxResults:$maxResults,sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){__typename,type,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},groups@include(if:$withGroups){id,name,permissionType}}}"
        }
    };
}();
$3fbecf5b2b9bf0ac$var$node.hash = "52200fecbeb2441b36c8ceb106bad130";
var $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039 = $3fbecf5b2b9bf0ac$var$node;
module.exports["default"] = $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039;

});

parcelRegister("cp4jg", function(module, exports) {
$parcel$export(module.exports, "useTeamPicker", () => (parcelRequire("9phVF")).useTeamPicker);

var $9phVF = parcelRequire("9phVF");


});

parcelRegister("9phVF", function(module, exports) {

var $dSrQ9 = parcelRequire("dSrQ9");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");

const $61edd6b4188abea2$var$useTeamPickerQuery = (0, $dSrQ9.default);
function $61edd6b4188abea2$var$modeToPickerProps(mode) {
    switch(mode){
        case 'ALL_TEAMS':
            return {
                includeTeams: true,
                verifiedTeams: false,
                includeTeamsUpdates: true
            };
        case 'VERIFIED_TEAMS':
            return {
                includeTeams: true,
                verifiedTeams: true,
                includeTeamsUpdates: true
            };
        case null:
            return {
                includeTeams: false,
                verifiedTeams: false,
                includeTeamsUpdates: false
            };
        case undefined:
            return {
                includeTeams: false,
                verifiedTeams: false,
                includeTeamsUpdates: false
            };
        default:
            return {
                includeTeams: false,
                verifiedTeams: false,
                includeTeamsUpdates: true
            };
    }
}
const $61edd6b4188abea2$export$45e9f296b7c501d5 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($61edd6b4188abea2$var$useTeamPickerQuery, {
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: 'network-only',
        onError: (error)=>{
            (0, $7Sm4c.markErrorAsHandled)(error);
        },
        skip: !(0, $6mKj3.expValEquals)('cc_enable_admin_controls_for_teams', 'isEnabled', true),
        __callerPackage__: "@confluence/permissions-principals"
    });
    const pickerProps = (0, $42omo.useMemo)(()=>{
        // If admin controls data is available (mode is a valid string), use it to determine team picker props
        const mode = data?.confluence_teamAdminControlsSettings?.teamAdminControlsMode;
        if (mode !== undefined && mode !== null) return $61edd6b4188abea2$var$modeToPickerProps(mode);
        // Fallback: If TaP is enabled but no admin controls data, show all teams
        if ((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')) return {
            includeTeams: true,
            verifiedTeams: false,
            includeTeamsUpdates: true
        };
        // TaP is disabled - no teams
        return {
            includeTeams: false,
            verifiedTeams: false,
            includeTeamsUpdates: false
        };
    }, [
        data?.confluence_teamAdminControlsSettings?.teamAdminControlsMode
    ]);
    return {
        pickerProps: pickerProps
    };
};
module.exports["useTeamPicker"] = $61edd6b4188abea2$export$45e9f296b7c501d5;

});

parcelRegister("dSrQ9", function(module, exports) {
/**
 * @generated SignedSource<<829e3b77762a8f9c571a6ef3da4b4aac>>
 * @relayHash 2e65e91f973b80aa33359c025ddf81a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77dcf45d142c697ffdd43103256587365d38330f7009874092b2ee7f4a8216ce
const $5dc9ca3ab5de68d7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceTeamAdminControlsSettings",
            "kind": "LinkedField",
            "name": "confluence_teamAdminControlsSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "teamAdminControlsMode"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTeamPickerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTeamPickerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2e65e91f973b80aa33359c025ddf81a0",
            "id": "77dcf45d142c697ffdd43103256587365d38330f7009874092b2ee7f4a8216ce",
            "metadata": {},
            "name": "useTeamPickerQuery",
            "operationKind": "query",
            "text": "query useTeamPickerQuery($cloudId:ID!){confluence_teamAdminControlsSettings(cloudId:$cloudId){teamAdminControlsMode}}"
        }
    };
}();
$5dc9ca3ab5de68d7$var$node.hash = "f35bcbb3a9ec452df1f7352ea21732d6";
var $5dc9ca3ab5de68d7$export$2e2bcd8739ae039 = $5dc9ca3ab5de68d7$var$node;
module.exports["default"] = $5dc9ca3ab5de68d7$export$2e2bcd8739ae039;

});

parcelRegister("eicAg", function(module, exports) {
/* HeaderCell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $eXmBZ = parcelRequire("eXmBZ");


var $3gadb = parcelRequire("3gadb");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");


var $eEA8O = parcelRequire("eEA8O");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1734009c6c243aaa$var$HeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { center: center, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _1bahesu3 _1p57v77o _y3gn1h6o _1ul9xy5q _4t3i1wug",
            __cmplp.center ? "_4cvr1h6o" : "_4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$GroupNameWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { setWidth: setWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8i4vh _1e0c1txw _2lx21bp4 _1bah1h6o _1reoewfl _o5721q9c _1tke1u1b _y3gn1h6o _syazi7uo",
            __cmplp.setWidth ? "_p12fglyw" : "_p12foahv",
            __cmplp.setWidth ? "_1bsb7l9q" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$largeGroupNameStyle = (0, $ecnYn.xcss)({
    whiteSpace: 'normal',
    wordBreak: 'keep-all'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1734009c6c243aaa$var$ColumnNameWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1e0c1txw _o5721q9c _syazazsu _1wpz1h6o",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$IconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _4t3i4cqu _s7n4nkob _jq8g4cqu _14hp4cqu _irr31s93 _oq58tktm",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$export$efcbfab786023e1a = ({ groupName: groupName, columnName: columnName, showGroupName: showGroupName = false, testKey: testKey, tooltipContent: tooltipContent, tooltipIconLabel: tooltipIconLabel, centerGroupName: centerGroupName = false, setMaxWidth: setMaxWidth = false, setWidth: setWidth = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1734009c6c243aaa$var$HeaderWrapper, {
        center: centerGroupName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1734009c6c243aaa$var$GroupNameWrapper, {
        "data-testid": testKey ? `space-table-header-${testKey}` : undefined,
        "aria-label": `${groupName}`,
        setMaxWidth: setMaxWidth,
        setWidth: setWidth
    }, showGroupName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            setWidth ? $1734009c6c243aaa$var$largeGroupNameStyle : false
        ]
    }, groupName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        "aria-label": `${groupName}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1734009c6c243aaa$var$ColumnNameWrapper, {
        key: groupName + columnName,
        "aria-label": `${columnName}`
    }, columnName, tooltipContent && tooltipIconLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipContent)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1734009c6c243aaa$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            ...tooltipProps,
            appearance: "subtle-link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: formatMessage(tooltipIconLabel),
                color: "var(--ds-icon, #292A2E)",
                size: "small"
            })
        })))));
};
module.exports["HeaderCell"] = $1734009c6c243aaa$export$efcbfab786023e1a;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("auKqk", function(module, exports) {
/* ErrorPageComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $ccHMk = parcelRequire("ccHMk");


var $7p4As = parcelRequire("7p4As");


var $ecnYn = parcelRequire("ecnYn");


var $6f0Oj = parcelRequire("6f0Oj");


var $hhzGx = parcelRequire("hhzGx");


var $iNQQp = parcelRequire("iNQQp");

const $ae2504483138c997$var$ErrorContainerStyles = null;
const $ae2504483138c997$var$ErrorContainerMobileStyles = null;
const $ae2504483138c997$var$ErrorContainer = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, resizeContainerRef: resizeContainerRef, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: resizeContainerRef,
        "data-vc": "not-found-container",
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _bfhkvuon _4t3i10fc _p12fauwl",
            isMobile && "_4t3i1kxc",
            isCenteredLayout && "_18zr1ejb _1rjc1jfw _1tke10fc _4t3i1wug _vchhusvi"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorPageWrapperStyles = null;
const $ae2504483138c997$var$ErrorPageWrapperMobileStyles = null;
const $ae2504483138c997$var$ErrorPageWrapper = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _p12fcv93 _2lx2vrvc",
            isMobile && "_2lx21bp4",
            isCenteredLayout && "_2lx21bp4 _4cvr1h6o _1bsb1osq _p12f1fdn"
        ])
    }, children);
};
const $ae2504483138c997$var$AlignContentStyles = null;
const $ae2504483138c997$var$AlignContentMobileStyles = null;
const $ae2504483138c997$var$AlignContent = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18s8v47k _1wpz1h6o _y3gn1e5h",
            isMobile && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o",
            isCenteredLayout && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _1bsb1osq"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorTitleStyles = null;
const $ae2504483138c997$var$ErrorTitleMobileStyles = null;
const $ae2504483138c997$var$ErrorTitle = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h1", {
        className: (0, $gMc0m.default)([
            "_18s818rw _11c81iff _k48pi7a9 _1bsbr5sb _syazi7uo",
            isMobile && "_11c812ln _1bsb96ou",
            isCenteredLayout && "_18s8r4wq _11c81iff _syazi7uo _y3gn1h6o _1bsb1osq",
            isCenteredLayout && isMobile && "_11c81iff _1bsb1osq"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorMessageStyles = null;
const $ae2504483138c997$var$ErrorMessageMobileStyles = null;
const $ae2504483138c997$var$ErrorMessage = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _k48pi7a9 _syazi7uo _p12fqxjr",
            isMobile && "_11c81d4k _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f96ou",
            isCenteredLayout && "_11c81d4k _19pkidpf _2hwx1wug _otyridpf _18u01wug _k48pi7a9 _1iqs1rm4 _syazi7uo _y3gn1h6o _p12f1fdn",
            isMobile && isCenteredLayout && "_p12f1fdn"
        ])
    }, children);
};
const $ae2504483138c997$var$ButtonContainerStyles = null;
const $ae2504483138c997$var$ButtonContainerMobileStyles = null;
const $ae2504483138c997$var$ButtonContainer = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1e5h",
            isMobile && "_1bah1h6o",
            isCenteredLayout && "_zulppxbi _1bah1h6o _1n261g80"
        ])
    }, children);
};
const $ae2504483138c997$var$primaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250'
});
const $ae2504483138c997$var$mobilePrimaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200'
});
const $ae2504483138c997$var$secondaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250',
    marginLeft: 'space.200'
});
const $ae2504483138c997$var$mobileSecondaryButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200',
    marginLeft: 'space.100'
});
const $ae2504483138c997$var$childrenStyles = (0, $ecnYn.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-90px`
    marginTop: '-90px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$var$mobileChildrenStyles = (0, $ecnYn.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-74px`
    marginTop: '-74px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$var$centeredErrorContainerStyles = null;
const $ae2504483138c997$var$centeredErrorPageWrapperStyles = null;
const $ae2504483138c997$var$centeredAlignContentStyles = null;
const $ae2504483138c997$var$centeredErrorTitleStyles = null;
const $ae2504483138c997$var$centeredErrorTitleMobileStyles = null;
const $ae2504483138c997$var$centeredErrorMessageStyles = null;
const $ae2504483138c997$var$centeredErrorMessageMobileStyles = null;
const $ae2504483138c997$var$centeredButtonContainerStyles = null;
const $ae2504483138c997$var$centeredButtonStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.300'
});
const $ae2504483138c997$var$centeredChildrenStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.500',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '640px',
    width: '100%'
});
const $ae2504483138c997$var$centeredChildrenMobileStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.400',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '640px',
    width: '100%'
});
const $ae2504483138c997$var$ErrorPageChildren = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children)) return null;
    if (isCenteredLayout) {
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $ae2504483138c997$var$centeredChildrenMobileStyles
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $ae2504483138c997$var$centeredChildrenStyles
        }, children);
    }
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ae2504483138c997$var$mobileChildrenStyles
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ae2504483138c997$var$childrenStyles
    }, children);
};
const $ae2504483138c997$export$8350f8038f1a598b = ({ errorImage: errorImage, errorImageDark: errorImageDark, errorTitle: errorTitle, errorMessage: errorMessage, primaryButtonProps: primaryButtonProps, secondaryButtonProps: secondaryButtonProps, children: children, layout: layout = 'default' })=>{
    const { resizeContainerRef: resizeContainerRef, shouldUseMobileLayout: shouldUseMobileLayout } = (0, $iNQQp.useErrorPageMobileLayout)();
    const isMobile = shouldUseMobileLayout; // CCCEMAU-2938: keep the centered layout added for Mohiti as an explicit opt-in so
    // legacy error pages continue using the existing shared layout until each consumer is
    // intentionally migrated.
    const isCenteredLayout = layout === 'centered';
    const renderPrimaryButton = ()=>{
        if (!primaryButtonProps?.children) return null;
        const button = 'href' in primaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "primary",
            ...primaryButtonProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            ...primaryButtonProps
        });
        if (isCenteredLayout && !isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $ae2504483138c997$var$centeredButtonStyles
        }, button);
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $ae2504483138c997$var$mobilePrimaryButtonStyles
        }, button);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $ae2504483138c997$var$primaryButtonStyles
        }, button);
    };
    const renderSecondaryButton = ()=>{
        if (!secondaryButtonProps?.children) return null;
        const button = 'href' in secondaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "default",
            ...secondaryButtonProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "default",
            ...secondaryButtonProps
        });
        if (isCenteredLayout && !isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $ae2504483138c997$var$centeredButtonStyles
        }, button);
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $ae2504483138c997$var$mobileSecondaryButtonStyles
        }, button);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $ae2504483138c997$var$secondaryButtonStyles
        }, button);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ErrorContainer, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout,
        resizeContainerRef: resizeContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ErrorPageWrapper, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hhzGx.ErrorPageImage), {
        src: errorImage,
        srcDark: errorImageDark,
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ErrorTitle, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ErrorMessage, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorMessage), (primaryButtonProps?.children || secondaryButtonProps?.children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ButtonContainer, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, renderPrimaryButton(), renderSecondaryButton()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae2504483138c997$var$ErrorPageChildren, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, children));
};
module.exports["ErrorPageComponent"] = $ae2504483138c997$export$8350f8038f1a598b;

});

parcelRegister("hhzGx", function(module, exports) {
/* ErrorPageImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");

const $c32ae4d4c06d56af$var$imageStylesMobile = null;
const $c32ae4d4c06d56af$var$imageStylesDesktop = null;
const $c32ae4d4c06d56af$var$centeredImageStyles = null;
const $c32ae4d4c06d56af$var$imageStyles = null;
function $c32ae4d4c06d56af$export$9afbc24a6b683cb2({ src: src, srcDark: srcDark, isMobile: isMobile, isCenteredLayout: isCenteredLayout }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: src,
        srcDark: srcDark || src,
        className: (0, $gMc0m.default)([
            isCenteredLayout && "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb7rrr _p12faq80",
            !isCenteredLayout && isMobile && "_1bsb118a",
            !isCenteredLayout && !isMobile && "_1bsbn7od",
            !isCenteredLayout && "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f261p"
        ])
    });
}
module.exports["ErrorPageImage"] = $c32ae4d4c06d56af$export$9afbc24a6b683cb2;

});

parcelRegister("iNQQp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8dwdz = parcelRequire("8dwdz");

const $5359ea5c70f1dd78$export$78b0da9378bc7a2d = ()=>{
    const MOBILE_BREAKPOINT = 700;
    const [isContainerNarrow, setIsContainerNarrow] = (0, $42omo.useState)(false);
    const lastIsNarrowRef = (0, $42omo.useRef)(null);
    const resizeObserverRef = (0, $42omo.useRef)(null);
    const handleResize = ([entry])=>{
        const nextIsNarrow = entry.contentRect.width < MOBILE_BREAKPOINT;
        if (lastIsNarrowRef.current !== nextIsNarrow) {
            lastIsNarrowRef.current = nextIsNarrow;
            setIsContainerNarrow(nextIsNarrow);
        }
    };
    const resizeContainerRef = (element)=>{
        // Clean up previous observer
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        // Set up new observer if element exists
        if (element) {
            const resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(element);
            resizeObserverRef.current = resizeObserver;
        }
    };
    // Combine existing mobile detection with container width detection
    const shouldUseMobileLayout = isContainerNarrow || (0, $8dwdz.shouldShowMobileWeb)();
    return {
        resizeContainerRef: resizeContainerRef,
        shouldUseMobileLayout: shouldUseMobileLayout
    };
};
module.exports["useErrorPageMobileLayout"] = $5359ea5c70f1dd78$export$78b0da9378bc7a2d;

});

parcelRegister("6UBEn", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $3cc01bd0176870aa$var$MIN_VALUE = 0;
const $3cc01bd0176870aa$var$MAX_VALUE = 1;
const $3cc01bd0176870aa$var$increasingBarAnimation = null;
const $3cc01bd0176870aa$var$decreasingBarAnimation = null;
const $3cc01bd0176870aa$var$containerStyles = null;
const $3cc01bd0176870aa$var$containerStylesT26Shape = null;
const $3cc01bd0176870aa$var$containerAppearance = {
    default: "_bfhki8nm",
    success: "_bfhki8nm",
    inverse: "_bfhk1vck"
};
const $3cc01bd0176870aa$var$barAppearance = {
    default: "_bfhk1aqn",
    success: "_bfhkkcmj",
    inverse: "_bfhkvuon"
};
const $3cc01bd0176870aa$var$barStyles = null;
const $3cc01bd0176870aa$var$barStylesT26Shape = null;
const $3cc01bd0176870aa$var$determinateBarStyles = null;
const $3cc01bd0176870aa$var$increasingBarStyles = null;
const $3cc01bd0176870aa$var$decreasingBarStyles = null; /**
                                   * __Progress bar__
                                   *
                                   * A progress bar displays the status of a given process.
                                   *
                                   * - [Examples](https://atlassian.design/components/progress-bar/examples)
                                   * - [Code](https://atlassian.design/components/progress-bar/code)
                                   * - [Usage](https://atlassian.design/components/progress-bar/usage)
                                   */ 
const $3cc01bd0176870aa$var$ProgressBar = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { appearance: t1, ariaLabel: ariaLabel, isIndeterminate: t2, testId: t3, value: t4 } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const isIndeterminate = t2 === undefined ? false : t2;
    const testId = t3 === undefined ? "progress-bar" : t3;
    const value = t4 === undefined ? 0 : t4;
    const valueParsed = isIndeterminate ? $3cc01bd0176870aa$var$MIN_VALUE : Math.max($3cc01bd0176870aa$var$MIN_VALUE, Math.min(value, $3cc01bd0176870aa$var$MAX_VALUE));
    let t5;
    if ($[0] !== appearance) {
        t5 = (0, $gMc0m.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
            (0, $dh538.fg)("platform-dst-shape-theme-default") && "_2rko1rr0",
            $3cc01bd0176870aa$var$containerAppearance[appearance]
        ]);
        $[0] = appearance;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== appearance || $[3] !== isIndeterminate || $[4] !== value) {
        t6 = isIndeterminate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: (0, $gMc0m.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $3cc01bd0176870aa$var$barAppearance[appearance],
                "_5sagymdr _tip812c5 _j7hq7g40",
                (0, $dh538.fg)("platform-dst-shape-theme-default") && "_2rko1rr0"
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: (0, $gMc0m.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $3cc01bd0176870aa$var$barAppearance[appearance],
                "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v",
                (0, $dh538.fg)("platform-dst-shape-theme-default") && "_2rko1rr0"
            ])
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $gMc0m.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $3cc01bd0176870aa$var$barAppearance[appearance],
                "_v564calv",
                (0, $dh538.fg)("platform-dst-shape-theme-default") && "_2rko1rr0"
            ])
        });
        $[2] = appearance;
        $[3] = isIndeterminate;
        $[4] = value;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== ariaLabel || $[7] !== t5 || $[8] !== t6 || $[9] !== testId || $[10] !== valueParsed) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            role: "progressbar",
            "aria-label": ariaLabel,
            "aria-valuemin": $3cc01bd0176870aa$var$MIN_VALUE,
            "aria-valuenow": valueParsed,
            "aria-valuemax": $3cc01bd0176870aa$var$MAX_VALUE,
            "data-testid": testId,
            className: t5
        }, t6);
        $[6] = ariaLabel;
        $[7] = t5;
        $[8] = t6;
        $[9] = testId;
        $[10] = valueParsed;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $3cc01bd0176870aa$var$MIN_VALUE : Math.max($3cc01bd0176870aa$var$MIN_VALUE, Math.min(value, $3cc01bd0176870aa$var$MAX_VALUE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $3cc01bd0176870aa$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $3cc01bd0176870aa$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0",
            $3cc01bd0176870aa$var$containerAppearance[appearance]
        ])
    }, isIndeterminate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
            $3cc01bd0176870aa$var$barAppearance[appearance],
            "_5sagymdr _tip812c5 _j7hq7g40",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
            $3cc01bd0176870aa$var$barAppearance[appearance],
            "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            width: `${Number(value) * 100}%`
        },
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
            $3cc01bd0176870aa$var$barAppearance[appearance],
            "_v564calv",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
        ])
    }));
};
var $3cc01bd0176870aa$export$2e2bcd8739ae039 = $3cc01bd0176870aa$var$ProgressBar;
module.exports["default"] = $3cc01bd0176870aa$export$2e2bcd8739ae039;

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("618I0"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("618I0", function(module, exports) {

let $4619977a62937b7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4619977a62937b7e$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("kAGh9", function(module, exports) {
/* BulkAccessManagementPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $laHi9 = parcelRequire("laHi9");


var $ccHMk = parcelRequire("ccHMk");


var $7p4As = parcelRequire("7p4As");


var $inPa6 = parcelRequire("inPa6");


var $cO1el = parcelRequire("cO1el");


var $6f0Oj = parcelRequire("6f0Oj");


var $dcJ7R = parcelRequire("dcJ7R");


var $ecnYn = parcelRequire("ecnYn");


var $iO5Gm = parcelRequire("iO5Gm");


var $6mKj3 = parcelRequire("6mKj3");


var $1BYn9 = parcelRequire("1BYn9");


var $g3p2i = parcelRequire("g3p2i");


var $hpRYU = parcelRequire("hpRYU");


var $euL71 = parcelRequire("euL71");


var $1NBp8 = parcelRequire("1NBp8");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7aRa9 = parcelRequire("7aRa9");


var $c6lYi = parcelRequire("c6lYi");


var $6sX6R = parcelRequire("6sX6R");

var $bYvQP = parcelRequire("bYvQP");

parcelRequire("cp4jg");
var $9phVF = parcelRequire("9phVF");


var $bQm3c = parcelRequire("bQm3c");


var $8A6YM = parcelRequire("8A6YM");














var $kZ5GD = parcelRequire("kZ5GD");

const $8799edea050578d8$var$i18n = (0, $aXWIB.defineMessages)({
    actionSelectionHeader: {
        id: "bulk-permissions.space.action-selection-header",
        defaultMessage: "Action to perform<asterisk>*</asterisk>"
    },
    actionSelectionAdd: {
        id: "bulk-permissions.space.action-selection-add",
        defaultMessage: "Add or change access"
    },
    actionSelectionRemove: {
        id: "bulk-permissions.space.action-selection-remove",
        defaultMessage: "Remove access"
    }
});
var $8799edea050578d8$export$19d9f94347fa723d = /*#__PURE__*/ function(ActionSelection) {
    ActionSelection["AddOrChangeAccess"] = "add-or-change-access";
    ActionSelection["RemoveAccess"] = "remove-access";
    return ActionSelection;
}({});
const $8799edea050578d8$var$actionSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $8799edea050578d8$var$asteriskStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.red'
});
const $8799edea050578d8$export$321778e99f9fd257 = ({ actionSelection: actionSelection, onRadioChange: onRadioChange, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8799edea050578d8$var$actionSelectionHeaderStyle,
        testId: "action-selection-radio-buttons"
    }, formatMessage($8799edea050578d8$var$i18n.actionSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8799edea050578d8$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        value: "add-or-change-access",
        onChange: onRadioChange,
        isChecked: actionSelection === "add-or-change-access",
        isDisabled: isDisabled,
        name: "action-selection",
        label: formatMessage($8799edea050578d8$var$i18n.actionSelectionAdd)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        value: "remove-access",
        onChange: onRadioChange,
        isChecked: actionSelection === "remove-access",
        isDisabled: isDisabled,
        name: "action-selection",
        label: formatMessage($8799edea050578d8$var$i18n.actionSelectionRemove)
    })));
};


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $2fd747c2df30bd9d$export$dc2a111abcc46324 = /*#__PURE__*/ function(BulkRoleAssignmentSpaceType) {
    BulkRoleAssignmentSpaceType["COLLABORATION"] = "COLLABORATION";
    BulkRoleAssignmentSpaceType["GLOBAL"] = "GLOBAL";
    BulkRoleAssignmentSpaceType["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    BulkRoleAssignmentSpaceType["PERSONAL"] = "PERSONAL";
    return BulkRoleAssignmentSpaceType;
}({});
var $2fd747c2df30bd9d$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["TEAM"] = "TEAM";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});


/**
 * @generated SignedSource<<20a9c4df2f36d65a8ff761b6589d70b2>>
 * @relayHash bd7c883ca62fec8638ba84ea336b2321
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 949dc2fd39019cf39ada8cacca907201f62bbe585e7daaae9c36adfb838b5f6d
const $60adf85299dca4dd$var$node = function() {
    var v0 = [
        {
            "concreteType": "SpaceRoleConnection",
            "kind": "LinkedField",
            "name": "spaceRolesByCriteria",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SpaceRole",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "roleId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDisplayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDescription"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleType"
                        },
                        {
                            "concreteType": "SpacePermissionInfo",
                            "kind": "LinkedField",
                            "name": "spacePermissionList",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "priority"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "requiredSpacePermissions"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "RoleSelectionSectionRolesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "RoleSelectionSectionRolesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bd7c883ca62fec8638ba84ea336b2321",
            "id": "949dc2fd39019cf39ada8cacca907201f62bbe585e7daaae9c36adfb838b5f6d",
            "metadata": {},
            "name": "RoleSelectionSectionRolesQuery",
            "operationKind": "query",
            "text": "query RoleSelectionSectionRolesQuery{spaceRolesByCriteria{nodes{roleId,roleDisplayName,roleDescription,roleType,spacePermissionList{id,priority,displayName,description,requiredSpacePermissions}}}}"
        }
    };
}();
$60adf85299dca4dd$var$node.hash = "cc445348302affe2962240cd1154aad8";
var $60adf85299dca4dd$export$2e2bcd8739ae039 = $60adf85299dca4dd$var$node;















var $5dK2X = parcelRequire("5dK2X");


var $bfgIy = parcelRequire("bfgIy");


var $1kHsc = parcelRequire("1kHsc");


var $ku6MO = parcelRequire("ku6MO");


var $3EH2D = parcelRequire("3EH2D");


var $jMyy4 = parcelRequire("jMyy4");








var $gdv5Z = parcelRequire("gdv5Z");


var $9rnOu = parcelRequire("9rnOu");


var $g26MG = parcelRequire("g26MG");

/**
 * @generated SignedSource<<1f74a5836cf333e34a3b589bcb62cb6c>>
 * @relayHash fe5341c7119ce6b48784ed36451a3ad5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92726285efdd6e37384c9e6e8ed615f4bed51619568bbfa43f845a7fbf98b969
const $1476e0968a56b5c7$var$node = function() {
    var v0 = [
        {
            "concreteType": "SpaceRoleConnection",
            "kind": "LinkedField",
            "name": "spaceRolesByCriteria",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SpaceRole",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "roleId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDisplayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDescription"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleType"
                        },
                        {
                            "concreteType": "SpacePermissionInfo",
                            "kind": "LinkedField",
                            "name": "spacePermissionList",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "priority"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hubDisplayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hubDescription"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "requiredSpacePermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SpaceRolePageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useViewPermissionsModalRolesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useViewPermissionsModalRolesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "fe5341c7119ce6b48784ed36451a3ad5",
            "id": "92726285efdd6e37384c9e6e8ed615f4bed51619568bbfa43f845a7fbf98b969",
            "metadata": {},
            "name": "useViewPermissionsModalRolesQuery",
            "operationKind": "query",
            "text": "query useViewPermissionsModalRolesQuery{spaceRolesByCriteria{nodes{roleId,roleDisplayName,roleDescription,roleType,spacePermissionList{id,priority,displayName,description,hubDisplayName,hubDescription,requiredSpacePermissions}},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$1476e0968a56b5c7$var$node.hash = "0d3baeae35295e4523feb5527dc2a3d3";
var $1476e0968a56b5c7$export$2e2bcd8739ae039 = $1476e0968a56b5c7$var$node;


/**
 * @generated SignedSource<<ab690981298f6411b3f046f43a909dd6>>
 * @relayHash 647398da5f046eab487178776f59ec6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29ca9ec3b6d7be7170e2da0e8662dc06bfdaf4762282d10e71dbefcbed8ec3ee
const $b4360d56b570d73b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v1 = {
        "kind": "ScalarField",
        "name": "priority"
    }, v2 = [
        {
            "concreteType": "SpacePermissionConnection",
            "kind": "LinkedField",
            "name": "spacePermissionsAll",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SpacePermissionInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        v0 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hubDisplayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hubDescription"
                        },
                        v1 /*: any*/ ,
                        {
                            "concreteType": "SpacePermissionGroup",
                            "kind": "LinkedField",
                            "name": "group",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "requiredSpacePermissions"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useViewPermissionsModalPermissionsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useViewPermissionsModalPermissionsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "647398da5f046eab487178776f59ec6d",
            "id": "29ca9ec3b6d7be7170e2da0e8662dc06bfdaf4762282d10e71dbefcbed8ec3ee",
            "metadata": {},
            "name": "useViewPermissionsModalPermissionsQuery",
            "operationKind": "query",
            "text": "query useViewPermissionsModalPermissionsQuery{spacePermissionsAll{nodes{id,displayName,description,hubDisplayName,hubDescription,priority,group{displayName,priority},requiredSpacePermissions}}}"
        }
    };
}();
$b4360d56b570d73b$var$node.hash = "e4a3c349162ebabf09288d398062a645";
var $b4360d56b570d73b$export$2e2bcd8739ae039 = $b4360d56b570d73b$var$node;






var $irVI7 = parcelRequire("irVI7");










const $5b8a2a030512dd5e$var$ENFORCE_DSP_LEARN_MORE_LINK = 'https://support.atlassian.com/security-and-access-policies/docs/what-is-a-data-security-policy/';
const $5b8a2a030512dd5e$var$i18n = (0, $aXWIB.defineMessages)({
    errorIconLabel: {
        id: "bulk-permissions.flag-message.error-icon-label",
        defaultMessage: "Error"
    },
    processingFlagTitle: {
        id: "bulk-permissions.flag-message.processing",
        defaultMessage: "Bulk change processing"
    },
    processingFlagContent: {
        id: "bulk-permissions.flag-message.processing-content",
        defaultMessage: "This can take a while. We\u2019ll notify you by email when it\u2019s finished."
    },
    errorFlagTitle: {
        id: "bulk-permissions.flag-message.error",
        defaultMessage: "Bulk access change failed"
    },
    errorFlagContent: {
        id: "bulk-permissions.flag-message.error-content",
        defaultMessage: "We ran into a problem completing your bulk access change. Try again."
    },
    warningTitle: {
        id: "bulk-permissions.flag-message.warning-title",
        defaultMessage: "Policy prohibits external sharing"
    },
    warningMessage: {
        id: "bulk-permissions.flag-message.warning-message",
        defaultMessage: "Even if a role includes permission to enable anonymous access or public links, your organization's security policy will prevent it."
    },
    learnMore: {
        id: "bulk-permissions.flag-messagelearn-more",
        defaultMessage: "Learn about policies"
    }
});
const $5b8a2a030512dd5e$export$4b081a83cd5f1b6f = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const showErrorFlag = ()=>flags.showErrorFlag({
            id: `error-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.errorFlagTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.errorFlagContent),
            isAutoDismiss: true
        });
    const showProcessingFlag = ()=>flags.showInfoFlag({
            id: `processing-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.processingFlagTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.processingFlagContent),
            isAutoDismiss: true
        });
    const showInfoFlag = ()=>flags.showInfoFlag({
            id: `processing-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.warningTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.warningMessage),
            actions: [
                {
                    content: formatMessage($5b8a2a030512dd5e$var$i18n.learnMore),
                    href: $5b8a2a030512dd5e$var$ENFORCE_DSP_LEARN_MORE_LINK
                }
            ],
            isAutoDismiss: true
        });
    return {
        showErrorFlag: showErrorFlag,
        showProcessingFlag: showProcessingFlag,
        showInfoFlag: showInfoFlag
    };
};


const $838f830302a4f6f5$var$useViewPermissionsModalPermissionsQuery = (0, $b4360d56b570d73b$export$2e2bcd8739ae039);
const $838f830302a4f6f5$var$useViewPermissionsModalRolesQuery = (0, $1476e0968a56b5c7$export$2e2bcd8739ae039);
const $838f830302a4f6f5$export$aec138b16dafcc0a = ({ flags: flags })=>{
    const [experienceStarted, setExperienceStarted] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showErrorFlag: showErrorFlag } = (0, $5b8a2a030512dd5e$export$4b081a83cd5f1b6f)({
        flags: flags
    });
    const fail = (error)=>{
        const experienceFailure = error || new Error('An error occurred');
        experienceTracker.fail({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            error: experienceFailure
        });
        showErrorFlag();
    };
    const { data: permissionsData, loading: loading } = (0, $jMyy4.useQueryInterop)($838f830302a4f6f5$var$useViewPermissionsModalPermissionsQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        },
        onError: (error)=>{
            setExperienceStarted(false);
            fail(error);
        },
        __callerPackage__: "@confluence/bulk-permissions"
    });
    const { data: rolesData, loading: rolesLoading } = (0, $jMyy4.useQueryInterop)($838f830302a4f6f5$var$useViewPermissionsModalRolesQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        },
        onError: (error)=>{
            setExperienceStarted(false);
            fail(error);
        },
        __callerPackage__: "@confluence/bulk-permissions"
    });
    (0, $42omo.useEffect)(()=>{
        if (loading || rolesLoading && !experienceStarted) experienceTracker.start({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
        });
    }, [
        loading,
        rolesLoading,
        experienceStarted,
        experienceTracker
    ]);
    return {
        loading: loading,
        permissions: permissionsData?.spacePermissionsAll?.nodes || [],
        roles: rolesData?.spaceRolesByCriteria?.nodes || []
    };
};









var $eXmBZ = parcelRequire("eXmBZ");





var $lsxnT = parcelRequire("lsxnT");

const $710ea738a38b5734$export$1a3c335d7dca645d = ({ content: content, isOpen: isOpen, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
        isOpen: isOpen,
        content: ()=>content,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                appearance: "subtle",
                "aria-haspopup": true,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
                onClick: onClick,
                "aria-label": formatMessage({
                    id: "bulk-access.role-select.info-popup",
                    defaultMessage: "View info"
                })
            }, null),
        shouldRenderToParent: true
    }));
};












var $1GzhS = parcelRequire("1GzhS");
















const $5e889a2aa3054314$var$i18n = (0, $aXWIB.defineMessages)({
    viewRolePermissionsLabel: {
        id: "bulk-permissions.info-popup.view-role-permissions-label",
        defaultMessage: "View role permissions"
    }
});
const $5e889a2aa3054314$var$contentStyle = (0, $ecnYn.xcss)({
    width: '315px',
    padding: 'space.300'
});
const $5e889a2aa3054314$var$headerStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $5e889a2aa3054314$var$buttonStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    display: 'flex',
    alignItems: 'center'
});
const $5e889a2aa3054314$var$usePermissionsSummary = ({ roleId: roleId, roleLookup: roleLookup })=>{
    const role = roleLookup.find((lookup)=>lookup.id === roleId);
    // Role access
    return {
        heading: role?.name,
        description: role?.description
    };
};
const $5e889a2aa3054314$export$90dae7b611e581b7 = ({ onCtaClick: onCtaClick, roleId: roleId, roleLookup: roleLookup })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { heading: heading, description: description } = $5e889a2aa3054314$var$usePermissionsSummary({
        roleId: roleId,
        roleLookup: roleLookup
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $5e889a2aa3054314$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5e889a2aa3054314$var$headerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $5e889a2aa3054314$var$buttonStyle
    }, roleId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: onCtaClick
    }, formatMessage($5e889a2aa3054314$var$i18n.viewRolePermissionsLabel)) : null)));
};


const $117ed3de9d2a23fd$export$5bafd35f9dc9151a = ({ analyticsSource: analyticsSource, currentRole: currentRole, roleLookup: roleLookup, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const [isViewPermissionsModalOpen, setIsViewPermissionsModalOpen] = (0, $42omo.useState)(false);
    const { permissions: permissions, roles: roles } = (0, $838f830302a4f6f5$export$aec138b16dafcc0a)({
        flags: flags
    });
    const systemRoles = roles.filter((role)=>role?.roleType === 'SYSTEM');
    const customRoles = roles.filter((role)=>role?.roleType === 'CUSTOM');
    const onInfoButtonClick = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'role-select-info-button',
                source: analyticsSource,
                attributes: {
                    roleId: currentRole?.id
                }
            }
        }).fire();
    }, [
        isPopupOpen,
        currentRole?.id,
        analyticsSource,
        createAnalyticsEvent
    ]);
    const onPopupContentCtaClick = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(false);
        setIsViewPermissionsModalOpen(true);
    }, []);
    const popupRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    (0, $42omo.useEffect)(()=>{
        if (popupRef.current) {
            const handleClickOutside = (e)=>{
                if (popupRef.current && !popupRef.current.contains(e.target)) setIsPopupOpen(false);
            };
            document.addEventListener('click', handleClickOutside);
            return ()=>document.removeEventListener('click', handleClickOutside);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isViewPermissionsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9rnOu.ViewRolePermissionModal), {
        systemRoles: (0, $g26MG.normalizeSpaceRoleList)(systemRoles.filter((r)=>r !== null)),
        customRoles: (0, $g26MG.normalizeSpaceRoleList)(customRoles.filter((r)=>r !== null)),
        allPermissions: (0, $g26MG.normalizeSpacePermissionAll)(permissions),
        initialActiveRoleId: currentRole?.id,
        analyticsSource: analyticsSource,
        onClose: ()=>setIsViewPermissionsModalOpen(false)
    }), currentRole ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: popupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $710ea738a38b5734$export$1a3c335d7dca645d), {
        "data-testid": "role-selector-info-button",
        isOpen: isPopupOpen,
        onClick: onInfoButtonClick,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5e889a2aa3054314$export$90dae7b611e581b7), {
            onCtaClick: onPopupContentCtaClick,
            roleId: currentRole.id,
            permissions: currentRole.permissions,
            roleLookup: roleLookup
        })
    })) : null);
};


const $0c8581713df69b2f$var$i18n = (0, $aXWIB.defineMessages)({
    roleSelectionHeader: {
        id: "bulk-permissions.space.role-selection-header",
        defaultMessage: "With what access<asterisk>*</asterisk>"
    },
    roleSelectionSubHeader: {
        id: "bulk-permissions.space.role-selection-sub-header",
        defaultMessage: "Choose the role they should have."
    },
    roleSelectionWarning: {
        id: "bulk-permissions.space.role-selection-warning",
        defaultMessage: "This will overwrite any existing access they have. <b>This can\u2019t be undone,</b> so make sure to double check your selections."
    },
    roleSelectLabel: {
        id: "bulk-permissions.space.role-select-label",
        defaultMessage: "Role"
    },
    roleSelectPlaceholder: {
        id: "bulk-permissions.space-role.select-placeholder",
        defaultMessage: "Select a role"
    }
});
const $0c8581713df69b2f$var$roleSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 'space.100'
});
const $0c8581713df69b2f$var$asteriskStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.red'
});
const $0c8581713df69b2f$var$roleSelectionContainer = (0, $ecnYn.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.300'
});
const $0c8581713df69b2f$var$sectionContainer = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
});
const $0c8581713df69b2f$var$roleSelectInfoButtonStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    minWidth: '500px',
    alignItems: 'center'
});
const $0c8581713df69b2f$var$roleSelectStyle = (0, $ecnYn.xcss)({
    minWidth: '300px'
});
const $0c8581713df69b2f$var$roleSelectionSectionRolesQuery = (0, $60adf85299dca4dd$export$2e2bcd8739ae039);
const $0c8581713df69b2f$export$884fc60bd42d0abd = ({ onRoleChange: onRoleChange, roleAssignment: roleAssignment, analyticsSource: analyticsSource, flags: flags, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [experienceStarted, setExperienceStarted] = (0, $42omo.useState)(false);
    //TODO: update this and add it to experience tracker once the experience is created
    const BULK_ROLES_VIEW_EXPERIENCE = 'bulk-roles-view-experience';
    const placeholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text"
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectPlaceholder));
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($0c8581713df69b2f$var$roleSelectionSectionRolesQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: BULK_ROLES_VIEW_EXPERIENCE
            });
        },
        onError: (error)=>{
            experienceTracker.stopOnError({
                name: BULK_ROLES_VIEW_EXPERIENCE,
                error: error
            });
        },
        __callerPackage__: "@confluence/bulk-permissions"
    });
    const roleOptions = data?.spaceRolesByCriteria?.nodes?.map((role)=>({
            id: role?.roleId || '',
            name: role?.roleDisplayName || '',
            permissions: role?.spacePermissionList.map((permission)=>permission.id) || [],
            description: role?.roleDescription || '',
            roleType: role?.roleType ?? (0, $3EH2D.SpaceRoleType).SYSTEM
        })) || [];
    (0, $42omo.useEffect)(()=>{
        if (loading && !experienceStarted) setExperienceStarted(true);
    }, [
        loading,
        experienceStarted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectionHeaderStyle
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0c8581713df69b2f$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionSubHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
        htmlFor: "role-selector"
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectInfoButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ku6MO.RoleSelector), {
        inputId: "role-selector",
        value: roleAssignment?.id || null,
        onChange: onRoleChange,
        placeholder: placeholder,
        isLoading: loading,
        isDisabled: isDisabled,
        spaceRoleOptions: roleOptions,
        appearance: "default"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $117ed3de9d2a23fd$export$5bafd35f9dc9151a), {
        currentRole: roleAssignment,
        roleLookup: roleOptions,
        analyticsSource: analyticsSource,
        flags: flags
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionWarning, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
    })));
};



var $ilq3G = parcelRequire("ilq3G");


var $eIwUX = parcelRequire("eIwUX");





var $6xdDU = parcelRequire("6xdDU");





var $lM2MU = parcelRequire("lM2MU");








var $eEA8O = parcelRequire("eEA8O");


var $1DHa6 = parcelRequire("1DHa6");


var $8o1lj = parcelRequire("8o1lj");


var $9ot3w = parcelRequire("9ot3w");


var $d8eRd = parcelRequire("d8eRd");











var $67Foi = parcelRequire("67Foi");




const $d771d120872e42c7$var$i18n = (0, $aXWIB.defineMessages)({
    addConfirmationDialogTitle: {
        id: "bulk-permissions.space.add.confirmation-dialog",
        defaultMessage: "Add {principalName} to all spaces?"
    },
    addAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces (excluding personal)</b> on your site as <b>{roleName}</b>."
    },
    addAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-all.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> on your site as <b>{roleName}</b>."
    },
    addAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all personal spaces</b> on your site as <b>{roleName}</b>."
    },
    confirmationDialogWarning: {
        id: "bulk-permissions.space.confirmation-dialog-warning",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    removeConfirmationDialogTitle: {
        id: "bulk-permissions.space.remove.confirmation-dialog",
        defaultMessage: "Remove {principalName} from all spaces?"
    },
    removeAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> (excluding personal) on your site."
    },
    removeAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-all.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> on your site."
    },
    removeAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all personal spaces</b> on your site."
    },
    cancelButtonText: {
        id: "bulk-permissions.space.cancel-button-text",
        defaultMessage: "Cancel"
    },
    addButtonText: {
        id: "bulk-permissions.space.add-button-text",
        defaultMessage: "Add to all"
    },
    removeButtonText: {
        id: "bulk-permissions.space.remove-button-text",
        defaultMessage: "Remove access"
    }
});
const $d771d120872e42c7$var$ConfirmatonSubSection = (0, $ecnYn.xcss)({
    paddingTop: 'space.300'
});
const $d771d120872e42c7$var$boldString = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks);
const $d771d120872e42c7$export$6daa4510cb54b507 = ({ principalName: principalName, isRemoval: isRemoval, spaceSelection: spaceSelection, roleName: roleName, onConfirm: onConfirm, onCancel: onCancel })=>{
    const getConfirmationDialogDescription = ()=>{
        if (isRemoval) switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $d771d120872e42c7$var$i18n.removeAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $d771d120872e42c7$var$i18n.removeAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $d771d120872e42c7$var$i18n.removeAllPersonalConfirmationDialogDescription;
        }
        else switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $d771d120872e42c7$var$i18n.addAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $d771d120872e42c7$var$i18n.addAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $d771d120872e42c7$var$i18n.addAllPersonalConfirmationDialogDescription;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
        name: "bulk-access-dialog",
        id: "bulk-access-dialog",
        attributes: {
            action: isRemoval ? 'remove' : 'add',
            spaceType: spaceSelection
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: isRemoval ? 'warning' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...isRemoval ? $d771d120872e42c7$var$i18n.removeConfirmationDialogTitle : $d771d120872e42c7$var$i18n.addConfirmationDialogTitle,
        values: {
            principalName: principalName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...getConfirmationDialogDescription(),
        values: {
            b: $d771d120872e42c7$var$boldString,
            roleName: roleName
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $d771d120872e42c7$var$ConfirmatonSubSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$d771d120872e42c7$var$i18n.confirmationDialogWarning,
        values: {
            b: $d771d120872e42c7$var$boldString
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $d771d120872e42c7$var$i18n.cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "confirmation-dialog-confirm-button",
        appearance: isRemoval ? 'warning' : 'primary',
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), isRemoval ? $d771d120872e42c7$var$i18n.removeButtonText : $d771d120872e42c7$var$i18n.addButtonText))));
};


const $1d76093de32754c2$export$9297639d67b5de69 = ({ principalName: principalName, roleName: roleName, isLoading: isLoading, isRemoval: isRemoval, spaceSelection: spaceSelection, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        testId: "bulk-access-confirmation",
        onClose: // Don't allow the dialog to close while mutation is loading
        isLoading ? undefined : onCancel
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lM2MU.LoadingDialog), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d771d120872e42c7$export$6daa4510cb54b507), {
        principalName: principalName,
        roleName: roleName,
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        onCancel: onCancel,
        onConfirm: onConfirm
    })));
};


/**
 * @generated SignedSource<<340abb860c699549fbb186fa0f01df84>>
 * @relayHash 0dc51d4e6b21d806122d9dcffa795bcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad25d5510f09dfa2653e56b9d7b9d15e81bd26b00f4b66aa0374e8710435b010
const $1d4c1eba0eff269c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "principalId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "principalType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceTypes"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "principalId",
                                    "variableName": "principalId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "principalType",
                                    "variableName": "principalType"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "principal"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceTypes",
                            "variableName": "spaceTypes"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkRemoveRoleAssignmentFromSpacesPayload",
            "kind": "LinkedField",
            "name": "bulkRemoveRoleAssignmentFromSpaces",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "taskId"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0dc51d4e6b21d806122d9dcffa795bcf",
            "id": "ad25d5510f09dfa2653e56b9d7b9d15e81bd26b00f4b66aa0374e8710435b010",
            "metadata": {},
            "name": "useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation",
            "operationKind": "mutation",
            "text": "mutation useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation($principalId:ID!,$principalType:RoleAssignmentPrincipalType!,$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkRemoveRoleAssignmentFromSpaces(input:{principal:{principalId:$principalId,principalType:$principalType},spaceTypes:$spaceTypes}){taskId,success,errors{message}}}"
        }
    };
}();
$1d4c1eba0eff269c$var$node.hash = "a5efdd94809c62d366be293748749bcb";
var $1d4c1eba0eff269c$export$2e2bcd8739ae039 = $1d4c1eba0eff269c$var$node;


/**
 * @generated SignedSource<<a1a39286bf2d284e9f77a27eb2277170>>
 * @relayHash a5b790ed65d0de142da6e4d1622295fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 16056f05f1e48cfbfc1a00a65f23a9f7adf9a12f7a15ad4d1d6d21505a8c51a2
const $0639403282a4d5d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "principalId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "principalType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "roleId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceTypes"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "principalId",
                                            "variableName": "principalId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "principalType",
                                            "variableName": "principalType"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "principal"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "roleId",
                                    "variableName": "roleId"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "roleAssignment"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceTypes",
                            "variableName": "spaceTypes"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkSetRoleAssignmentToSpacesPayload",
            "kind": "LinkedField",
            "name": "bulkSetRoleAssignmentToSpaces",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "taskId"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a5b790ed65d0de142da6e4d1622295fa",
            "id": "16056f05f1e48cfbfc1a00a65f23a9f7adf9a12f7a15ad4d1d6d21505a8c51a2",
            "metadata": {},
            "name": "useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation",
            "operationKind": "mutation",
            "text": "mutation useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation($principalId:ID!,$principalType:RoleAssignmentPrincipalType!,$roleId:ID!,$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkSetRoleAssignmentToSpaces(input:{roleAssignment:{principal:{principalId:$principalId,principalType:$principalType},roleId:$roleId},spaceTypes:$spaceTypes}){taskId,success,errors{message}}}"
        }
    };
}();
$0639403282a4d5d2$var$node.hash = "ed136028da75a75da2fb263f31962138";
var $0639403282a4d5d2$export$2e2bcd8739ae039 = $0639403282a4d5d2$var$node;






var $cXkvk = parcelRequire("cXkvk");


var $308Wd = parcelRequire("308Wd");


const $754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation = (0, $0639403282a4d5d2$export$2e2bcd8739ae039);
const $754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation = (0, $1d4c1eba0eff269c$export$2e2bcd8739ae039);
const $754fc52bc3b4de65$export$667fffd9e35f2dcd = ({ closeDialog: closeDialog, flags: flags, rolePermissions: rolePermissions })=>{
    const { showErrorFlag: showErrorFlag, showProcessingFlag: showProcessingFlag, showInfoFlag: showInfoFlag } = (0, $5b8a2a030512dd5e$export$4b081a83cd5f1b6f)({
        flags: flags
    });
    const showDSPWarning = (0, $cXkvk.useShouldShowDSPWarningForWorkspaceRole)(rolePermissions);
    const onMutationErrored = (0, $42omo.useCallback)(()=>{
        closeDialog();
        showErrorFlag();
    }, [
        closeDialog,
        showErrorFlag
    ]);
    const onAsyncMutationSubmitted = (0, $42omo.useCallback)((data)=>{
        closeDialog();
        /**
     * The backend is counting the mutation as a success for some exceptions
     * but returning an error in the mutation response.  We need to check for
     * these here.
     */ if (data?.bulkSetRoleAssignmentToSpaces?.errors?.length > 0 || data?.bulkRemoveRoleAssignmentFromSpaces?.errors?.length > 0) onMutationErrored();
        else if (data.bulkSetRoleAssignmentToSpaces?.taskId || data.bulkRemoveRoleAssignmentFromSpaces?.taskId) {
            if (showDSPWarning) showInfoFlag();
            else // show the progress flag
            showProcessingFlag();
        }
    }, [
        closeDialog,
        onMutationErrored,
        showDSPWarning,
        showInfoFlag,
        showProcessingFlag
    ]);
    const [bulkSetRoleAssignmentToSpaces, { data: bulkAssignmentData }] = (0, $308Wd.useMutationInterop)($754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: ()=>{
            closeDialog();
            onMutationErrored();
        },
        __callerPackage__: "@confluence/bulk-permissions"
    });
    const [bulkRemoveRoleAssignment, { data: bulkRemoveAssignmentData }] = (0, $308Wd.useMutationInterop)($754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: ()=>{
            closeDialog();
            onMutationErrored();
        },
        __callerPackage__: "@confluence/bulk-permissions"
    });
    return {
        bulkSetRoleAssignmentToSpaces: bulkSetRoleAssignmentToSpaces,
        bulkRemoveRoleAssignment: bulkRemoveRoleAssignment,
        bulkAssignmentData: bulkAssignmentData,
        bulkRemoveAssignmentData: bulkRemoveAssignmentData
    };
};


const $1f40f2edcedc8ce5$export$f7109619a5e9e0d6 = 'bulkAccessManagementScreen';
const $1f40f2edcedc8ce5$var$i18n = (0, $aXWIB.defineMessages)({
    bulkRoleAccessHeader: {
        id: "bulk-permissions.space.role-access-header",
        defaultMessage: "Manage space access in bulk"
    },
    bulkRoleAccessSubtext: {
        id: "bulk-permissions.space.role-access-subtext",
        defaultMessage: "Quickly add, change, or remove access for individual users or groups across spaces on your Confluence site."
    },
    bulkRoleAccessTeamsSubtext: {
        id: "bulk-permissions.space.role-access-subtext-teams",
        defaultMessage: "Quickly add, change, or remove access for individual users, teams, or groups across spaces on your Confluence site."
    },
    warningSubtext: {
        id: "bulk-permissions.space.warning-subtext",
        defaultMessage: "<b>This can\u2019t be undone</b> so make sure to double check your selections."
    },
    userPickerAccessHeader: {
        id: "bulk-permissions.space.user-picker-access-header",
        defaultMessage: "Who<asterisk>*</asterisk>"
    },
    userPickerPlaceholder: {
        id: "bulk-permissions.space.user-picker-placeholder",
        defaultMessage: "Add a user, group, or user class"
    },
    userPickerTeamsPlaceholder: {
        id: "bulk-permissions.space.user-picker-teams-placeholder",
        defaultMessage: "Add a user, team, group, or user class"
    },
    backToSpacePermissions: {
        id: "bulk-permissions.space-permissions-link.role-access",
        defaultMessage: "Space permissions"
    },
    userPickerSubtext: {
        id: "bulk-permissions.space.user-picker-subtext.role-access",
        defaultMessage: "You may only select one for this action."
    },
    applyButtonTextAdd: {
        id: "bulk-permissions.space.apply-button-text-add.role-access",
        defaultMessage: "Add to all"
    },
    applyButtonTextRemoveRolesOnly: {
        id: "bulk-permissions.space.apply-button-text-remove-roles-only.role-access",
        defaultMessage: "Remove access"
    },
    requirementMessage: {
        id: "bulk-permissions.space.requirement-message.role-access",
        defaultMessage: "<asterisk>* </asterisk> Required to perform action"
    }
});
const $1f40f2edcedc8ce5$var$bulkAddRolesHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $1f40f2edcedc8ce5$var$bulkAddRolesHeaderModernizedWrapperStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.100'
});
const $1f40f2edcedc8ce5$var$bulkRolesSubtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    width: '75%'
});
const $1f40f2edcedc8ce5$var$bulkRolesSubtextStyleModernized = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    width: '100%'
});
const $1f40f2edcedc8ce5$var$principlePickerHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $1f40f2edcedc8ce5$var$asteriskStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.red'
});
const $1f40f2edcedc8ce5$var$principlePickerFineTextStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.gray',
    marginTop: 'space.050',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $1f40f2edcedc8ce5$var$contentStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.1000',
    marginRight: 'space.1000',
    paddingBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$var$contentStyleModernized = (0, $ecnYn.xcss)({
    paddingBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$var$backAndFeedbackButtonsStyle = (0, $ecnYn.xcss)({
    width: '100%',
    marginLeft: 'space.negative.200',
    paddingTop: 'space.300',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $1f40f2edcedc8ce5$var$principlePickerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $1f40f2edcedc8ce5$var$requirementTextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.300',
    paddingBottom: 'space.1000',
    marginBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$var$requirementTextStyleModernized = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.300'
});
const $1f40f2edcedc8ce5$var$styles = {
    removalWarningSubtext: "_n3td1ejb"
};
const $1f40f2edcedc8ce5$export$554dd5f0355b3be6 = (principal)=>{
    if (principal?.type === 'group') return principal?.id;
    return principal?.id;
};
const $1f40f2edcedc8ce5$export$9c91ebd69562789f = (options)=>{
    // TEMPORARY WORKAROUND https://product-fabric.atlassian.net/browse/CPE-3651:
    // Smart User Picker does not currently expose a reliable field to identify guest users.
    // We're using the presence of the "GUEST" lozenge as a proxy to filter out guest users.
    // This should be revisited once the platform team adds a proper field
    // to accurately indicate guest status.
    return options.filter((option)=>{
        const { lozenge: lozenge } = option;
        const isGuest = typeof lozenge === 'object' && lozenge !== null && 'text' in lozenge && lozenge.text === 'GUEST';
        return !isGuest;
    });
};
const $1f40f2edcedc8ce5$export$db2035bfb5892b74 = (0, $7aRa9.withFlags)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})(({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const accessClassInclusion = (0, $6sX6R.useAccessClassInclusion)();
    const { pickerProps: teamPickerProps } = (0, $9phVF.useTeamPicker)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const [showDialog, setShowDialog] = (0, $42omo.useState)(false);
    const [stagedPrincipal, setStagedPrincipal] = (0, $42omo.useState)(undefined);
    const [spaceSelection, setSpaceSelection] = (0, $42omo.useState)((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
    const { setSearchQuery: setSearchQuery, transformOptions: transformOptions } = (0, $bYvQP.useAccessClassTransformer)();
    const [actionSelection, setActionSelection] = (0, $42omo.useState)((0, $8799edea050578d8$export$19d9f94347fa723d).AddOrChangeAccess);
    const [roleAssignment, setRoleAssignment] = (0, $42omo.useState)(null);
    const isRemoval = actionSelection === (0, $8799edea050578d8$export$19d9f94347fa723d).RemoveAccess;
    const closeDialog = (0, $42omo.useCallback)(()=>{
        setShowDialog(false);
    }, [
        setShowDialog
    ]);
    const { bulkSetRoleAssignmentToSpaces: bulkSetRoleAssignmentToSpaces, bulkRemoveRoleAssignment: bulkRemoveRoleAssignment } = (0, $754fc52bc3b4de65$export$667fffd9e35f2dcd)({
        closeDialog: closeDialog,
        flags: flags,
        rolePermissions: roleAssignment?.permissions || []
    });
    const getSpaceTypes = (targetValue)=>{
        const spaceTypesArray = [
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).PERSONAL,
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).COLLABORATION,
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).GLOBAL,
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).KNOWLEDGE_BASE
        ];
        if (targetValue === (0, $8A6YM.SpaceSelection).AllExcludingPersonal) return spaceTypesArray.filter((type)=>type !== (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).PERSONAL);
        else if (targetValue === (0, $8A6YM.SpaceSelection).AllIncludingPersonal) return spaceTypesArray;
        else if (targetValue === (0, $8A6YM.SpaceSelection).OnlyPersonal) return [
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).PERSONAL
        ];
    };
    const getPrincipalType = (principalType)=>{
        if (principalType === 'group') return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).GROUP;
        else if (principalType === 'team') return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).GROUP;
        else if (principalType === 'custom') return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).ACCESS_CLASS;
        else return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).USER;
    };
    const onDialogConfirm = (0, $42omo.useCallback)(async ()=>{
        closeDialog();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulk-access-management-confirm',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    principalType: stagedPrincipal?.type === 'group' ? stagedPrincipal?.extra?.usageType : stagedPrincipal?.type,
                    verified: stagedPrincipal?.type === 'team' ? stagedPrincipal?.verified : 'N/A',
                    selectedRole: roleAssignment?.name,
                    spaceTypes: getSpaceTypes(spaceSelection),
                    action: isRemoval ? 'remove' : 'add'
                }
            }
        }).fire();
        isRemoval ? await bulkRemoveRoleAssignment({
            variables: {
                principalId: $1f40f2edcedc8ce5$export$554dd5f0355b3be6(stagedPrincipal),
                principalType: getPrincipalType(stagedPrincipal.type),
                spaceTypes: getSpaceTypes(spaceSelection)
            }
        }) : await bulkSetRoleAssignmentToSpaces({
            variables: {
                principalId: $1f40f2edcedc8ce5$export$554dd5f0355b3be6(stagedPrincipal),
                principalType: getPrincipalType(stagedPrincipal.type),
                roleId: roleAssignment.id,
                spaceTypes: getSpaceTypes(spaceSelection)
            }
        });
    }, [
        closeDialog,
        isRemoval,
        bulkRemoveRoleAssignment,
        stagedPrincipal,
        spaceSelection,
        bulkSetRoleAssignmentToSpaces,
        roleAssignment,
        createAnalyticsEvent
    ]);
    const handleBackToDefaultSpaceAccessClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'defaultspaceperms',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceTypeRadioChange = (0, $42omo.useCallback)((e)=>{
        setSpaceSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementSpace',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    spaceSelection: e.target.value,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onActionRadioChange = (0, $42omo.useCallback)((e)=>{
        setActionSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementAction',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    actionSelection: e.target.value,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]); //Only passing roleId to the analytics event to avoid leaking UGC
    //Ticket to audit rest of analytics events: https://product-fabric.atlassian.net/browse/RBAC-1552
    const onRoleChange = (0, $42omo.useCallback)((role)=>{
        setRoleAssignment(role);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'role picker',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagement',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    roleAssignment: role.id
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onPrincipalChange = (0, $42omo.useCallback)((received)=>{
        // Only send an analytic event if a principal isn't deselected
        if (received) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'principal',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementPrincipal',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    principal: received.type,
                    verified: received.type === 'team' ? received.verified : 'N/A',
                    isRBACEnabled: true
                }
            }
        }).fire();
        setStagedPrincipal(received);
    }, [
        createAnalyticsEvent
    ]);
    const openDialog = (0, $42omo.useCallback)(()=>{
        setShowDialog(true);
    }, [
        setShowDialog
    ]); // Don't render the page until we know if the user is a product admin
    // to avoid a flicker of the restricted view.
    if (isAdminCheckLoading) return null;
    if (!isProductAdmin || isFreeEdition && !(0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIwUX.RestrictedView), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iO5Gm.FlexContainer), {
        id: "SpaceSelectionPanel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? $1f40f2edcedc8ce5$var$contentStyleModernized : $1f40f2edcedc8ce5$var$contentStyle
    }, (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$backAndFeedbackButtonsStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        onClick: handleBackToDefaultSpaceAccessClick,
        href: (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'allspaces'
        }),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            })
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.backToSpacePermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c6lYi.FeedbackCollectorButton), {
        source: "Bulk Space Roles"
    })), (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$bulkAddRolesHeaderModernizedWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h1",
        size: "large"
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.bulkRoleAccessHeader))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$bulkAddRolesHeaderStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.bulkRoleAccessHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? $1f40f2edcedc8ce5$var$bulkRolesSubtextStyleModernized : $1f40f2edcedc8ce5$var$bulkRolesSubtextStyle
    }, formatMessage(teamPickerProps.includeTeamsUpdates ? $1f40f2edcedc8ce5$var$i18n.bulkRoleAccessTeamsSubtext : $1f40f2edcedc8ce5$var$i18n.bulkRoleAccessSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerHeaderStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerAccessHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $1f40f2edcedc8ce5$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        ariaLabel: formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerPlaceholder),
        "data-test-id": "user-and-group-search",
        fieldId: "bulk-permissions-user-picker",
        includeGroup: true,
        withUsers: true,
        isMulti: false,
        smart: true,
        customInclusion: accessClassInclusion,
        placeholder: formatMessage(teamPickerProps.includeTeamsUpdates ? $1f40f2edcedc8ce5$var$i18n.userPickerTeamsPlaceholder : $1f40f2edcedc8ce5$var$i18n.userPickerPlaceholder),
        sitePermissionTypeFilter: (0, $g3p2i.SitePermissionTypeFilter).NONE,
        noOptionsMessage: null,
        onChange: (received)=>{
            onPrincipalChange(received);
        },
        value: stagedPrincipal || [],
        filterSearchResults: (value)=>value?.extra?.permissionType !== (0, $g3p2i.SitePermissionType).EXTERNAL,
        onInputChange: (searchQuery)=>setSearchQuery(searchQuery || ''),
        transformOptions: transformOptions,
        smartFilterOptions: $1f40f2edcedc8ce5$export$9c91ebd69562789f,
        isDisabled: isFreeEdition,
        includeTeams: teamPickerProps.includeTeams,
        includeTeamsUpdates: teamPickerProps.includeTeamsUpdates,
        verifiedTeams: teamPickerProps.verifiedTeams
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ilq3G.AgentAccessWarning), {
        stagedPrincipals: stagedPrincipal ? [
            stagedPrincipal
        ] : []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerFineTextStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8799edea050578d8$export$321778e99f9fd257), {
        actionSelection: actionSelection,
        onRadioChange: onActionRadioChange,
        isDisabled: isFreeEdition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8A6YM.SpaceSelectionRadioButtons), {
        spaceSelection: spaceSelection,
        onRadioChange: onSpaceTypeRadioChange,
        isDisabled: isFreeEdition
    }), isRemoval ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$styles.removalWarningSubtext
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.warningSubtext, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c8581713df69b2f$export$884fc60bd42d0abd), {
        onRoleChange: onRoleChange,
        roleAssignment: roleAssignment,
        analyticsSource: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
        flags: flags,
        isDisabled: isFreeEdition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: isRemoval ? 'danger' : 'primary',
        onClick: ()=>openDialog(),
        isDisabled: isFreeEdition || stagedPrincipal === undefined || !isRemoval && roleAssignment === null
    }, formatMessage(isRemoval ? $1f40f2edcedc8ce5$var$i18n.applyButtonTextRemoveRolesOnly : $1f40f2edcedc8ce5$var$i18n.applyButtonTextAdd)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? $1f40f2edcedc8ce5$var$requirementTextStyleModernized : $1f40f2edcedc8ce5$var$requirementTextStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.requirementMessage, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $1f40f2edcedc8ce5$var$asteriskStyle
            }, chunks)
    }))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1d76093de32754c2$export$9297639d67b5de69), {
        principalName: stagedPrincipal?.name || '',
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        isLoading: false,
        onConfirm: onDialogConfirm,
        onCancel: closeDialog,
        roleName: roleAssignment?.name
    })));
}));
module.exports["ANALYTICS_SOURCE"] = $1f40f2edcedc8ce5$export$f7109619a5e9e0d6;
module.exports["getPrincipalId"] = $1f40f2edcedc8ce5$export$554dd5f0355b3be6;
module.exports["pickerResultsFilter"] = $1f40f2edcedc8ce5$export$9c91ebd69562789f;
module.exports["BulkAccessManagementPage"] = $1f40f2edcedc8ce5$export$db2035bfb5892b74;

});

parcelRegister("iO5Gm", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $92d16e8054e90c29$var$flexContainerStyles = null;
const $92d16e8054e90c29$export$124d4c7bf7db9715 = ({ id: id, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        id: id,
        className: (0, $gMc0m.default)([
            "_1e0c1txw"
        ]),
        children: children
    });
const $92d16e8054e90c29$var$contentWrapperStyles = null;
const $92d16e8054e90c29$export$6ce170286acaa8d3 = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _1ul9idpf _1reo15vq"
        ]),
        children: children
    });
module.exports["FlexContainer"] = $92d16e8054e90c29$export$124d4c7bf7db9715;
module.exports["ContentWrapper"] = $92d16e8054e90c29$export$6ce170286acaa8d3;

});

parcelRegister("c6lYi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $7yOcR = parcelRequire("7yOcR");


var $7aRa9 = parcelRequire("7aRa9");


var $iquRY = parcelRequire("iquRY");


var $cNkvT = parcelRequire("cNkvT");

const $fa5a2619efb2e23a$export$396d041cc2808022 = (0, $aXWIB.defineMessages)({
    buttonText: {
        id: "space-roles.feedback-collector.button-text",
        defaultMessage: "Give feedback"
    },
    flagTitle: {
        id: "space-roles.feedback-collector.flag-title",
        defaultMessage: "Feedback submitted, thank you!"
    }
});
const $fa5a2619efb2e23a$var$FeedbackCollectorButtonComponent = ({ flags: flags, source: source, appearance: appearance = 'default' })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    return isRbacEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))),
        appearance: appearance,
        onClick: ()=>setIsOpen(true)
    }, formatMessage($fa5a2619efb2e23a$export$396d041cc2808022.buttonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cNkvT.SpaceRolesFeedbackCollector), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        onSubmit: ()=>{
            flags.showSuccessFlag({
                title: formatMessage($fa5a2619efb2e23a$export$396d041cc2808022.flagTitle),
                isAutoDismiss: true
            });
        },
        source: source
    })) : null;
};
const $fa5a2619efb2e23a$export$b39479f42d974760 = (0, $7aRa9.withFlags)($fa5a2619efb2e23a$var$FeedbackCollectorButtonComponent);
module.exports["feedbackCollectorMessages"] = $fa5a2619efb2e23a$export$396d041cc2808022;
module.exports["FeedbackCollectorButton"] = $fa5a2619efb2e23a$export$b39479f42d974760;

});

parcelRegister("cNkvT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $biiXa = parcelRequire("biiXa");


var $bQm3c = parcelRequire("bQm3c");


var $iquRY = parcelRequire("iquRY");

const $fe7fcc34e2e5b785$var$i18n = (0, $aXWIB.defineMessages)({
    feedbackTitle: {
        id: "space-roles.feedback-collector.title",
        defaultMessage: "Give feedback"
    },
    feedbackTitleDetails: {
        id: "space-roles.feedback-collector.title-details",
        defaultMessage: "How satisfied or dissatisfied are you overall with your experience using roles to manage access in Confluence?"
    }
});
const $fe7fcc34e2e5b785$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $fe7fcc34e2e5b785$var$ENTRYPOINT_ID = 'ba8149f4-b7d4-4f55-9e72-683a444d3b27';
const $fe7fcc34e2e5b785$export$91e87cfcc7a6c95d = ({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, source: source })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const { displayName: displayName, userId: userId, cloudId: cloudId, edition: edition, environment: environment } = (0, $bQm3c.useSessionData)();
    const { spaceRoleMode: spaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const getFeedbackMetadata = ()=>{
        const feedbackMetadata = {
            userId: userId,
            cloudId: cloudId,
            edition: edition,
            environment: environment,
            source: source,
            spaceRoleMode: spaceRoleMode
        };
        return JSON.stringify(feedbackMetadata, null, 2);
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        onClose: onClose,
        onSubmit: onSubmit,
        entrypointId: $fe7fcc34e2e5b785$var$ENTRYPOINT_ID,
        locale: locale,
        name: displayName ?? '',
        atlassianAccountId: userId ?? undefined,
        showTypeField: false,
        feedbackTitle: formatMessage($fe7fcc34e2e5b785$var$i18n.feedbackTitle),
        feedbackTitleDetails: formatMessage($fe7fcc34e2e5b785$var$i18n.feedbackTitleDetails),
        additionalFields: [
            {
                id: $fe7fcc34e2e5b785$var$FEEDBACK_CONTEXT_ID,
                value: getFeedbackMetadata()
            }
        ]
    });
};
module.exports["SpaceRolesFeedbackCollector"] = $fe7fcc34e2e5b785$export$91e87cfcc7a6c95d;

});

parcelRegister("biiXa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c4c27c8e6323826$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackFlag", () => (parcelRequire("29DUH")).default);


var $hrGQb = parcelRequire("hrGQb");


var $29DUH = parcelRequire("29DUH");


var $3c4c27c8e6323826$export$2e2bcd8739ae039 = (0, $hrGQb.default);

});

parcelRegister("hrGQb", function(module, exports) {

var $iA9co = parcelRequire("iA9co");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $2KPHZ = parcelRequire("2KPHZ");


var $gpfq4 = parcelRequire("gpfq4");


var $8zkrp = parcelRequire("8zkrp");

const $6b78f3070669f383$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $6b78f3070669f383$var$singleLineTruncatedText = (text, length = $6b78f3070669f383$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $gpfq4.default)(singleLineText, length);
};
class $6b78f3070669f383$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $6b78f3070669f383$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $6b78f3070669f383$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $2KPHZ.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $2KPHZ.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $6b78f3070669f383$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zkrp.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            onCancel: this.props.onCancel,
            locale: this.props.locale,
            anonymousFeedback: (0, $dh538.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            dialogRef: this.props.dialogRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $2KPHZ.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $iA9co.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$6b78f3070669f383$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $6b78f3070669f383$export$2e2bcd8739ae039;

});

parcelRegister("2KPHZ", function(module, exports) {
const $defa15de0313af4d$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $defa15de0313af4d$export$f0f6fc934288a17c;

});

parcelRegister("gpfq4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bab40c5fbb12059f$export$2e2bcd8739ae039);
function $bab40c5fbb12059f$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("8zkrp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $7gpC4 = parcelRequire("7gpC4");


var $fzqvY = parcelRequire("fzqvY");

var $fVjjG = parcelRequire("fVjjG");

var $fb3kw = parcelRequire("fb3kw");

var $kuB2l = parcelRequire("kuB2l");

var $jVhgp = parcelRequire("jVhgp");


var $2Nwuj = parcelRequire("2Nwuj");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $dh538 = parcelRequire("dh538");


var $aoVih = parcelRequire("aoVih");


var $6T8v4 = parcelRequire("6T8v4");


var $9EtP6 = parcelRequire("9EtP6");


var $fSdY7 = parcelRequire("fSdY7");


var $giCws = parcelRequire("giCws");

const $27c5bd5943874410$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        }
    }, children);
};
const $27c5bd5943874410$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onCancel: onCancel, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, dialogRef: dialogRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $42omo.useState)(false);
    const [description, setDescription] = (0, $42omo.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $42omo.useState)(false);
    const [type, setType] = (0, $42omo.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isTypeSelected = ()=>type !== 'empty';
    const validateType = (value)=>showTypeField && (!value || value === 'empty') ? formatMessage((0, $fSdY7.messages).validationErrorTypeRequired) : undefined;
    const validateDescription = (value)=>{
        if (!showDefaultTextFields || hasDescriptionDefaultValue) return undefined;
        return !value || !value.trim() ? formatMessage((0, $fSdY7.messages).validationErrorDescriptionRequired) : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCancel = (...args)=>{
        onCancel?.(...args);
        // Forward every arg the click handler received so consumers retain the full
        // pre-change runtime contract (originating event + Atlaskit UI analytics event).
        onClose(...args);
    };
    const canShowTextField = isTypeSelected() || !showTypeField;
    const isDisabled = isSubmitting || disableSubmitButton;
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $fSdY7.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $fSdY7.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $fSdY7.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $fSdY7.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $fSdY7.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $fSdY7.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $fSdY7.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $fSdY7.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $fSdY7.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $fSdY7.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $42omo.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $fSdY7.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, $fSdY7.messages).canBeContactedLabelAppify;
    };
    const renderContactLabel = ()=>{
        if ((0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $fSdY7.messages).canBeContactedLabelWithoutLink;
        return (0, $fSdY7.messages).canBeContactedLabel;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }, formatMessage((0, $fSdY7.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVhgp.default), null));
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("p", null, formatMessage((0, $fSdY7.messages).feedbackIsAnonymous));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        ref: dialogRef,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true
    }, (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fSdY7.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, (0, $dh538.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "topic",
        id: "topic",
        label: selectLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultLabel),
        isRequired: true,
        validate: validateType
    }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
            ...restProps,
            value: selectOptions.find((opt)=>opt.value === type) ?? null,
            onChange: (option)=>{
                if (!option || option instanceof Array) return;
                setType(option.value);
                restProps.onChange?.(option.value);
            },
            menuPosition: "fixed",
            options: selectOptions,
            // @ts-ignore
            ref: focusRef,
            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
            inputId: id,
            isInvalid: !!error
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVjjG.ErrorMessage), null, error))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $fSdY7.messages).defaultCustomTextAreaLabel),
        isRequired: true,
        name: "description",
        id: "description",
        validate: validateDescription
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
            ...fieldProps,
            name: "foo",
            minimumRows: 6,
            placeholder: summaryPlaceholder || undefined,
            onChange: (e)=>{
                setDescription(e.target.value);
                fieldProps.onChange(e.target.value);
            },
            value: description
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVjjG.ErrorMessage), null, error))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kuB2l.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fSdY7.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "can-be-contacted"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...(0, $dh538.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                ...!(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks)
                    }
                }
            }),
            onChange: (event)=>setCanBeContacted(event.target.checked)
        }), canBeContactedLabel && canBeContactedLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27c5bd5943874410$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27c5bd5943874410$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank"
        }, formatMessage((0, $fSdY7.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "enroll-in-research-group"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: enrolInResearchLabel || formatMessage((0, $fSdY7.messages).enrolInResearchLabel),
            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
        }), enrolInResearchLabel && enrolInResearchLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27c5bd5943874410$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: 'anonymousFeedback'
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            title: formatMessage((0, $fSdY7.messages).feedbackIsAnonymousTitle),
            appearance: 'information'
        }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fSdY7.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "primary",
        type: "submit",
        isDisabled: isSubmitting || isDisabled,
        testId: "feedbackCollectorSubmitBtn"
    }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fSdY7.messages).submitButtonLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fSdY7.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, (0, $dh538.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "topic",
            id: "topic",
            label: selectLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultLabel),
            isRequired: true,
            validate: validateType
        }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
                ...restProps,
                value: selectOptions.find((opt)=>opt.value === type) ?? null,
                onChange: (option)=>{
                    if (!option || option instanceof Array) return;
                    setType(option.value);
                    restProps.onChange?.(option.value);
                },
                menuPosition: "fixed",
                options: selectOptions,
                // @ts-ignore
                ref: focusRef,
                placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                inputId: id,
                isInvalid: !!error
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVjjG.ErrorMessage), null, error))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $fSdY7.messages).defaultCustomTextAreaLabel),
            isRequired: true,
            name: "description",
            id: "description",
            validate: validateDescription
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
                ...fieldProps,
                name: "foo",
                minimumRows: 6,
                placeholder: summaryPlaceholder || undefined,
                onChange: (e)=>{
                    setDescription(e.target.value);
                    fieldProps.onChange(e.target.value);
                },
                value: description
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVjjG.ErrorMessage), null, error))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kuB2l.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fSdY7.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "can-be-contacted"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...(0, $dh538.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                    ...!(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                        values: {
                            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                                    href: "https://www.atlassian.com/legal/privacy-policy",
                                    target: "_blank"
                                }, chunks)
                        }
                    }
                }),
                onChange: (event)=>setCanBeContacted(event.target.checked)
            }), canBeContactedLabel && canBeContactedLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27c5bd5943874410$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27c5bd5943874410$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: "https://www.atlassian.com/legal/privacy-policy",
                target: "_blank"
            }, formatMessage((0, $fSdY7.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "enroll-in-research-group"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: enrolInResearchLabel || formatMessage((0, $fSdY7.messages).enrolInResearchLabel),
                onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
            }), enrolInResearchLabel && enrolInResearchLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27c5bd5943874410$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: 'anonymousFeedback'
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
                title: formatMessage((0, $fSdY7.messages).feedbackIsAnonymousTitle),
                appearance: 'information'
            }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            onClick: handleCancel
        }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fSdY7.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "primary",
            type: "submit",
            isDisabled: isSubmitting || isDisabled,
            testId: "feedbackCollectorSubmitBtn"
        }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fSdY7.messages).submitButtonLabel))))));
};
const $27c5bd5943874410$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $giCws.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27c5bd5943874410$var$FeedbackForm, props));
};
var $27c5bd5943874410$export$2e2bcd8739ae039 = $27c5bd5943874410$var$FeedbackFormWithIntl;
module.exports["default"] = $27c5bd5943874410$export$2e2bcd8739ae039;

});

parcelRegister("9EtP6", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$baseStylesT26Shape = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pv187o _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18187o",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(63);
    const ourRef = (0, $42omo.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $82c18ff824db72a8$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $42omo.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$82c18ff824db72a8$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$82c18ff824db72a8$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $82c18ff824db72a8$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = isInvalid ? isInvalid : undefined;
    const t17 = isCompact ? isCompact : undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    let t20;
    if ($[36] !== appearance || $[37] !== isMonospaced || $[38] !== resize) {
        t20 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)("platform-dst-shape-theme-default") && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? "monospace" : "default"],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]);
        $[36] = appearance;
        $[37] = isMonospaced;
        $[38] = resize;
        $[39] = t20;
    } else t20 = $[39];
    const t21 = $82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t22;
    if ($[40] !== t21) {
        t22 = (0, $7sObp.default)(t21, "px");
        $[40] = t21;
        $[41] = t22;
    } else t22 = $[41];
    const t23 = $82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2;
    let t24;
    if ($[42] !== t23) {
        t24 = (0, $7sObp.default)(t23, "px");
        $[42] = t23;
        $[43] = t24;
    } else t24 = $[43];
    let t25;
    if ($[44] !== maxHeight || $[45] !== style || $[46] !== t22 || $[47] !== t24) {
        t25 = {
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t22,
            "--_eorxnz": t24
        };
        $[44] = maxHeight;
        $[45] = style;
        $[46] = t22;
        $[47] = t24;
        $[48] = t25;
    } else t25 = $[48];
    let t26;
    if ($[49] !== controlProps || $[50] !== getTextAreaRef || $[51] !== handleOnChange || $[52] !== isDisabled || $[53] !== isReadOnly || $[54] !== isRequired || $[55] !== minimumRows || $[56] !== onBlurWithAnalytics || $[57] !== onFocusWithAnalytics || $[58] !== rest || $[59] !== t20 || $[60] !== t25 || $[61] !== value) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t20,
            style: t25
        });
        $[49] = controlProps;
        $[50] = getTextAreaRef;
        $[51] = handleOnChange;
        $[52] = isDisabled;
        $[53] = isReadOnly;
        $[54] = isRequired;
        $[55] = minimumRows;
        $[56] = onBlurWithAnalytics;
        $[57] = onFocusWithAnalytics;
        $[58] = rest;
        $[59] = t20;
        $[60] = t25;
        $[61] = value;
        $[62] = t26;
    } else t26 = $[62];
    return t26;
} : (props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $82c18ff824db72a8$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function TextArea(props, ref) {
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82c18ff824db72a8$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function TextArea(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("fSdY7", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $a10dc5cbcf39e7b4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabel: {
        id: "feedback-collector.can-be-contacted.label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppify: {
        id: "feedback-collector.can-be-contacted.label-appify",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    },
    optInOptionsLegend: {
        id: "feedback-collector.opt-in.options.legend",
        defaultMessage: "Atlassian opt-in options"
    }
});
module.exports["messages"] = $a10dc5cbcf39e7b4$export$defe85febe8b728c;

});

parcelRegister("giCws", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1tbUg = parcelRequire("1tbUg");

const $9a574d55f4cfa28d$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $1tbUg.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};
module.exports["IntlProviderWithResolvedMessages"] = $9a574d55f4cfa28d$export$f793de1293176fe6;

});

parcelRegister("1tbUg", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ const $c02f8c9a6f146725$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};
module.exports["getMessagesForLocale"] = $c02f8c9a6f146725$export$d0a3169680473b6c;

});

parcelRegister("29DUH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $aD1SW = parcelRequire("aD1SW");


var $3sFtD = parcelRequire("3sFtD");


var $dh538 = parcelRequire("dh538");


var $fSdY7 = parcelRequire("fSdY7");


var $giCws = parcelRequire("giCws");

const $36b921ab0de27528$var$FeedbackFlag = ({ description: description, title: title })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aD1SW.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #6A9A23)",
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $fSdY7.messages).feedbackSuccessFlagDescriptionAppify : (0, $fSdY7.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, $fSdY7.messages).feedbackSuccessFlagTitle)
    });
};
const $36b921ab0de27528$var$FeedbackFlagWithIntl = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $giCws.IntlProviderWithResolvedMessages), {
        locale: props.locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36b921ab0de27528$var$FeedbackFlag, props));
var $36b921ab0de27528$export$2e2bcd8739ae039 = $36b921ab0de27528$var$FeedbackFlagWithIntl;
module.exports["default"] = $36b921ab0de27528$export$2e2bcd8739ae039;

});

parcelRegister("6sX6R", function(module, exports) {
/**
 * @generated SignedSource<<5781cbccd1c8eecb1569c5f9b0c8dc09>>
 * @relayHash 2bb1694d71660b70c596688bc417d3f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d3c1e078b8f837f9aa0d463343faa2b58625974fee0bd1da388729d4349cb736
const $3b5c116e02c56723$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceUserClassConnection",
            "kind": "LinkedField",
            "name": "confluence_userClasses",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceUserClass",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "principalId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAccessClassInclusionClassesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAccessClassInclusionClassesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2bb1694d71660b70c596688bc417d3f0",
            "id": "d3c1e078b8f837f9aa0d463343faa2b58625974fee0bd1da388729d4349cb736",
            "metadata": {},
            "name": "useAccessClassInclusionClassesQuery",
            "operationKind": "query",
            "text": "query useAccessClassInclusionClassesQuery($cloudId:ID!){confluence_userClasses(cloudId:$cloudId){nodes{principalId,displayName}}}"
        }
    };
}();
$3b5c116e02c56723$var$node.hash = "b9df1c827cf7bec061b12334b26b99d9";
var $3b5c116e02c56723$export$2e2bcd8739ae039 = $3b5c116e02c56723$var$node;



var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $fed355c8c6dd10eb$var$useAccessClassInclusionClassesQuery = (0, $3b5c116e02c56723$export$2e2bcd8739ae039);
const $fed355c8c6dd10eb$var$toLowerWithoutSpaces = (str)=>str?.toLowerCase().replace(/ /g, '');


const $fed355c8c6dd10eb$export$3084d470555a4d72 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($fed355c8c6dd10eb$var$useAccessClassInclusionClassesQuery, {
        variables: {
            cloudId: cloudId
        },
        onError: (e)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(e);
        },
        __callerPackage__: "@confluence/space-roles"
    });
    const allConfluenceUsers = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-licensed-users');
    const allConfluenceAdmins = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-product-admins');
    if (loading || error) return [];
    return [
        {
            ...allConfluenceUsers?.principalId && allConfluenceUsers?.displayName && {
                [$fed355c8c6dd10eb$var$toLowerWithoutSpaces(allConfluenceUsers.displayName)]: {
                    id: allConfluenceUsers.principalId,
                    name: allConfluenceUsers.displayName,
                    type: 'custom',
                    avatarUrl: (parcelRequire("56zia"))
                }
            },
            ...allConfluenceAdmins?.principalId && allConfluenceAdmins?.displayName && {
                [$fed355c8c6dd10eb$var$toLowerWithoutSpaces(allConfluenceAdmins.displayName)]: {
                    id: allConfluenceAdmins.principalId,
                    name: allConfluenceAdmins.displayName,
                    type: 'custom',
                    avatarUrl: (parcelRequire("56zia"))
                }
            }
        }
    ];
};
module.exports["useAccessClassInclusion"] = $fed355c8c6dd10eb$export$3084d470555a4d72;

});

parcelRegister("56zia", function(module, exports) {
module.exports = new URL("atlassian-icon.1175e11b.svg", import.meta.url).toString();

});

parcelRegister("bYvQP", function(module, exports) {
/**
 * @generated SignedSource<<62b0bbc683f6d381ee0b038d7be56a15>>
 * @relayHash 99c9b559039c583547ef40e7402826a6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cea427276cf747ecdd5141ecc68b95890eaafd7ffc2a1a5f883ee10092d34ab1
const $4214be3f4cede243$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceUserClassConnection",
            "kind": "LinkedField",
            "name": "confluence_userClasses",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceUserClass",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "principalId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAccessClassTransformerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAccessClassTransformerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "99c9b559039c583547ef40e7402826a6",
            "id": "cea427276cf747ecdd5141ecc68b95890eaafd7ffc2a1a5f883ee10092d34ab1",
            "metadata": {},
            "name": "useAccessClassTransformerQuery",
            "operationKind": "query",
            "text": "query useAccessClassTransformerQuery($cloudId:ID!){confluence_userClasses(cloudId:$cloudId){nodes{principalId,displayName}}}"
        }
    };
}();
$4214be3f4cede243$var$node.hash = "a336baeeba530d71a57fedc023a9b7eb";
var $4214be3f4cede243$export$2e2bcd8739ae039 = $4214be3f4cede243$var$node;



var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $eef51719bd266cea$var$useAccessClassTransformerQuery = (0, $4214be3f4cede243$export$2e2bcd8739ae039);
const $eef51719bd266cea$var$toLowerWithoutSpaces = (str)=>str?.toLowerCase().replace(/ /g, '');

const $eef51719bd266cea$export$8981ed613e05500d = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($eef51719bd266cea$var$useAccessClassTransformerQuery, {
        variables: {
            cloudId: cloudId
        },
        onError: (e)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(e);
        },
        __callerPackage__: "@confluence/space-roles"
    });
    const [searchQuery, setSearchQuery] = (0, $42omo.useState)('');
    const allConfluenceUsers = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-licensed-users');
    const allConfluenceAdmins = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-product-admins');
    const transformOptions = async (options)=>{
        const cleanedSearchTerm = $eef51719bd266cea$var$toLowerWithoutSpaces(searchQuery);
        const customInclusionList = [];
        [
            allConfluenceUsers,
            allConfluenceAdmins
        ].forEach((userClass)=>{
            if (userClass && $eef51719bd266cea$var$toLowerWithoutSpaces(userClass.displayName || '').includes(cleanedSearchTerm)) customInclusionList.push({
                id: userClass.principalId,
                name: userClass.displayName,
                type: 'custom',
                avatarUrl: (parcelRequire("56zia"))
            });
        });
        return [
            ...options,
            ...customInclusionList
        ];
    };
    return {
        setSearchQuery: setSearchQuery,
        transformOptions: transformOptions
    };
};
module.exports["useAccessClassTransformer"] = $eef51719bd266cea$export$8981ed613e05500d;

});

parcelRegister("ku6MO", function(module, exports) {
/* RoleSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $6T8v4 = parcelRequire("6T8v4");


var $3hOY6 = parcelRequire("3hOY6");


var $gdv5Z = parcelRequire("gdv5Z");


var $iXCQx = parcelRequire("iXCQx");


var $inPa6 = parcelRequire("inPa6");


var $g5lKx = parcelRequire("g5lKx");


var $aXWIB = parcelRequire("aXWIB");

const $d5c5d64568180920$var$i18n = (0, $aXWIB.defineMessages)({
    noRolesAvailable: {
        id: "space-roles.role-selector.no-roles-available",
        defaultMessage: "No roles are currently available"
    }
});
const $d5c5d64568180920$var$styles = {
    menuItem: "_zulp1b66 _1e0c1txw _2lx21bp4",
    menuContainer: "_1e0c1txw _2lx21bp4 _c71lnklw",
    menuScrollable: "_16jlkb7n _1o9zkb7n _i0dlf1ug _18m91wug _1tkeidpf",
    optionWithSuffixOuter: "_1e0c1txw _2lx2vrvc _1bah1y6m _4cvr1h6o _1ul9idpf _1bsb1osq",
    optionWithSuffixCluster: "_zulpu2gc _1e0c116y _2lx2vrvc _4cvr1h6o _p12f1osq _1ul9idpf",
    optionLabelTruncate: "_1reo15vq _18m915vq _16jlidpf _1o9zkb7n _i0dl1wug _1ul9idpf _1bto1l2s _o5721q9c",
    optionSuffixContainer: "_1o9zidpf"
};
const $d5c5d64568180920$export$7b32174eb7b60a13 = ({ initialRoleId: initialRoleId, value: value, isLoading: isLoading, isDisabled: isDisabled = false, onChange: onChange, placeholder: placeholder, spaceRoleOptions: spaceRoleOptions, onMenuClose: onMenuClose, onMenuOpen: onMenuOpen, menuPlacement: menuPlacement = 'auto', appearance: appearance = 'subtle', noOptionsMessage: noOptionsMessage, spacing: spacing = 'default', menuPortalTarget: menuPortalTarget, maxMenuHeight: maxMenuHeight = 320, renderOptionSuffix: renderOptionSuffix, menuFooter: menuFooter, inputId: inputId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [internalVal, setInternalVal] = (0, $42omo.useState)((value === undefined ? initialRoleId : value) || null);
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const resolvedNoOptionsMessage = noOptionsMessage ?? formatMessage($d5c5d64568180920$var$i18n.noRolesAvailable);
    const closeMenu = (0, $42omo.useCallback)(()=>{
        setIsMenuOpen(false);
    }, []); // The component is controlled if value is not `undefined`. `initialRole` will ignored in controlled mode.
    const isControlledComponent = value !== undefined;
    const options = (0, $42omo.useMemo)(()=>spaceRoleOptions.map((role)=>({
                id: role?.id ?? '',
                label: role?.name ?? '',
                value: role?.id ?? '',
                description: role?.description ?? '',
                ariaLabel: `${role?.name} - ${role?.description ?? ''}`,
                optionColor: role?.optionColor
            })), [
        spaceRoleOptions
    ]);
    const getOptionFromValue = (0, $42omo.useCallback)((val)=>{
        if (!val) return null;
        return typeof val === 'string' ? options.find((option)=>option.value === val) || null : {
            id: val.value.toString(),
            label: val.label,
            value: val.value.toString(),
            description: '',
            ariaLabel: `${val.label} - ${val.description ?? ''}`
        };
    }, [
        options
    ]);
    const CustomSingleValue = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
        const suffix = renderOptionSuffix?.(props.data.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).SingleValue, {
            ...props,
            "aria-label": props.data.ariaLabel
        }, suffix ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d5c5d64568180920$var$styles.optionWithSuffixOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d5c5d64568180920$var$styles.optionWithSuffixCluster
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d5c5d64568180920$var$styles.optionLabelTruncate
        }, props.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d5c5d64568180920$var$styles.optionSuffixContainer
        }, suffix))) : props.data.label);
    });
    const CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
        const suffix = renderOptionSuffix?.(props.data.id);
        const optionColor = props.data.optionColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, {
            ...props,
            "aria-label": props.data.ariaLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d5c5d64568180920$var$styles.menuItem
        }, suffix ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d5c5d64568180920$var$styles.optionWithSuffixOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d5c5d64568180920$var$styles.optionWithSuffixCluster
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d5c5d64568180920$var$styles.optionLabelTruncate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: optionColor
        }, props.data.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d5c5d64568180920$var$styles.optionSuffixContainer
        }, suffix))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: optionColor
        }, props.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: optionColor ?? 'color.text.subtlest'
        }, props.data.description)));
    }); // Resolve menuFooter - call it if it's a function
    const resolvedMenuFooter = (0, $42omo.useMemo)(()=>{
        if (!menuFooter) return null;
        return typeof menuFooter === 'function' ? menuFooter(closeMenu) : menuFooter;
    }, [
        menuFooter,
        closeMenu
    ]); // Custom Menu component with optional footer
    const CustomMenu = (0, $42omo.useMemo)(()=>{
        if (!resolvedMenuFooter) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Menu, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $d5c5d64568180920$var$styles.menuContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $d5c5d64568180920$var$styles.menuScrollable
            }, props.children), resolvedMenuFooter)));
    }, [
        resolvedMenuFooter
    ]);
    const handleChange = (newSelection)=>{
        const newSelectionType = spaceRoleOptions.find((role)=>role?.id === newSelection?.value)?.roleType;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'change',
                source: 'spaceRoles-roleSelector',
                attributes: {
                    newSelection: newSelection?.id,
                    newSelectionType: newSelectionType
                }
            }
        }).fire();
        setInternalVal(newSelection?.value || null); // Guard the unsafe `as SpaceRole` cast: if the option list and the new selection ever
        // diverge (e.g. a stale option fires after the list was filtered, or a disabled SYSTEM
        // role is no longer in the list), `.find(...)` returns undefined, and downstream
        // consumers that do `newRole.id` would NPE. Mirrors the guard pattern used by the
        // site-permissions local copy of this component.
        const matchedRole = spaceRoleOptions.find((role)=>role?.id === newSelection?.value);
        if (matchedRole) onChange?.(matchedRole);
    };
    const handleMenuOpen = (0, $42omo.useCallback)((currentRoleSelection)=>{
        onMenuOpen?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'open',
                source: 'spaceRoles-roleSelector',
                attributes: {
                    currentRoleSelection: currentRoleSelection?.id
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onMenuOpen
    ]);
    const SELECT_STYLE_PROPS = {
        isSearchable: false,
        styles: {
            menu: (base)=>({
                    ...base,
                    width: '320px',
                    padding: 0,
                    margin: 0,
                    zIndex: (0, $g5lKx.layers).modal() + 1 // Higher than modal to appear above modal content
                }),
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $g5lKx.layers).modal() + 1 // Higher than modal to appear above modal content
                })
        }
    };
    const selectValue = isControlledComponent ? getOptionFromValue(value) : getOptionFromValue(internalVal);
    const handleMenuOpenInternal = (0, $42omo.useCallback)(()=>{
        setIsMenuOpen(true);
        handleMenuOpen(getOptionFromValue(isControlledComponent ? value : internalVal));
    }, [
        getOptionFromValue,
        handleMenuOpen,
        isControlledComponent,
        value,
        internalVal
    ]);
    const handleMenuCloseInternal = (0, $42omo.useCallback)(()=>{
        setIsMenuOpen(false);
        onMenuClose?.();
    }, [
        onMenuClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        "data-testid": "space-roles-table-role-selector",
        inputId: inputId,
        placeholder: isLoading ? '' : placeholder,
        options: options,
        appearance: appearance,
        isLoading: isLoading,
        isDisabled: isDisabled,
        onChange: handleChange,
        onMenuOpen: handleMenuOpenInternal,
        onMenuClose: handleMenuCloseInternal,
        menuIsOpen: isMenuOpen,
        components: {
            SingleValue: CustomSingleValue,
            Option: CustomOption,
            ...CustomMenu ? {
                Menu: CustomMenu
            } : {}
        },
        menuPosition: "fixed",
        menuPlacement: menuPlacement,
        menuPortalTarget: menuPortalTarget,
        maxMenuHeight: maxMenuHeight,
        scrollBehavior: "outside",
        defaultValue: getOptionFromValue(initialRoleId),
        value: selectValue,
        noOptionsMessage: ()=>resolvedNoOptionsMessage,
        spacing: spacing,
        ...SELECT_STYLE_PROPS
    });
};
module.exports["RoleSelector"] = $d5c5d64568180920$export$7b32174eb7b60a13;

});

parcelRegister("3EH2D", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $6573ae76580eb783$export$fa4e386dd79a7949 = /*#__PURE__*/ function(ConfluenceRoleAssignabilityCode) {
    ConfluenceRoleAssignabilityCode["ASSIGNABLE"] = "ASSIGNABLE";
    ConfluenceRoleAssignabilityCode["DEFAULT_ROLE_ASSIGNMENT_NOT_SUPPORTED"] = "DEFAULT_ROLE_ASSIGNMENT_NOT_SUPPORTED";
    ConfluenceRoleAssignabilityCode["ESCALATION_NOT_ASSIGNABLE"] = "ESCALATION_NOT_ASSIGNABLE";
    ConfluenceRoleAssignabilityCode["GUEST_EXISTING_SPACE_ACCESS"] = "GUEST_EXISTING_SPACE_ACCESS";
    ConfluenceRoleAssignabilityCode["GUEST_SYSTEM_SPACE_ACCESS"] = "GUEST_SYSTEM_SPACE_ACCESS";
    ConfluenceRoleAssignabilityCode["NOT_ASSIGNABLE"] = "NOT_ASSIGNABLE";
    ConfluenceRoleAssignabilityCode["NO_MANAGE_GUEST_USERS_PERM_NOT_ASSIGNABLE"] = "NO_MANAGE_GUEST_USERS_PERM_NOT_ASSIGNABLE";
    ConfluenceRoleAssignabilityCode["NO_MANAGE_NONLICENSED_USERS_PERM_NOT_ASSIGNABLE"] = "NO_MANAGE_NONLICENSED_USERS_PERM_NOT_ASSIGNABLE";
    ConfluenceRoleAssignabilityCode["PRINCIPAL_INVALID_ROLE"] = "PRINCIPAL_INVALID_ROLE";
    return ConfluenceRoleAssignabilityCode;
}({});
var $6573ae76580eb783$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["APP"] = "APP";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});
var $6573ae76580eb783$export$69bdd9d16ab8ed0f = /*#__PURE__*/ function(SpaceRoleType) {
    SpaceRoleType["CUSTOM"] = "CUSTOM";
    SpaceRoleType["SYSTEM"] = "SYSTEM";
    return SpaceRoleType;
}({})// Note: Original file contained additional custom exports that need manual review:
// RoleAssignmentPrincipalInput
// Please verify these are handled correctly in your codebase.
;
module.exports["ConfluenceRoleAssignabilityCode"] = $6573ae76580eb783$export$fa4e386dd79a7949;
module.exports["SpaceRoleType"] = $6573ae76580eb783$export$69bdd9d16ab8ed0f;

});

parcelRegister("9rnOu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $kuBjO = parcelRequire("kuBjO");


var $75A8F = parcelRequire("75A8F");





var $aXWIB = parcelRequire("aXWIB");


var $jh864 = parcelRequire("jh864");


var $iKHTh = parcelRequire("iKHTh");


var $6f0Oj = parcelRequire("6f0Oj");


var $dcJ7R = parcelRequire("dcJ7R");


var $ecnYn = parcelRequire("ecnYn");


var $aRCWA = parcelRequire("aRCWA");


var $5BMKF = parcelRequire("5BMKF");

const $d78f8d894583618b$var$navContainerStyles = (0, $ecnYn.xcss)({
    width: '202px'
});
const $d78f8d894583618b$export$fa002117b34ac07e = ({ systemRoles: systemRoles, customRoles: customRoles, activeRoleId: activeRoleId, setActiveRoleId: setActiveRoleId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d78f8d894583618b$var$navContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKHTh.MenuList), null, [
        ...systemRoles,
        ...customRoles || []
    ].map((role)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jh864.ButtonMenuItem), {
            key: role.id,
            isSelected: role.id === activeRoleId,
            onClick: ()=>setActiveRoleId(role.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, role.name, role.isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRCWA))), {
            label: formatMessage((0, $5BMKF.viewRolePermissionsMessages).roleDisabledLabel),
            color: "var(--ds-icon-danger, #C9372C)",
            size: "small",
            spacing: "none"
        }))))));
};


const $b296da749f5cb895$export$5cfd4e5ecf699324 = ({ systemRoles: systemRoles, customRoles: customRoles, allPermissions: allPermissions, onClose: onClose, initialActiveRoleId: initialActiveRoleId, analyticsSource: analyticsSource, onClickEdit: onClickEdit })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [activeRoleId, setActiveRoleId] = (0, $42omo.useState)(initialActiveRoleId || systemRoles[0]?.id || '');
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewRolePermissionsModal',
                attributes: {
                    source: analyticsSource
                }
            }
        }).fire();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75A8F.ViewRolePermissionsWrapper), {
        systemRoles: systemRoles,
        customRoles: customRoles,
        allPermissions: allPermissions,
        activeRoleId: activeRoleId,
        setActiveRoleId: setActiveRoleId,
        analyticsSource: analyticsSource,
        onClose: onClose,
        onClickEdit: onClickEdit,
        extraPermissionContent: (0, $kuBjO.buildPermissionDescriptionTooltips)(allPermissions ?? [])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d78f8d894583618b$export$fa002117b34ac07e), {
        systemRoles: systemRoles,
        customRoles: customRoles || [],
        activeRoleId: activeRoleId,
        setActiveRoleId: setActiveRoleId
    }));
};
module.exports["ViewRolePermissionModal"] = $b296da749f5cb895$export$5cfd4e5ecf699324;

});

parcelRegister("kuBjO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4eaa9 = parcelRequire("4eaa9");

const $d0043c7e7d457c98$export$957155b70cf06c14 = (allPermissions)=>Object.fromEntries(allPermissions.filter((p)=>p.description?.trim()).map((p)=>[
            p.key,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4eaa9.PermissionDescriptionTooltip), {
                key: p.key,
                description: p.description
            })
        ]));
module.exports["buildPermissionDescriptionTooltips"] = $d0043c7e7d457c98$export$957155b70cf06c14;

});

parcelRegister("4eaa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eXmBZ = parcelRequire("eXmBZ");


var $3gadb = parcelRequire("3gadb");

const $d78324f06e782280$var$hasNonEmptyDescription = (value)=>{
    if (value == null || typeof value !== 'string') return false;
    // Treat whitespace-only (including \n, \t, etc.) as empty
    return !/^\s*$/.test(value);
};
const $d78324f06e782280$export$6b4b0e8b29cb3d9 = ({ description: description })=>{
    if (!$d78324f06e782280$var$hasNonEmptyDescription(description)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "right",
        content: description?.trim() ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        label: "",
        size: "small"
    }));
};
module.exports["PermissionDescriptionTooltip"] = $d78324f06e782280$export$6b4b0e8b29cb3d9;

});

parcelRegister("75A8F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $1qfLF = parcelRequire("1qfLF");


var $cO1el = parcelRequire("cO1el");


var $3sFtD = parcelRequire("3sFtD");


var $7yDmn = parcelRequire("7yDmn");


var $1Zr9M = parcelRequire("1Zr9M");


var $aRCWA = parcelRequire("aRCWA");


var $5nBzc = parcelRequire("5nBzc");


var $5BMKF = parcelRequire("5BMKF");


var $1DHa6 = parcelRequire("1DHa6");


var $8o1lj = parcelRequire("8o1lj");


var $9ot3w = parcelRequire("9ot3w");


var $6xdDU = parcelRequire("6xdDU");


var $8TTLA = parcelRequire("8TTLA");


var $6f0Oj = parcelRequire("6f0Oj");


var $cwkWT = parcelRequire("cwkWT");


var $dcJ7R = parcelRequire("dcJ7R");


var $ecnYn = parcelRequire("ecnYn");


var $1GzhS = parcelRequire("1GzhS");


var $5dK2X = parcelRequire("5dK2X");


var $bUlM5 = parcelRequire("bUlM5");


var $bWLcG = parcelRequire("bWLcG");


var $6mKj3 = parcelRequire("6mKj3");


var $lsxnT = parcelRequire("lsxnT");


var $1ytiN = parcelRequire("1ytiN");


var $1NBp8 = parcelRequire("1NBp8");


var $c6lYi = parcelRequire("c6lYi");


var $8Eh39 = parcelRequire("8Eh39");

const $1e059f1575c38760$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "space-roles.view-role-permissions-modal.title",
        defaultMessage: "Role permissions"
    },
    doneButtonText: {
        id: "space-roles.view-role-permissions-modal.done-button-text",
        defaultMessage: "Done"
    },
    permissionEnabled: {
        id: "space-roles.view-role-permissions-modal.permission-enabled",
        defaultMessage: "Enabled"
    },
    permissionDisabled: {
        id: "space-roles.view-role-permissions-modal.permission-disabled",
        defaultMessage: "Disabled"
    },
    editButtonLabel: {
        id: "space-roles.view-role-permissions-modal.edit-button-label",
        defaultMessage: "Edit role permissions"
    }
});
// -- Styles --
const $1e059f1575c38760$var$detailViewStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.600'
});
const $1e059f1575c38760$var$rolePermissionDetailContainerStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.400',
    rowGap: 'space.400',
    columnGap: 'space.1000',
    [(0, $bWLcG.media).above.sm]: {
        gridTemplateColumns: 'repeat(2, 1fr)'
    }
});
const $1e059f1575c38760$var$contentStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200'
});
const $1e059f1575c38760$var$checkboxGroupStyles = (0, $ecnYn.xcss)({
    gap: 'space.100',
    justifyContent: 'start'
});
const $1e059f1575c38760$var$modalHeaderStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.150',
    justifyContent: 'flex-end',
    width: '100%'
});
const $1e059f1575c38760$var$headingInlineStyle = (0, $ecnYn.xcss)({
    marginBlock: 'space.negative.150'
});
const $1e059f1575c38760$var$modalHeaderSpacing = (0, $ecnYn.xcss)({
    height: '100%',
    alignItems: 'center',
    width: '100%'
});
const $1e059f1575c38760$export$8008a8193747f6f5 = ({ systemRoles: systemRoles, customRoles: customRoles, allPermissions: allPermissions, onClose: onClose, onClickEdit: onClickEdit, activeRoleId: activeRoleId, analyticsSource: analyticsSource, title: title, children: children, footer: footer, extraPermissionContent: extraPermissionContent })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const defaultOnClickEdit = (0, $42omo.useCallback)(()=>{
        onClose();
        window.location.href = (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'roles'
        });
    }, [
        onClose
    ]);
    const handleClickEdit = onClickEdit || defaultOnClickEdit;
    const activeRole = [
        ...systemRoles,
        ...customRoles || []
    ].find((role)=>role.id === activeRoleId);
    // Right side detail view
    // Build a dictionary for the active role to look up if a permission is enabled or not
    const activeRolePermissionDict = (0, $8Eh39.buildPermissionDictionary)(activeRole?.permissions || []);
    // Get all permissions and group them by group name
    const sortedPermissionGroupDict = (0, $8Eh39.getNormalizedPermissionItems)(undefined, allPermissions || []);
    const permissionListComps = Object.values(sortedPermissionGroupDict).map((group)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.150",
            key: group.group.name,
            xcss: $1e059f1575c38760$var$checkboxGroupStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xsmall"
        }, group.group.name), group.group.checkboxes.map((item)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.100",
                alignBlock: "center",
                key: item.id
            }, activeRolePermissionDict[item.id] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                label: formatMessage($1e059f1575c38760$var$i18n.permissionEnabled),
                color: "var(--ds-icon-success, #6A9A23)",
                spacing: "none"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: formatMessage($1e059f1575c38760$var$i18n.permissionDisabled),
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, item.displayName), extraPermissionContent?.[item.id] && extraPermissionContent[item.id]);
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: 1000,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $1e059f1575c38760$var$modalHeaderSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium"
    }, title || formatMessage($1e059f1575c38760$var$i18n.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $1e059f1575c38760$var$modalHeaderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c6lYi.FeedbackCollectorButton), {
        source: analyticsSource,
        appearance: "subtle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: onClose
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $1e059f1575c38760$var$contentStyles
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1e059f1575c38760$var$detailViewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium"
    }, activeRole?.name || ''), activeRole?.isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "removed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRCWA))), {
        label: "",
        color: "currentColor"
    }), formatMessage((0, $5BMKF.viewRolePermissionsMessages).roleDisabledLabel))), (onClickEdit || isSiteAdmin) && activeRole && customRoles?.some((role)=>role.id === activeRole.id) && (0, $6mKj3.expVal)('custom-roles-ux-improvements', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1e059f1575c38760$var$headingInlineStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
        label: formatMessage($1e059f1575c38760$var$i18n.editButtonLabel),
        onClick: ()=>handleClickEdit(activeRole.id),
        testId: "edit-role-permissions-button"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, activeRole?.description || '')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
        xcss: $1e059f1575c38760$var$rolePermissionDetailContainerStyle
    }, permissionListComps)))), footer || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onClose
    }, formatMessage($1e059f1575c38760$var$i18n.doneButtonText))))));
};
module.exports["ViewRolePermissionsWrapper"] = $1e059f1575c38760$export$8008a8193747f6f5;

});

parcelRegister("8Eh39", function(module, exports) {
const $00348e3352156ed0$export$dbc5bcb243a11b25 = (permissions, allSpacePermissions, assignablePermissions)=>{
    // Permission groups are sorted here, then checkboxes of permissions are sorted below
    const sortedSpacePermissions = [
        ...allSpacePermissions
    ].sort((a, b)=>a.groupPriority - b.groupPriority);
    return Object.values(sortedSpacePermissions).reduce((acc, permission)=>{
        const isChecked = Boolean(permissions?.includes(permission.key));
        const checkbox = {
            id: permission.key,
            displayName: permission.actionName,
            priority: permission.priority,
            description: permission.description || '',
            isAssignable: !!assignablePermissions ? assignablePermissions.includes(permission.key) : true,
            isChecked: isChecked,
            isDisabled: false
        };
        const group = {
            groupName: permission.groupName,
            groupPriority: permission.groupPriority
        };
        if (!acc[group.groupName]) acc[group.groupName] = {
            group: {
                name: group.groupName,
                priority: group.groupPriority,
                checkboxes: []
            }
        };
        acc[group.groupName].group.checkboxes.push(checkbox);
        acc[group.groupName].group.checkboxes.sort((a, b)=>a.priority - b.priority);
        return acc;
    }, {});
};
const $00348e3352156ed0$export$eda4a295c95572c4 = (allowedPermissions)=>{
    return allowedPermissions.reduce((acc, permission)=>{
        acc[permission] = true;
        return acc;
    }, {});
};
module.exports["getNormalizedPermissionItems"] = $00348e3352156ed0$export$dbc5bcb243a11b25;
module.exports["buildPermissionDictionary"] = $00348e3352156ed0$export$eda4a295c95572c4;

});

parcelRegister("jh864", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8njHX = parcelRequire("8njHX");


var $jvL0g = parcelRequire("jvL0g");

const $bf400a28e0f66299$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $frIzR.c)(24);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const t1 = isDisabled ? undefined : actions;
    const t2 = isDisabled ? undefined : actionsOnHover;
    let t3;
    if ($[0] !== ariaControls || $[1] !== ariaExpanded || $[2] !== ariaHasPopup || $[3] !== children || $[4] !== description || $[5] !== dropIndicator || $[6] !== elemAfter || $[7] !== elemBefore || $[8] !== forwardedRef || $[9] !== hasDragIndicator || $[10] !== interactionName || $[11] !== isContentTooltipDisabled || $[12] !== isDisabled || $[13] !== isDragging || $[14] !== isSelected || $[15] !== onClick || $[16] !== t1 || $[17] !== t2 || $[18] !== testId || $[19] !== visualContentRef) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            actions: t1,
            actionsOnHover: t2,
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isSelected: isSelected,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[0] = ariaControls;
        $[1] = ariaExpanded;
        $[2] = ariaHasPopup;
        $[3] = children;
        $[4] = description;
        $[5] = dropIndicator;
        $[6] = elemAfter;
        $[7] = elemBefore;
        $[8] = forwardedRef;
        $[9] = hasDragIndicator;
        $[10] = interactionName;
        $[11] = isContentTooltipDisabled;
        $[12] = isDisabled;
        $[13] = isDragging;
        $[14] = isSelected;
        $[15] = onClick;
        $[16] = t1;
        $[17] = t2;
        $[18] = testId;
        $[19] = visualContentRef;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] !== listItemRef || $[22] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jvL0g.MenuListItem), {
            ref: listItemRef
        }, t3);
        $[21] = listItemRef;
        $[22] = t3;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jvL0g.MenuListItem), {
        ref: listItemRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8njHX.MenuItemBase), {
        testId: testId,
        description: description,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        isDisabled: isDisabled,
        /**
     * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
     * so they aren't rendered in the disabled state.
     */ actions: isDisabled ? undefined : actions,
        actionsOnHover: isDisabled ? undefined : actionsOnHover,
        onClick: onClick,
        ariaControls: ariaControls,
        ariaExpanded: ariaExpanded,
        ariaHasPopup: ariaHasPopup,
        isSelected: isSelected,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
});
module.exports["ButtonMenuItem"] = $bf400a28e0f66299$export$6dc09b7c0ec1dfcd;

});

parcelRegister("8njHX", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $gGs3F = parcelRequire("gGs3F");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $k2So4 = parcelRequire("k2So4");


var $6xzqO = parcelRequire("6xzqO");


var $6BXcn = parcelRequire("6BXcn");


var $5TK70 = parcelRequire("5TK70");


var $6hmpf = parcelRequire("6hmpf");

function $5185f3afa6ef08e0$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $5185f3afa6ef08e0$var$defaultAvatarValues = {
    size: 'small'
}; // Stable reference for the anchor's text-decoration reset. Hoisted to module
// scope so it is not re-created on every render of every menu item — the
// inline literal `{ textDecoration: 'none' }` had identical content but a new
// identity each render, forcing the host element's `style` to reconcile
// unnecessarily. Gated behind `navx-4728-jira-stability-fixes`.
const $5185f3afa6ef08e0$var$anchorTextDecorationResetStyle = {
    textDecoration: 'none'
};
const $5185f3afa6ef08e0$var$elemAfterDisplayVar = '--elem-after-display';
const $5185f3afa6ef08e0$var$actionsOnHoverOpacityVar = '--actions-on-hover-opacity';
const $5185f3afa6ef08e0$var$actionsOnHoverWidthVar = '--actions-on-hover-width';
const $5185f3afa6ef08e0$var$actionsOnHoverPaddingInlineEndVar = '--actions-on-hover-padding';
const $5185f3afa6ef08e0$var$notchColorVar = '--notch-color'; // Note: this is also used in `drag-handle.tsx`
const $5185f3afa6ef08e0$var$dragHandleDisplayVar = '--drag-handle-display';
const $5185f3afa6ef08e0$var$dragCursorAnimation = null; /**
                                   * ## 🤹 `position:relative`
                                   *
                                   * We need `position:relative` on an element that takes
                                   * up the full size of the interactive element so we
                                   * can correctly use `position:absolute` to place:
                                   * 1. the notch for links
                                   * 2. drop indicators for drag and drop
                                   * 3. a child of button / anchor to stretch it out to
                                   *    increase it's pressable area.
                                   *
                                   * ⛔️ We cannot add `position:relative` _only_ on the
                                   * button / anchor as that will cause sibling elements
                                   * to be rendered under the button / anchor when setting
                                   * a background color on the button / anchor.
                                   *
                                   * 📖 Note: `position:relative` elements are painted after
                                   * elements with `position:static` (the default)
                                   * https://drafts.csswg.org/css-position-4/#painting-order
                                   *
                                   * ⛔️ We cannot add `position:relative` to the container
                                   * element, as then the `:focus` ring styles on the
                                   * button / anchor can be cut off by the next sibling if it has
                                   * has a background color set (eg when selected)
                                   *
                                   * ✅ Add `position:relative` to all first level descendants
                                   * of the container element so that we don't impact DOM ordered
                                   * paint ordering within the item and the button / anchor focus
                                   * ring can still bleed over siblings
                                   *
                                   * 📖 We could use `> * { position: relative; }` on the container,
                                   * but that would violate our styling standard.
                                   */ 
const $5185f3afa6ef08e0$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
}; /**
    * All slots on the menu item (eg `elemBefore`) are rendered as siblings
    * of our main button / anchor element and they are visually placed on
    * top of the main button / anchor.
    *
    * 📖 This is done so that we don't nest interactive elements in our markup.
    *
    * ✅ This is great when element in the slot is an interactive element
    * as we don't want the main menu item button / anchor to be triggered
    * when interacting with the element in the slot.
    *
    * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
    * prevent the main button / anchor (that is visually behind the element in
    * the slot) from being clicked. The element in the slot is a sibling of our
    * main button / anchor (not a child of it) so clicking on the element in the
    * slot will not bubble up to the button / anchor.
    *
    * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
    * element so that static content in a slot does not prevent clicking on the main
    * button / anchor.
    */ 
const $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
}; /**
    * This is being _internally_ exported so it can be used in other menu item wrapper components, like
    * ExpandableMenuItemTrigger.
    *
    * This selector is used to apply hover styling on the menu item if it contains an open nested popup.
    * It's looking for a popup trigger with `aria-hasexpanded` and `aria-haspopup` attributes. The
    * reason for targeting the _trigger_ instead of the popup itself, is the popup might be rendered
    * outside the menu item, e.g. if rendered in a portal.
    *
    * An alternative solution might involve wrapping it with a popup context and listening to the popup
    * events through it (and applying the hover style when the popup is open). Exploring this has been
    * captured in [BLU-3354](https://jplat.atlassian.net/browse/BLU-3354).
    */ 
const $5185f3afa6ef08e0$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup])';
const $5185f3afa6ef08e0$var$containerStyles = {
    root: "_2rko12b0 _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3iviql _4cvr1h6o _uiztglyw _syazazsu _1yyu1j28 _91ju1txw _uomdidpf _pmxpidpf _db80idpf _irr319i6 _t7p8kb7n _g4kikb7n _91nl1wug _ynyi1wug _iy5o1b66 _v4o21b66",
    rootT26Shape: "_2rko1qi0",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_uomdkb7n _pmxp1wug _db801b66",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1mfcglyw _1sjuglyw",
    selected: "_bfhk15s3 _syaz6x5g _1yyujmqp _30l36x5g _irr3ufnl",
    disabled: "_syaz1gmx _bfhkn7od _irr3n7od _30l31gmx",
    hasDescription: "_4t3i1wto",
    dragging: "_tzy41ou4"
};
const $5185f3afa6ef08e0$var$nestedOpenPopupStyles = {
    root: "_1783kb7n _1d171wug _ligh1b66 _1fpr19i6",
    removeElemAfterOnHoverOrOpenNestedPopup: "_n3ixglyw",
    selected: "_1fprufnl"
};
const $5185f3afa6ef08e0$var$buttonOrAnchorStyles = {
    root: "_2rko12b0 _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk1j28 _syazazsu _4cvr1h6o _y3gnv2br _14iu13ro",
    rootT26Shape: "_2rko1qi0",
    selected: "_syaz6x5g _14iunozp",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _11om6b4r _7psyru3m _1uy01amc _bir2q7pw"
};
const $5185f3afa6ef08e0$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $5185f3afa6ef08e0$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $5185f3afa6ef08e0$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $5185f3afa6ef08e0$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _tzy4pnc3 _1bsbty16 _y4tidria _1guo18uv _12s918uv"
};
const $5185f3afa6ef08e0$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $5185f3afa6ef08e0$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh1ntv _1guo18uv _12s918uv"
};
const $5185f3afa6ef08e0$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
}; /**
    * We are using a wrapping element for our interactive content
    * even though only the `Text` element is the only thing not using `position:absolute`
    *
    * Rationale:
    * - Super clear that everything inside the interactive content should be in a specific slot in the grid
    * - To work around a browser bug in Safari where it does not work well with `position:absolute`
    *   on a subgrid child.
    *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
    */ 
const $5185f3afa6ef08e0$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $5185f3afa6ef08e0$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
} /**
   * Includes all props that are used by any menu item, as MenuItembase is the base component for all menu item components.
   *
   * We also include additional `aria` props to support the menu item being a trigger for the FlyoutMenuItem popup and for the
   * expanded content for ExpandableMenuItem.
   */ 
const $5185f3afa6ef08e0$var$MenuItemBaseNoRef = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $frIzR.c)(85);
    const { id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const level = (0, $6BXcn.useLevel)();
    const setFlyoutMenuOpen = (0, $5TK70.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $5TK70.useFlyoutMenuOpen)();
    const isLink = typeof href !== "undefined";
    const labelRef = (0, $42omo.useRef)(null);
    const descriptionRef = (0, $42omo.useRef)(null);
    const tooltipOnClick = (0, $42omo.useRef)(null);
    let t1;
    if ($[0] !== isFlyoutMenuOpen || $[1] !== onClick || $[2] !== setFlyoutMenuOpen) {
        t1 = (event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent);
            setFlyoutMenuOpen(!isFlyoutMenuOpen);
            tooltipOnClick.current?.(event);
        };
        $[0] = isFlyoutMenuOpen;
        $[1] = onClick;
        $[2] = setFlyoutMenuOpen;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] !== isContentTooltipDisabled) {
        t2 = ()=>{
            if (isContentTooltipDisabled) return false;
            const label = labelRef.current;
            const description_0 = descriptionRef.current;
            if (label && $5185f3afa6ef08e0$var$isTextClamped(label)) return true;
            return Boolean(description_0 && $5185f3afa6ef08e0$var$isTextClamped(description_0));
        };
        $[4] = isContentTooltipDisabled;
        $[5] = t2;
    } else t2 = $[5];
    const canTooltipAppear = t2;
    const showElemBefore = elemBefore !== (0, $6hmpf.COLLAPSE_ELEM_BEFORE);
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$interactiveContentStyles.root
        ]);
        $[6] = t3;
    } else t3 = $[6];
    const t4 = `calc(-1 * ${level} * ${(0, $k2So4.expandableMenuItemIndentation)})`;
    let t5;
    if ($[7] !== t4) {
        t5 = {
            insetInlineStart: t4
        };
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$extendButtonOrAnchorStyles.root
        ]);
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: t5,
            "aria-hidden": "true",
            className: t6
        });
        $[10] = t5;
        $[11] = t7;
    } else t7 = $[11];
    const t8 = !showElemBefore && $5185f3afa6ef08e0$var$textStyles.noElemBeforeIndent;
    let t9;
    if ($[12] !== t8) {
        t9 = (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$textStyles.root,
            t8
        ]);
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== isDisabled || $[15] !== isSelected) {
        t10 = $5185f3afa6ef08e0$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        });
        $[14] = isDisabled;
        $[15] = isSelected;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== children || $[18] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium",
            maxLines: 1,
            color: t10,
            ref: labelRef
        }, children);
        $[17] = children;
        $[18] = t10;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== description || $[21] !== isDisabled || $[22] !== isSelected) {
        t12 = description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: $5185f3afa6ef08e0$var$getTextColor({
                isDisabled: isDisabled,
                isSelected: isSelected
            }),
            size: "small",
            maxLines: 1,
            ref: descriptionRef
        }, description);
        $[20] = description;
        $[21] = isDisabled;
        $[22] = isSelected;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== t11 || $[25] !== t12 || $[26] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t9
        }, t11, t12);
        $[24] = t11;
        $[25] = t12;
        $[26] = t9;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== hasDragIndicator) {
        t14 = hasDragIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xzqO.DragHandle), null) : null;
        $[28] = hasDragIndicator;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== dropIndicator || $[31] !== t13 || $[32] !== t14 || $[33] !== t7) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t3
        }, t7, t13, t14, dropIndicator);
        $[30] = dropIndicator;
        $[31] = t13;
        $[32] = t14;
        $[33] = t7;
        $[34] = t15;
    } else t15 = $[34];
    const interactiveElemContent = t15;
    const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    const t16 = testId ? `${testId}-container` : undefined;
    let t17;
    if ($[35] !== actionsOnHover || $[36] !== description || $[37] !== elemAfter || $[38] !== isDisabled || $[39] !== isDragging || $[40] !== isSelected || $[41] !== showHoverActionsWhenNotHovered) {
        t17 = (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$containerStyles.root,
            $5185f3afa6ef08e0$var$nestedOpenPopupStyles.root,
            (0, $dh538.fg)("platform-dst-shape-theme-default") && $5185f3afa6ef08e0$var$containerStyles.rootT26Shape,
            isSelected && $5185f3afa6ef08e0$var$containerStyles.selected,
            isSelected && $5185f3afa6ef08e0$var$nestedOpenPopupStyles.selected,
            isDragging && $5185f3afa6ef08e0$var$containerStyles.dragging,
            description && $5185f3afa6ef08e0$var$containerStyles.hasDescription,
            showHoverActionsWhenNotHovered && $5185f3afa6ef08e0$var$containerStyles.showHoverActions,
            showHoverActionsWhenNotHovered && elemAfter && $5185f3afa6ef08e0$var$containerStyles.removeElemAfter,
            actionsOnHover && elemAfter && $5185f3afa6ef08e0$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            actionsOnHover && elemAfter && $5185f3afa6ef08e0$var$nestedOpenPopupStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            isDisabled && $5185f3afa6ef08e0$var$containerStyles.disabled
        ]);
        $[35] = actionsOnHover;
        $[36] = description;
        $[37] = elemAfter;
        $[38] = isDisabled;
        $[39] = isDragging;
        $[40] = isSelected;
        $[41] = showHoverActionsWhenNotHovered;
        $[42] = t17;
    } else t17 = $[42];
    let t18;
    if ($[43] !== children || $[44] !== description) {
        t18 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, description) : null);
        $[43] = children;
        $[44] = description;
        $[45] = t18;
    } else t18 = $[45];
    let t19;
    if ($[46] !== ariaControls || $[47] !== ariaExpanded || $[48] !== ariaHasPopup || $[49] !== forwardedRef || $[50] !== handleClick || $[51] !== hasDragIndicator || $[52] !== href || $[53] !== id || $[54] !== interactionName || $[55] !== interactiveElemContent || $[56] !== isDisabled || $[57] !== isLink || $[58] !== isSelected || $[59] !== target || $[60] !== testId) {
        t19 = (tooltipProps)=>{
            tooltipOnClick.current = tooltipProps.onClick;
            const sharedProps = {
                ...tooltipProps,
                "aria-controls": ariaControls,
                "aria-haspopup": ariaHasPopup,
                ref: (0, $3654r.default)([
                    forwardedRef,
                    tooltipProps.ref
                ]),
                id: id,
                testId: testId,
                interactionName: interactionName
            };
            return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
                ...sharedProps,
                onClick: handleClick,
                xcss: (0, $1bHXt.cx)($5185f3afa6ef08e0$var$buttonOrAnchorStyles.root, (0, $dh538.fg)("platform-dst-shape-theme-default") && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.rootT26Shape, $5185f3afa6ef08e0$var$topLevelSiblingStyles.root, isSelected && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.selected, hasDragIndicator && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.hasDragIndicator),
                style: (0, $dh538.fg)("navx-4728-jira-stability-fixes") ? $5185f3afa6ef08e0$var$anchorTextDecorationResetStyle : {
                    textDecoration: "none"
                },
                "aria-current": isSelected ? "page" : undefined,
                href: href,
                target: target,
                draggable: hasDragIndicator ? undefined : false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    $5185f3afa6ef08e0$var$notchStyles.root
                ])
            }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                ...sharedProps,
                onClick: handleClick,
                xcss: (0, $1bHXt.cx)($5185f3afa6ef08e0$var$buttonOrAnchorStyles.root, (0, $dh538.fg)("platform-dst-shape-theme-default") && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.rootT26Shape, $5185f3afa6ef08e0$var$topLevelSiblingStyles.root, isSelected && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.selected, hasDragIndicator && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.hasDragIndicator),
                "aria-expanded": ariaExpanded,
                isDisabled: isDisabled
            }, interactiveElemContent);
        };
        $[46] = ariaControls;
        $[47] = ariaExpanded;
        $[48] = ariaHasPopup;
        $[49] = forwardedRef;
        $[50] = handleClick;
        $[51] = hasDragIndicator;
        $[52] = href;
        $[53] = id;
        $[54] = interactionName;
        $[55] = interactiveElemContent;
        $[56] = isDisabled;
        $[57] = isLink;
        $[58] = isSelected;
        $[59] = target;
        $[60] = testId;
        $[61] = t19;
    } else t19 = $[61];
    let t20;
    if ($[62] !== canTooltipAppear || $[63] !== t18 || $[64] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t18,
            position: "right-start",
            ignoreTooltipPointerEvents: true,
            hideTooltipOnMouseDown: true,
            isScreenReaderAnnouncementDisabled: true,
            canAppear: canTooltipAppear
        }, t19);
        $[62] = canTooltipAppear;
        $[63] = t18;
        $[64] = t19;
        $[65] = t20;
    } else t20 = $[65];
    let t21;
    if ($[66] !== elemBefore || $[67] !== showElemBefore) {
        t21 = showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $5185f3afa6ef08e0$var$elemBeforeStyles.root,
                $5185f3afa6ef08e0$var$topLevelSiblingStyles.root,
                $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, elemBefore);
        $[66] = elemBefore;
        $[67] = showElemBefore;
        $[68] = t21;
    } else t21 = $[68];
    let t22;
    if ($[69] !== actionsOnHover) {
        t22 = actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $5185f3afa6ef08e0$var$actionsOnHoverStyles.root
            ])
        }, actionsOnHover);
        $[69] = actionsOnHover;
        $[70] = t22;
    } else t22 = $[70];
    let t23;
    if ($[71] !== elemAfter) {
        t23 = elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $5185f3afa6ef08e0$var$elemAfterStyles.root,
                $5185f3afa6ef08e0$var$topLevelSiblingStyles.root,
                $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, elemAfter);
        $[71] = elemAfter;
        $[72] = t23;
    } else t23 = $[72];
    let t24;
    if ($[73] !== actions) {
        t24 = actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $5185f3afa6ef08e0$var$actionStyles.root,
                $5185f3afa6ef08e0$var$topLevelSiblingStyles.root,
                $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, actions);
        $[73] = actions;
        $[74] = t24;
    } else t24 = $[74];
    let t25;
    if ($[75] !== isSelected || $[76] !== t16 || $[77] !== t17 || $[78] !== t20 || $[79] !== t21 || $[80] !== t22 || $[81] !== t23 || $[82] !== t24 || $[83] !== visualContentRef) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gGs3F.AvatarContext).Provider, {
            value: $5185f3afa6ef08e0$var$defaultAvatarValues
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: visualContentRef,
            "data-testid": t16,
            "data-selected": isSelected,
            className: t17
        }, t20, t21, t22, t23, t24));
        $[75] = isSelected;
        $[76] = t16;
        $[77] = t17;
        $[78] = t20;
        $[79] = t21;
        $[80] = t22;
        $[81] = t23;
        $[82] = t24;
        $[83] = visualContentRef;
        $[84] = t25;
    } else t25 = $[84];
    return t25;
} : ({ id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const level = (0, $6BXcn.useLevel)();
    const setFlyoutMenuOpen = (0, $5TK70.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $5TK70.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $42omo.useRef)(null);
    const descriptionRef = (0, $42omo.useRef)(null);
    const tooltipOnClick = (0, $42omo.useRef)(null);
    const handleClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent); // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]); /**
                                                       * Show the tooltip if _either_ label or description is truncated
                                                       */ 
    const canTooltipAppear = (0, $42omo.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
         // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description_0 = descriptionRef.current;
        if (label && $5185f3afa6ef08e0$var$isTextClamped(label)) return true;
        return Boolean(description_0 && $5185f3afa6ef08e0$var$isTextClamped(description_0));
    }, [
        isContentTooltipDisabled
    ]); // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $6hmpf.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$interactiveContentStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // This extends the clickable area of nested menu items to the width
    , {
        // of the root level menu items, while being visually indented.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            insetInlineStart: `calc(-1 * ${level} * ${(0, $k2So4.expandableMenuItemIndentation)})`
        },
        "aria-hidden": "true",
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$textStyles.root,
            !showElemBefore && $5185f3afa6ef08e0$var$textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "medium",
        maxLines: 1,
        color: $5185f3afa6ef08e0$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        ref: labelRef
    }, children), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: $5185f3afa6ef08e0$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        size: "small",
        maxLines: 1,
        ref: descriptionRef
    }, description)), hasDragIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xzqO.DragHandle), null) : null, dropIndicator); /**
           *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
           *
           * Note: we also remove the `elemAfter` when showing `actionsOnHover`
           */ 
    const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gGs3F.AvatarContext).Provider, {
        value: $5185f3afa6ef08e0$var$defaultAvatarValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: visualContentRef,
        "data-testid": testId ? `${testId}-container` : undefined,
        "data-selected": isSelected,
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$containerStyles.root,
            $5185f3afa6ef08e0$var$nestedOpenPopupStyles.root,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $5185f3afa6ef08e0$var$containerStyles.rootT26Shape,
            isSelected && $5185f3afa6ef08e0$var$containerStyles.selected,
            isSelected && $5185f3afa6ef08e0$var$nestedOpenPopupStyles.selected,
            isDragging && $5185f3afa6ef08e0$var$containerStyles.dragging,
            description && $5185f3afa6ef08e0$var$containerStyles.hasDescription,
            showHoverActionsWhenNotHovered && $5185f3afa6ef08e0$var$containerStyles.showHoverActions,
            showHoverActionsWhenNotHovered && elemAfter && $5185f3afa6ef08e0$var$containerStyles.removeElemAfter,
            actionsOnHover && elemAfter && $5185f3afa6ef08e0$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            actionsOnHover && elemAfter && $5185f3afa6ef08e0$var$nestedOpenPopupStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            isDisabled && $5185f3afa6ef08e0$var$containerStyles.disabled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, description) : null),
        position: "right-start",
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true // We don't need a duplicate hidden element containing tooltip content
        ,
        // as the content of the tooltip matches what is rendered for the menu item.
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, (tooltipProps)=>{
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        const sharedProps = {
            ...tooltipProps,
            'aria-controls': ariaControls,
            'aria-haspopup': ariaHasPopup,
            ref: (0, $3654r.default)([
                forwardedRef,
                tooltipProps.ref
            ]),
            id: id,
            testId: testId,
            interactionName: interactionName
        };
        return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
            ...sharedProps,
            onClick: handleClick,
            xcss: (0, $1bHXt.cx)($5185f3afa6ef08e0$var$buttonOrAnchorStyles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.rootT26Shape, $5185f3afa6ef08e0$var$topLevelSiblingStyles.root, isSelected && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.selected, hasDragIndicator && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.hasDragIndicator),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: (0, $dh538.fg)('navx-4728-jira-stability-fixes') ? $5185f3afa6ef08e0$var$anchorTextDecorationResetStyle : {
                textDecoration: 'none'
            },
            "aria-current": isSelected ? 'page' : undefined,
            href: href,
            target: target,
            draggable: hasDragIndicator ? undefined : false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "aria-hidden": "true",
            className: (0, $gMc0m.default)([
                $5185f3afa6ef08e0$var$notchStyles.root
            ])
        }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            ...sharedProps,
            onClick: handleClick,
            xcss: (0, $1bHXt.cx)($5185f3afa6ef08e0$var$buttonOrAnchorStyles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.rootT26Shape, $5185f3afa6ef08e0$var$topLevelSiblingStyles.root, isSelected && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.selected, hasDragIndicator && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.hasDragIndicator),
            "aria-expanded": ariaExpanded,
            isDisabled: isDisabled
        }, interactiveElemContent);
    }), showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$elemBeforeStyles.root,
            $5185f3afa6ef08e0$var$topLevelSiblingStyles.root,
            $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$actionsOnHoverStyles.root
        ])
    }, actionsOnHover), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$elemAfterStyles.root,
            $5185f3afa6ef08e0$var$topLevelSiblingStyles.root,
            $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$actionStyles.root,
            $5185f3afa6ef08e0$var$topLevelSiblingStyles.root,
            $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, actions)));
}; /**
    * __MenuItemBase__
    *
    * The base menu item component used to compose ButtonMenuItem and LinkMenuItem.
    *
    * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
    * This can be inferred from the type of the `onClick` prop.
    */ 
const $5185f3afa6ef08e0$export$859b390bf71e044e = (0, $3hoG4.default)($5185f3afa6ef08e0$var$MenuItemBaseNoRef);
module.exports["MenuItemBase"] = $5185f3afa6ef08e0$export$859b390bf71e044e;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("k2So4", function(module, exports) {
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $3bd71abec4b95b70$export$d492445a79a49b48 = '12px';
module.exports["expandableMenuItemIndentation"] = $3bd71abec4b95b70$export$d492445a79a49b48;

});

parcelRegister("6xzqO", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8aNCk = parcelRequire("8aNCk");

const $1d3ac884996bbce8$var$styles = {
    root: "_syazazsu _1e0c1i3c _2lx21bp4 _1bah1h6o _kqswstnw _152tidpf _u7coidpf _1e02idpf _ahbqxmi2"
};
const $1d3ac884996bbce8$export$a0c24614540b0efb = (0, $4pOgL.isReactCompilerActivePlatform)() ? function DragHandle() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("div", {
            "aria-hidden": "true",
            className: (0, $gMc0m.default)([
                $1d3ac884996bbce8$var$styles.root
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8aNCk))), {
            label: "",
            size: "small"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function DragHandle() {
    return /*#__PURE__*/ $42omo.createElement("div", {
        "aria-hidden": "true",
        className: (0, $gMc0m.default)([
            $1d3ac884996bbce8$var$styles.root
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8aNCk))), {
        label: "",
        size: "small"
    }));
};
module.exports["DragHandle"] = $1d3ac884996bbce8$export$a0c24614540b0efb;

});

parcelRegister("6BXcn", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $9r5xQ = parcelRequire("9r5xQ");

const $835b2725fca28696$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $835b2725fca28696$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $835b2725fca28696$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $835b2725fca28696$export$572ce188c913ceba = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $835b2725fca28696$export$650d12d3c2ddb8fc = (0, $9r5xQ.ExpandableMenuItemLevelContext);
const $835b2725fca28696$export$37e565a09598825e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $42omo.useContext)($835b2725fca28696$export$c856e5885cc34d81);
    (0, $dRnqM.default)(context !== null, "useIsExpanded must be used within an ExpandableMenuItem");
    return context;
} : ()=>{
    const context = (0, $42omo.useContext)($835b2725fca28696$export$c856e5885cc34d81);
    (0, $dRnqM.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $835b2725fca28696$export$c9a171ea8de5861b = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $42omo.useContext)($835b2725fca28696$export$48cb11cb8691f597);
    (0, $dRnqM.default)(context !== null, "useSetIsExpanded must be used within an ExpandableMenuItem");
    return context;
} : ()=>{
    const context = (0, $42omo.useContext)($835b2725fca28696$export$48cb11cb8691f597);
    (0, $dRnqM.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $835b2725fca28696$export$56c8438498b72c7a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($835b2725fca28696$export$572ce188c913ceba);
} : ()=>(0, $42omo.useContext)($835b2725fca28696$export$572ce188c913ceba);
const $835b2725fca28696$export$fdfe9e5e8183d4f2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($835b2725fca28696$export$650d12d3c2ddb8fc);
} : ()=>(0, $42omo.useContext)($835b2725fca28696$export$650d12d3c2ddb8fc);
const $835b2725fca28696$export$57108b5f08ae5194 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($835b2725fca28696$export$9c01e0e6a504d553) ?? true;
} : ()=>(0, $42omo.useContext)($835b2725fca28696$export$9c01e0e6a504d553) ?? true;
module.exports["AreAllAncestorsExpandedContext"] = $835b2725fca28696$export$9c01e0e6a504d553;
module.exports["IsExpandedContext"] = $835b2725fca28696$export$c856e5885cc34d81;
module.exports["SetIsExpandedContext"] = $835b2725fca28696$export$48cb11cb8691f597;
module.exports["OnExpansionToggleContext"] = $835b2725fca28696$export$572ce188c913ceba;
module.exports["LevelContext"] = $835b2725fca28696$export$650d12d3c2ddb8fc;
module.exports["useIsExpanded"] = $835b2725fca28696$export$37e565a09598825e;
module.exports["useSetIsExpanded"] = $835b2725fca28696$export$c9a171ea8de5861b;
module.exports["useOnExpansionToggle"] = $835b2725fca28696$export$56c8438498b72c7a;
module.exports["useLevel"] = $835b2725fca28696$export$fdfe9e5e8183d4f2;
module.exports["useAreAllAncestorsExpanded"] = $835b2725fca28696$export$57108b5f08ae5194;

});

parcelRegister("9r5xQ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $cd7d1982b9276331$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $42omo.createContext)(0);
module.exports["ExpandableMenuItemLevelContext"] = $cd7d1982b9276331$export$f8d6463f9b5ca897;

});

parcelRegister("5TK70", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $471f84ea38b53016$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $471f84ea38b53016$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
const $471f84ea38b53016$export$6927118f874a49aa = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($471f84ea38b53016$export$efa4d9670e96ac31);
} : ()=>(0, $42omo.useContext)($471f84ea38b53016$export$efa4d9670e96ac31);
const $471f84ea38b53016$export$538ac1aa421adb94 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($471f84ea38b53016$export$4c55b1c61a116b42);
} : ()=>(0, $42omo.useContext)($471f84ea38b53016$export$4c55b1c61a116b42);
const $471f84ea38b53016$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $42omo.createContext)({
    current: null
});
const $471f84ea38b53016$export$fb4c7299c436068c = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $471f84ea38b53016$export$761b237ca835a288 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($471f84ea38b53016$export$fb4c7299c436068c);
} : ()=>(0, $42omo.useContext)($471f84ea38b53016$export$fb4c7299c436068c);
const $471f84ea38b53016$export$9abe8108f4bc916 = $471f84ea38b53016$export$fb4c7299c436068c.Provider;
module.exports["IsOpenContext"] = $471f84ea38b53016$export$efa4d9670e96ac31;
module.exports["SetIsOpenContext"] = $471f84ea38b53016$export$4c55b1c61a116b42;
module.exports["useFlyoutMenuOpen"] = $471f84ea38b53016$export$6927118f874a49aa;
module.exports["useSetFlyoutMenuOpen"] = $471f84ea38b53016$export$538ac1aa421adb94;
module.exports["OnCloseContext"] = $471f84ea38b53016$export$7376ab1fc7707bdd;
module.exports["useTitleId"] = $471f84ea38b53016$export$761b237ca835a288;
module.exports["TitleIdContextProvider"] = $471f84ea38b53016$export$9abe8108f4bc916;

});

parcelRegister("6hmpf", function(module, exports) {
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $3c5b6d18b5aba7eb$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');
module.exports["COLLAPSE_ELEM_BEFORE"] = $3c5b6d18b5aba7eb$export$f4b8e24fae579c6f;

});

parcelRegister("jvL0g", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eLJ8w = parcelRequire("eLJ8w");

const $ad780ebce5bd3997$export$6c2f3257abc4825b = (0, $eLJ8w.ListItem);
module.exports["MenuListItem"] = $ad780ebce5bd3997$export$6c2f3257abc4825b;

});

parcelRegister("eLJ8w", function(module, exports) {
/* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");

function $66d0ff3d23490365$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ $42omo.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
}
const $66d0ff3d23490365$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $42omo.forwardRef)($66d0ff3d23490365$var$_ListItem);
module.exports["ListItem"] = $66d0ff3d23490365$export$a7b06bfba60a8a78;

});

parcelRegister("iKHTh", function(module, exports) {

var $aJT7b = parcelRequire("aJT7b");

const $19720d3977b4df3f$export$d4c4e98c5044dc8 = (0, $aJT7b.List);
module.exports["MenuList"] = $19720d3977b4df3f$export$d4c4e98c5044dc8;

});

parcelRegister("aJT7b", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");

function $002d225363d96747$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ $42omo.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
const $002d225363d96747$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $42omo.forwardRef)($002d225363d96747$var$_List);
module.exports["List"] = $002d225363d96747$export$54c2e3dc7acea9f5;

});

parcelRegister("g26MG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lebfc = parcelRequire("lebfc");


var $lAFHW = parcelRequire("lAFHW");


var $buthI = parcelRequire("buthI");


var $9wGTI = parcelRequire("9wGTI");


var $fGLQm = parcelRequire("fGLQm");

var $itlCX = parcelRequire("itlCX");

const $bab3f5eb7fd997b5$var$AccessClassIcon = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), {
        appearance: 'brand'
    });
const $bab3f5eb7fd997b5$var$getPrincipalIcon = (principal)=>{
    switch(principal.__typename){
        case 'SpaceRoleGroupPrincipal':
            return 0, (/*@__PURE__*/$parcel$interopDefault($lebfc));
        case 'SpaceRoleAccessClassPrincipal':
            return principal.principalId === 'anonymous-users' ? (0, (/*@__PURE__*/$parcel$interopDefault($buthI))) : $bab3f5eb7fd997b5$var$AccessClassIcon;
        case 'ConfluenceSpaceRoleAppPrincipal':
        case 'SpaceRoleGuestPrincipal':
        case 'SpaceRoleUserPrincipal':
        default:
            return null;
    }
};
const $bab3f5eb7fd997b5$export$4b3b0188cc9d39a8 = (data, isCompanyHub = false)=>{
    return data.map((item)=>({
            key: item.id,
            groupName: item.group.displayName,
            groupPriority: item.group.priority,
            // Use hubDisplayName if in companyhub context, otherwise fall back to displayName
            actionName: isCompanyHub && item.hubDisplayName || item.displayName,
            priority: item.priority,
            // Use hubDescription if in companyhub context, otherwise fall back to description
            description: isCompanyHub && item.hubDescription || item.description,
            requiredPermissions: item.requiredSpacePermissions ? [
                ...item.requiredSpacePermissions
            ].map((p)=>p ?? null) : null
        }))// Filter out all actions without display names before the deprecation of some permissions is completed
    .filter((item)=>!!item.actionName);
};
const $bab3f5eb7fd997b5$export$429eba48f8769b83 = (rawData)=>{
    return rawData.filter((d)=>d != null).map((item)=>({
            id: item.roleId,
            name: item.roleDisplayName,
            description: item.roleDescription,
            permissions: item.spacePermissionList.map((permission)=>permission.id),
            roleType: item.roleType,
            confluenceRoleAssignabilityCode: item.confluenceRoleAssignabilityCode,
            isDisabled: !!('disabled' in item && item.disabled)
        }));
};
const $bab3f5eb7fd997b5$export$8bdeeb44c9ac0591 = (type)=>{
    switch(type){
        case 'SpaceRoleGuestPrincipal':
            // Guests are users.
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'ConfluenceSpaceRoleAppPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).APP;
        case 'SpaceRoleGroupPrincipal':
            // Teams are groups.
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'SpaceRoleUserPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'SpaceRoleAccessClassPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).ACCESS_CLASS;
        default:
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
    }
};
const $bab3f5eb7fd997b5$export$bf16ef98b7c6b580 = (type)=>{
    switch(type){
        case 'user':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'team':
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'group':
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'external_user':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'custom':
            return (0, $itlCX.RoleAssignmentPrincipalType).ACCESS_CLASS;
        default:
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
    }
};
const $bab3f5eb7fd997b5$export$1c34a8ae4dfc585c = (rawData)=>{
    if (!rawData) return [];
    return rawData.map((item)=>{
        const { principal: principal, role: role } = item;
        const isTeam = principal.__typename === 'SpaceRoleGroupPrincipal' && principal.usageType === (0, $fGLQm.ConfluenceGroupUsageType).TEAM_COLLABORATION;
        return {
            assignmentId: principal.principalId,
            principal: {
                id: principal.principalId,
                displayName: principal.displayName,
                type: $bab3f5eb7fd997b5$export$8bdeeb44c9ac0591(principal.__typename),
                email: 'email' in principal ? principal?.email : undefined,
                avatarUrl: 'profilePicture' in principal ? principal.profilePicture?.path : undefined,
                icon: isTeam && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? null : $bab3f5eb7fd997b5$var$getPrincipalIcon(principal),
                isGuest: principal.__typename === 'SpaceRoleGuestPrincipal',
                isTeam: isTeam
            },
            roleId: role?.roleId || null,
            roleLabel: role?.roleDisplayName || null,
            roleDescription: role?.roleDescription || null,
            // Principal can either be assigned granular space permissions, or permissions through a role
            permissions: item?.permissions?.map((permission)=>permission.id) || role?.spacePermissionList.map((permission)=>permission.id) || [],
            availableRoles: [],
            unavailableRoles: [],
            assignablePermissions: item.assignablePermissions?.map((permission)=>permission).filter(Boolean) || []
        };
    });
};
const $bab3f5eb7fd997b5$export$f41b22015074a487 = (groupCountRecords, assignments)=>{
    const groupCountMap = groupCountRecords.reduce((acc, { key: key, value: value })=>{
        if (key !== null && key !== undefined) acc[key] = value;
        return acc;
    }, {});
    return assignments.map((assignment)=>({
            ...assignment,
            principal: assignment.principal.type === (0, $itlCX.RoleAssignmentPrincipalType).GROUP ? {
                ...assignment.principal,
                groupCount: groupCountMap[assignment.principal.id] ?? undefined
            } : assignment.principal
        }));
};
const $bab3f5eb7fd997b5$export$89b4246717b63b9f = (assignments, teamData)=>{
    if (!teamData || !teamData.teamsV2 || teamData.teamsV2?.length === 0) return assignments;
    // Pre-compute a map of team IDs to team info for O(1) lookup
    const teamInfoMap = new Map();
    for (const team of teamData.teamsV2)if (team?.id) teamInfoMap.set(team.id, team);
    return assignments.map((row)=>{
        const teamInfo = teamInfoMap.get(row.principal.id);
        if (!teamInfo) return row;
        return {
            ...row,
            principal: {
                ...row.principal,
                icon: null,
                avatarUrl: teamInfo.largeAvatarImageUrl ?? undefined,
                isTeam: true,
                isVerified: teamInfo.type?.verified ?? undefined,
                teamData: teamInfo,
                teamTypeName: teamInfo.type?.name
            }
        };
    });
};
const $bab3f5eb7fd997b5$var$UNLICENSED_USERS_ID = 'authenticated-users';
const $bab3f5eb7fd997b5$export$b3299b59e278e268 = (assignments)=>assignments.filter((record)=>record.principal.id !== $bab3f5eb7fd997b5$var$UNLICENSED_USERS_ID);
const $bab3f5eb7fd997b5$export$2fed59ad085105af = (displayTypes)=>{
    return displayTypes.filter((type)=>type !== 'TEAM').concat(displayTypes.includes('TEAM') ? [
        (0, $fGLQm.PrincipalFilterType).GROUP
    ] : []);
};
const $bab3f5eb7fd997b5$export$cc79220753e2d98a = (filterTypes)=>{
    if (filterTypes.length === 0) return [];
    const typesToFilterOut = [];
    if (!filterTypes.includes((0, $fGLQm.PrincipalFilterType).GROUP)) typesToFilterOut.push((0, $fGLQm.ConfluenceGroupUsageType).USERBASE_GROUP);
    if (!filterTypes.includes('TEAM')) typesToFilterOut.push((0, $fGLQm.ConfluenceGroupUsageType).TEAM_COLLABORATION);
    if (!filterTypes.includes((0, $fGLQm.PrincipalFilterType).USER_CLASS)) typesToFilterOut.push((0, $fGLQm.ConfluenceGroupUsageType).ADMIN_OVERSIGHT);
    return typesToFilterOut;
};
module.exports["normalizeSpacePermissionAll"] = $bab3f5eb7fd997b5$export$4b3b0188cc9d39a8;
module.exports["normalizeSpaceRoleList"] = $bab3f5eb7fd997b5$export$429eba48f8769b83;
module.exports["getPrincipalTypeFromUserPickerType"] = $bab3f5eb7fd997b5$export$bf16ef98b7c6b580;
module.exports["normalizeAssignments"] = $bab3f5eb7fd997b5$export$1c34a8ae4dfc585c;
module.exports["mergeGroupCountWithAssignments"] = $bab3f5eb7fd997b5$export$f41b22015074a487;
module.exports["mergeTeamDataWithAssignments"] = $bab3f5eb7fd997b5$export$89b4246717b63b9f;
module.exports["filterOutUnlicensedUsersAssignment"] = $bab3f5eb7fd997b5$export$b3299b59e278e268;
module.exports["displayPrincipalTypesToAPIPrincipalFilterTypes"] = $bab3f5eb7fd997b5$export$2fed59ad085105af;
module.exports["getTypesToFilterOut"] = $bab3f5eb7fd997b5$export$cc79220753e2d98a;

});

parcelRegister("fGLQm", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $4556f39c84e2f302$export$83836e07b7a1797e = /*#__PURE__*/ function(ConfluenceGroupManagementType) {
    ConfluenceGroupManagementType["ADMINS"] = "ADMINS";
    ConfluenceGroupManagementType["EXTERNAL"] = "EXTERNAL";
    ConfluenceGroupManagementType["OPEN"] = "OPEN";
    ConfluenceGroupManagementType["TEAM_MEMBERS"] = "TEAM_MEMBERS";
    return ConfluenceGroupManagementType;
}({});
var $4556f39c84e2f302$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $4556f39c84e2f302$export$c68cf5b85bcf89b0 = /*#__PURE__*/ function(PrincipalFilterType) {
    PrincipalFilterType["APP"] = "APP";
    PrincipalFilterType["GROUP"] = "GROUP";
    PrincipalFilterType["GUEST"] = "GUEST";
    PrincipalFilterType["USER"] = "USER";
    PrincipalFilterType["USER_CLASS"] = "USER_CLASS";
    return PrincipalFilterType;
}({});
var $4556f39c84e2f302$export$69bdd9d16ab8ed0f = /*#__PURE__*/ function(SpaceRoleType) {
    SpaceRoleType["CUSTOM"] = "CUSTOM";
    SpaceRoleType["SYSTEM"] = "SYSTEM";
    return SpaceRoleType;
}({});
module.exports["ConfluenceGroupUsageType"] = $4556f39c84e2f302$export$e7c9280c9da1cc0a;
module.exports["PrincipalFilterType"] = $4556f39c84e2f302$export$c68cf5b85bcf89b0;

});

parcelRegister("itlCX", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $d794298446e7cdbe$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["APP"] = "APP";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});
module.exports["RoleAssignmentPrincipalType"] = $d794298446e7cdbe$export$4e2d5448f3fd8728;

});

parcelRegister("cXkvk", function(module, exports) {

var $6iz6M = parcelRequire("6iz6M");

const $89f97fd25aadbe4e$export$15fb7df3b09f81b2 = (rolePermissions)=>{
    const hasPublicLinksPermission = rolePermissions.includes('MANAGE_PUBLIC_LINKS');
    const hasAnonymousAccessPermission = rolePermissions.includes('NONLICENSED_USER_MANAGEMENT');
    const isPublicLinksActionDisabled = (0, $6iz6M.useIsActionDisabledForWorkspace)({
        action: 'PUBLIC_LINKS',
        skip: !hasPublicLinksPermission
    });
    const isAnonymousAccessActionDisabled = (0, $6iz6M.useIsActionDisabledForWorkspace)({
        action: 'ANONYMOUS_ACCESS',
        skip: !hasAnonymousAccessPermission
    });
    return isPublicLinksActionDisabled && hasPublicLinksPermission || isAnonymousAccessActionDisabled && hasAnonymousAccessPermission;
};
module.exports["useShouldShowDSPWarningForWorkspaceRole"] = $89f97fd25aadbe4e$export$15fb7df3b09f81b2;

});

parcelRegister("6iz6M", function(module, exports) {
/**
 * @generated SignedSource<<4f6dea84a7047469e2cc6c511e7a6518>>
 * @relayHash 93f071a13614e9b1cac311dde06f99b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c699bfb84a21ff66c9f3ec0304f078aaf4311194166f6949aaaedb9e7e376aa7
const $0a04cb25b81afab7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForWorkspace",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsActionDisabledForWorkspaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsActionDisabledForWorkspaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "93f071a13614e9b1cac311dde06f99b5",
            "id": "c699bfb84a21ff66c9f3ec0304f078aaf4311194166f6949aaaedb9e7e376aa7",
            "metadata": {},
            "name": "useIsActionDisabledForWorkspaceQuery",
            "operationKind": "query",
            "text": "query useIsActionDisabledForWorkspaceQuery($action:DataSecurityPolicyAction!){dataSecurityPolicy{isActionEnabledForWorkspace(action:$action){action,allowed}}}"
        }
    };
}();
$0a04cb25b81afab7$var$node.hash = "5548aa746f7031f0532e6507c978135c";
var $0a04cb25b81afab7$export$2e2bcd8739ae039 = $0a04cb25b81afab7$var$node;



var $jMyy4 = parcelRequire("jMyy4");

const $84df5a84e221158e$export$cc4f507e54133df3 = (0, $0a04cb25b81afab7$export$2e2bcd8739ae039);
const $84df5a84e221158e$export$1e86459cb60ae95 = ({ action: action, skip: skip = false })=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)($84df5a84e221158e$export$cc4f507e54133df3, {
        variables: {
            action: action
        },
        fetchPolicy: 'cache-and-network',
        skip: skip,
        __callerPackage__: "@confluence/data-security"
    });
    if (skip) return false;
    const allowedResp = data?.dataSecurityPolicy?.isActionEnabledForWorkspace?.allowed;
    // Defaults to disabled if we don't have a definitive answer
    return allowedResp === undefined || allowedResp === null ? true : !allowedResp;
};
module.exports["useIsActionDisabledForWorkspace"] = $84df5a84e221158e$export$1e86459cb60ae95;

});

parcelRegister("7siXU", function(module, exports) {
/* AdminSecurityPageWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $gdv5Z = parcelRequire("gdv5Z");


var $eyWa4 = parcelRequire("eyWa4");


var $aoVih = parcelRequire("aoVih");


var $kpYGL = parcelRequire("kpYGL");


var $9hlns = parcelRequire("9hlns");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $1BYn9 = parcelRequire("1BYn9");


var $lt6Lx = parcelRequire("lt6Lx");


var $jmjWc = parcelRequire("jmjWc");


var $4VuiN = parcelRequire("4VuiN");


var $dV8WM = parcelRequire("dV8WM");

const $d1833dcdda5c7ac3$var$UpsellBannerPlaceholder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "40%",
        height: "var(--ds-space-300, 24px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "var(--ds-space-200, 16px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "80%",
        height: "var(--ds-space-200, 16px)"
    })));

const $d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminGlobalV2Loadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qLEMU",
    name: "ChangeEditionSectionMessageAdminGlobalV2Loadable",
    loader: async ()=>(await (parcelRequire("37hRz"))).ChangeEditionSectionMessageAdminGlobalV2,
    loading: $d1833dcdda5c7ac3$var$UpsellBannerPlaceholder
});

const $d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminSpaceV2Loadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5GUNJ",
    name: "ChangeEditionSectionMessageAdminSpaceV2Loadable",
    loader: async ()=>(await (parcelRequire("1YacX"))).ChangeEditionSectionMessageAdminSpaceV2,
    loading: $d1833dcdda5c7ac3$var$UpsellBannerPlaceholder
});
const $d1833dcdda5c7ac3$var$styles = {
    spinnerContainer: "_1yt41epz _1e0c1txw _1bah1h6o",
    headerContainer: "_1e0c1txw _1bah1yb4 _6rth1ejb",
    bannerContainer: "_6rth1jfw"
};
const $d1833dcdda5c7ac3$export$2491da3a335cfdb = ({ title: title, documentTitle: documentTitle, bannerVariant: bannerVariant = 'global', titleAction: titleAction, fullWidth: fullWidth, children: children })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    if (isAdminCheckLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d1833dcdda5c7ac3$var$styles.spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large"
    }));
    if (!isProductAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dV8WM.RestrictedPage), null);
    const banner = isFreeEdition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d1833dcdda5c7ac3$var$styles.bannerContainer
    }, bannerVariant === 'space' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminSpaceV2Loadable, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminGlobalV2Loadable, null)) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4VuiN.AdminPageLayout), {
        banner: banner,
        fullWidth: fullWidth
    }, documentTitle !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
        titlePrefix: documentTitle
    }), title !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d1833dcdda5c7ac3$var$styles.headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h1",
        size: "large"
    }, title), titleAction), children);
};
module.exports["AdminSecurityPageWrapper"] = $d1833dcdda5c7ac3$export$2491da3a335cfdb;

});

parcelRegister("dV8WM", function(module, exports) {
/* RestrictedPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");

var $df295c692eec9998$exports = {};
$df295c692eec9998$exports = new URL("RestrictedContentIcon.39ea6b58.svg", import.meta.url).toString();


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c29d0256b2906de1$var$RestrictedPageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$RestrictedPageContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsbv36b _1e0c1txw _2lx21bp4 _1bah1h6o _4t3i10j7",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$CenteredContent = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$RestrictedMessageTitle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8r2fv _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$RestrictedContentImage = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1w81",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$export$4242cfff65d64b16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c29d0256b2906de1$var$RestrictedPageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c29d0256b2906de1$var$RestrictedPageContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c29d0256b2906de1$var$CenteredContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c29d0256b2906de1$var$RestrictedContentImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($df295c692eec9998$exports)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c29d0256b2906de1$var$RestrictedMessageTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "site-permissions.restricted.page.view.title",
        defaultMessage: "This is a restricted page"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "site-permissions.restricted.page.manual.request.access.from.author",
        defaultMessage: "If you think you should have access, try asking the person who sent you here for help."
    }))));
module.exports["RestrictedPage"] = $c29d0256b2906de1$export$4242cfff65d64b16;

});

parcelRegister("37hRz", function(module, exports) {

let $244fe1c34d8fc17d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $244fe1c34d8fc17d$var$load("lFAez"),
    $244fe1c34d8fc17d$var$load("1qlDN"),
    $244fe1c34d8fc17d$var$load("1yVM6"),
    $244fe1c34d8fc17d$var$load("cEqm7"),
    $244fe1c34d8fc17d$var$load("6XCf4"),
    $244fe1c34d8fc17d$var$load("eUAdQ")
]).then(()=>parcelRequire('rN8w9'));

});

parcelRegister("1YacX", function(module, exports) {

let $16f3501e60ae994e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $16f3501e60ae994e$var$load("lFAez"),
    $16f3501e60ae994e$var$load("1qlDN"),
    $16f3501e60ae994e$var$load("1yVM6"),
    $16f3501e60ae994e$var$load("cEqm7"),
    $16f3501e60ae994e$var$load("6XCf4"),
    $16f3501e60ae994e$var$load("gc0jz")
]).then(()=>parcelRequire('cJgGV'));

});

parcelRegister("dpPtd", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
const $c997cd3fd9f4ee84$export$2879604e6aec4ab = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $c997cd3fd9f4ee84$export$a4270ab432ac8a58 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $frIzR.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$var$FlagContext.Provider, {
            value: api
        }, children);
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($c997cd3fd9f4ee84$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent
        }, t5);
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t4, t6);
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag_1)=>{
        const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
        const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagType, {
            ...restProps,
            key: flag_1.id
        });
    })));
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $c997cd3fd9f4ee84$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$export$a4270ab432ac8a58, null, fn());
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("6V36D", function(module, exports) {
$parcel$export(module.exports, "VerifiedTeamLozenge", () => (parcelRequire("hVSC8")).VerifiedTeamLozenge);

var $hVSC8 = parcelRequire("hVSC8");


});

parcelRegister("hVSC8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bh5s2 = parcelRequire("bh5s2");


var $3gadb = parcelRequire("3gadb");

const $2e5b5aad519af945$var$i18n = (0, $aXWIB.defineMessages)({
    teamVerifiedLozengeTooltip: {
        id: "permissions-principals.team-verified-lozenge.tooltip",
        defaultMessage: "This team is verified because it is controlled by an organization admin."
    },
    groupVerifiedLozengeTooltip: {
        id: "permissions-principals.group-verified-lozenge.tooltip",
        defaultMessage: "This group is verified because it is controlled by an organization admin."
    }
});
const $2e5b5aad519af945$export$ba3ff7dd3e281a6b = ({ isTeam: isTeam = true, spacing: spacing = 'compact' })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: isTeam ? formatMessage($2e5b5aad519af945$var$i18n.teamVerifiedLozengeTooltip) : formatMessage($2e5b5aad519af945$var$i18n.groupVerifiedLozengeTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
        label: "verified team",
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: "small",
        spacing: spacing
    }));
};
module.exports["VerifiedTeamLozenge"] = $2e5b5aad519af945$export$ba3ff7dd3e281a6b;

});

parcelRegister("6MSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9387550ed869acb8$export$4242cfff65d64b16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M3-19",
    name: "RestrictedPage",
    loader: async ()=>(await (parcelRequire("5SBaA"))).RestrictedPage
});
module.exports["RestrictedPage"] = $9387550ed869acb8$export$4242cfff65d64b16;

});

parcelRegister("5SBaA", function(module, exports) {

let $447ed40594a09b31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $447ed40594a09b31$var$load("6wr18"),
    $447ed40594a09b31$var$load("ffEVr"),
    $447ed40594a09b31$var$load("daX4F"),
    $447ed40594a09b31$var$load("7EorR"),
    $447ed40594a09b31$var$load("hhss7"),
    $447ed40594a09b31$var$load("2OcM6"),
    $447ed40594a09b31$var$load("kUiwW")
]).then(()=>parcelRequire('3kPYw'));

});

parcelRegister("1SSaP", function(module, exports) {

let $15f4db57ac423b4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $15f4db57ac423b4f$var$load("f35QR"),
    $15f4db57ac423b4f$var$load("eVYW1"),
    $15f4db57ac423b4f$var$load("ls0Um"),
    $15f4db57ac423b4f$var$load("020xd"),
    $15f4db57ac423b4f$var$load("eTBsW"),
    $15f4db57ac423b4f$var$load("bYxCZ"),
    $15f4db57ac423b4f$var$load("6HBYC"),
    $15f4db57ac423b4f$var$load("eDqo1"),
    $15f4db57ac423b4f$var$load("lxiFd"),
    $15f4db57ac423b4f$var$load("1oiJ6"),
    $15f4db57ac423b4f$var$load("huUvS"),
    $15f4db57ac423b4f$var$load("6wr18"),
    $15f4db57ac423b4f$var$load("8j9XC"),
    $15f4db57ac423b4f$var$load("6vhrJ"),
    $15f4db57ac423b4f$var$load("fxC6e"),
    $15f4db57ac423b4f$var$load("ffEVr"),
    $15f4db57ac423b4f$var$load("7uWW8")
]).then(()=>parcelRequire('1c1P5'));

});

parcelRegister("go5PI", function(module, exports) {
const $a85703dfa4960dc8$export$6efc679b5f68edbb = 'adminConfiguration';
const $a85703dfa4960dc8$export$29494bfe5045193 = 'https://support.atlassian.com/confluence-cloud/docs/insert-confluence-wiki-markup/';
const $a85703dfa4960dc8$export$68fe928f91262da7 = 'https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor/';
const $a85703dfa4960dc8$export$d1b15eb7eed612ff = 'https://support.atlassian.com/confluence-cloud/docs/configure-time-and-date-formats/';
const $a85703dfa4960dc8$export$4facdf667af1c221 = 'https://confluence.atlassian.com/x/A41jL';
const $a85703dfa4960dc8$export$c6b232dd07adf3e8 = 'https://support.atlassian.com/confluence-cloud/docs/view-a-page/';
module.exports["ADMIN_CONFIGURATION_ANALYTICS_SOURCE"] = $a85703dfa4960dc8$export$6efc679b5f68edbb;
module.exports["WIKI_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$29494bfe5045193;
module.exports["CONVERT_PAGES_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$68fe928f91262da7;
module.exports["DATE_TIME_FORMAT_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$d1b15eb7eed612ff;
module.exports["PRESENCE_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$c6b232dd07adf3e8;

});

parcelRegister("fDMHs", function(module, exports) {

let $b6304654a530d6eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b6304654a530d6eb$var$load("f35QR"),
    $b6304654a530d6eb$var$load("eVYW1"),
    $b6304654a530d6eb$var$load("ls0Um"),
    $b6304654a530d6eb$var$load("020xd"),
    $b6304654a530d6eb$var$load("eTBsW"),
    $b6304654a530d6eb$var$load("bYxCZ"),
    $b6304654a530d6eb$var$load("6HBYC"),
    $b6304654a530d6eb$var$load("eDqo1"),
    $b6304654a530d6eb$var$load("lxiFd"),
    $b6304654a530d6eb$var$load("1oiJ6"),
    $b6304654a530d6eb$var$load("huUvS"),
    $b6304654a530d6eb$var$load("8j9XC"),
    $b6304654a530d6eb$var$load("6vhrJ"),
    $b6304654a530d6eb$var$load("fxC6e"),
    $b6304654a530d6eb$var$load("hMzlw")
]).then(()=>parcelRequire('lkTIR'));

});

parcelRegister("87xWZ", function(module, exports) {
const $9a9bb38d8a0d9d21$export$dd8dbc63482d3d52 = 'adminDefaultSpaceLogoConfig';
const $9a9bb38d8a0d9d21$export$a6c9f5ac24569a0a = [
    '.gif',
    '.jpg',
    '.jpeg',
    '.png',
    '.svg',
    '.webp'
];
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE"] = $9a9bb38d8a0d9d21$export$dd8dbc63482d3d52;
module.exports["ALLOWED_LOGO_FILE_EXTENSIONS"] = $9a9bb38d8a0d9d21$export$a6c9f5ac24569a0a;

});

parcelRegister("ksDMU", function(module, exports) {

let $ee55493640697816$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee55493640697816$var$load("lh6fT").then(()=>parcelRequire('f9aTe'));

});

parcelRegister("9VF1g", function(module, exports) {
const $3395fdb7c7788386$export$f57d5d3f8ce40ac2 = 'adminHeaderAndFooterConfig';
const $3395fdb7c7788386$export$6dbb84b06e78ca9 = '/admin/header-and-footer';
module.exports["ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE"] = $3395fdb7c7788386$export$f57d5d3f8ce40ac2;
module.exports["ADMIN_MIGRATION_HEADER_AND_FOOTER_PATH_NAME"] = $3395fdb7c7788386$export$6dbb84b06e78ca9;

});

parcelRegister("ktfnc", function(module, exports) {

let $ee7270e4559d9344$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee7270e4559d9344$var$load("8iU4E").then(()=>parcelRequire('46IN4'));

});

parcelRegister("kzcPl", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");

const $a85fb93a41cf2970$export$e7cba70eb2004729 = 'adminTemplatesAndBlueprints';
const $a85fb93a41cf2970$export$59e8eaf2c1cf7d28 = '/admin/templates-and-blueprints';
const $a85fb93a41cf2970$export$8726b5b334ad0749 = [
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_TEMPLATES_LOAD_EXPERIENCE),
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_BLUEPRINTS_LOAD_EXPERIENCE),
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_SYSTEM_TEMPLATES_LOAD_EXPERIENCE)
];
module.exports["ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE"] = $a85fb93a41cf2970$export$e7cba70eb2004729;
module.exports["PATH_NAME"] = $a85fb93a41cf2970$export$59e8eaf2c1cf7d28;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_SUB_EXPERIENCES"] = $a85fb93a41cf2970$export$8726b5b334ad0749;

});

parcelRegister("pI7qq", function(module, exports) {

let $04d48efb2da6bc27$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $04d48efb2da6bc27$var$load("dCPNW").then(()=>parcelRequire('bHNfF'));

});

parcelRegister("3Tdyk", function(module, exports) {
const $b18a48086d5c5e91$export$fa039ba6a22ab542 = 'adminNotifications';
module.exports["ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE"] = $b18a48086d5c5e91$export$fa039ba6a22ab542;

});

parcelRegister("kEPYK", function(module, exports) {

let $f09fdcf9f91bb3a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f09fdcf9f91bb3a4$var$load("lUFbG"),
    $f09fdcf9f91bb3a4$var$load("jfGTp"),
    $f09fdcf9f91bb3a4$var$load("gNBrZ"),
    $f09fdcf9f91bb3a4$var$load("e6e7M"),
    $f09fdcf9f91bb3a4$var$load("kYIpq"),
    $f09fdcf9f91bb3a4$var$load("7EorR"),
    $f09fdcf9f91bb3a4$var$load("fFJCh"),
    $f09fdcf9f91bb3a4$var$load("19uFC"),
    $f09fdcf9f91bb3a4$var$load("dcntv")
]).then(()=>parcelRequire('gLYG4'));

});

parcelRegister("2iZZQ", function(module, exports) {

let $1add5a6f97fa6a77$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1add5a6f97fa6a77$var$load("gNfuQ"),
    $1add5a6f97fa6a77$var$load("krOJz")
]).then(()=>parcelRequire('lMhQj'));

});

parcelRegister("i6ccO", function(module, exports) {
const $5030b4f7b6082c77$export$40d649ebb84b67da = 'spaceReportsSiteSettings';
module.exports["ADMIN_SPACE_REPORT_SCREEN"] = $5030b4f7b6082c77$export$40d649ebb84b67da;

});

parcelRegister("1wgeK", function(module, exports) {

let $11b55fe1d7f0ccb3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11b55fe1d7f0ccb3$var$load("lQHJf").then(()=>parcelRequire('2nzCJ'));

});

parcelRegister("jPtik", function(module, exports) {
const $877d602a9e3b74d4$export$3b900d9a0f807a35 = 'adminConfigureCodeMacro';
const $877d602a9e3b74d4$export$99fd23db6b16a233 = 'Confluence';
const $877d602a9e3b74d4$export$c73844cf6c80166 = 'Java';
module.exports["ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE"] = $877d602a9e3b74d4$export$3b900d9a0f807a35;
module.exports["DEFAULT_THEME_VALUE"] = $877d602a9e3b74d4$export$99fd23db6b16a233;
module.exports["DEFAULT_LANGUAGE_VALUE"] = $877d602a9e3b74d4$export$c73844cf6c80166;

});

parcelRegister("2OOsw", function(module, exports) {

let $20d7646468dc1fb1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20d7646468dc1fb1$var$load("lMnCe").then(()=>parcelRequire('5XJaz'));

});

parcelRegister("5vGLM", function(module, exports) {
const $18527396bdb04510$export$5ab36823e88567de = 'securityConfiguration';
const $18527396bdb04510$export$40326e81f7c56c6a = 'https://support.atlassian.com/confluence-cloud/docs/hide-external-links-from-search-engines/';
const $18527396bdb04510$export$f7de0eba11e77fd5 = 'https://support.atlassian.com/confluence-cloud/docs/turn-on-privacy-mode-for-analytics-data/';
const $18527396bdb04510$export$8802c1db742ad689 = 2147483647;
module.exports["ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE"] = $18527396bdb04510$export$5ab36823e88567de;
module.exports["EXTERNAL_LINKS_LEARN_MORE_LINK"] = $18527396bdb04510$export$40326e81f7c56c6a;
module.exports["PRIVACY_IN_ANALYTICS_LINK"] = $18527396bdb04510$export$f7de0eba11e77fd5;
module.exports["MAX_SAFE_JAVA_INTEGER"] = $18527396bdb04510$export$8802c1db742ad689;

});

parcelRegister("d1a5I", function(module, exports) {

let $97a3324273ff0607$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $97a3324273ff0607$var$load("6wr18"),
    $97a3324273ff0607$var$load("cOFDc"),
    $97a3324273ff0607$var$load("3Bbwl"),
    $97a3324273ff0607$var$load("ffEVr"),
    $97a3324273ff0607$var$load("e6e7M"),
    $97a3324273ff0607$var$load("kYIpq"),
    $97a3324273ff0607$var$load("4fYzp"),
    $97a3324273ff0607$var$load("423w4")
]).then(()=>parcelRequire('bDmGo'));

});

parcelRegister("kJp2Z", function(module, exports) {

let $f17b7073c52a3f72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f17b7073c52a3f72$var$load("9lUu8"),
    $f17b7073c52a3f72$var$load("cOFDc"),
    $f17b7073c52a3f72$var$load("j98o0")
]).then(()=>parcelRequire('dlYPV'));

});

parcelRegister("eOW3x", function(module, exports) {

let $aca2c4f1ace949bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aca2c4f1ace949bc$var$load("kaFPr").then(()=>parcelRequire('2C4l7'));

});

parcelRegister("dWfBt", function(module, exports) {
const $3252933457ee5bfd$export$1c3a7fb1674ebcd2 = 'adminApplicationNavigator';
const $3252933457ee5bfd$export$59e8eaf2c1cf7d28 = '/admin/application-navigator';
module.exports["ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE"] = $3252933457ee5bfd$export$1c3a7fb1674ebcd2;

});

parcelRegister("bz3UX", function(module, exports) {

let $86b6008e69f92e26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86b6008e69f92e26$var$load("f4DD6").then(()=>parcelRequire('6JHmj'));

});

parcelRegister("9JmJC", function(module, exports) {
const $3381874ada981275$export$4ad87fa408071f9e = 'adminMacroUsage';
module.exports["ADMIN_MACRO_USAGE_ANALYTICS_SOURCE"] = $3381874ada981275$export$4ad87fa408071f9e;

});

parcelRegister("4pKXe", function(module, exports) {

let $336deb6275ba373e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $336deb6275ba373e$var$load("6wr18"),
    $336deb6275ba373e$var$load("ffEVr"),
    $336deb6275ba373e$var$load("3YiRE")
]).then(()=>parcelRequire('iR5x9'));

});

parcelRegister("4l9JY", function(module, exports) {
// Server expects the "after" parameter as a string index
const $bd0500c03ad06aff$export$eb9c69e3a09b9217 = '-1';
const $bd0500c03ad06aff$export$5716e8bcb003888d = 20;
const $bd0500c03ad06aff$export$717a6bceadab3608 = 'trashed';
const $bd0500c03ad06aff$export$ee14340141c11674 = 5000;
const $bd0500c03ad06aff$export$43b26519b9b8a3e = 'adminTrashedSpaces';
module.exports["DEFAULT_START_INDEX"] = $bd0500c03ad06aff$export$eb9c69e3a09b9217;
module.exports["DEFAULT_PAGE_SIZE"] = $bd0500c03ad06aff$export$5716e8bcb003888d;
module.exports["SPACE_STATUS_TRASHED"] = $bd0500c03ad06aff$export$717a6bceadab3608;
module.exports["POLL_INTERVAL_MS"] = $bd0500c03ad06aff$export$ee14340141c11674;
module.exports["ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE"] = $bd0500c03ad06aff$export$43b26519b9b8a3e;

});

parcelRegister("gGU1v", function(module, exports) {

let $c26c06a33d9c5ed3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c26c06a33d9c5ed3$var$load("4fYzp"),
    $c26c06a33d9c5ed3$var$load("iOJdB")
]).then(()=>parcelRequire('452sv'));

});

parcelRegister("434W4", function(module, exports) {
// XMLs or CSVs should be in a zip file
const $b6c44f979bbed03e$export$417e5fe1d0de6e47 = [
    '.zip'
];
const $b6c44f979bbed03e$export$42f152cabc617ec2 = 1500;
const $b6c44f979bbed03e$export$5f9abcd3ce58c0ab = 'adminImportSpaces';
const $b6c44f979bbed03e$export$61387ee612136e90 = 300000;
const $b6c44f979bbed03e$export$9e3220b2979f5262 = 'https://marketplace.atlassian.com/apps/1219672/cloud-migration-assistant-for-confluence';
const $b6c44f979bbed03e$export$ebe1d3a4348867c4 = 'https://confluence.atlassian.com/doc/export-content-to-word-pdf-html-and-xml-139475.html#ExportContenttoWord,PDF,HTMLandXML-ExportmultiplepagestoHTML,XML,orPDF';
module.exports["ALLOWED_FILE_EXTENSIONS"] = $b6c44f979bbed03e$export$417e5fe1d0de6e47;
module.exports["IMPORT_STATUS_CHECK_POLL_INTERVAL_MS"] = $b6c44f979bbed03e$export$42f152cabc617ec2;
module.exports["ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE"] = $b6c44f979bbed03e$export$5f9abcd3ce58c0ab;
module.exports["MEDIA_AUTH_PROVIDER_FIVE_MIN_TIMEOUT"] = $b6c44f979bbed03e$export$61387ee612136e90;
module.exports["CLOUD_MIGRATION_ASSISTANT_LINK"] = $b6c44f979bbed03e$export$9e3220b2979f5262;
module.exports["EXPORT_HELP_LINK"] = $b6c44f979bbed03e$export$ebe1d3a4348867c4;

});

parcelRegister("iMgCe", function(module, exports) {

let $dab9993526fb29f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dab9993526fb29f0$var$load("4Z5Uh").then(()=>parcelRequire('f10rR'));

});

parcelRegister("2i0P8", function(module, exports) {
const $ffc87555304a609f$export$8b897d36b093ccf1 = 'adminJiraMacroRepair';
const $ffc87555304a609f$export$ee14340141c11674 = 1000;
const $ffc87555304a609f$export$765b83ed862a0ed = '/wiki/plugins/servlet/applinks/listApplicationLinks';
module.exports["ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE"] = $ffc87555304a609f$export$8b897d36b093ccf1;
module.exports["POLL_INTERVAL_MS"] = $ffc87555304a609f$export$ee14340141c11674;
module.exports["APP_LINKS_URL"] = $ffc87555304a609f$export$765b83ed862a0ed;

});

parcelRegister("bKpjI", function(module, exports) {

let $88d7a10176ff8e11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88d7a10176ff8e11$var$load("6KDUv").then(()=>parcelRequire('iiqL3'));

});

parcelRegister("ft9Jc", function(module, exports) {
const $5b008143e5994a1d$export$5b9a48b5dd6a4ea2 = 'adminThemes';
module.exports["ADMIN_THEMES_ANALYTICS_SOURCE"] = $5b008143e5994a1d$export$5b9a48b5dd6a4ea2;

});

parcelRegister("9lL6v", function(module, exports) {

let $6cea9d196da14ab4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6cea9d196da14ab4$var$load("Wowvf"),
    $6cea9d196da14ab4$var$load("37ldp"),
    $6cea9d196da14ab4$var$load("9BxhS")
]).then(()=>parcelRequire('5JXtG'));

});

parcelRegister("fmC2G", function(module, exports) {
const $2d4e85d5268f55f9$export$546ba186ec91e3c9 = 'adminPdfExport';
const $2d4e85d5268f55f9$export$dec669626e46bbfe = 'https://support.atlassian.com/confluence-cloud/docs/customize-exports-to-pdf/';
module.exports["ADMIN_PDF_EXPORT_ANALYTICS_SOURCE"] = $2d4e85d5268f55f9$export$546ba186ec91e3c9;
module.exports["STYLESHEET_SUPPORT_DOC_URL"] = $2d4e85d5268f55f9$export$dec669626e46bbfe;

});

parcelRegister("iccOf", function(module, exports) {

let $d3f348a7d9e2b86b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3f348a7d9e2b86b$var$load("56MKu"),
    $d3f348a7d9e2b86b$var$load("6mLKo")
]).then(()=>parcelRequire('jmxIE'));

});

parcelRegister("8Nhaa", function(module, exports) {
const $1ede882b6a23a4b1$export$fa5f102b28968fd8 = 'spaceManager';
module.exports["SPACE_MANAGER_ANALYTICS_SOURCE"] = $1ede882b6a23a4b1$export$fa5f102b28968fd8;

});

parcelRegister("iaCjK", function(module, exports) {

let $d3a6e23c27c334db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3a6e23c27c334db$var$load("iLTLW"),
    $d3a6e23c27c334db$var$load("e6e7M"),
    $d3a6e23c27c334db$var$load("2YlyO")
]).then(()=>parcelRequire('753aK'));

});

parcelRegister("LmgJF", function(module, exports) {

let $08e5aa0bcab85e1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $08e5aa0bcab85e1d$var$load("8Uf6n"),
    $08e5aa0bcab85e1d$var$load("1atBh"),
    $08e5aa0bcab85e1d$var$load("lK4Zk"),
    $08e5aa0bcab85e1d$var$load("aGTsr"),
    $08e5aa0bcab85e1d$var$load("68wXf"),
    $08e5aa0bcab85e1d$var$load("2gKO4"),
    $08e5aa0bcab85e1d$var$load("j104l"),
    $08e5aa0bcab85e1d$var$load("7CYB9"),
    $08e5aa0bcab85e1d$var$load("fjOTL"),
    $08e5aa0bcab85e1d$var$load("7EorR"),
    $08e5aa0bcab85e1d$var$load("1GCFv"),
    $08e5aa0bcab85e1d$var$load("5DjNv"),
    $08e5aa0bcab85e1d$var$load("bo7iw"),
    $08e5aa0bcab85e1d$var$load("4fYzp"),
    $08e5aa0bcab85e1d$var$load("lFAez"),
    $08e5aa0bcab85e1d$var$load("1qlDN"),
    $08e5aa0bcab85e1d$var$load("1yVM6"),
    $08e5aa0bcab85e1d$var$load("cEqm7"),
    $08e5aa0bcab85e1d$var$load("6XCf4"),
    $08e5aa0bcab85e1d$var$load("6gpUD")
]).then(()=>parcelRequire('dTw2J'));

});

parcelRegister("d73E7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $61e340fdd81a37ab$export$eb67fd6afe5bdfc8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "X7rQv",
    name: "WhiteboardRouteComponentLoader",
    loader: ()=>(parcelRequire("79uWH"))
});
module.exports["WhiteboardRouteComponentLoader"] = $61e340fdd81a37ab$export$eb67fd6afe5bdfc8;

});

parcelRegister("79uWH", function(module, exports) {

let $535160db0a330217$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $535160db0a330217$var$load("h3ABO"),
    $535160db0a330217$var$load("jPzkK"),
    $535160db0a330217$var$load("7HPPR"),
    $535160db0a330217$var$load("bzyKp"),
    $535160db0a330217$var$load("k3yUD"),
    $535160db0a330217$var$load("7U84Z"),
    $535160db0a330217$var$load("jPuvo"),
    $535160db0a330217$var$load("jLwPS"),
    $535160db0a330217$var$load("9IMTL"),
    $535160db0a330217$var$load("coUzl"),
    $535160db0a330217$var$load("5nMTY"),
    $535160db0a330217$var$load("9yJxD"),
    $535160db0a330217$var$load("eM4bT"),
    $535160db0a330217$var$load("dy59R"),
    $535160db0a330217$var$load("FHgFh"),
    $535160db0a330217$var$load("i6s2m"),
    $535160db0a330217$var$load("dwSiO"),
    $535160db0a330217$var$load("bNW8r"),
    $535160db0a330217$var$load("HaNwW"),
    $535160db0a330217$var$load("4oONP"),
    $535160db0a330217$var$load("cmqxT"),
    $535160db0a330217$var$load("l5It5"),
    $535160db0a330217$var$load("67Alm"),
    $535160db0a330217$var$load("2B2rM"),
    $535160db0a330217$var$load("7bkye"),
    $535160db0a330217$var$load("35X59"),
    $535160db0a330217$var$load("2F69B"),
    $535160db0a330217$var$load("9anPW"),
    $535160db0a330217$var$load("lFAez"),
    $535160db0a330217$var$load("1qlDN"),
    $535160db0a330217$var$load("1yVM6"),
    $535160db0a330217$var$load("fAtWn"),
    $535160db0a330217$var$load("iPYAE"),
    $535160db0a330217$var$load("cyGuT"),
    $535160db0a330217$var$load("9DBoM"),
    $535160db0a330217$var$load("5lTVp"),
    $535160db0a330217$var$load("lWNY8"),
    $535160db0a330217$var$load("h9S8v"),
    $535160db0a330217$var$load("6wr18"),
    $535160db0a330217$var$load("5dkX4"),
    $535160db0a330217$var$load("e2WH6"),
    $535160db0a330217$var$load("ffEVr"),
    $535160db0a330217$var$load("a0cZb"),
    $535160db0a330217$var$load("RXMWr"),
    $535160db0a330217$var$load("7j0mT"),
    $535160db0a330217$var$load("69R9L"),
    $535160db0a330217$var$load("zSp86"),
    $535160db0a330217$var$load("g0OKa"),
    $535160db0a330217$var$load("Wowvf"),
    $535160db0a330217$var$load("1F7LX"),
    $535160db0a330217$var$load("c6DIp"),
    $535160db0a330217$var$load("dgH7p"),
    $535160db0a330217$var$load("jZLnv"),
    $535160db0a330217$var$load("6edij"),
    $535160db0a330217$var$load("hXbzh"),
    $535160db0a330217$var$load("foAs3"),
    $535160db0a330217$var$load("hhss7"),
    $535160db0a330217$var$load("7EorR"),
    $535160db0a330217$var$load("h94bv"),
    $535160db0a330217$var$load("jZkQK")
]).then(()=>parcelRequire('ib0d9'));

});

parcelRegister("jwuij", function(module, exports) {

let $e368814ebed5f47d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e368814ebed5f47d$var$load("d62hC"),
    $e368814ebed5f47d$var$load("1GCFv"),
    $e368814ebed5f47d$var$load("gLWJk")
]).then(()=>parcelRequire('5Idyr'));

});

parcelRegister("hMroJ", function(module, exports) {

let $cf1c2c054ee3ada6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cf1c2c054ee3ada6$var$load("4De00"),
    $cf1c2c054ee3ada6$var$load("d62hC"),
    $cf1c2c054ee3ada6$var$load("bGqrb"),
    $cf1c2c054ee3ada6$var$load("6tsCm"),
    $cf1c2c054ee3ada6$var$load("6kcCF"),
    $cf1c2c054ee3ada6$var$load("9V1vV"),
    $cf1c2c054ee3ada6$var$load("i6s2m"),
    $cf1c2c054ee3ada6$var$load("bNW8r"),
    $cf1c2c054ee3ada6$var$load("4oONP"),
    $cf1c2c054ee3ada6$var$load("bDfgb"),
    $cf1c2c054ee3ada6$var$load("lUFbG"),
    $cf1c2c054ee3ada6$var$load("Wowvf"),
    $cf1c2c054ee3ada6$var$load("dtpmo"),
    $cf1c2c054ee3ada6$var$load("35X59"),
    $cf1c2c054ee3ada6$var$load("2F69B"),
    $cf1c2c054ee3ada6$var$load("3g3jg"),
    $cf1c2c054ee3ada6$var$load("1GCFv"),
    $cf1c2c054ee3ada6$var$load("bRqDI"),
    $cf1c2c054ee3ada6$var$load("4fYzp"),
    $cf1c2c054ee3ada6$var$load("6wr18"),
    $cf1c2c054ee3ada6$var$load("7EorR"),
    $cf1c2c054ee3ada6$var$load("5dkX4"),
    $cf1c2c054ee3ada6$var$load("9lUu8"),
    $cf1c2c054ee3ada6$var$load("hhss7"),
    $cf1c2c054ee3ada6$var$load("ffEVr"),
    $cf1c2c054ee3ada6$var$load("e2WH6"),
    $cf1c2c054ee3ada6$var$load("h94bv"),
    $cf1c2c054ee3ada6$var$load("iOr1f")
]).then(()=>parcelRequire('58rkb'));

});

parcelRegister("2x0sL", function(module, exports) {

let $1d7f05ca52ae687d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d7f05ca52ae687d$var$load("d62hC"),
    $1d7f05ca52ae687d$var$load("bGqrb"),
    $1d7f05ca52ae687d$var$load("6tsCm"),
    $1d7f05ca52ae687d$var$load("6kcCF"),
    $1d7f05ca52ae687d$var$load("9V1vV"),
    $1d7f05ca52ae687d$var$load("i6s2m"),
    $1d7f05ca52ae687d$var$load("bNW8r"),
    $1d7f05ca52ae687d$var$load("4oONP"),
    $1d7f05ca52ae687d$var$load("lUFbG"),
    $1d7f05ca52ae687d$var$load("bGpE6"),
    $1d7f05ca52ae687d$var$load("4RbVd"),
    $1d7f05ca52ae687d$var$load("4rv8V"),
    $1d7f05ca52ae687d$var$load("gufL1"),
    $1d7f05ca52ae687d$var$load("hXbzh"),
    $1d7f05ca52ae687d$var$load("Wowvf"),
    $1d7f05ca52ae687d$var$load("7j0mT"),
    $1d7f05ca52ae687d$var$load("69R9L"),
    $1d7f05ca52ae687d$var$load("c0JsV"),
    $1d7f05ca52ae687d$var$load("dtpmo"),
    $1d7f05ca52ae687d$var$load("35X59"),
    $1d7f05ca52ae687d$var$load("2F69B"),
    $1d7f05ca52ae687d$var$load("3g3jg"),
    $1d7f05ca52ae687d$var$load("1GCFv"),
    $1d7f05ca52ae687d$var$load("bRqDI"),
    $1d7f05ca52ae687d$var$load("4fYzp"),
    $1d7f05ca52ae687d$var$load("6wr18"),
    $1d7f05ca52ae687d$var$load("7EorR"),
    $1d7f05ca52ae687d$var$load("5dkX4"),
    $1d7f05ca52ae687d$var$load("9lUu8"),
    $1d7f05ca52ae687d$var$load("hhss7"),
    $1d7f05ca52ae687d$var$load("ffEVr"),
    $1d7f05ca52ae687d$var$load("e2WH6"),
    $1d7f05ca52ae687d$var$load("h94bv"),
    $1d7f05ca52ae687d$var$load("kZzff")
]).then(()=>parcelRequire('2rALa'));

});

parcelRegister("6Bq28", function(module, exports) {

let $4cea647e5f294b76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4cea647e5f294b76$var$load("jPzkK"),
    $4cea647e5f294b76$var$load("9DBoM"),
    $4cea647e5f294b76$var$load("9yJxD"),
    $4cea647e5f294b76$var$load("d62hC"),
    $4cea647e5f294b76$var$load("1be0X"),
    $4cea647e5f294b76$var$load("aCwOt"),
    $4cea647e5f294b76$var$load("bGqrb"),
    $4cea647e5f294b76$var$load("6tsCm"),
    $4cea647e5f294b76$var$load("6kcCF"),
    $4cea647e5f294b76$var$load("9V1vV"),
    $4cea647e5f294b76$var$load("i6s2m"),
    $4cea647e5f294b76$var$load("bNW8r"),
    $4cea647e5f294b76$var$load("8LtYa"),
    $4cea647e5f294b76$var$load("diyjB"),
    $4cea647e5f294b76$var$load("4oONP"),
    $4cea647e5f294b76$var$load("lUFbG"),
    $4cea647e5f294b76$var$load("Wowvf"),
    $4cea647e5f294b76$var$load("67Alm"),
    $4cea647e5f294b76$var$load("9nwFZ"),
    $4cea647e5f294b76$var$load("2B2rM"),
    $4cea647e5f294b76$var$load("dtpmo"),
    $4cea647e5f294b76$var$load("35X59"),
    $4cea647e5f294b76$var$load("2F69B"),
    $4cea647e5f294b76$var$load("3g3jg"),
    $4cea647e5f294b76$var$load("1GCFv"),
    $4cea647e5f294b76$var$load("bRqDI"),
    $4cea647e5f294b76$var$load("4fYzp"),
    $4cea647e5f294b76$var$load("7gkvG"),
    $4cea647e5f294b76$var$load("6wr18"),
    $4cea647e5f294b76$var$load("7EorR"),
    $4cea647e5f294b76$var$load("5dkX4"),
    $4cea647e5f294b76$var$load("9lUu8"),
    $4cea647e5f294b76$var$load("hhss7"),
    $4cea647e5f294b76$var$load("ffEVr"),
    $4cea647e5f294b76$var$load("e2WH6"),
    $4cea647e5f294b76$var$load("h94bv"),
    $4cea647e5f294b76$var$load("bT0I9")
]).then(()=>parcelRequire('1hCZf'));

});

parcelRegister("bwC5h", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $4b4iP = parcelRequire("4b4iP");

const $864039964f3f4398$var$SpaceRestriction = ({ spaceKey: spaceKey, contentId: contentId, children: children })=>{
    if (!spaceKey) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        contentId: contentId
    }, children);
};
$864039964f3f4398$var$SpaceRestriction.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node.isRequired
};
var $864039964f3f4398$export$2e2bcd8739ae039 = $864039964f3f4398$var$SpaceRestriction;
module.exports["default"] = $864039964f3f4398$export$2e2bcd8739ae039;

});

parcelRegister("epBQg", function(module, exports) {

let $a7e0c1217d89d0a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7e0c1217d89d0a4$var$load("hmUGS").then(()=>parcelRequire('1azj7'));

});

parcelRegister("iufgB", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ef29e49aacc3ecbc$export$80e55c7cff6cb8a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "IPyzb",
    name: "CreateContentRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("9DVBe"))).CreateContentRouteComponentWrapper
});
module.exports["CreateContentRouteComponentLoader"] = $ef29e49aacc3ecbc$export$80e55c7cff6cb8a;

});

parcelRegister("9DVBe", function(module, exports) {

let $70546f9fa1c8f1f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $70546f9fa1c8f1f0$var$load("7PNQN"),
    $70546f9fa1c8f1f0$var$load("h94bv"),
    $70546f9fa1c8f1f0$var$load("ghNAx"),
    $70546f9fa1c8f1f0$var$load("6GIKD"),
    $70546f9fa1c8f1f0$var$load("c6DIp"),
    $70546f9fa1c8f1f0$var$load("dgH7p"),
    $70546f9fa1c8f1f0$var$load("jZLnv"),
    $70546f9fa1c8f1f0$var$load("6edij"),
    $70546f9fa1c8f1f0$var$load("hXbzh"),
    $70546f9fa1c8f1f0$var$load("6wr18"),
    $70546f9fa1c8f1f0$var$load("loo2r"),
    $70546f9fa1c8f1f0$var$load("gbDLp"),
    $70546f9fa1c8f1f0$var$load("8YSo7"),
    $70546f9fa1c8f1f0$var$load("4NdV5"),
    $70546f9fa1c8f1f0$var$load("Wowvf"),
    $70546f9fa1c8f1f0$var$load("36QeB"),
    $70546f9fa1c8f1f0$var$load("ffEVr"),
    $70546f9fa1c8f1f0$var$load("lbsQO"),
    $70546f9fa1c8f1f0$var$load("jLwPS"),
    $70546f9fa1c8f1f0$var$load("9IMTL"),
    $70546f9fa1c8f1f0$var$load("7j0mT"),
    $70546f9fa1c8f1f0$var$load("69R9L"),
    $70546f9fa1c8f1f0$var$load("zSp86"),
    $70546f9fa1c8f1f0$var$load("kuFG2"),
    $70546f9fa1c8f1f0$var$load("7tgvK"),
    $70546f9fa1c8f1f0$var$load("g0OKa"),
    $70546f9fa1c8f1f0$var$load("hhss7"),
    $70546f9fa1c8f1f0$var$load("7EorR"),
    $70546f9fa1c8f1f0$var$load("lrKPf")
]).then(()=>parcelRequire('79aVL'));

});

parcelRegister("6CEg5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $9eE57 = parcelRequire("9eE57");

class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $42omo.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};
module.exports["PerformanceStart"] = $dc6daeb5b2d3b455$export$616e8efc277d5c6;

});

parcelRegister("bNQ52", function(module, exports) {

let $897cab626435179c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $897cab626435179c$var$load("6wr18"),
    $897cab626435179c$var$load("ffEVr"),
    $897cab626435179c$var$load("8VHGu")
]).then(()=>parcelRequire('7mbVv'));

});

parcelRegister("ko9Ek", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4cd8f2daf274114d$export$2312ebab360877df = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HinAE",
    // Name is used in next/packages/view-page/src/index.ts must match
    name: "ViewPageRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("k7ap5"))).ViewPageRouteComponent
});
module.exports["ViewPageRouteComponentLoader"] = $4cd8f2daf274114d$export$2312ebab360877df;

});

parcelRegister("k7ap5", function(module, exports) {

let $ea4c88067eb8a07c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ea4c88067eb8a07c$var$load("h3ABO"),
    $ea4c88067eb8a07c$var$load("5iZqi"),
    $ea4c88067eb8a07c$var$load("2YffH"),
    $ea4c88067eb8a07c$var$load("6kcCF"),
    $ea4c88067eb8a07c$var$load("2LxnN"),
    $ea4c88067eb8a07c$var$load("e2ahM"),
    $ea4c88067eb8a07c$var$load("5Wqrg"),
    $ea4c88067eb8a07c$var$load("HaNwW"),
    $ea4c88067eb8a07c$var$load("evm5a"),
    $ea4c88067eb8a07c$var$load("c6VA1"),
    $ea4c88067eb8a07c$var$load("2MTmD"),
    $ea4c88067eb8a07c$var$load("hOBst"),
    $ea4c88067eb8a07c$var$load("bzyKp"),
    $ea4c88067eb8a07c$var$load("k3yUD"),
    $ea4c88067eb8a07c$var$load("2RWyc"),
    $ea4c88067eb8a07c$var$load("fAtWn"),
    $ea4c88067eb8a07c$var$load("iPYAE"),
    $ea4c88067eb8a07c$var$load("cyGuT"),
    $ea4c88067eb8a07c$var$load("3KVI3"),
    $ea4c88067eb8a07c$var$load("5lTVp"),
    $ea4c88067eb8a07c$var$load("lWNY8"),
    $ea4c88067eb8a07c$var$load("6wr18"),
    $ea4c88067eb8a07c$var$load("h9S8v"),
    $ea4c88067eb8a07c$var$load("jPuvo"),
    $ea4c88067eb8a07c$var$load("3GuOt"),
    $ea4c88067eb8a07c$var$load("ffEVr"),
    $ea4c88067eb8a07c$var$load("hxmLu"),
    $ea4c88067eb8a07c$var$load("1oUEV"),
    $ea4c88067eb8a07c$var$load("i065F"),
    $ea4c88067eb8a07c$var$load("eIWkK"),
    $ea4c88067eb8a07c$var$load("a0cZb"),
    $ea4c88067eb8a07c$var$load("RXMWr"),
    $ea4c88067eb8a07c$var$load("jLwPS"),
    $ea4c88067eb8a07c$var$load("9IMTL"),
    $ea4c88067eb8a07c$var$load("5dBst"),
    $ea4c88067eb8a07c$var$load("70IPm"),
    $ea4c88067eb8a07c$var$load("6GIKD"),
    $ea4c88067eb8a07c$var$load("2Ws5B"),
    $ea4c88067eb8a07c$var$load("coUzl"),
    $ea4c88067eb8a07c$var$load("5nMTY"),
    $ea4c88067eb8a07c$var$load("fRtVQ"),
    $ea4c88067eb8a07c$var$load("b9CA3"),
    $ea4c88067eb8a07c$var$load("g0OKa"),
    $ea4c88067eb8a07c$var$load("Wowvf"),
    $ea4c88067eb8a07c$var$load("1F7LX"),
    $ea4c88067eb8a07c$var$load("c6DIp"),
    $ea4c88067eb8a07c$var$load("dgH7p"),
    $ea4c88067eb8a07c$var$load("hH53H"),
    $ea4c88067eb8a07c$var$load("7j0mT"),
    $ea4c88067eb8a07c$var$load("69R9L"),
    $ea4c88067eb8a07c$var$load("zSp86"),
    $ea4c88067eb8a07c$var$load("7tgvK"),
    $ea4c88067eb8a07c$var$load("jZLnv"),
    $ea4c88067eb8a07c$var$load("6edij"),
    $ea4c88067eb8a07c$var$load("aDgIB"),
    $ea4c88067eb8a07c$var$load("hXbzh"),
    $ea4c88067eb8a07c$var$load("foAs3"),
    $ea4c88067eb8a07c$var$load("hhss7"),
    $ea4c88067eb8a07c$var$load("f2Ovh"),
    $ea4c88067eb8a07c$var$load("lAHER"),
    $ea4c88067eb8a07c$var$load("7EorR"),
    $ea4c88067eb8a07c$var$load("h94bv"),
    $ea4c88067eb8a07c$var$load("2dt2D")
]).then(()=>parcelRequire('bkGU6'));

});

parcelRegister("4D2qK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d5ef270b375fd8a7$export$9a7f1112e3576698 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Nmdfv",
    name: "ViewPageLiteLoader",
    loader: async ()=>(await (parcelRequire("ibAqx"))).ViewPageLite
});
module.exports["ViewPageLiteLoader"] = $d5ef270b375fd8a7$export$9a7f1112e3576698;

});

parcelRegister("ibAqx", function(module, exports) {

let $d3d582b83484090e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3d582b83484090e$var$load("h3ABO"),
    $d3d582b83484090e$var$load("h94bv"),
    $d3d582b83484090e$var$load("eIWkK"),
    $d3d582b83484090e$var$load("6GIKD"),
    $d3d582b83484090e$var$load("g0OKa"),
    $d3d582b83484090e$var$load("5gRHV"),
    $d3d582b83484090e$var$load("d62hC"),
    $d3d582b83484090e$var$load("jPzkK"),
    $d3d582b83484090e$var$load("cIKpa"),
    $d3d582b83484090e$var$load("bNW8r"),
    $d3d582b83484090e$var$load("dlm6q"),
    $d3d582b83484090e$var$load("4oONP"),
    $d3d582b83484090e$var$load("dtpmo"),
    $d3d582b83484090e$var$load("1GCFv"),
    $d3d582b83484090e$var$load("fAtWn"),
    $d3d582b83484090e$var$load("iPYAE"),
    $d3d582b83484090e$var$load("5lTVp"),
    $d3d582b83484090e$var$load("lWNY8"),
    $d3d582b83484090e$var$load("h9S8v"),
    $d3d582b83484090e$var$load("5dkX4"),
    $d3d582b83484090e$var$load("el56J"),
    $d3d582b83484090e$var$load("9lUu8"),
    $d3d582b83484090e$var$load("e2WH6"),
    $d3d582b83484090e$var$load("5vzT0"),
    $d3d582b83484090e$var$load("a0cZb"),
    $d3d582b83484090e$var$load("RXMWr"),
    $d3d582b83484090e$var$load("fRtVQ"),
    $d3d582b83484090e$var$load("coUzl"),
    $d3d582b83484090e$var$load("5nMTY"),
    $d3d582b83484090e$var$load("7j0mT"),
    $d3d582b83484090e$var$load("69R9L"),
    $d3d582b83484090e$var$load("hXbzh"),
    $d3d582b83484090e$var$load("6wr18"),
    $d3d582b83484090e$var$load("dwSiO"),
    $d3d582b83484090e$var$load("evP3v"),
    $d3d582b83484090e$var$load("HaNwW"),
    $d3d582b83484090e$var$load("cmqxT"),
    $d3d582b83484090e$var$load("ZBVfs"),
    $d3d582b83484090e$var$load("4oXMS"),
    $d3d582b83484090e$var$load("67Alm"),
    $d3d582b83484090e$var$load("2B2rM"),
    $d3d582b83484090e$var$load("9anPW"),
    $d3d582b83484090e$var$load("cyGuT"),
    $d3d582b83484090e$var$load("9DBoM"),
    $d3d582b83484090e$var$load("jPuvo"),
    $d3d582b83484090e$var$load("ffEVr"),
    $d3d582b83484090e$var$load("zSp86"),
    $d3d582b83484090e$var$load("Wowvf"),
    $d3d582b83484090e$var$load("1F7LX"),
    $d3d582b83484090e$var$load("foAs3"),
    $d3d582b83484090e$var$load("hhss7"),
    $d3d582b83484090e$var$load("7EorR"),
    $d3d582b83484090e$var$load("1gUNx"),
    $d3d582b83484090e$var$load("eiF7i"),
    $d3d582b83484090e$var$load("h9zFU")
]).then(()=>parcelRequire('kcroh'));

});

parcelRegister("grnbw", function(module, exports) {

let $bf8126fd754f52a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf8126fd754f52a0$var$load("lRtGG"),
    $bf8126fd754f52a0$var$load("7Xau5")
]).then(()=>parcelRequire('aUago'));

});

parcelRegister("8pBIa", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("6Evf5")).default);

var $6Evf5 = parcelRequire("6Evf5");


});

parcelRegister("6Evf5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $ep3mz = parcelRequire("ep3mz");


var $hl1Kw = parcelRequire("hl1Kw");


var $3GP6F = parcelRequire("3GP6F");


var $aeLio = parcelRequire("aeLio");


var $jMyy4 = parcelRequire("jMyy4");

parcelRequire("hAOSI");
var $9LzHv = parcelRequire("9LzHv");


var $fJp8a = parcelRequire("fJp8a");

const $4d7eb68e35a8590f$var$dayInMilliseconds = 86400000; // hours*minutes*seconds*milliseconds
const $4d7eb68e35a8590f$var$NO_DATE_DEFINED = -1;
const $4d7eb68e35a8590f$var$ARCHIVED = 'archived';
const $4d7eb68e35a8590f$export$10ab27af88aafb56 = (pastDateStr, currentDate = new Date())=>{
    const pastDate = new Date(pastDateStr);
    // days since creation
    return Math.round((currentDate.getTime() - pastDate.getTime()) / $4d7eb68e35a8590f$var$dayInMilliseconds);
};
const $4d7eb68e35a8590f$var$_getDaysSinceCreated = (node)=>{
    const createdDateStr = node?.history?.createdDate;
    return createdDateStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(createdDateStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$var$_getDaysSinceUpdated = (node)=>{
    const lastUpdatedStr = node?.history?.lastUpdated?.when;
    return lastUpdatedStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(lastUpdatedStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$export$f8668f0d8d89d19c = (currentDate = new Date())=>{
    const hours = currentDate.getHours();
    return hours >= 15 && hours <= 23;
};
const $4d7eb68e35a8590f$export$35de754c0b3b58bd = ()=>{
    if (document && document.visibilityState) return document.visibilityState;
    return 'unset';
};
const $4d7eb68e35a8590f$var$SendTrackViewPageEvent = ({ pageType: pageType, source: source = 'viewPageScreen' })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const featureCodes = (0, $3GP6F.useFeatureCodesInURL)();
    const commentLink = (0, $aeLio.useGetCommentLinkType)();
    const lastFiredKeyRef = (0, $42omo.useRef)(null);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $fJp8a.default), {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence-classic/confluence-frontend-server"
    });
    const space = data?.content?.nodes?.[0]?.space;
    const fabricEditorSupported = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorSupported;
    const fabricEditorEligibility = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorEligibility;
    if (error || loading || !space) return null;
    const dedupeKey = `${source}:${contentId}`;
    if (lastFiredKeyRef.current === dedupeKey) return null;
    lastFiredKeyRef.current = dedupeKey;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9LzHv.default), {
        action: "viewed",
        actionSubject: "page",
        source: source,
        containerType: "space",
        containerId: space.id,
        objectType: "page",
        objectId: contentId,
        attributes: {
            pageType: pageType,
            daysSinceCreated: $4d7eb68e35a8590f$var$_getDaysSinceCreated(data.content.nodes[0]),
            daysSinceModified: $4d7eb68e35a8590f$var$_getDaysSinceUpdated(data.content.nodes[0]),
            searchReferrer: searchSessionId,
            ...additionalAnalytics,
            isArchivedPage: data.content.nodes[0].status === $4d7eb68e35a8590f$var$ARCHIVED,
            viewedScreenAfter3PM: $4d7eb68e35a8590f$export$f8668f0d8d89d19c(),
            pageVisibility: $4d7eb68e35a8590f$export$35de754c0b3b58bd(),
            fabricEditorEligibility: fabricEditorEligibility,
            fabricEditorSupported: fabricEditorSupported,
            ...featureCodes && featureCodes.from ? {
                from: featureCodes.from
            } : {},
            ...commentLink && {
                commentLink: commentLink
            }
        }
    });
};
$4d7eb68e35a8590f$var$SendTrackViewPageEvent.propTypes = {
    pageType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'page',
        'blogpost'
    ]),
    source: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'viewPageScreen',
        'mobileWebView'
    ])
};
var $4d7eb68e35a8590f$export$2e2bcd8739ae039 = $4d7eb68e35a8590f$var$SendTrackViewPageEvent;
module.exports["default"] = $4d7eb68e35a8590f$export$2e2bcd8739ae039;

});

parcelRegister("3GP6F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");




const $9bc3195b956679d5$export$eddc138581adbc11 = ()=>{
    const history = (0, $dPJCf.useHistory)();
    const location = (0, $QU6QS.useLocation)();
    const queryParams = location?.search;
    const queryParamsFeatureCodes = (0, $lpPVE.getFeatureCodes)(new URLSearchParams(queryParams));
    const [featureCodes, setFeatureCodes] = (0, $42omo.useState)(queryParamsFeatureCodes);
    (0, $42omo.useEffect)(()=>{
        if (queryParams && queryParams.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
            setFeatureCodes(queryParamsFeatureCodes);
            (0, $lpPVE.hideFeatureCodesQueryParam)(history, location);
        }
    }, [
        history,
        location,
        queryParams,
        queryParamsFeatureCodes
    ]);
    return featureCodes;
};
module.exports["useFeatureCodesInURL"] = $9bc3195b956679d5$export$eddc138581adbc11;

});

parcelRegister("lpPVE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    FeatureCode["SEND_TO_DESKTOP_EMAIL"] = "SNDDSKEML";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("aeLio", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");

const $741319b101f491d9$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $741319b101f491d9$var$useReplyToCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $741319b101f491d9$export$f4b5305c973a36dc = ()=>{
    const focusedCommentId = $741319b101f491d9$var$useFocusedCommentIdQueryParam();
    const replyToCommentId = $741319b101f491d9$var$useReplyToCommentIdQueryParam();
    if (focusedCommentId) return 'isFocusedComment';
    else if (replyToCommentId) return 'isReplyToComment';
    return undefined;
};
module.exports["useGetCommentLinkType"] = $741319b101f491d9$export$f4b5305c973a36dc;

});

parcelRegister("hAOSI", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("9LzHv")).default);

var $9LzHv = parcelRequire("9LzHv");


});

parcelRegister("9LzHv", function(module, exports) {
$parcel$export(module.exports, "default", () => $71c43243f3d11279$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $1DWH0 = parcelRequire("1DWH0");

const $71c43243f3d11279$var$sendTrackEvent = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const analyticsData = {
        action: props.action,
        actionSubject: props.actionSubject,
        attributes: props.attributes,
        containerId: props.containerId,
        containerType: props.containerType,
        objectId: props.objectId,
        objectType: props.objectType,
        source: props.source
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: analyticsData
    });
    analyticsEvent.fire();
};
function $71c43243f3d11279$var$SendTrackEventComponent(props) {
    const { action: action, actionSubject: actionSubject, attributes: attributes = {}, containerId: containerId, containerType: containerType, objectId: objectId, objectType: objectType, source: source } = props;
    (0, $42omo.useEffect)(()=>{
        $71c43243f3d11279$var$sendTrackEvent({
            ...props,
            attributes: attributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        action,
        actionSubject,
        attributes,
        containerId,
        containerType,
        objectId,
        objectType,
        source
    ]);
    return null;
}
$71c43243f3d11279$var$SendTrackEventComponent.propTypes = {
    action: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    actionSubject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    containerId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    containerType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    objectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    objectType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
var $71c43243f3d11279$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($71c43243f3d11279$var$SendTrackEventComponent);

});

parcelRegister("fJp8a", function(module, exports) {
/**
 * @generated SignedSource<<a06a8a013af654ab7c26aeab2b65cf59>>
 * @relayHash 32571b6f378434b18a3f7ffd275bf6d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b9659f35a7eec8367641693f458f5b2681600dc7f00ef95a9271421a2154a8c
const $2483e127b5e3d8b1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "lastUpdated",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "when"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorEligibility"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SendTrackViewPageEventQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SendTrackViewPageEventQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "32571b6f378434b18a3f7ffd275bf6d4",
            "id": "7b9659f35a7eec8367641693f458f5b2681600dc7f00ef95a9271421a2154a8c",
            "metadata": {},
            "name": "SendTrackViewPageEventQuery",
            "operationKind": "query",
            "text": "query SendTrackViewPageEventQuery($contentId:ID){content(id:$contentId){nodes{id,history{createdDate,lastUpdated{when}},metadata{frontend{fabricEditorSupported,fabricEditorEligibility}},space{id},status}}}"
        }
    };
}();
$2483e127b5e3d8b1$var$node.hash = "19847917790449aae265767493366eb2";
var $2483e127b5e3d8b1$export$2e2bcd8739ae039 = $2483e127b5e3d8b1$var$node;
module.exports["default"] = $2483e127b5e3d8b1$export$2e2bcd8739ae039;

});

parcelRegister("dBHLx", function(module, exports) {

let $9e80ae02db229a1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e80ae02db229a1a$var$load("eEyVs"),
    $9e80ae02db229a1a$var$load("7EorR"),
    $9e80ae02db229a1a$var$load("iCuQy")
]).then(()=>parcelRequire('4Shbp'));

});

parcelRegister("jEQIl", function(module, exports) {

let $e4faa4b0d5de0a25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4faa4b0d5de0a25$var$load("ckx79").then(()=>parcelRequire('eGJ8h'));

});

parcelRegister("dY5Vp", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $41efc32f19d16eca$export$aeb070a9ba92094e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "UtR1u",
    name: "LazyQuestions",
    loader: async ()=>(await (parcelRequire("upqak"))).Questions
});
module.exports["LazyQuestions"] = $41efc32f19d16eca$export$aeb070a9ba92094e;

});

parcelRegister("upqak", function(module, exports) {

let $05b6858b03d956a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $05b6858b03d956a2$var$load("jlCbV"),
    $05b6858b03d956a2$var$load("f35QR"),
    $05b6858b03d956a2$var$load("eVYW1"),
    $05b6858b03d956a2$var$load("ls0Um"),
    $05b6858b03d956a2$var$load("020xd"),
    $05b6858b03d956a2$var$load("eTBsW"),
    $05b6858b03d956a2$var$load("bYxCZ"),
    $05b6858b03d956a2$var$load("6HBYC"),
    $05b6858b03d956a2$var$load("eDqo1"),
    $05b6858b03d956a2$var$load("lxiFd"),
    $05b6858b03d956a2$var$load("1oiJ6"),
    $05b6858b03d956a2$var$load("huUvS"),
    $05b6858b03d956a2$var$load("6wr18"),
    $05b6858b03d956a2$var$load("jbrCY"),
    $05b6858b03d956a2$var$load("9fGNu"),
    $05b6858b03d956a2$var$load("hhss7"),
    $05b6858b03d956a2$var$load("g5HUX"),
    $05b6858b03d956a2$var$load("c39Xf"),
    $05b6858b03d956a2$var$load("czd3n"),
    $05b6858b03d956a2$var$load("7P36N"),
    $05b6858b03d956a2$var$load("lVfKJ"),
    $05b6858b03d956a2$var$load("7EorR"),
    $05b6858b03d956a2$var$load("8j9XC"),
    $05b6858b03d956a2$var$load("1GCFv"),
    $05b6858b03d956a2$var$load("6vhrJ"),
    $05b6858b03d956a2$var$load("fxC6e"),
    $05b6858b03d956a2$var$load("ffEVr"),
    $05b6858b03d956a2$var$load("5xtwP")
]).then(()=>parcelRequire('gCU3O'));

});

parcelRegister("bfcuB", function(module, exports) {

let $82fac92c4ad03163$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $82fac92c4ad03163$var$load("6wr18"),
    $82fac92c4ad03163$var$load("gYJBG"),
    $82fac92c4ad03163$var$load("bJATU"),
    $82fac92c4ad03163$var$load("9BMwf"),
    $82fac92c4ad03163$var$load("6CBhM"),
    $82fac92c4ad03163$var$load("2yk7f"),
    $82fac92c4ad03163$var$load("jtqzu"),
    $82fac92c4ad03163$var$load("7Ya0F"),
    $82fac92c4ad03163$var$load("3Bbwl"),
    $82fac92c4ad03163$var$load("lUFbG"),
    $82fac92c4ad03163$var$load("jfGTp"),
    $82fac92c4ad03163$var$load("gNBrZ"),
    $82fac92c4ad03163$var$load("7EorR"),
    $82fac92c4ad03163$var$load("llxGi"),
    $82fac92c4ad03163$var$load("ffEVr"),
    $82fac92c4ad03163$var$load("hLE8r")
]).then(()=>parcelRequire('9Gz8W'));

});

parcelRegister("3vULB", function(module, exports) {

let $28f04d11195bdc3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $28f04d11195bdc3c$var$load("6wr18"),
    $28f04d11195bdc3c$var$load("6CBhM"),
    $28f04d11195bdc3c$var$load("2yk7f"),
    $28f04d11195bdc3c$var$load("ffEVr"),
    $28f04d11195bdc3c$var$load("5DjNv"),
    $28f04d11195bdc3c$var$load("bo7iw"),
    $28f04d11195bdc3c$var$load("2sCab")
]).then(()=>parcelRequire('3GuAz'));

});

parcelRegister("83I8f", function(module, exports) {

let $5de0d63c5b5c7fe9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5de0d63c5b5c7fe9$var$load("9GOJf"),
    $5de0d63c5b5c7fe9$var$load("6wr18"),
    $5de0d63c5b5c7fe9$var$load("gYJBG"),
    $5de0d63c5b5c7fe9$var$load("9BMwf"),
    $5de0d63c5b5c7fe9$var$load("6CBhM"),
    $5de0d63c5b5c7fe9$var$load("2yk7f"),
    $5de0d63c5b5c7fe9$var$load("jtqzu"),
    $5de0d63c5b5c7fe9$var$load("nGUH4"),
    $5de0d63c5b5c7fe9$var$load("7Ya0F"),
    $5de0d63c5b5c7fe9$var$load("6tsCm"),
    $5de0d63c5b5c7fe9$var$load("2KBe6"),
    $5de0d63c5b5c7fe9$var$load("bYGFL"),
    $5de0d63c5b5c7fe9$var$load("jfGTp"),
    $5de0d63c5b5c7fe9$var$load("gNBrZ"),
    $5de0d63c5b5c7fe9$var$load("7EorR"),
    $5de0d63c5b5c7fe9$var$load("llxGi"),
    $5de0d63c5b5c7fe9$var$load("4fYzp"),
    $5de0d63c5b5c7fe9$var$load("ffEVr"),
    $5de0d63c5b5c7fe9$var$load("90USU"),
    $5de0d63c5b5c7fe9$var$load("6sFkE")
]).then(()=>parcelRequire('1T0Cv'));

});

parcelRegister("5zOxZ", function(module, exports) {

let $40f76e43bd900212$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40f76e43bd900212$var$load("6wr18"),
    $40f76e43bd900212$var$load("bJATU"),
    $40f76e43bd900212$var$load("9BMwf"),
    $40f76e43bd900212$var$load("6CBhM"),
    $40f76e43bd900212$var$load("2yk7f"),
    $40f76e43bd900212$var$load("jtqzu"),
    $40f76e43bd900212$var$load("7Ya0F"),
    $40f76e43bd900212$var$load("lUFbG"),
    $40f76e43bd900212$var$load("jfGTp"),
    $40f76e43bd900212$var$load("gNBrZ"),
    $40f76e43bd900212$var$load("7EorR"),
    $40f76e43bd900212$var$load("llxGi"),
    $40f76e43bd900212$var$load("ffEVr"),
    $40f76e43bd900212$var$load("90USU"),
    $40f76e43bd900212$var$load("bYnOS")
]).then(()=>parcelRequire('3EzW0'));

});

parcelRegister("5tYsv", function(module, exports) {

let $3fde8f0472d5414e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fde8f0472d5414e$var$load("ioTV7").then(()=>parcelRequire('9wYcO'));

});

parcelRegister("kFptA", function(module, exports) {

let $f0bb6606df0c2a62$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0bb6606df0c2a62$var$load("2QH3d").then(()=>parcelRequire('flSU2'));

});

parcelRegister("19zWE", function(module, exports) {

let $0d7283a12eafbe22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d7283a12eafbe22$var$load("1qAcJ").then(()=>parcelRequire('66lXR'));

});

parcelRegister("hKYBj", function(module, exports) {

let $ced5bda1692f3cf4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ced5bda1692f3cf4$var$load("feDdV"),
    $ced5bda1692f3cf4$var$load("6wr18"),
    $ced5bda1692f3cf4$var$load("5ppK3"),
    $ced5bda1692f3cf4$var$load("4mgLr"),
    $ced5bda1692f3cf4$var$load("ffEVr"),
    $ced5bda1692f3cf4$var$load("ht9O7")
]).then(()=>parcelRequire('eTYeK'));

});

parcelRegister("k2W0I", function(module, exports) {

let $e980fe4254b8570c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e980fe4254b8570c$var$load("jDjSj"),
    $e980fe4254b8570c$var$load("6wr18"),
    $e980fe4254b8570c$var$load("1GCFv"),
    $e980fe4254b8570c$var$load("4fYzp"),
    $e980fe4254b8570c$var$load("hOaAV"),
    $e980fe4254b8570c$var$load("lFAez"),
    $e980fe4254b8570c$var$load("1qlDN"),
    $e980fe4254b8570c$var$load("1yVM6"),
    $e980fe4254b8570c$var$load("cEqm7"),
    $e980fe4254b8570c$var$load("ffEVr"),
    $e980fe4254b8570c$var$load("jbmut"),
    $e980fe4254b8570c$var$load("6XCf4"),
    $e980fe4254b8570c$var$load("gNfuQ"),
    $e980fe4254b8570c$var$load("kVHWO"),
    $e980fe4254b8570c$var$load("5mKg8")
]).then(()=>parcelRequire('fyrrY'));

});

parcelRegister("l5PUQ", function(module, exports) {
const $794cae3221ca3442$export$ccc7dd6c48bfb65d = 'adminUserAccess';
const $794cae3221ca3442$export$728435b9c77444c = 500;
var $794cae3221ca3442$export$37d3310174fb25af = /*#__PURE__*/ function(PermissionResultType) {
    PermissionResultType["ALLOWED"] = "ALLOWED";
    PermissionResultType["DENIED"] = "DENIED";
    PermissionResultType["INHERITED"] = "INHERITED";
    PermissionResultType["IRRELEVANT"] = "IRRELEVANT";
    return PermissionResultType;
}({});
module.exports["ADMIN_USER_ACCESS_ANALYTICS_SOURCE"] = $794cae3221ca3442$export$ccc7dd6c48bfb65d;
module.exports["SPACE_PERMS_REPORT_POLL_INTERVAL_MS"] = $794cae3221ca3442$export$728435b9c77444c;
module.exports["PermissionResultType"] = $794cae3221ca3442$export$37d3310174fb25af;

});

parcelRegister("964fa", function(module, exports) {

let $69f7f74f2bf98c92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69f7f74f2bf98c92$var$load("kbzD1").then(()=>parcelRequire('aFOyu'));

});

parcelRegister("lkTzI", function(module, exports) {

let $f88693499cea4a63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f88693499cea4a63$var$load("iLTLW"),
    $f88693499cea4a63$var$load("8yLIX"),
    $f88693499cea4a63$var$load("e6e7M"),
    $f88693499cea4a63$var$load("2jEbr")
]).then(()=>parcelRequire('gaL8X'));

});

parcelRegister("h84KH", function(module, exports) {

let $c786deb8b7fd29e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c786deb8b7fd29e4$var$load("6wr18"),
    $c786deb8b7fd29e4$var$load("gyQ2s"),
    $c786deb8b7fd29e4$var$load("6CBhM"),
    $c786deb8b7fd29e4$var$load("iLTLW"),
    $c786deb8b7fd29e4$var$load("ffEVr"),
    $c786deb8b7fd29e4$var$load("e6e7M"),
    $c786deb8b7fd29e4$var$load("kYIpq"),
    $c786deb8b7fd29e4$var$load("7EorR"),
    $c786deb8b7fd29e4$var$load("3CazT"),
    $c786deb8b7fd29e4$var$load("6v3DV"),
    $c786deb8b7fd29e4$var$load("1V58T"),
    $c786deb8b7fd29e4$var$load("gp06T"),
    $c786deb8b7fd29e4$var$load("9ifQI"),
    $c786deb8b7fd29e4$var$load("abd2b"),
    $c786deb8b7fd29e4$var$load("4fYzp"),
    $c786deb8b7fd29e4$var$load("gNfuQ"),
    $c786deb8b7fd29e4$var$load("hhss7"),
    $c786deb8b7fd29e4$var$load("1jGw5")
]).then(()=>parcelRequire('8XK0M'));

});

parcelRegister("edpw6", function(module, exports) {

let $a59612b55a258248$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a59612b55a258248$var$load("aFUSO").then(()=>parcelRequire('8Cf2W'));

});

parcelRegister("hbqB4", function(module, exports) {

let $c8281850dea4549b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c8281850dea4549b$var$load("6wr18"),
    $c8281850dea4549b$var$load("gyQ2s"),
    $c8281850dea4549b$var$load("6CBhM"),
    $c8281850dea4549b$var$load("iLTLW"),
    $c8281850dea4549b$var$load("4JAC8"),
    $c8281850dea4549b$var$load("ffEVr"),
    $c8281850dea4549b$var$load("e6e7M"),
    $c8281850dea4549b$var$load("hhss7"),
    $c8281850dea4549b$var$load("37ldp"),
    $c8281850dea4549b$var$load("7O0x7")
]).then(()=>parcelRequire('cbGfM'));

});

parcelRegister("mSA7M", function(module, exports) {

let $044c64f7d51e3074$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $044c64f7d51e3074$var$load("8j9XC"),
    $044c64f7d51e3074$var$load("kpjEU"),
    $044c64f7d51e3074$var$load("d62hC"),
    $044c64f7d51e3074$var$load("fT5Tk"),
    $044c64f7d51e3074$var$load("jPzkK"),
    $044c64f7d51e3074$var$load("hVgF8"),
    $044c64f7d51e3074$var$load("bGqrb"),
    $044c64f7d51e3074$var$load("6tsCm"),
    $044c64f7d51e3074$var$load("6kcCF"),
    $044c64f7d51e3074$var$load("9V1vV"),
    $044c64f7d51e3074$var$load("i6s2m"),
    $044c64f7d51e3074$var$load("bNW8r"),
    $044c64f7d51e3074$var$load("1ZFzv"),
    $044c64f7d51e3074$var$load("diyjB"),
    $044c64f7d51e3074$var$load("4oONP"),
    $044c64f7d51e3074$var$load("lUFbG"),
    $044c64f7d51e3074$var$load("Wowvf"),
    $044c64f7d51e3074$var$load("gy5DL"),
    $044c64f7d51e3074$var$load("dtpmo"),
    $044c64f7d51e3074$var$load("35X59"),
    $044c64f7d51e3074$var$load("2F69B"),
    $044c64f7d51e3074$var$load("3g3jg"),
    $044c64f7d51e3074$var$load("1GCFv"),
    $044c64f7d51e3074$var$load("bRqDI"),
    $044c64f7d51e3074$var$load("4fYzp"),
    $044c64f7d51e3074$var$load("6wr18"),
    $044c64f7d51e3074$var$load("7EorR"),
    $044c64f7d51e3074$var$load("5dkX4"),
    $044c64f7d51e3074$var$load("9lUu8"),
    $044c64f7d51e3074$var$load("hhss7"),
    $044c64f7d51e3074$var$load("ffEVr"),
    $044c64f7d51e3074$var$load("e2WH6"),
    $044c64f7d51e3074$var$load("5vzT0"),
    $044c64f7d51e3074$var$load("h94bv"),
    $044c64f7d51e3074$var$load("42uV7")
]).then(()=>parcelRequire('i6Ad2'));

});

parcelRegister("ehBkr", function(module, exports) {

let $a65f9bed439c79c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a65f9bed439c79c6$var$load("2B2rM"),
    $a65f9bed439c79c6$var$load("7gkvG"),
    $a65f9bed439c79c6$var$load("6wr18"),
    $a65f9bed439c79c6$var$load("2Gceu"),
    $a65f9bed439c79c6$var$load("jmKRS"),
    $a65f9bed439c79c6$var$load("9TQyl"),
    $a65f9bed439c79c6$var$load("3dFwk"),
    $a65f9bed439c79c6$var$load("5uN9h"),
    $a65f9bed439c79c6$var$load("71gca"),
    $a65f9bed439c79c6$var$load("bYGFL"),
    $a65f9bed439c79c6$var$load("jfGTp"),
    $a65f9bed439c79c6$var$load("gNBrZ"),
    $a65f9bed439c79c6$var$load("5TD4G"),
    $a65f9bed439c79c6$var$load("eEyVs"),
    $a65f9bed439c79c6$var$load("ffEVr"),
    $a65f9bed439c79c6$var$load("72caV"),
    $a65f9bed439c79c6$var$load("bLm2D"),
    $a65f9bed439c79c6$var$load("lsoh8")
]).then(()=>parcelRequire('eP5Ba'));

});

parcelRegister("4M3H8", function(module, exports) {

let $379e82d32d715df2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $379e82d32d715df2$var$load("9cxnP").then(()=>parcelRequire('3J1Lm'));

});

parcelRegister("2Ifa7", function(module, exports) {

let $1f9b73bf2c33a303$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1f9b73bf2c33a303$var$load("aGTsr"),
    $1f9b73bf2c33a303$var$load("6wr18"),
    $1f9b73bf2c33a303$var$load("bJkEE"),
    $1f9b73bf2c33a303$var$load("7KC2Z"),
    $1f9b73bf2c33a303$var$load("3Bbwl"),
    $1f9b73bf2c33a303$var$load("2KBe6"),
    $1f9b73bf2c33a303$var$load("bYGFL"),
    $1f9b73bf2c33a303$var$load("jfGTp"),
    $1f9b73bf2c33a303$var$load("gNBrZ"),
    $1f9b73bf2c33a303$var$load("4rKYa"),
    $1f9b73bf2c33a303$var$load("e6e7M"),
    $1f9b73bf2c33a303$var$load("kYIpq"),
    $1f9b73bf2c33a303$var$load("7EorR"),
    $1f9b73bf2c33a303$var$load("ffEVr"),
    $1f9b73bf2c33a303$var$load("5DjNv"),
    $1f9b73bf2c33a303$var$load("bo7iw"),
    $1f9b73bf2c33a303$var$load("4fYzp"),
    $1f9b73bf2c33a303$var$load("eIFCH")
]).then(()=>parcelRequire('cpWoN'));

});

parcelRegister("lQqv5", function(module, exports) {

let $fe7302b7be868084$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe7302b7be868084$var$load("2bs4C"),
    $fe7302b7be868084$var$load("cOr5H")
]).then(()=>parcelRequire('iOUgp'));

});

parcelRegister("iSFH7", function(module, exports) {

let $dbed9cc52b5430a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dbed9cc52b5430a7$var$load("6wr18"),
    $dbed9cc52b5430a7$var$load("3Q80N"),
    $dbed9cc52b5430a7$var$load("1tzsM"),
    $dbed9cc52b5430a7$var$load("0566w"),
    $dbed9cc52b5430a7$var$load("jvHRs"),
    $dbed9cc52b5430a7$var$load("llxGi"),
    $dbed9cc52b5430a7$var$load("jtcRz"),
    $dbed9cc52b5430a7$var$load("1Pok1"),
    $dbed9cc52b5430a7$var$load("iFEfD"),
    $dbed9cc52b5430a7$var$load("l8LQp"),
    $dbed9cc52b5430a7$var$load("1oAGT"),
    $dbed9cc52b5430a7$var$load("fTujI"),
    $dbed9cc52b5430a7$var$load("1Qgo1"),
    $dbed9cc52b5430a7$var$load("gnDXu"),
    $dbed9cc52b5430a7$var$load("ffEVr"),
    $dbed9cc52b5430a7$var$load("aez9w")
]).then(()=>parcelRequire('cjovp'));

});

parcelRegister("1nRfY", function(module, exports) {

let $10214017254b43ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $10214017254b43ff$var$load("cOFDc"),
    $10214017254b43ff$var$load("9lUu8"),
    $10214017254b43ff$var$load("6wr18"),
    $10214017254b43ff$var$load("e6e7M"),
    $10214017254b43ff$var$load("kYIpq"),
    $10214017254b43ff$var$load("7EorR"),
    $10214017254b43ff$var$load("4fYzp"),
    $10214017254b43ff$var$load("ffEVr"),
    $10214017254b43ff$var$load("eKInd")
]).then(()=>parcelRequire('ewPGQ'));

});

parcelRegister("f1YWS", function(module, exports) {

let $af163a24df3bb86e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $af163a24df3bb86e$var$load("9lUu8"),
    $af163a24df3bb86e$var$load("cOFDc"),
    $af163a24df3bb86e$var$load("c8GnP")
]).then(()=>parcelRequire('145h7'));

});

parcelRegister("7GuCn", function(module, exports) {

let $598434c0d7109764$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $598434c0d7109764$var$load("exvU8").then(()=>parcelRequire('9ZXTU'));

});

parcelRegister("hbxro", function(module, exports) {

let $c82d67667bc14e44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c82d67667bc14e44$var$load("6wr18"),
    $c82d67667bc14e44$var$load("fiBFO"),
    $c82d67667bc14e44$var$load("ffEVr"),
    $c82d67667bc14e44$var$load("2MuhG")
]).then(()=>parcelRequire('gelCt'));

});

parcelRegister("syHJB", function(module, exports) {

let $055d89359b3569b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $055d89359b3569b3$var$load("9EI97").then(()=>parcelRequire('ivpO0'));

});

parcelRegister("i2w4s", function(module, exports) {

let $d2214a7e20c834ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2214a7e20c834ca$var$load("2n8AT").then(()=>parcelRequire('cv3PF'));

});

parcelRegister("kcni8", function(module, exports) {

let $eb46fed7e75084ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb46fed7e75084ad$var$load("jczTu").then(()=>parcelRequire('bnpc5'));

});

parcelRegister("jjudR", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $e0f73c3ac42b2c93$var$syncFallback = function syncFallback(create) {
    return create();
};
var $e0f73c3ac42b2c93$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $e0f73c3ac42b2c93$export$db21c7ffa21794e7 = $e0f73c3ac42b2c93$var$useInsertionEffect || $e0f73c3ac42b2c93$var$syncFallback;
var $e0f73c3ac42b2c93$export$811a713a7276cb9d = $e0f73c3ac42b2c93$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $e0f73c3ac42b2c93$export$db21c7ffa21794e7;
module.exports["useInsertionEffectWithLayoutFallback"] = $e0f73c3ac42b2c93$export$811a713a7276cb9d;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("6i41U", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("19w2x", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6ttbq = parcelRequire("6ttbq");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $hUAWL = parcelRequire("hUAWL");


var $2K5gO = parcelRequire("2K5gO");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $105205360274b3e9$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $105205360274b3e9$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $105205360274b3e9$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $105205360274b3e9$export$a300664a1a230956 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion } = t0;
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $2K5gO.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $6ttbq.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $4QtAs.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== requestAnimationFrame || $[9] !== setTimeout) {
        t3 = ()=>{
            if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = requestAnimationFrame;
        $[9] = setTimeout;
        $[10] = t3;
    } else t3 = $[10];
    (0, $dclyF.useLayoutEffect)(t3);
    let t4;
    if ($[11] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[11] = setElementRef;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $2K5gO.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $105205360274b3e9$export$a300664a1a230956;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("hUAWL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9fe18f2334f78b72$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $9fe18f2334f78b72$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9fe18f2334f78b72$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $9fe18f2334f78b72$export$1775f27e7c8051ca;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("4YBSq", function(module, exports) {
/**
 * @generated SignedSource<<9700b2b14bf1783e20ed515703a9c457>>
 * @relayHash f85bb73042ebe75e2cb50dec93f9b7c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139
const $16e983e3bee16ecd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedded"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collabService"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f85bb73042ebe75e2cb50dec93f9b7c4",
            "id": "ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139",
            "metadata": {},
            "name": "EditContentButtonQuery",
            "operationKind": "query",
            "text": "query EditContentButtonQuery($contentId:ID!){content(id:$contentId){nodes{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}}}"
        }
    };
}();
$16e983e3bee16ecd$var$node.hash = "94b096c536d2633f3df010c4409c1c2a";
var $16e983e3bee16ecd$export$2e2bcd8739ae039 = $16e983e3bee16ecd$var$node;
module.exports["default"] = $16e983e3bee16ecd$export$2e2bcd8739ae039;

});

parcelRegister("kwDQA", function(module, exports) {
/**
 * @generated SignedSource<<c4c634ffb5984138b240a2bcc61996d1>>
 * @relayHash 68505bc224ec19edfba49afd43c7d907
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99
const $377c093245c44338$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentAnalyticsViewers",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "68505bc224ec19edfba49afd43c7d907",
            "id": "7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99",
            "metadata": {},
            "name": "useAnalyticsByLineQuery",
            "operationKind": "query",
            "text": "query useAnalyticsByLineQuery($contentId:ID!){contentAnalyticsViewers(contentId:$contentId){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
        }
    };
}();
$377c093245c44338$var$node.hash = "1059930ceaf11a1fca0cb8f2f9d20c27";
var $377c093245c44338$export$2e2bcd8739ae039 = $377c093245c44338$var$node;
module.exports["default"] = $377c093245c44338$export$2e2bcd8739ae039;

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<dd6200b047aed134b0d9af6a992daf7b>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("568fA", function(module, exports) {
/**
 * @generated SignedSource<<e2045cb4c83675e7e407c2efe51efbe1>>
 * @relayHash f5377fb7a336ea197d2d8df561c3c35e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ba569705dcebdc323e95a461524d3052a4257acdc1042d3187378b46031e68ee
const $0dc90704ec36fa39$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useObjectHeader"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current",
                "draft"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v12 = {
        "kind": "ScalarField",
        "name": "number"
    }, v13 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "when"
    }, v16 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ], v17 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "condition": "useObjectHeader",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": v16 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "draftVersion",
                                            "plural": false,
                                            "selections": v16 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "condition": "useObjectHeader",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": v17 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "draftVersion",
                                            "plural": false,
                                            "selections": v17 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f5377fb7a336ea197d2d8df561c3c35e",
            "id": "ba569705dcebdc323e95a461524d3052a4257acdc1042d3187378b46031e68ee",
            "metadata": {},
            "name": "ContentTypesHeaderQuery",
            "operationKind": "query",
            "text": "query ContentTypesHeaderQuery($contentId:ID,$useObjectHeader:Boolean!){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}\n      draftVersion@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}}}"
        }
    };
}();
$0dc90704ec36fa39$var$node.hash = "2abb5d91a30df68c545d69974a9ee651";
var $0dc90704ec36fa39$export$2e2bcd8739ae039 = $0dc90704ec36fa39$var$node;
module.exports["default"] = $0dc90704ec36fa39$export$2e2bcd8739ae039;

});

parcelRegister("lPNkm", function(module, exports) {
/**
 * @generated SignedSource<<fcf122e4a0dd12a263fab6061b3a36dd>>
 * @relayHash 19081691cac2c634716f82092efd5e14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3
const $98f50c7d6961f0d8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        },
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SpaceSettingsMetadata",
                            "kind": "LinkedField",
                            "name": "customHeaderAndFooter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "header",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "footer",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "19081691cac2c634716f82092efd5e14",
            "id": "3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3",
            "metadata": {},
            "name": "CustomHeaderFooterQuery",
            "operationKind": "query",
            "text": "query CustomHeaderFooterQuery($spaceKey:String){space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}}}"
        }
    };
}();
$98f50c7d6961f0d8$var$node.hash = "deed3f087b4973bd7d276b1389cfb125";
var $98f50c7d6961f0d8$export$2e2bcd8739ae039 = $98f50c7d6961f0d8$var$node;
module.exports["default"] = $98f50c7d6961f0d8$export$2e2bcd8739ae039;

});

parcelRegister("k5dl6", function(module, exports) {
/**
 * @generated SignedSource<<6dc466aba14c78f3432cf6d35f092a95>>
 * @relayHash 9f9cb3b101c0d783a0151d795ee8a444
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06
const $bff977656480fdfe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "contentId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    },
                    v2 /*: any*/ 
                ]
            }
        ]
    }, v4 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v11 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "when"
    }, v14 = {
        "kind": "ScalarField",
        "name": "number"
    }, v15 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v20 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v21 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v24 /*: any*/ ,
            v16 /*: any*/ ,
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v24 /*: any*/ ,
                                v16 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9f9cb3b101c0d783a0151d795ee8a444",
            "id": "97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06",
            "metadata": {},
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentsFocusedInlineCommentQuery($commentId:ID!,$contentId:ID){content(id:$contentId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(commentId:$commentId,depth:ALL,type:UNRESOLVED){nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$bff977656480fdfe$var$node.hash = "c6bc55705b1b90c4e9cb60ee0b5a4650";
var $bff977656480fdfe$export$2e2bcd8739ae039 = $bff977656480fdfe$var$node;
module.exports["default"] = $bff977656480fdfe$export$2e2bcd8739ae039;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $6mKj3 = parcelRequire("6mKj3");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $3uzFB = parcelRequire("3uzFB");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default),
            __callerPackage__: "@confluence/loom-utils"
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    if ((0, $6mKj3.isExperimentEnabled)('confluence_frontend_loom_agg_perm_check_exp')) return $9633e2f0bea217d1$var$getLoomUserAggPermissionStatus(cloudId, userId);
    return $9633e2f0bea217d1$export$4fb5a1b2348fe5c4(cloudId, userId, environment);
};
const $9633e2f0bea217d1$export$4fb5a1b2348fe5c4 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$getLoomUserAggPermissionStatus = async (cloudId, userId)=>{
    if (!userId) return "not-permitted";
    const variables = (0, $3uzFB.getLoomUserPermissionQueryVariables)(cloudId, userId);
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $3uzFB.LoomUserPermissionQuery),
            variables: variables,
            errorPolicy: 'all',
            interopApolloAggClient: true,
            __callerPackage__: "@confluence/loom-utils"
        });
        if (error) throw error;
        return (0, $3uzFB.hasExactLoomUserPermission)(data, variables) ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserLegacyPermissionStatus"] = $9633e2f0bea217d1$export$4fb5a1b2348fe5c4;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("3uzFB", function(module, exports) {

var $keH2u = parcelRequire("keH2u");

const $9ee481529bbe8b4d$export$a4bb6b905bc500e2 = (0, $keH2u.default);
const $9ee481529bbe8b4d$export$8d50de945dbf45ca = (cloudId, userId)=>({
        principalId: `ari:cloud:identity::user/${userId}`,
        loomResourceId: `ari:cloud:loom::site/${cloudId}`
    });
const $9ee481529bbe8b4d$export$b048e9c33b8e482 = (data, variables)=>{
    const matchingRows = data?.bulkPermitted?.filter((row)=>row?.principalId === variables.principalId && row?.resourceId === variables.loomResourceId && row?.permissionId === 'write') ?? [];
    if (matchingRows.length < 1) return false;
    return matchingRows.every((row)=>row?.permitted === true);
};
module.exports["LoomUserPermissionQuery"] = $9ee481529bbe8b4d$export$a4bb6b905bc500e2;
module.exports["getLoomUserPermissionQueryVariables"] = $9ee481529bbe8b4d$export$8d50de945dbf45ca;
module.exports["hasExactLoomUserPermission"] = $9ee481529bbe8b4d$export$b048e9c33b8e482;

});

parcelRegister("keH2u", function(module, exports) {
/**
 * @generated SignedSource<<9936c66f475f5b5cae80af06b548f8cb>>
 * @relayHash 1246767ea7fb9149278e67c3ec09752c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5
const $ebcff904befcd9cb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "loomResourceId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "permissionIds",
                    "value": [
                        "write"
                    ]
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "principalIds.0",
                            "variableName": "principalId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "principalIds"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "resourceIds.0",
                            "variableName": "loomResourceId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "resourceIds"
                }
            ],
            "concreteType": "BulkPermittedResponse",
            "kind": "LinkedField",
            "name": "bulkPermitted",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "principalId"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permissionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permitted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "1246767ea7fb9149278e67c3ec09752c",
            "id": "b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5",
            "metadata": {},
            "name": "loomUserPermissionQuery",
            "operationKind": "query",
            "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
        }
    };
}();
$ebcff904befcd9cb$var$node.hash = "714c5537c580f754bda23bcf99534b30";
var $ebcff904befcd9cb$export$2e2bcd8739ae039 = $ebcff904befcd9cb$var$node;
module.exports["default"] = $ebcff904befcd9cb$export$2e2bcd8739ae039;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<7e1563bf12c221b07284eee871d1f539>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<d3a959f3c995162dd3e589ad8c39797e>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $bcPqk = parcelRequire("bcPqk");

const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $bcPqk.default);
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("bcPqk", function(module, exports) {
/**
 * @generated SignedSource<<0d565de88cf0b0b5b63d9eb6adb77c13>>
 * @relayHash cbefab13307a82cf7144a0c0749ceeba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce
const $6247a0815b189874$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": [
                        "DRAFT",
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "containerId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cbefab13307a82cf7144a0c0749ceeba",
            "id": "856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce",
            "metadata": {},
            "name": "ReactionsCommentsQuery",
            "operationKind": "query",
            "text": "query ReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$6247a0815b189874$var$node.hash = "0b21ca1826000dc79e07e5aee0fcca18";
var $6247a0815b189874$export$2e2bcd8739ae039 = $6247a0815b189874$var$node;
module.exports["default"] = $6247a0815b189874$export$2e2bcd8739ae039;

});

parcelRegister("9inwL", function(module, exports) {
/**
 * @generated SignedSource<<82a1df34aa63d7968e489d43648de5d0>>
 * @relayHash 84e141f4639993fa671b560586b064ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8efac480ec4a436c1a451826fa401d62a5e1cb57c29989be5ed579813655fbf2
const $5791e6e7c338c837$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "missingSpaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "missingSpaceKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "84e141f4639993fa671b560586b064ac",
            "id": "8efac480ec4a436c1a451826fa401d62a5e1cb57c29989be5ed579813655fbf2",
            "metadata": {},
            "name": "ContentPrerequisitesQuery",
            "operationKind": "query",
            "text": "query ContentPrerequisitesQuery($contentId:ID!,$missingSpaceKey:Boolean=false,$spaceKey:String){content(id:$contentId){nodes{id,type,space{id,key,alias}}},space(key:$spaceKey)@skip(if:$missingSpaceKey){id,name}}"
        }
    };
}();
$5791e6e7c338c837$var$node.hash = "0027e387b6111f3e5ddcfb9450c87857";
var $5791e6e7c338c837$export$2e2bcd8739ae039 = $5791e6e7c338c837$var$node;
module.exports["default"] = $5791e6e7c338c837$export$2e2bcd8739ae039;

});

parcelRegister("4uNpa", function(module, exports) {
/**
 * @generated SignedSource<<d7fe2a7a66643bd9c72401c8da9b795f>>
 * @relayHash 81e3b75d8ec7e8341dfb9fe5d7c36fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911
const $2411ee21620b66c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "homepageId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "81e3b75d8ec7e8341dfb9fe5d7c36fac",
            "id": "9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911",
            "metadata": {},
            "name": "ContentRedirectQuery",
            "operationKind": "query",
            "text": "query ContentRedirectQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,title,space{id,homepageId,key,alias},history{createdDate}}}}"
        }
    };
}();
$2411ee21620b66c4$var$node.hash = "440c7fc38cc16d750fa69bd87e3ba7c2";
var $2411ee21620b66c4$export$2e2bcd8739ae039 = $2411ee21620b66c4$var$node;
module.exports["default"] = $2411ee21620b66c4$export$2e2bcd8739ae039;

});

parcelRegister("98Fgg", function(module, exports) {
/**
 * @generated SignedSource<<9e3e16b02d7e839cb28fafbd9cc22027>>
 * @relayHash 1eef94f086d4818dc81396289138687a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09
const $314d226daa5f5ce2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isBlog"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "condition": "isBlog",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "CURRENT"
                            ]
                        }
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "ptpage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                }
                            ],
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "nearestAncestors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PTPageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "PTPage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "nearestAncestors(first:1)"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "1eef94f086d4818dc81396289138687a",
            "id": "57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09",
            "metadata": {},
            "name": "preloadLegacyBridgeQuery",
            "operationKind": "query",
            "text": "query preloadLegacyBridgeQuery($contentId:ID!,$isBlog:Boolean!){ptpage(id:$contentId,status:[CURRENT])@skip(if:$isBlog){id,nearestAncestors(first:1){edges{node{id,title}}}},content(id:$contentId){nodes{id,type,title,version{number},space{id,key,name,type},operations{operation,targetType}}}}"
        }
    };
}();
$314d226daa5f5ce2$var$node.hash = "6d396d281028b16cc64fd39e7d8cd3db";
var $314d226daa5f5ce2$export$2e2bcd8739ae039 = $314d226daa5f5ce2$var$node;
module.exports["default"] = $314d226daa5f5ce2$export$2e2bcd8739ae039;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<c5b5f73002999b27d52061f945d6fdad>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "4580906c8b823122d6a7f5ad8c2e2c6c";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("38Ncj", function(module, exports) {
/**
 * @generated SignedSource<<97620748d8d680bcf5801bcd64a5c19f>>
 * @relayHash 21cebd3db50676fd19d57554f2f4d6fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904
const $630a58f9ca4672ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isContentTypePublicLinkEligible"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "condition": "isContentTypePublicLinkEligible",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "21cebd3db50676fd19d57554f2f4d6fc",
            "id": "fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904",
            "metadata": {},
            "name": "useShareAndRestrictButtonDataQuery",
            "operationKind": "query",
            "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus,accessType}}"
        }
    };
}();
$630a58f9ca4672ab$var$node.hash = "336fe7f51ff27baeb231379611028a5d";
var $630a58f9ca4672ab$export$2e2bcd8739ae039 = $630a58f9ca4672ab$var$node;
module.exports["default"] = $630a58f9ca4672ab$export$2e2bcd8739ae039;

});

parcelRegister("1ydBT", function(module, exports) {
/**
 * @generated SignedSource<<2677448ae3824ed4f96e28a9f90ebc11>>
 * @relayHash cba455fca3d3e3ded9f59ef8dd1da82e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b15555a02e345dcac49028e56ae8de642103a954aa49f5dd68c34c48c3bc41c1
const $4edc52e24113851d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "FOOTER"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "FOOTER"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "cba455fca3d3e3ded9f59ef8dd1da82e",
            "id": "b15555a02e345dcac49028e56ae8de642103a954aa49f5dd68c34c48c3bc41c1",
            "metadata": {},
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$4edc52e24113851d$var$node.hash = "3a2732629f8a4a69bf446268336b7bc9";
var $4edc52e24113851d$export$2e2bcd8739ae039 = $4edc52e24113851d$var$node;
module.exports["default"] = $4edc52e24113851d$export$2e2bcd8739ae039;

});

parcelRegister("MJaSd", function(module, exports) {

var $kgNLQ = parcelRequire("kgNLQ");

const $eeebfa790a4a25a5$export$c6ff0a0df62acf44 = 3;
const $eeebfa790a4a25a5$export$533048ab2aed5b1a = -1;
// Default empty preload data structure (can be spread and isDataProcessed overridden)
const $eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA = {
    allComments: [],
    allFilteredComments: [],
    openInlineComments: [],
    openFooterComments: [],
    resolvedComments: [],
    openComments: [],
    commentsDataMap: {
        inline: {},
        general: {}
    },
    flatCommentsMap: {},
    hasNestedComments: false,
    commentCount: null,
    hasAnyComments: false,
    isDataProcessed: false
};
const $eeebfa790a4a25a5$export$fa19d42490144c8 = (contentId)=>({
        pageId: contentId,
        // Query for all comments regardless of status (although skip deleted since we have no way to show it), we'll filter on the FE
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED'
        ],
        first: $eeebfa790a4a25a5$export$c6ff0a0df62acf44
    });
const $eeebfa790a4a25a5$export$7cc295d5a932445b = (processedPreloadData, preloadCacheData)=>{
    if (!processedPreloadData.isDataProcessed || !preloadCacheData?.comments) return false;
    const totalCount = preloadCacheData.comments.totalCount;
    // If totalCount is the loading flag, we're still loading
    if (totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a) return false;
    // Calculate loaded comment count (parent comments + replies)
    const loadedCommentCount = preloadCacheData.comments.nodes?.reduce((acc, comment)=>{
        if (!comment) return acc;
        return acc + (comment?.replies?.length || 0) + 1; // parent + reply count
    }, 0) ?? 0;
    // Check if we've loaded all available comments
    return loadedCommentCount === totalCount;
};
const $eeebfa790a4a25a5$export$e229b0e2973dcb38 = (processedCommentsData, preloadCacheData, contentStatus)=>{
    // Check cache value to determine if we're in a loading state (totalCount === -1)
    const isPreloadLoadingFromCache = preloadCacheData?.comments?.totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a;
    // Process preload data
    // Don't process if we're loading (check cache value, not loading state)
    let processedPreloadData;
    if (isPreloadLoadingFromCache) processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    else if (preloadCacheData?.comments) {
        if (preloadCacheData.comments.nodes) {
            const allComments = (preloadCacheData.comments.nodes || []).filter((node)=>node !== null);
            // Filter preload comments by the contentStatus prop (same as CommentsDataBackgroundLoader does)
            // This ensures we only show comments that match the current page's content status
            const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatus);
            processedPreloadData = {
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            };
        } else processedPreloadData = {
            ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
            isDataProcessed: true
        };
    } else processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    // Determine which data source to use
    // If ProcessedCommentsDataStore has processed data, use that
    // Otherwise, use the preload query data
    const hasFullData = processedCommentsData.isDataProcessed;
    // Calculate if all data has been preloaded
    const allDataPreloaded = $eeebfa790a4a25a5$export$7cc295d5a932445b(processedPreloadData, preloadCacheData);
    // Dynamically determine the data to return based on current state
    // isDataProcessed always comes from ProcessedCommentsDataStore
    // Only the comment data itself comes from preload when full data isn't available
    const finalData = hasFullData ? processedCommentsData : {
        ...processedCommentsData,
        // Override comment data with preload data, but keep isDataProcessed from store
        ...processedPreloadData,
        isDataProcessed: processedCommentsData.isDataProcessed,
        error: processedCommentsData.error
    };
    return {
        ...finalData,
        // Keep separate vars for preload loading status so we don't have to assert isPreloading && ... everywhere
        isPreloadLoading: isPreloadLoadingFromCache,
        isPreloadDataProcessed: processedPreloadData.isDataProcessed,
        // Indicate whether preload completed with comments (for SSR placeholder display)
        preloadCompletedWithComments: processedPreloadData.isDataProcessed && processedPreloadData.allFilteredComments.length > 0,
        allDataPreloaded: // Indicate whether the preload contained ALL comments
        allDataPreloaded,
        // Indicate whether we're currently using full data or preload data
        isUsingFullData: hasFullData
    };
};
module.exports["PRELOAD_LOADING_FLAG"] = $eeebfa790a4a25a5$export$533048ab2aed5b1a;
module.exports["buildPreloadObjectCommentsQueryVariables"] = $eeebfa790a4a25a5$export$fa19d42490144c8;
module.exports["getPreloadAwareObjectComments"] = $eeebfa790a4a25a5$export$e229b0e2973dcb38;

});

parcelRegister("lj2R9", function(module, exports) {
/**
 * @generated SignedSource<<1e72b221db30c6dd58d4a18a3c908cd9>>
 * @relayHash 667db9b1207176451cb2198029bc1794
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c
const $0d0305ae4f6822bb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalCollaboratorCount"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "667db9b1207176451cb2198029bc1794",
            "id": "263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c",
            "metadata": {},
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "operationKind": "query",
            "text": "query ViewSpaceExternalCollaboratorsDialogQuery($spaceKey:String){space(key:$spaceKey){id,name,externalCollaboratorCount,currentUser{isAdmin}}}"
        }
    };
}();
$0d0305ae4f6822bb$var$node.hash = "722ca76340bcbe86e394e6f8663add12";
var $0d0305ae4f6822bb$export$2e2bcd8739ae039 = $0d0305ae4f6822bb$var$node;
module.exports["default"] = $0d0305ae4f6822bb$export$2e2bcd8739ae039;

});

parcelRegister("g2a13", function(module, exports) {
/**
 * @generated SignedSource<<e6d20f14365dfcef5db10c797898d3cf>>
 * @relayHash fe506bd9046797cde11ab0f7fcc9d885
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be
const $53f7ad90e8632c3f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "SpaceSidebarLinks",
            "kind": "LinkedField",
            "name": "spaceSidebarLinks",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "quick",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "position"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "styleClass"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShortcutsSpaceNavigationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShortcutsSpaceNavigationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fe506bd9046797cde11ab0f7fcc9d885",
            "id": "854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be",
            "metadata": {},
            "name": "useShortcutsSpaceNavigationQuery",
            "operationKind": "query",
            "text": "query useShortcutsSpaceNavigationQuery($spaceKey:String){spaceSidebarLinks(spaceKey:$spaceKey){__typename,quick{id,url,position,title,styleClass}}}"
        }
    };
}();
$53f7ad90e8632c3f$var$node.hash = "52dba71769af710a3e1e472bed635436";
var $53f7ad90e8632c3f$export$2e2bcd8739ae039 = $53f7ad90e8632c3f$var$node;
module.exports["default"] = $53f7ad90e8632c3f$export$2e2bcd8739ae039;

});

parcelRegister("eKTWO", function(module, exports) {

var $hU1C8 = parcelRequire("hU1C8");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $jMyy4 = parcelRequire("jMyy4");

const $862814430f69e6aa$export$aad7e27ed56b51fc = (0, $hU1C8.default);
const $862814430f69e6aa$export$ba9e49b520a30a69 = ({ spaceKey: spaceKey, cloudId: cloudId })=>{
    // Apollo path — runs when experiment is on. useQueryInterop must be called
    // unconditionally; the skip option prevents network activity when unused.
    const { data: apolloData, loading: apolloLoading, refetch: apolloRefetch } = (0, $jMyy4.useQueryInterop)($862814430f69e6aa$export$aad7e27ed56b51fc, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: !(0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false) || !spaceKey,
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/space-curation"
    });
    const apolloResult = (0, $42omo.useMemo)(()=>{
        if (!(0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false)) return null;
        const raw = apolloData?.confluence_remoteObjectSuggestionCount;
        // null data is the suppression signal — this includes the case where the
        // backend returns errors alongside null data (e.g. NotFoundException when
        // the user has been permanently suppressed). Do not gate on apolloError.
        const apolloIsSuppressed = !apolloLoading && raw == null;
        return {
            count: raw ?? 0,
            isLoading: apolloLoading,
            isSuppressed: apolloIsSuppressed,
            refetch: ()=>{
                apolloRefetch();
            }
        };
    }, [
        apolloData,
        apolloLoading,
        apolloRefetch
    ]);
    // cfetch path — used when experiment is off
    const [count, setCount] = (0, $42omo.useState)(0);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [isSuppressed, setIsSuppressed] = (0, $42omo.useState)(false);
    const fetchCount = (0, $42omo.useCallback)(async ()=>{
        if ((0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false)) return;
        if (!spaceKey) {
            setCount(0);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions/count`, {
                method: 'GET'
            });
            const text = await response.text();
            const parsed = parseInt(text, 10);
            if (isNaN(parsed)) setIsSuppressed(true);
            else {
                setCount(parsed);
                setIsSuppressed(false);
            }
        } catch (error) {
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error) && error.response.status === 404) setIsSuppressed(true);
        // silently fail on other errors
        } finally{
            setIsLoading(false);
        }
    }, [
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        fetchCount();
    }, [
        fetchCount
    ]);
    if ((0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false)) return apolloResult ?? {
        count: count,
        isLoading: isLoading,
        isSuppressed: isSuppressed,
        refetch: fetchCount
    };
    return {
        count: count,
        isLoading: isLoading,
        isSuppressed: isSuppressed,
        refetch: fetchCount
    };
};
module.exports["RemoteObjectSuggestionCountQuery"] = $862814430f69e6aa$export$aad7e27ed56b51fc;
module.exports["useFetchSuggestionCount"] = $862814430f69e6aa$export$ba9e49b520a30a69;

});

parcelRegister("hU1C8", function(module, exports) {
/**
 * @generated SignedSource<<fb2a123e9f105316d12025951f51fc75>>
 * @relayHash 2928057d03b4f5d5a1a268a9759b926b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492
const $41493c5c0e5e4e0b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2928057d03b4f5d5a1a268a9759b926b",
            "id": "e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492",
            "metadata": {},
            "name": "useFetchSuggestionCountQuery",
            "operationKind": "query",
            "text": "query useFetchSuggestionCountQuery($cloudId:ID!,$spaceKey:String!){confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}"
        }
    };
}();
$41493c5c0e5e4e0b$var$node.hash = "b167569d29d494154affeddaea33f5a3";
var $41493c5c0e5e4e0b$export$2e2bcd8739ae039 = $41493c5c0e5e4e0b$var$node;
module.exports["default"] = $41493c5c0e5e4e0b$export$2e2bcd8739ae039;

});

parcelRegister("bxFRs", function(module, exports) {

var $fjJAG = parcelRequire("fjJAG");


var $42omo = parcelRequire("42omo");


var $f7B1p = parcelRequire("f7B1p");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $k8jyJ = parcelRequire("k8jyJ");

const $dddab7bf95955fb3$export$318c078b35b04ba8 = (0, $fjJAG.default);
// name` values from `search.configuration.thirdPartyProducts
var $dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_CONNECTOR_NAME = /*#__PURE__*/ function(SEARCH_THIRD_PARTY_CONNECTOR_NAME) {
    SEARCH_THIRD_PARTY_CONNECTOR_NAME["GOOGLE_DRIVE"] = "google-drive-connector";
    SEARCH_THIRD_PARTY_CONNECTOR_NAME["MICROSOFT_TEAMS"] = "microsoft-teams-connector";
    return SEARCH_THIRD_PARTY_CONNECTOR_NAME;
}($dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_CONNECTOR_NAME || {});
const $dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION = 'SearchThirdPartyAuthConfiguration';
const $dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_QUERY = `
query SearchThirdPartyAuthConfiguration($cloudId: ID!) {
	search {
		configuration(cloudId: $cloudId) {
			thirdPartyProducts {
				name
				isUserOAuthed
				outboundAuthUrl
				providerId
			}
		}
	}
}
`.trim();
const $dddab7bf95955fb3$var$filterAuthenticationStatus = (merged)=>{
    const authenticatedServices = {};
    const unauthenticatedServices = {};
    Object.entries(merged).forEach(([product, status])=>{
        if (status.isAuthenticated) authenticatedServices[product] = status;
        else unauthenticatedServices[product] = status;
    });
    return {
        authenticatedServices: authenticatedServices,
        unauthenticatedServices: unauthenticatedServices
    };
};
async function $dddab7bf95955fb3$var$fetchSearchThirdPartyProducts(cloudId) {
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/graphql?q=${$dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'atl-attribution': JSON.stringify({
                    product: 'Confluence Cloud',
                    service: 'confluence-frontend'
                }),
                ...window['GLOBAL_AGG_REGION_STEERING_HINT'] ? {
                    'Atl-Edge-Region-Hint': window['GLOBAL_AGG_REGION_STEERING_HINT']
                } : {}
            },
            body: JSON.stringify({
                query: $dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_QUERY,
                variables: {
                    cloudId: cloudId
                },
                operationName: $dddab7bf95955fb3$var$SEARCH_THIRD_PARTY_AUTH_CONFIGURATION_OPERATION
            })
        });
        const json = await response.json();
        if (json.errors?.length) return {
            error: new Error(json.errors.map((e)=>e.message ?? 'GraphQL error').join('; '))
        };
        const products = json.data?.search?.configuration?.thirdPartyProducts ?? [];
        return {
            products: products
        };
    } catch (e) {
        return {
            error: e instanceof Error ? e : new Error('Failed to fetch search third-party configuration')
        };
    }
}
function $dddab7bf95955fb3$var$authStatusForSearchConnector(products, connectorName, fetchError) {
    const outboundAuthUrl = $dddab7bf95955fb3$var$outboundAuthUrlForConnector(products, connectorName);
    if (fetchError) return {
        isAuthenticated: false,
        error: fetchError,
        outboundAuthUrl: outboundAuthUrl
    };
    const matches = products.filter((p)=>p.name === connectorName);
    if (matches.length === 0) return {
        isAuthenticated: false,
        outboundAuthUrl: outboundAuthUrl
    };
    return {
        isAuthenticated: matches.some((p)=>p.isUserOAuthed),
        outboundAuthUrl: outboundAuthUrl
    };
}
function $dddab7bf95955fb3$var$outboundAuthUrlForConnector(products, connectorName) {
    const match = products.find((p)=>p.name === connectorName);
    return match?.outboundAuthUrl;
}
const $dddab7bf95955fb3$export$3d6949c2295aff10 = ({ products: products, cloudId: cloudId })=>{
    const needsSearchProducts = products.includes((0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT_TEAMS) || products.includes((0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE);
    // Apollo path — always call the hook, but skip when experiment is off or search products not needed
    const { data: apolloAuthData, loading: apolloAuthLoading, refetch: apolloAuthRefetch } = (0, $jMyy4.useQueryInterop)($dddab7bf95955fb3$export$318c078b35b04ba8, {
        variables: {
            cloudId: cloudId
        },
        skip: !(0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false) || !needsSearchProducts,
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/space-curation"
    });
    // cfetch path state — used when experiment is off
    const [mergedByProduct, setMergedByProduct] = (0, $42omo.useState)(null);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [optimisticallyAuthenticatedProducts, setOptimisticallyAuthenticatedProducts] = (0, $42omo.useState)(new Set());
    const markOptimisticallyAuthenticated = (0, $42omo.useCallback)((product)=>{
        setOptimisticallyAuthenticatedProducts((prev)=>{
            const next = new Set(prev);
            next.add(product);
            return next;
        });
    }, []);
    const productsKey = products.join(',');
    const stableProductsRef = (0, $42omo.useRef)(products);
    if (stableProductsRef.current.join(',') !== productsKey) stableProductsRef.current = products;
    const refetch = (0, $42omo.useCallback)(async ()=>{
        // Apollo path handles data reactively — skip imperative fetch
        if ((0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false)) return;
        const products = stableProductsRef.current;
        if (products.length === 0) {
            setMergedByProduct(null);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const merged = {};
            let searchProducts = [];
            let searchFetchError;
            if (products.includes((0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT_TEAMS) || products.includes((0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE)) {
                const searchResult = await $dddab7bf95955fb3$var$fetchSearchThirdPartyProducts(cloudId);
                if ('error' in searchResult) searchFetchError = searchResult.error;
                else searchProducts = searchResult.products;
            }
            for (const product of products)switch(product){
                case (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT_TEAMS:
                    merged[(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT_TEAMS] = $dddab7bf95955fb3$var$authStatusForSearchConnector(searchProducts, "microsoft-teams-connector", searchFetchError);
                    break;
                case (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE:
                    merged[(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE] = $dddab7bf95955fb3$var$authStatusForSearchConnector(searchProducts, "google-drive-connector", searchFetchError);
                    break;
            }
            setMergedByProduct(merged);
        } finally{
            setIsLoading(false);
        }
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        refetch();
    }, [
        refetch
    ]);
    // Apollo-derived merged state
    const apolloMergedByProduct = (0, $42omo.useMemo)(()=>{
        if (!(0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false)) return null;
        const merged = {};
        const searchProductRows = apolloAuthData?.search?.configuration?.thirdPartyProducts ?? [];
        const currentProducts = stableProductsRef.current;
        for (const product of currentProducts)switch(product){
            case (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT_TEAMS:
                merged[(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT_TEAMS] = $dddab7bf95955fb3$var$authStatusForSearchConnector(searchProductRows, "microsoft-teams-connector");
                break;
            case (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE:
                merged[(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE] = $dddab7bf95955fb3$var$authStatusForSearchConnector(searchProductRows, "google-drive-connector");
                break;
        }
        return merged;
    }, [
        apolloAuthData
    ]);
    const activeMerged = (0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false) ? apolloMergedByProduct : mergedByProduct;
    const activeIsLoading = (0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false) ? apolloAuthLoading : isLoading;
    const { authenticatedServices: authenticatedServices, unauthenticatedServices: unauthenticatedServices } = (0, $42omo.useMemo)(()=>{
        if (activeMerged == null) return {
            authenticatedServices: {},
            unauthenticatedServices: {}
        };
        const { authenticatedServices: authed, unauthenticatedServices: unauthed } = $dddab7bf95955fb3$var$filterAuthenticationStatus(activeMerged);
        const filteredUnauthed = {};
        Object.entries(unauthed).forEach(([product, status])=>{
            if (!optimisticallyAuthenticatedProducts.has(product)) filteredUnauthed[product] = status;
        });
        return {
            authenticatedServices: authed,
            unauthenticatedServices: filteredUnauthed
        };
    }, [
        activeMerged,
        optimisticallyAuthenticatedProducts
    ]);
    return {
        authenticatedServices: authenticatedServices,
        unauthenticatedServices: unauthenticatedServices,
        isLoading: activeIsLoading,
        refetch: (0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false) ? async ()=>{
            await apolloAuthRefetch();
        } : refetch,
        markOptimisticallyAuthenticated: markOptimisticallyAuthenticated
    };
};
module.exports["SearchThirdPartyAuthConfigurationQuery"] = $dddab7bf95955fb3$export$318c078b35b04ba8;
module.exports["useFetch3PAuthentications"] = $dddab7bf95955fb3$export$3d6949c2295aff10;

});

parcelRegister("fjJAG", function(module, exports) {
/**
 * @generated SignedSource<<63e4b4b5654d044e095111904b4801ac>>
 * @relayHash 9ab71c77a538002c46c237ae928d5f03
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aa36de1317d82cca9120f0212240884de55487b414401daec208a504366bd2fb
const $663538df32445a7f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "SearchQueryAPI",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "SearchGraphQLConfigurationResponse",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SearchThirdPartyMetadata",
                            "kind": "LinkedField",
                            "name": "thirdPartyProducts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isUserOAuthed"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "outboundAuthUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "providerId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "use3PAuthenticationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "use3PAuthenticationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9ab71c77a538002c46c237ae928d5f03",
            "id": "aa36de1317d82cca9120f0212240884de55487b414401daec208a504366bd2fb",
            "metadata": {},
            "name": "use3PAuthenticationQuery",
            "operationKind": "query",
            "text": "query use3PAuthenticationQuery($cloudId:ID!){search{configuration(cloudId:$cloudId){thirdPartyProducts{name,isUserOAuthed,outboundAuthUrl,providerId}}}}"
        }
    };
}();
$663538df32445a7f$var$node.hash = "395781fb487938898a5cb0d0541a783e";
var $663538df32445a7f$export$2e2bcd8739ae039 = $663538df32445a7f$var$node;
module.exports["default"] = $663538df32445a7f$export$2e2bcd8739ae039;

});

parcelRegister("k8jyJ", function(module, exports) {

var $5ENnH = parcelRequire("5ENnH");


var $i8Cpw = parcelRequire("i8Cpw");


var $fHq8i = parcelRequire("fHq8i");

var $9d3782c3b842cfbc$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["SUGGEST"] = "SUGGEST";
    Action["ACCEPT"] = "ACCEPT";
    Action["REJECT"] = "REJECT";
    Action["IGNORE"] = "IGNORE";
    return Action;
}({});
const $9d3782c3b842cfbc$export$f0c7a43b2eefe22f = {
    LOOM: 'loom',
    MICROSOFT_TEAMS: 'teams',
    GOOGLE_DRIVE: 'gdrive'
};
const $9d3782c3b842cfbc$export$fcdafa222e2a08e2 = Object.values($9d3782c3b842cfbc$export$f0c7a43b2eefe22f);
const $9d3782c3b842cfbc$export$f092255c909e2b34 = [
    $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE,
    $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT_TEAMS
];
const $9d3782c3b842cfbc$export$defe15004d994007 = {
    [$9d3782c3b842cfbc$export$f0c7a43b2eefe22f.LOOM]: (0, (/*@__PURE__*/$parcel$interopDefault($5ENnH))),
    [$9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT_TEAMS]: (0, (/*@__PURE__*/$parcel$interopDefault($i8Cpw))),
    [$9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE]: (0, (/*@__PURE__*/$parcel$interopDefault($fHq8i)))
};
const $9d3782c3b842cfbc$export$51b10001420b4ba3 = [
    {
        pattern: 'docs.google.com/document',
        product: 'Google Docs',
        productKey: 'googleDocs',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'docs.google.com/spreadsheets',
        product: 'Google Sheets',
        productKey: 'googleSheets',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_spreadsheet_x32.png'
    },
    {
        pattern: 'docs.google.com/presentation',
        product: 'Google Slides',
        productKey: 'googleSlides',
        iconUrl: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico'
    },
    {
        pattern: 'drive.google.com',
        product: 'Google Drive',
        productKey: 'googleDrive',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'loom.com',
        product: 'Loom',
        productKey: 'loom',
        iconUrl: 'https://cdn.loom.com/assets/favicons-loom/favicon.ico'
    },
    {
        pattern: 'teams.microsoft.com',
        product: 'Microsoft Teams',
        productKey: 'microsoftTeams',
        iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($i8Cpw)))
    },
    {
        pattern: 'sharepoint.com',
        product: 'Microsoft OneDrive',
        productKey: 'microsoftTeams',
        iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($i8Cpw)))
    }
];
function $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url) {
    return $9d3782c3b842cfbc$export$51b10001420b4ba3.find((entry)=>url.includes(entry.pattern));
}
function $9d3782c3b842cfbc$export$39b141cbf41f04f3(url) {
    return $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url)?.productKey ?? 'link';
}
function $9d3782c3b842cfbc$export$82cacbc9ddf6b54e(url) {
    return $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url)?.iconUrl ?? '';
}
module.exports["Action"] = $9d3782c3b842cfbc$export$e19cd5f9376f8cee;
module.exports["EXTERNAL_PRODUCT_CONNECTION"] = $9d3782c3b842cfbc$export$f0c7a43b2eefe22f;
module.exports["AUTH_OPTIONS"] = $9d3782c3b842cfbc$export$f092255c909e2b34;
module.exports["EXTERNAL_PRODUCT_CONNECTION_ICON_URLS"] = $9d3782c3b842cfbc$export$defe15004d994007;
module.exports["getSuggestionProductKeyFromContentUrl"] = $9d3782c3b842cfbc$export$39b141cbf41f04f3;
module.exports["getSuggestionIconUrlFromContentUrl"] = $9d3782c3b842cfbc$export$82cacbc9ddf6b54e;

});

parcelRegister("5ENnH", function(module, exports) {
module.exports = new URL("loom.96da19c1.svg", import.meta.url).toString();

});

parcelRegister("i8Cpw", function(module, exports) {
module.exports = new URL("onedrive.6c1133d8.svg", import.meta.url).toString();

});

parcelRegister("fHq8i", function(module, exports) {
module.exports = new URL("google-drive.3a58669c.svg", import.meta.url).toString();

});

parcelRegister("4k9rB", function(module, exports) {

var $f2eEV = parcelRequire("f2eEV");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/navigation/setting/manifest.ts
var $32605b18efda5acf$var$navigationSettingAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $f2eEV.NavigationSettingAriResourceOwner),
    resourceType: (0, $f2eEV.NavigationSettingAriResourceType),
    resourceIdSlug: "{firstPartyApp}/{siteId}/{activationId}/{settingId}",
    resourceIdSegmentFormats: {
        firstPartyApp: /[a-z0-9-]{1,100}/,
        siteId: /[a-zA-Z0-9_\-.]{1,255}/,
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        settingId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/navigation/setting/index.ts
var $32605b18efda5acf$export$d9494d14fa8a72a2 = class _NavigationSettingAri extends (0, $3NXcb.RegisteredAri) {
    get firstPartyApp() {
        return this._firstPartyApp;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get settingId() {
        return this._settingId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $32605b18efda5acf$var$navigationSettingAriStaticOpts.qualifier,
            platformQualifier: $32605b18efda5acf$var$navigationSettingAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $32605b18efda5acf$var$navigationSettingAriStaticOpts.resourceOwner,
            resourceType: $32605b18efda5acf$var$navigationSettingAriStaticOpts.resourceType,
            resourceId: `${opts.firstPartyApp}/${opts.siteId}/${opts.activationId}/${opts.settingId}`,
            resourceIdSegmentValues: {
                firstPartyApp: opts.firstPartyApp,
                siteId: opts.siteId,
                activationId: opts.activationId,
                settingId: opts.settingId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $32605b18efda5acf$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $32605b18efda5acf$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(opts);
    }
    getVariables() {
        return {
            firstPartyApp: this.firstPartyApp,
            siteId: this.siteId,
            activationId: this.activationId,
            settingId: this.settingId
        };
    }
    constructor(opts){
        super(opts), this._firstPartyApp = opts.resourceIdSegmentValues.firstPartyApp, this._siteId = opts.resourceIdSegmentValues.siteId, this._activationId = opts.resourceIdSegmentValues.activationId, this._settingId = opts.resourceIdSegmentValues.settingId;
    }
};
module.exports["NavigationSettingAri"] = $32605b18efda5acf$export$d9494d14fa8a72a2;

});

parcelRegister("f2eEV", function(module, exports) {
// src/navigation/setting/types.ts
var $af2269ee0529d700$export$efad67ea8db3f12e = "navigation", $af2269ee0529d700$export$fd28c74ac3f5b728 = "setting";
module.exports["NavigationSettingAriResourceOwner"] = $af2269ee0529d700$export$efad67ea8db3f12e;
module.exports["NavigationSettingAriResourceType"] = $af2269ee0529d700$export$fd28c74ac3f5b728;

});

parcelRegister("dGmBZ", function(module, exports) {
/**
 * @generated SignedSource<<feee02eeb4671c2b8ad67730c80d25ec>>
 * @relayHash 3a2b6de25396328a7215eef4ddb9d1c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da824bb32521ddcdda62ebc8dbb8760dafd02a73da759678ecb4d940100cf6a0
const $819504ce5ddad46c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "position"
    }, v6 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v7 = {
        "kind": "ScalarField",
        "name": "path"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "SpaceSidebarLinks",
            "kind": "LinkedField",
            "name": "spaceSidebarLinks",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "includeHidden",
                            "value": true
                        }
                    ],
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "main",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "webItemKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webItemCompleteKey"
                        },
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDefault"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconClass"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hidden"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canHide"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "linkIdentifier"
                        },
                        v8 /*: any*/ 
                    ],
                    "storageKey": "main(includeHidden:true)"
                },
                {
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "quick",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v3 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "condition": "isLicensed",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAdmin"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourited"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "containsExternalCollaborators"
                },
                {
                    "concreteType": "SpaceHistory",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "didContainUserContent"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceNavigationQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceNavigationQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "3a2b6de25396328a7215eef4ddb9d1c0",
            "id": "da824bb32521ddcdda62ebc8dbb8760dafd02a73da759678ecb4d940100cf6a0",
            "metadata": {},
            "name": "SpaceNavigationQuery",
            "operationKind": "query",
            "text": "query SpaceNavigationQuery($spaceKey:String,$isLicensed:Boolean!){user:confluence_atlassianUser(current:true){id,confluence{permissionType}},spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id,webItemKey,webItemCompleteKey,title,url,position,styleClass,icon{path,width,height,isDefault},iconClass,hidden,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},space(key:$spaceKey){id,key,name,type,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators,history{createdDate},didContainUserContent}}"
        }
    };
}();
$819504ce5ddad46c$var$node.hash = "bca4942401246f836068201b36fd61d7";
var $819504ce5ddad46c$export$2e2bcd8739ae039 = $819504ce5ddad46c$var$node;
module.exports["default"] = $819504ce5ddad46c$export$2e2bcd8739ae039;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<5ee9a080d233dacfb12ae6bd7fab5fc6>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "cc599626e8f53c4256f22a11dfce92c8";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("e5i8U", function(module, exports) {
/**
 * @generated SignedSource<<a8bfa1759f680b51f3aa57c8dc2881e9>>
 * @relayHash e2df23bdc78f713de65477722c69e437
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54
const $352d8776ce9e612e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "e2df23bdc78f713de65477722c69e437",
            "id": "a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54",
            "metadata": {},
            "name": "useSpaceViewsDataSpaceRootQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsDataSpaceRootQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$352d8776ce9e612e$var$node.hash = "0fe50aba41f4ffff776e7aeae840f990";
var $352d8776ce9e612e$export$2e2bcd8739ae039 = $352d8776ce9e612e$var$node;
module.exports["default"] = $352d8776ce9e612e$export$2e2bcd8739ae039;

});

parcelRegister("2fQCH", function(module, exports) {
/**
 * @generated SignedSource<<bb240b22e09d0e349cbdc3cc16e0e4d3>>
 * @relayHash 5841807a4e3bf2a59de617588db23f8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8
const $3b3e50e8050cb646$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "didContainUserContent"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5841807a4e3bf2a59de617588db23f8f",
            "id": "1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8",
            "metadata": {},
            "name": "FooterCreateButtonsQuery",
            "operationKind": "query",
            "text": "query FooterCreateButtonsQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}}"
        }
    };
}();
$3b3e50e8050cb646$var$node.hash = "8f908e5cb8da1d069802e69ea3d7f563";
var $3b3e50e8050cb646$export$2e2bcd8739ae039 = $3b3e50e8050cb646$var$node;
module.exports["default"] = $3b3e50e8050cb646$export$2e2bcd8739ae039;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("9eCf8", function(module, exports) {
/**
 * @generated SignedSource<<8534e239fb0aacc80e873983c931e3ce>>
 * @relayHash 40e147f795d6ae695dc2af4dc7df056c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 689b777212e11a0053f5570d2350dc0482010aee341093c6a0ec7019bd59dc72
const $b0adf32477ccbbfa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v6 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v7 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v8 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v12 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v15 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v16 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v12 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v21 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v22 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v23 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v24 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v25 = [
        {
            "alias": "currentPage",
            "args": [
                v5 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v24 /*: any*/ 
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ 
        },
        "params": {
            "cacheID": "40e147f795d6ae695dc2af4dc7df056c",
            "id": "689b777212e11a0053f5570d2350dc0482010aee341093c6a0ec7019bd59dc72",
            "metadata": {},
            "name": "PageTreeQuery",
            "operationKind": "query",
            "text": "query PageTreeQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$b0adf32477ccbbfa$var$node.hash = "9ca5cb64b6d53c6754a4b7af001ba098";
var $b0adf32477ccbbfa$export$2e2bcd8739ae039 = $b0adf32477ccbbfa$var$node;
module.exports["default"] = $b0adf32477ccbbfa$export$2e2bcd8739ae039;

});

parcelRegister("fL5TY", function(module, exports) {
/**
 * @generated SignedSource<<f44238e1234b91ab73d5297b2f7fc17a>>
 * @relayHash 32d094adde43b53166e21c73e0e18466
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db
const $b517e71d543026da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endCursor"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "statuses"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "endCursor"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orderby",
                    "variableName": "orderBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "statuses"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "blogpost"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blank"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft",
                                        "editor"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "32d094adde43b53166e21c73e0e18466",
            "id": "8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db",
            "metadata": {},
            "name": "BlogTreeRootComponentQuery",
            "operationKind": "query",
            "text": "query BlogTreeRootComponentQuery($spaceKey:String!,$first:Int,$endCursor:String,$statuses:[String],$orderBy:String){content(spaceKey:$spaceKey,type:\"blogpost\",first:$first,orderby:$orderBy,after:$endCursor,status:$statuses){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}"
        }
    };
}();
$b517e71d543026da$var$node.hash = "dcdc7591048a9e478035919db8a4bcd0";
var $b517e71d543026da$export$2e2bcd8739ae039 = $b517e71d543026da$var$node;
module.exports["default"] = $b517e71d543026da$export$2e2bcd8739ae039;

});

parcelRegister("6DMfJ", function(module, exports) {
const $4d5bd09a97238678$export$e3c11860ad35ba05 = [
    'current',
    'draft'
];
const $4d5bd09a97238678$export$70918a400db2b6af = 'VIRTUAL_ROOT_ID';
const $4d5bd09a97238678$export$8ec3d08588d2eeda = 40;
const $4d5bd09a97238678$export$130b26c73bb9d040 = 16;
module.exports["BLOG_STATUSES"] = $4d5bd09a97238678$export$e3c11860ad35ba05;
module.exports["VIRTUAL_ROOT_ID"] = $4d5bd09a97238678$export$70918a400db2b6af;
module.exports["PAGE_SIZE"] = $4d5bd09a97238678$export$8ec3d08588d2eeda;
module.exports["INDENT_PER_LEVEL"] = $4d5bd09a97238678$export$130b26c73bb9d040;

});

parcelRegister("gsSsC", function(module, exports) {
/**
 * @generated SignedSource<<1d6d8b72f5cf1c6f95545e0cb79a843c>>
 * @relayHash 1b389961e5e66b422fc68105162ea2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05
const $64636a4927b33bd4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b389961e5e66b422fc68105162ea2a7",
            "id": "8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05",
            "metadata": {},
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "operationKind": "query",
            "text": "query useIsUserViewingSpaceAsAnonQuery($spaceKey:String){space(key:$spaceKey){id,currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$64636a4927b33bd4$var$node.hash = "7c791401f0e963cfa78bdcff70a3c87c";
var $64636a4927b33bd4$export$2e2bcd8739ae039 = $64636a4927b33bd4$var$node;
module.exports["default"] = $64636a4927b33bd4$export$2e2bcd8739ae039;

});

parcelRegister("gRzR4", function(module, exports) {
/**
 * @generated SignedSource<<437e2fd324fdb1225cb122ee838aa6a2>>
 * @relayHash b761690351fd38a63053eefb2d1de3c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8983e89338e9db4549f597c6a2f7f4aa36777c139be8c74459f3b001a0c76de2
const $7836e6257492ac35$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "generatedBy"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorId"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                },
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        }
                    ]
                },
                {
                    "concreteType": "ContentProperties",
                    "kind": "LinkedField",
                    "name": "contentProperties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DraftContentProperties",
                            "kind": "LinkedField",
                            "name": "draft",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "PublishedContentProperties",
                            "kind": "LinkedField",
                            "name": "latest",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "b761690351fd38a63053eefb2d1de3c0",
            "id": "8983e89338e9db4549f597c6a2f7f4aa36777c139be8c74459f3b001a0c76de2",
            "metadata": {},
            "name": "SmartCreateFeedbackBannerQuery",
            "operationKind": "query",
            "text": "query SmartCreateFeedbackBannerQuery($contentId:ID!){singleContent(id:$contentId){title,id,type,creatorId,version{number},history{createdDate},contentProperties{draft{generatedBy},latest{generatedBy}}}}"
        }
    };
}();
$7836e6257492ac35$var$node.hash = "3b6aed693a868f37a0f80c27a28586a0";
var $7836e6257492ac35$export$2e2bcd8739ae039 = $7836e6257492ac35$var$node;
module.exports["default"] = $7836e6257492ac35$export$2e2bcd8739ae039;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<79c814000abc51a87825021048515fd1>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "031eb89bf77537fd501cf18345136db8";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("4JDbp", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $b400565b9de87bc3$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7RGj.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$var$WidthObserver;
module.exports["default"] = $b400565b9de87bc3$export$2e2bcd8739ae039;

});

parcelRegister("i7RGj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $5EteX.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $63cd7642b16dfa22$export$2f62ee6831462844 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $frIzR.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("cTQmR", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $a6db6a3439cd9017$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $a6db6a3439cd9017$export$7c77c3a9bb93870d;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
        const $ = (0, $frIzR.c)(3);
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("kvJHJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $42omo.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $cbc8g.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("bflGB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lisKW = parcelRequire("lisKW");

parcelRequire("4ARHe");


var $l65Bo = parcelRequire("l65Bo");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).prototype.stopCallback = function(...[e, element, combo]) {
        const isAllowed = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS).map((className)=>element.classList.contains(className)).some((truthful)=>truthful);
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    let accelerator;
    let deprecatedAccelerator;
    let flags;
    let listener;
    let otherProps;
    if ($[0] !== t0) {
        ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps } = t0);
        $[0] = t0;
        $[1] = accelerator;
        $[2] = deprecatedAccelerator;
        $[3] = flags;
        $[4] = listener;
        $[5] = otherProps;
    } else {
        accelerator = $[1];
        deprecatedAccelerator = $[2];
        flags = $[3];
        listener = $[4];
        otherProps = $[5];
    }
    let t1;
    if ($[6] !== accelerator || $[7] !== deprecatedAccelerator || $[8] !== flags || $[9] !== listener) {
        t1 = (e, combo)=>{
            if ((0, $9wGTI.fg)("confluence_frontend_shortcut_deprecation_flag")) (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: combo,
                accelerator: accelerator,
                deprecatedAccelerator: deprecatedAccelerator
            });
            listener(e, combo);
        };
        $[6] = accelerator;
        $[7] = deprecatedAccelerator;
        $[8] = flags;
        $[9] = listener;
        $[10] = t1;
    } else t1 = $[10];
    const deprecatedListener = t1;
    let t2;
    if ($[11] !== deprecatedAccelerator || $[12] !== deprecatedListener || $[13] !== otherProps) {
        t2 = deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: deprecatedAccelerator,
            listener: deprecatedListener,
            ...otherProps
        });
        $[11] = deprecatedAccelerator;
        $[12] = deprecatedListener;
        $[13] = otherProps;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== accelerator || $[16] !== listener || $[17] !== otherProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: accelerator,
            listener: listener,
            ...otherProps
        });
        $[15] = accelerator;
        $[16] = listener;
        $[17] = otherProps;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t2, t3);
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("lisKW", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("4ARHe", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    'ProseMirror-focused',
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
const $e13bb5c64c0a0eec$export$bc654500edb91b60 = 'mod+shift+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;
module.exports["UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$bc654500edb91b60;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $aXWIB.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_zulpv77o _1e0c1txw _4cvr1h6o"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        // Needed to bypass the flags.hideAllFlags() that happens on some page transitions.
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 604800000);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("4tOXV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $1Whri = parcelRequire("1Whri");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window?.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent ?? '';
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_1rjcv77o _1e0c1txw _4cvr1h6o",
    base: "_2rko12b0 _1rjcv77o _18zru2gc _1e0c1o8l _18u0v77o _2hwxv77o",
    contentBefore: "_18u01b66 _2hwxze3t",
    darkBackground: "_bfhk18j9",
    lightBackground: "_bfhkysee"
};
const $05ef07480c610d29$var$i18n = (0, $aXWIB.defineMessages)({
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: t1 } = t0;
    const isTooltip = t1 === undefined ? false : t1;
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $aXWIB.useIntl)();
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== areKeyboardShortcutsEnabled || $[1] !== contentBefore || $[2] !== intl.formatMessage || $[3] !== isEditorShortcut || $[4] !== isTooltip || $[5] !== shortcut) {
        const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        const shouldRenderShortcutSegment = areKeyboardShortcutsEnabled || isEditorShortcut;
        T0 = (0, $gdv5Z.default);
        t2 = "span";
        t3 = $05ef07480c610d29$var$styles.flexCenter;
        t4 = contentBefore;
        t5 = shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                as: "span",
                key: `${shortcutSegment}-${index}`,
                xcss: (0, $1Whri.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
            }, shortcutSegment));
        $[0] = areKeyboardShortcutsEnabled;
        $[1] = contentBefore;
        $[2] = intl.formatMessage;
        $[3] = isEditorShortcut;
        $[4] = isTooltip;
        $[5] = shortcut;
        $[6] = T0;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else {
        T0 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] !== T0 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            as: t2,
            xcss: t3
        }, t4, t5);
        $[11] = T0;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
}; /**
    * Converts shortcut strings like "ctrl+[" to an array of strings like ["Ctrl", "["].
    *
    * This is used for mapping the shortcut constants in `confluence-shortcuts.ts` to the
    * format expected by the ADS Tooltip `shortcut` prop.
    *
    * It checks if keyboard shortcuts are enabled and returns undefined if they are not.
    *
    * @example
    * ```
    * const shortcut = useShortcutStrings({ shortcut: 'ctrl+[' });
    * <Tooltip content="My tooltip" shortcut={shortcut} />
    * ```
    */ 
const $05ef07480c610d29$export$e84ae736f9706c5d = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { shortcut: shortcut, isEditorShortcut: t1 } = t0;
    const isEditorShortcut = t1 === undefined ? false : t1;
    const intl = (0, $aXWIB.useIntl)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return;
    let t2;
    if ($[0] !== intl.formatMessage || $[1] !== shortcut) {
        t2 = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        $[0] = intl.formatMessage;
        $[1] = shortcut;
        $[2] = t2;
    } else t2 = $[2];
    const shortcutStrings = t2;
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return;
    return shortcutStrings;
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;
module.exports["useShortcutStrings"] = $05ef07480c610d29$export$e84ae736f9706c5d;

});

parcelRegister("fZAJP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = ()=>{
    const $ = (0, $frIzR.c)(6);
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $42omo.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    let t0;
    let t1;
    if ($[0] !== isLicensed || $[1] !== isLoggedIn) {
        t0 = ()=>{
            if (typeof window.__SHORTCUT_ENABLED__ !== "boolean") {
                if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
                $640354b193201be7$var$inflightPromise.then(setEnabled);
            }
            $640354b193201be7$var$updaters.add(setEnabled);
            return ()=>{
                $640354b193201be7$var$updaters.delete(setEnabled);
            };
        };
        t1 = [
            isLoggedIn,
            isLicensed
        ];
        $[0] = isLicensed;
        $[1] = isLoggedIn;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    const notify = $640354b193201be7$var$_temp;
    const t2 = Boolean(enabled);
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2,
            notify
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
async function $640354b193201be7$var$_temp(enabled_0) {
    try {
        const res = await (0, $f7B1p.cfetch)("/wiki/rest/confluenceshortcuts/latest/enabled", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                enabled: enabled_0
            })
        });
        if (res.ok) {
            const newEnabled = await res.text() === "true";
            window.__SHORTCUT_ENABLED__ = newEnabled;
            $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
        }
    } catch (t0) {
        const e = t0;
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
}
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("2Pg7f", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $esRft = parcelRequire("esRft");


var $4JWgN = parcelRequire("4JWgN");


var $ee7An = parcelRequire("ee7An");


var $loiTn = parcelRequire("loiTn");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $htJyp = parcelRequire("htJyp");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $fj4Q9 = parcelRequire("fj4Q9");


var $7rhez = parcelRequire("7rhez");


var $dBzHN = parcelRequire("dBzHN");


var $crJ46 = parcelRequire("crJ46");


var $6MWy1 = parcelRequire("6MWy1");


var $2cWqt = parcelRequire("2cWqt");


var $2LGbr = parcelRequire("2LGbr");


var $6Ac15 = parcelRequire("6Ac15");


var $1DG7o = parcelRequire("1DG7o");

const $49cfd043cf935c3d$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $49cfd043cf935c3d$var$AvatarGroup = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { appearance: t1, moreIndicatorAppearance: moreIndicatorAppearance, avatar: t2, borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: t3, size: t4, testId: testId, label: t5, moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: t6, shouldPopupRenderToParent: t7 } = t0;
    const appearance = t1 === undefined ? "stack" : t1;
    const avatar = t2 === undefined ? (0, $esRft.default) : t2;
    const showMoreButtonProps = t3 === undefined ? {} : t3;
    const size = t4 === undefined ? "medium" : t4;
    const label = t5 === undefined ? "avatar group" : t5;
    const tooltipPosition = t6 === undefined ? "bottom" : t6;
    const shouldPopupRenderToParent = t7 === undefined ? false : t7;
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>setIsOpen(false);
        $[0] = t8;
    } else t8 = $[0];
    const onClose = t8;
    let t9;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (event)=>{
            const { clientX: clientX, clientY: clientY, type: type } = event;
            if (type === "keydown" || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
            setIsOpen($49cfd043cf935c3d$var$_temp);
        };
        $[1] = t9;
    } else t9 = $[1];
    const handleTriggerClicked = t9;
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    const { AvatarGroupItem: avatarGroupItemOverrides, Avatar: avatarOverrides, MoreIndicator: moreIndicatorOverrides } = (0, $dBzHN.getOverrides)(overrides);
    let t10;
    let t11;
    if ($[2] !== isFocused || $[3] !== isOpen) {
        t10 = ()=>{
            if (!isOpen) setTriggeredUsingKeyboard(false);
            if ((0, $dh538.fg)("platform-dst-top-layer")) return 0, $ee7An.default;
            if (!isFocused) return 0, $ee7An.default;
            if (isOpen) return 0, $ee7An.default;
            (0, $fFa3V.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $4JWgN.KEY_DOWN)) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
            const unbind = ()=>{
                (0, $fFa3V.bind)(window, {
                    type: "keydown",
                    listener: function openOnKeyDown(e_0) {
                        if (e_0.key === (0, $4JWgN.KEY_DOWN)) {
                            e_0.preventDefault();
                            handleTriggerClicked(e_0);
                        }
                    }
                });
            };
            return unbind;
        };
        t11 = [
            isFocused,
            isOpen,
            handleTriggerClicked
        ];
        $[2] = isFocused;
        $[3] = isOpen;
        $[4] = t10;
        $[5] = t11;
    } else {
        t10 = $[4];
        t11 = $[5];
    }
    (0, $42omo.useEffect)(t10, t11);
    const renderMoreDropdown = function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = (t12)=>{
            const { "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, onClick: onClick, ...props } = t12;
            return moreIndicatorOverrides.render((0, $2LGbr.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                onClick: onClick,
                ...props,
                ...(0, $dh538.fg)("jira-ai-agent-stack") && {
                    appearance: moreIndicatorAppearance
                }
            });
        };
        if (typeof onMoreClick === "function") return renderMoreButton({
            onClick: onMoreClick
        });
        if ((0, $dh538.fg)("platform-dst-top-layer")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rhez.MoreDropdownTopLayer), {
            isOpen: isOpen,
            onClose: onClose,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            data: data,
            max: max,
            overrides: overrides,
            onAvatarClick: onAvatarClick,
            testId: testId,
            labelId: labelId,
            renderMoreButton: renderMoreButton,
            handleTriggerClicked: handleTriggerClicked,
            bindFocus: bindFocus
        });
        const boundary = boundariesElement === "scrollParent" ? "clippingParents" : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === "scrollParent") return;
            return boundariesElement === "window" ? "document" : "viewport";
        })();
        const avatarComponent = avatar && (0, $dh538.fg)("platform-avatar-group-pass-avatar-to-item") ? avatar : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: (t13)=>{
                const { setInitialFocusRef: setInitialFocusRef } = t13;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MWy1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2cWqt.default), {
                    onClick: $49cfd043cf935c3d$var$_temp2,
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
                    titleId: labelId,
                    testId: `${testId}--section`
                }, data.slice(max).map((avatarData, index)=>avatarGroupItemOverrides.render((0, $fj4Q9.default), {
                        avatar: avatarData,
                        avatarComponent: avatarComponent,
                        onAvatarClick: onAvatarClick,
                        avatarOverrides: avatarOverrides,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, index + max)))));
            },
            trigger: (triggerProps)=>(0, $dh538.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
                }, renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                })) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    };
    const max_0 = maxCount === undefined || maxCount === 0 ? $49cfd043cf935c3d$var$MAX_COUNT[appearance] : maxCount;
    const total_0 = data.length;
    const maxAvatar = total_0 > max_0 ? max_0 - 1 : max_0;
    const groupId = (0, $c0qxy.useId)();
    return appearance === "stack" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ac15.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size
    }, data.slice(0, maxAvatar).map((avatarData_0, idx)=>{
        const callback = avatarData_0.onClick || onAvatarClick;
        const finalAvatar = avatarOverrides.render(avatar, {
            ...avatarData_0,
            size: size,
            borderColor: borderColor || avatarData_0.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event_0, analyticsEvent)=>{
                callback(event_0, analyticsEvent, idx);
            } : undefined,
            stackIndex: max_0 - idx
        }, idx);
        if ((0, $dh538.fg)("platform-dst-motion-uplift")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $1DG7o.composeUniqueKey)(avatarData_0, idx)
        }, !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar);
        else return !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            key: (0, $1DG7o.composeUniqueKey)(avatarData_0, idx),
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crJ46.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData_1, idx_0)=>{
        const callback_0 = avatarData_1.onClick || onAvatarClick;
        const finalAvatar_0 = avatarOverrides.render(avatar, {
            ...avatarData_1,
            size: size,
            borderColor: borderColor || avatarData_1.borderColor,
            testId: testId && `${testId}--avatar-${idx_0}`,
            onClick: callback_0 ? (event_1, analyticsEvent_0)=>{
                callback_0(event_1, analyticsEvent_0, idx_0);
            } : undefined,
            stackIndex: max_0 - idx_0
        }, idx_0);
        if ((0, $dh538.fg)("platform-dst-motion-uplift")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $1DG7o.composeUniqueKey)(avatarData_1, idx_0)
        }, !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0);
        else return !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            key: (0, $1DG7o.composeUniqueKey)(avatarData_1, idx_0),
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId));
} : ({ appearance: appearance = 'stack', moreIndicatorAppearance: moreIndicatorAppearance, avatar: avatar = (0, $esRft.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const onClose = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $42omo.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen_0)=>!isOpen_0);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    const { AvatarGroupItem: avatarGroupItemOverrides, Avatar: avatarOverrides, MoreIndicator: moreIndicatorOverrides } = (0, $dBzHN.getOverrides)(overrides);
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow.
    // Skipped when top-layer is enabled — DropdownMenu/top-layer handles
    // ArrowDown-to-open and arrow key navigation internally.
    (0, $42omo.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Top-layer path: ArrowDown-to-open is handled by the menu's
        // own focus management, so skip the parent's ArrowDown handler.
        if ((0, $dh538.fg)('platform-dst-top-layer')) return 0, $ee7An.default;
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $ee7An.default;
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4JWgN.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e_0) {
                    if (e_0.key === (0, $4JWgN.KEY_DOWN)) {
                        // prevent page scroll
                        e_0.preventDefault();
                        handleTriggerClicked(e_0);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>moreIndicatorOverrides.render((0, $2LGbr.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props,
                ...(0, $dh538.fg)('jira-ai-agent-stack') && {
                    appearance: moreIndicatorAppearance
                }
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        if ((0, $dh538.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rhez.MoreDropdownTopLayer), {
            isOpen: isOpen,
            onClose: onClose,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            data: data,
            max: max,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            overrides: overrides,
            onAvatarClick: onAvatarClick,
            testId: testId,
            labelId: labelId,
            renderMoreButton: renderMoreButton,
            handleTriggerClicked: handleTriggerClicked,
            bindFocus: bindFocus
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        const avatarComponent = avatar && (0, $dh538.fg)('platform-avatar-group-pass-avatar-to-item') ? avatar : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MWy1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2cWqt.default), {
                    onClick: (e_1)=>e_1.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
                    titleId: labelId,
                    testId: `${testId}--section`
                }, data.slice(max).map((avatarData, index)=>avatarGroupItemOverrides.render((0, $fj4Q9.default), {
                        avatar: avatarData,
                        avatarComponent: avatarComponent,
                        onAvatarClick: onAvatarClick,
                        avatarOverrides: avatarOverrides,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>(0, $dh538.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
                }, renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                })) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max_0 = maxCount === undefined || maxCount === 0 ? $49cfd043cf935c3d$var$MAX_COUNT[appearance] : maxCount;
    const total_0 = data.length;
    const maxAvatar = total_0 > max_0 ? max_0 - 1 : max_0;
    const groupId = (0, $c0qxy.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ac15.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size
    }, data.slice(0, maxAvatar).map((avatarData_0, idx)=>{
        const callback = avatarData_0.onClick || onAvatarClick;
        const finalAvatar = avatarOverrides.render(avatar, {
            ...avatarData_0,
            size: size,
            borderColor: borderColor || avatarData_0.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event_0, analyticsEvent)=>{
                callback(event_0, analyticsEvent, idx);
            } : undefined,
            stackIndex: max_0 - idx
        }, idx);
        if ((0, $dh538.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $1DG7o.composeUniqueKey)(avatarData_0, idx)
        }, !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar);
        else return !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            key: (0, $1DG7o.composeUniqueKey)(avatarData_0, idx),
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crJ46.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData_1, idx_0)=>{
        const callback_0 = avatarData_1.onClick || onAvatarClick;
        const finalAvatar_0 = avatarOverrides.render(avatar, {
            ...avatarData_1,
            size: size,
            borderColor: borderColor || avatarData_1.borderColor,
            testId: testId && `${testId}--avatar-${idx_0}`,
            onClick: callback_0 ? (event_1, analyticsEvent_0)=>{
                callback_0(event_1, analyticsEvent_0, idx_0);
            } : undefined,
            stackIndex: max_0 - idx_0
        }, idx_0);
        if ((0, $dh538.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $1DG7o.composeUniqueKey)(avatarData_1, idx_0)
        }, !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0);
        else return !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            key: (0, $1DG7o.composeUniqueKey)(avatarData_1, idx_0),
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId));
};
var $49cfd043cf935c3d$export$2e2bcd8739ae039 = $49cfd043cf935c3d$var$AvatarGroup;
function $49cfd043cf935c3d$var$_temp(isOpen_0) {
    return !isOpen_0;
}
function $49cfd043cf935c3d$var$_temp2(e_1) {
    return e_1.stopPropagation();
}
module.exports["default"] = $49cfd043cf935c3d$export$2e2bcd8739ae039;

});

parcelRegister("fj4Q9", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");

var $d77M1 = parcelRequire("d77M1");

var $cGtPE = parcelRequire("cGtPE");


var $dh538 = parcelRequire("dh538");


var $atkCk = parcelRequire("atkCk");

const $b02c3981c986946c$var$AvatarGroupItem = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(24);
    const { avatar: avatar, avatarComponent: avatarComponent, index: index, onAvatarClick: onAvatarClick, testId: testId, avatarOverrides: avatarOverrides, role: role } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: _borderColor, children: children, href: href, isDisabled: isDisabled, key: _key, label: label, name: name, onClick: onClick, presence: presence, size: _size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: _groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $atkCk.default)();
    let t0;
    if ($[0] !== role) {
        t0 = (t1)=>{
            const { children: children_0, className: className, disabled: disabled, draggable: draggable, onClick: onClick_0, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref_0, tabIndex: tabIndex_0, "data-testid": testId_0, ...props_0 } = t1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                type: "button",
                className: className,
                disabled: disabled,
                draggable: draggable,
                onClick: onClick_0,
                onDragStart: onDragStart,
                onMouseDown: onMouseDown,
                ref: ref_0,
                tabIndex: tabIndex_0,
                "data-testid": testId_0,
                role: role,
                ...props_0
            }, children_0);
        };
        $[0] = role;
        $[1] = t0;
    } else t0 = $[1];
    const CustomComponent = t0;
    const AvatarComponent = (0, $dh538.fg)("platform-avatar-group-pass-avatar-to-item") ? avatarComponent ?? (0, $esRft.default) : (0, $esRft.default);
    const AvatarIcon = avatarOverrides && (0, $dh538.fg)("platform-avatar-group-pass-avatar-to-item") ? avatarOverrides.render(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    }, 0) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    const callback = onClick || onAvatarClick;
    let t1;
    if ($[2] !== AvatarIcon || $[3] !== callback || $[4] !== href || $[5] !== index || $[6] !== itemRef || $[7] !== name || $[8] !== ref || $[9] !== role || $[10] !== target || $[11] !== testId) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            if (href) {
                let t2;
                if ($[13] !== callback || $[14] !== index) {
                    t2 = (event)=>callback && callback(event, undefined, index);
                    $[13] = callback;
                    $[14] = index;
                    $[15] = t2;
                } else t2 = $[15];
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
                    ref: (0, $3654r.default)([
                        ref,
                        itemRef
                    ]),
                    href: href,
                    target: target,
                    rel: target === "_blank" ? "noopener noreferrer" : undefined,
                    iconBefore: AvatarIcon,
                    testId: testId,
                    role: role,
                    onClick: t2
                }, name);
                break bb0;
            }
            if (typeof callback === "function") {
                let t2;
                if ($[16] !== callback || $[17] !== index) {
                    t2 = (event_0)=>callback && callback(event_0, undefined, index);
                    $[16] = callback;
                    $[17] = index;
                    $[18] = t2;
                } else t2 = $[18];
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
                    ref: (0, $3654r.default)([
                        ref,
                        itemRef
                    ]),
                    onClick: t2,
                    iconBefore: AvatarIcon,
                    testId: testId,
                    role: role
                }, name);
                break bb0;
            }
        }
        $[2] = AvatarIcon;
        $[3] = callback;
        $[4] = href;
        $[5] = index;
        $[6] = itemRef;
        $[7] = name;
        $[8] = ref;
        $[9] = role;
        $[10] = target;
        $[11] = testId;
        $[12] = t1;
    } else t1 = $[12];
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    let t2;
    if ($[19] !== AvatarIcon || $[20] !== CustomComponent || $[21] !== name || $[22] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d77M1.default), {
            iconBefore: AvatarIcon,
            component: CustomComponent,
            testId: testId
        }, name);
        $[19] = AvatarIcon;
        $[20] = CustomComponent;
        $[21] = name;
        $[22] = testId;
        $[23] = t2;
    } else t2 = $[23];
    return t2;
} : (props, ref)=>{
    const { avatar: avatar, avatarComponent: avatarComponent, index: index, onAvatarClick: onAvatarClick, testId: testId, avatarOverrides: avatarOverrides, role: role } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: _borderColor, children: children, href: href, isDisabled: isDisabled, key: _key, label: label, name: name, onClick: onClick, presence: presence, size: _size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: _groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $atkCk.default)();
    const CustomComponent = ({ children: children_0, className: className, disabled: disabled, draggable: draggable, onClick: onClick_0, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref_0, tabIndex: tabIndex_0, 'data-testid': testId_0, ...props_0 })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick_0,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref_0,
            tabIndex: tabIndex_0,
            "data-testid": testId_0,
            role: role,
            ...props_0
        }, children_0);
    };
    const AvatarComponent = (0, $dh538.fg)('platform-avatar-group-pass-avatar-to-item') ? avatarComponent ?? (0, $esRft.default) : (0, $esRft.default);
    const AvatarIcon = avatarOverrides && (0, $dh538.fg)('platform-avatar-group-pass-avatar-to-item') ? avatarOverrides.render(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: 'transparent',
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: '',
        presence: presence,
        size: 'small',
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    }, 0) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        role: role,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        onClick: (event_0)=>callback && callback(event_0, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        role: role
    }, name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d77M1.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b02c3981c986946c$export$2e2bcd8739ae039 = $b02c3981c986946c$var$AvatarGroupItem;
module.exports["default"] = $b02c3981c986946c$export$2e2bcd8739ae039;

});

parcelRegister("atkCk", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2gBGR = parcelRequire("2gBGR");

// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
const $f69e73e233725633$var$useRegisterItemWithFocusManager = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useRegisterItemWithFocusManager() {
    const $ = (0, $frIzR.c)(3);
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $2gBGR.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== registerRef) {
        t0 = ()=>{
            if (itemRef.current !== null) registerRef(itemRef.current);
        };
        t1 = [
            registerRef
        ];
        $[0] = registerRef;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
    return itemRef;
} : function useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $2gBGR.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
};
var $f69e73e233725633$export$2e2bcd8739ae039 = $f69e73e233725633$var$useRegisterItemWithFocusManager;
module.exports["default"] = $f69e73e233725633$export$2e2bcd8739ae039;

});

parcelRegister("2gBGR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $9cda518d56d21a57$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
module.exports["FocusManagerContext"] = $9cda518d56d21a57$export$f18c1d4fc7326096;

});

parcelRegister("7rhez", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $4JWgN = parcelRequire("4JWgN");


var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $hFC20 = parcelRequire("hFC20");


var $3rEYI = parcelRequire("3rEYI");


var $bgEkj = parcelRequire("bgEkj");


var $4Mlap = parcelRequire("4Mlap");


var $4S3pg = parcelRequire("4S3pg");


var $itGS3 = parcelRequire("itGS3");


var $JW5lP = parcelRequire("JW5lP");


var $fjSIv = parcelRequire("fjSIv");


var $fj4Q9 = parcelRequire("fj4Q9");

const $718509c391f9c05e$var$animation = (0, $hFC20.slideAndFade)();
const $718509c391f9c05e$var$topLayerPlacement = (0, $bgEkj.fromLegacyPlacement)({
    legacy: 'bottom-end'
});
function $718509c391f9c05e$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                    key: index,
                    ...props
                }),
            ...overrides?.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                    key: index,
                    ...props
                }),
            ...overrides?.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props),
            ...overrides?.MoreIndicator
        }
    };
}
function $718509c391f9c05e$export$36ea40361987a72d({ isOpen: isOpen, onClose: onClose, isTriggeredUsingKeyboard: _isTriggeredUsingKeyboard, data: data, max: max, overrides: overrides, onAvatarClick: onAvatarClick, testId: testId, labelId: labelId, renderMoreButton: renderMoreButton, handleTriggerClicked: handleTriggerClicked, bindFocus: _bindFocus }) {
    const handleOnClose = (0, $42omo.useCallback)(({ reason: _reason })=>{
        onClose();
    }, [
        onClose
    ]);
    const triggerRef = (0, $42omo.useRef)(null);
    const popoverRef = (0, $42omo.useRef)(null);
    const menuRef = (0, $42omo.useRef)(null);
    const overflowMenuTestId = testId ? `${testId}--overflow-menu` : undefined;
    const popoverId = (0, $fjSIv.usePopoverId)();
    (0, $itGS3.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: $718509c391f9c05e$var$topLayerPlacement,
        isOpen: isOpen
    });
    // Arrow key navigation inside the open menu
    (0, $JW5lP.useArrowNavigation)({
        containerRef: menuRef,
        onClose: onClose,
        isEnabled: isOpen
    });
    // ArrowDown-to-open: when the trigger is focused and the menu is closed,
    // pressing ArrowDown opens the menu (WAI-ARIA menu button pattern).
    //
    // Bind the keydown listener directly to the trigger element via its ref so
    // that opening the menu does not trigger a focus-driven re-render of the
    // host component, which would unmount and remount the menu items and drop
    // menuitem focus.
    (0, $42omo.useEffect)(()=>{
        const trigger = triggerRef.current;
        if (!trigger || isOpen) return;
        return (0, $fFa3V.bind)(trigger, {
            type: 'keydown',
            listener: function openOnArrowDown(event) {
                if (event.key === (0, $4JWgN.KEY_DOWN)) {
                    // Prevent page scroll when opening the menu via ArrowDown.
                    event.preventDefault();
                    handleTriggerClicked(event);
                }
            }
        });
    }, [
        isOpen,
        handleTriggerClicked
    ]);
    const triggerAria = (0, $3rEYI.getAriaForTrigger)({
        role: 'menu',
        isOpen: isOpen,
        popoverId: popoverId
    });
    const setTriggerRef = (0, $42omo.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderMoreButton({
        ref: setTriggerRef,
        ...triggerAria,
        onClick: handleTriggerClicked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Mlap.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: "avatar group",
        isOpen: isOpen,
        onClose: handleOnClose,
        animate: $718509c391f9c05e$var$animation,
        placement: $718509c391f9c05e$var$topLayerPlacement,
        testId: overflowMenuTestId ? `${overflowMenuTestId}--content` : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S3pg.PopoverSurface), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: menuRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
        minWidth: 250,
        maxHeight: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
        titleId: labelId,
        testId: testId ? `${testId}--section` : undefined
    }, data.slice(max).map((avatar, index)=>$718509c391f9c05e$var$getOverrides(overrides).AvatarGroupItem.render((0, $fj4Q9.default), {
            avatar: avatar,
            onAvatarClick: onAvatarClick,
            testId: testId ? `${testId}--avatar-group-item-${index + max}` : undefined,
            index: index + max,
            role: 'menuitem'
        }, index + max))))))));
}
module.exports["MoreDropdownTopLayer"] = $718509c391f9c05e$export$36ea40361987a72d;

});

parcelRegister("dBzHN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1DG7o = parcelRequire("1DG7o");

function $c815a93d07d97aec$export$f525cc57d37ca574(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>//@ts-ignore - TS2604/TS2786: Component type union causing issues for help-center local consumption with TS 5.9.2
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props),
            ...overrides && overrides.MoreIndicator
        }
    };
}
module.exports["getOverrides"] = $c815a93d07d97aec$export$f525cc57d37ca574;

});

parcelRegister("1DG7o", function(module, exports) {
const $e8b8a534df2444a6$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};
module.exports["composeUniqueKey"] = $e8b8a534df2444a6$export$b067756944994c79;

});

parcelRegister("crJ46", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $g9Srd = parcelRequire("g9Srd");


var $dh538 = parcelRequire("dh538");

const $97f44b6287529f93$var$gutter = "var(--ds-space-negative-050, -4px)";
const $97f44b6287529f93$var$listStyles = null;
const $97f44b6287529f93$var$listStylesFlagged = null;
const $97f44b6287529f93$var$listItemStyles = null;
const $97f44b6287529f93$var$Grid = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { id: id, children: children, testId: testId, "aria-label": label } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $dh538.fg)("platform-avatar-group-spacing-fix") && "_6rth1b66 _y4tiv77o _bozgv77o"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = (0, $dh538.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ $42omo.createElement((0, $g9Srd.default), {
            exitThenEnter: true
        }, (0, $42omo.Children).map(children, $97f44b6287529f93$var$_temp)) : (0, $42omo.Children).map(children, $97f44b6287529f93$var$_temp2);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== id || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ $42omo.createElement("ul", {
            id: id,
            "data-testid": testId,
            "aria-label": label,
            className: t1
        }, t2);
        $[3] = id;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ $42omo.createElement("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"
        ])
    }, (0, $dh538.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $42omo.createElement((0, $g9Srd.default), {
        exitThenEnter: true
    }, (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ $42omo.createElement("li", {
            className: (0, $gMc0m.default)([
                "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
            ])
        }, child))) : (0, $42omo.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ $42omo.createElement("li", {
            className: (0, $gMc0m.default)([
                "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
            ])
        }, child_0))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $97f44b6287529f93$export$2e2bcd8739ae039 = $97f44b6287529f93$var$Grid;
function $97f44b6287529f93$var$_temp(child) {
    return child && /*#__PURE__*/ $42omo.createElement("li", {
        className: (0, $gMc0m.default)([
            "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
        ])
    }, child);
}
function $97f44b6287529f93$var$_temp2(child_0) {
    return child_0 && /*#__PURE__*/ $42omo.createElement("li", {
        className: (0, $gMc0m.default)([
            "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
        ])
    }, child_0);
}
module.exports["default"] = $97f44b6287529f93$export$2e2bcd8739ae039;

});

parcelRegister("6MWy1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $1ztii = parcelRequire("1ztii");


var $2gBGR = parcelRequire("2gBGR");

// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Focus manager__
 *
 * A focus manager {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $5d9c84f5f87b7a1d$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $42omo.useEffect)(()=>{
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $1ztii.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: (0, $1ztii.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gBGR.FocusManagerContext).Provider, {
        value: contextValue
    }, children);
};
var $5d9c84f5f87b7a1d$export$2e2bcd8739ae039 = $5d9c84f5f87b7a1d$var$FocusManager;
module.exports["default"] = $5d9c84f5f87b7a1d$export$2e2bcd8739ae039;

});

parcelRegister("1ztii", function(module, exports) {
$parcel$export(module.exports, "default", () => $15cbf707a7ad85d1$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");

const $15cbf707a7ad85d1$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $15cbf707a7ad85d1$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $15cbf707a7ad85d1$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("2cWqt", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $2gBGR = parcelRequire("2gBGR");

/**
 * It sets focus to the first avatar when popup is open.
 */ const $fd056483eb698f52$var$PopupAvatarGroup = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    let children;
    let isLoading;
    let maxHeight;
    let minHeight;
    let onClick;
    let rest;
    let role;
    let setInitialFocusRef;
    let spacing;
    let t1;
    let t2;
    let testId;
    if ($[0] !== t0) {
        ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: t1, minHeight: minHeight, minWidth: t2, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isLoading;
        $[3] = maxHeight;
        $[4] = minHeight;
        $[5] = onClick;
        $[6] = rest;
        $[7] = role;
        $[8] = setInitialFocusRef;
        $[9] = spacing;
        $[10] = t1;
        $[11] = t2;
        $[12] = testId;
    } else {
        children = $[1];
        isLoading = $[2];
        maxHeight = $[3];
        minHeight = $[4];
        onClick = $[5];
        rest = $[6];
        role = $[7];
        setInitialFocusRef = $[8];
        spacing = $[9];
        t1 = $[10];
        t2 = $[11];
        testId = $[12];
    }
    const maxWidth = t1 === undefined ? 800 : t1;
    const minWidth = t2 === undefined ? 320 : t2;
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $2gBGR.FocusManagerContext));
    let t3;
    let t4;
    if ($[13] !== menuItemRefs || $[14] !== setInitialFocusRef) {
        t3 = ()=>{
            setInitialFocusRef?.(menuItemRefs[0]);
        };
        t4 = [
            menuItemRefs,
            setInitialFocusRef
        ];
        $[13] = menuItemRefs;
        $[14] = setInitialFocusRef;
        $[15] = t3;
        $[16] = t4;
    } else {
        t3 = $[15];
        t4 = $[16];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[17] !== children || $[18] !== isLoading || $[19] !== maxHeight || $[20] !== maxWidth || $[21] !== minHeight || $[22] !== minWidth || $[23] !== onClick || $[24] !== rest || $[25] !== role || $[26] !== spacing || $[27] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            minHeight: minHeight,
            minWidth: minWidth,
            onClick: onClick,
            role: role,
            spacing: spacing,
            testId: testId,
            ...rest
        }, children);
        $[17] = children;
        $[18] = isLoading;
        $[19] = maxHeight;
        $[20] = maxWidth;
        $[21] = minHeight;
        $[22] = minWidth;
        $[23] = onClick;
        $[24] = rest;
        $[25] = role;
        $[26] = spacing;
        $[27] = testId;
        $[28] = t5;
    } else t5 = $[28];
    return t5;
} : ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $2gBGR.FocusManagerContext));
    (0, $42omo.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest
    }, children);
};
var $fd056483eb698f52$export$2e2bcd8739ae039 = $fd056483eb698f52$var$PopupAvatarGroup;
module.exports["default"] = $fd056483eb698f52$export$2e2bcd8739ae039;

});

parcelRegister("2LGbr", function(module, exports) {
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $965bb25f1302cdca$var$boxShadowCssVar = '--avatar-box-shadow';
const $965bb25f1302cdca$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh1ntv _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhki8nm _syazi7uo _16qs1nhn _t9ec1aqe _1ejjglyw _mizu1v1w _ra3xnqa1 _1ah3yh40 _128myh40 _irr3plhp _30l3i7uo _1di61gdz _9h8hi7uo _jlxit94y",
    circle: "_2rko1qll",
    active: "_bfhk15s3 _16qsdfwd _syaz6x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    disabled: "_80om13gf _1peq2wxo _1hfkvuon",
    hexagon: "_mkrz1k6g"
};
const $965bb25f1302cdca$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $965bb25f1302cdca$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $965bb25f1302cdca$var$fontMap = {
    small: "_11c8wadc",
    medium: "_11c8wadc",
    large: "_11c8wadc",
    xlarge: "_11c81d4k",
    xxlarge: "_11c81d4k"
};
const $965bb25f1302cdca$var$MAX_DISPLAY_COUNT = 99;
const $965bb25f1302cdca$var$MoreIndicator = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $965bb25f1302cdca$var$MAX_DISPLAY_COUNT ? $965bb25f1302cdca$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ $42omo.createElement("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$965bb25f1302cdca$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $gMc0m.default)([
            $965bb25f1302cdca$var$styles.root,
            $965bb25f1302cdca$var$borderRadiusMap[size],
            appearance === 'circle' && $965bb25f1302cdca$var$styles.circle,
            appearance === 'hexagon' && (0, $dh538.fg)('jira-ai-agent-stack') && $965bb25f1302cdca$var$styles.hexagon,
            $965bb25f1302cdca$var$widthHeightMap[size],
            $965bb25f1302cdca$var$fontMap[size],
            isActive && $965bb25f1302cdca$var$styles.active
        ])
    }, "+", displayCount);
});
$965bb25f1302cdca$var$MoreIndicator.displayName = 'MoreIndicator'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $965bb25f1302cdca$export$2e2bcd8739ae039 = $965bb25f1302cdca$var$MoreIndicator;
module.exports["default"] = $965bb25f1302cdca$export$2e2bcd8739ae039;

});

parcelRegister("6Ac15", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $g9Srd = parcelRequire("g9Srd");


var $dh538 = parcelRequire("dh538");

const $7b5befcdc2ab883e$var$listStyles = null;
const $7b5befcdc2ab883e$var$listSmallStyles = null;
const $7b5befcdc2ab883e$var$listItemStyles = null;
const $7b5befcdc2ab883e$var$listItemSmallStyles = null;
const $7b5befcdc2ab883e$var$Stack = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { id: id, children: children, testId: testId, "aria-label": label, size: size } = t0;
    let t1;
    if ($[0] !== size) {
        t1 = (0, $gMc0m.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === "small" && (0, $dh538.fg)("platform-avatar-group-spacing-fix") && "_12l21b66"
        ]);
        $[0] = size;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== size) {
        t2 = (0, $dh538.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ $42omo.createElement((0, $g9Srd.default), {
            exitThenEnter: true
        }, (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ $42omo.createElement("li", {
                className: (0, $gMc0m.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === "small" && (0, $dh538.fg)("platform-avatar-group-spacing-fix") && "_12l2r5cr"
                ])
            }, child))) : (0, $42omo.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ $42omo.createElement("li", {
                className: (0, $gMc0m.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === "small" && (0, $dh538.fg)("platform-avatar-group-spacing-fix") && "_12l2r5cr"
                ])
            }, child_0));
        $[2] = children;
        $[3] = size;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== id || $[6] !== label || $[7] !== t1 || $[8] !== t2 || $[9] !== testId) {
        t3 = /*#__PURE__*/ $42omo.createElement("ul", {
            id: id,
            "data-testid": testId,
            "aria-label": label,
            className: t1
        }, t2);
        $[5] = id;
        $[6] = label;
        $[7] = t1;
        $[8] = t2;
        $[9] = testId;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ $42omo.createElement("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l21b66"
        ])
    }, (0, $dh538.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $42omo.createElement((0, $g9Srd.default), {
        exitThenEnter: true
    }, (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ $42omo.createElement("li", {
            className: (0, $gMc0m.default)([
                "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
            ])
        }, child))) : (0, $42omo.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ $42omo.createElement("li", {
            className: (0, $gMc0m.default)([
                "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
            ])
        }, child_0))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7b5befcdc2ab883e$export$2e2bcd8739ae039 = $7b5befcdc2ab883e$var$Stack;
module.exports["default"] = $7b5befcdc2ab883e$export$2e2bcd8739ae039;

});

parcelRegister("fDXXi", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $3rIQe = parcelRequire("3rIQe");


var $KKFWL = parcelRequire("KKFWL");

const $e5e4133608950b34$export$5bf35293e545f20c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $KKFWL.default)(...params));
            event.fire((0, $3rIQe.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $KKFWL.default)(...params));
        event.fire((0, $3rIQe.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $e5e4133608950b34$export$5bf35293e545f20c;

});

parcelRegister("3rIQe", function(module, exports) {
const $10cdf05152c4d491$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $10cdf05152c4d491$export$3f072f06b90c3985;

});

parcelRegister("KKFWL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::d33f3d33520a5e35881ec61f3c089abb>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ const $0ce3610ad559befd$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $0ce3610ad559befd$export$2e2bcd8739ae039 = $0ce3610ad559befd$var$createEventPayload;
module.exports["default"] = $0ce3610ad559befd$export$2e2bcd8739ae039;

});

parcelRegister("2qY37", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $118484dfd30546b5$var$messages = (0, $aXWIB.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $118484dfd30546b5$export$2e2bcd8739ae039 = $118484dfd30546b5$var$messages;
module.exports["default"] = $118484dfd30546b5$export$2e2bcd8739ae039;

});

parcelRegister("bUp2E", function(module, exports) {

var $caPHA = parcelRequire("caPHA");

const $4ebff2946cad2a83$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $4ebff2946cad2a83$var$TEAM_SUBJECT = 'teamProfileCard';
const $4ebff2946cad2a83$var$USER_SUBJECT = 'profilecard';
const $4ebff2946cad2a83$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */ const $4ebff2946cad2a83$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $caPHA.getPageTime)())
        }
    });
const $4ebff2946cad2a83$export$6f40cdf6d42c018d = (type)=>{
    switch(type){
        case 'user':
            return $4ebff2946cad2a83$var$USER_SUBJECT;
        case 'team':
            return $4ebff2946cad2a83$var$TEAM_SUBJECT;
        case 'agent':
            return $4ebff2946cad2a83$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $4ebff2946cad2a83$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $4ebff2946cad2a83$var$createEvent('ui', 'triggered', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $4ebff2946cad2a83$export$c9b0e37b229a297b = (action, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$TEAM_SUBJECT, 'request', attributes);
const $4ebff2946cad2a83$export$12dae48763368ac9 = (action, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$USER_SUBJECT, 'request', attributes);
const $4ebff2946cad2a83$export$41816a317479160b = (type, actionSubjectId, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'rendered', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), actionSubjectId, attributes);
const $4ebff2946cad2a83$export$fdcd134fbeb1f921 = (type, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), 'action', attributes);
const $4ebff2946cad2a83$export$93260987012593be = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$USER_SUBJECT, 'reportingLines', attributes);
const $4ebff2946cad2a83$export$79befd155063a6a7 = (type, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), 'moreActions', attributes);
const $4ebff2946cad2a83$export$2703289b35687fde = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'avatar', attributes);
const $4ebff2946cad2a83$export$b4411a7661cf2d3f = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $4ebff2946cad2a83$export$c86679da702d560e = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $4ebff2946cad2a83$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);
module.exports["PACKAGE_META_DATA"] = $4ebff2946cad2a83$export$849551cf61929d4f;
module.exports["getActionSubject"] = $4ebff2946cad2a83$export$6f40cdf6d42c018d;

});

parcelRegister("caPHA", function(module, exports) {
const $156cb4b98a287aa0$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $156cb4b98a287aa0$var$performanceAvailable = $156cb4b98a287aa0$var$isPerformanceAvailable();
const $156cb4b98a287aa0$var$initialPageTime = Date.now();
const $156cb4b98a287aa0$export$e9faea7c41053334 = ()=>{
    if ($156cb4b98a287aa0$var$performanceAvailable) return performance.now();
    return Date.now() - $156cb4b98a287aa0$var$initialPageTime;
};
module.exports["getPageTime"] = $156cb4b98a287aa0$export$e9faea7c41053334;

});

parcelRegister("exN3e", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $7yDmn = parcelRequire("7yDmn");


var $iXCQx = parcelRequire("iXCQx");


var $2qY37 = parcelRequire("2qY37");


var $aHGHx = parcelRequire("aHGHx");


var $bUp2E = parcelRequire("bUp2E");

const $bcf90d0eb3671370$var$ErrorMessage = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aHGHx.ErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorUserNotFound));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aHGHx.ErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorGeneric), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                color: "color.text.subtlest"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorRetrySuggestion)));
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: reload
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorTryAgain));
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aHGHx.ErrorWrapper), {
            testId: "profilecard-error"
        }, t4, t5, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $42omo.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $bUp2E.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aHGHx.ErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorUserNotFound));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aHGHx.ErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorGeneric), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorRetrySuggestion)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aHGHx.ErrorWrapper), {
        testId: "profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
        label: "icon error"
    }), errorContent(), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: reload
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorTryAgain)));
};
var $bcf90d0eb3671370$export$2e2bcd8739ae039 = $bcf90d0eb3671370$var$ErrorMessage;
module.exports["default"] = $bcf90d0eb3671370$export$2e2bcd8739ae039;

});

parcelRegister("aHGHx", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");

const $5321d44dec43675e$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_19pku2gc",
    teamErrorText: "_syaz1rpy _19pku2gc"
};
const $5321d44dec43675e$export$bb27b7e39840238f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $1Whri.cx)($5321d44dec43675e$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($5321d44dec43675e$var$styles.errorWrapper),
        ...props
    });
const $5321d44dec43675e$export$b065fd053267ec81 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5321d44dec43675e$var$styles.errorTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text"
        }, props.children));
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $5321d44dec43675e$var$styles.errorTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text"
    }, props.children));
const $5321d44dec43675e$export$90d92ccfb27352c6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $1Whri.cx)($5321d44dec43675e$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t0
        }, props.children);
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($5321d44dec43675e$var$styles.teamErrorText)
    }, props.children);
module.exports["ErrorWrapper"] = $5321d44dec43675e$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $5321d44dec43675e$export$b065fd053267ec81;

});

parcelRegister("keVvA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

const $36f6a30267bec70f$var$IntlMessagesProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $frIzR.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $36f6a30267bec70f$export$2e2bcd8739ae039 = $36f6a30267bec70f$var$IntlMessagesProvider;
module.exports["default"] = $36f6a30267bec70f$export$2e2bcd8739ae039;

});

parcelRegister("e9OZ6", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $frIzR.c)(4);
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $e1a1ee666860bb23$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    (0, $42omo.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $e1a1ee666860bb23$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $aXWIB.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) return (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("3nj6t", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $dWjpO = parcelRequire("dWjpO");


var $ay6Zz = parcelRequire("ay6Zz");


var $fDXXi = parcelRequire("fDXXi");


var $ifSYH = parcelRequire("ifSYH");


var $3H8bj = parcelRequire("3H8bj");


var $exN3e = parcelRequire("exN3e");


var $lFfRz = parcelRequire("lFfRz");


var $joVWg = parcelRequire("joVWg");

const $92606fc73eb2626b$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $42omo.useState)();
    // Initialize as true when fix is enabled since we fetch immediately on mount,
    // avoiding a brief error screen flash before the useEffect fires.
    const [isLoading, setIsLoading] = (0, $42omo.useState)((0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $dh538.fg)('confluence_fix_agent_profile_card_flash'));
    const [error, setError] = (0, $42omo.useState)();
    const [isPermitted, setIsPermitted] = (0, $42omo.useState)(true);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const creatorUserId = (0, $42omo.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $3H8bj.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $ay6Zz.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $42omo.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = (0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $dh538.fg)('confluence_fix_agent_profile_card_flash') ? creator_type === 'CUSTOMER' && creator ? (0, $3H8bj.getAAIDFromARI)(creator) : undefined : creatorUserId;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                if ((0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $dh538.fg)('confluence_fix_agent_profile_card_flash')) profileHref = (0, $ay6Zz.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $dWjpO.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        creatorUserId,
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $ifSYH.AgentForbiddenError) && (0, $dh538.fg)('platform_editor_reduced_agent_profile_card')) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $42omo.useEffect)(()=>{
        if (!((0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $dh538.fg)('confluence_fix_agent_profile_card_flash'))) return;
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $dh538.fg)('confluence_fix_agent_profile_card_flash')) return;
        fetchData();
    }, [
        fetchData
    ]);
    if (!isPermitted && (0, $dh538.fg)('platform_editor_reduced_agent_profile_card')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lFfRz.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $joVWg.AgentProfileCardLazy), {
        agent: {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        },
        isLoading: false,
        resourceClient: props.resourceClient,
        cloudId: props.cloudId,
        hideAgentActions: true,
        hideConversationStarters: true,
        hideAiDisclaimer: true,
        hideStarButton: props.hideStarButton
    })));
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lFfRz.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $exN3e.default), {
        reload: ()=>{
            fetchData();
        },
        errorType: error || null,
        fireAnalytics: fireEvent
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $joVWg.AgentProfileCardLazy), {
        agent: agentData,
        isLoading: isLoading,
        hasError: !!error,
        onConversationStartersClick: props.onConversationStartersClick,
        onChatClick: props.onChatClick,
        addFlag: props.addFlag,
        resourceClient: props.resourceClient,
        cloudId: props.cloudId,
        onDeleteAgent: props.onDeleteAgent,
        hideMoreActions: props.hideMoreActions,
        hideAiDisclaimer: props.hideAiDisclaimer,
        hideConversationStarters: props.hideConversationStarters,
        hideAgentActions: props.hideAgentActions,
        hideStarButton: props.hideStarButton
    }));
};
module.exports["AgentProfileCardResourced"] = $92606fc73eb2626b$export$4b013ffffcb40af8;

});

parcelRegister("dWjpO", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $c6GJD = parcelRequire("c6GJD");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");


var $3gadb = parcelRequire("3gadb");


var $f3WwA = parcelRequire("f3WwA");


var $99GMb = parcelRequire("99GMb");


var $bOrYy = parcelRequire("bOrYy");


var $5sLX8 = parcelRequire("5sLX8");

const $c7d46d6df90d8d02$var$styles = {
    clickableItem: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    rovoIconWrapper: "_1e0c1txw",
    name: "_1bah1yb4 _4cvr1y6m",
    description: "_1mouze3t _1i4qfg65 _1nmz1hna",
    headingWrapper: "_kqswh2mm",
    hiddenIconWrapper: "_19pkv77o"
};
const $c7d46d6df90d8d02$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $dh538.fg)('rovo_agent_support_a2a_avatar') ? (0, $bOrYy.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $dh538.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $c7d46d6df90d8d02$export$f35b2eeaa7e3db15 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creator.name, " ", creator.status === "inactive" && formatMessage((0, $5sLX8.messages).agentDeactivated))
            });
            if (creator.type === "REMOTE_A2A") {
                if ((0, $c6GJD.default).getExperimentValue("rovo_hide_remote_a2a_agent_creator_exp", "isEnabled", false)) return null;
                return formatMessage((0, $5sLX8.messages).remoteAgentCreatedBy, {
                    creatorNameWithLink: creator.name
                });
            }
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t1 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = t1;
    } else t1 = $[4];
    const creatorRender = t1;
    if ((0, $dh538.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = creator?.type !== "REMOTE_A2A";
        let t2;
        if ($[5] !== creatorRender || $[6] !== showRovoIcon) {
            t2 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $c7d46d6df90d8d02$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $c7d46d6df90d8d02$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[5] = creatorRender;
            $[6] = showRovoIcon;
            $[7] = t2;
        } else t2 = $[7];
        return t2;
    }
    let t2;
    if ($[8] !== creatorRender) {
        t2 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c7d46d6df90d8d02$var$styles.clickableItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c7d46d6df90d8d02$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[8] = creatorRender;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank"
            }, creator.name, ' ', creator.status === 'inactive' && formatMessage((0, $5sLX8.messages).agentDeactivated))
        });
        if (creator.type === 'REMOTE_A2A') {
            if ((0, $c6GJD.default).getExperimentValue('rovo_hide_remote_a2a_agent_creator_exp', 'isEnabled', false)) return null;
            return formatMessage((0, $5sLX8.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
        } // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    if ((0, $dh538.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c7d46d6df90d8d02$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c7d46d6df90d8d02$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c7d46d6df90d8d02$var$styles.clickableItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c7d46d6df90d8d02$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $c7d46d6df90d8d02$export$e02348ba0b01a210 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c7d46d6df90d8d02$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $5sLX8.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f3WwA.HiddenIcon), {
            label: formatMessage((0, $5sLX8.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.075",
            xcss: $c7d46d6df90d8d02$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99GMb.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: $c7d46d6df90d8d02$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c7d46d6df90d8d02$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && (0, $dh538.fg)("jira_browse_agents_modal") && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: $c7d46d6df90d8d02$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.075",
        xcss: $c7d46d6df90d8d02$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c7d46d6df90d8d02$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage((0, $5sLX8.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f3WwA.HiddenIcon), {
        label: formatMessage((0, $5sLX8.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99GMb.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c7d46d6df90d8d02$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && (0, $dh538.fg)('jira_browse_agents_modal') && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $c7d46d6df90d8d02$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $c7d46d6df90d8d02$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $c7d46d6df90d8d02$export$e02348ba0b01a210;

});

parcelRegister("f3WwA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aRCWA = parcelRequire("aRCWA");

const $b7d9c8d9c2bd0031$export$bce21421c351deb1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRCWA))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRCWA))), props);
module.exports["HiddenIcon"] = $b7d9c8d9c2bd0031$export$bce21421c351deb1;

});

parcelRegister("99GMb", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $gI8uy = parcelRequire("gI8uy");


var $kfYj7 = parcelRequire("kfYj7");


var $fVUfS = parcelRequire("fVUfS");


var $7yZqb = parcelRequire("7yZqb");

const $1eedb87b7dc29dd4$var$styles = {
    pressableStarIcon: "_bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4t3i1tcg _1bsb1tcg",
    hidden: "_tzy4idpf"
};
const $1eedb87b7dc29dd4$export$703abb8bd2abdfa5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const t2 = !visible && $1eedb87b7dc29dd4$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $1Whri.cx)($1eedb87b7dc29dd4$var$styles.pressableStarIcon, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsHovered(true);
        t5 = ()=>setIsHovered(false);
        $[2] = t4;
        $[3] = t5;
    } else {
        t4 = $[2];
        t5 = $[3];
    }
    let t6;
    if ($[4] !== agentName || $[5] !== formatMessage || $[6] !== isHovered || $[7] !== isStarred) {
        t6 = isStarred || isHovered ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
            spacing: "spacious",
            label: formatMessage((0, $7yZqb.default).removeFromFavouritesLabel, {
                agentName: agentName
            }),
            color: "var(--ds-icon-accent-orange, #E06C00)"
        }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
            spacing: "spacious",
            label: formatMessage((0, $7yZqb.default).clickToFavouriteLabel, {
                agentName: agentName
            }),
            color: "var(--ds-icon, #292A2E)"
        });
        $[4] = agentName;
        $[5] = formatMessage;
        $[6] = isHovered;
        $[7] = isStarred;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== handleToggle || $[10] !== t3 || $[11] !== t6) {
        t7 = /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
            xcss: t3,
            onClick: handleToggle,
            onMouseEnter: t4,
            onMouseLeave: t5
        }, t6);
        $[9] = handleToggle;
        $[10] = t3;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($1eedb87b7dc29dd4$var$styles.pressableStarIcon, !visible && $1eedb87b7dc29dd4$var$styles.hidden),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, isStarred || isHovered ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
        spacing: "spacious",
        label: formatMessage((0, $7yZqb.default).removeFromFavouritesLabel, {
            agentName: agentName
        }),
        color: "var(--ds-icon-accent-orange, #E06C00)"
    }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
        spacing: "spacious",
        label: formatMessage((0, $7yZqb.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        color: "var(--ds-icon, #292A2E)"
    }));
};
module.exports["StarIconButton"] = $1eedb87b7dc29dd4$export$703abb8bd2abdfa5;

});

parcelRegister("7yZqb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $89ec1a82fbe0f7cb$var$message = (0, $aXWIB.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $89ec1a82fbe0f7cb$export$2e2bcd8739ae039 = $89ec1a82fbe0f7cb$var$message;
module.exports["default"] = $89ec1a82fbe0f7cb$export$2e2bcd8739ae039;

});

parcelRegister("bOrYy", function(module, exports) {
const $0745c744ad6a5c9d$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $0745c744ad6a5c9d$export$3055eac4de8cbd2b;

});

parcelRegister("5sLX8", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f1c180459da2c1cd$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $f1c180459da2c1cd$export$defe85febe8b728c;

});

parcelRegister("ifSYH", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");


var $3H8bj = parcelRequire("3H8bj");


var $kmvqe = parcelRequire("kmvqe");


var $kCJlM = parcelRequire("kCJlM");


var $aVH97 = parcelRequire("aVH97");


var $ePIZ4 = parcelRequire("ePIZ4");

class $a7f2279fbf11205d$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
const $a7f2279fbf11205d$var$buildActivationIdQuery = (cloudId, product)=>({
        query: `
		query RovoAgentProfileCard_ActivationQuery($cloudId: ID!, $product: String!) {
			tenantContexts(cloudIds: [$cloudId]) {
				activationIdByProduct(product: $product) {
					active
				}
			}
		}
	`,
        variables: {
            cloudId: cloudId,
            product: product
        }
    });
const $a7f2279fbf11205d$var$buildRovoAgentQueryByAri = (agentAri)=>({
        query: `
	  query RovoAgentProfileCard_AgentQueryByAri($agentAri: ID!) {
			agentStudio_agentById(id: $agentAri) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            agentAri: agentAri
        }
    });
const $a7f2279fbf11205d$var$buildRovoAgentQueryByAccountIdOld = (identityAccountId, cloudId)=>({
        query: `
		query RovoAgentProfileCard_AgentQueryByAccountId($identityAccountId: ID!, $cloudId: ID!) {
			agentStudio_agentByIdentityAccountId(identityAccountId: $identityAccountId, cloudId: $cloudId) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
						profileUrl
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            identityAccountId: identityAccountId,
            cloudId: cloudId
        }
    });
const $a7f2279fbf11205d$var$buildRovoAgentQueryByAccountId = (identityAccountId, cloudId)=>({
        query: `
		query RovoAgentProfileCard_AgentQueryByAccountId($id: ID!, $cloudId: String!) {
			agentStudio_agentByIdentityAccountId(cloudId: $cloudId, id: $id) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
						profileUrl
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            id: identityAccountId.startsWith((0, $3H8bj.USER_ARI_PREFIX)) ? identityAccountId : `${0, $3H8bj.USER_ARI_PREFIX}${identityAccountId}`,
            cloudId: cloudId
        }
    });
const $a7f2279fbf11205d$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $a7f2279fbf11205d$export$2e2bcd8739ae039 extends (0, $kmvqe.default) {
    basePath() {
        return '/gateway/api/assist/rovo/v1/agents';
    }
    sharedCacheKey(idValue) {
        return `${this.options.cloudId ?? ''}:${idValue}`;
    }
    getCachedProfile(idValue) {
        if (!(0, $dh538.fg)('platform_editor_agent_profile_card_favourite_sync')) return super.getCachedProfile(idValue);
        const key = this.sharedCacheKey(idValue);
        const cached = (0, $ePIZ4.sharedAgentProfileCache).get(key);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            (0, $ePIZ4.sharedAgentProfileCache).delete(key);
            return null;
        }
        return cached.profile;
    }
    setCachedProfile(idValue, profile) {
        if (!(0, $dh538.fg)('platform_editor_agent_profile_card_favourite_sync')) {
            super.setCachedProfile(idValue, profile);
            return;
        }
        (0, $ePIZ4.sharedAgentProfileCache).set(this.sharedCacheKey(idValue), {
            expire: Date.now() + (this.config.cacheMaxAge || (0, $ePIZ4.SHARED_CACHE_MAX_AGE)),
            profile: profile
        });
    }
    async getActivationId(cloudId, product) {
        const response = await (0, $aVH97.AGGQuery)('/gateway/api/graphql', $a7f2279fbf11205d$var$buildActivationIdQuery(cloudId, product));
        return response?.tenantContexts?.[0]?.activationIdByProduct?.active ?? null;
    }
    async getAgentByARIAgg(agentAri) {
        const response = await (0, $aVH97.AGGQuery)('/gateway/api/graphql', $a7f2279fbf11205d$var$buildRovoAgentQueryByAri(agentAri));
        if (response.agentStudio_agentById?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentById returning QueryError: ${response.agentStudio_agentById.message}`);
        return response?.agentStudio_agentById;
    }
    async getAgentByAccountIdAgg(identityAccountId, cloudId) {
        const response = await (0, $aVH97.AGGQuery)('/gateway/api/graphql', (0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') ? $a7f2279fbf11205d$var$buildRovoAgentQueryByAccountId(identityAccountId, cloudId) : $a7f2279fbf11205d$var$buildRovoAgentQueryByAccountIdOld(identityAccountId, cloudId));
        if (response.agentStudio_agentByIdentityAccountId?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentByIdentityAccountId returning QueryError: ${response.agentStudio_agentByIdentityAccountId.message}`);
        return response?.agentStudio_agentByIdentityAccountId;
    }
    makeRequest(id, analytics) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $a7f2279fbf11205d$var$createHeaders(product, this.options.cloudId);
        let restPromise;
        if (id.type === 'identity') restPromise = fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>{
            if (response.status === 403 && (0, $dh538.fg)('platform_editor_reduced_agent_profile_card')) throw new $a7f2279fbf11205d$export$a6d78d75d03919f1();
            return response.json();
        });
        else restPromise = fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>{
            if (response.status === 403 && (0, $dh538.fg)('platform_editor_reduced_agent_profile_card')) throw new $a7f2279fbf11205d$export$a6d78d75d03919f1();
            return response.json();
        });
        const aggStartTime = (0, $caPHA.getPageTime)();
        const aggPromise = this.getActivationId(this.options.cloudId || '', this.options.productIdentifier || 'rovo').then((activationId)=>{
            if (!activationId) throw new Error('ProfileCard Activation ID not found');
            if (id.type === 'identity') return this.getAgentByAccountIdAgg(id.value, this.options.cloudId || '');
            else {
                const agentAri = `ari:cloud:rovo::agent/activation/${activationId}/${id.value}`;
                return this.getAgentByARIAgg(agentAri);
            }
        })// We are not going to break the flow if the AGG endpoint fails for now
        // @TODO once all the data moved to AGG, we can remove this catch
        .catch((error)=>{
            if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                ...(0, $kCJlM.getErrorAttributes)(error),
                errorType: 'RovoAgentProfileCardAggError',
                duration: (0, $caPHA.getPageTime)() - aggStartTime,
                gateway: true,
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            return Promise.resolve(null);
        });
        return Promise.all([
            restPromise,
            aggPromise
        ]).then(([restData, aggData])=>({
                restData: restData,
                aggData: aggData
            }));
    }
    /**
   * This function will call both REST and AGG endpoints to get the agent profile
   * There are some data that is only available in the AGG endpoint, so we need to call both
   * For any new fields, please only add them to the AGG endpoint
   *
   * @TODO migrate everything to AGG endpoint
   */ getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $caPHA.getPageTime)();
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            this.makeRequest(id, analytics).then((data)=>{
                if (this.cache || (0, $dh538.fg)('platform_editor_agent_profile_card_favourite_sync')) this.setCachedProfile(id.value, data);
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.request', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    ...(0, $kCJlM.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $caPHA.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            const headers = $a7f2279fbf11205d$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.deleteAgent', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                resolve();
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.deleteAgent', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    ...(0, $kCJlM.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $caPHA.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics(`operational.rovoAgentProfilecard.triggered.${actionSubjectId}`, {
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            const headers = $a7f2279fbf11205d$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.succeeded.${actionSubjectId}`, {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                if ((0, $dh538.fg)('platform_editor_agent_profile_card_favourite_sync')) this.syncFavouriteToCache(agentId, isFavourite);
                resolve();
            }).catch((error)=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.failed.${actionSubjectId}`, {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    ...(0, $kCJlM.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    /**
   * Keeps the shared agent profile cache in sync with the favourite state
   */ syncFavouriteToCache(agentId, isFavourite) {
        const prefix = `${this.options.cloudId ?? ''}:`;
        const keysToUpdate = [];
        (0, $ePIZ4.sharedAgentProfileCache).forEach((cached, key)=>{
            if (key.startsWith(prefix) && cached.profile?.restData?.id === agentId) keysToUpdate.push(key);
        });
        keysToUpdate.forEach((key)=>{
            const cached = (0, $ePIZ4.sharedAgentProfileCache).get(key);
            if (!cached) return;
            const { restData: restData } = cached.profile;
            const wasFavourite = restData.favourite;
            const currentCount = restData.favourite_count ?? 0;
            const favouriteCount = isFavourite ? currentCount + (wasFavourite ? 0 : 1) : Math.max(0, currentCount - (wasFavourite ? 1 : 0));
            (0, $ePIZ4.sharedAgentProfileCache).set(key, {
                ...cached,
                profile: {
                    ...cached.profile,
                    restData: {
                        ...restData,
                        favourite: isFavourite,
                        favourite_count: favouriteCount
                    }
                }
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $caPHA.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            const headers = $a7f2279fbf11205d$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.succeeded.getAgentPermissions', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.failed.getAgentPermissions', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    ...(0, $kCJlM.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    constructor(options){
        super(options);
        this.options = void 0;
        this.options = options;
    }
}
module.exports["AgentForbiddenError"] = $a7f2279fbf11205d$export$a6d78d75d03919f1;
module.exports["default"] = $a7f2279fbf11205d$export$2e2bcd8739ae039;

});

parcelRegister("3H8bj", function(module, exports) {
const $7dc5183756e8ff90$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $7dc5183756e8ff90$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($7dc5183756e8ff90$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $7dc5183756e8ff90$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $7dc5183756e8ff90$export$3761e66a04602cbd;

});

parcelRegister("kmvqe", function(module, exports) {

var $9trs7 = parcelRequire("9trs7");

class $b272eafffdf5f2db$export$2e2bcd8739ae039 {
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
    constructor(config){
        this.config = void 0;
        this.cache = void 0;
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $9trs7.LRUMap)(this.config.cacheSize);
    }
}
module.exports["default"] = $b272eafffdf5f2db$export$2e2bcd8739ae039;

});

parcelRegister("kCJlM", function(module, exports) {

var $5mig0 = parcelRequire("5mig0");

const $af1466f9c996c258$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $af1466f9c996c258$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $af1466f9c996c258$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $af1466f9c996c258$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $5mig0.DirectoryGraphQLError)) return !!error && $af1466f9c996c258$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $5mig0.AGGError)) return !!error.errorType && $af1466f9c996c258$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $af1466f9c996c258$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $af1466f9c996c258$export$6ad9e7706a4ee0f8 = (error)=>{
    const defaultErrorAttributes = {
        errorCount: null,
        errorDetails: null,
        errorCategory: null,
        errorType: null,
        errorPath: null,
        errorNumber: null,
        errorStatusCode: null,
        traceId: null,
        errorStack: null
    };
    if (error instanceof (0, $5mig0.DirectoryGraphQLErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($af1466f9c996c258$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($af1466f9c996c258$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $5mig0.DirectoryGraphQLError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber ?? null,
        isSLOFailure: !$af1466f9c996c258$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $5mig0.AGGErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($af1466f9c996c258$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($af1466f9c996c258$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $5mig0.AGGError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorType: error.errorType ?? null,
        errorStatusCode: error.statusCode ?? null,
        isSLOFailure: !$af1466f9c996c258$var$isIgnoredError(error),
        errorCategory: error.classification ?? null
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $5mig0.DirectoryGraphQLErrors) || causeError instanceof (0, $5mig0.AGGErrors)) return $af1466f9c996c258$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                ...defaultErrorAttributes,
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            ...defaultErrorAttributes,
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        ...defaultErrorAttributes,
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $af1466f9c996c258$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $5mig0.DirectoryGraphQLErrors)(errors, traceId);
};
const $af1466f9c996c258$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $5mig0.AGGErrors)(errors, traceId);
};
module.exports["getErrorAttributes"] = $af1466f9c996c258$export$6ad9e7706a4ee0f8;
module.exports["handleDirectoryGraphQLErrors"] = $af1466f9c996c258$export$7642af465ceb7f05;
module.exports["handleAGGErrors"] = $af1466f9c996c258$export$d9ad65d422ee3f8c;

});

parcelRegister("5mig0", function(module, exports) {
class $3fe614271ff38656$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = void 0;
        this.traceId = void 0;
        this.code = code;
        this.traceId = traceId;
    }
}
class $3fe614271ff38656$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = void 0;
        this.type = void 0;
        this.path = void 0;
        this.errorNumber = void 0;
        this.extensions = void 0;
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $3fe614271ff38656$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $3fe614271ff38656$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $3fe614271ff38656$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = void 0;
        this.extensions = void 0;
        this.statusCode = void 0;
        this.errorType = void 0;
        this.classification = void 0;
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $3fe614271ff38656$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $3fe614271ff38656$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}
module.exports["HttpError"] = $3fe614271ff38656$export$65bd6083489bd8bb;
module.exports["DirectoryGraphQLError"] = $3fe614271ff38656$export$c1e4d0de940c06a2;
module.exports["DirectoryGraphQLErrors"] = $3fe614271ff38656$export$5a5fbfed34a590a1;
module.exports["AGGError"] = $3fe614271ff38656$export$4a696f048dcc929;
module.exports["AGGErrors"] = $3fe614271ff38656$export$60d8267243755b9c;

});

parcelRegister("aVH97", function(module, exports) {

var $5mig0 = parcelRequire("5mig0");


var $kCJlM = parcelRequire("kCJlM");

const $c2424f4bc7159f1e$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $c2424f4bc7159f1e$var$id = (headers)=>headers;
async function $c2424f4bc7159f1e$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $c2424f4bc7159f1e$var$id) {
    return $c2424f4bc7159f1e$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $kCJlM.handleDirectoryGraphQLErrors));
}
async function $c2424f4bc7159f1e$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $c2424f4bc7159f1e$var$id) {
    return $c2424f4bc7159f1e$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $kCJlM.handleAGGErrors));
}
async function $c2424f4bc7159f1e$var$graphQLQuery(serviceUrl, query, processHeaders = $c2424f4bc7159f1e$var$id, handleErrors) {
    const headers = processHeaders($c2424f4bc7159f1e$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $5mig0.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}
module.exports["directoryGraphqlQuery"] = $c2424f4bc7159f1e$export$a5b5995619d4fe36;
module.exports["AGGQuery"] = $c2424f4bc7159f1e$export$a14afb5f82fe705;

});

parcelRegister("ePIZ4", function(module, exports) {

var $9trs7 = parcelRequire("9trs7");

const $381198be3c4b63f0$var$SHARED_CACHE_SIZE = 50;
const $381198be3c4b63f0$export$815222107f6bee54 = 300000; // 5 minutes
const $381198be3c4b63f0$export$d0bf8b40238c05cd = new (0, $9trs7.LRUMap)($381198be3c4b63f0$var$SHARED_CACHE_SIZE);
module.exports["SHARED_CACHE_MAX_AGE"] = $381198be3c4b63f0$export$815222107f6bee54;
module.exports["sharedAgentProfileCache"] = $381198be3c4b63f0$export$d0bf8b40238c05cd;

});

parcelRegister("lFfRz", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $50e0a701e5718424$var$styles = {
    wrapper: "_2rko1mok _1bsb1gwv _bfhk1bhr"
};
const $50e0a701e5718424$export$2c6604b50c274e6f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $50e0a701e5718424$var$styles.wrapper
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $50e0a701e5718424$var$styles.wrapper
    }, children);
};
module.exports["AgentProfileCardWrapper"] = $50e0a701e5718424$export$2c6604b50c274e6f;

});

parcelRegister("joVWg", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $2d361b33fb84f723$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dMH7S")));
module.exports["AgentProfileCardLazy"] = $2d361b33fb84f723$export$ed0ca9c1d49ea0bf;

});

parcelRegister("dMH7S", function(module, exports) {

let $a09135ffe36b84b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a09135ffe36b84b4$var$load("7j0mT"),
    $a09135ffe36b84b4$var$load("69R9L"),
    $a09135ffe36b84b4$var$load("6wr18"),
    $a09135ffe36b84b4$var$load("lVz7d"),
    $a09135ffe36b84b4$var$load("i6SWa"),
    $a09135ffe36b84b4$var$load("aSL4q"),
    $a09135ffe36b84b4$var$load("7EorR"),
    $a09135ffe36b84b4$var$load("jPuvo"),
    $a09135ffe36b84b4$var$load("ffEVr"),
    $a09135ffe36b84b4$var$load("hhss7"),
    $a09135ffe36b84b4$var$load("cGVng")
]).then(()=>parcelRequire('iydPT'));

});

parcelRegister("3pfAb", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("k7eoe")).FabricChannel);

var $7l88B = parcelRequire("7l88B");


var $cCg1W = parcelRequire("cCg1W");


var $k7eoe = parcelRequire("k7eoe");


});

parcelRegister("i25hX", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $c5134eb78e10703c$var$MAX_CONSUMED_EVENT_KEYS = 5000;
const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload'
]);
const $c5134eb78e10703c$var$isIgnoredForTriggerLatest = (type)=>{
    if ($c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(type)) return true;
    return type === 'set-message-context' && (0, $dh538.fg)('rovo_chat_fix_cold_start_prompt_insertion');
};
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let consumedEventKeys = new Set();
    let consumedEventKeyQueue = [];
    let subIdCounter = 0;
    let eventIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const createEvent = (payload)=>{
        eventIdCounter += 1;
        return {
            id: eventIdCounter.toString(),
            payload: payload
        };
    };
    const rememberConsumedEventKey = (claimKey)=>{
        consumedEventKeys.add(claimKey);
        consumedEventKeyQueue = [
            ...consumedEventKeyQueue,
            claimKey
        ];
        if (consumedEventKeyQueue.length > $c5134eb78e10703c$var$MAX_CONSUMED_EVENT_KEYS) {
            const [oldestClaimKey, ...remainingClaimKeys] = consumedEventKeyQueue;
            consumedEventKeyQueue = remainingClaimKeys;
            if (oldestClaimKey) consumedEventKeys.delete(oldestClaimKey);
        }
    };
    const claimConsumeOnceEvent = ({ event: event, consumeOnceKey: consumeOnceKey })=>{
        if (!event.payload.consumeOnce || !consumeOnceKey) return true;
        const claimKey = `${consumeOnceKey}:${event.id}`;
        if (consumedEventKeys.has(claimKey)) return false;
        rememberConsumedEventKey(claimKey);
        return true;
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        const callbackWithConsumption = (event)=>{
            if (!claimConsumeOnceEvent({
                event: event,
                consumeOnceKey: consumeOnceKey
            })) return;
            callback(event.payload);
        };
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callbackWithConsumption,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const event = publishQueue[topic];
                callbackWithConsumption(event);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        const event = createEvent(payload);
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$isIgnoredForTriggerLatest(payload.type)) publishQueue[topic] = event;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(event.payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(event));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic,
        consumeOnceKey
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const active = t0 === undefined ? false : t0;
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    let t1;
    let t2;
    if ($[0] !== active || $[1] !== flushQueue) {
        t1 = ()=>()=>{
                if (active) flushQueue();
            };
        t2 = [
            active,
            flushQueue
        ];
        $[0] = active;
        $[1] = flushQueue;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
} : (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (topic)=>{
    const $ = (0, $frIzR.c)(3);
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    let t0;
    if ($[0] !== publish || $[1] !== topic) {
        t0 = (payload)=>publish(topic, payload);
        $[0] = publish;
        $[1] = topic;
        $[2] = t0;
    } else t0 = $[2];
    const publishFn = t0;
    return publishFn;
} : (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount, consumeOnceKey: consumeOnceKey } = t0;
    let t1;
    if ($[0] !== consumeOnceKey || $[1] !== topic || $[2] !== triggerLatest) {
        t1 = {
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        };
        $[0] = consumeOnceKey;
        $[1] = topic;
        $[2] = triggerLatest;
        $[3] = t1;
    } else t1 = $[3];
    $c5134eb78e10703c$export$d3d523392640272(t1, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
} : ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount, consumeOnceKey: consumeOnceKey })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest,
        consumeOnceKey: consumeOnceKey
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("fYQcF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");

parcelRequire("3pfAb");
var $k7eoe = parcelRequire("k7eoe");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $1M9Av = parcelRequire("1M9Av");


var $ea2ui = parcelRequire("ea2ui");


var $j4EkW = parcelRequire("j4EkW");

const $a22fd04a8888d493$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $42omo.useContext)((0, $ifW2H.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $42omo.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $j4EkW.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $42omo.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $dWJ5i.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $ea2ui.AISessionState).unset,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).viewed, (0, $ea2ui.AISessionState).error, (0, $ea2ui.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $ea2ui.AISessionState).initiated,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).submitted, (0, $ea2ui.AISessionState).actioned, (0, $ea2ui.AISessionState).adopted, (0, $ea2ui.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $k7eoe.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $42omo.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $dWJ5i.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $1M9Av.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $42omo.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $42omo.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $42omo.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    // Each `useCallback` above depends on `createAndMergeEventPayload`, which in
    // turn closes over per-render config values (e.g. `additionalAttributes`
    // passed via `customConfig`). When callers spread fresh literals on every
    // render, those callbacks get fresh identities every render too. Consumers
    // that feed them into their own `useCallback` / `useEffect` deps then suffer
    // spurious re-runs — and combined with functional state updaters, this can
    // drive infinite render loops (see Jira CRCS-4870 / OOM regression).
    //
    // Stabilise the entire return surface behind a feature gate.
    const stableReturn = $a22fd04a8888d493$var$useStableMethods(baseReturn);
    return (0, $dh538.fg)('platform_ai_analytics_stable_handler_refs') ? stableReturn : baseReturn;
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a22fd04a8888d493$var$useStableMethods(methods) {
    const ref = (0, $42omo.useRef)(methods);
    ref.current = methods;
    return (0, $42omo.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a22fd04a8888d493$export$ddf49ad062368ad2;

});

parcelRegister("dWJ5i", function(module, exports) {
const $a273a9fd41301c8f$var$t = Symbol.for("@ts-pattern/matcher"), $a273a9fd41301c8f$var$e = Symbol.for("@ts-pattern/isVariadic"), $a273a9fd41301c8f$var$n = "@ts-pattern/anonymous-select-key", $a273a9fd41301c8f$var$r = (t)=>Boolean(t && "object" == typeof t), $a273a9fd41301c8f$var$i = (e)=>e && !!e[$a273a9fd41301c8f$var$t], $a273a9fd41301c8f$var$o = (n, s, c)=>{
    if ($a273a9fd41301c8f$var$i(n)) {
        const e = n[$a273a9fd41301c8f$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($a273a9fd41301c8f$var$r(n)) {
        if (!$a273a9fd41301c8f$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $a273a9fd41301c8f$var$i(s) && s[$a273a9fd41301c8f$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$a273a9fd41301c8f$var$o(t, e[n], c)) && r.every((t, e)=>$a273a9fd41301c8f$var$o(t, n[e], c)) && (0 === a.length || $a273a9fd41301c8f$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$a273a9fd41301c8f$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $a273a9fd41301c8f$var$i(a = r) && "optional" === a[$a273a9fd41301c8f$var$t]().matcherType) && $a273a9fd41301c8f$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $a273a9fd41301c8f$var$s = (e)=>{
    var n, o, a;
    return $a273a9fd41301c8f$var$r(e) ? $a273a9fd41301c8f$var$i(e) ? null != (n = null == (o = (a = e[$a273a9fd41301c8f$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s) : $a273a9fd41301c8f$var$c(Object.values(e), $a273a9fd41301c8f$var$s) : [];
}, $a273a9fd41301c8f$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $a273a9fd41301c8f$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$a273a9fd41301c8f$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $a273a9fd41301c8f$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $a273a9fd41301c8f$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$a273a9fd41301c8f$var$l(t),
        and: (e)=>$a273a9fd41301c8f$var$m(t, e),
        or: (e)=>$a273a9fd41301c8f$var$d(t, e),
        select: (e)=>void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t)
    });
}
function $a273a9fd41301c8f$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$a273a9fd41301c8f$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$a273a9fd41301c8f$var$h($a273a9fd41301c8f$var$l(t)),
        select: (e)=>$a273a9fd41301c8f$var$h(void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t))
    });
}
function $a273a9fd41301c8f$var$l(e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($a273a9fd41301c8f$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $a273a9fd41301c8f$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$s(e),
                matcherType: "optional"
            })
    });
}
const $a273a9fd41301c8f$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $a273a9fd41301c8f$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $a273a9fd41301c8f$var$m(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "and"
            })
    });
}
function $a273a9fd41301c8f$var$d(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "or"
            })
    });
}
function $a273a9fd41301c8f$var$p(e) {
    return {
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $a273a9fd41301c8f$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $a273a9fd41301c8f$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $a273a9fd41301c8f$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $a273a9fd41301c8f$var$n
                    ].concat(void 0 === i ? [] : $a273a9fd41301c8f$var$s(i))
            })
    });
}
function $a273a9fd41301c8f$var$v(t) {
    return "number" == typeof t;
}
function $a273a9fd41301c8f$var$b(t) {
    return "string" == typeof t;
}
function $a273a9fd41301c8f$var$w(t) {
    return "bigint" == typeof t;
}
const $a273a9fd41301c8f$var$S = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return !0;
})), $a273a9fd41301c8f$var$O = $a273a9fd41301c8f$var$S, $a273a9fd41301c8f$var$j = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length >= t))(e))),
        length: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && Boolean(t.match(n))))));
        }
    }), $a273a9fd41301c8f$var$K = $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$b)), $a273a9fd41301c8f$var$x = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e >= t))(e))),
        int: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t < 0)))
    }), $a273a9fd41301c8f$var$E = $a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$v)), $a273a9fd41301c8f$var$A = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e >= t))(e))),
        positive: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t < 0)))
    }), $a273a9fd41301c8f$var$P = $a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$w)), $a273a9fd41301c8f$var$T = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "boolean" == typeof t;
})), $a273a9fd41301c8f$var$B = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "symbol" == typeof t;
})), $a273a9fd41301c8f$var$_ = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null == t;
})), $a273a9fd41301c8f$var$k = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null != t;
}));
var $a273a9fd41301c8f$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $a273a9fd41301c8f$var$t,
    optional: $a273a9fd41301c8f$var$l,
    array: function(...e) {
        return $a273a9fd41301c8f$var$h({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $a273a9fd41301c8f$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$a273a9fd41301c8f$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $a273a9fd41301c8f$var$f(t, (t)=>$a273a9fd41301c8f$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $a273a9fd41301c8f$var$g(t, (t, e)=>{
                                const n = $a273a9fd41301c8f$var$o(s, e, r), i = $a273a9fd41301c8f$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$a273a9fd41301c8f$var$s(e[0]),
                            ...$a273a9fd41301c8f$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $a273a9fd41301c8f$var$m,
    union: $a273a9fd41301c8f$var$d,
    not: function(e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$a273a9fd41301c8f$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $a273a9fd41301c8f$var$p,
    select: $a273a9fd41301c8f$var$y,
    any: $a273a9fd41301c8f$var$S,
    _: $a273a9fd41301c8f$var$O,
    string: $a273a9fd41301c8f$var$K,
    number: $a273a9fd41301c8f$var$E,
    bigint: $a273a9fd41301c8f$var$P,
    boolean: $a273a9fd41301c8f$var$T,
    symbol: $a273a9fd41301c8f$var$B,
    nullish: $a273a9fd41301c8f$var$_,
    nonNullable: $a273a9fd41301c8f$var$k,
    instanceOf: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p($a273a9fd41301c8f$export$ce1e7a33533a73d9(t)));
    }
};
class $a273a9fd41301c8f$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $a273a9fd41301c8f$var$$ = {
    matched: !1,
    value: void 0
};
function $a273a9fd41301c8f$export$4659b591c19bdf3d(t) {
    return new $a273a9fd41301c8f$var$I(t, $a273a9fd41301c8f$var$$);
}
class $a273a9fd41301c8f$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$a273a9fd41301c8f$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $a273a9fd41301c8f$var$$ : {
            matched: !0,
            value: e(s ? $a273a9fd41301c8f$var$n in c ? c[$a273a9fd41301c8f$var$n] : c : this.input, this.input)
        };
        return new $a273a9fd41301c8f$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $a273a9fd41301c8f$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $a273a9fd41301c8f$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $a273a9fd41301c8f$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $a273a9fd41301c8f$var$L(t) {
    throw new $a273a9fd41301c8f$export$6c1467edb54d3773(t);
}
module.exports["P"] = $a273a9fd41301c8f$export$56c0d5a1e737357d;
module.exports["match"] = $a273a9fd41301c8f$export$4659b591c19bdf3d;

});

parcelRegister("ifW2H", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $62e0541727c97e34$export$4f059feb37b5835e = (0, $42omo.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $62e0541727c97e34$export$4f059feb37b5835e;

});

parcelRegister("8Y3mE", function(module, exports) {

var $ea2ui = parcelRequire("ea2ui");

const $a544c5804dc19870$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $ea2ui.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $a544c5804dc19870$export$5013b36eeed4ec19;

});

parcelRegister("ea2ui", function(module, exports) {
var $5a6bb3bf0e14987c$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $5a6bb3bf0e14987c$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $5a6bb3bf0e14987c$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $5a6bb3bf0e14987c$export$7052d5b66e36f60f;

});

parcelRegister("1M9Av", function(module, exports) {
const $699df07a7cf548d4$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $699df07a7cf548d4$export$e053e424fcbfebe9;

});

parcelRegister("j4EkW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kTkuM = parcelRequire("kTkuM");


var $a4NM6 = parcelRequire("a4NM6");


var $ea2ui = parcelRequire("ea2ui");

const $a4ec83494ea42b83$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $42omo.useRef)(undefined);
    const aiSessionStateRef = (0, $42omo.useRef)((0, $ea2ui.AISessionState).unset);
    const setAISessionState = (0, $42omo.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $42omo.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $42omo.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $kTkuM.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $a4NM6.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $42omo.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $a4NM6.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $a4ec83494ea42b83$export$259576f4e7ac6488;

});

parcelRegister("kTkuM", function(module, exports) {

var $dWJ5i = parcelRequire("dWJ5i");


var $cUcZ5 = parcelRequire("cUcZ5");

function $9779584a42635fbf$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $dWJ5i.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
}
module.exports["getNewSingleInstrumentationID"] = $9779584a42635fbf$export$cee2a1482be61648;

});

parcelRegister("a4NM6", function(module, exports) {

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

const $2674cc9dba61bfc1$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $2674cc9dba61bfc1$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $2674cc9dba61bfc1$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $eGd7K.setCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $2674cc9dba61bfc1$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $hEbxW.getCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $2674cc9dba61bfc1$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$d6fb1caea334c7c7;

});

parcelRegister("9tntP", function(module, exports) {

var $hf8aJ = parcelRequire("hf8aJ");

class $e12337ddb1a59fdd$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hf8aJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $e12337ddb1a59fdd$export$12b6b072930fd68f;

});

parcelRegister("hf8aJ", function(module, exports) {

var $9PTEZ = parcelRequire("9PTEZ");

function $41a6d457f373bb5d$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $41a6d457f373bb5d$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $9PTEZ.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $41a6d457f373bb5d$export$c90b54e658fc4d7c;

});

parcelRegister("9PTEZ", function(module, exports) {
class $98d3e4a5bcf7dec9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $98d3e4a5bcf7dec9$export$d27a2b6293f7631c;

});

parcelRegister("9JsQ8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $chO1Z = parcelRequire("chO1Z");


var $7CgcZ = parcelRequire("7CgcZ");

const $b894277b0121d160$var$FileIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), 'grayBold');
$b894277b0121d160$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $b894277b0121d160$export$2e2bcd8739ae039 = $b894277b0121d160$var$FileIconWithColor;
module.exports["default"] = $b894277b0121d160$export$2e2bcd8739ae039;

});

parcelRegister("1w5AW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $1zLiv = parcelRequire("1zLiv");


var $7CgcZ = parcelRequire("7CgcZ");

const $236bd638115a684a$var$ChartBarIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), 'purpleBold');
$236bd638115a684a$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $236bd638115a684a$export$2e2bcd8739ae039 = $236bd638115a684a$var$ChartBarIconWithColor;
module.exports["default"] = $236bd638115a684a$export$2e2bcd8739ae039;

});

parcelRegister("h45kr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $cUQMr = parcelRequire("cUQMr");


var $7CgcZ = parcelRequire("7CgcZ");

const $55cc43e42726cbf8$var$ListBulletedIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), 'greenBold');
$55cc43e42726cbf8$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $55cc43e42726cbf8$export$2e2bcd8739ae039 = $55cc43e42726cbf8$var$ListBulletedIconWithColor;
module.exports["default"] = $55cc43e42726cbf8$export$2e2bcd8739ae039;

});

parcelRegister("8PFSM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $kXb3C = parcelRequire("kXb3C");

const $009878891f6679eb$var$BranchObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $009878891f6679eb$export$2e2bcd8739ae039 = $009878891f6679eb$var$BranchObject;
module.exports["default"] = $009878891f6679eb$export$2e2bcd8739ae039;

});

parcelRegister("gPNUg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $fP78j = parcelRequire("fP78j");

const $1babd35f9918b35a$var$BranchObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $1babd35f9918b35a$export$2e2bcd8739ae039 = $1babd35f9918b35a$var$BranchObjectTile;
module.exports["default"] = $1babd35f9918b35a$export$2e2bcd8739ae039;

});

parcelRegister("fP78j", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $fce53c8d1c9f5417$var$ObjectTileBase = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $frIzR.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size
        }, t3);
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
};
var $fce53c8d1c9f5417$export$2e2bcd8739ae039 = $fce53c8d1c9f5417$var$ObjectTileBase;
module.exports["default"] = $fce53c8d1c9f5417$export$2e2bcd8739ae039;

});

parcelRegister("iZCav", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fZeLS = parcelRequire("fZeLS");


var $kXb3C = parcelRequire("kXb3C");

const $0686486f925c9ddd$var$CommitObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $0686486f925c9ddd$export$2e2bcd8739ae039 = $0686486f925c9ddd$var$CommitObject;
module.exports["default"] = $0686486f925c9ddd$export$2e2bcd8739ae039;

});

parcelRegister("8wyB4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fZeLS = parcelRequire("fZeLS");


var $fP78j = parcelRequire("fP78j");

const $b36b776ec4bd4602$var$CommitObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $b36b776ec4bd4602$export$2e2bcd8739ae039 = $b36b776ec4bd4602$var$CommitObjectTile;
module.exports["default"] = $b36b776ec4bd4602$export$2e2bcd8739ae039;

});

parcelRegister("5NrIb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7OYaz = parcelRequire("7OYaz");


var $kXb3C = parcelRequire("kXb3C");

const $692c05f58e5d3ef7$var$PullRequestObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PullRequestObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PullRequestObject({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $692c05f58e5d3ef7$export$2e2bcd8739ae039 = $692c05f58e5d3ef7$var$PullRequestObject;
module.exports["default"] = $692c05f58e5d3ef7$export$2e2bcd8739ae039;

});

parcelRegister("iAJNI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7OYaz = parcelRequire("7OYaz");


var $fP78j = parcelRequire("fP78j");

const $5112347e60ca9722$var$PullRequestObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PullRequestObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PullRequestObjectTile({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $5112347e60ca9722$export$2e2bcd8739ae039 = $5112347e60ca9722$var$PullRequestObjectTile;
module.exports["default"] = $5112347e60ca9722$export$2e2bcd8739ae039;

});

parcelRegister("gV3jM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eIlE7 = parcelRequire("eIlE7");


var $kXb3C = parcelRequire("kXb3C");

const $2708dfe0209c3c78$var$CodeObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $2708dfe0209c3c78$export$2e2bcd8739ae039 = $2708dfe0209c3c78$var$CodeObject;
module.exports["default"] = $2708dfe0209c3c78$export$2e2bcd8739ae039;

});

parcelRegister("i9OUl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eIlE7 = parcelRequire("eIlE7");


var $fP78j = parcelRequire("fP78j");

const $db9e370fec44d3db$var$CodeObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $db9e370fec44d3db$export$2e2bcd8739ae039 = $db9e370fec44d3db$var$CodeObjectTile;
module.exports["default"] = $db9e370fec44d3db$export$2e2bcd8739ae039;

});

parcelRegister("l5jcq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $kXb3C = parcelRequire("kXb3C");

const $6c7fb5a91851c05d$var$BugObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $6c7fb5a91851c05d$export$2e2bcd8739ae039 = $6c7fb5a91851c05d$var$BugObject;
module.exports["default"] = $6c7fb5a91851c05d$export$2e2bcd8739ae039;

});

parcelRegister("2tvDK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $fP78j = parcelRequire("fP78j");

const $ab5e2ffbeed9f2f4$var$BugObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039 = $ab5e2ffbeed9f2f4$var$BugObjectTile;
module.exports["default"] = $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039;

});

parcelRegister("1WiZb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4BqOc = parcelRequire("4BqOc");


var $kXb3C = parcelRequire("kXb3C");

const $c77f4c6a2336f8ae$var$ChangesObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $c77f4c6a2336f8ae$export$2e2bcd8739ae039 = $c77f4c6a2336f8ae$var$ChangesObject;
module.exports["default"] = $c77f4c6a2336f8ae$export$2e2bcd8739ae039;

});

parcelRegister("ey7ks", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4BqOc = parcelRequire("4BqOc");


var $fP78j = parcelRequire("fP78j");

const $c86924eeed42fcc2$var$ChangesObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $c86924eeed42fcc2$export$2e2bcd8739ae039 = $c86924eeed42fcc2$var$ChangesObjectTile;
module.exports["default"] = $c86924eeed42fcc2$export$2e2bcd8739ae039;

});

parcelRegister("kWiYc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $kXb3C = parcelRequire("kXb3C");

const $4ce94c9023f0019e$var$EpicObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $4ce94c9023f0019e$export$2e2bcd8739ae039 = $4ce94c9023f0019e$var$EpicObject;
module.exports["default"] = $4ce94c9023f0019e$export$2e2bcd8739ae039;

});

parcelRegister("9Q0L0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $fP78j = parcelRequire("fP78j");

const $4cf8a3e1f7af7bd1$var$EpicObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039 = $4cf8a3e1f7af7bd1$var$EpicObjectTile;
module.exports["default"] = $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039;

});

parcelRegister("cKqka", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $kXb3C = parcelRequire("kXb3C");

const $4b99d5ed076c1160$var$IncidentObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $4b99d5ed076c1160$export$2e2bcd8739ae039 = $4b99d5ed076c1160$var$IncidentObject;
module.exports["default"] = $4b99d5ed076c1160$export$2e2bcd8739ae039;

});

parcelRegister("5rEH7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $fP78j = parcelRequire("fP78j");

const $011790d80979173b$var$IncidentObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $011790d80979173b$export$2e2bcd8739ae039 = $011790d80979173b$var$IncidentObjectTile;
module.exports["default"] = $011790d80979173b$export$2e2bcd8739ae039;

});

parcelRegister("7Jxvl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $kXb3C = parcelRequire("kXb3C");

const $ef63a9b3b9aed96b$var$ProblemObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $ef63a9b3b9aed96b$export$2e2bcd8739ae039 = $ef63a9b3b9aed96b$var$ProblemObject;
module.exports["default"] = $ef63a9b3b9aed96b$export$2e2bcd8739ae039;

});

parcelRegister("alMZU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $fP78j = parcelRequire("fP78j");

const $1b8a825273197b02$var$ProblemObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $1b8a825273197b02$export$2e2bcd8739ae039 = $1b8a825273197b02$var$ProblemObjectTile;
module.exports["default"] = $1b8a825273197b02$export$2e2bcd8739ae039;

});

parcelRegister("8d3zB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $kXb3C = parcelRequire("kXb3C");

const $487ca0b42e22d1f4$var$WorkItemObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $487ca0b42e22d1f4$export$2e2bcd8739ae039 = $487ca0b42e22d1f4$var$WorkItemObject;
module.exports["default"] = $487ca0b42e22d1f4$export$2e2bcd8739ae039;

});

parcelRegister("kMqyt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $fP78j = parcelRequire("fP78j");

const $cb2f9539166b293e$var$WorkItemObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $cb2f9539166b293e$export$2e2bcd8739ae039 = $cb2f9539166b293e$var$WorkItemObjectTile;
module.exports["default"] = $cb2f9539166b293e$export$2e2bcd8739ae039;

});

parcelRegister("9J3bP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $kXb3C = parcelRequire("kXb3C");

const $458cec0faf8f188b$var$StoryObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $458cec0faf8f188b$export$2e2bcd8739ae039 = $458cec0faf8f188b$var$StoryObject;
module.exports["default"] = $458cec0faf8f188b$export$2e2bcd8739ae039;

});

parcelRegister("lWQXA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $fP78j = parcelRequire("fP78j");

const $d00f1f002e9877f9$var$StoryObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $d00f1f002e9877f9$export$2e2bcd8739ae039 = $d00f1f002e9877f9$var$StoryObjectTile;
module.exports["default"] = $d00f1f002e9877f9$export$2e2bcd8739ae039;

});

parcelRegister("4KIbP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $49GPt = parcelRequire("49GPt");


var $kXb3C = parcelRequire("kXb3C");

const $627ab7f82241d2c9$var$SubtaskObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $627ab7f82241d2c9$export$2e2bcd8739ae039 = $627ab7f82241d2c9$var$SubtaskObject;
module.exports["default"] = $627ab7f82241d2c9$export$2e2bcd8739ae039;

});

parcelRegister("aV3Bk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $49GPt = parcelRequire("49GPt");


var $fP78j = parcelRequire("fP78j");

const $18453b22d1a1a3c1$var$SubtaskObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $18453b22d1a1a3c1$export$2e2bcd8739ae039 = $18453b22d1a1a3c1$var$SubtaskObjectTile;
module.exports["default"] = $18453b22d1a1a3c1$export$2e2bcd8739ae039;

});

parcelRegister("7G33r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $kXb3C = parcelRequire("kXb3C");

const $b1b906ca2447e962$var$TaskObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $b1b906ca2447e962$export$2e2bcd8739ae039 = $b1b906ca2447e962$var$TaskObject;
module.exports["default"] = $b1b906ca2447e962$export$2e2bcd8739ae039;

});

parcelRegister("fX4W8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $fP78j = parcelRequire("fP78j");

const $042d51f21cf4898d$var$TaskObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $042d51f21cf4898d$export$2e2bcd8739ae039 = $042d51f21cf4898d$var$TaskObjectTile;
module.exports["default"] = $042d51f21cf4898d$export$2e2bcd8739ae039;

});

parcelRegister("j6GAe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

const $90028f2cad692a01$var$BlogObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $90028f2cad692a01$export$2e2bcd8739ae039 = $90028f2cad692a01$var$BlogObjectTile;
module.exports["default"] = $90028f2cad692a01$export$2e2bcd8739ae039;

});

parcelRegister("66dpz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

const $893c7e3925139b9a$var$PageLiveDocObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $893c7e3925139b9a$export$2e2bcd8739ae039 = $893c7e3925139b9a$var$PageLiveDocObject;
module.exports["default"] = $893c7e3925139b9a$export$2e2bcd8739ae039;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("fAGae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

const $0f3b40ffeda05888$var$PageLiveDocObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $0f3b40ffeda05888$export$2e2bcd8739ae039 = $0f3b40ffeda05888$var$PageLiveDocObjectTile;
module.exports["default"] = $0f3b40ffeda05888$export$2e2bcd8739ae039;

});

parcelRegister("k9Smn", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");

//      
var $eaced0a9c3d84a94$var$charCodeOfDot = ".".charCodeAt(0);
var $eaced0a9c3d84a94$var$reEscapeChar = /\\(\\)?/g;
var $eaced0a9c3d84a94$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $eaced0a9c3d84a94$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $eaced0a9c3d84a94$var$charCodeOfDot) result.push("");
    string.replace($eaced0a9c3d84a94$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($eaced0a9c3d84a94$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $eaced0a9c3d84a94$var$keysCache = {};
var $eaced0a9c3d84a94$var$keysRegex = /[.[\]]+/;
var $eaced0a9c3d84a94$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($eaced0a9c3d84a94$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $eaced0a9c3d84a94$var$keysCache[key] = key.split($eaced0a9c3d84a94$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $eaced0a9c3d84a94$var$keysCache[key] = $eaced0a9c3d84a94$var$stringToPath(key);
    }
    return $eaced0a9c3d84a94$var$keysCache[key];
};
//      
var $eaced0a9c3d84a94$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $eaced0a9c3d84a94$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $eaced0a9c3d84a94$var$_toPropertyKey(arg) {
    var key = $eaced0a9c3d84a94$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $eaced0a9c3d84a94$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $eaced0a9c3d84a94$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $bDniu.default)(current, [
                key
            ].map($eaced0a9c3d84a94$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $7Q5yr.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $eaced0a9c3d84a94$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $eaced0a9c3d84a94$var$setInRecursor(state, 0, $eaced0a9c3d84a94$var$toPath(key), value1, destroyArrays);
};
var $eaced0a9c3d84a94$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $eaced0a9c3d84a94$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $eaced0a9c3d84a94$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $eaced0a9c3d84a94$export$c52e5867d5879e24(values, name);
    var error = $eaced0a9c3d84a94$export$c52e5867d5879e24(errors, name);
    if (error && error[$eaced0a9c3d84a94$export$735bebc8ffabf28a]) error = error[$eaced0a9c3d84a94$export$735bebc8ffabf28a];
    var submitError = submitErrors && $eaced0a9c3d84a94$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $eaced0a9c3d84a94$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $eaced0a9c3d84a94$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $eaced0a9c3d84a94$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $eaced0a9c3d84a94$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$eaced0a9c3d84a94$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $eaced0a9c3d84a94$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $eaced0a9c3d84a94$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $eaced0a9c3d84a94$var$subscriptionFilter(result, state, previousState, subscription, $eaced0a9c3d84a94$export$41e855cb628c1b55, $eaced0a9c3d84a94$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $eaced0a9c3d84a94$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $eaced0a9c3d84a94$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $eaced0a9c3d84a94$var$subscriptionFilter(result, state, previousState, subscription, $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3, $eaced0a9c3d84a94$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $eaced0a9c3d84a94$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$eaced0a9c3d84a94$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $eaced0a9c3d84a94$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $eaced0a9c3d84a94$export$83d89fbfd8236492 = "4.20.10";
var $eaced0a9c3d84a94$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $eaced0a9c3d84a94$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $eaced0a9c3d84a94$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $eaced0a9c3d84a94$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $eaced0a9c3d84a94$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $eaced0a9c3d84a94$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $eaced0a9c3d84a94$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $eaced0a9c3d84a94$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($eaced0a9c3d84a94$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $eaced0a9c3d84a94$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $7Q5yr.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $7Q5yr.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $7Q5yr.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $7Q5yr.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $7Q5yr.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $eaced0a9c3d84a94$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $eaced0a9c3d84a94$export$e6bdf135a54e021b,
                    shallowEqual: $eaced0a9c3d84a94$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $7Q5yr.default)({}, state.formState.values)); // clone to avoid writing
            if ($eaced0a9c3d84a94$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $eaced0a9c3d84a94$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $eaced0a9c3d84a94$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $7Q5yr.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $eaced0a9c3d84a94$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $eaced0a9c3d84a94$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $eaced0a9c3d84a94$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$eaced0a9c3d84a94$export$735bebc8ffabf28a]) {
                    var existing = $eaced0a9c3d84a94$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$eaced0a9c3d84a94$export$735bebc8ffabf28a] = error[$eaced0a9c3d84a94$export$735bebc8ffabf28a];
                    merged = $eaced0a9c3d84a94$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$eaced0a9c3d84a94$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$eaced0a9c3d84a94$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $eaced0a9c3d84a94$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $eaced0a9c3d84a94$var$notify(fieldSubscriber, fieldState, lastFieldState, $eaced0a9c3d84a94$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $eaced0a9c3d84a94$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$eaced0a9c3d84a94$var$hasAnyError(formState.errors) && !(formState.submitErrors && $eaced0a9c3d84a94$var$hasAnyError(formState.submitErrors));
        var nextFormState = $eaced0a9c3d84a94$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $eaced0a9c3d84a94$var$notify(state.subscribers, nextFormState, lastFormState, $eaced0a9c3d84a94$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $7Q5yr.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $7Q5yr.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $7Q5yr.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $eaced0a9c3d84a94$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $eaced0a9c3d84a94$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name) === $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $7Q5yr.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $7Q5yr.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $7Q5yr.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $eaced0a9c3d84a94$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$eaced0a9c3d84a94$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $7Q5yr.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $eaced0a9c3d84a94$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $eaced0a9c3d84a94$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $eaced0a9c3d84a94$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $eaced0a9c3d84a94$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $eaced0a9c3d84a94$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $eaced0a9c3d84a94$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $eaced0a9c3d84a94$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $eaced0a9c3d84a94$export$83d89fbfd8236492;
module.exports["createForm"] = $eaced0a9c3d84a94$export$f681a8129d2e9d28;

});

parcelRegister("jTvbt", function(module, exports) {

var $k9Smn = parcelRequire("k9Smn");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $e7bb57e5fe20696d$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $e7bb57e5fe20696d$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($e7bb57e5fe20696d$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $e7bb57e5fe20696d$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $k9Smn.getIn)(errors, input.name);
    });
};
//      
var $e7bb57e5fe20696d$var$noop = function noop() {};
var $e7bb57e5fe20696d$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $e7bb57e5fe20696d$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $e7bb57e5fe20696d$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $e7bb57e5fe20696d$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $e7bb57e5fe20696d$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($e7bb57e5fe20696d$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$e7bb57e5fe20696d$export$2e2bcd8739ae039 = $e7bb57e5fe20696d$var$createDecorator;
module.exports["default"] = $e7bb57e5fe20696d$export$2e2bcd8739ae039;

});

parcelRegister("abN8T", function(module, exports) {

var $92z90 = parcelRequire("92z90");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $76b10d1eacd527b2$var$set(object, path, value) {
    return object == null ? object : $92z90(object, path, value);
}
module.exports = $76b10d1eacd527b2$var$set;

});

parcelRegister("bIwjt", function(module, exports) {

var $kt8c2 = parcelRequire("kt8c2");


var $gmi3X = parcelRequire("gmi3X");

const $852fcfb8b079dfa1$var$SMART_CARD_STORAGE_SCOPE = 'smart-card-social-proof';
const $852fcfb8b079dfa1$export$f44b87513fae83d9 = 'site-cloud-id:v1:';
const $852fcfb8b079dfa1$export$a99d139543208cca = 86400000;
const $852fcfb8b079dfa1$var$smartCardStorage = new (0, $kt8c2.default)($852fcfb8b079dfa1$var$SMART_CARD_STORAGE_SCOPE);
function $852fcfb8b079dfa1$var$normalizeBaseUri(baseUriWithNoTrailingSlash = '') {
    return baseUriWithNoTrailingSlash.replace(/\/$/, '');
}
function $852fcfb8b079dfa1$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash = '') {
    return `${$852fcfb8b079dfa1$export$f44b87513fae83d9}${encodeURIComponent($852fcfb8b079dfa1$var$normalizeBaseUri(baseUriWithNoTrailingSlash))}`;
}
const $852fcfb8b079dfa1$export$dea1a8bc5840f118 = (baseUriWithNoTrailingSlash = '')=>`${$852fcfb8b079dfa1$var$SMART_CARD_STORAGE_SCOPE}_${$852fcfb8b079dfa1$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash)}`;
const $852fcfb8b079dfa1$export$b4b75b5ce5d33ae5 = $852fcfb8b079dfa1$export$dea1a8bc5840f118();
class $852fcfb8b079dfa1$export$a15da722a3b05509 {
    readStoredCloudId(baseUriWithNoTrailingSlash = '') {
        try {
            const cloudId = $852fcfb8b079dfa1$var$smartCardStorage.getItem($852fcfb8b079dfa1$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash));
            if (typeof cloudId !== 'string' || !cloudId || cloudId === 'undefined') return undefined;
            return cloudId;
        } catch  {
            return undefined;
        }
    }
    writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId) {
        if (!cloudId) return;
        try {
            $852fcfb8b079dfa1$var$smartCardStorage.setItemWithExpiry($852fcfb8b079dfa1$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash), cloudId, $852fcfb8b079dfa1$export$a99d139543208cca);
        } catch  {
        // Quota, private-mode, SSR, etc. — same intent as personalization-service.
        }
    }
    ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash) {
        const baseUri = $852fcfb8b079dfa1$var$normalizeBaseUri(baseUriWithNoTrailingSlash);
        const existing = this.tenantInfoInflightPromises.get(baseUri);
        if (existing) return existing;
        const promise = (async ()=>{
            try {
                const response = await (0, $gmi3X.request)('get', `${baseUri}/_edge/tenant_info`);
                const cloudId = response?.cloudId;
                if (cloudId) this.writeStoredCloudId(baseUri, cloudId);
                return cloudId ? cloudId : this.readStoredCloudId(baseUri);
            } catch  {
                return this.readStoredCloudId(baseUri);
            } finally{
                this.tenantInfoInflightPromises.delete(baseUri);
            }
        })();
        this.tenantInfoInflightPromises.set(baseUri, promise);
        return promise;
    }
    /** Pure synchronous read scoped to the given base URI. */ getStoredCloudId(baseUriWithNoTrailingSlash = '') {
        return this.readStoredCloudId(baseUriWithNoTrailingSlash);
    }
    /** Writes tenant cloud id for tests or callers that intentionally warm storage before edge resolves. */ persistStoredCloudId(cloudId, baseUriWithNoTrailingSlash = '') {
        this.writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId);
    }
    async get(baseUriWithNoTrailingSlash = '') {
        const fromStorage = this.readStoredCloudId(baseUriWithNoTrailingSlash);
        if (fromStorage) return fromStorage;
        return this.ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash);
    }
    /** Clears session pin and persisted storage so the next {@link get} is a fresh tenant_info fetch. */ clearCache() {
        this.tenantInfoInflightPromises.clear();
    }
    constructor(){
        this.tenantInfoInflightPromises = new Map();
    }
}
const $852fcfb8b079dfa1$export$1956112846aa829e = new $852fcfb8b079dfa1$export$a15da722a3b05509();
function $852fcfb8b079dfa1$export$763646cf0dfa675c(baseUriWithNoTrailingSlash = '') {
    return $852fcfb8b079dfa1$export$1956112846aa829e.getStoredCloudId(baseUriWithNoTrailingSlash);
}
const $852fcfb8b079dfa1$export$143af22820ae9de = (baseUriWithNoTrailingSlash = '')=>$852fcfb8b079dfa1$export$1956112846aa829e.get(baseUriWithNoTrailingSlash);
module.exports["getCurrentSiteCloudIdSync"] = $852fcfb8b079dfa1$export$763646cf0dfa675c;
module.exports["getCurrentSiteCloudId"] = $852fcfb8b079dfa1$export$143af22820ae9de;

});

parcelRegister("3uVVG", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => (parcelRequire("uvNb9")).AuthError);

var $uvNb9 = parcelRequire("uvNb9");


var $9P47v = parcelRequire("9P47v");

function $81514351a4f15f99$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $9P47v.isOfTypeAuthError)(errorType)) reject(new (0, $uvNb9.AuthError)(data.message, errorType));
                    else reject(new (0, $uvNb9.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $uvNb9.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $81514351a4f15f99$export$73693bad9f5880b0;

});

parcelRegister("uvNb9", function(module, exports) {
class $2c5766e42a4da15d$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $2c5766e42a4da15d$export$145273558d58e0ac;

});

parcelRegister("9P47v", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $cd3cb472abe3f4ba$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $cd3cb472abe3f4ba$export$400e64c8451aa84f;

});

parcelRegister("iWvOt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $Y0OXK = parcelRequire("Y0OXK");


var $hL5V3 = parcelRequire("hL5V3");

const $f9f9ad585f1b3a08$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $hL5V3.useConfluencePageData)(props.src || '', extensionKey || '');
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Y0OXK.Page), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};
module.exports["IFrame"] = $f9f9ad585f1b3a08$export$b32b5f1ee4493319;

});

parcelRegister("Y0OXK", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $I1nNR = parcelRequire("I1nNR");


var $a4Weo = parcelRequire("a4Weo");


var $eNWGp = parcelRequire("eNWGp");

const $7e20740578e340e4$export$6955bcca4cd3539f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eNWGp.Page), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $a4Weo.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $a4Weo.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eNWGp.Page), props));
module.exports["Page"] = $7e20740578e340e4$export$6955bcca4cd3539f;

});

parcelRegister("I1nNR", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { children: children, locale: t1, fetchTranslations: fetchTranslations } = t0;
    const incomingLocale = t1 === undefined ? (0, $chRg6.DEFAULT_LOCALE) : t1;
    const [messages, setMessages] = (0, $42omo.useState)();
    let t2;
    if ($[0] !== incomingLocale) {
        t2 = (0, $chRg6.normalizeLocale)(incomingLocale);
        $[0] = incomingLocale;
        $[1] = t2;
    } else t2 = $[1];
    const locale = t2;
    let t3;
    let t4;
    if ($[2] !== fetchTranslations || $[3] !== locale) {
        t3 = ()=>{
            const loadTranslations = async ()=>{
                const localeMessages = await fetchTranslations(locale);
                setMessages(localeMessages);
            };
            loadTranslations();
        };
        t4 = [
            fetchTranslations,
            locale
        ];
        $[2] = fetchTranslations;
        $[3] = locale;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    if (!messages) return null;
    let t5;
    if ($[6] !== children || $[7] !== locale || $[8] !== messages) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, $chRg6.DEFAULT_LOCALE)
        }, children);
        $[6] = children;
        $[7] = locale;
        $[8] = messages;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE)
    }, children);
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("a4Weo", function(module, exports) {

var $504sF = parcelRequire("504sF");


var $5GGZL = parcelRequire("5GGZL");

const $eae070da32ac21dd$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $504sF.default;
        case 'en-US':
        default:
            return 0, $5GGZL.default;
    }
};
var $eae070da32ac21dd$export$2e2bcd8739ae039 = $eae070da32ac21dd$var$fetchTranslations;
module.exports["default"] = $eae070da32ac21dd$export$2e2bcd8739ae039;

});

parcelRegister("504sF", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e428a1b86b9241f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $0e428a1b86b9241f$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("5GGZL", function(module, exports) {
$parcel$export(module.exports, "default", () => $45dca5869897ff09$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $45dca5869897ff09$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("eNWGp", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7k8Uw = parcelRequire("7k8Uw");


var $aXWIB = parcelRequire("aXWIB");


var $6uh00 = parcelRequire("6uh00");


var $5qNp3 = parcelRequire("5qNp3");

const $172be5db228fd17c$var$ViewComponent = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { locale: locale } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uh00.ViewPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uh00.ViewPage), {
        locale: locale,
        ...props
    });
};
const $172be5db228fd17c$var$EditComponent = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { locale: locale } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5qNp3.EditPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5qNp3.EditPage), {
        locale: locale,
        ...props
    });
};
const $172be5db228fd17c$export$6955bcca4cd3539f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { locale: locale } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7k8Uw.Page), {
            locale: locale,
            ...props,
            viewComponent: $172be5db228fd17c$var$ViewComponent,
            editComponent: $172be5db228fd17c$var$EditComponent
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7k8Uw.Page), {
        locale: locale,
        ...props,
        viewComponent: $172be5db228fd17c$var$ViewComponent,
        editComponent: $172be5db228fd17c$var$EditComponent
    });
};
module.exports["Page"] = $172be5db228fd17c$export$6955bcca4cd3539f;

});

parcelRegister("6uh00", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $I1nNR = parcelRequire("I1nNR");


var $a4Weo = parcelRequire("a4Weo");


var $ktyYp = parcelRequire("ktyYp");

const $6d62a53500c7e32b$export$767e3006bdbb424a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ktyYp.ViewPage), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $a4Weo.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $a4Weo.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ktyYp.ViewPage), props));
module.exports["ViewPage"] = $6d62a53500c7e32b$export$767e3006bdbb424a;

});

parcelRegister("ktyYp", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aI44c = parcelRequire("aI44c");


var $aXWIB = parcelRequire("aXWIB");

const $216b1f3eb7fd7629$export$767e3006bdbb424a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { locale: locale } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aI44c.ViewPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aI44c.ViewPage), {
        locale: locale,
        ...props
    });
};
module.exports["ViewPage"] = $216b1f3eb7fd7629$export$767e3006bdbb424a;

});

parcelRegister("5qNp3", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $I1nNR = parcelRequire("I1nNR");


var $a4Weo = parcelRequire("a4Weo");


var $657oH = parcelRequire("657oH");

const $8690a9fa0f1ae334$export$1fea75498367c4ac = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $657oH.EditPage), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $a4Weo.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $a4Weo.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $657oH.EditPage), props));
module.exports["EditPage"] = $8690a9fa0f1ae334$export$1fea75498367c4ac;

});

parcelRegister("657oH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aiCKw = parcelRequire("aiCKw");


var $aXWIB = parcelRequire("aXWIB");

const $015976cb7cb7475e$export$1fea75498367c4ac = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { locale: locale } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aiCKw.EditPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aiCKw.EditPage), {
        locale: locale,
        ...props
    });
};
module.exports["EditPage"] = $015976cb7cb7475e$export$1fea75498367c4ac;

});

parcelRegister("hL5V3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bRSdj = parcelRequire("bRSdj");

var $lw2XG = parcelRequire("lw2XG");

var $7e0969c4e751a56a$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $7e0969c4e751a56a$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $7e0969c4e751a56a$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $7e0969c4e751a56a$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $42omo.useMemo)(()=>{
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($7e0969c4e751a56a$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $lw2XG.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $42omo.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $bRSdj.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};
module.exports["useConfluencePageData"] = $7e0969c4e751a56a$export$10fb2803bc7b79fc;

});

parcelRegister("hpNab", function(module, exports) {

var $kFwgS = parcelRequire("kFwgS");


var $9tQM5 = parcelRequire("9tQM5");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("cGc86", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $diaaX.createUniqueKey)();
        $[0] = t1;
    } else t1 = $[0];
    const uniqueKey = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            uniqueKey: uniqueKey
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        }
    }, children);
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
} : ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("kudeD", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        }
    }, children);
};
const $0a26766864270169$export$865423e6f8e2e839 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
} : ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { children: children, contentType: contentType, sourceComponent: sourceComponent } = t0;
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    let t1;
    let t2;
    if ($[0] !== contentType || $[1] !== isInitialized || $[2] !== setContentType) {
        t1 = ()=>{
            isInitialized && contentType && setContentType(contentType);
        };
        t2 = [
            isInitialized,
            contentType,
            setContentType
        ];
        $[0] = contentType;
        $[1] = isInitialized;
        $[2] = setContentType;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[5] !== children || $[6] !== contentType || $[7] !== isInitialized || $[8] !== sourceComponent) {
        t3 = !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a26766864270169$var$Provider, {
            contentType: contentType,
            sourceComponent: sourceComponent
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[5] = children;
        $[6] = contentType;
        $[7] = isInitialized;
        $[8] = sourceComponent;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2LONO = parcelRequire("2LONO");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $aXWIB = parcelRequire("aXWIB");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $2LONO.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$serializeQueryParams = (queryParams)=>queryParams ? new URLSearchParams(Object.entries(queryParams).sort(([paramA], [paramB])=>paramA.localeCompare(paramB))).toString() : '';
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, queryParams: consumerQueryParams, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature_0)=>feature_0 !== 'edit' && feature_0 !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature_1)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature_1)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature_2)=>(0, $cezNv.isRedirectionEnabled)(feature_2)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const consumerQueryParamsString = $5a8d62fce039da42$var$serializeQueryParams(consumerQueryParams);
    const contentConfigurationQueryParamsString = $5a8d62fce039da42$var$serializeQueryParams(contentConfiguration?.queryParams);
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        const searchParams = new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery
        });
        new URLSearchParams(consumerQueryParamsString).forEach((value, key)=>{
            if (!searchParams.has(key)) searchParams.set(key, value);
        });
        new URLSearchParams(contentConfigurationQueryParamsString).forEach((value_0, key_0)=>{
            searchParams.set(key_0, value_0);
        });
        return `?${searchParams.toString()}`;
    }, [
        consumerQueryParamsString,
        contentConfigurationQueryParamsString,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $d21a741e0de1277a$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $d21a741e0de1277a$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$d21a741e0de1277a$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $d21a741e0de1277a$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("apdJR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $chO1Z = parcelRequire("chO1Z");


var $lebfc = parcelRequire("lebfc");


var $8PFSM = parcelRequire("8PFSM");


var $l5jcq = parcelRequire("l5jcq");


var $1WiZb = parcelRequire("1WiZb");


var $gV3jM = parcelRequire("gV3jM");


var $iZCav = parcelRequire("iZCav");


var $kWiYc = parcelRequire("kWiYc");


var $cKqka = parcelRequire("cKqka");


var $7Jxvl = parcelRequire("7Jxvl");


var $5NrIb = parcelRequire("5NrIb");


var $9J3bP = parcelRequire("9J3bP");


var $4KIbP = parcelRequire("4KIbP");


var $7G33r = parcelRequire("7G33r");


var $8d3zB = parcelRequire("8d3zB");


var $dh538 = parcelRequire("dh538");


var $kbte2 = parcelRequire("kbte2");


var $7063J = parcelRequire("7063J");


var $a1WXB = parcelRequire("a1WXB");

const $1bd73597fc32b869$var$extractorPriorityMap = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
const $1bd73597fc32b869$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $1bd73597fc32b869$var$getEmptyJsonLd = ()=>$1bd73597fc32b869$var$emptyData;
const $1bd73597fc32b869$var$prioritiseIcon = ({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon })=>urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
const $1bd73597fc32b869$var$extractTaskType = (jsonLd)=>{
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $a1WXB.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
const $1bd73597fc32b869$var$extractFileFormat = (jsonLd)=>jsonLd['schema:fileFormat'];
const $1bd73597fc32b869$var$documentLabel = (opts, label)=>{
    if (!opts.showIconLabel) return '';
    return (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? label : opts.title || label;
};

const $1bd73597fc32b869$var$getBlogIconWrapped = ()=>(parcelRequire("gVFPf")).default;

const $1bd73597fc32b869$var$getDocumentIcon = ()=>(parcelRequire("lasLj")).default;

const $1bd73597fc32b869$var$getFileIcon = ()=>(parcelRequire("6lfCR")).default;

const $1bd73597fc32b869$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("Tpfw2")).default;

const $1bd73597fc32b869$var$getPresentationIcon = ()=>(parcelRequire("AEzrY")).default;

const $1bd73597fc32b869$var$getSpreadsheetIcon = ()=>(parcelRequire("a5mbM")).default;
const $1bd73597fc32b869$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $a1WXB.isConfluenceGenerator)(opts.provider.id)) {
        const LiveDocumentIconWrapped = $1bd73597fc32b869$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LiveDocumentIconWrapped, {
            label: $1bd73597fc32b869$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    }
    const FileIcon = $1bd73597fc32b869$var$getFileIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FileIcon, {
        label: $1bd73597fc32b869$var$documentLabel(opts, 'file'),
        testId: "file-icon"
    });
};
const $1bd73597fc32b869$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                const BlogIconWrapped = $1bd73597fc32b869$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BlogIconWrapped, {
                    label: $1bd73597fc32b869$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $1bd73597fc32b869$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $1bd73597fc32b869$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DocumentIcon, {
                    label: $1bd73597fc32b869$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $1bd73597fc32b869$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PresentationIcon, {
                    label: $1bd73597fc32b869$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $1bd73597fc32b869$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpreadsheetIcon, {
                    label: $1bd73597fc32b869$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
                color: "currentColor",
                label: $1bd73597fc32b869$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $1bd73597fc32b869$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DocumentIcon, {
                    label: $1bd73597fc32b869$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
const $1bd73597fc32b869$var$extractIconFromDocument = (type, opts)=>{
    const iconFromType = $1bd73597fc32b869$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $7063J.getIconForFileType)(opts.fileFormat, (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $1bd73597fc32b869$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $1bd73597fc32b869$var$extractIconFromTask = (opts)=>{
    const { taskType: taskType, provider: provider } = opts;
    const legacyTaskLabel = opts.title || 'task';
    const getLabel = (semantic)=>(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : legacyTaskLabel;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7G33r.default), {
        label: getLabel('Task'),
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $kbte2.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $kbte2.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7G33r.default), {
                    label: getLabel('Task'),
                    testId: "jira-task-icon"
                });
            case 0, $kbte2.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KIbP.default), {
                    label: getLabel('Sub-task'),
                    testId: "jira-subtask-icon"
                });
            case 0, $kbte2.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9J3bP.default), {
                    label: getLabel('Story'),
                    testId: "jira-story-icon"
                });
            case 0, $kbte2.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5jcq.default), {
                    label: getLabel('Bug'),
                    testId: "jira-bug-icon"
                });
            case 0, $kbte2.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kWiYc.default), {
                    label: getLabel('Epic'),
                    testId: "jira-epic-icon"
                });
            case 0, $kbte2.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cKqka.default), {
                    label: getLabel('Incident'),
                    testId: "jira-incident-icon"
                });
            case 0, $kbte2.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d3zB.default), {
                    label: getLabel('Service request'),
                    testId: "jira-service-request-icon"
                });
            case 0, $kbte2.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1WiZb.default), {
                    label: getLabel('Change'),
                    testId: "jira-change-icon"
                });
            case 0, $kbte2.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Jxvl.default), {
                    label: getLabel('Problem'),
                    testId: "jira-problem-icon"
                });
            case 0, $kbte2.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
const $1bd73597fc32b869$var$typeToIcon = (type, opts)=>{
    const getLabel = (title)=>(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? title : opts.title || title;
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iZCav.default), {
                label: getLabel('commit'),
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
                label: getLabel('project'),
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5NrIb.default), {
                label: getLabel('pull request'),
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8PFSM.default), {
                label: getLabel('reference'),
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gV3jM.default), {
                label: getLabel('repository'),
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7G33r.default), {
                label: getLabel('goal'),
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return $1bd73597fc32b869$var$extractIconFromTask(opts);
        default:
            return undefined;
    }
};
const $1bd73597fc32b869$var$standardisedExtractIcon = (type, opts)=>{
    const iconFromType = $1bd73597fc32b869$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $7063J.getIconForFileType)(opts.fileFormat, (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $1bd73597fc32b869$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $1bd73597fc32b869$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return $1bd73597fc32b869$var$extractIconFromDocument(type, opts);
        default:
            return type ? $1bd73597fc32b869$var$standardisedExtractIcon(type, opts) : undefined;
    }
};
const $1bd73597fc32b869$var$extractIcon = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        ...(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? {} : {
            title: (0, $a1WXB.extractTitle)(jsonLd)
        },
        provider: (0, $a1WXB.extractProvider)(jsonLd),
        fileFormat: $1bd73597fc32b869$var$extractFileFormat(jsonLd),
        taskType: $1bd73597fc32b869$var$extractTaskType(jsonLd),
        icon: jsonLd.icon && (0, $a1WXB.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>$1bd73597fc32b869$var$extractorPriorityMap[b] - $1bd73597fc32b869$var$extractorPriorityMap[a])[0];
        return $1bd73597fc32b869$var$extractIconByType(highestPriorityType, opts);
    } else return $1bd73597fc32b869$var$extractIconByType(type, opts);
};
const $1bd73597fc32b869$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $a1WXB.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $kbte2.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $kbte2.JIRA_GENERATOR_ID)) return $1bd73597fc32b869$var$extractIcon(jsonLd, 'type', showIconLabel);
    }
    return $1bd73597fc32b869$var$extractIcon(jsonLd, 'provider', showIconLabel);
};
const $1bd73597fc32b869$export$643db2ee2409e635 = (response, showLabel = true)=>{
    if ((0, $a1WXB.isEntityPresent)(response)) {
        if ((0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            const entityIcon = (0, $a1WXB.extractEntityIcon)(response);
            if (entityIcon) return [
                entityIcon.url,
                entityIcon.label
            ];
        }
        const provider = (0, $a1WXB.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $1bd73597fc32b869$var$extractInlineIcon(response?.data || $1bd73597fc32b869$var$getEmptyJsonLd(), showLabel);
};
module.exports["extractSmartLinkInlineIcon"] = $1bd73597fc32b869$export$643db2ee2409e635;

});

parcelRegister("7063J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $dh538 = parcelRequire("dh538");


var $kbte2 = parcelRequire("kbte2");


var $5AFH0 = parcelRequire("5AFH0");























const $1d56b0baf3d560d1$var$getLazyIcons = ()=>({
        [(0, $kbte2.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("lasLj")))
        },
        [(0, $kbte2.IconType).Audio]: {
            default: ()=>(parcelRequire("g4ye5"))
        },
        [(0, $kbte2.IconType).Code]: {
            default: ()=>(parcelRequire("9ntzJ"))
        },
        [(0, $kbte2.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("6lfCR")))
        },
        [(0, $kbte2.IconType).Folder]: {
            default: ()=>(parcelRequire("dknTc"))
        },
        [(0, $kbte2.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("6lfCR")))
        },
        [(0, $kbte2.IconType).Image]: {
            default: ()=>(parcelRequire("91idS"))
        },
        [(0, $kbte2.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("AEzrY")))
        },
        [(0, $kbte2.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("a5mbM")))
        },
        [(0, $kbte2.IconType).Video]: {
            default: ()=>(parcelRequire("3brop"))
        },
        [(0, $kbte2.IconType).Archive]: {
            default: ()=>(parcelRequire("5dAfr"))
        },
        [(0, $kbte2.IconType).Executable]: {
            default: ()=>(parcelRequire("kX6XP"))
        },
        [(0, $kbte2.IconType).GIF]: {
            default: ()=>(parcelRequire("baHbT"))
        },
        [(0, $kbte2.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("c8ZoX"))
        },
        [(0, $kbte2.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("2PEWm"))
        },
        [(0, $kbte2.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("9wre1"))
        },
        [(0, $kbte2.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("htcSJ"))
        },
        [(0, $kbte2.IconType).MSExcel]: {
            default: ()=>(parcelRequire("516g5"))
        },
        [(0, $kbte2.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("ffDhW"))
        },
        [(0, $kbte2.IconType).MSWord]: {
            default: ()=>(parcelRequire("5lE6Q"))
        },
        [(0, $kbte2.IconType).PDF]: {
            default: ()=>(parcelRequire("7peNt"))
        },
        [(0, $kbte2.IconType).Sketch]: {
            default: ()=>(parcelRequire("1ySEE"))
        }
    });
const $1d56b0baf3d560d1$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $5AFH0.default)(fileFormat);
    if (!iconDescriptor?.icon) return null;
    const lazyIcons = $1d56b0baf3d560d1$var$getLazyIcons();
    if ((0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y')) return [
        lazyIcons[iconDescriptor.icon]?.default,
        iconDescriptor.label ?? ''
    ];
    return [
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $1d56b0baf3d560d1$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    const icon = $1d56b0baf3d560d1$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "hbd6r",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    });
    if ((0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const descriptorLabel = icon[1] || '';
        const label = showIconLabel ?? true ? descriptorLabel : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            testId: "document-file-format-icon",
            label: label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        testId: "document-file-format-icon"
    });
};
module.exports["getIconForFileType"] = $1d56b0baf3d560d1$export$4d685c85ebc7a1e3;

});

parcelRegister("5AFH0", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $kbte2 = parcelRequire("kbte2");

const $7ab107555535bab8$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            icon: icon,
            label: label
        } : {
            icon: icon
        };
    switch(fileFormat){
        case 'folder':
            return getIconDescriptor((0, $kbte2.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $kbte2.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $kbte2.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $kbte2.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $kbte2.IconType).Spreadsheet, 'spreadsheet');
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $kbte2.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $kbte2.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $kbte2.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $kbte2.IconType).GoogleSlides, 'google slide');
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $kbte2.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $kbte2.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $kbte2.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $kbte2.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $kbte2.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $kbte2.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $kbte2.IconType).Video, 'video');
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $kbte2.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $kbte2.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $kbte2.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $kbte2.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
        case 'application/invision.prototype':
            return getIconDescriptor((0, $kbte2.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $7ab107555535bab8$export$2e2bcd8739ae039 = $7ab107555535bab8$var$extractFileFormatIcon;
module.exports["default"] = $7ab107555535bab8$export$2e2bcd8739ae039;

});

parcelRegister("g4ye5", function(module, exports) {

let $bb3791a86665eb65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bb3791a86665eb65$var$load("jDjSj"),
    $bb3791a86665eb65$var$load("ip5rC")
]).then(()=>parcelRequire('D3qek'));

});

parcelRegister("9ntzJ", function(module, exports) {

let $6d3d3413030d7ae9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d3d3413030d7ae9$var$load("6P4qp").then(()=>parcelRequire('i8lHX'));

});

parcelRegister("dknTc", function(module, exports) {

let $9b3fac87a6810483$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b3fac87a6810483$var$load("6wr18"),
    $9b3fac87a6810483$var$load("ffEVr"),
    $9b3fac87a6810483$var$load("IqhnW")
]).then(()=>parcelRequire('cc4If'));

});

parcelRegister("91idS", function(module, exports) {

let $691257b3c0707792$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $691257b3c0707792$var$load("6wr18"),
    $691257b3c0707792$var$load("ffEVr"),
    $691257b3c0707792$var$load("g3NgS")
]).then(()=>parcelRequire('dxfO9'));

});

parcelRegister("3brop", function(module, exports) {

let $2517a5cf0c13a05f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2517a5cf0c13a05f$var$load("6wr18"),
    $2517a5cf0c13a05f$var$load("ffEVr"),
    $2517a5cf0c13a05f$var$load("e3J4u")
]).then(()=>parcelRequire('hQd89'));

});

parcelRegister("5dAfr", function(module, exports) {

let $3cca48c73573eb39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3cca48c73573eb39$var$load("2fk6g").then(()=>parcelRequire('dlbUV'));

});

parcelRegister("kX6XP", function(module, exports) {

let $f40eb84301e8c025$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f40eb84301e8c025$var$load("huUvS").then(()=>parcelRequire('2ixko'));

});

parcelRegister("baHbT", function(module, exports) {

let $822221aaef5e7b27$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $822221aaef5e7b27$var$load("1oiJ6").then(()=>parcelRequire('d5BUD'));

});

parcelRegister("c8ZoX", function(module, exports) {

let $8d75dc799514e943$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d75dc799514e943$var$load("lxiFd").then(()=>parcelRequire('4rkAw'));

});

parcelRegister("2PEWm", function(module, exports) {

let $21001a16bfe99cf8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21001a16bfe99cf8$var$load("eDqo1").then(()=>parcelRequire('jDMpf'));

});

parcelRegister("9wre1", function(module, exports) {

let $6eec388d67832b92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6eec388d67832b92$var$load("6HBYC").then(()=>parcelRequire('l59oX'));

});

parcelRegister("htcSJ", function(module, exports) {

let $cb7f232b5be92725$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb7f232b5be92725$var$load("bYxCZ").then(()=>parcelRequire('jOGxt'));

});

parcelRegister("516g5", function(module, exports) {

let $3a71e68ec6145457$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a71e68ec6145457$var$load("eTBsW").then(()=>parcelRequire('d8Kpd'));

});

parcelRegister("ffDhW", function(module, exports) {

let $b1a6bb9a21a18a09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1a6bb9a21a18a09$var$load("020xd").then(()=>parcelRequire('hY1Uy'));

});

parcelRegister("5lE6Q", function(module, exports) {

let $3e4e06d4705f4ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e4e06d4705f4ba7$var$load("ls0Um").then(()=>parcelRequire('90Icb'));

});

parcelRegister("7peNt", function(module, exports) {

let $5646588e31a854db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5646588e31a854db$var$load("eVYW1").then(()=>parcelRequire('11LZV'));

});

parcelRegister("1ySEE", function(module, exports) {

let $12335cac957a87bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $12335cac957a87bb$var$load("f35QR").then(()=>parcelRequire('9W0IA'));

});

parcelRegister("gVFPf", function(module, exports) {

var $6iY4P = parcelRequire("6iY4P");


var $j6GAe = parcelRequire("j6GAe");


var $a27Du = parcelRequire("a27Du");

const $c8a71e37908ae30d$var$BlogIconWithColor = (0, $a27Du.renderIconPerSize)((0, $6iY4P.default), (0, $j6GAe.default));
$c8a71e37908ae30d$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $c8a71e37908ae30d$export$2e2bcd8739ae039 = $c8a71e37908ae30d$var$BlogIconWithColor;
module.exports["default"] = $c8a71e37908ae30d$export$2e2bcd8739ae039;

});

parcelRegister("a27Du", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7642E = parcelRequire("7642E");


var $dh538 = parcelRequire("dh538");


var $kbte2 = parcelRequire("kbte2");

const $4e81ca7cb8a4cadc$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $4e81ca7cb8a4cadc$var$isIconSizeLarge = (size)=>size && [
        (0, $kbte2.SmartLinkSize).Large,
        (0, $kbte2.SmartLinkSize).XLarge
    ].includes(size);
const $4e81ca7cb8a4cadc$export$3acc3fb10995f020 = (size)=>{
    if ((0, $dh538.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $kbte2.SmartLinkSize).Small:
        case (0, $kbte2.SmartLinkSize).Medium:
            return undefined;
        case (0, $kbte2.SmartLinkSize).XLarge:
        case (0, $kbte2.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $kbte2.SmartLinkSize).XLarge:
        case (0, $kbte2.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};
const $4e81ca7cb8a4cadc$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ($4e81ca7cb8a4cadc$var$isIconSizeLarge(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectIcon, props);
    };
};
const $4e81ca7cb8a4cadc$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = $4e81ca7cb8a4cadc$export$3acc3fb10995f020(size);
        if (tileSize === undefined) {
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                color: $4e81ca7cb8a4cadc$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { shape: _shape, UNSAFE_circleReplacementComponent: _unsafe, ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["renderIconPerSize"] = $4e81ca7cb8a4cadc$export$28dd5ad82647c000;
module.exports["renderIconTile"] = $4e81ca7cb8a4cadc$export$87c3646d0e299cfe;

});

parcelRegister("lasLj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8jHAi = parcelRequire("8jHAi");


var $a27Du = parcelRequire("a27Du");

const $56ace5b3e81dcb4e$var$PageIconWithColor = (0, $a27Du.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), 'blueBold');
$56ace5b3e81dcb4e$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $56ace5b3e81dcb4e$export$2e2bcd8739ae039 = $56ace5b3e81dcb4e$var$PageIconWithColor;
module.exports["default"] = $56ace5b3e81dcb4e$export$2e2bcd8739ae039;

});

parcelRegister("6lfCR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $chO1Z = parcelRequire("chO1Z");


var $a27Du = parcelRequire("a27Du");

const $605dae01bd698622$var$FileIconWithColor = (0, $a27Du.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), 'grayBold');
$605dae01bd698622$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $605dae01bd698622$export$2e2bcd8739ae039 = $605dae01bd698622$var$FileIconWithColor;
module.exports["default"] = $605dae01bd698622$export$2e2bcd8739ae039;

});

parcelRegister("Tpfw2", function(module, exports) {

var $66dpz = parcelRequire("66dpz");


var $fAGae = parcelRequire("fAGae");


var $a27Du = parcelRequire("a27Du");

const $587019717fd213eb$var$LiveDocumentIconWithColor = (0, $a27Du.renderIconPerSize)((0, $66dpz.default), (0, $fAGae.default));
$587019717fd213eb$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $587019717fd213eb$export$2e2bcd8739ae039 = $587019717fd213eb$var$LiveDocumentIconWithColor;
module.exports["default"] = $587019717fd213eb$export$2e2bcd8739ae039;

});

parcelRegister("AEzrY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $1zLiv = parcelRequire("1zLiv");


var $a27Du = parcelRequire("a27Du");

const $caa0195d6d388e56$var$ChartBarIconWithColor = (0, $a27Du.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), 'purpleBold');
$caa0195d6d388e56$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $caa0195d6d388e56$export$2e2bcd8739ae039 = $caa0195d6d388e56$var$ChartBarIconWithColor;
module.exports["default"] = $caa0195d6d388e56$export$2e2bcd8739ae039;

});

parcelRegister("a5mbM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $cUQMr = parcelRequire("cUQMr");


var $a27Du = parcelRequire("a27Du");

const $972cdf56c57da0b2$var$ListBulletedIconWithColor = (0, $a27Du.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), 'greenBold');
$972cdf56c57da0b2$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $972cdf56c57da0b2$export$2e2bcd8739ae039 = $972cdf56c57da0b2$var$ListBulletedIconWithColor;
module.exports["default"] = $972cdf56c57da0b2$export$2e2bcd8739ae039;

});

parcelRegister("4vCA9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a879f42abb981ca6$var$placeholderShimmer = null;
const $a879f42abb981ca6$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $a879f42abb981ca6$var$spanSkeletonStyles = null;
const $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhkysee",
    blue: "_bfhk1s93",
    darkGray: "_bfhk7qp0"
};
const $a879f42abb981ca6$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a879f42abb981ca6$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $gMc0m.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $a879f42abb981ca6$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a879f42abb981ca6$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $gMc0m.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $a879f42abb981ca6$export$2e2bcd8739ae039 = $a879f42abb981ca6$export$8f31e4c4a37b8e9c;
module.exports["SpanSkeleton"] = $a879f42abb981ca6$export$85d5658002cae6ce;
module.exports["Skeleton"] = $a879f42abb981ca6$export$8f31e4c4a37b8e9c;

});

parcelRegister("lnMCl", function(module, exports) {

var $aCX5O = parcelRequire("aCX5O");

const $2ba6046cea568699$export$39b0f5626e96f41e = (0, $aCX5O.useMessageInstanceEvent);
module.exports["useMessageInstanceEvent"] = $2ba6046cea568699$export$39b0f5626e96f41e;

});

parcelRegister("hrSFW", function(module, exports) {
var $cb3f5eae1efed147$var$has = Object.prototype.hasOwnProperty;
function $cb3f5eae1efed147$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $cb3f5eae1efed147$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($cb3f5eae1efed147$var$has.call(foo, ctor) && ++len && !$cb3f5eae1efed147$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$cb3f5eae1efed147$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $cb3f5eae1efed147$export$de8294bb3be0322f;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("aqrhZ", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("96msn")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("96msn")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("96msn")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $lhchg = parcelRequire("lhchg");


var $96msn = parcelRequire("96msn");

parcelRequire("1BwGq");
var $jnAB4 = parcelRequire("jnAB4");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("eow39");
var $jyd5r = parcelRequire("jyd5r");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");


var $iYRNV = parcelRequire("iYRNV");


});

parcelRegister("8dgvm", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("dXZzO")).MODE);

var $dXZzO = parcelRequire("dXZzO");

const $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN = undefined;
const $5fac572772fbabda$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $5fac572772fbabda$var$DEFAULT_MODE = (0, $dXZzO.MODE).HYDRATE;
const $5fac572772fbabda$var$DEFAULT_RETRY = 2;
const $5fac572772fbabda$var$config = {
    crossOrigin: $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN,
    manifest: $5fac572772fbabda$var$DEFAULT_MANIFEST,
    mode: $5fac572772fbabda$var$DEFAULT_MODE,
    retry: $5fac572772fbabda$var$DEFAULT_RETRY
};
const $5fac572772fbabda$export$44487a86467333c3 = ()=>$5fac572772fbabda$var$config;
const $5fac572772fbabda$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $5fac572772fbabda$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN;
    $5fac572772fbabda$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $5fac572772fbabda$var$DEFAULT_MANIFEST;
    $5fac572772fbabda$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $5fac572772fbabda$var$DEFAULT_MODE;
    $5fac572772fbabda$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $5fac572772fbabda$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $5fac572772fbabda$export$44487a86467333c3;
module.exports["setConfig"] = $5fac572772fbabda$export$940a7873bb071df8;

});

parcelRegister("dXZzO", function(module, exports) {
const $a2b08cde192cf1ec$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $a2b08cde192cf1ec$export$e48589d9e4824227;

});

parcelRegister("lhchg", function(module, exports) {

var $89YVk = parcelRequire("89YVk");


var $8dgvm = parcelRequire("8dgvm");

parcelRequire("ecrVx");
var $4CMiD = parcelRequire("4CMiD");
var $6y0vU = parcelRequire("6y0vU");


var $27zaj = parcelRequire("27zaj");

const $f7d4b5876658b264$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $8dgvm.setConfig)(config);
        (0, $4CMiD.LISTENERS).length = 0;
        (0, $6y0vU.setCurrent)(0);
        if (!(0, $27zaj.isNodeEnvironment)()) (0, $89YVk.collect)();
    }
};

});

parcelRegister("89YVk", function(module, exports) {

var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");


var $8lfql = parcelRequire("8lfql");


var $3iPPT = parcelRequire("3iPPT");

const $5f0e6c234ea4c71a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $8dgvm.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $dXZzO.MODE).RENDER ? (0, $8lfql.cloneElements)(markers[i], lazyBegin) : (0, $3iPPT.refElements)(markers[i], lazyBegin);
        if ((0, $euF6Z.COLLECTED).has(lazyBegin)) (0, $euF6Z.COLLECTED).get(lazyBegin).push(value);
        else (0, $euF6Z.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $5f0e6c234ea4c71a$export$bb44f104e3c54dae;

});

parcelRegister("euF6Z", function(module, exports) {
const $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $a8d3c1fdc5de2df2$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $a8d3c1fdc5de2df2$export$4831ef3968ea94ef;

});

parcelRegister("8lfql", function(module, exports) {
const $612c3fc5c2a28c4f$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $612c3fc5c2a28c4f$export$c42217d53a7ebafb;

});

parcelRegister("3iPPT", function(module, exports) {
const $267b431587227d50$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $267b431587227d50$export$c69443129766a7fc;

});

parcelRegister("ecrVx", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("6y0vU")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("6y0vU")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("4CMiD")).LISTENERS);

var $6y0vU = parcelRequire("6y0vU");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");


});

parcelRegister("6y0vU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $euF6Z = parcelRequire("euF6Z");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");

let $4c46510d73a23c1f$var$CURRENT_PHASE = (0, $euF6Z.PHASE).PAINT;
const $4c46510d73a23c1f$export$5f80f094fd31fffd = (phase)=>{
    $4c46510d73a23c1f$var$CURRENT_PHASE = phase;
    (0, $4CMiD.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $4c46510d73a23c1f$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $ilgZx.createSubscribe)((0, $4CMiD.LISTENERS)),
    currentValue: ()=>$4c46510d73a23c1f$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).PAINT)
    }
});
const $4c46510d73a23c1f$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($4c46510d73a23c1f$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $4c46510d73a23c1f$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $4c46510d73a23c1f$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $4c46510d73a23c1f$export$1dc361b277327f88;

});

parcelRegister("4CMiD", function(module, exports) {
const $35e02d56e6163baa$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $35e02d56e6163baa$export$81b9c458a026d68f;

});

parcelRegister("ilgZx", function(module, exports) {
const $d5a75e5021e4308a$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $d5a75e5021e4308a$export$364097d812234b3f;

});

parcelRegister("27zaj", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("7zmsS")).default);

var $7zmsS = parcelRequire("7zmsS");

const $18b7834f7092bd86$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $18b7834f7092bd86$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $18b7834f7092bd86$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $18b7834f7092bd86$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $18b7834f7092bd86$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $18b7834f7092bd86$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $18b7834f7092bd86$export$283635c04a02cc36;
module.exports["attrToProp"] = $18b7834f7092bd86$export$62bf630d0de3d781;

});

parcelRegister("7zmsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $582d3a4d2ad75f69$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $582d3a4d2ad75f69$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("96msn", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");


var $27zaj = parcelRequire("27zaj");
var $7zmsS = parcelRequire("7zmsS");


var $k001K = parcelRequire("k001K");


var $1r9rN = parcelRequire("1r9rN");


var $2niqO = parcelRequire("2niqO");


var $aAlyb = parcelRequire("aAlyb");


var $1C3RC = parcelRequire("1C3RC");


var $1Bcgq = parcelRequire("1Bcgq");


var $fLvpO = parcelRequire("fLvpO");

function $6a061803acf54fcf$var$_extends() {
    $6a061803acf54fcf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a061803acf54fcf$var$_extends.apply(this, arguments);
}
function $6a061803acf54fcf$var$lazyProxy(_loader, { defer: defer = (0, $euF6Z.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $27zaj.isNodeEnvironment)();
    const dataLazyId = (0, $7zmsS.default)(moduleId);
    const LazyInternal = isServer ? (0, $2niqO.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $1r9rN.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $aAlyb.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $8dgvm.getConfig)();
                return (0, $1Bcgq.retry)(_loader, {
                    delay: (0, $k001K.RETRY_DELAY),
                    factor: (0, $k001K.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $27zaj.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $8dgvm.getConfig)();
        return (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $euF6Z.PHASE).PAINT ? (0, $k001K.PRIORITY).HIGH : (0, $k001K.PRIORITY).LOW;
        return (0, $1C3RC.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6a061803acf54fcf$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $euF6Z.PHASE).LAZY
    }
};
function $6a061803acf54fcf$export$c952e5f94576010e(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6a061803acf54fcf$export$291dd592399bdafa(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6a061803acf54fcf$export$488013bae63b21da(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6a061803acf54fcf$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6a061803acf54fcf$export$291dd592399bdafa;
module.exports["lazy"] = $6a061803acf54fcf$export$488013bae63b21da;

});

parcelRegister("aQIfl", function(module, exports) {
const $0209d2ec05e7d0da$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $0209d2ec05e7d0da$export$303f43e55cf1ef2f;

});

parcelRegister("k001K", function(module, exports) {
const $e8f3d428f2749473$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e8f3d428f2749473$export$a339266ad71b2447 = 300;
const $e8f3d428f2749473$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e8f3d428f2749473$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e8f3d428f2749473$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e8f3d428f2749473$export$ba64c908e55507fe;

});

parcelRegister("1r9rN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("1BwGq");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $k001K = parcelRequire("k001K");


var $fLvpO = parcelRequire("fLvpO");


var $8VyCG = parcelRequire("8VyCG");


var $femay = parcelRequire("femay");


var $1C3RC = parcelRequire("1C3RC");


var $iYRNV = parcelRequire("iYRNV");


var $36I1o = parcelRequire("36I1o");

function $10bfa415480e5081$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $42omo.useContext)((0, $iYRNV.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $fLvpO.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $36I1o.useSubscription)({
            context: (0, $9uVEz.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $euF6Z.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $36I1o.useSubscription)({
                context: (0, $6y0vU.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $42omo.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $1C3RC.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $k001K.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        (0, $42omo.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $euF6Z.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $8dgvm.getConfig)().mode === (0, $dXZzO.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8VyCG.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $femay.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $10bfa415480e5081$export$6898b5504b58699a;

});

parcelRegister("1BwGq", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("9uVEz")).WaitContext);

var $9uVEz = parcelRequire("9uVEz");


var $jnAB4 = parcelRequire("jnAB4");


});

parcelRegister("9uVEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jLShN = parcelRequire("jLShN");

const $6ea3a326e6c1ad89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: ()=>(0, $jLShN.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $6ea3a326e6c1ad89$export$9ba3fe09d15de47b;

});

parcelRegister("jLShN", function(module, exports) {
const $e64c8432c5ffa90e$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $e64c8432c5ffa90e$export$276c7dbda7675aec;

});

parcelRegister("jnAB4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9uVEz = parcelRequire("9uVEz");

const $e1bc8db03d394dff$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $42omo.useContext)((0, $9uVEz.WaitContext));
    const value = (0, $42omo.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $42omo.useRef)(new Set());
    const api = (0, $42omo.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $42omo.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9uVEz.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("eow39", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("h5RZ7")).LazySuspenseContext);

var $jyd5r = parcelRequire("jyd5r");


var $h5RZ7 = parcelRequire("h5RZ7");


});

parcelRegister("jyd5r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");


var $h5RZ7 = parcelRequire("h5RZ7");

class $e3bb580fd9a2f323$export$256c542058532d6f extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $27zaj.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $42omo.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $e3bb580fd9a2f323$export$256c542058532d6f;

});

parcelRegister("h5RZ7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c71cc793aab4db4d$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $c71cc793aab4db4d$export$c33990e84065970c;

});

parcelRegister("fLvpO", function(module, exports) {
const $b7a39d38ff5e8305$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $b7a39d38ff5e8305$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$b7a39d38ff5e8305$export$6aa69c1258005366]: true
    });
    return error;
};
const $b7a39d38ff5e8305$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($b7a39d38ff5e8305$export$6aa69c1258005366);
module.exports["createLoaderError"] = $b7a39d38ff5e8305$export$c73a6a6f0bf7d425;

});

parcelRegister("8VyCG", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $67fe80fcd34326f0$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $67fe80fcd34326f0$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($67fe80fcd34326f0$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $67fe80fcd34326f0$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $67fe80fcd34326f0$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $67fe80fcd34326f0$export$d55db778a3e1446b;

});

parcelRegister("femay", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");

function $b1695c2d5acdcbdf$var$_extends() {
    $b1695c2d5acdcbdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1695c2d5acdcbdf$var$_extends.apply(this, arguments);
}
const $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $27zaj.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), $b1695c2d5acdcbdf$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4;

});

parcelRegister("1C3RC", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");


var $27zaj = parcelRequire("27zaj");


var $k001K = parcelRequire("k001K");


var $1J5yR = parcelRequire("1J5yR");


var $iYRNV = parcelRequire("iYRNV");

function $12cc564e7e862135$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $8dgvm.getConfig)();
    const assets = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1J5yR.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $12cc564e7e862135$var$fakePromise = {
    then: ()=>$12cc564e7e862135$var$fakePromise,
    catch: ()=>$12cc564e7e862135$var$fakePromise,
    finally: ()=>$12cc564e7e862135$var$fakePromise
};
function $12cc564e7e862135$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1J5yR.insertLinkTag)(href, rel));
        return $12cc564e7e862135$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $12cc564e7e862135$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jLShN.noopCleanup;
}
function $12cc564e7e862135$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $27zaj.isNodeEnvironment)()) return 0, $jLShN.noopCleanup;
    (_GlobalReactLooselyLa = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $k001K.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $12cc564e7e862135$export$3af04dbcb01bad4d,
        $12cc564e7e862135$export$1046fd6a49d5e7a,
        $12cc564e7e862135$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jLShN.noopCleanup;
}
module.exports["preloadAsset"] = $12cc564e7e862135$export$25bad4aa00c45355;

});

parcelRegister("1J5yR", function(module, exports) {

var $iYRNV = parcelRequire("iYRNV");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");

function $141e4ec3ad408220$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jLShN.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $8dgvm.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $141e4ec3ad408220$export$6610512821c8a4ce;

});

parcelRegister("iYRNV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dd1790f807a46380$export$e2d53c0cbedd2710 = {
    current: null
};
const $dd1790f807a46380$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $42omo.createContext)($dd1790f807a46380$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $dd1790f807a46380$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $dd1790f807a46380$export$8146ab57a3f7a7cb;

});

parcelRegister("36I1o", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $2434146821c65301$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $2434146821c65301$export$368b4214baeb914c;

});

parcelRegister("2niqO", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $27zaj = parcelRequire("27zaj");


var $fLvpO = parcelRequire("fLvpO");

function $1bac06d947c9671a$var$load(moduleId, loader) {
    try {
        return (0, $27zaj.getExport)(loader());
    } catch (err) {
        throw (0, $fLvpO.createLoaderError)(err);
    }
}
function $1bac06d947c9671a$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $1bac06d947c9671a$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $8dgvm.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $euF6Z.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("link", {
                key: url,
                rel: defer === (0, $euF6Z.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $1bac06d947c9671a$export$eb2e4b04351cdd9e;

});

parcelRegister("aAlyb", function(module, exports) {
const $7b4dfb9d7bf38586$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $7b4dfb9d7bf38586$export$e673efccd97e4223;

});

parcelRegister("1Bcgq", function(module, exports) {
const $12a2c288067cec34$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $12a2c288067cec34$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $12a2c288067cec34$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $12a2c288067cec34$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $12a2c288067cec34$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $12a2c288067cec34$var$calculateDelay(context, policy);
        if (delay) await $12a2c288067cec34$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $12a2c288067cec34$export$9369b12211e1fce4;

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

const $02745cd2b6b0665c$var$PageObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $02745cd2b6b0665c$export$2e2bcd8739ae039 = $02745cd2b6b0665c$var$PageObject;
module.exports["default"] = $02745cd2b6b0665c$export$2e2bcd8739ae039;

});

parcelRegister("g5QRf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb761d6fd7d44f19$var$_react = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb761d6fd7d44f19$var$_baseNew = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb761d6fd7d44f19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $bb761d6fd7d44f19$var$_react.default.createElement($bb761d6fd7d44f19$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$bb761d6fd7d44f19$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $bb761d6fd7d44f19$var$_default = module.exports.default = $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("5AXU5"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("5AXU5", function(module, exports) {

let $412ec824ba8169ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $412ec824ba8169ad$var$load("coUzl"),
    $412ec824ba8169ad$var$load("5nMTY"),
    $412ec824ba8169ad$var$load("7j0mT"),
    $412ec824ba8169ad$var$load("69R9L"),
    $412ec824ba8169ad$var$load("jZLnv"),
    $412ec824ba8169ad$var$load("6edij"),
    $412ec824ba8169ad$var$load("hXbzh"),
    $412ec824ba8169ad$var$load("6wr18"),
    $412ec824ba8169ad$var$load("ffEVr"),
    $412ec824ba8169ad$var$load("ajMch"),
    $412ec824ba8169ad$var$load("kFiBp"),
    $412ec824ba8169ad$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $42omo.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _kqswh2mm"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $gMc0m.default)([
                "_kqswstnw _1ltv1ssb _154i1ssb _1pbyb4wl"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    if (!contentId) return null;
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("hwDTW", function(module, exports) {

var $eHPLt = parcelRequire("eHPLt");


var $1WABR = parcelRequire("1WABR");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");


var $bRRFB = parcelRequire("bRRFB");


var $cSA01 = parcelRequire("cSA01");


var $erbrP = parcelRequire("erbrP");


var $gQUlr = parcelRequire("gQUlr");

/** `Object#toString` result references. */ var $cc24605e9ae7f4f1$var$mapTag = '[object Map]', $cc24605e9ae7f4f1$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $cc24605e9ae7f4f1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cc24605e9ae7f4f1$var$hasOwnProperty = $cc24605e9ae7f4f1$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $cc24605e9ae7f4f1$var$isEmpty(value) {
    if (value == null) return true;
    if ($bRRFB(value) && ($fZxmY(value) || typeof value == 'string' || typeof value.splice == 'function' || $cSA01(value) || $gQUlr(value) || $dI6Ko(value))) return !value.length;
    var tag = $1WABR(value);
    if (tag == $cc24605e9ae7f4f1$var$mapTag || tag == $cc24605e9ae7f4f1$var$setTag) return !value.size;
    if ($erbrP(value)) return !$eHPLt(value).length;
    for(var key in value){
        if ($cc24605e9ae7f4f1$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $cc24605e9ae7f4f1$var$isEmpty;

});

parcelRegister("f9yl5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jTxSS = parcelRequire("jTxSS");


var $a1WXB = parcelRequire("a1WXB");


var $eIleF = parcelRequire("eIleF");


var $l3dur = parcelRequire("l3dur");


var $dh538 = parcelRequire("dh538");


var $4T4vf = parcelRequire("4T4vf");

parcelRequire("882hS");
var $85Mv7 = parcelRequire("85Mv7");

parcelRequire("afUmf");
var $3ts5j = parcelRequire("3ts5j");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $226XV = parcelRequire("226XV");

var $ba441b9d4456e512$export$89741becde3d0e54 = /*#__PURE__*/ function(SMART_LINK_DRAG_TYPES) {
    SMART_LINK_DRAG_TYPES["EDITOR"] = "smart-link-from-editor";
    SMART_LINK_DRAG_TYPES["RENDERER"] = "smart-link-from-renderer";
    return SMART_LINK_DRAG_TYPES;
}({});
var $ba441b9d4456e512$export$a4a3cf1d43312764 = /*#__PURE__*/ function(SMART_LINK_APPEARANCE) {
    SMART_LINK_APPEARANCE["INLINE"] = "inline";
    SMART_LINK_APPEARANCE["BLOCK"] = "block";
    SMART_LINK_APPEARANCE["EMBED"] = "embed";
    return SMART_LINK_APPEARANCE;
}({});
function $ba441b9d4456e512$export$ac5f6dc1cb5b8db6(type) {
    return type === "smart-link-from-editor" || type === "smart-link-from-renderer";
} /**
   * Checks if a ProseMirror node type is a smart link card.
   */ 
function $ba441b9d4456e512$export$250eee508686c799(nodeType) {
    return nodeType === 'inlineCard' || nodeType === 'blockCard' || nodeType === 'embedCard';
}
const $ba441b9d4456e512$var$idleState = {
    type: 'idle'
};
const $ba441b9d4456e512$var$draggingState = {
    type: 'dragging'
};
const $ba441b9d4456e512$var$styles = {
    preview: "_1reo15vq _18m915vq _2rko12b0 _1rjc1b66 _18zru2gc _1dqonqa1 _1h6d1l7x _bfhkvuon _p12fgx0z _16qs130s",
    previewText: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    draggableBlock: "_80om1qgj"
};
const $ba441b9d4456e512$var$previewIconStyles = null;
const $ba441b9d4456e512$var$draggableInlineStyles = null;
const $ba441b9d4456e512$var$SmartLinkDragPreview = (0, $4pOgL.isReactCompilerActivePlatform)() ? function SmartLinkDragPreview(t0) {
    const $ = (0, $frIzR.c)(7);
    const { title: title, url: url, iconUrl: iconUrl } = t0;
    let t1;
    if ($[0] !== iconUrl) {
        t1 = iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: iconUrl,
            alt: "",
            className: (0, $gMc0m.default)([
                "_1bsbpxbi _4t3ipxbi _1o9zidpf"
            ])
        });
        $[0] = iconUrl;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = title || url;
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: $ba441b9d4456e512$var$styles.previewText
        }, t2);
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ba441b9d4456e512$var$styles.preview
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.075"
        }, t1, t3));
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SmartLinkDragPreview({ title: title, url: url, iconUrl: iconUrl }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ba441b9d4456e512$var$styles.preview
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.075"
    }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: iconUrl,
        alt: "",
        className: (0, $gMc0m.default)([
            "_1bsbpxbi _4t3ipxbi _1o9zidpf"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $ba441b9d4456e512$var$styles.previewText
    }, title || url)));
};
function $ba441b9d4456e512$var$getIconUrl(details) {
    if (details?.data && 'icon' in details.data && typeof details?.data?.icon === 'string') return details.data.icon;
    const objectIconUrl = (0, $226XV.getObjectIconUrl)(details);
    if (objectIconUrl) return objectIconUrl;
     // Confluence/Jira content-type specific icons (page, blog, whiteboard, issue, etc.)
    if (details?.entityData && 'iconUrl' in details.entityData && typeof details.entityData.iconUrl === 'string') return details.entityData.iconUrl;
     // Fallback to provider/generator icon (product logo)
    if (typeof details?.meta?.generator?.icon?.url === 'string') return details.meta.generator.icon.url;
    return undefined;
} /**
   * Inner component that handles the actual drag behavior.
   * Must be rendered within a SmartCardProvider context.
   */ 
const $ba441b9d4456e512$var$SmartLinkDraggableInner = (0, $4pOgL.isReactCompilerActivePlatform)() ? function SmartLinkDraggableInner(t0) {
    const $ = (0, $frIzR.c)(35);
    const { url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: t1, children: children } = t0;
    const isChangeboardTarget = t1 === undefined ? false : t1;
    const ref = (0, $42omo.useRef)(null);
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const [state, setState] = (0, $42omo.useState)($ba441b9d4456e512$var$idleState);
    let t2;
    if ($[0] !== appearance || $[1] !== propTitle || $[2] !== source || $[3] !== store || $[4] !== url) {
        t2 = (targetEl)=>({
                element: targetEl,
                getInitialData: ()=>{
                    const cardState = store.getState()[url];
                    const details = cardState?.details;
                    const title = propTitle || (0, $a1WXB.extractSmartLinkTitle)(details);
                    const iconUrl = $ba441b9d4456e512$var$getIconUrl(details);
                    return {
                        type: source,
                        url: url,
                        title: title,
                        iconUrl: iconUrl,
                        appearance: appearance
                    };
                },
                onGenerateDragPreview: (t3)=>{
                    const { nativeSetDragImage: nativeSetDragImage } = t3;
                    const cardState_0 = store.getState()[url];
                    const details_0 = cardState_0?.details;
                    const title_0 = propTitle || (0, $a1WXB.extractSmartLinkTitle)(details_0);
                    const iconUrl_0 = $ba441b9d4456e512$var$getIconUrl(details_0);
                    (0, $3ts5j.setCustomNativeDragPreview)({
                        getOffset: (0, $85Mv7.pointerOutsideOfPreview)({
                            x: "16px",
                            y: "8px"
                        }),
                        render (t4) {
                            const { container: container } = t4;
                            setState({
                                type: "preview",
                                container: container,
                                title: title_0,
                                iconUrl: iconUrl_0
                            });
                            return ()=>setState($ba441b9d4456e512$var$draggingState);
                        },
                        nativeSetDragImage: nativeSetDragImage
                    });
                },
                onDragStart: ()=>setState($ba441b9d4456e512$var$draggingState),
                onDrop: ()=>setState($ba441b9d4456e512$var$idleState)
            });
        $[0] = appearance;
        $[1] = propTitle;
        $[2] = source;
        $[3] = store;
        $[4] = url;
        $[5] = t2;
    } else t2 = $[5];
    const getDragConfig = t2;
    let t3;
    if ($[6] !== appearance || $[7] !== getDragConfig) {
        t3 = ()=>{
            const el = ref.current;
            if (!el) return;
            let cleanupDraggable = null;
            let observer = null;
            if (appearance !== "inline") {
                const setupSmartElementLink = ()=>{
                    el.querySelectorAll("[data-smart-element-link]").forEach($ba441b9d4456e512$var$_temp);
                };
                setupSmartElementLink();
                observer = new MutationObserver(setupSmartElementLink);
                observer.observe(el, {
                    childList: true,
                    subtree: true
                });
            }
            const unbindPointerDown = (0, $fFa3V.bind)(el, {
                type: "pointerdown",
                listener: (event)=>{
                    const selectionAtPointerDown = window.getSelection();
                    if (appearance === "inline" && selectionAtPointerDown?.type === "Range" && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                    cleanupDraggable?.();
                    const target = event.target;
                    let dragTarget = el;
                    if (appearance === "inline") {
                        const targetElement = target instanceof Element ? target : null;
                        const hostInlineCardRoot = el.closest("[data-prosemirror-node-name=\"inlineCard\"][draggable=\"true\"]");
                        const inlineCardRoot = targetElement?.closest("[data-prosemirror-node-name=\"inlineCard\"][draggable=\"true\"]") ?? null;
                        const closestInlineAnchor = targetElement?.closest("a[href], [data-smart-element-link]") ?? null;
                        if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                        else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                    } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                    cleanupDraggable = (0, $4T4vf.draggable)(getDragConfig(dragTarget));
                }
            });
            return ()=>{
                cleanupDraggable?.();
                unbindPointerDown();
                observer?.disconnect();
            };
        };
        $[6] = appearance;
        $[7] = getDragConfig;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== appearance || $[10] !== getDragConfig || $[11] !== propTitle || $[12] !== source || $[13] !== store || $[14] !== url) {
        t4 = [
            url,
            propTitle,
            appearance,
            source,
            store,
            getDragConfig
        ];
        $[9] = appearance;
        $[10] = getDragConfig;
        $[11] = propTitle;
        $[12] = source;
        $[13] = store;
        $[14] = url;
        $[15] = t4;
    } else t4 = $[15];
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[16] !== state.container || $[17] !== state.iconUrl || $[18] !== state.title || $[19] !== state.type || $[20] !== url) {
        t5 = state.type === "preview" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba441b9d4456e512$var$SmartLinkDragPreview, {
            title: state.title,
            url: url,
            iconUrl: state.iconUrl
        }), state.container) : null;
        $[16] = state.container;
        $[17] = state.iconUrl;
        $[18] = state.title;
        $[19] = state.type;
        $[20] = url;
        $[21] = t5;
    } else t5 = $[21];
    const preview = t5;
    if (appearance === "inline") {
        const t6 = isChangeboardTarget ? "smart-link-draggable-changeboard" : undefined;
        let t7;
        if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $gMc0m.default)([
                "_80om1qgj _1e0c1nu9"
            ]);
            $[22] = t7;
        } else t7 = $[22];
        let t8;
        if ($[23] !== children || $[24] !== t6 || $[25] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ref: ref,
                "data-testid": "smart-link-draggable-inline",
                "data-spotlight-target": t6,
                className: t7
            }, children);
            $[23] = children;
            $[24] = t6;
            $[25] = t7;
            $[26] = t8;
        } else t8 = $[26];
        let t9;
        if ($[27] !== preview || $[28] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, preview);
            $[27] = preview;
            $[28] = t8;
            $[29] = t9;
        } else t9 = $[29];
        return t9;
    }
    let t6;
    if ($[30] !== children) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: ref,
            xcss: $ba441b9d4456e512$var$styles.draggableBlock,
            testId: "smart-link-draggable-block"
        }, children);
        $[30] = children;
        $[31] = t6;
    } else t6 = $[31];
    let t7;
    if ($[32] !== preview || $[33] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t6, preview);
        $[32] = preview;
        $[33] = t6;
        $[34] = t7;
    } else t7 = $[34];
    return t7;
} : function SmartLinkDraggableInner({ url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget = false, children: children }) {
    const ref = (0, $42omo.useRef)(null);
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const [state, setState] = (0, $42omo.useState)($ba441b9d4456e512$var$idleState); // Store the draggable config so we can re-register on different elements
    // when the browser picks a child as the drag target.
    const getDragConfig = (0, $42omo.useCallback)((targetEl)=>({
            element: targetEl,
            getInitialData: ()=>{
                const cardState = store.getState()[url];
                const details = cardState?.details;
                const title = propTitle || (0, $a1WXB.extractSmartLinkTitle)(details);
                const iconUrl = $ba441b9d4456e512$var$getIconUrl(details);
                return {
                    type: source,
                    url: url,
                    title: title,
                    iconUrl: iconUrl,
                    appearance: appearance
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                const cardState_0 = store.getState()[url];
                const details_0 = cardState_0?.details;
                const title_0 = propTitle || (0, $a1WXB.extractSmartLinkTitle)(details_0);
                const iconUrl_0 = $ba441b9d4456e512$var$getIconUrl(details_0);
                (0, $3ts5j.setCustomNativeDragPreview)({
                    getOffset: (0, $85Mv7.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setState({
                            type: 'preview',
                            container: container,
                            title: title_0,
                            iconUrl: iconUrl_0
                        });
                        return ()=>setState($ba441b9d4456e512$var$draggingState);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>setState($ba441b9d4456e512$var$draggingState),
            onDrop: ()=>setState($ba441b9d4456e512$var$idleState)
        }), [
        url,
        propTitle,
        appearance,
        source,
        store
    ]);
    // On pointerdown, determine the drag element and register it with Pragmatic DnD.
    // Uses pointerdown because the drag source may not exist at mount time as smart cards resolve.
    // For inline cards inside ProseMirror, prefer the inner anchor because the browser fires
    // dragstart from that element rather than from the inline card wrapper.
    (0, $42omo.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const inlineCardRootSelector = '[data-prosemirror-node-name="inlineCard"][draggable="true"]'; // In contentEditable editors (ProseMirror), the browser may pick a child
        // element (e.g., an <a> tag) as the drag target instead of our element.
        // On pointerdown, we find the likely drag target and register draggable()
        // on it so pragmatic-drag-and-drop recognizes the drag.
        let cleanupDraggable = null; // In contentEditable="true" contexts (block/embed cards), the browser treats
        // the smart-element-link as editable text rather than a draggable element.
        // Not needed for inline cards since the wrapper is already not editable
        let observer = null;
        if (appearance !== "inline") {
            const setupSmartElementLink = ()=>{
                el.querySelectorAll('[data-smart-element-link]').forEach((link)=>{
                    link.contentEditable = 'false';
                    link.setAttribute('draggable', 'true');
                });
            };
            setupSmartElementLink();
            observer = new MutationObserver(setupSmartElementLink);
            observer.observe(el, {
                childList: true,
                subtree: true
            });
        }
        const unbindPointerDown = (0, $fFa3V.bind)(el, {
            type: 'pointerdown',
            listener: (event)=>{
                const selectionAtPointerDown = window.getSelection();
                if (appearance === "inline" && selectionAtPointerDown?.type === 'Range' && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                cleanupDraggable?.();
                const target = event.target; // Find the nearest draggable ancestor within the card to match
                // the element the browser will use as the dragstart target.
                let dragTarget = el;
                if (appearance === "inline") {
                    const targetElement = target instanceof Element ? target : null;
                    const hostInlineCardRoot = el.closest(inlineCardRootSelector);
                    const inlineCardRoot = targetElement?.closest(inlineCardRootSelector) ?? null;
                    const closestInlineAnchor = targetElement?.closest('a[href], [data-smart-element-link]') ?? null;
                    if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                    else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                cleanupDraggable = (0, $4T4vf.draggable)(getDragConfig(dragTarget));
            }
        });
        return ()=>{
            cleanupDraggable?.();
            unbindPointerDown();
            observer?.disconnect();
        };
    }, [
        url,
        propTitle,
        appearance,
        source,
        store,
        getDragConfig
    ]);
    const preview = state.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba441b9d4456e512$var$SmartLinkDragPreview, {
        title: state.title,
        url: url,
        iconUrl: state.iconUrl
    }), state.container) : null; // Use span with inline display for inline cards to preserve text flow.
    if (appearance === "inline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: ref,
        "data-testid": "smart-link-draggable-inline",
        "data-spotlight-target": isChangeboardTarget ? 'smart-link-draggable-changeboard' : undefined,
        className: (0, $gMc0m.default)([
            "_80om1qgj _1e0c1nu9"
        ])
    }, children), preview);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: ref,
        xcss: $ba441b9d4456e512$var$styles.draggableBlock,
        testId: "smart-link-draggable-block"
    }, children), preview);
};
/**
 * Wraps a smart link card to make it draggable into the content tree.
 * Extracts the resolved title and icon from the smart link data store at drag start time.
 * Falls back to rendering children directly when the feature flag is off or url is missing.
 */ function $ba441b9d4456e512$var$_temp(link) {
    link.contentEditable = "false";
    link.setAttribute("draggable", "true");
}
const $ba441b9d4456e512$export$c67c8f76ce4436c = (0, $4pOgL.isReactCompilerActivePlatform)() ? function SmartLinkDraggable(t0) {
    const $ = (0, $frIzR.c)(9);
    const { url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children } = t0;
    if (!url || !(0, $l3dur.isSafeUrl)(url) || !(0, $dh538.fg)("cc_drag_and_drop_smart_link_from_content_to_tree")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== appearance || $[3] !== children || $[4] !== isChangeboardTarget || $[5] !== source || $[6] !== title || $[7] !== url) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba441b9d4456e512$var$SmartLinkDraggableInner, {
            url: url,
            title: title,
            appearance: appearance,
            source: source,
            isChangeboardTarget: isChangeboardTarget
        }, children);
        $[2] = appearance;
        $[3] = children;
        $[4] = isChangeboardTarget;
        $[5] = source;
        $[6] = title;
        $[7] = url;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : function SmartLinkDraggable({ url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children }) {
    if (!url || !(0, $l3dur.isSafeUrl)(url) || !(0, $dh538.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba441b9d4456e512$var$SmartLinkDraggableInner, {
        url: url,
        title: title,
        appearance: appearance,
        source: source,
        isChangeboardTarget: isChangeboardTarget
    }, children);
};
module.exports["SMART_LINK_DRAG_TYPES"] = $ba441b9d4456e512$export$89741becde3d0e54;
module.exports["SMART_LINK_APPEARANCE"] = $ba441b9d4456e512$export$a4a3cf1d43312764;
module.exports["isSmartLinkDrag"] = $ba441b9d4456e512$export$ac5f6dc1cb5b8db6;
module.exports["SmartLinkDraggable"] = $ba441b9d4456e512$export$c67c8f76ce4436c;

});

parcelRegister("882hS", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("85Mv7")).pointerOutsideOfPreview);

var $85Mv7 = parcelRequire("85Mv7");


});

parcelRegister("85Mv7", function(module, exports) {

var $ic3Jg = parcelRequire("ic3Jg");


var $iFRCn = parcelRequire("iFRCn");


var $76xc7 = parcelRequire("76xc7");

function $30069a8958953d8b$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $iFRCn.isSafariOnIOS)() || (0, $ic3Jg.isAndroid)()) return (0, $76xc7.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $30069a8958953d8b$export$427e20518819fabc;

});

parcelRegister("iFRCn", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");


var $e880Z = parcelRequire("e880Z");

const $3720fb1a551ae595$export$52fc40c68fea4952 = (0, $aYpzB.once)(function isSafariOnIOS() {
    return (0, $e880Z.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $3720fb1a551ae595$export$52fc40c68fea4952;

});

parcelRegister("76xc7", function(module, exports) {
const $54acc06d1c628398$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $54acc06d1c628398$export$81d8e72a15eef435;

});

parcelRegister("afUmf", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("3ts5j")).setCustomNativeDragPreview);

var $3ts5j = parcelRequire("3ts5j");


});

parcelRegister("3ts5j", function(module, exports) {

var $3CnSH = parcelRequire("3CnSH");


var $e880Z = parcelRequire("e880Z");


var $f7qXf = parcelRequire("f7qXf");


var $hSdmP = parcelRequire("hSdmP");


var $j4IDJ = parcelRequire("j4IDJ");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $90430ceac724b72d$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $90430ceac724b72d$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $90430ceac724b72d$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $j4IDJ.supportsPopover)()) container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $j4IDJ.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $hSdmP.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $f7qXf.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $j4IDJ.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ /**
		 * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
		 * We can remove it in a future release
		 */ if ((0, $e880Z.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $3CnSH.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $90430ceac724b72d$export$52d889c66db0f96e;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("51lK8", function(module, exports) {

var $4T4vf = parcelRequire("4T4vf");


var $f1MqO = parcelRequire("f1MqO");

const $883f68a01157ae2e$var$api = (0, $f1MqO.makeApi)({
    monitor: (0, $4T4vf.monitorForElements)
});
const $883f68a01157ae2e$export$4b66ee8317094cdb = $883f68a01157ae2e$var$api.autoScroll;
const $883f68a01157ae2e$export$c9168f41de61f525 = $883f68a01157ae2e$var$api.autoScrollWindow;
module.exports["autoScrollForElements"] = $883f68a01157ae2e$export$4b66ee8317094cdb;

});

parcelRegister("f1MqO", function(module, exports) {

var $bSjaC = parcelRequire("bSjaC");

parcelRequire("eItNK");
var $aYpzB = parcelRequire("aYpzB");


var $jtbk8 = parcelRequire("jtbk8");


var $ejbcR = parcelRequire("ejbcR");


var $h66Yh = parcelRequire("h66Yh");

function $d8d8df98db63a460$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $bSjaC.combine)((0, $ejbcR.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $aYpzB.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $aYpzB.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $h66Yh.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $jtbk8.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}
module.exports["makeApi"] = $d8d8df98db63a460$export$b8fa21320a811083;

});

parcelRegister("eItNK", function(module, exports) {
$parcel$export(module.exports, "once", () => (parcelRequire("aYpzB")).once);

var $aYpzB = parcelRequire("aYpzB");


});

parcelRegister("jtbk8", function(module, exports) {
parcelRequire("5jQxm");
var $66utD = parcelRequire("66utD");


var $1PEak = parcelRequire("1PEak");

// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $ae06eb7a26d5c40d$var$schedulers = new Map();
function $ae06eb7a26d5c40d$export$5cff7ac265db316a(monitor) {
    const scheduler = $ae06eb7a26d5c40d$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $ae06eb7a26d5c40d$var$makeScheduler(monitor);
    $ae06eb7a26d5c40d$var$schedulers.set(monitor, created);
    return created;
}
function $ae06eb7a26d5c40d$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $66utD.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $1PEak.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $1PEak.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}
module.exports["getScheduler"] = $ae06eb7a26d5c40d$export$5cff7ac265db316a;

});

parcelRegister("5jQxm", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("66utD")).getElementFromPointWithoutHoneypot);

var $66utD = parcelRequire("66utD");


});

parcelRegister("1PEak", function(module, exports) {
const $b8aa3381b771fe03$var$ledger = new Map();
const $b8aa3381b771fe03$var$requested = new Set();
function $b8aa3381b771fe03$export$8c764c3f2fc3d2d2(element) {
    $b8aa3381b771fe03$export$1cb7cbb266b6f6fa(element);
    const entry = $b8aa3381b771fe03$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b8aa3381b771fe03$var$ledger.set(element, fresh);
    return fresh;
}
function $b8aa3381b771fe03$export$1cb7cbb266b6f6fa(element) {
    $b8aa3381b771fe03$var$requested.add(element);
}
function $b8aa3381b771fe03$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b8aa3381b771fe03$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b8aa3381b771fe03$var$ledger.forEach((_, element)=>{
        if (!$b8aa3381b771fe03$var$requested.has(element)) $b8aa3381b771fe03$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b8aa3381b771fe03$var$requested.clear();
}
function $b8aa3381b771fe03$export$13ae770ed39b71ea() {
    $b8aa3381b771fe03$var$ledger.clear();
}
module.exports["markAndGetEngagement"] = $b8aa3381b771fe03$export$8c764c3f2fc3d2d2;
module.exports["clearUnusedEngagements"] = $b8aa3381b771fe03$export$991e77dd347f3df1;
module.exports["clearEngagementHistory"] = $b8aa3381b771fe03$export$13ae770ed39b71ea;

});

parcelRegister("ejbcR", function(module, exports) {
const $ba3cc2be2c89e337$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $ba3cc2be2c89e337$export$aea217a45095ce11 = `[${$ba3cc2be2c89e337$export$4b152ab55cad4fd6}="true"]`;
function $ba3cc2be2c89e337$export$4ec12fb57dfebd53(element) {
    element.setAttribute($ba3cc2be2c89e337$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($ba3cc2be2c89e337$export$4b152ab55cad4fd6);
}
module.exports["selector"] = $ba3cc2be2c89e337$export$aea217a45095ce11;
module.exports["addScrollableAttribute"] = $ba3cc2be2c89e337$export$4ec12fb57dfebd53;

});

parcelRegister("h66Yh", function(module, exports) {

var $h9dtK = parcelRequire("h9dtK");


var $1PEak = parcelRequire("1PEak");


var $ejbcR = parcelRequire("ejbcR");


var $6DDhO = parcelRequire("6DDhO");

function $568f43811c88fe4c$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $568f43811c88fe4c$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$568f43811c88fe4c$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $ejbcR.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $568f43811c88fe4c$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $1PEak.markAndGetEngagement)(element);
    const config = (0, $h9dtK.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $6DDhO.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $568f43811c88fe4c$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $1PEak.markAndGetEngagement)(element);
        const config = (0, $h9dtK.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $6DDhO.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $568f43811c88fe4c$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $568f43811c88fe4c$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$568f43811c88fe4c$var$isScrollingAvailable(remainder)) return;
    $568f43811c88fe4c$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}
module.exports["tryScroll"] = $568f43811c88fe4c$export$233199807749476d;

});

parcelRegister("h9dtK", function(module, exports) {
const $35bbc9592dd770aa$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $35bbc9592dd770aa$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $35bbc9592dd770aa$export$e96028ec7ff9d079(provided) {
    return {
        ...$35bbc9592dd770aa$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $35bbc9592dd770aa$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}
module.exports["getInternalConfig"] = $35bbc9592dd770aa$export$e96028ec7ff9d079;

});

parcelRegister("6DDhO", function(module, exports) {

var $hhm38 = parcelRequire("hhm38");


var $ajYex = parcelRequire("ajYex");


var $lFBSq = parcelRequire("lFBSq");


var $wfJXn = parcelRequire("wfJXn");


var $eIOs5 = parcelRequire("eIOs5");


var $6UNNA = parcelRequire("6UNNA");

function $d6a7fe667f94accc$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $d6a7fe667f94accc$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $d6a7fe667f94accc$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $ajYex.edges).reduce((map, edge)=>{
        const hitbox = (0, $lFBSq.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $ajYex.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $eIOs5.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $6UNNA.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $hhm38.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}
module.exports["getScrollBy"] = $d6a7fe667f94accc$export$6cfa6dfe6898b98f;

});

parcelRegister("hhm38", function(module, exports) {
const $7d638df63a9348c1$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};
module.exports["canScrollOnEdge"] = $7d638df63a9348c1$export$ccd6d9407403fcad;

});

parcelRegister("ajYex", function(module, exports) {
const $e2d5736e549d9f1a$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $e2d5736e549d9f1a$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};
module.exports["edges"] = $e2d5736e549d9f1a$export$4544a00f8eb65eb2;
module.exports["edgeAxisLookup"] = $e2d5736e549d9f1a$export$7fc144124ccf8292;

});

parcelRegister("lFBSq", function(module, exports) {

var $8e8VQ = parcelRequire("8e8VQ");


var $84ZAS = parcelRequire("84ZAS");

function $c2a3ef074bb4151d$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $8e8VQ.axisLookup)[axis];
        const side = (0, $84ZAS.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $c2a3ef074bb4151d$export$b9a449c20abb0e9 = {
    top: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};
module.exports["getOverElementHitbox"] = $c2a3ef074bb4151d$export$b9a449c20abb0e9;

});

parcelRegister("8e8VQ", function(module, exports) {
const $88deb29ded672487$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $88deb29ded672487$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $88deb29ded672487$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $88deb29ded672487$var$vertical,
        crossAxis: $88deb29ded672487$var$horizontal
    },
    horizontal: {
        mainAxis: $88deb29ded672487$var$horizontal,
        crossAxis: $88deb29ded672487$var$vertical
    }
};
module.exports["axisLookup"] = $88deb29ded672487$export$42e42cdab35a2b96;

});

parcelRegister("84ZAS", function(module, exports) {
const $5948654a23ca7c24$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};
module.exports["mainAxisSideLookup"] = $5948654a23ca7c24$export$a45c0cd714a4dbaa;

});

parcelRegister("wfJXn", function(module, exports) {

var $8e8VQ = parcelRequire("8e8VQ");


var $htU2u = parcelRequire("htU2u");


var $84ZAS = parcelRequire("84ZAS");

// We want a consistent scroll speed across devices, regardless of framerate
function $3f544cf5427e20fd$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $3f544cf5427e20fd$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $8e8VQ.axisLookup)[axis];
    const side = (0, $84ZAS.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $htU2u.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $htU2u.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $3f544cf5427e20fd$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $3f544cf5427e20fd$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $3f544cf5427e20fd$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $htU2u.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $84ZAS.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}
module.exports["getScrollChange"] = $3f544cf5427e20fd$export$470a2ff46db8cee8;

});

parcelRegister("htU2u", function(module, exports) {
function $1fec9052eae48826$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}
module.exports["getPercentageInRange"] = $1fec9052eae48826$export$1a29de000a332d74;

});

parcelRegister("eIOs5", function(module, exports) {
function $602bab09026eed2a$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}
module.exports["isAxisAllowed"] = $602bab09026eed2a$export$7120fdbd90bd1292;

});

parcelRegister("6UNNA", function(module, exports) {
function $92037081dc0ecd04$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
module.exports["isWithin"] = $92037081dc0ecd04$export$cda7a9d4399bf2e3;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return (0, $9wGTI.fg)('aifc_create_enabled');
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("7EIq6", function(module, exports) {

var $dd33Q = parcelRequire("dd33Q");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, spaceEnabledContentTypesQueryOptions);
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = isDefaultSpaceKeyLoading || isAnyContentTypesLoading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("5k6WH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $uRQKa = parcelRequire("uRQKa");


var $6ttbq = parcelRequire("6ttbq");

const $479e1e8ac650b5b6$export$c537e63161742ce3 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $42omo.useState)((0, $6ttbq.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $uRQKa.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $fFa3V.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $42omo.useState)((0, $6ttbq.isReducedMotion));
    (0, $42omo.useEffect)(()=>{
        if (!(0, $uRQKa.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $479e1e8ac650b5b6$export$c537e63161742ce3;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("4TIFs", function(module, exports) {
$parcel$export(module.exports, "default", () => $390ef28ea0b1f2a7$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $390ef28ea0b1f2a7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("4XRO0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::197921048e92db6f31070962e79acfb7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $39d668c2c7063a5d$var$_react = $39d668c2c7063a5d$var$_interopRequireDefault((parcelRequire("42omo")));

var $39d668c2c7063a5d$var$_baseNew = $39d668c2c7063a5d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $39d668c2c7063a5d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: play video in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $39d668c2c7063a5d$var$VideoPlayCircleIcon = (props)=>/*#__PURE__*/ $39d668c2c7063a5d$var$_react.default.createElement($39d668c2c7063a5d$var$_baseNew.default, Object.assign({
        name: "VideoPlayCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m5-2.694c0-.808.866-1.32 1.574-.931l4.958 2.722a1.062 1.062 0 0 1 0 1.862l-4.958 2.722A1.063 1.063 0 0 1 5 10.75zm1.5.74v3.965l3.611-1.983z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 10.01V6.046l3.611 1.983z"/>`
    }, props));
$39d668c2c7063a5d$var$VideoPlayCircleIcon.displayName = 'VideoPlayCircleIcon';
var $39d668c2c7063a5d$var$_default = module.exports.default = $39d668c2c7063a5d$var$VideoPlayCircleIcon;

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("exBjF", function(module, exports) {
parcelRequire("5V8lD");
var $4pgc7 = parcelRequire("4pgc7");
var $3jjlh = parcelRequire("3jjlh");
var $wbfRU = parcelRequire("wbfRU");
var $hPMbS = parcelRequire("hPMbS");
var $6UtPP = parcelRequire("6UtPP");

var $a96117fb0ff7c511$var$global = (0, $wbfRU.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $a96117fb0ff7c511$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $4pgc7.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $a96117fb0ff7c511$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $a96117fb0ff7c511$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $3jjlh.fill)($a96117fb0ff7c511$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $6UtPP.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $hPMbS.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $hPMbS.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($a96117fb0ff7c511$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();
module.exports["CaptureConsole"] = $a96117fb0ff7c511$export$25a43cb5b5c58c08;

});

parcelRegister("5V8lD", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("wbfRU")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("ksUmj")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("ksUmj")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("4pgc7")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("4pgc7")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("kGRNS")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("3jjlh")).fill);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("6UtPP")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("hPMbS")).safeJoin);





parcelRequire("wbfRU");


parcelRequire("ksUmj");

parcelRequire("4pgc7");




var $6NRdb = parcelRequire("6NRdb");

parcelRequire("kGRNS");

parcelRequire("3jjlh");



parcelRequire("6UtPP");



parcelRequire("hPMbS");




var $c1Rlb = parcelRequire("c1Rlb");






$parcel$exportWildcard(module.exports, $6NRdb);
$parcel$exportWildcard(module.exports, $c1Rlb);

});

parcelRegister("3FhX7", function(module, exports) {

var $wbfRU = parcelRequire("wbfRU");


var $ksUmj = parcelRequire("ksUmj");

function $2ab3206f334f2299$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $2ab3206f334f2299$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $2ab3206f334f2299$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $ksUmj.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $2ab3206f334f2299$export$1cfafeee2987818b() {
    var global = (0, $wbfRU.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}
module.exports["htmlTreeAsString"] = $2ab3206f334f2299$export$5647df6b7814ac86;

});

parcelRegister("wbfRU", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $6NRdb = parcelRequire("6NRdb");

var $060bb845762b2c42$var$fallbackGlobalObject = {};
function $060bb845762b2c42$export$256479dc0cea61c4() {
    return (0, $6NRdb.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $060bb845762b2c42$var$fallbackGlobalObject;
}
function $060bb845762b2c42$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $060bb845762b2c42$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
module.exports["getGlobalObject"] = $060bb845762b2c42$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $060bb845762b2c42$export$7e223ec222791509;

});

parcelRegister("6NRdb", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $3kQPK = parcelRequire("3kQPK");


var $kyRHQ = parcelRequire("kyRHQ");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $3kQPK.isBrowserBundle)() && Object.prototype.toString.call(typeof $kyRHQ !== 'undefined' ? $kyRHQ : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});

parcelRegister("3kQPK", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $26dc390a525d107c$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
module.exports["isBrowserBundle"] = $26dc390a525d107c$export$2928c40372e623c0;

});

parcelRegister("ksUmj", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $ee6223dddca4d288$var$objectToString = Object.prototype.toString;
function $ee6223dddca4d288$export$e6127cc7fe7395c3(wat) {
    switch($ee6223dddca4d288$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $ee6223dddca4d288$export$49034edbe6b62415(wat, Error);
    }
}
function $ee6223dddca4d288$var$isBuiltin(wat, ty) {
    return $ee6223dddca4d288$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $ee6223dddca4d288$export$9f9636d330b71954(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'ErrorEvent');
}
function $ee6223dddca4d288$export$ef9e2056653f0c8e(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'DOMError');
}
function $ee6223dddca4d288$export$12e869b2a583f783(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'DOMException');
}
function $ee6223dddca4d288$export$844ec244b1367d54(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'String');
}
function $ee6223dddca4d288$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $ee6223dddca4d288$export$53b83ca8eaab0383(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'Object');
}
function $ee6223dddca4d288$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $ee6223dddca4d288$export$49034edbe6b62415(wat, Event);
}
function $ee6223dddca4d288$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $ee6223dddca4d288$export$49034edbe6b62415(wat, Element);
}
function $ee6223dddca4d288$export$49841c62b9eff15(wat) {
    return $ee6223dddca4d288$var$isBuiltin(wat, 'RegExp');
}
function $ee6223dddca4d288$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $ee6223dddca4d288$export$bc2894c7158efbac(wat) {
    return $ee6223dddca4d288$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $ee6223dddca4d288$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $ee6223dddca4d288$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
module.exports["isError"] = $ee6223dddca4d288$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $ee6223dddca4d288$export$49034edbe6b62415;
module.exports["isString"] = $ee6223dddca4d288$export$844ec244b1367d54;
module.exports["isPrimitive"] = $ee6223dddca4d288$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $ee6223dddca4d288$export$53b83ca8eaab0383;
module.exports["isEvent"] = $ee6223dddca4d288$export$9671ea99bd126ace;
module.exports["isElement"] = $ee6223dddca4d288$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $ee6223dddca4d288$export$49841c62b9eff15;
module.exports["isSyntheticEvent"] = $ee6223dddca4d288$export$bc2894c7158efbac;
module.exports["isNaN"] = $ee6223dddca4d288$export$c9f5652083b8129d;

});

parcelRegister("ldQnK", function(module, exports) {
var $f73371db46ba81c9$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];
module.exports["SeverityLevels"] = $f73371db46ba81c9$export$484b1ea9aec914c;

});

parcelRegister("4pgc7", function(module, exports) {
$parcel$export(module.exports, "logger", () => $33560f1d6b7016a1$export$af88d00dbe7f521);

var $hXuPC = parcelRequire("hXuPC");


var $kyuk6 = parcelRequire("kyuk6");


var $wbfRU = parcelRequire("wbfRU");

// TODO: Implement different loggers for different environments
var $33560f1d6b7016a1$var$global = (0, $wbfRU.getGlobalObject)();
/** Prefix for logging strings */ var $33560f1d6b7016a1$var$PREFIX = 'Sentry Logger ';
var $33560f1d6b7016a1$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $33560f1d6b7016a1$export$cda52e2a8927a2ca(callback) {
    var global = (0, $wbfRU.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $33560f1d6b7016a1$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $33560f1d6b7016a1$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $kyuk6.IS_DEBUG_BUILD) $33560f1d6b7016a1$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $33560f1d6b7016a1$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $33560f1d6b7016a1$var$global.console)[name].apply(_a, (0, $hXuPC.__spread)([
                    $33560f1d6b7016a1$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $33560f1d6b7016a1$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $33560f1d6b7016a1$export$af88d00dbe7f521;
if (0, $kyuk6.IS_DEBUG_BUILD) $33560f1d6b7016a1$export$af88d00dbe7f521 = (0, $wbfRU.getGlobalSingleton)('logger', $33560f1d6b7016a1$var$makeLogger);
else $33560f1d6b7016a1$export$af88d00dbe7f521 = $33560f1d6b7016a1$var$makeLogger();
module.exports["CONSOLE_LEVELS"] = $33560f1d6b7016a1$export$2a2b1d2252a69ecb;

});

parcelRegister("kyuk6", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $ef6e812e97b2e7a4$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
module.exports["IS_DEBUG_BUILD"] = $ef6e812e97b2e7a4$export$48a8984ec0bf2e44;

});

parcelRegister("8KmfX", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $65e3e2445bc0a001$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports["memoBuilder"] = $65e3e2445bc0a001$export$8115b0b78e956ab3;

});

parcelRegister("kGRNS", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $ksUmj = parcelRequire("ksUmj");


var $8KmfX = parcelRequire("8KmfX");


var $3jjlh = parcelRequire("3jjlh");


var $2FEvv = parcelRequire("2FEvv");

function $03e31ed33816e4c8$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $03e31ed33816e4c8$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $03e31ed33816e4c8$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $03e31ed33816e4c8$export$a3295358bff77e(object, depth);
    if ($03e31ed33816e4c8$var$jsonSize(normalized) > maxSize) return $03e31ed33816e4c8$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $03e31ed33816e4c8$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $8KmfX.memoBuilder)();
    var _a = (0, $hXuPC.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $ksUmj.isNaN)(value)) return value;
    var stringified = $03e31ed33816e4c8$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $ksUmj.isError)(value) || (0, $ksUmj.isEvent)(value) ? (0, $3jjlh.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $03e31ed33816e4c8$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $03e31ed33816e4c8$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $ksUmj.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $2FEvv.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $03e31ed33816e4c8$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $03e31ed33816e4c8$var$jsonSize(value) {
    return $03e31ed33816e4c8$var$utf8Length(JSON.stringify(value));
}
module.exports["normalize"] = $03e31ed33816e4c8$export$a3295358bff77e;

});

parcelRegister("3jjlh", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $3FhX7 = parcelRequire("3FhX7");


var $ksUmj = parcelRequire("ksUmj");


var $hPMbS = parcelRequire("hPMbS");

function $26922664d1405f23$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $26922664d1405f23$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $26922664d1405f23$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $26922664d1405f23$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $26922664d1405f23$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $26922664d1405f23$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $26922664d1405f23$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $26922664d1405f23$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $ksUmj.isError)(value)) newObj = (0, $hXuPC.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $26922664d1405f23$var$getOwnProperties(value));
    else if ((0, $ksUmj.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $hXuPC.__assign)({
            type: event_1.type,
            target: $26922664d1405f23$var$serializeEventTarget(event_1.target),
            currentTarget: $26922664d1405f23$var$serializeEventTarget(event_1.currentTarget)
        }, $26922664d1405f23$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $ksUmj.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $26922664d1405f23$var$serializeEventTarget(target) {
    try {
        return (0, $ksUmj.isElement)(target) ? (0, $3FhX7.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $26922664d1405f23$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $26922664d1405f23$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($26922664d1405f23$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $hPMbS.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $hPMbS.truncate)(serialized, maxLength);
    }
    return '';
}
function $26922664d1405f23$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $ksUmj.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $hXuPC.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $26922664d1405f23$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($26922664d1405f23$export$d25f2688db1bb433);
    return val;
}
function $26922664d1405f23$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $ksUmj.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports["fill"] = $26922664d1405f23$export$9563e054e6f787fb;
module.exports["convertToPlainObject"] = $26922664d1405f23$export$62ff257738bf57f5;

});

parcelRegister("hPMbS", function(module, exports) {

var $ksUmj = parcelRequire("ksUmj");

function $cfbc94b797f7d695$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $cfbc94b797f7d695$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $cfbc94b797f7d695$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $cfbc94b797f7d695$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $ksUmj.isString)(value)) return false;
    if ((0, $ksUmj.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $cfbc94b797f7d695$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
module.exports["truncate"] = $cfbc94b797f7d695$export$6a506b36fdea397d;
module.exports["safeJoin"] = $cfbc94b797f7d695$export$465e9d514283d4fd;

});

parcelRegister("2FEvv", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

var $1f1ed4f8ccef7485$var$STACKTRACE_LIMIT = 50;
function $1f1ed4f8ccef7485$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $hXuPC.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $hXuPC.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $1f1ed4f8ccef7485$export$c55c24c0eeba0205(frames);
    };
}
function $1f1ed4f8ccef7485$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $1f1ed4f8ccef7485$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $1f1ed4f8ccef7485$var$defaultFunctionName = '<anonymous>';
function $1f1ed4f8ccef7485$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $1f1ed4f8ccef7485$var$defaultFunctionName;
        return fn.name || $1f1ed4f8ccef7485$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $1f1ed4f8ccef7485$var$defaultFunctionName;
    }
}
module.exports["getFunctionName"] = $1f1ed4f8ccef7485$export$aad197c7121a6651;

});

parcelRegister("6UtPP", function(module, exports) {

var $cs0rL = parcelRequire("cs0rL");


var $ldQnK = parcelRequire("ldQnK");

function $507f1d9e8f769fdb$var$isSupportedSeverity(level) {
    return (0, $ldQnK.SeverityLevels).indexOf(level) !== -1;
}
function $507f1d9e8f769fdb$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $cs0rL.Severity).Warning;
    if ($507f1d9e8f769fdb$var$isSupportedSeverity(level)) return level;
    return (0, $cs0rL.Severity).Log;
}
module.exports["severityFromString"] = $507f1d9e8f769fdb$export$e01cef29b4327697;

});

parcelRegister("c1Rlb", function(module, exports) {

var $wbfRU = parcelRequire("wbfRU");


var $6NRdb = parcelRequire("6NRdb");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $wbfRU.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $6NRdb.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $6NRdb.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $wbfRU.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("emwrp", function(module, exports) {
parcelRequire("5V8lD");
var $4pgc7 = parcelRequire("4pgc7");


var $8kQ9p = parcelRequire("8kQ9p");

/** Deduplication filter */ var $a74c48ddcd29ab0c$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($a74c48ddcd29ab0c$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $8kQ9p.IS_DEBUG_BUILD) && (0, $4pgc7.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $a74c48ddcd29ab0c$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($a74c48ddcd29ab0c$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($a74c48ddcd29ab0c$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$a74c48ddcd29ab0c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$a74c48ddcd29ab0c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $a74c48ddcd29ab0c$var$_getExceptionFromEvent(previousEvent);
    var currentException = $a74c48ddcd29ab0c$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$a74c48ddcd29ab0c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$a74c48ddcd29ab0c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $a74c48ddcd29ab0c$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $a74c48ddcd29ab0c$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $a74c48ddcd29ab0c$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}
module.exports["Dedupe"] = $a74c48ddcd29ab0c$export$688d98c249d31ad3;

});

parcelRegister("8kQ9p", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $6118a50aab7b3a53$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
module.exports["IS_DEBUG_BUILD"] = $6118a50aab7b3a53$export$48a8984ec0bf2e44;

});

parcelRegister("6JOHL", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

parcelRequire("5V8lD");
var $ksUmj = parcelRequire("ksUmj");
var $4pgc7 = parcelRequire("4pgc7");
var $kGRNS = parcelRequire("kGRNS");


var $8kQ9p = parcelRequire("8kQ9p");

/** Patch toString calls to return proper name for wrapped functions */ var $4e7e46f7945dcb56$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $hXuPC.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $ksUmj.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $hXuPC.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $kGRNS.normalize)(errorData, this._options.depth);
            if ((0, $ksUmj.isPlainObject)(normalizedErrorData)) contexts = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $hXuPC.__assign)({}, normalizedErrorData), _a));
            return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $hXuPC.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $ksUmj.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $hXuPC.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $ksUmj.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $8kQ9p.IS_DEBUG_BUILD) && (0, $4pgc7.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();
module.exports["ExtraErrorData"] = $4e7e46f7945dcb56$export$56d961ef3a52a072;

});

parcelRegister("erpTL", function(module, exports) {
/** Add node transaction to the event */ var $a837ad3723132784$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();
module.exports["Transaction"] = $a837ad3723132784$export$febc5573c75cefb0;

});

parcelRegister("aLypr", function(module, exports) {
const $e5e607f963e2ce3b$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $e5e607f963e2ce3b$export$7452d7062a4d0634;

});

parcelRegister("9ISlX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d6477c19fa37ad04$export$8f5a73ba0d077b01 = 32;
class $d6477c19fa37ad04$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + $d6477c19fa37ad04$export$8f5a73ba0d077b01;
            onHeightUpdate(height);
        };
    }
}
module.exports["embedHeaderHeight"] = $d6477c19fa37ad04$export$8f5a73ba0d077b01;
module.exports["EmbedResizeMessageListener"] = $d6477c19fa37ad04$export$3482036c37e627f4;

});

parcelRegister("6CRn4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5311f5d282e4b997$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $gxsT9 = parcelRequire("gxsT9");


var $gAARK = parcelRequire("gAARK");


var $aB5Ee = parcelRequire("aB5Ee");


var $8K67p = parcelRequire("8K67p");


var $1OLls = parcelRequire("1OLls");

function $5311f5d282e4b997$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $8K67p.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $aB5Ee.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $aFUXX.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH) - (0, $aFUXX.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $1OLls.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $dh538.fg)('media-perf-uplift-mutation-fix')
        }),
        ...!(0, $dh538.fg)('platform_editor_fix_media_in_renderer') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $gxsT9.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1OLls.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});

parcelRegister("aB5Ee", function(module, exports) {
/**
 * Convert media node width to pixel
 *
 * for legacy experience, image is aligned inside resize handle bar with a gap. So gutterOffset is used to for this use case.
 * for new experience, image is aligned with resize handle bar, so gutterOffset is 0
 *
 * @param width - media single node width
 * @param editorWidth - width of editor
 * @param widthType - width type is defined in the adf document for mediaSingle node, and it is associated with the `width`
 * @param gutterOffset - resize handle bar offset, determines whether align with resize handle bar
 * @returns pixel number for media single node
 */ function $808f41f1d2f81b77$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
module.exports["getMediaSinglePixelWidth"] = $808f41f1d2f81b77$export$a6f4ec2edd25b07e;

});

parcelRegister("1OLls", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $3ZFfQ = parcelRequire("3ZFfQ");


var $fJNzZ = parcelRequire("fJNzZ");


var $fVLcy = parcelRequire("fVLcy");


var $dk9GR = parcelRequire("dk9GR");

function $0ef555bed3f3ee7f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $0ef555bed3f3ee7f$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $aFUXX.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $aFUXX.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $aFUXX.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $aFUXX.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $aFUXX.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $aFUXX.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $0ef555bed3f3ee7f$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $fJNzZ.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $0ef555bed3f3ee7f$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(width, containerWidth) : $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $0ef555bed3f3ee7f$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $0ef555bed3f3ee7f$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $0ef555bed3f3ee7f$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $0ef555bed3f3ee7f$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $0ef555bed3f3ee7f$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $0ef555bed3f3ee7f$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = (0, $dk9GR.roundToClosestEvenPxValue)(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? (0, $fVLcy.calcResizedWidth)(layout, width || 0, containerWidth) : $0ef555bed3f3ee7f$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $0ef555bed3f3ee7f$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &,[data-prosemirror-node-name='bodiedSyncBlock'] &,[data-prosemirror-node-name='syncBlock'] &,[data-sync-block-renderer] &,[data-bodied-sync-block] &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $0ef555bed3f3ee7f$var$_ref2, " ", isInRenderer ? $0ef555bed3f3ee7f$var$_ref : `max-width: ${cssMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $3ZFfQ.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $0ef555bed3f3ee7f$var$float(layout), ";margin:", $0ef555bed3f3ee7f$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $3ZFfQ.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $0ef555bed3f3ee7f$var$isImageAligned(layout), ";");
};
const $0ef555bed3f3ee7f$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $9K4OG.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $0ef555bed3f3ee7f$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $9K4OG.css)("position:relative;", $0ef555bed3f3ee7f$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;height:auto!important;>div{position:absolute;height:100%;}}");
const $0ef555bed3f3ee7f$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $0ef555bed3f3ee7f$export$9e3fd9f6215dd7b6(rest)
    }, children);
$0ef555bed3f3ee7f$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $0ef555bed3f3ee7f$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    // [FEATURE FLAG: platform_editor_media_border_radius_fix]
    // Fixes border radius to properly match image with 8px radius
    // To clean up: remove conditional, keep only flag-on behavior ('8px')
    const borderRadius = (0, $dh538.fg)('platform_editor_media_border_radius_fix') ? "var(--ds-radius-large, 8px)" : '1px'; // OLD BEHAVIOR (to be removed when flag is cleaned up)
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    });
};
module.exports["MediaSingleDimensionHelper"] = $0ef555bed3f3ee7f$export$2b2737a2ef2f5b46;
module.exports["MediaWrapper"] = $0ef555bed3f3ee7f$export$542000db99cecf28;
module.exports["MediaBorderGapFiller"] = $0ef555bed3f3ee7f$export$e18e95249d813157;

});

parcelRegister("fVLcy", function(module, exports) {

var $fJNzZ = parcelRequire("fJNzZ");

function $64e5bd53603a2719$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
module.exports["calcResizedWidth"] = $64e5bd53603a2719$export$d48e8f24f681763e;

});

parcelRegister("dk9GR", function(module, exports) {
/**
 * Reduces the given CSS width value to the next lowest even pixel value if the value is in px.
 * This is to mitigate subpixel rendering issues of embedded smart links.
 *
 * @param widthValue CSS width value to be rounded
 * @returns Reduced CSS width value where px value given, or otherwise the original value
 * @example
 */ // widthValue could be a string in px, rem or percentage, e.g. "800px", "100%", etc.
function $06b3f6cceff05778$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
module.exports["roundToClosestEvenPxValue"] = $06b3f6cceff05778$export$c832331b07480714;

});

parcelRegister("fBAKC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


const $7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("69fUv")));
const $7850275dc402dd65$export$f386473e8f104bcb = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $l998X.jsx)($7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
                ...props
            })
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
            ...props
        })
    });
module.exports["LazyLoadedDatasourceRenderFailedAnalyticsWrapper"] = $7850275dc402dd65$export$f386473e8f104bcb;

});

parcelRegister("69fUv", function(module, exports) {

let $479fecd0aea59d37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $479fecd0aea59d37$var$load("koKgZ").then(()=>parcelRequire('7Fmwh'));

});

parcelRegister("h8cpw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $eIleF = parcelRequire("eIleF");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $kKODE = parcelRequire("kKODE");


var $eB2Ls = parcelRequire("eB2Ls");


var $4gOU2 = parcelRequire("4gOU2");


var $dOvUN = parcelRequire("dOvUN");


var $afp1H = parcelRequire("afp1H");


var $bz6dj = parcelRequire("bz6dj");


var $9oOnT = parcelRequire("9oOnT");


var $7DSoa = parcelRequire("7DSoa");


var $iqqlF = parcelRequire("iqqlF");


var $lz9QA = parcelRequire("lz9QA");

function $4a6a130a5859a503$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))(), []);
    const linkState = (0, $lz9QA.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $eIleF.useSmartLinkContext)();
    const invokeClientAction = (0, $9oOnT.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $7DSoa.default)();
    const appendCrossProductAnalyticsParams = (0, $iqqlF.useSmartLinkCrossProductUrlWrapperGated)({
        details: linkState.details
    });
    if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve({
        url: url
    });
    if (linkState.details && !actionOptions?.hide) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $eB2Ls.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $bz6dj.toAction)(downloadActionProps, invokeClientAction, (0, $afp1H.messages).download, 'download-content'));
        const viewActionProps = (0, $dh538.fg)('platform_smartlink_xpc_url_wrapping') ? (0, $dOvUN.extractInvokeViewAction)({
            ...invokeParam,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        }) : (0, $dOvUN.extractInvokeViewAction)(invokeParam);
        if (viewActionProps) actions.push((0, $bz6dj.toAction)(viewActionProps, invokeClientAction, (0, $afp1H.messages).view, 'view-content'));
        const previewActionProps = (0, $4gOU2.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            ...(0, $dh538.fg)('platform_smartlink_xpc_url_wrapping') ? {
                transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
            } : undefined
        });
        if (previewActionProps) actions.push((0, $bz6dj.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $afp1H.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}
module.exports["useSmartLinkActions"] = $4a6a130a5859a503$export$a95296ded9241771;

});

parcelRegister("bz6dj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $2752aec5c6b5a722$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), message),
        invoke: ()=>invokeClientAction(action)
    };
};
module.exports["toAction"] = $2752aec5c6b5a722$export$9d52be0dab870c7;

});

parcelRegister("7FiWH", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");


var $lOzEN = parcelRequire("lOzEN");


var $8tdj3 = parcelRequire("8tdj3");


var $jypE9 = parcelRequire("jypE9");


var $dh538 = parcelRequire("dh538");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $iGbqR = parcelRequire("iGbqR");

var $d925B = parcelRequire("d925B");


var $3RxtY = parcelRequire("3RxtY");

function $f7a722354e8e82d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Dynamic padding value that adjusts based on the editor's base font size.
 * When base font size is <= akEditorFullPageDenseFontSize (13px), uses 1px padding.
 * Otherwise, uses default value with token('space.025').
 */ const $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK = `clamp(1px, calc((var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * 999), ${"var(--ds-space-025, 2px)"})`;
const $f7a722354e8e82d7$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $f7a722354e8e82d7$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $f7a722354e8e82d7$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $f7a722354e8e82d7$var$linkStylesCommon = (0, $ecnYn.xcss)({
    position: 'absolute',
    left: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    top: '0px',
    height: '1.2em',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $f7a722354e8e82d7$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $f7a722354e8e82d7$var$ICON_WIDTH = 16;
const $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $f7a722354e8e82d7$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $f7a722354e8e82d7$var$HoverLinkOverlay = ({ children: children, isVisible: isVisible = false, url: url, destinationUrl: destinationUrl, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const containerRef = (0, $42omo.useRef)(null);
    const hoverLinkButtonRef = (0, $42omo.useRef)(null);
    const hiddenTextRef = (0, $42omo.useRef)(null);
    const [showLabel, setShowLabel] = (0, $42omo.useState)(true);
    const [isHovered, setHovered] = (0, $42omo.useState)(false);
    const openTextWidthRef = (0, $42omo.useRef)(null);
    const regularPadding = $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK;
    const memoizedHoverLinkStyles = (0, $42omo.useMemo)(()=>({
            paddingBlock: compactPadding ? '1px' : regularPadding
        }), [
        compactPadding,
        regularPadding
    ]);
    const hoverLinkStyles = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedHoverLinkStyles : {
        paddingBlock: compactPadding ? '1px' : $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK
    };
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH;
        let canShowLabel = cardWidth - openTextWidth > $f7a722354e8e82d7$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $f7a722354e8e82d7$var$ICON_WIDTH;
        // When a smart link wraps to multiple lines in a constrained container (e.g. table cell),
        // the hover button can overflow beyond the container bounds. We detect this by comparing
        // the button's right edge to the container's right edge, and hide the label if it overflows.
        if (containerRef.current && hoverLinkButtonRef.current) {
            const containerRight = containerRef.current.getBoundingClientRect().right;
            const buttonRight = hoverLinkButtonRef.current.getBoundingClientRect().right;
            if (buttonRight > containerRight) canShowLabel = false;
        }
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
        // Reset label visibility on hover start so we can measure if it overflows.
        // Without this, the label stays hidden from a previous hover and won't be re-measured.
        if (isHovered) setShowLabel(true);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $f7a722354e8e82d7$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open((0, $dh538.fg)('platform_smartlink_xpc_url_wrapping') ? destinationUrl ?? url : url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).BUTTON);
    };
    const isPreviewButton = showPanelButton && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true);
    const label = isPreviewButton ? formatMessage((0, $3RxtY.messages).previewButtonTitle) : formatMessage((0, $3RxtY.messages).openButtonTitle);
    let icon = null;
    if (isPreviewButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
        label: ""
    });
    else if (isPreviewButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: containerRef,
        css: $f7a722354e8e82d7$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false),
        // No-op focus/blur handlers to satisfy a11y/mouse-events-have-key-events rule.
        // The hover overlay is a mouse convenience — keyboard users can access link actions
        // (open, preview) via the floating toolbar that appears on selection.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, children, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $f7a722354e8e82d7$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fpGTa.default), {
        ref: hoverLinkButtonRef,
        xcss: $f7a722354e8e82d7$var$linkStylesCommon,
        href: (0, $dh538.fg)('platform_smartlink_xpc_url_wrapping') ? destinationUrl ?? url : url,
        target: "_blank",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic paddingBlock value based on experiment flags
        style: hoverLinkStyles,
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $f7a722354e8e82d7$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label)));
};
var $f7a722354e8e82d7$export$2e2bcd8739ae039 = $f7a722354e8e82d7$var$HoverLinkOverlay;
module.exports["default"] = $f7a722354e8e82d7$export$2e2bcd8739ae039;

});

parcelRegister("eLQM6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


const $b100a9eece33ac5b$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aYXeR")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": "datasource-table-view-suspense"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $l998X.jsx)($b100a9eece33ac5b$var$LazyDatasourceTableView, {
                ...props
            })
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": 'datasource-table-view-suspense'
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)($b100a9eece33ac5b$var$LazyDatasourceTableView, {
            ...props
        })
    });
};
var $b100a9eece33ac5b$export$2e2bcd8739ae039 = $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers;
module.exports["default"] = $b100a9eece33ac5b$export$2e2bcd8739ae039;

});

parcelRegister("aYXeR", function(module, exports) {

let $7fed758f66b6cdff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7fed758f66b6cdff$var$load("lFAez"),
    $7fed758f66b6cdff$var$load("ebJTU"),
    $7fed758f66b6cdff$var$load("fAtWn"),
    $7fed758f66b6cdff$var$load("iPYAE"),
    $7fed758f66b6cdff$var$load("coUzl"),
    $7fed758f66b6cdff$var$load("5nMTY"),
    $7fed758f66b6cdff$var$load("1F7LX"),
    $7fed758f66b6cdff$var$load("hXbzh"),
    $7fed758f66b6cdff$var$load("6wr18"),
    $7fed758f66b6cdff$var$load("8makw"),
    $7fed758f66b6cdff$var$load("XNe8U"),
    $7fed758f66b6cdff$var$load("ffEVr"),
    $7fed758f66b6cdff$var$load("kHOMt"),
    $7fed758f66b6cdff$var$load("hhss7"),
    $7fed758f66b6cdff$var$load("Wowvf"),
    $7fed758f66b6cdff$var$load("7EorR"),
    $7fed758f66b6cdff$var$load("7ixUU")
]).then(()=>parcelRequire('jfuml'));

});

parcelRegister("655oj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9trs7 = parcelRequire("9trs7");


var $eIleF = parcelRequire("eIleF");


var $gmi3X = parcelRequire("gmi3X");


var $1Okf1 = parcelRequire("1Okf1");

const $b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE = 50;
const $b1fdc4e801245f01$export$f82fcd766a8daa7f = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$40b1dd31340bd5c2 = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$15cd58682efec5a5 = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$5e074c0b68e2ce03 = 20;
const $b1fdc4e801245f01$export$7d812bb756889442 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(13);
    const { connections: t0 } = (0, $eIleF.useSmartLinkContext)();
    const { client: client } = t0;
    const resolverUrl = (0, $1Okf1.useResolverUrl)(client);
    const cachedRequest = $b1fdc4e801245f01$var$_temp;
    const uncachedRequest = $b1fdc4e801245f01$var$_temp2;
    let t1;
    if ($[0] !== resolverUrl) {
        t1 = async (datasourceId, data_1, t2)=>{
            const force_0 = t2 === undefined ? false : t2;
            return cachedRequest(datasourceId, data_1, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $b1fdc4e801245f01$export$f82fcd766a8daa7f, force_0);
        };
        $[0] = resolverUrl;
        $[1] = t1;
    } else t1 = $[1];
    const getDatasourceDetails = t1;
    let t2;
    if ($[2] !== resolverUrl) {
        t2 = async (datasourceId_0, data_2, t3)=>{
            const force_1 = t3 === undefined ? false : t3;
            return cachedRequest(datasourceId_0, data_2, `${resolverUrl}/datasource/${datasourceId_0}/fetch/data`, $b1fdc4e801245f01$export$40b1dd31340bd5c2, force_1);
        };
        $[2] = resolverUrl;
        $[3] = t2;
    } else t2 = $[3];
    const getDatasourceData = t2;
    let t3;
    if ($[4] !== resolverUrl) {
        t3 = async (data_3, t4)=>{
            const force_2 = t4 === undefined ? false : t4;
            const resolvedCacheIdKey = "datasourceId" in data_3 ? data_3.datasourceId : data_3.integrationKey;
            if (!resolvedCacheIdKey) throw new Error("No target was supplied to retrieve actions for");
            return cachedRequest(resolvedCacheIdKey, data_3, `${resolverUrl}/actions`, $b1fdc4e801245f01$export$15cd58682efec5a5, force_2);
        };
        $[4] = resolverUrl;
        $[5] = t3;
    } else t3 = $[5];
    const getDatasourceActionsAndPermissions = t3;
    let t4;
    if ($[6] !== resolverUrl) {
        t4 = async (data_4)=>uncachedRequest(data_4, `${resolverUrl}/actions/execute`);
        $[6] = resolverUrl;
        $[7] = t4;
    } else t4 = $[7];
    const executeAtomicAction = t4;
    const invalidateDatasourceDataCacheByAri = $b1fdc4e801245f01$var$_temp3;
    let t5;
    if ($[8] !== executeAtomicAction || $[9] !== getDatasourceActionsAndPermissions || $[10] !== getDatasourceData || $[11] !== getDatasourceDetails) {
        t5 = {
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        };
        $[8] = executeAtomicAction;
        $[9] = getDatasourceActionsAndPermissions;
        $[10] = getDatasourceData;
        $[11] = getDatasourceDetails;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ()=>{
    const { connections: { client: client } } = (0, $eIleF.useSmartLinkContext)();
    const resolverUrl = (0, $1Okf1.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
       * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
       * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
       */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $gmi3X.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data_0, url_0)=>{
        const responsePromise_0 = (0, $gmi3X.request)('post', url_0, data_0, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise_0;
    };
    const getDatasourceDetails = (0, $42omo.useCallback)(async (datasourceId, data_1, force_0 = false)=>cachedRequest(datasourceId, data_1, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $b1fdc4e801245f01$export$f82fcd766a8daa7f, force_0), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $42omo.useCallback)(async (datasourceId_0, data_2, force_1 = false)=>cachedRequest(datasourceId_0, data_2, `${resolverUrl}/datasource/${datasourceId_0}/fetch/data`, $b1fdc4e801245f01$export$40b1dd31340bd5c2, force_1), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $42omo.useCallback)(async (data_3, force_2 = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data_3 ? data_3.datasourceId : data_3.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data_3, `${resolverUrl}/actions`, $b1fdc4e801245f01$export$15cd58682efec5a5, force_2);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $42omo.useCallback)(async (data_4)=>uncachedRequest(data_4, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $42omo.useCallback)((ari)=>{
        $b1fdc4e801245f01$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $b1fdc4e801245f01$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $42omo.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};
async function $b1fdc4e801245f01$var$_temp(cacheKeyId, data, url, lruMap, force) {
    const cacheKeyData = {
        ...data,
        ..."fields" in data ? {
            fields: [
                ...data.fields || []
            ].sort()
        } : {},
        ..."fieldKeys" in data ? {
            fieldKeys: [
                ...data.fieldKeys || []
            ].sort()
        } : {}
    };
    const cacheKey = JSON.stringify({
        cacheKeyId: cacheKeyId,
        cacheKeyData: cacheKeyData
    });
    if (force) lruMap.delete(cacheKey);
    let responsePromise = lruMap.get(cacheKey);
    if (responsePromise) return responsePromise;
    const headers = {
        "origin-timezone": Intl?.DateTimeFormat().resolvedOptions().timeZone
    };
    try {
        responsePromise = (0, $gmi3X.request)("post", url, data, headers, [
            200,
            201,
            202,
            203,
            204
        ]);
        lruMap.set(cacheKey, responsePromise);
        return await responsePromise;
    } catch (t0) {
        const e = t0;
        lruMap.delete(cacheKey);
        throw e;
    }
}
async function $b1fdc4e801245f01$var$_temp2(data_0, url_0) {
    const responsePromise_0 = (0, $gmi3X.request)("post", url_0, data_0, undefined, [
        200,
        201,
        202,
        203,
        204
    ]);
    return responsePromise_0;
}
function $b1fdc4e801245f01$var$_temp3(ari) {
    $b1fdc4e801245f01$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
        const response = await value;
        const targetFound = response.data.items.some((item)=>item.ari?.data === ari);
        if (targetFound) $b1fdc4e801245f01$export$40b1dd31340bd5c2.delete(key);
    });
}
module.exports["DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE"] = $b1fdc4e801245f01$export$5e074c0b68e2ce03;
module.exports["useDatasourceClientExtension"] = $b1fdc4e801245f01$export$7d812bb756889442;

});

parcelRegister("4Z0ju", function(module, exports) {
const $706ca8480df97452$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};
module.exports["buildDatasourceAdf"] = $706ca8480df97452$export$1de3504963fc32f2;

});

parcelRegister("2WHHL", function(module, exports) {
const $4de09c96514ff692$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $4de09c96514ff692$var$uniqueKey = Symbol('closestEdge');
function $4de09c96514ff692$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $4de09c96514ff692$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$4de09c96514ff692$var$uniqueKey]: addClosestEdge
    };
}
function $4de09c96514ff692$export$945a571f3b658bf(userData) {
    return userData[$4de09c96514ff692$var$uniqueKey] ?? null;
}
module.exports["attachClosestEdge"] = $4de09c96514ff692$export$f0cafff222395e89;
module.exports["extractClosestEdge"] = $4de09c96514ff692$export$945a571f3b658bf;

});

parcelRegister("5X6QO", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");


});

parcelRegister("eOL5r", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $20c6df176d77bef6$export$c588cb30ff3b876e;

});

parcelRegister("gZctg", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");


});

parcelRegister("ihBqS", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $cmcCB = parcelRequire("cmcCB");

function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};
module.exports["preventUnhandled"] = $713d889559578e2f$export$453c0582481cc59d;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("3wgAM", function(module, exports) {

var $2LrJx = parcelRequire("2LrJx");


var $5Nw7l = parcelRequire("5Nw7l");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $29013b23581f9040$var$pick = $5Nw7l(function(object, paths) {
    return object == null ? {} : $2LrJx(object, paths);
});
module.exports = $29013b23581f9040$var$pick;

});

parcelRegister("2LrJx", function(module, exports) {

var $egNUN = parcelRequire("egNUN");


var $7U49l = parcelRequire("7U49l");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $20357bdd9d2fadfb$var$basePick(object, paths) {
    return $egNUN(object, paths, function(value, path) {
        return $7U49l(object, path);
    });
}
module.exports = $20357bdd9d2fadfb$var$basePick;

});

parcelRegister("7HI7Y", function(module, exports) {
$parcel$export(module.exports, "merge", () => $59bec75d4837f566$export$4950aa0f605343fb, (v) => $59bec75d4837f566$export$4950aa0f605343fb = v);
var $59bec75d4837f566$export$4950aa0f605343fb;
"use strict";

var $YgydF = parcelRequire("YgydF");


var $HHFyQ = parcelRequire("HHFyQ");


var $5Dgek = parcelRequire("5Dgek");


var $kQ0lo = parcelRequire("kQ0lo");

/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $59bec75d4837f566$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($5Dgek.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $YgydF.Observable) return observables[0];
    return $kQ0lo.mergeAll(concurrent)(new $HHFyQ.ArrayObservable(observables, scheduler));
}
$59bec75d4837f566$export$4950aa0f605343fb = $59bec75d4837f566$var$merge;

});

parcelRegister("kQ0lo", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $f2b8ee495d9150ab$export$18aef43295bbe906, (v) => $f2b8ee495d9150ab$export$18aef43295bbe906 = v);
var $f2b8ee495d9150ab$export$18aef43295bbe906;
"use strict";

var $XrDsM = parcelRequire("XrDsM");


var $hsCka = parcelRequire("hsCka");

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $f2b8ee495d9150ab$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $XrDsM.mergeMap($hsCka.identity, null, concurrent);
}
$f2b8ee495d9150ab$export$18aef43295bbe906 = $f2b8ee495d9150ab$var$mergeAll;

});

parcelRegister("hsCka", function(module, exports) {
$parcel$export(module.exports, "identity", () => $cb62c79807c8a85d$export$f0954fd7d5368655, (v) => $cb62c79807c8a85d$export$f0954fd7d5368655 = v);
var $cb62c79807c8a85d$export$f0954fd7d5368655;
"use strict";
function $cb62c79807c8a85d$var$identity(x) {
    return x;
}
$cb62c79807c8a85d$export$f0954fd7d5368655 = $cb62c79807c8a85d$var$identity;

});

parcelRegister("eVpDl", function(module, exports) {
"use strict";
var $adda45daebf3b6ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $adda45daebf3b6ff$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $adda45daebf3b6ff$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $adda45daebf3b6ff$var$filter;
var $adda45daebf3b6ff$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $adda45daebf3b6ff$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $adda45daebf3b6ff$var$FilterSubscriber = function(_super) {
    $adda45daebf3b6ff$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($axeml.Subscriber);

});

parcelRegister("kXEyd", function(module, exports) {
"use strict";
var $f428c5e2ee2b390f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $f428c5e2ee2b390f$var$take(count) {
    return function(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $f428c5e2ee2b390f$var$TakeOperator(count));
    };
}
module.exports.take = $f428c5e2ee2b390f$var$take;
var $f428c5e2ee2b390f$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f428c5e2ee2b390f$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f428c5e2ee2b390f$var$TakeSubscriber = function(_super) {
    $f428c5e2ee2b390f$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($axeml.Subscriber);

});

parcelRegister("2g0GA", function(module, exports) {
"use strict";
var $1a4d9b96869ee1a1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError = function(_super) {
    $1a4d9b96869ee1a1$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError;

});

parcelRegister("1Ria2", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $15a8d410ba774044$export$45b10814cc054894, (v) => $15a8d410ba774044$export$45b10814cc054894 = v);
var $15a8d410ba774044$export$45b10814cc054894;
"use strict";

var $244gB = parcelRequire("244gB");

function $15a8d410ba774044$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $15a8d410ba774044$var$toArray() {
    return $244gB.reduce($15a8d410ba774044$var$toArrayReducer, []);
}
$15a8d410ba774044$export$45b10814cc054894 = $15a8d410ba774044$var$toArray;

});

parcelRegister("244gB", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $180f43c63924c6e6$export$533b26079ad0b4b, (v) => $180f43c63924c6e6$export$533b26079ad0b4b = v);
var $180f43c63924c6e6$export$533b26079ad0b4b;
"use strict";

var $kiSup = parcelRequire("kiSup");


var $ib5HR = parcelRequire("ib5HR");


var $avZwt = parcelRequire("avZwt");


var $5wWzN = parcelRequire("5wWzN");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $180f43c63924c6e6$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $5wWzN.pipe($kiSup.scan(accumulator, seed), $ib5HR.takeLast(1), $avZwt.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $5wWzN.pipe($kiSup.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $ib5HR.takeLast(1))(source);
    };
}
$180f43c63924c6e6$export$533b26079ad0b4b = $180f43c63924c6e6$var$reduce;

});

parcelRegister("kiSup", function(module, exports) {
"use strict";
var $ec7fc18d41270381$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $ec7fc18d41270381$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $ec7fc18d41270381$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $ec7fc18d41270381$var$scan;
var $ec7fc18d41270381$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ec7fc18d41270381$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ec7fc18d41270381$var$ScanSubscriber = function(_super) {
    $ec7fc18d41270381$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ib5HR", function(module, exports) {
"use strict";
var $d3bdae4589ae3cf1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $d3bdae4589ae3cf1$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $d3bdae4589ae3cf1$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $d3bdae4589ae3cf1$var$takeLast;
var $d3bdae4589ae3cf1$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d3bdae4589ae3cf1$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d3bdae4589ae3cf1$var$TakeLastSubscriber = function(_super) {
    $d3bdae4589ae3cf1$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($axeml.Subscriber);

});

parcelRegister("avZwt", function(module, exports) {
"use strict";
var $7a7c85c9732247d4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $7a7c85c9732247d4$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $7a7c85c9732247d4$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $7a7c85c9732247d4$var$defaultIfEmpty;
var $7a7c85c9732247d4$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7a7c85c9732247d4$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7a7c85c9732247d4$var$DefaultIfEmptySubscriber = function(_super) {
    $7a7c85c9732247d4$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($axeml.Subscriber);

});

parcelRegister("hu8We", function(module, exports) {
$parcel$export(module.exports, "of", () => $cbac2bf0af029aab$export$ba255e9e49e00608, (v) => $cbac2bf0af029aab$export$ba255e9e49e00608 = v);
var $cbac2bf0af029aab$export$ba255e9e49e00608;
"use strict";

var $HHFyQ = parcelRequire("HHFyQ");

$cbac2bf0af029aab$export$ba255e9e49e00608 = $HHFyQ.ArrayObservable.of;

});

parcelRegister("fulrs", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6j5QO = parcelRequire("6j5QO");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteDelay = $kVeeY.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($6j5QO.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($6j5QO.Notification.createComplete());
    };
    return DelaySubscriber;
}($axeml.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});

parcelRegister("3u6GG", function(module, exports) {
$parcel$export(module.exports, "async", () => $28995c6d2039be6b$export$12af436354f1a4f7, (v) => $28995c6d2039be6b$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $28995c6d2039be6b$export$12af436354f1a4f7;
"use strict";

var $k8JsH = parcelRequire("k8JsH");


var $iOeLv = parcelRequire("iOeLv");

$28995c6d2039be6b$export$12af436354f1a4f7 = new $iOeLv.AsyncScheduler($k8JsH.AsyncAction);

});

parcelRegister("kVeeY", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $f3b42d67f4ad5339$export$871608497c498473, (v) => $f3b42d67f4ad5339$export$871608497c498473 = v);
var $f3b42d67f4ad5339$export$871608497c498473;
"use strict";
function $f3b42d67f4ad5339$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$f3b42d67f4ad5339$export$871608497c498473 = $f3b42d67f4ad5339$var$isDate;

});

parcelRegister("5TGLQ", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $aw01o = parcelRequire("aw01o");


var $a6FC8 = parcelRequire("a6FC8");

const $0aa0cd7558ee373c$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $aw01o.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $0aa0cd7558ee373c$export$ea56ca58f08ffa52;

});

parcelRegister("gL6du", function(module, exports) {
const $21e9301be8cff986$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $21e9301be8cff986$export$dca0327c9b9c6498;

});

parcelRegister("aw01o", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $3nGJd = parcelRequire("3nGJd");


var $4eigd = parcelRequire("4eigd");


var $2iEso = parcelRequire("2iEso");

const $734802129a3b7f4d$var$INVALID_DATE = new Date(NaN);
const $734802129a3b7f4d$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $734802129a3b7f4d$var$INVARIANT_DATE = (0, $2iEso.toDate)($734802129a3b7f4d$var$INVARIANT);
const $734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $734802129a3b7f4d$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $734802129a3b7f4d$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $734802129a3b7f4d$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $734802129a3b7f4d$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($734802129a3b7f4d$var$INVARIANT_DATE);
    const shortDate = $734802129a3b7f4d$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $734802129a3b7f4d$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $734802129a3b7f4d$var$stripExtras(date).match($734802129a3b7f4d$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $734802129a3b7f4d$var$INVALID_DATE;
        const dateParts = $734802129a3b7f4d$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $4eigd.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3nGJd.isValid)(normalizedDate)) return $734802129a3b7f4d$var$INVALID_DATE;
        return (0, $2iEso.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $734802129a3b7f4d$export$cfa2ef2687faeda2;

});

parcelRegister("3nGJd", function(module, exports) {

var $7sNuF = parcelRequire("7sNuF");

const $7f0fa5875d6e9a42$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $7sNuF.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $7f0fa5875d6e9a42$export$1ea939691cdc45b8;

});

parcelRegister("7sNuF", function(module, exports) {

var $1RvqY = parcelRequire("1RvqY");

const $320ec45740b0ee24$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $1RvqY.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $320ec45740b0ee24$export$f645ddd439eb259d;

});

parcelRegister("1RvqY", function(module, exports) {
const $323f2e4da88832b7$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $323f2e4da88832b7$export$553d7fa8e3805fc0;

});

parcelRegister("4eigd", function(module, exports) {

var $aKKC5 = parcelRequire("aKKC5");

const $927e6bf7203913f7$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $aKKC5.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $927e6bf7203913f7$export$fcc71269590ba0a8;

});

parcelRegister("aKKC5", function(module, exports) {
const $00e4455f9b4cd7ae$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $00e4455f9b4cd7ae$export$abe96da78d4f59dd;

});

parcelRegister("2iEso", function(module, exports) {
const $f36e5bfee980e3d5$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $f36e5bfee980e3d5$export$e67a095c620b86fe;

});

parcelRegister("a6FC8", function(module, exports) {
const $5e4f9944cbc7c90e$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $5e4f9944cbc7c90e$export$9b7ca29af37c192;

});

parcelRegister("1BiXn", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $dh538 = parcelRequire("dh538");


var $9s7Po = parcelRequire("9s7Po");


var $hnvzE = parcelRequire("hnvzE");

const $2f66d7816a46cebf$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
const $2f66d7816a46cebf$var$CardLoadingWithContext = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const props = (0, $42omo.useContext)($2f66d7816a46cebf$var$MediaCardContext);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9s7Po.CardLoading), {
            ...props,
            interactionName: "media-card-async-loading"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const props = (0, $42omo.useContext)($2f66d7816a46cebf$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9s7Po.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $2f66d7816a46cebf$var$loadCardWithMediaClient() {
    return (parcelRequire("8eu3e"));
}
const $2f66d7816a46cebf$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "a0IPb",
    name: "MediaCardWithMediaClientLoadable",
    loader: ()=>$2f66d7816a46cebf$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$CardLoadingWithContext, null)
});
const $2f66d7816a46cebf$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>$2f66d7816a46cebf$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $2f66d7816a46cebf$var$CardLoader = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $dh538.fg)("platform_media_react19_support") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$CardLoadingWithContext, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardWithMediaClientLoadable, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "media-card",
            mode: "list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardContext.Provider, {
            value: props
        }, t0));
        $[2] = props;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardContext.Provider, {
        value: props
    }, (0, $dh538.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardWithMediaClientLoadable, props)));
};
$2f66d7816a46cebf$var$CardLoader.preload = ()=>{
    if ((0, $dh538.fg)('platform_media_react19_support')) $2f66d7816a46cebf$var$loadCardWithMediaClient().then(()=>{});
    else $2f66d7816a46cebf$var$MediaCardWithMediaClientLoadable.preload?.();
};
var $2f66d7816a46cebf$export$2e2bcd8739ae039 = $2f66d7816a46cebf$var$CardLoader;
module.exports["default"] = $2f66d7816a46cebf$export$2e2bcd8739ae039;

});

parcelRegister("9s7Po", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $1oCLl = parcelRequire("1oCLl");


var $gez7V = parcelRequire("gez7V");


var $fDGbV = parcelRequire("fDGbV");


var $64ehG = parcelRequire("64ehG");

const $bf3fa0f5391f39b8$export$5d25853fd6bdf402 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== dimensionsProp) {
        t1 = (0, $fDGbV.getDimensionsWithDefault)(dimensionsProp);
        $[0] = dimensionsProp;
        $[1] = t1;
    } else t1 = $[1];
    const dimensions = t1;
    const t2 = testId || "media-card-loading";
    let t3;
    if ($[2] !== interactionName) {
        t3 = (0, $1oCLl.expValEquals)("cc-maui-ai-edit-loading-experiment", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gez7V.LoadingBar), {
            interactionName: interactionName || "media-card-loading"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            interactionName: interactionName || "media-card-loading"
        });
        $[2] = interactionName;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== dimensions || $[5] !== t2 || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64ehG.Wrapper), {
            "data-testid": t2,
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading"
        }, t3);
        $[4] = dimensions;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ dimensions: dimensionsProp, testId: testId, interactionName: interactionName })=>{
    const dimensions = (0, $fDGbV.getDimensionsWithDefault)(dimensionsProp);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64ehG.Wrapper), {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions,
        "data-vc": "media-card-loading"
    }, (0, $1oCLl.expValEquals)('cc-maui-ai-edit-loading-experiment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gez7V.LoadingBar), {
        interactionName: interactionName || 'media-card-loading'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: interactionName || 'media-card-loading'
    }));
};
module.exports["CardLoading"] = $bf3fa0f5391f39b8$export$5d25853fd6bdf402;

});

parcelRegister("gez7V", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $90YwQ = parcelRequire("90YwQ");

const $03e6b4efe224efe1$var$TICK_INTERVAL_MS = 1000;
const $03e6b4efe224efe1$var$STATIC_PROGRESS_VALUE = 0.9; /**
                                    * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                    * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                    * which makes things simpler than doing an `isServer` check or a `null` check.
                                    *
                                    * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                    */ 
const $03e6b4efe224efe1$var$useLayoutEffect = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
const $03e6b4efe224efe1$var$messages = (0, $aXWIB.defineMessages)({
    loadingBarLabel: {
        id: "fabric.media.loading_bar_label",
        defaultMessage: "Loading"
    }
});
const $03e6b4efe224efe1$var$trackStyles = null;
const $03e6b4efe224efe1$var$fillStyles = null;
const $03e6b4efe224efe1$var$clampToPercent = (progress)=>Math.min(1, Math.max(0, progress)) * 100;
const $03e6b4efe224efe1$export$6665614bc5d690f6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { animationDisabled: t1, testId: testId, interactionName: interactionName } = t0;
    const animationDisabled = t1 === undefined ? false : t1;
    const intl = (0, $aXWIB.useIntl)();
    const [progress, setProgress] = (0, $42omo.useState)(animationDisabled ? $03e6b4efe224efe1$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $42omo.useRef)();
    const interactionContext = (0, $42omo.useContext)((0, $90YwQ.default));
    let t2;
    let t3;
    if ($[0] !== interactionContext || $[1] !== interactionName) {
        t2 = ()=>{
            if (interactionContext != null) return interactionContext.hold(interactionName);
        };
        t3 = [
            interactionContext,
            interactionName
        ];
        $[0] = interactionContext;
        $[1] = interactionName;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    $03e6b4efe224efe1$var$useLayoutEffect(t2, t3);
    let t4;
    let t5;
    if ($[4] !== animationDisabled) {
        t4 = ()=>{
            if (animationDisabled) {
                setProgress($03e6b4efe224efe1$var$STATIC_PROGRESS_VALUE);
                return;
            }
            intervalRef.current = setInterval(()=>{
                setProgress((prev)=>{
                    if (prev < 0.1) return prev + 0.1;
                    else {
                        if (prev < 0.6) return prev + 0.35;
                        else {
                            if (prev < 0.9) return prev + 0.1;
                        }
                    }
                    clearInterval(intervalRef.current);
                    return prev;
                });
            }, $03e6b4efe224efe1$var$TICK_INTERVAL_MS);
            return ()=>clearInterval(intervalRef.current);
        };
        t5 = [
            animationDisabled
        ];
        $[4] = animationDisabled;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[7] !== intl) {
        t6 = intl.formatMessage($03e6b4efe224efe1$var$messages.loadingBarLabel);
        $[7] = intl;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1rr0 _kqswstnw _94n5u2gc _1bsb1lk2 _1ltv1ghs _4t3ii2wt _bfhki8nm"
        ]);
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== progress) {
        t8 = $03e6b4efe224efe1$var$clampToPercent(progress);
        $[10] = progress;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = `${t8}%`;
    let t10;
    if ($[12] !== t9) {
        t10 = {
            width: t9
        };
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $gMc0m.default)([
            "_2rko1rr0 _v564aq9m _1e0c1ule _4t3i1osq _bfhk10ef"
        ]);
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t10) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: t10,
            className: t11
        });
        $[15] = t10;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== progress || $[18] !== t12 || $[19] !== t6 || $[20] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            role: "progressbar",
            "aria-valuenow": progress,
            "aria-label": t6,
            "data-testid": testId,
            className: t7
        }, t12);
        $[17] = progress;
        $[18] = t12;
        $[19] = t6;
        $[20] = testId;
        $[21] = t13;
    } else t13 = $[21];
    return t13;
} : ({ animationDisabled: animationDisabled = false, testId: testId, interactionName: interactionName })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [progress, setProgress] = (0, $42omo.useState)(animationDisabled ? $03e6b4efe224efe1$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $42omo.useRef)();
    const interactionContext = (0, $42omo.useContext)((0, $90YwQ.default));
    $03e6b4efe224efe1$var$useLayoutEffect(()=>{
        if (interactionContext != null) return interactionContext.hold(interactionName);
    }, [
        interactionContext,
        interactionName
    ]);
    (0, $42omo.useEffect)(()=>{
        if (animationDisabled) {
            setProgress($03e6b4efe224efe1$var$STATIC_PROGRESS_VALUE);
            return;
        }
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 0.1) return prev + 0.1;
                else if (prev < 0.6) return prev + 0.35;
                else if (prev < 0.9) return prev + 0.1;
                clearInterval(intervalRef.current);
                return prev;
            });
        }, $03e6b4efe224efe1$var$TICK_INTERVAL_MS);
        return ()=>clearInterval(intervalRef.current);
    }, [
        animationDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": intl.formatMessage($03e6b4efe224efe1$var$messages.loadingBarLabel),
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1rr0 _kqswstnw _94n5u2gc _1bsb1lk2 _1ltv1ghs _4t3ii2wt _bfhki8nm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            width: `${$03e6b4efe224efe1$var$clampToPercent(progress)}%`
        },
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564aq9m _1e0c1ule _4t3i1osq _bfhk10ef"
        ])
    }));
};
module.exports["LoadingBar"] = $03e6b4efe224efe1$export$6665614bc5d690f6;

});

parcelRegister("64ehG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $1CyYH = parcelRequire("1CyYH");

const $fd9c20c94dd40490$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $1CyYH.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};
module.exports["Wrapper"] = $fd9c20c94dd40490$export$e6dfd72ab29f8598;

});

parcelRegister("1CyYH", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $fN2NR = parcelRequire("fN2NR");

const $aedc46c8c12477c6$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.center), "position:relative;background:var(--ds-surface-sunken, #F8F8F8);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });
module.exports["wrapperStyles"] = $aedc46c8c12477c6$export$491e6397d7c1480b;

});

parcelRegister("fN2NR", function(module, exports) {
const $adbace133e9e6202$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $adbace133e9e6202$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $adbace133e9e6202$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $adbace133e9e6202$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $adbace133e9e6202$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $adbace133e9e6202$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $adbace133e9e6202$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
module.exports["size"] = $adbace133e9e6202$export$346677f925de839c;
module.exports["center"] = $adbace133e9e6202$export$3481c78889e8fbe8;
module.exports["borderRadius"] = $adbace133e9e6202$export$7a57f79000377ca2;

});

parcelRegister("8eu3e", function(module, exports) {

let $5fe6f10fc4c774d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5fe6f10fc4c774d2$var$load("esOWw"),
    $5fe6f10fc4c774d2$var$load("coUzl"),
    $5fe6f10fc4c774d2$var$load("5nMTY"),
    $5fe6f10fc4c774d2$var$load("hXbzh"),
    $5fe6f10fc4c774d2$var$load("f35QR"),
    $5fe6f10fc4c774d2$var$load("eVYW1"),
    $5fe6f10fc4c774d2$var$load("ls0Um"),
    $5fe6f10fc4c774d2$var$load("020xd"),
    $5fe6f10fc4c774d2$var$load("eTBsW"),
    $5fe6f10fc4c774d2$var$load("bYxCZ"),
    $5fe6f10fc4c774d2$var$load("6HBYC"),
    $5fe6f10fc4c774d2$var$load("eDqo1"),
    $5fe6f10fc4c774d2$var$load("lxiFd"),
    $5fe6f10fc4c774d2$var$load("1oiJ6"),
    $5fe6f10fc4c774d2$var$load("huUvS"),
    $5fe6f10fc4c774d2$var$load("6wr18"),
    $5fe6f10fc4c774d2$var$load("fsikk"),
    $5fe6f10fc4c774d2$var$load("8j9XC"),
    $5fe6f10fc4c774d2$var$load("fisfU"),
    $5fe6f10fc4c774d2$var$load("7EorR"),
    $5fe6f10fc4c774d2$var$load("6vhrJ"),
    $5fe6f10fc4c774d2$var$load("fxC6e"),
    $5fe6f10fc4c774d2$var$load("kknf5"),
    $5fe6f10fc4c774d2$var$load("hPalR"),
    $5fe6f10fc4c774d2$var$load("jDjSj"),
    $5fe6f10fc4c774d2$var$load("8059b"),
    $5fe6f10fc4c774d2$var$load("3QZdB"),
    $5fe6f10fc4c774d2$var$load("3M4Om"),
    $5fe6f10fc4c774d2$var$load("4jPsO"),
    $5fe6f10fc4c774d2$var$load("72780"),
    $5fe6f10fc4c774d2$var$load("hszIA"),
    $5fe6f10fc4c774d2$var$load("ajMch"),
    $5fe6f10fc4c774d2$var$load("2fk6g"),
    $5fe6f10fc4c774d2$var$load("ffEVr"),
    $5fe6f10fc4c774d2$var$load("fwuXj")
]).then(()=>parcelRequire('r0CCR'));

});

parcelRegister("9k33u", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $grxv4.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("3BZZG", function(module, exports) {
const $b77837f445efd10f$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $b77837f445efd10f$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $b77837f445efd10f$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $b77837f445efd10f$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $b77837f445efd10f$export$d87a47989c00f322;
    if (appearance === 'square') return $b77837f445efd10f$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $b77837f445efd10f$export$aeb48196afcd236a;
    return $b77837f445efd10f$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $b77837f445efd10f$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $b77837f445efd10f$export$ed7b8a4728e9c63;

});

parcelRegister("e63NX", function(module, exports) {

var $hL7bb = parcelRequire("hL7bb");

const $aeded572d33c89ca$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
const $aeded572d33c89ca$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
const $aeded572d33c89ca$export$5883721593c4e4b1 = (a, b)=>{
    if ($aeded572d33c89ca$export$7695387cd66cf5b5(a) && $aeded572d33c89ca$export$7695387cd66cf5b5(b)) return a.id !== b.id || a.collectionName !== b.collectionName || a.occurrenceKey !== b.occurrenceKey;
    else return !(0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))(a, b);
};
module.exports["isFileIdentifier"] = $aeded572d33c89ca$export$7695387cd66cf5b5;
module.exports["isExternalImageIdentifier"] = $aeded572d33c89ca$export$2782f2fbff82f0c9;

});

parcelRegister("hL7bb", function(module, exports) {
var $cedc651d64f014e0$var$pSlice = Array.prototype.slice;

var $gFqzn = parcelRequire("gFqzn");


var $2EuUq = parcelRequire("2EuUq");

var $cedc651d64f014e0$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $cedc651d64f014e0$var$objEquiv(actual, expected, opts);
};
function $cedc651d64f014e0$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $cedc651d64f014e0$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $cedc651d64f014e0$var$objEquiv(a, b, opts) {
    var i, key;
    if ($cedc651d64f014e0$var$isUndefinedOrNull(a) || $cedc651d64f014e0$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($2EuUq(a)) {
        if (!$2EuUq(b)) return false;
        a = $cedc651d64f014e0$var$pSlice.call(a);
        b = $cedc651d64f014e0$var$pSlice.call(b);
        return $cedc651d64f014e0$var$deepEqual(a, b, opts);
    }
    if ($cedc651d64f014e0$var$isBuffer(a)) {
        if (!$cedc651d64f014e0$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $gFqzn(a), kb = $gFqzn(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$cedc651d64f014e0$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});

parcelRegister("gFqzn", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("2EuUq", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});

parcelRegister("7NoXb", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fs5Wi = parcelRequire("fs5Wi");


var $1GQGM = parcelRequire("1GQGM");


const $a320422a745418e6$var$MediaViewer = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5Drrd")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
const $a320422a745418e6$var$AsyncMediaViewer = (0, $4pOgL.isReactCompilerActivePlatform)() ? function AsyncMediaViewer(props) {
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs5Wi.default), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GQGM.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a320422a745418e6$var$MediaViewer, props)));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function AsyncMediaViewer(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs5Wi.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GQGM.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a320422a745418e6$var$MediaViewer, props)));
};
var $a320422a745418e6$export$2e2bcd8739ae039 = $a320422a745418e6$var$AsyncMediaViewer;
module.exports["default"] = $a320422a745418e6$export$2e2bcd8739ae039;

});

parcelRegister("fs5Wi", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $70BxX = parcelRequire("70BxX");


var $cOrQJ = parcelRequire("cOrQJ");

const $379228055afe24f5$export$442b7be89436c101 = '#101214';
const $379228055afe24f5$var$ModalSpinner = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const t0 = colorMode !== "dark";
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70BxX.default), {
            blankedColor: $379228055afe24f5$export$442b7be89436c101,
            invertSpinnerColor: t0
        });
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70BxX.default), {
        blankedColor: $379228055afe24f5$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $379228055afe24f5$export$2e2bcd8739ae039 = $379228055afe24f5$var$ModalSpinner;
module.exports["default"] = $379228055afe24f5$export$2e2bcd8739ae039;

});

parcelRegister("70BxX", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9DX83 = parcelRequire("9DX83");

const $9f2ec0906c10b2d9$var$ModalSpinner = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9DX83.default), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9DX83.default), props);
var $9f2ec0906c10b2d9$export$2e2bcd8739ae039 = $9f2ec0906c10b2d9$var$ModalSpinner;
module.exports["default"] = $9f2ec0906c10b2d9$export$2e2bcd8739ae039;

});

parcelRegister("9DX83", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed42ad447c5e042f$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $ed42ad447c5e042f$var$blanketStyles = null;
const $ed42ad447c5e042f$var$spinnerStyles = null;
const $ed42ad447c5e042f$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $ed42ad447c5e042f$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $42omo.createElement("div", {
        style: {
            backgroundColor: blankedColor || $ed42ad447c5e042f$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "large",
        appearance: invertSpinnerColor || $ed42ad447c5e042f$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("1GQGM", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $caX7N = parcelRequire("caX7N");

const $86b842c4b2e17806$export$51aee4c01b17acde = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
            zIndex: 510
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: 510
    }, children);
module.exports["MediaViewerPortal"] = $86b842c4b2e17806$export$51aee4c01b17acde;

});

parcelRegister("5Drrd", function(module, exports) {

let $41a5e0db310d2418$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $41a5e0db310d2418$var$load("esOWw"),
    $41a5e0db310d2418$var$load("hXbzh"),
    $41a5e0db310d2418$var$load("f35QR"),
    $41a5e0db310d2418$var$load("eVYW1"),
    $41a5e0db310d2418$var$load("ls0Um"),
    $41a5e0db310d2418$var$load("020xd"),
    $41a5e0db310d2418$var$load("eTBsW"),
    $41a5e0db310d2418$var$load("bYxCZ"),
    $41a5e0db310d2418$var$load("6HBYC"),
    $41a5e0db310d2418$var$load("eDqo1"),
    $41a5e0db310d2418$var$load("lxiFd"),
    $41a5e0db310d2418$var$load("1oiJ6"),
    $41a5e0db310d2418$var$load("huUvS"),
    $41a5e0db310d2418$var$load("6wr18"),
    $41a5e0db310d2418$var$load("llcfA"),
    $41a5e0db310d2418$var$load("azCDs"),
    $41a5e0db310d2418$var$load("dT77m"),
    $41a5e0db310d2418$var$load("8j9XC"),
    $41a5e0db310d2418$var$load("ffEVr"),
    $41a5e0db310d2418$var$load("6vhrJ"),
    $41a5e0db310d2418$var$load("fxC6e"),
    $41a5e0db310d2418$var$load("kknf5"),
    $41a5e0db310d2418$var$load("hPalR"),
    $41a5e0db310d2418$var$load("jDjSj"),
    $41a5e0db310d2418$var$load("8059b"),
    $41a5e0db310d2418$var$load("3QZdB"),
    $41a5e0db310d2418$var$load("3M4Om"),
    $41a5e0db310d2418$var$load("4jPsO"),
    $41a5e0db310d2418$var$load("72780"),
    $41a5e0db310d2418$var$load("hszIA"),
    $41a5e0db310d2418$var$load("ajMch"),
    $41a5e0db310d2418$var$load("2fk6g"),
    $41a5e0db310d2418$var$load("hhss7"),
    $41a5e0db310d2418$var$load("cKkZK")
]).then(()=>parcelRequire('gamJO'));

});

parcelRegister("31QJ7", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $51c490bf07ac8c08$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    check_internet_connection: {
        id: "fabric.media.check_internet_connection",
        defaultMessage: "Failed to load. Please check your internet connection"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    archive_format_not_supported: {
        id: "fabric.media.archive_format_not_supported",
        defaultMessage: "Preview is not available for this file type."
    },
    unsupported_file_format: {
        id: "fabric.media.unsupported_file_format",
        defaultMessage: "Unsupported file format"
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    manage_captions: {
        id: "fabric.media.manage_captions",
        defaultMessage: "Manage Captions"
    },
    add_captions: {
        id: "fabric.media.add_captions",
        defaultMessage: "Add Captions"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    expand: {
        id: "fabric.media.expand",
        defaultMessage: "Expand"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    open_file_in_viewer_aria_label: {
        id: "fabric.media.open_file_in_viewer_aria_label",
        defaultMessage: "Open {name} in fullscreen"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    },
    image_placer_img_alt: {
        id: "media.media-avatar-picker.image-placer.image-alt",
        defaultMessage: "Image preview"
    },
    svg_base_alt: {
        id: "media.media-viewer.base-svg.alt",
        defaultMessage: "Svg Image"
    },
    archive_download_label_assistive_text: {
        id: "media.media-viewer.archive-sidebar.wrapper.label_assistive_text",
        defaultMessage: "Download Media"
    }
});
module.exports["messages"] = $51c490bf07ac8c08$export$defe85febe8b728c;

});

parcelRegister("jRNsq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("i2CQL", function(module, exports) {

var $g99e4 = parcelRequire("g99e4");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $g99e4.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("g99e4", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $bc14a4aa688fca7b$export$6ccbb43953eebf8);

var $9mu1x = parcelRequire("9mu1x");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $bc14a4aa688fca7b$import_meta = Object.assign(Object.create(null), {
    url: "file:///../platform/node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $bc14a4aa688fca7b$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = false;
const $bc14a4aa688fca7b$var$identity = (arg)=>arg;
function $bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector = $bc14a4aa688fca7b$var$identity, equalityFn) {
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$bc14a4aa688fca7b$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = true;
    }
    const slice = $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $bc14a4aa688fca7b$var$useDebugValue(slice);
    return slice;
}
const $bc14a4aa688fca7b$var$createImpl = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $9mu1x.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $bc14a4aa688fca7b$export$185802fd694ee1f5 = (createState)=>createState ? $bc14a4aa688fca7b$var$createImpl(createState) : $bc14a4aa688fca7b$var$createImpl;
var $bc14a4aa688fca7b$export$2e2bcd8739ae039 = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $bc14a4aa688fca7b$export$185802fd694ee1f5(createState);
};

});

parcelRegister("8QL6C", function(module, exports) {

var $6mxnm = parcelRequire("6mxnm");


var $hMBjV = parcelRequire("hMBjV");


var $78fzv = parcelRequire("78fzv");

const $586e61da7604bdbd$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $586e61da7604bdbd$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hMBjV.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $6mxnm.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $586e61da7604bdbd$export$836625761e76d373 = {
    mediaInline: false
};
function $586e61da7604bdbd$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $78fzv.getGenericFeatureFlag)(flagName, $586e61da7604bdbd$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $586e61da7604bdbd$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $586e61da7604bdbd$export$383e8f51978266d;

});

parcelRegister("6mxnm", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $6b97f3fad80b5910$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $6b97f3fad80b5910$export$2db74afa1ef496f1;

});

parcelRegister("hMBjV", function(module, exports) {
const $d17c6572fbd16cff$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $d17c6572fbd16cff$export$189fe120be7e73fc = ()=>$d17c6572fbd16cff$var$productKeys;
module.exports["getProductKeys"] = $d17c6572fbd16cff$export$189fe120be7e73fc;

});

parcelRegister("78fzv", function(module, exports) {

var $bcpPc = parcelRequire("bcpPc");

function $18475707c4faede4$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $bcpPc.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $18475707c4faede4$export$f2687d0de19e4973;

});

parcelRegister("bcpPc", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $6c56cea62b261d1c$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $6c56cea62b261d1c$export$d125817a2695dbc9;

});

parcelRegister("bSKDV", function(module, exports) {
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $d1a10455ac2f8edd$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $d1a10455ac2f8edd$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $d1a10455ac2f8edd$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #0B120E24)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #7D818A)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #292A2E)"
};
module.exports["hexToEditorBorderPaletteColor"] = $d1a10455ac2f8edd$export$bad3c41dd33cb4bc;

});

parcelRegister("55QXP", function(module, exports) {
var $59f4a16af392a89e$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $59f4a16af392a89e$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});
module.exports["RESOLVE_METHOD"] = $59f4a16af392a89e$export$ecd1fed429542b49;
module.exports["VIEW_METHOD"] = $59f4a16af392a89e$export$9cf3651d97128b9c;

});

parcelRegister("fGYGE", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1yB28 = parcelRequire("1yB28");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $7BTEV = parcelRequire("7BTEV");

const $4e0b21253fab8db4$var$baseStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small'
});
const $4e0b21253fab8db4$var$mediumBadgeStyles = (0, $ecnYn.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $4e0b21253fab8db4$export$d5da84b0136a0cc4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { status: t1, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = t0;
    const status = t1 === undefined ? "default" : t1;
    const intl = (0, $aXWIB.useIntl)();
    let t2;
    if ($[0] !== intl) {
        t2 = intl.formatMessage((0, $7BTEV.commentMessages).viewCommentsOnMedia);
        $[0] = intl;
        $[1] = t2;
    } else t2 = $[1];
    const title = t2;
    let t3;
    bb0: switch(status){
        case "active":
            t3 = "color.background.accent.yellow.subtlest.pressed";
            break bb0;
        case "entered":
            t3 = "color.background.accent.yellow.subtlest.hovered";
            break bb0;
        default:
            t3 = "color.background.accent.yellow.subtlest";
    }
    const colourToken = t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            $4e0b21253fab8db4$var$baseStyles,
            $4e0b21253fab8db4$var$mediumBadgeStyles
        ];
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: title,
            spacing: "spacious",
            color: "currentColor"
        });
        $[3] = title;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== colourToken || $[6] !== onClick || $[7] !== onMouseEnter || $[8] !== onMouseLeave || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: t4,
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken
        }, t5);
        $[5] = colourToken;
        $[6] = onClick;
        $[7] = onMouseEnter;
        $[8] = onMouseLeave;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t6 || $[12] !== title) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "top",
            content: title
        }, t6);
        $[11] = t6;
        $[12] = title;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $aXWIB.useIntl)();
    const title = intl.formatMessage((0, $7BTEV.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $42omo.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $4e0b21253fab8db4$var$baseStyles,
            $4e0b21253fab8db4$var$mediumBadgeStyles
        ],
        padding: "space.0",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        backgroundColor: colourToken
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
        label: title,
        spacing: "spacious",
        color: "currentColor"
    })));
};
module.exports["CommentBadgeNext"] = $4e0b21253fab8db4$export$d5da84b0136a0cc4;

});

parcelRegister("7BTEV", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $724c8781ca7eb4e2$export$4c0d145df60cfb04 = (0, $aXWIB.defineMessages)({
    addCommentOnMedia: {
        id: "fabric.editor.addCommentOnMedia",
        defaultMessage: "Add comment"
    },
    viewCommentsOnMedia: {
        id: "fabric.editor.viewCommentOnMedia",
        defaultMessage: "View comments"
    },
    viewAndAddCommentsOnMedia: {
        id: "fabric.editor.viewAndAddCommentsOnMedia",
        defaultMessage: "View and add comments"
    }
});
module.exports["commentMessages"] = $724c8781ca7eb4e2$export$4c0d145df60cfb04;

});

parcelRegister("4i54r", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eXmBZ = parcelRequire("eXmBZ");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $3gadb = parcelRequire("3gadb");


var $dztev = parcelRequire("dztev");

const $df07f356bbd706ec$var$baseStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $df07f356bbd706ec$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com'
];
const $df07f356bbd706ec$var$NO_EXTERNAL_BADGE_HOSTS_NEW = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com',
    'bitbucket.org'
];
const $df07f356bbd706ec$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    if ((0, $1oCLl.expValEquals)('platform_editor_media_external_badge_bbc_fix', 'isEnable', true)) return Boolean(hostname && $df07f356bbd706ec$var$NO_EXTERNAL_BADGE_HOSTS_NEW.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
    return Boolean(hostname && $df07f356bbd706ec$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $df07f356bbd706ec$export$66bf2ed7a5d4691f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { type: type, url: url } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $dztev.externalMediaMessages).externalMediaFile);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const message = t1;
    if (type !== "external" || $df07f356bbd706ec$export$babb68fb5c212c90(url)) return null;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "external-image-badge"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== message) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            label: message
        });
        $[3] = message;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== message || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            padding: "space.050",
            xcss: $df07f356bbd706ec$var$baseStyles,
            tabIndex: 0
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: message,
            position: "top"
        }, t3));
        $[5] = message;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ type: type, url: url })=>{
    const intl = (0, $aXWIB.useIntl)();
    const message = intl.formatMessage((0, $dztev.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $df07f356bbd706ec$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.050",
        xcss: $df07f356bbd706ec$var$baseStyles,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "external-image-badge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: message,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        label: message
    })));
};
module.exports["ExternalImageBadge"] = $df07f356bbd706ec$export$66bf2ed7a5d4691f;

});

parcelRegister("dztev", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c4b5cf4ce6d702b4$export$8e36294abfabe45e = (0, $aXWIB.defineMessages)({
    externalMediaFile: {
        id: "fabric.editor.externalMediaFile",
        defaultMessage: "External media file"
    }
});
module.exports["externalMediaMessages"] = $c4b5cf4ce6d702b4$export$8e36294abfabe45e;

});

parcelRegister("1xbL9", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $0b276d94054df1c8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $0b276d94054df1c8$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $0b276d94054df1c8$var$hackedZIndexStyles = (0, $ecnYn.xcss)({
    // @ts-ignore
    zIndex: '1'
});
const $0b276d94054df1c8$var$resizeOffsetStyles = (0, $ecnYn.xcss)({
    right: 'space.150'
});
const $0b276d94054df1c8$var$getBadgeVisible = (width, height)=>{
    return width && width < $0b276d94054df1c8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $0b276d94054df1c8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $0b276d94054df1c8$export$6a31fc38737d0e58 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    let { children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: t1 } = t0;
    const useMinimumZIndex = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== mediaHeight || $[1] !== mediaWidth) {
        t2 = $0b276d94054df1c8$var$getBadgeVisible(mediaWidth, mediaHeight);
        $[0] = mediaHeight;
        $[1] = mediaWidth;
        $[2] = t2;
    } else t2 = $[2];
    const [visible, setVisible] = (0, $42omo.useState)(t2);
    let t3;
    let t4;
    if ($[3] !== mediaElement) {
        t3 = ()=>{
            const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((entries)=>{
                const [entry] = entries;
                const { width: width, height: height } = entry.contentRect;
                setVisible($0b276d94054df1c8$var$getBadgeVisible(width, height));
            }));
            if (mediaElement) observer.observe(mediaElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            mediaElement
        ];
        $[3] = mediaElement;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    if (typeof children === "function") {
        let t5;
        if ($[6] !== children || $[7] !== visible) {
            t5 = children({
                visible: visible
            });
            $[6] = children;
            $[7] = visible;
            $[8] = t5;
        } else t5 = $[8];
        children = t5;
    }
    if (!(0, $dh538.fg)("media-perf-uplift-mutation-fix")) {
        if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) === 0) return null;
    }
    const t5 = useMinimumZIndex && $0b276d94054df1c8$var$hackedZIndexStyles;
    const t6 = extendedResizeOffset && $0b276d94054df1c8$var$resizeOffsetStyles;
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = [
            $0b276d94054df1c8$var$containerStyles,
            t5,
            t6
        ];
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== children || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "div",
            testId: "media-badges",
            "data-media-badges": "true",
            contentEditable: false,
            xcss: t7
        }, children);
        $[12] = children;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $42omo.useState)($0b276d94054df1c8$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $42omo.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($0b276d94054df1c8$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    // delete this block on cleanup of media-perf-uplift-mutation-fix
    if (!(0, $dh538.fg)('media-perf-uplift-mutation-fix')) {
        // becuase it is wrapped in a fragment, React.Children.count(children) will always be 1.
        // That makes this check a source of late mutations that we don't need.
        if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) === 0) return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $0b276d94054df1c8$var$containerStyles,
            useMinimumZIndex && $0b276d94054df1c8$var$hackedZIndexStyles,
            extendedResizeOffset && $0b276d94054df1c8$var$resizeOffsetStyles
        ]
    }, children);
};
module.exports["MediaBadges"] = $0b276d94054df1c8$export$6a31fc38737d0e58;

});

parcelRegister("46EIy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cewj5 = parcelRequire("cewj5");


var $6ZDLj = parcelRequire("6ZDLj");

const $340ce807e864e408$var$DURATION_MIN = 0.5;
const $340ce807e864e408$var$DURATION_MAX = 1.0;
const $340ce807e864e408$var$EXTRA_PADDING = 4;
const $340ce807e864e408$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $340ce807e864e408$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $340ce807e864e408$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $340ce807e864e408$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $340ce807e864e408$var$DURATION_MAX - $340ce807e864e408$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $340ce807e864e408$var$DURATION_MAX), $340ce807e864e408$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $340ce807e864e408$export$ba458cf715b18bd1);
        }
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $340ce807e864e408$var$EXTRA_PADDING) return newOffset - $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $340ce807e864e408$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, $340ce807e864e408$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($cewj5)))(this.handleMutation, 30, true));
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$340ce807e864e408$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $340ce807e864e408$var$mapReactChildToReactNode(child, index) {
    const key = $340ce807e864e408$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $340ce807e864e408$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $340ce807e864e408$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $340ce807e864e408$export$817db220b90d8024;

});

parcelRegister("cewj5", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $8e7fda51b7396b67$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$8e7fda51b7396b67$var$debounce.debounce = $8e7fda51b7396b67$var$debounce;
module.exports = $8e7fda51b7396b67$var$debounce;

});

parcelRegister("6ZDLj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bwcZT = parcelRequire("bwcZT");

const $15c7f4a4aa94e52b$export$924abd21043fc000 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowLeftWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowLeftWrapper), props);
const $15c7f4a4aa94e52b$export$a5ffe38c17bbc0a1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ShadowRight), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ShadowRight), props);
const $15c7f4a4aa94e52b$export$abf07652016c7e56 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowRightWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowRightWrapper), props);
const $15c7f4a4aa94e52b$export$b39b1b86b48b621f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.LeftArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.LeftArrow), props);
const $15c7f4a4aa94e52b$export$6208675820d4cc50 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.RightArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.RightArrow), props);
const $15c7f4a4aa94e52b$export$d37eb83491863cbb = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripViewWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripViewWrapper), props);
const $15c7f4a4aa94e52b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListWrapper), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripList), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripList), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$54cfc70c184c0713 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListItem), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListItem), props);
module.exports["LeftArrow"] = $15c7f4a4aa94e52b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $15c7f4a4aa94e52b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $15c7f4a4aa94e52b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $15c7f4a4aa94e52b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $15c7f4a4aa94e52b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $15c7f4a4aa94e52b$export$54cfc70c184c0713;

});

parcelRegister("bwcZT", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $bPdpL = parcelRequire("bPdpL");


var $5tOl1 = parcelRequire("5tOl1");


var $46EIy = parcelRequire("46EIy");


var $dh538 = parcelRequire("dh538");

const $1156f5d5007639c5$var$filmStripViewStyles = null;
const $1156f5d5007639c5$var$filmStripListWrapperStyles = null;
const $1156f5d5007639c5$var$filmStripListStyles = null;
const $1156f5d5007639c5$var$filmStripListItemStyles = null;
const $1156f5d5007639c5$var$arrowWrapperStyles = null;
const $1156f5d5007639c5$var$arrowLeftWrapperStyles = null;
const $1156f5d5007639c5$var$arrowRightWrapperStyles = null;
const $1156f5d5007639c5$var$shadowStyles = null;
const $1156f5d5007639c5$var$resetButtonStyle = null;
const $1156f5d5007639c5$var$shadowLeftStyles = null;
const $1156f5d5007639c5$var$shadowRightStyles = null;
const $1156f5d5007639c5$var$ShadowLeft = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1ltvidpf"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1ltvidpf"
        ])
    }, children);
const $1156f5d5007639c5$export$924abd21043fc000 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] !== children || $[1] !== onClick) {
        t1 = (0, $dh538.fg)("platform_media_a11y_suppression_fixes") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
            className: (0, $gMc0m.default)([
                "_kkk2n7od _1e0c1ule",
                "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
                "_1ltvu2gc _uhasv77o",
                "arrow"
            ]),
            onClick: (event)=>onClick && onClick(event)
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
                "_1ltvu2gc _uhasv77o",
                "arrow"
            ]),
            onClick: onClick
        }, children);
        $[0] = children;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, onClick: onClick })=>{
    return (0, $dh538.fg)('platform_media_a11y_suppression_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_kkk2n7od _1e0c1ule",
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
};
const $1156f5d5007639c5$export$a5ffe38c17bbc0a1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1xi2idpf"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1xi2idpf"
        ])
    }, children);
const $1156f5d5007639c5$export$abf07652016c7e56 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] !== children || $[1] !== onClick) {
        t1 = (0, $dh538.fg)("platform_media_a11y_suppression_fixes") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
            className: (0, $gMc0m.default)([
                "_kkk2n7od _1e0c1ule",
                "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
                "_1xi2u2gc _7wy9v77o",
                "arrow"
            ]),
            onClick: (event)=>onClick && onClick(event)
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
                "_1xi2u2gc _7wy9v77o",
                "arrow"
            ]),
            onClick: onClick
        }, children);
        $[0] = children;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, onClick: onClick })=>{
    return (0, $dh538.fg)('platform_media_a11y_suppression_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_kkk2n7od _1e0c1ule",
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
};
const $1156f5d5007639c5$export$b39b1b86b48b621f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
            color: "currentColor",
            spacing: "spacious",
            label: "left"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$924abd21043fc000, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $1156f5d5007639c5$export$6208675820d4cc50 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
            color: "currentColor",
            spacing: "spacious",
            label: "right"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$abf07652016c7e56, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $1156f5d5007639c5$export$d37eb83491863cbb = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_2rkofajl _kqswh2mm _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _1yqxkb7n _1ajs4jg8"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _kqswh2mm _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _1yqxkb7n _1ajs4jg8"
        ])
    }, children);
const $1156f5d5007639c5$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(9);
    const { children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId || $[3] !== onTouchEnd || $[4] !== onTouchMove || $[5] !== onTouchStart || $[6] !== onWheel || $[7] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: ref,
            onWheel: onWheel,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd,
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = onTouchEnd;
        $[4] = onTouchMove;
        $[5] = onTouchStart;
        $[6] = onWheel;
        $[7] = ref;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
        ])
    }, children));
const $1156f5d5007639c5$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, style: style } = t0;
    const t1 = ref;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== style || $[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
            ref: t1,
            style: style,
            className: t2
        }, children);
        $[1] = children;
        $[2] = style;
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ])
    }, children));
const $1156f5d5007639c5$export$54cfc70c184c0713 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children, index: index } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $46EIy.MediaFilmStripListItemSelector)
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== index) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
            className: t1,
            "data-testid": "media-filmstrip-list-item",
            key: index
        }, children);
        $[1] = children;
        $[2] = index;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $46EIy.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $1156f5d5007639c5$export$924abd21043fc000;
module.exports["ShadowRight"] = $1156f5d5007639c5$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $1156f5d5007639c5$export$abf07652016c7e56;
module.exports["LeftArrow"] = $1156f5d5007639c5$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $1156f5d5007639c5$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $1156f5d5007639c5$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $1156f5d5007639c5$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $1156f5d5007639c5$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $1156f5d5007639c5$export$54cfc70c184c0713;

});

parcelRegister("aL0VQ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hZ6O7 = parcelRequire("hZ6O7");


var $jRNsq = parcelRequire("jRNsq");


var $i2CQL = parcelRequire("i2CQL");


var $jQCJ9 = parcelRequire("jQCJ9");

const $4cae511015088d55$var$areFilesPotentiallyDuplicated = (file1, file2)=>file1.status === file2.status && file1.name === file2.name && file1.size === file2.size && file1.mimeType === file2.mimeType && file1.id !== file2.id;
const $4cae511015088d55$export$f91c9e51e5ab027d = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useFileHashes(ids) {
    const $ = (0, $frIzR.c)(15);
    const nonErrorFiles = (0, $i2CQL.useMediaStore)($4cae511015088d55$var$_temp);
    const mediaClient = (0, $jRNsq.useMediaClient)();
    let t0;
    if ($[0] !== ids) {
        t0 = Object.fromEntries(ids.map($4cae511015088d55$var$_temp2));
        $[0] = ids;
        $[1] = t0;
    } else t0 = $[1];
    const collections = t0;
    let t1;
    if ($[2] !== ids || $[3] !== nonErrorFiles) {
        let t2;
        if ($[5] !== ids) {
            t2 = (file)=>ids.some((t3)=>{
                    const { id: id_0 } = t3;
                    return file.id === id_0;
                });
            $[5] = ids;
            $[6] = t2;
        } else t2 = $[6];
        t1 = nonErrorFiles.filter(t2);
        $[2] = ids;
        $[3] = nonErrorFiles;
        $[4] = t1;
    } else t1 = $[4];
    const files = t1;
    const prevFiles = (0, $jQCJ9.usePrevious)(files);
    let t2;
    let t3;
    if ($[7] !== collections || $[8] !== files || $[9] !== mediaClient || $[10] !== prevFiles) {
        t2 = ()=>{
            const prev = prevFiles ?? [];
            const addedOrChangedFiles = files.filter((file_0)=>file_0 && prev.every((prevFile)=>prevFile.id !== file_0.id || prevFile.status !== file_0.status));
            const potentialDuplicates = files.filter((file_1)=>addedOrChangedFiles.some((addedFile)=>$4cae511015088d55$var$areFilesPotentiallyDuplicated(file_1, addedFile)));
            if (potentialDuplicates.length) [
                ...addedOrChangedFiles,
                ...potentialDuplicates
            ].forEach((file_2)=>{
                const collectionName_0 = collections[file_2.id];
                mediaClient.file.getFileState(file_2.id, {
                    collectionName: collectionName_0,
                    includeHashForDuplicateFiles: true,
                    forceRefresh: true
                });
            });
        };
        t3 = [
            files,
            prevFiles,
            mediaClient,
            collections
        ];
        $[7] = collections;
        $[8] = files;
        $[9] = mediaClient;
        $[10] = prevFiles;
        $[11] = t2;
        $[12] = t3;
    } else {
        t2 = $[11];
        t3 = $[12];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[13] !== files) {
        t4 = Object.fromEntries(files.map($4cae511015088d55$var$_temp3));
        $[13] = files;
        $[14] = t4;
    } else t4 = $[14];
    const hashMap = t4;
    return hashMap;
} : function useFileHashes(ids) {
    const nonErrorFiles = (0, $i2CQL.useMediaStore)((state)=>Object.values(state.files).filter((0, $hZ6O7.isNonErrorFinalFileState)));
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const collections = (0, $42omo.useMemo)(()=>Object.fromEntries(ids.map(({ id: id, collectionName: collectionName })=>[
                id,
                collectionName
            ])), [
        ids
    ]);
    const files = (0, $42omo.useMemo)(()=>nonErrorFiles.filter((file)=>ids.some(({ id: id_0 })=>file.id === id_0)), [
        nonErrorFiles,
        ids
    ]);
    const prevFiles = (0, $jQCJ9.usePrevious)(files);
    (0, $42omo.useEffect)(()=>{
        const prev = prevFiles ?? [];
        // Get the files that have been added or whose status has changed since last time.
        const addedOrChangedFiles = files.filter((file_0)=>file_0 && prev.every((prevFile)=>prevFile.id !== file_0.id || prevFile.status !== file_0.status));
        // Get the files from the list that are duplicates of the added / changed files
        const potentialDuplicates = files.filter((file_1)=>addedOrChangedFiles.some((addedFile)=>$4cae511015088d55$var$areFilesPotentiallyDuplicated(file_1, addedFile)));
        if (potentialDuplicates.length) // if any duplicates are found then fetch their hashes along with the added files
        [
            ...addedOrChangedFiles,
            ...potentialDuplicates
        ].forEach((file_2)=>{
            const collectionName_0 = collections[file_2.id];
            mediaClient.file.getFileState(file_2.id, {
                collectionName: collectionName_0,
                includeHashForDuplicateFiles: true,
                forceRefresh: true
            });
        });
    }, [
        files,
        prevFiles,
        mediaClient,
        collections
    ]);
    const hashMap = (0, $42omo.useMemo)(()=>Object.fromEntries(files.map((file_3)=>[
                file_3.id,
                file_3.hash
            ])), [
        files
    ]);
    return hashMap;
};
function $4cae511015088d55$var$_temp3(file_3) {
    return [
        file_3.id,
        file_3.hash
    ];
}
function $4cae511015088d55$var$_temp2(t0) {
    const { id: id, collectionName: collectionName } = t0;
    return [
        id,
        collectionName
    ];
}
function $4cae511015088d55$var$_temp(state) {
    return Object.values(state.files).filter((0, $hZ6O7.isNonErrorFinalFileState));
}
module.exports["useFileHashes"] = $4cae511015088d55$export$f91c9e51e5ab027d;

});

parcelRegister("jQCJ9", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $8227eceacc56cecd$export$5cae361ad82dce8b(value) {
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
module.exports["usePrevious"] = $8227eceacc56cecd$export$5cae361ad82dce8b;

});

parcelRegister("kSoKM", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $aFUXX = parcelRequire("aFUXX");

function $095aa81eb4c35edf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $095aa81eb4c35edf$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    loading: {
        id: "fabric.editor.expand.loading",
        defaultMessage: "Loading..."
    },
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    },
    expandBodyAriaLabel: {
        id: "fabric.editor.expandBodyAriaLabel",
        defaultMessage: "Expand body content"
    }
});
const $095aa81eb4c35edf$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: ()=>expanded ? [
                $095aa81eb4c35edf$var$expandIconWrapperStyle(),
                $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle
            ] : $095aa81eb4c35edf$var$expandIconWrapperStyle()
    }, children);
};
const $095aa81eb4c35edf$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $aFUXX.akEditorSwoopCubicBezier)}`
        }
    });
const $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $095aa81eb4c35edf$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $095aa81eb4c35edf$export$c67faf67c1185cba = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $095aa81eb4c35edf$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});
module.exports["messages"] = $095aa81eb4c35edf$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $095aa81eb4c35edf$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $095aa81eb4c35edf$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $095aa81eb4c35edf$export$c67faf67c1185cba;

});

parcelRegister("3C50A", function(module, exports) {

var $apAFY = parcelRequire("apAFY");


var $bHD89 = parcelRequire("bHD89");


var $1J0ov = parcelRequire("1J0ov");

const $24a3efb1cf8e29fc$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $bHD89.ANALYTICS_BRIDGE_CHANNEL));
};
const $24a3efb1cf8e29fc$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $24a3efb1cf8e29fc$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $24a3efb1cf8e29fc$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $24a3efb1cf8e29fc$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $24a3efb1cf8e29fc$export$79f423cc3fd39762;

});

parcelRegister("bHD89", function(module, exports) {
const $f220a889fcad0dca$export$f636b5b56f1d624a = 'Screen';
const $f220a889fcad0dca$export$9d2de6eebf7462b5 = 'Drawer';
const $f220a889fcad0dca$export$1171103ea9083ffa = 'Modal';
const $f220a889fcad0dca$export$cae2783c9279926 = 'InlineDialog';
const $f220a889fcad0dca$export$d1123261ca8831d2 = 'Dropdown';
const $f220a889fcad0dca$export$a1562d08625f5d7e = 'UI';
const $f220a889fcad0dca$export$947dac6c72b26f81 = 'TRACK';
const $f220a889fcad0dca$export$f1d537d508d2945a = 'SCREEN';
const $f220a889fcad0dca$export$12346a674644c156 = 'OPERATIONAL';
const $f220a889fcad0dca$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["SCREEN"] = $f220a889fcad0dca$export$f636b5b56f1d624a;
module.exports["MODAL"] = $f220a889fcad0dca$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $f220a889fcad0dca$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $f220a889fcad0dca$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $f220a889fcad0dca$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $f220a889fcad0dca$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $f220a889fcad0dca$export$2ceccf177fae277c;

});

parcelRegister("1J0ov", function(module, exports) {
const $9c601e99598456fc$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $9c601e99598456fc$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $9c601e99598456fc$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $9c601e99598456fc$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $9c601e99598456fc$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $9c601e99598456fc$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $9c601e99598456fc$export$e6baab532ef8c6bf;

});

parcelRegister("ij2FZ", function(module, exports) {
const $d70a1b66183cdb12$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $d70a1b66183cdb12$export$d4f002c79ea2ad20 = 'skill';
const $d70a1b66183cdb12$export$e4d0b30afd49f7df = 'skillTag';
const $d70a1b66183cdb12$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $d70a1b66183cdb12$export$aae1b80712c1b67b = `${$d70a1b66183cdb12$export$d4f002c79ea2ad20}:${$d70a1b66183cdb12$export$e4d0b30afd49f7df}`;
const $d70a1b66183cdb12$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $d70a1b66183cdb12$export$d0e832101df0ac96 && extensionKey === $d70a1b66183cdb12$export$aae1b80712c1b67b;
};
const $d70a1b66183cdb12$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $d70a1b66183cdb12$export$aae1b80712c1b67b,
                extensionType: $d70a1b66183cdb12$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $d70a1b66183cdb12$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $d70a1b66183cdb12$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $d70a1b66183cdb12$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $d70a1b66183cdb12$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $d70a1b66183cdb12$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $d70a1b66183cdb12$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $d70a1b66183cdb12$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $d70a1b66183cdb12$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $d70a1b66183cdb12$export$a425ebfe740d9932;

});

parcelRegister("d3VBU", function(module, exports) {

var $42omo = parcelRequire("42omo");






































const $fd687e8904fce28a$export$dce8bc0f04f0d915 = {
    skill: ()=>(parcelRequire("ciV2C")),
    assets: ()=>(parcelRequire("8OGHW")),
    add: ()=>Promise.resolve((parcelRequire("g5gZt"))),
    'chart-bar-line': ()=>(parcelRequire("4qVJ2")),
    'ai-generative-text': ()=>Promise.resolve((parcelRequire("h7YX1"))),
    'work-item': ()=>Promise.resolve((parcelRequire("2qVkt"))),
    'lock-locked': ()=>Promise.resolve((parcelRequire("9Q2dU"))),
    'chart-pie': ()=>(parcelRequire("8sr2T")),
    plan: ()=>(parcelRequire("i4zNS")),
    settings: ()=>Promise.resolve((parcelRequire("fIcbd"))),
    'project-status': ()=>(parcelRequire("6E8pW")),
    'merge-success': ()=>(parcelRequire("3mxkw")),
    'person-add': ()=>(parcelRequire("kMEmh")),
    'people-group': ()=>Promise.resolve((parcelRequire("lebfc"))),
    'person-added': ()=>(parcelRequire("pt6v8")),
    login: ()=>(parcelRequire("kURs4")),
    'ai-generative-text-summary': ()=>Promise.resolve((parcelRequire("a6IPc"))),
    transition: ()=>(parcelRequire("aho4H")),
    board: ()=>Promise.resolve((parcelRequire("5aaqS"))),
    release: ()=>Promise.resolve((parcelRequire("5j8et"))),
    'app-switcher': ()=>(parcelRequire("798YW")),
    search: ()=>Promise.resolve((parcelRequire("jluld"))),
    'playlist-add': ()=>(parcelRequire("dnSjb")),
    'playlist-remove': ()=>(parcelRequire("4kdB8")),
    summary: ()=>Promise.resolve((parcelRequire("a6IPc"))),
    clock: ()=>Promise.resolve((parcelRequire("kevJM"))),
    'ai-generative-chapters': ()=>(parcelRequire("kJyT8")),
    talent: ()=>(parcelRequire("i3Sza")),
    incident: ()=>Promise.resolve((parcelRequire("5LN4K"))),
    form: ()=>(parcelRequire("2CaDj")),
    ticket: ()=>(parcelRequire("kC0Cc")),
    alert: ()=>(parcelRequire("e6w7G")),
    pulse: ()=>(parcelRequire("186Qe")),
    'text-lengthen': ()=>(parcelRequire("7xeCY")),
    'ai-generative-cleanup': ()=>Promise.resolve((parcelRequire("cbtR4"))),
    survey: ()=>(parcelRequire("c58rI")),
    'text-review': ()=>(parcelRequire("aC3t3"))
};
const $fd687e8904fce28a$export$ca2f546e21dcce87 = $fd687e8904fce28a$export$dce8bc0f04f0d915.skill;
const $fd687e8904fce28a$export$f7883dcc9f65479a = Object.fromEntries(Object.entries($fd687e8904fce28a$export$dce8bc0f04f0d915).map(([key, loader])=>[
        key,
        (0, $42omo.lazy)(loader)
    ]));
const $fd687e8904fce28a$export$78596fa6083c04d1 = $fd687e8904fce28a$export$f7883dcc9f65479a.skill;
module.exports["skillIcon"] = $fd687e8904fce28a$export$dce8bc0f04f0d915;
module.exports["defaultIcon"] = $fd687e8904fce28a$export$ca2f546e21dcce87;
module.exports["skillIconMap"] = $fd687e8904fce28a$export$f7883dcc9f65479a;
module.exports["DefaultSkillIcon"] = $fd687e8904fce28a$export$78596fa6083c04d1;

});

parcelRegister("ciV2C", function(module, exports) {

let $8f5369acfd9ab17e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f5369acfd9ab17e$var$load("2ap9J").then(()=>parcelRequire('bKhxF'));

});

parcelRegister("8OGHW", function(module, exports) {

let $66b41f16e830c814$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66b41f16e830c814$var$load("1yrlK").then(()=>parcelRequire('2LFoe'));

});

parcelRegister("4qVJ2", function(module, exports) {

let $33a65e3728a6deed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33a65e3728a6deed$var$load("czqcb").then(()=>parcelRequire('OmUay'));

});

parcelRegister("8sr2T", function(module, exports) {

let $6285eaf809731400$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6285eaf809731400$var$load("8vVzT").then(()=>parcelRequire('4DzVW'));

});

parcelRegister("i4zNS", function(module, exports) {

let $d2845f86362f2ced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2845f86362f2ced$var$load("hpUn4").then(()=>parcelRequire('3Pjsu'));

});

parcelRegister("6E8pW", function(module, exports) {

let $4d6d0204a36cd6bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d6d0204a36cd6bd$var$load("l4YAS").then(()=>parcelRequire('f2ref'));

});

parcelRegister("3mxkw", function(module, exports) {

let $272d47d3be217e93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $272d47d3be217e93$var$load("6HxBR").then(()=>parcelRequire('2KFft'));

});

parcelRegister("kMEmh", function(module, exports) {

let $f21798a7023c2d22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f21798a7023c2d22$var$load("fjOTL").then(()=>parcelRequire('cDMVr'));

});

parcelRegister("pt6v8", function(module, exports) {

let $04c8e955877b500e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $04c8e955877b500e$var$load("4rKYa").then(()=>parcelRequire('l8mxb'));

});

parcelRegister("kURs4", function(module, exports) {

let $f3a28009260eef94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3a28009260eef94$var$load("iMSgb").then(()=>parcelRequire('ilSNM'));

});

parcelRegister("aho4H", function(module, exports) {

let $77be2ab0ef9d3474$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77be2ab0ef9d3474$var$load("8Qv5g").then(()=>parcelRequire('cnlZf'));

});

parcelRegister("798YW", function(module, exports) {

let $5340574c778c8cd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5340574c778c8cd4$var$load("48rvp").then(()=>parcelRequire('kNHXO'));

});

parcelRegister("dnSjb", function(module, exports) {

let $9be78cd6942a698e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9be78cd6942a698e$var$load("7kkP6").then(()=>parcelRequire('3DMri'));

});

parcelRegister("4kdB8", function(module, exports) {

let $326393f9ce2ef51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $326393f9ce2ef51d$var$load("k2R9e").then(()=>parcelRequire('2Ihtu'));

});

parcelRegister("kJyT8", function(module, exports) {

let $f18312b6ea88af73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f18312b6ea88af73$var$load("1okAQ").then(()=>parcelRequire('iulqN'));

});

parcelRegister("i3Sza", function(module, exports) {

let $d262d588718b83e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d262d588718b83e3$var$load("eF7Ol").then(()=>parcelRequire('f7Fwi'));

});

parcelRegister("2CaDj", function(module, exports) {

let $1e7760e1b1d31574$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1e7760e1b1d31574$var$load("3TFqP").then(()=>parcelRequire('4JtPF'));

});

parcelRegister("kC0Cc", function(module, exports) {

let $f017d56eb0f65c8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f017d56eb0f65c8a$var$load("334w0").then(()=>parcelRequire('kVwu3'));

});

parcelRegister("e6w7G", function(module, exports) {

let $a44a8b2afa568976$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a44a8b2afa568976$var$load("2ABJz").then(()=>parcelRequire('7Shff'));

});

parcelRegister("186Qe", function(module, exports) {

let $0d2bd8617a14a4d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d2bd8617a14a4d3$var$load("cSj9q").then(()=>parcelRequire('8uomH'));

});

parcelRegister("7xeCY", function(module, exports) {

let $57c6f6319bc0dd8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57c6f6319bc0dd8e$var$load("9f5Sw").then(()=>parcelRequire('eugUs'));

});

parcelRegister("c58rI", function(module, exports) {

let $8cbc80e42da4fe4b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cbc80e42da4fe4b$var$load("2jXG3").then(()=>parcelRequire('gjyaY'));

});

parcelRegister("aC3t3", function(module, exports) {

let $7ba02494c7b926ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ba02494c7b926ed$var$load("ct54r").then(()=>parcelRequire('1mMWQ'));

});

parcelRegister("lGVHb", function(module, exports) {
function $b4b40a49047a27cf$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $b4b40a49047a27cf$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $b4b40a49047a27cf$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const trimmedDescription = node.description && node.description?.length > 150 ? `${node.description?.slice(0, 147)}...` : node.description ?? '';
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $b4b40a49047a27cf$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.displayName ?? node.name ?? '',
        description: node.helpText ?? node.description ?? '',
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $b4b40a49047a27cf$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$b4b40a49047a27cf$export$db36004670a5626e(edge?.node) ? $b4b40a49047a27cf$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $b4b40a49047a27cf$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$b4b40a49047a27cf$export$7d1ba2a7b9e1a07(edge?.node) ? $b4b40a49047a27cf$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $b4b40a49047a27cf$export$faef8b68e529d4a7(edges) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($b4b40a49047a27cf$export$db36004670a5626e(node)) return $b4b40a49047a27cf$export$74ea09dd5afceb60(node);
        if ($b4b40a49047a27cf$export$7d1ba2a7b9e1a07(node)) return $b4b40a49047a27cf$export$fd76a94f4a001a14(node);
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $b4b40a49047a27cf$export$74ea09dd5afceb60;
module.exports["parseSkillEdges"] = $b4b40a49047a27cf$export$2cffb029ea623d71;
module.exports["parseConvoAiSkillEdges"] = $b4b40a49047a27cf$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $b4b40a49047a27cf$export$faef8b68e529d4a7;

});

parcelRegister("h5cDl", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $lGVHb = parcelRequire("lGVHb");

const $69b3b1a34fa19136$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Legacy GraphQL query — graphIntegration_componentDirectoryItems.
 * Returns user-facing descriptions (not AI model instructions).
 * Used when rovo_chat_unified_skills_agg is OFF.
 */ const $69b3b1a34fa19136$var$LEGACY_SKILLS_QUERY = `
  query GraphIntegrationItemsQuery(
    $first: Int
    $cloudId: ID!
    $surface: GraphIntegrationSurface
    $relevantFor: [GraphIntegrationDirectoryItemType!]
  ) {
    graphIntegration_componentDirectoryItems(
      first: $first
      cloudId: $cloudId
      surface: $surface
      relevantFor: $relevantFor
    )
    @optIn(to: "GraphIntegrationItemsQuery")
    {
      edges {
        node {
          __typename
          ... on GraphIntegrationSkillDirectoryItem {
            id
            slashCommand
            name
            description
            iconUrl
            integrationKey {
              displayName
              iconUrl
            }
            color
            tags {
              displayName
            }
          }
        }
      }
    }
  }
`;
/**
 * New unified GraphQL query — convoai_availableSkills.
 * Used when rovo_chat_unified_skills_agg is ON.
 */ const $69b3b1a34fa19136$var$UNIFIED_SKILLS_QUERY = `
  query ConvoAiAvailableSkillsQuery(
    $first: Int
    $cloudId: ID!
  ) {
    convoai_availableSkills(
      first: $first
      cloudId: $cloudId
    )
    @optIn(to: "ConvoAiAvailableSkills")
    {
      edges {
        node {
          __typename
          ... on ConvoAiSkill {
            id
            name
            description
            displayName
            slashCommand
						helpText
            iconUrl
            iconKey
            color
            source
            tags
            category
            integrationKeys
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
/**
 * Session-level cache for fetched skills.
 * Keyed by `${cloudId}:${graphqlEndpoint}:${useUnified}` to avoid redundant network requests.
 * Skills are cached for the lifetime of the page (matching Relay store behavior).
 * A page refresh will fetch fresh data.
 */ const $69b3b1a34fa19136$var$skillsCache = new Map();
function $69b3b1a34fa19136$export$e6cf70cf6554c856() {
    $69b3b1a34fa19136$var$skillsCache.clear();
}
/**
 * Fetch skills using the new unified convoai_availableSkills endpoint.
 */ async function $69b3b1a34fa19136$var$fetchSkillsUnified(cloudId) {
    const response = await fetch($69b3b1a34fa19136$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $69b3b1a34fa19136$var$UNIFIED_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 100
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length || json.data?.convoai_availableSkills?.errors?.length) return [];
    const edges = json.data?.convoai_availableSkills?.edges;
    return (0, $lGVHb.parseConvoAiSkillEdges)(edges);
}
/**
 * Fetch skills using the legacy graphIntegration_componentDirectoryItems endpoint.
 */ async function $69b3b1a34fa19136$var$fetchSkillsLegacy(cloudId) {
    const response = await fetch($69b3b1a34fa19136$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $69b3b1a34fa19136$var$LEGACY_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 100,
                surface: 'ROVO',
                relevantFor: [
                    'SKILL'
                ]
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length) return [];
    const edges = json.data?.graphIntegration_componentDirectoryItems?.edges;
    return (0, $lGVHb.parseSkillEdges)(edges);
}
async function $69b3b1a34fa19136$export$268d57ae88e7df66(cloudId) {
    const useUnified = (0, $dh538.fg)('rovo_chat_unified_skills_agg');
    const cacheKey = `${cloudId}:${useUnified}`;
    const cached = $69b3b1a34fa19136$var$skillsCache.get(cacheKey);
    if (cached) return cached;
    try {
        const skills = useUnified ? await $69b3b1a34fa19136$var$fetchSkillsUnified(cloudId) : await $69b3b1a34fa19136$var$fetchSkillsLegacy(cloudId);
        $69b3b1a34fa19136$var$skillsCache.set(cacheKey, skills);
        return skills;
    } catch  {
        // Silently fail — the insert menu will just not show skills
        return [];
    }
}
module.exports["clearSkillsCache"] = $69b3b1a34fa19136$export$e6cf70cf6554c856;
module.exports["fetchSkills"] = $69b3b1a34fa19136$export$268d57ae88e7df66;

});

parcelRegister("iuafG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $fSglY = parcelRequire("fSglY");

const $8fdbd961e8c69c33$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $8fdbd961e8c69c33$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $8fdbd961e8c69c33$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const disclaimerContent = /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $fSglY.i18n).disclaimerMessage));
    if (withLink) return /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
        appearance: "subtle",
        href: $8fdbd961e8c69c33$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick
    }, disclaimerContent);
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($8fdbd961e8c69c33$var$styles.text)
    }, disclaimerContent);
};
module.exports["AIDisclaimer"] = $8fdbd961e8c69c33$export$e0542ba0c737fe5c;

});

parcelRegister("fSglY", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168;

});

parcelRegister("4iPjq", function(module, exports) {
parcelRequire("aqrhZ");
var $96msn = parcelRequire("96msn");


var $5wEPK = parcelRequire("5wEPK");


const $74848600c16eb369$var$LazyLinkPickerComponent = (0, $96msn.lazyForPaint)(()=>(parcelRequire("8LIeT")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $74848600c16eb369$var$_default_1 = (0, $5wEPK.composeLinkPicker)($74848600c16eb369$var$LazyLinkPickerComponent);
var $74848600c16eb369$export$2e2bcd8739ae039 = $74848600c16eb369$var$_default_1;
module.exports["default"] = $74848600c16eb369$export$2e2bcd8739ae039;

});

parcelRegister("5wEPK", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

parcelRequire("aqrhZ");
var $jyd5r = parcelRequire("jyd5r");


var $bYRk6 = parcelRequire("bYRk6");


var $2lNr8 = parcelRequire("2lNr8");


var $knjgj = parcelRequire("knjgj");


var $918lS = parcelRequire("918lS");


var $jrfDA = parcelRequire("jrfDA");


var $lQSkW = parcelRequire("lQSkW");

const $99bf16152ad1d840$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $99bf16152ad1d840$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $2lNr8.COMPONENT_NAME),
    source: (0, $2lNr8.COMPONENT_NAME)
};
const $99bf16152ad1d840$var$DefaultRootComponent = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $99bf16152ad1d840$var$fixedWidthContainerStyles = null;
const $99bf16152ad1d840$var$FixedWidthContainer = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_1bsb1ubl"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            role: "dialog",
            "aria-modal": "false",
            "aria-label": "link-picker",
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb1ubl"
        ])
    });
};
const $99bf16152ad1d840$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $99bf16152ad1d840$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: $99bf16152ad1d840$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $knjgj.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lQSkW.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $2lNr8.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99bf16152ad1d840$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $918lS.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jyd5r.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrfDA.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RootComponent, {
            ...props,
            "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $99bf16152ad1d840$export$922eb685ceb4a294;

});

parcelRegister("2lNr8", function(module, exports) {
const $7282d690d6f118fb$export$85183a312807388d = 'media';
const $7282d690d6f118fb$export$fc44104665f4d1e5 = 'linkPicker';
const $7282d690d6f118fb$export$452f1062ecf44be7 = 5;
const $7282d690d6f118fb$export$bf31a09f182d5584 = 342;
const $7282d690d6f118fb$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $7282d690d6f118fb$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $7282d690d6f118fb$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $7282d690d6f118fb$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $7282d690d6f118fb$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $7282d690d6f118fb$export$542fb16962bf430c;

});

parcelRegister("knjgj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $hzd6s = parcelRequire("hzd6s");

const $56c0565d5892d700$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $56c0565d5892d700$export$3285420c698bc605 = /*#__PURE__*/ (0, $42omo.createContext)($56c0565d5892d700$export$c07727f5eddb98f);
const $56c0565d5892d700$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $42omo.useRef)((0, $dQl1W.v4)());
    (0, $42omo.useEffect)(()=>{
        (0, $hzd6s.startUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
        return ()=>(0, $hzd6s.abortUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($56c0565d5892d700$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $56c0565d5892d700$export$36ecc935abdc3636 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
} : ()=>(0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $56c0565d5892d700$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $56c0565d5892d700$export$36ecc935abdc3636;

});

parcelRegister("hzd6s", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $f665373313765471$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $f665373313765471$var$ufoExperiences = {
    [$f665373313765471$export$f9c7780c574346a2.mounted]: new (0, $9801n.ConcurrentExperience)($f665373313765471$export$f9c7780c574346a2.mounted, {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $f665373313765471$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $f665373313765471$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $f665373313765471$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $f665373313765471$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $f665373313765471$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $f665373313765471$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $f665373313765471$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $f665373313765471$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $f665373313765471$export$b1021040eb94cdca;

});

parcelRegister("918lS", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hzd6s = parcelRequire("hzd6s");


var $2lNr8 = parcelRequire("2lNr8");


var $abGcM = parcelRequire("abGcM");


var $knjgj = parcelRequire("knjgj");


var $khavy = parcelRequire("khavy");


var $3blls = parcelRequire("3blls");

const $4548d496336bec74$export$e926676385687eaf = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ErrorBoundary(t0) {
    const $ = (0, $frIzR.c)(6);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== linkPickerSessionId) {
        t1 = (error, info)=>{
            createAnalyticsEvent((0, $abGcM.default)("ui.linkPicker.unhandledErrorCaught", {
                browserInfo: window?.navigator?.userAgent || "unknown",
                error: error.toString(),
                componentStack: info?.componentStack ?? ""
            })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
            (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
        };
        $[0] = createAnalyticsEvent;
        $[1] = linkPickerSessionId;
        $[2] = t1;
    } else t1 = $[2];
    const handleError = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleError) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $khavy.BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, $3blls.ErrorBoundaryFallback)
        }, children);
        $[3] = children;
        $[4] = handleError;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ErrorBoundary({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    const handleError = (0, $42omo.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $abGcM.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $khavy.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $3blls.ErrorBoundaryFallback)
    }, children);
};
module.exports["ErrorBoundary"] = $4548d496336bec74$export$e926676385687eaf;

});

parcelRegister("abGcM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::590b9da528f0d0b88cea1feaa1815283>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $1d2d80882026b768$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $1d2d80882026b768$export$2e2bcd8739ae039 = $1d2d80882026b768$var$createEventPayload;
module.exports["default"] = $1d2d80882026b768$export$2e2bcd8739ae039;

});

parcelRegister("khavy", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $096b317da4a8d9ff$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $096b317da4a8d9ff$export$688779ac61ee945f;

});

parcelRegister("3blls", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2lNr8 = parcelRequire("2lNr8");


var $c2ARh = parcelRequire("c2ARh");


var $atwsN = parcelRequire("atwsN");


var $lO9iE = parcelRequire("lO9iE");

const $6fbfcea2b9f5c943$var$errorBoundaryFallbackStyles = null;
const $6fbfcea2b9f5c943$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $6fbfcea2b9f5c943$export$8a28b7e38e4685dd = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    const header = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    const description = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_11c8i4vh"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== description || $[6] !== header) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
            minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
            "data-testid": "link-picker-root-error-boundary-ui",
            className: t2
        }, /*#__PURE__*/ $42omo.createElement((0, $atwsN.EmptyState), {
            header: header,
            renderImage: $6fbfcea2b9f5c943$var$_temp,
            description: description
        }));
        $[5] = description;
        $[6] = header;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const header = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
    const description = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
    return /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
        minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $gMc0m.default)([
            "_11c8i4vh"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $atwsN.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $42omo.createElement((0, $c2ARh.GenericErrorSVG), null),
        description: description
    }));
};
function $6fbfcea2b9f5c943$var$_temp() {
    return /*#__PURE__*/ $42omo.createElement((0, $c2ARh.GenericErrorSVG), null);
}
module.exports["ErrorBoundaryFallback"] = $6fbfcea2b9f5c943$export$8a28b7e38e4685dd;

});

parcelRegister("c2ARh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2890d1e9307e8ae4$var$SIZE = 96;
const $2890d1e9307e8ae4$var$genericErrorStyles = null;
const $2890d1e9307e8ae4$export$e54420a1a27457a4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]);
        t1 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        });
        t2 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
        });
        t3 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
        });
        t4 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
        });
        t5 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        });
        t6 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
            clipRule: "evenodd"
        });
        t7 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
            clipRule: "evenodd"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] !== props) {
        t8 = /*#__PURE__*/ $42omo.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            className: t0
        }, t1, t2, t3, t4, t5, t6, t7);
        $[8] = props;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $2890d1e9307e8ae4$export$e54420a1a27457a4;

});

parcelRegister("atwsN", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");

const $e8c7333955d8c82e$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $e8c7333955d8c82e$export$fddf379e22a74b00 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { testId: testId, header: header, description: description, action: action, renderImage: renderImage } = t0;
    let t1;
    if ($[0] !== renderImage) {
        t1 = renderImage?.();
        $[0] = renderImage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== header) {
        t2 = /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
            size: "small",
            as: "h2"
        }, header);
        $[2] = header;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== description) {
        t3 = description && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            as: "p",
            color: "color.text"
        }, description);
        $[4] = description;
        $[5] = t3;
    } else t3 = $[5];
    const t4 = action && action;
    let t5;
    if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== testId) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            xcss: $e8c7333955d8c82e$var$styles.containerV2,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, t1, t2, t3, t4);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = testId;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        xcss: $e8c7333955d8c82e$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $e8c7333955d8c82e$export$fddf379e22a74b00;

});

parcelRegister("lO9iE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $562443300071d672$var$minHeightComponentStyles = null;
const $562443300071d672$export$42134e2a251518b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $562443300071d672$export$42134e2a251518b3;

});

parcelRegister("jrfDA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $lO9iE = parcelRequire("lO9iE");

const $c92e1a3420d5d33f$var$styles = null;
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $c92e1a3420d5d33f$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $c92e1a3420d5d33f$export$d96e921133238c41 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const minHeight = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_4cvr1h6o"
        ]);
        $[2] = t1;
    } else t1 = $[2];
    const t2 = props.name || "link-picker-loading";
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: t2,
            size: "medium"
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== minHeight || $[6] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            className: t1
        }, t3);
        $[5] = minHeight;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const minHeight = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $gMc0m.default)([
            "_4cvr1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $c92e1a3420d5d33f$export$d96e921133238c41;

});

parcelRegister("lQSkW", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ab7LA = parcelRequire("ab7LA");

const $6958f3d9e68e6f8d$export$54320b51a950d54a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab7LA.LazyMessagesProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab7LA.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $6958f3d9e68e6f8d$export$54320b51a950d54a;

});

parcelRegister("ab7LA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $iaMDd = parcelRequire("iaMDd");


var $3lHRF = parcelRequire("3lHRF");

const $42f9fe6b4d8a0292$export$d013d33430f9fb4b = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
            defaultMessages: (0, $iaMDd.default),
            loaderFn: (0, $3lHRF.fetchMessagesForLocale)
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
        defaultMessages: (0, $iaMDd.default),
        loaderFn: (0, $3lHRF.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $42f9fe6b4d8a0292$export$d013d33430f9fb4b;

});

parcelRegister("3lHRF", function(module, exports) {

var $aWYpi = parcelRequire("aWYpi");

const $b1e230aff09883c2$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $b1e230aff09883c2$export$2b153a2030b0feb2;

});

parcelRegister("aWYpi", function(module, exports) {

























const $c4ed7fdc8607c9f9$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("49ni4")),
    da: ()=>(parcelRequire("9i24I")),
    de: ()=>(parcelRequire("3GGRL")),
    en_GB: ()=>(parcelRequire("f9H50")),
    en_ZZ: ()=>(parcelRequire("ecHgQ")),
    en: ()=>Promise.resolve((parcelRequire("iaMDd"))),
    es: ()=>(parcelRequire("b9n7m")),
    fi: ()=>(parcelRequire("9Ymrs")),
    fr: ()=>(parcelRequire("c09we")),
    hu: ()=>(parcelRequire("eWHOv")),
    it: ()=>(parcelRequire("joBHN")),
    ja: ()=>(parcelRequire("EDSZV")),
    ko: ()=>(parcelRequire("f5q2I")),
    nb: ()=>(parcelRequire("rJqkb")),
    nl: ()=>(parcelRequire("58PdT")),
    pl: ()=>(parcelRequire("enArn")),
    pt_BR: ()=>(parcelRequire("5XYTp")),
    ru: ()=>(parcelRequire("k3D4M")),
    sv: ()=>(parcelRequire("819Nj")),
    th: ()=>(parcelRequire("khF3L")),
    tr: ()=>(parcelRequire("3Shvv")),
    uk: ()=>(parcelRequire("7MpfQ")),
    vi: ()=>(parcelRequire("bbM1s")),
    zh_TW: ()=>(parcelRequire("hE3F1")),
    zh: ()=>(parcelRequire("dpRbE"))
};
module.exports["locales"] = $c4ed7fdc8607c9f9$export$df1c34db1371eeed;

});

parcelRegister("49ni4", function(module, exports) {

let $305a11b60fea096a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $305a11b60fea096a$var$load("4Mixi"),
    $305a11b60fea096a$var$load("1jsQH"),
    $305a11b60fea096a$var$load("i5eMd"),
    $305a11b60fea096a$var$load("bv8GZ"),
    $305a11b60fea096a$var$load("i9sd0"),
    $305a11b60fea096a$var$load("4DYJ5"),
    $305a11b60fea096a$var$load("gyXEE"),
    $305a11b60fea096a$var$load("hoPZ9")
]).then(()=>parcelRequire('k82rV'));

});

parcelRegister("9i24I", function(module, exports) {

let $6c376795d61b5f16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c376795d61b5f16$var$load("cjveN"),
    $6c376795d61b5f16$var$load("deyvi"),
    $6c376795d61b5f16$var$load("4UPfH"),
    $6c376795d61b5f16$var$load("cdeuH"),
    $6c376795d61b5f16$var$load("aNg21"),
    $6c376795d61b5f16$var$load("hfFxJ"),
    $6c376795d61b5f16$var$load("1Mp9N"),
    $6c376795d61b5f16$var$load("2Fu3d")
]).then(()=>parcelRequire('5CXR9'));

});

parcelRegister("3GGRL", function(module, exports) {

let $2af68baa2ba0afdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2af68baa2ba0afdb$var$load("8XGJb"),
    $2af68baa2ba0afdb$var$load("6dERU"),
    $2af68baa2ba0afdb$var$load("gd4qs"),
    $2af68baa2ba0afdb$var$load("7gF8f"),
    $2af68baa2ba0afdb$var$load("YEGhv"),
    $2af68baa2ba0afdb$var$load("gofGr"),
    $2af68baa2ba0afdb$var$load("dBb6q"),
    $2af68baa2ba0afdb$var$load("eJgH8")
]).then(()=>parcelRequire('28QMN'));

});

parcelRegister("f9H50", function(module, exports) {

let $b0891d001c3b0f5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0891d001c3b0f5d$var$load("hdvZr"),
    $b0891d001c3b0f5d$var$load("kTurq"),
    $b0891d001c3b0f5d$var$load("fviv5"),
    $b0891d001c3b0f5d$var$load("djb49"),
    $b0891d001c3b0f5d$var$load("d8WL7"),
    $b0891d001c3b0f5d$var$load("2RQvP"),
    $b0891d001c3b0f5d$var$load("7Lkvk")
]).then(()=>parcelRequire('b4NXj'));

});

parcelRegister("ecHgQ", function(module, exports) {

let $a573c0545bc835b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a573c0545bc835b1$var$load("4ViGN"),
    $a573c0545bc835b1$var$load("j0PWv"),
    $a573c0545bc835b1$var$load("eBoC7"),
    $a573c0545bc835b1$var$load("ksTQ6"),
    $a573c0545bc835b1$var$load("j5F5K"),
    $a573c0545bc835b1$var$load("7NpX8"),
    $a573c0545bc835b1$var$load("cukQS"),
    $a573c0545bc835b1$var$load("5FaEJ")
]).then(()=>parcelRequire('5SuH4'));

});

parcelRegister("b9n7m", function(module, exports) {

let $81e277acab2bd080$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81e277acab2bd080$var$load("32vlK"),
    $81e277acab2bd080$var$load("dlmud"),
    $81e277acab2bd080$var$load("bNv64"),
    $81e277acab2bd080$var$load("5CGnz"),
    $81e277acab2bd080$var$load("dXu4x"),
    $81e277acab2bd080$var$load("bFU3Y"),
    $81e277acab2bd080$var$load("3CucM"),
    $81e277acab2bd080$var$load("9yemY")
]).then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("9Ymrs", function(module, exports) {

let $742b201de0044ee5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $742b201de0044ee5$var$load("bjoGV"),
    $742b201de0044ee5$var$load("cbkj0"),
    $742b201de0044ee5$var$load("4Afgd"),
    $742b201de0044ee5$var$load("9Oxgj"),
    $742b201de0044ee5$var$load("18TX5"),
    $742b201de0044ee5$var$load("exaJ2"),
    $742b201de0044ee5$var$load("lp8Wm"),
    $742b201de0044ee5$var$load("l2LZP")
]).then(()=>parcelRequire('ezgWl'));

});

parcelRegister("c09we", function(module, exports) {

let $8bccde637f75ef88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8bccde637f75ef88$var$load("8oiz7"),
    $8bccde637f75ef88$var$load("17m16"),
    $8bccde637f75ef88$var$load("cMubu"),
    $8bccde637f75ef88$var$load("kAg8V"),
    $8bccde637f75ef88$var$load("9Cdzw"),
    $8bccde637f75ef88$var$load("hcCcg"),
    $8bccde637f75ef88$var$load("cHWSM"),
    $8bccde637f75ef88$var$load("35Ssm")
]).then(()=>parcelRequire('gYv97'));

});

parcelRegister("eWHOv", function(module, exports) {

let $ae1877f695269b3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae1877f695269b3f$var$load("hFxmj"),
    $ae1877f695269b3f$var$load("b4NO6"),
    $ae1877f695269b3f$var$load("3fLE9"),
    $ae1877f695269b3f$var$load("fM2oh"),
    $ae1877f695269b3f$var$load("guNAg"),
    $ae1877f695269b3f$var$load("j9KTb"),
    $ae1877f695269b3f$var$load("b37xN"),
    $ae1877f695269b3f$var$load("ik6u5")
]).then(()=>parcelRequire('bVNwo'));

});

parcelRegister("joBHN", function(module, exports) {

let $e1ed81b248c56b08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e1ed81b248c56b08$var$load("BXOZB"),
    $e1ed81b248c56b08$var$load("1K1Fj"),
    $e1ed81b248c56b08$var$load("8hOn0"),
    $e1ed81b248c56b08$var$load("xnqy2"),
    $e1ed81b248c56b08$var$load("cM3gY"),
    $e1ed81b248c56b08$var$load("3hjAq"),
    $e1ed81b248c56b08$var$load("7PjNK"),
    $e1ed81b248c56b08$var$load("Vt6S9")
]).then(()=>parcelRequire('lxZVf'));

});

parcelRegister("EDSZV", function(module, exports) {

let $07a2ad1527c69f6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $07a2ad1527c69f6b$var$load("9Xiuh"),
    $07a2ad1527c69f6b$var$load("38sfA"),
    $07a2ad1527c69f6b$var$load("h4OCL"),
    $07a2ad1527c69f6b$var$load("awkVi"),
    $07a2ad1527c69f6b$var$load("6yRq3"),
    $07a2ad1527c69f6b$var$load("2bCHJ"),
    $07a2ad1527c69f6b$var$load("ktSfi"),
    $07a2ad1527c69f6b$var$load("9GZ76")
]).then(()=>parcelRequire('hflsJ'));

});

parcelRegister("f5q2I", function(module, exports) {

let $afbb862f455b1607$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afbb862f455b1607$var$load("7Odo3"),
    $afbb862f455b1607$var$load("bjmre"),
    $afbb862f455b1607$var$load("bcQs2"),
    $afbb862f455b1607$var$load("11DLa"),
    $afbb862f455b1607$var$load("cft22"),
    $afbb862f455b1607$var$load("fdXnq"),
    $afbb862f455b1607$var$load("iouLY"),
    $afbb862f455b1607$var$load("4sOIV")
]).then(()=>parcelRequire('73LWR'));

});

parcelRegister("rJqkb", function(module, exports) {

let $0535c1e8d4cff100$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0535c1e8d4cff100$var$load("4VkvT"),
    $0535c1e8d4cff100$var$load("asvK9"),
    $0535c1e8d4cff100$var$load("aBa7j"),
    $0535c1e8d4cff100$var$load("barSq"),
    $0535c1e8d4cff100$var$load("gctEz"),
    $0535c1e8d4cff100$var$load("cItJR"),
    $0535c1e8d4cff100$var$load("hPZE5"),
    $0535c1e8d4cff100$var$load("QTjdE")
]).then(()=>parcelRequire('h0YR4'));

});

parcelRegister("58PdT", function(module, exports) {

let $3be56eed8368bce0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3be56eed8368bce0$var$load("g5qJV"),
    $3be56eed8368bce0$var$load("7v6wU"),
    $3be56eed8368bce0$var$load("b544F"),
    $3be56eed8368bce0$var$load("a8heY"),
    $3be56eed8368bce0$var$load("9PPH7"),
    $3be56eed8368bce0$var$load("SctKm"),
    $3be56eed8368bce0$var$load("dzIm8"),
    $3be56eed8368bce0$var$load("hrf1M")
]).then(()=>parcelRequire('573SD'));

});

parcelRegister("enArn", function(module, exports) {

let $a77f7b0327a81145$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a77f7b0327a81145$var$load("dPa6p"),
    $a77f7b0327a81145$var$load("aEpRh"),
    $a77f7b0327a81145$var$load("K6fhx"),
    $a77f7b0327a81145$var$load("6hlNE"),
    $a77f7b0327a81145$var$load("1y1eN"),
    $a77f7b0327a81145$var$load("1fJz1"),
    $a77f7b0327a81145$var$load("jqwnR"),
    $a77f7b0327a81145$var$load("lsloj")
]).then(()=>parcelRequire('8sMYh'));

});

parcelRegister("5XYTp", function(module, exports) {

let $4581b27058c75bd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4581b27058c75bd4$var$load("iG4uh"),
    $4581b27058c75bd4$var$load("3fuR9"),
    $4581b27058c75bd4$var$load("gZU54"),
    $4581b27058c75bd4$var$load("2bqSD"),
    $4581b27058c75bd4$var$load("e8jpx"),
    $4581b27058c75bd4$var$load("9yA8o"),
    $4581b27058c75bd4$var$load("bGhLc"),
    $4581b27058c75bd4$var$load("iRKhU")
]).then(()=>parcelRequire('lRfBG'));

});

parcelRegister("k3D4M", function(module, exports) {

let $e9a266292735eae2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e9a266292735eae2$var$load("9tVE8"),
    $e9a266292735eae2$var$load("fMrUo"),
    $e9a266292735eae2$var$load("4Wdqb"),
    $e9a266292735eae2$var$load("bJykp"),
    $e9a266292735eae2$var$load("fjbzp"),
    $e9a266292735eae2$var$load("448N7"),
    $e9a266292735eae2$var$load("9v6ER"),
    $e9a266292735eae2$var$load("aEAsN")
]).then(()=>parcelRequire('hZouV'));

});

parcelRegister("819Nj", function(module, exports) {

let $5d6603af87dbf1fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d6603af87dbf1fc$var$load("6UAlo"),
    $5d6603af87dbf1fc$var$load("9eNkX"),
    $5d6603af87dbf1fc$var$load("k10Cs"),
    $5d6603af87dbf1fc$var$load("dh2Er"),
    $5d6603af87dbf1fc$var$load("1pFHs"),
    $5d6603af87dbf1fc$var$load("gBDdh"),
    $5d6603af87dbf1fc$var$load("8Mz40"),
    $5d6603af87dbf1fc$var$load("l6YHr")
]).then(()=>parcelRequire('4LH4L'));

});

parcelRegister("khF3L", function(module, exports) {

let $ec453ec2806faba2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec453ec2806faba2$var$load("jYGxH").then(()=>parcelRequire('hlxQj'));

});

parcelRegister("3Shvv", function(module, exports) {

let $2d23fecbe4644720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d23fecbe4644720$var$load("czAFw").then(()=>parcelRequire('gQkbc'));

});

parcelRegister("7MpfQ", function(module, exports) {

let $5aa09b1e53b19903$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5aa09b1e53b19903$var$load("c0Efy").then(()=>parcelRequire('lC9hp'));

});

parcelRegister("bbM1s", function(module, exports) {

let $8255f915989d7a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8255f915989d7a01$var$load("dKBuH").then(()=>parcelRequire('fzD7h'));

});

parcelRegister("hE3F1", function(module, exports) {

let $cd890306c10c6d8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd890306c10c6d8a$var$load("ia9y3"),
    $cd890306c10c6d8a$var$load("j9OUx"),
    $cd890306c10c6d8a$var$load("l079e"),
    $cd890306c10c6d8a$var$load("bV8sS"),
    $cd890306c10c6d8a$var$load("kKXTS"),
    $cd890306c10c6d8a$var$load("ebljE"),
    $cd890306c10c6d8a$var$load("hF4v3"),
    $cd890306c10c6d8a$var$load("afU9w")
]).then(()=>parcelRequire('6PXdj'));

});

parcelRegister("dpRbE", function(module, exports) {

let $9c46ddff53e4b24d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c46ddff53e4b24d$var$load("15ncj"),
    $9c46ddff53e4b24d$var$load("gDiIK"),
    $9c46ddff53e4b24d$var$load("f1B4n"),
    $9c46ddff53e4b24d$var$load("eLlpV"),
    $9c46ddff53e4b24d$var$load("7sItg"),
    $9c46ddff53e4b24d$var$load("j4dSZ"),
    $9c46ddff53e4b24d$var$load("1Tuyb"),
    $9c46ddff53e4b24d$var$load("7iCpI")
]).then(()=>parcelRequire('5WXmf'));

});

parcelRegister("8LIeT", function(module, exports) {

let $01a5c22f8eaee1df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $01a5c22f8eaee1df$var$load("hXbzh"),
    $01a5c22f8eaee1df$var$load("6wr18"),
    $01a5c22f8eaee1df$var$load("7EorR"),
    $01a5c22f8eaee1df$var$load("ffEVr"),
    $01a5c22f8eaee1df$var$load("Wowvf"),
    $01a5c22f8eaee1df$var$load("hhss7"),
    $01a5c22f8eaee1df$var$load("7j0mT"),
    $01a5c22f8eaee1df$var$load("69R9L"),
    $01a5c22f8eaee1df$var$load("c0JsV")
]).then(()=>parcelRequire('cDSVd'));

});

parcelRegister("6m4LV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $lqsSp = parcelRequire("lqsSp");


var $caX7N = parcelRequire("caX7N");


var $gdv5Z = parcelRequire("gdv5Z");


var $g5lKx = parcelRequire("g5lKx");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");


var $oZBat = parcelRequire("oZBat");


var $fRJCL = parcelRequire("fRJCL");


var $4dNEc = parcelRequire("4dNEc");


var $2205s = parcelRequire("2205s");


var $2TEGg = parcelRequire("2TEGg");

const $df640aaa5edb6adc$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
function $df640aaa5edb6adc$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId, agent: agent }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48FEk.InternalEntryPointContainer), {
        id: $df640aaa5edb6adc$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2205s.CardLoading), null),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId,
            agent: agent
        }
    });
}
function $df640aaa5edb6adc$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df640aaa5edb6adc$var$UserProfileCardForMentionInner, props));
}
/** Inner implementation of {@link UserProfileCardForMention}. */ function $df640aaa5edb6adc$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', trigger: trigger, testId: testId, agent: agent }) {
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $42omo.useCallback)(()=>{
        (0, $fRJCL.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $42omo.useCallback)((_props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $oZBat.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        environmentProvider
    ]);
    // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    if (!referenceElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2TEGg.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        placement: placement,
        trigger: trigger,
        testId: testId,
        agent: agent,
        shouldRenderToParent: false
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        onError: onErrorBoundary,
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: (0, $g5lKx.layers).modal()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lqsSp.Popper), {
        referenceElement: referenceElement,
        placement: placement
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: ref,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- positioning controlled by popper
            style: style,
            testId: testId ? `${testId}--mention-popup` : undefined
        }, entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df640aaa5edb6adc$var$PopperContent, {
            entryPointReference: entryPointReference,
            entryPointErrorFallback: entryPointErrorFallback,
            cloudId: cloudId,
            testId: testId,
            agent: agent
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2205s.CardLoading), null))))));
}
module.exports["UserProfileCardForMention"] = $df640aaa5edb6adc$export$b3a703a1f8ebb0c8;

});

parcelRegister("kDHbX", function(module, exports) {
$parcel$export(module.exports, "captureException", () => (parcelRequire("2YBYF")).captureException);
$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("zhyda")).default);

var $2YBYF = parcelRequire("2YBYF");


var $zhyda = parcelRequire("zhyda");


var $7G5lK = parcelRequire("7G5lK");


});

parcelRegister("2YBYF", function(module, exports) {

var $jJdxh = parcelRequire("jJdxh");

const $8a08e7796fbf4a43$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $jJdxh.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $8a08e7796fbf4a43$export$f5282963edea4a68 = (location, error, details = {})=>(0, $jJdxh.default).captureException(location, error, details);
module.exports["captureException"] = $8a08e7796fbf4a43$export$f5282963edea4a68;

});

parcelRegister("jJdxh", function(module, exports) {
// This is the only file that should directly import Raven.

var $805AA = parcelRequire("805AA");

var $k3i2h = parcelRequire("k3i2h");

var $ffG6S = parcelRequire("ffG6S");


var $exBjF = parcelRequire("exBjF");

var $emwrp = parcelRequire("emwrp");

var $6JOHL = parcelRequire("6JOHL");

var $erpTL = parcelRequire("erpTL");


var $da6ky = parcelRequire("da6ky");

const $e63d427485e90328$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $e63d427485e90328$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $e63d427485e90328$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $e63d427485e90328$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $e63d427485e90328$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $k3i2h.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $e63d427485e90328$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$e63d427485e90328$var$getFilteredIntegrations(integrations),
                new $emwrp.Dedupe(),
                new $6JOHL.ExtraErrorData(),
                new $erpTL.Transaction(),
                new $exBjF.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $ffG6S.init({
        ...defaultConfig,
        ...config
    });
    try {
        $805AA.setExtras(getExtraContext());
    } catch (e) {
        $805AA.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $e63d427485e90328$var$tags = [
    'packageName',
    'teamName'
];
const $e63d427485e90328$var$captureException = (location, error, details)=>{
    $805AA.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($e63d427485e90328$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $805AA.captureException(error);
};
const $e63d427485e90328$var$sentryErrorHandler = {
    installGlobalHandler: $e63d427485e90328$var$installGlobalHandler,
    captureException: $e63d427485e90328$var$captureException
};
var $e63d427485e90328$export$2e2bcd8739ae039 = $e63d427485e90328$var$sentryErrorHandler;
module.exports["default"] = $e63d427485e90328$export$2e2bcd8739ae039;

});

parcelRegister("zhyda", function(module, exports) {

var $hwDTW = parcelRequire("hwDTW");


var $1j3sF = parcelRequire("1j3sF");


var $hzZxz = parcelRequire("hzZxz");

var $3C50A = parcelRequire("3C50A");


var $2YBYF = parcelRequire("2YBYF");

let $b0036220825f82c1$var$analyticsClient;
const $b0036220825f82c1$export$d4079397f9611138 = (client)=>{
    $b0036220825f82c1$var$analyticsClient = client;
};
const $b0036220825f82c1$export$bf406c01a195b215 = ()=>{
    $b0036220825f82c1$var$analyticsClient = undefined;
};
const $b0036220825f82c1$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $hzZxz.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($hwDTW))));
        if (event && event.context) {
            const fullEvent = (0, $hzZxz.extractAWCDataFromEvent)(event);
            (0, $2YBYF.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $2YBYF.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $3C50A.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($b0036220825f82c1$var$analyticsClient && $b0036220825f82c1$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $b0036220825f82c1$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $2YBYF.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $b0036220825f82c1$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $b0036220825f82c1$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $b0036220825f82c1$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $b0036220825f82c1$export$2e2bcd8739ae039 = $b0036220825f82c1$var$fireErrorAnalytics;
module.exports["default"] = $b0036220825f82c1$export$2e2bcd8739ae039;

});

parcelRegister("hzZxz", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bHD89 = parcelRequire("bHD89");


var $01od0 = parcelRequire("01od0");

const $50a1a1624abaf5e4$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $01od0.getAnalyticsType)(castedEvent);
    const attributes = (0, $01od0.getAttributes)(castedEvent);
    const source = (0, $01od0.getSource)(castedEvent);
    const actionSubject = (0, $01od0.getActionSubject)(castedEvent);
    if (analyticsType === (0, $bHD89.SCREEN_EVENT_TYPE)) return {
        type: (0, $bHD89.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $bHD89.UI_EVENT_TYPE:
        case 0, $bHD89.TRACK_EVENT_TYPE:
        case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $01od0.getAction)(castedEvent);
                const actionSubjectId = (0, $01od0.getActionSubjectId)(castedEvent);
                const containerId = (0, $01od0.getContainerId)(castedEvent);
                const containerType = (0, $01od0.getContainerType)(castedEvent);
                const objectId = (0, $01od0.getObjectId)(castedEvent);
                const objectType = (0, $01od0.getObjectType)(castedEvent);
                const tags = (0, $01od0.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $50a1a1624abaf5e4$export$1c850cf68c053906;

});

parcelRegister("e7URT", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a48dd4fd18e75a65$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a48dd4fd18e75a65$var$isUndefined;

});

parcelRegister("01od0", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $e7URT = parcelRequire("e7URT");


var $apAFY = parcelRequire("apAFY");


var $lgmus = parcelRequire("lgmus");


var $1j3sF = parcelRequire("1j3sF");


var $da6ky = parcelRequire("da6ky");

const $4b9739432bab74fb$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $4b9739432bab74fb$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $4b9739432bab74fb$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $4b9739432bab74fb$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $4b9739432bab74fb$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $4b9739432bab74fb$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'source').filter(Boolean));
const $4b9739432bab74fb$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $4b9739432bab74fb$export$6ca3170acb89054 = (event)=>event.payload.action;
const $4b9739432bab74fb$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $4b9739432bab74fb$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerId').filter(Boolean));
const $4b9739432bab74fb$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerType').filter(Boolean));
const $4b9739432bab74fb$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectId').filter(Boolean));
const $4b9739432bab74fb$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectType').filter(Boolean));
const $4b9739432bab74fb$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))((0, (/*@__PURE__*/$parcel$interopDefault($5qOzM)))($4b9739432bab74fb$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $4b9739432bab74fb$export$a3569ac53b82a914;
module.exports["getAttributes"] = $4b9739432bab74fb$export$fe94072fee8a6976;
module.exports["getSource"] = $4b9739432bab74fb$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $4b9739432bab74fb$export$6f40cdf6d42c018d;
module.exports["getAction"] = $4b9739432bab74fb$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $4b9739432bab74fb$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $4b9739432bab74fb$export$7c8178cc9001d237;
module.exports["getContainerType"] = $4b9739432bab74fb$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $4b9739432bab74fb$export$fa986b91291934c7;
module.exports["getObjectType"] = $4b9739432bab74fb$export$11cc42aebef2ef3a;
module.exports["getTags"] = $4b9739432bab74fb$export$af63d7414243dad3;

});

parcelRegister("7G5lK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");


var $zhyda = parcelRequire("zhyda");

class $b901a3778c48e0b9$var$CatchAndReportErrors extends (0, $42omo.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $zhyda.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    }
}
const $b901a3778c48e0b9$var$reportingErrorBoundary = (0, $1DWH0.default)()($b901a3778c48e0b9$var$CatchAndReportErrors);
var $b901a3778c48e0b9$export$2e2bcd8739ae039 = $b901a3778c48e0b9$var$reportingErrorBoundary;

});

parcelRegister("7uLCZ", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $4tRVV = parcelRequire("4tRVV");



var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $2HVlJ = parcelRequire("2HVlJ");



var $lPGZG = parcelRequire("lPGZG");


var $dlky5 = parcelRequire("dlky5");

var $575047a4d1f8def0$export$bb38bb9a1161268 = 'unmounted';
var $575047a4d1f8def0$export$84cbff306f539230 = 'exited';
var $575047a4d1f8def0$export$df38205c966be359 = 'entering';
var $575047a4d1f8def0$export$78e9e6e3e014d60a = 'entered';
var $575047a4d1f8def0$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $575047a4d1f8def0$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
                _this.appearStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else initialStatus = $575047a4d1f8def0$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $575047a4d1f8def0$export$bb38bb9a1161268;
        else initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $575047a4d1f8def0$export$bb38bb9a1161268) return {
            status: $575047a4d1f8def0$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $575047a4d1f8def0$export$df38205c966be359 && status !== $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else if (status === $575047a4d1f8def0$export$df38205c966be359 || status === $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $575047a4d1f8def0$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $dlky5.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $575047a4d1f8def0$export$84cbff306f539230) this.setState({
            status: $575047a4d1f8def0$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $575047a4d1f8def0$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $575047a4d1f8def0$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $575047a4d1f8def0$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $575047a4d1f8def0$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $575047a4d1f8def0$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $bDniu.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lPGZG.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
$575047a4d1f8def0$var$Transition.contextType = (0, $lPGZG.default);
$575047a4d1f8def0$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $575047a4d1f8def0$var$noop() {}
$575047a4d1f8def0$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $575047a4d1f8def0$var$noop,
    onEntering: $575047a4d1f8def0$var$noop,
    onEntered: $575047a4d1f8def0$var$noop,
    onExit: $575047a4d1f8def0$var$noop,
    onExiting: $575047a4d1f8def0$var$noop,
    onExited: $575047a4d1f8def0$var$noop
};
$575047a4d1f8def0$var$Transition.UNMOUNTED = $575047a4d1f8def0$export$bb38bb9a1161268;
$575047a4d1f8def0$var$Transition.EXITED = $575047a4d1f8def0$export$84cbff306f539230;
$575047a4d1f8def0$var$Transition.ENTERING = $575047a4d1f8def0$export$df38205c966be359;
$575047a4d1f8def0$var$Transition.ENTERED = $575047a4d1f8def0$export$78e9e6e3e014d60a;
$575047a4d1f8def0$var$Transition.EXITING = $575047a4d1f8def0$export$4aacc83d4d59139f;
var $575047a4d1f8def0$export$2e2bcd8739ae039 = $575047a4d1f8def0$var$Transition;
module.exports["default"] = $575047a4d1f8def0$export$2e2bcd8739ae039;

});

parcelRegister("2HVlJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f8c1559a495fd3f$export$2e2bcd8739ae039);
var $1f8c1559a495fd3f$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("lPGZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe4fb61bd619d593$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var $fe4fb61bd619d593$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);

});

parcelRegister("dlky5", function(module, exports) {
var $9b6d2d196fd1178d$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $9b6d2d196fd1178d$export$7d26bbb1236dafd6;

});

parcelRegister("7QdQz", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /*
  Styles in this file are based on
  packages/editor/editor-core/src/plugins/media/styles.ts
*/ const $18d786e757e244a7$export$a06160db3520e5a2 = 'resizer-item';
const $18d786e757e244a7$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $18d786e757e244a7$export$10b67c6ff1748bd = 'resizer-is-extended';
const $18d786e757e244a7$export$6afc20f0ff6d041 = 'resizer-handle';
const $18d786e757e244a7$export$a5792d7e2a486d41 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-track`;
const $18d786e757e244a7$export$2201bc1aaee73f36 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-thumb`;
const $18d786e757e244a7$export$97a99610b6f0a178 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-danger`;
const $18d786e757e244a7$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $18d786e757e244a7$export$b5fa87f62ced4967 = 3;
const $18d786e757e244a7$export$3d867927ebf9bc1f = 1;
module.exports["resizerItemClassName"] = $18d786e757e244a7$export$a06160db3520e5a2;
module.exports["resizerHoverZoneClassName"] = $18d786e757e244a7$export$c42cdcfd48254bda;
module.exports["resizerExtendedZone"] = $18d786e757e244a7$export$10b67c6ff1748bd;
module.exports["resizerHandleClassName"] = $18d786e757e244a7$export$6afc20f0ff6d041;
module.exports["resizerHandleTrackClassName"] = $18d786e757e244a7$export$a5792d7e2a486d41;
module.exports["resizerHandleThumbClassName"] = $18d786e757e244a7$export$2201bc1aaee73f36;
module.exports["resizerDangerClassName"] = $18d786e757e244a7$export$97a99610b6f0a178;
module.exports["handleWrapperClass"] = $18d786e757e244a7$export$b123b2c8a2536d05;
module.exports["resizerHandleThumbWidth"] = $18d786e757e244a7$export$b5fa87f62ced4967;
module.exports["resizerHandleZIndex"] = $18d786e757e244a7$export$3d867927ebf9bc1f;

});

parcelRegister("7akU4", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $gCTRV = parcelRequire("gCTRV");

const $76978b4203515d8f$export$27292f9d0a2a0aef = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...props,
            ref: ref,
            "data-ssr-content-dom-ref": (0, $eTj7Y.isSSR)() && (0, $gCTRV.isSSRStreaming)() ? "" : undefined
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        ref: ref,
        "data-ssr-content-dom-ref": (0, $eTj7Y.isSSR)() && (0, $gCTRV.isSSRStreaming)() ? '' : undefined
    }));
module.exports["NodeViewContentHole"] = $76978b4203515d8f$export$27292f9d0a2a0aef;

});

parcelRegister("2gkmX", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $eTj7Y = parcelRequire("eTj7Y");

var $gCTRV = parcelRequire("gCTRV");


var $5vVM5 = parcelRequire("5vVM5");


var $7fmpI = parcelRequire("7fmpI");


var $led7c = parcelRequire("led7c");

var $6B1pv = parcelRequire("6B1pv");


var $lWghV = parcelRequire("lWghV");


var $gSnMl = parcelRequire("gSnMl");


var $bT1qC = parcelRequire("bT1qC");


var $7akU4 = parcelRequire("7akU4");

class $1697754dbd6854fe$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init(shouldSkipInitRender = false) {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $6B1pv.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        if (!shouldSkipInitRender) {
            this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
            // During SSR, renderToStaticMarkup + container.innerHTML (in portal) clobbers the
            // contentDOMWrapper that was appended above. The React ref callback
            // (forwardRef) never fires in renderToStaticMarkup, so contentDOM is
            // left detached. Re-attach it by finding the marked SSR ref target.
            if ((0, $eTj7Y.isSSR)() && (0, $gCTRV.isSSRStreaming)() && this.domRef) {
                const refTarget = this.domRef.querySelector('[data-ssr-content-dom-ref]');
                if (refTarget) this.handleRef(refTarget);
            }
        }
        trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Only return reference if domRef is defined
        if (this.domRef === undefined) //raise an error
        throw new Error('domRef is not defined or may have been destroyed');
        // Spreading props to pass through dynamic component props
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $1697754dbd6854fe$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $gSnMl.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $1697754dbd6854fe$export$2e2bcd8739ae039;

});

parcelRegister("gSnMl", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

const $98e7d56f800fed91$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
};
module.exports["generateUniqueNodeKey"] = $98e7d56f800fed91$export$4a323a0542a1e4d1;

});

parcelRegister("bT1qC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $eTj7Y = parcelRequire("eTj7Y");


var $7fmpI = parcelRequire("7fmpI");


var $lWghV = parcelRequire("lWghV");

var $led7c = parcelRequire("led7c");

var $6B1pv = parcelRequire("6B1pv");


var $d7ZU3 = parcelRequire("d7ZU3");


var $TfRUG = parcelRequire("TfRUG");


var $gSnMl = parcelRequire("gSnMl");


var $iEqmY = parcelRequire("iEqmY");

const $8cc71206023006a6$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $8cc71206023006a6$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $8cc71206023006a6$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $8cc71206023006a6$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $6B1pv.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $8cc71206023006a6$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$8cc71206023006a6$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $5SAOw.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $iEqmY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $8cc71206023006a6$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $8cc71206023006a6$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $d7ZU3.getBrowserInfo)().android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $8cc71206023006a6$var$counterPerEditorViewMap = new WeakMap();
function $8cc71206023006a6$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $8cc71206023006a6$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || (0, $eTj7Y.isSSR)()) return $8cc71206023006a6$var$createNodeView(parameters);
        if ((0, $dh538.fg)('platform_editor_inline_node_virt_threshold_override')) return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $8cc71206023006a6$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $8cc71206023006a6$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $8cc71206023006a6$var$createNodeView(parameters);
        return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $8cc71206023006a6$export$17a8c3162956317d;

});

parcelRegister("iEqmY", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $5d9b4 = parcelRequire("5d9b4");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $af3e0b19ba2c5452$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $af3e0b19ba2c5452$export$d73c873f0a6a03c3;

});

parcelRegister("9MZd8", function(module, exports) {
"use strict";
var $720813ee147e427f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $720813ee147e427f$var$__assign = module.exports && module.exports.__assign || function() {
    $720813ee147e427f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $720813ee147e427f$var$__assign.apply(this, arguments);
};
var $720813ee147e427f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $720813ee147e427f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $720813ee147e427f$var$React = $720813ee147e427f$var$__importStar((parcelRequire("42omo")));

var $9QE25 = parcelRequire("9QE25");


var $720813ee147e427f$var$fast_memoize_1 = $720813ee147e427f$var$__importDefault((parcelRequire("hdx2V")));
var $720813ee147e427f$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $720813ee147e427f$var$clamp = $720813ee147e427f$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $720813ee147e427f$var$snap = $720813ee147e427f$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $720813ee147e427f$var$hasDirection = $720813ee147e427f$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $720813ee147e427f$var$findClosestSnap = $720813ee147e427f$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $720813ee147e427f$var$endsWith = $720813ee147e427f$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $720813ee147e427f$var$getStringSize = $720813ee147e427f$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($720813ee147e427f$var$endsWith(n, 'px')) return n;
    if ($720813ee147e427f$var$endsWith(n, '%')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vh')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vw')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vmax')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $720813ee147e427f$var$calculateNewMax = $720813ee147e427f$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $720813ee147e427f$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $720813ee147e427f$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $720813ee147e427f$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $720813ee147e427f$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $720813ee147e427f$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $720813ee147e427f$var$baseClassName = '__resizable_base__';
var $720813ee147e427f$var$Resizable = /** @class */ function(_super) {
    $720813ee147e427f$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $720813ee147e427f$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($720813ee147e427f$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $720813ee147e427f$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($720813ee147e427f$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $720813ee147e427f$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $720813ee147e427f$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $720813ee147e427f$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($720813ee147e427f$var$baseClassName);
        else element.className += $720813ee147e427f$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($720813ee147e427f$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($720813ee147e427f$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($720813ee147e427f$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($720813ee147e427f$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $720813ee147e427f$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $720813ee147e427f$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $720813ee147e427f$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $720813ee147e427f$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $720813ee147e427f$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $720813ee147e427f$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $720813ee147e427f$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $720813ee147e427f$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $720813ee147e427f$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($720813ee147e427f$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($720813ee147e427f$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($720813ee147e427f$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($720813ee147e427f$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($720813ee147e427f$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($720813ee147e427f$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $720813ee147e427f$var$React.createElement($9QE25.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $720813ee147e427f$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($720813ee147e427f$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $720813ee147e427f$var$React.createElement("div", $720813ee147e427f$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $720813ee147e427f$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $720813ee147e427f$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($720813ee147e427f$var$React.PureComponent);
module.exports.Resizable = $720813ee147e427f$var$Resizable;

});

parcelRegister("9QE25", function(module, exports) {
"use strict";
var $72b8060db0128555$var$__assign = module.exports && module.exports.__assign || function() {
    $72b8060db0128555$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $72b8060db0128555$var$__assign.apply(this, arguments);
};
var $72b8060db0128555$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $72b8060db0128555$var$React = $72b8060db0128555$var$__importStar((parcelRequire("42omo")));
var $72b8060db0128555$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $72b8060db0128555$var$Resizer(props) {
    return $72b8060db0128555$var$React.createElement("div", {
        className: props.className || '',
        style: $72b8060db0128555$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $72b8060db0128555$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $72b8060db0128555$var$Resizer;

});

parcelRegister("hdx2V", function(module, exports) {
//
// Main
//
function $c88d48d30306f53a$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $c88d48d30306f53a$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $c88d48d30306f53a$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $c88d48d30306f53a$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $c88d48d30306f53a$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $c88d48d30306f53a$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $c88d48d30306f53a$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c88d48d30306f53a$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c88d48d30306f53a$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $c88d48d30306f53a$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $c88d48d30306f53a$var$monadic : $c88d48d30306f53a$var$variadic;
    return $c88d48d30306f53a$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c88d48d30306f53a$var$strategyVariadic(fn, options) {
    var strategy = $c88d48d30306f53a$var$variadic;
    return $c88d48d30306f53a$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c88d48d30306f53a$var$strategyMonadic(fn, options) {
    var strategy = $c88d48d30306f53a$var$monadic;
    return $c88d48d30306f53a$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $c88d48d30306f53a$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $c88d48d30306f53a$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$c88d48d30306f53a$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$c88d48d30306f53a$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$c88d48d30306f53a$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $c88d48d30306f53a$var$cacheDefault = {
    create: function create() {
        return new $c88d48d30306f53a$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $c88d48d30306f53a$var$memoize;
module.exports.strategies = {
    variadic: $c88d48d30306f53a$var$strategyVariadic,
    monadic: $c88d48d30306f53a$var$strategyMonadic
};

});

parcelRegister("aFv56", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-analytics
 */ const $260a3ee885876edc$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $260a3ee885876edc$export$2e2bcd8739ae039 = $260a3ee885876edc$var$createEventPayload;
module.exports["default"] = $260a3ee885876edc$export$2e2bcd8739ae039;

});

parcelRegister("sXTCx", function(module, exports) {
const $8b92489052cdb314$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $8b92489052cdb314$export$3f072f06b90c3985;

});

parcelRegister("l4JAB", function(module, exports) {
/* eslint-disable compat/compat */ const $1f035c9bfd2157e4$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);
module.exports["runWhenIdle"] = $1f035c9bfd2157e4$export$51d09170c61ebe04;

});

parcelRegister("gJPaw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eWRwJ = parcelRequire("eWRwJ");

var $inPa6 = parcelRequire("inPa6");


var $eIleF = parcelRequire("eIleF");


var $aFv56 = parcelRequire("aFv56");


var $sXTCx = parcelRequire("sXTCx");


var $l4JAB = parcelRequire("l4JAB");


const $ddd2d2f6cc8c3171$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $l4JAB.runWhenIdle)(()=>{
                        (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $l4JAB.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("difjF"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};
module.exports["useSmartLinkLifecycleAnalytics"] = $ddd2d2f6cc8c3171$export$612752b1e088a45e;

});

parcelRegister("difjF", function(module, exports) {

let $9ad8d64c6bd7f38d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ad8d64c6bd7f38d$var$load("hXbzh"),
    $9ad8d64c6bd7f38d$var$load("7j0mT"),
    $9ad8d64c6bd7f38d$var$load("69R9L"),
    $9ad8d64c6bd7f38d$var$load("6cVEd")
]).then(()=>parcelRequire('bSBwg'));

});

parcelRegister("4HPW1", function(module, exports) {

var $f3eID = parcelRequire("f3eID");





const $48cec7a5ea226746$export$75d81fc396e386db = (pos)=>(0, $f3eID.isNumber)(pos.x);
module.exports["isVerticalPosition"] = $48cec7a5ea226746$export$75d81fc396e386db;

});

parcelRegister("f3eID", function(module, exports) {
const $487a105a5241fa4c$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
module.exports["isNumber"] = $487a105a5241fa4c$export$7e4aa119212bc614;

});

parcelRegister("9g7lU", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");

const $10b813166c2c35ba$export$d52a13210f6817c5 = (containerWidth)=>{
    const padding = containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    return Math.min(containerWidth - padding * 2, (0, $aFUXX.akEditorFullWidthLayoutWidth)) / 2;
};
module.exports["getContainerWidthOrFullEditorWidth"] = $10b813166c2c35ba$export$d52a13210f6817c5;

});

parcelRegister("cc99d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0cd8dd83f623ffc8a93c918c96c1a11>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e0db38dacc0710f$var$_react = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("42omo")));

var $8e0db38dacc0710f$var$_baseNew = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8e0db38dacc0710f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e0db38dacc0710f$var$FieldTextIcon = (props)=>/*#__PURE__*/ $8e0db38dacc0710f$var$_react.default.createElement($8e0db38dacc0710f$var$_baseNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$8e0db38dacc0710f$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $8e0db38dacc0710f$var$_default = module.exports.default = $8e0db38dacc0710f$var$FieldTextIcon;

});

parcelRegister("8b5jG", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2daQU = parcelRequire("2daQU");


var $9MZd8 = parcelRequire("9MZd8");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $5duTD = parcelRequire("5duTD");


var $7QdQz = parcelRequire("7QdQz");

const $d4ce0c3cc8105bda$var$resizerLabelStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    bottom: "var(--ds-space-0, 0px)",
    width: '100%',
    overflow: 'visible',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-0, 0px)",
    zIndex: 'layer' // 400 same z-index as the floating toolbar
});
const $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES = [
    'left',
    'right'
];
const $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES_FOR_VERTICAL_RESIZE = [
    'left',
    'right',
    'bottom'
];
const $d4ce0c3cc8105bda$var$inheritedCSS = {
    position: 'inherit',
    height: 'inherit',
    width: 'inherit',
    display: 'inherit',
    flexDirection: 'inherit',
    justifyContent: 'inherit',
    alignItems: 'inherit'
};
const $d4ce0c3cc8105bda$var$ResizerNext = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(94);
    const [isResizing, setIsResizing] = (0, $42omo.useState)(false);
    const resizable = (0, $42omo.useRef)(null);
    const resizeHandleThumbRef = (0, $42omo.useRef)(null);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>({
                getResizerThumbEl () {
                    return resizeHandleThumbRef.current;
                }
            });
        t1 = [
            resizeHandleThumbRef
        ];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useImperativeHandle)(ref, t0, t1);
    let appearance;
    let children;
    let childrenDOMRef;
    let className;
    let handleClassName;
    let handleResize;
    let handleResizeStart;
    let handleResizeStop;
    let handleStyles;
    let handleTooltipContent;
    let height;
    let labelComponent;
    let otherProps;
    let snap;
    let snapGap;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let width;
    if ($[2] !== props) {
        ({ width: width, height: height, children: children, handleClassName: handleClassName, className: className, handleResize: handleResize, handleResizeStart: handleResizeStart, handleResizeStop: handleResizeStop, handleSize: t2, handleAlignmentMethod: t3, handlePositioning: t4, appearance: appearance, handleStyles: handleStyles, resizeRatio: t5, snap: snap, snapGap: snapGap, isHandleVisible: t6, handleHighlight: t7, handleTooltipContent: handleTooltipContent, needExtendedResizeZone: t8, childrenDOMRef: childrenDOMRef, labelComponent: labelComponent, ...otherProps } = props);
        $[2] = props;
        $[3] = appearance;
        $[4] = children;
        $[5] = childrenDOMRef;
        $[6] = className;
        $[7] = handleClassName;
        $[8] = handleResize;
        $[9] = handleResizeStart;
        $[10] = handleResizeStop;
        $[11] = handleStyles;
        $[12] = handleTooltipContent;
        $[13] = height;
        $[14] = labelComponent;
        $[15] = otherProps;
        $[16] = snap;
        $[17] = snapGap;
        $[18] = t2;
        $[19] = t3;
        $[20] = t4;
        $[21] = t5;
        $[22] = t6;
        $[23] = t7;
        $[24] = t8;
        $[25] = width;
    } else {
        appearance = $[3];
        children = $[4];
        childrenDOMRef = $[5];
        className = $[6];
        handleClassName = $[7];
        handleResize = $[8];
        handleResizeStart = $[9];
        handleResizeStop = $[10];
        handleStyles = $[11];
        handleTooltipContent = $[12];
        height = $[13];
        labelComponent = $[14];
        otherProps = $[15];
        snap = $[16];
        snapGap = $[17];
        t2 = $[18];
        t3 = $[19];
        t4 = $[20];
        t5 = $[21];
        t6 = $[22];
        t7 = $[23];
        t8 = $[24];
        width = $[25];
    }
    const handleSize = t2 === undefined ? "medium" : t2;
    const handleAlignmentMethod = t3 === undefined ? "center" : t3;
    const handlePositioning = t4 === undefined ? "overlap" : t4;
    const resizeRatio = t5 === undefined ? 1 : t5;
    const isHandleVisible = t6 === undefined ? false : t6;
    const handleHighlight = t7 === undefined ? "none" : t7;
    const needExtendedResizeZone = t8 === undefined ? true : t8;
    let t9;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $dZ8uq.expValEqualsNoExposure)("cc-maui-experiment", "isEnabled", true) && (0, $1oCLl.expValEquals)("databases-native-embeds-v2", "isEnabled", true);
        $[26] = t9;
    } else t9 = $[26];
    const isDatabasesV2Enabled = t9;
    const supportedHandles = isDatabasesV2Enabled ? $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES_FOR_VERTICAL_RESIZE : $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES;
    let t10;
    if ($[27] !== handleResizeStart) {
        t10 = (event)=>{
            event.preventDefault();
            setIsResizing(true);
            handleResizeStart();
        };
        $[27] = handleResizeStart;
        $[28] = t10;
    } else t10 = $[28];
    const onResizeStart = t10;
    let t11;
    if ($[29] !== handleResize) {
        t11 = (_event, direction, _elementRef, delta)=>{
            if (!handleResize) return;
            const resizableCurrent = resizable.current;
            if (!resizableCurrent || !resizableCurrent.state.original) return;
            const originalState = {
                x: resizableCurrent.state.original.x,
                y: resizableCurrent.state.original.y,
                width: resizableCurrent.state.original.width,
                height: resizableCurrent.state.original.height
            };
            if (isDatabasesV2Enabled) handleResize(originalState, delta, direction);
            else handleResize(originalState, delta);
        };
        $[29] = handleResize;
        $[30] = t11;
    } else t11 = $[30];
    const onResize = t11;
    let t12;
    if ($[31] !== handleResizeStop) {
        t12 = (_event_0, direction_0, _elementRef_0, delta_0)=>{
            const resizableCurrent_0 = resizable.current;
            if (!resizableCurrent_0 || !resizableCurrent_0.state.original) return;
            const originalState_0 = {
                x: resizableCurrent_0.state.original.x,
                y: resizableCurrent_0.state.original.y,
                width: resizableCurrent_0.state.original.width,
                height: resizableCurrent_0.state.original.height
            };
            setIsResizing(false);
            if (isDatabasesV2Enabled) handleResizeStop(originalState_0, delta_0, direction_0);
            else handleResizeStop(originalState_0, delta_0);
        };
        $[31] = handleResizeStop;
        $[32] = t12;
    } else t12 = $[32];
    const onResizeStop = t12;
    let t13;
    if ($[33] !== handleAlignmentMethod || $[34] !== handleClassName || $[35] !== handleSize) {
        t13 = supportedHandles.reduce((result, position)=>({
                ...result,
                [position]: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(handleClassName ?? (0, $7QdQz.resizerHandleClassName), position, handleSize, position === "bottom" && isDatabasesV2Enabled ? undefined : handleAlignmentMethod)
            }), {});
        $[33] = handleAlignmentMethod;
        $[34] = handleClassName;
        $[35] = handleSize;
        $[36] = t13;
    } else t13 = $[36];
    const handles = t13;
    const handleWidth = handlePositioning === "adjacent" ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)";
    const t14 = handlePositioning === "adjacent" ? "center" : undefined;
    let t15;
    if ($[37] !== handlePositioning || $[38] !== handleStyles || $[39] !== handleWidth || $[40] !== t14) {
        const baseHorizontalHandleStyles = {
            width: handleWidth,
            zIndex: (0, $7QdQz.resizerHandleZIndex),
            pointerEvents: "auto",
            alignItems: t14
        };
        const baseBottomHandleStyles = {
            height: handleWidth,
            zIndex: (0, $7QdQz.resizerHandleZIndex),
            pointerEvents: "auto",
            justifyContent: handlePositioning === "adjacent" ? "center" : undefined
        };
        const t16 = handlePositioning === "adjacent" ? "center" : undefined;
        let t17;
        if ($[42] !== handleWidth || $[43] !== t16) {
            t17 = {
                width: handleWidth,
                zIndex: (0, $7QdQz.resizerHandleZIndex),
                pointerEvents: "auto",
                alignItems: t16
            };
            $[42] = handleWidth;
            $[43] = t16;
            $[44] = t17;
        } else t17 = $[44];
        const memoizedBaseHorizontalHandleStyles = t17;
        const t18 = handlePositioning === "adjacent" ? "center" : undefined;
        let t19;
        if ($[45] !== handleWidth || $[46] !== t18) {
            t19 = {
                height: handleWidth,
                zIndex: (0, $7QdQz.resizerHandleZIndex),
                pointerEvents: "auto",
                justifyContent: t18
            };
            $[45] = handleWidth;
            $[46] = t18;
            $[47] = t19;
        } else t19 = $[47];
        const memoizedBaseBottomHandleStyles = t19;
        const offset = handlePositioning === "adjacent" ? `calc(${handleWidth} * -1)` : `calc(${handleWidth} * -0.5)`;
        let t20;
        if ($[48] !== handleStyles || $[49] !== memoizedBaseBottomHandleStyles || $[50] !== memoizedBaseHorizontalHandleStyles || $[51] !== offset) {
            t20 = supportedHandles.reduce((result_0, position_0)=>({
                    ...result_0,
                    [position_0]: {
                        ...position_0 === "bottom" ? memoizedBaseBottomHandleStyles : memoizedBaseHorizontalHandleStyles,
                        [position_0]: offset,
                        ...handleStyles?.[position_0]
                    }
                }), {});
            $[48] = handleStyles;
            $[49] = memoizedBaseBottomHandleStyles;
            $[50] = memoizedBaseHorizontalHandleStyles;
            $[51] = offset;
            $[52] = t20;
        } else t20 = $[52];
        const memoizedNextHandleStyles = t20;
        t15 = (0, $1oCLl.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? memoizedNextHandleStyles : supportedHandles.reduce((result_1, position_1)=>({
                ...result_1,
                [position_1]: {
                    ...position_1 === "bottom" ? baseBottomHandleStyles : baseHorizontalHandleStyles,
                    [position_1]: offset,
                    ...handleStyles?.[position_1]
                }
            }), {});
        $[37] = handlePositioning;
        $[38] = handleStyles;
        $[39] = handleWidth;
        $[40] = t14;
        $[41] = t15;
    } else t15 = $[41];
    const nextHandleStyles = t15;
    const t16 = appearance === "danger";
    let t17;
    if ($[53] !== className || $[54] !== isHandleVisible || $[55] !== isResizing || $[56] !== t16) {
        t17 = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(className, (0, $7QdQz.resizerItemClassName), {
            "is-resizing": isResizing,
            "display-handle": isHandleVisible,
            [(0, $7QdQz.resizerDangerClassName)]: t16
        });
        $[53] = className;
        $[54] = isHandleVisible;
        $[55] = isResizing;
        $[56] = t16;
        $[57] = t17;
    } else t17 = $[57];
    const resizerClassName = t17;
    let t18;
    if ($[58] !== needExtendedResizeZone) {
        t18 = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $7QdQz.resizerHoverZoneClassName), {
            [(0, $7QdQz.resizerExtendedZone)]: needExtendedResizeZone
        });
        $[58] = needExtendedResizeZone;
        $[59] = t18;
    } else t18 = $[59];
    const resizerZoneClassName = t18;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t19;
    if ($[60] !== formatMessage || $[61] !== handleHighlight || $[62] !== handleTooltipContent) {
        t19 = supportedHandles.reduce((result_2, position_2)=>{
            const thumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                className: (0, $7QdQz.resizerHandleThumbClassName),
                "data-testid": `resizer-handle-${position_2}-thumb`,
                "aria-label": formatMessage((0, $5duTD.messages).resizeHandle),
                contentEditable: false,
                ref: resizeHandleThumbRef,
                type: "button",
                tabIndex: -1
            });
            if ((!handleHighlight || handleHighlight === "none") && !handleTooltipContent) return {
                ...result_2,
                [position_2]: thumb
            };
            const thumbWithTrack = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, thumb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $7QdQz.resizerHandleTrackClassName), handleHighlight),
                "data-testid": `resizer-handle-${position_2}-track`
            }));
            if (!!handleTooltipContent) return {
                ...result_2,
                [position_2]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    contentEditable: false,
                    style: $d4ce0c3cc8105bda$var$inheritedCSS
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: handleTooltipContent,
                    hideTooltipOnClick: true,
                    position: "mouse",
                    mousePosition: "auto-start",
                    testId: `resizer-handle-${position_2}-tooltip`
                }, thumbWithTrack))
            };
            return {
                ...result_2,
                [position_2]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    contentEditable: false,
                    style: $d4ce0c3cc8105bda$var$inheritedCSS
                }, thumbWithTrack)
            };
        }, {});
        $[60] = formatMessage;
        $[61] = handleHighlight;
        $[62] = handleTooltipContent;
        $[63] = t19;
    } else t19 = $[63];
    const handleComponent = t19;
    let t20;
    bb0: {
        if (!snap || snap.x?.length === 0 && snap.y?.length === 0) {
            t20 = undefined;
            break bb0;
        }
        t20 = snapGap;
    }
    const snapGapActual = t20;
    const resolvedHeight = isDatabasesV2Enabled ? height ?? "auto" : "auto";
    const t21 = width ?? "auto";
    let t22;
    if ($[64] !== resolvedHeight || $[65] !== t21) {
        t22 = {
            width: t21,
            height: resolvedHeight
        };
        $[64] = resolvedHeight;
        $[65] = t21;
        $[66] = t22;
    } else t22 = $[66];
    const resizerAutoSize = t22;
    let t23;
    if ($[67] !== resizerAutoSize || $[68] !== resolvedHeight || $[69] !== width) {
        t23 = (0, $1oCLl.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? resizerAutoSize : {
            width: width ?? "auto",
            height: resolvedHeight
        };
        $[67] = resizerAutoSize;
        $[68] = resolvedHeight;
        $[69] = width;
        $[70] = t23;
    } else t23 = $[70];
    const resizerSize = t23;
    let t24;
    if ($[71] !== childrenDOMRef) {
        t24 = (ref_0)=>childrenDOMRef && childrenDOMRef(ref_0);
        $[71] = childrenDOMRef;
        $[72] = t24;
    } else t24 = $[72];
    let t25;
    if ($[73] !== children || $[74] !== resizerZoneClassName || $[75] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: resizerZoneClassName,
            ref: t24
        }, children);
        $[73] = children;
        $[74] = resizerZoneClassName;
        $[75] = t24;
        $[76] = t25;
    } else t25 = $[76];
    let t26;
    if ($[77] !== labelComponent) {
        t26 = labelComponent && (0, $iu6m9.editorExperiment)("single_column_layouts", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $d4ce0c3cc8105bda$var$resizerLabelStyles
        }, labelComponent);
        $[77] = labelComponent;
        $[78] = t26;
    } else t26 = $[78];
    let t27;
    if ($[79] !== handleComponent || $[80] !== handles || $[81] !== nextHandleStyles || $[82] !== onResize || $[83] !== onResizeStart || $[84] !== onResizeStop || $[85] !== otherProps || $[86] !== resizeRatio || $[87] !== resizerClassName || $[88] !== resizerSize || $[89] !== snap || $[90] !== snapGapActual || $[91] !== t25 || $[92] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MZd8.Resizable), {
            ref: resizable,
            size: resizerSize,
            className: resizerClassName,
            handleClasses: handles,
            handleWrapperClass: (0, $7QdQz.handleWrapperClass),
            handleStyles: nextHandleStyles,
            onResizeStart: onResizeStart,
            onResize: onResize,
            onResizeStop: onResizeStop,
            resizeRatio: resizeRatio,
            snapGap: snapGapActual,
            snap: snap,
            handleComponent: handleComponent,
            ...otherProps
        }, t25, t26);
        $[79] = handleComponent;
        $[80] = handles;
        $[81] = nextHandleStyles;
        $[82] = onResize;
        $[83] = onResizeStart;
        $[84] = onResizeStop;
        $[85] = otherProps;
        $[86] = resizeRatio;
        $[87] = resizerClassName;
        $[88] = resizerSize;
        $[89] = snap;
        $[90] = snapGapActual;
        $[91] = t25;
        $[92] = t26;
        $[93] = t27;
    } else t27 = $[93];
    return t27;
} : (props, ref)=>{
    const [isResizing, setIsResizing] = (0, $42omo.useState)(false);
    const resizable = (0, $42omo.useRef)(null);
    const resizeHandleThumbRef = (0, $42omo.useRef)(null);
    (0, $42omo.useImperativeHandle)(ref, ()=>{
        return {
            getResizerThumbEl () {
                return resizeHandleThumbRef.current;
            }
        };
    }, [
        resizeHandleThumbRef
    ]);
    const { width: width, height: height, children: children, handleClassName: handleClassName, className: className, handleResize: handleResize, handleResizeStart: handleResizeStart, handleResizeStop: handleResizeStop, handleSize: handleSize = 'medium', handleAlignmentMethod: handleAlignmentMethod = 'center', handlePositioning: handlePositioning = 'overlap', appearance: appearance, handleStyles: handleStyles, resizeRatio: resizeRatio = 1, snap: snap, snapGap: snapGap, isHandleVisible: isHandleVisible = false, handleHighlight: handleHighlight = 'none', handleTooltipContent: handleTooltipContent, needExtendedResizeZone: needExtendedResizeZone = true, childrenDOMRef: childrenDOMRef, labelComponent: labelComponent, ...otherProps } = props;
    const isDatabasesV2Enabled = (0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $1oCLl.expValEquals)('databases-native-embeds-v2', 'isEnabled', true);
    const supportedHandles = isDatabasesV2Enabled ? $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES_FOR_VERTICAL_RESIZE : $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES;
    const onResizeStart = (0, $42omo.useCallback)((event)=>{
        // prevent creating a drag event on Firefox
        event.preventDefault();
        setIsResizing(true);
        handleResizeStart();
    }, [
        handleResizeStart
    ]);
    const onResize = (0, $42omo.useCallback)((_event, direction, _elementRef, delta)=>{
        if (!handleResize) return;
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        if (isDatabasesV2Enabled) handleResize(originalState, delta, direction);
        else handleResize(originalState, delta);
    }, [
        handleResize,
        isDatabasesV2Enabled
    ]);
    const onResizeStop = (0, $42omo.useCallback)((_event_0, direction_0, _elementRef_0, delta_0)=>{
        const resizableCurrent_0 = resizable.current;
        if (!resizableCurrent_0 || !resizableCurrent_0.state.original) return;
        const originalState_0 = {
            x: resizableCurrent_0.state.original.x,
            y: resizableCurrent_0.state.original.y,
            width: resizableCurrent_0.state.original.width,
            height: resizableCurrent_0.state.original.height
        };
        setIsResizing(false);
        if (isDatabasesV2Enabled) handleResizeStop(originalState_0, delta_0, direction_0);
        else handleResizeStop(originalState_0, delta_0);
    }, [
        handleResizeStop,
        isDatabasesV2Enabled
    ]);
    const handles = (0, $42omo.useMemo)(()=>supportedHandles.reduce((result, position)=>({
                ...result,
                [position]: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(handleClassName ?? (0, $7QdQz.resizerHandleClassName), position, handleSize, position === 'bottom' && isDatabasesV2Enabled ? undefined : handleAlignmentMethod)
            }), {}), [
        handleClassName,
        handleSize,
        handleAlignmentMethod,
        supportedHandles,
        isDatabasesV2Enabled
    ]);
    const handleWidth = handlePositioning === 'adjacent' ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)";
    const baseHorizontalHandleStyles = {
        width: handleWidth,
        zIndex: (0, $7QdQz.resizerHandleZIndex),
        pointerEvents: 'auto',
        alignItems: handlePositioning === 'adjacent' ? 'center' : undefined
    };
    const baseBottomHandleStyles = {
        height: handleWidth,
        zIndex: (0, $7QdQz.resizerHandleZIndex),
        pointerEvents: 'auto',
        justifyContent: handlePositioning === 'adjacent' ? 'center' : undefined
    };
    const memoizedBaseHorizontalHandleStyles = (0, $42omo.useMemo)(()=>({
            width: handleWidth,
            zIndex: (0, $7QdQz.resizerHandleZIndex),
            pointerEvents: 'auto',
            alignItems: handlePositioning === 'adjacent' ? 'center' : undefined
        }), [
        handleWidth,
        handlePositioning
    ]);
    const memoizedBaseBottomHandleStyles = (0, $42omo.useMemo)(()=>({
            height: handleWidth,
            zIndex: (0, $7QdQz.resizerHandleZIndex),
            pointerEvents: 'auto',
            justifyContent: handlePositioning === 'adjacent' ? 'center' : undefined
        }), [
        handleWidth,
        handlePositioning
    ]);
    const offset = handlePositioning === 'adjacent' ? `calc(${handleWidth} * -1)` : `calc(${handleWidth} * -0.5)`;
    const memoizedNextHandleStyles = (0, $42omo.useMemo)(()=>supportedHandles.reduce((result_0, position_0)=>({
                ...result_0,
                [position_0]: {
                    ...position_0 === 'bottom' ? memoizedBaseBottomHandleStyles : memoizedBaseHorizontalHandleStyles,
                    [position_0]: offset,
                    ...handleStyles?.[position_0]
                }
            }), {}), [
        memoizedBaseBottomHandleStyles,
        memoizedBaseHorizontalHandleStyles,
        offset,
        handleStyles,
        supportedHandles
    ]);
    const nextHandleStyles = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedNextHandleStyles : // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- intentional fallback for experiment off path
    supportedHandles.reduce((result_1, position_1)=>({
            ...result_1,
            [position_1]: {
                ...position_1 === 'bottom' ? baseBottomHandleStyles : baseHorizontalHandleStyles,
                [position_1]: offset,
                ...handleStyles?.[position_1]
            }
        }), {});
    const resizerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(className, (0, $7QdQz.resizerItemClassName), {
        'is-resizing': isResizing,
        'display-handle': isHandleVisible,
        [(0, $7QdQz.resizerDangerClassName)]: appearance === 'danger'
    });
    const resizerZoneClassName = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $7QdQz.resizerHoverZoneClassName), {
        [(0, $7QdQz.resizerExtendedZone)]: needExtendedResizeZone
    });
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleComponent = (0, $42omo.useMemo)(()=>{
        return supportedHandles.reduce((result_2, position_2)=>{
            const thumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $7QdQz.resizerHandleThumbClassName),
                "data-testid": `resizer-handle-${position_2}-thumb`,
                "aria-label": formatMessage((0, $5duTD.messages).resizeHandle),
                contentEditable: false,
                ref: resizeHandleThumbRef,
                type: "button",
                tabIndex: -1
            });
            if ((!handleHighlight || handleHighlight === 'none') && !handleTooltipContent) return {
                ...result_2,
                [position_2]: thumb
            };
            const thumbWithTrack = //It's important to have {thumb} element before the div, the thumb element is the one that gets focus and only the 1st element recives aria-descibedby attribute which is important for screen reader users
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, thumb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $7QdQz.resizerHandleTrackClassName), handleHighlight),
                "data-testid": `resizer-handle-${position_2}-track`
            }));
            if (!!handleTooltipContent) return {
                ...result_2,
                [position_2]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    contentEditable: false,
                    style: $d4ce0c3cc8105bda$var$inheritedCSS
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: handleTooltipContent,
                    hideTooltipOnClick: true,
                    position: "mouse",
                    mousePosition: "auto-start",
                    testId: `resizer-handle-${position_2}-tooltip`
                }, thumbWithTrack))
            };
            return {
                ...result_2,
                [position_2]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    contentEditable: false,
                    style: $d4ce0c3cc8105bda$var$inheritedCSS
                }, thumbWithTrack)
            };
        }, {});
    }, [
        handleHighlight,
        handleTooltipContent,
        formatMessage,
        supportedHandles
    ]);
    // snapGap is usually a constant, if snap.x?.length is 0 and snapGap has a value resizer cannot be resized
    const snapGapActual = (0, $42omo.useMemo)(()=>{
        if (!snap || snap.x?.length === 0 && snap.y?.length === 0) return undefined;
        return snapGap;
    }, [
        snap,
        snapGap
    ]);
    const resolvedHeight = isDatabasesV2Enabled ? height ?? 'auto' : 'auto';
    const resizerAutoSize = (0, $42omo.useMemo)(()=>({
            width: width ?? 'auto',
            height: resolvedHeight
        }), [
        resolvedHeight,
        width
    ]);
    const resizerSize = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? resizerAutoSize : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    {
        width: width ?? 'auto',
        height: resolvedHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MZd8.Resizable), {
        ref: resizable,
        size: resizerSize,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resizerClassName,
        handleClasses: handles,
        handleWrapperClass: (0, $7QdQz.handleWrapperClass),
        handleStyles: nextHandleStyles,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeStop: onResizeStop,
        resizeRatio: resizeRatio,
        snapGap: snapGapActual,
        snap: snap,
        handleComponent: handleComponent,
        ...otherProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: resizerZoneClassName,
        ref: (ref_0)=>childrenDOMRef && childrenDOMRef(ref_0)
    }, children), labelComponent && (0, $iu6m9.editorExperiment)('single_column_layouts', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d4ce0c3cc8105bda$var$resizerLabelStyles
    }, labelComponent));
};
const $d4ce0c3cc8105bda$var$_default_1 = /*#__PURE__*/ (0, $42omo.forwardRef)($d4ce0c3cc8105bda$var$ResizerNext);
var $d4ce0c3cc8105bda$export$2e2bcd8739ae039 = $d4ce0c3cc8105bda$var$_default_1;
module.exports["default"] = $d4ce0c3cc8105bda$export$2e2bcd8739ae039;

});

parcelRegister("5R7aO", function(module, exports) {

var $iZnNE = parcelRequire("iZnNE");

const $48c4032e291b308c$export$5ea7b9558ea477a = (mediaSingleWidth, snapArray, guidelineSnaps, snapGap = 0)=>{
    const closestGapIndex = snapArray.reduce((prev, curr, index)=>Math.abs(curr - mediaSingleWidth) < Math.abs(snapArray[prev] - mediaSingleWidth) ? index : prev, 0);
    const gap = Math.abs(snapArray[closestGapIndex] - mediaSingleWidth);
    if (gap < snapGap) {
        const snappingWidth = snapArray[closestGapIndex];
        const guidelineKeys = [];
        // find wich guideline have the matching snap width
        guidelineSnaps.forEach((gs)=>{
            if (gs.width === snappingWidth) guidelineKeys.push(gs.guidelineKey);
        });
        const defaultGuidelineKeys = guidelineKeys.filter((guidelineKey)=>!guidelineKey.startsWith((0, $iZnNE.MEDIA_DYNAMIC_GUIDELINE_PREFIX)));
        return {
            gap: gap,
            // only highlight default guidelines
            // when there are both default and dynamic guidelines to be highlighted
            keys: defaultGuidelineKeys.length && defaultGuidelineKeys.length < guidelineKeys.length ? defaultGuidelineKeys : guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};
module.exports["findClosestSnap"] = $48c4032e291b308c$export$5ea7b9558ea477a;

});

parcelRegister("iZnNE", function(module, exports) {
const $24a81e51b8a90adc$export$4ff81dc131aec9c3 = 'media_';
const $24a81e51b8a90adc$export$74e673d6ab2f5668 = 'grid_';
module.exports["MEDIA_DYNAMIC_GUIDELINE_PREFIX"] = $24a81e51b8a90adc$export$4ff81dc131aec9c3;

});

parcelRegister("kz7Zs", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $aFUXX = parcelRequire("aFUXX");


var $h1fR7 = parcelRequire("h1fR7");


var $9g7lU = parcelRequire("9g7lU");

const $f0fea36e9642cf24$var$getDefaultGuidelines = (0, $2XqLN.default)((editorWidth)=>{
    return [
        -6,
        -5,
        -4,
        -3,
        -2,
        -1,
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((val, index)=>({
            key: `grid_${index}`,
            position: {
                x: (0, $h1fR7.roundToNearest)(val / 12 * editorWidth)
            }
        }));
});
const $f0fea36e9642cf24$var$getWideGuidelines = (0, $2XqLN.default)((editorWidth)=>{
    const wideSpacing = (0, $h1fR7.roundToNearest)(editorWidth * (0, $aFUXX.breakoutWideScaleRatio) / 2);
    return [
        {
            key: `wide_left`,
            position: {
                x: -wideSpacing
            }
        },
        {
            key: `wide_right`,
            position: {
                x: wideSpacing
            }
        }
    ];
});
const $f0fea36e9642cf24$var$getFullWidthGuidelines = (0, $2XqLN.default)((containerWidth)=>{
    const fullWidth = (0, $h1fR7.roundToNearest)((0, $9g7lU.getContainerWidthOrFullEditorWidth)(containerWidth));
    return [
        {
            key: `full_width_left`,
            position: {
                x: -fullWidth
            }
        },
        {
            key: `full_width_right`,
            position: {
                x: fullWidth
            }
        }
    ];
});
const $f0fea36e9642cf24$export$9e51f24cdc2ab89d = (editorWidth, containerWidth, isFullWidthMode = false)=>{
    const innerGrids = $f0fea36e9642cf24$var$getDefaultGuidelines(editorWidth);
    const wideGuidelines = !isFullWidthMode ? $f0fea36e9642cf24$var$getWideGuidelines(editorWidth) : [];
    const fullWidthGuidelines = !isFullWidthMode ? $f0fea36e9642cf24$var$getFullWidthGuidelines(containerWidth) : [];
    return [
        ...innerGrids,
        ...wideGuidelines,
        ...fullWidthGuidelines
    ];
};
module.exports["generateDefaultGuidelines"] = $f0fea36e9642cf24$export$9e51f24cdc2ab89d;

});

parcelRegister("h1fR7", function(module, exports) {

var $gAARK = parcelRequire("gAARK");

const $52236a8a8d0f34ae$export$f72673597dacfcfa = (value, interval = (0, $gAARK.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
module.exports["roundToNearest"] = $52236a8a8d0f34ae$export$f72673597dacfcfa;

});

parcelRegister("eR5Wp", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $4HPW1 = parcelRequire("4HPW1");

const $5789695514318adc$export$da9fa72115c158e6 = (0, $2XqLN.default)((guidelines, editorWidth, layout = 'center')=>{
    const offset = editorWidth / 2;
    const getPositionX = (position)=>{
        return (0, $4HPW1.isVerticalPosition)(position) ? position.x : 0;
    };
    const calcXSnaps = (guidelineReference)=>{
        const snapsWidth = guidelineReference.filter((g)=>g.width > 0).map((g)=>g.width);
        const uniqueSnapWidth = [
            ...new Set(snapsWidth)
        ];
        return snapsWidth.length ? uniqueSnapWidth : undefined;
    };
    const guidelinesSnapsReference = guidelines.map((guideline)=>{
        const positionX = getPositionX(guideline.position);
        if ([
            'align-end',
            'wrap-right'
        ].includes(layout)) return {
            guidelineKey: guideline.key,
            width: offset - positionX
        };
        else if ([
            'align-start',
            'wrap-left'
        ].includes(layout)) return {
            guidelineKey: guideline.key,
            width: positionX + offset
        };
        return {
            guidelineKey: guideline.key,
            width: Math.abs(positionX) * 2
        };
    });
    return {
        guidelineReference: guidelinesSnapsReference,
        snaps: {
            x: calcXSnaps(guidelinesSnapsReference)
        }
    };
});
module.exports["getGuidelineSnaps"] = $5789695514318adc$export$da9fa72115c158e6;

});

parcelRegister("6MTPr", function(module, exports) {
const $7d01492d97569010$var$activeGuidelineStyle = (guideline)=>({
        ...guideline,
        active: true,
        show: true
    });
const $7d01492d97569010$export$529f80a31b4cd2ac = (gap, maxGap, activeGuidelineKeys, guidelines)=>{
    if (activeGuidelineKeys.length) return guidelines.map((guideline)=>{
        if (activeGuidelineKeys.includes(guideline.key) && gap < maxGap) return $7d01492d97569010$var$activeGuidelineStyle(guideline);
        return guideline;
    });
    else return guidelines;
};
module.exports["getGuidelinesWithHighlights"] = $7d01492d97569010$export$529f80a31b4cd2ac;

});

parcelRegister("10CSJ", function(module, exports) {

var $42omo = parcelRequire("42omo");



class $330e3eb3197f64f9$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            (parcelRequire("gjMRx")),
            (parcelRequire("2uY23"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
        };
    }
}
$330e3eb3197f64f9$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $330e3eb3197f64f9$export$3ce634ac4a869e2c;

});

parcelRegister("gjMRx", function(module, exports) {

let $be1452be5d27e803$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be1452be5d27e803$var$load("esOWw"),
    $be1452be5d27e803$var$load("hXbzh"),
    $be1452be5d27e803$var$load("8j9XC"),
    $be1452be5d27e803$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("2uY23", function(module, exports) {

let $1d1cf33ab9ed3a1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d1cf33ab9ed3a1c$var$load("8j9XC"),
    $1d1cf33ab9ed3a1c$var$load("esOWw"),
    $1d1cf33ab9ed3a1c$var$load("f35QR"),
    $1d1cf33ab9ed3a1c$var$load("eVYW1"),
    $1d1cf33ab9ed3a1c$var$load("ls0Um"),
    $1d1cf33ab9ed3a1c$var$load("020xd"),
    $1d1cf33ab9ed3a1c$var$load("eTBsW"),
    $1d1cf33ab9ed3a1c$var$load("bYxCZ"),
    $1d1cf33ab9ed3a1c$var$load("6HBYC"),
    $1d1cf33ab9ed3a1c$var$load("eDqo1"),
    $1d1cf33ab9ed3a1c$var$load("lxiFd"),
    $1d1cf33ab9ed3a1c$var$load("1oiJ6"),
    $1d1cf33ab9ed3a1c$var$load("huUvS"),
    $1d1cf33ab9ed3a1c$var$load("dT77m"),
    $1d1cf33ab9ed3a1c$var$load("6vhrJ"),
    $1d1cf33ab9ed3a1c$var$load("fxC6e"),
    $1d1cf33ab9ed3a1c$var$load("hqblC")
]).then(()=>parcelRequire('4rZL5'));

});

parcelRegister("lhT9r", function(module, exports) {

var $42omo = parcelRequire("42omo");




class $d6fdc1f3aa5fd3b7$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) Promise.all([
            (parcelRequire("gjMRx")),
            (parcelRequire("iGdGo")),
            (parcelRequire("gfJu4"))
        ]).then(([mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        }).catch(()=>{
        // TODO [MS-2272]: Add operational error to catch import error
        });
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args);
        this.state = {
            Dropzone: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.displayName = 'AsyncDropzone';
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone = void 0;
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary = void 0;
module.exports["DropzoneLoader"] = $d6fdc1f3aa5fd3b7$export$66201d263cd6342;

});

parcelRegister("iGdGo", function(module, exports) {

let $d996c35cfe5cc1fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d996c35cfe5cc1fb$var$load("8j9XC"),
    $d996c35cfe5cc1fb$var$load("esOWw"),
    $d996c35cfe5cc1fb$var$load("f35QR"),
    $d996c35cfe5cc1fb$var$load("eVYW1"),
    $d996c35cfe5cc1fb$var$load("ls0Um"),
    $d996c35cfe5cc1fb$var$load("020xd"),
    $d996c35cfe5cc1fb$var$load("eTBsW"),
    $d996c35cfe5cc1fb$var$load("bYxCZ"),
    $d996c35cfe5cc1fb$var$load("6HBYC"),
    $d996c35cfe5cc1fb$var$load("eDqo1"),
    $d996c35cfe5cc1fb$var$load("lxiFd"),
    $d996c35cfe5cc1fb$var$load("1oiJ6"),
    $d996c35cfe5cc1fb$var$load("huUvS"),
    $d996c35cfe5cc1fb$var$load("dT77m"),
    $d996c35cfe5cc1fb$var$load("6vhrJ"),
    $d996c35cfe5cc1fb$var$load("fxC6e"),
    $d996c35cfe5cc1fb$var$load("cCWZm")
]).then(()=>parcelRequire('xvLlm'));

});

parcelRegister("gfJu4", function(module, exports) {

let $bd515437e3b43a65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd515437e3b43a65$var$load("lE3cg").then(()=>parcelRequire('dp2qz'));

});

parcelRegister("12Oyv", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");

const $b79e6ddf5e0c34a1$export$881345eb2554ea9e = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls } = t0;
    const wrapperRef = (0, $42omo.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== childComponentSelector || $[1] !== dom || $[2] !== handleEscape || $[3] !== handleFocus || $[4] !== isShortcutToFocusToolbar) {
        t1 = ()=>{
            if (!wrapperRef.current) return;
            const { current: element } = wrapperRef;
            const getFocusableElements = ()=>{
                if (!element) return [];
                const focusableSelectors = [
                    "button:not([disabled])",
                    "[role=\"button\"]:not([disabled])",
                    "[tabindex]:not([tabindex=\"-1\"])"
                ].join(",");
                const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
                return allFocusable.filter((el)=>{
                    if (!el.closest(`${childComponentSelector}`)) return false;
                    let currentEl = el;
                    while(currentEl && currentEl !== element){
                        const computedStyle = window.getComputedStyle(currentEl);
                        if (computedStyle.display === "none" || computedStyle.visibility === "hidden") return false;
                        currentEl = currentEl.parentElement;
                    }
                    return true;
                });
            };
            const moveFocus = (direction)=>{
                const focusableElements = getFocusableElements();
                if (focusableElements.length === 0) return;
                const doc = (0, $hTKp4.getDocument)();
                const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
                let nextIndex;
                if (currentIndex === -1) nextIndex = 0;
                else if (direction === "right") nextIndex = (currentIndex + 1) % focusableElements.length;
                else nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
                focusableElements[nextIndex]?.focus();
            };
            const handleTab = ()=>{
                const focusableElements_0 = getFocusableElements();
                if (focusableElements_0.length === 0) return;
                const doc_0 = (0, $hTKp4.getDocument)();
                let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
                if (index < 0) index = 0;
                focusableElements_0.forEach($b79e6ddf5e0c34a1$var$_temp);
                focusableElements_0[index].setAttribute("tabindex", "0");
            };
            const handleKeyDown = (event)=>{
                const targetElement = event.target;
                if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
                bb86: switch(event.key){
                    case "Escape":
                        handleEscape(event);
                        break bb86;
                    case "ArrowLeft":
                        event.preventDefault();
                        moveFocus("left");
                        break bb86;
                    case "ArrowRight":
                        event.preventDefault();
                        moveFocus("right");
                        break bb86;
                    case "Tab":
                        handleTab();
                        break bb86;
                    default:
                }
            };
            const globalKeyDownHandler = (event_0)=>{
                if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
            };
            element?.addEventListener("keydown", handleKeyDown);
            dom?.addEventListener("keydown", globalKeyDownHandler);
            return ()=>{
                element?.removeEventListener("keydown", handleKeyDown);
                dom?.removeEventListener("keydown", globalKeyDownHandler);
            };
        };
        t2 = [
            wrapperRef,
            childComponentSelector,
            dom,
            isShortcutToFocusToolbar,
            handleFocus,
            handleEscape
        ];
        $[0] = childComponentSelector;
        $[1] = dom;
        $[2] = handleEscape;
        $[3] = handleFocus;
        $[4] = isShortcutToFocusToolbar;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[7] !== ariaControls || $[8] !== ariaLabel || $[9] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: "custom-key-handler-wrapper",
            ref: wrapperRef,
            role: "toolbar",
            "aria-label": ariaLabel,
            "aria-controls": ariaControls
        }, children);
        $[7] = ariaControls;
        $[8] = ariaLabel;
        $[9] = children;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements_0 = getFocusableElements();
            if (focusableElements_0.length === 0) return;
            const doc_0 = (0, $hTKp4.getDocument)();
            let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements_0.forEach((el_2)=>el_2.setAttribute('tabindex', '-1'));
            focusableElements_0[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event_0)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls
    }, children);
};
function $b79e6ddf5e0c34a1$var$_temp(el_2) {
    return el_2.setAttribute("tabindex", "-1");
}
module.exports["ToolbarKeyboardNavigationProvider"] = $b79e6ddf5e0c34a1$export$881345eb2554ea9e;

});

parcelRegister("dTb09", function(module, exports) {
// Shorthand alias for the global cache map key because it's (intentionally) a long name
const $7b24741974f5c34f$var$CACHE_MAP_KEY = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
// Initialize the global cache map once
globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] || new WeakMap();
function $7b24741974f5c34f$export$e328888e5cffce88() {
    globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = new WeakMap();
}
function $7b24741974f5c34f$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $7b24741974f5c34f$export$691e93bad45e6f07;

});

parcelRegister("fseNl", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $38c46137884bb9b4$export$31b2b7ff910ba1f3 = new (0, $ks2lK.PluginKey)('editorToolbarPluginKey');
module.exports["editorToolbarPluginKey"] = $38c46137884bb9b4$export$31b2b7ff910ba1f3;

});

parcelRegister("l7fKC", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $8hoW2 = parcelRequire("8hoW2");


var $9jB2n = parcelRequire("9jB2n");


var $12Oyv = parcelRequire("12Oyv");


var $j0UQK = parcelRequire("j0UQK");

const $a3c14e992c9fdb13$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $a3c14e992c9fdb13$export$4c260019440d418f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { children: children, label: label, actionSubjectId: actionSubjectId, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.toolbar, $a3c14e992c9fdb13$var$styles.toolbarResponsive, $a3c14e992c9fdb13$var$styles.hiddenSelectors, $a3c14e992c9fdb13$var$styles.toolbarSeparator, $a3c14e992c9fdb13$var$styles.hiddenSelectorsPatch);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== actionSubjectId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j0UQK.ViewEventEmitter), {
            actionSubject: (0, $j0UQK.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: actionSubjectId
        });
        $[1] = actionSubjectId;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t1,
            "aria-label": label,
            testId: testId,
            "data-toolbar-type": "inline"
        }, t2, children);
        $[3] = children;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    const toolbar = t3;
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $8hoW2.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        let t4;
        if ($[8] !== ariaControls || $[9] !== ariaLabel || $[10] !== childComponentSelector || $[11] !== dom || $[12] !== handleEscape || $[13] !== handleFocus || $[14] !== isShortcutToFocusToolbar || $[15] !== toolbar) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $12Oyv.ToolbarKeyboardNavigationProvider), {
                childComponentSelector: childComponentSelector,
                dom: dom,
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                handleFocus: handleFocus,
                ariaControls: ariaControls,
                ariaLabel: ariaLabel
            }, toolbar);
            $[8] = ariaControls;
            $[9] = ariaLabel;
            $[10] = childComponentSelector;
            $[11] = dom;
            $[12] = handleEscape;
            $[13] = handleFocus;
            $[14] = isShortcutToFocusToolbar;
            $[15] = toolbar;
            $[16] = t4;
        } else t4 = $[16];
        wrappedToolbar = t4;
    }
    let t4;
    if ($[17] !== wrappedToolbar) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9jB2n.ResponsiveWrapper), null, wrappedToolbar);
        $[17] = wrappedToolbar;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.toolbar, $a3c14e992c9fdb13$var$styles.toolbarResponsive, $a3c14e992c9fdb13$var$styles.hiddenSelectors, $a3c14e992c9fdb13$var$styles.toolbarSeparator, $a3c14e992c9fdb13$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j0UQK.ViewEventEmitter), {
        actionSubject: (0, $j0UQK.ACTION_SUBJECT).TOOLBAR,
        actionSubjectId: actionSubjectId
    }), children);
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $8hoW2.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $12Oyv.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel
        }, toolbar);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9jB2n.ResponsiveWrapper), null, wrappedToolbar);
};
const $a3c14e992c9fdb13$export$7469f9986edfc2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children, label: label, breakpointPreset: breakpointPreset } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar, $a3c14e992c9fdb13$var$styles.hiddenSelectors);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== label) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t1,
            "aria-label": label,
            "data-toolbar-type": "primary"
        }, children);
        $[1] = children;
        $[2] = label;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== breakpointPreset || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9jB2n.ResponsiveContainer), {
            breakpointPreset: breakpointPreset
        }, t2);
        $[4] = breakpointPreset;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, label: label, breakpointPreset: breakpointPreset })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9jB2n.ResponsiveContainer), {
        breakpointPreset: breakpointPreset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar, $a3c14e992c9fdb13$var$styles.hiddenSelectors),
        "aria-label": label,
        "data-toolbar-type": "primary"
    }, children));
};
module.exports["Toolbar"] = $a3c14e992c9fdb13$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $a3c14e992c9fdb13$export$7469f9986edfc2;

});

parcelRegister("9jB2n", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");

const $bc8e1bf6110fb52a$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    responsiveContainerFullPage: "_1bsb1ns9 _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    fullpage: "_luoiglyw _2ojp1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _syrzglyw _fr6v1ule _1je21ule _1btx1ule _biad1ule _1ana1ule",
    fullpageUpdated: "_1nfkglyw _wne21ule _aw2dglyw _1gtx1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _1mri1ule _17b71ule _1btx1ule _gbo31ule",
    reduced: "_kkyiglyw _1dj81ule _1cg81ule _j3qgglyw _xh1i1ule _oj3l1ule _13s9glyw _4nul1ule _wt211ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssue: "_152xglyw _1cn41ule _4cj71ule _afriglyw _ozjb1ule _w81r1ule _1mckglyw _r2nv1ule _1ym01ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssueUpdated: "_152xglyw _1cn41ule _1j4d1ule _1n52glyw _1nd71ule _lf431ule _103bglyw _1p0z1ule _g5yu1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmComment: "_s2iiglyw _o4331ule _1jvu1ule _lankglyw _1xpy1ule _1vu31ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmCommentUpdated: "_s2iiglyw _o4331ule _1u301ule _u7j1glyw _c7al1ule _14ob1ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    confluenceComment: "_15nrglyw _cm5a1ule _7qjy1ule _13ioglyw _8urt1ule _cpaf1ule _18zmglyw _1uj01ule _1oqh1ule _tzm6glyw _ktne1ule _87bn1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $bc8e1bf6110fb52a$var$presetStyleMap = {
    fullpage: $bc8e1bf6110fb52a$var$styles.fullpage,
    reduced: $bc8e1bf6110fb52a$var$styles.reduced,
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssue,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmComment,
    'confluence-comment': $bc8e1bf6110fb52a$var$styles.confluenceComment
};
const $bc8e1bf6110fb52a$var$updatedPresetStyleMap = {
    fullpage: $bc8e1bf6110fb52a$var$styles.fullpageUpdated,
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssueUpdated,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmCommentUpdated
};
const $bc8e1bf6110fb52a$export$e60a4704009a0009 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children, breakpointPreset: breakpointPreset } = t0;
    let t1;
    bb0: {
        if (breakpointPreset === "fullpage") {
            t1 = (0, $dZ8uq.expValEqualsNoExposure)("platform_editor_ai_improve_formatting_toolbar", "isEnabled", true);
            break bb0;
        }
        t1 = (0, $1oCLl.expValEquals)("platform_editor_toolbar_update_jira_config", "isEnabled", true) && breakpointPreset in $bc8e1bf6110fb52a$var$updatedPresetStyleMap;
    }
    const isUpdatedConfig = t1;
    const t2 = breakpointPreset === "fullpage" ? $bc8e1bf6110fb52a$var$styles.responsiveContainerFullPage : $bc8e1bf6110fb52a$var$styles.responsiveContainer;
    const t3 = isUpdatedConfig ? $bc8e1bf6110fb52a$var$updatedPresetStyleMap[breakpointPreset] : $bc8e1bf6110fb52a$var$presetStyleMap[breakpointPreset];
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = (0, $1Whri.cx)(t2, t3);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t4
        }, children);
        $[3] = children;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = (()=>{
        if (breakpointPreset === 'fullpage') return (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_ai_improve_formatting_toolbar', 'isEnabled', true);
        return (0, $1oCLl.expValEquals)('platform_editor_toolbar_update_jira_config', 'isEnabled', true) && breakpointPreset in $bc8e1bf6110fb52a$var$updatedPresetStyleMap;
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(breakpointPreset === 'fullpage' ? $bc8e1bf6110fb52a$var$styles.responsiveContainerFullPage : $bc8e1bf6110fb52a$var$styles.responsiveContainer, isUpdatedConfig ? $bc8e1bf6110fb52a$var$updatedPresetStyleMap[breakpointPreset] : $bc8e1bf6110fb52a$var$presetStyleMap[breakpointPreset])
    }, children);
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $bc8e1bf6110fb52a$export$fa6e408d6a7d6214 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $bc8e1bf6110fb52a$var$styles.responsiveRulesWrapper
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $bc8e1bf6110fb52a$var$styles.responsiveRulesWrapper
    }, children);
};
module.exports["ResponsiveContainer"] = $bc8e1bf6110fb52a$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $bc8e1bf6110fb52a$export$fa6e408d6a7d6214;

});

parcelRegister("j0UQK", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $e7817ef9ea32a2ec$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $e7817ef9ea32a2ec$export$58d0f383acf77599 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { actionSubjectId: actionSubjectId, actionSubject: actionSubject } = t0;
    const isMountedRef = (0, $42omo.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $8hoW2.useToolbarUI)();
    let t1;
    let t2;
    if ($[0] !== actionSubject || $[1] !== actionSubjectId || $[2] !== fireAnalyticsEvent) {
        t1 = ()=>{
            if (isMountedRef.current) return;
            isMountedRef.current = true;
            const payload = {
                action: "viewed",
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                eventType: "ui"
            };
            fireAnalyticsEvent && fireAnalyticsEvent(payload);
        };
        t2 = [
            actionSubjectId,
            actionSubject,
            fireAnalyticsEvent
        ];
        $[0] = actionSubject;
        $[1] = actionSubjectId;
        $[2] = fireAnalyticsEvent;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $42omo.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $8hoW2.useToolbarUI)();
    (0, $42omo.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $e7817ef9ea32a2ec$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $e7817ef9ea32a2ec$export$58d0f383acf77599;

});

parcelRegister("kYvrE", function(module, exports) {

var $3lhEv = parcelRequire("3lhEv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/site/manifest.ts
var $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $3lhEv.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $3lhEv.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $f451cd8c9de7a9df$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $f451cd8c9de7a9df$export$82e6693d75ffdd8;

});

parcelRegister("3lhEv", function(module, exports) {
// src/confluence/site/types.ts
var $26f1069ffd8f654d$export$9e07499cd8b0bde5 = "confluence", $26f1069ffd8f654d$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $26f1069ffd8f654d$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $26f1069ffd8f654d$export$57b7cabbf31f1f68;

});

parcelRegister("744ND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d51e4a53b773461fcacb3f2ef49e80e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $524ca136d29d3c89$var$_react = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("42omo")));

var $524ca136d29d3c89$var$_baseNew = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $524ca136d29d3c89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $524ca136d29d3c89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $524ca136d29d3c89$var$_react.default.createElement($524ca136d29d3c89$var$_baseNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$524ca136d29d3c89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $524ca136d29d3c89$var$_default = module.exports.default = $524ca136d29d3c89$var$WarningOutlineIcon;

});

parcelRegister("2QlXt", function(module, exports) {
class $d18f4572a8af9b70$export$7edca8cfa9634e37 {
    static extractErrorMessage(error) {
        if (error instanceof Error) return $d18f4572a8af9b70$export$7edca8cfa9634e37.redactSensitiveInfo(error.message || 'unknown-error');
        else return $d18f4572a8af9b70$export$7edca8cfa9634e37.redactSensitiveInfo(String(error));
    }
}
$d18f4572a8af9b70$export$7edca8cfa9634e37.redactSensitiveInfo = (str)=>{
    const redacted = str// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
    return redacted;
};
module.exports["ErrorUtils"] = $d18f4572a8af9b70$export$7edca8cfa9634e37;

});

parcelRegister("7ShCl", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $3d55d2ba43147efd$export$480e55f805d7990f = (0, $aXWIB.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askRovoToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.title",
        defaultMessage: "Ask Rovo"
    },
    askRovoToolbarRemixAppTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.title",
        defaultMessage: "Edit"
    },
    askRovoToolbarImageTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.image.title",
        defaultMessage: "Edit image"
    },
    moreRovoOptionsMenuLabel: {
        id: "fabric.editor.ai.toolbar.moreRovoOptions.label",
        defaultMessage: "More Rovo options"
    },
    askRovoAiSplitButtonLabel: {
        id: "fabric.editor.ai.toolbar.askRovoAiSplitButton.label",
        defaultMessage: "Ask Rovo AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    askRovoToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand",
        defaultMessage: "Ask Rovo {key}+'"
    },
    askRovoToolbarRemixAppTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.tooltip.quickCommand",
        defaultMessage: "Edit {key}+'"
    },
    askRovoToolbarImageTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.image.tooltip.quickCommand",
        defaultMessage: "Edit image {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    rovoToolbarDropdownChevronLabel: {
        id: "fabric.editor.ai.toolbar.rovoDropdownChevron.label",
        defaultMessage: "More Ask Rovo options"
    },
    summarizeToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.summarize.title",
        defaultMessage: "Summarize"
    },
    translateToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.translate.title",
        defaultMessage: "Translate"
    },
    translateOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.translateOptions.label",
        defaultMessage: "Translate options"
    },
    spellingAndGrammarToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.spellingAndGrammar.title",
        defaultMessage: "Fix spelling and grammar"
    },
    makeLongerToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeShorterToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeShorter.title",
        defaultMessage: "Make shorter"
    },
    changeToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.changeTone.title",
        defaultMessage: "Change tone"
    },
    changeToneOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.changeToneOptions.title",
        defaultMessage: "Change tone options"
    },
    moreProfessionalToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreProfessionalTone.title",
        defaultMessage: "More professional"
    },
    moreCasualToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreCasualTone.title",
        defaultMessage: "More casual"
    },
    moreEmpatheticToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreEmpatheticTone.title",
        defaultMessage: "More empathetic"
    },
    adjustLengthToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.adjustLength.title",
        defaultMessage: "Adjust length"
    },
    DefineDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.DefineDropdownIconTitle.title",
        defaultMessage: "Define"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    cmdPaletteUnhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage",
        defaultMessage: "We're having issues and can't generate a response right now. Try again later."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    },
    // Telepointer
    aiRovoTelepointer: {
        id: "fabric.editor.ai.telepointer.rovo",
        defaultMessage: "Rovo"
    },
    // On-paste menu messages
    pasteMenuActionsTitle: {
        id: "fabric.editor.ai.paste-menu.section-title",
        defaultMessage: "Actions"
    },
    // Block menu messages
    blockMenuNestedMenuTitle: {
        id: "fabric.editor.ai.config.item.blockMenuNestedMenu.title",
        defaultMessage: "View more actions"
    },
    // Smartlink action messages
    smartlinkListKeyTopics: {
        id: "fabric.editor.ai.smartlink.action.listKeyTopics",
        defaultMessage: "List key topics"
    },
    smartlinkListKeyThemes: {
        id: "fabric.editor.ai.smartlink.action.listKeyThemes",
        defaultMessage: "List key themes"
    },
    smartlinkExtractInsights: {
        id: "fabric.editor.ai.smartlink.action.extractInsights",
        defaultMessage: "Extract insights"
    },
    smartlinkExtractUserQuotes: {
        id: "fabric.editor.ai.smartlink.action.extractUserQuotes",
        defaultMessage: "Extract user quotes"
    },
    smartlinkAddDecisions: {
        id: "fabric.editor.ai.smartlink.action.addDecisions",
        defaultMessage: "Add decisions"
    },
    smartlinkDefineActionItems: {
        id: "fabric.editor.ai.smartlink.action.defineActionItems",
        defaultMessage: "Define action items"
    },
    smartlinkSummarizeChanges: {
        id: "fabric.editor.ai.smartlink.action.summarizeChanges",
        defaultMessage: "Summarize changes"
    },
    smartlinkAddRelatedWorkItems: {
        id: "fabric.editor.ai.smartlink.action.addRelatedWorkItems",
        defaultMessage: "Add related work items"
    },
    smartlinkListTodos: {
        id: "fabric.editor.ai.smartlink.action.listTodos",
        defaultMessage: "List to-dos"
    }
});
module.exports["aiMessages"] = $3d55d2ba43147efd$export$480e55f805d7990f;

});

parcelRegister("ls2Fy", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $aXWIB = parcelRequire("aXWIB");

const $19b135ef0d7ad272$export$21be832820f3e6e6 = (0, $aXWIB.defineMessages)({
    aupViolationMessage: {
        id: "fabric.editor.ai.experience.aupViolationMessage",
        defaultMessage: "Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content."
    },
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    rateLimitEnforced: {
        id: "fabric.editor.ai.experience-application.rateLimitEnforced",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    elevateDisabledGenerateError: {
        id: "fabric.editor.ai.experience.elevateDisabledGenetateError",
        defaultMessage: "Free generate is disabled in Elevate at this time."
    },
    internalServerError: {
        id: "fabric.editor.ai.experience.internalServerError",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    hipaaContentError: {
        id: "fabric.editor.ai.experience.hipaaContentError",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again."
    },
    adfStreamingError: {
        id: "fabric.editor.ai.experience.adfStreamingError",
        defaultMessage: "Our apologies, we couldn't get a response."
    },
    aifcAupViolationMessage: {
        id: "fabric.editor.ai.experience.aifcAupViolationMessage",
        defaultMessage: "Content does not comply with our <link>Acceptable Use Policy</link>."
    },
    aifcApiError: {
        id: "fabric.editor.ai.experience.aifcApiError",
        defaultMessage: "An unknown error occurred."
    },
    aifcApiErrorRetry: {
        id: "fabric.editor.ai.experience.aifcApiErrorRetry",
        defaultMessage: "An unknown error occurred. Please reload and try again."
    },
    aifcTokenLimitExceeded: {
        id: "fabric.editor.ai.experience.aifcTokenLimitExceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    aifcInputTooShortError: {
        id: "fabric.editor.ai.experience.aifcInputTooShortError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    },
    aifcHipaaContentError: {
        id: "fabric.editor.ai.experience.aifcHipaaContentError",
        defaultMessage: "Your content contains links to HIPAA restricted content. Remove links and try again."
    },
    aifcRateLimitEnforced: {
        id: "fabric.editor.ai.experience.aifcRateLimitEnforced",
        defaultMessage: "You\u2019ve reached the <link>maximum number of requests</link>. Try again in 5 minutes."
    },
    aifcInternalServerError: {
        id: "fabric.editor.ai.experience.aifcInternalServerError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response. Try again in 5 minutes or <link>check Rovo status</link>."
    },
    aifcAdfStreamingError: {
        id: "fabric.editor.ai.experience.aifcAdfStreamingError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response."
    },
    noTextualContentError: {
        id: "fabric.editor.ai.experience.noTextualContentError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    }
});
module.exports["aiFailedStateMessages"] = $19b135ef0d7ad272$export$21be832820f3e6e6;

});

parcelRegister("1MUpo", function(module, exports) {
const $72d61fc920bbc248$export$27903d543b563e39 = (attrs)=>(...content)=>({
            type: 'bodiedExtension',
            attrs: attrs,
            content: content
        });
module.exports["bodiedExtension"] = $72d61fc920bbc248$export$27903d543b563e39;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("lesF8", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $6cQbn = parcelRequire("6cQbn");

const $0eec8481dd12dbe1$export$4153d6fbc2386422 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CommentEditor(props) {
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
            ...props,
            appearance: "comment",
            AppearanceComponent: (0, $6cQbn.CommentEditorWithIntl)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function CommentEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $6cQbn.CommentEditorWithIntl)
    });
};
module.exports["CommentEditor"] = $0eec8481dd12dbe1$export$4153d6fbc2386422;

});

parcelRegister("7EEGh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $1PKpt = parcelRequire("1PKpt");

const $c97a308eea576e63$export$5252bd745392dcde = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ChromelessEditor(props) {
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
            ...props,
            appearance: "chromeless",
            AppearanceComponent: (0, $1PKpt.default)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function ChromelessEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $1PKpt.default)
    });
};
module.exports["ChromelessEditor"] = $c97a308eea576e63$export$5252bd745392dcde;

});

parcelRegister("f2DFf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3jQ9y = parcelRequire("3jQ9y");


var $c6GJD = parcelRequire("c6GJD");


var $6qvTD = parcelRequire("6qvTD");

var $8Yt3t = parcelRequire("8Yt3t");


var $dh538 = parcelRequire("dh538");


var $9I1d6 = parcelRequire("9I1d6");


var $iunO7 = parcelRequire("iunO7");


var $9m4TI = parcelRequire("9m4TI");


var $bM5Iz = parcelRequire("bM5Iz");


var $8ALYZ = parcelRequire("8ALYZ");


var $fEQUX = parcelRequire("fEQUX");


var $9odlF = parcelRequire("9odlF");


var $7QA1q = parcelRequire("7QA1q");

/**
 * IDs of experiences that are always enabled regardless of the
 * `platform_native_embeds_rollout_non_maui_experience` feature gate.
 * MauiWhiteboardExperienceManifest is included because it only matches
 * whiteboard URLs with `isRemixDiagram=true` (i.e. diagrams created via the MAUI flow).
 */ const $0da3868ac9bf0e25$var$alwaysEnabledExperienceIds = new Set([
    (0, $bM5Iz.MAUI_EXPERIENCE_MANIFEST_ID),
    (0, $8ALYZ.MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID)
]);
const $0da3868ac9bf0e25$var$allExperiences = [
    (0, $9m4TI.DBEntryExperienceManifest),
    (0, $iunO7.DBExperienceManifest),
    (0, $bM5Iz.MauiExperienceManifest),
    (0, $fEQUX.PageExperienceManifest),
    (0, $9odlF.SlideExperienceManifest),
    // MauiWhiteboardExperienceManifest must come before WhiteboardExperienceManifest
    // so its more specific isUrlMatch (requiring isRemixDiagram=true) is checked first.
    (0, $8ALYZ.MauiWhiteboardExperienceManifest),
    (0, $7QA1q.WhiteboardExperienceManifest)
];
const $0da3868ac9bf0e25$var$gatedExperiences = $0da3868ac9bf0e25$var$allExperiences.map((experience)=>({
        ...experience,
        isUrlMatch: (url)=>{
            if (!(0, $dh538.fg)('platform_native_embeds_rollout_non_maui_experience')) {
                if ($0da3868ac9bf0e25$var$alwaysEnabledExperienceIds.has(experience.id)) return experience.isUrlMatch(url);
                return false;
            }
            return experience.isUrlMatch(url);
        }
    }));
// Register all experience manifests at module-load time.
// This is intentionally module-level (not inside a React lifecycle) because the
// facade must be available before any child embed loads.
(0, $9I1d6.getNativeEmbedFacade)().setup({
    experiences: $0da3868ac9bf0e25$var$gatedExperiences
});
const $0da3868ac9bf0e25$var$buildNativeEmbedParameters = (url, parameterDefaults)=>(0, $8Yt3t.setParameters)({}, {
        url: url,
        alwaysShowTitle: false,
        alignment: (0, $6qvTD.DEFAULT_ALIGNMENT),
        height: 600,
        width: undefined,
        ...parameterDefaults
    });
const $0da3868ac9bf0e25$var$STANDALONE_URL_AUTOCONVERT_EXPERIMENT = 'platform_native_embeds_standalone_url_autoconvert';
const $0da3868ac9bf0e25$var$shouldRequireStandaloneUrlForAutoConvert = ()=>// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- Use dynamic config directly so the paste guard defaults off and can be intentionally rolled out.
    (0, $c6GJD.default).getExperimentValue($0da3868ac9bf0e25$var$STANDALONE_URL_AUTOCONVERT_EXPERIMENT, 'value', false);
const $0da3868ac9bf0e25$var$getStandaloneUrl = (text)=>{
    const url = text.trim();
    // Native embed autoconvert only receives a URL here when the pasted content is exactly one link.
    if (!url || /\s/.test(url)) return undefined;
    try {
        new URL(url);
        return url;
    } catch  {
        return undefined;
    }
};

const $0da3868ac9bf0e25$var$createRenderFn = (isPublishedPage, api, renderOverlay, analyticsPageContext)=>async ()=>{
        const { default: Ui } = await (parcelRequire("iXjoS"));
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Ui, {
                ...props,
                api: api,
                isPublishedPage: isPublishedPage,
                renderOverlay: renderOverlay,
                analyticsPageContext: analyticsPageContext
            });
    };
const $0da3868ac9bf0e25$export$622e7486b3a76ca4 = (isPublishedPage, api, cardClient, renderOverlay, analyticsPageContext)=>{
    // Wire up the CardClient for short-link URL resolution when provided.
    // This is a separate call from setup() because the CardClient may not be
    // available at module-load time when setup() is called.
    if (cardClient) (0, $9I1d6.getNativeEmbedFacade)().setCardClient(cardClient);
    return {
        title: 'Native Embed',
        type: (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE),
        key: (0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY),
        description: 'Embed native Atlassian content',
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: $0da3868ac9bf0e25$var$createRenderFn(isPublishedPage, api, renderOverlay, analyticsPageContext),
                    // @ts-expect-error This option is experimental and not reflected in the manifest type definition
                    __hideFrame: true
                },
                ...Object.fromEntries((0, $9I1d6.getNativeEmbedFacade)().getAllExperienceIds().map((experienceId)=>[
                        experienceId,
                        {
                            type: 'extension',
                            render: $0da3868ac9bf0e25$var$createRenderFn(isPublishedPage, api, renderOverlay, analyticsPageContext),
                            __hideFrame: true
                        }
                    ]))
            },
            autoConvert: {
                url: [
                    (text)=>{
                        const url = $0da3868ac9bf0e25$var$shouldRequireStandaloneUrlForAutoConvert() ? $0da3868ac9bf0e25$var$getStandaloneUrl(text) : text;
                        if (!url) return undefined;
                        // Check if URL matches any registered experience patterns
                        const experienceId = (0, $9I1d6.getNativeEmbedFacade)().getExperienceIdFromUrl(url);
                        if (experienceId) {
                            // Check if this experience should auto-convert to native embed
                            const manifest = (0, $9I1d6.getNativeEmbedFacade)().getManifestByUrl(url);
                            if (!manifest || manifest.shouldAutoConvertToNativeEmbed !== true) // Return undefined to allow smart link handling instead
                            return undefined;
                            return {
                                type: 'extension',
                                attrs: {
                                    extensionKey: `${0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY}:${experienceId}`,
                                    extensionType: (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE),
                                    parameters: $0da3868ac9bf0e25$var$buildNativeEmbedParameters(url, manifest?.parameterDefaults)
                                }
                            };
                        }
                        // Return undefined if URL doesn't match - handled by smart links instead.
                        return undefined;
                    }
                ]
            }
        }
    };
};
module.exports["createManifest"] = $0da3868ac9bf0e25$export$622e7486b3a76ca4;

});

parcelRegister("6qvTD", function(module, exports) {
const $10cd02f6187de47c$export$cc438a848c487501 = 'nativeEmbedDepth';
const $10cd02f6187de47c$export$8de1a2f5887e1625 = 2;
const $10cd02f6187de47c$export$5deb91d6dd3decbb = ()=>{
    if (typeof window === 'undefined') return 0;
    const raw = new URLSearchParams(window.location.search).get($10cd02f6187de47c$export$cc438a848c487501);
    if (raw === null) return 0;
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed >= 0 ? Math.floor(parsed) : 0;
};
const $10cd02f6187de47c$export$de0f33c023e33ebd = [
    'left',
    'center',
    'right',
    'wrap-left',
    'wrap-right'
];
const $10cd02f6187de47c$export$11a9886c2819741 = 'center';
const $10cd02f6187de47c$export$1770a45a9210903c = {
    url: undefined,
    alwaysShowTitle: false,
    alignment: $10cd02f6187de47c$export$11a9886c2819741,
    borderColor: undefined,
    borderSize: undefined,
    displayText: undefined,
    height: 600,
    aspectRatio: 1,
    width: undefined
};
const $10cd02f6187de47c$export$98d307a8fd081b69 = {
    ASK_ROVO: 'askRovo',
    REMIX_VARIANT: 'remixVariant',
    SUMMARISE: 'summarise',
    REFRESH: 'refresh',
    EDIT: 'edit',
    EMBED: 'embed',
    BORDER: 'border',
    ALIGNMENT: 'alignment',
    OPEN_IN_NEW_WINDOW: 'openInNewWindow',
    /** Opens the embed's fullscreen preview dialog. */ EXPAND: 'expand',
    EDIT_URL: 'editUrl',
    ALWAYS_SHOW_TITLE: 'alwaysShowTitle',
    SET_EMBED_TYPE: 'setEmbedType',
    /**
	 * Copies the native-embed node to the clipboard.
	 */ COPY: 'copy',
    /**
	 * @private
	 * @deprecated Use `COPY` instead. `COPY_LINK` is a deprecated alias for `COPY` and will be removed in a future release.
	 */ COPY_LINK: 'copyLink',
    DELETE: 'delete',
    SEPARATOR: 'separator'
};
const $10cd02f6187de47c$export$8637b4cdcb7cc177 = [
    'onAlignmentClick',
    'onAppearanceClick',
    'onAskRovoClick',
    'onSummariseClick',
    'onChangeBorderClick',
    'onCopyClick',
    'onCopyLinkClick',
    'onDeleteClick',
    'onEditClick',
    'onEditUrlClick',
    'onExpandClick',
    'onOpenInNewWindowClick',
    'onRefreshClick',
    'onSetEmbedTypeClick',
    'onShowTitleClick'
];
module.exports["EMBED_DEPTH_QUERY_PARAM"] = $10cd02f6187de47c$export$cc438a848c487501;
module.exports["MAX_EMBED_DEPTH"] = $10cd02f6187de47c$export$8de1a2f5887e1625;
module.exports["getCurrentEmbedDepth"] = $10cd02f6187de47c$export$5deb91d6dd3decbb;
module.exports["ALIGNMENT_VALUES"] = $10cd02f6187de47c$export$de0f33c023e33ebd;
module.exports["DEFAULT_ALIGNMENT"] = $10cd02f6187de47c$export$11a9886c2819741;
module.exports["NATIVE_EMBED_PARAMETER_DEFAULTS"] = $10cd02f6187de47c$export$1770a45a9210903c;
module.exports["BUILTIN_TOOLBAR_KEYS"] = $10cd02f6187de47c$export$98d307a8fd081b69;
module.exports["EDITOR_TOOLBAR_HANDLER_KEYS"] = $10cd02f6187de47c$export$8637b4cdcb7cc177;

});

parcelRegister("8Yt3t", function(module, exports) {

var $6qvTD = parcelRequire("6qvTD");

const $632e855fbbf69945$var$getMacroParamsRecord = (parameters)=>{
    if (!parameters?.macroParams || typeof parameters.macroParams !== 'object') return {};
    return parameters.macroParams;
};
const $632e855fbbf69945$var$unwrapMacroParamValue = (macroParamValue)=>{
    if (macroParamValue && typeof macroParamValue === 'object' && 'value' in macroParamValue) return macroParamValue.value;
    return macroParamValue;
};
const $632e855fbbf69945$var$PARAMETER_VALIDATORS = {
    alignment: (value)=>(0, $6qvTD.ALIGNMENT_VALUES).includes(value)
};
/**
 * Explicitly declares the intended primitive type for each parameter key.
 * This is necessary for keys whose default value is `undefined` (e.g. `url`, `width`),
 * because `typeof undefined === 'undefined'` gives no type information for deserialization.
 */ const $632e855fbbf69945$var$PARAMETER_TYPES = {
    alignment: 'string',
    alwaysShowTitle: 'boolean',
    aspectRatio: 'number',
    borderColor: 'string',
    borderSize: 'number',
    displayText: 'string',
    height: 'number',
    url: 'string',
    width: 'number'
};
const $632e855fbbf69945$var$parseFromDefault = (defaultValue, value, explicitType)=>{
    const resolvedType = explicitType ?? typeof defaultValue;
    if (resolvedType === 'boolean') {
        if (typeof value === 'boolean') return value;
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
    if (resolvedType === 'number') {
        const parsed = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
        return Number.isFinite(parsed) ? parsed : undefined;
    }
    // String-like values
    return typeof value === 'string' ? value : undefined;
};
const $632e855fbbf69945$var$serializeParameterValue = (key, value)=>{
    const validator = $632e855fbbf69945$var$PARAMETER_VALIDATORS[key];
    if (validator && !validator(value)) return undefined;
    return value === undefined ? undefined : String(value);
};
const $632e855fbbf69945$var$deserializeParameterValue = (key, value)=>{
    const parsedValue = $632e855fbbf69945$var$parseFromDefault((0, $6qvTD.NATIVE_EMBED_PARAMETER_DEFAULTS)[key], value, $632e855fbbf69945$var$PARAMETER_TYPES[key]);
    const validator = $632e855fbbf69945$var$PARAMETER_VALIDATORS[key];
    if (parsedValue === undefined) return undefined;
    if (validator && !validator(parsedValue)) return undefined;
    return parsedValue;
};
const $632e855fbbf69945$export$c77521bc1ca83dcc = (parameters, key)=>{
    const macroParams = $632e855fbbf69945$var$getMacroParamsRecord(parameters);
    if (!(key in macroParams)) return (0, $6qvTD.NATIVE_EMBED_PARAMETER_DEFAULTS)[key];
    const value = $632e855fbbf69945$var$unwrapMacroParamValue(macroParams[key]);
    const parsedValue = $632e855fbbf69945$var$deserializeParameterValue(key, value);
    return parsedValue === undefined ? (0, $6qvTD.NATIVE_EMBED_PARAMETER_DEFAULTS)[key] : parsedValue;
};
function $632e855fbbf69945$export$1d5e65f36fbcdb49(parameters, key) {
    if (key) return $632e855fbbf69945$export$c77521bc1ca83dcc(parameters, key);
    return Object.fromEntries(Object.keys((0, $6qvTD.NATIVE_EMBED_PARAMETER_DEFAULTS)).map((defaultKey)=>[
            defaultKey,
            $632e855fbbf69945$export$c77521bc1ca83dcc(parameters, defaultKey)
        ]));
}
const $632e855fbbf69945$export$98091b65241a3a6 = (parameters, update)=>{
    return $632e855fbbf69945$export$60752c4a8a24d484(parameters, update);
};
const $632e855fbbf69945$export$60752c4a8a24d484 = (parameters, updates)=>{
    const currentParameters = parameters ?? {};
    const currentMacroParams = $632e855fbbf69945$var$getMacroParamsRecord(parameters);
    const wrappedUpdates = Object.fromEntries(Object.entries(updates).map(([key, value])=>[
            key,
            $632e855fbbf69945$var$serializeParameterValue(key, value)
        ]).filter(([, value])=>value !== undefined).map(([key, value])=>[
            key,
            {
                value: value
            }
        ]));
    return {
        ...currentParameters,
        macroParams: {
            ...currentMacroParams,
            ...wrappedUpdates
        }
    };
};
const $632e855fbbf69945$export$46a0fc3fddbe8c3b = (config)=>config;
module.exports["getParameter"] = $632e855fbbf69945$export$c77521bc1ca83dcc;
module.exports["getParameters"] = $632e855fbbf69945$export$1d5e65f36fbcdb49;
module.exports["setParameter"] = $632e855fbbf69945$export$98091b65241a3a6;
module.exports["setParameters"] = $632e855fbbf69945$export$60752c4a8a24d484;
module.exports["createEditorToolbarActions"] = $632e855fbbf69945$export$46a0fc3fddbe8c3b;

});

parcelRegister("9I1d6", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $gUq9X = parcelRequire("gUq9X");


var $i5z7u = parcelRequire("i5z7u");

/**
 * Matches Confluence short-link URLs of the form /wiki/x/<token>.
 * These URLs do not map to a specific experience until resolved via ORS.
 */ const $94dbcd51291b69b2$var$CONFLUENCE_SHORT_LINK_PATTERN = /\/wiki\/x\/[^/]+/;
let $94dbcd51291b69b2$var$nativeEmbedFacade;
function $94dbcd51291b69b2$export$31739795deb20347() {
    if (!$94dbcd51291b69b2$var$nativeEmbedFacade) $94dbcd51291b69b2$var$nativeEmbedFacade = new $94dbcd51291b69b2$export$3aace7af5e09b157((0, $gUq9X.getExperienceManifestRegistry)(), (0, $i5z7u.getSurfaceService)());
    return $94dbcd51291b69b2$var$nativeEmbedFacade;
}



class $94dbcd51291b69b2$export$3aace7af5e09b157 {
    /**
   * Registers an experience manifest so it can be matched by URL via {@link resolveManifestForUrl}.
   */ registerExperienceManifest(manifest) {
        this.experienceManifestRegistry.registerExperienceManifest(manifest);
    }
    /**
   * One-shot convenience method that registers experience manifests and
   * optionally configures the host surface in a single call.
   *
   * Prefer `setup()` over calling `registerExperienceManifest` /
   * `setSurface` individually — it makes the configuration declarative,
   * validates inputs eagerly, and guards against accidental double-setup.
   *
   * The low-level methods remain available for advanced use cases
   * (conditional registration, dynamic surface changes, etc.).
   *
   * @param config - The setup configuration.
   * @param config.experiences - Non-empty array of experience manifests to register.
   * @param config.surface - Optional surface configuration.
   *
   * Logs a warning and returns early if `setup()` has already been called.
   *
   * @example
   * ```ts
   * import { getNativeEmbedFacade } from '@atlassian/native-embeds-core';
   *
   * getNativeEmbedFacade().setup({
   *   experiences: [WhiteboardExperienceManifest, DBExperienceManifest],
   * });
   * ```
   */ setup(config) {
        if (this.isSetUp) {
            // eslint-disable-next-line no-console
            console.warn("NativeEmbedFacade.setup() has already been called. This call will be ignored. Use the low-level registerExperienceManifest() and setSurface() methods if you need to modify configuration after initial setup.");
            return;
        }
        for (const manifest of config.experiences)this.registerExperienceManifest(manifest);
        if (config.surface) this.setSurface(config.surface);
        if (config.cardClient) this.cardClient = config.cardClient;
        this.isSetUp = true;
    }
    /**
   * Sets the {@link CardClient} instance used for short-link URL resolution.
   *
   * This is useful when the `CardClient` is not available at the time `setup()`
   * is called (e.g. when the facade is initialised at module-load time before
   * the card provider is ready). Calling this after `setup()` replaces any
   * previously configured client.
   *
   * @param cardClient - The CardClient instance to use for ORS requests.
   */ setCardClient(cardClient) {
        this.cardClient = cardClient;
    }
    /**
   * Synchronous function that verifies if the URL matches any registered experience, and returns the experience ID if it does.
   * @param url - The URL to get the experience from.
   * @returns
   */ getExperienceIdFromUrl(url) {
        return this.experienceManifestRegistry.getExperienceIdFromUrl(url);
    }
    /**
   * Async variant of {@link getExperienceIdFromUrl} that handles Confluence
   * short-link URLs (e.g. `/wiki/x/<token>`).
   *
   * When the URL is a Confluence short link and a `cardClient` has been
   * configured (via `setup({ cardClient })` or `setCardClient()`), this method
   * resolves the short link to its canonical URL via the Object Resolver
   * Service and then matches the expanded URL against registered experience
   * manifests.
   *
   * Falls back to the synchronous {@link getExperienceIdFromUrl} for all
   * non-short-link URLs, or when no `cardClient` is available.
   *
   * @param url - The URL to resolve and match.
   * @returns The matched experience manifest ID, or `undefined` if no match.
   */ async getExperienceIdFromUrlAsync(url) {
        // Fast path: direct synchronous match (works for all non-short-link URLs)
        const syncResult = this.experienceManifestRegistry.getExperienceIdFromUrl(url);
        if (syncResult) return syncResult;
        // Expand Confluence short links via ORS when a cardClient is available
        const expandedUrl = await this.expandShortLink(url);
        if (!expandedUrl) return undefined;
        return this.experienceManifestRegistry.getExperienceIdFromUrl(expandedUrl);
    }
    /**
   * If `url` is a Confluence short link and a `cardClient` is configured,
   * resolves it to its canonical expanded URL via the Object Resolver Service.
   *
   * Returns `undefined` when:
   * - the feature gate `platform_native_embeds_rollout_non_maui_experience` is off,
   * - the URL is not a short link,
   * - no `cardClient` is available, or
   * - resolution fails or returns the same URL.
   */ async expandShortLink(url) {
        if (!(0, $dh538.fg)('platform_native_embeds_rollout_non_maui_experience')) return undefined;
        const isShortLink = $94dbcd51291b69b2$var$CONFLUENCE_SHORT_LINK_PATTERN.test(url);
        if (!isShortLink || !this.cardClient) return undefined;
        try {
            const response = await this.cardClient.fetchData(url);
            const data = response?.data;
            if (!data || typeof data !== 'object') return undefined;
            const resolvedUrl = data['url'];
            if (typeof resolvedUrl === 'string' && resolvedUrl !== url) return resolvedUrl;
            // url can also be an object with an @id (JsonLd Link type)
            if (resolvedUrl && typeof resolvedUrl === 'object') {
                const id = resolvedUrl['@id'];
                if (typeof id === 'string' && id !== url) return id;
            }
        } catch  {
        // Short-link expansion is best-effort; fall through to return undefined.
        }
        return undefined;
    }
    /**
   * Synchronous function that returns the manifest for a URL if it matches any registered experience.
   * Uses `isUrlMatch` to find the matching manifest.
   * @param url - The URL to get the manifest for.
   * @returns The matching manifest, or undefined if no match is found.
   */ getManifestByUrl(url) {
        return this.experienceManifestRegistry.getManifestByUrl(url);
    }
    /**
   * Synchronous function that returns the manifest for a given experience ID.
   * @param id - The experience manifest ID to look up.
   * @returns The matching manifest, or undefined if no match is found.
   */ getManifestById(id) {
        return this.experienceManifestRegistry.getManifestById(id);
    }
    /**
   * Returns a list of all registered experience IDs.
   */ getAllExperienceIds() {
        return this.experienceManifestRegistry.getAllExperienceIds();
    }
    /**
   * Register or replace the active host surface.
   *
   * The surface provides capabilities that differ per host (editor, renderer,
   * etc.). The {@link Surface} interface will grow as new surface concerns
   * are identified.
   *
   * - Replaces any previously registered surface (last-write-wins).
   * - Pass `null` to clear the surface (e.g. on unmount).
   *
   * @param surface - The surface configuration, or `null` to clear.
   */ setSurface(surface) {
        this.surfaceService.setSurface(surface);
    }
    /**
   * Finds the matching manifest for a URL and creates an experience.
   * Title metadata will be resolved later by Smart Card.
   *
   * When the URL is a Confluence short link (e.g. `/wiki/x/<token>`) and a
   * `cardClient` has been configured, the short link is expanded to its
   * canonical URL via the Object Resolver Service before manifest matching.
   * The experience is created with the expanded URL.
   */ async createExperienceForUrl(url) {
        // Reject non-URL strings early. macroParams.url may contain prose text
        // with an embedded link rather than a bare URL (e.g. after a bad paste).
        try {
            new URL(url);
        } catch  {
            return undefined;
        }
        const resolvedUrl = await this.expandShortLink(url) ?? url;
        const manifest = this.experienceManifestRegistry.getManifestByUrl(resolvedUrl);
        if (!manifest) return undefined;
        const urlMeta = {
            url: resolvedUrl,
            title: ''
        };
        // Lazy import — ExperienceService transitively pulls in
        // rovo-content-bridge-api which uses uuid/randomBytes. Keeping it out of
        // the static import graph prevents the SSR pre-compile crash.
        const { getExperienceService: getExperienceService } = await (parcelRequire("4gm1U"));
        const experience = getExperienceService().registerExperience({
            manifest: manifest,
            urlMeta: urlMeta
        });
        return {
            experience: experience,
            manifest: manifest
        };
    }
    /**
   * Unregister an experience and dispose its event listeners.
   *
   * Call when the embed is removed from the host surface (e.g. editor node
   * deleted, component unmount). This prevents memory leaks from stale
   * listener references.
   *
   * Safe to call with an ID that was never registered — it's a no-op.
   */ async destroyExperience(experienceId) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("4gm1U"));
        getExperienceService().unregisterExperience(experienceId);
    }
    /** Notify the child embed that its selection state changed. */ async sendSelectedChange(experienceId, selected) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("4gm1U"));
        getExperienceService().sendSelectedChange(experienceId, selected);
    }
    constructor(experienceManifestRegistry, surfaceService){
        this.experienceManifestRegistry = void 0;
        this.surfaceService = void 0;
        this.cardClient = void 0;
        this.isSetUp = false;
        this.experienceManifestRegistry = experienceManifestRegistry;
        this.surfaceService = surfaceService;
    }
}
module.exports["getNativeEmbedFacade"] = $94dbcd51291b69b2$export$31739795deb20347;

});

parcelRegister("gUq9X", function(module, exports) {
let $3dd987877b517ef9$var$experienceService;
function $3dd987877b517ef9$export$1b2983209f90e067() {
    if ($3dd987877b517ef9$var$experienceService) return $3dd987877b517ef9$var$experienceService;
    $3dd987877b517ef9$var$experienceService = new $3dd987877b517ef9$export$21c7ca9c95b7ce6b();
    return $3dd987877b517ef9$var$experienceService;
}
class $3dd987877b517ef9$export$21c7ca9c95b7ce6b {
    registerExperienceManifest(experienceManifest) {
        this.experienceManifests.push(experienceManifest);
    }
    safeIsUrlMatch(experience, url) {
        try {
            return experience.isUrlMatch(url);
        } catch  {
            return false;
        }
    }
    getExperienceIdFromUrl(url) {
        return this.experienceManifests.find((experience)=>this.safeIsUrlMatch(experience, url))?.id;
    }
    getManifestByUrl(url) {
        return this.experienceManifests.find((experience)=>this.safeIsUrlMatch(experience, url));
    }
    getManifestById(id) {
        return this.experienceManifests.find((experience)=>experience.id === id);
    }
    getAllExperienceIds() {
        return this.experienceManifests.map((experience)=>experience.id);
    }
    async getExperienceById(id) {
        return this.experienceManifests.find((experience)=>experience.id === id);
    }
    constructor(){
        this.experienceManifests = [];
    }
}
module.exports["getExperienceManifestRegistry"] = $3dd987877b517ef9$export$1b2983209f90e067;

});

parcelRegister("i5z7u", function(module, exports) {
let $b81e40131903687f$var$surfaceServiceInstance;
function $b81e40131903687f$export$a019fb3db45daa2b() {
    if (!$b81e40131903687f$var$surfaceServiceInstance) $b81e40131903687f$var$surfaceServiceInstance = new $b81e40131903687f$export$f9308bd8ae7f0c97();
    return $b81e40131903687f$var$surfaceServiceInstance;
}
class $b81e40131903687f$export$f9308bd8ae7f0c97 {
    /**
   * Register or replace the active host surface.
   *
   * @param surface - The surface configuration, or `null` to clear.
   */ setSurface(surface) {
        this._surface = surface;
    }
    /**
   * Returns the currently active surface, or `null` if none is set.
   */ getSurface() {
        return this._surface;
    }
    constructor(){
        this._surface = null;
    }
}
module.exports["getSurfaceService"] = $b81e40131903687f$export$a019fb3db45daa2b;

});

parcelRegister("4gm1U", function(module, exports) {

let $31a9beb14cd8327a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31a9beb14cd8327a$var$load("iRTKR").then(()=>parcelRequire('gj81t'));

});

parcelRegister("iunO7", function(module, exports) {

var $8Yt3t = parcelRequire("8Yt3t");


var $dMSEk = parcelRequire("dMSEk");


var $lTT6U = parcelRequire("lTT6U");

const $189b4f079483e237$export$6dc7663b60a7f493 = (0, $dMSEk.experienceManifestId)('database');
const $189b4f079483e237$var$isDatabaseUrl = (url)=>{
    return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/) !== null;
};
const $189b4f079483e237$var$isDatabaseEntryUrl = (url)=>{
    try {
        return $189b4f079483e237$var$isDatabaseUrl(url) && new URL(url).searchParams.has('entryId');
    } catch  {
        return false;
    }
};
const $189b4f079483e237$var$isDatabaseNonEntryUrl = (url)=>{
    return $189b4f079483e237$var$isDatabaseUrl(url) && !$189b4f079483e237$var$isDatabaseEntryUrl(url);
};
const $189b4f079483e237$export$3db4c20f17f55c0a = {
    ...(0, $lTT6U.dbSharedManifestFields),
    id: $189b4f079483e237$export$6dc7663b60a7f493,
    isUrlMatch: $189b4f079483e237$var$isDatabaseNonEntryUrl,
    parameterDefaults: {
        alwaysShowTitle: true
    },
    uiConfig: {
        ...(0, $lTT6U.dbSharedUiConfig),
        editorToolbarActions: ()=>(0, $8Yt3t.createEditorToolbarActions)({
                items: [
                    ...(0, $lTT6U.getDbToolbarItems)()
                ],
                moreItems: (0, $lTT6U.dbMoreItems)
            })
    }
};
module.exports["DBExperienceManifest"] = $189b4f079483e237$export$3db4c20f17f55c0a;

});

parcelRegister("dMSEk", function(module, exports) {
const $c11d54150f019f2a$export$32c943c51c185af3 = (s)=>s;
module.exports["experienceManifestId"] = $c11d54150f019f2a$export$32c943c51c185af3;

});

parcelRegister("lTT6U", function(module, exports) {
/* shared.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $5aaqS = parcelRequire("5aaqS");


var $6B0jU = parcelRequire("6B0jU");


var $dk0le = parcelRequire("dk0le");


var $4ymSL = parcelRequire("4ymSL");


var $6qvTD = parcelRequire("6qvTD");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $hirMS = parcelRequire("hirMS");


var $53T8Y = parcelRequire("53T8Y");

const $66534ffd791792e4$var$dbIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))),
    (0, (/*@__PURE__*/$parcel$interopDefault($dk0le))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5aaqS)))
];
const $66534ffd791792e4$var$dbHandleChildCommands = (_experience, _command)=>{};
const $66534ffd791792e4$var$dbTransformUrl = (url, _isFullScreen)=>{
    const urlObj = new URL(url);
    urlObj.searchParams.set('presentationMode', 'nativeEmbedEditorPlugin');
    return urlObj.toString();
};
const $66534ffd791792e4$var$dbRenderLoadingComponent = (props)=>/*#__PURE__*/ $42omo.createElement((0, $53T8Y.default), {
        animationDisabled: props.animationDisabled,
        icons: $66534ffd791792e4$var$dbIcons,
        testId: props.testId
    });
const $66534ffd791792e4$export$8f59efcb9ee755ea = ()=>{
    const itemsBeforeUpdate = [
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EMBED,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EDIT,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
    ];
    const itemsAfterUpdate = [
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EMBED,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EDIT,
        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALIGNMENT
    ];
    return (0, $dh538.fg)('cc-maui-toolbar-separators-update') ? itemsAfterUpdate : itemsBeforeUpdate;
};
const $66534ffd791792e4$export$828ffb167e211671 = [
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).DELETE
]; /**
                                                                                                                                                                         * Returns the "More options" dropdown items for the DB Entry embed.
                                                                                                                                                                         *
                                                                                                                                                                         * The "Always show title" toggle is gated on the `databases-native-embeds-v2`
                                                                                                                                                                         * experiment: it is only included when the experiment is enabled. Evaluated
                                                                                                                                                                         * lazily (rather than at module-load time) because the manifest is registered
                                                                                                                                                                         * before Statsig is bootstrapped.
                                                                                                                                                                         */ 
const $66534ffd791792e4$export$c84eb7789dc18 = ()=>{
    const items = [];
    if ((0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $1oCLl.expValEquals)('databases-native-embeds-v2', 'isEnabled', true)) items.push((0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE);
    items.push((0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY, (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).DELETE);
    return items;
};
const $66534ffd791792e4$export$2ef16a6e7258368a = {
    editorToolbarHandlers: {},
    renderLoadingComponent: $66534ffd791792e4$var$dbRenderLoadingComponent,
    titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
    appearance: 'minimal',
    showHeader: false,
    showBorder: false,
    waitForContentReady: true
};
const $66534ffd791792e4$export$28b94c65c51f8734 = {
    allowVerticalResize: true,
    isActive: ()=>true,
    handleChildCommands: $66534ffd791792e4$var$dbHandleChildCommands,
    shouldAutoConvertToNativeEmbed: true,
    lockResizeAspectRatio: ()=>false,
    supportedFeatures: new Set((0, $hirMS.allNativeEmbedCoreFeatures)),
    transformUrl: $66534ffd791792e4$var$dbTransformUrl
};
module.exports["getDbToolbarItems"] = $66534ffd791792e4$export$8f59efcb9ee755ea;
module.exports["dbMoreItems"] = $66534ffd791792e4$export$828ffb167e211671;
module.exports["getDbEntryMoreItems"] = $66534ffd791792e4$export$c84eb7789dc18;
module.exports["dbSharedUiConfig"] = $66534ffd791792e4$export$2ef16a6e7258368a;
module.exports["dbSharedManifestFields"] = $66534ffd791792e4$export$28b94c65c51f8734;

});

parcelRegister("hirMS", function(module, exports) {
/**
 * Core features that are supported by all native embeds.
 *
 * All native embed must either support the feature or respond in
 * the feature handshake that its not supported.
 */ const $3e5755bf95f911bd$export$189dc4df3d8f1369 = {
    /** When agreed, the parent sends selected-change events to the child when the embed's selection state changes. */ SelectedChange: 'selected-change',
    /** When agreed, the parent sends view-mode-change events to the child when the embed switches between regular and maximize (e.g. full screen). */ ViewModeChange: 'view-mode-change',
    /** When agreed, the parent sends header-visibility-change events to the child when the host native embed controls/chrome visibility changes. */ HeaderVisibilityChange: 'header-visibility-change',
    /** When agreed, the child captures click events and notifies the host via the bridge. */ NotifyHostClick: 'notify-host-click',
    /** When agreed, the child can request the host to toggle the full-screen dialog. */ ToggleFullScreen: 'toggle-full-screen',
    /**
	 * When agreed, the child can request the host to resize the embed container. */ RequestResize: 'request-resize',
    /**
	 * When agreed, the host sends `on-full-screen-changed` events to the child whenever
	 * the inline full-screen preview opens or closes WITHOUT remounting the iframe.
	 *
	 * This handshake is only ever negotiated when the host runs the shared-iframe
	 * code path (i.e. `Element.prototype.moveBefore` is supported AND the
	 * `platform_native_embeds_full_rollout_bugfix` gate is on). On any other
	 * host path the embed is torn down and re-created across the full-screen
	 * toggle, so a child has no need for this event.
	 */ NoRefreshFullScreenPreview: 'no-refresh-full-screen-preview',
    /**
	 * When agreed, the child sends a `content-ready` event to the host once its
	 * content is fully rendered and visible to the user. The host holds its own
	 * loading overlay visible until this event fires (or a safety timeout elapses),
	 * preventing a flash of the child's internal loading state between the iframe
	 * `load` event and the child's first painted frame.
	 *
	 * Only negotiated for embed types that set `waitForContentReady: true` in their
	 * `uiConfig` (currently database native embeds).
	 */ ContentReady: 'content-ready'
};
const $3e5755bf95f911bd$export$75135a796fe6e3e2 = Object.values($3e5755bf95f911bd$export$189dc4df3d8f1369);
module.exports["NativeEmbedCoreFeature"] = $3e5755bf95f911bd$export$189dc4df3d8f1369;
module.exports["allNativeEmbedCoreFeatures"] = $3e5755bf95f911bd$export$75135a796fe6e3e2;

});

parcelRegister("53T8Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $56970310d3e6cf82$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $7YDPK = parcelRequire("7YDPK");


var $9ILEC = parcelRequire("9ILEC");

function $56970310d3e6cf82$export$2e2bcd8739ae039(props) {
    if (props.variant === 'simple-bar') {
        const { variant: _variant, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ILEC.default), rest);
    }
    const { variant: _variant, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7YDPK.default), rest);
}

});

parcelRegister("7YDPK", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e663b8e68ab2921$export$2e2bcd8739ae039);
/* icon-carousel-variant.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8EF7j = parcelRequire("8EF7j");


var $2fSUW = parcelRequire("2fSUW");


var $4CxKE = parcelRequire("4CxKE");


var $ZDq1z = parcelRequire("ZDq1z");


var $h191R = parcelRequire("h191R");


var $8oVcN = parcelRequire("8oVcN");


var $55RG0 = parcelRequire("55RG0");


var $gvvnt = parcelRequire("gvvnt");

const $8e663b8e68ab2921$var$containerStyles = null;
const $8e663b8e68ab2921$var$innerStyles = null;
const $8e663b8e68ab2921$var$progressBarWrapperStyles = null;
const $8e663b8e68ab2921$var$defaultIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8EF7j))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4CxKE))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2fSUW)))
];
function $8e663b8e68ab2921$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, testId: testId }) {
    const progress = (0, $gvvnt.useFakeProgress)(animationDisabled);
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1r04idpf _kqswstnw _1e0c1txw _4cvr1h6o _1bah1h6o _bfhkhfxm"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulpv47k _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $55RG0.default), {
        animationDisabled: animationDisabled,
        icons: icons ?? $8e663b8e68ab2921$var$defaultIcons,
        testId: testId ? `${testId}--${0, $h191R.SLIDE_MORPH_TEST_ID_SUFFIX}` : undefined,
        cycleDirection: "right"
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsb1tkr"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $8oVcN.default), {
        ariaLabel: "Loading",
        testId: testId ? `${testId}--${0, $h191R.PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined,
        value: progress
    }))));
}

});

parcelRegister("8EF7j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a6242f603ec1727a8ab94c75bc410d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64d1f41eb9b7eee3$var$_react = $64d1f41eb9b7eee3$var$_interopRequireDefault((parcelRequire("42omo")));

var $64d1f41eb9b7eee3$var$_baseNew = $64d1f41eb9b7eee3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $64d1f41eb9b7eee3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramSymbolMindMap".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for mind map diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon = (props)=>/*#__PURE__*/ $64d1f41eb9b7eee3$var$_react.default.createElement($64d1f41eb9b7eee3$var$_baseNew.default, Object.assign({
        name: "DiagramSymbolMindMapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 13.5h2.5v-2H12zM1.5 9H4V7H1.5zM12 4.5h2.5v-2H12zm4 .125C16 5.385 15.384 6 14.625 6h-2.75c-.76 0-1.375-.616-1.375-1.375V4.25h-1a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h1v-.375c0-.76.616-1.375 1.375-1.375h2.75c.76 0 1.375.616 1.375 1.375v2.25c0 .76-.616 1.375-1.375 1.375h-2.75c-.76 0-1.375-.616-1.375-1.375v-.375h-1a2 2 0 0 1-2-2v-2.5h-2v.375c0 .76-.616 1.375-1.375 1.375h-2.75C.615 10.5 0 9.884 0 9.125v-2.25C0 6.115.616 5.5 1.375 5.5h2.75c.76 0 1.375.616 1.375 1.375v.375h2v-2.5a2 2 0 0 1 2-2h1v-.375c0-.76.616-1.375 1.375-1.375h2.75l.14.007c.694.07 1.235.656 1.235 1.368z"/>`
    }, props));
$64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon.displayName = 'DiagramSymbolMindMapIcon';
var $64d1f41eb9b7eee3$var$_default = module.exports.default = $64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon;

});

parcelRegister("2fSUW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c0dc6357dcf36b6b5fbc7fab2883cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a4794ee5fae0adf$var$_react = $1a4794ee5fae0adf$var$_interopRequireDefault((parcelRequire("42omo")));

var $1a4794ee5fae0adf$var$_baseNew = $1a4794ee5fae0adf$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1a4794ee5fae0adf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sticker".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Used for sticker tool in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a4794ee5fae0adf$var$StickerIcon = (props)=>/*#__PURE__*/ $1a4794ee5fae0adf$var$_react.default.createElement($1a4794ee5fae0adf$var$_baseNew.default, Object.assign({
        name: "StickerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-1.998 12.687L6 14c0-1.102.223-2.153.627-3.11a8 8 0 0 1 7.56-4.888A6.5 6.5 0 0 0 8 1.5m5.413 6.026a6.5 6.5 0 0 0-5.404 3.947 6.5 6.5 0 0 0-.483 1.94zM0 8a8 8 0 0 1 15.899-1.277.75.75 0 0 1-.21.65l-8.317 8.315a.75.75 0 0 1-.649.21A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$1a4794ee5fae0adf$var$StickerIcon.displayName = 'StickerIcon';
var $1a4794ee5fae0adf$var$_default = module.exports.default = $1a4794ee5fae0adf$var$StickerIcon;

});

parcelRegister("h191R", function(module, exports) {
const $ec1cb32042d7b116$export$422c871edd75db5 = 'progress-bar';
const $ec1cb32042d7b116$export$eb09afb535a4cb18 = 'slide-morph';
const $ec1cb32042d7b116$export$7442c4c7574447bc = 50;
module.exports["PROGRESS_BAR_TEST_ID_SUFFIX"] = $ec1cb32042d7b116$export$422c871edd75db5;
module.exports["SLIDE_MORPH_TEST_ID_SUFFIX"] = $ec1cb32042d7b116$export$eb09afb535a4cb18;
module.exports["STATIC_PROGRESS_VALUE"] = $ec1cb32042d7b116$export$7442c4c7574447bc;

});

parcelRegister("8oVcN", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd755021a547180e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $dd755021a547180e$var$MIN_VALUE = 0;
const $dd755021a547180e$var$MAX_VALUE = 100;
const $dd755021a547180e$var$containerStyles = null;
const $dd755021a547180e$var$barStyles = null; /**
                         * This is a progress bar component that was built to match the atlaskit component `@atlaskit/progress-bar`.
                         * We couldn't use the atlaskit component due to the colour requirements for this progress bar not being supported,
                         * hence, a custom component was required.
                         */ 
function $dd755021a547180e$export$2e2bcd8739ae039({ ariaLabel: ariaLabel, testId: testId, value: value = 0 }) {
    const valueParsed = Math.max($dd755021a547180e$var$MIN_VALUE, Math.min(value, $dd755021a547180e$var$MAX_VALUE));
    return /*#__PURE__*/ $42omo.createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $dd755021a547180e$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $dd755021a547180e$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm"
        ])
    }, /*#__PURE__*/ $42omo.createElement("span", {
        style: {
            width: `${valueParsed}%`
        },
        "data-testid": `${testId}--progress-value-bar`,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564aq9m _1e0c1ule _4t3ii2wt _kqswstnw _bfhk10ef"
        ])
    }));
}

});

parcelRegister("55RG0", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e7dad9e9100192b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $i7jPX = parcelRequire("i7jPX");


var $bgUWL = parcelRequire("bgUWL");


var $dHSFf = parcelRequire("dHSFf");

// so we override the background via a wrapper targeting the tile's root <span>.
const $3e7dad9e9100192b$var$tileWrapperStyles = null;
function $3e7dad9e9100192b$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, testId: testId, cycleDirection: cycleDirection = 'right' }) {
    const iconsWithProps = icons.map((Icon)=>(props)=>/*#__PURE__*/ $42omo.createElement(Icon, {
                color: "var(--ds-icon-subtle, #505258)",
                ...props
            }));
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_a47o1j9a"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $i7jPX.default), {
        label: "",
        backgroundColor: "color.background.neutral",
        hasBorder: true,
        size: "xlarge",
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement((0, $dHSFf.default), {
        animationDisabled: animationDisabled,
        icons: iconsWithProps,
        cycleDirection: cycleDirection,
        testId: testId ? `${testId}--${0, $bgUWL.ICON_CYCLER_TEST_ID_SUFFIX}` : undefined
    })));
}

});

parcelRegister("bgUWL", function(module, exports) {
const $72147bd7a5974ea4$export$a87bbf852b8799e2 = 'icon-cycler';
module.exports["ICON_CYCLER_TEST_ID_SUFFIX"] = $72147bd7a5974ea4$export$a87bbf852b8799e2;

});

parcelRegister("dHSFf", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e4e9b37e2ebb815$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $5e4e9b37e2ebb815$var$ICON_CYCLE_DELAY_MS = 900;
const $5e4e9b37e2ebb815$var$ICON_CYCLE_TRANSITION_MS = 400;
const $5e4e9b37e2ebb815$var$ICON_CYCLE_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
const $5e4e9b37e2ebb815$var$enteringAnimations = {
    left: "_kqswh2mm _j7hqzuuk",
    right: "_kqswh2mm _j7hq1s47"
};
const $5e4e9b37e2ebb815$var$exitingAnimations = {
    left: "_kqswstnw _j7hq1qyy",
    right: "_kqswstnw _j7hq1pdg"
};
const $5e4e9b37e2ebb815$var$commonAnimationStyles = null;
const $5e4e9b37e2ebb815$var$containerStyles = null;
const $5e4e9b37e2ebb815$var$iconSlotStyles = null; /**
                              * Cycles through a list of icon components with a vertical slide transition.
                              *
                              * Each icon is shown for ICON_CYCLE_DELAY_MS, then the current icon slides
                              * out upward while the next icon slides in from below over ICON_CYCLE_TRANSITION_MS.
                              */ 
function $5e4e9b37e2ebb815$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, cycleDirection: cycleDirection = 'left', testId: testId }) {
    const [currentIndex, setCurrentIndex] = (0, $42omo.useState)(0);
    const [isTransitioning, setIsTransitioning] = (0, $42omo.useState)(false);
    const timerRef = (0, $42omo.useRef)(null);
    const nextIndex = (currentIndex + 1) % icons.length;
    const scheduleNextTransition = (0, $42omo.useCallback)(()=>{
        timerRef.current = setTimeout(()=>{
            setIsTransitioning(true);
        }, $5e4e9b37e2ebb815$var$ICON_CYCLE_DELAY_MS);
    }, []);
    const handleAnimationEnd = (0, $42omo.useCallback)(()=>{
        setIsTransitioning(false);
        setCurrentIndex((prev)=>(prev + 1) % icons.length);
    }, [
        icons.length
    ]);
    (0, $42omo.useEffect)(()=>{
        if (animationDisabled || icons.length <= 1) return;
        if (!isTransitioning) scheduleNextTransition();
        return ()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [
        animationDisabled,
        icons.length,
        isTransitioning,
        scheduleNextTransition
    ]);
    if (icons.length === 0) return null;
    const CurrentIcon = icons[currentIndex];
    const NextIcon = icons[nextIndex];
    if (animationDisabled || icons.length === 1 || !isTransitioning) return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement(CurrentIcon, {
        label: ""
    })));
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            "_5sag1cqc _1pgl18mf _1o51q7pw",
            $5e4e9b37e2ebb815$var$exitingAnimations[cycleDirection]
        ])
    }, /*#__PURE__*/ $42omo.createElement(CurrentIcon, {
        label: ""
    })), /*#__PURE__*/ $42omo.createElement("div", {
        onAnimationEnd: handleAnimationEnd,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            "_5sag1cqc _1pgl18mf _1o51q7pw",
            $5e4e9b37e2ebb815$var$enteringAnimations[cycleDirection]
        ])
    }, /*#__PURE__*/ $42omo.createElement(NextIcon, {
        label: ""
    })));
}

});

parcelRegister("gvvnt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h191R = parcelRequire("h191R");

function $505212c2c3c913b5$export$966e81c93dd9c110(animationDisabled) {
    const [progress, setProgress] = (0, $42omo.useState)(animationDisabled ? (0, $h191R.STATIC_PROGRESS_VALUE) : 0);
    (0, $42omo.useEffect)(()=>{
        if (animationDisabled) return;
        const interval = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 10) return prev + 10;
                if (prev < 60) return prev + 35;
                if (prev < 90) return prev + 10;
                return prev;
            });
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        animationDisabled
    ]);
    return progress;
}
module.exports["useFakeProgress"] = $505212c2c3c913b5$export$966e81c93dd9c110;

});

parcelRegister("9ILEC", function(module, exports) {
$parcel$export(module.exports, "default", () => $51c7bd4e4555939e$export$2e2bcd8739ae039);
/* simple-bar-variant.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $h191R = parcelRequire("h191R");


var $8oVcN = parcelRequire("8oVcN");


var $gvvnt = parcelRequire("gvvnt");

const $51c7bd4e4555939e$var$messages = (0, $aXWIB.defineMessages)({
    loadingLabel: {
        id: "native-embeds-core.common.loading-overlay.simple-bar-variant.loadingLabel",
        defaultMessage: "Loading"
    }
});
const $51c7bd4e4555939e$var$containerStyles = null;
const $51c7bd4e4555939e$var$blanketStyles = null;
const $51c7bd4e4555939e$var$progressBarWrapperStyles = null;
function $51c7bd4e4555939e$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, showBlanket: showBlanket = false, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const progress = (0, $gvvnt.useFakeProgress)(animationDisabled);
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1r04idpf _kqswstnw _1e0c1txw _4cvresu3 _1bah1h6o _85i5utpp _bfhkhfxm _1pbykb7n"
        ])
    }, showBlanket && /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1r04idpf _kqswstnw _bfhk1i5c"
        ])
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsb1lk2 _kqswh2mm _1pbykb7n"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $8oVcN.default), {
        ariaLabel: formatMessage($51c7bd4e4555939e$var$messages.loadingLabel),
        testId: testId ? `${testId}--${0, $h191R.PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined,
        value: progress
    })));
}

});

parcelRegister("9m4TI", function(module, exports) {

var $8Yt3t = parcelRequire("8Yt3t");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $dMSEk = parcelRequire("dMSEk");


var $lTT6U = parcelRequire("lTT6U");

const $f72546d7cb92419f$var$isDbEntryV2Enabled = ()=>(0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $1oCLl.expValEquals)('databases-native-embeds-v2', 'isEnabled', true);
/**
 * Returns the parameter defaults for the DB Entry embed.
 *
 * When v2 is enabled (see {@link isDbEntryV2Enabled}), new entry embeds
 * default to having the title visible (`alwaysShowTitle: true`),
 * matching the regular DB embed behaviour. Otherwise no override is
 * applied.
 */ const $f72546d7cb92419f$var$getDbEntryParameterDefaults = ()=>$f72546d7cb92419f$var$isDbEntryV2Enabled() ? {
        alwaysShowTitle: true
    } : {};
const $f72546d7cb92419f$export$a8c9f0f28b60cece = (0, $dMSEk.experienceManifestId)('database-entry');
const $f72546d7cb92419f$var$isDatabaseEntryUrl = (url)=>{
    try {
        return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/) !== null && new URL(url).searchParams.has('entryId');
    } catch  {
        return false;
    }
};
const $f72546d7cb92419f$export$b0c2faa0f9dece58 = {
    ...(0, $lTT6U.dbSharedManifestFields),
    id: $f72546d7cb92419f$export$a8c9f0f28b60cece,
    isUrlMatch: $f72546d7cb92419f$var$isDatabaseEntryUrl,
    get parameterDefaults () {
        return $f72546d7cb92419f$var$getDbEntryParameterDefaults();
    },
    uiConfig: {
        ...(0, $lTT6U.dbSharedUiConfig),
        get appearance () {
            return $f72546d7cb92419f$var$isDbEntryV2Enabled() ? 'overlay' : 'minimal';
        },
        get showBorder () {
            return $f72546d7cb92419f$var$isDbEntryV2Enabled();
        },
        editorToolbarActions: ()=>(0, $8Yt3t.createEditorToolbarActions)({
                items: [
                    ...(0, $lTT6U.getDbToolbarItems)()
                ],
                moreItems: (0, $lTT6U.getDbEntryMoreItems)()
            })
    }
};
module.exports["DBEntryExperienceManifest"] = $f72546d7cb92419f$export$b0c2faa0f9dece58;

});

parcelRegister("bM5Iz", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $jQW4q = parcelRequire("jQW4q");


var $8EF7j = parcelRequire("8EF7j");


var $fnc8R = parcelRequire("fnc8R");


var $jdPfT = parcelRequire("jdPfT");


var $1zLiv = parcelRequire("1zLiv");


var $6qvTD = parcelRequire("6qvTD");

var $8Yt3t = parcelRequire("8Yt3t");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $8z9j5 = parcelRequire("8z9j5");


var $hirMS = parcelRequire("hirMS");


var $53T8Y = parcelRequire("53T8Y");


var $dMSEk = parcelRequire("dMSEk");

const $0230259ec6fa40c8$var$mauiLoadingIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8EF7j))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fnc8R)))
];
const $0230259ec6fa40c8$export$b0111d5aa9d78690 = (0, $dMSEk.experienceManifestId)('maui');
const $0230259ec6fa40c8$var$isMauiUrl = (url)=>/\/remix\/ui\/[A-Za-z0-9_-]+/.test(url); /**
                                                                                      * Experience manifest for a MAUI embed.
                                                                                      * Register with getNativeEmbedFacade().registerExperienceManifest(MauiExperienceManifest),
                                                                                      * then call getNativeEmbedFacade().createExperienceForUrl(url) to obtain an Experience for EmbedFrameUI.
                                                                                      */ 
const $0230259ec6fa40c8$export$f519d88de7ad4d5e = {
    id: $0230259ec6fa40c8$export$b0111d5aa9d78690,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $0230259ec6fa40c8$var$isMauiUrl,
    supportedFeatures: new Set((0, $hirMS.allNativeEmbedCoreFeatures)),
    isActive: ()=>true,
    lockResizeAspectRatio: ()=>!(0, $dh538.fg)('cc_maui_resize'),
    parameterDefaults: {
        width: 760
    },
    shouldFocusOnClick: (_url, _meta)=>!(0, $dh538.fg)('cc_maui_editing'),
    shouldAutoConvertToNativeEmbed: true,
    transformUrl: (url, _isFullScreen, options)=>{
        const urlObj = new URL(url);
        const { colorMode: colorMode } = (0, $8z9j5.default)();
        if (colorMode) urlObj.searchParams.set('theme', colorMode);
         // When the host Confluence page is in edit mode, forward an
        // `enable-edits=` query param (empty value) so the embedded MAUI app
        // can render its edit-only affordances.
        if (options?.isEditMode) urlObj.searchParams.set('enable-edits', '');
        return urlObj.toString();
    },
    // remove this when MAUI is onboarded to the Linking Platform. This is here to allow testing before it is onboarded.
    resolveViaLinkingPlatform: false,
    uiConfig: {
        trackViewed: true,
        showBorder: false,
        showExpandButton: false,
        renderLoadingComponent: (props)=>{
            // The exposure is fired at the toolbar click in `duplicate-and-replace-maui-app.ts`.
            if ((0, $dZ8uq.expValEqualsNoExposure)('cc-maui-ai-edit-loading-experiment', 'isEnabled', true)) return /*#__PURE__*/ $42omo.createElement((0, $53T8Y.default), {
                variant: "simple-bar",
                animationDisabled: props.animationDisabled,
                showBlanket: props.source === 'ai-edit',
                testId: props.testId
            });
            return /*#__PURE__*/ $42omo.createElement((0, $53T8Y.default), {
                animationDisabled: props.animationDisabled,
                icons: $0230259ec6fa40c8$var$mauiLoadingIcons,
                testId: props.testId
            });
        },
        editorToolbarActions: ()=>(0, $8Yt3t.createEditorToolbarActions)({
                customActions: {},
                items: [
                    ...(0, $dh538.fg)('cc-maui-phase-2') ? (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [],
                    ...(0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? (0, $dh538.fg)('cc-maui-toolbar-separators-update') ? [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).BORDER
                    ] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).BORDER,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [],
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $dh538.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EXPAND,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).DELETE
                ],
                moreItems: []
            }),
        editorToolbarHandlers: {
            onAskRovoClick: (_parameters, context)=>{
                const editorApi = context?.editorApi; // Stage the embed as the inline-Rovo streaming target. The overlay
                // is NOT triggered here — `RovoPromptScreenWithLogic.onSubmit`
                // promotes this on prompt submit. `expValEquals` (NOT NoExposure)
                // because this toolbar click is the designated `cc-maui-experiment`
                // exposure point.
                if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning -- gate + experiment layering for MAUI rollout (cc-maui-experiment + cc-maui-phase-2); will simplify post-rollout
                (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true) && (0, $dh538.fg)('cc-maui-phase-2')) {
                    const localId = context?.selectedNodeLocalId;
                    if (localId) editorApi?.aiExperience?.actions?.stageInlineRovoStreaming?.(localId);
                }
                editorApi?.aiExperience?.actions?.openAIModal?.({
                    invokedFrom: 'floatingToolbar'
                });
            }
        },
        fullScreenDialogControls: {
            hideOpenInNewTab: true,
            hideTitleIcon: true
        },
        headerControls: {
            hideMoreMenu: true,
            hideTitle: true
        },
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))),
        appearance: 'overlay'
    }
};
module.exports["MAUI_EXPERIENCE_MANIFEST_ID"] = $0230259ec6fa40c8$export$b0111d5aa9d78690;
module.exports["MauiExperienceManifest"] = $0230259ec6fa40c8$export$f519d88de7ad4d5e;

});

parcelRegister("jQW4q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7739ad8bf36e5bd9a55f1766d10483c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e73feb3a782b379c$var$_react = $e73feb3a782b379c$var$_interopRequireDefault((parcelRequire("42omo")));

var $e73feb3a782b379c$var$_baseNew = $e73feb3a782b379c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e73feb3a782b379c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeRemix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Remix with Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e73feb3a782b379c$var$AiGenerativeRemixIcon = (props)=>/*#__PURE__*/ $e73feb3a782b379c$var$_react.default.createElement($e73feb3a782b379c$var$_baseNew.default, Object.assign({
        name: "AiGenerativeRemixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="M15.78 3.72a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM6 4.25a.75.75 0 0 1-.49.71l-1.1.4a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.41 0l-.4-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.48-.59L0 4.25l.01-.12a.75.75 0 0 1 .48-.59l1.1-.4a.5.5 0 0 0 .3-.3l.4-1.1.05-.11A.75.75 0 0 1 3 1.24l.12.01a.75.75 0 0 1 .54.38l.05.11.4 1.1c.05.14.16.25.3.3l1.1.4a.75.75 0 0 1 .49.71"/>`
    }, props));
$e73feb3a782b379c$var$AiGenerativeRemixIcon.displayName = 'AiGenerativeRemixIcon';
var $e73feb3a782b379c$var$_default = module.exports.default = $e73feb3a782b379c$var$AiGenerativeRemixIcon;

});

parcelRegister("fnc8R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43688494f0a31d9179ab4b6542dc66c8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3126c2152de312c$var$_react = $b3126c2152de312c$var$_interopRequireDefault((parcelRequire("42omo")));

var $b3126c2152de312c$var$_baseNew = $b3126c2152de312c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b3126c2152de312c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "World".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: Geographical data visualization.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b3126c2152de312c$var$WorldIcon = (props)=>/*#__PURE__*/ $b3126c2152de312c$var$_react.default.createElement($b3126c2152de312c$var$_baseNew.default, Object.assign({
        name: "WorldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/><path fill="currentcolor" d="M9.5 12.13a2.63 2.63 0 0 1 2.63-2.63H15V11h-2.87c-.62 0-1.12.5-1.12 1.13V15H9.5zm-1.5.62a2 2 0 0 0-2-2 .5.5 0 0 1-.5-.5v-.5A2.5 2.5 0 0 0 3 7.25H1v1.5h2a1 1 0 0 1 1 1v.5a2 2 0 0 0 2 2 .5.5 0 0 1 .5.5V15H8zm-1.25-6.5A.75.75 0 0 0 6 5.5h-.25A2.5 2.5 0 0 1 3.25 3V1.63h1.5V3a1 1 0 0 0 1 1H6a2.25 2.25 0 0 1 2.25 2.25c0 .41.34.75.75.75h1.5a.5.5 0 0 0 .5-.5 2 2 0 0 1 2-2h1.75V6H13a.5.5 0 0 0-.5.5 2 2 0 0 1-2 2H9a2.25 2.25 0 0 1-2.25-2.25"/>`
    }, props));
$b3126c2152de312c$var$WorldIcon.displayName = 'WorldIcon';
var $b3126c2152de312c$var$_default = module.exports.default = $b3126c2152de312c$var$WorldIcon;

});

parcelRegister("8ALYZ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $8EF7j = parcelRequire("8EF7j");


var $2fSUW = parcelRequire("2fSUW");


var $4CxKE = parcelRequire("4CxKE");


var $ZDq1z = parcelRequire("ZDq1z");


var $6qvTD = parcelRequire("6qvTD");

var $8Yt3t = parcelRequire("8Yt3t");


var $dh538 = parcelRequire("dh538");


var $hirMS = parcelRequire("hirMS");


var $53T8Y = parcelRequire("53T8Y");


var $2cuux = parcelRequire("2cuux");


var $dMSEk = parcelRequire("dMSEk");

const $f6a0496ea7747590$export$7bda1cade81459d3 = (0, $dMSEk.experienceManifestId)('maui-whiteboard'); /**
                                                                                                                      * Dynamic-config killswitch for sending `disableCanvasScroll` conditionally in
                                                                                                                      * legacy full screen. Default `false` = change enabled (param omitted from the
                                                                                                                      * legacy full-screen URL so the blown-up board scrolls); set to `true` to roll
                                                                                                                      * back to the pre-EPS8-40 behavior (param sent everywhere).
                                                                                                                      */ 
const $f6a0496ea7747590$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH = 'platform_native_embed_legacy_fs_canvas_scroll';
const $f6a0496ea7747590$var$whiteboardIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8EF7j))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4CxKE))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2fSUW)))
];
const $f6a0496ea7747590$var$isMauiWhiteboardUrl = (url)=>{
    const isWhiteboardPath = // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
    if (!isWhiteboardPath) return false;
    try {
        return new URL(url).searchParams.get('isRemixDiagram') === 'true';
    } catch  {
        return false;
    }
}; /**
    * Experience manifest for a MAUI whiteboard embed — a whiteboard created through
    * the MAUI (remix diagram) flow.
    *
    * Register with getNativeEmbedFacade().registerExperience(MauiWhiteboardExperienceManifest)
    * to obtain an Experience for EmbedFrameUI.
    */ 
const $f6a0496ea7747590$export$72612bab14c2e7fe = {
    id: $f6a0496ea7747590$export$7bda1cade81459d3,
    isUrlMatch: $f6a0496ea7747590$var$isMauiWhiteboardUrl,
    shouldAutoConvertToNativeEmbed: true,
    supportedFeatures: new Set((0, $hirMS.allNativeEmbedCoreFeatures)),
    // Thunk so the killswitch is read at URL-build time (after Statsig init), and
    // so the conditional behavior is gated at its source: when rolled back the
    // manifest emits the pre-EPS8-40 plain-string value, which `resolveQueryParams`
    // passes through unchanged at every build site.
    //
    // `disableCanvasScroll` is correct inline (and in shared-iframe full screen,
    // which reuses the inline URL) but makes the blown-up board feel broken in the
    // legacy full-screen iframe, so by default it is omitted from that build site
    // only. `hideCursors` applies everywhere (plain string === appliesTo: 'always').
    queryParams: ()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const rolledBack = (0, $c6GJD.default).getExperimentValue($f6a0496ea7747590$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH, 'value', false);
        return rolledBack ? {
            disableCanvasScroll: 'true',
            hideCursors: 'true'
        } : {
            disableCanvasScroll: {
                value: 'true',
                appliesTo: 'exceptLegacyFullscreen'
            },
            hideCursors: 'true'
        };
    },
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // this is used to identify the native embed view in the whiteboard app
        urlObj.searchParams.set('nativeEmbedView', 'true'); // Default the parent product for MAUI whiteboards when the native embed
        // URL doesn't already specify one. native-embeds-core re-applies this
        // onto the ORS-resolved iframe src (which otherwise defaults to
        // `smartlink`). An existing value (e.g. `rovo`) is preserved.
        // Killswitch: platform_native_embed_parent_product_url
        // false (default) = change enabled; true = rollback
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        if (!urlObj.searchParams.has('parentProduct') && !(0, $c6GJD.default).getExperimentValue('platform_native_embed_parent_product_url', 'value', false)) urlObj.searchParams.set('parentProduct', 'nativeEmbedDiagram');
        const initialTheme = (0, $2cuux.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    isActive: ()=>{
        return true;
    },
    uiConfig: {
        trackViewed: true,
        isAskRovoEnabled: ()=>(0, $dh538.fg)('cc-maui-phase-2'),
        editorToolbarActions: ()=>(0, $8Yt3t.createEditorToolbarActions)({
                items: [
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    ...(0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT
                    ] : [],
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $dh538.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    // BUILTIN_TOOLBAR_KEYS.BORDER, // Border option is yet to be implemented.
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $dh538.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $42omo.createElement((0, $53T8Y.default), {
                animationDisabled: props.animationDisabled,
                icons: $f6a0496ea7747590$var$whiteboardIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        appearance: 'overlay'
    },
    handleChildCommands: (_experience, _cmd)=>{}
};
module.exports["MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID"] = $f6a0496ea7747590$export$7bda1cade81459d3;
module.exports["MauiWhiteboardExperienceManifest"] = $f6a0496ea7747590$export$72612bab14c2e7fe;

});

parcelRegister("2cuux", function(module, exports) {

var $8z9j5 = parcelRequire("8z9j5");

var $2LONO = parcelRequire("2LONO");

const $31ca606e996c9780$export$6f4b285026a87b72 = ()=>{
    const theme = (0, $8z9j5.default)();
    if (Object.keys(theme).length === 0) return undefined;
    return (0, $2LONO.themeObjectToString)(theme);
};
module.exports["getInitialThemeParam"] = $31ca606e996c9780$export$6f4b285026a87b72;

});

parcelRegister("fEQUX", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $1Zr9M = parcelRequire("1Zr9M");


var $8jHAi = parcelRequire("8jHAi");


var $eHJoz = parcelRequire("eHJoz");


var $9RVmI = parcelRequire("9RVmI");


var $f8c3d = parcelRequire("f8c3d");


var $6qvTD = parcelRequire("6qvTD");

var $8Yt3t = parcelRequire("8Yt3t");


var $dh538 = parcelRequire("dh538");


var $hirMS = parcelRequire("hirMS");


var $53T8Y = parcelRequire("53T8Y");


var $dMSEk = parcelRequire("dMSEk");

const $fab1e522e1d7606e$export$7870b2bb7b39809b = (0, $dMSEk.experienceManifestId)('page');
const $fab1e522e1d7606e$var$pageIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f8c3d))),
    (0, (/*@__PURE__*/$parcel$interopDefault($eHJoz)))
]; // Match page URLs: /wiki/spaces/<key>/pages/<id>
// Match blog URLs: /wiki/spaces/<key>/blog/<id> or /wiki/spaces/<key>/blog/<year>/<month>/<day>/<id>
const $fab1e522e1d7606e$var$pagePathPattern = /\/wiki\/spaces\/[^/]+\/(pages\/\d+|blog\/(\d+\/){0,3}\d+)/;
const $fab1e522e1d7606e$var$pageShortLinkPathPattern = /\/wiki\/x\/[A-Za-z0-9_-]+/;
const $fab1e522e1d7606e$var$isPageUrl = (url)=>{
    if ($fab1e522e1d7606e$var$pagePathPattern.test(url)) return true;
    if (!(0, $dh538.fg)('platform_native_embeds_full_rollout_bugfix')) return false;
    return $fab1e522e1d7606e$var$pageShortLinkPathPattern.test(url);
};
const $fab1e522e1d7606e$var$isEditUrl = (url)=>/\/wiki\/spaces\/[^/]+\/(pages|blog)\/(edit-embed|edit-v2)\/\d+/.test(url); // PGXT-10098: keep blog icons correct before resolved metadata is available.
const $fab1e522e1d7606e$var$blogPathPattern = /\/wiki\/spaces\/[^/]+\/blog\//;
const $fab1e522e1d7606e$var$isBlogUrl = (url)=>{
    try {
        return $fab1e522e1d7606e$var$blogPathPattern.test(new URL(url).pathname);
    } catch  {
        return $fab1e522e1d7606e$var$blogPathPattern.test(url);
    }
};
const $fab1e522e1d7606e$var$resolveTitleIcon = (meta, url)=>{
    if (meta.documentType === 'schema:DigitalDocument') return 0, (/*@__PURE__*/$parcel$interopDefault($e0ycV));
    if (meta.documentType === 'schema:BlogPosting' || $fab1e522e1d7606e$var$isBlogUrl(url)) return 0, (/*@__PURE__*/$parcel$interopDefault($9RVmI));
    return 0, (/*@__PURE__*/$parcel$interopDefault($8jHAi));
}; /**
    * Experience manifest for a page embed.
    * Register with getNativeEmbedFacade().registerExperienceManifest(PageExperienceManifest),
    * then call getNativeEmbedFacade().createExperienceForUrl(url) to obtain an Experience for EmbedFrameUI.
    */ 
const $fab1e522e1d7606e$export$f85d1a9111fa6dfc = {
    enforceQueryParams: true,
    id: $fab1e522e1d7606e$export$7870b2bb7b39809b,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $fab1e522e1d7606e$var$isPageUrl,
    supportedFeatures: new Set((0, $hirMS.allNativeEmbedCoreFeatures)),
    isActive: ()=>true,
    shouldFocusOnClick: (url, meta)=>{
        // Don't steal focus for live docs (documentType === 'schema:DigitalDocument')
        if (meta.documentType === 'schema:DigitalDocument') return false;
         // Don't steal focus when the page is in edit mode
        if ($fab1e522e1d7606e$var$isEditUrl(url)) return false;
        return true;
    },
    transformUrl: (url, _isFullScreen)=>{
        const urlObj = new URL(url);
        urlObj.searchParams.set('sample-param', 'true');
        return urlObj.toString();
    },
    uiConfig: {
        showHeader: (_meta, url)=>!$fab1e522e1d7606e$var$isEditUrl(url),
        headerControls: {
            editButton: {
                show: (meta)=>meta.documentType !== 'schema:DigitalDocument',
                // Don't show edit button for live docs
                onSwitchToEditing: (currentUrl, originalUrl)=>{
                    const url = new URL(currentUrl); // Detect whether this is originally a blog URL. The iframe's internal
                    // SPA router may resolve blog URLs (e.g. /blog/2026/04/29/<id>) to
                    // their canonical /pages/<id> form, so iframeSrc (currentUrl) may
                    // show /pages/<id> even for blogs. We check the originalUrl (the URL
                    // before iframe navigation) to detect blogs reliably; fall back to
                    // the current URL when no originalUrl is provided.
                    const contentIsBlog = $fab1e522e1d7606e$var$isBlogUrl(originalUrl ?? currentUrl);
                    if (contentIsBlog) {
                        // Blogs use /blog/edit-v2/<id> because there is no /blog/edit-embed/ route,
                        // which would cause a redirect that strips native embed query params.
                        // Extract the content ID from either the blog URL or the resolved /pages/<id> URL.
                        const blogMatch = url.pathname.match(/\/blog\/(?:\d+\/\d+\/\d+\/)?(\d+)(?:\/[^/]*)?$/);
                        const pagesMatch = url.pathname.match(/\/pages\/(\d+)/);
                        const contentId = blogMatch?.[1] ?? pagesMatch?.[1];
                        if (contentId) // Replace the path portion after /spaces/<key>/ with /blog/edit-v2/<id>
                        url.pathname = url.pathname.replace(/\/spaces\/([^/]+)\/.*$/, `/spaces/$1/blog/edit-v2/${contentId}`);
                    } else // Pages use /pages/edit-embed/<id> (dedicated embedded editor route).
                    url.pathname = url.pathname.replace(/\/pages\/(\d+)/, '/pages/edit-embed/$1');
                    url.searchParams.set('initialAllowedFeatures', 'delete-draft');
                    return url.toString();
                },
                onSwitchToViewing: (currentUrl, _originalUrl)=>{
                    const url = new URL(currentUrl); // Reverse the edit URL transforms back to view URLs
                    url.pathname = url.pathname.replace(/\/pages\/edit-embed\/(\d+)/, '/pages/$1').replace(/\/blog\/edit-v2\/(\d+)/, '/blog/$1');
                    url.searchParams.delete('initialAllowedFeatures');
                    return url.toString();
                }
            }
        },
        editorToolbarActions: ()=>(0, $8Yt3t.createEditorToolbarActions)({
                items: [
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $dh538.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $dh538.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $42omo.createElement((0, $53T8Y.default), {
                animationDisabled: props.animationDisabled,
                icons: $fab1e522e1d7606e$var$pageIcons,
                testId: props.testId
            }),
        resolveTitleIcon: $fab1e522e1d7606e$var$resolveTitleIcon,
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        appearance: 'overlay'
    }
};
module.exports["PageExperienceManifest"] = $fab1e522e1d7606e$export$f85d1a9111fa6dfc;

});

parcelRegister("9odlF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $l1HSN = parcelRequire("l1HSN");


var $g5QRf = parcelRequire("g5QRf");


var $hyKjN = parcelRequire("hyKjN");


var $4XRO0 = parcelRequire("4XRO0");


var $lW0cT = parcelRequire("lW0cT");


var $6qvTD = parcelRequire("6qvTD");

var $8Yt3t = parcelRequire("8Yt3t");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $hirMS = parcelRequire("hirMS");


var $53T8Y = parcelRequire("53T8Y");


var $dMSEk = parcelRequire("dMSEk");

const $c4c7e0706612362e$var$slideIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4XRO0))),
    (0, (/*@__PURE__*/$parcel$interopDefault($lW0cT))),
    (0, (/*@__PURE__*/$parcel$interopDefault($hyKjN)))
];
const $c4c7e0706612362e$export$7f3e59c853b03788 = (0, $dMSEk.experienceManifestId)('slide'); /**
                                                                                                  * Experience manifest for a slide embed.
                                                                                                  * Register with getNativeEmbedFacade().registerExperience(SlideExperienceManifest)
                                                                                                  * to obtain a Experience for EmbedFrameUI.
                                                                                                  */ 
const $c4c7e0706612362e$export$513ec3204bdf9ec = {
    id: $c4c7e0706612362e$export$7f3e59c853b03788,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: (url)=>(0, $dZ8uq.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true) && (0, $l1HSN.isConfluenceSlideUrl)(url),
    supportedFeatures: new Set((0, $hirMS.allNativeEmbedCoreFeatures)),
    queryParams: {
        disableCanvasScroll: 'true'
    },
    isActive: ()=>(0, $dZ8uq.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true),
    // Slides have a 16:9 canvas; set the default embed dimensions to 16:10 with a little extra height cause it looks nicer.
    parameterDefaults: {
        width: 960,
        height: 600
    },
    uiConfig: {
        editorToolbarActions: ()=>(0, $8Yt3t.createEditorToolbarActions)({
                items: [
                    // BUILTIN_TOOLBAR_KEYS.ASK_ROVO, // Removed until correct context from embed is provided https://product-fabric.atlassian.net/browse/CNS-29056
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EMBED,
                    ...(0, $dh538.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $dh538.fg)('cc-maui-toolbar-separators-update') ? [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EDIT_URL
                    ] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EDIT_URL,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $42omo.createElement((0, $53T8Y.default), {
                animationDisabled: props.animationDisabled,
                icons: $c4c7e0706612362e$var$slideIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        appearance: 'overlay'
    }
};
module.exports["SlideExperienceManifest"] = $c4c7e0706612362e$export$513ec3204bdf9ec;

});

parcelRegister("hyKjN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f72cdc9dd744d65444b8998cb10ed6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc898a812ba93870$var$_react = $cc898a812ba93870$var$_interopRequireDefault((parcelRequire("42omo")));

var $cc898a812ba93870$var$_baseNew = $cc898a812ba93870$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $cc898a812ba93870$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoMiniplayer".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for picture-in-picture functionality for videos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc898a812ba93870$var$VideoMiniplayerIcon = (props)=>/*#__PURE__*/ $cc898a812ba93870$var$_react.default.createElement($cc898a812ba93870$var$_baseNew.default, Object.assign({
        name: "VideoMiniplayerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm4.75 4a.75.75 0 0 1 .75-.75h4.75a.75.75 0 0 1 .75.75v2.75a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$cc898a812ba93870$var$VideoMiniplayerIcon.displayName = 'VideoMiniplayerIcon';
var $cc898a812ba93870$var$_default = module.exports.default = $cc898a812ba93870$var$VideoMiniplayerIcon;

});

parcelRegister("7QA1q", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $8EF7j = parcelRequire("8EF7j");


var $2fSUW = parcelRequire("2fSUW");


var $4CxKE = parcelRequire("4CxKE");


var $ZDq1z = parcelRequire("ZDq1z");


var $6qvTD = parcelRequire("6qvTD");

var $8Yt3t = parcelRequire("8Yt3t");


var $dh538 = parcelRequire("dh538");


var $hirMS = parcelRequire("hirMS");


var $53T8Y = parcelRequire("53T8Y");


var $2cuux = parcelRequire("2cuux");


var $dMSEk = parcelRequire("dMSEk");


var $2hIvT = parcelRequire("2hIvT");

const $5dec7c06fb632983$export$571bdd0f87630d48 = (0, $dMSEk.experienceManifestId)('whiteboard'); /**
                                                                                                            * Dynamic-config killswitch for sending `disableCanvasScroll` conditionally in
                                                                                                            * legacy full screen. Default `false` = change enabled (param omitted from the
                                                                                                            * legacy full-screen URL so the blown-up board scrolls); set to `true` to roll
                                                                                                            * back to the pre-EPS8-40 behavior (param sent everywhere).
                                                                                                            */ 
const $5dec7c06fb632983$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH = 'platform_native_embed_legacy_fs_canvas_scroll';
const $5dec7c06fb632983$var$whiteboardIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8EF7j))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4CxKE))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2fSUW)))
];
const $5dec7c06fb632983$var$isWhiteboardUrl = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?")); /**
                                                                                                                                                * Experience manifest for a whiteboard embed.
                                                                                                                                                * Register with getNativeEmbedFacade().registerExperience(WhiteboardExperienceManifest)
                                                                                                                                                * to obtain a Experience for EmbedFrameUI.
                                                                                                                                                */ 
const $5dec7c06fb632983$export$257420b954ccf94c = {
    id: $5dec7c06fb632983$export$571bdd0f87630d48,
    handleChildCommands: (_experience, cmd)=>{
        switch(cmd.type){
            case (0, $2hIvT.NativeEmbedChildCommandType).FreezeFrameResponse:
                break;
            case (0, $2hIvT.NativeEmbedChildCommandType).UnfreezeFrameResponse:
                break;
        }
    },
    isUrlMatch: $5dec7c06fb632983$var$isWhiteboardUrl,
    shouldAutoConvertToNativeEmbed: true,
    supportedFeatures: new Set((0, $hirMS.allNativeEmbedCoreFeatures)),
    // Thunk so the killswitch is read at URL-build time (after Statsig init), and
    // so the conditional behavior is gated at its source: when rolled back the
    // manifest emits the pre-EPS8-40 plain-string value, which `resolveQueryParams`
    // passes through unchanged at every build site.
    //
    // `disableCanvasScroll` is correct inline (and in shared-iframe full screen,
    // which reuses the inline URL) but makes the blown-up board feel broken in the
    // legacy full-screen iframe, so by default it is omitted from that build site
    // only. `hideCursors` applies everywhere (plain string === appliesTo: 'always').
    queryParams: ()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const rolledBack = (0, $c6GJD.default).getExperimentValue($5dec7c06fb632983$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH, 'value', false);
        return rolledBack ? {
            disableCanvasScroll: 'true',
            hideCursors: 'true'
        } : {
            disableCanvasScroll: {
                value: 'true',
                appliesTo: 'exceptLegacyFullscreen'
            },
            hideCursors: 'true'
        };
    },
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // this is used to identify the native embed view in the whiteboard app
        urlObj.searchParams.set('nativeEmbedView', 'true');
        const initialTheme = (0, $2cuux.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    isActive: ()=>{
        return true;
    },
    uiConfig: {
        editorToolbarActions: ()=>(0, $8Yt3t.createEditorToolbarActions)({
                items: [
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $dh538.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    // BUILTIN_TOOLBAR_KEYS.BORDER, // Border option is yet to be implemented.
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $dh538.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $42omo.createElement((0, $53T8Y.default), {
                animationDisabled: props.animationDisabled,
                icons: $5dec7c06fb632983$var$whiteboardIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        appearance: 'overlay'
    }
};
module.exports["WhiteboardExperienceManifest"] = $5dec7c06fb632983$export$257420b954ccf94c;

});

parcelRegister("2hIvT", function(module, exports) {
var $6dd9b8d1663dd2ce$export$e02855afa78b2d37 = /*#__PURE__*/ function(NativeEmbedCommandType) {
    NativeEmbedCommandType["FreezeFrameRequest"] = "freezeFrameRequest";
    NativeEmbedCommandType["UnfreezeFrame"] = "unfreezeFrame";
    return NativeEmbedCommandType;
}({});
var $6dd9b8d1663dd2ce$export$f17561b95ea7b258 = /*#__PURE__*/ function(NativeEmbedChildCommandType) {
    NativeEmbedChildCommandType["FreezeFrameResponse"] = "freezeFrameResponse";
    NativeEmbedChildCommandType["UnfreezeFrameResponse"] = "unfreezeFrameResponse";
    return NativeEmbedChildCommandType;
}({});
module.exports["NativeEmbedChildCommandType"] = $6dd9b8d1663dd2ce$export$f17561b95ea7b258;

});

parcelRegister("iXjoS", function(module, exports) {

let $dcccc924f92906cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dcccc924f92906cf$var$load("9skky"),
    $dcccc924f92906cf$var$load("6iz6l"),
    $dcccc924f92906cf$var$load("4SCW2"),
    $dcccc924f92906cf$var$load("6wr18"),
    $dcccc924f92906cf$var$load("iRTKR"),
    $dcccc924f92906cf$var$load("7eMui"),
    $dcccc924f92906cf$var$load("ffEVr"),
    $dcccc924f92906cf$var$load("8W1PX")
]).then(()=>parcelRequire('4fcUa'));

});

parcelRegister("49OjX", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $9V9F6 = parcelRequire("9V9F6");


var $h5cDl = parcelRequire("h5cDl");


var $4R6DR = parcelRequire("4R6DR");

async function $1975dca5cd7e2ffb$export$af16a73460e35e28(cloudId, config) {
    const allSkills = await (0, $h5cDl.fetchSkills)(cloudId);
    const filteredSkills = (0, $4R6DR.filterSkills)(allSkills, config);
    return (0, $9V9F6.buildSkillsManifest)(filteredSkills, {
        // Skills should appear below native editor elements in the slash menu.
        // A high priority value (lower importance) ensures native items rank
        // higher when search scores are equal. Skills are identified by their
        // extensionType property (set by buildMenuItem for all extension items)
        // in the reranker at
        // platform/packages/editor/editor-common/src/quick-insert/boost-native-results-above-skills.ts
        priority: config.priority ?? 9000,
        onAction: (skill)=>{
            config.onAnalyticsEvent?.({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
                attributes: {
                    skillSlug: skill.slug,
                    skillName: skill.name,
                    isAiSkill: true
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            });
            return config.onSkillSelected?.(`/${skill.slug}`, skill);
        }
    });
}
module.exports["createRovoSkillsExtensionManifest"] = $1975dca5cd7e2ffb$export$af16a73460e35e28;

});

parcelRegister("9V9F6", function(module, exports) {

var $ij2FZ = parcelRequire("ij2FZ");


var $d3VBU = parcelRequire("d3VBU");

const $d5608b0937f691e7$var$DEFAULT_CATEGORY = 'AI';
const $d5608b0937f691e7$var$MAX_DESCRIPTION_LENGTH = 150;
/**
 * Truncate description to a maximum length.
 * Used to keep insert menu items readable when skill descriptions are long.
 */ function $d5608b0937f691e7$var$truncateDescription(description) {
    if (description.length <= $d5608b0937f691e7$var$MAX_DESCRIPTION_LENGTH) return description;
    return description.slice(0, $d5608b0937f691e7$var$MAX_DESCRIPTION_LENGTH).trim() + "\u2026";
}
/**
 * Returns the skill-specific icon based on the iconName field.
 * Falls back to the default skill icon if no match is found.
 */ const $d5608b0937f691e7$var$getSkillIcon = (iconName)=>iconName && (0, $d3VBU.skillIcon)[iconName] ? (0, $d3VBU.skillIcon)[iconName] : (0, $d3VBU.defaultIcon);
function $d5608b0937f691e7$export$d76981760c7a9606(skills, options = {}) {
    const { onAction: onAction, categories: categories = [
        $d5608b0937f691e7$var$DEFAULT_CATEGORY
    ], priority: priority, getLozenge: getLozenge, nodes: nodes } = options;
    const quickInsertModules = skills.map((skill)=>{
        const keywords = [
            skill.slug,
            skill.product,
            skill.name,
            'skill',
            'skills'
        ].filter((k)=>typeof k === 'string' && k.length > 0);
        return {
            key: skill.slug,
            title: skill.name,
            description: $d5608b0937f691e7$var$truncateDescription(skill.helpText ?? skill.description ?? ''),
            keywords: keywords,
            categories: categories,
            ...priority !== undefined && {
                priority: priority
            },
            icon: $d5608b0937f691e7$var$getSkillIcon(skill.iconName),
            ...getLozenge && {
                lozenge: getLozenge(skill)
            },
            action: async ()=>onAction?.(skill)
        };
    });
    return {
        title: 'Rovo Skills',
        description: 'AI-powered skills from Rovo',
        type: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
        key: (0, $ij2FZ.ROVO_SKILL_EXTENSION_KEY),
        icons: {
            '16': (0, $d3VBU.defaultIcon),
            '24': (0, $d3VBU.defaultIcon),
            '48': (0, $d3VBU.defaultIcon)
        },
        modules: {
            quickInsert: quickInsertModules,
            ...nodes && {
                nodes: nodes
            }
        }
    };
}
module.exports["buildSkillsManifest"] = $d5608b0937f691e7$export$d76981760c7a9606;

});

parcelRegister("4R6DR", function(module, exports) {
function $c686993d36abd21c$export$757808344f89f413(skills, config) {
    if (config.showAllSkills) return skills;
    const allowedSlugs = config.allowedSkills ?? [];
    if (allowedSlugs.length === 0) return [];
    const skillsBySlug = new Map(skills.map((skill)=>[
            skill.slug,
            skill
        ]));
    return allowedSlugs.map((slug)=>skillsBySlug.get(slug)).filter((skill)=>skill !== undefined);
}
module.exports["filterSkills"] = $c686993d36abd21c$export$757808344f89f413;

});

parcelRegister("cOau5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kycWk = parcelRequire("kycWk");


var $F4YLX = parcelRequire("F4YLX");


const $831f4393e6328081$export$8c5d88a1b5304a38 = ({ contentId: contentId, isCommentContext: isCommentContext = false })=>{
    return {
        title: 'Redaction',
        type: (0, $kycWk.REDACTION_EXTENSION_TYPE),
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>(parcelRequire("fSxYU"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(args)=>{
                            const node = args.node;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
                                contentId: contentId,
                                extensionNode: node,
                                isCommentContext: isCommentContext
                            });
                        }
                }
            }
        }
    };
};
module.exports["createTourableRedactionExtension"] = $831f4393e6328081$export$8c5d88a1b5304a38;

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("F4YLX", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $87886bfe56e46f2e$export$2e83ac12275e5b95 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jDbpB",
    name: "TourableRedactionExtensionLoader",
    loader: async ()=>(await (parcelRequire("bOmaA"))).TourableRedactionExtension
});
module.exports["TourableRedactionExtensionLoader"] = $87886bfe56e46f2e$export$2e83ac12275e5b95;

});

parcelRegister("bOmaA", function(module, exports) {

let $89958fa6e0d2d088$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89958fa6e0d2d088$var$load("5AfWB").then(()=>parcelRequire('jubPE'));

});

parcelRegister("fSxYU", function(module, exports) {

let $b8f6422d7c09d941$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8f6422d7c09d941$var$load("3XbzG").then(()=>parcelRequire('4s2T0'));

});

parcelRegister("i5WUp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $9Rf00 = parcelRequire("9Rf00");

var $au4KV = parcelRequire("au4KV");


var $gWF6I = parcelRequire("gWF6I");


var $9NDUe = parcelRequire("9NDUe");

var $2Gu9D = parcelRequire("2Gu9D");


var $in8wv = parcelRequire("in8wv");


var $kt1Xc = parcelRequire("kt1Xc");


var $2UyBL = parcelRequire("2UyBL");

const $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $990b0c00f1a7800f$var$DEFAULT_MAX_LINES = 4;
const $990b0c00f1a7800f$var$styles = {
    container: "_11c8wadc"
};
const $990b0c00f1a7800f$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $990b0c00f1a7800f$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    }); /**
     * Main AI Snippet component. Fetches the AI snippet data from the server and displays it.
     * If the snippet data type is not supported, it will display the fallback component.
     * If the AI snippet data is not found or another error occurs it will display the AISnippet component,
     * but with the fallback text in place of the response text.
     *
     * @param contentId - The content ID of the AI snippet
     * @param contentType - The content type of the AI snippet
     * @param cloudId - The cloud ID of the AI snippet
     * @param fallbackText - The text to display if the AI snippet fails to load
     * @param fallbackComponent - The component to display if the AI snippet is not supported
     * @param source [optional] - The source for where the AI snippet was triggered from defaults to 'smartlink'
     * @param onLoadComplete [optional] - The callback function that executes when loading has completed
     * @returns
     */ 
const $990b0c00f1a7800f$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ $42omo.createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: $990b0c00f1a7800f$var$getAnalyticsConfig(props)
    }, /*#__PURE__*/ $42omo.createElement($990b0c00f1a7800f$export$ac90160f7ae1e32f, props));
};
const $990b0c00f1a7800f$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $990b0c00f1a7800f$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $irOoi.useQueryLoader)((0, $2UyBL.default));
    const isLoadingRef = (0, $42omo.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $2Gu9D.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $990b0c00f1a7800f$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $dh538.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $42omo.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        }; // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ $42omo.createElement((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ $42omo.createElement((0, $in8wv.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        }
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($990b0c00f1a7800f$var$styles.container)
    }, /*#__PURE__*/ $42omo.createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ $42omo.createElement((0, $au4KV.AIStreamLoading), null)
    }, queryRef ? /*#__PURE__*/ $42omo.createElement((0, $kt1Xc.AISnippetLoader), {
        queryRef: queryRef,
        fallbackText: fallbackText,
        contentId: contentId,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        showFooter: showFooter,
        showAwareness: showAwareness
    }) : /*#__PURE__*/ $42omo.createElement((0, $au4KV.AIStreamLoading), null))));
    return /*#__PURE__*/ $42omo.createElement((0, $dpPtd.FlagsProvider), null, isEnabledForJira ? content : /*#__PURE__*/ $42omo.createElement((0, $9Rf00.AIFeedbackPropertiesProvider), {
        entrypointId: $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID,
        userId: userId,
        displayName: displayName
    }, content));
};
const $990b0c00f1a7800f$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ $42omo.createElement((0, $gWF6I.RelayEnvironmentProvider), null, /*#__PURE__*/ $42omo.createElement($990b0c00f1a7800f$export$1b2af18ca4bb327b, props));
};
module.exports["AISnippetWithRelayEnvironment"] = $990b0c00f1a7800f$export$c9a07cebec67e951;

});

parcelRegister("2Rith", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("9Rf00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $a07f007de41f1483$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $a07f007de41f1483$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $aXWIB.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a07f007de41f1483$export$f906c21bacdb2d8e.Provider, {
        value: contextValue
    }, children);
};
const $a07f007de41f1483$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $42omo.useContext)($a07f007de41f1483$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $a07f007de41f1483$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $a07f007de41f1483$export$ff3deb4415ee32e3;

});

parcelRegister("au4KV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $igbBp = parcelRequire("igbBp");

const $fe7ceaa3509ef4fa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $fe7ceaa3509ef4fa$var$i18n = (0, $aXWIB.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const title = titleMessage ?? $fe7ceaa3509ef4fa$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: padding,
        xcss: $fe7ceaa3509ef4fa$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $igbBp.GeneratingStreamAnimation), {
        alt: formatMessage($fe7ceaa3509ef4fa$var$i18n.generatingSummaryAnimationAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), title)));
};
module.exports["AIStreamLoading"] = $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef;

});

parcelRegister("igbBp", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $42omo = parcelRequire("42omo");

const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
module.exports["GeneratingStreamAnimation"] = $dd45fdb3e38904f6$export$3709887a1be0e305;

});

parcelRegister("2Gu9D", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $42omo = parcelRequire("42omo");


var $5aVN7 = parcelRequire("5aVN7");

const $b5fd5f50ef335781$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $42omo.useRef)(new (0, $5aVN7.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $42omo.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $42omo.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $42omo.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $b5fd5f50ef335781$export$fade2d05a6320d49;

});

parcelRegister("in8wv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $e6pbP = parcelRequire("e6pbP");


var $c6GJD = parcelRequire("c6GJD");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $fYQcF = parcelRequire("fYQcF");


var $aFC6o = parcelRequire("aFC6o");

var $iuafG = parcelRequire("iuafG");

var $aXh2V = parcelRequire("aXh2V");


var $fXbFR = parcelRequire("fXbFR");

const $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $b015c3cc5e677900$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $b015c3cc5e677900$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $42omo.useRef)(text);
    const isExperimentEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const isFeedbackEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-experiment-feedback', 'isEnabled', false);
    const handleLikeClicked = (0, $42omo.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $42omo.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $42omo.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100",
        ref: ref
    }, showAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aFC6o.AIAwareness), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        maxLines: maxLines
    }, renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6pbP.default), {
        options: {
            disableParsingRawHTML: true
        }
    }, $b015c3cc5e677900$var$sanitizeMarkdown(text || '')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6pbP.default), null, text || '') : text || ''), showFooter && text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iuafG.AIDisclaimer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXh2V.AIFeedbackComponent), {
        contentId: contentId,
        onLikeClicked: isFeedbackEnabled ? handleLikeClicked : undefined,
        onDislikeClicked: isFeedbackEnabled ? handleDislikeClicked : undefined
    })));
};
module.exports["AISnippetContent"] = $b015c3cc5e677900$export$3cf37822a11d3ff3;

});

parcelRegister("aFC6o", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $eLAh6 = parcelRequire("eLAh6");

const $902b2990c09c9892$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $902b2990c09c9892$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $eLAh6.i18n).rovoAwarenessMessage,
        define: (0, $eLAh6.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($902b2990c09c9892$var$styles.text)
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.RovoIcon), {
        size: "xxsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, formatMessage(message))));
};
module.exports["AIAwareness"] = $902b2990c09c9892$export$fde99ed387d90f1;

});

parcelRegister("eLAh6", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8e99185ad20025a1$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $8e99185ad20025a1$export$a7357cdd1f0b0168;

});

parcelRegister("aXh2V", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $biiXa = parcelRequire("biiXa");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $9Rf00 = parcelRequire("9Rf00");


var $aFwxm = parcelRequire("aFwxm");

const $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $00b0d3bf57a2c2c6$var$i18n = (0, $aXWIB.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $00b0d3bf57a2c2c6$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $00b0d3bf57a2c2c6$var$i18n.privacyPolicyLink));
const $00b0d3bf57a2c2c6$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $00b0d3bf57a2c2c6$var$i18n.researchGroupLink));
const $00b0d3bf57a2c2c6$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$00b0d3bf57a2c2c6$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00b0d3bf57a2c2c6$var$PrivacyPolicyLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $dh538.fg)('product-terminology-refresh') ? $00b0d3bf57a2c2c6$var$i18n.improveAtlassianTextAppify : $00b0d3bf57a2c2c6$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00b0d3bf57a2c2c6$var$ResearchGroupLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS = (0, $ecnYn.xcss)({
    transform: 'rotate(180deg)'
});
const $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS = (0, $ecnYn.xcss)({
    height: '24px',
    width: '24px'
});
const $00b0d3bf57a2c2c6$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $42omo.useState)(false);
    const feedbackCollectorProperties = (0, $9Rf00.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $42omo.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagTitle),
            description: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aFwxm.ThumbIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: handleLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aFwxm.ThumbIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: handleDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00b0d3bf57a2c2c6$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00b0d3bf57a2c2c6$var$EnrolLabel, null)
    })));
};
module.exports["AIFeedbackComponent"] = $00b0d3bf57a2c2c6$export$f9f34317e5bc3551;

});

parcelRegister("aFwxm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9FnLD = parcelRequire("9FnLD");

const $321f16821ba8d88a$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $321f16821ba8d88a$export$ec2ba0e929740f73;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("kt1Xc", function(module, exports) {

var $2UyBL = parcelRequire("2UyBL");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $9Rf00 = parcelRequire("9Rf00");


var $in8wv = parcelRequire("in8wv");

const $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $45557925e309956a$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $irOoi.usePreloadedQuery)((0, $2UyBL.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ $42omo.createElement((0, $in8wv.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $dh538.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ $42omo.createElement((0, $9Rf00.AIFeedbackPropertiesProvider), {
        entrypointId: $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name
    }, content);
    return content;
};
module.exports["AISnippetLoader"] = $45557925e309956a$export$f50b64530422ea99;

});

parcelRegister("2UyBL", function(module, exports) {
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $06d2529594a8e25b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$06d2529594a8e25b$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $06d2529594a8e25b$export$2e2bcd8739ae039 = $06d2529594a8e25b$var$node;
module.exports["default"] = $06d2529594a8e25b$export$2e2bcd8739ae039;

});

parcelRegister("4IoVL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $eGqQQ = parcelRequire("eGqQQ");


var $3aeMC = parcelRequire("3aeMC");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $2TuWI = parcelRequire("2TuWI");


var $cga1x = parcelRequire("cga1x");


var $kzNtP = parcelRequire("kzNtP");


var $c4QoG = parcelRequire("c4QoG");


var $I0A3i = parcelRequire("I0A3i");


var $kQiXs = parcelRequire("kQiXs");

const $17b0f8a5b73de479$var$DEFAULT_CONFIG = {
    clientId: '',
    fileStoreUrl: ''
};
const $17b0f8a5b73de479$var$cachedGetDownloadData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, contentAri: contentAri, contentProduct: contentProduct, isExternalShare: isExternalShare, shareToken: shareToken })=>{
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $3aeMC.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    }) && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) return (0, $3aeMC.fetchTokenForSourceProduct)({
        contentAri: contentAri ?? contentId,
        contentId: contentId,
        sourceProduct: contentProduct
    });
    if (isExternalShare && shareToken && (0, $6mKj3.expValEquals)('add_anonid_in_media_token', 'cohort', 'test')) {
        const tokenResponse = await (0, $I0A3i.fetchExternalContentMediaSessionToken)(shareToken);
        const tokenData = tokenResponse?.data;
        return {
            token: tokenData?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value || '',
            config: tokenData?.externalContentMediaSession?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
        };
    }
    // Fallback to existing logic for backward compatibility
    const response = await (isExternalShare ? (0, $I0A3i.fetchExternalShareMediaToken) : (0, $I0A3i.fetchMediaToken))(contentId);
    const data = response?.data;
    const externalData = data?.['singleContent'];
    const content = isExternalShare ? externalData : data?.['content']?.nodes?.[0];
    return {
        token: content?.body?.atlas_doc_format?.mediaToken?.token || '',
        config: data?.mediaConfiguration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$export$6176af039388fdbf = (dataGetter)=>async ()=>{
        const data = await dataGetter();
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$da46cefd33160c4d = (viewDataGetter, uploadDataGetter)=>async (params)=>{
        // Currently, supplying upload token only for file and collection update action.
        // If no params are provided, the view token is returned.
        const isUpdateAction = !!params?.access?.find(({ type: type, actions: actions })=>(type === 'file' || type == 'collection') && actions.includes('update'));
        const data = await (isUpdateAction ? uploadDataGetter() : viewDataGetter());
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$6cb774192b5cd093 = (contextId)=>{
    try {
        const { snippetId: snippetId, scope: scope } = JSON.parse(contextId);
        return snippetId ? {
            snippetId: snippetId,
            scope: scope
        } : undefined;
    } catch  {} // not JSON or not a SnippetContextId.
};
const $17b0f8a5b73de479$export$724cb324eb7535cd = async (contextId, contentProduct, contentAri)=>{
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $3aeMC.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    }) && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
        const auth = await (0, $3aeMC.fetchTokenForSourceProduct)({
            contentAri: contentAri ?? contextId,
            contentId: contextId,
            sourceProduct: contentProduct
        });
        return {
            clientId: auth.config.clientId || '',
            token: auth.token || '',
            baseUrl: auth.config.fileStoreUrl || ''
        };
    }
    if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
        const snippetContext = $17b0f8a5b73de479$export$6cb774192b5cd093(contextId);
        if (snippetContext && snippetContext.scope !== (0, $cga1x.SnippetScope).GLOBAL) {
            const auth = await (0, $2TuWI.fetchSnippetMediaToken)(snippetContext.snippetId);
            return {
                clientId: auth.clientId,
                token: auth.token,
                baseUrl: auth.baseUrl
            };
        }
    }
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = (0, $c4QoG.getTemplateMediaContextValues)(contextId);
    // template media informtion is stored slightly different in the context
    // to be able to discern which call to make
    if (collectionId || templateId) return (0, $c4QoG.getTemplateMediaAuth)({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
    const response = await (0, $I0A3i.fetchMediaToken)(contextId);
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.mediaConfiguration || {};
    return {
        clientId: clientId,
        token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
        baseUrl: fileStoreUrl || ''
    };
};
const $17b0f8a5b73de479$var$cachedGetUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = options.contentType === 'comment' && options.cloudId && (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? await (0, $I0A3i.getCommentUploadToken)(options.contentId, options.cloudId) : await (0, $I0A3i.getUploadToken)(options.contentId);
    const session = response?.data?.contentMediaSession;
    return {
        token: session?.token?.value || '',
        config: session?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG,
        collectionId: session?.collection || ''
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getUploadCollectionId = async (options)=>{
    const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
    return uploadData.collectionId;
};
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter = (options)=>()=>$17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
const $17b0f8a5b73de479$var$getUploadMediaClientConfig = async (options)=>({
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    });
const $17b0f8a5b73de479$var$cachedGetExportDspData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, spaceKey: spaceKey })=>{
    const response = await (0, $I0A3i.getIsExportEnabledForContent)(contentId, spaceKey);
    const isExportAllowed = response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    return {
        isExportAllowed: isExportAllowed,
        exp: Date.now() + 60000
    };
}, (json)=>json.exp);
const $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy = async (options)=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const { contentId: contentId, spaceKey: spaceKey, mediaDspContentId: mediaDspContentId } = options;
    if (!(0, $9wGTI.fg)('dlp_allow_content_dsp_check_without_space_details')) {
        // Note: If you can't provide spaceKey, you can't enable downloads in media viewer
        if (!spaceKey) return true;
    }
    try {
        const relevantContentId = mediaDspContentId || contentId;
        const response = await $17b0f8a5b73de479$var$cachedGetExportDspData.getValue({
            contentId: relevantContentId,
            spaceKey: spaceKey
        });
        const isExportAllowed = response?.isExportAllowed;
        return !isExportAllowed;
    } catch  {
        // Fails CLOSED
        return true;
    }
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetter = (options)=>async ()=>{
        // Only pass contentId, isExternalShare, and shareToken to the cacheWithExp function
        // to avoid unnecessary re-fetching of the token if other options differ
        const authQueryOptions = {
            contentId: options.contentId,
            contentAri: options.contentAri,
            contentProduct: options.contentProduct,
            isExternalShare: options.isExternalShare,
            shareToken: options.shareToken
        };
        let data = await $17b0f8a5b73de479$var$cachedGetDownloadData.getValue(authQueryOptions);
        if (options.mediaToken) data = {
            ...data,
            token: options.mediaToken
        };
        // For drafts mediaToken by default is null and created once any media added to them
        // So, once publishing draft that just got media but token was cached before as `null`
        // we need to re-fetch the token without the cache
        if (!data.token) data = await $17b0f8a5b73de479$var$cachedGetDownloadData.forceGetValue(authQueryOptions);
        return data;
    };
const $17b0f8a5b73de479$export$9891be2d4fea1436 = async (options)=>{
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    };
};
const $17b0f8a5b73de479$export$e43b4f8676d4deae = async (options)=>({
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    });
const $17b0f8a5b73de479$export$39c5d94533971b79 = async (options)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$9891be2d4fea1436(options)
    });
const $17b0f8a5b73de479$export$4887a1cde0f552dc = async (options)=>{
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(options);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$9891be2d4fea1436(options),
        $17b0f8a5b73de479$var$getUploadMediaClientConfig(options),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$e43b4f8676d4deae(options) : undefined,
        $17b0f8a5b73de479$var$getUploadCollectionId(options)
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
};
const $17b0f8a5b73de479$export$c64cc28e06e9eda = (pathname)=>{
    return !!(0, $1NBp8.PDF_EXPORT_PAGE).match(pathname);
};
let $17b0f8a5b73de479$var$previousAttachUploadedMediaListener;
const $17b0f8a5b73de479$var$registerGlobalFileAddedListener = (options)=>{
    if ($17b0f8a5b73de479$var$previousAttachUploadedMediaListener) (0, $eGqQQ.globalMediaEventEmitter).off('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
    $17b0f8a5b73de479$var$previousAttachUploadedMediaListener = (0, $kQiXs.attachUploadedMedia)(options);
    (0, $eGqQQ.globalMediaEventEmitter).on('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$export$af68076132bb2083 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$de798661504725b9 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$221251ab27f63f41 = async (getOptions)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$af68076132bb2083(getOptions)
    });
const $17b0f8a5b73de479$export$e6a9b44aa174a3d4 = async (getOptions)=>{
    const initialOptions = getOptions();
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(initialOptions);
    if ((0, $9wGTI.fg)('confluence_frontend_fix_stale_media_collection')) {
        // Fix for stale media collection bug when the provider is reused across SPA navigations
        // (confluence_frontend_transition_preloading_system). Without this fix, uploadParams.collection
        // and the file-added listener remain frozen to the page active at provider creation time.
        // Register the global file-added listener dynamically so that SPA navigations always
        // register the attachment callback against the current page's contentId.
        const registerDynamicFileAddedListener = ()=>{
            $17b0f8a5b73de479$var$registerGlobalFileAddedListener(getOptions());
        };
        // Track the last contentId we fetched upload data for, and the cached result.
        // This lets us detect a contentId change and eagerly re-fetch before any upload.
        let lastFetchedContentId = initialOptions.contentId;
        let latestUploadData;
        // Deduplicate concurrent calls to refreshUploadDataIfNeeded — if a refresh is already
        // in-flight (e.g. from useMediaOptions and authProvider both calling simultaneously),
        // subsequent callers share the same promise rather than racing to write latestUploadData.
        let inFlightRefresh;
        // Refresh upload data for the current options if contentId has changed since the
        // last fetch. Concurrent calls are deduplicated via inFlightRefresh.
        // Called by useMediaOptions on navigation so all uploadParams.collection read sites
        // get the correct collection without needing to do anything special themselves.
        const refreshUploadDataIfNeeded = async ()=>{
            const currentOptions = getOptions();
            if (currentOptions.contentId !== lastFetchedContentId) {
                if (inFlightRefresh) return inFlightRefresh;
                inFlightRefresh = (async ()=>{
                    registerDynamicFileAddedListener();
                    latestUploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
                    lastFetchedContentId = currentOptions.contentId;
                    inFlightRefresh = undefined;
                })();
                return inFlightRefresh;
            }
        };
        // Build a fully-dynamic uploadMediaClientConfig whose authProvider always fetches
        // upload data for the CURRENT options so tokens stay correct across SPA navigations.
        // Note: we do NOT call registerDynamicFileAddedListener here — the listener is only
        // re-registered in refreshUploadDataIfNeeded (on actual navigation), not on every
        // token fetch, to avoid unnecessary teardown/rebuild of the module-level singleton.
        const dynamicUploadMediaClientConfig = {
            authProvider: $17b0f8a5b73de479$export$6176af039388fdbf(async ()=>{
                const currentOptions = getOptions();
                const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
                latestUploadData = uploadData;
                lastFetchedContentId = currentOptions.contentId;
                return uploadData;
            }),
            getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
            useSha256ForUploads: true
        };
        // Fetch all async dependencies in parallel — no waterfall.
        const [viewMediaClientConfig, viewAndUploadMediaClientConfig, initialUploadData] = await Promise.all([
            $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
            (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
            $17b0f8a5b73de479$var$cachedGetUploadData.getValue(getOptions())
        ]);
        latestUploadData = initialUploadData;
        return {
            viewMediaClientConfig: viewMediaClientConfig,
            // uploadParams is resolved via a getter so SPA navigations don't leave the collection
            // frozen to the page that was active when this provider was first created.
            get uploadParams () {
                return {
                    collection: latestUploadData.collectionId,
                    onUploadRejection: getOptions().onUploadRejection
                };
            },
            refreshUploadDataIfNeeded: refreshUploadDataIfNeeded,
            uploadMediaClientConfig: dynamicUploadMediaClientConfig,
            viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
        };
    }
    // Original (pre-fix) implementation: upload params and file-added listener are
    // frozen at creation time. Used when confluence_frontend_fix_stale_media_collection is off.
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadMediaClientConfig(opts);
        })(),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadCollectionId(opts);
        })()
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: initialOptions.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
}; /**
 * Usage sketch (React):
 * const liveOptionsRef = useRef(currentOptions);
 * liveOptionsRef.current = currentOptions; // update on changes
 * const providerPromise = useMemo(() => createEditorMediaProviderDynamic(() => liveOptionsRef.current), []);
 * editorApi.media.actions.setProvider(providerPromise);
 */ 
module.exports["createAuthProvider"] = $17b0f8a5b73de479$export$6176af039388fdbf;
module.exports["getAuthFromContext"] = $17b0f8a5b73de479$export$724cb324eb7535cd;
module.exports["getViewMediaClientConfig"] = $17b0f8a5b73de479$export$9891be2d4fea1436;
module.exports["createRendererMediaProvider"] = $17b0f8a5b73de479$export$39c5d94533971b79;
module.exports["createEditorMediaProvider"] = $17b0f8a5b73de479$export$4887a1cde0f552dc;
module.exports["controlDataExportOnCertainFeatures"] = $17b0f8a5b73de479$export$c64cc28e06e9eda;
module.exports["createRendererMediaProviderDynamic"] = $17b0f8a5b73de479$export$221251ab27f63f41;
module.exports["createEditorMediaProviderDynamic"] = $17b0f8a5b73de479$export$e6a9b44aa174a3d4;

});

parcelRegister("3aeMC", function(module, exports) {

var $haHYm = parcelRequire("haHYm");


var $hceZu = parcelRequire("hceZu");

const $6a7b95e6b4c9360c$export$8953ee4427cc19a2 = ({ hostProduct: hostProduct, sourceProduct: sourceProduct })=>{
    return !!sourceProduct && sourceProduct !== hostProduct;
};
const $6a7b95e6b4c9360c$export$9f88fc74c33fbfe = ({ contentAri: contentAri, contentId: contentId, sourceProduct: sourceProduct })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return (0, $haHYm.fetchMediaToken)(contentId);
        case 'jira-work-item':
            return (0, $hceZu.fetchJiraMediaToken)(contentAri);
        default:
            throw new Error(`Unsupported source product for token fetch: ${sourceProduct}`);
    }
};
module.exports["requiresCrossProductAuth"] = $6a7b95e6b4c9360c$export$8953ee4427cc19a2;
module.exports["fetchTokenForSourceProduct"] = $6a7b95e6b4c9360c$export$9f88fc74c33fbfe;

});

parcelRegister("haHYm", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $k2in1 = parcelRequire("k2in1");

const $ef717af67d2dc416$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $ef717af67d2dc416$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $ef717af67d2dc416$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $ef717af67d2dc416$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME = 'MediaUploadTokenQuery';
const $ef717af67d2dc416$var$GET_CONTENT_MEDIA_SESSION_QUERY = `query ${$ef717af67d2dc416$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME}($contentId: ID!) {
	contentMediaSession(contentId: $contentId) {
		token {
			value
		}
		configuration {
			clientId
			fileStoreUrl
		}
		collection
	}
}`;
const $ef717af67d2dc416$var$getContentMediaSession = async (contentId)=>{
    const bodyData = {
        query: $ef717af67d2dc416$var$GET_CONTENT_MEDIA_SESSION_QUERY,
        operationName: $ef717af67d2dc416$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME,
        variables: {
            contentId: contentId
        }
    };
    const response = await (0, $k2in1.fetchWithRetry)($ef717af67d2dc416$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$ef717af67d2dc416$var$COMMON_HEADERS,
            ...$ef717af67d2dc416$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get content media session: ${response.statusText}`);
    const result = await response.json();
    return result;
};
const $ef717af67d2dc416$export$2b7fb70f168591f8 = async (contentId)=>{
    try {
        const response = await $ef717af67d2dc416$var$getContentMediaSession(contentId);
        const contentData = response.data?.contentMediaSession;
        const token = contentData?.token?.value;
        const configuration = contentData?.configuration;
        const collection = contentData?.collection;
        if (!token || !configuration || !collection) throw new Error('Failed to get content media session data');
        return {
            config: configuration,
            token: token,
            collectionId: collection
        };
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-synced-block-provider/fetchMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get content media session: ${errorMsg}`);
    }
};
module.exports["fetchMediaToken"] = $ef717af67d2dc416$export$2b7fb70f168591f8;

});

parcelRegister("hceZu", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $k2in1 = parcelRequire("k2in1");

const $4613ccfbf32aa608$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $4613ccfbf32aa608$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $4613ccfbf32aa608$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $4613ccfbf32aa608$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH = 2048;
const $4613ccfbf32aa608$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_JIRA_MEDIA_TOKEN';
const $4613ccfbf32aa608$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY = `query ${$4613ccfbf32aa608$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME}($issueAri: ID!, $maxTokenLength: Int!) {
  jira {
    issueById(id: $issueAri) {
      mediaReadToken(maxTokenLength: $maxTokenLength) @optIn(to: "JiraMediaReadTokenInIssue") {
        clientId
        endpointUrl
        tokenLifespanInSeconds
        tokensWithFiles {
          edges {
            node {
              token
            }
          }
        }
      }
    }
  }
}`;
const $4613ccfbf32aa608$var$getJiraMediaReadToken = async (issueAri)=>{
    const bodyData = {
        query: $4613ccfbf32aa608$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY,
        operationName: $4613ccfbf32aa608$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME,
        variables: {
            issueAri: issueAri,
            maxTokenLength: $4613ccfbf32aa608$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH
        }
    };
    const response = await (0, $k2in1.fetchWithRetry)($4613ccfbf32aa608$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$4613ccfbf32aa608$var$COMMON_HEADERS,
            ...$4613ccfbf32aa608$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get Jira media read token: ${response.statusText}`);
    return await response.json();
};
const $4613ccfbf32aa608$export$5bc7dcc953e26849 = async (issueAri)=>{
    try {
        const response = await $4613ccfbf32aa608$var$getJiraMediaReadToken(issueAri);
        const mediaReadToken = response.data?.jira?.issueById?.mediaReadToken;
        const clientId = mediaReadToken?.clientId;
        const endpointUrl = mediaReadToken?.endpointUrl;
        // Use the first available token from tokensWithFiles, or fall back to empty string.
        // A generic read token (without specific file IDs) is sufficient for rendering.
        const token = mediaReadToken?.tokensWithFiles?.edges?.[0]?.node?.token ?? '';
        if (!clientId || !endpointUrl) throw new Error('Missing clientId or endpointUrl');
        return {
            config: {
                clientId: clientId,
                fileStoreUrl: endpointUrl
            },
            token: token
        };
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-synced-block-provider/fetchJiraMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get Jira media read token: ${errorMsg}`);
    }
};
module.exports["fetchJiraMediaToken"] = $4613ccfbf32aa608$export$5bc7dcc953e26849;

});

parcelRegister("2TuWI", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL = '/gateway/api/blocks/v1/snippets';
const $15f98e0699368f56$export$73c71f9590626082 = async (snippetId)=>{
    try {
        const response = await (0, $f7B1p.cfetch)(`${$15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL}/${snippetId}/media-token`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        const collectionId = data.collectionNames?.[snippetId];
        return {
            clientId: data.config.clientId,
            token: data.token,
            baseUrl: data.config.fileStoreUrl,
            ...collectionId !== undefined && {
                collectionId: collectionId
            }
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        throw error;
    }
};
module.exports["fetchSnippetMediaToken"] = $15f98e0699368f56$export$73c71f9590626082;

});

parcelRegister("cga1x", function(module, exports) {
/** Define the source of the snippets */ var $bd320fc30ef678ce$export$100829e61c5df591 = /*#__PURE__*/ function(SnippetScope) {
    SnippetScope["GLOBAL"] = "GLOBAL";
    SnippetScope["USER"] = "USER";
    SnippetScope["SITE"] = "SITE";
    return SnippetScope;
}({});
module.exports["SnippetScope"] = $bd320fc30ef678ce$export$100829e61c5df591;

});

parcelRegister("kzNtP", function(module, exports) {

var $9ILXP = parcelRequire("9ILXP");


var $a4TK8 = parcelRequire("a4TK8");

const $852f3734fd3706d8$var$BUFFER_MS = 60000; // refresh token 60 seconds before it expires
const $852f3734fd3706d8$var$EMPTY = [
    -Infinity,
    null,
    null
];
function $852f3734fd3706d8$export$d18015d30d3c28a4(asyncFunction, tokenOrExpInMsAccessor, tokenExpBufferInMs = $852f3734fd3706d8$var$BUFFER_MS) {
    const cache = {};
    async function getValue(arg, force) {
        // It is ok to have clashing hash because we are going to check args anyway
        // Worse case is calling fn() more often than it should
        let hash = '';
        try {
            hash = JSON.stringify(arg);
        } catch  {}
        const [exp, lastArg, lastValue] = cache[hash] || $852f3734fd3706d8$var$EMPTY;
        if (force || exp <= Date.now() || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(lastArg, arg)) {
            const value = await asyncFunction(arg);
            let tokenOrExp = null;
            try {
                tokenOrExp = tokenOrExpInMsAccessor(value);
            } catch (e) {}
            let exp = null;
            if (tokenOrExp) {
                if (!isNaN(tokenOrExp)) exp = Number(tokenOrExp);
                else if (typeof tokenOrExp === 'string') try {
                    exp = (0, $9ILXP.default)(tokenOrExp).exp * 1000 - tokenExpBufferInMs;
                } catch (e) {}
            }
            cache[hash] = exp === null ? $852f3734fd3706d8$var$EMPTY : [
                exp,
                arg,
                value
            ];
            return value;
        }
        return lastValue;
    }
    return {
        forceGetValue: (arg)=>{
            return getValue(arg, true);
        },
        getValue: (arg)=>{
            return getValue(arg, false);
        }
    };
}
module.exports["cacheWithExp"] = $852f3734fd3706d8$export$d18015d30d3c28a4;

});

parcelRegister("c4QoG", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $7EQEd = parcelRequire("7EQEd");

// blueprints/templates in uuid form are technically a new template
const $30f3da79b755ac50$var$isBlueprint = (templateId)=>!/^[0-9]+$/.test(templateId);
const $30f3da79b755ac50$var$isNewTemplate = (templateId)=>!templateId || templateId === '';
const $30f3da79b755ac50$var$shouldUseTemplateId = (templateIds)=>templateIds.length;
const $30f3da79b755ac50$var$formatTemplateId = (templateId, isFirstLoad, isUpload)=>{
    if ($30f3da79b755ac50$var$isNewTemplate(templateId) || $30f3da79b755ac50$var$isBlueprint(templateId) && isUpload || !isFirstLoad) return [];
    else return [
        templateId
    ];
};
const $30f3da79b755ac50$var$cachedGetTemplateUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateUploadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    const session = response?.data?.templateMediaSession;
    const collectionId = session?.collections?.[0]?.value || '';
    return {
        token: session?.uploadToken?.value || '',
        config: session?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        },
        collectionId: collectionId
    };
}, (json)=>json.token);
const $30f3da79b755ac50$var$cachedGetTemplateDownloadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    return {
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        config: response?.data?.templateMediaSession?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        }
    };
}, (json)=>json.token);
const $30f3da79b755ac50$export$ea5d75839efa2930 = async (editorOptions)=>{
    const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !editorOptions.collectionId, true);
    const uploadData = await $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
        ...editorOptions,
        templateIds: templateIds,
        collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : editorOptions.collectionId
    });
    return uploadData.collectionId;
};
const $30f3da79b755ac50$export$8867d7a854cea94a = (contextId)=>{
    let collectionId, templateId, spaceKey = null;
    try {
        ({ collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = JSON.parse(contextId));
    } catch (_) {}
    return {
        collectionId: collectionId,
        templateId: templateId,
        spaceKey: spaceKey
    };
};
const $30f3da79b755ac50$export$c52d46b5239d3052 = async ({ templateId: templateId, collectionId: collectionId, spaceKey: spaceKey })=>{
    // if given a templateId the source is the renderer, otherwise it's the editor
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        templateIds: templateId ? [
            templateId
        ] : [],
        collectionId: templateId ? null : collectionId,
        spaceKey: spaceKey
    });
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.templateMediaSession?.configuration || {};
    return {
        clientId: clientId,
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        baseUrl: fileStoreUrl
    };
};
const $30f3da79b755ac50$var$getAuthFromContext = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = $30f3da79b755ac50$export$8867d7a854cea94a(contextId);
    // templateID = null/undefined -> not template type
    // templateId = "" -> new template
    // templateId = "2394234324" -> user modified template
    // templateId = "23j4h-23jk4h-kj2h34-kj23h4" -> new template
    if (typeof collectionId !== 'string' && typeof templateId !== 'string') // copy source is page contentType
    return (0, $4IoVL.getAuthFromContext)(contextId);
    return $30f3da79b755ac50$export$c52d46b5239d3052({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
};
const $30f3da79b755ac50$export$e7a68a11bc740f17 = (options)=>{
    return {
        authProvider: (0, $4IoVL.createAuthProvider)(async ()=>$30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue(options)),
        getAuthFromContext: $30f3da79b755ac50$var$getAuthFromContext
    };
};
const $30f3da79b755ac50$export$4f3a63958bc8e871 = (options)=>{
    return Promise.resolve({
        viewMediaClientConfig: $30f3da79b755ac50$export$e7a68a11bc740f17(options)
    });
};
const $30f3da79b755ac50$export$582e7673a587f23a = async (options)=>{
    let isFirstDownload = true;
    let collectionId = options.collectionId;
    const getEditorViewTemplateMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(async ()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, isFirstDownload, false);
                isFirstDownload = false;
                return $30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                isFirstDownload = false;
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const getTemplateMediaUploadMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !collectionId, true);
                return $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const viewMediaClientConfig = getEditorViewTemplateMediaClientConfig(options);
    const uploadMediaClientConfig = getTemplateMediaUploadMediaClientConfig(options);
    const collection = await $30f3da79b755ac50$export$ea5d75839efa2930(options);
    collectionId = collection || null;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig
    };
};
module.exports["getTemplateUploadCollectionId"] = $30f3da79b755ac50$export$ea5d75839efa2930;
module.exports["getTemplateMediaContextValues"] = $30f3da79b755ac50$export$8867d7a854cea94a;
module.exports["getTemplateMediaAuth"] = $30f3da79b755ac50$export$c52d46b5239d3052;
module.exports["createRendererTemplateMediaProvider"] = $30f3da79b755ac50$export$4f3a63958bc8e871;
module.exports["createTemplateEditorMediaProvider"] = $30f3da79b755ac50$export$582e7673a587f23a;

});

parcelRegister("7EQEd", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $6UhpO = parcelRequire("6UhpO");


var $23pnW = parcelRequire("23pnW");


var $c0rhi = parcelRequire("c0rhi");

const $bced78bb0973f66e$export$852d9acd488f2352 = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $6UhpO.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
const $bced78bb0973f66e$export$779a7b38112a4dbb = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $23pnW.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "@confluence/fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["getTemplateDownloadToken"] = $bced78bb0973f66e$export$852d9acd488f2352;
module.exports["getTemplateUploadToken"] = $bced78bb0973f66e$export$779a7b38112a4dbb;

});

parcelRegister("6UhpO", function(module, exports) {
/**
 * @generated SignedSource<<6f71e30a6f3ff9ae17bdb70469621c47>>
 * @relayHash 7da80c4186ab379cb41cda405bebee65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1
const $ba0dcc1d393f4102$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "downloadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "7da80c4186ab379cb41cda405bebee65",
            "id": "b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1",
            "metadata": {},
            "name": "TemplateMediaSessionDownloadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionDownloadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},downloadToken{value,duration}}}"
        }
    };
}();
$ba0dcc1d393f4102$var$node.hash = "cb69ec0c674b12c3415c2289771f970f";
var $ba0dcc1d393f4102$export$2e2bcd8739ae039 = $ba0dcc1d393f4102$var$node;
module.exports["default"] = $ba0dcc1d393f4102$export$2e2bcd8739ae039;

});

parcelRegister("23pnW", function(module, exports) {
/**
 * @generated SignedSource<<d8493d612cba7ab67c2663a1ef2f2968>>
 * @relayHash f5528f55bdab5a02587ef6cd5262334d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059
const $d22835c5674bcb0e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "uploadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "f5528f55bdab5a02587ef6cd5262334d",
            "id": "7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059",
            "metadata": {},
            "name": "TemplateMediaSessionUploadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionUploadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},uploadToken{value,duration}}}"
        }
    };
}();
$d22835c5674bcb0e$var$node.hash = "1d0108dcbf48addfcc8b1c4145c7178d";
var $d22835c5674bcb0e$export$2e2bcd8739ae039 = $d22835c5674bcb0e$var$node;
module.exports["default"] = $d22835c5674bcb0e$export$2e2bcd8739ae039;

});

parcelRegister("I0A3i", function(module, exports) {

var $6IsMq = parcelRequire("6IsMq");


var $iTcHJ = parcelRequire("iTcHJ");


var $bS81H = parcelRequire("bS81H");


var $5d9b4 = parcelRequire("5d9b4");


var $9ILXP = parcelRequire("9ILXP");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $c0rhi = parcelRequire("c0rhi");


var $lUobS = parcelRequire("lUobS");


var $62FVQ = parcelRequire("62FVQ");


var $6mmMU = parcelRequire("6mmMU");


var $egLSs = parcelRequire("egLSs");


var $dqLCu = parcelRequire("dqLCu");

const $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery = (0, $bS81H.default);
const $1fd47ba2b01e31e6$var$FetchMediaTokenQuery = (0, $iTcHJ.default);
const $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery = (0, $6IsMq.default);
let $1fd47ba2b01e31e6$var$isFirstLoad = true;
const $1fd47ba2b01e31e6$export$f3bf3f7b03608218 = (requestBody)=>{
    if (requestBody.contentType === 'comment' && (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint')) // Hard disable drag-and-drop upload functionality for comments
    return;
    // Use regular mutation for normal uploads (file browser, copy-paste, etc.)
    return (0, $egLSs.experimentalFileUploadMutate)({
        variables: requestBody
    });
};
const $1fd47ba2b01e31e6$export$2b7fb70f168591f8 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$FetchMediaTokenQuery,
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            missingContentId: !contentId
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoad ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoad = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
let $1fd47ba2b01e31e6$var$isFirstLoadJira = true;
const $1fd47ba2b01e31e6$export$5bc7dcc953e26849 = (issueAri)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery,
        variables: {
            issueAri: issueAri,
            maxTokenLength: 65536
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoadJira ? 'cache-first' : 'network-only',
        __callerPackage__: "@confluence/fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoadJira = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
/**
 * `fetchMediaToken` is called repetitively to renew the token before it
 * expires. If an error condition arises (because of frontend or backend), the
 * same error(s) may be reported as unhandled to our analytics and monitoring at
 * a very high rate/volume. Such repetitive reporting fron one user in one tab
 * is noisy. `throttleFetchMediaTokenErrors` attempts to reduce the noise.
 */ const $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((_cacheKey)=>{
    /**
   * The errors that happened last time. The `GraphQLError` instances are big
   * and are not trivial to compare so `prevErrors` caches partial info.
   */ let prevErrors = undefined;
    return (graphQLErrors, networkError)=>{
        // Each of `graphQLErrors` and `networkError` are reported to analytics and
        // monitoring so type of `Error` does not matter to what follows and
        // `GraphQLError` is the most convenient TypeScript type to deal with.
        if (networkError) graphQLErrors = (graphQLErrors || []).concat(networkError);
        if (graphQLErrors) {
            /**
       * The new/current errors which will become `prevErrors` at the end of
       * this iteration.
       */ const nextErrors = {};
            for (const graphQLError of graphQLErrors){
                // Extract the partial, easy-to-compare, cachable info from the big
                // `GraphQLError` instance:
                const message = graphQLError.message || String(graphQLError) || graphQLError.originalError?.message || String(graphQLError.originalError);
                const { path: path } = graphQLError;
                const key = Array.isArray(path) && path.join('.') || message;
                if (key) {
                    const value = (0, $aMcHK.getStatusCode)(graphQLError) || message;
                    if (value) {
                        nextErrors[key] = value;
                        // If a similar error happened in the previous iteration, do not
                        // report it to analytics and monitoring again:
                        if (prevErrors?.[key] === value) (0, $7Sm4c.markErrorAsHandled)(graphQLError);
                    }
                }
            }
            prevErrors = nextErrors;
        } else // If `MediaDownloadTokenQuery` succeeds, report subsequent/future errors
        // even if similar ones occurred and were reported before the current
        // success - there is a meaningful change in state and it may be useful in
        // debugging.
        prevErrors = undefined;
    };
});
const $1fd47ba2b01e31e6$export$e5e77dc812ab6e52 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $lUobS.default),
        variables: {
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$db4c125247d46dd = (shareToken)=>(0, $c0rhi.queryInterop)({
        query: (0, $dqLCu.default),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$2b96f2ad626f63d2 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "@confluence/fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$de87322aceb1e609 = async (contentId)=>{
    if (!(0, $9wGTI.fg)('confluence-media-upload-token-cache')) return $1fd47ba2b01e31e6$export$2b96f2ad626f63d2(contentId);
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $62FVQ.default),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "@confluence/fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $9ILXP.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4205291ac54c446e = async (contentId, cloudId)=>{
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $6mmMU.default),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "@confluence/fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $9ILXP.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $6mmMU.default),
        variables: {
            cloudId: cloudId,
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4777fc7c5d601381 = (contentId, spaceKey)=>{
    const action = (0, $9wGTI.fg)('cc-dlp_split-attachment-dl-from-export-dsp') ? 'ATTACHMENT_DOWNLOAD' : 'PAGE_EXPORT';
    const variables = {
        action: action,
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1,
        ...spaceKey && {
            spaceKey: spaceKey
        }
    };
    /* Note -> relay compatible query replacement available, in @confluence/data-security package.
   * Using queryInterop for compatibility with Relay migration
   */ return (0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery,
        variables: variables,
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/fabric-media-support"
    });
};
module.exports["setAttachment"] = $1fd47ba2b01e31e6$export$f3bf3f7b03608218;
module.exports["fetchMediaToken"] = $1fd47ba2b01e31e6$export$2b7fb70f168591f8;
module.exports["fetchExternalShareMediaToken"] = $1fd47ba2b01e31e6$export$e5e77dc812ab6e52;
module.exports["fetchExternalContentMediaSessionToken"] = $1fd47ba2b01e31e6$export$db4c125247d46dd;
module.exports["getUploadToken"] = $1fd47ba2b01e31e6$export$de87322aceb1e609;
module.exports["getCommentUploadToken"] = $1fd47ba2b01e31e6$export$4205291ac54c446e;
module.exports["getIsExportEnabledForContent"] = $1fd47ba2b01e31e6$export$4777fc7c5d601381;

});

parcelRegister("lUobS", function(module, exports) {
/**
 * @generated SignedSource<<57e8668d9fe3c9f67ee75bb15b6e474f>>
 * @relayHash ea7172d4f00c5846ec23ab207abff057
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e
const $2624e38a54eebf0f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ea7172d4f00c5846ec23ab207abff057",
            "id": "def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e",
            "metadata": {},
            "name": "ExternalShareMediaDownloadTokenQuery",
            "operationKind": "query",
            "text": "query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{mediaToken{token}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$2624e38a54eebf0f$var$node.hash = "3592e1b2dcd3aa2c38a177d9b363dafe";
var $2624e38a54eebf0f$export$2e2bcd8739ae039 = $2624e38a54eebf0f$var$node;
module.exports["default"] = $2624e38a54eebf0f$export$2e2bcd8739ae039;

});

parcelRegister("62FVQ", function(module, exports) {
/**
 * @generated SignedSource<<025b00e9b31b73f237130d2a69699587>>
 * @relayHash 20688ce23e5e858cfc82d72bb57f43b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c
const $15e95f80a91466f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "20688ce23e5e858cfc82d72bb57f43b8",
            "id": "6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c",
            "metadata": {},
            "name": "MediaUploadTokenQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$15e95f80a91466f9$var$node.hash = "1f89a4aaada59e040e6317ae1cdc704c";
var $15e95f80a91466f9$export$2e2bcd8739ae039 = $15e95f80a91466f9$var$node;
module.exports["default"] = $15e95f80a91466f9$export$2e2bcd8739ae039;

});

parcelRegister("6mmMU", function(module, exports) {
/**
 * @generated SignedSource<<daf984ad5eaae28ba5768f141c1480ac>>
 * @relayHash c06482aa2ab100620d21019ae889668d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37
const $39c17bb60e74ced3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "alias": "contentMediaSession",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "confluence_commentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c06482aa2ab100620d21019ae889668d",
            "id": "6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37",
            "metadata": {},
            "name": "MediaUploadTokenQueryCommentQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQueryCommentQuery($cloudId:ID!,$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId,contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$39c17bb60e74ced3$var$node.hash = "ecbc3538cd4e4434bac2e03ab7969cd8";
var $39c17bb60e74ced3$export$2e2bcd8739ae039 = $39c17bb60e74ced3$var$node;
module.exports["default"] = $39c17bb60e74ced3$export$2e2bcd8739ae039;

});

parcelRegister("egLSs", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

const $7fce44bdcdfe3fe8$export$1b01a64a392afa44 = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
        method: 'POST',
        body: JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResult: ()=>({
                experimentalFileUpload: true
            })
    });
};
module.exports["experimentalFileUploadMutate"] = $7fce44bdcdfe3fe8$export$1b01a64a392afa44;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("dqLCu", function(module, exports) {
/**
 * @generated SignedSource<<4edd735d079b37bb48067afaa74a4066>>
 * @relayHash c64eff3bdc2352e89d29fc9d40e39f79
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255
const $b85e553ccc70de04$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shareToken"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "externalContentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readWriteToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c64eff3bdc2352e89d29fc9d40e39f79",
            "id": "0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255",
            "metadata": {},
            "name": "ExternalContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl,clientId}}}"
        }
    };
}();
$b85e553ccc70de04$var$node.hash = "73d645a33a55cbb7625d57b6d5cf2a1a";
var $b85e553ccc70de04$export$2e2bcd8739ae039 = $b85e553ccc70de04$var$node;
module.exports["default"] = $b85e553ccc70de04$export$2e2bcd8739ae039;

});

parcelRegister("kQiXs", function(module, exports) {

var $I0A3i = parcelRequire("I0A3i");

const $c59debd6932d7898$var$noop = ()=>{};
const $c59debd6932d7898$export$ad897c91dfb246e9 = (options)=>{
    if (options.contentId && options.contentType) return (file)=>{
        const { id: id, name: name, size: size, mimeType: mimeType } = file;
        const { contentId: contentId, contentType: contentType } = options;
        const requestBody = {
            size: size,
            contentType: contentType,
            mimeType: mimeType,
            fileName: name,
            pageId: contentId,
            fileStoreId: id,
            minorEdit: true,
            renderEditorHTML: false,
            collectionName: `contentId-${contentId}`,
            uploadSource: 'fabric-editor'
        };
        (0, $I0A3i.setAttachment)(requestBody);
    };
    else return $c59debd6932d7898$var$noop;
};
module.exports["attachUploadedMedia"] = $c59debd6932d7898$export$ad897c91dfb246e9;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.ACCESS_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("jibmA", function(module, exports) {

var $60cDW = parcelRequire("60cDW");

const $005667118ff06aa5$export$b98882f166bb7ce2 = (url)=>{
    const windowHostname = typeof window !== 'undefined' && window.location ? window.location.hostname : (0, $60cDW.getSSRRenderInputs)().host;
    // Only including support for certain Jira paths to minimise hardcoding
    const linkClickExceptionPaths = [
        '/browse',
        '/jira'
    ];
    let urlObject;
    try {
        // Resolve against the current host so relative URLs (e.g. /browse/ABC-1) parse correctly.
        urlObject = url && new URL(url, windowHostname ? `https://${windowHostname}` : undefined);
    } catch  {}
    const { hostname: hostname, pathname: pathname } = urlObject || {};
    return hostname && windowHostname && hostname !== windowHostname || linkClickExceptionPaths.some((exceptionPath)=>pathname?.startsWith(exceptionPath));
};
module.exports["isExternalLink"] = $005667118ff06aa5$export$b98882f166bb7ce2;

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("8QQGs", function(module, exports) {
"use strict";
var $671c0bfbaf864118$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $671c0bfbaf864118$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $671c0bfbaf864118$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $671c0bfbaf864118$var$catchError;
var $671c0bfbaf864118$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $671c0bfbaf864118$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $671c0bfbaf864118$var$CatchSubscriber = function(_super) {
    $671c0bfbaf864118$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($dZ9AU.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("2mnXV", function(module, exports) {
"use strict";
var $1b8039eb254298fd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $1b8039eb254298fd$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $1b8039eb254298fd$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $1b8039eb254298fd$var$distinctUntilChanged;
var $1b8039eb254298fd$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1b8039eb254298fd$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1b8039eb254298fd$var$DistinctUntilChangedSubscriber = function(_super) {
    $1b8039eb254298fd$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $3FcLR.tryCatch(this.keySelector)(value);
            if (key === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $3FcLR.tryCatch(this.compare)(this.key, key);
            if (result === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($axeml.Subscriber);

});

parcelRegister("3VDUL", function(module, exports) {
"use strict";
var $2dc5a83127dcb05a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $2dc5a83127dcb05a$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $2dc5a83127dcb05a$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $2dc5a83127dcb05a$var$skipWhile;
var $2dc5a83127dcb05a$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2dc5a83127dcb05a$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2dc5a83127dcb05a$var$SkipWhileSubscriber = function(_super) {
    $2dc5a83127dcb05a$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($axeml.Subscriber);

});

parcelRegister("j8M4E", function(module, exports) {
"use strict";
var $def40e2be1e8c847$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $def40e2be1e8c847$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $def40e2be1e8c847$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $def40e2be1e8c847$var$switchMap;
var $def40e2be1e8c847$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $def40e2be1e8c847$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $def40e2be1e8c847$var$SwitchMapSubscriber = function(_super) {
    $def40e2be1e8c847$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $dZ9AU.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("i3vZV", function(module, exports) {
"use strict";
var $d25153e5d88b6a52$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

function $d25153e5d88b6a52$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $d25153e5d88b6a52$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $d25153e5d88b6a52$var$timeInterval;
var $d25153e5d88b6a52$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $d25153e5d88b6a52$var$TimeInterval;
var $d25153e5d88b6a52$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $d25153e5d88b6a52$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d25153e5d88b6a52$var$TimeIntervalSubscriber = function(_super) {
    $d25153e5d88b6a52$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $d25153e5d88b6a52$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ePuNq", function(module, exports) {
"use strict";
var $acbdb7992e24bbb8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6GdLZ = parcelRequire("6GdLZ");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $acbdb7992e24bbb8$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteTimeout = $kVeeY.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $acbdb7992e24bbb8$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $6GdLZ.TimeoutError()));
    };
}
module.exports.timeout = $acbdb7992e24bbb8$var$timeout;
var $acbdb7992e24bbb8$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $acbdb7992e24bbb8$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $acbdb7992e24bbb8$var$TimeoutSubscriber = function(_super) {
    $acbdb7992e24bbb8$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($axeml.Subscriber);

});

parcelRegister("6GdLZ", function(module, exports) {
"use strict";
var $4dd15960f755eae6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $4dd15960f755eae6$var$TimeoutError = function(_super) {
    $4dd15960f755eae6$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $4dd15960f755eae6$var$TimeoutError;

});

parcelRegister("5h38X", function(module, exports) {
"use strict";
var $3d70fa8830a46307$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $bGuMq = parcelRequire("bGuMq");

/**
 * @class BehaviorSubject<T>
 */ var $3d70fa8830a46307$var$BehaviorSubject = function(_super) {
    $3d70fa8830a46307$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($augeV.Subject);
module.exports.BehaviorSubject = $3d70fa8830a46307$var$BehaviorSubject;

});

parcelRegister("1a6Dn", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $hrAmX = parcelRequire("hrAmX");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $42omo.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $42omo.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const batchResultData = batchResult?.data;
    const batchResultError = batchResult?.error;
    const batchResultLoading = batchResult?.loading;
    const completedBatchResultKeyRef = (0, $42omo.useRef)(null);
    const baseOptions = {
        variables: variables,
        skip: Boolean(batchResult),
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY) && // Keep watching query for home route to avoid VC90 regression
    (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "@confluence/web-panel-location"
    });
    const result = batchResult ?? {
        loading: loading,
        data: data,
        error: error
    };
    (0, $42omo.useEffect)(()=>{
        if (batchResultLoading || batchResultError || !batchResultData || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResultData,
        batchResultError,
        batchResultLoading,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    const panels = (result.data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: result.loading,
        error: result.error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("7VJPz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a2xFu = parcelRequire("a2xFu");

var $kYvrE = parcelRequire("kYvrE");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $1lyRS = parcelRequire("1lyRS");

const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $a2xFu.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $kYvrE.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lyRS.SmartButtonLoader), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("5kjCz", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $2XqLN.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $42omo.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $42omo.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("1lyRS", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("g6kbH"))).SmartButton
});
module.exports["SmartButtonLoader"] = $16e92128cf9491a8$export$32d8d71ddecea49c;

});

parcelRegister("g6kbH", function(module, exports) {

let $bb8cddb85750a6c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bb8cddb85750a6c0$var$load("lbsQO"),
    $bb8cddb85750a6c0$var$load("b9CA3"),
    $bb8cddb85750a6c0$var$load("6wr18"),
    $bb8cddb85750a6c0$var$load("gctwz"),
    $bb8cddb85750a6c0$var$load("ffEVr"),
    $bb8cddb85750a6c0$var$load("hhss7"),
    $bb8cddb85750a6c0$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("lOeVN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $42omo.useRef)();
    propsRef.current = props;
    return (0, $42omo.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("1421M"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("1421M", function(module, exports) {

let $0c67bcd931c05ad3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c67bcd931c05ad3$var$load("6wr18"),
    $0c67bcd931c05ad3$var$load("ffEVr"),
    $0c67bcd931c05ad3$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: true,
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    return (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("1SPMi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $k7eoe = parcelRequire("k7eoe");


var $bQm3c = parcelRequire("bQm3c");


var $2SowE = parcelRequire("2SowE");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $k7eoe.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $k7eoe.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("iP9x4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $5yfLD = parcelRequire("5yfLD");


var $4h1jl = parcelRequire("4h1jl");


var $9wGTI = parcelRequire("9wGTI");


var $4IoVL = parcelRequire("4IoVL");

const $2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $2c59df77bd212c3d$var$isServerEnvironment = ()=>undefined;
const $2c59df77bd212c3d$var$isClientEnvironment = ()=>window.__SSR_RENDERED__;
const $2c59df77bd212c3d$var$getInitialAuth = (config)=>{
    const recordedAuth = config.contentProduct === 'jira-work-item' ? (0, $4h1jl.jiraMediaConfigRecorder)?.get() : (0, $4h1jl.mediaConfigRecorder)?.get();
    if (!recordedAuth) return undefined;
    return {
        ...recordedAuth,
        // If the mediaToken is provided in the config, use it.
        // This ensures the correct token is used in cases where the token differs from
        // the initial page, such as media included through an `include` macro.
        token: config?.mediaToken || recordedAuth.token
    };
};
const $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy = ()=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const shouldEnforceDataSecurityPolicy = (0, $4h1jl.mediaConfigEnforceDSPRecorder)?.get();
    return !!shouldEnforceDataSecurityPolicy;
};
const $2c59df77bd212c3d$var$getServerModeConfig = (config)=>({
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: $2c59df77bd212c3d$var$getInitialAuth(config),
            enforceDataSecurityPolicy: $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy()
        }
    });
const $2c59df77bd212c3d$var$createClientAuthProvider = ({ contentAri: contentAri, contentId: contentId, contentProduct: contentProduct, spaceKey: spaceKey, isExternalShare: isExternalShare, mediaToken: mediaToken })=>async (authContext)=>{
        if (!!contentId && (!!spaceKey || contentProduct === 'jira-work-item')) {
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare,
                mediaToken: mediaToken
            });
            return viewMediaClientConfig.authProvider(authContext);
        } else throw new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR);
    };
const $2c59df77bd212c3d$var$getClientModeConfig = (config)=>({
        mode: 'client',
        config: {
            authProvider: $2c59df77bd212c3d$var$createClientAuthProvider(config),
            initialAuth: config.contentProduct === 'jira-work-item' ? window.__JIRA_MEDIA_CONFIG__ : window.__MEDIA_CONFIG__,
            enforceDataSecurityPolicy: window.__MEDIA_CONFIG_ENFORCE_DSP__
        }
    });
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig = (config)=>{
    if ($2c59df77bd212c3d$var$isServerEnvironment()) return $2c59df77bd212c3d$var$getServerModeConfig(config);
    else if ($2c59df77bd212c3d$var$isClientEnvironment()) return $2c59df77bd212c3d$var$getClientModeConfig(config);
};
const $2c59df77bd212c3d$export$85decadf1b9d641b = (0, $2XqLN.default)($2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig, (0, (/*@__PURE__*/$parcel$interopDefault($5yfLD))));
const $2c59df77bd212c3d$export$45c8e19bd67cadee = (config)=>{
    return $2c59df77bd212c3d$export$85decadf1b9d641b(config);
};
module.exports["getMediaSSRModeAndAuthConfigMemoized"] = $2c59df77bd212c3d$export$85decadf1b9d641b;
module.exports["useMediaSSRModeAndAuthConfig"] = $2c59df77bd212c3d$export$45c8e19bd67cadee;

});

parcelRegister("4h1jl", function(module, exports) {

var $2BiLx = parcelRequire("2BiLx");

const $c75b7ce9b9db2aec$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$269fe681eda28e68 = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
module.exports["mediaConfigRecorder"] = $c75b7ce9b9db2aec$export$279f2f878f49d0df;
module.exports["jiraMediaConfigRecorder"] = $c75b7ce9b9db2aec$export$269fe681eda28e68;
module.exports["mediaConfigEnforceDSPRecorder"] = $c75b7ce9b9db2aec$export$e125b144e38aa5db;

});

parcelRegister("2BiLx", function(module, exports) {
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    reset() {
        this.object = null;
    }
    constructor(){
        this.object = null;
    }
}
module.exports["ObjectRecorder"] = $53dcea44a491523c$export$e411414ea02dd271;

});

parcelRegister("bMPhU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "@confluence/space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<9c89aa0352f7d1dca5a5a1271100cc40>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("jIiuI", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $669e2d348d1011a7$export$6a671bebd9daad64 = (0, $42omo.createContext)((0, $1Aku8.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $669e2d348d1011a7$export$6a671bebd9daad64;

});

parcelRegister("grQpA", function(module, exports) {
var $3afb5a6a58db13d7$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $3afb5a6a58db13d7$export$1a949ef92fd30eca = (error)=>{
    return error instanceof Error && error.name === 'RelayNetwork' && 'source' in error && Array.isArray(error.source?.errors);
};
const $3afb5a6a58db13d7$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $3afb5a6a58db13d7$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $3afb5a6a58db13d7$export$d76ef0f862d061a6;
module.exports["isRelayNetworkError"] = $3afb5a6a58db13d7$export$1a949ef92fd30eca;
module.exports["isGQLGatewayError"] = $3afb5a6a58db13d7$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $3afb5a6a58db13d7$export$9c0545f564a8227f;

});

parcelRegister("1Igmn", function(module, exports) {
// our service
const $0be0f811af274f82$var$SERVICE = 'forge-ui';
const $0be0f811af274f82$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $0be0f811af274f82$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $0be0f811af274f82$export$14ef296862e3705e;

});

parcelRegister("5U2YR", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $jIiuI = parcelRequire("jIiuI");

const $a50a0967117e6a0e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $42omo.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $a50a0967117e6a0e$export$163ecee29aa3a8f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { value: value, children: children } = t0;
    const envFromContext = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    let t1;
    let t2;
    if ($[0] !== envFromContext || $[1] !== environment || $[2] !== page || $[3] !== product) {
        t1 = ()=>({
                environment: environment ?? envFromContext,
                product: product,
                page: page
            });
        t2 = [
            page,
            environment,
            envFromContext,
            product
        ];
        $[0] = envFromContext;
        $[1] = environment;
        $[2] = page;
        $[3] = product;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    const memoedValue = (0, $hQK66.useMemoOne)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== memoedValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a50a0967117e6a0e$export$b438ce9ad9530ae5.Provider, {
            value: memoedValue
        }, children);
        $[6] = children;
        $[7] = memoedValue;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ value: value, children: children })=>{
    const envFromContext = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $hQK66.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a50a0967117e6a0e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $a50a0967117e6a0e$export$dba2dab0d0f39612 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($a50a0967117e6a0e$export$b438ce9ad9530ae5);
} : ()=>{
    return (0, $42omo.useContext)($a50a0967117e6a0e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $a50a0967117e6a0e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $a50a0967117e6a0e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $a50a0967117e6a0e$export$dba2dab0d0f39612;

});

parcelRegister("3Spjc", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $7TH2w = parcelRequire("7TH2w");

const $ee4a4828226e63ce$export$d28801614368e543 = 'forge-ui';
const $ee4a4828226e63ce$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $7TH2w.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $7TH2w.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $7TH2w.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $ee4a4828226e63ce$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
const $ee4a4828226e63ce$var$ForgeUIAnalyticsListener = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, client: client, commonAttributes: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const commonAttributes = t2;
    let t3;
    if ($[2] !== client || $[3] !== commonAttributes) {
        t3 = (event)=>{
            const { eventType: eventType, data: data } = event.payload;
            const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
            const forgeUIAnalyticsContext = $ee4a4828226e63ce$var$getPayloadAttributesFromContext(event.context);
            const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? "unknown";
            const payload = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                ...forgeUIAnalyticsContext,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...event.context.reduce($ee4a4828226e63ce$var$_temp, {}),
                    ...attributes
                },
                tags: tags
            };
            $ee4a4828226e63ce$export$7329bcdc3edcd90e(client)({
                eventType: eventType,
                ...payload
            });
        };
        $[2] = client;
        $[3] = commonAttributes;
        $[4] = t3;
    } else t3 = $[4];
    const listenerHandler = t3;
    let t4;
    if ($[5] !== children || $[6] !== listenerHandler) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
            onEvent: listenerHandler,
            channel: $ee4a4828226e63ce$export$d28801614368e543
        }, children);
        $[5] = children;
        $[6] = listenerHandler;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $ee4a4828226e63ce$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $ee4a4828226e63ce$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: listenerHandler,
        channel: $ee4a4828226e63ce$export$d28801614368e543
    }, children);
};
var $ee4a4828226e63ce$export$2e2bcd8739ae039 = $ee4a4828226e63ce$var$ForgeUIAnalyticsListener;
function $ee4a4828226e63ce$var$_temp(prev, curr) {
    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === "object" ? curr.forgeUIAttributes : {};
    return {
        ...prev,
        ...forgeUIAttributes
    };
}
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $ee4a4828226e63ce$export$d28801614368e543;
module.exports["sendEvent"] = $ee4a4828226e63ce$export$7329bcdc3edcd90e;
module.exports["default"] = $ee4a4828226e63ce$export$2e2bcd8739ae039;

});

parcelRegister("39Ajm", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dh538 = parcelRequire("dh538");

const $2ce486181186726b$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2ce486181186726b$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$54ff27488d768aba = (0, $eSUdr.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2ce486181186726b$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2ce486181186726b$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2ce486181186726b$export$54ff27488d768aba;

});

parcelRegister("7zIsq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gNyf6 = parcelRequire("gNyf6");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $xQxzY = parcelRequire("xQxzY");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");


var $8VYSW = parcelRequire("8VYSW");

const $f6a9c96fc0de3888$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $f6a9c96fc0de3888$export$88e0391b02a3c5c9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions } = t0;
    let t1;
    if ($[0] !== client || $[1] !== cloudId || $[2] !== context || $[3] !== includeHidden || $[4] !== locale || $[5] !== queryOptions || $[6] !== types) {
        t1 = $f6a9c96fc0de3888$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
        $[0] = client;
        $[1] = cloudId;
        $[2] = context;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = queryOptions;
        $[6] = types;
        $[7] = t1;
    } else t1 = $[7];
    const requestOptions = t1;
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $39Ajm.FetchPreFilteredForgeAppsQuery), requestOptions);
    let t2;
    if ($[8] !== data || $[9] !== loading) {
        t2 = $f6a9c96fc0de3888$export$55348c7eb6377fe1({
            loading: loading,
            data: data
        });
        $[8] = data;
        $[9] = loading;
        $[10] = t2;
    } else t2 = $[10];
    const extensions = t2;
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== extensions || $[13] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[11] = createAnalyticsEvent;
        $[12] = extensions;
        $[13] = page;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[16] !== createAnalyticsEvent || $[17] !== error || $[18] !== extensions || $[19] !== page) {
        t5 = ()=>{
            if (!extensions && error && error.graphQLErrors.length > 0) {
                const err_0 = error.graphQLErrors.find($f6a9c96fc0de3888$var$_temp);
                createAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "usePrefilteredExtensionList",
                            errorName: err_0 ? (0, $grQpA.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[16] = createAnalyticsEvent;
        $[17] = error;
        $[18] = extensions;
        $[19] = page;
        $[20] = t5;
        $[21] = t6;
    } else {
        t5 = $[20];
        t6 = $[21];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[22] !== extensions) {
        t7 = extensions || [];
        $[22] = extensions;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== error || $[25] !== loading || $[26] !== t7) {
        t8 = {
            error: error,
            extensions: t7,
            loading: loading
        };
        $[24] = error;
        $[25] = loading;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $f6a9c96fc0de3888$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $39Ajm.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $f6a9c96fc0de3888$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err_0 = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err_0 ? (0, $grQpA.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $f6a9c96fc0de3888$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
const $f6a9c96fc0de3888$var$fetchRequests = new Map();
const $f6a9c96fc0de3888$export$f55e1916fecb1860 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types } = t0;
    const environment = (0, $irOoi.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $42omo.useState)(null);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== context || $[2] !== environment || $[3] !== includeHidden || $[4] !== locale || $[5] !== types) {
        t1 = ()=>{
            const cacheKey = JSON.stringify({
                cloudId: cloudId,
                context: context,
                includeHidden: includeHidden,
                locale: locale,
                types: types
            });
            if (!$f6a9c96fc0de3888$var$fetchRequests.has(cacheKey)) {
                const extensions_0 = new Promise((resolve, reject)=>{
                    (0, $irOoi.fetchQuery)(environment, (0, $gNyf6.default), {
                        cloudId: cloudId,
                        context: context,
                        includeHidden: includeHidden,
                        locale: locale,
                        types: types
                    }, {
                        networkCacheConfig: {
                            metadata: {
                                headers: {
                                    "atl-attribution": (0, $1Igmn.createAtlAttributionHeader)(cloudId)
                                },
                                allowOnExternalPage: true
                            }
                        }
                    }).subscribe({
                        next: (data)=>{
                            resolve($f6a9c96fc0de3888$export$55348c7eb6377fe1({
                                data: data,
                                loading: false
                            }));
                        },
                        error: (error_0)=>{
                            $f6a9c96fc0de3888$var$fetchRequests.delete(cacheKey);
                            reject(error_0);
                        }
                    });
                });
                $f6a9c96fc0de3888$var$fetchRequests.set(cacheKey, extensions_0);
            }
            $f6a9c96fc0de3888$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
                setExtensions(extensions_1);
                setLoading(false);
            }).catch((error_1)=>{
                setError(error_1);
                setLoading(false);
            });
        };
        t2 = [
            cloudId,
            context,
            includeHidden,
            locale,
            types,
            environment
        ];
        $[0] = cloudId;
        $[1] = context;
        $[2] = environment;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = types;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[8] !== createAnalyticsEvent || $[9] !== extensions || $[10] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[8] = createAnalyticsEvent;
        $[9] = extensions;
        $[10] = page;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[13] !== createAnalyticsEvent || $[14] !== error || $[15] !== extensions || $[16] !== page) {
        t5 = ()=>{
            if (!extensions && error && (0, $grQpA.isRelayNetworkError)(error)) {
                const err_0 = error.source.errors.find($f6a9c96fc0de3888$var$_temp2);
                createAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "useExtensionList",
                            errorName: err_0 ? (0, $grQpA.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[13] = createAnalyticsEvent;
        $[14] = error;
        $[15] = extensions;
        $[16] = page;
        $[17] = t5;
        $[18] = t6;
    } else {
        t5 = $[17];
        t6 = $[18];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[19] !== extensions) {
        t7 = extensions || [];
        $[19] = extensions;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== error || $[22] !== loading || $[23] !== t7) {
        t8 = {
            extensions: t7,
            loading: loading,
            error: error
        };
        $[21] = error;
        $[22] = loading;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types })=>{
    const environment = (0, $irOoi.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $42omo.useState)(null);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const cacheKey = JSON.stringify({
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden,
            locale: locale,
            types: types
        });
        if (!$f6a9c96fc0de3888$var$fetchRequests.has(cacheKey)) {
            const extensions_0 = new Promise((resolve, reject)=>{
                (0, $irOoi.fetchQuery)(environment, (0, $gNyf6.default), {
                    cloudId: cloudId,
                    context: // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                    context,
                    includeHidden: includeHidden,
                    locale: locale,
                    types: types
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(cloudId)
                            },
                            allowOnExternalPage: true
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve($f6a9c96fc0de3888$export$55348c7eb6377fe1({
                            data: data,
                            loading: false
                        }));
                    },
                    error: (error_0)=>{
                        $f6a9c96fc0de3888$var$fetchRequests.delete(cacheKey);
                        reject(error_0);
                    }
                });
            });
            $f6a9c96fc0de3888$var$fetchRequests.set(cacheKey, extensions_0);
        }
        $f6a9c96fc0de3888$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
            setExtensions(extensions_1);
            setLoading(false);
        }).catch((error_1)=>{
            setError(error_1);
            setLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        locale,
        types,
        environment
    ]);
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $grQpA.isRelayNetworkError)(error)) {
            const err_0 = error.source.errors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err_0 ? (0, $grQpA.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
function $f6a9c96fc0de3888$var$_temp(err) {
    return (0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err);
}
function $f6a9c96fc0de3888$var$_temp2(err) {
    return (0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err);
}
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $f6a9c96fc0de3888$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $f6a9c96fc0de3888$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $f6a9c96fc0de3888$export$55348c7eb6377fe1;
module.exports["usePrefilteredExtensionListRelay"] = $f6a9c96fc0de3888$export$f55e1916fecb1860;

});

parcelRegister("gNyf6", function(module, exports) {
/**
 * @generated SignedSource<<34b9bd3d4874799a2e3dfbdec507c380>>
 * @relayHash 57057313f17699c6ffabb286b9a1141a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 849f20631fa84f3517a0c2c9b324c8769fe830778f9926f3c77e8c60cb80034b
const $c701b66f5c3386e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "849f20631fa84f3517a0c2c9b324c8769fe830778f9926f3c77e8c60cb80034b",
            "metadata": {},
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c701b66f5c3386e6$var$node.hash = "d028e6b4d01b71cf67c24b6983fbfddf";
var $c701b66f5c3386e6$export$2e2bcd8739ae039 = $c701b66f5c3386e6$var$node;
module.exports["default"] = $c701b66f5c3386e6$export$2e2bcd8739ae039;

});

parcelRegister("1l37u", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a816caaccdbc6f4f$export$6107f09ca09b8b5f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    embeddedParentModalKey: undefined,
    setEmbeddedParentModalKey: ()=>{},
    forwarder: ()=>Promise.resolve()
});
module.exports["EmbeddedModalContext"] = $a816caaccdbc6f4f$export$6107f09ca09b8b5f;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("62fWd", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jIiuI = parcelRequire("jIiuI");

var $5U2YR = parcelRequire("5U2YR");


var $3Spjc = parcelRequire("3Spjc");

const $3c9dbf4421667f34$export$64f0f7e9be5f8ff = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children } = t0;
    let t1;
    if ($[0] !== page || $[1] !== product) {
        t1 = {
            product: product,
            page: page
        };
        $[0] = page;
        $[1] = product;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== page) {
        t2 = {
            moduleType: page
        };
        $[3] = page;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== analyticsWebClient || $[6] !== children || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Spjc.default), {
            client: analyticsWebClient,
            commonAttributes: t2
        }, children);
        $[5] = analyticsWebClient;
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t1 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5U2YR.MetricsContextProvider), {
            value: t1
        }, t3);
        $[9] = t1;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== environment || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIiuI.EnvironmentContext).Provider, {
            value: environment
        }, t4);
        $[12] = environment;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIiuI.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5U2YR.MetricsContextProvider), {
        value: {
            product: product,
            page: page
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Spjc.default), {
        client: analyticsWebClient,
        commonAttributes: {
            moduleType: page
        }
    }, children)));
};
module.exports["ForgeUIExtensionPointProvider"] = $3c9dbf4421667f34$export$64f0f7e9be5f8ff;

});

parcelRegister("kksmx", function(module, exports) {
const $e82f7a932bbd9bed$export$66373c7c22b9de3c = '__LEGACY_MACRO_SSRED__';
const $e82f7a932bbd9bed$export$583da28e18e772e3 = (macroOutput, macroData)=>{
    if (macroOutput) return 'ssr-new';
    else if (macroData) return 'ssr-exp';
    return 'ssr-legacy';
};
const $e82f7a932bbd9bed$export$90da570939dfebac = (macroId)=>window[$e82f7a932bbd9bed$export$66373c7c22b9de3c]?.[macroId];
const $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c = ({ macroId: macroId, renderType: renderType })=>{
    return null;
};
module.exports["getRenderType"] = $e82f7a932bbd9bed$export$583da28e18e772e3;
module.exports["getExtensionSSRMark"] = $e82f7a932bbd9bed$export$90da570939dfebac;
module.exports["ExtensionSSRMark"] = $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c;

});

parcelRegister("foRF9", function(module, exports) {

var $aoRTi = parcelRequire("aoRTi");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $aMlgD = parcelRequire("aMlgD");


var $6mEZ3 = parcelRequire("6mEZ3");

const $5faed47790e8728c$var$isBlueprint = (contentId)=>!/^[0-9]+$/.test(contentId);
const $5faed47790e8728c$export$74ec65bf601b5f8c = async (options)=>{
    const { macroDefinition: macroDefinition, contentId: contentId, selectedMacro: selectedMacro, intl: intl } = options;
    const results = await (0, $aoRTi.experimentalMacroPlaceholderADFQuery)({
        variables: {
            contentId: $5faed47790e8728c$var$isBlueprint(contentId) ? '0' : contentId ?? '0',
            macroDefinition: JSON.stringify(macroDefinition)
        }
    });
    let placeholderAdf;
    try {
        if (results?.data) placeholderAdf = JSON.parse(results?.data?.experimentalMacroPlaceholderADF?.json);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Error getting placeholder ADF');
    }
    const adf = {
        ...placeholderAdf
    };
    if ((0, $fgbpl.isBodiedExtension)(adf.type)) {
        if (selectedMacro) // Copy the macro contents into the adf node
        adf.content = selectedMacro.content;
        else if (!adf.content || adf.content.length === 0) {
            if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.EMPTY_ADF_CONTENT);
            if (adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.MULTI_BODIED_INITIAL_CONTENT);
        }
    }
    const macroAttributes = (0, $6mEZ3.formatAsMacroAttributes)(adf);
    if (intl) {
        const macroTitleOverride = (0, $aMlgD.getMacroTitleOverride)(macroDefinition.name, intl);
        if (macroTitleOverride && macroAttributes.attrs.parameters?.macroMetadata) macroAttributes.attrs.parameters.macroMetadata.title = macroTitleOverride;
    }
    return macroAttributes;
};
module.exports["fetchMacroAttributes"] = $5faed47790e8728c$export$74ec65bf601b5f8c;

});

parcelRegister("aoRTi", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $fef05c831d419c6c$export$145bdd0c11f23103 = async ({ variables: variables })=>{
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: '/wiki/rest/internal/1.0/macro/placeholder',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            macro: JSON.parse(variables.macroDefinition),
            contentId: variables.contentId
        }),
        parseResponseOnError: (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                __badStatusError: true
            };
            throw error;
        },
        parseResult: (json)=>{
            if (json && typeof json === 'object' && '__badStatusError' in json) return {
                experimentalMacroPlaceholderADF: {
                    json: ''
                }
            };
            return {
                experimentalMacroPlaceholderADF: {
                    json: JSON.stringify(json)
                }
            };
        },
        variables: variables
    });
    return {
        data: result.data
    };
};
module.exports["experimentalMacroPlaceholderADFQuery"] = $fef05c831d419c6c$export$145bdd0c11f23103;

});

parcelRegister("fgbpl", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $aba988feb2cb54c3$export$b05e83f63451e97 = (extensionType)=>{
    return [
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)
    ].indexOf(extensionType) >= 0;
};
module.exports["isBodiedExtension"] = $aba988feb2cb54c3$export$b05e83f63451e97;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3wBuN = parcelRequire("3wBuN");


var $esRft = parcelRequire("esRft");


var $gj7hi = parcelRequire("gj7hi");


var $chO1Z = parcelRequire("chO1Z");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $gMc0m.default)([
            "_1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $42omo.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_2mzuglyw",
    classIconStyles: "_2rkofajl",
    iconStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $42omo.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_17261kzg _17lp134g _15d44clk",
            "_17261772 _17lp1wkm _15d4zabe",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $7sObp.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $7sObp.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $gMc0m.default)([
            "_2rkofajl _ca0q1b66 _y3gn1h6o _bfhk1i45",
            "_17261kzg _17lp134g _15d44clk",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $2XqLN = parcelRequire("2XqLN");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $aXWIB.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $2XqLN.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $2XqLN.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $2XqLN.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $2XqLN.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $2XqLN.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("4eJH6", function(module, exports) {
var $7dcc17f1ea6ba5ae$export$b573856c46cc9357 = /*#__PURE__*/ function(CalendarView) {
    CalendarView["dayGridMonth"] = "dayGridMonth";
    CalendarView["timeGridWeek"] = "timeGridWeek";
    CalendarView["listMonth"] = "listMonth";
    CalendarView["list"] = "list";
    CalendarView["timeline"] = "timeline";
    return CalendarView;
}({});
var $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8 = /*#__PURE__*/ function(CalendarViewPreference) {
    CalendarViewPreference["month"] = "month";
    CalendarViewPreference["agendaWeek"] = "agendaWeek";
    CalendarViewPreference["basicDay"] = "basicDay";
    CalendarViewPreference["timeline"] = "timeline";
    return CalendarViewPreference;
}({});
module.exports["CalendarView"] = $7dcc17f1ea6ba5ae$export$b573856c46cc9357;
module.exports["CalendarViewPreference"] = $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8;

});

parcelRegister("ltKTq", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c9e0854a72739c18$export$feb9e2d8bc9b9b85 = /*#__PURE__*/ function(CALENDAR_CONTEXT) {
    CALENDAR_CONTEXT["SPACE_CALENDARS"] = "spaceCalendars";
    CALENDAR_CONTEXT["MY_CALENDARS"] = "myCalendars";
    CALENDAR_CONTEXT["SPACE_SUBCALENDAR"] = "spaceSubCalendar";
    CALENDAR_CONTEXT["EMBEDDED_SUBCALENDAR"] = "embeddedSubCalendar";
    CALENDAR_CONTEXT["MULTIPLE_CALENDARS"] = "multipleCalendars";
    CALENDAR_CONTEXT["EMBEDDED_MULTIPLE_CALENDARS"] = "embeddedMultipleCalendars";
    CALENDAR_CONTEXT["MACRO"] = "macro";
    return CALENDAR_CONTEXT;
}({});
const $c9e0854a72739c18$var$TCContext = /*#__PURE__*/ (0, $42omo.createContext)({});
const $c9e0854a72739c18$export$5f8036cb54c4d559 = ()=>{
    const context = (0, $42omo.useContext)($c9e0854a72739c18$var$TCContext);
    if (context === undefined) throw new Error('useTCContextDispatch must be used within TCContextProvider');
    return context;
};
let $c9e0854a72739c18$var$initialState;
const $c9e0854a72739c18$var$getInitialState = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents, firstDay: firstDay })=>{
    return(// @ts-expect-error - TS2454 Typescript 5.9.2 upgrade
    $c9e0854a72739c18$var$initialState || {
        calendars: calendars,
        events: [],
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        viewDate: new Date(),
        dateTimeFormatOptions: {
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: userTimeFormat === 'displayTimeFormat12' ? 'h12' : 'h23',
            timeZone: userTimeZoneId
        },
        calendarErrors: [],
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
};
const $c9e0854a72739c18$var$AT = {
    SET_EVENTS: 'SET_EVENTS',
    SET_CALENDAR_EVENTS: 'SET_CALENDAR_EVENTS',
    SET_CALENDARS: 'SET_CALENDARS',
    SET_VIEW_DATE: 'SET_VIEW_DATE',
    SET_CALENDAR_ERRORS: 'SET_CALENDAR_ERRORS',
    SET_IS_LOADING_EVENTS: 'SET_IS_LOADING_EVENTS',
    SET_FIRST_DAY: 'SET_FIRST_DAY'
};
const $c9e0854a72739c18$export$97f0c60a5aa0f317 = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, children: children, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents = false, firstDay: firstDay = 1 })=>{
    const initialState = $c9e0854a72739c18$var$getInitialState({
        calendars: calendars,
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
    const reducer = (0, $42omo.useCallback)((state, action)=>{
        switch(action.type){
            case $c9e0854a72739c18$var$AT.SET_EVENTS:
                return {
                    ...state,
                    events: action.events
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS:
                {
                    const calendarIds = action.calendarIds;
                    const newEvents = action.events;
                    const oldEvents = state.events.filter((event)=>!calendarIds.includes(event.subCalendarId));
                    const updatedEvents = oldEvents.concat(newEvents);
                    return {
                        ...state,
                        events: updatedEvents
                    };
                }
            case $c9e0854a72739c18$var$AT.SET_CALENDARS:
                return {
                    ...state,
                    calendars: action.calendars
                };
            case $c9e0854a72739c18$var$AT.SET_VIEW_DATE:
                return {
                    ...state,
                    viewDate: action.viewDate
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS:
                if (state.calendarErrors.length === 0 && action.calendarErrors.length === 0) return state;
                return {
                    ...state,
                    calendarErrors: action.calendarErrors
                };
            case $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS:
                return {
                    ...state,
                    isLoadingEvents: action.isLoadingEvents
                };
            case $c9e0854a72739c18$var$AT.SET_FIRST_DAY:
                return {
                    ...state,
                    firstDay: action.firstDay
                };
            default:
                return initialState;
        }
    }, [
        initialState
    ]);
    const [state, dispatch] = (0, $42omo.useReducer)(reducer, initialState);
    const actions = (0, $42omo.useMemo)(()=>({
            setEvents: (events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_EVENTS,
                    events: events
                });
            },
            setCalendarEvents: (calendarIds, events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS,
                    calendarIds: calendarIds,
                    events: events
                });
            },
            setCalendars: (calendars)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDARS,
                    calendars: calendars
                });
            },
            setViewDate: (viewDate)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_VIEW_DATE,
                    viewDate: viewDate
                });
            },
            setCalendarErrors: (calendarErrors)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS,
                    calendarErrors: calendarErrors
                });
            },
            setIsLoadingEvents: (isLoadingEvents)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS,
                    isLoadingEvents: isLoadingEvents
                });
            },
            setFirstDay: (firstDay)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_FIRST_DAY,
                    firstDay: firstDay
                });
            }
        }), []);
    const tcContextValue = (0, $42omo.useMemo)(()=>({
            state: state,
            actions: actions
        }), [
        state,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c9e0854a72739c18$var$TCContext.Provider, {
        value: tcContextValue
    }, children);
};
module.exports["CALENDAR_CONTEXT"] = $c9e0854a72739c18$export$feb9e2d8bc9b9b85;
module.exports["useTCContextDispatch"] = $c9e0854a72739c18$export$5f8036cb54c4d559;
module.exports["TCContextProvider"] = $c9e0854a72739c18$export$97f0c60a5aa0f317;

});

parcelRegister("j4RIK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cdc6aab464c1fae2$export$6122306715c85017 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qKe_8",
    name: "PageTreeMacroHandler",
    loader: async ()=>(await (parcelRequire("kfSWE"))).PageTreeMacroRenderer
});
module.exports["PageTreeMacroHandler"] = $cdc6aab464c1fae2$export$6122306715c85017;

});

parcelRegister("kfSWE", function(module, exports) {

let $ebefd44b05b60429$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ebefd44b05b60429$var$load("6wr18"),
    $ebefd44b05b60429$var$load("ffEVr"),
    $ebefd44b05b60429$var$load("Wowvf"),
    $ebefd44b05b60429$var$load("5is1n"),
    $ebefd44b05b60429$var$load("3PgFB")
]).then(()=>parcelRequire('hD0Hb'));

});

parcelRegister("ZJvdP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $543e3a9ad9cfc398$export$3ad73c971369d052 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sYDyD",
    name: "PageIncludeMacroHandler",
    loader: async ()=>(await (parcelRequire("cqkhv"))).PageIncludeMacroRenderer
});
module.exports["PageIncludeMacroHandler"] = $543e3a9ad9cfc398$export$3ad73c971369d052;

});

parcelRegister("cqkhv", function(module, exports) {

let $90b7a532fd6dc45f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $90b7a532fd6dc45f$var$load("5h4De").then(()=>parcelRequire('doY9Y'));

});

parcelRegister("8Ksv7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $11414ac1857ca883$export$cfa4ed6e2f4ad26 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lJE6O",
    name: "BlogPostsMacroHandler",
    loader: async ()=>(await (parcelRequire("jq5wq"))).BlogPostsMacroRenderer
});
module.exports["BlogPostsMacroHandler"] = $11414ac1857ca883$export$cfa4ed6e2f4ad26;

});

parcelRegister("jq5wq", function(module, exports) {

let $e234ba9a813deafc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e234ba9a813deafc$var$load("7j0mT"),
    $e234ba9a813deafc$var$load("69R9L"),
    $e234ba9a813deafc$var$load("1GCFv"),
    $e234ba9a813deafc$var$load("dZsGY"),
    $e234ba9a813deafc$var$load("bV5bW"),
    $e234ba9a813deafc$var$load("28h7Y")
]).then(()=>parcelRequire('5iRsI'));

});

parcelRegister("jJli4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $f9KPY = parcelRequire("f9KPY");


const $7549d063fe593b21$export$2800e3d415e59020 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8zrD8",
    name: "ExcerptIncludeLoader",
    loader: async ()=>(await (parcelRequire("fZwnX"))).ExcerptInclude,
    // Component shadow is a subset of ExcerptIncludeProps so this would generate a TS error here as Loadable
    // expects the prop types to match.
    // @ts-expect-error
    loading: (0, $f9KPY.ExcerptIncludeComponentShadow)
});
module.exports["ExcerptIncludeLoader"] = $7549d063fe593b21$export$2800e3d415e59020;

});

parcelRegister("f9KPY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lOkIA = parcelRequire("lOkIA");


var $dhEYL = parcelRequire("dhEYL");

class $747c563e4499b240$export$8f88facf076a2d46 extends (0, $42omo.PureComponent) {
    render() {
        const { shouldPanelBeDisplayed: shouldPanelBeDisplayed, targetContentTitle: targetContentTitle } = this.props;
        return shouldPanelBeDisplayed ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "excerpt-include-panel",
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle || // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "editor.excerpt.include.panel.title.loading"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        });
    }
}
module.exports["ExcerptIncludeComponentShadow"] = $747c563e4499b240$export$8f88facf076a2d46;

});

parcelRegister("dhEYL", function(module, exports) {
const $9b021e0aba5455d5$export$21f42ab9b6679f44 = {
    display: 'block',
    // DEBUGGING
    borderWidth: "var(--ds-border-width, 1px)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    borderImage: 'initial'
};
const $9b021e0aba5455d5$export$92937d9937dc7ce9 = {
    display: 'block',
    // DEBUGGING
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    minWidth: '128px',
    padding: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $9b021e0aba5455d5$export$d763905bda51ef54 = {
    display: 'block',
    // DEBUGGING
    minWidth: '128px',
    borderWidth: `${"var(--ds-border-width, 1px)"} 0px 0px 0px`,
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    padding: "var(--ds-space-100, 8px)"
};
const $9b021e0aba5455d5$export$99e3f651fb62ec86 = {
    color: "var(--ds-text-subtlest, #6B6E76)",
    paddingLeft: "var(--ds-space-050, 4px)"
};
module.exports["panel"] = $9b021e0aba5455d5$export$21f42ab9b6679f44;
module.exports["panelHeader"] = $9b021e0aba5455d5$export$92937d9937dc7ce9;
module.exports["panelBody"] = $9b021e0aba5455d5$export$d763905bda51ef54;
module.exports["panelHeaderExcerpt"] = $9b021e0aba5455d5$export$99e3f651fb62ec86;

});

parcelRegister("fZwnX", function(module, exports) {

let $ba45ac930d65655b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ba45ac930d65655b$var$load("6GIKD"),
    $ba45ac930d65655b$var$load("hH53H"),
    $ba45ac930d65655b$var$load("hXbzh"),
    $ba45ac930d65655b$var$load("6wr18"),
    $ba45ac930d65655b$var$load("ffEVr"),
    $ba45ac930d65655b$var$load("Wowvf"),
    $ba45ac930d65655b$var$load("lbsQO"),
    $ba45ac930d65655b$var$load("9tNcH")
]).then(()=>parcelRequire('c6u22'));

});

parcelRegister("5LTS4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $6VdZc = parcelRequire("6VdZc");


var $4JC0x = parcelRequire("4JC0x");


var $1xpoY = parcelRequire("1xpoY");


var $bF1aY = parcelRequire("bF1aY");


var $h8C1D = parcelRequire("h8C1D");


var $kksmx = parcelRequire("kksmx");

const $ebb4d303074e1a0c$var$NOT_SSRED = 'none';
const $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED = 'ssr-blocked';
// Limit performance tracking for only top 10 extensions on initial load.
// The value is semi-arbitrary, as this is +2 to the number of extensions
// we attempt to SSR on initial load - this will give us an idea how the
// non-SSRed extensions are performing.
// This will lead to ~39% more tracking events send overall, comparing to
// 50/50 rollout we had before, but will prevent from sending huge amount
// of events for individual pages with a lot of extensions.
const $ebb4d303074e1a0c$var$TRACKING_LIMIT = 10;
const $ebb4d303074e1a0c$var$isBlocklisted = (ssrPreloadFailure)=>ssrPreloadFailure?.startsWith('blocklist') ? $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED : $ebb4d303074e1a0c$var$NOT_SSRED;
// This check is being made only upon initial render, and therefore is sufficient for
// checking whether element (in our case the marker) appears above the fold when rendered.
const $ebb4d303074e1a0c$var$isMarkerAboveTheFold = (el)=>{
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
};
const $ebb4d303074e1a0c$var$getPerformanceEntry = (entryName)=>{
    if (performance && typeof performance.getEntriesByName === 'function') return performance.getEntriesByName(entryName);
    return [];
};
const $ebb4d303074e1a0c$export$64e91845ba744516 = ({ node: node, contentId: contentId, extensionKey: extensionKey })=>{
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { localId: localId } = node;
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const extensionBlocklist = (0, $1xpoY.default).getString('confluence-extensions-server-render-blocklist', '');
    const markerRef = (0, $42omo.useRef)(null);
    const { extensionIndex: extensionIndex, isUnsupportedExtension: isUnsupportedExtension } = (0, $h8C1D.useExtensionIndex)(macroId);
    const doNotTrackExtension = extensionIndex === (0, $h8C1D.UNKNOWN_INDEX) || extensionIndex >= $ebb4d303074e1a0c$var$TRACKING_LIMIT;
    (0, $42omo.useEffect)(()=>{
        // NOTE: as of now, this metric is tailored to monitoring the performance of extensions
        // on initial load. We're not planning to use this metric in any way on transitions yet
        // thus we don't want to spam analytics with the data we don't use.
        if (doNotTrackExtension || !(0, $6VdZc.isInitial)()) return;
        // WARN: Complexity alert! The logic of fmp/tti/duration calculation is convoluted
        // here because of several reasons. Due to the timing of creating performance marks
        // that we use here, we may report extension timing *before* TTI measure is evaluated,
        // since TTI measure is waiting for several page segments. Thus on initial load we have
        // to rely on other reference points, that are available before extensions are rendered.
        const pageTTI = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('rendererRendered.end')?.pop()?.startTime : $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric:tti')?.pop()?.duration;
        const pageFMP = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('CFP-63.ssr-ttr')?.pop()?.startTime : pageTTI;
        const clientRouteStart = $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric.start')?.pop()?.startTime;
        const ssrPreloadFailure = (0, $4JC0x.getPreloadFailures)(macroId) || '';
        const ssrGeneralFailure = (0, $4JC0x.getGeneralFailures)() || '';
        const isExtensionSSRed = (0, $6VdZc.isInitial)() ? (0, $kksmx.getExtensionSSRMark)(macroId) || $ebb4d303074e1a0c$var$isBlocklisted(ssrPreloadFailure) : $ebb4d303074e1a0c$var$NOT_SSRED;
        // On transition we cannot reliably expect that "browser-metric:tti" measure is there
        // before macro rendering. Thus, use routing start as a base point for extension performance
        // measurement on transition. Note that FMP=TTI on transition.
        const startTime = ((0, $6VdZc.isInitial)() ? pageFMP : clientRouteStart) ?? 0;
        const customData = {
            isExtensionSSRed: isExtensionSSRed,
            extensionIndex: extensionIndex,
            extensionKey: extensionKey,
            contentId: contentId,
            pageFMP: pageFMP ?? 0,
            pageTTI: pageTTI ?? 0,
            isATF: $ebb4d303074e1a0c$var$isMarkerAboveTheFold(markerRef.current),
            ssrPreloadFailure: isUnsupportedExtension ? 'unsupportedContentInternalExtension' : ssrPreloadFailure || ssrGeneralFailure,
            clientRouteStart: clientRouteStart ?? 0,
            hydratable: window?.__HYDRATABLE__ || false,
            hydrationFailed: window?.__HYDRATION_FAILED__ || false
        };
        const metric = (0, $bF1aY.LEGACY_EXTENSION_LOADING_METRIC)(`${extensionKey}.${contentId}.${localId}`);
        metric.start({
            startTime: startTime
        });
        metric.stop({
            customData: customData
        });
    }, [
        doNotTrackExtension,
        extensionBlocklist,
        extensionKey,
        extensionIndex,
        isUnsupportedExtension,
        routeName,
        localId,
        contentId,
        macroId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: markerRef
    });
};
module.exports["ExtensionLoadingComplete"] = $ebb4d303074e1a0c$export$64e91845ba744516;

});

parcelRegister("bF1aY", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $63112e910a0def69$export$841f5507db609445 = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.LEGACY_EXTENSION_LOADING_CUSTOM_KEY)
});
module.exports["LEGACY_EXTENSION_LOADING_METRIC"] = $63112e910a0def69$export$841f5507db609445;

});

parcelRegister("h8C1D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lcuos = parcelRequire("lcuos");


var $8pcS0 = parcelRequire("8pcS0");

const $028a91b33dee434b$export$7affafe0528b70b1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    indexes: new Map()
});
const $028a91b33dee434b$var$extractExtensions = (adf)=>(0, $lcuos.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $028a91b33dee434b$export$e4ac003417d6dace = 'UNKNOWN';
const $028a91b33dee434b$export$981cab9712b3b1a3 = ({ document: document, children: children })=>{
    const indexes = (0, $42omo.useMemo)(()=>{
        const extensions = $028a91b33dee434b$var$extractExtensions(document);
        return new Map(extensions.map((node, idx)=>{
            window['unsupportedExtension'] = window['unsupportedExtension'] || {};
            if (node.attrs?.parameters?.nestedContent?.content && node.attrs.extensionKey === '__confluenceADFMigrationUnsupportedContentInternalExtension__') node.attrs.parameters.nestedContent.content.forEach((each)=>{
                window['unsupportedExtension'][each.attrs?.parameters?.macroMetadata?.macroId?.value] = idx;
            });
            return [
                node.attrs?.parameters?.macroMetadata?.macroId?.value,
                idx
            ];
        }));
    }, [
        document
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            indexes: indexes
        }), [
        indexes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($028a91b33dee434b$export$7affafe0528b70b1.Provider, {
        value: value
    }, children);
};
const $028a91b33dee434b$export$ea9830505fbaa6ad = (macroId)=>{
    const { indexes: indexes } = (0, $42omo.useContext)($028a91b33dee434b$export$7affafe0528b70b1);
    let index = indexes.get(macroId);
    const unsupportedExtensions = window['unsupportedExtension'];
    let isUnsupportedExtension = false;
    if (unsupportedExtensions && unsupportedExtensions[macroId]) {
        index = unsupportedExtensions[macroId];
        isUnsupportedExtension = true;
    }
    return {
        extensionIndex: typeof index === 'number' ? index : $028a91b33dee434b$export$e4ac003417d6dace,
        isUnsupportedExtension: isUnsupportedExtension
    };
};
module.exports["UNKNOWN_INDEX"] = $028a91b33dee434b$export$e4ac003417d6dace;
module.exports["ExtrensionIndexProvider"] = $028a91b33dee434b$export$981cab9712b3b1a3;
module.exports["useExtensionIndex"] = $028a91b33dee434b$export$ea9830505fbaa6ad;

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("5X6NW"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("5X6NW", function(module, exports) {

let $4557bda7dcbec4e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4557bda7dcbec4e7$var$load("6uCgj"),
    $4557bda7dcbec4e7$var$load("khyhL"),
    $4557bda7dcbec4e7$var$load("coUzl"),
    $4557bda7dcbec4e7$var$load("5nMTY"),
    $4557bda7dcbec4e7$var$load("7j0mT"),
    $4557bda7dcbec4e7$var$load("69R9L"),
    $4557bda7dcbec4e7$var$load("6wr18"),
    $4557bda7dcbec4e7$var$load("hhss7"),
    $4557bda7dcbec4e7$var$load("ffEVr"),
    $4557bda7dcbec4e7$var$load("dnwTC")
]).then(()=>parcelRequire('3Jp28'));

});

parcelRegister("l7BGZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $076f2e82bb035170$export$b5586d12ffc2e1b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Qw8xt",
    name: "LiveSearchLoader",
    loader: async ()=>(await (parcelRequire("8AXgG"))).LiveSearch
});

const $076f2e82bb035170$export$e7e4bc50f3fd132e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cgOQy",
    name: "LazyLiveSearchLoader",
    loader: async ()=>(await (parcelRequire("8AXgG"))).LiveSearch
});
module.exports["LiveSearchLoader"] = $076f2e82bb035170$export$b5586d12ffc2e1b;
module.exports["LazyLiveSearchLoader"] = $076f2e82bb035170$export$e7e4bc50f3fd132e;

});

parcelRegister("8AXgG", function(module, exports) {

let $641fa8f338629ec8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $641fa8f338629ec8$var$load("7j0mT"),
    $641fa8f338629ec8$var$load("69R9L"),
    $641fa8f338629ec8$var$load("6wr18"),
    $641fa8f338629ec8$var$load("jYRaq"),
    $641fa8f338629ec8$var$load("hUmZG"),
    $641fa8f338629ec8$var$load("8059b"),
    $641fa8f338629ec8$var$load("ffEVr"),
    $641fa8f338629ec8$var$load("Wowvf"),
    $641fa8f338629ec8$var$load("1F7LX"),
    $641fa8f338629ec8$var$load("7EorR"),
    $641fa8f338629ec8$var$load("hhss7"),
    $641fa8f338629ec8$var$load("2IX0x")
]).then(()=>parcelRequire('jF1MT'));

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("1ODQT"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("1ODQT"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("1ODQT", function(module, exports) {

let $15295fc25ddbbd18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $15295fc25ddbbd18$var$load("6GIKD"),
    $15295fc25ddbbd18$var$load("hH53H"),
    $15295fc25ddbbd18$var$load("hXbzh"),
    $15295fc25ddbbd18$var$load("lbsQO"),
    $15295fc25ddbbd18$var$load("9ftJe"),
    $15295fc25ddbbd18$var$load("hhss7"),
    $15295fc25ddbbd18$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("31HPn", function(module, exports) {
const $23fc703b824b091d$export$38c6526d67de94bb = 'xen:macro';
const $23fc703b824b091d$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $23fc703b824b091d$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $23fc703b824b091d$export$46fc26821adc3495 = 'connectAddon';
const $23fc703b824b091d$export$95077f102dafd025 = 'migratedServerP2Addon';
const $23fc703b824b091d$export$981e47da3e2dfc13 = 'bodiedExtension';
const $23fc703b824b091d$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $23fc703b824b091d$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $23fc703b824b091d$export$bf4c163a4c708db1 = 'forgeDocUpdated';
module.exports["MODULE_NAME"] = $23fc703b824b091d$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $23fc703b824b091d$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $23fc703b824b091d$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $23fc703b824b091d$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $23fc703b824b091d$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $23fc703b824b091d$export$bf4c163a4c708db1;

});

parcelRegister("2igSQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fb3kw = parcelRequire("fb3kw");


var $2xdp1 = parcelRequire("2xdp1");


var $kwjRd = parcelRequire("kwjRd");


var $idCCS = parcelRequire("idCCS");

const $f852cc0c808326c8$export$cdee65ffaf9b2fb7 = ({ parameters: parameters })=>{
    // https://github.com/final-form/react-final-form/issues/103
    // If users name variables using numbers it breaks the form
    // hacky fix added a $ character in front
    const inputName = `$${parameters?.name}`;
    const inputPlaceholder = `${parameters?.placeholder || parameters?.name}`;
    // . [ or ] in the variable name causes Final Form to throw an error
    const validInputName = inputName.replace(/[`.\[\]\/]/gi, '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableInputWrapper), null, parameters?.type === (0, $2xdp1.MULTI_LINES_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableTextareaInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            display: 'inline-block',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: '0px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))));
};
module.exports["TemplateVariableInput"] = $f852cc0c808326c8$export$cdee65ffaf9b2fb7;

});

parcelRegister("2xdp1", function(module, exports) {

var $55ggG = parcelRequire("55ggG");

const $df54c7f294e74661$export$178c63c1bbc65458 = (0, $55ggG.i18n).templateVariableDefault.defaultMessage;
const $df54c7f294e74661$export$ae3b897442224943 = 'text';
const $df54c7f294e74661$export$a43e313f04be91d7 = 'textarea';
const $df54c7f294e74661$export$22c50a44ec8aa5dd = 'select';
const $df54c7f294e74661$export$d1952e7dbe0fefc9 = 5;
const $df54c7f294e74661$export$777b44f8413b254e = 100;
module.exports["defaultVariableName"] = $df54c7f294e74661$export$178c63c1bbc65458;
module.exports["TEXT_TYPE"] = $df54c7f294e74661$export$ae3b897442224943;
module.exports["MULTI_LINES_TYPE"] = $df54c7f294e74661$export$a43e313f04be91d7;
module.exports["LIST_TYPE"] = $df54c7f294e74661$export$22c50a44ec8aa5dd;
module.exports["ROWS_DEFAULT"] = $df54c7f294e74661$export$d1952e7dbe0fefc9;
module.exports["COLUMNS_DEFAULT"] = $df54c7f294e74661$export$777b44f8413b254e;

});

parcelRegister("55ggG", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $446fbea06bd2a31f$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    propertyPanelVariableDisplayString: {
        id: "template-variable.property.panel.variable.display.string",
        defaultMessage: "Text"
    },
    propertyPanelVariableDisplayStringTooltip: {
        id: "template-variable.property.panel.variable.display.string.tooltip",
        defaultMessage: "Single line text input field."
    },
    propertyPanelVariableDisplayTextArea: {
        id: "template-variable.property.panel.variable.display.textarea",
        defaultMessage: "Multi-line Text"
    },
    propertyPanelVariableDisplayTextAreaTooltip: {
        id: "template-variable.property.panel.variable.display.textarea.tooltip",
        defaultMessage: "Multi-line text input field."
    },
    propertyPanelVariableDisplayList: {
        id: "template-variable.property.panel.variable.display.list",
        defaultMessage: "List"
    },
    propertyPanelVariableDisplayListTooltip: {
        id: "template-variable.property.panel.variable.display.list.tooltip",
        defaultMessage: "Drop down list."
    },
    templateEditorChangingVariableDialogTitle: {
        id: "template-variable.template.editor.changing.variable.dialog.title",
        defaultMessage: "Edit template variable"
    },
    templateEditorVariableNameField: {
        id: "template-variable.template.editor.variable.name.field",
        defaultMessage: "Variable name"
    },
    propertyPanelVariableDisplayTextAreaRowsTooltip: {
        id: "template-variable.property.panel.variable.textarea.rows.tooltip",
        defaultMessage: "Number of rows to display for the field."
    },
    propertyPanelVariableDisplayTextAreaColumnsTooltip: {
        id: "template-variable.property.panel.variable.textarea.columns.tooltip",
        defaultMessage: "Number of columns to display for the field."
    },
    propertyPanelVariableListValuesTooltip: {
        id: "template-variable.property.panel.variable.list.values.tooltip",
        defaultMessage: "Enter each item for the list, separating each with a comma."
    },
    templateEditorVariableListFieldPlaceholder: {
        id: "template-variable.template.editor.variable.list.field.placeholder",
        defaultMessage: "option 1, option 2, option 3"
    },
    templateEditorVariableSaveButtonLabel: {
        id: "template-variable.template.editor.variable.save.button.label",
        defaultMessage: "Save"
    },
    templateVariableDefault: {
        id: "template-variable.template.editor.variable.name.default",
        defaultMessage: "variable_name"
    }
});
module.exports["i18n"] = $446fbea06bd2a31f$export$a7357cdd1f0b0168;

});

parcelRegister("kwjRd", function(module, exports) {
/* SharedComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f809923cf8cfa046$export$4af78215734bfe2b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkxmi2 _otyrpxbi _n3tdv77o _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$59d0bfd82baefce0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41e2s _2rko458z _bfhk1s93",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$8eff3c6bf5b8c758 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1nmz9jpi _syazi7uo _k48p4jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$b4ff36272a61159f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41e2s _2rko18r2 _syaz1rpy _bfhk1s93 _1nmz9jpi",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e3cad7a6d45ce703 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _p12f1osq _o5724jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e9df20cb66227872 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _p12f1osq _kqswh2mm _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_vr2wn7od",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$c996e1cc40266f34 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
module.exports["TemplateVariableInputWrapper"] = $f809923cf8cfa046$export$4af78215734bfe2b;
module.exports["TemplateVariableNameWrapper"] = $f809923cf8cfa046$export$59d0bfd82baefce0;
module.exports["TemplateVariableName"] = $f809923cf8cfa046$export$8eff3c6bf5b8c758;
module.exports["TemplateVariableType"] = $f809923cf8cfa046$export$b4ff36272a61159f;
module.exports["TemplateVariableInputFieldWrapper"] = $f809923cf8cfa046$export$e3cad7a6d45ce703;
module.exports["TemplateVariableTextareaInputFieldWrapper"] = $f809923cf8cfa046$export$e9df20cb66227872;
module.exports["ButtonStyle"] = $f809923cf8cfa046$export$bdc3c19374266b98;
module.exports["DropDownInputWrapper"] = $f809923cf8cfa046$export$c996e1cc40266f34;

});

parcelRegister("idCCS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $9EtP6 = parcelRequire("9EtP6");


var $4noo5 = parcelRequire("4noo5");


var $6Ipjn = parcelRequire("6Ipjn");


var $4KS7f = parcelRequire("4KS7f");


var $3gadb = parcelRequire("3gadb");


var $kwjRd = parcelRequire("kwjRd");


var $2xdp1 = parcelRequire("2xdp1");

const $ab3c5e793706abd9$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    invalidVariableNameError: {
        id: "template-variable.description.invalid.variable.name",
        defaultMessage: "This template contains a variable using invalid character(s) (. , [ , ], /). Please have the template owner remove these characters from the variable to use it."
    }
});
const $ab3c5e793706abd9$var$generateDropdownOptionsList = (options)=>options ? options.map((option)=>({
            label: option,
            value: option
        })) : [];
const $ab3c5e793706abd9$var$styles = {
    option: (provided)=>({
            ...provided,
            wordBreak: 'break-word'
        })
};
const $ab3c5e793706abd9$var$checkTemplateVariableValidity = (variableName)=>{
    const invalidVariableCharacters = [
        '.',
        '[',
        ']',
        '/'
    ];
    return invalidVariableCharacters.some((invalidVariableCharacter)=>variableName?.includes(invalidVariableCharacter));
};
const $ab3c5e793706abd9$export$25a5c8174bd010d5 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $aXWIB.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    const parameterOptions = parameters.params && parameters.params.options;
    const options = (0, $42omo.useMemo)(()=>$ab3c5e793706abd9$var$generateDropdownOptionsList(parameterOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        parameterOptions
    ]);
    const onChangeHandler = (0, $42omo.useMemo)(()=>(option)=>{
            onChange(option.value);
        }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: hasInvalidVariableName
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: parameters.isDisabled
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    })));
};
const $ab3c5e793706abd9$export$b9055edfa32ac8b4 = ({ onChange: onChange, value: value, inputName: inputName, parameters: parameters, placeholder: placeholder })=>{
    const intl = (0, $aXWIB.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            ...tooltipProps,
            testId: "text-field-input",
            name: inputName,
            onChange: onChange,
            value: value || '',
            placeholder: placeholder,
            isDisabled: hasInvalidVariableName,
            width: 200,
            isCompact: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        testId: "text-field-input",
        name: inputName,
        onChange: onChange,
        value: value || '',
        placeholder: placeholder,
        isDisabled: parameters?.isDisabled,
        width: 200,
        isCompact: true
    }));
};
const $ab3c5e793706abd9$export$9a5caaaacb4c92d3 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $aXWIB.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
            ...tooltipProps,
            testId: "text-area-input",
            onChange: onChange,
            value: value || '',
            minimumRows: parameters.params && parameters.params.rows || 1,
            cols: parameters.params && parameters.params.columns || 30,
            resize: "vertical",
            isDisabled: hasInvalidVariableName,
            placeholder: placeholder
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        testId: "text-area-input",
        onChange: onChange,
        value: value || '',
        minimumRows: parameters.params && parameters.params.rows || 1,
        cols: parameters.params && parameters.params.columns || 30,
        resize: "vertical",
        isDisabled: parameters?.isDisabled,
        placeholder: placeholder
    }));
};
const $ab3c5e793706abd9$export$f57c870ff73570c7 = (props)=>{
    const { parameters: parameters } = props;
    switch(parameters.type){
        case 0, $2xdp1.LIST_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$25a5c8174bd010d5, props);
        case 0, $2xdp1.MULTI_LINES_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$9a5caaaacb4c92d3, props);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$b9055edfa32ac8b4, props);
    }
};
module.exports["TemplateVariableInputComponent"] = $ab3c5e793706abd9$export$f57c870ff73570c7;

});

parcelRegister("hHZWk", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $42omo.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $frIzR.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("8eAX8", function(module, exports) {

var $k5ycH = parcelRequire("k5ycH");


var $cpjd2 = parcelRequire("cpjd2");


var $8n9tL = parcelRequire("8n9tL");


var $64KID = parcelRequire("64KID");


var $9fLxI = parcelRequire("9fLxI");

const $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES = [
    'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources'
];
const $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES = [
    'wr!confluence.web.resources:view-content',
    'wr!confluence.macros.advanced:get-more'
];
const $d0091e97ce884599$export$1d71148f13231a96 = ()=>[
        // transitional and implicit dependencies
        'wrc!com.atlassian.confluence.extra.team-calendars:amd',
        'wrc!com.atlassian.confluence.extra.team-calendars:user-timezone-setup',
        // editor context
        'wrc!com.atlassian.confluence.extra.team-calendars:calendar-init-editor',
        // macro-browser (not loaded by macro browser for some reason)
        'wrc!com.atlassian.confluence.extra.team-calendars:macro-browser-web-resources'
    ];
function $d0091e97ce884599$export$c3c980ae518bc695(webresources, macroRenderedOutputFromSSR, macroOutput, callback, scriptContainer, unavailableCallback) {
    const defaultWrmResources = $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES;
    const staticConnectWrmResources = $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES;
    let deps = [], jsTags;
    if (macroRenderedOutputFromSSR || macroOutput) deps = [
        ...defaultWrmResources
    ];
    else {
        if (!webresources) return Promise.resolve();
        jsTags = webresources?.tags?.js ?? null;
        const contexts = !jsTags || !scriptContainer ? webresources.contexts && webresources.contexts.map((context)=>`wrc!${context}`) || [] : [];
        const keys = !jsTags || !scriptContainer ? webresources.keys && webresources.keys.map((key)=>`wr!${key}`) || [] : [];
        deps = [
            ...defaultWrmResources,
            ...staticConnectWrmResources,
            ...contexts,
            ...keys
        ];
    }
    return new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)(deps, ()=>{
            // Callback
            if (callback) callback();
            if (scriptContainer && jsTags) (0, $k5ycH.loadResources)(scriptContainer, jsTags).then(resolve);
            else resolve();
        }, ()=>{
            // Unavailable Callback
            // eslint-disable-next-line no-console
            console.error(`Cannot loadMacroWebResources: ${deps}`);
            if (unavailableCallback) unavailableCallback();
        });
    });
}
function $d0091e97ce884599$export$a144665563142e() {
    let macrosMetadataCache = null;
    const macrosMetadataSpaceAwareCache = {};
    return async function metadataLoader() {
        const spaceKey = $d0091e97ce884599$var$getSpaceKey();
        if (spaceKey) {
            if (!macrosMetadataSpaceAwareCache[spaceKey]) macrosMetadataSpaceAwareCache[spaceKey] = $d0091e97ce884599$var$fetchMacroMetadata(spaceKey);
            return macrosMetadataSpaceAwareCache[spaceKey];
        }
        if (!macrosMetadataCache) macrosMetadataCache = $d0091e97ce884599$var$fetchMacroMetadata();
        return macrosMetadataCache;
    };
}
function $d0091e97ce884599$var$getSpaceKey() {
    const pageUrl = window.location.toString();
    const match = (0, $8n9tL.findAndMatchRoute)((0, $64KID.namedRoutes), pageUrl);
    // There's a race condition when the space key is not yet available in AJS upon
    // calling metadataLoader, therefore we fallback to the space key in the URL.
    return window.AJS?.Meta?.get('space-key') || match?.params?.spaceKey;
}
function $d0091e97ce884599$var$fetchMacroMetadata(spaceKey) {
    return (0, $9fLxI.getExtensionManifest)({
        spaceKey: spaceKey
    }).then((manifest)=>{
        const macros = manifest?.macros || [];
        return macros;
    });
}
module.exports["teamCalendarWRM"] = $d0091e97ce884599$export$1d71148f13231a96;
module.exports["loadMacroWebResources"] = $d0091e97ce884599$export$c3c980ae518bc695;
module.exports["createMetadataLoader"] = $d0091e97ce884599$export$a144665563142e;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("8cOoD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cpjd2 = parcelRequire("cpjd2");


var $gEtAQ = parcelRequire("gEtAQ");


var $fySJw = parcelRequire("fySJw");


var $3LvmY = parcelRequire("3LvmY");

const $198de0e1d1f1ab22$export$f1a6c160e5107221 = 'dataProvider';
const $198de0e1d1f1ab22$export$57b0f508e89cfdbb = ({ connectHost: connectHost })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isViewPage = (0, $gEtAQ.isViewPage)();
        $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
            connectHost: connectHost,
            createAnalyticsEvent: createAnalyticsEvent,
            isViewPage: isViewPage
        });
    }, [
        connectHost,
        createAnalyticsEvent
    ]);
    return null;
};
const $198de0e1d1f1ab22$export$594716b2dbd4f0f9 = ()=>!!window['connectHost']?.isModuleDefined($198de0e1d1f1ab22$export$f1a6c160e5107221);
const $198de0e1d1f1ab22$export$eb1900d465fb2cb9 = ({ connectHost: connectHost, createAnalyticsEvent: createAnalyticsEvent, isViewPage: isViewPage })=>{
    const isDPModuleDefined = $198de0e1d1f1ab22$export$594716b2dbd4f0f9();
    const dataProviderModule = {
        emitToDataProvider: async (...args)=>{
            const data = args.length > 1 ? args[0] : null;
            const sendResponse = args.length > 1 ? args[args.length - 1] : args[0];
            const context = sendResponse?._context;
            const fragmentLocalId = context?.extension?.options?.productContext?.['macro.fragmentLocalId'];
            const extensionKey = context?.extension?.key;
            const event = (0, $3LvmY.getReceivedConnectRefDataEvent)({
                isViewPage: isViewPage,
                extensionKey: extensionKey
            });
            createAnalyticsEvent(event).fire();
            if (!extensionKey) throw Error('Missing Connect app extensionKey while transferring data.');
            const connectDataListener = (0, $fySJw.getConnectDataListener)();
            const status = await connectDataListener.transfer(extensionKey, fragmentLocalId, data, createAnalyticsEvent, isViewPage);
            return sendResponse(status);
        }
    };
    if (!isDPModuleDefined) connectHost.defineModule($198de0e1d1f1ab22$export$f1a6c160e5107221, dataProviderModule);
};
const $198de0e1d1f1ab22$export$8738a87451e0e0f8 = async ({ logger: logger, isViewPage: isViewPage, createAnalyticsEvent: createAnalyticsEvent })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
                connectHost: connectHost,
                createAnalyticsEvent: createAnalyticsEvent,
                isViewPage: isViewPage
            });
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for dataProvider!`;
            resolve();
        });
    });
};
module.exports["DataProviderModule"] = $198de0e1d1f1ab22$export$57b0f508e89cfdbb;
module.exports["checkIsDPModuleDefined"] = $198de0e1d1f1ab22$export$594716b2dbd4f0f9;
module.exports["loadDataProviderModule"] = $198de0e1d1f1ab22$export$8738a87451e0e0f8;

});

parcelRegister("fySJw", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $2XKS9 = parcelRequire("2XKS9");


var $dc2v6 = parcelRequire("dc2v6");


var $3LvmY = parcelRequire("3LvmY");


var $1AM4E = parcelRequire("1AM4E");

let $8e595456ec3aa5d5$var$connectDataListener;


class $8e595456ec3aa5d5$var$ConnectDataListener {
    init({ emit: emit }) {
        this.emit = emit;
    }
    static async validate(extensionKey, data) {
        const { validateSchema: validateSchema, DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("fNtDT"));
        if (!data.eventData) throw new DataTransferValidationError({
            message: "Passed data is missing 'eventData'."
        });
        const keys = Object.keys(data.eventData);
        if (keys.length !== 1) throw new DataTransferValidationError({
            message: "'eventData' should only include a single key. The key should be same with 'refDataSchema.outputType'."
        });
        const connectMacroKeyRefOutputTypeMap = await (0, $dc2v6.getConnectMacroKeyRefOutputTypeMap)();
        if (!connectMacroKeyRefOutputTypeMap.has(extensionKey)) // This is a case that shouldn't really happen. Throwing a regular error instead of DataTransferValidationError
        // because this error is not related to what the vendor emitted data.
        throw new Error('extensionKey is not found in the macro metadata.');
        if (connectMacroKeyRefOutputTypeMap.get(extensionKey) !== keys[0]) throw new DataTransferValidationError({
            message: `'eventData' should contain 'refDataSchema.outputType' defined in the app manifest (${connectMacroKeyRefOutputTypeMap.get(extensionKey)}).`
        });
        validateSchema(keys[0], data.eventData[keys[0]]);
    }
    async transfer(extensionKey, localId, data, createAnalyticsEvent, isViewPage) {
        if (this.emit && localId && data) {
            const transfer = {
                extensionKey: extensionKey,
                localId: localId,
                data: data,
                isViewPage: isViewPage
            };
            const isTrackable = (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).isTrackable(transfer);
            let didStartExperience = false;
            const shouldTrack = isTrackable && (0, $6mKj3.expVal)('confluence_enable_connect_group_4_metrics', 'isEnabled', false);
            if (shouldTrack && !(0, $6mKj3.expVal)('confluence_fix_referentiality_metrics', 'isEnabled', false)) {
                (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                didStartExperience = true;
            }
            const { DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("fNtDT"));
            try {
                await $8e595456ec3aa5d5$var$ConnectDataListener.validate(extensionKey, data);
            } catch (e) {
                const event = (0, $3LvmY.getValidationFailedEvent)({
                    isViewPage: isViewPage,
                    extensionKey: extensionKey,
                    error: e
                });
                createAnalyticsEvent(event).fire();
                if (shouldTrack && !didStartExperience && !(e instanceof DataTransferValidationError)) {
                    (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                    didStartExperience = true;
                }
                if (didStartExperience) (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).fail(e instanceof Error ? e : String(e));
                if (e instanceof DataTransferValidationError) return {
                    status: (0, $2XKS9.ConnectDataTransferStatus).Error,
                    message: e.message,
                    module: 'data_provider',
                    errors: e.errors
                };
                throw e;
            }
            if (shouldTrack && !didStartExperience) {
                (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                didStartExperience = true;
            }
            this.emit(localId, data.eventData);
            if (didStartExperience) (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).succeed();
            return {
                status: (0, $2XKS9.ConnectDataTransferStatus).Success,
                message: 'Data accepted and emitted',
                module: 'data_provider'
            };
        }
        return {
            status: (0, $2XKS9.ConnectDataTransferStatus).Error,
            message: 'There was an issue accepting the data',
            module: 'data_provider'
        };
    }
    constructor(){
        this.emit = void 0;
    }
}
const $8e595456ec3aa5d5$export$605049a72d9f563 = ()=>{
    if (!$8e595456ec3aa5d5$var$connectDataListener) $8e595456ec3aa5d5$var$connectDataListener = new $8e595456ec3aa5d5$var$ConnectDataListener();
    return $8e595456ec3aa5d5$var$connectDataListener;
};
module.exports["getConnectDataListener"] = $8e595456ec3aa5d5$export$605049a72d9f563;

});

parcelRegister("2XKS9", function(module, exports) {
var $606590dfce3163d6$export$f9f405499e653992 = /*#__PURE__*/ function(ConnectDataTransferStatus) {
    ConnectDataTransferStatus["Success"] = "Success";
    ConnectDataTransferStatus["Error"] = "Error";
    return ConnectDataTransferStatus;
}({});
module.exports["ConnectDataTransferStatus"] = $606590dfce3163d6$export$f9f405499e653992;

});

parcelRegister("dc2v6", function(module, exports) {

var $3IXUB = parcelRequire("3IXUB");

let $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
let $a1018373af446f97$var$initialized = false;
async function $a1018373af446f97$var$createMacroKeyRefOutputTypeMap() {
    const macros = await (0, $3IXUB.getMacroMetaData)();
    const result = macros.filter((macro)=>macro.refDataSchema != null).map((macro)=>[
            macro.macroName,
            macro.refDataSchema.outputType
        ]);
    return new Map(result);
}
async function $a1018373af446f97$export$9fde119d071a7062() {
    // used this initialized variable because I was seeing that connectMacroKeyRefOutputTypeMap may
    // be null errors otherwise
    if (!$a1018373af446f97$var$initialized) {
        $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap = await $a1018373af446f97$var$createMacroKeyRefOutputTypeMap();
        $a1018373af446f97$var$initialized = true;
    }
    return $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
}
module.exports["getConnectMacroKeyRefOutputTypeMap"] = $a1018373af446f97$export$9fde119d071a7062;

});

parcelRegister("3IXUB", function(module, exports) {

var $8eAX8 = parcelRequire("8eAX8");


var $6OgRG = parcelRequire("6OgRG");


var $l21Jh = parcelRequire("l21Jh");

const $a3d4cd842e4cfa1b$var$loadMacroMetadata = (0, $8eAX8.createMetadataLoader)();
function $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4(browserConfig) {
    return (0, $l21Jh.autoConvert)($a3d4cd842e4cfa1b$export$82582a527779c20, browserConfig);
}
const $a3d4cd842e4cfa1b$export$82582a527779c20 = async ()=>{
    const macros = await $a3d4cd842e4cfa1b$var$loadMacroMetadata();
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    return macros.filter((macroMetadata)=>{
        if (macroMetadata.hidden) return false;
        return isAllowed(macroMetadata);
    });
};
module.exports["getAutoConverter"] = $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4;
module.exports["getMacroMetaData"] = $a3d4cd842e4cfa1b$export$82582a527779c20;

});

parcelRegister("6OgRG", function(module, exports) {
// This blocklist should reflect what is in https://pug.jira-dev.com/wiki/spaces/AEC/pages/3239608672/Macro+blocklist so if you want to add or remove something, please remember to update the page.
const $38fb99c52e3447fe$var$blocklist = {
    align: true,
    bgcolor: true,
    center: true,
    cheese: true,
    clickable: true,
    code: true,
    colgroup: true,
    column: true,
    'content-by-user': true,
    copyright: true,
    'create-space-button': true,
    div: true,
    expand: true,
    'fancy-bullets': true,
    'google-drive-docs': true,
    'google-drive-sheets': true,
    'google-drive-slides': true,
    favpages: true,
    'gadget-b7a6531b1c147f2e175f1209bed5c0ad': true,
    'gadget-01c2ed272e88f7333da124a03a481477': true,
    'gadget-d2450e06a9a285cf57eedb2d502d9d65b964eb847382938b6c57809bac2261bb': true,
    'global-reports': true,
    highlight: true,
    htmlcomment: true,
    im: true,
    img: true,
    info: true,
    junitreport: true,
    li: true,
    loremipsum: true,
    lozenge: true,
    multimedia: true,
    navmap: true,
    network: true,
    noformat: true,
    note: true,
    ol: true,
    OneDrive: true,
    p: true,
    panel: true,
    pre: true,
    'privacy-policy': true,
    'privacy-mark': true,
    'recently-used-labels': true,
    'reg-tm': true,
    rollover: true,
    roundrect: true,
    search: true,
    section: true,
    sm: true,
    'space-attachments': true,
    'space-details': true,
    span: true,
    status: true,
    strike: true,
    style: true,
    table: true,
    tbody: true,
    td: true,
    th: true,
    thead: true,
    tr: true,
    'trello-board': true,
    'trello-card': true,
    tip: true,
    tm: true,
    ul: true,
    warning: true
};
function $38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, blocklistOverrides = {}) {
    const key = macroMetadata.alternateId || (macroMetadata.id ? macroMetadata.id.replace('macro-', '') : macroMetadata.macroName);
    return blocklistOverrides.hasOwnProperty(key) ? blocklistOverrides[key] : Boolean($38fb99c52e3447fe$var$blocklist[key]);
}
function $38fb99c52e3447fe$export$1dba5c5d55fad37f() {
    const overrides = {};
    return (macroMetadata)=>!$38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, overrides);
}
async function $38fb99c52e3447fe$export$f38acf7431de7e2b(macroBrowser) {
    const originalList = [
        ...macroBrowser.metadataList
    ];
    // Currently no FF info is needed to create the blocklist but if it was, need to pass featureFlagClient to isAllowedWithFeatureFlags()
    const isAllowed = $38fb99c52e3447fe$export$1dba5c5d55fad37f();
    macroBrowser.metadataList = macroBrowser.metadataList.filter(isAllowed);
    /**
	 * Bring blocklisted items back so they show up elsewhere
	 */ return function restore() {
        macroBrowser.metadataList = originalList;
    };
}
module.exports["isAllowedWithFeatureFlags"] = $38fb99c52e3447fe$export$1dba5c5d55fad37f;
module.exports["applyBlocklist"] = $38fb99c52e3447fe$export$f38acf7431de7e2b;

});

parcelRegister("l21Jh", function(module, exports) {

var $3CRZ9 = parcelRequire("3CRZ9");


var $8PZXE = parcelRequire("8PZXE");

const $159df558ca333321$var$noop = ()=>null;
const $159df558ca333321$export$65b04260b3a15835 = async (loadMacroMetadata, browserConfig)=>{
    const { contentId: contentId } = browserConfig;
    if (!contentId) return $159df558ca333321$var$noop;
    const [jiraAutoConvert, connectAddonAutoConvert] = await Promise.all([
        (0, $3CRZ9.createJiraConverter)(contentId),
        (0, $8PZXE.createConnectAddonConverter)(loadMacroMetadata, contentId)
    ]);
    return (link)=>jiraAutoConvert(link) || connectAddonAutoConvert(link);
};
module.exports["autoConvert"] = $159df558ca333321$export$65b04260b3a15835;

});

parcelRegister("3CRZ9", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $6g1oe = parcelRequire("6g1oe");


var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

function $3fcae9e87e9104a7$var$convertLink(link, defaultJiraMacroAttributes) {
    const noop = ()=>{};
    const legacyHandler = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).require('confluence/jim/editor-plugins/jira-paste-link');
    // jira paste handler needs object in this format
    const uri = {
        source: link
    };
    const jimPasteHandlerResult = legacyHandler.pasteHandler(uri, null, noop);
    if (!jimPasteHandlerResult || !jimPasteHandlerResult.params) return null;
    /**
	 * use JSON.parse , JSON.stringify to deeply clone object, avoid any reference
	 */ const macroAttributes = JSON.parse(JSON.stringify(defaultJiraMacroAttributes));
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    macroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(jimPasteHandlerResult.params);
    return macroAttributes;
}
async function $3fcae9e87e9104a7$export$2264c7423a8e6d34(contentId) {
    const placeholderMacro = {
        macroDefinition: {
            name: 'jira'
        },
        contentId: contentId
    };
    // fetch ADF structure of JIM, and modify it to provide to editor later
    const jiraADFNode = await (0, $foRF9.fetchMacroAttributes)(placeholderMacro);
    return (link)=>$3fcae9e87e9104a7$var$convertLink(link, jiraADFNode);
}
module.exports["createJiraConverter"] = $3fcae9e87e9104a7$export$2264c7423a8e6d34;

});

parcelRegister("8PZXE", function(module, exports) {

var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

/*
This script adds autoconvert handlers to the confluence editor.

It executes on editor initialisation, registering the handlers defined in the original add-on descriptors of whatever
add-ons are installed. Each one is associated with a particular macro (although a macro can be associated with many
handlers.

On pattern match, the each handler will be asked if they match and will be processed by the first matching handler.
The macro object is then created, using the matched uri and the information already existing in the JS context, and
the macro is inserted into the editor.
*/ const $44631a970962135a$var$TRELLO_MACRO_NAME = 'trello-card';
const $44631a970962135a$var$escapePattern = (str)=>{
    return str.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
const $44631a970962135a$var$replaceAll = (find, replace, str)=>{
    return str.replace(new RegExp(find, 'g'), replace);
};
const $44631a970962135a$var$convertPatternToRegex = (pattern)=>{
    // Consolidate any double up wildcards
    while(pattern.indexOf('{}{}') !== -1)pattern = pattern.replace('{}{}', '{}');
    // build a regex from the defined autoconvert pattern
    pattern = $44631a970962135a$var$escapePattern(pattern);
    pattern = $44631a970962135a$var$replaceAll('{}', '[^/]*?', pattern);
    // eslint-disable-next-line prefer-template
    pattern = '^' + pattern + '$';
    return pattern;
};
const $44631a970962135a$var$isPatternSafe = (pattern)=>{
    const patternBlockList = [
        'http://',
        'https://',
        'http://{}',
        'https://{}',
        'http://{}.{}',
        'https://{}.{}',
        'http://{}.{}.{}',
        'https://{}.{}.{}'
    ];
    // check the url pattern is not banned
    return patternBlockList.every((bannedPattern)=>bannedPattern !== pattern);
};
const $44631a970962135a$var$hasAutoconvertData = (macro)=>{
    return macro.autoconvertData && macro.autoconvertData.urlParameter && macro.autoconvertData.patterns;
};
const $44631a970962135a$var$getADFNodeForMacros = async (macros, contentId)=>{
    const macroAttributesArray = await Promise.all(Array.from(macros).map((macroName)=>(0, $foRF9.fetchMacroAttributes)({
            macroDefinition: {
                name: macroName
            },
            contentId: contentId
        })));
    return macroAttributesArray.reduce((accu, macroAttributes)=>{
        accu[macroAttributes.attrs.extensionKey] = macroAttributes;
        return accu;
    }, {});
};
const $44631a970962135a$var$convertLink = (link, autoconvertDefs, macroAttributesMap)=>{
    const matchedAcd = autoconvertDefs.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    if (matchedAcd) {
        const { macroName: macroName, urlParameter: urlParameter } = matchedAcd;
        const params = {};
        params[urlParameter] = link;
        const macroAttributes = macroAttributesMap[macroName];
        const convertedMacroAttributes = JSON.parse(JSON.stringify(macroAttributes));
        convertedMacroAttributes.attrs.text = `${urlParameter} = ${link}`;
        convertedMacroAttributes.attrs.extensionKey = macroName;
        if (!convertedMacroAttributes.attrs.parameters) convertedMacroAttributes.attrs.parameters = {};
        convertedMacroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(params);
        return convertedMacroAttributes;
    } else return null;
};
async function $44631a970962135a$export$13c25ccf87e8cca2(loadMacroMetadata, contentId) {
    const autoconvertDefs = [];
    const macros = await loadMacroMetadata();
    // this object contains name of macros which have correct autoconvertData
    const filteredMacros = new Set();
    macros.forEach((macro)=>{
        if (// Don't convert any new Trello links to Trello macro due to new Trello smart links
        !$44631a970962135a$var$hasAutoconvertData(macro) || macro.macroName === $44631a970962135a$var$TRELLO_MACRO_NAME) return;
        // only macro with autoconvertData can be converted
        macro.autoconvertData.patterns.forEach((pattern)=>{
            if ($44631a970962135a$var$isPatternSafe(pattern)) {
                const acd = {
                    macroName: macro.macroName,
                    urlParameter: macro.autoconvertData.urlParameter,
                    matcher: $44631a970962135a$var$convertPatternToRegex(pattern)
                };
                filteredMacros.add(acd.macroName);
                autoconvertDefs.push(acd);
            }
        });
    });
    const macroAttributes = await $44631a970962135a$var$getADFNodeForMacros(filteredMacros, contentId);
    return (link)=>$44631a970962135a$var$convertLink(link, autoconvertDefs, macroAttributes);
}
module.exports["createConnectAddonConverter"] = $44631a970962135a$export$13c25ccf87e8cca2;

});

parcelRegister("3LvmY", function(module, exports) {
const $a60398d8d7606d16$export$16d909a88d49df97 = ({ isViewPage: isViewPage, extensionKey: extensionKey, error: error })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'failed',
            actionSubject: 'connectRefEventDataValidation',
            attributes: {
                extensionKey: extensionKey,
                message: error.message
            }
        }
    };
};
const $a60398d8d7606d16$export$f472af28e6312d6e = ({ isViewPage: isViewPage, extensionKey: extensionKey })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'received',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: extensionKey
            }
        }
    };
};
module.exports["getValidationFailedEvent"] = $a60398d8d7606d16$export$16d909a88d49df97;
module.exports["getReceivedConnectRefDataEvent"] = $a60398d8d7606d16$export$f472af28e6312d6e;

});

parcelRegister("1AM4E", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $b8656fd966301400$var$getError = (messageOrError)=>{
    if (messageOrError instanceof Error) return messageOrError;
    return new Error(messageOrError);
};
const $b8656fd966301400$export$9e19abdf0a0245fe = new class ConnectReferentialityExperienceTrackerSupport {
    isTrackable(transfer) {
        return Boolean(transfer?.extensionKey) && Boolean(transfer?.localId) && Boolean(transfer?.data);
    }
    start(transfer) {
        (0, $fGzMp.getExperienceTracker)().start({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE),
            attributes: {
                extensionKey: transfer?.extensionKey,
                isViewPage: transfer?.isViewPage
            }
        });
    }
    succeed() {
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE)
        });
    }
    fail(messageOrError) {
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE),
            error: $b8656fd966301400$var$getError(messageOrError)
        });
    }
}();
module.exports["ConnectReferentialityExperienceTrackerSupport"] = $b8656fd966301400$export$9e19abdf0a0245fe;

});

parcelRegister("fNtDT", function(module, exports) {

let $b8026cfc4781e004$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8026cfc4781e004$var$load("iEvs6").then(()=>parcelRequire('bppNh'));

});

parcelRegister("hYoU4", function(module, exports) {

var $3wgAM = parcelRequire("3wgAM");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $1P1Tu.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $FOT9i.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $9zUhf.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("2HGN8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $42omo.useState)();
    // Clear the override state when navigating to a different page
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_appearance_override_reset')) setContentAppearanceOverride(undefined);
    }, [
        contentId
    ]);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const editorWidth = metadata?.editorWidth;
            const widthValue = editorWidth?.value;
            const version = editorWidth?.version;
            if (widthValue && version !== undefined) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    /*
  	Previous check was:
  	const draftAppearanceQuery = getContentAppearanceQuery(ContentAppearancePropertyKey.DRAFT);
  	which always returns contentAppearanceQuery
  */ const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $jMyy4.useQueryInterop)((0, $8VcPj.contentAppearanceQuery), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        __callerPackage__: "@confluence/content-appearance"
    });
    const context = (0, $42omo.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        // Under certain circumstances due to a previous bug with the content appearance during legacy editor autoconvert, an incorrect value may have been sent to collab service.
        // In this circumstance favour the initial content appearance value.
        const shouldUseInitial = contentAppearanceOverride && initialContentAppearance && contentAppearanceOverride.version === initialContentAppearance.version && contentAppearanceOverride.appearance !== initialContentAppearance.appearance;
        return {
            contentAppearance: shouldUseInitial ? initialContentAppearance : contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $42omo.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("dGzwg", function(module, exports) {
"use strict";
var $9f6ac0077b20b014$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $9f6ac0077b20b014$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $9f6ac0077b20b014$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $9f6ac0077b20b014$var$debounceTime;
var $9f6ac0077b20b014$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9f6ac0077b20b014$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9f6ac0077b20b014$var$DebounceTimeSubscriber = function(_super) {
    $9f6ac0077b20b014$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($9f6ac0077b20b014$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($axeml.Subscriber);
function $9f6ac0077b20b014$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

});

parcelRegister("41KFX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $6Dfc9 = parcelRequire("6Dfc9");


var $879OR = parcelRequire("879OR");

const $73d6907ec9f8e642$export$fce5991a3cbd7c5a = new Set([
    'default-templates',
    'pin-templates'
]);
const $73d6907ec9f8e642$var$DEFAULT_RESULT = {
    navStyle: 'control',
    isWithinD0: false,
    source: null
};
function $73d6907ec9f8e642$export$9e39472fc9788dd0() {
    if ((0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS),
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT
    ];
    return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
    ];
}
const $73d6907ec9f8e642$export$aed714501b2c585 = ()=>{
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)($73d6907ec9f8e642$export$9e39472fc9788dd0(), !(0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled'));
    const { isEligible: isEligibleForSimplifyNavXflow, isLoading: isLoadingIsEligibleForSimplifyNavXflow, hasError: hasEligibleForSimplifyNavXflowError, isWithinD0Window: isWithinD0WindowForSimplifyNavXflow } = (0, $879OR.useIsEligibleForSimplifyNavXflow)({
        onboardingStateData: onboardingStateData,
        onboardingStateLoading: onboardingStateLoading,
        onboardingStateError: onboardingStateError,
        skip: !(0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')
    });
    if (onboardingStateLoading) {
        if ((0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled')) return {
            navStyle: 'loading',
            isWithinD0: false,
            source: null
        };
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    if (onboardingStateError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const entries = onboardingStateData?.onboardingState;
    if (!entries) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const eligibleEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE);
    if (eligibleEntry?.value !== 'true') {
        // Not eligible for new user experiment, but might be for xflow.
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) {
            if (isLoadingIsEligibleForSimplifyNavXflow) // This may happen if TAP traits are loading, although they should generally be preloaded.
            // Case of onboarding state loading is handled in previous conditionals.
            return {
                navStyle: 'loading',
                isWithinD0: false,
                source: null
            };
            if (hasEligibleForSimplifyNavXflowError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
            if (isEligibleForSimplifyNavXflow) {
                const navStyle = (0, $6mKj3.expVal)('cfind_5565_creation_focused_nav_xflow', 'cohort', 'control');
                if ($73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return {
                    navStyle: navStyle,
                    isWithinD0: isWithinD0WindowForSimplifyNavXflow,
                    source: 'xflow'
                };
            }
        }
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    const navStyle = (0, $6mKj3.expVal)('cc_activation_simplify_nav_new_user', 'cohort', 'control');
    if (!$73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const startAtEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_START_AT);
    return {
        navStyle: navStyle,
        isWithinD0: (0, $6Dfc9.isWithinD0Window)(startAtEntry?.value),
        source: 'new-user'
    };
};
module.exports["TREATMENT_COHORTS"] = $73d6907ec9f8e642$export$fce5991a3cbd7c5a;
module.exports["useSimplifiedNavNewUsers"] = $73d6907ec9f8e642$export$aed714501b2c585;

});

parcelRegister("879OR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $kOUwv = parcelRequire("kOUwv");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $1KHQh = parcelRequire("1KHQh");


var $6Dfc9 = parcelRequire("6Dfc9");

const $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT = 'firstActivationDate';
// Use a module-level variable to ensure the effect only fires once per app lifecycle,
// even if the hook is called from multiple places simultaneously.
let $1f55678574e67c8a$var$hasRunEffect = false;
function $1f55678574e67c8a$export$5b324fbcfda94020() {
    $1f55678574e67c8a$var$hasRunEffect = false;
}
const $1f55678574e67c8a$export$bbe7d46982302b03 = ({ onboardingStateData: onboardingStateData, onboardingStateLoading: onboardingStateLoading, onboardingStateError: onboardingStateError, skip: skip })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    const { data: siteTraitsData, loading: siteTraitsDataLoading, error: siteTraitsDataError } = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: skip
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const entries = onboardingStateData?.onboardingState;
    const isInCfindLandCreationFocusedNavExperiment = !!entries?.find((s)=>s.key === (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME))?.value;
    const isInActivationExperiment = entries?.find(({ key: key })=>key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE)?.value === 'true';
    const isOnboardingStateForExperimentSet = entries?.find(({ key: key })=>key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE)?.value === 'true';
    const xflowStartAt = entries?.find(({ key: key })=>key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT)?.value;
    // We checked the user's eligibility at one point and determined they were not in treatment.
    const isReturningControlUser = isOnboardingStateForExperimentSet && !xflowStartAt;
    // A user who already has a START_AT recorded is a returning enrolled user and is always eligible.
    const isReturningEnrolledUser = !!xflowStartAt;
    const siteActivationDateTrait = siteTraitsData?.attributes?.find(({ name: name })=>name === $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT)?.value;
    // TAP site traits data is only needed when the user might be a first-time eligible user.
    // If onboarding state alone can determine eligibility, don't wait for TAP data to load —
    // this avoids an unnecessary loading state that hides navigation items.
    const canDetermineWithoutTap = skip || !hasLicensedAccess || isInCfindLandCreationFocusedNavExperiment || isInActivationExperiment || isReturningControlUser || isReturningEnrolledUser;
    const isLoading = !!(onboardingStateLoading || !canDetermineWithoutTap && siteTraitsDataLoading);
    const hasError = !!(onboardingStateError || !canDetermineWithoutTap && siteTraitsDataError);
    // A new user is eligible if their site's firstActivationDate is non-null and
    // after the experiment start date. Returning enrolled users are always eligible.
    const isSiteActivationAfterExperimentStart = ()=>{
        if (!siteActivationDateTrait) return false;
        const experimentStartDate = (0, $1KHQh.getXflowExperimentStartDate)();
        if (!experimentStartDate) return false;
        try {
            return new Date(siteActivationDateTrait) >= experimentStartDate;
        } catch  {
            return false;
        }
    };
    const isEligible = !skip && !isLoading && !hasError && hasLicensedAccess && !isInCfindLandCreationFocusedNavExperiment && !isInActivationExperiment && !isReturningControlUser && (isReturningEnrolledUser || isSiteActivationAfterExperimentStart());
    (0, $42omo.useEffect)(()=>{
        if (!isEligible || isOnboardingStateForExperimentSet || $1f55678574e67c8a$var$hasRunEffect) return;
        $1f55678574e67c8a$var$hasRunEffect = true;
        if ((0, $6mKj3.expValEquals)('cfind_5565_creation_focused_nav_xflow', 'cohort', 'pin-templates')) setOnboardingState([
            {
                key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
                value: 'true'
            },
            {
                key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT,
                value: new Date().toISOString()
            }
        ]);
        else setOnboardingState({
            key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'eligible',
                actionSubject: 'cfind-5565-simplify-nav-xflow',
                actionSubjectId: 'cfind-5565-simplify-nav-xflow',
                source: 'cfind-5565-simplify-nav-xflow',
                attributes: {
                    siteActivationDate: siteActivationDateTrait
                }
            }
        }).fire();
    }, [
        isEligible,
        isOnboardingStateForExperimentSet,
        setOnboardingState,
        siteActivationDateTrait,
        createAnalyticsEvent
    ]);
    return {
        isLoading: isLoading,
        hasError: hasError,
        isEligible: isEligible,
        // For returning enrolled users, use their START_AT timestamp to determine if they're
        // within the D0 window. For first-time users (no START_AT yet), they're implicitly
        // within their D0 window if and only if they're eligible.
        isWithinD0Window: xflowStartAt ? (0, $6Dfc9.isWithinD0Window)(xflowStartAt) : isEligible
    };
};
module.exports["useIsEligibleForSimplifyNavXflow"] = $1f55678574e67c8a$export$bbe7d46982302b03;

});

parcelRegister("dmKyV", function(module, exports) {
$parcel$export(module.exports, "WRM", () => (parcelRequire("1UB3e")).default);
$parcel$export(module.exports, "withWRMDependencies", () => (parcelRequire("6u5YI")).default);

var $1UB3e = parcelRequire("1UB3e");


var $6u5YI = parcelRequire("6u5YI");


});

parcelRegister("1UB3e", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 */ const $1647c2fd90c2cc68$var$WRM = {
    require (dependencies, callback) {
        return new Promise((resolve)=>{
            (0, $cpjd2.requireLegacyWRM)(dependencies, (modules)=>{
                resolve(modules);
                if (callback) callback(modules);
            }, ()=>{});
        });
    }
};
var $1647c2fd90c2cc68$export$2e2bcd8739ae039 = $1647c2fd90c2cc68$var$WRM;
module.exports["default"] = $1647c2fd90c2cc68$export$2e2bcd8739ae039;

});

parcelRegister("6u5YI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 *
 * withWRMDependencies is a decorator for loading WRM dependencies.
 *
 * It's a helper which besides loading dependencies will also hide the component
 * while the dependencies are not loaded avoiding FOUC and weird behaviours.
 *
 * usage:
 *
 * withWRMDependencies('wr!mypluginkey')(
 *  class MyComponent extends Component {}
 * )
 *
 * or
 *
 * withWRMDependencies(['wrc!myContext', 'wr!myWebResource'])(
 *  class MyComponent extends Component {}
 * )
 */ function $4b8a2e9a57493429$var$withWRMDependencies(dependencies, options) {
    const configs = {
        isBlocking: true,
        ...options
    };
    return (BaseComponent)=>{
        class WRMComponent extends (0, $42omo.Component) {
            componentDidMount() {
                this.mounted = true;
                if (dependencies && dependencies.length > 0) (0, $cpjd2.requireLegacyWRM)(dependencies, this.markAsLoaded, ()=>{});
                else this.markAsLoaded();
            }
            componentWillUnmount() {
                this.mounted = false;
            }
            render() {
                const { dependenciesLoaded: dependenciesLoaded } = this.state;
                if (dependenciesLoaded || !configs.isBlocking) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, {
                    ...this.props,
                    wrmDependenciesLoaded: dependenciesLoaded
                });
                else return null;
            }
            constructor(...args){
                super(...args);
                this.state = {
                    dependenciesLoaded: false
                };
                this.markAsLoaded = ()=>{
                    if (this.mounted) this.setState({
                        dependenciesLoaded: true
                    });
                };
            }
        }
        WRMComponent.displayName = `WRMComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return WRMComponent;
    };
}
var $4b8a2e9a57493429$export$2e2bcd8739ae039 = $4b8a2e9a57493429$var$withWRMDependencies;
module.exports["default"] = $4b8a2e9a57493429$export$2e2bcd8739ae039;

});

parcelRegister("2u5DE", function(module, exports) {
/* ConnectorIconPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $iXCQx = parcelRequire("iXCQx");


var $4m1Oz = parcelRequire("4m1Oz");

const $d17daeda8c6eb45a$var$styles = {
    base: "_2rkolb4i _1e0c1txw _4cvr1h6o _1bah1h6o",
    16: "_1bsb7vkz _4t3i7vkz",
    20: "_1bsbgktf _4t3igktf",
    24: "_1bsb1tcg _4t3i1tcg"
};
const $d17daeda8c6eb45a$export$9e3ad3aeb0d31482 = ({ connector: connector, size: size = 24 })=>{
    const { key: key, displayName: displayName } = connector;
    const LogoComponent = (0, $4m1Oz.getDataSourceLogo)(key);
    if (LogoComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($d17daeda8c6eb45a$var$styles.base, $d17daeda8c6eb45a$var$styles[size]),
        role: "img",
        "aria-label": displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LogoComponent, {
        size: size
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($d17daeda8c6eb45a$var$styles.base, $d17daeda8c6eb45a$var$styles[size]),
        role: "img",
        "aria-label": displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        weight: "semibold",
        color: "color.text.subtle"
    }, displayName.charAt(0).toUpperCase()));
};
module.exports["ConnectorIconPlaceholder"] = $d17daeda8c6eb45a$export$9e3ad3aeb0d31482;

});

parcelRegister("4m1Oz", function(module, exports) {
/**
 * Minimal entry point for connector display utilities.
 *
 * Exports only what is needed to resolve connector display names and logos
 * for UI surfaces that do not require the full form-builder UI. This imports
 * from `connector-display-data` which contains only display name messages and
 * SVG icon references, completely avoiding the heavy form-builder configs,
 * feature-gate side effects, URL constants, and connector-specific UI
 * components bundled by `/ui`.
 */ 
var $7Ahyw = parcelRequire("7Ahyw");

const $3cf416eed42ff920$export$b105eabd53e3db4d = (connectorType)=>{
    if (connectorType in (0, $7Ahyw.connectorDisplayDataMap)) return (0, $7Ahyw.connectorDisplayDataMap)[connectorType].icon;
    return undefined;
};
const $3cf416eed42ff920$export$aa607b28e60073a4 = (connectorType, _datasource)=>{
    if (connectorType in (0, $7Ahyw.connectorDisplayDataMap)) return (0, $7Ahyw.connectorDisplayDataMap)[connectorType].displayName;
    return '';
};
module.exports["getDataSourceLogo"] = $3cf416eed42ff920$export$b105eabd53e3db4d;
module.exports["getDataSourceTitle"] = $3cf416eed42ff920$export$aa607b28e60073a4;

});

parcelRegister("7Ahyw", function(module, exports) {
/**
 * Lightweight connector display data: display names and icon components only.
 *
 * This module is the single source of truth for connector display metadata
 * (name + icon). It deliberately avoids importing the full form-builder
 * connector configs, feature-gate logic, URL constants, and heavy UI
 * components so that consumers who only need display information (e.g. the
 * `/connector-display-utils` entry point) do not pull in the entire
 * form-builder dependency graph.
 *
 * The full `configsMap` in `displayed-third-party-products.tsx` references
 * this data via each connector config's `connectorDisplayName` and `icon`
 * fields, which remain the canonical values defined in each config file.
 * This module duplicates only the display name message descriptors so it can
 * stand alone without importing those config files.
 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1C4E7 = parcelRequire("1C4E7");


var $k2ZWs = parcelRequire("k2ZWs");

// ---------------------------------------------------------------------------
// Display name messages
// ---------------------------------------------------------------------------
// These mirror the `connectorDisplayName` message descriptors defined in each
// connector config file. The message IDs MUST stay in sync with the originals.
const $f3a07f6d44a4a605$var$displayMessages = (0, $aXWIB.defineMessages)({
    adobeSign: {
        id: "adobe-sign-connector.connector-display-name",
        defaultMessage: "Adobe Sign"
    },
    aha: {
        id: "aha-connector.connector-display-name",
        defaultMessage: "Aha!"
    },
    airtable: {
        id: "airtable-connector.connector-display-name",
        defaultMessage: "Airtable"
    },
    asana: {
        id: "asana-connector.connector-display-name",
        defaultMessage: "Asana"
    },
    azureDevops: {
        id: "azure-devops-connector.connector-display-name",
        defaultMessage: "Azure DevOps"
    },
    box: {
        id: "box-connector.connector-display-name",
        defaultMessage: "Box"
    },
    canva: {
        id: "canva-connector.connector-display-name",
        defaultMessage: "Canva"
    },
    confluenceDC: {
        id: "confluence-dc-connector.connector-display-name",
        defaultMessage: "Confluence Data Center"
    },
    databricks: {
        id: "databricks-connector.connector-display-name",
        defaultMessage: "Databricks"
    },
    datadog: {
        id: "datadog-connector.connector-display-name",
        defaultMessage: "Datadog"
    },
    demoConnector: {
        id: "demo-connector.connector-display-name.nonfinal",
        defaultMessage: "Demo Connector"
    },
    docusign: {
        id: "docusign-connector.connector-display-name",
        defaultMessage: "Docusign"
    },
    dropbox: {
        id: "dropbox-connector.connector-display-name",
        defaultMessage: "Dropbox"
    },
    dynatrace: {
        id: "dynatrace-connector.connector-display-name.nonfinal",
        defaultMessage: "Dynatrace"
    },
    exampleConnector: {
        id: "example-connector-config.connector-display-name.nonfinal",
        defaultMessage: "Example Connector"
    },
    exampleConnectorOAuth: {
        id: "example-connector-config.oauth-connector-display-name.nonfinal",
        defaultMessage: "Example Connector OAuth"
    },
    github: {
        id: "github-connector.connector-display-name",
        defaultMessage: "GitHub"
    },
    gitlab: {
        id: "gitlab-connector.connector-display-name",
        defaultMessage: "GitLab"
    },
    gmail: {
        id: "gmail-connector",
        defaultMessage: "Gmail"
    },
    googleCalendar: {
        id: "google-calendar-connector",
        defaultMessage: "Google Calendar"
    },
    googleDrive: {
        id: "google-drive-connector.display-name",
        defaultMessage: "Google Drive"
    },
    hris: {
        id: "hris-s3-connector.connector-display-name",
        defaultMessage: "HRIS S3"
    },
    hubspot: {
        id: "hubspot-connector.connector-display-name",
        defaultMessage: "HubSpot"
    },
    jiraDC: {
        id: "jira-dc-connector.connector-display-name",
        defaultMessage: "Jira Data Center"
    },
    lucid: {
        id: "lucid-connector.connector-display-name",
        defaultMessage: "Lucid"
    },
    microsoftTeams: {
        id: "teams-connector.connector-display-name",
        defaultMessage: "Microsoft Teams"
    },
    miro: {
        id: "miro-connector.connector-display-name",
        defaultMessage: "Miro"
    },
    monday: {
        id: "monday-connector.connector-display-name",
        defaultMessage: "Monday"
    },
    newrelic: {
        id: "newrelic-connector.connector-display-name",
        defaultMessage: "NewRelic"
    },
    notion: {
        id: "notion-connector.connector-display-name",
        defaultMessage: "Notion"
    },
    outlookCalendar: {
        id: "outlook-calendar-connector.connector-display-name",
        defaultMessage: "Microsoft Outlook Calendar"
    },
    outlookMail: {
        id: "outlook-mail-connector.connector-display-name",
        defaultMessage: "Microsoft Outlook Mail"
    },
    platformSharepoint: {
        id: "sharepoint-connector.platform-connector-display-name",
        defaultMessage: "Microsoft SharePoint and OneDrive"
    },
    salesforce: {
        id: "salesforce-connector.connector-display-name",
        defaultMessage: "Salesforce"
    },
    servicenow: {
        id: "servicenow-connector.connector-display-name",
        defaultMessage: "ServiceNow"
    },
    slack: {
        id: "slack-connector.connector-display-name",
        defaultMessage: "Slack"
    },
    smartsheet: {
        id: "smartsheet-connector.connector-display-name",
        defaultMessage: "Smartsheet"
    },
    spinnaker: {
        id: "spinnaker-connector.connector-display-name",
        defaultMessage: "Spinnaker"
    },
    webCrawler: {
        id: "web-crawler-connector.connector-display-name",
        defaultMessage: "Custom website"
    },
    workday: {
        id: "workday-connector.connector-display-name",
        defaultMessage: "Workday"
    },
    workdayV2: {
        id: "workday-v2-connector.connector-display-name",
        defaultMessage: "Workday"
    },
    zendesk: {
        id: "zendesk-connector.connector-display-name",
        defaultMessage: "Zendesk"
    }
});
const $f3a07f6d44a4a605$export$fc76a4fd8a4832c4 = {
    'test-connector-config-local': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.exampleConnector,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: ""
            })
    },
    'test-connector-config-local-oauth': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.exampleConnectorOAuth,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: ""
            })
    },
    'demo-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.demoConnector,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.rocketImage)
            })
    },
    'github-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.github,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.githubIcon)
            })
    },
    'microsoft-teams-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.microsoftTeams,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.microsoftTeamsIcon)
            })
    },
    'gmail-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.gmail,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.gmailIcon)
            })
    },
    'google-calendar-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.googleCalendar,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.googleCalendarIcon)
            })
    },
    'dropbox-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.dropbox,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.dropboxIcon)
            })
    },
    'salesforce-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.salesforce,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.salesforceIcon)
            })
    },
    'outlook-mail-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.outlookMail,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.microsoftOutlookMailIcon)
            })
    },
    'airtable-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.airtable,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.airtableIcon)
            })
    },
    'asana-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.asana,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.asanaIcon)
            })
    },
    'smartsheet-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.smartsheet,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.smartsheetIcon)
            })
    },
    'outlook-calendar-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.outlookCalendar,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.microsoftOutlookCalendarIcon)
            })
    },
    'notion-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.notion,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.notionIcon)
            })
    },
    'zendesk-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.zendesk,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.zendeskIcon)
            })
    },
    'docusign-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.docusign,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.docusignIcon)
            })
    },
    'servicenow-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.servicenow,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.serviceNowIcon)
            })
    },
    'miro-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.miro,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.miroIcon)
            })
    },
    'gitlab-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.gitlab,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.gitlabIcon)
            })
    },
    'lucid-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.lucid,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.lucidIcon)
            })
    },
    'box-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.box,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.boxIcon)
            })
    },
    'canva-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.canva,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.canvaIcon)
            })
    },
    'azure-devops-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.azureDevops,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.azureDevopsIcon)
            })
    },
    'adobe-sign-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.adobeSign,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.adobeSignIcon)
            })
    },
    'confluence-dc-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.confluenceDC,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.confluenceDcIcon)
            })
    },
    'platform-sharepoint-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.platformSharepoint,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.microsoftSharepointIcon)
            })
    },
    'jira-dc-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.jiraDC,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.jiraDcIcon)
            })
    },
    'monday-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.monday,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.mondayIcon)
            })
    },
    'aha-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.aha,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.ahaIcon)
            })
    },
    'workday-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.workday,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.workdayIcon)
            })
    },
    'workday-v2-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.workdayV2,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.workdayIcon)
            })
    },
    'platform-google-calendar-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.googleCalendar,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.googleCalendarIcon)
            })
    },
    'platform-google-drive-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.googleDrive,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.googleDriveIcon)
            })
    },
    'spinnaker-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.spinnaker,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.spinnakerIcon)
            })
    },
    'slack-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.slack,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.slackIcon)
            })
    },
    'hubspot-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.hubspot,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.hubspotIcon)
            })
    },
    'datadog-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.datadog,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.datadogIcon)
            })
    },
    'newrelic-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.newrelic,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.newrelicIcon)
            })
    },
    'dynatrace-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.dynatrace,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.dynatraceIcon)
            })
    },
    'databricks-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.databricks,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.databricksIcon)
            })
    },
    'hris-s3-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.hris,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.hrisIcon)
            })
    },
    'webcrawler-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.webCrawler,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.globeIcon)
            })
    },
    'platform-webcrawler-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.webCrawler,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.globeIcon)
            })
    }
};
module.exports["connectorDisplayDataMap"] = $f3a07f6d44a4a605$export$fc76a4fd8a4832c4;

});

parcelRegister("2qVTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ivb8S = parcelRequire("ivb8S");


var $iQzVo = parcelRequire("iQzVo");


var $bQm3c = parcelRequire("bQm3c");


var $7N8s0 = parcelRequire("7N8s0");


var $3rBp8 = parcelRequire("3rBp8");


var $kKl1I = parcelRequire("kKl1I");


var $iA3UT = parcelRequire("iA3UT");


var $f7K4n = parcelRequire("f7K4n");


var $fzrJO = parcelRequire("fzrJO");

/**
 * Computes the next PromoDismissed value when a surface is dismissed.
 * Merges with the existing state so sidebar and banner can be dismissed independently.
 */ function $a557bf5109e4692d$var$getNextPromoDismissed(current, surface) {
    // Not set or current is invalid
    if (!current || ![
        'sidebar',
        'banner'
    ].includes(current)) return surface;
    if (current === surface) return surface;
    return 'both';
}
const $a557bf5109e4692d$var$DISABLED_CONFIG = {
    recommendedConnectors: [],
    spotlightShown: false,
    enrolmentDate: null,
    shouldShowEmptyState: false,
    shouldShowNthPromo: false,
    shouldShowNthPagePromo: false,
    shouldShowPostConnectPromo: false,
    shouldShowPostConnectPagePromo: false,
    shouldShowSidebarItem: false,
    shouldShowSpotlight: false,
    onSetupConnector: ()=>{},
    onDismissPromo: ()=>{},
    onMaybeLater: ()=>{},
    onDismissSpotlight: ()=>{}
};
function $a557bf5109e4692d$export$a3a7ec612e040e85({ hasRecentItems: hasRecentItems = false } = {}) {
    // No experiment check here. Surface components gate rendering via
    // useIsConnectorOnboardingEnabled() before calling this hook.
    const intl = (0, $aXWIB.useIntl)();
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    const debugConnectorKey = environment !== 'PRODUCTION' ? (0, $6mKj3.UNSAFE_expValNoExposure)('twcg-1489-cc-3p-connector-onboarding', 'debugConnectors', '') || undefined : undefined;
    const { teamType: teamType } = (0, $iA3UT.useConnectorOnboardingTeamType)({
        skip: !(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-fg')
    });
    const { connectorStates: connectorStates, connectedCount: connectedCount, loading: connectorStatesLoading, error: connectorStatesError } = (0, $f7K4n.useConnectorStates)({
        skip: !(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-fg')
    });
    // Actions-only subscription: avoids re-rendering surfaces on modal open/close.
    const { openSetupModal: openSetupModal } = (0, $fzrJO.useSetupConnectorActions)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    // Connectors connected during this session. Merged into connectorStates below
    // so a just-connected connector drops out of the recommended list immediately,
    // without waiting for useConnectorStates (admin_getAllDataSources) to refetch.
    const connectedConnectorKeys = (0, $fzrJO.useConnectedConnectorKeys)();
    const effectiveConnectorStates = (0, $42omo.useMemo)(()=>{
        if (connectedConnectorKeys.length === 0) return connectorStates;
        const merged = {
            ...connectorStates
        };
        for (const key of connectedConnectorKeys)merged[key] = {
            ...merged[key],
            hasEnabledDataSource: true
        };
        return merged;
    }, [
        connectorStates,
        connectedConnectorKeys
    ]);
    // Carries the latest promoDismissed value into callbacks without violating rules-of-hooks.
    // Updated on every render after the loading/error early returns.
    const promoDismissedRef = (0, $42omo.useRef)(undefined);
    const { onboardingState: connectorOnboardingState, loading: onboardingStateLoading, error: onboardingStateError, updateOnboardingState: updateOnboardingState } = (0, $kKl1I.useConnectorOnboardingState)({
        skip: !(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-fg')
    });
    // Stable callback refs — must be declared before any early returns to satisfy rules-of-hooks
    const onSetupConnector = (0, $42omo.useCallback)((connectorKey)=>openSetupModal(connectorKey), [
        openSetupModal
    ]);
    const onDismissPromo = (0, $42omo.useCallback)((surface)=>{
        const next = $a557bf5109e4692d$var$getNextPromoDismissed(promoDismissedRef.current, surface);
        if (next === promoDismissedRef.current) return;
        const update = {
            key: (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED,
            value: next
        };
        setOnboardingState(update);
        updateOnboardingState(update);
        promoDismissedRef.current = next;
    }, [
        setOnboardingState,
        updateOnboardingState
    ]);
    const onMaybeLater = (0, $42omo.useCallback)(()=>{}, []);
    const onDismissSpotlight = (0, $42omo.useCallback)(()=>{
        const update = {
            key: (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).SPOTLIGHT_SHOWN,
            value: 'true'
        };
        setOnboardingState(update);
        updateOnboardingState(update);
    }, [
        setOnboardingState,
        updateOnboardingState
    ]);
    if (onboardingStateError) {
        if ((0, $1uFM6.isUnauthorizedError)(onboardingStateError)) (0, $7Sm4c.markErrorAsHandled)(onboardingStateError);
        return $a557bf5109e4692d$var$DISABLED_CONFIG;
    }
    if (connectorStatesError) {
        if ((0, $1uFM6.isUnauthorizedError)(connectorStatesError)) (0, $7Sm4c.markErrorAsHandled)(connectorStatesError);
        return $a557bf5109e4692d$var$DISABLED_CONFIG;
    }
    if (onboardingStateLoading || connectorStatesLoading) return $a557bf5109e4692d$var$DISABLED_CONFIG;
    // If 2+ connectors are already configured org-wide at load, the site is not a
    // good onboarding target; hide the entire experiment. Uses the query's
    // connectedCount (not in-session connections) so connecting a 2nd connector
    // mid-session keeps the surfaces while recommendations remain.
    if (connectedCount >= 2) return $a557bf5109e4692d$var$DISABLED_CONFIG;
    const { recommendedConnectors: recommendedConnectors, connectedAppName: connectedAppName } = (0, $3rBp8.getRecommendedConnectors)(teamType, effectiveConnectorStates, intl, debugConnectorKey);
    const hasConnectedAny = connectedAppName !== undefined;
    const nextRecommendedConnector = recommendedConnectors[recommendedConnectors.length - 1];
    const promoDismissed = connectorOnboardingState?.promoDismissed;
    // Keep the ref in sync so dismiss callbacks always close over the latest value.
    promoDismissedRef.current = promoDismissed;
    const spotlightShown = !!connectorOnboardingState?.spotlightShown;
    const enrolmentDateStr = connectorOnboardingState?.enrolmentDate;
    const enrolmentDate = enrolmentDateStr ? new Date(enrolmentDateStr) : null;
    const daysSinceEnrolment = (0, $7N8s0.getDaysSinceEnrolment)(enrolmentDateStr);
    const sidebarDismissed = promoDismissed === 'sidebar' || promoDismissed === 'both';
    const bannerDismissed = promoDismissed === 'banner' || promoDismissed === 'both';
    return {
        recommendedConnectors: recommendedConnectors,
        connectedAppName: connectedAppName,
        nextRecommendedConnector: nextRecommendedConnector,
        spotlightShown: spotlightShown,
        enrolmentDate: enrolmentDate,
        promoDismissed: promoDismissed,
        shouldShowEmptyState: !hasConnectedAny && !hasRecentItems,
        shouldShowNthPromo: hasRecentItems && !hasConnectedAny && !bannerDismissed,
        shouldShowNthPagePromo: hasRecentItems && !hasConnectedAny && !bannerDismissed,
        shouldShowPostConnectPromo: hasConnectedAny && !bannerDismissed,
        shouldShowPostConnectPagePromo: hasConnectedAny && !bannerDismissed,
        shouldShowSidebarItem: !sidebarDismissed,
        shouldShowSpotlight: !!enrolmentDate && daysSinceEnrolment >= 3 && !spotlightShown,
        onSetupConnector: onSetupConnector,
        onDismissPromo: onDismissPromo,
        onMaybeLater: onMaybeLater,
        onDismissSpotlight: onDismissSpotlight
    };
}
module.exports["useConnectorPromoConfig"] = $a557bf5109e4692d$export$a3a7ec612e040e85;

});

parcelRegister("3rBp8", function(module, exports) {

var $4m1Oz = parcelRequire("4m1Oz");

const $74d16154f462178f$export$79b5cd6c0e5e498b = {
    'SOFTWARE DEVELOPMENT': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'github-connector'
    ],
    DEFAULT: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    'PROJECT MANAGEMENT': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    OPERATIONS: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'servicenow-connector'
    ],
    'PRODUCT MANAGEMENT': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    DESIGN: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    'IT SUPPORT': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'servicenow-connector'
    ],
    MARKETING: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'hubspot-connector'
    ],
    SALES: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'salesforce-connector'
    ],
    FINANCE: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    'HUMAN RESOURCES': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'workday-v2-connector'
    ],
    LEGAL: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    'DATA SCIENCE': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'databricks-connector'
    ],
    'CUSTOMER SERVICE': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'zendesk-connector'
    ]
};
function $74d16154f462178f$export$21ab61aa81d09012(teamType, connectorStates, intl, debugConnectorKey) {
    const connectorKeys = teamType && $74d16154f462178f$export$79b5cd6c0e5e498b[teamType] ? $74d16154f462178f$export$79b5cd6c0e5e498b[teamType] : $74d16154f462178f$export$79b5cd6c0e5e498b.DEFAULT;
    const recommendedConnectors = [];
    let connectedAppName;
    for (const connectorKey of connectorKeys){
        const state = connectorStates[connectorKey];
        const isSetUp = state?.hasEnabledDataSource === true;
        const title = (0, $4m1Oz.getDataSourceTitle)(connectorKey, undefined);
        const displayName = typeof title === 'string' ? title || connectorKey : intl.formatMessage(title);
        if (isSetUp) {
            if (connectedAppName === undefined) connectedAppName = displayName;
        } else recommendedConnectors.push({
            key: connectorKey,
            displayName: displayName
        });
    }
    if (debugConnectorKey) {
        const debugTitle = (0, $4m1Oz.getDataSourceTitle)(debugConnectorKey, undefined);
        const debugDisplayName = typeof debugTitle === 'string' ? debugTitle || debugConnectorKey : intl.formatMessage(debugTitle);
        recommendedConnectors.unshift({
            key: debugConnectorKey,
            displayName: debugDisplayName
        });
    }
    return {
        recommendedConnectors: recommendedConnectors,
        connectedAppName: connectedAppName
    };
}
module.exports["TEAM_CONNECTOR_MAP"] = $74d16154f462178f$export$79b5cd6c0e5e498b;
module.exports["getRecommendedConnectors"] = $74d16154f462178f$export$21ab61aa81d09012;

});

parcelRegister("iA3UT", function(module, exports) {

var $ljH80 = parcelRequire("ljH80");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $3rBp8 = parcelRequire("3rBp8");

const $79de3473932085bf$var$VALID_TEAM_TYPES = Object.keys((0, $3rBp8.TEAM_CONNECTOR_MAP));
const $79de3473932085bf$var$userTeamTypeQuery = (0, $ljH80.default);
const $79de3473932085bf$var$sanitizeTeamType = (teamType)=>{
    if (teamType && $79de3473932085bf$var$VALID_TEAM_TYPES.includes(teamType)) return teamType;
    return undefined;
};
const $79de3473932085bf$export$94dea13b9b35c280 = ({ skip: skip } = {})=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($79de3473932085bf$var$userTeamTypeQuery, {
        variables: {
            userId: userId ?? ''
        },
        skip: skip || !isLicensed || !userId,
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/experiment-twcg-1489-cc-3p-connector-onboarding"
    });
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'useConnectorOnboardingTeamTypeQuery',
                source: 'twcg1489ConnectorOnboarding',
                attributes: {
                    message: error.message
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent
    ]);
    if (loading) return {
        teamType: undefined,
        loading: true
    };
    if (error) return {
        teamType: undefined,
        loading: false,
        error: error
    };
    if (data?.user?.__typename === 'AtlassianAccountUser') return {
        teamType: $79de3473932085bf$var$sanitizeTeamType(data.user.extendedProfile?.teamType?.toUpperCase()),
        loading: false
    };
    return {
        teamType: undefined,
        loading: false
    };
};
module.exports["useConnectorOnboardingTeamType"] = $79de3473932085bf$export$94dea13b9b35c280;

});

parcelRegister("f7K4n", function(module, exports) {

var $iGpO4 = parcelRequire("iGpO4");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");

const $aad293923f85f3d0$var$connectorStatesQuery = (0, $iGpO4.default);
function $aad293923f85f3d0$export$6b0d2f38f604a837({ skip: skip } = {}) {
    const { orgId: orgId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = Boolean(skip || !orgId || !cloudId);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($aad293923f85f3d0$var$connectorStatesQuery, {
        variables: {
            orgId: orgId ?? '',
            resourceId: cloudId ?? '',
            first: 75
        },
        skip: shouldSkip,
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/experiment-twcg-1489-cc-3p-connector-onboarding"
    });
    const { connectorStates: connectorStates, connectedCount: connectedCount } = (0, $42omo.useMemo)(()=>{
        const edges = data?.admin_getAllDataSources?.edges;
        if (!edges) return {
            connectorStates: {},
            connectedCount: 0
        };
        const result = {};
        let count = 0;
        for (const edge of edges){
            const node = edge?.node;
            if (!node?.type) continue;
            // .find() is used instead of .some() because the perf-linting/no-quadratic-complexity
            // rule tracks 'some' as a nested iterator and fires when called inside an outer
            // for-of loop; 'find' is not in its ITERATOR_METHODS set.
            const hasEnabledDataSource = Boolean(node.datasources?.find((ds)=>ds.enabled));
            result[node.type] = {
                hasEnabledDataSource: hasEnabledDataSource
            };
            if (hasEnabledDataSource) count += 1;
        }
        return {
            connectorStates: result,
            connectedCount: count
        };
    }, [
        data
    ]);
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            connectorStates: {},
            connectedCount: 0,
            loading: false,
            error: error
        };
    }
    if (loading) return {
        connectorStates: {},
        connectedCount: 0,
        loading: true
    };
    return {
        connectorStates: connectorStates,
        connectedCount: connectedCount,
        loading: false
    };
}
module.exports["useConnectorStates"] = $aad293923f85f3d0$export$6b0d2f38f604a837;

});

parcelRegister("fBjVq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3141cf32c54bf764$var$RendererLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AfRhk",
    // Name needs to match the one in next/packages/view-page/src/index.ts
    name: "ClassicRendererLoader",
    loader: ()=>(parcelRequire("dyQZh"))
});
var $3141cf32c54bf764$export$2e2bcd8739ae039 = $3141cf32c54bf764$var$RendererLoader;
module.exports["default"] = $3141cf32c54bf764$export$2e2bcd8739ae039;

});

parcelRegister("dyQZh", function(module, exports) {

let $9df78d88df4b474b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9df78d88df4b474b$var$load("h3ABO"),
    $9df78d88df4b474b$var$load("2YffH"),
    $9df78d88df4b474b$var$load("bSSi4"),
    $9df78d88df4b474b$var$load("lsOq1"),
    $9df78d88df4b474b$var$load("2LxnN"),
    $9df78d88df4b474b$var$load("e2ahM"),
    $9df78d88df4b474b$var$load("dzUzj"),
    $9df78d88df4b474b$var$load("5Wqrg"),
    $9df78d88df4b474b$var$load("HaNwW"),
    $9df78d88df4b474b$var$load("5iZqi"),
    $9df78d88df4b474b$var$load("evm5a"),
    $9df78d88df4b474b$var$load("c6VA1"),
    $9df78d88df4b474b$var$load("2MTmD"),
    $9df78d88df4b474b$var$load("eBRUf"),
    $9df78d88df4b474b$var$load("hOBst"),
    $9df78d88df4b474b$var$load("bzyKp"),
    $9df78d88df4b474b$var$load("k3yUD"),
    $9df78d88df4b474b$var$load("2RWyc"),
    $9df78d88df4b474b$var$load("2F69B"),
    $9df78d88df4b474b$var$load("fAtWn"),
    $9df78d88df4b474b$var$load("iPYAE"),
    $9df78d88df4b474b$var$load("cyGuT"),
    $9df78d88df4b474b$var$load("3KVI3"),
    $9df78d88df4b474b$var$load("5lTVp"),
    $9df78d88df4b474b$var$load("lWNY8"),
    $9df78d88df4b474b$var$load("6wr18"),
    $9df78d88df4b474b$var$load("h9S8v"),
    $9df78d88df4b474b$var$load("jPuvo"),
    $9df78d88df4b474b$var$load("3GuOt"),
    $9df78d88df4b474b$var$load("el56J"),
    $9df78d88df4b474b$var$load("ffEVr"),
    $9df78d88df4b474b$var$load("hxmLu"),
    $9df78d88df4b474b$var$load("1oUEV"),
    $9df78d88df4b474b$var$load("eIWkK"),
    $9df78d88df4b474b$var$load("a0cZb"),
    $9df78d88df4b474b$var$load("RXMWr"),
    $9df78d88df4b474b$var$load("jLwPS"),
    $9df78d88df4b474b$var$load("9IMTL"),
    $9df78d88df4b474b$var$load("5dBst"),
    $9df78d88df4b474b$var$load("6GIKD"),
    $9df78d88df4b474b$var$load("2Ws5B"),
    $9df78d88df4b474b$var$load("coUzl"),
    $9df78d88df4b474b$var$load("5nMTY"),
    $9df78d88df4b474b$var$load("7j0mT"),
    $9df78d88df4b474b$var$load("69R9L"),
    $9df78d88df4b474b$var$load("7tgvK"),
    $9df78d88df4b474b$var$load("fRtVQ"),
    $9df78d88df4b474b$var$load("b9CA3"),
    $9df78d88df4b474b$var$load("g0OKa"),
    $9df78d88df4b474b$var$load("hhss7"),
    $9df78d88df4b474b$var$load("Wowvf"),
    $9df78d88df4b474b$var$load("1F7LX"),
    $9df78d88df4b474b$var$load("c6DIp"),
    $9df78d88df4b474b$var$load("dgH7p"),
    $9df78d88df4b474b$var$load("hH53H"),
    $9df78d88df4b474b$var$load("jZLnv"),
    $9df78d88df4b474b$var$load("6edij"),
    $9df78d88df4b474b$var$load("hXbzh"),
    $9df78d88df4b474b$var$load("foAs3"),
    $9df78d88df4b474b$var$load("f2Ovh"),
    $9df78d88df4b474b$var$load("lAHER"),
    $9df78d88df4b474b$var$load("7EorR"),
    $9df78d88df4b474b$var$load("8CeYz")
]).then(()=>parcelRequire('djmKw'));

});

parcelRegister("eDAGu", function(module, exports) {

var $2c1Wz = parcelRequire("2c1Wz");


var $i7t6K = parcelRequire("i7t6K");

let $7ca3f558dc62e54e$var$pe = null;
const $7ca3f558dc62e54e$var$getObserver = ()=>{
    if ($7ca3f558dc62e54e$var$pe !== null) return $7ca3f558dc62e54e$var$pe;
    $7ca3f558dc62e54e$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).LongTask) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask].push(entry);
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).Event) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).Event].push(entry);
        });
    });
    return $7ca3f558dc62e54e$var$pe;
};
const $7ca3f558dc62e54e$export$231c167ad8c908df = ()=>{
    if ($7ca3f558dc62e54e$var$pe) {
        // Disconnect the observer if it's already set up
        $7ca3f558dc62e54e$var$pe.disconnect();
        $7ca3f558dc62e54e$var$pe = null;
    }
    for (const type of Object.values((0, $2c1Wz.PerformanceObserverEntryTypes)))$7ca3f558dc62e54e$var$getObserver().observe({
        type: type,
        buffered: true
    });
};
module.exports["startLightHouseObservers"] = $7ca3f558dc62e54e$export$231c167ad8c908df;

});

parcelRegister("lTjel", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $94ecb5e99e218b76$export$b602c35a55c29946 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "-DYr1",
    name: "ErrorAppLoader",
    loader: async ()=>(await (parcelRequire("bZGgW"))).ErrorApp
});
module.exports["ErrorAppLoader"] = $94ecb5e99e218b76$export$b602c35a55c29946;

});

parcelRegister("aFgFx", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");




var $a2zQR = parcelRequire("a2zQR");

async function $457aeee54b862c4a$export$b1c9c77d4871a337(spaceKey, contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $457aeee54b862c4a$var$preloadContentData(contentId, spaceKey),
        $457aeee54b862c4a$var$preloadContentTree(contentId, spaceKey)
    ]);
}
async function $457aeee54b862c4a$var$preloadContentData(contentId, spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $a2zQR.default),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/confluence-embeds"
    });
}
async function $457aeee54b862c4a$var$preloadContentTree(contentId, spaceKey) {}
module.exports["preloadEmbedData"] = $457aeee54b862c4a$export$b1c9c77d4871a337;

});

parcelRegister("kyd3u", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");



var $9ycGg = parcelRequire("9ycGg");




var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");

function $7f1954fc7a2cd99f$export$c628356b573f8241({ isUnpublishedDraft: isUnpublishedDraft, spaceKey: spaceKey, contentId: contentId }) {
    const queries = [
        (0, $dYU3e.query)({
            query: (0, $fxLAA.default),
            variables: {
                contentId: contentId,
                spaceKey: spaceKey,
                versionOverride: null,
                embeddedContentRender: null,
                limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
                ...isUnpublishedDraft && {
                    status: [
                        'draft'
                    ]
                }
            },
            __callerPackage__: "@confluence/content-header"
        }),
        (0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        })
    ];
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}
module.exports["preloadEditorByLineData"] = $7f1954fc7a2cd99f$export$c628356b573f8241;

});

parcelRegister("ddSqr", function(module, exports) {

var $5rHrW = parcelRequire("5rHrW");


var $wPrRK = parcelRequire("wPrRK");


var $dYU3e = parcelRequire("dYU3e");


var $lyWac = parcelRequire("lyWac");


var $cRQNp = parcelRequire("cRQNp");


var $eP7b6 = parcelRequire("eP7b6");


var $9HhEw = parcelRequire("9HhEw");

function $1b23138cfdb36f61$export$77aa43a33b3d905d(contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $eP7b6.default),
            variables: {
                contentId: contentId
            },
            context: {
                allowOnExternalPage: true
            },
            __callerPackage__: "@confluence/content-header"
        }),
        (0, $dYU3e.query)({
            query: (0, $9HhEw.default),
            variables: {
                contentId: contentId
            },
            context: {
                allowOnExternalPage: true
            },
            __callerPackage__: "@confluence/content-header"
        }),
        (0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            includeContentBody: true,
            useCache: true
        }),
        (0, $wPrRK.slowQueryGuard)('preloadContentAnalyticsViewers', ()=>(0, $5rHrW.preloadContentAnalyticsViewers)(contentId), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT))
    ]);
}
module.exports["preloadContentTitleWithByLineExternal"] = $1b23138cfdb36f61$export$77aa43a33b3d905d;

});

parcelRegister("6YxJf", function(module, exports) {

var $MyxIQ = parcelRequire("MyxIQ");

const $3050fc659ed4bb43$export$4be2eb0104d640dc = async ()=>{
    return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('confluence-home-banner');
};
module.exports["preloadPostOfficeConfluenceHomeBanner"] = $3050fc659ed4bb43$export$4be2eb0104d640dc;

});

parcelRegister("1Rv6U", function(module, exports) {
// Data Plugin definition and utility types
const $355a7b1aa3f573ec$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $355a7b1aa3f573ec$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $355a7b1aa3f573ec$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $355a7b1aa3f573ec$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};
module.exports["PluginTypes"] = $355a7b1aa3f573ec$export$a235a73f7b906dce;
module.exports["ContainerTypes"] = $355a7b1aa3f573ec$export$6e383182a26455ff;
module.exports["UserIdTypes"] = $355a7b1aa3f573ec$export$e391bab95adb8396;

});

parcelRegister("h3nb6", function(module, exports) {
/* eslint-disable no-restricted-syntax */ 
var $42omo = parcelRequire("42omo");


var $64KID = parcelRequire("64KID");


var $kE2cJ = parcelRequire("kE2cJ");


var $jmjWc = parcelRequire("jmjWc");


const $e9270d50e13c4524$export$58ad04e57ec143c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DOtt7",
    name: "RedirectLegacyCopyPageLoader",
    loader: async ()=>(await (parcelRequire("3JgB7"))).RedirectLegacyCopyPage
});
$e9270d50e13c4524$export$58ad04e57ec143c3.NAVIGATION_PARAMS = ()=>false;






const $1547fdfac1788133$export$70a5a4ee184a1106 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "hF4WF",
    name: "RedirectLegacyViewPageLoader",
    loader: async ()=>(await (parcelRequire("9RxHT"))).RedirectLegacyViewPage
});
$1547fdfac1788133$export$70a5a4ee184a1106.NAVIGATION_PARAMS = ()=>false;




// These are routes shared between SSR and SPA

var $jiFpb = parcelRequire("jiFpb");


var $4lJOK = parcelRequire("4lJOK");


var $hDf9e = parcelRequire("hDf9e");


var $hkCxu = parcelRequire("hkCxu");


var $k1285 = parcelRequire("k1285");


var $SwMnm = parcelRequire("SwMnm");




var $jiJCD = parcelRequire("jiJCD");





var $kFqI2 = parcelRequire("kFqI2");


var $kJOOQ = parcelRequire("kJOOQ");

parcelRequire("6g1oe");


var $aTWRz = parcelRequire("aTWRz");

var $iyEDi = parcelRequire("iyEDi");

const $8012954d5e28a430$export$33ab8fb3f76d8b14 = ()=>{
    const location = (0, $kFqI2.useSelector)((0, $iyEDi.getLocation));
    const dispatch = (0, $kFqI2.useDispatch)();
    (0, $42omo.useEffect)(()=>{
        const { query: query, pathname: pathname } = location;
        let contentType;
        if (pathname.indexOf('/createpage.action') !== -1 || pathname.indexOf('/createpage-entervariables.action') !== -1) contentType = 'pages';
        else if (pathname.indexOf('/createblogpost.action') !== -1) contentType = 'blog';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        let spaceKey;
        if (typeof query.spaceKey !== 'undefined' && query.spaceKey) spaceKey = query.spaceKey;
        else if (typeof query.draftId !== 'undefined' && /^[0-9]+$/.test(query.draftId)) spaceKey = 'byDraft';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        const newQuery = {};
        Object.keys(query).filter((param)=>param !== 'spaceKey').forEach((param)=>newQuery[param] = query[param]);
        const nextLocation = {
            ...location,
            pathname: `${(0, $aTWRz.CONTEXT_PATH)}/spaces/${spaceKey}/${contentType}/create`,
            query: newQuery,
            search: (0, $jiJCD.format)({
                query: newQuery
            })
        };
        dispatch((0, $kJOOQ.replace)(nextLocation));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
$8012954d5e28a430$export$33ab8fb3f76d8b14.NAVIGATION_PARAMS = ()=>false;






var $lFjPc = parcelRequire("lFjPc");


var $aVKfT = parcelRequire("aVKfT");

const $d553d8b4da7f3160$export$25552d6a584e1fb8 = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>{
    // Construct the module id from URL params to match the format expected by ForgeGlobalSettingsExtensionPoint
    // Format: ari:cloud:ecosystem::extension/{appId}/{envId}/static/{moduleKey}
    // This matches against app.id in the Forge extensions list
    const id = `ari:cloud:ecosystem::extension/${appId}/${envId}/static/${forgeManifestRoute}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVKfT.ForgeGlobalSettingsExtensionPoint), {
        key: id,
        id: id
    });
};
$d553d8b4da7f3160$export$25552d6a584e1fb8.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminForgeApps'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $5d42f987126d0d25$var$AdminForgeAppsRedirect = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "vKaNx",
    name: "AdminForgeAppsRedirect",
    loader: async ()=>(await (parcelRequire("jOXb3"))).AdminForgeAppsRedirect
});
const $5d42f987126d0d25$export$1eaead8b8e68953c = ({ params: params, query: query })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5d42f987126d0d25$var$AdminForgeAppsRedirect, {
        params: params,
        query: query
    });
};
$5d42f987126d0d25$export$1eaead8b8e68953c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminForgeAppsRedirect'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









var $aF1vZ = parcelRequire("aF1vZ");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aF1vZ.AdvancedSearch), null);
$f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: (0, $9wGTI.fg)('unified_search_in_confluence') ? null : {
            screenEvent: {
                name: 'advancedSearchScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('fullpage_search_summarize_button_revamp', 'fullpage_search_summarize_button_revamp_treatment', 'visibility') || (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('fullpage_search_summarize_button_revamp', 'fullpage_search_summarize_button_revamp_treatment', 'border')
        }
    };
};


/* eslint react/prop-types:0 */ 









const $f9284ca1d97b2b7a$export$32926c3a37851958 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Rr_Hq",
    name: "BetaFeaturesSiteSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("fS0ja"))).BetaFeaturesSiteSettingsPage
});


const $7949c11e9e78d917$export$39279dc1d0cb138f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f9284ca1d97b2b7a$export$32926c3a37851958), null);
$7949c11e9e78d917$export$39279dc1d0cb138f.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'betaFeaturesScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });








var $8g7sM = parcelRequire("8g7sM");




var $bUMKD = parcelRequire("bUMKD");


var $78QFu = parcelRequire("78QFu");

const $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f = ({ params: { contentId: contentId, externalToken: externalToken }, hash: hash })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUMKD.ExternalSharePageLoader), {
        contentId: contentId === 'undefined' ? undefined : contentId,
        shareToken: externalToken,
        queryHash: hash,
        ContentRenderer: (0, $8g7sM.default)
    });
$b4ceb88d52b227e6$export$2f64eafbbfb5bb9f.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: true,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                routeName: name
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });












const $2a1308b9f924bd74$export$dceb5680f254ba0d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4i8AJ",
    name: "ForgeGlobalPageExtensionPoint",
    loader: async ()=>(await (parcelRequire("7lrfj"))).GlobalPage
});


const $88f9531119605f50$export$a0e2b6c59fd25a4e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2a1308b9f924bd74$export$dceb5680f254ba0d), {
        key: `${appId}-${envId}-${forgeManifestRoute}`,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$88f9531119605f50$export$a0e2b6c59fd25a4e.NAVIGATION_PARAMS = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>{
    return {
        Screen: {
            screenEvent: {
                name: 'globalPageScreen',
                id: appId,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    };
};












const $5651b1434c6bae88$var$SitePermissions = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8YbJt",
    name: "SitePermissions",
    loader: async ()=>(await (parcelRequire("9dIvj"))).SitePermissions
});
const $5651b1434c6bae88$export$72e24cb8f0330a61 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5651b1434c6bae88$var$SitePermissions, null);
$5651b1434c6bae88$export$72e24cb8f0330a61.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









var $6X8o4 = parcelRequire("6X8o4");


var $1NBp8 = parcelRequire("1NBp8");


var $ge2sX = parcelRequire("ge2sX");


var $d9tcB = parcelRequire("d9tcB");

function $5340377d047d37c6$export$3c0681f7b17941c4(routeMatch) {
    if (routeMatch?.name === (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name || routeMatch?.name === (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name && // Hub Dashboard aka Consolidated Settings (https://hello.atlassian.net/wiki/spaces/CLI/pages/4111377280/Project+Poster+Hub+Dashboard) uses /admin/permissions/hub without the tab param and doesn't use the site admin nav there:
    routeMatch?.params?.tab) {
        // https://hello.atlassian.net/wiki/spaces/~701217e532d6bdc7846948a0f4e8afe31a122/pages/3993181421/Company+Hub+-+Beta+Tag+Removal
        // documents the product and design folks of Company Hub want Hub permissions to be among the site admin screens of the product,
        // specifically next to permissions-related screens such as Global permissions, Space permissions, Analytics permissions, etc in
        // the Security section.
        const sessionData = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)());
        // But for non-site admins the site admin side nav is pretty much empty and, more importantly, there are no other
        // permissions-related screens there. Then Hub permissions in the site admin side nav can only make sense to site admins.
        if (sessionData?.accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS) return true;
    }
    return false;
}



var $9HNv5 = parcelRequire("9HNv5");







var $agglT = parcelRequire("agglT");


const $b11848dc615e604f$export$b212d6e1ccf8d345 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uZr6h",
    loader: async ()=>(await (parcelRequire("bUPA7"))).CompanyHubSettingsPage,
    name: 'CompanyHubSettingsPage'
});



var $8NC5Z = parcelRequire("8NC5Z");


var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");




var $2Uf3N = parcelRequire("2Uf3N");























var $iquRY = parcelRequire("iquRY");


const $3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3C38l",
    name: "SpacePermissionsSettingsRouteComponent",
    loader: async ()=>(parcelRequire("K4Itq"))
});
const $3dace45d43821ccc$var$DEFAULT_TAB = 'users';
const $3dace45d43821ccc$export$c4e68572e7b94bc6 = ({ name: routeName, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } })=>{
    //
    // Warning:
    // "Hub permissions" is a customization of "Space permissions" predating RBAC so
    // "Hub permissions" is to be used in the Company Hub-type of space and
    // "Space permissions" or RBAC are to be used in all other types of space!
    //
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (isCompanyHub) {
        if (routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name,
            params: {
                tab: 'users'
            }
        });
    } else {
        //RBAC Milestone 2 Redirect Logic in case users try to access via url
        const isSpacePermissionsTab = tab === 'users' || tab === 'groups' || tab === 'guests';
        if (isSpacePermissionsTab && isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.SPACE_MEMBERS).name,
            params: {
                spaceKey: spaceKey
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$3dace45d43821ccc$export$c4e68572e7b94bc6.NAVIGATION_PARAMS = (routeMatch, isNav4Enabled)=>{
    const { name: name, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } } = routeMatch;
    return {
        Screen: {
            screenEvent: {
                name: tab === 'public-links' ? 'spacePermissionsPublicLinksScreen' : `${tab}SpacePermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: $3dace45d43821ccc$var$getSideNav(routeMatch, isNav4Enabled),
            spaceKey: spaceKey
        }
    };
};
const $3dace45d43821ccc$var$getSideNav = (routeMatch, isNav4Enabled)=>(0, $cEgMD.isCompanyHubSpaceKey)(routeMatch.params.spaceKey) && (0, $5340377d047d37c6$export$3c0681f7b17941c4)(routeMatch) ? (0, $lFjPc.ADMIN_HOME_ID) : isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID);









const $94454e5f287d76d5$export$a9d78c41686becfd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "2UE21",
    loader: async ()=>(await (parcelRequire("5TJmA"))).SpaceRoleManagementPage,
    name: 'SpaceRoleManagementPage'
});

















const $f9fff28badc7670c$export$214350c926cc60f2 = ({ name: routeName, params: { spaceKey: spaceKey } })=>{
    const { isRbacEnabled: isRbacEnabled, loading: loading } = (0, $iquRY.useSpaceRoleMode)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub && routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name,
        params: {
            tab: 'users'
        }
    });
    if (!loading && !isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94454e5f287d76d5$export$a9d78c41686becfd), {
        spaceKey: spaceKey
    });
};
$f9fff28badc7670c$export$214350c926cc60f2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceMembersScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });





/**
 * The routes "Company Hub settings > Users" and "Hub permissions" in the Confluence app.
 * `AdminCompanyHubPermissionsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute({ params: params, ...props }) {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (isSiteAdmin && shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
        featureName: "companyHubPermissions"
    });
    if (!params.tab) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).USERS
    });
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    if (isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f9fff28badc7670c$export$214350c926cc60f2), {
        ...props,
        params: {
            spaceKey: spaceKey,
            ...params
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dace45d43821ccc$export$c4e68572e7b94bc6), {
        ...props,
        params: {
            spaceKey: spaceKey,
            ...params
        }
    });
}
$ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name, params: params } = routeMatch;
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = (0, $5340377d047d37c6$export$3c0681f7b17941c4)(routeMatch) ? (0, $lFjPc.ADMIN_HOME_ID) : (0, $lFjPc.COMPANY_HUB_SETTINGS_ID);
    return {
        Screen: {
            screenEvent: {
                name: `${params.tab || 'consolidated'}HubPermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: navView,
            spaceKey: spaceKey
        }
    };
};
const $ce2a2ee7f6871785$export$eeb7368e8bf944ac = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute);


















const $4fa13b181dc663ad$var$CustomizeNavigation = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Ss1hK",
    name: "CustomizeNavigation",
    loader: async ()=>(await (parcelRequire("fUGDw"))).CustomizeNavigation
});
const $4fa13b181dc663ad$export$3206f56dd9eda6e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fa13b181dc663ad$var$CustomizeNavigation, null);
$4fa13b181dc663ad$export$3206f56dd9eda6e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'customizeNavigationScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });
const $4fa13b181dc663ad$export$5744f34ed241a45c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$4fa13b181dc663ad$export$5744f34ed241a45c.NAVIGATION_PARAMS = ()=>false;









const $9dff8dc763109b25$export$a4a7c409f3d3e524 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LLjB-",
    name: "GlobalAutomationRoute",
    loader: async ()=>(await (parcelRequire("6V55f"))).Automation
});
$9dff8dc763109b25$export$a4a7c409f3d3e524.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalAutomationRoute'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $3e17cd15ad9a2d77$var$UserDetails = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4otHM",
    name: "UserDetails",
    loader: async ()=>(await (parcelRequire("769vU"))).UserDetails
});
const $3e17cd15ad9a2d77$export$ef0ae9b94af7599 = ({ params: { accountId: accountId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3e17cd15ad9a2d77$var$UserDetails, {
        accountId: accountId
    });
$3e17cd15ad9a2d77$export$ef0ae9b94af7599.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsUserDetailsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });





parcelRequire("b1pD4");
var $3ACqI = parcelRequire("3ACqI");





const $a311429dbe08f666$export$6b6e4f47fea5bdb9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w4gXW",
    name: "ViewPagePdfExportLoader",
    loader: async ()=>(await (parcelRequire("iWp4Q"))).ViewPagePdfExportPage
});


parcelRequire("4Yv1J");
var $f5aR2 = parcelRequire("f5aR2");

parcelRequire("crTA1");
var $iqZzD = parcelRequire("iqZzD");

const $de365c057d45c0f8$export$d4d3fe32e0af1ab9 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a311429dbe08f666$export$6b6e4f47fea5bdb9), {
        contentId: String(contentId),
        spaceKey: String(spaceKey),
        classicComments: (0, $3ACqI.CommentsSectionLoader)
    })));
$de365c057d45c0f8$export$d4d3fe32e0af1ab9.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                contentId: contentId,
                routeName: name,
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });






var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");

parcelRequire("4Yv1J");


parcelRequire("crTA1");


const $cdc5bb1b4ce25ace$export$f10520cd46ef45dd = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $djZz9.SpaceOverviewLoader), {
        spaceKey: String(spaceKey)
    })));
$cdc5bb1b4ce25ace$export$f10520cd46ef45dd.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                routeName: name,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            },
            spaceKey: spaceKey
        },
        MainLayout: {
            enableNavigation: false
        }
    });






var $1wgMJ = parcelRequire("1wgMJ");








var $56QzY = parcelRequire("56QzY");


const $24a857c7c96255d7$var$PeopleDirectory = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zWQBJ",
    name: "PeopleDirectory",
    loader: async ()=>(await (parcelRequire("3BNlM"))).PeopleDirectory
});
const $24a857c7c96255d7$export$c7bf94fd367d52ef = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24a857c7c96255d7$var$PeopleDirectory, {
        statusCodeHandlers: {
            401: (0, $1wgMJ.redirectToLoginPage)
        }
    });
$24a857c7c96255d7$export$c7bf94fd367d52ef.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            name: 'inProdPeopleDirectory',
            attributes: {
                navdexPointType: (0, $56QzY.START_TOUCH)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    };
};












const $a6aaee7eaacb3bc0$export$1696ac6f866195be = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MGscQ",
    name: "MarketplaceRoute",
    loader: async ()=>(await (parcelRequire("QVJaI"))).Marketplace
});
$a6aaee7eaacb3bc0$export$1696ac6f866195be.NAVIGATION_PARAMS = ({ name: name })=>{
    let eventName = '';
    let navView = (0, $lFjPc.PRODUCT_HOME_ID);
    if (name === (0, $1NBp8.MARKETPLACE_FIND_APPS).name) {
        eventName = 'marketplaceFindApps';
        navView = (0, $lFjPc.PRODUCT_HOME_ID);
    } else if (name === (0, $1NBp8.MARKETPLACE_APP_REQUESTS).name) {
        eventName = 'marketplaceAppRequests';
        navView = (0, $lFjPc.ADMIN_HOME_ID);
    } else if ((0, $1NBp8.MARKETPLACE_MANAGE_PROMOTIONS).name) {
        eventName = 'marketplacePromotions';
        navView = (0, $lFjPc.ADMIN_HOME_ID);
    }
    return {
        Screen: {
            screenEvent: {
                name: eventName,
                id: eventName
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};












const $3dce15286068fd34$export$f2df3d24f362ca75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "QJy0w",
    name: "ForgeSpacePageExtensionPoint",
    loader: async ()=>(await (parcelRequire("628tr"))).SpacePage
});


parcelRequire("crTA1");


const $e20a45805838a7c5$export$16cbc228d727cb5e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dce15286068fd34$export$f2df3d24f362ca75), {
        key: appId + envId + forgeManifestRoute,
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    }));
};
$e20a45805838a7c5$export$16cbc228d727cb5e.NAVIGATION_PARAMS = ({ name: name, params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });


/* eslint react/prop-types:0 */ 









const $70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zXYF3",
    name: "SpaceSettingsForgeAppsRouteComponent",
    loader: ()=>(parcelRequire("kjKSX"))
});
const $70d1956925899c9e$export$21a09e0ddc77eafe = ({ params: { appId: appId, forgeManifestRoute: forgeManifestRoute, envId: envId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent, {
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$70d1956925899c9e$export$21a09e0ddc77eafe.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, appId: appId, envId: envId } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId
                }
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZLKey",
    name: "SpaceSettingsArchiveSpaceRouteComponent",
    loader: ()=>(parcelRequire("hTO1G"))
});
const $3d2592d831aaf97c$export$c5e406a0947cdc56 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent, {
        spaceKey: spaceKey
    });
$3d2592d831aaf97c$export$c5e406a0947cdc56.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsArchiveSpace',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $c1c9698c93be07c8$var$SpaceSettingsEditorConversionRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "640l2",
    name: "SpaceSettingsEditorConversionRouteComponent",
    loader: ()=>(parcelRequire("WJkgK"))
});
const $c1c9698c93be07c8$export$698dfc3fe326e6d2 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c1c9698c93be07c8$var$SpaceSettingsEditorConversionRouteComponent, {
        spaceKey: spaceKey
    });
$c1c9698c93be07c8$export$698dfc3fe326e6d2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditorConversion',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "dJgx9",
    name: "SpaceSettingsContentStateRouteComponent",
    loader: ()=>(parcelRequire("gObvh"))
});
const $ada82682e35c0989$export$9cf7aa4fa48eb220 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent, {
        spaceKey: spaceKey
    });
$ada82682e35c0989$export$9cf7aa4fa48eb220.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsContentState',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "z-Bup",
    name: "SpaceSettingsRelatedPagesRouteComponent",
    loader: async ()=>(await (parcelRequire("afKSR"))).SpaceSettingsRelatedPagesRouteComponent
});
const $5fd2607ebf0fb934$export$50efde5a87cc8957 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent, {
        spaceKey: spaceKey
    });
$5fd2607ebf0fb934$export$50efde5a87cc8957.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsRelatedPages',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iFso2",
    name: "SpaceSettingsEditFeaturesRouteComponent",
    loader: async ()=>(await (parcelRequire("kSHES"))).SpaceSettingsEditFeaturesRouteComponent
});
const $c991c60ce35a3f45$export$769dfef0447f3a55 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent, {
        spaceKey: spaceKey
    });
$c991c60ce35a3f45$export$769dfef0447f3a55.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditFeatures',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });






var $feuG2 = parcelRequire("feuG2");




parcelRequire("crTA1");


const $ae6364090fd3faa0$export$45c01163cd56b3a2 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feuG2.LazySpaceDetailsPage), {
        spaceKey: spaceKey
    }));
};
$ae6364090fd3faa0$export$45c01163cd56b3a2.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: (0, $feuG2.SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID)
        }
    });









const $bd0ed31e3ea4d2cc$export$6e087ccb94d5f2ed = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9oKK",
    name: "AgentContextPageLoader",
    loader: async ()=>(await (parcelRequire("j5opD"))).AgentContextPage
});









var $wtSEP = parcelRequire("wtSEP");


var $bQm3c = parcelRequire("bQm3c");

parcelRequire("crTA1");


const $d79bba560e75ebc3$export$5cb7b3311cd85f89 = ({ params: { spaceKey: spaceKey } })=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    if (!isAdminHubAIEnabled || !isAIEarlyAccessEnabled || !(0, $6mKj3.expValEquals)('cc_space_agents_md_context', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd0ed31e3ea4d2cc$export$6e087ccb94d5f2ed), {
        spaceKey: spaceKey
    }));
};
$d79bba560e75ebc3$export$5cb7b3311cd85f89.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'agenticSpaceInstructions'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID)
        }
    });












const $ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EJBqs",
    name: "SpaceLookAndFeelSettingsRouteComponent",
    loader: async ()=>(parcelRequire("l1Dg4"))
});
const $ea3042d7dfb4b938$export$9ebf5b01b0356442 = ({ params: { spaceKey: spaceKey, tab: tab } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$ea3042d7dfb4b938$export$9ebf5b01b0356442.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingLookAndFeelPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












var $8dwdz = parcelRequire("8dwdz");

parcelRequire("crTA1");



const $6079beeead36a4aa$var$ArchivedPagesListContainer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mIHzp",
    name: "ArchivedPagesListContainer",
    loader: async ()=>(await (parcelRequire("bxUCq"))).ArchivedPagesListContainer
});
const $6079beeead36a4aa$export$77792abc2bfae7a1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6079beeead36a4aa$var$ArchivedPagesListContainer, {
        spaceKey: spaceKey
    }));
};
$6079beeead36a4aa$export$77792abc2bfae7a1.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    return {
        Screen: {
            screenEvent: {
                name: 'spaceArchivedPages',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            enableNavigation: !isMobile
        }
    };
};














/* SpaceContributors.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $aXWIB = parcelRequire("aXWIB");


var $cO1el = parcelRequire("cO1el");


var $gdv5Z = parcelRequire("gdv5Z");


var $eyWa4 = parcelRequire("eyWa4");

/* SpaceContributorsList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");








var $abC4X = parcelRequire("abC4X");








var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");


var $3IBnw = parcelRequire("3IBnw");


var $b3j2Y = parcelRequire("b3j2Y");


var $eCryJ = parcelRequire("eCryJ");

/* ContributorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $esRft = parcelRequire("esRft");


var $gj7hi = parcelRequire("gj7hi");





var $kPml2 = parcelRequire("kPml2");





var $u9agA = parcelRequire("u9agA");





var $a6t12 = parcelRequire("a6t12");

var $ee95a156d3a184b5$exports = {};
$ee95a156d3a184b5$exports = new URL("abstract_blue.ba013008.png", import.meta.url).toString();


var $3dac5e1f5ad138b3$exports = {};
$3dac5e1f5ad138b3$exports = new URL("abstract_gray.49aefa84.png", import.meta.url).toString();


var $7cf450b526cd2111$exports = {};
$7cf450b526cd2111$exports = new URL("abstract_lime.614f08cd.png", import.meta.url).toString();


var $95a3e867a2556232$exports = {};
$95a3e867a2556232$exports = new URL("abstract_orange.75bb3294.png", import.meta.url).toString();


var $86c1619f764c5a6b$exports = {};
$86c1619f764c5a6b$exports = new URL("abstract_purple.32c2eaba.png", import.meta.url).toString();


var $c5d9993c43646aa5$exports = {};
$c5d9993c43646aa5$exports = new URL("abstract_2_blue.92cdf214.png", import.meta.url).toString();


var $7452246e02604ce9$exports = {};
$7452246e02604ce9$exports = new URL("abstract_2_gray.a253343b.png", import.meta.url).toString();


var $1cb9f8119bc0f288$exports = {};
$1cb9f8119bc0f288$exports = new URL("abstract_2_lime.3f0a3533.png", import.meta.url).toString();


var $f04de2c3074bf320$exports = {};
$f04de2c3074bf320$exports = new URL("abstract_2_orange.ba5b7dd0.png", import.meta.url).toString();


var $3801daceeec90851$exports = {};
$3801daceeec90851$exports = new URL("abstract_2_purple.dd28c3fc.png", import.meta.url).toString();


var $6c6a9ad4138425a1$exports = {};
$6c6a9ad4138425a1$exports = new URL("cloud_blue.aed012f6.png", import.meta.url).toString();


var $704c4914e8483682$exports = {};
$704c4914e8483682$exports = new URL("cloud_gray.a167c078.png", import.meta.url).toString();


var $d17b2b68fa2305dd$exports = {};
$d17b2b68fa2305dd$exports = new URL("cloud_lime.d827708d.png", import.meta.url).toString();


var $6c4a174976cdef93$exports = {};
$6c4a174976cdef93$exports = new URL("cloud_orange.0a9d30da.png", import.meta.url).toString();


var $d8ac21f1b6fb4edc$exports = {};
$d8ac21f1b6fb4edc$exports = new URL("cloud_purple.db3e6e0e.png", import.meta.url).toString();


var $c0293fea42355148$exports = {};
$c0293fea42355148$exports = new URL("default_blue.a7d8e57a.png", import.meta.url).toString();


var $f5f8e4d009ee9604$exports = {};
$f5f8e4d009ee9604$exports = new URL("default_gray.62ae8414.png", import.meta.url).toString();


var $b49ab0898ec073d2$exports = {};
$b49ab0898ec073d2$exports = new URL("default_lime.68e476a8.png", import.meta.url).toString();


var $a1035355cb501289$exports = {};
$a1035355cb501289$exports = new URL("default_orange.bbf67771.png", import.meta.url).toString();


var $6ff8250900168938$exports = {};
$6ff8250900168938$exports = new URL("default_purple.863e0469.png", import.meta.url).toString();


var $0d30cbed3c710d19$exports = {};
$0d30cbed3c710d19$exports = new URL("default_2_blue.9968944b.png", import.meta.url).toString();


var $fb813ee36ad26dcf$exports = {};
$fb813ee36ad26dcf$exports = new URL("default_2_gray.3bed0158.png", import.meta.url).toString();


var $3acbb5aa8217a1a0$exports = {};
$3acbb5aa8217a1a0$exports = new URL("default_2_lime.1b02187b.png", import.meta.url).toString();


var $1d5654ffaba9c0e8$exports = {};
$1d5654ffaba9c0e8$exports = new URL("default_2_orange.9138d10b.png", import.meta.url).toString();


var $5a465059480d0c0c$exports = {};
$5a465059480d0c0c$exports = new URL("default_2_purple.51ed90f3.png", import.meta.url).toString();


var $830fcd21aafa0bc0$exports = {};
$830fcd21aafa0bc0$exports = new URL("dev_blue.c51e69f0.png", import.meta.url).toString();


var $13ef99582cc1ae75$exports = {};
$13ef99582cc1ae75$exports = new URL("dev_gray.9f2b2ad6.png", import.meta.url).toString();


var $d3e7d6f83443a9af$exports = {};
$d3e7d6f83443a9af$exports = new URL("dev_lime.62d11101.png", import.meta.url).toString();


var $b443796956609f61$exports = {};
$b443796956609f61$exports = new URL("dev_orange.aaa9d6d8.png", import.meta.url).toString();


var $36ff9338f2995490$exports = {};
$36ff9338f2995490$exports = new URL("dev_purple.31b25562.png", import.meta.url).toString();


var $ccf4e277df8f5d29$exports = {};
$ccf4e277df8f5d29$exports = new URL("launch_blue.a76d899d.png", import.meta.url).toString();


var $0c227f099438f14d$exports = {};
$0c227f099438f14d$exports = new URL("launch_gray.1c67bf3d.png", import.meta.url).toString();


var $2cb93dddabb6f410$exports = {};
$2cb93dddabb6f410$exports = new URL("launch_lime.d253b1e6.png", import.meta.url).toString();


var $9cade7673212b661$exports = {};
$9cade7673212b661$exports = new URL("launch_orange.4675ff98.png", import.meta.url).toString();


var $f6d89891a2d2e4ab$exports = {};
$f6d89891a2d2e4ab$exports = new URL("launch_purple.a73bfdf5.png", import.meta.url).toString();


var $26ca066d51dd627f$exports = {};
$26ca066d51dd627f$exports = new URL("meetings_blue.77ac6747.png", import.meta.url).toString();


var $4d8ff17dd8e33c99$exports = {};
$4d8ff17dd8e33c99$exports = new URL("meetings_gray.68e6f7ea.png", import.meta.url).toString();


var $1923cd941ca90b29$exports = {};
$1923cd941ca90b29$exports = new URL("meetings_lime.7adbc297.png", import.meta.url).toString();


var $d36f333734651c77$exports = {};
$d36f333734651c77$exports = new URL("meetings_orange.cd5e170c.png", import.meta.url).toString();


var $a6ce3b0a0394c69b$exports = {};
$a6ce3b0a0394c69b$exports = new URL("meetings_purple.605f1d57.png", import.meta.url).toString();


const $74e1981ac7fa4f8b$var$HEADER_IMAGES = [
    (0, (/*@__PURE__*/$parcel$interopDefault($ee95a156d3a184b5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($86c1619f764c5a6b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7cf450b526cd2111$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($95a3e867a2556232$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3dac5e1f5ad138b3$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c5d9993c43646aa5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3801daceeec90851$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1cb9f8119bc0f288$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f04de2c3074bf320$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7452246e02604ce9$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6c6a9ad4138425a1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d8ac21f1b6fb4edc$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d17b2b68fa2305dd$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6c4a174976cdef93$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($704c4914e8483682$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c0293fea42355148$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6ff8250900168938$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b49ab0898ec073d2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a1035355cb501289$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f5f8e4d009ee9604$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0d30cbed3c710d19$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5a465059480d0c0c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3acbb5aa8217a1a0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1d5654ffaba9c0e8$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fb813ee36ad26dcf$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($830fcd21aafa0bc0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($36ff9338f2995490$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d3e7d6f83443a9af$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b443796956609f61$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($13ef99582cc1ae75$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ccf4e277df8f5d29$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f6d89891a2d2e4ab$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2cb93dddabb6f410$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9cade7673212b661$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0c227f099438f14d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($26ca066d51dd627f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a6ce3b0a0394c69b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1923cd941ca90b29$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d36f333734651c77$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4d8ff17dd8e33c99$exports)))
];
/**
 * Simple hash function that converts a string to a numeric hash.
 * Uses a multiplicative hash for good distribution.
 */ const $74e1981ac7fa4f8b$var$hashString = (str)=>{
    let hash = 5381;
    for(let i = 0; i < str.length; i++)hash = Math.abs((hash * 33 + str.charCodeAt(i)) % 2147483647);
    return hash;
};
const $74e1981ac7fa4f8b$export$f4539ec1c290b2c9 = (accountId)=>{
    const index = $74e1981ac7fa4f8b$var$hashString(accountId) % $74e1981ac7fa4f8b$var$HEADER_IMAGES.length;
    return $74e1981ac7fa4f8b$var$HEADER_IMAGES[index];
};


const $4005975cfd549f33$var$i18n = (0, $aXWIB.defineMessages)({
    deactivated: {
        id: "space-contributors.card.deactivated",
        defaultMessage: "({label})"
    },
    deactivatedLabel: {
        id: "space-contributors.card.deactivated.label",
        defaultMessage: "Deactivated"
    },
    roleAdmin: {
        id: "space-contributors.card.role.space-admin",
        defaultMessage: "Space Admin"
    },
    roleOwner: {
        id: "space-contributors.card.role.space-owner",
        defaultMessage: "Space Owner"
    },
    roleAuthor: {
        id: "space-contributors.card.role.author",
        defaultMessage: "Author"
    },
    roleReviewer: {
        id: "space-contributors.card.role.content-reviewer",
        defaultMessage: "Content Reviewer"
    }
});
const $4005975cfd549f33$var$roleLabels = {
    admin: $4005975cfd549f33$var$i18n.roleAdmin,
    owner: $4005975cfd549f33$var$i18n.roleOwner,
    author: $4005975cfd549f33$var$i18n.roleAuthor,
    reviewer: $4005975cfd549f33$var$i18n.roleReviewer
}; // Separator between role labels.
const $4005975cfd549f33$var$ROLE_SEPARATOR = " \xb7 ";
const $4005975cfd549f33$var$styles = {
    card: "_2rkopb1k _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _2lx21bp4 _4t3i1osq _bfhkvuon _1cwg1i6y _80omtlke",
    cardSelected: "_2rkopb1k _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _2lx21bp4 _4t3i1osq _bfhkvuon _12y31dm9 _1qu2nqa1 _12jiq98m _1cwg1i6y _80omtlke",
    cardDeactivated: "_2rkopb1k _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _2lx21bp4 _4t3i1osq _bfhki8nm _1cwg1i6y _80omtlke",
    headerImageContainer: "_1reo15vq _18m915vq _4t3i1ady _1bsb1osq _13lipb1k _qrwqpb1k",
    content: "_zulpu2gc _18zrpxbi _1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1y6m _85i5pxbi _1pfhc7mi",
    details: "_zulp1b66 _1e0c1txw _2lx21bp4",
    locationPill: "_2rko1qi0 _189ee4h9 _1dqonqa1 _1h6d1l7x _18zr12x7 _1e0c1txw _4cvr1h6o _4t3i1tcg _bfhki8nm _1pfh1wug"
};
const $4005975cfd549f33$export$3f45fa6d1e6fb5fe = ({ contributor: contributor })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [isSelected, setIsSelected] = (0, $42omo.useState)(false);
    const handleVisibilityChange = (0, $42omo.useCallback)((isVisible)=>{
        setIsSelected(isVisible);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: contributor.accountId,
        trigger: "click",
        position: "right-start",
        onVisibilityChange: handleVisibilityChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default // eslint-disable-next-line no-nested-ternary -- simple 3-way style selection
    ), {
        xcss: contributor.isDeactivated ? $4005975cfd549f33$var$styles.cardDeactivated : isSelected ? $4005975cfd549f33$var$styles.cardSelected : $4005975cfd549f33$var$styles.card,
        testId: `contributor-card-${contributor.accountId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4005975cfd549f33$var$styles.headerImageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, $74e1981ac7fa4f8b$export$f4539ec1c290b2c9)(contributor.accountId),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4005975cfd549f33$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        name: contributor.displayName,
        src: contributor.avatarUrl,
        size: "large",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small"
    }, contributor.displayName), contributor.isDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        size: "small"
    }, intl.formatMessage($4005975cfd549f33$var$i18n.deactivated, {
        label: intl.formatMessage($4005975cfd549f33$var$i18n.deactivatedLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4005975cfd549f33$var$styles.details
    }, contributor.jobTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        size: "small",
        weight: "bold"
    }, contributor.jobTitle), contributor.roles.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        size: "small"
    }, contributor.roles.map((role)=>intl.formatMessage($4005975cfd549f33$var$roleLabels[role])).join($4005975cfd549f33$var$ROLE_SEPARATOR))), contributor.location && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4005975cfd549f33$var$styles.locationPill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kPml2))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        size: "small"
    }, contributor.location))))));
};






var $eSUdr = parcelRequire("eSUdr");


var $c0rhi = parcelRequire("c0rhi");





var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $aBfpe = parcelRequire("aBfpe");


var $dK51B = parcelRequire("dK51B");





var $7QM6o = parcelRequire("7QM6o");

// Max role labels shown per contributor.
const $8fbc34173e9b34f3$var$MAX_ROLES = 2;
// AGG batch user query for resolving display names and avatars
const $8fbc34173e9b34f3$var$FetchUsersBatchQuery = (0, $eSUdr.default)`query useSpaceContributorsFetchUsersBatchQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture accountStatus}}`;
const $8fbc34173e9b34f3$var$AGG_USERS_BATCH_LIMIT = 90;
const $8fbc34173e9b34f3$var$normalizeLocation = (location)=>{
    if (!location) return undefined;
    return location.replace(/^Home office:\s*/i, '').trim() || undefined;
};
const $8fbc34173e9b34f3$var$MIN_CREATED_THRESHOLD = 5;
const $8fbc34173e9b34f3$var$MIN_UPDATED_THRESHOLD = 10;
const $8fbc34173e9b34f3$var$MIN_COMMENT_THRESHOLD = 10;
const $8fbc34173e9b34f3$var$hasSignificantActivity = (entry)=>(entry.created ?? 0) >= $8fbc34173e9b34f3$var$MIN_CREATED_THRESHOLD || (entry.updated ?? 0) >= $8fbc34173e9b34f3$var$MIN_UPDATED_THRESHOLD || (entry.commentCreated ?? 0) >= $8fbc34173e9b34f3$var$MIN_COMMENT_THRESHOLD;
const $8fbc34173e9b34f3$export$18cd2142783a34b5 = (entry, spaceRoles)=>{
    const roles = [];
    if ((entry.created ?? 0) >= $8fbc34173e9b34f3$var$MIN_CREATED_THRESHOLD) roles.push('author');
    if ((entry.updated ?? 0) >= $8fbc34173e9b34f3$var$MIN_UPDATED_THRESHOLD || (entry.commentCreated ?? 0) >= $8fbc34173e9b34f3$var$MIN_COMMENT_THRESHOLD) roles.push('reviewer');
    // Owner takes precedence over admin, and both lead the list when present.
    if (spaceRoles.ownerId === entry.accountId) roles.unshift('owner');
    else if (spaceRoles.adminIds.has(entry.accountId) && roles.length > 0) // Only surface the admin role when the user also has at least one other role.
    roles.unshift('admin');
    return roles.slice(0, $8fbc34173e9b34f3$var$MAX_ROLES);
};
const $8fbc34173e9b34f3$var$compareContributors = (a, b)=>{
    // Pages created is the primary sort (more superior)
    const createdDiff = (b.created ?? 0) - (a.created ?? 0);
    if (createdDiff !== 0) return createdDiff;
    // Edits (updated) as secondary sort
    const updatedDiff = (b.updated ?? 0) - (a.updated ?? 0);
    if (updatedDiff !== 0) return updatedDiff;
    // Comments as tertiary sort
    return (b.commentCreated ?? 0) - (a.commentCreated ?? 0);
};
const $8fbc34173e9b34f3$var$fetchUserProfiles = async (accountIds, signal)=>{
    const profileMap = new Map();
    if (accountIds.length === 0 || signal.aborted) return profileMap;
    const batches = [];
    for(let i = 0; i < accountIds.length; i += $8fbc34173e9b34f3$var$AGG_USERS_BATCH_LIMIT)batches.push(accountIds.slice(i, i + $8fbc34173e9b34f3$var$AGG_USERS_BATCH_LIMIT));
    const processBatch = async (batch)=>{
        if (signal.aborted) return;
        try {
            const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
                query: $8fbc34173e9b34f3$var$FetchUsersBatchQuery,
                variables: {
                    accountIds: batch
                },
                interopApolloAggClient: true,
                __callerPackage__: "@confluence/space-contributors"
            });
            if (error?.graphQLErrors) error.graphQLErrors.forEach((0, $7Sm4c.markErrorAsHandled));
            const users = data?.users ?? [];
            for (const user of users)if (user !== null) profileMap.set(user.accountId, {
                displayName: user.name ?? user.accountId,
                avatarUrl: user.picture ?? undefined,
                jobTitle: undefined,
                location: undefined,
                isDeactivated: user.accountStatus !== 'active'
            });
        } catch  {
        // Silently handle batch failures
        }
    };
    await Promise.all(batches.map(processBatch));
    return profileMap;
};
const $8fbc34173e9b34f3$var$buildAliasedUserQuery = (accountIds)=>{
    const fields = accountIds.map((id, index)=>`user_${index}: confluence_atlassianUser(id: "${id}") { title location }`).join('\n');
    return `query useSpaceContributorsProfileDetailsQuery { ${fields} }`;
};
const $8fbc34173e9b34f3$var$ALIASED_BATCH_LIMIT = 25;
const $8fbc34173e9b34f3$var$fetchUserProfileDetails = async (accountIds, signal)=>{
    const detailsMap = new Map();
    if (accountIds.length === 0 || signal.aborted) return detailsMap;
    const batches = [];
    for(let i = 0; i < accountIds.length; i += $8fbc34173e9b34f3$var$ALIASED_BATCH_LIMIT)batches.push(accountIds.slice(i, i + $8fbc34173e9b34f3$var$ALIASED_BATCH_LIMIT));
    const processBatch = async (batch)=>{
        if (signal.aborted) return;
        try {
            const queryString = $8fbc34173e9b34f3$var$buildAliasedUserQuery(batch);
            const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
                query: (0, $eSUdr.default)(queryString),
                variables: {},
                interopApolloAggClient: true,
                __callerPackage__: "@confluence/space-contributors"
            });
            if (error?.graphQLErrors) error.graphQLErrors.forEach((0, $7Sm4c.markErrorAsHandled));
            if (data) batch.forEach((accountId, index)=>{
                const user = data[`user_${index}`];
                if (user) detailsMap.set(accountId, {
                    title: user.title,
                    location: user.location
                });
            });
        } catch  {
        // Silently handle batch failures
        }
    };
    await Promise.all(batches.map(processBatch));
    return detailsMap;
};
const $8fbc34173e9b34f3$var$FetchSpaceRolesQuery = (0, $eSUdr.default)`query useSpaceContributorsSpaceRolesQuery($spaceId:ID!$first:Int){space(id:$spaceId){id spaceOwner{ownerId ownerType}spaceAdmins(first:$first excludeAddOns:true){nodes{__typename ...on KnownUser{accountId}}}}}`;
const $8fbc34173e9b34f3$var$SPACE_ADMINS_LIMIT = 50;
const $8fbc34173e9b34f3$var$fetchSpaceRoles = async (spaceId, signal)=>{
    const adminIds = new Set();
    let ownerId;
    if (!spaceId || signal.aborted) return {
        adminIds: adminIds,
        ownerId: ownerId
    };
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: $8fbc34173e9b34f3$var$FetchSpaceRolesQuery,
            variables: {
                spaceId: spaceId,
                first: $8fbc34173e9b34f3$var$SPACE_ADMINS_LIMIT
            },
            interopApolloAggClient: true,
            __callerPackage__: "@confluence/space-contributors"
        });
        if (error?.graphQLErrors) error.graphQLErrors.forEach((0, $7Sm4c.markErrorAsHandled));
        for (const node of data?.space?.spaceAdmins?.nodes ?? [])if (node?.accountId) adminIds.add(node.accountId);
        const owner = data?.space?.spaceOwner;
        if (owner?.ownerType === 'USER' && owner.ownerId) ownerId = owner.ownerId;
    } catch (error) {
        // Roles are additive; report the failure but still render contributors.
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).DISCO
        });
    }
    return {
        adminIds: adminIds,
        ownerId: ownerId
    };
};
const $8fbc34173e9b34f3$var$TODAY = new Date();
const $8fbc34173e9b34f3$var$SIX_MONTHS_AGO = new Date($8fbc34173e9b34f3$var$TODAY);
$8fbc34173e9b34f3$var$SIX_MONTHS_AGO.setMonth($8fbc34173e9b34f3$var$TODAY.getMonth() - 6);
const $8fbc34173e9b34f3$var$FROM_DATE = $8fbc34173e9b34f3$var$SIX_MONTHS_AGO.toISOString().split('T')[0];
const $8fbc34173e9b34f3$var$TO_DATE = $8fbc34173e9b34f3$var$TODAY.toISOString().split('T')[0];
const $8fbc34173e9b34f3$var$TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
const $8fbc34173e9b34f3$var$EMPTY_VARIABLES = {};
const $8fbc34173e9b34f3$var$parseActivityResult = (json)=>({
        experimentalAnalyticsActivityByUser: json
    });
const $8fbc34173e9b34f3$export$57e3e2823ad3ffc8 = (spaceKey)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    const [contributors, setContributors] = (0, $42omo.useState)([]);
    const [profilesLoading, setProfilesLoading] = (0, $42omo.useState)(true);
    const [profilesError, setProfilesError] = (0, $42omo.useState)(null);
    const abortControllerRef = (0, $42omo.useRef)(null);
    const url = (0, $42omo.useMemo)(()=>{
        if (!cloudId || !spaceId) return '';
        const params = new URLSearchParams({
            fromDate: $8fbc34173e9b34f3$var$FROM_DATE,
            toDate: $8fbc34173e9b34f3$var$TO_DATE,
            timezone: $8fbc34173e9b34f3$var$TIMEZONE,
            content: 'page,livedoc',
            spaceId: spaceId,
            sortBy: 'created',
            sortOrder: 'desc',
            limit: '50'
        });
        return `/gateway/api/ex/confluence/${cloudId}/analytics/v2/activityByUser?${params.toString()}`;
    }, [
        cloudId,
        spaceId
    ]);
    const { data: data, loading: activityLoading, error: error } = (0, $dK51B.useExperimentalQuery)({
        url: url,
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: $8fbc34173e9b34f3$var$parseActivityResult,
        skip: !cloudId || !spaceId,
        variables: $8fbc34173e9b34f3$var$EMPTY_VARIABLES
    });
    const activeEntries = (0, $42omo.useMemo)(()=>(data?.experimentalAnalyticsActivityByUser?.activityByUser ?? []).filter($8fbc34173e9b34f3$var$hasSignificantActivity).sort($8fbc34173e9b34f3$var$compareContributors), [
        data
    ]);
    const resolveProfiles = (0, $42omo.useCallback)(async (entries, resolvedSpaceId)=>{
        // Cancel any in-flight profile fetch
        abortControllerRef.current?.abort();
        const controller = new AbortController();
        abortControllerRef.current = controller;
        setProfilesLoading(true);
        setProfilesError(null);
        try {
            // Roles and the activity-entry profiles have no interdependency, so
            // fetch them concurrently rather than waterfalling.
            const entryIds = entries.map((entry)=>entry.accountId);
            const [spaceRoles, profileMap, detailsMap] = await Promise.all([
                $8fbc34173e9b34f3$var$fetchSpaceRoles(resolvedSpaceId, controller.signal),
                $8fbc34173e9b34f3$var$fetchUserProfiles(entryIds, controller.signal),
                $8fbc34173e9b34f3$var$fetchUserProfileDetails(entryIds, controller.signal)
            ]);
            // Account ids with a space-level role.
            const roleIds = new Set(spaceRoles.adminIds);
            if (spaceRoles.ownerId) roleIds.add(spaceRoles.ownerId);
            // Owners/admins not already among the activity entries still need
            // their profiles resolved.
            const fetchedIds = new Set(entryIds);
            const extraIds = Array.from(roleIds).filter((id)=>!fetchedIds.has(id));
            if (extraIds.length > 0 && !controller.signal.aborted) {
                const [extraProfiles, extraDetails] = await Promise.all([
                    $8fbc34173e9b34f3$var$fetchUserProfiles(extraIds, controller.signal),
                    $8fbc34173e9b34f3$var$fetchUserProfileDetails(extraIds, controller.signal)
                ]);
                extraProfiles.forEach((profile, id)=>profileMap.set(id, profile));
                extraDetails.forEach((detail, id)=>detailsMap.set(id, detail));
            }
            // Merge activity entries with owners/admins, deduping by accountId.
            // Owners/admins without activity are added with zero counts.
            const mergedEntries = new Map();
            for (const entry of entries)mergedEntries.set(entry.accountId, entry);
            for (const accountId of roleIds)if (!mergedEntries.has(accountId)) mergedEntries.set(accountId, {
                accountId: accountId,
                created: 0,
                updated: 0,
                commentCreated: 0,
                viewed: 0
            });
            const dedupedEntries = Array.from(mergedEntries.values()).sort($8fbc34173e9b34f3$var$compareContributors);
            if (!controller.signal.aborted) {
                // Single pass over the (already activity-sorted) entries: resolve
                // each profile and drop contributors with no surfaced role. In
                // practice the dropped ones are admins who have not authored or
                // reviewed any content, which should not appear on the list at all.
                const resolved = [];
                for (const entry of dedupedEntries){
                    const roles = $8fbc34173e9b34f3$export$18cd2142783a34b5(entry, spaceRoles);
                    if (roles.length === 0) continue;
                    const profile = profileMap.get(entry.accountId);
                    const details = detailsMap.get(entry.accountId);
                    resolved.push({
                        ...entry,
                        displayName: profile?.displayName ?? entry.accountId,
                        avatarUrl: profile?.avatarUrl,
                        jobTitle: details?.title ?? undefined,
                        location: $8fbc34173e9b34f3$var$normalizeLocation(details?.location),
                        isDeactivated: profile?.isDeactivated ?? false,
                        roles: roles
                    });
                }
                // Sink deactivated users to the bottom while preserving the
                // activity-based order within each group (Array.sort is stable).
                resolved.sort((a, b)=>Number(a.isDeactivated) - Number(b.isDeactivated));
                setContributors(resolved);
            }
        } catch (err) {
            if (!controller.signal.aborted) setProfilesError(err instanceof Error ? err : new Error('Failed to load contributor profiles'));
        } finally{
            setProfilesLoading(false);
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (activityLoading) return;
        if (spaceId) resolveProfiles(activeEntries, spaceId);
        else {
            setContributors([]);
            setProfilesLoading(false);
        }
        return ()=>{
            abortControllerRef.current?.abort();
        };
    }, [
        activeEntries,
        resolveProfiles,
        activityLoading,
        spaceId
    ]);
    return {
        contributors: contributors,
        loading: activityLoading || profilesLoading,
        error: error ?? profilesError
    };
};


const $ca40d910a8d2b8d4$var$i18n = (0, $aXWIB.defineMessages)({
    empty: {
        id: "space-contributors.list.empty",
        defaultMessage: "No contributors found for this space."
    },
    loading: {
        id: "space-contributors.list.loading",
        defaultMessage: "Loading contributors\u2026"
    },
    errorHeading: {
        id: "space-contributors.list.error.heading",
        defaultMessage: "We couldn't load contributors"
    },
    errorDescription: {
        id: "space-contributors.list.error.description",
        defaultMessage: "Something went wrong while loading the contributors for this space. Try refreshing the page."
    }
});
const $ca40d910a8d2b8d4$var$styles = {
    container: "",
    loadingContainer: "_1rjcxy5q _1e0c1txw _1bah1h6o"
};
const $ca40d910a8d2b8d4$var$gridStyles = null;
const $ca40d910a8d2b8d4$var$SpaceContributorsListComponent = ({ spaceKey: spaceKey })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { contributors: contributors, loading: loading, error: error } = (0, $8fbc34173e9b34f3$export$57e3e2823ad3ffc8)(spaceKey);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ca40d910a8d2b8d4$var$styles.loadingContainer,
        testId: "space-contributors-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium",
        label: intl.formatMessage($ca40d910a8d2b8d4$var$i18n.loading)
    }));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
        header: intl.formatMessage($ca40d910a8d2b8d4$var$i18n.errorHeading),
        description: intl.formatMessage($ca40d910a8d2b8d4$var$i18n.errorDescription),
        testId: "space-contributors-error"
    }));
    if (contributors.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ca40d910a8d2b8d4$var$styles.container,
        testId: "space-contributors-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($ca40d910a8d2b8d4$var$i18n.empty)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ca40d910a8d2b8d4$var$styles.container,
        testId: "space-contributors-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "space-contributors-grid",
        className: (0, $gMc0m.default)([
            "_zulppxbi _1e0c11p5 _yv0efsjm _170416hb"
        ])
    }, contributors.map((contributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4005975cfd549f33$export$3f45fa6d1e6fb5fe), {
            key: contributor.accountId,
            contributor: contributor
        })))));
};
const $ca40d910a8d2b8d4$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ca40d910a8d2b8d4$var$i18n.errorHeading);
const $ca40d910a8d2b8d4$export$5f10e7078a8df25b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $ca40d910a8d2b8d4$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ca40d910a8d2b8d4$var$SpaceContributorsListComponent, props));


const $262ca66c88e39807$var$i18n = (0, $aXWIB.defineMessages)({
    pageTitle: {
        id: "space-contributors.page.title",
        defaultMessage: "Contributors"
    }
});
const $262ca66c88e39807$var$styles = {
    page: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1rjcxy5q _18zrxy5q _p12f1fra _7cca15wb"
};
const $262ca66c88e39807$export$e06119d84e0ded1e = ({ spaceKey: spaceKey })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $262ca66c88e39807$var$styles.page,
        testId: "space-contributors-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large"
    }, intl.formatMessage($262ca66c88e39807$var$i18n.pageTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ca40d910a8d2b8d4$export$5f10e7078a8df25b), {
        spaceKey: spaceKey
    })));
};


parcelRequire("crTA1");


const $4a57d37907c9234e$export$68e37a802707fb55 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_space_contributors', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $262ca66c88e39807$export$e06119d84e0ded1e), {
        spaceKey: spaceKey
    }));
};
$4a57d37907c9234e$export$68e37a802707fb55.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_space_contributors', 'isEnabled', false)) return false;
    return {
        Screen: {
            screenEvent: {
                name: 'spaceContributorsScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    };
};














/* SpaceSuggestions.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");





var $hmuev = parcelRequire("hmuev");


var $fIcbd = parcelRequire("fIcbd");


var $lOHzS = parcelRequire("lOHzS");





var $dcJ7R = parcelRequire("dcJ7R");





var $6F6hl = parcelRequire("6F6hl");


var $kcIQr = parcelRequire("kcIQr");


var $7aRa9 = parcelRequire("7aRa9");


var $aWwYt = parcelRequire("aWwYt");


var $1xpoY = parcelRequire("1xpoY");


var $1YXTQ = parcelRequire("1YXTQ");











var $f7B1p = parcelRequire("f7B1p");

const $498957231e78a7c6$var$buildSpaceSuggestionsUrl = (spaceKey)=>`/wiki/rest/internal/1.0/spaces/${spaceKey}/organization/suggestions`;
const $498957231e78a7c6$var$ContentTitlesQuery = (0, $eSUdr.default)`query useFetchSpaceSuggestionsContentTitlesQuery($ids:[ID!]!){pageContent:content(ids:$ids type:"page"){nodes{id title}}folderContent:content(ids:$ids type:"folder"){nodes{id title}}whiteboardContent:content(ids:$ids type:"whiteboard"){nodes{id title}}databaseContent:content(ids:$ids type:"database"){nodes{id title}}embedContent:content(ids:$ids type:"embed"){nodes{id title}}blogpostContent:content(ids:$ids type:"blogpost"){nodes{id title}}slideContent:content(ids:$ids type:"slide"){nodes{id title}}}`;
/**
 * Extracts the content ID referenced by a single action, or `undefined` if
 * the action type does not reference content.
 */ function $498957231e78a7c6$var$getContentIdFromAction(action) {
    switch(action.actionType){
        case 'MOVE':
        case 'RENAME':
            return action.parameters.contentId;
        case 'CREATE_FOLDER':
            return action.parameters.parentContentId;
        default:
            return undefined;
    }
}
/**
 * Extracts every content ID referenced by the actions in a set of suggestions.
 * Returns a deduplicated array of IDs.
 */ function $498957231e78a7c6$var$collectContentIds(suggestions) {
    const allActions = suggestions.flatMap((s)=>s.actions);
    const ids = new Set();
    for (const action of allActions){
        const id = $498957231e78a7c6$var$getContentIdFromAction(action);
        if (id !== undefined) ids.add(id);
    }
    return Array.from(ids);
}
/**
 * Batch-fetches content titles for the given IDs using Confluence AGG content
 * lookup. Returns a map from content ID to its title.
 *
 * IDs that cannot be resolved (e.g. deleted content, aliases, content types
 * outside the queried set) are silently omitted from the returned map —
 * callers should fall back to the raw ID.
 */ async function $498957231e78a7c6$var$fetchContentNames(contentIds) {
    if (contentIds.length === 0) return {};
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: $498957231e78a7c6$var$ContentTitlesQuery,
            variables: {
                ids: contentIds
            },
            fetchPolicy: 'network-only',
            interopApolloAggClient: true,
            __callerPackage__: "@confluence/space-suggestions"
        });
        if (error) return {};
        const contentTitleNodes = [
            data?.pageContent?.nodes,
            data?.folderContent?.nodes,
            data?.whiteboardContent?.nodes,
            data?.databaseContent?.nodes,
            data?.embedContent?.nodes,
            data?.blogpostContent?.nodes,
            data?.slideContent?.nodes
        ].flatMap((nodes)=>nodes ?? []);
        const names = {};
        for (const node of contentTitleNodes)if (node?.id && node.title) names[node.id] = node.title;
        return names;
    } catch  {
        // Content title resolution is best-effort; fall back to raw IDs on failure.
        return {};
    }
}
/**
 * Builds a map from CREATE_FOLDER alias → folder title within a single
 * suggestion. Used to resolve `destinationAlias` in MOVE actions to a
 * human-readable folder name.
 */ function $498957231e78a7c6$var$buildAliasToTitleMap(actions) {
    const map = {};
    for (const action of actions)if (action.actionType === 'CREATE_FOLDER') map[action.parameters.alias] = action.parameters.title;
    return map;
}
/**
 * Returns a copy of the action with any referenced content ID replaced by
 * its resolved human-readable name from `names`, and any destination alias
 * replaced by the folder title from `aliasToTitle`. Falls back to the raw
 * ID or alias when a name is not available.
 */ function $498957231e78a7c6$var$enrichActionWithNames(action, names, aliasToTitle) {
    switch(action.actionType){
        case 'MOVE':
            return {
                ...action,
                parameters: {
                    ...action.parameters,
                    contentName: names[action.parameters.contentId] ?? action.parameters.contentId,
                    destinationName: aliasToTitle[action.parameters.destinationAlias] ?? action.parameters.destinationAlias
                }
            };
        case 'RENAME':
            return {
                ...action,
                parameters: {
                    ...action.parameters,
                    contentName: names[action.parameters.contentId] ?? action.parameters.contentId
                }
            };
        case 'CREATE_FOLDER':
            return {
                ...action,
                parameters: {
                    ...action.parameters,
                    parentContentName: names[action.parameters.parentContentId] ?? action.parameters.parentContentId
                }
            };
        default:
            return action;
    }
}
/**
 * Enriches raw suggestion actions with resolved content names and alias titles.
 * Falls back to the raw content ID or alias when a name is not available.
 */ function $498957231e78a7c6$var$enrichActionsWithNames(actions, names) {
    const aliasToTitle = $498957231e78a7c6$var$buildAliasToTitleMap(actions);
    return actions.map((action)=>$498957231e78a7c6$var$enrichActionWithNames(action, names, aliasToTitle));
}
function $498957231e78a7c6$var$enrichSuggestionsWithNames(suggestions, names) {
    return suggestions.map((suggestion)=>{
        return {
            ...suggestion,
            actions: $498957231e78a7c6$var$enrichActionsWithNames(suggestion.actions, names)
        };
    });
}
const $498957231e78a7c6$export$389535f4489ece32 = (spaceKey)=>{
    const [suggestions, setSuggestions] = (0, $42omo.useState)([]);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const callEpochRef = (0, $42omo.useRef)(0);
    const refetch = (0, $42omo.useCallback)(async ()=>{
        const epoch = callEpochRef.current + 1;
        callEpochRef.current = epoch;
        setIsLoading(true);
        setError(undefined);
        try {
            const response = await (0, $f7B1p.cfetch)($498957231e78a7c6$var$buildSpaceSuggestionsUrl(spaceKey), {
                method: 'GET'
            });
            if (!response.ok) throw new Error(`Failed to fetch space suggestions: ${response.status} ${response.statusText}`);
            const data = await response.json();
            // Discard the response if a newer call has been issued in the meantime.
            if (callEpochRef.current !== epoch) return;
            const rawSuggestions = data.suggestions ?? [];
            // Resolve content IDs to human-readable titles (best-effort).
            const contentIds = $498957231e78a7c6$var$collectContentIds(rawSuggestions);
            const contentNames = await $498957231e78a7c6$var$fetchContentNames(contentIds);
            // Re-check epoch after the async name resolution.
            if (callEpochRef.current !== epoch) return;
            setSuggestions($498957231e78a7c6$var$enrichSuggestionsWithNames(rawSuggestions, contentNames));
        } catch (err) {
            if (callEpochRef.current !== epoch) return;
            setError(err instanceof Error ? err : new Error(String(err)));
            setSuggestions([]);
        } finally{
            if (callEpochRef.current === epoch) setIsLoading(false);
        }
    }, [
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        refetch();
    }, [
        refetch
    ]);
    return {
        suggestions: suggestions,
        isLoading: isLoading,
        error: error,
        refetch: refetch
    };
};



var $frIzR = parcelRequire("frIzR");




const $3e2deca241a656e1$var$buildDecisionsUrl = (spaceKey, suggestionId)=>`/wiki/rest/internal/1.0/spaces/${spaceKey}/organization/suggestions/${suggestionId}/decisions`;
const $3e2deca241a656e1$export$850e02422c077917 = async (spaceKey, suggestionId, decision)=>{
    const response = await (0, $f7B1p.cfetch)($3e2deca241a656e1$var$buildDecisionsUrl(spaceKey, suggestionId), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(decision)
    });
    if (response.status !== 204) throw new Error(`Failed to record suggestion decision: ${response.status}`);
};
const $3e2deca241a656e1$export$c8ee8ca7852adba0 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] !== spaceKey) {
        t0 = (suggestionId, decision)=>$3e2deca241a656e1$export$850e02422c077917(spaceKey, suggestionId, decision);
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const recordDecision = t0;
    let t1;
    if ($[2] !== recordDecision) {
        t1 = {
            recordDecision: recordDecision
        };
        $[2] = recordDecision;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};











const $d5471619bea93e71$var$initialRunState = {
    isRunning: false,
    error: undefined
};
const $d5471619bea93e71$var$POLL_INTERVAL_MS = 2000;
const $d5471619bea93e71$var$POLL_BACKOFF_AFTER_MS = 30000;
const $d5471619bea93e71$var$POLL_BACKOFF_INTERVAL_MS = 5000;
const $d5471619bea93e71$var$POLL_TIMEOUT_MS = 300000;
const $d5471619bea93e71$var$isActiveRunStatus = (status)=>status === 'QUEUED' || status === 'RUNNING';
const $d5471619bea93e71$var$isSuccessfulRunStatus = (status)=>status === 'SUCCEEDED' || status === 'COMPLETED';
const $d5471619bea93e71$var$runReducer = (state, action)=>{
    switch(action.type){
        case 'started':
            return {
                isRunning: true,
                error: undefined
            };
        case 'succeeded':
            return {
                isRunning: false,
                error: undefined
            };
        case 'failed':
            return {
                ...state,
                isRunning: false,
                error: action.error
            };
        default:
            return state;
    }
};
const $d5471619bea93e71$var$buildSpaceOrganizerRunUrl = (spaceKey)=>`/wiki/rest/internal/1.0/spaces/${spaceKey}/organization/runs`;
const $d5471619bea93e71$var$buildLongTaskUrl = (runId)=>`/wiki/rest/api/longtask/${runId}`;
const $d5471619bea93e71$var$toError = (err)=>err instanceof Error ? err : new Error(String(err));
const $d5471619bea93e71$var$throwIfAborted = (signal)=>{
    if (signal?.aborted) throw new Error('Space Organizer run was cancelled');
};
const $d5471619bea93e71$var$getPollIntervalMs = (elapsedMs, { pollIntervalMs: pollIntervalMs, backoffAfterMs: backoffAfterMs, backoffIntervalMs: backoffIntervalMs })=>{
    if (elapsedMs >= (backoffAfterMs ?? $d5471619bea93e71$var$POLL_BACKOFF_AFTER_MS)) return backoffIntervalMs ?? $d5471619bea93e71$var$POLL_BACKOFF_INTERVAL_MS;
    return pollIntervalMs ?? $d5471619bea93e71$var$POLL_INTERVAL_MS;
};
const $d5471619bea93e71$var$waitForPollInterval = (timeoutMs, signal)=>new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(new Error('Space Organizer run was cancelled'));
            return;
        }
        let timeoutId;
        const onAbort = ()=>{
            clearTimeout(timeoutId);
            reject(new Error('Space Organizer run was cancelled'));
        };
        timeoutId = setTimeout(()=>{
            signal?.removeEventListener('abort', onAbort);
            resolve();
        }, timeoutMs);
        signal?.addEventListener('abort', onAbort, {
            once: true
        });
    });
const $d5471619bea93e71$var$parseJsonResponse = async (response, errorPrefix)=>{
    if (!response.ok) throw new Error(`${errorPrefix}: ${response.status}`);
    return await response.json();
};
const $d5471619bea93e71$var$postSpaceOrganizerRun = async (spaceKey)=>{
    const response = await (0, $f7B1p.cfetch)($d5471619bea93e71$var$buildSpaceOrganizerRunUrl(spaceKey), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    return $d5471619bea93e71$var$parseJsonResponse(response, 'Failed to run Space Organizer');
};
const $d5471619bea93e71$var$getLongTask = async (runId)=>{
    const response = await (0, $f7B1p.cfetch)($d5471619bea93e71$var$buildLongTaskUrl(runId), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json'
        }
    });
    return $d5471619bea93e71$var$parseJsonResponse(response, 'Failed to poll Space Organizer run');
};
const $d5471619bea93e71$export$2d0e2d7096700483 = async (spaceKey, options = {})=>{
    const startedAtMs = Date.now();
    const timeoutMs = options.timeoutMs ?? $d5471619bea93e71$var$POLL_TIMEOUT_MS;
    const result = await $d5471619bea93e71$var$postSpaceOrganizerRun(spaceKey);
    $d5471619bea93e71$var$throwIfAborted(options.signal);
    if (!result.runId) throw new Error('Failed to run Space Organizer: missing runId');
    const runStatus = result.status ?? 'QUEUED';
    const createdSuggestionCount = result.createdSuggestionCount ?? 0;
    if (runStatus === 'FAILED') throw new Error(`Failed to run Space Organizer: ${runStatus}`);
    if ($d5471619bea93e71$var$isSuccessfulRunStatus(runStatus)) return {
        ...result,
        status: runStatus,
        createdSuggestionCount: createdSuggestionCount
    };
    if (!$d5471619bea93e71$var$isActiveRunStatus(runStatus)) throw new Error(`Failed to run Space Organizer: ${runStatus}`);
    while(true){
        const elapsedMs = Date.now() - startedAtMs;
        if (elapsedMs >= timeoutMs) throw new Error('Space Organizer run is still taking longer than expected');
        await $d5471619bea93e71$var$waitForPollInterval(Math.min($d5471619bea93e71$var$getPollIntervalMs(elapsedMs, options), timeoutMs - elapsedMs), options.signal);
        const task = await $d5471619bea93e71$var$getLongTask(result.runId);
        $d5471619bea93e71$var$throwIfAborted(options.signal);
        if (!task.finished) continue;
        if (task.successful) return {
            ...result,
            status: 'SUCCEEDED',
            createdSuggestionCount: createdSuggestionCount
        };
        throw new Error('Failed to run Space Organizer: long task failed');
    }
};
const $d5471619bea93e71$export$8bbb7994e59d093c = (spaceKey)=>{
    const $ = (0, $frIzR.c)(8);
    const [state, dispatch] = (0, $42omo.useReducer)($d5471619bea93e71$var$runReducer, $d5471619bea93e71$var$initialRunState);
    const activeRunPromiseRef = (0, $42omo.useRef)(undefined);
    const abortControllerRef = (0, $42omo.useRef)(undefined);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>()=>{
                abortControllerRef.current?.abort();
            };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[2] !== spaceKey) {
        t2 = async ()=>{
            if (activeRunPromiseRef.current) return activeRunPromiseRef.current;
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            dispatch({
                type: "started"
            });
            const activeRunPromise = $d5471619bea93e71$export$2d0e2d7096700483(spaceKey, {
                signal: abortController.signal
            }).then((result)=>{
                if (!abortController.signal.aborted) dispatch({
                    type: "succeeded"
                });
                return result;
            }).catch((err)=>{
                const nextError = $d5471619bea93e71$var$toError(err);
                if (!abortController.signal.aborted) dispatch({
                    type: "failed",
                    error: nextError
                });
                throw nextError;
            }).finally(()=>{
                if (activeRunPromiseRef.current === activeRunPromise) activeRunPromiseRef.current = undefined;
                if (abortControllerRef.current === abortController) abortControllerRef.current = undefined;
            });
            activeRunPromiseRef.current = activeRunPromise;
            return activeRunPromise;
        };
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const run = t2;
    let t3;
    if ($[4] !== run || $[5] !== state.error || $[6] !== state.isRunning) {
        t3 = {
            run: run,
            isRunning: state.isRunning,
            error: state.error
        };
        $[4] = run;
        $[5] = state.error;
        $[6] = state.isRunning;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};












var $c4sKh = parcelRequire("c4sKh");


























var $cvXh8 = parcelRequire("cvXh8");











var $3sFtD = parcelRequire("3sFtD");


var $ebrpi = parcelRequire("ebrpi");


var $cbtR4 = parcelRequire("cbtR4");


var $1AXSe = parcelRequire("1AXSe");











var $26Yfd = parcelRequire("26Yfd");

function $fcb9b1196ffd7d14$export$5864b77b647e728c(props) {
    const $ = (0, $frIzR.c)(47);
    const { item: item } = props;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const cardRef = (0, $42omo.useRef)(null);
    const reviewButtonRef = (0, $42omo.useRef)(null);
    const isSelected = !props.activity && Boolean(props.isSelected);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            reviewButtonRef.current?.focus();
        };
        $[0] = t0;
    } else t0 = $[0];
    const focusReviewButton = t0;
    let t1;
    if ($[1] !== props) {
        t1 = ()=>{
            if (!props.activity) props.onReview(props.item);
        };
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    const handleReview = (0, $26Yfd.useStableCallback)(t1);
    let t2;
    let t3;
    if ($[3] !== isSelected) {
        t2 = ()=>{
            if (isSelected) {
                focusReviewButton();
                const timeoutId = window.setTimeout(focusReviewButton, 0);
                return ()=>window.clearTimeout(timeoutId);
            }
        };
        t3 = [
            focusReviewButton,
            isSelected
        ];
        $[3] = isSelected;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $42omo.useEffect)(t2, t3);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsHovered(true);
        $[6] = t4;
    } else t4 = $[6];
    const handleMouseOver = t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) setIsHovered(false);
        };
        $[7] = t5;
    } else t5 = $[7];
    const handleMouseOut = t5;
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (event_0)=>{
            setIsFocused(true);
            if (event_0.target === event_0.currentTarget) focusReviewButton();
        };
        $[8] = t6;
    } else t6 = $[8];
    const handleFocus = t6;
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (event_1)=>{
            if (!event_1.currentTarget.contains(event_1.relatedTarget)) setIsFocused(false);
        };
        $[9] = t7;
    } else t7 = $[9];
    const handleBlur = t7;
    const isInteractive = !props.activity;
    const showActions = isInteractive && (isHovered || isFocused);
    const t8 = isInteractive ? "space-suggestion-card" : undefined;
    const t9 = isInteractive ? isSelected ? "true" : "false" : undefined;
    const t10 = isInteractive ? -1 : undefined;
    let t11;
    if ($[10] !== isHovered || $[11] !== isInteractive || $[12] !== isSelected) {
        t11 = isInteractive && isHovered && !isSelected ? {
            backgroundColor: "var(--ds-surface-overlay-hovered, #F0F1F2)"
        } : undefined;
        $[10] = isHovered;
        $[11] = isInteractive;
        $[12] = isSelected;
        $[13] = t11;
    } else t11 = $[13];
    const t12 = isInteractive ? handleMouseOver : undefined;
    const t13 = isInteractive ? handleMouseOut : undefined;
    const t14 = isInteractive ? handleFocus : undefined;
    const t15 = isInteractive ? handleBlur : undefined;
    const t16 = isSelected && $fcb9b1196ffd7d14$var$styles.selectedCard;
    let t17;
    if ($[14] !== t16) {
        t17 = (0, $gMc0m.default)([
            $fcb9b1196ffd7d14$var$styles.card,
            t16
        ]);
        $[14] = t16;
        $[15] = t17;
    } else t17 = $[15];
    let t18;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $fcb9b1196ffd7d14$var$styles.iconWrapper
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cbtR4))), {
            label: "",
            color: "var(--ds-icon, #292A2E)",
            spacing: "spacious"
        }));
        $[16] = t18;
    } else t18 = $[16];
    let t19;
    if ($[17] !== item.summary) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, item.summary);
        $[17] = item.summary;
        $[18] = t19;
    } else t19 = $[18];
    let t20;
    if ($[19] !== item.timestamp) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, item.timestamp);
        $[19] = item.timestamp;
        $[20] = t20;
    } else t20 = $[20];
    let t21;
    if ($[21] !== t19 || $[22] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "start",
            space: "space.150",
            grow: "hug"
        }, t18, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, t19, t20));
        $[21] = t19;
        $[22] = t20;
        $[23] = t21;
    } else t21 = $[23];
    let t22;
    if ($[24] !== formatMessage || $[25] !== handleReview || $[26] !== isSelected || $[27] !== props.activity || $[28] !== props.onApprove || $[29] !== props.onReject || $[30] !== props.status || $[31] !== showActions) {
        t22 = props.activity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fcb9b1196ffd7d14$var$ActivityStatusLozenge, {
            status: props.status
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: showActions ? {
                opacity: 1,
                pointerEvents: "auto"
            } : undefined,
            "data-card-actions": true,
            className: (0, $gMc0m.default)([
                $fcb9b1196ffd7d14$var$styles.actions
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
            label: formatMessage($fcb9b1196ffd7d14$var$i18n.approveLabel),
            appearance: "subtle",
            onClick: props.onApprove,
            isTooltipDisabled: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            label: formatMessage($fcb9b1196ffd7d14$var$i18n.rejectLabel),
            appearance: "subtle",
            onClick: props.onReject,
            isTooltipDisabled: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            ref: reviewButtonRef,
            onClick: handleReview,
            testId: "space-suggestion-review-button",
            "data-selected": isSelected ? "true" : "false"
        }, formatMessage($fcb9b1196ffd7d14$var$i18n.reviewButton))));
        $[24] = formatMessage;
        $[25] = handleReview;
        $[26] = isSelected;
        $[27] = props.activity;
        $[28] = props.onApprove;
        $[29] = props.onReject;
        $[30] = props.status;
        $[31] = showActions;
        $[32] = t22;
    } else t22 = $[32];
    let t23;
    if ($[33] !== t21 || $[34] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.150",
            spread: "space-between"
        }, t21, t22);
        $[33] = t21;
        $[34] = t22;
        $[35] = t23;
    } else t23 = $[35];
    let t24;
    if ($[36] !== t10 || $[37] !== t11 || $[38] !== t12 || $[39] !== t13 || $[40] !== t14 || $[41] !== t15 || $[42] !== t17 || $[43] !== t23 || $[44] !== t8 || $[45] !== t9) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: cardRef,
            "data-testid": t8,
            "data-selected": t9,
            tabIndex: t10,
            style: t11,
            onMouseOver: t12,
            onMouseOut: t13,
            onFocus: t14,
            onBlur: t15,
            className: t17
        }, t23);
        $[36] = t10;
        $[37] = t11;
        $[38] = t12;
        $[39] = t13;
        $[40] = t14;
        $[41] = t15;
        $[42] = t17;
        $[43] = t23;
        $[44] = t8;
        $[45] = t9;
        $[46] = t24;
    } else t24 = $[46];
    return t24;
}
function $fcb9b1196ffd7d14$var$ActivityStatusLozenge(t0) {
    const $ = (0, $frIzR.c)(8);
    const { status: status } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (status === "success") {
        let t1;
        if ($[0] !== formatMessage) {
            t1 = formatMessage($fcb9b1196ffd7d14$var$i18n.statusSuccess);
            $[0] = formatMessage;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1AXSe.default), {
                appearance: "success",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($3sFtD)))
            }, t1);
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t1;
    if ($[4] !== formatMessage) {
        t1 = formatMessage($fcb9b1196ffd7d14$var$i18n.statusFailed);
        $[4] = formatMessage;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1AXSe.default), {
            appearance: "warning",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($ebrpi)))
        }, t1);
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
}
const $fcb9b1196ffd7d14$var$ICON_WRAPPER_SIZE = 38;
const $fcb9b1196ffd7d14$var$styles = {
    card: "_2rko1mok _v564pobe _1rjcpxbi _18zrpxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _bfhkvuon _1qu2glyw",
    selectedCard: "_1h6dq98m _bfhk15s3 _1hvw1dm9 _49pcnqa1 _nt75q98m",
    iconWrapper: "_2rko1mok _1reo15vq _18m915vq _1bsb10mc _4t3i10mc _bfhki8nm _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    actions: "_v5641laf _tzy4idpf _lcxvglyw"
};
const $fcb9b1196ffd7d14$var$i18n = (0, $aXWIB.defineMessages)({
    reviewButton: {
        id: "space-suggestions.suggestion-card.review-button",
        defaultMessage: "Review"
    },
    approveLabel: {
        id: "space-suggestions.suggestion-card.approve-label",
        defaultMessage: "Approve"
    },
    rejectLabel: {
        id: "space-suggestions.suggestion-card.reject-label",
        defaultMessage: "Reject"
    },
    statusSuccess: {
        id: "space-suggestions.suggestion-card.status-success",
        defaultMessage: "Success"
    },
    statusFailed: {
        id: "space-suggestions.suggestion-card.status-failed",
        defaultMessage: "Failed"
    }
});












var $eEA8O = parcelRequire("eEA8O");


var $1s5hv = parcelRequire("1s5hv");




var $jvYFk = parcelRequire("jvYFk");























var $g5gZt = parcelRequire("g5gZt");














var $fVUfS = parcelRequire("fVUfS");


var $kmWRd = parcelRequire("kmWRd");

var $3hnrC = parcelRequire("3hnrC");

var $cHiEk = parcelRequire("cHiEk");

var $4WZFP = parcelRequire("4WZFP");

















var $bfgIy = parcelRequire("bfgIy");


var $fVjjG = parcelRequire("fVjjG");









var $lBvGi = parcelRequire("lBvGi");


var $4noo5 = parcelRequire("4noo5");






const $ecb1c9ab381f8a9b$var$fieldMessages = (0, $aXWIB.defineMessages)({
    contentId: {
        id: "space-suggestions.action-builder.field.content-id",
        defaultMessage: "Content ID"
    },
    newTitle: {
        id: "space-suggestions.action-builder.field.new-title",
        defaultMessage: "New title"
    },
    destinationAlias: {
        id: "space-suggestions.action-builder.field.destination-alias",
        defaultMessage: "Destination folder ID"
    },
    folderTitle: {
        id: "space-suggestions.action-builder.field.folder-title",
        defaultMessage: "Folder name"
    },
    parentContentId: {
        id: "space-suggestions.action-builder.field.parent-content-id",
        defaultMessage: "Parent content ID"
    }
});
/** Fields rendered per action type. Order controls top-to-bottom layout. */ const $ecb1c9ab381f8a9b$var$FIELDS_BY_TYPE = {
    RENAME: [
        {
            key: 'contentId',
            label: $ecb1c9ab381f8a9b$var$fieldMessages.contentId
        },
        {
            key: 'title',
            label: $ecb1c9ab381f8a9b$var$fieldMessages.newTitle
        }
    ],
    MOVE: [
        {
            key: 'contentId',
            label: $ecb1c9ab381f8a9b$var$fieldMessages.contentId
        },
        {
            key: 'destinationAlias',
            label: $ecb1c9ab381f8a9b$var$fieldMessages.destinationAlias
        }
    ],
    CREATE_FOLDER: [
        {
            key: 'title',
            label: $ecb1c9ab381f8a9b$var$fieldMessages.folderTitle
        },
        {
            key: 'parentContentId',
            label: $ecb1c9ab381f8a9b$var$fieldMessages.parentContentId
        }
    ]
};
function $ecb1c9ab381f8a9b$export$562600678466294f(t0) {
    const $ = (0, $frIzR.c)(73);
    const { suggestionId: suggestionId, nextActionIndex: nextActionIndex, onAdd: onAdd, onBack: onBack } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [actionType, setActionType] = (0, $42omo.useState)("RENAME");
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [values, setValues] = (0, $42omo.useState)(t1);
    const [submitted, setSubmitted] = (0, $42omo.useState)(false);
    const fields = $ecb1c9ab381f8a9b$var$FIELDS_BY_TYPE[actionType];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (event)=>{
            setActionType(event.currentTarget.value);
            setSubmitted(false);
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleTypeChange = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (key)=>(event_0)=>{
                const { value: value } = event_0.currentTarget;
                setValues((current)=>({
                        ...current,
                        [key]: value
                    }));
            };
        $[2] = t3;
    } else t3 = $[2];
    const handleFieldChange = t3;
    let t4;
    if ($[3] !== fields || $[4] !== values) {
        let t5;
        if ($[6] !== values) {
            t5 = (missing, t6)=>{
                const { key: key_0 } = t6;
                if (!(values[key_0] ?? "").trim()) missing.push(key_0);
                return missing;
            };
            $[6] = values;
            $[7] = t5;
        } else t5 = $[7];
        t4 = fields.reduce(t5, []);
        $[3] = fields;
        $[4] = values;
        $[5] = t4;
    } else t4 = $[5];
    const missingKeys = t4;
    let t5;
    if ($[8] !== actionType || $[9] !== missingKeys.length || $[10] !== nextActionIndex || $[11] !== onAdd || $[12] !== suggestionId || $[13] !== values) {
        t5 = ()=>{
            setSubmitted(true);
            if (missingKeys.length > 0) return;
            const get = (key_1)=>(values[key_1] ?? "").trim();
            const actionStepId = `${suggestionId}-${nextActionIndex}`;
            let action;
            bb27: switch(actionType){
                case "RENAME":
                    action = {
                        actionStepId: actionStepId,
                        parentActionStepId: null,
                        actionType: "RENAME",
                        parameters: {
                            contentId: get("contentId"),
                            title: get("title")
                        }
                    };
                    break bb27;
                case "MOVE":
                    action = {
                        actionStepId: actionStepId,
                        parentActionStepId: null,
                        actionType: "MOVE",
                        parameters: {
                            contentId: get("contentId"),
                            destinationAlias: get("destinationAlias")
                        }
                    };
                    break bb27;
                case "CREATE_FOLDER":
                    action = {
                        actionStepId: actionStepId,
                        parentActionStepId: null,
                        actionType: "CREATE_FOLDER",
                        parameters: {
                            alias: `new-folder-${nextActionIndex}`,
                            parentContentId: get("parentContentId"),
                            title: get("title")
                        }
                    };
            }
            onAdd(action);
        };
        $[8] = actionType;
        $[9] = missingKeys.length;
        $[10] = nextActionIndex;
        $[11] = onAdd;
        $[12] = suggestionId;
        $[13] = values;
        $[14] = t5;
    } else t5 = $[14];
    const handleSubmit = t5;
    let t6;
    if ($[15] !== formatMessage) {
        t6 = formatMessage($ecb1c9ab381f8a9b$var$i18n.typeRename);
        $[15] = formatMessage;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== t6) {
        t7 = {
            name: "action-type",
            value: "RENAME",
            label: t6
        };
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== formatMessage) {
        t8 = formatMessage($ecb1c9ab381f8a9b$var$i18n.typeMove);
        $[19] = formatMessage;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== t8) {
        t9 = {
            name: "action-type",
            value: "MOVE",
            label: t8
        };
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== formatMessage) {
        t10 = formatMessage($ecb1c9ab381f8a9b$var$i18n.typeCreateFolder);
        $[23] = formatMessage;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== t10) {
        t11 = {
            name: "action-type",
            value: "CREATE_FOLDER",
            label: t10
        };
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== t11 || $[28] !== t7 || $[29] !== t9) {
        t12 = [
            t7,
            t9,
            t11
        ];
        $[27] = t11;
        $[28] = t7;
        $[29] = t9;
        $[30] = t12;
    } else t12 = $[30];
    const typeOptions = t12;
    let t13;
    if ($[31] !== formatMessage) {
        t13 = formatMessage($ecb1c9ab381f8a9b$var$i18n.actionTypeLabel);
        $[31] = formatMessage;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, t13);
        $[33] = t13;
        $[34] = t14;
    } else t14 = $[34];
    let t15;
    if ($[35] !== actionType || $[36] !== typeOptions) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBvGi.default), {
            options: typeOptions,
            value: actionType,
            onChange: handleTypeChange
        });
        $[35] = actionType;
        $[36] = typeOptions;
        $[37] = t15;
    } else t15 = $[37];
    let t16;
    if ($[38] !== t14 || $[39] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, t14, t15);
        $[38] = t14;
        $[39] = t15;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== fields || $[42] !== formatMessage || $[43] !== missingKeys || $[44] !== submitted || $[45] !== values) {
        let t18;
        if ($[47] !== formatMessage || $[48] !== missingKeys || $[49] !== submitted || $[50] !== values) {
            t18 = (t19)=>{
                const { key: key_2, label: label } = t19;
                const fieldId = `suggestion-action-field-${key_2}`;
                const isInvalid = submitted && missingKeys.includes(key_2);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                    key: key_2,
                    space: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
                    htmlFor: fieldId
                }, formatMessage(label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                    id: fieldId,
                    value: values[key_2] ?? "",
                    onChange: handleFieldChange(key_2),
                    isInvalid: isInvalid
                }), isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVjjG.ErrorMessage), null, formatMessage($ecb1c9ab381f8a9b$var$i18n.requiredError)));
            };
            $[47] = formatMessage;
            $[48] = missingKeys;
            $[49] = submitted;
            $[50] = values;
            $[51] = t18;
        } else t18 = $[51];
        t17 = fields.map(t18);
        $[41] = fields;
        $[42] = formatMessage;
        $[43] = missingKeys;
        $[44] = submitted;
        $[45] = values;
        $[46] = t17;
    } else t17 = $[46];
    let t18;
    if ($[52] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150"
        }, t17);
        $[52] = t17;
        $[53] = t18;
    } else t18 = $[53];
    let t19;
    if ($[54] !== t16 || $[55] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hnrC.SidePanelBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200"
        }, t16, t18));
        $[54] = t16;
        $[55] = t18;
        $[56] = t19;
    } else t19 = $[56];
    let t20;
    if ($[57] !== formatMessage) {
        t20 = formatMessage($ecb1c9ab381f8a9b$var$i18n.back);
        $[57] = formatMessage;
        $[58] = t20;
    } else t20 = $[58];
    let t21;
    if ($[59] !== onBack || $[60] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            onClick: onBack
        }, t20);
        $[59] = onBack;
        $[60] = t20;
        $[61] = t21;
    } else t21 = $[61];
    let t22;
    if ($[62] !== formatMessage) {
        t22 = formatMessage($ecb1c9ab381f8a9b$var$i18n.add);
        $[62] = formatMessage;
        $[63] = t22;
    } else t22 = $[63];
    let t23;
    if ($[64] !== handleSubmit || $[65] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "primary",
            onClick: handleSubmit
        }, t22);
        $[64] = handleSubmit;
        $[65] = t22;
        $[66] = t23;
    } else t23 = $[66];
    let t24;
    if ($[67] !== t21 || $[68] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cHiEk.SidePanelFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "row",
            gap: "space.100",
            justifyContent: "end"
        }, t21, t23));
        $[67] = t21;
        $[68] = t23;
        $[69] = t24;
    } else t24 = $[69];
    let t25;
    if ($[70] !== t19 || $[71] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t19, t24);
        $[70] = t19;
        $[71] = t24;
        $[72] = t25;
    } else t25 = $[72];
    return t25;
}
const $ecb1c9ab381f8a9b$var$i18n = (0, $aXWIB.defineMessages)({
    actionTypeLabel: {
        id: "space-suggestions.action-builder.action-type-label",
        defaultMessage: "Action type"
    },
    typeRename: {
        id: "space-suggestions.action-builder.type-rename",
        defaultMessage: "Rename"
    },
    typeMove: {
        id: "space-suggestions.action-builder.type-move",
        defaultMessage: "Move"
    },
    typeCreateFolder: {
        id: "space-suggestions.action-builder.type-create-folder",
        defaultMessage: "Create folder"
    },
    requiredError: {
        id: "space-suggestions.action-builder.required-error",
        defaultMessage: "This field is required"
    },
    back: {
        id: "space-suggestions.action-builder.back-button",
        defaultMessage: "Back"
    },
    add: {
        id: "space-suggestions.action-builder.add-button",
        defaultMessage: "Add"
    }
});















var $7gpC4 = parcelRequire("7gpC4");


var $5tmwS = parcelRequire("5tmwS");


var $8jHAi = parcelRequire("8jHAi");








function $d8bd850498ec77a9$export$f169aa7193128f39(props) {
    const $ = (0, $frIzR.c)(31);
    const { action: action, index: index, isChecked: isChecked, onCheckedChange: onCheckedChange } = props;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== action || $[1] !== formatMessage) {
        t0 = $d8bd850498ec77a9$var$getActionRowContent(action, formatMessage);
        $[0] = action;
        $[1] = formatMessage;
        $[2] = t0;
    } else t0 = $[2];
    const rowContent = t0;
    const ContentIcon = rowContent.contentType === "folder" ? (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))) : (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi)));
    let t1;
    if ($[3] !== index || $[4] !== onCheckedChange) {
        t1 = (event)=>{
            onCheckedChange(index, event.currentTarget.checked);
        };
        $[3] = index;
        $[4] = onCheckedChange;
        $[5] = t1;
    } else t1 = $[5];
    const handleChange = t1;
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            $d8bd850498ec77a9$var$styles.row
        ]);
        $[6] = t2;
    } else t2 = $[6];
    const t3 = `suggestion-review-row-${rowContent.actionType}-${index}`;
    const t4 = rowContent.checkboxLabel;
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $gMc0m.default)([
            $d8bd850498ec77a9$var$styles.labelContent
        ]);
        t6 = (0, $gMc0m.default)([
            $d8bd850498ec77a9$var$styles.actionText
        ]);
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    let t7;
    if ($[9] !== rowContent.actionLabel) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t6
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, rowContent.actionLabel));
        $[9] = rowContent.actionLabel;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== ContentIcon) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $d8bd850498ec77a9$var$styles.contentIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ContentIcon, {
            label: "",
            size: "small",
            color: "currentColor"
        }));
        $[11] = ContentIcon;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $gMc0m.default)([
            $d8bd850498ec77a9$var$styles.titleText
        ]);
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== rowContent.title) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t9
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, rowContent.title));
        $[14] = rowContent.title;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10 || $[17] !== t7 || $[18] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t5
        }, t7, t8, t10);
        $[16] = t10;
        $[17] = t7;
        $[18] = t8;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== rowContent.subtext) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, rowContent.subtext);
        $[20] = rowContent.subtext;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== t11 || $[23] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.025"
        }, t11, t12);
        $[22] = t11;
        $[23] = t12;
        $[24] = t13;
    } else t13 = $[24];
    let t14;
    if ($[25] !== handleChange || $[26] !== isChecked || $[27] !== rowContent.checkboxLabel || $[28] !== t13 || $[29] !== t3) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
            xcss: $d8bd850498ec77a9$var$styles.checkbox,
            isChecked: isChecked,
            onChange: handleChange,
            name: t3,
            "aria-label": t4,
            label: t13
        }));
        $[25] = handleChange;
        $[26] = isChecked;
        $[27] = rowContent.checkboxLabel;
        $[28] = t13;
        $[29] = t3;
        $[30] = t14;
    } else t14 = $[30];
    return t14;
}
function $d8bd850498ec77a9$var$getActionRowContent(action, formatMessage) {
    switch(action.actionType){
        case 'CREATE_FOLDER':
            {
                const { parentContentId: parentContentId, parentContentName: parentContentName, title: title } = action.parameters;
                const parentLabel = parentContentName || parentContentId;
                return {
                    actionType: action.actionType,
                    actionLabel: formatMessage($d8bd850498ec77a9$var$actionLabelMessages.CREATE_FOLDER),
                    title: title,
                    subtext: formatMessage($d8bd850498ec77a9$var$i18n.createFolderSubtext, {
                        parentContentName: parentLabel
                    }),
                    contentType: 'folder',
                    checkboxLabel: formatMessage($d8bd850498ec77a9$var$i18n.checkboxLabel, {
                        action: formatMessage($d8bd850498ec77a9$var$actionLabelMessages.CREATE_FOLDER),
                        title: title
                    })
                };
            }
        case 'MOVE':
            {
                const { contentId: contentId, contentName: contentName, destinationAlias: destinationAlias, destinationName: destinationName } = action.parameters;
                const title = contentName || contentId;
                const destinationLabel = destinationName || destinationAlias;
                return {
                    actionType: action.actionType,
                    actionLabel: formatMessage($d8bd850498ec77a9$var$actionLabelMessages.MOVE),
                    title: title,
                    subtext: destinationLabel ? formatMessage($d8bd850498ec77a9$var$i18n.moveSubtext, {
                        destinationName: destinationLabel
                    }) : '',
                    contentType: 'page',
                    checkboxLabel: formatMessage($d8bd850498ec77a9$var$i18n.checkboxLabel, {
                        action: formatMessage($d8bd850498ec77a9$var$actionLabelMessages.MOVE),
                        title: title
                    })
                };
            }
        case 'RENAME':
            {
                const { contentId: contentId, contentName: contentName, title: title } = action.parameters;
                const previousTitle = contentName || contentId;
                return {
                    actionType: action.actionType,
                    actionLabel: formatMessage($d8bd850498ec77a9$var$actionLabelMessages.RENAME),
                    title: title,
                    subtext: previousTitle,
                    contentType: 'page',
                    checkboxLabel: formatMessage($d8bd850498ec77a9$var$i18n.checkboxLabel, {
                        action: formatMessage($d8bd850498ec77a9$var$actionLabelMessages.RENAME),
                        title: title
                    })
                };
            }
        default:
            return {
                actionType: action.actionType,
                actionLabel: formatMessage($d8bd850498ec77a9$var$i18n.unknownActionLabel),
                title: action.actionType,
                subtext: formatMessage($d8bd850498ec77a9$var$i18n.unknownActionSubtext, {
                    parameters: $d8bd850498ec77a9$var$stringifyUnknownParameters(action.parameters)
                }),
                contentType: 'page',
                checkboxLabel: formatMessage($d8bd850498ec77a9$var$i18n.checkboxLabel, {
                    action: formatMessage($d8bd850498ec77a9$var$i18n.unknownActionLabel),
                    title: action.actionType
                })
            };
    }
}
function $d8bd850498ec77a9$var$stringifyUnknownParameters(parameters) {
    if (parameters === undefined) return '';
    try {
        return JSON.stringify(parameters);
    } catch  {
        return String(parameters);
    }
}
const $d8bd850498ec77a9$var$styles = {
    row: "_2rko1mok _1rjcu2gc _18zru2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _bfhkvuon _80omtlke",
    checkbox: "_4cvr1y6m",
    labelContent: "_1e0c11p5 _yv0e148c _gy1p1b66 _4cvr1h6o _1ul9idpf",
    actionText: "_o5721q9c",
    contentIcon: "_syazdv2p",
    titleText: "_1ul9idpf _1i4q1hna"
};
const $d8bd850498ec77a9$var$actionLabelMessages = (0, $aXWIB.defineMessages)({
    CREATE_FOLDER: {
        id: "space-suggestions.review-row.action.create-folder",
        defaultMessage: "Create"
    },
    MOVE: {
        id: "space-suggestions.review-row.action.move",
        defaultMessage: "Move"
    },
    RENAME: {
        id: "space-suggestions.review-row.action.rename",
        defaultMessage: "Rename"
    }
});
const $d8bd850498ec77a9$var$i18n = (0, $aXWIB.defineMessages)({
    createFolderSubtext: {
        id: "space-suggestions.review-row.create-folder-subtext",
        defaultMessage: "in {parentContentName}"
    },
    moveSubtext: {
        id: "space-suggestions.review-row.move-subtext",
        defaultMessage: "to {destinationName}"
    },
    unknownActionLabel: {
        id: "space-suggestions.review-row.unknown-action-label",
        defaultMessage: "Unknown action"
    },
    unknownActionSubtext: {
        id: "space-suggestions.review-row.unknown-action-subtext",
        defaultMessage: "parameters: {parameters}"
    },
    checkboxLabel: {
        id: "space-suggestions.review-row.checkbox-label",
        defaultMessage: "{action} {title}"
    }
});


const $b77336ff8374f0f7$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "space-suggestions.review-panel.title",
        defaultMessage: "Review suggestion"
    },
    close: {
        id: "space-suggestions.review-panel.close-label",
        defaultMessage: "Close"
    },
    cancel: {
        id: "space-suggestions.review-panel.cancel-button",
        defaultMessage: "Cancel"
    },
    approve: {
        id: "space-suggestions.review-panel.approve-button",
        defaultMessage: "Approve"
    },
    subtext: {
        id: "space-suggestions.review-panel.subtext",
        defaultMessage: "{count, plural, one {# suggested change} other {# suggested changes}}"
    },
    addAction: {
        id: "space-suggestions.review-panel.add-action-button",
        defaultMessage: "Add action"
    },
    addActionTitle: {
        id: "space-suggestions.review-panel.add-action-title",
        defaultMessage: "Add action"
    }
});
const $b77336ff8374f0f7$export$d14c5d2f3baf5df7 = 400;
const $b77336ff8374f0f7$export$4dbccbfafc528199 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(59);
    const { rawSuggestion: rawSuggestion, timestamp: timestamp, onClose: onClose, onCancel: onCancel, onApprove: onApprove, isApproveDisabled: t1, width: t2, headerHeight: t3, isEmbedded: t4 } = t0;
    const isApproveDisabled = t1 === undefined ? false : t1;
    const width = t2 === undefined ? $b77336ff8374f0f7$export$d14c5d2f3baf5df7 : t2;
    const headerHeight = t3 === undefined ? 0 : t3;
    const isEmbedded = t4 === undefined ? false : t4;
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $1xpoY.default).getBoolean("confluence-space-suggestion-add-action", false);
        $[0] = t5;
    } else t5 = $[0];
    const isAddActionEnabled = t5;
    const [mode, setMode] = (0, $42omo.useState)("review");
    const baseActions = rawSuggestion.actions;
    let t6;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [];
        $[1] = t6;
    } else t6 = $[1];
    const [addedActions, setAddedActions] = (0, $42omo.useState)(t6);
    let t7;
    if ($[2] !== addedActions || $[3] !== baseActions) {
        t7 = [
            ...baseActions,
            ...addedActions
        ];
        $[2] = addedActions;
        $[3] = baseActions;
        $[4] = t7;
    } else t7 = $[4];
    const reviewActions = t7;
    const actionCount = reviewActions.length;
    let t8;
    if ($[5] !== baseActions) {
        t8 = ()=>baseActions.map($b77336ff8374f0f7$var$_temp);
        $[5] = baseActions;
        $[6] = t8;
    } else t8 = $[6];
    const [checkedActions, setCheckedActions] = (0, $42omo.useState)(t8);
    const previousIdRef = (0, $42omo.useRef)(rawSuggestion.id);
    let t10;
    let t9;
    if ($[7] !== baseActions || $[8] !== rawSuggestion.id) {
        t9 = ()=>{
            if (previousIdRef.current !== rawSuggestion.id) {
                previousIdRef.current = rawSuggestion.id;
                setAddedActions([]);
                setCheckedActions(baseActions.map($b77336ff8374f0f7$var$_temp2));
                setMode("review");
            }
        };
        t10 = [
            rawSuggestion.id,
            baseActions
        ];
        $[7] = baseActions;
        $[8] = rawSuggestion.id;
        $[9] = t10;
        $[10] = t9;
    } else {
        t10 = $[9];
        t9 = $[10];
    }
    (0, $42omo.useEffect)(t9, t10);
    let t11;
    if ($[11] !== checkedActions) {
        t11 = checkedActions.every($b77336ff8374f0f7$var$_temp3);
        $[11] = checkedActions;
        $[12] = t11;
    } else t11 = $[12];
    const isEveryActionUnchecked = t11;
    let t12;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (index, isChecked_0)=>{
            setCheckedActions((currentCheckedActions)=>currentCheckedActions.map((currentIsChecked, currentIndex)=>currentIndex === index ? isChecked_0 : currentIsChecked));
        };
        $[13] = t12;
    } else t12 = $[13];
    const handleCheckedChange = t12;
    let t13;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (action)=>{
            setAddedActions((current)=>[
                    ...current,
                    action
                ]);
            setCheckedActions($b77336ff8374f0f7$var$_temp4);
            setMode("review");
        };
        $[14] = t13;
    } else t13 = $[14];
    const handleAddAction = t13;
    const isApproveButtonDisabled = isApproveDisabled || isEveryActionUnchecked;
    let t14;
    if ($[15] !== checkedActions || $[16] !== onApprove || $[17] !== reviewActions) {
        t14 = ()=>{
            const [acceptedActionStepIds, declinedActionStepIds] = reviewActions.reduce((t15, action_0, i)=>{
                const [accepted, declined] = t15;
                if (action_0.actionStepId) {
                    if (checkedActions[i] ?? true) accepted.push(action_0.actionStepId);
                    else declined.push(action_0.actionStepId);
                }
                return [
                    accepted,
                    declined
                ];
            }, [
                [],
                []
            ]);
            onApprove(acceptedActionStepIds, declinedActionStepIds);
        };
        $[15] = checkedActions;
        $[16] = onApprove;
        $[17] = reviewActions;
        $[18] = t14;
    } else t14 = $[18];
    const handleApprove = t14;
    const isBuilding = isAddActionEnabled && mode === "build";
    const t15 = isBuilding ? $b77336ff8374f0f7$var$i18n.addActionTitle : $b77336ff8374f0f7$var$i18n.title;
    let t16;
    if ($[19] !== formatMessage || $[20] !== t15) {
        t16 = formatMessage(t15);
        $[19] = formatMessage;
        $[20] = t15;
        $[21] = t16;
    } else t16 = $[21];
    let t17;
    if ($[22] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "small"
        }, t16);
        $[22] = t16;
        $[23] = t17;
    } else t17 = $[23];
    let t18;
    if ($[24] !== actionCount || $[25] !== formatMessage || $[26] !== isBuilding || $[27] !== timestamp) {
        t18 = !isBuilding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage($b77336ff8374f0f7$var$i18n.subtext, {
            count: actionCount
        }), " \u2022 ", timestamp);
        $[24] = actionCount;
        $[25] = formatMessage;
        $[26] = isBuilding;
        $[27] = timestamp;
        $[28] = t18;
    } else t18 = $[28];
    let t19;
    if ($[29] !== t17 || $[30] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, t17, t18);
        $[29] = t17;
        $[30] = t18;
        $[31] = t19;
    } else t19 = $[31];
    let t20;
    if ($[32] !== formatMessage) {
        t20 = formatMessage($b77336ff8374f0f7$var$i18n.close);
        $[32] = formatMessage;
        $[33] = t20;
    } else t20 = $[33];
    let t21;
    if ($[34] !== onClose || $[35] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            label: t20,
            appearance: "subtle",
            onClick: onClose
        });
        $[34] = onClose;
        $[35] = t20;
        $[36] = t21;
    } else t21 = $[36];
    let t22;
    if ($[37] !== t19 || $[38] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WZFP.SidePanelHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center"
        }, t19, t21));
        $[37] = t19;
        $[38] = t21;
        $[39] = t22;
    } else t22 = $[39];
    let t23;
    if ($[40] !== actionCount || $[41] !== checkedActions || $[42] !== formatMessage || $[43] !== handleApprove || $[44] !== isApproveButtonDisabled || $[45] !== isBuilding || $[46] !== onCancel || $[47] !== rawSuggestion.id || $[48] !== reviewActions) {
        t23 = isBuilding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ecb1c9ab381f8a9b$export$562600678466294f), {
            suggestionId: rawSuggestion.id,
            nextActionIndex: actionCount + 1,
            onAdd: handleAddAction,
            onBack: ()=>setMode("review")
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hnrC.SidePanelBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, reviewActions.map((action_1, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8bd850498ec77a9$export$f169aa7193128f39), {
                key: `${rawSuggestion.id}-${index_0}`,
                action: action_1,
                index: index_0,
                isChecked: checkedActions[index_0] ?? true,
                onCheckedChange: handleCheckedChange
            })), isAddActionEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: $b77336ff8374f0f7$var$styles.addActionButton,
            onClick: ()=>setMode("build")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            label: "",
            size: "small",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($b77336ff8374f0f7$var$i18n.addAction)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cHiEk.SidePanelFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "row",
            gap: "space.100",
            justifyContent: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            onClick: onCancel
        }, formatMessage($b77336ff8374f0f7$var$i18n.cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "primary",
            onClick: handleApprove,
            isDisabled: isApproveButtonDisabled
        }, formatMessage($b77336ff8374f0f7$var$i18n.approve)))));
        $[40] = actionCount;
        $[41] = checkedActions;
        $[42] = formatMessage;
        $[43] = handleApprove;
        $[44] = isApproveButtonDisabled;
        $[45] = isBuilding;
        $[46] = onCancel;
        $[47] = rawSuggestion.id;
        $[48] = reviewActions;
        $[49] = t23;
    } else t23 = $[49];
    let t24;
    if ($[50] !== t22 || $[51] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t22, t23);
        $[50] = t22;
        $[51] = t23;
        $[52] = t24;
    } else t24 = $[52];
    const panelContent = t24;
    if (isEmbedded) {
        let t25;
        if ($[53] !== panelContent) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $b77336ff8374f0f7$var$styles.embeddedPanel
            }, panelContent);
            $[53] = panelContent;
            $[54] = t25;
        } else t25 = $[54];
        return t25;
    }
    let t25;
    if ($[55] !== headerHeight || $[56] !== panelContent || $[57] !== width) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kmWRd.SidePanel), {
            isFixed: true,
            width: width,
            headerHeight: headerHeight,
            panelTop: headerHeight
        }, panelContent);
        $[55] = headerHeight;
        $[56] = panelContent;
        $[57] = width;
        $[58] = t25;
    } else t25 = $[58];
    return t25;
});
const $b77336ff8374f0f7$var$styles = {
    embeddedPanel: "_bfhkvuon _1e0c1txw _2lx21bp4 _4t3i1osq _1bsb1osq",
    addActionButton: "_2rko1mok _1rjcu2gc _18zru2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _y3gn1e5h _bfhkvuon _syazazsu _80omtlke _irr319i6"
};
function $b77336ff8374f0f7$var$_temp() {
    return true;
}
function $b77336ff8374f0f7$var$_temp2() {
    return true;
}
function $b77336ff8374f0f7$var$_temp3(isChecked) {
    return !isChecked;
}
function $b77336ff8374f0f7$var$_temp4(current_0) {
    return [
        ...current_0,
        true
    ];
}


const $e21399041d87a406$export$971b6134229768db = (0, $jvYFk.PanelName).SpaceSuggestionReviewPanel;
const $e21399041d87a406$export$30c78b171c5bb25b = 400;
const $e21399041d87a406$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "space-suggestions.review-panel.title",
        defaultMessage: "Review suggestion"
    },
    cancel: {
        id: "space-suggestions.review-panel.cancel-button",
        defaultMessage: "Cancel"
    },
    approve: {
        id: "space-suggestions.review-panel.approve-button",
        defaultMessage: "Approve"
    },
    subtext: {
        id: "space-suggestions.review-panel.subtext",
        defaultMessage: "{count, plural, one {# suggested change} other {# suggested changes}}"
    }
});
let $e21399041d87a406$var$panelState = null;
const $e21399041d87a406$var$listeners = new Set();
const $e21399041d87a406$var$emitChange = ()=>{
    $e21399041d87a406$var$listeners.forEach((listener)=>listener());
};
const $e21399041d87a406$var$subscribe = (listener)=>{
    $e21399041d87a406$var$listeners.add(listener);
    return ()=>{
        $e21399041d87a406$var$listeners.delete(listener);
    };
};
const $e21399041d87a406$var$getSnapshot = ()=>$e21399041d87a406$var$panelState;
const $e21399041d87a406$export$882db99fc7554945 = ()=>{
    return (0, $42omo.useSyncExternalStore)($e21399041d87a406$var$subscribe, $e21399041d87a406$var$getSnapshot, $e21399041d87a406$var$getSnapshot);
};
const $e21399041d87a406$export$9ae27c93f69dca2b = (item, onApprove)=>{
    $e21399041d87a406$var$panelState = {
        item: item,
        onApprove: onApprove
    };
    $e21399041d87a406$var$emitChange();
};
const $e21399041d87a406$export$c60311a397544f15 = ()=>{
    if ($e21399041d87a406$var$panelState === null) return;
    $e21399041d87a406$var$panelState = null;
    $e21399041d87a406$var$emitChange();
};
const $e21399041d87a406$export$6dd63ee87c66410 = ()=>{
    const $ = (0, $frIzR.c)(6);
    const state = $e21399041d87a406$export$882db99fc7554945();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (state === null) return null;
    let t0;
    if ($[0] !== formatMessage || $[1] !== state.item.rawSuggestion.actions.length) {
        t0 = formatMessage($e21399041d87a406$var$i18n.subtext, {
            count: state.item.rawSuggestion.actions.length
        });
        $[0] = formatMessage;
        $[1] = state.item.rawSuggestion.actions.length;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== state.item.timestamp || $[4] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, t0, " \u2022", " ", state.item.timestamp);
        $[3] = state.item.timestamp;
        $[4] = t0;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $e21399041d87a406$export$ba7f11c5ef95fe05 = ()=>{
    const $ = (0, $frIzR.c)(10);
    const state = $e21399041d87a406$export$882db99fc7554945();
    const { hideObjectSidebarByPanelId: hideObjectSidebarByPanelId } = (0, $aWwYt.useObjectSidebarActions)();
    let t0;
    if ($[0] !== hideObjectSidebarByPanelId) {
        t0 = ()=>{
            $e21399041d87a406$export$c60311a397544f15();
            hideObjectSidebarByPanelId($e21399041d87a406$export$971b6134229768db);
        };
        $[0] = hideObjectSidebarByPanelId;
        $[1] = t0;
    } else t0 = $[1];
    const handleClose = t0;
    let t1;
    if ($[2] !== handleClose || $[3] !== state) {
        t1 = (acceptedActionStepIds, declinedActionStepIds)=>{
            state?.onApprove(acceptedActionStepIds, declinedActionStepIds);
            handleClose();
        };
        $[2] = handleClose;
        $[3] = state;
        $[4] = t1;
    } else t1 = $[4];
    const handleApprove = t1;
    if (state === null) return null;
    let t2;
    if ($[5] !== handleApprove || $[6] !== handleClose || $[7] !== state.item.rawSuggestion || $[8] !== state.item.timestamp) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b77336ff8374f0f7$export$4dbccbfafc528199), {
            rawSuggestion: state.item.rawSuggestion,
            timestamp: state.item.timestamp,
            onClose: handleClose,
            onCancel: handleClose,
            onApprove: handleApprove,
            isEmbedded: true
        });
        $[5] = handleApprove;
        $[6] = handleClose;
        $[7] = state.item.rawSuggestion;
        $[8] = state.item.timestamp;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
};
const $e21399041d87a406$export$11e48a44da8fc06e = ()=>{
    const $ = (0, $frIzR.c)(15);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { hideObjectSidebarByPanelId: hideObjectSidebarByPanelId } = (0, $aWwYt.useObjectSidebarActions)();
    let t0;
    if ($[0] !== hideObjectSidebarByPanelId) {
        t0 = ()=>{
            $e21399041d87a406$export$c60311a397544f15();
            hideObjectSidebarByPanelId($e21399041d87a406$export$971b6134229768db);
        };
        $[0] = hideObjectSidebarByPanelId;
        $[1] = t0;
    } else t0 = $[1];
    const handleClose = t0;
    let t1;
    if ($[2] !== formatMessage) {
        t1 = formatMessage($e21399041d87a406$var$i18n.cancel);
        $[2] = formatMessage;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== handleClose || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            onClick: handleClose
        }, t1);
        $[4] = handleClose;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== formatMessage) {
        t3 = formatMessage($e21399041d87a406$var$i18n.approve);
        $[7] = formatMessage;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== handleClose || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "primary",
            onClick: handleClose
        }, t3);
        $[9] = handleClose;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t2 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "row",
            gap: "space.100",
            justifyContent: "end"
        }, t2, t4);
        $[12] = t2;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
const $e21399041d87a406$export$2738c5b277b0dcc0 = ()=>{
    const $ = (0, $frIzR.c)(5);
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    let t0;
    if ($[0] !== showObjectSidebar) {
        t0 = (item, onApprove)=>{
            $e21399041d87a406$export$9ae27c93f69dca2b(item, onApprove);
            showObjectSidebar({
                id: $e21399041d87a406$export$971b6134229768db,
                headerComponentElements: {
                    headerLabel: $e21399041d87a406$var$i18n.title,
                    HeaderAfterIconElement: $e21399041d87a406$export$6dd63ee87c66410
                },
                BodyComponent: $e21399041d87a406$export$ba7f11c5ef95fe05,
                FooterComponent: $e21399041d87a406$export$11e48a44da8fc06e,
                closeOptions: {
                    onPanelClose: $e21399041d87a406$export$c60311a397544f15
                }
            }, "push");
        };
        $[0] = showObjectSidebar;
        $[1] = t0;
    } else t0 = $[1];
    const showSpaceSuggestionReviewPanel = t0;
    const t1 = isObjectSidebarShown && panel?.id === $e21399041d87a406$export$971b6134229768db;
    let t2;
    if ($[2] !== showSpaceSuggestionReviewPanel || $[3] !== t1) {
        t2 = {
            isSpaceSuggestionReviewPanelShown: t1,
            showSpaceSuggestionReviewPanel: showSpaceSuggestionReviewPanel
        };
        $[2] = showSpaceSuggestionReviewPanel;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
function $e21399041d87a406$export$ef25d91c3cd2ccfc(t0) {
    const $ = (0, $frIzR.c)(10);
    const { onClosePanel: onClosePanel, onApprove: onApprove } = t0;
    const state = $e21399041d87a406$export$882db99fc7554945();
    let t1;
    if ($[0] !== onClosePanel) {
        t1 = ()=>{
            $e21399041d87a406$export$c60311a397544f15();
            onClosePanel();
        };
        $[0] = onClosePanel;
        $[1] = t1;
    } else t1 = $[1];
    const handleClose = t1;
    let t2;
    if ($[2] !== handleClose || $[3] !== onApprove) {
        t2 = (acceptedActionStepIds, declinedActionStepIds)=>{
            onApprove(acceptedActionStepIds, declinedActionStepIds);
            handleClose();
        };
        $[2] = handleClose;
        $[3] = onApprove;
        $[4] = t2;
    } else t2 = $[4];
    const handleApprove = t2;
    if (state === null) return null;
    let t3;
    if ($[5] !== handleApprove || $[6] !== handleClose || $[7] !== state.item.rawSuggestion || $[8] !== state.item.timestamp) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b77336ff8374f0f7$export$4dbccbfafc528199), {
            rawSuggestion: state.item.rawSuggestion,
            timestamp: state.item.timestamp,
            onClose: handleClose,
            onCancel: handleClose,
            onApprove: handleApprove,
            isEmbedded: true
        });
        $[5] = handleApprove;
        $[6] = handleClose;
        $[7] = state.item.rawSuggestion;
        $[8] = state.item.timestamp;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
}


function $39ab054bc99062f4$export$3974e4a17f8cfed1(t0) {
    const $ = (0, $frIzR.c)(27);
    const { items: items, onReview: onReview, onApprove: onApprove, onReject: onReject, onPanelApprove: onPanelApprove } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isSpaceSuggestionReviewPanelShown: isSpaceSuggestionReviewPanelShown, showSpaceSuggestionReviewPanel: showSpaceSuggestionReviewPanel } = (0, $e21399041d87a406$export$2738c5b277b0dcc0)();
    const reviewPanelState = (0, $e21399041d87a406$export$882db99fc7554945)();
    const selectedItem = isSpaceSuggestionReviewPanelShown ? reviewPanelState?.item ?? null : null;
    let t1;
    if ($[0] !== onPanelApprove || $[1] !== onReview || $[2] !== showSpaceSuggestionReviewPanel) {
        t1 = (item)=>{
            showSpaceSuggestionReviewPanel(item, (accepted, declined)=>{
                onPanelApprove?.(item, accepted, declined);
            });
            onReview?.(item);
        };
        $[0] = onPanelApprove;
        $[1] = onReview;
        $[2] = showSpaceSuggestionReviewPanel;
        $[3] = t1;
    } else t1 = $[3];
    const handleReview = t1;
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage($39ab054bc99062f4$var$i18n.needsReviewTitle);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "small"
        }, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== items.length) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), null, items.length);
        $[8] = items.length;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $39ab054bc99062f4$var$styles.title
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, t3, t4));
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== handleReview || $[14] !== items || $[15] !== onApprove || $[16] !== onReject || $[17] !== selectedItem) {
        let t7;
        if ($[19] !== handleReview || $[20] !== onApprove || $[21] !== onReject || $[22] !== selectedItem) {
            t7 = (item_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($39ab054bc99062f4$var$ReviewCard, {
                    key: item_0.id,
                    item: item_0,
                    onReview: handleReview,
                    isSelected: selectedItem === item_0,
                    onApprove: onApprove,
                    onReject: onReject
                });
            $[19] = handleReview;
            $[20] = onApprove;
            $[21] = onReject;
            $[22] = selectedItem;
            $[23] = t7;
        } else t7 = $[23];
        t6 = items.map(t7);
        $[13] = handleReview;
        $[14] = items;
        $[15] = onApprove;
        $[16] = onReject;
        $[17] = selectedItem;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[24] !== t5 || $[25] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, t5, t6));
        $[24] = t5;
        $[25] = t6;
        $[26] = t7;
    } else t7 = $[26];
    return t7;
}
function $39ab054bc99062f4$var$ReviewCard(t0) {
    const $ = (0, $frIzR.c)(12);
    const { item: item, onReview: onReview, onApprove: onApprove, onReject: onReject, isSelected: isSelected } = t0;
    let t1;
    if ($[0] !== item || $[1] !== onApprove) {
        t1 = ()=>onApprove?.(item);
        $[0] = item;
        $[1] = onApprove;
        $[2] = t1;
    } else t1 = $[2];
    const handleApprove = t1;
    let t2;
    if ($[3] !== item || $[4] !== onReject) {
        t2 = ()=>onReject?.(item);
        $[3] = item;
        $[4] = onReject;
        $[5] = t2;
    } else t2 = $[5];
    const handleReject = t2;
    let t3;
    if ($[6] !== handleApprove || $[7] !== handleReject || $[8] !== isSelected || $[9] !== item || $[10] !== onReview) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fcb9b1196ffd7d14$export$5864b77b647e728c), {
            item: item,
            onReview: onReview,
            onApprove: handleApprove,
            onReject: handleReject,
            isSelected: isSelected
        });
        $[6] = handleApprove;
        $[7] = handleReject;
        $[8] = isSelected;
        $[9] = item;
        $[10] = onReview;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
}
const $39ab054bc99062f4$var$styles = {
    title: "_otyr1b66"
};
const $39ab054bc99062f4$var$i18n = (0, $aXWIB.defineMessages)({
    needsReviewTitle: {
        id: "space-suggestions.needs-review.section-title",
        defaultMessage: "Needs review"
    }
});

















function $7a11a659efbcfeb8$export$e2965c80b64d68ac() {
    const $ = (0, $frIzR.c)(4);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($7a11a659efbcfeb8$var$i18n.noSuggestionsFound);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $7a11a659efbcfeb8$var$styles.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, t0));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
}
const $7a11a659efbcfeb8$var$i18n = (0, $aXWIB.defineMessages)({
    noSuggestionsFound: {
        id: "space-suggestions.no-suggestions-found",
        defaultMessage: "No suggestions found"
    }
});
const $7a11a659efbcfeb8$var$styles = {
    container: "_1q511ejb _85i51ejb _bozg1ejb _y4ti1ejb _y3gn1h6o"
};

























var $82gXq = parcelRequire("82gXq");

















var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");











var $kZ5GD = parcelRequire("kZ5GD");




function $4113ad3f42982536$export$127a1cc3c5ba7db0(t0) {
    const $ = (0, $frIzR.c)(54);
    const { type: type, onToggle: onToggle, onSetApproval: onSetApproval, onAddTrigger: onAddTrigger } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsExpanded($4113ad3f42982536$var$_temp);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleToggleExpand = t1;
    let t2;
    if ($[1] !== onToggle || $[2] !== type.id) {
        t2 = ()=>{
            onToggle(type.id);
        };
        $[1] = onToggle;
        $[2] = type.id;
        $[3] = t2;
    } else t2 = $[3];
    const handleToggleEnabled = t2;
    let t3;
    if ($[4] !== onSetApproval || $[5] !== type.id) {
        t3 = ()=>{
            onSetApproval(type.id, "review");
        };
        $[4] = onSetApproval;
        $[5] = type.id;
        $[6] = t3;
    } else t3 = $[6];
    const handleSelectReview = t3;
    let t4;
    if ($[7] !== onSetApproval || $[8] !== type.id) {
        t4 = ()=>{
            onSetApproval(type.id, "auto");
        };
        $[7] = onSetApproval;
        $[8] = type.id;
        $[9] = t4;
    } else t4 = $[9];
    const handleSelectAuto = t4;
    let t5;
    if ($[10] !== onAddTrigger || $[11] !== type.id) {
        t5 = ()=>{
            onAddTrigger(type.id);
        };
        $[10] = onAddTrigger;
        $[11] = type.id;
        $[12] = t5;
    } else t5 = $[12];
    const handleAddTrigger = t5;
    const t6 = isExpanded ? $4113ad3f42982536$var$i18n.collapseCardLabel : $4113ad3f42982536$var$i18n.expandCardLabel;
    let t7;
    if ($[13] !== formatMessage || $[14] !== t6 || $[15] !== type.title) {
        t7 = formatMessage(t6, {
            title: type.title
        });
        $[13] = formatMessage;
        $[14] = t6;
        $[15] = type.title;
        $[16] = t7;
    } else t7 = $[16];
    const expandLabel = t7;
    const approvalGroupName = `approval-${type.id}`;
    const t8 = `setting-card-${type.id}`;
    let t9;
    if ($[17] !== type.title) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "bold"
        }, type.title);
        $[17] = type.title;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== type.description) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, type.description);
        $[19] = type.description;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10 || $[22] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, t9, t10);
        $[21] = t10;
        $[22] = t9;
        $[23] = t11;
    } else t11 = $[23];
    const t12 = type.enabled;
    let t13;
    if ($[24] !== formatMessage || $[25] !== type.title) {
        t13 = formatMessage($4113ad3f42982536$var$i18n.toggleLabel, {
            title: type.title
        });
        $[24] = formatMessage;
        $[25] = type.title;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== handleToggleEnabled || $[28] !== t13 || $[29] !== type.enabled) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
            isChecked: t12,
            onChange: handleToggleEnabled,
            label: t13
        });
        $[27] = handleToggleEnabled;
        $[28] = t13;
        $[29] = type.enabled;
        $[30] = t14;
    } else t14 = $[30];
    const t15 = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    let t16;
    if ($[31] !== expandLabel || $[32] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: t15,
            label: expandLabel,
            onClick: handleToggleExpand,
            isTooltipDisabled: false
        });
        $[31] = expandLabel;
        $[32] = t15;
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== t14 || $[35] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, t14, t16);
        $[34] = t14;
        $[35] = t16;
        $[36] = t17;
    } else t17 = $[36];
    let t18;
    if ($[37] !== t11 || $[38] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "start",
            spread: "space-between",
            space: "space.200"
        }, t11, t17);
        $[37] = t11;
        $[38] = t17;
        $[39] = t18;
    } else t18 = $[39];
    let t19;
    if ($[40] !== approvalGroupName || $[41] !== formatMessage || $[42] !== handleAddTrigger || $[43] !== handleSelectAuto || $[44] !== handleSelectReview || $[45] !== isExpanded || $[46] !== type.approval || $[47] !== type.id || $[48] !== type.triggers) {
        t19 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $4113ad3f42982536$var$styles.expandedBody,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $4113ad3f42982536$var$styles.subSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            spread: "space-between",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "bold"
        }, formatMessage($4113ad3f42982536$var$i18n.triggersLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
            label: formatMessage($4113ad3f42982536$var$i18n.addTriggerLabel),
            onClick: handleAddTrigger,
            isTooltipDisabled: false,
            testId: `setting-card-${type.id}-add-trigger`
        })), type.triggers.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, formatMessage($4113ad3f42982536$var$i18n.noTriggers)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, type.triggers.map($4113ad3f42982536$var$_temp2)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $4113ad3f42982536$var$styles.subSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "bold"
        }, formatMessage($4113ad3f42982536$var$i18n.approvalLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
            name: approvalGroupName,
            value: "review",
            isChecked: type.approval === "review",
            onChange: handleSelectReview,
            label: formatMessage($4113ad3f42982536$var$i18n.approvalReviewLabel)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $4113ad3f42982536$var$styles.radioHelper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage($4113ad3f42982536$var$i18n.approvalReviewDescription)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
            name: approvalGroupName,
            value: "auto",
            isChecked: type.approval === "auto",
            onChange: handleSelectAuto,
            label: formatMessage($4113ad3f42982536$var$i18n.approvalAutoLabel)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $4113ad3f42982536$var$styles.radioHelper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage($4113ad3f42982536$var$i18n.approvalAutoDescription))))))));
        $[40] = approvalGroupName;
        $[41] = formatMessage;
        $[42] = handleAddTrigger;
        $[43] = handleSelectAuto;
        $[44] = handleSelectReview;
        $[45] = isExpanded;
        $[46] = type.approval;
        $[47] = type.id;
        $[48] = type.triggers;
        $[49] = t19;
    } else t19 = $[49];
    let t20;
    if ($[50] !== t18 || $[51] !== t19 || $[52] !== t8) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $4113ad3f42982536$var$styles.card,
            testId: t8
        }, t18, t19);
        $[50] = t18;
        $[51] = t19;
        $[52] = t8;
        $[53] = t20;
    } else t20 = $[53];
    return t20;
}
function $4113ad3f42982536$var$_temp2(trigger, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        key: index,
        size: "small"
    }, trigger);
}
function $4113ad3f42982536$var$_temp(prev) {
    return !prev;
}
const $4113ad3f42982536$var$styles = {
    card: "_2rkopb1k _189ee4h9 _1dqonqa1 _1h6d1l7x _1q51pxbi _85i5pxbi _bozgpxbi _y4tipxbi _bfhkvuon",
    expandedBody: "_1pfhpxbi",
    subSection: "_2rkopb1k _1q51pxbi _85i5pxbi _bozgpxbi _y4tipxbi _bfhkhfxm",
    radioHelper: "_bozg1ejb"
};
const $4113ad3f42982536$var$i18n = (0, $aXWIB.defineMessages)({
    toggleLabel: {
        id: "space-suggestions.setting-card.toggle-label",
        defaultMessage: "Enable {title}"
    },
    expandCardLabel: {
        id: "space-suggestions.setting-card.expand-label",
        defaultMessage: "Expand {title} settings"
    },
    collapseCardLabel: {
        id: "space-suggestions.setting-card.collapse-label",
        defaultMessage: "Collapse {title} settings"
    },
    triggersLabel: {
        id: "space-suggestions.setting-card.triggers-label",
        defaultMessage: "Triggers"
    },
    addTriggerLabel: {
        id: "space-suggestions.setting-card.add-trigger-label",
        defaultMessage: "Add trigger"
    },
    noTriggers: {
        id: "space-suggestions.setting-card.no-triggers",
        defaultMessage: "No triggers configured"
    },
    approvalLabel: {
        id: "space-suggestions.setting-card.approval-label",
        defaultMessage: "Approval"
    },
    approvalReviewLabel: {
        id: "space-suggestions.setting-card.approval-review-label",
        defaultMessage: "Require review"
    },
    approvalReviewDescription: {
        id: "space-suggestions.setting-card.approval-review-description",
        defaultMessage: "Require approval before updating content"
    },
    approvalAutoLabel: {
        id: "space-suggestions.setting-card.approval-auto-label",
        defaultMessage: "Automatic"
    },
    approvalAutoDescription: {
        id: "space-suggestions.setting-card.approval-auto-description",
        defaultMessage: "Make updates to content automatically"
    }
});


const $73599e1b34c1b442$var$SEED_TYPES = [
    {
        id: 'group-related-pages',
        title: 'Group related pages',
        description: 'Create a new sub-folder for a clear content cluster',
        enabled: true,
        approval: 'review',
        triggers: [
            'Daily at 9am'
        ]
    },
    {
        id: 'rename-for-consistency',
        title: 'Rename for consistency',
        description: 'Recommend better names for pages and folders',
        enabled: true,
        approval: 'review',
        triggers: []
    },
    {
        id: 'auto-linking',
        title: 'Auto linking',
        description: 'Finds related pages in the space, links them together',
        enabled: true,
        approval: 'review',
        triggers: []
    }
];
function $73599e1b34c1b442$export$7d05e0deed78c249() {
    const $ = (0, $frIzR.c)(37);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [enableSuggestions, setEnableSuggestions] = (0, $42omo.useState)(true);
    const [recommendationTypes, setRecommendationTypes] = (0, $42omo.useState)($73599e1b34c1b442$var$SEED_TYPES);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            setEnableSuggestions($73599e1b34c1b442$var$_temp);
        };
        $[0] = t0;
    } else t0 = $[0];
    const handleToggleEnableSuggestions = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (id)=>{
            setRecommendationTypes((prev_0)=>prev_0.map((type)=>type.id === id ? {
                        ...type,
                        enabled: !type.enabled
                    } : type));
        };
        $[1] = t1;
    } else t1 = $[1];
    const handleToggleType = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id_0, mode)=>{
            setRecommendationTypes((prev_1)=>prev_1.map((type_0)=>type_0.id === id_0 ? {
                        ...type_0,
                        approval: mode
                    } : type_0));
        };
        $[2] = t2;
    } else t2 = $[2];
    const handleSetApproval = t2;
    const handleAddTrigger = $73599e1b34c1b442$var$_temp2;
    let t3;
    if ($[3] !== formatMessage) {
        t3 = formatMessage($73599e1b34c1b442$var$i18n.enableSuggestionsLabel);
        $[3] = formatMessage;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "bold"
        }, t3);
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== formatMessage) {
        t5 = formatMessage($73599e1b34c1b442$var$i18n.enableSuggestionsDescription);
        $[7] = formatMessage;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, t5);
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t4 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, t4, t6);
        $[11] = t4;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== formatMessage) {
        t8 = formatMessage($73599e1b34c1b442$var$i18n.enableSuggestionsLabel);
        $[14] = formatMessage;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== enableSuggestions || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
            isChecked: enableSuggestions,
            onChange: handleToggleEnableSuggestions,
            label: t8,
            testId: "space-suggestions-settings-enable-toggle"
        });
        $[16] = enableSuggestions;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== t7 || $[20] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "start",
            spread: "space-between",
            space: "space.200"
        }, t7, t9));
        $[19] = t7;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== formatMessage) {
        t11 = formatMessage($73599e1b34c1b442$var$i18n.smartRecommendationTypesHeading);
        $[22] = formatMessage;
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $73599e1b34c1b442$var$styles.sectionHeading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "small"
        }, t11));
        $[24] = t11;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== recommendationTypes) {
        let t14;
        if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
            t14 = (type_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4113ad3f42982536$export$127a1cc3c5ba7db0), {
                    key: type_1.id,
                    type: type_1,
                    onToggle: handleToggleType,
                    onSetApproval: handleSetApproval,
                    onAddTrigger: handleAddTrigger
                });
            $[28] = t14;
        } else t14 = $[28];
        t13 = recommendationTypes.map(t14);
        $[26] = recommendationTypes;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[29] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, t13);
        $[29] = t13;
        $[30] = t14;
    } else t14 = $[30];
    let t15;
    if ($[31] !== t12 || $[32] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150"
        }, t12, t14);
        $[31] = t12;
        $[32] = t14;
        $[33] = t15;
    } else t15 = $[33];
    let t16;
    if ($[34] !== t10 || $[35] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.300",
            testId: "space-suggestions-settings"
        }, t10, t15);
        $[34] = t10;
        $[35] = t15;
        $[36] = t16;
    } else t16 = $[36];
    return t16;
}
function $73599e1b34c1b442$var$_temp2(_id) {}
function $73599e1b34c1b442$var$_temp(prev) {
    return !prev;
}
const $73599e1b34c1b442$var$styles = {
    sectionHeading: "_6rth1b66"
};
const $73599e1b34c1b442$var$i18n = (0, $aXWIB.defineMessages)({
    enableSuggestionsLabel: {
        id: "space-suggestions.settings.enable-suggestions-label",
        defaultMessage: "Enable suggestions"
    },
    enableSuggestionsDescription: {
        id: "space-suggestions.settings.enable-suggestions-description",
        defaultMessage: "Choose whether you want smart recommendations and agent activity to be visible"
    },
    smartRecommendationTypesHeading: {
        id: "space-suggestions.settings.smart-recommendation-types-heading",
        defaultMessage: "Smart recommendation types"
    }
});


const $ed4520496c03f0d5$var$getActionStepIds = (item)=>{
    const actionStepIds = [];
    for (const action of item.rawSuggestion.actions ?? [])if (action.actionStepId) actionStepIds.push(action.actionStepId);
    return actionStepIds;
};
function $ed4520496c03f0d5$var$SpaceSuggestionsComponent({ spaceKey: spaceKey, flags: flags }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const objectSidebarActions = (0, $aWwYt.useObjectSidebarActions)();
    const objectSidebarActionsRef = (0, $42omo.useRef)(objectSidebarActions);
    objectSidebarActionsRef.current = objectSidebarActions;
    const { suggestions: suggestions, isLoading: isLoading, error: error, refetch: refetch } = (0, $498957231e78a7c6$export$389535f4489ece32)(spaceKey);
    const { run: run, isRunning: isRunning, error: runError } = (0, $d5471619bea93e71$export$8bbb7994e59d093c)(spaceKey);
    const { recordDecision: recordDecision } = (0, $3e2deca241a656e1$export$c8ee8ca7852adba0)(spaceKey);
    // Suggestions the user has approved or rejected this session, tracked by
    // suggestion id. The card is hidden immediately by filtering it out of
    // `reviewItems` (optimistic UI); a failed decision restores the id and brings
    // the card back.
    const [removedIds, setRemovedIds] = (0, $42omo.useState)(()=>new Set());
    // The suggestion currently selected in the list. Reset on a fresh run.
    const [selectedSuggestionId, setSelectedSuggestionId] = (0, $42omo.useState)(null);
    // Guards against `setState` after unmount: the decision call fires on click
    // and may resolve after the user has navigated away.
    const mountedRef = (0, $42omo.useRef)(true);
    // Which body view is currently shown:
    // - 'list': the default Needs review / suggestions list (the previous behavior).
    // - 'settings': the Knowledge curator settings view, toggled via the Settings icon.
    const [view, setView] = (0, $42omo.useState)('list');
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            (0, $e21399041d87a406$export$c60311a397544f15)();
            objectSidebarActionsRef.current.hideObjectSidebarByPanelId((0, $e21399041d87a406$export$971b6134229768db));
        };
    }, [
        spaceKey
    ]);
    const goToSettings = (0, $42omo.useCallback)(()=>{
        (0, $e21399041d87a406$export$c60311a397544f15)();
        objectSidebarActions.hideObjectSidebarByPanelId((0, $e21399041d87a406$export$971b6134229768db));
        setView('settings');
    }, [
        objectSidebarActions
    ]);
    const goToList = (0, $42omo.useCallback)(()=>{
        setView('list');
    }, []);
    const handleLaunch = (0, $42omo.useCallback)(async ()=>{
        try {
            await run();
            await refetch();
            // A fresh run regenerates the suggestion set, so previous session-only
            // removals no longer apply.
            setRemovedIds(new Set());
            setSelectedSuggestionId(null);
        } catch  {
        // The run and fetch hooks own their error states; this prevents an unhandled rejection.
        }
    }, [
        refetch,
        run
    ]);
    // Shared submit path for both approve and reject. Optimistically removes the
    // card, then fires the decision to the backend immediately. On success a basic
    // auto-dismiss confirmation flag is shown; on failure the card is restored and
    // an error flag is shown. The success flag is shown only after the call
    // succeeds so a failed call never shows a contradictory confirmation + error.
    const submitDecision = (0, $42omo.useCallback)((item, decision, flagTitle)=>{
        setRemovedIds((prev)=>new Set(prev).add(item.id));
        (async ()=>{
            try {
                await recordDecision(item.id, decision); // TODO(DISCO follow-up): refresh the space page tree once the per-action
                // contentId mapping is defined — publish OutboundPageTreeMessage.ContentUpdated
                // via @confluence/page-tree-refresh-state-container.
                if (!mountedRef.current) return;
                flags.showSuccessFlag({
                    id: `space-suggestion-decision-${item.id}`,
                    title: flagTitle,
                    isAutoDismiss: true
                });
            } catch  {
                // Skip UI updates if we've already unmounted to avoid setting state on
                // an unmounted component.
                if (!mountedRef.current) return;
                setRemovedIds((prev_0)=>{
                    const next = new Set(prev_0);
                    next.delete(item.id);
                    return next;
                });
                flags.showErrorFlag({
                    id: `space-suggestion-decision-error-${item.id}`,
                    title: formatMessage($ed4520496c03f0d5$var$i18n.decisionErrorTitle),
                    description: formatMessage($ed4520496c03f0d5$var$i18n.decisionErrorDescription),
                    isAutoDismiss: true
                });
            }
        })();
    }, [
        recordDecision,
        flags,
        formatMessage
    ]);
    const handleApprove = (0, $42omo.useCallback)((item_0)=>{
        createEvent({
            type: 'sendUIEvent',
            data: {
                source: 'spaceSuggestionsScreen',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spaceSuggestionApprove'
            }
        }).fire();
        submitDecision(item_0, {
            acceptedActionStepIds: $ed4520496c03f0d5$var$getActionStepIds(item_0),
            declinedActionStepIds: []
        }, formatMessage($ed4520496c03f0d5$var$i18n.approvedFlagTitle));
    }, [
        createEvent,
        formatMessage,
        submitDecision
    ]);
    const handleReject = (0, $42omo.useCallback)((item_1)=>{
        createEvent({
            type: 'sendUIEvent',
            data: {
                source: 'spaceSuggestionsScreen',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spaceSuggestionReject'
            }
        }).fire();
        submitDecision(item_1, {
            acceptedActionStepIds: [],
            declinedActionStepIds: $ed4520496c03f0d5$var$getActionStepIds(item_1)
        }, formatMessage($ed4520496c03f0d5$var$i18n.rejectedFlagTitle));
    }, [
        createEvent,
        formatMessage,
        submitDecision
    ]);
    const handlePanelApprove = (0, $42omo.useCallback)((item_2, acceptedActionStepIds, declinedActionStepIds)=>{
        createEvent({
            type: 'sendUIEvent',
            data: {
                source: 'spaceSuggestionsScreen',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spaceSuggestionPanelApprove'
            }
        }).fire();
        submitDecision(item_2, {
            acceptedActionStepIds: acceptedActionStepIds,
            declinedActionStepIds: declinedActionStepIds
        }, formatMessage($ed4520496c03f0d5$var$i18n.approvedFlagTitle));
    }, [
        createEvent,
        formatMessage,
        submitDecision
    ]); // Mark unmounted so in-flight decision callbacks don't touch state afterwards.
    // Set `true` on mount as well so a StrictMode remount (dev mount→unmount→mount)
    // doesn't leave the ref stuck at `false` after the first cleanup runs.
    (0, $42omo.useEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const reviewItems = (0, $42omo.useMemo)(()=>// Single pass: skip removed (approved/rejected) suggestions while mapping.
        suggestions.reduce((items, suggestion)=>{
            if (!removedIds.has(suggestion.id)) items.push({
                id: suggestion.id,
                summary: suggestion.title,
                rawSuggestion: suggestion,
                timestamp: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                    date: suggestion.createdAt
                })
            });
            return items;
        }, []), [
        suggestions,
        removedIds
    ]);
    const isSettingsEnabled = (0, $1xpoY.default).getBoolean('confluence-space-suggestion-settings', false);
    const isSettingsView = isSettingsEnabled && view === 'settings';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ed4520496c03f0d5$var$styles.page
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ed4520496c03f0d5$var$styles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large"
    }, formatMessage($ed4520496c03f0d5$var$i18n.pageTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.075"
    }, !isSettingsView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($lOHzS))),
        onClick: handleLaunch,
        isLoading: isRunning,
        isDisabled: isLoading
    }, formatMessage($ed4520496c03f0d5$var$i18n.launchButton)), isSettingsEnabled && (isSettingsView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($ed4520496c03f0d5$var$i18n.backButtonLabel),
        appearance: "subtle",
        isTooltipDisabled: false,
        onClick: goToList,
        testId: "space-suggestions-back-button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))),
        label: formatMessage($ed4520496c03f0d5$var$i18n.settingsLabel),
        appearance: "subtle",
        isTooltipDisabled: false,
        onClick: goToSettings,
        testId: "space-suggestions-settings-button"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ed4520496c03f0d5$var$styles.gridDefault
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ed4520496c03f0d5$var$styles.mainContent
    }, isSettingsView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $73599e1b34c1b442$export$7d05e0deed78c249), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, runError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        role: "alert",
        testId: "space-suggestions-run-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($ed4520496c03f0d5$var$i18n.runError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        testId: "space-suggestions-run-error-cause"
    }, runError.message)), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        "aria-live": "polite",
        testId: "space-suggestions-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($ed4520496c03f0d5$var$i18n.loading))), !isLoading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        role: "alert",
        testId: "space-suggestions-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($ed4520496c03f0d5$var$i18n.error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        testId: "space-suggestions-error-cause"
    }, error.message)), !isLoading && !error && reviewItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7a11a659efbcfeb8$export$e2965c80b64d68ac), null), !isLoading && !error && reviewItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39ab054bc99062f4$export$3974e4a17f8cfed1), {
        items: reviewItems,
        onApprove: handleApprove,
        onReject: handleReject,
        onPanelApprove: handlePanelApprove,
        selectedItemId: selectedSuggestionId ?? undefined
    })))));
}
const $ed4520496c03f0d5$export$af3e35e229e01d1e = (0, $7aRa9.withFlags)($ed4520496c03f0d5$var$SpaceSuggestionsComponent);
const $ed4520496c03f0d5$var$i18n = (0, $aXWIB.defineMessages)({
    pageTitle: {
        id: "space-suggestions.page.knowledge-curator-title",
        defaultMessage: "Knowledge curator"
    },
    launchButton: {
        id: "space-suggestions.page.launch-button",
        defaultMessage: "Launch"
    },
    settingsLabel: {
        id: "space-suggestions.page.settings-button-label",
        defaultMessage: "Go to settings"
    },
    backButtonLabel: {
        id: "space-suggestions.page.back-button-label",
        defaultMessage: "Back to suggestions"
    },
    loading: {
        id: "space-suggestions.page.loading",
        defaultMessage: "Loading\u2026"
    },
    error: {
        id: "space-suggestions.page.error",
        defaultMessage: "Something went wrong while loading suggestions. Please try again later."
    },
    approvedFlagTitle: {
        id: "space-suggestions.page.approved-flag-title",
        defaultMessage: "Suggestion approved"
    },
    decisionErrorTitle: {
        id: "space-suggestions.page.decision-error-title",
        defaultMessage: "Couldn't save your decision"
    },
    decisionErrorDescription: {
        id: "space-suggestions.page.decision-error-description",
        defaultMessage: "Please try again."
    },
    rejectedFlagTitle: {
        id: "space-suggestions.page.rejected-flag-title",
        defaultMessage: "Suggestion rejected"
    },
    runError: {
        id: "space-suggestions.page.run-error",
        defaultMessage: "Something went wrong while running Space Organizer. Please try again later."
    }
});
const $ed4520496c03f0d5$var$styles = {
    page: "_1q511ejb _85i51ejb _bozg1ejb _y4ti1ejb",
    header: "_otyr1ejb",
    mainContent: "_1ul9idpf",
    gridDefault: "_1e0c11p5 _yv0ehkll"
};


parcelRequire("crTA1");


const $2593d4b17876c400$export$a3041cafa4dd68cd = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_space_organizer', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed4520496c03f0d5$export$af3e35e229e01d1e), {
        spaceKey: spaceKey
    }));
};
$2593d4b17876c400$export$a3041cafa4dd68cd.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_space_organizer', 'isEnabled', false)) return false;
    return {
        Screen: {
            screenEvent: {
                name: 'spaceSuggestionsScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    };
};


/* eslint react/prop-types:0 */ 









const $9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EYcHq",
    name: "SpaceSettingsDataClassificationRouteComponent",
    loader: ()=>(parcelRequire("jOUeC"))
});
const $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent, {
        spaceKey: spaceKey
    });
$9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsDataClassification',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $0db33795337c2a26$var$SpaceSettingsWatermarkConfigurationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oooFg",
    name: "SpaceSettingsWatermarkConfigurationRouteComponent",
    loader: ()=>(parcelRequire("amnPv"))
});
const $0db33795337c2a26$export$2bb331cf926ecae2 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0db33795337c2a26$var$SpaceSettingsWatermarkConfigurationRouteComponent, {
        spaceKey: spaceKey
    });
$0db33795337c2a26$export$2bb331cf926ecae2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsWatermarkConfiguration',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });






var $bDjCi = parcelRequire("bDjCi");

function $e84d6ad8839aa142$export$355693d248632c9a() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $bDjCi.CALENDAR_CONTEXT).MY_CALENDARS
    });
}
$e84d6ad8839aa142$export$355693d248632c9a.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'myCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey
        }
    });








function $d017e5de5f44817e$export$6443958a7203f769() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $bDjCi.CALENDAR_CONTEXT).MULTIPLE_CALENDARS
    });
}
$d017e5de5f44817e$export$6443958a7203f769.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'multipleCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey
        }
    });








function $d3bef7a856c272ba$export$5984a4822491c8de() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $bDjCi.CALENDAR_CONTEXT).EMBEDDED_MULTIPLE_CALENDARS
    });
}
$d3bef7a856c272ba$export$5984a4822491c8de.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'embeddedMultipleCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });


/* eslint-disable react/prop-types */ 












const $116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "tO6zv",
    name: "SpaceTeamCalendarsRouteComponent",
    loader: ()=>(parcelRequire("iAxzI"))
});
const $116a232d5237eb91$export$c1ba174e1a668b1a = ({ params: { subCalendarId: subCalendarId } })=>{
    const calendarContext = subCalendarId ? (0, $bDjCi.CALENDAR_CONTEXT).SPACE_SUBCALENDAR : (0, $bDjCi.CALENDAR_CONTEXT).SPACE_CALENDARS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent, {
        subCalendarId: subCalendarId,
        calendarContext: calendarContext
    });
};
$116a232d5237eb91$export$c1ba174e1a668b1a.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>{
    return {
        Screen: {
            screenEvent: {
                name: 'spaceTeamCalendarsScreen',
                id: spaceKey,
                attributes: {
                    isSingleCalendar: !!subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    };
};








const $40c2c72cc1663e14$export$b6ba0c14cb68dffc = ({ params: { subCalendarId: subCalendarId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $bDjCi.CALENDAR_CONTEXT).EMBEDDED_SUBCALENDAR,
        subCalendarId: subCalendarId
    });
};
$40c2c72cc1663e14$export$b6ba0c14cb68dffc.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceEmbeddedSubcalendarScreen',
                id: spaceKey,
                attributes: {
                    subCalendarId: subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });












const $8089a5c0318e4300$export$d299494231e51197 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XYKgm",
    name: "LazySpaceDirectory",
    loader: async ()=>(await (parcelRequire("fFNVl"))).SpaceDirectory
});


const $6b9376eebbcdd446$export$e2f6c7ec524fdd6a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8089a5c0318e4300$export$d299494231e51197), null);
$6b9376eebbcdd446$export$e2f6c7ec524fdd6a.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceDirectoryScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });





















const $bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EHSjL",
    name: "SpaceSettingsLandingPageRouteComponent",
    loader: ()=>(parcelRequire("l40Ef"))
});
const $bdfe305fbc319d8d$export$b0e13503df86295 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name,
        params: {
            spaceKey: spaceKey,
            tab: 'users'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent, {
        spaceKey: spaceKey
    });
};
$bdfe305fbc319d8d$export$b0e13503df86295.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsLandingPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });








parcelRequire("b1pD4");



var $6O2BV = parcelRequire("6O2BV");





var $1iSzD = parcelRequire("1iSzD");


var $ep3mz = parcelRequire("ep3mz");





var $3d5UI = parcelRequire("3d5UI");





var $7EX8o = parcelRequire("7EX8o");

parcelRequire("4Yv1J");



var $4H46k = parcelRequire("4H46k");


var $9pOEz = parcelRequire("9pOEz");

const $6c697104f01a0e5d$var$EmbeddedSpaceOverview = ({ spaceKey: spaceKey, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7EX8o.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        classicComments: (0, $3ACqI.CommentsSectionLoader),
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        showHeaderButtons: false
    }));
};
const $6c697104f01a0e5d$var$SpaceOverview = ({ spaceKey: spaceKey, onExperienceResolved: onExperienceResolved })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $djZz9.SpaceOverviewSwitcherLoader), {
        spaceKey: spaceKey,
        onExperienceResolved: onExperienceResolved
    });
};
const $6c697104f01a0e5d$export$495cec58911c040d = ({ spaceKey: spaceKey })=>{
    const [contextContentId] = (0, $ep3mz.usePageContentId)();
    const [spaceOverviewExperience, setSpaceOverviewExperience] = (0, $42omo.useState)('unknown');
    const contentId = contextContentId ?? '';
    (0, $42omo.useEffect)(()=>{
        if (!contentId || !(0, $9wGTI.fg)('cc-dlp-ensure-content-id-for-legacy-space-overview')) return;
        (0, $3d5UI.waitForGlobal)({
            listener: 'SpaceOverviewRouteComponent.tsx',
            globalProperty: 'AJS.Meta.set'
        }, ()=>{
            window.AJS.Meta.set('content-id-alt', contentId);
        });
        return ()=>{
            window.AJS?.Meta?.set?.('content-id-alt', undefined);
        };
    }, [
        contentId
    ]);
    const component = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6c697104f01a0e5d$var$EmbeddedSpaceOverview, {
        contentId: contentId,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6c697104f01a0e5d$var$SpaceOverview, {
        spaceKey: spaceKey,
        onExperienceResolved: setSpaceOverviewExperience
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9pOEz.CommentContextWrapper), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), {
        attributes: {
            spaceOverviewExperience: spaceOverviewExperience
        }
    }));
};
var $6c697104f01a0e5d$export$2e2bcd8739ae039 = $6c697104f01a0e5d$export$495cec58911c040d;


const $8290afb66ac54848$export$200c90655ff1c697 = (0, $4lJOK.getSpaceOverviewRoute)((0, $6c697104f01a0e5d$export$495cec58911c040d));








parcelRequire("b1pD4");















const $0b1718e5f1e38843$export$26b856d756d6b8dc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "h8KkD",
    name: "HubRendererLoader",
    loader: async ()=>(await (parcelRequire("f6jYE"))).HubRendererComponent
});








parcelRequire("4Yv1J");









const $f6b27607b6d81126$var$EmbeddedHubRenderer = ({ spaceKey: spaceKey, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7EX8o.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        classicComments: (0, $3ACqI.CommentsSectionLoader),
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        showHeaderButtons: false
    }));
};
const $f6b27607b6d81126$export$964c57d73cd4c096 = ({ spaceKey: spaceKey })=>{
    const [contextContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = contextContentId ?? '';
    const component = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f6b27607b6d81126$var$EmbeddedHubRenderer, {
        contentId: contentId,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0b1718e5f1e38843$export$26b856d756d6b8dc), {
        spaceKey: spaceKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9pOEz.CommentContextWrapper), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null));
};
const $f6b27607b6d81126$export$d8819c37d45ffdfc = (0, $hDf9e.getCompanyHubRoute)((0, $6c697104f01a0e5d$export$495cec58911c040d));


























/**
 * The route "Company Hub settings > Analytics" in the Confluence app.
 * `CompanyHubAnalyticsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute() {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
        featureName: "companyHub"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).ANALYTICS
    });
}
$b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute.NAVIGATION_PARAMS = (_routeMatch, isNav4Enabled)=>{
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = isNav4Enabled ? (0, $lFjPc.COMPANY_HUB_SETTINGS_ID) : (0, $lFjPc.PRODUCT_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubAnalytics'
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_ANALYTICS).name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $b5f6e0dacae3f98e$export$ccf9c625603cc873 = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute);









var $eXODy = parcelRequire("eXODy");








var $hnvzE = parcelRequire("hnvzE");


var $8zMP3 = parcelRequire("8zMP3");


var $2VZOl = parcelRequire("2VZOl");


var $8KbKw = parcelRequire("8KbKw");


var $hQm1C = parcelRequire("hQm1C");


var $eqNP8 = parcelRequire("eqNP8");








var $39rFu = parcelRequire("39rFu");


var $8Hqv7 = parcelRequire("8Hqv7");


var $6gETM = parcelRequire("6gETM");


var $8jRXE = parcelRequire("8jRXE");


var $3gyyc = parcelRequire("3gyyc");

const $6a336fa33a376cf7$var$EditPageLoaderInternal = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader })=>{
    const [prevContentId, setPrevContentId] = (0, $42omo.useState)(contentId);
    const [prevContentType, setPrevContentType] = (0, $42omo.useState)(contentType);
    const { referredFromLivePage: referredFromLivePage } = (0, $39rFu.useEditPageLoadingValues)();
    const { loadEditor: setEditPageLoadingValues } = (0, $39rFu.useEditPageLoadingActions)();
    const [livePageTransitionHandled, setLivePageTransitionHandled] = (0, $42omo.useState)(false);
    // This useEffect allows us to unmount and remount the ClassicEditorContextProvider,
    // NativeCollabLoader, and FullPageEditor when switching from one edit page to another edit page.
    // This is necessary to reset the editor properly for edit -> edit transitions.
    (0, $42omo.useEffect)(()=>{
        setPrevContentId(contentId);
        setLivePageTransitionHandled(false);
    }, [
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        setPrevContentType(contentType);
    }, [
        contentType
    ]);
    // Be careful when modifying this useEffect as this can break live page -> edit page transitions
    // This effect is a temporary solution to address an issue where the editor does not reset properly when navigating from a live page.
    // The editor tends to hold onto state from the previous page, causing problems when switching between pages if a full unmount doesn't occur.
    // This effects resets the editor by force-unmounting it by showing the loading screen when it detects a transition from a live page.
    (0, $42omo.useEffect)(()=>{
        // livePageTransitionHandled is used to prevent the editor from showing the loading screen endlessly
        if (referredFromLivePage && !livePageTransitionHandled) {
            setLivePageTransitionHandled(true);
            // Need to reset this property or it'll be retained when the browser back button is used.
            // In that case, it doesn't go through the flow that sets the value again.
            setEditPageLoadingValues({
                referredFromLivePage: undefined
            });
        }
    }, [
        referredFromLivePage,
        livePageTransitionHandled,
        setEditPageLoadingValues
    ]);
    if (contentId !== prevContentId || contentType !== prevContentType || referredFromLivePage && !livePageTransitionHandled) // isLoading is set to true by a state change, which does not happen immediately after content id changes
    // To make sure loading screen shows up immediately after content id changes, compare new content id with the content id in ref
    // This is smilar to how componentWillUpdate works in a classic react component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
    const EditPageWrapper = ClassicEditorContextProviderLoader ?? (({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "edit-page-default-wrapper"
        }, children));
    return(// @ts-ignore - Property 'isWithinEditor' is missing in type '{ children: Element; }' but required in type '{ children: any; isWithinEditor: any; }'
    // This error was introduced after upgrading to TypeScript 5
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EditPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hQm1C.NativeCollabLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        permissionTokenRefresh: (0, $8KbKw.fetchCollabPermissionToken)(contentId, draftShareId)
    }, (propsFromNativeCollab)=>{
        if (propsFromNativeCollab.subType === 'live' && !propsFromNativeCollab.isOverviewPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.VIEW_PAGE).name,
            params: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        });
        return (0, $3gyyc.isSSRStreaming)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "content-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8jRXE.FullPageEditorLoader), {
            ...propsFromNativeCollab,
            extensionContextProvider: {
                ClassicEditorContextProvider: ClassicEditorContextProviderLoader
            }
        }))) : // This TreeRootForServerPlaceholderWrapper placed here to ensure the proper lookup of the placeholders for
        // SSRed loadables. Due to different component trees between server (EditPageLoader) and client (EditPageLoaderServer)
        // the placeholder ids hierarchy is different. This wrapper terminates the lookup for placeholder ids on the common parent,
        // so it matches on both server and client.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Hqv7.FullCycleRenderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8jRXE.FullPageEditorLoader), {
            ...propsFromNativeCollab,
            extensionContextProvider: {
                ClassicEditorContextProvider: ClassicEditorContextProviderLoader
            }
        })));
    }))));
};
const $6a336fa33a376cf7$export$b6d447abe5222d2c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "edit-page-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a336fa33a376cf7$var$EditPageLoaderInternal, props));
};



var $ak57N = parcelRequire("ak57N");


var $34NZw = parcelRequire("34NZw");


var $5vi32 = parcelRequire("5vi32");














var $cZa7r = parcelRequire("cZa7r");










const $0e80cf500c4229e5$var$EditPageContent = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6a336fa33a376cf7$export$b6d447abe5222d2c), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    });
const $0e80cf500c4229e5$export$5cc0e8d070ec38e9 = ({ params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam }, query: query, pathname: pathname })=>{
    const draftShareId = typeof query?.draftShareId === 'string' ? query.draftShareId : undefined;
    // editRouteTypeParam !== contentType !== pageType
    // editContentType is blog or pages
    // contentType is blogpost or page
    // pageType is blog or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldRedirectCompanyHubEditRoute = isCompanyHub && (0, $1NBp8.COMPANY_HUB_EDIT).pattern !== pathname;
    if (shouldRedirectCompanyHubEditRoute) // The company hub edit route should handle upsell scenarios and other cases
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.COMPANY_HUB_EDIT).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cZa7r.AnnotationsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $3gyyc.isSSRStreaming)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e80cf500c4229e5$var$EditPageContent, {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ak57N.EditPageLoaderServer), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6a336fa33a376cf7$export$b6d447abe5222d2c), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: editRouteTypeParam === 'page',
        isEditPage: true
    })));
};
$0e80cf500c4229e5$export$5cc0e8d070ec38e9.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const isPageLikeContent = editRouteTypeParam === 'pages' || editRouteTypeParam === 'blog';
    const isBlog = editRouteTypeParam === 'blog';
    // editRouteTypeParam !== contentType
    // editRouteTypeParam is blog or pages
    // contentType is blogpost or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    let viewId = (0, $lFjPc.CONTAINER_HOME_ID);
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) viewId = (0, $lFjPc.PRODUCT_HOME_ID);
    else if (isBlog) viewId = (0, $lFjPc.CONTAINER_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                    navdexPointType: (0, $56QzY.END)
                }
            },
            pageState: {
                routeName: routeName,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            navView: viewId,
            spaceKey: spaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: false,
            isViewPage: true,
            isEdit: true
        }
    };
};


const $1f7939e43bf6965f$export$335f265b0f783405 = (0, $hkCxu.getCompanyHubEditRoute)((0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9));



























var $6gbpH = parcelRequire("6gbpH");


var $7f6xB = parcelRequire("7f6xB");


var $cbvYp = parcelRequire("cbvYp");


var $4cOi8 = parcelRequire("4cOi8");





var $eDATL = parcelRequire("eDATL");

const $ca035e1fc91a5c2a$export$b1a4eb0063bc2123 = ({ params: { contentId: contentId, contentType: editRouteTypeParam } })=>{
    const sessionData = (0, $bQm3c.useSessionData)();
    // Don't render until session data is available to prevent context errors
    if (!sessionData) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gbpH.HubEditorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbvYp.ConfluenceDependenciesProvider), {
        mode: (0, $4cOi8.ExtensionMode).EDITOR,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f6xB.HeadingLinksStyleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDATL.default), {
        contentId: contentId,
        product: "CONFLUENCE",
        hasEditPermission: true,
        viewMode: "edit",
        userPreferencesProvider: undefined,
        isLoomPluginEnabled: false,
        editorPluginAIOptions: undefined,
        editorPluginAIDefinitionsEnabled: false,
        editorPluginAIDefinitionsConfig: undefined,
        isDesktop: false,
        contextPanelOptions: undefined,
        getExtensionHeight: undefined,
        __rendererExtensionOptions: undefined,
        PropsProvider: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: editRouteTypeParam === 'page',
        isEditPage: true
    })))));
};
$ca035e1fc91a5c2a$export$b1a4eb0063bc2123.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const contentType = 'page';
    const viewId = (0, $lFjPc.PRODUCT_HOME_ID);
    const screenEventName = 'companyHubEditorScreen';
    const screenIsInSpace = false;
    return {
        Screen: {
            screenEvent: {
                name: screenEventName,
                id: spaceKey,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                    navdexPointType: (0, $56QzY.END),
                    screenIsInSpace: screenIsInSpace
                }
            },
            pageState: {
                routeName: routeName,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType
            },
            showPremiumOnboarding: showPremiumOnboarding
        },
        MainLayout: {
            navView: viewId,
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};


const $437f27e114bb0121$export$29545d7913f7e4d9 = (0, $k1285.getCompanyHubEditorRoute)((0, $ca035e1fc91a5c2a$export$b1a4eb0063bc2123));


















/**
 * The route "Company Hub settings" in the Confluence app.
 * `CompanyHubSettingsRoute` wraps this one to implement the Company Hub pseudo app.
 */ const $dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), null);
$dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute.NAVIGATION_PARAMS = (_routeMatch, isNav4Enabled)=>{
    const navView = isNav4Enabled ? (0, $lFjPc.COMPANY_HUB_SETTINGS_ID) : (0, $lFjPc.PRODUCT_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubSettingsScreen',
                attributes: {
                    // Company Hub hides its space from the user, doesn't refer to its page
                    // as such, is rather presented to the user as "a new surface", and thus
                    // doesn't constitute space usage from the perspective of the user.
                    screenIsInSpace: false
                }
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_SETTINGS).name,
                spaceKey: (0, $cEgMD.getCompanyHubSpaceKey)()
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $dbfb738401d21a8a$export$5df4bb70a888e6ef = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute);

















parcelRequire("crTA1");



const $3ae3b5e6a32b9f05$var$SpacePages = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Mg0yj",
    name: "SpacePages",
    loader: async ()=>(await (parcelRequire("lNzoy"))).SpacePages
});
const $3ae3b5e6a32b9f05$export$64ef8a59e56631d4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ae3b5e6a32b9f05$var$SpacePages, null));
};
$3ae3b5e6a32b9f05$export$64ef8a59e56631d4.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spacePagesScreen',
                attributes: {
                    navigationLayer: 'container',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            disableMinWidth: true
        }
    });








parcelRequire("crTA1");





const $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazySpaceBlogRedirect), null));
$5fbf62dcc2c7f9c7$export$59ba7d1ff575355e.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'blogHomeScreen'
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $604611f3b9c6a1bd$export$6fe611e4bd8a9f83 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "KbMaW",
    name: 'ManagePagesLoader',
    loader: async ()=>{
        return (await (parcelRequire("kvrFT"))).ManagePagesV2;
    }
});






var $lt6Lx = parcelRequire("lt6Lx");




parcelRequire("crTA1");


const $95e685c28d9f350e$export$690ececaf2f5ac01 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lt6Lx.DocumentContentTitle), {
        notFound: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $604611f3b9c6a1bd$export$6fe611e4bd8a9f83), {
        spaceKey: spaceKey
    }));
};
$95e685c28d9f350e$export$690ececaf2f5ac01.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceBulkTools',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1mKe4",
    name: "TemplateMigrationPreviewLoader",
    loader: async ()=>(await (parcelRequire("9bk2S"))).TemplateMigrationPreview
});


const $a310d6589e3c6137$export$2549ad5558b468ce = ({ params: { contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4), {
        templateId: contentId
    });
$a310d6589e3c6137$export$2549ad5558b468ce.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'templateMigrationPreviewScreen'
            },
            pageState: {
                routeName: name,
                contentId: contentId
            }
        },
        MainLayout: false
    });












const $ab6a74840300f72c$export$8cf1c696fd3c0922 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-xoDL",
    name: "TemplateEditorLoader",
    loader: async ()=>{
        const { TemplateEditor: TemplateEditor } = await (parcelRequire("eDS9F"));
        return TemplateEditor;
    }
});


function $db60bab822fccf44$var$getId(params) {
    const { contentId: contentId, pluginKey: pluginKey, moduleKey: moduleKey } = params;
    return !contentId && moduleKey ? `${pluginKey}:${moduleKey}` : contentId;
}
const $db60bab822fccf44$export$b015e9e7191a93bd = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab6a74840300f72c$export$8cf1c696fd3c0922), {
        templateId: id,
        spaceKey: spaceKey
    }));
};
$db60bab822fccf44$export$b015e9e7191a93bd.NAVIGATION_PARAMS = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return {
        Screen: {
            screenEvent: {
                name: 'editTemplatePageScreen',
                id: id || ''
            },
            pageState: {
                contentId: id,
                spaceKey: spaceKey
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    };
};









const $e6c819a73b1c7672$export$70238cd3868b67c9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gd8xC",
    name: "Onboarding",
    loader: async ()=>(await (parcelRequire("7WjJq"))).Onboarding
});






var $4PPzL = parcelRequire("4PPzL");

const $52219feed318a69e$export$329ee42b27a3306e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6c819a73b1c7672$export$70238cd3868b67c9), null));
$52219feed318a69e$export$329ee42b27a3306e.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'onboardingContainerScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: false
    });















const $72fe25ca1dda155a$export$e5cc8897c2b49b25 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "P5sQM",
    name: "ContentHistoryLoader",
    loader: async ()=>(await (parcelRequire("eBhNl"))).ContentHistory
});






const $9c31020ce936d864$export$e63bb7d08a16e003 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "krpYG",
    name: "NewContentHistory",
    loader: async ()=>(await (parcelRequire("lEtIM"))).NewContentHistory
});











const $48c85dee1e05da94$var$parseVersionParam = (value)=>{
    if (!value || Array.isArray(value)) return undefined;
    const parsedValue = parseInt(value, 10);
    return isNaN(parsedValue) ? undefined : parsedValue;
};
const $48c85dee1e05da94$var$ContentHistoryRouteComponent = ({ params: { spaceKey: spaceKey, contentId: contentId }, query: query })=>{
    const version1 = $48c85dee1e05da94$var$parseVersionParam(query?.version1);
    const version2 = $48c85dee1e05da94$var$parseVersionParam(query?.version2);
    return (0, $6mKj3.expValEquals)('confluence_content_history_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c31020ce936d864$export$e63bb7d08a16e003), {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        version1: version1,
        version2: version2
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $72fe25ca1dda155a$export$e5cc8897c2b49b25), {
        spaceKey: spaceKey,
        contentId: contentId,
        stack: "classic"
    });
};
$48c85dee1e05da94$var$ContentHistoryRouteComponent.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, contentSlug: contentSlug } })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    return {
        Screen: {
            screenEvent: {
                name: isCompanyHub ? 'hubHistoryScreen' : 'pageHistoryScreen',
                id: contentId
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: contentSlug
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isCompanyHub ? (0, $lFjPc.COMPANY_HUB_SETTINGS_ID) : (0, $lFjPc.CONTAINER_HOME_ID)
        }
    };
};
const $48c85dee1e05da94$export$e510023ce2e8f364 = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($48c85dee1e05da94$var$ContentHistoryRouteComponent, (route)=>(0, $cEgMD.isCompanyHubSpaceKey)(route?.params?.spaceKey));












const $64e99ecf69e59c34$export$9defecaf7509c9ff = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NjYCL",
    name: "TemplateGalleryLoader",
    loader: async ()=>(await (parcelRequire("bLcV9"))).TemplateGallery
});


const $0f81c6a8d9931e4d$export$e2ed88affe37abdc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64e99ecf69e59c34$export$9defecaf7509c9ff), null);
$0f81c6a8d9931e4d$export$e2ed88affe37abdc.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'templateGalleryScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });









const $eedda2b5abe28404$export$25901255b411dbc4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "hLwu8",
    name: "MacroRendererPageLoader",
    loader: async ()=>(await (parcelRequire("iEUAa"))).MacroRendererPage
});


parcelRequire("4Yv1J");


const $fcdf58a0a381c832$export$29b5dbba9b9e21d8 = ({ params: { contentId: contentId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eedda2b5abe28404$export$25901255b411dbc4), {
        contentId: contentId,
        ContentExtensionsProvider: (0, $f5aR2.ContentExtensionsProvider)
    });
};
$fcdf58a0a381c832$export$29b5dbba9b9e21d8.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'mobileMacroRendererScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                routeName: name,
                contentId: contentId
            }
        },
        MainLayout: false // No navigation layout needed for mobile app view
    });









const $7b810fd40f00ac37$var$MobileAppTakeoverPageLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oLwa7",
    name: "MobileAppTakeoverPageLoader",
    loader: async ()=>(await (parcelRequire("ipfH1"))).MobileAppTakeoverPage
});
const $7b810fd40f00ac37$export$1a98ae7373202607 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b810fd40f00ac37$var$MobileAppTakeoverPageLoader, null);
$7b810fd40f00ac37$export$1a98ae7373202607.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'mobileTakeoverPage'
            }
        },
        MainLayout: false
    });









var $hwzJf = parcelRequire("hwzJf");


var $idSff = parcelRequire("idSff");

const $75f6c666a9c742b2$export$e5707bd7e32dbf9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idSff.SiteHomepageRedirectLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hwzJf.GoToHomeLoader), null));
$75f6c666a9c742b2$export$e5707bd7e32dbf9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'wikiScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });

















const $4625b8b3d160569d$export$48d3d184aade51b1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hwzJf.GoToHomeLoader), null);
$4625b8b3d160569d$export$48d3d184aade51b1.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'homeScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            editorPreloader: (0, $eXODy.getEditorPreloader)
        }
    });











const $92a0e12da2d6b5f0$export$bf305e48a79a981b = {
    attributes: {
        navdexPointType: (0, $56QzY.END)
    }
};


const $c3c08e13adc00b49$export$daeca97aa431dd80 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "blogpost"
    });
$c3c08e13adc00b49$export$daeca97aa431dd80.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });









const $93e08279e521422d$export$92431fd1ef2a3e02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "page"
    });
$93e08279e521422d$export$92431fd1ef2a3e02.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });






var $8MiHL = parcelRequire("8MiHL");





const $2807fe6645e49e0b$export$6a3218472cdf374a = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MiHL.LazyRouteToRightEditor), {
        contentType: "pages",
        contentId: contentId,
        spaceKey: spaceKey
    });
$2807fe6645e49e0b$export$6a3218472cdf374a.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b).attributes,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });











const $cdf2efa932a544ee$export$657999c2675036a8 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MiHL.LazyRouteToRightEditor), {
        contentType: "blog",
        contentId: contentId,
        spaceKey: spaceKey
    });
$cdf2efa932a544ee$export$657999c2675036a8.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'blogpost'
            }
        },
        MainLayout: false
    });













const $9ba53981e2ca7f45$export$a835caedc175b18 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "c8AJW",
    name: "EmbeddedEditPageLoader",
    loader: async ()=>(await (parcelRequire("cJC2l"))).EmbeddedEditPage
});



const $dde5e37bf0f94188$export$a338f76d183c610 = ({ params: { contentId: contentId, spaceKey: spaceKey }, query: { draftShareId: draftShareId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ba53981e2ca7f45$export$a835caedc175b18), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: String(draftShareId),
        contentType: "page"
    }));
$dde5e37bf0f94188$export$a338f76d183c610.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageEmbedScreen',
                id: contentId,
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'page'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });









const $91e544e3fd3704c7$export$bae7b470830e7536 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EbSw2",
    name: "SmartCreatePageEditorLoader",
    loader: async ()=>(await (parcelRequire("iY7Hl"))).SmartCreatePageEditorDataWrapper
});















const $bb42a89ba72dd22d$export$997e52ba9fce325c = ({ params: { contentId: contentId }, query: { sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId } })=>{
    if (!(0, $9wGTI.fg)('aifc_create_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.HOME).toUrl()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91e544e3fd3704c7$export$bae7b470830e7536), {
        contentId: contentId,
        sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId
    }));
};
$bb42a89ba72dd22d$export$997e52ba9fce325c.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageSmartCreateScreen',
                id: contentId,
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'page'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });





const $819b80c2c59a2565$var$AI_PLANNER_BRIDGE_NAVIGATION_PARAMS = {
    Screen: {
        showPremiumOnboarding: false,
        screenEvent: {
            name: 'aiPlannerConfluenceBridgeScreen'
        }
    },
    MainLayout: false,
    BannerContext: {
        includeTopNav: false
    }
};

const $819b80c2c59a2565$export$bb48d26d51801617 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VA3-t",
    name: "AIPlannerConfluenceBridgeRoute",
    loader: async ()=>(await (parcelRequire("gpq9c"))).AIPlannerConfluenceBridgeRoute
});
$819b80c2c59a2565$export$bb48d26d51801617.NAVIGATION_PARAMS = ()=>$819b80c2c59a2565$var$AI_PLANNER_BRIDGE_NAVIGATION_PARAMS;


/* eslint react/prop-types:0 */ 









const $d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xxPa8",
    name: "SpaceSettingsAutomationRouteComponent",
    loader: ()=>(parcelRequire("8xWdd"))
});
const $d6b8391ba067d418$export$3e7656e40361b9c3 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent, {
        spaceKey: spaceKey
    });
$d6b8391ba067d418$export$3e7656e40361b9c3.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingAutomationRoute',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $90cab0c9e6efa470$export$c5b2c959a5ee5a4a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Lsv8X",
    name: "ConnectSpaceCustomContentListView",
    loader: async ()=>(await (parcelRequire("iXUzT"))).ConnectSpaceCustomContentListView
});


const $25fdeb0a789de125$export$1045fc666c352ae6 = ({ params: { spaceKey: spaceKey, type: type } })=>{
    const [stateKey, setStateKey] = (0, $42omo.useState)(history?.state?.key || Math.random());
    // Updating a key state and reload ConnectSpaceCustomContentListView component.
    //
    // Connect Apps can have an inner history state (created with AP.history), which add
    // hashtag to URL (for example: #!state1)
    // When user navigates to this route again the URL is reset to initial state and
    // hashtag is removed, but inner app does not get any notifications about that and
    // don't reset inner app state.
    //
    // To fix this issue we are listening history.state.key, and when it's changed
    // (user create a new entry in history) refresh component
    (0, $42omo.useEffect)(()=>{
        // We rely on history.state.key that is not documented, but major browsers have it
        if (history?.state?.key) setStateKey(history.state.key);
        else if (!history?.state?._AP) setStateKey(Math.random());
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        history?.state,
        setStateKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90cab0c9e6efa470$export$c5b2c959a5ee5a4a), {
        spaceKey: spaceKey,
        type: type,
        key: stateKey
    });
};
$25fdeb0a789de125$export$1045fc666c352ae6.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, type: type } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceCustomContent',
                id: spaceKey,
                attributes: {
                    type: type
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });









const $ae3041c2a586590e$export$cc376322db18bf6e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sjwPy",
    name: "CustomContentOnPageComponentLoader",
    loader: async ()=>(await (parcelRequire("eSHjN"))).CustomContentOnPageComponent
});





const $4af991445198673b$export$80477c996ae74379 = ({ params: { contentId: contentId, spaceKey: spaceKey, type: type } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ae3041c2a586590e$export$cc376322db18bf6e), {
        contentId: contentId,
        spaceKey: spaceKey,
        type: type === 'undefined' ? '' : type
    });
};
$4af991445198673b$export$80477c996ae74379.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentOnPage',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $95bd051929613722$export$f536037c46d4c012 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9X2ye",
    name: "CustomContentView",
    loader: async ()=>(await (parcelRequire("8R4tZ"))).CustomContentView
});


const $c7473af47fe3192c$export$b836ebd0f49cc9f5 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95bd051929613722$export$f536037c46d4c012), {
        spaceKey: spaceKey,
        contentId: contentId
    });
};
$c7473af47fe3192c$export$b836ebd0f49cc9f5.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentView',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $0960da40109465b4$var$PublicLinksSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rP97Y",
    name: "PublicLinksSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("4pErf"))
});
const $0960da40109465b4$export$af4daa43ca1332b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0960da40109465b4$var$PublicLinksSettingsPageRouteComponent, null);
$0960da40109465b4$export$af4daa43ca1332b9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'publicLinksSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $d86fe9bfb21b5293$var$AnonymousAccessSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7xkbS",
    name: "AnonymousAccessSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("9KOnT"))
});
const $d86fe9bfb21b5293$export$1d391e6d67538b19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d86fe9bfb21b5293$var$AnonymousAccessSettingsPageRouteComponent, null);
$d86fe9bfb21b5293$export$1d391e6d67538b19.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'anonymousAccessSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $4fabe80bae5e8d04$var$SpaceManagementPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VdX74",
    name: "SpaceManagementPageRouteComponent",
    loader: async ()=>(parcelRequire("6ODB7"))
});
const $4fabe80bae5e8d04$export$fd1cbd536f2e61b4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fabe80bae5e8d04$var$SpaceManagementPageRouteComponent, null);
$4fabe80bae5e8d04$export$fd1cbd536f2e61b4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceManagementScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $25cfc5c41bd5d05f$var$SpaceDefaultsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "PWywz",
    name: "SpaceDefaultsPageRouteComponent",
    loader: async ()=>(parcelRequire("7sQ6z"))
});
const $25cfc5c41bd5d05f$export$5425f152a964e2a4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($25cfc5c41bd5d05f$var$SpaceDefaultsPageRouteComponent, null);
$25cfc5c41bd5d05f$export$5425f152a964e2a4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceDefaultsPermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $815c579597235468$var$SpaceRolesPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Jbnxb",
    name: "SpaceRolesPageRouteComponent",
    loader: async ()=>(parcelRequire("j31oX"))
});
const $815c579597235468$export$3d75421a82ac4ef3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($815c579597235468$var$SpaceRolesPageRouteComponent, null);
$815c579597235468$export$3d75421a82ac4ef3.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceRolesScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $139f96c2577c166d$var$SitePermissionsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Y2xVK",
    name: "SitePermissionsPageRouteComponent",
    loader: async ()=>(parcelRequire("alRCK"))
});
const $139f96c2577c166d$export$29c72ea3332ea2cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($139f96c2577c166d$var$SitePermissionsPageRouteComponent, null);
$139f96c2577c166d$export$29c72ea3332ea2cc.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $e5c5bd5a8c7b0d6f$var$GuestsSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vk7Ko",
    name: "GuestsSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("kz8pQ"))
});
const $e5c5bd5a8c7b0d6f$export$16c169bdc6cd5ebe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e5c5bd5a8c7b0d6f$var$GuestsSettingsPageRouteComponent, null);
$e5c5bd5a8c7b0d6f$export$16c169bdc6cd5ebe.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'guestsSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $9cf8f85dda9fbba2$var$AppsPermissionsSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HIGKF",
    name: "AppsPermissionsSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("bb7pf"))
});
const $9cf8f85dda9fbba2$export$74dc62432aba2eaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9cf8f85dda9fbba2$var$AppsPermissionsSettingsPageRouteComponent, null);
$9cf8f85dda9fbba2$export$74dc62432aba2eaa.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'appPermissionsSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $862979a48c317517$var$JsmAccessSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1MuLn",
    name: "JsmAccessSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("ivrRE"))
});
const $862979a48c317517$export$bc6803ac9d998199 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($862979a48c317517$var$JsmAccessSettingsPageRouteComponent, null);
$862979a48c317517$export$bc6803ac9d998199.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'jsmAccessSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $95bdd88deead3c11$export$ecc44bd892306adb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "00c23",
    name: "ContactAdministratorRoute",
    loader: async ()=>(await (parcelRequire("dqpQq"))).ContactAdministratorPage
});
$95bdd88deead3c11$export$ecc44bd892306adb.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            screenEvent: {
                name: 'contactAdministratorScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    };
};













const $1fb601398675b5a1$var$RoleBasedAccessControlHubRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "FJbMa",
    name: "RoleBasedAccessControlHubRouteComponent",
    loader: async ()=>(parcelRequire("fFYfK"))
});
const $1fb601398675b5a1$export$23838e4b7dc196e5 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1fb601398675b5a1$var$RoleBasedAccessControlHubRouteComponent, null);
};
$1fb601398675b5a1$export$23838e4b7dc196e5.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name } = routeMatch;
    return {
        Screen: {
            screenEvent: {
                name: 'roleBasedAccessControlHubScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};












const $e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LCRNu",
    name: "AdminAnnouncementBannerRenderer",
    loader: async ()=>(await (parcelRequire("941FH"))).AdminAnnouncementBannerRenderer
});
const $e77b8eed9c4fe03f$export$81a4ecf687c4a61b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer, null);
};
$e77b8eed9c4fe03f$export$81a4ecf687c4a61b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminAnnouncementBannerRenderer'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });















const $36a63e56cd2b2984$var$AdminCenterPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yN5_D",
    name: "AdminCenterPage",
    loader: async ()=>(await (parcelRequire("fpeTv"))).AdminCenterPage
});
const $36a63e56cd2b2984$export$60c1a30975370191 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36a63e56cd2b2984$var$AdminCenterPage, null);
$36a63e56cd2b2984$export$60c1a30975370191.NAVIGATION_PARAMS = ()=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenter',
                attributes: {
                    edition: edition
                }
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};














parcelRequire("crTA1");



const $015145ca08e6a13a$var$AdminCenterSpacePage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "1dPKI",
    name: "AdminCenterSpacePage",
    loader: async ()=>(await (parcelRequire("fpeTv"))).AdminCenterSpacePage
});
const $015145ca08e6a13a$export$bd929b984ffc4a9 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($015145ca08e6a13a$var$AdminCenterSpacePage, {
        spaceKey: spaceKey
    }));
};
$015145ca08e6a13a$export$bd929b984ffc4a9.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenterSpace',
                id: spaceKey,
                attributes: {
                    edition: edition
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID)
        }
    };
};















var $euL71 = parcelRequire("euL71");

const $6f06338c7fe23a44$export$44bc7d6c094dc951 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition === (0, $euL71.ConfluenceEdition).PREMIUM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CENTER).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CONFIGURATION).name
    });
};
$6f06338c7fe23a44$export$44bc7d6c094dc951.NAVIGATION_PARAMS = ()=>false;


/* eslint react/prop-types:0 */ 









const $e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HYdso",
    name: "SpaceSettingsExportSpaceUnavailableRouteComponent",
    loader: ()=>(parcelRequire("fVdPo"))
});
const $e2d8d9818dde6381$export$1d1f8d0ef7c7a185 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent, {
        spaceKey: spaceKey
    });
$e2d8d9818dde6381$export$1d1f8d0ef7c7a185.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsExportSpaceUnavailable',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });














var $9TVBV = parcelRequire("9TVBV");


const $55b7ec62080e1638$export$405a6cc8f1c994c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LzFeC",
    loader: async ()=>(await Promise.resolve((parcelRequire("9TVBV")))).BulkSpacePermissionsPage,
    name: 'BulkSpacePermissionsPage'
});







const $fe2917192dc4f6b9$export$db2035bfb5892b74 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VMbza",
    loader: async ()=>(await Promise.resolve((parcelRequire("kAGh9")))).BulkAccessManagementPage,
    name: 'BulkAccessManagementPage'
});






var $7siXU = parcelRequire("7siXU");




const $4255a2123073399b$export$a1ed7a563d6f8c80 = ()=>{
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (!isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7siXU.AdminSecurityPageWrapper), {
        bannerVariant: "space"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $55b7ec62080e1638$export$405a6cc8f1c994c8), null));
    if ((0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7siXU.AdminSecurityPageWrapper), {
        bannerVariant: "space"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe2917192dc4f6b9$export$db2035bfb5892b74), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7siXU.AdminSecurityPageWrapper), {
        bannerVariant: "space"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe2917192dc4f6b9$export$db2035bfb5892b74), null));
};
$4255a2123073399b$export$a1ed7a563d6f8c80.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9TVBV.ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });

















const $d1361d4d835db3f1$export$5164e66822dc5aec = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition !== (0, $euL71.ConfluenceEdition).PREMIUM) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bDjCi.LazyTeamCalendarSiteSettingsPage), null);
};
$d1361d4d835db3f1$export$5164e66822dc5aec.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $bDjCi.ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












var $4VuiN = parcelRequire("4VuiN");

/* AdminControls.tsx generated by @compiled/babel-plugin v0.36.1 */ 






























var $2Nwuj = parcelRequire("2Nwuj");


var $fzqvY = parcelRequire("fzqvY");


var $fb3kw = parcelRequire("fb3kw");


var $dn4ZF = parcelRequire("dn4ZF");


var $8tdj3 = parcelRequire("8tdj3");


var $ay6Zz = parcelRequire("ay6Zz");


var $inPa6 = parcelRequire("inPa6");





var $dpPtd = parcelRequire("dpPtd");











var $1kHsc = parcelRequire("1kHsc");

parcelRequire("6V36D");
var $hVSC8 = parcelRequire("hVSC8");


var $1BYn9 = parcelRequire("1BYn9");


var $6MSEP = parcelRequire("6MSEP");








var $1DHa6 = parcelRequire("1DHa6");


var $8o1lj = parcelRequire("8o1lj");


var $9ot3w = parcelRequire("9ot3w");


var $d8eRd = parcelRequire("d8eRd");





var $hArLp = parcelRequire("hArLp");








var $lsxnT = parcelRequire("lsxnT");

/**
 * @generated SignedSource<<854134a3a69b1d840cfbb29220ff4613>>
 * @relayHash f9b10ce854bd3b612917f0d940680b5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f61aa3a25666da7daba04ef61b2c17cddfcb8277a20e02879d3acd04ad2a3aff
const $dab459a150882bfc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConfluenceSiteTeamConfigurationsMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateTeamAdminControlsSettingsPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamAdminControlsSettings",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConfluenceSiteTeamConfigurationsMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateTeamAdminControlsSettingsPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamAdminControlsSettings",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f9b10ce854bd3b612917f0d940680b5b",
            "id": "f61aa3a25666da7daba04ef61b2c17cddfcb8277a20e02879d3acd04ad2a3aff",
            "metadata": {},
            "name": "useConfluenceSiteTeamConfigurationsMutation",
            "operationKind": "mutation",
            "text": "mutation useConfluenceSiteTeamConfigurationsMutation($input:ConfluenceTeamAdminControlsMode!){confluence{updateTeamAdminControlsSettings(input:$input){success,errors{message,extensions{statusCode,errorType,__typename,...on BulkMutationErrorExtension{id}},__typename},__typename}}}"
        }
    };
}();
$dab459a150882bfc$var$node.hash = "cb12cbeaf9954a0e8247aceccec6df18";
var $dab459a150882bfc$export$2e2bcd8739ae039 = $dab459a150882bfc$var$node;


/**
 * @generated SignedSource<<68ede829ccd8475ef7718dac6a1a3df6>>
 * @relayHash 39d6a72d5b5b54c388e853287b5b83d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bcdafa25a8ff8d9dade01defb15b8941be3356093ed52cf164bb281b32a6ceb4
const $4ee2724dd2a3884a$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceQueryApi",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSiteConfiguration",
                    "kind": "LinkedField",
                    "name": "siteConfiguration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceTeamAdminControlsSettings",
                            "kind": "LinkedField",
                            "name": "teamAdminControlsSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "teamAdminControlsMode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useConfluenceSiteTeamConfigurationsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useConfluenceSiteTeamConfigurationsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "39d6a72d5b5b54c388e853287b5b83d9",
            "id": "bcdafa25a8ff8d9dade01defb15b8941be3356093ed52cf164bb281b32a6ceb4",
            "metadata": {},
            "name": "useConfluenceSiteTeamConfigurationsQuery",
            "operationKind": "query",
            "text": "query useConfluenceSiteTeamConfigurationsQuery{confluence{siteConfiguration{teamAdminControlsSettings{teamAdminControlsMode}}}}"
        }
    };
}();
$4ee2724dd2a3884a$var$node.hash = "dc96564c26929e9d164a8c5239b5e482";
var $4ee2724dd2a3884a$export$2e2bcd8739ae039 = $4ee2724dd2a3884a$var$node;






var $308Wd = parcelRequire("308Wd");


var $jMyy4 = parcelRequire("jMyy4");








var $irVI7 = parcelRequire("irVI7");














var $a3fRD = parcelRequire("a3fRD");

const $b453cb24cea38560$var$i18nFlags = (0, $aXWIB.defineMessages)({
    successTitle: {
        id: "team-admin-controls.flag.success.title",
        defaultMessage: "Settings saved"
    },
    errorTitle: {
        id: "team-admin-controls.flag.error.title",
        defaultMessage: "Error"
    },
    errorDescription: {
        id: "team-admin-controls.flag.error.description",
        defaultMessage: "Something went wrong. Please try again."
    }
});
const $b453cb24cea38560$export$b8f59813a918ec2 = ()=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const showSuccessFlag = ()=>{
        showFlag({
            id: `team-admin-controls-success-${Date.now()}`,
            title: formatMessage($b453cb24cea38560$var$i18nFlags.successTitle),
            isAutoDismiss: true,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                label: formatMessage($b453cb24cea38560$var$i18nFlags.successTitle)
            })
        });
    };
    const showErrorFlag = ()=>{
        showFlag({
            id: `team-admin-controls-error-${Date.now()}`,
            title: formatMessage($b453cb24cea38560$var$i18nFlags.errorTitle),
            description: formatMessage($b453cb24cea38560$var$i18nFlags.errorDescription),
            isAutoDismiss: true,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: formatMessage($b453cb24cea38560$var$i18nFlags.errorTitle)
            })
        });
    };
    return {
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};


var $44851797bb5ee99f$export$640f4d7e68eecbe5 = /*#__PURE__*/ function(ConfluenceTeamAdminControlsMode) {
    ConfluenceTeamAdminControlsMode["ALL_TEAMS"] = "ALL_TEAMS";
    ConfluenceTeamAdminControlsMode["VERIFIED_TEAMS"] = "VERIFIED_TEAMS";
    ConfluenceTeamAdminControlsMode["NO_TEAMS"] = "NO_TEAMS";
    ConfluenceTeamAdminControlsMode["MEMBER_MANAGED_TEAMS"] = "MEMBER_MANAGED_TEAMS";
    return ConfluenceTeamAdminControlsMode;
}({});
const $44851797bb5ee99f$var$ConfluenceSiteConfigurationQuery = (0, $4ee2724dd2a3884a$export$2e2bcd8739ae039);
const $44851797bb5ee99f$var$UpdateTeamAdminControlsSettingsMutation = (0, $dab459a150882bfc$export$2e2bcd8739ae039);
const $44851797bb5ee99f$export$6c26751b3fc2f7e9 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showErrorFlag: showErrorFlag, showSuccessFlag: showSuccessFlag } = (0, $b453cb24cea38560$export$b8f59813a918ec2)();
    const { data: data, loading: siteConfigurationLoading, error: siteConfigurationError } = (0, $jMyy4.useQueryInterop)($44851797bb5ee99f$var$ConfluenceSiteConfigurationQuery, {
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/team-admin-controls"
    });
    const [runMutation, { loading: updateTeamAdminControlsSettingsLoading }] = (0, $308Wd.useMutationInterop)($44851797bb5ee99f$var$UpdateTeamAdminControlsSettingsMutation, {
        __callerPackage__: "@confluence/team-admin-controls"
    });
    async function updateTeamAdminControlsSettings(newTeamAdminControlsMode) {
        await runMutation({
            variables: {
                input: newTeamAdminControlsMode
            }
        }).catch((error)=>{
            (0, $7Sm4c.markErrorAsHandled)(error);
            showErrorFlag();
            experienceTracker.fail({
                name: (0, $irVI7.TEAM_ADMIN_CONTROLS_UPDATE_EXPERIENCE),
                error: error
            });
        });
        showSuccessFlag();
        experienceTracker.succeed({
            name: (0, $irVI7.TEAM_ADMIN_CONTROLS_UPDATE_EXPERIENCE)
        });
    }
    const currentTeamAdminControlsMode = data?.confluence?.siteConfiguration?.teamAdminControlsSettings?.teamAdminControlsMode;
    return {
        siteConfigurationLoading: siteConfigurationLoading,
        siteConfigurationError: siteConfigurationError,
        currentTeamAdminControlsMode: currentTeamAdminControlsMode,
        updateTeamAdminControlsSettings: updateTeamAdminControlsSettings,
        updateTeamAdminControlsSettingsLoading: updateTeamAdminControlsSettingsLoading
    };
};


const $14c1e67c9ac9a79b$var$i18n = (0, $aXWIB.defineMessages)({
    mayLoseAccessFrictionModalTitle: {
        id: "team-admin-controls.friction-modal.lose-some-access-title",
        defaultMessage: "Member-managed teams will lose access"
    },
    noTeamsFrictionModalTitle: {
        id: "team-admin-controls.friction-modal.no-teams-title",
        defaultMessage: "Teams will lose access"
    },
    mayLoseAccessFrictionModalBody: {
        id: "team-admin-controls.friction-modal.lose-some-access-body",
        defaultMessage: "Limiting the use of <b>open teams</b> to may cause unintended loss of access that is already configured across your site."
    },
    loseAccessFrictionModalBodyAdditional: {
        id: "team-admin-controls.friction-modal.lose-some-access-body-additional",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    willLoseAccessFrictionModalBody: {
        id: "team-admin-controls.friction-modal.no-teams-body",
        defaultMessage: "Any member-managed teams currently assigned access on this site will lose that access."
    },
    noTeamsFrictionModalBody: {
        id: "team-admin-controls.friction-modal.no-teams-body",
        defaultMessage: "Any teams currently assigned access on this site will lose that access."
    },
    noTeamsFrictionModalBodyAdditional: {
        id: "team-admin-controls.friction-modal.no-teams-body-additional",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    verifiedTeamsFrictionModalBody: {
        id: "team-admin-controls.friction-modal.verified-teams-body",
        defaultMessage: "Atlassian team is a collection of users that are part of your real-world team. Limiting the use teams to <b>only verified</b> may cause unintended loss of access across your site."
    },
    verifiedTeamsFrictionModalBodyAdditional: {
        id: "team-admin-controls.friction-modal.verified-teams-body-additional",
        defaultMessage: "<b>You can restore this later.</b>"
    },
    frictionModalContinueButton: {
        id: "team-admin-controls.friction-modal.continue-button",
        defaultMessage: "Continue"
    },
    frictionModalCancelButton: {
        id: "team-admin-controls.friction-modal.cancel-button",
        defaultMessage: "Cancel"
    }
});
const $14c1e67c9ac9a79b$export$fe53eaaf4efb0181 = ({ title: title, onConfirm: onConfirm, onClose: onClose, width: width = 'small', teamAccessType: teamAccessType })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const modalText = (0, $42omo.useMemo)(()=>{
        switch(teamAccessType){
            case (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS:
                return {
                    title: formatMessage($14c1e67c9ac9a79b$var$i18n.mayLoseAccessFrictionModalTitle),
                    body: formatMessage($14c1e67c9ac9a79b$var$i18n.willLoseAccessFrictionModalBody, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                    }),
                    bodyAdditional: formatMessage($14c1e67c9ac9a79b$var$i18n.loseAccessFrictionModalBodyAdditional, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                    })
                };
            case (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS:
                return {
                    title: formatMessage($14c1e67c9ac9a79b$var$i18n.noTeamsFrictionModalTitle),
                    body: formatMessage($14c1e67c9ac9a79b$var$i18n.noTeamsFrictionModalBody, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                    }),
                    bodyAdditional: formatMessage($14c1e67c9ac9a79b$var$i18n.noTeamsFrictionModalBodyAdditional, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                    })
                };
            default:
                return {
                    title: formatMessage($14c1e67c9ac9a79b$var$i18n.mayLoseAccessFrictionModalTitle),
                    body: formatMessage($14c1e67c9ac9a79b$var$i18n.mayLoseAccessFrictionModalBody, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                    }),
                    bodyAdditional: formatMessage($14c1e67c9ac9a79b$var$i18n.loseAccessFrictionModalBodyAdditional, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                    })
                };
        }
    }, [
        teamAccessType,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: width,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, title ?? modalText.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, " ", modalText.body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, modalText.bodyAdditional))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: ()=>onClose()
    }, formatMessage($14c1e67c9ac9a79b$var$i18n.frictionModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "warning",
        onClick: ()=>onConfirm()
    }, formatMessage($14c1e67c9ac9a79b$var$i18n.frictionModalContinueButton)))));
};



const $4cdac1dfe86e0470$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "team-admin-controls.admin-controls.page.title",
        defaultMessage: "Teams"
    },
    manageTeamsButton: {
        id: "team-admin-controls.admin-controls.page.manage-teams-button",
        defaultMessage: "Manage teams"
    },
    description1: {
        id: "team-admin-controls.admin-controls.page.description1",
        defaultMessage: "Decide whether users on your site can assign access to teams (for example, by adding a team to a space and assigning it specific access). When enabled, users can assign access to teams, in addition to groups and individual users."
    },
    description2: {
        id: "team-admin-controls.admin-controls.page.description2",
        defaultMessage: "Atlassian teams let you collaborate quickly and easily with your project team across most Atlassian apps by sharing important links and resources, easily notifying all members, tracking work across apps on the team profile, and more. <link>Learn more about teams</link>"
    },
    radioGroupLabel: {
        id: "team-admin-controls.admin-controls.page.radio-group-label",
        defaultMessage: "Which teams can be assigned access?"
    },
    radioGroupOption1: {
        id: "team-admin-controls.admin-controls.page.radio-group-option-1",
        defaultMessage: "All teams"
    },
    radioGroupOption2: {
        id: "team-admin-controls.admin-controls.page.radio-group-option-2",
        defaultMessage: "Only admin-managed teams"
    },
    radioGroupOption3: {
        id: "team-admin-controls.admin-controls.page.radio-group-option-3",
        defaultMessage: "No teams can be assigned access"
    },
    radioGroupDescription1: {
        id: "team-admin-controls.admin-controls.page.radio-group-description-1",
        defaultMessage: "Both admin-managed and member-managed teams"
    },
    radioGroupDescription2: {
        id: "team-admin-controls.admin-controls.page.radio-group-description-2",
        defaultMessage: "All admin-managed teams will be marked with a blue check. <link>More about admin-managed teams</link>"
    },
    radioGroupDescription3: {
        id: "team-admin-controls.admin-controls.page.radio-group-description-3",
        defaultMessage: "Access can only be assigned to groups and individual users"
    },
    membershipControlRadioGroupLabel: {
        id: "team-admin-controls.admin-controls.page.membership-control-radio-group-label",
        defaultMessage: "Membership control"
    },
    membershipControlRadioGroupOption1: {
        id: "team-admin-controls.admin-controls.page.membership-control-radio-group-option-1",
        defaultMessage: "Allow teams that anyone can join"
    },
    membershipControlRadioGroupOption2: {
        id: "team-admin-controls.admin-controls.page.membership-control-radio-group-option-2",
        defaultMessage: "Only allow teams that require approval to join"
    },
    saveButton: {
        id: "team-admin-controls.admin-controls.page.save-button",
        defaultMessage: "Save"
    },
    cancelButton: {
        id: "team-admin-controls.admin-controls.page.cancel-button",
        defaultMessage: "Cancel"
    }
});
const $4cdac1dfe86e0470$var$styles = {
    container: "_1rjcxncg _18zrxncg _195g1wug _p12f1fra",
    description: "_12l21epz",
    radioGroupDescription: "_ahbqxy5q"
};
const $4cdac1dfe86e0470$var$membershipControlRadioOptions = [
    {
        value: 'open-membership',
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4cdac1dfe86e0470$var$i18n.membershipControlRadioGroupOption1)
    },
    {
        value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4cdac1dfe86e0470$var$i18n.membershipControlRadioGroupOption2)
    }
];
const $4cdac1dfe86e0470$export$997e23a0aec74966 = 'https://support.atlassian.com/platform-experiences/docs/teams-in-confluence-permissions/';
const $4cdac1dfe86e0470$var$AdminControlsContent = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, orgId: orgId, edition: edition } = (0, $bQm3c.useSessionData)();
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const { href: href } = (0, $ay6Zz.navigateToTeamsApp)({
        type: 'LANDING',
        cloudId: cloudId,
        orgId: orgId,
        userHasNav4Enabled: true
    });
    const onClickManageTeams = ()=>{
        window.open(href, '_blank');
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'adminControls',
                actionSubject: 'adminControls',
                action: 'clicked manage teams button'
            }
        }).fire();
    };
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { siteConfigurationLoading: siteConfigurationLoading, currentTeamAdminControlsMode: currentTeamAdminControlsMode, updateTeamAdminControlsSettings: updateTeamAdminControlsSettings, updateTeamAdminControlsSettingsLoading: updateTeamAdminControlsSettingsLoading } = (0, $44851797bb5ee99f$export$6c26751b3fc2f7e9)();
    const [hasChanged, setHasChanged] = (0, $42omo.useState)(false);
    const [membershipControlType, setMembershipControlType] = (0, $42omo.useState)('open-membership');
    const [lastSavedMembershipControlType, setLastSavedMembershipControlType] = (0, $42omo.useState)('open-membership');
    const [showFrictionModal, setShowFrictionModal] = (0, $42omo.useState)(false);
    const [selectedTeamAccessType, setSelectedTeamAccessType] = (0, $42omo.useState)(undefined); // Track the last saved mode locally to avoid stale server data affecting shouldShowFrictionModal
    const [lastSavedMode, setLastSavedMode] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        if (!siteConfigurationLoading && currentTeamAdminControlsMode) {
            if (currentTeamAdminControlsMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS) {
                setSelectedTeamAccessType((0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS);
                setLastSavedMode((0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS);
                const membershipControlTypeValue = (0, $6mKj3.expVal)('confluence_frontend_perms_teams_ga_fast_follow', 'isEnabled', false) ? (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS : 'open-membership';
                setMembershipControlType(membershipControlTypeValue);
                setLastSavedMembershipControlType(membershipControlTypeValue);
            } else {
                setSelectedTeamAccessType(currentTeamAdminControlsMode);
                setLastSavedMode(currentTeamAdminControlsMode);
            }
        }
    }, [
        siteConfigurationLoading,
        currentTeamAdminControlsMode
    ]);
    const onTeamAccessTypeChange = (value)=>{
        setHasChanged(value !== lastSavedMode);
        setSelectedTeamAccessType(value);
        if (value !== (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS) setMembershipControlType(lastSavedMembershipControlType);
    };
    const onMembershipControlTypeChange = (value)=>{
        setHasChanged(value !== lastSavedMembershipControlType);
        setMembershipControlType(value);
    }; // We want to show the friction modal only when there is possible access loss:
    // so going from All teams -> Verified/No teams, or Verified -> No teams
    // Going from No teams -> any level above will result in access gain so we don't show the modal.
    // We use lastSavedMode (local state) instead of currentTeamAdminControlsMode (server state)
    // to avoid stale data issues after a save.
    const shouldShowFrictionModal = (0, $42omo.useCallback)(()=>{
        if (lastSavedMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS) return true;
        else if (lastSavedMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS && selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS) return true;
        else if (lastSavedMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS) return false;
        return false;
    }, [
        lastSavedMode,
        selectedTeamAccessType
    ]);
    const onSaveClick = ()=>{
        if (shouldShowFrictionModal()) setShowFrictionModal(true);
        else onConfirmFrictionModal();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'adminControls',
                actionSubject: 'adminControls',
                action: 'saved team access type',
                attributes: {
                    teamAccessType: selectedTeamAccessType || '(empty)',
                    membershipControlType: membershipControlType
                }
            }
        }).fire();
    };
    const onConfirmFrictionModal = async ()=>{
        setShowFrictionModal(false);
        experienceTracker.start({
            name: 'updateTeamAdminControlsSettings'
        });
        if (selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS && membershipControlType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS) {
            await updateTeamAdminControlsSettings((0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS);
            setLastSavedMembershipControlType(membershipControlType);
            setMembershipControlType(membershipControlType);
        } else {
            await updateTeamAdminControlsSettings(selectedTeamAccessType);
            setLastSavedMembershipControlType('open-membership');
            setMembershipControlType('open-membership');
        }
        setLastSavedMode(selectedTeamAccessType);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'adminControls',
                actionSubject: 'adminControls',
                action: 'confirmed friction modal',
                attributes: {
                    teamAccessType: selectedTeamAccessType,
                    membershipControlType: membershipControlType
                }
            }
        }).fire();
        setHasChanged(false);
    };
    if (!isProductAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6MSEP.RestrictedPage), null);
    const onCancel = ()=>{
        setHasChanged(false);
        setShowFrictionModal(false);
        setSelectedTeamAccessType(lastSavedMode);
        setMembershipControlType(lastSavedMembershipControlType);
    };
    return siteConfigurationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? undefined : $4cdac1dfe86e0470$var$styles.container
    }, showFrictionModal && selectedTeamAccessType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $14c1e67c9ac9a79b$export$fe53eaaf4efb0181), {
        width: "medium",
        teamAccessType: selectedTeamAccessType,
        onConfirm: ()=>onConfirmFrictionModal(),
        onClose: ()=>setShowFrictionModal(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large"
    }, formatMessage($4cdac1dfe86e0470$var$i18n.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        appearance: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? 'default' : 'subtle',
        onClick: ()=>onClickManageTeams()
    }, formatMessage($4cdac1dfe86e0470$var$i18n.manageTeamsButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200",
        xcss: $4cdac1dfe86e0470$var$styles.description
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($4cdac1dfe86e0470$var$i18n.description1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($4cdac1dfe86e0470$var$i18n.description2, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: $4cdac1dfe86e0470$export$997e23a0aec74966,
                target: "_blank"
            }, chunks)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: ()=>{
            // TODO: Implement save functionality
            return Promise.resolve();
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "small"
        }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupLabel)), siteConfigurationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "teamAccessType",
            defaultValue: currentTeamAdminControlsMode ?? undefined
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                space: "space.100",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
                ...fieldProps,
                value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS,
                label: formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupOption1),
                onChange: (e)=>onTeamAccessTypeChange(e.target.value),
                isChecked: selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                alignInline: "start",
                space: "space.050",
                xcss: $4cdac1dfe86e0470$var$styles.radioGroupDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupDescription1))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
                ...fieldProps,
                value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS,
                label: formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupOption2),
                onChange: (e)=>onTeamAccessTypeChange(e.target.value),
                isChecked: selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                alignInline: "start",
                alignBlock: "center",
                space: "space.050",
                xcss: $4cdac1dfe86e0470$var$styles.radioGroupDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hVSC8.VerifiedTeamLozenge), {
                spacing: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupDescription2, {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: $4cdac1dfe86e0470$export$997e23a0aec74966,
                        target: "_blank"
                    }, chunks)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
                ...fieldProps,
                value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS,
                label: formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupOption3),
                onChange: (e)=>onTeamAccessTypeChange(e.target.value),
                isChecked: selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                alignInline: "start",
                space: "space.050",
                xcss: $4cdac1dfe86e0470$var$styles.radioGroupDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupDescription3))))), selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS && (0, $6mKj3.expVal)('confluence_frontend_perms_teams_ga_fast_follow', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "small"
        }, formatMessage($4cdac1dfe86e0470$var$i18n.membershipControlRadioGroupLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "membershipControlType",
            defaultValue: membershipControlType
        }, ({ fieldProps: membershipFieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                space: "space.150",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
                ...membershipFieldProps,
                value: $4cdac1dfe86e0470$var$membershipControlRadioOptions[0].value,
                label: $4cdac1dfe86e0470$var$membershipControlRadioOptions[0].label,
                onChange: (e)=>onMembershipControlTypeChange(e.target.value),
                isChecked: membershipControlType === $4cdac1dfe86e0470$var$membershipControlRadioOptions[0].value
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
                ...membershipFieldProps,
                value: $4cdac1dfe86e0470$var$membershipControlRadioOptions[1].value,
                label: $4cdac1dfe86e0470$var$membershipControlRadioOptions[1].label,
                onChange: (e)=>onMembershipControlTypeChange(e.target.value),
                isChecked: membershipControlType === $4cdac1dfe86e0470$var$membershipControlRadioOptions[1].value
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dn4ZF.default), {
            align: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            type: "submit",
            isDisabled: !hasChanged,
            isLoading: updateTeamAdminControlsSettingsLoading,
            appearance: "primary",
            onClick: ()=>onSaveClick()
        }, formatMessage($4cdac1dfe86e0470$var$i18n.saveButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            type: "button",
            appearance: "subtle",
            onClick: onCancel,
            isDisabled: !hasChanged
        }, formatMessage($4cdac1dfe86e0470$var$i18n.cancelButton)))))))));
};
const $4cdac1dfe86e0470$export$c6013ec0ca71e14e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4cdac1dfe86e0470$var$AdminControlsContent, null));


const $7793a666921a34a3$export$ee12bdabe55b87f5 = ()=>{
    if ((0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4VuiN.AdminPageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4cdac1dfe86e0470$export$c6013ec0ca71e14e), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4cdac1dfe86e0470$export$c6013ec0ca71e14e), null);
};
$7793a666921a34a3$export$ee12bdabe55b87f5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminTeamControlsSettings'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $f1b6649640833ae0$export$acaa2dba3cb8a594 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sV2io",
    name: "LazyConfigurationPage",
    loader: async ()=>(await (parcelRequire("1SSaP"))).ConfigurationPage
});



var $go5PI = parcelRequire("go5PI");




const $daea30cdb73fa105$export$9a9547459861b1d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1b6649640833ae0$export$acaa2dba3cb8a594), null);
$daea30cdb73fa105$export$9a9547459861b1d.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $go5PI.ADMIN_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $26ef48198c7a4b22$export$c666402e8e189c20 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XqQyJ",
    name: "LazyDefaultSpaceLogoConfigPage",
    loader: async ()=>(await (parcelRequire("fDMHs"))).DefaultSpaceLogoConfigPage
});



var $87xWZ = parcelRequire("87xWZ");




const $cf2a30228181ae7a$export$12cd952fb663f2a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26ef48198c7a4b22$export$c666402e8e189c20), null);
$cf2a30228181ae7a$export$12cd952fb663f2a5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $87xWZ.ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $0035ce34a536ea29$export$b15e4e022e4cf20b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Gs9zR",
    name: "LazyHeaderAndFooterPage",
    loader: async ()=>(await (parcelRequire("ksDMU"))).HeaderAndFooterPage
});



var $9VF1g = parcelRequire("9VF1g");




const $d9d1782c5d23f713$export$66aaa3e4fa4fb446 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0035ce34a536ea29$export$b15e4e022e4cf20b), null);
$d9d1782c5d23f713$export$66aaa3e4fa4fb446.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9VF1g.ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $20670991d47ae85d$export$eeb35ce919747456 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "g_FZa",
    name: "LazyTemplatesAndBlueprintsPage",
    loader: async ()=>(await (parcelRequire("ktfnc"))).TemplatesAndBlueprintsPage
});



var $kzcPl = parcelRequire("kzcPl");




const $3de5f90ca85ac387$export$fb8cddd2e05884ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $20670991d47ae85d$export$eeb35ce919747456), null);
$3de5f90ca85ac387$export$fb8cddd2e05884ff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $kzcPl.ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });


/* eslint react/prop-types:0 */ 







// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 



var $3Tdyk = parcelRequire("3Tdyk");


const $ee7f717a6b819a49$export$9be270b9ed22878c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "v1sq_",
    name: "LazyNotificationsSiteSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("pI7qq"))).NotificationsSiteSettingsPage
});


const $5035325f0c8b9a13$export$65794158c09a379 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee7f717a6b819a49$export$9be270b9ed22878c), null);
$5035325f0c8b9a13$export$65794158c09a379.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $3Tdyk.ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $4a6faff2aaf4384e$export$26695507154f3759 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6TCL1",
    name: "PerformanceInsightsPage",
    loader: async ()=>(await (parcelRequire("kEPYK"))).PerformanceInsightsPage
});





const $50fb216eea7c3440$export$66e6ee80c1ffed5a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4a6faff2aaf4384e$export$26695507154f3759), null);
$50fb216eea7c3440$export$66e6ee80c1ffed5a.NAVIGATION_PARAMS = ({ params: { tab: tab } })=>({
        Screen: {
            screenEvent: {
                name: 'performanceInsightsScreen',
                attributes: {
                    tab: tab
                }
            },
            pageState: {
                routeName: (0, $1NBp8.PERFORMANCE_INSIGHTS).name,
                tab: tab
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });














var $i6ccO = parcelRequire("i6ccO");


const $13b2a397a1cc2782$export$bac0713ec898bd76 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CRbee",
    name: "LazySpaceReportsSiteSettings",
    loader: async ()=>(await (parcelRequire("2iZZQ"))).SpaceReports
});


const $ba2c2ff5f89f0551$export$2667c61817b129fd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13b2a397a1cc2782$export$bac0713ec898bd76), null);
$ba2c2ff5f89f0551$export$2667c61817b129fd.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $i6ccO.ADMIN_SPACE_REPORT_SCREEN)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $a1651aa6544b68ec$export$d90af831494c8387 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HbgyC",
    name: "LazyCodeMacroConfigurationPage",
    loader: async ()=>(await (parcelRequire("1wgeK"))).ConfigureCodeMacroPage
});



var $jPtik = parcelRequire("jPtik");




const $2e9a50b174f89446$export$761483e0f415164e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1651aa6544b68ec$export$d90af831494c8387), null);
$2e9a50b174f89446$export$761483e0f415164e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $jPtik.ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











const $0fb617f0ce9f4007$export$8984debadcec9d93 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$0fb617f0ce9f4007$export$8984debadcec9d93.NAVIGATION_PARAMS = ()=>false;









const $545b6e8effa8c8db$export$a21466da6a7c3088 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9Xsqa",
    name: "LazySecurityConfigurationPage",
    loader: async ()=>(await (parcelRequire("2OOsw"))).SecurityConfigurationPage
});



var $5vGLM = parcelRequire("5vGLM");




const $7fe52c8ec8c71cab$export$b882bc9c4e633e9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $545b6e8effa8c8db$export$a21466da6a7c3088), null);
$7fe52c8ec8c71cab$export$b882bc9c4e633e9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $5vGLM.ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $a1e3506434e0a4ce$export$f9089107330a702f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "n74z_",
    name: "ShareableLinkSiteAdminControlsLoader",
    loader: async ()=>(await (parcelRequire("d1a5I"))).ShareableLinkSiteAdminControls
});





const $a2ed3e45c015a582$export$aa92c319822402c4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1e3506434e0a4ce$export$f9089107330a702f), null);
$a2ed3e45c015a582$export$aa92c319822402c4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'siteSettingsAccessLinksScreen'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












var $dPJCf = parcelRequire("dPJCf");








const $96dd8e8b415e5b54$export$868f48701a8723ed = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yhJFR",
    name: "ShareableLinkSiteAdminConfigurationLoader",
    loader: async ()=>(await (parcelRequire("kJp2Z"))).SiteConfigPage
});





const $9272dc73a7cf38e5$export$8d78fedca7a630f7 = ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const handleBack = (0, $42omo.useCallback)(()=>push((0, $1NBp8.ADMIN_SHAREABLE_LINKS).toUrl()), [
        push
    ]);
    if (!(0, $6mKj3.expValEquals)('shareable_links_m0', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $96dd8e8b415e5b54$export$868f48701a8723ed), {
        onBack: handleBack
    });
};
$9272dc73a7cf38e5$export$8d78fedca7a630f7.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'siteSettingsAccessLinksConfigurationScreen'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $78ef366567be569a$export$80059957d731c042 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w8ZSB",
    name: "LazyApplicationNavigatorPage",
    loader: async ()=>(await (parcelRequire("eOW3x"))).ApplicationNavigatorPage
});



var $dWfBt = parcelRequire("dWfBt");




const $98f73671c286928d$export$55ff18e8dde17771 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $78ef366567be569a$export$80059957d731c042), null);
$98f73671c286928d$export$55ff18e8dde17771.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $dWfBt.ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $b750d916e554f7df$export$93a51467d25d0499 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "84mIg",
    name: "LazyMacroUsagePage",
    loader: async ()=>(await (parcelRequire("bz3UX"))).MacroUsagePage
});



var $9JmJC = parcelRequire("9JmJC");




const $2395a25321aca708$export$1e71122b3eac56e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b750d916e554f7df$export$93a51467d25d0499), null);
$2395a25321aca708$export$1e71122b3eac56e4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9JmJC.ADMIN_MACRO_USAGE_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $b1c56f7f0cd3abfc$export$db3288808f1d2cee = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "TlnkG",
    name: "LazyTrashedSpacesPage",
    loader: async ()=>(await (parcelRequire("4pKXe"))).TrashedSpacesPage
});



var $4l9JY = parcelRequire("4l9JY");




const $b9260b374d11ae03$export$154b40ed25137a69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1c56f7f0cd3abfc$export$db3288808f1d2cee), null);
$b9260b374d11ae03$export$154b40ed25137a69.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $4l9JY.ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $b17503f7798017b5$export$2ed44b7640eeeaea = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "X7LBt",
    name: "LazyImportSpacesPage",
    loader: async ()=>(await (parcelRequire("gGU1v"))).ImportSpacesPage
});



var $434W4 = parcelRequire("434W4");




const $d9481fcbb25a62a6$export$6078cc5c61cdb00c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b17503f7798017b5$export$2ed44b7640eeeaea), null);
$d9481fcbb25a62a6$export$6078cc5c61cdb00c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $434W4.ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $856e303ba52ed6c6$export$f522a213bf45cbaf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "s23-1",
    name: "LazyJiraMacroRepairPage",
    loader: async ()=>(await (parcelRequire("iMgCe"))).JiraMacroRepairPage
});



var $2i0P8 = parcelRequire("2i0P8");




const $3ed31ec1d64e85a3$export$1162e5a60ee7576b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $856e303ba52ed6c6$export$f522a213bf45cbaf), null);
$3ed31ec1d64e85a3$export$1162e5a60ee7576b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $2i0P8.ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $c621c947d336edb6$export$39b0a52384de05d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MZ13C",
    name: "LazyThemesPage",
    loader: async ()=>(await (parcelRequire("bKpjI"))).ThemesPage
});



var $ft9Jc = parcelRequire("ft9Jc");




const $95678b1264993b8d$export$cdc2bb4346e935c9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c621c947d336edb6$export$39b0a52384de05d), null);
$95678b1264993b8d$export$cdc2bb4346e935c9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $ft9Jc.ADMIN_THEMES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $94ac68953a95a3c6$export$def53ea7cb291102 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4g9eZ",
    name: "LazyPdfExportPage",
    loader: async ()=>(await (parcelRequire("9lL6v"))).PdfExportPage
});



var $fmC2G = parcelRequire("fmC2G");




const $d726f64aa7b98b71$export$81e12ffb7d442c0c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94ac68953a95a3c6$export$def53ea7cb291102), null);
$d726f64aa7b98b71$export$81e12ffb7d442c0c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $fmC2G.ADMIN_PDF_EXPORT_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $9f03bd3fce1c6524$export$e1745bf2bc7b6d75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "e-VGC",
    name: "LazyWatermarkConfigurationPage",
    loader: async ()=>(await (parcelRequire("iccOf"))).WatermarkConfigurationPage
});





const $1cb4912c670744a4$export$ee4273463a3d48ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9f03bd3fce1c6524$export$e1745bf2bc7b6d75), null);
$1cb4912c670744a4$export$ee4273463a3d48ad.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminWatermarkConfiguration'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









var $8Nhaa = parcelRequire("8Nhaa");




const $b39b3b8c8cb41baf$export$9334d2c8540310e3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ge6Hg",
    name: "SpaceManagerLoader",
    loader: async ()=>(await (parcelRequire("iaCjK"))).SpaceManager
});


const $244c44f585122129$export$986d179bc3f7f637 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b39b3b8c8cb41baf$export$9334d2c8540310e3), null);
$244c44f585122129$export$986d179bc3f7f637.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $8Nhaa.SPACE_MANAGER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });



/* eslint react/prop-types:0 */ 









const $d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9HaD7",
    name: "LazyDefaultSpacePermissionsPage",
    loader: async ()=>(await (parcelRequire("LmgJF"))).DefaultSpacePermissionsPage
});
const $d3d38e453fe82603$export$6b4028c8cfa4e9e1 = (routeMatch)=>{
    const { params: { tab: tab } } = routeMatch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage, {
        activeTab: tab
    });
};
$d3d38e453fe82603$export$6b4028c8cfa4e9e1.NAVIGATION_PARAMS = (routeMatch)=>({
        Screen: {
            screenEvent: {
                name: 'siteSpacePermissionsScreen',
                attributes: {
                    tab: routeMatch.params.tab
                }
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











function $09759410f0cf9b55$export$e7dd35a659f967b8({ params: { key: key, spaceKey: spaceKey }, query: query }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: key || spaceKey,
            query: query
        }
    });
}
$09759410f0cf9b55$export$e7dd35a659f967b8.NAVIGATION_PARAMS = ()=>false;











function $26b63860644dba7c$export$7bc70d297bcfbf4f(extra) {
    const redirectComponent = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name,
            params: {
                query: {
                    ...query,
                    ...extra
                }
            }
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}









var $7Snc9 = parcelRequire("7Snc9");

const $7cf8f51aa88b9ccf$export$df2de76576f721a1 = ({ pathname: pathname, search: search, query: query })=>{
    if (query['unmatched-route']) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Snc9.NotFound), null);
    search = search.startsWith('?') ? `${search}&unmatched-route=true` : `?unmatched-route=true`;
    return(//Redirect for .action pages that forces a full page reload
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    }));
};
$7cf8f51aa88b9ccf$export$df2de76576f721a1.NAVIGATION_PARAMS = ()=>false;











const $0a13ad86816c36c0$export$cdc5cf7d787e5e31 = ({ pathname: pathname, search: search, query: query })=>{
    const { draftId: draftId } = query;
    if (typeof draftId !== 'string' || !/^[0-9]+$/.test(draftId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.WIKI).name
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    });
};
$0a13ad86816c36c0$export$cdc5cf7d787e5e31.NAVIGATION_PARAMS = ()=>false;









var $bcVE2 = parcelRequire("bcVE2");





var $jxpvN = parcelRequire("jxpvN");

const $a474944cbbe3347a$var$bannerContextValue = {
    includeTopNav: false
};
const $a474944cbbe3347a$export$300afabe53226c5d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jxpvN.BannerContext).Provider, {
        value: $a474944cbbe3347a$var$bannerContextValue
    }, children);






var $d73E7 = parcelRequire("d73E7");

const $09a888bb83dd7791$var$isEmbeddedWhiteboard = ({ query: query })=>(0, $bcVE2.isEmbeddedWhiteboardMode)({
        parentProduct: query.parentProduct,
        presentationMode: query.presentationMode
    });
const $09a888bb83dd7791$export$d584a39bdee41574 = (match)=>{
    const { params: { contentId: contentId, spaceKey: spaceKey } } = match;
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d73E7.WhiteboardRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    });
    if ($09a888bb83dd7791$var$isEmbeddedWhiteboard(match) && (0, $9wGTI.fg)('confluence_ssr_embedded_whiteboard_preload_cache')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a474944cbbe3347a$export$300afabe53226c5d), null, element);
    return element;
};
$09a888bb83dd7791$export$d584a39bdee41574.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey }, query: { focusedCommentId: focusedCommentId, focusedMentionId: focusedMentionId, parentProduct: parentProduct, presentationMode: presentationMode } })=>({
        Screen: {
            screenEvent: {
                name: 'whiteboardScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    focusedCommentId: focusedCommentId,
                    focusedMentionId: focusedMentionId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'whiteboard',
                routeName: routeName
            }
        },
        MainLayout: (0, $bcVE2.isEmbeddedWhiteboardMode)({
            parentProduct: parentProduct,
            presentationMode: presentationMode
        }) && (0, $9wGTI.fg)('confluence_ssr_embedded_whiteboard_preload_cache') ? false : {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });


// Slides route — renders the whiteboard shell in slides mode.
// Downstream whiteboard components now derive slides mode from the route name
// (SLIDES_VIEW) rather than from a ?slides=true query param, so no query-param
// bridge is needed.









const $4e31866782374d42$export$3a64ee6cc47e86a4 = (match)=>{
    const { params: { contentId: contentId, spaceKey: spaceKey } } = match;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d73E7.WhiteboardRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    });
};
$4e31866782374d42$export$3a64ee6cc47e86a4.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey }, query: { focusedCommentId: focusedCommentId, focusedMentionId: focusedMentionId } })=>({
        Screen: {
            screenEvent: {
                name: 'slideScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    focusedCommentId: focusedCommentId,
                    focusedMentionId: focusedMentionId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'slide',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });












const $18b64a781b16c69e$export$e1e87cd6ad2f9497 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yFgQP",
    name: "FolderRedirectLoader",
    loader: async ()=>(await (parcelRequire("jwuij"))).FolderRedirect
});






const $47326de99f5119ec$export$cdb01b3d24a21485 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "OUrjG",
    name: "FolderContainerLoader",
    loader: async ()=>(await (parcelRequire("hMroJ"))).FolderContainer
});





const $6e131d5d0e81b5af$export$110a009c083fc1fc = ({ params: { contentId: contentId } })=>(0, $6mKj3.expVal)('confluence_folder_view', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $47326de99f5119ec$export$cdb01b3d24a21485), {
        contentId: contentId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18b64a781b16c69e$export$e1e87cd6ad2f9497), {
        contentId: contentId
    });
$6e131d5d0e81b5af$export$110a009c083fc1fc.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } })=>({
        Screen: {
            screenEvent: {
                name: 'folderScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentSlug: contentSlug,
                contentType: 'folder',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });












const $1f4e11c8ff1e70c5$export$e1cd63b567cc2910 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LWjU2",
    name: "EmbedRouteLoader",
    loader: async ()=>(await (parcelRequire("2x0sL"))).EmbedContainer
});





parcelRequire("crTA1");





const $a86e8bdaaaef979c$export$1a870b21a11af9ae = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f4e11c8ff1e70c5$export$e1cd63b567cc2910), {
        contentId: contentId,
        spaceKey: spaceKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "EmbedViewRoute"
    }));
$a86e8bdaaaef979c$export$1a870b21a11af9ae.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'smartLinkEmbedPageScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    contentType: 'embed'
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'embed',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });









const $ff966974ac17a8ae$export$d5b2cc659cf7a894 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "K1tWi",
    name: "DatabaseContainerLoader",
    loader: async ()=>(await (parcelRequire("6Bq28"))).DatabaseContainer
});









var $bwC5h = parcelRequire("bwC5h");




const $b443bc65ee980e3b$export$2b633aba04c212bb = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>(0, $9wGTI.fg)('confluence-fix-space-db-redirect-behaviour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC5h.default), {
        spaceKey: spaceKey,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ff966974ac17a8ae$export$d5b2cc659cf7a894), {
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "DatabaseViewRoute"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC5h.default), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ff966974ac17a8ae$export$d5b2cc659cf7a894), {
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "DatabaseViewRoute"
    }));
$b443bc65ee980e3b$export$2b633aba04c212bb.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'databaseScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'database',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });














const $88d3e4eaff5b722d$export$4c4704aeef10cf08 = (0, $4lJOK.getSpaceOverviewRoute)(({ spaceKey: spaceKey, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey,
            query: query
        }
    }));









const $79a774581f86de14$export$e7975a21b41d4767 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "hYSgM",
    name: "LazyLoader",
    loader: ()=>(parcelRequire("epBQg"))
});









var $iufgB = parcelRequire("iufgB");







var $6CEg5 = parcelRequire("6CEg5");




const $4da47b9dcf27590f$export$9af206dbb2b6a483 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iufgB.CreateContentRouteComponentLoader), {
        preloadWhiteboardRouteComponent: (0, $d73E7.WhiteboardRouteComponentLoader).preload,
        preloadDatabaseRouteComponent: (0, $ff966974ac17a8ae$export$d5b2cc659cf7a894).preload,
        preloadPageAndBlogRouteComponent: (0, $79a774581f86de14$export$e7975a21b41d4767).preload,
        preloadSmartLinkEmbedRouteComponent: (0, $1f4e11c8ff1e70c5$export$e1cd63b567cc2910).preload
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6CEg5.PerformanceStart), {
        subject: "PageTree",
        subjectId: "newContentRendered"
    }));
$4da47b9dcf27590f$export$9af206dbb2b6a483.NAVIGATION_PARAMS = ({ name: routeName, params: { spaceKey: spaceKey, contentType: createRouteTypeParam }, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    // spaceKey comes from query object while on creation route
    const currentSpaceKey = spaceKey || query?.spaceKey;
    const isPageLikeContent = createRouteTypeParam === 'page' || createRouteTypeParam === 'blog';
    return {
        Screen: {
            screenEvent: {
                name: 'createContentScreen'
            },
            pageState: {
                spaceKey: currentSpaceKey,
                routeName: routeName
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            // CREATE_CONTENT route can return an undefined spaceKey during creation so we render a loading screen
            navView: query.spaceKey ? (0, $lFjPc.CONTAINER_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_LOADING_ID),
            spaceKey: currentSpaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};


















const $5b463946eccb17c7$export$7bd9ae6d5c998c1f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "78c05",
    name: "SplitPageResultsLoader",
    loader: async ()=>(await (parcelRequire("bNQ52"))).SplitPageResults
});


const $f39a8f3c45c29808$export$5fb3818945ba48e4 = ({ params: params })=>{
    const { contentId: contentId, spaceKey: spaceKey } = params;
    if (!(0, $6mKj3.expValEquals)('confluence-page-splitter', 'isEnabled', 'Test')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5b463946eccb17c7$export$7bd9ae6d5c998c1f), {
        spaceKey: spaceKey,
        contentId: contentId
    });
};
$f39a8f3c45c29808$export$5fb3818945ba48e4.NAVIGATION_PARAMS = ({ name: name, params: params })=>{
    const { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } = params;
    if (!(0, $6mKj3.expValEquals)('confluence-page-splitter', 'isEnabled', 'Test')) return false;
    return {
        Screen: {
            screenEvent: {
                name: 'pageSplitScreen',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: 'page',
                contentSlug: contentSlug || ''
            },
            showPremiumOnboarding: false
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: false
        }
    };
};
























var $ko9Ek = parcelRequire("ko9Ek");




















var $4D2qK = parcelRequire("4D2qK");





const $37eba1df63470b23$export$f574cd97f97b4d34 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XaRNl",
    name: "ViewPageLiteHeaderLoader",
    loader: async ()=>(await (parcelRequire("grnbw"))).ViewPageLiteHeader
});


parcelRequire("8pBIa");
var $6Evf5 = parcelRequire("6Evf5");

parcelRequire("4Yv1J");


parcelRequire("crTA1");





const $92d3732f6f6decb7$export$e537bc4c45dc607c = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } })=>{
    const isPage = routeName === (0, $1NBp8.VIEW_PAGE).name;
    const isBlog = routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || routeName === (0, $1NBp8.VIEW_BLOG).name;
    let contentType;
    // any one of VIEW_BLOG_DATE_LEGACY, VIEW_BLOG or VIEW_PAGE route can end up here from ViewPageOrBlogRoute
    if (isBlog) contentType = 'blogpost';
    else if (isPage) contentType = 'page';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        screenEvent: {
            name: 'viewPageScreen',
            id: contentId,
            attributes: {
                isPublicView: false,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            objectType: contentType,
            objectId: contentId
        },
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            routeName: routeName,
            contentSlug: contentSlug,
            isLite: true,
            contentType: contentType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $37eba1df63470b23$export$f574cd97f97b4d34), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4D2qK.ViewPageLiteLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Evf5.default), {
        pageType: contentType
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "ViewPageLiteRoute"
    }));
};



var $lJlG6 = parcelRequire("lJlG6");

function $7a7b7faa4141aa1d$var$isLite(query) {
    return Boolean(query?.lite);
}
function $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() {
    return window?.__SSR_RENDERED__ && window?.__DELAYED_CONTENT_REDIRECTION__?.contentSlug || '';
}
const $7a7b7faa4141aa1d$export$51ff3cc323c1250d = (props)=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const { name: name, params: params, query: query } = props;
    const { contentId: contentId, spaceKey: spaceKey } = params;
    const isViewPage = name === (0, $1NBp8.VIEW_PAGE).name;
    if ($7a7b7faa4141aa1d$var$isLite(query)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92d3732f6f6decb7$export$e537bc4c45dc607c), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ko9Ek.ViewPageRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId,
        isMobile: isMobile,
        isPage: isViewPage,
        // TODO: When we have a new `<MobileAppViewPageLoader />` component for the mobile app, update this component to
        //   pass `isMobileApp` here as an additional prop, and inside the component, check if `isMobileApp` is true and
        //   if so, use the new `<MobileAppViewPageLoader />` component
        // https://product-fabric.atlassian.net/browse/REACT-8691
        isEmbeddedConfluence: isEmbeddedConfluence || isMobileApp
    }));
};
$7a7b7faa4141aa1d$export$51ff3cc323c1250d.NAVIGATION_PARAMS = ({ name: name, params: params, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence && !isMobileApp;
    const { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } = params;
    const isViewBlog = name === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || name === (0, $1NBp8.VIEW_BLOG).name;
    const contentType = isViewBlog ? 'blogpost' : 'page';
    if ($7a7b7faa4141aa1d$var$isLite(query)) return false;
    // Use contentSlug from SSR delayed-redirection if available
    const correctContentSlug = $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() || contentSlug || '';
    return {
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                objectType: contentType,
                objectId: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType,
                contentSlug: correctContentSlug
            },
            showPremiumOnboarding: showPremiumOnboarding
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            isViewPage: true
        }
    };
};









const $674c97fafa39ddaa$export$c8774699c65926c8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "djuV7",
    name: "TopicHomepage",
    loader: async ()=>(await (parcelRequire("dBHLx"))).TopicHomepageComponent
});














const $ad7e3274b7fede14$export$54f890efdb9a624 = ({ params: { topicId: topicId } })=>{
    if (!(0, $9wGTI.fg)('confluence_enable_ai_topics_homepage')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $674c97fafa39ddaa$export$c8774699c65926c8), {
        topicId: topicId
    });
};
$ad7e3274b7fede14$export$54f890efdb9a624.NAVIGATION_PARAMS = ({ params: { topicId: topicId } })=>({
        Screen: {
            screenEvent: {
                name: 'topicsScreen'
            },
            pageState: {
                topicId: topicId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            topicId: topicId
        }
    });












const $44ff6e33806985ff$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ULKKd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("jEQIl"))
});
const $44ff6e33806985ff$export$384dd5b6b76557b1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($44ff6e33806985ff$var$QuestionsRouteComponent, {
        spaceKey: spaceKey
    });
};
const $44ff6e33806985ff$export$9f80bcb940c350e6 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($44ff6e33806985ff$var$QuestionsRouteComponent, {
        spaceKey: spaceKey,
        openCreateQuestionModal: true
    });
};
$44ff6e33806985ff$export$384dd5b6b76557b1.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'questionsScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });
$44ff6e33806985ff$export$9f80bcb940c350e6.NAVIGATION_PARAMS = $44ff6e33806985ff$export$384dd5b6b76557b1.NAVIGATION_PARAMS;






var $dY5Vp = parcelRequire("dY5Vp");




function $281ce5bf20714bdc$export$aea18e9fd89afe15({ params: { spaceKey: spaceKey, questionId: questionId } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dY5Vp.LazyQuestions), {
        spaceKey: spaceKey,
        questionId: questionId
    });
}
$281ce5bf20714bdc$export$aea18e9fd89afe15.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'questionScreen',
                questionId: questionId
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $34607f68a2922062$export$5d828b79b8aa9d27 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "y34AA",
    name: "SiteAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("bfcuB"))).SiteAnalyticsPage
});





const $63dcc013c61b21bf$export$ccfda76403f5bd22 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $34607f68a2922062$export$5d828b79b8aa9d27), null);
};
$63dcc013c61b21bf$export$ccfda76403f5bd22.NAVIGATION_PARAMS = ({ name: name, params: { tab: tab } })=>{
    return {
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                routeName: name,
                tab: tab
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};









const $421f3eadd830fd14$export$6dd852c6aabadfda = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rTAZ6",
    name: "SitePermissionsPageLoader",
    loader: async ()=>(await (parcelRequire("3vULB"))).SitePermissionsPage
});





const $2dd41eaa3836b7ed$export$7ed59daacefa1324 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $421f3eadd830fd14$export$6dd852c6aabadfda), null);
};
$2dd41eaa3836b7ed$export$7ed59daacefa1324.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'instanceAnalyticsPermissions'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $b925f878325ca863$export$1c22a22c4bc3d8e9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "D9x42",
    name: "PageAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("83I8f"))).PageAnalyticsPage
});





const $2ddeeae61cd450c5$export$77b30b491c5d0ee0 = ({ params: { contentId: contentId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b925f878325ca863$export$1c22a22c4bc3d8e9), {
        contentId: contentId
    });
};
$2ddeeae61cd450c5$export$77b30b491c5d0ee0.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, tab: tab } })=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $lFjPc.CONTAINER_HOME_ID)
        }
    });









const $9c22efa8f8a6df7c$export$5c0ffde074fc4758 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VV9sG",
    name: "SpaceAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("5zOxZ"))).SpaceAnalyticsPage
});





parcelRequire("crTA1");


const $e76c2474e57ea114$export$af7907eff44c835f = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c22efa8f8a6df7c$export$5c0ffde074fc4758), {
        spaceKey: spaceKey
    }));
};
$e76c2474e57ea114$export$af7907eff44c835f.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, tab: tab } }, isNav4Enabled)=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID)
        }
    });














const $4a724484ea837e6c$export$703d82918dc06325 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
            spaceKey: spaceKey,
            tab: 'analytics'
        })
    });
$4a724484ea837e6c$export$703d82918dc06325.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceAnalyticsPermissions',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID)
        }
    });





















const $b819de32c6839e12$var$LazySpaceLegacyContentRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Fm82P",
    name: "LazySpaceLegacyContentRouteComponent",
    loader: async ()=>(await (parcelRequire("5tYsv"))).SpaceLegacyContentRouteComponent
});
const $b819de32c6839e12$export$f983b39883686021 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('cc-admin-exp-legacy-content-report', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b819de32c6839e12$var$LazySpaceLegacyContentRouteComponent, {
        spaceKey: spaceKey
    });
};
$b819de32c6839e12$export$f983b39883686021.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            pageState: {
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'legacyContentScreen'
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });





















const $baeceeb2053ed280$var$LazySpaceAvatarsSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6fQBw",
    name: "LazySpaceAvatarsSettingsRouteComponent",
    loader: async ()=>(await (parcelRequire("kFptA"))).SpaceAvatarsSettingsRouteComponent
});
const $baeceeb2053ed280$export$232f775b06326172 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_approvals_eap', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($baeceeb2053ed280$var$LazySpaceAvatarsSettingsRouteComponent, {
        spaceKey: spaceKey
    });
};
$baeceeb2053ed280$export$232f775b06326172.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            pageState: {
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'avatarsSettingsScreen'
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });





















const $1a46d2ab385e41f3$var$LazySpaceStatusAndApprovalsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "szUQW",
    name: "LazySpaceStatusAndApprovalsRouteComponent",
    loader: async ()=>(await (parcelRequire("19zWE"))).SpaceStatusAndApprovalsRouteComponent
});
const $1a46d2ab385e41f3$export$905b6f7e554c11f5 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_approvals_eap', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a46d2ab385e41f3$var$LazySpaceStatusAndApprovalsRouteComponent, {
        spaceKey: spaceKey
    });
};
$1a46d2ab385e41f3$export$905b6f7e554c11f5.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            pageState: {
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'statusAndApprovalsScreen'
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $bab2dace65c311d3$export$2b00c7dac5a350a7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "c1xIf",
    name: "SmartCreateSpaceLoader",
    loader: async ()=>(await (parcelRequire("hKYBj"))).SmartCreateSpace
});











const $f9a064f293d5119a$export$683599b1d0dc8e7b = ()=>{
    if (!(0, $9wGTI.fg)('aifc_space_creation_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.HOME).toUrl()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bab2dace65c311d3$export$2b00c7dac5a350a7), null);
};
$f9a064f293d5119a$export$683599b1d0dc8e7b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'spaceSmartCreateScreen'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });












const $e1b3581d111cffc5$export$d563a43e58d8e249 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nNYrs",
    name: "LazyUserAccessPage",
    loader: async ()=>(await (parcelRequire("k2W0I"))).UserAccessPage
});



var $l5PUQ = parcelRequire("l5PUQ");

const $c4bba5ee88869a52$export$45dbe3e1239d2b94 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1b3581d111cffc5$export$d563a43e58d8e249), null);
$c4bba5ee88869a52$export$45dbe3e1239d2b94.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $l5PUQ.ADMIN_USER_ACCESS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });






var $4xcIM = parcelRequire("4xcIM");


var $dh538 = parcelRequire("dh538");













const $69b9df17dc76bcc3$export$31b05ec87f8c8c11 = 'confluence-fe-space-settings-enable-afm-pdf';

const $69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EoQbw",
    name: "LazyExportSpaceRouteComponent",
    loader: async ()=>(await (parcelRequire("964fa"))).ExportSpaceRouteComponent
});
const $69b9df17dc76bcc3$export$4d1bd2808cfd2f38 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $dh538.fg)($69b9df17dc76bcc3$export$31b05ec87f8c8c11)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.LEGACY_SPACE_PDF_EXPORT).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent, {
        spaceKey: spaceKey
    });
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.propTypes = {
    params: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired
    }).isRequired
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'ExportSpaceScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $8e1d38472579226f$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yT4rd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("jEQIl"))
});
const $8e1d38472579226f$export$6cff3d6e80ecc64 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e1d38472579226f$var$QuestionsRouteComponent, {
        isGlobalPage: true
    });
};
$8e1d38472579226f$export$6cff3d6e80ecc64.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });












const $a488bad1e68dd6a7$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6VNHf",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("jEQIl"))
});
const $a488bad1e68dd6a7$export$5c0c86e79c0609bd = ({ params: { questionId: questionId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a488bad1e68dd6a7$var$QuestionsRouteComponent, {
        questionId: questionId,
        spaceKey: spaceKey,
        isGlobalPage: true
    });
};
$a488bad1e68dd6a7$export$5c0c86e79c0609bd.NAVIGATION_PARAMS = ({ params: { questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionScreen',
                questionId: questionId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });








// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 




const $ce2cb80274e3a560$export$67d9d65bd2b4815 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PsbBz",
    name: "ImporterDashboardLoader",
    loader: async ()=>(await (parcelRequire("lkTzI"))).ImporterDashboard
});


const $e2dae4d283de07f2$export$abf2f9d0f3a44f9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ce2cb80274e3a560$export$67d9d65bd2b4815), null);
$e2dae4d283de07f2$export$abf2f9d0f3a44f9c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'IMPORTER_STATUS_DASHBOARD'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $95bf1213cdd8988b$export$989c0e84e4723f09 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "e5N_k",
    name: "LazyNBMPage",
    loader: async ()=>(await (parcelRequire("h84KH"))).NBMPage
});





const $0a6ea19b0fb236e1$export$e644f8e819f9f36 = ({ params: { scanId: scanId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95bf1213cdd8988b$export$989c0e84e4723f09), {
        scanId: scanId
    });
$0a6ea19b0fb236e1$export$e644f8e819f9f36.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminNBMMigration'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $198dcbe4d14ced85$export$a3c0c81377169fa4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "7zyLS",
    name: "LazyDCScriptMigrationPage",
    loader: async ()=>(await (parcelRequire("edpw6"))).DCScriptMigrationPage
});





const $a58212c7e75084fc$export$4b568b9f0da70fe4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $198dcbe4d14ced85$export$a3c0c81377169fa4), null);
$a58212c7e75084fc$export$4b568b9f0da70fe4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminDCScriptMigration'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $68d7a2def2ba29ce$export$2779aee8643e6e52 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "eJge6",
    name: "LazyNBMPerformanceReportPage",
    loader: async ()=>(await (parcelRequire("hbqB4"))).NBMPerformanceReportPage
});





const $8a13ebd6aa0a88b0$export$84f173be1e35ceff = ({ params: { scanId: scanId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $68d7a2def2ba29ce$export$2779aee8643e6e52), {
        scanId: scanId
    });
$8a13ebd6aa0a88b0$export$84f173be1e35ceff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminNBMPerformanceReport'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $2eac21f7c787ce68$export$e9527e3d8dc95465 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "2Y2rY",
    name: "AttachmentsPageLoader",
    loader: async ()=>(await (parcelRequire("mSA7M"))).AttachmentsPage
});








const $167b5527ac95ab07$export$fd9e136112feb41f = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expValEquals)('cc_attachments_page', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2eac21f7c787ce68$export$e9527e3d8dc95465), {
        contentId: contentId,
        spaceKey: spaceKey
    });
};
$167b5527ac95ab07$export$fd9e136112feb41f.NAVIGATION_PARAMS = ({ name: routeName, params: params })=>{
    const { spaceKey: spaceKey, contentId: contentId } = params;
    return {
        Screen: {
            screenEvent: {
                name: 'attachmentsPage',
                id: contentId
            },
            pageState: {
                routeName: routeName,
                contentId: contentId,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    };
};





















const $b29dfc1baf0b1da5$export$842f6d7651a65eb6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qf_1G",
    name: "AISearchPage",
    loader: async ()=>(await (parcelRequire("ehBkr"))).AISearchMain
});


const $962d6764e800d7d4$export$e23fb2c3ce6c7abf = ()=>{
    if (!(0, $9wGTI.fg)('rovo_ai_mode_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b29dfc1baf0b1da5$export$842f6d7651a65eb6), null);
};
$962d6764e800d7d4$export$e23fb2c3ce6c7abf.NAVIGATION_PARAMS = (routeMatch)=>{
    const aiSearchQuery = routeMatch?.query?.aiSearchQuery ?? '';
    return {
        Screen: {
            screenEvent: {
                name: 'aiSearchPageScreen'
            },
            pageState: {
                aiSearchQuery: aiSearchQuery
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            aiSearchQuery: aiSearchQuery
        }
    };
};












const $8fead1916e46fc92$export$8fc14d22356d64d4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ljR4j",
    name: "LazyPermissionsExportPage",
    loader: async ()=>(await (parcelRequire("4M3H8"))).PermissionsExportPage
});


const $6deffcd0919e3152$var$PERMISSIONS_EXPORT_ANALYTICS_SOURCE = 'adminPermissionsExport';
const $6deffcd0919e3152$export$9dc6a62d8cf9ae06 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8fead1916e46fc92$export$8fc14d22356d64d4), null);
$6deffcd0919e3152$export$9dc6a62d8cf9ae06.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $6deffcd0919e3152$var$PERMISSIONS_EXPORT_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $d1a3d93d30978035$export$a1aaf5446f2374eb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "otSDI",
    name: "LazyAssignRolesPage",
    loader: async ()=>(await (parcelRequire("2Ifa7"))).AssignRolesPage
});


const $5fcbb229533ae7f5$var$PERMISSIONS_COMBINATIONS_ANALYTICS_SOURCE = 'adminPermissionsCombinations';
const $5fcbb229533ae7f5$export$2cdfcdcf001693ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d1a3d93d30978035$export$a1aaf5446f2374eb), null);
$5fcbb229533ae7f5$export$2cdfcdcf001693ff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $5fcbb229533ae7f5$var$PERMISSIONS_COMBINATIONS_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $3b0f1c21afd88c83$export$9950ebbef62306b5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "v4Ssn",
    name: "LazySystemOperationsPage",
    loader: async ()=>(await (parcelRequire("lQqv5"))).SystemOperationsPage
});


const $7fda056324955ad3$var$SYSTEM_OPERATIONS_ANALYTICS_SOURCE = 'adminSystemOperations';
const $7fda056324955ad3$export$26979a3c4ac291c5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b0f1c21afd88c83$export$9950ebbef62306b5), null);
$7fda056324955ad3$export$26979a3c4ac291c5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $7fda056324955ad3$var$SYSTEM_OPERATIONS_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











var $92IuX = parcelRequire("92IuX");



const $beac86ab997501a9$var$AUDIT_LOG_ANALYTICS_SOURCE = 'audit-log';
const $beac86ab997501a9$export$b6dab1e8a8b6a66d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92IuX.AuditLogLoader), null);
$beac86ab997501a9$export$b6dab1e8a8b6a66d.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $beac86ab997501a9$var$AUDIT_LOG_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });








parcelRequire("4Yv1J");


const $4afa1bc9a87a9b40$export$58816268cacd10b6 = (0, $SwMnm.getAccessLinkRoute)({
    ContextProvider: (0, $f5aR2.ContentExtensionsProvider),
    NotFound: $wtSEP.NotFound
});












const $b2177b1b2ac4dbde$export$ca2a4947b862b5fa = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w3AoH",
    name: "ShareableLinkSpaceAdminControlsLoader",
    loader: async ()=>(await (parcelRequire("1nRfY"))).ShareableLinkSpaceAdminControls
});


const $59aa589db7ef9ce2$export$1e82a9179bad8a9a = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2177b1b2ac4dbde$export$ca2a4947b862b5fa), {
        spaceKey: spaceKey
    });
};
$59aa589db7ef9ce2$export$1e82a9179bad8a9a.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsAccessLinksScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });
























const $4bccd682b45dd1bd$export$6624b9636171dd7c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "_Q5hm",
    name: "ShareableLinkSpaceAdminConfigurationLoader",
    loader: async ()=>(await (parcelRequire("f1YWS"))).SpaceConfigPage
});


const $cda2b7f6563453d4$export$cf69ae5c9e6b5385 = ({ params: { spaceKey: spaceKey } })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const handleBack = (0, $42omo.useCallback)(()=>push((0, $1NBp8.SPACE_SETTINGS_SHAREABLE_LINKS).toUrl({
            spaceKey: spaceKey
        })), [
        push,
        spaceKey
    ]);
    if (!(0, $6mKj3.expValEquals)('shareable_links_m0', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4bccd682b45dd1bd$export$6624b9636171dd7c), {
        onBack: handleBack,
        spaceKey: spaceKey
    });
};
$cda2b7f6563453d4$export$cf69ae5c9e6b5385.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsAccessLinksConfigurationScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $lFjPc.CONTAINER_ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });


function $c6a4b2258628a516$var$redirect(name) {
    const redirectComponent = ({ params: params = {} })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: name,
            params: params
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}
const $c6a4b2258628a516$export$4d9abfe5519d76c6 = (0, $jiFpb.processNavigationParams)({
    [(0, $64KID.namedRoutes).BASE.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).WIKI.name),
    [(0, $64KID.namedRoutes).WIKI.name]: (0, $75f6c666a9c742b2$export$e5707bd7e32dbf9b),
    [(0, $64KID.namedRoutes).HOME.name]: (0, $4625b8b3d160569d$export$48d3d184aade51b1),
    [(0, $64KID.namedRoutes).MOBILE_TAKEOVER_PAGE.name]: (0, $7b810fd40f00ac37$export$1a98ae7373202607),
    [(0, $64KID.namedRoutes).MOBILE_MACRO_RENDERER.name]: (0, $fcdf58a0a381c832$export$29b5dbba9b9e21d8),
    [(0, $64KID.namedRoutes).TEMPLATE_GALLERY.name]: (0, $0f81c6a8d9931e4d$export$e2ed88affe37abdc),
    [(0, $64KID.namedRoutes).EDIT_PAGE.name]: (0, $2807fe6645e49e0b$export$6a3218472cdf374a),
    [(0, $64KID.namedRoutes).EDIT_BLOG.name]: (0, $cdf2efa932a544ee$export$657999c2675036a8),
    [(0, $64KID.namedRoutes).EDIT_PAGE_V2.name]: (0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9),
    [(0, $64KID.namedRoutes).EDIT_BLOG_V2.name]: (0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9),
    [(0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name]: (0, $dde5e37bf0f94188$export$a338f76d183c610),
    [(0, $64KID.namedRoutes).EDIT_PAGE_SMART_CREATE.name]: (0, $bb42a89ba72dd22d$export$997e52ba9fce325c),
    [(0, $64KID.namedRoutes).AI_PLANNER_CONFLUENCE_BRIDGE.name]: (0, $819b80c2c59a2565$export$bb48d26d51801617),
    [(0, $64KID.namedRoutes).CREATE_CONTENT.name]: (0, $4da47b9dcf27590f$export$9af206dbb2b6a483),
    [(0, $64KID.namedRoutes).CREATE_PAGE.name]: (0, $93e08279e521422d$export$92431fd1ef2a3e02),
    [(0, $64KID.namedRoutes).CREATE_BLOG.name]: (0, $c3c08e13adc00b49$export$daeca97aa431dd80),
    [(0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).CREATE_PAGE_VARIABLES_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).RESUME_DRAFT_LEGACY.name]: (0, $0a13ad86816c36c0$export$cdc5cf7d787e5e31),
    [(0, $64KID.namedRoutes).COPY_PAGE_LEGACY.name]: (0, $e9270d50e13c4524$export$58ad04e57ec143c3),
    [(0, $64KID.namedRoutes).DASHBOARD_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).SPA_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).INDEX_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).VIEW_PAGE_ACTION_LEGACY.name]: (0, $1547fdfac1788133$export$70a5a4ee184a1106),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_INDEX_ACTION_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    [(0, $64KID.namedRoutes).SPACE_INDEX_ACTION_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    // it should be after "INDEX_ACTION_LEGACY", and can't be the last one, as it will brake navigation to space settings
    [(0, $64KID.namedRoutes).ACTION_REDIRECT_LEGACY.name]: (0, $7cf8f51aa88b9ccf$export$df2de76576f721a1),
    [(0, $64KID.namedRoutes).SPACE_DIRECTORY.name]: (0, $6b9376eebbcdd446$export$e2f6c7ec524fdd6a),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_REDIRECT_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    [(0, $64KID.namedRoutes).SPACE_INDEX.name]: (0, $88d3e4eaff5b722d$export$4c4704aeef10cf08),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW.name]: (0, $8290afb66ac54848$export$200c90655ff1c697),
    [(0, $64KID.namedRoutes).HUB.name]: (0, $f6b27607b6d81126$export$d8819c37d45ffdfc),
    [(0, $64KID.namedRoutes).HUB_EDIT.name]: (0, $437f27e114bb0121$export$29545d7913f7e4d9),
    [(0, $64KID.namedRoutes).COMPANY_HUB.name]: (0, $f6b27607b6d81126$export$d8819c37d45ffdfc),
    [(0, $64KID.namedRoutes).COMPANY_HUB_ANALYTICS.name]: (0, $b5f6e0dacae3f98e$export$ccf9c625603cc873),
    [(0, $64KID.namedRoutes).COMPANY_HUB_EDIT.name]: (0, $1f7939e43bf6965f$export$335f265b0f783405),
    [(0, $64KID.namedRoutes).COMPANY_HUB_SETTINGS.name]: (0, $dbfb738401d21a8a$export$5df4bb70a888e6ef),
    [(0, $64KID.namedRoutes).GLOBAL_PAGE_FORGE.name]: (0, $88f9531119605f50$export$a0e2b6c59fd25a4e),
    [(0, $64KID.namedRoutes).SPACE_PAGES.name]: (0, $3ae3b5e6a32b9f05$export$64ef8a59e56631d4),
    [(0, $64KID.namedRoutes).VIEW_PAGE.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).PAGE_SPLIT.name]: (0, $f39a8f3c45c29808$export$5fb3818945ba48e4),
    [(0, $64KID.namedRoutes).BLOG_HOME.name]: (0, $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e),
    [(0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).VIEW_BLOG.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).WHITEBOARD_HOME.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_PAGES.name),
    [(0, $64KID.namedRoutes).WHITEBOARD_BOARD.name]: (0, $09a888bb83dd7791$export$d584a39bdee41574),
    [(0, $64KID.namedRoutes).SLIDES_VIEW.name]: (0, $4e31866782374d42$export$3a64ee6cc47e86a4),
    [(0, $64KID.namedRoutes).DATABASE_VIEW.name]: (0, $b443bc65ee980e3b$export$2b633aba04c212bb),
    [(0, $64KID.namedRoutes).EMBED_VIEW.name]: (0, $a86e8bdaaaef979c$export$1a870b21a11af9ae),
    [(0, $64KID.namedRoutes).FOLDER_VIEW.name]: (0, $6e131d5d0e81b5af$export$110a009c083fc1fc),
    [(0, $64KID.namedRoutes).CONTACT_ADMINISTRATOR.name]: (0, $95bdd88deead3c11$export$ecc44bd892306adb),
    [(0, $64KID.namedRoutes).SPACE_CALENDARS.name]: (0, $116a232d5237eb91$export$c1ba174e1a668b1a),
    [(0, $64KID.namedRoutes).SPACE_CALENDARS_SUBCALENDAR.name]: (0, $116a232d5237eb91$export$c1ba174e1a668b1a),
    [(0, $64KID.namedRoutes).SPACE_EMBEDDED_SUBCALENDAR.name]: (0, $40c2c72cc1663e14$export$b6ba0c14cb68dffc),
    [(0, $64KID.namedRoutes).MULTIPLE_SUBCALENDAR.name]: (0, $d017e5de5f44817e$export$6443958a7203f769),
    [(0, $64KID.namedRoutes).EMBEDDED_MULTIPLE_SUBCALENDAR.name]: (0, $d3bef7a856c272ba$export$5984a4822491c8de),
    [(0, $64KID.namedRoutes).DISCOVER.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: ''
    }),
    [(0, $64KID.namedRoutes).ALL_UPDATES.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: 0
    }),
    [(0, $64KID.namedRoutes).POPULAR.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: 1,
        feedType: 'POPULAR'
    }),
    [(0, $64KID.namedRoutes).MY_WORK_HOME.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1
    }),
    [(0, $64KID.namedRoutes).MY_WORK_DRAFTS.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 2
    }),
    [(0, $64KID.namedRoutes).RECENT_DRAFTS.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 2
    }),
    [(0, $64KID.namedRoutes).MY_WORK_RECENT.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1,
        filter: 'WORKED_ON'
    }),
    [(0, $64KID.namedRoutes).RECENT_PAGES.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1
    }),
    [(0, $64KID.namedRoutes).MY_RECENTLY_VISITED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 0
    }),
    [(0, $64KID.namedRoutes).RECENT_VISITED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 0
    }),
    [(0, $64KID.namedRoutes).MY_SAVED_FOR_LATER.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 3
    }),
    [(0, $64KID.namedRoutes).RECENT_SAVED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 3
    }),
    [(0, $64KID.namedRoutes).TEMPLATE_MIGRATION_PREVIEW.name]: (0, $a310d6589e3c6137$export$2549ad5558b468ce),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_BLUEPRINT.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_SPACE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE_SPACE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).ADVANCED_SEARCH.name]: (0, $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f),
    [(0, $64KID.namedRoutes).EXTERNAL_SHARE.name]: (0, $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f),
    [(0, $64KID.namedRoutes).ACCESS_LINK.name]: (0, $4afa1bc9a87a9b40$export$58816268cacd10b6),
    [(0, $64KID.namedRoutes).PEOPLE_DIRECTORY.name]: (0, $24a857c7c96255d7$export$c7bf94fd367d52ef),
    [(0, $64KID.namedRoutes).MARKETPLACE_APP_REQUESTS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).MARKETPLACE_MANAGE_PROMOTIONS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).MARKETPLACE_FIND_APPS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).CONTENT_HISTORY.name]: (0, $48c85dee1e05da94$export$e510023ce2e8f364),
    [(0, $64KID.namedRoutes).ONBOARDING.name]: (0, $52219feed318a69e$export$329ee42b27a3306e),
    [(0, $64KID.namedRoutes).ADMIN_GLOBAL_AUTOMATION.name]: (0, $9dff8dc763109b25$export$a4a7c409f3d3e524),
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS.name]: (0, $5651b1434c6bae88$export$72e24cb8f0330a61),
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HUB_PERMISSIONS.name]: (0, $ce2a2ee7f6871785$export$eeb7368e8bf944ac),
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HOME_BUILDER.name]: (0, $4fa13b181dc663ad$export$5744f34ed241a45c),
    [(0, $64KID.namedRoutes).ADMIN_CUSTOMIZE_NAVIGATION.name]: (0, $4fa13b181dc663ad$export$3206f56dd9eda6e),
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS.name]: (0, $3e17cd15ad9a2d77$export$ef0ae9b94af7599),
    [(0, $64KID.namedRoutes).ADMIN_EDIT_EXTERNAL_SHARING.name]: (0, $0960da40109465b4$export$af4daa43ca1332b9),
    [(0, $64KID.namedRoutes).ADMIN_ANONYMOUS_ACCESS.name]: (0, $d86fe9bfb21b5293$export$1d391e6d67538b19),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_MANAGEMENT.name]: (0, $4fabe80bae5e8d04$export$fd1cbd536f2e61b4),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_DEFAULTS.name]: (0, $25cfc5c41bd5d05f$export$5425f152a964e2a4),
    [(0, $64KID.namedRoutes).ADMIN_GUESTS.name]: (0, $e5c5bd5a8c7b0d6f$export$16c169bdc6cd5ebe),
    [(0, $64KID.namedRoutes).ADMIN_APP_PERMISSIONS.name]: (0, $9cf8f85dda9fbba2$export$74dc62432aba2eaa),
    [(0, $64KID.namedRoutes).ADMIN_JSM_ACCESS.name]: (0, $862979a48c317517$export$bc6803ac9d998199),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_ROLES.name]: (0, $815c579597235468$export$3d75421a82ac4ef3),
    [(0, $64KID.namedRoutes).ADMIN_SITE_PERMISSIONS.name]: (0, $139f96c2577c166d$export$29c72ea3332ea2cc),
    [(0, $64KID.namedRoutes).ADMIN_FORGE_APPS_REDIRECT.name]: (0, $5d42f987126d0d25$export$1eaead8b8e68953c),
    [(0, $64KID.namedRoutes).ADMIN_FORGE_APPS.name]: (0, $d553d8b4da7f3160$export$25552d6a584e1fb8),
    [(0, $64KID.namedRoutes).ADMIN_BETA_FEATURES.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name),
    [(0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name]: (0, $7949c11e9e78d917$export$39279dc1d0cb138f),
    [(0, $64KID.namedRoutes).ADMIN_NOTIFICATIONS.name]: (0, $5035325f0c8b9a13$export$65794158c09a379),
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    [(0, $64KID.namedRoutes).SITE_ANALYTICS.name]: (0, $63dcc013c61b21bf$export$ccfda76403f5bd22),
    [(0, $64KID.namedRoutes).SITE_ANALYTICS_PERMISSIONS.name]: (0, $2dd41eaa3836b7ed$export$7ed59daacefa1324),
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS.name]: (0, $e76c2474e57ea114$export$af7907eff44c835f),
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS_PERMISSIONS.name]: (0, $4a724484ea837e6c$export$703d82918dc06325),
    [(0, $64KID.namedRoutes).SPACE_SMART_CREATE.name]: (0, $f9a064f293d5119a$export$683599b1d0dc8e7b),
    [(0, $64KID.namedRoutes).PAGE_ANALYTICS.name]: (0, $2ddeeae61cd450c5$export$77b30b491c5d0ee0),
    [(0, $64KID.namedRoutes).SPACE_ARCHIVED_PAGES.name]: (0, $6079beeead36a4aa$export$77792abc2bfae7a1),
    [(0, $64KID.namedRoutes).SPACE_CONTRIBUTORS.name]: (0, $4a57d37907c9234e$export$68e37a802707fb55),
    [(0, $64KID.namedRoutes).SPACE_SUGGESTIONS.name]: (0, $2593d4b17876c400$export$a3041cafa4dd68cd),
    [(0, $64KID.namedRoutes).SPACE_BULK_TOOLS.name]: (0, $95e685c28d9f350e$export$690ececaf2f5ac01),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name]: (0, $bdfe305fbc319d8d$export$b0e13503df86295),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE_ALT.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name),
    [(0, $64KID.namedRoutes).SPACE_FORGE_APPS.name]: (0, $e20a45805838a7c5$export$16cbc228d727cb5e),
    [(0, $64KID.namedRoutes).SPACE_CUSTOM_CONTENT_LIST.name]: (0, $25fdeb0a789de125$export$1045fc666c352ae6),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_FORGE_APPS.name]: (0, $70d1956925899c9e$export$21a09e0ddc77eafe),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_ARCHIVE_SPACE.name]: (0, $3d2592d831aaf97c$export$c5e406a0947cdc56),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDITOR_CONVERSION.name]: (0, $c1c9698c93be07c8$export$698dfc3fe326e6d2),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AUTOMATION.name]: (0, $d6b8391ba067d418$export$3e7656e40361b9c3),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AVATARS_AND_STATUS.name]: (0, $ada82682e35c0989$export$9cf7aa4fa48eb220),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_CONTENT_STATE.name]: (0, $ada82682e35c0989$export$9cf7aa4fa48eb220),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DATA_CLASSIFICATION.name]: (0, $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_WATERMARK_CONFIGURATION.name]: (0, $0db33795337c2a26$export$2bb331cf926ecae2),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE.name]: (0, $e2d8d9818dde6381$export$1d1f8d0ef7c7a185),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT.name]: (0, $69b9df17dc76bcc3$export$4d1bd2808cfd2f38),
    [(0, $64KID.namedRoutes).SPACE_LEGACY_CONTENT.name]: (0, $b819de32c6839e12$export$f983b39883686021),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AVATARS.name]: (0, $baeceeb2053ed280$export$232f775b06326172),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_STATUS_AND_APPROVALS.name]: (0, $1a46d2ab385e41f3$export$905b6f7e554c11f5),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_RELATED_PAGES.name]: (0, $5fd2607ebf0fb934$export$50efde5a87cc8957),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDIT_FEATURES.name]: (0, $c991c60ce35a3f45$export$769dfef0447f3a55),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AGENT_CONTEXT.name]: (0, $d79bba560e75ebc3$export$5cb7b3311cd85f89),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DETAILS.name]: (0, $ae6364090fd3faa0$export$45c01163cd56b3a2),
    [(0, $64KID.namedRoutes).SPACE_QUESTIONS_NATIVE.name]: (0, $44ff6e33806985ff$export$384dd5b6b76557b1),
    [(0, $64KID.namedRoutes).SPACE_QUESTIONS_ASK_NATIVE.name]: (0, $44ff6e33806985ff$export$9f80bcb940c350e6),
    [(0, $64KID.namedRoutes).SPACE_QUESTION_NATIVE.name]: (0, $281ce5bf20714bdc$export$aea18e9fd89afe15),
    [(0, $64KID.namedRoutes).QUESTIONS_NATIVE.name]: (0, $8e1d38472579226f$export$6cff3d6e80ecc64),
    [(0, $64KID.namedRoutes).QUESTION_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).QUESTIONS_TOPICS_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).QUESTIONS_TOPIC_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).QUESTIONS_EXPERTS_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).MY_CALENDAR.name]: (0, $e84d6ad8839aa142$export$355693d248632c9a),
    [(0, $64KID.namedRoutes).PDF_EXPORT_PAGE.name]: (0, $de365c057d45c0f8$export$d4d3fe32e0af1ab9),
    [(0, $64KID.namedRoutes).PDF_EXPORT_SPACE.name]: (0, $cdc5bb1b4ce25ace$export$f10520cd46ef45dd),
    [(0, $64KID.namedRoutes).CUSTOM_CONTENTS_ON_PAGE_LIST.name]: (0, $4af991445198673b$export$80477c996ae74379),
    [(0, $64KID.namedRoutes).CUSTOM_CONTENT_VIEW.name]: (0, $c7473af47fe3192c$export$b836ebd0f49cc9f5),
    [(0, $64KID.namedRoutes).SPACE_PERMISSIONS_SETTINGS.name]: (0, $3dace45d43821ccc$export$c4e68572e7b94bc6),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_SHAREABLE_LINKS.name]: (0, $59aa589db7ef9ce2$export$1e82a9179bad8a9a),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_SHAREABLE_LINKS_CONFIGURATION.name]: (0, $cda2b7f6563453d4$export$cf69ae5c9e6b5385),
    [(0, $64KID.namedRoutes).ROLE_BASED_ACCESS_CONTROL_HUB.name]: (0, $1fb601398675b5a1$export$23838e4b7dc196e5),
    [(0, $64KID.namedRoutes).SPACE_LOOK_AND_FEEL_SETTINGS.name]: (0, $ea3042d7dfb4b938$export$9ebf5b01b0356442),
    [(0, $64KID.namedRoutes).ADMIN_ANNOUNCEMENT_BANNER_RENDERER.name]: (0, $e77b8eed9c4fe03f$export$81a4ecf687c4a61b),
    [(0, $64KID.namedRoutes).SPACE_MANAGER.name]: (0, $244c44f585122129$export$986d179bc3f7f637),
    [(0, $64KID.namedRoutes).USER_ACCESS.name]: (0, $c4bba5ee88869a52$export$45dbe3e1239d2b94),
    [(0, $64KID.namedRoutes).ADMIN_CENTER.name]: (0, $36a63e56cd2b2984$export$60c1a30975370191),
    [(0, $64KID.namedRoutes).ADMIN_CENTER_SPACE.name]: (0, $015145ca08e6a13a$export$bd929b984ffc4a9),
    [(0, $64KID.namedRoutes).ADMIN_SETTINGS.name]: (0, $6f06338c7fe23a44$export$44bc7d6c094dc951),
    [(0, $64KID.namedRoutes).ADMIN_BULK_PERMISSIONS.name]: (0, $4255a2123073399b$export$a1ed7a563d6f8c80),
    [(0, $64KID.namedRoutes).ADMIN_SITE_SPACE_PERMISSIONS.name]: (0, $d3d38e453fe82603$export$6b4028c8cfa4e9e1),
    [(0, $64KID.namedRoutes).ADMIN_TEAM_CALENDARS.name]: (0, $d1361d4d835db3f1$export$5164e66822dc5aec),
    [(0, $64KID.namedRoutes).ADMIN_TEAM_CONTROLS.name]: (0, $7793a666921a34a3$export$ee12bdabe55b87f5),
    [(0, $64KID.namedRoutes).ADMIN_CONFIGURATION.name]: (0, $daea30cdb73fa105$export$9a9547459861b1d),
    [(0, $64KID.namedRoutes).ADMIN_DEFAULT_SPACE_LOGO.name]: (0, $cf2a30228181ae7a$export$12cd952fb663f2a5),
    [(0, $64KID.namedRoutes).ADMIN_HEADER_AND_FOOTER.name]: (0, $d9d1782c5d23f713$export$66aaa3e4fa4fb446),
    [(0, $64KID.namedRoutes).ADMIN_TEMPLATES_AND_BLUEPRINTS.name]: (0, $3de5f90ca85ac387$export$fb8cddd2e05884ff),
    [(0, $64KID.namedRoutes).ADMIN_CODE_MACRO_CONFIGURATION.name]: (0, $2e9a50b174f89446$export$761483e0f415164e),
    [(0, $64KID.namedRoutes).ADMIN_COLOR_SCHEME.name]: (0, $0fb617f0ce9f4007$export$8984debadcec9d93),
    [(0, $64KID.namedRoutes).ADMIN_SECURITY_CONFIGURATION.name]: (0, $7fe52c8ec8c71cab$export$b882bc9c4e633e9b),
    [(0, $64KID.namedRoutes).ADMIN_SHAREABLE_LINKS.name]: (0, $a2ed3e45c015a582$export$aa92c319822402c4),
    [(0, $64KID.namedRoutes).ADMIN_SHAREABLE_LINKS_CONFIGURATION.name]: (0, $9272dc73a7cf38e5$export$8d78fedca7a630f7),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_REPORTS.name]: (0, $ba2c2ff5f89f0551$export$2667c61817b129fd),
    [(0, $64KID.namedRoutes).ADMIN_APPLICATION_NAVIGATOR.name]: (0, $98f73671c286928d$export$55ff18e8dde17771),
    [(0, $64KID.namedRoutes).ADMIN_TRASHED_SPACES.name]: (0, $b9260b374d11ae03$export$154b40ed25137a69),
    [(0, $64KID.namedRoutes).ADMIN_IMPORT_SPACES.name]: (0, $d9481fcbb25a62a6$export$6078cc5c61cdb00c),
    [(0, $64KID.namedRoutes).ADMIN_JIRA_MACRO_REPAIR.name]: (0, $3ed31ec1d64e85a3$export$1162e5a60ee7576b),
    [(0, $64KID.namedRoutes).ADMIN_MACRO_USAGE.name]: (0, $2395a25321aca708$export$1e71122b3eac56e4),
    [(0, $64KID.namedRoutes).ADMIN_THEMES.name]: (0, $95678b1264993b8d$export$cdc2bb4346e935c9),
    [(0, $64KID.namedRoutes).ADMIN_PDF_EXPORT.name]: (0, $d726f64aa7b98b71$export$81e12ffb7d442c0c),
    [(0, $64KID.namedRoutes).ADMIN_WATERMARK_CONFIGURATION.name]: (0, $1cb4912c670744a4$export$ee4273463a3d48ad),
    [(0, $64KID.namedRoutes).ADMIN_DC_SCRIPT_MIGRATION.name]: (0, $a58212c7e75084fc$export$4b568b9f0da70fe4),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_SCANS.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_SCAN.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_UNVERIFIED.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_UNSUPPORTED.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_RUN_TRANSFORMATIONS.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_TRANSFORMATIONS.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_PERFORMANCE_REPORT.name]: (0, $8a13ebd6aa0a88b0$export$84f173be1e35ceff),
    [(0, $64KID.namedRoutes).ADMIN_NBM_PERFORMANCE_REPORT_SCAN.name]: (0, $8a13ebd6aa0a88b0$export$84f173be1e35ceff),
    [(0, $64KID.namedRoutes).SPACE_MEMBERS.name]: (0, $f9fff28badc7670c$export$214350c926cc60f2),
    [(0, $64KID.namedRoutes).TOPICS.name]: (0, $ad7e3274b7fede14$export$54f890efdb9a624),
    [(0, $64KID.namedRoutes).IMPORTER_STATUS_DASHBOARD.name]: (0, $e2dae4d283de07f2$export$abf2f9d0f3a44f9c),
    [(0, $64KID.namedRoutes).ATTACHMENTS_PAGE.name]: (0, $167b5527ac95ab07$export$fd9e136112feb41f),
    [(0, $64KID.namedRoutes).AI_SEARCH_PAGE.name]: (0, $962d6764e800d7d4$export$e23fb2c3ce6c7abf),
    [(0, $64KID.namedRoutes).PERMISSIONS_EXPORT.name]: (0, $6deffcd0919e3152$export$9dc6a62d8cf9ae06),
    [(0, $64KID.namedRoutes).PERMISSIONS_COMBINATIONS.name]: (0, $5fcbb229533ae7f5$export$2cdfcdcf001693ff),
    [(0, $64KID.namedRoutes).ADMIN_SYSTEM_OPERATIONS.name]: (0, $7fda056324955ad3$export$26979a3c4ac291c5),
    [(0, $64KID.namedRoutes).NEW_AUDIT_LOG.name]: (0, $beac86ab997501a9$export$b6dab1e8a8b6a66d)
});
module.exports["routeComponents"] = $c6a4b2258628a516$export$4d9abfe5519d76c6;

});

parcelRegister("7Snc9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lFjPc = parcelRequire("lFjPc");


var $iJ8K8 = parcelRequire("iJ8K8");


var $5gmpn = parcelRequire("5gmpn");


var $4H46k = parcelRequire("4H46k");

function $1cae7e3e681988dd$export$271f9f08425019c7() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
        screenEvent: {
            name: 'notFoundScreen'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5gmpn.MainLayout), {
        navView: (0, $lFjPc.PRODUCT_HOME_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4H46k.LazyConfluenceNotFound), null)));
}
module.exports["NotFound"] = $1cae7e3e681988dd$export$271f9f08425019c7;

});

parcelRegister("irDFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d9861065b5c0df$export$2e2bcd8739ae039);

var $jmjWc = parcelRequire("jmjWc");


var $d6d9861065b5c0df$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "yQebH",
    name: "packages.confluence-frontend-server.src.components.EngagementMessages.EngagementMessages",
    loader: ()=>(parcelRequire("hbxro"))
});

});

parcelRegister("fekRU", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("bLeKY")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("6SYln")).useRouterActions);

var $4uoOx = parcelRequire("4uoOx");


var $7gd6S = parcelRequire("7gd6S");


var $he0G3 = parcelRequire("he0G3");


var $iwIcb = parcelRequire("iwIcb");


var $fvDxY = parcelRequire("fvDxY");


var $1Vajh = parcelRequire("1Vajh");


var $juJos = parcelRequire("juJos");


var $bLeKY = parcelRequire("bLeKY");


var $6SYln = parcelRequire("6SYln");


var $eKH5i = parcelRequire("eKH5i");


});

parcelRegister("2yKZA", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("iNLdL")).default);

var $iNLdL = parcelRequire("iNLdL");


var $99qx9 = parcelRequire("99qx9");


});

parcelRegister("fJGSb", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("90vNP")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("kgdzf")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("2mGqd")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("bRK5n")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("eNEWi")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("eNEWi")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("e8SDD")).isSameRouteMatch);

var $7cg8h = parcelRequire("7cg8h");


var $90vNP = parcelRequire("90vNP");


var $kgdzf = parcelRequire("kgdzf");


var $2mGqd = parcelRequire("2mGqd");


var $bRK5n = parcelRequire("bRK5n");


var $eNEWi = parcelRequire("eNEWi");


var $e8SDD = parcelRequire("e8SDD");


});

parcelRegister("2OiMz", function(module, exports) {
parcelRequire("fJGSb");
var $eNEWi = parcelRequire("eNEWi");

const $20bed211f9ba6efe$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $eNEWi.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("fvDxY", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $fgJFQ = parcelRequire("fgJFQ");


var $goduw = parcelRequire("goduw");

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");


var $eknCg = parcelRequire("eknCg");

parcelRequire("fJGSb");
var $eNEWi = parcelRequire("eNEWi");
var $90vNP = parcelRequire("90vNP");
var $kgdzf = parcelRequire("kgdzf");
var $2mGqd = parcelRequire("2mGqd");
var $bRK5n = parcelRequire("bRK5n");


var $jBvme = parcelRequire("jBvme");

parcelRequire("fJGSb");
var $e8SDD = parcelRequire("e8SDD");

const $745af82a95a6067e$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $745af82a95a6067e$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $745af82a95a6067e$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $745af82a95a6067e$var$stripTrailingSlash(prefix);
        prefix = $745af82a95a6067e$var$addLeadingSlash(prefix);
        path = $745af82a95a6067e$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $745af82a95a6067e$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $745af82a95a6067e$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$745af82a95a6067e$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($jBvme)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($jBvme)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $745af82a95a6067e$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$745af82a95a6067e$export$e83e3719fc818ee5(path)) {
        path = $745af82a95a6067e$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($jBvme)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $745af82a95a6067e$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $jBvme.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $745af82a95a6067e$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $745af82a95a6067e$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $e8SDD.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};


const $b4a86d7e3d134181$export$36d128238e6b60f5 = {
    action: (0, $eknCg.DEFAULT_ACTION),
    basePath: '',
    location: (0, $eknCg.DEFAULT_HISTORY).location,
    history: (0, $eknCg.DEFAULT_HISTORY),
    match: (0, $eknCg.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $eknCg.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $b4a86d7e3d134181$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $eNEWi.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $7Q5yr.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $2mGqd.isServerEnvironment)()) dispatch($b4a86d7e3d134181$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $eNEWi.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $745af82a95a6067e$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $goduw.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $7Q5yr.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $745af82a95a6067e$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $745af82a95a6067e$export$ae9fda833d91ed65)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $90vNP.generateLocationFromPath)(route.path, (0, $7Q5yr.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $bRK5n.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $745af82a95a6067e$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $745af82a95a6067e$export$ae9fda833d91ed65)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $90vNP.generateLocationFromPath)(route.path, (0, $7Q5yr.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $bRK5n.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $7Q5yr.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $745af82a95a6067e$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $745af82a95a6067e$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $7Q5yr.default)({}, existingPathParams, params);
            const updatedPath = (0, $kgdzf.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $7Q5yr.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $745af82a95a6067e$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $745af82a95a6067e$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $b4a86d7e3d134181$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $745af82a95a6067e$export$2fa6dede99f181e5)(path)) {
                const location = (0, $fgJFQ.parsePath)((0, $745af82a95a6067e$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $eNEWi.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $goduw.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $b4a86d7e3d134181$export$1cf0ecab63b1963c = (0, $1P1Tu.createStore)({
    initialState: $b4a86d7e3d134181$export$36d128238e6b60f5,
    actions: $b4a86d7e3d134181$var$actions,
    name: 'router'
});
const $b4a86d7e3d134181$export$d6b817abe7a77ea5 = (0, $FOT9i.createContainer)($b4a86d7e3d134181$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($b4a86d7e3d134181$var$actions.bootstrapStore(props));
            !(0, $2mGqd.isServerEnvironment)() && dispatch($b4a86d7e3d134181$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $2mGqd.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $b4a86d7e3d134181$export$9569010eab09ae9e = (0, $9zUhf.createHook)($b4a86d7e3d134181$export$1cf0ecab63b1963c);
const $b4a86d7e3d134181$export$ada49399abf7a3a1 = (0, $9zUhf.createActionsHook)($b4a86d7e3d134181$export$1cf0ecab63b1963c);
function $b4a86d7e3d134181$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $9zUhf.createHook)($b4a86d7e3d134181$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $b4a86d7e3d134181$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $4HDYO.defaultRegistry).getStore($b4a86d7e3d134181$export$1cf0ecab63b1963c);
const $b4a86d7e3d134181$export$ebf37f7e180b13a9 = ()=>$b4a86d7e3d134181$export$5ccad187366c8494().storeState.getState();
module.exports["RouterStore"] = $b4a86d7e3d134181$export$1cf0ecab63b1963c;
module.exports["RouterContainer"] = $b4a86d7e3d134181$export$d6b817abe7a77ea5;
module.exports["useRouterStore"] = $b4a86d7e3d134181$export$9569010eab09ae9e;
module.exports["useRouterStoreActions"] = $b4a86d7e3d134181$export$ada49399abf7a3a1;

});

parcelRegister("eknCg", function(module, exports) {

var $9577u = parcelRequire("9577u");


var $7cg8h = parcelRequire("7cg8h");

const $a6e540a11192f951$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $a6e540a11192f951$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $a6e540a11192f951$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $a6e540a11192f951$export$39607c9878cf5148 = (0, $7cg8h.createLegacyHistory)();
const $a6e540a11192f951$export$1515254c8c90bebb = {
    location: $a6e540a11192f951$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($9577u)))
};
const $a6e540a11192f951$export$fa440ddf675c8a93 = 'POP';
module.exports["DEFAULT_MATCH"] = $a6e540a11192f951$export$2de13e891a662beb;
module.exports["DEFAULT_ROUTE"] = $a6e540a11192f951$export$4eadc79233226325;
module.exports["DEFAULT_HISTORY"] = $a6e540a11192f951$export$39607c9878cf5148;
module.exports["DEFAULT_ACTION"] = $a6e540a11192f951$export$fa440ddf675c8a93;

});

parcelRegister("2BZYg", function(module, exports) {

var $67jR9 = parcelRequire("67jR9");


var $dCvbe = parcelRequire("dCvbe");


var $7dOkC = parcelRequire("7dOkC");


var $gI0WE = parcelRequire("gI0WE");


var $dAheB = parcelRequire("dAheB");





var $citzk = parcelRequire("citzk");


});

parcelRegister("8A6YM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eXmBZ = parcelRequire("eXmBZ");


var $6f0Oj = parcelRequire("6f0Oj");


var $dcJ7R = parcelRequire("dcJ7R");


var $ecnYn = parcelRequire("ecnYn");


var $kZ5GD = parcelRequire("kZ5GD");


var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $iquRY = parcelRequire("iquRY");

const $ec94e17fe3441559$var$i18n = (0, $aXWIB.defineMessages)({
    archivedSpacesTooltip: {
        id: "bulk-permissions.space.archived-spaces-tooltip",
        defaultMessage: "Archived spaces are not included in bulk permissions actions."
    },
    archivedSpacesTooltipBulkAccess: {
        id: "bulk-permissions.space.archived-spaces-tooltip-bulk-access",
        defaultMessage: "Archived spaces are not included in bulk access actions."
    },
    archivedSpacesTooltipIconLabel: {
        id: "bulk-permissions.space.archived-spaces-tooltip-icon-label",
        defaultMessage: "Archived space information"
    },
    spaceSelectionHeader: {
        id: "bulk-permissions.space.space-selection-header",
        defaultMessage: "Choose which spaces"
    },
    spaceAccessSelectionHeader: {
        id: "bulk-permissions.space.space-access-selection-header",
        defaultMessage: "On which spaces<asterisk>*</asterisk>"
    },
    spaceSelectionOne: {
        id: "bulk-permissions.space.space-selection-one",
        defaultMessage: "All"
    },
    spaceSelectionOneDescription: {
        id: "bulk-permissions.space.space-selection-one.description.non-final",
        defaultMessage: "All spaces within your tenant"
    },
    spaceSelectionTwo: {
        id: "bulk-permissions.space.space-selection-two",
        defaultMessage: "All (excluding personal)"
    },
    spaceSelectionTwoDescription: {
        id: "bulk-permissions.space.space-selection-two.description.non-final",
        defaultMessage: "All spaces within your tenant, except for personal spaces."
    },
    spaceSelectionFour: {
        id: "bulk-permissions.space.space-selection-four",
        defaultMessage: "Only personal"
    },
    spaceSelectionFourDescription: {
        id: "bulk-permissions.space.space-selection-four.description.non-final",
        defaultMessage: "Only select personal spaces within this tenant"
    }
});
var $ec94e17fe3441559$export$463c90b38fc542de = /*#__PURE__*/ function(SpaceSelection) {
    SpaceSelection["AllExcludingPersonal"] = "all-excluding-personal";
    SpaceSelection["AllIncludingPersonal"] = "all-including-personal";
    SpaceSelection["OnlyPersonal"] = "only-personal";
    return SpaceSelection;
}({});
const $ec94e17fe3441559$var$spaceSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $ec94e17fe3441559$var$spaceSelectionRadioButtonStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
});
const $ec94e17fe3441559$var$asteriskStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.red'
});
const $ec94e17fe3441559$export$1117068039e5ec07 = ({ spaceSelection: spaceSelection, onRadioChange: onRadioChange, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const spaceSelectionHeader = ()=>{
        if (isRbacEnabled) return $ec94e17fe3441559$var$i18n.spaceAccessSelectionHeader;
        return $ec94e17fe3441559$var$i18n.spaceSelectionHeader;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionHeaderStyle,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionHeaderStyle
    }, formatMessage(spaceSelectionHeader(), {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $ec94e17fe3441559$var$asteriskStyle
            }, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: isRbacEnabled ? formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltipBulkAccess) : formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltip),
        position: "right"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                    ...iconProps,
                    size: "small"
                }),
            appearance: "subtle",
            label: formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltipIconLabel),
            spacing: "compact",
            shape: "circle",
            ...tooltipProps
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionRadioButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        value: "all-including-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "all-including-personal",
        isDisabled: isDisabled,
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionOne)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        value: "all-excluding-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "all-excluding-personal",
        isDisabled: isDisabled,
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionTwo)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
        value: "only-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "only-personal",
        isDisabled: isDisabled,
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionFour)
    })));
};
module.exports["SpaceSelection"] = $ec94e17fe3441559$export$463c90b38fc542de;
module.exports["SpaceSelectionRadioButtons"] = $ec94e17fe3441559$export$1117068039e5ec07;

});

parcelRegister("ilq3G", function(module, exports) {
/* AgentAccessWarning.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $aoVih = parcelRequire("aoVih");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $gdv5Z = parcelRequire("gdv5Z");


var $9wGTI = parcelRequire("9wGTI");


var $inPa6 = parcelRequire("inPa6");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $277fe46309fe3848$var$i18n = (0, $aXWIB.defineMessages)({
    body: {
        id: "bulk-permissions.agent-access-warning.body",
        defaultMessage: "Adding an agent to all spaces makes all open content in the spaces accessible to anyone who can use the agent, even if they wouldn\u2019t have content access otherwise."
    },
    dismiss: {
        id: "bulk-permissions.agent-access-warning.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $277fe46309fe3848$var$STORAGE_SURFACE_KEY = 'bulk-permissions';
const $277fe46309fe3848$var$AGENT_WARNING_DISMISSED_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_AGENT_ACCESS_WARNING_DISMISSED;
const $277fe46309fe3848$export$c2f7ab9e26a4f003 = ({ stagedPrincipals: stagedPrincipals })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(()=>{
        try {
            const dismissed = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem($277fe46309fe3848$var$AGENT_WARNING_DISMISSED_KEY));
            return $277fe46309fe3848$var$STORAGE_SURFACE_KEY in (dismissed ?? {});
        } catch  {
            return false;
        }
    });
    const hasAgent = stagedPrincipals.some((p)=>p?.appType === 'agent');
    (0, $42omo.useEffect)(()=>{
        if (!hasAgent || isDismissed || !(0, $9wGTI.fg)('aa-296_fe_rovo_agents_can_take_actions')) return;
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'agentAccessWarningBannerScreen',
                action: 'viewed',
                actionSubject: 'screen',
                source: 'bulkPermissions'
            }
        }).fire();
    }, [
        hasAgent,
        isDismissed,
        createAnalyticsEvent
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        try {
            const existing = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem($277fe46309fe3848$var$AGENT_WARNING_DISMISSED_KEY)) ?? {};
            (0, $17wUi.confluenceLocalStorageInstance).setItem($277fe46309fe3848$var$AGENT_WARNING_DISMISSED_KEY, JSON.stringify({
                ...existing,
                [$277fe46309fe3848$var$STORAGE_SURFACE_KEY]: 1
            }));
            setIsDismissed(true);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'agentAccessWarningDismissClick',
                    source: 'bulkPermissions'
                }
            }).fire();
        } catch  {
            return;
        }
    }, [
        createAnalyticsEvent
    ]);
    if (!hasAgent || isDismissed || !(0, $9wGTI.fg)('aa-296_fe_rovo_agents_can_take_actions')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $277fe46309fe3848$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "warning",
        testId: "agent-access-warning-bulk-permissions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $277fe46309fe3848$var$styles.body
    }, formatMessage($277fe46309fe3848$var$i18n.body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $277fe46309fe3848$var$styles.dismissButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($277fe46309fe3848$var$i18n.dismiss),
        appearance: "subtle",
        onClick: handleDismiss,
        testId: "agent-access-warning-dismiss-bulk-permissions"
    })));
};
const $277fe46309fe3848$var$styles = {
    container: "_kqswh2mm _19pku2gc _otyru2gc",
    body: "_u5f3xy5q",
    dismissButton: "_kqswstnw _154iu2gc _1xi2u2gc"
};
module.exports["AgentAccessWarning"] = $277fe46309fe3848$export$c2f7ab9e26a4f003;

});

parcelRegister("eIwUX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $auKqk = parcelRequire("auKqk");


var $75i5X = parcelRequire("75i5X");


var $aGLO2 = parcelRequire("aGLO2");

const $57959768319b5632$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "bulk-permissions.restricted.title",
        defaultMessage: "This item is restricted"
    },
    message: {
        id: "bulk-permissions.space-settings.restricted.message",
        defaultMessage: "If you think you should have access, try asking the person who sent you here for help."
    }
});
const $57959768319b5632$export$b5dab984a2ed58cb = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auKqk.ErrorPageComponent), {
        errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($75i5X))),
        errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($aGLO2))),
        errorTitle: intl.formatMessage($57959768319b5632$var$i18n.title),
        errorMessage: intl.formatMessage($57959768319b5632$var$i18n.message)
    });
};
module.exports["RestrictedView"] = $57959768319b5632$export$b5dab984a2ed58cb;

});

parcelRegister("lM2MU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1DHa6 = parcelRequire("1DHa6");


var $9ot3w = parcelRequire("9ot3w");


var $d8eRd = parcelRequire("d8eRd");


var $1GzhS = parcelRequire("1GzhS");


var $ecnYn = parcelRequire("ecnYn");


var $6UBEn = parcelRequire("6UBEn");


var $2ZJmt = parcelRequire("2ZJmt");

const $b25698afe0cbfe9a$var$i18n = (0, $aXWIB.defineMessages)({
    loadingTitle: {
        id: "bulk-permissions.space.loading-title",
        defaultMessage: "We\u2019re processing your change"
    },
    loadingDialogDescription: {
        id: "bulk-permissions.space.loading-dialog-description",
        defaultMessage: "Don\u2019t navigate away or refresh."
    }
});
const $b25698afe0cbfe9a$var$LoadingSubSectionStyle = (0, $ecnYn.xcss)({
    rowGap: 'space.300',
    paddingBottom: 'space.800'
});
const $b25698afe0cbfe9a$export$7d8626d803788e96 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b25698afe0cbfe9a$var$i18n.loadingTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b25698afe0cbfe9a$var$LoadingSubSectionStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b25698afe0cbfe9a$var$i18n.loadingDialogDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UBEn.default), {
        isIndeterminate: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZJmt.NavigationLockout), null));
module.exports["LoadingDialog"] = $b25698afe0cbfe9a$export$7d8626d803788e96;

});

parcelRegister("5BMKF", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $284ed2dc30431279$export$462fa05039a3a9e6 = (0, $aXWIB.defineMessages)({
    roleDisabledLabel: {
        id: "space-roles.view-role-permissions-modal.role-disabled-label",
        defaultMessage: "Role disabled"
    }
});
module.exports["viewRolePermissionsMessages"] = $284ed2dc30431279$export$462fa05039a3a9e6;

});

parcelRegister("2c1Wz", function(module, exports) {
var $49cc78e79e334ef6$export$a4def92db6fc8e17 = /*#__PURE__*/ function(PerformanceObserverEntryTypes) {
    PerformanceObserverEntryTypes["LayoutShift"] = "layout-shift";
    PerformanceObserverEntryTypes["LongTask"] = "longtask";
    PerformanceObserverEntryTypes["Event"] = "event";
    return PerformanceObserverEntryTypes;
}({});
module.exports["PerformanceObserverEntryTypes"] = $49cc78e79e334ef6$export$a4def92db6fc8e17;

});

parcelRegister("i7t6K", function(module, exports) {

var $2c1Wz = parcelRequire("2c1Wz");

class $4313abb7a0000648$export$2c6e86519c9e8188 {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    // Default maxLength is an arbitrary number but it is long enough to capture tasks within the full experience
    // 1000 x 50ms = 50s which should be long enough for every healthy experience
    constructor(maxLength = 1000){
        this.buffer = [];
        this.maxLength = void 0;
        this.full = false;
        this.maxLength = maxLength;
    }
}
const $4313abb7a0000648$export$f7dc16cbd16f7bbe = {
    [(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]: new $4313abb7a0000648$export$2c6e86519c9e8188(),
    [(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]: new $4313abb7a0000648$export$2c6e86519c9e8188(),
    [(0, $2c1Wz.PerformanceObserverEntryTypes).Event]: new $4313abb7a0000648$export$2c6e86519c9e8188()
};
// This function is exposed to the window object to be used in the integration tests
// to fail the test if there is a layout shift in the page
const $4313abb7a0000648$var$hadLayoutShift = (predicate)=>{
    const buffer = $4313abb7a0000648$export$f7dc16cbd16f7bbe[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift].buffer;
    return predicate(buffer);
};
window.__hadLayoutShift = $4313abb7a0000648$var$hadLayoutShift;
module.exports["EntriesBuffer"] = $4313abb7a0000648$export$f7dc16cbd16f7bbe;

});

parcelRegister("jiFpb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iJ8K8 = parcelRequire("iJ8K8");


var $5gmpn = parcelRequire("5gmpn");


var $8dwdz = parcelRequire("8dwdz");


var $6pwLK = parcelRequire("6pwLK");


var $1dnxO = parcelRequire("1dnxO");

const $6a421125f8ad1b8e$var$routeWithNavigationMapping = new Map();
function $6a421125f8ad1b8e$export$658b4fa209be6b36(match) {
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    // We need to ensure all the entries calling processNavigationParams are returning the same RouteWithNavigation instance
    // So that they won't get re-mounted when switching between routes
    const RouteWithNavParams = $6a421125f8ad1b8e$var$routeWithNavigationMapping.get(match.name);
    if (!RouteWithNavParams) return null;
    const { NAVIGATION_PARAMS: NAVIGATION_PARAMS } = RouteWithNavParams;
    if (typeof NAVIGATION_PARAMS !== 'function') return null;
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const spaceNavParams = NAVIGATION_PARAMS(match, isNav4Enabled);
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RouteWithNavParams, match);
    if (spaceNavParams === false) return element;
    const { Screen: screen, MainLayout: mainLayout, BannerContext: bannerContext } = spaceNavParams;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), screen, mainLayout === false ? element : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !isMobile,
        ...mainLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6pwLK.BannerContextProvider), {
        includeTopNav: bannerContext?.includeTopNav
    }, element)));
}
function $6a421125f8ad1b8e$export$5ce5fb2a75a2a873(routes) {
    for(const name in routes){
        const RouteWithNavParams = routes[name];
        if (typeof RouteWithNavParams.NAVIGATION_PARAMS !== 'function') throw new Error(`Route must define a static NAVIGATION_PARAMS function. ${name} is missing the NAVIGATION_PARAMS function. Please read patterns/routing.md`);
        $6a421125f8ad1b8e$var$routeWithNavigationMapping.set(name, RouteWithNavParams);
        routes[name] = $6a421125f8ad1b8e$export$658b4fa209be6b36;
    }
    return routes;
}
module.exports["processNavigationParams"] = $6a421125f8ad1b8e$export$5ce5fb2a75a2a873;

});

parcelRegister("4lJOK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $kE2cJ = parcelRequire("kE2cJ");


var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");


var $lFjPc = parcelRequire("lFjPc");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $iqPBi = parcelRequire("iqPBi");

function $3dad7419d64a8662$export$3731f94d374dc29b(Component) {
    const SpaceOverviewRoute = (match)=>{
        const { params: { spaceKey: spaceKey = '', contentId: contentId = '' }, query: query } = match;
        if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.COMPANY_HUB).name
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPBi.SpaceBase), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: contentId,
            query: query
        }));
    };
    SpaceOverviewRoute.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey = '' }, query: { mode: mode = '' } })=>({
            Screen: {
                screenEvent: {
                    name: 'spaceOverviewScreen',
                    id: spaceKey,
                    attributes: {
                        isGlobalMode: mode === 'global',
                        navdexPointType: (0, $56QzY.START_TOUCH),
                        spaceKey: spaceKey
                    }
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.SPACE_OVERVIEW).name,
                    contentType: 'page'
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.CONTAINER_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        });
    return SpaceOverviewRoute;
}
const $3dad7419d64a8662$export$2df060b942be85a7 = $3dad7419d64a8662$export$3731f94d374dc29b((0, $djZz9.SpaceOverviewSwitcherLoader));
module.exports["getSpaceOverviewRoute"] = $3dad7419d64a8662$export$3731f94d374dc29b;

});

parcelRegister("hDf9e", function(module, exports) {

var $42omo = parcelRequire("42omo");





var $inPa6 = parcelRequire("inPa6");


var $kDuN4 = parcelRequire("kDuN4");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

const $0d72b6e269966c48$var$isOnCompanyHubRouteArgs = {
    selector: (routeName)=>(0, $1NBp8.COMPANY_HUB).name === routeName
};

const $0d72b6e269966c48$export$83316d703678f96f = ({ children: children })=>{
    const isOnCompanyHubRoute = (0, $dPJCf.useRouteName)($0d72b6e269966c48$var$isOnCompanyHubRouteArgs);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleAnalyticCaught = (0, $42omo.useCallback)(async (event, channel)=>{
        if (event?.payload?.action === 'clicked' || event?.payload?.actionSubject === 'smartLink' && event?.payload?.action === 'renderSuccess') await (parcelRequire("hz81G")).then(async ({ handleEventCaught: handleEventCaught })=>{
            await handleEventCaught(activationId, cloudId, createAnalyticsEvent, event, !!isOnCompanyHubRoute, channel, spaceId);
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        isOnCompanyHubRoute,
        spaceId
    ]);
    if (!isOnCompanyHubRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: "*",
        onEvent: handleAnalyticCaught
    }, children);
};



var $lFjPc = parcelRequire("lFjPc");


var $9HNv5 = parcelRequire("9HNv5");


var $8NC5Z = parcelRequire("8NC5Z");


var $7CeAz = parcelRequire("7CeAz");





var $56QzY = parcelRequire("56QzY");


var $cEgMD = parcelRequire("cEgMD");


var $kE2cJ = parcelRequire("kE2cJ");


var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");


var $eqNP8 = parcelRequire("eqNP8");





var $jKzCD = parcelRequire("jKzCD");


var $e4o8D = parcelRequire("e4o8D");


var $eCfJ3 = parcelRequire("eCfJ3");


var $2Uf3N = parcelRequire("2Uf3N");

function $8d67d674949172ba$export$d135e6fd61f0ae86(Component) {
    const CompanyHubRoute = ()=>{
        const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled, isCompanyHubPublished: isCompanyHubPublished } = (0, $7CeAz.useIsCompanyHubEnabled)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
        const { push: push } = (0, $dPJCf.useRouteActions)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                push((0, $1NBp8.COMPANY_HUB_EDIT).toUrl({}, {
                    query: {
                        redirect: 'first-time',
                        contentId: homepageId
                    }
                }));
            },
            route: (0, $1NBp8.COMPANY_HUB).pattern
        });
        if (isCreatingHub) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        screenEventAttributes.publishedCompanyHub = isCompanyHubPublished;
        if (shouldShowPremiumUpsell) {
            /**
       * SSR compatibility: CompanyHomeBuilderUpsellPage uses UpsellLooknFeel/SectionMessage
       * which lacks SSR support. Rendering during SSR would cause:
       * - Hydration mismatches between server/client renders
       * - Visible layout shift (CLS) during client hydration since SectionMessage
       *   appears at the top of the content area
       *
       * For now, client-side rendering only, until components are refactored for SSR support.
       */ if (renderServerPlaceholder) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
                featureName: "companyHub"
            });
        }
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (!isCompanyHubEntryPointEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name
        });
        // The only different between SPA and SSR is we don't render space base in SSR
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0d72b6e269966c48$export$83316d703678f96f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: ""
        }));
    };
    const screenEventAttributes = {
        navdexPointType: (0, $56QzY.START_TOUCH),
        // Company Hub hides its space from the user, doesn't refer to its page
        // as such, is rather presented to the user as "a new surface", and thus
        // doesn't constitute space usage from the perspective of the user.
        screenIsInSpace: false
    };
    /**
   * Warning: Though the function NAVIGATION_PARAMS is invoked during render,
   * each route has its own implementation. Consequently, it cannot invoke
   * hooks or, during route transitions between implementations that invoke
   * different hooks, the rule of hooks to invoke a hook the same number of
   * times during each render would be violated and an error would be thrown
   * by React that would damage the DOM.
   */ CompanyHubRoute.NAVIGATION_PARAMS = ()=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHub',
                    id: spaceKey,
                    // Warning: The value of the analytics event attribute
                    // publishedCompanyHub that ScreenEvent sends will be
                    // inaccurate on initial SPA load without SSR, because
                    // ScreenEvent sends before SPAViewContext has loaded.
                    attributes: screenEventAttributes
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.COMPANY_HUB).name
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubRoute);
}
const $8d67d674949172ba$export$ea13ab632841088 = $8d67d674949172ba$export$d135e6fd61f0ae86((0, $djZz9.SpaceOverviewLoader));
module.exports["getCompanyHubRoute"] = $8d67d674949172ba$export$d135e6fd61f0ae86;

});

parcelRegister("hkCxu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $lFjPc = parcelRequire("lFjPc");


var $jKzCD = parcelRequire("jKzCD");


var $8NC5Z = parcelRequire("8NC5Z");


var $1NBp8 = parcelRequire("1NBp8");


var $9HNv5 = parcelRequire("9HNv5");


var $eqNP8 = parcelRequire("eqNP8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $56QzY = parcelRequire("56QzY");


var $eCfJ3 = parcelRequire("eCfJ3");








var $5gmpn = parcelRequire("5gmpn");


var $iJ8K8 = parcelRequire("iJ8K8");


var $ak57N = parcelRequire("ak57N");


var $8dwdz = parcelRequire("8dwdz");











var $6pwLK = parcelRequire("6pwLK");

function $ef4380efcf1da8eb$export$b5c57a98f1ddfa55(uri) {
    return uri.includes('/edit-v2/');
}
function $ef4380efcf1da8eb$export$4ceedc3d36a46889(query) {
    const draftShareId = query?.draftShareId;
    return Array.isArray(draftShareId) ? draftShareId?.[0] : draftShareId;
}


const $ec45f4b8e7cc34aa$export$6a3218472cdf374a = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey }, query: query })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)({
        skip: !isCompanyHub
    });
    const contentType = name === (0, $1NBp8.EDIT_PAGE_V2).name || name === (0, $1NBp8.COMPANY_HUB_EDIT).name ? 'page' : 'blogpost';
    const draftShareId = (0, $ef4380efcf1da8eb$export$4ceedc3d36a46889)(query);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6pwLK.BannerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ak57N.EditPageLoaderServer), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }));
    //
    // navView
    //
    let navView = (0, $lFjPc.CONTAINER_HOME_ID);
    if (isCompanyHub) {
        if (shouldShowPremiumUpsell) return null;
        else if (name === (0, $1NBp8.COMPANY_HUB_EDIT).name) // CompanyHubEditRoute provides its own Screen and MainLayout.
        return children;
        navView = (0, $lFjPc.PRODUCT_HOME_ID);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType
        },
        screenEvent: {
            name: 'editPageScreen',
            id: contentId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !(0, $8dwdz.shouldShowMobileWeb)(),
        spaceKey: spaceKey,
        navView: navView,
        isEdit: true
    }, children));
};



var $2Uf3N = parcelRequire("2Uf3N");

function $aa6dab5502f2e37f$export$39a78a0252c20555(component) {
    const CompanyHubEditRoute = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const [queriedContentId, setQueriedContentId] = (0, $42omo.useState)(null);
        const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                setQueriedContentId(homepageId);
                setQueryParams({
                    redirect: 'first-time'
                });
            },
            onExists: (homepageId)=>{
                setQueriedContentId(homepageId);
            },
            route: (0, $1NBp8.COMPANY_HUB_EDIT).pattern
        });
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
            featureName: "companyHub"
        });
        // If there is no contentId in SSR then we will just see the FullPageLoadingScreen being rendered
        // So we skip the loading screen component to ensure the EditPageRoute is rendered instead
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ((isCreatingHub || !queriedContentId && !contentId) && true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        const Component = component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...routeProps,
            params: {
                contentId: contentId ?? (queriedContentId || ''),
                spaceKey: spaceKey,
                contentType: 'pages'
            }
        });
    };
    CompanyHubEditRoute.NAVIGATION_PARAMS = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHubEditScreen',
                    id: spaceKey,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        // Company Hub hides its space from the user, doesn't refer to its page
                        // as such, is rather presented to the user as "a new surface", and thus
                        // doesn't constitute space usage from the perspective of the user.
                        screenIsInSpace: false
                    }
                },
                // When no contentId is passed, Screen.js handles querying it and updating pageState with it.
                // usually, this is done by the Screen.js component, but in this case, we need to do it here
                // because contentId is not getting queried properly on route creation.
                pageState: {
                    spaceKey: spaceKey,
                    contentId: routeProps?.query?.contentId
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID)
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubEditRoute);
}
const $aa6dab5502f2e37f$export$31ce72eecdb1dd8 = $aa6dab5502f2e37f$export$39a78a0252c20555((0, $ec45f4b8e7cc34aa$export$6a3218472cdf374a));
module.exports["getCompanyHubEditRoute"] = $aa6dab5502f2e37f$export$39a78a0252c20555;

});

parcelRegister("k1285", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eDATL = parcelRequire("eDATL");


var $cEgMD = parcelRequire("cEgMD");


var $lFjPc = parcelRequire("lFjPc");


var $jKzCD = parcelRequire("jKzCD");


var $8NC5Z = parcelRequire("8NC5Z");


var $1NBp8 = parcelRequire("1NBp8");


var $9HNv5 = parcelRequire("9HNv5");


var $eqNP8 = parcelRequire("eqNP8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $56QzY = parcelRequire("56QzY");


var $eCfJ3 = parcelRequire("eCfJ3");


var $2Uf3N = parcelRequire("2Uf3N");

function $7c7def46d7360d1a$export$340541672a1ec29f(component) {
    const CompanyHubEditorRoute = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const [queriedContentId, setQueriedContentId] = (0, $42omo.useState)(null);
        const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                setQueriedContentId(homepageId);
                setQueryParams({
                    redirect: 'first-time'
                });
            },
            onExists: (homepageId)=>{
                setQueriedContentId(homepageId);
            },
            route: (0, $1NBp8.COMPANY_HUB_EDIT).pattern
        });
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
            featureName: "companyHub"
        });
        // If there is no contentId in SSR then we will just see the FullPageLoadingScreen being rendered
        // So we skip the loading screen component to ensure the HubEditor is rendered instead
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ((isCreatingHub || !queriedContentId && !contentId) && true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        const Component = component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...routeProps,
            params: {
                contentId: contentId ?? (queriedContentId || ''),
                spaceKey: spaceKey,
                contentType: 'pages'
            }
        });
    };
    CompanyHubEditorRoute.NAVIGATION_PARAMS = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHubEditorScreen',
                    id: spaceKey,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        screenIsInSpace: false
                    }
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: routeProps?.query?.contentId
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID)
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubEditorRoute);
}
const $7c7def46d7360d1a$export$5c9c0a4930517099 = $7c7def46d7360d1a$export$340541672a1ec29f((0, $eDATL.default));
module.exports["getCompanyHubEditorRoute"] = $7c7def46d7360d1a$export$340541672a1ec29f;

});

parcelRegister("SwMnm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lFjPc = parcelRequire("lFjPc");


var $bUMKD = parcelRequire("bUMKD");


var $6mKj3 = parcelRequire("6mKj3");


var $78QFu = parcelRequire("78QFu");

function $fadd80cba2fb56d8$export$4464cf8f058e6616({ ContextProvider: ContextProvider = (0, $42omo.Fragment), NotFound: NotFound = (0, $42omo.Fragment) } = {}) {
    function AccessLinkRoute({ params: { shareToken: shareToken }, hash: hash }) {
        if (!(0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NotFound, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUMKD.ExternalSharePageLoader), {
            shareToken: shareToken,
            queryHash: hash
        }));
    }
    AccessLinkRoute.NAVIGATION_PARAMS = ({ name: name })=>({
            Screen: {
                screenEvent: {
                    name: 'viewPageScreen',
                    attributes: {
                        isPublicView: false,
                        isAccessLinkView: true,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                },
                pageState: {
                    routeName: name
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID)
            }
        });
    return AccessLinkRoute;
}
const $fadd80cba2fb56d8$export$7fef32ef76619e1b = $fadd80cba2fb56d8$export$4464cf8f058e6616();
module.exports["getAccessLinkRoute"] = $fadd80cba2fb56d8$export$4464cf8f058e6616;

});

parcelRegister("8g7sM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3f88486f5953222$export$2e2bcd8739ae039);

var $jmjWc = parcelRequire("jmjWc");


var $kb9X9 = parcelRequire("kb9X9");

const $c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD = `confluence.fabric.content.renderer.download`;

var $c3f88486f5953222$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cDY9-",
    name: 'ClassicContentRendererLoader',
    loader: async ()=>{
        (0, $kb9X9.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.start`);
        const module = await (parcelRequire("fJtJD"));
        (0, $kb9X9.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.end`);
        return module;
    }
});

});

parcelRegister("2Uf3N", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


const $44a1291d5f4bf190$export$bbf3d8e57337c75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xoU6a",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'CompanyHubMainLayout',
    loader: async ()=>(await (parcelRequire("iBtOw"))).CompanyHubMainLayout
});


function $13aed4a881b0bcc1$export$f5fe5ef796a4c528(Wrapped, routeMatchPredicate = ()=>true) {
    const CompanyHubPseudoAppRoute = (props)=>{
        const wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapped, props);
        if (routeMatchPredicate(props)) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44a1291d5f4bf190$export$bbf3d8e57337c75), null, wrapped);
        return wrapped;
    };
    CompanyHubPseudoAppRoute.NAVIGATION_PARAMS = (...args)=>{
        const wrappedNavParams = Wrapped.NAVIGATION_PARAMS(...args);
        if (routeMatchPredicate(args[0])) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return typeof wrappedNavParams === 'object' ? {
            ...wrappedNavParams,
            MainLayout: false
        } : false;
        return wrappedNavParams;
    };
    return CompanyHubPseudoAppRoute;
}
module.exports["getCompanyHubPseudoAppRoute"] = $13aed4a881b0bcc1$export$f5fe5ef796a4c528;

});

parcelRegister("4VuiN", function(module, exports) {
/* AdminPageLayout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

/**
 * Canonical layout for an admin page in Confluence. Every admin-shell
 * page renders inside a centred, max-1024px column with consistent padding.
 */ const $0e52f7509d59c259$var$styles = {
    outer: "_1bsb1osq _p12f1osq _1e0c1txw _1bah1h6o _1reo15vq _18m915vq",
    inner: "_1q51oahv _85i51jfw _1bsb1osq _1ul910sk _p12f1qe4 _1e0c1txw _2lx21bp4"
};
// Matches Mission Control's ContentContainer for consistency.
const $0e52f7509d59c259$var$innerInlineStyle = {
    paddingInlineStart: '112px',
    // Forced px sizing to match Mission Control's ContentContainer padding
    paddingInlineEnd: '112px',
    containerType: 'inline-size',
    containerName: 'AdminPage',
    boxSizing: 'content-box'
};
const $0e52f7509d59c259$var$fullWidthInnerInlineStyle = {
    ...$0e52f7509d59c259$var$innerInlineStyle,
    paddingInlineStart: "var(--ds-space-400, 32px)",
    paddingInlineEnd: "var(--ds-space-400, 32px)",
    paddingBlockStart: "var(--ds-space-400, 32px)",
    maxWidth: 'none'
};
const $0e52f7509d59c259$export$a2627d382ba9038 = ({ children: children, banner: banner, fullWidth: fullWidth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $0e52f7509d59c259$var$styles.outer,
        as: "main"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $0e52f7509d59c259$var$styles.inner,
        style: fullWidth ? $0e52f7509d59c259$var$fullWidthInnerInlineStyle : $0e52f7509d59c259$var$innerInlineStyle,
        testId: "admin-page-layout-inner"
    }, banner, children));
module.exports["AdminPageLayout"] = $0e52f7509d59c259$export$a2627d382ba9038;

});

parcelRegister("92IuX", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cf6f9a67c56b1fae$export$a52edf641f55b288 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qAAZg",
    name: "AuditLogLoader",
    loader: async ()=>(await (parcelRequire("iSFH7"))).AuditLog
});
module.exports["AuditLogLoader"] = $cf6f9a67c56b1fae$export$a52edf641f55b288;

});

parcelRegister("4uoOx", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $7Q5yr = parcelRequire("7Q5yr");


var $iLaQ6 = parcelRequire("iLaQ6");


var $fgJFQ = parcelRequire("fgJFQ");


var $42omo = parcelRequire("42omo");

parcelRequire("fJGSb");
var $90vNP = parcelRequire("90vNP");


var $bLeKY = parcelRequire("bLeKY");

class $344d365525b84c59$var$Redirector extends (0, $42omo.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $fgJFQ.createPath)((0, $90vNP.generateLocationFromPath)(to.path, routeAttributes)) : (0, $fgJFQ.createPath)(to) : to;
        const currentPath = (0, $fgJFQ.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $iLaQ6.default)($344d365525b84c59$var$Redirector, "defaultProps", {
    push: false
});
const $344d365525b84c59$export$2d8d895a0a0f636e = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    const [t0, actions] = (0, $bLeKY.useRouter)();
    const { location: location } = t0;
    let t1;
    if ($[0] !== actions || $[1] !== location || $[2] !== props) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($344d365525b84c59$var$Redirector, (0, $7Q5yr.default)({
            actions: actions,
            location: location
        }, props));
        $[0] = actions;
        $[1] = location;
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const [{ location: location }, actions] = (0, $bLeKY.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($344d365525b84c59$var$Redirector, (0, $7Q5yr.default)({
        actions: actions,
        location: location
    }, props));
};

});

parcelRegister("7gd6S", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $fgJFQ = parcelRequire("fgJFQ");


var $42omo = parcelRequire("42omo");


var $fvDxY = parcelRequire("fvDxY");

const $5494325cb202f384$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fvDxY.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $5494325cb202f384$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $42omo.useMemo)(()=>(0, $fgJFQ.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5494325cb202f384$export$55185c17a0fcbe46, (0, $7Q5yr.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("he0G3", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6SYln = parcelRequire("6SYln");

const $c8a444f562531ada$export$b371fa9cf762ad06 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    const actions = (0, $6SYln.useRouterActions)();
    let t1;
    if ($[0] !== actions || $[1] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children(actions));
        $[0] = actions;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children })=>{
    const actions = (0, $6SYln.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children(actions));
};
$c8a444f562531ada$export$b371fa9cf762ad06.displayName = 'RouterActions';

});

parcelRegister("iwIcb", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $bDniu = parcelRequire("bDniu");


var $42omo = parcelRequire("42omo");

parcelRequire("fJGSb");
var $2mGqd = parcelRequire("2mGqd");


var $fvDxY = parcelRequire("fvDxY");

const $d7cd7f7a82617ee7$var$_excluded = [
    "listen"
];
const $d7cd7f7a82617ee7$export$672d721d310ff5f0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children } = t0;
    const [state, _ref] = (0, $fvDxY.useRouterStore)();
    const { listen: listen } = _ref;
    let t1;
    if ($[0] !== _ref || $[1] !== children || $[2] !== listen || $[3] !== state) {
        const actions = (0, $bDniu.default)(_ref, $d7cd7f7a82617ee7$var$_excluded);
        if (!state.unlisten && !(0, $2mGqd.isServerEnvironment)()) listen();
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children(state, actions));
        $[0] = _ref;
        $[1] = children;
        $[2] = listen;
        $[3] = state;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children })=>{
    const [state, _ref] = (0, $fvDxY.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $bDniu.default)(_ref, $d7cd7f7a82617ee7$var$_excluded);
    if (!state.unlisten && !(0, $2mGqd.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children(state, actions));
};

});

parcelRegister("1Vajh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");


var $fvDxY = parcelRequire("fvDxY");

const $16631ca42655b61b$var$createPathParamHook = (0, $9zUhf.createHook)((0, $fvDxY.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $16631ca42655b61b$export$8c8591dcd57728e6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (paramKey)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== paramKey) {
        t0 = $16631ca42655b61b$var$createPathParamHook({
            paramKey: paramKey
        });
        $[0] = paramKey;
        $[1] = t0;
    } else t0 = $[1];
    const [paramVal, routerActions] = t0;
    let t1;
    if ($[2] !== paramKey || $[3] !== routerActions) {
        t1 = (newValue, updateType)=>{
            routerActions.updatePathParam({
                [paramKey]: newValue
            }, updateType);
        };
        $[2] = paramKey;
        $[3] = routerActions;
        $[4] = t1;
    } else t1 = $[4];
    const setPathParam = t1;
    let t2;
    if ($[5] !== paramVal || $[6] !== setPathParam) {
        t2 = [
            paramVal,
            setPathParam
        ];
        $[5] = paramVal;
        $[6] = setPathParam;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (paramKey)=>{
    const [paramVal, routerActions] = $16631ca42655b61b$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $42omo.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("juJos", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");


var $fvDxY = parcelRequire("fvDxY");

const $e31407dac1ee5e44$var$createQueryParamHook = (0, $9zUhf.createHook)((0, $fvDxY.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $e31407dac1ee5e44$export$ae316f0eeb712a36 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (paramKey)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== paramKey) {
        t0 = $e31407dac1ee5e44$var$createQueryParamHook({
            paramKey: paramKey
        });
        $[0] = paramKey;
        $[1] = t0;
    } else t0 = $[1];
    const [paramVal, routerActions] = t0;
    let t1;
    if ($[2] !== paramKey || $[3] !== routerActions) {
        t1 = (newValue, updateType)=>{
            routerActions.updateQueryParam({
                [paramKey]: newValue
            }, updateType);
        };
        $[2] = paramKey;
        $[3] = routerActions;
        $[4] = t1;
    } else t1 = $[4];
    const setQueryParam = t1;
    let t2;
    if ($[5] !== paramVal || $[6] !== setQueryParam) {
        t2 = [
            paramVal,
            setQueryParam
        ];
        $[5] = paramVal;
        $[6] = setQueryParam;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (paramKey)=>{
    const [paramVal, routerActions] = $e31407dac1ee5e44$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $42omo.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("bLeKY", function(module, exports) {

var $fvDxY = parcelRequire("fvDxY");

const $88ff87d4edee9f4f$export$9a302a45f65d0572 = (0, $fvDxY.useRouterStore);
module.exports["useRouter"] = $88ff87d4edee9f4f$export$9a302a45f65d0572;

});

parcelRegister("6SYln", function(module, exports) {

var $fvDxY = parcelRequire("fvDxY");

const $50369837b01b4c0e$export$402e82ff1b20594b = (0, $fvDxY.useRouterStoreActions);
module.exports["useRouterActions"] = $50369837b01b4c0e$export$402e82ff1b20594b;

});

parcelRegister("eKH5i", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $7Q5yr = parcelRequire("7Q5yr");


var $42omo = parcelRequire("42omo");


var $fvDxY = parcelRequire("fvDxY");

const $abd6c83cb0bdb230$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $abd6c83cb0bdb230$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $abd6c83cb0bdb230$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $frIzR.c)(10);
        const [t0, t1] = (0, $fvDxY.useRouterStore)();
        const { action: action, history: history, location: location, match: match, query: query, route: route } = t0;
        const { push: push, replace: replace } = t1;
        let t2;
        if ($[0] !== action || $[1] !== history || $[2] !== location || $[3] !== match || $[4] !== props || $[5] !== push || $[6] !== query || $[7] !== replace || $[8] !== route) {
            t2 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, (0, $7Q5yr.default)({}, props, {
                action: action,
                history: history,
                location: location,
                match: match,
                push: push,
                query: query,
                replace: replace,
                route: route
            }));
            $[0] = action;
            $[1] = history;
            $[2] = location;
            $[3] = match;
            $[4] = props;
            $[5] = push;
            $[6] = query;
            $[7] = replace;
            $[8] = route;
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    } : (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $fvDxY.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, (0, $7Q5yr.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("iNLdL", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $fgJFQ = parcelRequire("fgJFQ");


var $42omo = parcelRequire("42omo");

parcelRequire("fJGSb");
var $eNEWi = parcelRequire("eNEWi");
var $90vNP = parcelRequire("90vNP");


var $fvDxY = parcelRequire("fvDxY");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");




const $e5e1340cfb852c3e$export$d8e6abf214c9ec0f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (delay)=>{
    const $ = (0, $frIzR.c)(5);
    const timeoutId = (0, $42omo.useRef)();
    let t0;
    if ($[0] !== delay) {
        t0 = (callback)=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
            timeoutId.current = setTimeout(callback, delay);
        };
        $[0] = delay;
        $[1] = t0;
    } else t0 = $[1];
    const schedule = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            clearTimeout(timeoutId.current);
        };
        $[2] = t1;
    } else t1 = $[2];
    const cancel = t1;
    let t2;
    if ($[3] !== schedule) {
        t2 = {
            schedule: schedule,
            cancel: cancel
        };
        $[3] = schedule;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (delay)=>{
    const timeoutId = (0, $42omo.useRef)();
    const schedule = (0, $42omo.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $42omo.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};





var $7kJa0 = parcelRequire("7kJa0");


var $4cEBp = parcelRequire("4cEBp");



const $db016eba4594a63a$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $db016eba4594a63a$var$PREFETCH_DELAY = 225;
const $db016eba4594a63a$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $bDniu.default)(_ref, $db016eba4594a63a$var$_excluded);
    const routerActions = (0, $fvDxY.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $e5e1340cfb852c3e$export$d8e6abf214c9ec0f)($db016eba4594a63a$var$PREFETCH_DELAY);
    const validLinkType = (0, $7kJa0.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $42omo.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $fgJFQ.createPath)((0, $90vNP.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $42omo.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $eNEWi.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $4cEBp.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $42omo.createElement)(validLinkType, (0, $7Q5yr.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$db016eba4594a63a$var$Link.displayName = 'Link';
var $db016eba4594a63a$export$2e2bcd8739ae039 = $db016eba4594a63a$var$Link;
module.exports["default"] = $db016eba4594a63a$export$2e2bcd8739ae039;

});

parcelRegister("99qx9", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

parcelRequire("fekRU");
var $bLeKY = parcelRequire("bLeKY");

const $6a9989614c37c704$export$7903e4b73fc7d6c3 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const [t0] = (0, $bLeKY.useRouter)();
    const { action: action, location: location, match: match, query: query, route: route } = t0;
    if (!route || !route.component) return null;
    let t1;
    if ($[0] !== action || $[1] !== location || $[2] !== match || $[3] !== query || $[4] !== route) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(route.component, {
            action: action,
            location: location,
            match: match,
            query: query,
            route: route
        });
        $[0] = action;
        $[1] = location;
        $[2] = match;
        $[3] = query;
        $[4] = route;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $bLeKY.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});

parcelRegister("7cg8h", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $fgJFQ = parcelRequire("fgJFQ");


var $ldFTj = parcelRequire("ldFTj");


var $9577u = parcelRequire("9577u");

const $53d62af6f7dec6ac$var$hasWindow = ()=>typeof window !== 'undefined';
const $53d62af6f7dec6ac$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9577u)))
};
const $53d62af6f7dec6ac$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $53d62af6f7dec6ac$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $53d62af6f7dec6ac$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($ldFTj)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $53d62af6f7dec6ac$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $53d62af6f7dec6ac$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $53d62af6f7dec6ac$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $7Q5yr.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $53d62af6f7dec6ac$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $53d62af6f7dec6ac$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $fgJFQ.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $fgJFQ.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $53d62af6f7dec6ac$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9577u))),
        createHref: (location)=>(0, $fgJFQ.createPath)(location)
    } : $53d62af6f7dec6ac$var$methodsPlaceholders);
};
module.exports["createLegacyHistory"] = $53d62af6f7dec6ac$export$883c3f3b6c000133;

});

parcelRegister("90vNP", function(module, exports) {

var $6u8gz = parcelRequire("6u8gz");


var $jBvme = parcelRequire("jBvme");

function $68ecc87c295e3713$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $jBvme.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $6u8gz.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}
module.exports["generateLocationFromPath"] = $68ecc87c295e3713$export$37e0729cc751960b;

});

parcelRegister("kgdzf", function(module, exports) {

var $6u8gz = parcelRequire("6u8gz");

const $ebffd37ed2f29079$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $6u8gz.compile)(pattern)(params);
module.exports["generatePath"] = $ebffd37ed2f29079$export$82476f982757e71e;

});

parcelRegister("2mGqd", function(module, exports) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $kyRHQ = parcelRequire("kyRHQ");

const $1b8e8af09982959b$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $1b8e8af09982959b$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $kyRHQ !== 'undefined' && $kyRHQ.versions != null && $kyRHQ.versions.node != null) return true;
    if ($1b8e8af09982959b$var$isJsDomEnvironment()) return true;
    return false;
};
module.exports["isServerEnvironment"] = $1b8e8af09982959b$export$455cc18296abe008;

});

parcelRegister("bRK5n", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a3864974e7521fc$export$2e2bcd8739ae039);

var $jBvme = parcelRequire("jBvme");


var $7Q5yr = parcelRequire("7Q5yr");

// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $6u8gz = parcelRequire("6u8gz");

const $88cc02e307def951$var$cache = {};
const $88cc02e307def951$var$cacheLimit = 10000;
let $88cc02e307def951$var$cacheCount = 0;
function $88cc02e307def951$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $88cc02e307def951$var$cache[cacheKey] || ($88cc02e307def951$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $6u8gz.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($88cc02e307def951$var$cacheCount < $88cc02e307def951$var$cacheLimit) {
        pathCache[path] = result;
        $88cc02e307def951$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $88cc02e307def951$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $88cc02e307def951$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $88cc02e307def951$export$2e2bcd8739ae039 = $88cc02e307def951$var$matchPath;





/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $81153f08ca88fcf2$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $7Q5yr.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $81153f08ca88fcf2$export$2e2bcd8739ae039 = $81153f08ca88fcf2$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $c9d7f4f03de0228a$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $c9d7f4f03de0228a$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $88cc02e307def951$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $c9d7f4f03de0228a$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $81153f08ca88fcf2$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $7Q5yr.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $c9d7f4f03de0228a$export$2e2bcd8739ae039 = $c9d7f4f03de0228a$var$execRouteMatching;


const $5f6ebbba23b821ba$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $5f6ebbba23b821ba$var$MAX_CACHE_SIZE = 1000;
function $5f6ebbba23b821ba$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$5f6ebbba23b821ba$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $5f6ebbba23b821ba$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($5f6ebbba23b821ba$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $5f6ebbba23b821ba$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $5f6ebbba23b821ba$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $8a3864974e7521fc$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $jBvme.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $5f6ebbba23b821ba$export$f594abf16a5ad948).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $c9d7f4f03de0228a$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $5f6ebbba23b821ba$export$f594abf16a5ad948).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $8a3864974e7521fc$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$8a3864974e7521fc$var$matchRoute(routes, pathname, queryParams, basePath);
const $8a3864974e7521fc$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $8a3864974e7521fc$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $8a3864974e7521fc$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$8a3864974e7521fc$var$matchRoute(routes, pathname, queryParams, basePath);
module.exports["warmupMatchRouteCache"] = $8a3864974e7521fc$export$4e76f1d455ef7c95;

});

parcelRegister("eNEWi", function(module, exports) {

var $jBvme = parcelRequire("jBvme");


var $eknCg = parcelRequire("eknCg");


var $kgdzf = parcelRequire("kgdzf");


var $bRK5n = parcelRequire("bRK5n");

const $ac6565fbdd2740f2$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $kgdzf.generatePath)(route.path, params);
    const matchedRoute = (0, $bRK5n.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $eknCg.DEFAULT_MATCH),
        query: query
    };
};
const $ac6565fbdd2740f2$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $jBvme.qs).parse(search);
    const matchedRoute = (0, $bRK5n.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $eknCg.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $eknCg.DEFAULT_MATCH)
    };
};
module.exports["createRouterContext"] = $ac6565fbdd2740f2$export$faed15f35ddc6f99;
module.exports["findRouterContext"] = $ac6565fbdd2740f2$export$a0bd0313cbeabd49;

});

parcelRegister("e8SDD", function(module, exports) {
const $a4bc320d29325c9b$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $a4bc320d29325c9b$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $a4bc320d29325c9b$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $a4bc320d29325c9b$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
module.exports["isSameRouteMatch"] = $a4bc320d29325c9b$export$5997e70fc4543270;

});

parcelRegister("67jR9", function(module, exports) {

var $dAheB = parcelRequire("dAheB");

parcelRequire("kiPPO");
var $2JDKk = parcelRequire("2JDKk");

const $4742cc970dec848b$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $4742cc970dec848b$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $dAheB.getResourceStore)().actions;
    const nextResources = (0, $2JDKk.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $4742cc970dec848b$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $dAheB.getResourceStore)().actions;
    const nextResources = (0, $2JDKk.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $4742cc970dec848b$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $dAheB.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $4742cc970dec848b$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $4742cc970dec848b$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $4742cc970dec848b$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $dAheB.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $dAheB.getResourceStore)().actions;
            const nextResources = (0, $2JDKk.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $dAheB.getResourceStore)().actions.getSafeData();
        }
    };
};

});

parcelRegister("dCvbe", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7dOkC = parcelRequire("7dOkC");

const $9ea702aeb9826c12$export$fee1a6213543bd78 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, resource: resource, options: options } = t0;
    const result = (0, $7dOkC.useResource)(resource, options);
    let t1;
    if ($[0] !== children || $[1] !== result) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children(result));
        $[0] = children;
        $[1] = result;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, resource: resource, options: options })=>{
    const result = (0, $7dOkC.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children(result));
};

});

parcelRegister("7dOkC", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

parcelRequire("cILXD");
var $fvDxY = parcelRequire("fvDxY");


var $dAheB = parcelRequire("dAheB");

const $5420ca17ee0c02f1$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $dAheB.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $fvDxY.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $42omo.useMemo)(()=>(0, $9zUhf.createHook)((0, $fvDxY.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $dAheB.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $42omo.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $42omo.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $42omo.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $42omo.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $42omo.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $7Q5yr.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};
module.exports["useResource"] = $5420ca17ee0c02f1$export$9f6abfd74295843b;

});

parcelRegister("gI0WE", function(module, exports) {

var $dAheB = parcelRequire("dAheB");

const $0323a30ca62195ae$export$dee7bf9fc0ff48c3 = (fn)=>(0, $dAheB.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("dAheB", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");

var $4HDYO = parcelRequire("4HDYO");

parcelRequire("fJGSb");
var $2mGqd = parcelRequire("2mGqd");




parcelRequire("kiPPO");
var $805w8 = parcelRequire("805w8");

const $b7ba00244348395b$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $7Q5yr.default)({}, slice) : (0, $805w8.getDefaultStateSlice)();
};
const $b7ba00244348395b$export$6a0b1779210de0ee = (state)=>state.context;


parcelRequire("kiPPO");
var $9TEQa = parcelRequire("9TEQa");
var $cWFMO = parcelRequire("cWFMO");
var $d9ugi = parcelRequire("d9ugi");
var $jzWvl = parcelRequire("jzWvl");
var $kewJQ = parcelRequire("kewJQ");
var $5dcSG = parcelRequire("5dcSG");
var $bxyvr = parcelRequire("bxyvr");
var $4rRjP = parcelRequire("4rRjP");
var $gsHWb = parcelRequire("gsHWb");
var $5QGUJ = parcelRequire("5QGUJ");
var $lQZ6X = parcelRequire("lQZ6X");

const $9e3c019357e66096$var$_excluded = [
    "context"
], $9e3c019357e66096$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $9e3c019357e66096$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $d9ugi.deleteResourceState)(type, key));
                dispatch((0, $9TEQa.executeForDependents)(resource, (dependentResource)=>$9e3c019357e66096$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $d9ugi.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $bDniu.default)(_getState, $9e3c019357e66096$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $b7ba00244348395b$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $7Q5yr.default)({}, prevSlice, changes, {
                expiresAt: (0, $5dcSG.getExpiresAt)(maxAge),
                accessedAt: (0, $kewJQ.getAccessedAt)()
            });
            dispatch((0, $d9ugi.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $9TEQa.executeForDependents)(resource, (dependentResource)=>$9e3c019357e66096$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $d9ugi.getResourceState)(type, key));
            if (cached && (0, $bxyvr.shouldUseCache)(cached)) {
                if ((0, $bxyvr.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $4rRjP.setSsrDataPromise)(cached);
                    cached = (0, $5dcSG.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $kewJQ.getAccessedAt)();
                dispatch((0, $d9ugi.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($9e3c019357e66096$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $d9ugi.getResourceState)(type, key)) || (0, $805w8.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $lQZ6X.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $d9ugi.getPrefetchSlice)(type, key)) || (0, $cWFMO.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $9TEQa.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $d9ugi.setResourceState)(type, key, (0, $7Q5yr.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $kewJQ.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $9TEQa.executeForDependents)(resource, (dependentResource)=>$9e3c019357e66096$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $gsHWb.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $d9ugi.getResourceState)(type, key));
            const finalSlice = (0, $7Q5yr.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $kewJQ.getAccessedAt)(),
                expiresAt: (0, $5dcSG.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $d9ugi.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $d9ugi.getPrefetchSlice)(type, key)) || (0, $cWFMO.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $9TEQa.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $d9ugi.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $9TEQa.executeForDependents)(resource, (dependentResource)=>$9e3c019357e66096$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $9e3c019357e66096$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $9TEQa.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $9e3c019357e66096$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $9TEQa.actionWithDependencies)(routerStoreContext.route.resources, resource, $9e3c019357e66096$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $9TEQa.actionWithDependencies)(routerStoreContext.route.resources, resource, $9e3c019357e66096$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $9TEQa.actionWithDependencies)(routerStoreContext.route.resources, resource, $9e3c019357e66096$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($9e3c019357e66096$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $d9ugi.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $d9ugi.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $2mGqd.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $9TEQa.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$9e3c019357e66096$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $9TEQa.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$9e3c019357e66096$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $7Q5yr.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $5QGUJ.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $bDniu.default)(_ref, $9e3c019357e66096$var$_excluded2);
                const deserializedError = !error ? null : (0, $jzWvl.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $7Q5yr.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $5QGUJ.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $jzWvl.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $gsHWb.TimeoutError) ? loading : false
                }))
};
const $9e3c019357e66096$export$94f50dade551bd01 = (0, $1P1Tu.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $9e3c019357e66096$export$e324594224ef24da,
    name: 'router-resources'
});
const $9e3c019357e66096$export$cc90fb9c37c5589d = (0, $FOT9i.createContainer)($9e3c019357e66096$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $9e3c019357e66096$export$fee1a6213543bd78 = (0, $j1v0l.createSubscriber)($9e3c019357e66096$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $b7ba00244348395b$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $9e3c019357e66096$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $4HDYO.defaultRegistry).getStore($9e3c019357e66096$export$94f50dade551bd01);
const $9e3c019357e66096$export$ac3608e0bb357c7 = (0, $9zUhf.createHook)($9e3c019357e66096$export$94f50dade551bd01, {
    selector: (0, $b7ba00244348395b$export$c9ed509724feb827)
});
const $9e3c019357e66096$export$98e41a62c9bef75e = (0, $9zUhf.createActionsHook)($9e3c019357e66096$export$94f50dade551bd01);
const $9e3c019357e66096$export$e59f52df235ac7b3 = (0, $9zUhf.createHook)($9e3c019357e66096$export$94f50dade551bd01, {
    selector: (0, $b7ba00244348395b$export$6a0b1779210de0ee)
});
module.exports["getResourceStore"] = $9e3c019357e66096$export$6f6057d42352becb;
module.exports["useResourceStore"] = $9e3c019357e66096$export$ac3608e0bb357c7;
module.exports["useResourceStoreActions"] = $9e3c019357e66096$export$98e41a62c9bef75e;

});

parcelRegister("citzk", function(module, exports) {
const $8f3e1a3bae8b20f8$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});

parcelRegister("75i5X", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Light.e0fef1fb.svg", import.meta.url).toString();

});

parcelRegister("aGLO2", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Dark.bc90ae31.svg", import.meta.url).toString();

});

parcelRegister("9HNv5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d561062df6e47d30$export$4047609c83584c4b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nCrwB",
    name: "CompanyHomeBuilderUpsellPage",
    loader: async ()=>(await (parcelRequire("eeExv"))).CompanyHomeBuilderUpsellPage
});
module.exports["CompanyHomeBuilderUpsellPage"] = $d561062df6e47d30$export$4047609c83584c4b;

});

parcelRegister("jKzCD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1uFM6 = parcelRequire("1uFM6");


var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $8NC5Z = parcelRequire("8NC5Z");


var $gi8UL = parcelRequire("gi8UL");

function $6d8995f9c98e457c$export$567b73f497a151cb({ onSuccess: onSuccess, onExists: onExists, route: route }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCreatingHub, setIsCreatingHub] = (0, $42omo.useState)(false);
    const [creationError, setCreationError] = (0, $42omo.useState)(null);
    const { isSiteAdmin: isSiteAdmin, frontCoverState: frontCoverState } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const isCompanyHubUnset = frontCoverState === (0, $cEgMD.FrontCoverStateEnum).UNSET;
    const hasCreatedHub = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasCreatedHub.current) {
            const shouldCreateHub = isCompanyHubUnset && isSiteAdmin && !shouldShowPremiumUpsell && !isCreatingHub;
            if (shouldCreateHub) {
                let wasHubCreated = false;
                setIsCreatingHub(true);
                hasCreatedHub.current = true;
                experienceTracker.start({
                    name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
                });
                (0, $gi8UL.createCompanyHubSpace)().then(({ didCreateSpace: didCreateSpace, homepageId: homepageId })=>{
                    if (didCreateSpace) {
                        experienceTracker.succeed({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE)
                        });
                        wasHubCreated = true;
                        onSuccess?.(homepageId);
                    } else {
                        experienceTracker.abort({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                            reason: 'Hub space already exists. Handled by redirecting user to Hub editor without first time experience'
                        });
                        onExists?.(homepageId);
                    }
                }).catch((error)=>{
                    setCreationError(error);
                    if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User has stale admin permissions'
                    });
                    else if ((0, $1uFM6.isUnauthorizedError)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User is not authenticated'
                    });
                    else experienceTracker.fail({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        error: error
                    });
                }).finally(()=>{
                    setIsCreatingHub(false);
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            source: 'companyHub',
                            action: 'created',
                            actionSubject: 'onRouteStart',
                            actionSubjectId: 'companyHubOnRouteCreation',
                            attributes: {
                                created: wasHubCreated,
                                route: route
                            }
                        }
                    }).fire();
                });
            }
        }
    }, [
        isCompanyHubUnset,
        isSiteAdmin,
        createAnalyticsEvent,
        shouldShowPremiumUpsell,
        isCreatingHub,
        experienceTracker,
        onSuccess,
        onExists,
        route
    ]);
    return {
        isCreatingHub: isCreatingHub,
        creationError: creationError
    };
}
module.exports["useCompanyHubOnRouteCreationFlow"] = $6d8995f9c98e457c$export$567b73f497a151cb;

});

parcelRegister("eCfJ3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $abC4X = parcelRequire("abC4X");


var $7p4As = parcelRequire("7p4As");


var $bUlM5 = parcelRequire("bUlM5");


var $ecnYn = parcelRequire("ecnYn");


var $2Nwuj = parcelRequire("2Nwuj");


var $1NBp8 = parcelRequire("1NBp8");


var $1uFM6 = parcelRequire("1uFM6");


var $gi8UL = parcelRequire("gi8UL");


var $iQTig = parcelRequire("iQTig");


var $5X6zn = parcelRequire("5X6zn");

const $3f49c0dd8d66c83c$var$containerStyles = (0, $ecnYn.xcss)({
    height: '90vh',
    paddingInline: 'space.200'
});
const $3f49c0dd8d66c83c$export$c09c08db0e42b276 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const errorConfig = (0, $42omo.useMemo)(()=>{
        if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5X6zn))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagDescription, {
                a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, chunks)
            })
        };
        if ((0, $1uFM6.isUnauthorizedError)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5X6zn))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagDescription, {
                b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
            }),
            buttonLabel: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagButton),
            buttonLink: (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()
        };
        return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iQTig))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagDescription)
        };
    }, [
        error,
        formatMessage
    ]);
    const { imageUrl: imageUrl, title: title, description: description, buttonLabel: buttonLabel, buttonLink: buttonLink } = errorConfig;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $3f49c0dd8d66c83c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
        header: title,
        description: description,
        primaryAction: buttonLabel && buttonLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "primary",
            href: buttonLink
        }, buttonLabel) : undefined,
        imageUrl: imageUrl
    }));
};
module.exports["HubErrorPageComponent"] = $3f49c0dd8d66c83c$export$c09c08db0e42b276;

});

parcelRegister("eDATL", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5AtW0 = parcelRequire("5AtW0");


var $e6Iiv = parcelRequire("e6Iiv");


var $auTg8 = parcelRequire("auTg8");


var $1JdaQ = parcelRequire("1JdaQ");


var $k00oi = parcelRequire("k00oi");

var $7bZ3i = parcelRequire("7bZ3i");


var $gdv5Z = parcelRequire("gdv5Z");


var $fwDOR = parcelRequire("fwDOR");


var $9hlns = parcelRequire("9hlns");


var $8Ixq2 = parcelRequire("8Ixq2");

var $jrlgF = parcelRequire("jrlgF");

var $g3LxX = parcelRequire("g3LxX");

var $gqsO5 = parcelRequire("gqsO5");


var $calJ6 = parcelRequire("calJ6");

var $3y8SL = parcelRequire("3y8SL");


var $bsZfq = parcelRequire("bsZfq");


var $fs87B = parcelRequire("fs87B");

var $40t6Q = parcelRequire("40t6Q");


var $55iAf = parcelRequire("55iAf");


var $8nA5C = parcelRequire("8nA5C");


var $iIQ1o = parcelRequire("iIQ1o");


var $fMq01 = parcelRequire("fMq01");

const $a9c57e8f71b11b09$var$hubEditorStyles = {
    spinnerContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kxc"
};
const $a9c57e8f71b11b09$var$EditorInternal = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(72);
    const intl = (0, $aXWIB.useIntl)();
    const [editorApi, setEditorApi] = (0, $42omo.useState)(undefined);
    const { editorActions: editorActions, contentId: contentId, userId: userId, cloudId: cloudId, product: product, mediaProvider: mediaProvider, setExternalEditorApi: setExternalEditorApi, additionalExtensionProviders: t0, loadAdditionalExtensionProviders: loadAdditionalExtensionProviders, onExtensionProvidersLoaded: onExtensionProvidersLoaded, PropsProvider: PropsProvider, linkPickerOptions: linkPickerOptions } = props;
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? [] : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const additionalExtensionProviders = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new (0, $k00oi.default)();
        $[2] = t2;
    } else t2 = $[2];
    const smartCardClient = t2;
    const { pageMediaConfig: pageMediaConfig } = (0, $gqsO5.useHubContext)();
    const { closeConfigPanel: closeConfigPanel, openConfigPanel: openConfigPanel } = (0, $3y8SL.useHubEditorExtensionConfigPanel)(editorActions);
    const [t3] = (0, $g3LxX.useExtensionsState)();
    const { selectedExtensionLocalId: selectedExtensionLocalId } = t3;
    const { setIsInViewMode: setIsInViewMode } = (0, $g3LxX.useExtensionsActions)();
    const { featureFlags: featureFlags } = (0, $gqsO5.useHubContext)();
    let t4;
    if ($[3] !== PropsProvider || $[4] !== contentId || $[5] !== editorActions || $[6] !== intl || $[7] !== openConfigPanel) {
        t4 = {
            contentId: contentId,
            intl: intl,
            PropsProvider: PropsProvider,
            editorActions: editorActions,
            openConfigPanel: openConfigPanel
        };
        $[3] = PropsProvider;
        $[4] = contentId;
        $[5] = editorActions;
        $[6] = intl;
        $[7] = openConfigPanel;
        $[8] = t4;
    } else t4 = $[8];
    const hubExtensionProviders = (0, $40t6Q.useHubExtensionProviders)(t4);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t5;
    let t6;
    if ($[9] !== editorActions || $[10] !== loadAdditionalExtensionProviders || $[11] !== openConfigPanel) {
        t5 = ()=>{
            if (loadAdditionalExtensionProviders && editorActions) loadAdditionalExtensionProviders({
                editorActions: editorActions,
                openConfigPanel: openConfigPanel
            });
        };
        t6 = [
            loadAdditionalExtensionProviders,
            editorActions,
            openConfigPanel
        ];
        $[9] = editorActions;
        $[10] = loadAdditionalExtensionProviders;
        $[11] = openConfigPanel;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t5, t6);
    let t7;
    if ($[14] !== additionalExtensionProviders || $[15] !== hubExtensionProviders) {
        t7 = [
            ...hubExtensionProviders,
            ...additionalExtensionProviders
        ];
        $[14] = additionalExtensionProviders;
        $[15] = hubExtensionProviders;
        $[16] = t7;
    } else t7 = $[16];
    const allExtensionProviders = t7;
    let t8;
    let t9;
    if ($[17] !== allExtensionProviders || $[18] !== onExtensionProvidersLoaded) {
        t8 = ()=>{
            if (onExtensionProvidersLoaded && allExtensionProviders.length > 0) onExtensionProvidersLoaded(allExtensionProviders);
        };
        t9 = [
            onExtensionProvidersLoaded,
            allExtensionProviders
        ];
        $[17] = allExtensionProviders;
        $[18] = onExtensionProvidersLoaded;
        $[19] = t8;
        $[20] = t9;
    } else {
        t8 = $[19];
        t9 = $[20];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t8, t9);
    let t10;
    if ($[21] !== contentId || $[22] !== editorApi || $[23] !== mediaProvider || $[24] !== pageMediaConfig) {
        t10 = {
            contentId: contentId,
            editorAPI: editorApi,
            customMediaProvider: mediaProvider,
            mediaConfig: pageMediaConfig
        };
        $[21] = contentId;
        $[22] = editorApi;
        $[23] = mediaProvider;
        $[24] = pageMediaConfig;
        $[25] = t10;
    } else t10 = $[25];
    const mediaOptions = (0, $iIQ1o.useMediaOptions)(t10);
    let t11;
    if ($[26] !== featureFlags || $[27] !== intl || $[28] !== linkPickerOptions || $[29] !== mediaOptions || $[30] !== props) {
        t11 = ()=>(0, $8nA5C.createHubEditorPreset)({
                ...props,
                intl: intl,
                mediaOptions: mediaOptions,
                linkPickerOptions: linkPickerOptions,
                featureFlags: featureFlags
            });
        $[26] = featureFlags;
        $[27] = intl;
        $[28] = linkPickerOptions;
        $[29] = mediaOptions;
        $[30] = props;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== contentId || $[33] !== intl || $[34] !== linkPickerOptions || $[35] !== mediaOptions || $[36] !== props.editorPluginAIDefinitionsEnabled || $[37] !== props.editorPluginHubTextColorEnabled || $[38] !== props.hasEditPermission || $[39] !== props.isDesktop || $[40] !== props.isLoomPluginEnabled) {
        t12 = [
            intl,
            props.hasEditPermission,
            props.isLoomPluginEnabled,
            props.editorPluginAIDefinitionsEnabled,
            props.editorPluginHubTextColorEnabled,
            props.isDesktop,
            contentId,
            mediaOptions,
            linkPickerOptions
        ];
        $[32] = contentId;
        $[33] = intl;
        $[34] = linkPickerOptions;
        $[35] = mediaOptions;
        $[36] = props.editorPluginAIDefinitionsEnabled;
        $[37] = props.editorPluginHubTextColorEnabled;
        $[38] = props.hasEditPermission;
        $[39] = props.isDesktop;
        $[40] = props.isLoomPluginEnabled;
        $[41] = t12;
    } else t12 = $[41];
    const { preset: preset, editorApi: presetEditorApi } = (0, $1JdaQ.usePreset)(t11, t12);
    let t13;
    let t14;
    if ($[42] !== setIsInViewMode) {
        t13 = ()=>{
            setIsInViewMode(false);
        };
        t14 = [
            setIsInViewMode
        ];
        $[42] = setIsInViewMode;
        $[43] = t13;
        $[44] = t14;
    } else {
        t13 = $[43];
        t14 = $[44];
    }
    (0, $42omo.useEffect)(t13, t14);
    let t15;
    let t16;
    if ($[45] !== presetEditorApi || $[46] !== setExternalEditorApi) {
        t15 = ()=>{
            setEditorApi(presetEditorApi);
            if (!setExternalEditorApi || !presetEditorApi) return;
            setExternalEditorApi(presetEditorApi);
        };
        t16 = [
            presetEditorApi,
            setExternalEditorApi
        ];
        $[45] = presetEditorApi;
        $[46] = setExternalEditorApi;
        $[47] = t15;
        $[48] = t16;
    } else {
        t15 = $[47];
        t16 = $[48];
    }
    (0, $42omo.useEffect)(t15, t16);
    let t17;
    if ($[49] !== PropsProvider || $[50] !== additionalExtensionProviders || $[51] !== allExtensionProviders || $[52] !== closeConfigPanel || $[53] !== cloudId || $[54] !== contentId || $[55] !== editorActions || $[56] !== editorApi || $[57] !== formatMessage || $[58] !== hubExtensionProviders.length || $[59] !== preset || $[60] !== props || $[61] !== selectedExtensionLocalId || $[62] !== userId) {
        t17 = (linkingFeatures)=>hubExtensionProviders.length > 0 && additionalExtensionProviders.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6Iiv.ComposableEditor), {
                appearance: "full-page",
                ...linkingFeatures,
                ...props,
                preset: preset,
                ...allExtensionProviders.length > 0 ? {
                    extensionProviders: allExtensionProviders
                } : {},
                editorActions: editorActions,
                contextPanel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $calJ6.HubEditorConfigPanelEntryPoint), {
                    localId: selectedExtensionLocalId || "",
                    closeConfigPanel: closeConfigPanel,
                    editorActions: editorActions,
                    contentId: contentId,
                    editorApi: editorApi,
                    propsProvider: PropsProvider
                }),
                emojiProvider: (0, $fs87B.getEmojiProvider)({
                    cloudId: cloudId,
                    userId: userId
                })
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
                name: "hub-extensions-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $a9c57e8f71b11b09$var$hubEditorStyles.spinnerContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                size: "large",
                label: formatMessage((0, $fMq01.default).hubStudioLoadingSpinnerLabel)
            })));
        $[49] = PropsProvider;
        $[50] = additionalExtensionProviders;
        $[51] = allExtensionProviders;
        $[52] = closeConfigPanel;
        $[53] = cloudId;
        $[54] = contentId;
        $[55] = editorActions;
        $[56] = editorApi;
        $[57] = formatMessage;
        $[58] = hubExtensionProviders.length;
        $[59] = preset;
        $[60] = props;
        $[61] = selectedExtensionLocalId;
        $[62] = userId;
        $[63] = t17;
    } else t17 = $[63];
    let t18;
    if ($[64] !== cloudId || $[65] !== linkPickerOptions || $[66] !== product || $[67] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bsZfq.EditorLinkingFeatures), {
            product: product,
            cloudId: cloudId,
            options: (0, $55iAf.LINKING_FEATURES_CARD_OPTIONS),
            linkPickerOptions: linkPickerOptions
        }, t17);
        $[64] = cloudId;
        $[65] = linkPickerOptions;
        $[66] = product;
        $[67] = t17;
        $[68] = t18;
    } else t18 = $[68];
    let t19;
    if ($[69] !== product || $[70] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), {
            product: product,
            client: smartCardClient
        }, t18);
        $[69] = product;
        $[70] = t18;
        $[71] = t19;
    } else t19 = $[71];
    return t19;
} : (props)=>{
    const intl = (0, $aXWIB.useIntl)();
    const [editorApi, setEditorApi] = (0, $42omo.useState)(undefined);
    const { editorActions: editorActions, contentId: contentId, userId: userId, cloudId: cloudId, product: product, mediaProvider: mediaProvider, setExternalEditorApi: setExternalEditorApi, additionalExtensionProviders: additionalExtensionProviders = [], loadAdditionalExtensionProviders: loadAdditionalExtensionProviders, onExtensionProvidersLoaded: onExtensionProvidersLoaded, PropsProvider: PropsProvider, linkPickerOptions: linkPickerOptions } = props;
    const smartCardClient = (0, $42omo.useMemo)(()=>new (0, $k00oi.default)(), []);
    const { pageMediaConfig: pageMediaConfig } = (0, $gqsO5.useHubContext)();
    const { closeConfigPanel: closeConfigPanel, openConfigPanel: openConfigPanel } = (0, $3y8SL.useHubEditorExtensionConfigPanel)(editorActions);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId }] = (0, $g3LxX.useExtensionsState)();
    const { setIsInViewMode: setIsInViewMode } = (0, $g3LxX.useExtensionsActions)();
    const { featureFlags: featureFlags } = (0, $gqsO5.useHubContext)();
    const hubExtensionProviders = (0, $40t6Q.useHubExtensionProviders)({
        contentId: contentId,
        intl: intl,
        PropsProvider: PropsProvider,
        editorActions: editorActions,
        openConfigPanel: openConfigPanel
    });
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)(); // Load additional extension providers when editor is ready; we need to inject
    // editor-specific props
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (loadAdditionalExtensionProviders && editorActions) loadAdditionalExtensionProviders({
            editorActions: editorActions,
            openConfigPanel: openConfigPanel
        });
    }, [
        loadAdditionalExtensionProviders,
        editorActions,
        openConfigPanel
    ]);
    // Combine hub extensions with additional extensions
    const allExtensionProviders = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return [
            ...hubExtensionProviders,
            ...additionalExtensionProviders
        ];
    }, [
        hubExtensionProviders,
        additionalExtensionProviders
    ]); // Notify parent when all extension providers (hub + additional) are available
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (onExtensionProvidersLoaded && allExtensionProviders.length > 0) onExtensionProvidersLoaded(allExtensionProviders);
    }, [
        onExtensionProvidersLoaded,
        allExtensionProviders
    ]);
    const mediaOptions = (0, $iIQ1o.useMediaOptions)({
        contentId: contentId,
        editorAPI: editorApi,
        customMediaProvider: mediaProvider,
        mediaConfig: pageMediaConfig
    });
    const { preset: preset, editorApi: presetEditorApi } = (0, $1JdaQ.usePreset)(()=>{
        return (0, $8nA5C.createHubEditorPreset)({
            ...props,
            intl: intl,
            mediaOptions: mediaOptions,
            linkPickerOptions: linkPickerOptions,
            featureFlags: featureFlags
        });
    }, [
        intl,
        props.hasEditPermission,
        props.isLoomPluginEnabled,
        props.editorPluginAIDefinitionsEnabled,
        props.editorPluginHubTextColorEnabled,
        props.isDesktop,
        contentId,
        mediaOptions,
        linkPickerOptions
    ]);
    (0, $42omo.useEffect)(()=>{
        setIsInViewMode(false);
    }, [
        setIsInViewMode
    ]);
    (0, $42omo.useEffect)(()=>{
        setEditorApi(presetEditorApi);
        if (!setExternalEditorApi || !presetEditorApi) return;
        setExternalEditorApi(presetEditorApi);
    }, [
        presetEditorApi,
        setExternalEditorApi
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), {
        product: product,
        client: smartCardClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bsZfq.EditorLinkingFeatures), {
        product: product,
        cloudId: cloudId,
        options: (0, $55iAf.LINKING_FEATURES_CARD_OPTIONS),
        linkPickerOptions: linkPickerOptions
    }, (linkingFeatures)=>{
        return hubExtensionProviders.length > 0 && additionalExtensionProviders.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6Iiv.ComposableEditor), {
            appearance: "full-page",
            ...linkingFeatures,
            ...props,
            preset: preset,
            ...allExtensionProviders.length > 0 ? {
                extensionProviders: allExtensionProviders
            } : {},
            editorActions: editorActions,
            contextPanel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $calJ6.HubEditorConfigPanelEntryPoint), {
                localId: selectedExtensionLocalId || '',
                closeConfigPanel: closeConfigPanel,
                editorActions: editorActions,
                contentId: contentId,
                editorApi: editorApi,
                propsProvider: PropsProvider
            }),
            emojiProvider: (0, $fs87B.getEmojiProvider)({
                cloudId: cloudId,
                userId: userId
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "hub-extensions-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $a9c57e8f71b11b09$var$hubEditorStyles.spinnerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: 'large',
            label: formatMessage((0, $fMq01.default).hubStudioLoadingSpinnerLabel)
        })));
    }));
};
const $a9c57e8f71b11b09$var$HubEditor = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Ixq2.GenericErrorPage), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrlgF.HubErrorBoundary), {
            packageName: "@atlassian/hub-editor",
            id: "hub-editor",
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auTg8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5AtW0.default), {
            render: (editorActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a9c57e8f71b11b09$var$EditorInternal, {
                    editorActions: editorActions,
                    ...props
                })
        })));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrlgF.HubErrorBoundary), {
        packageName: "@atlassian/hub-editor",
        id: "hub-editor",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Ixq2.GenericErrorPage), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auTg8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5AtW0.default), {
        render: (editorActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a9c57e8f71b11b09$var$EditorInternal, {
                editorActions: editorActions,
                ...props
            })
    })));
};
var $a9c57e8f71b11b09$export$2e2bcd8739ae039 = $a9c57e8f71b11b09$var$HubEditor;
module.exports["default"] = $a9c57e8f71b11b09$export$2e2bcd8739ae039;

});

parcelRegister("bUMKD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bab760cfbd2a476f$export$efc60a58bfe62d46 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CsDwr",
    name: "ExternalSharePageLoader",
    loader: async ()=>(await (parcelRequire("drIIO"))).ExternalSharePage
});
module.exports["ExternalSharePageLoader"] = $bab760cfbd2a476f$export$efc60a58bfe62d46;

});

parcelRegister("7kJa0", function(module, exports) {
const $556d6e904ae2cb77$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $556d6e904ae2cb77$export$855ece989b15eb57 = (type)=>$556d6e904ae2cb77$var$VALID_LINK_TYPES.includes(type) ? type : 'a';
module.exports["getValidLinkType"] = $556d6e904ae2cb77$export$855ece989b15eb57;

});

parcelRegister("4cEBp", function(module, exports) {
const $298cd4e6f66a6ca2$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $298cd4e6f66a6ca2$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);


const $30f7c735edfd6408$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $298cd4e6f66a6ca2$export$130b789831072f4c)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $298cd4e6f66a6ca2$export$130b789831072f4c)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $298cd4e6f66a6ca2$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};
module.exports["handleNavigation"] = $30f7c735edfd6408$export$706ad1af8096e280;

});

parcelRegister("kewJQ", function(module, exports) {
const $ebae82a295ea9871$export$9ccb639b7a119f61 = ()=>Date.now();
module.exports["getAccessedAt"] = $ebae82a295ea9871$export$9ccb639b7a119f61;

});

parcelRegister("cWFMO", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $77j7A = parcelRequire("77j7A");


var $5dcSG = parcelRequire("5dcSG");


var $7yWTQ = parcelRequire("7yWTQ");


var $gsHWb = parcelRequire("gsHWb");

const $dd3d42294a4a783e$export$37d3126be6549b13 = 10000;


function $96cb50b2b6a0b3cb$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $7Q5yr.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $7yWTQ.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $gsHWb.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $5dcSG.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $77j7A.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $5dcSG.getExpiresAt)((0, $dd3d42294a4a783e$export$37d3126be6549b13))) : resourceMaxAge
    };
}
module.exports["createLoadingSlice"] = $96cb50b2b6a0b3cb$export$dc62515c8f0b52dd;

});

parcelRegister("9co0j", function(module, exports) {

var $77j7A = parcelRequire("77j7A");

/**
 * Utility method to created async versions of getData functions
 */ const $6b27dac18cfad6ce$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $6b27dac18cfad6ce$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $6b27dac18cfad6ce$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $77j7A.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $77j7A.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $77j7A.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("9TEQa", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $805w8 = parcelRequire("805w8");


var $d9ugi = parcelRequire("d9ugi");

var $01dc03d74c43c24b$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $01dc03d74c43c24b$var$fromEntries = ($01dc03d74c43c24b$var$_Object$fromEntries = Object.fromEntries) != null ? $01dc03d74c43c24b$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $01dc03d74c43c24b$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $01dc03d74c43c24b$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $01dc03d74c43c24b$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($01dc03d74c43c24b$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($01dc03d74c43c24b$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($01dc03d74c43c24b$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $01dc03d74c43c24b$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($01dc03d74c43c24b$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $01dc03d74c43c24b$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$01dc03d74c43c24b$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $01dc03d74c43c24b$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($01dc03d74c43c24b$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $01dc03d74c43c24b$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($01dc03d74c43c24b$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $01dc03d74c43c24b$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($01dc03d74c43c24b$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $01dc03d74c43c24b$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $01dc03d74c43c24b$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $01dc03d74c43c24b$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $d9ugi.getResourceState)(dependencyType, key)) || (0, $805w8.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $d9ugi.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $7Q5yr.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };
module.exports["actionWithDependencies"] = $01dc03d74c43c24b$export$5f7e1fd85734e71e;
module.exports["mapActionWithDependencies"] = $01dc03d74c43c24b$export$f71a65c89c987a02;
module.exports["executeForDependents"] = $01dc03d74c43c24b$export$7d1ffac63c68405d;
module.exports["getDependencies"] = $01dc03d74c43c24b$export$75915f81f2a6540a;

});

parcelRegister("5dcSG", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");

const $3cb8288f8bd76f1d$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $3cb8288f8bd76f1d$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $7Q5yr.default)({}, slice, {
        expiresAt: $3cb8288f8bd76f1d$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;
module.exports["getExpiresAt"] = $3cb8288f8bd76f1d$export$b65d7ba7fbf150f1;
module.exports["setExpiresAt"] = $3cb8288f8bd76f1d$export$18d1d420fd588368;

});

parcelRegister("7yWTQ", function(module, exports) {
const $5819659e47b8b03a$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};
module.exports["generateTimeGuard"] = $5819659e47b8b03a$export$58634b3a58ae66b7;

});

parcelRegister("805w8", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $kewJQ = parcelRequire("kewJQ");


var $77j7A = parcelRequire("77j7A");


var $5dcSG = parcelRequire("5dcSG");

/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $21ed6f9fefefd2b7$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $5d329a7033b585ad$export$fa8e33c3301e2e94 = ()=>(0, $7Q5yr.default)({}, (0, $21ed6f9fefefd2b7$export$2df85a734ff5ed27), {
        expiresAt: (0, $5dcSG.getExpiresAt)((0, $77j7A.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $kewJQ.getAccessedAt)()
    });
module.exports["getDefaultStateSlice"] = $5d329a7033b585ad$export$fa8e33c3301e2e94;

});

parcelRegister("fZdY8", function(module, exports) {
const $ba376373d546270a$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $ba376373d546270a$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$ba376373d546270a$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
module.exports["getResourceIdentifier"] = $ba376373d546270a$export$c616b176adf9ad4a;
module.exports["getResourceIdentifiers"] = $ba376373d546270a$export$cd7fbe7e979df558;

});

parcelRegister("2JDKk", function(module, exports) {

var $fZdY8 = parcelRequire("fZdY8");


var $aHI0m = parcelRequire("aHI0m");

const $1fde9d7e88344811$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $aHI0m.routeHasResources)(nextRoute)) return [];
    if ((0, $aHI0m.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $fZdY8.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $fZdY8.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};
module.exports["getResourcesForNextLocation"] = $1fde9d7e88344811$export$7cbbc763e2f3d65d;

});

parcelRegister("lQZ6X", function(module, exports) {

var $d9ugi = parcelRequire("d9ugi");

const $041b0fee44978eed$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $041b0fee44978eed$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $041b0fee44978eed$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $041b0fee44978eed$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $041b0fee44978eed$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $d9ugi.deleteResourceState)(type, keyTobeDeleted));
    };
module.exports["validateLRUCache"] = $041b0fee44978eed$export$89440b7623c2c75c;

});

parcelRegister("d9ugi", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $7Q5yr = parcelRequire("7Q5yr");

function $993396fcd283d97e$var$_toPropertyKey(t) {
    var i = $993396fcd283d97e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $993396fcd283d97e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $993396fcd283d97e$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $993396fcd283d97e$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $7Q5yr.default)({}, prefetching, {
                [type]: (0, $7Q5yr.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $993396fcd283d97e$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($993396fcd283d97e$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $7Q5yr.default)({}, data, {
                [type]: (0, $7Q5yr.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $993396fcd283d97e$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $993396fcd283d97e$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $bDniu.default)(data, [
            type
        ].map($993396fcd283d97e$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $bDniu.default)(resourceForType, [
                key
            ].map($993396fcd283d97e$var$_toPropertyKey));
            setState({
                data: (0, $7Q5yr.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };
module.exports["getPrefetchSlice"] = $993396fcd283d97e$export$11374758be89e40;
module.exports["setPrefetchSlice"] = $993396fcd283d97e$export$1e32615dc8354436;
module.exports["setResourceState"] = $993396fcd283d97e$export$704f800f263b050e;
module.exports["getResourceState"] = $993396fcd283d97e$export$5fc90c33b03fffb;
module.exports["deleteResourceState"] = $993396fcd283d97e$export$d40f35dc5952864b;

});

parcelRegister("aHI0m", function(module, exports) {
const $7cb00df43ecd63c9$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $7cb00df43ecd63c9$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
module.exports["routeHasResources"] = $7cb00df43ecd63c9$export$740886389191c640;
module.exports["routeHasChanged"] = $7cb00df43ecd63c9$export$221027ff1aa38f82;

});

parcelRegister("jzWvl", function(module, exports) {
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $e40eaaf8ba0e3baf$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e40eaaf8ba0e3baf$var$NonError);
    }
}
const $e40eaaf8ba0e3baf$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $e40eaaf8ba0e3baf$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $e40eaaf8ba0e3baf$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $e40eaaf8ba0e3baf$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $e40eaaf8ba0e3baf$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $e40eaaf8ba0e3baf$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $e40eaaf8ba0e3baf$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $e40eaaf8ba0e3baf$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $e40eaaf8ba0e3baf$var$NonError(value);
};
module.exports["serializeError"] = $e40eaaf8ba0e3baf$export$46ff38bc6bdea8fb;
module.exports["deserializeError"] = $e40eaaf8ba0e3baf$export$64cddc1e268e9046;

});

parcelRegister("bxyvr", function(module, exports) {
const $866d8af9e56aeb5e$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $866d8af9e56aeb5e$var$isFresh = (resource)=>{
    if ($866d8af9e56aeb5e$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $866d8af9e56aeb5e$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($866d8af9e56aeb5e$var$isFresh(resource)) return true;
    return false;
};
module.exports["isFromSsr"] = $866d8af9e56aeb5e$export$b25d2963b8a3488a;
module.exports["shouldUseCache"] = $866d8af9e56aeb5e$export$399de8c43d0ece3c;

});

parcelRegister("4rRjP", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");

const $33d30b06eb892254$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $7Q5yr.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;
module.exports["setSsrDataPromise"] = $33d30b06eb892254$export$2e4da1b414980956;

});

parcelRegister("gsHWb", function(module, exports) {
class $bfc157eefbe6b0df$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}
module.exports["TimeoutError"] = $bfc157eefbe6b0df$export$66d311bf29d5c89c;

});

parcelRegister("5QGUJ", function(module, exports) {
const $442318ec4c29808b$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});
module.exports["transformData"] = $442318ec4c29808b$export$3ceb62baab058c6b;

});

parcelRegister("kiPPO", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("kewJQ")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("cWFMO")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("9TEQa")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("9TEQa")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("9TEQa")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("9TEQa")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("5dcSG")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("5dcSG")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("805w8")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("2JDKk")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("lQZ6X")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("d9ugi")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("d9ugi")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("d9ugi")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("d9ugi")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("d9ugi")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("jzWvl")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("jzWvl")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("bxyvr")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("bxyvr")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("4rRjP")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("gsHWb")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("5QGUJ")).transformData);

var $kewJQ = parcelRequire("kewJQ");


var $cWFMO = parcelRequire("cWFMO");


var $9co0j = parcelRequire("9co0j");


var $9TEQa = parcelRequire("9TEQa");


var $5dcSG = parcelRequire("5dcSG");


var $7yWTQ = parcelRequire("7yWTQ");


var $805w8 = parcelRequire("805w8");


var $fZdY8 = parcelRequire("fZdY8");


var $2JDKk = parcelRequire("2JDKk");


var $lQZ6X = parcelRequire("lQZ6X");


var $d9ugi = parcelRequire("d9ugi");


var $aHI0m = parcelRequire("aHI0m");


var $jzWvl = parcelRequire("jzWvl");


var $bxyvr = parcelRequire("bxyvr");


var $4rRjP = parcelRequire("4rRjP");


var $gsHWb = parcelRequire("gsHWb");


var $5QGUJ = parcelRequire("5QGUJ");


});

parcelRegister("iQTig", function(module, exports) {
module.exports = new URL("GenericError.cd21964e.svg", import.meta.url).toString();

});

parcelRegister("5X6zn", function(module, exports) {
module.exports = new URL("RestrictedError.e0fef1fb.svg", import.meta.url).toString();

});

parcelRegister("calJ6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $fwDOR = parcelRequire("fwDOR");


var $8Ixq2 = parcelRequire("8Ixq2");

var $jrlgF = parcelRequire("jrlgF");


const $694cf1213eae6915$var$HubEditorConfigPanelLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("cCWcB")).then((mod)=>({
            default: mod.HubEditorConfigPanel
        })));
const $694cf1213eae6915$export$99ce0b7d4622b2b7 = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { localId: localId, closeConfigPanel: closeConfigPanel, contentId: contentId, editorActions: editorActions, editorApi: editorApi, propsProvider: propsProvider } = t0;
    if (localId) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, $l998X.jsx)((0, $8Ixq2.GenericErrorPage), {});
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                name: "editor-config-panel-chunk-loader"
            });
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== closeConfigPanel || $[3] !== contentId || $[4] !== editorActions || $[5] !== editorApi || $[6] !== localId || $[7] !== propsProvider) {
            t3 = /*#__PURE__*/ (0, $l998X.jsx)((0, $jrlgF.HubErrorBoundary), {
                id: "hub-editor-config-panel",
                packageName: "@atlassian/hub-editor-config-panel",
                fallback: t1,
                shouldForceError: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: t2,
                    children: /*#__PURE__*/ (0, $l998X.jsx)($694cf1213eae6915$var$HubEditorConfigPanelLazy, {
                        localId: localId,
                        closeConfigPanel: closeConfigPanel,
                        contentId: contentId,
                        editorActions: editorActions,
                        editorApi: editorApi,
                        propsProvider: propsProvider
                    })
                })
            });
            $[2] = closeConfigPanel;
            $[3] = contentId;
            $[4] = editorActions;
            $[5] = editorApi;
            $[6] = localId;
            $[7] = propsProvider;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    return null;
} : ({ localId: localId, closeConfigPanel: closeConfigPanel, contentId: contentId, editorActions: editorActions, editorApi: editorApi, propsProvider: propsProvider })=>{
    if (localId) return /*#__PURE__*/ (0, $l998X.jsx)((0, $jrlgF.HubErrorBoundary), {
        id: "hub-editor-config-panel",
        packageName: "@atlassian/hub-editor-config-panel",
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $8Ixq2.GenericErrorPage), {}),
        shouldForceError: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                name: "editor-config-panel-chunk-loader"
            }),
            children: /*#__PURE__*/ (0, $l998X.jsx)($694cf1213eae6915$var$HubEditorConfigPanelLazy, {
                localId: localId,
                closeConfigPanel: closeConfigPanel,
                contentId: contentId,
                editorActions: editorActions,
                editorApi: editorApi,
                propsProvider: propsProvider
            })
        })
    });
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
module.exports["HubEditorConfigPanelEntryPoint"] = $694cf1213eae6915$export$99ce0b7d4622b2b7;

});

parcelRegister("3y8SL", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ks2lK = parcelRequire("ks2lK");


var $4TXTZ = parcelRequire("4TXTZ");


var $g3LxX = parcelRequire("g3LxX");


var $80hhG = parcelRequire("80hhG");

const $df25cdf8a2d7986f$var$UFOPRESS_EVENT = 'editor-config-panel-edit';
const $df25cdf8a2d7986f$export$b3c1b53ec616df30 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (editorActions)=>{
    const $ = (0, $frIzR.c)(8);
    const { setSelectedExtensionLocalId: setSelectedExtensionLocalId } = (0, $g3LxX.useExtensionsActions)();
    let t0;
    if ($[0] !== editorActions || $[1] !== setSelectedExtensionLocalId) {
        t0 = (localId)=>{
            if (!localId) return;
            const { attrs: attrs, type: type } = editorActions?.getNodeByLocalId(localId)?.toJSON() || {};
            const { extensionType: extensionType, extensionKey: extensionKey } = attrs || {};
            const editorView = editorActions._privateGetEditorView();
            const selection = editorView?.state?.selection;
            if (selection instanceof (0, $ks2lK.NodeSelection)) {
                if ((0, $80hhG.ALLOWED_EXTENSIONS).includes(extensionType)) {
                    (0, $4TXTZ.default)($df25cdf8a2d7986f$var$UFOPRESS_EVENT);
                    setSelectedExtensionLocalId(localId);
                }
            } else {
                if (type !== "multiBodiedExtension" || !editorView?.state) return;
                let multiBodiedExtensionPosition = editorView.state.selection.from;
                editorView.state.tr.doc.descendants((node, pos)=>{
                    if (node.attrs?.localId === localId) {
                        multiBodiedExtensionPosition = pos;
                        return;
                    }
                });
                editorView.dispatch(editorView.state.tr?.setSelection?.((0, $ks2lK.NodeSelection).create(editorView.state.tr.doc, multiBodiedExtensionPosition)));
                if ((0, $80hhG.ALLOWED_EXTENSIONS).includes(extensionType)) {
                    (0, $4TXTZ.default)($df25cdf8a2d7986f$var$UFOPRESS_EVENT);
                    setSelectedExtensionLocalId(localId);
                }
            }
            !!extensionKey && extensionType;
        };
        $[0] = editorActions;
        $[1] = setSelectedExtensionLocalId;
        $[2] = t0;
    } else t0 = $[2];
    const openConfigPanel = t0;
    let t1;
    if ($[3] !== setSelectedExtensionLocalId) {
        t1 = ()=>{
            setSelectedExtensionLocalId(null);
        };
        $[3] = setSelectedExtensionLocalId;
        $[4] = t1;
    } else t1 = $[4];
    const closeConfigPanel = t1;
    let t2;
    if ($[5] !== closeConfigPanel || $[6] !== openConfigPanel) {
        t2 = {
            openConfigPanel: openConfigPanel,
            closeConfigPanel: closeConfigPanel
        };
        $[5] = closeConfigPanel;
        $[6] = openConfigPanel;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (editorActions)=>{
    const { setSelectedExtensionLocalId: setSelectedExtensionLocalId } = (0, $g3LxX.useExtensionsActions)();
    const openConfigPanel = (0, $42omo.useCallback)((localId)=>{
        if (!localId) return;
        const { attrs: attrs, type: type } = editorActions?.getNodeByLocalId(localId)?.toJSON() || {};
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs || {};
        const editorView = editorActions._privateGetEditorView();
        const selection = editorView?.state?.selection;
        if (selection instanceof (0, $ks2lK.NodeSelection)) {
            if ((0, $80hhG.ALLOWED_EXTENSIONS).includes(extensionType)) {
                (0, $4TXTZ.default)($df25cdf8a2d7986f$var$UFOPRESS_EVENT);
                setSelectedExtensionLocalId(localId);
            }
        } else {
            if (type !== 'multiBodiedExtension' || !editorView?.state) return;
            // Handle MultiBodiedExtension config panel
            let multiBodiedExtensionPosition = editorView.state.selection.from;
            editorView.state.tr.doc.descendants((node, pos)=>{
                if (node.attrs?.localId === localId) {
                    multiBodiedExtensionPosition = pos;
                    return;
                }
            });
            editorView.dispatch(editorView.state.tr?.setSelection?.((0, $ks2lK.NodeSelection).create(editorView.state.tr.doc, multiBodiedExtensionPosition)));
            if ((0, $80hhG.ALLOWED_EXTENSIONS).includes(extensionType)) {
                (0, $4TXTZ.default)($df25cdf8a2d7986f$var$UFOPRESS_EVENT);
                setSelectedExtensionLocalId(localId);
            }
        }
        !!extensionKey && extensionType;
    }, [
        setSelectedExtensionLocalId,
        editorActions
    ]);
    const closeConfigPanel = (0, $42omo.useCallback)(()=>{
        setSelectedExtensionLocalId(null);
    }, [
        setSelectedExtensionLocalId
    ]);
    return (0, $42omo.useMemo)(()=>({
            openConfigPanel: openConfigPanel,
            closeConfigPanel: closeConfigPanel
        }), [
        openConfigPanel,
        closeConfigPanel
    ]);
};
module.exports["useHubEditorExtensionConfigPanel"] = $df25cdf8a2d7986f$export$b3c1b53ec616df30;

});

parcelRegister("bsZfq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $477dG = parcelRequire("477dG");


var $jhcFr = parcelRequire("jhcFr");

const $5b35bc9304135edf$export$2a89c15ccab17d33 = (0, $2XqLN.default)((product)=>{
    /**
   * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
   * (only supports Cloud single-issue URLs right now)
   */ const smartLinksBeforeMacros = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
    // Make smart links connect to staging when developing locally.
    const environment = undefined;
    const cardProvider = Promise.resolve(new (0, $477dG.EditorCardProvider)(environment, undefined, product));
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/pastePluginOptions.ts
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/cardPluginOptions.ts
    return {
        provider: cardProvider,
        resolveBeforeMacros: smartLinksBeforeMacros,
        allowBlockCards: true,
        allowEmbeds: true
    };
});
const $5b35bc9304135edf$export$5681a80d8b7b2bfb = (0, $4pOgL.isReactCompilerActivePlatform)() ? (product)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== product) {
        t0 = $5b35bc9304135edf$export$2a89c15ccab17d33(product);
        $[0] = product;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (product)=>{
    return (0, $42omo.useMemo)(()=>{
        return $5b35bc9304135edf$export$2a89c15ccab17d33(product);
    }, [
        product
    ]);
};
const $5b35bc9304135edf$export$535281304894bcdc = (0, $4pOgL.isReactCompilerActivePlatform)() ? (product, cardOptions)=>{
    const $ = (0, $frIzR.c)(3);
    const baseSmartLinks = $5b35bc9304135edf$export$5681a80d8b7b2bfb(product);
    let t0;
    if ($[0] !== baseSmartLinks || $[1] !== cardOptions) {
        t0 = {
            linking: {
                smartLinks: {
                    ...baseSmartLinks,
                    ...cardOptions
                }
            }
        };
        $[0] = baseSmartLinks;
        $[1] = cardOptions;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (product, cardOptions)=>{
    const baseSmartLinks = $5b35bc9304135edf$export$5681a80d8b7b2bfb(product);
    return (0, $42omo.useMemo)(()=>({
            linking: {
                smartLinks: {
                    ...baseSmartLinks,
                    ...cardOptions
                }
            }
        }), [
        baseSmartLinks,
        cardOptions
    ]);
};
const $5b35bc9304135edf$export$78db118acf87bd21 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (product, options, cloudId, linkPickerOptions)=>{
    const $ = (0, $frIzR.c)(15);
    const config = $5b35bc9304135edf$export$535281304894bcdc(product, options);
    let t0;
    if ($[0] !== cloudId || $[1] !== product) {
        t0 = {
            product: product,
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = product;
        $[2] = t0;
    } else t0 = $[2];
    const productConfig = t0;
    const linkPickerProps = (0, $jhcFr.useLinkPickerEditorProps)(undefined, productConfig);
    const linkPickerPlugins = linkPickerOptions?.linkPickerPlugins;
    const t1 = config.linking?.linkPicker;
    let t2;
    if ($[3] !== linkPickerPlugins) {
        t2 = linkPickerPlugins && {
            plugins: linkPickerPlugins
        };
        $[3] = linkPickerPlugins;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== linkPickerProps || $[6] !== t1 || $[7] !== t2) {
        t3 = {
            ...t1,
            ...linkPickerProps,
            ...t2
        };
        $[5] = linkPickerProps;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    const t4 = config.linking?.smartLinks;
    let t5;
    if ($[9] !== t4) {
        t5 = {
            ...t4
        };
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== config.linking || $[12] !== t3 || $[13] !== t5) {
        t6 = {
            linking: {
                ...config.linking,
                linkPicker: t3,
                smartLinks: t5
            }
        };
        $[11] = config.linking;
        $[12] = t3;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : (product, options, cloudId, linkPickerOptions)=>{
    const config = $5b35bc9304135edf$export$535281304894bcdc(product, options);
    const productConfig = (0, $42omo.useMemo)(()=>({
            product: product,
            cloudId: cloudId
        }), [
        product,
        cloudId
    ]);
    const linkPickerProps = (0, $jhcFr.useLinkPickerEditorProps)(undefined, productConfig);
    const linkPickerPlugins = linkPickerOptions?.linkPickerPlugins;
    return (0, $42omo.useMemo)(()=>({
            linking: {
                ...config.linking,
                linkPicker: {
                    ...config.linking?.linkPicker,
                    ...linkPickerProps,
                    ...linkPickerPlugins && {
                        plugins: linkPickerPlugins
                    }
                },
                smartLinks: {
                    ...config.linking?.smartLinks
                }
            }
        }), [
        config,
        linkPickerProps,
        linkPickerPlugins
    ]);
};
const $5b35bc9304135edf$export$9b0cf83b2bedfd63 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, options: options, cloudId: cloudId, product: t1, linkPickerOptions: linkPickerOptions } = t0;
    const product = t1 === undefined ? "CONFLUENCE" : t1;
    const mergedProps = $5b35bc9304135edf$export$78db118acf87bd21(product, options, cloudId, linkPickerOptions);
    let t2;
    if ($[0] !== children || $[1] !== mergedProps) {
        t2 = children(mergedProps);
        $[0] = children;
        $[1] = mergedProps;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children, options: options, cloudId: cloudId, product: product = 'CONFLUENCE', linkPickerOptions: linkPickerOptions })=>{
    const mergedProps = $5b35bc9304135edf$export$78db118acf87bd21(product, options, cloudId, linkPickerOptions);
    return children(mergedProps);
};
module.exports["EditorLinkingFeatures"] = $5b35bc9304135edf$export$9b0cf83b2bedfd63;

});

parcelRegister("fs87B", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $5d9b4 = parcelRequire("5d9b4");


var $ibzAc = parcelRequire("ibzAc");

const $7c7d6f28eb9ed9b2$var$BASE_URL = '/gateway/api/emoji';
const $7c7d6f28eb9ed9b2$var$getEmojiConfig = (cloudId, userId, disableUpload, emojiSSRConfig, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const providers = [
        {
            url: `${$7c7d6f28eb9ed9b2$var$BASE_URL}/standard`
        },
        {
            url: `${$7c7d6f28eb9ed9b2$var$BASE_URL}/atlassian`
        }
    ];
    if (cloudId) providers.push({
        url: `${$7c7d6f28eb9ed9b2$var$BASE_URL}/${cloudId}/site`
    });
    const config = {
        providers: providers,
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $7c7d6f28eb9ed9b2$var$resolverOfMemoize = (extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const disableUpload = extraConfig?.disableUpload ?? false;
    const emojiSSRConfigString = extraConfig?.emojiSSRConfig ? JSON.stringify(extraConfig.emojiSSRConfig) : '';
    return `${cloudId}_${userId}_${disableUpload}_${emojiSSRConfigString}`;
};
const $7c7d6f28eb9ed9b2$var$getEmojiResource = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const emojiConfig = $7c7d6f28eb9ed9b2$var$getEmojiConfig(cloudId, userId, disableUpload, emojiSSRConfig);
    return new (0, $ibzAc.default)(emojiConfig);
}, $7c7d6f28eb9ed9b2$var$resolverOfMemoize);
const $7c7d6f28eb9ed9b2$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((extraConfig)=>{
    const emojiResource = $7c7d6f28eb9ed9b2$var$getEmojiResource(extraConfig);
    return emojiResource.getEmojiProvider();
}, $7c7d6f28eb9ed9b2$var$resolverOfMemoize);
module.exports["getEmojiProvider"] = $7c7d6f28eb9ed9b2$export$8210f5f78c0bcf27;

});

parcelRegister("40t6Q", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cKAxI = parcelRequire("cKAxI");


var $g6QUH = parcelRequire("g6QUH");


var $4cOi8 = parcelRequire("4cOi8");

var $8wrz6 = parcelRequire("8wrz6");


var $litlC = parcelRequire("litlC");


var $rsHkn = parcelRequire("rsHkn");


var $aYtOO = parcelRequire("aYtOO");


var $2QkXB = parcelRequire("2QkXB");


var $2baLD = parcelRequire("2baLD");


var $5zHV6 = parcelRequire("5zHV6");

const $5e59c19caa0b430a$export$c7edf67c9c07ecac = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(11);
    const { contentId: contentId, intl: intl, PropsProvider: PropsProvider, editorActions: editorActions, openConfigPanel: openConfigPanel } = props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [extensionProviders, setExtensionProviders] = (0, $42omo.useState)(t0);
    const theming = (0, $litlC.useHubTheming)();
    const palette = theming?.isAdvancedThemingEnabled ? theming.palette : undefined;
    let t1;
    if ($[1] !== PropsProvider || $[2] !== contentId || $[3] !== editorActions || $[4] !== intl || $[5] !== openConfigPanel || $[6] !== palette) {
        t1 = async ()=>{
            const hubExtensionProviders = [];
            const defaultExtensionProviderProps = {
                contentId: contentId,
                propsProvider: PropsProvider,
                mode: (0, $4cOi8.ExtensionMode).EDITOR,
                defaultParameters: (0, $8wrz6.getHubDefaultParameters)({
                    palette: palette
                })
            };
            const defaultExtensionInstanceProps = {
                editorActions: editorActions,
                openConfigPanel: openConfigPanel,
                intl: intl,
                contentId: contentId
            };
            try {
                const DEFAULT_EXTENSION_PROVIDERS = [
                    (0, $2baLD.spotlightExtensionProvider),
                    (0, $aYtOO.linksMenuExtensionProvider),
                    (0, $cKAxI.cardsExtensionProvider),
                    (0, $g6QUH.carouselExtensionProvider)
                ];
                DEFAULT_EXTENSION_PROVIDERS.forEach(async (extensionProvider)=>{
                    const providerInstance = await extensionProvider(defaultExtensionProviderProps);
                    const provider = await providerInstance(defaultExtensionInstanceProps);
                    hubExtensionProviders.push(provider);
                });
                const sectionExtProviderInstance = await (0, $2QkXB.sectionExtensionProvider)({
                    ...defaultExtensionProviderProps,
                    defaultParameters: (0, $8wrz6.getHubDefaultParameters)({
                        palette: palette,
                        element: "section"
                    }),
                    getSectionExtensionContents: $5zHV6.getSectionExtensionContents
                });
                const sectionExtProvider = await sectionExtProviderInstance(defaultExtensionInstanceProps);
                hubExtensionProviders.push(sectionExtProvider);
                const hubElementPlaceholderExtensionProviderInstance = await (0, $rsHkn.hubElementPlaceholderExtensionProvider)(defaultExtensionInstanceProps);
                hubExtensionProviders.push(hubElementPlaceholderExtensionProviderInstance);
                setExtensionProviders(hubExtensionProviders);
            } catch (t2) {
                const error = t2;
            }
        };
        $[1] = PropsProvider;
        $[2] = contentId;
        $[3] = editorActions;
        $[4] = intl;
        $[5] = openConfigPanel;
        $[6] = palette;
        $[7] = t1;
    } else t1 = $[7];
    const loadProviders = t1;
    let t2;
    let t3;
    if ($[8] !== loadProviders) {
        t2 = ()=>{
            loadProviders();
        };
        t3 = [
            loadProviders
        ];
        $[8] = loadProviders;
        $[9] = t2;
        $[10] = t3;
    } else {
        t2 = $[9];
        t3 = $[10];
    }
    (0, $42omo.useEffect)(t2, t3);
    return extensionProviders;
} : (props)=>{
    const { contentId: contentId, intl: intl, PropsProvider: PropsProvider, editorActions: editorActions, openConfigPanel: openConfigPanel } = props;
    const [extensionProviders, setExtensionProviders] = (0, $42omo.useState)([]);
    // When advanced theming is enabled, seed new extension instances with
    // palette-backed default colors (e.g. var(--hub-color-primary-200)). Falls
    // back to legacy single-color defaults when the framework isn't mounted.
    const theming = (0, $litlC.useHubTheming)();
    const palette = theming?.isAdvancedThemingEnabled ? theming.palette : undefined;
    const loadProviders = (0, $42omo.useCallback)(async ()=>{
        const hubExtensionProviders = [];
        const defaultExtensionProviderProps = {
            contentId: contentId,
            propsProvider: PropsProvider,
            mode: (0, $4cOi8.ExtensionMode).EDITOR,
            defaultParameters: (0, $8wrz6.getHubDefaultParameters)({
                palette: palette
            })
        };
        const defaultExtensionInstanceProps = {
            editorActions: editorActions,
            openConfigPanel: openConfigPanel,
            intl: intl,
            contentId: contentId
        };
        try {
            const DEFAULT_EXTENSION_PROVIDERS = [
                (0, $2baLD.spotlightExtensionProvider),
                (0, $aYtOO.linksMenuExtensionProvider),
                (0, $cKAxI.cardsExtensionProvider),
                (0, $g6QUH.carouselExtensionProvider)
            ];
            DEFAULT_EXTENSION_PROVIDERS.forEach(async (extensionProvider)=>{
                const providerInstance = await extensionProvider(defaultExtensionProviderProps);
                const provider = await providerInstance(defaultExtensionInstanceProps);
                hubExtensionProviders.push(provider);
            });
            // section provider — uses the section-specific bg shade (accent.100)
            // when advanced theming is on; otherwise inherits the generic seed.
            const sectionExtProviderInstance = await (0, $2QkXB.sectionExtensionProvider)({
                ...defaultExtensionProviderProps,
                defaultParameters: (0, $8wrz6.getHubDefaultParameters)({
                    palette: palette,
                    element: 'section'
                }),
                getSectionExtensionContents: $5zHV6.getSectionExtensionContents
            });
            const sectionExtProvider = await sectionExtProviderInstance(defaultExtensionInstanceProps);
            hubExtensionProviders.push(sectionExtProvider);
            const hubElementPlaceholderExtensionProviderInstance = await (0, $rsHkn.hubElementPlaceholderExtensionProvider)(defaultExtensionInstanceProps);
            hubExtensionProviders.push(hubElementPlaceholderExtensionProviderInstance);
            setExtensionProviders(hubExtensionProviders);
        } catch (error) {
        // todo: log error to analytics
        }
    }, [
        editorActions,
        openConfigPanel,
        intl,
        PropsProvider,
        contentId,
        palette
    ]);
    (0, $42omo.useEffect)(()=>{
        loadProviders();
    }, [
        loadProviders
    ]);
    return extensionProviders;
};
module.exports["useHubExtensionProviders"] = $5e59c19caa0b430a$export$c7edf67c9c07ecac;

});

parcelRegister("55iAf", function(module, exports) {
const $9b887f242ff81a3d$export$c5dfd3b79761d51f = {
    allowDatasource: true
};
const $9b887f242ff81a3d$export$71250061dd993259 = true;
module.exports["LINKING_FEATURES_CARD_OPTIONS"] = $9b887f242ff81a3d$export$c5dfd3b79761d51f;
module.exports["IS_UPLOAD_MEDIA_CONFIG_REQUIRED"] = $9b887f242ff81a3d$export$71250061dd993259;

});

parcelRegister("8nA5C", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $akLj5 = parcelRequire("akLj5");

function $6efdd0a20b4dcd75$export$3f6a2f4541d2f102(props) {
    const { intl: intl, mediaOptions: mediaOptions, linkPickerOptions: linkPickerOptions, featureFlags: featureFlags } = props;
    const __livePage = false;
    // const editorPluginAIOptions = createPageEditorPluginAIOptions({
    // 	product,
    // 	aiGlobalOptIn: { status: 'disabled', triggerOptInFlow: () => { } },
    // 	PromptEditor: createPromptEditor({
    // 		enableLinks: false,
    // 		linking: {
    // 			smartLinks: { provider: undefined },
    // 		},
    // 		mentionProvider: undefined,
    // 		featureFlags: {},
    // 	}),
    // 	isRovoEnabled: false,
    // });
    return (0, $akLj5.hubPreset)({
        intl: intl,
        pluginOptions: {
            base: {
                __livePage: __livePage
            },
            helpDialog: {
                imageUploadProviderExists: Boolean(mediaOptions?.provider),
                aiEnabled: false
            },
            hyperlink: {
                linkPicker: {
                    plugins: linkPickerOptions?.linkPickerPlugins || []
                },
                onClickCallback: undefined
            },
            quickInsert: {
                emptyStateHandler: undefined,
                quickInsert: props.quickInsert
            },
            placeholder: {
                viewMode: props.viewMode,
                isAIEnabled: false
            },
            selection: {
                __livePage: __livePage
            },
            editorDisabled: {
                disabled: undefined
            },
            annotation: {
                annotationManager: undefined,
                createCommentExperience: undefined,
                selectCommentExperience: undefined,
                viewInlineCommentTraceUFOPress: undefined
            },
            tasksAndDecisions: {
                hasEditPermission: props.hasEditPermission,
                requestToEditContent: undefined,
                hasRequestedEditPermission: undefined
            },
            contextPanel: props.contextPanelOptions ? {
                objectSideBar: props.contextPanelOptions.objectSideBar
            } : undefined,
            extension: {
                extensionHandlers: props.extensionHandlers,
                __rendererExtensionOptions: props.__rendererExtensionOptions,
                getExtensionHeight: props.getExtensionHeight
            },
            card: {
                __livePage: __livePage,
                linkPicker: props.linking?.linkPicker,
                onClickCallback: props.linking?.smartLinks?.onClickCallback
            },
            avatarGroup: {
                collabEdit: undefined
            },
            // ai: editorPluginAIOptions,
            loom: {
                renderButton: ()=>null
            },
            editorViewMode: {
                viewMode: props.viewMode
            },
            // aiDefinitions: props.editorPluginAIDefinitionsConfig,
            selectionMarker: {
                __livePage: __livePage
            },
            engagementPlatform: {
                coordinationClient: {
                    start: ()=>Promise.resolve(false),
                    stop: ()=>Promise.resolve(false)
                }
            },
            selectionExtension: {},
            metrics: {},
            primaryToolbar: {
                contextualFormattingEnabled: true
            },
            selectionToolbar: {
                contextualFormattingEnabled: true
            }
        },
        providers: {
            userPreferencesProvider: props.userPreferencesProvider,
            userPreferencesProviderNext: props.userPreferencesProviderNext,
            cardProvider: props.linking?.smartLinks?.provider,
            contextIdentifierProvider: props.contextIdentifierProvider,
            inlineCommentAnnotationProvider: props.annotationProviders?.inlineComment,
            mediaProvider: mediaOptions?.provider,
            syncMediaProvider: props.media?.syncProvider,
            mentionProvider: props.mentionProvider,
            profilecardProvider: props.mention?.profilecardProvider,
            emojiProvider: props.emojiProvider,
            autoformattingProvider: props.autoformattingProvider,
            taskDecisionProvider: props.taskDecisionProvider
        },
        enabledOptionalPlugins: {
            toolbar: true,
            findReplace: Boolean(props.allowFindReplace),
            loom: props.isLoomPluginEnabled,
            aiDefinitions: props.editorPluginAIDefinitionsEnabled,
            connectivity: props.isDesktop || !(0, $1oCLl.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true),
            metrics: (0, $dh538.fg)('platform_editor_ease_of_use_metrics'),
            codeBlockAdvanced: true,
            selectionExtension: (0, $1oCLl.expValEquals)('platform_editor_controls', 'cohort', 'variant1'),
            // aiExperience: Boolean(props.editorPluginAIOptions?.aiGlobalOptIn?.status !== 'disabled'),
            interaction: (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
            userPreferences: (0, $dh538.fg)('platform_editor_use_preferences_plugin'),
            companyHubTextColor: props.editorPluginHubTextColorEnabled ?? false,
            // This plugin provides support for showing an indicator when we drag and drop components from components panel
            hubExternalInsert: featureFlags?.hub_editor_floating_toolbar ?? false
        }
    });
}
module.exports["createHubEditorPreset"] = $6efdd0a20b4dcd75$export$3f6a2f4541d2f102;

});

parcelRegister("iIQ1o", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gqsO5 = parcelRequire("gqsO5");


var $55iAf = parcelRequire("55iAf");

const $65ae352143522577$export$74fedad14355d824 = ({ contentId: contentId, editorAPI: editorAPI, customMediaProvider: customMediaProvider, mediaConfig: mediaConfig })=>{
    const resolver = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        const createMediaProvider = ()=>{
            return (0, $gqsO5.getMediaProvider)(mediaConfig?.mediaCollectionName ?? '', mediaConfig?.asapIssuer ?? '', mediaConfig?.mediaToken ?? '', mediaConfig?.mediaUrl ?? '', (0, $55iAf.IS_UPLOAD_MEDIA_CONFIG_REQUIRED));
        };
        const mediaProvider = createMediaProvider();
        if (mediaProvider) {
            if (editorAPI?.media?.actions) editorAPI.media.actions.setProvider(Promise.resolve(mediaProvider));
            if (resolver.current) resolver.current(mediaProvider);
        }
    }, [
        contentId,
        mediaConfig,
        editorAPI
    ]);
    return (0, $42omo.useMemo)(()=>{
        const provider = customMediaProvider ?? new Promise((resolve)=>{
            resolver.current = resolve;
        });
        return {
            provider: provider,
            allowMediaSingle: true,
            allowMediaGroup: true,
            allowResizing: true,
            allowLinking: true,
            allowResizingInTables: true,
            allowAltTextOnImages: true,
            allowMediaSingleEditable: true,
            allowRemoteDimensionsFetch: true,
            allowCaptions: true,
            allowLazyLoading: true,
            allowAdvancedToolBarOptions: true,
            allowDropzoneDropLine: true,
            allowTemplatePlaceholders: true,
            featureFlags: {}
        };
    }, [
        customMediaProvider
    ]);
};
module.exports["useMediaOptions"] = $65ae352143522577$export$74fedad14355d824;

});

parcelRegister("fMq01", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9acc7bbf03b4f2ec$var$_default_1 = (0, $aXWIB.defineMessages)({
    hubStudioLoadingSpinnerLabel: {
        id: "hub-editor.loading-spinner-label",
        defaultMessage: "Loading hub"
    }
});
var $9acc7bbf03b4f2ec$export$2e2bcd8739ae039 = $9acc7bbf03b4f2ec$var$_default_1;
module.exports["default"] = $9acc7bbf03b4f2ec$export$2e2bcd8739ae039;

});

parcelRegister("77j7A", function(module, exports) {
const $52e804f8f8bf6a09$export$881d135f98d8d7d0 = 100;
const $52e804f8f8bf6a09$export$9ab5bdcb8a1d6c34 = false;
const $52e804f8f8bf6a09$export$12c1dc38ea1692da = 0;
module.exports["DEFAULT_CACHE_MAX_LIMIT"] = $52e804f8f8bf6a09$export$881d135f98d8d7d0;
module.exports["DEFAULT_RESOURCE_BROWSER_ONLY"] = $52e804f8f8bf6a09$export$9ab5bdcb8a1d6c34;
module.exports["DEFAULT_RESOURCE_MAX_AGE"] = $52e804f8f8bf6a09$export$12c1dc38ea1692da;

});

parcelRegister("80hhG", function(module, exports) {

var $kcoxM = parcelRequire("kcoxM");


var $5Ac5G = parcelRequire("5Ac5G");


var $cNwLI = parcelRequire("cNwLI");


var $lf1vG = parcelRequire("lf1vG");


var $bl1ay = parcelRequire("bl1ay");


var $ab2CU = parcelRequire("ab2CU");


var $cVaAA = parcelRequire("cVaAA");


var $3cMhk = parcelRequire("3cMhk");

const $38f295c1ec230ae3$export$fe220054b070cbc4 = [
    (0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
    (0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE),
    (0, $kcoxM.CARDS_EXTENSION_TYPE),
    (0, $cVaAA.LINKS_MENU_EXTENSION_TYPE),
    (0, $cNwLI.SECTION_EXTENSION_TYPE),
    (0, $lf1vG.SEARCH_EXTENSION_TYPE),
    (0, $5Ac5G.carouselExtensionType),
    (0, $cNwLI.RESOURCE_TILES_EXTENSION_TYPE),
    (0, $3cMhk.CALLOUT_BANNER_EXTENSION_TYPE),
    (0, $ab2CU.JSM_HELP_EXTENSION_TYPE)
];
module.exports["ALLOWED_EXTENSIONS"] = $38f295c1ec230ae3$export$fe220054b070cbc4;

});

parcelRegister("akLj5", function(module, exports) {

var $bupcf = parcelRequire("bupcf");


var $3ihIB = parcelRequire("3ihIB");


var $hr8mu = parcelRequire("hr8mu");


var $jmHSv = parcelRequire("jmHSv");


var $cpn0f = parcelRequire("cpn0f");


var $PJ00O = parcelRequire("PJ00O");


var $fi7Vj = parcelRequire("fi7Vj");


var $fPXRH = parcelRequire("fPXRH");


var $55skd = parcelRequire("55skd");


var $2E0F0 = parcelRequire("2E0F0");


var $khxQ7 = parcelRequire("khxQ7");


var $hSJYu = parcelRequire("hSJYu");


var $cwPVT = parcelRequire("cwPVT");


var $duFi2 = parcelRequire("duFi2");


var $agrUc = parcelRequire("agrUc");


var $kXH7i = parcelRequire("kXH7i");


var $acwPl = parcelRequire("acwPl");


var $01uqX = parcelRequire("01uqX");


var $7rj2U = parcelRequire("7rj2U");


var $jgFdO = parcelRequire("jgFdO");


var $gyXPd = parcelRequire("gyXPd");


var $5y9PZ = parcelRequire("5y9PZ");


var $2yr9J = parcelRequire("2yr9J");


var $kbe7k = parcelRequire("kbe7k");


var $1nZXu = parcelRequire("1nZXu");


var $kIhx9 = parcelRequire("kIhx9");


var $bS1lJ = parcelRequire("bS1lJ");


var $2nH2Y = parcelRequire("2nH2Y");


var $4iQt6 = parcelRequire("4iQt6");


var $4KTOl = parcelRequire("4KTOl");


var $lgjGE = parcelRequire("lgjGE");


var $3mcWz = parcelRequire("3mcWz");


var $hcboS = parcelRequire("hcboS");


var $8ABVP = parcelRequire("8ABVP");


var $fTvEN = parcelRequire("fTvEN");


var $eyggb = parcelRequire("eyggb");


var $l7rln = parcelRequire("l7rln");


var $dtCIm = parcelRequire("dtCIm");


var $7sK9h = parcelRequire("7sK9h");


var $jS0a0 = parcelRequire("jS0a0");


var $6q6xk = parcelRequire("6q6xk");


var $fYKTL = parcelRequire("fYKTL");


var $fCLXZ = parcelRequire("fCLXZ");


var $flknw = parcelRequire("flknw");


var $cu2RD = parcelRequire("cu2RD");


var $HYzBP = parcelRequire("HYzBP");


var $gATpw = parcelRequire("gATpw");


var $aUwPP = parcelRequire("aUwPP");


var $cVhn8 = parcelRequire("cVhn8");


var $6AqNX = parcelRequire("6AqNX");


var $05jmd = parcelRequire("05jmd");


var $5HHoF = parcelRequire("5HHoF");


var $80JwR = parcelRequire("80JwR");


var $cWFvG = parcelRequire("cWFvG");


var $2U68K = parcelRequire("2U68K");


var $dH9DB = parcelRequire("dH9DB");


var $b3BjA = parcelRequire("b3BjA");


var $36iDo = parcelRequire("36iDo");


var $59fTa = parcelRequire("59fTa");


var $kYgUn = parcelRequire("kYgUn");


var $8HLyI = parcelRequire("8HLyI");


var $itirX = parcelRequire("itirX");


var $e6sdP = parcelRequire("e6sdP");


var $5DsxN = parcelRequire("5DsxN");


var $1GAIu = parcelRequire("1GAIu");


var $bULcr = parcelRequire("bULcr");


var $4NiQW = parcelRequire("4NiQW");


var $5Qu3R = parcelRequire("5Qu3R");


var $7nKrc = parcelRequire("7nKrc");


var $c8680 = parcelRequire("c8680");


var $6borH = parcelRequire("6borH");


var $eeGWn = parcelRequire("eeGWn");


var $jaskt = parcelRequire("jaskt");


var $i2zv0 = parcelRequire("i2zv0");


var $5mDFx = parcelRequire("5mDFx");


var $3JBsx = parcelRequire("3JBsx");


var $1KHo7 = parcelRequire("1KHo7");


var $fMaLE = parcelRequire("fMaLE");


var $bz4KD = parcelRequire("bz4KD");


var $kw2eg = parcelRequire("kw2eg");


var $vxKdN = parcelRequire("vxKdN");


var $3O0YV = parcelRequire("3O0YV");


var $hEicH = parcelRequire("hEicH");


var $fI6T7 = parcelRequire("fI6T7");


var $dh538 = parcelRequire("dh538");


var $1ewUw = parcelRequire("1ewUw");


var $01IzD = parcelRequire("01IzD");


var $flOSQ = parcelRequire("flOSQ");


var $1xIUY = parcelRequire("1xIUY");


var $4MVLq = parcelRequire("4MVLq");


var $fWkcL = parcelRequire("fWkcL");


var $iWSPQ = parcelRequire("iWSPQ");


var $4y9Kz = parcelRequire("4y9Kz");


var $cHFKB = parcelRequire("cHFKB");


var $eRg9X = parcelRequire("eRg9X");


var $1sSwB = parcelRequire("1sSwB");


var $aJHVS = parcelRequire("aJHVS");


var $9tRxr = parcelRequire("9tRxr");


var $i2djY = parcelRequire("i2djY");


var $jQ06G = parcelRequire("jQ06G");


var $5Dd7d = parcelRequire("5Dd7d");


var $bVUSv = parcelRequire("bVUSv");


var $b4WWq = parcelRequire("b4WWq");


var $78pY6 = parcelRequire("78pY6");


var $4REcT = parcelRequire("4REcT");


var $dxCwJ = parcelRequire("dxCwJ");


var $86sOu = parcelRequire("86sOu");


var $kzRVg = parcelRequire("kzRVg");


var $8J4Ig = parcelRequire("8J4Ig");


var $h5EPM = parcelRequire("h5EPM");


var $71mY6 = parcelRequire("71mY6");


var $f3DGR = parcelRequire("f3DGR");


var $aKz7i = parcelRequire("aKz7i");


var $gzLIB = parcelRequire("gzLIB");


var $dhSx4 = parcelRequire("dhSx4");


var $7IWcn = parcelRequire("7IWcn");


var $k2N06 = parcelRequire("k2N06");


var $6Hz7H = parcelRequire("6Hz7H");


var $a05p6 = parcelRequire("a05p6");


var $kM0Zd = parcelRequire("kM0Zd");


var $fgDQY = parcelRequire("fgDQY");


var $2MD6X = parcelRequire("2MD6X");


var $9go3B = parcelRequire("9go3B");


var $c9cMu = parcelRequire("c9cMu");


var $iKcD8 = parcelRequire("iKcD8");


var $jWhwv = parcelRequire("jWhwv");


var $3Xrfi = parcelRequire("3Xrfi");


var $hjUys = parcelRequire("hjUys");


var $8fkUp = parcelRequire("8fkUp");


var $1gKzC = parcelRequire("1gKzC");


var $1yQ82 = parcelRequire("1yQ82");


var $2tLa9 = parcelRequire("2tLa9");


var $9NORi = parcelRequire("9NORi");


var $dfnwW = parcelRequire("dfnwW");


var $2brVr = parcelRequire("2brVr");


var $1tg3R = parcelRequire("1tg3R");


var $19tf6 = parcelRequire("19tf6");


var $7BhUY = parcelRequire("7BhUY");

function $79b8bfc371482db1$export$b21c20e4234a3291(props) {
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the HubPresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    return new (0, $bupcf.EditorPresetBuilder)().add([
        (0, $l7rln.featureFlagsPlugin),
        (0, $h5EPM.featureFlagsPluginOptions)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $jmHSv.analyticsPlugin),
        (0, $fWkcL.analyticsPluginOptions)({
            options: pluginOptions.analytics
        })
    ]).add((0, $55skd.betterTypeHistoryPlugin)).add([
        (0, $36iDo.pastePlugin),
        (0, $fgDQY.pastePluginOptions)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $acwPl.default)).add((0, $jS0a0.focusPlugin)).add((0, $gyXPd.compositionPlugin)).add([
        (0, $kbe7k.contextIdentifierPlugin),
        (0, $jQ06G.contextIdentifierPluginOptions)({
            options: pluginOptions.contextIdentifier,
            providers: providers
        })
    ]).add([
        (0, $fi7Vj.default),
        (0, $cHFKB.basePluginOptions)({
            options: pluginOptions.base
        })
    ]).maybeAdd([
        (0, $hEicH.userPreferencesPlugin),
        (0, $7BhUY.userPreferencesPluginOptions)({
            providers: providers
        })
    ], Boolean(enabledOptionalPlugins.interaction) && (0, $dh538.fg)('platform_editor_use_preferences_plugin')).add((0, $4KTOl.decorationsPlugin)).add([
        (0, $fMaLE.typeAheadPlugin),
        (0, $19tf6.typeAheadPluginOptions)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $HYzBP.default)).maybeAdd([
        (0, $3JBsx.toolbarPlugin),
        {
            contextualFormattingEnabled: 'always-inline'
        }
    ], Boolean(enabledOptionalPlugins.toolbar)).add([
        (0, $itirX.primaryToolbarPlugin),
        (0, $c9cMu.primaryToolbarPluginOptions)({
            options: pluginOptions.primaryToolbar
        })
    ]).add((0, $kw2eg.undoRedoPlugin)).add([
        (0, $khxQ7.blockTypePlugin),
        (0, $eRg9X.blockTypePluginOptions)({
            options: pluginOptions.blockType
        })
    ]).add((0, $kXH7i.clearMarksOnEmptyDocPlugin)).add([
        (0, $7nKrc.selectionToolbarPlugin),
        (0, $8fkUp.selectionToolbarPluginOptions)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ]).add([
        (0, $gATpw.hyperlinkPlugin),
        (0, $gzLIB.hyperlinkPluginOptions)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $5mDFx.textFormattingPlugin),
        (0, $2brVr.textFormattingPluginOptions)({
            options: pluginOptions.textFormatting
        })
    ]).add((0, $fI6T7.widthPlugin)).add([
        (0, $e6sdP.quickInsertPlugin),
        (0, $iKcD8.quickInsertPluginOptions)({
            options: pluginOptions.quickInsert
        })
    ]).add([
        (0, $kYgUn.placeholderPlugin),
        (0, $2MD6X.placeholderPluginOptions)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $vxKdN.unsupportedContentPlugin)).add([
        (0, $lgjGE.editorDisabledPlugin),
        (0, $78pY6.editorDisabledPluginOptions)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $6borH.submitEditorPlugin),
        (0, $1yQ82.submitEditorPluginOptions)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $kIhx9.copyButtonPlugin)).add((0, $7sK9h.floatingToolbarPlugin)).maybeAdd((0, $6AqNX.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $bULcr.selectionPlugin),
        (0, $hjUys.selectionPluginOptions)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $7rj2U.default),
        (0, $i2djY.codeBlockPluginOptions)({
            options: pluginOptions.codeBlock
        })
    ]).add((0, $bz4KD.ufoPlugin)).add((0, $2nH2Y.dataConsumerPlugin)).add((0, $3ihIB.accessibilityUtilsPlugin)).add((0, $2yr9J.contentInsertionPlugin)).add((0, $fPXRH.batchAttributeUpdatesPlugin)).add([
        (0, $cwPVT.breakoutPlugin),
        (0, $1sSwB.breakoutPluginOptions)()
    ]).add((0, $hr8mu.alignmentPlugin)).add([
        (0, $i2zv0.textColorPlugin),
        (0, $dfnwW.textColorPluginOptions)({
            options: pluginOptions.textColor,
            // remove the textColorPlugin only when companyHubTextColor plugin is enabled
            isPluginEnabled: !Boolean(enabledOptionalPlugins.companyHubTextColor)
        })
    ]).maybeAdd((0, $01IzD.companyHubTextColorPlugin), Boolean(enabledOptionalPlugins.companyHubTextColor)).add((0, $5HHoF.listPlugin)).add((0, $5DsxN.rulePlugin)).add([
        (0, $fTvEN.expandPlugin),
        (0, $kzRVg.expandPluginOptions)()
    ]).add((0, $fCLXZ.guidelinePlugin)).add([
        (0, $fYKTL.gridPlugin),
        (0, $f3DGR.gridPluginOptions)({
            options: pluginOptions.grid
        })
    ]).add([
        (0, $cpn0f.annotationPlugin),
        (0, $iWSPQ.annotationPluginOptions)({
            options: pluginOptions.annotation,
            providers: providers
        })
    ]).add([
        (0, $cWFvG.mediaPlugin),
        (0, $6Hz7H.mediaPluginOptions)({
            intl: intl,
            providers: providers
        })
    ]).add((0, $2U68K.mediaInsertPlugin)).add((0, $duFi2.default)).add([
        (0, $hcboS.emojiPlugin),
        (0, $dxCwJ.emojiPluginOptions)({
            options: pluginOptions.emoji,
            providers: providers
        })
    ]).add([
        (0, $eeGWn.default),
        (0, $2tLa9.tablePluginOptions)()
    ]).add([
        (0, $jaskt.tasksAndDecisionsPlugin),
        (0, $9NORi.tasksAndDecisionsPluginOptions)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $flknw.helpDialogPlugin),
        (0, $aKz7i.helpDialogPluginOptions)({
            options: {
                imageUploadProviderExists: false,
                // aiEnabled: enabledOptionalPlugins.aiExperience,
                aiEnabled: false
            }
        })
    ]).add([
        (0, $b3BjA.default),
        (0, $kM0Zd.panelPluginOptions)({
            options: pluginOptions.panel
        })
    ]).add([
        (0, $1nZXu.contextPanelPlugin),
        (0, $5Dd7d.contextPanelPluginOptions)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $eyggb.extensionPlugin),
        (0, $8J4Ig.extensionPluginOptions)({
            options: pluginOptions.extension
        })
    ]).add([
        (0, $4iQt6.default),
        (0, $b4WWq.datePluginOptions)({
            options: pluginOptions.date
        })
    ]).add([
        (0, $8HLyI.default),
        (0, $9go3B.placeholderTextPluginOptions)({
            options: pluginOptions.placeholderText
        })
    ]).add([
        (0, $05jmd.layoutPlugin),
        (0, $7IWcn.layoutPluginOptions)()
    ]).add([
        (0, $agrUc.cardPlugin),
        (0, $aJHVS.cardPluginOptions)({
            options: pluginOptions.card,
            providers: providers
        })
    ]).add([
        (0, $bS1lJ.customAutoformatPlugin),
        (0, $bVUSv.customAutoformatPluginOptions)({
            options: pluginOptions.customAutoformat,
            providers: providers
        })
    ]).add([
        (0, $c8680.statusPlugin),
        (0, $1gKzC.statusPluginOptions)({
            options: pluginOptions.status
        })
    ]).add((0, $aUwPP.indentationPlugin)).add((0, $1GAIu.scrollIntoViewPlugin)).add([
        (0, $1KHo7.toolbarListsIndentationPlugin),
        (0, $1tg3R.toolbarListsIndentationPluginOptions)({
            options: pluginOptions.toolbarListsIndentation
        })
    ]).add([
        (0, $cVhn8.insertBlockPlugin),
        (0, $dhSx4.insertBlockPluginOptions)()
    ]).add([
        (0, $PJ00O.avatarGroupPlugin),
        (0, $4y9Kz.avatarGroupPluginOptions)({
            options: pluginOptions.avatarGroup
        })
    ]).maybeAdd([
        (0, $dtCIm.findReplacePlugin),
        (0, $71mY6.findReplacePluginOptions)({
            options: pluginOptions.findReplace
        })
    ], enabledOptionalPlugins.findReplace).add((0, $hSJYu.borderPlugin)).add((0, $6q6xk.fragmentPlugin)).add((0, $59fTa.pasteOptionsToolbarPlugin)).add([
        (0, $01uqX.codeBidiWarningPlugin),
        (0, $9tRxr.codeBidiWarningPluginOptions)()
    ])// .maybeAdd(
    // 	[aiPlugin, aiPluginOptions({ options: pluginOptions.ai })],
    // 	enabledOptionalPlugins.aiExperience,
    // )
    .maybeAdd([
        (0, $80JwR.loomPlugin),
        (0, $k2N06.loomPluginOptions)({
            options: pluginOptions.loom
        })
    ], enabledOptionalPlugins.loom).add([
        (0, $3mcWz.editorViewModePlugin),
        (0, $4REcT.editorViewModePluginOptions)({
            options: pluginOptions.editorViewMode
        })
    ])// aiDefinitionsPlugin depends on editorViewModePlugin
    .maybeAdd([
        (0, $1ewUw.aiDefinitionsPlugin),
        (0, $4MVLq.aiDefinitionsPluginOptions)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions).add([
        (0, $5Qu3R.selectionMarkerPlugin),
        (0, $3Xrfi.selectionMarkerPluginOptions)({
            options: pluginOptions.selectionMarker
        })
    ]).add((0, $2E0F0.blockControlsPlugin)).add((0, $cu2RD.highlightPlugin)).add([
        (0, $8ABVP.engagementPlatformPlugin),
        (0, $86sOu.engagementPlatformPluginOptions)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd((0, $5y9PZ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd([
        (0, $dH9DB.metricsPlugin),
        (0, $a05p6.metricsPluginOptions)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).maybeAdd((0, $jgFdO.codeBlockAdvancedPlugin), enabledOptionalPlugins.codeBlockAdvanced).maybeAdd([
        (0, $4NiQW.selectionExtensionPlugin),
        (0, $jWhwv.selectionExtensionPluginOptions)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).maybeAdd((0, $flOSQ.hubExternalInsertPlugin), enabledOptionalPlugins.hubExternalInsert).add((0, $1xIUY.hubShellPlugin)).add((0, $3O0YV.userIntentPlugin));
}
module.exports["hubPreset"] = $79b8bfc371482db1$export$b21c20e4234a3291;

});

parcelRegister("01IzD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9GzMM = parcelRequire("9GzMM");


var $UUFGH = parcelRequire("UUFGH");


var $1PWfQ = parcelRequire("1PWfQ");


var $9F27L = parcelRequire("9F27L");


var $digS9 = parcelRequire("digS9");

const $92236b2f38adfd2f$var$pluginConfig = (textColorConfig)=>{
    if (!textColorConfig || typeof textColorConfig === 'boolean') return undefined;
    return textColorConfig;
};
const $92236b2f38adfd2f$export$164d98bc1a6b118 = ({ config: textColorConfig, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9F27L.PrimaryToolbarComponent), {
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            disabled: disabled,
            api: api
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $digS9.getToolbarComponents)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'textColor',
        component: primaryToolbarComponent
    });
    return {
        name: 'companyHubTextColor',
        marks () {
            return [
                {
                    name: 'companyHubTextColor',
                    mark: (0, $9GzMM.textColor)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'companyHubTextColor',
                    plugin: ({ dispatch: dispatch })=>(0, $1PWfQ.createPlugin)(dispatch, $92236b2f38adfd2f$var$pluginConfig(textColorConfig))
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $1PWfQ.pluginKey).getState(editorState);
        },
        actions: {
            changeColor: (color)=>{
                return (0, $UUFGH.changeColor)(color, api?.analytics?.actions);
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["companyHubTextColorPlugin"] = $92236b2f38adfd2f$export$164d98bc1a6b118;

});

parcelRegister("flOSQ", function(module, exports) {

var $6FVCy = parcelRequire("6FVCy");

const $4655949c8108f145$export$ff4d2b674c5a359b = ({ api: api })=>({
        name: 'hubExternalInsert',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $6FVCy.key).getState(editorState);
            return pluginState ? {
                dropTargetPos: pluginState.dropTargetPos
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'hubExternalInsert',
                    plugin: ({ nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $6FVCy.createPlugin)(api, nodeViewPortalProviderAPI);
                    }
                }
            ];
        }
    });
module.exports["hubExternalInsertPlugin"] = $4655949c8108f145$export$ff4d2b674c5a359b;

});

parcelRegister("1xIUY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b3eKQ = parcelRequire("b3eKQ");

const $ec9b6a853ee48486$export$f271121a021219d3 = ()=>({
        name: 'hubShell',
        contentComponent ({ editorView: editorView }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3eKQ.HubShellContentComponent), {
                editorView: editorView
            });
        }
    });
module.exports["hubShellPlugin"] = $ec9b6a853ee48486$export$f271121a021219d3;

});

parcelRegister("4MVLq", function(module, exports) {
function $d45ccd44c931de7b$export$13aeab2a71badd1e({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIDefinitionsConfig`.
    return options;
}
module.exports["aiDefinitionsPluginOptions"] = $d45ccd44c931de7b$export$13aeab2a71badd1e;

});

parcelRegister("fWkcL", function(module, exports) {
function $acf26518460f3499$export$bfd53895e8497571({}) {
    return {};
}
module.exports["analyticsPluginOptions"] = $acf26518460f3499$export$bfd53895e8497571;

});

parcelRegister("iWSPQ", function(module, exports) {
function $0b0084cdebc703c9$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: undefined,
        annotationManager: options.annotationManager
    };
}
module.exports["annotationPluginOptions"] = $0b0084cdebc703c9$export$b3e029fd31f94f55;

});

parcelRegister("4y9Kz", function(module, exports) {
function $69a335eff8f686c5$export$eeaea850bc5c5797({ options: options }) {
    return {
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}
module.exports["avatarGroupPluginOptions"] = $69a335eff8f686c5$export$eeaea850bc5c5797;

});

parcelRegister("cHFKB", function(module, exports) {
function $38a0d8518c026de5$export$a23b3fa66082f163({ options: options }) {
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: undefined
    };
}
module.exports["basePluginOptions"] = $38a0d8518c026de5$export$a23b3fa66082f163;

});

parcelRegister("eRg9X", function(module, exports) {
function $9f528e524f6d39d5$export$817c0e398e6ff750({}) {
    return {
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        isUndoRedoButtonsEnabled: true,
        allowBlockType: undefined
    };
}
module.exports["blockTypePluginOptions"] = $9f528e524f6d39d5$export$817c0e398e6ff750;

});

parcelRegister("1sSwB", function(module, exports) {
function $629d78bc6ac5b14e$export$3be6b735d5cbc3e6() {
    return {
        allowBreakoutButton: true
    };
}
module.exports["breakoutPluginOptions"] = $629d78bc6ac5b14e$export$3be6b735d5cbc3e6;

});

parcelRegister("aJHVS", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");

/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $17845e7231cbde23$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $17845e7231cbde23$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        allowDatasource: false,
        provider: providers.cardProvider,
        resolveBeforeMacros: $17845e7231cbde23$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        onClickCallback: options.onClickCallback,
        fullWidthMode: false,
        linkPicker: options.linkPicker,
        lpLinkPicker: true,
        editorAppearance: 'full-page',
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $eTj7Y.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt
    };
}
module.exports["cardPluginOptions"] = $17845e7231cbde23$export$514131654bb897e2;

});

parcelRegister("9tRxr", function(module, exports) {
function $2071df89d6cd2287$export$3f0ff0bcf72f4d98() {
    return {
        appearance: 'full-page'
    };
}
module.exports["codeBidiWarningPluginOptions"] = $2071df89d6cd2287$export$3f0ff0bcf72f4d98;

});

parcelRegister("i2djY", function(module, exports) {
function $d6ebf8f29df564a1$export$74cc43e84bb9c20({}) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false
    };
}
module.exports["codeBlockPluginOptions"] = $d6ebf8f29df564a1$export$74cc43e84bb9c20;

});

parcelRegister("jQ06G", function(module, exports) {
function $e3f44214a7b3dbd1$export$2c26eb5ff90afcfd({ providers: providers }) {
    return {
        contextIdentifierProvider: providers.contextIdentifierProvider
    };
}
module.exports["contextIdentifierPluginOptions"] = $e3f44214a7b3dbd1$export$2c26eb5ff90afcfd;

});

parcelRegister("5Dd7d", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $26ea6a4e9a24a366$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return(// If object-sidebar is not enabled, then we don't need to pass the contextPanelOptions
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? {
        objectSideBar: options.objectSideBar
    } : undefined);
}
module.exports["contextPanelPluginOptions"] = $26ea6a4e9a24a366$export$48a60d81b6bb28e3;

});

parcelRegister("bVUSv", function(module, exports) {
function $fec23932796ad742$export$f18d68682e981a91({ providers: providers }) {
    return {
        autoformattingProvider: providers.autoformattingProvider
    };
}
module.exports["customAutoformatPluginOptions"] = $fec23932796ad742$export$f18d68682e981a91;

});

parcelRegister("b4WWq", function(module, exports) {
function $ef880343d49ffe72$export$5598bb2314a53fa8({}) {
    return {
        weekStartDay: undefined
    };
}
module.exports["datePluginOptions"] = $ef880343d49ffe72$export$5598bb2314a53fa8;

});

parcelRegister("78pY6", function(module, exports) {
function $b19d9c84f5cf0ba1$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}
module.exports["editorDisabledPluginOptions"] = $b19d9c84f5cf0ba1$export$de47eee62065048e;

});

parcelRegister("4REcT", function(module, exports) {
function $94460a3ae74708d0$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}
module.exports["editorViewModePluginOptions"] = $94460a3ae74708d0$export$36a79e2b5698697a;

});

parcelRegister("dxCwJ", function(module, exports) {
function $3d4c034b969d8545$export$7adcaf18ca5c72c4({ providers: providers }) {
    return {
        emojiProvider: providers.emojiProvider
    };
}
module.exports["emojiPluginOptions"] = $3d4c034b969d8545$export$7adcaf18ca5c72c4;

});

parcelRegister("86sOu", function(module, exports) {
function $2867aa80797b1484$export$128eafe7f843e327({ options: options }) {
    return {
        coordinationClient: options.coordinationClient
    };
}
module.exports["engagementPlatformPluginOptions"] = $2867aa80797b1484$export$128eafe7f843e327;

});

parcelRegister("kzRVg", function(module, exports) {
function $3f3e4f29f2065e64$export$ed53f0c49fce09d6() {
    return {
        allowInsertion: true,
        useLongPressSelection: false,
        appearance: 'full-page',
        allowInteractiveExpand: true,
        __livePage: false
    };
}
module.exports["expandPluginOptions"] = $3f3e4f29f2065e64$export$ed53f0c49fce09d6;

});

parcelRegister("8J4Ig", function(module, exports) {
function $13dc9dee75d5bdd5$export$c18b9102cd0790c9({ options: options }) {
    return {
        breakoutEnabled: true,
        extensionHandlers: options.extensionHandlers,
        useLongPressSelection: false,
        appearance: 'full-page',
        __rendererExtensionOptions: options.__rendererExtensionOptions,
        getExtensionHeight: options.getExtensionHeight
    };
}
module.exports["extensionPluginOptions"] = $13dc9dee75d5bdd5$export$c18b9102cd0790c9;

});

parcelRegister("h5EPM", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");

function $30d1497707429888$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        lpLinkPicker: true,
        tableDragAndDrop: (0, $iu6m9.editorExperiment)('platform_editor_tables_drag_and_drop', true),
        tableWithFixedColumnWidthsOption: true,
        tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["featureFlagsPluginOptions"] = $30d1497707429888$export$3bff061e5229a7;

});

parcelRegister("71mY6", function(module, exports) {
function $d1cac142960ff61c$export$d9e183f0607e1b5d({}) {
    return {
        // originally depends on !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        twoLineEditorToolbar: false
    };
}
module.exports["findReplacePluginOptions"] = $d1cac142960ff61c$export$d9e183f0607e1b5d;

});

parcelRegister("f3DGR", function(module, exports) {
function $7b1a452cbb48f485$export$c66d0d1462a05bd({}) {
    return {
        shouldCalcBreakoutGridLines: true
    };
}
module.exports["gridPluginOptions"] = $7b1a452cbb48f485$export$c66d0d1462a05bd;

});

parcelRegister("aKz7i", function(module, exports) {
function $88af40f8c2f52f9b$export$2a67100cd9c61f05({ options: options }) {
    return options;
}
module.exports["helpDialogPluginOptions"] = $88af40f8c2f52f9b$export$2a67100cd9c61f05;

});

parcelRegister("gzLIB", function(module, exports) {
function $8da7b06601c8ee38$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: 'full-page',
        lpLinkPicker: true,
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}
module.exports["hyperlinkPluginOptions"] = $8da7b06601c8ee38$export$ab9ae3984d5aef33;

});

parcelRegister("dhSx4", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");

function $ad7b1b353b46da00$export$1e11b615e9dc119e() {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: 'full-page'
    };
}
module.exports["insertBlockPluginOptions"] = $ad7b1b353b46da00$export$1e11b615e9dc119e;

});

parcelRegister("7IWcn", function(module, exports) {
function $1ec840f9865e761e$export$33fb6c6592b2cd5f() {
    return {
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true,
        useLongPressSelection: false,
        UNSAFE_allowSingleColumnLayout: undefined,
        editorAppearance: 'full-page'
    };
}
module.exports["layoutPluginOptions"] = $1ec840f9865e761e$export$33fb6c6592b2cd5f;

});

parcelRegister("k2N06", function(module, exports) {
function $7880f5c156c13df4$export$feaee25faac0c640({ options: options }) {
    return {
        renderButton: options.renderButton,
        shouldShowToolbarButton: undefined
    };
}
module.exports["loomPluginOptions"] = $7880f5c156c13df4$export$feaee25faac0c640;

});

parcelRegister("6Hz7H", function(module, exports) {

var $fvooL = parcelRequire("fvooL");

function $06402620f0da3ac5$export$484123ae56f6fbd9({ intl: intl, providers: providers }) {
    return {
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
            const storageSupports = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage((0, $fvooL.i18n).invalidAltText)
            ];
            return [];
        },
        featureFlags: {
            mediaInline: true
        },
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: false,
        editorAppearance: 'full-page',
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        waitForMediaUpload: true
    };
}
module.exports["mediaPluginOptions"] = $06402620f0da3ac5$export$484123ae56f6fbd9;

});

parcelRegister("a05p6", function(module, exports) {
function $fbb0f2e011f7db3d$export$4677177d82484aef({ options: options }) {
    return options;
}
module.exports["metricsPluginOptions"] = $fbb0f2e011f7db3d$export$4677177d82484aef;

});

parcelRegister("kM0Zd", function(module, exports) {
function $3a82bd1b55f2a13e$export$c18e432f323b002e({}) {
    return {
        useLongPressSelection: false,
        allowCustomPanel: true,
        allowCustomPanelEdit: true
    };
}
module.exports["panelPluginOptions"] = $3a82bd1b55f2a13e$export$c18e432f323b002e;

});

parcelRegister("fgDQY", function(module, exports) {
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $30425996693f45d2$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $30425996693f45d2$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $30425996693f45d2$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true
    };
}
module.exports["pastePluginOptions"] = $30425996693f45d2$export$6b1ad42d09c74964;

});

parcelRegister("2MD6X", function(module, exports) {

var $d7ZU3 = parcelRequire("d7ZU3");


var $iu6m9 = parcelRequire("iu6m9");


var $dRcd0 = parcelRequire("dRcd0");

function $61bb71a0a099da18$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const placeholder = (()=>{
        if (options.viewMode === 'view') return undefined;
        if (!options.isAIEnabled) {
            const browser = (0, $d7ZU3.getBrowserInfo)();
            const key = browser.mac ? "\u2318" : 'Ctrl';
            return intl.formatMessage((0, $dRcd0.i18n).editorEmptyDocumentPlaceholderAI, {
                key: key
            });
        }
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $dRcd0.i18n).defaultPlaceholder);
        return intl.formatMessage((0, $dRcd0.i18n).easyCommandsPlaceholder);
    })();
    return {
        placeholder: placeholder
    };
}
module.exports["placeholderPluginOptions"] = $61bb71a0a099da18$export$c6841f879d4c8aef;

});

parcelRegister("9go3B", function(module, exports) {
function $d7ec44375c0c69ab$export$8b53e6ddc7cf96b4({}) {
    return {};
}
module.exports["placeholderTextPluginOptions"] = $d7ec44375c0c69ab$export$8b53e6ddc7cf96b4;

});

parcelRegister("c9cMu", function(module, exports) {
function $096819e9e3145dca$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}
module.exports["primaryToolbarPluginOptions"] = $096819e9e3145dca$export$44901d053a58e418;

});

parcelRegister("iKcD8", function(module, exports) {
function $851eded84e8bf107$export$26cff1f2fe9f781b({ options: options }) {
    return {
        enableElementBrowser: true,
        elementBrowserHelpUrl: '',
        disableDefaultItems: false,
        headless: false,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined
    };
}
module.exports["quickInsertPluginOptions"] = $851eded84e8bf107$export$26cff1f2fe9f781b;

});

parcelRegister("jWhwv", function(module, exports) {
function $f4b12af64bc7f2eb$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}
module.exports["selectionExtensionPluginOptions"] = $f4b12af64bc7f2eb$export$222c5aa4c9fb0805;

});

parcelRegister("3Xrfi", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");

function $0f50d38d2e30ef8c$export$197b78e13e8987d2({ options: options }) {
    return {
        hideCursorOnInit: options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)
    };
}
module.exports["selectionMarkerPluginOptions"] = $0f50d38d2e30ef8c$export$197b78e13e8987d2;

});

parcelRegister("hjUys", function(module, exports) {
function $b34077e910610c2a$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}
module.exports["selectionPluginOptions"] = $b34077e910610c2a$export$ddc2936355c1da67;

});

parcelRegister("8fkUp", function(module, exports) {
function $fc71367a7a47d521$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider
    };
}
module.exports["selectionToolbarPluginOptions"] = $fc71367a7a47d521$export$bc6dcb3c2a6112e1;

});

parcelRegister("1gKzC", function(module, exports) {
function $706ab7504ddbc2fe$export$9d286ea8d36eb908({}) {
    return {
        menuDisabled: false,
        allowZeroWidthSpaceAfter: true
    };
}
module.exports["statusPluginOptions"] = $706ab7504ddbc2fe$export$9d286ea8d36eb908;

});

parcelRegister("1yQ82", function(module, exports) {
function $a2229dc7f4dff797$export$3612ff8a6b94af71({}) {
    return undefined;
}
module.exports["submitEditorPluginOptions"] = $a2229dc7f4dff797$export$3612ff8a6b94af71;

});

parcelRegister("2tLa9", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");

function $3bb66ac430418946$export$9868b594778cf535() {
    return {
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: false,
        wasFullWidthEnabled: false,
        getEditorFeatureFlags: ()=>({
                tableWithFixedColumnWidthsOption: true,
                tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true)
            }),
        isCommentEditor: false,
        isChromelessEditor: false
    };
}
module.exports["tablePluginOptions"] = $3bb66ac430418946$export$9868b594778cf535;

});

parcelRegister("9NORi", function(module, exports) {
function $0274cb1d352a52e1$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission
    };
}
module.exports["tasksAndDecisionsPluginOptions"] = $0274cb1d352a52e1$export$1d23e03c42bfc1ac;

});

parcelRegister("dfnwW", function(module, exports) {
function $6878daa5f772afae$export$a4eedeb4455295f2({ isPluginEnabled: isPluginEnabled = true }) {
    return {
        toolbarConfig: {
            enabled: isPluginEnabled
        }
    };
}
module.exports["textColorPluginOptions"] = $6878daa5f772afae$export$a4eedeb4455295f2;

});

parcelRegister("2brVr", function(module, exports) {
function $92619e811c751fec$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}
module.exports["textFormattingPluginOptions"] = $92619e811c751fec$export$cb883a3a9320698e;

});

parcelRegister("1tg3R", function(module, exports) {
function $0d249c3975c8bf3b$export$bd221c449644c740({}) {
    return {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: true
    };
}
module.exports["toolbarListsIndentationPluginOptions"] = $0d249c3975c8bf3b$export$bd221c449644c740;

});

parcelRegister("19tf6", function(module, exports) {
function $63f1cbdbc55ad759$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}
module.exports["typeAheadPluginOptions"] = $63f1cbdbc55ad759$export$612ea2d32c3e4c96;

});

parcelRegister("7BhUY", function(module, exports) {
function $00f1b9d5a2046f3b$export$abdb0d09187eec69({ providers: providers }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        initialUserPreferences: undefined
    };
}
module.exports["userPreferencesPluginOptions"] = $00f1b9d5a2046f3b$export$abdb0d09187eec69;

});

parcelRegister("UUFGH", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $dAtrv = parcelRequire("dAtrv");


var $1PWfQ = parcelRequire("1PWfQ");


var $8V9Xs = parcelRequire("8V9Xs");


var $e6JxC = parcelRequire("e6JxC");


var $7tB0g = parcelRequire("7tB0g");

/**
 * Helper to create a higher order analytics command
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @return Higher order command with analytics logic inside.
 */ function $e1064870f1881c82$var$createWithColorAnalytics(newColor, previousColor, editorAnalyticsApi) {
    return (0, $dAtrv.withAnalytics)(editorAnalyticsApi, {
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColor.toLowerCase(),
            previousColor: previousColor?.toLowerCase() || ''
        }
    });
}
const $e1064870f1881c82$export$917538e4f4eb20f9 = (color, editorAnalyticsApi)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        if (textColor) {
            const pluginState = (0, $1PWfQ.pluginKey).getState(state);
            const activeColor = (0, $8V9Xs.getActiveColor)(state);
            const withColorAnalytics = $e1064870f1881c82$var$createWithColorAnalytics(color, activeColor, editorAnalyticsApi);
            if (pluginState?.disabled) return false;
            if (color === pluginState?.defaultColor) {
                withColorAnalytics((0, $e6JxC.removeColor)())(state, dispatch);
                return true;
            }
            withColorAnalytics((0, $7tB0g.toggleColor)(color))(state, dispatch);
            return true;
        }
        return false;
    };
module.exports["changeColor"] = $e1064870f1881c82$export$917538e4f4eb20f9;

});

parcelRegister("1PWfQ", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $8V9Xs = parcelRequire("8V9Xs");


var $3cILT = parcelRequire("3cILT");


var $fjyPY = parcelRequire("fjyPY");

function $cd8de2c8d893dc64$var$createInitialPluginState(editorState, pluginConfig) {
    const defaultColor = pluginConfig?.defaultColor || (0, $3cILT.DEFAULT_COLOR);
    const state = {
        color: (0, $8V9Xs.getActiveColor)(editorState),
        disabled: (0, $fjyPY.getDisabledState)(editorState),
        defaultColor: defaultColor.color
    };
    return state;
}
var $cd8de2c8d893dc64$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["RESET_COLOR"] = 0] = "RESET_COLOR";
    ACTIONS[ACTIONS["SET_COLOR"] = 1] = "SET_COLOR";
    ACTIONS[ACTIONS["DISABLE"] = 2] = "DISABLE";
    return ACTIONS;
}({});
const $cd8de2c8d893dc64$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('companyHubTextColorPlugin');
function $cd8de2c8d893dc64$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $1S4f7.SafePlugin)({
        key: $cd8de2c8d893dc64$export$18d4026d1ea86bb1,
        state: {
            init (_, editorState) {
                return $cd8de2c8d893dc64$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (tr, pluginState, _, newState) {
                const meta = tr.getMeta($cd8de2c8d893dc64$export$18d4026d1ea86bb1) || {};
                let nextState;
                switch(meta.action){
                    case 0:
                        nextState = {
                            ...pluginState,
                            color: pluginState.defaultColor
                        };
                        break;
                    case 1:
                        nextState = {
                            ...pluginState,
                            color: meta.color,
                            disabled: false
                        };
                        break;
                    case 2:
                        nextState = {
                            ...pluginState,
                            disabled: true
                        };
                        break;
                    default:
                        nextState = {
                            ...pluginState,
                            color: (0, $8V9Xs.getActiveColor)(newState),
                            disabled: (0, $fjyPY.getDisabledState)(newState)
                        };
                }
                if (pluginState && pluginState.color !== nextState.color || pluginState && pluginState.disabled !== nextState.disabled) {
                    dispatch($cd8de2c8d893dc64$export$18d4026d1ea86bb1, nextState);
                    return nextState;
                }
                return pluginState;
            }
        },
        props: {
            attributes: ()=>({
                    'data-company-hub-text-color-plugin': 'true'
                })
        }
    });
}
module.exports["ACTIONS"] = $cd8de2c8d893dc64$export$92a1a3b7554e9387;
module.exports["pluginKey"] = $cd8de2c8d893dc64$export$18d4026d1ea86bb1;
module.exports["createPlugin"] = $cd8de2c8d893dc64$export$ae829ec7b2625219;

});

parcelRegister("9F27L", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eiA8Z = parcelRequire("eiA8Z");


var $2iDug = parcelRequire("2iDug");

const $bde92491bf906b85$export$94516d5cccf573e3 = (0, $aXWIB.injectIntl)(({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled, api: api })=>{
    const { color: color, defaultColor: defaultColor, disabled: textColorDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'companyHubTextColor'
    ], (states)=>({
            color: states.companyHubTextColorState?.color,
            defaultColor: states.companyHubTextColorState?.defaultColor,
            disabled: states.companyHubTextColorState?.disabled
        }));
    if (color === undefined || defaultColor === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2iDug.ToolbarCompanyHubTextColor), {
        pluginState: {
            color: color,
            defaultColor: defaultColor,
            disabled: textColorDisabled
        },
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isReducedSpacing: isReducedSpacing,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: disabled,
        pluginInjectionApi: api,
        toolbarType: (0, $2iDug.ToolbarType).PRIMARY
    });
});
module.exports["PrimaryToolbarComponent"] = $bde92491bf906b85$export$94516d5cccf573e3;

});

parcelRegister("digS9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $kDB94 = parcelRequire("kDB94");


var $6Dr7z = parcelRequire("6Dr7z");

const $cec3fbf74ecbb846$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            ...(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_GROUP),
            parents: [
                {
                    ...(0, $cPCP8.TEXT_SECTION),
                    rank: (0, $4Chin.TEXT_SECTION_RANK)[(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                },
                {
                    type: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children)
        },
        {
            type: 'button',
            key: 'company-hub-text-color-button-inline-toolbar',
            parents: [
                {
                    ...(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_GROUP),
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Dr7z.CompanyHubTextColorButton), {
                    api: api,
                    parents: parents
                })
        }
    ];
};
module.exports["getToolbarComponents"] = $cec3fbf74ecbb846$export$a758406ca53b86a5;

});

parcelRegister("6FVCy", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $4T4vf = parcelRequire("4T4vf");


var $2Zpy2 = parcelRequire("2Zpy2");

const $553226b6c1a9879d$var$HUB_EXTENSION_DRAG_TYPE = 'hub-extension';
const $553226b6c1a9879d$export$df61b30b684217c0 = new (0, $ks2lK.PluginKey)('hubExternalInsert');
const $553226b6c1a9879d$var$initialState = {
    decorations: (0, $ftzrq.DecorationSet).empty,
    showCursorDropIndicator: false,
    dropTargetPos: null
};
/**
 * Container node types we deliberately descend INTO when resolving a drop
 * position. When the cursor is over content nested inside one of these
 * containers, we keep the resolved position inside the container instead
 * of clamping it back up to the document root.
 *
 * This is what enables drag-and-drop into:
 *   - layouts (`layoutSection` → `layoutColumn`)
 *   - hub `section` extension (a `multiBodiedExtension` with
 *     `extensionFrame` content holes)
 *   - bodied / nested expand / standard bodiedExtension containers
 *
 * Anything not in this set behaves like a leaf for the purposes of drop
 * resolution — the position is clamped to the nearest ancestor in the set
 * (or to the doc root). This matches the deny-list intuition used by
 * `editor-plugin-block-controls` for in-editor drag-and-drop.
 */ const $553226b6c1a9879d$var$DESCEND_INTO_NODES = new Set([
    'doc',
    'layoutSection',
    'layoutColumn',
    'multiBodiedExtension',
    'extensionFrame',
    'bodiedExtension',
    'expand',
    'nestedExpand'
]);
/**
 * Pick the boundary (before or after the child at the given depth) that
 * matches the cursor's vertical position. Reads the block DOM rect
 * directly to avoid calling `coordsAtPos`, which forces a full
 * synchronous layout reflow and is extremely slow when complex React
 * node views are present.
 */ function $553226b6c1a9879d$var$pickBoundaryForDepth(editorView, resolvedPos, depth, clientY, rawPos) {
    const blockStart = resolvedPos.before(depth);
    const blockEnd = resolvedPos.after(depth);
    const domNode = editorView.nodeDOM(blockStart);
    if (domNode instanceof HTMLElement) {
        const rect = domNode.getBoundingClientRect();
        const blockMidY = (rect.top + rect.bottom) / 2;
        return clientY < blockMidY ? blockStart : blockEnd;
    }
    // Fallback when the DOM node isn't available (e.g. during transient
    // node-view mount): use the proportional position within the block.
    const blockSize = blockEnd - blockStart;
    const offsetInBlock = rawPos - blockStart;
    return offsetInBlock < blockSize / 2 ? blockStart : blockEnd;
}
/**
 * Resolves a document position from mouse coordinates by using
 * ProseMirror's posAtCoords API and walking inward from the cursor's
 * deepest level outward, picking the **innermost** ancestor that we
 * recognise as a "descend-into" container. This means a drop inside a
 * `layoutColumn` resolves to a position inside the column (not above
 * the whole layout), and a drop inside a hub `section` resolves to a
 * position inside the section's content body.
 *
 * Returns the position at the chosen child boundary (above or below
 * the inner block), or null if the coordinates don't map to a position
 * inside the editor.
 *
 * NOTE: We avoid `coordsAtPos` for the same perf reason as before —
 * `pickBoundaryForDepth()` reads `nodeDOM().getBoundingClientRect()`
 * which is cheap.
 */ function $553226b6c1a9879d$var$resolveDropPosition(editorView, clientX, clientY) {
    try {
        const posInfo = editorView.posAtCoords({
            left: clientX,
            top: clientY
        });
        if (!posInfo) return null;
        const rawPos = Math.min(posInfo.pos, editorView.state.doc.content.size);
        const resolvedPos = editorView.state.doc.resolve(rawPos);
        // Walk from the deepest depth INWARD (towards depth 1), stopping
        // at the first ancestor whose parent is a known descend-into
        // container. This is the inverse of the previous `depth >= 1`
        // clamp, which always forced the position up to the document
        // root and prevented drops into layouts / sections / extensions.
        //
        // `resolvedPos.depth` is the parent depth at the cursor; the
        // child sitting at that level lives at `depth + 1`. We walk
        // from the cursor's parent upward, and as soon as we find a
        // parent that is in DESCEND_INTO_NODES we pick the boundary of
        // the child at that level.
        for(let d = resolvedPos.depth; d >= 1; d--){
            const parent = resolvedPos.node(d - 1);
            if ($553226b6c1a9879d$var$DESCEND_INTO_NODES.has(parent.type.name)) return $553226b6c1a9879d$var$pickBoundaryForDepth(editorView, resolvedPos, d, clientY, rawPos);
        }
        // Cursor is at depth 0 (over the doc itself, e.g. between
        // blocks at the very top). Fall back to the raw position.
        return resolvedPos.pos;
    } catch  {
        return null;
    }
}
function $553226b6c1a9879d$export$ae829ec7b2625219(api, nodeViewPortalProviderAPI) {
    // If portal API is missing (e.g. wrong editor wiring), run as no-op so the page doesn't break
    if (!nodeViewPortalProviderAPI || typeof nodeViewPortalProviderAPI.render !== 'function') return new (0, $1S4f7.SafePlugin)({
        key: $553226b6c1a9879d$export$df61b30b684217c0,
        state: {
            init: ()=>$553226b6c1a9879d$var$initialState,
            apply: (_tr, state)=>state
        },
        props: {
            decorations: (state)=>$553226b6c1a9879d$export$df61b30b684217c0.getState(state)?.decorations
        }
    });
    return new (0, $1S4f7.SafePlugin)({
        key: $553226b6c1a9879d$export$df61b30b684217c0,
        state: {
            init: ()=>$553226b6c1a9879d$var$initialState,
            apply: (tr, currentState, _oldState, newState)=>{
                try {
                    const meta = tr.getMeta($553226b6c1a9879d$export$df61b30b684217c0);
                    // If there is no meta for this plugin and the doc hasn't changed,
                    // nothing can affect our state — return early to avoid expensive
                    // decoration teardown/recreation (which involves React portals).
                    if (!meta && !tr.docChanged) return currentState;
                    const showCursorDropIndicator = meta?.showCursorDropIndicator ?? currentState.showCursorDropIndicator;
                    const dropTargetPos = meta?.dropTargetPos !== undefined ? meta.dropTargetPos : currentState.dropTargetPos;
                    // If nothing meaningful changed, keep the current state as-is
                    // to avoid destroying and recreating the React portal decoration.
                    if (showCursorDropIndicator === currentState.showCursorDropIndicator && dropTargetPos === currentState.dropTargetPos && !tr.docChanged) return currentState;
                    let decorations = currentState.decorations;
                    if (tr.docChanged) decorations = decorations.map(tr.mapping, tr.doc);
                    // Only remove and recreate decorations when the indicator
                    // visibility or position actually changed.
                    const indicatorChanged = showCursorDropIndicator !== currentState.showCursorDropIndicator || dropTargetPos !== currentState.dropTargetPos;
                    if (indicatorChanged) {
                        const cursorDecs = (0, $2Zpy2.findCursorIndicatorDecs)(decorations);
                        if (cursorDecs.length > 0) decorations = decorations.remove(cursorDecs);
                        if (showCursorDropIndicator && dropTargetPos != null) {
                            const clampedPos = Math.min(dropTargetPos, newState.doc.content.size);
                            const resolvedPos = newState.doc.resolve(clampedPos);
                            // Render the indicator at exactly the position the
                            // pointer resolved to. `resolveDropPosition()` has
                            // already placed `dropTargetPos` at a valid child
                            // boundary inside the innermost descend-into
                            // container — the document root, a `layoutColumn`,
                            // a hub `section`, etc. We must therefore read
                            // the surrounding `prevNode` / `nextNode` /
                            // `parentNode` from THAT depth, not from the
                            // document root, otherwise the gap/offset hints
                            // passed to `createCursorIndicatorDecoration` will
                            // describe the wrong siblings and the indicator
                            // will visually misalign inside nested containers.
                            const indicatorDepth = resolvedPos.depth;
                            const parentNode = resolvedPos.node(indicatorDepth);
                            const indexInParent = resolvedPos.index(indicatorDepth);
                            const prevNode = indexInParent > 0 ? parentNode.child(indexInParent - 1) : null;
                            const nextNode = indexInParent < parentNode.childCount ? parentNode.child(indexInParent) : null;
                            // `lineLength` is intentionally NOT passed any more.
                            // The indicator now sizes itself to its container's
                            // natural width via CSS (`left: 0; right: 0` on an
                            // absolute child of a `width: 100%` host). This is
                            // what makes the indicator behave correctly inside
                            // `layoutColumn`s of differing widths and inside
                            // hub `section` extension frames.
                            const dec = (0, $2Zpy2.createCursorIndicatorDecoration)(clampedPos, nodeViewPortalProviderAPI, prevNode, nextNode, parentNode);
                            decorations = decorations.add(newState.doc, [
                                dec
                            ]);
                        }
                    }
                    return {
                        decorations: decorations,
                        showCursorDropIndicator: showCursorDropIndicator,
                        dropTargetPos: dropTargetPos
                    };
                } catch  {
                    return currentState;
                }
            }
        },
        props: {
            decorations: (state)=>$553226b6c1a9879d$export$df61b30b684217c0.getState(state)?.decorations
        },
        view (editorView) {
            let cleanup;
            try {
                // Track pending rAF to throttle onDrag updates to at most once per frame.
                let rafId = null;
                cleanup = (0, $4T4vf.monitorForElements)({
                    canMonitor: ({ source: source })=>source.data.type === $553226b6c1a9879d$var$HUB_EXTENSION_DRAG_TYPE,
                    onDragStart: ({ location: location })=>{
                        const coords = location.current.input;
                        const dropPos = $553226b6c1a9879d$var$resolveDropPosition(editorView, coords.clientX, coords.clientY);
                        editorView.dispatch(editorView.state.tr.setMeta($553226b6c1a9879d$export$df61b30b684217c0, {
                            showCursorDropIndicator: true,
                            dropTargetPos: dropPos
                        }));
                    },
                    onDrag: ({ location: location })=>{
                        const coords = location.current.input;
                        const clientX = coords.clientX;
                        const clientY = coords.clientY;
                        // Throttle to one update per animation frame to avoid excessive
                        // ProseMirror transactions while the user is dragging.
                        if (rafId != null) cancelAnimationFrame(rafId);
                        rafId = requestAnimationFrame(()=>{
                            rafId = null;
                            const dropPos = $553226b6c1a9879d$var$resolveDropPosition(editorView, clientX, clientY);
                            const currentState = $553226b6c1a9879d$export$df61b30b684217c0.getState(editorView.state);
                            // Only dispatch if position actually changed to avoid unnecessary updates
                            if (currentState?.dropTargetPos !== dropPos) editorView.dispatch(editorView.state.tr.setMeta($553226b6c1a9879d$export$df61b30b684217c0, {
                                dropTargetPos: dropPos
                            }));
                        });
                    },
                    onDrop: ()=>{
                        if (rafId != null) {
                            cancelAnimationFrame(rafId);
                            rafId = null;
                        }
                        // Always ensure the indicator is cleaned up when a drag
                        // ends. The EditorDropTarget's onDrop already clears the
                        // indicator and inserts content in its own transaction,
                        // but we still need this for drags that end outside the
                        // drop target (cancelled or missed). The apply function's
                        // early-return optimisation ensures this is a no-op when
                        // the indicator was already cleared by EditorDropTarget.
                        const currentState = $553226b6c1a9879d$export$df61b30b684217c0.getState(editorView.state);
                        if (currentState?.showCursorDropIndicator) editorView.dispatch(editorView.state.tr.setMeta($553226b6c1a9879d$export$df61b30b684217c0, {
                            showCursorDropIndicator: false,
                            dropTargetPos: null
                        }));
                    }
                });
            } catch  {}
            return {
                destroy () {
                    try {
                        cleanup?.();
                    } catch  {}
                }
            };
        }
    });
}
module.exports["key"] = $553226b6c1a9879d$export$df61b30b684217c0;
module.exports["createPlugin"] = $553226b6c1a9879d$export$ae829ec7b2625219;

});

parcelRegister("b3eKQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $gqsO5 = parcelRequire("gqsO5");


var $jEpek = parcelRequire("jEpek");

const $ffd6fda601ce180e$export$6bbf8dcb80fbe27c = ({ editorView: editorView })=>{
    const navbarContainerRef = (0, $42omo.useRef)(null);
    const [mounted, setMounted] = (0, $42omo.useState)(false);
    const { isInPreviewMode: isInPreviewMode } = (0, $gqsO5.useHubContext)();
    (0, $42omo.useEffect)(()=>{
        const pmDom = editorView?.dom;
        if (!pmDom) return;
        const pmParent = pmDom.parentElement;
        if (!pmParent) return;
        // Insert the Navbar wrapper BEFORE the ProseMirror editable div.
        //
        // To make the navbar span the editor's full width (matching how
        // `full-width` layout extensions break out of the line-length
        // constraint), we mirror the structure used by editor breakout marks
        // (see `BreakoutView` in `@atlaskit/editor-plugin-breakout`):
        //
        //   - The outer element is a flex container that centers its child.
        //     `transform: none` neutralises any inherited transforms that
        //     would otherwise interfere with the inner element overflowing
        //     past the line-length-constrained parent.
        //   - The inner element gets a `min-width` matching the breakout
        //     formula. It uses the same CSS variables the editor exposes on
        //     its content container, so the navbar automatically scales with
        //     the editor's full-width layout, the viewport, and the
        //     guttering/context-panel state.
        const navbarOuterEl = document.createElement('div');
        navbarOuterEl.setAttribute('data-hub-shell-navbar', 'true');
        navbarOuterEl.style.display = 'flex';
        navbarOuterEl.style.justifyContent = 'center';
        navbarOuterEl.style.transform = 'none';
        const navbarInnerEl = document.createElement('div');
        // This is the same width as set for hub editor
        navbarInnerEl.style.minWidth = 'min(calc(100cqw - var(--hub-editor-gutter-padding-inline) * 2 - 8px), var(--ak-editor--full-width-layout-width))';
        navbarOuterEl.appendChild(navbarInnerEl);
        pmParent.insertBefore(navbarOuterEl, pmDom);
        navbarContainerRef.current = navbarInnerEl;
        setMounted(true);
        return ()=>{
            navbarOuterEl.remove();
            navbarContainerRef.current = null;
        };
    }, [
        editorView
    ]);
    if (!mounted || !navbarContainerRef.current) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $jTxSS.createPortal)(// In preview mode the navbar should be fully interactive so authors
    // can test navigation. In edit mode pointer-events are disabled to
    // prevent accidental navigation while editing.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jEpek.Navbar), {
        isEditMode: !isInPreviewMode
    }), navbarContainerRef.current));
};
module.exports["HubShellContentComponent"] = $ffd6fda601ce180e$export$6bbf8dcb80fbe27c;

});

parcelRegister("fvooL", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $4c417a863b46d1bc$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    invalidAltText: {
        id: "editor-presets-hub.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});
module.exports["i18n"] = $4c417a863b46d1bc$export$a7357cdd1f0b0168;

});

parcelRegister("dRcd0", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $38c68446ccb3ecb5$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    easyCommandsPlaceholder: {
        id: "editor-presets-hub.placeholder.easy-commands-placeholder",
        defaultMessage: "Type / for all elements."
    },
    aiPlaceholder: {
        id: "editor-presets-hub.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence or / to add elements."
    },
    defaultPlaceholder: {
        id: "editor-presets-hub.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "editor-presets-hub.placeholder.default-placeholder-ai",
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    }
});
module.exports["i18n"] = $38c68446ccb3ecb5$export$a7357cdd1f0b0168;

});

parcelRegister("8V9Xs", function(module, exports) {

var $3cILT = parcelRequire("3cILT");

const $c3320d5d95da4c41$export$1c6fa8f53a5fb47f = (state)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = state.selection;
    const { textColor: textColor } = state.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(state.storedMarks || $cursor.marks()) || undefined);
    else state.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $3cILT.DEFAULT_COLOR).color;
};
module.exports["getActiveColor"] = $c3320d5d95da4c41$export$1c6fa8f53a5fb47f;

});

parcelRegister("e6JxC", function(module, exports) {

var $eD3dl = parcelRequire("eD3dl");


var $1PWfQ = parcelRequire("1PWfQ");

const $002cfcf26694d43a$export$4a26621adcb675d6 = ()=>(state, dispatch)=>{
        const { schema: schema } = state;
        const { textColor: textColor } = schema.marks;
        const tr = state.tr;
        (0, $eD3dl.removeMark)(textColor)({
            tr: tr
        });
        if (dispatch) dispatch(tr.setMeta((0, $1PWfQ.pluginKey), {
            action: (0, $1PWfQ.ACTIONS).RESET_COLOR
        }));
        return true;
    };
module.exports["removeColor"] = $002cfcf26694d43a$export$4a26621adcb675d6;

});

parcelRegister("7tB0g", function(module, exports) {

var $eD3dl = parcelRequire("eD3dl");

var $b167b = parcelRequire("b167b");


var $1PWfQ = parcelRequire("1PWfQ");


var $3cILT = parcelRequire("3cILT");


var $fjyPY = parcelRequire("fjyPY");

const $b2cc98c8308dc410$export$afb561a73dff6672 = (color)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        const tr = state.tr;
        const disabledState = (0, $fjyPY.getDisabledState)(state);
        if (disabledState) {
            if (dispatch) dispatch(tr.setMeta((0, $1PWfQ.pluginKey), {
                action: (0, $1PWfQ.ACTIONS).DISABLE
            }));
            return false;
        }
        if (dispatch) {
            (0, $3cILT.overrideMarks).forEach((mark)=>{
                const { marks: marks } = tr.doc.type.schema;
                if (marks[mark]) (0, $eD3dl.removeMark)(marks[mark])({
                    tr: tr
                });
            });
            (0, $b167b.toggleMark)(textColor, {
                color: color
            })({
                tr: tr
            });
            dispatch(tr);
        }
        return true;
    };
module.exports["toggleColor"] = $b2cc98c8308dc410$export$afb561a73dff6672;

});

parcelRegister("3cILT", function(module, exports) {

var $1To4a = parcelRequire("1To4a");

const $569e940ac284ce8e$export$ccbc17c7832f26ef = [
    'backgroundColor'
];
const $569e940ac284ce8e$export$37394b0fa44b998c = {
    color: (0, $1To4a.default)('color.text'),
    label: 'Default'
};
module.exports["overrideMarks"] = $569e940ac284ce8e$export$ccbc17c7832f26ef;
module.exports["DEFAULT_COLOR"] = $569e940ac284ce8e$export$37394b0fa44b998c;

});

parcelRegister("fjyPY", function(module, exports) {

var $3x31R = parcelRequire("3x31R");

var $lrJCy = parcelRequire("lrJCy");


var $3cILT = parcelRequire("3cILT");

const $98edde6665fe847c$var$hasLinkMark = ($pos)=>{
    const { doc: { type: { schema: { marks: { link: linkMarkType } } } }, pos: pos } = $pos;
    if (!linkMarkType) return false;
    return $pos.doc.rangeHasMark(pos, Math.min(pos + 1, $pos.doc.content.size), linkMarkType);
};
const $98edde6665fe847c$export$4af1020a67b5ec91 = (state)=>{
    const { textColor: textColor } = state.schema.marks;
    if (textColor) {
        const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
        if (empty && !$cursor || $cursor && $98edde6665fe847c$var$hasLinkMark($cursor) || (0, $3x31R.isMarkAllowedInRange)(state.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $3cILT.overrideMarks).includes(mark.type.name);
        };
        if ((0, $lrJCy.isMarkExcluded)(textColor, state.storedMarks?.filter(omitOverrides) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};
module.exports["getDisabledState"] = $98edde6665fe847c$export$4af1020a67b5ec91;

});

parcelRegister("2iDug", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $8mBDG = parcelRequire("8mBDG");


var $5n7dr = parcelRequire("5n7dr");

var $koWgP = parcelRequire("koWgP");


var $litlC = parcelRequire("litlC");


var $UUFGH = parcelRequire("UUFGH");


var $eB87j = parcelRequire("eB87j");

var $3cccdde471a746af$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primary";
    ToolbarType["FLOATING"] = "floating";
    return ToolbarType;
}({});
const $3cccdde471a746af$export$803d4933f12f6ddc = (0, $aXWIB.injectIntl)(({ pluginState: pluginState, editorView: editorView, pluginInjectionApi: pluginInjectionApi, disabled: disabled })=>{
    const blackWhiteColorMap = (0, $koWgP.createBuiltInColorMap)({
        knownColors: [
            "var(--ds-text-inverse, #FFFFFF)",
            "var(--ds-text, #292A2E)"
        ]
    });
    // Help Hub advanced theming: surface the 22-swatch brand palette
    // (20 palette shades + white + black) in the text-color picker so
    // heading/normal text can use brand colours. Gated on the advanced
    // theming flag via `isAdvancedThemingEnabled` — when OFF (or outside a
    // HubThemingProvider, e.g. cross-host) `useHubTheming()` is undefined
    // and we fall back to the black/white default.
    const theming = (0, $litlC.useHubTheming)();
    const builtInColorMap = theming?.isAdvancedThemingEnabled && theming.brandBackgroundColorMap ? theming.brandBackgroundColorMap : blackWhiteColorMap;
    const changeTextColor = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((color)=>{
        if (color && !disabled) (0, $UUFGH.changeColor)(color, pluginInjectionApi?.analytics?.actions)(editorView.state, editorView.dispatch);
        editorView?.focus();
        return false;
    }, [
        disabled,
        editorView,
        pluginInjectionApi?.analytics?.actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8mBDG.ToolbarDropdownWrapper), {
        "data-testid": "company-hub-text-color-picker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5n7dr.ColorPicker), {
        analyticsSource: "companyHubToolbarTextColor",
        builtInColorMap: builtInColorMap,
        onChange: changeTextColor,
        value: pluginState.color || pluginState.defaultColor,
        isDisabled: disabled || pluginState.disabled,
        pickerTitle: (0, $eB87j.messages).colorPickerTitle,
        showCustomPalette: true,
        showTextIcon: true,
        enableBorderLessStyle: true
    }));
});
module.exports["ToolbarType"] = $3cccdde471a746af$export$a5d11b3163e4b1a5;
module.exports["ToolbarCompanyHubTextColor"] = $3cccdde471a746af$export$803d4933f12f6ddc;

});

parcelRegister("6Dr7z", function(module, exports) {
/* CompanyHubTextColorButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eiA8Z = parcelRequire("eiA8Z");


var $9dV3t = parcelRequire("9dV3t");


var $gzUv9 = parcelRequire("gzUv9");


var $jwWgu = parcelRequire("jwWgu");


var $wJ8xb = parcelRequire("wJ8xb");

var $efG2U = parcelRequire("efG2U");


var $bWiTS = parcelRequire("bWiTS");

var $iS6Uy = parcelRequire("iS6Uy");


var $aFUXX = parcelRequire("aFUXX");


var $7thpX = parcelRequire("7thpX");

var $7ERUE = parcelRequire("7ERUE");

var $f7YIZ = parcelRequire("f7YIZ");

var $iIVVb = parcelRequire("iIVVb");

var $8hoW2 = parcelRequire("8hoW2");


var $eyWa4 = parcelRequire("eyWa4");


var $1To4a = parcelRequire("1To4a");


var $hgHrd = parcelRequire("hgHrd");

var $koWgP = parcelRequire("koWgP");


var $litlC = parcelRequire("litlC");


var $UUFGH = parcelRequire("UUFGH");


var $el7Yk = parcelRequire("el7Yk");


var $9uFUI = parcelRequire("9uFUI");

const $68e9f5afbb6c16c2$var$popupComponentStyles = {
    popupWrapper: "_2rko12b0 _bfhkvuon _16qs130s _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
const $68e9f5afbb6c16c2$var$getHighlightColorIcon = (highlightColor)=>{
    if (highlightColor) return (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)(highlightColor);
    return undefined;
};
const $68e9f5afbb6c16c2$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
const $68e9f5afbb6c16c2$export$5738d006e3bc472b = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const buttonRef = (0, $42omo.useRef)(null);
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $8hoW2.useToolbarUI)();
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { color: color, defaultColor: defaultColor, disabled: textColorDisabled, highlightColor: highlightColor } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'companyHubTextColor',
        'highlight'
    ], (states)=>({
            color: states.companyHubTextColorState?.color,
            defaultColor: states.companyHubTextColorState?.defaultColor,
            disabled: states.companyHubTextColorState?.disabled,
            highlightColor: states.highlightState?.activeColor
        }));
    const blackWhiteColorMap = (0, $42omo.useMemo)(()=>(0, $koWgP.createBuiltInColorMap)({
            knownColors: [
                (0, $1To4a.default)('color.text.inverse'),
                (0, $1To4a.default)('color.text')
            ]
        }), []); // Help Hub advanced theming: surface the 22-swatch brand palette (20
    // palette shades + white + black) in the text-color picker so heading /
    // normal text can use brand colours. Gated on the advanced theming flag
    // via `isAdvancedThemingEnabled` — when OFF (or outside a
    // HubThemingProvider, e.g. cross-host) `useHubTheming()` is undefined and
    // we fall back to the black/white default.
    const theming = (0, $litlC.useHubTheming)();
    const builtInColorMap = theming?.isAdvancedThemingEnabled && theming.brandBackgroundColorMap ? theming.brandBackgroundColorMap : blackWhiteColorMap;
    const getIconColor = (0, $42omo.useCallback)(()=>{
        if (!color || color === defaultColor) return (0, $1To4a.default)('color.text');
         // find a matching editor text palette color for the hex color
        // if none is found, return the hex color itself
        return (0, $iS6Uy.hexToEditorTextPaletteColor)(color) || color || (0, $1To4a.default)('color.text');
    }, [
        color,
        defaultColor
    ]);
    const handleColorChange = (0, $42omo.useCallback)((color_0)=>{
        if (color_0 && !textColorDisabled && editorView?.state && editorView?.dispatch) {
            (0, $UUFGH.changeColor)(color_0, api?.analytics?.actions)(editorView.state, editorView.dispatch);
            editorView.focus();
        }
        setIsOpen(false);
        return false;
    }, [
        textColorDisabled,
        editorView,
        api?.analytics?.actions
    ]);
    const handleInternalClick = (0, $42omo.useCallback)((evt)=>{
        // Stop propagation of clicks inside the popup to prevent the document click listener from triggering
        // Without this, clicking on RGB/HEX/HSL dropdown would close the popup immediately
        evt.stopPropagation();
    }, []);
    const handleInternalKeyDown = (0, $42omo.useCallback)((evt_0)=>{
        // Stop propagation of keyboard events inside the popup to prevent the document listener from triggering
        // Support standard keyboard interactions for interactive elements within the popup
        if (evt_0.key === 'Enter' || evt_0.key === ' ') evt_0.stopPropagation();
    }, []);
    const closeMenu = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        setIsOpen,
        isOpen
    ]);
    if (!api?.companyHubTextColor || color === undefined || defaultColor === undefined) return null;
    const iconColor = getIconColor();
    const isDisabled = Boolean(textColorDisabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isOpen && buttonRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68e9f5afbb6c16c2$var$PopupWithListeners, {
        target: buttonRef.current,
        zIndex: (0, $aFUXX.akEditorFloatingOverlapPanelZIndex),
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        alignY: "top",
        alignX: "left",
        handleClickOutside: closeMenu,
        handleEscapeKeydown: closeMenu,
        allowOutOfBounds: true,
        fitHeight: 350,
        fitWidth: 350,
        preventOverflow: true,
        stick: false,
        offset: [
            0,
            10
        ],
        focusTrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wJ8xb.OutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            role: "none",
            "data-test-id": 'company-hub-text-color-picker',
            onClick: handleInternalClick,
            onKeyDown: handleInternalKeyDown,
            ref: setOutsideClickTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $68e9f5afbb6c16c2$var$popupComponentStyles.popupWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hgHrd.ColorPickerDropdown), {
            analyticsSource: "companyHubToolbarTextColor",
            builtInColorMap: builtInColorMap,
            onChange: handleColorChange,
            value: color || defaultColor,
            pickerTitle: (0, $9dV3t.companyHubTextColorMessages).colorPickerTitle,
            showCustomPalette: true,
            enableBorderLessStyle: false,
            isOpen: true,
            update: ()=>Promise.resolve(null),
            setInitialFocusRef: ()=>null
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $el7Yk.HighlightColorSection), {
            api: api,
            parents: parents
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9uFUI.RemoveColorSection), {
            api: api,
            parents: parents
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: formatMessage((0, $9dV3t.companyHubTextColorMessages).colorPickerTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        testId: "company-hub-text-color-toolbar-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7YIZ.ToolbarColorSwatch), {
            highlightColor: $68e9f5afbb6c16c2$var$getHighlightColorIcon(highlightColor)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7thpX.TextColorIcon), {
            label: formatMessage((0, $9dV3t.companyHubTextColorMessages).colorPickerTitle),
            iconColor: iconColor,
            size: 'small',
            isDisabled: isDisabled,
            spacing: 'compact'
        })),
        ref: buttonRef,
        onClick: handleClick,
        isSelected: isOpen,
        isDisabled: isDisabled
    })));
};
module.exports["CompanyHubTextColorButton"] = $68e9f5afbb6c16c2$export$5738d006e3bc472b;

});

parcelRegister("2Zpy2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $ftzrq = parcelRequire("ftzrq");


var $dzoNi = parcelRequire("dzoNi");

const $6144eae1ca3b6577$export$b81140debd8a9739 = 'hub-external-insert-cursor';
function $6144eae1ca3b6577$export$f06d6d3dfe4b012f(decorations) {
    return decorations.find(0, 1e9, (spec)=>spec.type === $6144eae1ca3b6577$export$b81140debd8a9739);
}
/** Minimal gap/offset for cursor indicator alignment (first version – constants). */ function $6144eae1ca3b6577$var$getGapAndOffset(_prevNode, _nextNode, _parentNode) {
    if (!_prevNode && _nextNode) return {
        gap: 0,
        offset: 0
    };
    if (_prevNode && !_nextNode) return {
        gap: 0,
        offset: 0
    };
    return {
        gap: 4,
        offset: 0
    };
}
function $6144eae1ca3b6577$export$f9707a82f2564638(pos, nodeViewPortalProviderAPI, prevNode, nextNode, parentNode) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = `hub-external-insert-cursor-${(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()}`;
    const { gap: gap, offset: offset } = $6144eae1ca3b6577$var$getGapAndOffset(prevNode, nextNode, parentNode);
    return (0, $ftzrq.Decoration).widget(pos, ()=>{
        const element = document.createElement('div');
        element.setAttribute('data-hub-external-insert-cursor', 'true');
        element.style.clear = 'unset';
        element.style.display = 'block';
        // `position: relative` makes this host the offset parent of
        // the indicator's `position: absolute` container, so the
        // indicator's `left: 0; right: 0` resolves against this
        // host's natural (container-constrained) width.
        element.style.position = 'relative';
        element.style.width = '100%';
        element.style.setProperty((0, $dzoNi.CURSOR_DROP_INDICATOR_OFFSET), `${offset}px`);
        element.style.setProperty((0, $dzoNi.CURSOR_DROP_INDICATOR_GAP), `${gap}px`);
        try {
            nodeViewPortalProviderAPI.render(()=>(0, $42omo.createElement)((0, $dzoNi.CursorDropIndicator)), element, key, undefined, true);
        } catch  {}
        return element;
    }, {
        type: $6144eae1ca3b6577$export$b81140debd8a9739,
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
}
module.exports["findCursorIndicatorDecs"] = $6144eae1ca3b6577$export$f06d6d3dfe4b012f;
module.exports["createCursorIndicatorDecoration"] = $6144eae1ca3b6577$export$f9707a82f2564638;

});

parcelRegister("jEpek", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");

parcelRequire("cILXD");
var $iNLdL = parcelRequire("iNLdL");
var $6SYln = parcelRequire("6SYln");


var $9ML05 = parcelRequire("9ML05");


var $esRft = parcelRequire("esRft");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $fJM5Q = parcelRequire("fJM5Q");


var $6S3N0 = parcelRequire("6S3N0");


var $aaEXZ = parcelRequire("aaEXZ");


var $g9Srd = parcelRequire("g9Srd");

var $htJyp = parcelRequire("htJyp");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $2hNw6 = parcelRequire("2hNw6");


var $cOy6N = parcelRequire("cOy6N");

var $gqsO5 = parcelRequire("gqsO5");

var $8PMrR = parcelRequire("8PMrR");


var $7Nj0p = parcelRequire("7Nj0p");


var $dZoX8 = parcelRequire("dZoX8");


var $9vsU0 = parcelRequire("9vsU0");


const $82e353492bcc8e1f$var$MobileMenuOverlay = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6rp67")).then((m)=>({
            default: m.MobileMenuOverlay
        })));
const $82e353492bcc8e1f$var$motionStyles = {
    slideEntering: "_j7hq14i1 _5sagi9qs _1pglindk",
    slideExiting: "_j7hq15r3 _5sagi9qs _1pgl1lbj"
};
const $82e353492bcc8e1f$var$styles = {
    navbar: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    navbarUpdated: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    navBarDisabled: "_lcxvglyw",
    logoContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    rightSection: "_zulputpp _1e0c1txw _4cvr1h6o"
};
const $82e353492bcc8e1f$export$42cfbb80f7861e77 = ({ isEditMode: isEditMode = false })=>{
    (0, $fBMbo.di)((0, $dh538.fg), (0, $gqsO5.useHubContext));
    const [isAvatarMenuOpen, setIsAvatarMenuOpen] = (0, $42omo.useState)(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = (0, $42omo.useState)(false);
    const navbarRef = (0, $42omo.useRef)(null);
    const isBelowSm = (0, $2hNw6.UNSAFE_useMediaQuery)('below.sm')?.matches ?? false;
    const hubContext = (0, $gqsO5.useHubContext)();
    const { featureFlags: featureFlags, hubType: hubType } = hubContext;
    const { options: navStyle } = (0, $8PMrR.useNavigationStyle)();
    const isNavBarUpdated = featureFlags?.hub_component_upgrade ?? false;
    const shouldShowMobileNavLinks = isNavBarUpdated && isBelowSm && (0, $dh538.fg)('hubs_nav_mobile_view');
    const dynamicStyle = (0, $42omo.useMemo)(()=>{
        if (!navStyle) return undefined;
        const border = `1px solid ${navStyle.borderColor}`;
        return {
            backgroundColor: navStyle.backgroundColor,
            color: navStyle.textColor,
            borderRadius: navStyle.padding ? `${navStyle.cornerRadius}px` : '0',
            border: navStyle.borderType === 'ALL_BORDER' ? border : 'none',
            // this will be the css 'none' value
            borderBottom: [
                'BOTTOM_BORDER',
                'ALL_BORDER'
            ].includes(navStyle.borderType) ? border : undefined,
            // bottom border is always applied for all borders
            position: navStyle.fixedAtTop ? 'sticky' : 'relative',
            top: navStyle.padding && navStyle.fixedAtTop ? "var(--ds-space-300, 24px)" : '0px',
            zIndex: navStyle.fixedAtTop ? 1 : undefined,
            marginTop: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginLeft: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginRight: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginBottom: "var(--ds-space-300, 24px)",
            // we always add a margin bottom to the navbar
            transition: 'margin 0.3s ease, border-radius 0.3s ease, top 0.3s ease'
        };
    }, [
        navStyle
    ]);
    const iconColor = isNavBarUpdated ? navStyle?.textColor : undefined;
    const { push: push } = (0, $6SYln.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const logoUrl = hubContext.branding.logo.url;
    const { avatarSrc: avatarSrc, email: email } = hubContext.user;
    const { renderRightNavActions: renderRightNavActions } = hubContext;
    const isAnonymousRoute = hubContext.layout?.isAnonymousRoute || false;
    const handleInboxClick = (0, $42omo.useCallback)(()=>{
        push(`/user/requests`);
    }, [
        push
    ]);
    const handleProfileClick = (0, $42omo.useCallback)(()=>{
        setIsAvatarMenuOpen(!isAvatarMenuOpen);
    }, [
        isAvatarMenuOpen
    ]);
    const handleAvatarMenuClose = (0, $42omo.useCallback)(()=>{
        setIsAvatarMenuOpen(false);
    }, []);
    const handleHamburgerClick = (0, $42omo.useCallback)(()=>{
        setIsMobileMenuOpen(true);
    }, []);
    const handleMobileMenuClose = (0, $42omo.useCallback)(()=>{
        setIsMobileMenuOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: navbarRef,
        "data-testId": "navbar",
        xcss: (0, $1Whri.cx)(isNavBarUpdated ? $82e353492bcc8e1f$var$styles.navbarUpdated : $82e353492bcc8e1f$var$styles.navbar, isEditMode && $82e353492bcc8e1f$var$styles.navBarDisabled),
        style: isNavBarUpdated ? dynamicStyle : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $82e353492bcc8e1f$var$styles.logoContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iNLdL.default), {
        to: !isAnonymousRoute ? '/' : '/user/login'
    }, logoUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        height: (0, $cOy6N.getHubLogoHeight)(hubType),
        src: logoUrl,
        alt: formatMessage((0, $dZoX8.default).hubLogo)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fJM5Q))), {
                ...iconProps,
                color: iconColor
            }),
        label: formatMessage((0, $dZoX8.default).hubLogo),
        color: navStyle?.textColor
    }))), !isAnonymousRoute && email && isNavBarUpdated && !isBelowSm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9vsU0.NavLinks), {
        textColor: navStyle?.textColor,
        backgroundColor: navStyle?.backgroundColor
    }), !isAnonymousRoute && email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $82e353492bcc8e1f$var$styles.rightSection
    }, !isNavBarUpdated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderRightNavActions && renderRightNavActions()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6S3N0))), {
                ...iconProps_0,
                color: iconColor
            }),
        label: "User requests",
        onClick: handleInboxClick
    })), shouldShowMobileNavLinks ? isMobileMenuOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps_1,
                color: iconColor
            }),
        label: formatMessage((0, $dZoX8.default).closeMenu),
        onClick: handleMobileMenuClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaEXZ))), {
                ...iconProps_2,
                color: iconColor
            }),
        label: formatMessage((0, $dZoX8.default).openMenu),
        onClick: handleHamburgerClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ML05.Profile), {
                ...triggerProps,
                tooltip: "Profile and settings",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                    appearance: "circle",
                    size: "medium",
                    src: avatarSrc
                }),
                onClick: handleProfileClick
            }),
        shouldRenderToParent: true,
        placement: "bottom-end",
        isOpen: isAvatarMenuOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Nj0p.AvatarMenu), null),
        onClose: handleAvatarMenuClose
    })), !isAnonymousRoute && !email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iNLdL.default), {
        to: `/user/login`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), null, formatMessage((0, $dZoX8.default).login))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
        appear: true
    }, isMobileMenuOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $htJyp.default), {
        enteringAnimationXcss: $82e353492bcc8e1f$var$motionStyles.slideEntering,
        exitingAnimationXcss: $82e353492bcc8e1f$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82e353492bcc8e1f$var$MobileMenuOverlay, {
        onClose: handleMobileMenuClose,
        navbarRef: navbarRef
    })))));
};
module.exports["Navbar"] = $82e353492bcc8e1f$export$42cfbb80f7861e77;

});

parcelRegister("eB87j", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $204e6db0a10d1a26$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    colorPickerTitle: {
        id: "companyHub.editor.textColor.pickerTitle",
        defaultMessage: "Text Color"
    }
});
module.exports["messages"] = $204e6db0a10d1a26$export$defe85febe8b728c;

});

parcelRegister("el7Yk", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eiA8Z = parcelRequire("eiA8Z");


var $e0nFU = parcelRequire("e0nFU");


var $fIFhP = parcelRequire("fIFhP");


var $5qdhe = parcelRequire("5qdhe");


var $bWiTS = parcelRequire("bWiTS");


var $g66hv = parcelRequire("g66hv");

var $5v3PK = parcelRequire("5v3PK");


var $cO1el = parcelRequire("cO1el");


var $cvXh8 = parcelRequire("cvXh8");


var $5gydP = parcelRequire("5gydP");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

const $fc471d83569d4f7a$var$styles = {
    container: "_zulp12x7 _19pkpxbi",
    removeHighlightButton: "_2rko12b0 _195gv77o _189ee4h9 _1dqonqa1 _1h6d1l7x",
    icon: "_1e0c1o8l _18u01n1a"
};
const $fc471d83569d4f7a$var$TextColorIconDecorator = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { label: label, isSelected: isSelected } = t0;
    let t1;
    if ($[0] !== isSelected || $[1] !== label) {
        t1 = isSelected ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
            color: "var(--ds-icon, #292A2E)",
            label: label
        }) : /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: $fc471d83569d4f7a$var$styles.icon
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5gydP))), {
            label: label,
            color: "var(--ds-icon, #292A2E)",
            shouldRecommendSmallIcon: true,
            spacing: "spacious",
            size: "small"
        }));
        $[0] = isSelected;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ label: label, isSelected: isSelected })=>{
    const iconColor = "var(--ds-icon, #292A2E)";
    return isSelected ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        color: iconColor,
        label: label
    }) : /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $fc471d83569d4f7a$var$styles.icon
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5gydP))), {
        label: label,
        color: iconColor,
        shouldRecommendSmallIcon: true,
        spacing: "spacious",
        size: "small"
    }));
};
const $fc471d83569d4f7a$export$586c660b6a27552f = (0, $4pOgL.isReactCompilerActivePlatform)() ? function HighlightColorSection(t0) {
    const $ = (0, $frIzR.c)(24);
    const { api: api, parents: parents } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "highlight"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const activeColor = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t1, $fc471d83569d4f7a$var$_temp);
    const context = (0, $5v3PK.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    let t2;
    if ($[1] !== api || $[2] !== closeMenu || $[3] !== parents) {
        t2 = (color, event)=>{
            if (api?.highlight?.commands?.changeColor) {
                api.core.actions.execute(api.highlight.commands.changeColor({
                    color: color,
                    inputMethod: (0, $fIFhP.getInputMethodFromParentKeys)(parents)
                }));
                closeMenu?.(event);
            }
        };
        $[1] = api;
        $[2] = closeMenu;
        $[3] = parents;
        $[4] = t2;
    } else t2 = $[4];
    const handleHighlightColorChange = t2;
    let t3;
    if ($[5] !== activeColor) {
        const isSelected = (color_0)=>color_0.value === activeColor;
        t3 = (0, $5qdhe.highlightColorPalette).filter($fc471d83569d4f7a$var$_temp2).map((color_2)=>({
                ...color_2,
                decorator: /*#__PURE__*/ $42omo.createElement($fc471d83569d4f7a$var$TextColorIconDecorator, {
                    label: color_2.label,
                    isSelected: isSelected(color_2)
                })
            }));
        $[5] = activeColor;
        $[6] = t3;
    } else t3 = $[6];
    const colorPalette = t3;
    let t4;
    if ($[7] !== formatMessage) {
        t4 = formatMessage((0, $e0nFU.highlightMessages).highlight);
        $[7] = formatMessage;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
            size: "xxsmall"
        }, t4);
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== handleHighlightColorChange) {
        t6 = (color_3, _, event_0)=>{
            handleHighlightColorChange(color_3, event_0);
        };
        $[11] = handleHighlightColorChange;
        $[12] = t6;
    } else t6 = $[12];
    const t7 = activeColor || null;
    let t8;
    if ($[13] !== colorPalette) {
        t8 = colorPalette || [];
        $[13] = colorPalette;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t8) {
        t9 = {
            palette: t8,
            hexToPaletteColor: (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)
        };
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t6 || $[18] !== t7 || $[19] !== t9) {
        t10 = /*#__PURE__*/ $42omo.createElement((0, $g66hv.default), {
            onClick: t6,
            selectedColor: t7,
            paletteOptions: t9
        });
        $[17] = t6;
        $[18] = t7;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10 || $[22] !== t5) {
        t11 = /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
            xcss: $fc471d83569d4f7a$var$styles.container,
            testId: "highlight-color-menu-item"
        }, t5, t10);
        $[21] = t10;
        $[22] = t5;
        $[23] = t11;
    } else t11 = $[23];
    return t11;
} : function HighlightColorSection({ api: api, parents: parents }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const activeColor = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'highlight'
    ], (states)=>states.highlightState?.activeColor);
    const context = (0, $5v3PK.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const handleHighlightColorChange = (0, $42omo.useCallback)((color, event)=>{
        if (api?.highlight?.commands?.changeColor) {
            api.core.actions.execute(api.highlight.commands.changeColor({
                color: color,
                inputMethod: (0, $fIFhP.getInputMethodFromParentKeys)(parents)
            }));
            closeMenu?.(event);
        }
    }, [
        api,
        closeMenu,
        parents
    ]);
    const colorPalette = (0, $42omo.useMemo)(()=>{
        const isSelected = (color_0)=>color_0.value === activeColor;
        return (0, $5qdhe.highlightColorPalette).filter((color_1)=>color_1.value !== (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR)).map((color_2)=>({
                ...color_2,
                decorator: /*#__PURE__*/ $42omo.createElement($fc471d83569d4f7a$var$TextColorIconDecorator, {
                    label: color_2.label,
                    isSelected: isSelected(color_2)
                })
            }));
    }, [
        activeColor
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        xcss: $fc471d83569d4f7a$var$styles.container,
        testId: "highlight-color-menu-item"
    }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "xxsmall"
    }, formatMessage((0, $e0nFU.highlightMessages).highlight)), /*#__PURE__*/ $42omo.createElement((0, $g66hv.default), {
        onClick: (color_3, _, event_0)=>{
            handleHighlightColorChange(color_3, event_0);
        },
        selectedColor: activeColor || null,
        paletteOptions: {
            palette: colorPalette || [],
            hexToPaletteColor: (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)
        }
    }));
};
function $fc471d83569d4f7a$var$_temp2(color_1) {
    return color_1.value !== (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR);
}
function $fc471d83569d4f7a$var$_temp(states) {
    return states.highlightState?.activeColor;
}
module.exports["HighlightColorSection"] = $fc471d83569d4f7a$export$586c660b6a27552f;

});

parcelRegister("9uFUI", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $e0nFU = parcelRequire("e0nFU");


var $fIFhP = parcelRequire("fIFhP");


var $5qdhe = parcelRequire("5qdhe");


var $5v3PK = parcelRequire("5v3PK");


var $iXCQx = parcelRequire("iXCQx");

const $2e94db936cbb379c$var$styles = {
    removeColorButton: "_2rko12b0 _195gv77o _189ee4h9 _1dqonqa1 _1h6d1l7x _19pk12x7"
};
const $2e94db936cbb379c$export$c6c1c71256ced33c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { api: api, parents: parents } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const context = (0, $5v3PK.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    let t1;
    if ($[0] !== api || $[1] !== closeMenu || $[2] !== parents) {
        t1 = (event)=>{
            if (!api) return;
            const defaultColor = api.textColor.sharedState.currentState()?.defaultColor;
            if (!defaultColor) return;
            api.core.actions.execute((t2)=>{
                const { tr: tr } = t2;
                api.textColor.commands.changeColor(defaultColor, (0, $fIFhP.getInputMethodFromParentKeys)(parents))({
                    tr: tr
                });
                api.highlight?.commands.changeColor({
                    color: (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR),
                    inputMethod: (0, $fIFhP.getInputMethodFromParentKeys)(parents)
                })({
                    tr: tr
                });
                return tr;
            });
            closeMenu?.(event);
        };
        $[0] = api;
        $[1] = closeMenu;
        $[2] = parents;
        $[3] = t1;
    } else t1 = $[3];
    const onClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            $2e94db936cbb379c$var$styles.removeColorButton
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage((0, $e0nFU.highlightMessages).removeColor);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            weight: "medium"
        }, t3);
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== onClick || $[10] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t2
        }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            shouldFitContainer: true,
            appearance: "subtle",
            onClick: onClick
        }, t4));
        $[9] = onClick;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const context = (0, $5v3PK.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const onClick = (event)=>{
        if (!api) return;
        const defaultColor = api.textColor.sharedState.currentState()?.defaultColor;
        if (!defaultColor) return;
        api.core.actions.execute(({ tr: tr })=>{
            api.textColor.commands.changeColor(defaultColor, (0, $fIFhP.getInputMethodFromParentKeys)(parents))({
                tr: tr
            });
            api.highlight?.commands.changeColor({
                color: (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR),
                inputMethod: (0, $fIFhP.getInputMethodFromParentKeys)(parents)
            })({
                tr: tr
            });
            return tr;
        });
        closeMenu?.(event);
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $2e94db936cbb379c$var$styles.removeColorButton
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        shouldFitContainer: true,
        appearance: "subtle",
        onClick: onClick
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        weight: "medium"
    }, formatMessage((0, $e0nFU.highlightMessages).removeColor))));
};
module.exports["RemoveColorSection"] = $2e94db936cbb379c$export$c6c1c71256ced33c;

});

parcelRegister("dzoNi", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2n8po = parcelRequire("2n8po");


var $gdv5Z = parcelRequire("gdv5Z");

const $923b57cf95a315f3$export$5c1bdc10c885b45b = '--editor-cursor-drop-indicator-offset';
const $923b57cf95a315f3$export$386f7807bfc7e1a9 = '--editor-cursor-drop-indicator-gap';
const $923b57cf95a315f3$var$styles = {
    container: "_kqswstnw _1ltvidpf _1xi2idpf _1e0c1ule _1pbyb4wl _t9ec1fkh",
    dropIndicator: "_4t3i1osq _1bsb1osq _kqswh2mm _1e0c1ule"
};
const $923b57cf95a315f3$export$94ce81ee629276a7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CursorDropIndicator() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $923b57cf95a315f3$var$styles.container,
            testId: "hub-external-insert-cursor-drop-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $923b57cf95a315f3$var$styles.dropIndicator,
            testId: "hub-external-insert-cursor-drop-indicator-box"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2n8po.DropIndicator), {
            edge: "bottom"
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function CursorDropIndicator() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $923b57cf95a315f3$var$styles.container,
        testId: "hub-external-insert-cursor-drop-indicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $923b57cf95a315f3$var$styles.dropIndicator,
        testId: "hub-external-insert-cursor-drop-indicator-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2n8po.DropIndicator), {
        edge: "bottom"
    })));
};
module.exports["CURSOR_DROP_INDICATOR_OFFSET"] = $923b57cf95a315f3$export$5c1bdc10c885b45b;
module.exports["CURSOR_DROP_INDICATOR_GAP"] = $923b57cf95a315f3$export$386f7807bfc7e1a9;
module.exports["CursorDropIndicator"] = $923b57cf95a315f3$export$94ce81ee629276a7;

});

parcelRegister("cOy6N", function(module, exports) {

var $cNwLI = parcelRequire("cNwLI");

const $8b29b73fbf447029$export$8eeba3862e4455cf = (hubType)=>{
    // Help hubs always use new height
    if (hubType === 'HELP_HUB') return 0, $cNwLI.HUB_LOGO_HEIGHT;
    // CSM hubs always use new height
    if (hubType === 'CUSTOMER_SERVICE') return 0, $cNwLI.HUB_LOGO_HEIGHT;
    // Fallback to legacy height for other hub types
    return 0, $cNwLI.HUB_LOGO_HEIGHT_LEGACY;
};
module.exports["getHubLogoHeight"] = $8b29b73fbf447029$export$8eeba3862e4455cf;

});

parcelRegister("7Nj0p", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");

parcelRequire("cILXD");
var $iNLdL = parcelRequire("iNLdL");
var $bLeKY = parcelRequire("bLeKY");


var $56M4r = parcelRequire("56M4r");

var $d77M1 = parcelRequire("d77M1");

var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $dh538 = parcelRequire("dh538");


var $gqsO5 = parcelRequire("gqsO5");


var $iyju2 = parcelRequire("iyju2");


var $wcTgs = parcelRequire("wcTgs");

const $cb49fc38cf397002$var$styles = {
    menu: "_1bsbnpok"
};
const $cb49fc38cf397002$export$f7f58290278dd286 = ()=>{
    (0, $fBMbo.di)((0, $gqsO5.useHubContext), (0, $dh538.fg));
    const hubContext = (0, $gqsO5.useHubContext)();
    const [{ match: match }] = (0, $bLeKY.useRouter)();
    const { user: user, env: env, actions: actions, renderAvatarMenuOptions: renderAvatarMenuOptions, cloudUrl: cloudUrl } = hubContext;
    const { isJiraAdmin: isJiraAdmin } = user;
    const { helpCenterId: helpCenterId, hoistedProjectKey: hoistedProjectKey } = env;
    const { id: pageId } = match.params;
    const { onLogoutClick: onLogoutClick } = actions;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const shouldUseConsumerAvatarMenu = (0, $dh538.fg)('enable-jsm-in-hubs');
    const consumerAvatarMenuContent = shouldUseConsumerAvatarMenu && typeof renderAvatarMenuOptions === 'function' ? renderAvatarMenuOptions() : null;
    const csmEditorUrl = `${cloudUrl}/jira/helpcenter/projects/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}`;
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $cb49fc38cf397002$var$styles.menu
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2SlZp.default), {
        spacing: "cozy"
    }, /*#__PURE__*/ $42omo.createElement((0, $7rvPL.default), null, /*#__PURE__*/ $42omo.createElement((0, $iyju2.AccountDetails), null)), consumerAvatarMenuContent || isJiraAdmin && /*#__PURE__*/ $42omo.createElement((0, $7rvPL.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $42omo.createElement((0, $cGtPE.default), {
        href: csmEditorUrl,
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $wcTgs.default).editSite))), /*#__PURE__*/ $42omo.createElement((0, $7rvPL.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $42omo.createElement((0, $d77M1.default), {
        component: (0, $iNLdL.default),
        to: `/user/profile`,
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $wcTgs.default).profile)), /*#__PURE__*/ $42omo.createElement((0, $56M4r.default), {
        onClick: onLogoutClick
    }, formatMessage((0, $wcTgs.default).logout)))));
};
module.exports["AvatarMenu"] = $cb49fc38cf397002$export$f7f58290278dd286;

});

parcelRegister("dZoX8", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $63668275061fc928$var$_default_1 = (0, $aXWIB.defineMessages)({
    hubLogo: {
        id: "company-hub.hub-app-shell.navbar.hub.logo",
        defaultMessage: "Support home"
    },
    login: {
        id: "company-hub.hub-app-shell.navbar.hub.log-in",
        defaultMessage: "Log in"
    },
    openMenu: {
        id: "company-hub.hub-app-shell.navbar.open-menu.non-final",
        defaultMessage: "Open navigation menu"
    },
    closeMenu: {
        id: "company-hub.hub-app-shell.navbar.close-menu.non-final",
        defaultMessage: "Close navigation menu"
    }
});
var $63668275061fc928$export$2e2bcd8739ae039 = $63668275061fc928$var$_default_1;
module.exports["default"] = $63668275061fc928$export$2e2bcd8739ae039;

});

parcelRegister("9vsU0", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $5GY4f = parcelRequire("5GY4f");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $irOoi = parcelRequire("irOoi");

parcelRequire("cILXD");
var $6SYln = parcelRequire("6SYln");


var $eEA8O = parcelRequire("eEA8O");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $fwDOR = parcelRequire("fwDOR");


var $gqsO5 = parcelRequire("gqsO5");


var $b44o4 = parcelRequire("b44o4");


var $3CrLU = parcelRequire("3CrLU");


var $ahcSt = parcelRequire("ahcSt");


var $lxESh = parcelRequire("lxESh");

const $17071cb9d6c1c418$var$styles = {
    countBadge: "_2rkopb1k _4t3igktf _1ul9gktf _1e0c116y _4cvr1h6o _1bah1h6o _bfhk1aqn _syaz15cr _19bv1b66 _u5f31b66"
};
// network request when the data has already been fetched for this hub.
// Only used when hubs_fix_rerendering_bootstrap_page_media is ON.
const $17071cb9d6c1c418$var$requestCountCache = new Map();
const $17071cb9d6c1c418$var$getCacheKey = (cloudUrl, helpCenterAri)=>`${cloudUrl}::${helpCenterAri}`; /**
                                                                                                   * Test-only helper: clears the module-level request count cache so unit tests
                                                                                                   * can simulate a "first mount with no cached data" scenario without resetting
                                                                                                   * the entire jest module registry.
                                                                                                   */ 
const $17071cb9d6c1c418$export$7a00ed33b23e6d4d = ()=>{
    $17071cb9d6c1c418$var$requestCountCache.clear();
};
const $17071cb9d6c1c418$var$NavLinkItems = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(51);
    const { backgroundColor: t1, requestCount: requestCount, textColor: t2 } = t0;
    const backgroundColor = t1 === undefined ? "var(--ds-background-neutral-bold, #292A2E)" : t1;
    const textColor = t2 === undefined ? "var(--ds-text-inverse, #FFFFFF)" : t2;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { push: push } = (0, $6SYln.useRouterActions)();
    const { cloudId: cloudId, env: t3 } = (0, $gqsO5.useHubContext)();
    const { helpCenterAri: helpCenterAri } = t3;
    let t4;
    if ($[0] !== cloudId || $[1] !== helpCenterAri) {
        t4 = {
            cloudId: cloudId,
            hubAri: helpCenterAri
        };
        $[0] = cloudId;
        $[1] = helpCenterAri;
        $[2] = t4;
    } else t4 = $[2];
    const data = (0, $irOoi.useLazyLoadQuery)((0, $5GY4f.default), t4);
    const helpCenterById = data?.helpCenter?.helpCenterById;
    const helpCenterRef = helpCenterById?.__typename === "HelpCenter" ? helpCenterById : null;
    let t5;
    if ($[3] !== push) {
        t5 = ()=>{
            push("/");
        };
        $[3] = push;
        $[4] = t5;
    } else t5 = $[4];
    const handleHomeClick = t5;
    let t6;
    if ($[5] !== push) {
        t6 = ()=>{
            push("/user/requests");
        };
        $[5] = push;
        $[6] = t6;
    } else t6 = $[6];
    const handleRequestsClick = t6;
    let t7;
    if ($[7] !== push) {
        t7 = ()=>{
            push("/user/approvals");
        };
        $[7] = push;
        $[8] = t7;
    } else t7 = $[8];
    const handleApprovalsClick = t7;
    if (!requestCount || !helpCenterById) return null;
    let t8;
    if ($[9] !== textColor) {
        t8 = {
            color: textColor
        };
        $[9] = textColor;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== formatMessage) {
        t9 = formatMessage((0, $3CrLU.default).home);
        $[11] = formatMessage;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== handleHomeClick || $[14] !== t8 || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            onClick: handleHomeClick,
            style: t8
        }, t9);
        $[13] = handleHomeClick;
        $[14] = t8;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== helpCenterRef || $[18] !== textColor) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxESh.PortalDropdown), {
            queryRef: helpCenterRef,
            textColor: textColor
        });
        $[17] = helpCenterRef;
        $[18] = textColor;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== textColor) {
        t12 = {
            color: textColor
        };
        $[20] = textColor;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== formatMessage) {
        t13 = formatMessage((0, $3CrLU.default).requests);
        $[22] = formatMessage;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== backgroundColor || $[25] !== requestCount.request || $[26] !== textColor) {
        t14 = requestCount.request > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            style: {
                backgroundColor: textColor,
                color: backgroundColor
            },
            xcss: $17071cb9d6c1c418$var$styles.countBadge
        }, requestCount.request);
        $[24] = backgroundColor;
        $[25] = requestCount.request;
        $[26] = textColor;
        $[27] = t14;
    } else t14 = $[27];
    let t15;
    if ($[28] !== t13 || $[29] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.075"
        }, t13, t14);
        $[28] = t13;
        $[29] = t14;
        $[30] = t15;
    } else t15 = $[30];
    let t16;
    if ($[31] !== handleRequestsClick || $[32] !== t12 || $[33] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            onClick: handleRequestsClick,
            style: t12
        }, t15);
        $[31] = handleRequestsClick;
        $[32] = t12;
        $[33] = t15;
        $[34] = t16;
    } else t16 = $[34];
    let t17;
    if ($[35] !== backgroundColor || $[36] !== formatMessage || $[37] !== handleApprovalsClick || $[38] !== requestCount.approvals || $[39] !== requestCount.pendingApprovals || $[40] !== textColor) {
        t17 = (requestCount.approvals > 0 || requestCount.pendingApprovals > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            onClick: handleApprovalsClick,
            style: {
                color: textColor
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.075"
        }, formatMessage((0, $3CrLU.default).approvals), requestCount.pendingApprovals > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            style: {
                backgroundColor: textColor,
                color: backgroundColor
            },
            xcss: $17071cb9d6c1c418$var$styles.countBadge
        }, requestCount.pendingApprovals)));
        $[35] = backgroundColor;
        $[36] = formatMessage;
        $[37] = handleApprovalsClick;
        $[38] = requestCount.approvals;
        $[39] = requestCount.pendingApprovals;
        $[40] = textColor;
        $[41] = t17;
    } else t17 = $[41];
    let t18;
    if ($[42] !== helpCenterRef || $[43] !== textColor) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahcSt.MoreDropdown), {
            queryRef: helpCenterRef,
            textColor: textColor
        });
        $[42] = helpCenterRef;
        $[43] = textColor;
        $[44] = t18;
    } else t18 = $[44];
    let t19;
    if ($[45] !== t10 || $[46] !== t11 || $[47] !== t16 || $[48] !== t17 || $[49] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            testId: "nav-links",
            space: "space.050"
        }, t10, t11, t16, t17, t18);
        $[45] = t10;
        $[46] = t11;
        $[47] = t16;
        $[48] = t17;
        $[49] = t18;
        $[50] = t19;
    } else t19 = $[50];
    return t19;
} : ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", requestCount: requestCount, textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { push: push } = (0, $6SYln.useRouterActions)();
    const { cloudId: cloudId, env: { helpCenterAri: helpCenterAri } } = (0, $gqsO5.useHubContext)();
    const data = (0, $irOoi.useLazyLoadQuery)((0, $5GY4f.default), {
        cloudId: cloudId,
        hubAri: helpCenterAri
    });
    const helpCenterById = data?.helpCenter?.helpCenterById;
    const helpCenterRef = helpCenterById?.__typename === 'HelpCenter' ? helpCenterById : null;
    const handleHomeClick = (0, $42omo.useCallback)(()=>{
        push('/');
    }, [
        push
    ]);
    const handleRequestsClick = (0, $42omo.useCallback)(()=>{
        push('/user/requests');
    }, [
        push
    ]);
    const handleApprovalsClick = (0, $42omo.useCallback)(()=>{
        push('/user/approvals');
    }, [
        push
    ]);
    if (!requestCount || !helpCenterById) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        testId: "nav-links",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: handleHomeClick,
        style: {
            color: textColor
        }
    }, formatMessage((0, $3CrLU.default).home)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxESh.PortalDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: handleRequestsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $3CrLU.default).requests), requestCount.request > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $17071cb9d6c1c418$var$styles.countBadge
    }, requestCount.request))), (requestCount.approvals > 0 || requestCount.pendingApprovals > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: handleApprovalsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $3CrLU.default).approvals), requestCount.pendingApprovals > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $17071cb9d6c1c418$var$styles.countBadge
    }, requestCount.pendingApprovals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahcSt.MoreDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }));
};
const $17071cb9d6c1c418$export$b615cd9717379c80 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { backgroundColor: t1, textColor: t2 } = t0;
    const backgroundColor = t1 === undefined ? "var(--ds-background-neutral-bold, #292A2E)" : t1;
    const textColor = t2 === undefined ? "var(--ds-text-inverse, #FFFFFF)" : t2;
    const { cloudUrl: cloudUrl, env: t3 } = (0, $gqsO5.useHubContext)();
    const { helpCenterAri: helpCenterAri } = t3;
    let t4;
    if ($[0] !== cloudUrl || $[1] !== helpCenterAri) {
        t4 = ()=>(0, $dh538.fg)("hubs_fix_rerendering_bootstrap_page_media") ? $17071cb9d6c1c418$var$requestCountCache.get($17071cb9d6c1c418$var$getCacheKey(cloudUrl, helpCenterAri)) ?? null : null;
        $[0] = cloudUrl;
        $[1] = helpCenterAri;
        $[2] = t4;
    } else t4 = $[2];
    const [requestCount, setRequestCount] = (0, $42omo.useState)(t4);
    let t5;
    let t6;
    if ($[3] !== cloudUrl || $[4] !== helpCenterAri) {
        t5 = ()=>{
            if ((0, $dh538.fg)("hubs_fix_rerendering_bootstrap_page_media")) {
                const cacheKey = $17071cb9d6c1c418$var$getCacheKey(cloudUrl, helpCenterAri);
                const cached = $17071cb9d6c1c418$var$requestCountCache.get(cacheKey);
                (0, $b44o4.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
                    const next = {
                        approvals: data.userRequestsCounts.approvalsCount,
                        pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                        request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
                    };
                    $17071cb9d6c1c418$var$requestCountCache.set(cacheKey, next);
                    setRequestCount(next);
                }).catch(()=>{
                    if (cached) return;
                    const fallback = {
                        approvals: 0,
                        pendingApprovals: 0,
                        request: 0
                    };
                    $17071cb9d6c1c418$var$requestCountCache.set(cacheKey, fallback);
                    setRequestCount(fallback);
                });
            } else (0, $b44o4.getRequestCount)(cloudUrl, helpCenterAri).then((data_0)=>{
                setRequestCount({
                    approvals: data_0.userRequestsCounts.approvalsCount,
                    pendingApprovals: data_0.userRequestsCounts.pendingApprovalsCount,
                    request: data_0.userRequestsCounts.allOpenRequestsCount + data_0.userRequestsCounts.pendingApprovalsCount
                });
            }).catch(()=>{
                setRequestCount({
                    approvals: 0,
                    pendingApprovals: 0,
                    request: 0
                });
            });
        };
        t6 = [
            cloudUrl,
            helpCenterAri
        ];
        $[3] = cloudUrl;
        $[4] = helpCenterAri;
        $[5] = t5;
        $[6] = t6;
    } else {
        t5 = $[5];
        t6 = $[6];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "nav-links-loader"
        });
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== backgroundColor || $[9] !== requestCount || $[10] !== textColor) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: t7
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17071cb9d6c1c418$var$NavLinkItems, {
            textColor: textColor,
            backgroundColor: backgroundColor,
            requestCount: requestCount
        }));
        $[8] = backgroundColor;
        $[9] = requestCount;
        $[10] = textColor;
        $[11] = t8;
    } else t8 = $[11];
    return t8;
} : ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    const { cloudUrl: cloudUrl, env: { helpCenterAri: helpCenterAri } } = (0, $gqsO5.useHubContext)();
    const [requestCount, setRequestCount] = (0, $42omo.useState)(()=>(0, $dh538.fg)('hubs_fix_rerendering_bootstrap_page_media') ? $17071cb9d6c1c418$var$requestCountCache.get($17071cb9d6c1c418$var$getCacheKey(cloudUrl, helpCenterAri)) ?? null : null);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('hubs_fix_rerendering_bootstrap_page_media')) {
            const cacheKey = $17071cb9d6c1c418$var$getCacheKey(cloudUrl, helpCenterAri);
            const cached = $17071cb9d6c1c418$var$requestCountCache.get(cacheKey);
            (0, $b44o4.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
                // Always refresh both the request and approvals counts from the
                // latest API response. The Approvals tab is rendered only when
                // `approvals > 0`, so updating to a fresh value of 0 will
                // correctly remove the tab when there is nothing to show.
                const next = {
                    approvals: data.userRequestsCounts.approvalsCount,
                    pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                    request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
                };
                $17071cb9d6c1c418$var$requestCountCache.set(cacheKey, next);
                setRequestCount(next);
            }).catch(()=>{
                if (cached) // Keep showing the cached values on refresh failure.
                return;
                 // fallback count to zero if request count API fails on first load
                const fallback = {
                    approvals: 0,
                    pendingApprovals: 0,
                    request: 0
                };
                $17071cb9d6c1c418$var$requestCountCache.set(cacheKey, fallback);
                setRequestCount(fallback);
            });
        } else (0, $b44o4.getRequestCount)(cloudUrl, helpCenterAri).then((data_0)=>{
            setRequestCount({
                approvals: data_0.userRequestsCounts.approvalsCount,
                pendingApprovals: data_0.userRequestsCounts.pendingApprovalsCount,
                request: data_0.userRequestsCounts.allOpenRequestsCount + data_0.userRequestsCounts.pendingApprovalsCount
            });
        }).catch(()=>{
            // fallback count to zero if request count API fails
            setRequestCount({
                approvals: 0,
                pendingApprovals: 0,
                request: 0
            });
        });
    }, [
        cloudUrl,
        helpCenterAri
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "nav-links-loader"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17071cb9d6c1c418$var$NavLinkItems, {
        textColor: textColor,
        backgroundColor: backgroundColor,
        requestCount: requestCount
    }));
};
module.exports["NavLinks"] = $17071cb9d6c1c418$export$b615cd9717379c80;

});

parcelRegister("iyju2", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $esRft = parcelRequire("esRft");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $gqsO5 = parcelRequire("gqsO5");

const $507d823c0e403e41$var$styles = {
    displayName: "_11c8fhey",
    root: "_ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi",
    emailText: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq _1e0c1o8l _p12f1lit"
};
const $507d823c0e403e41$export$66e04d0aacdb3b2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(15);
    const { user: user } = (0, $gqsO5.useHubContext)();
    const { avatarSrc: avatarSrc, displayName: displayName, email: email } = user;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            $507d823c0e403e41$var$styles.root
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== avatarSrc) {
        t1 = /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.100"
        }, /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
            appearance: "circle",
            size: "medium",
            src: avatarSrc
        }));
        $[1] = avatarSrc;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            $507d823c0e403e41$var$styles.displayName
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== displayName) {
        t3 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t2
        }, displayName);
        $[4] = displayName;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $gMc0m.default)([
            $507d823c0e403e41$var$styles.emailText
        ]);
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== email) {
        t5 = /*#__PURE__*/ $42omo.createElement("small", {
            className: t4
        }, email);
        $[7] = email;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t3 || $[10] !== t5) {
        t6 = /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), null, t3, t5);
        $[9] = t3;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t1 || $[13] !== t6) {
        t7 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t0
        }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, t1, t6));
        $[12] = t1;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : ()=>{
    const { user: user } = (0, $gqsO5.useHubContext)();
    const { avatarSrc: avatarSrc, displayName: displayName, email: email } = user;
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $507d823c0e403e41$var$styles.root
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), null, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $507d823c0e403e41$var$styles.displayName
        ])
    }, displayName), /*#__PURE__*/ $42omo.createElement("small", {
        className: (0, $gMc0m.default)([
            $507d823c0e403e41$var$styles.emailText
        ])
    }, email))));
};
module.exports["AccountDetails"] = $507d823c0e403e41$export$66e04d0aacdb3b2;

});

parcelRegister("5GY4f", function(module, exports) {
/**
 * @generated SignedSource<<7b1a123d3618f7a9632022151735c34b>>
 * @relayHash e3ab3c07799a07e48aa007432a9e01ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 514323f1394cfa2b2152df0caef6ade5d66a70e35ad4643bcac9ab5b68b507b4
const $90c305b275fffefc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hubAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "portalDropdown_AtlassianHubAppShell"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "moreDropdown_AtlassianHubAppShell"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterPortals",
                                            "kind": "LinkedField",
                                            "name": "portals",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterPortal",
                                                    "kind": "LinkedField",
                                                    "name": "portalsList",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "customPages",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "ids": [],
                                                        "type": "CUSTOM"
                                                    }
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterPageName",
                                                    "kind": "LinkedField",
                                                    "name": "name",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "default"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "514323f1394cfa2b2152df0caef6ade5d66a70e35ad4643bcac9ab5b68b507b4",
            "metadata": {},
            "name": "navLinksQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$90c305b275fffefc$var$node.hash = "5c0f53cb85dff35888c9656687817b29";
var $90c305b275fffefc$export$2e2bcd8739ae039 = $90c305b275fffefc$var$node;
module.exports["default"] = $90c305b275fffefc$export$2e2bcd8739ae039;

});

parcelRegister("3CrLU", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $dc81a9e6bf62194b$var$messages = (0, $aXWIB.defineMessages)({
    downIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.down-icon",
        defaultMessage: "Open dropdown"
    },
    home: {
        id: "company-hub.hub-app-shell.navbar.nav-links.home",
        defaultMessage: "Home"
    },
    more: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more",
        defaultMessage: "More"
    },
    portals: {
        id: "company-hub.hub-app-shell.navbar.nav-links.portals",
        defaultMessage: "Portals"
    },
    requests: {
        id: "company-hub.hub-app-shell.navbar.nav-links.requests",
        defaultMessage: "Requests"
    },
    approvals: {
        id: "company-hub.hub-app-shell.navbar.nav-links.approvals",
        defaultMessage: "Approvals"
    }
});
var $dc81a9e6bf62194b$export$2e2bcd8739ae039 = $dc81a9e6bf62194b$var$messages;
module.exports["default"] = $dc81a9e6bf62194b$export$2e2bcd8739ae039;

});

$parcel$global.rwr("aFBfl", () => { 
var $42omo = parcelRequire("42omo");


var $2FNjD = parcelRequire("2FNjD");


var $egy7N = parcelRequire("egy7N");


var $fXXXK = parcelRequire("fXXXK");


var $4FYDR = parcelRequire("4FYDR");


var $jTxSS = parcelRequire("jTxSS");


var $9HkI0 = parcelRequire("9HkI0");


var $hnvzE = parcelRequire("hnvzE");


var $5QpZa = parcelRequire("5QpZa");


var $5nRL1 = parcelRequire("5nRL1");


var $1iSzD = parcelRequire("1iSzD");


var $lJlG6 = parcelRequire("lJlG6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3ay3Q = parcelRequire("3ay3Q");


var $aanDq = parcelRequire("aanDq");


var $hS38r = parcelRequire("hS38r");

function $7826f8c58773ce67$export$a311cb1baa7d2d62() {
    (0, $hS38r.resourceTimingBuffer).start();
}



var $hPcrh = parcelRequire("hPcrh");


var $04e9M = parcelRequire("04e9M");


var $i7t6K = parcelRequire("i7t6K");


var $2c1Wz = parcelRequire("2c1Wz");

function $dc2c9e680a6dd356$var$findFiberNode(domNode) {
    if (!domNode) return undefined;
    const key = Object.keys(domNode).find((k)=>k.startsWith('__reactFiber$'));
    return key ? domNode[key] : undefined;
}
function $dc2c9e680a6dd356$var$attributionByClosestFiberNode(fiberNode) {
    let current = fiberNode;
    while(current){
        if (current.memoizedProps?.__boundaryMarker) return current.memoizedProps?.attribution ?? 'unknown';
        current = current.return;
    }
    return 'not-attributed';
}
function $dc2c9e680a6dd356$var$toQuerySelector(node) {
    const path = [];
    if (node instanceof HTMLElement) {
        if (node.tagName) path.push(node.tagName.toLowerCase());
        if (node.id) path.push(`#${node.id}`);
        if (node.className) path.push(`.${node.className.split(' ').join('.')}`);
        if (node.dataset) Object.entries(node.dataset).forEach(([key, value])=>{
            path.push(`[data-${key}=${value}]`);
        });
    }
    return path.join('');
}
const $dc2c9e680a6dd356$export$36b44777ebe5656d = (experienceName, clsAttributionConfig)=>{
    const layoutShiftMap = new Map();
    const shifts = (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift].buffer;
    const includeEntries = clsAttributionConfig.includeEntries?.[experienceName] ?? false;
    shifts.forEach((shift)=>{
        shift.sources.forEach((source)=>{
            let hasInsideShift = false;
            let hasOutsideShift = false;
            if (source.previousRect.x !== source.currentRect.x || source.previousRect.y !== source.currentRect.y) hasOutsideShift = true;
            if (source.previousRect.width !== source.currentRect.width || source.previousRect.height !== source.currentRect.height) hasInsideShift = true;
            const getDebugEntry = ()=>({
                    shift: shift.value,
                    hasInsideShift: hasInsideShift,
                    hasOutsideShift: hasOutsideShift,
                    element: source.node ? $dc2c9e680a6dd356$var$toQuerySelector(source.node) : 'undefined'
                });
            const fiberNode = $dc2c9e680a6dd356$var$findFiberNode(source.node);
            const attribution = fiberNode ? $dc2c9e680a6dd356$var$attributionByClosestFiberNode(fiberNode) : 'nonReact';
            if (layoutShiftMap.has(attribution)) {
                const stats = layoutShiftMap.get(attribution);
                stats.totalShift += shift.value;
                if (includeEntries) stats.entries.push(getDebugEntry());
            } else layoutShiftMap.set(attribution, {
                totalShift: shift.value,
                entries: includeEntries ? [
                    getDebugEntry()
                ] : []
            });
        });
    });
    return Object.fromEntries(layoutShiftMap);
};





const $4f467cf502568ccb$export$2d8f8d64dc343d7b = ()=>{
    if (typeof window === 'undefined' || !window.__HYDRATABLE__) return undefined;
    return {
        successful: !window.__HYDRATION_ERRORS__?.length,
        warningCount: 0,
        minWarningComponentDepth: 0,
        maxWarningComponentDepth: 0
    };
};



var $5ZqQS = parcelRequire("5ZqQS");


var $9eE57 = parcelRequire("9eE57");


var $1xpoY = parcelRequire("1xpoY");


var $kGrzq = parcelRequire("kGrzq");

const $ebf4d3ce910d3665$export$6adfe6668ae1a7f8 = (prefix)=>{
    const filteredMarkers = (window.performance?.getEntriesByType?.('mark') || []).filter((marker)=>marker.name.startsWith(prefix));
    filteredMarkers.sort((a, b)=>a.startTime - b.startTime);
    return filteredMarkers;
};
const $ebf4d3ce910d3665$export$a52fc5851be9b858 = (prefix)=>{
    const measures = new (0, $kGrzq.BaseMeasures)();
    for (const { name: name, startTime: startTime } of $ebf4d3ce910d3665$export$6adfe6668ae1a7f8(prefix)){
        const fieldName = name.replace(/\.start|\.end$/, '').replace(prefix, '');
        // Handle multiple pairs of markers due to re-renders
        if (name.endsWith('.start')) measures.markMeasureStart(fieldName, Math.floor(startTime));
        else measures.markMeasureEnd(fieldName, Math.floor(startTime), true);
    }
    const durations = {};
    for (const [name, { duration: duration }] of Object.entries(measures.getMeasures()))durations[name] = duration;
    return durations;
};


function $316168ab5c690743$export$9dbd6bda36500fa9() {
    const entries = (0, $ebf4d3ce910d3665$export$6adfe6668ae1a7f8)('wf/');
    const startTimes = {};
    const timings = {};
    for (const { name: name, startTime: startTime } of entries){
        if (name.endsWith('.start')) {
            const key = name.slice(0, -6);
            startTimes[key] = startTime;
        } else if (name.endsWith('.end')) {
            const key = name.slice(0, -4);
            if (typeof startTimes[key] === 'number') timings[key] = {
                startTime: startTimes[key],
                endTime: startTime
            };
        }
    }
    return timings;
}



var $6VdZc = parcelRequire("6VdZc");


var $8Lf0D = parcelRequire("8Lf0D");

var $jy3Cx = parcelRequire("jy3Cx");


var $5leFG = parcelRequire("5leFG");

const $2ba6133bff070823$export$8c5248f0cec8446d = new (0, $5leFG.EventBus)();


var $80c67148001d6fe8$var$_JSCacheRate;
class $80c67148001d6fe8$export$aca60c726e4e7838 {
    /**
   * Clear Cache
   *
   * Clears all existing cache entries
   */ static clearCache() {
        this.IDs.reset();
        this.Cache.clear();
    }
    /**
   * Compute Cache Rate
   *
   * Iterates the cache looking for the LRU cache compute
   * and creates a new compute based upon the results of
   * it (if it exists). If not, it'll compute cache rate
   * using a bottom-up iteration of loaded assets
   */ static computeCacheRate(time) {
        let lastKey = '';
        const entries = this.Cache.keys;
        const maxIndex = entries.length - 1;
        for(let i = maxIndex; i > -1; i--){
            const key = entries[i];
            const { time: stopTime } = this.Cache.get(key);
            if (time > stopTime) {
                lastKey = key;
                break;
            }
        }
        let newEntry;
        if (lastKey) newEntry = this.mergeFromLastKey(lastKey, time);
        else newEntry = this.iterateResources(time);
        const ID = $80c67148001d6fe8$export$aca60c726e4e7838.IDs.ID();
        $80c67148001d6fe8$export$aca60c726e4e7838.Cache.set(ID, {
            time: time,
            ...newEntry
        });
        return $80c67148001d6fe8$export$aca60c726e4e7838.Cache.get(ID);
    }
    /**
   * Merge From Last Key
   *
   * Combines the LRU cache rate with a cache rate being computed
   */ static mergeFromLastKey(key, time) {
        const { lastIndex: lastIndex, criticalPath: criticalPath } = $80c67148001d6fe8$export$aca60c726e4e7838.Cache.get(key);
        const { lastIndex: newIndex, criticalPath: newCriticalPath } = this.iterateResources(time, lastIndex + 1);
        return {
            lastIndex: newIndex,
            criticalPath: this.merge(criticalPath, newCriticalPath)
        };
    }
    /**
   * Iterate Resources
   *
   * Iterates performance resource timings given a time and from (index)
   * filter. While iterating, this method will accumulate the scripts
   * that have loaded prior to the input time and capture the last index
   * of the final script loaded within that scope
   */ static iterateResources(time, from = 0) {
        const criticalPath = this.criticalPath;
        const resources = window.performance.getEntriesByType('resource');
        const { length: length } = resources;
        let lastIndex = from;
        for(let i = lastIndex; i < length; i++){
            const entry = resources[i];
            if (entry.initiatorType !== 'script' || entry.responseEnd > time) continue;
            lastIndex = i;
            if (entry.transferSize) criticalPath.nonCachedSize += entry.encodedBodySize;
            else {
                criticalPath.cachedCount += 1;
                criticalPath.cachedSize += entry.encodedBodySize;
            }
            criticalPath.totalSize += entry.encodedBodySize;
            criticalPath.scripts.push({
                name: entry.name.split('/').pop() || '',
                start: entry.startTime,
                end: entry.responseEnd,
                size: entry.encodedBodySize
            });
        }
        return {
            criticalPath: criticalPath,
            lastIndex: lastIndex
        };
    }
    /**
   * Critical Path
   *
   * Returns an initialized `CriticalPath` object
   */ static get criticalPath() {
        return {
            scripts: [],
            totalSize: 0,
            cachedCount: 0,
            cachedSize: 0,
            nonCachedSize: 0
        };
    }
    /**
   * Merge
   *
   * Merges the properties of two critical path objects
   */ static merge(cachedCP, newCP) {
        return {
            scripts: cachedCP.scripts.concat(newCP.scripts),
            totalSize: cachedCP.totalSize + newCP.totalSize,
            cachedCount: cachedCP.cachedCount + newCP.cachedCount,
            cachedSize: cachedCP.cachedSize + newCP.cachedSize,
            nonCachedSize: cachedCP.nonCachedSize + newCP.nonCachedSize
        };
    }
}
$80c67148001d6fe8$var$_JSCacheRate = $80c67148001d6fe8$export$aca60c726e4e7838;
$80c67148001d6fe8$export$aca60c726e4e7838.IDs = new (0, $8Lf0D.AutoIncrementingID)();
$80c67148001d6fe8$export$aca60c726e4e7838.Cache = new (0, $jy3Cx.Cache)();
$80c67148001d6fe8$export$aca60c726e4e7838.Listener = (0, $2ba6133bff070823$export$8c5248f0cec8446d).on('page-transition', $80c67148001d6fe8$var$_JSCacheRate.clearCache.bind($80c67148001d6fe8$var$_JSCacheRate));


const $798e13e8b010d13b$export$2ae1dd61fa7d6fb4 = (stop)=>{
    const { criticalPath: { scripts: scripts, totalSize: totalSize, cachedCount: cachedCount, cachedSize: cachedSize, nonCachedSize: nonCachedSize } } = (0, $80c67148001d6fe8$export$aca60c726e4e7838).computeCacheRate(stop);
    return {
        cachedRate: cachedCount / scripts.length * 100,
        count: scripts.length,
        size: totalSize,
        cachedSize: cachedSize,
        nonCachedSize: nonCachedSize,
        sizeBasedCachedRate: cachedSize / (cachedSize + nonCachedSize)
    };
};


const $1f8015dad40e09ac$export$4a5a528f9e4c1e63 = ()=>window.jQuery?.fn?.jquery;


const $8476ac2738811490$export$30c543c9fd9ad97 = ({ stop: stop })=>{
    const customAttributes = {
        initial: (0, $6VdZc.isInitial)(),
        criticalAssets: (0, $798e13e8b010d13b$export$2ae1dd61fa7d6fb4)(stop),
        jqVer: (0, $1f8015dad40e09ac$export$4a5a528f9e4c1e63)()
    };
    return customAttributes;
};


var $lqJ5I = parcelRequire("lqJ5I");

const $894ba807f7f34abc$export$3f2fb183b6cd13c4 = ({})=>{
    // Only track frontend calls, skip during SSR
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (typeof window === 'undefined') return {
        frontendTotalOperations: 0
    };
    const stats = (0, $lqJ5I.networkTracker).getStats();
    return {
        frontendTotalOperations: stats.totalOperations
    };
};


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $4c29a57cb1cefaed$var$isAssets = (x)=>{
    if (typeof x !== 'object' || !x) return false;
    for (const value of Object.values(x)){
        if (typeof value !== 'string') return false;
    }
    return true;
};
const $4c29a57cb1cefaed$var$scriptInitiator = {
    script: true,
    other: true,
    link: true
};
const $4c29a57cb1cefaed$var$criticalChunkPrefixes = {
    'query-preloader': true,
    'translations.en-US': true,
    runtime: true,
    atlaskit: true,
    afp: true,
    static: true,
    vendors: true,
    app: true
};
const $4c29a57cb1cefaed$var$getCachedAssets = ()=>{
    try {
        const assets = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CACHED_ASSETS)) || {};
        if (!$4c29a57cb1cefaed$var$isAssets(assets)) return {};
        return assets;
    } catch  {
        return {};
    }
};
const $4c29a57cb1cefaed$var$updateCachedAssets = (assets)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CACHED_ASSETS, JSON.stringify(assets));
    } catch  {
    // NOOP
    }
};
const $4c29a57cb1cefaed$export$445ccb86da5ca9ca = (endTime)=>{
    const cachedChunks = $4c29a57cb1cefaed$var$getCachedAssets();
    const loadedChunks = {};
    const criticalChunks = {};
    let totalChunkCount = 0;
    performance.getEntriesByType('resource').forEach((entry)=>{
        const { initiatorType: initiatorType, responseEnd: responseEnd, duration: duration, name: name } = entry;
        // Discard non-scripts and scripts that were loaded after the end time
        if (!$4c29a57cb1cefaed$var$scriptInitiator[initiatorType] || responseEnd > endTime) return;
        const chunkName = name.split('/').pop();
        if (!chunkName) return;
        const chunkPrefix = chunkName.split('~').shift();
        if (!chunkPrefix) return;
        // Match loaded chunk name with cached chunk name for all critical chunks
        if ($4c29a57cb1cefaed$var$criticalChunkPrefixes[chunkPrefix]) {
            loadedChunks[chunkPrefix] = chunkName;
            criticalChunks[chunkPrefix] = {
                cached: cachedChunks[chunkPrefix] === chunkName,
                duration: duration
            };
        }
        totalChunkCount++;
    });
    $4c29a57cb1cefaed$var$updateCachedAssets(loadedChunks);
    return {
        criticalChunks: criticalChunks,
        totalChunkCount: totalChunkCount
    };
};









var $dtDUi = parcelRequire("dtDUi");










const $ac2afaf945b706af$var$getElementSelector = (element)=>{
    if (!element || !element.tagName) return 'n/a';
    const selector = `${element.tagName.toLowerCase()}.${element.className?.split(' ').join('.')}`;
    if (element.dataset?.testid) return `${selector}[data-testid="${element.dataset?.testid}"]`;
    return selector;
};
const $ac2afaf945b706af$export$2980a1865b8e55dd = (hydrationErrors)=>{
    let loggingConfig = {};
    try {
        loggingConfig = JSON.parse((0, $1xpoY.default).getString('confluence_hydration_error_logging', '{}'));
    } catch  {
    // no-op, if an error occurs here, there's really nowhere to submit it
    }
    return hydrationErrors.reduce((accumulator, error)=>{
        if (!error.type || !error.msg) return accumulator;
        // Log selectors for mismatched hydration errors. The presense of parentNode or parent
        // depend on actual hydration error / patch used.
        const finalParent = error.parent || error.parentNode;
        if (loggingConfig.selectors && (finalParent || error.child)) {
            if (!accumulator.selectors) accumulator.selectors = '';
            const parent = finalParent ? $ac2afaf945b706af$var$getElementSelector(finalParent) : 'n/a';
            const child = error.child ? $ac2afaf945b706af$var$getElementSelector(error.child) : 'n/a';
            accumulator.selectors += `${parent}->${child}; `;
        }
        // For UNSAFE_TEXT_MISMATCH errors, only track the count
        // Don't log the actual text content as it contains sensitive data
        // Similarly, UNSAFE_CLIENT_MISMATCH and UNSAFE_SERVER_MISMATCH contain user content in text nodes
        if (loggingConfig.errors) {
            if (error.type === 'UNSAFE_TEXT_MISMATCH') accumulator.unsafeTextMismatches = (accumulator.unsafeTextMismatches || 0) + 1;
            else if (error.type === 'UNSAFE_CLIENT_MISMATCH') accumulator.unsafeClientMismatches = (accumulator.unsafeClientMismatches || 0) + 1;
            else if (error.type === 'UNSAFE_SERVER_MISMATCH') accumulator.unsafeServerMismatches = (accumulator.unsafeServerMismatches || 0) + 1;
            else {
                if (!accumulator[error.type]) accumulator[error.type] = '';
                accumulator[error.type] += (accumulator[error.type] ? ' ; ' : '') + error.msg;
            }
        }
        // Add error stack
        if (loggingConfig.stack && error.stack) {
            if (!accumulator.stack) accumulator.stack = '';
            accumulator.stack += `Stack: ${error.stack} \n`;
        }
        return accumulator;
    }, {});
};

const $58d4f470662e1918$export$494b6359b6a45bfd = ()=>{
    const heightChanges = window?.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__;
    const result = {
        initialHeight: window?.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0,
        changes: heightChanges?.length || 0
    };
    if (heightChanges?.length) result.finalHeight = heightChanges[heightChanges.length - 1];
    return result;
};


var $lXQLs = parcelRequire("lXQLs");



const $ca8fa84470cae806$var$REACT_ERROR_421_PATTERN = /Minified React error #421/;
const $ca8fa84470cae806$var$REACT_ERROR_423_PATTERN = /Minified React error #423/;
const $ca8fa84470cae806$export$c3747700ebedb58c = (error)=>{
    if (!error.type) return null;
    const baseType = error.type.startsWith('UNSAFE_') ? error.type.slice(7) : error.type;
    if (baseType === 'ERROR_MESSAGES_FROM_REACT' && error.msg && (0, $9wGTI.fg)('confluence_frontend_sfx_hydration_errors')) {
        if ($ca8fa84470cae806$var$REACT_ERROR_421_PATTERN.test(error.msg)) return 'SUSPENSE_UPDATE';
        if ($ca8fa84470cae806$var$REACT_ERROR_423_PATTERN.test(error.msg)) return 'ROOT_RERENDER';
    }
    return baseType;
};
const $ca8fa84470cae806$export$92d14dc1fbc3f3a3 = (hydrationErrors)=>{
    const counts = {};
    for (const error of hydrationErrors){
        const normalizedType = $ca8fa84470cae806$export$c3747700ebedb58c(error);
        if (normalizedType) counts[normalizedType] = (counts[normalizedType] || 0) + 1;
    }
    return counts;
};

const $32c078c7f61fe0e3$export$d966f1e92068ec2e = (stats)=>{
    if (!stats) return {
        totalLinks: 0,
        totalResolved: 0
    };
    const { links: links } = stats;
    let totalLinks = 0;
    let totalResolved = 0;
    Object.values(links).forEach((byAppearance)=>{
        Object.values(byAppearance).forEach(({ total: total, resolved: resolved })=>{
            totalLinks += total;
            totalResolved += resolved;
        });
    });
    return {
        totalLinks: totalLinks,
        totalResolved: totalResolved
    };
};

const $8b39c089fbdae2d5$export$96934690d8345a62 = (obj)=>{
    if (typeof obj !== 'object' || !obj) return {};
    const recursivelyBuildCustomValues = (obj)=>{
        const customValues = {};
        Object.entries(obj).forEach(([key, value])=>{
            if (Array.isArray(value)) customValues[key] = value.map((e)=>JSON.stringify(e)).join(',');
            else if (typeof value === 'object' && value) {
                const nestedValues = recursivelyBuildCustomValues(value);
                Object.entries(nestedValues).forEach(([nestedKey, nestedValue])=>{
                    customValues[`${key}:${nestedKey}`] = nestedValue;
                });
            } else {
                if (typeof value === 'number') customValues[key] = Math.round(value);
                else if (typeof value === 'boolean') customValues[key] = value;
                else customValues[key] = String(value);
            }
        });
        return customValues;
    };
    return recursivelyBuildCustomValues(obj);
};



function $31b0fb0fb1951a4c$var$limitTop10(obj) {
    return Object.fromEntries(Object.entries(obj).sort((a, b)=>b[1] - a[1]).slice(0, 10));
}
const $31b0fb0fb1951a4c$export$7908ff149a3cbadd = ({ stop: stop })=>{
    const customAttributes = {
        transitionId: (0, $6VdZc.browserMetricsState).transitionId,
        // HTTP protocol used to fetch resources
        // Use multiple domains for http/1.1 users
        // Set in packages/confluence-frontend-server/templates/generator.js
        domainSharding: Boolean(window.__GET_CC_ASSET_URL),
        // HTTP protocol used to fetch resources
        httpProtocol: (0, $lXQLs.getHTTPProtocol)(performance.getEntriesByType('resource')),
        // Add the critical path JS assets size stats
        criticalAssets: (0, $798e13e8b010d13b$export$2ae1dd61fa7d6fb4)(stop),
        // Send stats on expensive queries and unnecessary watches
        apolloDiffStoreStats: (0, $8b39c089fbdae2d5$export$96934690d8345a62)($31b0fb0fb1951a4c$var$limitTop10(window?.__APOLLO_STATS__?.diffStore || {}))
    };
    Object.entries((0, $ebf4d3ce910d3665$export$a52fc5851be9b858)('CFP-63.')).forEach(([fieldName, value])=>{
        customAttributes[`cfp63Durations:${fieldName}`] = value;
    });
    if ((0, $6VdZc.browserMetricsState).transitionId === 0) {
        const navigationTimings = window.performance.getEntriesByType('navigation');
        if (navigationTimings.length) {
            // TypeScript isn't returning the proper type for this, so some
            // casting here
            const firstTiming = navigationTimings[0];
            if (firstTiming.transferSize != null) customAttributes.pageLoadedFromCache = firstTiming.transferSize === 0;
        }
        // Record the current version of jQuery
        customAttributes.jqVer = window.jQuery?.fn?.jquery;
        // Record if page is rendered by React SSR service
        customAttributes.ssr = Boolean(window.__SSR_RENDERED__);
        // Some SSR render errors (e.g.: edit page content area failed to SSR) are considered critical even when window.__SSR_RENDERED__ is true
        customAttributes.ssrHasCriticalError = Boolean(window.__SSR_HAS_CRITICAL_ERROR__);
        customAttributes.ssrTraceId = window.__SSR_TRACE_ID__ ?? '';
        // only send ssr macro metrics if there is at least one macro on the SSRd page
        if (window?.__SSR_MACROS_INFO__) customAttributes.ssrMacrosInfo = window.__SSR_MACROS_INFO__;
        if (window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__) customAttributes.macrosPreloadFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
        // Record user clicks and intent to click on SSR placeholder elements
        customAttributes.ssrInteractions = window?.__SSR_INTERACTIONS__ || {};
        // @ts-ignore `__SSR_INTERACTIONS_DURATIONS__` maintains an array of numbers, but browser-metrics doesn't really accept arrays. Might make sense to comma-join the values
        customAttributes.ssrInteractionsDurations = window?.__SSR_INTERACTIONS_DURATIONS__ || {};
        customAttributes.ssrQueryTimeouts = window?.__SSR_QUERY_TIMEOUTS__ || {};
        customAttributes.ssrPartialSuccess = window?.__SSR_PARTIAL_SUCCESS__ || {};
        if (window?.__SSR_STREAM_END__) customAttributes.ssrStreamEnd = window.__SSR_STREAM_END__;
        customAttributes.reactStreaming = window.__SSR_REACT_STREAMING__ || false;
        // Record loadable ids that timed out
        customAttributes.loadableTimeouts = Array.from(new Set(window?.__LOADABLE_TIMEOUTS__ || [])).join(',');
        if (window?.__HYDRATION_ERRORS__) {
            customAttributes.hydrationErrors = (0, $ac2afaf945b706af$export$2980a1865b8e55dd)(window.__HYDRATION_ERRORS__);
            if ((0, $1xpoY.default).getBoolean('confluence_hydration_error_type_logging', false)) customAttributes.hydrationErrorCounts = (0, $ca8fa84470cae806$export$92d14dc1fbc3f3a3)(window.__HYDRATION_ERRORS__);
            if (window?.__HYDRATION_FAILED__ && (0, $9wGTI.fg)('confluence_frontend_sfx_hydration_errors')) {
                const { route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
                window.__HYDRATION_ERRORS__.forEach((error)=>{
                    const normalizedType = (0, $ca8fa84470cae806$export$c3747700ebedb58c)(error);
                    if (normalizedType) monitoringClient.incrementCounter('hydrationErrorCount', [
                        `type:${normalizedType}`,
                        `route:${route}`
                    ]);
                });
            }
        }
        customAttributes.hydratable = window?.__HYDRATABLE__ || false;
        customAttributes.hydrationFailed = window?.__HYDRATION_FAILED__ || false;
        // Record the number of SSRed elements
        customAttributes.totalSSRedElements = window?.__TOTAL_SSR_ELEMENTS__ || 0;
        if (window?.__SSR_SMARTLINKS_STATS__) customAttributes.ssrSmartLinksStats = (0, $32c078c7f61fe0e3$export$d966f1e92068ec2e)(window.__SSR_SMARTLINKS_STATS__);
        if (window?.__SSR_SHORTCUTS_STATS__) customAttributes.ssrShortcutsStats = window.__SSR_SHORTCUTS_STATS__;
        if (window?.__SSR_SMARTLINKS_ICON_DIFF__) customAttributes.ssrSmartlinksIconDiff = window.__SSR_SMARTLINKS_ICON_DIFF__;
        // Calculates which query is the long pole, as well as its duration
        customAttributes.longPoleQuery = window?.__SSR_LONG_POLE_QUERY__ || {};
        // Node counts from AK renderer, available in fabric only
        customAttributes.rendererNodesCount = window?.__RENDERER_NODES_COUNT__ || {};
        customAttributes.remoteLocalStorage = window?.__REMOTE_LOCAL_STORAGE__?.length || 0;
        customAttributes.wrmKeys = window?.__WRM_KEYS__ || {};
        customAttributes.connectAppKeys = (window?.__APP_KEYS__ || []).join(',');
        customAttributes.atlGeneralHeightChanges = (0, $8b39c089fbdae2d5$export$96934690d8345a62)((0, $58d4f470662e1918$export$494b6359b6a45bfd)());
        // Add the caching status of each asset
        const cacheStatus = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
            cacheStatus: (0, $4c29a57cb1cefaed$export$445ccb86da5ca9ca)(stop)
        });
        for (const [key, value] of Object.entries(cacheStatus))customAttributes[key] = value;
    }
    return customAttributes;
};

const $47229cc534a9628f$export$79c58f8fef22ebf2 = ()=>{
    const customAttributes = {
        ssrRegion: window.__SSR_REGION__ ?? ''
    };
    return customAttributes;
};



var $eSuZj = parcelRequire("eSuZj");


var $68uaC = parcelRequire("68uaC");

const $65f6d9e9d3e9996f$export$3def7672244bab0c = ()=>{
    const ssrTTRMark = performance?.getEntriesByName('CFP-63.ssr-ttr');
    if (!ssrTTRMark || !ssrTTRMark[0]) return undefined;
    // rounded to the nearest integer as the VC component log only uses integers as keys
    return Math.round(ssrTTRMark[0].startTime);
};
const $65f6d9e9d3e9996f$export$bf7408e83532dcd0 = ()=>{
    if (!window.__SSR_MEASURES__) return [];
    const ssrTimings = Object.keys(window.__SSR_MEASURES__).map((key)=>{
        return {
            label: key,
            data: window.__SSR_MEASURES__[key]
        };
    });
    return ssrTimings || [];
};


const $535b2ac93dbeac9a$export$4ace2d93f0a81ca0 = ()=>typeof window === 'undefined' ? 'na' : window.__SSR_STICKY_VERSION_STATE__ ?? 'na';


const $18160efac3c2d8a9$var$SSR_STACK_COOKIE_NAME = 'cc-ssr-stack';
const $18160efac3c2d8a9$var$getIsBifrost = ()=>{
    const ssrStack = (0, $68uaC.Cookies).get($18160efac3c2d8a9$var$SSR_STACK_COOKIE_NAME);
    if (ssrStack !== undefined) {
        (0, $68uaC.Cookies).remove($18160efac3c2d8a9$var$SSR_STACK_COOKIE_NAME, {
            path: '/'
        });
        return ssrStack === 'bifrost';
    }
    return undefined;
};
const $18160efac3c2d8a9$export$8f5840779a8ebb97 = (interaction, otherMetadataFromSessionData)=>{
    let fmpPatch = {};
    if (interaction.type === 'page_load') {
        Object.entries((0, $316168ab5c690743$export$9dbd6bda36500fa9)()).forEach(([key, value])=>{
            interaction.customTimings.push({
                labelStack: [],
                data: {
                    [key]: value
                }
            });
        });
        // In UFO realm, there's seemingly a bug causing `metric:fmp` to be populated in ~10-15%
        // of cases probably due to some race condition. Adding it here as a fallback until
        // investigation with #help-devinfra-fe-observability is completed.
        // Covered by ticket https://product-fabric.atlassian.net/browse/CCP-7117
        const fmpTime = (0, $65f6d9e9d3e9996f$export$3def7672244bab0c)();
        if (fmpTime) fmpPatch = {
            'metric:fmp': fmpTime
        };
    } else if (interaction.type === 'transition') {
        // For transitions, FMP is tracked via the UFOTransitionMarkFMP component which places
        // an 'fmp' custom mark on the interaction. We read the mark time and compute the
        // relative FMP as the offset from interaction start.
        const fmpMark = interaction.marks.find((mark)=>mark.type === 'custom' && mark.name === 'fmp');
        if (fmpMark) fmpPatch = {
            'metric:fmp': Math.round(fmpMark.time - interaction.start)
        };
    }
    const buildInfoData = (0, $eSuZj.getBuildInfo)();
    const buildInfo = {};
    if (buildInfoData) {
        Object.keys(buildInfoData).forEach((item)=>{
            const newKey = `buildInfo:${item}`;
            buildInfo[newKey] = buildInfoData[item];
        });
        // If the short-lived SSR stack cookie is present, trust it over the
        // bootstrapped build info. This covers Bifrost -> monolith fallback reloads
        // and also prevents a stale Bifrost value from being reused after this read.
        const isBifrost = $18160efac3c2d8a9$var$getIsBifrost();
        if (isBifrost !== undefined) buildInfo['buildInfo:IS_BIFROST'] = isBifrost;
    }
    const data = {
        ...(0, $31b0fb0fb1951a4c$export$7908ff149a3cbadd)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $8476ac2738811490$export$30c543c9fd9ad97)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $894ba807f7f34abc$export$3f2fb183b6cd13c4)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $47229cc534a9628f$export$79c58f8fef22ebf2)(),
        ...buildInfo,
        ...otherMetadataFromSessionData,
        'stickyVersions:state': (0, $535b2ac93dbeac9a$export$4ace2d93f0a81ca0)(),
        postOfficeAssetsDisplayed: window.__PO_ASSET_DISPLAYED__
    };
    return {
        ...fmpPatch,
        confluence: data
    };
};




var $lMdlY = parcelRequire("lMdlY");




function $9d8d828ea9fa0be5$export$29dd34cf1269f6da(traceId) {
    return !!traceId && /^[a-z0-9]+$/i.test(traceId) && traceId.length >= 16;
}
function $9d8d828ea9fa0be5$export$47cd5ebc723ead8d() {
    const traceId = window.__SSR_TRACE_ID__;
    const traceSampled = window.__SSR_TRACE_SAMPLED__;
    // Only enable trace propagation if the trace is sampled unless the gate disables this check.
    // Keep per-request unique traceIds for prod traffic until we have the x-request-id solution.
    // See: https://hello.atlassian.net/wiki/spaces/~71202065d425fcbfb345c9a5639940cc3845bb/pages/4187050054/Trace+Propagation+Across+an+Experience
    if (!traceSampled) {
        if (!(0, $9wGTI.fg)('confluence_disable_ufo_trace_sampling_check')) return;
    }
    const validTraceId = $9d8d828ea9fa0be5$export$29dd34cf1269f6da(traceId) ? traceId : undefined;
    const validSpanId = validTraceId ? validTraceId.substring(validTraceId.length - 16) : undefined;
    // If the traceId is invalid, we ignore it and don't set the trace context.
    // This would fallback to default behavior where trace context is not propagated.
    if (validTraceId && validSpanId) (0, $lMdlY.setActiveTrace)(validTraceId, validSpanId, '' /* trace type param is unused */ );
}


const $7d85b53d694de3c0$export$5fc9317dcf7889c3 = {
    sanitiseEndpoints: (url)=>url,
    mapResources: (url)=>url,
    hasTimingHeaders: (url)=>url.includes('graphql')
};


const $30ba73f8286a8f5a$export$69f5225124bf14a6 = {
    typingMethod: 'timeout',
    kind: {
        hover: 0,
        legacy: 0,
        typing: 0,
        press: 1,
        page_load: 1,
        transition: 1,
        generic: 0
    },
    rates: {
        unknown: 1000
    },
    removeInteractionsUFOPrefixes: true,
    enableEditorLnvHandler: true,
    autoGeneratedRate: 1000,
    rules: [],
    awaitBM3TTI: [],
    ufoNameOverrides: {},
    killswitch: [],
    segmentPrefix: 'ufo-',
    enabled: true,
    doNotAbortActivePressInteraction: [],
    doNotAbortActivePressInteractionOnTransition: [],
    enableCompleteUsingDoubleRAF: true,
    capability: {
        feature_flag_access: 1,
        react_profiler: 1
    },
    namePrefix: 'ufo-',
    removePageSegmentsUFOPrefixes: false
};
const $30ba73f8286a8f5a$var$getConfig = (configName)=>{
    try {
        return JSON.parse((0, $1xpoY.default).getString(configName, ''));
    } catch  {
        // TODO: AFO-4167: Change the fallback to be `{}` once we have a stable config for FedRamp environment
        return $30ba73f8286a8f5a$export$69f5225124bf14a6;
    }
};
function $30ba73f8286a8f5a$var$runConfigureSsrTiming() {
    (0, $hPcrh.configure)({
        getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
        // from confluence/next/packages/browser-metrics/src/initializeBrowserMetrics.ts
        // TODO: add correct functions to `getTimings` and `getFeatureFlags`
        getTimings: ()=>null,
        getFeatureFlags: ()=>null
    });
}
function $30ba73f8286a8f5a$export$6381c51f97ce9880({ shard: shard, cloudId: cloudId }) {
    const config = (0, $9wGTI.fg)('ufo-use-statsig-config-confluence-new') ? $30ba73f8286a8f5a$var$getConfig('confluence_ufo_config') : $30ba73f8286a8f5a$export$69f5225124bf14a6;
    if (!config?.enabled) return;
    (0, $aanDq.configure)((0, $7d85b53d694de3c0$export$5fc9317dcf7889c3));
    (0, $7826f8c58773ce67$export$a311cb1baa7d2d62)();
    $30ba73f8286a8f5a$var$runConfigureSsrTiming();
    (0, $9d8d828ea9fa0be5$export$47cd5ebc723ead8d)();
    const perfPushExperienceRates = {
        'view-page': 1,
        'edit-page': 1,
        'live-edit': 1,
        'space-overview': 1,
        'confluence-home': 1,
        'advanced-search': 1,
        'unified-search': 1,
        'embedded-view-page': 1,
        'embedded-live-edit': 1,
        'edit-page-embed': 1,
        'whiteboard-view-page': 1,
        'database-view-page': 1,
        'public-link-shared-page': 1
    };
    const assetsConfig = {
        classification: {
            all: true,
            allAtlassian: ({ entry: entry })=>entry.name.includes('atl-paas.net/') || entry.name.includes('cloudfront') && entry.name.includes('batch.js'),
            preloaded: ({ entry: entry, SSRDoneTime: SSRDoneTime })=>Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime)
        }
    };
    (0, $3ay3Q.init)((0, $04e9M.getAnalyticsWebClient)(), {
        postInteractionLog: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        extraInteractionMetrics: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        enableSegmentHighlighting: false,
        enableAdditionalPerformanceMarks: false,
        shouldCalculateLighthouseMetricsFromTTAI: true,
        manuallyTrackReactProfilerMounts: true,
        product: 'confluence',
        population: (0, $1xpoY.default).getString('cc_ufo_group', 'unknown'),
        region: shard || 'unknown',
        getReactHydrationStats: (0, $9wGTI.fg)('confluence_frontend_enable_hydration_stats') ? (0, $4f467cf502568ccb$export$2d8f8d64dc343d7b) : undefined,
        ...config,
        // vc config must come after ...config spread to prevent the Statsig dynamic config
        // from overwriting locally-controlled settings (e.g. enabledVCRevisions).
        vc: {
            ...config?.vc,
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            selectorConfig: {
                id: false,
                role: false,
                className: true,
                testId: true
            },
            devToolsEnabled: (0, $1xpoY.default).isKillSwitchOn('confluence_enable_ttvc_devtool'),
            enabledVCRevisions: {
                all: (0, $9wGTI.fg)('ufo_disable_ttvc_v4') ? [] : [
                    'fy26.04'
                ]
            },
            includeSSRInV3: true,
            includeSSRRatio: true,
            trackLayoutShiftOffenders: (0, $9wGTI.fg)('confluence_vc_track_layout_shift_offenders')
        },
        minorInteractions: [
            'space-navigation-hover',
            'hover-page-card'
        ],
        ssr: {
            getSSRDoneTime: $65f6d9e9d3e9996f$export$3def7672244bab0c,
            getSSRTimings: $65f6d9e9d3e9996f$export$bf7408e83532dcd0
        },
        additionalPayloadData: (interaction)=>(0, $18160efac3c2d8a9$export$8f5840779a8ebb97)(interaction, {
                cloudId: cloudId,
                isShardPreProd: shard ? shard.startsWith('conf-prod-us-preprod') : false,
                layoutShiftWithAttribution: (0, $dc2c9e680a6dd356$export$36b44777ebe5656d)(interaction.ufoName, $30ba73f8286a8f5a$var$getConfig('confluence_cls_attribution_config'))
            }),
        extraSearchPageInteraction: {
            enabled: true,
            searchPageMetricName: 'unified_search',
            searchPageRoute: '/wiki/search'
        },
        enableBetterPageVisibilityApi: (0, $9wGTI.fg)('confluence_enable_better_page_visibility'),
        assetsConfig: assetsConfig
    });
    // When client-side TTVC calculation is disabled, the __on_ufo_vc_debug_data_ready callback
    // is never called (no VC calculators run). Listen for UFO_FINISH_INTERACTION instead to
    // ensure __TTVC_READY__ is set and Apollo stats are still reported on interaction completion.
    if (typeof window !== 'undefined') window.addEventListener('UFO_FINISH_INTERACTION', ()=>{
        if (!(0, $9wGTI.fg)('ufo_disable_ttvc_v4')) return;
        $30ba73f8286a8f5a$var$reportApolloDiffStoreStats();
        // @ts-ignore
        window.__TTVC_READY__ = true;
    }, {
        once: true
    });
}
// Helper: report Apollo diffStore stats to monitoring
function $30ba73f8286a8f5a$var$reportApolloDiffStoreStats() {
    const apolloStats = window['__APOLLO_STATS__'];
    if (apolloStats?.diffStore) {
        const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
        const entries = Object.entries(apolloStats?.diffStore).sort((a, b)=>b[1] - a[1]).slice(0, 10);
        for (const [query, value] of entries)// cc_fe_telemetry_apolloDiffStore in SFX
        monitoringClient.gauge(`apolloDiffStore`, value, [
            `query:${query}`
        ]);
    }
}
// UFO library emits mutation debug data once it is available. Debug data includes all mutations listed in the UFO dev tools,
// as well as includes a UFO traceId that can be linked to UFO (BM) page load event
// https://hello.atlassian.net/wiki/spaces/APD/pages/5398802024/RUNBOOK+Emitting+and+receiving+TTVC+debug+data+from+UFO
if (typeof window !== 'undefined') // @ts-ignore
window.__on_ufo_vc_debug_data_ready = function(data) {
    // only send debug data when revision is in the allowed list
    const allowedRevisionList = (0, $1xpoY.default).getStringList('confluence_debug_data_revision_config', []);
    if (data?.revision && data?.isClean && allowedRevisionList.includes(data.revision) && (0, $9wGTI.fg)('confluence_emit_v3_debug_data')) {
        const payload = {
            source: 'confluenceRoot',
            action: 'emitted',
            actionSubject: 'debugDataV3',
            attributes: {
                ...data
            },
            eventType: 'operational'
        };
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
            analyticsClient.sendOperationalEvent(payload);
        });
    }
    // When TTVC v4 client-side calculation is active (flag off), Apollo stats fire here.
    // When it's disabled (flag on), they fire via UFO_FINISH_INTERACTION instead.
    if (!(0, $9wGTI.fg)('ufo_disable_ttvc_v4')) $30ba73f8286a8f5a$var$reportApolloDiffStoreStats();
    // This is to inform external tools/tests that page finished loading and "performance measured" events were emitted.
    // @ts-ignore
    window.__TTVC_READY__ = true;
};



var $2v1PW = parcelRequire("2v1PW");







function $e8bac4b2464d29b3$export$77f9905a9b9e760d(_sessionData) {
    (0, $2v1PW.init)({
        getAnalyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
        experiences: {
            'edit-page': {
                enabled: true
            },
            'live-edit': {
                enabled: true
            }
        },
        population: (0, $1xpoY.default).getString('cc_ufo_group', 'unknown')
    });
}






var $c6GJD = parcelRequire("c6GJD");


var $3kTfj = parcelRequire("3kTfj");

















var $7W8i8 = parcelRequire("7W8i8");


var $hpjl4 = parcelRequire("hpjl4");

const $b48399af2cf0b1aa$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $hpjl4.JS_LOAD_START))) return {
            name: mark.substring(0, mark.indexOf((0, $hpjl4.JS_LOAD_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $hpjl4.JS_LOAD_END))) return {
            name: mark.substring(0, mark.indexOf((0, $hpjl4.JS_LOAD_END))),
            type: 'end'
        };
        return null;
    }
};



var $j4jXg = parcelRequire("j4jXg");




// used for page-load and page-segment-load events
const $a7aad5d0a1d87072$export$eb13033bc77c7e96 = [
    'confluence.ssr.page-statuses',
    'confluence_react_streaming',
    'confluence_frontend_vc_observer_initialization',
    'confluence_frontend_remove_comments_placeholder',
    'enable_loadable_placeholder_for_legacy_macros',
    'edition_awareness_standard_upsell_confluence_ab',
    'edition_awareness_standard_upsell_confluence_ab_fg',
    'platform-ssr-table-resize',
    'confluence_frontend_content_wrapper',
    'content_early_connect_iframe_initialization',
    'confluence_emit_v3_debug_data',
    'nav4_confluence_global_links',
    'confluence_use_atlaspack',
    'confluence_use_atlaspack_variant_1',
    'confluence_use_atlaspack_variant_2',
    'platform_ufo_exclude_3p_extensions_from_ttvc',
    'confluence_frontend_v2_removal',
    'confluence_frontend_statlas_redirect',
    'confluence_frontend_enable_react_dom_context_patch',
    'confluence_exclude_children_macro_from_blocklist',
    'confluence_use_react-compiler',
    'confluence_enable_2p_toolbar_apps',
    'confluence_ssr_cookie_banner_black_space',
    'cc-engagement-omnibar-hide-inline-comments',
    'cc-engagement-omnibar-hide-highlight-actions',
    'cc-engagement-omnibar-hide-sidebar-flyout'
];
const $a7aad5d0a1d87072$export$e669174961337a38 = [];



var $78QFu = parcelRequire("78QFu");

const $105e628ab69b7692$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const clsData = {
        score: 0,
        nodeCounts: {}
    };
    const allLayoutShifts = buffer.getAll();
    const layoutShifts = allLayoutShifts.filter(// Filter for layoutShifts within start and stop time and if entry had no recent user input (which can cause CLS)
    (entry)=>entry.startTime >= start && entry.startTime <= stop && !entry.hadRecentInput);
    const sessionWindows = [];
    let currentWindow = null;
    // Record CLS offenderes by node type
    layoutShifts.forEach((layoutShift)=>{
        layoutShift.sources.forEach((source)=>{
            const { node: node } = source;
            const nodeKey = `${node?.localName || '-'}(:)${node?.className || '-'}`;
            const count = clsData.nodeCounts[nodeKey];
            if (count > 0) clsData.nodeCounts[nodeKey] += 1;
            else clsData.nodeCounts[nodeKey] = 1;
        });
    });
    // Group layout shifts into session windows and calculate score
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric rounded to 4 decimal places
    clsData.score = Math.round(maxScore * 10000) / 10000;
    return clsData;
};


const $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $f69af1ee3d00be57$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter(// filter entries that are long tasks (greater than MAX_ACCEPTABLE_TASK_DURATION)
    // and overlap with the start and stop window in any way
    (entry)=>entry.startTime <= stop && entry.duration > $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // accumulate observed tbt even when the entry's duration is outside the stop window
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION;
        // accumulate total tbt within start and stop window
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });


const $35573fd923792093$export$f878c419d6dfad3e = 10;
const $35573fd923792093$var$getEstimatedP98LongestInteraction = (interactionEvents)=>{
    const sortedInteractions = [
        ...interactionEvents
    ].sort((a, b)=>b.duration - a.duration);
    sortedInteractions.splice($35573fd923792093$export$f878c419d6dfad3e);
    // If we have an usually high number of interactions,
    // ignore the longest interaction and take the next one.
    // https://web.dev/articles/inp#what-is-inp -> "Details on how INP is calculated"
    const p98Index = Math.min(sortedInteractions.length - 1, Math.floor(interactionEvents.length / 50));
    return {
        p98: sortedInteractions[p98Index],
        interactionCount: sortedInteractions.length
    };
};
const $35573fd923792093$export$6693a9916ea977ef = (start, stop, buffer)=>{
    const inpData = {
        score: 0,
        interactionCounts: {}
    };
    const allEvents = buffer.getAll();
    const interactionEvents = allEvents.filter((entry)=>entry.startTime >= start && entry.startTime <= stop && entry.entryType !== 'first-input' && //@ts-ignore for some reason our Typecheck says this property doesn't exist but its in the reference https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEventTiming
        entry.interactionId);
    if (interactionEvents.length) {
        const { p98: p98, interactionCount: interactionCount } = $35573fd923792093$var$getEstimatedP98LongestInteraction(interactionEvents);
        inpData.score = p98.duration;
        inpData.interactionCounts = interactionCount;
    }
    return inpData;
};








// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 




const $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $6947188617eea69c$export$b7f047fd73089148 = (start, stop, buffer)=>buffer.getAll().filter(// filter entries that are long tasks (greater than MAX_ACCEPTABLE_TASK_DURATION)
    (entry)=>entry.duration > $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((longTaskTiming, entry)=>{
        longTaskTiming += entry.duration - $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION;
        return longTaskTiming;
    }, 0);






var $eDAGu = parcelRequire("eDAGu");

const $21a76cadeda71c1e$export$1391212d75b2ee65 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $21a76cadeda71c1e$export$b46cecdf698e4bb5 = async ({ start: start, stop: stop })=>{
    // PerformanceObserver is not deterministic in reporting entries, so a 500ms delay is needed
    // 500ms was tested in Jira and it captured enough data without causing a volume drop in reported events
    await $21a76cadeda71c1e$export$1391212d75b2ee65(500);
    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $105e628ab69b7692$export$fc6227831ee7c7)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]);
    const longTaskTiming = (0, $6947188617eea69c$export$b7f047fd73089148)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    const metrics = {
        'metric:tbt': Math.round(tbt.total),
        // sum of blocking time for long tasks within the 'start' and 'stop' time
        'metric:tbt:observed': Math.round(tbt.observed),
        // sum of blocking time for long tasks that might end beyond the 'stop' time
        'metric:cls': cls.score,
        'metric:clsNodeCounts': cls.nodeCounts,
        'metric:longTaskTiming': Math.round(longTaskTiming)
    };
    return metrics;
};


const $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS = 8000;
const $834cc9c1e99eabd0$export$d4724968c3d7ea5 = async ({ start: start, stop: stop })=>{
    const webVitalsAttributes = {
        uuid: (0, $78QFu.getUniquePageLoadId)().uuid ?? ''
    };
    // wait for 8 seconds to calculate CLS to account for macros causing page layout shifts
    await (0, $21a76cadeda71c1e$export$1391212d75b2ee65)($834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS);
    const cls = (0, $105e628ab69b7692$export$fc6227831ee7c7)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]);
    // for slow pages, TTI is marked too early which causes TBT numbers to be inaccurate so we extend the stop time
    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    const inp = (0, $35573fd923792093$export$6693a9916ea977ef)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).Event]);
    webVitalsAttributes['metric:inpForInitialLoad'] = inp.score;
    webVitalsAttributes['metric:clsForInitialLoad'] = cls.score;
    webVitalsAttributes['metric:clsOffendersForInitialLoad'] = cls.nodeCounts;
    webVitalsAttributes['metric:tbtForInitialLoad'] = Math.round(tbt.total); // sum of blocking time for long tasks within the 'start' and 'stop' time
    return webVitalsAttributes;
};





const $eaeb1ca3a97f458a$export$e3f9d1444e2c5f5d = (sessionData)=>{
    const { cloudId: cloudId, environment: environment, shard: shard } = sessionData;
    const plugins = [];
    plugins.push((0, $21a76cadeda71c1e$export$b46cecdf698e4bb5));
    /**
	 * https://product-fabric.atlassian.net/browse/CCP-1320
	 * Remove unused attributes in page-segment-load event
	 */ const buildInfo = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
        buildInfo: (0, $eSuZj.getBuildInfo)()
    });
    /**
	 * Data to be added to all events.
	 */ const allEventConfig = {
        custom: (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
            cloudId: cloudId,
            environment: environment,
            shard: shard,
            ssr: Boolean(window.__SSR_RENDERED__)
        }),
        featureFlags: (0, $a7aad5d0a1d87072$export$e669174961337a38),
        sfxEvents: {
            activeTab: (0, $j4jXg.PageVisibleFields).pageVisibleState
        },
        plugins: plugins
    };
    /**
	 * Data to be added to only page-load events.
	 */ const pageLoadEventConfig = {
        custom: buildInfo,
        plugins: [
            (0, $31b0fb0fb1951a4c$export$7908ff149a3cbadd),
            (0, $47229cc534a9628f$export$79c58f8fef22ebf2),
            (0, $894ba807f7f34abc$export$3f2fb183b6cd13c4)
        ],
        histogram: {
            initial: {
                fmp: '1000_2000_2500_3000_4000_5000',
                tti: '2000_2500_3000_3500_4000_5000_6000'
            },
            transition: {
                fmp: '500_1000_1500_2000_2500_3000',
                tti: '1000_1500_2000_2500_3000_4000'
            }
        },
        // page-load type event will include allEventConfig.featureFlags + the following list.
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96)
    };
    /**
	 * Data to be added to only custom events.
	 */ const pageSegmentLoadEventConfig = {
        plugins: [
            (0, $8476ac2738811490$export$30c543c9fd9ad97),
            (0, $47229cc534a9628f$export$79c58f8fef22ebf2)
        ],
        histogram: {
            initial: {
                fmp: '1000_2000_2500_3000_4000_5000',
                tti: '2000_2500_3000_3500_4000_5000_6000'
            },
            transition: {
                fmp: '500_1000_1500_2000_2500_3000',
                tti: '1000_1500_2000_2500_3000_4000'
            }
        },
        // page-segment-load type event will include allEventConfig.featureFlags + the following list.
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96),
        enableBundleEvalTimings: false
    };
    const customEventConfig = {
        custom: buildInfo,
        plugins: [
            (0, $8476ac2738811490$export$30c543c9fd9ad97)
        ]
    };
    const webVitalsConfig = {
        custom: buildInfo,
        enabled: true,
        plugins: [
            (0, $834cc9c1e99eabd0$export$d4724968c3d7ea5)
        ],
        // Undefined timeout defaults to 30000ms, increasing timeout here on Cypress tests to prevent flakiness.
        timeout: window?.Cypress ? undefined : 10000,
        ttciEnabled: false,
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96)
    };
    return {
        all: allEventConfig,
        [(0, $j4jXg.BMEventsType).PAGE_LOAD]: pageLoadEventConfig,
        [(0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD]: pageSegmentLoadEventConfig,
        [(0, $j4jXg.BMEventsType).CUSTOM]: customEventConfig,
        [(0, $j4jXg.BMEventsType).WEB_VITALS]: webVitalsConfig
    };
};





let $ae045ed661bc53ec$var$isBrowserMetricsInitialized = false;
const $ae045ed661bc53ec$var$logger = (0, $7W8i8.getLogger)('initializeBrowserMetrics');
const $ae045ed661bc53ec$var$criticalAssetsList = [
    'app',
    'atl',
    'runtime',
    'vendors',
    'ssr-scripts',
    'stable_vendors',
    'query-preloader',
    'browser-not-supported'
];
function $ae045ed661bc53ec$var$mapResources(url) {
    return $ae045ed661bc53ec$var$criticalAssetsList.find((asset)=>url.includes(`/${asset}.`)) || 'ignored';
}

const $ae045ed661bc53ec$export$efcab8bd082cbc1f = (sessionData)=>{
    if (!$ae045ed661bc53ec$var$isBrowserMetricsInitialized) {
        const { shard: shard } = sessionData;
        const getAnalyticsWebClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const product = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? 'embeddedConfluence' : 'confluence';
        (parcelRequire("5j7rq")).then((ufo)=>ufo.setup(sessionData, getAnalyticsWebClientPromise)).catch((error)=>{
            $ae045ed661bc53ec$var$logger.error`Fail to import UFO client: ${error}`;
        });
        (0, $eDAGu.startLightHouseObservers)();
        (0, $3kTfj.browserMetrics).init({
            info: {
                app: {
                    framework: {
                        name: 'react',
                        version: (0, $42omo.version)
                    },
                    version: {
                        web: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
                        ssr: window.__SSR_BUILD__
                    }
                },
                hostname: window.location.hostname,
                product: product,
                population: (0, $1xpoY.default).getString('cc_ufo_group', 'unknown'),
                region: shard
            },
            plugins: {
                featureFlags: {
                    client: Promise.resolve({
                        getValue: (featureFlagKey)=>{
                            // Using `FeatureGates.checkGate` here to avoid triggering exposure tracking
                            // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
                            return (0, $c6GJD.default).checkGate(featureFlagKey);
                        }
                    })
                },
                resourceTimings: {
                    mapResources: $ae045ed661bc53ec$var$mapResources,
                    // Not interested in fetch requests as we have already marked wf/
                    sanitiseEndpoints: ()=>'ignored'
                },
                bundleEvalTimings: $b48399af2cf0b1aa$export$1a2bb347935fc536
            },
            endpoints: {
                eventPipelineClient: getAnalyticsWebClientPromise
            },
            events: (0, $eaeb1ca3a97f458a$export$e3f9d1444e2c5f5d)(sessionData),
            ssr: {
                getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
                getTimings: ()=>window.__SSR_MEASURES__ || {}
            },
            enableReactUFOTracker: true
        });
        $ae045ed661bc53ec$var$isBrowserMetricsInitialized = true;
    }
};



var $KcDWk = parcelRequire("KcDWk");


var $iC5L0 = parcelRequire("iC5L0");


var $hp2SH = parcelRequire("hp2SH");


var $9PBjm = parcelRequire("9PBjm");


var $gKr8t = parcelRequire("gKr8t");



function $0b6b84530a4d34b5$export$b4a2d416bf2548b() {
    return 0, $gKr8t.apolloAGGCache;
}



var $9HB34 = parcelRequire("9HB34");


var $ezH4I = parcelRequire("ezH4I");

var $3GQl6 = parcelRequire("3GQl6");


var $hZpML = parcelRequire("hZpML");





var $cMvQV = parcelRequire("cMvQV");


var $9j59h = parcelRequire("9j59h");




var $lTjel = parcelRequire("lTjel");









/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 


const $db1172108b431747$export$bc237d627614fc48 = `!function(e,t){const n=t.__SSR_INTERACTIONS__={},i=t.__SSR_INTERACTIONS_DURATIONS__={},o=t.__SSR_EVENT_LISTENERS__=[];Array.from(e.getElementsByClassName("ssrMouseEvent")).forEach((t=>{t.previousSibling&&((t,s)=>{if(!t||!s)return;const r=e=>{if(!e)return!1;if(e.disabled)return!0;let t=!1;for(let n=0;n<e.childNodes.length;n++)if(r(e.childNodes[n])){t=!0;break}return t};if(r(t)){var c;const n=e.createElement("div");n.style.cssText="display: inline-block; position: relative;",n.setAttribute("data-testid","".concat(s,"_CLICK_CONTAINER"));const i=e.createElement("div");i.style.cssText="content: ''; position: absolute; top: 0; left: 0; bottom: 0; right: 0;",i.setAttribute("data-testid","".concat(s,"_CLICK_AREA")),null===(c=t.parentElement)||void 0===c||c.replaceChild(n,t),n.append(t),n.append(i),t=i}const a=e=>{n[e]=!0,i[e]=[...i[e]||[],performance.now()]};let l,d=!1;const u=()=>{a("".concat(s,"_CLICK"))},_=()=>{d=!0,l=setTimeout((function(){d&&(a("".concat(s,"_HOVER")),d=!1)}),100)},E=()=>{l&&clearTimeout(l),d=!1};t.addEventListener("click",u,!0),t.addEventListener("mouseenter",_),t.addEventListener("mouseleave",E),o.push([t,"click",u,!0]),o.push([t,"mouseenter",_,void 0]),o.push([t,"mouseleave",E,void 0])})(t.previousSibling,t.value)}))}(document,window);`;


const $c07037197fae7cb7$export$a6f691eaa46471c3 = ()=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        dangerouslySetInnerHTML: {
            __html: `if(window["__SSR_RENDERED__"]){${(0, $db1172108b431747$export$bc237d627614fc48)}}`
        }
    });
};



var $frIzR = parcelRequire("frIzR");










const $ab36569cbfed18a7$export$857c9d19bfa05cb5 = (t0)=>{
    const $ = (0, $frIzR.c)(1);
    if (!window.__SSR_INLINE_COMMENT_MARKS__ || window.__SSR_INLINE_COMMENT_MARKS__ && window.__SSR_INLINE_COMMENT_MARKS__.length < 1) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "inline-comments-script",
            "data-testid": "inline-comments-script",
            "data-marks": window.__SSR_INLINE_COMMENT_MARKS__,
            "data-focused": window.__SSR_FOCUSED_INLINE_COMMENTS__
        });
        $[0] = t1;
    } else t1 = $[0];
    return t1;
};


const $2eff8a40a60fa79f$export$708921e5c63e07ae = (t0)=>{
    const $ = (0, $frIzR.c)(1);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab36569cbfed18a7$export$857c9d19bfa05cb5), null);
        $[0] = t1;
    } else t1 = $[0];
    return t1;
};








function $a6e2c333ce8dee1c$export$d2cb5cf8969d339e() {
    const script = `window.performance.mark("${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_FORCE_LAYOUT}.start");` + // Accessing clientHeight causes the browser to perform a synchronous layout recalculation.
    // While this doesn't directly trigger a "paint" operation, it increases the likelihood of one
    // occurring shortly afterward. This means it is less likely that users will see a partially
    // painted screen while the browser processes imported JavaScript modules.
    `window.document.documentElement.clientHeight;` + `window.performance.mark("${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_FORCE_LAYOUT}.end")`;
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: script
        }
    });
}


const $8714b2bec379cfae$export$bd148a921cde8da1 = ()=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6e2c333ce8dee1c$export$d2cb5cf8969d339e), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SSR_SCRIPTS}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c07037197fae7cb7$export$a6f691eaa46471c3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2eff8a40a60fa79f$export$708921e5c63e07ae), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SSR_SCRIPTS}.end`), !window.__SSR_REACT_STREAMING__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            // Suppress error when performance API failed.
            // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
            // That's why wrap with try catch statement.
            __html: 'if(window["__SSR_RENDERED__"]){try{window.performance.mark("CFP-63.ssr-ttr");window.performance.measure("browser-metric:fmp",undefined,"CFP-63.ssr-ttr")}catch(e){}}'
        }
    }));
};







/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 



var $dh538 = parcelRequire("dh538");


var $a9dFP = parcelRequire("a9dFP");


var $ajqJ5 = parcelRequire("ajqJ5");

/**
 * Provides a script that, when executed before paint, sets the `data-color-mode` attribute based on the current system theme,
 * to enable SSR support for automatic theme switching, avoid a flash of un-themed content on first paint.
 *
 * @param {string} colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 *
 * @returns {string} A string to be added to the innerHTML of a script tag in the document head
 */ const $1f244cc9b266328f$var$getSSRAutoScript = (colorMode, contrastMode)=>{
    if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
    const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $ajqJ5.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $a9dFP.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
    const setContrastMode = contrastMode === 'auto' && (0, $dh538.fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $ajqJ5.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $a9dFP.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
    return `(() => {${setColorMode}${setContrastMode}})()`;
};
var $1f244cc9b266328f$export$2e2bcd8739ae039 = $1f244cc9b266328f$var$getSSRAutoScript;


var $hY0xh = parcelRequire("hY0xh");

var $geGFh = parcelRequire("geGFh");


var $58u2L = parcelRequire("58u2L");

class $60061fec709c0fa4$export$f9bc2ffe605f0ec0 {
    setThemeStateBasedOnSavedThemeState(theme) {
        // If theme is undefined, no reason to set that in themeState as it's not actually a theme (just Original)
        if (theme) this.themeState = {
            ...this.getThemeState(),
            ...theme,
            typography: 'typography'
        };
    }
    getThemeState() {
        return this.themeState;
    }
    async getThemeStylesScript() {
        // Generates an array of styles
        if (this.getThemeState().colorMode) {
            const modifiedThemeState = {
                ...this.getThemeState(),
                typography: 'typography'
            };
            const themeStyles = await (0, $geGFh.default)(modifiedThemeState);
            // Add a stylesheet for each theme being used
            return themeStyles.map((theme)=>{
                const attributes = Object.entries(theme.attrs).map(([key, value])=>`${key}="${value}"`);
                return `<style ${attributes}>${theme.css}</style>`;
            }).join('');
        } else return '';
    }
    getSSRAutoColorModeScript() {
        // Creates and returns the script used to set the html attributes if the user choose 'auto'
        const currentColorMode = this.getThemeState().colorMode;
        if (currentColorMode === 'auto') {
            const nonceValue = window.__SSR_NONCE_VALUE__;
            const scriptContent = (0, $1f244cc9b266328f$export$2e2bcd8739ae039)(currentColorMode);
            return nonceValue !== undefined ? `<script nonce="${nonceValue}">${scriptContent}</script>` : `<script>${scriptContent}</script>`;
        } else return '';
    }
    getThemeHtmlAttrsScript({ forceAuto: forceAuto = false } = {}) {
        // Simple script to add theme attributes to HTML tag based on users codeMode selection
        const currentThemeState = this.getThemeState();
        if (currentThemeState.colorMode) {
            const themeAttrs = (0, $hY0xh.default)(currentThemeState);
            if (currentThemeState.colorMode === 'auto' || forceAuto) /*
               If the colorMode is auto, we don't want to just default to "light" because if the user's
               browser setting is "dark", this would set the "data-color-mode" to "light" and then set
               again with "dark" with the script from getSSRAutoColorModeScript(). Removing the "data-color-mode"
               setAttribute for "auto" makes sure that it is only set once by the getSSRAutoColorModeScript()
             */ delete themeAttrs['data-color-mode'];
            const attributeSetters = Object.entries(themeAttrs).map(([attr, value])=>`document?.documentElement?.setAttribute("${attr}", "${value}");`).join('');
            return `try { ${attributeSetters} } catch (e) {}`;
        } else return '';
    }
    constructor(){
        this.themeState = void 0;
        // If colorMode doesn't get set, you don't want to return anything
        this.themeState = (0, $58u2L.getDefaultTheme)();
    }
}


const $cad415a4c0599362$export$fd920a796bc0c5e = new (0, $60061fec709c0fa4$export$f9bc2ffe605f0ec0)();



var $bj5fB = parcelRequire("bj5fB");

const $ef8ede6c338f8be6$export$6838ff380832204f = ({ uri: uri })=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)(uri);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        dangerouslySetInnerHTML: {
            __html: `if(window["__SSR_RENDERED__"]){${(0, $cad415a4c0599362$export$fd920a796bc0c5e).getThemeHtmlAttrsScript({
                forceAuto: isMobileApp
            })}}`
        }
    });
};


const $d847caf3274d14b7$export$f3385cdc6645f7e3 = ({ uri: uri })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_THEME_INIT}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ef8ede6c338f8be6$export$6838ff380832204f), {
        uri: uri
    }), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_THEME_INIT}.end`));







const $799291abed68198f$export$640957ec8f6fdf34 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_REACT_ROOT}.start`), children, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_REACT_ROOT}.end`));
};


// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $irVI7 = parcelRequire("irVI7");


var $dYU3e = parcelRequire("dYU3e");


var $emNvf = parcelRequire("emNvf");

function $c63485f681d81d31$export$693b572d94b96722() {
    return (0, $dYU3e.query)({
        query: (0, $emNvf.default),
        __callerPackage__: "@confluence/page-layout"
    });
}



var $lyWac = parcelRequire("lyWac");


var $xwvlW = parcelRequire("xwvlW");











var $bPDOf = parcelRequire("bPDOf");


var $8Z78B = parcelRequire("8Z78B");

const $07b476ef513689d8$export$e5077e9c81abf107 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};



var $hAiCi = parcelRequire("hAiCi");





var $74VX5 = parcelRequire("74VX5");

const $b7ee762a3100e127$export$18585825cd8ca022 = ()=>{
    return (0, $dYU3e.queryAgg)({
        query: (0, $74VX5.default),
        __callerPackage__: "@confluence/app-navigation"
    });
};


async function $a6a4fe9083f3db22$export$d46e9819bcc1eb51() {
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    const topNavigationPromises = [
        (0, $dYU3e.query)({
            query: (0, $hAiCi.default),
            __callerPackage__: "@confluence/app-navigation"
        })
    ];
    if ((0, $9wGTI.fg)('aifc_create_enabled')) topNavigationPromises.push((0, $07b476ef513689d8$export$e5077e9c81abf107)());
    if (userId) topNavigationPromises.push((0, $b7ee762a3100e127$export$18585825cd8ca022)());
    return (0, $lyWac.waitForAllReturnWhenError)(topNavigationPromises);
}


function $1d20c0a68123b7f2$export$2d0f6d5aa0911699() {
    return (0, $a6a4fe9083f3db22$export$d46e9819bcc1eb51)();
}









/**
 * @generated SignedSource<<4578650f7a6fe4e1474f11e8181e051b>>
 * @relayHash 21354ce056af321d3c9a22d041061cbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 995f0038c2de9764a22d6b1084f25ff437d0af79bc8d777102ec6b571d9ec00a
const $c79c1229f6775c21$var$node = function() {
    var v0 = [
        {
            "concreteType": "SiteOperations",
            "kind": "LinkedField",
            "name": "siteOperations",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "userProfile"
                },
                {
                    "kind": "ScalarField",
                    "name": "application"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadOperationsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadOperationsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "21354ce056af321d3c9a22d041061cbd",
            "id": "995f0038c2de9764a22d6b1084f25ff437d0af79bc8d777102ec6b571d9ec00a",
            "metadata": {},
            "name": "preloadOperationsQuery",
            "operationKind": "query",
            "text": "query preloadOperationsQuery{siteOperations{userProfile,application}}"
        }
    };
}();
$c79c1229f6775c21$var$node.hash = "abad04e66f2fedacc515f8a26b1558e3";
var $c79c1229f6775c21$export$2e2bcd8739ae039 = $c79c1229f6775c21$var$node;


async function $969a3e14c27be3bd$export$9930aa21f1e6a4e3() {
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!userId) return;
    return (0, $dYU3e.query)({
        query: (0, $c79c1229f6775c21$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/site-operations"
    });
}



var $eiCiP = parcelRequire("eiCiP");


var $9fLxI = parcelRequire("9fLxI");





var $eqB7W = parcelRequire("eqB7W");


var $b1ypt = parcelRequire("b1ypt");

function $88b2ba3b9422ec6a$export$3837c35a0d92ab93() {
    const macroParams = window['__LEGACY_MACRO_PARAMS__'] || [];
    window['__LEGACY_MACRO_PARAMS__'] = [];
    // eslint-disable-next-line check-preloaders/no-promise-all
    return Promise.all(macroParams.map(({ isMacroContentAndBody: isMacroContentAndBody, ...rest })=>{
        return isMacroContentAndBody ? (0, $dYU3e.query)({
            query: (0, $eqB7W.default),
            variables: rest,
            context: {
                single: true
            },
            __callerPackage__: "@confluence/fabric-extension-handlers"
        }) : (0, $dYU3e.query)({
            query: (0, $b1ypt.default),
            variables: rest,
            context: {
                single: true
            },
            __callerPackage__: "@confluence/fabric-extension-handlers"
        });
    }));
}






var $iHLZT = parcelRequire("iHLZT");


var $l6Xaz = parcelRequire("l6Xaz");


var $d1d56 = parcelRequire("d1d56");

async function $821e100427ee88aa$export$ce64f7b5556cdb62({ preloadSuperBatchForSSR: preloadSuperBatchForSSR = false } = {}) {
    if (preloadSuperBatchForSSR) {
        const superbatchData = await (0, $dYU3e.query)({
            query: (0, $d1d56.default),
            __callerPackage__: "@confluence/wrm"
        });
        const resourceList = superbatchData?.data?.internalFrontendResource?.resourceList || [];
        const { js: js, css: css } = resourceList.reduce((acc, resource)=>{
            const html = (0, $l6Xaz.convertSuperBatchResourceToTags)(resource);
            acc[resource.type].push(html);
            return acc;
        }, {
            js: [],
            css: []
        });
        (0, $iHLZT.superbatchJSRecorder).add((0, $l6Xaz.removeJquery)(js.join('\n')));
        (0, $iHLZT.superbatchCSSRecorder).add(css.join('\n'));
    } else if (!window.__SUPERBATCH_REQUESTED__) return (0, $dYU3e.query)({
        query: (0, $d1d56.default),
        __callerPackage__: "@confluence/wrm"
    });
    return Promise.resolve();
}



var $6gmJj = parcelRequire("6gmJj");


var $hvqgK = parcelRequire("hvqgK");


var $9WAeG = parcelRequire("9WAeG");








var $f7B1p = parcelRequire("f7B1p");


var $3mugH = parcelRequire("3mugH");


var $d6NtA = parcelRequire("d6NtA");


var $60cDW = parcelRequire("60cDW");


var $cgNzK = parcelRequire("cgNzK");




const $29df517881fdeca7$export$c2d188ccf9271ffd = 'CookiePreferencesQuery';
const $29df517881fdeca7$var$preloadCookiePreferencesForBanner = async ()=>{
    if (window.__COOKIE_CONSENT_PREFERENCES__) return window.__COOKIE_CONSENT_PREFERENCES__;
    const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, userId: userId, perimeter: perimeter, isBifrostIcRequest: isBifrostIcRequest, environment: environment, confluenceBrowserStorageControls: confluenceBrowserStorageControls } = (0, $60cDW.getSSRRenderInputs)();
    // If the consent token cookie exists (user has already set their preferences), there is no need to
    // fetch the preferences from ConsentHub.
    if (cookiesConsentToken) {
        window.__COOKIE_CONSENT_PREFERENCES__ = {
            consentToken: cookiesConsentToken,
            ...cookiesFallbackToken ? {
                fallbackConsentToken: cookiesFallbackToken
            } : {}
        };
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    if (!userId) {
        if ((0, $9wGTI.fg)('platform_moonjelly_bsc_ssr_banner_flash_fix')) {
            // For anonymous users, if only the fallback token exists (the primary consent token has
            // expired but the long-lived fallback is still present), include the fallback as a consent
            // signal so that SSR and client hydration make consistent banner visibility decisions.
            const anonymousConsentToken = (0, $hvqgK.serializeConsents)({});
            if (!anonymousConsentToken && !cookiesFallbackToken) {
                window.__COOKIE_CONSENT_PREFERENCES__ = null;
                return window.__COOKIE_CONSENT_PREFERENCES__;
            }
            window.__COOKIE_CONSENT_PREFERENCES__ = {
                ...anonymousConsentToken ? {
                    consentToken: anonymousConsentToken
                } : {},
                ...cookiesFallbackToken ? {
                    fallbackConsentToken: cookiesFallbackToken
                } : {}
            };
            return window.__COOKIE_CONSENT_PREFERENCES__;
        }
        // Legacy path (gate off): does not include fallbackConsentToken for anonymous users
        const consentToken = (0, $hvqgK.serializeConsents)({});
        window.__COOKIE_CONSENT_PREFERENCES__ = consentToken ? {
            consentToken: consentToken
        } : null;
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    if (perimeter === 'fedramp-moderate' || isBifrostIcRequest === true && (0, $6mKj3.expVal)('confluence_ssr_bifrost_ic', 'isEnabled', false)) {
        window.__COOKIE_CONSENT_PREFERENCES__ = null;
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    if (confluenceBrowserStorageControls && !environment) {
        window.__COOKIE_CONSENT_PREFERENCES__ = null;
        (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Cannot preload Cookie Consent Preferences: missing environment'));
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    const env = confluenceBrowserStorageControls ? environment : (0, $xwvlW.getPreloaderFnContext)().environment;
    const hostEnv = env === 'PRODUCTION' ? 'prod' : 'staging';
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:CookieConsentPreferences', async ()=>{
        let result = null;
        const isLocalPillar = (0, $d6NtA.isLocal)();
        const url = isLocalPillar ? '/gateway/api/consenthub/session/user/consents/cookies' : `https://atl-preferences-center-elb.${hostEnv}.atl-paas.net/rest/user/${userId}/consents/cookies`;
        try {
            const res = await (0, $f7B1p.cfetch)(url, (0, $cgNzK.constructCompatibleRequestInit)({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                    ...Boolean(undefined) && Boolean(undefined) && !isLocalPillar ? {
                        'x-ssr-service-name': 'atl-preferences-center'
                    } : {}
                },
                credentials: 'include'
            }));
            if (!res.ok) throw new Error(`Cannot load Cookie Consent Preferences: ${res.statusText}`);
            result = await res.json();
        } catch (e) {
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Fetching cookie preferences failed: ${e.message}`));
        }
        if (result && Object.keys(result).length) {
            window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign({}, result, {
                fallbackConsentToken: cookiesFallbackToken
            });
            return window.__COOKIE_CONSENT_PREFERENCES__;
        } else {
            window.__COOKIE_CONSENT_PREFERENCES__ = null;
            return window.__COOKIE_CONSENT_PREFERENCES__;
        }
    });
};
const $29df517881fdeca7$var$getCookiePreferencesForBanner = ()=>{
    if (window.__COOKIE_CONSENT_PREFERENCES__ !== undefined) return Promise.resolve(window.__COOKIE_CONSENT_PREFERENCES__);
    if (!window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__) window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__ = $29df517881fdeca7$var$preloadCookiePreferencesForBanner().finally(()=>{
        window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__ = null;
    });
    return window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__;
};
const $29df517881fdeca7$export$990c5eb6cb59ce1c = async ()=>{
    const { confluenceBrowserStorageControls: confluenceBrowserStorageControls } = (0, $60cDW.getSSRRenderInputs)();
    if (!confluenceBrowserStorageControls) return $29df517881fdeca7$var$preloadCookiePreferencesForBanner();
    const cookiePreferences = await $29df517881fdeca7$var$getCookiePreferencesForBanner();
    if (window.__PRELOADED_COOKIE_PREFERENCES__ === undefined) {
        const { prefs: prefs } = (0, $6gmJj.initializePreferencesData)(cookiePreferences ?? undefined);
        window.__PRELOADED_COOKIE_PREFERENCES__ = prefs ?? null;
    }
    return cookiePreferences;
};








parcelRequire("8nle6");
var $5SzHz = parcelRequire("5SzHz");





var $eS4vC = parcelRequire("eS4vC");

// When firing preload functions we don't have experience tracker started thus we can only annotate the request through URL match
function $df23aac6d1130849$export$7388eaba0b85ff24(exp) {
    window['GLOBAL_FALLBACK_ATL_EXP'] = exp;
}













var $lesra = parcelRequire("lesra");




/**
 * @generated SignedSource<<665e9f622479d8b8a25b05a0d8f0fe94>>
 * @relayHash fe3341ed930f93ccf29cba79d0a71a5f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd2b05a3bb62454654b6b992f1679f4ed4910edc57ce1d395f4c143c40888dc2
const $83b1dd2d3bda0ead$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isNotLicensed"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "suggestion"
    }, v2 = {
        "kind": "ScalarField",
        "name": "dismissalDateTime"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "condition": "isNotLicensed",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "shouldShowCardOnPageTreeHover"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "feedRecommendedUserSettingsDismissTimestamp"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userSpacesNotifiedOfExternalCollab"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "favouriteTemplateEntityIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "homePagesDisplayView"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "feedType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "feedTab"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recentFilter"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "missionControlOverview"
                        },
                        {
                            "concreteType": "MissionControlMetricSuggestionState",
                            "kind": "LinkedField",
                            "name": "missionControlMetricSuggestions",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ConfluenceEditorSettings",
                            "kind": "LinkedField",
                            "name": "confluenceEditorSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "toolbarDockingInitialPosition"
                                }
                            ]
                        },
                        {
                            "concreteType": "MissionControlFeatureDiscoverySuggestionState",
                            "kind": "LinkedField",
                            "name": "missionControlFeatureDiscoverySuggestions",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "globalPageCardAppearancePreference"
                        },
                        {
                            "concreteType": "HomeWidget",
                            "kind": "LinkedField",
                            "name": "homeWidgets",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isHomeOnboardingDismissed"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "theme"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "watchMyOwnContent"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "commentsPanelSorting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCommentsPanelAutomaticSummariesEnabled"
                        },
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "userKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "date"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserSettingsQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserSettingsQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "fe3341ed930f93ccf29cba79d0a71a5f",
            "id": "fd2b05a3bb62454654b6b992f1679f4ed4910edc57ce1d395f4c143c40888dc2",
            "metadata": {},
            "name": "UserSettingsQuery",
            "operationKind": "query",
            "text": "query UserSettingsQuery($isNotLicensed:Boolean!){userPreferences@skip(if:$isNotLicensed){shouldShowCardOnPageTreeHover,feedRecommendedUserSettingsDismissTimestamp,userSpacesNotifiedOfExternalCollab,favouriteTemplateEntityIds,homePagesDisplayView,feedType,feedTab,recentFilter,missionControlOverview,missionControlMetricSuggestions{suggestion,value,dismissalDateTime},confluenceEditorSettings{toolbarDockingInitialPosition},missionControlFeatureDiscoverySuggestions{suggestion,dismissalDateTime},globalPageCardAppearancePreference,homeWidgets{id,state,__typename},isHomeOnboardingDismissed,theme,watchMyOwnContent,commentsPanelSorting,isCommentsPanelAutomaticSummariesEnabled,__typename},featureDiscovery{pluginKey,featureKey,userKey,date}}"
        }
    };
}();
$83b1dd2d3bda0ead$var$node.hash = "3c17a61cf39923f903a643933ae0bf4d";
var $83b1dd2d3bda0ead$export$2e2bcd8739ae039 = $83b1dd2d3bda0ead$var$node;









var $arxGM = parcelRequire("arxGM");


var $dBy7h = parcelRequire("dBy7h");

const $fb5b21f5b81a7b59$export$8ff552280f2680c = async ()=>{
    const { cloudId: cloudId, activationId: activationId, userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    // Can only fetch shared theme when we have all required params
    if (!userId || !cloudId || !activationId) return null;
    try {
        const workspaceAri = (0, $dBy7h.getWorkspaceARI)({
            cloudId: cloudId,
            activationId: activationId
        });
        const response = await (0, $dYU3e.queryAgg)({
            query: (0, $arxGM.default),
            variables: {
                workspaceAri: workspaceAri,
                accountId: userId
            },
            __callerPackage__: "@confluence/preload-storage-queries"
        });
        const theme = response?.data?.settings_userPreferencesResolved?.theme;
        return theme === undefined ? null : theme;
    } catch  {
        // Errors are handled by waitForAllReturnWhenError in the parent function
        return null;
    }
};


const $96ee7afaced2313e$export$758dd268a3743917 = 'default';
const $96ee7afaced2313e$export$e0e94d96f49a1aa = async ({ themeState: themeState })=>{
    const { isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn) return;
    // Apply themeState immediately if provided via query param (always defined for embedded pages)
    if (themeState) (0, $cad415a4c0599362$export$fd920a796bc0c5e).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(decodeURIComponent(themeState)));
    // Always fetch user settings
    // When shared-user-preferences flag is on, also fetch the workspace theme from AGG in parallel
    const userSettingsPromise = (0, $dYU3e.query)({
        query: (0, $83b1dd2d3bda0ead$export$2e2bcd8739ae039),
        variables: {
            isNotLicensed: !isLicensed
        },
        __callerPackage__: "@confluence/preload-storage-queries"
    });
    const sharedThemePromise = (0, $9wGTI.fg)('shared-user-preferences') ? (0, $fb5b21f5b81a7b59$export$8ff552280f2680c)() : Promise.resolve(null);
    await (0, $lyWac.waitForAllReturnWhenError)([
        userSettingsPromise,
        sharedThemePromise
    ]);
    const userSettingsResponse = await userSettingsPromise;
    const workspaceTheme = await sharedThemePromise;
    const response = userSettingsResponse;
    const legacyTheme = response?.data?.userPreferences?.theme;
    let theme;
    if ((0, $9wGTI.fg)('shared-user-preferences')) // Empty theme returned from API means there is no preference set, which should be treated as default (Auto color mode)
    theme = workspaceTheme === '' ? $96ee7afaced2313e$export$758dd268a3743917 : workspaceTheme;
    else theme = legacyTheme;
    // Apply user preference theme only when no themeState is provided (prevents flicker from mismatch)
    if (!themeState && theme) (0, $cad415a4c0599362$export$fd920a796bc0c5e).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(theme));
    return response;
};



var $hHhbz = parcelRequire("hHhbz");

var $gHaxX = parcelRequire("gHaxX");





var $dBcar = parcelRequire("dBcar");





var $1KHQh = parcelRequire("1KHQh");


var $6Dfc9 = parcelRequire("6Dfc9");





var $aw3Ol = parcelRequire("aw3Ol");

async function $409dab8543f88c3f$export$d47cd72065cce2c3(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $aw3Ol.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/experiment-simplify-nav-new-user"
    });
}


async function $6634d7b887e5963f$export$fd58bb520338782d(spaceKey, result) {
    const { data: data, hasErrors: hasErrors } = result;
    if (hasErrors || !data?.onboardingState) return;
    const eligibleEntry = data.onboardingState.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE);
    const startAtEntry = data.onboardingState.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_START_AT);
    if (eligibleEntry?.value !== 'true') {
        if ((0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) {
            // Mirror the eligibility hook: do not preload if user is enrolled in the
            // old creation-focused-nav onboarding state.
            const creationFocusedNavStartTimeEntry = data.onboardingState.find((s)=>s.key === (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME));
            if (creationFocusedNavStartTimeEntry?.value) return;
            // Not eligible for new-user experiment — check xflow eligibility.
            const xflowStartAtEntry = data.onboardingState.find((s)=>s.key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT);
            if (xflowStartAtEntry?.value) // Returning enrolled user: preload if within D0 window.
            {
                if ((0, $6Dfc9.isWithinD0Window)(xflowStartAtEntry.value)) await (0, $409dab8543f88c3f$export$d47cd72065cce2c3)(spaceKey);
            } else {
                // First-time xflow user: no START_AT yet, but will get one on first render.
                // Preload optimistically if firstActivationDate is after the experiment start date.
                const rawActivationDate = (0, $60cDW.getSSRRenderInputs)().tapContext?.site?.firstActivationDate;
                const siteActivationDate = rawActivationDate ? String(rawActivationDate) : null;
                const experimentStartDate = (0, $1KHQh.getXflowExperimentStartDate)();
                if (siteActivationDate && experimentStartDate && new Date(siteActivationDate) >= experimentStartDate) await (0, $409dab8543f88c3f$export$d47cd72065cce2c3)(spaceKey);
            }
        }
        return;
    }
    // Relevant for real experiment variant users
    if (startAtEntry?.value) {
        if ((0, $6Dfc9.isWithinD0Window)(startAtEntry.value)) await (0, $409dab8543f88c3f$export$d47cd72065cce2c3)(spaceKey);
    }
}


















var $iQzVo = parcelRequire("iQzVo");


var $gikGR = parcelRequire("gikGR");


var $ljH80 = parcelRequire("ljH80");


var $iGpO4 = parcelRequire("iGpO4");


var $7N8s0 = parcelRequire("7N8s0");

const $29e73fd15ceba733$export$9865c9c16b8cbabb = async (userId)=>{
    if (!(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-fg')) return;
    const { isRovoEnabled: isRovoEnabled, orgId: orgId, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isRovoEnabled) return;
    // Always preload onboarding state first. It is lightweight and tells us
    // whether the more expensive AGG queries are still needed.
    const onboardingResult = await (0, $dYU3e.queryAgg)({
        query: (0, $gikGR.default),
        variables: {},
        __callerPackage__: "@confluence/experiment-twcg-1489-cc-3p-connector-onboarding"
    }).catch(()=>null);
    // Extract the enrolment date and skip the AGG queries when the experiment
    // is past its active window (30 days).
    const enrolmentDateStr = onboardingResult?.data?.userPreferences?.onboardingState?.find((entry)=>entry.key === (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).ENROLMENT_DATE)?.value ?? undefined;
    if (!(0, $7N8s0.isWithinEnrolmentWindow)(enrolmentDateStr)) return;
    // When the user has dismissed both promo surfaces, all visibility flags in
    // useConnectorPromoConfig will be false, so the AGG queries are not needed.
    const promoDismissed = onboardingResult?.data?.userPreferences?.onboardingState?.find((entry)=>entry.key === (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED)?.value;
    if (promoDismissed === 'both') return;
    // Within the window — fire the AGG queries in parallel.
    const tasks = [];
    if (userId) tasks.push((0, $dYU3e.queryAgg)({
        query: (0, $ljH80.default),
        variables: {
            userId: userId
        },
        __callerPackage__: "@confluence/experiment-twcg-1489-cc-3p-connector-onboarding"
    }));
    if (orgId && cloudId) tasks.push((0, $dYU3e.queryAgg)({
        query: (0, $iGpO4.default),
        variables: {
            orgId: orgId,
            resourceId: cloudId,
            first: 75
        },
        __callerPackage__: "@confluence/experiment-twcg-1489-cc-3p-connector-onboarding"
    }));
    if (tasks.length > 0) await (0, $lyWac.waitForAllReturnWhenError)(tasks);
};














function $e0b364cfa44ad6fc$var$getOnboardingKeysToPreload() {
    if ((0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled')) {
        if ((0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) return [
            ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS),
            (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
            (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT
        ];
        return [
            ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
        ];
    }
    return [
        (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
        (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME)
    ];
}
const $e0b364cfa44ad6fc$export$6c6d6d173d015704 = (onResult)=>{
    const promise = (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: $e0b364cfa44ad6fc$var$getOnboardingKeysToPreload()
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    if (onResult) return promise.then(async (result)=>{
        await onResult(result);
        return result;
    });
    return promise;
};












var $d9tcB = parcelRequire("d9tcB");


var $4vyfK = parcelRequire("4vyfK");





var $8dUjs = parcelRequire("8dUjs");

const $0253e305bf4bf030$export$8b5d8927d613430e = async ()=>{
    const { edition: edition, accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const { webItemParams: webItemParams } = (0, $8dUjs.getGlobalAppsParams)({
        edition: edition,
        accessStatus: accessStatus
    });
    return (0, $4vyfK.preloadWebItemLocation)(webItemParams);
};



var $hPkGG = parcelRequire("hPkGG");

const $34aa8f5c495a6ba2$export$3efc211209d16247 = async (spaceKey)=>{
    const { cloudId: cloudId, userId: userId, activationId: activationId, accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const promises = [
        (0, $0253e305bf4bf030$export$8b5d8927d613430e)()
    ];
    if (userId && !(0, $9wGTI.fg)('navx-global-side-nav-confluence')) promises.push((0, $dYU3e.queryAgg)({
        query: (0, $hPkGG.default),
        context: {
            headers: {
                'Atl-Client-Name': 'confluence-frontend'
            }
        },
        variables: {
            entityAri: (0, $hHhbz.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            ownerAri: (0, $gHaxX.IdentityUserAri).create({
                userId: userId
            }).toString()
        },
        __callerPackage__: "@confluence/side-navigation"
    }));
    if (accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) promises.push((0, $e0b364cfa44ad6fc$export$6c6d6d173d015704)(// When FG on and on a space route: if user is simplify-nav D0-eligible, preload blog count for nav.
    spaceKey && ((0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled') || (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) ? (result)=>(0, $6634d7b887e5963f$export$fd58bb520338782d)(spaceKey, result) : undefined));
    if (accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS) promises.push((0, $29e73fd15ceba733$export$9865c9c16b8cbabb)(userId ?? undefined));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};






var $aQN68 = parcelRequire("aQN68");

async function $e44b2547c6a8e817$export$dfd129d3c3f4c561() {
    return (0, $dYU3e.query)({
        query: (0, $aQN68.default),
        __callerPackage__: "@confluence/side-navigation"
    });
}








/* eslint-disable import-extensions/file-extension-required */ 









var $aT8im = parcelRequire("aT8im");


var $5wdey = parcelRequire("5wdey");

async function $1f8e7f4831866dd9$export$f92adbce3a1ce419() {
    const { isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return;
    return (0, $dYU3e.query)({
        query: (0, $5wdey.default),
        variables: {
            key: [
                (0, $aT8im.EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED)
            ]
        },
        __callerPackage__: "@confluence/experiment-edition-awareness-for-standard-to-premium"
    });
}






var $cbHql = parcelRequire("cbHql");

const $da1fd1e44d7582fe$export$b4f1825d0b62630d = ()=>(0, $dYU3e.query)({
        query: (0, $cbHql.default),
        __callerPackage__: "@confluence/editor-presets"
    });



var $iUV81 = parcelRequire("iUV81");


var $9sGCn = parcelRequire("9sGCn");


var $3y1ko = parcelRequire("3y1ko");



















const $9c2bd2b1923ffb30$export$20203945a91bbda3 = ()=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { userId: userId, accessStatus: accessStatus } = preloadedSessionContext;
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const tasks = [];
    if (isLicensed && userId) tasks.push((0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values((0, $dBcar.CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH))
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $hXDOc = parcelRequire("hXDOc");


var $kM8fE = parcelRequire("kM8fE");


var $g277M = parcelRequire("g277M");



var $wPrRK = parcelRequire("wPrRK");











var $kkLBe = parcelRequire("kkLBe");





var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");
/**
 * @generated SignedSource<<eddb0c7c953e97c5c75f74c7e515f4d7>>
 * @relayHash da3e826951bca8f84c0c19032c9325c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cc91647276a51b61d8fbbab9ded643964adccb27641d4f58398ffb6db21e5cd3
const $aa72a6013de18737$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "agentSessionsPropertyKey"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "fetchAgentSessionsMarker"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAgentTrustReceiptData"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSSR"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "preloadLabels"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v13 = {
        "kind": "ScalarField",
        "name": "title"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "number"
    }, v17 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "confRev"
            },
            v16 /*: any*/ ,
            {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    }
                ]
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v20 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v16 /*: any*/ 
        ]
    }, v23 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v14 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ 
            ]
        }
    ], v24 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "cover-picture-id-published",
                    "editor",
                    "import-source",
                    "imported-page-modified-date"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v23 /*: any*/ ,
        "storageKey": "properties(keys:[\"cover-picture-id-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
    }, v25 = {
        "condition": "useNewContentTopper",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v23 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            }
        ]
    }, v26 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "representation"
    }, v28 = {
        "concreteType": "WebResourceTags",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "js"
            },
            {
                "kind": "ScalarField",
                "name": "css"
            }
        ]
    }, v29 = [
        v28 /*: any*/ 
    ], v30 = {
        "condition": "isSSR",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "MapOfStringToFormattedBody",
                "kind": "LinkedField",
                "name": "macroRenderedOutput",
                "plural": true,
                "selections": [
                    v14 /*: any*/ ,
                    {
                        "concreteType": "FormattedBody",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                            v21 /*: any*/ ,
                            v27 /*: any*/ ,
                            {
                                "concreteType": "WebResourceDependencies",
                                "kind": "LinkedField",
                                "name": "webresource",
                                "plural": false,
                                "selections": v29 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    }, v31 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "dynamic",
                "plural": false,
                "selections": [
                    v27 /*: any*/ ,
                    v21 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "WebResourceDependencies",
                        "kind": "LinkedField",
                        "name": "webresource",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SuperBatchWebResources",
                                "kind": "LinkedField",
                                "name": "superbatch",
                                "plural": false,
                                "selections": v29 /*: any*/ 
                            },
                            v28 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v32 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v23 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v33 = {
        "kind": "ScalarField",
        "name": "name"
    }, v34 = {
        "condition": "preloadLabels",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": {
                            "direction": "ASCENDING",
                            "sortField": "LABELLING_CREATIONDATE"
                        }
                    }
                ],
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v9 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "label"
                            },
                            v33 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "prefix"
                            }
                        ]
                    }
                ],
                "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            }
        ]
    }, v35 = {
        "condition": "fetchAgentSessionsMarker",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "agentSessionsMarker",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "key",
                        "variableName": "agentSessionsPropertyKey"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v23 /*: any*/ 
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "background"
    }, v37 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v38 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v39 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v40 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v41 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v42 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v43 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v44 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v45 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v46 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ScreenLookAndFeel",
                                "kind": "LinkedField",
                                "name": "screen",
                                "plural": false,
                                "selections": [
                                    v36 /*: any*/ ,
                                    v37 /*: any*/ ,
                                    v38 /*: any*/ ,
                                    v39 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    v41 /*: any*/ ,
                                    v42 /*: any*/ ,
                                    v43 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v45 /*: any*/ ,
                                    {
                                        "concreteType": "LayerScreenLookAndFeel",
                                        "kind": "LinkedField",
                                        "name": "layer",
                                        "plural": false,
                                        "selections": [
                                            v36 /*: any*/ ,
                                            v37 /*: any*/ ,
                                            v38 /*: any*/ ,
                                            v39 /*: any*/ ,
                                            v40 /*: any*/ ,
                                            v41 /*: any*/ ,
                                            v42 /*: any*/ ,
                                            v43 /*: any*/ ,
                                            v44 /*: any*/ ,
                                            v45 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "width"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "height"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterTop"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterRight"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterBottom"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterLeft"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    v36 /*: any*/ ,
                                    v37 /*: any*/ ,
                                    v38 /*: any*/ ,
                                    v39 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    v41 /*: any*/ ,
                                    v42 /*: any*/ ,
                                    v43 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v45 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "SpaceSettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "routeOverrideEnabled"
                    }
                ]
            },
            {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAnonymouslyAuthorized"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentUnifiedWithSpaceKeyQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "spaceHomepage",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v17 /*: any*/ ,
                        {
                            "condition": "includeAgentTrustReceiptData",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        v26 /*: any*/ ,
                        v30 /*: any*/ ,
                        v31 /*: any*/ ,
                        v32 /*: any*/ ,
                        v34 /*: any*/ ,
                        v35 /*: any*/ 
                    ]
                },
                v46 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentUnifiedWithSpaceKeyQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "spaceHomepage",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v17 /*: any*/ ,
                        {
                            "condition": "includeAgentTrustReceiptData",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v19 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v20 /*: any*/ 
                            ]
                        },
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        v26 /*: any*/ ,
                        v30 /*: any*/ ,
                        v31 /*: any*/ ,
                        v32 /*: any*/ ,
                        v34 /*: any*/ ,
                        v35 /*: any*/ 
                    ]
                },
                v46 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "da3e826951bca8f84c0c19032c9325c6",
            "id": "cc91647276a51b61d8fbbab9ded643964adccb27641d4f58398ffb6db21e5cd3",
            "metadata": {},
            "name": "ContentUnifiedWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query ContentUnifiedWithSpaceKeyQuery($spaceKey:String!,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false){spaceHomepage(spaceKey:$spaceKey,version:$versionOverride){id,status,type,subType,title,space{id,key,alias},version{confRev,number,when@include(if:$includeAgentTrustReceiptData)},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n    contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},properties(keys:[\"cover-picture-id-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},metadata{lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},macroRenderedOutput@include(if:$isSSR){key,value{value,representation,webresource{tags{js,css}}}},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}}\n    operations@include(if:$preloadLabels){operation,targetType},agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}},space(key:$spaceKey){id,theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$aa72a6013de18737$var$node.hash = "fec01422af34f842b451cc8520d27d92";
var $aa72a6013de18737$export$2e2bcd8739ae039 = $aa72a6013de18737$var$node;






var $2GGOW = parcelRequire("2GGOW");





var $fEmGS = parcelRequire("fEmGS");


var $hNtOj = parcelRequire("hNtOj");

function $1acff4ea84553836$var$processContentPreloadPermissionError(result) {
    result?.errors?.forEach((error)=>{
        // The "Cannot find space" condition is handled by redirecting to the correct space
        // even if error is not propagated to ContentPrerequisites where it is normally handled.
        if ((0, $2GGOW.isUnauthorizedError)(error)) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('view', error);
    });
}
const $1acff4ea84553836$export$dba3e11e87da376f = (data)=>({
        content: data?.spaceHomepage ? {
            nodes: [
                data?.spaceHomepage
            ],
            // @ts-ignore
            __typename: 'PaginatedContentListWithChild'
        } : null,
        space: data?.space || null
    });
function $1acff4ea84553836$export$97ce9ab4bdd6b3fc({ contentId: contentId, spaceKey: spaceKey, isBlog: isBlog, versionOverride: versionOverride = null, userId: userId, agentSessionsEnabled: agentSessionsEnabled = false }) {
    window.performance.mark('CFP-63.preloadContent.start');
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    // Space overview
    if (spaceKey && !contentId) return (0, $dYU3e.query)({
        query: (0, $aa72a6013de18737$export$2e2bcd8739ae039),
        variables: {
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            useNewContentTopper: true,
            // Fetch the agent-session marker on the homepage node so the data bridged into the
            // ContentUnifiedQuery cache entry below is complete and matches the live read's
            // selection set (avoids a partial-data cache miss -> Tiny renderer).
            ...agentSessionsEnabled && userId ? {
                agentSessionsPropertyKey: `cc-agent-mention-sessions:${userId}`,
                fetchAgentSessionsMarker: true
            } : {},
            // Keep this in lockstep with the ContentUnifiedQuery write below AND the
            // ViewPageContainer read: the agent-trust-receipt fields must be fetched here so
            // the transformed data written into the ContentUnifiedQuery cache slot is complete.
            ...(0, $9wGTI.fg)('cc_sparks_agent_trust_receipt') ? {
                includeAgentTrustReceiptData: true
            } : {}
        },
        errorPolicy: 'all',
        __callerPackage__: "@confluence/content-body"
    }).then((result)=>{
        // Record the end mark and timestamp to track *both* duration of preloading
        // and timestamp of the moment when preloading finished
        window.performance.mark('CFP-63.preloadContent.end');
        window.performance.mark('CFP-63.preloadContentEnd');
        const data = result?.data;
        const homepageId = data?.spaceHomepage?.id;
        if (homepageId) {
            // update result with transformed data
            result.data = $1acff4ea84553836$export$dba3e11e87da376f(data);
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $jgc4t.default),
                variables: {
                    contentId: homepageId,
                    spaceKey: spaceKey,
                    versionOverride: versionOverride,
                    isSSR: isSSR,
                    useNewContentTopper: true,
                    // Match the variables that ViewPageContainer sends when the experiment is enabled,
                    // so the bridged cache entry shares the same key as the live read and is a hit.
                    // Without this, the space-overview homepage reads ContentUnifiedQuery with the
                    // agent-session vars while this entry was written without them → cache miss →
                    // body is null on first paint → page renders with the Tiny renderer.
                    ...agentSessionsEnabled && userId ? {
                        agentSessionsPropertyKey: `cc-agent-mention-sessions:${userId}`,
                        fetchAgentSessionsMarker: true
                    } : {},
                    // Must match the variable set ViewPageContainer reads ContentUnifiedQuery
                    // with, otherwise the cache key diverges and the homepage re-fetches on the
                    // server.
                    ...(0, $9wGTI.fg)('cc_sparks_agent_trust_receipt') ? {
                        includeAgentTrustReceiptData: true
                    } : {}
                },
                data: {
                    ...result.data
                },
                __callerPackage__: "@confluence/content-body"
            });
        }
        $1acff4ea84553836$var$processContentPreloadPermissionError(result);
        return {
            result: result,
            hasErrors: result?.hasErrors
        };
    });
    const chooseContentUnifiedQuery = isBlog ? (0, $f9opb.default) : (0, $jgc4t.default);
    const queryVariables = {
        contentId: contentId,
        spaceKey: spaceKey,
        versionOverride: versionOverride,
        isSSR: isSSR,
        useNewContentTopper: true,
        // Match the variables that ViewPageContainer sends when the experiment is enabled,
        // so the preloaded cache entry is a hit and no second network request is made.
        ...agentSessionsEnabled && userId ? {
            agentSessionsPropertyKey: `cc-agent-mention-sessions:${userId}`,
            fetchAgentSessionsMarker: true
        } : {},
        // Match the variable ViewPageContainer reads ContentUnifiedQuery with so the preloaded
        // cache entry is hit and the agent-trust-receipt fields are present on first client render.
        ...(0, $9wGTI.fg)('cc_sparks_agent_trust_receipt') ? {
            includeAgentTrustReceiptData: true
        } : {}
    };
    if (isSSR) queryVariables.preloadLabels = true;
    return (0, $dYU3e.query)({
        query: chooseContentUnifiedQuery,
        variables: queryVariables,
        errorPolicy: 'all',
        __callerPackage__: "@confluence/content-body"
    }).then((result)=>{
        // Record the end mark and timestamp to track *both* duration of preloading
        // and timestamp of the moment when preloading finished
        window.performance.mark('CFP-63.preloadContent.end');
        window.performance.mark('CFP-63.preloadContentEnd');
        $1acff4ea84553836$var$processContentPreloadPermissionError(result);
        return {
            result: result,
            hasErrors: result?.hasErrors
        };
    });
}



var $furnK = parcelRequire("furnK");


var $lcQ5b = parcelRequire("lcQ5b");





var $b2p4s = parcelRequire("b2p4s");

const $6dc053709e1de01d$export$4a518872c59a5d22 = ({ contentId: contentId, draftShareId: draftShareId })=>{
    return (0, $dYU3e.query)({
        query: (0, $b2p4s.default),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'draft'
            ]
        },
        __callerPackage__: "@confluence/content-prerequisites"
    });
};


/**
 * @generated SignedSource<<641bef976a9dfa27cfaf237e55d369e4>>
 * @relayHash e60aa4bbe3e8e564d5efcbac06a88233
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd60613781bda67c40bd5c06e6073d1bf578b724b948b3ce74e2e9f3303be1d
const $e6a14af32fbfc2ce$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedSmartLinkList",
            "kind": "LinkedField",
            "name": "contentSmartLinks",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "emojiTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canView"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resourceType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resolved"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadContentSmartLinksQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadContentSmartLinksQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e60aa4bbe3e8e564d5efcbac06a88233",
            "id": "7dd60613781bda67c40bd5c06e6073d1bf578b724b948b3ce74e2e9f3303be1d",
            "metadata": {},
            "name": "preloadContentSmartLinksQuery",
            "operationKind": "query",
            "text": "query preloadContentSmartLinksQuery($contentId:ID!){contentSmartLinks(id:$contentId){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved}}}"
        }
    };
}();
$e6a14af32fbfc2ce$var$node.hash = "45952b76e4b10a1d4c45176a81952be2";
var $e6a14af32fbfc2ce$export$2e2bcd8739ae039 = $e6a14af32fbfc2ce$var$node;


/**
 * @generated SignedSource<<f9309a5246b377b04e6071ee882577e4>>
 * @relayHash 928e14504cea054d1244ccf4c022e350
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e8b3b1e09c616007e089ee9ea7026d4922b2fadcf5dfa2547427274025af269d
const $866645ac6f42c4a0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedSmartLinkList",
            "kind": "LinkedField",
            "name": "confluence_contentSmartLinksForDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "emojiTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canView"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resourceType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resolved"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadContentSmartLinksForDraftQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadContentSmartLinksForDraftQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "928e14504cea054d1244ccf4c022e350",
            "id": "e8b3b1e09c616007e089ee9ea7026d4922b2fadcf5dfa2547427274025af269d",
            "metadata": {},
            "name": "preloadContentSmartLinksForDraftQuery",
            "operationKind": "query",
            "text": "query preloadContentSmartLinksForDraftQuery($contentId:ID!){confluence_contentSmartLinksForDraft(id:$contentId){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved}}}"
        }
    };
}();
$866645ac6f42c4a0$var$node.hash = "d08d65bd7c8823a600315f571b5567dc";
var $866645ac6f42c4a0$export$2e2bcd8739ae039 = $866645ac6f42c4a0$var$node;









var $8tmcF = parcelRequire("8tmcF");




















var $jhATi = parcelRequire("jhATi");


var $hR977 = parcelRequire("hR977");

const $7da0fb3e82be6868$export$c5bb6d638f1fa69c = (node)=>{
    return node?.['__typename'] === 'InlineSmartLink';
};
const $7da0fb3e82be6868$var$parseSmartlinksResponse = (res, isDraft)=>{
    if (isDraft) return res?.data?.confluence_contentSmartLinksForDraft?.nodes || [];
    return res?.data?.contentSmartLinks?.nodes || [];
};
const $7da0fb3e82be6868$export$7df91b88e675cedb = (res, isDraft = false)=>{
    const content = $7da0fb3e82be6868$var$parseSmartlinksResponse(res, isDraft);
    // filter to only inline smartlins and limit to the max number of smartlinks allowed per call by ORS
    const inputSmartLinks = content.filter($7da0fb3e82be6868$export$c5bb6d638f1fa69c).slice(0, 50);
    return inputSmartLinks.filter((node)=>!!node).map((node)=>{
        return {
            appearance: 'inline',
            resourceUrl: node?.url,
            title: node?.title,
            emojiTitle: node?.emojiTitle,
            canView: node?.canView,
            product: node?.product,
            resourceType: node?.resourceType,
            subType: node?.subType,
            iconUrl: node?.iconUrl,
            resolved: node?.resolved
        };
    });
};



var $3y0Sn = parcelRequire("3y0Sn");


var $cS4kb = parcelRequire("cS4kb");

function $ee659c10b0d5386a$export$feca2dfbe7ee574(gqlState, orsState, links) {
    const linksByUrl = new Map();
    for (const link of links)if (link.resourceUrl) linksByUrl.set(link.resourceUrl, link);
    let matchedCount = 0;
    const byType = {};
    for (const url of Object.keys(gqlState)){
        const ors = orsState[url];
        const link = linksByUrl.get(url);
        const typeKey = [
            link?.resourceType,
            link?.subType
        ].filter(Boolean).join('/') || 'unknown';
        if (!byType[typeKey]) byType[typeKey] = {
            total: 0,
            matched: 0,
            missingIcon: 0,
            wrongIcon: 0
        };
        byType[typeKey].total++;
        if (!ors) continue;
        const gqlIcon = gqlState[url].details?.data?.icon?.url ?? null;
        const orsIcon = ors.details?.data?.icon?.url ?? null;
        if (gqlIcon !== orsIcon) {
            if (gqlIcon === null) byType[typeKey].missingIcon++;
            else byType[typeKey].wrongIcon++;
        } else {
            matchedCount++;
            byType[typeKey].matched++;
        }
    }
    return {
        matchedCount: matchedCount,
        byType: byType
    };
}


const $9eb88ac593a96a41$export$92162a33dbbd338d = 250;
const $9eb88ac593a96a41$export$5fc2ebe451bbe5aa = 350;
const $9eb88ac593a96a41$export$83d9e8edcbcda504 = 1;
const $9eb88ac593a96a41$export$c048e241ec0ff835 = 50;
const $9eb88ac593a96a41$var$getContentSmartLinksORSMeasureName = ()=>{
    const queryBoundary = (0, $g277M.getQueryBoundary)();
    if (!queryBoundary || queryBoundary === 'default') return 'ssr-app/prepare/preloadQuery/fetch:contentSmartLinksORS';
    return `ssr-app/prepare/preloadQuery/dataFetcher:${queryBoundary}/fetch:contentSmartLinksORS`;
};
const $9eb88ac593a96a41$export$3b6cf89022ccdd35 = async (contentId, isDraft = false)=>{
    if (isDraft) {
        const smartLinkDraftRes = await (0, $dYU3e.query)({
            query: (0, $866645ac6f42c4a0$export$2e2bcd8739ae039),
            variables: {
                contentId: contentId
            },
            __callerPackage__: "@confluence/content-smartlinks"
        });
        return (0, $7da0fb3e82be6868$export$7df91b88e675cedb)(smartLinkDraftRes, isDraft);
    }
    const smartLinksRes = await (0, $dYU3e.query)({
        query: (0, $e6a14af32fbfc2ce$export$2e2bcd8739ae039),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/content-smartlinks"
    });
    return (0, $7da0fb3e82be6868$export$7df91b88e675cedb)(smartLinksRes, isDraft);
};
const $9eb88ac593a96a41$export$d966f1e92068ec2e = (orsCalls, smartLinks, resolvedSmartLinks, fetchTimeout)=>{
    const resolvedLinks = resolvedSmartLinks.reduce((acc, { status: status, body: body })=>{
        if (status === 504) acc[body?.data?.url] = 'timeout';
        if (status === 200) acc[body?.data?.url] = 'resolved';
        return acc;
    }, {});
    return {
        fetch: orsCalls.length,
        fetchTimeout: fetchTimeout,
        links: smartLinks.reduce((acc, { resourceUrl: resourceUrl, appearance: appearance })=>{
            const linkType = (0, $cS4kb.getLinkType)(resourceUrl);
            if (!acc?.[linkType]?.[appearance]) acc[linkType] = {
                [appearance]: {
                    total: 0,
                    timeout: 0,
                    resolved: 0
                }
            };
            acc[linkType][appearance].total++;
            if (resolvedLinks[resourceUrl]) {
                if (resolvedLinks[resourceUrl] === 'timeout') acc[linkType][appearance].timeout++;
                if (resolvedLinks[resourceUrl] === 'resolved') acc[linkType][appearance].resolved++;
            }
            return acc;
        }, {})
    };
};
async function $9eb88ac593a96a41$export$6ef3ef384e337a5(links, timeout, batchTimeout, fetchTimeout, shouldSkipTimeGuard) {
    if (links.length === 0) return [];
    const { customURLs: customURLs, userContext: userContext } = (0, $60cDW.getSSRRenderInputs)();
    const objectResolverURL = (0, $d6NtA.isLocal)() ? '/gateway/api/object-resolver/resolve/batch' : customURLs?.['object-resolver-service'];
    const firstLink = links[0].resourceUrl;
    const type = (0, $cS4kb.getLinkType)(firstLink);
    const task = async ()=>{
        try {
            // ORS only expects resourceURL and appearance, otherwise it throws a 400 for any unrecognized fields
            // GQL can return any number of fields (title, emoji, resolved state, etc) but ORS should only accept
            // resourceURL and appearance
            const sanitizedLinksForORS = links.map(({ resourceUrl: resourceUrl, appearance: appearance })=>({
                    resourceUrl: resourceUrl,
                    appearance: appearance
                }));
            const res = await (0, $jhATi.fetchORSForSSR)({
                // Despite the API has a timeout it does not respect it. It can easily go over time.
                url: `${objectResolverURL}?timeout=${timeout}`,
                body: JSON.stringify(sanitizedLinksForORS),
                userContext: userContext
            });
            if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
            return res.json();
        } catch (e) {
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Smart link content ORS call failed: ${e.message}`));
        }
        return [];
    };
    if (shouldSkipTimeGuard) return task();
    return (0, $8tmcF.timeGuard)(task, ()=>{
        fetchTimeout[type] = fetchTimeout[type] || 0;
        fetchTimeout[type]++;
        return [];
    }, batchTimeout);
}
const $9eb88ac593a96a41$export$dc2d6742e80fba3c = async (contentId, isDraft = false)=>{
    const smartLinks = await $9eb88ac593a96a41$export$3b6cf89022ccdd35(contentId, isDraft);
    if (!smartLinks?.length) return;
    // How long a single ORS resolution can take
    const timeout = (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_max_time', $9eb88ac593a96a41$export$92162a33dbbd338d);
    // How long a batch of ORS resolution can take
    const batchTimeout = (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_batch_max_time', $9eb88ac593a96a41$export$5fc2ebe451bbe5aa);
    // How many links should be packed in a batch
    const min = (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_min_batch_count', $9eb88ac593a96a41$export$83d9e8edcbcda504);
    const max = Math.max(min, (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_max_batch_count', $9eb88ac593a96a41$export$c048e241ec0ff835));
    let linksForORS = smartLinks;
    let gqlResolvedState = {};
    let gqlStats = {};
    if ((0, $6mKj3.expVal)('confluence_skip_ors_for_smartlinks', 'isEnabled', false)) {
        const { resolvedFromGql: resolvedFromGql, linksForORS: remaining } = (0, $3y0Sn.partitionResolvedLinks)(smartLinks);
        linksForORS = remaining;
        // format resolved links to match that of getInitialState
        gqlResolvedState = (0, $3y0Sn.buildResolvedSmartLinkState)(resolvedFromGql);
        gqlStats = {
            totalLinks: smartLinks.length,
            resolvedFromGqlCount: resolvedFromGql?.length,
            linksForORSCount: remaining?.length,
            skippedORS: remaining?.length === 0
        };
    }
    const orsCalls = [];
    const fetchTimeout = {};
    let resolvedSmartLinks = [];
    if (linksForORS.length > 0) await (0, $9WAeG.SSRMeasures).run($9eb88ac593a96a41$var$getContentSmartLinksORSMeasureName(), async ()=>{
        let smartLinksBatches = (0, $cS4kb.groupSmartLinksByHostname)(linksForORS);
        smartLinksBatches = (0, $cS4kb.mergeSmallThirdPartyBatches)(smartLinksBatches, min);
        smartLinksBatches = (0, $cS4kb.splitLinksIntoBatches)(smartLinksBatches, max);
        for (const smartLinksBatch of smartLinksBatches)orsCalls.push($9eb88ac593a96a41$export$6ef3ef384e337a5(smartLinksBatch, timeout, batchTimeout, fetchTimeout));
        // eslint-disable-next-line check-preloaders/no-promise-all
        resolvedSmartLinks = (await Promise.all(orsCalls)).flat();
    });
    if ((0, $6mKj3.expVal)('confluence_frontend_smartlinks_title_while_loading', 'isEnabled', false)) {
        const titles = {};
        for (const link of linksForORS)if (link.title) titles[link.resourceUrl] = link.title;
        if (Object.keys(titles).length > 0) window['__SSR_SMARTLINKS_TITLES__'] = titles;
    }
    // Format response to fit SmartCard Provider storeOptions initial state
    // Save correctly formatted response to window obj so it can be used on SSR and SPA (no duplicate calls)
    // Merge GraphQL-resolved state with ORS-resolved state
    window['__SSR_SMARTLINKS__'] = {
        ...gqlResolvedState,
        ...(0, $hR977.getInitialState)(resolvedSmartLinks)
    };
    window['__SSR_SMARTLINKS_STATS__'] = {
        ...$9eb88ac593a96a41$export$d966f1e92068ec2e(orsCalls, smartLinks, resolvedSmartLinks, fetchTimeout),
        gql: gqlStats
    };
    // Temporary Icon comparison while confluence_skip_ors_for_smartlinks is DISABLED
    // compare GQL-built icons against ORS-resolved icons for resolved Confluence links
    const orsState = window['__SSR_SMARTLINKS__'] || {};
    const resolvedConfluenceLinks = linksForORS.filter((link)=>link.product === 'confluence' && link.resolved === true);
    if (resolvedConfluenceLinks.length > 0) {
        const gqlBuiltState = (0, $3y0Sn.buildResolvedSmartLinkState)(resolvedConfluenceLinks);
        const { matchedCount: matchedCount, byType: byType } = (0, $ee659c10b0d5386a$export$feca2dfbe7ee574)(gqlBuiltState, orsState, resolvedConfluenceLinks);
        const diffCount = resolvedConfluenceLinks.length - matchedCount;
        window['__SSR_SMARTLINKS_ICON_DIFF__'] = {
            totalResolvedConfluenceLinks: resolvedConfluenceLinks.length,
            matchedCount: matchedCount,
            diffCount: diffCount,
            byType: byType
        };
    }
};















var $5Kzz3 = parcelRequire("5Kzz3");








const $df3ec02d5ab74bd9$var$DEFAULT_DATA_FETCHER_TIMEOUT = 1000;
const $df3ec02d5ab74bd9$var$SMARTLINKS_TIMEOUT_BUFFER = 250;
/*
 * Statsig timeout configs for preloading with suspense
 */ function $df3ec02d5ab74bd9$var$getStreamingTimeoutsAndBatchSizes() {
    // How long a single ORS resolution can take
    const timeout = (0, $1xpoY.default).getNumber('confluence_smart_link_streaming_max_time', (0, $9eb88ac593a96a41$export$92162a33dbbd338d));
    // How long a batch of ORS resolution can take
    const batchTimeout = (0, $1xpoY.default).getNumber('confluence_smart_link_streaming_batch_max_time', (0, $9eb88ac593a96a41$export$5fc2ebe451bbe5aa));
    // How many links should be packed in a batch
    const min = (0, $1xpoY.default).getNumber('confluence_smart_link_min_batch_count', (0, $9eb88ac593a96a41$export$83d9e8edcbcda504));
    const max = Math.max(min, (0, $1xpoY.default).getNumber('confluence_smart_link_streaming_max_batch_count', (0, $9eb88ac593a96a41$export$c048e241ec0ff835)));
    return {
        timeout: timeout,
        batchTimeout: batchTimeout,
        min: min,
        max: max
    };
}
// merge links when batches resolve into global store
function $df3ec02d5ab74bd9$var$mergeIntoWindowSSRSmartlinks(resolvedSubset) {
    const subsetState = (0, $hR977.getInitialState)(resolvedSubset);
    (0, $5Kzz3.updateSSRSmartLinksStore)(subsetState);
}
/**
 * Get batches for a given bucket (1p or 3p)
 */ function $df3ec02d5ab74bd9$var$getBatchesForBucket(config) {
    const { links: links, isThirdParty: isThirdParty, min: min, max: max } = config;
    if (!links.length) return [];
    // mirroring batching logic in preloadContentSmartLinks.ts
    let smartLinksBatches = (0, $cS4kb.groupSmartLinksByHostname)(links);
    // only doing 3p split in the case where we know link is 3p
    if (isThirdParty) smartLinksBatches = (0, $cS4kb.mergeSmallThirdPartyBatches)(smartLinksBatches, min);
    smartLinksBatches = (0, $cS4kb.splitLinksIntoBatches)(smartLinksBatches, max);
    return smartLinksBatches;
}
function $df3ec02d5ab74bd9$export$333cf40682450957(config) {
    const batches = $df3ec02d5ab74bd9$var$getBatchesForBucket(config);
    const { bucketName: bucketName } = config;
    batches.forEach((batch, index)=>{
        const fetcherName = `content-smartlinks-${bucketName}-batch-${index}`;
        // Use the global request start time as the source of truth for the clock
        const requestStartTime = window['__SSR_CURRENT_DATE__'] || performance.now();
        const boundaryMapEntries = {};
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        batch.forEach((link)=>{
            boundaryMapEntries[link.resourceUrl] = fetcherName;
        });
        (0, $5Kzz3.updateSSRSmartLinksBoundaryMap)(boundaryMapEntries);
        (0, $eS4vC.createDataFetcherForSuspense)(fetcherName, async ()=>{
            // batchTimeout should almost equal (but be slightly less than) data fetcher timeout
            const { timeout: timeout, batchTimeout: batchTimeout } = $df3ec02d5ab74bd9$var$getStreamingTimeoutsAndBatchSizes();
            const dataFetcherTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_data_fetcher_timeout', $df3ec02d5ab74bd9$var$DEFAULT_DATA_FETCHER_TIMEOUT);
            const fetchTimeout = {};
            const resolved = await (0, $9eb88ac593a96a41$export$6ef3ef384e337a5)(batch, timeout, batchTimeout, fetchTimeout, true);
            // Calculate time since the absolute start of the request
            const totalTimeSinceRequestStart = performance.now() - requestStartTime;
            const dataFetcher = window.__dataFetcherForSuspense__?.[fetcherName];
            /**
       * Even if the data fetcher hasn't officially timed out, check the total elapsed time.
       * If it is too close to the data fetcher timeout (within a buffer time), don't merge the results.
       *
       * This avoids a race condition where ORS returns at the exact same time/after the
       * fetcher timeout, which leads to a hydration error if the fallback is committed first.
       *
       * Buffer time ensures React has enough time to render
       * the results into HTML before guard timeout resolves the boundary.
       */ if (dataFetcher && dataFetcher.isTimeout() || totalTimeSinceRequestStart >= dataFetcherTimeout - $df3ec02d5ab74bd9$var$SMARTLINKS_TIMEOUT_BUFFER) return [];
            $df3ec02d5ab74bd9$var$mergeIntoWindowSSRSmartlinks(resolved);
            return resolved;
        });
    });
}
async function $df3ec02d5ab74bd9$export$b30149a5ef7702c0(contentId, isDraft) {
    // Clear old data and boundary map from the store
    (0, $5Kzz3.resetSSRSmartLinksStore)();
    // Wait for GraphQL first to know how many links we have
    const smartLinks = await (0, $9eb88ac593a96a41$export$3b6cf89022ccdd35)(contentId, isDraft);
    if (!smartLinks?.length) return;
    if ((0, $6mKj3.expVal)('confluence_frontend_smartlinks_title_while_loading', 'isEnabled', false)) {
        const titles = {};
        for (const link of smartLinks)if (link.title) titles[link.resourceUrl] = link.title;
        if (Object.keys(titles).length > 0) window.__SSR_SMARTLINKS_TITLES__ = titles;
    }
    // De-duplicate links to ensure each unique URL belongs to only one batch.
    // This prevents hydration mismatches where a link resolves in a successful
    // batch but waits on a pending boundary from a duplicate entry in another batch.
    const uniqueLinks = Array.from(new Map(smartLinks.map((link)=>[
            link.resourceUrl,
            link
        ])).values());
    let linksForORS = uniqueLinks;
    // When the experiment is enabled, partition links into already-resolved
    // (from GraphQL) and unresolved (need ORS). Resolved links get their
    // initial state built directly from the GraphQL data and written to window.
    if ((0, $6mKj3.expVal)('confluence_skip_ors_for_smartlinks', 'isEnabled', false)) {
        const { resolvedFromGql: resolvedFromGql, linksForORS: remaining } = (0, $3y0Sn.partitionResolvedLinks)(uniqueLinks);
        linksForORS = remaining;
        const gqlResolvedState = (0, $3y0Sn.buildResolvedSmartLinkState)(resolvedFromGql);
        if (Object.keys(gqlResolvedState).length > 0) window['__SSR_SMARTLINKS__'] = {
            ...window['__SSR_SMARTLINKS__'],
            ...gqlResolvedState
        };
    }
    const firstPartyLinks = linksForORS.filter((link)=>(0, $cS4kb.isFirstPartyLink)(link.resourceUrl));
    const thirdPartyLinks = linksForORS.filter((link)=>!(0, $cS4kb.isFirstPartyLink)(link.resourceUrl));
    const { min: min, max: max } = $df3ec02d5ab74bd9$var$getStreamingTimeoutsAndBatchSizes();
    // create data fetchers only when we know buckets have links
    if (firstPartyLinks.length) $df3ec02d5ab74bd9$export$333cf40682450957({
        bucketName: 'first-party',
        isThirdParty: false,
        links: firstPartyLinks,
        min: min,
        max: max
    });
    if (thirdPartyLinks.length) $df3ec02d5ab74bd9$export$333cf40682450957({
        bucketName: 'third-party',
        isThirdParty: true,
        links: thirdPartyLinks,
        min: min,
        max: max
    });
}



var $4zhNK = parcelRequire("4zhNK");


var $fyUox = parcelRequire("fyUox");


var $7Ba23 = parcelRequire("7Ba23");





var $gw4Eo = parcelRequire("gw4Eo");

const $7309ff12be989147$export$a95d48b280e02650 = ({ contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType })=>{
    const entityAri = (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        resourceId: contentId,
        activationId: ''
    });
    const workspaceId = (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: 'workspace',
        resourceId: activationId,
        activationId: ''
    });
    return (0, $dYU3e.queryAgg)({
        query: $7309ff12be989147$export$133357fbca043a2d,
        variables: {
            workspaceId: workspaceId,
            entityAri: entityAri
        },
        __callerPackage__: "@confluence/contextual-reading-aids"
    });
};
const $7309ff12be989147$export$133357fbca043a2d = (0, $7Ba23.default);



var $iV8Fk = parcelRequire("iV8Fk");





var $ld6xp = parcelRequire("ld6xp");


var $2XqLN = parcelRequire("2XqLN");


var $lcuos = parcelRequire("lcuos");


var $e1KOF = parcelRequire("e1KOF");


var $6aq5c = parcelRequire("6aq5c");


var $iyDxB = parcelRequire("iyDxB");


var $8pcS0 = parcelRequire("8pcS0");





var $6mEZ3 = parcelRequire("6mEZ3");








var $92uc5 = parcelRequire("92uc5");


var $8mIlz = parcelRequire("8mIlz");


var $6Cce7 = parcelRequire("6Cce7");










const $cd2d56ef117b2819$export$e87714e2a0c200ee = 8;
const $cd2d56ef117b2819$export$717eaf20c85e91ca = 'confluence-extensions-server-render-blocklist';


// Instead of gating the static constant, we will filter out Calendars here unless the flag is enabled
const $64a1b8a95751bd5c$var$knownExtensionSet = new Set((0, $8pcS0.serverRenderedExtensions).filter((ext)=>ext !== (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS || (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)));
const $64a1b8a95751bd5c$var$getMacroId = (node)=>node.attrs?.parameters?.macroMetadata?.macroId?.value;
const $64a1b8a95751bd5c$var$extractExtensions = (adf)=>(0, $lcuos.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $64a1b8a95751bd5c$var$augmentWithMarks = (marks)=>{
    if (!marks?.length) return {};
    const fragments = marks.filter((mark)=>mark.type === 'fragment');
    if (fragments.length) return {
        fragmentLocalId: fragments[0].attrs.localId
    };
    return {};
};
const $64a1b8a95751bd5c$var$blocklistCache = new Map();
const $64a1b8a95751bd5c$export$80c99e8065c92427 = ()=>$64a1b8a95751bd5c$var$blocklistCache.clear();
const $64a1b8a95751bd5c$var$isBlocklisted = (blocklist, extensionKey)=>{
    if (blocklist.length === 0) return false;
    if ($64a1b8a95751bd5c$var$blocklistCache.has(extensionKey)) return $64a1b8a95751bd5c$var$blocklistCache.get(extensionKey);
    const isBlocked = blocklist.length > 0 && blocklist.some((block)=>{
        try {
            const blockRegex = new RegExp(block, 'ig');
            return blockRegex.test(extensionKey);
        } catch  {
            // Malformed regex/input, consider extension being not blocked
            return false;
        }
    });
    $64a1b8a95751bd5c$var$blocklistCache.set(extensionKey, isBlocked);
    return isBlocked;
};
// The rule of excluding extensions from querying in the prepare phase of SSR are the following:
//  - extension should be located at the top of the page, assuming extensions returned by the
//    adf-utils/filter are in the order from top to down of the page;
//  - extension should be common/legacy, i.e. of type "com.atlassian.confluence.macro.core";
//  - extension should not be a part of those we have a special handling in SPA (excepting children macro);
//  - extensions shouldn't have an output in a content query.
const $64a1b8a95751bd5c$var$byExcluded = (excludeExtensionIdSet, numberOfExtensionsToSSR = 0)=>(node, index)=>{
        const { parameters: parameters, extensionKey: extensionKey, extensionType: extensionType } = node.attrs || {};
        return index < numberOfExtensionsToSSR && extensionType === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE && (!$64a1b8a95751bd5c$var$knownExtensionSet.has(extensionKey) || extensionKey === 'children') && !parameters.macroOutput && !excludeExtensionIdSet.has($64a1b8a95751bd5c$var$getMacroId(node));
    };
const $64a1b8a95751bd5c$var$getSchema = (0, $2XqLN.default)(()=>(0, $iyDxB.getSchemaBasedOnStage)((0, $e1KOF.ADFStages).STAGE_0));
const $64a1b8a95751bd5c$var$createMacroQueryParamsProvider = (documentADF)=>{
    // This code (both `getRendererDocument` and `getRendererNodeContent`) inspired by `renderDocument`
    // function in `platform/packages/editor/renderer/src/render-document.ts`
    // Here we convert the `content` of our adf node to renderer/editor/ProseMirror node,
    // which ensures `content` in preloader and in SSR render would match and would not cause apollo cache mismatch.
    const getRendererDocument = (0, $2XqLN.default)(()=>{
        const schema = $64a1b8a95751bd5c$var$getSchema();
        const validDocumentADF = (0, $6aq5c.validateADFEntity)(schema, documentADF);
        const pnDoc = schema.nodeFromJSON(validDocumentADF);
        return {
            version: 1,
            type: 'doc',
            content: pnDoc.content.toJSON()
        };
    });
    const getRendererNodeContent = (macroId)=>{
        const rendererDocument = getRendererDocument();
        const [rendererNode] = (0, $lcuos.filter)(rendererDocument, (n)=>$64a1b8a95751bd5c$var$getMacroId(n) === macroId);
        return rendererNode.content || [];
    };
    return (node)=>{
        const requestADF = (0, $6mEZ3.extensionToADF)(node);
        requestADF.attrs = {
            ...requestADF.attrs,
            ...$64a1b8a95751bd5c$var$augmentWithMarks(node.marks)
        };
        if (requestADF.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) requestADF.content = getRendererNodeContent($64a1b8a95751bd5c$var$getMacroId(node));
        delete requestADF.attrs.layout;
        return {
            ...requestADF,
            type: node.type
        };
    };
};
const $64a1b8a95751bd5c$var$preloadMacrosSSRAndReturnTopXFailed = async (contentId, contentNodes, numberOfExtensionsToSSR, renderOnlyExtensionKeys, extensionsBlocklist)=>{
    if (renderOnlyExtensionKeys && renderOnlyExtensionKeys.length === 0) return {};
    // NOTE: prealod is not a type. It was created with a typo https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/confluence_frontend_prealod_macro_timeout
    const macroTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_prealod_macro_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const blocklistedExtensions = extensionsBlocklist.split(',').map((extensionName)=>extensionName.trim()).filter(Boolean);
    // Catch error if contentNodes is empty
    if (!contentNodes || !contentNodes[0]) return {
        general: 'contentNodesEmpty'
    };
    // Leave early when there's TinyMCE or borked content
    if (contentNodes[0].body.dynamic?.representation !== 'atlas_doc_format') return {};
    // Exclude extensions that are included into the content response as we don't need
    // to load any data for these extensions.
    const excludeExtensionIdSet = new Set((contentNodes[0].macroRenderedOutput || []).map((ext)=>ext.key));
    let documentADF;
    try {
        documentADF = JSON.parse(contentNodes[0].body.dynamic.value);
    } catch  {
        // While contentNodes[0].body.dynamic.value should be defined in all valid cases,
        // and should it not, the experience for the user will be broken anyway, we want
        // to swallow this error, skip macros preloading and let SPA handle the case, as
        // SPA already have proper experience tracking.
        return;
    }
    const toMacroQueryParams = $64a1b8a95751bd5c$var$createMacroQueryParamsProvider(documentADF);
    const extensions = $64a1b8a95751bd5c$var$extractExtensions(documentADF).filter($64a1b8a95751bd5c$var$byExcluded(excludeExtensionIdSet, numberOfExtensionsToSSR || (0, $cd2d56ef117b2819$export$e87714e2a0c200ee))).filter((node)=>!renderOnlyExtensionKeys || renderOnlyExtensionKeys.includes(node?.attrs?.extensionKey)).map(toMacroQueryParams);
    if (numberOfExtensionsToSSR === 0) return extensions.length === 0 ? {} : undefined;
    // eslint-disable-next-line check-preloaders/no-promise-all
    const preloadResult = await Promise.all(extensions.map(async (extensionADF)=>{
        const { isMacroContentAndBody: isMacroContentAndBody, ...variables } = (0, $8mIlz.getMacroQueryVariables)({
            adf: extensionADF,
            contentId: contentId
        });
        const attr = extensionADF.attrs;
        const extensionKey = attr?.extensionKey;
        const failure = (reason)=>({
                [`${extensionKey}:${$64a1b8a95751bd5c$var$getMacroId(extensionADF)}`]: reason
            });
        const failureIfNotSuccess = (reason)=>(success)=>success ? undefined : failure(reason);
        // we may block some extensions via feature flags
        if ($64a1b8a95751bd5c$var$isBlocklisted(blocklistedExtensions, extensionKey)) return failure('blocklist');
        let macroBodyPreloadPromise = Promise.resolve(undefined);
        if (extensionADF.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) macroBodyPreloadPromise = (0, $wPrRK.slowQueryGuard)(`ExtensionContentConverter_${extensionKey || 'unknown'}`, ()=>{
            return (0, $dYU3e.query)({
                variables: (0, $92uc5.getContentConverterVariables)({
                    content: extensionADF.content,
                    contentId: contentId
                }),
                query: (0, $6Cce7.ContentConverterQuery),
                context: {
                    single: true
                },
                __callerPackage__: "@confluence/fabric-extension-handlers"
            });
        }, macroTimeout).then(failureIfNotSuccess('timeout-macrobody'));
        const macroPreloadPromise = (0, $wPrRK.slowQueryGuard)(`Extension_${extensionKey || 'unknown'}`, ()=>{
            return isMacroContentAndBody ? (0, $dYU3e.query)({
                query: (0, $eqB7W.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "@confluence/fabric-extension-handlers"
            }) : (0, $dYU3e.query)({
                query: (0, $b1ypt.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "@confluence/fabric-extension-handlers"
            });
        }, macroTimeout).then(failureIfNotSuccess('timeout'));
        // eslint-disable-next-line check-preloaders/no-promise-all
        const [macroPreloadResult, macroBodyPreloadResult] = await Promise.all([
            macroPreloadPromise,
            macroBodyPreloadPromise
        ]);
        return {
            ...macroPreloadResult,
            ...macroBodyPreloadResult
        };
    }));
    const preloadFailures = preloadResult ? preloadResult.filter((item)=>!!item) : [];
    return Object.assign({}, ...preloadFailures);
};
async function $64a1b8a95751bd5c$export$f860aab1074a1289(contentId, contentNodes, extensionsBlocklist, numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee), renderOnlyExtensionIds) {
    // Function has early return so we extracted it out to avoid setting global in every return
    return window['__SSR_MACRO_PRELOAD_TOPX_FAILS__'] = await $64a1b8a95751bd5c$var$preloadMacrosSSRAndReturnTopXFailed(contentId, contentNodes, numberOfExtensionsToSSR, renderOnlyExtensionIds, extensionsBlocklist);
}












var $gK2Sc = parcelRequire("gK2Sc");











const $eb281dfded33b271$var$extractExtensions = (adf)=>(0, $lcuos.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $eb281dfded33b271$export$62987d2cbce2773d = (contentNodes)=>{
    try {
        const adf = JSON.parse(contentNodes[0].body.dynamic.value);
        const extensions = $eb281dfded33b271$var$extractExtensions(adf);
        return extensions.length > 0;
    } catch  {
        return false;
    }
};
const $eb281dfded33b271$var$failureIfNotSuccess = (reason)=>(success)=>success ? undefined : {
            MacrosQuery_extensions: reason
        };
const $eb281dfded33b271$var$preloadMacrosSSRAndReturnTopXFailed = async (contentId, contentNodesOrPromise)=>{
    const blocklist = (0, $ld6xp.getMultiMacroQueryBlocklistFF)();
    const isContentNodePromise = typeof contentNodesOrPromise?.then === 'function';
    if (contentNodesOrPromise && !isContentNodePromise) {
        if (!$eb281dfded33b271$export$62987d2cbce2773d(contentNodesOrPromise)) return {};
    }
    const noExtensionsSignal = new Promise((resolve)=>{
        if (isContentNodePromise) contentNodesOrPromise.then((contentNodes)=>{
            if (!$eb281dfded33b271$export$62987d2cbce2773d(contentNodes)) resolve();
        });
    });
    // NOTE: prealod is not a type. It was created with a typo https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/confluence_frontend_prealod_macro_timeout
    const macroTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_prealod_macro_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const macrosQueryTask = ()=>(0, $wPrRK.slowQueryGuard)('MacrosQuery_preload', ()=>(0, $dYU3e.query)({
                variables: {
                    first: (0, $cd2d56ef117b2819$export$e87714e2a0c200ee),
                    contentId: contentId,
                    blocklist: blocklist
                },
                query: (0, $gK2Sc.default),
                context: {
                    single: true
                },
                __callerPackage__: "@confluence/fabric-extension-handlers"
            }), macroTimeout, noExtensionsSignal).then($eb281dfded33b271$var$failureIfNotSuccess('timeout-rendered-macros'));
    const preloadResult = await macrosQueryTask();
    return preloadResult ? Object.assign({}, preloadResult) : {};
};
async function $eb281dfded33b271$export$b470c165ef60e727(contentId, contentNodesOrPromise) {
    const topXFailed = await $eb281dfded33b271$var$preloadMacrosSSRAndReturnTopXFailed(contentId, contentNodesOrPromise);
    window['__SSR_MACRO_PRELOAD_TOPX_FAILS__'] = topXFailed;
    return topXFailed;
}



const $7411787db12277fb$var$preloadMacrosSSRQuery = async ({ contentId: contentId, useMultipleMacrosQuery: useMultipleMacrosQuery, contentNodes: contentNodes, numberOfExtensionsToSSR: numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee) })=>{
    if (useMultipleMacrosQuery) return (0, $eb281dfded33b271$export$b470c165ef60e727)(contentId, contentNodes);
    else {
        const legacyBlocklistedExtensions = (0, $1xpoY.default).getString((0, $cd2d56ef117b2819$export$717eaf20c85e91ca), '');
        // if we're using MacrosQuery but this is the call for the old query, we need to
        // check if there are any blocklisted (for the Macros query) macros on the page
        // and attempt to use the old queries to render them instead
        const blocklistedExtensions = (0, $ld6xp.getMultiMacroQueryBlocklistFF)();
        return (0, $64a1b8a95751bd5c$export$f860aab1074a1289)(contentId, contentNodes, legacyBlocklistedExtensions, numberOfExtensionsToSSR, blocklistedExtensions);
    }
};
const $7411787db12277fb$export$64dcb3aec0dc81b3 = async ({ contentId: contentId, useMultipleMacrosQuery: useMultipleMacrosQuery, contentNodes: contentNodes, numberOfExtensionsToSSR: numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee) })=>{
    return $7411787db12277fb$var$preloadMacrosSSRQuery({
        contentId: contentId,
        useMultipleMacrosQuery: useMultipleMacrosQuery,
        contentNodes: contentNodes,
        numberOfExtensionsToSSR: numberOfExtensionsToSSR
    });
};



var $7K6Nt = parcelRequire("7K6Nt");


var $1i2qc = parcelRequire("1i2qc");








var $bS81H = parcelRequire("bS81H");

const $151aa4f2ef9a59b5$export$dc87c93837fe9dba = async (contentId, spaceKey)=>{
    const action = (0, $9wGTI.fg)('cc-dlp_split-attachment-dl-from-export-dsp') ? 'ATTACHMENT_DOWNLOAD' : 'PAGE_EXPORT';
    const response = await (0, $dYU3e.query)({
        query: (0, $bS81H.default),
        variables: {
            action: action,
            contentId: contentId,
            contentStatus: 'CURRENT',
            contentVersion: 1,
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/fabric-media-support"
    });
    return response;
};



var $aOHMQ = parcelRequire("aOHMQ");


var $28DDG = parcelRequire("28DDG");


var $22UVa = parcelRequire("22UVa");


var $1NBp8 = parcelRequire("1NBp8");


var $dhOY2 = parcelRequire("dhOY2");


var $7tT2b = parcelRequire("7tT2b");





var $axutP = parcelRequire("axutP");

function $853f14d41fe05930$export$fb43949e55e0c9d2({ cloudId: cloudId, spaceKey: spaceKey }) {
    return (0, $dYU3e.query)({
        query: (0, $axutP.default),
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/team-presence"
    });
}






var $9ycGg = parcelRequire("9ycGg");

parcelRequire("8nle6");



var $gBI6h = parcelRequire("gBI6h");


var $lt4mJ = parcelRequire("lt4mJ");


var $eSLr0 = parcelRequire("eSLr0");


var $5Rwa0 = parcelRequire("5Rwa0");








var $7Ndnw = parcelRequire("7Ndnw");


var $8CHHT = parcelRequire("8CHHT");


var $gDMf3 = parcelRequire("gDMf3");






var $e5EnV = parcelRequire("e5EnV");

function $c44bc7c35ccb995d$export$b39ebabf96e926c8(id) {
    return (0, $dYU3e.query)({
        query: (0, $e5EnV.default),
        variables: {
            id: id
        },
        __callerPackage__: "@confluence/no-permission"
    });
}



var $ePnB5 = parcelRequire("ePnB5");


var $3U5ab = parcelRequire("3U5ab");










async function $e85a231992f6246b$export$2563ff426f0d0b3b() {
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
            ]
        },
        __callerPackage__: "@confluence/experiment-omnibar"
    });
}



var $jsQRz = parcelRequire("jsQRz");





var $eDV4X = parcelRequire("eDV4X");


var $fD4xZ = parcelRequire("fD4xZ");

function $4e24c7560d847d2b$export$1c5f808d33dd5bee({ contentId: contentId }) {
    if (!contentId) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $fD4xZ.default),
        variables: {
            contentId: contentId,
            status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES),
            refetchQuery: false
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/labels"
    });
}












var $9xoMO = parcelRequire("9xoMO");





var $1k2r8 = parcelRequire("1k2r8");

const $ae623fc05873186d$export$8770175d3079e1c0 = [
    'onboarding-origin-state:attributes',
    'onboarding-state:isFoundingAdmin',
    'onboarding-state:isRedactionsTourVisible',
    'onboarding-state:isContentWrapperLabelsTourDismissed',
    'onboarding-state:isMoreActionsTourVisible',
    'onboarding-state:isMoreActionsHintVisible',
    'random:ShareAndRestrictDialog:spotlightSeen',
    'home-onboarding-takeover-v2:hasSeenHomeNudge',
    'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    'home-onboarding-takeover-v2:takeoverSeenAt',
    'home-onboarding-takeover-v2:onboardingActionStates',
    'home-onboarding-takeover-v2:isCollapsed',
    'home-onboarding-takeover-v2:hasSeenConfetti',
    'home-onboarding-takeover-v2:hasDismissedCarousel',
    'home-onboarding-takeover-v2:hasDismissedLearningResources',
    'home-onboarding-takeover-v2:hasDismissedTakeover',
    'editor-state:editorOnboardingEligiblity',
    'editor-state:editorVisited',
    'editor-state:wasDraftBannerSeen',
    'editor-state:isDraftBannerVisible',
    'editor-state:isLandInEditorBannerVisible',
    'editor-state:hasUserPublished',
    'editor-state:successFlagCompleted',
    'editor-state:recentSpotlightOpen',
    'editor-state:recentSpotlightCompleted',
    'editor-state:editorTutorialSuccessFlagCompleted',
    'editor-state:wasEditorConversionModalSeen',
    'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    'onboarding-intent-experiences:onboardingIntentExperienceLandClosed',
    'page:pagePresenceAvatarGroupSpotlightSeen',
    'page:pageTelepointerAvatarGroupSpotlightSeen',
    'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt',
    'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    'trial-components:dismissedTrialnullDayFlag',
    'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen',
    'land-in-sample-space:hasDismissedBanner',
    'land-in-sample-space:hasSeenSampleContentFlag',
    'live-page-nudge:wasLivePageNudgeSeen',
    'nav4:isNav4GlobalSpotlightDismissed',
    'nav4:isNav4SpaceTourDismissed',
    'personalized-templates-v2:onboardingActionStates',
    'personalized-templates-v2:hasDismissedOnboardingActions',
    'personalized-templates-v2:takeoverSeenAt',
    'personalized-templates-v2:isTemplateListDismissed',
    'personalized-templates-v2:templateUsageValues',
    'templates-collection:isTaggedForTemplatesCollectionExperiment',
    'templates-collection:isTemplatesSectionDismissed',
    'onboarding-state:introWorkflow',
    'onboarding-state:legacy',
    'onboarding-state:isSampleContentV2SpotlightVisible',
    'onboarding-state:landOnPath',
    'onboarding-state:teamSpaceCreated',
    'onboarding-state:improvedGetStartedPath',
    'onboarding-state:improvedGetStartedWhiteboardPath',
    'nav4:isNav4CollapseReminderSpotlightDismissed',
    'storage-enforcement-state:flagsDismissedFreeThreshold',
    'onboarding-state:nthUserOnboardingFlagViewed',
    'onboarding-state:nthUserOnboardingCompletedTimestamp',
    'onboarding-state:nthUserOnboardingPageViewed',
    'onboarding-state:nthUserGSPagePath',
    'onboarding-state:nthUserBannerDismissed'
];
const $ae623fc05873186d$export$c279cfd6dfc47585 = ()=>{
    // When the centralized onboarding state experiment is enabled, use the centralized preloader
    // to ensure all onboarding state queries hit the cache.
    if ((0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return (0, $1k2r8.preloadAllOnboardingState)();
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: (0, $9wGTI.fg)('confluence_preload_all_onboarding_keys') ? (0, $9xoMO.OnboardingKeysCombined) : $ae623fc05873186d$export$8770175d3079e1c0
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};






var $1swiX = parcelRequire("1swiX");





var $dpyxe = parcelRequire("dpyxe");





var $cRQNp = parcelRequire("cRQNp");


var $3Tnjq = parcelRequire("3Tnjq");




var $80xNa = parcelRequire("80xNa");
















var $aqBZ0 = parcelRequire("aqBZ0");


var $ccWUN = parcelRequire("ccWUN");


var $gFF2G = parcelRequire("gFF2G");

function $12c3454d795c5c51$export$3ae0996a709f5fba(contentId) {
    if (!contentId) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $gFF2G.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/archive-pages"
    }).then(({ data: data })=>{
        const contentStatus = data?.content?.nodes?.[0]?.status;
        const isContentArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
        if (isContentArchived) return (0, $dYU3e.query)({
            query: (0, $ccWUN.default),
            variables: {
                contentId: contentId
            },
            __callerPackage__: "@confluence/archive-pages"
        });
        return Promise.resolve();
    });
}


function $d3f749dabb808bb9$export$8114133102d6f1fd(contentId, spaceKey) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $fyUox.preloadPageTitleContentProperties)({
            contentId: contentId,
            spaceKey: spaceKey
        }),
        (0, $12c3454d795c5c51$export$3ae0996a709f5fba)(contentId)
    ]);
}



var $4trRg = parcelRequire("4trRg");







var $gad6U = parcelRequire("gad6U");

const $cc003fd311374024$export$7261e64a95ae02eb = (contentId)=>{
    return (0, $dYU3e.query)({
        query: (0, $gad6U.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/audio"
    });
};


/**
 * Preloads approval data for SSR.
 */ 
var $c0rhi = parcelRequire("c0rhi");





var $lKLmX = parcelRequire("lKLmX");

function $fa8eaa7cdcb1d432$export$2d00200c8fdc5d86({ cloudId: cloudId, contentId: contentId, contentStatus: contentStatus, spaceKey: spaceKey }) {
    const otherContentStatus = contentStatus === 'CURRENT' ? 'DRAFT' : 'CURRENT';
    return (0, $c0rhi.queryInterop)({
        query: (0, $lKLmX.default),
        variables: {
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            otherContentStatus: otherContentStatus,
            transitionType: null,
            spaceKey: spaceKey,
            includeApprovalsBetaFeatures: (0, $9wGTI.fg)('confluence_approvals_beta')
        },
        __callerPackage__: "@confluence/approvals"
    });
}


/**
 * @generated SignedSource<<1f63863ff73605ac57bbe7e6d963dc7d>>
 * @relayHash b2979c7cdb495363844387e7ca70adab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b7a1ec5233246939ca5d1e47156b6777dfd302edb1f892f73f595aecfdb1c2b5
const $b901c22c72a3c746$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v2 = [
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "kind": "ScalarField",
            "name": "hasUserAccessAdminRole"
        },
        {
            "kind": "ScalarField",
            "name": "userCanCreateContent"
        },
        {
            "kind": "ScalarField",
            "name": "isNewUser"
        },
        {
            "concreteType": "CurrentConfluenceUser",
            "kind": "LinkedField",
            "name": "currentConfluenceUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isAnonymous"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "kind": "ScalarField",
                    "name": "timeZone"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "locale"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "UnifiedUserQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "UnifiedUserQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "b2979c7cdb495363844387e7ca70adab",
            "id": "b7a1ec5233246939ca5d1e47156b6777dfd302edb1f892f73f595aecfdb1c2b5",
            "metadata": {},
            "name": "UnifiedUserQuery",
            "operationKind": "query",
            "text": "query UnifiedUserQuery{isSiteAdmin,hasUserAccessAdminRole,userCanCreateContent,isNewUser,currentConfluenceUser{isAnonymous},user:confluence_atlassianUser(current:true){id,displayName,timeZone,photos{value,isPrimary},emails{value,isPrimary},confluence{permissionType,space{id},operations{operation,targetType},accessStatus,accountId,userKey,locale}}}"
        }
    };
}();
$b901c22c72a3c746$var$node.hash = "587fceb239a4e30f4440f813cd8683f5";
var $b901c22c72a3c746$export$2e2bcd8739ae039 = $b901c22c72a3c746$var$node;


const $445d6fd463fd83fa$var$DEFAULT_PRELOAD_RECOMMENDATION_TIMEOUT = 700;
const $445d6fd463fd83fa$var$createPreloadContentTask = (contentId, isBlog, spaceKey, cloudId, contentNodesPromiseResolve, userId, agentSessionsEnabled)=>{
    return (0, $kkLBe.prepareGuardExceptionTask)('Content', ()=>(0, $1acff4ea84553836$export$97ce9ab4bdd6b3fc)({
            contentId: contentId,
            isBlog: isBlog,
            spaceKey: spaceKey,
            userId: userId,
            agentSessionsEnabled: agentSessionsEnabled
        }).then(({ result: result, hasErrors: hasErrors })=>{
            contentNodesPromiseResolve?.(result?.data?.content?.nodes);
            if (hasErrors) return (0, $lyWac.waitForAllReturnWhenError)([
                (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey),
                (0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId),
                (0, $6dc053709e1de01d$export$4a518872c59a5d22)({
                    contentId: contentId,
                    draftShareId: window.location.search.match(/draftShareId=(.*?)(#|&|$)/)?.[1] ?? ''
                })
            ]);
            else var error;
        }));
};
const $445d6fd463fd83fa$var$createContentMainTasks = (params)=>{
    const { spaceKey: spaceKey, contentId: contentId, username: username, edition: edition, isPrevEditRoute: isPrevEditRoute, isBlog: isBlog, cloudId: cloudId, contentNodesPromiseResolve: contentNodesPromiseResolve, contentNodesPromise: contentNodesPromise, isInitialLoad: isInitialLoad, userId: userId, agentSessionsEnabled: agentSessionsEnabled } = params;
    return [
        (0, $furnK.preloadContentHeader)({
            spaceKey: spaceKey,
            contentId: contentId,
            username: username,
            edition: edition,
            isPrevEditRoute: isPrevEditRoute,
            useNewContentTopper: true
        }),
        (0, $d3f749dabb808bb9$export$8114133102d6f1fd)(contentId, spaceKey),
        (0, $fyUox.preloadPageTitleContentProperties)({
            contentId: contentId,
            spaceKey: spaceKey
        }),
        (0, $kkLBe.prepareGuardExceptionTask)('Macros', ()=>(0, $7411787db12277fb$export$64dcb3aec0dc81b3)({
                contentId: contentId,
                useMultipleMacrosQuery: true,
                contentNodes: contentNodesPromise
            })),
        (0, $kkLBe.prepareGuardExceptionTask)('MacroData', ()=>(0, $7K6Nt.preloadMacroData)({
                contentNodes: contentNodesPromise,
                context: {
                    contentId: contentId,
                    spaceKey: spaceKey
                },
                route: 'view'
            })),
        $445d6fd463fd83fa$var$createPreloadContentTask(contentId, isBlog, spaceKey, cloudId || '', contentNodesPromiseResolve, userId, agentSessionsEnabled),
        (0, $gBI6h.preloadPageStatusQuery)(contentId),
        (0, $lt4mJ.preloadLegacyBridge)({
            contentId: contentId,
            isBlog: isBlog
        }),
        (0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            includeContentBody: false,
            useCache: true
        }),
        // SmartLinks: keep original non-suspense fetcher behavior when experiment is disabled
        ...!isInitialLoad && !(0, $6mKj3.expVal)('confluence_remove_preload_smartlinks_on_transition', 'isEnabled', false) || isInitialLoad && !(0, $6mKj3.expVal)('confluence_smartlinks_suspense', 'isEnabled', false) ? [
            (0, $9eb88ac593a96a41$export$dc2d6742e80fba3c)(contentId)
        ] : []
    ];
};
const $445d6fd463fd83fa$export$9503d022471fff24 = async (match, url, isTransition = false, previousMatch = null)=>{
    const { isLicensed: isLicensed, userId: userId, edition: edition, cloudId: cloudId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, environment: environment, isAdminHubAIEnabled: isAdminHubAIEnabled, activationId: activationId } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    // following functions will be triggered after we load data
    const postLoadingTasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    const username = (0, $1swiX.getUsername)(match);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const isBlog = Boolean((0, $kM8fE.matchBlogPage)(url));
    const isInitialLoad = !isTransition;
    const shouldPreloadNavigation = !isEmbeddedConfluence && (isInitialLoad || (0, $1swiX.shouldPreloadNavigationForTransition)(previousMatch));
    // Get isArchived from cached page data
    const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
    // Don't preload queries that will be updated by editor if previous route is edit_page
    const isPrevEditRoute = previousMatch?.name === (0, $1NBp8.EDIT_PAGE_V2).name || previousMatch?.name === (0, $1NBp8.EDIT_BLOG_V2).name || previousMatch?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || previousMatch?.name === (0, $1NBp8.HUB_EDIT).name;
    if (isPrevEditRoute && isTransition) // Preload for edit -> view transition
    return (0, $furnK.preloadContentHeader)({
        spaceKey: spaceKey,
        contentId: contentId,
        username: username,
        edition: edition,
        isPrevEditRoute: isPrevEditRoute,
        useNewContentTopper: true
    });
    if ((0, $9wGTI.fg)('confluence_preload_user_data')) tasks.push((0, $dYU3e.query)({
        query: (0, $b901c22c72a3c746$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/query-preloaders"
    }));
    if (!isPrevEditRoute) tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, edition === (0, $80xNa.CONFLUENCE_EDITION).FREE));
    if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) tasks.push((0, $fa8eaa7cdcb1d432$export$2d00200c8fdc5d86)({
        cloudId: cloudId,
        contentId: contentId,
        contentStatus: 'CURRENT',
        spaceKey: spaceKey
    }));
    // Content types header (object header) + Unified Share and Restrict Button
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-types-header', ()=>{
        const contentTypesHeaderPreloadTasks = [];
        if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) contentTypesHeaderPreloadTasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            contentTypesHeaderPreloadTasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, true));
            // preload data for whether "unpublished changes" label should show in view page object header
            contentTypesHeaderPreloadTasks.push((0, $4vyfK.preloadWebItemLocation)({
                location: 'page.metadata.banner',
                contentId: contentId
            }));
        }
        // (No need to call preloadPageRestrictionsQuery() here; it will be called by
        //  preloadContentHeader() )
        return contentTypesHeaderPreloadTasks;
    }));
    // Content main
    let contentNodesPromiseResolve = undefined;
    const contentNodesPromise = new Promise((resolve)=>{
        contentNodesPromiseResolve = resolve;
    });
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>{
        const mainTasks = $445d6fd463fd83fa$var$createContentMainTasks({
            spaceKey: spaceKey,
            contentId: contentId,
            username: username,
            edition: edition,
            isPrevEditRoute: isPrevEditRoute,
            isBlog: isBlog,
            cloudId: cloudId,
            contentNodesPromiseResolve: contentNodesPromiseResolve,
            contentNodesPromise: contentNodesPromise,
            isInitialLoad: isInitialLoad,
            userId: userId,
            // confluence-feature-gating/inline-usage: must be inlined
            agentSessionsEnabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)
        });
        if (isInitialLoad && isLoggedIn && (0, $6mKj3.expVal)('confluence_end_of_page_recs_suspense', 'isEnabled', false)) mainTasks.push((0, $eS4vC.createDataFetcherForSuspense)('end-of-page-recommendations', ()=>(0, $dhOY2.preloadEndOfPageRecommendation)({
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: isBlog ? 'blogpost' : 'page'
            })));
        return mainTasks;
    }));
    // SmartLinks preloaded with Suspense data fetcher outside of content-main suspense boundary
    if (isInitialLoad && (0, $6mKj3.expVal)('confluence_smartlinks_suspense', 'isEnabled', false)) (0, $df3ec02d5ab74bd9$export$b30149a5ef7702c0)(contentId);
    tasks.push((0, $4trRg.preloadContentMode)({
        contentId: contentId,
        isDraft: false,
        useCache: true,
        isArchived: isArchived
    }));
    // Navigation, Page tree and blog tree for blog post
    if (shouldPreloadNavigation) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
        return (0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog, previousMatch?.params?.spaceKey);
    }));
    // Space details
    tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    // Inline Comments
    if (match?.query.focusedCommentId) tasks.push((0, $aOHMQ.preloadFocusedInlineComment)(match?.query.focusedCommentId, contentId));
    // Reactions
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('page-reactions', match)) {
        // Preload whether the server has enabled reactions at all to show placeholder
        tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        }));
        // Preload reactions asynchronously so SSR won't wait for it
        // it's best effort preloading so if it preloads then we have the data, otherwise SPA can load it
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        }));
    }
    // Recommendations
    if (!isInitialLoad || !(0, $6mKj3.expVal)('confluence_end_of_page_recs_suspense', 'isEnabled', false)) // Only preload recommendations for authenticated users (knowledge_discovery service requires auth)
    {
        if (isLoggedIn) {
            const recommendationsTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_recommendation_timeout', $445d6fd463fd83fa$var$DEFAULT_PRELOAD_RECOMMENDATION_TIMEOUT);
            tasks.push((0, $wPrRK.slowQueryGuard)('preloadEndOfPageRecommendation', ()=>{
                return (0, $dhOY2.preloadEndOfPageRecommendation)({
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: isBlog ? 'blogpost' : 'page'
                });
            }, recommendationsTimeout));
        }
    }
    // Stuff only needed for initial load
    if (isInitialLoad) {
        tasks.push(// We only refresh token when it is about to expire.
        (0, $1i2qc.preloadMediaToken)(contentId));
        tasks.push((0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey));
        if ((0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) tasks.push((0, $151aa4f2ef9a59b5$export$dc87c93837fe9dba)(contentId, spaceKey));
    }
    // Preload onboarding state for view page
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS) && !isTransition && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) tasks.push((0, $ae623fc05873186d$export$c279cfd6dfc47585)());
    // Labels
    if (isTransition) tasks.push((0, $4e24c7560d847d2b$export$1c5f808d33dd5bee)({
        contentId: contentId
    }));
    // Preload web panel atl_general
    if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
        contentId: contentId,
        locations: [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ]
    }));
    else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    // Object Sidebar Control + AI Button
    if (isAdminHubAIEnabled) {
        if ((0, $6mKj3.expValEquals)('reduce_queries_in_default_suspense', 'isEnabled', true)) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('ai-floating-context-menu', ()=>(0, $28DDG.preloadAIFloatingContextMenu)(contentId, isBlog)));
        else tasks.push((0, $28DDG.preloadAIFloatingContextMenu)(contentId, isBlog));
    }
    // Preload Audio Listen Button
    tasks.push((0, $cc003fd311374024$export$7261e64a95ae02eb)(contentId));
    const extensionListLoader = ()=>(0, $8CHHT.preloadUseExtensionList)({
            contentId: contentId,
            spaceKey: spaceKey,
            moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
        });
    tasks.push(extensionListLoader());
    // Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        activationId: activationId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId,
        environment: environment
    }));
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    // Preload definition autohighlights
    // Only preload autohighlights for authenticated users (knowledge_discovery service requires auth)
    if (isLoggedIn) tasks.push((0, $7309ff12be989147$export$a95d48b280e02650)({
        contentId: contentId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: isBlog ? 'blogpost' : 'page'
    }));
    // Preload footer comments for the redesigned footer comment experience
    // SSRing live pages necessitates non-server (i.e. transition) preloading, so enable here too for consistency in the footer component
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        const preloadObjectCommentsTask = ()=>(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? (0, $3U5ab.preloadObjectComments)(contentId) : (0, $ePnB5.preloadFooterComments)(contentId, isArchived);
        if ((0, $6mKj3.expValEquals)('reduce_queries_in_default_suspense', 'isEnabled', true)) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('object-comments', ()=>[
                preloadObjectCommentsTask(),
                (0, $jsQRz.preloadAddCommentPermissionCheck)(contentId)
            ]));
        else {
            tasks.push(preloadObjectCommentsTask());
            // Preload add comment permission check for the redesigned footer comment experience
            tasks.push((0, $jsQRz.preloadAddCommentPermissionCheck)(contentId));
        }
    }
    // Preload onboarding state for view page (only if not already preloaded by centralized experiment)
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS) && (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) {
        if (isTransition || !(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) tasks.push((0, $ae623fc05873186d$export$c279cfd6dfc47585)());
    }
    // Preload OmniBar if the experiment is enabled (any of the omnibar engagement gates)
    if ((0, $9wGTI.fg)('cc-engagement-omnibar-hide-inline-comments') || (0, $9wGTI.fg)('cc-engagement-omnibar-hide-highlight-actions') || (0, $9wGTI.fg)('cc-engagement-omnibar-hide-sidebar-flyout')) {
        tasks.push((0, $e85a231992f6246b$export$2563ff426f0d0b3b)());
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        }));
    }
    // Preload Smart Create Feedback Banner
    if ((0, $9wGTI.fg)('aifc_create_enabled')) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    const errors = await (0, $lyWac.waitForAllReturnWhenError)(tasks);
    const postLoadingErrors = await (0, $lyWac.waitForAllReturnWhenError)(postLoadingTasks.map((task)=>task()));
    if (errors || postLoadingErrors) return [
        ...errors || [],
        ...postLoadingErrors || []
    ];
};








/**
 * @generated SignedSource<<e1d07984b577db48b7ecdd332628cb11>>
 * @relayHash 9db18599ae8276f38e57885f4b3ed842
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edafd438720a1dc9f3ad7178421078636892a9a16b7d545d094272279358a150
const $05c40bb113a7d622$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOverviewIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOverviewIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9db18599ae8276f38e57885f4b3ed842",
            "id": "edafd438720a1dc9f3ad7178421078636892a9a16b7d545d094272279358a150",
            "metadata": {},
            "name": "SpaceOverviewIdQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewIdQuery($spaceKey:String){space(key:$spaceKey){id,homepageId}}"
        }
    };
}();
$05c40bb113a7d622$var$node.hash = "7fd7786f0088a31ebf4c6fb6bedcf998";
var $05c40bb113a7d622$export$2e2bcd8739ae039 = $05c40bb113a7d622$var$node;


function $12a2f5ca95176b67$export$c390629d140bb37e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $05c40bb113a7d622$export$2e2bcd8739ae039),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/content-types-header"
    }).then((result)=>({
            result: result,
            hasErrors: result.hasErrors
        }));
}





















var $8vxJi = parcelRequire("8vxJi");








var $eq95w = parcelRequire("eq95w");







function $75c1298c647aa5e8$export$f26c9f918e5ab17(resource) {
    const nonce = window.__SSR_NONCE_VALUE__;
    if (resource.resourceType === 'CSS') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}" data-key="${resource.key}" data-batch-type="${resource.batchType}"${resource.ieOnly ? ' data-ie-only="true"' : ''} />`;
    else if (resource.resourceType === 'JAVASCRIPT') return `<script nonce="${nonce}" src="${resource.url}" data-key="${resource.key}" data-batch-type="${resource.batchType}"${resource.ieOnly ? ' data-ie-only="true"' : ''}></script>`;
    return '';
}


// Track the connect resources promise so it can be awaited before rendering head
let $64996f4302e0f23b$var$connectWebResourcesPromise = null;
const $64996f4302e0f23b$export$253d53ce310d89cb = ()=>$64996f4302e0f23b$var$connectWebResourcesPromise;
const $64996f4302e0f23b$export$5749ba203d594aae = ()=>{
    $64996f4302e0f23b$var$connectWebResourcesPromise = null;
};
const $64996f4302e0f23b$var$getPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $64996f4302e0f23b$export$51bf8f21dab6d404 = (contentId, locations = [
    (0, $eSLr0.ATL_GENERAL),
    (0, $eSLr0.ATL_FOOTER)
])=>{
    const promise = (async ()=>{
        if (!((0, $9wGTI.fg)('content_early_connect_iframe_initialization') || (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false))) return;
        // When early webpanel initialization is enabled, check if there are any webpanels
        // before preloading connect resources
        if (contentId) {
            const uniqueLocations = Array.from(new Set(locations.filter(Boolean)));
            if (uniqueLocations.length === 0) return;
            let panelsByLocation = new Map();
            const webPanelPromises = (0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true) ? [
                (0, $5Rwa0.preloadWebPanelLocations)({
                    contentId: contentId,
                    locations: uniqueLocations
                }).then((result)=>{
                    panelsByLocation = $64996f4302e0f23b$var$getPanelsByLocation(result.data?.webPanels);
                })
            ] : uniqueLocations.map((location)=>(0, $dYU3e.query)({
                    query: (0, $eq95w.default),
                    variables: {
                        contentId: contentId,
                        location: location
                    },
                    __callerPackage__: "@confluence/fabric-extension-handlers"
                }).then((result)=>{
                    const locationPanels = [];
                    result.data?.webPanels?.forEach((panel)=>{
                        if (panel) locationPanels.push(panel);
                    });
                    panelsByLocation.set(location, locationPanels);
                }));
            // Wait for web panel probes, but don't fail fast if one errors
            const errors = await (0, $lyWac.waitForAllReturnWhenError)(webPanelPromises);
            if (errors) // If webpanel queries failed, continue with preloading to avoid blocking
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Failed to query webpanels before preloading connect resources: ${errors.map((e)=>e.message).join(', ')}`));
            else {
                const hasWebPanels = uniqueLocations.some((location)=>(panelsByLocation.get(location)?.length ?? 0) > 0);
                if (!hasWebPanels) return;
            }
        }
        try {
            const response = await (0, $f7B1p.cfetch)('/wiki/rest/webResources/1.0/resources', {
                method: 'POST',
                body: JSON.stringify({
                    r: [
                        'confluence.web.resources:querystring',
                        'confluence.web.resources:navigator-context',
                        'com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5',
                        'confluence.web.resources:view-content',
                        'confluence.macros.advanced:get-more',
                        'com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources'
                    ],
                    c: [],
                    xc: [
                        '_super'
                    ],
                    xr: [
                        'com.atlassian.plugins.jquery:jquery',
                        'com.atlassian.plugins.jquery:jquery-migrate'
                    ]
                })
            });
            if (!response.ok) throw new Error(`Failed to preload web resources: ${response.status}`);
            const data = await response.json();
            // unparsedData in the response will later be claimed by window.WRM.data.claim()
            // This need to be fore all the JS scripts because they might claim the data while executing.
            if (data?.unparsedData) {
                const entries = [];
                for (const [key, value] of Object.entries(data.unparsedData))// value is a stringified JSON object.
                entries.push(`d["${key}"]=${(0, $8vxJi.stringifyForSSR)(value)}`);
                (0, $iHLZT.superbatchJSRecorder).addConnectResource(`<script>(function(d){if(d){${entries.join(';')}}})(window?.WRM?._unparsedData)</script>`);
            }
            (0, $iHLZT.superbatchJSRecorder).addConnectResource(data?.resources?.filter((resource)=>resource.resourceType === 'JAVASCRIPT')?.map((resource)=>(0, $75c1298c647aa5e8$export$f26c9f918e5ab17)(resource)).join('\n'));
            (0, $iHLZT.superbatchCSSRecorder).addConnectResource(data?.resources?.filter((resource)=>resource.resourceType === 'CSS')?.map((resource)=>(0, $75c1298c647aa5e8$export$f26c9f918e5ab17)(resource)).join('\n'));
        } catch (error) {
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Unable to preload connect web resources: ${error.message}`));
        }
    })();
    $64996f4302e0f23b$var$connectWebResourcesPromise = promise;
    return promise;
};






var $7tHGa = parcelRequire("7tHGa");





var $gSfo4 = parcelRequire("gSfo4");


var $79mss = parcelRequire("79mss");

function $2257f3db82626244$export$fc412545d4d6ad12(contentId, contentStatus) {
    return (0, $dYU3e.query)({
        query: (0, $79mss.default),
        variables: {
            contentId: contentId,
            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)([
                contentStatus
            ])
        },
        __callerPackage__: "@confluence/data-classification"
    });
}


async function $c7f6674d8ea135ae$export$137d64ae0bf4fe94(contentId) {
    const queries = [];
    queries.push((0, $2257f3db82626244$export$fc412545d4d6ad12)(contentId, (0, $7tHGa.ContentStatus).CURRENT));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}























var $d3OVq = parcelRequire("d3OVq");

function $5fc5440e5bdafbe2$export$f73e4f65960ffd6e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $d3OVq.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/space-base"
    });
}



var $ivyMZ = parcelRequire("ivyMZ");


var $6anVB = parcelRequire("6anVB");


var $5iG5Q = parcelRequire("5iG5Q");














var $cEgMD = parcelRequire("cEgMD");





var $6SSyC = parcelRequire("6SSyC");

function $7df05aa0881398cb$export$ac86736f8ee66015(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $6SSyC.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/screen"
    });
}






var $ixL26 = parcelRequire("ixL26");








var $3hHGU = parcelRequire("3hHGU");


var $jpSPX = parcelRequire("jpSPX");








var $3D1KL = parcelRequire("3D1KL");

function $428e758fdbd08d59$export$9a90cdaf2bd47339({ contentId: contentId, spaceKey: spaceKey }) {
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:pageButtons', async ()=>{
        const tasks = [
            (0, $3D1KL.preloadEditButton)({
                spaceKey: spaceKey,
                contentId: contentId
            })
        ];
        return (0, $lyWac.waitForAllReturnWhenError)(tasks);
    });
}


const $79570d1de8e3464e$export$ba9b2fb7540ef84 = (spaceKey)=>(0, $dYU3e.query)({
        query: (0, $ixL26.default),
        variables: {
            spaceKey: spaceKey,
            excludeOperations: Boolean(!(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey))
        },
        __callerPackage__: "@confluence/space-overview"
    });
const $79570d1de8e3464e$export$50a212ec809090eb = (spaceKey)=>{
    const { cloudId: cloudId, isRovoEnabled: isRovoEnabled } = (0, $xwvlW.getPreloaderFnContext)();
    if (!(0, $jpSPX.isSmartSpaceOverviewEnabled)({
        spaceKey: spaceKey,
        cloudId: cloudId,
        isRovoEnabled: isRovoEnabled
    })) return Promise.resolve(null);
    return (0, $dYU3e.query)({
        query: (0, $3hHGU.default),
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/space-overview"
    });
};
const $79570d1de8e3464e$var$preloadSpaceOverviewQueries = async ({ homepageId: homepageId = '', spaceKey: spaceKey, previousMatch: previousMatch, versionOverride: versionOverride, skipPageTreePreload: skipPageTreePreload = false })=>{
    const tasks = [];
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    let contentNodesPromiseResolve = undefined;
    const contentNodesPromise = new Promise((resolve)=>{
        contentNodesPromiseResolve = resolve;
    });
    if (homepageId) {
        // If we know the homepageId, preload early
        tasks.push((0, $c7f6674d8ea135ae$export$137d64ae0bf4fe94)(homepageId));
        if ((0, $6mKj3.expVal)('confluence_preload_content_types_header_query', 'isEnabled', false)) tasks.push((0, $4zhNK.preloadContentTypesHeader)(homepageId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        tasks.push((0, $kkLBe.prepareGuardExceptionTask)('MacroData', ()=>(0, $7K6Nt.preloadMacroData)({
                contentNodes: contentNodesPromise,
                context: {
                    contentId: homepageId,
                    spaceKey: spaceKey
                },
                route: 'space-overview'
            })));
    }
    tasks.push((0, $kkLBe.prepareGuardExceptionTask)('ContentAndMacros', ()=>(0, $1acff4ea84553836$export$97ce9ab4bdd6b3fc)({
            contentId: homepageId,
            spaceKey: spaceKey,
            isBlog: false,
            versionOverride: versionOverride,
            userId: userId,
            // Mirror preloadViewPageRoute so the space-overview homepage preload uses the same
            // ContentUnifiedQuery variable shape (and cache key) as the live ViewPageContainer read.
            // confluence-feature-gating/inline-usage: expValEquals must be inlined at the callsite.
            agentSessionsEnabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)
        }).then(({ result: result, hasErrors: hasErrors })=>{
            const contentId = homepageId || result?.data?.content?.nodes[0]?.id;
            // in the event that there are errors (no id from result) and the homepageId is not valid (error when loading the space),
            // bypass preloadContentPrereqs since contentId is undefined
            if (!contentId) return;
            contentNodesPromiseResolve?.(result?.data?.content?.nodes);
            const promises = [];
            if (!homepageId) {
                // If we don't know the homepageId, preloadContent will tell us the id
                promises.push((0, $7411787db12277fb$export$64dcb3aec0dc81b3)({
                    contentId: contentId,
                    useMultipleMacrosQuery: true,
                    contentNodes: result?.data?.content?.nodes
                }));
                tasks.push((0, $c7f6674d8ea135ae$export$137d64ae0bf4fe94)(contentId));
                if ((0, $6mKj3.expVal)('confluence_preload_content_types_header_query', 'isEnabled', false)) tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
                promises.push((0, $7K6Nt.preloadMacroData)({
                    contentNodes: result?.data?.content?.nodes,
                    context: {
                        contentId: contentId,
                        spaceKey: spaceKey
                    },
                    route: 'space-overview'
                }));
            }
            if (hasErrors) promises.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey, {
                versionOverride: versionOverride
            }));
            return (0, $lyWac.waitForAllReturnWhenError)(promises);
        })), (0, $428e758fdbd08d59$export$9a90cdaf2bd47339)({
        contentId: homepageId,
        spaceKey: spaceKey
    }));
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: homepageId,
        spaceKey: spaceKey
    }));
    const shouldPreloadPageTree = !skipPageTreePreload && // When the consolidated preloader gate is on, navigation (including page tree + blog tree) is
    // preloaded by preloadSpaceOverviewRoute via preloadNavigationTasks instead, so skip it here.
    !(0, $9wGTI.fg)('space_overview_preloader_consolidation') && previousMatch && previousMatch?.params?.spaceKey !== spaceKey; // preload page tree on transition if the previous space key is different from the new space key
    if (shouldPreloadPageTree) tasks.push((0, $6anVB.preloadPageTree)({
        contentId: homepageId,
        spaceKey: spaceKey,
        statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        isSuperAdmin: false
    }), (0, $5iG5Q.preloadBlogTree)({
        spaceKey: spaceKey
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
async function $79570d1de8e3464e$export$2fae7b45037154b8({ spaceKey: spaceKey, homepageId: homepageId, homepageIdPromise: homepageIdPromise, previousMatch: previousMatch, versionOverride: versionOverride }) {
    const promises = [
        (0, $7df05aa0881398cb$export$ac86736f8ee66015)(spaceKey),
        (0, $5fc5440e5bdafbe2$export$f73e4f65960ffd6e)(spaceKey),
        (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey),
        $79570d1de8e3464e$export$50a212ec809090eb(spaceKey)
    ];
    if (homepageId || homepageIdPromise) {
        // In some case we append homepageId as a query param. Then preload with it.
        // next/packages/space-overview/src/SpaceOverview.tsx still needs SpaceOverviewQuery but others are not depending on it
        promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey), $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
            homepageId: homepageId,
            spaceKey: spaceKey,
            previousMatch: previousMatch,
            versionOverride: versionOverride
        }));
        if ((0, $6mKj3.expVal)('confluence_preload_share_and_restrict_button_query', 'isEnabled', false)) promises.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(homepageId, spaceKey));
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    } else if (Boolean(undefined)) {
        // Use new query to preload as space key then transform to the old queries.
        // next/packages/space-overview/src/SpaceOverview.tsx still needs SpaceOverviewQuery but others are not depending on it
        promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey), $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
            spaceKey: spaceKey
        }));
        if ((0, $6mKj3.expVal)('confluence_preload_share_and_restrict_button_query', 'isEnabled', false)) promises.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(undefined, spaceKey));
    } else {
        const isEarlyPageTreePreloadEnabled = !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && // When the consolidated preloader gate is on, the route preloads the page tree via
        // preloadNavigationTasks, so skip the early transition preload here to avoid duplicate work.
        !(0, $9wGTI.fg)('space_overview_preloader_consolidation') && (0, $6mKj3.expVal)('confluence_optimize_overview_transition_nav', 'isEnabled', false);
        if (isEarlyPageTreePreloadEnabled && previousMatch?.params?.spaceKey !== spaceKey) promises.push((0, $6anVB.preloadPageTree)({
            spaceKey: spaceKey,
            statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
            isSuperAdmin: false,
            fetchPolicy: 'network-only'
        }), (0, $5iG5Q.preloadBlogTree)({
            spaceKey: spaceKey,
            fetchPolicy: 'network-only'
        }));
        if ((0, $6mKj3.expVal)('confluence_preload_share_and_restrict_button_query', 'isEnabled', false)) // Preload share button data with spaceKey early (before homepageId is known)
        promises.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(undefined, spaceKey));
        // If we have no information on home id and yet using old query, we need to fetch it first.
        promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey).then((res)=>{
            // Because homepageId was provided by the function caller, it may or may
            // not be out of sync with backend:
            const actualHomepageId = res?.data?.space?.homepage?.id;
            if (actualHomepageId) return $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
                homepageId: actualHomepageId,
                spaceKey: spaceKey,
                previousMatch: previousMatch,
                versionOverride: versionOverride,
                skipPageTreePreload: isEarlyPageTreePreloadEnabled
            });
        }));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
}












parcelRequire("8nle6");






var $jtfsl = parcelRequire("jtfsl");

function $3c8474b5b6cc7016$export$986e86a20e675444({ accountId: accountId }) {
    return (0, $dYU3e.query)({
        query: (0, $jtfsl.default),
        variables: {
            accountId: accountId
        },
        __callerPackage__: "@confluence/custom-sites-extensions"
    });
}

















const $de1bf574523c3b16$export$7237b12e4aa9c6c = async ()=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (activationId && cloudId) return `~HUB-${cloudId}-${activationId}~`;
};










var $c3Qwv = parcelRequire("c3Qwv");






























const $5cdf3a7c2cbff10f$export$2cbe0869fedf40d1 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.CROSS_JOIN_NTH_USER_ONBOARDING).TRENDING_PAGES,
                (0, $dBcar.CROSS_JOIN_NTH_USER_ONBOARDING).DISMISSED
            ]
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};


const $fe22b38e04163065$var$homepageIdPromiseMap = new Map();
const $fe22b38e04163065$var$homepageIdMap = new Map();
const $fe22b38e04163065$var$loadHomepageId = async (spaceKey)=>{
    const { result: result, hasErrors: hasErrors } = await (0, $12a2f5ca95176b67$export$c390629d140bb37e)(spaceKey);
    return !hasErrors && result?.data?.space?.homepageId || null;
};
const $fe22b38e04163065$export$75a73f2fbf5e96e8 = async (match)=>{
    const { spaceKey: spaceKey } = match.params;
    const homepageId = match.query ? (0, $c3Qwv.getSingleParam)(match.query, (0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY) : undefined;
    if (homepageId) return;
    const homepageIdPromise = $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey) ?? $fe22b38e04163065$var$loadHomepageId(spaceKey);
    // Keep both maps in sync - promises and actual values for synchronous access
    $fe22b38e04163065$var$homepageIdPromiseMap.set(spaceKey, homepageIdPromise);
    return homepageIdPromise.then((homepageId)=>{
        $fe22b38e04163065$var$homepageIdMap.set(spaceKey, homepageId);
    });
};
const $fe22b38e04163065$export$75071d943b36f58f = async (match, previousMatch, _url)=>{
    const { cloudId: cloudId, isLicensed: isLicensed, userId: userId, activationId: activationId, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    const { spaceKey: spaceKey } = match.params;
    const initialHomepageId = match.query ? (0, $c3Qwv.getSingleParam)(match.query, (0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY) : undefined;
    const tasks = [];
    spaceKey && (0, $9wGTI.fg)('space_overview_preloader_consolidation');
    const isCompanyHub = match.name === (0, $1NBp8.COMPANY_HUB).name;
    const companyHubSpaceKey = isCompanyHub ? await (0, $de1bf574523c3b16$export$7237b12e4aa9c6c)() : undefined;
    const versionOverride = companyHubSpaceKey && match.query ? (0, $c3Qwv.getSingleParamInt)(match.query, 'versionOverride') : null;
    const homepageId = initialHomepageId || $fe22b38e04163065$var$homepageIdMap.get(spaceKey ?? companyHubSpaceKey);
    if (spaceKey && (0, $9wGTI.fg)('space_overview_preloader_consolidation')) {
        // Consolidated navigation preloading: use the shared helper (page tree + blog tree included)
        // like the view page route, instead of splitting nav queries between this route and
        // preloadSpaceOverview. Company hub has no `spaceKey` route param, so it is naturally excluded
        // here — preserving the prior behaviour where the page tree was not preloaded for company hub.
        const isCrossSpaceTransition = Boolean(previousMatch && previousMatch.params?.spaceKey !== spaceKey);
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (isCrossSpaceTransition) tasks.push((0, $dpyxe.preloadNavigationTasks)(spaceKey, homepageId ?? '', isLicensed, false, // space overview is never a blog
        previousMatch?.params?.spaceKey));
    }
    tasks.push((0, $79570d1de8e3464e$export$2fae7b45037154b8)({
        spaceKey: spaceKey ?? companyHubSpaceKey,
        homepageId: homepageId,
        homepageIdPromise: $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey ?? companyHubSpaceKey),
        previousMatch: previousMatch,
        versionOverride: versionOverride
    }));
    if (homepageId) {
        // Get isArchived from cached page data
        const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(homepageId ?? undefined);
        tasks.push((0, $4trRg.preloadContentMode)({
            contentId: homepageId,
            isDraft: true,
            useCache: true,
            isArchived: isArchived
        }));
    }
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: homepageId || '',
        contentIdPromise: $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey ?? companyHubSpaceKey),
        spaceKey: spaceKey ?? companyHubSpaceKey
    }));
    if ((0, $9wGTI.fg)('content_early_connect_iframe_initialization') || (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
        // Preload superbatch
        tasks.push((0, $kkLBe.prepareGuardExceptionTask)('Superbatch', ()=>(0, $821e100427ee88aa$export$ce64f7b5556cdb62)({
                preloadSuperBatchForSSR: true
            })));
        // Preload Connect web resources
        tasks.push((0, $kkLBe.prepareGuardExceptionTask)('Connect Web Resources', ()=>(0, $64996f4302e0f23b$export$51bf8f21dab6d404)(homepageId)));
    }
    tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    if ((0, $6mKj3.expValEquals)('cc_ssr_crossjoin_nth_user_onboarding', 'isEnabled', true)) tasks.push((0, $5cdf3a7c2cbff10f$export$2cbe0869fedf40d1)());
    if (isCompanyHub && userId) tasks.push((0, $3c8474b5b6cc7016$export$986e86a20e675444)({
        accountId: userId
    }));
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    // Space Overview's homepageId is needed for the content types header, but may not be in the URL
    // depending on which route was used.  skip preloading if it's not in the url because sequential calls block SSR
    if (!isCompanyHub && homepageId && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(homepageId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        // Standalone Restrictions button needs to have its data preloaded)
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(homepageId, false));
    }
    // Unified Share and Restrict Button
    if (!isCompanyHub && homepageId && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(homepageId));
    // Preload definition autohighlights
    // Only preload autohighlights for authenticated users (knowledge_discovery service requires auth)
    if (homepageId && isLoggedIn) tasks.push((0, $7309ff12be989147$export$a95d48b280e02650)({
        contentId: homepageId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: 'page'
    }));
    // Preload media token for cover image
    if (homepageId) tasks.push((0, $1i2qc.preloadMediaToken)(homepageId));
    // Skip if early webpanel initialization is enabled, as we already query it in preloadConnectWebResources
    if (homepageId && !(0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
        if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
            contentId: homepageId,
            locations: [
                (0, $eSLr0.ATL_GENERAL),
                (0, $eSLr0.ATL_FOOTER)
            ]
        }));
        else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: homepageId,
            location: (0, $eSLr0.ATL_GENERAL)
        }), (0, $5Rwa0.preloadWebPanelLocation)({
            contentId: homepageId,
            location: (0, $eSLr0.ATL_FOOTER)
        }));
    }
    if (!isCompanyHub && !homepageId && ((0, $9wGTI.fg)('confluence_frontend_usd_ssr') || (0, $9wGTI.fg)('confluence_frontend_content_wrapper'))) {
        // Unified Share and Restrict Button - preload using spaceKey to avoid chained queries
        if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(undefined, spaceKey));
        //moved chained queries to the bottom to unblock other queries needed to preload & to combine the contentId query
        const homepageIdPromise = $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey) || $fe22b38e04163065$var$loadHomepageId(spaceKey);
        await homepageIdPromise.then((contentId)=>{
            if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
                tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId ?? '', false));
            }
            if (contentId) {
                // Preload web panel atl_general
                if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
                    contentId: contentId,
                    locations: [
                        (0, $eSLr0.ATL_GENERAL),
                        (0, $eSLr0.ATL_FOOTER)
                    ]
                }));
                else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
                    contentId: contentId,
                    location: (0, $eSLr0.ATL_GENERAL)
                }), (0, $5Rwa0.preloadWebPanelLocation)({
                    contentId: contentId,
                    location: (0, $eSLr0.ATL_FOOTER)
                }));
                // Preload media token for cover image
                tasks.push((0, $1i2qc.preloadMediaToken)(contentId));
            }
        });
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
const $fe22b38e04163065$export$d1ef19b00f2c3147 = ()=>{
    $fe22b38e04163065$var$homepageIdMap.clear();
    $fe22b38e04163065$var$homepageIdPromiseMap.clear();
};



var $7A94k = parcelRequire("7A94k");


















/**
 * @generated SignedSource<<c6f52d76f40a36d5184d0bf9735570f1>>
 * @relayHash 692b310473739d80af6d43542c26df31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80d9be10877ca72fa849742e6835bc1972fa04172f344617d7d379ae9262fa7b
const $f4ed30693011df84$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "referenceId",
                    "variableName": "id"
                }
            ],
            "kind": "ScalarField",
            "name": "contentIdByReferenceId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentIdByReferenceIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentIdByReferenceIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "692b310473739d80af6d43542c26df31",
            "id": "80d9be10877ca72fa849742e6835bc1972fa04172f344617d7d379ae9262fa7b",
            "metadata": {},
            "name": "ContentIdByReferenceIdQuery",
            "operationKind": "query",
            "text": "query ContentIdByReferenceIdQuery($id:String!){contentIdByReferenceId(referenceId:$id)}"
        }
    };
}();
$f4ed30693011df84$var$node.hash = "d1f8ea313ddf642c92d2df2b0f67af0d";
var $f4ed30693011df84$export$2e2bcd8739ae039 = $f4ed30693011df84$var$node;



var $d5h4f = parcelRequire("d5h4f");


var $kwaj3 = parcelRequire("kwaj3");

async function $7ba44aaf109d7b00$export$69c63edd0aeaee0b({ spaceKey: spaceKey, contentId: contentId, skipPageTree: skipPageTree = false }) {
    const preloadPromises = [
        $7ba44aaf109d7b00$var$preloadContentData(contentId, spaceKey),
        $7ba44aaf109d7b00$var$preloadSpace(spaceKey)
    ];
    return (0, $lyWac.waitForAllReturnWhenError)(preloadPromises);
}
async function $7ba44aaf109d7b00$var$preloadContentData(contentId, spaceKey) {
    const UUIDRegex = /[-]/;
    const isUuidBasedId = UUIDRegex.test(contentId);
    if (isUuidBasedId) await (0, $dYU3e.query)({
        query: (0, $f4ed30693011df84$export$2e2bcd8739ae039),
        variables: {
            id: contentId
        },
        __callerPackage__: "@confluence/whiteboard-common"
    });
    else await (0, $dYU3e.query)({
        query: (0, $d5h4f.default),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // The DSP query doesn't currently user the content version value, so using a fixed value
            contentVersion: 1
        },
        __callerPackage__: "@confluence/whiteboard-common"
    });
}
async function $7ba44aaf109d7b00$var$preloadSpace(spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $kwaj3.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/whiteboard-common"
    });
}





















var $bcVE2 = parcelRequire("bcVE2");

const $58246c7bb1bd3b0e$var$getSingle = (value)=>Array.isArray(value) ? value[0] : value ?? undefined;
const $58246c7bb1bd3b0e$export$a8738b3e8374c78c = (match)=>{
    const isEmbedded = (0, $bcVE2.isEmbeddedWhiteboardMode)({
        parentProduct: match.query?.parentProduct,
        presentationMode: match.query?.presentationMode
    });
    const parentProduct = $58246c7bb1bd3b0e$var$getSingle(match.query?.parentProduct);
    return {
        isEmbeddedWhiteboardMode: isEmbedded,
        bypassesMainLayout: isEmbedded && (0, $9wGTI.fg)('confluence_ssr_embedded_whiteboard_preload_cache'),
        parentProduct: parentProduct,
        isSmartLinkEmbed: parentProduct === 'smartLink',
        isRovoEmbed: parentProduct === 'rovo'
    };
};


const $d639d659544153c3$export$a107836a8bcfc0c9 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const { bypassesMainLayout: bypassesMainLayout, isSmartLinkEmbed: isSmartLinkEmbed, isRovoEmbed: isRovoEmbed } = (0, $58246c7bb1bd3b0e$export$a8738b3e8374c78c)(match);
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!bypassesMainLayout) {
        if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    }
    // Content types header (object header)
    if (!(bypassesMainLayout && isSmartLinkEmbed) && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        // Standalone Restrictions button needs to have its data preloaded)
        if (!(bypassesMainLayout && isRovoEmbed)) tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    }
    // Unified Share and Restrict Button
    if (!(bypassesMainLayout && (isSmartLinkEmbed || isRovoEmbed)) && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    if (!(bypassesMainLayout && isRovoEmbed) && (0, $9wGTI.fg)('aifc_create_enabled')) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    tasks.push((0, $7ba44aaf109d7b00$export$69c63edd0aeaee0b)({
        spaceKey: spaceKey,
        contentId: contentId,
        skipPageTree: bypassesMainLayout
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};




















var $c7BJC = parcelRequire("c7BJC");

async function $6ac7363a4b3b3fec$export$de0a909710c86263(spaceKey, contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $6ac7363a4b3b3fec$var$preloadContentData(contentId, spaceKey),
        $6ac7363a4b3b3fec$var$preloadContentTree(contentId, spaceKey)
    ]);
}
async function $6ac7363a4b3b3fec$var$preloadContentData(contentId, spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $c7BJC.default),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // The DSP query doesn't currently user the content version value, so using a fixed value
            contentVersion: 1
        },
        __callerPackage__: "@confluence/confluence-databases"
    });
}
async function $6ac7363a4b3b3fec$var$preloadContentTree(contentId, spaceKey) {}














const $f7a595baa9e6d446$export$f9f9f93ef86bfae1 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $6ac7363a4b3b3fec$export$de0a909710c86263)(spaceKey, contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};















var $1TElT = parcelRequire("1TElT");


var $65pdw = parcelRequire("65pdw");


var $4TRDb = parcelRequire("4TRDb");

const $136b2b02116ae317$var$preloadEditorData = async (contentId)=>{
    return (0, $dYU3e.query)({
        query: (0, $4TRDb.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/smart-create-page-editor"
    });
};
const $136b2b02116ae317$export$6e1d336ae32be6c2 = async (contentId)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        $136b2b02116ae317$var$preloadEditorData(contentId),
        (0, $1TElT.preloadEmojiTitle)(contentId, '', false),
        (0, $65pdw.preloadEditorPageCoverPicture)(contentId, '', false)
    ]);
};


const $ff76ae367134cd26$export$2a230d51c69b591b = async (contentId)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $136b2b02116ae317$export$6e1d336ae32be6c2)(contentId),
        (0, $1i2qc.preloadMediaToken)(contentId)
    ]);
};














var $aFgFx = parcelRequire("aFgFx");


















const $a17ca091e4cf9f3d$export$18e29f32c47bffc9 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    // Content types header (object header)
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
    tasks.push((0, $4trRg.preloadContentMode)({
        contentId: contentId,
        isDraft: false,
        useCache: true
    }));
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $aFgFx.preloadEmbedData)(spaceKey, contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $cvj7x = parcelRequire("cvj7x");





var $fywGr = parcelRequire("fywGr");


var $h8QBE = parcelRequire("h8QBE");













const $8401ee2f6eb43799$export$6316c27636a04811 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.NTH_USER_EMOJI_TITLE_DISCOVERED).EMOJI_TITLE_DISCOVERED
            ]
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};











const $4b6107ec1852de14$export$f487e1233221fed9 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP
            ]
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};






var $7PLO8 = parcelRequire("7PLO8");


var $32Xjk = parcelRequire("32Xjk");

const $8332e6e273585306$export$3e6908d03c4e3a25 = (contentId)=>{
    return (0, $dYU3e.query)({
        query: (0, $32Xjk.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        __callerPackage__: "@confluence/emoji-title"
    });
};


parcelRequire("8nle6");









var $8R0gj = parcelRequire("8R0gj");




var $kyd3u = parcelRequire("kyd3u");




















































var $3gyyc = parcelRequire("3gyyc");


const $40a9d2820cf67538$export$d8f603dd70536f4f = ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId || !userId) return;
    (parcelRequire("tWJUB")).then(({ get3pProductKeys: get3pProductKeys })=>get3pProductKeys({
            cloudId: cloudId,
            userId: userId
        })).catch(()=>{
    // Best-effort warm-up only. Any failure is swallowed so it can never
    // affect the route transition; the editor-mount hook will re-fetch.
    });
};



const $32e736695aa13b8b$export$8abf4a07f4444858 = async (match, _url, isTransition = false)=>{
    const { userId: userId, isLicensed: isLicensed, cloudId: cloudId, activationId: activationId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, environment: environment } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const isBlog = Boolean((0, $kM8fE.matchEditBlog)(_url));
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const shouldPreloadMentionsProvider = Boolean(undefined);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const shouldPreloadNavigation = !isEmbeddedConfluence;
    if ((0, $6mKj3.expValEquals)('confluence_edit_page_editor_data_guard_exception', 'isEnabled', true)) {
        // During 'platform_editor_editor_ssr_streaming' remove this variable and use prepareGuardExceptionTask directly
        // in tasks.push
        const preloadPromise = (0, $kkLBe.prepareGuardExceptionTask)('EditorData', ()=>(0, $cvj7x.preloadEditorData)({
                spaceKey: spaceKey,
                contentId: contentId,
                cloudId: cloudId,
                shouldPreloadMentionsProvider: shouldPreloadMentionsProvider,
                useCache: false,
                isBlog: isBlog
            }));
        tasks.push((0, $3gyyc.isSSRStreaming)() ? (0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>preloadPromise) : preloadPromise);
    } else {
        // During 'platform_editor_editor_ssr_streaming' remove this variable and use preloadEditorData directly
        // in tasks.push
        const preloadPromise = (0, $cvj7x.preloadEditorData)({
            spaceKey: spaceKey,
            contentId: contentId,
            cloudId: cloudId,
            shouldPreloadMentionsProvider: shouldPreloadMentionsProvider,
            useCache: false,
            isBlog: isBlog
        });
        tasks.push((0, $3gyyc.isSSRStreaming)() ? (0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>preloadPromise) : preloadPromise);
    }
    // we dont know if a page is unpublished until we get data back. guess based on the draftShareId being in the url
    const guessIsUnpublishedDraft = Boolean(match?.query?.draftShareId);
    tasks.push((0, $kyd3u.preloadEditorByLineData)({
        isUnpublishedDraft: guessIsUnpublishedDraft,
        spaceKey: spaceKey,
        contentId: contentId
    }));
    if ((0, $3gyyc.isSSRStreaming)()) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-types-header', ()=>{
        const contentTypesHeaderPreloadTasks = [];
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            contentTypesHeaderPreloadTasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
            // Standalone Restrictions button needs to have its data preloaded
            contentTypesHeaderPreloadTasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
        }
        if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) contentTypesHeaderPreloadTasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
        return contentTypesHeaderPreloadTasks;
    }));
    else {
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
            // Standalone Restrictions button needs to have its data preloaded
            tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
        }
        // Unified Share and Restrict Button
        if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    }
    if (isLicensed) {
        tasks.push((0, $fywGr.preloadEditorOnboardingState)());
        tasks.push((0, $h8QBE.preloadLandUsersInEditorWithRevampedBpqa)());
        // @TODO: check if we need to remove preloadNthUserOnboardingCompletedTimestamp, preloadNthUserEmojiTitleDiscovered, preloadEmojiEverSetProperty if auto_page_emoji_for_new_users_exp is dialed down.
        tasks.push((0, $4b6107ec1852de14$export$f487e1233221fed9)());
        tasks.push((0, $8401ee2f6eb43799$export$6316c27636a04811)());
        tasks.push((0, $8332e6e273585306$export$3e6908d03c4e3a25)(contentId));
    }
    // Warm the third-party connector-config cache off the editor's critical path so
    // the quick-insert embed items (Google Drive, Figma, …) resolve from cache at
    // editor mount instead of firing the request during hydration and appearing
    // late. Client-only (the request uses a localStorage-backed cache) and scoped to
    // the `confluence_quick_insert_embeds` experiment cohort. Read without exposure —
    // the authoritative exposure fires inside the provider builder at editor mount.
    // Fire-and-forget: this is intentionally not pushed into `tasks`.
    if ((0, $6mKj3.UNSAFE_expValNoExposure)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control') (0, $40a9d2820cf67538$export$d8f603dd70536f4f)({
        cloudId: cloudId,
        userId: userId
    });
    if (isTransition) {
        if ((0, $6mKj3.expValEquals)('cc_editor_edit_page_preload_loadables', 'isEnabled', true)) (parcelRequire("6ysPB")).then(({ preloadEditPageLoadables: preloadEditPageLoadables })=>preloadEditPageLoadables()).catch(()=>{});
        if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
            contentId: contentId,
            locations: [
                (0, $eSLr0.ATL_GENERAL),
                (0, $eSLr0.ATL_FOOTER)
            ]
        }));
        return (0, $lyWac.waitForAllReturnWhenError)(tasks);
    }
    tasks.push((0, $8R0gj.preloadDraft)(contentId));
    tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
        contentId: contentId,
        locations: [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ]
    }));
    else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    tasks.push((0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId));
    if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) tasks.push((0, $fa8eaa7cdcb1d432$export$2d00200c8fdc5d86)({
        cloudId: cloudId,
        contentId: contentId,
        contentStatus: 'DRAFT',
        spaceKey: spaceKey
    }));
    // Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        activationId: activationId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId,
        environment: environment
    }));
    // Preload forge extension manifest
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    // Preload Smart Create Feedback Banner
    if ((0, $9wGTI.fg)('aifc_create_enabled')) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    // Preload Audio Listen Button
    tasks.push((0, $cc003fd311374024$export$7261e64a95ae02eb)(contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};





async function $73df6e46d3afaa7c$export$9c3872cc60e7dbce(match, _url) {
    const { contentId: contentId, draftShareId: draftShareId } = match.params;
    await (0, $8R0gj.preloadDraft)(contentId, draftShareId);
}









var $2XqLa = parcelRequire("2XqLa");


var $jG2Es = parcelRequire("jG2Es");


var $khheP = parcelRequire("khheP");


var $dC2j7 = parcelRequire("dC2j7");

const $61c2bc00711f31ff$export$e56b81ae74d866fc = (options)=>{
    const variables = (0, $dC2j7.getPreloadAggSpacePagesQueryVariables)(options);
    const { spaceKey: spaceKey, isLoggedIn: isLoggedIn, spaceId: spaceId = '' } = options;
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.queryAgg)({
            query: (0, $khheP.default),
            variables: variables,
            __callerPackage__: "@confluence/space-pages"
        }),
        ...!spaceId ? [
            (0, $dYU3e.query)({
                query: (0, $2XqLa.default),
                variables: {
                    spaceKey: spaceKey
                },
                __callerPackage__: "@confluence/space-pages"
            })
        ] : [],
        ...isLoggedIn ? [
            (0, $dYU3e.query)({
                query: (0, $jG2Es.default),
                variables: {
                    spaceKey: spaceKey
                },
                __callerPackage__: "@confluence/space-pages"
            })
        ] : []
    ]);
};






var $yuLaV = parcelRequire("yuLaV");




const $106eac55bed5d4af$export$206b1c2d74bc11a2 = async (match)=>{
    const { userId: userId, isLoggedIn: isLoggedIn, accessStatus: accessStatus, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    const { spaceKey: spaceKey } = match.params;
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    return (0, $61c2bc00711f31ff$export$e56b81ae74d866fc)({
        cloudId: cloudId,
        spaceKey: spaceKey,
        queryParams: match.query,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn,
        spaceId: '',
        isWhiteboardEnabled: isWhiteboardsEnabled,
        isDatabaseEnabled: isDatabasesEnabled,
        isSlidesEnabled: isSlidesEnabled
    });
};



var $aYbn7 = parcelRequire("aYbn7");




var $ddSqr = parcelRequire("ddSqr");










var $73cd2 = parcelRequire("73cd2");

const $189a8a30ba3005c8$export$517a8e5c755236cc = async ({ shareToken: shareToken, contentId: contentId })=>{
    const sharedContentResult = await (0, $dYU3e.query)({
        query: (0, $73cd2.default),
        variables: {
            shareToken: shareToken,
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        __callerPackage__: "@confluence/external-share"
    });
    const singleContent = sharedContentResult?.data?.singleContent;
    const resolvedContentId = contentId ?? singleContent?.id;
    const isPage = singleContent?.type === 'page';
    if (!resolvedContentId || !isPage) return (0, $lyWac.waitForAllReturnWhenError)([
        Promise.resolve(sharedContentResult)
    ]);
    return (0, $lyWac.waitForAllReturnWhenError)([
        Promise.resolve(sharedContentResult),
        (0, $dYU3e.query)({
            query: (0, $aYbn7.default),
            variables: {
                contentId: resolvedContentId
            },
            context: {
                allowOnExternalPage: true
            },
            __callerPackage__: "@confluence/external-share"
        }),
        (0, $ddSqr.preloadContentTitleWithByLineExternal)(resolvedContentId)
    ]);
};


















var $fdq4F = parcelRequire("fdq4F");


var $5WLjq = parcelRequire("5WLjq");




const $1f9d1c86f6a99b0e$export$5da6d89b949b94fc = (match)=>{
    const tasks = [];
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) tasks.push((0, $189a8a30ba3005c8$export$517a8e5c755236cc)({
        shareToken: match.params.shareToken
    }));
    const { accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (isLicensed) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
        const sideNavTasks = [
            (0, $5WLjq.preloadSpacesList)({
                isLicensed: isLicensed
            })
        ];
        if ((0, $9wGTI.fg)('navx-global-side-nav-confluence')) sideNavTasks.push((0, $fdq4F.preloadPlatformNavigationQuery)());
        return sideNavTasks;
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};





















const $0ef4e79dd69588ad$export$9f53340e87bacbbd = async (match)=>{
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { cloudId: cloudId } = preloadedSessionContext;
    // Since this query is not called in ContentPrerequisites when contentId is
    // missing, we should follow the same reasoning and skip preload when content is
    // missing.
    if (contentId) tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        // Standalone Restrictions button needs to have its data preloaded
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    }
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};














const $29ace679d934655d$export$7cbbf2d30ca863e7 = async (match)=>{
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    // Since this query is not called in ContentPrerequisites when contentId is
    // missing, we should follow the same reasoning and skip preload when content is
    // missing.
    if (contentId) tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};












var $gGK1T = parcelRequire("gGK1T");


var $2E1L5 = parcelRequire("2E1L5");

function $434ee60a7b6c6c34$export$b00a1ce9bc36f6f2(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $gGK1T.default),
        variables: {
            contentId: contentId,
            limit: (0, $2E1L5.DEFAULT_CONTRIBUTORS_FETCH_LIMIT)
        },
        __callerPackage__: "@confluence/content-ownership"
    });
}















var $5Sm9D = parcelRequire("5Sm9D");


var $gAiOv = parcelRequire("gAiOv");

async function $fbd9f14d3be2d912$export$238042884af28457(contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $5Sm9D.default),
            variables: {
                id: contentId,
                after: null,
                contentId: contentId,
                includeDevDocsSyncStatus: (0, $6mKj3.expVal)('confluence_dev_docs', 'isEnabled', false)
            },
            __callerPackage__: "@confluence/folder"
        }),
        (0, $dYU3e.query)({
            query: (0, $gAiOv.default),
            variables: {
                id: contentId
            },
            __callerPackage__: "@confluence/folder"
        })
    ]);
}



















var $ieWRE = parcelRequire("ieWRE");


var $84kyw = parcelRequire("84kyw");

const $2c7b09695f067c18$export$d0af89ed4f3cce26 = ({ contentId: contentId, spaceKey: spaceKey, isRovoEnabled: isRovoEnabled })=>{
    if (!contentId || !spaceKey || !isRovoEnabled || !(0, $6mKj3.expVal)('confluence_folder_view', 'isEnabled', false) || (0, $6mKj3.expVal)('confluence_smart_folders_milestone', 'value', 0) < 2) return Promise.resolve([]);
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $ieWRE.default),
            variables: {
                spaceKey: spaceKey
            },
            __callerPackage__: "@confluence/smart-folder"
        }),
        (0, $dYU3e.query)({
            query: (0, $84kyw.default),
            variables: {
                contentId: contentId
            },
            __callerPackage__: "@confluence/smart-folder"
        })
    ]);
};


const $ae578b27499cf6ef$export$4286139fad35252 = async (match)=>{
    const { isLicensed: isLicensed, isRovoEnabled: isRovoEnabled } = (0, $xwvlW.getPreloaderFnContext)();
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const tasks = [];
    if (contentId) {
        // Core folder data: FolderOverviewFirstPageQuery + FolderRedirectFirstChildQuery in parallel
        tasks.push((0, $fbd9f14d3be2d912$export$238042884af28457)(contentId));
        // Fetch content status/redirect — required by FolderPrerequisites
        tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey));
        // Preload the sticky ContentTypesHeader shown at the top of FolderOverview
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        // Warm the ownership/contributors query consumed by BadgeStylePageOwnershipByline in FolderHeader
        tasks.push((0, $434ee60a7b6c6c34$export$b00a1ce9bc36f6f2)(contentId));
        if (spaceKey) // Warm smart-folder enablement + ancestor data used to decide whether the
        // empty-state connection UX can render during SSR.
        tasks.push((0, $2c7b09695f067c18$export$d0af89ed4f3cce26)({
            contentId: contentId,
            spaceKey: spaceKey,
            isRovoEnabled: isRovoEnabled
        }));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};


parcelRequire("8nle6");
var $jLyos = parcelRequire("jLyos");








var $5IsL6 = parcelRequire("5IsL6");


























var $iaK3p = parcelRequire("iaK3p");

const $8741a5de3be893c9$export$3764d460af2e353f = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $iaK3p.default),
        __callerPackage__: "@confluence/feature-discovery"
    });
};








const $69ec3a471529e315$export$34e54806d88e1d6d = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $8Z78B.default),
            variables: {
                key: (0, $dBcar.NTH_USER_AUTO_FOLLOW_SPACES).HAS_AUTO_FOLLOWED_SPACES
            },
            __callerPackage__: "@confluence/onboarding-helpers"
        }),
        (0, $8741a5de3be893c9$export$3764d460af2e353f)()
    ]);
};


















var $Yc1IN = parcelRequire("Yc1IN");


var $gFJ3I = parcelRequire("gFJ3I");


var $3cztU = parcelRequire("3cztU");


var $g4evd = parcelRequire("g4evd");


var $lNpDX = parcelRequire("lNpDX");


var $d7td2 = parcelRequire("d7td2");

const $f413d4da5ba15b92$export$77a2c40a93849218 = ({ isLoggedIn: isLoggedIn })=>{
    // If the user is not logged in we show the following feed by default
    // so only preload that feed. If the user is logged in preload both
    // feeds and the feed preference
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $xwvlW.getPreloaderFnContext)();
    const followingFeedQuery = (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) ? (0, $dYU3e.queryAgg)({
        query: (0, $Yc1IN.default),
        variables: {
            first: (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'following_ssr', 5)
        },
        __callerPackage__: "@confluence/feed"
    }) : (0, $dYU3e.query)({
        query: (0, $3cztU.default),
        variables: {
            first: (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'following_ssr', 5)
        },
        __callerPackage__: "@confluence/feed"
    });
    // Select the popular-feed query to preload. Decision order MUST mirror
    // `usePopularFeedWithTimeGranularityStorage`'s client-side selection so the
    // SSR-cached response matches the query the client fires on hydration.
    // Otherwise SSR users would suffer a cache miss + re-fetch, negating the
    // latency win for the very users we care most about (first paint).
    //
    // The V2 experiment in Statsig (`confluence_ai_snippets_popular_feed`) is
    // configured with an `isEnabled` boolean param (NOT a `cohort` string param).
    // All branch checks use `('isEnabled', true)` to detect the treatment arm.
    //
    //   - V2 (parallel)            when popular_feed isEnabled=true AND isRovoLLMEnabled
    //   - V1-with-snippets         when in_following_popular_feeds isEnabled=true AND NOT V2-treatment
    //   - vanilla V1               otherwise (incl. non-Rovo V2-treatment users)
    const popularFirstCount = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? 10 : (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'popular_ssr', 5);
    let popularFeedDataQuery;
    if (isRovoLLMEnabled && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed', 'isEnabled', true)) // V2 (parallel hydration) — node-level aiProperty, AGG calls cc-smarts
    // in parallel with the Confluence content hop. We only enter this
    // branch when `isRovoLLMEnabled` is true, so the V2 query variable can
    // be passed `true` unconditionally — no need to re-evaluate the
    // prereq experiment here.
    popularFeedDataQuery = (0, $dYU3e.queryAgg)({
        query: (0, $d7td2.default),
        variables: {
            first: popularFirstCount,
            isRovoLLMEnabled: true
        },
        __callerPackage__: "@confluence/feed"
    });
    else if (// V1-with-snippets is suppressed for ANY user in the V2-treatment arm
    // (Rovo or not), matching the client-side hook's skipQuery condition.
    // Without this guard, non-Rovo users with popular_feed isEnabled=true
    // would receive a V1-with-snippets SSR preload while the client fires
    // vanilla V1, causing an SSR cache miss + re-fetch (negating the
    // latency win for the very users we care most about — first paint).
    //
    // Gate order: V2-treatment exclusion FIRST so the in-following gate
    // stays at the end of the expression and satisfies the
    // `confluence-feature-gating/no-preconditioning` ESLint rule.
    !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed', 'isEnabled', true) && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true)) // V1-with-snippets (legacy serial path). Use the NO-exposure variant
    // for the prereq experiment check — SSR fires before the user sees the
    // page, so we must NOT log a real exposure here. The client-side hook
    // (usePopularFeedWithTimeGranularityStorage) uses `expVal` for the
    // same check and is the single source of truth for exposure logging —
    // SSR and client both return the same `isRovoLLMEnabled` variable
    // value, ensuring the SSR-cached response matches what the client
    // would have fetched. The intentional divergence is exposure logging.
    // Semantics preserved from the original `expVal('...', 'isEnabled', false)`
    // which returned the boolean `isEnabled` value: when the gate is ON
    // (isEnabled=true) honor the user's real Rovo flag, otherwise pass
    // `true` (legacy pre-prereq behaviour).
    popularFeedDataQuery = (0, $dYU3e.queryAgg)({
        query: (0, $gFJ3I.default),
        variables: {
            first: popularFirstCount,
            isRovoLLMEnabled: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed_for_ai_enabled', 'isEnabled', true) ? isRovoLLMEnabled : true
        },
        __callerPackage__: "@confluence/feed"
    });
    else // Vanilla V1 (no AI snippets). Used by: users outside both gates, and
    // non-Rovo users in the V2-treatment arm (V2 cannot serve them, and
    // V1-with-snippets is suppressed for V2-treatment users — vanilla V1
    // is the safe fallback).
    popularFeedDataQuery = (0, $dYU3e.query)({
        query: (0, $lNpDX.default),
        variables: {
            first: popularFirstCount
        },
        __callerPackage__: "@confluence/feed"
    });
    const popularFeedQuery = [
        popularFeedDataQuery,
        (0, $dYU3e.query)({
            query: (0, $g4evd.default),
            __callerPackage__: "@confluence/feed"
        })
    ];
    const tasks = [
        followingFeedQuery
    ];
    if (isLoggedIn) tasks.push(...popularFeedQuery);
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};





var $6YxJf = parcelRequire("6YxJf");



/* eslint-disable import-extensions/file-extension-required */ 

















var $1gy7x = parcelRequire("1gy7x");

const $e192ddb06e08d8ca$export$853a2dce20c9140 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $1gy7x.PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS))
            ]
        },
        __callerPackage__: "@confluence/experiment-personalized-templates-v2"
    });
};









var $eyUJP = parcelRequire("eyUJP");



const $fe35e2c6f7a7af9b$export$67d796e2874a7983 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS))
            ]
        },
        __callerPackage__: "@confluence/experiment-personalized-templates-v2"
    });
};



var $byPOx = parcelRequire("byPOx");


var $lWFZM = parcelRequire("lWFZM");


var $l57Xv = parcelRequire("l57Xv");


var $c8Y4F = parcelRequire("c8Y4F");

const $6dafd0e2e7720a45$export$3687d58480022124 = (userId, accessStatus)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $byPOx.default),
            __callerPackage__: "@confluence/experiment-personalized-templates-v2"
        }),
        (0, $dYU3e.query)({
            query: (0, $lWFZM.default),
            __callerPackage__: "@confluence/experiment-personalized-templates-v2"
        }),
        ...accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS ? [
            (0, $dYU3e.queryAgg)({
                query: (0, $l57Xv.default),
                variables: {
                    accountId: userId || ''
                },
                __callerPackage__: "@confluence/experiment-personalized-templates-v2"
            })
        ] : [],
        ...accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS ? [
            (0, $e192ddb06e08d8ca$export$853a2dce20c9140)()
        ] : [],
        (0, $fe35e2c6f7a7af9b$export$67d796e2874a7983)(),
        (0, $dYU3e.query)({
            query: (0, $c8Y4F.default),
            __callerPackage__: "@confluence/experiment-personalized-templates-v2"
        })
    ]);
};











const $c81a9dc13c505c10$export$42b064b77c9ba75f = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                // For the banner and cards
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).SELECTED_TEMPLATES,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_AT,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).DISMISSED_HEADER,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_HEADER
            ]
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};









var $b4VFP = parcelRequire("b4VFP");




const $e5a69db009315bb4$export$f8fb9f2632d64c50 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
            ]
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};






var $2fsJn = parcelRequire("2fsJn");







/**
 * @generated SignedSource<<614722153aca82d9dabeb40fc48ec31c>>
 * @relayHash ddee5bcc7d51d2ed5555d8cc6f48ec88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28d394c12f422131aed5b9fb5279cc5096ef0d8e677d3789fcf89b22b34d31b6
const $724e41e8cbd5c99e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "key"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": [
                        "templates-collection:isTaggedForTemplatesCollectionExperiment",
                        "templates-collection:isTemplatesSectionDismissed",
                        "onboarding-state:introWorkflow",
                        "onboarding-state:legacy",
                        "onboarding-state:isFoundingAdmin",
                        "onboarding-state:isSampleContentV2SpotlightVisible",
                        "onboarding-state:landOnPath",
                        "onboarding-state:teamSpaceCreated",
                        "onboarding-state:isMoreActionsTourVisible",
                        "onboarding-state:isMoreActionsHintVisible",
                        "onboarding-state:improvedGetStartedPath",
                        "onboarding-state:improvedGetStartedWhiteboardPath",
                        "onboarding-state:nthUserGSPagePath",
                        "onboarding-state:isRedactionsTourVisible",
                        "onboarding-state:xflowSpaceCreated",
                        "onboarding-state:templateOnboardingViewedTime",
                        "onboarding-state:nthUserOnboardingCompletedTimestamp",
                        "onboarding-state:nthUserOnboardingFlagViewed",
                        "onboarding-state:nthUserOnboardingPageViewed",
                        "onboarding-state:nthUserBannerDismissed"
                    ]
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ],
            "storageKey": "onboardingState(key:[\"templates-collection:isTaggedForTemplatesCollectionExperiment\",\"templates-collection:isTemplatesSectionDismissed\",\"onboarding-state:introWorkflow\",\"onboarding-state:legacy\",\"onboarding-state:isFoundingAdmin\",\"onboarding-state:isSampleContentV2SpotlightVisible\",\"onboarding-state:landOnPath\",\"onboarding-state:teamSpaceCreated\",\"onboarding-state:isMoreActionsTourVisible\",\"onboarding-state:isMoreActionsHintVisible\",\"onboarding-state:improvedGetStartedPath\",\"onboarding-state:improvedGetStartedWhiteboardPath\",\"onboarding-state:nthUserGSPagePath\",\"onboarding-state:isRedactionsTourVisible\",\"onboarding-state:xflowSpaceCreated\",\"onboarding-state:templateOnboardingViewedTime\",\"onboarding-state:nthUserOnboardingCompletedTimestamp\",\"onboarding-state:nthUserOnboardingFlagViewed\",\"onboarding-state:nthUserOnboardingPageViewed\",\"onboarding-state:nthUserBannerDismissed\"])"
        },
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v0 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadTemplatesCollectionEligibleQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadTemplatesCollectionEligibleQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ddee5bcc7d51d2ed5555d8cc6f48ec88",
            "id": "28d394c12f422131aed5b9fb5279cc5096ef0d8e677d3789fcf89b22b34d31b6",
            "metadata": {},
            "name": "preloadTemplatesCollectionEligibleQuery",
            "operationKind": "query",
            "text": "query preloadTemplatesCollectionEligibleQuery{onboardingState(key:[\"templates-collection:isTaggedForTemplatesCollectionExperiment\",\"templates-collection:isTemplatesSectionDismissed\",\"onboarding-state:introWorkflow\",\"onboarding-state:legacy\",\"onboarding-state:isFoundingAdmin\",\"onboarding-state:isSampleContentV2SpotlightVisible\",\"onboarding-state:landOnPath\",\"onboarding-state:teamSpaceCreated\",\"onboarding-state:isMoreActionsTourVisible\",\"onboarding-state:isMoreActionsHintVisible\",\"onboarding-state:improvedGetStartedPath\",\"onboarding-state:improvedGetStartedWhiteboardPath\",\"onboarding-state:nthUserGSPagePath\",\"onboarding-state:isRedactionsTourVisible\",\"onboarding-state:xflowSpaceCreated\",\"onboarding-state:templateOnboardingViewedTime\",\"onboarding-state:nthUserOnboardingCompletedTimestamp\",\"onboarding-state:nthUserOnboardingFlagViewed\",\"onboarding-state:nthUserOnboardingPageViewed\",\"onboarding-state:nthUserBannerDismissed\"]){key,value},confluence_tenantContext{licensedProducts{licenseStatus,productKey}},user:confluence_atlassianUser{id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$724e41e8cbd5c99e$var$node.hash = "2e478de184cf22dbf9c640f31ec7f723";
var $724e41e8cbd5c99e$export$2e2bcd8739ae039 = $724e41e8cbd5c99e$var$node;





const $b7411e454a753e13$var$PreloadTemplatesCollectionEligibleQuery = (0, $724e41e8cbd5c99e$export$2e2bcd8739ae039);
const $b7411e454a753e13$export$61d1d0b9775c631b = ()=>(0, $dYU3e.query)({
        query: $b7411e454a753e13$var$PreloadTemplatesCollectionEligibleQuery,
        __callerPackage__: "@confluence/home"
    });











const $fedd9a86a97c3653$export$520ec834118606cc = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values({
                ...(0, $dBcar.ONBOARDING_INTENT_EXPERIENCES),
                ...(0, $dBcar.ONBOARDING_EXPERIENCES)
            })
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};






var $aSQ2H = parcelRequire("aSQ2H");

const $94117ca0130c8194$export$1cf448b10191509a = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $aSQ2H.default),
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};





const $b8044be2d73de97b$export$609c06e14413a6a4 = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $fedd9a86a97c3653$export$520ec834118606cc)(),
        (0, $94117ca0130c8194$export$1cf448b10191509a)()
    ]);
};






var $lkQRq = parcelRequire("lkQRq");

function $d85b408e33b913ac$export$d97df32fa415897c({ isLicensed: isLicensed }) {
    if (!isLicensed) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $lkQRq.default),
        __callerPackage__: "@confluence/home"
    });
}


const $ef1b2e92c64fee29$export$3e66106e6cf0fa15 = ({ isLicensed: isLicensed })=>{
    return (0, $d85b408e33b913ac$export$d97df32fa415897c)({
        isLicensed: isLicensed
    });
};






var $cMfVN = parcelRequire("cMfVN");

function $4f0b16a97f4cdcc7$export$a3d255f35641358b() {
    return (0, $dYU3e.query)({
        query: (0, $cMfVN.default),
        __callerPackage__: "@confluence/home"
    });
}



var $a67vB = parcelRequire("a67vB");


var $y9T5W = parcelRequire("y9T5W");

const $5a0086fce17702fe$var$preloadRecentWork = (args)=>{
    const queryOptions = (0, $a67vB.getRecentWorkQueryOptions)(args);
    if (queryOptions.skip) return Promise.resolve({});
    return (0, $dYU3e.queryAgg)({
        ...queryOptions,
        __callerPackage__: "@confluence/home"
    });
};
const $5a0086fce17702fe$export$afe654e7a7c068fa = ({ userId: userId, cloudId: cloudId, isLicensed: isLicensed, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, isSlidesEnabled: isSlidesEnabled = false })=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { accessStatus: accessStatus } = preloadedSessionContext;
    const canAccessHome = accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';
    const tasks = [
        $5a0086fce17702fe$var$preloadRecentWork({
            cloudId: cloudId,
            isLoggedIn: !!userId,
            isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
            isDatabaseEnabled: isDatabaseEnabled,
            isSlidesEnabled: isSlidesEnabled,
            first: (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)
        }),
        (0, $f413d4da5ba15b92$export$77a2c40a93849218)({
            isLoggedIn: !!userId
        }),
        (0, $ef1b2e92c64fee29$export$3e66106e6cf0fa15)({
            isLicensed: isLicensed
        }),
        (0, $4f0b16a97f4cdcc7$export$a3d255f35641358b)()
    ];
    if (userId) {
        tasks.push((0, $b8044be2d73de97b$export$609c06e14413a6a4)(), (0, $b7411e454a753e13$export$61d1d0b9775c631b)());
        if (isLicensed && canAccessHome) {
            tasks.push((0, $69ec3a471529e315$export$34e54806d88e1d6d)());
            tasks.push((0, $e5a69db009315bb4$export$f8fb9f2632d64c50)());
        }
    }
    if (isLicensed && canAccessHome && userId && (0, $9wGTI.fg)('cc-ssr-preload-use-cases-nth-user-onboarding')) tasks.push((0, $c81a9dc13c505c10$export$42b064b77c9ba75f)());
    if (isLicensed && canAccessHome && userId && accessStatus) tasks.push((0, $6dafd0e2e7720a45$export$3687d58480022124)(userId, accessStatus));
    const unifiedSpacePreloader = (0, $2fsJn.preloadPersistentInviteButtonEligible)({
        spaceKey: undefined
    }, false);
    if (unifiedSpacePreloader) // @ts-ignore-next-line
    tasks.push(unifiedSpacePreloader); //type can be undefined, but the surrounding conditional prevents it
    // https://switcheroo.atlassian.com/ui/gates/e8661ed8-caef-4eed-a747-bf4d58be15c9/key/post-office_enable-confluence-home-banner
    if (userId && canAccessHome && isLicensed && (0, $9wGTI.fg)('post-office_enable-confluence-home-banner')) {
        // Confluence Home Banner in SSR
        const preloadPostOfficeHomeBanner = async ()=>{
            return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ConfluenceHomeBanner', async ()=>{
                const result = await (0, $6YxJf.preloadPostOfficeConfluenceHomeBanner)();
                return result ?? {};
            });
        };
        tasks.push(preloadPostOfficeHomeBanner());
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};















var $igBnm = parcelRequire("igBnm");

const $e4b2bfbed97961bc$export$a8fc7c44e5aafa61 = ({ isLoggedIn: isLoggedIn })=>{
    if (!isLoggedIn) return Promise.resolve({});
    return (0, $dYU3e.query)({
        query: (0, $igBnm.default),
        __callerPackage__: "@confluence/home"
    });
};



var $k2RxH = parcelRequire("k2RxH");


var $5dcQK = parcelRequire("5dcQK");

const $914eb87cd194adde$export$daee90b6ccc653e0 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled, isDatabaseEnabled: isDatabaseEnabled })=>{
    const isDatabaseEnabledResolved = isDatabaseEnabled ?? (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.queryAgg)({
            ...(0, $k2RxH.getRecentQueryOptions)({
                pill: 'all',
                cloudId: cloudId,
                endCursor: '',
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled,
                isDatabaseEnabled: isDatabaseEnabledResolved
            }),
            __callerPackage__: "@confluence/home"
        }),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        }),
        ...isLoggedIn ? [
            (0, $dYU3e.query)({
                query: (0, $5dcQK.default),
                __callerPackage__: "@confluence/home"
            })
        ] : []
    ]);
};










var $1abNy = parcelRequire("1abNy");

const $82a332f3eb0b7b32$var$PAGE_SIZE = 24;
const $82a332f3eb0b7b32$export$9151a9689f071b49 = ({ isLoggedIn: isLoggedIn })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $1abNy.default),
            variables: {
                limit: $82a332f3eb0b7b32$var$PAGE_SIZE,
                start: 0
            },
            __callerPackage__: "@confluence/home"
        }),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        })
    ]);
};


/* eslint-disable import-extensions/file-extension-required */ 







var $d64J2 = parcelRequire("d64J2");


var $kgC8N = parcelRequire("kgC8N");

const $db48a3960bd53439$export$ef22b7398f0c0746 = ({ isLoggedIn: isLoggedIn })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $d64J2.default),
            variables: (0, $kgC8N.DRAFTS_QUERY_OPTIONS).variables,
            __callerPackage__: "@confluence/home"
        }),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        })
    ]);
};



var $01STT = parcelRequire("01STT");

const $f65ab46c8acdebd2$var$getSelectedView = (matchParams)=>{
    const view = matchParams?.view;
    return Object.values((0, $01STT.View)).includes(view) ? view : (0, $01STT.View).OVERVIEW;
};
const $f65ab46c8acdebd2$var$preloadSelectedView = ({ cloudId: cloudId, isLicensed: isLicensed, userId: userId, matchParams: matchParams, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, isSlidesEnabled: isSlidesEnabled = false })=>{
    if (!cloudId) return Promise.resolve({});
    const isLoggedIn = Boolean(userId);
    const selectedView = $f65ab46c8acdebd2$var$getSelectedView(matchParams);
    switch(selectedView){
        case (0, $01STT.View).RECENT:
            return (0, $914eb87cd194adde$export$daee90b6ccc653e0)({
                cloudId: cloudId,
                isLoggedIn: isLoggedIn,
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isDatabaseEnabled: isDatabaseEnabled
            });
        case (0, $01STT.View).STARRED:
            return (0, $82a332f3eb0b7b32$export$9151a9689f071b49)({
                isLoggedIn: isLoggedIn
            });
        case (0, $01STT.View).DRAFTS:
            return (0, $db48a3960bd53439$export$ef22b7398f0c0746)({
                isLoggedIn: isLoggedIn
            });
        case (0, $01STT.View).OVERVIEW:
        default:
            return (0, $5a0086fce17702fe$export$afe654e7a7c068fa)({
                userId: userId,
                cloudId: cloudId,
                isLicensed: isLicensed,
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isDatabaseEnabled: isDatabaseEnabled,
                isSlidesEnabled: isSlidesEnabled
            });
    }
};
const $f65ab46c8acdebd2$export$ae91664215c56ac5 = (options)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
            const sideNavTasks = [
                (0, $5WLjq.preloadSpacesList)({
                    //preloads left nav
                    isLicensed: options.isLicensed
                })
            ];
            if ((0, $9wGTI.fg)('navx-global-side-nav-confluence')) sideNavTasks.push((0, $fdq4F.preloadPlatformNavigationQuery)());
            return sideNavTasks;
        }),
        (0, $5IsL6.preloadCreateSpace)({
            isLicensed: options.isLicensed
        }),
        $f65ab46c8acdebd2$var$preloadSelectedView(options)
    ]);
};









var $bFNdd = parcelRequire("bFNdd");







const $179951d621935e1e$export$cefc517f3ae2aa98 = async (match)=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { userId: userId, cloudId: cloudId, accessStatus: accessStatus } = preloadedSessionContext;
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const tasks = [];
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const canAccessHome = accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';
    //All top Navigation preloading is done in next/packages/query-preloaders/src/index.ts
    if (isLicensed && canAccessHome) tasks.push((0, $f65ab46c8acdebd2$export$ae91664215c56ac5)({
        cloudId: cloudId,
        isLicensed: isLicensed,
        userId: userId,
        matchParams: match.params,
        isWhiteboardViewedEnabled: isWhiteboardsEnabled,
        isDatabaseEnabled: isDatabasesEnabled,
        isSlidesEnabled: isSlidesEnabled
    }));
    // Preload current user's personal space metadata for home route consumers(onboarding etc).
    tasks.push((0, $jLyos.preloadPersonalSpaceDetail)());
    tasks.push((0, $bFNdd.preloadPostOfficeConfluenceSideNav)());
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};









var $iwZYw = parcelRequire("iwZYw");

const $dfe1021c2b61fce7$export$eec5c6a2cd111615 = ()=>(0, $dYU3e.query)({
        query: (0, $iwZYw.default),
        __callerPackage__: "@confluence/admin-announcement-banner"
    });






var $1hmAp = parcelRequire("1hmAp");

const $b5b554d7930e19fd$export$91ccde13a31d1982 = ()=>(0, $dYU3e.query)({
        query: (0, $1hmAp.default),
        __callerPackage__: "@confluence/storage-enforcement"
    });


const $5368439faec350a5$export$6c7e4784651f052f = async ()=>{
    const { edition: edition } = (0, $xwvlW.getPreloaderFnContext)();
    const upperCaseEdition = edition?.toUpperCase() || '';
    if (upperCaseEdition === 'PREMIUM' || upperCaseEdition === 'STANDARD') return (0, $dfe1021c2b61fce7$export$eec5c6a2cd111615)();
    else if (upperCaseEdition === 'FREE') return (0, $b5b554d7930e19fd$export$91ccde13a31d1982)();
};






var $l998X = parcelRequire("l998X");


var $eI9QI = parcelRequire("eI9QI");


var $2mPpz = parcelRequire("2mPpz");




const $6dedf2638d31103b$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'admin/overview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'overview'
                }
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'atlassian-apps'
                }
            }
        }
    },
    {
        name: 'admin/discovered-products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'shadow-it-apps'
                }
            }
        }
    },
    {
        name: 'admin/domains',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'domains'
                }
            }
        }
    },
    {
        name: 'admin/user-requests',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-requests'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'app-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/authentication-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'authentication-policies'
                }
            }
        }
    },
    {
        name: 'admin/users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'users'
                }
            }
        }
    },
    {
        name: 'admin/audit-log',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'audit-log'
                }
            }
        }
    },
    {
        name: 'admin/billing-preview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing-preview'
                }
            }
        }
    },
    {
        name: 'admin/data-residency',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-residency'
                }
            }
        }
    },
    {
        name: 'admin/encryption',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'encryption'
                }
            }
        }
    },
    {
        name: 'admin/data-security-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-security-policies'
                }
            }
        }
    },
    {
        name: 'admin/backups',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'backups'
                }
            }
        }
    },
    {
        name: 'admin/rovo',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'rovo'
                }
            }
        }
    },
    {
        name: 'admin/units',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/user-connected-apps',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-connected-apps'
                }
            }
        }
    },
    {
        name: 'admin/changelog',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'changelog'
                }
            }
        }
    },
    {
        name: 'admin/product-insights',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'product-insights'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'board'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'confluence/wiki-home',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/home'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-welcome',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/welcome'
                }
            }
        }
    },
    {
        name: 'confluence/space-overview',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: '^wiki/spaces/[^/]+/overview(/.*)?$'
                }
            }
        }
    },
    {
        name: 'confluence/pages-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: '^(?!.*edit).*wiki/spaces/.*/pages.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages-with-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*/pages/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: '^(?!.*edit).*wiki/spaces/.*/blog.*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-with-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*/blog/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-content',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/*/.*'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-space-settings',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.+?/settings(/.*)?$'
                }
            }
        }
    },
    {
        name: 'confluence/blogs',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/(?!.*/edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/whiteboard',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/.*whiteboard.*'
                }
            }
        }
    },
    {
        name: 'confluence/slides',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/slide/.*'
                }
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    },
    {
        name: 'jira/queue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'queue'
                }
            }
        }
    },
    {
        name: 'jira/browse',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/browse/software',
        when: {
            context: {
                product: 'jira',
                subproduct: 'software'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/browse/issue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse/.*?'
                }
            }
        }
    },
    {
        name: 'jira/issues',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'list'
                }
            }
        }
    },
    {
        name: 'jira/itsm/changes-list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?'
                }
            }
        }
    },
    {
        name: 'jira/itsm/changes-list/detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?/.*?'
                }
            }
        }
    },
    {
        name: 'jira/itsm/risk-insights',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/settings/change-management?tab=risk-insights'
                }
            }
        }
    },
    {
        name: 'jira/itsm/incidents-list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/incidents/custom/.*?'
                }
            }
        }
    },
    {
        name: 'jira/get-started',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/get-started'
                }
            }
        }
    },
    {
        name: 'jira/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'projects/selectedissue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'projects'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/global-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '/issues'
                },
                search: {
                    matches: '.*filter.*'
                }
            }
        }
    },
    {
        name: 'jira/issues-full-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software'
                }
            }
        }
    },
    {
        name: 'jira/polaris',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/polaris'
                }
            }
        }
    },
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'backlog'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    },
    {
        name: 'jira/helpcenter',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/helpcenter'
                }
            }
        }
    },
    {
        name: 'jira/ops',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops'
                }
            }
        }
    },
    {
        // Jira Plans timeline/list view
        name: 'jira/plan/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/timeline'
                }
            }
        }
    },
    {
        // Jira Plans calendar view
        name: 'jira/plan/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/calendar'
                }
            }
        }
    },
    {
        // Jira Plans program board
        name: 'jira/plan/program',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/program'
                }
            }
        }
    },
    {
        // Any pages within Jira Plan
        name: 'jira/plan',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*'
                }
            }
        }
    },
    {
        name: 'jira/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*(?=.*project)(?=.*setting).*'
                }
            }
        }
    },
    {
        name: 'jira/your-work',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/issues/?$'
                }
            }
        }
    },
    {
        name: 'jira/ops/alerts',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts'
                }
            }
        }
    },
    {
        name: 'jira/ops/alert-details',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/integration',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/integrations/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/team-policies',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/policies'
                }
            }
        }
    },
    {
        name: 'jira/ops/group-detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/group-detail'
                }
            }
        }
    },
    {
        name: 'jira/ops/heartbeats',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/heartbeats'
                }
            }
        }
    },
    {
        name: 'jira/ops/who-is-on-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/who-is-on-call'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/on-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/on-call'
                }
            }
        }
    },
    {
        name: 'jira/ops/alert-notifications',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/settings/personal/alert-notifications'
                }
            }
        }
    },
    {
        name: 'jira/settings/products/ops/incoming-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/settings/products/ops/incoming-call(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/settings/automation',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'settings/automation'
                }
            }
        }
    },
    {
        name: 'jira/for-you',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/for-you'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types/cases',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types/category/cases'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/projects/incidents',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/section/incidents/custom/.*?/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/business/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board'
                }
            }
        }
    },
    {
        name: 'jira/business/board/not/embedded',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*/boards/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*/boards/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/board/not/embedded',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/boards/(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/boards/.*?/backlog(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/list-detail-view',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*list.*'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/business/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/software/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        // Handles both CMP Software and Business
        name: 'jira/cmp/project-settings/people',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/people'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        // Any project route in JSW
        name: 'jira/software/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JSW
        name: 'jira/software/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Any project route in JWM
        name: 'jira/business/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JWM
        name: 'jira/business/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Project directory
        name: 'jira/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/projects'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/.+?/list'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/project-summary',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/summary'
                }
            }
        }
    },
    {
        name: 'jira/software/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/[^/]+)?/projects/[^/]+/boards'
                }
            }
        }
    },
    {
        name: 'loom/all',
        when: {
            context: {
                product: 'loom'
            }
        }
    },
    {
        name: 'loom/home',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'home'
                }
            }
        }
    },
    {
        name: 'loom/looms/videos',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'looms/videos'
                }
            }
        }
    },
    {
        name: 'loom/meetings',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'meetings'
                }
            }
        }
    },
    {
        name: 'loom/notifications/all',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'notifications/all'
                }
            }
        }
    },
    {
        name: 'loom/watch-later',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'watch-later'
                }
            }
        }
    },
    {
        name: 'loom/history',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'history'
                }
            }
        }
    },
    {
        name: 'loom/settings/account',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/account'
                }
            }
        }
    },
    {
        name: 'loom/settings/workspace',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/workspace'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/cmp/project-settings/project-config/issuelayout',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/issuelayout'
                }
            }
        }
    },
    {
        name: 'studio/rovo-agents',
        when: {
            context: {
                product: 'atlassianStudio',
                subproduct: 'rovo-agents'
            }
        }
    },
    {
        name: 'studio/all',
        when: {
            context: {
                product: 'atlassianStudio'
            }
        }
    },
    {
        name: 'cpq',
        when: {
            context: {
                product: 'cpq'
            }
        }
    },
    {
        name: 'welcome/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'welcome/software'
                }
            }
        }
    },
    {
        name: 'bitbucket/all',
        when: {
            context: {
                product: 'bitbucket'
            }
        }
    },
    {
        name: 'bitbucket/home',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'workspace/overview'
                }
            }
        }
    },
    {
        name: 'bitbucket/admin',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'admin'
                }
            }
        }
    },
    {
        name: 'bitbucket/settings',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'workspace/settings'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-requests/new',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/new'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-requests/list',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/?$'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-request/view',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/\\d+'
                }
            }
        }
    },
    {
        name: 'jira/rovo-search',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/rovo-search'
                }
            }
        }
    },
    {
        name: 'confluence/rovo-search',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/search'
                }
            }
        }
    },
    {
        name: 'jira/assets/dashboards',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    // Dashboard id in product is a UUID (path segment after …/dashboards/)
                    matches: 'jira/assets/dashboards/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
                }
            }
        }
    },
    {
        name: 'jira/assets/schemas',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/assets/schemas$'
                }
            }
        }
    }
];


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $23990983e3348fe0$export$a5cfae247d8360ef = 'screen-space-flags';


/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $jQRRW = parcelRequire("jQRRW");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $190tu = parcelRequire("190tu");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ce10a05500133248$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ce10a05500133248$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("cZpTL")));
        case 'da':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("b5mhT")));
        case 'de':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("9Twow")));
        case 'en-GB':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("iCk4Y")));
        case 'en-US':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("i0ur8")));
        case 'en-XA':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("l7s9R")));
        case 'en-XB':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("gnY8c")));
        case 'en-ZZ':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("9LdEZ")));
        case 'en':
            return $ce10a05500133248$var$importHelper(await Promise.resolve((parcelRequire("190tu"))));
        case 'es':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("fEHAt")));
        case 'et':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("47Um8")));
        case 'fi':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("fr5Eg")));
        case 'fr':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("6PuHy")));
        case 'hr':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("34UIr")));
        case 'hu':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("gAwaN")));
        case 'it':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("lVcnf")));
        case 'ja':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("hBROz")));
        case 'ko':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("gVffl")));
        case 'nb':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("kJQNY")));
        case 'nl':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("iVNUL")));
        case 'pl':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("izM9A")));
        case 'pt-BR':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("ciqSJ")));
        case 'ro':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("jjEwj")));
        case 'ru':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("dv3cd")));
        case 'sl':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("37kkP")));
        case 'sr-RS':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("3b4CG")));
        case 'sr-YR':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("6xgDq")));
        case 'sr':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("kN3Ki")));
        case 'sv':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("b6EFp")));
        case 'th':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("c5Azu")));
        case 'tr':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("6cSLG")));
        case 'uk':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("dcpcT")));
        case 'vi':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("lITtB")));
        case 'zh-CN':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("6Rfcd")));
        case 'zh-TW':
            return $ce10a05500133248$var$importHelper(await (parcelRequire("ktVuZ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($190tu));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $gNhq8 = parcelRequire("gNhq8");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3775b3243126f7e2$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3775b3243126f7e2$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("cvpCL")));
        case 'da':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("3rDPF")));
        case 'de':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("koyyF")));
        case 'en-GB':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("fW7pK")));
        case 'en-US':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("4SIDg")));
        case 'en-XA':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("6cdWq")));
        case 'en-XB':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("k44G7")));
        case 'en-ZZ':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("hTIiZ")));
        case 'en':
            return $3775b3243126f7e2$var$importHelper(await Promise.resolve((parcelRequire("gNhq8"))));
        case 'es':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("7JvUo")));
        case 'et':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("dRM9e")));
        case 'fi':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("eyA4r")));
        case 'fr':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("hTjzH")));
        case 'hr':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("1JrzL")));
        case 'hu':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("lcJUc")));
        case 'it':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("l1Qvs")));
        case 'ja':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("97gxo")));
        case 'ko':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("28KjQ")));
        case 'nb':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("cPkVk")));
        case 'nl':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("87m4Y")));
        case 'pl':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("3LQss")));
        case 'pt-BR':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("kADCg")));
        case 'ro':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("5riq8")));
        case 'ru':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("cagvh")));
        case 'sl':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("ksw7T")));
        case 'sr-RS':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("ceSvC")));
        case 'sr-YR':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("apwlw")));
        case 'sr':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("fSi2v")));
        case 'sv':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("F3Cke")));
        case 'th':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("g1ihm")));
        case 'tr':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("gUFVV")));
        case 'uk':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("2yg4t")));
        case 'vi':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("cOEa8")));
        case 'zh-CN':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("47qkI")));
        case 'zh-TW':
            return $3775b3243126f7e2$var$importHelper(await (parcelRequire("fjGpB")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($gNhq8));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aaA6n = parcelRequire("aaA6n");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $49b3f91cccc41e4d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $49b3f91cccc41e4d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("3BZ99")));
        case 'da':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("bWvna")));
        case 'de':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("flGYB")));
        case 'en-GB':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("5qBEv")));
        case 'en-US':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("lIPCs")));
        case 'en-XA':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("8zNf2")));
        case 'en-XB':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("1SRKH")));
        case 'en-ZZ':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("fFhpz")));
        case 'en':
            return $49b3f91cccc41e4d$var$importHelper(await Promise.resolve((parcelRequire("aaA6n"))));
        case 'es':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("3XVjk")));
        case 'et':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("6p29z")));
        case 'fi':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("eNOc0")));
        case 'fr':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("9k5WG")));
        case 'hr':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("7owSW")));
        case 'hu':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("l9B7C")));
        case 'it':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("iptbF")));
        case 'ja':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("7zZbX")));
        case 'ko':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("bMnbg")));
        case 'nb':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("2hRtX")));
        case 'nl':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("6FkeT")));
        case 'pl':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("5LN1r")));
        case 'pt-BR':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("cFcSb")));
        case 'ro':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("aKNKv")));
        case 'ru':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("yDHmi")));
        case 'sl':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("1djfm")));
        case 'sr-RS':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("eZUNS")));
        case 'sr-YR':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("c3PIF")));
        case 'sr':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("ihhCr")));
        case 'sv':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("aLzaO")));
        case 'th':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("5ZMR4")));
        case 'tr':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("kI5EO")));
        case 'uk':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("4OPSI")));
        case 'vi':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("cFPHn")));
        case 'zh-CN':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("dULS7")));
        case 'zh-TW':
            return $49b3f91cccc41e4d$var$importHelper(await (parcelRequire("g7y9j")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aaA6n));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4fHNz = parcelRequire("4fHNz");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $82c41f1ec94ebfb9$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $82c41f1ec94ebfb9$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("5xziy")));
        case 'da':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("18Hzf")));
        case 'de':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("9iBIA")));
        case 'en-GB':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("cfipm")));
        case 'en-US':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("fiu0J")));
        case 'en-XA':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("dfqFh")));
        case 'en-XB':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("c2cWs")));
        case 'en-ZZ':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("d52Hd")));
        case 'en':
            return $82c41f1ec94ebfb9$var$importHelper(await Promise.resolve((parcelRequire("4fHNz"))));
        case 'es':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("lgF96")));
        case 'et':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("jw1FE")));
        case 'fi':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("4JELE")));
        case 'fr':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("1kxJj")));
        case 'hr':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("l6zVa")));
        case 'hu':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("dWyoI")));
        case 'it':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("fvKND")));
        case 'ja':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("dcjOX")));
        case 'ko':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("aPCcp")));
        case 'nb':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("2uSwL")));
        case 'nl':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("68cCD")));
        case 'pl':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("jppvA")));
        case 'pt-BR':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("jybJb")));
        case 'ro':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("j64Xe")));
        case 'ru':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("bxqIw")));
        case 'sl':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("hSedA")));
        case 'sr-RS':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("9uHPr")));
        case 'sr-YR':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("hSWH0")));
        case 'sr':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("1sSzi")));
        case 'sv':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("8qXgQ")));
        case 'th':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("4Lajz")));
        case 'tr':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("eNPlV")));
        case 'uk':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("e9vFn")));
        case 'vi':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("jq4oY")));
        case 'zh-CN':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("2awYG")));
        case 'zh-TW':
            return $82c41f1ec94ebfb9$var$importHelper(await (parcelRequire("aaQMD")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4fHNz));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $hT7EH = parcelRequire("hT7EH");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9dd3c1b4511f6644$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $9dd3c1b4511f6644$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("1jabv")));
        case 'da':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("7mov1")));
        case 'de':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("8uoVC")));
        case 'en-GB':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("gz6uF")));
        case 'en-US':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("1GoYT")));
        case 'en-XA':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("eQ8Zl")));
        case 'en-XB':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("ikHh6")));
        case 'en-ZZ':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("2GiBV")));
        case 'en':
            return $9dd3c1b4511f6644$var$importHelper(await Promise.resolve((parcelRequire("hT7EH"))));
        case 'es':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("iyWwK")));
        case 'et':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("hDhdt")));
        case 'fi':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("8aVea")));
        case 'fr':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("kEfSb")));
        case 'hr':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("gJAAM")));
        case 'hu':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("5S4RM")));
        case 'it':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("4p85t")));
        case 'ja':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("1wmq7")));
        case 'ko':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("bdz3k")));
        case 'nb':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("cPixi")));
        case 'nl':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("cINh8")));
        case 'pl':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("hgFsW")));
        case 'pt-BR':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("9E73q")));
        case 'ro':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("krMf2")));
        case 'ru':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("j7xZf")));
        case 'sl':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("jL6am")));
        case 'sr-RS':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("738nS")));
        case 'sr-YR':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("7EYyR")));
        case 'sr':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("9dQw1")));
        case 'sv':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("lvh45")));
        case 'th':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("31dUW")));
        case 'tr':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("bkyZM")));
        case 'uk':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("aSroz")));
        case 'vi':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("3JFOi")));
        case 'zh-CN':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("k82YV")));
        case 'zh-TW':
            return $9dd3c1b4511f6644$var$importHelper(await (parcelRequire("7MpBv")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($hT7EH));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2Cirw = parcelRequire("2Cirw");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $874af0c9f9765348$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $874af0c9f9765348$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("eGMaw")));
        case 'da':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("kFAf3")));
        case 'de':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("5vL4N")));
        case 'en-GB':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("br3Zc")));
        case 'en-US':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("gvITV")));
        case 'en-XA':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("glRb3")));
        case 'en-XB':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("6lsG6")));
        case 'en-ZZ':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("6hJXo")));
        case 'en':
            return $874af0c9f9765348$var$importHelper(await Promise.resolve((parcelRequire("2Cirw"))));
        case 'es':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("dj23V")));
        case 'et':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("1bBKq")));
        case 'fi':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("e4mSG")));
        case 'fr':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("36Mfu")));
        case 'hr':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("hcQ82")));
        case 'hu':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("6iZLw")));
        case 'it':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("erHpn")));
        case 'ja':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("fdQsb")));
        case 'ko':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("8wptm")));
        case 'nb':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("gR2mu")));
        case 'nl':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("QOrlE")));
        case 'pl':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("69mtF")));
        case 'pt-BR':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("ttQQt")));
        case 'ro':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("1KReV")));
        case 'ru':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("8XtxY")));
        case 'sl':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("clVOb")));
        case 'sr-RS':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("h0bQ4")));
        case 'sr-YR':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("2QxUV")));
        case 'sr':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("fw3gu")));
        case 'sv':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("fEd1a")));
        case 'th':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("aIa2C")));
        case 'tr':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("a1qBH")));
        case 'uk':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("lyaP6")));
        case 'vi':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("6MzGD")));
        case 'zh-CN':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("iiltI")));
        case 'zh-TW':
            return $874af0c9f9765348$var$importHelper(await (parcelRequire("bleeZ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2Cirw));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kf5a8 = parcelRequire("kf5a8");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c5b1d60977197279$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $c5b1d60977197279$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("k0hHz")));
        case 'da':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("iszcR")));
        case 'de':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("5Or4T")));
        case 'en-GB':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("kgmEP")));
        case 'en-US':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("enblM")));
        case 'en-XA':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("dOAsv")));
        case 'en-XB':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("2DvGy")));
        case 'en-ZZ':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("7A6dp")));
        case 'en':
            return $c5b1d60977197279$var$importHelper(await Promise.resolve((parcelRequire("kf5a8"))));
        case 'es':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("cI4O0")));
        case 'et':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("6QVjH")));
        case 'fi':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("1Z7QE")));
        case 'fr':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("l8KD4")));
        case 'hr':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("ddnGe")));
        case 'hu':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("6U0oD")));
        case 'it':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("6zdfY")));
        case 'ja':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("eZjit")));
        case 'ko':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("lK1xg")));
        case 'nb':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("iEkDX")));
        case 'nl':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("wZgFM")));
        case 'pl':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("dR7EO")));
        case 'pt-BR':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("1mq27")));
        case 'ro':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("k6ih1")));
        case 'ru':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("2nwWB")));
        case 'sl':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("2p5QR")));
        case 'sr-RS':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("8HI7p")));
        case 'sr-YR':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("v1VfJ")));
        case 'sr':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("eCARq")));
        case 'sv':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("j8LSv")));
        case 'th':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("1bpCj")));
        case 'tr':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("7fpPm")));
        case 'uk':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("dPdg3")));
        case 'vi':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("le2JO")));
        case 'zh-CN':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("7W1zC")));
        case 'zh-TW':
            return $c5b1d60977197279$var$importHelper(await (parcelRequire("7RgIB")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kf5a8));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $e77Av = parcelRequire("e77Av");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4d103c8ed05eb4fd$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $4d103c8ed05eb4fd$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("lnCdp")));
        case 'da':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("eb1gR")));
        case 'de':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("5RIKb")));
        case 'en-GB':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("dovsn")));
        case 'en-US':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("8ujMv")));
        case 'en-XA':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("7uLNo")));
        case 'en-XB':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("h5IDc")));
        case 'en-ZZ':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("eqahM")));
        case 'en':
            return $4d103c8ed05eb4fd$var$importHelper(await Promise.resolve((parcelRequire("e77Av"))));
        case 'es':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("gUfa2")));
        case 'et':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("fzoAJ")));
        case 'fi':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("bHHEy")));
        case 'fr':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("1LZnU")));
        case 'hr':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("e5v3e")));
        case 'hu':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("9nIBZ")));
        case 'it':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("26FpJ")));
        case 'ja-JP':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("4Gifa")));
        case 'ja':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("gjCMe")));
        case 'ko':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("2uT7I")));
        case 'nb':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("hvuuM")));
        case 'nl':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("hnBZg")));
        case 'pl':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("7SJn9")));
        case 'pt-BR':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("j05vz")));
        case 'ro':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("i0UGC")));
        case 'ru':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("7sBhv")));
        case 'sl':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("luKLP")));
        case 'sr-RS':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("1eM5i")));
        case 'sr-YR':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("5VqXr")));
        case 'sr':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("aFL7V")));
        case 'sv':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("hADG6")));
        case 'th':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("h6zhf")));
        case 'tr':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("gk800")));
        case 'uk':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("8KsH5")));
        case 'vi':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("8gA9a")));
        case 'zh-CN':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("e3o5i")));
        case 'zh-TW':
            return $4d103c8ed05eb4fd$var$importHelper(await (parcelRequire("2Zvud")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($e77Av));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kMgxO = parcelRequire("kMgxO");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $193ea6a661b759dc$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $193ea6a661b759dc$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("myuXu")));
        case 'da':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("1Zl29")));
        case 'de':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("3ktao")));
        case 'en-GB':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("aTDX5")));
        case 'en-US':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("gMxgr")));
        case 'en-XA':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("1Af9x")));
        case 'en-XB':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("buXa0")));
        case 'en-ZZ':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("ccbpW")));
        case 'en':
            return $193ea6a661b759dc$var$importHelper(await Promise.resolve((parcelRequire("kMgxO"))));
        case 'es':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("j434L")));
        case 'et':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("dMsU4")));
        case 'fi':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("jyRDE")));
        case 'fr':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("9pglX")));
        case 'hr':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("iozT6")));
        case 'hu':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("dJrYt")));
        case 'it':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("7B9fx")));
        case 'ja':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("7GCXU")));
        case 'ko':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("eDQJt")));
        case 'nb':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("h2jfy")));
        case 'nl':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("jFjcD")));
        case 'pl':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("2pDy6")));
        case 'pt-BR':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("7ef6d")));
        case 'ro':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("na8Hk")));
        case 'ru':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("cgktE")));
        case 'sl':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("1I6NP")));
        case 'sr-RS':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("9BVla")));
        case 'sr-YR':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("cZ5ja")));
        case 'sr':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("im5oS")));
        case 'sv':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("e6ztg")));
        case 'th':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("lTjdd")));
        case 'tr':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("f1Q5v")));
        case 'uk':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("gDyIy")));
        case 'vi':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("9JZXX")));
        case 'zh-CN':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("e8Hp5")));
        case 'zh-TW':
            return $193ea6a661b759dc$var$importHelper(await (parcelRequire("2iQNZ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kMgxO));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fDWrG = parcelRequire("fDWrG");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $96974bb3b0aa91b9$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $96974bb3b0aa91b9$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("cGmZy")));
        case 'da':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("aeM1b")));
        case 'de':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("djdhG")));
        case 'en-GB':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("aEsGF")));
        case 'en-US':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("4HhyS")));
        case 'en-XA':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("uaYOe")));
        case 'en-XB':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("e4gwe")));
        case 'en-ZZ':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("2lp9B")));
        case 'en':
            return $96974bb3b0aa91b9$var$importHelper(await Promise.resolve((parcelRequire("fDWrG"))));
        case 'es':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("1CkmC")));
        case 'et':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("7YcUs")));
        case 'fi':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("fQLi3")));
        case 'fr':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("1TBQM")));
        case 'hr':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("hkcvm")));
        case 'hu':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("gzkUO")));
        case 'it':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("fPjSs")));
        case 'ja':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("uiA6m")));
        case 'ko':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("8rxkz")));
        case 'nb':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("1MYlW")));
        case 'nl':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("czdey")));
        case 'pl':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("1yEI5")));
        case 'pt-BR':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("fTF6i")));
        case 'ro':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("5kcep")));
        case 'ru':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("jCvFV")));
        case 'sl':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("dcSyT")));
        case 'sr-RS':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("2FKmW")));
        case 'sr-YR':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("dL1X2")));
        case 'sr':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("5GLIP")));
        case 'sv':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("8T3bi")));
        case 'th':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("bkDbV")));
        case 'tr':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("ec0Qz")));
        case 'uk':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("err6c")));
        case 'vi':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("cx45K")));
        case 'zh-CN':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("kJHYp")));
        case 'zh-TW':
            return $96974bb3b0aa91b9$var$importHelper(await (parcelRequire("ensmY")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fDWrG));
    }
};



var $c0QiU = parcelRequire("c0QiU");


var $8SCD0 = parcelRequire("8SCD0");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $96o0f = parcelRequire("96o0f");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c806437e9ab3c705$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $c806437e9ab3c705$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("8pkfo")));
        case 'da':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("3xGoG")));
        case 'de':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("40eBS")));
        case 'en-GB':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("aPwCB")));
        case 'en-US':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("4ugRI")));
        case 'en-XA':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("lXmGM")));
        case 'en-XB':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("f4AyR")));
        case 'en-ZZ':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("kCR1F")));
        case 'en':
            return $c806437e9ab3c705$var$importHelper(await Promise.resolve((parcelRequire("96o0f"))));
        case 'es':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("cmHVh")));
        case 'et':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("4l2T3")));
        case 'fi':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("dFQgI")));
        case 'fr':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("2dfft")));
        case 'hr':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("kvq2U")));
        case 'hu':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("fuDUl")));
        case 'it':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("CbMTN")));
        case 'ja':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("95nBU")));
        case 'ko':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("5zIEY")));
        case 'nb':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("g3fl3")));
        case 'nl':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("lY2P3")));
        case 'pl':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("hSkuL")));
        case 'pt-BR':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("2LCWr")));
        case 'ro':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("l3u53")));
        case 'ru':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("iagzr")));
        case 'sl':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("a57cu")));
        case 'sr-RS':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("hhSu4")));
        case 'sr-YR':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("4j5zJ")));
        case 'sr':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("gVJGC")));
        case 'sv':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("frDwI")));
        case 'th':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("DmzaP")));
        case 'tr':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("bi3sU")));
        case 'uk':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("8cyvu")));
        case 'vi':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("9qg2r")));
        case 'zh-CN':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("e0XLq")));
        case 'zh-TW':
            return $c806437e9ab3c705$var$importHelper(await (parcelRequire("4senR")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($96o0f));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $faKVU = parcelRequire("faKVU");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $41aea332c559312c$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $41aea332c559312c$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("2hVW4")));
        case 'da':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("fAaEK")));
        case 'de':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("8GjgQ")));
        case 'en-GB':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("5a41J")));
        case 'en-US':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("fix6E")));
        case 'en-XA':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("bwCLU")));
        case 'en-XB':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("4bt64")));
        case 'en-ZZ':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("6MvOp")));
        case 'en':
            return $41aea332c559312c$var$importHelper(await Promise.resolve((parcelRequire("faKVU"))));
        case 'es':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("60oCJ")));
        case 'et':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("hgfXf")));
        case 'fi':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("bf7FY")));
        case 'fr':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("8TUis")));
        case 'hr':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("goxB3")));
        case 'hu':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("atMnC")));
        case 'it':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("eDBpO")));
        case 'ja':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("fndj2")));
        case 'ko':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("1Fzpx")));
        case 'nb':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("4ZXgO")));
        case 'nl':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("7ArxX")));
        case 'pl':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("kHy3v")));
        case 'pt-BR':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("27vXu")));
        case 'ro':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("aGvLS")));
        case 'ru':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("brfyh")));
        case 'sl':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("9S126")));
        case 'sr-RS':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("7Hl4N")));
        case 'sr-YR':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("18607")));
        case 'sr':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("k3ViT")));
        case 'sv':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("cISby")));
        case 'th':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("3JasV")));
        case 'tr':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("9euEq")));
        case 'uk':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("bQrvq")));
        case 'vi':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("5y8fx")));
        case 'zh-CN':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("jUr6Q")));
        case 'zh-TW':
            return $41aea332c559312c$var$importHelper(await (parcelRequire("1PEi6")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($faKVU));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $g9B2Z = parcelRequire("g9B2Z");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $636cec1019919bed$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $636cec1019919bed$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("fbEnR")));
        case 'da':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("lFFbj")));
        case 'de':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("lkpSJ")));
        case 'en-GB':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("2q85D")));
        case 'en-US':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("e64qf")));
        case 'en-XA':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("2WvPQ")));
        case 'en-XB':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("2KXXN")));
        case 'en-ZZ':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("anZ9e")));
        case 'en':
            return $636cec1019919bed$var$importHelper(await Promise.resolve((parcelRequire("g9B2Z"))));
        case 'es':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("1O5Gg")));
        case 'et':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("hXxhz")));
        case 'fi':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("iy9Kq")));
        case 'fr':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("3vBHP")));
        case 'hr':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("cfRRK")));
        case 'hu':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("hudxz")));
        case 'it':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("hY4Xy")));
        case 'ja':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("OMRr8")));
        case 'ko':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("7wXr9")));
        case 'nb':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("eYyK6")));
        case 'nl':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("aM9uG")));
        case 'pl':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("mfQCG")));
        case 'pt-BR':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("e8E84")));
        case 'ro':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("7z0do")));
        case 'ru':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("dgSBX")));
        case 'sl':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("gkvnV")));
        case 'sr-RS':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("ihJB0")));
        case 'sr-YR':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("hQoao")));
        case 'sr':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("j3rsf")));
        case 'sv':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("i6lZE")));
        case 'th':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("gemmb")));
        case 'tr':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("81f9G")));
        case 'uk':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("aPdB2")));
        case 'vi':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("c0bPU")));
        case 'zh-CN':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("1aud0")));
        case 'zh-TW':
            return $636cec1019919bed$var$importHelper(await (parcelRequire("lW8b5")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($g9B2Z));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ayxoO = parcelRequire("ayxoO");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4954c74f42031292$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $4954c74f42031292$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("44VVw")));
        case 'da':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("lj8VP")));
        case 'de':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("7b5JG")));
        case 'en-GB':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("fkiO8")));
        case 'en-US':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("ctn5G")));
        case 'en-XA':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("lEFIu")));
        case 'en-XB':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("6Vy8L")));
        case 'en-ZZ':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("i9SUy")));
        case 'en':
            return $4954c74f42031292$var$importHelper(await Promise.resolve((parcelRequire("ayxoO"))));
        case 'es':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("3D2oa")));
        case 'et':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("aBfSC")));
        case 'fi':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("aXfLu")));
        case 'fr':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("hHbpn")));
        case 'hr':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("3FQml")));
        case 'hu':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("epMeh")));
        case 'it':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("M4CYG")));
        case 'ja':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("ax0T5")));
        case 'ko':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("h19CY")));
        case 'nb':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("jd0kM")));
        case 'nl':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("cP3TX")));
        case 'pl':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("kkbnw")));
        case 'pt-BR':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("jwK8C")));
        case 'ro':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("h63LY")));
        case 'ru':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("bZxBV")));
        case 'sl':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("8dMdU")));
        case 'sr-RS':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("bb8gm")));
        case 'sr-YR':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("gEoeD")));
        case 'sr':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("ax3oZ")));
        case 'sv':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("6qkex")));
        case 'th':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("cnFuw")));
        case 'tr':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("32434")));
        case 'uk':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("cnPZE")));
        case 'vi':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("ceQUP")));
        case 'zh-CN':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("2Ee5k")));
        case 'zh-TW':
            return $4954c74f42031292$var$importHelper(await (parcelRequire("lYBDN")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ayxoO));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $cYsan = parcelRequire("cYsan");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f1d52e5870ae9a59$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $f1d52e5870ae9a59$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("4P6Vl")));
        case 'da':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("27aNh")));
        case 'de':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("aSlsY")));
        case 'en-GB':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("cOAck")));
        case 'en-US':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("76gkg")));
        case 'en-XA':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("2Bl1Y")));
        case 'en-XB':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("grzFC")));
        case 'en-ZZ':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("6JE8A")));
        case 'en':
            return $f1d52e5870ae9a59$var$importHelper(await Promise.resolve((parcelRequire("cYsan"))));
        case 'es':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("9S9M8")));
        case 'et':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("gkLcq")));
        case 'fi':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("lLyBc")));
        case 'fr':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("4jCEx")));
        case 'hr':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("7OGyS")));
        case 'hu':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("8clR5")));
        case 'it':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("3MYuU")));
        case 'ja':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("aBCf4")));
        case 'ko':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("5Bhq2")));
        case 'nb':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("3rRY7")));
        case 'nl':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("30lWk")));
        case 'pl':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("hA595")));
        case 'pt-BR':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("3RoXR")));
        case 'ro':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("2j9hJ")));
        case 'ru':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("eRauK")));
        case 'sl':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("krh33")));
        case 'sr-RS':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("eaNh3")));
        case 'sr-YR':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("dbpza")));
        case 'sr':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("gDeem")));
        case 'sv':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("16hwG")));
        case 'th':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("hsd8R")));
        case 'tr':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("2JjwY")));
        case 'uk':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("epoZZ")));
        case 'vi':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("2k0Bf")));
        case 'zh-CN':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("gGmMl")));
        case 'zh-TW':
            return $f1d52e5870ae9a59$var$importHelper(await (parcelRequire("4Juzw")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cYsan));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $7BpGO = parcelRequire("7BpGO");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b1f55b02ab5dd48a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b1f55b02ab5dd48a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("6QBDZ")));
        case 'da':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("hsbp6")));
        case 'de':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("5XNq8")));
        case 'en-GB':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("jaglo")));
        case 'en-US':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("lln0M")));
        case 'en-XA':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("4R0PP")));
        case 'en-XB':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("zm9ce")));
        case 'en-ZZ':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("2PCg8")));
        case 'en':
            return $b1f55b02ab5dd48a$var$importHelper(await Promise.resolve((parcelRequire("7BpGO"))));
        case 'es':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("cSEky")));
        case 'et':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("8jOSK")));
        case 'fi':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("lqJAb")));
        case 'fr':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("hLNRp")));
        case 'hr':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("hEaLO")));
        case 'hu':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("edyni")));
        case 'it':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("3v8Uk")));
        case 'ja':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("bUyhs")));
        case 'ko':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("4DZSE")));
        case 'nb':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("kZ3Vp")));
        case 'nl':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("5L9Y0")));
        case 'pl':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("9VlSx")));
        case 'pt-BR':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("2IZJt")));
        case 'ro':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("2IzXu")));
        case 'ru':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("bholk")));
        case 'sl':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("8bDhu")));
        case 'sr-RS':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("4wkUe")));
        case 'sr-YR':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("jKH7t")));
        case 'sr':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("ax7Wv")));
        case 'sv':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("iXAiR")));
        case 'th':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("1kllb")));
        case 'tr':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("bMeLJ")));
        case 'uk':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("cGxs1")));
        case 'vi':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("bQE6x")));
        case 'zh-CN':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("5fPLI")));
        case 'zh-TW':
            return $b1f55b02ab5dd48a$var$importHelper(await (parcelRequire("2h5uo")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($7BpGO));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jeVa2 = parcelRequire("jeVa2");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1cfeadb092a11e96$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $1cfeadb092a11e96$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("8jtTq")));
        case 'da':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("cv3GI")));
        case 'de':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("ZXTsi")));
        case 'en-GB':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("lY5PF")));
        case 'en-US':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("9V8xD")));
        case 'en-XA':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("7pWep")));
        case 'en-XB':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("6rKzg")));
        case 'en-ZZ':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("2oKaF")));
        case 'en':
            return $1cfeadb092a11e96$var$importHelper(await Promise.resolve((parcelRequire("jeVa2"))));
        case 'es':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("41esF")));
        case 'et':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("dRD1P")));
        case 'fi':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("fFTG6")));
        case 'fr':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("bCI0M")));
        case 'hr':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("4l9p8")));
        case 'hu':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("brtXp")));
        case 'it':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("FE06j")));
        case 'ja':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("4QkHm")));
        case 'ko':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("gbbp3")));
        case 'nb':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("e82Fu")));
        case 'nl':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("e6FoT")));
        case 'pl':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("fhiWh")));
        case 'pt-BR':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("aWZX5")));
        case 'ro':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("aV1kH")));
        case 'ru':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("6f7fJ")));
        case 'sl':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("7y5pr")));
        case 'sr-RS':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("jHNNf")));
        case 'sr-YR':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("8Qs2q")));
        case 'sr':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("kVBlv")));
        case 'sv':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("46N3z")));
        case 'th':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("l5yjD")));
        case 'tr':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("gM1Sd")));
        case 'uk':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("jcc6B")));
        case 'vi':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("eSb44")));
        case 'zh-CN':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("ab3Wu")));
        case 'zh-TW':
            return $1cfeadb092a11e96$var$importHelper(await (parcelRequire("4KkWY")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jeVa2));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $b2ONX = parcelRequire("b2ONX");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e84fe42f89af6fb4$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e84fe42f89af6fb4$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("8gKl9")));
        case 'da':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("jpSOO")));
        case 'de':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("6AecT")));
        case 'en-GB':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("hlWDs")));
        case 'en-US':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("l6nXd")));
        case 'en-XA':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("iEmwp")));
        case 'en-XB':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("2gNE9")));
        case 'en-ZZ':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("aTgWD")));
        case 'en':
            return $e84fe42f89af6fb4$var$importHelper(await Promise.resolve((parcelRequire("b2ONX"))));
        case 'es':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("iiAsS")));
        case 'et':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("2tWdS")));
        case 'fi':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("iiOFt")));
        case 'fr':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("aeHTQ")));
        case 'hr':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("5GK6s")));
        case 'hu':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("eEw0a")));
        case 'it':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("jthau")));
        case 'ja':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("84Cxf")));
        case 'ko':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("iW3kM")));
        case 'nb':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("9nNUV")));
        case 'nl':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("81GdU")));
        case 'pl':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("92qiC")));
        case 'pt-BR':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("9bHyb")));
        case 'ro':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("gvcyQ")));
        case 'ru':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("jRfhy")));
        case 'sl':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("irGVY")));
        case 'sr-RS':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("7O4me")));
        case 'sr-YR':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("4s7jC")));
        case 'sr':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("dA2nN")));
        case 'sv':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("9IUYg")));
        case 'th':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("bCUq0")));
        case 'tr':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("ew9Iy")));
        case 'uk':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("h6IDB")));
        case 'vi':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("hKi96")));
        case 'zh-CN':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("4Dsjr")));
        case 'zh-TW':
            return $e84fe42f89af6fb4$var$importHelper(await (parcelRequire("laflr")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($b2ONX));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $k3ebb = parcelRequire("k3ebb");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bce6c13b69697278$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $bce6c13b69697278$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("ktaGw")));
        case 'da':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("1nAmB")));
        case 'de':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("kADfk")));
        case 'en-GB':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("39Kqy")));
        case 'en-US':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("lspmN")));
        case 'en-XA':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("OUGQx")));
        case 'en-XB':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("aXzEj")));
        case 'en-ZZ':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("eeT8z")));
        case 'en':
            return $bce6c13b69697278$var$importHelper(await Promise.resolve((parcelRequire("k3ebb"))));
        case 'es':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("gWIaz")));
        case 'et':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("7edTv")));
        case 'fi':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("4OGmS")));
        case 'fr':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("7BE2v")));
        case 'hr':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("56MyO")));
        case 'hu':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("qLVGx")));
        case 'it':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("48zwW")));
        case 'ja':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("cQeIN")));
        case 'ko':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("1Dxz8")));
        case 'nb':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("d4Hmo")));
        case 'nl':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("gjyaO")));
        case 'pl':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("cAhBk")));
        case 'pt-BR':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("8YHHO")));
        case 'ro':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("759f8")));
        case 'ru':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("7Y4Mm")));
        case 'sl':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("fBb1L")));
        case 'sr-RS':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("fO9qZ")));
        case 'sr-YR':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("kYiGN")));
        case 'sr':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("25Upz")));
        case 'sv':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("2KPG0")));
        case 'th':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("8uKnv")));
        case 'tr':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("hHp3F")));
        case 'uk':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("ex8X1")));
        case 'vi':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("6SbWl")));
        case 'zh-CN':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("6wqja")));
        case 'zh-TW':
            return $bce6c13b69697278$var$importHelper(await (parcelRequire("5VpDs")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($k3ebb));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $cGs9w = parcelRequire("cGs9w");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d75107a999e7d9fe$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $d75107a999e7d9fe$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("dhNNU")));
        case 'da':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("jeBuB")));
        case 'de':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("j6f4O")));
        case 'en-GB':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("kD2zY")));
        case 'en-US':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("92Bya")));
        case 'en-XA':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("aOWdw")));
        case 'en-XB':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("7t4bC")));
        case 'en-ZZ':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("7Sa8a")));
        case 'en':
            return $d75107a999e7d9fe$var$importHelper(await Promise.resolve((parcelRequire("cGs9w"))));
        case 'es':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("lXA5l")));
        case 'et':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("5aTpK")));
        case 'fi':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("7fLFn")));
        case 'fr':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("lhgAS")));
        case 'hr':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("lNiHq")));
        case 'hu':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("h1f53")));
        case 'it':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("9euo9")));
        case 'ja':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("aQeTx")));
        case 'ko':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("jKCUu")));
        case 'nb':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("1u5LJ")));
        case 'nl':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("d2bnS")));
        case 'pl':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("bd2Zq")));
        case 'pt-BR':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("1wPMw")));
        case 'ro':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("gF5rz")));
        case 'ru':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("elclF")));
        case 'sl':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("kbgzR")));
        case 'sr-RS':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("v1pT0")));
        case 'sr-YR':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("l0Crr")));
        case 'sr':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("9PZYW")));
        case 'sv':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("injBd")));
        case 'th':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("hzgJF")));
        case 'tr':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("2aS0a")));
        case 'uk':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("5cu4s")));
        case 'vi':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("lplb2")));
        case 'zh-CN':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("8nYPU")));
        case 'zh-TW':
            return $d75107a999e7d9fe$var$importHelper(await (parcelRequire("50zN1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cGs9w));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $foa2l = parcelRequire("foa2l");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $98c214c47f807082$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $98c214c47f807082$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("qRlBF")));
        case 'da':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("eICgf")));
        case 'de':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("fSFtG")));
        case 'en-GB':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("9B4Ca")));
        case 'en-US':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("5aMRH")));
        case 'en-XA':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("5fuln")));
        case 'en-XB':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("1mHIH")));
        case 'en-ZZ':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("1uSoo")));
        case 'en':
            return $98c214c47f807082$var$importHelper(await Promise.resolve((parcelRequire("foa2l"))));
        case 'es':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("jtzSo")));
        case 'et':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("53ueL")));
        case 'fi':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("fKytd")));
        case 'fr':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("63vCc")));
        case 'hr':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("4MvCs")));
        case 'hu':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("aoP1S")));
        case 'it':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("3sAgr")));
        case 'ja':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("1n5YT")));
        case 'ko':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("h9xHo")));
        case 'nb':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("8KAdZ")));
        case 'nl':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("bgeKH")));
        case 'pl':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("4B2Nz")));
        case 'pt-BR':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("tRe5z")));
        case 'ro':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("bK3WI")));
        case 'ru':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("7irz8")));
        case 'sl':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("cJiFs")));
        case 'sr-RS':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("j6HYL")));
        case 'sr-YR':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("5zjR4")));
        case 'sr':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("jjCqb")));
        case 'sv':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("3KZyc")));
        case 'th':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("crTHB")));
        case 'tr':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("1Ka3U")));
        case 'uk':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("7E4Qy")));
        case 'vi':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("hYUvO")));
        case 'zh-CN':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("ghsss")));
        case 'zh-TW':
            return $98c214c47f807082$var$importHelper(await (parcelRequire("93OYL")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($foa2l));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $1Vfmh = parcelRequire("1Vfmh");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2620f3af971c6c10$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $2620f3af971c6c10$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("hClXY")));
        case 'da':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("hRm4F")));
        case 'de':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("faXH8")));
        case 'en-GB':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("hJ6r1")));
        case 'en-US':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("g5neE")));
        case 'en-XA':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("lpioP")));
        case 'en-XB':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("hkqrg")));
        case 'en-ZZ':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("179Md")));
        case 'en':
            return $2620f3af971c6c10$var$importHelper(await Promise.resolve((parcelRequire("1Vfmh"))));
        case 'es':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("cKQDj")));
        case 'et':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("5ihX5")));
        case 'fi':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("5abYe")));
        case 'fr':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("3fVB6")));
        case 'hr':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("cuF7f")));
        case 'hu':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("jzbcB")));
        case 'it':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("jUV4j")));
        case 'ja':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("dC4lh")));
        case 'ko':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("dReF7")));
        case 'nb':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("le3nC")));
        case 'nl':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("dyjca")));
        case 'pl':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("kxSoh")));
        case 'pt-BR':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("5PZVa")));
        case 'ro':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("9jewc")));
        case 'ru':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("4JIEf")));
        case 'sl':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("lBugK")));
        case 'sr-RS':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("elWfu")));
        case 'sr-YR':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("dqXgH")));
        case 'sr':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("bUpxm")));
        case 'sv':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("ay5EV")));
        case 'th':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("gbFWz")));
        case 'tr':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("eBJcN")));
        case 'uk':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("jxHHN")));
        case 'vi':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("aEvb3")));
        case 'zh-CN':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("aMU9j")));
        case 'zh-TW':
            return $2620f3af971c6c10$var$importHelper(await (parcelRequire("1dSty")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($1Vfmh));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5U1zM = parcelRequire("5U1zM");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2ef667146b868deb$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $2ef667146b868deb$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("kCxZ5")));
        case 'da':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("alWoE")));
        case 'de':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("2k0yx")));
        case 'en-GB':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("iFxq4")));
        case 'en-US':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("3Xjc2")));
        case 'en-XA':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("51O5A")));
        case 'en-XB':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("dnjzB")));
        case 'en-ZZ':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("ahSoT")));
        case 'en':
            return $2ef667146b868deb$var$importHelper(await Promise.resolve((parcelRequire("5U1zM"))));
        case 'es':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("cJXik")));
        case 'et':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("3f0Fr")));
        case 'fi':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("iWQO6")));
        case 'fr':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("c6nXU")));
        case 'hr':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("7M0f6")));
        case 'hu':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("15WTx")));
        case 'it':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("lAzjh")));
        case 'ja':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("beV3E")));
        case 'ko':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("8Kz2Z")));
        case 'nb':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("aFbGF")));
        case 'nl':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("a24Sy")));
        case 'pl':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("6tcP1")));
        case 'pt-BR':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("7kDLD")));
        case 'ro':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("9JcU7")));
        case 'ru':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("1eIXL")));
        case 'sl':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("ik5VI")));
        case 'sr-RS':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("1wmX4")));
        case 'sr-YR':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("gJj4D")));
        case 'sr':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("kGFwa")));
        case 'sv':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("6XJTT")));
        case 'th':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("cDsqP")));
        case 'tr':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("1sfji")));
        case 'uk':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("hwmk8")));
        case 'vi':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("8aXh4")));
        case 'zh-CN':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("gAZxn")));
        case 'zh-TW':
            return $2ef667146b868deb$var$importHelper(await (parcelRequire("2LLiX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5U1zM));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $57xWx = parcelRequire("57xWx");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6d7e9baaccc5244a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $6d7e9baaccc5244a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("gAEGB")));
        case 'da':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("dMJF5")));
        case 'de':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("6pKIv")));
        case 'en-GB':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("jqwrY")));
        case 'en-US':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("3W8CE")));
        case 'en-XA':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("h214p")));
        case 'en-XB':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("kLlQM")));
        case 'en-ZZ':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("iCeA1")));
        case 'en':
            return $6d7e9baaccc5244a$var$importHelper(await Promise.resolve((parcelRequire("57xWx"))));
        case 'es':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("5rCoM")));
        case 'et':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("aw1rm")));
        case 'fi':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("8ITYw")));
        case 'fr':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("c0Gtc")));
        case 'hr':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("leZEY")));
        case 'hu':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("7tJBP")));
        case 'it':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("5yLqW")));
        case 'ja':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("6yV4D")));
        case 'ko':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("ezNqT")));
        case 'nb':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("8tM0n")));
        case 'nl':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("hr9h0")));
        case 'pl':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("lTIc2")));
        case 'pt-BR':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("ghpeV")));
        case 'ro':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("cZ8Qj")));
        case 'ru':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("kEyaV")));
        case 'sl':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("8InNC")));
        case 'sr-RS':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("hfnTn")));
        case 'sr-YR':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("67PcB")));
        case 'sr':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("22vVN")));
        case 'sv':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("aA24d")));
        case 'th':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("fFh2C")));
        case 'tr':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("8x8Qx")));
        case 'uk':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("kOrUi")));
        case 'vi':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("c5TSF")));
        case 'zh-CN':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("dlwhB")));
        case 'zh-TW':
            return $6d7e9baaccc5244a$var$importHelper(await (parcelRequire("bzFAS")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($57xWx));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4DVgS = parcelRequire("4DVgS");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9205e55c2b03abbf$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $9205e55c2b03abbf$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("18J8c")));
        case 'da':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("ktFNM")));
        case 'de':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("9TP7r")));
        case 'en-GB':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("2MOnI")));
        case 'en-US':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("62ALx")));
        case 'en-XA':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("3TOwu")));
        case 'en-XB':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("bMiNH")));
        case 'en-ZZ':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("jNFAH")));
        case 'en':
            return $9205e55c2b03abbf$var$importHelper(await Promise.resolve((parcelRequire("4DVgS"))));
        case 'es':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("ljkw3")));
        case 'et':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("i0P5c")));
        case 'fi':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("6ODIz")));
        case 'fr':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("kGimx")));
        case 'hr':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("lHPqi")));
        case 'hu':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("iXipl")));
        case 'it':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("33CvA")));
        case 'ja':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("3PU8V")));
        case 'ko':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("6xWQm")));
        case 'nb':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("2YfsB")));
        case 'nl':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("7uCTo")));
        case 'pl':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("e5UZq")));
        case 'pt-BR':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("3nzC9")));
        case 'ro':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("qp9S6")));
        case 'ru':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("evrj3")));
        case 'sl':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("iAREi")));
        case 'sr-RS':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("4JqHt")));
        case 'sr-YR':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("eryyQ")));
        case 'sr':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("3D6Ix")));
        case 'sv':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("9zGMZ")));
        case 'th':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("39Rei")));
        case 'tr':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("l6rvQ")));
        case 'uk':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("lGagy")));
        case 'vi':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("9zunr")));
        case 'zh-CN':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("g92qV")));
        case 'zh-TW':
            return $9205e55c2b03abbf$var$importHelper(await (parcelRequire("ft73v")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4DVgS));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8tEET = parcelRequire("8tEET");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $97f5f84bf86ebe81$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $97f5f84bf86ebe81$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("iitm0")));
        case 'da':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9a0Kb")));
        case 'de':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9X8kp")));
        case 'en-GB':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("d4wxz")));
        case 'en-US':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("8N0XQ")));
        case 'en-XA':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("qvwys")));
        case 'en-XB':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("jJAhj")));
        case 'en-ZZ':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("aC7Do")));
        case 'en':
            return $97f5f84bf86ebe81$var$importHelper(await Promise.resolve((parcelRequire("8tEET"))));
        case 'es':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("a2hH9")));
        case 'et':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("aGNXV")));
        case 'fi':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("3ygJs")));
        case 'fr':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("lEm5y")));
        case 'hr':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("8yWzv")));
        case 'hu':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("byGSA")));
        case 'it':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("71g5k")));
        case 'ja':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("6HenW")));
        case 'ko':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("5HXUg")));
        case 'nb':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("eODHb")));
        case 'nl':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("dLADO")));
        case 'pl':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("24VEe")));
        case 'pt-BR':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("40iY1")));
        case 'ro':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("egl1q")));
        case 'ru':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9mMGO")));
        case 'sl':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("3qFE0")));
        case 'sr-RS':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("3wQcD")));
        case 'sr-YR':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("fDOxt")));
        case 'sr':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9Eqsz")));
        case 'sv':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("gyn2A")));
        case 'th':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("hhf8Q")));
        case 'tr':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("9prlg")));
        case 'uk':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("bGNnN")));
        case 'vi':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("glZwc")));
        case 'zh-CN':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("29rck")));
        case 'zh-TW':
            return $97f5f84bf86ebe81$var$importHelper(await (parcelRequire("3upPm")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8tEET));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $b6i2n = parcelRequire("b6i2n");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $94f4a62ece3e9a21$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $94f4a62ece3e9a21$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("cDdaq")));
        case 'da':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("auOfl")));
        case 'de':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("5wIYr")));
        case 'en-GB':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("7VZz0")));
        case 'en-US':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("k47Zk")));
        case 'en-XA':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("6oMpr")));
        case 'en-XB':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("buNhf")));
        case 'en-ZZ':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("hzXmp")));
        case 'en':
            return $94f4a62ece3e9a21$var$importHelper(await Promise.resolve((parcelRequire("b6i2n"))));
        case 'es':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("dh44h")));
        case 'et':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("7WzwU")));
        case 'fi':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("3k8AG")));
        case 'fr':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("geY98")));
        case 'hr':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("7qHjX")));
        case 'hu':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("3s44g")));
        case 'it':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("1Xkv4")));
        case 'ja':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("as4oX")));
        case 'ko':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("e5dzS")));
        case 'nb':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("dGpOG")));
        case 'nl':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("80uT5")));
        case 'pl':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("6Nmfs")));
        case 'pt-BR':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("i1dhj")));
        case 'ro':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("3sHvi")));
        case 'ru':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("66aeI")));
        case 'sl':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("akPKe")));
        case 'sr-RS':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("62fTj")));
        case 'sr-YR':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("lPC4H")));
        case 'sr':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("2ZduP")));
        case 'sv':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("i4OQL")));
        case 'th':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("gwnv5")));
        case 'tr':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("5Jjdv")));
        case 'uk':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("aJnC5")));
        case 'vi':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("jUDUz")));
        case 'zh-CN':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("17MhK")));
        case 'zh-TW':
            return $94f4a62ece3e9a21$var$importHelper(await (parcelRequire("5iIKM")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($b6i2n));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $hYdie = parcelRequire("hYdie");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $15c7f109c0b3eaf2$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $15c7f109c0b3eaf2$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("8nmw0")));
        case 'da':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("3doji")));
        case 'de':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("1Oqzy")));
        case 'en-GB':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("bVAOn")));
        case 'en-US':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("7AlJL")));
        case 'en-XA':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("41ilg")));
        case 'en-XB':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("b4dkn")));
        case 'en-ZZ':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("96hZt")));
        case 'en':
            return $15c7f109c0b3eaf2$var$importHelper(await Promise.resolve((parcelRequire("hYdie"))));
        case 'es':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("2lwQK")));
        case 'et':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("5nyCO")));
        case 'fi':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("9EUXj")));
        case 'fr':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("jPBlT")));
        case 'hr':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("c1QEb")));
        case 'hu':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("67ObA")));
        case 'it':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("kpo0h")));
        case 'ja':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("dIXkk")));
        case 'ko':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("StmFr")));
        case 'nb':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("8HRam")));
        case 'nl':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("kIvbW")));
        case 'pl':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("kb2WL")));
        case 'pt-BR':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("jJGiG")));
        case 'ro':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("gjtft")));
        case 'ru':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("2O8Ud")));
        case 'sl':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("iupCL")));
        case 'sr-RS':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("8MjEO")));
        case 'sr-YR':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("h7rjs")));
        case 'sr':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("5OzKu")));
        case 'sv':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("8putr")));
        case 'th':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("jC72S")));
        case 'tr':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("8dJob")));
        case 'uk':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("lSGkj")));
        case 'vi':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("2pXqz")));
        case 'zh-CN':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("iLuja")));
        case 'zh-TW':
            return $15c7f109c0b3eaf2$var$importHelper(await (parcelRequire("c8RHS")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($hYdie));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $f65x9 = parcelRequire("f65x9");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2c7c09c977914df0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $2c7c09c977914df0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("1eQXd")));
        case 'da':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("4BuSr")));
        case 'de':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("fYBx8")));
        case 'en-GB':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("dBvjV")));
        case 'en-US':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("d1ASM")));
        case 'en-XA':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("2Gx92")));
        case 'en-XB':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("87OwI")));
        case 'en-ZZ':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("3mt22")));
        case 'en':
            return $2c7c09c977914df0$var$importHelper(await Promise.resolve((parcelRequire("f65x9"))));
        case 'es':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("iT8gj")));
        case 'et':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("a5wxd")));
        case 'fi':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("g2Te9")));
        case 'fr':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("dCauw")));
        case 'hr':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("92iRe")));
        case 'hu':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("37njW")));
        case 'it':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("7clBf")));
        case 'ja':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("aMcgl")));
        case 'ko':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("4OlwQ")));
        case 'nb':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("NAgHO")));
        case 'nl':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("lMTw5")));
        case 'pl':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("Zfmgg")));
        case 'pt-BR':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("2H8xi")));
        case 'ro':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("hu4gj")));
        case 'ru':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("cvaUd")));
        case 'sl':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("iXWdg")));
        case 'sr-RS':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("ccYKF")));
        case 'sr-YR':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("hD3yW")));
        case 'sr':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("5TvTU")));
        case 'sv':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("lqj2a")));
        case 'th':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("lgygW")));
        case 'tr':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("eOamb")));
        case 'uk':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("8sIM1")));
        case 'vi':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("8sxCA")));
        case 'zh-CN':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("5Mtnd")));
        case 'zh-TW':
            return $2c7c09c977914df0$var$importHelper(await (parcelRequire("79Jsn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($f65x9));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6rGkx = parcelRequire("6rGkx");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $05f1fcbef8ad6b50$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $05f1fcbef8ad6b50$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("btONi")));
        case 'da':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("cVlbZ")));
        case 'de':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("kBSwR")));
        case 'en-GB':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("iq2Ha")));
        case 'en-US':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("5Za3J")));
        case 'en-XA':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("7qdcA")));
        case 'en-XB':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("fVPDF")));
        case 'en-ZZ':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("18JTz")));
        case 'en':
            return $05f1fcbef8ad6b50$var$importHelper(await Promise.resolve((parcelRequire("6rGkx"))));
        case 'es':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("dO75E")));
        case 'et':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("6nyeE")));
        case 'fi':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("lyfNH")));
        case 'fr':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("3EeAE")));
        case 'hr':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("hqdIj")));
        case 'hu':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("dW9f5")));
        case 'it':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("9wfQB")));
        case 'ja':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("hRkFc")));
        case 'ko':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("ddJov")));
        case 'nb':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("jigr4")));
        case 'nl':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("54TR9")));
        case 'pl':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("ecgqg")));
        case 'pt-BR':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("kNY9t")));
        case 'ro':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("6R1Tz")));
        case 'ru':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("1OM09")));
        case 'sl':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("2VfZD")));
        case 'sr-RS':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("bzCDp")));
        case 'sr-YR':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("aMyR0")));
        case 'sr':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("7AUrQ")));
        case 'sv':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("2PyPc")));
        case 'th':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("YyzdC")));
        case 'tr':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("iURxI")));
        case 'uk':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("hTDKi")));
        case 'vi':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("a1UKY")));
        case 'zh-CN':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("i0vtB")));
        case 'zh-TW':
            return $05f1fcbef8ad6b50$var$importHelper(await (parcelRequire("6xqzX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6rGkx));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kKV5X = parcelRequire("kKV5X");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b27778c6df0a1ea3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b27778c6df0a1ea3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("1NYRC")));
        case 'da':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("dYrYA")));
        case 'de':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("kEZZO")));
        case 'en-GB':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("if7BP")));
        case 'en-US':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("gkAL1")));
        case 'en-XA':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("galxv")));
        case 'en-XB':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("1KbcF")));
        case 'en-ZZ':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("5R3U2")));
        case 'en':
            return $b27778c6df0a1ea3$var$importHelper(await Promise.resolve((parcelRequire("kKV5X"))));
        case 'es':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("gbJYL")));
        case 'et':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("cdHiZ")));
        case 'fi':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("ULOdL")));
        case 'fr':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("iJaMK")));
        case 'hr':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("2Tui6")));
        case 'hu':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("dCK44")));
        case 'it':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("1aPXW")));
        case 'ja':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("bs5bi")));
        case 'ko':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("f9TiZ")));
        case 'nb':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("cS71P")));
        case 'nl':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("bHpBu")));
        case 'pl':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("gc3W0")));
        case 'pt-BR':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("cW099")));
        case 'ro':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("1iQtT")));
        case 'ru':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("dQkcb")));
        case 'sl':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("eCQlI")));
        case 'sr-RS':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("8erZp")));
        case 'sr-YR':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("4nl4V")));
        case 'sr':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("abr61")));
        case 'sv':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("aJo6X")));
        case 'th':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("gqVEY")));
        case 'tr':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("85Yqg")));
        case 'uk':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("3AeHJ")));
        case 'vi':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("55eKA")));
        case 'zh-CN':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("1iVmS")));
        case 'zh-TW':
            return $b27778c6df0a1ea3$var$importHelper(await (parcelRequire("ed1DR")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kKV5X));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8eaIp = parcelRequire("8eaIp");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e7828c42cee8f105$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e7828c42cee8f105$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("8soQH")));
        case 'da':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("AcmB1")));
        case 'de':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("eBZC4")));
        case 'en-GB':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("aQguK")));
        case 'en-US':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("34B0a")));
        case 'en-XA':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("cxnmS")));
        case 'en-XB':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("4EYTl")));
        case 'en-ZZ':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("bJtGs")));
        case 'en':
            return $e7828c42cee8f105$var$importHelper(await Promise.resolve((parcelRequire("8eaIp"))));
        case 'es':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("j11u3")));
        case 'et':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("4Iu9a")));
        case 'fi':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("2Nl1L")));
        case 'fr':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("iFn6p")));
        case 'hr':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("b3s7K")));
        case 'hu':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("1TvLV")));
        case 'it':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("f2hYx")));
        case 'ja':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("4CBdR")));
        case 'ko':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("1RKr2")));
        case 'nb':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("bhjSn")));
        case 'nl':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("9bBvZ")));
        case 'pl':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("lHU96")));
        case 'pt-BR':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("7uvFj")));
        case 'ro':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("845sW")));
        case 'ru':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("gu9bW")));
        case 'sl':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("2jE4Q")));
        case 'sr-RS':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("fXcft")));
        case 'sr-YR':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("iQ2Vw")));
        case 'sr':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("gtYuO")));
        case 'sv':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("asYPk")));
        case 'th':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("3jL6F")));
        case 'tr':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("dt5Ek")));
        case 'uk':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("8CrAA")));
        case 'vi':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("5Xak2")));
        case 'zh-CN':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("2x03E")));
        case 'zh-TW':
            return $e7828c42cee8f105$var$importHelper(await (parcelRequire("4a5zq")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8eaIp));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8Wdqe = parcelRequire("8Wdqe");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9b7fe572d491aa75$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $9b7fe572d491aa75$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("9VKWU")));
        case 'da':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("eEiCw")));
        case 'de':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("9JB41")));
        case 'en-GB':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("hV07a")));
        case 'en-US':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("gDq2e")));
        case 'en-XA':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("6bPds")));
        case 'en-XB':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("ecgTI")));
        case 'en-ZZ':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("6o8ua")));
        case 'en':
            return $9b7fe572d491aa75$var$importHelper(await Promise.resolve((parcelRequire("8Wdqe"))));
        case 'es':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("9QeTC")));
        case 'et':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("8bUPH")));
        case 'fi':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("jydp9")));
        case 'fr':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("iloKM")));
        case 'hr':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("dfyFv")));
        case 'hu':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("kENzV")));
        case 'it':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("6eell")));
        case 'ja':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("1YD3M")));
        case 'ko':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("4kGYK")));
        case 'nb':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("4Hq5s")));
        case 'nl':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("6Fddj")));
        case 'pl':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("6BShP")));
        case 'pt-BR':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("67yyE")));
        case 'ro':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("El8YA")));
        case 'ru':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("eYNBw")));
        case 'sl':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("dEblD")));
        case 'sr-RS':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("jh6sZ")));
        case 'sr-YR':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("eAgqe")));
        case 'sr':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("7LJh0")));
        case 'sv':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("aqwUD")));
        case 'th':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("2JiTe")));
        case 'tr':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("4gyuP")));
        case 'uk':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("2cyZP")));
        case 'vi':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("hhfGW")));
        case 'zh-CN':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("gvgJi")));
        case 'zh-TW':
            return $9b7fe572d491aa75$var$importHelper(await (parcelRequire("btEIp")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8Wdqe));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6Ey85 = parcelRequire("6Ey85");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1b8402c44ebac4e9$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $1b8402c44ebac4e9$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("ls6Zj")));
        case 'da':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("15mZm")));
        case 'de':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("doZ7S")));
        case 'en-GB':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("diQmT")));
        case 'en-US':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("7hpmi")));
        case 'en-XA':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("8Fw4S")));
        case 'en-XB':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("l1He6")));
        case 'en-ZZ':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("ilTZL")));
        case 'en':
            return $1b8402c44ebac4e9$var$importHelper(await Promise.resolve((parcelRequire("6Ey85"))));
        case 'es':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("3BLr5")));
        case 'et':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("cAkqT")));
        case 'fi':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("2pYQB")));
        case 'fr':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("hQ4xx")));
        case 'hr':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("1gNZX")));
        case 'hu':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("54YVY")));
        case 'it':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("9IWwn")));
        case 'ja':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("5MqOz")));
        case 'ko':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("6O41U")));
        case 'nb':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("dMSCA")));
        case 'nl':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("w1ZQX")));
        case 'pl':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("47Edk")));
        case 'pt-BR':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("i7S8e")));
        case 'ro':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("eM3rX")));
        case 'ru':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("gsuf5")));
        case 'sl':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("3GLTX")));
        case 'sr-RS':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("ghIyH")));
        case 'sr-YR':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("kTdQD")));
        case 'sr':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("ao0pU")));
        case 'sv':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("d5zS6")));
        case 'th':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("kU9Bh")));
        case 'tr':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("6gc2r")));
        case 'uk':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("6q3fz")));
        case 'vi':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("l9eWx")));
        case 'zh-CN':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("5qgOk")));
        case 'zh-TW':
            return $1b8402c44ebac4e9$var$importHelper(await (parcelRequire("37UgO")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6Ey85));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $3d9WN = parcelRequire("3d9WN");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fb234b00f2071fa3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $fb234b00f2071fa3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("45b9z")));
        case 'da':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("1sDYK")));
        case 'de':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("4CsHf")));
        case 'en-GB':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("4wTm9")));
        case 'en-US':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("4h72G")));
        case 'en-XA':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("5ohrQ")));
        case 'en-XB':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("dzxc3")));
        case 'en-ZZ':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("j7JQa")));
        case 'en':
            return $fb234b00f2071fa3$var$importHelper(await Promise.resolve((parcelRequire("3d9WN"))));
        case 'es':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("jGcku")));
        case 'et':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("bIsWt")));
        case 'fi':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("alyXB")));
        case 'fr':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("hoxc6")));
        case 'hr':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("b4qlQ")));
        case 'hu':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("1Uurj")));
        case 'it':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("6BUtM")));
        case 'ja':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("cYXx7")));
        case 'ko':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("idcgG")));
        case 'nb':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("59inb")));
        case 'nl':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("4m2Sb")));
        case 'pl':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("5MoII")));
        case 'pt-BR':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("8zydd")));
        case 'ro':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("5H4eB")));
        case 'ru':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("3vPJc")));
        case 'sl':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("gA2xU")));
        case 'sr-RS':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("60Lwd")));
        case 'sr-YR':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("aNHSu")));
        case 'sr':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("fpzDy")));
        case 'sv':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("6SAbG")));
        case 'th':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("hDKnD")));
        case 'tr':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("dblAN")));
        case 'uk':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("3gjtx")));
        case 'vi':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("9mwGO")));
        case 'zh-CN':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("8x59G")));
        case 'zh-TW':
            return $fb234b00f2071fa3$var$importHelper(await (parcelRequire("bzFQm")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($3d9WN));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6bHt8 = parcelRequire("6bHt8");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1dd2388c58dddd9d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $1dd2388c58dddd9d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("jIdVZ")));
        case 'da':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("4xhSQ")));
        case 'de':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("7EwnF")));
        case 'en-GB':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("k3E0o")));
        case 'en-US':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("80RZJ")));
        case 'en-XA':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("8CsTa")));
        case 'en-XB':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("loIZs")));
        case 'en-ZZ':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("hJhrs")));
        case 'en':
            return $1dd2388c58dddd9d$var$importHelper(await Promise.resolve((parcelRequire("6bHt8"))));
        case 'es':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("ePqOe")));
        case 'et':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("jINk5")));
        case 'fi':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("gqpBw")));
        case 'fr':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("1roHb")));
        case 'hr':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("fGIZ4")));
        case 'hu':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("jIMau")));
        case 'it':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("lzQvT")));
        case 'ja':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("3K32N")));
        case 'ko':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("cWXqX")));
        case 'nb':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("4FH7p")));
        case 'nl':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("aeVv6")));
        case 'pl':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("2UrBG")));
        case 'pt-BR':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("aOw3v")));
        case 'ro':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("1vAxq")));
        case 'ru':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("hiGCK")));
        case 'sl':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("kLaPk")));
        case 'sr-RS':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("iJtWO")));
        case 'sr-YR':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("l7gVc")));
        case 'sr':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("jxN0u")));
        case 'sv':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("g691M")));
        case 'th':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("kixZ4")));
        case 'tr':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("LQLNC")));
        case 'uk':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("1yVN1")));
        case 'vi':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("at24j")));
        case 'zh-CN':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("96qjp")));
        case 'zh-TW':
            return $1dd2388c58dddd9d$var$importHelper(await (parcelRequire("6YqLJ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6bHt8));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $7vWY6 = parcelRequire("7vWY6");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d0db132fe41bb31f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $d0db132fe41bb31f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("1LpSr")));
        case 'da':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("bvrkp")));
        case 'de':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("02Yd6")));
        case 'en-GB':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("dLK1A")));
        case 'en-US':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("4SLw9")));
        case 'en-XA':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("1VVmJ")));
        case 'en-XB':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("goMeW")));
        case 'en-ZZ':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("9dyCN")));
        case 'en':
            return $d0db132fe41bb31f$var$importHelper(await Promise.resolve((parcelRequire("7vWY6"))));
        case 'es':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("cTzry")));
        case 'et':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("dIoHy")));
        case 'fi':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("3RJ21")));
        case 'fr':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("9sHg7")));
        case 'hr':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("7tSBx")));
        case 'hu':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("40C0A")));
        case 'it':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("8ixib")));
        case 'ja':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("1JuBT")));
        case 'ko':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("3dZ9f")));
        case 'nb':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("lGNLQ")));
        case 'nl':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("dqfCk")));
        case 'pl':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("ck4nk")));
        case 'pt-BR':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("cw5Ee")));
        case 'ro':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("c6T8f")));
        case 'ru':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("gREVX")));
        case 'sl':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("a3qnR")));
        case 'sr-RS':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("30FqW")));
        case 'sr-YR':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("gxTOv")));
        case 'sr':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("PV8Yp")));
        case 'sv':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("87P91")));
        case 'th':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("dlQX1")));
        case 'tr':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("hfAFd")));
        case 'uk':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("bj4ZW")));
        case 'vi':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("9FUEQ")));
        case 'zh-CN':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("5cNzU")));
        case 'zh-TW':
            return $d0db132fe41bb31f$var$importHelper(await (parcelRequire("kL4GF")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($7vWY6));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5j4Cn = parcelRequire("5j4Cn");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8b18328e6473975e$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8b18328e6473975e$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("dBqKf")));
        case 'da':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("3Qq1K")));
        case 'de':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("dV1W3")));
        case 'en-GB':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("90jP0")));
        case 'en-US':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("iC5L5")));
        case 'en-XA':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("hsrB8")));
        case 'en-XB':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("iJkX5")));
        case 'en-ZZ':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("dcLFo")));
        case 'en':
            return $8b18328e6473975e$var$importHelper(await Promise.resolve((parcelRequire("5j4Cn"))));
        case 'es':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("9l0bw")));
        case 'et':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("ilvnY")));
        case 'fi':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("jCs0C")));
        case 'fr':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("5SsPO")));
        case 'hr':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("d9xvN")));
        case 'hu':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("frfnt")));
        case 'it':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("inUxe")));
        case 'ja':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("flQhK")));
        case 'ko':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("1OMhC")));
        case 'nb':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("81qiI")));
        case 'nl':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("3BqL6")));
        case 'pl':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("jGcQ3")));
        case 'pt-BR':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("1uDtI")));
        case 'ro':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("lduSs")));
        case 'ru':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("7rL6x")));
        case 'sl':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("13N5z")));
        case 'sr-RS':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("6p4u1")));
        case 'sr-YR':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("hmV0j")));
        case 'sr':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("82CEB")));
        case 'sv':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("cqbvt")));
        case 'th':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("4OMwv")));
        case 'tr':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("aTMcN")));
        case 'uk':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("cSl8T")));
        case 'vi':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("grGrh")));
        case 'zh-CN':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("4fT85")));
        case 'zh-TW':
            return $8b18328e6473975e$var$importHelper(await (parcelRequire("hsL5e")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5j4Cn));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8nApX = parcelRequire("8nApX");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb8ac3a3a164780d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $bb8ac3a3a164780d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("dkP8f")));
        case 'da':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("9K0ut")));
        case 'de':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("erGSk")));
        case 'en-GB':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("xzGgN")));
        case 'en-US':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("afhQo")));
        case 'en-XA':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("418JS")));
        case 'en-XB':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("2bn0B")));
        case 'en-ZZ':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("4bOOa")));
        case 'en':
            return $bb8ac3a3a164780d$var$importHelper(await Promise.resolve((parcelRequire("8nApX"))));
        case 'es':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("euHFi")));
        case 'et':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("9FYQQ")));
        case 'fi':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("9PYIr")));
        case 'fr':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("aOs9j")));
        case 'hr':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("apYGp")));
        case 'hu':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("bQEQ9")));
        case 'it':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("9gMNA")));
        case 'ja':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("bUcVf")));
        case 'ko':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("bE0oF")));
        case 'nb':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("dcBMI")));
        case 'nl':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("eayvQ")));
        case 'pl':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("ktNCp")));
        case 'pt-BR':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("iF5CO")));
        case 'ro':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("7ynNQ")));
        case 'ru':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("cRdXf")));
        case 'sl':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("431S1")));
        case 'sr-RS':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("cLOXU")));
        case 'sr-YR':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("9k4WX")));
        case 'sr':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("kuR5A")));
        case 'sv':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("8mOnM")));
        case 'th':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("aSGVv")));
        case 'tr':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("akt5W")));
        case 'uk':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("6Mt5i")));
        case 'vi':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("fSpz2")));
        case 'zh-CN':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("10c2u")));
        case 'zh-TW':
            return $bb8ac3a3a164780d$var$importHelper(await (parcelRequire("fzjVn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8nApX));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kHXyL = parcelRequire("kHXyL");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9580f92347c74f32$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $9580f92347c74f32$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("1d7Xm")));
        case 'da':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("fhIlA")));
        case 'de':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("97nLs")));
        case 'en-GB':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("hnGKA")));
        case 'en-US':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("3Lnvg")));
        case 'en-XA':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("2uM3C")));
        case 'en-XB':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("8yElw")));
        case 'en-ZZ':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("auCC2")));
        case 'en':
            return $9580f92347c74f32$var$importHelper(await Promise.resolve((parcelRequire("kHXyL"))));
        case 'es':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("3WFy2")));
        case 'et':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("4vHmF")));
        case 'fi':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("lYcKE")));
        case 'fr':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("9G9oT")));
        case 'hr':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("8iP56")));
        case 'hu':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("iDdYL")));
        case 'it':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("7sVxF")));
        case 'ja':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("1NRP3")));
        case 'ko':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("eSyFb")));
        case 'nb':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("jiKDf")));
        case 'nl':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("lOf4U")));
        case 'pl':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("14cLa")));
        case 'pt-BR':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("7gvhr")));
        case 'ro':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("isYx2")));
        case 'ru':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("2ivap")));
        case 'sl':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("bspFP")));
        case 'sr-RS':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("iT7Bj")));
        case 'sr-YR':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("1ufvN")));
        case 'sr':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("gummO")));
        case 'sv':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("4kqhJ")));
        case 'th':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("gip1e")));
        case 'tr':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("lRss2")));
        case 'uk':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("kSxqn")));
        case 'vi':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("452Wi")));
        case 'zh-CN':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("jJkiB")));
        case 'zh-TW':
            return $9580f92347c74f32$var$importHelper(await (parcelRequire("fVcfA")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kHXyL));
    }
};



var $3nDO6 = parcelRequire("3nDO6");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6e6y3 = parcelRequire("6e6y3");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a9c1e78a592d7dad$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a9c1e78a592d7dad$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("idRZz")));
        case 'da':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("7d8jN")));
        case 'de':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("eJosu")));
        case 'en-GB':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("fSR9p")));
        case 'en-US':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("2aOul")));
        case 'en-XA':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("8KWRB")));
        case 'en-XB':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("aD6lN")));
        case 'en-ZZ':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("ht1nW")));
        case 'en':
            return $a9c1e78a592d7dad$var$importHelper(await Promise.resolve((parcelRequire("6e6y3"))));
        case 'es':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("6TdpN")));
        case 'et':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("3dPbj")));
        case 'fi':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("bNrrT")));
        case 'fr':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("fzWvN")));
        case 'hr':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("k9LUw")));
        case 'hu':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("7NEGR")));
        case 'it':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("fHFaz")));
        case 'ja':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("lB4Ue")));
        case 'ko':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("hcpTt")));
        case 'nb':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("lLSQO")));
        case 'nl':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("04L3J")));
        case 'pl':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("7Gmd2")));
        case 'pt-BR':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("eCPZn")));
        case 'ro':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("2siS3")));
        case 'ru':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("jYxQj")));
        case 'sl':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("i2pRS")));
        case 'sr-RS':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("6851R")));
        case 'sr-YR':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("79owM")));
        case 'sr':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("fOIhl")));
        case 'sv':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("dgcZd")));
        case 'th':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("hR3zt")));
        case 'tr':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("kHeB2")));
        case 'uk':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("jX25P")));
        case 'vi':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("inesZ")));
        case 'zh-CN':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("4hAqw")));
        case 'zh-TW':
            return $a9c1e78a592d7dad$var$importHelper(await (parcelRequire("62O4L")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6e6y3));
    }
};



var $kdvUL = parcelRequire("kdvUL");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $etB1f = parcelRequire("etB1f");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $caca9f1b5b96d72a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $caca9f1b5b96d72a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("5LldV")));
        case 'da':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("bfGP4")));
        case 'de':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("jGodn")));
        case 'en-GB':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("l2Upn")));
        case 'en-US':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("2VfwF")));
        case 'en-XA':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("eLOF2")));
        case 'en-XB':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("ipE39")));
        case 'en-ZZ':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("F2Hw0")));
        case 'en':
            return $caca9f1b5b96d72a$var$importHelper(await Promise.resolve((parcelRequire("etB1f"))));
        case 'es':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("b6ZoS")));
        case 'et':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("hWHhW")));
        case 'fi':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("jWBzC")));
        case 'fr':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("lloRn")));
        case 'hr':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("7lhoK")));
        case 'hu':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("fTfQH")));
        case 'it':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("3CPUN")));
        case 'ja':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("8Z1zR")));
        case 'ko':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("gMfEV")));
        case 'nb':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("01pCV")));
        case 'nl':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("bOKuE")));
        case 'pl':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("5S7fV")));
        case 'pt-BR':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("aWR85")));
        case 'ro':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("gbdXE")));
        case 'ru':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("fRIvY")));
        case 'sl':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("4O2NT")));
        case 'sr-RS':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("6NgG6")));
        case 'sr-YR':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("6GSTs")));
        case 'sr':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("jTf4w")));
        case 'sv':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("ia0mz")));
        case 'th':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("HzhjT")));
        case 'tr':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("jzLQb")));
        case 'uk':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("j8CoH")));
        case 'vi':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("4UqBV")));
        case 'zh-CN':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("fMWzH")));
        case 'zh-TW':
            return $caca9f1b5b96d72a$var$importHelper(await (parcelRequire("4rXW5")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($etB1f));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $l7nJS = parcelRequire("l7nJS");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9d7691261b962abe$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $9d7691261b962abe$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("7F3wY")));
        case 'da':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("5ThXX")));
        case 'de':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("ifLF0")));
        case 'en-GB':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("hQpPC")));
        case 'en-US':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("grX31")));
        case 'en-XA':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("56m6k")));
        case 'en-XB':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("j2jty")));
        case 'en-ZZ':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("aUTQd")));
        case 'en':
            return $9d7691261b962abe$var$importHelper(await Promise.resolve((parcelRequire("l7nJS"))));
        case 'es':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("2lc7b")));
        case 'et':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("9De0h")));
        case 'fi':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("dPQCn")));
        case 'fr':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("a3wwm")));
        case 'hr':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("N8n34")));
        case 'hu':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("f73Ab")));
        case 'it':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("d1TD1")));
        case 'ja':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("hqk7Y")));
        case 'ko':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("6JSr6")));
        case 'nb':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("PTBOV")));
        case 'nl':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("BDhK6")));
        case 'pl':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("az4lL")));
        case 'pt-BR':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("kjp2o")));
        case 'ro':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("3G2oA")));
        case 'ru':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("eDz89")));
        case 'sl':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("j0FpS")));
        case 'sr-RS':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("3VhJA")));
        case 'sr-YR':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("gsLZE")));
        case 'sr':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("ebIbe")));
        case 'sv':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("eJp0O")));
        case 'th':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("hXakN")));
        case 'tr':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("dn1vt")));
        case 'uk':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("3kGQX")));
        case 'vi':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("fcA9B")));
        case 'zh-CN':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("ayJEf")));
        case 'zh-TW':
            return $9d7691261b962abe$var$importHelper(await (parcelRequire("eWB3S")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($l7nJS));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kuHXA = parcelRequire("kuHXA");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fd44160c70b7deb3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $fd44160c70b7deb3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("6kkJ4")));
        case 'da':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("duAZa")));
        case 'de':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("1ZERr")));
        case 'en-GB':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("5W4OK")));
        case 'en-US':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("1Xy1X")));
        case 'en-XA':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("36pnH")));
        case 'en-XB':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("9wZAE")));
        case 'en-ZZ':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("aVJvU")));
        case 'en':
            return $fd44160c70b7deb3$var$importHelper(await Promise.resolve((parcelRequire("kuHXA"))));
        case 'es':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("e6Xxe")));
        case 'et':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("hqm7k")));
        case 'fi':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("6cIp2")));
        case 'fr':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("giM71")));
        case 'hr':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("cBYmo")));
        case 'hu':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("aYwnN")));
        case 'it':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("lkaJU")));
        case 'ja':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("56Qpv")));
        case 'ko':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("iBBMG")));
        case 'nb':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("kmCuo")));
        case 'nl':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("hM9fu")));
        case 'pl':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("40CVR")));
        case 'pt-BR':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("gcYDt")));
        case 'ro':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("avcWa")));
        case 'ru':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("jzQPI")));
        case 'sl':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("hrbZ6")));
        case 'sr-RS':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("10Bed")));
        case 'sr-YR':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("9FuFO")));
        case 'sr':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("daLb5")));
        case 'sv':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("gzlIo")));
        case 'th':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("jpRHl")));
        case 'tr':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("eAst9")));
        case 'uk':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("cIr6G")));
        case 'vi':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("1N7Ew")));
        case 'zh-CN':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("5UxGo")));
        case 'zh-TW':
            return $fd44160c70b7deb3$var$importHelper(await (parcelRequire("hMvPE")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kuHXA));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $4ArCP = parcelRequire("4ArCP");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $16e9b25b1441c3c8$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $16e9b25b1441c3c8$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("2PLrc")));
        case 'da':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("5U1ma")));
        case 'de':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("kK4P8")));
        case 'en-GB':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("hoIUd")));
        case 'en-US':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("e2nxm")));
        case 'en-XA':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("1mdVo")));
        case 'en-XB':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("8JFse")));
        case 'en-ZZ':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("eU2Qu")));
        case 'en':
            return $16e9b25b1441c3c8$var$importHelper(await Promise.resolve((parcelRequire("4ArCP"))));
        case 'es':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("d6i2l")));
        case 'et':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("70pqn")));
        case 'fi':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("1Qgy2")));
        case 'fr':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("eczpc")));
        case 'hr':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("4959m")));
        case 'hu':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("9iaw4")));
        case 'it':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("j0x3U")));
        case 'ja':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("9qlD0")));
        case 'ko':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("fdW6i")));
        case 'nb':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("kU4F2")));
        case 'nl':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("2f1JX")));
        case 'pl':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("4xaRW")));
        case 'pt-BR':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("18Vsq")));
        case 'ro':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("h4ZRi")));
        case 'ru':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("5U8NJ")));
        case 'sl':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("4nFVq")));
        case 'sr-RS':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("cuDz2")));
        case 'sr-YR':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("jCQrS")));
        case 'sr':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("4uQwK")));
        case 'sv':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("aWUzU")));
        case 'th':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("I7xZy")));
        case 'tr':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("iKabz")));
        case 'uk':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("bMJBQ")));
        case 'vi':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("29KnO")));
        case 'zh-CN':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("hiOCh")));
        case 'zh-TW':
            return $16e9b25b1441c3c8$var$importHelper(await (parcelRequire("6qUXY")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4ArCP));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $hutRG = parcelRequire("hutRG");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0730a88e59717014$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $0730a88e59717014$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("erlv3")));
        case 'da':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("hyrCI")));
        case 'de':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("lRpEo")));
        case 'en-GB':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("ggw2O")));
        case 'en-US':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("hPTao")));
        case 'en-XA':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("lcBLN")));
        case 'en-XB':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("dBkh6")));
        case 'en-ZZ':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("dFJoB")));
        case 'en':
            return $0730a88e59717014$var$importHelper(await Promise.resolve((parcelRequire("hutRG"))));
        case 'es':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("4Dzz2")));
        case 'et':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("9oSEu")));
        case 'fi':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("2LYdk")));
        case 'fr':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("4BCOh")));
        case 'hr':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("j1vKh")));
        case 'hu':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("6bsbz")));
        case 'it':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("alXGr")));
        case 'ja':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("2zxWZ")));
        case 'ko':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("5ucB7")));
        case 'nb':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("h6Pun")));
        case 'nl':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("9AvLk")));
        case 'pl':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("3ABqE")));
        case 'pt-BR':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("lW5ia")));
        case 'ro':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("biIex")));
        case 'ru':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("4Xmpo")));
        case 'sl':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("8105H")));
        case 'sr-RS':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("6GstT")));
        case 'sr-YR':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("b825f")));
        case 'sr':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("7HCuW")));
        case 'sv':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("9Uxty")));
        case 'th':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("fwEkh")));
        case 'tr':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("4QDVl")));
        case 'uk':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("k26Lv")));
        case 'vi':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("7jx5e")));
        case 'zh-CN':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("c0uLU")));
        case 'zh-TW':
            return $0730a88e59717014$var$importHelper(await (parcelRequire("gqxhP")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($hutRG));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8tFY2 = parcelRequire("8tFY2");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $19f5f4b8c417ee5a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $19f5f4b8c417ee5a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("3nXKv")));
        case 'da':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("leIEI")));
        case 'de':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("1dYwG")));
        case 'en-GB':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("e9ZOX")));
        case 'en-US':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("bEeHl")));
        case 'en-XA':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("aZ8JL")));
        case 'en-XB':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("he4rO")));
        case 'en-ZZ':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("64o15")));
        case 'en':
            return $19f5f4b8c417ee5a$var$importHelper(await Promise.resolve((parcelRequire("8tFY2"))));
        case 'es':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("bO7Bp")));
        case 'et':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("1hanH")));
        case 'fi':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("lumMh")));
        case 'fr':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("7qzx6")));
        case 'hr':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("2oSLc")));
        case 'hu':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("1Opka")));
        case 'it':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("hgOdp")));
        case 'ja':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("557jE")));
        case 'ko':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("iTAbm")));
        case 'nb':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("e2qxW")));
        case 'nl':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("2aaTR")));
        case 'pl':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("ast8h")));
        case 'pt-BR':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("99Xkk")));
        case 'ro':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("aCCUe")));
        case 'ru':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("hSNGq")));
        case 'sl':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("7aGbT")));
        case 'sr-RS':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("2bbS0")));
        case 'sr-YR':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("gBZsU")));
        case 'sr':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("3OW7P")));
        case 'sv':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("lUjFE")));
        case 'th':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("2LYh8")));
        case 'tr':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("mONzw")));
        case 'uk':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("gvgRQ")));
        case 'vi':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("8oRHf")));
        case 'zh-CN':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("hz2Kg")));
        case 'zh-TW':
            return $19f5f4b8c417ee5a$var$importHelper(await (parcelRequire("jN80O")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8tFY2));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $7ppsX = parcelRequire("7ppsX");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $be0684d835eed70a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $be0684d835eed70a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("7gF24")));
        case 'da':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("72nxx")));
        case 'de':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("iF71G")));
        case 'en-GB':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("iE53B")));
        case 'en-US':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("8aWgE")));
        case 'en-XA':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("jLeAR")));
        case 'en-XB':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("lKDeX")));
        case 'en-ZZ':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("izdO1")));
        case 'en':
            return $be0684d835eed70a$var$importHelper(await Promise.resolve((parcelRequire("7ppsX"))));
        case 'es':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("9OmuJ")));
        case 'et':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("364YA")));
        case 'fi':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("6czQz")));
        case 'fr':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("csIQU")));
        case 'hr':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("270mj")));
        case 'hu':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("8jLpN")));
        case 'it':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("eah6n")));
        case 'ja':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("2RSnl")));
        case 'ko':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("dfdvc")));
        case 'nb':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("8W4t8")));
        case 'nl':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("51u8p")));
        case 'pl':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("38ld7")));
        case 'pt-BR':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("bFgv5")));
        case 'ro':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("l8jMH")));
        case 'ru':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("9qE70")));
        case 'sl':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("VOBXZ")));
        case 'sr-RS':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("bxlxO")));
        case 'sr-YR':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("fGImP")));
        case 'sr':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("fzJq9")));
        case 'sv':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("abZe5")));
        case 'th':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("gK0xx")));
        case 'tr':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("5RiXl")));
        case 'uk':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("9x7Pe")));
        case 'vi':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("c4e4Z")));
        case 'zh-CN':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("fpfLj")));
        case 'zh-TW':
            return $be0684d835eed70a$var$importHelper(await (parcelRequire("dW3ES")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($7ppsX));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bPfg5 = parcelRequire("bPfg5");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bf652114658a4c59$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $bf652114658a4c59$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("ezpFa")));
        case 'da':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("6iXcm")));
        case 'de':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("j8hPt")));
        case 'en-GB':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("c6ypt")));
        case 'en-US':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("9A6MN")));
        case 'en-XA':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("kl8Zu")));
        case 'en-XB':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("10ck8")));
        case 'en-ZZ':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("emoOI")));
        case 'en':
            return $bf652114658a4c59$var$importHelper(await Promise.resolve((parcelRequire("bPfg5"))));
        case 'es':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("b029V")));
        case 'et':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("dPDLv")));
        case 'fi':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("bmPng")));
        case 'fr':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("1xaPk")));
        case 'hr':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("h89gC")));
        case 'hu':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("iwOVL")));
        case 'it':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("582EA")));
        case 'ja':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("15jtm")));
        case 'ko':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("1ylzx")));
        case 'nb':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("aVqqC")));
        case 'nl':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("irnoA")));
        case 'pl':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("a703N")));
        case 'pt-BR':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("1Vjjh")));
        case 'ro':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("b7TOB")));
        case 'ru':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("3xF69")));
        case 'sl':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("g7M1d")));
        case 'sr-RS':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("adblt")));
        case 'sr-YR':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("bjieh")));
        case 'sr':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("iIpDn")));
        case 'sv':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("iaV4U")));
        case 'th':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("38VFR")));
        case 'tr':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("6pvxQ")));
        case 'uk':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("6eJ39")));
        case 'vi':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("guWtA")));
        case 'zh-CN':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("amBL2")));
        case 'zh-TW':
            return $bf652114658a4c59$var$importHelper(await (parcelRequire("OtK4y")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bPfg5));
    }
};


const $15113d446a8ed41e$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $ce10a05500133248$export$720676d8cac8fbb)(locale),
        (0, $3775b3243126f7e2$export$720676d8cac8fbb)(locale),
        (0, $49b3f91cccc41e4d$export$720676d8cac8fbb)(locale),
        (0, $82c41f1ec94ebfb9$export$720676d8cac8fbb)(locale),
        (0, $9dd3c1b4511f6644$export$720676d8cac8fbb)(locale),
        (0, $874af0c9f9765348$export$720676d8cac8fbb)(locale),
        (0, $c5b1d60977197279$export$720676d8cac8fbb)(locale),
        (0, $4d103c8ed05eb4fd$export$720676d8cac8fbb)(locale),
        (0, $193ea6a661b759dc$export$720676d8cac8fbb)(locale),
        (0, $96974bb3b0aa91b9$export$720676d8cac8fbb)(locale),
        (0, $c0QiU.messagesLoader)(locale),
        (0, $8SCD0.messagesLoader)(locale),
        (0, $c806437e9ab3c705$export$720676d8cac8fbb)(locale),
        (0, $41aea332c559312c$export$720676d8cac8fbb)(locale),
        (0, $636cec1019919bed$export$720676d8cac8fbb)(locale),
        (0, $4954c74f42031292$export$720676d8cac8fbb)(locale),
        (0, $f1d52e5870ae9a59$export$720676d8cac8fbb)(locale),
        (0, $b1f55b02ab5dd48a$export$720676d8cac8fbb)(locale),
        (0, $1cfeadb092a11e96$export$720676d8cac8fbb)(locale),
        (0, $e84fe42f89af6fb4$export$720676d8cac8fbb)(locale),
        (0, $bce6c13b69697278$export$720676d8cac8fbb)(locale),
        (0, $d75107a999e7d9fe$export$720676d8cac8fbb)(locale),
        (0, $98c214c47f807082$export$720676d8cac8fbb)(locale),
        (0, $2620f3af971c6c10$export$720676d8cac8fbb)(locale),
        (0, $2ef667146b868deb$export$720676d8cac8fbb)(locale),
        (0, $6d7e9baaccc5244a$export$720676d8cac8fbb)(locale),
        (0, $9205e55c2b03abbf$export$720676d8cac8fbb)(locale),
        (0, $97f5f84bf86ebe81$export$720676d8cac8fbb)(locale),
        (0, $94f4a62ece3e9a21$export$720676d8cac8fbb)(locale),
        (0, $15c7f109c0b3eaf2$export$720676d8cac8fbb)(locale),
        (0, $2c7c09c977914df0$export$720676d8cac8fbb)(locale),
        (0, $05f1fcbef8ad6b50$export$720676d8cac8fbb)(locale),
        (0, $b27778c6df0a1ea3$export$720676d8cac8fbb)(locale),
        (0, $e7828c42cee8f105$export$720676d8cac8fbb)(locale),
        (0, $9b7fe572d491aa75$export$720676d8cac8fbb)(locale),
        (0, $1b8402c44ebac4e9$export$720676d8cac8fbb)(locale),
        (0, $fb234b00f2071fa3$export$720676d8cac8fbb)(locale),
        (0, $1dd2388c58dddd9d$export$720676d8cac8fbb)(locale),
        (0, $d0db132fe41bb31f$export$720676d8cac8fbb)(locale),
        (0, $8b18328e6473975e$export$720676d8cac8fbb)(locale),
        (0, $bb8ac3a3a164780d$export$720676d8cac8fbb)(locale),
        (0, $9580f92347c74f32$export$720676d8cac8fbb)(locale),
        (0, $3nDO6.messagesLoader)(locale),
        (0, $a9c1e78a592d7dad$export$720676d8cac8fbb)(locale),
        (0, $kdvUL.messagesLoader)(locale),
        (0, $caca9f1b5b96d72a$export$720676d8cac8fbb)(locale),
        (0, $9d7691261b962abe$export$720676d8cac8fbb)(locale),
        (0, $fd44160c70b7deb3$export$720676d8cac8fbb)(locale),
        (0, $16e9b25b1441c3c8$export$720676d8cac8fbb)(locale),
        (0, $0730a88e59717014$export$720676d8cac8fbb)(locale),
        (0, $19f5f4b8c417ee5a$export$720676d8cac8fbb)(locale),
        (0, $be0684d835eed70a$export$720676d8cac8fbb)(locale),
        (0, $bf652114658a4c59$export$720676d8cac8fbb)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $15113d446a8ed41e$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $jQRRW.withIntlProvider)({
        messagesLoader: $15113d446a8ed41e$export$d5a462ce7bd04520
    }, Component);
};














var $cpPWT = parcelRequire("cpPWT");


var $cyz5M = parcelRequire("cyz5M");


var $6Ht9d = parcelRequire("6Ht9d");


var $j0Fou = parcelRequire("j0Fou");

const $34734b2d588fba6f$export$963cdca6c7580c53 = [
    {
        messageTemplateId: 'confluence-3p-connector-nudge',
        statsigExperiment: 'post-office_3p_user_authentication_nudge',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variation'
        ]
    },
    {
        messageTemplateId: 'confluence-auto-provisioning-edition-parity-trial-dialog',
        // https://switcheroo.atlassian.com/ui/gates/d0ba1046-934a-4af7-8294-e6ca8b846ab3/key/confluence_autoprovisioning_edition_parity
        statsigExperiment: 'confluence_autoprovisioning_edition_parity',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variation'
        ]
    },
    {
        messageTemplateId: 'confluence-ai-audio-player-spotlight-tour',
        // https://switcheroo.atlassian.com/ui/gates/e9b0503b-0486-48e3-a511-123e409058f4/key/confluence_audio_v3_changeboarding
        statsigExperiment: 'confluence_audio_v3_changeboarding',
        statsigParameterName: 'isEnabled',
        statsigTestCohorts: [
            'true'
        ]
    },
    {
        messageTemplateId: 'rovo-growth-nudge-end-user-highly-connected-apps',
        // https://switcheroo.atlassian.com/ui/gates/f36896ce-14dc-4a48-9888-dd0df3c671e0/key/rovo_nudge_end_user_highly_connected_apps_exp
        statsigExperiment: 'rovo_nudge_end_user_highly_connected_apps_exp',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variant1',
            'variant2'
        ]
    },
    {
        messageTemplateId: 'commerce-subscription-auto-upgrade-ccp',
        // https://switcheroo.atlassian.com/ui/gates/3b39fad7-0834-4007-9b28-73367d7231fd/key/auto-upgrades_w_pde_legal_update_ab_test,
        statsigExperiment: 'auto-upgrades_w_pde_legal_update_ab_test',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variation'
        ]
    }
];





const $a7eadc618a11c917$export$86fac4eb228cc5e9 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $a7eadc618a11c917$export$60075266d0d5c9c4 = ()=>(0, $42omo.useContext)($a7eadc618a11c917$export$86fac4eb228cc5e9);










var $7XIdu = parcelRequire("7XIdu");




const $e1aac9cee19c4445$export$32c78d11bbf53e24 = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const handleVisibilityChange = (0, $42omo.useCallback)((modalOnScreen)=>{
        const shouldShow = !modalOnScreen;
        if (!shouldShow) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'suppressed',
            actionSubject: 'screenSpaceFlags'
        });
        setIsVisible(shouldShow);
    }, [
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const modalOnScreen = !!globalThis.document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
        handleVisibilityChange(modalOnScreen);
    }, [
        handleVisibilityChange
    ]);
    return (0, $c6GJD.default).checkGate('post-office-screen-space-flags-modal-detector') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: isVisible && children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 














































































































































const $90021a5e9b56864d$export$e30378e28ad3e6ab = {
    'admin-hub-app-access-settings-access-message-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("hTU1a"))),
    'adminhub-platform-usage-m5-spotlight-tour': (0, $42omo.lazy)(()=>(parcelRequire("bb6sB"))),
    'adminhub-portfolio-insights-nav-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("jf6d3"))),
    'adminhub-rovo-bookmarks-onboarding-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("g0non"))),
    'adminhub-rovo-chat-button-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("900Tl"))),
    'adminhub-rovo-chat-toggle-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("bVJjp"))),
    'adminhub-system-health-dashboard-app-status-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("iQHra"))),
    'adminhub-system-health-dashboard-app-status-spotlight-v2': (0, $42omo.lazy)(()=>(parcelRequire("8U3Nd"))),
    'adminhub-system-health-dashboard-status-hub-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("bTY1R"))),
    'adminhub-theme-darkmode': (0, $42omo.lazy)(()=>(parcelRequire("4fb4L"))),
    'adminhub-unit-create-ga-spotlight-tour': (0, $42omo.lazy)(()=>(parcelRequire("f9guR"))),
    'adminhub-urm-rank-ra-using-ml-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("lQwjw"))),
    'adminhub-user-requests-count-message-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("5U9Yl"))),
    'assets-deeplinking-modal': (0, $42omo.lazy)(()=>(parcelRequire("gXIev"))),
    'cases': (0, $42omo.lazy)(()=>(parcelRequire("gwAtY"))),
    'cases-request-types-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("5BuKr"))),
    'cc-changeboarding-block-menu-primary': (0, $42omo.lazy)(()=>(parcelRequire("eauZQ"))),
    'cc-changeboarding-block-menu-primary-new': (0, $42omo.lazy)(()=>(parcelRequire("8XR9v"))),
    'cc-changeboarding-block-menu-templates': (0, $42omo.lazy)(()=>(parcelRequire("bslzO"))),
    'cc-changeboarding-block-menu-transform': (0, $42omo.lazy)(()=>(parcelRequire("1d288"))),
    'cc-changeboarding-synced-blocks': (0, $42omo.lazy)(()=>(parcelRequire("96AVN"))),
    'cc-editor-table-cell-menu-changes': (0, $42omo.lazy)(()=>(parcelRequire("2BGsK"))),
    'commerce-subscription-auto-upgrade-ccp': (0, $42omo.lazy)(()=>(parcelRequire("1kO9S"))),
    'commerce-subscription-auto-upgrade-no-payment-method-ccp': (0, $42omo.lazy)(()=>(parcelRequire("b1asB"))),
    'confluence-3p-connector-nudge': (0, $42omo.lazy)(()=>(parcelRequire("brkAz"))),
    'confluence-ai-audio-player-spotlight-tour': (0, $42omo.lazy)(()=>(parcelRequire("9AH4j"))),
    'confluence-auto-provisioning-edition-parity-trial-dialog': (0, $42omo.lazy)(()=>(parcelRequire("d75wG"))),
    'confluence-commented-on-page-nudge': (0, $42omo.lazy)(()=>(parcelRequire("dnOiB"))),
    'confluence-continue-reading-nudge': (0, $42omo.lazy)(()=>(parcelRequire("6JAdj"))),
    'confluence-editor-smart-links-draggable-changeboard': (0, $42omo.lazy)(()=>(parcelRequire("g3tI0"))),
    'confluence-fast-and-snappy-survey': (0, $42omo.lazy)(()=>(parcelRequire("4RySe"))),
    'confluence-founding-admin-connect-tools-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("jSc4X"))),
    'confluence-inline-reactions-mau-nudge': (0, $42omo.lazy)(()=>(parcelRequire("xpCDf"))),
    'confluence-inline-reactions-mcu-nudge': (0, $42omo.lazy)(()=>(parcelRequire("4GwkX"))),
    'confluence-inline-reactions-nudge': (0, $42omo.lazy)(()=>(parcelRequire("5u7cq"))),
    'confluence-lovability-survey': (0, $42omo.lazy)(()=>(parcelRequire("jtUHm"))),
    'confluence-maui-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("at41i"))),
    'confluence-maui-changeboarding-remix-tour': (0, $42omo.lazy)(()=>(parcelRequire("3dm00"))),
    'confluence-maui-slides-create-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("jbib7"))),
    'confluence-maui-slides-edit-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("aW9IB"))),
    'confluence-maui-slides-modal': (0, $42omo.lazy)(()=>(parcelRequire("kdxw4"))),
    'confluence-maui-slides-toolbar-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("9htqv"))),
    'confluence-mentioned-in-comment-nudge': (0, $42omo.lazy)(()=>(parcelRequire("74iQN"))),
    'confluence-mentioned-on-page-nudge': (0, $42omo.lazy)(()=>(parcelRequire("5Ew3s"))),
    'confluence-nudge-for-jira': (0, $42omo.lazy)(()=>(parcelRequire("e3KlB"))),
    'confluence-object-sidebar-remix-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("desqE"))),
    'confluence-ootb-daily-brief-agent-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("Y8oCe"))),
    'cpq-user-feedback': (0, $42omo.lazy)(()=>(parcelRequire("4BuLh"))),
    'edition-benefits-modal': (0, $42omo.lazy)(()=>(parcelRequire("1Thq7"))),
    'encryption-policy-page-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("l9jc8"))),
    'end-of-trial-extension': (0, $42omo.lazy)(()=>(parcelRequire("gg5UE"))),
    'ep-migration-external-messages': (0, $42omo.lazy)(()=>(parcelRequire("goKWQ"))),
    'ep-migration-inapp-1736': (0, $42omo.lazy)(()=>(parcelRequire("65CjO"))),
    'ep-migration-inapp-1737': (0, $42omo.lazy)(()=>(parcelRequire("dDm9g"))),
    'ep-migration-inapp-2055': (0, $42omo.lazy)(()=>(parcelRequire("8E2z4"))),
    'ep-migration-inapp-2271': (0, $42omo.lazy)(()=>(parcelRequire("lyKqX"))),
    'ep-migration-inapp-3273': (0, $42omo.lazy)(()=>(parcelRequire("cMkRx"))),
    'ep-migration-inapp-3280': (0, $42omo.lazy)(()=>(parcelRequire("rjKoE"))),
    'ep-migration-inapp-3282': (0, $42omo.lazy)(()=>(parcelRequire("dFvPJ"))),
    'ep-migration-inapp-715': (0, $42omo.lazy)(()=>(parcelRequire("24wf9"))),
    'ep-migration-jira-ops-team-heartbeats': (0, $42omo.lazy)(()=>(parcelRequire("kgs2Y"))),
    'example-generated-spotlight-template': (0, $42omo.lazy)(()=>(parcelRequire("g4zqA"))),
    'jira-assets-schemas-display-name': (0, $42omo.lazy)(()=>(parcelRequire("dMUgb"))),
    'jira-board-inline-editing-onboarding': (0, $42omo.lazy)(()=>(parcelRequire("03acy"))),
    'jira-business-saved-views-admin-changeboarding-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("4ImLl"))),
    'jira-business-saved-views-user-changeboarding-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("hNYGB"))),
    'jira-filter-refinement': (0, $42omo.lazy)(()=>(parcelRequire("2mRvB"))),
    'jira-filter-refinement-board-and-backlog': (0, $42omo.lazy)(()=>(parcelRequire("a4VVI"))),
    'jira-filter-refinement-standalone-release-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("9YH9O"))),
    'jira-forms-conditional-fields-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("c6gD1"))),
    'jira-forms-public-forms-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("gUPfp"))),
    'jira-forms-public-forms-changeboarding-flag': (0, $42omo.lazy)(()=>(parcelRequire("gH4Ot"))),
    'jira-fps-to-gnin-cta-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("jrYzB"))),
    'jira-glance-panel-navigation-arrows': (0, $42omo.lazy)(()=>(parcelRequire("fAjAo"))),
    'jira-gnin-to-fps-cta-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("1glQs"))),
    'jira-hamonisation-software-timeline': (0, $42omo.lazy)(()=>(parcelRequire("jF00y"))),
    'jira-in-context-config-sidebar-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("kb2TK"))),
    'jira-issueview-description-title-final': (0, $42omo.lazy)(()=>(parcelRequire("74jEK"))),
    'jira-issueview-status': (0, $42omo.lazy)(()=>(parcelRequire("afy8z"))),
    'jira-list-conditional-formatting': (0, $42omo.lazy)(()=>(parcelRequire("2hmq4"))),
    'jira-manual-trial-awareness-modal': (0, $42omo.lazy)(()=>(parcelRequire("1m9L7"))),
    'jira-messaging-research-recruitment': (0, $42omo.lazy)(()=>(parcelRequire("3SMxY"))),
    'jira-onboarding-hub-welcome-modal': (0, $42omo.lazy)(()=>(parcelRequire("eCJ4O"))),
    'jira-ops-group-customisation': (0, $42omo.lazy)(()=>(parcelRequire("5VGt6"))),
    'jira-ops-unified-view-revamp': (0, $42omo.lazy)(()=>(parcelRequire("cGuso"))),
    'jira-plans-efa-change-boarding': (0, $42omo.lazy)(()=>(parcelRequire("fIBDg"))),
    'jira-project-term-refresh-changeboarding-flag': (0, $42omo.lazy)(()=>(parcelRequire("jzkrd"))),
    'jira-quick-find-intent-detection-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("03cg3"))),
    'jira-rovo-dev-survey': (0, $42omo.lazy)(()=>(parcelRequire("784KA"))),
    'jira-rovo-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("6YLik"))),
    'jira-screen-modal': (0, $42omo.lazy)(()=>(parcelRequire("kGns1"))),
    'jira-setup-user-interviews-signup': (0, $42omo.lazy)(()=>(parcelRequire("dPlq7"))),
    'jira-side-nav-mature-example-project-space-setup': (0, $42omo.lazy)(()=>(parcelRequire("dTFwU"))),
    'jira-software-cmp-currency-field-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("ci6eu"))),
    'jira-space-settings-playbooks-navigation-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("hLbyA"))),
    'jira-sprints-auto-managed-feature-discovery': (0, $42omo.lazy)(()=>(parcelRequire("l6eYL"))),
    'jira-timeline-10k-issues-message': (0, $42omo.lazy)(()=>(parcelRequire("aZcJG"))),
    'jira-timeline-feedback-collector-changeboarding': (0, $42omo.lazy)(()=>(parcelRequire("5nybb"))),
    'jira-twcg-810-personalised-rt-upgrade-free-customers': (0, $42omo.lazy)(()=>(parcelRequire("5Ctct"))),
    'jira-work-item-view-native-projects-field': (0, $42omo.lazy)(()=>(parcelRequire("bpSbS"))),
    'jsm-edition-awareness-button-popup': (0, $42omo.lazy)(()=>(parcelRequire("kctk3"))),
    'jsm-project-summary-onboarding': (0, $42omo.lazy)(()=>(parcelRequire("a5SgP"))),
    'marketing-screen-space-flag-contentful-usecase': (0, $42omo.lazy)(()=>(parcelRequire("8KCLJ"))),
    'mercury-edit-hierarchy-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("8jPAy"))),
    'message-template-template': (0, $42omo.lazy)(()=>(parcelRequire("jQsf1"))),
    'navx-smartlink-full-picture-auth-nudge': (0, $42omo.lazy)(()=>(parcelRequire("fjl4m"))),
    'plan-calendar-create-item-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("4hqZj"))),
    'post-office-gold-1': (0, $42omo.lazy)(()=>(parcelRequire("kLxqa"))),
    'project-pages-revamp-onboarding-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("1GI2N"))),
    'ptr-changeboarding-space-navigation-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("hJ8Of"))),
    'rovo-3p-celebrate-nudge': (0, $42omo.lazy)(()=>(parcelRequire("4CxN9"))),
    'rovo-3rd-party-integration-admin-nudge': (0, $42omo.lazy)(()=>(parcelRequire("jGphw"))),
    'rovo-agents-scenario-onboarding': (0, $42omo.lazy)(()=>(parcelRequire("5VKYq"))),
    'rovo-button-onboarding-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("d0tJU"))),
    'rovo-chat-inline-memory-saved-message': (0, $42omo.lazy)(()=>(parcelRequire("15VmW"))),
    'rovo-chat-memory-settings-onboarding-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("kSf38"))),
    'rovo-chat-welcome-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("4ofl9"))),
    'rovo-extension-gdocs-definitions-install-cta-flag': (0, $42omo.lazy)(()=>(parcelRequire("1AIyT"))),
    'rovo-growth-3p-smartlink-admin-paste-nudge': (0, $42omo.lazy)(()=>(parcelRequire("4Udyh"))),
    'rovo-growth-3p-smartlink-paste-nudge': (0, $42omo.lazy)(()=>(parcelRequire("3MyU8"))),
    'rovo-growth-nudge-end-user-highly-connected-apps': (0, $42omo.lazy)(()=>(parcelRequire("61npX"))),
    'shared-user-preferences-onboarding': (0, $42omo.lazy)(()=>(parcelRequire("8TKKA"))),
    'solcom-create-space-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("3AgQf"))),
    'starburst-screen-space-flags-twc-welcome-modal': (0, $42omo.lazy)(()=>(parcelRequire("ca9BQ"))),
    'statuspage-navigation-spotlight': (0, $42omo.lazy)(()=>(parcelRequire("8nGSq"))),
    'team-wolverine-jira-migration-success': (0, $42omo.lazy)(()=>(parcelRequire("7Gwv2"))),
    'test-message-config-sets': (0, $42omo.lazy)(()=>(parcelRequire("bbxjT"))),
    'test-message-dynamic-config-sets': (0, $42omo.lazy)(()=>(parcelRequire("h2YRW"))),
    'test-message-inapp': (0, $42omo.lazy)(()=>(parcelRequire("eFGJr"))),
    'test-message-inapp-ep-modal': (0, $42omo.lazy)(()=>(parcelRequire("eATWS"))),
    'test-message-inapp-implicit-pendo': (0, $42omo.lazy)(()=>(parcelRequire("fpuJu"))),
    'test-message-tap-ingestion-trigger-subscription': (0, $42omo.lazy)(()=>(parcelRequire("hWIYP"))),
    'test-screen-space-flags-message': (0, $42omo.lazy)(()=>(parcelRequire("9AN3p"))),
    'test-simple-ipm-spotlight-page-load': (0, $42omo.lazy)(()=>(parcelRequire("iENKQ"))),
    'twc-conf-sample-page-tour': (0, $42omo.lazy)(()=>(parcelRequire("7gIM8"))),
    'twc-project-pages-confluence-tour': (0, $42omo.lazy)(()=>(parcelRequire("16is3"))),
    'twc-xflow-modal-v2': (0, $42omo.lazy)(()=>(parcelRequire("7xmBT")))
};
const $90021a5e9b56864d$var$messageRenderer = (0, $cyz5M.asMessageRenderer)($90021a5e9b56864d$export$e30378e28ad3e6ab, 'screen-space-flags');
const $90021a5e9b56864d$export$bce4e5106d86e473 = $90021a5e9b56864d$var$messageRenderer.initializeMessageRenderer;
const $90021a5e9b56864d$export$2df1250b8f917a59 = $90021a5e9b56864d$var$messageRenderer.MessageRenderer;



var $6yHRM = parcelRequire("6yHRM");

const $ba6077e9eb9bab3c$export$e343914da553b968 = ()=>{
    const route = (0, $6yHRM.usePostOfficeRoute)();
    let result = {};
    if (route?.searchParams) result = Object.fromEntries(route.searchParams);
    if (typeof window !== 'undefined' && typeof window.location?.pathname === 'string') result = {
        ...result,
        pathname: window.location.pathname
    };
    return result;
};


const $6d0bf1735457e2b7$export$f6564e60882bdf90 = ({ initialData: initialData, preloadedInitialData: preloadedInitialData, setPreloadedInitialData: setPreloadedInitialData, jiraFlagsService: jiraFlagsService, reportExpectedError: reportExpectedError, reportUnexpectedError: reportUnexpectedError })=>{
    const injectedMessageTemplates = (0, $a7eadc618a11c917$export$60075266d0d5c9c4)();
    // https://switcheroo.atlassian.com/ui/gates/3088e603-a723-449e-a763-b42e9db2a626/key/post-office_enable_ssf_injected_messages
    const isInjectedMessagesEnabled = (0, $c6GJD.default).checkGate('post-office_enable_ssf_injected_messages');
    const injectedMessageRenderer = (0, $42omo.useMemo)(()=>injectedMessageTemplates ? (0, $cyz5M.asMessageRenderer)(injectedMessageTemplates, 'screen-space-flags').MessageRenderer : (0, $90021a5e9b56864d$export$2df1250b8f917a59), [
        injectedMessageTemplates
    ]);
    const MessageRenderer = isInjectedMessagesEnabled ? injectedMessageRenderer : (0, $90021a5e9b56864d$export$2df1250b8f917a59);
    const isEPExternalMessageSSREnabled = (0, $c6GJD.default).checkGate('post-office_enabled_ep_external_message_ssr');
    const [localMessageState, setLocalMessageState] = (0, $42omo.useState)(()=>{
        const messages = preloadedInitialData?.messages?.length ? preloadedInitialData.messages : undefined;
        const triggeredMessages = preloadedInitialData?.triggeredMessages?.length ? preloadedInitialData.triggeredMessages : undefined;
        return {
            messages: messages,
            triggeredMessages: triggeredMessages
        };
    });
    // Dismissals are stored locally to keep the local state relatively immutable,
    // except unless explicitly refreshed from the server.
    const [dismissedMessageInstanceIds, setDismissedMessageInstanceIds] = (0, $42omo.useState)([]);
    const filterByDismissed = (0, $42omo.useCallback)((list)=>list?.filter((msg)=>!dismissedMessageInstanceIds.includes(msg.messageInstanceId)), [
        dismissedMessageInstanceIds
    ]);
    // Filter the messages at runtime to ensure they are always accurate and
    // so we don't need to manage the dismissed messages in the state.
    const { filteredMessages: filteredMessages, filteredTriggeredMessages: filteredTriggeredMessages } = (0, $42omo.useMemo)(()=>({
            filteredMessages: filterByDismissed(localMessageState.messages),
            filteredTriggeredMessages: filterByDismissed(localMessageState.triggeredMessages)
        }), [
        localMessageState.messages,
        localMessageState.triggeredMessages,
        filterByDismissed
    ]);
    (0, $6Ht9d.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $cpPWT.useMessagePlacementHooks)();
    const handleDismiss = (0, $42omo.useCallback)(({ messageInstanceId: messageInstanceId })=>{
        if (messageInstanceId) // dismiss the current message instance
        setDismissedMessageInstanceIds((current)=>[
                ...current,
                messageInstanceId
            ]);
        else // eslint-disable-next-line no-console
        console.error(`A valid messageInstanceId is required to dismiss a message: ${messageInstanceId}`);
    }, []);
    const onDismissed = (0, $42omo.useCallback)((messageInstanceId)=>{
        handleDismiss({
            messageInstanceId: messageInstanceId
        });
    }, [
        handleDismiss
    ]);
    (0, $42omo.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $42omo.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $42omo.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    (0, $42omo.useEffect)(()=>{
        // update the preloaded initial data with the accurate filtered messages
        if (typeof setPreloadedInitialData === 'function') {
            if (isEPExternalMessageSSREnabled) setPreloadedInitialData({
                messages: filteredMessages ?? [],
                triggeredMessages: filteredTriggeredMessages ?? []
            });
            else setPreloadedInitialData({
                messages: filteredMessages ?? [],
                triggeredMessages: filteredTriggeredMessages ?? []
            });
        }
    }, [
        filteredMessages,
        filteredTriggeredMessages,
        isEPExternalMessageSSREnabled,
        setPreloadedInitialData
    ]);
    const activeScopes = (0, $eI9QI.usePostOfficeContextScope)({
        scopes: $6dedf2638d31103b$export$54a06e3f4a159ad8,
        treatIntersectionAsSame: true
    });
    const searchParams = (0, $ba6077e9eb9bab3c$export$e343914da553b968)();
    const messagesState = (0, $j0Fou.usePlacementApi)('/update-messages', {
        queryParams: {
            ...searchParams,
            updateKey: activeScopes.updateKey ?? ''
        },
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: (0, $c6GJD.default).checkGate('post-office-ssf-enable-continuous-auto-refetch') ? !!activeScopes.updateKey && !filteredMessages?.length : !!activeScopes.updateKey && typeof filteredMessages === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $42omo.useEffect)(()=>{
        const data = messagesState?.data;
        if (!data) return;
        setLocalMessageState((prev)=>{
            const messages = data.messages ?? [];
            let selectedMessages = [];
            if (messages.length > 0) {
                let selectedMessage;
                // New experiments in the screen-space-flags placement must be added to the EXPERIMENTAL_MESSAGES list
                for (const message of messages){
                    const experimentalMessage = (0, $34734b2d588fba6f$export$963cdca6c7580c53).find((p)=>p.messageTemplateId === message.messageTemplateId);
                    if (experimentalMessage) {
                        const cohort = (0, $c6GJD.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                            fireExperimentExposure: true
                        });
                        if (experimentalMessage?.statsigAAExperiment) (0, $c6GJD.default).getExperimentValue(experimentalMessage.statsigAAExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                            fireExperimentExposure: true
                        });
                        if (experimentalMessage.statsigTestCohorts.includes(cohort)) {
                            selectedMessage = message;
                            break;
                        }
                    } else {
                        selectedMessage = message;
                        break;
                    }
                }
                selectedMessages = selectedMessage ? [
                    selectedMessage
                ] : [];
            }
            const triggeredMessages = data.triggeredMessages ?? [];
            return {
                ...prev,
                messages: selectedMessages,
                triggeredMessages: triggeredMessages
            };
        });
    }, [
        messagesState.data
    ]);
    const messageToRender = filteredMessages?.[0];
    const content = (0, $c6GJD.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $e1aac9cee19c4445$export$32c78d11bbf53e24), {
        children: [
            messageToRender ? /*#__PURE__*/ (0, $42omo.createElement)(MessageRenderer, {
                ...messageToRender,
                key: messageToRender.messageInstanceId,
                id: messageToRender.messageInstanceId,
                messageInstanceId: messageToRender.messageInstanceId,
                onDismissed: onDismissed,
                SuspenseBoundary: (0, $cyz5M.MaybeSuspenseBoundary),
                jiraFlagsService: jiraFlagsService,
                onError: reportUnexpectedError,
                reportExpectedError: reportExpectedError
            }) : null,
            filteredTriggeredMessages?.map((msg)=>/*#__PURE__*/ (0, $42omo.createElement)(MessageRenderer, {
                    ...msg,
                    key: msg.messageInstanceId,
                    id: msg.messageInstanceId,
                    messageInstanceId: msg.messageInstanceId,
                    onDismissed: onDismissed,
                    SuspenseBoundary: (0, $cyz5M.MaybeSuspenseBoundary),
                    jiraFlagsService: jiraFlagsService,
                    onError: reportUnexpectedError,
                    reportExpectedError: reportExpectedError
                }))
        ]
    }) : null;
    return content;
};


const $0381e4ebc4c9b908$export$c32237a999261c49 = (input)=>(0, $eI9QI.createMatchScopes)({
        scopes: $6dedf2638d31103b$export$54a06e3f4a159ad8
    })(input);
const $0381e4ebc4c9b908$export$c60b43809441c5b0 = (0, $15113d446a8ed41e$export$b0eee5de066b2bf5)((0, $2mPpz.createPlacementComponent)((0, $23990983e3348fe0$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6d0bf1735457e2b7$export$f6564e60882bdf90), {
        ...props
    });
}), {
    choreographer: {
        isDefaultEnabled: true // this is the default value, but leaving it as explicitly defined
    }
}));
var $0381e4ebc4c9b908$export$2e2bcd8739ae039 = $0381e4ebc4c9b908$export$c60b43809441c5b0;



var $5vi32 = parcelRequire("5vi32");


var $9QvUi = parcelRequire("9QvUi");











var $kO3gu = parcelRequire("kO3gu");

const $47d6b670e406d296$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
const $47d6b670e406d296$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
const $47d6b670e406d296$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
    const fetch = (0, $42omo.useMemo)(()=>{
        if (returnOverride) return $47d6b670e406d296$export$fb5156757134712c({
            returnOverride: returnOverride
        });
        return $47d6b670e406d296$export$c05392ff95b4319d({
            eligibleMessages: eligibleMessages
        });
    }, [
        eligibleMessages,
        returnOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO3gu.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
const $47d6b670e406d296$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
        return new Response(JSON.stringify(returnOverride), {
            status: 200,
            statusText: 'ok'
        });
    };
const $47d6b670e406d296$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
        const finalUrl = url.replace($47d6b670e406d296$export$e5ffd38dcf6e5c53, $47d6b670e406d296$export$85c4756977e87c75);
        const payload = {
            originalMethod: options?.method || 'GET',
            originalBody: $47d6b670e406d296$var$parseBody(options?.body),
            eligibleMessages: eligibleMessages
        };
        return globalThis.fetch(finalUrl, {
            ...options,
            method: 'POST',
            headers: {
                ...options?.headers || {}
            },
            body: $47d6b670e406d296$var$stringifyPayload(payload)
        });
    };
const $47d6b670e406d296$var$objectHasKeys = (input)=>!!Object.keys(input).length;
const $47d6b670e406d296$var$parseBody = (body)=>{
    if (typeof body === 'undefined' || body === null) return undefined;
    try {
        const parsedBody = JSON.parse(body);
        if ($47d6b670e406d296$var$objectHasKeys(parsedBody)) return parsedBody;
        throw new Error();
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};
const $47d6b670e406d296$var$stringifyPayload = (payload)=>{
    try {
        return JSON.stringify(payload);
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};


const $29f905239c235f73$export$52e362b70e115c68 = (0, $47d6b670e406d296$export$52e362b70e115c68);
const $29f905239c235f73$export$c05392ff95b4319d = (0, $47d6b670e406d296$export$c05392ff95b4319d);




var $lAJUP = parcelRequire("lAJUP");




const $95ecb474353a02ba$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride, disableInitialData: disableInitialData })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: errorFallback,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $29f905239c235f73$export$52e362b70e115c68), {
            eligibleMessages: eligibleMessages,
            returnOverride: returnOverride,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9QvUi.default), {
                PlacementComponent: PlacementComponent,
                placementId: placementId,
                disableInitialData: disableInitialData
            })
        })
    });
const $95ecb474353a02ba$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
    const { searchParams: searchParams } = (0, $6yHRM.usePostOfficeRoute)();
    const previewId = searchParams?.get('contentfulPreviewId');
    const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
    const localeForPreview = searchParams?.get('locale');
    const eligibleMessage = [
        {
            messageInstanceId: 'messageInstanceId',
            messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
            messageCategory: 'Engagement',
            context: {
                id: previewId,
                localeForPreview: localeForPreview
            },
            createdAt: new Date().toString(),
            eventTime: new Date().toString(),
            triggerId: 'triggerId',
            messageCreationType: 'explicit'
        }
    ];
    if (isEnabled && hasPreviewType) return /*#__PURE__*/ (0, $l998X.jsx)($95ecb474353a02ba$export$16e97e6603eadea, {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $0381e4ebc4c9b908$export$c60b43809441c5b0),
        eligibleMessages: eligibleMessage
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};



var $9oJIg = parcelRequire("9oJIg");

var $MyxIQ = parcelRequire("MyxIQ");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");











var $8MKuN = parcelRequire("8MKuN");


var $bQm3c = parcelRequire("bQm3c");





var $0VKZa = parcelRequire("0VKZa");

function $ccd0dc06d2167081$var$useIsEmbeddedView() {
    if ((0, $9wGTI.fg)('confluence_screen_space_flags_no_embed')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    return false;
}
const $ccd0dc06d2167081$export$f6564e60882bdf90 = /*#__PURE__*/ (0, $42omo.memo)(()=>{
    const [messageErrorToReport, setMessageErrorToReport] = (0, $42omo.useState)();
    const [preloadedInitialData, setPreloadedInitialData] = (0, $MyxIQ.usePlacementPreloadedData)('screen-space-flags/update-messages');
    const memoizedPlacementProps = (0, $42omo.useMemo)(()=>({
            reportExpectedError: (0, $7Sm4c.markErrorAsHandled),
            reportUnexpectedError: setMessageErrorToReport,
            preloadedInitialData: preloadedInitialData,
            setPreloadedInitialData: setPreloadedInitialData
        }), [
        preloadedInitialData,
        setPreloadedInitialData
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isEmbeddedView = $ccd0dc06d2167081$var$useIsEmbeddedView();
    if (isEmbeddedView) return null;
    if (!userId) return null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95ecb474353a02ba$export$46db7cd62b063064), {
        isEnabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9oJIg.PlacementFetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9QvUi.default), {
        placementId: "screen-space-flags",
        // @ts-ignore - Type 'ComponentType<ErrorBoundariedProps<Placement>>' is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $0381e4ebc4c9b908$export$c60b43809441c5b0),
        placementProps: memoizedPlacementProps,
        disableInitialData: true
    }), messageErrorToReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: messageErrorToReport
    })));
    return (0, $6mKj3.expVal)('confluence_edit_page_conditional_ufohold_ignore', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MKuN.ConditionalUfoHoldIgnore), null, content) : content;
});
const $ccd0dc06d2167081$export$1966d6abb8c3b6 = async (match)=>{
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const activeScopes = (0, $0381e4ebc4c9b908$export$c32237a999261c49)({
        route: {
            hostname: '',
            pathname: match?.pathname ?? '',
            search: match?.search ?? ''
        },
        context: (0, $0VKZa.sessionToPostOfficeContext)(sessionContext)
    });
    const updateMessagesBody = {
        current: activeScopes,
        previous: []
    };
    return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('screen-space-flags', {
        resource: '/update-messages',
        requestInit: {
            method: 'POST',
            body: JSON.stringify(updateMessagesBody)
        }
    });
};








async function $f217a7781374a3c1$export$5ab53e93f975c926(match) {
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!userId || !match) return;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ScreenSpaceFlags', async ()=>{
        return (0, $ccd0dc06d2167081$export$1966d6abb8c3b6)(match);
    });
}












var $kdKo9 = parcelRequire("kdKo9");

async function $143cdfd4eb3dc7a0$export$f8ed1334515840af(spaceKey) {
    const result = await (0, $dYU3e.query)({
        query: (0, $kdKo9.default),
        variables: {
            spaceKey: spaceKey
        },
        errorPolicy: 'all',
        // Preloaders are called both on server at initial load AND transition on client-side.
        // On server-side it doesn't matter fetch policy because we only gonna request once.
        // On client-side it must be network-only to get fresh data.
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/restrictions"
    });
    window['__SPACE_RESTRICTED_CHECK_ERROR__'] = false;
    window['__SPACE_NOTFOUND_CHECK_ERROR__'] = false;
    if (result?.errors) result.errors.forEach((error)=>{
        const status_code = error?.extensions?.statusCode;
        if (status_code === 403) {
            window['__SPACE_RESTRICTED_CHECK_ERROR__'] = true;
            (0, $7Sm4c.markErrorAsHandled)(error);
        } else if (status_code === 404 || status_code === 400) {
            window['__SPACE_NOTFOUND_CHECK_ERROR__'] = true;
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
}


const $f7b10b9020854fc7$export$6fb7f9b73aaa748e = async (spaceKey)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $143cdfd4eb3dc7a0$export$f8ed1334515840af)(spaceKey)
    ]);
};


















async function $b4d670122e111714$export$e77946254f7ce879(match) {
    const tasks = [];
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId, isRovoEnabled: isRovoEnabled } = preloadedSessionContext;
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    tasks.push((0, $5WLjq.preloadSpacesList)({
        isLicensed: isLicensed
    }));
    const isFullPageSearchEnabled = ((0, $9wGTI.fg)('unified_search_in_confluence') || isRovoEnabled) && !(0, $9wGTI.fg)('confluence_rovo_search_opt_out');
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
}



async function $e80763d537fd4542$export$6aefe8c2dfd7fe98(url) {
    const match = $e80763d537fd4542$var$matchRoute(url);
    if (match?.experience === (0, $irVI7.VIEW_PAGE_EXPERIENCE) || match?.experience === (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE) || match?.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $9fLxI.getExtensionManifest)({
            spaceKey: match.params.spaceKey
        }),
        (0, $5SzHz.preloadSpaceDetail)(match.params.spaceKey),
        (0, $821e100427ee88aa$export$ce64f7b5556cdb62)(),
        (0, $88b2ba3b9422ec6a$export$3837c35a0d92ab93)()
    ]);
}
async function $e80763d537fd4542$export$57d895781a697848(...args) {
    // All the function calls originated from this entry point are attached to a query boundary.
    // This is used to help us identify fetches fired from components.
    return (0, $g277M.runInQueryBoundary)('default', ()=>{
        return $e80763d537fd4542$var$preloadQueryBasedOnRouteImpl(...args);
    });
}
async function $e80763d537fd4542$var$preloadQueryBasedOnRouteImpl(url, isTransition = false, previousMatch = null, preloadOptions) {
    const commonTasks = [];
    const match = $e80763d537fd4542$var$matchRoute(url);
    if (match?.experience) (0, $df23aac6d1130849$export$7388eaba0b85ff24)(match.experience);
    const isEmbeddedWhiteboard = match?.experience === (0, $irVI7.WHITEBOARD_EXPERIENCE) && (0, $58246c7bb1bd3b0e$export$a8738b3e8374c78c)(match).bypassesMainLayout;
    /**
   * There are synchronous operations in preparing session data.
   * All queries that independent to session data should be fired first.
   */ if (!isTransition) {
        commonTasks.push((0, $29df517881fdeca7$export$990c5eb6cb59ce1c)());
        if (match?.experience === (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE)) // The PDF export route only renders a specific Confluence page's title and content.
        // So, we don't need to fetch data for certain common Confluence features and preferences such as navigation and user settings.
        // Note 1: PDF export is not a SSR capability and also need not support SPA transitions, as it is only accessible via direct URL.
        commonTasks.push(// Remote local storage
        (0, $eiCiP.preloadLocalStorage)(), // Forge UI user profile
        (0, $969a3e14c27be3bd$export$9930aa21f1e6a4e3)());
        else if (isEmbeddedWhiteboard) {
            commonTasks.push((0, $eiCiP.preloadLocalStorage)());
            // https://switcheroo.atlassian.com/ui/gates/0d974cd3-c266-43ed-9312-0980df443012/key/post-office_screen-space-flags-confluence-ssr
            if ((0, $9wGTI.fg)('post-office_screen-space-flags-confluence-ssr')) commonTasks.push((0, $f217a7781374a3c1$export$5ab53e93f975c926)(match));
            commonTasks.push((0, $96ee7afaced2313e$export$e0e94d96f49a1aa)({
                themeState: undefined
            }));
            commonTasks.push((0, $3y1ko.preloadShortcutEnabledState)());
        } else if (match?.experience !== (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE)) {
            // external share doesn't have navigation, returns only errors
            commonTasks.push((0, $eiCiP.preloadLocalStorage)(), (0, $5368439faec350a5$export$6c7e4784651f052f)());
            commonTasks.push((0, $c63485f681d81d31$export$693b572d94b96722)());
            commonTasks.push((0, $e44b2547c6a8e817$export$dfd129d3c3f4c561)());
            commonTasks.push((0, $eS4vC.createDataFetcherForSuspense)('top-nav', ()=>[
                    (0, $a6a4fe9083f3db22$export$d46e9819bcc1eb51)(),
                    (0, $1d20c0a68123b7f2$export$2d0f6d5aa0911699)(),
                    (0, $3y1ko.preloadShortcutEnabledState)()
                ]));
            commonTasks.push((0, $34aa8f5c495a6ba2$export$3efc211209d16247)(match?.params?.spaceKey));
            if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) commonTasks.push((0, $da1fd1e44d7582fe$export$b4f1825d0b62630d)());
            // https://switcheroo.atlassian.com/ui/gates/0d974cd3-c266-43ed-9312-0980df443012/key/post-office_screen-space-flags-confluence-ssr
            if ((0, $9wGTI.fg)('post-office_screen-space-flags-confluence-ssr')) commonTasks.push((0, $f217a7781374a3c1$export$5ab53e93f975c926)(match));
            commonTasks.push((0, $969a3e14c27be3bd$export$9930aa21f1e6a4e3)());
            const experience = match?.experience;
            commonTasks.push((0, $96ee7afaced2313e$export$e0e94d96f49a1aa)({
                themeState: [
                    (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE),
                    (0, $irVI7.VIEW_PAGE_EXPERIENCE)
                ].includes(experience) ? match?.query?.themeState : undefined
            }));
            if ((0, $9wGTI.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) commonTasks.push((0, $1f8e7f4831866dd9$export$f92adbce3a1ce419)());
        }
    }
    if (!match) // Following code are specific to each route.
    // If we don't get a match here then there is nothing interesting
    return Promise.resolve();
    let routeTasks = Promise.resolve();
    const commonRouteTasks = [];
    // Routes can have common data if the route has a space key
    const spaceKey = match?.params?.spaceKey;
    if (spaceKey) commonRouteTasks.push((0, $f7b10b9020854fc7$export$6fb7f9b73aaa748e)(spaceKey));
    // TODO: We should do similar for content id here
    // but currently preloadPageRestrictionsQuery is spread out in each individual route.
    if (!isEmbeddedWhiteboard && (0, $9wGTI.fg)('aifc_onboarding_ga_enabled')) commonRouteTasks.push((0, $9c2bd2b1923ffb30$export$20203945a91bbda3)());
    if (match.experience === (0, $irVI7.VIEW_PAGE_EXPERIENCE)) {
        const { isLivePage: isLivePageSSR } = (0, $60cDW.getSSRRenderInputs)();
        // On transition or SSR revisit, validate whether we're a live doc. If so, only preload live doc routes, not all view page routes.
        // Prevents unnecessary GQL calls, e.g. ContentUnifiedQuery.
        let isCachedLivePage = false;
        const contentId = match?.params?.contentId;
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const shouldCheckCachedLivePage = isTransition || Boolean(undefined);
        if (contentId && !isLivePageSSR && shouldCheckCachedLivePage) {
            const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
            isCachedLivePage = subType === 'live' && isArchived === false;
        }
        routeTasks = isLivePageSSR || isCachedLivePage ? (0, $iUV81.preloadLivePageRoute)(match, url) : (0, $445d6fd463fd83fa$export$9503d022471fff24)(match, url, isTransition, previousMatch);
    } else if (match.experience === (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE) || match.experience === (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE)) {
        if (preloadOptions?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJSAndCriticalData) routeTasks = (0, $fe22b38e04163065$export$75a73f2fbf5e96e8)(match);
        else routeTasks = (0, $fe22b38e04163065$export$75071d943b36f58f)(match, previousMatch, url);
    } else if (match.experience === (0, $irVI7.WHITEBOARD_EXPERIENCE)) routeTasks = (0, $d639d659544153c3$export$a107836a8bcfc0c9)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.DATABASE_EXPERIENCE)) routeTasks = (0, $f7a595baa9e6d446$export$f9f9f93ef86bfae1)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.EMBED_EXPERIENCE)) routeTasks = (0, $a17ca091e4cf9f3d$export$18e29f32c47bffc9)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE)) routeTasks = (0, $ff76ae367134cd26$export$2a230d51c69b591b)(match.params.contentId);
    else if (match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) routeTasks = (0, $32e736695aa13b8b$export$8abf4a07f4444858)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.HOME_EXPERIENCE)) routeTasks = (0, $179951d621935e1e$export$cefc517f3ae2aa98)(match);
    else if (match.experience === (0, $irVI7.SPACE_PAGES_EXPERIENCE)) routeTasks = (0, $106eac55bed5d4af$export$206b1c2d74bc11a2)(match);
    else if (match.experience === (0, $irVI7.CONTENT_HISTORY_EXPERIENCE)) routeTasks = (0, $0ef4e79dd69588ad$export$9f53340e87bacbbd)(match);
    else if (match.experience === (0, $irVI7.ATTACHMENTS_PAGE_EXPERIENCE)) routeTasks = (0, $29ace679d934655d$export$7cbbf2d30ca863e7)(match);
    else if (match.experience === (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)) routeTasks = (0, $b4d670122e111714$export$e77946254f7ce879)(match);
    else if (match.experience === (0, $irVI7.SHAREABLE_LINK_EXPERIENCE)) routeTasks = (0, $1f9d1c86f6a99b0e$export$5da6d89b949b94fc)(match);
    else if (match.experience === (0, $irVI7.FOLDER_EXPERIENCE)) routeTasks = (0, $ae578b27499cf6ef$export$4286139fad35252)(match);
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $eS4vC.createDataFetcherForSuspense)('default', ()=>[
                routeTasks,
                ...commonRouteTasks
            ]),
        ...commonTasks
    ]).then((errors)=>{
        if (errors) for (const e of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(e);
    });
}
async function $e80763d537fd4542$export$faa68b5324f40037(pageUrl) {
    const match = $e80763d537fd4542$var$matchRoute(pageUrl);
    if (!match) return;
    if (match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) return (0, $73df6e46d3afaa7c$export$9c3872cc60e7dbce)(match, pageUrl);
}
function $e80763d537fd4542$var$matchRoute(url) {
    let match;
    let experience;
    if (match = (0, $kM8fE.matchViewPage)(url)) experience = (0, $irVI7.VIEW_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchWhiteboardPage)(url)) experience = (0, $irVI7.WHITEBOARD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSpaceOverview)(url)) experience = (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE);
    else if (match = (0, $kM8fE.matchCompanyHub)(url)) experience = (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchHome)(url)) experience = (0, $irVI7.HOME_EXPERIENCE);
    else if (match = (0, $kM8fE.matchFabricEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchExternalShare)(url)) experience = (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchAccessLink)(url)) experience = (0, $irVI7.SHAREABLE_LINK_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSpacePages)(url)) experience = (0, $irVI7.SPACE_PAGES_EXPERIENCE);
    else if (match = (0, $kM8fE.matchContentHistory)(url)) experience = (0, $irVI7.CONTENT_HISTORY_EXPERIENCE);
    else if (match = (0, $kM8fE.matchAttachmentsPage)(url)) experience = (0, $irVI7.ATTACHMENTS_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchEmbeddedEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (match = (0, $kM8fE.matchDatabasePage)(url)) experience = (0, $irVI7.DATABASE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchEmbedPage)(url)) experience = (0, $irVI7.EMBED_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSmartCreateEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSearch)(url)) experience = (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE);
    else if ((0, $kM8fE.matchPdfExport)(url)) {
        match = (0, $kM8fE.matchPdfExport)(url);
        experience = (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE);
    } else if (match = (0, $kM8fE.matchFolderPage)(url)) experience = (0, $irVI7.FOLDER_EXPERIENCE);
    return match && {
        ...match,
        experience: experience
    };
}
async function $e80763d537fd4542$export$bd8e570400e2d126() {
    const pageUrl = window.location.toString();
    // Extensions Manifest and extensions data (when preloading is requested for them)
    // are heavy and should not be loaded on server side and embedded into HTML.
    $e80763d537fd4542$export$6aefe8c2dfd7fe98(pageUrl);
    if (window.__SSR_RENDERED__) $e80763d537fd4542$export$faa68b5324f40037(pageUrl);
    else $e80763d537fd4542$export$57d895781a697848(pageUrl);
}






var $8PKGr = parcelRequire("8PKGr");


var $aXEzU = parcelRequire("aXEzU");








var $dA1Sn = parcelRequire("dA1Sn");


var $gnYQc = parcelRequire("gnYQc");











var $2DVQX = parcelRequire("2DVQX");


var $7ZzSP = parcelRequire("7ZzSP");


var $id4ij = parcelRequire("id4ij");

const $2bffd0a48908e22c$export$daa1e83127b2f677 = async ()=>{
    const imageElements = Array.prototype.slice.call(document.getElementById('content') ? document.getElementById('content').querySelectorAll('img') : []);
    window._contentMediaSources = imageElements.filter((element)=>(0, $id4ij.isPartOfElementStillInViewPort)(element)).map((element)=>element.src);
};



var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");


var $4xcIM = parcelRequire("4xcIM");





var $kFqI2 = parcelRequire("kFqI2");


var $T1bCI = parcelRequire("T1bCI");


var $7l88B = parcelRequire("7l88B");





var $gWfvV = parcelRequire("gWfvV");


var $6vAdz = parcelRequire("6vAdz");








var $7zgzO = parcelRequire("7zgzO");








var $djMdn = parcelRequire("djMdn");


var $ibzAc = parcelRequire("ibzAc");





var $32x2E = parcelRequire("32x2E");

const $b765bc6fd36943f2$export$e2036a91fb26c8cf = (url)=>{
    /* Extracting Confluence page data from URL because we don't have access to the page context
	 * from the Screen Space Flags placement.
	 *
	 * Sample page URL: wiki/spaces/{spaceKey}/pages/{contentId}/This+is+the+title+of+a+page
	 * Sample blog URL: wiki/spaces/{spaceKey}/blog/2025/04/11/{contentId}/This+is+the+title+of+a+blog+post
	 */ const [, spaceKey, rawContentType, contentId] = url.match(/\/wiki\/spaces\/([^/]+)\/(pages|blog)(?:\/\d{4}\/\d{2}\/\d{2})?\/([^/]+)/) || [];
    const contentType = rawContentType === 'pages' ? 'page' : rawContentType === 'blog' ? 'blogpost' : rawContentType;
    return {
        spaceKey: spaceKey,
        contentType: contentType,
        contentId: contentId
    };
};






var $8dbvt = parcelRequire("8dbvt");


var $2HQyh = parcelRequire("2HQyh");


var $1AapX = parcelRequire("1AapX");


var $jMyy4 = parcelRequire("jMyy4");


const $19a192258e8db8bc$export$1d93f080b8c40251 = (skip = false)=>{
    const { contentId: contentId, spaceKey: spaceKey } = (0, $b765bc6fd36943f2$export$e2036a91fb26c8cf)(globalThis.location.href);
    // Get recommendation data
    const { data: recPageData, loading: recPageLoading, error: recPageError } = (0, $jMyy4.useQueryInterop)((0, $2HQyh.default), {
        variables: {
            type: 'page',
            id: contentId ?? '',
            exp: 'end_of_page_v5',
            key: spaceKey ?? '',
            keyString: spaceKey ?? ''
        },
        skip: !contentId || !spaceKey || skip,
        __callerPackage__: "@confluence-classic/confluence-post-office-provider"
    });
    // Transform/sort data and grab first rec
    const recommendedPage = (0, $42omo.useMemo)(()=>{
        const rankedPages = $19a192258e8db8bc$var$transformAndOrderRecs(recPageData?.getRecommendedPages?.recommendedPages);
        return rankedPages?.[0];
    }, [
        recPageData
    ]);
    // Get avatar and name of the page owner
    const { data: hoverPageData, loading: hoverPageLoading, error: hoverPageError } = (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $1AapX.default), {
        variables: {
            id: recommendedPage ? recommendedPage.id : ''
        },
        skip: !recommendedPage || skip,
        __callerPackage__: "@confluence-classic/confluence-post-office-provider"
    });
    const pageRecommendationData = {
        data: undefined,
        loading: hoverPageLoading || recPageLoading,
        hoverPageError: hoverPageError,
        recPageError: recPageError
    };
    if (hoverPageData?.singleContent?.history?.ownedBy?.displayName && hoverPageData?.singleContent?.history?.ownedBy?.profilePicture?.path && recommendedPage?.links?.webui && recommendedPage?.title.text) pageRecommendationData.data = {
        pageOwner: {
            name: hoverPageData.singleContent.history.ownedBy.displayName,
            avatarUrl: hoverPageData.singleContent.history.ownedBy.profilePicture.path
        },
        page: {
            title: recommendedPage.title.text,
            url: `/wiki${recommendedPage.links.webui}`
        }
    };
    return pageRecommendationData;
};
/**
 * The ordering of recs array is determined by the "ranking" in the backend.
 * Each rec will have a corresponding "strategies" array that can have one or multiple strategies.
 * We want to ensure that we are choosing strategies from each rec in a way that avoids monotony on the UI.
 * To accomplish this, we must first sort the recs array depending on the number of strategies each rec has, in
 * ascending order. We then pass each rec to transformEndOfPageRecContent which helps to choose the strategy, and
 * finally we return the transformed array back to the intial ranking order determind by the backend
 */ const $19a192258e8db8bc$var$transformAndOrderRecs = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>(0, $8dbvt.transformEndOfPageRecContent)(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const el = transformedRecs.find((card)=>card.id === rec.content.id);
        pageCards.push(el);
    });
    return pageCards;
};


/* eslint-disable graphql-relay-compat/no-import-graphql-operations */ /* eslint-disable no-restricted-imports */ 






var $3V1KT = parcelRequire("3V1KT");


var $2OQgp = parcelRequire("2OQgp");











const $f95c9b8c12af7d64$var$INITIAL_REACTED_USER_QUERY_RESULT = {
    data: undefined,
    loading: false,
    error: undefined
};
// Helper function to fetch the specific names of users who reacted to a specific emoji
const $f95c9b8c12af7d64$var$getReactedUsersForEmoji = async (contentId, contentType, emojiId)=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $2OQgp.ReactedUsersQuery),
        variables: {
            contentId: contentId,
            contentType: contentType.toUpperCase(),
            containerId: contentId,
            containerType: contentType.toUpperCase(),
            emojiId: emojiId
        },
        __callerPackage__: "@confluence-classic/confluence-post-office-provider"
    });
    return data;
};
// Helper function to get unique users who reacted to any emoji
const $f95c9b8c12af7d64$var$getUniqueReactedUsers = async (contentId, contentType, emojiIds)=>{
    const uniqueUsers = {};
    // Process all emojis in parallel to get all unique users
    await Promise.allSettled(emojiIds.filter(Boolean).map(async (emojiId)=>{
        const data = await $f95c9b8c12af7d64$var$getReactedUsersForEmoji(contentId, contentType, emojiId);
        // Add all users to the unique users map
        for (const user of data?.reactedUsers?.confluencePerson ?? [])if (user?.displayName && user.accountId) uniqueUsers[user.accountId] = user.displayName;
    }));
    return uniqueUsers;
};
const $f95c9b8c12af7d64$export$a35f2f61e0cb4308 = (numberOfReactedUsers, skip = false)=>{
    // Needed for Confluence-required analytic events
    const { userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { contentId: contentId, contentType: contentType } = (0, $b765bc6fd36943f2$export$e2036a91fb26c8cf)(window.location.href);
    const [reactedUsers, setReactedUsers] = (0, $42omo.useState)($f95c9b8c12af7d64$var$INITIAL_REACTED_USER_QUERY_RESULT);
    const [uniqueUsersCount, setUniqueUsersCount] = (0, $42omo.useState)(0);
    // Fetch page author and author's avatar URL
    const { data: spaceHoverPageCardResult, loading: spaceHoverPageCardLoading, error: spaceHoverPageCardError } = (0, $jMyy4.useQueryInterop)((0, $1AapX.default), {
        variables: {
            id: contentId
        },
        skip: !contentId || skip,
        __callerPackage__: "@confluence-classic/confluence-post-office-provider"
    });
    // Fetch total reactions count and emoji ID summary
    const { data: reactionsContentData, loading: reactionsLoading, error: reactionsError } = (0, $jMyy4.useQueryInterop)((0, $3V1KT.ReactionsContentQuery), {
        variables: {
            contentId: contentId
        },
        skip: !contentId || skip,
        __callerPackage__: "@confluence-classic/confluence-post-office-provider"
    });
    // Use the emoji ID summary from reactionsContentData to fetch the specific names of users who reacted
    (0, $42omo.useEffect)(()=>{
        const emojiIds = reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji?.flatMap((reaction)=>reaction?.emojiId ?? []);
        // Need to put this in a function and then call it because we can't use async/await in useEffect
        const getReactedUsers = async ()=>{
            if (!contentId || !contentType || !emojiIds || reactedUsers.data || reactedUsers.loading) return;
            setReactedUsers({
                loading: true
            });
            try {
                // Get all unique users in parallel
                const uniqueUsers = await $f95c9b8c12af7d64$var$getUniqueReactedUsers(contentId, contentType, emojiIds);
                // Take only the first numberOfReactedUsers users for the reactedUsers state
                const limitedUsers = Object.values(uniqueUsers).slice(0, numberOfReactedUsers);
                // Update state
                setUniqueUsersCount(Object.keys(uniqueUsers).length);
                setReactedUsers({
                    data: limitedUsers,
                    loading: false
                });
            } catch (error) {
                setReactedUsers({
                    loading: false,
                    error: error
                });
            }
        };
        getReactedUsers();
    }, [
        contentId,
        contentType,
        reactionsContentData,
        reactedUsers,
        numberOfReactedUsers
    ]);
    // Transform this so that it matches Post Office's expected shape (for use with the ReactionWrapper component)
    const transformedReactionsSummary = (0, $42omo.useMemo)(()=>({
            reactionsSummary: {
                ari: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.ari || '',
                containerAri: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.containerAri || '',
                reactionsSummaryForEmoji: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji?.map((emoji)=>{
                    // Only return emoji objects that have all required non-null values
                    if (emoji?.count != null && emoji?.emojiId != null && emoji?.reacted != null) return {
                        count: emoji.count,
                        emojiId: emoji.emojiId,
                        reacted: emoji.reacted,
                        __typename: 'ReactionsSummaryForEmoji'
                    };
                    return null; // Return null for incomplete emoji data
                }) || [],
                // Provide empty array as fallback if the whole map operation is undefined
                __typename: 'ReactionsSummaryResponse'
            }
        }), [
        reactionsContentData
    ]);
    return {
        data: {
            authorName: spaceHoverPageCardResult?.singleContent?.history?.ownedBy?.displayName ?? undefined,
            authorAvatar: spaceHoverPageCardResult?.singleContent?.history?.ownedBy?.profilePicture?.path,
            reactionsCount: uniqueUsersCount,
            reactionsSummary: transformedReactionsSummary,
            reactedUsers: reactedUsers.data,
            userId: userId || undefined,
            activationId: activationId
        },
        loading: spaceHoverPageCardLoading || reactionsLoading || reactedUsers.loading,
        error: spaceHoverPageCardError || reactionsError || reactedUsers.error
    };
};


const $a730e736ff2c0fdb$export$50c48a5a1548e4da = ({ children: children })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const experimentsContextValue = (0, $42omo.useMemo)(()=>{
        return {
            usePageRecommendationData: $19a192258e8db8bc$export$1d93f080b8c40251,
            useInlineReactionsData: $f95c9b8c12af7d64$export$a35f2f61e0cb4308,
            getPageDataFromUrl: $b765bc6fd36943f2$export$e2036a91fb26c8cf,
            emojiProvider: (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
                userId: userId,
                cloudId: cloudId
            })
        };
    }, [
        userId,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $djMdn.ConfluenceExperimentsContext).Provider, {
        value: experimentsContextValue
    }, children);
};






var $kDuN4 = parcelRequire("kDuN4");


var $aXjWU = parcelRequire("aXjWU");

const $f6be7463febe9936$var$GASV3_DWELL_TRIGGER_TIME = 40000; // ms
const $f6be7463febe9936$var$PO_DWELL_TRIGGER_TIME = 60000; // ms
const $f6be7463febe9936$export$2855524b2284c48 = ({ children: children })=>{
    const { fireTrigger: fireTrigger } = (0, $aXjWU.useFirePostOfficeTrigger)({
        triggerId: 'confluence-page-dwelled'
    });
    const onEvent = (0, $42omo.useCallback)((event)=>{
        if (event.payload?.data?.action === 'dwelled' && event.payload?.data?.actionSubject === 'page') {
            const dwellTime = event.payload.data.attributes?.dwellTime;
            // Dwell events are triggered at 5, 10, 20, 40, 80s, but we want 60s
            if (event.payload.data.attributes?.finalDwellEvent) fireTrigger({
                isActive: false
            });
            else if (dwellTime && dwellTime >= $f6be7463febe9936$var$GASV3_DWELL_TRIGGER_TIME && dwellTime <= $f6be7463febe9936$var$PO_DWELL_TRIGGER_TIME) fireTrigger({
                isActive: true
            });
        }
    }, [
        fireTrigger
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: onEvent,
        channel: "*"
    }, children);
};


const $074500c4d6f25c0d$var$ConfluencePostOfficeProvider = ({ children: children })=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, environment: environment, locale: locale, orgId: orgId, edition: edition } = (0, $bQm3c.useSessionData)();
    const context = (0, $42omo.useMemo)(()=>({
            current: (0, $0VKZa.sessionToPostOfficeContext)({
                accessStatus: accessStatus,
                activationId: activationId,
                cloudId: cloudId,
                locale: locale,
                orgId: orgId,
                edition: edition
            })
        }), [
        activationId,
        cloudId,
        accessStatus,
        locale,
        orgId,
        edition
    ]);
    const env = (0, $42omo.useMemo)(()=>({
            env: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    const analyticsClientInstance = (0, $42omo.useMemo)(()=>(0, $04e9M.getAnalyticsWebClient)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWfvV.PostOfficeProvider), {
        context: context,
        environment: env,
        analyticsClientInstance: analyticsClientInstance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6be7463febe9936$export$2855524b2284c48), null, children));
};
const $074500c4d6f25c0d$export$fb465b6e855c1e85 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($074500c4d6f25c0d$var$ConfluencePostOfficeProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a730e736ff2c0fdb$export$50c48a5a1548e4da), null, children));
};
const $074500c4d6f25c0d$var$ConfluenceRouterListener = ({ children: children })=>{
    const routeContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    (0, $6vAdz.usePostOfficeRouteUpdate)([
        routeContext.getHref() ?? '',
        routeContext.match?.name ?? ''
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $074500c4d6f25c0d$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($074500c4d6f25c0d$var$ConfluenceRouterListener, null, children);
};







var $lonEO = parcelRequire("lonEO");


var $kZDrw = parcelRequire("kZDrw");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $f7i8j = parcelRequire("f7i8j");


var $jVK0t = parcelRequire("jVK0t");





var $bcvT8 = parcelRequire("bcvT8");








var $1Rv6U = parcelRequire("1Rv6U");




const $fe198622d822a4a2$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $1Rv6U.PluginTypes).GetContainers,
        fetch
    ];
};
const $fe198622d822a4a2$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $1Rv6U.PluginTypes).GetUsers,
        fetch
    ];
};
const $fe198622d822a4a2$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $1Rv6U.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $fe198622d822a4a2$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $1Rv6U.PluginTypes).GetAvailableSites,
        fetch
    ];
};






var $fKdEy = parcelRequire("fKdEy");

function $3dc98590eeed1246$var$hasSiteSettings(data) {
    return data && typeof data === 'object' && data['siteSettings'] && data['tenant'];
}
const $3dc98590eeed1246$var$getCloudId = async ()=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $fKdEy.default),
        __callerPackage__: "@confluence/cross-flow"
    });
    const containers = [];
    if ($3dc98590eeed1246$var$hasSiteSettings(data)) {
        const { siteTitle: siteTitle } = data.siteSettings;
        const tenantId = data.tenant.cloudId;
        containers.push({
            id: tenantId,
            displayName: siteTitle,
            type: (0, $1Rv6U.ContainerTypes).ATLASSIAN_CLOUD_ID
        });
    }
    return {
        type: (0, $1Rv6U.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $3dc98590eeed1246$export$81d1d40061d190bc = (0, $fe198622d822a4a2$export$76378b0f825c024c)($3dc98590eeed1246$var$getCloudId);








const $c394a569c7bfdabb$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await (0, $f7B1p.cfetch)(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    idType: (0, $1Rv6U.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    id: value.id,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $c394a569c7bfdabb$export$7c44908d2777db01 = (0, $fe198622d822a4a2$export$8feb7eae83cf8cd5)($c394a569c7bfdabb$var$getUsers);


const $70d683a301b7be27$export$d900e4062895cd7c = ({ children: children })=>{
    const { cloudId: cloudId, locale: locale } = (0, $bQm3c.useSessionData)();
    const analyticWebClient = (0, $42omo.useMemo)(()=>(0, $04e9M.getAnalyticsWebClient)(), []);
    const isMarketingOptOut = document.querySelector("meta[name='ajs-marketing-opt-out']")?.getAttribute('content') === 'true';
    if (isMarketingOptOut) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcvT8.default), {
        cloudId: cloudId,
        analyticsClient: analyticWebClient,
        locale: locale,
        plugins: [
            (0, $c394a569c7bfdabb$export$7c44908d2777db01),
            (0, $3dc98590eeed1246$export$81d1d40061d190bc)
        ]
    }, children);
};



var $fcF01 = parcelRequire("fcF01");


var $d5ap9 = parcelRequire("d5ap9");


var $1ytiN = parcelRequire("1ytiN");





var $aXWIB = parcelRequire("aXWIB");





var $5spQU = parcelRequire("5spQU");


var $lsxnT = parcelRequire("lsxnT");











var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $hSHWm = parcelRequire("hSHWm");


var $jmjWc = parcelRequire("jmjWc");


const $639a6e255dabf06b$export$96cfefeef4383728 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "mA5-d",
    name: "CoreInvitesLoadable",
    loader: async ()=>(await (parcelRequire("9hxmQ"))).CoreInvites
});



var $koZ31 = parcelRequire("koZ31");







const $8855e66edaf78755$var$INVITE_DIALOG_PARAM = 'inviteDialog';
const $8855e66edaf78755$var$getOpenModalParam = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get($8855e66edaf78755$var$INVITE_DIALOG_PARAM) || '';
};
function $8855e66edaf78755$export$fd22f9b0c5d723c2(openCoreInvites) {
    (0, $42omo.useEffect)(()=>{
        if (!window) return;
        if ($8855e66edaf78755$var$getOpenModalParam() !== 'open') return;
        openCoreInvites((0, $koZ31.CoreInvitesSource).OPEN_MODAL_QUERY_PARAM);
        // remove the query param from the URL without reloading the page
        const url = new URL(window.location.href);
        url.searchParams.delete($8855e66edaf78755$var$INVITE_DIALOG_PARAM);
        window.history.replaceState({}, document.title, url.toString());
    }, [
        openCoreInvites
    ]);
}


const $685338b3d2a4b0a3$var$noop = ()=>{
    return undefined;
};
const $685338b3d2a4b0a3$var$messages = (0, $aXWIB.defineMessages)({
    inviteToCollaborateOnIssue: {
        id: "core-invites-provider..contextual-note-base",
        defaultMessage: "{invitingUser} needs to work with {invitedUser} on {pageTitle}."
    }
});
function $685338b3d2a4b0a3$export$2e865a7ec399eb55({ children: children }) {
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [initialInvitees, setInitialInvitees] = (0, $42omo.useState)([]);
    const [source, setSource] = (0, $42omo.useState)((0, $koZ31.CoreInvitesSource).UNKNOWN);
    const [showSpotlight, setShowSpotlight] = (0, $42omo.useState)(false);
    const [productContext, setProductContext] = (0, $42omo.useState)(undefined);
    const stablePropsRef = (0, $42omo.useRef)({
        onInviteCompleted: $685338b3d2a4b0a3$var$noop,
        onModalClose: $685338b3d2a4b0a3$var$noop
    });
    const intl = (0, $aXWIB.useIntl)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const contextualInviteNudgeChoreographer = useChoreographer('cc-contextual-invite-nudge', {
        start: ()=>setShowSpotlight(true),
        stop: ()=>setShowSpotlight(false)
    });
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const handleModalOpen = (0, $42omo.useCallback)((touchPoint, { onModalClosed: onModalClosed = $685338b3d2a4b0a3$var$noop, onInviteCompleted: onInviteCompleted = $685338b3d2a4b0a3$var$noop, getContextualInviteNudgeProps: getContextualInviteNudgeProps } = {}, initialInvitees = [], productContextMetadata)=>{
        setInitialInvitees(initialInvitees);
        setSource(touchPoint || (0, $koZ31.CoreInvitesSource).UNKNOWN);
        setProductContext(productContextMetadata);
        stablePropsRef.current.onModalClose = onModalClosed;
        stablePropsRef.current.onInviteCompleted = onInviteCompleted;
        setIsOpen(true);
        const shouldShow = getContextualInviteNudgeProps?.()?.showSpotlight;
        if (shouldShow) contextualInviteNudgeChoreographer.startMessage();
    }, [
        contextualInviteNudgeChoreographer,
        setInitialInvitees,
        setSource,
        setIsOpen
    ]);
    const handleModalClose = (0, $42omo.useCallback)(()=>{
        setSource((0, $koZ31.CoreInvitesSource).UNKNOWN);
        setProductContext(undefined);
        // remember the current value for later invocation, since we're about to override it
        const onClosed = stablePropsRef.current.onModalClose;
        stablePropsRef.current.onModalClose = $685338b3d2a4b0a3$var$noop;
        stablePropsRef.current.onInviteCompleted = $685338b3d2a4b0a3$var$noop;
        setIsOpen(false);
        onClosed();
        contextualInviteNudgeChoreographer.stopMessage();
    }, [
        contextualInviteNudgeChoreographer,
        setSource,
        setIsOpen
    ]);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const failExperienceOnError = (0, $42omo.useCallback)((error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.CORE_INVITES_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    const isInvitationsEnabled = !(0, $9wGTI.fg)('confluence_oasis_diasble_invitations') || (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-invitations');
    const coreInviteContext = (0, $42omo.useMemo)(()=>({
            openCoreInvites: isInvitationsEnabled ? handleModalOpen : undefined
        }), [
        handleModalOpen,
        isInvitationsEnabled
    ]);
    const displayInfiSpotlight = true;
    const inviteCompletedHandler = (0, $42omo.useCallback)((result)=>{
        stablePropsRef.current.onInviteCompleted(result);
    }, [
        stablePropsRef
    ]);
    (0, $8855e66edaf78755$export$fd22f9b0c5d723c2)(isInvitationsEnabled ? handleModalOpen : $685338b3d2a4b0a3$var$noop);
    const contextualNoteEligible = source === (0, $koZ31.CoreInvitesSource).MENTION && productContext?.pageTitle && (0, $9wGTI.fg)('twcg-1239-contextual-ra-note-gate');
    const experimentalNotes = (invitedUserIdentifier, currentUserName)=>{
        return intl.formatMessage($685338b3d2a4b0a3$var$messages.inviteToCollaborateOnIssue, {
            invitingUser: currentUserName,
            invitedUser: invitedUserIdentifier,
            pageTitle: productContext?.pageTitle
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSHWm.CoreInvitesContext).Provider, {
        value: coreInviteContext
    }, children, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH,
        onError: failExperienceOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $639a6e255dabf06b$export$96cfefeef4383728), {
        initialInvitees: initialInvitees,
        onSendHandler: handleModalClose,
        onCancelHandler: handleModalClose,
        onInviteCompletedHandler: inviteCompletedHandler,
        source: source,
        orgId: orgId,
        displayInfiSpotlight: displayInfiSpotlight,
        showSpotlight: showSpotlight,
        experimentalNotes: contextualNoteEligible ? experimentalNotes : undefined,
        experimentalProductContext: productContext
    })));
}



var $hrAmX = parcelRequire("hrAmX");


var $bJX6u = parcelRequire("bJX6u");


var $ktUCG = parcelRequire("ktUCG");


var $brNvA = parcelRequire("brNvA");


var $cryCi = parcelRequire("cryCi");


var $fN9wG = parcelRequire("fN9wG");


var $97W74 = parcelRequire("97W74");








var $6g1oe = parcelRequire("6g1oe");





var $dBmJE = parcelRequire("dBmJE");


var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $kCeSx = parcelRequire("kCeSx");


var $cbc8g = parcelRequire("cbc8g");


var $2cEww = parcelRequire("2cEww");






var $aXWtB = parcelRequire("aXWtB");














var $7aRa9 = parcelRequire("7aRa9");

parcelRequire("gLUd5");
var $5Z4kM = parcelRequire("5Z4kM");














var $gEtAQ = parcelRequire("gEtAQ");


var $jlIaF = parcelRequire("jlIaF");








var $2Nwuj = parcelRequire("2Nwuj");

const $b59268334a98f13b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    genericSSRErrorFlagReason: {
        id: "ssr-render-failure-notification.flag.generic.message",
        defaultMessage: "Reason: {reason}. "
    },
    branchDeployErrorFlagReason: {
        id: "ssr-render-failure-notification.flag.branch.deploy.message",
        defaultMessage: "Possible outdated branch deploy detected. Your PR changes might not be tested against SSR accurately. "
    },
    runbookLink: {
        id: "ssr-render-failure-notification.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for information on how to debug this failure."
    }
});
const $b59268334a98f13b$var$BRANCH_DEPLOY_RUNBOOK_LINK = `https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4898451942/Branch+Deploys`;
const $b59268334a98f13b$var$GENERIC_SSR_FAILURE_RUNBOOK_LINK = `https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4911008649/SSR+Render+Failures`;
const $b59268334a98f13b$export$487f09dcd3f678bf = ({ ssrErrors: ssrErrors, isBranchDeployFailure: isBranchDeployFailure })=>{
    const runbookLink = isBranchDeployFailure ? $b59268334a98f13b$var$BRANCH_DEPLOY_RUNBOOK_LINK : $b59268334a98f13b$var$GENERIC_SSR_FAILURE_RUNBOOK_LINK;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "flagErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, isBranchDeployFailure ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b59268334a98f13b$export$a7357cdd1f0b0168.branchDeployErrorFlagReason) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$b59268334a98f13b$export$a7357cdd1f0b0168.genericSSRErrorFlagReason,
        values: {
            reason: ssrErrors[0]
        }
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$b59268334a98f13b$export$a7357cdd1f0b0168.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: runbookLink
                }, chunks)
        }
    }));
};











const $5e5853def1ddf657$var$i18n = (0, $aXWIB.defineMessages)({
    hydrationErrorMessage: {
        id: "ssr-render-failure-notification.hydration.flag.message",
        defaultMessage: "To view the hydration mismatches, refer to window.__HYDRATION_ERRORS__ in the browser console."
    },
    runbookLink: {
        id: "ssr-render-failure-notification.hydration.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for information on how to debug the mismatches."
    }
});
const $5e5853def1ddf657$export$7922b21049d03e3b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "flagErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $5e5853def1ddf657$var$i18n.hydrationErrorMessage)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$5e5853def1ddf657$var$i18n.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: "https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches"
                }, chunks)
        }
    }));
};


const $008c5cd8cb4c3a95$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    ssrRenderErrorFlagTitle: {
        id: "ssr-render-failure-notification.flag",
        defaultMessage: "This page was NOT SSR RENDERED!"
    },
    hydrationErrorFlagTitle: {
        id: "ssr-render-failure-notification.hydration.flag",
        defaultMessage: "This page was NOT HYDRATED PROPERLY!"
    }
});
const $008c5cd8cb4c3a95$export$475a1abe7cf690a3 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const hasShownErrorFlagRef = (0, $42omo.useRef)(false);
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    // we want to exclude testing environments and pollinator tenants from showing the error flag
    const isTestEnvironment = (0, $1xpoY.default).isKillSwitchOn('confluence_frontend_ssr_failure_notification');
    // We only want to show the error flag in the dev/staging environment
    // however, branch deploys on production will default to process.env.CLOUD_ENV = 'branch'
    const isStagingEnvironment = // @ts-expect-error - ts(2345) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    [
        'dev',
        'branch',
        'staging',
        'stg-fedm'
    ].includes("production") && environment !== 'PRODUCTION';
    (0, $42omo.useEffect)(()=>{
        if (!isStagingEnvironment || isTestEnvironment) return;
        // regex to match /spaces/:spaceKey/blogs (blogs overview)
        const blogsOverviewRegex = new RegExp(`^${(0, $jlIaF.CONTEXT_PATH)}/spaces/[^/]+/blogs$`);
        // Helper function to determine if we should skip error checking for certain paths
        const isAllowedPath = (pathname)=>{
            return (0, $gEtAQ.isHomePage)() || (0, $gEtAQ.isViewPage)() || (0, $gEtAQ.isSpaceOverview)() || (0, $gEtAQ.isBlogPage)() || (0, $gEtAQ.isWhiteboard)() || (0, $gEtAQ.isDatabase)() || Boolean((0, $1NBp8.EDIT_PAGE).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_V2).match(pathname)) || Boolean((0, $1NBp8.EDIT_BLOG).match(pathname)) || Boolean((0, $1NBp8.EDIT_BLOG_V2).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(pathname)) || Boolean(blogsOverviewRegex.test(pathname)) || Boolean((0, $1NBp8.COMPANY_HUB).match(pathname)) || Boolean((0, $1NBp8.COMPANY_HUB_EDIT).match(pathname)) || Boolean((0, $1NBp8.EMBED_VIEW).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_SMART_CREATE).match(pathname)) || Boolean('/'.match(pathname));
        };
        if (isAllowedPath(window.location.pathname)) {
            const showHydrationError = ()=>{
                if (!hasShownErrorFlagRef.current) {
                    flags.showErrorFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $008c5cd8cb4c3a95$export$a7357cdd1f0b0168.hydrationErrorFlagTitle),
                        isAutoDismiss: false,
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5e5853def1ddf657$export$7922b21049d03e3b), null)
                    });
                    hasShownErrorFlagRef.current = true;
                }
            };
            if ((0, $6mKj3.expVal)('confluence_frontend_hydration_error_events_exp', 'isEnabled', false)) window.addEventListener('hydrationError', showHydrationError);
            // sometimes errors exist but the page is still SSRd successfully - we don't want to show the SSR render error flag in this case
            if (window.__SSR_RENDERED__) {
                // if the page is SSRd successfully we check if the page was hydrated successfully, and show a hydration error flag if not
                if (window.__HYDRATION_FAILED__) showHydrationError();
                return;
            }
            // COMPILED dev warnings show up on every SSRd page even if the page is SSRd successfully,
            // so we need to filter them out to distinguish from actual errors being reported for local dev ssr
            const ssrErrors = window.__SSR_ERROR__?.filter((err)=>!err.includes('DEV WARNING')) ?? [];
            // on old branch deploys, ssr errors can still be empty but the page might not be SSRd successfully
            const isBranchDeployFailure = (0, $5Z4kM.isBranchDeployFn)() && !window.__SSR_RENDERED__ && !ssrErrors?.length;
            if (!hasShownErrorFlagRef.current && (isBranchDeployFailure || ssrErrors.length)) {
                flags.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $008c5cd8cb4c3a95$export$a7357cdd1f0b0168.ssrRenderErrorFlagTitle),
                    isAutoDismiss: false,
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b59268334a98f13b$export$487f09dcd3f678bf), {
                        ssrErrors: ssrErrors,
                        isBranchDeployFailure: isBranchDeployFailure
                    })
                });
                hasShownErrorFlagRef.current = true;
            }
            return ()=>{
                window.removeEventListener('hydrationError', showHydrationError);
            };
        }
    }, [
        isStagingEnvironment,
        flags,
        isTestEnvironment
    ]);
    return null;
});
const $008c5cd8cb4c3a95$export$4e5ff544be3ec09b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($008c5cd8cb4c3a95$export$475a1abe7cf690a3, null));
};



var $iJELi = parcelRequire("iJELi");


var $8n9tL = parcelRequire("8n9tL");


var $4o1RV = parcelRequire("4o1RV");


var $aFbGo = parcelRequire("aFbGo");


var $64KID = parcelRequire("64KID");











var $4PPzL = parcelRequire("4PPzL");


var $5q601 = parcelRequire("5q601");










const $e7cb2c525109c7cf$var$MIN_LONG_TASK_DURATION = 50;
const $e7cb2c525109c7cf$export$de3c307012927947 = (start, stop, idleThreshold, buffer)=>{
    const entires = buffer.getAll().filter((entry)=>entry.duration >= $e7cb2c525109c7cf$var$MIN_LONG_TASK_DURATION).map((entry)=>({
            start: entry.startTime,
            stop: entry.startTime + entry.duration
        })).filter((entry)=>entry.stop > start && entry.start < stop).concat([
        // Add a fake entry to simplify the logic below
        {
            start: stop,
            stop: stop
        }
    ]).sort((a, b)=>a.start - b.start);
    let lastStop = start;
    for (const entry of entires){
        if (lastStop + idleThreshold < entry.start) return lastStop;
        lastStop = entry.stop;
    }
    return null;
};









var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $682a207fed74bf66$export$e49353726941624a = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.TIME_TO_APP_IDLE_KEY)
});



const $f6158bccfa436061$var$IDLE_THRESHOLD = 3000;
const $f6158bccfa436061$var$RETRY_INTERVAL = $f6158bccfa436061$var$IDLE_THRESHOLD * 2;
const $f6158bccfa436061$var$TIMEOUT_INTERVAL = 300000; // 5 minutes
const $f6158bccfa436061$var$PERFORMANCE_OBSERVER_LATENCY_ADJUSTMENT = 1000;
const $f6158bccfa436061$var$performance = window.performance;
const $f6158bccfa436061$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $f6158bccfa436061$var$wainNextIdle = ()=>{
    const onIdleCallback = window.requestIdleCallback || window.requestAnimationFrame;
    const cancelCallback = (id)=>{
        if (onIdleCallback === window.requestIdleCallback) window.cancelIdleCallback(id);
        else window.cancelAnimationFrame(id);
    };
    return new Promise((resolve)=>{
        const callbackId = onIdleCallback(()=>{
            cancelCallback(callbackId);
            resolve();
        });
    });
};
const $f6158bccfa436061$export$560b992b8a813cfb = /*#__PURE__*/ (0, $42omo.memo)(({})=>{
    const routes = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routeName = routes.match?.name || '';
    const contentId = routes.match?.params?.contentId || '';
    const transitionId = routes.transitionId || 0;
    (0, $42omo.useEffect)(()=>{
        const htmlTime = $f6158bccfa436061$var$performance?.getEntriesByName?.('CFP-63.html').pop()?.startTime || 0;
        const isInitialLoad = transitionId === 0;
        const metric = (0, $682a207fed74bf66$export$e49353726941624a)(`${transitionId}-${routeName}-${contentId}`);
        // we have two different 'startTime' variables in this context:
        // 'metricStartTime' - This is used for reporting to the metric and for calculating duration.
        // 'startTime' - This is used as a boundary for idle time calculation. There may be instances where the HTML is ready,
        // but the component is not yet rendered. In such cases, we use the component's first render time as the start boundary.
        const startTime = $f6158bccfa436061$var$performance?.now();
        const metricStartTime = isInitialLoad ? htmlTime : startTime;
        let abortedTime = 0;
        metric.start({
            startTime: metricStartTime
        });
        async function measureTimeToAppIdle() {
            while(true){
                await $f6158bccfa436061$var$delay($f6158bccfa436061$var$RETRY_INTERVAL);
                // wait for current long task to complete
                await $f6158bccfa436061$var$wainNextIdle();
                const endTime = $f6158bccfa436061$var$performance?.now();
                // wait to allow performance observer to collect recent entries
                // note that `endTime` somewhat behind after this line, but it's ok
                await $f6158bccfa436061$var$delay($f6158bccfa436061$var$PERFORMANCE_OBSERVER_LATENCY_ADJUSTMENT);
                const idleTime = (0, $e7cb2c525109c7cf$export$de3c307012927947)(startTime, endTime, $f6158bccfa436061$var$IDLE_THRESHOLD, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
                const aborted = abortedTime && (!idleTime || abortedTime < idleTime) ? 'transition' : false;
                const timedOut = endTime - metricStartTime > $f6158bccfa436061$var$TIMEOUT_INTERVAL;
                if (idleTime || timedOut || aborted) {
                    const stopTime = idleTime || endTime;
                    const duration = stopTime - metricStartTime;
                    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(startTime, stopTime, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
                    const customData = {
                        duration: duration,
                        startTime: metricStartTime,
                        stopTime: stopTime,
                        aborted: aborted,
                        transitionId: transitionId,
                        routeName: routeName,
                        contentId: contentId,
                        timedOut: timedOut,
                        idleThreshold: $f6158bccfa436061$var$IDLE_THRESHOLD,
                        tbtObserved: Math.round(tbt.observed),
                        tbtTotal: Math.round(tbt.total),
                        totalElementsToHydrate: (0, $ezH4I.getTotalHydratedElements)()
                    };
                    metric.stop({
                        stopTime: stopTime,
                        customData: customData
                    });
                    return;
                }
            }
        }
        measureTimeToAppIdle();
        return ()=>{
            abortedTime = $f6158bccfa436061$var$performance?.now();
        };
    }, [
        transitionId,
        routeName,
        contentId
    ]);
    return null;
});







var $iFjdQ = parcelRequire("iFjdQ");




function $192302f00fa5cc0a$export$8c3a984654991d73(routeName) {
    if (!routeName) return;
    switch(routeName){
        // edit route names taken from @confluence/browser-metrics/src/metricKeys.ts
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_TO_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION));
            return;
        default:
            return;
    }
}



var $jfrcs = parcelRequire("jfrcs");





var $aeSHO = parcelRequire("aeSHO");


var $25MM7 = parcelRequire("25MM7");


var $NAPtM = parcelRequire("NAPtM");


var $iJiK8 = parcelRequire("iJiK8");














var $ikfiQ = parcelRequire("ikfiQ");


const $8bd37d13e213b9df$var$NetworkStatusFlagLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Umim",
    name: "NetworkStatusFlagLoader",
    loader: ()=>(parcelRequire("aYxMO")).then((module)=>module.NetworkStatusFlagWithFlags)
});
const $8bd37d13e213b9df$export$529640d4682c2 = ()=>{
    const $ = (0, $frIzR.c)(2);
    const networkStatus = (0, $ikfiQ.useNetworkStatusListenerCache)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let reason;
    bb0: switch(networkStatus){
        case (0, $ikfiQ.ClientNetworkStatus).IP_BLOCKED:
            reason = "IP blocked";
            break bb0;
        case (0, $ikfiQ.ClientNetworkStatus).OFFLINE:
            reason = "Network unavailable";
    }
    if (reason) experienceTracker.abort({
        reason: reason,
        checkForTimeout: false
    });
    let t0;
    if ($[0] !== networkStatus) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8bd37d13e213b9df$var$NetworkStatusFlagLoader, {
            status: networkStatus
        });
        $[0] = networkStatus;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};



var $itS9i = parcelRequire("itS9i");


var $hmRc4 = parcelRequire("hmRc4");


var $8Ss4E = parcelRequire("8Ss4E");








var $hzVuz = parcelRequire("hzVuz");





const $af5e1b3a6aa255af$export$38f39b921d5551c1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "Bc3Ba",
    name: "Heartbeat",
    loader: async ()=>(await (parcelRequire("dTt0t"))).Heartbeat
});



var $39rFu = parcelRequire("39rFu");











var $inPa6 = parcelRequire("inPa6");


var $gqqjz = parcelRequire("gqqjz");

const $e4d79357fba42d43$var$i18n = (0, $aXWIB.defineMessages)({
    localStorageQuotaExceededTitle: {
        id: "local-storage-quota-subscriber.flag.quota-exceeded.title",
        defaultMessage: "We ran into a problem"
    },
    localStorageQuotaExceededDescription: {
        id: "local-storage-quota-subscriber.flag.quota-exceeded.description",
        defaultMessage: "We've noticed an issue that may affect your experience on Confluence. Select \u201CRefresh\u201D below to fix it."
    },
    refreshLocalStorage: {
        id: "local-storage-quota-subscriber.flag.refresh.title",
        defaultMessage: "Refresh"
    }
});
const $e4d79357fba42d43$export$b2c5189af5b5e948 = ()=>{
    const [isOverflown, setIsOverflown] = (0, $42omo.useState)(false);
    const [wasShown, setWasShown] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const onQuotaExceeded = ()=>setIsOverflown(true);
        window.addEventListener('local-storage.quota.exceeded', onQuotaExceeded);
        return ()=>{
            setIsOverflown(false);
            window.removeEventListener('local-storage.quota.exceeded', onQuotaExceeded);
        };
    }, [
        setIsOverflown
    ]);
    const clearLocalStorage = ()=>{
        window.localStorage.clear();
        window.location.reload();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LocalStorageQuotaSubscriber',
                action: 'clicked',
                actionSubject: 'LocalStorageQuotaExceededFlag',
                actionSubjectId: 'localStorageQuotaCleared'
            }
        }).fire();
    };
    const showFlag = (flags)=>{
        if (wasShown) return;
        flags.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e4d79357fba42d43$var$i18n.localStorageQuotaExceededTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e4d79357fba42d43$var$i18n.localStorageQuotaExceededDescription),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e4d79357fba42d43$var$i18n.refreshLocalStorage),
                    href: '',
                    onClick: ()=>clearLocalStorage()
                }
            ]
        });
        setWasShown(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        if (isOverflown) showFlag(flags);
        return null;
    });
};






var $7J5Uc = parcelRequire("7J5Uc");

const $0f25e4f8facf0d0e$export$913cb5ed19d2180b = (initialTheme)=>{
    const { initializeTheme: initializeTheme } = (0, $7J5Uc.useThemingActions)();
    (0, $42omo.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};



var $cBuRD = parcelRequire("cBuRD");





var $6UYek = parcelRequire("6UYek");


var $eHj6r = parcelRequire("eHj6r");








const $852a6819cc9585c3$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = false;
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled via feature flag or environment variable
    if ((0, $9wGTI.fg)('confluence_strict_mode') || false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).StrictMode, null, children);
    else return children;
};



var $2JYae = parcelRequire("2JYae");





var $3WLLD = parcelRequire("3WLLD");








var $ek3aD = parcelRequire("ek3aD");










var $1z9oK = parcelRequire("1z9oK");











var $iXCQx = parcelRequire("iXCQx");

const $003e065b50dd1979$var$RUNBOOK_URL = 'https://hello.atlassian.net/wiki/spaces/~7120202da6a0b2c4184c0da3ba8ade6d08feaa/pages/5761728624/React+suspense+boundary+errors+run-book';
const $003e065b50dd1979$var$i18n = (0, $aXWIB.defineMessages)({
    outsideBoundaryError: {
        id: "streaming-boundary-error-notification.outside-boundary.message",
        defaultMessage: "Query \"{operationName}\" preloaded in [{expectedBoundaries}] but accessed outside any suspense boundary."
    },
    boundaryMismatchError: {
        id: "streaming-boundary-error-notification.boundary-mismatch.message",
        defaultMessage: "Query \"{operationName}\" preloaded in [{expectedBoundaries}] but accessed in \"{currentBoundaries}\" boundary."
    },
    runbookLink: {
        id: "streaming-boundary-error-notification.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for details."
    }
});
const $003e065b50dd1979$export$4f6d1b579f9e99e4 = ({ operationName: operationName, errorType: errorType, args: args })=>{
    const expectedBoundaries = args?.expectedBoundaries?.join(', ') || '';
    const currentBoundaries = args?.currentBoundaries?.join(" \u2192 ") || '';
    const renderMessage = ()=>{
        switch(errorType){
            case 'outside-boundary':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$003e065b50dd1979$var$i18n.outsideBoundaryError,
                    values: {
                        operationName: operationName,
                        expectedBoundaries: expectedBoundaries
                    }
                });
            case 'boundary-mismatch':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$003e065b50dd1979$var$i18n.boundaryMismatchError,
                    values: {
                        operationName: operationName,
                        expectedBoundaries: expectedBoundaries,
                        currentBoundaries: currentBoundaries
                    }
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "queryBoundaryErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, renderMessage()), (errorType === 'boundary-mismatch' || errorType === 'outside-boundary') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$003e065b50dd1979$var$i18n.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: $003e065b50dd1979$var$RUNBOOK_URL
                }, chunks)
        }
    }));
};


class $82be4d32af71312a$var$BoundaryErrorHandler {
    constructor(flags){
        this.flags = flags;
        this.errorStream = void 0;
        this.cleanup = ()=>{
            if (this.errorStream) this.errorStream.removeListener(this.handleBoundaryError);
        };
        this.handleBoundaryError = (error)=>{
            const flagId = `query-boundary-${error.errorType}-${error.operationName}`;
            let flagTitle = null;
            switch(error.errorType){
                case 'outside-boundary':
                    flagTitle = 'Query Used Outside Suspense Boundary!';
                    break;
                case 'boundary-mismatch':
                    flagTitle = 'Query Boundary Mismatch!';
                    break;
            }
            if (flagTitle) this.flags.showErrorFlag({
                id: flagId,
                title: flagTitle,
                isAutoDismiss: false,
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $003e065b50dd1979$export$4f6d1b579f9e99e4), error)
            });
        };
        if (window.__SSR_REACT_STREAMING__) {
            this.errorStream = (0, $1z9oK.getClientStream)('query-boundary-errors');
            this.errorStream.addListener(this.handleBoundaryError);
        }
    }
}
const $82be4d32af71312a$export$edc06ce642e48a51 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    (0, $42omo.useEffect)(()=>{
        if (!window.__SSR_REACT_STREAMING__) return;
        // Create the handler which will automatically set up the listener
        const handler = new $82be4d32af71312a$var$BoundaryErrorHandler(flags);
        return ()=>{
            handler.cleanup();
        };
    }, [
        flags
    ]);
    return null;
});
const $82be4d32af71312a$export$5413c6653c828d95 = ()=>{
    return null;
};












const $875130f53b935742$export$9bfc14d39c192dcd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Tqz5C",
    name: "InconsistentLicenseFlag",
    loader: async ()=>(await (parcelRequire("1BZTM"))).InconsistentLicenseFlag
});





var $h3nb6 = parcelRequire("h3nb6");


var $7Snc9 = parcelRequire("7Snc9");




var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $jwv1p = parcelRequire("jwv1p");


var $eIKcA = parcelRequire("eIKcA");


var $4QflW = parcelRequire("4QflW");





const $a409a9cb99445cc0$var$ShortcutsProvider = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zhDj6",
    name: "ShortcutsProvider",
    loader: ()=>(parcelRequire("7GuCn"))
});
var $a409a9cb99445cc0$export$2e2bcd8739ae039 = $a409a9cb99445cc0$var$ShortcutsProvider;





var $irDFR = parcelRequire("irDFR");












const $1f18aab14ff5333d$export$4a5ef4d351acbcfc = async (url, isTransition)=>{
    const shouldPreload = isTransition || !window.__SSR_RENDERED__;
    let match;
    if (match = (0, $kM8fE.matchHome)(url)) (0, $jwv1p.preloadHome)(match);
    else if ((0, $kM8fE.matchSpaceOverview)(url)) {
        if (shouldPreload) (0, $jwv1p.preloadSpaceOverview)();
    } else if ((0, $kM8fE.matchLivePage)(url) && shouldPreload) {
        if (await (0, $aXEzU.waitUntilStatsigInitialized)()) (0, $jwv1p.preloadLivePagesComponents)();
    } else if (match = (0, $kM8fE.matchViewPage)(url)) {
        if (shouldPreload) (0, $jwv1p.preloadViewPageComponents)(match);
    } else if ((0, $kM8fE.matchFabricEditor)(url)) (0, $jwv1p.preloadNativeEditorComponentsPreloader)();
    else if ((0, $kM8fE.matchCreateContent)(url)) (0, $jwv1p.preloadCreateContent)();
    else if ((0, $kM8fE.matchWhiteboardPage)(url)) (0, $jwv1p.preloadWhiteboardPage)();
    else if ((0, $kM8fE.matchSearch)(url)) (0, $jwv1p.preloadSearch)();
};






var $50adebb1075ad3af$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "exd9t",
    name: "packages.confluence-frontend-server.src.components.ReduxError.src.index",
    loader: ()=>(parcelRequire("syHJB"))
});


const $126a66f6ad21916b$var$browserHistory = (0, $hmRc4.getBrowserHistory)();
function $126a66f6ad21916b$export$86fbec116b87613f({ sessionData: sessionData }) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).performance.mark('CFP-63.app-component-render');
    (0, $42omo.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).__SSR_ERROR__) (0, $5ZqQS.getMonitoringClient)().submitError(JSON.stringify({
            ssrError: (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).__SSR_ERROR__
        }), {
            // Having '-ssr' suffix to not mix with FE Error detector. Set another dedicated cc-fe-performance detector.
            attribution: 'backbone-ssr'
        });
    }, []);
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isPdfExportRoute = typeof (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))) !== 'undefined' && (0, $1NBp8.PDF_EXPORT_PAGE).match((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.pathname);
    const { isLoggedIn: isLoggedIn, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isRovoEnabled = isRovoLLMEnabled && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    // When loading confluence from the mobile app, we need the theme to respect the system color mode of the app
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    // Initializing the theme in a non-blocking way, instead of using <ThemeContainer>, so
    // that the app does not flash and re-paint after the SPA loads on top of the SSR page.
    (0, $0f25e4f8facf0d0e$export$913cb5ed19d2180b)(initialTheme);
    // Lite Mode™ check outside of the router
    // For certain pages supporting lite mode some functionality is not needed
    const isLite = (0, $aFbGo.isViewPageLite)();
    // Check if app is being loaded in iFrame
    // We don't want to render the Rovo Chat wrapper if in iFrame
    const isIframe = typeof (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))) !== 'undefined' && (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).self !== (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).top;
    const startPageLoadMetrics = (0, $42omo.useCallback)((routeName = '', ufoName = routeName, transitionId, contentId = '')=>{
        (0, $jfrcs.startBrowserMetricsPageLoad)(routeName, ufoName, transitionId, contentId);
        if ((0, $9wGTI.fg)('platform_ufo_custom_cohort_data_migration')) (0, $2cEww.addUFOCustomCohortData)('isDesktop', isDesktop);
        else (0, $cbc8g.addUFOCustomData)({
            isDesktop: isDesktop
        });
    }, [
        isDesktop
    ]);
    const onRoute = (0, $42omo.useCallback)(async (match, transitionId)=>{
        // Reset window.__APOLLO_STATS__ on transition
        (0, $eHj6r.resetApolloStats)();
        // transitionId = 0 when it is initial load, and 0 is falsey
        if (transitionId) {
            // The page can't be rendered by SSR if is a transition
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))['__SSR_RENDERED__'] = false;
            //hydrateRoot and related logic should not be enabled on transitions
            //as its only for ssr rendered page
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))['__HYDRATABLE__'] = false;
            (0, $KcDWk.releaseSSRedLegacyMacros)();
            // Delayed content redirection is not needed on transitions
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))['__DELAYED_CONTENT_REDIRECTION__'] = {};
            if (0, $itS9i.debuggerEnabled) (0, $itS9i.clearAnalyticsDebugger)();
        } else {
            (0, $5ZqQS.getMonitoringClient)().incrementCounter('confluence-spa.react-initialized');
            (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).performance.mark('CFP-63.route-manager-initialized');
        }
        (0, $78QFu.setUniquePageLoadId)(match?.name ?? '', match, transitionId, sessionData);
        (0, $8Ss4E.startExperienceForRoute)(match, transitionId, sessionData);
        (0, $2ba6133bff070823$export$8c5248f0cec8446d).stream([
            {
                type: 'page-transition',
                ID: transitionId
            }
        ]);
        const transitionPreloaderCurrentCallbackIDs = (0, $ek3aD.getGlobalTransitionPreloader)().getCurrentRouteCallbackIds();
        const isSeamlessTransition = (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') ? transitionPreloaderCurrentCallbackIDs.includes('live_doc_preloading_transition_callback_id') && transitionId !== 0 : false;
        //if the new editor metrics FF is on, start BM here only if the route is not edit page or if it is initial load, or an embedded editor.
        if (!isSeamlessTransition && (!(0, $gEtAQ.isEditPage)(match?.name) || transitionId === 0 || (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)())) {
            (0, $jfrcs.startBrowserMetricsPageLoad)(match?.name ?? '', match?.ufoName, transitionId, match?.params.contentId);
            if ((0, $9wGTI.fg)('platform_ufo_custom_cohort_data_migration')) (0, $2cEww.addUFOCustomCohortData)('isDesktop', isDesktop);
            else (0, $cbc8g.addUFOCustomData)({
                isDesktop: isDesktop
            });
            //If it is an embedded editor, start the BM right here since it does a full page reload
            if ((0, $gEtAQ.isEditPage)(match?.name) && (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) {
                (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_FMP_ACTION));
                (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_TTI_ACTION));
            }
        }
        // add SSR stats to initial page load only
        // we will be utilizing serverTime to track BE perf in Statsig
        if (transitionId === 0) {
            /** @type {Object<string, {startTime: number, duration: number} | undefined>} */ const ssrMeasure = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))['__SSR_MEASURES__'];
            const serverTime = ssrMeasure ? Object.keys(ssrMeasure).filter((key)=>key.includes('prepare/preloadQuery/fetch')).reduce((total, key)=>total + (ssrMeasure[key]?.duration ?? 0), 0) : 0;
            /** @type {number | undefined} */ const serverCallCount = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))['__FETCH_COUNT__'];
            if (serverTime && serverCallCount) (0, $cbc8g.addUFOCustomData)({
                serverTime: serverTime,
                serverCallCount: serverCallCount
            });
        }
        // mark edit experience after transition to new route is complete
        (0, $192302f00fa5cc0a$export$8c3a984654991d73)(match?.name);
        (0, $5ZqQS.getMonitoringClient)().updateContext({
            pageName: match?.name ?? 'unknown',
            transitionId: transitionId,
            product: (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? 'embeddedConfluence' : 'confluence'
        });
    }, [
        sessionData,
        isDesktop
    ]);
    /**
   * Please note this App is a pure component.
   * This means following components will NOT re-render when user navigates.
   * Please be careful when adding any component that requires router information.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $852a6819cc9585c3$export$5f8d39834fd61797), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $008c5cd8cb4c3a95$export$4e5ff544be3ec09b), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82be4d32af71312a$export$5413c6653c828d95), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dBmJE.ConnectedRouter), {
        history: $126a66f6ad21916b$var$browserHistory,
        context: (0, $kFqI2.ReactReduxContext)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kCeSx.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hzVuz.ExternalShareContextProvider), {
        path: $126a66f6ad21916b$var$browserHistory.location.pathname
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
        nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
        livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UYek.SubscriptionsContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8n9tL.RouteManager), {
        routeComponents: (0, $h3nb6.routeComponents),
        namedRoutes: (0, $64KID.namedRoutes),
        notFound: (0, $7Snc9.NotFound),
        onInitialize: onRoute,
        onTransition: onRoute,
        onPreload: $126a66f6ad21916b$var$onPreloadRoute,
        routePolicy: routePolicy,
        setBrowserHistoryListener: (0, $hmRc4.setBrowserHistoryListener),
        startPageLoadMetrics: startPageLoadMetrics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $af5e1b3a6aa255af$export$38f39b921d5551c1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cBuRD.NotificationLandedEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6158bccfa436061$export$560b992b8a813cfb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $074500c4d6f25c0d$export$9f8d3084fd3d5fc0), null), !isLite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJiK8.Dialogs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), !isIframe && isRovoEnabled && !isPdfExportRoute && (0, $9wGTI.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIKcA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bd37d13e213b9df$export$529640d4682c2), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a409a9cb99445cc0$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $50adebb1075ad3af$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $875130f53b935742$export$9bfc14d39c192dcd), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e4d79357fba42d43$export$b2c5189af5b5e948), null), !isLite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irDFR.default), null)))));
}
$126a66f6ad21916b$export$86fbec116b87613f.propTypes = {
    sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired
};
function $126a66f6ad21916b$var$onPreloadRoute({ url: url }, previousMatch, options) {
    (0, $1f18aab14ff5333d$export$4a5ef4d351acbcfc)(url, true);
    if (options?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJS) return;
    (0, $e80763d537fd4542$export$57d895781a697848)(url, true, previousMatch, options);
    if (options?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJSAndCriticalData) return;
    (0, $e80763d537fd4542$export$6aefe8c2dfd7fe98)(url);
}


class $2652ca00a3968b71$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        window.performance.mark('CFP-63.root-component-render');
        const { store: store, apolloClient: apolloClient, sessionData: sessionData } = this.props;
        return(// This is at the top because the root-level UnstatedProvider must not re-render
        // otherwise it will lose and recreate its instances
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Provider), {
            inject: [
                new (0, $hrAmX.BannerStateContainer)({
                    initialState: {
                        banners: window.__SSR_BANNERS__
                    }
                }),
                new (0, $bJX6u.ContentStateStateContainer)(window.__SSR_CONTENT_STATE__),
                new (0, $ktUCG.EmojiTitleStateContainer)(window.__SSR_EMOJI_TITLE__)
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lonEO.GraphqlProvider), {
            client: apolloClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kFqI2.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVK0t.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70d683a301b7be27$export$d900e4062895cd7c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7l88B.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZDrw.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $685338b3d2a4b0a3$export$2e865a7ec399eb55), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fN9wG.XProductUserInviteProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $brNvA.ReattachCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $074500c4d6f25c0d$export$fb465b6e855c1e85), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $126a66f6ad21916b$export$86fbec116b87613f), {
            sessionData: sessionData
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccd0dc06d2167081$export$f6564e60882bdf90), null))))))))))))))))))));
    }
}
$2652ca00a3968b71$export$2e2bcd8739ae039.displayName = 'Root';
$2652ca00a3968b71$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    apolloClient: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired
};






const $64ffce910ca717e1$var$ErrorType = Object.freeze({
    REMOVE_CHILD_ERROR: 'removeChildError',
    INSERT_BEFORE_ERROR: 'insertBeforeError'
});
function $64ffce910ca717e1$export$d1215808cd22e615() {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function(child) {
            if (child.parentNode !== this) {
                if (console) {
                    console.error('Cannot remove a child from a different parent', child, this);
                    $64ffce910ca717e1$var$sendRemoveChildErrorAnalyticsEvent(child);
                }
                return child;
            }
            return originalRemoveChild.apply(this, arguments);
        };
        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function(newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    $64ffce910ca717e1$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode);
                }
                return newNode;
            }
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
/**
 * Send an analytics event when a 'removeChild' error occurs. This function helps to track the occurrence of this suppressed error.
 * @param {Node} childNode - The node that is attempted to be removed.
 */ function $64ffce910ca717e1$var$sendRemoveChildErrorAnalyticsEvent(childNode) {
    const nodeData = {
        nodeToBeRemoved: $64ffce910ca717e1$var$extractNodeData(childNode)
    };
    $64ffce910ca717e1$var$sendAnalyticsEvent($64ffce910ca717e1$var$ErrorType.REMOVE_CHILD_ERROR, nodeData);
}
/**
 * Send an analytics event when an 'insertBefore' error occurs.  This function helps to track the occurrence of this suppressed error.
 * @param {Node} referenceNode - The existing node in the DOM tree. The new node is intended to be inserted before this node.
 * @param {Node} newNode - The new node that is attempted to be inserted.
 */ function $64ffce910ca717e1$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode) {
    const nodeData = {
        newNode: $64ffce910ca717e1$var$extractNodeData(newNode),
        referenceNode: $64ffce910ca717e1$var$extractNodeData(referenceNode)
    };
    $64ffce910ca717e1$var$sendAnalyticsEvent($64ffce910ca717e1$var$ErrorType.INSERT_BEFORE_ERROR, nodeData);
}
function $64ffce910ca717e1$var$sendAnalyticsEvent(action, nodeData) {
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'confluenceFrontendServer',
            actionSubject: 'domManipulationError',
            action: 'error',
            attributes: {
                suppressedError: action,
                ...nodeData
            }
        });
    });
}
function $64ffce910ca717e1$var$extractNodeData(node) {
    if (!node) return {};
    return {
        nodeName: node.nodeName,
        parentElementNodeName: node.parentElement?.nodeName,
        isConnected: node.isConnected
    };
}



var $7LuKf = parcelRequire("7LuKf");







function $55460e99d99202dd$export$841e9db237ec2bdb(rootNode) {
    const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_COMMENT, {
        acceptNode: (node)=>{
            return node.nodeValue === '$' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
    });
    const suspenseComments = [];
    let currentNode = null;
    while(currentNode = walker.nextNode())suspenseComments.push(currentNode);
    return suspenseComments;
}
function $55460e99d99202dd$export$c4c689e5d93ba5b6(node) {
    // Check if the node itself has data-hydration-shield
    if (node.nodeType === Node.ELEMENT_NODE && node.hasAttribute('data-hydration-shield')) return true;
    // Check if the parent has data-hydration-shield
    const parent = node.parentNode;
    if (parent?.nodeType === Node.ELEMENT_NODE && parent.hasAttribute('data-hydration-shield')) return true;
    return false;
}
function $55460e99d99202dd$export$9efc73f328295609(boundary) {
    let nextNode = boundary.nextSibling;
    // Skip text nodes that are just whitespace
    while(nextNode && nextNode.nodeType === Node.TEXT_NODE && !nextNode.textContent?.trim())nextNode = nextNode.nextSibling;
    // Return the next node if it is an element node
    if (nextNode && nextNode.nodeType === Node.ELEMENT_NODE) return nextNode;
}
function $55460e99d99202dd$export$b5009d2dcc72fd5c(rootNode, root) {
    (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).flushSync(()=>{
        $55460e99d99202dd$export$841e9db237ec2bdb(rootNode).forEach((boundary)=>{
            const node = $55460e99d99202dd$export$9efc73f328295609(boundary);
            if (node && $55460e99d99202dd$export$c4c689e5d93ba5b6(node)) {
                if (!(0, $6mKj3.expVal)('confluence_frontend_skip_activatable_hydration', 'isEnabled', false)) return;
            }
            if (node) root.unstable_scheduleHydration(node);
        });
        root.unstable_scheduleHydration(rootNode);
    });
}



var $2DIgf = parcelRequire("2DIgf");

const $cff4f803b29c74e8$export$e99e0154cbe3afef = (rootNode)=>{
    const vcObserver = (0, $2DIgf.getVCObserver)();
    vcObserver.setSSRElement(rootNode);
    vcObserver.setReactRootRenderStart();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            vcObserver.setReactRootRenderStop();
        });
    });
};


function $82f3624e89bd584a$export$62028ff70825ead9(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
}





const $c641ec602c55a36e$var$MAX_ERROR_STACK_LENGTH = 100000;
const $c641ec602c55a36e$var$DEFAULT_STACK_LENGTH = 1000;
const $c641ec602c55a36e$export$423e2732e9c54334 = ({ componentStack: componentStack })=>{
    if (!componentStack) return '';
    let loggingConfig = {};
    try {
        loggingConfig = JSON.parse((0, $1xpoY.default).getString('confluence_hydration_error_logging', '{}'));
    } catch (error) {
    // no-op, if an error occurs here, there's really nowhere to submit it
    }
    if (loggingConfig.stack) {
        const errorStackLogLen = loggingConfig.stackLength ?? $c641ec602c55a36e$var$DEFAULT_STACK_LENGTH;
        const clampedErrorStackLog = Math.min($c641ec602c55a36e$var$MAX_ERROR_STACK_LENGTH, errorStackLogLen);
        return componentStack.toString().substring(0, clampedErrorStackLog) ?? '';
    }
    return '';
};



function $301b91f6022f88c3$export$6f190738a936fdf9(error, errorInfo) {
    if (typeof window !== 'undefined' && window.dispatchEvent) window.dispatchEvent(new CustomEvent('hydrationError', {
        detail: {
            error: error.message,
            stack: (0, $c641ec602c55a36e$export$423e2732e9c54334)(errorInfo),
            timestamp: Date.now()
        }
    }));
}



var $awd1Q = parcelRequire("awd1Q");





var $7RVQB = parcelRequire("7RVQB");

let $c4a23b150b65622f$var$translationPromise = null;
async function $c4a23b150b65622f$export$d72c30eb19cf29ca() {
    if ($c4a23b150b65622f$var$translationPromise === null) $c4a23b150b65622f$var$translationPromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_TRANSLATION, ()=>(0, $awd1Q.loadTranslation)((0, $7RVQB.lazyLanguage)));
    return $c4a23b150b65622f$var$translationPromise;
}








function $2430be288db8ba8d$export$7424fb7c300d6ad9() {
    const maxStackSize = (0, $1xpoY.default).getNumber('confluence_frontend_dev_console_max_stack_size', 0);
    // Default value means don't trim stacks.
    if (maxStackSize === 0 || !(0, $cMvQV.isChrome)()) return;
    // The code below takes many hints from React devtools code
    // https://github.com/facebook/react/blob/c80a07509582daadf275f36ffe7a88c3b12e9db4/packages/react-devtools-shared/src/hook.js#L456
    for (const method of [
        'error',
        'warn'
    ]){
        const originalMethod = console[method];
        console[method] = function(...args) {
            if (args.length === 0) return;
            const lastArg = args[args.length - 1];
            // React's custom built component stack strings match "\s{4}in"
            // Chrome's prefix matches "\s{4}at"
            if (typeof lastArg === 'string' && /\s{4}(in|at)\s{1}/.test(lastArg)) {
                const firstArg = args[0];
                const newArgs = args.slice();
                if (args.length > 1 && typeof firstArg === 'string' && firstArg.endsWith('%s')) newArgs[0] = firstArg.slice(0, firstArg.length - 2); // Strip the %s param
                // Create a fake Error so that when we print it we get native source maps. Every
                // browser will print the .stack property of the error and then parse it back for source
                // mapping.
                const fakeError = new Error('');
                // It has to start with ^[\w.]*Error\b to trigger stack formatting.
                fakeError.name = 'Error Component Stack';
                // Overwrite the stack property with the trimmed stack trace.
                fakeError.stack = lastArg.split('\n').slice(0, maxStackSize + 1).join('\n');
                newArgs[newArgs.length - 1] = fakeError;
                // If the developer has React devtools extension installed, it contains its own override logic for console methods,
                // which is downstream of our implementation here. If the extension's "append component stacks" setting is on,
                // then it will end up appending a second stack trace to the one we're providing. Thus we need to force that
                // setting to be off temporarily.
                let originalAppendComponentStack;
                const reactDevtoolsSettings = window.__REACT_DEVTOOLS_GLOBAL_HOOK__?.settings;
                if (reactDevtoolsSettings) {
                    originalAppendComponentStack = reactDevtoolsSettings.appendComponentStack;
                    reactDevtoolsSettings.appendComponentStack = false;
                }
                originalMethod(...newArgs);
                if (reactDevtoolsSettings) reactDevtoolsSettings.appendComponentStack = originalAppendComponentStack;
            } else originalMethod(...args);
        };
    }
}


if (window?.performance) {
    window.performance.mark('CFP-63.app');
    window.performance.mark('navigation-fmp.NavigationFMP.start');
    window.performance.mark('side-navigation-fmp.SideNavigationFMP.start');
}
const $67148092cd3543c6$var$logger = (0, $7W8i8.getLogger)('SPAEntry');
// Try load translation early if we know locale from SSR
if (window.__SSR_LOCALE__) (0, $c4a23b150b65622f$export$d72c30eb19cf29ca)();


(0, $82f3624e89bd584a$export$62028ff70825ead9)(async function() {
    /**
   * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
   * This ensures we catch and track any errors that occur during the app's initialization,
   * including async operations and React rendering. Moving this call later would risk missing
   * early errors.
   * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
   */ (0, $5QpZa.default)();
    // When page is being refreshed or redirected from server we run into a condition when redirect
    // url requested from the server and SPA (which resources are loaded via early HTML flush) is
    // being initialized at the same time. We don't want to waste browser resources/make network
    // calls when page is going to be redirected anyway, so bail out early.
    if (document.querySelector(`meta[http-equiv="Refresh"]`)) return;
    // collect SSR placeholder dimensions at the start of initialization
    // to bypass capturing of intermediate loading states in dimensions check
    if (window.__DELAY_COLLECT_SSR_PLACEHOLDERS__) (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).COLLECT_PLACEHOLDER_DIMENSIONS, ()=>{
        (0, $5nRL1.collectSSRPlaceholderDimensions)(document, window);
    });
    const rootNode = document.getElementById('confluence-ui');
    if (window.__HYDRATABLE__) {
        // remove nonce attributes from style tags to support react hydration
        document.querySelectorAll('style[nonce]').forEach((styleTag)=>{
            styleTag.removeAttribute('nonce');
        });
        (0, $dA1Sn.saveFullCycleOutput)();
    }
    const { client: client, aggClient: aggClient } = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).CREATE_APOLLO_CLIENTS, ()=>{
        const apolloClient = (0, $hp2SH.getApolloClient)();
        const apolloAggClient = (0, $gKr8t.getAGGClient)();
        // Initialize the Relay environment alongside the Apollo clients so
        // `window.GLOBAL_RELAY_ENV` is set before any Relay-enabled interop
        // call (including the preloader interop path in
        // `@confluence/query-preloader-tools`). Mirrors how
        // `GLOBAL_APOLLO_AGG_CLIENT` is set during `getAGGClient()`.
        (0, $9HB34.getRelayEnvironment)();
        return {
            client: apolloClient,
            aggClient: apolloAggClient
        };
    });
    let initializeEmbeddedConfluencePromise;
    // @TODO: Update this to use `isMobileApp_DO_NOT_USE()` once we remove the experiment-gate
    if ((0, $lJlG6.isMobileApp_checkGateViaSSR_DO_NOT_USE)()) initializeEmbeddedConfluencePromise = (await (parcelRequire("i2w4s"))).initialize();
    else if ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) initializeEmbeddedConfluencePromise = (await (parcelRequire("kcni8"))).initialize();
    let browserNotSupported;
    // Must call this before any browser-helper functions, to ensure user agent has been set first
    (0, $cMvQV.setUserAgent)();
    // Bypass browser compatibility checks in the case of the Confluence native mobile app;
    // it is the responsibility of the mobile app to ensure the rendering of Confluence
    const shouldCheckBrowserCompatibility = !(0, $cMvQV.isNativeMobile)();
    if (shouldCheckBrowserCompatibility) {
        browserNotSupported = (0, $2DVQX.coreBrowserNotSupported)();
        if (browserNotSupported) // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), rootNode);
    }
    const sessionDataPromise = (async ()=>{
        const sessionData = await (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_SESSION_DATA, ()=>(0, $aXEzU.getSessionDataAndInitializeStatsig)());
        const { userId: userId, isLicensed: isLicensed, monolithRegion: monolithRegion } = sessionData;
        // Expose synthetic environment flag to the window so downstream consumers
        // can detect it without importing @confluence/statsig-client avoiding possible circular dependencies.
        if ((0, $1xpoY.default).isKillSwitchOn('cc_e2e_stable_ui')) window.__IS_SYNTHETIC_ENV__ = true;
        // Note: this MUST be done before preload queries below
        // in order to ensure performant AGG queries
        (0, $8PKGr.initializeAggRegionSteeringHint)(monolithRegion);
        // If page is SSRed preload data that is only needed for hydration
        // If page is not SSRed, preload all the data.
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        (0, $e80763d537fd4542$export$bd8e570400e2d126)();
        try {
            await (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_INITIALIZE_STORAGE_MANAGER, async ()=>{
                // Initialize browser storage controls after Statsig is ready (for proper feature gate evaluation)
                // This must happen before initializeStorageManager
                await (0, $7ZzSP.initializeBootstrapStorage)({
                    userId: userId,
                    cloudId: sessionData.cloudId
                });
                await (0, $17wUi.initializeStorageManager)({
                    userId: userId,
                    isLicensed: isLicensed
                });
                (0, $gnYQc.applyPersistedStatsigOverrides)();
                (0, $ae045ed661bc53ec$export$efcab8bd082cbc1f)(sessionData);
                (0, $30ba73f8286a8f5a$export$6381c51f97ce9880)(sessionData);
                if ((0, $6mKj3.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $e8bac4b2464d29b3$export$77f9905a9b9e760d)(sessionData);
            });
            return sessionData;
        } catch  {
            // HOT-89887: server is giving 403 errors on an expired token, causing Apollo
            // to throw. Uncaught, the React app wouldn't start, and can't acknowledge
            // messages from the service worker; thus the service worker can't trigger a
            // redirect to the login page; thus user gets stuck at the Confluence logo
            // screen. By catching here, we can at least bootstrap the app and proceed to
            // the redirect.
            //
            // https://jira.atlassian.com/browse/CONFCLOUD-71974: IP allowlisting is
            // causing a 403 scenario similar to HOT-89887 above.
            return (0, $iC5L0.getEmptySessionData)();
        }
    })();
    // Preload loadable id defined in the global __LOADABLE__ array
    // If the page is rendered by React SSR service this promise will be blocking.
    // On normal SPA it is not blocking.
    const preloadLoadablePromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_LOADABLE, ()=>(0, $3GQl6.preloadLoadable)());
    // Captures the media sources in the current view port as early as possible while SSR response is displaying.
    (0, $2bffd0a48908e22c$export$daa1e83127b2f677)();
    // Preload components/JS chunks as early as possible, when entry point is loaded and
    // route is known, so they'll be ready by the moment when they're actually used.
    (0, $1f18aab14ff5333d$export$4a5ef4d351acbcfc)(window.location.toString(), false);
    Promise.all([
        sessionDataPromise,
        // No-Op if load translation is already called earlier
        (0, $c4a23b150b65622f$export$d72c30eb19cf29ca)(),
        preloadLoadablePromise,
        initializeEmbeddedConfluencePromise
    ]).then(([sessionData])=>{
        // If cloudId is not present in sessionData, we can assume sessionData did not load successfully. Instead of
        // allowing the app to render the red error message, we can render our simplified Error App that fires key analytics
        // events and shows a more pleasing error UI.
        if (sessionData.cloudId === '' && !(0, $9wGTI.fg)('confluence_fe_error_app_disabled')) {
            let isMobileTakeoverPage = false;
            try {
                if (window?.location?.pathname) isMobileTakeoverPage = Boolean((0, $1NBp8.MOBILE_TAKEOVER_PAGE).match(window.location.pathname));
            } catch  {
                // If anything goes wrong, default to false (don't skip ErrorAppLoader)
                isMobileTakeoverPage = false;
            }
            if (!isMobileTakeoverPage) {
                const root = (0, $2FNjD.createRoot)(rootNode);
                root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lTjel.ErrorAppLoader), {
                    entryPoint: "confluence-frontend"
                }));
                return;
            }
        }
        if (!crypto.randomUUID && (0, $9wGTI.fg)('confluence_pollyfill_crypto_randomuuid')) crypto.randomUUID = (0, $9HkI0.v4);
        // Initialize VCObserver before any rendering logic
        if (rootNode && (0, $9wGTI.fg)('confluence_frontend_vc_observer_initialization')) (0, $cff4f803b29c74e8$export$e99e0154cbe3afef)(rootNode);
        // Redux store
        const store = (0, $3Tw8v.default)();
        (0, $9F7Qb.subscribe)(store);
        // When __APOLLO_STATE__ is available in the global variable it means we are bootstrapping SPA over a SSR rendered page.
        // __APOLLO_STATE__ is the serialized apollo cache that is enough to render everything that has already preloaded in preloadLoadable.
        // We are disabling network so on the first render so the components will read from cache only not firing queries again.
        // See https://github.com/apollographql/apollo-client/issues/4814
        if (window['__APOLLO_STATE__'] || window.__SSR_REACT_STREAMING__) client.disableNetworkFetches = true;
        if (window['__APOLLO_AGG_STATE__'] || window.__SSR_REACT_STREAMING__) aggClient.disableNetworkFetches = true;
        if ((0, $9wGTI.fg)('confluence_frontend_suspense_boundary_patch')) window.__CC_REACT_DOM_421_STACK_PATCH__ = true;
        if (typeof window !== 'undefined' && (0, $6mKj3.expValEquals)('confluence_frontend_enable_react_dom_context_patch', 'isEnabled', true)) window.__CC_REACT_DOM_CONTEXT_PATCH__ = true;
        // Workaround for a race condition between Google Translate and React's DOM reconciliation.
        // Google Translate mutates the DOM by wrapping text nodes in <font> elements, reparenting
        // them under a new parent. When React later tries to removeChild or insertBefore on the
        // original parent, the node is no longer a child of that parent, causing a crash.
        // This patches Node.prototype.removeChild and insertBefore to gracefully handle the
        // mismatch instead of throwing.
        //
        // These patches must be applied unconditionally at startup. An on-demand approach that
        // used a MutationObserver to lazily install the patches only when Google Translate was
        // detected was attempted, but there is a race condition: Google Translate can reparent
        // nodes and trigger React's removeChild/insertBefore before the MutationObserver
        // callback fires to install the patches, so React still crashes.
        //
        // See: https://github.com/facebook/react/issues/11538#issuecomment-417504600
        // See: https://product-fabric.atlassian.net/browse/CCP-2409
        (0, $64ffce910ca717e1$export$d1215808cd22e615)();
        // code for regression drill logic. Systematic way of indentifying and tracking performance regressions in web pages
        // will be used to test out criterion, a new perfomacne tracking software
        // for more info visit https://hello.atlassian.net/wiki/spaces/CVMAI/pages/3761808800/Regression+Drill+Plan
        const delayValueForRegression = (0, $1xpoY.default).getNumber('confluence_frontend_preprod_slow', 0);
        delayValueForRegression;
        /**
     * Emotion has 2 ways of SSR support
     * 1. Render style tags along with the component
     * 2. Extract the styles with createEmotionServer
     * Normally we don't need t client side extraction because all the style tags should be in <head>
     * However with streaming there is no good way to support it.
     * The "css" key here is special it runs the logic of moving all the style tags to <head> before React hydrates on the the client side.
     * Reference: https://github.com/emotion-js/emotion/blob/38db311adf024fe8a24b57c687824c47abbd0957/packages/cache/src/index.ts#L63
     */ const cache = (0, $egy7N.default)({
            key: 'css'
        });
        const App = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "confluence-root"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d847caf3274d14b7$export$f3385cdc6645f7e3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fXXXK.C), {
            value: cache
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $799291abed68198f$export$640957ec8f6fdf34), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2652ca00a3968b71$export$2e2bcd8739ae039), {
            store: store,
            apolloClient: client,
            sessionData: sessionData
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8714b2bec379cfae$export$bd148a921cde8da1), null));
        const renderCallback = ()=>{
            // This is important broadcast in Apollo allows hooks that subscribe to the cache to be updated.
            // Broadcast is disabled until here.
            (0, $9PBjm.getApolloCache)().startBroadcast();
            (0, $0b6b84530a4d34b5$export$b4a2d416bf2548b)().startBroadcast();
            if (window['__APOLLO_STATE__'] || window.__SSR_REACT_STREAMING__) client.disableNetworkFetches = false;
            if (window['__APOLLO_AGG_STATE__'] || window.__SSR_REACT_STREAMING__) aggClient.disableNetworkFetches = false;
            const userAgentParser = new (0, (/*@__PURE__*/$parcel$interopDefault($4FYDR)))(navigator.userAgent);
            const { name: browserName, version: browserVersion } = userAgentParser.getBrowser();
            (0, $7LuKf.initialization)(sessionData, {
                browserName: browserName
            });
            // Inside of cleanUpLoadablePlaceholders function, it delayed cleaning up loadable placeholders.
            (0, $ezH4I.cleanUpLoadablePlaceholders)();
            (0, $KcDWk.releaseUnusedSSRedLegacyMacrosWithDelay)();
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
                // GASv3 analytics client is initialized inside of initialization() so we
                // must call the analytics client after that function has been called.
                if (shouldCheckBrowserCompatibility) analyticsClient.sendOperationalEvent({
                    source: 'confluenceRoot',
                    action: 'executed',
                    actionSubject: 'browserRuntimeCheck',
                    attributes: {
                        failedCoreBrowserCheck: browserNotSupported,
                        browserName: browserName,
                        browserVersion: browserVersion
                    }
                });
            });
            if (rootNode && !(0, $9wGTI.fg)('confluence_frontend_vc_observer_initialization')) (0, $cff4f803b29c74e8$export$e99e0154cbe3afef)(rootNode);
        };
        const ConcurrentApp = ()=>{
            (0, $42omo.useEffect)(()=>{
                if (window['__HYDRATION_START__']) $67148092cd3543c6$var$logger.debug`Hydration finished in ${Math.floor(performance.now() - window['__HYDRATION_START__'])}ms`;
                renderCallback();
            }, []);
            return App;
        };
        // If there are loadable timeouts, there is a very high chance hydration will also fail
        // Trying to hydrate and failing is more expensive than running createRoot from the start so we skip hydration in this case
        if (window['__LOADABLE_TIMEOUTS__']?.length && (0, $6mKj3.expVal)('confluence_frontend_skip_hydration_for_timeouts', 'isEnabled', false)) window['__HYDRATABLE__'] = false;
        const isHydratable = window['__HYDRATABLE__'];
        // Fire exposure for cc_performance_holdout - this is needed to monitor the performance of
        // the holdout group as a custom cohort in Glance / via UFO.
        (0, $9wGTI.fg)('cc_performance_holdout');
        (0, $9wGTI.fg)('cc_bifrost_early_query_preload');
        (0, $9wGTI.fg)('confluence_move_statig_bootstrap_after_body');
        // Fire exposure for this experiment (evaluated in SSR) so that its added to UFO payload
        (0, $6mKj3.expVal)('confluence_frontend_do_not_preload_empty_loadables', 'isEnabled', false);
        (0, $6mKj3.expVal)('move_statsig_bootstrap_after_fmp', 'isEnabled', false);
        (0, $6mKj3.expVal)('cc_remove_stream_transformer_bifrost', 'isEnabled', false);
        (0, $6mKj3.expVal)('confluence_ssr_use_statsig_native_bootstrap', 'isEnabled', false);
        (0, $6mKj3.expVal)('cc_superbatch_before_preload', 'isEnabled', false);
        (0, $6mKj3.expVal)('confluence_skip_ors_shortcut_smartlinks', 'isEnabled', false);
        (0, $6mKj3.expVal)('confluence_skip_ors_for_smartlinks', 'isEnabled', false);
        if (isHydratable) {
            window['__HYDRATION_START__'] = performance.now();
            window['__HYDRATION_FAILED__'] = false;
            $67148092cd3543c6$var$logger.debug`Starting hydration`;
            const root = (0, $2FNjD.hydrateRoot)(rootNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConcurrentApp, null), {
                onRecoverableError: (error, errorInfo)=>{
                    if (window['__HYDRATION_ERRORS__'] && error?.message) window['__HYDRATION_ERRORS__'].push({
                        type: 'ERROR_MESSAGES_FROM_REACT',
                        msg: error.message,
                        stack: (0, $c641ec602c55a36e$export$423e2732e9c54334)(errorInfo)
                    });
                    const { hydrationFailed: hydrationFailed, friendlyMessage: friendlyMessage, docLink: docLink } = (0, $dtDUi.matchHydrationError)(error);
                    if (hydrationFailed) {
                        window['__HYDRATION_FAILED__'] = true;
                        if ((0, $6mKj3.expValEquals)('confluence_frontend_hydration_error_events_exp', 'isEnabled', true)) (0, $301b91f6022f88c3$export$6f190738a936fdf9)(error, errorInfo);
                    }
                }
            });
            window.__REACT_ROOT__ = root;
            if (window.__SSR_REACT_STREAMING__) // When streaming is enabled, we can schedule a synchronous hydration for all
            // resolved suspense boundaries in the root node as otherwise there is a
            // performance regression in React 18 that impacts TTAI
            //
            // https://hello.atlassian.net/wiki/spaces/~moates/pages/5497372057/Challenges+with+Selective+Hydration
            //
            // When we move to React 19 we can remove this.
            //
            // @see scheduleSyncHydration
            (0, $55460e99d99202dd$export$b5009d2dcc72fd5c)(rootNode, root);
        } else {
            const concurrentRoot = (0, $2FNjD.createRoot)(rootNode);
            concurrentRoot.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConcurrentApp, null));
        }
    });
});
 }, ["7EorR","94OmX","2tjDW","eiF7i","aZinD","lAHER","f2Ovh","hhss7","foAs3","hXbzh","6edij","jZLnv","3Llsl","dgH7p","c6DIp","1F7LX","ffEVr","Wowvf","g0OKa","b9CA3","zSp86","69R9L","7j0mT","5nMTY","coUzl","cIlmS","lqIoN","9IMTL","jLwPS","RXMWr","a0cZb","1oUEV","hxmLu","lWNY8","5lTVp","bd77Q","2jJ1i","8PzH3","kQSfw","4SCW2","6iz6l","iPYAE","fAtWn","dFGWk","iqTGf","2RWyc","k3yUD","bzyKp","e4wOQ","khyhL","6uCgj","j9Q0e","50D4z","2wRqX","2MTmD","c6VA1","blwYk","cV1Ln","evm5a","hGJ7X","ijNBa","jeALs","fxcvO","e2ahM","2LxnN","fkbDX","kahxF","6Naxm","4aHyS","6wr18","2YffH","h3ABO","1QTBI"]);

$parcel$global.rlb("aFBfl")
//# sourceMappingURL=dashboard-spa-container-jquery3.bf6011e5.js.map
